webpackJsonp([1],{

/***/ "++Cn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"blue-grey darken-1"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs4":"","pt-2":"","pl-2":""}},[_c('v-avatar',{attrs:{"size":"100px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.employe.urlAvatar,"alt":"avatar"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.employe.nomPrenom.substr(0,25))+" ")]),_vm._v(" "),_c('div',{staticClass:"body-1"},[_vm._v(_vm._s(_vm.employe.poste.substr(0,25)))]),_vm._v(" "),_c('div',{staticClass:"caption"},[_c('v-chip',{attrs:{"color":"green","text-color":"white"}},[_vm._v(_vm._s(_vm.employe.typeContrat.substr(0,25)))])],1)])])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',{staticClass:"pa-3"},[_c('v-tooltip',{attrs:{"bottom":""}},[(_vm.employe.absent == true)?_c('v-icon',{attrs:{"slot":"activator","large":"","color":"white"},slot:"activator"},[_vm._v("\n                exit_to_app\n            ")]):_vm._e(),_vm._v("\n                absent\n            ")],1),_vm._v(" "),(_vm.employe.contratValide == false)?_c('v-badge',{attrs:{"color":"red"},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_c('span',[_vm._v("!")])]},proxy:true}],null,false,3477122434)},[_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-icon',{attrs:{"slot":"activator","large":"","color":"white"},slot:"activator"},[_vm._v("\n                    mail\n                ")]),_vm._v("\n                    contrat non conforme\n                ")],1)],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"info"},on:{"click":function($event){return _vm.showDetailEmpl(_vm.employe.idEmploye)}}},[_vm._v("\n                Suivre\n                "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("navigate_next")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+/4Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutResponsable),callback:function ($$v) {_vm.dialogAjoutResponsable=$$v},expression:"dialogAjoutResponsable"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter un responsable de zone")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modifier un responsable de zone  ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutResponsable = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enregistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-form',{ref:"formUser",attrs:{"lazy-validation":"","id":"formUser"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('div',[_c('v-flex',{attrs:{"text-xs-center":"","layout":"","align-center":"","justify-center":""}},[(_vm.dialogEdit != true)?_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"list-type":"picture-card","name":"photo","action":"","auto-upload":false}},[_c('i',{staticClass:"el-icon-plus"})]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"list-type":"picture-card","name":"photo","action":"","auto-upload":false}},[(_vm.responsable.urlImg)?_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":_vm.responsable.urlImg,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":_vm.logoUser,"alt":""}})]):_vm._e()],1)],1)])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-col',[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Nom et prénoms","name":"nomUser","rules":_vm.nomUserRules,"counter":4,"required":""},model:{value:(_vm.responsable.nom),callback:function ($$v) {_vm.$set(_vm.responsable, "nom", $$v)},expression:"responsable.nom"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Login de connexion","name":"loginUser","rules":[function (v) { return !!v || 'Le login est obligatoire'; }],"required":""},model:{value:(_vm.responsable.login),callback:function ($$v) {_vm.$set(_vm.responsable, "login", $$v)},expression:"responsable.login"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"E-mail","name":"emailUser","rules":_vm.loginUserRules,"counter":6,"required":""},model:{value:(_vm.responsable.email),callback:function ($$v) {_vm.$set(_vm.responsable, "email", $$v)},expression:"responsable.email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"name":"contactUser","min":"0","label":"Contact","counter":8,"rules":_vm.contactUserRules,"hint":"Exemple: 00-00-00-00","persistent-hint":"","required":""},model:{value:(_vm.responsable.contact),callback:function ($$v) {_vm.$set(_vm.responsable, "contact", $$v)},expression:"responsable.contact"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Fonction occupée","name":"fonctionUser","counter":6,"required":""},model:{value:(_vm.responsable.fonction),callback:function ($$v) {_vm.$set(_vm.responsable, "fonction", $$v)},expression:"responsable.fonction"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"label":"Services","name":"serviceUser","items":_vm.listService,"rules":_vm.serviceUserRules,"item-value":"id","item-text":"libelle"},model:{value:(_vm.responsable.serviceId),callback:function ($$v) {_vm.$set(_vm.responsable, "serviceId", $$v)},expression:"responsable.serviceId"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"disabled":_vm.dialogEdit,"label":"Type d'utilisateur","name":"serviceUser","items":_vm.typeUser,"rules":[function (v) { return !!v || 'Veuillez sélectionner le type.'; }],"item-value":"value","item-text":"text"},model:{value:(_vm.responsable.type),callback:function ($$v) {_vm.$set(_vm.responsable, "type", $$v)},expression:"responsable.type"}})],1)],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                            PARAMETRE DE CONNEXION\n                                                        ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[(_vm.dialogEdit != true)?_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpUser","label":"Mot de passe","rules":_vm.mdpUserRules,"counter":4,"required":""},model:{value:(_vm.responsable.password),callback:function ($$v) {_vm.$set(_vm.responsable, "password", $$v)},expression:"responsable.password"}})],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit != true)?_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpVerUser","label":"Confirmer le mot de passe","rules":_vm.mdpVerUserRules,"counter":4,"required":""},model:{value:(_vm.responsable.confirmePassword),callback:function ($$v) {_vm.$set(_vm.responsable, "confirmePassword", $$v)},expression:"responsable.confirmePassword"}})],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpUserConnect","label":"Votre mot de passe","rules":_vm.mdpUserConnectRules,"counter":4,"required":""},model:{value:(_vm.mdpUserConnect),callback:function ($$v) {_vm.mdpUserConnect=$$v},expression:"mdpUserConnect"}})],1):_vm._e()],1)],1)],1)])],1)],1),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":_vm.clear}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid},on:{"click":_vm.submitUser}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer cet enregistrement ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteUser($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogRole),callback:function ($$v) {_vm.dialogRole=$$v},expression:"dialogRole"}},[_c('v-card',[_c('v-toolbar',{staticClass:"orange",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter des droits d'accès")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogRole = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n            ATTRIBUER DES ROLES A L'UTILISATEUR\n          ")])],1),_vm._v(" "),_c('v-form',{ref:"formRole",attrs:{"lazy-validation":"","id":"formRole"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Accès au dasbord")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","multiple":"","placeholder":"Catégorie"},model:{value:(_vm.menuSele),callback:function ($$v) {_vm.menuSele=$$v},expression:"menuSele"}},_vm._l((_vm.menu),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Attribuer des roles")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","multiple":"","placeholder":"Catégorie"},model:{value:(_vm.role),callback:function ($$v) {_vm.role=$$v},expression:"role"}},_vm._l((_vm.roles),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.description,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogRole = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.menuSele.length !== 0)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":_vm.submitRole}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAttribuerEquipe),callback:function ($$v) {_vm.dialogAttribuerEquipe=$$v},expression:"dialogAttribuerEquipe"}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"1 1 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Attribuer une equipe")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAttribuerEquipe = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-form',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"flex":"1 1 auto"},attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Nom","placeholder":"Nom de l'équipe","solo":""}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"grid-content bg-purple-light",staticStyle:{"width":"500px"}},[_c('el-card',{staticClass:"box-card",staticStyle:{"margin":"10px"}},[_c('div',{staticClass:"clearfix",staticStyle:{"display":"table","content":"' '","clear":"both","flex":"1 1 auto"},attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Card name")])]),_vm._v(" "),_vm._l((5),function(o){return _c('div',{key:o,staticClass:"text item",staticStyle:{"margin-bottom":"18px","font-size":"14px","flex":"1 1 auto"}},[_vm._v("\n                                "+_vm._s('La liste des elements ' + o)+"\n                            ")])})],2)],1)])],1),_vm._v(" "),_c('hr',{staticStyle:{"height":"10px","color":"#c0eff8","border-radius":"50px","flex":"1 1 auto"}}),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":_vm.clear},slot:"activator"},[_vm._v("Annuler"),_c('v-icon',{attrs:{"rigth":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"blue","dark":""},on:{"click":function($event){$event.stopPropagation();}},slot:"activator"},[_vm._v("Ajouter"),_c('v-icon',{attrs:{"rigth":""}},[_vm._v("add")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1),_vm._v(" "),_c('ModalAttribuerZone',{attrs:{"userResponsable":_vm.responsable,"show":_vm.showModalZone},on:{"close":function($event){_vm.showModalZone = false}}}),_vm._v(" "),_c('ModalAttribuerEquipe',{attrs:{"userResponsable":_vm.responsable,"show":_vm.showModalEquipe},on:{"close":function($event){_vm.showModalEquipe = false}}}),_vm._v(" "),_c('v-container',[_c('v-spacer'),_vm._v(" "),(_vm.droitAcces.create_user)?_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"blue","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.showModalNewUser();}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n                            Ajouter un nouveau responsable\n                        ")],1)],1):_vm._e(),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            LISTE DES RESPONSABLES DE ZONES "),_c('v-icon',{attrs:{"right":""}},[_vm._v("accessibility")])],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":14}},[_c('div',{staticClass:"grid-content bg-purple-light"},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeRespo('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeRespo('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnRespo,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                                            ")])],1)],1)],1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('data-tables',{attrs:{"data":_vm.listeResponsable}},[_c('el-table-column',{attrs:{"prop":"avatar","label":"Avatar","fixed":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nom","label":"Nom et prenoms"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"login","label":"Login"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"contact","label":"Contact"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.admin_profil_update_user)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.showModalEditUser(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                                            Editer\n                                        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"green","dark":""},nativeOn:{"click":function($event){return _vm.modalZone(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("home")])],1),_vm._v("\n                                            Attribuer une zone\n                                        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.role_user)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.newRole(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("vpn_key")])],1):_vm._e(),_vm._v("\n                                            Droit d'accès\n                                        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.user_delete)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.itemUser = scope.row;_vm.dialogSupr = true;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                                            Supprimer\n                                        ")],1)]}}])})],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+3Xw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_location_TarifLocation__ = __webpack_require__("+u7w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_intervention_Intervention_index__ = __webpack_require__("tvuD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_calendrier_ModalCalendContrat__ = __webpack_require__("YJo1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_carteCarburant_CarteCarburant_index__ = __webpack_require__("bcvN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_besoin_besoinTravaux_vue__ = __webpack_require__("FdeE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_parc_loadConducteur_vue__ = __webpack_require__("F22d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_validationDG_ModalValidationDmdFond__ = __webpack_require__("DUFI");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("4UDB");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Vb+l");
__webpack_require__("Oq2I");
__webpack_require__("miEh");

//Importation des modals









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LoadConducteurExcel: __WEBPACK_IMPORTED_MODULE_7__components_parc_loadConducteur_vue__["a" /* default */],
    ModalTarifLocation: __WEBPACK_IMPORTED_MODULE_2__components_location_TarifLocation__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_8__components_Loading__["a" /* default */],
    ModalCalendContrat: __WEBPACK_IMPORTED_MODULE_4__components_calendrier_ModalCalendContrat__["a" /* default */],
    InterventionIndex: __WEBPACK_IMPORTED_MODULE_3__components_intervention_Intervention_index__["a" /* default */],
    CarteCarburantIndex: __WEBPACK_IMPORTED_MODULE_5__components_carteCarburant_CarteCarburant_index__["a" /* default */],
    BesoinTravaux: __WEBPACK_IMPORTED_MODULE_6__components_besoin_besoinTravaux_vue__["a" /* default */],
    ModalValidationDmdFond: __WEBPACK_IMPORTED_MODULE_9__components_validationDG_ModalValidationDmdFond__["a" /* default */]
  },

  name: "app",
  data: function data() {
    var _formClientLocation, _ref;

    return _ref = {
      loading: false,
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      racourcis: [{ path: "/", text: "Accueil", disabled: false }, { path: "/parc/auto", text: "Parc auto", disabled: true }],
      valid: true,
      dialogEdit: false,
      dialogIntervention: false,
      dialogAjoutIntervention: false,
      dialogConsommationCarburant: false,
      dialogValiderDevis: false,
      dialogAjoutVisit: false,
      dialogAjoutVehiConducteur: false,
      dialogSuprVisit: false,
      dialogVisite: false,
      dialogShowVign: false,
      dialogVidange: false,
      dialogAssurance: false,
      dialogConducteur: false,
      dialogContrat: false,
      dialogAjoutContrat: false,
      dialogShowContrat: false,
      dialogAjoutMarq: false,
      logoAssur: "/static/img-doc.png",
      dialogAjoutMod: false,
      dialogAjoutSerie: false,
      dialogClientLocation: false,
      showModalMission: false,
      showModalTarif: false,
      dialogShowClientLocation: false,
      dialogAjoutClientLocation: false,
      dialogSuprClientLocation: false,
      dialogCloseContrat: false,
      dialogParaMarque: false,
      showModalCalendContrat: false,
      showCompagnLib: "",
      InterId: "",
      dialogSupr: false,
      etape: 0,
      listIntervention: [],
      listDemandeur: [],
      kilometrage: 0,
      periode: "",
      selectPriorite: "",
      priorite: [{ value: "Moins urgent", label: "Moins urgent" }, { value: "Urgent", label: "Urgent" }, { value: "Très urgent", label: "Très urgent" }],
      selectType: "",
      type: [{ value: "Curative", label: "Curative" }, { value: "Préventive", label: "Préventive" }],
      selectGravite: "",
      gravite: [{ value: "Moins grave", label: "Moins grave" }, { value: "Grave", label: "Grave" }, { value: "Très grave", label: "Très grave" }],
      selectCategorie: "",
      categorie: [{ value: "Carrosserie", label: "Carrosserie" }, { value: "Lavage", label: "Lavage" }, { value: "Parallélisme", label: "Parallélisme" }, { value: "Pneumatique", label: "Pneumatique" }, { value: "Réparation", label: "Réparation" }, { value: "Vidange", label: "Vidange" }, { value: "Autre", label: "Autre" }],
      motif: "",
      dateInter: "",
      selectVehicule: "",
      selectVehiculeId: "",
      listVehicule: [],
      interventionCourant: [],
      selectReponse: "",
      reponse: [{ value: 1, label: "Valider" }, { value: 2, label: "Refuser" }],
      selectReponseDevis: "",
      reponseDevis: [{ value: 1, label: "Valider" }, { value: 2, label: "Refuser" }],
      remarque: "",
      remarqueValider: "",
      devis: [{
        key: Date.now(),
        libelle: "",
        cout: 0,
        qte: 1,
        tva: 0,
        total: 0,
        id: ""
      }]
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "devis", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "ht", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "totalRemise", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "tva", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "total", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "totalF", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "totalTtc", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listProduit", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "totComLigneTTC", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "maindoeuvre", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "diagnostique", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectPrestataire", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listPrestataire", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogAjoutCons", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listConsommation", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listOldConsommation", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "mntTotCons", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "quantTotCons", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "distParcTot", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "menuDateAchat", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listType", [{ value: "Espèce", label: "Espèce" }, { value: "Carte", label: "Carte" }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "idConsommation", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formAjoutCons", {
      station: "",
      dateAchat: "",
      distParcourCons: "",
      vehicule: "",
      typeCons: "",
      montant: "",
      quantite: "",
      kiloCons: ""
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogSuppCarburant", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dateD", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dateF", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogShowVisit", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showCompagnLib", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showVehLib", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "visiteCourant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "idVisit", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formAttribueCondu", {
      parc: '',
      vehicule: ''
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formVisite", {
      libelle: "",
      numero: "",
      dateDebut: null,
      dateFin: null,
      dateRen: null,
      montant: "",
      description: "",
      vehMat: ""
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fileLogo", [{ name: "", url: "" }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listVisite", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogAjoutVign", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogEditVign", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogSuprVign", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "vidangeCourant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "tableStatVeh", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "tableStatCond", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "tableStatInterv", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "tableStatContrat", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "idVign", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listParc", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listVidn", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listCompagn", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formVidn", {
      numero: "",
      date: null,
      dateDebt: null,
      dateRen: null,
      montant: "",
      document: "",
      vehMat: "",
      statut: ""
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "compagnCourant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "idCompagn", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbVeh", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "VehExt", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbVehLouer", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbMarqu", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbCond", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbDemand", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbBesoins", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbContrat", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbCarburan", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbCarteCar", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbVisiteTech", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbVidang", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbAssur", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbTarif", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbClient", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listAssu", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "typeParc", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectParc", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectCompagnLib", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formAssu", {
      attestation: "",
      police: "",
      montant: "",
      description: "",
      dateAssu: null,
      dateDebutAssu: null,
      dateFinAssu: null,
      dateRenAssu: null
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogShowAssu", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogAjoutAssu", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogSuprAssu", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "assuranceCourant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "idAssu", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "etatAssurance", true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "etatCompagnie", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "etatSerie", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogShowCondMission", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogFicheCond", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogAjoutCond", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogSuprCond", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogSuprMarq", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogSuprModel", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogSuprSeri", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "conducteurCourant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "condMissionCourant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dispoCond", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "idConducteur", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listConducteur", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listCondMission", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listCondMissEnCours", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listVehiculeAffecte", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "detailMission", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "idCondCours", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listTypePermis", [{
      value: "A",
      label: "A"
    }, {
      value: "B",
      label: "B"
    }, {
      value: "C",
      label: "C"
    }, {
      value: "D",
      label: "D"
    }, {
      value: "E",
      label: "E"
    }, {
      value: "F",
      label: "F"
    }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listDisponibilite", [{ value: 0, label: "Disponible" }, { value: 1, label: "Activite" }, { value: 2, label: "Absent" }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listMarque", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formConducteur", {
      nom: "",
      prenom: "",
      lieuNaiss: "",
      matricule: "",
      fonction: "",
      dateNaiss: "",
      dateEmbauch: "",
      typePermis: "",
      numPermis: "",
      dateValPermis: "",
      phone1: "",
      phone2: "",
      adresse: "",
      email: "",
      disponibilite: ""
      // imageUrl: ''
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "remarqueFin", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fichier", { url: "" }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fileFin", [{ name: "", url: "" }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "statutVign", [{
      value: 1,
      label: "Activé"
    }, {
      value: 0,
      label: "Desactivé"
    }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "statutVisit", [{ value: 1, label: "Activé" }, { value: 0, label: "Desactivé" }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listContrat", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "contratCourant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listClient", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectClient", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "montantLocation", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "montantLocationFormat", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dateS", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "avance", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "penalite", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectEtat", 2), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "etatContrat", [{ value: 1, label: "Activé le contrat immédiatement" }, { value: 0, label: "Réserver le véhicule" }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectConducteur", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "attribuer", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listConducteurDispo", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listCaisse", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectCaisse", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "typeContrat", "Contrat de location"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "optionContrat", [{
      key: Date.now(),
      libelle: "",
      cout: 0,
      qte: 1,
      tva: 0,
      total: 0,
      id: ""
    }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listTrarification", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectTarification", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "remise", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "tvaCont", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbr", 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listVehiculeDispo", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "detailCout", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listClientLocation", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formClientLocation", (_formClientLocation = {
      nom: "",
      prenom: "",
      piece: "",
      numPiece: "",
      type: "",
      contact: "",
      adresse: ""
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_formClientLocation, "type", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_formClientLocation, "profession", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_formClientLocation, "affinite", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_formClientLocation, "fixe", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_formClientLocation, "email", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_formClientLocation, "nomPersoContact", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_formClientLocation, "prenomPersoContact", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_formClientLocation, "telPersoContact", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_formClientLocation, "persoSignataire", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_formClientLocation, "DateDelivrPiece", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_formClientLocation, "DateExpirPiece", ""), _formClientLocation)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "clientLocationCourant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "idClientLoc", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "datePaiement", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "statsMarque", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "statsMarqueData", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectClose", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "close", [{ value: 2, label: "Terminé" }, { value: 3, label: "Résilier" }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dateR", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "autre", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbrContratExpireDay", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "consommationCourant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "statutAssu", [{ value: 1, label: "Activé" }, { value: 0, label: "Desactivé" }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listTypeClient", [{ value: "Personne physique", label: "Personne physique" }, { value: "Personne morale", label: "Personne morale" }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "typedePermis", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "detailsPermis", ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "affinite", [{ value: "Parents", label: "Parents" }, { value: "Partenaire", label: "Partenaire" }, { value: "Amie", label: "Ami(e)" }, { value: "Collègue", label: "Collègue" }, { value: "Autre", label: "Autre" }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listSerie", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listModele", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formMarque", {
      libelle: ""
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formModele", {
      libelle: ""
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formSerie", {
      libelle: ""
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "logo", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectMarque", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectSerie", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "marqueCourant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "modeleCourant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "serieCourant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "logoMarque", "/static/img-doc.png"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "logoVignet", "/static/img-doc.png"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "logoVidange", "/static/img-doc.png"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "logoVisite", "/static/img-doc.png"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "imageDevis", "/static/img-doc.png"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "imageChauf", "/static/img-doc.png"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fileDevis", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fileConsom", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "imageConsom", "/static/img-doc.png"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "statConsom", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "statQutConsom", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "totCarb", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "totMntCarb", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnMod", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnSerie", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnMarq", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnCond", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnCarbu", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnCont", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnCli", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnVisT", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnAllVidn", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnAssur", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnDmd", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showModalInterv", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showDialogCarcurant", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeCarte", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbBesoin", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showModalBesoin", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showModalLoadConducteur", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fileExcel", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "lstConducteur", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbDemandCarbu", ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showModalDetailDmdFond", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogShowListDfon", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "demandeDetailFond", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeDemandes", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogConfirmRefus", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogConfirm", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "demandeDetail", ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "mntTotal", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "totalDmd", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formRefus", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "ruleFormRefus", {
      rapportRefus: [{ required: true, message: 'Veuillez saisir' }]
    }), _ref;
  },

  methods: {
    handleFileExcel: function handleFileExcel(command //0=>Importer,1=>generer
    ) {
      switch (command) {
        case "0":
          //importer un fichier
          this.$refs.fileInputExcel.click();
          break;
        case "1":
          //generer un modele un fichier
          this.generateFileExcel();
          break;
      }
    },
    generateFileExcel: function generateFileExcel() {
      var url = this.domaine + "conducteur/generer/modele";
      window.open(url);
    },
    onFileExcelPicked: function onFileExcelPicked() {
      var _this = this;

      this.fileExcel.splice(0, 1);
      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this.fileExcel.push(fileReader.result);
      });

      fileReader.readAsDataURL(files[0]);

      var url = this.domaine + "parc/load_conducteur/excel";
      var data = new FormData();
      //emvoie du fichier

      data.append("fichierExcel", files[0], files[0][name]);

      this.$http.post(url, data).then(function (resp) {
        _this.loading = false;

        _this.$notify({
          title: "Chargement liste conducteur",
          message: "Chargement effectué",
          type: "success",
          position: "top-right",
          duration: 7000
        });
        _this.lstConducteur = resp.body.lstConducteur;
        _this.showModalLoadConducteur = true;
      }, function (resp) {
        _this.loading = false;
        _this.$message.error("Erreur lors de l'importation du fichier");
      });
    },

    //MODAL BESOIN
    modalBesoin: function modalBesoin() {
      this.showModalBesoin = true;
      this.loadBesoinVehAvalider();
    },

    //enregistrement des images
    onFileImageLogoPicked: function onFileImageLogoPicked(event) {
      var _this2 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this2.logoMarque = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoMarque = files[0];
    },
    loadCarte: function loadCarte() {
      var _this3 = this;

      var url = this.domaine + "carteCarburant/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this3.cartes = response.body.cartes;
        }
      });
    },
    modalInterv: function modalInterv() {
      this.showModalInterv = true;
    },
    handleChangePrix: function handleChangePrix(item) {
      //this.loading = true
    },
    loadPage: function loadPage() {
      this.loading = true;
    },
    loadCout: function loadCout() {
      var _this4 = this;

      var url = this.domaine + "parc/dashboard/cout";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this4.detailCout = response.body.detailCout;
        }
      });
    },
    loadClientLocation: function loadClientLocation() {
      var _this5 = this;

      this.loading = true;
      var url = this.domaine + "client/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this5.listClientLocation = response.body.clients;
          _this5.nbClient = response.body.nbClient;

          if (_this5.listClientLocation === undefined || _this5.listClientLocation.length == 0) {
            _this5.disabledBtnCli = true;
          } else {
            _this5.disabledBtnCli = false;
          }
          _this5.loading = false;
        }
      });
    },
    loadCaisse: function loadCaisse() {
      var _this6 = this;

      var url = this.domaine + "caisse/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this6.listCaisse = response.body.caisse;
        }
      });
    },
    loadConducteur: function loadConducteur() {
      var _this7 = this;

      this.loading = true;
      var url = this.domaine + "conducteur/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this7.listConducteur = response.body.conducteur;
          if (_this7.listConducteur === undefined || _this7.listConducteur.length == 0) {
            _this7.disabledBtnCond = true;
          } else {
            _this7.disabledBtnCond = false;
          }
          _this7.nbCond = response.body.nbCond;
          _this7.tableStatCond = response.body.statCond;
          _this7.loading = false;
        }
      });
    },
    loadListConducteur: function loadListConducteur(item) {
      var _this8 = this;

      var url = this.domaine + "conducteur/search/" + item;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this8.listConducteur = response.body.conducteur;
          _this8.dialogConducteur = true;
        }
      });
    },
    loadListIntervention: function loadListIntervention(item) {
      var _this9 = this;

      var url = this.domaine + "intervention/search/" + item;
      // let url = this.domaine + 'intervention/search/'+item
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this9.listIntervention = response.body.intervention;
          _this9.dialogIntervention = true;
        }
      });
    },
    loadListContrat: function loadListContrat(item) {
      var _this10 = this;

      var url = this.domaine + "contrat/search/" + item;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this10.listContrat = response.body.contrat;
          _this10.dialogContrat = true;
        }
      });
    },
    loadConducteurDispo: function loadConducteurDispo() {
      var _this11 = this;

      var url = this.domaine + "contrat/index/conducteur/dispo";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this11.listConducteurDispo = response.body.conducteur;
        }
      });
    },
    loadForfait: function loadForfait() {
      var _this12 = this;

      var url = this.domaine + "tarification/forfait";
      this.$http.get(url).then(function (response) {
        _this12.nbTarif = response.body.nbTarif;
      });
    },
    loadClient: function loadClient() {
      var _this13 = this;

      var url = this.domaine + "contrat/index/client/location";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this13.listClient = response.body.client;
        }
      });
    },
    loadBesoinVehAvalider: function loadBesoinVehAvalider() {
      var _this14 = this;

      // this.loading = true
      var url = this.domaine + "besoin/vehicule";
      this.$http.get(url).then(function (response) {
        _this14.nbBesoins = response.body.besoins.length;
        // this.loading = false;
      });
    },
    loadTarification: function loadTarification() {
      var _this15 = this;

      this.loading = true;
      this.selectTarification = "";
      this.listTrarification = [];
      this.montantLocation = 0;
      this.montantLocationFormat = 0;
      if (this.selectVehicule != "") {
        var url = this.domaine + "contrat/tarification/index/" + this.selectVehicule;
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this15.listTrarification = response.body.tarif;
            _this15.loading = false;
            _this15.calculContrat();
          }
        });
      } else {
        this.loading = false;
        this.$notify({
          title: "ATTENTION",
          message: "Veuillez sélectionner le véhicule concerné.",
          type: "warning"
        });
      }
    },
    loadPrixLocation: function loadPrixLocation() {
      var _this16 = this;

      this.loading = true;
      this.montantLocation = 0;
      this.montantLocationFormat = 0;
      if (this.selectTarification != "") {
        var url = this.domaine + "contrat/prix/location/" + this.selectTarification;
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this16.montantLocation = response.body.montant;
            _this16.montantLocationFormat = response.body.montantFormat;
            _this16.calculContrat();
            _this16.loading = false;
          }
        });
      } else {
        this.$notify({
          title: "ATTENTION",
          message: "Veuillez sélectionner le tarif concerné.",
          type: "warning"
        });
        this.calculContrat();
        this.loading = false;
      }
    },
    loadCondMission: function loadCondMission(ligne) {
      var _this17 = this;

      var url = this.domaine + "conducteur/load/mission/" + ligne.idCond;
      this.idCondCours = ligne.idCond;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this17.listCondMission = response.body.missionsCond;
        }
      });
    },
    loadAssu: function loadAssu() {
      var _this18 = this;

      var url = this.domaine + "parc/index/assurance";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this18.listAssu = response.body.assurance;
          _this18.nbAssur = response.body.nbAssur;
          if (_this18.nbAssur == 0) {
            _this18.disabledBtnAssur = false;
          } else {
            _this18.disabledBtnAssur = true;
          }
          // this.loading = false;

          var notife = _this18.$vs;
          var thise = _this18;

          if (_this18.notif === "active" && response.body.compteur > 0 && _this18.droitAcces.intervention) {
            _this18.$vs.notify({
              title: "ASSURANCE",
              text: "Vous avez " + response.body.compteur + " assurance(s) qui expirent dans moins d'une semaine",
              type: "warning",
              position: "top-right",
              icon: "description",
              time: 10000
            });
          }

          var detail = _this18.notif;
          if (response.body.assurance) {
            _this18.listAssu.forEach(function (item) {
              if (item.expire == true && detail === "active" && this.droitAcces.intervention) {
                notife.notify({
                  title: "ASSURANCE EXPIRE",
                  text: "L'assurance' du véhicule " + item.VehMat + " a expirée depuis le " + item.dateFnReel,
                  color: "danger",
                  position: "top-right",
                  icon: "description",
                  //time:10000,
                  fixed: true,
                  click: function click() {
                    thise.showAssu(item);
                  }
                });
              }
            });
          }
        }
      });
    },
    loadDemandeCarburan: function loadDemandeCarburan() {
      var _this19 = this;

      this.loading = true;
      var url = this.domaine + "demandeFond/index/type/carburant";
      this.$http.get(url).then(function (response) {
        _this19.loading = false;
        _this19.listeDemandes = response.body.listeDemandes;
        _this19.nbDemandCarbu = _this19.listeDemandes.length;
        if (_this19.nbDemandCarbu > 0) {
          _this19.$notify({
            title: "DEMANDES DE FONDS EN CARBURANT",
            message: "VOUS AVEZ DES DEMANDES DE FONDS EN CARBURANT EN ATTENTE DE VALIDATION",
            type: "warning",
            position: "top-right",
            duration: 5000
          });
        }
        _this19.mntTotal = response.body.montantTotal;
        _this19.totalDmd = _this19.listeDemandes.length;
      }, function (error) {
        _this19.loading = false;
        _this19.$message.error("Une erreur est survenue lors du chargement des demandes de fonds");
      });
    },
    loadCompagnie: function loadCompagnie() {
      var _this20 = this;

      var url = this.domaine + "fournisseur/indexFournisseur";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this20.listCompagn = response.body.prestataire;
        }
      });
    },
    loadDevis: function loadDevis() {
      var _this21 = this;

      var url = this.domaine + "product/load-product-stock";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this21.listProduit = response.body;
        }
      });
    },
    loadPrestaire: function loadPrestaire() {
      var _this22 = this;

      var url = this.domaine + "fournisseur/indexPrestataire";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this22.listPrestataire = response.body.prestataire;
        }
      });
    },
    loadVisite: function loadVisite() {
      var _this23 = this;

      this.loading = true;
      var url = this.domaine + "visite/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this23.listVisite = response.body.visite;
          _this23.nbVisiteTech = response.body.nbVisiteTech;
          if (_this23.listVisite === undefined || _this23.listVisite.length == 0) {
            _this23.disabledBtnVisT = true;
          } else {
            _this23.disabledBtnVisT = false;
          }
          _this23.loading = false;
          var notif = _this23.$vs;
          var thise = _this23;

          if (_this23.notif === "active" && response.body.compteur > 0 && _this23.droitAcces.intervention) {
            _this23.$vs.notify({
              title: "VISITE TECHNIQUE",
              text: "Vous avez " + response.body.compteur + " visite(s) technique(s) qui expirent dans moins d'une semaine",
              type: "warning",
              position: "top-right",
              icon: "description",
              time: 5000
            });
          }

          _this23.listVisite.forEach(function (item) {
            if (thise.notif === "active" && item.expire == true && this.droitAcces.intervention) {
              notif.notify({
                title: "VISITE TECHNIQUE EXPIRE",
                text: "La visite technique du véhicule " + item.VehMat + " a expirée depuis le " + item.dateFin,
                color: "danger",
                position: "top-right",
                icon: "description",
                time: 5000,
                click: function click() {
                  thise.dialogShowVisit = true;
                  thise.visiteCourant = item;
                }
              });
            }
          });
        }
      });
    },
    loadVign: function loadVign() {
      var _this24 = this;

      this.loading = true;
      var url = this.domaine + "vidange/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this24.listVidn = response.body.vidange;
          _this24.nbVidang = response.body.nbVidang;
          if (_this24.listVidn === undefined || _this24.listVidn.length == 0) {
            _this24.disabledBtnAllVidn = true;
          } else {
            _this24.disabledBtnAllVidn = false;
          }
          _this24.loading = false;
          var notif = _this24.$vs;
          var thise = _this24;

          if (_this24.notif === "active" && response.body.compteur > 0 && _this24.droitAcces.intervention) {
            _this24.$vs.notify({
              title: "VIDANGE",
              text: "Vous avez " + response.body.compteur + " vidange(s) qui doivent être effectué aujourd'hui",
              color: "danger",
              position: "top-right",
              icon: "description",
              time: 10000
            });
          }

          _this24.listVidn.forEach(function (item) {
            var _this25 = this;

            if (thise.notif === "active" && item.expire == true && this.droitAcces.intervention) {
              notif.notify({
                title: "VIDANGE EXPIRE",
                text: "La vidange du véhicule " + item.VehMat + " a expirée depuis le " + item.dateDebt,
                color: "danger",
                position: "top-right",
                icon: "description",
                time: 10000,
                fixed: true,
                click: function click() {
                  _this25.showVign(item);
                }
              });
            }
          });
        }
      });
    },
    loadMarque: function loadMarque() {
      var _this26 = this;

      var url = this.domaine + "parc/index/marque";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this26.listMarque = response.body.marque;
          _this26.nbMarqu = response.body.nbMarqu;
          if (_this26.listMarque === undefined || _this26.listMarque.length == 0) {
            _this26.disabledBtnMarq = true;
          } else {
            _this26.disabledBtnMarq = false;
          }
        }
      });
    },
    loadModele: function loadModele() {
      var _this27 = this;

      var url = this.domaine + "parc/index/modele";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this27.listModele = response.body.modele;
          _this27.nbMarqu = _this27.listModele.length();
          if (_this27.listModele === undefined || _this27.listModele.length == 0) {
            _this27.disabledBtnMod = true;
          } else {
            _this27.disabledBtnMod = false;
          }
        }
      });
    },
    loadSerie: function loadSerie() {
      var _this28 = this;

      var url = this.domaine + "parc/index/serie";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this28.listSerie = response.body.serie;
          if (_this28.listSerie === undefined || _this28.listSerie.length == 0) {
            _this28.disabledBtnSerie = true;
          } else {
            _this28.disabledBtnSerie = false;
          }
        }
      });
    },
    loadVehicule: function loadVehicule() {
      var _this29 = this;

      this.loading = true;
      var type = 'flotte';
      var url = this.domaine + 'parc/index/type' + '/' + type;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this29.listVehicule = response.body.vehicule;
          _this29.nbVeh = response.body.nbVeh;
          _this29.nbVehLouer = response.body.nbVehLouer;
          //if(this.droitAcces.liste_demande_fond)
          (function (response) {
            _this29.loading = false;

            // this.mntTTC =  response.body.mntTTC
            _this29.cartes = response.body.cartes;
            _this29.oldCartes = response.body.cartes;

            _this29.mntTotal = response.body.montantTotalFormat;
            //affichage nombre de demande
            _this29.nbCarteCar = _this29.cartes.length;
          });
          (function (response) {
            _this29.loading = false;
            _this29.$message.error("Une erreur est survenue lors du chargement des cartes");
          });
        }
      });
    },
    loadIntervention: function loadIntervention() {
      var _this30 = this;

      this.loading = true;
      var url = "";

      if (this.droitAcces.intervention) {
        url = this.domaine + "intervention/index";
      } else {
        url = this.domaine + "intervention/demandeur/" + this.user.id + "/index";
      }

      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this30.listIntervention = response.body.intervention;
          _this30.nbDemand = response.body.nbDemand;
          _this30.tableStatInterv = response.body.statInterv;
          _this30.loading = false;
        }
      });
    },
    loadConsommation: function loadConsommation() {
      var _this31 = this;

      this.loading = true;
      var url = this.domaine + "consommation/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this31.loading = false;
          _this31.listConsommation = response.body.consommations;
          _this31.listOldConsommation = response.body.consommations;
          _this31.nbCarburan = response.body.nbCarburan;
          if (_this31.listConsommation === undefined || _this31.listConsommation.length == 0) {
            _this31.disabledBtnCarbu = true;
          } else {
            _this31.disabledBtnCarbu = false;
          }
          _this31.mntTotCons = response.body.totCons.mntTotCons;
          _this31.quantTotCons = response.body.totCons.quantTotCons;
          _this31.distParcTot = response.body.totCons.distParcTot;
          _this31.statConsom = response.body.stats;
          _this31.statConsom = response.body.stats;
          _this31.statQutConsom = response.body.stats;
          _this31.totCarb = response.body.totCarb;
          _this31.totMntCarb = response.body.totMntCarb;
          _this31.chartAllBilanCarburant();
          _this31.chartAllBilanCarburantQut();
          _this31.loading = false;
        }
      });
    },
    loadContrat: function loadContrat() {
      var _this32 = this;

      this.loading = true;
      var url = this.domaine + "contrat/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this32.listContrat = response.body.contrat;
          if (_this32.listContrat === undefined || _this32.listContrat.length == 0) {
            _this32.disabledBtnCont = true;
          } else {
            _this32.disabledBtnCont = false;
          }
          _this32.nbContrat = response.body.nbContrat;
          _this32.tableStatContrat = response.body.statCont;
          _this32.nbrContratExpireDay = response.body.nbrContratExpireDay;
          _this32.loading = false;
          var notif = _this32.$vs;
          var thise = _this32;
          _this32.listContrat.forEach(function (item) {
            //on verif le contrat est reservé
            if (thise.notif === "active" && item.etat == 0 && this.droitAcces.intervention) {
              notif.notify({
                title: "RESERVATION DU CLIENT " + item.client,
                text: "Cet contrat que vous avez enrégistré est encore en réservation. Veuillez contacté le client pour plus d'info",
                type: "warning",
                position: "top-right",
                icon: "description",
                time: 10000
              });
            }

            //on verifi si la date de fin du contrat est passé
            if (thise.notif === "active" && item.expire == true && this.droitAcces.intervention) {
              notif.notify({
                title: "CONTRAT EXPIRE",
                text: "Le contrat " + item.ref + " du client " + item.client + " a expiré depuis la date du " + item.dateFFormat,
                color: "danger",
                position: "top-right",
                icon: "description",
                time: 10000,
                click: function click() {
                  thise.contratCourant = item;
                  thise.dialogShowContrat = true;
                }
              });
            }
          });

          //contrat expirant aujourd'hui
          if (_this32.notif === "active" && _this32.nbrContratExpireDay != 0 && _this32.droitAcces.intervention) {
            _this32.$vs.notify({
              title: "CONTRAT EXPIRANT AUJOURD'HUI",
              text: _this32.nbrContratExpireDay + " Contrat (s) expire(ent) aujourd'hui.",
              color: "rgb(58, 154, 201)",
              position: "top-right",
              icon: "check_box",
              time: 10000
            });
          }
        }
      });
    },
    menuContrat: function menuContrat() {
      this.dialogContrat = true;
      this.loadContrat();
      this.loadClientLocation();
    },
    menuClient: function menuClient() {
      this.dialogClientLocation = true;
      this.loadClientLocation();
    },
    menuIntervention: function menuIntervention() {
      this.dialogIntervention = true;
      this.loadIntervention();
    },
    menuVisiteTechnique: function menuVisiteTechnique() {
      this.dialogVisite = true;
      this.loadVisite();
    },
    menuVidange: function menuVidange() {
      this.dialogVidange = true;
      this.loadVign();
    },
    menuAssurance: function menuAssurance() {
      this.dialogAssurance = true;
      this.loadAssu();
    },
    menuConducteur: function menuConducteur() {
      this.dialogConducteur = true;
      this.loadConducteur();
    },
    menuConsommation: function menuConsommation() {
      this.selectParc = '';
      this.dialogConsommationCarburant = true;
      this.loadConsommation();
    },
    menuCarte: function menuCarte() {
      this.showDialogCarcurant = true;
    },
    modalDmdCarb: function modalDmdCarb() {
      this.dialogShowListDfon = true;
    },
    modalImpDmd: function modalImpDmd(item) {
      this.demandeDetailFond = item;
      this.showModalDetailDmdFond = true;
    },
    showDialogDmdFondAfter: function showDialogDmdFondAfter(idDmd, type) {
      this.showModalDetailDmdFond = false;
      this.loadDemandeCarburan();
    },
    modalResponse: function modalResponse(item, response) {
      this.demandeDetail = item;
      if (response) {
        this.dialogConfirm = true;
      } else {
        this.dialogConfirmRefus = true;
      }
    },
    menuMarque: function menuMarque() {
      this.dialogParaMarque = true;
      this.loadMarque();
      this.loadModele();
      this.loadSerie();
    },
    modalMission: function modalMission() {
      this.showModalMission = true;
    },
    modalTarifs: function modalTarifs() {
      this.showModalTarif = true;
    },
    modalCalend: function modalCalend() {
      this.showModalCalendContrat = true;
    },
    newContrat: function newContrat() {
      this.contratCourant = [];
      this.dialogEdit = false;
      this.loadTarification();
      this.dialogAjoutContrat = true;
      this.montantLocation = 0;
      this.selectVehicule = "";
      this.selectClient = "";
      this.selectCaisse = "";
      this.selectEtat = "";
      this.attribuer = false;
      this.totalF = 0;
      this.selectTarification = "";
      this.typeContrat = "Contrat de location";
      this.selectConducteur = "";
      this.remise = 0;
      this.tva = 0;
      this.penalite = 0;
      this.nbr = 1;
      this.montantLocation = 0;
      this.kilometrage = 0;
      this.avance = 0;
      this.dateS = "";
      this.dateD = "";
      this.datePaiement = "";
      this.optionContrat = [{
        key: Date.now(),
        libelle: "",
        cout: 0,
        qte: 1,
        tva: 0,
        total: 0,
        id: ""
      }];
    },
    newClientLocation: function newClientLocation() {
      this.dialogAjoutClientLocation = true;
      this.dialogEdit = false;
      this.formClientLocation.nom = "";
      this.formClientLocation.prenom = "";
      this.formClientLocation.piece = "";
      this.formClientLocation.numPiece = "";
      this.formClientLocation.type = "";
      this.formClientLocation.contact = "";
      this.formClientLocation.adresse = "";
      this.formClientLocation.email = "";
    },
    newIntervention: function newIntervention() {
      this.dialogEdit = false;
      this.dialogAjoutIntervention = true;
      this.interventionCourant = [];
      this.interventionCourant.etat = 0;
      this.etape = 1;
      //this.demandeur = ''
      this.loadUserAdmin();
      this.selectPriorite = "";
      this.selectType = "";
      this.selectGravite = "";
      this.selectCategorie = "";
      this.motif = "";
      this.dateInter = "";
      this.selectVehicule = "";
      this.selectCaisse = "";
      this.selectReponse = "";
      // this.calculTotalDevis()
      this.devis = [{
        key: Date.now(),
        libelle: "",
        cout: 0,
        qte: 1,
        tva: 0,
        total: 0,
        id: ""
      }];
    },
    newValiderDevis: function newValiderDevis(ligne) {
      this.dialogEdit = true;
      this.dialogValiderDevis = true;
      this.interventionCourant = ligne;
      this.selectReponseDevis = "";
      this.remarqueValider = "";
    },
    newConducteur: function newConducteur() {
      this.dialogAjoutCond = true;
      this.dialogEdit = false;
      this.selectMarque = "";
      this.formConducteur = {};
      this.typedePermis = [];
      this.$refs.formConducteur.reset();
      this.conducteurCourant = [];
      this.imageChauf = "/static/img-doc.png";
    },
    newAssu: function newAssu() {
      this.dialogAjoutAssu = true;
      this.dialogEdit = false;
      this.assuranceCourant = [];
      this.logoAssur = "/static/img-doc.png";
      this.selectMarque = "";
      this.selectParc = '';
      this.selectCompagnLib = "";
      this.selectVehicule = "";
      this.formAssu = {};
    },
    newVida: function newVida() {
      this.dialogAjoutVign = true;
      this.dialogEditVign = true;
      this.selectMarque = "";
      this.selectParc = "";
      this.formVidn = {};
      this.vidangeCourant = [];
      this.vidangeCourant.vehId = "";
      this.vidangeCourant.id = "";
      this.selectVehicule = "";
      this.selectVehiculeId = "";
      this.logoVidange = "/static/img-doc.png";
    },
    newAttrCondu: function newAttrCondu() {
      this.dialogAjoutVehiConducteur = true;
      this.formAttribueCondu.vehicule = '';
      this.formAttribueCondu.parc = '';
      this.selectParc = "";
    },
    newVisit: function newVisit() {
      this.dialogAjoutVisit = true;
      this.dialogEdit = false;
      this.formVisite = {};
      this.logoVisite = "/static/img-doc.png";
      this.selectVehicule = "";
      this.selectParc = "";
      this.visiteCourant = [];
    },
    newMarque: function newMarque() {
      this.dialogAjoutMarq = true;
      this.dialogEdit = false;
      this.formMarque = {};
      this.marqueCourant.id = "";
      this.logoMarque = "/static/img-doc.png";
    },
    newModele: function newModele() {
      this.dialogAjoutMod = true;
      this.dialogEdit = false;
      this.selectMarque = "";
      this.formModele = {};
    },
    newSerie: function newSerie() {
      this.dialogAjoutSerie = true;
      this.dialogEdit = false;
      this.formSerie = {};
      this.selectSerie = "";
    },
    newConsom: function newConsom() {
      this.dialogAjoutCons = true;
      this.consommationCourant = "";
      this.imageConsom = "/static/img-doc.png";
      this.formAjoutCons.station = "";
      this.formAjoutCons.dateAchat = "";
      this.formAjoutCons.distParcourCons = 0;
      this.formAjoutCons.vehicule = "";
      this.formAjoutCons.typeCons = "";
      this.formAjoutCons.montant = 0;
      this.formAjoutCons.quantite = 0;
      this.formAjoutCons.kiloCons = 0;
    },
    editContrat: function editContrat(ligne) {
      this.contratCourant = ligne;
      this.dialogEdit = true;
      this.dialogAjoutContrat = true;
      this.selectVehicule = ligne.idVeh;
      this.selectClient = ligne.idCli;
      this.selectCaisse = ligne.idCaisse;
      this.selectEtat = ligne.etatContrat;
      this.attribuer = ligne.attribuer;
      this.selectTarification = ligne.idTarif;
      this.listTrarification = ligne.optionTarif;
      this.typeContrat = "Contrat de location";
      this.selectConducteur = ligne.idCond;
      this.remise = ligne.remise;
      this.tva = ligne.remise;
      this.nbr = ligne.nbr;
      this.montantLocation = ligne.montantLocation;
      this.avance = ligne.avance;
      this.penalite = ligne.penalite;
      this.kilometrage = ligne.kilomSorti;
      this.dateS = ligne.dateS;
      this.dateD = "";
      this.datePaiement = ligne.datePaiement;
      this.optionContrat = ligne.option;

      this.loadPrixLocation();
    },
    editClientLocation: function editClientLocation(ligne) {
      this.dialogAjoutClientLocation = true;
      this.dialogEdit = true;
      this.clientLocationCourant = ligne;
      this.formClientLocation = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, ligne);
      this.clientLocationCourant.url = ligne.url;
    },
    editCarburant: function editCarburant(ligne) {
      this.consommationCourant = ligne;
      this.dialogAjoutCons = true;
      this.imageConsom = this.consommationCourant.imageRecu;
      this.formAjoutCons.station = ligne.station;
      this.formAjoutCons.dateAchat = ligne.dateAchat;
      this.formAjoutCons.distParcourCons = ligne.distParcourCons;
      this.formAjoutCons.vehicule = ligne.idVeh;
      this.formAjoutCons.typeCons = ligne.typeCons;
      this.formAjoutCons.montant = ligne.mntCons;
      this.formAjoutCons.quantite = ligne.quantite;
      this.formAjoutCons.kiloCons = ligne.kiloCons;
    },
    editConducteur: function editConducteur(ligne) {
      this.dialogAjoutCond = true;
      this.dialogEdit = true;
      this.conducteurCourant = ligne;
      this.imageChauf = ligne.url;
      this.formConducteur.imageUrl = ligne.url;
      this.formConducteur.nom = ligne.nom;
      this.formConducteur.adresse = ligne.adresse;
      this.formConducteur.email = ligne.email;
      this.formConducteur.lieuNaiss = ligne.lieuNaiss;
      this.formConducteur.prenom = ligne.prenom;
      this.formConducteur.matricule = ligne.matricule;
      this.formConducteur.fonction = ligne.fonction;
      this.formConducteur.dateNaiss = ligne.dateNs;
      this.formConducteur.dateEmbauch = ligne.dateEmb;
      this.detailsPermis = ligne.typePermis;
      this.typedePermis = '';
      this.formConducteur.numPermis = ligne.numPermis;
      this.formConducteur.dateValPermis = ligne.dateVp;
      this.formConducteur.phone1 = ligne.phone1;
      this.formConducteur.phone2 = ligne.phone2;

      if (this.conducteurCourant.dispo == 0) {
        this.formConducteur.disponibilite = "Disponible";
      } else if (this.conducteurCourant.dispo == 1) {
        this.formConducteur.disponibilite = "Activite";
      } else {
        this.formConducteur.disponibilite = "Absent";
      }
      this.loading = false;
    },
    editAssu: function editAssu(ligne) {
      this.dialogShowAssu = false;
      this.dialogAjoutAssu = true;
      this.dialogEdit = true;
      this.logoAssur = ligne.url;
      this.assuranceCourant = ligne;
      this.formAssu.attestation = this.assuranceCourant.numAttes;
      this.formAssu.police = this.assuranceCourant.numPolice;
      this.formAssu.montant = this.assuranceCourant.mntAssurReel;
      this.formAssu.description = this.assuranceCourant.descripAssur;
      this.formAssu.dateAssu = this.assuranceCourant.dateAssur;
      this.formAssu.dateDebutAssu = this.assuranceCourant.dateDbtReel;
      this.formAssu.dateFinAssu = this.assuranceCourant.dateFnReel;
      this.formAssu.dateRenAssu = this.assuranceCourant.dateRenouvReel;
      // this.formAssu.statut = this.assuranceCourant.statut;
      this.selectCompagnLib = this.assuranceCourant.societeId;
      this.selectVehicule = this.assuranceCourant.vehId;
    },
    editVign: function editVign(ligne) {
      this.dialogAjoutVign = true;
      this.dialogEditVign = false;
      this.dialogShowVign = false;
      this.vidangeCourant = ligne;
      this.selectParc = ligne.parcVehi;
      this.logoVidange = ligne.url;
      this.formVidn = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, ligne);
      this.formVidn.montant = this.vidangeCourant.montant;
      this.formVidn.statut = this.vidangeCourant.statut;
      this.selectVehicule = this.vidangeCourant.vehMat;
      this.selectVehiculeId = this.vidangeCourant.vehId;
    },
    editVisit: function editVisit(ligne) {
      this.dialogAjoutVisit = true;
      this.dialogEdit = true;
      this.logoVisite = ligne.url;
      this.selectParc = "";
      this.visiteCourant = ligne;
      this.formVisite = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, ligne);
      this.formVisite.montant = this.visiteCourant.montant;
      this.formVisite.statut = this.visiteCourant.statut;
      this.selectVehicule = this.visiteCourant.VehId;
    },
    editMarque: function editMarque(ligne) {
      this.loadingModalMarq = false;
      this.dialogAjoutMarq = true;
      this.dialogEdit = true;
      this.marqueCourant = ligne;
      this.formMarque.libelle = this.marqueCourant.libelle;
      this.logoMarque = ligne.url;
    },
    editModele: function editModele(ligne) {
      this.loadingModalMod = false;
      this.dialogAjoutMod = true;
      this.dialogEdit = true;
      this.modeleCourant = ligne;
      this.formModele.libelle = this.modeleCourant.libelle;
      this.selectMarque = this.modeleCourant.marqLibelle;
    },
    editSerie: function editSerie(ligne) {
      this.loadingModalSerie = false;
      this.dialogAjoutSerie = true;
      this.dialogEdit = true;
      this.serieCourant = ligne;
      this.formSerie.libelle = this.serieCourant.libelle;
      this.selectSerie = this.serieCourant.ModeleId;
    },
    closeContrat: function closeContrat(ligne) {
      this.contratCourant = ligne;
      this.dialogCloseContrat = true;
      this.selectCLose = "";
      this.remarque = "";
      this.dateR = "";
      this.kilometrage = 0;
    },

    //enregistrement des images
    onFileImageAssurLogoPicked: function onFileImageAssurLogoPicked(event) {
      var _this33 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this33.logoAssur = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoAssur = files[0];
    },
    onFileImageVidangeLogoPicked: function onFileImageVidangeLogoPicked(event) {
      var _this34 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this34.logoVidange = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoVidange = files[0];
    },
    onFileImageVisiteLogoPicked: function onFileImageVisiteLogoPicked(event) {
      var _this35 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this35.logoVisite = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoVisite = files[0];
    },
    showIntervention: function showIntervention(ligne) {
      var _this36 = this;

      this.loadUserAdmin();
      this.loadIntervention();

      this.loading = true;
      this.interventionCourant = ligne;
      this.dialogEdit = true;
      this.dialogAjoutIntervention = true;

      this.selectPriorite = ligne.priorite;
      this.selectType = ligne.type;
      this.selectGravite = ligne.gravite;
      this.selectCategorie = ligne.categorie;
      this.motif = ligne.motif;
      this.selectReponse = ligne.etat;
      this.dateInter = ligne.dateFormat;
      this.selectVehicule = ligne.idVeh;
      this.selectPrestataire = ligne.idPres;
      this.remarque = ligne.remarque;
      this.diagnostique = ligne.diagnostique;
      this.maindoeuvre = ligne.maindoeuvre;
      this.kilometrage = ligne.kilometrage;
      this.dateD = ligne.dateDFormat;
      this.dateF = ligne.dateFFormat;
      this.remarqueFin = ligne.remarqueFin;
      this.fileFin = ligne.fichierFin;
      this.etape = ligne.etape;
      if (!this.droitAcces.intervention) {
        this.etape = 1;
      }
      this.devis = ligne.devis;
      this.datePaiement = ligne.datePaiement;
      this.selectCaisse = ligne.idCaisse;
      this.imageDevis = ligne.photoDevis;
      //this.demandeur = ligne.idDemandeur

      var url = this.domaine + "intervention/" + ligne.id + "/show/intervention";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this36.interventionCourant = response.body.intervention;
          _this36.loading = false;
        }
      }, function (response) {});
      this.calculTotalDevis();
    },
    showContrat: function showContrat(ligne) {
      this.contratCourant = ligne;
      this.dialogShowContrat = true;
    },
    showLocationClient: function showLocationClient(ligne) {
      this.dialogShowClientLocation = true;
      this.clientLocationCourant = ligne;
    },
    showCondMission: function showCondMission(ligne) {
      this.detailMission = ligne;
      this.dialogShowCondMission = true;
      this.condMissionCourant = ligne;
    },
    showAssu: function showAssu(ligne) {
      this.dialogShowAssu = true;
      this.assuranceCourant = ligne;
      this.formAssu.attestation = this.assuranceCourant.numAttes;
      this.formAssu.police = this.assuranceCourant.numPolice;
      this.formAssu.montant = this.assuranceCourant.mntAssurReel;
      this.formAssu.description = this.assuranceCourant.descripAssur;
      this.formAssu.dateAssu = this.assuranceCourant.dateAssur;
      this.formAssu.dateDebutAssu = this.assuranceCourant.dateDbtReel;
      this.formAssu.dateFinAssu = this.assuranceCourant.dateFnReel;
      this.formAssu.dateRenAssu = this.assuranceCourant.dateRenouvReel;
      this.showCompagnLib = this.assuranceCourant.compagnLibelle;
      this.showVehLib = this.assuranceCourant.vehMatricule;
    },
    showVisit: function showVisit(ligne) {
      this.dialogShowVisit = true;
      this.visiteCourant = ligne;
    },
    showVign: function showVign(ligne) {
      this.dialogShowVign = true;
      this.vidangeCourant = ligne;
      this.formVidn.attestation = this.vidangeCourant.numAttes;
      this.formVidn.police = this.vidangeCourant.numPolice;
      this.formVidn.montant = this.vidangeCourant.mntAssurReel;
      this.formVidn.description = this.vidangeCourant.descripAssur;
      this.formVidn.dateAssu = this.vidangeCourant.dateAssur;
      this.formVidn.dateDebutAssu = this.vidangeCourant.dateDbtReel;
      this.formVidn.dateFinAssu = this.vidangeCourant.dateFnReel;
      this.formVidn.dateRenAssu = this.vidangeCourant.dateRenouvReel;
      this.showCompagnLib = this.vidangeCourant.compagnLibelle;
      this.showVehLib = this.vidangeCourant.vehMatricule;
    },
    ficheConducteur: function ficheConducteur(ligne) {
      this.dialogFicheCond = true;
      this.conducteurCourant = ligne;
    },
    submitIntervention: function submitIntervention(etape) {
      var _this37 = this;

      this.loading = true;
      if (this.$refs.formIntervention.validate()) {
        if (this.selectVehicule != "" && this.selectType != "" && this.selectGravite != "" && this.selectPriorite != "" && this.motif != "" && this.dateInter != "") {
          var form = document.getElementById("formIntervention");
          var data = new FormData(form);
          data.append("idUser", this.user.id);
          // data.append("etape", etape);
          // data.append("type", this.selectType);
          // data.append("priorite", this.selectPriorite);
          // data.append("gravite", this.selectGravite);
          // data.append("categorie", this.selectCategorie);
          // data.append("vehicule", this.selectVehicule);
          if (this.interventionCourant.id) {
            data.append("id", this.interventionCourant.id);
          } else {
            data.append("id", "");
          }
          var url = this.domaine + "intervention/new/intervention";
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              if (response.body.code == 1) {
                _this37.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Demande d'intervention enregistré avec succès.",
                  type: "success",
                  position: "top-center",
                  duration: 5000
                });

                _this37.loadIntervention();
                // this.showIntervention(response.body.data)
                _this37.loading = false;

                if (!_this37.droitAcces.intervention) {
                  _this37.dialogAjoutIntervention = false;
                } else {
                  _this37.showIntervention(response.body.data);
                  if (etape == 1) {
                    _this37.dialogAjoutIntervention = false;
                  } else {
                    _this37.etape = etape;
                  }
                }
              }
            }
          }, function (response) {
            _this37.loading = false;
          });
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
    },
    submitContrat: function submitContrat() {
      var _this38 = this;

      this.loading = true;
      if (this.$refs.formContrat.validate() && this.selectVehicule != "" && this.selectClient != "" && this.montantLocation != 0 && this.selectCaisse != "" && this.dateS != "" && this.dateD != "" && (this.selectEtat != "" || this.selectEtat != null) && this.selectTarification != "" && this.remise >= 0 && this.nbr >= 1 && this.datePaiement != "") {
        var etat = false;
        if (this.optionContrat.length > 0) {
          this.optionContrat.forEach(function (item) {
            if (item.libelle != "" && item.qte != 0 && item.cout != 0) {
              etat = true;
            }
          });
        } else {
          etat = true;
        }
        if (etat == true) {
          var form = document.getElementById("formContrat");
          var data = new FormData(form);
          data.append("idUser", this.user.id);
          data.append("vehicule", this.selectVehicule);
          data.append("client", this.selectClient);
          data.append("caisse", this.selectCaisse);
          data.append("etat", this.selectEtat);
          data.append("attribuer", this.attribuer);
          data.append("total", this.totalF);
          data.append("tarif", this.selectTarification);
          data.append("typeContrat", this.typeContrat);
          data.append("totalTtc", this.totalTtc);
          data.append("totalHT", this.ht);
          data.append("option", []);
          if (this.attribuer == true) {
            data.append("conducteur", this.selectConducteur);
          }
          if (this.contratCourant.id) {
            data.append("id", this.contratCourant.id);
          } else {
            data.append("id", "");
          }
          this.optionContrat.forEach(function (item) {
            data.append("option[id][]", item.id);
            data.append("option[libelle][]", item.libelle);
            data.append("option[qte][]", item.qte);
            data.append("option[unite][]", item.unite);
            data.append("option[montant][]", item.cout);
            data.append("option[tva][]", item.tva);
            data.append("option[total][]", item.total);
          });

          var url = this.domaine + "contrat/new";
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              if (response.body.code == 1) {
                _this38.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Contrat enregistré avec succès.",
                  type: "success",
                  position: "top-center",
                  duration: 5000
                });
                _this38.totalTtc = 0;
                _this38.loadContrat();
                _this38.loading = false;
                _this38.dialogAjoutContrat = false;
                _this38.$refs.formContrat.reset();
              }
            }
          }, function (response) {
            _this38.loading = false;
          });
        } else {
          this.$message.error("Veuillez compléter les champs obligatoires pour la facture !");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
    },
    submitClientLocation: function submitClientLocation() {
      var _this39 = this;

      this.loading = true;
      if (this.$refs.formClientLocation.validate()) {
        if (this.formClientLocation.nom != "" && this.formClientLocation.prenom != "" && this.formClientLocation.piece != "" && this.formClientLocation.numPiece != "" && this.formClientLocation.DateDelivrPiece != "" && this.formClientLocation.DateExpirPiece != "" && this.formClientLocation.contact != "" && this.formClientLocation.profession != "" && this.formClientLocation.type != "" && this.formClientLocation.persoSignataire != "" && this.formClientLocation.nomPersoContact != "" && this.formClientLocation.prenomPersoContact != "" && this.formClientLocation.telPersoContact != "") {
          var form = document.getElementById("formClientLocation");
          var data = new FormData(form);
          data.append("type", this.formClientLocation.type);
          data.append("affinite", this.formClientLocation.affinite);
          var url = this.domaine + "client/new";
          if (this.clientLocationCourant.id) {
            data.append("id", this.clientLocationCourant.id);
          } else {
            data.append("id", "");
          }

          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this39.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Location client enregistrée avec succès.",
                  type: "success",
                  position: "top-center",
                  duration: 5000
                });

                _this39.loadClientLocation();
                _this39.dialogAjoutClientLocation = false;
                _this39.loading = false;
                _this39.$refs.formClientLocation.reset();
              } else if (verif.code === 0) {
                _this39.$message.error(verif.message);
                _this39.loading = false;
              }
            } else {
              _this39.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this39.loading = false;
            }
          }, function (response) {
            _this39.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this39.loading = false;
          });
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Location client n'a pas été enregistrée.",
          position: "top-center",
          duration: 5000
        });
        this.loading = false;
      }
    },
    submitValideIntervention: function submitValideIntervention(etape) {
      var _this40 = this;

      this.loading = true;
      if (this.$refs.formValidInter.validate()) {
        if (this.selectReponse != "") {
          var form = document.getElementById("formValidInter");
          var data = new FormData(form);
          data.append("idUser", this.user.id);
          data.append("etape", etape);
          data.append("reponse", this.selectReponse);

          var url = this.domaine + "intervention/new/" + this.interventionCourant.id + "/valider/intervention";
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              if (response.body.code == 1) {
                _this40.loadIntervention();
                _this40.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Validation de l'intervention enregistré avec succès.",
                  type: "success",
                  position: "top-center",
                  duration: 5000
                });

                _this40.showIntervention(response.body.data);
                _this40.loading = false;
                if (_this40.selectReponse == 1) {
                  _this40.etape = etape;
                } else {
                  _this40.etape = 2;
                }
              }
            }
          }, function (response) {
            _this40.loading = false;
          });
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
    },
    submitDiagnostique: function submitDiagnostique(etape) {
      var _this41 = this;

      this.loading = true;
      if (this.$refs.formDiagnostique.validate()) {
        if (this.selectPrestataire != "" && this.maindoeuvre != 0 && this.maindoeuvre >= 0 && this.diagnostique != "" && this.datePaiement != "") {
          var etat = false;
          if (this.devis.length > 0) {
            this.devis.forEach(function (item) {
              if (item.libelle != "" && item.qte > 0 && item.cout > 0) {
                etat = true;
              }
            });
          }
          if (etat == true) {
            var form = document.getElementById("formDiagnostique");
            var data = new FormData(form);
            data.append("idUser", this.user.id);
            data.append("etape", etape);
            data.append("idPres", this.selectPrestataire);
            data.append("caisse", this.selectCaisse);
            this.devis.forEach(function (item) {
              data.append("option[id][]", item.id);
              data.append("option[libelle][]", item.libelle);
              data.append("option[qte][]", item.qte);
              data.append("option[unite][]", item.unite);
              data.append("option[montant][]", item.cout);
              data.append("option[tva][]", item.tva);
            });

            var url = this.domaine + "intervention/new/" + this.interventionCourant.id + "/diagnostique";
            this.$http.post(url, data).then(function (response) {
              _this41.loading = false;
              _this41.$refs.fileDevis.value = "";
              _this41.imageDevis = "/static/img-doc.png";
              if (response.body) {
                if (response.body.code == 1) {
                  _this41.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Diagnostique enregistré avec succès.",
                    type: "success",
                    position: "top-center",
                    duration: 5000
                  });

                  _this41.loadIntervention();
                  _this41.showIntervention(response.body.data);
                  _this41.loading = false;
                }
              }
            }, function (response) {
              _this41.loading = false;
            });
          } else {
            this.$message.error("Veuillez compléter les champs obligatoires pour le dévis !");
            this.loading = false;
          }
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
    },
    submitValiderDevis: function submitValiderDevis() {
      var _this42 = this;

      this.loading = true;
      if (this.$refs.formValiderDevis.validate()) {
        if (this.selectReponseDevis != "") {
          var form = document.getElementById("formValiderDevis");
          var data = new FormData(form);
          data.append("idUser", this.user.id);
          data.append("reponse", this.selectReponseDevis);

          var url = this.domaine + "intervention/new/" + this.interventionCourant.id + "/valider/devis";
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              if (response.body.code == 1) {
                _this42.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Validation du dévis enregistré avec succès.",
                  type: "success",
                  position: "top-center",
                  duration: 5000
                });

                _this42.$refs.fileDevis.value = "";
                _this42.imageDevis = "/static/car_avatar.png";
                _this42.dialogValiderDevis = false;
                _this42.loadIntervention();
                _this42.showIntervention(_this42.interventionCourant);
                _this42.loading = false;
              }
            }
          }, function (response) {
            _this42.loading = false;
          });
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
    },

    //enregistrement des images
    onFileImageChauffPicked: function onFileImageChauffPicked(event) {
      var _this43 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this43.imageChauf = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.imageChauf = files[0];
    },
    submitCloseContrat: function submitCloseContrat() {
      var _this44 = this;

      this.loading = true;
      if (this.$refs.formCloseContrat.validate()) {
        if (this.selectClose != "" && this.dateR != "") {
          var form = document.getElementById("formCloseContrat");
          var data = new FormData(form);
          data.append("idUser", this.user.id);
          data.append("reponse", this.selectClose);

          var url = this.domaine + "contrat/close/" + this.contratCourant.id;
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              if (response.body.code == 1) {
                _this44.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Contrat fermé avec succès.",
                  type: "success",
                  position: "top-center",
                  duration: 5000
                });

                _this44.dialogCloseContrat = false;
                _this44.loadContrat();
                _this44.loadConducteur();
                _this44.loading = false;
              }
            }
          }, function (response) {
            _this44.loading = false;
          });
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
    },
    submitProgrammation: function submitProgrammation(etape) {
      var _this45 = this;

      this.loading = true;
      if (this.$refs.formProgrammation.validate()) {
        if (this.dateD != "" && this.dateF != "" && this.dateD < this.dateF && this.kilometrage > 0) {
          var form = document.getElementById("formProgrammation");
          var data = new FormData(form);
          data.append("idUser", this.user.id);
          data.append("etape", etape);

          var url = this.domaine + "intervention/new/" + this.interventionCourant.id + "/programmation";
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              if (response.body.code == 1) {
                _this45.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Programmation enregistré avec succès.",
                  type: "success",
                  position: "top-center",
                  duration: 5000
                });

                _this45.dialogValiderDevis = false;
                _this45.loadIntervention();
                _this45.showIntervention(response.body.data);
                _this45.loading = false;
              }
            }
          }, function (response) {
            _this45.loading = false;
          });
        } else {
          this.$message.error("Veuillez remplir le formulaire correctement !");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
    },
    submitFinIntervention: function submitFinIntervention(etape) {
      var _this46 = this;

      this.loading = true;
      if (this.$refs.formFinIntervention.validate()) {
        if (this.remarqueFin != "") {
          var form = document.getElementById("formFinIntervention");
          var data = new FormData(form);
          data.append("idUser", this.user.id);
          data.append("etape", etape);

          var url = this.domaine + "intervention/new/" + this.interventionCourant.id + "/fin/intervention";
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              if (response.body.code == 1) {
                _this46.saveFichier(_this46.interventionCourant.id);
                _this46.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Fin de l'intervention enregistré avec succès.",
                  type: "success",
                  position: "top-center",
                  duration: 5000
                });

                _this46.loadIntervention();
                _this46.showIntervention(_this46.interventionCourant);
                _this46.loading = false;
              }
            }
          }, function (response) {
            _this46.loading = false;
          });
        } else {
          this.$message.error("Veuillez remplir le formulaire correctement !");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
    },
    submitConducteur: function submitConducteur() {
      var _this47 = this;

      // this.loading = true;
      if (this.$refs.formConducteur.validate()) {
        var form = document.getElementById("formConducteur");
        var data = new FormData(form);
        data.append("disponibilite", this.formConducteur.disponibilite);
        data.append("typePermis1", this.detailsPermis);
        data.append("typePermis", this.typedePermis);

        var url = this.domaine + "conducteur/new/conducteur";

        if (this.conducteurCourant.idCond) {
          data.append("id", this.conducteurCourant.idCond);
        } else {
          data.append("id", "");
        }

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this47.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Conducteur enregistré avec succès.",
                type: "success",
                position: "top-center",
                duration: 5000
              });

              _this47.loadConducteur();
              _this47.dialogAjoutCond = false;
              _this47.loading = false;
              _this47.$refs.formConducteur.reset();
              _this47.conducteurCourant = "";
            } else if (verif.code === 0) {
              _this47.$message.error(verif.message);
              _this47.loading = false;
            }
          } else {
            _this47.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this47.loading = false;
          }
        }, function (response) {
          _this47.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this47.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le conducteur n'a pas été enregistré.",
          position: "top-center",
          duration: 5000
        });
        this.loading = false;
      }
    },
    submitAttribution: function submitAttribution() {
      var _this48 = this;

      this.loading = true;
      var form = document.getElementById("formAttribueCondu");
      var data = new FormData(form);
      var url = this.domaine + "conducteur/vehicule/atribuer/new";
      data.append("vehicule", this.formAttribueCondu.vehicule);
      data.append("idConduteur", this.conducteurCourant.idCond);
      this.$http.post(url, data).then(function (response) {
        _this48.loading = false;
        var verif = response.body;
        if (verif.code === 1) {
          _this48.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: "Véhicule affécté à ce conducteur.",
            type: "success",
            position: "top-center",
            duration: 5000
          });
          _this48.loadVConducteur();
          _this48.dialogAjoutVehiConducteur = false;
          _this48.loading = false;
        }
      }, function (error) {
        _this48.$message.error("Ce véhicule déja été affecter à ce conducteur");
        _this48.loading = false;
      });
    },
    submitVisit: function submitVisit() {
      var _this49 = this;

      this.loading = true;
      if (this.$refs.formVisite.validate()) {
        if (this.formVisite.numero != "" && this.formVisite.dateDebut != "" && this.formVisite.dateFin != "" && this.formVisite.montant > 0 && (this.formVisite.statut == 0 || this.formVisite.statut == 1) && this.selectVehicule != "") {
          var form = document.getElementById("formVisite");
          var data = new FormData(form);
          data.append("idVeh", this.selectVehicule);
          data.append("statut", this.formVisite.statut);
          var url = this.domaine + "visite/new";
          if (this.visiteCourant.id) {
            data.append("id", this.visiteCourant.id);
          } else {
            data.append("id", "");
          }

          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this49.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Visite technique enregistrée avec succès.",
                  type: "success",
                  position: "top-center",
                  duration: 5000
                });

                _this49.loadVehicule();
                _this49.loadVisite();
                _this49.dialogAjoutVisit = false;
                _this49.loading = false;
                _this49.$refs.formVisite.reset();
              } else if (verif.code === 0) {
                _this49.$message.error(verif.message);
                _this49.loading = false;
              } else if (verif.code === 4) {
                _this49.$message.error(verif.message);
                _this49.loading = false;
              } else if (verif.code === 2) {
                _this49.$message.error(verif.message);
                _this49.loading = false;
              } else if (verif.code === 3) {
                _this49.$message.error(verif.message);
                _this49.loading = false;
              }
            } else {
              _this49.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this49.loading = false;
            }
          }, function (response) {
            _this49.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this49.loading = false;
          });
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Vidange n'a pas été enregistrée.",
          position: "top-center",
          duration: 5000
        });
        this.loading = false;
      }
    },
    submitAssu: function submitAssu() {
      var _this50 = this;

      this.loading = true;
      if (this.$refs.formAssu.validate()) {
        if (this.formAssu.attestation != "" && this.formAssu.police != "" && this.formAssu.montant > 0 && this.formAssu.dateAssu != "" && this.selectCompagnLib != "" && this.selectVehicule != "" && this.formAssu.dateDebutAssu && this.formAssu.dateFinAssu && (this.formAssu.statut == 1 || this.formAssu.statut == 0)) {
          var form = document.getElementById("formAssu");
          var data = new FormData(form);
          data.append("idVeh", this.selectVehicule);
          data.append("idCompagn", this.selectCompagnLib);
          data.append("statut", this.formAssu.statut);
          var url = this.domaine + "parc/new/assurance";
          if (this.assuranceCourant.id) {
            data.append("id", this.assuranceCourant.id);
          } else {
            data.append("id", "");
          }

          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;

              if (verif.code === 1) {
                _this50.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Asssurance enregistrée avec succès.",
                  type: "success",
                  position: "top-center",
                  duration: 5000
                });

                _this50.loadAssu();
                _this50.loadVehicule();
                _this50.loadCompagnie();
                _this50.dialogAjoutAssu = false;
                _this50.loading = false;
                _this50.$refs.formAssu.reset();
              } else if (verif.code === 4) {
                _this50.$notify({
                  title: "MODIFICATION REUSSI",
                  message: "Asssurance modifiée avec succès.",
                  type: "success",
                  position: "top-center",
                  duration: 5000
                });
                _this50.dialogAjoutAssu = false;
                _this50.dialogShowAssu = false;
                _this50.loading = false;
              } else if (verif.code === 0) {
                _this50.$message.error(verif.message);
                _this50.loading = false;
              } else if (verif.code === 2) {
                _this50.$message.error(verif.message);
                _this50.loading = false;
              } else if (verif.code === 3) {
                _this50.$message.error(verif.message);
                _this50.loading = false;
              }
            } else {
              _this50.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur 1");
              _this50.loading = false;
            }
            _this50.dialogAjoutAssu = false;
            _this50.loadAssu();
            _this50.loadVehicule();
            _this50.loadCompagnie();
            _this50.loading = false;
          }, function (response) {
            _this50.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur 2");
            _this50.loading = false;
          });
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Assurance n'a pas été enregistré.",
          position: "top-center",
          duration: 5000
        });

        this.loading = false;
      }
    },
    submitVign: function submitVign() {
      var _this51 = this;

      this.loading = true;
      if (this.$refs.formVidn.validate()) {
        var dateRen = this.functionTime(this.formVidn.dateRen);
        if (this.formVidn.numero != "" && this.selectVehicule != "" && this.formVidn.kiloActu != "" && this.formVidn.kiloProch != "" && this.formVidn.dateDebt != "" && this.formVidn.statut == 0 || this.formVidn.statut == 1) {
          if (dateRen.getTime() <= new Date().getTime() && this.formVidn.statut == 1) {
            this.loading = false;
            this.$notify.error({
              title: "ERREUR D'ENREGISTREMENT",
              message: "La date de renouvellement est passée,Veuillez désactiver l'assurance avant d'enregistrée",
              position: "top-center"
            });
          } else {
            var form = document.getElementById("formVidn");
            var data = new FormData(form);

            data.append("statut", this.formVidn.statut);
            var url = this.domaine + "vidange/new";
            if (this.vidangeCourant.id) {
              data.append("idVeh", this.selectVehiculeId);
              data.append("id", this.vidangeCourant.id);
            } else {
              data.append("id", "");
              data.append("idVeh", this.selectVehicule);
            }

            this.$http.post(url, data).then(function (response) {
              if (response.body) {
                var verif = response.body;
                if (verif.code === 1) {
                  _this51.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Vidange enregistrée avec succès.",
                    type: "success",
                    position: "top-center"
                  });

                  _this51.loadVehicule();
                  _this51.loadVign();
                  _this51.dialogAjoutVign = false;
                  _this51.loading = false;
                  _this51.$refs.formVidn.reset();
                  _this51.selectVehicule = "";
                  _this51.selectVehiculeId = "";
                } else if (verif.code === 0) {
                  _this51.$message.error(verif.message);
                  _this51.loading = false;
                } else if (verif.code === 3) {
                  _this51.$message.error(verif.message);
                  _this51.loading = false;
                }
              } else {
                _this51.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                _this51.loading = false;
              }
            }, function (response) {
              _this51.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this51.loading = false;
            });
          }
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Vidange n'a pas été enregistrée.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitCarburant: function submitCarburant() {
      var _this52 = this;

      this.loading = true;
      if (this.$refs.formConsomm.validate()) {
        if (this.formAjoutCons.vehicule != "" && this.formAjoutCons.station != "" && this.formAjoutCons.dateAchat != "" && this.formAjoutCons.montant > 0 && this.formAjoutCons.quantite > 0 && this.formAjoutCons.typeCons != "") {
          var form = document.getElementById("formConsomm");
          var data = new FormData(form);
          var url = this.domaine + "consommation/save";
          data.append("idUser", this.user.id);
          data.append("vehicule", this.formAjoutCons.vehicule);
          data.append("type", this.formAjoutCons.typeCons);
          data.append("identifiantCarte", this.formAjoutCons.identifiant);
          if (this.consommationCourant.id != "") {
            data.append("id", this.consommationCourant.id);
          } else {
            data.append("id", "");
          }

          this.$http.post(url, data).then(function (response) {
            _this52.loading = false;
            _this52.dialogAjoutCons = false;
            if (response.body) {
              _this52.loading = false;
              var verif = response.body;
              if (verif.code == 1) {
                _this52.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "La consommation a été enregistré avec succès.",
                  type: "success",
                  position: "top-right"
                });
              }

              if (verif.code == 3) {
                _this52.$notify({
                  title: "SOLDE CARTE INVALIDE",
                  message: "Le solde de la carte est inférieur au montant",
                  type: "warning",
                  position: "top-right",
                  duration: 5000
                });
              }
              _this52.loadConsommation();

              _this52.$refs.fileConsom.value = "";
              _this52.imageConsom = "/static/car_avatar.png";

              _this52.$refs.formConsomm.reset();
            } else {
              _this52.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this52.loading = false;
            }
            _this52.loadConsommation();
          }, function (response) {
            _this52.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this52.loading = false;
          });
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      }
    },
    submitMarq: function submitMarq() {
      var _this53 = this;

      this.loading = true;
      if (this.$refs.formMarque.validate()) {
        if (this.formMarque.libelle != "") {
          var form = document.getElementById("formMarque");
          var data = new FormData(form);
          var url = this.domaine + "parc/new/marque";
          if (this.marqueCourant.id) {
            data.append("id", this.marqueCourant.id);
          } else {
            data.append("id", "");
          }
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this53.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Marque enregistrée avec succès.",
                  type: "success",
                  position: "top-center"
                });

                _this53.loadMarque();
                _this53.dialogAjoutMarq = false;
                _this53.loading = false;
                _this53.$refs.formMarque.reset();
                _this53.$refs.uploadFichCom.reset();
              } else if (verif.code === 0) {
                _this53.$message.error(verif.message);
                _this53.loading = false;
              }
            } else {
              _this53.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this53.loading = false;
            }
          }, function (response) {
            _this53.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this53.loading = false;
          });
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La marque n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    deleteVehiCondu: function deleteVehiCondu(row) {
      var _this54 = this;

      this.loading = true;
      var url = this.domaine + "conducteur/delete/vehicule/" + this.conducteurCourant.idCond + '/' + row.idVeh;
      this.$http.get(url).then(function (response) {
        if (response.body.code === 1) {
          _this54.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: "Véhicule retiré avec succès.",
            type: "success",
            position: "top-center"
          });
          _this54.loadVConducteur();
          _this54.loading = false;
        }
      }, function (error) {
        _this54.$message.error("Impossible de retirer ce vehicule à ce conducteur.");
        _this54.loading = false;
      });
    },
    submitModele: function submitModele() {
      var _this55 = this;

      this.loading = true;
      if (this.$refs.formModele.validate()) {
        if (this.selectMarque != "" && this.formModele.libelle != "") {
          var form = document.getElementById("formModele");
          var data = new FormData(form);
          data.append("idMarque", this.selectMarque);

          var url = this.domaine + "parc/new/modele";
          if (this.modeleCourant.id) {
            data.append("id", this.modeleCourant.id);
          } else {
            data.append("id", "");
          }

          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this55.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Marque enregistrée avec succès.",
                  type: "success",
                  position: "top-center"
                });

                _this55.loadModele();
                _this55.loadMarque();
                _this55.dialogAjoutMod = false;
                _this55.loading = false;
                _this55.$refs.formModele.reset();
              } else if (verif.code === 0) {
                _this55.$message.error(verif.message);
                _this55.loading = false;
              }
            } else {
              _this55.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this55.loading = false;
            }
          }, function (response) {
            _this55.$message.error("Veuillez renseigner les champs obligatoires * ");
            _this55.loading = false;
          });
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La marque n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitSerie: function submitSerie() {
      var _this56 = this;

      this.loading = true;
      if (this.$refs.formSerie.validate()) {
        if (this.formSerie.libelle != "" && this.selectSerie != "") {
          var form = document.getElementById("formSerie");
          var data = new FormData(form);
          data.append("idModele", this.selectSerie);
          var url = this.domaine + "parc/new/serie";
          if (this.serieCourant.id) {
            data.append("id", this.serieCourant.id);
          } else {
            data.append("id", "");
          }

          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this56.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Marque enregistrée avec succès.",
                  type: "success",
                  position: "top-center"
                });

                _this56.loadSerie();
                _this56.dialogAjoutSerie = false;
                _this56.loading = false;
                _this56.$refs.formSerie.reset();
              } else if (verif.code === 0) {
                _this56.$message.error(verif.message);
                _this56.loading = false;
              }
            } else {
              _this56.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this56.loading = false;
            }
          }, function (response) {
            _this56.$message.error("Veuillez renseigner les champs obligatoires *");
            _this56.loading = false;
          });
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La marque n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    saveFichier: function saveFichier(id) {
      var url = this.domaine + "intervention/upload/fichiers/" + id;
      this.fichier.url = url;
      this.$refs.uploadIntervention.submit();
    },
    impmerFacture: function impmerFacture(ligne) {
      this.contratCourant = ligne;
      var url = this.domaine + "contrat/" + this.contratCourant.id + "/" + this.user.id + "/imprimer/facture";
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    imprimerDemande: function imprimerDemande(ligne) {
      this.interventionCourant = ligne;
      var url = this.domaine + "intervention/" + this.interventionCourant.id + "/imprimer";
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    ImprimerVidange: function ImprimerVidange(ligne) {
      var url = this.domaine + "vidange/imprimer/" + ligne.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    ImprimerVisite: function ImprimerVisite(ligne) {
      var url = this.domaine + "visite/imprimer/" + ligne.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    ImprimerConducteur: function ImprimerConducteur(ligne) {
      var url = this.domaine + "conducteur/imprimer/" + ligne.idCond;
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    imprimeListeHisAdminVisiteVeh: function imprimeListeHisAdminVisiteVeh(type) {
      var idVeh = this.idVeh;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "tabParcauto/imprimerPDF/historique/" + idVeh + "/admin-visite/vehicule";
      } else {
        url = this.domaine + "tabParcauto/imprimerEXC/historique/" + idVeh + "/admin-visite/vehicule";
      }
      window.open(url);
    },
    imprimeListeModele: function imprimeListeModele(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "parc/imprimerPDF/modele/liste";
      } else {
        url = this.domaine + "parc/imprimerEXC/modele/liste";
      }
      window.open(url);
    },
    imprimeListeSerie: function imprimeListeSerie(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "parc/imprimerPDF/serie/liste";
      } else {
        url = this.domaine + "parc/imprimerEXC/serie/liste";
      }
      window.open(url);
    },
    imprimeListeMarque: function imprimeListeMarque(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "parc/imprimerPDF/marque/liste";
      } else {
        url = this.domaine + "parc/imprimerEXC/marque/liste";
      }
      window.open(url);
    },
    imprimeListeConducteur: function imprimeListeConducteur(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "conducteur/imprimerPDF/liste";
      } else {
        url = this.domaine + "conducteur/imprimerEXC/liste";
      }
      window.open(url);
    },
    imprimeListeCarburant: function imprimeListeCarburant(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "consommation/imprimerPDF/liste";
      } else {
        url = this.domaine + "consommation/imprimerEXC/liste";
      }
      window.open(url);
    },
    imprimeListeContrat: function imprimeListeContrat(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "contrat/imprimerPDF/" + this.user.id + "/liste";
      } else {
        url = this.domaine + "contrat/imprimerEXC/liste";
      }
      window.open(url);
    },
    imprimeListeClient: function imprimeListeClient(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "client/imprimerPDF/liste";
      } else {
        url = this.domaine + "client/imprimerEXC/liste";
      }
      window.open(url);
    },
    imprimeListeVisitTechnik: function imprimeListeVisitTechnik(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "visite/imprimerPDF/liste";
      } else {
        url = this.domaine + "visite/imprimerEXC/liste";
      }
      window.open(url);
    },
    imprimeListeVign: function imprimeListeVign(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "vidange/imprimerPDF/liste";
      } else {
        url = this.domaine + "vidange/imprimerEXC/liste";
      }
      window.open(url);
    },
    imprimeListeAssur: function imprimeListeAssur(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "parc/imprimerPDF/assurance/liste";
      } else {
        url = this.domaine + "parc/imprimerEXC/assurance/liste";
      }
      window.open(url);
    },
    imprimeListeDemande: function imprimeListeDemande(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "intervention/imprimerPDF/liste";
      } else {
        url = this.domaine + "intervention/imprimerEXC/liste";
      }
      window.open(url);
    },
    deleteIntervention: function deleteIntervention() {
      var _this57 = this;

      this.loading = true;
      var url = this.domaine + "intervention/" + this.InterId + "/delete";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this57.$notify({
            title: "SUPPRESSION",
            message: "Intervention supprimée avec succès.",
            type: "success",
            position: "top-center"
          });
          _this57.dialogSupr = false;
          _this57.loading = false;
          _this57.loadIntervention();
          _this57.loading = false;
        }
      });
    },
    deleteMarq: function deleteMarq() {
      var _this58 = this;

      var url = this.domaine + "parc/delete/marque/" + this.idMarque;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          var verif = response.body;
          if (verif.code === 1) {
            _this58.$notify({
              title: "SUPPRESSION",
              message: "Marque supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
            _this58.dialogSuprMarq = false;
            _this58.loadMarque();
            // this.loadPage()
          } else if (verif.code === 0) {
            _this58.$message.error(verif.message);
            _this58.loading = false;
          }
        }
      });
    },
    deleteModel: function deleteModel() {
      var _this59 = this;

      var url = this.domaine + "parc/delete/modele/" + this.idModele;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          var verif = response.body;
          if (verif.code === 1) {
            _this59.$notify({
              title: "SUPPRESSION",
              message: "Modèle supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
            _this59.dialogSuprModel = false;
            _this59.loadModele();
            // this.loadPage()
          } else if (verif.code === 0) {
            _this59.$message.error(verif.message);
            _this59.loading = false;
          }
        }
      });
    },
    deleteSeri: function deleteSeri() {
      var _this60 = this;

      var url = this.domaine + "parc/delete/serie/" + this.idSerie;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          var verif = response.body;
          if (verif.code === 1) {
            _this60.$notify({
              title: "SUPPRESSION",
              message: "Serie supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
            _this60.dialogSuprSeri = false;
            _this60.loadSerie();
            // this.loadPage()
          } else if (verif.code === 0) {
            _this60.$message.error(verif.message);
            _this60.loading = false;
          }
        }
      });
    },
    deleteConducteur: function deleteConducteur() {
      var _this61 = this;

      var url = this.domaine + "conducteur/delete/" + this.idConducteur;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          var verif = response.body;
          if (verif.code === 1) {
            _this61.$notify({
              title: "SUPPRESSION",
              message: "Conducteur supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
            _this61.dialogSuprCond = false;
            _this61.loadConducteur();
            _this61.loadPage();
          } else if (verif.code === 0) {
            _this61.$message.error(verif.message);
            _this61.loading = false;
          }
        }
      });
    },
    deleteCarburant: function deleteCarburant() {
      var _this62 = this;

      this.loading = true;
      var url = this.domaine + "consommation/delete/" + this.idConsommation;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this62.loading = false;

          _this62.$notify({
            title: "SUPPRESSION",
            message: "La consommation a été  supprimé avec succès.",
            type: "success",
            position: "top-right"
          });
          _this62.dialogSuppCarburant = false;
          _this62.idConsommation = null;
          _this62.loadConsommation();
        }
      }, function (response) {
        _this62.$message.error("Erreur lors de la suppression de la consommation");
        _this62.loading = false;
      });
    },
    deleteAssu: function deleteAssu() {
      var _this63 = this;

      var url = this.domaine + "parc/delete/assurance/" + this.idAssu;
      this.$http.get(url).then(function (response) {
        if (response.body.rep == 1) {
          _this63.$notify({
            title: "SUPPRESSION",
            message: "Assurance supprimée avec succès.",
            type: "success",
            position: "top-center"
          });
          _this63.dialogSuprAssu = false;
          _this63.loadAssu();
          _this63.loadPage();
        } else if (response.body.rep == 0) {
          _this63.$notify({
            title: "SUPPRESSION",
            message: "Suppression impossible.",
            type: "error",
            position: "top-center"
          });
          _this63.dialogSuprAssu = false;
        }
      });
    },
    deleteVisit: function deleteVisit() {
      var _this64 = this;

      var url = this.domaine + "visite/delete/" + this.idVisit;
      this.$http.get(url).then(function (response) {
        if (response.body.rep == 1) {
          _this64.$notify({
            title: "SUPPRESSION",
            message: "Visite technique supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          _this64.dialogSuprVisit = false;
          _this64.loadVisite();
          _this64.loadPage();
        } else if (response.body.rep == 0) {
          _this64.$notify({
            title: "SUPPRESSION",
            message: "Suppression impossible.",
            type: "error",
            position: "top-center"
          });
          _this64.dialogSuprVisit = false;
        }
      });
    },
    deleteVign: function deleteVign() {
      var _this65 = this;

      var url = this.domaine + "vidange/delete/" + this.idVign;
      this.$http.get(url).then(function (response) {
        if (response.body.rep == 1) {
          _this65.$notify({
            title: "SUPPRESSION",
            message: "Vidange supprimée avec succès.",
            type: "success",
            position: "top-center"
          });
          _this65.dialogSuprVign = false;
          _this65.loadVign();
          _this65.loadPage();
        } else if (response.body.rep == 0) {
          _this65.$notify({
            title: "SUPPRESSION",
            message: "Suppression impossible.",
            type: "error",
            position: "top-center"
          });
          _this65.dialogSuprVign = false;
        }
      });
    },
    deleteClientLocation: function deleteClientLocation() {
      var _this66 = this;

      var url = this.domaine + "client/delete/" + this.idClientLoc;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          var verif = response.body;
          if (verif.code === 1) {
            _this66.$notify({
              title: "SUPPRESSION",
              message: "Client supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
            _this66.dialogSuprClientLocation = false;
            _this66.loadClientLocation();
            _this66.loadPage();
          } else if (verif.code === 0) {
            _this66.$message.error(verif.message);
            _this66.loading = false;
          }
        }
      });
    },
    selectTab: function selectTab(idtab) {
      var _this67 = this;

      switch (idtab) {
        case "tab-2":
          {
            this.loading = true;
            var url = this.domaine + "conducteur/load/mission-en-cours/" + this.conducteurCourant.idCond;
            this.$http.get(url).then(function (response) {
              if (response.body) {
                _this67.loading = false;
                _this67.listCondMissEnCours = response.body.missionsCondEnCours;
              }
            });
          }
          break;
        case "tab-3":
          {
            var _url = this.domaine + "tabParcauto/docadmin/" + this.idVeh;
            this.$http.get(_url).then(function (resp) {
              _this67.itemsDocAss = resp.body.docsassur;
              _this67.itemsDocVig = resp.body.docsvig;
              _this67.itemsDocVis = resp.body.docsvistech;
              _this67.mntTotAssur = resp.body.total.mntTotAssur;
              _this67.mntTotVig = resp.body.total.mntTotVig;
              _this67.mntTotVistech = resp.body.total.mntTotVistech;
            }, function (resp) {
              _this67.$message.error("erreur lors du chargement des documents administratifs");
            });
          }
          break;
        case "tab-4":
          {
            var _url2 = this.domaine + "tabParcauto/consommation/" + this.idVeh;
            this.$http.get(_url2).then(function (resp) {
              _this67.itemsCons = resp.body.consommation;
              _this67.mntTotCons = resp.body.total.mntTotCons;
              _this67.quantTotCons = resp.body.total.quantTotCons;
              _this67.distParcTot = resp.body.total.distParcTot;
            }, function (resp) {
              _this67.$message.error("erreur lors du chargement des consommations");
            });
          }
          break;
        case "tab-5":
          {
            this.loadVConducteur();
          }
          break;
      }
    },
    loadListMarq: function loadListMarq(queryString, cb) {
      var links = this.listMarque;
      var results = queryString ? links.filter(this.createFilter(queryString)) : links;
      cb(results);
    },
    loadVConducteur: function loadVConducteur() {
      var _this68 = this;

      this.loading = true;
      var url = this.domaine + "conducteur/load/list-vehicule-affecter/" + this.conducteurCourant.idCond;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this68.listVehiculeAffecte = response.body.listVehiculeAffecte;
          _this68.loading = false;
        }
      });
    },
    loadListMod: function loadListMod(queryString, cb) {
      var links = this.listModele;
      var results = queryString ? links.filter(this.createFilter(queryString)) : links;
      cb(results);
    },
    querySearch: function querySearch(queryString, cb) {
      var links = this.listProduit;
      var results = queryString ? links.filter(this.createFilter(queryString)) : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (link) {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    calculTotalDevis: function calculTotalDevis() {
      var total = 0;
      var tvaG = 0;
      var ht = 0;
      this.devis.forEach(function (item) {
        var t = 0;
        var c = 0;
        var tva = 0;
        c = parseInt(item.cout) * parseInt(item.qte);
        tva = c * (parseInt(item.tva) / 100);
        t = c + tva;
        item.total = t;
        total += t;
        tvaG += tva;
        ht += c;
      });

      this.total = new Intl.NumberFormat("fr-Fr").format(total);
      this.tva = new Intl.NumberFormat("fr-Fr").format(tvaG);
      this.ht = new Intl.NumberFormat("fr-Fr").format(ht);
    },
    calculContrat: function calculContrat() {
      var total = 0;
      var tvaG = this.tvaCont;
      var ht = 0;
      var montantLocation = this.montantLocation * this.nbr - this.montantLocation * this.nbr * (this.remise / 100);
      tvaG = this.montantLocation * (parseInt(this.tvaCont) / 100);
      if (this.optionContrat.length != 0) {
        this.optionContrat.forEach(function (item) {
          var t = 0;
          var c = 0;
          var tva = 0;
          c = parseInt(item.cout) * parseInt(item.qte);
          tva = c * (parseInt(item.tva) / 100);
          t = c + tva;
          item.total = t;
          total += t;
          tvaG += tva;
          ht += c;
        });
      }

      total += Math.round(montantLocation);
      ht += Math.round(montantLocation);

      this.tva = new Intl.NumberFormat("fr-Fr").format(tvaG);
      this.totalRemise = new Intl.NumberFormat("fr-Fr").format(Math.round(this.montantLocation * this.nbr * (this.remise / 100)));
      this.totalF = Math.round(montantLocation);

      this.ht = new Intl.NumberFormat("fr-Fr").format(ht);
      this.total = new Intl.NumberFormat("fr-Fr").format(ht + tvaG);
      this.totalTtc = Math.round(ht + tvaG);
    },
    contratLigne: function contratLigne() {
      this.optionContrat.push({
        key: Date.now(),
        libelle: "",
        cout: 0,
        qte: 1,
        tva: 0,
        total: 0,
        id: ""
      });
      this.totComLigneTTC += 5;
    },
    devisLigne: function devisLigne() {
      this.devis.push({
        key: Date.now(),
        libelle: "",
        cout: 0,
        qte: 1,
        tva: 0,
        total: 0,
        id: ""
      });
      this.totComLigneTTC += 5;
    },
    suppressionDevis: function suppressionDevis(index) {
      var item = this.devis.indexOf(index);
      this.devis.splice(item, 1);
      this.calculTotalDevis();
    },
    deleteOptionContrat: function deleteOptionContrat(index) {
      var item = this.optionContrat.indexOf(index);
      this.optionContrat.splice(item, 1);
      this.calculContrat();
    },
    lienFlotte: function lienFlotte() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.$router.push({ name: "Flotte", params: {
          type: item
        } });
    },


    // lienFlotte() {
    //   this.$router.push({ name: "Flotte",params: { etat_veh:"flotte"} });
    // },

    loadParc: function loadParc() {
      var _this69 = this;

      var url = this.domaine + "parc/index/parc";
      this.$http.get(url).then(function (response) {
        if (response.body.parc) {
          var tableau = response.body.parc;
          for (var i = 0; i < tableau.length; ++i) {
            for (var j = i + 1; j < tableau.length; ++j) {
              if (tableau[i].libelle === tableau[j].libelle) {
                tableau.splice(j--, 1);
              }
            }
          }
          _this69.listParc = tableau;
        }
      });
    },
    loadTypeParc: function loadTypeParc(item) {
      var _this70 = this;

      this.loading = true;
      var url = this.domaine + "parc/parcSelect/" + item;
      this.$http.get(url).then(function (response) {
        _this70.loading = false;
        _this70.listVehicule = response.body.detailVehi;
      }, function (errRep) {
        _this70.loading = false;
        _this70.$message.error("Une erreur est survenue lors du chargement de la liste des vehicules");
      });
    },
    loadUserAdmin: function loadUserAdmin() {
      var _this71 = this;

      var url = this.domaine + "mission/liste/admin";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this71.listDemandeur = response.body.listAdmin;
        }
      });
    },
    loadGraph: function loadGraph() {
      var _this72 = this;

      var url = this.domaine + "mission/graph/vehicule";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this72.disponible = response.body.etatVehicule.disponible;
          _this72.enCours = response.body.etatVehicule.enCours;
          _this72.panne = response.body.etatVehicule.panne;
          _this72.reparation = response.body.etatVehicule.reparation;
          _this72.location = response.body.etatVehicule.location;
          _this72.statsMarque = response.body.dataAxis;
          _this72.statsMarqueData = response.body.data;
          _this72.chartsDisponibilite();
          _this72.chartsMarqueVeh();
        }
      });
    },
    chartsDisponibilite: function chartsDisponibilite() {
      var optionDisponibilite = {
        title: {
          text: "DISPONIBILITEES DES VEHICULES DU PARC AUTO",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          x: "left",
          data: ["En panne", "En cours de mission", "En cours de location", "En cours de reparation", "Disponible"]
        },
        series: [{
          type: "pie",
          radius: ["50%", "80%"],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: "center"
            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: "12",
                fontWeight: "bold"
              }
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: [{ value: this.panne, name: "En panne" }, { value: this.enCours, name: "En cours de mission" }, { value: this.location, name: "En cours de location" }, { value: this.reparation, name: "En cours de reparation" }, { value: this.disponible, name: "Disponible" }]
        }]
      };

      var chartsDisponibilite = echarts.init(document.getElementById("chartsDisponibilite"));
      chartsDisponibilite.setOption(optionDisponibilite);
    },
    chartAllBilanCarburant: function chartAllBilanCarburant() {
      var option = {
        title: {
          text: "Montant de la consommation de carburant/Mois Total = " + this.totMntCarb + " Fcfa"
        },
        tooltip: {},
        legend: {
          data: ["Sales"]
        },
        xAxis: {
          type: "category",
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [{
          data: [],
          type: "bar"
        }]
      };

      this.statConsom.forEach(function (element) {
        option.xAxis.data.push(element.date);
        option.series[0].data.push(element.montant);
      });

      var myChart = echarts.init(document.getElementById("chartAllBilanCarburant"));
      // use configuration item and data specified to show chart
      myChart.setOption(option);
    },
    chartAllBilanCarburantQut: function chartAllBilanCarburantQut() {
      var option = {
        title: {
          text: "Quantite de carburant/Mois Total=" + this.totCarb + " L"
        },
        tooltip: {},
        legend: {
          data: ["Sales"]
        },
        xAxis: {
          type: "category",
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [{
          data: [],
          type: "bar"
        }]
      };

      this.statQutConsom.forEach(function (element) {
        option.xAxis.data.push(element.date);
        option.series[0].data.push(element.quantite);
      });

      var myChart = echarts.init(document.getElementById("chartAllBilanCarburantQut"));
      // use configuration item and data specified to show chart
      myChart.setOption(option);
    },
    onFileDevPicked: function onFileDevPicked(event) {
      var _this73 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this73.imageDevis = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.fileDevis = files[0];
    },
    onFileConsomPicked: function onFileConsomPicked(event) {
      var _this74 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this74.imageConsom = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.fileConsom = files[0];
    },
    chartsMarqueVeh: function chartsMarqueVeh() {
      var dataAxis = [];
      var data = [];
      var yMax = 500;
      var dataShadow = [];
      for (var i = 0; i < data.length; i++) {
        dataShadow.push(yMax);
      }

      var optionApproEntre = {
        title: {
          text: "STATISTIQUES DU NOMBRE DE VEHICULES ACQUIS PAR AN",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        xAxis: {
          data: [],
          axisLabel: {
            inside: true,
            textStyle: {
              color: "#000"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          z: 10
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#999"
            }
          }
        },
        dataZoom: [{
          type: "inside"
        }],
        series: [{
          // For shadow
          type: "bar",
          itemStyle: {
            normal: { color: "rgba(0,0,0,0.05)" }
          },
          barGap: "-100%",
          barCategoryGap: "40%",
          data: dataShadow,
          animation: false
        }, {
          type: "bar",
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: "#83bff6" }, { offset: 0.5, color: "#188df0" }, { offset: 1, color: "#188df0" }])
            },
            emphasis: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: "#2378f7" }, { offset: 0.7, color: "#2378f7" }, { offset: 1, color: "#83bff6" }])
            }
          },
          data: []
        }]
      };
      var zoomSize = 23;

      this.statsMarque.forEach(function (element) {
        optionApproEntre.xAxis.data.push(element);
      });

      this.statsMarqueData.forEach(function (element) {
        optionApproEntre.series[1].data.push(element);
      });

      var chartsMarqueVeh = echarts.init(document.getElementById("chartsMarqueVeh"));
      chartsMarqueVeh.setOption(optionApproEntre);
    },

    //impression de limage du recu consommation carburant
    imprimerRecu: function imprimerRecu(urlImageRecu) {
      window.open(urlImageRecu);
    },


    //impression de liste consommation carburant

    imprimeListeConsPDF: function imprimeListeConsPDF() {
      var tab = [];
      this.listConsommation.forEach(function (consommation) {
        tab.push(consommation.id);
      });

      var url = this.domaine + "consommation/imprimerPDF/liste/" + tab;
      window.open(url);
    },
    functionTime: function functionTime(dateR) {
      var date = "";
      var splittedDate = dateR.split("-");

      //on verifie si la date est au format Y-m-d
      if (splittedDate[2].length == 4) {
        date = [splittedDate[2], splittedDate[1], splittedDate[0]].join("-");
        var dateObject = new Date(date);
      } else {
        var dateObject = new Date(dateR);
      }
      return dateObject;
    },
    filtrePeriode: function filtrePeriode() {
      if (this.periode == null) {
        this.listConsommation = this.listOldConsommation;
        return;
      }
      //this.listConsommation.splice(0)

      var dateDbt = new Date(this.periode[0]);
      var dateFin = new Date(this.periode[1]);
      this.listConsommation = this.listOldConsommation.filter(function (item) {
        var dateAchat = new Date(item.dateAchatNonFormat);
        if (dateAchat >= dateDbt && dateAchat <= dateFin) {
          return item;
        }
      });
    }
  },
  computed: {},
  mounted: function mounted() {
    this.loadPage();
    this.loadAssu();
    this.loadBesoinVehAvalider();
    this.loadParc();
    this.loadGraph();
    this.loadVehicule();
    this.loadCarte();
    this.loadMarque();
    this.loadForfait();
    this.loadDevis();
    this.loadVisite();
    this.loadVign();
    this.loadPrestaire();
    this.loadConsommation();
    this.loadCompagnie();
    this.loadClientLocation();
    this.loadConducteurDispo();
    this.loadConducteur();
    this.loadContrat();
    this.loadIntervention();
    this.loadCaisse();
    this.loadVehiculeDispo();
    this.loadCout();
    this.loadClient();
    this.chartsDisponibilite();
    this.loadDemandeCarburan();
  }
});

/***/ }),

/***/ "+CPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_resource_vue__ = __webpack_require__("7Cad");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d00db3c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_resource_vue__ = __webpack_require__("24ue");
function injectStyle (ssrContext) {
  __webpack_require__("btWr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_resource_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d00db3c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_resource_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+E58":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompteExploitation_vue__ = __webpack_require__("8O0v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3e76302_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompteExploitation_vue__ = __webpack_require__("tyEA");
function injectStyle (ssrContext) {
  __webpack_require__("hq/E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompteExploitation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3e76302_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompteExploitation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+Ebi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_besoin_ModalCommandeDetails__ = __webpack_require__("Dbyj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_besoin_ModalCommandeMAJ__ = __webpack_require__("OXnm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_comparateur_ModalComparateurCmd__ = __webpack_require__("9W7p");




var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3__components_Loading__["a" /* default */],
    ModalCommandeDetails: __WEBPACK_IMPORTED_MODULE_4__components_besoin_ModalCommandeDetails__["a" /* default */],
    ModalCommandeMAJ: __WEBPACK_IMPORTED_MODULE_5__components_besoin_ModalCommandeMAJ__["a" /* default */],
    ModalComparateurCmd: __WEBPACK_IMPORTED_MODULE_6__components_comparateur_ModalComparateurCmd__["a" /* default */]
  },
  name: "Besoin",
  data: function data() {
    var _ref;

    return _ref = {
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      valid: true,
      factNull: false,
      choix: true,
      racourcis: [{ path: "/", text: "Accueil", disabled: false }, { path: "/projet", text: "Liste des besoins", disabled: true }],
      detail: [{
        value: "Pour Cotisation",
        label: "Pour Cotisation"
      }, {
        value: "Pour achat",
        label: "Pour achat"
      }, {
        value: "Pour Immobilisation",
        label: "Pour Immobilisation"
      }],
      priorites: [{
        value: 1,
        label: "Faible"
      }, {
        value: 2,
        label: "Normal"
      }, {
        value: 3,
        label: "Urgent"
      }],
      EtatConfirmation: [{
        value: 0,
        label: "Approuvé"
      }, {
        value: 1,
        label: "En attente"
      }],
      hiddenButton: false,
      searchQuery: "",
      results: [],
      isLoading: false,
      allowInput: true,
      selected: null,
      notification: 0,
      notifCommande: 0,
      showModalDetailCom: false,
      selectEtatPrioriteBesoin: null,
      selectEtatConfirmationBesoin: null,
      oldComboUser: [],
      selectEtatService: null,
      comboService: [],
      idBesoin: "",
      idCommande: "",
      dialogSupr: false,
      dialogImprCommande: false,
      dialogCOmmande: false,
      disabledBtnValide: true,
      dialogBesoin: false,
      dialogComm: false,
      dialogEdit: false,
      listBesoin: [],
      dialogShowEditRessource: false,
      tacheSelectioner: [],
      commCourant: [],
      formEditRessource: {
        id: '',
        libelle: '',
        option: [],
        qte: 0,
        dateF: '',
        dateD: ''
      },
      etat: 0,
      nombreSelection: 0,
      nombreBonSelection: 0,
      optionBesoin: [{ type: "", key: 1, value: "", qte: 1, unite: "", id: "", priorite: 1, mode: 1 }],
      optionProduit: [{ type: "", key: 1, produit: "", qte: 1, unite: "", priorite: "", mode: "" }],
      listProd: [],
      libelle: "",
      dateLivr: "",
      mode: 1,
      priorite: 1,
      besoinCourant: [],
      listeProduitAffich: []
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "searchQuery", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selected", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listeVehicule", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "infOrenseigner", [{
      libelle: '',
      dateLivr: '',
      mode: '',
      priorite: ''
    }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "optionCommande", [{
      key: 1,
      produit: "",
      codeGestion: "",
      codeAnalytique: "",
      prix: 0,
      qte: 1,
      tva: 0,
      total: 0,
      id: "",
      priorite: 1,
      mode: ''
    }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "totalComTTC", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "totComLigneTTCFormat", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "totalComHT", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "totalComTVA", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "totComLigneTTC", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listFour", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "formInventaire", {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tableInventaire", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectFourn", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listCommande", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "detailCommande", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "oldListBesoin", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "produitUnite", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listBesoinAttente", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tab", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listBonCommande", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "oldListBonCommande", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "notifBonCommande", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "oldListBonCommande", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectEtatDemandeur", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectEtatDate", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "comboUser", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dateCreated", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "typeProduit", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "oldListCommande", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectEtatPrioriteCommande", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectEtatDateCommande", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "activDerouler", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "disabledImprime", true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showModalModifCom", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listTypeRessource", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listeProjet", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listeChantier", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listeTravaux", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listeTacheTrx", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "temp", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "projetS", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "itituleBci", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectBci", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "numeroDevis", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "chantierS", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "travauxS", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tacheS", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "valeurUniteMateriel", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "valeurCodeAnalytique", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "valeurCodeGestion", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "valeurTypeUniteMateriel", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "commandeDeriv", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "commandeDerivDeux", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showModalCompCmd", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dialogDetailCmd", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "mntTotalCmd", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "nbCommandeSug", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "nbCommandeSugDeux", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "typeDmd", "Projet"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listDemande", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectDemande", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "disabledChamp", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "logoDefaut", '/static/img-doc.png'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "logoPdf", '/static/pdf.png'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "imagePdf", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dateLivrSouh", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tranconA", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tranconB", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "idTravaux", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "projetLib", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "chantieretLib", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "entrepotLib", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "entrepotId", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "travuxLib", ""), _ref;
  },


  methods: (_methods = {
    select: function select() {
      // traitement à effectuer lorsqu'un élément est sélectionné
    },
    deleteBesoin: function deleteBesoin(item) {
      var _this = this;

      this.loading = true;
      var formData = new FormData();
      formData.append("userConnect", this.user.id);
      var url = this.domaine + "optionbesoin/delete/" + this.idBesoin.id + "/demande";
      this.$http.post(url, formData).then(function (response) {
        _this.loading = false;
        _this.$message({
          type: "success",
          duration: 5000,
          message: response.body.message
        });
        _this.dialogSupr = false;

        _this.loadRecentBesoin();
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors de la suppression ");
      });
    },

    //recherche le prix fournisseur pour les produits selection
    handleChangeFour: function handleChangeFour(idFour) {
      var _this2 = this;

      var url = this.domaine + "fournisseur/info/produit";
      this.loading = true;
      var data = new FormData();

      var produits = new Array();
      var i = void 0;
      for (i = 0; i < this.optionCommande.length; i++) {
        produits[i] = this.optionCommande[i].idProd;
      }

      data.append("produits", produits);
      data.append("fournisseur", idFour);

      this.$http.post(url, data).then(function (response) {
        var produits = response.body.produits;
        _this2.loading = false;
        _this2.optionCommande.forEach(function (item, index, array, $this) {
          var $idProd = item.idProd;
          var produitFind = produits.find(function (prod) {
            return prod.id == $idProd;
          });

          array[index].prix = produitFind.prix;
        });
      }, function (error) {
        _this2.loading = false;
      });
    },


    //afficher le formulaire d'une commande
    showFormCommande: function showFormCommande() {
      //on determine le nombre de produit corespondant
      var comp = 0;
      var temp = [];
      this.factNull = false;
      this.optionCommande.splice(0);
      for (var index = 0; index < this.multipleSelection.length; index++) {
        var element1 = this.multipleSelection[0]["travauxId"];
        // let element2 = this.multipleSelection[0]["idProd"];
        var magasin1 = this.multipleSelection[0]["entrepotId"];
        var element = this.multipleSelection[index]["travauxId"];
        var element2 = this.multipleSelection[index]["entrepotId"];

        if (element1 != '') {
          if (element1 == element) {
            comp++;
          } else {
            this.factNull = true;
            // this.$refs.multipleTable.toggleRowSelection(
            //   this.multipleSelection[index]
            // );
          }
        } else {
          if (magasin1 == element2) {
            comp++;
          } else {
            this.factNull = true;
            this.$refs.multipleTable.toggleRowSelection(this.multipleSelection[index]);
          }
        }
      }
      if (this.multipleSelection.length == comp && this.factNull === false) {
        var multipleSelection1 = this.multipleSelection;

        var tableau = multipleSelection1;
        for (var i = 0; i < tableau.length; ++i) {
          for (var j = i + 1; j < tableau.length; ++j) {
            if (tableau[i].idProd === tableau[j].idProd) {
              tableau[i].qte = tableau[i].qte + tableau[j].qte;
              tableau.splice(j--, 1);
            }
          }
        }
        console.log('tableau', tableau);
        this.optionCommande = tableau;
        // this.dateLivr = th/
        this.idTravaux = this.multipleSelection[0]['idTravaux'];
        this.projetLib = this.multipleSelection[0]["projet"];
        this.dateLivr = this.multipleSelection[0]["dateLivr"];
        this.chantieretLib = this.multipleSelection[0]["chantier"];
        this.entrepotLib = this.multipleSelection[0]["libEntrepot"];
        this.travuxLib = this.multipleSelection[0]["travaux"];
        this.libelle = this.multipleSelection[0]["libelle"] ? this.multipleSelection[0]["libelle"] : '';
        this.hiddenButton = this.libelle != '' ? true : false;
        this.selectFourn = '';
        this.numeroDevis = '';
        console.log('this.optionCommande', this.optionCommande);

        this.dialogComm = true;
        this.disabledChamp = false;
      } else {
        this.$notify({
          title: "Fusion",
          message: "Impossible de lier ces besoins pour la commande. Veuillez selectionner des besoins émit pour les mêmes Travaux / pour les mêmes entrepots",
          type: "error",
          position: "top-center"
        });
      }
    },
    showForGenererCommande: function showForGenererCommande() {
      //on determine le nombre de produit corespondant
      var comp = 0;
      var temp = [];
      this.factNull = false;
      this.optionCommande.splice(0);
      for (var index = 0; index < this.multipleSelection.length; index++) {
        var element1 = this.multipleSelection[0]["travauxId"];
        // let element2 = this.multipleSelection[0]["idProd"];
        var magasin1 = this.multipleSelection[0]["entrepotId"];
        var element = this.multipleSelection[index]["travauxId"];
        var element2 = this.multipleSelection[index]["entrepotId"];

        if (element1 != '') {
          if (element1 == element) {
            comp++;
          } else {
            this.factNull = true;
            // this.$refs.multipleTable.toggleRowSelection(
            //   this.multipleSelection[index]
            // );
          }
        } else {
          if (magasin1 == element2) {
            comp++;
          } else {
            this.factNull = true;
            this.$refs.multipleTable.toggleRowSelection(this.multipleSelection[index]);
          }
        }
      }

      if (this.multipleSelection.length == comp && this.factNull === false) {
        var multipleSelection1 = this.multipleSelection;

        var tableau = multipleSelection1;
        for (var i = 0; i < tableau.length; ++i) {
          for (var j = i + 1; j < tableau.length; ++j) {
            if (tableau[i].idProd === tableau[j].idProd) {
              tableau[i].qte = tableau[i].qte + tableau[j].qte;
              tableau.splice(j--, 1);
            }
          }
        }
        this.optionCommande = tableau;
        // this.dateLivr = th/
        this.idTravaux = this.multipleSelection[0]['idTravaux'];
        this.projetLib = this.multipleSelection[0]["projet"];
        this.dateLivr = this.multipleSelection[0]["dateLivr"];
        this.chantieretLib = this.multipleSelection[0]["chantier"];
        this.entrepotLib = this.multipleSelection[0]["libEntrepot"];
        this.travuxLib = this.multipleSelection[0]["travaux"];
        this.libelle = this.multipleSelection[0]["libelle"] ? this.multipleSelection[0]["libelle"] : '';
        this.hiddenButton = this.libelle != '' ? true : false;
        this.numeroDevis = '';
        this.selectFourn = '';
        this.dialogComm = true;
        this.disabledChamp = false;
      } else {
        this.$notify({
          title: "Fusion",
          message: "Impossible de lier ces bon de commande interne. Veuillez selectionner des besoins émit pour les mêmes Travaux  ou le memem mode",
          type: "error",
          position: "top-center"
        });
      }
    },


    //afficher le formulaire de generation de commande
    showBunttonGenerer: function showBunttonGenerer() {
      var _this3 = this;

      this.hiddenButton = true;
      //  recuperation des produits concerne
      this.optionCommande.splice(0);
      this.multipleSelection.forEach(function (optionbesoin) {
        _this3.optionCommande.push(optionbesoin);
      }, this);
      this.idTravaux = this.multipleSelection[0]['idTravaux'];
      this.projetLib = this.multipleSelection[0]["projet"];
      this.chantieretLib = this.multipleSelection[0]["chantier"];
      this.travuxLib = this.multipleSelection[0]["travaux"];
      this.dateLivr = this.multipleSelection[0]["dateLivrSouh"];
      this.entrepotLib = this.multipleSelection[0]["libEntrepot"];
      this.tranconA = this.multipleSelection[0]["tranconA"];
      this.tranconB = this.multipleSelection[0]["tranconB"];
      this.libelle = '';
      this.selectFourn = '';
      this.numeroDevis = '';
      this.dialogComm = true;
      this.disabledChamp = false;
    },


    //afficher le formulaire d'une commande
    showFormCommandNew: function showFormCommandNew(row, etat) {
      var _this4 = this;

      console.log('row', row);
      console.log('this.optionCommande', this.optionCommande);
      //  recuperation des produits concerne
      if (row) {
        // this.optionCommande.splice(0);
        this.optionCommande = row['option'];
        this.idTravaux = row['travauxId'];
        this.projetLib = row["projet"];
        this.chantieretLib = row["chantier"];
        this.travuxLib = row["travaux"];
        this.dateLivr = row["dateLivr"];
        this.priorite = row["priorite"];
        this.entrepotLib = row["libEntrepot"];
        this.entrepotId = row["entrepotId"];
        this.libelle = row["libelle"] ? row["libelle"] : '';
        this.tranconA = row["tranconA"];
        this.tranconB = row["tranconB"];
        console.log('jje', this.libelle.length);
        this.hiddenButton = false;
      } else {
        this.hiddenButton = true;
        // this.optionCommande.splice(0);
        this.multipleSelection.forEach(function (optionbesoin) {
          _this4.optionCommande.push(optionbesoin);
        }, this);
        this.idTravaux = this.multipleSelection[0]['idTravaux'];
        this.projetLib = this.multipleSelection[0]["projet"];
        this.chantieretLib = this.multipleSelection[0]["chantier"];
        this.travuxLib = this.multipleSelection[0]["travaux"];
        this.dateLivr = this.multipleSelection[0]["dateLivrSouh"];
        this.entrepotLib = this.multipleSelection[0]["libEntrepot"];
        this.tranconA = this.multipleSelection[0]["tranconA"];
        this.tranconB = this.multipleSelection[0]["tranconB"];
      }
      // this.hiddenButton =  false     

      console.log('row', row);
      console.log('hdhd', this.hiddenButton);
      console.log('this.optionCommande', this.optionCommande);
      this.selectFourn = '';
      this.numeroDevis = '';
      this.selectBci = row.id;
      this.dialogComm = true;
      this.disabledChamp = false;
      this.loadFourn();
    },


    //Action methodes
    showCommande: function showCommande(ligneCommande, etat) {
      this.hiddenButton = etat;
      this.disabledChamp = true;
      this.showModalDetailCom = true;
      this.detailCommande = ligneCommande;
      console.log('hiddenButton', this.hiddenButton);
      console.log('etat', etat);
      console.log('ligneCommande', ligneCommande);
    },
    editCommande: function editCommande(ligneCommande) {
      this.showModalModifCom = true;
      this.detailCommande = ligneCommande;
    },
    deleteCommande: function deleteCommande() {
      var _this5 = this;

      this.loading = true;
      var url = this.domaine + "besoin/delete/comd/" + this.idCommande.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this5.$notify({
            title: "SUPPRESSION",
            message: "Commande supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          _this5.dialogCOmmande = false;
          _this5.dialogSupr = false;
          _this5.loading = false;
          _this5.loadCommandeRecent();
          _this5.loadRecentBesoin();
        } else {
          _this5.$message.error("Impossible de supprimer");
          _this5.loading = false;
        }
      }, function (error) {
        _this5.$message.error("Impossible de supprimer");
        _this5.loading = false;
      });
    },

    //Controlle de l'activation du boutton deroulez
    activationDerouler: function activationDerouler() {
      this.activDerouler ? this.activDerouler = false : this.activDerouler = true;
      //enregistrement des besoins ayant été vue par l'utilisateur
      if (this.activDerouler && this.listBesoin.length > 0) this.enregistrementBesoinVue();
    },
    enregistrementBesoinVue: function enregistrementBesoinVue() {
      var url = this.domaine + "besoin/save/checked/" + this.user.id + "/show";
      this.$http.get(url);
    },


    //filtre commande
    clearSelectCommande: function clearSelectCommande() {
      this.listCommande = this.oldListCommande;
    },
    filtrerEtatDateCommande: function filtrerEtatDateCommande(date) {
      this.selectEtatPrioriteCommande = null;

      this.listCommande = this.oldListCommande;
      this.listCommande = this.listCommande.filter(function (commande) {
        if (commande.dateJour >= date[0] && commande.dateJour <= date[1]) return commande.dateJour;else if (commande.dateJour == date[0] && commande.dateJour == date[1]) return commande.dateJour;
      });
    },
    filtrerEtatPrioriteCommande: function filtrerEtatPrioriteCommande(priorite) {
      //reinitialisation de la liste commande
      this.listCommande = this.oldListCommande;
      this.selectEtatDateCommande = null;

      //filtre de la liste de commande
      this.listCommande = this.listCommande.filter(function (commande) {
        return commande.priorite == priorite;
      });
    },
    loadDemande: function loadDemande() {
      var _this6 = this;

      this.loading = true;
      this.listDemande = [];
      var url = this.domaine + "entrepot/liste";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this6.listDemande = response.body.demande;
          _this6.loading = false;
        }
      });
    },
    loadFourn: function loadFourn() {
      var _this7 = this;

      this.loading = true;
      var url = this.domaine + "fournisseur/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this7.listFour = response.body.fournisseur;
          _this7.loading = false;
        }
      });
    },
    loadTravaux: function loadTravaux() {
      var _this8 = this;

      this.loading = true;
      this.travauxS = "";
      this.listTravaux = [];
      if (this.chantierS != "" && this.chantierS != null) {
        var url = this.domaine + "projet/" + this.chantierS + "/index/chantier/travaux";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this8.listeTravaux = response.body.travaux;
            _this8.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un chantier");
        this.loading = false;
      }
    },
    loadTacheTrx: function loadTacheTrx() {
      var _this9 = this;

      this.loading = true;
      this.tacheS = [], this.listeTacheTrx.splice(0);
      if (this.travauxS != "" || this.travauxS !== undefined) {
        var url = this.domaine + "tache/travaux/" + this.travauxS;
        this.$http.get(url).then(function (response) {
          _this9.listeTacheTrx = response.body.taches;
          _this9.loading = false;
        });
      } else {
        this.$message.error("Veuillez sélectionner une tache");
        this.loading = false;
      }
    },


    //filtre
    loadDemandeur: function loadDemandeur(userId) {
      this.selectEtatDate = null;
      this.listBesoin = this.oldListBesoin;
      this.listBesoin = this.listBesoin.filter(function (item) {
        return item.userId == userId;
      });
    },
    loadDate: function loadDate(date) {
      this.listBesoin = this.oldListBesoin;
      this.selectEtatDemandeur = null;
      if (date) {
        this.listBesoin = this.listBesoin.filter(function (item) {
          if (item.dateJour >= date[0] && item.dateJour <= date[1]) return item.dateJour;else if (item.dateJour == date[0] || item.dateJour == date[1]) return item.dateJour;
        });
      }
    },
    loadServiceBesoin: function loadServiceBesoin(service) {
      var _this10 = this;

      this.listBesoin = this.oldListBesoin;
      this.selectEtatDate = null;
      this.listBesoin = this.listBesoin.filter(function (besoin) {
        _this10.comboUser = _this10.oldComboUser;
        _this10.comboUser = _this10.comboUser.filter(function (user) {
          return user.serviceId == service;
        });
        return besoin.serviceId == service;
      });
    },
    filtrerEtatPrioriteBesoin: function filtrerEtatPrioriteBesoin(priorite) {
      //reinitialisation de la liste commande
      this.listBesoin = this.oldListBesoin;
      this.selectEtatDate = null;
      this.selectEtatService = null;
      this.selectEtatDemandeur = null;

      //filtre de la liste de commande
      this.listBesoin = this.listBesoin.filter(function (besoin) {
        return besoin.priorite == priorite;
      });
    },
    filtrerEtatConfirmationBesoin: function filtrerEtatConfirmationBesoin(etat) {
      //reinitialisation de la liste commande
      this.listBesoin = this.oldListBesoin;
      this.selectEtatDate = null;
      this.selectEtatService = null;
      this.selectEtatDemandeur = null;

      // filtre de la liste de commande
      this.listBesoin = this.listBesoin.filter(function (besoin) {
        return besoin.etat == etat;
      });
    },
    filtrerEtatService: function filtrerEtatService(service) {
      this.loadServiceBesoin(service);
    },
    filtrerEtatDemandeur: function filtrerEtatDemandeur(userId) {
      this.loadDemandeur(userId);
    },
    filtrerEtatDate: function filtrerEtatDate(date) {
      if (this.selectEtatDate != null) this.loadDate(date);else this.listBesoin = this.oldListBesoin;
    },
    filtrerEntrepot: function filtrerEntrepot(idEnt) {
      this.loadDmdParEntrp(idEnt);
    },
    filtrerCmdEntrepot: function filtrerCmdEntrepot(idEnt) {
      this.loadCmdParEntrp(idEnt);
    },
    filtrerTravaux: function filtrerTravaux(idTrx) {
      this.loadDmdParTrx(idTrx);
    },
    filtrerCommandeTravaux: function filtrerCommandeTravaux(idTrx) {
      this.loadCmdParTrx(idTrx);
    },
    filtreByChantier: function filtreByChantier(idChantier) {
      this.listBesoin = this.oldListBesoin;
      if (idChantier == '' || idChantier == null) {
        this.listBesoin = this.oldListBesoin;
      }
      this.listBesoin = this.listBesoin.filter(function (item) {
        return item.chantierId == idChantier;
      });
    },
    filtreByProjet: function filtreByProjet(idProjet) {
      this.listBesoin = this.oldListBesoin;
      if (idProjet == '' || idProjet == null) {
        this.listBesoin = this.oldListBesoin;
      }
      this.listBesoin = this.listBesoin.filter(function (item) {
        return item.projetId == idProjet;
      });
    },
    loadCmdParTrx: function loadCmdParTrx(idTrx) {
      this.listCommande = this.oldListCommande;
      this.listCommande = this.listCommande.filter(function (item) {
        return item.travauxId == idTrx;
      });
    },
    loadDmdParTrx: function loadDmdParTrx(idTrx) {
      this.listBesoin = this.oldListBesoin;
      //this.selectEtatDmd = null;
      this.listBesoin = this.listBesoin.filter(function (item) {
        return item.travauxId == idTrx;
      });
    },
    loadDmdParEntrp: function loadDmdParEntrp(idEnt) {
      this.listBesoin = this.oldListBesoin;
      //this.selectEtatDmd = null;
      this.listBesoin = this.listBesoin.filter(function (item) {
        return item.entrepotId == idEnt;
      });
    },
    loadCmdParEntrp: function loadCmdParEntrp(idEnt) {
      this.listCommande = this.oldListCommande;
      this.listCommande = this.listCommande.filter(function (item) {
        return item.entrepotId == idEnt;
      });
    },
    verifFormInfo: function verifFormInfo(optionP) {
      if (optionP.unite != null) {
        return true;
      } else {
        return false;
      }
    },
    clearSelect: function clearSelect() {
      this.listBesoin = this.oldListBesoin;
      this.comboUser = this.oldComboUser;
    },
    editRessources: function editRessources(ligne) {
      this.dialogShowEditRessource = true;
      this.tacheSelectioner = ligne;
      console.log('tacheSelectioner', ligne);
      this.formEditRessource.libelle = ligne.produit;
      this.formEditRessource.qte = ligne.qte;
      this.formEditRessource.dateD = ligne.dateDUtilisation;
      this.formEditRessource.dateF = ligne.dateFUtilisation;
      this.optionBesoin = ligne.option;
    },
    resetFormEditRess: function resetFormEditRess() {
      this.formEditRessource = {};
      this.dialogShowEditRessource = false;
    },
    sumbitRessource: function sumbitRessource(ligne) {
      var _this11 = this;

      this.loading = true;
      var form = document.getElementById("formEditRessource");
      var data = new FormData(form);
      var url = "";
      console.log('optionBesoin', this.optionBesoin);
      for (var prop in this.optionBesoin) {
        ligne = this.optionBesoin[prop];
        data.append("options[optionCom][]", ligne.id);
        data.append("options[qte][]", ligne.qte);
        data.append("options[codeAnalytique][]", ligne.codeAnalytique);
        data.append("options[codeGestion][]", ligne.codeGestion);
      }
      // data.append("idOptBesoin",ligne.id)   
      url = this.domaine + "besoin/edit/demande";
      this.$http.post(url, data).then(function (response) {
        _this11.loading = false;
        if (response.body) {
          var verif = response.body;
          _this11.loading = false;
          if (verif.code === 1) {
            _this11.$notify({
              title: "MODIFICATION REUSSI",
              message: response.body.message,
              type: "success",
              position: "top-center"
            });
            _this11.loading = false;
            _this11.dialogSuprRessource = false;
            _this11.dialogShowEditRessource = false;
            _this11.dialogShowTravaux = false;
            _this11.formEditRessource.dateD = '';
            _this11.formEditRessource.dateD = '';
            _this11.loadRecentBesoin();
          }
        }
      }, function (error) {
        _this11.loading = false;
        _this11.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
        // this.loading = false;
      });
    },


    //filtre
    loadUser: function loadUser() {
      var _this12 = this;

      this.loading = true;
      var url = this.domaine + "besoin/liste/utilisateur";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this12.comboUser = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.body.user);
          _this12.oldComboUser = _this12.comboUser;
          _this12.loading = false;
        }
      });
    },
    loadTypeRessource: function loadTypeRessource() {
      var _this13 = this;

      var url = this.domaine + "product/typeRessource";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this13.listTypeRessource = response.body.types;
          _this13.loading = false;
        }
      });
    },
    loadService: function loadService() {
      var _this14 = this;

      this.loading = true;
      var url = this.domaine + "besoin/liste/service";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this14.comboService = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.body.service);
          _this14.loading = false;
        }
      });
    },
    imprimerCommande: function imprimerCommande(ligne) {
      this.dialogImprCommande = true;
      this.commCourant = ligne;
    },
    imprimerModeCommande: function imprimerModeCommande(mode) {
      var url = this.domaine + 'besoin/' + this.commCourant.idBonCom + '/imprimer/commande/' + this.user.id + '/' + mode;
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      this.dialogImprCommande = false;
      window.open(url);
    },

    //Imprimer la liste des besoins
    imprimeListeBesoin: function imprimeListeBesoin(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "besoin/imprimerPDF/liste";
      } else {
        url = this.domaine + "besoin/imprimerEXC/liste";
      }

      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    deleteRow: function deleteRow(index, rows) {
      rows.splice(index, 1);
    },

    //Suppression
    deleteNeed: function deleteNeed() {
      var _this15 = this;

      var besoinId = this.recupIdSelection();

      this.$confirm("Voulez-vous supprimer cette selection?", "Attention", {
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
        type: "warning"
      }).then(function () {
        _this15.$message({
          type: "success",
          message: "Suppression en cours!"
        });
        _this15.loading = true;
        var besoinTabId = [];
        var i = 0;

        //envoie du tableau obtenu
        var url = _this15.domaine + "besoin/delete/selection/" + besoinId;
        _this15.$http.get(url).then(function (response) {
          if (response.ok) {
            _this15.loading = false;
            _this15.$notify({
              title: "SUPPRESSION REUSSIE",
              message: "La selection a été supprimée avec succès.",
              type: "success",
              position: "top-center"
            });
            _this15.loadRecentBesoin();
          }
        });
      }).catch(function () {
        _this15.$message({
          type: "info",
          message: "Suppression annulée"
        });
      });
    },
    recupIdSelection: function recupIdSelection() {
      var besoinTabId = [];
      //recuperation des id de besoin
      this.multipleSelection.forEach(function (besoin) {
        besoinTabId.push(besoin.id);
      });
      return besoinTabId;
    },
    loadPage: function loadPage() {
      this.loading = true;
    },
    loadBesoin: function loadBesoin() {
      var _this16 = this;

      this.loading = true;
      var url = "";
      if (this.droitAcces.besoin) {
        url = this.domaine + "besoin/index";
      } else {
        url = this.domaine + "besoin/index/" + this.user.id + "/user";
      }

      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this16.listBesoin = response.body.besoin;
          _this16.listBesoinAttente = response.body.besoinAttente;
          _this16.oldListBesoin = response.body.besoin;
          if (_this16.oldListBesoin) _this16.disabledImprime = false;else _this16.disabledImprime = true;
          _this16.loading = false;
        }
      });
      this.loadUser();
      this.loadDate();
      this.loadService();
    },
    loadProduit: function loadProduit(queryString, cb) {
      var _this17 = this;

      var url = this.domaine + "product/product-list";
      var formdata = new FormData();
      formdata.append("user", this.user.id);
      formdata.append("tag", queryString);
      this.$http.post(url, formdata).then(function (response) {
        if (response.body) {
          _this17.listProd = response.body;
          var links = response.body;
          var results = queryString ? links.filter(_this17.createFilter(queryString)) : links;
          cb(results);
        }
      }, function (response) {});
    },
    loadRecentBesoin: function loadRecentBesoin() {
      var _this18 = this;

      this.loading = true;
      var url = "";
      if (this.droitAcces.besoin) {
        url = this.domaine + "besoin/index_recent";
      } else {
        url = this.domaine + "besoin/index/" + this.user.id + "/user/recent";
      }

      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this18.listBesoin = response.body.besoin ? response.body.besoin : [];
          _this18.notification = _this18.listBesoin.length;
          _this18.listBesoinAttente = response.body.besoinAttente;
          _this18.oldListBesoin = response.body.besoin;
          if (_this18.oldListBesoin) _this18.disabledImprime = false;else _this18.disabledImprime = true;
          _this18.loading = false;
        }
      });
      this.loadUser();
      this.loadDate();
      this.loadService();
    },
    loadCommande: function loadCommande() {
      var _this19 = this;

      this.loading = true;
      var url = "";
      if (this.droitAcces.index_besoin_commande) {
        url = this.domaine + "besoin/index/commande";
      } else {
        url = this.domaine + "besoin/index/commande/" + this.user.id + "/user";
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this19.listCommande = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.body.commande);
          _this19.oldListCommande = _this19.listCommande;
          _this19.loading = false;
        }
      });
    },
    loadBonCommande: function loadBonCommande() {
      var _this20 = this;

      this.loading = true;
      var url = this.domaine + "besoin/index/boncommande/1/recent";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this20.listBonCommande = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.body.commande);
          _this20.oldListBonCommande = _this20.listBonCommande;
          _this20.notifBonCommande = _this20.listBonCommande.length;
          _this20.loading = false;
        }
      });
    },
    loadCommandeRecent: function loadCommandeRecent() {
      var _this21 = this;

      this.loading = true;
      var url = "";
      if (this.droitAcces.index_besoin_commande) {
        url = this.domaine + "besoin/index/commande/recent";
      } else {
        url = this.domaine + "besoin/index/commande/recent/" + this.user.id + "/user";
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this21.listCommande = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.body.commande);

          _this21.oldListCommande = _this21.listCommande;
          _this21.notifCommande = _this21.listCommande.length;
          _this21.loading = false;
        }
      });
    },
    newBesoin: function newBesoin() {
      this.dialogBesoin = true;
      // this.loadTypeProduit()
      this.loadProduit();
      this.loadVehicule();
      this.dialogEdit = false;
      this.optionProduit = [{
        type: "",
        codeAnalytique: "",
        codeGestion: "",
        key: 1,
        produit: "",
        qte: 1,
        unite: "",
        id: "",
        priorite: "",
        mode: ""
      }];
      this.projetS = '';
      this.itituleBci = '';
      this.chantierS = '';
      this.travauxS = '';
      this.tacheS = [], this.dateLivrSouh = '';
      this.logoDefaut = '/static/img-doc.png', this.logoPdf = '/static/pdf.png', this.imagePdf = false, this.tranconA = '';
      this.tranconB = '';
      this.itituleBci = '';
      this.tableInventaire = [];
    },
    loadUniteVehciule: function loadUniteVehciule(item) {
      var valeur = void 0;
      valeur = this.listeVehicule.find(function (element) {
        if (element.value == item) {
          return element.unite;
        }
      });

      this.valeurUniteMateriel = valeur.unite;
      this.valeurCodeAnalytique = valeur.codeAnalytique;
      this.valeurCodeGestion = valeur.codeGestion;
    },
    handleSelect: function handleSelect(produit) {
      var index = this.optionBesoin.indexOf(produit);
      this.optionBesoin.splice(index, 3, produit);
    },
    onFileImageLogoPicked: function onFileImageLogoPicked(event) {
      var _this22 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].type == "application/pdf") {
        this.logoDefaut = this.logoPdf;
        var _fileReader = new FileReader();
        _fileReader.addEventListener("load", function () {});
        _fileReader.readAsDataURL('/static/pdf.png');
        // this.logoDefaut = files[0]
      }
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this22.logoDefaut = fileReader.result;
      });
      this.imagePdf = false;
      fileReader.readAsDataURL(files[0]);
      this.logoDefaut = files[0];
      if (files[0]['type'].split("/").pop() == 'pdf') {
        this.imagePdf = true;
      }
    },
    editBesoin: function editBesoin() {
      this.dialogBesoin = true;
      this.dialogEdit = true;
      this.optionBesoin = this.multipleSelection;
    },
    besoinSelect: function besoinSelect(row, index) {
      var etat = null;
      if (parseFloat(row.qte) != 0) {
        etat = true;
      } else {
        etat = false;
      }
      return etat;
    },
    besoinBonSelect: function besoinBonSelect(row, index) {
      var etat = null;
      if (parseFloat(row.qte) != 0) {
        etat = true;
      } else {
        etat = false;
      }
      return etat;
    },
    submitBesoin: function submitBesoin() {
      var _this23 = this;

      this.loading = true;
      if (this.$refs.formBesoin.validate()) {
        var etat = false;
        console.log('this.tableInventair', this.tableInventaire);
        if (this.tableInventaire.length > 0) {
          this.tableInventaire.forEach(function (item) {
            if (item.libelle != "" && item.qte > 0 && item.priorite != "") {
              etat = true;
            }
          });
        }

        if (etat == true) {
          var form = document.getElementById("formBesoin");
          var formdata = new FormData(form);
          var url = this.domaine + "besoin/new";
          formdata.append("idUser", this.user.id);
          for (var prop in this.tableInventaire) {
            var ligne = this.tableInventaire[prop];
            formdata.append("options[id][]", ligne.id);
            formdata.append("options[produit][]", ligne.libelle);
            formdata.append("options[qte][]", ligne.qte);
            formdata.append("options[codeAnalytique][]", ligne.codeAnalytique);
            formdata.append("options[codeGestion][]", ligne.codeGestion);
            formdata.append("options[unite][]", ligne.unite);
            formdata.append("options[priorite][]", ligne.priorite);

            formdata.append("projetId", this.projetS);
            formdata.append("itituleBci", this.itituleBci);
            formdata.append("chantierId", this.chantierS);
            formdata.append("travauxId", this.travauxS);
            formdata.append("tacheId", this.tacheS);
            formdata.append("entrepotId", this.selectDemande);
            formdata.append("typeDmd", this.typeDmd);
            formdata.append("dateLivrSouh", this.dateLivrSouh);
            formdata.append("tranconB", this.tranconB);
            formdata.append("tranconA", this.tranconA);
          }

          this.$http.post(url, formdata).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this23.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Besoin enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });

                _this23.dialogBesoin = false;
                _this23.loadRecentBesoin();
                _this23.selectDemande = '';
                _this23.dateLivrSouh = '';
                _this23.loading = false;
                _this23.$refs.formBesoin.reset();
                _this23.projetS = '';
                _this23.itituleBci = '';
                _this23.chantierS = '';
                _this23.travauxS = '';
                _this23.tacheS = [], _this23.tranconB = '';
                _this23.tranconA = '';
                formdata.append("entrepotId", _this23.selectDemande);
              }
            } else {
              _this23.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this23.loading = false;
              _this23.clear();
            }
          }, function (response) {
            _this23.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this23.loading = false;
          });
        } else {
          this.$notify({
            title: "ATTENTION",
            message: "Vous devez obligatoirement enregistré des lignes pour le besoin et que ces lignes ont été correctements remplis.",
            position: "top-center",
            type: "warning"
          });
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La besoin n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    submitComm: function submitComm() {
      var _this24 = this;

      var dateNow = new Date().toISOString().slice(0, 10);

      // on change le format de la date pour  la comparaison  de date
      var tabDateDbt = this.dateLivr.split("-"); //["16","08","2018 00:00:00"]
      var jr = tabDateDbt[0];
      var mois = tabDateDbt[1];
      var annee = tabDateDbt[2].split(" ")[0];
      var dateDbt = annee + "-" + mois + "-" + jr;
      this.loading = true;
      if (this.$refs.formComm.validate() && this.libelle != "" && this.dateLivr != "" &&
      // this.selectFourn != "" &&
      dateNow <= dateDbt) {
        var etat = false;
        if (this.optionCommande.length > 0) {
          this.optionCommande.forEach(function (item) {
            if (item.produit != "" && item.prix > 0 && item.qte > 0 && item.unite != "" && item.priorite > 0) {
              etat = true;
            }
          });
        }

        if (etat == true || this.hiddenButton == true) {
          var form = document.getElementById("formComm");
          var data = new FormData();
          var url = '';
          data.append("bci", this.selectBci);
          data.append("libelle", this.libelle);
          data.append("dateLivr", this.dateLivr);
          data.append("priorite", this.priorite);
          data.append("total", this.totalComTTC);
          data.append("mode", this.mode);
          data.append("idUser", this.user.id);
          data.append("fournisseur", this.selectFourn);
          data.append("projetId", this.projetS);
          data.append("itituleBci", this.itituleBci);
          data.append("numeroDevis", this.numeroDevis);
          data.append("chantierId", this.chantierS);
          data.append("bonGenerer", this.hiddenButton);
          data.append("travauxId", this.idTravaux ? this.idTravaux : this.multipleSelection[0]["travauxId"]);
          data.append("entrepotId", this.entrepotId ? this.multipleSelection[0]["entrepotId"] : this.entrepotId);
          //on va enregister dabor la commande
          url = this.domaine + "besoin/commande/new";

          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              url = _this24.domaine + "besoin/new/commande";
              var nbData = 10;
              var nbReq = 1;
              var ligne = null;

              var nbRest = void 0;
              if (_this24.optionCommande.length > 10) {
                nbData = 10;
                nbReq = Math.round(_this24.optionCommande.length / nbData);
                nbRest = _this24.optionCommande.length % nbData;
                if (nbRest > 0) {
                  nbReq += 1;
                }
              }

              _this24.totalComTTC = 0;
              for (var i = 0; i < nbReq; i++) {
                var initJ = i * nbData;
                var finJ = (i + 1) * nbData;
                var dataLot = [];
                if (_this24.optionCommande.length > 0) {
                  for (var j = initJ; j < finJ; j++) {
                    if (_this24.optionCommande[j] == undefined) {
                      break;
                    }
                    dataLot.push(_this24.optionCommande[j]);
                  }
                }
                var _data = new FormData();
                for (var prop in dataLot) {
                  ligne = dataLot[prop];
                  _data.append("options[id][]", ligne.id);
                  _data.append("options[produit][]", ligne.produit);
                  _data.append("options[prix][]", ligne.prix);
                  _data.append("options[qte][]", ligne.qte);
                  _data.append("options[unite][]", ligne.unite);
                  _data.append("options[tva][]", ligne.tva);
                  _data.append("options[total][]", ligne.total);
                  _this24.totalComTTC += ligne.total;
                }

                _data.append("idCommande", verif.idCommande);
                _data.append("idBonCommande", verif.idBonCommande);
                _data.append("total", _this24.totalComTTC);
                _data.append("idUser", _this24.user.id);
                _data.append("fournisseur", _this24.selectFourn);
                _data.append("projetId", _this24.projetS);
                _data.append("itituleBci", _this24.itituleBci);
                _data.append("chantierId", _this24.chantierS);
                _data.append("travauxId", _this24.idTravaux ? _this24.idTravaux : _this24.multipleSelection[0]["travauxId"]);
                _data.append("priorite", _this24.priorite);
                _data.append("dateLivr", _this24.dateLivr);

                _this24.$http.post(url, _data).then(function (response) {
                  if (response.body) {
                    var _verif = response.body;

                    if (_verif.code === 1) {
                      _this24.$notify({
                        title: "ENREGISTREMENT REUSSI",
                        message: "Commande enregistrée avec succès.",
                        type: "success",
                        position: "top-center"
                      });

                      _this24.dialogComm = false;
                      _this24.loadCommandeRecent();
                      _this24.loadRecentBesoin();
                      _this24.$refs.formComm.reset();
                    } else if (_verif.code === 2) {
                      _this24.$message.error(_verif.message);
                      _this24.loading = false;
                    } else if (_verif.code === 3) {
                      _this24.$notify({
                        title: "ENREGISTREMENT REUSSI",
                        message: "Bon de commande générer avec succès.",
                        type: "success",
                        position: "top-center"
                      });

                      _this24.dialogComm = false;
                      _this24.loadCommandeRecent();
                      _this24.loadRecentBesoin();
                      _this24.loading = false;
                    }
                    // this.loadBonCommande()
                  } else {
                    _this24.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                    _this24.loading = false;
                    _this24.clear();
                  }
                }, function (error) {
                  _this24.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                  _this24.loading = false;
                });
              }
            }
          }, function (error) {
            _this24.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this24.loading = false;
          });
        } else {
          this.$notify({
            title: "ATTENTION",
            message: "Vous devez obligatoirement enregistré des lignes pour la commande et que ces lignes ont été correctements remplis , les prix des produits doivent etre obligatoirement superieur a 0.",
            position: "top-center",
            type: "warning"
          });
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires ou verifier que la date est superieur de la date d'aujourd'hui");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La commande n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    loadUniteProduit: function loadUniteProduit(item) {
      this.valeurUniteMateriel = '';
      this.valeurTypeUniteMateriel = '';
      this.valeurCodeAnalytique = '', this.valeurCodeGestion = '', this.codegestion = item.codeGestion;
      this.valeurTypeUniteMateriel = item.type;
      this.valeurUniteMateriel = item.unite;
      this.valeurCodeAnalytique = item.codeAnalytique;
      this.valeurCodeGestion = item.codeGestion;
    },
    loadTypeProduit: function loadTypeProduit(item) {
      var _this25 = this;

      var oekke = 'cart';
      if (oekke.length > 2) {
        var url = this.domaine + "product/productSelect/produit?libelle=" + oekke;
        this.$http.get(url).then(function (response) {
          _this25.loading = false;
          _this25.listeProduitAffich = response.body.produits;
        }, function (errRep) {
          _this25.loading = false;
          _this25.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
        });
      } else {
        this.listeProduitAffich = [];
      }
    },
    loadVehicule: function loadVehicule() {
      var _this26 = this;

      this.loading = true;
      var url = this.domaine + "product/productSelect/type/" + 'VEHICULE/ENGIN';
      this.$http.get(url).then(function (response) {
        _this26.loading = false;
        _this26.listeVehicule = response.body.produits;
      }, function (errRep) {
        _this26.loading = false;
        _this26.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    calculTotalBe: function calculTotalBe() {},


    //Notifications
    showNotification: function showNotification() {
      var _this27 = this;

      var url = this.domaine + "besoin/affiche/notification/" + this.user.id;

      //recuperation des notifications
      this.$http.get(url).then(function (response) {
        if (response.body) _this27.notification = response.body.notification;
      });
    },
    verifPrioriteBonBesoin: function verifPrioriteBonBesoin() {
      var tabPrioriteProd = [];
      var prioriteFinal = 0;
      //Recuperation des priorites des besoins
      this.multipleSelection.forEach(function (produit) {
        tabPrioriteProd.push(produit.priorite);
      });

      //Verification et des niveaux de priorite
      for (var i = 0; i < tabPrioriteProd.length; i++) {
        if (tabPrioriteProd[i] === 3) {
          prioriteFinal = 3;
          break;
        } else if (tabPrioriteProd[i] === 2) {
          //Control de l'existence d'une priorité plus haute
          for (var _i = 0; _i < tabPrioriteProd.length; _i++) {
            if (tabPrioriteProd[_i] === 3) {
              prioriteFinal = 3;
              break;
            } else {
              prioriteFinal = 2;
            }
          }
          break;
        } else {
          prioriteFinal = 1;
        }
      }

      //Attributon de la valeur de la priorite
      this.priorite = prioriteFinal;
    },
    verifPrioriteBesoin: function verifPrioriteBesoin() {
      var tabPrioriteProd = [];
      var prioriteFinal = 0;

      //Recuperation des priorites des besoins
      this.multipleSelection.forEach(function (produit) {
        tabPrioriteProd.push(produit.priorite);
      });

      //Verification et des niveaux de priorite
      for (var i = 0; i < tabPrioriteProd.length; i++) {
        if (tabPrioriteProd[i] === 3) {
          prioriteFinal = 3;
          break;
        } else if (tabPrioriteProd[i] === 2) {
          //Control de l'existence d'une priorité plus haute
          for (var _i2 = 0; _i2 < tabPrioriteProd.length; _i2++) {
            if (tabPrioriteProd[_i2] === 3) {
              prioriteFinal = 3;
              break;
            } else {
              prioriteFinal = 2;
            }
          }
          break;
        } else {
          prioriteFinal = 1;
        }
      }

      //Attributon de la valeur de la priorite
      this.priorite = prioriteFinal;
    },
    addListInventaire: function addListInventaire(item) {
      console.log('item', item);
      this.tableInventaire.push({
        code: item.codeGestion ? item.codeGestion : 'non defini',
        type: this.valeurTypeUniteMateriel ? this.valeurTypeUniteMateriel : 'VEHICULE/ENGIN',
        libelle: item.produit.value,
        idProd: item.produit.id,
        id: item.produit.id,
        codeAnalytique: this.valeurCodeAnalytique ? this.valeurCodeAnalytique : item.codeAnalytique,
        codeGestion: this.valeurCodeGestion ? this.valeurCodeGestion : item.codeGestion,
        etat: item.etat,
        unite: this.typeDmd != 'Carburant' ? this.valeurUniteMateriel : 'Litre',
        qte: item.qte,
        priorite: item.priorite ? item.priorite : 'Normal',
        mode: item.mode
      });
      this.optionProduit = [{ type: "", codeAnalytique: "", codeGestion: "", produit: "", qte: 1, unite: "", priorite: "" }];
      this.formInventaire = {};
      this.valeurUniteMateriel = "";
      this.valeurCodeAnalytique = '', this.valeurCodeGestion = '', this.valeurTypeUniteMateriel = '';
    },
    removeOptionBesoin: function removeOptionBesoin(item) {
      var index = this.optionBesoin.indexOf(item);
      this.totTTC -= this.optionBesoin[index].total;
      if (index !== -1) {
        this.optionBesoin.splice(index, 1);
      }
      this.calculTotalBe();
    },
    calculTotalComm: function calculTotalComm() {
      this.totComLigneTTC = 0;
      var totalHT = 0;
      var totalTVA = 0;
      for (var prop in this.optionCommande) {
        var currentC = this.optionCommande[prop];
        totalHT += currentC.prix * currentC.qte;
        totalTVA += Math.round(currentC.prix * currentC.qte * (currentC.tva / 100));
        var tot = currentC.prix * currentC.qte + Math.round(currentC.prix * currentC.qte * (currentC.tva / 100));
        this.optionCommande[prop].total = tot;
        this.totComLigneTTC += tot;
      }
      this.totalComHT = new Intl.NumberFormat("fr-Fr").format(totalHT);
      this.totalComTVA = new Intl.NumberFormat("fr-Fr").format(totalTVA);
      this.totalComTTC = this.totComLigneTTC;
      this.totComLigneTTCFormat = new Intl.NumberFormat("fr-Fr").format(this.totComLigneTTC);
    },
    removeOptionComm: function removeOptionComm(item) {
      var index = this.optionCommande.indexOf(item);
      this.totTTC -= this.optionCommande[index].total;
      if (index !== -1) {
        this.optionCommande.splice(index, 1);
      }
      this.calculTotalComm();
    },
    querySearch: function querySearch(queryString, cb) {
      var links = this.listKeyword;
      var results = queryString ? links.filter(this.createFilter(queryString)) : links;
      // call callback function to return suggestions
      cb(results);
    },

    //////////
    createFilter: function createFilter(queryString) {
      return function (link) {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },

    //////////
    handleSelectionBonChange: function handleSelectionBonChange(val) {
      var _this28 = this;

      var factNull = false;
      //verification de l'etat
      var dataFact = val.filter(function (elt, index) {
        if (elt.etat == 1) {
          _this28.$refs.multipleTableBon.toggleRowSelection(elt);
          factNull = true;
        }
        return elt.etat == 1;
      });

      this.nombreBonSelection = val;
      this.multipleSelection = val;
      if (this.nombreBonSelection.length === 0) {
        this.disabledBtnValide = true;
        this.choix = true;
      } else {
        this.disabledBtnValide = false;
        this.choix = false;
      }

      if (factNull == true) {
        this.$message({
          message: "Attention, vous ne pouvez selectionner que les besoins deja validé",
          type: "warning",
          duration: 1000
        });
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this29 = this;

      var factNull = false;
      //verification de l'etat
      var dataFact = val.filter(function (elt, index) {
        if (elt.etat == 1) {
          _this29.$refs.multipleTable.toggleRowSelection(elt);
          factNull = true;
        }
        return elt.etat == 1;
      });

      //  this.multipleSelection = dataFact
      this.multipleSelection = val;
      this.nombreSelection = val;
      if (this.multipleSelection.length === 0) {
        this.disabledBtnValide = true;
        this.choix = true;
      } else {
        this.disabledBtnValide = false;
        this.choix = false;
      }

      if (factNull == true) {
        this.$message({
          message: "Attention, vous ne pouvez selectionner que les besoins deja validé",
          type: "warning",
          duration: 1000
        });
      }
    },

    beforeMount: function beforeMount() {
      if (!this.roleAcces[this.$router.history.current.name]) {
        this.$router.push({ name: "Home" });
      }
    },

    //Projet
    selectProjet: function selectProjet(idProjet) {
      this.loadChantier(idProjet);
    },
    loadProjet: function loadProjet() {
      var _this30 = this;

      var url = this.domaine + "projet/index/projet/all";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this30.loading = false;
        _this30.listeProjet = response.body.projet;
      }, function (errRep) {
        _this30.loading = false;
        _this30.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    loadChantier: function loadChantier() {
      var _this31 = this;

      if (this.projetS == "" || this.projetS == null) {
        return;
      }
      this.loading = true;
      this.listeChantier.splice(0);
      this.listeTacheTrx.splice(0);
      this.listeTravaux.splice(0);
      this.chantierS = "", this.travauxS = "";
      this.tacheS = [];

      var url = this.domaine + "projet/" + this.projetS + "/index/chantier";
      this.$http.get(url).then(function (response) {
        _this31.loading = false;
        _this31.listeChantier = response.body.chantier;
      }, function (errRep) {
        _this31.loading = false;
        _this31.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, "loadProduit", function loadProduit() {
    var _this32 = this;

    var url = "";
    this.loading = true;
    url = this.domaine + "product/product-list";
    this.$http.get(url).then(function (response) {
      if (response.body) {
        _this32.loading = false;
        _this32.listProduit = response.body;
        _this32.listeProduitAffich = response.body;
        _this32.itemsProduit = response.body;
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, "loadProduitFoun", function loadProduitFoun(ligne) {
    var _this33 = this;

    this.loading = true;
    this.fournCourant = ligne;
    var url = "";
    // if (this.droitAcces.index_produit_fourn) {
    url = this.domaine + "fournisseur/" + this.fournCourant.id + "/index/produit";
    // } else {
    //   url =
    //     this.domaine +
    //     "fournisseur/" +
    //     this.fournCourant.id +
    //     "/index/" +
    //     this.user.id +
    //     "/produit";
    // }

    this.$http.get(url).then(function (response) {
      if (response.body) {
        _this33.listProduit = response.body.produit;
        _this33.loading = false;
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, "closeDialogComp", function closeDialogComp() {
    this.showModalDetailCmd = false;
    //this.loadCommande()
    //this.loadBesoin()
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, "imprimerListe", function imprimerListe() {
    var _this34 = this;

    this.loading = true;
    var options = [];
    var formdata = new FormData();
    for (var prop in this.optionCommande) {
      var ligne = this.optionCommande[prop];
      options.push(ligne.id);
    }

    var url = this.domaine + "comparateur/imprimerPDF/listePrixFourn";
    formdata.append("options", options);
    formdata.append("typeOption", 2); //optionBesoin

    var req = new XMLHttpRequest();
    this.$http.post(url, formdata, { responseType: "arraybuffer" }).then(function (response) {
      var blob = new Blob([response.data], {
        type: response.headers.get("content-type")
      });

      var url = URL.createObjectURL(blob);
      _this34.loading = false;
      window.open(url);
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, "showDialogComparaison", function showDialogComparaison() {
    var _this35 = this;

    this.loading = true;
    this.dialogComm = false;
    // this.optionCommande = this.multipleSelection;
    var formdata = new FormData();
    var url = this.domaine + "comparateur/new/commande";
    var options = [];
    var listProdPrixNulle = [];
    var smsAficher = "Aucune tarification de ce produit est indiqué chez vous fournisseurs ";
    var mesProdPrixNulle = "Les produits de cette commande ne se trouvent chez aucun de vos fournisseurs ";

    for (var prop in this.optionCommande) {
      var ligne = this.optionCommande[prop];
      options.push(ligne.id);
    }
    formdata.append("options", options);
    formdata.append("typeOption", 2); //optionBesoin

    this.$http.post(url, formdata).then(function (response) {
      //affichage des messages
      var nbCmd = 0;
      var nbCmdDeux = 0;
      var listeFoun = [];
      var listeNull = [];
      var listeFounSecond = [];
      if (response.body.code == 1) {
        var nbProdNull = response.body.listeProdNull.length;
        var messages = response.body.messageProd;
        var mes = "";
        //recuperer les message
        for (var index in messages) {
          mes += "-- " + messages[index];
        }

        _this35.$confirm(mes, "Avertissement", {
          confirmButtonText: "Continuer",
          cancelButtonText: "Annuler",
          type: "warning"
        }).then(function () {
          var respFour = response.body.fournisseurs[0];
          _this35.mntTotalCmd = response.body.mntTotauxFormat;
          _this35.listeProdNull = response.body.listeProdNull;

          //let listeFoun = [];
          for (var four in respFour) {
            nbCmd++;
            var listeProduit = respFour[four];
            var infoFour = {
              fournisseur: four,
              produits: [],
              mntTotal: 0,
              mntTotalHt: 0
            };

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(listeProduit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var produit = _step.value;

                infoFour.produits.push(produit);
                infoFour.mntTotal += parseFloat(produit.mntTotal);
                infoFour.mntTotalHt += parseFloat(produit.mntTotalHt);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            listeFoun.push(infoFour);
          }

          _this35.nbCommandeSug = nbCmd;
          _this35.commandeDeriv = listeFoun;

          _this35.dialogDetailCmd = true;
          _this35.loading = false;

          //AFFICHAGE DE PRODUITS DONT LE MONTANT EST NULL
          if (response.body.listeProdNull.length > 0) {
            _this35.dialogProdNull = true;
            //this.closeProdNull();
          }
          if (listeFoun.length > 0) {
            _this35.showModalCompCmd = true;
          }
        }).catch(function () {
          _this35.loading = false;
          _this35.showModalCompCmd = false;
          _this35.$alert(smsAficher, {
            confirmButtonText: "OK"
          });
        });
      } else {
        var respFour = response.body.fournisseurs[0];
        _this35.mntTotalCmd = response.body.mntTotauxFormat;
        _this35.listeProdNull = response.body.listeProdNull;
        if (respFour.length == 0) {
          _this35.loading = false;
          _this35.$alert(mesProdPrixNulle, "", {
            confirmButtonText: "OK"
          });
          return;
        }
        _this35.loading = false;
        _this35.dialogComm = false;
        _this35.showModalCompCmd = false;
        for (var four in respFour) {
          var listeProduit = respFour[four];
          var infoFour = {
            fournisseur: four,
            produits: [],
            mntTotal: 0,
            mntTotalHt: 0

          };
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(listeProduit), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var produit = _step2.value;

              infoFour.produits.push(produit);
              infoFour.mntTotal += parseFloat(produit.mntTotal);
              infoFour.mntTotalHt += parseFloat(produit.mntTotalHt);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          if (infoFour.produits.length == options.length) {
            nbCmd++;
            listeFoun.push(infoFour);
          } else {
            nbCmdDeux++;
            listeFounSecond.push(infoFour);
          }
        }

        _this35.nbCommandeSug = nbCmd;
        _this35.commandeDeriv = listeFoun;
        _this35.nbCommandeSugDeux = nbCmdDeux;
        _this35.commandeDerivDeux = listeFounSecond;
        _this35.dialogDetailCmd = true;
        _this35.loading = false;
        //AFFICHAGE DE PRODUITS DONT LE MONTANT EST NULL
        if (response.body.listeProdNull.length > 0) {
          _this35.dialogProdNull = true;
        }

        if (listeFoun.length > 0) {
          _this35.showModalCompCmd = true;
        }
      }
      _this35.infOrenseigner = [_this35.libelle, _this35.dateLivr, _this35.priorite, _this35.projetLib, _this35.travuxLib, _this35.chantieretLib, _this35.idTravaux, _this35.entrepotLib, _this35.mode];
      _this35.dialogComm = false;
      _this35.showModalCompCmd = true;
    }, function (error) {
      _this35.loading = false;
      _this35.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
    });
  }), _methods),

  watch: {
    activDerouler: function activDerouler(newValue, oldValue) {
      if (newValue) {
        this.showNotification();
        this.loadProjet();
      }
    }
  },

  computed: {},
  mounted: function mounted() {
    this.loadPage();
    this.loadTypeRessource();
    this.loadProduit();
    this.loadCommandeRecent();
    // this.loadBonCommande()
    this.loadRecentBesoin();
    this.loadProjet();
    this.loadDemande();
  }
});

/***/ }),

/***/ "+Krb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableauTache_vue__ = __webpack_require__("RiaC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59710216_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableauTache_vue__ = __webpack_require__("8Wo+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableauTache_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59710216_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableauTache_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+cHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","persistent":"","overlay":true,"scrollable":""},model:{value:(_vm.dialogAjoutCarteRgt),callback:function ($$v) {_vm.dialogAjoutCarteRgt=$$v},expression:"dialogAjoutCarteRgt"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.editRgt == false)?_c('span',[_vm._v(" Ajouter une carte carburant ")]):_c('span',[_vm._v("Modifier une carte carburant ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formRgt",staticClass:"demo-form-inline",attrs:{"id":"formRgt","model":_vm.formRgt,"rules":_vm.rules}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticStyle:{"margin-top":"20px"}},[_c('el-radio-group',{attrs:{"size":"mini"},model:{value:(_vm.typeRgt),callback:function ($$v) {_vm.typeRgt=$$v},expression:"typeRgt"}},[_c('el-radio-button',{attrs:{"label":"Autre"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"Mission"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"Chantier"}})],1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"ml-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"date de règlement","prop":"dateRgt"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"d-MM-yyyy HH:mm","value-format":"yyyy-MM-d HH:mm","name":"dateRgt","type":"datetime","placeholder":"Date de reglement"},model:{value:(_vm.formRgt.dateRgt),callback:function ($$v) {_vm.$set(_vm.formRgt, "dateRgt", $$v)},expression:"formRgt.dateRgt"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Montant","prop":"montant"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":0,"name":"montant","placeholder":"saisir un montant"},model:{value:(_vm.formRgt.montant),callback:function ($$v) {_vm.$set(_vm.formRgt, "montant", $$v)},expression:"formRgt.montant"}})],1)],1),_vm._v(" "),(_vm.typeRgt == 'Chantier')?_c('v-flex',{staticClass:"ml-1",attrs:{"xs4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Chantier concerné"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Selectionner un chantier"},model:{value:(_vm.formRgt.chantierId),callback:function ($$v) {_vm.$set(_vm.formRgt, "chantierId", $$v)},expression:"formRgt.chantierId"}},_vm._l((_vm.comboChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.text,"value":item.id}})}),1)],1)],1):_vm._e(),_vm._v(" "),(_vm.typeRgt == 'Mission')?_c('v-flex',{staticClass:"ml-1",attrs:{"xs4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Mission concerné"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Selectionner une mission","value":_vm.formRgt.missionId},on:{"change":_vm.handleMision},model:{value:(_vm.formRgt.missionId),callback:function ($$v) {_vm.$set(_vm.formRgt, "missionId", $$v)},expression:"formRgt.missionId"}},_vm._l((_vm.comboMission),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.text,"value":item.id}})}),1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"ml-1",attrs:{"xs5":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"description"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","row":25,"name":"description","placeholder":"description"},model:{value:(_vm.formRgt.description),callback:function ($$v) {_vm.$set(_vm.formRgt, "description", $$v)},expression:"formRgt.description"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){return _vm.resetForm('formCarte')}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.editRgt == null)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitForm('formRgt')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitForm('formRgt')}}},[_vm._v("Modifier"),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+k/P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":"","mt-2":"","mb-2":"","mr-2":"","ml-2":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"cyan darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('div',[_c('div',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.coutPrevu))]),_vm._v(" "),_c('div',[_vm._v("Coût prévisionnel (Budget validé)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('div'),_vm._v(" "),_c('div',{staticClass:"display-3"})])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","mt-2":"","mb-2":"","mr-2":"","ml-2":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"green darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('div',[_c('div',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.coutActuel))]),_vm._v(" "),_c('div',[_vm._v("Coût actuel")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('div'),_vm._v(" "),_c('div',{staticClass:"display-3"})])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","mt-2":"","mb-2":"","mr-2":"","ml-2":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"light-blue darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.nbOuvrier))]),_vm._v(" "),_c('div',[_vm._v("Contrat(s) ouvrier(s)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.nbPrestataire))]),_vm._v(" "),_c('div',[_vm._v("Contrat(s) prestataire(s)")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":"","mt-2":"","mb-2":"","mr-2":"","ml-2":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"purple darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('div',[_c('div',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.tauxExec))]),_vm._v(" "),_c('div',[_vm._v("Taux exécution chronogramme (chantier terminé) (%)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('div'),_vm._v(" "),_c('div',{staticClass:"display-3"})])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xs4":"","mt-2":"","mb-2":"","mr-2":"","ml-2":""}},[_c('p',[_c('b',[_vm._v("Taux evolution projet")])]),_vm._v(" "),_c('v-progress-circular',{attrs:{"size":190,"width":30,"rotate":360,"value":_vm.projet.evolution,"color":"red"}},[_vm._v(_vm._s(_vm.projet.evolutionNbr)+" %")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","mt-2":"","mb-2":"","mr-2":"","ml-2":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"orange darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.nbChantTermine))]),_vm._v(" "),_c('div',[_vm._v("Chantier(s) Terminé(s)")])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.nbChantArret))]),_vm._v(" "),_c('div',[_vm._v("Chantier(s) Arreté(s)")])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.nbChantEnCours))]),_vm._v(" "),_c('div',[_vm._v("Chantier(s) (en cours)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('div',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.nbChant))]),_vm._v(" "),_c('div',[_vm._v("Total chantier(s)")])])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+pKE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+u7w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TarifLocation_vue__ = __webpack_require__("7bGZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c325716e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TarifLocation_vue__ = __webpack_require__("B0+m");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TarifLocation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c325716e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TarifLocation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+xXI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(_vm.userCon.type === 2)?_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])}),1)],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.droitAcces.index_demande_demandeur && _vm.userCon.type === 2)?_c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"mb-5",attrs:{"xs3":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-8",staticStyle:{"width":"100%"},attrs:{"color":"primary","text-color":"white"}},[_vm._v("\n            Demande(s)\n            "),_c('v-avatar',{staticClass:"indigo"},[_vm._v(_vm._s(_vm.totalDmd))])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-5",attrs:{"xs3":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-8",staticStyle:{"width":"100%"},attrs:{"color":"orange darken-1","text-color":"white"}},[_vm._v("\n            En cours de traitement\n            "),_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbDmdCour))])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-5",attrs:{"xs3":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-8",staticStyle:{"width":"100%"},attrs:{"color":"light-green darken-1","text-color":"white"}},[_vm._v("\n            Cloturé(s)\n            "),_c('v-avatar',{staticClass:"light-green darken-4"},[_vm._v(_vm._s(_vm.nbDmdclot))])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-5",attrs:{"xs3":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-8",staticStyle:{"width":"100%"},attrs:{"color":"red darken-1","text-color":"white"}},[_vm._v("\n            Refusé(s)\n            "),_c('v-avatar',{staticClass:"red darken-4"},[_vm._v(_vm._s(_vm.nbDmdRef))])],1)],1)],1)],1)],1):_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n      VOUS N'AVIEZ PAS ACCES A CE CONTENU. VEUILLEZ DONC CONTACTER L'ADMINISTRATEUR PRINCIPAL\n      "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("stop_screen_share")])],1)],1),_vm._v(" "),(_vm.droitAcces.add_dmd && _vm.userCon.type === 2)?_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newDemande()}},slot:"activator"},[_vm._v("Ajouter\n        "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v("Ajouter une nouvelle demande")])],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutDmd),callback:function ($$v) {_vm.dialogAjoutDmd=$$v},expression:"dialogAjoutDmd"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit !== true)?_c('span',[_vm._v("Ajouter une nouvelle demande  "),_c('h6',{staticClass:"caption"},[_vm._v(_vm._s(_vm.libzone))])]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification de la demande "+_vm._s(_vm.demandeCourant.ref)+" "),_c('h6',{staticClass:"caption"},[_vm._v(" "+_vm._s(_vm.libzone))])]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutDmd = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-form',{ref:"formDemande",attrs:{"lazy-validation":"","id":"formDemande"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                EFFECTUER UN NOUVELLE DEMANDE\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de la demande")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Type de la demande"},model:{value:(_vm.selectTypeDemande),callback:function ($$v) {_vm.selectTypeDemande=$$v},expression:"selectTypeDemande"}},_vm._l((_vm.typeDemande),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nom du demandeur")]),_vm._v(" "),_c('el-autocomplete',{staticStyle:{"width":"100%"},attrs:{"fetch-suggestions":_vm.loadDemandeur,"name":"nomPrenDmd","placeholder":"Nom du demandeur","required":""},model:{value:(_vm.nomPrenDmd),callback:function ($$v) {_vm.nomPrenDmd=$$v},expression:"nomPrenDmd"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Contact 1 du demandeur")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"tel1Dmd","placeholder":"Contact 1 du demandeur","required":""},model:{value:(_vm.tel1Dmd),callback:function ($$v) {_vm.tel1Dmd=$$v},expression:"tel1Dmd"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Contact 2 du demandeur")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"tel2Dmd","placeholder":"Contact 2 du demandeur","required":""},model:{value:(_vm.tel2Dmd),callback:function ($$v) {_vm.tel2Dmd=$$v},expression:"tel2Dmd"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Sous zone concerné")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Sous zone concerné"},model:{value:(_vm.selectSal),callback:function ($$v) {_vm.selectSal=$$v},expression:"selectSal"}},_vm._l((_vm.itemsSal),function(item){return _c('el-option',{key:item.idSalle,attrs:{"label":item.nomSalle,"value":item.idSalle}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date d'intervention désiré")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"value-format":"dd-MM-yyyy","name":"datePrevu","type":"date","placeholder":"Date prévue de l'intervention"},model:{value:(_vm.datePrevu),callback:function ($$v) {_vm.datePrevu=$$v},expression:"datePrevu"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Motif de la demande")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":5,"name":"motif","placeholder":"Motif de la demande","required":""},model:{value:(_vm.descDmd),callback:function ($$v) {_vm.descDmd=$$v},expression:"descDmd"}})],1)])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutDmd = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submitDemande}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions')],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"30%","scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutNote),callback:function ($$v) {_vm.dialogAjoutNote=$$v},expression:"dialogAjoutNote"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Donner votre appréciation ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutNote = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-form',{ref:"formNote",attrs:{"lazy-validation":"","id":"formNote"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('p',{attrs:{"align":"center"}},[_c('el-rate',{attrs:{"name":"note","colors":['#99A9BF', '#F7BA2A', '#FF9900'],"show-score":"","text-color":"red","score-template":"{value} points"},model:{value:(_vm.noteDemande),callback:function ($$v) {_vm.noteDemande=$$v},expression:"noteDemande"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Remarque")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":5,"name":"remarque","placeholder":"Remarque","required":""},model:{value:(_vm.descDmd),callback:function ($$v) {_vm.descDmd=$$v},expression:"descDmd"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutNote = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submitNote}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions')],1)],1),_vm._v(" "),(_vm.droitAcces.index_demande_demandeur && _vm.userCon.type === 2)?_c('v-card',[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("LISTE DES DEMANDES DU "+_vm._s(_vm.libzone))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Rechercher","single-line":"","hide-details":""},model:{value:(_vm.search_dmd),callback:function ($$v) {_vm.search_dmd=$$v},expression:"search_dmd"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers_dmd,"items":_vm.items_dmd,"search":_vm.search_dmd,"no-data-text":"Aucune données","rows-per-page-text":"Ligne(s) par page"},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n            "+_vm._s(props.header.text)+"\n          ")]),_vm._v(" "),_c('span',[_vm._v("\n            "+_vm._s(props.header.text)+"\n          ")])])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.dmdeur))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('v-chip',{attrs:{"text-color":"white","label":"","color":props.item.color}},[_vm._v("\n            "+_vm._s(props.item.etat_dmd)+" \n          ")]),_vm._v(" "),(props.item.processus == true)?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n            FERMER "),_c('v-icon',{attrs:{"right":""}},[_vm._v("clear")])],1):_vm._e(),_vm._v(" "),(props.item.processus == false)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n            OUVERT "),_c('v-icon',{attrs:{"right":""}},[_vm._v("insert_emoticon")])],1):_vm._e(),_vm._v(" "),(props.item.note !== null)?_c('v-chip',[_c('el-rate',{attrs:{"disabled":""},model:{value:(props.item.note),callback:function ($$v) {_vm.$set(props.item, "note", $$v)},expression:"props.item.note"}})],1):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n            "+_vm._s(props.item.date_dmd)+" \n          ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.index_constat)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.affDetailDmd(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1):_vm._e(),_vm._v("\n              Détails\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.note_dmd && props.item.etatGlobal === 8 && props.item.processus === true && props.item.note === null)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.newNote(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("stars")])],1):_vm._e(),_vm._v("\n              Noté la demande\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.add_dmd && props.item.etatGlobal < 2)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.editDemande(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n              Modifier\n            ")],1)],1)])]}},{key:"pageText",fn:function(ref){
var pageStart = ref.pageStart;
var pageStop = ref.pageStop;
return [_vm._v("\n         Ligne "+_vm._s(pageStart)+" à "+_vm._s(pageStop)+"\n      ")]}}],null,false,833861009)})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+ztJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Liste des demandes de congés de l'année en cours")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"elevation-3",attrs:{"slot":"activator","dark":"","icon":"","flat":"","color":"primary"},on:{"click":function($event){return _vm.loadListeAbsence()}},slot:"activator"},[_c('v-icon',[_vm._v("cached")])],1),_vm._v("\n                    actualiser la liste\n                ")],1)],1),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"model":_vm.formTri}},[_c('el-form-item',{attrs:{"label":"Date"}},[_c('el-date-picker',{attrs:{"format":"MM-yyyy","placeholder":"Date de debut","type":"month"},model:{value:(_vm.formTri.dateDebut),callback:function ($$v) {_vm.$set(_vm.formTri, "dateDebut", $$v)},expression:"formTri.dateDebut"}}),_vm._v(" "),_c('el-date-picker',{attrs:{"format":"MM-yyyy","placeholder":"Date de fin","type":"month"},on:{"change":_vm.verifDate},model:{value:(_vm.formTri.dateFin),callback:function ($$v) {_vm.$set(_vm.formTri, "dateFin", $$v)},expression:"formTri.dateFin"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","color":"blue","fab":"","small":"","disabled":_vm.desactiveBout},on:{"click":function($event){return _vm.rechercheUser()}},slot:"activator"},[_c('v-icon',[_vm._v("search")])],1),_vm._v("Effectuer une recherche\n            ")],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('Loading',{attrs:{"value":_vm.loadingAbsence}}),_vm._v(" "),_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                    Durée: Affiche le Total des jours sans les weekends et les jours fériés.\n                ")]),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeAbsence}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":"","mr-2":""}},[_c('span',{staticClass:"title"},[_vm._v("Validateur demande d'absence")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":props.row.validationDmd,"stripe":""}},[_c('el-table-column',{attrs:{"prop":"responsable","label":"Responsable","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"statut","label":"Statut","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"cyan--text body-2"},[_vm._v(_vm._s(scope.row.statut))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateValidation","label":"date validation"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('div',{staticClass:"grid-content"},[_c('p',{staticClass:"title"},[_vm._v("Description du demandeur")]),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('div',{staticClass:"grid-content"},[_c('el-input',{attrs:{"type":"textarea","rows":4,"disabled":true,"readonly":"true","placeholder":"Description"},model:{value:(props.row.description),callback:function ($$v) {_vm.$set(props.row, "description", $$v)},expression:"props.row.description"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","mr-2":""}},[_c('div',{staticClass:"grid-content"},[_c('p',{staticClass:"title"},[_vm._v("Fichiers")]),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('div',{staticClass:"grid-content"},[_c('v-tooltip',{attrs:{"bottom":""}},[_vm._l((props.row.imagesAbs),function(image,imageIndex){return _c('v-avatar',{key:imageIndex,staticClass:"mb-1 mr-1 elevation-3",style:({ backgroundImage: 'url(' + image + ')' , cursor: 'pointer'}),attrs:{"slot":"activator","tile":true,"size":50,"color":"grey lighten-4"},on:{"click":function($event){return _vm.showDiapo(props.row.imagesAbs,imageIndex)}},slot:"activator"},[_c('img',{attrs:{"src":image,"alt":"avatar"}})])}),_vm._v("\n                                                        Cliquez pour agrandir\n                                                    ")],2)],1)],1)],1)],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idAbsence","label":"ID-DEMANDE","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"typeConge","label":"TYPE CONGE","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demandeur","label":"DEMANDEUR","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"service","label":"SERVICE","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"poste","label":"POSTE","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateDbt","label":"DATE DEBUT","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateFin","label":"DATE FIN","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"DUREE","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureDabsce","label":"TOTAL HEURE ABSENCE","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"STATUT","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status == 'En cours de traitement')?_c('el-tag',[_vm._v(_vm._s(scope.row.status))]):(scope.row.status == 'En Attente de validation par DG')?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.status))]):(scope.row.status == 'Refusé par la DRH')?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.status))]):(scope.row.status == 'Validée par DG')?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.status))]):(scope.row.status == 'Refusé le DG')?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.status))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"Action","label":"Action","align":"center","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status =='En cours de traitement' || scope.row.status =='En Attente de validation par DG')?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editDemande(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                                    Modifier la demande\n                                ")],1):_vm._e(),_vm._v(" "),(scope.row.status =='En cours de traitement' )?_c('v-tooltip',{attrs:{"bottom":""}},[(_vm.statutDemande == 0)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){_vm.idAbsenceSelect = scope.row.idAbsence; _vm.dialogValide = true;_vm.deduireVacance= false;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("done")])],1):_vm._e(),_vm._v("\n                                    Approuver la demande\n                                ")],1):_vm._e(),_vm._v(" "),(scope.row.status =='En Attente de validation par DG')?_c('v-tooltip',{attrs:{"bottom":""}},[(_vm.statutDemande == 1)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.showValideAbs(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("done_all")])],1):_vm._e(),_vm._v("\n                                    Valider la demande\n                                ")],1):_vm._e(),_vm._v(" "),(scope.row.status =='En cours de traitement' || scope.row.status =='En Attente de validation par DG')?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){_vm.idAbsenceSelect = scope.row.idAbsence; _vm.dialogRefus = true}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("close")])],1),_vm._v("\n                                    Refuser la demande\n                                ")],1):_vm._e()]}}])})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"550"},model:{value:(_vm.dialogRefus),callback:function ($$v) {_vm.dialogRefus=$$v},expression:"dialogRefus"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_c('el-alert',{attrs:{"title":"Voulez-vous refuser la demande selectionnée ?","type":"warning","closable":false,"show-icon":""}})],1),_vm._v(" "),_c('v-card-text',[_c('el-input',{attrs:{"rows":4,"placeholder":"Motif du refus","type":"textarea"},model:{value:(_vm.descRefus),callback:function ($$v) {_vm.descRefus=$$v},expression:"descRefus"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialogRefus = false}}},[_vm._v("\n                    Annuler\n                ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":"flat"},on:{"click":function($event){return _vm.submitDemande(0,_vm.idAbsenceSelect)}}},[_vm._v("\n                    Refuser\n                ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"650"},model:{value:(_vm.dialogValide),callback:function ($$v) {_vm.dialogValide=$$v},expression:"dialogValide"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_c('span',{staticClass:"title mb-2"},[_vm._v("Valider la demande d'absence")]),_vm._v(" "),(_vm.statutDemande == 0 || _vm.typeIdAbsenceSelect == 'VACANCE')?_c('el-alert',{attrs:{"title":"Voulez-vous valider la demande selectionnée ?","type":"warning","closable":false,"show-icon":""}}):_vm._e(),_vm._v(" "),(_vm.statutDemande == 1 && _vm.typeIdAbsenceSelect != 'VACANCE')?_c('el-alert',{attrs:{"title":"Avertissement","type":"warning","closable":false,"description":"Si l'option déduire est selectionée la période d'absence sera déduite des jours de congés annuels","show-icon":""}}):_vm._e(),_vm._v(" "),(_vm.statutDemande == 1 && _vm.typeIdAbsenceSelect != 'VACANCE')?_c('el-form',{staticStyle:{"width":"100%"},attrs:{"label-width":"130px","label-position":"top"}},[_c('el-form-item',{attrs:{"label":"Déduire des jours des congés annuels"}},[_c('el-select',{attrs:{"placeholder":"Déduire la période d'absence des congés annuels ?"},model:{value:(_vm.deduireVacance),callback:function ($$v) {_vm.deduireVacance=$$v},expression:"deduireVacance"}},_vm._l((_vm.listeDeduction),function(item,index){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1),_vm._v(" "),_c('span',{staticClass:"display-1 blue--text"},[_vm._v("  "+_vm._s(_vm.nbJoursVacance)+"/30")]),_vm._v(" Jrs rest/Total\n                         \n                        "),_c('span',{staticClass:"display-1 red--text"},[_vm._v("  "+_vm._s(_vm.dureeAbs))]),_vm._v(" Jrs Absence dmd\n                    ")],1),_vm._v(" "),(_vm.deduireVacance == true)?_c('el-form-item',{attrs:{"label":"Commentaire"}},[_c('el-input',{attrs:{"type":"textarea","rows":"5"},model:{value:(_vm.descRefus),callback:function ($$v) {_vm.descRefus=$$v},expression:"descRefus"}})],1):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","flat":"flat"},on:{"click":function($event){_vm.dialogValide = false}}},[_vm._v("\n                    Annuler\n                ")]),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"green darken-1","disabled":_vm.deduireVacance == true && _vm.descRefus == ''},on:{"click":function($event){return _vm.submitDemande(1,_vm.idAbsenceSelect)}}},[_vm._v("\n                    Valider\n                ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"max-width":"50%"},model:{value:(_vm.dialogModifDemande),callback:function ($$v) {_vm.dialogModifDemande=$$v},expression:"dialogModifDemande"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Modifier la demande de "+_vm._s(_vm.nomDemandeur)+" ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogModifDemande = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formAbsence",staticClass:"demo-form-inline",attrs:{"model":_vm.formDmdAbsence}},[_c('el-row',{attrs:{"type":"flex","gutter":20,"justify":"center"}},[_c('el-col',{attrs:{"span":14}},[_c('div',{staticClass:"block"},[_c('el-form-item',{attrs:{"label":"Période de congé"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy HH:mm","value-format":"yyyy-MM-dd HH:mm","type":"datetimerange","range-separator":"au","start-placeholder":"Début date","end-placeholder":"Fin date"},model:{value:(_vm.formDmdAbsence.datedbtFin),callback:function ($$v) {_vm.$set(_vm.formDmdAbsence, "datedbtFin", $$v)},expression:"formDmdAbsence.datedbtFin"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('div',[_c('el-form-item',{attrs:{"label":"Type de congé"}},[_c('el-select',{attrs:{"placeholder":"Type de congé"},model:{value:(_vm.formDmdAbsence.idTypeConge),callback:function ($$v) {_vm.$set(_vm.formDmdAbsence, "idTypeConge", $$v)},expression:"formDmdAbsence.idTypeConge"}},_vm._l((_vm.listeTypeConge),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1)])],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","gutter":20,"justify":"end"}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","color":"orange"},on:{"click":function($event){$event.stopPropagation();_vm.dialogModifDemande = false}},slot:"activator"},[_vm._v("\n                    Annuler\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v("\n                Annuler la modificatioon\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","color":"green"},on:{"click":function($event){return _vm.submitModDemande()}},slot:"activator"},[_vm._v("\n\n                Enregistrer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1),_vm._v("\n            enregistrer la modificatioon\n        ")],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('CoolLightBox',{attrs:{"items":_vm.items,"index":_vm.index},on:{"close":function($event){_vm.index = null}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/9jh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Fpr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/SGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticStyle:{"padding":"0px"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":""}},[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v(_vm._s(item.text))])}),1)],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{staticClass:"elevation-6 pt-4 mb-3",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"sm5":"","offset-xs2":""}},[_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"left","inline":true,"model":_vm.formTri}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Période de recherche"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"datetimerange","range-separator":"à","start-placeholder":"Début date","end-placeholder":"Fin date"},model:{value:(_vm.formTri.periode),callback:function ($$v) {_vm.$set(_vm.formTri, "periode", $$v)},expression:"formTri.periode"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","color":"blue","fab":"","small":"","disabled":_vm.desactiveBout},on:{"click":function($event){return _vm.recherche()}},slot:"activator"},[_c('v-icon',[_vm._v("search")])],1),_vm._v("Effectuer une recherche\n      ")],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-2":"","mb-4":"","ml-1":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('WidgetTravaux',{attrs:{"commis":false,"listeTrx":_vm.listeTravaux,"listeTrxId":_vm.listeTravauxId}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":"","ml-1":"","mr-1":"","mt-1":""}},[_c('v-card',[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick(_vm.onglet)}},model:{value:(_vm.onglet),callback:function ($$v) {_vm.onglet=$$v},expression:"onglet"}},[_c('el-tab-pane',{attrs:{"label":"Travaux"}},[_c('ListeTravaux',{attrs:{"type":0,"listeTrx":_vm.listeTravaux,"listeTrxId":_vm.listeTravauxId,"periode":_vm.periodeFormat},on:{"reloadListeTravaux":function($event){return _vm.loadTravaux()}}}),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Reserve Travaux"}},[_c('ListeReserve',{attrs:{"type":0,"listeReserveTrx":_vm.listeReserves},on:{"reloadListeReserve":function($event){return _vm.loadReserves()}}}),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/UO0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Technicien_vue__ = __webpack_require__("ad4g");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f9ce46d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Technicien_vue__ = __webpack_require__("9JC9");
function injectStyle (ssrContext) {
  __webpack_require__("MQyO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f9ce46d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Technicien_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f9ce46d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Technicien_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/XTI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"700","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogSatisfaction),callback:function ($$v) {_vm.dialogSatisfaction=$$v},expression:"dialogSatisfaction"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Rapport  Demande DMD-"+_vm._s(_vm.demandeDetail.idDemande))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                               Donnez votre avis sur le traitement de la demande\n                            ")]),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"id":"formRapport","model":_vm.formRapport}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"50%"},attrs:{"label":"Donnez une note sur 10","prop":"satisfait"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"satisfait","placeholder":"votre note"},model:{value:(_vm.formRapport.satisfait),callback:function ($$v) {_vm.$set(_vm.formRapport, "satisfait", $$v)},expression:"formRapport.satisfait"}},_vm._l((_vm.listeSatisfaction),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Pourquoi cette note"}},[_c('el-input',{attrs:{"type":"textarea","rows":6,"placeholder":"Donnez votre avis"},model:{value:(_vm.formRapport.rapport),callback:function ($$v) {_vm.$set(_vm.formRapport, "rapport", $$v)},expression:"formRapport.rapport"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitFormRapport()}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/lFb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/omi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/p7q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
      userCon: JSON.parse(sessionStorage.getItem('userInfo')),
      roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
      parent: true,
      groupe: { selection: [], liste: [] },
      folderGroupe: { selection: [], liste: [] },
      edit: false,
      currentFolder: { id: null, libelle: '', folder: [], fichiers: [], parent: '', parentID: '', admin: '' },
      upload: '',
      sendFile: '',
      sendFolder: '',
      folder: false,
      dialogShareFolder: false,
      dialogShareFile: false,
      erreur: { message: '', type: false },
      televersement: false,
      sheet: false,
      loading: false,
      allUser: [],
      allUserFolderSelected: [],
      allUserFile: [],
      allUserFileSelected: [],
      allUserShared: [],
      dossierPartage: [],
      fichierPartage: [],
      valid: true,
      checkbox: false,
      dossiers: [],
      user: JSON.parse(sessionStorage.getItem('userInfo')),
      viewMenu: false,
      currentFichier: { etat: false, libelle: '', admin: '' },
      dossier: { id: '', libelle: 'Dossier sans titre', description: '', etat: false, title: '',
        nameRules: [function (v) {
          return !!v || 'libelle requis';
        }]
      },
      items2: [],
      dialog: false,
      fichiersansNom: [],
      ctxFocus: null
    };
  },
  mounted: function mounted() {
    this.load();
    this.currentFolder.id = null;
  },

  methods: {
    removeF: function removeF(item) {
      var _this = this;

      var url = "";
      var formdata = new FormData();
      if (item == "folder") {
        url = this.domaine + 'webservice/drive/remove/folder';
        formdata.append('id', this.dossier.id);
      } else {
        url = this.domaine + 'webservice/drive/remove/fichier';
        formdata.append('id', this.currentFichier.id);
      }

      this.$confirm('Etes vous sur de vouloir supprimer l\'element ?').then(function (_) {

        _this.loading = true;

        formdata.append('user', _this.user.id);

        _this.$http.post(url, formdata).then(function (response) {
          if (response.body) {
            _this.loading = false;
            if (response.body.code == 2) {
              window.location.reload(true);
              _this.currentFichier.etat = false;
            } else {}
          }
        });
      }).catch(function (_) {});
    },
    submitShareFolder: function submitShareFolder() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + 'webservice/drive/share-docs-user';
      var formdata = new FormData();
      this.folderGroupe.selection.forEach(function (item) {
        formdata.append('data[]', item);
      });
      formdata.append('dossierId', this.dossier.id);
      formdata.append('userId', this.user.id);
      this.$http.post(url, formdata).then(function (response) {
        if (response.body) {
          if (response.body.code === 1) {
            _this2.$notify({
              title: 'LE DOSSIER A BIEN ETE PARTAGE',
              message: 'Partage réussie avec succès.',
              type: 'success',
              position: 'top-center'
            });
            _this2.loading = false;
            _this2.dialogShareFolder = false;
            window.location.reload(true);
          } else {
            _this2.$message.error(response.body.message);
          }
        }
      });
    },
    submitShareFile: function submitShareFile() {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + 'webservice/drive/share-file-user';
      var formdata = new FormData();
      this.groupe.selection.forEach(function (item) {
        formdata.append('data[]', item);
      });
      formdata.append('fileId', this.currentFichier.id);
      formdata.append('fileLibelle', this.currentFichier.libelle);
      formdata.append('userId', this.user.id);
      this.$http.post(url, formdata).then(function (response) {
        if (response.body) {
          if (response.body.code === 1) {
            _this3.$notify({
              title: 'LE FICHIER A BIEN ETE PARTAGE',
              message: 'Partage réussie avec succès.',
              type: 'success',
              position: 'top-center'
            });
            _this3.loading = false;
            _this3.dialogShareFile = false;
            window.location.reload(true);
          } else {
            _this3.$message.error(response.body.message);
          }
        }
      });
    },
    shareFilesInit: function shareFilesInit() {
      this.dialogShareFile = true;
      this.currentFichier.etat = false;
      this.loadUserFiles();
    },
    shareFolderInit: function shareFolderInit() {
      this.dossier.title = 'Partager';
      this.dialogShareFolder = true;
      this.loadUser();
    },
    editFile: function editFile(item) {
      this.currentFichier.etat = true;
      this.currentFichier.url = item.url;
      this.currentFichier.id = item.id;
      this.currentFichier.admin = item.admin;
      this.currentFichier.libelle = item.libelle;
    },
    editFolder: function editFolder(item) {
      this.edit = true;
      this.dossier.id = item.id;
      this.currentFolder.id = item.id;
      this.currentFolder.admin = item.admin;
      this.dossier.libelle = item.libelle;
      this.dossier.description = item.description;
    },
    parentFolder: function parentFolder() {
      if (this.currentFolder.parent == true) {
        this.currentFolder.id = this.currentFolder.parentID;
      } else {
        this.currentFolder.id = null;
      }
      this.load();
    },
    naviguateFolder: function naviguateFolder() {
      this.parent = false;
      this.folder = true;
      this.load();
    },
    lecture: function lecture() {
      window.open(this.currentFichier.url, '_blank');
    },
    lancement: function lancement() {
      if (this.currentFolder.id == null) {
        this.upload = this.domaine + 'webservice/drive/file/add/' + this.user.id;
      } else {
        this.upload = this.domaine + 'webservice/drive/file/add/' + this.user.id + '/' + this.currentFolder.id;
      }
    },
    submitUpload: function submitUpload() {
      this.$refs.upload.submit();
    },
    loadUserFiles: function loadUserFiles() {
      var _this4 = this;

      this.groupe.liste = [];
      this.groupe.selection = [];
      this.loading = true;
      var url = this.domaine + 'webservice/drive/load-user-files';
      var formdata = new FormData();
      formdata.append('user', this.user.id);
      formdata.append('fichierId', this.currentFichier.id);
      formdata.append('userId', this.user.id);
      this.$http.post(url, formdata).then(function (response) {
        if (response.body) {
          _this4.allUserFile = response.body[0];
          _this4.allUserFileSelected = response.body[1];
          _this4.loading = false;
          self = _this4;
          _this4.allUserFile.forEach(function (item) {
            self.groupe.liste.push({
              label: item.name,
              key: item.id
            });
          });
          _this4.allUserFileSelected.forEach(function (item) {
            self.groupe.selection[item.id] = item.id;
          });
        }
      });
    },
    loadUser: function loadUser() {
      var _this5 = this;

      this.folderGroupe.liste = [];
      this.folderGroupe.selection = [];
      this.loading = true;
      var url = this.domaine + 'webservice/drive/load-user';
      var formdata = new FormData();
      formdata.append('user', this.user.id);
      formdata.append('dossierId', this.currentFolder.id);
      formdata.append('userId', this.user.id);
      this.$http.post(url, formdata).then(function (response) {
        if (response.body) {
          _this5.allUser = response.body[0];
          _this5.allUserFolderSelected = response.body[1];
          _this5.loading = false;
          self = _this5;
          _this5.allUser.forEach(function (item) {
            self.folderGroupe.liste.push({
              label: item.name,
              key: item.id
            });
          });
          _this5.allUserFolderSelected.forEach(function (item) {
            self.folderGroupe.selection[item.id] = item.id;
          });
        }
      });
    },
    load: function load() {
      var _this6 = this;

      this.loading = true;
      var url = this.domaine + 'webservice/drive/';
      var formdata = new FormData();
      formdata.append('user', this.user.id);
      formdata.append('id', this.currentFolder.id);
      this.$http.post(url, formdata).then(function (response) {
        if (response.body) {
          _this6.fichierPartage = response.body[2];
          _this6.dossierPartage = response.body[1];
          _this6.dossiers = response.body[0].data;
          _this6.fichiersansNom = response.body[0].fiche;
          _this6.currentFolder.parent = response.body[0].parent;
          _this6.currentFolder.parentID = response.body[0].parentID;
          _this6.loading = false;
        }
      });
    },
    valideCreate: function valideCreate() {
      var _this7 = this;

      this.erreur.type = false;
      this.loading = false;
      if (this.$refs.form.validate()) {
        this.loading = true;
        var formdata = new FormData();
        formdata.append('dossier[libelle]', this.dossier.libelle);
        formdata.append('dossier[user]', this.user.id);
        formdata.append('dossier[id]', this.dossier.id);
        formdata.append('dossier[description]', this.dossier.description);
        formdata.append('dossier[etat]', this.dossier.etat);
        formdata.append('dossier[folder]', this.currentFolder.id);
        var url = this.domaine + 'webservice/drive/dossier/add';
        this.$http.post(url, formdata).then(function (response) {
          if (response.body.code == 1) {
            _this7.dossier.etat = false;
            _this7.load();
          } else {
            _this7.loading = false;
            _this7.erreur.type = true;
            _this7.erreur.message = response.body.message;
          }
        }, function (response) {});
      }
    },

    beforeMount: function beforeMount() {
      if (!this.roleAcces[this.$router.history.current.name]) {
        this.$router.push({ name: 'Home' });
      }
    }

  }
});

/***/ }),

/***/ "/sgE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutPrevisionBudgetChantier_vue__ = __webpack_require__("12HE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_728f8e43_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutPrevisionBudgetChantier_vue__ = __webpack_require__("sig4");
function injectStyle (ssrContext) {
  __webpack_require__("kSaB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutPrevisionBudgetChantier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_728f8e43_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutPrevisionBudgetChantier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/w6/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ouvrier_infoOuvrier__ = __webpack_require__("0onN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_boardTravaux_ListePresence__ = __webpack_require__("HaGr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "liste-ouvrier",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */], infoOuvrier: __WEBPACK_IMPORTED_MODULE_3__components_ouvrier_infoOuvrier__["a" /* default */], ListePresence: __WEBPACK_IMPORTED_MODULE_4__components_boardTravaux_ListePresence__["a" /* default */] },
  data: function data() {
    var _ref;

    return _ref = {
      //data general
      notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
      domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
      user: JSON.parse(sessionStorage.getItem('userInfo')),
      roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
      droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
      loading: false,
      racourcis: [{ path: '/listeOuvrier', text: 'Ouvrier' }],

      formContrat: {},

      listeOuvriers: [],
      selectTaches: [],
      listePrestOuvriers: [],
      listeProjets: [],
      listeTacheTrx: [],
      listeTravaux: [],
      listeProjet: [],
      tablePresence: [],
      listeChantier: [],
      listeRptNon: [],
      infoRapport: [],
      showInfo: false,
      active: 0,
      infoOuvr: {},
      nombreSelection: 0,
      multipleSelection: [],
      etat: false

    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'loading', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogRapport', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogListRapport', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'dateRapport', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'detailRapport', []), _ref;
  },


  methods: {
    showPointage: function showPointage(row) {
      var _this = this;

      this.loading = true;
      this.dateRapport = row.dateRpt;
      var url = this.domaine + "journal/" + row.id;
      this.$http.get(url).then(function (response) {
        _this.dialogListRapport = true;
        _this.detailRapport = response.body.journal;
        _this.loading = false;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Echec lors du chargement des Journaux");
      });
    },
    loadListeOuvrier: function loadListeOuvrier() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "ouvrier/index";
      this.$http.get(url).then(function (response) {
        _this2.listeOuvriers = response.body.ouvrier;
        _this2.loading = false;
      }, function (error) {
        _this2.loading = false;
        _this2.$message.error("Echec lors du chargement des RESSOURCES TECHNIQUES");
      });
    },
    besoinSelect: function besoinSelect(row, index) {
      var etat = null;
      if (parseInt(row.qte) != 0) {
        etat = true;
      } else {
        etat = false;
      }
      return etat;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      this.nombreSelection = val;
    },
    rapportJour: function rapportJour(rapport) {
      this.next();
      this.infoRapport = rapport;
    },
    loadOuvrierTravaux: function loadOuvrierTravaux() {
      var _this3 = this;

      this.loadStatRapport();
      this.loading = true;
      // on recherche tous les ouvrier affecter par defaut au chantier ou au travaux
      var url = this.domaine + "ouvrier/travaux/" + this.formContrat.travaux;

      this.$http.get(url).then(function (response) {
        _this3.listePrestOuvriers = response.body.ouvriers;
        _this3.loading = false;
      }, function (error) {
        _this3.loading = false;
        _this3.$message.error("Echec lors du chargement de la liste des ouvriers");
      });
    },
    next: function next() {
      this.loadOuvrierTravaux();
      if (this.active++ > 1) this.active = 1;
    },
    previous: function previous() {
      if (this.active-- < 0) this.active = 0;
      this.etat = false;
    },
    showInfoOuvrier: function showInfoOuvrier(item) {
      this.showInfo = true;
      this.infoOuvr = item;
    },
    generateRapport: function generateRapport() {
      this.dialogRapport = true;
      this.formContrat = {};
      this.selectTaches = [];
    },
    loadProjet: function loadProjet() {
      var _this4 = this;

      var url = this.domaine + "projet/index/projet/all";

      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this4.loading = false;
        _this4.listeProjet = response.body.projet;
      }, function (errRep) {
        _this4.loading = false;
        _this4.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    loadChantier: function loadChantier() {
      var _this5 = this;

      if (this.formContrat.projet == "" || this.formContrat.projet == null) {
        return;
      }
      this.loading = true;
      this.listeChantier.splice(0);
      this.listeTacheTrx.splice(0);
      this.listeTravaux.splice(0);

      var url = this.domaine + "projet/" + this.formContrat.projet + "/index/chantier";
      this.$http.get(url).then(function (response) {
        _this5.loading = false;
        _this5.listeChantier = response.body.chantier;
      }, function (errRep) {
        _this5.loading = false;
        _this5.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    loadTravaux: function loadTravaux() {
      var _this6 = this;

      this.loading = true;
      // this.formContrat.travaux = "";
      this.listTravaux = [];
      if (this.formContrat.chantier != "" && this.formContrat.chantier != null) {
        var url = this.domaine + "projet/" + this.formContrat.chantier + "/index/chantier/travaux";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this6.listeTravaux = response.body.travaux;
            _this6.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un chantier");
        this.loading = false;
      }
    },
    loadTacheTrx: function loadTacheTrx() {
      var _this7 = this;

      this.loading = true;
      this.listeTacheTrx.splice(0);
      if (this.formContrat.travaux) {
        var url = this.domaine + "tache/travaux/" + this.formContrat.travaux;
        this.$http.get(url).then(function (response) {
          _this7.listeTacheTrx = response.body.taches;
          _this7.loading = false;
        });
      } else {
        this.$message.error("Veuillez sélectionner une tache");
        this.loading = false;
      }
    },
    createRapport: function createRapport() {
      var _this8 = this;

      this.loading = true;
      var url = this.domaine + "journal/new/rapport/ouvrier";
      var data = new FormData();
      data.append("dateRapport", this.infoRapport.dateRptFormat);
      data.append("idUser", this.user.id);
      data.append("idTravaux", this.formContrat.travaux);
      data.append("tableRessourceOUvrier", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tablePresence));

      this.$http.post(url, data).then(function (resp) {
        _this8.loading = false;
        _this8.$notify({
          title: "Pointage effectué",
          message: resp.body.message,
          type: "success",
          position: "top-right",
          duration: 7000
        });
        _this8.dialogRapport = false;
        _this8.tableQuestion.splice(0);
        _this8.tableTravaux.splice(0);
        _this8.tableVisiteur.splice(0);
        _this8.tableInventaire.splice(0);
        _this8.tableRessource.splice(0);
        _this8.tableRessTechnik.splice(0);
        _this8.tablePresence.splice(0);

        _this8.$emit("reloadListeTrx");
        _this8.dialogAccord = false;
        _this8.closeDialog();
      }, function (resp) {
        _this8.loading = false;
        _this8.$message.error("Erreur lors de l'enregistrement du journal");
      });
    },
    loadStatRapport: function loadStatRapport() {
      var _this9 = this;

      var url = this.domaine + "journal/stat/travaux/ouvrier";
      var data = new FormData();
      data.append("listeTrx", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formContrat.travaux));
      this.$http.post(url, data).then(function (response) {
        _this9.loading = false;
        _this9.listeRptNon = response.body.listeTrxNonEffec;
      }, function (error) {
        _this9.loading = false;
        _this9.$message.error("Erreur lors de dashboard travaux");
      });
    },
    loadListePresence: function loadListePresence(liste) {
      this.tablePresence = liste;
    }
  },
  computed: {
    isInvalide: function isInvalide() {
      if (this.selectTaches) {
        return false;
      } else {
        return true;
      }
    }
  },

  mounted: function mounted() {
    this.loadListeOuvrier();
    this.loadProjet();
  }
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0+kO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_resourceHumaine_modalDetailEmploye__ = __webpack_require__("InPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_resourceHumaine_modelCarteContrat__ = __webpack_require__("CR5P");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */], modalDetailEmploye: __WEBPACK_IMPORTED_MODULE_1__components_resourceHumaine_modalDetailEmploye__["a" /* default */], modelCarteContrat: __WEBPACK_IMPORTED_MODULE_2__components_resourceHumaine_modelCarteContrat__["a" /* default */] },
    name: "listeContrat",
    data: function data() {
        return {
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,

            contratEmployes: [],
            contratsEnCours: [],
            contratsArenouveller: [],
            contratsExpire: [],
            contratsAnnule: [],
            contratsInactif: [],
            showDetailEmpl: false,
            employSelect: null

        };
    },

    methods: {
        loadContrat: function loadContrat() {
            var _this = this;

            this.loading = true;
            var url = this.domaine + "rh/contrat/all";

            this.$http.get(url).then(function (resp) {
                _this.loading = false;
                _this.contratEmployes = resp.body.listeContrats;
                _this.contratsArenouveller = _this.contratEmployes.filter(function (cont) {
                    return cont.etat == 2;
                });

                _this.contratsEnCours = _this.contratEmployes.filter(function (cont) {
                    return cont.etat == 0;
                });

                _this.contratsInactif = _this.contratEmployes.filter(function (cont) {
                    return cont.etat == 1;
                });

                _this.contratsExpire = _this.contratEmployes.filter(function (cont) {
                    return cont.etat == 3;
                });

                _this.contratsAnnule = _this.contratEmployes.filter(function (cont) {
                    return cont.etat == 4;
                });
            }, function (error) {
                _this.loading = false;
                _this.$message.error("Echec lors du chargement des contrats");
            });
        },
        showDetailEmploye: function showDetailEmploye(idEmploye) {
            this.employSelect = idEmploye;
            this.showDetailEmpl = true;
        }
    },
    mounted: function mounted() {
        this.loadContrat();
    }
});

/***/ }),

/***/ "0/Gr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "09Nl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"primary":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs9":""}},[_c('img',{attrs:{"src":"/static/back_connexion_archipro.png","width":"100%","height":"100%"}})]),_vm._v(" "),_c('v-flex',{staticClass:"mr-4 ml-4 mt-4 text-xs-center  ",attrs:{"xs3":""}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"text-xs-center"},[_c('img',{staticClass:"mb-5",attrs:{"src":_vm.logo,"alt":"ARCHIPROV2","width":"50%","height":"50%"}})]),_vm._v(" "),_c('v-card',{staticClass:"elevation-12"},[_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"rules":_vm.loginRules,"prepend-icon":"person","name":"login","label":"Login","type":"text","required":""},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==13){ return null; }return _vm.submit($event)}},model:{value:(_vm.login),callback:function ($$v) {_vm.login=$$v},expression:"login"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.passwordRules,"prepend-icon":"lock","name":"password","label":"Mot de passe","id":"password","type":"password","required":""},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&$event.keyCode!==13){ return null; }return _vm.submit($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"block":"","disabled":!_vm.valid,"color":"primary","dark":""},on:{"click":_vm.submit}},[_vm._v("Se connecter")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","small":"","color":"error"},on:{"click":function($event){_vm.dialogPassword = true}}},[_vm._v("Mot de passe oublié")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"align-content-end mt-5 mb-5",attrs:{"xs12":""}}),_vm._v(" "),_c('v-flex',{staticClass:"align-content-end mt-5",attrs:{"xs12":""}},[_c('p',{staticClass:"caption",staticStyle:{"font-weight":"bold"}},[_vm._v("®\n              "),_c('a',{attrs:{"href":"https://www.archipro.ci/","target":"_blank"}},[_vm._v("ARCHIPRO 2017-2022")])]),_vm._v(" "),_c('p',{staticClass:"primary--text"},[_c('a',{attrs:{"href":"https://www.archipro.ci/","target":"_blank"}},[_vm._v("Conditions d'utilisation | confidentialité")])])])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"attach":"true","width":"500"},model:{value:(_vm.dialogPassword),callback:function ($$v) {_vm.dialogPassword=$$v},expression:"dialogPassword"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v(" Reinitialisez votre mot de passe ")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Veuillez saisir votre nom d'utilisateur, vous recevrez un mot de passe par mail et sms ")]),_vm._v(" "),_c('p',{staticStyle:{"color":"red"}},[_vm._v("NB: Modifiez immediatement votre de passe lors de votre prochaine connexion")])]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form2",attrs:{"lazy-validation":""}},[_c('v-text-field',{attrs:{"rules":_vm.loginRules,"prepend-icon":"person","name":"login","label":"Login","type":"text","required":""},model:{value:(_vm.login),callback:function ($$v) {_vm.login=$$v},expression:"login"}})],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.isValidLogin,"color":"primary"},on:{"click":function($event){return _vm.submitResetPassword()}}},[_vm._v("Valider")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0X2T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Vb+l");
__webpack_require__("Oq2I");
__webpack_require__("miEh");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: 'ModalBanque',
  props: ["listApproDgCheq", "statCaisse2", "dialogModalBanque", "detailBanque", "montantEntree", "montantSortie", "tableOpera", "formRech", "searchOpera", "approCourant", "newAppro", "dialogAjoutAppro", "listApproBanque", "showAppro", "imprimeHistoBanque", "editAppro", "imprimerAppro", "handleCommand", "handleClick", "disabledBtn", "listOperation", "dateOperation", "totalEntree", "totalSortie", "imprimeListeHis"],
  data: function data() {
    return {

      loading: false,
      domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
      user: JSON.parse(sessionStorage.getItem('userInfo')),
      roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
      droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),

      //STATISTIQUE
      statAllCaisse: [],
      statBanque: [],
      // listApproDgCheq: [],
      fileCheque: [{ name: '', url: '' }],
      dialogConfirmCheq: false,
      idBanqueCourant: '',
      detailReglement: [],
      dialogEdit: false,
      validBanquPaiem: false,
      dialogShowPiece: false,
      showButtonPiece: false,
      pieceJusti: "/static/img-doc.png",
      optionPaiement: '',

      selectValidateurAppro: '',

      dateFactureRules: [function (v) {
        return !!v || "Veuillez renseigner les intervalles de date";
      }],
      dateOperationRules: [function (v) {
        return !!v || "Veuillez renseigner les intervalles de date";
      }],
      formValidCheq: {
        numCheq: '',
        dateSign: '',
        pieceJointe: ''
      },
      rulesTransfer: {
        caisse: [{ required: true, message: 'Veuillez selectionner une caisse', trigger: 'blur' }],
        libelleTransfert: [{ required: true, message: 'Veuillez saisir le motif', trigger: 'blur' }],
        montantTransf: [{ required: true, message: 'Veuillez saisir le montant', trigger: 'blur' }]
      },
      rules: {
        numCheq: [{ type: 'string', required: true, message: 'Ce champs est obligatoire', trigger: 'blur' }],
        dateSign: [{ type: 'string', required: true, message: 'Ce champs est obligatoire' }]
      },
      approForm: {
        motif: '',
        montant: ''
      },
      rulesAppro: {
        motif: [{ required: true, message: 'Veuillez saisir le motif', trigger: 'blur' }],
        montant: [{ required: true, message: 'Veuillez saisir le montant', trigger: 'blur' }]
      },
      image1: "/static/img-doc.png",
      image2: "/static/img-doc.png",
      image3: "/static/img-doc.png",
      image4: "/static/img-doc.png",
      urlImage: "/static/doc.png",

      file1: "",
      file2: "",
      file3: "",
      selectTypeFacture: "",
      typeFacture: [{ text: 'Par date de création', value: 1 }, { text: 'Par période', value: 2 }],
      selectEtatFacture: "",
      etatFacture: [{ text: 'Impayé', value: 0 }, { text: 'Soldé', value: 1 }, { text: 'En attente de paiement', value: 2 }, { text: 'En cours de paiement', value: 3 }],
      listFournisseur: [],
      selectFournisseur: "",
      listFacture: [],
      listClient: [],
      listCaisse: [],
      selectClient: "",

      totalFacture: 0,
      totalFacture1: 0,
      payeFacture: 0,
      payeFacture1: 0,
      impayeFacture: 0,
      impayeFacture1: 0,
      factureCourant: [],
      listReglement: [],
      montantVerse: 5,
      remettant: '',
      banque: '',
      reference: '',
      selectEncaisse: '',
      encaisse: [{ text: 'OUI', value: 1 }, { text: 'NON', value: 2 }],
      selectEffectue: "",
      effectue: [{ text: 'Lui même', value: 1 }, { text: 'Autre', value: 2 }],
      selectMode: '',
      mode: [{ text: 'Chèque', value: 1 }],
      modeBanque: [
      // { text: 'Espèce', value: 1 },
      { text: 'Chèque', value: 2 }],
      caisseCourant: [],
      valid: true,
      typeRech: "fournisseur",
      //Demandeur
      selectDemandeur: null,
      listeDemandeur: [],
      dialogAjoutReglement: false,
      dialogEditReglement: false,
      dialogShowReglement: false,
      dialogShow: false,
      readInput: false,
      // Reglement facture/mission/fournissseur
      dialogLoadReglement: false,
      soldeCaisse: 0,
      reglementCourant: [],
      dialogAjoutTrans: false,
      transFertForm: {
        libelleTransfert: '',
        montantTransf: '',
        caisseSelect: ''
      }

    };
  },

  computed: {},
  methods: {
    submitTransferCaisse: function submitTransferCaisse(formName) {
      var _this = this;

      if (this.detailBanque.solde1 >= this.transFertForm.montantTransf) {
        this.loading = true;
        var form = document.getElementById('transFertForm');
        var data = new FormData(form);
        data.append('idUser', this.user.id);
        data.append('caisseCrediter', this.transFertForm.caisseSelect);
        var url = this.domaine + 'caisse/' + this.detailBanque.id + '/new/transfert/caisse';
        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            _this.dialogAjoutTrans = false;
            if (verif.code === 1) {
              _this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: 'Transfert dans une autre trésorerie enregistré avec succès.',
                type: 'success',
                position: 'top-center'
              });
              _this.dialogAjoutAppro = false;
              _this.showBanque(_this.detailBanque.id);
              _this.loading = false;
            } else if (verif.code === 0) {
              _this.$message.error(verif.message);
              _this.loading = false;
            }
          } else {
            _this.$message.error('Erreur serveur');
            _this.loading = false;
          }
        }, function (response) {
          _this.$message.error('Erreur serveur');
          _this.loading = false;
        });
      } else {
        this.$message.error("Montant à transferer est supérieur au solde de la caisse.");
      }
    },
    newTransfert: function newTransfert(ligne) {
      this.loading = false;
      this.dialogAjoutTrans = true;
      this.transFertForm = {};
    },
    loadDialogConfirm: function loadDialogConfirm(item) {
      this.dialogConfirmCheq = true;
      this.idBanqueCourant = item.id;
    },
    loadClient: function loadClient() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + 'client/projet/index';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this2.listClient = response.body.client;
          _this2.loading = false;
        }
      }, function (error) {
        _this2.loading = false;
      });
    },

    //STATISTIQUE
    statAllbilan: function statAllbilan() {
      //somme des entrée et des sorties
      var optionAllBilan = {
        title: {
          text: 'TOTAL DES MONTANTS CREDIT ET DEBIT DES TRESORERIES',
          subtext: '',
          left: 'center'
        },
        color: ['#67C23A', '#e5323e'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: []
        }],
        yAxis: [{ type: 'value' }],
        series: [{
          name: 'Montant entrée ',
          type: 'bar',
          barWidth: 30,
          data: []
        }, {
          name: 'Montant sortie ',
          type: 'bar',
          barWidth: 30,
          data: []
        }]
      };

      this.statAllCaisse.forEach(function (element) {
        optionAllBilan.xAxis[0].data.push(element.date);
        optionAllBilan.series[0].data.push(element.entree);
        optionAllBilan.series[1].data.push(element.sortie);
      });

      var chartAllBilan = echarts.init(document.getElementById('chartAllBilan'));
      chartAllBilan.setOption(optionAllBilan);
    },
    statAllbilanBanque: function statAllbilanBanque() {
      //somme des entrée et des sorties
      var optionAllBilanBanque = {
        title: {
          text: 'TOTAL DES MONTANTS CREDIT ET DEBIT DE LA BANQUE',
          subtext: '',
          left: 'center'
        },
        color: ['#67C23A', '#e5323e'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: []
        }],
        yAxis: [{ type: 'value' }],
        series: [{
          name: 'Montant entrée ',
          type: 'bar',
          barWidth: 30,
          data: []
        }, {
          name: 'Montant sortie ',
          type: 'bar',
          barWidth: 30,
          data: []
        }]
      };
      this.statCaisse2.forEach(function (element) {
        optionAllBilanBanque.xAxis[0].data.push(element.date);
        optionAllBilanBanque.series[0].data.push(element.entree);
        optionAllBilanBanque.series[1].data.push(element.sortie);
      });

      var chartAllBilanBanque = echarts.init(document.getElementById('chartAllBilanBanque'));
      chartAllBilanBanque.setOption(optionAllBilanBanque);
    },
    onFileImage1Picked: function onFileImage1Picked(event) {
      var _this3 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this3.image1 = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.file1 = files[0];
    },
    savePieceJointe: function savePieceJointe() {
      var _this4 = this;

      var url = this.domaine + 'caisse/' + this.typeF + '/' + this.optionPaiement.id + '/new/optionPaiement';
      var form = document.getElementById("formPieceJointe");
      var data = new FormData(form);
      data.append('idUser', this.user.id);
      data.append('idPiece', this.optionPaiement.idPiece);

      this.loading = true;

      this.$http.post(url, data).then(function (response) {
        if (response.body) {
          _this4.$notify({
            title: 'ENREGISTREMENT REUSSI',
            message: 'Piece jointe enregistré avec succès.',
            type: 'success',
            position: 'top-center'
          });

          _this4.dialogShowPiece = false;
          _this4.showButtonPiece = false;
          _this4.loading = false;
          _this4.loadRegement(_this4.factureCourant, _this4.typeF),
          // this.loadCaisse()
          _this4.showBanque();

          // this.showCaisse(this.caisseCourant)
          //   this.loadRegement(this.factureCourant, this.typeF)
        }
      }, function (error) {
        _this4.$message.error('Erreur serveur');
        _this4.loading = false;
        _this4.validPaiem = false;
      });
    },

    //enregistrement des images
    onFilepiceJutiPicked: function onFilepiceJutiPicked(event) {
      var _this5 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this5.pieceJusti = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.pieceJusti = files[0];
    },
    showPieceJustifi: function showPieceJustifi(item) {
      this.optionPaiement = item;
      this.dialogShowPiece = true;
      this.showButtonPiece = false;
      this.pieceJusti = item.urlPiece;
    },
    ClearTransfertForm: function ClearTransfertForm() {
      this.dialogAjoutTrans = false;
      this.$refs['transFertForm'].resetFields();
    },
    imprimerFacture: function imprimerFacture(ligne) {
      var url = "";
      if (ligne.type == 1) {
        url = this.domaine + 'fournisseur/' + ligne.idFact + '/' + this.user.id + '/imprimer/facture';
      } else {
        url = this.domaine + 'fournisseur/' + ligne.idFact + '/' + this.user.id + '/imprimer/factureParc';
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    loadFacture: function loadFacture(ligne) {
      var _this6 = this;

      this.loading = true;
      this.caisseCourant = this.detailBanque;
      this.listFacture = [];
      if (this.$refs.formFacture.validate()) {
        var form = document.getElementById('formFacture');
        var data = new FormData(form);
        var url = this.domaine + 'caisse/' + this.caisseCourant.id + '/facture';
        data.append('idUser', this.user.id);
        data.append('fournisseur', this.selectFournisseur);
        data.append('type', this.selectTypeFacture);
        data.append('typeRech', this.typeRech);
        data.append('client', this.selectClient);

        data.append('idDemandeur', this.selectDemandeur);
        data.append('etat', this.selectEtatFacture);
        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this6.listFacture = verif.facture;
              if (_this6.listFacture.length === 0) {
                _this6.$notify({
                  title: 'RESULTATS DE VOTRE RECHERCHE',
                  message: "Aucune facture n'a été trouvée.",
                  type: 'warning',
                  position: 'top-center'
                });
              } else {
                _this6.$notify({
                  title: 'RESULTATS DE VOTRE RECHERCHE',
                  message: _this6.listFacture.length + " facture(s) ont été trouvée(s).",
                  type: 'success',
                  position: 'top-center'
                });
              }
            } else if (verif.code === 2) {
              _this6.$message({
                message: verif.message,
                type: 'warning'
              });
              _this6.loading = false;
            } else if (verif.code === 3) {
              _this6.$message({
                message: verif.message,
                type: 'warning'
              });
              _this6.loading = false;
            } else if (verif.code === 0) {
              _this6.$message.error(verif.message);
              _this6.loading = false;
            }

            _this6.loading = false;
          } else {
            _this6.$message.error('Erreur serveur');
            _this6.loading = false;
          }
        }, function (response) {
          _this6.$message.error('Erreur serveur');
          _this6.loading = false;
        });
      }
    },
    loadRegement: function loadRegement(ligne, type) {
      var _this7 = this;

      this.typeF = type;
      this.factureCourant = ligne;
      this.dialogLoadReglement = true;
      var url = this.domaine + 'caisse/' + this.typeF + '/' + this.factureCourant.idFact + '/index/reglement';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this7.listReglement = response.body.paiement;

          _this7.typeF = response.body.typeF;

          if (response.body.type != 3) // si ce na'est pas un facture de demande de fonds
            {
              _this7.readInput = false;
            } else {
            _this7.montantVerse = response.body.total1;
            _this7.selectEffectue = 1; //"Lui meme"
            _this7.selectMode = 1; //"espece"
            _this7.readInput = true;
          }
          _this7.totalFacture = response.body.total;
          _this7.totalFacture1 = response.body.total1;
          _this7.payeFacture = response.body.paye;
          _this7.payeFacture1 = response.body.paye1;
          _this7.impayeFacture = response.body.impaye;
          _this7.impayeFacture1 = response.body.impaye1;
          _this7.soldeCaisse = response.body.soldeCaisse;
          _this7.dialogAjoutReglement = false;
          _this7.dialogEditReglement = false;
          _this7.dialogEdit = false;
        }
      });
    },
    closeLoadReglement: function closeLoadReglement() {
      this.dialogLoadReglement = false;
      this.dialogAjoutReglement = false;
      this.dialogEditReglement = false;
      this.dialogEdit = false;
    },
    onFileImageLogoPicked: function onFileImageLogoPicked(event) {
      var _this8 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this8.urlImage = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.urlImage = files[0];
    },
    onFileImagePicked: function onFileImagePicked(event) {
      var _this9 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 10485760) {
        this.$message.error("La taille du fichier est supérieur à 10M");
        return;
      }
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this9.urlImage = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.file = files[0];
    },
    submitReglement: function submitReglement() {
      var _this10 = this;

      this.loading = true;

      if (this.montantVerse > 0 && this.montantVerse <= this.impayeFacture1) {
        var etat = false;
        if (this.selectEffectue != "" && this.selectMode != "") {
          if (this.selectEffectue == 2 && this.remettant == '' || this.selectMode != 1 && this.selectMode == 2 && (this.reference == '' || this.selectEncaisse == '')) {
            etat = false;
          } else if (this.selectEffectue == 2 && this.remettant == '' || this.selectMode != 1 && this.selectMode == 3 && this.reference == '') {
            etat = false;
          } else {
            etat = true;
          }
        } else {
          etat = false;
        }

        if (etat == true) {
          if (this.$refs.formReglement.validate()) {
            var form = document.getElementById('formReglement');
            var data = new FormData(form);
            var url = '';
            data.append('idUser', this.user.id);
            data.append('effectue', this.selectEffectue);
            data.append('mode', this.selectMode);
            data.append('encaisse', this.selectEncaisse);
            data.append('urlImage', this.selectEncaisse);

            if (this.reglementCourant.id) {
              url = this.domaine + 'caisse/' + this.reglementCourant.id + '/edit/reglement';
            } else {
              url = this.domaine + 'caisse/' + this.typeF + '/' + this.factureCourant.idFact + '/new/reglement';
            }

            this.$http.post(url, data).then(function (response) {
              if (response.body) {
                var verif = response.body;
                if (verif.code === 1) {
                  if (_this10.reglementCourant.id) {
                    _this10.$notify({
                      title: 'MODIFICATION REUSSI',
                      message: 'Paiement modifié avec succès.',
                      type: 'success',
                      position: 'top-center'
                    });
                  } else {
                    _this10.$notify({
                      title: 'ENREGISTREMENT REUSSI',
                      message: 'Paiement enregistré avec succès.',
                      type: 'success',
                      position: 'top-center'
                    });
                  }
                  // this.closeLoadReglement()
                  _this10.validBanquPaiem = false;
                  _this10.dialogEditReglement = false;
                  _this10.dialogAjoutReglement = false;
                  _this10.$refs.formReglement.reset(), _this10.loadRegement(_this10.factureCourant, _this10.typeF), _this10.loadCaisse();
                  _this10.showBanque();
                  _this10.listFacture = [];
                  // this.resetForme()
                  _this10.loading = false;
                  _this10.dialogEdit = false;
                } else if (verif.code === 0) {
                  _this10.$message.error(verif.message);
                  _this10.loading = false;
                }
              } else {
                _this10.$message.error('Erreur serveur');
                _this10.loading = false;
              }
            }, function (response) {
              _this10.$message.error('Erreur serveur');
              _this10.loading = false;
            });
          } else {
            this.$message.error('Veuillez renseigner les champs obligatoires');
            this.$notify.error({
              title: "ERREUR D'ENREGISTREMENT",
              message: "Le paiement n'a pas été enregistré.",
              position: 'top-center'
            });
            this.loading = false;
          }
        } else {
          this.validBanquPaiem = false;
          this.$message.error('Veuillez renseigner les champs obligatoires');
          this.loading = false;
        }
      } else {
        this.$notify.error({
          title: "ERREUR DU MONTANT",
          message: "Le montant versé ne doit pas etre superieur au montant restant.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    imprimeSearchFacture: function imprimeSearchFacture(item) {

      this.selectFournisseur = this.selectFournisseur != '' ? this.selectFournisseur : "null";
      this.selectTypeFacture = this.selectTypeFacture != '' ? this.selectTypeFacture : "null";
      this.selectEtatFacture = this.selectEtatFacture != '' ? this.selectEtatFacture : "null";
      this.dateFacture = this.dateFacture != '' ? this.dateFacture : "null";

      var url = this.domaine + 'caisse/impression/facture/search/' + item + '/' + this.user.id + '/' + this.selectFournisseur + '/' + this.selectTypeFacture + '/' + this.selectEtatFacture + '/' + this.dateFacture;
      window.open(url);

      this.selectFournisseur = '';
      this.selectTypeFacture = '';
      this.selectEtatFacture = '';
      this.dateFacture = '';
    },
    showReglement: function showReglement(ligne) {
      var _this11 = this;

      this.dialogShowReglement = true;
      this.reglementCourant = ligne;
      var url = this.domaine + 'caisse/' + this.reglementCourant.id + '/show/reglement';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this11.detailReglement = response.body.paiement;
        }
      });
    },
    imprimerReglement: function imprimerReglement(ligne) {
      this.reglementCourant = ligne;
      var url = this.domaine + 'caisse/' + this.reglementCourant.id + '/imprimer/reglement/' + this.user.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    submitValidForm: function submitValidForm(formName) {
      var _this12 = this;

      if (this.image1 != "/static/img-doc.png") {

        this.$refs[formName].validate(function (valid) {
          if (valid) {
            _this12.loading = true;
            var form = document.getElementById("formValidCheq");
            //recuperation des demandes
            var data = new FormData(form);
            var url = _this12.domaine + 'caisse/appro/' + _this12.idBanqueCourant + '/confirm/cheque';

            _this12.$http.post(url, data).then(function (response) {

              if (response.body) {
                var verif = response.body;
                if (verif.code === 5) {
                  _this12.$notify({
                    title: 'FICHIER INVALIDE',
                    message: 'Erreur dans la validation.',
                    type: 'error',
                    position: 'top-center'
                  });
                  _this12.loading = false;
                } else if (verif.code === 2) {

                  //reinitialiser le formulaire
                  var _form = document.getElementById("formValidCheq");
                  _this12.resetForm('formValidCheq');
                  // this.formDemande.detail = ''
                  //reinitialisation des images telecharger
                  _this12.image1 = "/static/img-doc.png";
                  _this12.image2 = "/static/img-doc.png";
                  _this12.image3 = "/static/img-doc.png";
                  _this12.image = "/static/img-doc.png";
                  _this12.file1 = "";
                  _this12.file2 = "";
                  _this12.file3 = "";
                  _this12.loading = false;
                  _this12.successNotif("Validation enregistrée avec succès");
                  _this12.dialogConfirmCheq = false;
                  _this12.$emit('close');
                  // this.$parent.loadListApproDgCheqBanque();
                } else if (verif.code === 0) {

                  _this12.$notify({
                    title: 'MONTANT INSUFFISANT POUR EFFECTUER L\'OPERATION',
                    message: 'Approvisionnement impossible.',
                    type: 'error',
                    position: 'top-center'
                  });
                  _this12.loading = false;
                  _this12.dialogConfirmCheq = false;
                }
              }
            }, function (erreur) {
              //reinitialiser le formulaire
              _this12.resetForm('formValidCheq');
              // this.formDemande.detail = ''
              //reinitialisation des images telecharger
              _this12.image1 = "/static/img-doc.png";
              _this12.image2 = "/static/img-doc.png";
              _this12.image3 = "/static/img-doc.png";
              _this12.image = "/static/img-doc.png";
              _this12.file1 = "";
              _this12.file2 = "";
              _this12.file3 = "";
              _this12.$message.error("Une erreur est survenue lors de l'enregistrement de la validation");
              _this12.dialogConfirmCheq = false;
            });
          }
        });
      } else {

        this.$notify({
          title: 'ECHEC DE LA VALIDATION',
          message: 'Veuillez uploader le chèque.',
          type: 'error',
          position: 'top-center'
        });
      }
    },
    successNotif: function successNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      this.$notify({
        title: 'ENREGISTREMENT REUSSI',
        message: mess,
        type: 'success',
        position: 'top-center'
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.formValidCheq.numCheq = '';
      this.formValidCheq.dateSign = '';
    },
    newReglement: function newReglement(ligne) {

      this.dialogAjoutReglement = true;
      this.dialogEditReglement = false;
      this.urlImage = "/static/doc.png";
      this.file = null;
      this.dialogEdit = false;
      this.montantVerse = 5;
      this.remettant = '';
      this.banque = '';
      this.reference = '';
      this.selectEncaisse = null;
      this.selectEffectue = null;
      this.selectMode = null;
    },
    resetForme: function resetForme() {
      this.urlImage = "/static/doc.png";
      this.file = null;
      // this.dialogEdit = false
      this.montantVerse = 5;
      this.remettant = '';
      this.banque = '';
      this.reference = '';
      this.selectEncaisse = null;
      this.selectEffectue = null;
      this.selectMode = null;
    },
    loadFournisseur: function loadFournisseur() {
      var _this13 = this;

      this.loading = true;
      var url = this.domaine + 'fournisseur/index';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this13.listFournisseur = response.body.fournisseur;
          _this13.loading = false;
        }
      });
    },
    editRegement: function editRegement(ligne) {
      this.loading = false;
      this.urlImage = "/static/doc.png";
      this.file = null;
      this.dialogShowReglement = false;
      this.dialogAjoutReglement = false;
      this.dialogEditReglement = true;
      this.dialogEdit = true;
      this.reglementCourant = ligne;
      this.montantVerse = this.reglementCourant.montant1;
      this.remettant = this.reglementCourant.remettant;
      this.banque = this.reglementCourant.banque;
      this.reference = this.reglementCourant.reference;
      this.selectEncaisse = this.reglementCourant.encaisse;
      this.selectEffectue = this.reglementCourant.effectue;
      this.selectMode = this.reglementCourant.mode;
    },
    showBanque: function showBanque() {
      var _this14 = this;

      // this.dialogModalBanque = true
      // this.dialogShow = true
      // this.caisseCourant = ligne
      this.listFacture = [];
      var url = this.domaine + 'caisse/' + this.detailBanque.id + '/show';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this14.detailCaisse = response.body.caisse;
          _this14.detailBanque = response.body.details;
          _this14.montantSortie = response.body.montantSortie;
          _this14.montantEntree = response.body.montantEntree;
          _this14.montantTvaEntree = response.body.montantTvaEntree;
          _this14.montantTvaSortie = response.body.montantTvaSortie;
          _this14.totalEntree = response.body.totalEntree;
          _this14.totalSortie = response.body.totalSortie;
          _this14.statCaisse2 = response.body.stats1;
          _this14.statAllbilanBanque();
        }
      });
    },
    loadCaisse: function loadCaisse() {
      var _this15 = this;

      this.loading = true;
      var url = "";
      if (this.droitAcces.caisse) {
        //pour l'admin
        url = this.domaine + 'caisse/index';
      } else if (this.droitAcces.caisse_unique_user) {
        //pour celui qui a crée la caisee
        url = this.domaine + 'caisse/unique/' + this.user.id + '/user/index';
      } else {
        url = this.domaine + 'caisse/unique/' + this.user.id + '/index';
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this15.detailCaisseS = response.body.caisse;
          _this15.listCaisse = response.body.caisse;
          _this15.statAllCaisse = response.body.stats;
          // this.statAllbilan()
          _this15.loading = false;
        }
      });
    }
  },

  mounted: function mounted() {
    this.loadFournisseur();
    this.loadCaisse();
    this.statAllbilanBanque();

    //  this.showBanque()
    // this.loadListApproDgCheq()
    // this.statAllbilan()  GENERE DES ERREURS AU CHARGEMENT
  }
});

/***/ }),

/***/ "0cAW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0dNY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "formAjoutFour",
    components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
    props: {
        typeFour: {
            type: Number,
            default: 1 // 1=>particuliers, 0=>Entreprise
        },
        idFour: {
            type: Number,
            default: null
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),

            logoFour: "/static/img-doc.png",
            fileLogo: "",
            etatModif: null,
            dialogAjoutFournisseur: false,
            formFour: {
                nom: "",
                raison: "",
                formJuridique: "",
                registre: "",
                typeFour: "",
                corpsMetier: "",
                civilite: "",
                prenom: "",
                email: "",
                dateNais: "",
                lieuNais: "",
                naturePiece: "",
                numPiece: "",
                dateDeliv: "",
                dateExpir: "",
                contact: "",
                profession: "",
                domicile: "",
                nationalite: "",
                service: "",
                listesFichier: []
            },
            listeTypeFour: [{
                id: 1,
                libelle: "Fournisseur"
            }, {
                id: 2,
                libelle: "Prestataire"
            }],
            listeCivilite: [{
                id: 1,
                libelle: "Monsieur"
            }, {
                id: 2,
                libelle: "Madame"
            }, {
                id: 3,
                libelle: "Mademoiselle"
            }],
            listeNaturePiece: [{
                id: 1,
                libelle: "CNI"
            }, {
                id: 2,
                libelle: "PASSEPORT"
            }, {
                id: 3,
                libelle: "PERMIS DE CONDUIRE"
            }, {
                id: 4,
                libelle: "ATTESTATION"
            }],
            listeCorpsMetier: [],
            loading: false,
            urlFour: "",
            rules: {
                typeFour: [{ required: true, message: 'Veuillez selectionnez un type fournisseur', trigger: 'blur' }],
                corpsMetier: [{ required: true, message: "Veuillez saisir ou selectionnez un corps de métier", trigger: 'blur' }],
                nom: [{ required: true, message: "Veuillez  saisir un nom", trigger: 'blur' }],
                prenom: [{ required: true, message: "Veuillez  saisir un prénom", trigger: 'blur' }],
                // email: [
                //     {type: 'email', required:true, message: "Veuillez  saisir une adresse mail",trigger: 'blur' }
                // ],
                civilite: [{ required: true, message: 'Veuillez selectionnez une civilité', trigger: 'blur' }],
                dateNais: [{ required: true, message: 'Veuillez selectionnez une date', trigger: 'blur' }],
                domicile: [{ required: true, message: 'Veuillez saisir une adresse', trigger: 'blur' }],
                // naturePiece: [
                //     {  required: true, message: 'Veuillez selectionnez votre type de pièce', trigger: 'blur' }
                // ],
                // numPiece: [
                //     {  required: true, message: 'Veuillez saisir le numéro de  la pièce', trigger: 'blur' }
                // ],
                contact: [{ required: true, message: 'Veuillez saisir un contact', trigger: 'blur' }],
                service: [{ required: true, message: 'Veuillez saisir une description', trigger: 'blur' }]
            }
        };
    },

    watch: {
        show: function show(newValue, oldValue) {
            if (newValue == true) {
                this.dialogAjoutFournisseur = true;
                this.resetForm();
                if (this.idFour == null) {
                    this.urlFour = this.domaine + 'fournisseur/create';
                } else {
                    this.urlFour = this.domaine + 'fournisseur/update';
                    this.loadFournisseur();
                }
                this.loadMetier();
            } else {
                this.dialogAjoutFournisseur = false;
            }
        }
    },
    methods: {
        loadFournisseur: function loadFournisseur() {
            var _this = this;

            var url = this.domaine + 'fournisseur/' + this.idFour + '/show';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    var details = response.body.fournisseur;
                    _this.etatModif = 0;
                    _this.formFour = {
                        nom: details.nom,
                        raison: details.raison,
                        formJuridique: details.formJuridique,
                        registre: details.registreComm,
                        registreCommerce: details.registre,
                        typeFour: details.typeFour,
                        corpsMetier: details.metierLibel,
                        civilite: details.civilite,
                        prenom: details.pren,
                        email: details.email,
                        dateNais: details.dateNais,
                        lieuNais: details.lieuNais,
                        naturePiece: details.naturePiece,
                        numPiece: details.numPiece,
                        dateDeliv: details.dateDeliv,
                        dateExpir: details.dateExpir,
                        contact: details.contact,
                        profession: details.profession,
                        domicile: details.domicile,
                        nationalite: details.nationalite,
                        service: details.service,
                        listesFichier: []
                    }, _this.logoFour = details.url;
                    _this.loading = false;
                }
            });
        },

        //  loadFournLimit () {
        //     this.loading = true
        //     let url = this.domaine + 'fournisseur/indexRecent'
        //     this.$http.get(url).then(response => {
        //         if (response.body) {
        //             this.listFour = response.body.fournisseur
        //             this.listFourFinal = response.body.fournisseur
        //             this.statAllFour = response.body.stats
        //             this.comboFournisseur = response.body.combofournisseur
        //             this.statAllFactureFour = response.body.statsFact
        //             this.nbrComAll = response.body.nbrCom
        //             this.nbrFactAll = response.body.nbrFact
        //             this.nbrLivrAll = response.body.nbrLivr
        //             this.depenseAll = response.body.coutTotal
        //             this.loading = false
        //         }
        //     })
        // },

        loadMetier: function loadMetier() {
            var _this2 = this;

            if (this.listeCorpsMetier.length > 0) {
                return;
            }
            var urlMetier = this.domaine + "fournisseur/liste/metier";
            this.$http.get(urlMetier).then(function (resp) {
                _this2.listeCorpsMetier = resp.body.listeMetier;
            }, function (error) {
                _this2.loading = false;
                _this2.$message.error("Une erreur est survenue lors de la recherche du corps de métier");
            });
        },
        saveForm: function saveForm() {
            var _this3 = this;

            this.$refs["formFour"].validate(function (valid) {

                if (valid) {
                    _this3.loading = true;
                    var form = document.getElementById('formFour');
                    var data = new FormData(form);
                    data.append('dataFour', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.formFour));
                    data.append('idUser', _this3.user.id);
                    data.append('idFour', _this3.idFour);
                    data.append('typeParEntr', _this3.typeFour);
                    _this3.$http.post(_this3.urlFour, data).then(function (response) {
                        _this3.loading = false;
                        if (response.body.code == 5) {
                            _this3.$alert(response.body.message, 'ENREGISTREMENT', {
                                confirmButtonText: 'OK',
                                callback: function callback(action) {
                                    _this3.closeForm();
                                }
                            });
                            return;
                        } else {
                            _this3.$alert(response.body.message, "ENREGISTREMENT", {
                                confirmButtonText: 'OK',
                                callback: function callback(action) {}
                            });
                            return;
                        }
                    }, function (error) {
                        _this3.loading = false;
                        _this3.$message.error("Une erreur est survenue lors de l'enregistrement du fournisseur");
                    });
                }
            });
        },
        resetForm: function resetForm() {
            this.logoFour = "/static/img-doc.png";
            this.formFour.formJuridique = "";
            this.formFour.registre = "";
            this.formFour.raison = "";
            this.formFour.typeFour = "";
            this.$refs["formFour"].resetFields();
        },
        closeForm: function closeForm() {
            //this.dialogAjoutFournisseur = false;
            this.$emit("close");
            this.resetForm();
        },

        //enregistrement des images
        onFileImageLogoPicked: function onFileImageLogoPicked(event) {
            var _this4 = this;

            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }
            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this4.logoFour = fileReader.result;
            });
            fileReader.readAsDataURL(files[0]);
            this.logoFour = files[0];
        }
    }
});

/***/ }),

/***/ "0iXz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardTravaux_vue__ = __webpack_require__("PPX5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8c3f288_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardTravaux_vue__ = __webpack_require__("/SGm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardTravaux_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8c3f288_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardTravaux_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0onN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_infoOuvrier_vue__ = __webpack_require__("UH4A");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8543fe0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_infoOuvrier_vue__ = __webpack_require__("hZT5");
function injectStyle (ssrContext) {
  __webpack_require__("0cAW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e8543fe0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_infoOuvrier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8543fe0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_infoOuvrier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0ygq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationMiss_vue__ = __webpack_require__("HpCd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b58b44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationMiss_vue__ = __webpack_require__("pZwn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationMiss_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b58b44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationMiss_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "12HE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_boardChantier_loadBudget_vue__ = __webpack_require__("mlun");



var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//function de difference de date

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Oq2I");
__webpack_require__("miEh");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3__components_Loading__["a" /* default */],
    LoadTypeBudgetExcel: __WEBPACK_IMPORTED_MODULE_4__components_boardChantier_loadBudget_vue__["a" /* default */]
  },
  props: {
    typeEtat: {
      type: Boolean
    },
    show: {
      type: Boolean
    },
    typeTrx: {
      type: Object
    },
    idChant: {
      type: Number
    }
  },
  name: "AjoutPrevisionBudgetChantier",
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,

      //VARIABLE
      dialogAjoutBudget: false,
      dialogImport: false,
      IdTypeSelct: "",
      formBudget: {
        dateMoisAn: null,
        unite: null,
        ressource: "",
        libelle: "",
        tache: "",
        valeurCodeGestion: '',
        valeurCodeAnalytique: '',
        qte: "",
        prix: "",
        montant: 5
      },
      rulesBudget: {
        // dateMoisAn: [{ required: true, message: "Veuillez selectionner" }],
        libelle: [{ required: true, message: "Veuillez selectionner" }],
        ressource: [{ required: true, message: "Veuillez selectionner" }],
        qte: [{ required: true, message: "Veuillez selectionner" }],
        prix: [{ required: true, message: "Veuillez selectionner" }]
      },
      datePickerRtp: {},
      valeurUniteMateriel: "",
      valeurCodeAnalytique: "",
      valeurCodeGestion: "",
      montantTotal: 0,
      showModalLoadBudget: false,

      //Importer fichier excel
      fileExcel: [],
      lstBudget: [],
      listaches: [],
      listeBudgetSupp: [],

      listeProduitBudget: [],
      listeProduitAffich: [],
      listProduit: [],
      tableBudget: [],
      tableDate: [],
      tableOptTrav: [],
      listTypeRessource: [],
      labelPosition: "top"
    };
  },

  computed: {
    verifFormBudget: function verifFormBudget() {
      console.log("typeEtat", this.typeEtat);
      if (this.typeEtat) {
        return true;
      } else {
        if (
        // this.formBudget.dateMoisAn != null &&
        this.formBudget.tache != "" && this.formBudget.qte != "" && this.formBudget.ressource != "" && this.formBudget.prix != "" && this.formBudget.tache != "") {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  watch: {
    show: function show(newValue, oldValue) {
      var _this2 = this;

      console.log('newValue', newValue, this.typeTrx);

      if (newValue == true) {
        var _this = this;
        this.listeBudgetSupp = [];
        _this.loadListeTravaux();
        this.tableBudget.splice(0);
        var detailBudget = this.typeTrx.detailBudget ? this.typeTrx.detailBudget : [];
        this.listaches = this.typeTrx.taches;
        console.log('detailBudget', detailBudget);
        this.tableOptTrav = detailBudget;
        if (detailBudget.length > 0) {
          detailBudget.forEach(function (item) {
            console.log('item ic', item);
            _this2.tableBudget.push(item);
          });
        }

        this.dialogAjoutBudget = true;
        // this.loadTypeRessource();
        // this.loadProduitBudget();
        this.loadProduit();
        this.formBudget = {
          libelle: "",
          qte: 0,
          prix: 0,
          total: 0,
          ressource: "",
          tache: ""
        };
      } else {
        this.dialogAjoutBudget = false;
      }
    }
  },
  methods: (_methods = {
    resetForm: function resetForm() {
      this.$refs["formBudget"].resetFields();
    },
    loadTypeBudeget: function loadTypeBudeget() {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + "budgetChantier/tache/" + this.formBudget.tache.id + "/" + this.typeTrx.sous + "/" + this.idChant + '/' + this.typeTrx.idTravaux;
      this.$http.get(url).then(function (response) {
        _this3.tableBudget = response.body.taches["detail"] ? response.body.taches["detail"] : [];
        _this3.tableDate = response.body.taches;
        _this3.tableOptTrav = response.body.optTravaux;
        _this3.loading = false;
      }, function (errRep) {
        _this3.loading = false;
      });
    },
    loadTypeRessource: function loadTypeRessource() {
      var _this4 = this;

      var url = this.domaine + "product/typeRessource";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this4.listTypeRessource = response.body.types;
          _this4.loading = false;
        }
      });
    },
    deleteRow: function deleteRow(index, rows) {
      // enregistrer lid du lot de travaux supprimer dans la liste
      this.listeBudgetSupp.push(this.tableBudget[index]);
      rows.splice(index, 1);
    },
    calculMontant: function calculMontant(item) {
      console.log('item', item);
      var prix = item.prix ? item.prix : 0;
      var qte = item.qte ? item.qte : 0;
      var calcul = qte * prix;

      this.montantTotal = calcul;

      console.log('montantTotal', this.montantTotal);
    },
    loadUniteProduit: function loadUniteProduit(item) {
      this.valeurUniteMateriel = '';
      this.valeurTypeUniteMateriel = '';
      this.valeurCodeAnalytique = '';
      this.valeurCodeGestion = '';
      this.codegestion = item.codeGestion;
      this.valeurTypeUniteMateriel = item.type;
      this.valeurUniteMateriel = item.unite;
      this.valeurCodeAnalytique = item.codeAnalytique;
      this.valeurCodeGestion = item.codeGestion;
      this.formBudget.prix = item.valeur;
    },
    loadTypeProduit: function loadTypeProduit() {
      var _this5 = this;

      this.loading = true;
      this.listeProduitBudget = [];
      if (this.formBudget.ressource != 0) {
        var url = this.domaine + "product/productSelect/type/" + this.formBudget.ressource;
        this.$http.get(url).then(function (response) {
          _this5.loading = false;
          _this5.listeProduitBudget = response.body.produits;
          _this5.listeProduitAffich = response.body.produits;
        }, function (errRep) {
          _this5.loading = false;
          _this5.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
        });
      } else {
        this.loadProduitBudget();
        this.loading = false;
      }
    },
    loadProduit: function loadProduit() {
      var _this6 = this;

      var url = "";
      this.loading = true;
      url = this.domaine + "product/product-list";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this6.loading = false;
          _this6.listProduit = response.body;
          _this6.listeProduitAffich = response.body;
        }
      });
    },
    loadListeTravaux: function loadListeTravaux() {
      var _this7 = this;

      this.loading = true;
      var url = this.domaine + "budgetChantier/chantier/" + this.idChant;
      this.$http.get(url).then(function (resp) {
        _this7.loading = false;
        _this7.tableListeTrxBudget = resp.body.listeTypeTrx;
        _this7.totalMntPropose = resp.body.totalMntPropose;
        _this7.totalMntValide = resp.body.totalMntValide;
        _this7.totalTravauxEnAttente = resp.body.totalTravauxEnAttente;
      }, function (error) {
        _this7.loading = false;
        _this7.$message.error("Une erreur est survenue lors du chargement de la liste travaux du module compte exploitation");
      });
    },
    closeFormTypeProduit: function closeFormTypeProduit() {
      this.showModalLoadBudget = false;
      this.loadProduitBudget();
    },
    handleFileExcel: function handleFileExcel(command //0=>Importer,1=>generer
    ) {
      switch (command) {
        case "0":
          //importer un fichier
          this.$refs.fileInputExcel.click();
          break;
        case "1":
          //generer un modele un fichier
          this.generateFileExcel();
          break;
        default:
          this.$refs.fileInputExcel.click();
          break;
      }
    },
    generateFileExcel: function generateFileExcel() {
      this.dialogImport = false;
      var url = this.domaine + "projet/generer/budget/modele";
      window.open(url);
    },
    onFileExcelPicked: function onFileExcelPicked(event) {
      var _this8 = this;

      this.fileExcel.splice(0, 1);
      // this.showModalLoadBudget = true;
      // this.dialogAjoutBudget = false;
      this.loading = true;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this8.fileExcel.push(fileReader.result);
      });
      fileReader.readAsDataURL(files[0]);

      var url = this.domaine + "projet/loadBudget/excel";
      var data = new FormData();
      data.append("fichierExcel", files[0], files[0][name]);
      this.$http.post(url, data).then(function (resp) {
        _this8.loading = false;
        _this8.$notify({
          title: "Chargement liste des budgets",
          message: "Chargement effectué",
          type: "success",
          position: "top-right",
          duration: 7000
        });
        _this8.tableBudget = resp.body.listeTypeTravaux;
        console.log('this.tableBudget', _this8.tableBudget);
        // this.showModalLoadBudget = true;
      }, function (error) {
        _this8.loading = false;
        _this8.$message.error("Erreur lors de l'importation du fichier");
      });
    },
    loadProduitBudget: function loadProduitBudget() {
      var _this9 = this;

      this.loading = true;
      var url = this.domaine + "budgetProjet/liste";

      this.listeProduitBudget.splice(0);
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this9.loading = false;
          _this9.listeProduitBudget = response.body.produits;
        }
      }, function (response) {
        _this9.loading = false;
      });
    },
    addListBudget: function addListBudget(item) {
      console.log('item', item);
      console.log('ressource', this.formBudget.ressource);
      var produit = this.formBudget.ressource;
      //verifier si l'item n'et pas deja enregistrer dans le tableau
      if (this.tableBudget.length > 0) {
        var eltProd = this.tableBudget.find(function (elt) {
          return elt.idProd == produit.idprod;
        });
        if (eltProd != null) {
          this.$message.error("Cette ressource a déjà été ajouté à la liste");
          return;
        }
      }
      console.log('item', item);
      this.tableBudget.push({
        libelle: item.tache.libelle,
        codeAnalytique: this.valeurCodeAnalytique,
        codeGestion: this.valeurCodeGestion,
        idTache: item.tache.id,
        idProd: produit.idprod,
        ressource: item.ressource.value,
        prix: item.prix,
        qte: item.qte,
        montant: this.montantTotal,
        unite: item.ressource.unite
        // dateMoisAn: item.dateMoisAn
      });
      this.valeurUniteMateriel = "";
      this.valeurCodeAnalytique = '';
      this.valeurCodeGestion = '';
      this.montantTotal = 0;
      this.formBudget.libelle = "";
      this.formBudget.qte = 0;
      this.formBudget.prix = 0;
      this.formBudget.montant = 0;
      this.formBudget.ressource = "";
      this.formBudget.unite = "";
      this.formBudget.dateMoisAn = "";
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "resetForm", function resetForm(formName) {
    this.$refs[formName].resetFields();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "headerRowStyle", function headerRowStyle(_ref) {
    var row = _ref.row,
        rowIndex = _ref.rowIndex;

    return { color: "black" };
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "format", function format(percentage) {
    return percentage + "%";
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getSumm", function getSumm(param) {
    var columns = param.columns,
        data = param.data;

    var sums = [];
    columns.forEach(function (column, index) {
      if (index === 0) {
        sums[index] = "Sous total";
        return;
      }

      if (index === 4) {
        sums[index] = "N/A";
        return;
      }
      var values = data.map(function (item) {
        return Number(item[column.property]);
      });
      if (!values.every(function (value) {
        return isNaN(value);
      })) {
        sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
          var value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0));
      } else {
        sums[index] = "N/A";
      }
    });

    return sums;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "closeDialog", function closeDialog() {
    this.$emit("close");
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "createBudget", function createBudget() {
    var _this10 = this;

    this.loading = true;
    var url = this.domaine + "budgetChantier/create/" + this.idChant;
    var nbData = 10;
    var nbReq = 1;
    var ligne = null;
    var nbRest = void 0;
    if (this.tableBudget.length > 10) {
      nbData = 10;
      nbReq = Math.round(this.tableBudget.length / nbData);
      nbRest = this.tableBudget.length % nbData;
      if (nbRest > 0) {
        nbReq += 1;
      }
    }

    for (var i = 0; i < nbReq; i++) {
      var initJ = i * nbData;
      var finJ = (i + 1) * nbData;
      var dataLot = [];
      if (this.tableBudget.length > 0) {
        for (var j = initJ; j < finJ; j++) {
          if (this.tableBudget[j] == undefined) {
            break;
          }
          dataLot.push(this.tableBudget[j]);
        }
      }
      var data = new FormData();

      for (var prop in dataLot) {
        ligne = dataLot[prop];
        console.log('ligne', ligne);
        data.append("option[annee][]", ligne.dateMoisAn);
        data.append("option[libelle][]", ligne.libelle);
        data.append("option[unite][]", ligne.unite);

        data.append("option[tacheId][]", ligne.idTache);
        data.append("option[idProd][]", ligne.idProd);
        data.append("option[ressource][]", ligne.ressource);
        data.append("option[qte][]", ligne.qte);
        data.append("option[prix][]", ligne.prix);
        data.append("option[montant][]", ligne.montant);
      }

      data.append("listBudget", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.listeBudgetSupp));
      data.append("typeTravauxId", this.typeTrx.id);
      console.log('data', this.formBudget.tache.id);
      data.append("tacheId", this.typeEtat ? this.typeTrx.id : this.formBudget.tache.id);
      data.append("idTravaux", this.typeTrx.idTravaux);
      data.append("optTravaux", this.tableOptTrav);
      data.append("typeDtravaux", this.tableOptTrav);
      data.append("etatModif", this.typeEtat);
      // data.append("dateD", this.typeTrx.dateD);
      // data.append("dateF", this.typeTrx.dateF);

      data.append("userId", this.user.id);
      data.append("nbSous", this.typeTrx.sous);

      this.$http.post(url, data).then(function (resp) {
        // this.$message.error("Veuillez patienter, cette fonctionnalité sera fonctionnelle dans quelques instants.");
        _this10.closeDialog();
        _this10.tableBudget.splice(0);
        _this10.loading = false;
        _this10.$notify({
          title: "Budget",
          message: "Budget enregistre avec succes",
          type: "success",
          position: "top-right",
          duration: 7000
        });
      }, function (error) {
        _this10.loading = false;
        _this10.$message.error("Erreur lors de l'enregistrement des budjets");
      });
    }
  }), _methods),

  mounted: function mounted() {}
});

/***/ }),

/***/ "12V6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadTarifiFourn_vue__ = __webpack_require__("OwC2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae87e88e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadTarifiFourn_vue__ = __webpack_require__("34zc");
function injectStyle (ssrContext) {
  __webpack_require__("lzUs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae87e88e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadTarifiFourn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae87e88e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadTarifiFourn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "13ay":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":"","mt-2":"","mb-2":"","mr-2":"","ml-2":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"purple darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('div',[_c('div',[_vm._v("Taux exécution chronogramme (%)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('div',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.tauxExec))])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":"","mt-2":"","mb-2":"","mr-2":"","ml-2":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"orange darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.nbTrxTermine))]),_vm._v(" "),_c('div',[_vm._v("Travaux Terminés")])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.nbTrxArret))]),_vm._v(" "),_c('div',[_vm._v("Travaux Arretés")])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.nbTrxEnCours))]),_vm._v(" "),_c('div',[_vm._v("Travaux (en cours)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_vm._v("Total travaux")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.nbTrx))])])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1V8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","xs12":""}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"100%"},model:{value:(_vm.dialogAjoutConducteur),callback:function ($$v) {_vm.dialogAjoutConducteur=$$v},expression:"dialogAjoutConducteur"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter des ressources ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeTypeTravaux}},[_c('el-table-column',{attrs:{"prop":"type","label":"Type ressource","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.type)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"codeAnalytique","label":"Code analytique","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.codeAnalytique)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"codeGestion","label":"Code gestion","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.codeGestion)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"reference","label":"Référence","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.reference)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.libelle)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"valeur","label":"Prix de vente (FCFA)","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(new Intl.NumberFormat("fr-FR").format(scope.row.valeur))+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.unite)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"Description","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.description)+"\n                  ")])]}}])})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"orange","dark":""},on:{"click":function($event){return _vm.closeDialog()}},slot:"activator"},[_vm._v("Anuller "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"green","dark":""},on:{"click":function($event){return _vm.saveListe()}},slot:"activator"},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1VJv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_divers_formTypeProjet__ = __webpack_require__("l7SS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_divers_formNiveauTypeTravaux__ = __webpack_require__("OT9U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_divers_formTypeTravaux__ = __webpack_require__("NPGg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_divers_formdupplication_dupformTypeTravaux__ = __webpack_require__("YFcr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_divers_formdupplication_dupformTypeTache__ = __webpack_require__("Rb7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_divers_formTypeTache__ = __webpack_require__("8pPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_divers_loadTypeproduit_vue__ = __webpack_require__("wthK");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Vb+l");










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */],
    formTypeProjet: __WEBPACK_IMPORTED_MODULE_3__components_divers_formTypeProjet__["a" /* default */],
    formTypeTravaux: __WEBPACK_IMPORTED_MODULE_5__components_divers_formTypeTravaux__["a" /* default */],
    formNiveauTypeTravaux: __WEBPACK_IMPORTED_MODULE_4__components_divers_formNiveauTypeTravaux__["a" /* default */],
    dupformTypeTravaux: __WEBPACK_IMPORTED_MODULE_6__components_divers_formdupplication_dupformTypeTravaux__["a" /* default */],
    dupformTypeTache: __WEBPACK_IMPORTED_MODULE_7__components_divers_formdupplication_dupformTypeTache__["a" /* default */],
    formTypeTache: __WEBPACK_IMPORTED_MODULE_8__components_divers_formTypeTache__["a" /* default */],
    LoadTypeProduitExcel: __WEBPACK_IMPORTED_MODULE_9__components_divers_loadTypeproduit_vue__["a" /* default */]
  },
  name: "app",
  data: function data() {
    var _ref;

    return _ref = {
      loading: false,
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      items: [{ path: "/", text: "Accueil", disabled: false }, { path: "/keywords", text: "Gestion des mots clés", disabled: true }],
      rules: {
        code: [{ required: true, message: "Veuillez  saisir un code", trigger: 'blur' }],
        libelle: [{ required: true, message: "Veuillez  saisir un libelle", trigger: 'blur' }],
        description: [{ required: false, message: "Veuillez  saisir une description", trigger: 'blur' }]
      },
      formTypeProj: {
        id: "",
        libelle: "",
        description: ""
      },
      columns: [{
        prop: "libelle",
        label: "Libellé lot"
      }, {
        prop: "ordre",
        label: "Ordre d'éxécution"
      }, {
        prop: "code",
        label: "Code"
      }, {
        prop: "description",
        label: "Description"
      }],
      listeRapportTrx: {
        type: Array
      },

      taches: [{
        prop: "libelle",
        label: "Libellé tâche"
      }, {
        prop: "ordre",
        label: "Ordre d'éxécution"
      }, {
        prop: "unite",
        label: "Unité"
      }, {
        prop: "prix",
        label: "Prix unitaire HT (FCFA)"
      }, {
        prop: "description",
        label: "Description"
      }],
      tachesTypeProduit: [{
        prop: "codeGestion",
        label: "Code article"
      }, {
        prop: "codeAnalytique",
        label: "Code analytique"
      }, {
        prop: "referenceProduit",
        label: "Référence"
      }, {
        prop: "libelleProduit",
        label: "Libellé"
      }, {
        prop: "valeurProduit",
        label: "Prix de (vente ou d'utilisation)(Fcfa)"
      }, {
        prop: "libelleUnite",
        label: "Unité"
      }, {
        prop: "descProduit",
        label: "Description"
      }],

      valid: true,

      dialogAjoutTypeRessource: false,
      dialogAjoutTache: false,
      dialogAjoutTravaux: false,
      dialogDupliquerTravaux: false,
      dialogAjoutProduit: false,
      dialogAjoutCategory: false,
      dialogSuprCategorie: false,
      dialogSuprKeyword: false,
      dialogEdit: false,
      dialogMofifTravaux: false,
      dialogEditCategorie: false,
      dialogShowTypeProjet: false,
      dialogShowCategorie: false,
      dialogShowTache: false,
      dialogEditProduit: false,
      dialogShowProduit: false,

      dialogSuprLexique: false,
      dialogShowTravaux: false,
      idProduit: "",
      idCategorie: "",
      idLexique: "",
      libelleProduit: "",
      libelleUnite: "Pcs",
      descProduit: "",
      typeProduit: "",
      codeType: '',
      valeurProduit: 0,
      ordre: 1,
      dialogTarif: false,
      dialogConfirm: false,
      referenceProduit: "",
      libelleCategorie: "",
      descCategorie: "",
      currentCategorie: {},
      currentProduit: {},
      categorie: "",
      itemsTypeProjet: [],
      itemsTravaux: [],
      itemsProduit: [],
      itemsTypeProduit: [],
      itemsTaches: [],
      categorieEdit: "",
      listCategorie: [],
      tableLots: [],
      tableTaches: [],
      tableTypeProduit: [],
      listeType: [],
      listeChantier: [],
      tableLotsNEW: [],
      tab: 0,
      tab1: 0,
      listProduit: [],
      IdProduiSelect: "",
      selectSearchTypeProjet: "",
      selectSearchTypeRessource: "",
      selectSearchTravaux: "",
      selectSearchProduit: "",
      selectSearchTypeProduit: "",
      selectSearchTache: "",
      listLexique: [],
      selectTypeEntre: "",
      dialogSupTarif: '',
      listTypeProjet: [],
      listTypeRessource: [],

      typeProjetCourant: [],
      typeRessourceCourant: [],
      dialogShowTypeRessource: false,
      detailTypeProjet: [],
      formTache: {
        id: "",
        libelle: "",
        ordre: 1,
        unite: "",
        prix: 0,
        description: ""
      },
      formTypeProduit: {
        id: "",
        referenceProduit: "",
        codeAnalytique: "",
        libelleProduit: "",
        valeurProduit: "",
        libelleUnite: 0,
        descProduit: ""
      },
      listTache: [],
      tacheCourant: [],
      detailTache: [],
      dialogSuprTyp: false,
      dialogSuprLots: false,
      dialogSuprTache: false,
      dialogSuprProd: false,
      //FILTRE
      listeProjet: []
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listeChantier', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'BesoinsList', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listeProduitAffich', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'projetS', ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'IdTypeSelct', ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'chantierS', ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'produitCourant', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listTravaux', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'typeProjet', ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'travaux', ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listAllTravaux', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'formTravaux', {
      id: "",
      libelle: "",
      ordre: "",
      code: "",
      description: ""
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'travauxCourant', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listeProduitFourn', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listeCommandeFourn', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listeStatistik', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listeStokProd', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listeStokEnlev', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'detailProjet', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showDialogTypeProjet', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showDialogTypeTrx', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'typeProjetSelect', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showDialogTypeRessource', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showDialogTypeNiveauTrx', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showDialogDupTypeProjet', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showDialogDupTypeTrx', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'typeDupProjetSelect', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listTypProjetTab', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'libelleSelect', ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selecAnne', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'totalCommande', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'totalQteCommande', 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listeTache', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listeTacheTravaux', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listTypProjetTabAll', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'idTypeTravauxSelect', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'etatTache', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showDialogDupTypeTache', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'libelleTacheSelect', ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'libelleChantier', ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'codeGestion', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listcodeGestion', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'typeDescription', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'typeLibelle', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'typeCode', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'editedTypeRessource', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listeTrx', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listeProjetTravaux', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'idTypeProjetSelect', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'idNivTypeProjetSelect', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listeTache', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listeTacheTravaux', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showDialogTypeTache', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'prixAchat', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectProduit', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectIdProduit', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'valeurUniteMateriel', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tarifCourant', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showModalLoadTypeTravaux', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'fileExcel', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'lstTypeTravaux', []), _ref;
  },

  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      if (newValue == true) {
        //this.oldListTravaux = this.listeTrx;
      }
    }
  },
  methods: {
    statPrixFourn: function statPrixFourn(dataFactHistoFour) {
      var posList = ['left', 'right', 'top', 'bottom', 'inside', 'insideTop', 'insideLeft', 'insideRight', 'insideBottom', 'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'];

      app.configParameters = {
        rotate: {
          min: -90,
          max: 90
        },
        align: {
          options: {
            left: 'left',
            center: 'center',
            right: 'right'
          }
        },
        verticalAlign: {
          options: {
            top: 'top',
            middle: 'middle',
            bottom: 'bottom'
          }
        },
        position: {
          options: echarts.util.reduce(posList, function (map, pos) {
            map[pos] = pos;
            return map;
          }, {})
        },
        distance: {
          min: 0,
          max: 100
        }
      };

      app.config = {
        rotate: 90,
        align: 'left',
        verticalAlign: 'middle',
        position: 'insideBottom',
        distance: 15,
        onChange: function onChange() {
          var labelOption = {
            normal: {
              rotate: app.config.rotate,
              align: app.config.align,
              verticalAlign: app.config.verticalAlign,
              position: app.config.position,
              distance: app.config.distance
            }
          };
          myChart.setOption({
            series: [{
              label: labelOption
            }, {
              label: labelOption
            }, {
              label: labelOption
            }]
          });
        }
      };

      var labelOption = {
        show: true,
        position: app.config.position,
        distance: app.config.distance,
        align: app.config.align,
        verticalAlign: app.config.verticalAlign,
        rotate: app.config.rotate,
        formatter: '{c}  {name|{a}}',
        fontSize: 16,
        rich: {
          name: {
            textBorderColor: '#fff'
          }
        }
      };

      var option = {
        color: ['#388E3C', '#F57C00', '#455A64', '#C62828'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: [{
          type: 'category',
          axisTick: { show: false },
          data: []
        }],
        yAxis: [{
          type: 'value'
        }],
        series: [{
          name: 'Prix actuel',
          type: 'bar',
          barGap: 0,
          label: labelOption,
          data: []
        }, {
          name: 'Ancien prix',
          type: 'bar',
          label: labelOption,
          data: []
        }]
      }; //option

      for (var datahis in dataFactHistoFour) {
        option.xAxis[0].data.push(datahis);
        var series = dataFactHistoFour[datahis];
        option.series[0].data.push(series["prix actuel"]);
        option.series[1].data.push(series["ancien prix"]);
      }

      var chartFactureAnFour = echarts.init(document.getElementById('chartFactureAnFour'));
      chartFactureAnFour.setOption(option);
    },
    statComRessour: function statComRessour(dataFactHistoFour) {
      var posList = ['left', 'right', 'top', 'bottom', 'inside', 'insideTop', 'insideLeft', 'insideRight', 'insideBottom', 'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'];

      app.configParameters = {
        rotate: {
          min: -90,
          max: 90
        },
        align: {
          options: {
            left: 'left',
            center: 'center',
            right: 'right'
          }
        },
        verticalAlign: {
          options: {
            top: 'top',
            middle: 'middle',
            bottom: 'bottom'
          }
        },
        position: {
          options: echarts.util.reduce(posList, function (map, pos) {
            map[pos] = pos;
            return map;
          }, {})
        },
        distance: {
          min: 0,
          max: 100
        }
      };

      app.config = {
        rotate: 90,
        align: 'left',
        verticalAlign: 'middle',
        position: 'insideBottom',
        distance: 15,
        onChange: function onChange() {
          var labelOption = {
            normal: {
              rotate: app.config.rotate,
              align: app.config.align,
              verticalAlign: app.config.verticalAlign,
              position: app.config.position,
              distance: app.config.distance
            }
          };
          myChart.setOption({
            series: [{
              label: labelOption
            }, {
              label: labelOption
            }, {
              label: labelOption
            }]
          });
        }
      };

      var labelOption = {
        show: true,
        position: app.config.position,
        distance: app.config.distance,
        align: app.config.align,
        verticalAlign: app.config.verticalAlign,
        rotate: app.config.rotate,
        formatter: '{c}  {name|{a}}',
        fontSize: 16,
        rich: {
          name: {
            textBorderColor: '#fff'
          }
        }
      };

      var option = {
        color: ['#388E3C', '#F57C00', '#455A64', '#C62828'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: [{
          type: 'category',
          axisTick: { show: false },
          data: []
        }],
        yAxis: [{
          type: 'value'
        }],
        series: [{
          name: 'Qte commandée',
          type: 'bar',
          barGap: 0,
          label: labelOption,
          data: []
        }, {
          name: 'Prix',
          type: 'bar',
          label: labelOption,
          data: []
        }, {
          name: 'Total TTC',
          type: 'bar',
          label: labelOption,
          data: []
        }]
      }; //option

      for (var datahis in dataFactHistoFour) {
        option.xAxis[0].data.push(datahis);
        var series = dataFactHistoFour[datahis];
        option.series[0].data.push(series["Qte commandée"]);
        option.series[1].data.push(series["Prix"]);
        option.series[2].data.push(series["Total TTC"]);
      }

      var chartCommFour = echarts.init(document.getElementById('chartCommFour'));
      chartCommFour.setOption(option);
    },
    statEntrepot: function statEntrepot(dataFactHistoFour) {
      var posList = ['left', 'right', 'top', 'bottom', 'inside', 'insideTop', 'insideLeft', 'insideRight', 'insideBottom', 'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'];

      app.configParameters = {
        rotate: {
          min: -90,
          max: 90
        },
        align: {
          options: {
            left: 'left',
            center: 'center',
            right: 'right'
          }
        },
        verticalAlign: {
          options: {
            top: 'top',
            middle: 'middle',
            bottom: 'bottom'
          }
        },
        position: {
          options: echarts.util.reduce(posList, function (map, pos) {
            map[pos] = pos;
            return map;
          }, {})
        },
        distance: {
          min: 0,
          max: 100
        }
      };

      app.config = {
        rotate: 90,
        align: 'left',
        verticalAlign: 'middle',
        position: 'insideBottom',
        distance: 15,
        onChange: function onChange() {
          var labelOption = {
            normal: {
              rotate: app.config.rotate,
              align: app.config.align,
              verticalAlign: app.config.verticalAlign,
              position: app.config.position,
              distance: app.config.distance
            }
          };
          myChart.setOption({
            series: [{
              label: labelOption
            }, {
              label: labelOption
            }, {
              label: labelOption
            }, {
              label: labelOption
            }]
          });
        }
      };

      var labelOption = {
        show: true,
        position: app.config.position,
        distance: app.config.distance,
        align: app.config.align,
        verticalAlign: app.config.verticalAlign,
        rotate: app.config.rotate,
        formatter: '{c}  {name|{a}}',
        fontSize: 16,
        rich: {
          name: {
            textBorderColor: '#fff'
          }
        }
      };

      var option = {
        color: ['#388E3C', '#F57C00', '#455A64', '#C62828'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center',
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: [{
          type: 'category',
          axisTick: { show: false },
          data: []
        }],
        yAxis: [{
          type: 'value'
        }],
        series: [{
          name: 'appro',
          type: 'bar',
          barGap: 0,
          label: labelOption,
          data: []
        }, {
          name: 'stock',
          type: 'bar',
          label: labelOption,
          data: []
        }, {
          name: 'sortie',
          type: 'bar',
          label: labelOption,
          data: []
        }, {
          name: 'retour',
          type: 'bar',
          label: labelOption,
          data: []
        }]
      }; //option

      for (var datahis in dataFactHistoFour) {
        option.xAxis[0].data.push(datahis);
        var series = dataFactHistoFour[datahis];
        option.series[0].data.push(series["appro"]);
        option.series[1].data.push(series["stock"]);
        option.series[2].data.push(series["sortie"]);
        option.series[3].data.push(series["retour"]);
      }

      var chartStockProd = echarts.init(document.getElementById('chartStockProd'));
      chartStockProd.setOption(option);
    },
    handleTabClick1: function handleTabClick1(onglet) {
      switch (onglet) {
        case "0":
          //TYPE PROJET
          this.loadTypeProjet();
          break;
        case "1":
          //TYPE LOT DE TRAVAUX
          this.loadTravauxParType();
          break;
        case "2":
          //TYPE LOT DE TACHE
          this.loadTacheParTypeTrx();
          break;
        case "3":
          //TYPE DE RESSOURCE
          this.loadTypeRessource();
          break;
        case "4":
          //TYPE DE PORDUIT
          this.loadProduit();
          break;
      }
    },
    TabClick: function TabClick(onglet) {
      switch (onglet) {
        case "0":
          //PRIX FOURNISSEUR
          this.loadProdFourn();
          break;
        case "1":
          //LISTE COMMANDE
          this.loadCommandFourn();
          break;
        case "2":
          //LISTE STOCK et ENLEVEMENT
          this.loadStockFourn();
          break;
        case "3":
          //LISTE STATISTIQUE
          var ladate = new Date();
          this.loadStatistique(ladate);
          break;

      }
    },
    loadProdFourn: function loadProdFourn() {
      var _this = this;

      var url = "";
      this.loading = true;
      url = this.domaine + "product/fournisseur/product-list/" + this.currentProduit.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this.loading = false;
          _this.listeProduitFourn = response.body.produit;
          _this.statPrixFourn(response.body.dataStat);
        }
      }, function (error) {
        _this.loading = false;
      });
    },
    loadCommandFourn: function loadCommandFourn() {
      var _this2 = this;

      var url = "";
      this.loading = true;
      url = this.domaine + "fournisseur/" + this.currentProduit.id + "/commande/liste";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this2.loading = false;
          _this2.listeCommandeFourn = response.body.commande;
          _this2.statComRessour(response.body.dataStat);
        }
      }, function (error) {
        _this2.loading = false;
      });
    },
    loadStatistique: function loadStatistique(anne) {
      var _this3 = this;

      var url = "";
      this.loading = true;
      url = this.domaine + 'product/' + this.currentProduit.id + "/statistique/produit/" + anne.getFullYear();
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this3.loading = false;
          _this3.totalCommande = response.body.totalCommande;
          _this3.totalQteCommande = response.body.totalQteCommande;
          _this3.listeStatistik = response.body.dataProduit;
          _this3.statDepenseAn(_this3.listeStatistik);
        }
      }, function (error) {
        _this3.loading = false;
      });
    },
    loadStockFourn: function loadStockFourn() {
      var _this4 = this;

      var url = "";
      this.loading = true;
      url = this.domaine + 'entrepot/' + this.currentProduit.id + "/stock/liste/produit";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this4.loading = false;
          _this4.listeStokProd = response.body.stock;
          _this4.listeStokEnlev = response.body.enlev;
          _this4.statEntrepot(response.body.dataStat);
        }
      }, function (error) {
        _this4.loading = false;
      });
    },
    closeFormTypeProjet: function closeFormTypeProjet() {
      this.showDialogTypeProjet = false;
      this.loadTypeProjet();
    },
    closeFormTypeTrx: function closeFormTypeTrx() {
      this.showDialogTypeTrx = false;
      this.loadTravauxParType();
    },
    closeNiveauFormTypeTrx: function closeNiveauFormTypeTrx() {
      this.showDialogTypeNiveauTrx = false;
      this.loadTacheParTypeTrx();
    },
    closeDupFormTypeTrx: function closeDupFormTypeTrx() {
      this.showDialogDupTypeTrx = false;
      this.loadTravauxParType();
    },
    closeFormTypeTache: function closeFormTypeTache() {
      this.showDialogTypeTache = false;
      this.loadTacheParTypeTrx();
    },
    closeDupFormTypeTache: function closeDupFormTypeTache() {
      this.showDialogDupTypeTache = false;
      this.loadTacheParTypeTrx();
    },
    closeFormTypeProduit: function closeFormTypeProduit() {
      this.showModalLoadTypeTravaux = false;
      this.loadProduit();
    },
    tableRowClassName: function tableRowClassName(_ref2) {
      var row = _ref2.row,
          rowIndex = _ref2.rowIndex;

      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    loadPage: function loadPage() {
      var loading = this.$loading({
        lock: true,
        text: "Veuillez patientez ...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 1000);
    },
    filtrerTypeProjet: function filtrerTypeProjet() {
      var idType = this.selectSearchTypeProjet;
      var tableau = this.listTypeProjet;

      this.listTypeProjet = tableau.filter(function (item) {
        return item.id == idType;
      });
      if (idType == null || idType == "undefined" || idType == "") {
        this.loadTypeProjet();
        var _tableau = this.listTypeProjet;
        this.listTypeProjet = _tableau;
        return;
      }
    },
    filtrerTypeRessource: function filtrerTypeRessource() {
      var idType = this.selectSearchTypeRessource;
      var tableau = this.listTypeRessource;

      this.listTypeRessource = tableau.filter(function (item) {
        return item.id == idType;
      });
      if (idType == null || idType == "undefined" || idType == "") {
        this.loadTypeRessource();
        var _tableau2 = this.listTypeRessource;
        this.listTypeRessource = _tableau2;
        return;
      }
    },
    filtrerTravaux: function filtrerTravaux() {
      var idType = this.selectSearchTravaux;
      var tableau = this.listAllTravaux;

      this.listAllTravaux = tableau.filter(function (item) {
        return item.id == idType;
      });
      if (idType == null || idType == "undefined" || idType == "") {
        this.loadAllTravaux();
        var _tableau3 = this.listAllTravaux;
        this.listAllTravaux = _tableau3;
        return;
      }
    },
    filtrerTache: function filtrerTache() {
      var idType = this.selectSearchTache;
      var tableau = this.listTache;
      this.listTache = tableau.filter(function (item) {
        return item.idType == idType;
      });
    },
    SelectionTypePrdotuit: function SelectionTypePrdotuit(item) {
      var data = this.listTypeRessource.filter(function (row) {
        if (row.libelle == item) {
          return row.code;
        }
      });
      this.codeType = data[0].code;
    },
    filtrerTacheType: function filtrerTacheType() {
      var idType = this.selectSearchTache;
      var tableau = this.listTache;

      this.listTache = tableau.filter(function (item) {
        return item.id == idType;
      });
      if (idType == null || idType == "undefined" || idType == "") {
        this.loadTache();
        var _tableau4 = this.listTache;
        this.listTache = _tableau4;
        return;
      }
    },
    filtrerTypeProduit: function filtrerTypeProduit() {
      var idType = this.selectSearchTypeProduit;
      var tableau = this.listProduit;

      this.listProduit = tableau.filter(function (item) {
        return item.type == idType;
      });
      if (idType == null || idType == "undefined" || idType == "") {
        this.loadProduit();
        var _tableau5 = this.listProduit;
        this.listProduit = _tableau5;
        return;
      }
    },
    filtrerProduit: function filtrerProduit() {
      var idType = this.selectSearchProduit;
      var tableau = this.listProduit;

      this.listProduit = tableau.filter(function (item) {
        return item.id == idType;
      });
      if (idType == null || idType == "undefined" || idType == "") {
        this.loadProduit();
        var _tableau6 = this.listProduit;
        this.listProduit = _tableau6;
        return;
      }
    },
    filtrerChantier: function filtrerChantier() {
      var idChant = this.chantierS;
      this.listTache = this.listeRapportTrx.filter(function (item) {
        return item.idType == idChant;
      });
    },
    clearSelect: function clearSelect() {
      this.selectSearchTypeProjet = "";
      this.chantierS = "";
      this.projetS = "";
    },
    loadProduit: function loadProduit() {
      var _this5 = this;

      var url = "";
      this.loading = true;
      url = this.domaine + "product/product-list";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this5.loading = false;
          _this5.listProduit = response.body;
          _this5.listeProduitAffich = response.body;
          _this5.itemsProduit = response.body;
        }
      });
    },
    loadTypeProduit: function loadTypeProduit() {
      var _this6 = this;

      this.loading = true;
      if (this.IdTypeSelct != 0) {
        var url = this.domaine + "product/productSelect/type/" + this.IdTypeSelct;
        this.$http.get(url).then(function (response) {
          _this6.loading = false;
          _this6.listeProduitAffich = response.body.produits;
        }, function (errRep) {
          _this6.loading = false;
          _this6.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
        });
      } else {
        this.loadProduit();
        this.loading = false;
      }
    },
    loadLexique: function loadLexique() {
      var _this7 = this;

      var url = this.domaine + "keyword/lexique-list/" + this.currentProduit.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this7.listLexique = response.body;
        }
      });
    },
    loadTypeProjet: function loadTypeProjet() {
      var _this8 = this;

      // this.getLoadSearch()
      var url = "";
      if (this.droitAcces.index_type_tache) {
        url = this.domaine + "projet/index/type/projet";
      } else {
        url = this.domaine + "projet/" + this.user.id + "/index/type/projet";
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this8.listTypeProjet = response.body.type;
          _this8.listeType = response.body.type;
          _this8.itemsTypeProjet = response.body.type;
        }
      });
    },
    loadTypePrjt: function loadTypePrjt() {
      var _this9 = this;

      var url = "";
      url = this.domaine + "projet/list/type/projet/vide";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this9.listTypProjetTab = response.body.type;

          //contient tous les types travaux qui ont des lot
          _this9.listTypProjetTabAll = response.body.typeAll;
        }
      });
    },
    editTarif: function editTarif(ligne) {
      this.dialogTarif = true;
      this.tarifCourant = ligne;
      this.selectProduit = ligne.libelle;
      this.selectIdProduit = ligne.idprod;
      this.prixAchat = ligne.prixAchat;
      this.valeurUniteMateriel = ligne.unite;
    },
    loadTravaux: function loadTravaux() {
      var _this10 = this;

      this.loading = true;
      this.travaux = "";
      this.listTravaux = [];
      if (this.typeProjet !== "") {
        var url = this.domaine + "product/" + this.typeProjet + "/type/projet/index/travaux";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this10.listTravaux = response.body.travaux;
            _this10.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un projet");
        this.loading = false;
      }
    },
    loadTravauxBytype: function loadTravauxBytype() {
      var _this11 = this;

      if (this.projetS == null || this.projetS == "undefined" || this.projetS == "") {
        this.listTache = this.listeRapportTrx;
        return;
      }
      this.loading = true;
      var url = "";
      url = this.domaine + "product/projet/travaux/" + this.projetS + "/index";

      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this11.listeChantier = response.body.travaux;
          _this11.loading = false;
        }
      });
    },
    loadAllTravaux: function loadAllTravaux() {
      var _this12 = this;

      this.loading = true;
      var url = "";
      if (this.droitAcces.all_travaux_projet) {
        url = this.domaine + "product/projet/travaux/index";
      } else {
        url = this.domaine + "product/projet/" + this.user.id + "/travaux/index";
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this12.listAllTravaux = response.body.travaux;
          _this12.itemsTravaux = response.body.travaux;
          _this12.loading = false;
        }
      });
    },
    loadTravauxParType: function loadTravauxParType() {
      var _this13 = this;

      this.loading = true;
      setTimeout(function () {
        _this13.listeProjetTravaux.splice(0);
        var url = _this13.domaine + "projet/liste/typeTravaux";
        _this13.$http.get(url).then(function (response) {
          _this13.listeProjetTravaux = response.body.listeProjetTravaux;
          _this13.loading = false;
        }, function (error) {
          _this13.loading = false;
          _this13.$message.error("Erreur lors du chargement des travaux ");
        });
      }, 2000);
    },
    loadTacheParTypeTrx: function loadTacheParTypeTrx() {
      var _this14 = this;

      this.loading = true;
      setTimeout(function () {
        var url = _this14.domaine + "projet/liste/typeTache";
        _this14.$http.get(url).then(function (response) {
          _this14.listeTacheTravaux = response.body.listeProjetTravauxTache;
          _this14.loading = false;
        }, function (error) {
          _this14.loading = false;
          _this14.$message.error("Erreur lors du chargement des taches ");
        });
      }, 2000);
    },
    deleteTache: function deleteTache(position, rows) {
      var tableau = [];
      rows.splice(position, 1);
      this.tableLotsNEW = this.tableTaches;
      this.tableTaches = [];

      for (var index = 0; index < this.tableLotsNEW.length; index++) {
        var tab = [];
        this.tab = {
          id: index + 1,
          libelle: this.tableLotsNEW[index]["libelle"],
          ordre: index + 1,
          unite: this.tableLotsNEW[index]["unite"],
          prix: this.tableLotsNEW[index]["prix"],
          description: this.tableLotsNEW[index]["description"]
        };
        this.tableTaches.push(this.tab);
      }

      var input = document.getElementById("ordreTache");
      this.formTache = {
        ordre: this.tableTaches.length == 0 ? 1 : this.tableTaches.length + 1
      };
    },
    deleteTypeProduit: function deleteTypeProduit(position, rows) {
      rows.splice(position, 1);
    },
    deleteTarif: function deleteTarif(ligne) {
      this.dialogSupTarif = true;
      this.tarifCourant = ligne;
      this.selectProduit = ligne.libelle;
    },
    deleteTarification: function deleteTarification() {
      var _this15 = this;

      this.loading = true;
      var url = "";
      var idTarif = this.tarifCourant['id'];
      url = this.domaine + "fournisseur/delete/" + idTarif + "/tarif";
      this.$http.get(url).then(function (response) {
        if (response.body.code == 2) {
          _this15.dialogSupTarif = false;
          _this15.loading = false;
          _this15.$notify({
            title: 'SUPPRESSION REUSSI',
            message: 'Tarification supprimé avec succès.',
            type: 'success',
            position: 'top-center'
          });
          _this15.loadProdFourn();
        } else {
          _this15.loading = false;
          _this15.$message.error('Impossible de supprimer la tarification de ce produit car il est déja utilisé dans une commande');
        }
      }, function (error) {
        // this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
        _this15.$message.error('Impossible de supprimer la tarification de ce produit, il est lié à une commande.');
        _this15.loading = false;
      });
    },
    deleteRow: function deleteRow(position, rows) {
      var tableau = [];
      rows.splice(position, 1);
      this.tableLotsNEW = this.tableLots;
      this.tableLots = [];

      for (var index = 0; index < this.tableLotsNEW.length; index++) {
        var tab = [];
        this.tab = {
          id: index + 1,
          libelle: this.tableLotsNEW[index]["libelle"],
          code: this.tableLotsNEW[index]["code"],
          ordre: index + 1,
          description: this.tableLotsNEW[index]["description"]
        };
        this.tableLots.push(this.tab);
      }
      var input = document.getElementById("ordre");
      this.formTravaux = {
        ordre: this.tableLots.length == 0 ? 1 : this.tableLots.length + 1
      };
    },
    loadTache: function loadTache() {
      var _this16 = this;

      var url = "";
      if (this.droitAcces.index_tache_type) {
        url = this.domaine + "projet/index/tache/type";
      } else {
        url = this.domaine + "projet/index/" + this.user.id + "/tache/type";
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this16.listTache = response.body.tache;
          _this16.listeRapportTrx = response.body.tache;
          _this16.itemsTaches = response.body.tache;
        }
      });
    },
    showTypeProjet: function showTypeProjet(item) {
      var _this17 = this;

      this.dialogShowTypeProjet = true;
      this.typeProjetCourant = item;
      var url = this.domaine + "projet/" + this.typeProjetCourant.id + "/show/type/projet";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this17.loading = false;
        if (response.body) {
          _this17.detailTypeProjet = response.body.type;
        }
      });
    },
    showTypeRessource: function showTypeRessource(item) {
      this.dialogShowTypeRessource = true;
      this.typeRessourceCourant = item;
    },
    showTache: function showTache(item) {
      var _this18 = this;

      this.dialogShowTache = true;
      this.tacheCourant = item;
      var url = this.domaine + "projet/" + this.tacheCourant.id + "/show/tache";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this18.loading = false;
        if (response.body) {
          _this18.detailTache = response.body.tache;
        }
      });
    },
    showProduit: function showProduit(item) {
      this.dialogShowProduit = true;
      this.currentProduit = item;
      this.loadProdFourn();
    },
    showCategorie: function showCategorie(item) {
      this.dialogShowCategorie = true;
      this.currentCategorie = item;
    },
    newTypeProjet: function newTypeProjet() {
      this.showDialogTypeProjet = true;
    },
    newTypeRessource: function newTypeRessource() {
      this.typeLibelle = '';
      this.typeCode = '';
      this.typeDescription = '';
      this.editedTypeRessource = [];
      this.dialogAjoutTypeRessource = true;
    },
    newTache: function newTache(item) {
      var etat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


      this.showDialogTypeTache = true;
      this.etatTache = etat;
      this.idTypeTravauxSelect = parseInt(item.idTypeTrx);
      this.listeTache.splice(0);
      this.listeTache = item.listeTypeTache.slice();
    },
    newTravaux: function newTravaux(item) {
      this.showDialogTypeTrx = true;
      this.listeTrx.splice(0);
      this.listeTrx = item.listeTypeTravaux.slice();
      this.listeTrx = item.listeTypeTravaux;
      this.idTypeProjetSelect = parseInt(item.idTypeProjet);
      conosole.log('rhrhrhr', this.listeTrx);
      conosole.log('idTypeProjetSelect', this.idTypeProjetSelect);
    },
    newNiveau: function newNiveau(item) {
      this.idNivTypeProjetSelect = item.idTypeTrx;
      this.listeTrx.splice(0);
      this.listeTrx = item.sous;
      this.showDialogTypeNiveauTrx = true;
    },
    duplicateTravaux: function duplicateTravaux(item) {
      this.libelleSelect = item.libelle;
      //recherche de tous les types projet qui non pas de lot
      this.loadTypePrjt();
      this.showDialogDupTypeTrx = true;
      this.listeTrx.splice(0);
      this.listeTrx = item.listeTypeTravaux.slice();
      this.idTypeProjetSelect = parseInt(item.idTypeProjet);
    },
    duplicateTaches: function duplicateTaches(item, itmChantier) {
      if (item.nbSous != 0) {
        this.etatTache = 'niveau';
      }

      this.libelleTacheSelect = item.libelle;
      this.libelleChantier = itmChantier.libelle;
      this.loadTypePrjt();
      this.showDialogDupTypeTache = true;
      this.listeTache.splice(0);
      this.listeTache = item.listeTypeTache.slice();
      this.idTypeTravauxSelect = parseInt(item.idTypeTrx);
    },
    loadCodeGestion: function loadCodeGestion() {
      var _this19 = this;

      this.listcodeGestion = [];
      var url = this.domaine + "product/gestionCode";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this19.listcodeGestion = response.body.code;
          _this19.loading = false;
        }
      });
    },
    loadTypeRessource: function loadTypeRessource() {
      var _this20 = this;

      this.listcodeGestion = [];
      var url = this.domaine + "product/typeRessource";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this20.listTypeRessource = response.body.types;
          _this20.loading = false;
        }
      });
    },
    submitType: function submitType() {
      var _this21 = this;

      this.loading = true;
      var data = new FormData();
      data.append('libelle', this.typeLibelle);
      data.append('ordre', this.typeCode);
      data.append('code', this.typeDescription);
      data.append('idUser', this.user.id);
      var url = this.domaine + 'projet/' + this.editedType.idTypeTrx + '/edit/type/travaux';
      this.$http.post(url, data).then(function (response) {
        _this21.loading = false;
        _this21.dialogMofifTravaux = false;
        if (response.body.code == 3) {
          _this21.$message.error(response.body.message);
          return;
        }
        _this21.$notify({
          title: 'MODIFICATION REUSSI',
          message: 'Type de travaux enregistré avec succès.',
          type: 'success',
          position: 'top-center'
        });
        _this21.loadTravauxParType();
      });
    },
    submitTarif: function submitTarif() {
      var _this22 = this;

      this.loading = true;
      var form = document.getElementById("formTarif");
      var data = new FormData(form);
      var url = "";
      var idTarif = this.tarifCourant['id'];
      url = this.domaine + "fournisseur/new/" + idTarif + "/tarif";
      data.append('produit', this.selectProduit);
      data.append('selectIdProduit', this.selectIdProduit);
      data.append('idUser', this.user.id);
      this.tableTarification = [];
      data.append("tarif", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableTarification));
      this.$http.post(url, data).then(function (response) {
        if (response.body) {
          var verif = response.body;
          if (verif.code === 1) {
            _this22.$notify({
              title: 'ENREGISTREMENT REUSSI',
              message: 'Tarification enregistré avec succès.',
              type: 'success',
              position: 'top-center'
            });
          }
          _this22.loadProdFourn();
          _this22.dialogTarif = false;
          _this22.dialogConfirm = false;
          _this22.loading = false;
        } else {
          _this22.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
          _this22.loading = false;
          _this22.dialogAppro = false;
        }
      }, function (response) {
        _this22.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
        _this22.loading = false;
      });
    },
    closeType: function closeType() {
      this.dialogAjoutTypeRessource = false;
    },
    submitTypeRessource: function submitTypeRessource() {
      var _this23 = this;

      this.loading = true;
      var data = new FormData();
      data.append('libelle', this.typeLibelle);
      data.append('code', this.typeCode);

      data.append('description', this.typeDescription);
      data.append('idUser', this.user.id);
      var url = "";
      if (this.editedTypeRessource.id) {
        url = this.domaine + 'product/' + this.editedTypeRessource.id + '/edit/type/ressource';
      } else {
        url = this.domaine + 'product/new/typeRessource';
      }
      this.$http.post(url, data).then(function (response) {
        _this23.loading = false;
        _this23.dialogAjoutTypeRessource = false;
        if (response.body.code == 3) {
          _this23.$message.error(response.body.message);
          return;
        }
        _this23.$notify({
          title: 'ENREGISTREMENT REUSSI',
          message: 'Type de ressrouce enregistré avec succès.',
          type: 'success',
          position: 'top-center'
        });
        _this23.loadTypeRessource();
      }, function (error) {
        _this23.loading = false;
        _this23.$message.error("Erreur lors de l'enregistrement du type projet ");
      });
    },
    newProduit: function newProduit() {
      this.produitCourant.id = "";
      this.dialogAjoutProduit = true;
      this.codeType = '';
      this.dialogEditProduit = false;
      this.loadCodeGestion();
      this.typeProduit = "";
      this.codeGestion = '';
      this.formTypeProduit = {
        id: "",
        codeGestion: "",
        codeAnalytique: "",
        referenceProduit: "",
        libelleProduit: "",
        valeurProduit: 0,
        libelleUnite: "",
        descProduit: ""
      };
      this.tableTypeProduit = [];
    },
    newCategorie: function newCategorie() {
      this.dialogAjoutCategory = true;
      this.dialogEditCategorie = false;
      this.idCategorie = "";
      this.libelleCategorie = "";
      this.descCategorie = "";
    },
    editTypeProjet: function editTypeProjet(item) {
      this.typeProjetCourant = item;
      this.typeProjetSelect = item;
      this.showDialogTypeProjet = true;
    },
    editType: function editType(item, element) {
      this.typeLibelle = item.libelle;
      this.typeELement = element;
      this.typeCode = item.ordre;
      this.typeDescription = item.code;
      this.editedType = item;
      this.dialogMofifTravaux = true;
    },
    editTypeRessource: function editTypeRessource(item) {
      this.typeLibelle = item.libelle;
      this.typeCode = item.code;
      this.typeDescription = item.description;
      this.editedTypeRessource = item;
      this.dialogShowTypeRessource = false;
      this.dialogAjoutTypeRessource = true;
    },
    editTache: function editTache(item) {
      this.tacheCourant = item;
      this.dialogAjoutTache = true;
      this.dialogEdit = true;
      this.formTache.id = this.tacheCourant.id;
      this.formTache.ordre = this.tacheCourant.ordre;
      this.formTache.libelle = this.tacheCourant.libelle;
      this.formTache.unite = this.tacheCourant.unite;
      this.formTache.prix = this.tacheCourant.prix;

      this.typeProjet = this.tacheCourant.idTypeP;
      this.formTache.description = this.tacheCourant.description;
      this.loadTravaux();
      this.travaux = this.tacheCourant.idType;
    },
    editTravaux: function editTravaux(item) {
      this.dialogAjoutTravaux = true;
      this.dialogEdit = true;
      this.travauxCourant = item;
      this.typeProjet = item.idType;
      this.formTravaux.id = item.id;
      this.formTravaux.libelle = item.libelle;
      this.formTravaux.ordre = item.ordre;
      this.formTravaux.description = item.description;
      this.formTravaux.code = item.code;
    },
    editProduit: function editProduit(item) {
      this.produitCourant = item;
      this.dialogAjoutProduit = true;
      this.dialogEditProduit = true;
      this.idProduit = item.id;
      this.referenceProduit = item.reference;
      this.libelleProduit = item.value;
      this.libelleUnite = item.unite;
      this.typeProduit = item.type;
      this.valeurProduit = item.valeur;
      this.descProduit = item.description;
      this.codeGestion = item.codeGestion;

      this.formTypeProduit.valeurProduit = item.valeur;
      this.formTypeProduit.descProduit = item.description;
      this.formTypeProduit.referenceProduit = item.reference;
      this.formTypeProduit.codeAnalytique = item.codeAnalytique;
      this.formTypeProduit.libelleProduit = item.value;
      this.formTypeProduit.libelleUnite = item.unite;
    },
    editCategorie: function editCategorie(item) {
      this.dialogAjoutCategory = true;
      this.dialogEditCategorie = true;
      this.idCategorie = item.id;
      this.libelleCategorie = item.libelle;
      this.descCategorie = item.description;
    },
    showTravaux: function showTravaux(item) {
      this.dialogShowTravaux = true;
      this.travauxCourant = item;
    },
    addProduit: function addProduit() {
      var _this24 = this;

      this.loading = true;
      var form = document.getElementById("formProduit");
      var data = new FormData();

      var url = "";
      if (this.produitCourant.id) {
        url = this.domaine + "product/" + this.produitCourant.id + "/edit/product";
      } else {
        url = this.domaine + "product/create-product";
      }

      if (this.formTypeProduit.libelleProduit != "", this.typeProduit != "") {
        data.append("codeGestion", this.formTypeProduit.codeGestion);
        data.append("codeAnalytique", this.formTypeProduit.codeAnalytique);
        data.append("referenceProduit", this.formTypeProduit.referenceProduit);
        data.append("libelleProduit", this.formTypeProduit.libelleProduit);
        data.append("libelleUnite", this.formTypeProduit.libelleUnite);
        data.append("valeurProduit", this.formTypeProduit.valeurProduit);
        data.append("descProduit", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formTypeProduit.descProduit));
        data.append("type", this.typeProduit);
        data.append("id", this.produitCourant.id);
        data.append("typePorduit", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableTypeProduit));
        data.append("idUser", this.user.id);

        this.$http.post(url, data).then(function (response) {
          _this24.loading = false;
          var verif = response.body;
          _this24.dialogShowProduit = false;
          if (verif.code == 3) {
            _this24.$alert(verif.message, "Modification libelle ressource", {
              confirmButtonText: "OK"
            });
            return;
          }
          _this24.dialogAjoutProduit = false;
          if (verif[0].code === 2) {
            _this24.$notify({
              title: "ENREGISTREMENT PRODUIT",
              message: verif.message,
              type: "success",
              position: "top-center"
            });
          }
          if (verif[0].code === 1) {
            _this24.$notify({
              title: "MODIFICATION PRODUIT",
              message: verif.message,
              type: "success",
              position: "top-center"
            });
          }
          _this24.loading = false;
          _this24.$refs.formProduit.reset();
          _this24.resitFOrmProduit();
          _this24.referenceProduit = "";
          _this24.tableTypeProduit = [];
          _this24.loadProduit();
        }, function (response) {
          _this24.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this24.loading = false;
        });
      } else if (this.tableTypeProduit.length > 0) {

        data.append("type", this.typeProduit);
        data.append("id", this.produitCourant.id);
        data.append("typePorduit", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableTypeProduit));

        this.$http.post(url, data).then(function (response) {
          _this24.loading = false;
          _this24.dialogShowProduit = false;
          var verif = response.body;
          if (verif[0].code === 3) {
            _this24.dialogAjoutProduit = true;
            _this24.$message.error(verif[0].message);
            _this24.libelleProduit = "";
          }
          _this24.dialogAjoutProduit = false;
          if (verif[0].code === 2) {
            _this24.$notify({
              title: "ENREGISTREMENT PRODUIT",
              message: verif.message,
              type: "success",
              position: "top-center"
            });
            _this24.$refs.formProduit.reset();
            _this24.resitFOrmProduit();
            _this24.referenceProduit = "";
            _this24.tableTypeProduit = [];
            _this24.loadProduit();
          }
          if (verif[0].code === 1) {
            _this24.$notify({
              title: "MODIFICATION PRODUIT",
              message: verif.message,
              type: "success",
              position: "top-center"
            });

            _this24.$refs.formProduit.reset();
            _this24.resitFOrmProduit();
            _this24.referenceProduit = "";
            _this24.tableTypeProduit = [];
            _this24.loadProduit();
          }
        });
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
      // }
    },
    addListTaches: function addListTaches(item) {
      var input = document.getElementById("ordreTache");

      if (item.ordre == undefined || item.ordre == "") {
        this.tableTaches.push({
          libelle: item.libelle,
          ordre: input.value,
          unite: item.unite,
          prix: item.prix,
          description: item.description
        });
      } else {
        this.tableTaches.push({
          libelle: item.libelle,
          ordre: this.tableTaches.length + 1,
          unite: item.unite,
          prix: item.prix,
          description: item.description
        });
      }
      this.formTache = {
        ordre: this.tableTaches.length + 1
      };
    },
    resitFOrmProduit: function resitFOrmProduit() {
      this.formTypeProduit.referenceProduit = "";
      this.formTypeProduit.valeurProduit = "";
      this.formTypeProduit.descProduit = "";
      this.formTypeProduit.libelleUnite = "";
      this.formTypeProduit.codeAnalytique = '';
      this.formTypeProduit.libelleProduit = "";
    },
    addListProduit: function addListProduit(item) {
      this.tableTypeProduit.push({
        codeGestion: this.codeGestion,
        codeAnalytique: item.codeAnalytique,
        referenceProduit: item.referenceProduit,
        libelleProduit: item.libelleProduit,
        valeurProduit: item.valeurProduit,
        libelleUnite: item.libelleUnite,
        descProduit: item.descProduit
      });
      this.formTypeProduit.referenceProduit = "";
      this.formTypeProduit.codeAnalytique = '';
      this.codeGestion = '';
      this.formTypeProduit.valeurProduit = "";
      this.formTypeProduit.descProduit = "";
      this.formTypeProduit.libelleUnite = "";
      this.formTypeProduit.libelleProduit = "";
    },
    addListParticipantDemande: function addListParticipantDemande(item) {
      var input = document.getElementById("ordre");

      if (item.ordre == undefined || item.ordre == "") {
        this.tableLots.push({
          id: item.code++,
          libelle: item.libelle,
          code: item.code,
          ordre: input.value,
          description: item.description
        });
      } else {
        this.tableLots.push({
          id: this.tableLots.length + 1,
          libelle: item.libelle,
          code: item.code,
          ordre: this.tableLots.length + 1,
          description: item.description
        });
      }
      this.formTravaux = {
        ordre: this.tableLots.length + 1
      };
    },
    addCategorie: function addCategorie() {
      var _this25 = this;

      if (this.$refs.formCategorie.validate()) {
        var form = document.getElementById("formCategorie");
        var data = new FormData(form);
        var url = "";
        if (this.idCategorie) {
          url = this.domaine + "keyword/update-familly/" + this.idCategorie;
        } else {
          url = this.domaine + "keyword/create-familly";
        }
        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 2) {
              if (_this25.idCategorie) {
                _this25.$notify({
                  title: "MODIFICATION REUSSI",
                  message: "Catégorie enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
              } else {
                _this25.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Catégorie enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
              }
              _this25.dialogAjoutCategory = false;
            } else if (verif.code === 1) {
              _this25.dialogAjoutCategory = true;
              _this25.$message.error(verif.message);
            }
          } else {
            _this25.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this25.loading = false;
          }
        }, function (response) {
          _this25.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this25.loading = false;
        });
      }
    },
    generateFileExcel: function generateFileExcel() {
      var url = this.domaine + "projet/generer/modele/produits";
      window.open(url);
    },
    onFileExcelPicked: function onFileExcelPicked(event) {
      var _this26 = this;

      this.fileExcel.splice(0, 1);
      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this26.fileExcel.push(fileReader.result);
      });
      fileReader.readAsDataURL(files[0]);
      var url = this.domaine + "projet/loadProduit/excel";
      var data = new FormData();
      data.append("fichierExcel", files[0], files[0][name]);
      this.$http.post(url, data).then(function (resp) {
        _this26.loading = false;

        _this26.$notify({
          title: "Chargement liste des ressources",
          message: "Chargement effectué",
          type: "success",
          position: "top-right",
          duration: 7000
        });
        _this26.lstTypeTravaux = resp.body.listeTypeTravaux;
        _this26.showModalLoadTypeTravaux = true;
      }, function (resp) {
        _this26.loading = false;
        _this26.$message.error("Erreur lors de l'importation du fichier");
      });
    },
    filtrerEtatPrioriteBesoin: function filtrerEtatPrioriteBesoin() {
      var _this27 = this;

      this.listeProduitAffich = this.listeProduitAffich.filter(function (element) {
        _this27.loading = false;
        return element.value == _this27.IdProduiSelect;
      });
    },
    submitTache: function submitTache() {
      var _this28 = this;

      this.loading = true;
      if (this.$refs.formTache.validate() && this.travaux != "" && this.formTache.libelle != "" && this.formTache.ordre != 0) {
        var form = document.getElementById("formTache");
        var data = new FormData(form);
        var url = "";
        if (this.tacheCourant.id) {
          url = this.domaine + "projet/" + this.tacheCourant.id + "/edit/tache/projet";
        } else {
          url = this.domaine + "projet/new/tache/projet";
        }

        data.append("id", this.formTache.id);
        data.append("travaux", this.travaux);
        data.append("idUser", this.user.id);
        data.append("tache", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableTaches));
        data.append("formTache", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formTache));

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 3) {
              // this.dialogAjoutTache = true
              _this28.$message.error(verif.message);
              // this.libelleProduit =""
            }
            if (verif.code === 1) {
              _this28.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Tâche enregistré avec succès.",
                type: "success",
                position: "top-center"
              });
              _this28.loading = false;
              _this28.dialogAjoutTache = false;
              _this28.tableTaches = [];
              _this28.formTache = {};
              _this28.loadTypeProjet();
              _this28.loadTache();
            } else {
              _this28.$message.error(verif.message);
              _this28.loading = false;
            }
          } else {
            _this28.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this28.loading = false;
          }
        }, function (response) {
          _this28.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this28.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La tâche n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    closeShowProdui: function closeShowProdui() {
      this.dialogShowProduit = false;
      this.handleTabClick1(4);
    },
    submitTravaux: function submitTravaux() {
      var _this29 = this;

      this.loading = true;
      if (this.$refs.formTravaux.validate() && this.tableLots != [] && this.typeProjet != "") {
        var form = document.getElementById("formTravaux");
        var data = new FormData(form);
        var url = "";
        if (this.travauxCourant.id) {
          url = this.domaine + "projet/" + this.travauxCourant.id + "/edit/travaux/projet";
        } else {
          url = this.domaine + "projet/new/travaux/projet";
        }
        data.append("formTravaux", this.formTravaux);
        data.append("id", this.formTravaux.id);
        data.append("type", this.typeProjet);
        data.append("idUser", this.user.id);
        data.append("lots", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableLots));
        data.append("formTravaux", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formTravaux));

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code == 3) {
              _this29.loading = false;
              _this29.$message.error(verif.message);
            }
            if (verif.code == 1) {
              _this29.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Lot enregistré avec succès.",
                type: "success",
                position: "top-center"
              });

              _this29.loading = false;
              _this29.dialogAjoutTravaux = false;
              //this.loadAllTravaux()
            } else {
              _this29.loading = false;
              _this29.$message.error(verif.message);
            }
          } else {
            _this29.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this29.loading = false;
          }
        }, function (response) {
          _this29.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this29.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le type travaux n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    removeKeyword: function removeKeyword(item) {
      this.dialogSuprKeyword = true;
      this.idProduit = item.id;
    },
    removeLexique: function removeLexique(item) {
      this.dialogSuprLexique = true;
      this.idLexique = item.id;
    },
    removeCategorie: function removeCategorie(item) {
      this.dialogSuprCategorie = true;
      this.idCategorie = item.id;
    },
    deleteType: function deleteType() {
      var _this30 = this;

      this.loading = true;
      var url = this.domaine + "projet/" + this.idAppro + "/delete/type";
      this.$http.get(url).then(function (response) {
        _this30.loading = false;
        if (response.body.code == 3) {
          _this30.$alert(response.body.message, "Suppresion type Chantier", {
            confirmButtonText: "OK"
          });
          _this30.dialogSuprTyp = false;
          return;
        }

        if (response.body) {
          var verif = response.body;
          if (verif.code === 1) {
            _this30.$notify({
              title: "SUPPRESSION",
              message: "Enregistrement supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
          } else if (verif.code === 2) {
            _this30.$notify({
              title: "SUPPRESSION",
              message: verif.message,
              type: "warning",
              position: "top-center"
            });
          }
          _this30.dialogSuprTyp = false;
          _this30.loadTypeProjet();
        }
      });
    },
    clearSelectProduit: function clearSelectProduit() {
      this.loadProduit();
    },
    deleteLots: function deleteLots() {
      var _this31 = this;

      var url = this.domaine + "projet/" + this.idAppro + "/lot/delete";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          var verif = response.body;
          if (verif.code === 1) {
            _this31.$notify({
              title: "SUPPRESSION",
              message: "e supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
          } else if (verif.code === 2) {
            _this31.$notify({
              title: "SUPPRESSION",
              message: verif.message,
              type: "warning",
              position: "top-center"
            });
          }
          _this31.dialogSuprLots = false;
          //this.loadAllTravaux()
        }
      });
    },
    deleteTaches: function deleteTaches() {
      var _this32 = this;

      var url = this.domaine + "projet/" + this.idAppro + "/delete/tache/projet";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          var verif = response.body;
          if (verif.code === 1) {
            _this32.$notify({
              title: "SUPPRESSION",
              message: "Tache supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
          } else if (verif.code === 2) {
            _this32.$notify({
              title: "SUPPRESSION",
              message: verif.message,
              type: "warning",
              position: "top-center"
            });
          }
          _this32.dialogSuprTache = false;
          _this32.loadTypeProjet();
          _this32.loadTache();
        }
      });
    },
    deleteTypeProd: function deleteTypeProd() {
      var _this33 = this;

      this.loading = true;
      var url = this.domaine + "product/delete-product/" + this.idAppro;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          var verif = response.body;
          if (verif.code === 1) {
            _this33.loading = false;
            _this33.$notify({
              title: "SUPPRESSION",
              message: "Approvisionnement supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
          } else if (verif.code === 2) {
            _this33.loading = false;
            _this33.$notify({
              title: "SUPPRESSION",
              message: verif.message,
              type: "warning",
              position: "top-center"
            });
          }
          _this33.loading = false;
          _this33.dialogSuprProd = false;
        }
        _this33.loading = false;
        _this33.dialogSuprProd = false;
        _this33.dialogSuprAppro = false;
        _this33.loadProduit();
      });
    }
  },
  mounted: function mounted() {
    this.loadTypeProjet();
    this.loadProduit();
    this.loadTypeRessource();
  }
});

/***/ }),

/***/ "1uTe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_rapport_ListeReserve__ = __webpack_require__("cz/F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_boardTravaux_ListeTravaux__ = __webpack_require__("s7lN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_boardTravaux_widgetTravaux__ = __webpack_require__("MasU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_boardChantier_widgetChantier__ = __webpack_require__("7rON");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_boardTravaux_ListePrestataire__ = __webpack_require__("9BzK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_boardChantier_CompteExploitationChantier__ = __webpack_require__("Tf2e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import ContratOuvrier from '@/components/boardChantier/Contrat_ouvrier';








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_6__components_Loading__["a" /* default */],
    ListeReserve: __WEBPACK_IMPORTED_MODULE_0__components_rapport_ListeReserve__["a" /* default */],
    ListeTravaux: __WEBPACK_IMPORTED_MODULE_1__components_boardTravaux_ListeTravaux__["a" /* default */],
    ListePrestataire: __WEBPACK_IMPORTED_MODULE_4__components_boardTravaux_ListePrestataire__["a" /* default */],
    WidgetTravaux: __WEBPACK_IMPORTED_MODULE_2__components_boardTravaux_widgetTravaux__["a" /* default */],
    WidgetChantier: __WEBPACK_IMPORTED_MODULE_3__components_boardChantier_widgetChantier__["a" /* default */],
    CompteExploitationChantier: __WEBPACK_IMPORTED_MODULE_5__components_boardChantier_CompteExploitationChantier__["a" /* default */]
  },
  name: "DashboardChantierProjet",
  props: {
    show: {
      type: Boolean
    },
    detailChantier: {
      type: Object
    },
    commis: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      dialogDashboardChantier: false,
      loading: false,
      onglet: "0",
      listeTravaux: [],
      listeTravauxId: [],

      //ONGLET TRAVAUX
      detailTravaux: {},
      dialogConfirmRefus: false,
      showRapport: false,
      showListeRapport: false,
      dialogListeRapport: false,
      listeRapports: [],

      //ONGLET OUVRIERS
      listPrestataires: [],
      listOuvriers: [],
      showListeOuvrier: false,

      //ONGLET RESERVE
      listeReserves: [],

      showCompteExploit: false
    };
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    loadTravaux: function loadTravaux(chantier) {
      var _this = this;

      this.loading = true;
      this.listeTravauxId = [];
      var url = this.domaine + "travaux/chantiers/" + chantier.id;
      this.$http.get(url).then(function (response) {
        _this.listeTravaux = response.body.travaux;
        _this.listeTravaux.forEach(function (element) {
          _this.listeTravauxId.push(element.idTrx);
        });
        _this.loading = false;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Echec lors du chargement des travaux");
      });
    },


    //ONGLETS OUVRIERS/PRESTATAIRE

    loadOuvrier: function loadOuvrier(idChantier) {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "ouvrier/chantier/" + idChantier;
      this.$http.get(url).then(function (response) {
        _this2.listOuvriers = response.body.ouvriers;
        _this2.listPrestataires = response.body.prestataires;
        _this2.loading = false;
        _this2.showListeOuvrier = true;
      }, function (error) {
        _this2.loading = false;
        _this2.$message.error("Echec lors du chargement des ouvriers");
      });
    },


    //ONGLET RESERVE
    loadReserves: function loadReserves() {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + "reserve/chantier/" + this.detailChantier.idChant;
      this.$http.get(url).then(function (response) {
        _this3.listeReserves = response.body.reserves;
        _this3.loading = false;
      }, function (error) {
        _this3.loading = false;
        _this3.$message.error("Echec lors du chargement des reserves");
      });
    },
    handleTabClick: function handleTabClick(tab) {
      this.showListeOuvrier = false;
      this.showCompteExploit = false;
      switch (tab) {
        case "0":
          if (this.listeTravaux.length == 0) {
            this.loadTravaux(this.detailChantier);
          }

          break;
        case "1":
          if (this.listOuvriers.length == 0 && this.listPrestataires.length == 0) {
            this.loadOuvrier(this.detailChantier.idChant);
          }
          break;
        case "2":
          if (this.listeReserves.length == 0) {
            this.loadReserves();
          }
          break;
        case "3":
          this.showCompteExploit = true;
          break;
        default:
          break;
      }
    }
  },

  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogDashboardChantier = newValue;
      if (newValue == true) {
        this.onglet = "0";
        this.loadTravaux(this.detailChantier);
      }
    }
  }
});

/***/ }),

/***/ "1wCn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
    name: "DetailMaintenance",
    props: ["show", "demandeDetail"],
    data: function data() {
        return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            dialogDetail: false,
            tableProduit: [],
            totalTTC: 0,
            formRapport: {},
            dialogVisible: false,
            dialogImageUrl: '',
            imageDmd1: "",
            imageDmd2: "",
            imageDmd3: "",
            imageConst1: "",
            imageConst2: "",
            imageConst3: "",
            imageDepan1: "",
            imageDepan2: "",
            imageDepan3: ""

        };
    },


    computed: {},
    watch: {
        show: function show(newValue, oldvalue) {
            this.dialogDetail = newValue;
            if (newValue == true) {
                this.loadDevisConstat();
            }
        }
    },

    methods: {
        closeDialog: function closeDialog() {
            this.$emit('close');
        },
        loadDevisConstat: function loadDevisConstat() {
            var _this = this;

            this.loading = true;
            var url = this.domaine + 'demande_maintenance/devis/constat/' + this.demandeDetail.idDemande;
            this.$http.get(url).then(function (response) {

                _this.tableProduit = response.body.tableProduit;
                _this.formRapport.rapport = response.body.rapport;
                _this.totalTTC = response.body.total;
                _this.loading = false;
            }, function (errResp) {
                _this.loading = false;
                _this.$message.error("Une erreur est survenue lors du chargement de la table des produits");
            });
        },
        handleRemove: function handleRemove(file, fileList) {},
        handleSuccess: function handleSuccess(response, file, fileList) {
            this.fileList.push(file);
        },
        handlePictureCardPreview: function handlePictureCardPreview(file, fileList) {
            this.dialogImageUrl = file.url;

            this.dialogVisible = true;
        },
        imprimerDetail: function imprimerDetail() {

            var url = this.domaine + "demande_maintenance/imprimerPDF/demande/" + this.user.id + "/" + this.demandeDetail.idDemande;
            window.open(url);
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "24ue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":"","ml-1":"","mr-1":"","mt-1":""}},[_c('v-card',[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":_vm.handleTabClick},model:{value:(_vm.onglet),callback:function ($$v) {_vm.onglet=$$v},expression:"onglet"}},[_c('el-tab-pane',{attrs:{"label":"Dashboard RH"}},[_c('boardResource')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Liste contrats"}},[_c('listeContrat',{on:{"clickDetCont":_vm.showDetailCont}})],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Liste demandes en attente"}},[_c('listeDemande')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Liste employés"}},[_c('listeEmploye')],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2O9s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2gK+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v(_vm._s(item.text)+"\n                ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-3",staticStyle:{"width":"100%"}},[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h3',[_vm._v("Liste des budgets projet")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL MONTANT PROPOSE\n                        : "+_vm._s(new
                        Intl.NumberFormat().format(_vm.totalMntPropose))+" ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL MONTANT VALIDE\n                        : "+_vm._s(new
                        Intl.NumberFormat().format(_vm.totalMntValide))+" ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL MONTANT MARCHE\n                        : "+_vm._s(new
                        Intl.NumberFormat().format(_vm.totalMntMarche))+" ")])])],1)],1),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"border":"","header-row-style":_vm.headerRowStyle,"highlight-current-row":"","data":_vm.listeProjet,"summary-method":_vm.getSummExploitBudget,"show-summary":""}},[_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"libelle","label":"PROJET"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(" "+_vm._s(prop.row.libelle)+"  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"mntTotalProjetPropose","label":"MONTANT TOTAL PROPOSE"},scopedSlots:_vm._u([{key:"default",fn:function(prop4){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"blue"}},[_vm._v("\n                            "+_vm._s(new Intl.NumberFormat().format(prop4.row.mntTotalProjetPropose))+"\n                        ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"mntTotalProjetValide","label":"MONTANT TOTAL VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(prop5){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"success"}},[_vm._v("\n                            "+_vm._s(new Intl.NumberFormat().format(prop5.row.mntTotalProjetValide))+"\n                        ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT","prop":"etat"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":scope.row.etat == 0 ? 'warning' : 'success',"disable-transitions":""}},[_vm._v(_vm._s(scope.row.libEtatBudget))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"mntMarche","label":"MONTANT DU MARCHE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"info"}},[_vm._v("\n                            "+_vm._s(new Intl.NumberFormat().format(prop.row.mntMarche))+"\n                        ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etatBudget != 3)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailProj(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1):_vm._e(),_vm._v("Detail du projet\n                        ")],1)]}}])})],1)],1)],1),_vm._v(" "),_c('DetailBudgetProjet',{attrs:{"show":_vm.showDetailProj,"detailProjet":_vm.detProj},on:{"close":function($event){_vm.showDetailProj = false; _vm.loadBudget()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2h4C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_edit_user_vue__ = __webpack_require__("t9n0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06cf1852_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_edit_user_vue__ = __webpack_require__("Px8Q");
function injectStyle (ssrContext) {
  __webpack_require__("racX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06cf1852"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_edit_user_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06cf1852_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_edit_user_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2lgG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_validationDG_ModalValidationDmd__ = __webpack_require__("J/ex");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_validationDG_ModalValidationDmdFond__ = __webpack_require__("DUFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_validationDG_ModalValidationDmdCom__ = __webpack_require__("9Tei");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_validationDG_ModalValidationMiss__ = __webpack_require__("0ygq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_validationDG_ModalValidationFacture__ = __webpack_require__("N3SU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_validationDG_ModalValidationInterv__ = __webpack_require__("gpm2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_validationDG_ModalValidationAppro__ = __webpack_require__("iWoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__facturePaiement__ = __webpack_require__("UgjE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_resourceHumaine_liste_demande__ = __webpack_require__("YSKP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Loading__ = __webpack_require__("NxGh");




var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        facturePaiement: __WEBPACK_IMPORTED_MODULE_10__facturePaiement__["a" /* default */],
        Loading: __WEBPACK_IMPORTED_MODULE_12__components_Loading__["a" /* default */], ModalValidationDmd: __WEBPACK_IMPORTED_MODULE_3__components_validationDG_ModalValidationDmd__["a" /* default */], ModalValidationMiss: __WEBPACK_IMPORTED_MODULE_6__components_validationDG_ModalValidationMiss__["a" /* default */], ModalValidationFacture: __WEBPACK_IMPORTED_MODULE_7__components_validationDG_ModalValidationFacture__["a" /* default */], ModalValidationInterv: __WEBPACK_IMPORTED_MODULE_8__components_validationDG_ModalValidationInterv__["a" /* default */], ModalValidationDmdFond: __WEBPACK_IMPORTED_MODULE_4__components_validationDG_ModalValidationDmdFond__["a" /* default */], ModalValidationDmdCom: __WEBPACK_IMPORTED_MODULE_5__components_validationDG_ModalValidationDmdCom__["a" /* default */], ModalValidationAppro: __WEBPACK_IMPORTED_MODULE_9__components_validationDG_ModalValidationAppro__["a" /* default */], listeDemande: __WEBPACK_IMPORTED_MODULE_11__components_resourceHumaine_liste_demande__["a" /* default */] },
    name: "app",
    data: function data() {
        var _ref;

        return _ref = {
            //data general
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            racourcis: [{ path: '/', text: 'Accueil', disabled: false }, { path: '/validationDmd', text: 'Dashboard des validations', disabled: true }],
            dialogValideSuivant: false,
            typeDmd: null,
            itemDmd: {},

            // stretch: false,
            //VALIDATION DES sDEMANDES
            listeDemandes: [],
            selectZoneDmd: '',
            oldListDemandes: [],
            legendeDmd: "LISTE DES DEMANDES DE MAINTENANCES A VALIDER",
            comboZoneDmd: [],
            mntTTCAValide: 0,
            demandeDetail: {},
            showModalDetailDmd: false,
            nbDmdMaint: 0,

            //VALIDATION MISSIONS
            legendeMiss: "LISTE DES DEMANDES DE MISSION A VALIDER",
            listeMissions: [],
            oldListMissions: [],
            selectMissDemd: "",
            listeDemandeurs: [],
            nbMiss: 0,
            mntTotalMissTTC: 0,
            detailMission: {},
            showModalDetailMiss: false,

            //VALIDATION FACTURE FOURNISSEUR
            legendeFour: "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER",
            nbFactFour: 0,
            listeFournisseurs: [],
            listeFacturesFour: [],
            oldListFacturesFour: [],
            selectFour: '',
            mntTotalFactTTC: 0,
            factureDetail: {},
            showModalDetailFact: false,

            //VALIDATION DES DEMANDES APPROVISIONNEMENTS
            legendeAppro: "LISTE DES DEMANDES APPROVISIONNEMENTS",
            mntTotalAppro: 0,
            listeDmdNoValidAppro: [],
            showModalDetailAppro: false,
            ApproDetail: {},
            nbAppro: 0,
            listBanque: [],
            listCaisse: [],

            //VALIDATION INTERVENTION
            legendeInterv: "LISTE DES REPARATIONS A VALIDER",
            mntTotalIntervTTC: 0,
            nbInterv: 0,
            selectInterv: '',
            listeDemdInterv: [],
            listeIntervention: [],
            oldListeIntervention: [],
            intervDetail: [],
            showModalIntervFact: false,

            //VALIDATION DENANDE DE FONDS
            legendeDmdFond: "LISTE DES DEMANDES DE FONDS A VALIDER",
            mntTotalDmdFondTTC: 0,
            nbDmdFond: 0,
            selectDmdFond: '',
            listeDemandeurFond: [],
            listeDmdFond: [],
            oldListeDemandeurFond: [],
            dmdFondDetail: [],
            showModalDetailDmdFond: false,
            onglet: "0",

            //VALIDATION DEMANDE CONGE
            listeDemandeurAbs: [],
            //VALIDATION COMMANDE
            legendeDmdCom: "LISTE DES BONS DE COMMANDES A VALIDER",
            mntTotalDmdComTTC: 0,
            nbDmdCom: 0,
            selectDmdCom: '',
            listeDemandeurCom: [],
            listeDmdCom: [],
            oldListeDemandeurCom: [],
            dmdComDetail: [],
            detailCommande: [],
            totalMontant: 0,
            totalComHT: [],
            totalComTVA: [],
            totalComRemise: [],
            showModalDetailDmdCom: false,
            commCourant: []
        }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'onglet', "0"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'listeProdNull', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'mntTotalCmd', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'listeProdNull', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'commandeDeriv', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'commandeDerivDeux', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'nbCommandeSug', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'nbCommandeSugDeux', 0), _ref;
    },


    methods: (_methods = {
        SubmitValideSuivant: function SubmitValideSuivant() {
            switch (this.typeDmd) {
                case "maintenance":
                    this.dialogValideSuivant = false;
                    this.modalDetailDmd(this.itemDmd);
                    break;

                case "intervention":
                    this.dialogValideSuivant = false;
                    this.modalDetailInterv(this.itemDmd);
                    break;
                case "factureFour":
                    this.dialogValideSuivant = false;
                    this.modalDetailFour(this.itemDmd);
                    break;
                case "mission":
                    this.dialogValideSuivant = false;
                    this.modalDetailMissDemd(this.itemDmd);
                    break;
                case "demandeFond":
                    this.dialogValideSuivant = false;
                    this.modalDetailDmdFond(this.itemDmd);
                    break;
            }
        },
        CancelValideSuivant: function CancelValideSuivant() {
            switch (this.typeDmd) {
                case "maintenance":
                    this.dialogValideSuivant = false;
                    this.loadDemandeAvalider();
                    break;

                case "intervention":
                    this.dialogValideSuivant = false;
                    this.loadDmdIntervention();
                    break;
                case "factureFour":
                    this.dialogValideSuivant = false;
                    this.loadFacture();
                    break;
                case "mission":
                    this.dialogValideSuivant = false;
                    this.loadMissionsAvalider;
                    break;
                case "demandeFond":
                    this.dialogValideSuivant = false;
                    this.loadDmdFond();
                    break;
            }
        },
        showDialogDmdAfter: function showDialogDmdAfter(idDmd, type) {
            this.showModalDetailDmd = false;
            this.listeDemandes = this.listeDemandes.filter(function (elm) {
                return elm.idDemande != idDmd;
            });

            if (this.listeDemandes.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDemandes[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadDemandeAvalider();
            }
        },
        showDialogDmdFondAfter: function showDialogDmdFondAfter(idDmd, type) {
            this.showModalDetailDmdFond = false;
            this.listeDmdFond = this.listeDmdFond.filter(function (elm) {
                return elm.id != idDmd;
            });

            if (this.listeDmdFond.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDmdFond[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadDmdFond();
            }
        },
        showDialogDmdComAfter: function showDialogDmdComAfter(idDmd, type) {
            this.showModalDetailDmdCom = false;
            this.listeDmdCom = this.listeDmdCom.filter(function (elm) {
                return elm.id != idDmd;
            });

            if (this.listeDmdCom.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDmdCom[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadDmdCom();
            }
        },
        showDialogFactAfter: function showDialogFactAfter(idDmd, type) {
            this.listCaisse = [];
            this.listBanque = [];
            this.showModalDetailFact = false;
            this.loadFacture();
            this.listeFacturesFour = this.listeFacturesFour.filter(function (elm) {
                return elm.idFact != idDmd;
            });

            if (this.listeFacturesFour.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeFacturesFour[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadFacture();
            }
        },
        showDialogMissAfter: function showDialogMissAfter(idDmd, type) {
            this.showModalDetailMiss = false;
            this.listeMissions = this.listeMissions.filter(function (elm) {
                return elm.IdUtil != idDmd;
            });

            if (this.listeMissions.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeMissions[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadMissionsAvalider();
            }
        },
        showDialogIntervAfter: function showDialogIntervAfter(idDmd, type) {
            this.showModalIntervFact = false;
            this.listeIntervention = this.listeIntervention.filter(function (elm) {
                return elm.intervId != idDmd;
            });

            if (this.listeIntervention.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeIntervention[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadDmdIntervention();
            }
        },
        showDialogComAfter: function showDialogComAfter(idDmd, type) {
            this.showModalDetailDmdCom = false;
            this.loadDmdCom();
        },


        //DEMANDE DE MAINTENANCE
        modalDetailDmd: function modalDetailDmd(item) {
            this.demandeDetail = item;
            this.showModalDetailDmd = true;
        },
        filtrerZoneDmd: function filtrerZoneDmd(idZone) {
            this.loadDmdParZone(idZone);
        },
        loadLieu: function loadLieu() {
            var _this = this;

            var url = this.domaine + 'validationDG/lieu';
            this.$http.get(url).then(function (response) {
                _this.comboZoneDmd = response.body.lieux;
            }, function (erreurRep) {});
        },
        loadDmdParZone: function loadDmdParZone(idZone) {
            this.legendeDmd = "LISTE DES DEMANDES DE MAINTENANCES A VALIDER FILTREES PAR ZONE";
            this.listeDemandes = this.oldListDemandes;
            this.listeDemandes = this.listeDemandes.filter(function (item) {
                return item.idZone == idZone;
            });
        },
        clearSelectDmdZone: function clearSelectDmdZone() {
            this.listeDemandes = this.oldListDemandes;
            this.legendeDmd = "LISTE DES DEMANDES DE MAINTENANCES A VALIDER";
        },
        loadDemandeAvalider: function loadDemandeAvalider() {
            var _this2 = this;

            this.loading = true;
            var url = this.domaine + 'validationDG/index/demandes';
            this.$http.get(url).then(function (response) {
                _this2.oldListDemandes = response.body.listeDemandes;
                _this2.listeDemandes = response.body.listeDemandes;
                _this2.mntTTCAValide = response.body.mntTTC;
                _this2.nbDmdMaint = response.body.nbMaint;
                _this2.loadLieu();
                _this2.loading = false;
            }, function (erreur) {
                _this2.loading = false;
                _this2.$message.error("Une erreur est survenue lors du chargement des demandes de maintenances'");
            });
        },


        //DEMANDE DE MISSION
        filtrerMissDemd: function filtrerMissDemd(idDemd) {
            this.loadMissionDemd(idDemd);
        },
        clearSelectMissDemd: function clearSelectMissDemd() {
            this.listeMissions = this.oldListMissions;
            this.legendeMiss = "LISTE DES DEMANDES DE MISSION A VALIDER";
        },
        loadMissionDemd: function loadMissionDemd(idDemd) {
            this.legendeMiss = "LISTE DES DEMANDES DE MISSION A VALIDER FILTREES PAR DEMANDEUR";
            this.listeMissions = this.oldListMissions;
            this.listeMissions = this.listeMissions.filter(function (item) {
                return item.idUserDemandeur == idDemd;
            });
        },
        loadMissionsAvalider: function loadMissionsAvalider() {
            var _this3 = this;

            var url = this.domaine + "validationDG/index/missions";
            this.$http.get(url).then(function (resp) {
                _this3.oldListMissions = resp.body.missions, _this3.listeMissions = resp.body.missions, _this3.nbMiss = resp.body.nbUtil, _this3.listeDemandeurs = resp.body.listeDemandeurs;
                _this3.mntTotalMissTTC = resp.body.mntTotalTTC;
            }, function (resp) {
                _this3.$message.error("erreur lors du chargement des missions.");
            });
        },
        modalDetailMissDemd: function modalDetailMissDemd(item) {
            this.detailMission = item;
            this.showModalDetailMiss = true;
        },


        //FACTURE FOURNISSEUR
        clearSelectFour: function clearSelectFour() {
            this.listeFacturesFour = this.oldListFacturesFour;
            this.legendeFour = "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER";
        },
        modalDetailFour: function modalDetailFour(item) {
            this.listBanque = [];
            this.listCaisse = [];
            if (item.listBanque.length == 0) {
                this.loadAllBanque();
            } else {
                this.listBanque = item.listBanque;
                this.listCaisse = item.listCaisse;
            }
            this.factureDetail = item;
            this.showModalDetailFact = true;
            this.showModalDetailFact = true;
            this.commandeDerivDeux = [];
            this.commandeDeriv = [];
            this.showDialogComparaison(item);
        },
        modalDetailDmdFond: function modalDetailDmdFond(item) {
            this.demandeDetail = item;
            this.showModalDetailDmdFond = true;
        },
        modalDetailDmdCom: function modalDetailDmdCom(ligne) {
            var _this4 = this;

            // this.loading = true
            this.demandeDetail = ligne;
            this.showModalDetailDmdCom = true;
            this.commCourant = ligne;
            var totalHT = 0;
            var totalTVA = 0;
            var totalRemise = 0;

            for (var option in this.commCourant.option) {
                var item = this.commCourant.option[option];
                var tmpTotalHTSRem = parseInt(item.prix * item.qte, 10);
                var mntRemise = 0;
                var remise = parseInt(item.remise, 10);
                if (remise > 0) {
                    mntRemise = tmpTotalHTSRem * remise / 100;
                }

                var tmpTotalHT = tmpTotalHTSRem - mntRemise;
                var tva = parseInt(item.tva, 10);
                var tmpTotalTVA = tmpTotalHT * (tva / 100);
                totalTVA += tmpTotalTVA;
                totalHT += tmpTotalHT;
                totalRemise += mntRemise;
            }
            this.totalComHT = new Intl.NumberFormat('fr-Fr').format(totalHT);
            this.totalComTVA = new Intl.NumberFormat('fr-Fr').format(totalTVA);
            this.totalComRemise = new Intl.NumberFormat('fr-Fr').format(totalRemise);
            var url = this.domaine + 'fournisseur/' + this.commCourant.id + '/show/commande';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this4.detailCommande = response.body.commande;

                    _this4.optionLivr = _this4.detailCommande.optionLivr;
                    _this4.loading = false;
                }
            });
        }
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'clearSelectFour', function clearSelectFour() {
        this.listeFacturesFour = this.oldListFacturesFour;
        this.legendeFour = "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER";
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'showDialogComparaison', function showDialogComparaison(item) {
        var _this5 = this;

        // this.loading = true;
        var smsAficher = "Aucune tarification de ce produit est indiqué chez vous fournisseurs ";
        var mesProdPrixNulle = "Les produits de cette commande ne se trouvent chez aucun autres de vos fournisseurs ";

        var formdata = new FormData();
        var url = this.domaine + "comparateur/new/commande";
        var options = [];
        var listProdPrixNulle = [];

        for (var prop in item.option) {
            var ligne = item.option[prop];
            options.push(ligne.id);
        }
        formdata.append("options", options);
        formdata.append("facture", 1);
        formdata.append("typeOption", 2); //optionBesoin

        this.$http.post(url, formdata).then(function (response) {
            //affichage des messages
            var nbCmd = 0;
            var nbCmdDeux = 0;
            var listeFoun = [];
            var listeNull = [];
            var listeFounSecond = [];

            var respFour = response.body.fournisseurs[0];
            _this5.mntTotalCmd = response.body.mntTotauxFormat;
            _this5.listeProdNull = response.body.listeProdNull;

            _this5.loading = false;
            for (var four in respFour) {
                var listeProduit = respFour[four];
                var infoFour = {
                    fournisseur: four,
                    produits: [],
                    mntTotal: 0,
                    mntTotalHt: 0

                };
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(listeProduit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var produit = _step.value;

                        infoFour.produits.push(produit);
                        infoFour.mntTotal += parseFloat(produit.mntTotal);
                        infoFour.mntTotalHt += parseFloat(produit.mntTotalHt);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                if (infoFour.produits.length == options.length) {
                    nbCmd++;
                    listeFoun.push(infoFour);
                } else {
                    nbCmdDeux++;

                    listeFounSecond.push(infoFour);
                }
            }
            _this5.nbCommandeSug = nbCmd;
            _this5.commandeDeriv = listeFoun;
            _this5.nbCommandeSugDeux = nbCmdDeux;
            _this5.commandeDerivDeux = listeFounSecond;
            // this.dialogDetailCmd = true;
            _this5.loading = false;
            //AFFICHAGE DE PRODUITS DONT LE MONTANT EST NULL
            if (response.body.listeProdNull.length > 0) {
                // this.dialogProdNull = true;
                //this.closeProdNull();
            }

            if (listeFoun.length > 0) {
                _this5.showModalCompCmd = true;
            }
            // }
        }, function (error) {
            _this5.loading = false;
            _this5.$message.error("Erreur serveur");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'filtrerFour', function filtrerFour() {
        var _this6 = this;

        // this.loadFactParFour(this.selectFour)
        var tab = this.listeFournisseurs;
        var newTab = [];
        this.listeFournisseurs = tab.filter(function (item) {
            if (item.value == _this6.selectFour) {
                newTab.push(item);
            }
            return newTab;
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'modalDetailAppro', function modalDetailAppro(item) {
        this.ApproDetail = item;
        this.showModalDetailAppro = true;
        this.loadListBanque(item.caisseId);
        this.loadListCaisse(item.caisseId);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadListBanque', function loadListBanque(item) {
        var _this7 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/tresor/' + item + '/banque';
        this.$http.get(url).then(function (response) {
            _this7.listBanque = response.body.listBanque;
            _this7.loading = false;
        }, function (errResp) {
            _this7.loading = false;
            _this7.$message.error("Une erreur est survenue lors du chargement de la liste banque");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadListCaisse', function loadListCaisse(item) {
        var _this8 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/tresor/' + item + '/caisse';
        this.$http.get(url).then(function (response) {
            _this8.listCaisse = response.body.listCaisse;
            _this8.loading = false;
        }, function (errResp) {
            _this8.loading = false;
            _this8.$message.error("Une erreur est survenue lors du chargement de la liste caisse");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadAllBanque', function loadAllBanque() {
        var _this9 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/tresor/banque';
        this.$http.get(url).then(function (response) {
            _this9.listBanque = response.body.listBanque;
            _this9.listCaisse = response.body.listCaisse;
            _this9.loading = false;
        }, function (errResp) {
            _this9.loading = false;
            _this9.$message.error("Une erreur est survenue lors du chargement de la liste banque");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadAllCaisse', function loadAllCaisse() {
        var _this10 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/tresor/caisse';
        this.$http.get(url).then(function (response) {
            _this10.listCaisse = response.body.listCaisse;
            _this10.loading = false;
        }, function (errResp) {
            _this10.loading = false;
            _this10.$message.error("Une erreur est survenue lors du chargement de la liste caisse");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadFactParFour', function loadFactParFour(idFour) {
        this.legendeFour = "LISTE DES DEVIS / FACTURES A VALIDER FILTREES PAR FOURNISSEUR";
        this.listeFacturesFour = this.oldListFacturesFour;
        this.listeFacturesFour = this.listeFacturesFour.filter(function (item) {
            return item.idUserDemandeur == idFour;
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadFacture', function loadFacture() {
        var _this11 = this;

        this.loading = true;
        var url = this.domaine + 'validationDG/fournisseur/facture';
        this.$http.get(url).then(function (response) {
            _this11.listeFournisseurs = response.body.listeFour;
            _this11.mntTotalFactTTC = response.body.totalFacture;
            _this11.nbFactFour = response.body.nbFact;
            _this11.listeFacturesFour = response.body.facture;
            _this11.oldListFacturesFour = response.body.facture;
            _this11.loading = false;
        }, function (resp) {
            _this11.$message.error("erreur lors du chargement des devis / factures fournisseurs.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'modalDetailInterv', function modalDetailInterv(item) {
        this.intervDetail = item;
        this.showModalIntervFact = true;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'clearSelectInterv', function clearSelectInterv() {
        this.listeIntervention = this.oldListeIntervention;
        this.legendeInterv = "LISTE DES REPARATIONS A VALIDER";
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'filtrerInterv', function filtrerInterv(idDemandeur) {
        this.loadDmdParInterv(idDemandeur);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdParInterv', function loadDmdParInterv(idDemandeur) {
        this.legendeInterv = "LISTE DES REPARATIONS A VALIDER FILTREES PAR DEMANDEUR";
        this.listeIntervention = this.oldListeIntervention;
        this.listeIntervention = this.oldListeIntervention.filter(function (item) {
            return item.idDemandeur == idDemandeur;
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdIntervention', function loadDmdIntervention() {
        var _this12 = this;

        this.loading = true;
        var url = this.domaine + 'validationDG/intervention/facture';
        this.$http.get(url).then(function (response) {
            _this12.listeIntervention = response.body.listeInterv;
            _this12.oldListeIntervention = response.body.listeInterv;
            _this12.mntTotalIntervTTC = response.body.mntTotal;
            _this12.nbInterv = response.body.nbInterv;
            _this12.listeDemdInterv = response.body.listeDemdInterv;
            _this12.loading = false;
        }, function (resp) {
            _this12.$message.error("erreur lors du chargement des demandes reparations.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'filtrerDmdFond', function filtrerDmdFond(idDemd) {
        this.loadDmdFond(idDemd);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'filtrerDmdCom', function filtrerDmdCom(idDemd) {
        this.loadDmdFond(idDemd);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdCom', function loadDmdCom() {
        var _this13 = this;

        this.loading = true;
        var url = '';
        if (droitAcces.valider1_bci) {
            url = this.domaine + "besoin/index/boncommande/2/recent";
        } else if (droitAcces.valider2_bci) {
            url = this.domaine + "besoin/index/boncommande/2/recent";
        }

        this.$http.get(url).then(function (response) {
            var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(response.body.besoin);
            _this13.listeDmdCom = data;
            _this13.oldListeDmdCom = data;
            _this13.loading = false;
        }, function (resp) {
            _this13.loading = false;
            _this13.$message.error("erreur lors du chargement des demandes de fonds.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdFond', function loadDmdFond() {
        var _this14 = this;

        this.loading = true;
        var url = this.domaine + 'validationDG/dmdFond/liste';
        this.$http.get(url).then(function (response) {
            _this14.listeDmdFond = response.body.listeDmdFond;
            _this14.oldListeDmdFond = response.body.listeDmdFond;
            _this14.mntTotalDmdFondTTC = response.body.mntTotal;
            _this14.nbDmdFond = response.body.nbDmdFond;
            _this14.listeDemandeurFond = response.body.listeDemandeurFond;
            _this14.loading = false;
        }, function (resp) {
            _this14.loading = false;
            _this14.$message.error("erreur lors du chargement des demandes de fonds.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdNoValidAppro', function loadDmdNoValidAppro() {
        var _this15 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/appro/no-valide-dg/all';
        this.$http.get(url).then(function (response) {
            _this15.listeDmdNoValidAppro = response.body.appro;
            _this15.mntTotalAppro = response.body.totDmdAppro;
            _this15.nbAppro = response.body.nbAppro;
            _this15.loading = false;
        }, function (resp) {
            _this15.$message.error("erreur lors du chargement des demandes approvisionnement.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'handleTabClick', function handleTabClick(tab) {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'clearSelectDmd', function clearSelectDmd() {
        this.listeFacturesFour = this.oldListFacturesFour;
        this.legendeFour = "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER";
    }), _methods),

    mounted: function mounted() {
        this.loadDemandeAvalider();
        this.loadMissionsAvalider();
        this.loadFacture();
        this.loadDmdIntervention();
        this.loadDmdFond();
        this.loadDmdCom();
        this.loadDmdNoValidAppro();
    }
});

/***/ }),

/***/ "34zc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","xs12":""}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%"},model:{value:(_vm.dialogAjoutBudget),callback:function ($$v) {_vm.dialogAjoutBudget=$$v},expression:"dialogAjoutBudget"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter des Tarifications ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeTypeTravaux}},[_c('el-table-column',{attrs:{"prop":"type","label":"TYPE RESSOURCE","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.type)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"PRODUIT CONCERNE","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.libelle)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"UNITE","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.unite)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"PRIX D'ACHAT (FCFA)","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.montant)+"\n                                    ")])]}}])})],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"orange","dark":""},on:{"click":function($event){return _vm.closeDialog()}},slot:"activator"},[_vm._v("Anuller "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"green","dark":""},on:{"click":function($event){return _vm.saveListe()}},slot:"activator"},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "382i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Besoin_vue__ = __webpack_require__("+Ebi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b90560_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Besoin_vue__ = __webpack_require__("Jsos");
function injectStyle (ssrContext) {
  __webpack_require__("sAkm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Besoin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35b90560_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Besoin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "38y9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  data: function data() {
    return {
      loading: false,
      domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
      userCon: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
      racourcis: [{ path: '/', text: 'Accueil', disabled: false }, { path: '/maintenance', text: 'Maintenance', disabled: false }, { path: '/demande', text: 'Demande', disabled: false }, { path: '/', text: 'Détails de la demande', disabled: true }],
      valid: true,
      dialogAjoutCst: false,
      dialogAjoutValid: false,
      dialogEdit: false,
      dialogShow: false,
      dialogSupr: false,
      dialogImageUrl: '',
      dialogVisible: false,
      id_dmd: this.$route.params.demande_id,
      detailDemande: [],
      constat: {
        fichier: { url: '' },
        descRmq: '',
        nomPrenSuperv: null,
        selectCat: null
      },
      msgInfo: 0,
      search_constat: '',
      headers_constat: [{ text: 'Référence', align: 'center', sortable: false, value: 'ref' }, { text: 'Superviseur', align: 'center', sortable: false, value: 'superviseur' }, { text: 'Etat', align: 'center', sortable: false, value: 'etat' }, { text: 'Catégorie', align: 'center', sortable: false, value: 'categorie' }, { text: 'Actions', align: 'center' }],
      listParam: [],
      listCategorie: [],
      listConstat: [],
      detailConstat: [],
      constatCourant: [],
      idConst: '',
      validation: [{ text: 'VALIDER', value: 1 }, { text: 'REFUSE', value: 2 }],
      slectValidation: null,
      descriptionValid: '',
      users: []
    };
  },
  mounted: function mounted() {
    this.loadPage();
    this.loadUser();
    this.loadCategorie();
    this.loadParametre();
    this.loadDemande();
    this.loadConstat();
  },

  methods: {
    loadPage: function loadPage() {
      var loading = this.$loading({
        lock: true,
        text: 'Veuillez patientez ...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(function () {
        loading.close();
      }, 1000);
    },
    loadUser: function loadUser() {
      var _this = this;

      var url = this.domaine + 'userCreate/user-list';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this.users = response.body;
        }
      });
    },
    loadDemande: function loadDemande() {
      var _this2 = this;

      if (this.$route.params.demande_id != 0) {
        var url = this.domaine + 'demande/' + this.id_dmd + '/show';
        this.$http.get(url).then(function (response) {
          _this2.detailDemande = response.body.demande;
        });
      }
    },
    loadCategorie: function loadCategorie() {
      var _this3 = this;

      var url = this.domaine + 'demande/index/categorie';
      this.$http.get(url).then(function (response) {
        _this3.listCategorie = response.body.listCats;
      });
    },
    loadParametre: function loadParametre() {
      var _this4 = this;

      var url = domaine + 'webService/index/parametre';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this4.listParam = response.body.param;
        }
      });
    },
    loadConstat: function loadConstat() {
      var _this5 = this;

      var url = this.domaine + 'demande/' + this.id_dmd + '/index/constat';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this5.listConstat = response.body.constat;
        }
      });
    },
    newConstat: function newConstat() {
      this.dialogAjoutCst = true;
      this.dialogEdit = false;
      this.constat = {
        fichier: { url: '' },
        descRmq: '',
        nomPrenSuperv: null,
        selectCat: null
      };
    },
    newValidation: function newValidation(ligne) {
      this.constatCourant = ligne;
      this.dialogAjoutValid = true;
      this.slectValidation = null;
      this.descriptionValid = '';
    },
    editConstat: function editConstat(ligne) {
      this.constatCourant = ligne;
      this.dialogAjoutCst = true;
      this.dialogEdit = true;
      this.constat = {
        fichier: { url: '' },
        descRmq: ligne.description,
        nomPrenSuperv: ligne.idSup,
        selectCat: ligne.idCat
      };
    },
    showConstat: function showConstat(ligne) {
      var _this6 = this;

      this.dialogShow = true;
      this.constatCourant = ligne;
      var url = this.domaine + 'demande/' + this.constatCourant.id + '/show/constat';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this6.detailConstat = response.body.constat;
        }
      });
    },
    submit: function submit() {
      var _this7 = this;

      this.loading = true;
      if (this.$refs.formConstat.validate()) {
        var form = document.getElementById('formConstat');
        var data = new FormData(form);
        var url = this.domaine + 'demande/constat';
        data.append('idUser', this.userCon.id);
        data.append('id_dmd', this.detailDemande.id_dmd);
        data.append('id_cat', this.constat.selectCat);
        data.append('prestataire', this.listParam.prestataire);
        if (this.constatCourant.id) {
          data.append('id', this.constatCourant.id);
        } else {
          data.append('id', '');
        }
        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              if (_this7.constatCourant.id) {
                _this7.$notify({
                  title: 'MODIFICATION REUSSI',
                  message: 'Constat modifié avec succès.',
                  type: 'success',
                  position: 'top-center'
                });
              } else {
                _this7.$notify({
                  title: 'ENREGISTREMENT REUSSI',
                  message: 'Constat enregistré avec succès.',
                  type: 'success',
                  position: 'top-center'
                });
              }

              _this7.dialogAjoutCst = false;
              _this7.loading = false;
              _this7.loadConstat();
              _this7.loadPage();
              _this7.$refs.formConstat.reset();
            } else if (verif.code === 1) {
              _this7.$message.error(verif.message);
              _this7.loading = false;
            } else if (verif.code === 0) {
              _this7.$message.error(verif.message);
              _this7.loading = false;
            }
          } else {
            _this7.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
            _this7.loading = false;
          }
        }, function (response) {
          _this7.loading = false;
          _this7.$message.error("Erreur lors de l'ajout du constat");
        });
      } else {
        this.$message.error('Veuillez renseigner les champs obligatoires');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le constat n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    submitValider: function submitValider() {
      var _this8 = this;

      this.loading = true;
      if (this.$refs.formValidation.validate()) {
        var form = document.getElementById('formValidation');
        var data = new FormData(form);
        var url = this.domaine + 'demande/' + this.constatCourant.id + '/valider/constat';
        data.append('idUser', this.userCon.id);
        data.append('validation', this.slectValidation);

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this8.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: 'Validation enregistré avec succès.',
                type: 'success',
                position: 'top-center'
              });

              _this8.dialogAjoutValid = false;
              _this8.loading = false;
              _this8.loadConstat();
              _this8.loadPage();
              _this8.$refs.formValidation.reset();
            } else if (verif.code === 0) {
              _this8.$message.error(verif.message);
              _this8.loading = false;
            }
          } else {
            _this8.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
            _this8.loading = false;
          }
        }, function (response) {
          _this8.loading = false;
          _this8.$message.error("Erreur lors de l'ajout");
        });
      } else {
        this.$message.error('Veuillez renseigner les champs obligatoires');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La validation n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    deleteConst: function deleteConst() {
      var _this9 = this;

      var url = this.domaine + 'demande/' + this.idConst + '/delete/constat';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this9.$notify({
            title: 'SUPPRESSION',
            message: 'Constat supprimé avec succès.',
            type: 'success',
            position: 'top-center'
          });
          _this9.dialogSupr = false;
          _this9.loadConstat();
          _this9.loadPage();
        }
      });
    },
    handleRemove: function handleRemove(file, fileList) {},
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  },
  beforeMount: function beforeMount() {
    if (!this.roleAcces[this.$router.history.current.name]) {
      this.$router.push({ name: 'Home' });
    }
  }
});

/***/ }),

/***/ "3Vbc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3jxz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailIntervention_vue__ = __webpack_require__("NE5R");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d24cf242_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailIntervention_vue__ = __webpack_require__("Nb+n");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailIntervention_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d24cf242_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailIntervention_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3lq4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n              LISTE DES PROJETS\n            ")]),_vm._v(" "),_c('v-layout',{staticClass:"mb-3"},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-chip',{staticStyle:{"font-size":"19px","width":"90%"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(" "+_vm._s(_vm.listeProjet.length)+" ")]),_vm._v("\n                        Projet(S)\n                      ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"card l-bg-orange-dark"},[_c('div',{staticClass:"card-statistic-3 p-4"},[_c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("MONTANT TOTAL BUDGET VALIDE ")]),_vm._v(" "),_c('h5',{attrs:{"id":"price"}},[_vm._v("(Somme de tous budgets validés)")])]),_vm._v(" "),_c('div',{staticClass:"row  align-items-center mb-2 d-flex"},[_c('div',{staticClass:"col-8"},[_c('h1',{attrs:{"id":"price"}},[_vm._v("\n                                          "+_vm._s(new Intl.NumberFormat().format(_vm.listeRapport.mntTotalBugValidePro))+" FCFA\n                                          ")])])])])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('div',{staticClass:"col-xl-3 ml-2"},[_c('div',{staticClass:"card l-bg-red-dark"},[_c('div',{staticClass:"card-statistic-3 p-4"},[_c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("MONTANT TOTAL ENGAGÉ ")]),_vm._v(" "),_c('h5',{attrs:{"id":"price"}},[_vm._v("(Somme des montants décaissés)")])]),_vm._v(" "),_c('div',{staticClass:"row  align-items-center mb-2 d-flex"},[_c('div',{staticClass:"col-8"},[_c('h1',{attrs:{"id":"price"}},[_vm._v("\n                                          "+_vm._s(new Intl.NumberFormat().format(_vm.listeRapport.mntTotalDecaissePro))+" FCFA\n                                          ")])])])])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('div',{staticClass:"col-xl-3 ml-2"},[_c('div',{staticClass:"card l-bg-green-dark"},[_c('div',{staticClass:"card-statistic-3 p-4"},[_c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("MARGE REELLE")]),_vm._v(" "),_c('h5',{attrs:{"id":"price"}},[_vm._v("(Montant du marché - Total des factures payées)")])]),_vm._v(" "),_c('div',{staticClass:"row  align-items-center mb-2 d-flex"},[_c('div',{staticClass:"col-8"},[_c('h1',{attrs:{"id":"price"}},[_vm._v("\n                                            "+_vm._s(new Intl.NumberFormat().format(_vm.listeRapport.mntmargePro))+" FCFA\n                                          ")])])])])])])])],1),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeProjet}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',{staticClass:"elevation-3 pl-4 pr-4 pt-2"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple mb-2"},[_c('v-alert',{staticClass:"mb-4",attrs:{"value":true,"outline":"","color":"primary","icon":"info"}},[_vm._v("DETAILS DES CHANTIERS\n                                ")]),_vm._v(" "),_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":props.row.chantier,"summary-method":_vm.getSummDetailBudget,"show-summary":""}},[_c('el-table-column',{attrs:{"align":"center","prop":"libelle","label":"LIBELLE CHANTIER"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"chefChantier","label":"CHEF CHANTIER"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((scope.row.chefChantier),function(item,index){return _c('span',{key:index},[_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":""}},[_vm._v(" "+_vm._s(item)+"  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("person")])],1),_vm._v("/\n                                        ")],1)})}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"budget","label":"BUDGET VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"success","label":"","color":"success"}},[_vm._v("\n                                         "+_vm._s(new Intl.NumberFormat().format( scope.row.mntTotalChantierValide))+" FCFA "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_atm")])],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecartBudget","label":"MONTANT ENGAGÉ","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                           "+_vm._s(new Intl.NumberFormat().format( scope.row.mntDepense))+" FCFA "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_atm")])],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecartBudget","label":"ECART BUDGET","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('v-chip',{attrs:{"label":"","outline":"","color":"primary"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(prop.row.ecartBudget))+"\n                                          FCFA "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_atm")])],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Evolution","prop":"evolution"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-progress-circular',{attrs:{"size":85,"width":15,"rotate":360,"value":scope.row.evolution,"color":"primary"}},[_vm._v(_vm._s(scope.row.evolution)+" %")])]}}],null,true)})],1)],1)],1)])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Libelle projet","prop":"libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Chef projet","prop":"chef"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.chef)+"\n                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("person")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Nombre chantier","prop":"nbrChantier"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.nbrChantier)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Total budget validé","prop":"mtDqe"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"success","label":"","color":"success"}},[_vm._v("\n                              "+_vm._s(new Intl.NumberFormat().format(scope.row.mntBudgetValidePro))+" FCFA "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_atm")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Montant dépensé","prop":"mtDqe"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                              "+_vm._s(scope.row.montantTotalDepenseNbr)+" FCFA "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_atm")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Marge réelle","prop":"marge"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"success","label":"","color":"success"}},[_vm._v("\n                            "+_vm._s(scope.row.marge)+" FCFA "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_atm")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Evolution","prop":"evolution"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-progress-circular',{attrs:{"size":85,"width":15,"rotate":360,"value":scope.row.evolution,"color":"primary"}},[_vm._v(_vm._s(scope.row.evolutionNbr)+" %")])]}}])})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3mFV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4+bD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Gjo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_boardChantier_dashboard_chantier__ = __webpack_require__("4pCO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Oq2I");
__webpack_require__("miEh");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */], DashboardChantier: __WEBPACK_IMPORTED_MODULE_2__components_boardChantier_dashboard_chantier__["a" /* default */] },
  name: "Chantier_index",
  props: {
    listeChantiers: {
      type: Array
    },
    userAdmin: {
      type: Boolean
    },
    commis: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      detailChantier: {},
      valid: true,
      dialogEdit: false,
      showDetailChantier: false,
      dialogEquipe: false,
      dialogAjoutOuvrier: false,
      editForm: false,
      logoOuvrier: "/static/img-doc.png",

      listTravaux: [],
      listTaches: [],
      selectTravaux: [],
      selectTaches: [],
      dialogSuprTyp: false,
      IdRessTeck: '',

      totalChantEnCours: 0,
      totalChantEnArret: 0,
      totalChantTermine: 0,
      chantierCourant: [],
      equipeCourant: [],
      showListOuvrier: false,
      listeOuvriers: [],
      listOuvrier: [],
      optionE: [],
      listePrestataires: [],
      selectType: "",
      formManoeuvre: {
        nom: "",
        matricule: "",
        domicile: "",
        profession: "",
        piece: "",
        numPiece: "",
        contact: "",
        dateNaiss: "",
        dateD: "",
        dateF: "",
        montant: "",
        montantSuppN: "",
        montantSupp: "",
        id: ""
      },
      rulesformManoeuvre: {
        nom: [{ required: true, message: "Saisir un nom", trigger: "blur" }],
        matricule: [{ required: true, message: "Saisir un matricule", trigger: "blur" }],
        piece: [{
          required: true,
          message: "Saisir le type de piece",
          trigger: "blur"
        }],
        numPiece: [{
          required: true,
          message: "Saisir le numero de la piece",
          trigger: "blur"
        }],
        contact: [{
          required: true,
          message: "Saisir un numéro de téléphone",
          trigger: "blur"
        }]
      },
      optionEquipe: [{
        key: 1,
        type: [{ text: "Prestataire", value: 1 }, { text: "Ouvrier/Manoeuvre", value: 2 }],
        selectType: "",
        fournisseur: "",
        ouvrier: "",
        duree: "",
        montant: 0,
        montantSupp: 0,
        id: ""
      }]
    };
  },

  computed: {},
  watch: {
    listeChantiers: function listeChantiers(newValue, oldValue) {
      var _this = this;

      this.totalChantEnCours = 0;
      this.totalChantEnArret = 0;
      this.totalChantTermine = 0;
      this.listeChantiers.forEach(function (elt) {
        if (elt.etat == 1) {
          _this.totalChantEnCours++;
        } else if (elt.etat == 2) {
          _this.totalChantEnArret++;
        } else if (elt.etat == 3) {
          _this.totalChantTermine++;
        }
      }, this);
    }
  },
  imprimeChaniter: function imprimeChaniter() {
    var idEtat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    var url = this.domaine + "mission/impression/liste/" + idEtat;
    window.open(url);
  },

  methods: {
    modalDetail: function modalDetail(item) {
      this.detailChantier = item;
      this.showDetailChantier = true;
    },
    editRessources: function editRessources(item) {
      console.log('item', item);
      this.dialogAjoutOuvrier = true;
      this.editForm = true;
      this.formManoeuvre.matricule = item.matricule;
      this.formManoeuvre.nom = item.nom;
      this.formManoeuvre.domicile = item.domicile;
      this.formManoeuvre.profession = item.profession;
      this.formManoeuvre.contact = item.contact;
      this.formManoeuvre.piece = item.piece;
      this.formManoeuvre.numPiece = item.numPiece;
      var dateNaissISO = item.dateNaiss.split('-').reverse().join('-');
      this.formManoeuvre.dateNaiss = new Date(dateNaissISO);
      this.formManoeuvre.id = item.id;
      var dateDISO = item.dateD.split('-').reverse().join('-');
      var dateFISO = item.dateF.split('-').reverse().join('-');

      this.formManoeuvre.dateD = new Date(dateDISO);
      this.formManoeuvre.dateF = new Date(dateFISO);
      this.formManoeuvre.montant = item.montantN;
      this.formManoeuvre.montantSupp = item.montantSuppN;
    },
    deleteType: function deleteType() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "ouvrier/" + this.IdRessTeck + "/chantier/" + this.chantierCourant.id;
      this.$http.get(url).then(function (response) {
        _this2.loading = false;
        _this2.$notify({
          title: "SUPPRESSION",
          message: response.message,
          type: "warning",
          position: "top-center"
        });
        _this2.dialogSuprTyp = false;
        _this2.loadListeOuvrier(_this2.chantierCourant.id);
      });
    },
    newEquipe: function newEquipe(item) {
      this.showListOuvrier = true;
      this.chantierCourant = item;
      this.loadListeOuvrier(item.id);
    },
    addOptionEquipe: function addOptionEquipe() {
      if (this.chantierCourant.soutraite == 1) {
        this.optionEquipe.push({
          key: Date.now(),
          type: [{ text: "Prestataire", value: 1 }],
          selectType: 1,
          fournisseur: this.chantierCourant.idFour,
          ouvrier: "",
          duree: "",
          montant: 0,
          montantSupp: 0,
          selectTravaux: [],
          selectTaches: [],
          id: ""
        });
      } else {
        this.optionEquipe.push({
          key: Date.now(),
          type: [{ text: "Prestataire", value: 1 }, { text: "Manoeuvre", value: 2 }],
          selectType: "",
          fournisseur: "",
          ouvrier: "",
          duree: "",
          montant: 0,
          montantSupp: 0,
          id: ""
        });
      }

      this.totComLigneTTC += 5;
    },
    onFileImageOuvrierPicked: function onFileImageOuvrierPicked(event) {
      var _this3 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this3.logoOuvrier = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoOuvrier = files[0];
    },
    submitformManoeuvre: function submitformManoeuvre(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.loading = true;
          // enregistrement des ouvriers

          var url = _this4.domaine + (_this4.editForm ? "ouvrier/edit/" + _this4.formManoeuvre.id : "ouvrier/new");
          var form = document.getElementById("formManoeuvre");
          var data = new FormData(form);

          data.append("nom", _this4.formManoeuvre.nom);
          data.append("matricule", _this4.formManoeuvre.matricule);
          data.append("domicile", _this4.formManoeuvre.domicile);
          data.append("profession", _this4.formManoeuvre.profession);
          data.append("piece", _this4.formManoeuvre.piece);
          data.append("contact", _this4.formManoeuvre.contact);
          data.append("numPiece", _this4.formManoeuvre.numPiece);

          console.log(data);

          console.log('ici');

          if (_this4.editForm) {
            data.append("montant", _this4.formManoeuvre.montant);
            data.append("montantSupp", _this4.formManoeuvre.montantSupp);
            data.append("chantier", _this4.chantierCourant.id);
            var dateNaissISO = new Date(_this4.formManoeuvre.dateNaiss).toISOString().split('T')[0];
            var dateFISO = new Date(_this4.formManoeuvre.dateF).toISOString().split('T')[0];
            var dateDISO = new Date(_this4.formManoeuvre.dateD).toISOString().split('T')[0];
            data.append("dateD", dateDISO);
            data.append("dateNaiss", dateNaissISO);
            data.append("dateF", dateFISO);
          } else {
            data.append("dateNaiss", _this4.formManoeuvre.dateNaiss);
          }

          // else {
          //   data.append("dateNaiss", this.formManoeuvre.dateNais);
          // }
          _this4.$http.post(url, data).then(function (response) {
            if (_this4.editForm) {
              _this4.loadListeOuvrier(_this4.chantierCourant.id);
            } else {
              _this4.loadOuvrier();
            }

            _this4.loading = false;
            _this4.dialogAjoutOuvrier = false;
            _this4.$message({
              message: "L'enregistrement sest deroule avec succes ",
              type: "success"
            });
          }, function (response) {
            _this4.loading = false;
            _this4.$message.error("Erreur lors de l'enregistrement d'un manoeuvre ");
          });
        }
      });
    },
    submitEquipe: function submitEquipe() {
      var _this5 = this;

      this.loading = true;
      if (this.$refs.formEquipe.validate()) {
        var etat = false;
        var form = document.getElementById("formEquipe");
        var data = new FormData(form);
        var url = "";
        // if (this.chantierCourant.id != "") {
        //   url =
        //     this.domaine + "projet/" + this.chantierCourant.id + "/edit/contrat";
        //   etat = true;
        // } else {
        url = this.domaine + "projet/" + this.chantierCourant.id + "/new/equipe";
        var ligne = null;
        for (var prop in this.optionEquipe) {
          ligne = this.optionEquipe[prop];

          // date selectionnée
          var tabDateFin = ligne.duree[1].split("-"); //["16","08","2018 00:00:00"]
          var jr = tabDateFin[0];
          var mois = tabDateFin[1];
          var annee = tabDateFin[2].split(" ")[0];
          var dateFin = annee + "-" + mois + "-" + jr;
          var dateChtFin = new Date(dateFin);
          // date de fin du chantier
          var tabDateFinC = this.chantierCourant.dateF.split("-"); //["16","08","2018 00:00:00"]
          var jrC = tabDateFinC[0];
          var moisC = tabDateFinC[1];
          var anneeC = tabDateFinC[2].split(" ")[0];
          var dateFinC = anneeC + "-" + moisC + "-" + jrC;
          var dateChtFinC = new Date(dateFinC);

          // on vérifie si la date de fin du chantier est plus inferieur a la date de fin selectionné
          if (dateChtFin > dateChtFinC) {
            this.$notify({
              title: "ATTENTION",
              message: "La durée doit etre comprise dans le durée du chantier .",
              type: "warning",
              position: "top-center"
            });
          } else {
            if (ligne.selectType !== null && ligne.duree !== null && ligne.ouvrier !== null || ligne.fournisseur !== "") {
              etat = true;
              data.append("option[id][]", ligne.id);
              data.append("option[type][]", ligne.selectType);
              data.append("option[ouvrier][]", ligne.ouvrier);
              data.append("option[fournisseur][]", ligne.fournisseur);
              data.append("option[duree][]", ligne.duree);
              data.append("option[montant][]", ligne.montant);
              data.append("option[montantSupp][]", ligne.montantSupp);
            } else {
              etat = false;
            }
          }
        }
        // }
        data.append("idUser", this.user.id);
        data.append("listTaches", this.selectTaches);
        data.append("listTravaux", this.selectTravaux);
        if (etat) {
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                if (_this5.chantierCourant.id) {
                  _this5.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Equipe enregistré avec succès.",
                    type: "success",
                    position: "top-center"
                  });
                } else {
                  _this5.$notify({
                    title: "MODIFICATION REUSSI",
                    message: "Contrat modifié avec succès.",
                    type: "success",
                    position: "top-center"
                  });
                }

                // this.loadChantier(this.projetCourant);
                // this.loadEquipe(this.travauxCourant);
                _this5.loadListeOuvrier(_this5.chantierCourant.id);
                _this5.dialogEquipe = false;
                _this5.loading = false;
                _this5.$refs.formEquipe.reset();
              } else if (verif.code === 0) {
                _this5.$message.error(verif.message);
                _this5.loading = false;
              }
            } else {
              _this5.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this5.loading = false;
            }
          }, function (response) {
            _this5.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this5.loading = false;
          });
        } else {
          // this.$notify({
          //   title: "ATTENTION",
          //   message: "Veuillez renseigner correctement tout les champs.",
          //   type: "warning",
          //   position: "top-center"
          // });

          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Equipe n'ont pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    loadPrestaire: function loadPrestaire() {
      var _this6 = this;

      this.loading = true;
      var url = this.domaine + "fournisseur/listePrestataire/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this6.listPrestataire = response.body.prestataire;
          _this6.loading = false;
        }
      });
    },
    loadOuvrier: function loadOuvrier() {
      var _this7 = this;

      var url = this.domaine + "ouvrier/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this7.listOuvrier = response.body.ouvrier;
        }
      });
    },
    openNewRessource: function openNewRessource() {
      this.dialogEquipe = true;
      this.selectTravaux = [], this.selectTaches = [], this.optionE = [];
      this.optionEquipe = [{
        key: 1,
        type: [{ text: "Prestataire", value: 1 }, { text: "Ouvrier/Manoeuvre", value: 2 }],
        selectType: "",
        fournisseur: "",
        ouvrier: "",
        duree: "",
        montant: 0,
        montantSupp: 0,
        id: ""
      }], this.loadPrestaire();
      this.loadOuvrier();
      this.loadTravaux(this.chantierCourant);
    },
    showDialogAjoutOuvrier: function showDialogAjoutOuvrier() {
      this.dialogAjoutOuvrier = true;
      this.editForm = false;
      this.formManoeuvre.matricule = "";
      this.formManoeuvre.nom = "";
      this.formManoeuvre.domicile = "";
      this.formManoeuvre.profession = "";
      this.formManoeuvre.contact = "";
      this.formManoeuvre.piece = "";
      this.formManoeuvre.numPiece = "";
      this.formManoeuvre.dateNaiss = "";
      this.formManoeuvre.dateD = "";
      this.formManoeuvre.dateF = "";
      this.formManoeuvre.montant = "";
      this.formManoeuvre.montantSupp = "";

      this.logoOuvrier = "/static/img-doc.png";
      this.optionE.selectType = "";
      this.optionE.fournisseur = "";
      this.optionE.ouvrier = "";
      this.optionE.duree = "";
      this.optionE.montant = "";
      this.optionE.montantSupp = "";
    },
    loadListeOuvrier: function loadListeOuvrier(idChantier) {
      var _this8 = this;

      this.loading = true;
      var url = "";
      // if(tache.idOpt) {
      //   url = this.domaine + "ouvrier/optionTravaux/" + tache.idOpt;
      // }else{
      url = this.domaine + "ouvrier/chantier/" + idChantier;

      // }

      this.$http.get(url).then(function (response) {
        _this8.listeOuvriers = response.body.ouvriers;
        _this8.listePrestataires = response.body.prestataires;
        // this.listePrestOuvriers = response.body.listePresOuvriers;
        _this8.listePresence = response.body.listePresence;
        // this.dialogOuvrier = true;
        _this8.loading = false;
      }, function (error) {
        _this8.loading = false;
        _this8.$message.error("Echec lors du chargement des ouvriers");
      });
    },
    loadTravaux: function loadTravaux(chantierCourant) {
      var _this9 = this;

      this.loading = true;
      var url = "";
      url = this.domaine + "projet/" + chantierCourant.id + "/index/chantier/travaux";
      this.$http.get(url).then(function (response) {
        _this9.listTravaux = response.body.travaux;
        _this9.loading = false;
      }, function (error) {
        _this9.loading = false;
        _this9.$message.error("Echec lors du chargement des ouvriers");
      });
    },
    filtrerTypeChantier: function filtrerTypeChantier() {
      var _this10 = this;

      this.selectTaches = [];
      if (this.selectTravaux.length == 1) {
        var url = "";
        url = this.domaine + "projet/chantier/" + this.chantierCourant.id + "/travaux/" + this.selectTravaux[0] + "/taches";
        this.$http.get(url).then(function (response) {
          _this10.listTaches = response.body.taches;
          _this10.loading = false;
        }, function (error) {
          _this10.loading = false;
          _this10.$message.error("Echec lors du chargement des ouvriers");
        });
      }
    },
    removeOptionEquipe: function removeOptionEquipe(item) {
      var index = this.optionEquipe.indexOf(item);
      if (index !== -1) {
        this.optionEquipe.splice(index, 1);
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "4XjW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4p9V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutDemandeFond_vue__ = __webpack_require__("jRpV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_797b5739_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutDemandeFond_vue__ = __webpack_require__("ZP2/");
function injectStyle (ssrContext) {
  __webpack_require__("WNAQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-797b5739"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutDemandeFond_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_797b5739_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutDemandeFond_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4pCO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_chantier_vue__ = __webpack_require__("Y+Vx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f12cdc6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_chantier_vue__ = __webpack_require__("DUFl");
function injectStyle (ssrContext) {
  __webpack_require__("2O9s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_chantier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f12cdc6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_chantier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4pxx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogDetail),callback:function ($$v) {_vm.dialogDetail=$$v},expression:"dialogDetail"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Detail du budget pour le projet "+_vm._s(_vm.detailProjet.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Informations generales sur le projet\n                                            ")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Référence")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                Projet "+_vm._s(_vm.detailProjet.idProj)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Libellé")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailProjet.libelle)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Prix du marché")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(new Intl.NumberFormat().format(_vm.detailProjet.mntMarche))+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Type de projet")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailProjet.typeProjet)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date début")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailProjet.dateDbt)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de fin")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailProjet.dateFin)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Situation géographique")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailProjet.adresse)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Chef de projet")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailProjet.chefProjet)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Maitre d'ouvrage")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailProjet.maitreOuvrage)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Architect")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailProjet.architect)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Responsable d'étude ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailProjet.chefEtude)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Responsable du contrôle")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailProjet.chefControle)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Budget établi par")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailProjet.userCreatedBudget)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Budget validé par")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailProjet.userModifiedBudget)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Etat du budget")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailProjet.libEtatBudget)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date d'enregistrement budget")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailProjet.dateEnregBudget)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Liste du budget travaux à valider\n                                            ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL BUDGET PROPOSE\n                                                         : "+_vm._s(new
                                                         Intl.NumberFormat().format(_vm.totalMntPropose))+" ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL BUDGET VALIDE\n                                                         : "+_vm._s(new
                                                         Intl.NumberFormat().format(_vm.totalMntValide))+" ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs4":""}},[_c('v-flex',[_c('el-popover',{ref:"popChantier0",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin":"0"},attrs:{"align":"center"}},[_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtTravauxPDFSimpl('PDF')}}},[_vm._v("PDF SIMPLE")])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtTravauxPDF('PDF')}}},[_vm._v("PDF DETAILLE")])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtTravauxPDFSimpl('EXC')}}},[_vm._v("EXC ")])],1)])]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popChantier0",arg:"popChantier0"}],attrs:{"type":"warning","disabled":_vm.disabledBtnPop,"icon":"el-icon-printer"}},[_vm._v("Rapport")])],1)],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeBudget}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Liste des Tâches ")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2 mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"grid-content"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":props.row.taches,"stripe":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Détails\n                                                                                                        budget")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2 mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"grid-content"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":props.row.detailBudget,"stripe":""}},[_c('el-table-column',{attrs:{"align":"center","prop":"libelle","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"montantPropose","label":"MONTANT PROPOSE"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                                                                                                        "+_vm._s(new
                                                                                                                                        Intl.NumberFormat().format(scope.row.montantPropose))+"\n                                                                                                                                    ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"montantValide","label":"MONTANT VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                                                                                                        "+_vm._s(new
                                                                                                                                        Intl.NumberFormat().format(scope.row.montantValide))+"\n                                                                                                                                    ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"mois","label":"MOIS"}})],1)],1)],1)],1)],1)])],1)],1)],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntBudgetPropose","label":"MONTANT PROPOSE","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":'warning'}},[_vm._v("\n                                                                                                "+_vm._s(new
                                                                                                Intl.NumberFormat().format(scope.row.mntBudgetPropose))+"\n                                                                                            ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntBudgetValide","label":"MONTANT VALIDE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":'success'}},[_vm._v("\n                                                                                                "+_vm._s(new
                                                                                                Intl.NumberFormat().format(scope.row.mntBudgetValide))+"\n                                                                                            ")])]}}],null,true)})],1)],1)],1)],1)],1)])],1)],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Travaux","prop":"libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"BUDGET PROPOSE","prop":"mntTotalBudgetPropose"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                                               "+_vm._s(new Intl.NumberFormat().format(scope.row.mntTotalBudgetPropose))+"\n                                                                           ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"BUDGET VALIDE","prop":"mntTotalBudgetValide"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                                               "+_vm._s(new Intl.NumberFormat().format(scope.row.mntTotalBudgetValide))+"\n                                                                           ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT","prop":"libEtatBudgetTrx"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":scope.row.etatBudgetTrx == 1 ?  'success':'danger'}},[_vm._v("\n                                                                               "+_vm._s(scope.row.libEtatBudgetTrx)+"\n                                                                               ")])]}}])})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-4",attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                                       Résultat compte d'exploitation(Affiche uniquement les travaux planifiés par le chef de projet)\n                                                                   ")]),_vm._v(" "),_c('el-tabs',{attrs:{"stretch":true,"type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick(_vm.compte)}},model:{value:(_vm.compte),callback:function ($$v) {_vm.compte=$$v},expression:"compte"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',[_vm._v("account_balance")]),_vm._v(" Recapitulatif annuel")],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-flex',[_c('el-popover',{ref:"popChantier",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin":"0"},attrs:{"align":"center"}},[_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifAnnuelSimpl('PDF')}}},[_vm._v("PDF SIMPLE")])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifAnnuel('PDF')}}},[_vm._v("PDF DETAILLE")])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifAnnuelSimpl('EXC')}}},[_vm._v("EXC ")])],1)])]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popChantier",arg:"popChantier"}],attrs:{"type":"warning","disabled":_vm.disabledBtnPop,"icon":"el-icon-printer"}},[_vm._v("Rapport")])],1)],1)],1),_vm._v(" "),_c('el-collapse',{attrs:{"accordion":""}},_vm._l((_vm.bilanMensuel),function(groupeMois,index){return _c('v-layout',{key:index,staticClass:"text-xs-center",attrs:{"wrap":""}},[_c('div',{staticStyle:{"width":"100%"}},[_c('el-collapse-item',{staticClass:" mb-1 pl-3 pr-3",staticStyle:{"width":"100%"},attrs:{"name":index}},[_c('template',{slot:"title"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-sm-left",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"dark":"","label":"","text-color":"white","color":"purple"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v("\n                                                                                                           "+_vm._s(index)+"\n                                                                                                       ")],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-sm-left",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL MONTANT\n                                                                                                           PREVU: "+_vm._s(new
                                                                                                           Intl.NumberFormat().format(groupeMois.totalMntPrevu))+" ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-sm-left",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL MONTANT\n                                                                                                           ENGAGÉ: "+_vm._s(new
                                                                                                           Intl.NumberFormat().format(groupeMois.totalMntDecaisse))+" ")])])],1)],1)],1),_vm._v(" "),_vm._l((groupeMois.mois),function(travaux,mois){return _c('v-flex',{key:mois,staticClass:"mt-3",attrs:{"xs12":""}},[_c('span',{staticClass:"blue--text",staticStyle:{"font-size":"20px"}},[_vm._v(" "+_vm._s(mois)+"-"+_vm._s(index))]),_vm._v(" "),_c('el-table',{staticClass:"elevation-1",staticStyle:{"width":"100%"},attrs:{"data":travaux,"highlight-current-row":"","header-row-style":_vm.headerRowStyle,"border":"","summary-method":_vm.getSummaries,"show-summary":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',{staticClass:"elevation-3 pl-4 pr-4 pt-2"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple mb-2"},[_c('v-alert',{staticClass:"mb-4",attrs:{"value":true,"outline":"","color":"primary","icon":"info"}},[_vm._v("Liste du budget établi\n                                                                                                                       ")]),_vm._v(" "),_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":props.row.detailBudget,"summary-method":_vm.getSummaries,"show-summary":""}},[_c('el-table-column',{attrs:{"align":"center","prop":"libelle","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"mntBudgetValide","label":"BUDGET VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                                                                                                       "+_vm._s(new Intl.NumberFormat().format(scope.row.mntBudgetValide))+"\n                                                                                                                                   ")]}}],null,true)})],1)],1)],1)])],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","align":"center","label":"TRAVAUX"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotalBudgetValide","align":"center","label":"BUDGET VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v(_vm._s(new
                                                                                                           Intl.NumberFormat().format(prop.row.mntTotalBudgetValide))+"\n                                                                                                       ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"montantDecaisse","label":"MONTANT ENGAGÉ"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v(_vm._s(new
                                                                                                           Intl.NumberFormat().format(prop.row.montantDecaisse))+"\n                                                                                                       ")]}}],null,true)})],1)],1)})],2),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"})],1)])}),1)],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',[_vm._v("library_books")]),_vm._v(" Recapitulatif travaux ")],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-flex',[_c('el-popover',{ref:"popChantier2",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin":"0"},attrs:{"align":"center"}},[_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifTravauxSimpl('PDF')}}},[_vm._v("PDF SIMPLE")])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifTravaux('PDF')}}},[_vm._v("PDF DETAILLE")])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifTravauxSimpl('EXC')}}},[_vm._v("EXC ")])],1)])]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popChantier2",arg:"popChantier2"}],attrs:{"type":"warning","disabled":_vm.disabledBtnPop,"icon":"el-icon-printer"}},[_vm._v("Rapport")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("Liste des travaux")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","header-row-style":_vm.headerRowStyle,"highlight-current-row":"","data":_vm.bilanTravaux,"summary-method":_vm.getSumm,"show-summary":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("Budget travaux")])],1),_vm._v(" "),_c('el-table',{staticClass:"elevation-2",staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":props.row.detailBudget,"summary-method":_vm.getSumm,"show-summary":""}},[_c('el-table-column',{attrs:{"align":"center","prop":"libelle","sortable":"","label":"DESIGNATION"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(" "+_vm._s(prop.row.libelle)+"  ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"mntRealise","label":"BUDGET VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(prop5){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v("\n                                                                                                                   "+_vm._s(new Intl.NumberFormat().format(prop5.row.mntBudgetValide))+"\n                                                                                                               ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"ecart","label":"ECART"},scopedSlots:_vm._u([{key:"default",fn:function(prop3){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":prop3.row.ecart < 0 ? 'danger' : 'success'}},[_vm._v("\n                                                                                                                   "+_vm._s(new Intl.NumberFormat().format(prop3.row.ecart))+"\n                                                                                                               ")])]}}],null,true)})],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"libelle","label":"DESIGNATION"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(" "+_vm._s(prop.row.libelle)+"  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"mntTotalBudgetValide","label":"BUDGET VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(prop5){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v("\n                                                                                                   "+_vm._s(new Intl.NumberFormat().format(prop5.row.mntTotalBudgetValide))+"\n                                                                                               ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"mntTotalTypeTrxDecaisse","label":"MONTANT ENGAGÉ"},scopedSlots:_vm._u([{key:"default",fn:function(prop5){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v("\n                                                                                                   "+_vm._s(new Intl.NumberFormat().format(prop5.row.mntTotalTypeTrxDecaisse))+"\n                                                                                               ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"ecart","label":"ECART"},scopedSlots:_vm._u([{key:"default",fn:function(prop3){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":prop3.row.ecart < 0 ? 'danger' : 'success'}},[_vm._v("\n                                                                                                   "+_vm._s(new Intl.NumberFormat().format(prop3.row.ecart))+"\n                                                                                               ")])]}}])})],1)],1)],1)],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',[_vm._v("account_balance_wallet")]),_vm._v(" Etat financier")],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-flex',[_c('el-popover',{ref:"popChantier3",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin":"0"},attrs:{"align":"center"}},[_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifFinanceSimpl('PDF')}}},[_vm._v("PDF SIMPLE")])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifFinance('PDF')}}},[_vm._v("PDF DETAILLE")])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifFinanceSimpl('EXC')}}},[_vm._v("EXC ")])],1)])]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popChantier3",arg:"popChantier3"}],attrs:{"type":"warning","disabled":_vm.disabledBtnPop,"icon":"el-icon-printer"}},[_vm._v("Rapport")])],1)],1)],1),_vm._v(" "),_vm._l((_vm.listeDetail),function(compte,index){return _c('v-layout',{key:index,staticClass:"mt-3 mb-4",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(index))])],1),_vm._v(" "),_c('el-table',{staticClass:"mb-4",staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":compte,"summary-method":_vm.getSummCompteFinance,"show-summary":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(propsArticle){return [_c('el-row',{staticClass:"elevation-3 pl-4 pr-4 pt-2"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("Détails facture")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":propsArticle.row.produits,"summary-method":_vm.getSummaries,"show-summary":""}},[_c('el-table-column',{attrs:{"prop":"ref","align":"center","label":"REFERENCE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"designation","align":"center","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","align":"center","label":"QUANTITE"},scopedSlots:_vm._u([{key:"default",fn:function(propA1){return [_vm._v(_vm._s(new
                                                                                                                       Intl.NumberFormat().format(propA1.row.qte))+"\n                                                                                                                   ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","align":"center","label":"UNITE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixU","align":"center","label":"PRIX UNITAIRE"},scopedSlots:_vm._u([{key:"default",fn:function(propA2){return [_vm._v(_vm._s(new
                                                                                                                       Intl.NumberFormat().format(propA2.row.prixU))+"\n                                                                                                                   ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","align":"center","label":"TVA"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remise","label":"REMISE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","align":"center","label":"TOTAL"},scopedSlots:_vm._u([{key:"default",fn:function(propA3){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v("\n                                                                                                                           "+_vm._s(new
                                                                                                                           Intl.NumberFormat().format(propA3.row.total))+"\n                                                                                                                       ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntBudgetValide","align":"center","label":"Budget matériel validé"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v("\n                                                                                                                           "+_vm._s(new
                                                                                                                           Intl.NumberFormat().format(prop.row.mntBudgetValide))+"\n                                                                                                                       ")])]}}],null,true)})],1)],1)])],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"","align":"center","prop":"ref","label":"REFERENCE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(" "+_vm._s(prop.row.ref)+"  ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"designation","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"total","label":"TOTAL FACTURE"},scopedSlots:_vm._u([{key:"default",fn:function(prop2){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v("\n                                                                                                   "+_vm._s(new Intl.NumberFormat().format(prop2.row.total))+"\n                                                                                               ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"totalPaye","label":"TOTAL FACTURE PAYEE"},scopedSlots:_vm._u([{key:"default",fn:function(prop2){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"success"}},[_vm._v("\n                                                                                                   "+_vm._s(new Intl.NumberFormat().format(prop2.row.totalPaye))+"\n                                                                                               ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"totalImpaye","label":"TOTAL FACTURE IMPAYEE"},scopedSlots:_vm._u([{key:"default",fn:function(prop2){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"danger"}},[_vm._v("\n                                                                                                   "+_vm._s(new Intl.NumberFormat().format(prop2.row.totalImpaye))+"\n                                                                                               ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"mntTotalBudgetValide","label":"BUDGET VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"info"}},[_vm._v("\n                                                                                                   "+_vm._s(new Intl.NumberFormat().format(prop.row.mntTotalBudgetValide))+"\n                                                                                               ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"ecart","label":"ECART BUDGET-TOTAL FACTURE"},scopedSlots:_vm._u([{key:"default",fn:function(prop3){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":prop3.row.ecart < 0 ? 'danger' : 'success'}},[_vm._v("\n                                                                                                   "+_vm._s(new Intl.NumberFormat().format(prop3.row.ecart))+"\n                                                                                               ")])]}}],null,true)})],1)],1)],1)})],2)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.detailProjet.etat == false && _vm.listeBudget.length > 0)?_c('v-btn',{staticClass:"mb-5",staticStyle:{"margin-right":"100px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"success"},on:{"click":function($event){_vm.dialogConfirm = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Valider le budget")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation du budget du projet "+_vm._s(_vm.detailProjet.libelle))]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous valider le budget  ?","closable":false,"show-icon":"","type":"success"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirm = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideBudget()}}},[_vm._v("Confirmer")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4q6j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "502k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"tile":""}},[_c('v-card-text',[_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTE DES DEMANDES DE CARBURANT A APPROUVER")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","mt-2":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-4 mt-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Selectionner un Chantier"},on:{"change":function($event){return _vm.filtrerChantier()},"clear":function($event){return _vm.clearSelectChantier()}},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),(_vm.chantierS != '')?_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner un travaux"},on:{"change":function($event){return _vm.filtrerTravaux()}},model:{value:(_vm.travauxS),callback:function ($$v) {_vm.travauxS=$$v},expression:"travauxS"}},_vm._l((_vm.listeTravaux),function(item){return _c('el-option',{key:item.idTravaux,attrs:{"label":item.libTravaux,"value":item.idTravaux}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.travauxS != '')?_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Selectionner une tâche"},on:{"change":function($event){return _vm.filtrerTaches()}},model:{value:(_vm.tachesS),callback:function ($$v) {_vm.tachesS=$$v},expression:"tachesS"}},_vm._l((_vm.listeTaches),function(item){return _c('el-option',{key:item.idTache,attrs:{"label":item.libTache,"value":item.idTache}})}),1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","disabled":_vm.disabledBtnValide,"icons":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.modalValideBesoin()}},slot:"activator"},[_vm._v("\n            Approuver / Rejeter\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done")])],1),_vm._v("Valider les ressources sélectionées\n        ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-2":""}},[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"mt-3":"","ml-1":"","mr-1":"","data":_vm.BesoinsList},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('h3',[_vm._v("Libelle du PROJET/CHANTIER/TRAVAUX/TACHE:")]),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(props.row.libelle)+"\n              ")]),_vm._v(" "),_c('h3',[_vm._v("DEMANDEUR:")]),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(props.row.demandeur)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"55","type":"selection"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE DEMANDE","align":"center"}}),_vm._v(" "),_c('el-table-column',{directives:[{name:"fi",rawName:"v-fi",value:(_vm.typeReche != 'carburant'),expression:"typeReche != 'carburant'"}],attrs:{"prop":"codeGestion","label":"Code analytique","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"TYPE RESSOURCE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"produit","label":"RESSOURCE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"QTE PREVU","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":""}},[_vm._v("\n                "+_vm._s(scope.row.qte)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteC","label":"QTE COMMANDE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"green","label":""}},[_vm._v("\n                "+_vm._s(scope.row.qteC)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteR","label":"QTE RESTANTE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"red","label":""}},[_vm._v("\n                "+_vm._s(scope.row.qteR)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"UNITE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"priorite","sortable":"","label":"PRIORITE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.priorite === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"green accent-3"}},[_vm._v("Faible\n              ")]):(scope.row.priorite === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"orange accent-4"}},[_vm._v("Normal")]):(scope.row.priorite === 3)?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"red accent-3"}},[_vm._v("Urgent")]):_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"blue lighten-4"}},[_vm._v("Aucune")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"DATE SOUH / PERIODE D'UTILISATION","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"periode","label":"PERIODE TRAVAUX","align":"center"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"1160"},model:{value:(_vm.dialogValideBesoin),callback:function ($$v) {_vm.dialogValideBesoin=$$v},expression:"dialogValideBesoin"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("\n          VALIDATION DES DEMANDES DE CARBURANT SELECTIONNEES\n        ")]),_vm._v(" "),_c('v-card-text',{staticClass:"mb-5"},[_c('el-alert',{attrs:{"title":'Voulez-vous approuver ou rejeter Les ressources selectionnées ',"description":"Les demandes de carburant pour les véhicules seront traité par les entrepots de type HYDROLIQUE. Veuillez précisez la date de livraison souhaitée s'il vous plait et la mention bon pour accord dans le champs commentaire et sélectioner un Entrepot.","type":"warning","center":"","closable":false,"show-icon":""}}),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%","margin-top":"30px"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":_vm.listeBesoinSelect}},[_c('el-table-column',{attrs:{"align":"center","prop":"produit","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"periode","label":"PERIODE TRAVAUX"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"dateLivrSouh","label":"DATE LIVRAISON SOUHAITEE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateLivrSouh","label":"CHANGER DATE LIVRAISON *"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('div',{staticClass:"block"},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","id":"dateLivrSouh","type":"date","placeholder":"Choississez une date de livraison"},model:{value:(prop.row.dateLivrSouh),callback:function ($$v) {_vm.$set(prop.row, "dateLivrSouh", $$v)},expression:"prop.row.dateLivrSouh"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteR","label":"QUANTITE A COMMANDER *"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('div',{staticClass:"block"},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","name":"qteR"},on:{"change":function($event){return _vm.calculTotalComm(prop.row)}},model:{value:(prop.row.qteR),callback:function ($$v) {_vm.$set(prop.row, "qteR", $$v)},expression:"prop.row.qteR"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"entrepot","label":"ENTREPOT DE TRAITEMENT *"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('div',{staticClass:"block"},[_c('el-select',{attrs:{"placeholder":"Selectionner l'entrepot"},model:{value:(prop.row.entrepot),callback:function ($$v) {_vm.$set(prop.row, "entrepot", $$v)},expression:"prop.row.entrepot"}},_vm._l((_vm.listEntrepot),function(item){return _c('el-option',{key:item.value,staticStyle:{"width":"100%"},attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]}}])})],1),_vm._v(" "),_c('el-form',{staticClass:"mt-4",attrs:{"label-position":"top","label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"Commentaire *"}},[_c('el-input',{attrs:{"rows":"6","type":"textarea","placeholder":"Veuillez saisir l'expression bon pour accord si vous souhaitez valider la demande"},model:{value:(_vm.commDec),callback:function ($$v) {_vm.commDec=$$v},expression:"commDec"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialogValideBesoin = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.verifBtnConfirme,"color":"green darken-1","flat":""},on:{"click":function($event){return _vm.validRejetBesoin(1)}}},[_vm._v("Confirmer\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.verifBtnRefus,"color":"red darken-1","flat":""},on:{"click":function($event){return _vm.validRejetBesoin(0)}}},[_vm._v("Rejeter")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "50Wr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","persistent":"","fullscreen":"","hide-overlay":""},model:{value:(_vm.dialogCarteCaburant),callback:function ($$v) {_vm.dialogCarteCaburant=$$v},expression:"dialogCarteCaburant"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v(" Liste des cartes carburant ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h6',[_vm._v("LISTE DES CARTES")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Solde Total: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntTotal)+" Fcfa ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbCarte))]),_vm._v("\n                      Carte(s)\n                    ")],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right mb-3"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.modalAjoutCarte()}},slot:"activator"},[_vm._v("Ajouter une carte\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("playlist_add")])],1),_vm._v("\n                  Effectuer une carte\n                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","disabled":_vm.disabledBtnCarte,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeDemandePDF()}},slot:"activator"},[_vm._v("\n                    Imprimer\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v(" print")])],1),_vm._v("\n                  Imprimer la liste des demandes\n                ")],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}}),_vm._v(" "),_c('div',{staticClass:"text-xs-left  mb-1 "},[_c('el-select',{attrs:{"clearable":"","placeholder":"Trier par fournisseur"},on:{"clear":function($event){return _vm.clearSelect()},"change":_vm.filtrerSociete},model:{value:(_vm.selectSoc),callback:function ($$v) {_vm.selectSoc=$$v},expression:"selectSoc"}},_vm._l((_vm.listeSociete),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('data-tables',{attrs:{"data":_vm.cartes}},[_c('el-table-column',{attrs:{"prop":"identifiant","label":"Identifiant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(" "+_vm._s(scope.row.identifiant))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"station","label":"Fournisseur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantFormat","label":"Solde (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(" "+_vm._s(scope.row.montantFormat))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nbRecharge","label":"Nb Appro"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.modalDetailCarte(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                      Détails des opérations\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.modalEditCarte(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                      Editer\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.intervention)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();return _vm.showDialogSupp(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                      Supprimer\n                    ")],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","description":"Tous les règlements effectués avec cette carte seront également supprimées,la suppresion ne sera pas possible si un rechargement a été effectué avec cette carte .","closable":false,"show-icon":"","type":"warning"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("CARTE")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("\n                    ID "+_vm._s(_vm.carteId)+"\n                  ")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.deleteCarte()}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('AjoutCarteCarburant',{attrs:{"editCarte":_vm.carteTransfert,"show":_vm.showModalAjoutCarte},on:{"close":function($event){_vm.showModalAjoutCarte = false;
      _vm.loadCarte();}}}),_vm._v(" "),_c('ReglementCarteIndex',{attrs:{"carte":_vm.carteRgt,"show":_vm.showModalRgt},on:{"close":function($event){_vm.showModalRgt = false}}}),_vm._v(" "),_c('TransfertCarteIndex',{attrs:{"carte":_vm.carteTransfert,"show":_vm.showModalTransfert},on:{"close":function($event){_vm.showModalTransfert = false}}}),_vm._v(" "),_c('FicheDetailCarte',{attrs:{"carte":_vm.carteSelect,"show":_vm.showModalDetail},on:{"close":function($event){_vm.showModalDetail = false;
      _vm.loadCarte();}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5N1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutMaintenance_vue__ = __webpack_require__("i/7P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b071c7c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutMaintenance_vue__ = __webpack_require__("htyB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutMaintenance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b071c7c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutMaintenance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5VJD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboardOngletPrj_vue__ = __webpack_require__("bHbr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_731170db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboardOngletPrj_vue__ = __webpack_require__("zfpq");
function injectStyle (ssrContext) {
  __webpack_require__("E+pB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboardOngletPrj_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_731170db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboardOngletPrj_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5d9T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutPrevisionBudget_vue__ = __webpack_require__("Usxo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b5040e1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutPrevisionBudget_vue__ = __webpack_require__("Gvx0");
function injectStyle (ssrContext) {
  __webpack_require__("yNzM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutPrevisionBudget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b5040e1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutPrevisionBudget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "607e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text))])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(_vm.droitAcces.index_commande_comparateur)?_c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h6',[_vm._v("LISTE DES COMMANDES ANALYSEES PAR LE COMPARATEUR DE PRIX")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant Total Economisé : ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.beneficeTotal)+" Fcfa ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.totalCmd))]),_vm._v("\n                Commande(s)\n              ")],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}}),_vm._v(" "),(_vm.droitAcces.index_commande_comparateur)?_c('data-tables',{attrs:{"data":_vm.listeCommandes}},[_c('el-table-column',{attrs:{"prop":"dateCom","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"refCmd","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userCreate","label":"Initiateur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fournisseur","label":"Fournisseur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"grey"},on:{"click":function($event){return _vm.modalDetailCmd(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                Detail des commandes générées\n              ")],1)]}}],null,false,3270688680)})],1):_vm._e()],1)],1):_vm._e()],1),_vm._v(" "),_c('ModalDetailCommande',{attrs:{"cmdInit":_vm.cmdInit,"cmdDerivees":_vm.cmdDerivees,"show":_vm.showModalDetailCmd},on:{"close":function($event){_vm.showModalDetailCmd = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "696s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: "ListeWorklog",
  props: {
    show: {
      type: Boolean
    },
    idChantier: {
      type: Number
    },
    listeWorklog: {
      type: Array
    },
    listeWorktrx: {
      type: Array
    },
    listeTacheWorktrx: {
      type: Array
    },
    listeWorktrx2: {
      type: Array
    },
    totalHeuretrx: 0,
    totalmintrx: 0,
    totalactivitetrx: 0
  },

  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      formWork: [{
        libelle: "",
        tempsmis: "",
        description: "",
        dateAdd: "",
        file: null
      }],
      formActivite: {},
      checked: false,
      tableTaches: [],
      tableTachesAffICh: [],
      typeLivraison: [{ text: "En attente", value: 1 }, { text: "En cours", value: 2 }, { text: "Terminée", value: 3 }],
      formTaches: {},
      selectTypeLivraison: "",
      logoWorklog: "/static/img-doc.png",

      editForm: false,
      dialogSupr: false,
      newVersion: true,
      dialogShowWorklog: false,
      dialogShowArticle: false,
      dialogSuprActivite: false,
      docSelect: {},
      ActiviteSelect: {},
      worklogCourant: {},
      Worklog: {},
      dialogWork: false,
      dialogActivite: false
    };
  },


  watch: {
    show: function show(newValue, oldvalue) {
      if (newValue == true) {
        this.loadWork(idChantier);
      }
    }
  },

  methods: {
    showDialogSuppActivite: function showDialogSuppActivite(item) {
      this.ActiviteSelect = item;
      this.dialogSuprActivite = true;
    },
    showDilogSupp: function showDilogSupp(item) {
      this.docSelect = item;
      this.dialogSupr = true;
    },
    deleteRow: function deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    showDialogWorklogDetail: function showDialogWorklogDetail(item) {
      this.dialogShowWorklog = true;
      this.worklogCourant = item;
    },
    showDialogActiviteEdit: function showDialogActiviteEdit(item) {
      this.dialogActivite = true;
      this.newVersion = false;
      this.formActivite = item;
      this.Worklog = item;
    },
    imprimeMatricePDF: function imprimeMatricePDF() {
      var url = this.domaine + 'worklogs/' + this.idChantier + '/' + this.user.id + '/imprimer_worklog_pdf';
      window.open(url);
    },

    //enregistrement des images
    onFileImageLogoPicked: function onFileImageLogoPicked(event) {
      var _this = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this.logoWorklog = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoWorklog = files[0];
    },
    deleteActivite: function deleteActivite(formNameWork) {
      var _this2 = this;

      this.loading = true;
      var form = document.getElementById("formActivite");
      var data = new FormData(form);
      var url = this.domaine + "tacheworklog/delete/activite/" + this.ActiviteSelect.worklog;
      data.append("ActiviteSelect", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.ActiviteSelect));

      this.$http.post(url, data).then(function (response) {
        _this2.loading = false;
        _this2.loadWork();

        _this2.$notify({
          title: "SUPPRESSION",
          message: "Activité supprimé avec succès.",
          type: "success",
          position: "top-center"
        });
        _this2.dialogSuprActivite = false;
      }, function (errRep) {
        _this2.loading = false;
        _this2.dialogSuprActivite = false;
        _this2.$notify.error({
          title: "SUPPRESSION ECHOUEE",
          message: "La suppression du worklog a échouée.",
          position: "top-center"
        });
      });
    },
    editTache: function editTache(formNameWork) {
      var _this3 = this;

      // this.editForm = false;
      this.$refs[formNameWork].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          var form = document.getElementById("formActivite");
          var data = new FormData(form);
          var url = _this3.domaine + "tacheworklog/edit/taches/" + _this3.Worklog.worklog;
          data.append("statut", _this3.formActivite.statut);
          data.append("worklog", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.Worklog));
          data.append("libelle", _this3.formActivite.libelle);
          data.append("commentaire", _this3.formActivite.commentaire);

          data.append("userId", _this3.user.id);
          data.append("idChantier", _this3.idChantier);
          _this3.loading = false;
          _this3.dialogActivite = false;
          _this3.$http.post(url, data).then(function (resp) {
            _this3.loading = false;
            _this3.resetForm("formWork");
            _this3.dialogActivite = false;
            _this3.loadWork();
            _this3.successNotif(resp.body.message);
          }, function (error) {
            _this3.loading = false;
            //this.resetForm('formWork');
            _this3.$message.error("Une erreur est survenue lors de l'enregistrement du document");
          });
        }
      });
    },
    showAddActivite: function showAddActivite(item) {
      this.newVersion = true;
      this.dialogActivite = true;
      this.Worklog = item;
      this.formActivite = {}, this.tableTaches = [], this.resetForm();
    },
    modifTacheEtat: function modifTacheEtat(item) {
      var _this4 = this;

      var form = document.getElementById("formWork");
      var data = new FormData(form);

      var url = this.domaine + "tacheworklog/edit/" + this.Worklog.id;
      data.append("userId", this.user.id);
      data.append("tachesTAB", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableTaches));
      data.append("formTaches", this.formTaches);
      data.append("idChantier", this.idChantier);
      this.loading = false;

      this.$http.post(url, data).then(function (resp) {
        _this4.loading = false;
        _this4.loadWork();
        _this4.successNotif(resp.body.message);
      }, function (error) {
        _this4.loading = false;
        //this.resetForm('formWork');
        _this4.$message.error("Une erreur est survenue lors de l'enregistrement du document");
      });
    },
    addListTaches: function addListTaches(item) {
      this.tableTaches.push({
        libelle: item.libelle,
        statut: item.statut,
        date: item.date,
        commentaire: item.commentaire

      });
      this.formActivite = {};
    },
    loadWork: function loadWork(idChantier) {
      var _this5 = this;

      this.loading = true;
      this.docSelect = null;
      var url = this.domaine + "worklogs/chantier/" + this.idChantier;
      this.$http.get(url).then(function (response) {

        _this5.listeWorktrx = response.body.listeWorklog;
        _this5.listeTacheWorktrx = response.body.listTacheeWorklog;
        _this5.totalHeuretrx = response.body.totalheure;
        _this5.totalmintrx = response.body.totalMinutes;
        _this5.totalactivitetrx = response.body.totalActivite;

        _this5.loading = false;
      }, function (response) {
        _this5.loading = false;
      });
    },
    showAjoutWork: function showAjoutWork() {

      this.editForm = false;
      this.formWork = {};
      this.dialogWork = true;
      this.newVersion = true;
      this.logoWorklog = '/static/img-doc.png';
    },
    addWork: function addWork(formNameWork) {
      var _this6 = this;

      this.editForm = false;
      this.$refs[formNameWork].validate(function (valid) {
        if (valid) {
          _this6.loading = true;
          var form = document.getElementById("formWork");
          var data = new FormData(form);
          var url = _this6.domaine + "worklogs/create";

          data.append("userId", _this6.user.id);
          data.append("tachesTAB", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this6.tableTaches));
          data.append("idChantier", _this6.idChantier);
          _this6.loading = false;

          _this6.$http.post(url, data).then(function (resp) {
            _this6.editForm = false;
            _this6.loading = false;
            _this6.resetForm("formWork");
            _this6.resetForm("formTaches");
            _this6.loadWork();
            _this6.dialogWork = false;
            _this6.successNotif(resp.body.message);
          }, function (error) {
            _this6.loading = false;
            _this6.dialogWork = false;
            //this.resetForm('formWork');
            _this6.$message.error("Une erreur est survenue lors de l'enregistrement du document");
          });
        }
      });
    },
    addActivite: function addActivite(formNameWork) {
      var _this7 = this;

      this.editForm = false;
      this.$refs[formNameWork].validate(function (valid) {
        if (valid) {
          _this7.loading = true;
          var form = document.getElementById("formWork");
          var data = new FormData(form);
          var url = _this7.domaine + "tacheworklog/create";

          data.append("userId", _this7.user.id);
          data.append("tachesTAB", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this7.tableTaches));
          data.append("idChantier", _this7.idChantier);
          data.append("idworklog", _this7.Worklog.id);

          _this7.$http.post(url, data).then(function (resp) {
            _this7.loading = false;
            _this7.resetForm("formActivite");
            _this7.resetForm("tableTaches");
            _this7.dialogActivite = false;
            _this7.loadWork();
            _this7.successNotif(resp.body.message);
          }, function (error) {
            _this7.loading = false;
            //this.resetForm('formWork');
            _this7.$message.error("Une erreur est survenue lors de l'enregistrement du document");
          });
        }
      });
    },
    showEditWork: function showEditWork(item) {
      this.docSelect = item;
      // this.editForm = true;
      this.formWork = item;
      this.tableTaches = item;
      this.newVersion = false;
      this.editForm = false;

      // this.resetForm();
      this.dialogWork = true;
      this.logoWorklog = item.urlImage;
    },
    editWork: function editWork(formNameWork) {
      var _this8 = this;

      // this.editForm = false;
      this.$refs[formNameWork].validate(function (valid) {
        if (valid) {
          _this8.loading = true;
          var form = document.getElementById("formWork");
          var data = new FormData(form);
          var url = _this8.domaine + "worklogs/edit/" + _this8.docSelect.id;
          data.append("tachesTAB", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this8.tableTaches));
          data.append("userId", _this8.user.id);
          data.append("idChantier", _this8.idChantier);
          _this8.loading = false;
          _this8.dialogWork = false;
          _this8.$http.post(url, data).then(function (resp) {
            _this8.loading = false;
            _this8.resetForm("formWork");
            _this8.dialogWork = false;
            _this8.loadWork();
            _this8.successNotif(resp.body.message);
          }, function (error) {
            _this8.loading = false;
            _this8.dialogWork = false;
            _this8.resetForm('formWork');
            _this8.$message.error("Une erreur est survenue lors de l'enregistrement du document");
          });
        }
      });
    },
    deleteDoc: function deleteDoc() {
      var _this9 = this;

      this.loading = true;
      var url = this.domaine + "worklogs/delete/" + this.docSelect.id;
      this.$http.get(url).then(function (response) {
        _this9.loading = false;
        _this9.loadWork();

        _this9.$notify({
          title: "SUPPRESSION",
          message: "Worklog supprimé avec succès.",
          type: "success",
          position: "top-center"
        });
        _this9.dialogSupr = false;
      }, function (errRep) {
        _this9.loading = false;
        _this9.dialogSupr = false;
        _this9.$notify.error({
          title: "SUPPRESSION ECHOUEE",
          message: "La suppression du worklog a échouée.",
          position: "top-center"
        });
      });
    },
    successNotif: function successNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Worklog enregistré avec succès";
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";

      this.$notify({
        title: "ENREGISTREMENT DOCUMENT",
        message: mess,
        type: type,
        position: "top-center",
        duration: 10000
      });
    },
    resetForm: function resetForm(formNameWork) {
      this.formWork = [];
      this.tableTaches = [];
      this.formWork.urlImage = "/static/doc.png";
      this.file = null;
    },
    onFileImagePicked: function onFileImagePicked(event) {
      var _this10 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 10485760) {
        this.$message.error("La taille du fichier est supérieur à 10M");
        return;
      }
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this10.formWork.urlImage = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.formWork.file = files[0];
    }
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ "69pY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6G+4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardChantierProjet_vue__ = __webpack_require__("1uTe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_111a574d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardChantierProjet_vue__ = __webpack_require__("wS7l");
function injectStyle (ssrContext) {
  __webpack_require__("Ltin")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardChantierProjet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_111a574d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardChantierProjet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6GQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: "Chantier_index",
  props: {
    listeChantiers: {
      type: Array
    }
  },

  data: function data() {
    var _ref;

    return _ref = {
      //data general
      loading: false,
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit"))
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "loading", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "worklogCourant", {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "listeWorklog", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "listProjet", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "listChantier", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dialogShowWorklog", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "worklogTotal", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectSearchChantierSuivi", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectTypeSearchProjet", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "totalActiviteEncours", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "totalActivite", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "totalActiviteTermine", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "activiteeEnCours", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "activiteeEnArret", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "activiteeTermine", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectTypeSearchSuivi", 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "typeSearch", [{ text: "Chantier", value: 1
      // { text: "Par chantier", value: 2 }
    }]), _ref;
  },

  computed: {},
  watch: {},

  loadProduit: function loadProduit() {
    var _this = this;

    var url = this.domaine + "product/product-list";
    this.$http.get(url).then(function (response) {
      if (response.body) {
        _this.listProd = response.body;
      }
    }, function (response) {});
  },
  imprimeChaniter: function imprimeChaniter() {
    var idEtat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    var url = this.domaine + "mission/impression/liste/" + idEtat;
    window.open(url);
  },

  methods: {
    loadWorklogChantier: function loadWorklogChantier() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "worklogs/all/chantier/";

      this.$http.get(url).then(function (response) {
        _this2.loading = false;
        if (response.body) {
          _this2.listeWorklog = response.body.listeWorklog;
          _this2.worklogTotal = response.body.totalWorklogs;
          _this2.totalActivite = response.body.totalActivite;
          _this2.totalActiviteEncours = response.body.totalActiviteEncours;
          _this2.totalActiviteTermine = response.body.totalActiviteTermine;
        }
      });
    },
    loadChantierDetails: function loadChantierDetails(idChantier) {
      var _this3 = this;

      this.loading = true;
      //   this.docSelect = null;
      var url = this.domaine + "worklogs/details/" + idChantier;
      this.$http.get(url).then(function (response) {
        _this3.listeWorklog = response.body.listeWorklog;
        _this3.loading = false;
      }, function (error) {
        _this3.loading = false;
        //   this.dialogWork = false;
        //this.resetForm('formWork');
        _this3.$message.error("Une erreur est survenue lors de l'affichage des worklogs");
      });
    },
    modalDetail: function modalDetail(item) {
      this.worklogCourant = item;
      this.dialogShowWorklog = true;
    },
    loadTravauxSuiviProjet: function loadTravauxSuiviProjet(ligne) {
      var _this4 = this;

      this.loading = true;
      var url = this.domaine + "projet/" + ligne + "/index/chantier";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this4.listChantier = response.body.chantier;
          _this4.loading = false;
        }
      });
    },
    loadProjet: function loadProjet() {
      var _this5 = this;

      this.loading = true;
      var url = this.domaine + "projet/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this5.listProjet = response.body.projet;
          _this5.loading = false;
        }
      });
    }
  },
  mounted: function mounted() {
    // this.loading = true;
    this.loadProjet();
    this.loadWorklogChantier();
    // this.loadTravauxSuiviProjet();
    this.loading = false;
  }
});

/***/ }),

/***/ "6I+N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6Ypr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"blue-grey darken-1"}},[_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs4":"","pt-2":"","pl-2":""}},[_c('v-avatar',{staticClass:"mb-1",attrs:{"size":"100px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":"/static/avatar-conducteur.png","alt":"avatar"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.contrat.userContrat))]),_vm._v(" "),_c('div',{staticClass:"body-1"},[_vm._v(_vm._s(_vm.contrat.poste))]),_vm._v(" "),_c('div',{staticClass:"body-1"},[_vm._v("Echéance: "+_vm._s(_vm.contrat.dateEcheance))]),_vm._v(" "),_c('div',{staticClass:"body-1"},[_vm._v("ID-CONT "+_vm._s(_vm.contrat.idContrat))]),_vm._v(" "),_c('div',{staticClass:"caption"},[_c('v-chip',{attrs:{"label":"","color":"blue darken-4","text-color":"white"}},[_vm._v(_vm._s(_vm.contrat.libTypeContrat))])],1)])])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"light":""}}),_vm._v(" "),_c('v-card-actions',{staticClass:"pa-3"},[_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(_vm.contrat.etat == 2)?_c('v-btn',{staticClass:"mr-2",attrs:{"slot":"activator","dark":"","icon":"","color":"orange"},on:{"click":function($event){return _vm.showRenouvContrat()}},slot:"activator"},[_c('v-icon',[_vm._v("autorenew")])],1):_vm._e(),_vm._v("\n                            renoulever\n                        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(_vm.contrat.etat == 0)?_c('v-btn',{staticClass:"mr-2",attrs:{"slot":"activator","dark":"","icon":"","color":"red"},on:{"click":function($event){return _vm.showAnnuleContrat(_vm.contrat)}},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1):_vm._e(),_vm._v("\n                            annuler\n                        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":"","color":"primary"},on:{"click":function($event){return _vm.showDetailEmpl(_vm.contrat.userIdContrat)}},slot:"activator"},[_c('v-icon',[_vm._v("visibility")])],1),_vm._v("\n                            Détail\n                        ")],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"550"},model:{value:(_vm.dialogAnnuleCont),callback:function ($$v) {_vm.dialogAnnuleCont=$$v},expression:"dialogAnnuleCont"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_c('el-alert',{attrs:{"title":'Voulez-vous annuler le contrat ID-' +_vm.contrat.idContrat+ ' de l\'employé '+_vm.contrat.userContrat+' ? ',"type":"warning","closable":false,"show-icon":""}})],1),_vm._v(" "),_c('v-card-text',[_c('el-input',{attrs:{"rows":4,"placeholder":"Motif d'annulation","type":"textarea"},model:{value:(_vm.descAnnule),callback:function ($$v) {_vm.descAnnule=$$v},expression:"descAnnule"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialogAnnuleCont = false}}},[_vm._v("\n                    Non\n                ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":"flat","disabled":_vm.descAnnule == ''},on:{"click":function($event){return _vm.submitEtatCont(4)}}},[_vm._v("\n                    Oui\n                ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"550"},model:{value:(_vm.dialogRenouvCont),callback:function ($$v) {_vm.dialogRenouvCont=$$v},expression:"dialogRenouvCont"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_c('el-alert',{attrs:{"title":'Voulez-vous renouveler le contrat ID-' +_vm.contrat.idContrat+ ' de l\'employé '+_vm.contrat.userContrat+' ? ',"type":"warning","closable":false,"show-icon":""}})],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formValidite",attrs:{"label-position":"top","model":_vm.formValidite}},[_c('el-row',{attrs:{"type":"flex","gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"block"},[_c('el-form-item',{attrs:{"label":"Période de validité"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"daterange","format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","range-separator":"à","start-placeholder":"Date de début","end-placeholder":"Date de fin"},model:{value:(_vm.formValidite.datedbtFin),callback:function ($$v) {_vm.$set(_vm.formValidite, "datedbtFin", $$v)},expression:"formValidite.datedbtFin"}})],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","flat":"flat"},on:{"click":function($event){_vm.dialogRenouvCont = false}}},[_vm._v("\n                    Non\n                ")]),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"green darken-1","disabled":_vm.formValidite.datedbtFin == null},on:{"click":function($event){return _vm.submitRenewContrat()}}},[_vm._v("\n                    Renouveler\n                ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6dBU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6y32":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
    name: "RapportDepannage",
    props: ["show", "demandeDetail"],
    data: function data() {
        return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),

            loading: false,
            dialogSatisfaction: false,
            formRapport: {},

            listeSatisfaction: [{ text: '1', value: 1 }, { text: '2', value: 2 }, { text: '3', value: 3 }, { text: '4', value: 4 }, { text: '5', value: 5 }, { text: '6', value: 6 }, { text: '7', value: 7 }, { text: '8', value: 8 }, { text: '9', value: 9 }, { text: '10', value: 10 }]

        };
    },


    computed: {},
    watch: {
        show: function show(newValue, oldvalue) {
            this.dialogSatisfaction = newValue;
        }
    },

    methods: {
        closeDialog: function closeDialog() {
            this.$emit('close');
        },
        submitFormRapport: function submitFormRapport() {
            var _this = this;

            this.loading = true;
            var url = this.domaine + 'demande_maintenance/avis/demandeur';

            var form = document.getElementById('formRapport');
            var data = new FormData(form);
            data.append("idDemande", this.demandeDetail.idDemande);
            data.append("remarqueNote", this.formRapport.rapport);
            data.append("note", this.formRapport.satisfait);
            this.$http.post(url, data).then(function (response) {
                _this.closeDialog();
                _this.loading = false;
                _this.successNotif("L'enregistrement du rapport s'est bien deroule ");
            }, function (erreurRep) {
                _this.$message.error("Une erreur est survenue lors de l'enregistrement du rapport");
            });
        },
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "74Hy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Ag2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_comparateur_index_vue__ = __webpack_require__("C5x3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_382e9ff0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_comparateur_index_vue__ = __webpack_require__("607e");
function injectStyle (ssrContext) {
  __webpack_require__("7G2y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-382e9ff0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_comparateur_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_382e9ff0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_comparateur_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Cad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_resourceHumaine_board_resource__ = __webpack_require__("WpKY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_resourceHumaine_liste_employe__ = __webpack_require__("BgY7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_resourceHumaine_detail_employe__ = __webpack_require__("SHB3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_resourceHumaine_liste_contrat__ = __webpack_require__("gMf6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_resourceHumaine_liste_demande__ = __webpack_require__("YSKP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */], boardResource: __WEBPACK_IMPORTED_MODULE_1__components_resourceHumaine_board_resource__["a" /* default */], listeEmploye: __WEBPACK_IMPORTED_MODULE_2__components_resourceHumaine_liste_employe__["a" /* default */], detailEmploye: __WEBPACK_IMPORTED_MODULE_3__components_resourceHumaine_detail_employe__["a" /* default */], listeContrat: __WEBPACK_IMPORTED_MODULE_4__components_resourceHumaine_liste_contrat__["a" /* default */], listeDemande: __WEBPACK_IMPORTED_MODULE_5__components_resourceHumaine_liste_demande__["a" /* default */] },
    name: "indexResource",
    data: function data() {
        return {
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            loading: false,

            onglet: "0",
            showDetailEmpl: false,
            idEmploye: null,
            showListeEmploye: false

        };
    },

    methods: {
        handleTabClick: function handleTabClick(tab, action) {
            //this.showDetailEmpl = false;
            this.showListeEmploye = false;
            switch (this.onglet) {
                case "0":

                    break;

                case "1":

                    break;
                case "2":

                    break;

                case "3":
                    //listes employes
                    this.showListeEmploye = true;
                    break;

            }
        },
        showDetailCont: function showDetailCont(idEmp) {
            this.idEmploye = idEmp;
            this.onglet = "1";
        }
    },
    mounted: function mounted() {
        this.idEmploye = this.user.id;
    }
});

/***/ }),

/***/ "7G2y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7bGZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
    name: "ModalTarifLocation",
    props: ["show"],
    data: function data() {
        var _ref;

        return _ref = {
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            loading: false,
            selectTarification: null,
            dialogTarifLocation: false,
            itemsTarif: [],
            dialogAjoutTarif: false,
            formAjoutTarif: {},
            dialogAnnule: false,
            formAjoutForfait: {},
            modeEdit: false,
            listVehicule: [],
            listTarif: [],
            dialogSuppTarif: false,
            valid: true,
            libelForfait: null,
            libelTarif: null,
            tarifSelect: false,
            listUniteForfait: [{ value: "Heure", label: "Heure" }, { value: "Jour", label: "Jour" }, { value: "Semaine", label: "Semaine" }, { value: "Mois", label: "Mois" }, { value: "Année", label: "Année" }],
            tarifCourant: []
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "listVehicule", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectVehicule", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnTar", false), _ref;
    },

    computed: {},
    watch: {
        show: function show(newValue, oldvalue) {
            this.dialogTarifLocation = newValue;
        }
    },
    methods: {
        loadForfait: function loadForfait() {
            var _this = this;

            var url = this.domaine + "tarification/forfait";
            this.$http.get(url).then(function (response) {
                _this.itemsTarif = response.body.forfaits;
                _this.nbTarif = response.body.nbTarif;
            });
        },
        loadVehicule: function loadVehicule() {
            var _this2 = this;

            this.loading = true;
            var type = 'flotte';
            var url = this.domaine + 'parc/index/type' + '/' + type;
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this2.listVehicule = response.body.vehicule;
                    _this2.loading = false;
                }
            });
        },
        loadTarif: function loadTarif() {
            var _this3 = this;

            var url = this.domaine + "tarification/index";
            this.loading = true;
            this.$http.get(url).then(function (resp) {
                _this3.loading = false;
                _this3.listTarif = resp.body.tarifications;
                _this3.nbTarif = resp.body.nbTarif;
            }, function (resp) {
                _this3.loading = false;
                _this3.$message.error("erreur lors du chargement des tarifs");
            });
        },
        loadTarification: function loadTarification(queryString, cb) {
            var links = this.listTarif;
            var results = queryString ? links.filter(this.createFilter(queryString)) : links;
            cb(results);
        },
        createFilter: function createFilter(queryString) {
            return function (link) {
                return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
        suppForfait: function suppForfait() {
            var _this4 = this;

            this.loading = true;
            var url = this.domaine + "tarification/delete/forfait/" + this.idForfait;
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this4.loading = false;
                    _this4.$notify({
                        title: "SUPPRESSION",
                        message: response.body.message,
                        type: "success",
                        position: "top-right"
                    });

                    _this4.dialogSuppTarif = false;
                    _this4.idForfait = null;
                    _this4.idTarif = null;
                    _this4.loadForfait();
                }
            }, function (response) {
                _this4.$message.error("Erreur lors de la suppression du forfait");
                _this4.loading = false;
            });
        },
        closeDialog: function closeDialog() {
            this.$emit('close');
        },
        confSuppTarif: function confSuppTarif(item) {
            this.libelForfait = item.libelleForfait;
            this.libelTarif = item.libelleTarif;
            this.idForfait = item.idForfait;
            this.idTarif = item.idTarif;
            this.dialogSuppTarif = true;
        },
        saveTarif: function saveTarif() {
            var _this5 = this;

            this.loading = true;
            if (this.$refs.formAjoutTarifForfait.validate()) {
                var form = document.getElementById('formAjoutTarifForfait');
                var data = new FormData(form);
                data.append('idUser', this.user.id);
                data.append("tarification", this.selectTarification);
                data.append("unite", this.formAjoutTarif.unite);
                data.append("vehicule", this.selectVehicule);
                if (this.modeEdit == true) {
                    data.append('id', this.tarifCourant.idForfait);
                } else {
                    data.append('id', "");
                }

                var url = this.domaine + "tarification/new";
                this.$http.post(url, data).then(function (resp) {
                    var verif = resp.body;
                    _this5.loading = false;
                    if (verif.code == 1) {
                        _this5.$notify({
                            title: "ENREGISTREMENT REUSSI",
                            message: "Le forfait a été enregistré avec succès.",
                            type: "success",
                            position: "top-right"
                        });

                        _this5.loadForfait();
                        _this5.dialogAjoutTarif = false;
                        _this5.$refs.formAjoutTarifForfait.reset();
                    } else {
                        _this5.$message.error("Le forfait n'a pas été enregistré ");
                    }
                }, function (resp) {
                    _this5.$refs.formAjoutTarifForfait.reset();
                    _this5.$message.error("Erreur lors de l'enregistrement du forfait");
                    _this5.loading = false;
                });
            }
        },
        editTarification: function editTarification(item) {
            this.tarifCourant = item;
            this.modeEdit = true;
            this.dialogAjoutTarif = true;
            this.selectTarification = item.tarification;
            this.formAjoutTarif = {
                montant: item.montant,
                unite: item.unite
            };
            this.selectVehicule = item.idVeh;
        },
        newTarif: function newTarif() {
            this.tarifCourant = [];
            this.$refs.formAjoutTarifForfait.reset();
            this.modeEdit = false;
            this.dialogAjoutTarif = true;
            this.selectVehicule = "";
        },
        imprimeListeTarif: function imprimeListeTarif(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + "tarification/imprimerPDF/liste";
            } else {
                url = this.domaine + "tarification/imprimerEXC/liste";
            }
            window.open(url);
        }
    },
    mounted: function mounted() {
        this.loadForfait();
        this.loadTarif();
        this.loadVehicule();
    }
});

/***/ }),

/***/ "7kbu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogDashboardProjet),callback:function ($$v) {_vm.dialogDashboardProjet=$$v},expression:"dialogDashboardProjet"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("TABLEAU DE BORD PROJET")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-2":"","ml-1":"","mb-3":""}},[_c('v-flex',{staticClass:"elevation-3",attrs:{"sm3":"","mr-2":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v("Informations Projet")])],1),_vm._v(" "),_c('v-list',{attrs:{"subheader":"","two-line":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailProjet.libelle))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Libelle")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailProjet.chef))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Responsable projet")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailProjet.dateD)+" --"+_vm._s(_vm.detailProjet.dateF)+"\n                ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Période d'exécution")])],1)],1),_vm._v(" "),_c('v-divider')],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm10":""}},[_c('WidgetProjet',{attrs:{"projet":_vm.detailProjet}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":"","ml-1":"","mr-1":"","mt-1":""}},[_c('v-card',[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick(_vm.onglet)}},model:{value:(_vm.onglet),callback:function ($$v) {_vm.onglet=$$v},expression:"onglet"}},[_c('el-tab-pane',{attrs:{"label":"Chantiers"}},[_c('ChantierIndex',{attrs:{"commis":false,"listeChantiers":_vm.chantiers}}),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Besoins Matériels/Matériaux"}},[_c('besoinResponsable',{attrs:{"listeBesoins":_vm.besoins,"idresponsable":_vm.detailProjet.idChef},on:{"reloadBesoins":function($event){return _vm.loadBesoinAvalider()}}})],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Rapport Journaliers"}},[_c('ListeRapportTrx',{attrs:{"type":2,"commis":false,"listeRapportTrx":_vm.listeRapports},on:{"reloadListeRapport":function($event){return _vm.loadRapportProjet()}}})],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Reserve Travaux"}},[_c('ListeReserve',{attrs:{"type":2,"listeReserveTrx":_vm.listeReserves},on:{"reloadListeReserve":function($event){return _vm.loadReserves()}}}),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7lSV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","xs12":""}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"100%"},model:{value:(_vm.dialogAjoutConducteur),callback:function ($$v) {_vm.dialogAjoutConducteur=$$v},expression:"dialogAjoutConducteur"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter des conducteurs ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeConducteur}},[_c('el-table-column',{attrs:{"prop":"nom","label":"Nom","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.nom)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prenom","label":"Prenom","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.prenom)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateNaissance","label":"Date de naissance","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.dateNaissance)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"adresse","label":"Adresse","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.adresse)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fonction","label":"Fonction","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.fonction)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tel1","label":"telephone 1","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.tel1)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tel2","label":"telephone 1","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.tel2)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"email","label":"Email","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.email)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"matricule","label":"matricule","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.matricule)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateEmbauche","label":"date embauche","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.dateEmbauche)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"typePermis","label":"type de permis","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.typePermis)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"numPermis","label":"numero de permis","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.numPermis)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateValidite","label":"date de validite","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.dateValidite)+"\n                                    ")])]}}])})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Anuller "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('span',[_vm._v("Annuler")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"green","dark":""},on:{"click":function($event){return _vm.saveListe()}},slot:"activator"},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1),_vm._v(" "),_c('span',[_vm._v("Enregistrer les conducteur")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7mNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalAttribuerEquipe_vue__ = __webpack_require__("J3dB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88e156b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalAttribuerEquipe_vue__ = __webpack_require__("lYAy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalAttribuerEquipe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88e156b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalAttribuerEquipe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7rJt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demande_vue__ = __webpack_require__("T8Ii");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1412fe66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Demande_vue__ = __webpack_require__("+xXI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demande_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1412fe66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Demande_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7rON":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_widgetChantier_vue__ = __webpack_require__("iHuT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_263b59ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_widgetChantier_vue__ = __webpack_require__("13ay");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_widgetChantier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_263b59ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_widgetChantier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7wE8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_boardFacture_vue__ = __webpack_require__("FaG6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bb4edfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_boardFacture_vue__ = __webpack_require__("kSEu");
function injectStyle (ssrContext) {
  __webpack_require__("hJS6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_boardFacture_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bb4edfe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_boardFacture_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "84cN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "84xr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_contrat_vue__ = __webpack_require__("PFHd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_876d1296_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_contrat_vue__ = __webpack_require__("kuBM");
function injectStyle (ssrContext) {
  __webpack_require__("tvP0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-876d1296"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_contrat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_876d1296_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_contrat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8O0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//function de difference de date

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Oq2I");
__webpack_require__("miEh");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */]
    },
    name: "CompteExploitation",
    data: function data() {
        return {
            //data general
            notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
            loading: false,
            racourcis: [{ path: "/compte", text: "Compte exploitation", disabled: false }],

            //formulaire de recherche
            formSearch: {
                projet: "",
                chantier: ""
            },
            listeProjet: [],
            listeChantier: [],
            rulesForm: {},
            bilanTravaux: [],
            bilanMensuel: [],
            info: {
                evolution: 0
            },
            activeLotTrx: "1",
            compte: "0",
            listeDetail: [],
            listeMateriaux: []
        };
    },

    computed: {
        disableBtnRecherche: function disableBtnRecherche() {
            if (this.formSearch.projet == "" && this.formSearch.chantier == "") {
                return true;
            }
        }
    },
    methods: {
        headerRowStyle: function headerRowStyle(_ref) {
            var row = _ref.row,
                rowIndex = _ref.rowIndex;

            return { "color": "black" };
        },
        format: function format(percentage) {
            return percentage + "%";
        },
        getSummaries: function getSummaries(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = "Sous total";
                    return;
                }
                var values = data.map(function (item) {
                    return Number(item[column.property]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0));
                } else {
                    sums[index] = "N/A";
                }
            });

            return sums;
        },
        getSummariesTache: function getSummariesTache(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = "Sous total";
                    return;
                }
                if (index === 4) {
                    sums[index] = "N/A";
                    return;
                }
                var values = data.map(function (item) {
                    return Number(item[column.property]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0));
                } else {
                    sums[index] = "N/A";
                }
            });

            return sums;
        },
        imprimeProjetPDF: function imprimeProjetPDF() {
            var tab = [];
            var url = "";

            this.bilanTravaux.forEach(function (element) {
                tab.push(element.idTravaux);
            });
            if (this.formSearch.chantier != undefined && this.formSearch.chantier != "") {
                url = this.domaine + 'compteExploit/imprimer/projet/' + this.formSearch.projet + '/' + this.user.id + '/' + tab + '/' + this.formSearch.chantier;
            } else {
                url = this.domaine + 'compteExploit/imprimer/projet/' + this.formSearch.projet + '/' + this.user.id + '/' + tab;
            }

            window.open(url);
        },
        imprimerEtatProjetPDF: function imprimerEtatProjetPDF() {
            var tab = [];
            var url = "";
            if (this.formSearch.chantier != undefined && this.formSearch.chantier != "") {
                url = this.domaine + 'compteExploit/imprimer/etat/projet/' + this.formSearch.projet + '/' + this.user.id + '/' + this.formSearch.chantier;
            } else {
                url = this.domaine + 'compteExploit/imprimer/etat/projet/' + this.formSearch.projet + '/' + this.user.id;
            }

            window.open(url);
        },
        getSumm: function getSumm(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = "Sous total";
                    return;
                }

                if (index === 4) {
                    sums[index] = "N/A";
                    return;
                }
                var values = data.map(function (item) {
                    return Number(item[column.property]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0));
                } else {
                    sums[index] = "N/A";
                }
            });

            return sums;
        },
        getSummCompte: function getSummCompte(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = "Sous total";
                    return;
                }

                var values = data.map(function (item) {
                    return Number(item[column.property]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0));
                } else {
                    sums[index] = "N/A";
                }
            });

            return sums;
        },
        loadProjet: function loadProjet() {
            var _this = this;

            var url = this.domaine + "projet/index/projet/all";

            this.loading = true;
            this.$http.get(url).then(function (response) {
                _this.loading = false;
                _this.listeProjet = response.body.projet;
            }, function (errRep) {
                _this.loading = false;
                _this.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
            });
        },
        selectProjet: function selectProjet(idProjet) {
            this.listeChantier.splice(0);
            this.formSearch.chantier = "";
            this.loadChantier(idProjet);
        },
        loadChantier: function loadChantier(item) {
            var _this2 = this;

            this.loading = true;
            var url = this.domaine + "projet/" + item + "/index/chantier";
            this.$http.get(url).then(function (response) {
                _this2.loading = false;
                _this2.listeChantier = response.body.chantier;
            }, function (errRep) {
                _this2.loading = false;
                _this2.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
            });
        },
        imprimeBudgtRecapitulatifAnnuelSimpl: function imprimeBudgtRecapitulatifAnnuelSimpl(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerPDF_RecapitulatifAnnuelSimpl';
            } else {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerEXC_RecapitulatifAnnuelSimpl';
            }
            window.open(url);
        },
        loadBilan: function loadBilan() {
            var _this3 = this;

            this.loading = true;
            var url = "";

            if (this.formSearch.chantier != undefined && this.formSearch.chantier != "") {
                url = this.domaine + "compteExploit/chantier/" + this.formSearch.chantier;
            } else {
                if (this.formSearch.projet != undefined && this.formSearch.projet != "") {
                    url = this.domaine + "compteExploit/projet/" + this.formSearch.projet;
                }
            }

            if (url == "") {
                return;
            }
            this.$http.get(url).then(function (response) {
                _this3.loading = false;
                _this3.bilanMensuel = response.body.mensuel;
                _this3.bilanTravaux = response.body.bilanTravaux.travaux;
                _this3.info = response.body.info;
                _this3.listeDetail = response.body.detailCompte;
                _this3.listeMateriaux = response.body.materiaux;
            }, function (errRep) {
                _this3.loading = false;
                _this3.$message.error("Une erreur est survenue lors du chargement du bilan");
            });
        },
        handleTabClick: function handleTabClick(tab) {
            switch (tab) {
                case "0":
                    break;
                case "1":
                    break;

                default:
                    break;
            }
        },


        //recherche info projet ou chantier
        submitForm: function submitForm() {}
    },

    mounted: function mounted() {
        this.loadProjet();
        //this.loadBilan();
    }
});

/***/ }),

/***/ "8P/w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_chart_bar__ = __webpack_require__("GbHy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_chart_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_chart_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_chart_pie__ = __webpack_require__("Vb+l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_echarts_lib_chart_pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_echarts_lib_chart_pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_tooltip__ = __webpack_require__("Oq2I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_title__ = __webpack_require__("miEh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts__ = __webpack_require__("XLwt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_echarts__ = __webpack_require__("cs+8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line__ = __webpack_require__("4UDB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_divers_LoadDepenseProduitExcel_vue__ = __webpack_require__("PBTy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_projet_LoadShowGraph_vue__ = __webpack_require__("DRSj");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// var echarts = require('echarts/lib/echarts')




 // Utilise cette méthode pour importer echarts







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_8__components_Loading__["a" /* default */],
    LoadDepenseProduitExcel: __WEBPACK_IMPORTED_MODULE_9__components_divers_LoadDepenseProduitExcel_vue__["a" /* default */],
    LoadShowGraph: __WEBPACK_IMPORTED_MODULE_10__components_projet_LoadShowGraph_vue__["a" /* default */],
    "v-chart": __WEBPACK_IMPORTED_MODULE_6_vue_echarts___default.a
  },
  name: "DetailBudgetProjet",
  props: {
    show: {
      type: Boolean
    },
    detailProjet: {
      type: Object
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      summaries: [],
      loading: false,
      dialogShowGraph: false,
      dialogNewImporter: false,
      dialogDetail: false,
      showButonExcel: false,
      dialogueImprimer: false,
      listPlanComptable: [],
      listeRecherche: [],
      listeRapport: [],
      listeChantier: [],
      listeInfoProjet: [],
      listeData: [],
      listTravaux: [],
      listeTypeCharge: [{ text: "DIRECT", value: "DIRECT" }, { text: "INDIRECTE", value: "INDIRECTE" }],
      selectTaches: "",
      listTravauxResult: [],
      listProjetDepense: [],
      totalInfo: [],
      selectTravaux: "",
      typeGraph: "",
      listChargeResult: [],
      mntTotalChargeI: 0,
      mntTotalChargeD: 0,
      mntTotalChargeDE: 0,
      mntTotalChargeMA: 0,
      mntTotalDepense: 0,
      listeBudget: [],
      bilanMensuel: [],
      listTaches: [],
      listDataDepenses: [],
      listTotals: [],
      infoProjet: null,
      selectAnnee: "",
      bilanTravaux: [],
      listeDetail: [],
      selectTypeCharge: null,
      showModalLoadData: false,
      showModalgraphData: false,
      helpDemande: [{
        num: "1",
        text: "Somme de toutes les commandes éffectuées"
      }, {
        num: "2",
        text: "Somme de toutes les demandes de fond éffectuées"
      }, {
        num: "3",
        text: "Somme de toutes les dépenses indiqué dans le rapport journalier"
      }],
      helpDemandeN: [{
        num: "1",
        text: "Somme de toutes les commandes éffectuées dans les travaux"
      }, {
        num: "2",
        text: "Somme de toutes les demandes de fond éffectuées dans les travaux"
      }, {
        num: "3",
        text: "Somme de toutes les dépenses indiqué dans le rapport journalier dans les travaux"
      }],

      //  new data
      selectProjet: [],
      projetS: null,
      selectChantier: [],
      selectPlan: [],
      libelleChantier: "",
      //critere de recherche
      formTri: { periode: "" },
      fileExcel: [],
      hideInterface: false,
      showRecherche: false,

      projetsSelectionnes: [],
      plansSelectionnes: [],
      listeProjet: [], // Remplir avec vos données de projet
      selectedFileName: "", // Nom du fichier sélectionné
      fichierSelect: null }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "fileExcel", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "compte", "0"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dialogConfirm", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnPop", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "totalMntPropose", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "totalMntValide", 0), _ref;
  },


  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      var _this2 = this;

      this.dialogDetail = newValue;
      if (newValue == true) {
        this.listeBudget = this.detailProjet.budgets;
        var _this = this;
        this.totalMntPropose = 0;
        this.totalMntValide = 0;
        this.totalMntMarche = 0;
        this.listeBudget.forEach(function (item) {
          _this2.totalMntPropose += item.mntTotalBudgetPropose;
          _this2.totalMntValide += item.mntTotalBudgetValide;
        });
        this.loadBilan(this.detailProjet.idProj);
      }
    }
  },

  methods: {
    handleTabClick: function handleTabClick(tab) {
      switch (tab) {
        case "0":
          break;
        case "1":
          break;

        default:
          break;
      }
    },
    headerRowStyle: function headerRowStyle(_ref2) {
      var row = _ref2.row,
          rowIndex = _ref2.rowIndex;

      return { color: "black" };
    },
    statistique: function statistique(dataStaBuge, dataStatDepen) {
      var chartDom = document.getElementById("main");
      var myChart = __WEBPACK_IMPORTED_MODULE_5_echarts__["init"](chartDom);
      var option;

      option = {
        title: {
          text: "Statistique des dépenses"
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["TOTAL MONTANT PLANIFIÉ ", "TOTAL MONTANT HT ENGAGÉ"]
        },
        grid: {
          left: "10%",
          right: "10%",
          bottom: "10%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["Janvier", "Fevrier", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Decembre"]
        },
        yAxis: {
          type: "value"
        },
        series: [{
          name: "TOTAL MONTANT HT PLANIFIE",
          type: "line",
          stack: "Total",
          data: []
        }, {
          name: "TOTAL MONTANT HT ENGAGE",
          type: "line",
          stack: "Total",
          data: []
        }]
      };

      var tabNb = option.xAxis.data.length;
      for (var i = 0; i < tabNb; i++) {
        for (var dataCBud in dataStaBuge) {
          var mois = option.xAxis.data;
          if (mois[i] === dataStaBuge[dataCBud]["mois"]) {
            option.series[0].data.push({
              value: dataStaBuge[dataCBud]["montant"],
              name: "TOTAL MONTANT HT PLANIFIE"
            });
          } else {
            option.series[0].data.push({
              value: 0,
              name: "TOTAL MONTANT HT PLANIFIE"
            });
          }
        }
      }
      for (var _i = 0; _i < tabNb; _i++) {
        for (var dataCBdep in dataStatDepen) {
          var _mois = option.xAxis.data;
          if (_mois[_i] === dataStatDepen[dataCBdep]["mois"]) {
            option.series[1].data.push({
              value: dataStatDepen[dataCBdep]["montant"],
              name: "TOTAL MONTANT HT ENGAGE"
            });
          } else {
            option.series[1].data.push({
              value: 0,
              name: "TOTAL MONTANT HT ENGAGE"
            });
          }
        }
      }

      option && myChart.setOption(option);

      // DIGRAMME CIRCULAIRE
      var optionComd = {
        title: {
          text: "Statistique des dépenses",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["PLANIFIE", "ENGAGEÉ"]
        },
        series: [{
          name: "DEPENSE(S)",
          type: "pie",
          radius: "75%",
          center: ["50%", "60%"],
          color: ["#ff6f43", "#26a59a"],
          data: [],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      };

      var dataCommandeFour = [this.mntTotalChargeDE, this.mntTotalChargeMA];
      var libelle = ["Dépensé", "budget"];
      for (var dataCom in dataCommandeFour) {
        optionComd.series[0].data.push({
          value: dataCommandeFour[dataCom],
          name: libelle[dataCom]
        });
      }

      var chartDempense = __WEBPACK_IMPORTED_MODULE_5_echarts__["init"](document.getElementById("chartDempense"));
      chartDempense.setOption(optionComd);
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getSumm: function getSumm(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 4) {
          sums[index] = "N/A";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    calculateSummaries: function calculateSummaries(_ref3) {
      var columns = _ref3.columns,
          data = _ref3.data;

      var sums = [];
      console.log("columns", columns);
      console.log("data", data);

      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]) || 0;
        });
        sums[index] = values.reduce(function (prev, curr) {
          return prev + curr;
        }, 0);
      });
      return sums.map(function (sum) {
        return typeof sum === "number" ? new Intl.NumberFormat().format(sum) + " XOF" : sum;
      });
    },
    handleChange: function handleChange(newValue, oldValue) {},
    closeFormTypeProduit: function closeFormTypeProduit() {
      this.showModalLoadData = false;
      this.loadData();
    },
    closeFormShowGraph: function closeFormShowGraph() {
      this.showModalgraphData = false;
    },
    loadBilan: function loadBilan(idProjet) {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + "budgetProjet/bilan/projet/" + idProjet;
      this.$http.get(url).then(function (response) {
        _this3.loading = false;
        _this3.bilanMensuel = response.body.mensuel;
        _this3.bilanTravaux = response.body.bilanTravaux.travaux;
        _this3.listeDetail = response.body.detailCompte;
      }, function (errRep) {
        _this3.loading = false;
        _this3.$message.error("Une erreur est survenue lors du chargement du bilan");
      });
    },
    loadProjet: function loadProjet() {
      var _this4 = this;

      var url = this.domaine + "projet/indicateur/projet";

      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this4.loading = false;
        _this4.listeProjet = response.body.projet;
        // this.listeRapport = response.body.rapport;
      }, function (errRep) {
        _this4.loading = false;
        _this4.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    loadPlanComptable: function loadPlanComptable() {
      var _this5 = this;

      var url = this.domaine + "planComptable/all/planComptable/index";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this5.loading = false;
        _this5.listPlanComptable = response.body.liste;
        // this.listeRapport = response.body.rapport;
      }, function (errRep) {
        _this5.loading = false;
        _this5.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    loadData: function loadData() {
      var _this6 = this;

      var url = "";
      this.loading = true;
      url = this.domaine + "projet/liste/info/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this6.loading = false;
          _this6.listTravauxResult = response.body.projets;
          _this6.listProjetDepense = response.body.projets;
          _this6.totalInfo = response.body.totals;
          _this6.listeData = response.body;
          _this6.initBarChart(response.body.barChartData); // INDICATEURS CLES PAR PROJETS
          _this6.initChart(response.body.barChartData); // pour COURBE DEVOLUTION DES MARGES
          _this6.initLineChart(response.body.stackedLinData); //INDICATEURS CLES POUR TRANSACTKON
        }
      });
    },
    loadTravaux: function loadTravaux() {
      var _this7 = this;

      this.listTravaux = [];
      if (this.selectChantier != "" && this.selectChantier != null) {
        this.loading = true;

        var url = this.domaine + "projet/" + this.selectChantier + "/index/chantier/travaux";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this7.listeTravaux = response.body.travaux;
            _this7.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un chantier");
        this.loading = false;
      }
    },
    loadTaches: function loadTaches() {
      var _this8 = this;

      this.listTravaux = [];
      if (this.selectTravaux != "" && this.selectTravaux != null) {
        this.loading = true;

        var url = this.domaine + "projet/travaux_tache/" + this.selectTravaux + "/index/tache";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this8.listTaches = response.body.tache;
            _this8.loading = false;
          }
        });
      }
    },
    onchangeChantier: function onchangeChantier(chantierS) {
      var _this9 = this;

      this.listeChantier.find(function (item) {
        if (item.id == chantierS) {
          _this9.listeTravaux = item.travauxId;
        }
      });
    },
    onChangeTravaux: function onChangeTravaux(travaux) {
      var _this10 = this;

      this.listeTravaux.find(function (item) {
        if (item.idChantier == travaux) {
          _this10.listTaches = item.travauxId;
        }
      });
    },
    getSelectedProjetsLabels: function getSelectedProjetsLabels(row) {
      // Convertir this.selectProjet en tableau s'il ne l'est pas déjà
      var selectedIds = Array.isArray(row) ? row : [row];

      // Filtrer les projets sélectionnés et récupérer leurs informations
      var selectedProjets = this.listeProjet.filter(function (projet) {
        return selectedIds.includes(projet.id);
      });

      // Créer un objet avec les informations des projets sélectionnés
      return selectedProjets.map(function (projet) {
        return {
          id: projet.id,
          libelle: projet.libelle
        };
      });
    },
    getSelectedPlansLabels: function getSelectedPlansLabels() {
      // Convertir this.selectPlan en tableau s'il ne l'est pas déjà
      var selectedIds = Array.isArray(this.selectPlan) ? this.selectPlan : [this.selectPlan];

      // Filtrer les plans comptables sélectionnés et récupérer leurs informations
      var selectedPlans = this.listPlanComptable.filter(function (plan) {
        return selectedIds.includes(plan.id);
      });

      // Créer un objet avec les informations des plans sélectionnés
      return selectedPlans.map(function (plan) {
        return {
          id: plan.id,
          libelle: plan.libelle,
          code: plan.code
          // Ajoutez d'autres propriétés si nécessaire
        };
      });
    },
    loadChantierSearch: function loadChantierSearch() {
      var _this11 = this;

      this.loading = true;

      this.listTravauxResult = [];
      this.listChantierResult = [];
      this.hideInterface = false;

      var data = new FormData();
      data.append("listProjet", this.selectProjet);
      data.append("charge", this.selectTypeCharge);
      data.append("compte", this.selectPlan);
      data.append("annee", this.selectAnnee);

      var projetsSelectionnes = [];
      this.selectProjet.forEach(function (id) {
        var projet = _this11.listeProjet.find(function (item) {
          return item.id === id;
        });
        if (projet) {
          projetsSelectionnes.push(projet.libelle);
        }
      });

      // Récupérer les libellés des plans comptables sélectionnés
      var plansSelectionnes = [];
      this.selectPlan.forEach(function (id) {
        var plan = _this11.listPlanComptable.find(function (item) {
          return item.id === id;
        });
        if (plan) {
          plansSelectionnes.push(plan.libelle);
        }
      });
      this.projetsSelectionnes = projetsSelectionnes;
      this.plansSelectionnes = plansSelectionnes;

      console.log("projetsSelectionnes", this.projetsSelectionnes);
      var url = this.domaine + "projet/index/recherche/info";
      this.$http.post(url, data).then(function (response) {
        _this11.loading = false;
        if (response.body) {
          _this11.showRecherche = true;
          _this11.$notify({
            title: "RESULTAT",
            message: response.body.projets.length > 0 ? "La recherche a retourn\xE9 " + response.body.projets.length + " r\xE9sultat(s)." : "Aucun résultat trouvé.",
            type: response.body.projets.length > 0 ? "success" : "warning",
            position: "top-center"
          });
          console.log("response", response);
          if (_this11.selectPlan.length > 0) {
            _this11.hideInterface = true;
          }
          _this11.loading = false;
          _this11.listTravauxResult = response.body.projets;
          _this11.totalInfo = response.body.totals;
          _this11.listeData = response.body;
          _this11.initBarChart(response.body.barChartData); // INDICATEURS CLES PAR PROJETS
          _this11.initChart(response.body.barChartData); // pour COURBE DEVOLUTION DES MARGES
          _this11.initLineChart(response.body.stackedLinData); //INDICATEURS CLES POUR TRANSACTKON
        }
      });
    },
    onFileExcelPicked: function onFileExcelPicked(event) {
      var _this12 = this;

      this.fileExcel.splice(0, 1);
      var files = event.target.files;
      if (!files.length) return;

      var filename = files[0].name;
      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez sélectionner un fichier Excel valide.");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieure à 1024 ko.");
        return;
      }

      this.selectedFileName = filename; // Mettre à jour le nom du fichier sélectionné
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this12.fileExcel.push(fileReader.result);
      });
      fileReader.readAsDataURL(files[0]);
      this.fichierSelect = files[0];
    },
    submitImport: function submitImport() {
      var _this13 = this;

      console.log("this.projetS", this.projetS);
      if (this.projetS === null || this.projetS === "") {
        this.$message.error("Veuillez sélectionner le projet.");
        return;
      }
      this.loading = true;
      var url = this.domaine + "projet/load/depense/excel";
      var data = new FormData();
      data.append("fichierExcel", this.fichierSelect);

      this.$http.post(url, data).then(function (resp) {
        _this13.loading = false;
        _this13.$notify({
          title: "Chargement liste des données du fichier",
          message: "Chargement effectué",
          type: "success",
          position: "top-right",
          duration: 7000
        });
        _this13.listDataDepenses = resp.body.liste;
        _this13.listTotals = resp.body.totals;
        _this13.showModalLoadData = true;
        _this13.dialogNewImporter = false;
        _this13.loadPlanComptable();
      }, function () {
        _this13.loading = false;
        _this13.$message.error("Erreur lors de l'importation du fichier");
      });
    },
    generateFileExcel: function generateFileExcel() {
      var url = this.domaine + "projet/generer/modele/depense/projet";
      window.open(url);
    },
    newImporter: function newImporter() {
      this.dialogNewImporter = true;
      this.selectedFileName = "";
      this.projetS = null;
    },
    onchangeInfo: function onchangeInfo(projetS) {
      var _this14 = this;

      this.listeProjet.find(function (item) {
        if (item.id == projetS) {
          _this14.listeInfoProjet = item;
        }
      });
    },
    onchangeCompte: function onchangeCompte(selectPlan) {
      console.log("selectPlan", selectPlan.length);
      this.listPlanComptable.forEach(function (element) {});
      this.hideInterface = false;
    },
    imprimerModePlan: function imprimerModePlan(mode) {
      var _this15 = this;

      this.loading = true;
      this.dialogueImprimer = true;
      var url = this.domaine + "projet/" + this.selectProjet + "/chantier/" + this.selectChantier + "/travaux/" + (this.selectTravaux ? this.selectTravaux : null) + "/taches/" + (this.selectTaches ? this.selectTaches : null) + "/imprimer/plan/" + this.user.id + "/" + mode + "/annee/" + (this.selectAnnee ? this.selectAnnee : null);
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this15.loading = false;
          _this15.dialogueImprimer = false;
          window.open(url);
        }
      });
      this.dialogueImprimer = false;
    },
    initBarChart: function initBarChart(row) {
      var _this16 = this;

      var barChart = __WEBPACK_IMPORTED_MODULE_5_echarts__["init"](this.$refs.bar_chart);
      var barChartOptions = {
        title: {
          text: "Statistiques des indicateurs clés des projets",
          left: "left",
          subtextStyle: {
            color: "#007BFF",
            fontSize: 14,
            cursor: "pointer",
            fontWeight: "bold"
          },
          // Activer les événements sur le sous-titre
          triggerEvent: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" }
        },
        legend: {
          data: ["Montant du marché", "Budget total", "Montant encaissé", "Montant décaissé"],
          bottom: 0
        },
        xAxis: {
          type: "category",
          data: row.projects.map(function (project) {
            return project.substring(0, 5);
          })
        },
        yAxis: {
          type: "value"
        },
        color: ["#5470C6", "#8e6e63", "#d3302f", "#378f3c"], // Palette de couleurs
        series: [{
          name: "Montant du marché",
          type: "bar",
          data: row.montantMarche,
          itemStyle: { color: "#5470C6" // Couleur spécifique
          } }, {
          name: "Budget total",
          type: "bar",
          data: row.budgetTotal,
          itemStyle: { color: "#8e6e63" // Couleur spécifique
          } }, {
          name: "Montant décaissé",
          type: "bar",
          data: row.montantDecaisse,
          itemStyle: { color: "#d3302f" // Couleur spécifique
          } }, {
          name: "Montant encaissé",
          type: "bar",
          data: row.montantEncaisse,
          itemStyle: { color: "#378f3c" // Couleur spécifique
          } }]
      };
      // Appliquer les options au graphique
      barChart.setOption(barChartOptions);
      var container = this.$refs.bar_chart;
      var voirPlusLink = document.createElement("div");
      voirPlusLink.innerHTML = "Voir plus";
      voirPlusLink.style.cssText = "\n          color: #007BFF;\n          font-size: 14px;\n          cursor: pointer;\n          font-weight: bold;\n          position: absolute;\n          left: 0;\n          top: 25px;\n        ";

      voirPlusLink.addEventListener("click", function () {
        _this16.handleVoirPlusClick("stat_projet");
      });

      container.appendChild(voirPlusLink);
    },
    initChart: function initChart(row) {
      var _this17 = this;

      var chart = __WEBPACK_IMPORTED_MODULE_5_echarts__["init"](this.$refs.chart);

      var options = {
        title: {
          text: "Courbe d'évolution des marges et du taux d'évolution physique",
          left: "left",
          subtextStyle: {
            color: "#007BFF",
            fontSize: 14,
            cursor: "pointer",
            fontWeight: "bold"
          },
          triggerEvent: true
        },

        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          },
          formatter: function formatter(params) {
            var result = params[0].axisValueLabel + "<br/>";
            params.forEach(function (param) {
              // Formater selon le type de donnée
              var value = param.seriesName === "Taux physique" ? param.value + "%" : param.value.toLocaleString() + " XOF";
              result += param.marker + param.seriesName + ": " + value + "<br/>";
            });
            return result;
          }
        },
        legend: {
          data: ["Marge", "Taux physique"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: row.projects.map(function (project) {
            return project.substring(0, 5);
          })

        },
        yAxis: [{
          type: "value",
          name: "Marge (XOF)",
          position: "left",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#4CAF50"
            }
          },
          axisLabel: {
            formatter: "{value} XOF"
          }
        }, {
          type: "value",
          name: "Taux physique (%)",
          position: "right",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#1976D2"
            }
          },
          axisLabel: {
            formatter: "{value} %"
          },
          splitLine: {
            show: false
          }
        }],
        series: [{
          name: "Marge",
          type: "line",
          smooth: true,
          yAxisIndex: 0, // Utilise le premier axe Y
          data: row.marges,
          lineStyle: {
            color: "#4CAF50",
            width: 3
          },
          itemStyle: {
            color: "#4CAF50"
          },
          symbol: "circle",
          symbolSize: 8
        }, {
          name: "Taux physique",
          type: "line",
          yAxisIndex: 1, // Utilise le second axe Y
          smooth: true,
          data: row.taux,
          lineStyle: {
            color: "#1976D2",
            width: 3
          },
          itemStyle: {
            color: "#1976D2"
          },
          symbol: "circle",
          symbolSize: 8
        }]
      };

      // Appliquer les options au graphique
      chart.setOption(options);

      var container = this.$refs.chart;
      var voirPlusLink = document.createElement("div");
      voirPlusLink.innerHTML = "Voir plus";
      voirPlusLink.style.cssText = "\n      color: #007BFF;\n      font-size: 14px;\n      cursor: pointer;\n      font-weight: bold;\n      position: absolute;\n      left: 0;\n      top: 25px;\n    ";

      voirPlusLink.addEventListener("click", function () {
        _this17.handleVoirPlusClick("courbe_marge");
      });

      container.appendChild(voirPlusLink);
    },
    initLineChart: function initLineChart(row) {
      var _this18 = this;

      var chart = __WEBPACK_IMPORTED_MODULE_5_echarts__["init"](this.$refs.trans);

      // Formatage des données pour une meilleure lisibilité
      var formatNumber = function formatNumber(value) {
        return value.toString();
      };

      var options = {
        title: {
          text: "Etat des transactions des projets (Débit / Crédit)",
          left: "left",
          subtextStyle: {
            color: "#007BFF",
            fontSize: 14,
            cursor: "pointer",
            fontWeight: "bold",
            width: 200,
            overflow: 'break'
          },
          triggerEvent: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: 'cross'
          },
          formatter: function formatter(params) {
            var result = params[0].axisValue + '<br/>';
            params.forEach(function (param) {
              result += param.marker + param.seriesName + ': ' + new Intl.NumberFormat().format(formatNumber(param.value)) + ' XOF<br/>';
            });
            return result;
          }
        },
        legend: {
          data: ["Débit", "Crédit"],
          top: '50px'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //     dataZoom: {
        //       yAxisIndex: 'none'
        //     },
        //     restore: {}
        //   }
        // },
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 100
        }, {
          start: 0,
          end: 100
        }],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: row.mois,
          axisLabel: {
            rotate: 45
          }
        },
        yAxis: [{
          type: "value",
          name: "Débit",
          position: 'left',
          axisLabel: {
            formatter: function formatter(value) {
              return new Intl.NumberFormat().format(formatNumber(value)) + ' XOF';
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#ff4d4f'
            }
          }
        }, {
          type: "value",
          name: "Crédit",
          position: 'right',
          axisLabel: {
            formatter: function formatter(value) {
              return new Intl.NumberFormat().format(formatNumber(value)) + ' XOF';
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#52c41a'
            }
          }
        }],
        series: [{
          name: "Débit",
          type: "line",
          data: row.debit, // Prend la première valeur de chaque tableau
          yAxisIndex: 0,
          symbol: 'circle',
          symbolSize: 8,
          lineStyle: {
            color: '#ff4d4f',
            width: 3
          },
          itemStyle: {
            color: '#ff4d4f'
          },
          areaStyle: {
            color: new __WEBPACK_IMPORTED_MODULE_5_echarts__["graphic"].LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(255,77,79,0.3)' }, { offset: 1, color: 'rgba(255,77,79,0.1)' }])
          }
        }, {
          name: "Crédit",
          type: "line",
          data: row.credit,
          yAxisIndex: 1,
          symbol: 'circle',
          symbolSize: 8,
          lineStyle: {
            color: '#52c41a',
            width: 3
          },
          itemStyle: {
            color: '#52c41a'
          },
          areaStyle: {
            color: new __WEBPACK_IMPORTED_MODULE_5_echarts__["graphic"].LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(82,196,26,0.3)' }, { offset: 1, color: 'rgba(82,196,26,0.1)' }])
          }
        }]
      };

      // Appliquer les options au graphique
      chart.setOption(options);

      // Ajouter le lien "Voir plus"
      var container = this.$refs.trans;
      var voirPlusLink = document.createElement("div");
      voirPlusLink.innerHTML = "Voir plus";
      voirPlusLink.style.cssText = "\n          color: #007BFF;\n          font-size: 14px;\n          cursor: pointer;\n          font-weight: bold;\n          position: absolute;\n          left: 0;\n          top: 25px;\n        ";

      voirPlusLink.addEventListener("click", function () {
        _this18.handleVoirPlusClick("transactions");
      });

      container.appendChild(voirPlusLink);

      // Gestion du redimensionnement
      window.addEventListener('resize', function () {
        chart.resize();
      });
    },
    handleVoirPlusClick: function handleVoirPlusClick(item) {
      console.log("Voir plus cliqué");
      this.typeGraph = item;
      this.showModalgraphData = true;
    }
  },
  mounted: function mounted() {
    this.loadProjet();
    this.loadPlanComptable();
    this.loadData();
  }
});

/***/ }),

/***/ "8RI3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_boardFactureFournisseur_vue__ = __webpack_require__("F/n8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dd6615c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_boardFactureFournisseur_vue__ = __webpack_require__("bAC1");
function injectStyle (ssrContext) {
  __webpack_require__("WvDW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_boardFactureFournisseur_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dd6615c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_boardFactureFournisseur_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8Rus":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tierce_boardFacture__ = __webpack_require__("7wE8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tierce_formAjoutFour__ = __webpack_require__("xQNe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tierce_boardFactureFournisseur__ = __webpack_require__("8RI3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_tierce_LoadTarifiFourn_vue__ = __webpack_require__("12V6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_tierce_LoadFourn_vue__ = __webpack_require__("WLV0");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Vb+l");
__webpack_require__("Oq2I");
__webpack_require__("miEh");








/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_4__components_Loading__["a" /* default */], LoadTarificationFourn: __WEBPACK_IMPORTED_MODULE_8__components_tierce_LoadTarifiFourn_vue__["a" /* default */], boardFacture: __WEBPACK_IMPORTED_MODULE_5__components_tierce_boardFacture__["a" /* default */], boardFactureFournisseur: __WEBPACK_IMPORTED_MODULE_7__components_tierce_boardFactureFournisseur__["a" /* default */], formAjoutFour: __WEBPACK_IMPORTED_MODULE_6__components_tierce_formAjoutFour__["a" /* default */], LoadFourn: __WEBPACK_IMPORTED_MODULE_9__components_tierce_LoadFourn_vue__["a" /* default */] },
    name: 'fournisseur',
    data: function data() {
        var _ref;

        return _ref = {
            loading: false,
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),

            headersMaintenance: [{ text: 'Nom du demandeur', align: 'left', value: '' }, { text: 'Date', align: 'left', value: '' }, { text: 'Etat', align: 'left', value: '' }, { text: 'Actions', align: 'center', value: '' }],
            racourcis: [{ path: '/', text: 'Accueil', disabled: false }, { path: '/fournisseur', text: 'Liste des fournisseurs', disabled: true }],
            menuNais: false,
            menuDeliv: false,
            dialogImprCommande: false,
            dialogImprFacture: false,
            dialogImprFusionCom: false,
            dialogImprLivraison: false,
            dialogImport: false,
            menuExpi: false,
            dialogDevis: false,
            validCommd: false,
            dialogConfirm: false,
            // dialogConf: false,
            //dialogAjout: false,
            dialogShow: false,
            dialogShowTarif: false,

            //mis pour crée le contrat de soutraitance
            dialogShowModalSous: false,
            dateDebut: '',
            dateFin: '',
            chefProjet: '',
            optinListTaches: [{ libelle: "", key: 1, quantite: "", unite: "", qteAsou: 0, id: "", total: 0 }],
            listTaches: [],
            showValeur: false,
            tableInventaire: [],
            valeurQte: '',
            valeurTtLigne: 0,
            qteAsous: 0,
            valeurPrix: '',
            valeurDateF: '',
            valeurDateD: '',
            IdTache: '',
            valeurUnite: '',
            formInventaire: {},
            listeTravaux: [],
            listeChantier: [],
            listeProjet: [],
            listeTacheTrx: [],
            tacheS: '',

            dialogEdit: false,
            dialogSupr: false,
            dialogReactiv: false,
            commReactiv: '',
            dialogConteneur: false,
            dialogSuprComm: false,
            dialogComm: false,
            dialogFacture: false,
            dialogFactureFact: false,
            dialogTarif: false,
            dialogArticlConteneur: false,
            dialogShowCommande: false,
            dialogShowFacture: false,
            dialogValiFacture: false,
            dialogLivraison: false,
            dialogShowLivraison: false,
            dialogShowMaintenance: false,
            showModalLoadTarification: false,
            showModalLoadTarificationFour: false,
            dialogAppro: false,
            projetS: '',
            valid: true,
            personneType: true,
            idFourn: '',
            nom: '',
            nomRules: [function (v) {
                return !!v || 'Le nom est obligatoire';
            }],
            pren: '',
            prenRules: [function (v) {
                return !!v || 'Le prénom est obligatoire';
            }],
            dateNais: null,
            lieuNais: '',
            selectNaturePiece: "",
            naturePiece: [{ text: 'CNI', value: 1 }, { text: 'Passeport', value: 2 }, { text: 'Permis de conduire', value: 3 }, { text: 'Attestation', value: 4 }],
            naturePieceRules: [function (v) {
                return !!v || 'La nature de la pièce est obligatoire';
            }],
            numPiece: '',
            numPieceRules: [function (v) {
                return !!v || 'Le numéro de la pièce est obligatoire';
            }],
            dateDeliv: "",
            dateExpi: "",
            contact: '',
            contactRules: [function (v) {
                return !!v || 'Le contact est obligatoire';
            }],
            loginUser: '',
            mdpUser: '',
            mdpVerUser: '',
            loginUserRules: [function (v) {
                return !!v || 'Le login est obligatoire';
            }, function (v) {
                return (/^\w+([.-]?\w+)*@\w+([-]?\w+)*(.\w{2,3})+$/.test(v) || 'Vous devez respecter format de E-mail'
                );
            }],
            mdpUserRules: [function (v) {
                return !!v || 'Le mot de passe est obligatoire';
            }, function (v) {
                return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
            }],
            mdpVerUserRules: [function (v) {
                return !!v || 'La vérifiaction du mot de passe est obligatoire. Il doit être identique au mot de pas entré précédenment';
            }, function (v) {
                return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
            }],
            service: '',
            profession: '',
            domicile: '',
            selectTypeEntre: '',
            nationalite: '',
            formJuridique: '',
            formJuridiqueRules: [function (v) {
                return !!v || 'La forme juridique est obligatoire';
            }],
            registreComm: '',
            siege: '',
            siegeRules: [function (v) {
                return !!v || 'Le siège social est obligatoire';
            }],
            telBureau: '',
            telBureauRules: [function (v) {
                return !!v || 'Le téléphone est obligatoire';
            }],
            representant: '',
            representantRules: [function (v) {
                return !!v || 'Le nom de représentant légal est obligatoire';
            }],
            metier: '',
            metierRules: [function (v) {
                return !!v || 'Le type de métier est obligatoire';
            }],
            selectType: ""
        }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'metier', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'typeFour', [{ text: 'Fournisseur', value: 1 }, { text: 'Prestataire', value: 2 }, { text: 'Fournisseur et Prestataire', value: 3 }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'typeFourRules', [function (v) {
            return !!v || 'Le type de fournisseur est obligatoire';
        }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'selectCivilite', ""), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'civilite', [{ text: 'Monsieur' }, { text: 'Madame' }, { text: 'Mademoiselle' }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'civiliteRules', [function (v) {
            return !!v || 'La civilité est obligatoire';
        }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listFour', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'fourSelect', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listFourFinal', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listProduiFinal', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'statAllFour', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'statAllFactureFour', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'statsFactureFourn', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'comboMetier', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'comboProduit', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'comboProfession', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'comboFournisseur', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'statFourn', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'nbrComAll', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'nbrFactAll', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'nbrLivrAll', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'depenseAll', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'nbrComFourn', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'nbrFactFourn', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'nbrLivrFourn', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'depenseFourn', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'detailFour', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'fournCourant', {}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'libelle', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dateLivr', ""), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'selectUsers', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'users', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listProd', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'tableEnsemble', [{
            infoConteneur: {
                marque: '',
                forfait: '',
                poidsCargot: '',
                tare: '',
                mesure: '',
                description: '',
                numeroConte: '',
                numCle: ''
            },
            infoArticle: {
                metrage: '',
                poidsBrute: '',
                poidsNet: '',
                tare: '',
                designation: '',
                tourtes: '',
                code: '',

                qte: ''
            }
        }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'formAjoutConteneur', {}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'formAjoutArticle', {}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'optionCommande', [{ key: 1, produit: '', prix: 0, qte: 1, remise: 0, tva: 0, total: 0, id: '' }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totalComHT', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totalComHTSR', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totalComRemise', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totalComTVA', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totalComTTC', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totComLigneTTC', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totComLigneTTCFormat', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listCommande', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'idComm', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'detailCommande', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'commCourant', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listFacture', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'factureCourant', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'detailFacture', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'decisionFact', [{ text: 'Accepter', value: 1 }, { text: 'Rejeter', value: 2 }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'upload', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'selectDecisionFact', ""), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'selectModalite', ""), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'modalite', [{ text: 'Mensuel', value: 1 }, { text: 'Trimestrielle', value: 2 }, { text: 'Semestrielle', value: 3 }, { text: 'Annuel', value: 4 }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'selectModeRegl', ""), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'modeRegl', [{ text: 'Espèce', value: 1 }, { text: 'Chèque', value: 2 }, { text: 'Virement', value: 3 }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'datePaie', ""), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogDocsVisible', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogDocsUrl', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'etatLivraison', [{ text: 'Total', value: 1 }, { text: 'Partiellement', value: 2 }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'typeLivraison', [{ text: 'Standard', value: 1 }, { text: 'Bâteau', value: 2 }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'selectLivraison', ""), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'selectTypeLivraison', ""), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'provenanceConteneur', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'recepetionConteneur', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'numCpteLivraison', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'numVoyage', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'livreur', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'commentaire', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'e1', 1), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'd1', 1), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'formConteneurArticle', {}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'tableArticleConteneur', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'tableArticleConteneurAffiche', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'optionLivraison', [{ key: 1, value: '', qte: 1, qteL: 0, id: '' }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listLivraison', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'livraisonCourant', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'detailLivraison', null), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'showBoat', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'showConteneurs', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'statsPieCommande', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'optionLivr', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'optionType', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'etatAffichage', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'optionEntrepot', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'optionAppro', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'optionQteRecu', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totalCommande', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totalFacture', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listMaintenance', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'detailMaintenance', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'maintenanceCourant', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'longDevis', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listCaisse', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'selectCaisse', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'optionDevis', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'devisTotal', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'devisTva', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'devisHt', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listKeyword', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listFournConnect', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listProjet', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listChantier', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listTravaux', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'tableTarification', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'chantierS', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'fourniS', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'disabledBtnPop', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'produiS', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'travauxS', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'disabledBtn', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'disabledBtnF', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'disabledBtnL', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'disabledBtnM', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listProduit', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'selectProduit', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'selectIdProduit', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'prixAchat', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listeProd', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'tarifCourant', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'typeComm', [{ text: 'Commande pour un chantier', value: 1 }, { text: 'Commande pour une maintenance', value: 2 }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'selectTypeCom', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'selectDemande', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listDemande', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'infoProduit', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'image1', "/static/img-doc.png"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'image2', "/static/img-doc.png"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totalTva', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totalRemise', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totalHT', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogShowArticle', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogMontantCommande', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogComparaison', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'commandeInit', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'oui', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'non', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'detailArticle', {}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totCmdHtInit', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totCmdTvaInit', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totCommandeInit', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'commandeDeriv', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totalBenefice', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogProdNull', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listeProdNull', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listContrat', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totalContrat', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totalVerse', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totalRestant', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'selectContrat', null), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'disabledSelectCaisse', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'disabledSelectCaisse', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'mntRestantContrat', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'logoFacture', "/static/img-doc.png"), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'avance', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'modePaie', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'deleteConteneur', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'currentConteneurToDelete', null), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'modalitePaie', [{ text: 'A la commande', value: 1 }, { text: '10 jours nets', value: 10 }, { text: '30 jours nets', value: 30 }, { text: '30 jours fin du mois', value: 45 }, { text: '60 jours nets', value: 60 }, { text: '60 jours fin de mois', value: 75 }, { text: '90 jours nets', value: 90 }, { text: '90 jours fin de mois', value: 105 }, { text: '120 jours nets', value: 120 }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'totalComRemise', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dateLivr', null), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'disBtnAjtCom', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'taches', [{
            prop: 'codeGestion',
            label: 'Code analytique'
        }, {
            prop: 'produit',
            label: 'Produit concerné'
        }, {
            prop: 'unite',
            label: 'Unité'
        }, {
            prop: 'prix',
            label: "Prix d'achat"
        }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'formConteneur', {
            export: "",
            numComm: "",
            bl: "",
            reception: "",
            numChargement: "",
            numVoyage: "",
            provenance: ""
        }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'formConteneur', {
            marque: "",
            numConteneur: "",
            numCle: "",
            type: "",
            poids: "",
            nbPacket: 0,
            description: "",
            tare: "",
            mesure: "",
            metrageTotal: 0,
            poidsBrutTotal: 0,
            poidsNetTotal: 0,
            tareTotal: 0
        }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'tableConteneur', [{
            conteneur: {
                marque: "",
                numConteneur: "",
                numCle: "",
                type: "",
                poids: "",
                nbPacket: 0,
                description: "",
                tare: "",
                mesure: "",
                metrageTotal: 0,
                poidsBrutTotal: 0,
                poidsNetTotal: 0,
                tareTotal: 0
            },
            articles: [{
                code: "",
                designation: "",
                qte: "",

                tourtes: "",
                metrage: 0,
                poidsBrute: "",
                poidsNet: "",
                tare: "",
                mesure: ""
            }]

        }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'formArticle', {
            code: "",
            designation: "",
            qte: "",

            tourtes: "",
            metrage: 0,
            poidsBrute: "",
            poidsNet: "",
            tare: "",
            mesure: ""
        }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'typeConteneur', [{
            id: 1,
            libelle: "10'"
        }, {
            id: 2,
            libelle: "20'"
        }, {
            id: 3,
            libelle: "20'HC"
        }, {
            id: 4,
            libelle: "40'"
        }, {
            id: 8,
            libelle: "40' HC"
        }, {
            id: 5,
            libelle: "45'"
        }, {
            id: 6,
            libelle: "Open Top"
        }, {
            id: 7,
            libelle: "Flat Rack"
        }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'prodSelct', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listTypeRessource', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'nbTourtes', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'nbMetrage', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'nbPoidsBrutes', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'nbTare', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'nbPoidsNet', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'formBateau', {
            export: "",
            numCom: "",
            bl: "",
            reception: "",
            numChargement: "",
            numVoyage: "",
            provenance: ""
        }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'formComm', {}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'disableCaisse', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dataFactureStat', null), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dataCommandeStat', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'showFactureStat', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dataFactureStatNb', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'nombreSelection', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'multipleSelection', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dataFactureStatFour', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dataCommandeStatFour', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'showFactureStatFour', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dataFactureStatNbFour', null), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'mntEstimeContrat', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'mntFactureGenere', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'mntAVerserContrat', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'evolutionContrat', 0), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'typeProduit', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'fileExcel', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'lstRessources', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listeFacturesContrat', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogInfoContrat', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'detailContrat', {}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogSupTarif', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'avanceContSelect', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listCaisseComplete', []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'libTachePrest', null), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'showFour', false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'typeF', null), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'nameFile', ""), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'valeurUniteMateriel', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'codegestion', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'selectUnite', ''), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'listeProduitAffich', []), _ref;
    },

    computed: {
        loadCaisseCommd: function loadCaisseCommd() {
            var _this = this;

            return this.listCaisse.filter(function (elt) {
                if (_this.commCourant.idProj != "") {
                    if (_this.commCourant.idBanque) {
                        return _this.commCourant.idCaisse == elt.id || _this.commCourant.idBanque.filter(function (element) {
                            return element = elt.id;
                        });
                    }
                } else {
                    return true;
                }
            });
        }

    },

    mounted: function mounted() {
        this.loadPage();
        this.loadMetier();
        //this.loadFournisseurConnecte()
        this.loadFournLimit();
        this.loadUser();
        this.loadCaisse();
        this.loadDevis();
        this.loadProjet();
        this.loadProduitListe();
        this.loadDemande();
        this.loadTypeRessource();
        // this.loadProduit()
        this.showFactureStat = true;
    },


    watch: {
        avance: function avance(newValue, oldValue) {
            if (this.selectContrat != null && newValue > 0) {
                this.calculMontAvance();
            }
        }
    },

    methods: {
        handleFileExcel: function handleFileExcel(command //0=>Importer,1=>generer

        ) {
            switch (command) {
                case "0":
                    //importer un fichier
                    this.$refs.fileInputExcel.click();
                    break;
                case "1":
                    //generer un modele un fichier
                    this.generateFileExcel();
                    break;
            }
        },
        newContrat: function newContrat() {
            this.dialogShowModalSous = true;
            this.listTaches = [];
            this.valeurTtLigne = 0;
            this.totalHT = 0;
            this.tableInventaire = [];
            this.chantierS = '', this.tacheS = '', this.travauxS = '', this.chefProjet = '', this.qteAsous = '';
            this.dateFin = '', this.dateDebut = '', this.valeurDateD = '';
            this.valeurDateF = '';
            this.valeurUnite = '';
            this.optinListTaches = [{
                libelle: "",
                key: 1,
                quantite: "",
                qte: 0,
                qteAsou: 0,
                unite: "",
                id: "",
                total: 0
            }];
            this.loadProjet();
        },
        loadInfoTaches: function loadInfoTaches(tacheLibel) {
            var libelle = '';
            libelle = this.listTaches.find(function (item) {
                return item.libelle == tacheLibel;
            });
            this.IdTache = libelle.idTache;
            this.valeurQte = libelle.qte;
            this.valeurUnite = libelle.unite;
            this.valeurDateD = libelle.dateD;
            this.valeurDateF = libelle.dateF;
            this.valeurPrix = libelle.prixUHT;
            this.qteAsous = libelle.qteAsous;
        },
        calculTotalLign: function calculTotalLign(index) {
            this.valeurTtLigne = this.valeurPrix * index;
        },
        addListInventaire: function addListInventaire(item) {
            var _this2 = this;

            var etat = false;
            if (item.qte != 0) {
                this.tableInventaire.forEach(function (item) {
                    if (item.id === _this2.IdTache) {
                        etat = true;
                        _this2.$message.error("Cette tâche a déjà été ajoutée.");
                        return;
                    }
                });
                if (!etat) {
                    var total = this.valeurPrix * item.qte;
                    this.tableInventaire.push({
                        id: this.IdTache,
                        libelle: item.libelle,
                        dateD: this.valeurDateD,
                        dateF: this.valeurDateF,
                        prix: this.valeurPrix,
                        qteAsou: item.qte,
                        unite: this.valeurUnite,
                        qte: this.valeurQte,
                        totalHt: total
                    });
                    this.totalHT += this.valeurPrix * item.qte;
                    this.optinListTaches = [{
                        libelle: "",
                        key: 1,
                        quantite: "",
                        qte: 0,
                        qteAsou: 0,
                        unite: "",
                        id: "",
                        total: 0
                    }];
                    this.valeurQte = '';
                    this.valeurPrix = '';
                    this.valeurDateF = '';
                    this.valeurDateD = '';
                    this.valeurUnite = '';
                    this.IdTache = '';
                }
            }
        },
        calculMntTache: function calculMntTache() {
            this.totalHT = 0;
            for (var index in this.optinListTaches) {
                var item = this.optionTache[index];
                var total = item.qte * item.prix;
                if (total != undefined) {
                    this.totalHT += total;
                    this.optinListTaches[index].total = total;
                }
            }
        },
        submitContrat: function submitContrat() {
            var _this3 = this;

            if (this.tableInventaire.length > 0) {

                this.loading = true;
                var form = document.getElementById("formBesoin");
                var formdata = new FormData(form);
                var _url = this.domaine + "projet/" + this.travauxS + "/new/soustraite/tache";
                formdata.append("idUser", this.user.id);

                for (var prop in this.tableInventaire) {
                    var ligne = this.tableInventaire[prop];

                    formdata.append("options[id][]", ligne.id);
                    formdata.append("options[prix][]", ligne.prix);
                    formdata.append("options[qteAsou][]", ligne.qteAsou);
                }
                formdata.append("projetId", this.projetS);
                formdata.append("idFourn", this.fournCourant.id);
                formdata.append("chantierId", this.chantierS);
                formdata.append("travauxId", this.travauxS);
                formdata.append("totalHT", this.totalHT);

                this.$http.post(_url, formdata).then(function (response) {
                    if (response.body) {
                        var verif = response.body;
                        if (verif.code === 1) {
                            _this3.$notify({
                                title: "ENREGISTREMENT REUSSI",
                                message: "Besoin enregistré avec succès.",
                                type: "success",
                                position: "top-center"
                            });

                            _this3.dialogShowModalSous = false;
                            _this3.loadContrat(_this3.fournCourant);
                            _this3.loading = false;
                            _this3.$refs.formBesoin.reset();
                        }
                    } else {
                        _this3.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                        _this3.loading = false;
                        _this3.clear();
                    }
                }, function (response) {
                    _this3.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                    _this3.loading = false;
                });
            }
            var url = this.domaine + "fournisseur/info/produit";
        },
        loadTacheTrx: function loadTacheTrx(idtravaux) {
            var _this4 = this;

            var etat = this.listTravaux.find(function (item) {
                return item.id == idtravaux;
            });
            if (etat.soutraite == 0) {
                this.$message.error("Veuillez sélectionner des travaux sous-traités");
                return;
            } else {
                this.loading = true;
                this.etatButon = true;
                var url = this.domaine + "tache/travaux/" + etat.idTrx;
                this.$http.get(url).then(function (response) {
                    if (response.body) {
                        _this4.listTaches = response.body.taches;
                        _this4.loading = false;
                        if (response.body.taches.length === 0) {
                            _this4.showValeur = true;
                        }
                    }
                });
            }
        },
        generateFileExcel: function generateFileExcel() {
            this.dialogImport = false;
            var url = this.domaine + "product/exportEXC/listRessources";
            window.open(url);
        },
        generateFileExcelFour: function generateFileExcelFour() {
            var url = this.domaine + "fournisseur/generer/liste";
            window.open(url);
        },
        generateFileFour: function generateFileFour() {
            var url = this.domaine + "fournisseur/export/liste";
            window.open(url);
        },
        loadTypeRessource: function loadTypeRessource() {
            var _this5 = this;

            var url = this.domaine + "product/typeRessource";
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this5.listTypeRessource = response.body.types;
                    _this5.loading = false;
                }
            });
        },
        onFileExcelPicked: function onFileExcelPicked(event) {
            var _this6 = this;

            this.fileExcel.splice(0, 1);
            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".xls") <= 0) {
                return alert("Veuillez selectionner un fichier excel valide ");
            }
            if (files[0].size > 1048576) {
                this.$message.error("La taille du fichier est supérieur à 1024 ko");
                return;
            }
            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this6.fileExcel.push(fileReader.result);
            });
            fileReader.readAsDataURL(files[0]);

            var url = this.domaine + "fournisseur/loadTarif/excel";
            var data = new FormData();
            data.append("fichierExcel", files[0], files[0][name]);
            this.$http.post(url, data).then(function (resp) {
                _this6.loading = false;
                _this6.$notify({
                    title: "Chargement des tarifications",
                    message: "Chargement effectué",
                    type: "success",
                    position: "top-right",
                    duration: 5000
                });
                _this6.lstRessources = resp.body.listeTypeTravaux;
                _this6.showModalLoadTarification = true;
            }, function (error) {
                _this6.loading = false;
                _this6.$message.error("Erreur lors de l'importation du fichier");
            });
        },
        onFileExcelPickedFourn: function onFileExcelPickedFourn(event) {
            var _this7 = this;

            this.fileExcel.splice(0, 1);
            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".xls") <= 0) {
                return alert("Veuillez selectionner un fichier excel valide ");
            }
            if (files[0].size > 1048576) {
                this.$message.error("La taille du fichier est supérieur à 1024 ko");
                return;
            }
            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this7.fileExcel.push(fileReader.result);
            });
            fileReader.readAsDataURL(files[0]);

            var url = this.domaine + "fournisseur/loadTarif/fourn/excel";
            var data = new FormData();
            data.append("fichierExcel", files[0], files[0][name]);
            this.$http.post(url, data).then(function (resp) {
                _this7.loading = false;
                _this7.$notify({
                    title: "Chargement des tarifications",
                    message: "Chargement effectué",
                    type: "success",
                    position: "top-right",
                    duration: 5000
                });
                _this7.lstRessources = resp.body.listeTypeTravaux;
                _this7.showModalLoadTarificationFour = true;
            }, function (error) {
                _this7.loading = false;
                _this7.$message.error("Erreur lors de l'importation du fichier");
            });
        },
        loadUniteProduit: function loadUniteProduit(item) {
            var valeur = void 0;
            var code = '';
            this.valeurUniteMateriel = '';
            valeur = this.listeProduitAffich.find(function (element) {
                if (element.id == item) {
                    code = element.codeGestion;
                    return element.unite;
                }
            });
            this.codegestion = code;
            this.valeurUniteMateriel = valeur.unite;
        },
        handleTypeLivr: function handleTypeLivr(valuetypeLivr) {
            var _this8 = this;

            if (valuetypeLivr == 1) {
                var optionLivrCopie = this.optionLivraison.slice();
                this.optionLivraison.splice(0);

                optionLivrCopie.forEach(function (elt, index) {
                    var eltMod = elt;
                    eltMod.qteL = elt.qte;
                    _this8.optionLivraison.push(eltMod);
                });

                // for(let indexOptLivr in this.optionLivraison){
                //     let qteL = this.optionLivraison[indexOptLivr].qte
                //     this.optionLivraison[indexOptLivr].qteL = qteL
                // }
            } else {

                var _optionLivrCopie = this.optionLivraison.slice();
                this.optionLivraison.splice(0);
                _optionLivrCopie.forEach(function (elt, index) {
                    var eltMod = elt;
                    eltMod.qteL = 0;
                    _this8.optionLivraison.push(eltMod);
                });
                // for(let indexOptLivr in this.optionLivraison){
                //     this.optionLivraison[indexOptLivr].qteL = 3
                // }
            }
        },
        showFormFour: function showFormFour() {
            this.showFour = true;
        },
        handleCommandFour: function handleCommandFour(command) {
            this.showFour = true;
            this.typeF = command;
        },
        closeFormFourTarif: function closeFormFourTarif(item) {
            var _this9 = this;

            var url = "";
            if (this.droitAcces.index_produit_fourn) {
                url = this.domaine + 'fournisseur/' + item + '/index/produit';
            } else {
                url = this.domaine + 'fournisseur/' + item + '/index/' + this.user.id + '/produit';
            }

            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this9.listProduit = response.body.produit;
                    _this9.loading = false;
                }
            });
        },
        closeFormFour: function closeFormFour() {
            this.showFour = false;
            this.typeF = null;
            this.fournCourant = {};
            this.loadFournLimit();
        },
        imprimerListe: function imprimerListe(mode) {
            var _this10 = this;

            this.loading = true;
            this.optionCommande = this.multipleSelection;
            var options = [];
            for (var index = 0; index < this.multipleSelection.length; index++) {
                var element1 = this.multipleSelection[0]["projet"];
                var element = this.multipleSelection[index]["projet"];
                // if (element1 != element) {
                //    this.$notify({
                //         title: "Fusion",
                //         message: "Veuillez sélectionner des commandes issues d'un même projet",
                //         type: "error",
                //         position: "top-center"
                //       });
                //     return
                //   }
            }

            var formdata = new FormData();
            for (var prop in this.multipleSelection) {
                var ligne = this.multipleSelection[prop];
                options.push(ligne.id);
            }

            var url = this.domaine + "fournisseur/imprimerFusionPdf/comamnde/" + mode;
            formdata.append("options", options);
            formdata.append("idUser", this.user.id);

            var req = new XMLHttpRequest();
            this.$http.post(url, formdata, { responseType: "arraybuffer" }).then(function (response) {
                var blob = new Blob([response.data], {
                    type: response.headers.get("content-type")
                });
                _this10.loading = false;
                var url = URL.createObjectURL(blob);
                _this10.loading = false;
                _this10.dialogImprFusionCom = false;
                window.open(url);
            }, function (error) {
                _this10.loading = false;
                _this10.$message.error("Une erreur est survenue lors du de la génération du document pdf");
            });
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.multipleSelection = val;
            this.nombreSelection = val;
        },
        besoinSelect: function besoinSelect(row, index) {
            var etat = null;
            if (parseInt(row.qte) != 0) {
                etat = true;
            } else {
                etat = false;
            }
            return etat;
        },
        loadTypeProduit: function loadTypeProduit(item) {
            var _this11 = this;

            if (this.$refs.typeProduit == "") {
                return;
            }
            this.loading = true;
            var url = this.domaine + "product/productSelect/type/" + item;
            this.$http.get(url).then(function (response) {
                _this11.loading = false;
                _this11.listProd = response.body.produits;
                _this11.listeProduitAffich = response.body.produits;
            }, function (errRep) {
                _this11.loading = false;
                _this11.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
            });
        },
        supprimerArticle: function supprimerArticle(index, rows) {
            rows.splice(index, 1);
        },
        editConteneur: function editConteneur(item) {
            this.formConteneur = item.conteneur;
            this.formArticle = item.articles[item.articles.length - 1];
            this.tableArticleConteneur = item.articles;
            this.dialogConteneur = true;
        },
        changeContrat: function changeContrat(data) {
            var _this12 = this;

            this.libTachePrest = null;
            if (data == null) {
                this.disabledSelectCaisse = false;
                return;
            }
            this.optionCommande.splice(0);
            if (data == "undefined" || data == "") {
                this.disabledSelectCaisse = false;
                return;
            }
            //rechercher la caisse lie au projet du contrat
            this.loading = true;

            this.listCaisse = this.listCaisseComplete;

            var url = this.domaine + 'projet/caisse/contrat/' + data;
            this.$http.get(url).then(function (response) {
                var _optionCommande;

                _this12.selectCaisse = response.body.caisse.id;

                //filtrer la liste des caisse
                _this12.listCaisse = _this12.listCaisse.filter(function (elt) {
                    if (elt.id == response.body.caisse.id || elt.id == response.body.caisse.idBanque) {
                        return true;
                    }
                    return false;
                });

                _this12.mntRestantContrat = response.body.caisse.mntRestant;
                (_optionCommande = _this12.optionCommande).push.apply(_optionCommande, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(response.body.caisse.produits));
                //this.optionCommande.produit =  response.body.caisse.libTrx;
                if (response.body.caisse.mntAVerse > 0) {
                    _this12.optionCommande[0].total = response.body.caisse.mntAVerse;
                } else {
                    _this12.optionCommande[0].total = 0;
                }

                _this12.mntEstimeContrat = response.body.caisse.mntEstime;
                _this12.mntFactureGenere = response.body.caisse.mntFacture;
                _this12.mntAVerserContrat = response.body.caisse.mntAVerse;
                _this12.evolutionContrat = response.body.caisse.evolution;
                _this12.projetS = response.body.caisse.idProjet;
                _this12.loadChantier();
                _this12.chantierS = response.body.caisse.idChantier;
                _this12.loadTravaux();
                _this12.calculMontAvance();
                _this12.libTachePrest = response.body.caisse.libTache;
                _this12.travauxS = response.body.caisse.idTravaux;
                _this12.avanceContSelect = response.body.caisse.isAvance;
                if (response.body.caisse.isAvance == true) {
                    _this12.$message('Une avance de demarrage a déja été versé pour ce contrat');
                }
                _this12.loading = false;
                _this12.disabledSelectCaisse = false;
            }, function (error) {
                _this12.loading = false;
                _this12.disabledSelectCaisse = false;
                _this12.$message.error("Une erreur est survenue lors du chargement de la caisse du projet");
            });
        },
        calculMontAvance: function calculMontAvance() {
            if (this.selectContrat != null && this.avance != 0) {
                var mntAvance = this.mntEstimeContrat * this.avance / 100;
                this.optionCommande[0].prix = mntAvance;
                this.optionCommande[0].total = mntAvance;
            }
        },
        verifFormConteneur: function verifFormConteneur() {
            if (this.formConteneur.marque != null && this.formConteneur.numConteneur != null && this.formConteneur.numCle != null) {
                return true;
            } else {
                return false;
            }
        },
        newConteneur: function newConteneur(formName) {

            this.formConteneur = {
                marque: '',
                type: '',
                poids: '',
                tare: '',
                mesure: '',
                description: '',
                numConteneur: '',
                numCle: '',
                nbPacket: ''
            }, this.formConteneurArticle = {
                metrage: '',
                poidsBrute: '',
                poidsNet: '',
                tare: '',
                designation: '',
                tourtes: '',
                code: '',
                qte: ''
            }, this.d1 = 1;
            this.dialogConteneur = true;
            // this.tableConteneur.splice(0)
            this.tableArticleConteneur.splice(0);
            // this.isEdit = false
            // this.idEditMission = ""
        },
        loadContrat: function loadContrat(ligne) {
            var _this13 = this;

            this.loading = true;
            var url = this.domaine + 'fournisseur/contrat/' + ligne.id;
            this.$http.get(url).then(function (response) {
                _this13.listContrat = response.body.contrats;
                _this13.totalContrat = response.body.totalContrat;
                _this13.totalVerse = response.body.totalVerse;
                _this13.totalRestant = response.body.totalRestant;
                _this13.loading = false;
            }, function (error) {
                _this13.loading = false;
                _this13.$message.error("Une erreur est survenue lors du chargement des contrats fournisseurs");
            });
        },
        loadProjet: function loadProjet() {
            var _this14 = this;

            var url = this.domaine + 'projet/index/projet/all';
            this.loading = true;
            this.$http.get(url).then(function (response) {
                _this14.loading = false;
                _this14.listProjet = response.body.projet;
                _this14.projetS = _this14.detailCommande.projet;
            }, function (errRep) {
                _this14.loading = false;
                _this14.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
            });
        },
        loadPage: function loadPage() {
            this.loading = true;
        },
        imprimerDemandeDevis: function imprimerDemandeDevis(item) {
            var url = this.domaine + 'maintenance/' + item.id + '/imprimer/demandeDevis';
            this.$http.get(url).then(function (response) {
                if (response.body) {}
            });
            window.open(url);
        },
        loadUser: function loadUser() {
            var _this15 = this;

            this.loading = true;
            var url = this.domaine + 'userCreate/user-list';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this15.users = response.body;
                    _this15.loading = false;
                }
            });
        },
        loadFournisseurConnecte: function loadFournisseurConnecte() {
            var _this16 = this;

            this.loading = true;
            var url = this.domaine + 'fournisseur/' + this.user.id + '/connecte';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this16.listFournConnect = response.body.fournisseur;
                    _this16.statAllFour = response.body.stats;
                    _this16.statAllFactureFour = response.body.statsFact;
                    _this16.nbrComAll = response.body.nbrCom;
                    _this16.nbrFactAll = response.body.nbrFact;
                    _this16.nbrLivrAll = response.body.nbrLivr;
                    _this16.depenseAll = response.body.coutTotal;
                    _this16.loading = false;
                }
            });
        },
        loadCaisseProjet: function loadCaisseProjet() {
            var _this17 = this;

            if (this.projetS !== '') {
                this.loading = true;
                var url = this.domaine + 'caisse/project/' + this.projetS;
                this.$http.get(url).then(function (response) {
                    if (response.body) {
                        _this17.loading = false;
                        _this17.selectCaisse = response.body.caisse.id;
                        _this17.disabledSelectCaisse = false;
                    }
                }, function (error) {
                    _this17.loading = false;
                });
            } else {
                this.disabledSelectCaisse = false;
                this.loading = false;
            }
        },
        onchangeInfo: function onchangeInfo(projetS) {
            var info = this.listProjet.find(function (item) {
                return item.id == projetS;
            });
            this.dateDebut = info.dateDFormat;
            this.dateFin = info.dateFFormat;
            this.chefProjet = info.libelleChef;
        },
        loadChantier: function loadChantier() {
            var _this18 = this;

            this.loading = true;
            this.chantierS = '';
            this.travauxS = '';
            this.listChantier = [];
            if (this.projetS !== '') {
                var url = this.domaine + 'projet/' + this.projetS + '/index/chantier';
                this.$http.get(url).then(function (response) {
                    if (response.body) {
                        _this18.listChantier = response.body.chantier;
                        _this18.loading = false;
                        _this18.loadCaisseProjet();
                    }
                });
            } else {
                this.$message.error('Veuillez sélectionner un projet');
                this.loading = false;
            }
        },
        loadTravaux: function loadTravaux() {
            var _this19 = this;

            this.loading = true;
            this.travauxS = '';
            this.listTravaux = [];
            if (this.chantierS !== '') {
                var url = this.domaine + 'projet/' + this.chantierS + '/index/chantier/travaux';
                this.$http.get(url).then(function (response) {
                    if (response.body) {
                        _this19.listTravaux = response.body.travaux;
                        _this19.loading = false;
                    }
                });
            } else {
                this.$message.error('Veuillez sélectionner un chantier');
                this.loading = false;
            }
        },
        loadProduitListe: function loadProduitListe() {
            var _this20 = this;

            var url = this.domaine + 'product/product-list';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this20.listeProd = response.body;
                }
            }, function (response) {});
        },
        loadDemande: function loadDemande() {
            var _this21 = this;

            this.loading = true;
            this.listDemande = [];
            var url = this.domaine + 'entrepot/index/demande/devis/valide';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this21.listDemande = response.body.demande;
                    _this21.loading = false;
                }
            });
        },
        loadDevis: function loadDevis() {
            var _this22 = this;

            this.loading = true;
            var url = this.domaine + 'product/load-product-stock';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this22.listKeyword = response.body;
                    _this22.loading = false;
                }
            });
        },
        clearAll: function clearAll() {
            this.projetS = '';
            this.chantierS = '';
            this.travauxS = '';
            this.libTachePrest = '';
            this.selectContrat = null;
        },
        loadCaisse: function loadCaisse() {
            var _this23 = this;

            this.loading = true;
            var url = this.domaine + 'caisse/index';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this23.listCaisseComplete = response.body.caisse;
                    _this23.listCaisse = response.body.caisse;

                    _this23.loading = false;
                }
            });
        },
        loadDemandeur: function loadDemandeur(queryString, cb) {
            var _this24 = this;

            var url = this.domaine + 'maintenance/listes-demandeur';
            var formdata = new FormData();
            formdata.append('user', this.user.id);
            formdata.append('tag', queryString);
            this.$http.post(url, formdata).then(function (response) {
                if (response.body) {
                    var links = response.body;
                    var results = queryString ? links.filter(_this24.createFilter(queryString)) : links;
                    cb(results);
                }
            }, function (response) {});
        },
        loadFourn: function loadFourn() {
            var _this25 = this;

            this.loading = true;
            var url = '';
            if (this.droitAcces.fournisseur) {
                url = this.domaine + 'fournisseur/index';
            } else {
                url = this.domaine + 'fournisseur/index/' + this.user.id;
            }
            // let url = this.domaine + 'fournisseur/index'
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this25.listFour = response.body.fournisseur;
                    _this25.listFourFinal = response.body.fournisseur;
                    _this25.statAllFour = response.body.stats;

                    //on recupere uniquement les profession differents
                    var tableau = response.body.profession;
                    for (var i = 0; i < tableau.length; ++i) {
                        for (var j = i + 1; j < tableau.length; ++j) {
                            if (tableau[i].profession === tableau[j].profession) {
                                tableau[i].qte = tableau[i].qte + tableau[j].qte;
                                tableau.splice(j--, 1);
                            }
                        }
                    }
                    _this25.comboProfession = tableau;

                    _this25.comboFournisseur = response.body.fournisseur;
                    _this25.statAllFactureFour = response.body.statsFact;
                    _this25.nbrComAll = response.body.nbrCom;
                    _this25.nbrFactAll = response.body.nbrFact;
                    _this25.nbrLivrAll = response.body.nbrLivr;
                    _this25.depenseAll = response.body.coutTotal;
                    //this.statAllDepense()
                    //this.statAllFacture()
                    _this25.loading = false;
                }
            });

            // on affiche les differents champs de recherche

            this.etatAffichage = 1;
        },
        loadFournLimit: function loadFournLimit() {
            var _this26 = this;

            var url = '';
            this.loading = true;
            if (this.droitAcces.fournisseur) {
                url = this.domaine + 'fournisseur/indexRecent';
            } else {
                url = this.domaine + 'fournisseur/indexRecent/' + this.user.id;
            }

            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this26.listFour = response.body.fournisseur;
                    _this26.listFourFinal = response.body.fournisseur;
                    _this26.statAllFour = response.body.stats;
                    _this26.comboFournisseur = response.body.combofournisseur;
                    _this26.statAllFactureFour = response.body.statsFact;
                    _this26.nbrComAll = response.body.nbrCom;
                    _this26.nbrFactAll = response.body.nbrFact;
                    _this26.nbrLivrAll = response.body.nbrLivr;
                    _this26.depenseAll = response.body.coutTotal;
                    _this26.loading = false;
                }
            });
        },
        loadCommande: function loadCommande(ligne) {
            var _this27 = this;

            this.loading = true;
            // this.fournCourant = ligne
            //let url=""
            //if (this.droitAcces.index_commande) {
            var url = this.domaine + 'fournisseur/' + ligne.id + '/index/commande';
            // }
            //if(this.droitAcces.index_cmd_user_createur){
            //url = this.domaine + 'fournisseur/' + this.fournCourant.id + '/index/' + this.user.id + '/commande'
            //}
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this27.listCommande = response.body.commande;
                    _this27.totalCommande = response.body.totalCommande;
                    if (_this27.listCommande === undefined || _this27.listCommande.length == 0) {
                        _this27.disabledBtn = true;
                    } else {
                        _this27.disabledBtn = false;
                    }
                    _this27.loading = false;
                }
            });
        },
        loadCommandeRecent: function loadCommandeRecent(ligne) {
            var _this28 = this;

            this.loadingCL = true;
            // this.fournCourant = ligne
            //let url=""
            //if (this.droitAcces.index_commande) {
            var url = this.domaine + 'fournisseur/' + ligne + '/index/commande/recent';
            // }
            //if(this.droitAcces.index_cmd_user_createur){
            //url = this.domaine + 'fournisseur/' + this.fournCourant.id + '/index/' + this.user.id + '/commande'
            //}
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this28.listCommande = response.body.commande;
                    _this28.totalCommande = response.body.totalCommande;
                    if (_this28.listCommande === undefined || _this28.listCommande.length == 0) {
                        _this28.disabledBtn = true;
                    } else {
                        _this28.disabledBtn = false;
                    }
                    _this28.loading = false;
                }
            });
        },
        loadLivraison: function loadLivraison(ligne) {
            var _this29 = this;

            this.loading = true;
            var url = "";
            if (this.droitAcces.index_livraison) {
                url = this.domaine + 'fournisseur/' + ligne.id + '/index/livraison';
            } else {
                url = this.domaine + 'fournisseur/' + ligne.id + '/index/' + this.user.id + '/livraison';
            }

            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this29.listLivraison = response.body.livraison;
                    if (_this29.listLivraison === undefined || _this29.listLivraison.length == 0) {
                        _this29.disabledBtnL = true;
                    } else {
                        _this29.disabledBtnL = false;
                    }
                    _this29.loading = false;
                }
            });
        },
        loadLivraisonRecent: function loadLivraisonRecent(ligne) {
            var _this30 = this;

            this.loading = true;
            var url = "";
            if (this.droitAcces.index_livraison) {
                url = this.domaine + 'fournisseur/' + ligne + '/index/livraison/recent';
            } else {
                url = this.domaine + 'fournisseur/' + ligne + '/index/' + this.user.id + '/livraison/recent';
            }

            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this30.listLivraison = response.body.livraison;
                    if (_this30.listLivraison === undefined || _this30.listLivraison.length == 0) {
                        _this30.disabledBtnL = true;
                    } else {
                        _this30.disabledBtnL = false;
                    }
                    _this30.loading = false;
                }
            });
        },
        loadFacture: function loadFacture(ligne) {
            var _this31 = this;

            this.loading = true;
            var url = this.domaine + 'fournisseur/' + ligne.id + '/index/facture';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this31.listFacture = response.body.facture;
                    _this31.totalFacture = response.body.totalFacture;
                    if (_this31.listFacture === undefined || _this31.listFacture.length == 0) {
                        _this31.disabledBtnF = true;
                    } else {
                        _this31.disabledBtnF = false;
                    }
                    _this31.loading = false;
                }
            });
        },
        loadFactureRecent: function loadFactureRecent(ligne) {
            var _this32 = this;

            this.loading = true;

            var url = this.domaine + 'fournisseur/' + ligne + '/index/facture/recent';

            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this32.listFacture = response.body.facture;
                    _this32.totalFacture = response.body.totalFacture;
                    if (_this32.listFacture === undefined || _this32.listFacture.length == 0) {
                        _this32.disabledBtnF = true;
                    } else {
                        _this32.disabledBtnF = false;
                    }
                    _this32.loading = false;
                }
            });
        },
        loadMaintenance: function loadMaintenance(ligne) {
            var _this33 = this;

            this.loading = true;
            var url = "";
            if (this.droitAcces.index_maintenance) {
                url = this.domaine + 'fournisseur/' + ligne.id + '/index/maintenance';
            }
            if (this.droitAcces.index_maintenance_user) {
                url = this.domaine + 'fournisseur/' + ligne.id + '/index/' + this.user.id + '/maintenance';
            }

            this.loading = true;
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this33.loading = false;
                    _this33.listMaintenance = response.body.maintenance;
                    if (_this33.listMaintenance === undefined || _this33.listMaintenance.length == 0) {
                        _this33.disabledBtnM = true;
                    } else {
                        _this33.disabledBtnM = false;
                    }
                    _this33.loading = false;
                }
            });
        },
        loadMaintenanceRecent: function loadMaintenanceRecent(ligne) {
            var _this34 = this;

            this.loading = true;
            var url = "";
            if (this.droitAcces.index_maintenance) {
                url = this.domaine + 'fournisseur/' + ligne.id + '/index/maintenance/recent';
            }
            if (this.droitAcces.index_maintenance_user) {
                url = this.domaine + 'fournisseur/' + ligne.id + '/index/' + this.user.id + '/maintenance/recent';
            }

            this.loading = true;
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this34.loading = false;
                    _this34.listMaintenance = response.body.maintenance;
                    if (_this34.listMaintenance === undefined || _this34.listMaintenance.length == 0) {
                        _this34.disabledBtnM = true;
                    } else {
                        _this34.disabledBtnM = false;
                    }
                    _this34.loading = false;
                }
            });
        },
        loadProduitFoun: function loadProduitFoun(ligne) {
            var _this35 = this;

            this.loading = true;
            var url = "";
            if (this.droitAcces.index_produit_fourn) {
                url = this.domaine + 'fournisseur/' + ligne.id + '/index/produit';
            } else {
                url = this.domaine + 'fournisseur/' + ligne.id + '/index/' + this.user.id + '/produit';
            }

            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this35.listProduit = response.body.produit;
                    _this35.loading = false;
                }
            });
        },
        loadProduitFounRecent: function loadProduitFounRecent(ligne) {
            var _this36 = this;

            this.loading = true;
            var url = "";
            if (this.droitAcces.index_produit_fourn) {
                url = this.domaine + 'fournisseur/' + ligne.id + '/index/produit/recent';
            } else {
                url = this.domaine + 'fournisseur/' + ligne.id + '/index/' + this.user.id + '/produit/recent';
            }
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this36.listProduit = response.body.produit;
                    _this36.listProduiFinal = response.body.produitFinal;
                    _this36.loading = false;
                }
            });
        },
        showFourn: function showFourn(ligne) {
            var _this37 = this;

            this.fourSelect = ligne;
            this.loading = true;
            this.showFactureStatFour = true;
            this.dialogShow = true;
            this.fournCourant = ligne;
            var url = this.domaine + 'fournisseur/' + ligne.id + '/show';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this37.detailFour = response.body.fournisseur;
                    _this37.statFourn = response.body.stats;
                    _this37.statsFactureFourn = response.body.statsFact;
                    _this37.nbrComFourn = response.body.nbrCom;
                    _this37.nbrFactFourn = response.body.nbrFact;
                    _this37.nbrLivrFourn = response.body.nbrLivr;
                    _this37.depenseFourn = response.body.coutTotal;
                    _this37.loading = false;
                }
            });
        },
        showLivraison: function showLivraison(ligne) {
            var _this38 = this;

            // this.loading = true
            this.dialogShowLivraison = true;
            this.livraisonCourant = ligne;
            var url = this.domaine + 'fournisseur/' + this.livraisonCourant.id + '/show/livraison';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this38.detailLivraison = response.body.livraison;
                    if (_this38.detailLivraison[0].export) {
                        _this38.showBoat = true;
                    }

                    if (_this38.detailLivraison[0].conteneurs.length > 0) {
                        _this38.showConteneurs = true;
                    }
                }
            });
        },
        showFacture: function showFacture(ligne) {
            var _this39 = this;

            this.loading = true;

            this.dialogShowFacture = true;
            this.factureCourant = ligne;
            var totalHT = 0;
            var totalTVA = 0;
            var totalRemise = 0;
            for (var option in this.factureCourant.option) {
                var item = this.factureCourant.option[option];

                var tmpTotalHTSRem = parseFloat(item.prix * item.qte);
                var mntRemise = 0;
                var remise = parseFloat(item.remise);
                if (remise > 0) {
                    mntRemise = tmpTotalHTSRem * remise / 100;
                }
                var tmpTotalHT = tmpTotalHTSRem - mntRemise;
                var tva = parseFloat(item.tva);
                var tmpTotalTVA = tmpTotalHT * (tva / 100);

                totalTVA += tmpTotalTVA;
                totalHT += tmpTotalHT;
                totalRemise += mntRemise;
            }
            this.totalComHT = new Intl.NumberFormat().format(totalHT);
            this.totalComTVA = new Intl.NumberFormat().format(totalTVA);
            this.totalComRemise = new Intl.NumberFormat('fr-Fr').format(totalRemise);
            var url = this.domaine + 'fournisseur/' + this.factureCourant.idFact + '/show/facture';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this39.detailFacture = response.body.facture;

                    _this39.loading = false;
                }
            });
        },
        refaireCommande: function refaireCommande() {
            var _this40 = this;

            this.loading = true;
            var url = this.domaine + 'fournisseur/' + this.commReactiv + '/' + this.user.id + '/refaire/commande';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this40.$notify({
                        title: "ENREGISTREMENT REUSSI",
                        message: "Commmande réinitialisé avec succès.",
                        type: "success",
                        position: "top-center"
                    });
                    // this.detailCommande = response.body.commande
                    _this40.loadCommandeRecent(_this40.fourSelect.id);
                    _this40.loadFactureRecent(_this40.fourSelect.id);
                    _this40.loadLivraisonRecent(_this40.fourSelect.id);
                    _this40.loading = false;
                }
            });
        },
        showCommande: function showCommande(ligne) {
            var _this41 = this;

            this.loading = true;

            this.dialogShowCommande = true;
            this.commCourant = ligne;

            var totalHT = 0;
            var totalTVA = 0;
            var totalRemise = 0;

            for (var option in this.commCourant.option) {
                var item = this.commCourant.option[option];
                var tmpTotalHTSRem = parseInt(item.prix * item.qte, 10);
                var mntRemise = 0;
                var remise = parseInt(item.remise, 10);
                if (remise > 0) {
                    mntRemise = tmpTotalHTSRem * remise / 100;
                }

                var tmpTotalHT = tmpTotalHTSRem - mntRemise;
                var tva = parseInt(item.tva, 10);
                var tmpTotalTVA = tmpTotalHT * (tva / 100);

                totalTVA += tmpTotalTVA;
                totalHT += tmpTotalHT;
                totalRemise += mntRemise;
            }

            this.totalComHT = new Intl.NumberFormat('fr-Fr').format(totalHT);
            this.totalComTVA = new Intl.NumberFormat('fr-Fr').format(totalTVA);
            this.totalComRemise = new Intl.NumberFormat('fr-Fr').format(totalRemise);
            var url = this.domaine + 'fournisseur/' + this.commCourant.id + '/show/commande';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this41.detailCommande = response.body.commande;

                    _this41.optionLivr = _this41.detailCommande.optionLivr;
                    _this41.loading = false;
                }
            });
        },
        showMaintenance: function showMaintenance(ligne) {
            var _this42 = this;

            this.loading = true;
            this.dialogShowMaintenance = true;
            this.maintenanceCourant = ligne;
            var url = this.domaine + 'fournisseur/' + this.maintenanceCourant.id + '/show/maintenance';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this42.detailMaintenance = response.body.maintenance;
                    _this42.longDevis = _this42.detailMaintenance.devis.length;
                    _this42.loading = false;
                }
            });
        },
        newFourn: function newFourn() {
            this.dialogEdit = false;
            this.loginUser = '';
            this.nom = '';
            this.pren = '';
            this.dateNais = null;
            this.lieuNais = '';
            this.selectNaturePiece = null;
            this.numPiece = '';
            this.dateDeliv = null;
            this.dateExpi = null;
            this.contact = '';
            this.service = '';
            this.profession = '';
            this.domicile = '';
            this.nationalite = '';
            this.formJuridique = '';
            this.registreComm = '';
            this.siege = '';
            this.telBureau = '';
            this.representant = '';
            this.metier = '';
            this.selectType = null;
            this.selectCivilite = null;
        },
        addListArticleConteneur: function addListArticleConteneur(item) {
            this.tableArticleConteneur.push({
                designation: item.designation,
                code: item.code,
                tourtes: item.tourtes,

                qte: item.qte,
                poidsBrute: item.poidsBrute,
                metrage: item.metrage,
                poidsNet: item.poidsNet,
                tare: item.tare
            });
            this.oui = this.tableArticleConteneur;
            this.tableEnsemble.infoArticle = this.oui;
            this.formArticle = {};
        },
        filtrerMetier: function filtrerMetier() {
            //this.oldListTravaux = this.listeTrx;
            var idMetier = this.chantierS;
            this.listFour = this.listFour.filter(function (item) {
                return item.idmetier == idMetier;
            });
        },
        filtrerProfession: function filtrerProfession() {
            //this.oldListTravaux = this.listeTrx;
            var idProfession = this.projetS;
            this.listFour = this.listFour.filter(function (item) {
                return item.idprofession == idProfession;
            });
        },
        filtrerFournisseur: function filtrerFournisseur() {
            //this.oldListTravaux = this.listeTrx;
            var idFournisseur = this.fourniS;
            this.listFour = this.listFour.filter(function (item) {
                return item.id == idFournisseur;
            });
        },
        filtrerTypeTarification: function filtrerTypeTarification() {
            var idType = this.prodSelct;
            var tab = this.listProduit;
            if (idType == null || idType == "undefined" || idType == "") {
                this.listProduit = tab;
                return;
            }

            var libele = this.typeProd.find(function (item) {
                return item.id == idType;
            });

            this.listProduit = tab.filter(function (item) {
                return item.type == libele.value;
            });
            this.comboProduit = this.listProduit;
        },
        filtrerTarification: function filtrerTarification() {
            var idProduit = this.produiS;
            if (idProduit == null || idProduit == "undefined" || idProduit == "") {
                this.filtrerTypeTarification();
                return;
            }
            var tab = this.listProduit;
            this.listProduit = tab.filter(function (item) {
                return item.id == idProduit;
            });
        },
        clearSelect1: function clearSelect1() {
            //this.listeTrx = this.oldListTravaux;
            this.chantierS = '';
            this.listFour = this.listFourFinal;

            // this.listeChantier.splice(0)
        },
        clearSelect2: function clearSelect2() {
            //this.listeTrx = this.oldListTravaux;
            this.projetS = '';
            this.listFour = this.listFourFinal;
            // this.listeChantier.splice(0)
        },
        clearSelect3: function clearSelect3() {
            //this.listeTrx = this.oldListTravaux;
            this.fourniS = '';
            this.listFour = this.listFourFinal;
            // this.listeChantier.splice(0)
        },
        clearSelect4: function clearSelect4() {
            //this.listeTrx = this.oldListTravaux;
            this.produiS = '';
            this.listProduit = this.listProduiFinal;
            // this.listeChantier.splice(0)
        },
        showDetailsArticle: function showDetailsArticle(ligne) {

            // this.loading = true
            this.dialogShowArticle = true;
            // this.livraisonCourant = ligne
            // this.tableArticleConteneur.getItem({
            //     designation : item.designation,
            //     code : item.code,
            //     tourtes : item.tourtes,
            //     tc : item.tc,
            //     qte: item.qte,
            //     poidsBrute : item.poidsBrute,
            //     metrage : item.metrage,
            //     poidsNet : item.poidsNet,
            //     Tare : item.Tare,
            // })

            // this.tableArticleConteneurAffiche = item

            // let url = this.domaine + 'fournisseur/' + this.livraisonCourant.id + '/show/livraison'
            // this.$http.get(url).then(response => {
            //     if (response.body) {
            //         this.detailLivraison = response.body.livraison
            //         // this.loading = false
            //     }
            // })
        },
        addListConteneur: function addListConteneur() {
            this.loading = true;

            var articles = this.tableArticleConteneur.slice();
            var metrageTotal = 0;
            var poidsNetTotal = 0;
            var poidsBruteTotal = 0;
            var tourtesTotal = 0;
            var tareTotal = 0;

            articles.forEach(function (element) {
                metrageTotal += element.metrage;
                poidsNetTotal += element.poidsNet;
                poidsBruteTotal += element.poidsBrute;
                tourtesTotal += element.tourtes;
                tareTotal += element.Tare;
            });
            this.formConteneur.metrageTotal = metrageTotal;
            this.formConteneur.poidsNetTotal = poidsNetTotal;
            this.formConteneur.poidsBruteTotal = poidsBruteTotal;
            this.formConteneur.tourtesTotal = tourtesTotal;
            this.formConteneur.tareTotal = tareTotal;

            this.tableConteneur.push({
                conteneur: this.formConteneur,
                articles: this.tableArticleConteneur.slice()
            });

            //vider le formualire info container et liste article
            this.formConteneur = {};
            this.tableArticleConteneur.splice(0);
            this.loading = false;
        },
        newArticleConte: function newArticleConte(ligne) {
            this.loading = false;
            this.dialogArticlConteneur = true;
            this.code = '';
            this.designation = '';
            this.qte = '';

            this.metrage = '';
            this.poidsBrute = '';
            this.poidsNet = '';
            this.tare = '';
            this.tourtes = '';
        },
        newCommande: function newCommande(ligne) {
            this.loading = false;
            this.dialogComm = true;
            this.dialogEdit = false;
            this.libelle = '';
            this.projetS = '';
            this.chantierS = '';
            this.travauxS = '';
            this.listTravaux = [];
            this.listChantier = [];
            this.selectUsers = [];
            this.dateLivr = null;
            this.optionCommande = [{ key: 1, produit: '', prix: 0, qte: 1, remise: 0, tva: 0, total: 0, id: '' }];
            this.totalComTTC = 0;
            this.totComLigneTTCFormat = 0;
            this.totalComHT = 0;
            this.totalComHTSR = 0;
            this.totalComRemise = 0;
            this.totalComTVA = 0;
            this.selectTypeCom = '';
            this.selectDemande = '';
            this.commCourant = [];
        },
        newAppro: function newAppro(ligne) {
            this.loading = false;
            this.livraisonCourant = ligne;
            this.dialogAppro = true;
            this.optionEntrepot = this.livraisonCourant.entrepot;
            this.optionAppro = this.livraisonCourant.appro;
            this.optionQteRecu = this.livraisonCourant.qteRecue;
        },
        newLivraison: function newLivraison(ligne) {

            this.loading = false;
            this.factureCourant = ligne;
            this.dialogLivraison = true;
            this.tableConteneur.splice(0);
            this.optionLivraison = this.factureCourant.livre;
            this.selectLivraison = '';
            this.selectTypeLivraison = '';
            this.provenanceConteneur = '';
            this.recepetionConteneur = '';
            this.numCpteLivraison = '';
            this.numVoyage = '';
            this.image2 = "";
        },
        newFacture: function newFacture(ligne) {
            this.disableCaisse = false;
            this.loading = false;
            this.commCourant = ligne;
            this.dialogFacture = true;
            this.dialogEdit = false;
            this.selectContrat = null;
            this.datePaie = "";
            this.selectCaisse = ligne.idCaisse;

            this.libelle = ligne.libelle;
            this.optionCommande = this.commCourant.option;
            this.totalComTTC = 0;
            this.totComLigneTTCFormat = 0;
            this.totalComHT = 0;
            this.totalComHTSR = 0;
            this.totalComRemise = 0;
            this.totalComTVA = 0;
            this.selectModalite = ligne.modalite;
            this.avance = ligne.avance;
            this.image1 = "";
            this.calculTotalComm();
        },
        newFactureFact: function newFactureFact(ligne) {
            this.loading = false;
            this.dialogEdit = false;
            this.disabledSelectCaisse = false;
            this.dialogFactureFact = true;
            this.logoFacture = "/static/img-doc.png", this.libelle = '', this.avance = 0;
            this.totalComHT = 0;
            this.totalComTVA = 0;
            this.totalComRemise = 0;
            this.selectModalite = "";
            this.selectContrat = null;
            this.selectCaisse = "";
            this.datePaie = "";
            this.optionCommande = [{ key: 1, produit: '', prix: 0, qte: 1, remise: 0, tva: 0, total: 0, id: '' }];
        },
        newDevis: function newDevis(ligne) {
            this.loading = false;
            this.maintenanceCourant = ligne;
            this.dialogDevis = true;
            this.dialogEdit = false;
            this.optionDevis = this.maintenanceCourant.devis;
            this.calculTotalDevis();
        },
        newTarif: function newTarif(ligne) {
            this.loading = false;
            this.tarifCourant.id = '';
            this.dialogTarif = true;
            this.dialogEdit = false;
            this.selectProduit = '';
            this.prixAchat = 0;
            this.selectIdProduit = '';
            this.tableTarification = [];
            // this.loadTypeRessource()
        },
        editTarif: function editTarif(ligne) {
            this.loading = false;
            this.tarifCourant.id = ligne.id;
            this.dialogTarif = true;
            this.dialogEdit = true;
            this.selectProduit = ligne.libelle;
            this.selectIdProduit = ligne.idproduit;
            this.prixAchat = ligne.prixAchat;
            this.valeurUniteMateriel = ligne.unite;
            this.tableTarification = ligne;
        },
        showTarif: function showTarif(ligne) {
            this.dialogShowTarif = true;
            this.tarifCourant = ligne;
        },
        deleteTarif: function deleteTarif(ligne) {
            this.dialogSupTarif = true;
            this.tarifCourant.id = ligne.id;
            this.selectProduit = ligne.libelle;
        },
        editFourn: function editFourn(ligne) {
            this.loading = false;
            if (ligne.type === 1) {
                this.personneType = false;
            } else {
                this.personneType = true;
            }
            this.typeF = ligne.type;
            this.dialogEdit = true;
            //this.dialogAjout = true
            this.showFour = true;
            this.fournCourant = ligne;
            this.loginUser = ligne.email;
            this.nom = ligne.nom;
            this.pren = ligne.pren;
            this.dateNais = ligne.dateNais;
            this.lieuNais = ligne.lieuNais;
            this.selectNaturePiece = ligne.naturePiece;
            this.numPiece = ligne.numPiece;
            this.dateDeliv = ligne.dateDeliv;
            this.dateExpi = ligne.dateExpi;
            this.contact = ligne.contact;
            this.service = ligne.service;
            this.profession = ligne.profession;
            this.domicile = ligne.domicile;
            this.nationalite = ligne.nationalite;
            this.formJuridique = ligne.formJuridique;
            this.registreComm = ligne.registreComm;
            this.siege = ligne.siege;
            this.telBureau = ligne.contact;
            this.representant = ligne.representant;
            this.metier = ligne.metier;
            this.selectType = parseInt(ligne.typeFour);
            this.selectCivilite = ligne.civilite;
        },
        editerFacture: function editerFacture() {

            this.loading = false;
            if (this.factureCourant.idContrat != null) {
                this.$message({
                    message: "Impossible de modifier une facture contrat,Si cette facture comporte des erreurs elle doit etre rejetée par le DG",
                    type: 'warning',
                    duration: 5000
                });
                return;
            }
            this.factureCourant = this.detailFacture;

            this.dialogFacture = true;
            this.dialogEdit = true;
            this.libelle = this.factureCourant.libelle;
            this.dateLivr = this.factureCourant.dateLivr;
            this.selectModalite = this.factureCourant.modalite;
            this.selectCaisse = this.factureCourant.caisse;
            this.datePaie = this.factureCourant.datePaie;
            this.optionCommande = this.factureCourant.option;
            this.calculTotalComm();
        },
        editFacture: function editFacture(ligne) {
            this.loading = false;
            this.commCourant = ligne;
            if (ligne.length != 0) //commande courante
                {
                    this.factureCourant = ligne;
                }
            //this.factureCourant = ligne

            this.dialogFacture = true;
            this.dialogEdit = true;
            this.libelle = this.factureCourant.libelle;
            this.dateLivr = this.factureCourant.dateLivr;
            this.selectModalite = this.factureCourant.modalite;
            this.selectCaisse = this.factureCourant.caisse;
            this.datePaie = this.factureCourant.datePaie;
            this.optionCommande = this.factureCourant.option;
            this.calculTotalComm();
        },
        editCommande: function editCommande(ligne) {
            this.loading = true;
            this.commCourant = ligne;
            this.dialogComm = true;
            this.dialogEdit = true;
            this.libelle = this.commCourant.libelle;
            this.projetS = this.commCourant.idProj;
            this.listChantier = this.commCourant.listChantier;
            this.chantierS = this.commCourant.idChan;
            this.listTravaux = this.commCourant.listTravaux;
            this.travauxS = this.commCourant.idTrav;
            this.dateLivr = this.commCourant.dateLivr;
            this.selectUsers = this.commCourant.user;

            this.optionCommande = this.commCourant.option;
            this.selectTypeCom = this.commCourant.type;
            this.selectDemande = this.commCourant.idDmd;
            this.calculTotalComm();
            this.loading = false;
        },
        submitTarif: function submitTarif() {
            var _this43 = this;

            this.loading = true;
            var form = document.getElementById("formTarif");
            var data = new FormData(form);
            var url = "";
            if (!!this.tarifCourant.id) {
                url = this.domaine + "fournisseur/new/" + this.tarifCourant.id + "/tarif";
            } else {
                url = this.domaine + "fournisseur/tarif/new";
            }
            if (this.selectProduit != '' && this.prixAchat > 0) {
                data.append('fournisseur', this.fournCourant.id);
                data.append('produit', this.selectProduit);
                data.append('selectIdProduit', this.selectIdProduit);
                data.append('id', this.tarifCourant.id);
                data.append('idUser', this.user.id);
                this.tableTarification = [];
                data.append("tarif", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.tableTarification));
                this.$http.post(url, data).then(function (response) {
                    if (response.body) {
                        var verif = response.body;
                        if (verif.code === 1) {
                            _this43.$notify({
                                title: 'ENREGISTREMENT REUSSI',
                                message: 'Tarification enregistré avec succès.',
                                type: 'success',
                                position: 'top-center'
                            });
                        }
                        _this43.loadProduitFounRecent(_this43.fournCourant);
                        _this43.dialogTarif = false;
                        _this43.dialogConfirm = false;
                        _this43.loading = false;
                    } else {
                        _this43.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this43.loading = false;
                        _this43.dialogAppro = false;
                    }
                }, function (response) {
                    _this43.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                    _this43.loading = false;
                });
            } else if (this.tableTarification.length > 0) {
                data.append('fournisseur', this.fournCourant.id);
                data.append('id', this.tarifCourant.id);
                data.append('idUser', this.user.id);
                data.append("typeProduit", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.tableTarification));
                this.$http.post(url, data).then(function (response) {
                    if (response.body) {
                        var verif = response.body;
                        if (verif.code === 1) {
                            _this43.$notify({
                                title: 'ENREGISTREMENT REUSSI',
                                message: 'Tarification enregistré avec succès.',
                                type: 'success',
                                position: 'top-center'
                            });
                        }
                        _this43.loadProduitFounRecent(_this43.fournCourant);
                        _this43.dialogTarif = false;
                        _this43.dialogConfirm = false;
                        _this43.loading = false;
                    } else {
                        _this43.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this43.loading = false;
                        _this43.dialogAppro = false;
                    }
                }, function (response) {
                    _this43.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                    _this43.loading = false;
                });
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "La tarification n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        submitAppro: function submitAppro() {
            var _this44 = this;

            this.loading = true;
            if (this.$refs.formAppro.validate()) {
                var form = document.getElementById('formAppro');
                var formdata = new FormData(form);
                var url = this.domaine + 'fournisseur/new/approvisionnement';
                formdata.append('idLivr', this.livraisonCourant.id);
                formdata.append('idUser', this.user.id);
                var ligneEntre = null;
                var reste = null;

                for (var prop in this.optionQteRecu) {
                    ligneEntre = this.optionQteRecu[prop];

                    //verifie si la quantite saisi est null on passe au prochain produit
                    if (ligneEntre.qte == 0) {
                        continue;
                    }

                    var valide = null;
                    for (var item in this.optionEntrepot) {
                        if (this.optionEntrepot[item].id == ligneEntre.idEntreprot) {
                            valide = this.optionEntrepot[item].valide;
                        }
                    }

                    formdata.append('recu[entrepot][]', ligneEntre.idEntreprot);
                    formdata.append('recu[ligne][]', ligneEntre.idLivre);
                    formdata.append('recu[qte][]', ligneEntre.qte); //quantite saisie
                    formdata.append('recu[valide][]', valide);
                }

                for (var _item in this.optionAppro) {
                    //reste += this.optionAppro[item].qteL
                    reste += this.optionAppro[_item].qteR;
                }
                if (reste !== 0) {
                    this.loading = false;
                    this.$notify({
                        title: "ATTENTION",
                        message: "Vous devez obligatoirement repartir toutes la livraison.",
                        type: 'warning',
                        position: 'top-center'
                    });
                } else {
                    this.$http.post(url, formdata).then(function (response) {
                        _this44.loading = false;
                        if (response.body) {
                            var verif = response.body;
                            if (verif.code === 1) {
                                _this44.$notify({
                                    title: 'ENREGISTREMENT REUSSI',
                                    message: 'Approvisionnement enregistré avec succès.',
                                    type: 'success',
                                    position: 'top-center'
                                });
                            }

                            _this44.loadLivraisonRecent(_this44.fourSelect.id);
                            _this44.loadFactureRecent(_this44.fourSelect.id);
                            _this44.loadCommande(_this44.fourSelect);
                            // this.showFourn(this.fourSelect.id)
                            _this44.dialogAppro = false;
                            _this44.loading = false;
                        } else {
                            _this44.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                            _this44.loading = false;
                            _this44.dialogAppro = false;
                        }
                    }, function (response) {
                        _this44.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this44.loading = false;
                    });
                }
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "La livraison n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        deleteTarification: function deleteTarification() {
            var _this45 = this;

            //  this.loading = true
            var url = "";
            url = this.domaine + "fournisseur/delete/" + this.tarifCourant.id + "/tarif";
            this.$http.get(url).then(function (response) {
                if (response.body.code == 2) {
                    _this45.dialogSupTarif = false;
                    _this45.loading = false;
                    _this45.$notify({
                        title: 'SUPPRESSION REUSSI',
                        message: 'Tarification supprimé avec succès.',
                        type: 'success',
                        position: 'top-center'
                    });
                    _this45.loadProduitFounRecent(_this45.fournCourant);
                } else {
                    _this45.loading = false;
                    _this45.$message.error('Impossible de supprimer la tarification de ce produit car il est déja utilisé dans une commande');
                }
            }, function (error) {
                // this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                _this45.$message.error('Impossible de supprimer la tarification de ce produit, il est lié à une commande.');
                _this45.loading = false;
            });
        },
        deleteRow: function deleteRow(index, rows) {
            rows.splice(index, 1);
        },
        submitLivraison: function submitLivraison() {
            var _this46 = this;

            this.loading = true;
            if (this.$refs.form.validate() && this.selectLivraison != "" && this.selectTypeLivraison != "") {
                var form = document.getElementById('formLivraison');
                var formdata = new FormData(form);
                var url = this.domaine + 'fournisseur/new/livraison';
                formdata.append('idFact', this.factureCourant.idFact);
                formdata.append('etat', this.selectLivraison);
                formdata.append('typeLivraison', this.selectTypeLivraison);
                formdata.append('idUser', this.user.id);

                if (this.selectTypeLivraison == 2) {
                    formdata.append('tableConteneurs', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.tableConteneur));
                }

                var ligne = null;
                for (var prop in this.optionLivraison) {
                    ligne = this.optionLivraison[prop];
                    formdata.append('options[id][]', ligne.id);
                    formdata.append('options[produit][]', ligne.produit);
                    formdata.append('options[qte][]', ligne.qte);
                    formdata.append('options[qteL][]', ligne.qteL);
                }
                this.$http.post(url, formdata).then(function (response) {
                    _this46.dialogLivraison = false;
                    _this46.loadLivraisonRecent(_this46.fourSelect.id);
                    _this46.loadFactureRecent(_this46.fourSelect.id);
                    _this46.loadCommande(_this46.fourSelect);
                    _this46.loading = false;
                    _this46.$notify({
                        title: 'ENREGISTREMENT REUSSI',
                        message: 'Livraison enregistré avec succès.',
                        type: 'success',
                        position: 'top-center'
                    });
                    if (response.body) {
                        var verif = response.body;
                        if (verif.code === 1) {} else if (verif.code === 2) {
                            _this46.$message.error(verif.message);
                            _this46.loading = false;
                            _this46.dialogLivraison = false;
                        } else if (verif.code === 3) {
                            _this46.$message.error(verif.message);
                            _this46.loading = false;
                            _this46.dialogLivraison = false;
                        }
                        _this46.loading = false;
                    } else {
                        _this46.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this46.loading = false;
                        _this46.dialogLivraison = false;
                    }
                }, function (response) {
                    _this46.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                    _this46.loading = false;
                });
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "La livraison n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        deleteTache: function deleteTache(position, rows) {
            rows.splice(position, 1);
        },
        addListTaches: function addListTaches(produit, prix) {
            var libelle = this.listeProd.filter(function (item) {
                if (item.id == produit) return item.value;
            });

            this.tableTarification.push({
                idprod: produit,
                codeGestion: this.codegestion,
                unite: this.valeurUniteMateriel,
                produit: libelle[0]['value'],
                prix: prix
            });
            this.dialogTarif = true;
            this.selectProduit = '';
            this.prixAchat = '';
            this.codegestion = '';
            this.valeurUniteMateriel = '';
        },
        submitValidFacture: function submitValidFacture() {
            var _this47 = this;

            //verification montant facture contrat
            if (this.selectContrat != "undefined" && this.selectContrat != null) {
                if (this.totComLigneTTCFormat > this.mntRestantContrat) {
                    this.$message.error("Le montant TTC definit est supérieur au montant restant " + this.mntRestantContrat);
                    return;
                }
            }

            this.loading = true;
            if (this.$refs.form.validate()) {
                var form = document.getElementById('formValidFacture');
                var formdata = new FormData(form);
                var url = this.domaine + 'fournisseur/valider/facture';
                formdata.append('id', this.factureCourant.idFact);
                formdata.append('idUser', this.user.id);
                formdata.append('decision', this.selectDecisionFact);
                this.$http.post(url, formdata).then(function (response) {
                    if (response.body) {
                        var verif = response.body;
                        if (verif.code === 1) {
                            _this47.$notify({
                                title: 'VALIDATION REUSSI',
                                message: 'Facture validé avec succès.',
                                type: 'success',
                                position: 'top-center'
                            });
                            _this47.loading = false;
                        } else if (verif.code === 2) {
                            _this47.$message.error(verif.message);
                            _this47.loading = false;
                        }
                        _this47.loading = false;
                        _this47.loadFactureRecent(_this47.fourSelect.id);
                        _this47.loadCommandeRecent(_this47.fourSelect.id);
                        _this47.calculTotalComm();
                        _this47.dialogValiFacture = false;
                        _this47.showFourn(_this47.fournCourant);
                    } else {
                        _this47.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this47.loading = false;
                        _this47.dialogValiFacture = false;
                    }
                }, function (response) {
                    _this47.$message.error('Veuillez obligatoirement ajouté des lignes de commande');
                    _this47.loading = false;
                });
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "La facture n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        submitFacture: function submitFacture() {
            var _this48 = this;

            this.loading = true;
            if (this.$refs.form.validate() && this.selectModalite != "" && this.datePaie != "" && this.image1 != "/static/img-doc.png") {
                var etat = false;
                if (this.optionCommande.length > 0) {
                    this.optionCommande.forEach(function (item) {
                        if (item.produit != '' && item.prix > 0 && item.qte > 0) {
                            etat = true;
                        }
                    });
                }

                if (etat == true) {
                    var form = document.getElementById('formFacture');
                    var data = new FormData(form);

                    var url = '';
                    data.append('total', this.totalComTTC);
                    data.append('id', this.commCourant.id);
                    data.append('idUser', this.user.id);
                    data.append('modalite', this.selectModalite);
                    data.append('avance', this.avance);
                    // data.append('caisse', this.selectCaisse)
                    data.append('id', this.commCourant.id);
                    //on va enregister dabor la facture
                    url = this.domaine + "fournisseur/facture/new";

                    this.$http.post(url, data).then(function (response) {
                        if (response.body) {
                            var verif = response.body;

                            url = _this48.domaine + 'fournisseur/new/facture';

                            var nbData = 10;
                            var nbReq = 1;
                            var ligne = null;

                            var nbRest = void 0;
                            if (_this48.optionCommande.length > 10) {
                                nbData = 10;
                                nbReq = Math.round(_this48.optionCommande.length / nbData);
                                nbRest = _this48.optionCommande.length % nbData;
                                if (nbRest > 0) {
                                    nbReq += 1;
                                }
                            }

                            for (var i = 0; i < nbReq; i++) {
                                var initJ = i * nbData;
                                var finJ = (i + 1) * nbData;
                                var dataLot = [];
                                if (_this48.optionCommande.length > 0) {
                                    for (var j = initJ; j < finJ; j++) {
                                        if (_this48.optionCommande[j] == undefined) {
                                            break;
                                        }
                                        dataLot.push(_this48.optionCommande[j]);
                                    }
                                }
                                var _data = new FormData(form);

                                for (var prop in dataLot) {
                                    ligne = dataLot[prop];
                                    _data.append('options[id][]', ligne.id);
                                    _data.append('options[produit][]', ligne.produit);
                                    _data.append('options[libelle][]', ligne.libelle);
                                    _data.append('options[prix][]', ligne.prix);
                                    _data.append('options[qte][]', ligne.qte);
                                    _data.append('options[unite][]', ligne.unite);
                                    _data.append('options[tva][]', ligne.tva);
                                    _data.append('options[remise][]', ligne.remise != null ? ligne.remise : 0);
                                    _data.append('options[total][]', ligne.total);
                                }
                                _data.append("idFacture", verif.idFacture);

                                _data.append('total', _this48.totalComTTC);
                                _data.append('id', _this48.commCourant.id);
                                _data.append('idUser', _this48.user.id);
                                _data.append('modalite', _this48.selectModalite);
                                _data.append('avance', _this48.avance);
                                // data.append('caisse', this.selectCaisse)

                                _this48.loading = true;

                                _this48.$http.post(url, _data).then(function (response) {
                                    if (response.body) {
                                        var _verif = response.body;
                                        if (_verif.code === 1) {
                                            if (_this48.factureCourant.idFact) {
                                                _this48.$notify({
                                                    title: 'MODIFICATION REUSSI',
                                                    message: response.body.message,
                                                    type: 'success',
                                                    position: 'top-center'
                                                });
                                            } else {
                                                _this48.$notify({
                                                    title: 'ENREGISTREMENT REUSSI',
                                                    message: response.body.message,
                                                    type: 'success',
                                                    position: 'top-center'
                                                });
                                            }
                                        } else if (_verif.code === 2) {
                                            _this48.$message.error(_verif.message);
                                            _this48.loading = false;
                                        }
                                        _this48.loading = false;
                                        _this48.calculTotalComm();
                                        _this48.loadFactureRecent(_this48.fourSelect.id);
                                        _this48.loadCommandeRecent(_this48.fourSelect.id);
                                        // this.showFourn(this.fournCourant)
                                        _this48.dialogFacture = false;
                                        _this48.dialogShowCommande = false;
                                    } else {
                                        _this48.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                                        _this48.loading = false;
                                        _this48.dialogFacture = false;
                                        _this48.dialogShowCommande = false;
                                    }
                                }, function (error) {
                                    _this48.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                                    _this48.loading = false;
                                });
                            }
                        } else {
                            _this48.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                            _this48.loading = false;
                            _this48.dialogFacture = false;
                            _this48.dialogShowCommande = false;
                        }
                    }, function (error) {
                        _this48.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this48.loading = false;
                    });
                } else {
                    this.$notify({
                        title: "ATTENTION",
                        message: "Vous devez obligatoirement enregistré des lignes pour la facture et que ces lignes ont été correctements remplis.",
                        position: 'top-center',
                        type: 'warning'
                    });
                    this.loading = false;
                }
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "La facture n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        submitEditFacture: function submitEditFacture() {
            var _this49 = this;

            this.loading = true;
            if (this.$refs.form.validate() && this.selectModalite != "" && this.selectCaisse != "" && this.datePaie != "" && this.image1 != "/static/img-doc.png") {
                var etat = false;
                if (this.optionCommande.length > 0) {
                    this.optionCommande.forEach(function (item) {
                        if (item.produit != '' && item.prix > 0 && item.qte > 0) {
                            etat = true;
                        }
                    });
                }

                if (etat == true) {
                    var form = document.getElementById('formFacture');
                    var formdata = new FormData(form);

                    var url = this.domaine + 'fournisseur/' + this.factureCourant.idFact + '/edit/facture';

                    for (var prop in this.optionCommande) {
                        var ligne = this.optionCommande[prop];
                        formdata.append('options[id][]', ligne.id);
                        formdata.append('options[produit][]', ligne.produit);
                        formdata.append('options[libelle][]', ligne.libelle);
                        formdata.append('options[prix][]', ligne.prix);
                        formdata.append('options[qte][]', ligne.qte);
                        formdata.append('options[unite][]', ligne.unite);
                        formdata.append('options[tva][]', ligne.tva);
                        formdata.append('options[remise][]', ligne.remise != null ? ligne.remise : 0);
                        formdata.append('options[total][]', ligne.total);
                    }

                    formdata.append('total', this.totalComTTC);
                    formdata.append('id', this.commCourant.id);
                    formdata.append('idUser', this.user.id);
                    formdata.append('modalite', this.selectModalite);
                    formdata.append('avance', this.avance);
                    formdata.append('caisse', this.selectCaisse);
                    this.loading = true;
                    this.$http.post(url, formdata).then(function (response) {
                        _this49.dialogShowFacture = false;
                        if (response.body) {
                            var verif = response.body;
                            if (verif.code === 1) {
                                if (_this49.factureCourant.idFact) {
                                    _this49.$notify({
                                        title: 'MODIFICATION REUSSI',
                                        message: response.body.message,
                                        type: 'success',
                                        position: 'top-center'
                                    });
                                } else {
                                    _this49.$notify({
                                        title: 'ENREGISTREMENT REUSSI',
                                        message: response.body.message,
                                        type: 'success',
                                        position: 'top-center'
                                    });
                                }
                            } else if (verif.code === 2) {
                                _this49.$message.error(verif.message);
                                _this49.loading = false;
                            }
                            _this49.loading = false;
                            _this49.calculTotalComm();
                            _this49.loadFactureRecent(_this49.fourSelect.id);
                            _this49.loadCommandeRecent(_this49.fourSelect.id);
                            // this.showFourn(this.fournCourant)
                            _this49.dialogFacture = false;
                        } else {
                            _this49.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                            _this49.loading = false;
                            _this49.dialogFacture = false;
                        }
                    }, function (response) {
                        _this49.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this49.loading = false;
                    });
                } else {
                    this.$notify({
                        title: "ATTENTION",
                        message: "Vous devez obligatoirement enregistré des lignes pour la facture et que ces lignes ont été correctements remplis.",
                        position: 'top-center',
                        type: 'warning'
                    });
                    this.loading = false;
                }
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "La facture n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        submitFactureFact: function submitFactureFact() {
            var _this50 = this;

            // this.loading = true
            //Verfions si le montant a verser ne depasse pas le montant total restant de la facture
            if (this.selectContrat != null && this.optionCommande[0].prix > this.selectContrat.mntRestant) {
                this.loading = false;

                this.$message({
                    message: 'Attention, le montant à verser supérieur au montant restant',
                    type: 'warning'
                });
                return;
            }

            if (this.$refs.formFactureFact.validate()) {
                var etat = false;
                if (this.optionCommande.length > 0) {
                    this.optionCommande.forEach(function (item) {
                        if (item.produit != '' && item.prix > 0 && item.qte > 0) {
                            etat = true;
                        }
                    });
                }

                if (etat == true) {
                    var form = document.getElementById('formFactureFact');
                    var formdata = new FormData(form);
                    for (var prop in this.optionCommande) {
                        var ligne = this.optionCommande[prop];
                        formdata.append('options[id][]', ligne.id);
                        formdata.append('options[produit][]', ligne.produit);
                        formdata.append('options[prix][]', ligne.prix);
                        formdata.append('options[qte][]', ligne.qte);
                        formdata.append('options[unite][]', ligne.unite);
                        formdata.append('options[libelle][]', ligne.libelle);
                        formdata.append('options[tva][]', ligne.tva);
                        formdata.append('options[remise][]', ligne.remise != null ? ligne.remise : 0);
                        formdata.append('options[total][]', ligne.total);
                    }
                    formdata.append('total', this.totalComTTC);
                    formdata.append('idfourn', this.fournCourant.id);
                    formdata.append('modalite', this.selectModalite);
                    formdata.append('avance', this.avance);
                    formdata.append('caisse', this.selectCaisse);

                    formdata.append('contratId', this.selectContrat);
                    formdata.append('chantierId', this.chantierS);
                    formdata.append('travauxId', this.travauxS);
                    formdata.append('travaux', this.travauxS);
                    formdata.append('idtache', this.libTachePrest);
                    formdata.append('idUser', this.user.id);

                    var url = this.domaine + 'fournisseur/devis/fact';
                    this.$http.post(url, formdata).then(function (response) {
                        if (response.body) {
                            var verif = response.body;
                            if (verif.code === 1) {
                                _this50.$notify({
                                    title: 'ENREGISTREMENT REUSSI',
                                    message: response.body.message,
                                    type: 'success',
                                    position: 'top-center'
                                });
                                _this50.loadFactureRecent(_this50.fourSelect.id);
                                // this.showFourn(this.fournCourant)
                                _this50.dialogFactureFact = false;
                                _this50.loading = false;
                                _this50.clear();
                            } else if (verif.code === 2) {
                                _this50.$message.error(verif.message);
                                _this50.loading = false;
                            } else if (verif.code === 0) {
                                _this50.$message.error(verif.message);
                                _this50.loading = false;
                            }
                        } else {
                            _this50.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                            _this50.loading = false;
                            _this50.clear();
                        }
                    }, function (response) {
                        _this50.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this50.loading = false;
                    });
                } else {
                    this.$notify({
                        title: "ATTENTION",
                        message: "Vous devez obligatoirement enregistré des lignes pour la facture et que ces lignes ont été correctements remplis.",
                        position: 'top-center',
                        type: 'warning'
                    });
                    this.loading = false;
                }
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "La facture n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },

        //enregistrement des images
        onFileImageFacturePicked: function onFileImageFacturePicked(event) {
            var _this51 = this;

            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this51.logoFacture = fileReader.result;
            });

            fileReader.readAsDataURL(files[0]);
            this.logoFacture = files[0];
        },
        submitDevis: function submitDevis() {
            var _this52 = this;

            this.loading = true;
            if (this.$refs.formDevis.validate()) {
                var form = document.getElementById('formDevis');
                var formdata = new FormData(form);
                var ligne = null;
                var url = this.domaine + 'fournisseur/' + this.maintenanceCourant.id + '/new/devis';
                for (var prop in this.optionDevis) {
                    ligne = this.optionDevis[prop];
                    formdata.append('options[id][]', ligne.id);
                    formdata.append('options[produit][]', ligne.produit);
                    formdata.append('options[prix][]', ligne.cout);
                    formdata.append('options[qte][]', ligne.qte);
                    formdata.append('options[unite][]', ligne.unite);
                    formdata.append('options[tva][]', ligne.tva);
                }

                formdata.append('idUser', this.user.id);
                if (ligne !== null) {
                    this.$http.post(url, formdata).then(function (response) {
                        if (response.body) {
                            var verif = response.body;
                            if (verif.code === 1) {
                                _this52.$notify({
                                    title: 'ENREGISTREMENT REUSSI',
                                    message: 'Devis enregistré avec succès.',
                                    type: 'success',
                                    position: 'top-center'
                                });

                                _this52.loadFactureRecent(_this52.fourSelect.id);
                                // this.showFourn(this.fournCourant)
                                _this52.loadMaintenanceRecent(_this52.fourSelect.id);
                                _this52.dialogDevis = false;
                                _this52.loading = false;
                                _this52.clear();
                            } else if (verif.code === 0) {
                                _this52.$message.error(verif.message);
                                _this52.loading = false;
                            }
                        } else {
                            _this52.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                            _this52.loading = false;
                            _this52.clear();
                        }
                    }, function (response) {
                        _this52.$message.error('Veuillez obligatoirement ajouté des lignes de commande');
                        _this52.loading = false;
                    });
                } else {
                    this.$notify({
                        title: "ATTENTION",
                        message: "Vous devez obligatoirement enregistré des lignes pour la commande.",
                        position: 'top-center',
                        type: 'warning'
                    });
                    this.loading = false;
                }
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "La devis n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        displayMontant: function displayMontant() {
            this.loading = true;
            if (this.$refs.formComm.validate() && this.libelle != "" && this.dateLivr != "" && (this.travauxS != "" || this.selectDemande != '')) {
                this.calculTotalComm();
                this.dialogMontantCommande = true;
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "La commande n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        submitComm: function submitComm() {
            var _this53 = this;

            this.loading = true;
            this.disBtnAjtCom = true;
            this.dialogMontantCommande = false;
            this.dialogComm = false;
            if (this.$refs.formComm.validate() && this.libelle != "" && this.dateLivr != "" && (this.travauxS != "" || this.selectDemande != '')) {
                var etat = false;
                if (this.optionCommande.length > 0) {
                    this.optionCommande.forEach(function (item) {
                        if (item.produit != '' && item.prix > 0 && item.qte > 0) {
                            etat = true;
                        }
                    });
                }

                if (etat == true) {
                    var url = '';
                    var form = document.getElementById('formComm');
                    var formdata = new FormData(form);
                    if (this.commCourant.id) {
                        url = this.domaine + 'fournisseur/edit/commande';
                        formdata.append('id', this.commCourant.id);
                    } else {
                        url = this.domaine + 'fournisseur/new/commande';
                        // formdata.append('id', this.fournCourant.id)
                        formdata.append('id', this.fourSelect.id);
                    }
                    for (var prop in this.optionCommande) {
                        var ligne = this.optionCommande[prop];
                        formdata.append('options[id][]', ligne.id);
                        formdata.append('options[produit][]', ligne.produit);
                        formdata.append('options[prix][]', ligne.prix);
                        formdata.append('options[qte][]', ligne.qte);
                        formdata.append('options[unite][]', ligne.unite);
                        formdata.append('options[tva][]', ligne.tva);
                        formdata.append('options[remise][]', ligne.remise != null ? ligne.remise : 0);
                        formdata.append('options[total][]', ligne.total);
                    }
                    formdata.append('total', this.totalComTTC);
                    formdata.append('users', this.selectUsers);
                    formdata.append('idUser', this.user.id);
                    formdata.append('travaux', this.travauxS);
                    formdata.append('demande', this.selectDemande);
                    formdata.append('modePaie', this.modePaie);
                    formdata.append('avance', this.avance);
                    formdata.append('type', this.selectTypeCom);

                    this.$http.post(url, formdata).then(function (response) {
                        _this53.disBtnAjtCom = false;
                        _this53.loading = false;
                        if (response.body) {
                            _this53.dialogShowCommande = false;
                            var verif = response.body;
                            if (verif.code === 1) {
                                _this53.disBtnAjtCom = false;
                                if (_this53.commCourant.id) {
                                    _this53.$notify({
                                        title: 'MODIFICATION REUSSI',
                                        message: response.body.message,
                                        type: 'success',
                                        position: 'top-center'
                                    });
                                } else {
                                    _this53.disBtnAjtCom = false;
                                    _this53.$notify({
                                        title: 'ENREGISTREMENT REUSSI',
                                        message: response.body.message,
                                        type: 'success',
                                        position: 'top-center'
                                    });
                                }
                                _this53.disBtnAjtCom = false;
                                _this53.loadCommandeRecent(_this53.fourSelect.id);
                                // this.showFourn(this.fournCourant)
                                _this53.dialogComm = false;
                                _this53.loading = false;
                                _this53.$refs.formComm.reset();
                            } else if (verif.code === 2) {
                                _this53.disBtnAjtCom = false;
                                _this53.$message.error(verif.message);
                                _this53.loading = false;
                            }
                        } else {
                            _this53.disBtnAjtCom = false;
                            _this53.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                            _this53.loading = false;
                            _this53.clear();
                        }
                    }, function (response) {
                        _this53.disBtnAjtCom = false;
                        _this53.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this53.loading = false;
                    });
                } else {
                    this.disBtnAjtCom = false;
                    this.$notify({
                        title: "ATTENTION",
                        message: "Vous devez obligatoirement enregistré des lignes pour la commande et que ces lignes ont été correctements remplis.",
                        position: 'top-center',
                        type: 'warning'
                    });
                    this.loading = false;
                }
            } else {
                this.disBtnAjtCom = false;
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "La commande n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        submitFourn: function submitFourn() {
            var _this54 = this;

            this.loading = true;
            if (this.$refs.form.validate()) {
                if (this.mdpUser === this.mdpVerUser) {
                    var url = '';
                    var form = document.getElementById('formFour');
                    var data = new FormData(form);
                    if (this.fournCourant.id) {
                        url = this.domaine + 'fournisseur/update';
                        data.append('id', this.fournCourant.id);
                    } else {
                        url = this.domaine + 'fournisseur/create';
                    }
                    if (this.personneType === true) {
                        data.append('type', 0);
                    } else {
                        data.append('type', 1);
                    }
                    data.append('typeFour', this.selectType);
                    data.append('metier', this.selectTypeEntre);
                    data.append('civilite', this.selectCivilite);
                    data.append('naturePiece', this.selectNaturePiece);
                    data.append('idUser', this.user.id);
                    this.$http.post(url, data).then(function (response) {
                        if (response.body) {
                            var verif = response.body;
                            if (verif.code === 1) {
                                if (_this54.fournCourant.id) {
                                    _this54.$notify({
                                        title: 'MODIFICATION REUSSI',
                                        message: 'Fournisseur modifié avec succès.',
                                        type: 'success',
                                        position: 'top-center'
                                    });
                                } else {
                                    _this54.$notify({
                                        title: 'ENREGISTREMENT REUSSI',
                                        message: 'Fournisseur enregistré avec succès.',
                                        type: 'success',
                                        position: 'top-center'
                                    });
                                }
                                // this.loadFourn()
                                _this54.loadFournLimit();
                                _this54.loadPage();
                                //this.dialogAjout = false
                                _this54.dialogEdit = false;
                                _this54.loading = false;
                                _this54.clear();
                            } else {
                                _this54.$message.error(verif.message);
                                _this54.loading = false;
                            }
                        } else {
                            _this54.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                            _this54.loading = false;
                        }
                    }, function (response) {
                        _this54.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this54.loading = false;
                    });
                } else {
                    this.$message.error('Le mot de passe de vérification doit être identique au mot de passe');
                    this.loading = false;
                }
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "Le fournisseur n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        validFacture: function validFacture(ligne) {
            this.loading = false;
            this.factureCourant = ligne;
            this.dialogValiFacture = true;
        },
        handlePictureCardPreview: function handlePictureCardPreview(file) {
            this.dialogDocsUrl = file.url;
            this.dialogDocsVisible = true;
        },
        calculTotalAppro: function calculTotalAppro(entreprosParam, livraisonParam, index) {

            var total = 0;
            for (var itemm in this.optionEntrepot) {
                for (var item in this.optionQteRecu) {
                    if (this.optionQteRecu[item].idLivre == livraisonParam.id && this.optionQteRecu[item].idEntreprot == this.optionEntrepot[itemm].id && this.optionEntrepot[itemm].valide == true) {
                        total += parseInt(this.optionQteRecu[item].qte);
                    }
                }
            }
            this.optionAppro[index].qteR = parseInt(this.optionAppro[index].qteLivre) - total;
        },
        qtelivraison: function qtelivraison(option, entrepros) {
            for (var item in this.optionQteRecu) {
                if (this.optionQteRecu[item].idLivre == option.id && this.optionQteRecu[item].idEntreprot == entrepros.id) {
                    return this.optionQteRecu[item].qte;
                }
            }
        },
        addOptionComm: function addOptionComm() {

            this.optionCommande.push({
                key: Date.now(),
                produit: '',
                prix: 0,
                qte: 1,
                remise: 0,
                tva: 0,
                total: 0,
                id: ''
            });
            this.totComLigneTTC += 5;
        },
        totauxCommande: function totauxCommande(index) {
            var _this55 = this;

            var idProduit = this.optionCommande[index].produit;
            if (isNaN(idProduit)) {
                idProduit = this.optionCommande[index].id;
            }
            var mntHT = 0;
            var mntTTC = 0;
            var mntTva = 0;
            var mntRemise = 0;
            var mntHTSRem = 0;

            if (idProduit != '') {
                if (this.dialogEdit == false) {
                    var url = this.domaine + 'fournisseur/info/produit/' + idProduit;
                    var data = new FormData();
                    data.append('fournisseur', this.fourSelect.id);
                    this.loading = true;
                    this.$http.post(url, data).then(function (response) {
                        if (response.body) {
                            _this55.loading = false;
                            _this55.infoProduit = response.body;

                            //ceki etait la avant modification de la transformation en commande
                            var prixOpt = parseFloat(_this55.infoProduit.prixAchat);
                            _this55.dialogEdit == false;
                            _this55.optionCommande[index].prix = _this55.infoProduit.prixAchat;

                            _this55.optionCommande[index].id = _this55.infoProduit.id;
                            var qteOpt = parseFloat(_this55.optionCommande[index].qte);
                            var tvaOpt = parseFloat(_this55.optionCommande[index].tva);
                            var remiseOpt = parseFloat(_this55.optionCommande[index].remise);

                            mntHTSRem = prixOpt * qteOpt;
                            mntRemise = remiseOpt > 0 ? mntHTSRem * remiseOpt / 100 : 0;
                            mntHT = mntHTSRem - mntRemise;
                            mntTva = Math.round(mntHT * (tvaOpt / 100));
                            mntTTC = mntHT + mntTva;

                            _this55.optionCommande[index].total = mntTTC;
                            _this55.optionCommande[index].prix = _this55.infoProduit.prixAchat;

                            _this55.optionCommande[index].unite = _this55.infoProduit.unite;

                            _this55.loading = false;
                        }
                    }, function (response) {
                        _this55.loading = false;
                    });
                } else {
                    this.loading = false;
                    var optionCmd = this.optionCommande.slice();
                    var totalHT = 0;
                    var totalHTRS = 0;
                    var totalTVA = 0;
                    var totalRemise = 0;
                    var mntTotal = 0;
                    var tot = 0;
                    var totHT = 0;

                    for (var prop in optionCmd) {
                        this.loading = false;

                        var item = optionCmd[prop];
                        var itemPrix = item.prix;
                        var itemQte = item.qte;
                        var itemTva = item.tva;
                        var itemRemise = item.remise;

                        var mntHtSRem = itemPrix * itemQte;
                        var _mntRemise = itemRemise > 0 ? mntHtSRem * itemRemise / 100 : 0;
                        var _mntHT = mntHtSRem - _mntRemise;
                        totalHT += _mntHT;
                        totalTVA += Math.round(_mntHT * (itemTva / 100));
                        tot = _mntHT + Math.round(_mntHT * (itemTva / 100));
                        totHT = Math.round(_mntHT);
                        mntTotal += totHT;
                        this.optionCommande[prop].total = totHT;
                        this.optionCommande[index].total = totHT;

                        this.totalComRemise = new Intl.NumberFormat("fr-FR").format(_mntRemise);
                    }

                    //ceki etait la avant modification de la transformation en commande
                    //   let prixOpt =  parseFloat(this.optionCommande[index].prix ) ;
                    //   let prixReseigner = this.optionCommande[index].prix
                    //   this.optionCommande[index].prix = prixReseigner

                    //   this.optionCommande[index].id = this.optionCommande[index].id
                    //   let qteOpt = parseFloat( this.optionCommande[index].qte);
                    //   let tvaOpt = parseFloat( this.optionCommande[index].tva);
                    //   let remiseOpt = parseFloat( this.optionCommande[index].remise);


                    //   mntHTSRem =  ( prixOpt * qteOpt);
                    //   mntRemise = (remiseOpt > 0) ? ( (mntHTSRem * remiseOpt) / 100): 0;
                    //   mntHT = mntHTSRem - mntRemise;
                    //   mntTva = Math.round(   mntHT * (tvaOpt / 100) )
                    //   mntTTC = mntHT + mntTva
                    //   this.optionCommande[index].total =  mntTTC ;
                    // this.optionCommande[index].prix = this.infoProduit.prixAchat;
                }
            } else {
                this.loading = false;
                this.$message.error('Veuillez sélectionner une ressource');
            }
        },
        calculTotalComm: function calculTotalComm() {
            var _this56 = this;

            this.loading = true;
            this.totComLigneTTC = 0;
            var totalHT = 0;
            var totalHTRS = 0;
            var totalTVA = 0;
            var totalRemise = 0;
            var mntTotal = 0;

            var optionCmd = this.optionCommande.slice();

            var _loop = function _loop(prop) {
                var item = optionCmd[prop];
                var tot = 0;
                var totHT = 0;
                if (item.produit != '') {
                    if (_this56.dialogEdit == false || _this56.selectContrat == undefined || _this56.selectContrat == null) {
                        var idProd = "";
                        if (item.id != null && item.id != "") {
                            idProd = item.id;
                        } else if (item.produit != null && item.produit != "") {
                            idProd = item.produit;
                        } else {
                            return {
                                v: void 0
                            };
                        }
                        var url = _this56.domaine + 'fournisseur/info/produit/' + idProd;
                        data = new FormData();

                        data.append('fournisseur', _this56.fourSelect.id);
                        if (typeof item.produit != 'string') {
                            _this56.$http.post(url, data).then(function (response) {
                                if (response.body) {

                                    // let itemPrix = parseFloat(item.prix,10);
                                    // let itemQte = parseFloat(item.qte,10);
                                    // let itemTva = parseFloat(item.tva,10);
                                    // let itemRemise = parseFloat(item.remise,10);

                                    var itemPrix = item.prix;
                                    var itemQte = item.qte;
                                    var itemTva = item.tva;
                                    var itemRemise = item.remise;

                                    _this56.infoProduit = response.body;
                                    // ANCIEN
                                    // item.prix = (this.infoProduit.prixAchat != 0) ? itemPrix :  this.infoProduit.prixAchat ;
                                    item.prix = _this56.infoProduit.prixAchat != 0 ? _this56.infoProduit.prixAchat : itemPrix;
                                    item.produit = _this56.infoProduit.produit;
                                    item.id = _this56.infoProduit.id;

                                    var mntHtSRem = itemPrix * itemQte;
                                    // CEKI ETAI LA
                                    var mntRemise = itemRemise > 0 ? mntHtSRem * itemRemise / 100 : 0;
                                    var mntHT = mntHtSRem - mntRemise;

                                    totalRemise += mntRemise;

                                    totalHT += mntHT;
                                    totalTVA += Math.round(mntHT * (itemTva / 100));

                                    // tot = (mntHT) + Math.round((mntHT) * (itemTva / 100))
                                    // ceki etait
                                    // tot = (mntHT) + Math.round((mntHT))
                                    // totHT = Math.round((mntHT))

                                    tot = mntHT + mntHT;
                                    // totHT = Math.round((mntHT))
                                    totHT = mntHT;
                                    mntTotal += totHT;
                                    totalHTRS += mntHT + mntRemise;
                                    _this56.optionCommande[prop].id = item.id;
                                    _this56.optionCommande[prop].produit = item.produit;
                                    _this56.optionCommande[prop].total = totHT;
                                    _this56.optionCommande[prop].prix = item.prix;
                                    _this56.optionCommande[prop].unite = _this56.infoProduit.unite;

                                    _this56.totalComHT = new Intl.NumberFormat("fr-FR").format(totalHT);
                                    _this56.totalComRemise = new Intl.NumberFormat("fr-FR").format(totalRemise);
                                    _this56.totalComHTSR = new Intl.NumberFormat("fr-FR").format(totalHTRS);
                                    _this56.totalComTVA = new Intl.NumberFormat("fr-FR").format(totalTVA);
                                    _this56.totComLigneTTCFormat = new Intl.NumberFormat("fr-FR").format(Math.round(mntTotal + totalTVA));
                                    _this56.totalComTTC = Math.round(mntTotal + totalTVA);
                                    _this56.loading = false;
                                }
                            }, function (response) {
                                _this56.loading = false;
                            });
                        } else {
                            var itemPrix = parseInt(item.prix, 10);
                            var itemQte = parseInt(item.qte, 10);
                            var itemTva = parseInt(item.tva, 10);
                            var itemRemise = parseInt(item.remise, 10);

                            var mntHtSRem = itemPrix * itemQte;
                            var mntRemise = itemRemise > 0 ? mntHtSRem * itemRemise / 100 : 0;
                            var mntHT = mntHtSRem - mntRemise;
                            totalHT += mntHT;
                            totalTVA += Math.round(mntHT * (itemTva / 100));
                            tot = mntHT + Math.round(mntHT * (itemTva / 100));
                            totHT = Math.round(mntHT);

                            // mntTotal += tot;
                            mntTotal += totHT;

                            _this56.optionCommande[prop].total = totHT;
                            _this56.optionCommande[prop].prix = itemPrix;
                            _this56.optionCommande[prop].unite = item.unite;

                            _this56.totalComHT = new Intl.NumberFormat("fr-FR").format(totalHT);
                            _this56.totalComTVA = new Intl.NumberFormat("fr-FR").format(totalTVA);
                            _this56.totComLigneTTCFormat = new Intl.NumberFormat("fr-FR").format(mntTotal + totalTVA);
                            _this56.totalComTTC = mntTotal + totalTVA;
                            _this56.loading = false;
                        }
                    } // if selectContrat
                    else {
                            var _itemPrix = parseInt(item.prix, 10);
                            var _itemQte = parseInt(item.qte, 10);
                            var _itemTva = parseInt(item.tva, 10);
                            var _itemRemise = parseInt(item.remise, 10);
                            var _mntHtSRem = _itemPrix * _itemQte;
                            var _mntRemise2 = _itemRemise > 0 ? _mntHtSRem * _itemRemise / 100 : 0;
                            var _mntHT2 = _mntHtSRem - _mntRemise2;
                            totalHT += _mntHT2;
                            totalTVA += Math.round(_mntHT2 * (_itemTva / 100));
                            tot = _mntHT2 + Math.round(_mntHT2 * (_itemTva / 100));
                            totHT = Math.round(_mntHT2);
                            // mntTotal += tot;
                            mntTotal += totHT;
                            _this56.optionCommande[prop].total = totHT;
                            _this56.optionCommande[prop].prix = _itemPrix;
                            _this56.optionCommande[prop].unite = item.unite;
                            _this56.totalComHT = new Intl.NumberFormat("fr-FR").format(totalHT);
                            _this56.totalComTVA = new Intl.NumberFormat("fr-FR").format(totalTVA);
                            _this56.totComLigneTTCFormat = new Intl.NumberFormat("fr-FR").format(mntTotal + totalTVA);
                            _this56.totalComTTC = mntTotal + totalTVA;
                            _this56.loading = false;
                        }
                } else {
                    _this56.loading = false;
                    _this56.$message.error('Veuillez sélectionner une ressource');
                }

                _this56.totComLigneTTC += tot;
            };

            for (var prop in optionCmd) {
                var data;

                var _ret = _loop(prop);

                if ((typeof _ret === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(_ret)) === "object") return _ret.v;
            }
            this.loading = false;
            this.totalComHT = new Intl.NumberFormat('fr-Fr').format(totalHT);
            this.totalComTVA = new Intl.NumberFormat('fr-Fr').format(totalTVA);
            this.totComLigneTTCFormat = new Intl.NumberFormat('fr-Fr').format(this.totComLigneTTC);
        },
        deleteFourn: function deleteFourn() {
            var _this57 = this;

            this.loading = true;
            var url = this.domaine + 'fournisseur/' + this.idFourn + '/delete';
            this.$http.get(url).then(function (response) {
                _this57.loading = false;
                if (response.body) {
                    _this57.dialogSupr = false;

                    _this57.loadFournLimit();

                    _this57.loadPage();

                    if (response.body.code == 2) {
                        _this57.$alert(response.body.message, 'Suppression', {
                            confirmButtonText: 'OK'
                        });
                    } else {
                        _this57.$notify({
                            title: 'SUPPRESSION',
                            message: response.body.message,
                            type: 'success',
                            duration: 5000,
                            position: 'top-center'
                        });
                    }
                }
            });
        },
        deleteCommande: function deleteCommande() {
            var _this58 = this;

            var url = this.domaine + 'fournisseur/' + this.idComm + '/delete/commande';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this58.$notify({
                        title: 'SUPPRESSION',
                        message: 'Commande supprimé avec succès.',
                        type: 'success',
                        position: 'top-center'
                    });
                    _this58.dialogSuprComm = false;
                    _this58.loadFournLimit(_this58.fournCourant);
                    _this58.loadCommandeRecent(_this58.fourSelect.id);
                    _this58.loadPage();
                }
            });
        },
        imprimerFacture: function imprimerFacture(ligne) {
            this.factureCourant = ligne;
            this.dialogImprFacture = true;
        },
        imprimerFuCom: function imprimerFuCom(ligne) {
            this.dialogImprFusionCom = true;
        },
        imprimerModeFacture: function imprimerModeFacture(mode) {
            this.dialogImprFacture = false;
            var url = this.domaine + 'fournisseur/' + this.factureCourant.idFact + '/' + this.user.id + '/imprimer/facture/' + mode;
            this.$http.get(url).then(function (response) {
                if (response.body) {}
            });
            window.open(url);
        },
        imprimerCommande: function imprimerCommande(ligne) {
            this.dialogImprCommande = true;
            this.commCourant = ligne;
        },
        imprimerModeCommande: function imprimerModeCommande(mode) {
            var url = this.domaine + 'fournisseur/' + this.commCourant.id + '/imprimer/commande/' + this.user.id + '/' + mode;
            this.$http.get(url).then(function (response) {
                if (response.body) {}
            });
            this.dialogImprCommande = false;
            window.open(url);
        },
        imprimerLivraison: function imprimerLivraison(ligne) {
            this.livraisonCourant = ligne;
            this.dialogImprLivraison = true;
        },
        imprimerModeLivraison: function imprimerModeLivraison(mode) {
            this.dialogImprLivraison = false;
            var url = this.domaine + 'fournisseur/' + this.livraisonCourant.id + '/imprimer/livraison/' + this.user.id + '/' + mode;
            this.$http.get(url).then(function (response) {
                if (response.body) {}
            });
            window.open(url);
        },
        imprimeListeHisFourCmde: function imprimeListeHisFourCmde(type) {
            var idFour = this.fournCourant.id;
            var url = "";
            if (type == "PDF") {
                url = this.domaine + "fournisseur/imprimerPDF/historique/" + idFour + "/commande/liste";
            } else {
                url = this.domaine + "fournisseur/imprimerEXC/historique/" + idFour + "/commande/liste";
            }
            window.open(url);
        },
        imprimeListeHisContra: function imprimeListeHisContra(type) {
            var idFour = this.fournCourant.id;
            var url = "";
            if (type == "PDF") {
                url = this.domaine + "fournisseur/imprimerPDF/historique/fournisseur/liste";
            } else {
                url = this.domaine + "fournisseur/imprimerEXC/historique/fournisseur/liste";
            }
            window.open(url);
        },
        imprimeListeHisFourFacture: function imprimeListeHisFourFacture(type) {
            var idFour = this.fournCourant.id;
            var url = "";
            if (type == "PDF") {
                url = this.domaine + "fournisseur/imprimerPDF/historique/" + idFour + "/facture/liste";
            } else {
                url = this.domaine + "fournisseur/imprimerEXC/historique/" + idFour + "/facture/liste";
            }
            window.open(url);
        },
        imprimeListeHisFourLivraison: function imprimeListeHisFourLivraison(type) {
            var idFour = this.fournCourant.id;
            var url = "";
            if (type == "PDF") {
                url = this.domaine + "fournisseur/imprimerPDF/historique/" + idFour + "/livraison/liste";
            } else {
                url = this.domaine + "fournisseur/imprimerEXC/historique/" + idFour + "/livraison/liste";
            }
            window.open(url);
        },
        imprimeListeHisFourMaintenance: function imprimeListeHisFourMaintenance(type) {
            var idFour = this.fournCourant.id;
            var url = "";
            if (type == "PDF") {
                url = this.domaine + "fournisseur/imprimerPDF/historique/" + idFour + "/maintenance/liste";
            } else {
                url = this.domaine + "fournisseur/imprimerEXC/historique/" + idFour + "/maintenance/liste";
            }
            window.open(url);
        },
        imprimeListeHisFournisseur: function imprimeListeHisFournisseur(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + "fournisseur/imprimerPDF/historique/fournisseur/liste";
            } else {
                url = this.domaine + "fournisseur/imprimerEXC/historique/fournisseur/liste";
            }
            window.open(url);
        },
        morale: function morale() {
            this.personneType = true;
            //this.dialogAjout = true
        },
        physique: function physique() {
            this.personneType = false;
            //this.dialogAjout = true
        },
        querySearch: function querySearch(queryString, cb) {
            var links = this.listKeyword;
            var results = queryString ? links.filter(this.createFilter(queryString)) : links;
            // call callback function to return suggestions
            cb(results);
        },
        createFilter: function createFilter(queryString) {
            return function (link) {
                return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
        removeOptionComm: function removeOptionComm(item) {
            var index = this.optionCommande.indexOf(item);

            //Montant total

            var prixOpt = parseInt(item.prix);
            var qteOpt = parseFloat(item.qte);
            var tvaOpt = parseFloat(item.tva);

            //let mntTotHT = this.totalHT;
            //let mntTotTTC =  this.totalComTTC;
            //let mntTotTva =  this.totalTva;

            var mntHT = parseFloat(prixOpt * qteOpt);
            var mntTva = parseFloat(Math.round(prixOpt * qteOpt * (tvaOpt / 100)));
            var mntTTC = mntHT + mntTva;

            this.totTTC -= this.optionCommande[index].total;
            if (index !== -1) {
                this.optionCommande.splice(index, 1);
            }

            //this.calculTotalComm()
        },
        demandeDevisPlus: function demandeDevisPlus() {
            this.optionDevis.push({
                key: Date.now(),
                libelle: '',
                cout: 0,
                qte: 1,
                tva: 0,
                total: 0,
                id: ''
            });
            this.totComLigneTTC += 5;
        },
        calculTotalDevis: function calculTotalDevis() {
            this.loading = true;
            var total = 0;
            var tvaG = 0;
            var ht = 0;
            this.optionDevis.forEach(function (item) {
                var _this59 = this;

                var t = 0;
                var c = 0;
                var tva = 0;
                if (item.produit != '') {
                    var idProd = "";
                    if (item.id != null && item.id != "") {
                        idProd = item.id;
                    } else if (item.produit != null && item.produit != "") {
                        idProd = item.produit;
                    } else {
                        return;
                    }
                    var url = this.domaine + 'fournisseur/info/produit/' + idProd;
                    var data = new FormData();
                    data.append('fournisseur', this.fourSelect.id);
                    this.$http.post(url, data).then(function (response) {
                        if (response.body) {
                            _this59.infoProduit = response.body;
                            item.cout = _this59.infoProduit.prixAchat;
                            c = parseInt(item.cout) * parseInt(item.qte);
                            tva = c * (parseInt(item.tva) / 100);
                            t = c + tva;
                            item.total = t;
                            total += t;
                            tvaG += tva;
                            ht += c;
                            _this59.loading = false;
                        }
                    }, function (response) {
                        _this59.loading = false;
                    });
                } else {
                    this.loading = false;
                    this.$message.error('Veuillez sélectionner une ressource');
                }

                c = parseInt(item.cout) * parseInt(item.qte);
                tva = c * (parseInt(item.tva) / 100);
                t = c + tva;
                item.total = t;
                total += t;
                tvaG += tva;
                ht += c;
            });

            this.devisTotal = new Intl.NumberFormat('fr-Fr').format(total);
            this.devisTva = new Intl.NumberFormat('fr-Fr').format(tvaG);
            this.devisHt = new Intl.NumberFormat('fr-Fr').format(ht);
        },
        suppressionDevis: function suppressionDevis(index) {
            var item = this.optionDevis.indexOf(index);
            this.optionDevis.splice(item, 1);
            this.calculTotalDevis();
        },
        clear: function clear() {
            this.$refs.form.reset();
            this.dialogComm = false;
        },
        onFileImage1Picked: function onFileImage1Picked(event) {
            var _this60 = this;

            var files = event.target.files;
            var filename = files[0].name;
            this.nameFile = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }
            if (files[0].size > 10485760) {
                this.$message.error("La taille du fichier est supérieur à 10 Mo");
                return;
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this60.image1 = fileReader.result;
            });

            fileReader.readAsDataURL(files[0]);
            this.file1 = files[0];
        },
        onFileImage2Picked: function onFileImage2Picked(event) {
            var _this61 = this;

            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this61.image2 = fileReader.result;
            });

            fileReader.readAsDataURL(files[0]);
            this.file2 = files[0];
        },
        imprimeListTarif: function imprimeListTarif(type) {
            // let listLivraison = this.listProduit
            var url = "";
            if (type == "PDF") {
                url = this.domaine + "fournisseur/imprimerPDF/historique/" + this.fournCourant.id + "/tarification";
            } else {
                url = this.domaine + "fournisseur/imprimerEXC/historique/" + this.fournCourant.id + "/tarification";
            }
            window.open(url);
        },
        showDialogComparaison: function showDialogComparaison(item) {
            var _this62 = this;

            this.loading = true;
            this.commandeInit = item;
            var totalCmdInit = 0;
            this.commandeInit.option.forEach(function (value, i) {
                totalCmdInit = totalCmdInit + value.total;
            });
            this.totCommandeInit = totalCmdInit;
            var url = this.domaine + 'comparateur/commande/' + item.id;
            this.$http.get(url).then(function (response) {
                _this62.loading = false;
                if (response.body.listeProdCom.length > 0) {
                    _this62.commandeDeriv = response.body.fournisseurs;
                    _this62.totalBenefice = response.body.beneficeTotal;
                    _this62.listeProdNull = response.body.listeProdNull;
                    _this62.dialogComparaison = true;
                } else {
                    _this62.dialogProdNull = true;
                }

                if (response.body.listeProdCom.length == 0 && response.body.listeProdNull.length == 0) {
                    _this62.$message.error("Aucune ressource de cette commande n'a été trouvé lors de la recherche ");
                }
                // if(response.body.listeProdNull.length > 0 ) {
                //     this.listeProdNull = response.body.listeProdNull;
                //     this.dialogProdNull = true
                // }
            });
            this.loading = false;
        },
        attribuerFour: function attribuerFour() {
            var _this63 = this;

            for (var index in this.listeProdNull) {
                var _item2 = this.listeProdNull[index];
                if (_item2.fournisseur == undefined || _item2.prixU == undefined || _item2.prixU == 0) {
                    this.$message.error('Veuillez selectionner un fournisseur et un montant supérieur à zéro pour chaque ressource');
                    return;
                }
            }
            var url = this.domaine + 'fournisseur/new/tarif/listproduit';

            var listProdFour = [];
            for (var _index in this.listeProdNull) {
                var _item3 = {
                    produit: this.listeProdNull[_index].idProduit,
                    prixAchat: this.listeProdNull[_index].prixU,
                    fournisseur: this.listeProdNull[_index].fournisseur
                };
                listProdFour.push(_item3);
            }
            var data = new FormData();
            data.append("listeProdFour", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(listProdFour));
            data.append('idUser', this.user.id);

            this.$http.post(url, data).then(function (response) {
                _this63.$notify({
                    title: 'Success',
                    message: response.body.message,
                    type: 'success'
                });
                _this63.dialogProdNull = false;
                _this63.showDialogComparaison(_this63.commandeInit);
            }, function (response) {
                _this63.$message.error("Une erreur s'est produite lors de l'enregistrement du montant de  la ressource ");
                _this63.loading = false;
            });
        },
        loadMetier: function loadMetier() {
            var _this64 = this;

            var url = this.domaine + "chantier/index";
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this64.comboMetier = response.body.metier;
                }
            });
        },
        validCmdDerivees: function validCmdDerivees(listPropos) {
            var _this65 = this;

            // this.loading = true
            var formdata = new FormData();
            formdata.append('commandes', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(listPropos));
            formdata.append('commandeInit', this.commandeInit.id);
            formdata.append('idUser', this.user.id);
            formdata.append('benefTotal', 9000);

            var url = this.domaine + 'comparateur/commande/create';
            this.$http.post(url, formdata).then(function (response) {
                _this65.loading = false;
                _this65.dialogComparaison = false;
                if (response.body) {
                    _this65.validCommd = false;
                    var verif = response.body;
                    _this65.$notify({
                        title: 'VALIDATION REUSSIE',
                        message: 'Les commandes ont été génerées.',
                        type: 'success',
                        position: 'top-center',
                        duration: 5000
                    });
                    _this65.loadCommandeRecent(_this65.fourSelect.id);
                } else {
                    _this65.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                    _this65.loading = false;
                    _this65.dialogAppro = false;
                }
            });
        },


        //DETAIL CONTRAT
        showDetailContrat: function showDetailContrat(idContrat) {
            var _this66 = this;

            this.loading = true;
            var url = this.domaine + 'contrat/prestataire/show/' + idContrat;
            this.$http.get(url).then(function (resp) {
                _this66.detailContrat = resp.body.contrat;
                _this66.dialogInfoContrat = true;
                _this66.loading = false;
            }, function (error) {
                _this66.$message.error("Echec lors Chargement detail contrat, verifiez votre connexion");
                _this66.loading = false;
            });
        },
        getSommeFact: function getSommeFact(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = "Total";
                    return;
                }

                if (index === 3) {
                    sums[index] = "N/A";
                    return;
                }
                var values = data.map(function (item) {
                    return Number(item[column.property]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0));
                } else {
                    sums[index] = "N/A";
                }
            });

            return sums;
        },
        headerRowStyle: function headerRowStyle(_ref2) {
            var row = _ref2.row,
                rowIndex = _ref2.rowIndex;

            return { "color": "black" };
        }
    },

    beforeMount: function beforeMount() {

        if (!this.roleAcces[this.$router.history.current.name]) {
            this.$router.push({ name: 'Home' });
        }
    }
});

/***/ }),

/***/ "8Uc3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__ = __webpack_require__("MqC/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar__ = __webpack_require__("olwm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fullcalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);







/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        events: {
            default: function _default() {
                return [];
            }
        },

        eventSources: {
            default: function _default() {
                return [];
            }
        },

        editable: {
            default: function _default() {
                return true;
            }
        },

        selectable: {
            default: function _default() {
                return true;
            }
        },

        selectHelper: {
            default: function _default() {
                return true;
            }
        },

        header: {
            default: function _default() {
                return {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'month,agendaWeek,agendaDay'
                };
            }
        },

        defaultView: {
            default: function _default() {
                return 'agendaWeek';
            }
        },

        sync: {
            default: function _default() {
                return false;
            }
        },

        config: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },

    computed: {
        defaultConfig: function defaultConfig() {
            var self = this;
            return {
                header: this.header,
                defaultView: this.defaultView,
                editable: this.editable,
                selectable: this.selectable,
                selectHelper: this.selectHelper,
                aspectRatio: 2,
                timeFormat: 'HH:mm',
                events: this.events,
                eventSources: this.eventSources,

                eventRender: function eventRender() {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }

                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    self.$emit.apply(self, ['event-render'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                viewRender: function viewRender() {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }

                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        args[_key2] = arguments[_key2];
                    }

                    self.$emit.apply(self, ['view-render'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventDestroy: function eventDestroy(event) {
                    if (this.sync) {
                        self.events = cal.fullCalendar('clientEvents');
                    }
                },
                eventClick: function eventClick() {
                    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                        args[_key3] = arguments[_key3];
                    }

                    self.$emit.apply(self, ['event-selected'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventDrop: function eventDrop() {
                    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                        args[_key4] = arguments[_key4];
                    }

                    self.$emit.apply(self, ['event-drop'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventReceive: function eventReceive() {
                    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                        args[_key5] = arguments[_key5];
                    }

                    self.$emit.apply(self, ['event-receive'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                eventResize: function eventResize() {
                    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                        args[_key6] = arguments[_key6];
                    }

                    self.$emit.apply(self, ['event-resize'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                dayClick: function dayClick() {
                    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                        args[_key7] = arguments[_key7];
                    }

                    self.$emit.apply(self, ['day-click'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(args)));
                },
                select: function select(start, end, jsEvent, view, resource) {
                    self.$emit('event-created', {
                        start: start,
                        end: end,
                        allDay: !start.hasTime() && !end.hasTime(),
                        view: view,
                        resource: resource
                    });
                }
            };
        }
    },

    mounted: function mounted() {
        var _this = this;

        var cal = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el),
            self = this;

        this.$on('remove-event', function (event) {
            if (event && event.hasOwnProperty('id')) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents', event.id);
            } else {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents', event);
            }
        });

        this.$on('rerender-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('rerenderEvents');
        });

        this.$on('refetch-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('refetchEvents');
        });

        this.$on('render-event', function (event) {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('renderEvent', event);
        });

        this.$on('reload-events', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEvents');
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('addEventSource', _this.events);
        });

        this.$on('rebuild-sources', function () {
            __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('removeEventSources');
            _this.eventSources.map(function (event) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(_this.$el).fullCalendar('addEventSource', event);
            });
        });

        cal.fullCalendar(__WEBPACK_IMPORTED_MODULE_1_lodash_defaultsdeep___default()(this.config, this.defaultConfig));
    },


    methods: {
        fireMethod: function fireMethod() {
            var _$;

            return (_$ = __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el)).fullCalendar.apply(_$, arguments);
        }
    },

    watch: {
        events: {
            deep: true,
            handler: function handler(val) {
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).fullCalendar('removeEvents');
                __WEBPACK_IMPORTED_MODULE_3_jquery___default()(this.$el).fullCalendar('addEventSource', this.events);
            }
        },
        eventSources: {
            deep: true,
            handler: function handler(val) {
                this.$emit('rebuild-sources');
            }
        }
    },

    beforeDestroy: function beforeDestroy() {
        this.$off('remove-event');
        this.$off('rerender-events');
        this.$off('refetch-events');
        this.$off('render-event');
        this.$off('reload-events');
        this.$off('rebuild-sources');
    }
});

/***/ }),

/***/ "8Wo+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","wrap":""}},_vm._l((10),function(n){return _c('v-flex',{staticClass:"mr-2 mt-4",attrs:{"align-center":"","xs2":""}},[_c('v-card',[_c('v-card-media',{staticClass:"white--text",attrs:{"height":"200px","src":"/static/tache.jpg"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('span',{staticClass:"headline"},[_vm._v("Titre tableau")])])],1)],1)],1),_vm._v(" "),_c('v-card-title',[_c('div',[_c('span',{staticClass:"grey--text"},[_vm._v("Tache(s) 100")]),_c('br'),_vm._v(" "),_c('span',[_vm._v("A faire: 20")]),_c('br'),_vm._v(" "),_c('span',[_vm._v("En cours : 20")]),_c('br'),_vm._v(" "),_c('span',[_vm._v("Termine: 20")]),_c('br')])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"orange"}},[_vm._v("Detail")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"orange"}},[_vm._v("Modifier")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"orange"}},[_vm._v("Supprimer")])],1)],1)],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8p1G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "DetailBudgetProjet",
  props: {
    show: {
      type: Boolean
    },
    detailProjet: {
      type: Object
    }
  },
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      loading: false,
      dialogDetail: false,
      listeProjet: [],
      listeRapport: [],
      listeChantier: [],
      listeBudget: [],
      bilanMensuel: [],
      bilanTravaux: [],
      listeDetail: [],
      compte: "0",
      dialogConfirm: false,
      disabledBtnPop: false,
      totalMntPropose: 0,
      totalMntValide: 0
    };
  },


  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      var _this2 = this;

      this.dialogDetail = newValue;
      if (newValue == true) {
        this.listeBudget = this.detailProjet.budgets;
        var _this = this;
        this.totalMntPropose = 0;
        this.totalMntValide = 0;
        this.totalMntMarche = 0;
        this.listeBudget.forEach(function (item) {
          _this2.totalMntPropose += item.mntTotalBudgetPropose;
          _this2.totalMntValide += item.mntTotalBudgetValide;
        });
        this.loadBilan(this.detailProjet.idProj);
      }
    }
  },

  methods: {
    handleTabClick: function handleTabClick(tab) {
      switch (tab) {
        case "0":
          break;
        case "1":
          break;

        default:
          break;
      }
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getSumm: function getSumm(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 4) {
          sums[index] = "N/A";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    getSummCompte: function getSummCompte(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getSummCompteFinance: function getSummCompteFinance(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 6) {
          sums[index] = "N/A";
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    handleChange: function handleChange(newValue, oldValue) {},
    SubmitValideBudget: function SubmitValideBudget() {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + "compteExploit/valider/budget_projet";

      var nbData = 10;
      var nbReq = 1;
      var ligne = null;

      var nbRest = void 0;
      if (this.listeBudget.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.listeBudget.length / nbData);
        nbRest = this.listeBudget.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (var i = 0; i < nbReq; i++) {
        var initJ = i * nbData;
        var finJ = (i + 1) * nbData;
        var dataLot = [];
        if (this.listeBudget.length > 0) {
          for (var j = initJ; j < finJ; j++) {
            if (this.listeBudget[j] == undefined) {
              break;
            }
            dataLot.push(this.listeBudget[j]);
          }
        }
        var data = new FormData();
        for (var prop in dataLot) {
          console.lpg("ddjd", dataLot[prop]);
          ligne = dataLot[prop];
          data.append("option[id][]", ligne.id);
          data.append("option[libelle][]", ligne.libelle);
          data.append("option[mntTotalBudgetPropose][]", ligne.mntTotalBudgetPropose);
          data.append("option[mntTotalBudgetValide][]", ligne.mntTotalBudgetValide);
          data.append("option[ecartMntTotal][]", ligne.ecartMntTotal);
          data.append("option[idBudget][]", ligne.idBudget);
          data.append("option[libelle][]", ligne.libelle);
          data.append("option[mntBudgetPropose][]", ligne.mntBudgetPropose);
          data.append("option[mntBudgetValide][]", ligne.mntBudgetValide);
          data.append("option[ecartBudget][]", ligne.ecartBudget);
          data.append("option[mois][]", ligne.mois);
        }

        // data.append('listeTypeTravaux', JSON.stringify(dataLot))
        data.append("idUser", this.user.id);
        data.append("idProjet", this.detailProjet.id);

        this.$http.post(url, data).then(function (resp) {
          _this3.loading = false;
          succesEnreg = false;
          _this3.$emit("close");
          _this3.dialogAjoutBudget = false;
          _this3.showFourn();
          _this3.$notify({
            title: "Enregistrement",
            message: "La liste a ete enregistre avec succes",
            type: "success",
            position: "top-right",
            duration: 5000
          });
        }, function (error) {
          _this3.loading = false;
          succesEnreg = false;
          _this3.dialogAjoutBudget = false;
          _this3.$message.error("Erreur lors de l'enregistrement des tarifs");
        });
      }
    },
    headerRowStyle: function headerRowStyle(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return { color: "black" };
    },
    getSummDetailBudget: function getSummDetailBudget(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 5) {
          sums[index] = "N/A";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    loadBilan: function loadBilan(idProjet) {
      var _this4 = this;

      this.loading = true;
      var url = this.domaine + "budgetProjet/bilan/projet/" + idProjet;
      this.$http.get(url).then(function (response) {
        _this4.loading = false;
        _this4.bilanMensuel = response.body.mensuel;
        _this4.bilanTravaux = response.body.bilanTravaux.travaux;
        _this4.listeDetail = response.body.detailCompte;
      }, function (errRep) {
        _this4.loading = false;
        _this4.$message.error("Une erreur est survenue lors du chargement du bilan");
      });
    },
    imprimeBudgtTravauxPDF: function imprimeBudgtTravauxPDF(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "budgetProjet/budget/projet/" + this.detailProjet.idProj + "/user/" + this.user.id + "/imprimerPDF_budget_travaux";
      } else {
        url = this.domaine + "budgetProjet/budget/projet/" + this.detailProjet.idProj + "/user/" + this.user.id + "/imprimerEXC_budget_travaux";
      }
      window.open(url);
    },
    imprimeBudgtTravauxPDFSimpl: function imprimeBudgtTravauxPDFSimpl(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "budgetProjet/budget/projet/" + this.detailProjet.idProj + "/user/" + this.user.id + "/imprimerPDF_budget_travauxSimpl";
      } else {
        url = this.domaine + "budgetProjet/budget/projet/" + this.detailProjet.idProj + "/user/" + this.user.id + "/imprimerEXC_budget_travauxSimpl";
      }
      window.open(url);
    },
    imprimeBudgtRecapitulatifAnnuel: function imprimeBudgtRecapitulatifAnnuel(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "budgetProjet/budget/projet/" + this.detailProjet.idProj + "/user/" + this.user.id + "/imprimerPDF_RecapitulatifAnnuel";
      } else {
        url = this.domaine + "budgetProjet/budget/projet/" + this.detailProjet.idProj + "/user/" + this.user.id + "/imprimerEXC_RecapitulatifAnnuel";
      }
      window.open(url);
    },
    imprimeBudgtRecapitulatifAnnuelSimpl: function imprimeBudgtRecapitulatifAnnuelSimpl(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "budgetProjet/budget/projet/" + this.detailProjet.idProj + "/user/" + this.user.id + "/imprimerPDF_RecapitulatifAnnuelSimpl";
      } else {
        url = this.domaine + "budgetProjet/budget/projet/" + this.detailProjet.idProj + "/user/" + this.user.id + "/imprimerEXC_RecapitulatifAnnuelSimpl";
      }
      window.open(url);
    },
    imprimeBudgtRecapitulatifTravaux: function imprimeBudgtRecapitulatifTravaux(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "budgetProjet/budget/projet/" + this.detailProjet.idProj + "/user/" + this.user.id + "/imprimerPDF_RecapitulatifTravaux";
      } else {
        url = this.domaine + "budgetProjet/budget/projet/" + this.detailProjet.idProj + "/user/" + this.user.id + "/imprimerEXC_RecapitulatifTravaux";
      }
      window.open(url);
    },
    imprimeBudgtRecapitulatifTravauxSimpl: function imprimeBudgtRecapitulatifTravauxSimpl(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "budgetProjet/budget/projet/" + this.detailProjet.idProj + "/user/" + this.user.id + "/imprimerPDF_RecapitulatifTravauxSimpl";
      } else {
        url = this.domaine + "budgetProjet/budget/projet/" + this.detailProjet.idProj + "/user/" + this.user.id + "/imprimerEXC_RecapitulatifTravauxSimpl";
      }
      window.open(url);
    },
    imprimeBudgtRecapitulatifFinance: function imprimeBudgtRecapitulatifFinance(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "budgetProjet/budget/projet/" + this.detailProjet.idProj + "/user/" + this.user.id + "/imprimerPDF_RecapitulatifFinancier";
      } else {
        url = this.domaine + "budgetProjet/budget/projet/" + this.detailProjet.idProj + "/user/" + this.user.id + "/imprimerEXC_RecapitulatifFinancier";
      }
      window.open(url);
    },
    imprimeBudgtRecapitulatifFinanceSimpl: function imprimeBudgtRecapitulatifFinanceSimpl(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "budgetProjet/budget/projet/" + this.detailProjet.idProj + "/user/" + this.user.id + "/imprimerPDF_RecapitulatifFinancierSimpl";
      } else {
        url = this.domaine + "budgetProjet/budget/projet/" + this.detailProjet.idProj + "/user/" + this.user.id + "/imprimerEXC_RecapitulatifFinancierSimpl";
      }
      window.open(url);
    },
    loadProjet: function loadProjet() {
      var _this5 = this;

      var url = this.domaine + "projet/indicateur/projet";

      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this5.loading = false;
        _this5.listeProjet = response.body.projet;
        _this5.listeRapport = response.body.rapport;
      }, function (errRep) {
        _this5.loading = false;
        _this5.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    }
  },
  mounted: function mounted() {
    this.loadProjet();
  }
});

/***/ }),

/***/ "8pPP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formTypeTache_vue__ = __webpack_require__("sVGo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebad7c9a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formTypeTache_vue__ = __webpack_require__("V3j6");
function injectStyle (ssrContext) {
  __webpack_require__("q0WE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ebad7c9a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formTypeTache_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebad7c9a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formTypeTache_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8taH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Loading",
  data: function data() {
    return {};
  },
  props: {
    value: { type: Boolean, default: false },
    message: { type: String, default: null },
    progressColor: { type: String, default: 'blue' }
  }
});

/***/ }),

/***/ "8uk5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_echarts__ = __webpack_require__("cs+8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_chart_line__ = __webpack_require__("4UDB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Vb+l");
__webpack_require__("Oq2I");
__webpack_require__("miEh");



// import * as echarts from 'echarts';


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */],
    'v-chart': __WEBPACK_IMPORTED_MODULE_0_vue_echarts___default.a
  },
  name: "DashboardRapport",
  props: {
    show: {
      type: Boolean
    },
    detailProjet: {
      type: Object
    }
  },
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      loading: false,
      dialogDetail: false,
      showButonExcel: false,
      dialogueImprimer: false,
      listeProjet: [],
      listeRecherche: [],
      listeRapport: [],
      listeChantier: [],
      listeTravaux: [],
      listTaches: [],
      listTravauxResult: [],
      listChargeResult: [],
      mntTotalChargeI: 0,
      showGraph: false,
      mntTotalChargeD: 0,
      mntTotalChargeDE: 0,
      mntTotalChargeMA: 0,
      mntTotalDepense: 0,
      listeBudget: [],
      bilanMensuel: [],
      bilanTravaux: [],
      listeDetail: [],
      helpDemande: [{
        num: "1",
        text: "Somme de toutes les commandes éffectuées"
      }, {
        num: "2",
        text: "Somme de toutes les demandes de fond éffectuées"
      }, {
        num: "3",
        text: "Somme de toutes les dépenses indiquée dans le rapport journalier"
      }],
      helpDemandeN: [{
        num: "1",
        text: "REDEMENT GLOBAL: Qte tâche / Durée totale prévue."
      }, {
        num: "1",
        text: "REDEMENT RÉEL: Le rendement réel d'une tâche d'un projet par jour: Calculé en divisant le nombre de tâches effectuées par le nombre de jours consacrés à la tâche."
      }, {
        num: "2",
        text: "Prix BUDGET: Somme de toutes les commandes effectuées pour la tâche."
      }, {
        num: "3",
        text: "ECART PRIX DE REVIENT: L'écart du prix de revient d'une tâche peut être calculé en soustrayant le coût réel de la tâche à son coût prévu. Par exemple, si le coût prévu pour une tâche était de 100 et que le coût réel était de 120, l'écart du prix de revient serait de 2"
      }, {
        num: "4",
        text: "ECART REDEMENT: L'écart de rendement d'une tâche d'un projet peut être calculé en soustrayant le rendement réel de la tâche à son rendement attendu. Par exemple, si la tâche a été estimée à prendre 100 heures pour être terminée, mais qu'elle a pris 120 heures, alors l'écart de rendement sera de -20 heures."
      }, {
        num: "5",
        text: "COUT RÉEL:Le coût réel d'une tâche d'un projet est le coût final de la réalisation de cette tâche, c'est-à-dire le coût réellement dépensé pour la réaliser."
      }, {
        num: "6",
        text: "VALEUR PLANIFIÉE: La valeur planifiée d'une tâche d'un projet est le coût estimé de la réalisation de cette tâche."
      }],

      //  new data
      selectProjet: [],
      selectChantier: [],
      selectTravaux: [],
      selectAnnee: '',
      selectTaches: '',
      libelleTravaux: '',
      selectAnneeFormat: '',
      selectAnneeMonth: null,
      //critere de recherche
      formTri: { periode: '' },

      compte: "0",
      dialogConfirm: false,
      disabledBtnPop: false,
      totalMntPropose: 0,
      totalMntValide: 0
    };
  },


  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      var _this2 = this;

      this.dialogDetail = newValue;
      if (newValue == true) {
        this.listeBudget = this.detailProjet.budgets;
        var _this = this;
        this.totalMntPropose = 0;
        this.totalMntValide = 0;
        this.totalMntMarche = 0;
        this.listeBudget.forEach(function (item) {
          _this2.totalMntPropose += item.mntTotalBudgetPropose;
          _this2.totalMntValide += item.mntTotalBudgetValide;
        });
        this.loadBilan(this.detailProjet.idProj);
      }
    }
  },

  methods: {
    handleTabClick: function handleTabClick(tab) {
      switch (tab) {
        case "0":
          break;
        case "1":
          break;

        default:
          break;
      }
    },
    headerRowStyle: function headerRowStyle(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return { color: "black" };
    },
    statistique: function statistique(dataStat) {
      var chartDom = document.getElementById('main');
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: 'Rapport d\'analyse de la valeur acquise'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['VALEUR PLANIFIEE (VP)', 'VALEUR ACQUISE (VA)', 'COUT REEL (CR),']
        },
        grid: {
          left: '10%',
          right: '10%',
          bottom: '10%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [] // Les données seront assignées en fonction de la condition
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: 'VALEUR PLANIFIEE',
          type: 'line',
          stack: 'Total',
          data: []
        }, {
          name: 'VALEUR ACQUISE',
          type: 'line',
          stack: 'Total',
          data: []
        }, {
          name: 'COUT REEL',
          type: 'line',
          stack: 'Total',
          data: []
        }]
      };

      if (this.selectAnneeMonth !== '' && this.selectAnneeMonth !== null) {
        option.xAxis.data = ["PERIODE: " + this.selectAnneeMonth[0] + " AU " + this.selectAnneeMonth[1]];
      } else {
        option.xAxis.data = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'];
      }
      var tabNb = option.xAxis.data.length;
      if (this.selectAnneeMonth !== '' && this.selectAnneeMonth !== null && this.selectAnneeMonth !== 'null') {
        option.series[0].data.push({ value: dataStat[0]['vp'], name: "VALEUR PLANIFIEE (VP)" });
        option.series[1].data.push({ value: dataStat[0]['va'], name: "VALEUR ACQUISE (VA)" });
        option.series[2].data.push({ value: dataStat[0]['cr'], name: "COUT REEL (CR)" });
      } else {

        for (var i = 0; i < tabNb; i++) {
          for (var dataCBud in dataStat) {
            var mois = option.xAxis.data;
            if (mois[i] === dataStat[dataCBud]['mois']) {
              option.series[0].data.push({ value: dataStat[dataCBud]['vp'], name: "VALEUR PLANIFIEE (VP)" });
              option.series[1].data.push({ value: dataStat[dataCBud]['va'], name: "VALEUR ACQUISE (VA)" });
              option.series[2].data.push({ value: dataStat[dataCBud]['cr'], name: "COUT REEL (CR)" });
            }
          }
        }
      }
      option && myChart.setOption(option);
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getSumm: function getSumm(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 4) {
          sums[index] = "N/A";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    getSummCompte: function getSummCompte(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    },
    getSummCompteFinance: function getSummCompteFinance(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 6) {
          sums[index] = "N/A";
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getSummDetailBudget: function getSummDetailBudget(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 5) {
          sums[index] = "N/A";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });

        if (!values.every(function (value) {
          return isNaN(value);
        })) {

          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    loadBilan: function loadBilan(idProjet) {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + "budgetProjet/bilan/projet/" + idProjet;
      this.$http.get(url).then(function (response) {
        _this3.loading = false;
        _this3.bilanMensuel = response.body.mensuel;
        _this3.bilanTravaux = response.body.bilanTravaux.travaux;
        _this3.listeDetail = response.body.detailCompte;
      }, function (errRep) {
        _this3.loading = false;
        _this3.$message.error("Une erreur est survenue lors du chargement du bilan");
      });
    },
    loadProjet: function loadProjet() {
      var _this4 = this;

      var url = this.domaine + "projet/indicateur/projet";

      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this4.loading = false;
        _this4.listeProjet = response.body.projet;
        // this.listeRapport = response.body.rapport;
      }, function (errRep) {
        _this4.loading = false;
        _this4.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    loadChantierSearch: function loadChantierSearch() {
      var _this5 = this;

      this.loading = true;
      this.listTravauxResult = [];
      this.listChantierResult = [];

      if (this.selectAnneeMonth && this.selectAnnee) {
        this.loading = false;
        this.$message.error("Veuillez sélectionner une période ou une année.");
      } else {

        if (this.selectTravaux != "" && this.selectChantier != "") {
          this.loading = true;

          this.listeTravaux.find(function (item) {
            if (item.id == _this5.selectTravaux) {
              _this5.libelleTravaux = item.libelle;
            }
          });
          var dateSelect = null;
          if (this.selectAnnee) {
            var tabDFin = new Intl.DateTimeFormat('en-GB').format(this.selectAnnee).split("/");
            dateSelect = tabDFin[2];
            this.selectAnneeFormat = tabDFin[2];
          }
          this.selectAnnee = dateSelect;
          var url = this.domaine + "projet/chantier/" + this.selectChantier + "/travaux/" + this.selectTravaux + "/annee/" + dateSelect + "/periode/" + (this.selectAnneeMonth ? this.selectAnneeMonth : null) + "/taches/" + (this.selectTaches ? this.selectTaches : null) + "/rendement";
          this.$http.get(url).then(function (response) {
            if (response.body) {
              _this5.loading = false;
              _this5.showGraph = true;
              _this5.listTravauxResult = response.body.taches;
              _this5.statistique(response.body.statRendet);
            }
          });
        } else {
          this.$message.error("Veuillez sélectionner le chantier et un travaux");
          this.loading = false;
        }
      }
    },
    loadTravaux: function loadTravaux() {
      var _this6 = this;

      this.loading = true;
      this.travauxS = "";
      this.listTravaux = [];
      if (this.selectChantier != "" && this.selectChantier != null) {
        var url = this.domaine + "projet/" + this.selectChantier + "/index/chantier/travaux";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this6.listeTravaux = response.body.travaux;
            _this6.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un chantier");
        this.loading = false;
      }
    },
    onchangeInfo: function onchangeInfo(projetS) {
      var _this7 = this;

      this.listeProjet.find(function (item) {
        if (item.id == projetS) {
          _this7.listeChantier = item.chantier;
        }
      });
    },
    onchangeChantier: function onchangeChantier(chantierS) {
      var _this8 = this;

      this.listeChantier.find(function (item) {
        if (item.id == chantierS) {
          _this8.listeTravaux = item.travauxId;
        }
      });
    },
    loadTaches: function loadTaches() {
      var _this9 = this;

      // this.loading = true;
      var url = this.domaine + "projet/travaux_tache/" + this.selectTravaux + "/index/tache";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this9.listTaches = response.body.tache;
          _this9.loading = false;
        }
      });
    },
    onChangeTravaux: function onChangeTravaux(travaux) {
      var _this10 = this;

      if (travaux && travaux != 'null') {
        this.listeTravaux.find(function (item) {
          if (item.idChantier == travaux) {
            _this10.listTaches = item.travauxId;
          }
        });
      }
    },
    imprimerModePlan: function imprimerModePlan(mode) {
      var url = this.domaine + "projet/chantier/" + this.selectChantier + "/travaux/" + this.selectTravaux + "/annee/" + this.selectAnnee + "/tache/" + (this.selectTaches ? this.selectTaches : null) + "/imprimer/rendement/" + this.user.id + "/" + mode + '/periode/' + (this.selectAnneeMonth ? this.selectAnneeMonth : null);
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      this.dialogueImprimer = false;
      window.open(url);
    }
  },
  mounted: function mounted() {
    this.loadProjet();
  }
});

/***/ }),

/***/ "9BWT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){return _vm.$router.push({ name: 'ParcAuto', path: '/parc/auto' })}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("keyboard_arrow_left")]),_vm._v(" Retour\n        ")],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":"","text-xs-center":""}},[(_vm.typeVehicule == 'flotte')?_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"color":"primary","text-color":"white"}},[_c('v-avatar',{staticClass:"purple darken-4"},[_vm._v(_vm._s(_vm.nbVehTot))]),_vm._v(" Véhicule(s)\n            ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"color":"green","text-color":"white"}},[_c('v-avatar',{staticClass:"green darken-4"},[_vm._v(_vm._s(_vm.nbVehDisp))]),_vm._v(" Disponible(s)\n            ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbVehUtil))]),_vm._v(" En cours utilisation\n            ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"color":"blue-grey ","text-color":"white"}},[_c('v-avatar',{staticClass:"blue-grey  darken-4"},[_vm._v(_vm._s(_vm.nbVehRep))]),_vm._v(" En réparation\n            ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"color":"purple","text-color":"white"}},[_c('v-avatar',{staticClass:"purple darken-4"},[_vm._v(_vm._s(_vm.nbVehLoc))]),_vm._v(" En location\n              ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"color":"red","text-color":"white"}},[_c('v-avatar',{staticClass:"red darken-4"},[_vm._v(_vm._s(_vm.nbVehPan))]),_vm._v(" En panne\n            ")],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.typeVehicule == 'externe')?_c('div',{staticClass:"text-xs-left mb-2"},[_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"color":"primary","text-color":"white"}},[_c('v-avatar',{staticClass:"purple darken-4"},[_vm._v(_vm._s(_vm.nbVehTot))]),_vm._v(" Véhicule(s)\n            ")],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-right mb-2"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newVeh()}},slot:"activator"},[_vm._v("\n                Ajouter "),_c('v-icon',{attrs:{"center":""}},[_vm._v("add")])],1),_vm._v("\n            Ajouter un vehicule\n        ")],1),_vm._v(" "),(_vm.typeVehicule != 'externe')?_c('v-tooltip',{attrs:{"top":""}},[_c('input',{ref:"fileInputExcel",staticStyle:{"display":"none"},attrs:{"name":"fileInputExcel","type":"file","accept":"image/*"},on:{"change":_vm.onFileExcelPicked}}),_vm._v(" "),(true)?_c('v-btn',{attrs:{"slot":"activator","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$refs.fileInputExcel.click()}},slot:"activator"},[_vm._v("\n                    Importer\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_download")])],1):_vm._e(),_vm._v("Importer fichier excel\n            ")],1):_vm._e(),_vm._v(" "),(_vm.typeVehicule != 'externe')?_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogImport=true}},slot:"activator"},[_vm._v("\n                Générer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1):_vm._e(),_vm._v("Générer un modèle\n            ")],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":true,"max-width":"80%","loading":_vm.loading},model:{value:(_vm.dialogAjoutVeh),callback:function ($$v) {_vm.dialogAjoutVeh=$$v},expression:"dialogAjoutVeh"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"flex":"0 0 auto"},attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter /modifier d'un nouveau véhicule ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutVeh = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formVehicule",attrs:{"id":"formVehicule","lazy-validation":"","enctype":"multipart/form-data"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 1,"step":"1"}},[_vm._v("Marque")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 2,"step":"2"}},[_vm._v("Générale")]),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.imageVeh,"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"fileVeh",staticStyle:{"display":"none"},attrs:{"name":"fichVeh","type":"file","accept":"image/*"},on:{"change":_vm.onFileVehPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileVeh.click()}}},[_vm._v("\n                                                            Photo vehicule "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.imageCarteGris,"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"fileCarteGris",staticStyle:{"display":"none"},attrs:{"name":"fichCarteGris","type":"file","accept":"image/*"},on:{"change":_vm.onFileCartePicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileCarteGris.click()}}},[_vm._v("\n                                                            Carte grise "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md8":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Catégorie *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"allow-create":"","filterable":"","clearable":"","placeholder":"Catégorie de véhicule"},on:{"change":function($event){return _vm.chargeSousCat(_vm.formVehicule.categorieId)}},model:{value:(_vm.formVehicule.categorieId),callback:function ($$v) {_vm.$set(_vm.formVehicule, "categorieId", $$v)},expression:"formVehicule.categorieId"}},_vm._l((_vm.listCategorie),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Sous catégorie *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"allow-create":"","filterable":"","clearable":"","placeholder":"Catégorie de véhicule"},on:{"change":_vm.chargeMarque},model:{value:(_vm.formVehicule.sousCategorieId),callback:function ($$v) {_vm.$set(_vm.formVehicule, "sousCategorieId", $$v)},expression:"formVehicule.sousCategorieId"}},_vm._l((_vm.listSousCategorie),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Marque concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"allow-create":"","filterable":"","clearable":"","placeholder":"Marque concerné"},on:{"change":_vm.chargeModele},model:{value:(_vm.formVehicule.marqueId),callback:function ($$v) {_vm.$set(_vm.formVehicule, "marqueId", $$v)},expression:"formVehicule.marqueId"}},_vm._l((_vm.listMarque),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Modèle concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"allow-create":"","filterable":"","clearable":"","placeholder":"Modele concerné"},on:{"change":_vm.chargeSerie},model:{value:(_vm.formVehicule.modeleId),callback:function ($$v) {_vm.$set(_vm.formVehicule, "modeleId", $$v)},expression:"formVehicule.modeleId"}},_vm._l((_vm.listModele),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Série du véhicule *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"allow-create":"","filterable":"","clearable":"","placeholder":"Série du véhicule"},on:{"change":_vm.selectSerie},model:{value:(_vm.formVehicule.serieId),callback:function ($$v) {_vm.$set(_vm.formVehicule, "serieId", $$v)},expression:"formVehicule.serieId"}},_vm._l((_vm.listSerie),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Immatriculation *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"matricule","placeholder":"Immatriculation","required":""},model:{value:(_vm.formVehicule.matricule),callback:function ($$v) {_vm.$set(_vm.formVehicule, "matricule", $$v)},expression:"formVehicule.matricule"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("N° du chassis *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"numChassis","placeholder":"N° du chassis","required":""},model:{value:(_vm.formVehicule.numChassis),callback:function ($$v) {_vm.$set(_vm.formVehicule, "numChassis", $$v)},expression:"formVehicule.numChassis"}})],1)])],1),_vm._v(" "),(_vm.typeVehicule != 'externe')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("N° de la carte grise *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"numCarteGris","placeholder":"N° de la carte grise ","required":""},model:{value:(_vm.formVehicule.numCarteGris),callback:function ($$v) {_vm.$set(_vm.formVehicule, "numCarteGris", $$v)},expression:"formVehicule.numCarteGris"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Code parc ")]),_vm._v(" "),_c('el-input',{attrs:{"name":"codeParc","placeholder":"Code du parc","required":""},model:{value:(_vm.formVehicule.codeParc),callback:function ($$v) {_vm.$set(_vm.formVehicule, "codeParc", $$v)},expression:"formVehicule.codeParc"}})],1)])],1):_vm._e()],1)],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutVeh = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v(" Continuer "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("navigate_next")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date d'acquisition *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"value-format":"dd-MM-yyyy","name":"dateAqui","type":"date","placeholder":"Date d'acquisition"},model:{value:(_vm.formVehicule.dateAqui),callback:function ($$v) {_vm.$set(_vm.formVehicule, "dateAqui", $$v)},expression:"formVehicule.dateAqui"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de carburant *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Type de carburant"},model:{value:(_vm.formVehicule.typeCarbuId),callback:function ($$v) {_vm.$set(_vm.formVehicule, "typeCarbuId", $$v)},expression:"formVehicule.typeCarbuId"}},_vm._l((_vm.typeCarburant),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nombre de place *")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","name":"nbPlace","placeholder":"Nombre de place","required":""},model:{value:(_vm.formVehicule.nbPlace),callback:function ($$v) {_vm.$set(_vm.formVehicule, "nbPlace", $$v)},expression:"formVehicule.nbPlace"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Kilométrage Compteur (Km/h) *")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","name":"kilometrage","placeholder":"Kilométrage (Km/h)","required":""},model:{value:(_vm.formVehicule.kilometrage),callback:function ($$v) {_vm.$set(_vm.formVehicule, "kilometrage", $$v)},expression:"formVehicule.kilometrage"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix d'achat ")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","name":"prixAchat","placeholder":"Prix d'achat du vehicule ","required":""},model:{value:(_vm.formVehicule.prixAchat),callback:function ($$v) {_vm.$set(_vm.formVehicule, "prixAchat", $$v)},expression:"formVehicule.prixAchat"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Coût utilisation (par jour) ")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","name":"coutUtil","placeholder":"Cout d'utilisation du vehicule ","required":""},model:{value:(_vm.formVehicule.coutUtil),callback:function ($$v) {_vm.$set(_vm.formVehicule, "coutUtil", $$v)},expression:"formVehicule.coutUtil"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Couleur *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"couleur","placeholder":"Couleur","required":""},model:{value:(_vm.formVehicule.couleur),callback:function ($$v) {_vm.$set(_vm.formVehicule, "couleur", $$v)},expression:"formVehicule.couleur"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Affecter un parc auto *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","allow-create":"","filterable":"","placeholder":"Affecter un parc auto"},model:{value:(_vm.formVehicule.parcId),callback:function ($$v) {_vm.$set(_vm.formVehicule, "parcId", $$v)},expression:"formVehicule.parcId"}},_vm._l((_vm.listParc),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Année du vehicule ")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"value-format":"yyyy","name":"annVeh","type":"year","placeholder":"Année du vehicule"},model:{value:(_vm.formVehicule.annVeh),callback:function ($$v) {_vm.$set(_vm.formVehicule, "annVeh", $$v)},expression:"formVehicule.annVeh"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ratio théorique ")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","min":"0","name":"ratio","placeholder":"Consommation théorique","required":""},model:{value:(_vm.formVehicule.ratio),callback:function ($$v) {_vm.$set(_vm.formVehicule, "ratio", $$v)},expression:"formVehicule.ratio"}})],1)])],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutVeh = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 1}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("navigate_before")]),_vm._v(" Précédent ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.formVehIsValid},nativeOn:{"click":function($event){return _vm.createVeh(_vm.idVehModif)}}},[_vm._v("\n                                        Enrregistrer "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"40%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuppVeh),callback:function ($$v) {_vm.dialogSuppVeh=$$v},expression:"dialogSuppVeh"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-xs-center"},[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Supprimer un vehicule")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"outline":"","color":"orange darken-1","icon":"warning","value":true}},[_vm._v("\n                        La suppression d'un vehicule est irréversible.\n                    ")])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{on:{"click":function($event){$event.stopPropagation();_vm.dialogSuppVeh = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteVeh()}}},[_vm._v("Supprimer\n                ")])],1)],1)],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[(_vm.typeVehicule == 'flotte')?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"valeurSelect","id":"valeurSelect","clearable":"","placeholder":"Rechercher par parc auto"},on:{"change":function($event){return _vm.loadTypeVehicule()}},model:{value:(_vm.selectParc),callback:function ($$v) {_vm.selectParc=$$v},expression:"selectParc"}},_vm._l((_vm.listParc),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-2",attrs:{"xs9":""}},[(_vm.typeVehicule == 'flotte')?_c('el-select',{attrs:{"placeholder":"Filtrer la liste"},on:{"change":_vm.filtrerVehicule},model:{value:(_vm.selectEtatVeh),callback:function ($$v) {_vm.selectEtatVeh=$$v},expression:"selectEtatVeh"}},_vm._l((_vm.comboEtatVeh),function(item){return _c('el-option',{key:item.etat,attrs:{"label":item.label,"value":item.etat}})}),1):_vm._e()],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs2":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"green","disabled":_vm.disabledBtnExc,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeExcFlotte(_vm.selectEtatVeh)}},slot:"activator"},[_vm._v("\n                        Imprimer Excel "),_c('v-icon',[_vm._v("printer")])],1),_vm._v("\n                        Imprimer la liste des vehicules\n                    ")],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs2":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","disabled":_vm.disabledBtnExc,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeFlotte(_vm.selectEtatVeh)}},slot:"activator"},[_vm._v("\n                        Imprimer "),_c('v-icon',[_vm._v("printer")])],1),_vm._v("\n                        Imprimer la liste des vehicules\n                    ")],1)],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"elevation-3",attrs:{"slot":"activator","dark":"","icon":"","flat":"","color":"primary"},on:{"click":function($event){return _vm.loadVehicule('flotte')}},slot:"activator"},[_c('v-icon',[_vm._v("cached")])],1),_vm._v("\n                    actualiser la liste\n                ")],1)],1)],1),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listVehicule}},[_c('el-table-column',{attrs:{"prop":"codeParc","label":"Code parc / Parc"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                        "+_vm._s(scope.row.codeParc)+" /  "+_vm._s(scope.row.parc)+"\n                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"categorie","label":"Catégorie / Sous-catégorie"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"indigo"}},[_vm._v("\n                        "+_vm._s(scope.row.categorie)+" / "+_vm._s(scope.row.sousCategorie)+"\n                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"matricule","label":"Immatriculation / Marque"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                        "+_vm._s(scope.row.matricule)+" / "+_vm._s(scope.row.marque)),_c('v-icon',{attrs:{"right":""}},[_vm._v("directions_car")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"marque","label":"Modèle / Série"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.modele)+" / "+_vm._s(scope.row.serie)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                        DISPONIBLE "),_c('v-icon',[_vm._v("directions_bus")])],1):(scope.row.etat == 2)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                        EN MISSION "),_c('v-icon',[_vm._v("directions_bus")])],1):(scope.row.etat == 3)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                        EN PANNE "),_c('v-icon',[_vm._v("directions_bus")])],1):(scope.row.etat == 4)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                        EN REPARATION "),_c('v-icon',[_vm._v("directions_bus")])],1):(scope.row.etat == 5)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"purple"}},[_vm._v("\n                        EN LOCATION "),_c('v-icon',[_vm._v("directions_bus")])],1):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.$router.push({name: 'FicheVehicule', params:{id: scope.row.idVeh}})}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                      Détails\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editVeh(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                      Modifier\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){return _vm.confSuppVeh(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                      Supprimer\n                    ")],1)],1)]}}])})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogImport),callback:function ($$v) {_vm.dialogImport=$$v},expression:"dialogImport"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h4',[_vm._v("ATTENTION:"),_c('br'),_vm._v("La colonne 'TYPE CARBURANT' doit contenir uniquement l'un des éléments suivant: ")]),_vm._v(" "),_c('i',{attrs:{"align":"center"}},[_vm._v("-Essence")]),_vm._v(",          \n        "),_c('i',{attrs:{"align":"center"}},[_vm._v("-Diesel")]),_c('br'),_vm._v(" "),_c('h4',[_vm._v("La colonne 'CATEGORIE DE VEHICULE' doit contenir uniquement l'un des éléments suivant:")]),_vm._v(" "),_c('i',{attrs:{"align":"center"}},[_vm._v("-Fonction")]),_vm._v(",         \n        "),_c('i',{attrs:{"align":"center"}},[_vm._v("-Transport")]),_vm._v(",\n        "),_c('i',{attrs:{"align":"center"}},[_vm._v("-Lourd")]),_vm._v(",\n        "),_c('i',{attrs:{"align":"center"}},[_vm._v("-Très lourd")]),_vm._v(",\n        "),_c('i',{attrs:{"align":"center"}},[_vm._v("-Leger")]),_vm._v(",\n        "),_c('i',{attrs:{"align":"center"}},[_vm._v("-Remorque")]),_vm._v(",\n        "),_c('i',{attrs:{"align":"center"}},[_vm._v("-Tracteur")]),_c('br'),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogImport = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.generateFileExcel()}}},[_vm._v("Généner "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"overlay":true,"scrollable":"","persistent":"","max-width":"92%"},model:{value:(_vm.showModalLoadVehicule),callback:function ($$v) {_vm.showModalLoadVehicule=$$v},expression:"showModalLoadVehicule"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Importation des véhicules ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.showModalLoadVehicule =false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('data-tables',{attrs:{"data":_vm.listVehiculeImport,"width":"100%"}},[_c('el-table-column',{attrs:{"prop":"categorie","label":"CATEGORIE","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                      "+_vm._s(scope.row.categorie)+"\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sousCategorie","label":"SOUS CATEGORIE","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                      "+_vm._s(scope.row.sousCategorie)+"\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"TYPE CARBURANT","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":""}},[_vm._v("\n                                      "+_vm._s(scope.row.type)+"\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"codeParc","label":"CODE PARC","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":""}},[_vm._v("\n                                      "+_vm._s(scope.row.codeParc)+"\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"parc","label":"PARC","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":""}},[_vm._v("\n                                      "+_vm._s(scope.row.parc)+"\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"immatriculation","label":"IMMATRICULATION","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                      "+_vm._s(scope.row.immatriculation)+"\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"marque","label":"MARQUE","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":""}},[_vm._v("\n                                      "+_vm._s(scope.row.marque)+"\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"modele","label":"MODELE","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":""}},[_vm._v("\n                                      "+_vm._s(scope.row.modele)+"\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serie","label":"SERIE","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":""}},[_vm._v("\n                                      "+_vm._s(scope.row.serie)+"\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chassi","label":"N° CHASSIS","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                      "+_vm._s(scope.row.chassi)+"\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"carteG","label":"CARTE GRISE","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                      "+_vm._s(scope.row.carteG)+"\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"place","label":"NOMBRE DE PLACE","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                      "+_vm._s(scope.row.place)+"\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"kilometrage","label":"KILOMETRAGE","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                      "+_vm._s(scope.row.kilometrage)+"\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"DATE D'ACQUISITION","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                      "+_vm._s(scope.row.date)+"\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"achat","label":"PRIX D'ACHAT","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                      "+_vm._s(new Intl.NumberFormat().format(scope.row.achat))+" XOF\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cout","label":"COÜT D'UTILISATION/JOUR","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                      "+_vm._s(new Intl.NumberFormat().format(scope.row.cout))+" XOF\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"couleur","label":"COULEUR","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                      "+_vm._s(scope.row.couleur)+"\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"annee","label":"ANNEE DU VEHIUCLE","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                      "+_vm._s(scope.row.annee)+"\n                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ratio","label":"RATIO THEORIQUE","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                      "+_vm._s(scope.row.ratio)+"\n                                  ")])]}}])})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.showModalLoadVehicule = false}}},[_vm._v("\n                  Annuler\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.saveListe()}}},[_vm._v("\n                  Enregistrer\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9BzK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListePrestataire_vue__ = __webpack_require__("PCFD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_488e3a57_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListePrestataire_vue__ = __webpack_require__("IFhl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListePrestataire_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_488e3a57_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListePrestataire_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9DBo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Hs7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9JC9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"blue","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.showModalNewUser();}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n                            Ajouter un nouveau responsable\n                        ")],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutResponsable),callback:function ($$v) {_vm.dialogAjoutResponsable=$$v},expression:"dialogAjoutResponsable"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter un technicien")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modifier un technicien   ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutResponsable = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enregistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-form',{ref:"formUser",attrs:{"lazy-validation":"","id":"formUser"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('div',[_c('v-flex',{attrs:{"text-xs-center":"","layout":"","align-center":"","justify-center":""}},[(_vm.dialogEdit != true)?_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"list-type":"picture-card","name":"photo","action":"","auto-upload":false}},[_c('i',{staticClass:"el-icon-plus"})]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"list-type":"picture-card","name":"photo","action":"","auto-upload":false}},[(_vm.responsable.urlImg)?_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":_vm.responsable.urlImg,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":_vm.logoUser,"alt":""}})]):_vm._e()],1)],1)])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-col',[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Nom et prénoms","name":"nomUser","rules":_vm.nomUserRules,"counter":4,"required":""},model:{value:(_vm.responsable.nom),callback:function ($$v) {_vm.$set(_vm.responsable, "nom", $$v)},expression:"responsable.nom"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Login de connexion","name":"loginUser","rules":[function (v) { return !!v || 'Le login est obligatoire'; }],"required":""},model:{value:(_vm.responsable.login),callback:function ($$v) {_vm.$set(_vm.responsable, "login", $$v)},expression:"responsable.login"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"E-mail","name":"emailUser","rules":_vm.loginUserRules,"counter":6,"required":""},model:{value:(_vm.responsable.email),callback:function ($$v) {_vm.$set(_vm.responsable, "email", $$v)},expression:"responsable.email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"name":"contactUser","min":"0","label":"Contact","counter":8,"rules":_vm.contactUserRules,"hint":"Exemple: 00-00-00-00","persistent-hint":"","required":""},model:{value:(_vm.responsable.contact),callback:function ($$v) {_vm.$set(_vm.responsable, "contact", $$v)},expression:"responsable.contact"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Fonction occupée","name":"fonctionUser","counter":6,"required":""},model:{value:(_vm.responsable.fonction),callback:function ($$v) {_vm.$set(_vm.responsable, "fonction", $$v)},expression:"responsable.fonction"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"label":"Services","name":"serviceUser","items":_vm.listService,"rules":_vm.serviceUserRules,"item-value":"id","item-text":"libelle"},model:{value:(_vm.responsable.serviceId),callback:function ($$v) {_vm.$set(_vm.responsable, "serviceId", $$v)},expression:"responsable.serviceId"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"label":"Selectionner une corps de metier","name":"domaineUser","items":_vm.listeDomaine,"rules":_vm.serviceUserRules,"item-value":"id","item-text":"libelle"},model:{value:(_vm.responsable.domaineId),callback:function ($$v) {_vm.$set(_vm.responsable, "domaineId", $$v)},expression:"responsable.domaineId"}})],1)],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                            PARAMETRE DE CONNEXION\n                                                        ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[(_vm.dialogEdit != true)?_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpUser","label":"Mot de passe","rules":_vm.mdpUserRules,"counter":4,"required":""},model:{value:(_vm.responsable.password),callback:function ($$v) {_vm.$set(_vm.responsable, "password", $$v)},expression:"responsable.password"}})],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit != true)?_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpVerUser","label":"Confirmer le mot de passe","rules":_vm.mdpVerUserRules,"counter":4,"required":""},model:{value:(_vm.responsable.confirmePassword),callback:function ($$v) {_vm.$set(_vm.responsable, "confirmePassword", $$v)},expression:"responsable.confirmePassword"}})],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpUserConnect","label":"Votre mot de passe","rules":_vm.mdpUserConnectRules,"counter":4,"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1):_vm._e()],1)],1)],1)])],1)],1),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":_vm.clear}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid},on:{"click":_vm.submitUser}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer cet enregistrement ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteUser($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogRole),callback:function ($$v) {_vm.dialogRole=$$v},expression:"dialogRole"}},[_c('v-card',[_c('v-toolbar',{staticClass:"orange",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter des droits d'accès")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogRole = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n            ATTRIBUER DES ROLES A L'UTILISATEUR\n          ")])],1),_vm._v(" "),_c('v-form',{ref:"formRole",attrs:{"lazy-validation":"","id":"formRole"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Accès au dasbord")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","multiple":"","placeholder":"Catégorie"},model:{value:(_vm.menuSele),callback:function ($$v) {_vm.menuSele=$$v},expression:"menuSele"}},_vm._l((_vm.menu),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Attribuer des roles")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","multiple":"","placeholder":"Catégorie"},model:{value:(_vm.role),callback:function ($$v) {_vm.role=$$v},expression:"role"}},_vm._l((_vm.roles),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.description,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogRole = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.menuSele.length !== 0)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":_vm.submitRole}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-container',[_c('v-card',[_c('v-card-text',[_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                    LISTE DES TECHNICIENS "),_c('v-icon',{attrs:{"right":""}},[_vm._v("accessibility")])],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('div',{staticClass:"grid-content bg-purple-light"},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeTech('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeTech('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnTech,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                                            ")])],1)],1)],1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('data-tables',{attrs:{"data":_vm.listeTechnicien}},[_c('el-table-column',{attrs:{"prop":"avatar","label":"Avatar","fixed":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nom","label":"Nom et prenoms"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"login","label":"Login"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"contact","label":"Contact"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.admin_profil_update_user)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.showModalEditUser(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                                            Editer\n                                        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.role_user)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.newRole(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("vpn_key")])],1):_vm._e(),_vm._v("\n                                            Droit d'accès\n                                        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.user_delete)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.itemUser = scope.row;_vm.dialogSupr = true;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                                            Supprimer\n                                        ")],1)]}}])})],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Tei":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationDmdCom_vue__ = __webpack_require__("JMMz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16405ad9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationDmdCom_vue__ = __webpack_require__("WyDN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationDmdCom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16405ad9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationDmdCom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9Voz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9W7p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalComparateurCmd_vue__ = __webpack_require__("MMZU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fd1afe4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalComparateurCmd_vue__ = __webpack_require__("NIRu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalComparateurCmd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fd1afe4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalComparateurCmd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9bKt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9mGq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Keywords_vue__ = __webpack_require__("1VJv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1adaa26d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Keywords_vue__ = __webpack_require__("kBig");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Keywords_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1adaa26d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Keywords_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9zqR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_boardProjet_dashboardProjet__ = __webpack_require__("jg7/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Oq2I");
__webpack_require__("miEh");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */], DashboardProjet: __WEBPACK_IMPORTED_MODULE_2__components_boardProjet_dashboardProjet__["a" /* default */] },
  name: "ListeProjet",
  props: {
    listeProjets: {
      type: Array
    }
  },

  data: function data() {
    return {
      //data general
      loading: false,
      detailProjet: {},
      showDetailProjet: false
    };
  },

  computed: {},
  methods: {
    modalDetail: function modalDetail(item) {
      this.detailProjet = item;
      this.showDetailProjet = true;
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "A1l2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Liste des contrats des employés")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-expansion-panel',{attrs:{"focusable":"","popout":"","value":"0"}},[_c('v-expansion-panel-content',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-toolbar',{attrs:{"color":"green","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.contratsEnCours.length)+" contrats(s) en cours")]),_vm._v(" "),_c('v-spacer')],1)]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"green lighten-5"},[(_vm.contratsEnCours.length > 0)?_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},_vm._l((_vm.contratsEnCours),function(contrt){return _c('v-flex',{attrs:{"xs12":"","md3":"","mb-3":"","pl-2":""}},[_c('modelCarteContrat',{attrs:{"contrat":contrt},on:{"contAnnule":function($event){return _vm.loadContrat()},"detailEmpl":_vm.showDetailEmploye}})],1)}),1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-toolbar',{attrs:{"color":"orange","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.contratsArenouveller.length)+" contrats(s) à renouveler ")]),_vm._v(" "),_c('v-spacer')],1)]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"orange lighten-5"},[(_vm.contratsArenouveller.length > 0)?_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},_vm._l((_vm.contratsArenouveller),function(contratAr){return _c('v-flex',{attrs:{"xs12":"","md3":"","mb-3":"","pl-2":""}},[_c('modelCarteContrat',{attrs:{"contrat":contratAr},on:{"contAnnule":function($event){return _vm.loadContrat()},"detailEmpl":_vm.showDetailEmploye}})],1)}),1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-toolbar',{attrs:{"color":"red","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.contratsExpire.length)+" contrats(s) expiré(s)")]),_vm._v(" "),_c('v-spacer')],1)]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"red lighten-5"},[(_vm.contratsExpire.length > 0)?_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},_vm._l((_vm.contratsExpire),function(contratEx){return _c('v-flex',{attrs:{"xs12":"","md3":"","mb-3":"","pl-2":""}},[_c('modelCarteContrat',{attrs:{"contrat":contratEx},on:{"contAnnule":function($event){return _vm.loadContrat()},"detailEmpl":_vm.showDetailEmploye}})],1)}),1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"color":"blue"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-toolbar',{attrs:{"color":"blue","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.contratsInactif.length)+" contrats(s) inactif(s)")]),_vm._v(" "),_c('v-spacer')],1)]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"blue lighten-5"},[(_vm.contratsInactif.length > 0)?_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},_vm._l((_vm.contratsInactif),function(contratInact){return _c('v-flex',{attrs:{"xs12":"","md3":"","mb-3":"","pl-2":""}},[_c('modelCarteContrat',{attrs:{"contrat":contratInact},on:{"contAnnule":function($event){return _vm.loadContrat()},"detailEmpl":_vm.showDetailEmploye}})],1)}),1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-toolbar',{attrs:{"color":"grey","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.contratsAnnule.length)+" contrats(s) annulé(s)")]),_vm._v(" "),_c('v-spacer')],1)]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-5"},[(_vm.contratsAnnule.length > 0)?_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},_vm._l((_vm.contratsAnnule),function(contratAn){return _c('v-flex',{attrs:{"xs12":"","md3":"","mb-3":"","pl-2":""}},[_c('modelCarteContrat',{attrs:{"contrat":contratAn},on:{"contAnnule":function($event){return _vm.loadContrat()},"detailEmpl":_vm.showDetailEmploye}})],1)}),1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('modalDetailEmploye',{attrs:{"show":_vm.showDetailEmpl,"userIdContrat":_vm.employSelect},on:{"close":function($event){_vm.showDetailEmpl = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AA+V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ABW1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */] },
  name: "ModalValidationDex",
  props: ["show", "detailCommande", "totalMontant"],
  data: function data() {
    var _ref;

    return _ref = {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      dialogDetail: false,
      listeTacheSupp: [],
      dialogSupr: false,
      index: '',
      indexRow: '',
      indexLigne: '',
      indexRowLigne: '',
      dialogVisible: false,
      dialogConfirmRefus: false,
      logoPdf: "/static/pdf.png",
      dialogConfirm: false,
      formRefus: {},
      items: []
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "index", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "urlImage", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "ruleFormRefus", {
      rapportRefus: [{ required: true, message: "Veuillez saisir" }]
    }), _ref;
  },


  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogDetail = newValue;
      this.urlImage = this.detailCommande.urlImage;
      console.log("detailCommande", this.detailCommande);

      if (newValue == true) {
        //this.loadDevisConstat()
      }
    }
  },

  methods: {
    successNotif: function successNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      this.$notify({
        title: "ENREGISTREMENT REUSSI",
        message: mess,
        type: "success",
        position: "top-center"
      });
    },
    showDiapo: function showDiapo(images, ind, image) {
      this.items = images;
      this.index = ind;
    },
    closeDialog: function closeDialog() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      console.log("item", item);
      if (item == "images") {
        this.index = null;
      } else {
        this.$emit("close", this.detailCommande.id, "bonCommandeInterne");
      }
    },
    deleteBesoin: function deleteBesoin() {
      this.this.listeTacheSupp = [];
      if (this.detailCommande.option[this.indexLigne].id != null) {
        this.listeTacheSupp.push(this.detailCommande.option[this.indexLigne].id);
      }
      this.indexRowLigne.splice(this.indexLigne, 1);
      this.dialogSupr = false;
    },
    deleteRow: function deleteRow(index, rows) {
      this.indexLigne = index;
      this.indexRowLigne = rows;
    },
    SubmitValideDevis: function SubmitValideDevis(item) {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "besoin/avalider/bci/nivau1";

      var data = new FormData();
      data.append("decision", item == "confirme" ? 1 : 0);
      data.append("commDec", this.formRefus.rapport);
      data.append("idUser", this.user.id);
      data.append("bci", this.detailCommande.id);
      data.append("listeSupp", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.listeTacheSupp));
      // on recupere le tableau
      for (var prop in this.detailCommande.option) {
        var ligne = this.detailCommande.option[prop];
        data.append("options[id][]", ligne.id);
        data.append("options[qte][]", ligne.qte);
      }
      this.$http.post(url, data).then(function (response) {
        _this.loading = false;
        _this.dialogConfirmRefus = false;
        _this.dialogConfirm = false;
        _this.formRefus.rapport = "";
        _this.successNotif(response.body.message);
        _this.closeDialog();
      }, function (errResp) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors de la validation de la mission");
      });
    },
    SubmitRefusDevis: function SubmitRefusDevis() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "besoin/avalider/bci/nivau1";
      var data = new FormData();
      data.append("decision", item == "confirme" ? 1 : 0);
      data.append("commDec", this.formRefus.rapport);
      data.append("bci", this.detailCommande.id);
      data.append("user", this.user.id);

      this.$http.post(url, data).then(function (response) {
        _this2.loading = false;
        _this2.successNotif(response.body.message);
        _this2.dialogConfirmRefus = false;
        _this2.closeDialog();
      }, function (errResp) {
        _this2.loading = false;
        _this2.$message.error("Une erreur est survenue lors du refus de la demande de mission");
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "AV5A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n              TABLEAU COMPARATIF DES PROJETS\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{staticClass:"elevation-12 pt-1 mb-3",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('h3',[_vm._v("Critères de recherche")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"model":_vm.formTri,"id":"formTri"}},[_c('el-form-item',{attrs:{"label":"Projet","width":"400px"}},[_c('el-select',{staticClass:"custom-select",attrs:{"filterable":"","multiple":"","clearable":"","collapse-tags":"","placeholder":"Projet"},on:{"change":function($event){return _vm.onchangeInfo(_vm.selectProjet)}},model:{value:(_vm.selectProjet),callback:function ($$v) {_vm.selectProjet=$$v},expression:"selectProjet"}},_vm._l((_vm.listProjetDepense),function(item){return _c('el-option',{key:item.idProjet,attrs:{"label":item.libelleProjet,"value":item.idProjet}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Numéro de compte"}},[_c('el-select',{staticClass:"custom-select",attrs:{"clearable":"","filterable":"","multiple":"","placeholder":"Numéro de compte"},on:{"change":function($event){return _vm.onchangeCompte(_vm.selectPlan)}},model:{value:(_vm.selectPlan),callback:function ($$v) {_vm.selectPlan=$$v},expression:"selectPlan"}},_vm._l((_vm.listPlanComptable),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Période"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"datetimerange","range-separator":"à","start-placeholder":"Début date","end-placeholder":"Fin date"},model:{value:(_vm.selectAnnee),callback:function ($$v) {_vm.selectAnnee=$$v},expression:"selectAnnee"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","color":"blue","fab":"","small":""},on:{"click":function($event){return _vm.loadChantierSearch()}},slot:"activator"},[_c('v-icon',[_vm._v("search")])],1),_vm._v("\n                      Effectuer une recherche\n                    ")],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newImporter()}},slot:"activator"},[_vm._v("\n                  Importer\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_download")])],1):_vm._e(),_vm._v("Importer fichier excel\n              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.generateFileExcel()}},slot:"activator"},[_vm._v("\n                  Générer\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1):_vm._e(),_vm._v("Générer un modèle\n              ")],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{staticClass:"mb-2",attrs:{"row":""}},[(_vm.showRecherche)?_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"warning"}},[_vm._v("\n                RESULATS DE LA RECHERCHE\n              ")]):_vm._e(),_vm._v(" "),(_vm.showRecherche && _vm.projetsSelectionnes.length > 0)?_c('div',[_c('h3',[_vm._v("Projets sélectionnés :")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-wrap":"wrap","gap":"8px"}},_vm._l((_vm.projetsSelectionnes),function(projet,index){return _c('v-chip',{key:index,staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"success"}},[_vm._v("\n                    "+_vm._s(projet)+"\n                  ")])}),1)]):_vm._e(),_vm._v(" "),(_vm.showRecherche && _vm.plansSelectionnes.length > 0)?_c('div',[_c('h3',[_vm._v("Plans comptables sélectionnés :")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-wrap":"wrap","gap":"8px"}},_vm._l((_vm.plansSelectionnes),function(projet,index){return _c('v-chip',{key:index,staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"info"}},[_vm._v("\n                    "+_vm._s(projet)+"\n                  ")])}),1)]):_vm._e(),_vm._v(" "),(_vm.showRecherche && _vm.selectAnnee && _vm.selectAnnee != '')?_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("PÉRIODE DU "+_vm._s(_vm.selectAnnee ? _vm.selectAnnee[0] : "")+" au\n                "+_vm._s(_vm.selectAnnee ? _vm.selectAnnee[1] : ""))]):_vm._e()],1),_vm._v(" "),(!_vm.hideInterface)?_c('v-layout',{staticClass:"mb-2",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"teal lighten-1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xs12":""}},[_c('div',[_vm._v("NOMBRE TOTAL DE PROJETS")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v("\n                          "+_vm._s(new Intl.NumberFormat().format(
                              _vm.totalInfo.nombreTotalProjets
                            ))+"\n                        ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"indigo lighten-1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xs12":""}},[_c('div',[_vm._v("MONTANT TOTAL DES MARCHÉS")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v("\n                          "+_vm._s(new Intl.NumberFormat().format(
                              _vm.totalInfo.totalMontantMarche
                            ))+"\n                          XOF\n                        ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"brown lighten-1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xs12":""}},[_c('div',[_vm._v("BUDGET TOTAL")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v("\n                          "+_vm._s(new Intl.NumberFormat().format(
                              _vm.totalInfo.totalBudget
                            ))+"\n                          XOF\n                        ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"red darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xs12":""}},[_c('div',[_vm._v("MONTANT TOTAL DÉCAISSÉ")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v("\n                          "+_vm._s(new Intl.NumberFormat().format(
                              _vm.totalInfo.totalMontantDepenses
                            ))+"\n                          XOF\n                        ")])])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.hideInterface)?_c('v-layout',{staticClass:"mb-2",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"green darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xs12":""}},[_c('div',[_vm._v("CHIFFRE D'AFFAIRES ENCAISSÉ")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v("\n                          "+_vm._s(new Intl.NumberFormat().format(
                              _vm.totalInfo.totalMontantEncaisse
                            ))+"\n                          XOF\n                        ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"green darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xs12":""}},[_c('div',[_vm._v("\n                          MARGE TOTALE (MONTANT MARCHÉ - MONTANT DÉCAISSÉ)\n                        ")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v("\n                          "+_vm._s(new Intl.NumberFormat().format(
                              _vm.totalInfo.totalMarges
                            ))+"\n                          XOF\n                        ")])])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.hideInterface)?_c('v-layout',{staticClass:"mb-2",attrs:{"row":""}},[_c('div',{ref:"bar_chart",staticClass:"chart"})]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.hideInterface)?_c('v-layout',{staticClass:"mb-2",attrs:{"row":""}},[_c('div',{ref:"chart",staticStyle:{"width":"100%","height":"400px"}})]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{staticClass:"mb-2",attrs:{"row":""}},[_c('div',{ref:"trans",staticStyle:{"width":"100%","height":"400px"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[(_vm.listTravauxResult.length > 0)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogueImprimer = true}},slot:"activator"},[_vm._v("\n                        Exporter en Pdf\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("Pdf\n                    ")],1)],1):_vm._e(),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listTravauxResult,"summary-method":_vm.calculateSummaries,"show-summary":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',{staticClass:"elevation-3 pl-4 pr-4 pt-2"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple mb-2"},[_c('div',[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("LISTE PAR NUMERO DE COMPTE ")])],1),_vm._v(" "),_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":props.row.marche,"align":"center","summary-method":_vm.calculateSummaries,"show-summary":"","height":"550"}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',{staticClass:"elevation-3 pl-4 pr-4 pt-2"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple mb-2"},[_c('div',[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("LISTE DES\n                                                  TRANSACTIONS")])],1),_vm._v(" "),_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":props.row.depenses,"align":"center","summary-method":_vm.calculateSummaries,"show-summary":"","height":"550"}},[_c('el-table-column',{attrs:{"prop":"date","label":"Date","align":"center","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"green"}},[_vm._v(_vm._s(scope.row.date))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleDepense","label":"Libellé de l'opération","align":"center","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row
                                                          .libelleDepense))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"MOUVEMENTS","align":"center"}},[_c('el-table-column',{attrs:{"prop":"montantD","label":"DÉBITS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                                            scope.row.montantD
                                                          ))+"\n                                                        XOF\n                                                      ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantC","label":"CRÉDITS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                                            scope.row.montantC
                                                          ))+"\n                                                        XOF\n                                                      ")])]}}],null,true)})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"SOLDES","align":"center"}},[_c('el-table-column',{attrs:{"prop":"soldeD","label":"DÉBITEURS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                                            scope.row.soldeD
                                                          ))+"\n                                                        XOF\n                                                      ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"soldeC","label":"CRÉDITEURS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                                            scope.row.soldeC
                                                          ))+"\n                                                        XOF\n                                                      ")])]}}],null,true)})],1)],1)],1)])])],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleCompte","label":"NUMÉRO DE COMPTE","align":"center","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.code)+"\n                                        "+_vm._s(scope.row.libelleCompte))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"MOUVEMENTS","align":"center"}},[_c('el-table-column',{attrs:{"prop":"totalMontantD","label":"DÉBIT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                              scope.row.totalMontantD
                                            ))+"\n                                          XOF\n                                        ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalMontantC","label":"CRÉDIT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                              scope.row.totalMontantC
                                            ))+"\n                                          XOF\n                                        ")])]}}],null,true)})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"SOLDES","align":"center"}},[_c('el-table-column',{attrs:{"prop":"totalSoldeD","label":"TOTAL DÉBITEURS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                              scope.row.totalSoldeD
                                            ))+"\n                                          XOF")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalSoldeC","label":"TOTAL CRÉDITEURS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                              scope.row.totalSoldeC
                                            ))+"\n                                          XOF")])]}}],null,true)})],1)],1)],1)])])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleProjet","label":"LIBELLÉ PROJET","align":"center","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.libelleProjet))])]}}])}),_vm._v(" "),(!_vm.hideInterface)?_c('el-table-column',{attrs:{"label":"ÉVOLUTION PHYSIQUE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-progress-circular',{attrs:{"size":80,"width":15,"rotate":360,"value":scope.row.evolution,"color":"orange"}},[_vm._v(_vm._s(scope.row.evolution)+" %")])]}}],null,false,2151128951)}):_vm._e(),_vm._v(" "),(!_vm.hideInterface)?_c('el-table-column',{attrs:{"label":"MONTANT DU MARCHÉ ","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                              scope.row.montantMarche
                            ))+"\n                          XOF\n                        ")])]}}],null,false,1911460497)}):_vm._e(),_vm._v(" "),(!_vm.hideInterface)?_c('el-table-column',{attrs:{"label":"BUDGET ESTIMATIF ","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.budget))+"\n                          XOF\n                        ")])]}}],null,false,2329928455)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"label":"MOUVEMENTS","align":"center"}},[_c('el-table-column',{attrs:{"prop":"montantD","label":"DÉBIT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                scope.row.montantD
                              ))+"\n                            XOF\n                          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantC","label":"CRÉDIT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                scope.row.montantC
                              ))+"\n                            XOF\n                          ")])]}}])})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"SOLDES","align":"center"}},[_c('el-table-column',{attrs:{"prop":"soldeDebit","label":"DÉBITEURS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                scope.row.soldeDebit
                              ))+"\n                            XOF")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"soldeCredit","label":"CRÉDITEURS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                scope.row.soldeCredit
                              ))+"\n                            XOF\n                          ")])]}}])})],1),_vm._v(" "),(!_vm.hideInterface)?_c('el-table-column',{attrs:{"label":"MARGE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"NumberFormat","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.marge))+"\n                          XOF\n                        ")])]}}],null,false,2982378450)}):_vm._e()],1),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialogShowGraph),callback:function ($$v) {_vm.dialogShowGraph=$$v},expression:"dialogShowGraph"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Détails du projet")]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Voici plus de détails sur les projets.")])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Fermer")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogueImprimer),callback:function ($$v) {_vm.dialogueImprimer=$$v},expression:"dialogueImprimer"}},[_c('v-card',[_c('div',{staticStyle:{"flex":"1 1 auto"}})]),_vm._v(" "),_c('v-btn',{staticClass:"blue",attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogueImprimer = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"40%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogNewImporter),callback:function ($$v) {_vm.dialogNewImporter=$$v},expression:"dialogNewImporter"}},[_c('v-card',[_c('v-toolbar',{staticClass:"info darken-4",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Importer des données")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogNewImporter = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h4',{staticStyle:{"color":"red"},attrs:{"align":"center"}},[_vm._v("\n          Nb : Veuillez vous assurer d'avoir respecté les critères du fichier\n          avant l'importation.\n        ")]),_vm._v(" "),_c('h4',{staticStyle:{"color":"red"},attrs:{"align":"center"}},[_vm._v("\n          -> Formatez la colonne de date sous le format \"Date courte\"\n          (JJ/MM/AAAA).\n        ")]),_vm._v(" "),_c('h4',{staticStyle:{"color":"red"},attrs:{"align":"center"}},[_vm._v("\n          -> Formatez toutes les colonnes contenant des valeurs numériques au\n          format \"123 Nombre\".\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-form',{ref:"formStock",attrs:{"lazy-validation":"","id":"formStock"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Sélectionnez le projet")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Sélectionnez un Projet"},on:{"change":function($event){return _vm.onchangeInfo(_vm.projetS)}},model:{value:(_vm.projetS),callback:function ($$v) {_vm.projetS=$$v},expression:"projetS"}},_vm._l((_vm.listeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Sélectionnez un fichier Excel")]),_vm._v(" "),_c('v-tooltip',{attrs:{"mt-2":"","top":""}},[_c('input',{ref:"fileInputExcel",staticStyle:{"display":"none"},attrs:{"name":"fileInputExcel","type":"file","accept":".xls,.xlsx"},on:{"change":_vm.onFileExcelPicked}}),_vm._v(" "),_c('v-btn',{attrs:{"slot":"activator","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$refs.fileInputExcel.click()}},slot:"activator"},[_vm._v("\n                        Sélectionnez un fichier Excel\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_download")])],1)],1)],1)])],1),_vm._v(" "),(_vm.selectedFileName.length > 0)?_c('div',{staticClass:"mt-2"},[_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"outline":""}},[_vm._v("\n                  Fichier sélectionné :\n                  "),_c('strong',[_vm._v(_vm._s(_vm.selectedFileName))])])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogNewImporter = false}}},[_vm._v("\n                  Annuler\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitImport()}}},[_vm._v("\n                  Enregistrer\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('LoadDepenseProduitExcel',{attrs:{"show":_vm.showModalLoadData,"projet":_vm.listeInfoProjet,"listeTypeTravaux":_vm.listDataDepenses,"listTotals":_vm.listTotals},on:{"close":function($event){return _vm.closeFormTypeProduit()}}}),_vm._v(" "),_c('LoadShowGraph',{attrs:{"show":_vm.showModalgraphData,"listeData":_vm.listeData,"typeGraph":_vm.typeGraph},on:{"close":function($event){return _vm.closeFormShowGraph()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AW6Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text))])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[(_vm.droitAcces.list_mission)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"brown darken-1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('div',[_c('div',{staticClass:"display-2"},[_vm._v("\n                    "+_vm._s(_vm.statistique.missAvalide2)+"\n                  ")]),_vm._v(" "),_c('div',[_vm._v("A VALIDER")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('div',[_vm._v("A APPROUVER")]),_vm._v(" "),_c('div',{staticClass:"display-2"},[_vm._v("\n                    "+_vm._s(_vm.statistique.missAvalide1)+"\n                ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"amber darken-4 darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('div',[_c('div',{staticClass:"display-2"},[_vm._v("\n                    "+_vm._s(_vm.statistique.missCloture)+"\n                  ")]),_vm._v(" "),_c('div',[_vm._v("CLOTUREES")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('div',[_vm._v("EN COURS")]),_vm._v(" "),_c('div',{staticClass:"display-2"},[_vm._v("\n                  "+_vm._s(_vm.statistique.missEncours)+"\n                ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs6":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"cyan darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{staticStyle:{"text-align":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('div',[_vm._v("FRAIS MISSION EN COURS FCFA")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v("\n                  "+_vm._s(_vm.statistique.totalFrais)+"\n                ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('div',[_vm._v("TOTAL NOTE DE FRAIS FCFA")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v("\n                  "+_vm._s(_vm.statistique.totalFraisAll)+"\n                ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"deep-orange  darken-3"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{staticStyle:{"text-align":"center"},attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_vm._v("TOTAL DEMANDES CREES")]),_vm._v(" "),_c('div',{staticClass:"display-2"},[_vm._v("\n                  "+_vm._s(_vm.statistique.missAll)+"\n                ")])])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-card',[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h2',[_vm._v("LISTE DES DEMANDES DE MISSION")]),_vm._v(" "),(_vm.droitAcces.list_mission)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-2"},[_c('el-select',{attrs:{"placeholder":"Filtrer la liste"},on:{"change":_vm.filtrerMission},model:{value:(_vm.selectEtatMiss),callback:function ($$v) {_vm.selectEtatMiss=$$v},expression:"selectEtatMiss"}},_vm._l((_vm.comboEtatMiss),function(item){return _c('el-option',{key:item.etat,attrs:{"label":item.label,"value":item.etat}})}),1)],1)],1):_vm._e(),_vm._v(" "),(_vm.missionUser > 0)?_c('v-alert',{staticClass:"elevation-4 subheading mb-3",attrs:{"value":true,"color":"warning","icon":"priority_high","outline":""}},[_vm._v("\n            Vous avez une demande de mission en attente de validation ou non cloturée. Vous devez patientez jusqu'à la validation de celle-ci ou vous devez cloturer la demande en cours avant de faire une autre demande\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[(_vm.droitAcces.list_mission)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"green","disabled":_vm.disabledBtnMiss,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeMissionExc(_vm.selectEtatMiss)}},slot:"activator"},[_vm._v("\n              Liste en Excel\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v(" print")])],1),_vm._v("\n            Imprimer la liste des missions\n          ")],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.list_mission)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","disabled":_vm.disabledBtnMiss,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeMission(_vm.selectEtatMiss)}},slot:"activator"},[_vm._v("\n              Liste\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v(" print")])],1),_vm._v("\n            Imprimer la liste des missions\n          ")],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","disabled":_vm.missionUser > 0,"color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newDemande('formDemande')}},slot:"activator"},[_vm._v("\n              Mission\n              "),_c('v-icon',{attrs:{"center":""}},[_vm._v("add")])],1),_vm._v("\n            Ajouter nouvelle demande de mission\n          ")],1)],1),_vm._v(" "),_c('data-tables',{attrs:{"data":_vm.tableMission}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Réference","width":"100","fixed":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demandeur","label":"Demandeur","width":"200","fixed":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"activite","label":"Activite","width":"240"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"budget","label":"Budget (Fcfa)","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"depart","label":"Départ","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fin","label":"Fin","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"retour","label":"Retour prevu","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"100","prop":"etatFact","label":"facture"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etatFact == true)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v("solde")]):_vm._e(),_vm._v(" "),(scope.row.etatFact == false)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v("non-solde")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"260","align":"center","prop":"libEtat","label":"Etat de la mission"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 3)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.libEtat))]):_vm._e(),_vm._v(" "),(scope.row.etat == 5)?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v("\n                "+_vm._s(scope.row.libEtat))]):_vm._e(),_vm._v(" "),(scope.row.etat == 1)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.libEtat))]):_vm._e(),_vm._v(" "),(scope.row.etat == 2)?_c('el-tag',[_vm._v(_vm._s(scope.row.libEtat))]):_vm._e(),_vm._v(" "),(scope.row.etat == 4)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.libEtat))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat == 3 && _vm.droitAcces.valider_mission)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.showDetailMission(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1):_vm._e(),_vm._v("\n                Détails\n              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat == 1 && _vm.droitAcces.cloturer_mission)?_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"green","dark":""},nativeOn:{"click":function($event){return _vm.cloturerMission(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("drive_eta")])],1):_vm._e(),_vm._v("\n                Clôre la mission\n              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat == 3)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editMission(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                Modifier\n              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat == 3)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSupr = true;
                    _vm.MissId = scope.row.IdUtil;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                Supprimer\n              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat != 3 && _vm.droitAcces.valider_mission)?_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"warning","dark":""},nativeOn:{"click":function($event){return _vm.showValidMission(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("description")])],1):_vm._e(),_vm._v("\n                Fiche de Validation\n              ")],1),_vm._v(" "),(scope.row.etat === 1 || scope.row.etat === 2)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"info","dark":""},on:{"click":function($event){return _vm.ImprimeSimpleMission(scope.row.IdUtil, 'simple')}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("print")])],1),_vm._v("\n                Simple\n              ")],1):_vm._e(),_vm._v(" "),(scope.row.etat === 1 || scope.row.etat === 2)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"indigo","dark":""},on:{"click":function($event){return _vm.ImprimeSimpleMission(scope.row.IdUtil, 'details')}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("print")])],1),_vm._v("\n                Détailé\n              ")],1):_vm._e()]}}])})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","scrollable":"","loading":_vm.loading,"max-width":"80%","persistent":""},model:{value:(_vm.dialogDemande),callback:function ($$v) {_vm.dialogDemande=$$v},expression:"dialogDemande"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter une demande de mission")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogDemande = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-stepper',{model:{value:(_vm.d1),callback:function ($$v) {_vm.d1=$$v},expression:"d1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"complete":_vm.d1 > 1,"step":"1"}},[_vm._v("Informations generales")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.d1 > 2,"step":"2"}},[_vm._v("Participants")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',[_c('el-form',{ref:"formDemande",staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formDemande,"rules":_vm.rules}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Motif","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Motif"},model:{value:(_vm.formDemande.Activite),callback:function ($$v) {_vm.$set(_vm.formDemande, "Activite", $$v)},expression:"formDemande.Activite"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Nom du demandeur","prop":"personne"}},[_c('el-autocomplete',{staticStyle:{"width":"100%"},attrs:{"name":"personne","placeholder":"nom du demandeur","fetch-suggestions":_vm.loadDemandeur},model:{value:(_vm.formDemande.UserMission),callback:function ($$v) {_vm.$set(_vm.formDemande, "UserMission", $$v)},expression:"formDemande.UserMission"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"required":"","label":"Contact du demandeur","prop":"tel1"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"tel1","placeholder":"Contact 1 du demandeur"},model:{value:(_vm.formDemande.tel1),callback:function ($$v) {_vm.$set(_vm.formDemande, "tel1", $$v)},expression:"formDemande.tel1"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Itineraire","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Itineraire"},model:{value:(_vm.formDemande.Itineraire),callback:function ($$v) {_vm.$set(_vm.formDemande, "Itineraire", $$v)},expression:"formDemande.Itineraire"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Chantier concerné"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Select un chantier"},model:{value:(_vm.formDemande.Chantier),callback:function ($$v) {_vm.$set(_vm.formDemande, "Chantier", $$v)},expression:"formDemande.Chantier"}},_vm._l((_vm.comboChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.text,"value":item.id}})}),1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date de départ","required":""}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","type":"date","id":"Depart","placeholder":"Depart"},model:{value:(_vm.formDemande.DateSorti),callback:function ($$v) {_vm.$set(_vm.formDemande, "DateSorti", $$v)},expression:"formDemande.DateSorti"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date de retour prévue","required":""}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","type":"date","id":"Retour","placeholder":"Retour"},model:{value:(_vm.formDemande.DateEntrePrevue),callback:function ($$v) {_vm.$set(_vm.formDemande, "DateEntrePrevue", $$v)},expression:"formDemande.DateEntrePrevue"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Description"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":4,"id":"Description","placeholder":"Description de la mission"},model:{value:(_vm.listDescription),callback:function ($$v) {_vm.listDescription=$$v},expression:"listDescription"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"error"},on:{"click":function($event){_vm.dialogDemande = false}}},[_vm._v("Fermer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.verifFormDmd()},nativeOn:{"click":function($event){_vm.d1 = 2}}},[_vm._v("Continuer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"primary","icon":"info"}},[_vm._v("\n                        Vous pouvez ajouter des participants a la mission\n                      ")])],1),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formDemandePart}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Nom","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Nom"},model:{value:(_vm.formDemandePart.Nom),callback:function ($$v) {_vm.$set(_vm.formDemandePart, "Nom", $$v)},expression:"formDemandePart.Nom"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Prénom"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Prenom"},model:{value:(_vm.formDemandePart.Prenom),callback:function ($$v) {_vm.$set(_vm.formDemandePart, "Prenom", $$v)},expression:"formDemandePart.Prenom"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Fonction"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Fonction"},model:{value:(_vm.formDemandePart.Fonction),callback:function ($$v) {_vm.$set(_vm.formDemandePart, "Fonction", $$v)},expression:"formDemandePart.Fonction"}})],1)],1)],1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.addListParticipantDemande(_vm.formDemandePart)}}},[_vm._v("Ajouter")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableParticipantDemande}},[_c('el-table-column',{attrs:{"prop":"nom","label":"Nom","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prenom","label":"Prénom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fonction","label":"Fonction"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(
                                    scope.$index,
                                    _vm.tableParticipantDemande
                                  )}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                              Supprimer ce participant\n                            ")],1)]}}])})],1)],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","flat":"","color":"error"},on:{"click":function($event){_vm.dialogDemande = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.d1 = 1}}},[_c('v-icon',[_vm._v("keyboard_arrow_left")]),_vm._v("Précédent")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.createDemande('formDemande')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","scrollable":"","loading":_vm.loading,"fullscreen":"","hide-overlay":""},model:{value:(_vm.dialogDetailMission),callback:function ($$v) {_vm.dialogDetailMission=$$v},expression:"dialogDetailMission"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Fiche de mission")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogDetailMission = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 1,"step":"1"}},[_vm._v("Informations generales")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 2,"step":"2"}},[_vm._v("Participants")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 3,"step":"3"}},[_vm._v("Budget de la mission")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date Depart")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                        "+_vm._s(_vm.detailMission.debut)+"\n                                      ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Activite")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                        "+_vm._s(_vm.detailMission.activite)+"\n                                      ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de la demande")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                        "+_vm._s(_vm.detailMission.date)+"\n                                      ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Retour prevue")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                        "+_vm._s(_vm.detailMission.dateEntrePrevue)+"\n                                      ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Itineraire")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                        "+_vm._s(_vm.detailMission.itineraire)+"\n                                      ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right blue--text title",attrs:{"xs6":""}},[_vm._v("\n                                        "+_vm._s(_vm.detailMission.chantier)+"\n                                      ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Demandeur ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                        "+_vm._s(_vm.detailMission.demandeur)+"\n                                      ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Etat")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right blue--text  title",attrs:{"xs10":""}},[_vm._v("\n                                        "+_vm._s(_vm.detailMission.libEtat)+"\n                                      ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Description")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs12":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","row":4,"readonly":true,"value":_vm.detailMission.description}})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 1}}},[_vm._v("Precedent")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("Suivant")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-3 mt-3",attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                          Vous pouvez ajouter ou modifier des participants a\n                          la mission\n                        ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"model":_vm.formParticipant}},[_c('el-form-item',[_c('el-input',{attrs:{"placeholder":"Nom"},model:{value:(_vm.formParticipant.Nom),callback:function ($$v) {_vm.$set(_vm.formParticipant, "Nom", $$v)},expression:"formParticipant.Nom"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-input',{attrs:{"placeholder":"Prenom"},model:{value:(_vm.formParticipant.Prenom),callback:function ($$v) {_vm.$set(_vm.formParticipant, "Prenom", $$v)},expression:"formParticipant.Prenom"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-input',{attrs:{"placeholder":"Fonction"},model:{value:(_vm.formParticipant.Fonction),callback:function ($$v) {_vm.$set(_vm.formParticipant, "Fonction", $$v)},expression:"formParticipant.Fonction"}})],1),_vm._v(" "),_c('el-form-item',[(
                                _vm.detailMission.etat == 3 ||
                                  _vm.detailMission.etat == 5
                              )?_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.addListParticipant(_vm.formParticipant)}}},[_vm._v("Ajouter")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableParticipant}},[_c('el-table-column',{attrs:{"prop":"nom","label":"Nom","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prenom","label":"Prenom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fonction","label":"Fonction"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableParticipant)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                Supprimer ce participant\n                              ")],1)]}}])})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 1}}},[_vm._v("Precedent")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 3}}},[_vm._v("Suivant")])],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                          Etablissez le budget de la mission\n                        ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true}},[_c('el-form-item',[_c('el-radio',{attrs:{"label":"Vehicule personnel"},model:{value:(_vm.radioVeh),callback:function ($$v) {_vm.radioVeh=$$v},expression:"radioVeh"}},[_vm._v("Vehicule personnel")])],1),_vm._v(" "),_c('el-form-item',[_c('el-radio',{attrs:{"label":"Transport en commun"},model:{value:(_vm.radioVeh),callback:function ($$v) {_vm.radioVeh=$$v},expression:"radioVeh"}},[_vm._v("Transport en commun")])],1),_vm._v(" "),_c('el-form-item',[_c('el-radio',{attrs:{"label":"Vehicule de service"},model:{value:(_vm.radioVeh),callback:function ($$v) {_vm.radioVeh=$$v},expression:"radioVeh"}},[_vm._v("Vehicule de service")])],1),_vm._v(" "),_c('el-form-item',[_c('el-select',{attrs:{"disabled":_vm.radioVeh != 'Vehicule de service',"placeholder":"Select un vehicule"},on:{"change":function($event){return _vm.selectVehicule(_vm.vehSelect)}},model:{value:(_vm.vehSelect),callback:function ($$v) {_vm.vehSelect=$$v},expression:"vehSelect"}},_vm._l((_vm.comboVeh),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-select',{attrs:{"disabled":_vm.radioVeh != 'Vehicule de service',"placeholder":"Conducteur affecté au vehicule "},model:{value:(_vm.condSelect),callback:function ($$v) {_vm.condSelect=$$v},expression:"condSelect"}},_vm._l((_vm.comboCond),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.text,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-date-picker',{attrs:{"type":"date","value-format":"yyyy-MM-dd","id":"DatePaiement","placeholder":"Date limite de paiement"},model:{value:(_vm.dateLimit),callback:function ($$v) {_vm.dateLimit=$$v},expression:"dateLimit"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-select',{attrs:{"placeholder":"Selectionner une caisse"},model:{value:(_vm.caisseSelect),callback:function ($$v) {_vm.caisseSelect=$$v},expression:"caisseSelect"}},_vm._l((_vm.listeCaisse),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"model":_vm.formFrais,"label-position":"top"}},[_c('el-form-item',{attrs:{"label":"Libelle"}},[_c('el-input',{attrs:{"placeholder":"libelle"},model:{value:(_vm.formFrais.libelle),callback:function ($$v) {_vm.$set(_vm.formFrais, "libelle", $$v)},expression:"formFrais.libelle"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Quantite"}},[_c('el-input-number',{attrs:{"min":1,"size":"large","controls-position":"right","placeholder":"quantite"},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.formFrais.quantite),callback:function ($$v) {_vm.$set(_vm.formFrais, "quantite", $$v)},expression:"formFrais.quantite"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Prix Unitaire(FCFA)"}},[_c('el-input-number',{attrs:{"min":0,"size":"large","controls-position":"right","placeholder":"prix unitaire(HT)"},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.formFrais.prixUnit),callback:function ($$v) {_vm.$set(_vm.formFrais, "prixUnit", $$v)},expression:"formFrais.prixUnit"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Tva"}},[_c('el-input-number',{attrs:{"value":0,"min":0,"size":"large","controls-position":"right","placeholder":"tva(%)"},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.formFrais.tva),callback:function ($$v) {_vm.$set(_vm.formFrais, "tva", $$v)},expression:"formFrais.tva"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Total"}},[_c('el-input',{staticStyle:{"width":"50%"},attrs:{"type":"number","min":0,"value":"total","prop":_vm.totalLigne,"placeholder":"TOTAL","readonly":true},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.totalLigne),callback:function ($$v) {_vm.totalLigne=$$v},expression:"totalLigne"}}),_vm._v(" "),(
                                _vm.detailMission.etat == 3 ||
                                  _vm.detailMission.etat == 5
                              )?_c('el-button',{attrs:{"disabled":!_vm.verifBudget,"type":"primary"},on:{"click":function($event){return _vm.addListFrais(_vm.formFrais)}}},[_vm._v("Ajouter")]):_vm._e()],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (HT):\n                            "+_vm._s(new Intl.NumberFormat().format(_vm.totalHT))+"\n                            fcfa")])]),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (TVA):\n                            "+_vm._s(new Intl.NumberFormat().format(_vm.totalTVA))+"\n                            fcfa")])]),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (TTC):\n                            "+_vm._s(new Intl.NumberFormat().format(_vm.totalTTC))+"\n                            fcfa")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableFrais}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Libelle","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantite","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"","label":"Prix unitaire(FCFA)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                              "+_vm._s(new Intl.NumberFormat().format(
                                  scope.row.prixUnit
                                ))+"\n                            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"TVA(%)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Total(FCFA)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                              "+_vm._s(new Intl.NumberFormat().format(
                                  scope.row.total
                                ))+"\n                            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRowBudget(scope.$index, _vm.tableFrais)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                Supprimer\n                              ")],1)]}}])})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("Precedent")]),_vm._v(" "),(_vm.detailMission.etat == 3 || _vm.detailMission.etat == 5)?_c('v-btn',{attrs:{"dark":"","color":"red"},nativeOn:{"click":function($event){_vm.dialogRejeterMission = true}}},[_vm._v("Rejeter")]):_vm._e(),_vm._v(" "),(_vm.detailMission.etat == 3 || _vm.detailMission.etat == 5)?_c('v-btn',{attrs:{"dark":"","color":"green"},nativeOn:{"click":function($event){return _vm.showDialogAccord()}}},[_vm._v("Valider")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","scrollable":"","loading":_vm.loading,"fullscreen":"","hide-overlay":""},model:{value:(_vm.dialogValidMission),callback:function ($$v) {_vm.dialogValidMission=$$v},expression:"dialogValidMission"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Fiche de validation de la mission\n            "+_vm._s(_vm.detailMission.IdUtil))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogValidMission = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',[_c('v-flex',[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                      Informations generales\n                    ")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date Depart")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                      "+_vm._s(_vm.detailMission.debut)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Activite")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                      "+_vm._s(_vm.detailMission.activite)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Caisse")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                      "+_vm._s(_vm.detailMission.caisse)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de la demande")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                      "+_vm._s(_vm.detailMission.date)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Retour prevue")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                      "+_vm._s(_vm.detailMission.dateEntrePrevue)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Itineraire")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                      "+_vm._s(_vm.detailMission.itineraire)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Marque")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                      "+_vm._s(_vm.detailMission.marque)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Modele")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                      "+_vm._s(_vm.detailMission.modele)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Serie")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                      "+_vm._s(_vm.detailMission.serie)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Moyen de transport")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                      "+_vm._s(_vm.detailMission.modeTransport)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right blue--text title",attrs:{"xs6":""}},[_vm._v("\n                                      "+_vm._s(_vm.detailMission.chantier)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Demandeur ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                      "+_vm._s(_vm.detailMission.demandeur)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Conducteur ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                      "+_vm._s(_vm.detailMission.nomPren)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Validateur 1 ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                      "+_vm._s(_vm.detailMission.validateur1)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Validateur 2 ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                      "+_vm._s(_vm.detailMission.validateur2)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Etat")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right blue--text  title",attrs:{"xs10":""}},[_vm._v("\n                                      "+_vm._s(_vm.detailMission.libEtat)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Description")]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('el-form',{staticClass:"demo-ruleForm"},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":""}},[_c('el-input',{attrs:{"readonly":true,"type":"textarea","rows":6},model:{value:(
                                              _vm.detailMission.description
                                            ),callback:function ($$v) {_vm.$set(_vm.detailMission, "description", $$v)},expression:"\n                                              detailMission.description\n                                            "}})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                      Informations participants\n                    ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableParticipant}},[_c('el-table-column',{attrs:{"prop":"nom","label":"Nom","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prenom","label":"Prenom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fonction","label":"Fonction"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                      Informations frais de mission\n                    ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Enregistré par")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                "+_vm._s(_vm.detailMission.validateur1)+"\n                              ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("date d'enregistrement")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                "+_vm._s(_vm.detailMission.dateValidation1)+"\n                              ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (HT):\n                                "+_vm._s(new Intl.NumberFormat().format(
                                    _vm.detailMission.totalFraisHT
                                  ))+"\n                                fcfa")])]),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (TVA):\n                                "+_vm._s(new Intl.NumberFormat().format(
                                    _vm.detailMission.totalTva
                                  ))+"\n                                fcfa")])]),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (TTC):\n                                "+_vm._s(new Intl.NumberFormat().format(
                                    _vm.detailMission.totalFrais
                                  ))+"\n                                fcfa")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableFrais}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Libelle","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantite","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixUnit","label":"Prix unitaire"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                  "+_vm._s(new Intl.NumberFormat().format(
                                      scope.row.prixUnit
                                    ))+"\n                                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"TVA"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                  "+_vm._s(new Intl.NumberFormat().format(
                                      scope.row.tva
                                    ))+"\n                                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Total"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                  "+_vm._s(new Intl.NumberFormat().format(
                                      scope.row.total
                                    ))+"\n                                ")]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.detailMission.etat == 2)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                      Rapport de mission\n                    ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Enregistré par")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                "+_vm._s(_vm.detailMission.userRapport)+"\n                              ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date Retour")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                "+_vm._s(_vm.detailMission.retour)+"\n                              ")])],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.detailMission.idVeh != ''),expression:"detailMission.idVeh != ''"}],attrs:{"row":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Carburant consommé (L)")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                  "+_vm._s(_vm.detailMission.mntCarburant)+"\n                                ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Montant Carburant (Fcfa)")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                  "+_vm._s(_vm.detailMission.carbConsom)+"\n                                ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Compteur de kilometrage")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                  "+_vm._s(_vm.detailMission.kmRetour)+"\n                                ")])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs3":""}},[_c('a',{attrs:{"href":_vm.detailMission.imageRapport,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.detailMission.imageRapport}})])],1)])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('v-layout',{staticClass:"ml-4 ",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_vm._v("Rapport de mission")]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('el-form',{staticClass:"demo-ruleForm"},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":""}},[_c('el-input',{attrs:{"readonly":true,"type":"textarea"},model:{value:(_vm.detailMission.rapport),callback:function ($$v) {_vm.$set(_vm.detailMission, "rapport", $$v)},expression:"detailMission.rapport"}})],1)],1)],1)],1)],1)],1)],1)],1)],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),(_vm.droitAcces.valider2_mission)?_c('v-tooltip',{attrs:{"top":""}},[(_vm.detailMission.etat == 5)?_c('v-btn',{staticClass:"mb-5",staticStyle:{"margin-right":"100px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"red"},on:{"click":function($event){_vm.dialogRejeterMission = true}},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Refuser la mission")])],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.valider2_mission)?_c('v-tooltip',{attrs:{"top":""}},[(_vm.detailMission.etat == 5)?_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"green"},on:{"click":function($event){return _vm.confValMission()}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Valider la mission")])],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","scrollable":"","loading":_vm.loading,"width":"80%","persistent":""},model:{value:(_vm.dialogCloturerMission),callback:function ($$v) {_vm.dialogCloturerMission=$$v},expression:"dialogCloturerMission"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Cloturer une mission")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogCloturerMission = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{staticClass:"demo-form-inline",attrs:{"model":_vm.formCloture,"id":"formRapport"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-form-item',{attrs:{"label":"Date de retour *"}},[_c('el-date-picker',{attrs:{"id":"dateRetour","type":"date","format":"dd-MM-yyyy","placeholder":"Date de retour"},model:{value:(_vm.formCloture.DateRetour),callback:function ($$v) {_vm.$set(_vm.formCloture, "DateRetour", $$v)},expression:"formCloture.DateRetour"}})],1)],1)]),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.detailMission.idVeh != ''),expression:"detailMission.idVeh != ''"}],attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-form-item',{attrs:{"label":"Carburant consomme"}},[_c('el-input',{attrs:{"placeholder":"Carburant consomme(L)"},model:{value:(_vm.formCloture.CarbConsom),callback:function ($$v) {_vm.$set(_vm.formCloture, "CarbConsom", _vm._n($$v))},expression:"formCloture.CarbConsom"}})],1)],1)]),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.detailMission.idVeh != ''),expression:"detailMission.idVeh != ''"}],attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-form-item',{attrs:{"label":"Montant carburant"}},[_c('el-input',{attrs:{"placeholder":"Montant carburant(FCFA)"},model:{value:(_vm.formCloture.MontantCarburant),callback:function ($$v) {_vm.$set(_vm.formCloture, "MontantCarburant", _vm._n($$v))},expression:"formCloture.MontantCarburant"}})],1)],1)]),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.detailMission.idVeh != ''),expression:"detailMission.idVeh != ''"}],attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-form-item',{attrs:{"label":"Kilometrage retour"}},[_c('el-input',{attrs:{"placeholder":"Kilometrage retour"},model:{value:(_vm.formCloture.KmRetour),callback:function ($$v) {_vm.$set(_vm.formCloture, "KmRetour", _vm._n($$v))},expression:"formCloture.KmRetour"}})],1)],1)])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":16}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-form-item',[_c('el-input',{attrs:{"type":"textarea","rows":10,"placeholder":"Saisir le rapport de mission"},model:{value:(_vm.formCloture.Rapport),callback:function ($$v) {_vm.$set(_vm.formCloture, "Rapport", $$v)},expression:"formCloture.Rapport"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"grid-content bg-purple-light"},[_c('v-flex',{staticClass:"ml-4",attrs:{"xs8":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"160px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.image1Rpt,"alt":"avatar"}})]),_vm._v(" "),_c('div',{staticClass:"font-weight-thin"},[_vm._v("\n                      Fichier au format (JPEG,PNG,PDF) avec une taille de 3Mo\n                      ko maximale\n                    ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"file1Rpt",staticStyle:{"display":"none"},attrs:{"name":"image1","type":"file","accept":"image/*"},on:{"change":_vm.onFileImage1RptPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.file1Rpt.click()}}},[_vm._v("Pièce jointe\n                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)],1)],1)],1)])],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-4",attrs:{"xs12":""}},[_c('el-row',{staticStyle:{"margin-top":"10px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6,"offset":18}},[_c('el-form-item',[_c('el-button',{attrs:{"type":"info"},on:{"click":function($event){_vm.dialogCloturerMission = false}}},[_vm._v("Fermer")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success"},on:{"click":function($event){return _vm.valideCloture()}}},[_vm._v("Cloturer")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialogAccord),callback:function ($$v) {_vm.dialogAccord=$$v},expression:"dialogAccord"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Voulez-vous validez la mission ?")]),_vm._v(" "),_c('v-card-text',[_vm._v("En cliquant sur valider, en tant que responsable, vous donnez votre\n          accord pour l'execution de cette mission")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.dialogAccord = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.validMission(_vm.detailMission.etat)}}},[_vm._v("Valider")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialogAccord2),callback:function ($$v) {_vm.dialogAccord2=$$v},expression:"dialogAccord2"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Voulez-vous validez la mission ?")]),_vm._v(" "),_c('v-card-text',[_vm._v("En cliquant sur valider, en tant que responsable, vous donnez votre\n          accord pour l'execution de cette mission")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.dialogAccord2 = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.valid2Mission()}}},[_vm._v("Valider")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"40%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogRejeterMission),callback:function ($$v) {_vm.dialogRejeterMission=$$v},expression:"dialogRejeterMission"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-xs-center"},[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Rejeter la demande de mission")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"outline":"","color":"orange darken-1","icon":"warning","value":true}},[_vm._v("\n              Etes-vous sur de vouloir rejeter l'ordre de mission ?\n            ")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{staticClass:"demo-form-inline"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-form-item',{attrs:{"label":"Motif du refus"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":"Motif du refus"},model:{value:(_vm.motifRejet),callback:function ($$v) {_vm.motifRejet=$$v},expression:"motifRejet"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{on:{"click":function($event){$event.stopPropagation();_vm.dialogRejeterMission = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.rejetMission()}}},[_vm._v("Confirmer\n          ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n            Voulez-vous vraiment supprimer cette mission ?\n          ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteMission($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Adal":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","xs12":""}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"100%"},model:{value:(_vm.dialogAjoutConducteur),callback:function ($$v) {_vm.dialogAjoutConducteur=$$v},expression:"dialogAjoutConducteur"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter des types de travaux ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeTypeTravaux}},[_c('el-table-column',{attrs:{"prop":"ordre","label":"Ordre","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.ordre)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"code","label":"Code","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.code)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Type Travaux","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.libelle)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"Description","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.description)+"\n                  ")])]}}])})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"orange","dark":""},on:{"click":function($event){return _vm.closeDialog()}},slot:"activator"},[_vm._v("Anuller "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('span',[_vm._v("Annuler")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"green","dark":""},on:{"click":function($event){return _vm.saveListe()}},slot:"activator"},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1),_vm._v(" "),_c('span',[_vm._v("Enregistrer les types travaux")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Agyo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_calendrier_Gantt__ = __webpack_require__("daGC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */], Gantt: __WEBPACK_IMPORTED_MODULE_1__components_calendrier_Gantt__["a" /* default */] },
  name: "planning",
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      loading: false,
      tasks: this.$route.params.tasks,
      idChantier: this.$route.params.id,
      libChantier: this.$route.params.libChantier,
      chefChantier: this.$route.params.chefChantier,
      libProjet: this.$route.params.libProjet,
      chefProjet: this.$route.params.chefProjet,
      selectedTask: null
    };
  },

  computed: {},
  filters: {
    toPercent: function toPercent(val) {
      if (!val) return "0";
      return Math.round(+val * 100);
    },
    niceDate: function niceDate(obj) {
      return "${obj.getFullYear()} / ${obj.getMonth()} / ${obj.getDate()}";
    }
  },

  methods: {
    selectTask: function selectTask(task) {
      this.selectedTask = task;
    }
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ "AnuP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ArOJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_absence_vue__ = __webpack_require__("EMUM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cd735af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_absence_vue__ = __webpack_require__("vnsy");
function injectStyle (ssrContext) {
  __webpack_require__("tMzy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cd735af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_absence_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cd735af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_absence_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B0+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","transition":"dialog-bottom-transition","scrollable":"","loading":_vm.loading,"persistent":""},model:{value:(_vm.dialogTarifLocation),callback:function ($$v) {_vm.dialogTarifLocation=$$v},expression:"dialogTarifLocation"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"green"}},[_c('v-toolbar-title',[_vm._v("Liste des forfaits de tarification")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                      LISTE DES FORFAITS DE TARIFICATION POUR LES LOCATIONS DE VEHICULE \n                    ")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeTarif('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeTarif('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnTar,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                                ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newTarif()}},slot:"activator"},[_vm._v("\n                            Ajouter "),_c('v-icon',{attrs:{"center":""}},[_vm._v("add")])],1),_vm._v("\n                        Ajouter une nouvelle tarification\n                    ")],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.itemsTarif}},[_c('el-table-column',{attrs:{"prop":"tarification","label":"Tarification","width":"270","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                    "+_vm._s(scope.row.tarification)+"\n                                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vehicule","label":"Vehicule","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                                    "+_vm._s(scope.row.vehicule)+"\n                                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                                "+_vm._s(scope.row.montant)+" FCFA\n                                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                                    "+_vm._s(scope.row.unite)+"\n                                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editTarification(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                                  Modifier\n                                ")],1)],1)]}}])})],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":true,"max-width":"50%","loading":_vm.loading},model:{value:(_vm.dialogAjoutTarif),callback:function ($$v) {_vm.dialogAjoutTarif=$$v},expression:"dialogAjoutTarif"}},[_c('v-card',[_c('v-toolbar',{attrs:{"light":"","dense":true,"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter une nouvelle tarification pour la location")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutTarif = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                        AJOUT D'UNE NOUVELLE TARIFICATION POUR LES LOCATION DE VEHICULE\n                      ")])],1),_vm._v(" "),_c('v-form',{ref:"formAjoutTarifForfait",attrs:{"lazy-validation":"","id":"formAjoutTarifForfait"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tarification *")]),_vm._v(" "),_c('el-autocomplete',{staticStyle:{"width":"100%"},attrs:{"fetch-suggestions":_vm.loadTarification,"placeholder":"Tarification","trigger-on-focus":true},model:{value:(_vm.selectTarification),callback:function ($$v) {_vm.selectTarification=$$v},expression:"selectTarification"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Désignation du forfait *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%","font-size":"22px"},attrs:{"disabled":true,"value":'Forfait'}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Vehicule *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Vehicule"},model:{value:(_vm.selectVehicule),callback:function ($$v) {_vm.selectVehicule=$$v},expression:"selectVehicule"}},_vm._l((_vm.listVehicule),function(item){return _c('el-option',{key:item.idVeh,attrs:{"label":item.libelle,"value":item.idVeh}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant du forfait *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","name":"montant","min":1,"placeholder":"Montant du forfait"},model:{value:(_vm.formAjoutTarif.montant),callback:function ($$v) {_vm.$set(_vm.formAjoutTarif, "montant", $$v)},expression:"formAjoutTarif.montant"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité (Jour, Mois ou Année) *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Unité (Jour, Mois ou Année)"},model:{value:(_vm.formAjoutTarif.unite),callback:function ($$v) {_vm.$set(_vm.formAjoutTarif, "unite", $$v)},expression:"formAjoutTarif.unite"}},_vm._l((_vm.listUniteForfait),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutTarif = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.saveTarif()}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"40%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuppTarif),callback:function ($$v) {_vm.dialogSuppTarif=$$v},expression:"dialogSuppTarif"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-xs-center"},[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Supprimer un tarif")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"outline":"","color":"orange darken-1","icon":"warning","value":true}},[_vm._v("\n                        Voulez vous supprimer le forfait de location "+_vm._s(_vm.libelForfait)+" ou l'ensemble des forfaits appartenant au tarif "+_vm._s(_vm.libelTarif)+" ?\n                        NB : Aucun vehicule possedant ce forfait ne doit etre en cours de location\n                    ")])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{on:{"click":function($event){$event.stopPropagation();_vm.dialogSuppTarif = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.suppForfait()}}},[_vm._v("Supprimer le forfait\n                ")]),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.suppTarif()}}},[_vm._v("Supprimer tous\n                ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B6fc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_board_Chantier_vue__ = __webpack_require__("mZ7f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fa06dd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_board_Chantier_vue__ = __webpack_require__("BGkZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_board_Chantier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fa06dd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_board_Chantier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BGkZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticStyle:{"padding":"0px"}},[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('ChantierIndex',{attrs:{"userAdmin":_vm.userAdmin,"commis":false,"listeChantiers":_vm.chantiers}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BKDk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");


var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: "AjoutIntervention",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    intervDetail: {
      type: Object
    },
    editForm: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),

      loading: false,
      labelPosition: "left",
      dialogDemande: false,
      typeDemande: [{ value: "Réparation", label: "Réparation" }, { value: "Maintenance", label: "Maintenance" }],
      gravite: [{ value: "Moins grave", label: "Moins grave" }, { value: "Grave", label: "Grave" }, { value: "Très grave", label: "Très grave" }],
      priorite: [{ value: "Moins urgent", label: "Moins urgent" }, { value: "Urgent", label: "Urgent" }, { value: "Très urgent", label: "Très urgent" }],
      listVehicule: [],
      categorie: [{ value: "Carrosserie", label: "Carrosserie" }, { value: "Lavage", label: "Lavage" }, { value: "Parallélisme", label: "Parallélisme" }, { value: "Pneumatique", label: "Pneumatique" }, { value: "Réparation", label: "Réparation" }, { value: "Vidange", label: "Vidange" }, { value: "Mécanique", label: "Mécanique" }, { value: "Peinture", label: "Peinture" }, { value: "Tolérie", label: "Tolérie" }, { value: "Electrique", label: "Electrique" }, { value: "Autre", label: "Autre" }],
      rules: {
        idVeh: [{ required: true, message: "Veuillez selectionner" }],
        categorie: [{ required: true, message: "Veuillez selectionner" }],
        telephone: [{ required: true, message: "Veuillez saisir un numero" }],
        demandeur: [{ required: true, message: "Veuillez saisir le nom du demandeur" }],
        dateFormat: [{
          required: true,
          message: "Veuillez selectionner une date",
          trigger: "blur"
        }],
        priorite: [{ required: true, message: "Veuillez selectionner" }],
        type: [{ required: true, message: "Veuillez selectionner", trigger: "blur" }],
        gravite: [{ required: true, message: "Veuillez selectionner", trigger: "blur" }]
      },
      imageDmdInterv: "/static/img-doc.png",
      fileDmdInterv: "",
      listeProjet: [],
      listeChantier: []
    };
  },


  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogDemande = newValue;
      this.loadVehicule();
      if (newValue == true) {
        this.loadProjet();
        if (this.editForm == true) {} else {
          this.imageDmdInterv = "/static/img-doc.png";
        }
      } else {
        this.formDemande = {};
      }
    }
  },

  methods: (_methods = {
    selectProjet: function selectProjet(idProjet) {
      this.listeChantier.splice(0);
      this.intervDetail.chantier = "";
      this.loadChantier(idProjet);
    },
    loadProjet: function loadProjet() {
      var _this = this;

      var url = this.domaine + "projet/index/projet/all";

      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this.loading = false;
        _this.listeProjet = response.body.projet;
      }, function (errRep) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    loadChantier: function loadChantier(item) {
      var _this2 = this;

      this.loading = true;
      //this.formDmd.chantier = '';
      var url = this.domaine + "projet/" + item + "/index/chantier";
      this.$http.get(url).then(function (response) {
        _this2.loading = false;
        _this2.listeChantier = response.body.chantier;
      }, function (errRep) {
        _this2.loading = false;
        _this2.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    loadVehicule: function loadVehicule() {
      var _this3 = this;

      this.loading = true;
      var type = "flotte";
      var url = this.domaine + 'parc/index/type' + '/' + type;
      this.$http.get(url).then(function (response) {
        _this3.listVehicule = response.body.vehicule;
        _this3.loading = false;
      }, function (errRep) {
        _this3.$message.error("Une erreur est survenue lors du chargement de la liste de vehicule");
        _this3.loading = false;
      });
    },
    createFilter: function createFilter(queryString) {
      return function (link) {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    submitIntervention: function submitIntervention(formName) {
      var _this4 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this4.intervDetail.demandeur == undefined) {
            _this4.$message.error("Veuillez saisir ou selectionner le demandeur");
            return;
          }
          _this4.loading = true;
          var formInterv = document.getElementById("formInterv");
          var url = _this4.domaine + "intervention/new/intervention";
          var data = new FormData(formInterv);
          data.append("idUser", _this4.user.id);
          //data.append('etape', etape)
          data.append("type", _this4.intervDetail.type);
          data.append("priorite", _this4.intervDetail.priorite);
          data.append("gravite", _this4.intervDetail.gravite);
          data.append("categorie", _this4.intervDetail.categorie);
          data.append("demandeur", _this4.intervDetail.demandeur);
          data.append("telephone", _this4.intervDetail.telephone);
          if (_this4.intervDetail.chantier != undefined || _this4.intervDetail.chantier != "") {
            data.append("chantier", _this4.intervDetail.chantier);
          }

          data.append("vehicule", _this4.intervDetail.idVeh);
          data.append("motif", _this4.intervDetail.motif);
          data.append("dateInter", _this4.intervDetail.dateFormat);
          if (_this4.intervDetail.id) {
            data.append("id", _this4.intervDetail.id);
          } else {
            data.append("id", "");
          }

          _this4.$http.post(url, data).then(function (response) {
            //reinitialiser le formulaire
            _this4.resetForm("formIntervention");
            _this4.loading = false;
            _this4.successNotif(response.body.message);
            _this4.closeDialog();
          }, function (erreur) {
            //reinitialiser le formulaire
            _this4.resetForm("formIntervention");
            _this4.closeDialog();
            _this4.loading = false;
            _this4.$message.error("Une erreur est survenue lors de l'enregistrement de la l'intervention");
          });
        }
      });
    },
    selectChauffeur: function selectChauffeur(idVeh) {
      var _this5 = this;

      this.listVehicule.find(function (item) {
        if (idVeh == item.idVeh) {
          _this5.intervDetail.Chauffeur = item.conducteur ? item.conducteur : "Aucun chauffeur";
        }
      });
    },
    loadDemandeur: function loadDemandeur(queryString, cb) {
      var _this6 = this;

      var url = this.domaine + "mission/listes-employe";
      var formdata = new FormData();
      formdata.append("user", this.user.id);
      formdata.append("tag", queryString);
      this.$http.post(url, formdata).then(function (response) {
        if (response.body) {
          var links = response.body;
          var results = queryString ? links.filter(_this6.createFilter(queryString)) : links;
          cb(results);
        }
      }, function (response) {});
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "createFilter", function createFilter(queryString) {
    return function (link) {
      return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
    };
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "resetForm", function resetForm(formName) {
    this.$refs[formName].resetFields();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "successNotif", function successNotif() {
    var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

    this.$notify({
      title: "ENREGISTREMENT REUSSI",
      message: mess,
      type: "success",
      position: "top-center"
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "onFileImageDmdIntervPicked", function onFileImageDmdIntervPicked(event) {
    var _this7 = this;

    var files = event.target.files;
    var filename = files[0].name;
    if (filename.lastIndexOf(".") <= 0) {
      return alert("Veuillez selectionner un  format de fichier valide ");
    }

    var fileReader = new FileReader();
    fileReader.addEventListener("load", function () {
      _this7.imageDmdInterv = fileReader.result;
    });

    this.imageDmdInterv = files[0];
    fileReader.readAsDataURL(files[0]);
    this.fileDmdInterv = files[0];
  }), _methods),
  mounted: function mounted() {}
});

/***/ }),

/***/ "BW/d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Besz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"100%"},model:{value:(_vm.dialogFormDetailProf),callback:function ($$v) {_vm.dialogFormDetailProf=$$v},expression:"dialogFormDetailProf"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter des détails professionnels sur l'employé")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.closeForm()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formDynamiqueProf",attrs:{"label-position":"top","id":"form1","name":"form1","model":_vm.formDynamiqueProf}},[_c('el-card',{staticClass:"box-card"},_vm._l((_vm.formDynamiqueProf.formDetailProfs),function(formProf,ind){return _c('el-row',{key:(formProf.ind),attrs:{"justify":"center","type":"flex","gutter":20}},[_c('v-layout',{staticClass:"mt-3",attrs:{"wrap":""},on:{"click":function($event){_vm.indiceForm = ind}}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"subheading"},[_vm._v("Ligne "+_vm._s(ind+1)+" ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":3}},[_c('el-form-item',{attrs:{"label":"Etablissement/Entreprise*"}},[_c('el-input',{attrs:{"placeholder":"Etablissement","aria-required":"true","id":"etablissement","name":"etablissement","type":"text"},model:{value:(formProf.etablissement),callback:function ($$v) {_vm.$set(formProf, "etablissement", $$v)},expression:"formProf.etablissement"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-form-item',{attrs:{"label":"Faculté/Classe/Service*"}},[_c('el-input',{attrs:{"placeholder":"Faculté","type":"text","id":"faculte"},model:{value:(formProf.faculte),callback:function ($$v) {_vm.$set(formProf, "faculte", $$v)},expression:"formProf.faculte"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Période de formation/contrat*"}},[_c('el-date-picker',{attrs:{"id":"periode","format":"d-MM-yyyy","range-separator":"à","start-placeholder":"Date de début","end-placeholder":"Date de fin","type":"daterange"},model:{value:(formProf.periode),callback:function ($$v) {_vm.$set(formProf, "periode", $$v)},expression:"formProf.periode"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-form-item',{attrs:{"label":"Diplome/Poste*"}},[_c('el-input',{attrs:{"placeholder":"Diplome obtenu ou poste occupé","aria-required":"true","id":"diplome","type":"text"},model:{value:(formProf.diplome),callback:function ($$v) {_vm.$set(formProf, "diplome", $$v)},expression:"formProf.diplome"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label":"Date diplome/contrat*"}},[_c('el-date-picker',{attrs:{"id":"dateDiplome","required":"","format":"d-MM-yyyy","placeholder":"Date d'obtention du diplome ou de signature du contrat","type":"date"},model:{value:(formProf.dateDiplome),callback:function ($$v) {_vm.$set(formProf, "dateDiplome", $$v)},expression:"formProf.dateDiplome"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',[_c('el-form-item',{attrs:{"label":"Type de contrat"}},[_c('el-select',{attrs:{"clearable":"","placeholder":"Type de contrat"},model:{value:(formProf.typeCont),callback:function ($$v) {_vm.$set(formProf, "typeCont", $$v)},expression:"formProf.typeCont"}},_vm._l((_vm.listeTypeContrat),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('div',[_c('el-form-item',{attrs:{"label":"."}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":"","color":"red"},on:{"click":function($event){return _vm.removeProf(formProf)}},slot:"activator"},[_c('v-icon',[_vm._v("clear")])],1),_vm._v("\n                                                       Supprimer\n                                                   ")],1)],1)],1)])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-upload',{ref:"uploadFichProf",refInFor:true,staticClass:"upload-demo",attrs:{"list-type":"picture-card","name":'Ligne'+(ind+1),"action":"","auto-upload":false,"on-change":_vm.changeFile,"multiple":true}},[_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":"","alt":""}})])],1)],1)],1)],1)],1)}),1),_vm._v(" "),_c('el-row',{attrs:{"justify":"end"}},[_c('el-col',{attrs:{"span":2,"offset":22}},[_c('div',[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","absolute":"","right":"","top":"","fab":"","color":"orange"},on:{"click":_vm.addDetailProf},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v("\n                                    Ajouter une ligne\n                                ")],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"text-xs-right mt-4"},[_c('div',{staticClass:"mt-4",staticStyle:{"width":"100%"}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","color":"green"},on:{"click":function($event){return _vm.submitFormProf('formDynamiqueProf')}},slot:"activator"},[_vm._v("\n\n                        Enregistrer\n\n                        "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("save")])],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BgY7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liste_employe_vue__ = __webpack_require__("Erb4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a72f9e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liste_employe_vue__ = __webpack_require__("KfOf");
function injectStyle (ssrContext) {
  __webpack_require__("+pKE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liste_employe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9a72f9e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liste_employe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BrKG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elevation-2 pt-3 pl-3 pr-3",staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('h4',{attrs:{"mt-2":""}},[_vm._v("WORKLOG")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-4 mt-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner de Projet"},on:{"clear":function($event){return _vm.clearSelect()},"change":function($event){return _vm.loadChantier()}},model:{value:(_vm.projetS),callback:function ($$v) {_vm.projetS=$$v},expression:"projetS"}},_vm._l((_vm.listeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Selectionner un Chantier"},on:{"change":function($event){return _vm.filtrerChantier()}},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","disabled":false,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeMatricePDF()}},slot:"activator"},[_vm._v("\n           Imprimer\n           "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1):_vm._e(),_vm._v("Imprimer le worklog\n       ")],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.showAjoutWork()}}},[_vm._v("\n              Ajouter\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("TOTAL TEMPS : "+_vm._s(_vm.totalHeuretrx)+" HEURES  "+_vm._s(_vm.totalmintrx)+" MINUTES ")])]),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("TOTAL DES WORKLOGS: "+_vm._s(_vm.totalactivitetrx))])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"elevation-1",attrs:{"xs12":""}},[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listeWork,"border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',[_c('el-col',{attrs:{"span":5}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('b',[_vm._v("Description")]),_vm._v(" : "),_c('p',[_vm._v(_vm._s(props.row.description))])]),_vm._v(" "),(props.row.statutworklog !='Terminé')?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"blue"},on:{"click":function($event){return _vm.showAddActivite(props.row)}},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v("\n                        Ajouter Activités\n                      ")],1):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":19}},[_c('div',[_c('b',[_vm._v("Liste des Activités")]),_vm._v(" :\n                      ")]),_vm._v(" "),_c('div',{staticClass:"elevation-3"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":props.row.taches}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"utilisateur","label":"ENREGISTRE PAR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateCreation","label":"DATE DE CREATION "}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateModification","label":"MODIFIER LE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"DATE SYSTEME "}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"commentaire","label":"COMMENTAIRE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"statut","label":"STATUT","width":"260"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.statut == 'Terminée')?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.statut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 'En cours')?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v("  "+_vm._s(scope.row.statut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 'Aucune activitée')?_c('el-tag',{attrs:{"type":"info"}},[_vm._v("  "+_vm._s(scope.row.statut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 'En attente')?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v("  "+_vm._s(scope.row.statut))]):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","width":"80","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scop){return [(scop.row.statut == 'Terminée')?_c('v-icon',{attrs:{"color":"green"}},[_vm._v("done")]):_vm._e(),_vm._v(" "),(scop.row.statut !='Terminée' )?_c('v-btn',{attrs:{"slot":"activator","disabled":props.row.close,"color":"orange","fab":"","dark":"","flat":"","small":""},nativeOn:{"click":function($event){return _vm.showDialogActiviteEdit(scop.row)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(scop.row.statut !='Terminée' )?_c('v-btn',{attrs:{"slot":"activator","disabled":props.row.close,"color":"red","fab":"","dark":"","flat":"","small":""},nativeOn:{"click":function($event){return _vm.showDialogActiviteEdit(scop.row)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1):_vm._e()]}}],null,true)})],1)],1)])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idwork","label":"ID","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"DESCRIPTION","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tempsmis","label":"TEMPS MIS","align":"center","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"enregistrer","label":"ENREGIRSTRE PAR","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateAdd","label":"DATE DE CREATION","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateModification","label":"DATE DE MODIFICATION","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"DATE SYSTEME","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"statutworklog","label":"STATUT","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.statutworklog == 'Terminé')?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.statutworklog))]):_vm._e(),_vm._v(" "),(scope.row.statutworklog == 'En cours')?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v("  "+_vm._s(scope.row.statutworklog))]):_vm._e(),_vm._v(" "),(scope.row.statutworklog == 'Aucune activitée en cours')?_c('el-tag',{attrs:{"type":"info"}},[_vm._v("  "+_vm._s(scope.row.statutworklog))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","width":"250","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"purple","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.showDialogWorklogDetail(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v("Détails\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(scope.row.statutworklog != 'Terminé')?_c('v-btn',{attrs:{"slot":"activator","color":"orange","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.showEditWork(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v("Modifier\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(scope.row.statutworklog != 'Terminé')?_c('v-btn',{attrs:{"slot":"activator","color":"red","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.showDilogSupp(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1):_vm._e(),_vm._v("Supprimer\n            ")],1)]}}])})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","closable":false,"show-icon":"","type":"warning"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("LIBELLE:")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("ID-28}")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("\n          Annuler\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.deleteDoc()}}},[_vm._v("\n          Supprimer\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"80%","overlay":true,"transition":"dialog-bottom-transition","scrollable":"","persistent":""},model:{value:(_vm.dialogWork),callback:function ($$v) {_vm.dialogWork=$$v},expression:"dialogWork"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[(_vm.newVersion == true)?_c('span',[_vm._v("Ajouter un nouveau worklog")]):_vm._e(),_vm._v(" "),(_vm.newVersion == false)?_c('span',[_vm._v("Modification du worklog")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogWork = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formWork",staticClass:"demo-form-inline",attrs:{"id":"formWork","model":_vm.formWork}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Libellé","prop":"libelle"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","required":"","placeholder":"libelle"},model:{value:(_vm.formWork.libelle),callback:function ($$v) {_vm.$set(_vm.formWork, "libelle", $$v)},expression:"formWork.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Temps mis (Heure)","required":""}},[_c('el-time-picker',{staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.newVersion,"value-format":"H-m","type":"time","id":"tempsmis","name":"tempsmis","placeholder":"Temps mis"},model:{value:(_vm.formWork.tempsmis),callback:function ($$v) {_vm.$set(_vm.formWork, "tempsmis", $$v)},expression:"formWork.tempsmis"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"description"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":3,"name":"description","placeholder":"Description"},model:{value:(_vm.formWork.description),callback:function ($$v) {_vm.$set(_vm.formWork, "description", $$v)},expression:"formWork.description"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date de création","required":""}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.newVersion,"value-format":"dd-MM-yyyy","type":"date","id":"dateAdd","name":"dateAdd","placeholder":"Date"},model:{value:(_vm.formWork.dateAdd),callback:function ($$v) {_vm.$set(_vm.formWork, "dateAdd", $$v)},expression:"formWork.dateAdd"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"ml-3",attrs:{"xs4":""}},[_c('p',{staticClass:"font-weight-thin"},[_vm._v("Format (JPEG,PNG,PDF), 10 Mo maximum")]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoWorkProj,"alt":"avatar"}})]),_c('br'),_vm._v(" "),_c('input',{ref:"fileLogo",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileLogo.click()}}},[_vm._v("Photo  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){_vm.resetForm('formWork'),_vm.resetForm('tableTaches'),_vm.dialogWork = false}}},[_vm._v("\n                      Annuler\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.newVersion == true)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.addWork('formWork')}}},[_vm._v("\n                      Enregistrer\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e(),_vm._v(" "),(_vm.newVersion == false)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.editWork('formWork')}}},[_vm._v("\n                      Modifier\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"80%","persistent":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogActivite),callback:function ($$v) {_vm.dialogActivite=$$v},expression:"dialogActivite"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[(_vm.newVersion == true)?_c('v-toolbar-title',[_vm._v("\n              Ajouter des activitées au worklog "+_vm._s(_vm.Worklog.libelle)+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.newVersion == false)?_c('v-toolbar-title',[_vm._v("\n              Modifier l'état de l'activitée\n              ")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogActivite = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formActivite",staticClass:"demo-form-inline",attrs:{"id":"formActivite","model":_vm.formActivite}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Libellé","prop":"libelle"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.newVersion,"name":"libelle","required":"","placeholder":"libelle"},model:{value:(_vm.formActivite.libelle),callback:function ($$v) {_vm.$set(_vm.formActivite, "libelle", $$v)},expression:"formActivite.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Statut","prop":"statut"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.formActivite.statut),callback:function ($$v) {_vm.$set(_vm.formActivite, "statut", $$v)},expression:"formActivite.statut"}},_vm._l((_vm.typeLivraison),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.text}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date de création","prop":"date"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.newVersion,"value-format":"dd-MM-yyyy","type":"date","id":"date","placeholder":"Date"},model:{value:(_vm.formActivite.date),callback:function ($$v) {_vm.$set(_vm.formActivite, "date", $$v)},expression:"formActivite.date"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Commentaire","prop":"commentaire"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":3,"name":"commentaire","placeholder":"Description"},model:{value:(_vm.formActivite.commentaire),callback:function ($$v) {_vm.$set(_vm.formActivite, "commentaire", $$v)},expression:"formActivite.commentaire"}})],1)],1)],1),_vm._v(" "),(_vm.newVersion == true)?_c('v-layout',{attrs:{"row":""}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.addListTaches(_vm.formActivite)}}},[_vm._v("Ajouter")])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.newVersion == true)?_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableTaches}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"statut","label":"Statut"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date de création"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"commentaire","label":"Commentaire"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableTaches)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("Supprimer cet article\n                        ")],1)]}}],null,false,191946132)})],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},nativeOn:{"click":function($event){_vm.dialogActivite = false}}},[_vm._v("\n                        Annuler\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.newVersion == true)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.addActivite('formActivite')}}},[_vm._v("\n                        Enregistrer\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e(),_vm._v(" "),(_vm.newVersion == false)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.editTache('formActivite')}}},[_vm._v("\n                        Modifier\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogSuprActivite),callback:function ($$v) {_vm.dialogSuprActivite=$$v},expression:"dialogSuprActivite"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","closable":false,"show-icon":"","type":"warning"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("Activité")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("Activitée- "+_vm._s(_vm.ActiviteSelect.libelle))])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSuprActivite = false}}},[_vm._v("\n                  Annuler\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.deleteActivite()}}},[_vm._v("\n                  Supprimer\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowWorklog),callback:function ($$v) {_vm.dialogShowWorklog=$$v},expression:"dialogShowWorklog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du worklog "+_vm._s(_vm.worklogCourant.libelle)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowWorklog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Libellé : ")]),_vm._v(" "+_vm._s(_vm.worklogCourant.libelle)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.worklogCourant.id)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Temps mis (Heure) : ")]),_vm._v(" "+_vm._s(_vm.worklogCourant.tempsmis)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description :")]),_vm._v(" "+_vm._s(_vm.worklogCourant.description)+"  ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Statut : ")]),_vm._v(" "+_vm._s(_vm.worklogCourant.statutworklog)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Ajouter par : ")]),_vm._v(" "+_vm._s(_vm.worklogCourant.enregistrer)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v(" "+_vm._s(_vm.worklogCourant.date)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v(" "+_vm._s(_vm.worklogCourant.dateModification)+" ")]),_vm._v(" "),_c('p',[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.worklogCourant.urlImage,"alt":"avatar"}})])],1)])],1)],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Liste des activitées ")]),_vm._v(" "),_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.worklogCourant.taches}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"utilisateur","label":"ENREGISTRER PAR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateCreation","label":"DATE DE CREATION "}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateModification","label":"MODIFIER LE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"DATE SYSTEME "}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"commentaire","label":"COMMENTAIRE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"statut","label":"STATUT"}})],1)],1)],1)]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowWorklog = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n                  Fermer\n                ")],1)],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C+2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Oq2I");
__webpack_require__("miEh");



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: "Contrat_ouvrier",
  props: {
    show: {
      type: Boolean
    },
    type: {
      type: Number, //0=>ouvrier 1=> prestataire
      default: 0
    },
    idPrestataire: {
      type: Number
    },
    idChant: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,

      dialogContrat: false,
      libPrestataire: "",
      listeContratsTache: [],
      listeContratsTravaux: [],
      tablePresence: [],
      infoPrestataire: {},
      listePaiements: [],
      dialogPaiement: false,
      formPaiement: {
        montant: 5
      },
      idContrat: null,
      montantTotalVerse: 0,
      montantTotalRestant: 0,
      montantTotal: 0,
      mntMaxRestant: 0
    };
  },


  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogContrat = newValue;
      if (newValue == true) {
        this.loadHistorique();
        this.montantTotalVerse = 0;
        this.montantTotalRestant = 0;
        this.montantTotal = 0;

        if (this.type == 0) {
          // ouvrier
          this.loadContratOuvrier(this.idPrestataire);
          this.loadPresence();
          this.loadInfOuvrier();
        } // prestataire
        else {
            this.loadInfPrestataire();
            this.loadContratTacheFournisseur(this.idPrestataire);
            this.loadContratTrxFournisseur(this.idPrestataire);
          }
      }
    }
  },

  methods: {
    //statistique etat
    statistiqueMntVerse: function statistiqueMntVerse() {
      var option = {
        backgroundColor: "#fafafa",
        title: {
          text: "STATISTIQUE MONTANT PAYE/RESTANT",
          subtext: "",
          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)"
        },

        series: [{
          name: "",
          type: "pie",
          radius: "70%",
          center: ["50%", "50%"],

          data: [{
            value: this.montantTotalRestant,
            name: "mnt restant",
            itemStyle: {
              color: "#c23531"
            }
          }, {
            value: this.montantTotalVerse,
            name: "mnt verse",
            itemStyle: {
              color: "#22c22a"
            }
          }],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      };
      var geneChartStatMontVerse = echarts.init(document.getElementById("statMontVerse"));
      geneChartStatMontVerse.setOption(option);
    },
    headerRowStyle: function headerRowStyle(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return { color: "black" };
    },
    getSummExploitBudget: function getSummExploitBudget(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 3) {
          sums[index] = "N/A";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    loadContratOuvrier: function loadContratOuvrier(idOuvrier) {
      var _this = this;

      this.loading = true;
      this.listeContratsTache.splice(0);
      var url = this.domaine + "contrat/prestataire/ouvrier/" + idOuvrier + "/chantier/" + this.idChant;
      this.$http.get(url).then(function (response) {
        _this.libPrestataire = response.body.libPrestataire;
        _this.listeContratsTache = response.body.contrats;
        _this.montantTotalVerse = response.body.mntTotalVerse;
        _this.montantTotalRestant = response.body.mntTotalRestant;
        _this.montantTotal = response.body.mntTotal;
        _this.loading = false;
        _this.statistiqueMntVerse();
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Echec lors du chargement des contrats ouvriers");
      });
    },
    imprimePaiementPDF: function imprimePaiementPDF() {
      var url = "";
      if (this.type == 0) {
        // ouvrier
        url = this.domaine + "ouvrier/" + this.idPrestataire + "/imprimer_paiement/" + this.idChant + "/" + this.user.id;
        window.open(url);
      } // prestataire
      else {
          url = this.domaine + "ouvrier/" + this.idPrestataire + "/imprimer_paiement_presataire/" + this.idChant + "/" + this.user.id;
          window.open(url);
        }
    },
    imprimerFacture: function imprimerFacture(ligne) {
      var url = "";
      url = this.domaine + "ouvrier/" + this.idPrestataire + "/imprimer/recu/" + this.idChant + "/" + this.user.id;
      window.open(url);
    },
    loadContratTacheFournisseur: function loadContratTacheFournisseur(idFournisseur) {
      var _this2 = this;

      this.loading = true;
      this.listeContratsTache.splice(0);
      var url = this.domaine + "contrat/prestataire/fournisseur_tache/" + idFournisseur + "/chantier/" + this.idChant;
      this.$http.get(url).then(function (response) {
        _this2.libPrestataire = response.body.libPrestataire;
        _this2.listeContratsTache = response.body.contrats;
        _this2.montantTotalVerse += response.body.mntTotalVerse;
        _this2.montantTotalRestant += response.body.mntTotalRestant;
        _this2.montantTotal += response.body.mntTotal;
        _this2.loading = false;
        _this2.statistiqueMntVerse();
      }, function (error) {
        _this2.loading = false;
        _this2.$message.error("Echec lors du chargement des contrats ouvriers");
      });
    },
    loadPresence: function loadPresence() {
      var _this3 = this;

      this.loading = true;
      this.tablePresence.splice(0);
      var url = "";

      if (this.type == 0 && this.idChant != null) {
        //ouvrier
        url = this.domaine + "contrat/prestataire/presence/" + this.idPrestataire + "/" + this.idChant;
      } else {
        return;
      }
      // else if(this.type == 1)//preatataire
      // {
      //     url = this.domaine + "contrat/prestataire/entreprise/" +this.idPrestataire;
      // }

      this.$http.get(url).then(function (response) {
        _this3.tablePresence = response.body.listePresence;
        _this3.loading = false;
      }, function (error) {
        _this3.loading = false;
        _this3.$message.error("Echec lors du chargement des contrats ouvriers");
      });
    },
    loadContratTrxFournisseur: function loadContratTrxFournisseur(idPrest) {
      var _this4 = this;

      this.loading = true;
      this.listeContratsTravaux.splice(0);
      var url = this.domaine + "contrat/prestataire/fournisseur/travaux/" + idPrest + "/chantier/" + this.idChant;
      this.$http.get(url).then(function (response) {
        _this4.libPrestataire = response.body.libPrestataire;
        _this4.listeContratsTravaux = response.body.contrats;
        _this4.loading = false;
        _this4.montantTotalVerse += response.body.mntTotalVerse;
        _this4.montantTotalRestant += response.body.mntTotalRestant;
        _this4.montantTotal += response.body.mntTotal;
        _this4.statistiqueMntVerse();
      }, function (error) {
        _this4.loading = false;
        _this4.$message.error("Echec lors du chargement des contrats ouvriers");
      });
    },
    loadInfOuvrier: function loadInfOuvrier() {
      var _this5 = this;

      this.loading = true;
      var url = this.domaine + "ouvrier/" + this.idPrestataire;
      this.$http.get(url).then(function (response) {
        _this5.infoPrestataire = response.body.ouvrier;
        _this5.loading = false;
      }, function (error) {
        _this5.loading = false;
        _this5.$message.error("Echec lors du chargement des infos du prestataire");
      });
    },
    loadInfPrestataire: function loadInfPrestataire() {
      var _this6 = this;

      this.loading = true;
      var url = this.domaine + "ouvrier/prestataire/" + this.idPrestataire;
      this.$http.get(url).then(function (response) {
        _this6.infoPrestataire = response.body.prestataire;
        _this6.loading = false;
      }, function (error) {
        _this6.loading = false;
        _this6.$message.error("Echec lors du chargement des infos du prestataire");
      });
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },


    //paiement ouvrier
    submitFormPaiement: function submitFormPaiement(formName) {
      var _this7 = this;

      if (this.formPaiement.montant != "undefined" && this.formPaiement.montant != null) {
        this.loading = true;
        var url = this.domaine + "ouvrier/" + this.idPrestataire + "/paiement/contrat/" + this.idContrat;
        var data = new FormData();

        data.append("idUser", this.user.id);
        data.append("montant", this.formPaiement.montant);
        data.append("datePaiement", this.formPaiement.datePaiement);

        this.$http.post(url, data).then(function (response) {
          //reinitialiser le formulaire
          _this7.loading = false;
          _this7.dialogPaiement = false;
          _this7.formPaiement.montant = "";
          _this7.formPaiement.datePaiement = "";

          //recharger l'historique des paiement
          _this7.loadContratOuvrier(_this7.idPrestataire);
          _this7.loadHistorique();

          _this7.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: "Le paiement a été enregistré",
            type: "success",
            position: "top-center"
          });
        }, function (erreur) {
          //reinitialiser le formulaire
          _this7.loading = false;
          _this7.$message.error("L'opération a echouée");
        });
      } else {
        this.$message.error("Veuillez remplir correctement les champs svp...");
      }
    },
    showDialogPaiement: function showDialogPaiement(contrat) {
      if (this.type == 1) {
        this.$alert("Veuillez effectuer le règlement dans le compte fournissuer", "Règlement fournisseur", {
          confirmButtonText: "OK",
          callback: function callback(action) {
            return;
          }
        });
        return;
      }
      this.idContrat = contrat.idContrat;
      this.dialogPaiement = true;
      this.mntMaxRestant = contrat.mntRestant;
    },


    //Charger l'historique de transaction
    loadHistorique: function loadHistorique() {
      var _this8 = this;

      this.listePaiements.splice(0);
      this.loading = true;
      var url = "";
      if (this.type == 0) {
        url = this.domaine + "ouvrier/" + this.idPrestataire + "/historique_paiement_ouvrier_chantier/" + this.idChant;
      } else if (this.type == 1) {
        url = this.domaine + "ouvrier/" + this.idPrestataire + "/historique_paiement_prestataire/chantier/" + this.idChant;
      }

      this.$http.get(url).then(function (response) {
        _this8.loading = false;
        _this8.listePaiements = response.body.paiements;
      }, function (error) {
        _this8.loading = false;
        _this8.$message.error("Une erreur est survenue lors du chargement de l'historique des paiements");
      });
    }
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ "C/WC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
    name: "ModalValidationDmd",
    props: ["show", "demandeDetail"],
    data: function data() {
        return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            dialogDetail: false,
            tableProduit: [],
            totalTTC: 0,
            formRapport: {},
            dialogVisible: false,
            dialogImageUrl: '',
            imageDmd1: "",
            imageDmd2: "",
            imageDmd3: "",
            imageConst1: "",
            imageConst2: "",
            imageConst3: "",
            imageDepan1: "",
            imageDepan2: "",
            imageDepan3: "",
            dialogConfirmRefus: false,
            dialogConfirm: false,
            formRefus: {},
            ruleFormRefus: {
                rapportRefus: [{ required: true, message: 'Veuillez saisir' }]
            }

        };
    },


    computed: {},
    watch: {
        show: function show(newValue, oldvalue) {
            this.dialogDetail = newValue;
            if (newValue == true) {
                this.loadDevisConstat();
            }
        }
    },

    methods: {
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        },
        closeDialog: function closeDialog() {
            this.$emit('close', this.demandeDetail.idDemande, "maintenance");
        },
        loadDevisConstat: function loadDevisConstat() {
            var _this = this;

            this.loading = true;
            var url = this.domaine + 'demande_maintenance/devis/constat/' + this.demandeDetail.idDemande;
            this.$http.get(url).then(function (response) {

                _this.tableProduit = response.body.tableProduit;
                _this.formRapport.rapport = response.body.rapport;
                _this.totalTTC = response.body.total;
                _this.loading = false;
            }, function (errResp) {
                _this.loading = false;
                _this.$message.error("Une erreur est survenue lors du chargement de la table des produits");
            });
        },
        handleRemove: function handleRemove(file, fileList) {},
        handleSuccess: function handleSuccess(response, file, fileList) {
            this.fileList.push(file);
        },
        handlePictureCardPreview: function handlePictureCardPreview(file, fileList) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        imprimerDetail: function imprimerDetail() {

            var url = this.domaine + "demande_maintenance/imprimerPDF/demande/" + this.user.id + "/" + this.demandeDetail.idDemande;
            window.open(url);
        },
        SubmitValideDevis: function SubmitValideDevis() {
            var _this2 = this;

            this.loading = true;
            var url = this.domaine + 'demande_maintenance/devis/validation2';
            var data = new FormData();
            data.append("idDemande", this.demandeDetail.idDemande);
            data.append("idUser", this.user.id);
            this.$http.post(url, data).then(function (response) {
                _this2.loading = false;
                _this2.successNotif(response.body.message);
                _this2.dialogConfirm = false;
                _this2.closeDialog();
            }, function (errResp) {
                _this2.loading = false;
                _this2.$message.error("Une erreur est survenue lors de la validation du devis");
            });
        },
        SubmitRefusDevis: function SubmitRefusDevis() {
            var _this3 = this;

            this.loading = true;
            var url = this.domaine + 'demande_maintenance/devis/refuser';
            var data = new FormData();
            data.append("idDemande", this.demandeDetail.idDemande);
            data.append("idUser", this.user.id);
            data.append("rapport", this.formRefus.rapport);

            this.$http.post(url, data).then(function (response) {
                _this3.loading = false;
                _this3.successNotif(response.body.message);
                _this3.dialogConfirmRefus = false;
                _this3.closeDialog();
            }, function (errResp) {
                _this3.loading = false;
                _this3.$message.error("Une erreur est survenue lors du refus du devis");
            });
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "C5x3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_comparateur_ModalDetailCommande__ = __webpack_require__("ssBb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */], ModalDetailCommande: __WEBPACK_IMPORTED_MODULE_0__components_comparateur_ModalDetailCommande__["a" /* default */] },
  name: "comparateur_index",
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [{ path: "/", text: "Accueil", disabled: false }, { path: "/demandeFond", text: "Demande de fonds", disabled: true }],

      listeCommandes: [],
      beneficeTotal: 0,
      mntTotal: 0,
      totalCmd: 0,
      cmdDerivees: [],
      cmdInit: [],
      showModalDetailCmd: false
    };
  },


  methods: {
    loadCommande: function loadCommande() {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "comparateur/commande/index";

      this.$http.get(url).then(function (response) {
        _this.loading = false;

        // this.mntTTC =  response.body.mntTTC
        _this.listeCommandes = response.body.commandes;
        _this.beneficeTotal = response.body.beneficeTotalFormat;

        //affichage nombre de demande
        _this.totalCmd = _this.listeCommandes.length;
      }, function (response) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors du chargement des commandes");
      });
    },
    modalDetailCmd: function modalDetailCmd(item) {
      var _this2 = this;

      this.loading = true;

      var idComInit = item.idCmdInit;
      var url = this.domaine + "comparateur/commande/initial/" + idComInit;
      this.$http.get(url).then(function (resp) {
        _this2.cmdDerivees = resp.body.derive, _this2.cmdInit = resp.body.initial[0];
        _this2.showModalDetailCmd = true;
        _this2.loading = false;
      }, function (resp) {
        _this2.loading = false;
        _this2.$message.error("erreur lors du chargement des details de la commande");
      });
    }
  },

  mounted: function mounted() {
    this.loadCommande();
  }
});

/***/ }),

/***/ "CCLi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"calendar",attrs:{"id":"calendar"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CLLl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CMsF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LoadConducteurExcel",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  props: {
    listeTypeTravaux: {
      type: Array,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    idChantier: {
      type: Number
    },
    typeTrx: {
      type: Number
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      dialogAjoutBudget: false,
      loading: false
    };
  },

  watch: {
    show: function show(newValue, oldValue) {
      if (newValue == true) {
        this.dialogAjoutBudget = true;
      } else {
        this.dialogAjoutBudget = false;
        this.$emit("close");

        // window.location.reload()
      }
    }
  },
  methods: {
    saveListe: function saveListe() {
      var _this = this;

      // this.loadPage()
      this.loading = true;
      var succesEnreg = true;
      var url = this.domaine + "budgetChantier/save/liste_Budget/excel/" + this.idChantier;
      var nbData = 10;
      var nbReq = 1;
      var ligne = null;

      var nbRest = void 0;
      if (this.listeTypeTravaux.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.listeTypeTravaux.length / nbData);
        nbRest = this.listeTypeTravaux.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (var i = 0; i < nbReq; i++) {
        var initJ = i * nbData;
        var finJ = (i + 1) * nbData;
        var dataLot = [];
        if (this.listeTypeTravaux.length > 0) {
          for (var j = initJ; j < finJ; j++) {
            if (this.listeTypeTravaux[j] == undefined) {
              break;
            }
            dataLot.push(this.listeTypeTravaux[j]);
          }
        }
        var data = new FormData();
        for (var prop in dataLot) {
          ligne = dataLot[prop];
          data.append("option[annee][]", ligne.annee);
          data.append("option[libelle][]", ligne.libelle);
          data.append("option[montant][]", ligne.montant);
        }

        // data.append('listeTypeTravaux', JSON.stringify(dataLot))
        data.append("idUser", this.user.id);
        data.append("typeTravauxId", this.typeTrx);

        this.$http.post(url, data).then(function (resp) {
          _this.loading = false;
          succesEnreg = false;
          _this.$emit("close");
          _this.dialogAjoutBudget = false;
          // this.loadListeTravaux()
          _this.$notify({
            title: "Enregistrement",
            message: "La liste a ete enregistre avec succes",
            type: "success",
            position: "top-right",
            duration: 7000
          });
        }, function (error) {
          _this.loading = false;
          succesEnreg = false;
          _this.dialogAjoutBudget = false;
          _this.$message.error("Erreur lors de l'enregistrement des types travaux");
        });
      }

      //  this.loading = true
      // const loading = this.$loading({
      //     lock: true,
      //     text: 'Veuillez patientez ...',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(0, 0, 0, 0.7)'
      // })
    },
    loadListeTravaux: function loadListeTravaux() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "budgetChantier/chantier/" + this.chantier.id;
      this.$http.get(url).then(function (resp) {
        _this2.loading = false;
        _this2.tableListeTrxBudget = resp.body.listeTypeTrx;
        _this2.totalMntPropose = resp.body.totalMntPropose;
        _this2.totalMntValide = resp.body.totalMntValide;
        _this2.totalTravauxEnAttente = resp.body.totalTravauxEnAttente;
      }, function (error) {
        _this2.loading = false;
        _this2.$message.error("Une erreur est survenue lors du chargement de la liste travaux du module compte exploitation");
      });
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
      // this.loadListeTravaux()
    }
  }
});

/***/ }),

/***/ "CR5P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modelCarteContrat_vue__ = __webpack_require__("c57L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5d05470_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modelCarteContrat_vue__ = __webpack_require__("6Ypr");
function injectStyle (ssrContext) {
  __webpack_require__("3Vbc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e5d05470"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modelCarteContrat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5d05470_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modelCarteContrat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CZee":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CdSF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cf4U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_user_ModalAttribuerZone__ = __webpack_require__("iA41");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_user_ModalAttribuerEquipe__ = __webpack_require__("7mNl");



var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */], ModalAttribuerZone: __WEBPACK_IMPORTED_MODULE_3__components_user_ModalAttribuerZone__["a" /* default */], ModalAttribuerEquipe: __WEBPACK_IMPORTED_MODULE_4__components_user_ModalAttribuerEquipe__["a" /* default */] },
    name: "Responsable",
    data: function data() {
        var _ref;

        return _ref = {
            //data general
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,

            valid: true,
            items: [{ value: false, photo: '', nom: '', login: '', fonction: '', contact: '48867578', action: '' }],
            mdpUserConnect: '',
            listService: [],
            dialogSupr: false,
            listeResponsable: [],
            dialogAjoutResponsable: false,
            dialogEdit: false,
            itemUser: null,
            disabledBtnZone: false,
            recherche: "",
            dialogAttribuerEquipe: false,
            disabledBtnTech: false,
            disabledBtnRespo: false,
            logoUser: "/static/avatar-conducteur.png",

            menuSele: [],
            menu: [],
            roles: [],
            responsable: {},
            selectTypeUser: null,
            selectServiceUser: null,
            dialogRole: false,
            role: [],
            typeUser: [{ text: 'Responsable de zone', value: 4 }],
            mdpUser: '',
            mdpVerUser: ''
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mdpUserConnect', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'serviceUserRules', [function (v) {
            return !!v || 'Veuillez sélectionner votre service.';
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'loginUserRules', [function (v) {
            return !!v || 'Le E-mail est obligatoire';
        }, function (v) {
            return (/^\w+([.-]?\w+)*@\w+([-]?\w+)*(.\w{2,3})+$/.test(v) || 'Vous devez respecter format de E-mail'
            );
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'nomUserRules', [function (v) {
            return !!v || 'Le nom est obligatoire';
        }, function (v) {
            return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mdpUserRules', [function (v) {
            return !!v || 'Le mot de passe est obligatoire';
        }, function (v) {
            return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mdpVerUserRules', [function (v) {
            return !!v || 'La verification du mot de passe est obligatoire. Il doit être identique au mot de pas entré précédenment';
        }, function (v) {
            return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mdpUserConnectRules', [function (v) {
            return !!v || 'Votre mot de passe est obligatoire pour la confirmation';
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'contactUserRules', [function (v) {
            return !!v || "Le contact de l'utilisateur est obligatoire";
        }, function (v) {
            return (/[0-9]/.test(v) || 'Vous devez respecter format du contact'
            );
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showModalZone', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showModalEquipe', false), _ref;
    },


    methods: (_methods = {
        imprimeListeRespo: function imprimeListeRespo(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + "userCreate/imprimerPDF/responsable/liste";
            } else {
                url = this.domaine + "userCreate/imprimerEXC/responsable/liste";
            }
            window.open(url);
        },
        attribuerEquipe: function attribuerEquipe() {
            this.dialogAttribuerEquipe = true;
        },
        deleteUser: function deleteUser() {
            var _this = this;

            var url = this.domaine + 'userCreate/delete/' + this.itemUser.id;
            this.loading = true;
            this.$http.get(url).then(function (response) {
                _this.loading = false;
                if (response.body) {
                    if (response.body.code === 1) {
                        _this.$notify({
                            title: 'SUPPRESSION',
                            message: 'Utilisateur supprimé avec succès.',
                            type: 'success',
                            position: 'top-center'
                        });
                        _this.dialogSupr = false;

                        _this.loadResponsable();
                    } else {
                        _this.$notify.error({
                            title: 'SUPPRESSION ECHOUE',
                            message: 'La suppression du fournisseur a échoué.',
                            position: 'top-center'
                        });
                    }
                }
            });
        },
        showModalNewUser: function showModalNewUser() {
            this.dialogEdit = false;
            this.dialogAjoutResponsable = true; // afficher le modal ajout utilisateur
        },
        showModalEditUser: function showModalEditUser(editResponsable) {
            this.dialogEdit = true;
            this.responsable = editResponsable;
            this.dialogAjoutResponsable = true;
        },
        clear: function clear() {
            this.$refs.formUser.reset();
            this.dialogAjout = false;
        },
        loadResponsable: function loadResponsable() {
            var _this2 = this;

            var url = this.domaine + 'userCreate/index/zone/' + this.user.id + '/responsable';
            if (this.droitAcces.index_user) {
                url = this.domaine + 'userCreate/index/zone/responsable';
            }
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this2.listeResponsable = response.body;
                    if (_this2.listeResponsable === undefined || _this2.listeResponsable.length == 0) {
                        _this2.disabledBtnZone = true;
                    } else {}
                }
            });
        },
        submitUser: function submitUser() {
            var _this3 = this;

            if (this.$refs.formUser.validate()) {
                if (this.responsable.password === this.responsable.confirmePassword) {
                    var form = document.getElementById('formUser');
                    var formdata = new FormData(form);
                    var url = '';
                    if (this.responsable.id) {
                        url = this.domaine + 'userCreate/' + this.responsable.id + '/user/edit';
                        formdata.append('mdpUser', this.mdpUserConnect);
                    } else {
                        url = this.domaine + 'userCreate/new';
                        formdata.append('mdpUser', this.responsable.password);
                        formdata.append('mdpVerUser', this.responsable.confirmePassword);
                    }
                    formdata.append('idUser', this.user.id);
                    formdata.append('serviceUser', this.responsable.serviceId);
                    formdata.append('nomUser', this.responsable.nom);

                    formdata.append('loginUser', this.responsable.login);
                    formdata.append('emailUser', this.responsable.email);
                    formdata.append('contactUser', this.responsable.contact);
                    formdata.append('fonctionUser', this.responsable.fonction);
                    formdata.append('type', this.responsable.type);
                    formdata.append('poste', '');
                    formdata.append('roleUser', this.role);

                    this.loading = true;
                    this.$http.post(url, formdata).then(function (response) {
                        _this3.loading = false;
                        _this3.dialogAjoutResponsable = false;
                        var verif = response.body;
                        if (_this3.responsable.id) {
                            if (verif.code === 1) {
                                _this3.$notify({
                                    title: "L'UTILISATEUR A BIEN ETE MODIFIE",
                                    message: 'Modification effectué avec succès.',
                                    type: 'success',
                                    position: 'top-center'
                                });
                            } else if (verif.code === 2) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 3) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 4) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 5) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 0) {
                                _this3.$message.error(verif.message);
                            }
                        } else {
                            if (verif.code === 1) {
                                _this3.$notify({
                                    title: "L'UTILISATEUR A BIEN ETE AJOUTE",
                                    message: 'Enrégistrement réussie avec succès.',
                                    type: 'success',
                                    position: 'top-center'
                                });
                            } else if (verif.code === 2) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 3) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 4) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 5) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 0) {
                                _this3.$message.error(verif.message);
                            }
                        }
                        _this3.loadResponsable();
                    }, function (response) {
                        _this3.$message.error('Erreur serveur');
                        _this3.loading = false;
                    });
                } else {
                    this.$message.error('Le mot de passe de vérification doit être identique au mot de passe');
                }
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "Utilisateur n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        newRole: function newRole(item) {
            this.responsable = item;
            this.dialogRole = true;
            this.role = item.roles;
            this.menuSele = item.menus;
        },
        loadService: function loadService() {
            var _this4 = this;

            var url = this.domaine + 'webService/liste-service';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this4.listService = response.body.service;
                    _this4.menu = response.body.menu;
                    _this4.roles = response.body.role;
                }
            });
        },


        //attribuer zone
        modalZone: function modalZone(editResponsable) {
            this.responsable = editResponsable;
            this.showModalZone = true;
        }
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_methods, 'newRole', function newRole(item) {
        this.responsable = item;
        this.dialogRole = true;
        this.role = item.roles;
        this.menuSele = item.menus;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_methods, 'submitRole', function submitRole() {
        var _this5 = this;

        this.loading = true;
        if (this.$refs.formRole.validate()) {
            var form = document.getElementById('formRole');
            var data = new FormData(form);
            var url = this.domaine + 'userCreate/' + this.responsable.id + '/role/user';
            data.append('idUser', this.user.id);
            data.append('menuUser', this.menuSele);
            data.append('roleUser', this.role);

            this.$http.post(url, data).then(function (response) {
                if (response.body) {
                    var verif = response.body;
                    if (verif.code === 1) {
                        _this5.$notify({
                            title: "ENREGISTREMENT REUSSI",
                            message: 'Droits enrégistré avec succès.',
                            type: 'success',
                            position: 'top-center'
                        });
                    }

                    _this5.loading = false;
                    _this5.dialogRole = false;

                    _this5.loadResponsable();

                    _this5.$refs.formRole.reset();
                    var menu = verif.menu;
                    var droit = verif.role;
                    sessionStorage.setItem('sessionAcces', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(menu));
                    sessionStorage.setItem('sessionDroit', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(droit));
                    _this5.roleAcces = JSON.parse(sessionStorage.getItem('sessionAcces'));
                    _this5.droitAcces = JSON.parse(sessionStorage.getItem('sessionDroit'));
                } else {
                    _this5.$message.error('Erreur serveur');
                    _this5.loading = false;
                    _this5.dialogRole = false;
                }
            }, function (response) {
                _this5.$message.error('Erreur serveur');
                _this5.loading = false;
            });
        } else {
            this.$notify.error({
                title: "ERREUR D'ENREGISTREMENT",
                message: "Utilisateur n'a pas été enregistré.",
                position: 'top-center'
            });
            this.loading = false;
        }
    }), _methods),
    beforeMount: function beforeMount() {
        if (!this.roleAcces[this.$router.history.current.name]) {
            this.$router.push({ name: 'Home' });
        }
    },
    mounted: function mounted() {
        this.loadService();
        this.loadResponsable();
    }
});

/*export default {
data() {
  }
};*/

/***/ }),

/***/ "CjW+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cv1M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutTypeProjet),callback:function ($$v) {_vm.dialogAjoutTypeProjet=$$v},expression:"dialogAjoutTypeProjet"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter/Editer un type de chantier")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeForm()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formTypeProj",staticClass:"demo-ruleForm",attrs:{"id":"formTypeProj","rules":_vm.rules,"label-position":"top","model":_vm.formTypeProj}},[_c('v-layout',{staticClass:"text-xs-center text-sm-left",attrs:{"row":"","wrap":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md4":"","mr-1":""}},[_c('div',[_c('el-form-item',{attrs:{"label":"Code de type chantier","prop":"code"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"code","placeholder":"Code de Type de chantier"},model:{value:(_vm.formTypeProj.code),callback:function ($$v) {_vm.$set(_vm.formTypeProj, "code", $$v)},expression:"formTypeProj.code"}})],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":"","mr-1":""}},[_c('div',[_c('el-form-item',{attrs:{"label":"Type de chantier","prop":"libelle"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Type de chantier"},model:{value:(_vm.formTypeProj.libelle),callback:function ($$v) {_vm.$set(_vm.formTypeProj, "libelle", $$v)},expression:"formTypeProj.libelle"}})],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('div',[_c('el-form-item',{attrs:{"label":"Description","prop":"description"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"description","placeholder":"Description"},model:{value:(_vm.formTypeProj.description),callback:function ($$v) {_vm.$set(_vm.formTypeProj, "description", $$v)},expression:"formTypeProj.description"}})],1)],1)])],1),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){return _vm.closeForm()}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"green","dark":""},on:{"click":function($event){return _vm.submitTypeProjet()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D+DM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AjoutTransfertCarte__ = __webpack_require__("tTNa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");


var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */], AjoutTransfertCarte: __WEBPACK_IMPORTED_MODULE_1__AjoutTransfertCarte__["a" /* default */] },
  name: "FicheDetailCarte",
  props: {
    carte: {
      type: Object,
      default: {}
    },
    show: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      // racourcis: [
      //     { path: '/', text: 'Accueil', disabled: false },
      //     { path: '/demandeFond', text: 'Demande de fonds', disabled: true }
      // ],

      //rechargements
      dialogSupr: false,
      dialogDetailCarte: false,
      rechargementsValider: [],
      oldRechargementsValider: [],
      formFiche: {},
      ruleFiche: {
        montant: [{ required: true, message: "Veuillez saisir" }]
      },
      dialogAddAppro: false,
      rechargeSelect: null,
      carteTransfert: false, // false=>espece // true=>carte
      image1: "/static/img-doc.png",
      file1: "",
      //Emis

      //achats
      achats: [],
      oldAchat: [],
      rechargementsEmis: [],
      oldRechargementsEmis: [],
      rechargementsRecus: [],
      rechargementsAValider: [],

      //Transfert
      transferts: [],
      oldTransferts: [],
      showModalAjoutTransfert: false,
      editTransfert: {},
      rechargementsAttente: [],
      oldRechargementsAttente: [],
      nbRechargeAttente: 0,
      dialogValideTransfert: false,
      montantTransfert: 0,
      motifRejetTransfert: "",
      rechargeId: null,
      activeName: "appro"
    };
  },


  watch: {
    show: function show(newValue, oldValue) {
      this.dialogDetailCarte = newValue;
      if (newValue == true) {
        this.activeName = "appro";
        this.rechargementsEmis.splice(0);
        this.rechargementsRecus.splice(0);
        this.rechargementsAValider.splice(0);
        this.loadRechargementValider();
      }
    }
  },

  methods: (_methods = {
    handleClick: function handleClick(tab, clicked) {
      var idTab = clicked.target.id;

      switch (idTab) {
        case "tab-appro":
          //appro
          this.loadRechargementValider();
          break;

        case "tab-achat":
          //achat
          this.loadAchat();
          break;

        case "tab-transfert":
          //transfert
          this.loadTransfertEnAttente();
          this.loadTransfertRecu();
          this.loadTransfertEmis();
          break;
      }
    },


    //enregistrement des images
    onFileImage1Picked: function onFileImage1Picked(event) {
      var _this = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this.image1 = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.file1 = files[0];
    },
    modalAppro: function modalAppro(recharge) {
      // if(recharge.carteSource){
      //     this.carteTransfert = true;
      //     this.formFiche.montant = recharge.montant;

      // }
      // else {
      //     this.carteTransfert = false;
      this.formFiche.montant = recharge.montant;
      this.image1 = "";
      //}
      this.rechargeSelect = recharge.id;
      this.dialogAddAppro = true;
    },
    submitAppro: function submitAppro(formName) {
      var _this2 = this;

      if (this.file1 == "") {
        this.$message.error("Veuillez selectionner une piece jointe");
        return;
      }

      this.loading = true;
      var form = document.getElementById("formFiche");
      //recuperation des demandes
      var data = new FormData(form);
      var url = this.domaine + "carteCarburant/valide/approvisionnement";

      data.append("userId", this.user.id);
      data.append("idRecharge", this.rechargeSelect);
      data.append("montant", this.formFiche.montant);

      this.$http.post(url, data).then(function (response) {
        //reinitialiser le formulaire
        //revoir les montants afficher dont le solde et les montant crediter dans l'affichage
        _this2.file1 = "";
        _this2.loading = false;
        _this2.dialogAddAppro = false;
        _this2.resetForm("formFiche");
        _this2.successNotif(response.body.message);
        _this2.loadRechargementValider();
      }, function (erreur) {
        //reinitialiser le formulaire
        _this2.loading = false;
        _this2.resetForm("formFiche");
        _this2.dialogAddAppro = false;
        _this2.$message.error("Une erreur est survenue lors de l'enregistrement de l'approvisionnement'");
        _this2.loadRechargementValider();
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    successNotif: function successNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "'ENREGISTREMENT REUSSI";

      this.$notify({
        title: "",
        message: mess,
        type: "success",
        position: "top-center"
      });
    },
    showDialogSupp: function showDialogSupp(item) {
      // this.carteId = item.carteId
      // this.dialogSupr = true;
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    loadTransfertEnAttente: function loadTransfertEnAttente() {
      var _this3 = this;

      this.loading = true;
      //afficher que les carte que l'utilisateur a creer
      //if(this.droitAcces.liste_demande_fond)
      var url = this.domaine + "carteCarburant/rechargeEnAttente/carte/" + this.carte.carteId;

      this.$http.get(url).then(function (response) {
        _this3.loading = false;
        // this.mntTTC =  response.body.mntTTC
        _this3.rechargementsAttente = response.body.transferts;
        _this3.oldRechargementsAttente = response.body.transferts;

        //this.mntTotal = response.body.montantTotalFormat
        //affichage nombre de demande
        _this3.nbRechargeAttente = _this3.rechargementsAttente.length;
      }, function (response) {
        _this3.loading = false;
        _this3.$message.error("Veuillez patienter, le chargements des teansferts en attente...");
      });
    },
    loadRechargementValider: function loadRechargementValider() {
      var _this4 = this;

      this.loading = true;
      //afficher que les carte que l'utilisateur a creer
      //if(this.droitAcces.liste_demande_fond)
      var url = this.domaine + "carteCarburant/valide/rechargements/carte/" + this.carte.carteId;

      this.$http.get(url).then(function (response) {
        _this4.loading = false;
        // this.mntTTC =  response.body.mntTTC
        _this4.rechargementsValider = response.body.transferts;
        _this4.oldRechargementsValider = response.body.transferts;

        //this.mntTotal = response.body.montantTotalFormat
        //affichage nombre de demande
        _this4.nbRecharge = _this4.rechargementsValider.length;
      }, function (response) {
        _this4.loading = false;
        _this4.$message.error("Veuillez patienter, le chargements des approvisonnements en cours...");
      });
    },
    loadTransfertRecu: function loadTransfertRecu() {
      var carte = this.carte;
      this.rechargementsRecus = this.oldRechargementsValider.filter(function (item) {
        if (item.carteSource != "" && item.carteCible == carte.identifiant && item.statut == 3) {
          //carte deja valider
          return item;
        }
      });
    },
    loadTransfertEmis: function loadTransfertEmis() {
      var _this5 = this;

      this.loading = true;
      var url = this.domaine + "carteCarburant/rechargements/emis/" + this.carte.carteId;

      this.$http.get(url).then(function (response) {
        _this5.loading = false;
        // this.mntTTC =  response.body.mntTTC
        _this5.rechargementsEmis = response.body.transferts;
        _this5.oldRechargementsEmis = response.body.transferts;

        //this.mntTotal = response.body.montantTotalFormat
        //affichage nombre de demande
        //this.nbRecharge = this.rechargementsValider.length
      }, function (response) {
        _this5.loading = false;
        _this5.$message.error("Veuillez patienter, le chargements des transfert emis est en cours...");
      });
    },
    loadAchat: function loadAchat() {
      var _this6 = this;

      this.loading = true;
      var url = this.domaine + "carteCarburant/achat/cartes/" + this.carte.carteId;

      this.$http.get(url).then(function (response) {
        _this6.loading = false;

        _this6.achats = response.body.achats;
        _this6.oldAchats = response.body.achats;
      }, function (response) {
        _this6.loading = false;
        _this6.$message.error("Veuillez patienter, le chargements des achats est en cours...");
      });
    },
    modalAjoutTransfert: function modalAjoutTransfert() {
      this.showModalAjoutTransfert = true;
    },
    modalValideTransfert: function modalValideTransfert(item) {
      this.montantTransfert = item.montantFormat;
      this.rechargeId = item.id;
      this.dialogValideTransfert = true;
    },
    submitValideTransfert: function submitValideTransfert(decision) {
      var _this7 = this;

      var data = new FormData();

      var url = "";
      if (decision == "refuser") {
        if (this.motifRejetTransfert == "") {
          this.$message.error("Veuillez saisir une brève description qui justifie le rejet de ce transfert");
          return;
        }
        url = this.domaine + "carteCarburant/refuser/recharge";
        data.append("refus", this.motifRejetTransfert);
      } else if (decision == "valider") {
        url = this.domaine + "carteCarburant/valider/recharge";
      }
      this.loading = true;

      data.append("rechargeId", this.rechargeId);
      data.append("userId", this.user.id);

      //afficher que les carte que l'utilisateur a creer
      //if(this.droitAcces.liste_demande_fond)
      //url = this.domaine +  'carteCarburant/rechargeEnAttente/carte/'+this.carte.carteId

      this.$http.post(url, data).then(function (response) {
        _this7.dialogValideTransfert = false;
        _this7.loading = false;
        _this7.successNotif(response.body.message, "CONFIRMATION TRANSFERT");
        _this7.loadTransfertEnAttente();
      }, function (response) {
        _this7.dialogValideTransfert = false;
        _this7.loading = false;
        _this7.$message.error("Une erreur s'est produite lors de la confirmation du transfert");
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "successNotif", function successNotif() {
    var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ENREGISTREMENT REUSSI";

    this.$notify({
      title: this.title,
      message: mess,
      type: "success",
      position: "top-center"
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "imprimerRecu", function imprimerRecu(urlImageRecu) {
    window.open(urlImageRecu);
  }), _methods),

  mounted: function mounted() {
    //this.loadCarte();
  }
});

/***/ }),

/***/ "D1h6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_boardChantier_AjoutPrevisionBudgetChantier__ = __webpack_require__("/sgE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//function de difference de date

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Oq2I");
__webpack_require__("miEh");




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */],
    AjoutPrevisionBudgetChantier: __WEBPACK_IMPORTED_MODULE_2__components_boardChantier_AjoutPrevisionBudgetChantier__["a" /* default */]
  },
  props: {
    show: {
      type: Boolean
    },
    chantier: {
      type: Object
    }
  },
  name: "CompteExploitationChantier",
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,

      //VARIABLE
      tableListeTrxBudget: [],
      selectEtatMiss: "",
      tableOldListeTrxBudget: [],
      comboEtatMiss: [{
        etat: 0,
        label: "Toutes les missions"
      }, {
        etat: 1,
        label: "Avec budget"
      }, {
        etat: 2,
        label: "Sans budget"
      }],
      totalMntPropose: 0,
      totalMntValide: 0,
      totalTravauxEnAttente: 0,

      //MODAL AJOUT PREVISION
      showModalAjoutPrevision: false,
      typeTravaux: [],
      typeEtat: false,
      dateAnMois: null,
      labelPosition: "top"
    };
  },

  computed: {},
  watch: {
    show: function show(newValue, oldValue) {
      this.tableListeTrxBudget.splice(0);
      if (newValue == true) {
        this.loadListeTravaux();
      }
    }
  },
  methods: {
    filtrerMission: function filtrerMission(etat) {
      var old = this.tableOldListeTrxBudget;
      this.tableListeTrxBudget = old;
      if (etat === 1) {
        this.tableListeTrxBudget = this.tableListeTrxBudget.filter(function (item) {
          if (item.detailBudget.length > 0) {
            return item;
          }
        });
      } else if (etat === 2) {
        this.tableListeTrxBudget = this.tableListeTrxBudget.filter(function (item) {
          if (item.detailBudget.length == 0) {
            return item;
          }
        });
      } else {
        return this.tableListeTrxBudget = old;
      }
    },
    headerRowStyle: function headerRowStyle(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return { color: "black" };
    },
    format: function format(percentage) {
      return percentage + "%";
    },
    getSumm: function getSumm(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 4) {
          sums[index] = "N/A";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    modalAjoutBudget: function modalAjoutBudget(item) {
      var etat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      console.log('rjjrr dans chantier', item, etat);
      this.typeTravaux = item;
      this.typeEtat = etat;
      this.showModalAjoutPrevision = true;
    },
    loadListeTravaux: function loadListeTravaux() {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "budgetChantier/chantier/" + this.chantier.id;
      this.$http.get(url).then(function (resp) {
        _this.loading = false;
        _this.tableListeTrxBudget = resp.body.listeTypeTrx;
        _this.tableOldListeTrxBudget = resp.body.listeTypeTrx;
        _this.totalMntPropose = resp.body.totalMntPropose;
        _this.totalMntValide = resp.body.totalMntValide;
        _this.totalTravauxEnAttente = resp.body.totalTravauxEnAttente;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors du chargement de la liste travaux du module compte exploitation");
      });
    },
    imprimeComptePDF: function imprimeComptePDF() {
      var url = this.domaine + "budgetChantier/" + this.chantier.id + "/" + this.user.id + "/imprimer_compteExploi_pdf";
      window.open(url);
    },


    //recherche info projet ou chantier
    submitForm: function submitForm() {}
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ "DOLh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DRSj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadShowGraph_vue__ = __webpack_require__("wzJ7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2662bce9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadShowGraph_vue__ = __webpack_require__("m7tA");
function injectStyle (ssrContext) {
  __webpack_require__("CdSF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2662bce9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadShowGraph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2662bce9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadShowGraph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DUFI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationDmdFond_vue__ = __webpack_require__("bMqG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a08e9b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationDmdFond_vue__ = __webpack_require__("Qu0c");
function injectStyle (ssrContext) {
  __webpack_require__("PD6H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a08e9b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationDmdFond_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a08e9b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationDmdFond_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DUFl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogDashboardChantier),callback:function ($$v) {_vm.dialogDashboardChantier=$$v},expression:"dialogDashboardChantier"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("TABLEAU DE BORD CHANTIER")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-2":"","ml-1":"","mb-3":""}},[_c('v-flex',{staticClass:"elevation-3",attrs:{"sm2":"","mr-2":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v("Informations Chantier")])],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailChantier.libelleProjet))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Libelle projet")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailChantier.libelle))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Libelle Chantier")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailChantier.chefProjet))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Responsable projet")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailChantier.chefChantier))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Chef chantier")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailChantier.dateD)+" --"+_vm._s(_vm.detailChantier.dateF)+"\n                  ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Période d'exécution")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailChantier.libEtat))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Etat")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailChantier.jourRestant))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Jour(s) restant(s)")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"background-color":"#FAFAFA"},attrs:{"sm10":""}},[_c('WidgetTravaux',{attrs:{"commis":_vm.commis,"listeTrx":_vm.listeTravaux,"listeTrxId":_vm.listeTravauxId}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":"","ml-1":"","mr-1":"","mt-1":""}},[_c('v-card',[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick(_vm.onglet)}},model:{value:(_vm.onglet),callback:function ($$v) {_vm.onglet=$$v},expression:"onglet"}},[_c('el-tab-pane',{attrs:{"label":"travaux"}},[_c('ListeTravaux',{attrs:{"type":1,"commis":_vm.commis,"listeTrxId":_vm.listeTravauxId,"listeTrx":_vm.listeTravaux,"idChantier":_vm.detailChantier.idChant},on:{"reloadListeTravaux":function($event){return _vm.loadTravaux(_vm.detailChantier)}}}),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Ouvriers/Prestataires"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-card-text',[_c('ListePrestataire',{attrs:{"idChantier":_vm.detailChantier.idChant,"type":1,"listeOuvriers":_vm.listOuvriers,"listePrestataires":_vm.listPrestataires,"show":_vm.showListeOuvrier}})],1)],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Reserve Travaux"}},[_c('ListeReserve',{attrs:{"type":1,"listeTrxId":_vm.listeTravauxId,"listeReserveTrx":_vm.listeReserves},on:{"reloadListeReserve":function($event){return _vm.loadReserves()}}}),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Worklog"}},[_c('ListeWorklog',{attrs:{"type":2,"listeWorktrx":_vm.listworklogs,"listeTacheWorktrx":_vm.listtache,"idChantier":_vm.detailChantier.idChant,"totalHeuretrx":_vm.totalHeuretrx,"totalmintrx":_vm.totalmintrx,"totalactivitetrx":_vm.totalActivite},on:{"reloadWorklogs":function($event){return _vm.loadWorklogs(_vm.detailChantier)}}}),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DXBY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Caisse_vue__ = __webpack_require__("skxa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14095d96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Caisse_vue__ = __webpack_require__("voI1");
function injectStyle (ssrContext) {
  __webpack_require__("uxb+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Caisse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14095d96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Caisse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DXMj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_widgetProjet_vue__ = __webpack_require__("bagP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5775c7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_widgetProjet_vue__ = __webpack_require__("+k/P");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_widgetProjet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5775c7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_widgetProjet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dbyj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalCommandeDetails_vue__ = __webpack_require__("r0nc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eafb0ee0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalCommandeDetails_vue__ = __webpack_require__("SfI+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalCommandeDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eafb0ee0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalCommandeDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DhyM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */] },
    name: "flotte",
    props: ["id"],
    data: function data() {
        var _ref;

        return _ref = {
            //data general
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            loading: false,
            titleMessInfo: "",
            messTextInfo: "",
            typeMessInfo: "success",
            racourcis: [{ path: '/parc/auto', text: 'ParcAuto', disabled: false }, { path: '/', text: 'Flotte', disabled: false }],
            //DATA VEHICULE
            nbVehTot: 0,
            nbVehDisp: 0,
            nbVehUtil: 0,
            paginationAssur: {},
            nbVehPan: 0,
            typeVehicule: '',
            nbVehLoc: 0,
            nbVehRep: 0,
            dialogSuprVeh: false,
            idVehModif: "",
            titleModalAjout: "Ajouter un nouveau véhicule",
            libBtnAjoutVeh: "Ajouter un vehicule",
            valid: true,
            listVehicule: [],
            listVehiculeImport: [],
            listMarque: [],
            listSousCategorie: [],
            listModele: [],
            listSerie: [],
            listParc: [],
            selectParc: '',
            listCategorie: []
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listSousCategorie", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formVehicule", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "e1", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogAjoutVeh", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogImport", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showModalLoadVehicule", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "typeVeh", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nameRules", [function (v) {
            return !!v || 'Ce champs est requis';
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "typeCarburant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "imageCarteGris", "/static/img-doc.png"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "imageVeh", "/static/car_avatar.png"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fileVeh", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fileCarteGris", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "menuAnnVeh", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogSuppVeh", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fileExcel", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "msgLoad", "Chargement en cours"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectEtatVeh", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "typeVehicule", ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbAssurAbs", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbAssurAexp", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbVisiteTechAbs", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbVisiteTechExp", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbVignetteAbs", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbVignetteExp", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "comboEtatVeh", [{
            etat: 0,
            label: "Vehicule"
        }, {
            etat: 1,
            label: "Vehicule Disponible"
        }, {
            etat: 2,
            label: "Vehicule en cours utilisation"
        }, {
            etat: 3,
            label: "Vehicule en panne"
        }, {
            etat: 4,
            label: "Vehicule en reparation"
        }, {
            etat: 5,
            label: "Vehicule en location"
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnExc", false), _ref;
    },

    computed: {
        formVehIsValid: function formVehIsValid() {
            return this.formVehicule.marqueId != "" && this.formVehicule.modeleId != "" && this.formVehicule.serieId != "" && this.formVehicule.matricule != null && this.formVehicule.numChassis != null && this.formVehicule.typeCarbuId != null && this.formVehicule.kilometrage != null && this.formVehicule.parcId != null;
        }
    },
    watch: {},
    methods: {
        chargeSousCat: function chargeSousCat(idCat) {
            if (idCat != "" && !isNaN(idCat)) {
                //chargement des modele lie a la categorie
                this.loadSousCat(idCat);
            } else {
                this.formVehicule.marqueId = '';
                this.listSerie = [];
                this.formVehicule.serieId = '';
                this.formVehicule.modeleId = '';
            }
        },
        chargeMarque: function chargeMarque(idCat) {
            if (idCat != "" && !isNaN(idCat)) {
                //chargement des modele lie a la categorie
                this.loadMarque(idCat);
            } else {
                this.formVehicule.marqueId = '';
                this.listSerie = [];
                this.formVehicule.serieId = '';
                this.formVehicule.modeleId = '';
            }
        },
        chargeModele: function chargeModele(idMarq) {
            if (idMarq != "" && !isNaN(idMarq)) {
                //chargement des modele lie a la categorie
                this.loadModele(idMarq);
            } else {
                this.listMarque.push({ id: idMarq, libelle: idMarq, text: idMarq });
            }
        },
        chargeSerie: function chargeSerie(idMod) {
            if (idMod != "" && !isNaN(idMod)) {
                //chargement des modele lie a la categorie
                this.loadSerie(idMod);
            } else {
                this.listModele.push({ id: idMod, libelle: idMod, text: idMod });
            }
        },
        selectSerie: function selectSerie(idSerie) {
            if (idSerie != "" && !isNaN(idSerie)) {} else {
                this.listSerie.push({ id: idSerie, libelle: idSerie, text: idSerie });
            }
        },
        filtrerVehicule: function filtrerVehicule(etat) {
            this.loadVehiculeParEtat(etat);
        },
        newVeh: function newVeh() {
            this.formVehicule = {};
            this.dialogAjoutVeh = true;
            this.imageCarteGris = "/static/img-doc.png";
            this.imageVeh = "/static/car_avatar.png";
            this.fileVeh = "";
            this.fileCarteGris = "";
        },
        generateFileExcel: function generateFileExcel() {
            this.dialogImport = false;
            var url = this.domaine + "parc/generer/modele/vehicule";
            window.open(url);
        },
        onFileExcelPicked: function onFileExcelPicked(event) {
            var _this = this;

            // this.loading = true;
            this.fileExcel.splice(0, 1);
            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".xls") <= 0) {
                return alert("Veuillez selectionner un fichier excel valide ");
            }
            if (files[0].size > 2097152) {
                this.$message.error("La taille du fichier est supérieur à 2 Mo");
                return;
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this.fileExcel.push(fileReader.result);
            });
            fileReader.readAsDataURL(files[0]);

            var url = this.domaine + "parc/load/vehicule/excel";
            var data = new FormData();
            data.append("fichierExcel", files[0], files[0][name]);
            this.$http.post(url, data).then(function (resp) {
                _this.loading = false;
                _this.$notify({
                    title: "Chargement liste des vehicules à importer",
                    message: "Chargement effectué",
                    type: "success",
                    position: "top-right",
                    duration: 7000
                });
                _this.showModalLoadVehicule = true;
                _this.listVehiculeImport = resp.body.listeVehicule;
            }, function (error) {
                _this.loading = false;
                _this.$message.error("Erreur lors de l'importation du fichier");
            });
        },
        editVeh: function editVeh(item) {
            console.log('item', item);
            this.loadSousCat(item.sousCategorieId);
            this.loadSousCat(item.categorieId);
            this.loadModele(item.marqueId);
            this.loadSerie(item.modeleId);
            this.formVehicule = item;
            this.idVehModif = item.idVeh;
            this.imageCarteGris = item.urlCarteGrise;
            this.imageVeh = item.photoVeh;
            this.dialogAjoutVeh = true;
        },
        saveListe: function saveListe() {
            var _this2 = this;

            this.loading = true;
            var succesEnreg = true;
            var url = this.domaine + "parc/save/modele/vehicule";
            var nbData = 10;
            var nbReq = 1;
            var ligne = null;

            var nbRest = void 0;
            if (this.listVehiculeImport.length > 10) {
                nbData = 10;
                nbReq = Math.round(this.listVehiculeImport.length / nbData);
                nbRest = this.listVehiculeImport.length % nbData;
                if (nbRest > 0) {
                    nbReq += 1;
                }
            }

            for (var i = 0; i < nbReq; i++) {
                var initJ = i * nbData;
                var finJ = (i + 1) * nbData;
                var dataLot = [];
                if (this.listVehiculeImport.length > 0) {
                    for (var j = initJ; j < finJ; j++) {
                        if (this.listVehiculeImport[j] == undefined) {
                            break;
                        }
                        dataLot.push(this.listVehiculeImport[j]);
                    }
                }
                var data = new FormData();
                data.append('listVehiculeImport', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataLot));

                this.$http.post(url, data).then(function (resp) {
                    _this2.loading = false;
                    succesEnreg = true;
                }, function (error) {
                    _this2.loading = false;
                    _this2.$message.error("Erreur lors de l'enregistrement des conducteurs");
                    succesEnreg = false;
                });
            }

            if (succesEnreg == true) {
                this.loading = false;
                this.showModalLoadVehicule = false;
                this.$notify({
                    title: "Enregistrement",
                    message: "La liste a été enregistré",
                    type: "success",
                    position: "top-right",
                    duration: 7000
                });
                this.closeDialog();
            }
        },
        createVeh: function createVeh() {
            var _this3 = this;

            var idVehModif = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.loading = true;

            if (this.formVehicule.marqueId == null || this.formVehicule.modeleId == null || this.formVehicule.serieId == null || this.formVehicule.categorieId == null) {
                this.loading = false;
                this.$message.error("Veuillez renseigner correctement les champs categorie, marque, modele et serie");
                return;
            }

            if (this.$refs.formVehicule.validate()) {
                var form = document.getElementById('formVehicule');
                var data = new FormData(form);
                var url = "";
                if (idVehModif !== "" && idVehModif !== undefined && idVehModif != null) {
                    url = this.domaine + 'parc/edit/vehicule/' + idVehModif;
                } else {
                    url = this.domaine + 'parc/new/vehicule'; //WebServiceBundle:ParcAutoController:newVehicule
                }

                data.append('idUser', this.user.id);
                data.append('typeVehicule', this.typeVehicule);
                data.append('type', this.formVehicule.categorieId);
                data.append('typeCarbu', this.formVehicule.typeCarbuId);
                data.append('marque', this.formVehicule.marqueId);
                data.append('modele', this.formVehicule.modeleId);
                data.append('serie', this.formVehicule.serieId);
                data.append('parc', this.formVehicule.parcId);
                data.append('dateAqui', this.formVehicule.dateAqui);
                data.append('annVeh', this.formVehicule.annVeh);
                data.append('coutUtil', this.formVehicule.coutUtil);
                data.append('matricule', this.formVehicule.matricule);
                data.append('codeParc', this.formVehicule.codeParc);
                data.append('ratio', this.formVehicule.ratio);
                data.append('sousCategorie', this.formVehicule.sousCategorieId);
                //data.append('prixAchat',this.formVehicule.prixAchat)

                this.$http.post(url, data).then(function (response) {
                    if (response.body) {
                        _this3.loading = false;
                        _this3.e1 = 1;
                        var verif = response.body;
                        if (verif.code === 1) {
                            _this3.$notify({
                                title: 'ENREGISTREMENT REUSSI',
                                message: "Véhicule enregistré avec succès.",
                                type: 'success',
                                position: 'top-right',
                                duration: 5000
                            });
                            _this3.dialogAjoutVeh = false;
                            //Reinitialisation des champs
                            _this3.$refs.formVehicule.reset();
                            _this3.$refs.fileCarteGris.value = "";
                            _this3.$refs.fileVeh.value = "";
                            _this3.imageCarteGris = "/static/car_avatar.png";
                            _this3.imageVeh = "/static/car_avatar.png";
                            _this3.imageCarteGris = "/static/car_avatar.png";
                            _this3.imageVeh = "/static/car_avatar.png";
                            _this3.loadVehicule();
                        } else if (verif.code === 0) {
                            _this3.$message.error(verif.message);
                            _this3.loading = false;
                        } else if (verif.code === 5) {
                            _this3.loading = false;
                            _this3.$message.error(verif.message);
                        }
                    } else {
                        _this3.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this3.loading = false;
                    }
                }, function (response) {
                    _this3.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                    _this3.loading = false;
                });
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "Le véhicule n'a pas été enregistré.",
                    position: 'top-right'
                });
                this.loading = false;
                this.e1 = 1;
            }
        },
        loadSousCat: function loadSousCat(idCat) {
            var _this4 = this;

            var url = this.domaine + 'parc/index/sous_categorie/' + idCat;
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this4.listSousCategorie = response.body.sous;
                }
            });
        },
        loadMarque: function loadMarque(idCat) {
            var _this5 = this;

            var url = this.domaine + 'parc/index/marque/cat';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this5.listMarque = response.body.marque;
                }
            });
        },
        loadCategorie: function loadCategorie() {
            var _this6 = this;

            var url = this.domaine + 'parc/index/categorie';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this6.listCategorie = response.body.categorie;
                }
            });
        },
        loadCarburant: function loadCarburant() {
            var _this7 = this;

            var url = this.domaine + 'parc/index/carburant';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this7.typeCarburant = response.body.carburant;
                }
            });
        },
        loadModele: function loadModele(idMarq) {
            var _this8 = this;

            var url = this.domaine + 'parc/index/modele/marque/' + idMarq;
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this8.listModele = response.body.modele;
                }
            });
        },
        loadSerie: function loadSerie(idMod) {
            var _this9 = this;

            var url = this.domaine + 'parc/index/serie/modele/' + idMod;
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this9.listSerie = response.body.serie;
                }
            });
        },
        confSuppVeh: function confSuppVeh(item) {
            this.idVehModif = item.idVeh;
            this.dialogSuppVeh = true;
        },
        imprimeFlotte: function imprimeFlotte() {
            var idEtat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            var url = this.domaine + 'parc/impression/flotte/' + idEtat;
            window.open(url);
        },
        imprimeExcFlotte: function imprimeExcFlotte() {
            var idEtat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            var url = this.domaine + 'parc/impressionExc/flotte/' + idEtat;
            window.open(url);
        },
        loadParc: function loadParc() {
            var _this10 = this;

            var url = this.domaine + 'parc/index/parc';
            this.$http.get(url).then(function (response) {
                if (response.body.parc) {
                    var tableau = response.body.parc;
                    for (var i = 0; i < tableau.length; ++i) {
                        for (var j = i + 1; j < tableau.length; ++j) {
                            if (tableau[i].libelle === tableau[j].libelle) {
                                tableau.splice(j--, 1);
                            }
                        }
                    }
                    _this10.listParc = tableau;
                }
            });
        },
        loadTypeVehicule: function loadTypeVehicule() {
            var _this11 = this;

            this.loading = true;
            if (this.selectParc != 0) {
                var url = this.domaine + "parc/parcSelect/" + this.selectParc;
                this.$http.get(url).then(function (response) {
                    _this11.loading = false;
                    _this11.listVehicule = response.body.listVehicule;
                }, function (errRep) {
                    _this11.loading = false;
                    _this11.$message.error("Une erreur est survenue lors du chargement de la liste des vehicules");
                });
            } else {
                this.loadVehicule();
                this.loading = false;
            }
        },
        loadVehiculeParEtat: function loadVehiculeParEtat(etat) {
            var _this12 = this;

            var url = this.domaine + 'parc/etat_veh';
            var data = new FormData();
            data.append("etat", etat);
            this.loading = true;

            this.$http.post(url, data).then(function (response) {
                _this12.loading = false;
                if (response.body) {
                    _this12.listVehicule = response.body.vehicule;
                    if (_this12.listVehicule === undefined || _this12.listVehicule.length == 0) {
                        _this12.disabledBtnExc = true;
                    } else {
                        _this12.disabledBtnExc = false;
                    }
                    _this12.nbVehTot = response.body.nbVeh;
                    _this12.nbVehDisp = response.body.nbVehDisp;
                    _this12.nbVehUtil = response.body.nbVehUtil;
                    _this12.nbVehPan = response.body.nbVehPan;
                    _this12.nbVehLoc = response.body.nbVehLoc;
                    _this12.nbVehRep = response.body.nbVehRep;
                }
            }, function (response) {
                _this12.loading = false;
            });
        },
        loadVehicule: function loadVehicule() {
            var _this13 = this;

            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            this.loading = true;
            var url = this.domaine + 'parc/index/type' + '/' + type;
            this.$http.get(url).then(function (response) {

                if (response.body) {
                    _this13.listVehicule = response.body.vehicule;
                    _this13.nbVehTot = response.body.nbVeh;
                    _this13.nbVehDisp = response.body.nbVehDisp;
                    _this13.nbVehUtil = response.body.nbVehUtil;
                    _this13.nbVehPan = response.body.nbVehPan;
                    _this13.nbVehLoc = response.body.nbVehLoc;
                    _this13.nbVehRep = response.body.nbVehRep;
                    _this13.nbAssurAbs = response.body.nbAssurAbs;
                    _this13.nbAssurAexp = response.body.nbAssurAexp;
                    _this13.nbVisiteTechAbs = response.body.nbVisiteTechAbs;
                    _this13.nbVisiteTechExp = response.body.nbVisiteTechExp;
                    _this13.nbVignetteAbs = response.body.nbVignetteAbs;
                    _this13.nbVignetteExp = response.body.nbVignetteExp;
                    _this13.loading = false;
                    if (_this13.notif === 'active') {
                        if (response.body.mesAlert != "") {
                            _this13.$vs.notify({
                                title: 'NOTIFICATIONS VEHICULES',
                                text: response.body.mesAlert,
                                color: 'warning',
                                position: 'top-right',
                                time: 10000
                            });
                        }

                        if (_this13.nbAssurAbs != 0) {
                            _this13.$vs.notify({
                                title: 'ASSURANCE NON-VALIDE',
                                text: response.body.nbAssurAbs + " vehicule(s) ne possede(nt) ou n'ont pas une assurance valide",
                                color: 'danger',
                                position: 'top-left',
                                icon: 'description',
                                time: 10000
                            });
                        }

                        if (_this13.nbAssurAexp != 0) {
                            _this13.$vs.notify({
                                title: 'EXPIRATION ASSURANCE',
                                text: response.body.nbAssurAexp + " assurance(s) vont expirer dans moins de 3 mois",
                                color: 'warning',
                                position: 'top-left',
                                icon: 'description',
                                time: 10000
                            });
                        }

                        if (_this13.nbVisiteTechAbs != 0) {
                            _this13.$vs.notify({
                                title: 'VISITE TECHNIQUE NON-VALIDE',
                                text: response.body.nbVisiteTechAbs + " vehicule(s) ne possede(nt) ou n'ont pas une visite technique valide",
                                color: 'danger',
                                position: 'top-left',
                                icon: 'description',
                                time: 10000
                            });
                        }

                        if (_this13.nbVisiteTechExp != 0) {
                            _this13.$vs.notify({
                                title: 'EXPIRATION VISITE TECHNIQUE',
                                text: response.body.nbVisiteTechExp + " visite(s)  technique vont expirer dans moins de  3 mois",
                                color: 'warning',
                                position: 'top-left',
                                icon: 'description',
                                time: 10000
                            });
                        }

                        if (_this13.nbVignetteAbs != 0) {
                            _this13.$vs.notify({
                                title: 'VIGNETTE NON-VALIDE',
                                text: response.body.nbVignetteAbs + " vehicule(s) ne possede(nt) ou n'ont pas une vignette valide",
                                color: 'danger',
                                position: 'top-left',
                                icon: 'description',
                                time: 10000
                            });
                        }

                        if (_this13.nbVignetteExp != 0) {
                            _this13.$vs.notify({
                                title: ' EXPIRATION VIGNETTE',
                                text: response.body.nbVignetteExp + " vignettes(s) vont expirer dans moins de 3 mois",
                                color: 'warning',
                                position: 'top-left',
                                icon: 'description',
                                time: 10000
                            });
                        }
                    }
                }
            });
        },
        deleteVeh: function deleteVeh() {
            var _this14 = this;

            this.loading = true;
            var url = this.domaine + "parc/vehicule/delete/" + this.idVehModif;
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this14.loading = false;
                    _this14.$notify({
                        title: "SUPPRESSION",
                        message: "Le vehicule a été  supprimé avec succès.",
                        type: "success",
                        position: "top-right",
                        duration: 5000
                    });
                    _this14.dialogSuppVeh = false;
                    _this14.idVehModif = null;
                    _this14.loadVehicule();
                }
            }, function (response) {
                _this14.dialogSuppVeh = false;
                _this14.$message.error("Erreur,Veuillez supprimer d'abord l'assurance, la vidange, la visite technique de cet véhicule");
                _this14.loading = false;
            });
        },
        onFileCartePicked: function onFileCartePicked(event) {
            var _this15 = this;

            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }
            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this15.imageCarteGris = fileReader.result;
            });
            fileReader.readAsDataURL(files[0]);
            this.fileCarteGris = files[0];
        },
        onFileVehPicked: function onFileVehPicked(event) {
            var _this16 = this;

            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this16.imageVeh = fileReader.result;
            });

            fileReader.readAsDataURL(files[0]);
            this.fileVeh = files[0];
        }
    },
    mounted: function mounted() {
        this.loadCategorie();
        this.loadCarburant();
        this.loadParc();
        var type = this.$route.params.type;
        if (this.$route.params.etat_veh == undefined || this.$route.params.etat_veh == 0) {
            this.typeVehicule = this.$route.params.type;
            this.loadVehicule(type);
        } else {
            // this.selectEtatVeh = this.$route.params.etat_veh
            this.typeVehicule = this.$route.params.etat_veh;
            this.loadVehiculeParEtat(this.$route.params.etat_veh);
        }
    }
});

/***/ }),

/***/ "DtXX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item,ind){return _c('v-breadcrumbs-item',{key:ind,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v(" "+_vm._s(item.text))])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":"","ml-1":"","mr-1":"","mt-1":""}},[_c('v-card',[_c('el-tabs',{attrs:{"stretch":"true","type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick(_vm.onglet)}},model:{value:(_vm.onglet),callback:function ($$v) {_vm.onglet=$$v},expression:"onglet"}},[_c('el-tab-pane',{attrs:{"label":" Confirmation paiement des factures"}},[_c('facturePaiement')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":" Validation devis / facture & Demande d'absence"}},[_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeDmdCom))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total  à valider: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntTotalDmdComTTC)+" Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbDmdCom))]),_vm._v("\n                                                    Commandes à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Demandeur"},on:{"clear":function($event){return _vm.clearSelectFour()},"change":_vm.filtrerDmdFond},model:{value:(_vm.selectDmdCom),callback:function ($$v) {_vm.selectDmdCom=$$v},expression:"selectDmdCom"}},_vm._l((_vm.listeDemandeurCom),function(item,ind){return _c('el-option',{key:ind,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeDmdCom}},[_c('el-table-column',{attrs:{"prop":"dateLivr","label":"Date de livraison"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demandeur","label":"Demandeur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projet","label":"Projet"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chantier","label":"Chantier"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"travaux","label":"travaux"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailDmdCom(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                                Detail\n                                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeMiss))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total des demandes de mission à validées: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntTotalMissTTC)+" Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbMiss))]),_vm._v("\n                                                    Missions à  valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Mission par demandeur"},on:{"clear":function($event){return _vm.clearSelectMissDemd()},"change":_vm.filtrerMissDemd},model:{value:(_vm.selectMissDemd),callback:function ($$v) {_vm.selectMissDemd=$$v},expression:"selectMissDemd"}},_vm._l((_vm.listeDemandeurs),function(item,ind){return _c('el-option',{key:ind,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeMissions}},[_c('el-table-column',{attrs:{"prop":"date","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demandeur","label":"demandeur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"budget","label":"Budget (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(_vm._s(scope.row.budget))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"activite","label":"Activite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailMissDemd(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                                Detail\n                                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeFour))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total des factures  à valider: ")]),_vm._v("  "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(new Intl.NumberFormat().format(_vm.mntTotalFactTTC))+" Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbFactFour))]),_vm._v("\n                                                    Factures à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Facture par fournisseur"},on:{"clear":function($event){return _vm.clearSelectFour()},"change":_vm.filtrerFour},model:{value:(_vm.selectFour),callback:function ($$v) {_vm.selectFour=$$v},expression:"selectFour"}},_vm._l((_vm.listeFournisseurs),function(item,ind){return _c('el-option',{key:ind,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeFacturesFour}},[_c('el-table-column',{attrs:{"prop":"date","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref","label":"Référence"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(_vm._s(new Intl.NumberFormat('fr-Fr').format(scope.row.total)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleFour","label":"Fournisseur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailFour(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                                Detail\n                                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeInterv))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total des réparations à valider: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntTotalIntervTTC)+" Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbInterv))]),_vm._v("\n                                                    Intervention à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Intervention par demandeur"},on:{"clear":function($event){return _vm.clearSelectInterv()},"change":_vm.filtrerInterv},model:{value:(_vm.selectInterv),callback:function ($$v) {_vm.selectInterv=$$v},expression:"selectInterv"}},_vm._l((_vm.listeDemdInterv),function(item,ind){return _c('el-option',{key:ind,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeIntervention}},[_c('el-table-column',{attrs:{"prop":"date","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"IdInterv","label":"Référence"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"garage","label":"Garage"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotCom","label":"Montant(fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.mntTotCom)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demandeur","label":"Demandeur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"priorite","label":"Priorité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.priorite == 'Moins urgent')?_c('el-tag',{attrs:{"type":"info"}},[_vm._v("  "+_vm._s(scope.row.priorite))]):_vm._e(),_vm._v(" "),(scope.row.priorite == 'Urgent')?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.priorite))]):_vm._e(),_vm._v(" "),(scope.row.priorite == 'Très urgent')?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.priorite))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailInterv(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                                Detail\n                                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeDmdFond))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total  à valider: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntTotalDmdFondTTC)+" Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbDmdFond))]),_vm._v("\n                                                    Demande de fonds à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Demandeur"},on:{"clear":function($event){return _vm.clearSelectFour()},"change":_vm.filtrerDmdFond},model:{value:(_vm.selectDmdFond),callback:function ($$v) {_vm.selectDmdFond=$$v},expression:"selectDmdFond"}},_vm._l((_vm.listeDemandeurFond),function(item,ind){return _c('el-option',{key:ind,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeDmdFond}},[_c('el-table-column',{attrs:{"prop":"dateFormat","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demandeur","label":"Nom du demandeur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantFormat","label":"Montant (Fcfa)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"typeDmd","label":"Type demande"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailDmdFond(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                                Detail\n                                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.droitAcces.all_appro_no_valid_dg)?_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeAppro))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total  à valider: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntTotalAppro)+" F Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:" mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbAppro))]),_vm._v("\n                                                    Approvisionnement(s) à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Facture par fournisseur"},on:{"clear":function($event){return _vm.clearSelectFour()},"change":_vm.filtrerFour},model:{value:(_vm.selectFour),callback:function ($$v) {_vm.selectFour=$$v},expression:"selectFour"}},_vm._l((_vm.listeFournisseurs),function(item,ind){return _c('el-option',{key:ind,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeDmdNoValidAppro}},[_c('el-table-column',{attrs:{"prop":"dateDmd","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"caisseLibelle","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(_vm._s(scope.row.montant)+" FCFA")])]}}],null,false,1202447318)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailAppro(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                            Detail\n                                                        ")],1)]}}],null,false,2190206670)})],1)],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeDmd))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbDmdMaint))]),_vm._v("\n                                                    Maintenances à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Demande par zone"},on:{"clear":function($event){return _vm.clearSelectDmdZone()},"change":_vm.filtrerZoneDmd},model:{value:(_vm.selectZoneDmd),callback:function ($$v) {_vm.selectZoneDmd=$$v},expression:"selectZoneDmd"}},_vm._l((_vm.comboZoneDmd),function(item,ind){return _c('el-option',{key:ind,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeDemandes}},[_c('el-table-column',{attrs:{"prop":"date","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nomDemandeur","label":"demandeur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libZone","label":"Zone"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libPriorite","label":"Priorité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 3)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.libPriorite))]):_vm._e(),_vm._v(" "),(scope.row.priorite == 0)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v("  "+_vm._s(scope.row.libPriorite))]):_vm._e(),_vm._v(" "),(scope.row.priorite == 1)?_c('el-tag',[_vm._v(_vm._s(scope.row.libPriorite))]):_vm._e(),_vm._v(" "),(scope.row.priorite == 2)?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.libPriorite))]):_vm._e(),_vm._v(" "),(scope.row.priorite == 3)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.libPriorite))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailDmd(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                                Detail\n                                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.droitAcces.all_appro_no_valid_dg)?_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v("LISTE DES DEMANDES DE CONGES")])],1),_vm._v(" "),_c('v-card-title',[_c('v-flex',{attrs:{"xs12":""}},[_c('listeDemande',{attrs:{"statutDemande":1}})],1)],1)],1)],1):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450"},model:{value:(_vm.dialogValideSuivant),callback:function ($$v) {_vm.dialogValideSuivant=$$v},expression:"dialogValideSuivant"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(" Validation suivante ")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez-vous passer à la validation suivante ?","closable":false,"show-icon":"","type":"warning"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogValideSuivant = false}}},[_vm._v("Non")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideSuivant()}}},[_vm._v("Afficher le fiche suivante")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450"},model:{value:(_vm.dialogValideSuivant),callback:function ($$v) {_vm.dialogValideSuivant=$$v},expression:"dialogValideSuivant"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(" Validation suivante ")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez-vous passer à la validation suivante ?","closable":false,"show-icon":"","type":"warning"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){return _vm.CancelValideSuivant()}}},[_vm._v("Non")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideSuivant()}}},[_vm._v("Afficher le fiche suivante")])],1)],1)],1)],1),_vm._v(" "),_c('ModalValidationInterv',{attrs:{"intervDetail":_vm.intervDetail,"totalFact":_vm.mntTotalIntervTTC,"show":_vm.showModalIntervFact},on:{"close":_vm.showDialogIntervAfter}}),_vm._v(" "),_c('ModalValidationFacture',{attrs:{"factureDetail":_vm.factureDetail,"totalFact":_vm.mntTotalFactTTC,"show":_vm.showModalDetailFact,"listCaisse":_vm.listCaisse,"listBanque":_vm.listBanque,"commandeDeriv":_vm.commandeDeriv,"commandeDerivDeux":_vm.commandeDerivDeux,"mntTotalCmd":_vm.mntTotalCmd,"nbCommandeSug":_vm.nbCommandeSug,"nbCommandeSugDeux":_vm.nbCommandeSugDeux},on:{"close":_vm.showDialogFactAfter}}),_vm._v(" "),_c('ModalValidationDmd',{attrs:{"demandeDetail":_vm.demandeDetail,"show":_vm.showModalDetailDmd},on:{"close":_vm.showDialogDmdAfter}}),_vm._v(" "),_c('ModalValidationMiss',{attrs:{"detailMission":_vm.detailMission,"show":_vm.showModalDetailMiss},on:{"close":_vm.showDialogMissAfter}}),_vm._v(" "),_c('ModalValidationDmdFond',{attrs:{"valider":true,"logistique":true,"demandeDetail":_vm.demandeDetail,"show":_vm.showModalDetailDmdFond},on:{"close":_vm.showDialogDmdFondAfter}}),_vm._v(" "),_c('ModalValidationAppro',{attrs:{"approDetail":_vm.ApproDetail,"listCaisse":_vm.listCaisse,"listBanque":_vm.listBanque,"show":_vm.showModalDetailAppro},on:{"close":function($event){_vm.showModalDetailAppro = false; _vm.loadDmdNoValidAppro()}}}),_vm._v(" "),_c('ModalValidationDmdCom',{attrs:{"detailCommande":_vm.detailCommande,"totalMontant":_vm.totalMontant,"show":_vm.showModalDetailDmdCom},on:{"close":_vm.showDialogComAfter}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E+pB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E/of":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_detail_prof_vue__ = __webpack_require__("uPRn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dcc44da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_detail_prof_vue__ = __webpack_require__("Besz");
function injectStyle (ssrContext) {
  __webpack_require__("y7Bl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9dcc44da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_detail_prof_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dcc44da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_detail_prof_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EBtP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('v-card',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n            LISTE DES DEMANDES A VALIDER "),_c('v-icon',{attrs:{"right":""}},[_vm._v("assignment")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Recherche","single-line":"","hide-details":""},model:{value:(_vm.searchRequest),callback:function ($$v) {_vm.searchRequest=$$v},expression:"searchRequest"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headersRequestValid,"search":_vm.searchRequest,"pagination":_vm.paginationRequestValid,"items":_vm.listRequestValid,"hide-actions":""},on:{"update:pagination":function($event){_vm.paginationRequestValid=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.numero))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.nomDemandeur))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.created))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){$event.stopPropagation();return _vm.validRequest(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("done")])],1),_vm._v("\n                  Valider\n                ")],1)],1)])]}}])}),_vm._v(" "),_c('div',{staticClass:"text-xs-center pt-2"},[_c('v-pagination',{attrs:{"length":_vm.pagesRequest},model:{value:(_vm.paginationRequestValid.page),callback:function ($$v) {_vm.$set(_vm.paginationRequestValid, "page", $$v)},expression:"paginationRequestValid.page"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n            LISTE DES DEVIS A VALIDER "),_c('v-icon',{attrs:{"right":""}},[_vm._v("assignment")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Recherche","single-line":"","hide-details":""},model:{value:(_vm.searchDevis),callback:function ($$v) {_vm.searchDevis=$$v},expression:"searchDevis"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headersDevisValid,"search":_vm.searchDevis,"pagination":_vm.paginationDevisValid,"items":_vm.listDevisValid,"hide-actions":""},on:{"update:pagination":function($event){_vm.paginationDevisValid=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.numero))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.nomDemandeur))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.created))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){$event.stopPropagation();return _vm.validDevis(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                  Modifier\n                ")],1)],1)])]}}])}),_vm._v(" "),_c('div',{staticClass:"text-xs-center pt-2"},[_c('v-pagination',{attrs:{"length":_vm.pagesDevis},model:{value:(_vm.paginationDevisValid.page),callback:function ($$v) {_vm.$set(_vm.paginationDevisValid, "page", $$v)},expression:"paginationDevisValid.page"}})],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.modalValidation),callback:function ($$v) {_vm.modalValidation=$$v},expression:"modalValidation"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Alerte !!!")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.modalValidation = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"flat":"","color":"blue darken-1","large":""},on:{"click":function($event){$event.stopPropagation();return _vm.accepterDemande($event)}}},[_vm._v("Accepter")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red","large":""},on:{"click":_vm.refuserDemande}},[_vm._v("Refuser")])],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EMUM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
    name: "formAbsence",
    props: {
        nbJrsRestantVacance: {
            type: Number,
            default: 0
        }
    },
    data: function data() {
        return {
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,

            formDmdAbsence: {},
            listeTypeConge: [],
            listePhotos: []

        };
    },

    methods: {
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        },
        submitForm: function submitForm() {
            var _this = this;

            this.loading = true;
            var url = this.domaine + 'rh/absence/' + this.user.id;
            var data = new FormData();
            data.append("dataForm", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formDmdAbsence));

            if (this.listePhotos.length > 0) {
                this.listePhotos.forEach(function (file) {
                    data.append("fichierImage[]", file, file[name]);
                }, this);
            }

            this.$http.post(url, data).then(function (response) {
                _this.loading = false;
                if (response.body.code == 0) {
                    _this.$alert(response.body.message, "Demande d'absence", {
                        confirmButtonText: 'OK'
                    });
                    return;
                }
                _this.formDmdAbsence.datedbtFin = '';
                _this.formDmdAbsence.idTypeConge = '';
                _this.formDmdAbsence.desc = '';

                _this.resetForm('formAbsence');
                _this.closeForm();

                _this.successNotif(response.body.message);
                _this.listePhotos.splice(0);
            }, function (error) {
                _this.loading = false;
                _this.$message.error("Echec lors de l'enregistrement de la demande");
            });
        },
        loadTypeConge: function loadTypeConge() {
            var _this2 = this;

            var url = this.domaine + 'rh/listeTypeConge';
            this.$http.get(url).then(function (resData) {
                _this2.listeTypeConge = resData.body.listeAbsences;
            }, function (error) {
                _this2.loading = false;
                _this2.$message.error("Echec lors du chargement de al liste des type de congé");
            });
        },
        resetForm: function resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        closeForm: function closeForm() {
            this.$emit("close");
        },
        changeFile: function changeFile(file, fileList) {
            this.listePhotos.splice(0);
            var fileReader = new FileReader();

            for (var ind in fileList) {
                var filename = fileList[ind].name;
                if (filename.lastIndexOf(".") <= 0) {
                    return alert("Veuillez selectionner un  format de fichier valide ");
                }
                //fileReader.readAsDataURL(fileList[ind].raw)
                this.listePhotos.push(fileList[ind].raw);
            }

            // fileReader.addEventListener("load", () => {
            //     this.listePhotos = fileReader.result
            // })

        }
    },
    computed: {
        formIsValid: function formIsValid() {

            if (this.formDmdAbsence.datedbtFin == null || this.formDmdAbsence.idTypeConge == null || this.formDmdAbsence.desc == "" || this.formDmdAbsence.desc == undefined) {
                return false;
            } else {
                return true;
            }
        }
    },
    mounted: function mounted() {
        this.loadTypeConge();
    }
});

/***/ }),

/***/ "EQwH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogModalCommandeMAJ),callback:function ($$v) {_vm.dialogModalCommandeMAJ=$$v},expression:"dialogModalCommandeMAJ"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Détails de la commande")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n            DETAILS DE LA COMMANDE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),_c('v-form',{ref:"formComm",attrs:{"lazy-validation":"","id":"formComm"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Fournisseur")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":true,"placeholder":"Fournisseur","name":"fournisseur"},model:{value:(_vm.fournisseurCommandeId),callback:function ($$v) {_vm.fournisseurCommandeId=$$v},expression:"fournisseurCommandeId"}},_vm._l((_vm.listFournisseur),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Intitulé de la commande")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Intitulé de la commande"},model:{value:(_vm.libelleCommande),callback:function ($$v) {_vm.libelleCommande=$$v},expression:"libelleCommande"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Priorité")]),_vm._v(" "),_c('el-select',{attrs:{"disabled":true,"trigger-on-focus":true},model:{value:(_vm.prioriteCommande),callback:function ($$v) {_vm.prioriteCommande=$$v},expression:"prioriteCommande"}},_vm._l((_vm.priorites),function(priorite){return _c('el-option',{key:priorite.value,attrs:{"label":priorite.label,"value":priorite.value}})}),1)],1)])],1),_vm._v(" "),(_vm.detailCommande && _vm.detailCommande.entrepotId)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Magasin chantier")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"maintenance","readonly":true},model:{value:(_vm.detailCommande.libEntrepot),callback:function ($$v) {_vm.$set(_vm.detailCommande, "libEntrepot", $$v)},expression:"detailCommande.libEntrepot"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.detailCommande && _vm.detailCommande.projetId)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné ")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Type de Projet"},on:{"change":function($event){return _vm.loadChantier()}},model:{value:(_vm.projetS),callback:function ($$v) {_vm.projetS=$$v},expression:"projetS"}},_vm._l((_vm.listeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chantier concerné ")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Chantier concerné"},on:{"change":function($event){return _vm.loadTravaux()}},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux ")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Travaux"},model:{value:(_vm.travauxS),callback:function ($$v) {_vm.travauxS=$$v},expression:"travauxS"}},_vm._l((_vm.listeTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1):_vm._e(),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                PRODUIT(S) LIE(S) A LA COMMANDE\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),_vm._l((_vm.optionCommande),function(besoin){return _c('v-layout',{key:besoin.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ressource")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"produit","placeholder":"Ressource","readonly":true},model:{value:(besoin.produit),callback:function ($$v) {_vm.$set(besoin, "produit", $$v)},expression:"besoin.produit"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","value":"qte","placeholder":"Quantité","readonly":true},model:{value:(besoin.qte),callback:function ($$v) {_vm.$set(besoin, "qte", $$v)},expression:"besoin.qte"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité")]),_vm._v(" "),_c('el-input',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"trigger-on-focus":true,"readonly":true},model:{value:(besoin.unite),callback:function ($$v) {_vm.$set(besoin, "unite", $$v)},expression:"besoin.unite"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Priorité")]),_vm._v(" "),(besoin.priorite == 1)?_c('el-input',{attrs:{"value":"Faible","trigger-on-focus":true,"readonly":true}}):(besoin.priorite == 2)?_c('el-input',{attrs:{"value":"Normal","trigger-on-focus":true,"readonly":true}}):(besoin.priorite == 3)?_c('el-input',{attrs:{"value":"Urgent","trigger-on-focus":true,"readonly":true}}):_c('el-input',{attrs:{"value":"Aucune","trigger-on-focus":true,"readonly":true}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(
                      _vm.tailleOptionBesoinSupUn && besoin.besoinId != null
                    ),expression:"\n                      tailleOptionBesoinSupUn && besoin.besoinId != null\n                    "}],attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.preventDefault();return _vm.removeOptionBesoin(besoin)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                  Supprimer\n                ")],1)],1)],1)}),_vm._v(" "),_c('br')],2),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","dark":""},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Annuler"),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.updateCommande()}}},[_vm._v("Modifier"),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ebd3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EgS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-center",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h3',[_vm._v("Prévision du budget")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL TRAVAUX EN ATTENTE DE VALIDATION\n                                    : "+_vm._s(new
                                    Intl.NumberFormat().format(_vm.totalTravauxEnAttente))+" ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL MONTANT PROPOSE\n                                    : "+_vm._s(new
                                    Intl.NumberFormat().format(_vm.totalMntPropose))+" ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL MONTANT VALIDE\n                                    : "+_vm._s(new
                                    Intl.NumberFormat().format(_vm.totalMntValide))+" ")])])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-4 mt-2",attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableListeTrxBudget}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',{staticClass:"elevation-3 pl-4 pr-4 pt-2"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple mb-2"},[_c('v-alert',{staticClass:"mb-4",attrs:{"value":true,"outline":"","color":"primary","icon":"info"}},[_vm._v("Detail du budget\n                                                        ")]),_vm._v(" "),_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":props.row.detailBudget,"summary-method":_vm.getSumm,"show-summary":""}},[_c('el-table-column',{attrs:{"align":"center","prop":"libelle","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"montantPropose","label":"MONTANT PROPOSE"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                                        "+_vm._s(new Intl.NumberFormat().format(scope.row.montantPropose))+"\n                                                                    ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"montantValide","label":"MONTANT VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                                        "+_vm._s(new Intl.NumberFormat().format(scope.row.montantValide))+"\n                                                                    ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"mois","label":"MOIS"}})],1)],1)],1)])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Travaux","prop":"libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"montant proposé","prop":"mntBudgetPropose"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                            "+_vm._s(new Intl.NumberFormat().format(scope.row.mntBudgetPropose))+"\n                                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"montant validé","prop":"mntBudgetValide"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                            "+_vm._s(new Intl.NumberFormat().format(scope.row.mntBudgetValide))+"\n                                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":scope.row.etat == 1 ?  'success':'warning',"disable-transitions":""}},[_vm._v(_vm._s(scope.row.libEtat))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","prop":"action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat == 3 )?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalAjoutBudget(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1):_vm._e(),_vm._v("Etablir le budget\n                                            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat == 0)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){return _vm.modalAjoutBudget(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("Modifer le budget\n                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('AjoutPrevisionBudget',{attrs:{"show":_vm.showModalAjoutPrevision,"typeTrx":_vm.typeTravaux,"idProjet":_vm.projet.id},on:{"close":function($event){_vm.showModalAjoutPrevision = false;_vm.loadListeTravaux()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Eh/d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Erb4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_resourceHumaine_modelCarteEmploye__ = __webpack_require__("t0yD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_resourceHumaine_modalDetailEmploye__ = __webpack_require__("InPd");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    show: {
      type: Boolean
    }
  },
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */], modelCarteEmploye: __WEBPACK_IMPORTED_MODULE_1__components_resourceHumaine_modelCarteEmploye__["a" /* default */], modalDetailEmploye: __WEBPACK_IMPORTED_MODULE_2__components_resourceHumaine_modalDetailEmploye__["a" /* default */] },
  name: "listeEmploye",
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
      user: JSON.parse(sessionStorage.getItem('userInfo')),

      listeEmployes: [],
      loading: false,
      dialogShow: false,
      dialogAjout: false,
      dialogService: false,
      dialogListService: false,
      dialogEdit: false,
      formUser: {
        mUser: '',
        matricule: '',
        nomUser: '',
        emailUser: '',
        civilite: '',
        contactUser: '',
        fonctionUser: '',
        adresse: ''
      },
      logoUser: "/static/img-doc.png",

      selectTypeUser: '',
      serviceUserRules: [function (v) {
        return !!v || 'Veuillez sélectionner votre service.';
      }],
      serviceCiviliteRules: [function (v) {
        return !!v || 'Veuillez sélectionner votre genre.';
      }],
      loginUserRules: [function (v) {
        return !!v || 'Le E-mail est obligatoire';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([-]?\w+)*(.\w{2,3})+$/.test(v) || 'Vous devez respecter format de E-mail'
        );
      }],
      nomUserRules: [function (v) {
        return !!v || 'Le nom est obligatoire';
      }, function (v) {
        return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
      }],
      contactUserRules: [function (v) {
        return !!v || "Le contact de l'utilisateur est obligatoire";
      }, function (v) {
        return (/[0-9]/.test(v) || 'Vous devez respecter format du contact'
        );
      }],
      photo: '',
      loginUser: '',
      selectServiceUser: null,
      selectGenreUser: null,
      formTri: {},
      listeServices: [],
      listePostes: [],
      typeUser: [{ text: "Membre de l'entreprise", value: 1 }],
      listCivilie: [{ text: "Masculin", value: 1 }, { text: 'Feminin', value: 2 }],
      listeTypeContrat: [{
        label: "Stagiaire formation",
        value: 1
      }, {
        label: "Stagiaire Professionnel",
        value: 3
      }, {
        label: "Temps partiel",
        value: 5
      }, {
        label: "Consultant",
        value: 7
      }, {
        label: "CDI",
        value: 9
      }, {
        label: "CDD",
        value: 11
      }],
      users: [],
      valid: true,
      desactiveBout: false,
      employSelect: null,
      showDetailEmpl: false,
      loadingService: false,
      libelle: '',
      libelleRules: [function (v) {
        return !!v || "Veuillez renseigner le libellé";
      }],
      selectChef: null,
      chef: '',
      chefRules: [function (v) {
        return !!v || "Veuillez sélectionner le responsable du service";
      }],
      serviceCourant: [],
      detailService: [],
      listService: []

    };
  },

  watch: {
    show: function show(newValue, oldValue) {
      if (newValue == true && this.listeEmployes.length == 0) {
        this.loadEmploye();
      }
    }
  },
  methods: {
    rechercheUser: function rechercheUser() {
      var _this = this;

      this.loading = true;
      this.listeEmployes = [];
      var url = this.domaine + 'userCreate/userbycritere';
      var data = {
        nom: this.formTri.nom,
        serviceId: this.formTri.service,
        posteId: this.formTri.poste,
        typeContrat: this.formTri.contrat
      };

      this.$http.get(url, { params: data }).then(function (response) {
        _this.listeEmployes = response.body.listeUsers;
        _this.loading = false;
      }, function (err) {
        _this.loading = false;
        _this.$message.error("Chargement de la liste de recherche des employes, verifier votre connexion");
      });
    },
    submitService: function submitService() {
      var _this2 = this;

      if (this.$refs.formService.validate()) {
        this.loadingService = true;
        var form = document.getElementById('formService');
        var data = new FormData(form);
        data.append('idUser', this.user.id);
        data.append('chef', this.selectChef);
        var url = '';
        if (this.serviceCourant.id) {
          url = this.domaine + 'webService/' + this.serviceCourant.id + '/edit/service';
        } else {
          url = this.domaine + 'webService/new/service';
        }
        this.$http.post(url, data).then(function (response) {
          _this2.loadingService = false;
          if (response.body) {

            var verif = response.body;
            if (verif.code === 1) {
              if (_this2.serviceCourant.id) {
                _this2.$notify({
                  title: 'MODIFICATION REUSSI',
                  message: 'Service modifié avec succès.',
                  type: 'success',
                  position: 'top-center'
                });
              } else {
                _this2.$notify({
                  title: 'ENREGISTREMENT REUSSI',
                  message: 'Service enregistré avec succès.',
                  type: 'success',
                  position: 'top-center'
                });
              }
              _this2.dialogService = false;
              _this2.dialogShow = false;
              _this2.loadListService();
              _this2.loadingService = false;
            } else if (verif.code === 0) {
              _this2.$message.error(verif.message);
              _this2.loadingService = false;
            }
          } else {
            _this2.$message.error('Erreur serveur');
            _this2.loadingService = false;
          }
        }, function (response) {
          _this2.$message.error('Erreur serveur');
          _this2.loadingService = false;
        });
      } else {
        this.$message.error('Veuillez renseigner les champs obligatoires');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le service n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loadingService = false;
      }
    },
    submit: function submit() {
      var _this3 = this;

      this.loading = true;
      if (this.$refs.formUser.validate()) {
        //if (this.mdpUser === this.mdpVerUser)
        //{
        var form = document.getElementById('formUser');
        var formdata = new FormData(form);
        var url = '';
        url = this.domaine + 'userCreate/new';
        formdata.append('idUser', this.user.id);
        formdata.append('serviceUser', this.selectServiceUser);
        // formdata.append('fonctionUser', this.fonctionUser)
        // formdata.append('type', this.selectTypeUser)
        // formdata.append('nomUser', this.formUser.nomUser)
        // formdata.append('contactUser', this.formUser.contactUser)
        formdata.append('genre', this.selectGenreUser);
        // formdata.append('matricule', this.formUser.matricule)
        // formdata.append('emailUser', this.formUser.emailUser)
        // formdata.append('adresse', this.formUser.adresse)
        formdata.append('rh', "oui");
        formdata.append('poste', null);

        this.$http.post(url, formdata).then(function (response) {
          if (response.body) {
            var verif = response.body;
            _this3.loading = false;
            _this3.dialogAjout = false;
            if (verif.code === 2) {
              _this3.$notify({
                title: "L'UTILISATEUR A BIEN ETE AJOUTE",
                message: verif.message,
                type: 'success',
                position: 'top-center'
              });

              // this.loadUser()
            } else {
              _this3.$notify({
                title: "L'UTILISATEUR EXISTE DEJA",
                message: verif.message,
                type: 'error',
                position: 'top-center'
              });
            }
          }
        }, function (error) {
          _this3.$message.error('Erreur serveur');
          _this3.loading = false;
        });
        //} else {
        //this.$message.error('Le mot de passe de vérification doit être identique au mot de passe')
        //}
      } else {
        this.$message.error('Veuillez renseigner les champs obligatoires');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Utilisateur n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    editService: function editService(ligne) {
      this.serviceCourant = ligne;
      this.dialogService = true;
      this.dialogEdit = true;
      this.libelle = this.serviceCourant.libelle;
      this.selectChef = this.serviceCourant.idChef;
    },
    showService: function showService(ligne) {
      var _this4 = this;

      this.dialogShow = true;
      this.serviceCourant = ligne;
      var url = this.domaine + 'webService/' + this.serviceCourant.id + '/show/service';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this4.detailService = response.body.service;
        }
      });
    },

    //enregistrement des images
    onFileImageLogoPicked: function onFileImageLogoPicked(event) {
      var _this5 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this5.logoUser = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoUser = files[0];
    },
    newUser: function newUser() {
      this.dialogAjout = true;
      this.formUser = {};
      this.selectServiceUser = null;
      this.selectTypeUser = null;
      this.selectGenreUser = null;
      this.logoUser = "/static/img-doc.png";
    },
    closeListeEmp: function closeListeEmp() {
      this.$emit("close");
    },
    showDetailEmploye: function showDetailEmploye(idEmploye) {
      this.employSelect = idEmploye;
      this.showDetailEmpl = true;
    },
    loadEmploye: function loadEmploye() {
      var _this6 = this;

      var url = this.domaine + "rh/employes";
      this.loading = true;
      this.$http.get(url).then(function (resp) {
        _this6.loading = false;
        _this6.listeEmployes = resp.body.listeEmployes;
      }, function (error) {
        _this6.loading = false;
        _this6.$message.error("Echec lors du chargement de la liste des employés");
      });
    },
    loadListService: function loadListService() {
      var _this7 = this;

      var url = this.domaine + 'webService/liste-service';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this7.listService = response.body.service;
        }
      });
    },
    loadUser: function loadUser() {
      var _this8 = this;

      var url = this.domaine + 'userCreate/user-list';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this8.users = response.body;
        }
      });
    },
    newService: function newService() {
      this.dialogService = true;
      this.dialogEdit = false;
      this.libelle = "";
      this.selectChef = "";
    },
    loadService: function loadService() {
      var _this9 = this;

      var url = this.domaine + "userCreate/liste/service";
      this.loading = true;
      this.$http.get(url).then(function (resp) {
        _this9.loading = false;
        _this9.listeServices = resp.body.listeServices;
      }, function (error) {
        _this9.loading = false;
        _this9.$message.error("Echec lors du chargement de la liste des services");
      });
    },
    loadPoste: function loadPoste() {
      var _this10 = this;

      var url = this.domaine + "rh/liste/poste";
      this.loading = true;
      this.$http.get(url).then(function (resp) {
        _this10.loading = false;
        _this10.listePostes = resp.body.listePostes;
      }, function (error) {
        _this10.loading = false;
        _this10.$message.error("Echec lors du chargement de la liste des postes");
      });
    }
  },
  mounted: function mounted() {
    this.loadPoste();
    // this.loadService();
  }
});

/***/ }),

/***/ "Et9W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('h4',{attrs:{"mt-3":""}},[_vm._v("LISTES DES RAPPORTS TRAVAUX")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":"","elevation-2":"","pt-3":"","pl-3":""}},[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"99%"},attrs:{"data":_vm.RapportTrx},on:{"selection-change":_vm.handleSelectionChange}},[(_vm.typeInterface)?_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',{staticClass:"elevation-3 pl-4 pr-4 pt-2"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple mb-2"},[(props.row && Array.isArray(props.row.journal) && props.row.journal.length > 0)?_c('div',[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":props.row.journal,"align":"center"}},[_c('el-table-column',{attrs:{"prop":"trancon","label":"Trançon","align":"center","width":"300","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateRapport","label":"Date","align":"center","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"initiateur","label":"INITIATEUR","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libEtat","label":"ETAT","align":"center","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.activite === 'NON')?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v("Aucune activité \n                            ")]):_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.libEtat))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","width":"180","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etatRapport === 0)?_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"orange"},on:{"click":function($event){return _vm.editRapportJour(scope.row)}},slot:"activator"},[_vm._v("\n                                Modifier\n                              ")]):_vm._e()],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"blue"},on:{"click":function($event){$event.stopPropagation();return _vm.loadDetailRapport(scope.row)}},slot:"activator"},[_vm._v("\n                                Détails\n                              ")]),_vm._v("\n                              Détails\n                            ")],1),_vm._v(" "),(scope.row.etatRapport === 0)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSupr = true;
                                  _vm.inter = 'RAPPORT';
                                  _vm.IdRapport = scope.row;}},slot:"activator"},[_vm._v("\n                                Supprimer\n                              ")]),_vm._v("\n                              Supprimer\n                            ")],1):_vm._e()],1)]}}],null,true)})],1)],1):_vm._e(),_vm._v(" "),(props.row && Array.isArray(props.row.journal) && props.row.journal.length == 0)?_c('div',[_c('p',[_vm._v("  "+_vm._s(props.row.motif == 'undefined' ? "Non défini" : props.row.motif))])]):_vm._e()])])],1)]}}],null,false,3942653333)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idRapport","label":"RAPPORT","width":"90","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("ID-"+_vm._s(scope.row.idRapport))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateRapport","width":"100","label":"Date du rapport","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libTrx","label":"Travaux","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libEtat","width":"250","label":"ETAT","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.journal.length == 0)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v("Aucune activité effectuée")]):_vm._e(),_vm._v(" "),(scope.row.etatRapport == 0 && scope.row.journal.length > 0)?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.libEtat))]):_vm._e(),_vm._v(" "),(scope.row.etatRapport == 1 && scope.row.journal.length > 0)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.libEtat))]):_vm._e(),_vm._v(" "),(scope.row.etatRapport == 2 && scope.row.journal.length > 0)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.libEtat))]):_vm._e(),_vm._v(" "),(scope.row.etatRapport == 3 && scope.row.journal.length > 0)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.libEtat))]):_vm._e(),_vm._v(" "),(scope.row.etatRapport == 4 && scope.row.journal.length > 0)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.libEtat))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.isDelete)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){_vm.dialogValidNewRapport=true;_vm.listDatat = scope.row}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("assignment")])],1),_vm._v("Detail rapport\n            ")],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.loadDetailGlobalRapport(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("assignment")])],1),_vm._v("Detail rapport\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(scope.row.isDelete)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSupr = true;
                  _vm.inter = 'RAPPORT_GLOBAL';
                  _vm.IdRapport = scope.row;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n              Supprimer\n            ")],1)]}}])})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer cet rapport ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteJournal($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogDetailRapport),callback:function ($$v) {_vm.dialogDetailRapport=$$v},expression:"dialogDetailRapport"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("RAPPORT DE TRAVAUX "+_vm._s(_vm.detailRapport.libTrx)+" N-"+_vm._s(_vm.detailRapport.idRapport))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogDetailRapport = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("Informations générales sur le rapport")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date Rapport")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailRapport.dateRapport))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Température")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailRapport.temp))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Pluie")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailRapport.pluie))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Vent")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailRapport.vent))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Nombre d'heure de travail *")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailRapport.nmbreHeur))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Trançon")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailRapport.trancon))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Du profil")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailRapport.profil))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Au profil")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailRapport.auProfil))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Initiateur")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v(_vm._s(_vm.detailRapport.initiateur))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de création")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailRapport.dateC))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Projet")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs12":""}},[_vm._v(_vm._s(_vm.detailRapport.projet))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v(_vm._s(_vm.detailRapport.chantier))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Statut")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[(_vm.detailRapport.etat === 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                      EN ATENTE DE VALIDATION\n                                      "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailRapport.etat === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                      VALIDE\n                                      "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailRapport.etat === 4)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                      REJETE\n                                      "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("TRAVAUX REALISES")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES TACHES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","mt-2":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.listeTaches}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',[_c('b',[_vm._v("Commentaire")]),_vm._v("\n                                        : "+_vm._s(props.row.commentaire)+"\n                                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libTache","label":"Libelle","sortable":""}}),_vm._v(" "),(_vm.soustraitant == 'OUI')?_c('el-table-column',{attrs:{"prop":"soustraitant","label":"Sous-traitant","sortable":""}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libEtatTache","label":"Etat"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"photos","label":"Images"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[_vm._l((props
                                            .row.photos),function(image,imageIndex){return _c('v-avatar',{key:imageIndex,staticClass:"mb-1 mr-1 elevation-3",style:({
                                            backgroundImage:
                                              'url(' + image + ')',
                                            cursor: 'pointer'
                                          }),attrs:{"slot":"activator","tile":true,"size":50,"color":"grey lighten-4"},on:{"click":function($event){return _vm.showDiapo(
                                              props.row.photos,
                                              imageIndex,
                                              image
                                            )}},slot:"activator"},[_c('img',{attrs:{"src":image,"alt":"avatar"}})])}),_vm._v("\n                                        Cliquez pour agrandir\n                                      ")],2)]}}])}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[(
                                            _vm.verifValideChefChant() ||
                                              _vm.verifValideChefProjet()
                                          )?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){$event.stopPropagation();return _vm.showDialogReserve(props.row)}},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Créer une réserve")])],1)]}}])})],1)],1)],1),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.detailRapport.listeReserves.length > 0)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("TRAVAUX DE RESERVE\n                    "+_vm._s(_vm.detailRapport.listeVehicules))]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES TRAVAUX DE RESERVE")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"data":_vm.detailRapport.listeReserves}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('h2',{staticClass:"mb-2"},[_vm._v("\n                                              Commentaires:\n                                            ")]),_vm._v(" "),_vm._l((scope.row
                                                .commentaires),function(com,i){return _c('div',{key:i,staticClass:"mb-2"},[_c('h3',[_vm._v("\n                                                Initiateur:\n                                                "+_vm._s(com.initiateur)+"\n                                              ")]),_vm._v(" "),_c('h4',[_vm._v("Date: "+_vm._s(com.dateCom))]),_vm._v(" "),_c('h4',[_vm._v("Description:")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(com.description))])])})],2)]),_vm._v(" "),_c('el-col',{attrs:{"span":14}},[_c('h2',{staticClass:"mb-2"},[_vm._v("Photos:")]),_vm._v(" "),_c('p',_vm._l((scope
                                                .row.photos),function(photo,index){return _c('span',{key:index},[_c('v-avatar',{staticClass:"mr-2",attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":photo,"alt":"avatar"}})])],1)}),0)])],1)]}}],null,false,793848742)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idReserve","label":"RESERVE","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("R-"+_vm._s(scope.row.idReserve))]}}],null,false,1760544068)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libTache","label":"TACHE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etatReserve","label":"ETAT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etatReserve == 0)?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.libEtatRes))]):_vm._e(),_vm._v(" "),(scope.row.etatReserve == 1)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.libEtatRes))]):_vm._e(),_vm._v(" "),(scope.row.etatReserve == 2)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.libEtatRes))]):_vm._e(),_vm._v(" "),(scope.row.etatReserve == 3)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.libEtatRes))]):_vm._e()]}}],null,false,492101708)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"initiateur","label":"INITIATEUR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"validateur","label":"VALIDATEUR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cout","label":"MONTANT"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dureeRetard","label":"DUREE RETARD (J)"}})],1)],1)],1),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("INCIDENTS")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES INCIDENTS")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.incidents}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',[_c('b',[_vm._v("Description")]),_vm._v("\n                                      : "+_vm._s(props.row.description)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libelle","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date et heure"}})],1)],1),_vm._v(" "),(_vm.detailRapport.incidents.length == 0)?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("VISITEUR CHANTIER")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES VISITEURS")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.listeVisiteurs}},[_c('el-table-column',{attrs:{"prop":"nomPrenom","label":"Nom & Prénoms","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fonction","label":"Fonction"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateVisite","label":"Date de visite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"HeureDbut","label":"Heure debut"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"HeureFin","label":"Heure debut"}})],1)],1),_vm._v(" "),(_vm.detailRapport.listeVisiteurs.length == 0)?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("INVENTAIRE DES RESSOURCES\n                  ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES RESSOURCES UTILISEES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.listeMateriels}},[_c('el-table-column',{attrs:{"prop":"libMat","label":"Ressources","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteMat","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}})],1)],1),_vm._v(" "),(_vm.detailRapport.listeMateriels.length == 0)?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("INVENTAIRE DES RESSOURCES EXTERNES")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES RESSOURCES EXTERNES UTILISEES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('br'),_vm._v(" "),(
                                _vm.detailRapport.listeExterneMateriels.length > 0
                              )?_c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                    TOTAL TRAVAIL : "+_vm._s(_vm.totalExterniHT)+"\n                                  ")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.listeExterneMateriels}},[_c('el-table-column',{attrs:{"prop":"type","label":"Type","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité ","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureDebut","label":"Heure debut"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureFin","label":"Heure fin"}})],1)],1),_vm._v(" "),(
                                _vm.detailRapport.listeExterneMateriels.length ==
                                  0
                              )?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("UTILISATION DES MATERIELS/ENGINS UTILISES")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES MATERIELS/ENGINS UTILISES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.detailRapport.listeVehicules.length > 0)?_c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                    TOTAL TRAVAIL : "+_vm._s(_vm.totalVehiHT)+"\n                                  ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                    TOTAL QUANTITE CARBURANT :\n                                    "+_vm._s(new Intl.NumberFormat("fr-Fr").format(
                                        _vm.totalQteCarb
                                      ))+"\n                                    LITRE(S)\n                                  ")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.listeVehicules}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',[_c('b',[_vm._v("Compteur début jour(km)")]),_vm._v("\n                                      : "+_vm._s(props.row.cptDjour)+"\n                                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Compteur fin jour(km)")]),_vm._v("\n                                      : "+_vm._s(props.row.cptFjour)+"\n                                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Prix (L) du carburant (FCFA)")]),_vm._v("\n                                      : "+_vm._s(props.row.cout)+"\n                                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Fournisseur")]),_vm._v("\n                                      : "+_vm._s(props.row.fournisseur)+"\n                                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description")]),_vm._v("\n                                      : "+_vm._s(props.row.description)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Matériel/Engin","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureDebut","label":"Heure début"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureFin","label":"Heure fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heurePause","label":"Heure pause"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureTotal","label":"Heure total"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité Carburant(L)","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"utilisation","label":"Côut horaire(FCFA)"}})],1)],1),_vm._v(" "),(_vm.detailRapport.listeVehicules.length == 0)?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("LISTE DES RESSOURCES TECHNIQUES")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES RESSOURCES TECHNIQUES UTILISEES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        TOTAL HEURE TRAVAIL : "+_vm._s(_vm.totalOuvrHT)+"\n                                    ")])],1)],1),_vm._v(" "),(this.totalOuvrHTHrSup != '00:00')?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        TOTAL HEURE SUPPLEMENTAIRE : "+_vm._s(_vm.totalOuvrHTHrSup)+"\n                                    ")])],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.listeParticipants}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [( props.row.heureSuppl != '00:00')?_c('v-flex',[_c('p',[_c('b',[_vm._v("Heure supplémentaire")]),_vm._v("\n                                          : "+_vm._s(props.row.heureSuppl)+"\n                                        ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description heure supplémentaire")]),_vm._v("\n                                          : "+_vm._s(props.row.descriptionSupp)+"\n                                        ")])]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description")]),_vm._v("\n                                          : "+_vm._s(props.row.description)+"\n                                        ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nomPrenom","label":"Nom & Prénoms","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"travaux","label":"Travaux","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureDbt","label":"Heure début","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureFin","label":"Heure fin","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heurePause","label":"Heure pause","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureIntem","label":"Heure Intemperie","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureTotal","label":"Heure travail","sortable":""}})],1)],1),_vm._v(" "),(_vm.detailRapport.listeParticipants &&
                                _vm.detailRapport.listeParticipants.length == 0
                              )?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('CoolLightBox',{attrs:{"items":_vm.items,"index":_vm.index},on:{"close":function($event){_vm.index = null}}}),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.verifValideChefProjet())?_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"green"},on:{"click":function($event){_vm.dialogValidRapport = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Valider la demande chef projet")])],1),_vm._v(" "),(_vm.verifValideChefChant())?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"purple"},on:{"click":function($event){_vm.dialogValidation = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v("Valider la demande chef chantier")])],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"ml-5",staticStyle:{"margin-bottom":"140px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"orange"},on:{"click":function($event){return _vm.imprimeJournalPDF(0)}},slot:"activator"},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('span',[_vm._v("Imprimer le rapport")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogDetailGblobalRapport),callback:function ($$v) {_vm.dialogDetailGblobalRapport=$$v},expression:"dialogDetailGblobalRapport"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("RAPPORT ID-"+_vm._s(_vm.detailRapport.idRapport)+" DE TRAVAUX DU\n          "+_vm._s(_vm.detailRapport.dateRapport)+" :\n          "+_vm._s(_vm.detailRapport.libTrx))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogDetailGblobalRapport = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("Informations générales sur le rapport")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Date de création")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[_vm._v(_vm._s(_vm.detailRapport.dateRapport))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Etat")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v(_vm._s(_vm.detailRapport.libEtat))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Projet")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[_vm._v(_vm._s(_vm.detailRapport.projet))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[_vm._v(_vm._s(_vm.detailRapport.chantier))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Statut")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[(_vm.detailRapport.etat === 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                      EN ATENTE DE VALIDATION\n                                      "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailRapport.etat === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                      VALIDE\n                                      "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailRapport.etat === 4)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                      REJETÉ\n                                      "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Travaux")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailRapport.libTrx))])],1)],1),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.listeRapport,"align":"center"}},[_c('el-table-column',{attrs:{"prop":"trancon","label":"Trançon","align":"center","width":"300","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateRapport","label":"Date","align":"center","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"initiateur","label":"INITIATEUR","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libEtat","label":"ETAT","align":"center","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etatRapport == 0)?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.libEtat))]):_vm._e(),_vm._v(" "),(scope.row.etatRapport == 1)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.libEtat))]):_vm._e(),_vm._v(" "),(scope.row.etatRapport == 2)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.libEtat))]):_vm._e(),_vm._v(" "),(scope.row.etatRapport == 3)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.libEtat))]):_vm._e(),_vm._v(" "),(scope.row.etatRapport == 4)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.libEtat))]):_vm._e()]}}])})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("TRAVAUX REALISES")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES TACHES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","mt-2":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.listeTaches}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',[_c('b',[_vm._v("Commentaire")]),_vm._v("\n                                        : "+_vm._s(props.row.commentaire)+"\n                                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libTache","label":"Libelle","sortable":""}}),_vm._v(" "),(_vm.soustraitant == 'OUI')?_c('el-table-column',{attrs:{"prop":"soustraitant","label":"Sous-traitant","sortable":""}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libEtatTache","label":"Etat"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"photos","label":"Images"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[_vm._l((props
                                            .row.photos),function(image,imageIndex){return _c('v-avatar',{key:imageIndex,staticClass:"mb-1 mr-1 elevation-3",style:({
                                            backgroundImage:
                                              'url(' + image + ')',
                                            cursor: 'pointer'
                                          }),attrs:{"slot":"activator","tile":true,"size":50,"color":"grey lighten-4"},on:{"click":function($event){return _vm.showDiapo(
                                              props.row.photos,
                                              imageIndex,
                                              image
                                            )}},slot:"activator"},[_c('img',{attrs:{"src":image,"alt":"avatar"}})])}),_vm._v("\n                                        Cliquez pour agrandir\n                                      ")],2)]}}])}),_vm._v(" "),_c('el-table-column',{scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[(
                                            _vm.verifValideChefChant() ||
                                              _vm.verifValideChefProjet()
                                          )?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){$event.stopPropagation();return _vm.showDialogReserve(props.row)}},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Créer une réserve")])],1)]}}])})],1)],1)],1),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.detailRapport.listeReserves.length > 0)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("TRAVAUX DE RESERVE")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES TRAVAUX DE RESERVE")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"data":_vm.detailRapport.listeReserves}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('h2',{staticClass:"mb-2"},[_vm._v("\n                                              Commentaires:\n                                            ")]),_vm._v(" "),_vm._l((scope.row
                                                .commentaires),function(com,i){return _c('div',{key:i,staticClass:"mb-2"},[_c('h3',[_vm._v("\n                                                Initiateur:\n                                                "+_vm._s(com.initiateur)+"\n                                              ")]),_vm._v(" "),_c('h4',[_vm._v("Date: "+_vm._s(com.dateCom))]),_vm._v(" "),_c('h4',[_vm._v("Description:")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(com.description))])])})],2)]),_vm._v(" "),_c('el-col',{attrs:{"span":14}},[_c('h2',{staticClass:"mb-2"},[_vm._v("Photos:")]),_vm._v(" "),_c('p',_vm._l((scope
                                                .row.photos),function(photo,index){return _c('span',{key:index},[_c('v-avatar',{staticClass:"mr-2",attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":photo,"alt":"avatar"}})])],1)}),0)])],1)]}}],null,false,793848742)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idReserve","label":"RESERVE","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("R-"+_vm._s(scope.row.idReserve))]}}],null,false,1760544068)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libTache","label":"TACHE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etatReserve","label":"ETAT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etatReserve == 0)?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.libEtatRes))]):_vm._e(),_vm._v(" "),(scope.row.etatReserve == 1)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.libEtatRes))]):_vm._e(),_vm._v(" "),(scope.row.etatReserve == 2)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.libEtatRes))]):_vm._e(),_vm._v(" "),(scope.row.etatReserve == 3)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.libEtatRes))]):_vm._e()]}}],null,false,492101708)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"initiateur","label":"INITIATEUR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"validateur","label":"VALIDATEUR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cout","label":"MONTANT"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dureeRetard","label":"DUREE RETARD (J)"}})],1)],1)],1),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("INCIDENTS")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES INCIDENTS")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.incidents}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',[_c('b',[_vm._v("Description")]),_vm._v("\n                                      : "+_vm._s(props.row.description)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libelle","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date et heure"}})],1)],1),_vm._v(" "),(_vm.detailRapport.incidents.length == 0)?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("VISITEUR CHANTIER")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES VISITEURS")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.listeVisiteurs}},[_c('el-table-column',{attrs:{"prop":"nomPrenom","label":"Nom & Prénoms","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fonction","label":"Fonction"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateVisite","label":"Date de visite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"HeureDbut","label":"Heure debut"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"HeureFin","label":"Heure debut"}})],1)],1),_vm._v(" "),(_vm.detailRapport.listeVisiteurs.length == 0)?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("INVENTAIRE DES RESSOURCES\n                  ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES RESSOURCES UTILISEES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.listeMateriels}},[_c('el-table-column',{attrs:{"prop":"libMat","label":"Ressources","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteMat","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}})],1)],1),_vm._v(" "),(_vm.detailRapport.listeMateriels.length == 0)?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("INVENTAIRE DES RESSOURCES EXTERNES")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES RESSOURCES EXTERNES UTILISEES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('br'),_vm._v(" "),(
                                _vm.detailRapport.listeExterneMateriels.length > 0
                              )?_c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                    TOTAL TRAVAIL : "+_vm._s(_vm.totalExterniHT)+"\n                                  ")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.listeExterneMateriels}},[_c('el-table-column',{attrs:{"prop":"type","label":"Type","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité ","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureDebut","label":"Heure debut"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureFin","label":"Heure fin"}})],1)],1),_vm._v(" "),(
                                _vm.detailRapport.listeExterneMateriels.length ==
                                  0
                              )?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("UTILISATION DES MATERIELS/ENGINS UTILISES")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES MATERIELS/ENGINS UTILISES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.detailRapport.listeVehicules.length > 0)?_c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                    TOTAL TRAVAIL : "+_vm._s(_vm.totalVehiHT)+"\n                                  ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                    TOTAL QUANTITE CARBURANT :\n                                    "+_vm._s(new Intl.NumberFormat("fr-Fr").format(
                                        _vm.totalQteCarb
                                      ))+"\n                                    LITRE(S)\n                                  ")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.listeVehicules}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',[_c('b',[_vm._v("Compteur début jour(km)")]),_vm._v("\n                                      : "+_vm._s(props.row.cptDjour)+"\n                                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Compteur fin jour(km)")]),_vm._v("\n                                      : "+_vm._s(props.row.cptFjour)+"\n                                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Prix (L) du carburant (FCFA)")]),_vm._v("\n                                      : "+_vm._s(props.row.cout)+"\n                                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Fournisseur")]),_vm._v("\n                                      : "+_vm._s(props.row.fournisseur)+"\n                                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description")]),_vm._v("\n                                      : "+_vm._s(props.row.description)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Matériel/Engin","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureDebut","label":"Heure début"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureFin","label":"Heure fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heurePause","label":"Heure pause"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureTotal","label":"Heure total"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité Carburant(L)","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"utilisation","label":"Côut horaire(FCFA)"}})],1)],1),_vm._v(" "),(_vm.detailRapport.listeVehicules.length == 0)?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("LISTE DES RESSOURCES TECHNIQUES")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        TOTAL HEURE TRAVAIL : "+_vm._s(_vm.totalOuvrHT)+"\n                                    ")])],1)],1),_vm._v(" "),(this.totalOuvrHTHrSup != '00:00')?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        TOTAL HEURE SUPPLEMENTAIRE : "+_vm._s(_vm.totalOuvrHTHrSup)+"\n                                    ")])],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.listeParticipants}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [( props.row.heureSuppl != '00:00')?_c('v-flex',[_c('p',[_c('b',[_vm._v("Heure supplémentaire")]),_vm._v("\n                                          : "+_vm._s(props.row.heureSuppl)+"\n                                        ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description heure supplémentaire")]),_vm._v("\n                                          : "+_vm._s(props.row.descriptionSupp)+"\n                                        ")])]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description")]),_vm._v("\n                                          : "+_vm._s(props.row.description)+"\n                                        ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nomPrenom","label":"Nom & Prénoms","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"travaux","label":"Travaux","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureDbt","label":"Heure début","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureFin","label":"Heure fin","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heurePause","label":"Heure pause","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureIntem","label":"Heure Intemperie","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureTotal","label":"Heure travail","sortable":""}})],1)],1),_vm._v(" "),(_vm.detailRapport.listeParticipants &&
                                _vm.detailRapport.listeParticipants
                              )?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('CoolLightBox',{attrs:{"items":_vm.items,"index":_vm.index},on:{"close":function($event){_vm.index = null}}}),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.verifValideChefProjet())?_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"green"},on:{"click":function($event){_vm.dialogValidRapport = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Valider la demande chef projet")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.verifValideChefProjetGlobal())?_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"green"},on:{"click":function($event){_vm.dialogValidRapportGbloabl = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Valider la demande chef projet")])],1),_vm._v(" "),(_vm.verifValideChefChant())?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"purple"},on:{"click":function($event){_vm.dialogValidation = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v("Valider la demande chef chantier")])],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"ml-5",staticStyle:{"margin-bottom":"140px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"orange"},on:{"click":function($event){return _vm.imprimeJournalPDF(1)}},slot:"activator"},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('span',[_vm._v("Imprimer le rapport")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogDetailListeRapport),callback:function ($$v) {_vm.dialogDetailListeRapport=$$v},expression:"dialogDetailListeRapport"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("LISTE DES RAPPORTS DE TRAVAUX "+_vm._s(_vm.libTrx))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeListeRapport()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("TRAVAUX REALISES")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES TACHES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","mt-2":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeRapports.listeTaches}},[_c('el-table-column',{attrs:{"prop":"libTache","label":"Libelle","sortable":""}}),_vm._v(" "),(_vm.soustraitant == 'OUI')?_c('el-table-column',{attrs:{"prop":"soustraitant","label":"Sous-traitant","sortable":""}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libEtatTache","label":"Etat"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"photos","label":"Images"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[_vm._l((props
                                            .row.photos),function(image,imageIndex){return _c('v-avatar',{key:imageIndex,staticClass:"mb-1 mr-1 elevation-3",style:({
                                            backgroundImage:
                                              'url(' + image + ')',
                                            cursor: 'pointer'
                                          }),attrs:{"slot":"activator","tile":true,"size":50,"color":"grey lighten-4"},on:{"click":function($event){return _vm.showDiapo(
                                              props.row.photos,
                                              imageIndex,
                                              image
                                            )}},slot:"activator"},[_c('img',{attrs:{"src":image,"alt":"avatar"}})])}),_vm._v("\n                                        Cliquez pour agrandir\n                                      ")],2)]}}])})],1)],1)],1),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.listeRapports.listeReserves.length > 0)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("TRAVAUX DE RESERVE")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES TRAVAUX DE RESERVE")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"data":_vm.listeRapports.listeReserves}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('h2',{staticClass:"mb-2"},[_vm._v("\n                                              Commentaires:\n                                            ")]),_vm._v(" "),_vm._l((scope.row
                                                .commentaires),function(com,i){return _c('div',{key:i,staticClass:"mb-2"},[_c('h3',[_vm._v("\n                                                Initiateur:\n                                                "+_vm._s(com.initiateur)+"\n                                              ")]),_vm._v(" "),_c('h4',[_vm._v("Date: "+_vm._s(com.dateCom))]),_vm._v(" "),_c('h4',[_vm._v("Description:")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(com.description))])])})],2)]),_vm._v(" "),_c('el-col',{attrs:{"span":14}},[_c('h2',{staticClass:"mb-2"},[_vm._v("Photos:")]),_vm._v(" "),_c('p',_vm._l((scope
                                                .row.photos),function(photo,index){return _c('span',{key:index},[_c('v-avatar',{staticClass:"mr-2",attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":photo,"alt":"avatar"}})])],1)}),0)])],1)]}}],null,false,793848742)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idReserve","label":"RESERVE","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("R-"+_vm._s(scope.row.idReserve))]}}],null,false,1760544068)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libTache","label":"TACHE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libEtatRes","label":"ETAT"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"initiateur","label":"INITIATEUR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"validateur","label":"VALIDATEUR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cout","label":"MONTANT"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dureeRetard","label":"DUREE RETARD (J)"}})],1)],1)],1),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("VISITEUR CHANTIER")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES VISITEURS")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeRapports.listeVisiteurs}},[_c('el-table-column',{attrs:{"prop":"nomPrenom","label":"Nom & Prénoms","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fonction","label":"Fonction"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateVisite","label":"Date de visite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"HeureDbut","label":"Heure debut"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"HeureFin","label":"Heure fin"}})],1)],1),_vm._v(" "),(_vm.listeRapports.listeVisiteurs.length == 0)?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("INCIDENTS")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES INCIDENTS")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.incidents}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',[_c('b',[_vm._v("Description")]),_vm._v("\n                                      : "+_vm._s(props.row.description)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libelle","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Nombre"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date et heure"}})],1)],1),_vm._v(" "),(_vm.detailRapport.incidents.length == 0)?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("INVENTAIRE DU RESSOURCES\n                  ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES RESSOURCES UTILISEES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeRapports.listeMateriels}},[_c('el-table-column',{attrs:{"prop":"libMat","label":"Ressources","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteMat","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}})],1)],1),_vm._v(" "),(_vm.listeRapports.listeMateriels.length == 0)?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("INVENTAIRE DES RESSOURCES EXTERNES")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES RESSOURCES EXTERNES UTILISEES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('br'),_vm._v(" "),(
                                _vm.detailRapport.listeExterneMateriels.length > 0
                              )?_c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                    TOTAL TRAVAIL : "+_vm._s(_vm.totalExterniHT)+"\n                                  ")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.listeExterneMateriels}},[_c('el-table-column',{attrs:{"prop":"type","label":"Type","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité ","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureDebut","label":"Heure debut"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureFin","label":"Heure fin"}})],1)],1),_vm._v(" "),(
                                _vm.detailRapport.listeExterneMateriels.length ==
                                  0
                              )?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("UTILISATION DES MATERIELS/ENGINS")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES MATERIELS/ENGINS UTILISES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.detailRapport.listeVehicules.length != 0)?_c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                    TOTAL TRAVAIL :\n                                    "+_vm._s(this.secondsToHms(_vm.totalVehiHMinite))+"\n                                  ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                    TOTAL QUANTITE CARBURANT :\n                                    "+_vm._s(new Intl.NumberFormat("fr-Fr").format(
                                        _vm.totalQteCarb
                                      ))+"\n                                    LITRE(S)\n                                  ")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeRapports.listeVehicules}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',[_c('b',[_vm._v("Compteur début jour(km)")]),_vm._v("\n                                      : "+_vm._s(props.row.cptDjour)+"\n                                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Compteur fin jour(km)")]),_vm._v("\n                                      : "+_vm._s(props.row.cptFjour)+"\n                                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Prix (L) du carburant (FCFA)")]),_vm._v("\n                                      : "+_vm._s(props.row.cout)+"\n                                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Fournisseur")]),_vm._v("\n                                      : "+_vm._s(props.row.fournisseur)+"\n                                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description")]),_vm._v("\n                                      : "+_vm._s(props.row.description)+"\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Véhicule","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureDebut","label":"Heure début"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureFin","label":"Heure fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heurePause","label":"Heure pause"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureTotal","label":"Heure travail"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité Carburant(L)","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"utilisation","label":"Côut horaire(FCFA)"}})],1)],1),_vm._v(" "),(_vm.detailRapport.listeVehicules.length == 0)?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("LISTE DES RESSOURCES TECHNIQUES")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES RESSOURCES TECHNIQUES UTILISEES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        TOTAL HEURE TRAVAIL : "+_vm._s(_vm.totalOuvrHT)+"\n                                    ")])],1)],1),_vm._v(" "),(this.totalOuvrHTHrSup != '00:00')?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        TOTAL HEURE SUPPLEMENTAIRE : "+_vm._s(_vm.totalOuvrHTHrSup)+"\n                                    ")])],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.listeParticipants}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [( props.row.heureSuppl != '00:00')?_c('v-flex',[_c('p',[_c('b',[_vm._v("Heure supplémentaire")]),_vm._v("\n                                          : "+_vm._s(props.row.heureSuppl)+"\n                                        ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description heure supplémentaire")]),_vm._v("\n                                          : "+_vm._s(props.row.descriptionSupp)+"\n                                        ")])]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description")]),_vm._v("\n                                          : "+_vm._s(props.row.description)+"\n                                        ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nomPrenom","label":"Nom & Prénoms","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"travaux","label":"Travaux","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureDbt","label":"Heure début","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureFin","label":"Heure fin","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heurePause","label":"Heure pause","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureIntem","label":"Heure Intemperie","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureTotal","label":"Heure travail","sortable":""}})],1)],1),_vm._v(" "),(_vm.detailRapport.listeParticipants &&
                                _vm.detailRapport.listeParticipants.length == 0
                              )?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                              Informations non renseignées lors de\n                              l'enregistrement du rapport\n                            ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('CoolLightBox',{attrs:{"items":_vm.items,"index":_vm.index},on:{"close":function($event){_vm.index = null}}})],1)],1),_vm._v(" "),_c('v-flex',[_c('el-popover',{ref:"popImpresion",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le mode d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeALLJournalPDF('simple')}}},[_vm._v("Simple")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeALLJournalPDF('details')}}},[_vm._v("\n              Detaillé\n            ")])],1)]),_vm._v(" "),_c('div',[_c('v-btn',{directives:[{name:"popover",rawName:"v-popover:popImpresion",arg:"popImpresion"}],staticClass:"ml-5",staticStyle:{"margin-bottom":"140px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"orange"},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"380"},model:{value:(_vm.dialogValidRapport),callback:function ($$v) {_vm.dialogValidRapport=$$v},expression:"dialogValidRapport"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Voulez-vous valider le rapport ?")]),_vm._v(" "),_c('v-card-text',[_vm._v("En cliquant sur valider, en tant que responsable, vous confirmez que\n        les travaux ont été correctement realisés.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.dialogValidRapport = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.validerRapport('VALIDE')}}},[_vm._v("Valider")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogValidation),callback:function ($$v) {_vm.dialogValidation=$$v},expression:"dialogValidation"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogValidRapport = true}}},[_vm._v("\n                  Valider\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogRejeterMission = true}}},[_vm._v("\n                  Rejeter\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"blue",attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogValidation = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"380"},model:{value:(_vm.dialogValidRapportGbloabl),callback:function ($$v) {_vm.dialogValidRapportGbloabl=$$v},expression:"dialogValidRapportGbloabl"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Voulez-vous valider le rapport ?")]),_vm._v(" "),_c('v-card-text',[_vm._v("En cliquant sur valider, en tant que responsable, vous confirmez que\n        les travaux ont été correctement realisés.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.dialogValidRapportGbloabl = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.validerRapportGlobal('global')}}},[_vm._v("Valider")])],1)],1)],1),_vm._v(" "),_c('AjoutReserve',{attrs:{"tache":_vm.tacheSelect,"show":_vm.showAddReserve},on:{"close":function($event){return _vm.closeAjoutReserve()}}}),_vm._v(" "),_c('RapportJournalier',{attrs:{"dateRpt":_vm.dateRapport,"detailTrx":_vm.detailTravaux,"show":_vm.showRapport,"editRapport":_vm.editRapport},on:{"close":function($event){_vm.showRapport = false},"reloadListeTrx":function($event){_vm.loadRapportTrx();
      _vm.$emit('reloadListeTravaux');}}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%"},model:{value:(_vm.dialogValidNewRapport),callback:function ($$v) {_vm.dialogValidNewRapport=$$v},expression:"dialogValidNewRapport"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Voulez-vous enrregistrer un rapport pour cette date ?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.dialogValidNewRapport = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.rapportJour(_vm.listDatat)}}},[_vm._v("Valider")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"40%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogRejeterMission),callback:function ($$v) {_vm.dialogRejeterMission=$$v},expression:"dialogRejeterMission"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-xs-center"},[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Rejeter le rapport")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"outline":"","color":"orange darken-1","icon":"warning","value":true}},[_vm._v("\n                      Etes-vous sur de vouloir rejeter le rapport ?\n                  ")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{staticClass:"demo-form-inline"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-form-item',{attrs:{"label":"Motif du refus"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":"Motif du refus"},model:{value:(_vm.motifRejet),callback:function ($$v) {_vm.motifRejet=$$v},expression:"motifRejet"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{on:{"click":function($event){$event.stopPropagation();_vm.dialogRejeterMission = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.validerRapport('REJETER')}}},[_vm._v("Confirmer\n              ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F/n8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_echarts__ = __webpack_require__("cs+8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_chart_line__ = __webpack_require__("4UDB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Vb+l");
__webpack_require__("Oq2I");
__webpack_require__("miEh");






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */],
        'v-chart': __WEBPACK_IMPORTED_MODULE_0_vue_echarts___default.a
    },
    name: "boardFacture",
    props: {
        show: {
            type: Boolean,
            default: false
        },
        idFour: {}
    },
    data: function data() {
        return {
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            loading: false,

            nbCommandeFour: 0,
            nbLivraisonFour: 0,
            dataCommandeFour: {},
            dataFactHistoFour: {},
            dataNbFactFour: {},
            dataMntFactFour: []

        };
    },

    methods: {
        statDepenseAn: function statDepenseAn(dataFactHistoFour) {
            var posList = ['left', 'right', 'top', 'bottom', 'inside', 'insideTop', 'insideLeft', 'insideRight', 'insideBottom', 'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'];

            app.configParameters = {
                rotate: {
                    min: -90,
                    max: 90
                },
                align: {
                    options: {
                        left: 'left',
                        center: 'center',
                        right: 'right'
                    }
                },
                verticalAlign: {
                    options: {
                        top: 'top',
                        middle: 'middle',
                        bottom: 'bottom'
                    }
                },
                position: {
                    options: echarts.util.reduce(posList, function (map, pos) {
                        map[pos] = pos;
                        return map;
                    }, {})
                },
                distance: {
                    min: 0,
                    max: 100
                }
            };

            app.config = {
                rotate: 90,
                align: 'left',
                verticalAlign: 'middle',
                position: 'insideBottom',
                distance: 15,
                onChange: function onChange() {
                    var labelOption = {
                        normal: {
                            rotate: app.config.rotate,
                            align: app.config.align,
                            verticalAlign: app.config.verticalAlign,
                            position: app.config.position,
                            distance: app.config.distance
                        }
                    };
                    myChart.setOption({
                        series: [{
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }]
                    });
                }
            };

            var labelOption = {
                show: true,
                position: app.config.position,
                distance: app.config.distance,
                align: app.config.align,
                verticalAlign: app.config.verticalAlign,
                rotate: app.config.rotate,
                formatter: '{c}  {name|{a}}',
                fontSize: 16,
                rich: {
                    name: {
                        textBorderColor: '#fff'
                    }
                }
            };

            var option = {
                color: ['#388E3C', '#F57C00', '#455A64', '#C62828'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {},
                toolbox: {
                    show: true,
                    orient: 'vertical',
                    left: 'right',
                    top: 'center',
                    feature: {
                        mark: { show: true },
                        dataView: { show: true, readOnly: false },
                        magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
                        restore: { show: true },
                        saveAsImage: { show: true }
                    }
                },
                xAxis: [{
                    type: 'category',
                    axisTick: { show: false },
                    data: []
                }],
                yAxis: [{
                    type: 'value'
                }],
                series: [{
                    name: 'Payé',
                    type: 'bar',
                    barGap: 0,
                    label: labelOption,
                    data: []
                }, {
                    name: 'En cours',
                    type: 'bar',
                    label: labelOption,
                    data: []
                }, {
                    name: 'En attente',
                    type: 'bar',
                    label: labelOption,
                    data: []
                }, {
                    name: 'Impayé',
                    type: 'bar',
                    label: labelOption,
                    data: []
                }]
            }; //option

            for (var datahis in dataFactHistoFour) {
                option.xAxis[0].data.push(datahis);

                var series = dataFactHistoFour[datahis];

                option.series[0].data.push(series["paye"]);
                option.series[1].data.push(series["cours"]);
                option.series[2].data.push(series["attente"]);
                option.series[3].data.push(series["impaye"]);
            }

            var chartFactureAnFour = echarts.init(document.getElementById('chartFactureAnFour'));
            chartFactureAnFour.setOption(option);
        },
        statFacture: function statFacture(dataNbFactFour) {
            var posList = ['left', 'right', 'top', 'bottom', 'inside', 'insideTop', 'insideLeft', 'insideRight', 'insideBottom', 'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'];

            app.configParameters = {
                rotate: {
                    min: -90,
                    max: 90
                },
                align: {
                    options: {
                        left: 'left',
                        center: 'center',
                        right: 'right'
                    }
                },
                verticalAlign: {
                    options: {
                        top: 'top',
                        middle: 'middle',
                        bottom: 'bottom'
                    }
                },
                position: {
                    options: echarts.util.reduce(posList, function (map, pos) {
                        map[pos] = pos;
                        return map;
                    }, {})
                },
                distance: {
                    min: 0,
                    max: 100
                }
            };

            app.config = {
                rotate: 90,
                align: 'left',
                verticalAlign: 'middle',
                position: 'insideBottom',
                distance: 15,
                onChange: function onChange() {
                    var labelOption = {
                        normal: {
                            rotate: app.config.rotate,
                            align: app.config.align,
                            verticalAlign: app.config.verticalAlign,
                            position: app.config.position,
                            distance: app.config.distance
                        }
                    };
                    myChart.setOption({
                        series: [{
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }]
                    });
                }
            };

            var labelOption = {
                show: true,
                position: app.config.position,
                distance: app.config.distance,
                align: app.config.align,
                verticalAlign: app.config.verticalAlign,
                rotate: app.config.rotate,
                formatter: '{c}  {name|{a}}',
                fontSize: 16,
                rich: {
                    name: {
                        textBorderColor: '#fff'
                    }
                }
            };

            var option = {
                backgroundColor: '#FFF',

                title: {
                    text: "",
                    left: 'center',
                    top: 10,
                    textStyle: {
                        color: '#000'
                    }
                },

                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },

                visualMap: {
                    show: false,
                    min: 80,
                    max: 600,
                    inRange: {
                        colorLightness: [0, 1]
                    }
                },
                series: [{
                    name: 'Nb Facture(s)',
                    type: 'pie',
                    radius: '75%',
                    center: ['50%', '50%'],
                    color: ["#388E3C", "#D32F2F", "#455A64", "#F57C00", "#00BCD4"],
                    data: [
                        // {value: 335, name: '直接访问'},
                    ].sort(function (a, b) {
                        return a.value - b.value;
                    }),
                    roseType: 'radius',
                    label: {
                        color: 'rgba(255, 255, 255, 0.3)'
                    },
                    labelLine: {
                        lineStyle: {
                            color: 'rgba(255, 255, 255, 0.3)'
                        },
                        smooth: 0.2,
                        length: 10,
                        length2: 20
                    },
                    itemStyle: {
                        color: '#c23531',
                        shadowBlur: 200,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    },

                    animationType: 'scale',
                    animationEasing: 'elasticOut',
                    animationDelay: function animationDelay(idx) {
                        return Math.random() * 200;
                    }
                }]
            };

            for (var dataFact in dataNbFactFour) {
                option.series[0].data.push({ value: dataNbFactFour[dataFact], name: dataFact });
            }

            var chartFactureFour = echarts.init(document.getElementById('chartFactureFour'));
            chartFactureFour.setOption(option);
        },
        statCommande: function statCommande(dataCommandeFour) {
            var posList = ['left', 'right', 'top', 'bottom', 'inside', 'insideTop', 'insideLeft', 'insideRight', 'insideBottom', 'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'];

            app.configParameters = {
                rotate: {
                    min: -90,
                    max: 90
                },
                align: {
                    options: {
                        left: 'left',
                        center: 'center',
                        right: 'right'
                    }
                },
                verticalAlign: {
                    options: {
                        top: 'top',
                        middle: 'middle',
                        bottom: 'bottom'
                    }
                },
                position: {
                    options: echarts.util.reduce(posList, function (map, pos) {
                        map[pos] = pos;
                        return map;
                    }, {})
                },
                distance: {
                    min: 0,
                    max: 100
                }
            };

            app.config = {
                rotate: 90,
                align: 'left',
                verticalAlign: 'middle',
                position: 'insideBottom',
                distance: 15,
                onChange: function onChange() {
                    var labelOption = {
                        normal: {
                            rotate: app.config.rotate,
                            align: app.config.align,
                            verticalAlign: app.config.verticalAlign,
                            position: app.config.position,
                            distance: app.config.distance
                        }
                    };
                    myChart.setOption({
                        series: [{
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }]
                    });
                }
            };

            var labelOption = {
                show: true,
                position: app.config.position,
                distance: app.config.distance,
                align: app.config.align,
                verticalAlign: app.config.verticalAlign,
                rotate: app.config.rotate,
                formatter: '{c}  {name|{a}}',
                fontSize: 16,
                rich: {
                    name: {
                        textBorderColor: '#fff'
                    }
                }
            };

            var optionComd = {
                title: {
                    text: 'Statistique des commandes',
                    subtext: '',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: ["Livraison(s)", "Commande(s)"]
                },
                series: [{
                    name: 'Commande(s)',
                    type: 'pie',
                    radius: '75%',
                    center: ['50%', '60%'],
                    color: ["#26A69A", "#FF7043"],
                    data: [
                        //{value: 1548, name: '搜索引擎'}
                    ],
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }]
            };

            for (var dataCom in dataCommandeFour) {
                optionComd.series[0].data.push({ value: dataCommandeFour[dataCom], name: dataCom });
            }

            this.nbCommandeFour = dataCommandeFour["commande"];
            this.nbLivraisonFour = dataCommandeFour["livraison"];

            var chartCommandeFour = echarts.init(document.getElementById('chartCommandeFour'));
            chartCommandeFour.setOption(optionComd);
        },
        loadAllDataFactAnFour: function loadAllDataFactAnFour() {
            var _this = this;

            this.loading = true;
            var url = this.domaine + 'facture/stathisto/' + this.idFour;

            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this.dataFactStatFour = response.body.dataFacture;
                    _this.dataNbFactFour = response.body.dataNbFact;
                    _this.dataMntFactFour = response.body.dataMntFacture;

                    _this.statDepenseAn(_this.dataFactStatFour);
                    _this.statFacture(_this.dataNbFactFour);
                    _this.loading = false;
                }
            });
        },
        loadAllDataCommandeStatFour: function loadAllDataCommandeStatFour() {
            var _this2 = this;

            this.loading = true;
            var url = this.domaine + 'facture/stat/general/' + this.idFour;
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this2.dataCommandeStatFour = response.body.dataCommande;
                    _this2.statCommande(_this2.dataCommandeStatFour);
                    _this2.loading = false;
                }
            });
        },
        closeDialog: function closeDialog() {
            this.$emit('close');
        }
    },

    watch: {
        show: function show(newValue, oldvalue) {
            if (newValue == true) {
                this.loadAllDataCommandeStatFour();
                this.loadAllDataFactAnFour();
            }
        }
    },

    mounted: function mounted() {}
});

/***/ }),

/***/ "F22d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadConducteur_vue__ = __webpack_require__("GlT3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_287d007f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadConducteur_vue__ = __webpack_require__("7lSV");
function injectStyle (ssrContext) {
  __webpack_require__("masD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-287d007f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadConducteur_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_287d007f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadConducteur_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F3kx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2",attrs:{"xs2":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"light-blue","dark":""}},[_c('v-toolbar-title',[_vm._v("Details travaux")])],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":"","subheader":"","dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Projet")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.libProjet))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Chef projet ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.chefProjet))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Chantier ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.libChantier))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Chef chantier ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.chefChantier))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.selectedTask)?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Travaux")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.selectedTask.text))])],1)],1):_vm._e(),_vm._v(" "),(_vm.selectedTask)?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Chef des travaux")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.selectedTask.chefTravaux))])],1)],1):_vm._e(),_vm._v(" "),(_vm.selectedTask)?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Progression")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("toPercent")(_vm.selectedTask.progress))+"%")])],1)],1):_vm._e(),_vm._v(" "),(_vm.selectedTask)?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Date initiale")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("moment")(_vm.selectedTask.start_date,"dddd, MMMM Do YYYY")))])],1)],1):_vm._e(),_vm._v(" "),(_vm.selectedTask)?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Date fin")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("moment")(_vm.selectedTask.end_date,"dddd, MMMM Do YYYY")))])],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('gantt',{attrs:{"tasks":_vm.tasks},on:{"task-selected":_vm.selectTask}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F7Wq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadTypeTaches_vue__ = __webpack_require__("pnvJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8327a44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadTypeTaches_vue__ = __webpack_require__("nenw");
function injectStyle (ssrContext) {
  __webpack_require__("qojX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d8327a44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadTypeTaches_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8327a44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadTypeTaches_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FIRw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","persistent":true,"transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogRapportDepannage),callback:function ($$v) {_vm.dialogRapportDepannage=$$v},expression:"dialogRapportDepannage"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Raaport de depannage Demande DMD-"+_vm._s(_vm.demandeDetail.idDemande))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                Ajouter des images\n                            ")]),_vm._v(" "),_c('el-form',{ref:"formRapport2",staticClass:"demo-form-inline",staticStyle:{"width":"100%"},attrs:{"id":"formRapport2","model":_vm.formRapport}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2",attrs:{"xs3":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.image1,"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"file1",staticStyle:{"display":"none"},attrs:{"name":"image1","type":"file","accept":"image/*"},on:{"change":_vm.onFileImage1Picked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.file1.click()}}},[_vm._v("Photo  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('div',{staticClass:"font-weight-thin"},[_vm._v("Fichier au format (JPEG,PNG,PDF) avec une taille de 1048 ko maximale")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Rapport de depannage"}},[_c('el-input',{attrs:{"type":"textarea","rows":4,"placeholder":"Rapport de depannage"},model:{value:(_vm.formRapport.rapport),callback:function ($$v) {_vm.$set(_vm.formRapport, "rapport", $$v)},expression:"formRapport.rapport"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitFormRapport()}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FJfj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "ModalCalendContrat",
  props: ["show"],
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      loading: false,
      dialogCalendContrat: false,
      dialogShowContrat: false,
      contratCourant: [],
      listContrat: [],
      events: [],
      config: {
        defaultView: "month",
        locale: "fr",
        eventRender: function eventRender(event, element) {}
      }
    };
  },

  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogCalendContrat = newValue;
    }
  },
  methods: {
    loadContrat: function loadContrat() {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "contrat/index";
      this.$http.get(url).then(function (response) {
        _this.events = response.body.calendContrat;
        _this.listContrat = response.body.contrat;
        _this.loading = false;
      }, function (response) {
        _this.loading = false;
        _this.$message.error("erreur lors du chargement des contrats de locations.");
      });
    },
    eventSelected: function eventSelected(event, jsEvent, view) {
      this.contratCourant = this.listContrat.find(function (cont) {
        return cont.id == event.idCont;
      });

      this.dialogShowContrat = true;
    }
  },
  mounted: function mounted() {
    this.loadContrat();
  }
});

/***/ }),

/***/ "FSjC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projet_vue__ = __webpack_require__("pc6w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c6a0074_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projet_vue__ = __webpack_require__("h4D2");
function injectStyle (ssrContext) {
  __webpack_require__("/Fpr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2c6a0074"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c6a0074_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Projet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FWb0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FaG6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_echarts__ = __webpack_require__("cs+8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_chart_line__ = __webpack_require__("4UDB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Vb+l");
__webpack_require__("Oq2I");
__webpack_require__("miEh");






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */],
        'v-chart': __WEBPACK_IMPORTED_MODULE_0_vue_echarts___default.a
    },
    name: "boardFacture",
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,

            nbCommande: 0,
            nbLivraison: 0,
            dataCommande: {},
            dataFactHisto: {},
            dataNbFact: {},
            dataMntFact: [],
            nombreTotalFouni: ''

        };
    },

    methods: {
        statDepenseAn: function statDepenseAn(dataFactHisto) {
            var posList = ['left', 'right', 'top', 'bottom', 'inside', 'insideTop', 'insideLeft', 'insideRight', 'insideBottom', 'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'];

            app.configParameters = {
                rotate: {
                    min: -90,
                    max: 90
                },
                align: {
                    options: {
                        left: 'left',
                        center: 'center',
                        right: 'right'
                    }
                },
                verticalAlign: {
                    options: {
                        top: 'top',
                        middle: 'middle',
                        bottom: 'bottom'
                    }
                },
                position: {
                    options: echarts.util.reduce(posList, function (map, pos) {
                        map[pos] = pos;
                        return map;
                    }, {})
                },
                distance: {
                    min: 0,
                    max: 100
                }
            };

            app.config = {
                rotate: 90,
                align: 'left',
                verticalAlign: 'middle',
                position: 'insideBottom',
                distance: 15,
                onChange: function onChange() {
                    var labelOption = {
                        normal: {
                            rotate: app.config.rotate,
                            align: app.config.align,
                            verticalAlign: app.config.verticalAlign,
                            position: app.config.position,
                            distance: app.config.distance
                        }
                    };
                    myChart.setOption({
                        series: [{
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }]
                    });
                }
            };

            var labelOption = {
                show: true,
                position: app.config.position,
                distance: app.config.distance,
                align: app.config.align,
                verticalAlign: app.config.verticalAlign,
                rotate: app.config.rotate,
                formatter: '{c}  {name|{a}}',
                fontSize: 16,
                rich: {
                    name: {
                        textBorderColor: '#fff'
                    }
                }
            };

            var option = {
                color: ['#388E3C', '#F57C00', '#455A64', '#C62828'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {},
                toolbox: {
                    show: true,
                    orient: 'vertical',
                    left: 'right',
                    top: 'center',
                    feature: {
                        mark: { show: true },
                        dataView: { show: true, readOnly: false },
                        magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
                        restore: { show: true },
                        saveAsImage: { show: true }
                    }
                },
                xAxis: [{
                    type: 'category',
                    axisTick: { show: false },
                    data: []
                }],
                yAxis: [{
                    type: 'value'
                }],
                series: [{
                    name: 'Payé',
                    type: 'bar',
                    barGap: 0,
                    label: labelOption,
                    data: []
                }, {
                    name: 'En cours',
                    type: 'bar',
                    label: labelOption,
                    data: []
                }, {
                    name: 'En attente',
                    type: 'bar',
                    label: labelOption,
                    data: []
                }, {
                    name: 'Impayé',
                    type: 'bar',
                    label: labelOption,
                    data: []
                }]
            }; //option

            for (var datahis in dataFactHisto) {
                option.xAxis[0].data.push(datahis);
                var series = dataFactHisto[datahis];

                option.series[0].data.push(series["paye"]);
                option.series[1].data.push(series["cours"]);
                option.series[2].data.push(series["attente"]);
                option.series[3].data.push(series["impaye"]);
            }

            var chartFactureAn = echarts.init(document.getElementById('chartFactureAn'));
            chartFactureAn.setOption(option);
        },
        statFacture: function statFacture(dataNbFact) {
            var posList = ['left', 'right', 'top', 'bottom', 'inside', 'insideTop', 'insideLeft', 'insideRight', 'insideBottom', 'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'];

            app.configParameters = {
                rotate: {
                    min: -90,
                    max: 90
                },
                align: {
                    options: {
                        left: 'left',
                        center: 'center',
                        right: 'right'
                    }
                },
                verticalAlign: {
                    options: {
                        top: 'top',
                        middle: 'middle',
                        bottom: 'bottom'
                    }
                },
                position: {
                    options: echarts.util.reduce(posList, function (map, pos) {
                        map[pos] = pos;
                        return map;
                    }, {})
                },
                distance: {
                    min: 0,
                    max: 100
                }
            };

            app.config = {
                rotate: 90,
                align: 'left',
                verticalAlign: 'middle',
                position: 'insideBottom',
                distance: 15,
                onChange: function onChange() {
                    var labelOption = {
                        normal: {
                            rotate: app.config.rotate,
                            align: app.config.align,
                            verticalAlign: app.config.verticalAlign,
                            position: app.config.position,
                            distance: app.config.distance
                        }
                    };
                    myChart.setOption({
                        series: [{
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }]
                    });
                }
            };

            var labelOption = {
                show: true,
                position: app.config.position,
                distance: app.config.distance,
                align: app.config.align,
                verticalAlign: app.config.verticalAlign,
                rotate: app.config.rotate,
                formatter: '{c}  {name|{a}}',
                fontSize: 16,
                rich: {
                    name: {
                        textBorderColor: '#fff'
                    }
                }
            };

            var option = {
                backgroundColor: '#FFF',

                title: {
                    text: "",
                    left: 'center',
                    top: 10,
                    textStyle: {
                        color: '#000'
                    }
                },

                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },

                visualMap: {
                    show: false,
                    min: 80,
                    max: 600,
                    inRange: {
                        colorLightness: [0, 1]
                    }
                },
                series: [{
                    name: 'Nb Facture(s)',
                    type: 'pie',
                    radius: '75%',
                    center: ['50%', '50%'],
                    color: ["#388E3C", "#D32F2F", "#455A64", "#F57C00", "#00BCD4"],
                    data: [
                        // {value: 335, name: '直接访问'},
                    ].sort(function (a, b) {
                        return a.value - b.value;
                    }),
                    roseType: 'radius',
                    label: {
                        color: 'rgba(255, 255, 255, 0.3)'
                    },
                    labelLine: {
                        lineStyle: {
                            color: 'rgba(255, 255, 255, 0.3)'
                        },
                        smooth: 0.2,
                        length: 10,
                        length2: 20
                    },
                    itemStyle: {
                        color: '#c23531',
                        shadowBlur: 200,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    },

                    animationType: 'scale',
                    animationEasing: 'elasticOut',
                    animationDelay: function animationDelay(idx) {
                        return Math.random() * 200;
                    }
                }]
            };
            for (var dataFact in dataNbFact) {
                //let series = this.dataNbFact[dataFact]

                option.series[0].data.push({ value: dataNbFact[dataFact], name: dataFact });
            }

            var chartFacture = echarts.init(document.getElementById('chartFacture'));
            chartFacture.setOption(option);
        },
        statCommande: function statCommande(dataCommande) {
            var posList = ['left', 'right', 'top', 'bottom', 'inside', 'insideTop', 'insideLeft', 'insideRight', 'insideBottom', 'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'];

            app.configParameters = {
                rotate: {
                    min: -90,
                    max: 90
                },
                align: {
                    options: {
                        left: 'left',
                        center: 'center',
                        right: 'right'
                    }
                },
                verticalAlign: {
                    options: {
                        top: 'top',
                        middle: 'middle',
                        bottom: 'bottom'
                    }
                },
                position: {
                    options: echarts.util.reduce(posList, function (map, pos) {
                        map[pos] = pos;
                        return map;
                    }, {})
                },
                distance: {
                    min: 0,
                    max: 100
                }
            };

            app.config = {
                rotate: 90,
                align: 'left',
                verticalAlign: 'middle',
                position: 'insideBottom',
                distance: 15,
                onChange: function onChange() {
                    var labelOption = {
                        normal: {
                            rotate: app.config.rotate,
                            align: app.config.align,
                            verticalAlign: app.config.verticalAlign,
                            position: app.config.position,
                            distance: app.config.distance
                        }
                    };
                    myChart.setOption({
                        series: [{
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }]
                    });
                }
            };

            var labelOption = {
                show: true,
                position: app.config.position,
                distance: app.config.distance,
                align: app.config.align,
                verticalAlign: app.config.verticalAlign,
                rotate: app.config.rotate,
                formatter: '{c}  {name|{a}}',
                fontSize: 16,
                rich: {
                    name: {
                        textBorderColor: '#fff'
                    }
                }
            };

            var optionComd = {
                title: {
                    text: 'Statistique des commandes',
                    subtext: '',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: ["Livraison(s)", "Commande(s)"]
                },
                series: [{
                    name: 'Commande(s)',
                    type: 'pie',
                    radius: '75%',
                    center: ['50%', '60%'],
                    color: ["#FF7043", "#26A69A"],
                    data: [
                        //{value: 1548, name: '搜索引擎'}
                    ],
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }]
            };

            for (var dataCom in dataCommande) {

                //let series = this.dataCommande[dataCom]

                optionComd.series[0].data.push({ value: dataCommande[dataCom], name: dataCom });
            }

            this.nbCommande = dataCommande["commande"];
            this.nbLivraison = dataCommande["livraison"];

            var chartCommande = echarts.init(document.getElementById('chartCommande'));
            chartCommande.setOption(optionComd);
        },
        loadAllDataCommandeStat: function loadAllDataCommandeStat() {
            var _this = this;

            var url = '';
            if (this.droitAcces.fournisseur) {
                url = this.domaine + 'facture/stat/general';
            } else {
                url = this.domaine + 'facture/stat/general/user/' + this.user.id;
            }
            // let url = this.domaine + 'facture/stat/general'

            this.$http.get(url).then(function (response) {
                _this.dataCommande = response.body.dataCommande;
                _this.statCommande(_this.dataCommande);
                _this.loading = false;
            }, function (error) {
                _this.loading = false;
            });
        },


        //STATISTIQUE FACTURE
        loadAllDataFactAn: function loadAllDataFactAn() {
            var _this2 = this;

            // this.loading = true
            var url = '';
            if (this.droitAcces.fournisseur) {
                url = this.domaine + 'facture/stathisto';
            } else {
                url = this.domaine + 'facture/stathisto/user/' + this.user.id;
            }

            this.$http.get(url).then(function (response) {
                _this2.dataFactHisto = response.body.dataFacture;
                _this2.dataNbFact = response.body.dataNbFact;
                _this2.dataMntFact = response.body.dataMntFacture;
                _this2.statDepenseAn(_this2.dataFactHisto);
                _this2.statFacture(_this2.dataNbFact);
                _this2.loading = false;
            }, function (error) {
                _this2.loading = false;
            });
        },
        loadFourn: function loadFourn() {
            var _this3 = this;

            /*
            if (droitAcces.fournisseur) {
                let url = this.domaine + 'fournisseur/index'
            } else{
               let url = this.domaine + 'fournisseur/'+ this.user.id + '/index'
            }*/
            this.loading = true;
            var url = this.domaine + 'fournisseur/index';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this3.listFour = response.body.fournisseur;
                    _this3.nombreTotalFouni = response.body.fournisseur.length;
                    _this3.listFourFinal = response.body.fournisseur;
                    _this3.statAllFour = response.body.stats;
                    _this3.comboProfession = response.body.profession;
                    _this3.comboFournisseur = response.body.fournisseur;
                    _this3.statAllFactureFour = response.body.statsFact;
                    _this3.nbrComAll = response.body.nbrCom;
                    _this3.nbrFactAll = response.body.nbrFact;
                    _this3.nbrLivrAll = response.body.nbrLivr;
                    _this3.depenseAll = response.body.coutTotal;
                    //this.statAllDepense()
                    //this.statAllFacture()
                    _this3.loading = false;
                }
            });
        },
        closeDialog: function closeDialog() {
            this.$emit('close');
        }
    },

    watch: {
        show: function show(newValue, oldvalue) {
            if (newValue == true) {
                //this.statDepenseAn()
                //this.statCommande()
                //this.statFacture()

            }
        }
    },

    mounted: function mounted() {
        //this.statDepenseAn()
        //this.statCommande()
        //this.statFacture()
        this.loadAllDataCommandeStat();
        this.loadAllDataFactAn();
        this.loadFourn();
    }
});

/***/ }),

/***/ "FdeE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_besoinTravaux_vue__ = __webpack_require__("W8r5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7a5dad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_besoinTravaux_vue__ = __webpack_require__("VvO2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_besoinTravaux_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7a5dad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_besoinTravaux_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FejV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-navigation-drawer',{attrs:{"absolute":"","temporary":""},model:{value:(_vm.showDraw),callback:function ($$v) {_vm.showDraw=$$v},expression:"showDraw"}},_vm._l((_vm.items),function(item){return _c('div',[_c('v-list',{staticClass:"pa-1"},[_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('img',{attrs:{"src":"/static/logistique.png"}})]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)],1)],1),_vm._v(" "),_c('v-list',{staticClass:"pt-0",attrs:{"dense":""}},[_c('v-divider'),_vm._v(" "),_vm._l((item.sousMenus),function(sousMenu){return _c('v-list-tile',{on:{"click":function($event){return _vm.switchFonction(sousMenu.action)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(sousMenu.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(sousMenu.title))])],1)],1)})],2)],1)}),0),_vm._v(" "),_c('CarteCarburantIndex',{attrs:{"show":_vm.showDialogCarburant},on:{"close":function($event){_vm.showDialogCarburant = false;}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ffyb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h4',[_vm._v("LISTE DES CHANTIERS")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('data-tables',{attrs:{"data":_vm.listeChantiers,"resizable":false}},[_c('el-table-column',{attrs:{"prop":"dateC","width":"98","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"200","prop":"libelle","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chefChantier","label":"Chef Chantier"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":""}},[_vm._v(" "+_vm._s(scope.row.chefChantier))])]}}])}),_vm._v(" "),(_vm.userAdmin)?_c('el-table-column',{attrs:{"prop":"chefChantier","label":"Commis Chantier"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((scope.row.commis),function(item,index){return _c('span',{key:index},[_c('v-chip',{attrs:{"outline":"","text-color":"green","label":""}},[_vm._v(" "+_vm._s(item))]),_vm._v("/\n                          ")],1)})}}],null,false,3976463264)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateD","width":"98","label":"Date Debut"}}),_vm._v("\n                  \\\n                  "),_c('el-table-column',{attrs:{"prop":"dateF","width":"98","label":"Date Fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"evolution","label":"Evolution","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-progress-circular',{attrs:{"size":90,"width":15,"rotate":360,"value":scope.row.evolution,"color":"primary"}},[_vm._v("\n                        "+_vm._s(scope.row.evolution)+" %\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"98","prop":"totalOuvriers","label":"nbre total d'ouvriers"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"warning"}},[_vm._v("\n                        "+_vm._s(scope.row.totalOuvriers))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!_vm.commis)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.newEquipe(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("person_add")])],1),_vm._v("\n                        Liste des ressources techniques...\n                      ")],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetail(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                        Détails...\n                      ")],1)]}}])})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('DashboardChantier',{attrs:{"detailChantier":_vm.detailChantier,"show":_vm.showDetailChantier,"commis":_vm.commis},on:{"close":function($event){_vm.showDetailChantier = false}}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":true,"width":"90%","scrollable":""},model:{value:(_vm.showListOuvrier),callback:function ($$v) {_vm.showListOuvrier=$$v},expression:"showListOuvrier"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("LISTE DES OUVRIERS ET PRESTATAIRE AFFECTES A CE CHANTIER:\n          "+_vm._s(_vm.chantierCourant.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.showListOuvrier = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTE DES OUVRIERS")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.openNewRessource()}},slot:"activator"},[_vm._v("\n              Ajouter\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e(),_vm._v("Ajouter des ouvriers/prestataire\n          ")],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","elevation-2":""}},[_c('v-flex',{attrs:{"sm12":"","mt-2":""}},[_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"mt-3":"","ml-1":"","mr-1":"","data":_vm.listeOuvriers}},[_c('el-table-column',{attrs:{"prop":"idContrat","label":"Contrat","align":"center","width":"100","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("CONT-"+_vm._s(scope.row.idContrat))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nom","label":"NOM","align":"center","width":"230","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateD","label":"Début"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"MONTANT/HEURE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantSupp","label":"MONTANT HEURE SUPP","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etatContrat","label":"Etat contrat","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editRessources(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                    Modifier\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprTyp = true;
                        _vm.IdRessTeck = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                    Supprimer\n                  ")],1)],1)]}}])})],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTE DES PRESTATAIRES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","elevation-2":""}},[_c('v-flex',{attrs:{"sm12":"","mt-2":""}},[_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"mt-3":"","ml-1":"","mr-1":"","data":_vm.listePrestataires}},[_c('el-table-column',{attrs:{"prop":"idContrat","label":"Contrat","align":"center","width":"100","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("CONT-"+_vm._s(scope.row.idContrat))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nom","label":"NOM","align":"center","width":"230","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateD","label":"Début"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"MONTANT/JOUR","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantSupp","label":"MONTANT HEURE SUPP","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etatContrat","label":"Etat contrat","align":"center"}})],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}})],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogEquipe),callback:function ($$v) {_vm.dialogEquipe=$$v},expression:"dialogEquipe"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit !== true)?_c('span',[_vm._v("Définir les équipes")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modifier le contrat de "+_vm._s(_vm.equipeCourant.executant))]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogEquipe = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEdit !== true)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n              Attribuer des personnes à la tâche\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("person_add")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n              Modification du contrat de\n              "+_vm._s(_vm.equipeCourant.executant)+" concernant la tâche\n              "+_vm._s(_vm.equipeCourant.tache)+"\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("person_add")])],1):_vm._e()],1),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chantier concerné")]),_vm._v(" "),_c('el-input',{attrs:{"value":_vm.chantierCourant.libelle,"disabled":""},model:{value:(_vm.chantierCourant.libelle),callback:function ($$v) {_vm.$set(_vm.chantierCourant, "libelle", $$v)},expression:"chantierCourant.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.chantierCourant.dateD,"disabled":""},model:{value:(_vm.chantierCourant.dateD),callback:function ($$v) {_vm.$set(_vm.chantierCourant, "dateD", $$v)},expression:"chantierCourant.dateD"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.chantierCourant.dateF,"disabled":""},model:{value:(_vm.chantierCourant.dateF),callback:function ($$v) {_vm.$set(_vm.chantierCourant, "dateF", $$v)},expression:"chantierCourant.dateF"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md11":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  Ajouter des lignes\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("person_add")])],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","small":"","dark":""},on:{"click":_vm.addOptionEquipe}},[_c('v-icon',[_vm._v("add")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-form',{ref:"formEquipe",attrs:{"lazy-validation":"","id":"formEquipe"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary"},on:{"click":function($event){return _vm.showDialogAjoutOuvrier()}}},[_vm._v("\n                  Ressources techniques\n                  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("add")])],1)],1),_vm._v(" "),_vm._l((_vm.optionEquipe),function(optionE){return (_vm.dialogEdit != true)?_c('v-layout',{key:optionE.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type d'éxecutant")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Type d'éxecutant"},model:{value:(optionE.selectType),callback:function ($$v) {_vm.$set(optionE, "selectType", $$v)},expression:"optionE.selectType"}},_vm._l((optionE.type),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),(optionE.selectType === 1)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prestataire")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Prestataire"},model:{value:(optionE.fournisseur),callback:function ($$v) {_vm.$set(optionE, "fournisseur", $$v)},expression:"optionE.fournisseur"}},_vm._l((_vm.listPrestataire),function(item){return _c('el-option',{key:item.idPres,attrs:{"label":item.libelle,"value":item.idPres}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux")]),_vm._v(" "),_c('el-select',{attrs:{"filterable":"","multiple":"","clearable":"","placeholder":"Travaux"},on:{"change":function($event){return _vm.filtrerTypeChantier()}},model:{value:(_vm.selectTravaux),callback:function ($$v) {_vm.selectTravaux=$$v},expression:"selectTravaux"}},_vm._l((_vm.listTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),(_vm.selectTravaux.length <= 1)?_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tache")]),_vm._v(" "),_c('el-select',{attrs:{"filterable":"","multiple":"","clearable":"","placeholder":"Tache"},model:{value:(_vm.selectTaches),callback:function ($$v) {_vm.selectTaches=$$v},expression:"selectTaches"}},_vm._l((_vm.listTaches.taches),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.tacheLibelle,"value":item.id}})}),1)],1):_vm._e()]):_vm._e(),_vm._v(" "),(optionE.selectType === 2)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ouvrier/Manoeuvre")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Ouvrier/Manoeuvre"},model:{value:(optionE.ouvrier),callback:function ($$v) {_vm.$set(optionE, "ouvrier", $$v)},expression:"optionE.ouvrier"}},_vm._l((_vm.listOuvrier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Durée")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"duree","range-separator":"à","format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","type":"daterange","start-placeholder":"Date de début","end-placeholder":"Date de fin","required":""},model:{value:(optionE.duree),callback:function ($$v) {_vm.$set(optionE, "duree", $$v)},expression:"optionE.duree"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant/forfait (heure)")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","required":"","min":0},model:{value:(optionE.montant),callback:function ($$v) {_vm.$set(optionE, "montant", $$v)},expression:"optionE.montant"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant heures supplementaires")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","min":0},model:{value:(optionE.montantSupp),callback:function ($$v) {_vm.$set(optionE, "montantSupp", $$v)},expression:"optionE.montantSupp"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.preventDefault();return _vm.removeOptionEquipe(optionE)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("Supprimer\n                  ")],1)],1)],1):_vm._e()}),_vm._v(" "),(_vm.dialogEdit)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type d'exécutant")]),_vm._v(" "),_c('el-input',{attrs:{"value":_vm.equipeCourant.typeExec,"disabled":""},model:{value:(_vm.equipeCourant.typeExec),callback:function ($$v) {_vm.$set(_vm.equipeCourant, "typeExec", $$v)},expression:"equipeCourant.typeExec"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Exécutant")]),_vm._v(" "),_c('el-input',{attrs:{"value":_vm.equipeCourant.executant,"disabled":""},model:{value:(_vm.equipeCourant.executant),callback:function ($$v) {_vm.$set(_vm.equipeCourant, "executant", $$v)},expression:"equipeCourant.executant"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateD","value-format":"dd-MM-yyyy","type":"date","required":""},model:{value:(_vm.dateDContrat),callback:function ($$v) {_vm.dateDContrat=$$v},expression:"dateDContrat"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateF","format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","type":"date","required":""},model:{value:(_vm.dateFContrat),callback:function ($$v) {_vm.dateFContrat=$$v},expression:"dateFContrat"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant / Jour")]),_vm._v(" "),_c('el-input',{attrs:{"name":"montant","type":"number","min":0},model:{value:(_vm.montantContrat),callback:function ($$v) {_vm.montantContrat=$$v},expression:"montantContrat"}})],1)])],1):_vm._e()],2)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogEquipe = false}}},[_vm._v("\n            Annuler\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-btn',{attrs:{"icons":"","color":"primary","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.submitEquipe()}}},[_vm._v("\n            Enregistrer\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e(),_vm._v(" "),(
              _vm.dialogEdit &&
                _vm.dateDContrat !== null &&
                _vm.dateFContrat !== null &&
                _vm.montantContrat !== 0
            )?_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.submitEquipe()}}},[_vm._v("\n            Modifier\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"70%"},model:{value:(_vm.dialogAjoutOuvrier),callback:function ($$v) {_vm.dialogAjoutOuvrier=$$v},expression:"dialogAjoutOuvrier"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v(_vm._s(_vm.editForm ? 'Modifier une ressources personnelles' : 'Ajouter une ressources personnelles')+" ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutOuvrier = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-container',[_c('el-form',{ref:"formManoeuvre",attrs:{"label-position":"right","model":_vm.formManoeuvre,"rules":_vm.rulesformManoeuvre,"id":"formManoeuvre","label-width":"120px"}},[_c('el-row',[(_vm.editForm)?_c('el-col',{attrs:{"span":4}},[_c('a',{attrs:{"href":_vm.logoOuvrier,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoOuvrier,"alt":"avatar"}})]),_c('br')],1),_vm._v(" "),_c('input',{ref:"fileOuvrier",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageOuvrierPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileOuvrier.click()}}},[_vm._v("Photo "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-form-item',{attrs:{"label":"Matricule","prop":"matricule"}},[_c('el-input',{model:{value:(_vm.formManoeuvre.matricule),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "matricule", $$v)},expression:"formManoeuvre.matricule"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-form-item',{attrs:{"label":"Nom","prop":"nom"}},[_c('el-input',{model:{value:(_vm.formManoeuvre.nom),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "nom", $$v)},expression:"formManoeuvre.nom"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-form-item',{attrs:{"label":"Domicile","prop":"domicile"}},[_c('el-input',{model:{value:(_vm.formManoeuvre.domicile),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "domicile", $$v)},expression:"formManoeuvre.domicile"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-form-item',{attrs:{"label":"Profession","prop":"profession"}},[_c('el-input',{model:{value:(_vm.formManoeuvre.profession),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "profession", $$v)},expression:"formManoeuvre.profession"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-form-item',{attrs:{"label":"Type de piece","prop":"piece"}},[_c('el-input',{model:{value:(_vm.formManoeuvre.piece),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "piece", $$v)},expression:"formManoeuvre.piece"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"numéro de pièce","prop":"numPiece"}},[_c('el-input',{model:{value:(_vm.formManoeuvre.numPiece),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "numPiece", $$v)},expression:"formManoeuvre.numPiece"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Contact","prop":"contact"}},[_c('el-input',{model:{value:(_vm.formManoeuvre.contact),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "contact", $$v)},expression:"formManoeuvre.contact"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Date de naissance","prop":"dateNaiss"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Date de naissance"},model:{value:(_vm.formManoeuvre.dateNaiss),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "dateNaiss", $$v)},expression:"formManoeuvre.dateNaiss"}})],1)],1),_vm._v(" "),(_vm.editForm)?_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Date de debut","prop":"dateD"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Date de debut"},model:{value:(_vm.formManoeuvre.dateD),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "dateD", $$v)},expression:"formManoeuvre.dateD"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.editForm)?_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Date de fin","prop":"dateD"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Date de fin"},model:{value:(_vm.formManoeuvre.dateF),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "dateF", $$v)},expression:"formManoeuvre.dateF"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.editForm)?_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Montant/forfait (Heure)","prop":"montant"}},[_c('el-input',{attrs:{"type":"number","required":"","min":0},model:{value:(_vm.formManoeuvre.montant),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "montant", $$v)},expression:"formManoeuvre.montant"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.editForm)?_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Montant heures supplementaires","prop":"montantSupp"}},[_c('el-input',{attrs:{"type":"number","required":"","min":0},model:{value:(_vm.formManoeuvre.montantSupp),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "montantSupp", $$v)},expression:"formManoeuvre.montantSupp"}})],1)],1):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialogAjoutOuvrier = false}}},[_vm._v("Fermer")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.submitformManoeuvre('formManoeuvre')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprTyp),callback:function ($$v) {_vm.dialogSuprTyp=$$v},expression:"dialogSuprTyp"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cet enregistrement ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprTyp = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteType($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FmqX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FicheDetailCarte_vue__ = __webpack_require__("D+DM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9849295c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FicheDetailCarte_vue__ = __webpack_require__("JvN7");
function injectStyle (ssrContext) {
  __webpack_require__("84cN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9849295c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FicheDetailCarte_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9849295c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FicheDetailCarte_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fqjw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__ = __webpack_require__("HabK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10f3fca5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__ = __webpack_require__("svFH");
function injectStyle (ssrContext) {
  __webpack_require__("BW/d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10f3fca5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10f3fca5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Vb+l");
__webpack_require__("Oq2I");
__webpack_require__("miEh");

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'home',
    data: function data() {
        return {
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            items: [{ path: '/login', text: 'Accueil', disabled: false }],
            listLastCommande: [],
            listLastFacture: [],
            listLastLivraison: [],
            listLastPaiemnet: [],
            listRetardPaiemnet: [],
            listDemandeAnnee: [],
            nbrSms: 0,
            disabledBtnCmd: false,
            disabledBtnFact: false,
            disabledBtnLiv: false,
            disabledBtnPaie: false,
            disabledBtnReta: false
        };
    },

    methods: {
        loadPage: function loadPage() {
            var loading = this.$loading({
                lock: true,
                text: 'Veuillez patientez ...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(function () {
                loading.close();
            }, 1000);
        },
        loadLastCommande: function loadLastCommande() {
            var _this = this;

            var url = this.domaine + 'webService/last/commande';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this.listLastCommande = response.body.commande;
                    if (_this.listLastCommande === undefined || _this.listLastCommande.length == 0) {
                        _this.disabledBtnCmd = true;
                    } else {
                        _this.disabledBtnCmd = false;
                    }
                }
            });
        },
        loadLastFacture: function loadLastFacture() {
            var _this2 = this;

            var url = this.domaine + 'webService/last/facture';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this2.listLastFacture = response.body.facture;
                    if (_this2.listLastFacture === undefined || _this2.listLastFacture.length == 0) {
                        _this2.disabledBtnFact = true;
                    } else {
                        _this2.disabledBtnFact = false;
                    }
                }
            });
        },
        loadLastLivraison: function loadLastLivraison() {
            var _this3 = this;

            var url = this.domaine + 'webService/last/livraison';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this3.listLastLivraison = response.body.livraison;
                    if (_this3.listLastLivraison === undefined || _this3.listLastLivraison.length == 0) {
                        _this3.disabledBtnLiv = true;
                    } else {
                        _this3.disabledBtnLiv = false;
                    }
                }
            });
        },
        loadLastPaiement: function loadLastPaiement() {
            var _this4 = this;

            var url = this.domaine + 'webService/last/paiement';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this4.listLastPaiemnet = response.body.paiement;
                    if (_this4.listLastPaiemnet === undefined || _this4.listLastPaiemnet.length == 0) {
                        _this4.disabledBtnPaie = true;
                    } else {
                        _this4.disabledBtnPaie = false;
                    }
                }
            });
        },
        loadRetardPaiement: function loadRetardPaiement() {
            var _this5 = this;

            var url = this.domaine + 'webService/retard/paiement';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this5.listRetardPaiemnet = response.body.retard;
                    if (_this5.listRetardPaiemnet === undefined || _this5.listRetardPaiemnet.length == 0) {
                        _this5.disabledBtnReta = true;
                    } else {
                        _this5.disabledBtnReta = false;
                    }
                }
            });
        },
        loadStatDemandeAnnee: function loadStatDemandeAnnee() {
            var _this6 = this;

            var url = this.domaine + 'webService/index';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this6.listDemandeAnnee = response.body.demande;
                    _this6.nbrSms = response.body.nbrSms;
                    _this6.statDemandeAnnee();
                }
            });
        },
        statDemandeAnnee: function statDemandeAnnee() {
            //optionUser
            var optionDemandeAnnee = {
                title: {
                    text: 'DEMANDES TRAITE ET NON TRAITE DURANT LES 12 DERNIERS MOIS',
                    subtext: '',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                legend: {
                    data: []
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    data: []
                }],
                yAxis: [{
                    type: 'value'
                }],
                series: [{
                    name: 'Demandes réfusés',
                    type: 'bar',
                    data: []
                }, {
                    name: 'Demandes en cours',
                    type: 'bar',
                    stack: '',
                    data: []
                }, {
                    name: 'Demandes traité',
                    type: 'bar',
                    stack: '',
                    data: []
                }]
            };

            this.listDemandeAnnee.forEach(function (element) {
                optionDemandeAnnee.xAxis[0].data.push(element.date);
                optionDemandeAnnee.series[0].data.push(element.traite);
                optionDemandeAnnee.series[1].data.push(element.nonTraite);
                optionDemandeAnnee.series[2].data.push(element.refuse);
            });

            var userChart = echarts.init(document.getElementById('userChart'));
            userChart.setOption(optionDemandeAnnee);
        },
        imprimeListeCmde: function imprimeListeCmde(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + "webService/imprimerPDF/commande/last";
            } else {
                url = this.domaine + "webService/imprimerEXC/commande/last";
            }
            window.open(url);
        },
        imprimeListeFact: function imprimeListeFact(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + "webService/imprimerPDF/facture/last";
            } else {
                url = this.domaine + "webService/imprimerEXC/facture/last";
            }
            window.open(url);
        },
        imprimeListeLiv: function imprimeListeLiv(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + "webService/imprimerPDF/livraison/last";
            } else {
                url = this.domaine + "webService/imprimerEXC/livraison/last";
            }
            window.open(url);
        },
        imprimeListePaie: function imprimeListePaie(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + "webService/imprimerPDF/paiement/last";
            } else {
                url = this.domaine + "webService/imprimerEXC/paiement/last";
            }
            window.open(url);
        },
        imprimeListeRetard: function imprimeListeRetard(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + "webService/imprimerPDF/paie-retard/last";
            } else {
                url = this.domaine + "webService/imprimerEXC/paie-retard/last";
            }
            window.open(url);
        }
    },
    mounted: function mounted() {
        this.loadPage();
        this.loadLastCommande();
        this.loadLastFacture();
        this.loadLastLivraison();
        this.loadLastPaiement();
        this.loadRetardPaiement();
        this.loadStatDemandeAnnee();
    },

    beforeMount: function beforeMount() {
        if (!this.roleAcces[this.$router.history.current.name]) {
            if (this.user.type === 1) {
                this.$router.push({ name: 'Home' });
            } else if (this.user.type === 2) {
                this.$router.push({ name: 'Demande' });
            } else if (this.user.type === 3) {
                this.$router.push({ name: 'Fournisseur' });
            }
        }
    }
});

/***/ }),

/***/ "FvTE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: "search",
  props: {
    show: {
      type: Boolean
    },
    detailChantier: {
      type: Object
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
      user: JSON.parse(sessionStorage.getItem('userInfo')),
      roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
      droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
      loading: false,
      listResulat: [],
      typeRech: '',
      valuetypeRech: '',

      //ONGLET TRAVAUX
      detailTravaux: {},
      dialogConfirmRefus: false,
      showRapport: false,
      showListeRapport: false,
      dialogListeRapport: false,
      dialogShowLivraison: false,
      dialogShowFacture: false,
      dialogShowCommande: false,
      valid: true,
      optionLivr: [],
      detailLivraison: [],
      showBoat: false,
      showConteneurs: false,
      totalComHT: 0,
      totalComHTSR: 0,
      totalComRemise: 0,
      totalComTVA: 0,
      totalComTTC: 0,
      totComLigneTTC: 0,
      nomFourn: '',
      selectFourn: [],
      listFourn: [],
      showButon: false,
      showButonExcel: false,

      listCommande: [],
      idComm: '',
      detailCommande: [],
      livraisonCourant: [],
      commCourant: [],
      listFacture: [],
      factureCourant: [],
      detailFacture: [],

      listeRapports: [],
      periodeFormat: "",

      //ONGLET RESERVE
      listeReserves: [],

      //DASHBOARD TRAVAUX
      formRecherche: {
        commande: '',
        facture: '',
        livraison: ''
      }
    };
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    headerRowStyle: function headerRowStyle(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return { "color": "black" };
    },
    getSumm: function getSumm(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }

        if (index === 4) {
          sums[index] = "N/A";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              var total = prev + curr;
              return Math.round(total);
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    imprimerFacture: function imprimerFacture(ligne) {
      var url = this.domaine + 'fournisseur/' + ligne.idFact + '/' + this.user.id + '/imprimer/facture';
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    imprimerCommande: function imprimerCommande(ligne) {
      var url = this.domaine + 'fournisseur/' + ligne.id + '/imprimer/commande/' + this.user.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    imprimerLivraison: function imprimerLivraison(ligne) {
      var url = this.domaine + 'fournisseur/' + ligne.id + '/imprimer/livraison/' + this.user.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    tableRowClassName: function tableRowClassName(_ref2) {
      var row = _ref2.row,
          rowIndex = _ref2.rowIndex;

      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    imprimerAppro: function imprimerAppro(ligne) {
      var _this = this;

      this.loading = true;
      this.approCourant = ligne;
      var url = this.domaine + 'entrepot/' + ligne.id + '/' + this.user.id + '/imprimer/approvisionnement';
      this.$http.get(url).then(function (response) {
        _this.loading = false;
        if (response.body) {}
      });
      window.open(url);
    },
    showInfo: function showInfo(row) {
      var totalHT = 0;
      var totalTVA = 0;
      var totalRemise = 0;
      switch (this.typeRech) {
        case 'commande':
          this.dialogShowCommande = true;
          this.detailCommande = row;
          this.optionLivr = row.optionLivr;
          for (var option in row.option) {
            var item = row.option[option];

            var tmpTotalHTSRem = parseFloat(item.prix * item.qte);
            var mntRemise = 0;
            var remise = parseFloat(item.remise);
            if (remise > 0) {
              mntRemise = tmpTotalHTSRem * remise / 100;
            }
            var tmpTotalHT = tmpTotalHTSRem - mntRemise;
            var tva = parseFloat(item.tva);
            var tmpTotalTVA = tmpTotalHT * (tva / 100);

            totalTVA += tmpTotalTVA;
            totalHT += tmpTotalHT;
            totalRemise += mntRemise;
          }
          this.totalComHT = new Intl.NumberFormat().format(totalHT);
          this.totalComTVA = new Intl.NumberFormat().format(totalTVA);
          this.totalComRemise = new Intl.NumberFormat('fr-Fr').format(totalRemise);
          break;

        case 'livraison':
          this.dialogShowLivraison = true;
          this.livraisonCourant = row;
          if (this.detailLivraison) {
            if (this.detailLivraison[0].export) {
              this.showBoat = true;
            }

            if (this.detailLivraison[0].conteneurs.length > 0) {
              this.showConteneurs = true;
            }
          }

          for (var _option in row.option) {
            var _item = row.option[_option];

            var _tmpTotalHTSRem = parseFloat(_item.prix * _item.qte);
            var _mntRemise = 0;
            var _remise = parseFloat(_item.remise);
            if (_remise > 0) {
              _mntRemise = _tmpTotalHTSRem * _remise / 100;
            }
            var _tmpTotalHT = _tmpTotalHTSRem - _mntRemise;
            var _tva = parseFloat(_item.tva);
            var _tmpTotalTVA = _tmpTotalHT * (_tva / 100);

            totalTVA += _tmpTotalTVA;
            totalHT += _tmpTotalHT;
            totalRemise += _mntRemise;
          }
          this.totalComHT = new Intl.NumberFormat().format(totalHT);
          this.totalComTVA = new Intl.NumberFormat().format(totalTVA);
          this.totalComRemise = new Intl.NumberFormat('fr-Fr').format(totalRemise);

          break;

        case 'facture':
          this.dialogShowFacture = true;
          this.detailFacture = row;
          for (var _option2 in row.option) {
            var _item2 = row.option[_option2];

            var _tmpTotalHTSRem2 = parseFloat(_item2.prix * _item2.qte);
            var _mntRemise2 = 0;
            var _remise2 = parseFloat(_item2.remise);
            if (_remise2 > 0) {
              _mntRemise2 = _tmpTotalHTSRem2 * _remise2 / 100;
            }
            var _tmpTotalHT2 = _tmpTotalHTSRem2 - _mntRemise2;
            var _tva2 = parseFloat(_item2.tva);
            var _tmpTotalTVA2 = _tmpTotalHT2 * (_tva2 / 100);

            totalTVA += _tmpTotalTVA2;
            totalHT += _tmpTotalHT2;
            totalRemise += _mntRemise2;
          }
          this.totalComHT = new Intl.NumberFormat().format(totalHT);
          this.totalComTVA = new Intl.NumberFormat().format(totalTVA);
          this.totalComRemise = new Intl.NumberFormat('fr-Fr').format(totalRemise);

          break;

        case 'approvisionnement':

          break;

        default:
          break;
      }
    },
    generateFile: function generateFile(format, etat) {
      var _this2 = this;

      var formdata = new FormData();
      formdata.append('idUser', this.user.id);
      formdata.append('typeRech', this.typeRech);
      formdata.append('commande', this.formRecherche.commande);
      formdata.append('livraison', this.formRecherche.livraison);
      formdata.append('approvisionnement', this.formRecherche.approvisionnement);
      formdata.append('facture', this.formRecherche.facture);
      formdata.append('fournisseur', this.selectFourn);

      var url = '';

      if (format == 'pdf') {
        url = this.domaine + "fournisseur/imprimerPDF/listeRecherche/" + etat;
        var req = new XMLHttpRequest();
        this.$http.post(url, formdata, { responseType: "arraybuffer" }).then(function (response) {
          var blob = new Blob([response.data], {
            type: response.headers.get("content-type")
          });

          var url = URL.createObjectURL(blob);
          _this2.loading = false;
          window.open(url);
        });
      } else {

        var idUser = this.user.id;
        var typeRech = this.typeRech;
        var commande = 'undefined';
        if (this.formRecherche.commande) commande = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([this.formRecherche.commande]);
        if (this.formRecherche.facture) commande = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formRecherche.facture);
        if (this.formRecherche.livraison) commande = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formRecherche.livraison);

        var fournisseur = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectFourn);

        url = this.domaine + "fournisseur/imprimerEXC/recherche/liste/" + idUser + '/' + typeRech + '/' + commande + '/' + fournisseur;

        window.open(url);
      }
    },
    loadFourn: function loadFourn() {
      var _this3 = this;

      this.loading = true;
      var url = '';
      url = this.domaine + 'fournisseur/index';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this3.listFourn = response.body.fournisseur;
          _this3.loading = false;
        }
      });
    },
    imprimerInfo: function imprimerInfo(row) {
      switch (this.typeRech) {
        case 'commande':
          this.imprimerCommande(row);
          break;

        case 'livraison':
          this.imprimerLivraison(row);
          break;

        case 'facture':
          this.imprimerFacture(row);
          break;

        case 'approvisionnement':
          this.imprimerAppro(row);
          break;

        default:
          break;
      }
    },
    recherche: function recherche() {
      var _this4 = this;

      this.loading = true;
      this.listResulat = [];
      this.showButon = true;

      switch (this.typeRech) {
        case 'commande':
          if (this.formRecherche.commande == '' || this.formRecherche.commande == 'undefined') {
            this.showButonExcel = true;
          } else {
            this.showButonExcel = false;
          }
          break;

        case 'livraison':
          if (this.formRecherche.livraison == '' || this.formRecherche.livraison == 'undefined') {
            this.showButonExcel = true;
          }
          break;

        case 'facture':
          if (this.formRecherche.facture == '' || this.formRecherche.facture == 'undefined') {
            this.showButonExcel = true;
          }
          break;

        default:
          if (this.formRecherche.commande == '' || this.formRecherche.commande == 'undefined') {
            this.showButonExcel = true;
          } else {
            this.showButonExcel = false;
          }
          break;
      }
      var form = document.getElementById('formRech');
      var data = new FormData(form);
      var url = this.domaine + 'fournisseur/serach/globale';
      data.append('idUser', this.user.id);
      data.append('typeRech', this.typeRech);
      data.append('commande', this.formRecherche.commande);
      data.append('livraison', this.formRecherche.livraison);
      data.append('approvisionnement', this.formRecherche.approvisionnement);
      data.append('facture', this.formRecherche.facture);
      data.append('fournisseur', this.selectFourn);

      this.$http.post(url, data).then(function (response) {
        if (response.body) {
          var verif = response.body;
          _this4.listResulat = response.body.result;
          if (verif.code === 2) {
            _this4.$notify({
              title: 'RESULTATS DE VOTRE RECHERCHE',
              message: verif.message,
              type: 'success',
              position: 'top-center'
            });
          } else {
            _this4.$notify({
              title: 'RESULTATS DE VOTRE RECHERCHE',
              message: verif.message,
              type: 'warning',
              position: 'top-center'
            });
          }
          _this4.loading = false;
        } else {
          _this4.$message.error('Erreur serveur');
          _this4.loading = false;
        }
      }, function (error) {
        _this4.$message.error('Erreur serveur');
        _this4.loading = false;
      });
    }
  },
  mounted: function mounted() {
    this.loadFourn();
  },

  computed: {
    desactiveBout: function desactiveBout() {

      return this.formTri.periode == undefined;
    }
  }

});

/***/ }),

/***/ "G+K8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Password_vue__ = __webpack_require__("pbl8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57d4cd64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Password_vue__ = __webpack_require__("LUUQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57d4cd64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G9KA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_intervention_AjoutIntervention__ = __webpack_require__("dPof");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_intervention_AjoutDiagIntervention__ = __webpack_require__("YdvK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_intervention_DetailIntervention__ = __webpack_require__("3jxz");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */],
    AjoutIntervention: __WEBPACK_IMPORTED_MODULE_1__components_intervention_AjoutIntervention__["a" /* default */],
    AjoutDiagIntervention: __WEBPACK_IMPORTED_MODULE_2__components_intervention_AjoutDiagIntervention__["a" /* default */],
    DetailIntervention: __WEBPACK_IMPORTED_MODULE_3__components_intervention_DetailIntervention__["a" /* default */]
  },
  name: "InterventionIndex",
  props: ["show"],
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      labelPosition: "left",
      dialogInterv: false,
      listIntervention: [],
      loading: false,

      //Ajout intervention
      showModalInterv: false,
      intervDetail: {},

      //Modal diagnostic
      showModalDiagnostic: false,

      //Planification
      idDmdInterv: "",
      dialogPlanification: false,
      formPlanning: {},
      rulesformPlanning: {
        dateDbt: [{
          required: true,
          message: "Choisir une date de debut",
          trigger: "change"
        }],
        dateFin: [{
          required: true,
          message: "Choisir une date de fin",
          trigger: "change"
        }],
        kilometrage: [{
          required: true,
          message: "Saisir le Km au compteur",
          trigger: "change"
        }]
      },
      //Rapport de depannage
      formRapport: {},
      rulesformRapport: {},
      dialogRapport: false,
      image1: "/static/img-doc.png",
      dialogSupr: false,

      //detail intervention
      showModalIntervDetail: false
    };
  },


  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogInterv = newValue;
      if (newValue == true) {
        this.listeIntervention();
      } else {}
    }
  },

  methods: {
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onFileImage1Picked: function onFileImage1Picked(event) {
      var _this = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this.image1 = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.file1 = files[0];
    },
    showIntervention: function showIntervention(item) {
      this.intervDetail = item;
      this.showModalIntervDetail = true;
    },
    modalPlaning: function modalPlaning(item) {
      this.idDmdInterv = item.id, this.dialogPlanification = true;
    },
    modalRapport: function modalRapport(item) {
      this.idDmdInterv = item.id, this.dialogRapport = true;
    },
    listeIntervention: function listeIntervention() {
      var _this2 = this;

      this.loading = true;
      var url = "";
      if (this.droitAcces.intervention) {
        url = this.domaine + "intervention/index";
      } else {
        url = this.domaine + "intervention/demandeur/" + this.user.id + "/index";
      }
      this.$http.get(url).then(function (response) {
        _this2.loading = false;
        _this2.listIntervention = response.body.intervention;
      }, function (errRep) {
        _this2.loading = false;
        _this2.$message.error("Une erreur lors du chargement de la liste des interventions'");
      });
    },
    submitFormPlanning: function submitFormPlanning(formName) {
      var _this3 = this;

      this.loading = true;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var form = document.getElementById("formPlanning");
          var data = new FormData(form);
          data.append("idUser", _this3.user.id);
          data.append("dateD", _this3.formPlanning.dateDbt);
          data.append("dateF", _this3.formPlanning.dateFin);
          data.append("kilometrage", _this3.formPlanning.kilometrage);
          //data.append('etape', etape)

          var url = _this3.domaine + "intervention/new/" + _this3.idDmdInterv + "/programmation";
          _this3.$http.post(url, data).then(function (response) {
            _this3.resetForm("formPlanning");
            _this3.loading = false;
            _this3.$notify({
              title: "ENREGISTREMENT REUSSI",
              message: "Programmation enregistrée avec succès.",
              type: "success",
              position: "top-center"
            });

            _this3.dialogPlanification = false;
            _this3.listeIntervention();
          }, function (response) {
            _this3.resetForm("formPlanning");
            _this3.dialogPlanification = false;
            _this3.loading = false;
            _this3.$message.error("Erreur lors de l'enregistrement de la planification");
          });
        }
      });
    },
    submitFormRapport: function submitFormRapport(formName) {
      var _this4 = this;

      this.loading = true;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var form = document.getElementById("formRapport");
          var data = new FormData(form);
          data.append("idUser", _this4.user.id);

          //data.append('etape', etape)

          var url = _this4.domaine + "intervention/new/" + _this4.idDmdInterv + "/fin/intervention";
          _this4.$http.post(url, data).then(function (response) {
            _this4.loading = false;
            _this4.$notify({
              title: "ENREGISTREMENT REUSSI",
              message: "Rapport enregistrée avec succès.",
              type: "success",
              position: "top-center"
            });

            _this4.dialogRapport = false;
            _this4.listeIntervention();
          }, function (response) {
            _this4.dialogRapport = false;
            _this4.loading = false;
            _this4.$message.error("Erreur lors de l'enregistrement du rapport de depannage");
          });
        }
      });
    },
    imprimerDemande: function imprimerDemande(ligne) {
      this.interventionCourant = ligne;
      var url = this.domaine + "intervention/" + this.interventionCourant.id + "/imprimer";
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    deleteInterv: function deleteInterv() {
      var _this5 = this;

      this.loading = true;
      var url = this.domaine + "intervention/" + this.idDmdInterv + "/delete";
      this.$http.get(url).then(function (response) {
        _this5.loading = false;

        _this5.$notify({
          title: "SUPPRESSION",
          message: "Intervention supprimée avec succès.",
          type: "success",
          position: "top-center"
        });
        _this5.dialogSupr = false;
        _this5.loading = false;
        _this5.listeIntervention();
      }, function (response) {
        _this5.dialogRapport = false;
        _this5.loading = false;
        _this5.$message.error("Erreur lors de la suppression de l'intervention");
      });
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    successNotif: function successNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      this.$notify({
        title: "ENREGISTREMENT REUSSI",
        message: mess,
        type: "success",
        position: "top-center"
      });
    },
    modalAjoutInterv: function modalAjoutInterv() {
      this.intervDetail = {};
      this.showModalInterv = true;
    },
    modalEditInterv: function modalEditInterv(item) {
      this.intervDetail = item;
      this.showModalInterv = true;
    },
    modalDiagnostic: function modalDiagnostic(item) {
      this.intervDetail = item;
      this.showModalDiagnostic = true;
    },
    imprimeListeDemande: function imprimeListeDemande(type) {
      var url = "";
      if (type == "PDF") {
        if (this.droitAcces.intervention) {
          url = this.domaine + "intervention/imprimerPDF/liste";
        } else {
          url = this.domaine + "intervention/imprimerPDF/" + this.user.id + "/liste";
        }
      } else {
        if (this.droitAcces.intervention) {
          url = this.domaine + "intervention/imprimerEXC/liste";
        } else {
          url = this.domaine + "intervention/imprimerEXC/" + this.user.id + "/liste";
        }
      }
      window.open(url);
    }
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ "G9jN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","persistent":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogModalDetailEmp),callback:function ($$v) {_vm.dialogModalDetailEmp=$$v},expression:"dialogModalDetailEmp"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Informations personnelles et professionnelles")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"pt-2 pr-2 pb-2 pl-2",attrs:{"xs12":""}},[_c('detailEmploye',{attrs:{"showEmpl":_vm.dialogModalDetailEmp,"idUserCont":_vm.userIdContrat}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GBiN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogInterv),callback:function ($$v) {_vm.dialogInterv=$$v},expression:"dialogInterv"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Liste des demandes d'intervention ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('div',{staticClass:"text-xs-right mt-3"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeListeDemande('PDF')}},slot:"activator"},[_vm._v("Imprimer PDF "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("\n            PDF\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"warning","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeListeDemande('EXC')}},slot:"activator"},[_vm._v("Imprimer EXCEL "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("\n            Excel\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.modalAjoutInterv()}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n            Ajouter une nouvelle intervention\n          ")],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listIntervention}},[_c('el-table-column',{attrs:{"prop":"vehicule","label":"Véhicule","width":"380","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.vehicule)+"\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("directions_car")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date","width":"280"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.date)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.type == 'Curative')?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                    REPARATION\n                  ")]):_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                    MAINTENANCE\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"categprie","label":"Catégorie","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.categorie)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demandeur","label":"Demandeur","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat / Etape"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    DIAGNOSTIQUE EN ATTENTE\n                  ")]):(scope.row.etat == 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"warning"}},[_vm._v("\n                    EN ATTENTE DE VALIDATION DU DEVIS\n                  ")]):(scope.row.etat == 2)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                    INTERVENTION REFUSEE\n                  ")]):(scope.row.etat == 3)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                    DEVIS VALIDE\n                  ")]):(scope.row.etat == 4)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                    DIVIS REFUSE\n                  ")]):(scope.row.etat == 5)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                    INTERVENTION TERMINEE\n                  ")]):(scope.row.etat == 6)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                    INTERVENTION EN COURS\n                  ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.showIntervention(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                      Détails\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat == 0)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.modalEditInterv(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                      Modifier\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(
                          scope.row.etat == 0 && _vm.droitAcces.new_diagnostique
                        )?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"teal"},on:{"click":function($event){return _vm.modalDiagnostic(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("build")])],1):_vm._e(),_vm._v("\n                      Effectuer le diagnostique\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(
                          scope.row.etat == 3 && _vm.droitAcces.new_programmation
                        )?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.modalPlaning(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("view_agenda")])],1):_vm._e(),_vm._v("\n                      Planifier l'intervention\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(
                          scope.row.etat == 6 &&
                            _vm.droitAcces.new_fin_intervention
                        )?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"yellow"},on:{"click":function($event){return _vm.modalRapport(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1):_vm._e(),_vm._v("\n                      Rapport de depannage\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(
                          _vm.droitAcces.Intervention_delete &&
                            scope.row.etat == 0
                        )?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSupr = true;
                          _vm.idDmdInterv = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                      Supprimer\n                    ")],1)],1)]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("INTERVENTION")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("\n              INTERV-"+_vm._s(_vm.idDmdInterv)+"\n            ")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.deleteInterv()}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"750","persistent":true,"transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogRapport),callback:function ($$v) {_vm.dialogRapport=$$v},expression:"dialogRapport"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Rapport de fin pour l'intervention INTERV-"+_vm._s(_vm.idDmdInterv))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogRapport = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formRapport",staticClass:"demo-form-inline",attrs:{"id":"formRapport","label-width":"170px","model":_vm.formRapport,"rules":_vm.rulesformRapport}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-flex',{staticClass:"mr-2",attrs:{"xs6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"170px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.image1,"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"file1",staticStyle:{"display":"none"},attrs:{"name":"image1","type":"file","accept":"image/*"},on:{"change":_vm.onFileImage1Picked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.file1.click()}}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('div',{staticClass:"font-weight-thin"},[_vm._v("\n                    Fichier au format (JPEG,PNG,PDF) avec une taille de 1048\n                    ko maximale\n                  ")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Remarque","prop":"rapport"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"remarque","type":"textarea","rows":6,"placeholder":"Rapport"},model:{value:(_vm.formRapport.remarque),callback:function ($$v) {_vm.$set(_vm.formRapport, "remarque", $$v)},expression:"formRapport.remarque"}})],1)],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){return _vm.resetForm('formRapport')}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitFormRapport('formRapport')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"750","persistent":true,"transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogPlanification),callback:function ($$v) {_vm.dialogPlanification=$$v},expression:"dialogPlanification"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Planifier une intervention pour la demande INTERV-"+_vm._s(_vm.idDmdInterv))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogPlanification = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formPlanning",staticClass:"demo-form-inline",attrs:{"id":"formPlanning","label-width":"150px","model":_vm.formPlanning,"rules":_vm.rulesformPlanning}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"label":"Date et heure debut","prop":"dateDbt"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"d-MM-yyyy HH:mm","value-format":"yyyy-MM-d HH:mm","name":"dateDbt","type":"datetime","placeholder":"Date de debut"},model:{value:(_vm.formPlanning.dateDbt),callback:function ($$v) {_vm.$set(_vm.formPlanning, "dateDbt", $$v)},expression:"formPlanning.dateDbt"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"label":"Date et heure fin","prop":"dateFin"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"d-MM-yyyy HH:mm","value-format":"yyyy-MM-d HH:mm","name":"dateFin","type":"datetime","placeholder":"Date de fin"},model:{value:(_vm.formPlanning.dateFin),callback:function ($$v) {_vm.$set(_vm.formPlanning, "dateFin", $$v)},expression:"formPlanning.dateFin"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"label":"Kilometrage","prop":"kilometarge"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0.0,"placeholder":"Kilometrage","name":"kilometrage"},model:{value:(_vm.formPlanning.kilometrage),callback:function ($$v) {_vm.$set(_vm.formPlanning, "kilometrage", $$v)},expression:"formPlanning.kilometrage"}})],1)],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){return _vm.resetForm('formPlanning')}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitFormPlanning('formPlanning')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('AjoutIntervention',{attrs:{"intervDetail":_vm.intervDetail,"show":_vm.showModalInterv},on:{"close":function($event){_vm.showModalInterv = false;
      _vm.listeIntervention();}}}),_vm._v(" "),_c('AjoutDiagIntervention',{attrs:{"demandeDetail":_vm.intervDetail,"show":_vm.showModalDiagnostic},on:{"close":function($event){_vm.showModalDiagnostic = false;
      _vm.listeIntervention();}}}),_vm._v(" "),_c('DetailIntervention',{attrs:{"intervDetail":_vm.intervDetail,"show":_vm.showModalIntervDetail},on:{"close":function($event){_vm.showModalIntervDetail = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GUsS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogDetail),callback:function ($$v) {_vm.dialogDetail=$$v},expression:"dialogDetail"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Fiche de Validation des demandes d'approvisionnements")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                        Informations sur les demandes d'approvisionnements\n                                    ")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Trésorerie")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                        "+_vm._s(_vm.approDetail.caisseType)+"\n                                                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de la demande")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                        "+_vm._s(_vm.approDetail.dateDmd)+"\n                                                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Demande éffectuée par ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                        "+_vm._s(_vm.approDetail.initiateur)+"\n                                                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Motif de la demande ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                        "+_vm._s(_vm.approDetail.motif)+"\n                                                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("MONTANT (TTC): ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"color":"orange","xs6":""}},[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_vm._v("\n                                                                        "+_vm._s(_vm.approDetail.montant)+" FCFA\n                                                                      ")])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Libellé trésorerie")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                        "+_vm._s(_vm.approDetail.caisseLibelle)+"\n                                                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Solde actuel")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                        "+_vm._s(_vm.approDetail.caisseSolde)+" FCFA\n                                                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5",staticStyle:{"margin-right":"100px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"red"},on:{"click":function($event){_vm.dialogConfirmRefus = true}},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Refuser la demande")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"green"},on:{"click":function($event){_vm.dialogConfirm = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v("Valider la demande")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirmRefus),callback:function ($$v) {_vm.dialogConfirmRefus=$$v},expression:"dialogConfirmRefus"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation de le demande d'approvisionnement")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous Refuser cette demande ?","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("TRESORERIE: "+_vm._s(_vm.approDetail.caisseType))]),_vm._v(" "),_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("LIBELLE: "+_vm._s(_vm.approDetail.caisseLibelle))]),_vm._v(" "),_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("GERE PAR: "+_vm._s(_vm.approDetail.initiateur))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{ref:"formRefus",staticClass:"demo-ruleForm",attrs:{"model":_vm.formRefus,"rules":_vm.rulesRefus,"id":"formRefus","label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"Commentaire","prop":"rapport"}},[_c('el-input',{attrs:{"type":"textarea","name":"rapport","placeholder":"Laisser ici votre commentaire","rows":5},model:{value:(_vm.formRefus.rapport),callback:function ($$v) {_vm.$set(_vm.formRefus, "rapport", $$v)},expression:"formRefus.rapport"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){return _vm.resetFormRefusAppro('formRefus')}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},nativeOn:{"click":function($event){return _vm.submitRefusAppro('formRefus')}}},[_vm._v("Refuser")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650px"},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation de l'approvisionnement")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p',[_c('b',[_vm._v("Vous")]),_vm._v(" êtes sur le point de valider la demande")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("APPRO-"+_vm._s(_vm.approDetail.id))])]),_vm._v(" "),(_vm.formValidate.choix == 2)?_c('el-alert',{attrs:{"title":"NB: Par chèque le gerant sera tenu de completer les pièces de la transaction","type":"warning","closable":false}}):_vm._e()],1),_vm._v(" "),_c('el-form',{ref:"formValidate",staticClass:"demo-ruleForm demo-form-inline",attrs:{"model":_vm.formValidate,"inline":true,"label-width":"150px"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"prop":"choix","label":"Type de règlement","rules":[
                                      { required: true, message: 'Le champs est obligatoire'} ]}},[_c('el-select',{attrs:{"placeholder":"Votre choix"},on:{"change":function($event){return _vm.changeReglement()}},model:{value:(_vm.formValidate.choix),callback:function ($$v) {_vm.$set(_vm.formValidate, "choix", $$v)},expression:"formValidate.choix"}},[_c('el-option',{attrs:{"label":"En Espèce","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Par Chèque","value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Autre","value":"3"}})],1)],1)],1),_vm._v(" "),(_vm.formValidate.choix == 2)?_c('v-flex',{staticClass:"mr-1",attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"prop":"banque","label":"La banque","rules":[
                                      { required: true, message: 'Le champs est obligatoire'} ]}},[_c('el-select',{attrs:{"placeholder":"La banque"},model:{value:(_vm.formValidate.banque),callback:function ($$v) {_vm.$set(_vm.formValidate, "banque", $$v)},expression:"formValidate.banque"}},_vm._l((_vm.listBanque),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1):_vm._e(),_vm._v(" "),(_vm.formValidate.choix == 1)?_c('v-flex',{staticClass:"mr-1",attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"prop":"banque","label":"La Caisse","rules":[
                                      { required: true, message: 'Le champs est obligatoire'} ]}},[_c('el-select',{attrs:{"placeholder":"La caisse"},model:{value:(_vm.formValidate.banque),callback:function ($$v) {_vm.$set(_vm.formValidate, "banque", $$v)},expression:"formValidate.banque"}},_vm._l((_vm.listCaisse),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1):_vm._e(),_vm._v(" "),(_vm.formValidate.choix == 3)?_c('v-flex',{staticClass:"mr-2",attrs:{"xs12":""}},[_c('el-form-item',{attrs:{"prop":"commentaire","label":"Commentaire"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"commentaire","placeholder":"Commentaire","rows":2},model:{value:(_vm.formValidate.commantaire),callback:function ($$v) {_vm.$set(_vm.formValidate, "commantaire", $$v)},expression:"formValidate.commantaire"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){return _vm.resetFormValidate('formValidate')}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.submitValidate('formValidate')}}},[_vm._v("Confirmer")])],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GjUy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","xs12":""}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"100%"},model:{value:(_vm.dialogAjoutFournisseur),callback:function ($$v) {_vm.dialogAjoutFournisseur=$$v},expression:"dialogAjoutFournisseur"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter/Editer un nouveau fournisseur")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.closeForm()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formFour",staticClass:"demo-ruleForm",attrs:{"id":"formFour","rules":_vm.rules,"label-position":"top","model":_vm.formFour}},[_c('v-layout',{staticClass:"text-xs-center text-sm-left",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm3":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoFour,"alt":"avatar"}})]),_c('br'),_vm._v(" "),_c('input',{ref:"fileLogo",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileLogo.click()}}},[_vm._v("Photo  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br'),_vm._v(" "),_c('div',{staticClass:"font-weight-thin"},[_vm._v("Fichier au format (JPEG,PNG,PDF) avec une taille de 1048 ko maximale")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm9":""}},[_c('el-row',{attrs:{"gutter":10}},[(_vm.typeFour == 0 )?_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Raison social","prop":"raison"}},[_c('el-input',{attrs:{"placeholder":"Saisir"},model:{value:(_vm.formFour.raison),callback:function ($$v) {_vm.$set(_vm.formFour, "raison", $$v)},expression:"formFour.raison"}})],1)],1)]):_vm._e(),_vm._v(" "),(_vm.typeFour == 0 )?_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"forme juridique","prop":"formJuridique"}},[_c('el-input',{attrs:{"placeholder":"Saisir"},model:{value:(_vm.formFour.formJuridique),callback:function ($$v) {_vm.$set(_vm.formFour, "formJuridique", $$v)},expression:"formFour.formJuridique"}})],1)],1)]):_vm._e(),_vm._v(" "),(_vm.typeFour == 0)?_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Registre de commerce","prop":"registreCommerce"}},[_c('el-input',{attrs:{"placeholder":"Saisir"},model:{value:(_vm.formFour.registre),callback:function ($$v) {_vm.$set(_vm.formFour, "registre", $$v)},expression:"formFour.registre"}})],1)],1)]):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Type fournisseur","prop":"typeFour"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionnez"},model:{value:(_vm.formFour.typeFour),callback:function ($$v) {_vm.$set(_vm.formFour, "typeFour", $$v)},expression:"formFour.typeFour"}},_vm._l((_vm.listeTypeFour),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Corps de métier","prop":"corpsMetier"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","allow-create":"","filterable":"","placeholder":"Selectionnez"},model:{value:(_vm.formFour.corpsMetier),callback:function ($$v) {_vm.$set(_vm.formFour, "corpsMetier", $$v)},expression:"formFour.corpsMetier"}},_vm._l((_vm.listeCorpsMetier),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Civilité/Représentant légal","prop":"civilite"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionnez"},model:{value:(_vm.formFour.civilite),callback:function ($$v) {_vm.$set(_vm.formFour, "civilite", $$v)},expression:"formFour.civilite"}},_vm._l((_vm.listeCivilite),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Nom/Représentant légal","prop":"nom"}},[_c('el-input',{attrs:{"placeholder":"Saisir"},model:{value:(_vm.formFour.nom),callback:function ($$v) {_vm.$set(_vm.formFour, "nom", $$v)},expression:"formFour.nom"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Prénom(s)/Représentant légal","prop":"prenom"}},[_c('el-input',{attrs:{"placeholder":"Saisir"},model:{value:(_vm.formFour.prenom),callback:function ($$v) {_vm.$set(_vm.formFour, "prenom", $$v)},expression:"formFour.prenom"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date de naissance/création","prop":"dateNais"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"d-MM-yyyy","placeholder":"Date de naissance","type":"date"},model:{value:(_vm.formFour.dateNais),callback:function ($$v) {_vm.$set(_vm.formFour, "dateNais", $$v)},expression:"formFour.dateNais"}})],1)],1)]),_vm._v(" "),_c('el-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeFour == 1),expression:"typeFour == 1"}],attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Lieu de naissance","prop":"lieuNais"}},[_c('el-input',{attrs:{"placeholder":"Saisir"},model:{value:(_vm.formFour.lieuNais),callback:function ($$v) {_vm.$set(_vm.formFour, "lieuNais", $$v)},expression:"formFour.lieuNais"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Nature de la pièce","prop":"naturePiece"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","allow-create":"","filterable":"","placeholder":"Selectionnez"},model:{value:(_vm.formFour.naturePiece),callback:function ($$v) {_vm.$set(_vm.formFour, "naturePiece", $$v)},expression:"formFour.naturePiece"}},_vm._l((_vm.listeNaturePiece),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Numéro de la pièce","prop":"numPiece"}},[_c('el-input',{attrs:{"placeholder":"Saisir"},model:{value:(_vm.formFour.numPiece),callback:function ($$v) {_vm.$set(_vm.formFour, "numPiece", $$v)},expression:"formFour.numPiece"}})],1)],1)]),_vm._v(" "),(_vm.typeFour == 1)?_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date de délivrance","prop":"dateDeliv"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"d-MM-yyyy","placeholder":"Selectionnez","type":"date"},model:{value:(_vm.formFour.dateDeliv),callback:function ($$v) {_vm.$set(_vm.formFour, "dateDeliv", $$v)},expression:"formFour.dateDeliv"}})],1)],1)]):_vm._e(),_vm._v(" "),(_vm.typeFour == 1)?_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Date d'expiration","prop":"dateExpir"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"d-MM-yyyy","placeholder":"Selectionnez","type":"date"},model:{value:(_vm.formFour.dateExpir),callback:function ($$v) {_vm.$set(_vm.formFour, "dateExpir", $$v)},expression:"formFour.dateExpir"}})],1)],1)]):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Domicile/Siège social","prop":"domicile"}},[_c('el-input',{attrs:{"placeholder":"Saisir"},model:{value:(_vm.formFour.domicile),callback:function ($$v) {_vm.$set(_vm.formFour, "domicile", $$v)},expression:"formFour.domicile"}})],1)],1)]),_vm._v(" "),(_vm.typeFour == 1)?_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Nationalité","prop":"nationalite"}},[_c('el-input',{attrs:{"placeholder":"Saisir"},model:{value:(_vm.formFour.nationalite),callback:function ($$v) {_vm.$set(_vm.formFour, "nationalite", $$v)},expression:"formFour.nationalite"}})],1)],1)]):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Profession","prop":"profession"}},[_c('el-input',{attrs:{"placeholder":"Saisir"},model:{value:(_vm.formFour.profession),callback:function ($$v) {_vm.$set(_vm.formFour, "profession", $$v)},expression:"formFour.profession"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Contact","prop":"contact"}},[_c('el-input',{attrs:{"placeholder":"Saisir"},model:{value:(_vm.formFour.contact),callback:function ($$v) {_vm.$set(_vm.formFour, "contact", $$v)},expression:"formFour.contact"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Service fournit","prop":"service"}},[_c('el-input',{attrs:{"placeholder":"Description","rows":6,"type":"textarea"},model:{value:(_vm.formFour.service),callback:function ($$v) {_vm.$set(_vm.formFour, "service", $$v)},expression:"formFour.service"}})],1)],1)])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","align-self-end":""}},[_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pr-1",attrs:{"xs12":"","sm6":"","md2":"","offset-md8":""}},[_c('v-btn',{attrs:{"block":"","color":"grey","dark":""},on:{"click":function($event){return _vm.closeForm()}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"green","dark":""},on:{"click":function($event){return _vm.saveForm()}},slot:"activator"},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}})],1),_vm._v("Enregistrer\n                                    ")],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GlT3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "LoadConducteurExcel",
    components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
    props: {
        listeConducteur: {
            type: Array,
            default: null
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),

            dialogAjoutConducteur: false,
            loading: false
        };
    },

    watch: {
        show: function show(newValue, oldValue) {
            if (newValue == true) {
                this.dialogAjoutConducteur = true;
            } else {
                this.dialogAjoutConducteur = false;
            }
        }
    },
    methods: {
        saveListe: function saveListe() {
            var _this = this;

            this.loading = true;
            var succesEnreg = true;
            var url = this.domaine + "parc/save/liste_conducteur/excel";
            var nbData = 1;
            if (this.listeConducteur.length > 10) {
                nbData = 10;
            }
            var nbReq = Math.round(this.listeConducteur.length / nbData);
            var nbRest = this.listeConducteur.length % nbData;
            if (nbRest > 0) {
                nbReq += 1;
            }
            for (var i = 0; i < nbReq; i++) {
                var initJ = i * nbData;
                var finJ = (i + 1) * nbData;
                var dataLot = [];
                if (this.listeConducteur.length > 0) {
                    for (var j = initJ; j < finJ; j++) {
                        if (this.listeConducteur[j] == undefined) {
                            break;
                        }
                        dataLot.push(this.listeConducteur[j]);
                    }
                }
                var data = new FormData();
                data.append('listeConducteur', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataLot));

                this.$http.post(url, data).then(function (resp) {}, function (error) {
                    _this.loading = false;
                    _this.$message.error("Erreur lors de l'enregistrement des conducteurs");
                    succesEnreg = false;
                });
            }
            this.loading = false;

            if (succesEnreg == true) {
                this.$notify({
                    title: "Enregistrement",
                    message: "La liste a ete enregistre avec succes",
                    type: "success",
                    position: "top-right",
                    duration: 7000
                });
                this.closeDialog();
            }
        },
        closeDialog: function closeDialog() {
            //this.dialogAjoutFournisseur = false;
            this.$emit("close");
        }
    }
});

/***/ }),

/***/ "Gr1M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_resourceHumaine_detail_employe__ = __webpack_require__("SHB3");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { detailEmploye: __WEBPACK_IMPORTED_MODULE_0__components_resourceHumaine_detail_employe__["a" /* default */] },
    name: "modalDetailEmploye",
    props: {
        userIdContrat: {
            type: Number
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            dialogModalDetailEmp: false
        };
    },

    methods: {
        closeDialog: function closeDialog() {
            this.$emit("close");
        }
    },
    watch: {
        show: function show(newValue, oldValue) {
            if (newValue == true) {
                this.dialogModalDetailEmp = true;
            } else {
                this.dialogModalDetailEmp = false;
            }
        }
    }
});

/***/ }),

/***/ "Gvx0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"width":"80%","persistent":true,"transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogAjoutBudget),callback:function ($$v) {_vm.dialogAjoutBudget=$$v},expression:"dialogAjoutBudget"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Planifier budget pour les travaux "+_vm._s(_vm.typeTrx.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formBudget",staticClass:"demo-form-inline",attrs:{"id":"formBudget","model":_vm.formBudget,"rules":_vm.rulesBudget,"label-position":_vm.labelPosition}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"libelle","label":"Liste ","required":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","allow-create":"","default-first-option":"","placeholder":"Selectionnez une tache de la liste"},model:{value:(_vm.formBudget.libelle),callback:function ($$v) {_vm.$set(_vm.formBudget, "libelle", $$v)},expression:"formBudget.libelle"}},_vm._l((_vm.listeProduitBudget),function(group){return _c('el-option-group',{key:group.label,attrs:{"label":group.label}},_vm._l((group.produits),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.label,"value":item.value}})}),1)}),1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"dateMoisAn","label":"Mois annee","required":""}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"MMMM-yyyy","value-format":"yyyy-MM","type":"month","id":"dateMoisAn","placeholder":"Sélectionnez un mois"},model:{value:(_vm.formBudget.dateMoisAn),callback:function ($$v) {_vm.$set(_vm.formBudget, "dateMoisAn", $$v)},expression:"formBudget.dateMoisAn"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"libelle","label":"Liste ","required":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","allow-create":"","default-first-option":"","placeholder":"Selectionnez un élement de la liste"},model:{value:(_vm.formBudget.libelle),callback:function ($$v) {_vm.$set(_vm.formBudget, "libelle", $$v)},expression:"formBudget.libelle"}},_vm._l((_vm.listeProduitBudget),function(group){return _c('el-option-group',{key:group.label,attrs:{"label":group.label}},_vm._l((group.produits),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.label,"value":item.value}})}),1)}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"montant","label":"Montant ","required":""}},[_c('el-input-number',{attrs:{"controls-position":"right","min":0},model:{value:(_vm.formBudget.montant),callback:function ($$v) {_vm.$set(_vm.formBudget, "montant", $$v)},expression:"formBudget.montant"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"action"}},[_c('el-button',{attrs:{"type":"primary","disabled":!_vm.verifFormBudget},on:{"click":function($event){return _vm.addListBudget(_vm.formBudget)}}},[_vm._v("Ajouter")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableBudget}},[_c('el-table-column',{attrs:{"prop":"dateMoisAn","label":"Annee mois"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libelle","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant proposé"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                "+_vm._s(new Intl.NumberFormat().format(scope.row.montant))+"\n                                            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableBudget)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                                    Supprimer\n                                                ")],1)]}}])})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.createBudget()}}},[_vm._v("Enregistrer")])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H7ti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_carteCarburant_CarteCarburant_index__ = __webpack_require__("bcvN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "menuDrawer",
    components: { CarteCarburantIndex: __WEBPACK_IMPORTED_MODULE_0__components_carteCarburant_CarteCarburant_index__["a" /* default */] },
    props: {
        drawer: {
            type: Boolean,
            default: null
        }
    },
    data: function data() {
        return {
            items: [{
                title: "Logistique",
                icon: "directions_bus",
                sousMenus: [{
                    title: "Carte Carburant",
                    icon: "credit_card",
                    action: "carteCarburant"
                }]
            }],
            showDrawer: null,
            showDialogCarburant: false
        };
    },

    watch: {
        drawer: function drawer(newValue, oldValue) {
            this.showDrawer = newValue;
        }
    },
    computed: {
        showDraw: {
            get: function get() {
                return this.showDrawer;
            },
            set: function set(newValue) {
                if (newValue == false) {
                    this.$emit("close");
                }
            }
        }
    },
    methods: {
        switchFonction: function switchFonction(fonction) {
            switch (fonction) {
                case "carteCarburant":
                    this.carteCarburant();
                    break;
            }
        },
        carteCarburant: function carteCarburant() {
            this.showDialogCarburant = true;
        }
    }
});

/***/ }),

/***/ "HIBi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HTxj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//liste l'ensemble  des besoins  ou les besoinsa valider par un responsable

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "VehiculeBesoin",
  props: {
    show: {
      type: Boolean
    },
    listeBesoinsVeh: {
      type: Array
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false
    };
  }
});

/***/ }),

/***/ "HVE6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Flotte_vue__ = __webpack_require__("DhyM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_465dc6da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Flotte_vue__ = __webpack_require__("9BWT");
function injectStyle (ssrContext) {
  __webpack_require__("RE2M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-465dc6da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Flotte_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_465dc6da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Flotte_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HZcb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: "MatriceContract",
  props: {
    show: {
      type: Boolean
    },
    idProjet: {
      type: Number
    }

  },
  data: function data() {
    var _ref;

    return _ref = {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
      droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),

      formDoc: {
        ordre: "",
        libelle: "",
        categorie: 0,
        numDoc: "",
        version: "",
        mode: 0,
        commentaire: "",
        file: null,
        urlImage: "/static/doc.png"
      },
      editForm: false,
      dialogShowVersion: false,
      dialogSupr: false,
      listeDoc: [],
      dialogDoc: false,
      status: [{
        text: "EN ATTENTE",
        value: 0
      }, {
        text: "ACO",
        value: 1
      }, {
        text: "AC1",
        value: 2
      }, {
        text: "BPE",
        value: 3
      }],
      rulesFormDoc: {

        ordre: [{ required: true, message: 'Veuillez saisir' }],
        libelle: [{ required: true, message: 'Veuillez saisir' }],
        categorie: [{ required: true, message: 'Veuillez selectionner' }],
        numDoc: [{ required: true, message: 'Veuillez saisir' }],
        version: [{ required: true, message: 'Veuillez saisir', trigger: 'change' }],
        mode: [{ required: true, message: 'Veuillez selectionner', trigger: 'blur' }],
        status: [{ required: true, message: 'Veuillez selectionner', trigger: 'blur' }]

      },

      mode: [{
        text: "Courrier",
        value: 0
      }, {
        text: "Mail",
        value: 1
      }],
      rulesFormVersion: {

        identifiant: [{ required: true, message: 'Veuillez saisir' }],
        mode: [{ required: true, message: 'Veuillez selectionner', trigger: 'blur' }]
      }

    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "mode", [{
      text: "Courrier",
      value: 0
    }, {
      text: "Mail",
      value: 1
    }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "categories", [{
      text: "Autorisation",
      value: 0
    }, {
      text: "Environnement sociale",
      value: 1
    }, {
      text: "ETUDE",
      value: 2
    }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "versionCourante", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectCategorieMatrice", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectStatusMatrice", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectSaverMatrice", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectModeMatrice", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "logoMatrice", '/static/img-doc.png'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "docSelect", {
      numDoc: ""
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dialogVersion", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "formVersion", {
      libelle: "",
      commentaire: "",
      file: null,
      urlImage: "/static/doc.png"
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "newVersion", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "versionSelect", {
      libelle: ""
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dialogSuprVers", false), _ref;
  },


  watch: {
    show: function show(newValue, oldvalue) {
      if (newValue == true) {
        this.loadDoc();
        this.onglet = "0";
        // this.loadReserves();
        // this.loadBesoinAvalider()
        // this.loadRapportProjet();
      }
    }
  },

  methods: {
    showDialogVersionDetail: function showDialogVersionDetail(item) {
      this.dialogShowVersion = true;
      this.versionCourante = item;
    },
    showDialogSuppVersion: function showDialogSuppVersion(item) {
      this.versionSelect = item;
      this.dialogSuprVers = true;
    },
    showDilogSupp: function showDilogSupp(item) {
      this.docSelect = item;
      this.dialogSupr = true;
    },
    loadDoc: function loadDoc() {
      var _this = this;

      this.loading = true;
      this.docSelect = null;
      var url = this.domaine + "matrice/projet/" + this.idProjet;
      this.$http.get(url).then(function (response) {

        _this.loading = false;
        _this.listeDoc = response.body.listeDoc;
      }, function (response) {
        _this.loading = false;
      });
    },
    showAjoutDoc: function showAjoutDoc() {
      this.editForm = false;
      this.resetForm();
      this.dialogDoc = true;
      this.logoMatrice = '/static/img-doc.png';
    },
    imprimeMatricePDF: function imprimeMatricePDF() {
      var tab = [];
      var userid = this.user.id;
      this.listeDoc.forEach(function (element) {
        tab.push(element.idDoc);
      });
      var url = this.domaine + 'matrice/imprimer_matrice_pdf/' + userid + '/liste/' + tab;
      window.open(url);
    },
    showDialogVersionEdit: function showDialogVersionEdit(item) {
      this.dialogVersion = true;
      this.newVersion = false;
      this.versionSelect = item;
      this.formVersion = item;
      //  this.formVersion.libelle = item.libelle
      //  this.formVersion.mode = item.modeS
      this.formVersion.urlImage = item.urlImage;
      //  this.formVersion.description = item.commentaire
      //this.formVersion.status =  item.status
      // this.formVersion.reserve = item.reserve
    },
    showAddVersion: function showAddVersion(item) {
      this.newVersion = true;

      if (item.attente == true) {
        this.$message.error("Veuillez modifier l'etat de la derniere version du document");
        return;
      }
      this.docSelect = item;

      this.resetFormVersion();

      this.dialogVersion = true;
    },
    addVersion: function addVersion(formName) {
      var _this2 = this;

      //this.editForm =  false
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          var form = document.getElementById("formVersion");
          var data = new FormData(form);
          var url = _this2.domaine + 'matrice/new/version/' + _this2.docSelect.idDoc;
          data.append("mode", _this2.formDoc.mode);
          //data.append("status",this.formDoc.status)
          data.append("userId", _this2.user.id);

          _this2.$http.post(url, data).then(function (resp) {
            _this2.loading = false;
            _this2.resetFormVersion();
            _this2.dialogVersion = false;
            _this2.loadDoc();
            _this2.successNotif(resp.body.message);
          }, function (error) {
            _this2.loading = false;
            //this.resetForm('formDoc');
            _this2.$message.error("Une erreur est survenue lors de l'enregistrement du document");
          });
        }
      });
    },
    addDoc: function addDoc(formName) {
      var _this3 = this;

      this.editForm = false;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          var form = document.getElementById("formDoc");
          var data = new FormData(form);
          var url = _this3.domaine + 'matrice/create';
          data.append("categorie", _this3.formDoc.categorie);
          data.append("mode", _this3.formDoc.mode);
          data.append("dateSend", _this3.formDoc.dateSend);
          //data.append("status",this.formDoc.status)
          data.append("userId", _this3.user.id);
          data.append("projetId", _this3.idProjet);

          _this3.$http.post(url, data).then(function (resp) {
            var verif = resp.body;
            if (verif.code === 0) {
              _this3.loading = false;
              _this3.resetForm();
              _this3.dialogDoc = false;
              _this3.loadDoc();
              _this3.successNotif(verif.message);
            } else {
              _this3.loading = false;
              _this3.$message.error("Le numero d'ordre de ce documment existe deja");
            }
          }, function (error) {
            _this3.loading = false;
            //this.resetForm('formDoc');
            _this3.$message.error("Une erreur est survenue lors de l'enregistrement du document");
          });
        }
      });
    },
    showEditDoc: function showEditDoc(item) {

      //this.resetForm();

      this.formDoc = item;
      this.formDoc.dateSend = item.versions[0].dateSend;

      this.docSelect = item;
      this.editForm = true;

      this.logoMatrice = item.versions[0].urlImage;
      // this.formDoc.libelle = this.docSelect.libelle
      // this.formDoc.ordre = this.docSelect.ordre
      // //this.formDoc.categorie = this.docSelect.etatCategorie
      // this.formDoc.numDoc =  this.docSelect.numDoc
      // this.formDoc.version = this.docSelect.version
      // //this.formDoc.mode = this.docSelect.etatMode
      // //this.formDoc.status =  this.docSelect.etatStatus
      // this.formDoc.commentaire =  this.docSelect.commentaire
      // this.formDoc.file = null;


      this.dialogDoc = true;
    },
    editDoc: function editDoc(formName) {
      var _this4 = this;

      this.editForm = true;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.loading = true;
          var form = document.getElementById("formDoc");
          var data = new FormData(form);
          var url = _this4.domaine + 'matrice/edit/' + _this4.docSelect.idDoc;
          data.append("categorie", _this4.formDoc.categorie);
          data.append("mode", _this4.formDoc.mode);
          data.append("status", _this4.formDoc.status);
          //data.append("userId",this.user.id)
          //data.append("projetId",this.idProjet)

          _this4.$http.post(url, data).then(function (resp) {
            _this4.loading = false;
            _this4.resetForm();
            _this4.dialogDoc = false;
            _this4.loadDoc();
            _this4.successNotif(resp.body.message);
          }, function (error) {
            _this4.loading = false;
            //this.resetForm('formDoc');
            _this4.$message.error("Une erreur est survenue lors de la modification du document");
          });
        }
      });
    },
    editVersion: function editVersion() {
      var _this5 = this;

      this.loading = true;
      var form = document.getElementById("formVersion");
      var data = new FormData(form);
      var url = this.domaine + 'matrice/edit/version/' + this.versionSelect.id;
      data.append("status", this.formVersion.status);
      data.append("userId", this.user.id);
      data.append("dateSend", this.formVersion.dateSend);
      //data.append("projetId",this.idProjet)

      this.$http.post(url, data).then(function (resp) {
        _this5.loading = false;
        _this5.resetForm();
        _this5.dialogVersion = false;
        _this5.loadDoc();
        _this5.successNotif(resp.body.message);
      }, function (error) {
        _this5.loading = false;
        _this5.resetForm('formDoc');
        _this5.$message.error("Une erreur est survenue lors de la modification de la version");
      });
    },
    deleteDoc: function deleteDoc() {
      var _this6 = this;

      this.loading = true;
      var url = this.domaine + "matrice/delete/" + this.docSelect.idDoc;
      this.$http.get(url).then(function (response) {
        _this6.loading = false;
        _this6.loadDoc();

        _this6.$notify({
          title: "SUPPRESSION",
          message: "Document supprimé avec succès.",
          type: "success",
          position: "top-center"
        });
        _this6.dialogSupr = false;
      }, function (errRep) {
        _this6.loading = false;
        _this6.dialogSupr = false;
        _this6.$notify.error({
          title: "SUPPRESSION ECHOUEE",
          message: "La suppression du document a échouée.",
          position: "top-center"
        });
      });
    },
    deleteVersion: function deleteVersion() {
      var _this7 = this;

      this.loading = true;
      var url = this.domaine + "matrice/delete/version/" + this.versionSelect.id;
      this.$http.get(url).then(function (response) {
        _this7.loading = false;
        _this7.loadDoc();

        _this7.$notify({
          title: "SUPPRESSION",
          message: "Document supprimé avec succès.",
          type: "success",
          position: "top-center"
        });
        _this7.dialogSuprVers = false;
      }, function (errRep) {
        _this7.loading = false;
        _this7.dialogSupr = false;
        _this7.$notify.error({
          title: "SUPPRESSION ECHOUEE",
          message: "La suppression du document a échouée.",
          position: "top-center"
        });
      });
    },
    successNotif: function successNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Document enregistré avec succès";
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";

      this.$notify({
        title: 'ENREGISTREMENT DOCUMENT',
        message: mess,
        type: type,
        position: 'top-center',
        duration: 10000
      });
    },
    resetForm: function resetForm() {
      this.formDoc = [];
      this.file = null;
      //  this.$refs["formDoc"].resetFields();
      this.formDoc.urlImage = "/static/doc.png";
      this.formDoc.file = null;
      //this.formDoc= {}
    },
    resetFormVersion: function resetFormVersion() {
      this.$refs['formVersion'].resetFields();
      this.formVersion.libelle = "";
      this.formVersion.commentaire = "";
      this.formVersion.urlImage = "/static/doc.png";
      this.formVersion.file = null;
    },

    //enregistrement des images
    onFileImageLogoPicked: function onFileImageLogoPicked(event) {
      var _this8 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this8.logoMatrice = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoMatrice = files[0];
    },
    onFileImageMatrice: function onFileImageMatrice(event) {
      var _this9 = this;

      var files = event.target.files;
      var filename = files[0].name;
      var extension = files[0].type;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 10485760) {
        this.$message.error("La taille du fichier est supérieur à 10M");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this9.formDoc.urlImage = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);

      this.formDoc.urlImage = files[0];
    },
    onFileImagePickedVersion: function onFileImagePickedVersion(event) {
      var _this10 = this;

      //  this.formVersion.urlImage = "";
      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 10485760) {
        this.$message.error("La taille du fichier est supérieur à 10M");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this10.formVersion.urlImage = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);

      this.formVersion.file = files[0];
    }
  },

  computed: {
    verifEditVersion: function verifEditVersion() {
      if (this.formVersion.status != null && this.formVersion.reserve != null) {
        return true;
      } else {
        return false;
      }
    }
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ "HaGr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListePresence_vue__ = __webpack_require__("ZNpQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29269fc6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListePresence_vue__ = __webpack_require__("m+tu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListePresence_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29269fc6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListePresence_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HabK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'google-map',
    props: ['name', "listMarqueur"],
    data: function data() {
        return {
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            mapName: this.name + "-map",
            markers: [],
            dialogPlan: false
        };
    },
    methods: {
        geolocate: function geolocate(map) {
            var _this = this;

            this.listMarqueur.forEach(function (projet) {
                var marker = {
                    lat: projet.lat,
                    lng: projet.lng,
                    image: projet.urlImage,

                    lib: "<img src=" + projet.urlImage + " height=180px  width=290px  /><br/>" + "<b  style='font-weight: bold'>Adresse: </b>" + projet.adresse + " <br/><b style='font-weight: bold'>Projet: </b>" + projet.libelle + " <br/><b style='font-weight: bold'>Prix du marché: </b><b style='font-weight: bold; color:blue'>" + projet.mntMarche + " FCFA</b><br/><b style='font-weight: bold'>Montant total dépensé: </b><b style='font-weight: bold; color:blue'>" + projet.montantTotalDepenseNbr + " FCFA</b><br/><b style='font-weight: bold'> Etat d'avancement : </b> <progress id='file' max='100' value=" + projet.evolutionNbr + ">" + projet.evolutionNbr + "%</progress><b style='font-weight: bold; color:blue'>" + projet.evolutionNbr + " %</b><br/><b style='font-weight: bold'>Date début: </b>" + projet.dateD + " <br/><b style='font-weight: bold'> Date de fin: </b>" + projet.dateF + "<br/> <b style='font-weight: bold'>Lat/Lng: </b>" + projet.lat + "/" + projet.lng,
                    couleurMk: projet.couleurMarker
                };
                _this.markers.push(marker);
            });

            //Ajout des markers
            this.markers.forEach(function (coord) {
                var position = new google.maps.LatLng(coord.lat, coord.lng);
                var libelle = coord.lib;
                var marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    //   icon: 'http://www.devnotebook.fr/sites/default/files/styles/media_crop/public/2017-05/marqueur_maison.png'
                    icon: {
                        path: 'M256,0C153.755,0,70.573,83.182,70.573,185.426c0,126.888,165.939,313.167,173.004,321.035    c6.636,7.391,18.222,7.378,24.846,0c7.065-7.868,173.004-194.147,173.004-321.035C441.425,83.182,358.244,0,256,0z M256,278.719    c-51.442,0-93.292-41.851-93.292-93.293S204.559,92.134,256,92.134s93.291,41.851,93.291,93.293S307.441,278.719,256,278.719z',
                        fillColor: coord.couleurMk,
                        fillOpacity: 0.5,
                        scale: 0.04,
                        strokeColor: coord.couleurMk,
                        strokeWeight: 1
                    }
                });
                _this.attachSecretMessage(marker, libelle);
            });
            //chargement des marqueurs des projets
            //this.loading = true
            // let url = this.domaine + 'chantier/index'
            // this.$http.get(url).then(response => {
            //     this.loading = false
            //     this.items = response.body.chantier

            // for (var i = 0; i < this.items.length; i++) {
            //     const marker = {
            //         lat: this.items[i].lat,
            //         lng: this.items[i].lng,
            //         lib: " <b style='font-weight: bold'>Adresse: </b>" +this.items[i].adresse +" <br/>   <b style='font-weight: bold'>Projet: </b>" +this.items[i].libelle +" <br/> <b style='font-weight: bold'>Date début: </b>" + this.items[i].dateD+" <br/><b style='font-weight: bold'> Date de fin: </b>" + this.items[i].dateF +" <br/><b style='font-weight: bold'> Etat d'avancement : </b> <b style='font-weight: bold; color:blue'>" + this.items[i].evolutionNbr+ " %</b> <br/> <b style='font-weight: bold'>Lat/Lng: </b>" +this.items[i].latitude+"/"+this.items[i].longitude ,
            //         couleurMk: this.items[i].couleurMarker,
            //     }
            //     this.markers.push(marker);
            // }

            // //Ajout des markers
            // this.markers.forEach((coord) => {
            //     const position = new google.maps.LatLng(coord.lat, coord.lng);
            //     const libelle = coord.lib
            //     const marker = new google.maps.Marker({
            //         position,
            //         map,
            //         icon:{
            //             path: 'M256,0C153.755,0,70.573,83.182,70.573,185.426c0,126.888,165.939,313.167,173.004,321.035    c6.636,7.391,18.222,7.378,24.846,0c7.065-7.868,173.004-194.147,173.004-321.035C441.425,83.182,358.244,0,256,0z M256,278.719    c-51.442,0-93.292-41.851-93.292-93.293S204.559,92.134,256,92.134s93.291,41.851,93.291,93.293S307.441,278.719,256,278.719z',
            //             fillColor: coord.couleurMk,
            //             fillOpacity: 0.5,
            //             scale: 0.04,
            //             strokeColor: coord.couleurMk,
            //             strokeWeight: 1
            //         }
            //     });
            //     this.attachSecretMessage(marker, libelle);
            // });

            // }, (response)=>{
            //     this.loading = false
            //     this.$message.error('erreur lors du chargement des coordonnees des projets');
            // })
        },
        attachSecretMessage: function attachSecretMessage(marker, secretMessage) {
            var infowindow = new google.maps.InfoWindow({
                content: secretMessage
            });

            marker.addListener('click', function () {
                infowindow.open(marker.get('map'), marker);
            });
        },
        mount: function mount() {
            var element = document.getElementById(this.mapName);
            var options = {
                zoom: 7.0,
                center: new google.maps.LatLng(6.982418, -5.327522),
                gestureHandling: 'greedy'
            };

            var newStyle = [{
                "featureType": "all",
                "elementType": "all",
                "stylers": [{
                    "invert_lightness": true
                }, {
                    "saturation": "-9"
                }, {
                    "lightness": "0"
                }, {
                    "visibility": "simplified"
                }]
            }, {
                "featureType": "landscape.man_made",
                "elementType": "all",
                "stylers": [{
                    "weight": "1.00"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [{
                    "weight": "0.49"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "on"
                }, {
                    "weight": "0.01"
                }, {
                    "lightness": "-7"
                }, {
                    "saturation": "-35"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "labels.text",
                "stylers": [{
                    "visibility": "on"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "labels.text.stroke",
                "stylers": [{
                    "visibility": "off"
                }]
            }, {
                "featureType": "road.highway",
                "elementType": "labels.icon",
                "stylers": [{
                    "visibility": "on"
                }]
            }];

            var styles = {
                'monTheme': [{
                    featureType: 'road',
                    stylers: [{ visibility: 'off' }]
                }, {
                    featureType: 'road.arterial',
                    stylers: [{ visibility: 'off' }]
                }, {
                    featureType: 'road.local',
                    stylers: [{ visibility: 'off' }]
                }, {
                    featureType: 'landscape',
                    stylers: [{ visibility: 'off' }]
                }, {
                    featureType: 'water',
                    stylers: [{ visibility: 'on' }, { lightness: -100 }]
                }]
            };

            var map = new google.maps.Map(element, options);

            map.setOptions({ 'styles': newStyle });
            // var styledMapType = new google.maps.StyledMapType(styles['monTheme'], {name: 'monTheme'});
            // map.setOptions(styles['monTheme'], {name: 'monTheme'});


            var iconBase = 'static/legend/';
            var iconBase_ = "http://www.devnotebook.fr/sites/default/files/styles/media_crop/public/2017-05/marqueur_maison.png";

            var icons = {
                Livre: {
                    name: 'Projet',
                    icon: iconBase + 'mkv.png'
                },
                travaux: {
                    name: 'En travaux',
                    icon: iconBase + 'mko.png'
                },
                Arrete: {
                    name: 'Arret des travaux',
                    icon: iconBase + 'mkr.png'
                }
            };

            var legend = document.getElementById('legend');

            for (var key in icons) {
                var type = icons[key];
                var name = type.name;
                var icon = type.icon;
                var div = document.createElement('div');
                div.innerHTML = '<img src="' + icon + '"> ' + name;
                if (legend != null) {
                    legend.appendChild(div);
                }
            }
            map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(legend);

            this.geolocate(map);

            var card = document.getElementById('pac-card');
            var input = document.getElementById('pac-input');
            var types = document.getElementById('type-selector');
            var strictBounds = document.getElementById('strict-bounds-selector');

            map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);
            var autocomplete = new google.maps.places.Autocomplete(input);
            // Bind the map's bounds (viewport) property to the autocomplete object,
            // so that the autocomplete requests use the current map bounds for the
            // bounds option in the request.
            autocomplete.bindTo('bounds', map);

            // Set the data fields to return when the user selects a place.
            autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);

            var infowindow = new google.maps.InfoWindow();
            var infowindowContent = document.getElementById('infowindow-content');
            infowindow.setContent(infowindowContent);
            var marker = new google.maps.Marker({
                map: map,
                anchorPoint: new google.maps.Point(0, -29)
            });

            autocomplete.addListener('place_changed', function () {
                infowindow.close();

                marker.setVisible(false);
                var place = autocomplete.getPlace();

                if (!place.geometry) {
                    // User entered the name of a Place that was not suggested and
                    // pressed the Enter key, or the Place Details request failed.
                    window.alert("No details available for input: '" + place.name + "'");
                    return;
                }

                // If the place has a geometry, then present it on a map.
                if (place.geometry.viewport) {
                    map.fitBounds(place.geometry.viewport);
                } else {
                    map.setCenter(place.geometry.location);
                    map.setZoom(17); // Why 17? Because it looks good.
                }

                marker.setPosition(place.geometry.location);
                marker.setVisible(true);

                var address = '';
                if (place.address_components) {
                    address = [place.address_components[0] && place.address_components[0].short_name || '', place.address_components[1] && place.address_components[1].short_name || '', place.address_components[2] && place.address_components[2].short_name || ''].join(' ');
                }

                infowindowContent.children['place-icon'].src = place.icon;
                infowindowContent.children['place-name'].textContent = place.name;

                infowindowContent.children['place-address'].textContent = address + " (Latitude: " + place.geometry.location.lat() + " Longitude:" + place.geometry.location.lng() + " )";
                infowindow.open(map, marker);
            });

            // Sets a listener on a radio button to change the filter type on Places
            // Autocomplete.
            function setupClickListener(id, types) {
                var radioButton = document.getElementById(id);
                radioButton.addEventListener('click', function () {
                    autocomplete.setTypes(types);
                });
            }

            if (legend != null) {

                setupClickListener('changetype-all', []);
                setupClickListener('changetype-address', ['address']);
                setupClickListener('changetype-establishment', ['establishment']);
                setupClickListener('changetype-geocode', ['geocode']);
            }
            if (document.getElementById('use-strict-bounds') != null) {
                document.getElementById('use-strict-bounds').addEventListener('click', function () {
                    autocomplete.setOptions({ strictBounds: this.checked });
                });
            }
        }
    },
    watch: {
        listMarqueur: function listMarqueur() {
            this.mount();
        }
    },

    mounted: function mounted() {
        //this.mount();

    }
});

/***/ }),

/***/ "Hogj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationDex_vue__ = __webpack_require__("ABW1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6173b774_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationDex_vue__ = __webpack_require__("nbCe");
function injectStyle (ssrContext) {
  __webpack_require__("vswG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6173b774"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationDex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6173b774_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationDex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HpCd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "ModalValidationMiss",
  props: ["show", "detailMission"],
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
      loading: false,
      dialogDetail: false,
      dialogVisible: false,
      dialogConfirmRefus: false,
      dialogConfirm: false,
      formRefus: {},
      ruleFormRefus: {
        rapportRefus: [{ required: true, message: 'Veuillez saisir' }]
      }
    };
  },


  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogDetail = newValue;
      if (newValue == true) {
        //this.loadDevisConstat()
      }
    }
  },

  methods: {
    successNotif: function successNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      this.$notify({
        title: 'ENREGISTREMENT REUSSI',
        message: mess,
        type: 'success',
        position: 'top-center'
      });
    },
    SubmitValideBudget: function SubmitValideBudget() {},
    closeDialog: function closeDialog() {
      this.$emit('close', this.detailMission.IdUtil, "mission");
    },
    SubmitValideDevis: function SubmitValideDevis() {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "mission/valide/mission";
      var data = new FormData();
      data.append("idMission", this.detailMission.IdUtil);
      data.append("etatValMiss", this.detailMission.etat);
      data.append("idVeh", this.detailMission.idVeh);
      data.append("user", this.user.id);

      this.$http.post(url, data).then(function (response) {
        _this.loading = false;
        _this.successNotif(response.body.message);
        _this.dialogConfirm = false;
        _this.closeDialog();
      }, function (errResp) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors de la validation de la mission");
      });
    },
    SubmitRefusDevis: function SubmitRefusDevis() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "mission/rejeter";
      var data = new FormData();
      data.append("motifRefus", this.formRefus.rapport);
      data.append("idMission", this.detailMission.IdUtil);
      data.append("user", this.user.id);

      this.$http.post(url, data).then(function (response) {
        _this2.loading = false;
        _this2.successNotif(response.body.message);
        _this2.dialogConfirmRefus = false;
        _this2.closeDialog();
      }, function (errResp) {
        _this2.loading = false;
        _this2.$message.error("Une erreur est survenue lors du refus de la demande de mission");
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "HrBg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_resourceHumaine_detail_employe__ = __webpack_require__("SHB3");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { detailEmploye: __WEBPACK_IMPORTED_MODULE_0__components_resourceHumaine_detail_employe__["a" /* default */] },
    name: "boardEmploye",
    data: function data() {
        return {
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            loading: false,

            showEmp: false,
            idUser: null

        };
    },
    mounted: function mounted() {
        this.showEmp = true;
        this.idUser = this.user.id;
    }
});

/***/ }),

/***/ "Hx5p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I1Kh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
    name: "modelCarteEmploye",
    props: {
        employe: {
            type: Object
        }
    },
    data: function data() {
        return {
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false

        };
    },

    methods: {
        showDetailEmpl: function showDetailEmpl(idEmp) {
            this.$emit("detailEmpl", idEmp);
            this.$emit("close");
        },
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        }
    }
});

/***/ }),

/***/ "I9Qq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IFhl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTE DES OUVRIERS (Chantier)")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{attrs:{"color":"cyan","text-color":"white"}},[_c('v-avatar',{staticClass:"cyan darken-4"},[_vm._v(_vm._s(_vm.nbContratOuvriers))]),_vm._v("Contrat(s) ouvrier\n            ")],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1",attrs:{"xs12":"","md3":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"primary darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total : ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("  "+_vm._s(new Intl.NumberFormat().format(_vm.mntTotalOuv))+"\n              ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1",attrs:{"xs12":"","md3":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total payé: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("  "+_vm._s(new Intl.NumberFormat().format(_vm.mntTotalVerseOuv))+"\n              ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1",attrs:{"xs10":"","md3":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total restant: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" \n                "+_vm._s(new Intl.NumberFormat().format(_vm.mntTotalRestantOuv))+"\n              ")])])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":"","mt-2":""}},[_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"mt-3":"","ml-1":"","mr-1":"","data":_vm.listeOuvriers}},[_c('el-table-column',{attrs:{"prop":"nom","label":"NOM","align":"center","width":"230","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nbContrats","label":"Nb CONTRAT(S)","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"info"}},[_vm._v("\n                  "+_vm._s(scope.row.nbContrats)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotal","label":"MONTANT TOTAL","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("\n                  "+_vm._s(new Intl.NumberFormat().format(scope.row.mntTotal))+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotalVerse","label":"MONTANT PAYE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"success"}},[_vm._v("\n                  "+_vm._s(new Intl.NumberFormat().format(scope.row.mntTotalVerse))+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotalRestant","label":"MONTANT RESTANT","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"warning"}},[_vm._v("\n                  "+_vm._s(new Intl.NumberFormat().format(scope.row.mntTotalRestant))+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalListeContrat(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                  Détails...\n                ")],1)]}}])})],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"mt-2"},[_vm._v("LISTE DES PRESTATAIRES (Chantier)")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{attrs:{"color":"cyan","text-color":"white"}},[_c('v-avatar',{staticClass:"cyan darken-4"},[_vm._v(_vm._s(_vm.nbContratPrest))]),_vm._v("Contrat(s) prestataire\n            ")],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1",attrs:{"xs12":"","md3":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"primary darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total : ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("  "+_vm._s(new Intl.NumberFormat().format(_vm.mntTotalPrest))+"\n              ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1",attrs:{"xs12":"","md3":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total payé: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" \n                "+_vm._s(new Intl.NumberFormat().format(_vm.mntTotalVersePrest))+"\n              ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1",attrs:{"xs10":"","md3":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total restant: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" \n                "+_vm._s(new Intl.NumberFormat().format(_vm.mntTotalRestantPrest))+"\n              ")])])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":"","mt-2":""}},[_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"mt-3":"","ml-1":"","mr-1":"","data":_vm.listePrestataires}},[_c('el-table-column',{attrs:{"prop":"nom","label":"NOM","align":"center","width":"230","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nbContrats","label":"Nb CONTRAT(S)","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotal","label":"MONTANT TOTAL","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(new Intl.NumberFormat().format(scope.row.mntTotal))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotalVerse","label":"MONTANT PAYE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(new Intl.NumberFormat().format(scope.row.mntTotalVerse))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotalRestant","label":"MONTANT RESTANT","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(new Intl.NumberFormat().format(scope.row.mntTotalRestant))+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalListeContrat(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                  Détails...\n                ")],1)]}}])})],1)],1)],1)],1)],1),_vm._v(" "),_c('ContratOuvrier',{attrs:{"idChant":_vm.idChantier,"show":_vm.showListeContrat,"type":_vm.typePrestataire,"idPrestataire":_vm.idPrest},on:{"close":function($event){_vm.showListeContrat = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IOgm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","scrollable":"","loading":_vm.loading,"max-width":"100%","persistent":""},model:{value:(_vm.dialogRapport),callback:function ($$v) {_vm.dialogRapport=$$v},expression:"dialogRapport"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("AJOUTER UN RAPPORT JOURNALIER DE CHANTIER TRAVAUX: "+_vm._s(_vm.detailTrx.libelle)+"  ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-stepper',{model:{value:(_vm.d1),callback:function ($$v) {_vm.d1=$$v},expression:"d1"}},[_c('v-stepper-header',{staticStyle:{"flex-wrap":"inherit","overflow":"visible"}},[_c('v-stepper-step',{attrs:{"complete":_vm.d1 > 1,"step":"1"}},[_vm._v("Date & Conditions Atmosphériques")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.d1 > 2,"step":"2"}},[_vm._v("Visite Chantier")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.d1 > 3,"step":"3"}},[_vm._v("Incidents")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.d1 > 4,"step":"4"}},[_vm._v("Matériaux utilisés")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.d1 > 5,"step":"5"}},[_vm._v("Ressources Externes (non prévu)")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.d1 > 6,"step":"6"}},[_vm._v("Personnels")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.d1 > 7,"step":"7"}},[_vm._v("Matériel(s) / Engin(s) affecté(s)")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.d1 > 8,"step":"8"}},[_vm._v("Travaux Réalisés")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',[_c('el-form',{ref:"formInfo",staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formInfo}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date du rapport","required":""}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"picker-options":_vm.datePickerRtp,"format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"date","id":"dateRapport","placeholder":"Date du rapport"},model:{value:(_vm.formInfo.dateRapport),callback:function ($$v) {_vm.$set(_vm.formInfo, "dateRapport", $$v)},expression:"formInfo.dateRapport"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Température"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":0,"size":"large","controls-position":"right","placeholder":"Température"},model:{value:(_vm.formInfo.temp),callback:function ($$v) {_vm.$set(_vm.formInfo, "temp", $$v)},expression:"formInfo.temp"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Précipitation(mm2)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":0,"size":"large","controls-position":"right","placeholder":"Précipitation"},model:{value:(_vm.formInfo.pluie),callback:function ($$v) {_vm.$set(_vm.formInfo, "pluie", $$v)},expression:"formInfo.pluie"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Vent(km/h)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":0,"size":"large","controls-position":"right","placeholder":"Vitesse du vent"},model:{value:(_vm.formInfo.vent),callback:function ($$v) {_vm.$set(_vm.formInfo, "vent", $$v)},expression:"formInfo.vent"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Nombre d'heure de travail","required":""}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":0,"size":"large","controls-position":"right","placeholder":"Nombre d'heure de travail"},model:{value:(_vm.formInfo.heurTravail),callback:function ($$v) {_vm.$set(_vm.formInfo, "heurTravail", $$v)},expression:"formInfo.heurTravail"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Tronçon","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Tronçon"},model:{value:(_vm.formInfo.trancon),callback:function ($$v) {_vm.$set(_vm.formInfo, "trancon", $$v)},expression:"formInfo.trancon"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Du profil","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Du profil"},model:{value:(_vm.formInfo.profil),callback:function ($$v) {_vm.$set(_vm.formInfo, "profil", $$v)},expression:"formInfo.profil"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Au profil","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Du profil"},model:{value:(_vm.formInfo.auProfil),callback:function ($$v) {_vm.$set(_vm.formInfo, "auProfil", $$v)},expression:"formInfo.auProfil"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"grey","dark":""},on:{"click":function($event){_vm.dialogRapport = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.verifFormInfo()},nativeOn:{"click":function($event){return _vm.loadPresenceOuvrier()}}},[_vm._v("Continuer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"primary","icon":"info"}},[_vm._v("\n                                                Ajouter des personnes ayant visitées le chantier\n                                            ")])],1),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formVisiteur}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md2":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Nom","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Nom"},on:{"change":_vm.handleChangeCont},model:{value:(_vm.formVisiteur.nom),callback:function ($$v) {_vm.$set(_vm.formVisiteur, "nom", $$v)},expression:"formVisiteur.nom"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Prénom","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Prénom"},model:{value:(_vm.formVisiteur.prenom),callback:function ($$v) {_vm.$set(_vm.formVisiteur, "prenom", $$v)},expression:"formVisiteur.prenom"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Fonction","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Fonction"},model:{value:(_vm.formVisiteur.fonction),callback:function ($$v) {_vm.$set(_vm.formVisiteur, "fonction", $$v)},expression:"formVisiteur.fonction"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"50%"},attrs:{"label":"Debut","required":""}},[_c('el-time-select',{attrs:{"picker-options":{
                                                                start: '00:00',
                                                                step: '00:15',
                                                                end: '23:45'
                                                            },"placeholder":"Heure debut "},model:{value:(_vm.formVisiteur.heure),callback:function ($$v) {_vm.$set(_vm.formVisiteur, "heure", $$v)},expression:"formVisiteur.heure"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"50%"},attrs:{"label":"Fin","required":""}},[_c('el-time-select',{attrs:{"picker-options":{
                                                                start: '00:00',
                                                                step: '00:15',
                                                                end: '23:45'
                                                            },"placeholder":"Heure fin "},model:{value:(_vm.formVisiteur.heureFin),callback:function ($$v) {_vm.$set(_vm.formVisiteur, "heureFin", $$v)},expression:"formVisiteur.heureFin"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":"","ml-3":""}},[_c('el-form-item',{attrs:{"label":"Action"}},[(_vm.tableVisiteur.length != 10)?_c('el-button',{attrs:{"type":"primary","disabled":!_vm.verifFormVisiteur()},on:{"click":function($event){return _vm.addListVisiteur(_vm.formVisiteur)}}},[_vm._v("Ajouter")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableVisiteur}},[_c('el-table-column',{attrs:{"prop":"nom","label":"Nom","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prenom","label":"Prénom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fonction","label":"Fonction"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heure","label":"Heure Debut"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureFin","label":"Heure Fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableVisiteur)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                                            Supprimer ce visiteur\n                                                        ")],1)]}}])})],1)],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.d1 = 1}}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_left")]),_vm._v(" Précédent")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.d1 = 3}}},[_vm._v("Continuer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"primary","icon":"info"}},[_vm._v("\n                                                Sécurité/Hse - SITUATIONS ENVIRONNEMENTALES ET SOCIALES\n                                            ")])],1),_vm._v(" "),_vm._l((_vm.listeQualitatif),function(quest,index){return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"prop":'listeQualitatif.' + index + '.libelle',"name":"libelle","placeholder":"Question","readonly":true},model:{value:(quest.libelle),callback:function ($$v) {_vm.$set(quest, "libelle", $$v)},expression:"quest.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"default-first-option":"","placeholder":"Reponse * "},model:{value:(quest.reponse),callback:function ($$v) {_vm.$set(quest, "reponse", $$v)},expression:"quest.reponse"}},_vm._l((_vm.reponses),function(item){return _c('el-option',{key:item.value,attrs:{"prop":'listeQualitatif.' + index + '.resp',"label":item.text,"value":item.id}})}),1)],1),_vm._v(" "),(quest.reponse == 1)?_c('v-flex',{attrs:{"md3":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Nombre *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","value":"nombre","prop":'listeQualitatif.' + index + '.qte',"placeholder":"Qte"},model:{value:(quest.qte),callback:function ($$v) {_vm.$set(quest, "qte", $$v)},expression:"quest.qte"}})],1):_vm._e(),_vm._v(" "),(quest.reponse == 1)?_c('v-flex',{attrs:{"md3":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Heure *")]),_vm._v(" "),_c('el-time-select',{staticStyle:{"width":"100%"},attrs:{"format":"HH:mm","prop":'listeQualitatif.' + index + '.date',"value-format":"HH:mm","id":"HeureArret","placeholder":"Selectionnez l'heure","picker-options":{
                                                                start: '00:00',
                                                                step: '00:05',
                                                                end: '23:55'
                                                                }},model:{value:(quest.dateHarret),callback:function ($$v) {_vm.$set(quest, "dateHarret", $$v)},expression:"quest.dateHarret"}})],1):_vm._e(),_vm._v(" "),(quest.reponse == 1)?_c('v-flex',{attrs:{"md3":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Observation *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"prop":'listeQualitatif.' + index + '.description',"type":"textarea","rows":6,"placeholder":"Observation  "},model:{value:(quest.description),callback:function ($$v) {_vm.$set(quest, "description", $$v)},expression:"quest.description"}})],1):_vm._e()],1)})],2),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.d1 = 2}}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_left")]),_vm._v(" Précédent")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.d1 = 4}}},[_vm._v("Continuer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-card',[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"primary","icon":"info"}},[_vm._v("\n                                                Inventaire Matériaux Utilisées\n\n                                            ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"md18":""}},_vm._l((_vm.optionProduit),function(optionP){return _c('v-layout',{key:optionP.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md9":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Type ressource *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":""},on:{"change":function($event){return _vm.loadUniteProduit(optionP.produit)}},model:{value:(optionP.produit),callback:function ($$v) {_vm.$set(optionP, "produit", $$v)},expression:"optionP.produit"}},_vm._l((_vm.listeProduitAffich),function(item){return _c('el-option',{key:item.id,attrs:{"id":item.id,"label":item.value+' / '+item.type,"value":item}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité *")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","min":"1"},model:{value:(optionP.qte),callback:function ($$v) {_vm.$set(optionP, "qte", $$v)},expression:"optionP.qte"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"valeurSelect","readonly":true},model:{value:(_vm.valeurUniteMateriel),callback:function ($$v) {_vm.valeurUniteMateriel=$$v},expression:"valeurUniteMateriel"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix unitaire *")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","min":"0"},model:{value:(optionP.prix),callback:function ($$v) {_vm.$set(optionP, "prix", $$v)},expression:"optionP.prix"}})],1)]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"md1":""}},[(_vm.tableInventaire.length != 10)?_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addListInventaire(optionP)}}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1)],1)}),1),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formInventaire}},[_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableInventaire}},[_c('el-table-column',{attrs:{"prop":"type","label":"Catégorie de ressource","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Type ressource","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix unitaire"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableInventaire)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                                            Supprimer\n                                                        ")],1)]}}])})],1)],1)],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.d1 = 3}}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_left")]),_vm._v(" Précédent")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.d1 = 5}}},[_vm._v("Continuer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"5"}},[_c('v-card',[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"primary","icon":"info"}},[_vm._v("\n                                                Inventaire Ressources Externes (non prévu)\n                                            ")])],1),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formExternRes}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Type","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Type"},model:{value:(_vm.formExternRes.type),callback:function ($$v) {_vm.$set(_vm.formExternRes, "type", $$v)},expression:"formExternRes.type"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Libelle","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Libellé"},model:{value:(_vm.formExternRes.libelle),callback:function ($$v) {_vm.$set(_vm.formExternRes, "libelle", $$v)},expression:"formExternRes.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Quantité","required":""}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":0,"size":"large","controls-position":"right","placeholder":"Quantité"},model:{value:(_vm.formExternRes.qte),callback:function ($$v) {_vm.$set(_vm.formExternRes, "qte", $$v)},expression:"formExternRes.qte"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Unité","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Unité"},model:{value:(_vm.formExternRes.unite),callback:function ($$v) {_vm.$set(_vm.formExternRes, "unite", $$v)},expression:"formExternRes.unite"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"50%"},attrs:{"label":"Debut","required":""}},[_c('el-time-select',{attrs:{"picker-options":{
                                                                start: '00:00',
                                                                step: '00:15',
                                                                end: '23:45'
                                                            },"placeholder":"Heure debut "},model:{value:(_vm.formExternRes.heure),callback:function ($$v) {_vm.$set(_vm.formExternRes, "heure", $$v)},expression:"formExternRes.heure"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"50%"},attrs:{"label":"Fin","required":""}},[_c('el-time-select',{attrs:{"picker-options":{
                                                                start: '00:00',
                                                                step: '00:15',
                                                                end: '23:45'
                                                            },"placeholder":"Heure fin "},model:{value:(_vm.formExternRes.heureFin),callback:function ($$v) {_vm.$set(_vm.formExternRes, "heureFin", $$v)},expression:"formExternRes.heureFin"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":"","ml-5":""}},[_c('el-form-item',{attrs:{"label":"Action"}},[(_vm.tableformExtern.length != 10)?_c('el-button',{attrs:{"type":"primary","disabled":!_vm.veriformExternRes()},on:{"click":function($event){return _vm.addListRessouE(_vm.formExternRes)}}},[_vm._v("Ajouter")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableformExtern}},[_c('el-table-column',{attrs:{"prop":"type","label":"Type","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heure","label":"Heure Debut"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureFin","label":"Heure Fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableformExtern)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                                            Supprimer cette ressource\n                                                        ")],1)]}}])})],1)],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.d1 = 4}}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_left")]),_vm._v(" Précédent")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.loadOuvrierTravaux();_vm.loadRessourceTechnik();_vm.loadVehicule(); _vm.d1 = 6}}},[_vm._v("Continuer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"6"}},[_c('v-card',[_c('v-flex',{staticClass:"mb-2 ml-2 mr-2",attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("Personnels affectés au chantier")])],1),_vm._v(" "),_c('ListePresence',{attrs:{"idTravaux":_vm.detailTrx.idTrx,"listeOuvriers":_vm.listePrestOuvriers,"listeData":_vm.listeData},on:{"dataChange":_vm.loadListePresence}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.d1 = 5}}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_left")]),_vm._v(" Précédent")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.loadTache();_vm.d1 = 7}}},[_vm._v("Continuer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"7"}},[_c('v-card',[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"primary","icon":"info"}},[_vm._v("\n                                                Matériel(s) / Engin(s) affecté(s) au travaux\n                                            ")])],1),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formVehicule}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Matériel/Engin","required":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Selectionnez ou saisir le matériel "},on:{"change":function($event){_vm.findCoutVehicule();_vm.calculTotalHeure()}},model:{value:(_vm.formVehicule.libelle),callback:function ($$v) {_vm.$set(_vm.formVehicule, "libelle", $$v)},expression:"formVehicule.libelle"}},_vm._l((_vm.listeVehicule),function(item){return _c('el-option',{key:item.idVeh,attrs:{"label":item.matricule,"value":item.matricule}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"heure debut","required":""}},[_c('el-time-select',{attrs:{"picker-options":{
                                                              start: '00:00',
                                                              step: '00:15',
                                                              end: '23:45'
                                                          },"placeholder":"Heure debut "},on:{"change":function($event){return _vm.calculTotalHeure()}},model:{value:(_vm.formVehicule.heureDebut),callback:function ($$v) {_vm.$set(_vm.formVehicule, "heureDebut", $$v)},expression:"formVehicule.heureDebut"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"heure fin","required":""}},[_c('el-time-select',{attrs:{"picker-options":{
                                                              start: '00:00',
                                                              step: '00:15',
                                                              end: '23:45'
                                                          },"placeholder":"Heure de fin "},on:{"change":function($event){return _vm.calculTotalHeure()}},model:{value:(_vm.formVehicule.heureFin),callback:function ($$v) {_vm.$set(_vm.formVehicule, "heureFin", $$v)},expression:"formVehicule.heureFin"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"heure pause/Intemperie","required":""}},[_c('el-time-select',{attrs:{"picker-options":{
                                                              start: '00:00',
                                                              step: '00:15',
                                                              end: '23:45'
                                                          },"placeholder":"Heure pause/Intemperie "},on:{"change":function($event){return _vm.calculTotalHeure()}},model:{value:(_vm.formVehicule.heurePause),callback:function ($$v) {_vm.$set(_vm.formVehicule, "heurePause", $$v)},expression:"formVehicule.heurePause"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"heure travail"}},[_c('el-input',{staticClass:"inline-input",staticStyle:{"font-size":"22px"},attrs:{"required":"","placeholder":this.totalHeureVehicule,"value":this.totalHeureVehicule,"readonly":true},model:{value:(_vm.formVehicule.heureTotal),callback:function ($$v) {_vm.$set(_vm.formVehicule, "heureTotal", $$v)},expression:"formVehicule.heureTotal"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Compteur début jour (km/h)","required":""}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Compteur début jour"},model:{value:(_vm.formVehicule.cptDjour),callback:function ($$v) {_vm.$set(_vm.formVehicule, "cptDjour", $$v)},expression:"formVehicule.cptDjour"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Compteur fin jour (km/h)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Compteur fin jour"},model:{value:(_vm.formVehicule.cptFjour),callback:function ($$v) {_vm.$set(_vm.formVehicule, "cptFjour", $$v)},expression:"formVehicule.cptFjour"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Qte de Carburant prise (litre)","required":""}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Quantité consommée"},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.formVehicule.qte),callback:function ($$v) {_vm.$set(_vm.formVehicule, "qte", $$v)},expression:"formVehicule.qte"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Prix (L) du carburant(FCFA)","required":""}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Cout unitaire du carburant"},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.formVehicule.cout),callback:function ($$v) {_vm.$set(_vm.formVehicule, "cout", $$v)},expression:"formVehicule.cout"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Observation"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Observation  "},model:{value:(_vm.formVehicule.description),callback:function ($$v) {_vm.$set(_vm.formVehicule, "description", $$v)},expression:"formVehicule.description"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Action"}},[_c('el-button',{attrs:{"type":"primary","disabled":!_vm.verifFormVehicule()},on:{"click":function($event){return _vm.addListVehicule(_vm.formVehicule)}}},[_vm._v("Ajouter")])],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                      TOTAL TRAVAIL : "+_vm._s(_vm.totalComHT)+"\n                                                  ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableVehicule}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',[_c('b',[_vm._v("Compteur début jour(km)")]),_vm._v("\n                                                            : "+_vm._s(props.row.cptDjour)+"\n                                                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Compteur fin jour(km)")]),_vm._v("\n                                                            : "+_vm._s(props.row.cptFjour)+"\n                                                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Prix (L) du  carburant (FCFA)")]),_vm._v("\n                                                            : "+_vm._s(props.row.cout)+"\n                                                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Observation")]),_vm._v("\n                                                            : "+_vm._s(props.row.description)+"\n                                                          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Matériel/Engin","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureDebut","label":"Heure début"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureFin","label":"Heure fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heurePause","label":"Heure pause"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureTotal","label":"Heure travail"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Qte de carburant prise<(Litre)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRowVehicule(scope.$index, _vm.tableVehicule)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                                                Supprimer\n                                                            ")],1)]}}])})],1)],1)],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.d1 = 6}}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_left")]),_vm._v(" Précédent")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.loadTache();_vm.d1 = 8}}},[_vm._v("Continuer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"8"}},[_c('v-card',[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"primary","icon":"info"}},[_vm._v("\n                                                Travaux réalisés (La liste des tâches ne contient que celles en cours d'exécution)\n                                            ")])],1),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formTravaux}},[(this.tableTravaux.length <= 0)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Activité","required":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Selectionnez la tache"},model:{value:(_vm.formTravaux.activite),callback:function ($$v) {_vm.$set(_vm.formTravaux, "activite", $$v)},expression:"formTravaux.activite"}},_vm._l((_vm.listeActivite),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1)],1),_vm._v(" "),(this.formTravaux.activite == 'NON')?_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Description","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Observation"},model:{value:(_vm.formTravaux.descriptionActivite),callback:function ($$v) {_vm.$set(_vm.formTravaux, "descriptionActivite", $$v)},expression:"formTravaux.descriptionActivite"}})],1)],1):_vm._e(),_vm._v(" "),(this.formTravaux.activite == 'OUI')?_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Libelle","required":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Selectionnez la tache"},on:{"change":_vm.handleChangeTrx},model:{value:(_vm.formTravaux.tache),callback:function ($$v) {_vm.$set(_vm.formTravaux, "tache", $$v)},expression:"formTravaux.tache"}},_vm._l((_vm.listeTaches),function(item){return _c('el-option',{key:item.idTache,attrs:{"label":item.libelle,"value":item.idTache}})}),1)],1)],1):_vm._e(),_vm._v(" "),(_vm.etatSoutraitance)?_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"80%"},attrs:{"label":"Sous-traitant"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","allow-create":"","placeholder":"Selectionnez le sous-traitant"},on:{"change":_vm.handleSelect},model:{value:(_vm.formTravaux.sousTraitant),callback:function ($$v) {_vm.$set(_vm.formTravaux, "sousTraitant", $$v)},expression:"formTravaux.sousTraitant"}},_vm._l((_vm.listeSouTraitant),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1):_vm._e(),_vm._v(" "),(this.formTravaux.activite == 'OUI')?_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Quantité total","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":true,"size":"large","controls-position":"right","placeholder":"Quantité total"},model:{value:(_vm.formTravaux.qteTotal),callback:function ($$v) {_vm.$set(_vm.formTravaux, "qteTotal", $$v)},expression:"formTravaux.qteTotal"}})],1)],1):_vm._e(),_vm._v(" "),(this.formTravaux.activite == 'OUI')?_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Quantité déja effectuée","required":""}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":true,"size":"large","controls-position":"right","placeholder":"Quantité déja effectuée"},model:{value:(_vm.formTravaux.qteEffect),callback:function ($$v) {_vm.$set(_vm.formTravaux, "qteEffect", $$v)},expression:"formTravaux.qteEffect"}})],1)],1):_vm._e(),_vm._v(" "),(this.formTravaux.activite == 'OUI')?_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Quantité","required":""}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":0,"size":"large","max":_vm.maxEvolution,"step":0.01,"controls-position":"right","placeholder":"Quantité"},model:{value:(_vm.formTravaux.qte),callback:function ($$v) {_vm.$set(_vm.formTravaux, "qte", $$v)},expression:"formTravaux.qte"}})],1)],1):_vm._e(),_vm._v(" "),(this.formTravaux.activite == 'OUI')?_c('v-flex',{attrs:{"md2":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Unité"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"controls-position":"right","disabled":true},model:{value:(_vm.formTravaux.unite),callback:function ($$v) {_vm.$set(_vm.formTravaux, "unite", $$v)},expression:"formTravaux.unite"}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(this.tableTravaux.length <= 0 && this.formTravaux.activite == 'OUI')?_c('v-layout',{attrs:{"row":""}},[_c('el-row',{attrs:{"type":"flex","gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('el-upload',{ref:"uploadFichContrat",staticClass:"upload-demo",attrs:{"list-type":"picture-card","name":"photo","action":"","auto-upload":false,"on-change":_vm.changeFile,"multiple":true}},[_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":_vm.logoProjet,"alt":""}})])],1),_vm._v(" "),_c('span',[_vm._v("Taille inférieur à 10 Mo")])],1)],1):_vm._e(),_vm._v(" "),(this.tableTravaux.length <= 0 && this.formTravaux.activite == 'OUI')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md8":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Observation"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Observation  "},model:{value:(_vm.formTravaux.description),callback:function ($$v) {_vm.$set(_vm.formTravaux, "description", $$v)},expression:"formTravaux.description"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('el-form-item',{staticStyle:{"width":"60%"},attrs:{"label":"Action"}},[_c('el-button',{attrs:{"type":"primary","disabled":!_vm.verifFormTravaux()},on:{"click":function($event){return _vm.addListTravaux()}}},[_vm._v("Ajouter")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('CoolLightBox',{attrs:{"items":_vm.items,"index":_vm.index},on:{"close":function($event){_vm.index = null}}}),_vm._v(" "),(this.formTravaux.activite == 'OUI')?_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableTravaux}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',[_c('b',[_vm._v("Observation")]),_vm._v(" : "+_vm._s(props.row.description))])]}}],null,false,3876295710)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libelle ","sortable":""}}),_vm._v(" "),(_vm.etatSoutraitance)?_c('el-table-column',{attrs:{"prop":"libellSousTrai","label":"Sous-traitant"}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité effectuée"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unitée"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"image","label":"Photo"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((scope.row.imageTaches),function(img,index){return _c('v-avatar',{key:index,staticClass:"mr-1",attrs:{"tile":true,"size":"40px","height":"40px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":img,"alt":"avatar"}})])})}}],null,false,1863813158)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableTravaux)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                                            Supprimer\n                                                        ")],1)]}}],null,false,2905197989)})],1)],1):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.d1 = 6}}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_left")]),_vm._v(" Précédent")],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"green","disabled":!_vm.verifTableTravaux()},nativeOn:{"click":function($event){_vm.dialogAccord = true}}},[_vm._v("Enregister "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done")])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","persistent":""},model:{value:(_vm.dialogAccord),callback:function ($$v) {_vm.dialogAccord=$$v},expression:"dialogAccord"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Voulez-vous valider le rapport journaliers du "+_vm._s(_vm.dateRaport))]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                    En cliquant sur valider, le rapport sera soumis pour validation à votre supérieur hiérarchique (Chef chantier ou Chef projet).Après la validation le rapport ne pourra plus être supprimé.Votre Supérieur peut emettre une réserve s'il estime qu'une tâche est à refaire, dans ce cas vous recevrez une notification."),_c('br'),_vm._v(" "),_c('b',[_vm._v("NB: Vous ne pouvez effectuer qu'un seul rapport par jour")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.dialogAccord = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.createRapport()}}},[_vm._v("Valider")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","persistent":""},model:{value:(_vm.dialogNewRapport),callback:function ($$v) {_vm.dialogNewRapport=$$v},expression:"dialogNewRapport"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Voulez-vous effectuer un autre rapport journalier pour la date du "+_vm._s(_vm.dateRaport))]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                    En cliquant sur NON, vous ne pourriez plus effectué de rapport journalier pour la date du "+_vm._s(_vm.dateRaport)+" "),_c('br')]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.dialogNewRapport = false;_vm.dialogRapport = false}}},[_vm._v("Non")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.createNewRapport()}}},[_vm._v("Oui")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IPbc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RechercheInfo_vue__ = __webpack_require__("FvTE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_294e4cea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RechercheInfo_vue__ = __webpack_require__("ea37");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RechercheInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_294e4cea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RechercheInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ISzt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogDetail),callback:function ($$v) {_vm.dialogDetail=$$v},expression:"dialogDetail"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Fiche de Validation d'une demande d'intervention")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Informations générales sur l'intervention\n                                            ")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Référence")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.intervDetail.IdInterv)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Priorité")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.intervDetail.priorite)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Gravité")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.intervDetail.gravite)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Garage")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.intervDetail.garage)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs3":""}},[_c('a',{attrs:{"href":_vm.intervDetail.imageDevis,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.intervDetail.imageDevis}})])],1)])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Vehicule")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.intervDetail.vehicule)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Chauffeur du véhicule")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.intervDetail.conducteur)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Type")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.intervDetail.type)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Demandeur")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.intervDetail.demandeur)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Categorie")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.intervDetail.categorie)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Budget alloué  ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(new Intl.NumberFormat().format(_vm.intervDetail.budgetTotal))+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3",attrs:{"row":""}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Facture déjà validée  ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(new Intl.NumberFormat().format(_vm.intervDetail.mntFactureValide))+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3",attrs:{"row":""}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Ecart budget - facture validée  ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(new Intl.NumberFormat().format(_vm.intervDetail.ecartBudget))+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3",attrs:{"row":""}}),_vm._v(" "),_c('v-layout',{staticClass:"mb-2",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Etat budget (si la facture est validée)")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_c('el-tag',{attrs:{"type":(_vm.intervDetail.ecartBudget >= _vm.intervDetail.mntTotOptInterv) ? 'success' : 'danger',"disable-transitions":""}},[((_vm.intervDetail.ecartBudget >= _vm.intervDetail.mntTotOptInterv))?_c('span',[_vm._v("Dans le budget")]):_c('span',[_vm._v("Hors budget")])])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Description")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.intervDetail.motif)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                DIAGNOSTIQUE\n                                            ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',[_c('v-flex',{staticClass:"text-xs-left mb-3",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Maindoeuvre(Fcfa)")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                        "+_vm._s(new Intl.NumberFormat().format(_vm.intervDetail.maindoeuvre))+"\n                                                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Diagnostique")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                    "+_vm._s(_vm.intervDetail.libelleDiag)+"\n                                                                ")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left ml-3",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Diagnostique enregistré par")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                    "+_vm._s(_vm.intervDetail.userDiag)+"\n                                                                ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date d'enregistrement ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                    "+_vm._s(_vm.intervDetail.dateDiagEnreg)+"\n                                                                ")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES ARTICLES FOURNIS PAR LE GARAGE: "+_vm._s(_vm.intervDetail.garage))]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (TTC): "+_vm._s(new Intl.NumberFormat().format(_vm.intervDetail.mntTotOptInterv))+" fcfa")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.intervDetail.optionInterv}},[_c('el-table-column',{attrs:{"prop":"libProd","label":"Designation","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix unitaire"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotal","label":"Total"}})],1)],1),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                PRODUITS EN STOCKS\n                                            ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"text-xs-left mb-3",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"m3-2 ml-1 mr-1 mb-3",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Produit stock","description":'Après la validation un bon de sortie sera disponible dans l\'entrepot concerné si le produit est en nombre suffisant. Une commande sera générée dans le cas contraire',"closable":false,"show-icon":"","type":"warning"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Entrepot concerné")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                        "+_vm._s(_vm.intervDetail.entrepot)+"\n                                                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.intervDetail.optionIntervStock}},[_c('el-table-column',{attrs:{"prop":"libProd","label":"Designation","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteStock","label":"Quantite en stock"}})],1)],1)],1),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5",staticStyle:{"margin-right":"100px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"red"},on:{"click":function($event){_vm.dialogConfirmRefus = true}},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Refuser la demande")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"green"},on:{"click":function($event){_vm.dialogConfirm = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v("Valider la demande")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirmRefus),callback:function ($$v) {_vm.dialogConfirmRefus=$$v},expression:"dialogConfirmRefus"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation de facture")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous Refuser cette facture ?","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("FACTURE ")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v(_vm._s(_vm.intervDetail.Idfact))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{ref:"refFormRefust",staticClass:"demo-form-inline",attrs:{"id":"formRefus","rules":_vm.ruleFormRefus,"label-position":"top","inline":true,"model":_vm.formRefus}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Commentaire","prop":"rapportRefus"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Pourquoi voulez-vous refuser ?"},model:{value:(_vm.formRefus.rapport),callback:function ($$v) {_vm.$set(_vm.formRefus, "rapport", $$v)},expression:"formRefus.rapport"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirmRefus = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitRefusDevis()}}},[_vm._v("Refuser")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation de la demande d'intervention")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous valider la demande d'intervention ?","closable":false,"show-icon":"","type":"success"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("DEMANDE D'INTERVENTION ")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v(_vm._s(_vm.intervDetail.IdInterv))]),_vm._v(" "),_c('p',{staticClass:"red--text .font-weight-regular subheading"},[_vm._v("MONTANT: "+_vm._s(new Intl.NumberFormat().format(_vm.intervDetail.mntTotCom))+" FCFA")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirm = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideDevis()}}},[_vm._v("Confirmer")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "InPd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalDetailEmploye_vue__ = __webpack_require__("Gr1M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c76c17e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalDetailEmploye_vue__ = __webpack_require__("G9jN");
function injectStyle (ssrContext) {
  __webpack_require__("DOLh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c76c17e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modalDetailEmploye_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c76c17e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modalDetailEmploye_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ixl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "AjoutReserve",
  props: {
    show: {
      type: Boolean
    },
    tache: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),

      loading: false,
      dialogReserve: false,
      formReserve: {
        description: null,
        images: []
      },
      fichierImage: [],
      rules: {
        description: [{ required: true, message: "Veuillez saisir" }]
      }
    };
  },


  watch: {
    show: function show(newValue, oldvalue) {
      if (newValue == false) {
        this.dialogReserve = false;
      } else {
        this.dialogReserve = true;
        this.resetForm("formReserve");
      }
    }
  },

  methods: {
    createReserve: function createReserve() {
      var _this = this;

      this.$refs["formReserve"].validate(function (valid) {
        if (valid) {
          _this.loading = true;
          var url = _this.domaine + "reserve/new";
          var data = new FormData();
          data.append("idOptTrx", _this.tache.idOptTrx);
          data.append("description", _this.formReserve.description);
          data.append("idUser", _this.user.id);

          if (_this.fichierImage.length > 0) {
            _this.fichierImage.forEach(function (file) {
              data.append("fichierImage[]", file, file[name]);
            }, _this);
          }

          _this.$http.post(url, data).then(function (resp) {
            _this.loading = false;
            //this.dialogAccord = false;
            _this.$notify({
              title: "Reserve",
              message: "Reserve enregistrée",
              type: "success",
              position: "top-right",
              duration: 7000
            });

            _this.formReserve.images.splice(0);
            _this.fichierImage.splice(0);
            _this.closeDialog();
          }, function (resp) {
            _this.loading = false;
            _this.$message.error("Erreur lors de l'enregistrement d'une reserve");
          });
        }
      });
    },
    onFileTachePicked: function onFileTachePicked(event) {
      var _this2 = this;

      this.formReserve.images.splice(0, 1);
      this.fichierImage.splice(0, 1);
      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this2.formReserve.images.push(fileReader.result);
      });

      fileReader.readAsDataURL(files[0]);

      this.fichierImage.push(files[0]);
    },
    onFileTachePicked2: function onFileTachePicked2(event) {
      var _this3 = this;

      this.formReserve.images.splice(1, 1);
      this.fichierImage.splice(1, 1);
      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this3.formReserve.images.push(fileReader.result);
      });

      fileReader.readAsDataURL(files[0]);

      this.fichierImage.push(files[0]);
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.formReserve.images.splice(0);
      this.formReserve.description = "";
    }
  }

});

/***/ }),

/***/ "J/ex":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationDmd_vue__ = __webpack_require__("C/WC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e295c4b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationDmd_vue__ = __webpack_require__("ltEs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationDmd_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e295c4b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationDmd_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J3dB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
    name: "ModalAttribuerEquipe",
    props: ["show", "userResponsable"],

    data: function data() {
        var generateData = function generateData(_) {
            var data = [];
            for (var i = 1; i <= 15; i++) {
                data.push({
                    key: i,
                    label: "Option " + i,
                    disabled: i % 4 === 0
                });
            };
            return data;
        };

        return {
            data: generateData(),
            value1: [1, 4],

            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            loading: false,

            dialogAttribuerEquipe: false
        };
    },


    computed: {},

    methods: {
        closeDialog: function closeDialog() {
            this.$emit('close');
        },
        loadTechInfo: function loadTechInfo() {},
        loadTechInfoById: function loadTechInfoById(techId) {},
        submitEquipe: function submitEquipe() {}
    },

    watch: {
        show: function show(newValue, oldvalue) {
            if (newValue == true) {}
            this.dialogAttribuerEquipe = newValue;
        }
    },

    mounted: function mounted() {}
});

/***/ }),

/***/ "JC3o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('google-map',{attrs:{"name":"example","listMarqueur":_vm.listMarqueur}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JEO5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JMMz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "ModalValidationDmdCom",
  props: ["show", "detailCommande", "totalMontant"],
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
      loading: false,
      dialogDetail: false,
      dialogVisible: false,
      dialogConfirmRefus: false,
      dialogConfirm: false,
      formRefus: {},
      ruleFormRefus: {
        rapportRefus: [{ required: true, message: 'Veuillez saisir' }]
      }
    };
  },


  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogDetail = newValue;
      if (newValue == true) {
        //this.loadDevisConstat()
      }
    }
  },

  methods: {
    successNotif: function successNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      this.$notify({
        title: 'ENREGISTREMENT REUSSI',
        message: mess,
        type: 'success',
        position: 'top-center'
      });
    },
    SubmitValideBudget: function SubmitValideBudget() {},
    closeDialog: function closeDialog() {
      this.$emit('close', this.detailCommande.IdUtil, "mission");
    },
    SubmitValideDevis: function SubmitValideDevis(item) {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "validationDG/commande/valide";
      var data = new FormData();
      data.append("idComande", this.detailCommande.id);
      data.append("user", this.user.id);
      data.append("etat", item);
      this.$http.post(url, data).then(function (response) {
        _this.loading = false;
        _this.successNotif(response.body.message);
        _this.dialogConfirm = false;
        _this.closeDialog();
      }, function (errResp) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors de la validation de la mission");
      });
    },
    SubmitRefusDevis: function SubmitRefusDevis() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "mission/rejeter";
      var data = new FormData();
      data.append("motifRefus", this.formRefus.rapport);
      data.append("idMission", this.detailCommande.IdUtil);
      data.append("user", this.user.id);

      this.$http.post(url, data).then(function (response) {
        _this2.loading = false;
        _this2.successNotif(response.body.message);
        _this2.dialogConfirmRefus = false;
        _this2.closeDialog();
      }, function (errResp) {
        _this2.loading = false;
        _this2.$message.error("Une erreur est survenue lors du refus de la demande de mission");
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "JezI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Entrepot_vue__ = __webpack_require__("gKWr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c62c6fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Entrepot_vue__ = __webpack_require__("opP9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Entrepot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c62c6fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Entrepot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JikA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LoadDepenseProduitExcel",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  props: {
    listeTypeTravaux: {
      type: Array,
      default: null
    },
    projet: {
      type: Array,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    idTypeProjet: {
      type: Number
    },
    listTotals: {
      type: Array,
      default: null
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      dialogAjoutConducteur: false,
      loading: false,
      dialogSupr: false,
      idLigne: null

    };
  },

  watch: {
    show: function show(newValue, oldValue) {
      if (newValue == true) {
        this.dialogAjoutConducteur = true;
      } else {
        this.dialogAjoutConducteur = false;
      }
    }
  },
  methods: {
    saveListe: function saveListe() {
      var _this = this;

      var succesEnreg = true;
      var url = this.domaine + "projet/save/depense/excel";
      var nbData = 10;
      var nbReq = 1;
      var ligne = null;

      var nbRest = void 0;
      if (this.listeTypeTravaux.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.listeTypeTravaux.length / nbData);
        nbRest = this.listeTypeTravaux.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }

      for (var i = 0; i < nbReq; i++) {
        var initJ = i * nbData;
        var finJ = (i + 1) * nbData;
        var dataLot = [];
        if (this.listeTypeTravaux.length > 0) {
          for (var j = initJ; j < finJ; j++) {
            if (this.listeTypeTravaux[j] == undefined) {
              break;
            }
            dataLot.push(this.listeTypeTravaux[j]);
          }
        }
        var data = new FormData();

        for (var prop in dataLot) {
          ligne = dataLot[prop];
          data.append("option[date][]", ligne.date);
          data.append("option[code][]", ligne.code);
          data.append("option[banque][]", ligne.banque);
          data.append("option[libelle][]", ligne.libelle);
          data.append("option[type][]", ligne.type);
          data.append("option[montantD][]", ligne.montantD);
          data.append("option[montantC][]", ligne.montantC);
          data.append("option[soldeD][]", ligne.soldeD);
          data.append("option[soldeC][]", ligne.soldeC);
        }
        data.append("idUser", this.user.id);
        data.append("projet", this.projet.id);

        this.$http.post(url, data).then(function (resp) {}, function (error) {
          _this.loading = false;
          _this.$message.error("Erreur lors de l'enregistrement des types travaux");
          // succesEnreg = false;
          // window.location.reload();
        });
      }
      var loading = this.$loading({
        lock: true,
        text: "Veuillez patientez ...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
        // this.loading = false
        if (succesEnreg == true) {
          _this.dialogAjoutConducteur = false;
          _this.$emit("close");
          _this.$emit("showModalLoadTypeTravaux");

          _this.$notify({
            title: "Enregistrement",
            message: "La liste a ete enregistre avec succes",
            type: "success",
            position: "top-right",
            duration: 7000
          });
        }
      }, 30000);
    },
    edit: function edit(row) {},
    deleteRow: function deleteRow(row) {
      console.log('row', row);
      var index = this.listeTypeTravaux.indexOf(row);
      if (index !== -1) {
        this.listeTypeTravaux.splice(index, 1); // Supprime l'élément à l'index trouvé
      }
    },
    loadTravauxParType: function loadTravauxParType() {
      var _this2 = this;

      this.loading = true;
      setTimeout(function () {
        _this2.listeProjetTravaux.splice(0);
        var url = _this2.domaine + "projet/liste/typeTravaux";
        _this2.$http.get(url).then(function (response) {
          _this2.listeProjetTravaux = response.body.listeProjetTravaux;
          _this2.loading = false;
        }, function (error) {
          _this2.loading = false;
          _this2.$message.error("Erreur lors du chargement des travaux ");
        });
      }, 2000);
    },
    closeDialog: function closeDialog() {
      var _this3 = this;

      var loading = this.$loading({
        lock: true,
        text: "Veuillez patientez ...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
        _this3.$emit("close");
      }, 1000);
    }
  }
});

/***/ }),

/***/ "Jsos":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v(_vm._s(item.text))])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newBesoin()}},slot:"activator"},[_vm._v("\n        Ajouter\n        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("Ajouter un nouveau bon de commande interne\n    ")],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content"},[_c('el-row',[_c('el-col',[_c('el-card',{staticClass:"box-card"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md12":""}},[_c('el-button',{staticClass:"btnV",attrs:{"type":"warning","size":"medium"}},[_vm._v("BON DE COMMANDE INTERNE EN ATTENTE")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":""}},[_c('el-card',{staticClass:"box-card"},[(_vm.activDerouler)?_c('div',{staticClass:"mb-1"},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),(!_vm.disabledImprime)?_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[(_vm.droitAcces.imprime_pdf_besoin_liste)?_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeBesoin('PDF')}}},[_vm._v("PDF")]):_vm._e(),_vm._v(" "),(_vm.droitAcces.imprime_exc_besoin_liste)?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeBesoin('EXC')}}},[_vm._v("EXCEL")]):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledImprime,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste")])],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"elevation-3",attrs:{"slot":"activator","dark":"","icon":"","flat":"","color":"primary"},on:{"click":function($event){return _vm.loadRecentBesoin()}},slot:"activator"},[_c('v-icon',[_vm._v("cached")])],1),_vm._v("\n                              actualiser la liste\n                          ")],1)],1),_vm._v(" "),_c('el-collapse',{attrs:{"accordion":""},on:{"change":function($event){return _vm.activationDerouler()}}},[_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_vm._v("\n                              VEUILLEZ CLIQUER POUR DEROULER SVP\n                              "),_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('v-badge',{directives:[{name:"show",rawName:"v-show",value:(!_vm.activDerouler),expression:"!activDerouler"}],staticClass:"notification",attrs:{"left":""}},[_c('span',{staticStyle:{"margin-top":"-11px"},attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.notification))]),_vm._v(" "),_c('v-icon',{attrs:{"large":"","color":"grey lighten-1"}},[_vm._v("notifications_active")]),_vm._v("Besoin(s) non traitée(s)\n                                ")],1)],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('div',[_c('el-tabs',{attrs:{"type":"border-card"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v("\n                                      LISTE DES 10 DERNIERES DEMANDES\n                                      APPROUVEES\n                                    ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"text-xs-right"},[(_vm.droitAcces.index_besoin_commande)?_c('v-tooltip',{attrs:{"top":""}},[(
                                              !_vm.choix &&
                                                this.nombreSelection
                                                  .length === 1
                                            )?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.verifPrioriteBesoin();
                                              _vm.showFormCommandNew();
                                              _vm.loadFourn();}},slot:"activator"},[_vm._v("\n                                            Commander\n                                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1):_vm._e(),_vm._v("Passer une Commander\n                                        ")],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.index_besoin_commande)?_c('v-tooltip',{attrs:{"top":""}},[(
                                              !_vm.choix &&
                                                this.nombreSelection.length >=
                                                  2
                                            )?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.verifPrioriteBesoin();
                                              _vm.showFormCommande();
                                              _vm.loadFourn();}},slot:"activator"},[_vm._v("\n                                            Commander\n                                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1):_vm._e(),_vm._v("Passer un Commander\n                                        ")],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-3 mt-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner de Projet"},on:{"change":function($event){_vm.loadChantier();_vm.filtreByProjet(_vm.projetS)}},model:{value:(_vm.projetS),callback:function ($$v) {_vm.projetS=$$v},expression:"projetS"}},_vm._l((_vm.listeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner un Chantier"},on:{"change":function($event){return _vm.loadTravaux()}},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner un Chantier les travaux"},on:{"clear":function($event){return _vm.clearSelect()},"change":function($event){return _vm.filtrerTravaux(_vm.travauxS)}},model:{value:(_vm.travauxS),callback:function ($$v) {_vm.travauxS=$$v},expression:"travauxS"}},_vm._l((_vm.listeTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-3 mt-1",attrs:{"row":""}},[_c('v-flex',[_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"Filtrer par service"},on:{"clear":function($event){return _vm.clearSelect()},"change":_vm.filtrerEtatService},model:{value:(_vm.selectEtatService),callback:function ($$v) {_vm.selectEtatService=$$v},expression:"selectEtatService"}},_vm._l((_vm.comboService),function(item){return _c('el-option',{key:item.serviceId,attrs:{"label":item.serviceLibelle,"value":item.serviceId}})}),1),_vm._v(" "),_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"Filtrer par demandeur"},on:{"clear":function($event){return _vm.clearSelect()},"change":_vm.filtrerEtatDemandeur},model:{value:(_vm.selectEtatDemandeur),callback:function ($$v) {_vm.selectEtatDemandeur=$$v},expression:"selectEtatDemandeur"}},_vm._l((_vm.comboUser),function(item){return _c('el-option',{key:item.userId,attrs:{"label":item.userName,"value":item.userId}})}),1),_vm._v(" "),_c('el-date-picker',{attrs:{"clearable":"","type":"daterange","range-separator":"à","start-placeholder":"date de debut","end-placeholder":"date de fin","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy"},on:{"clear":function($event){return _vm.clearSelect()},"change":_vm.filtrerEtatDate},model:{value:(_vm.selectEtatDate),callback:function ($$v) {_vm.selectEtatDate=$$v},expression:"selectEtatDate"}}),_vm._v(" "),_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"Filtrer par priorité"},on:{"clear":function($event){return _vm.clearSelect()},"change":_vm.filtrerEtatPrioriteBesoin},model:{value:(_vm.selectEtatPrioriteBesoin),callback:function ($$v) {_vm.selectEtatPrioriteBesoin=$$v},expression:"selectEtatPrioriteBesoin"}},_vm._l((_vm.priorites),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"#2196f3"},on:{"click":function($event){return _vm.loadBesoin()}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("search")])],1),_vm._v("\n                                            Afficher la liste de tous les\n                                            besoins\n                                          ")],1)],1)],1)],1),_vm._v(" "),_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"highlight-current-row":"","data":_vm.listBesoin,"stripe":"","border":"","height":"350"},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Intitulé du BCI","sortable":"","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projet","label":"Projet","sortable":"","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chantier","label":"Chantier","sortable":"","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"travaux","label":"Travaux","sortable":"","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tache","label":"Tâche","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((scope.row.tache),function(item,index){return _c('span',{key:index},[_vm._v("\n                                           "+_vm._s(item)+"/\n                                          ")])})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tranconA","label":"PK debut","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tranconB","label":"PK fin","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"priorite","sortable":"","label":"Priorite","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.priorite === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"green accent-3"}},[_vm._v("Faible")]):(
                                              scope.row.priorite === 2
                                            )?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"orange accent-4"}},[_vm._v("Normal")]):(
                                              scope.row.priorite === 3
                                            )?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"red accent-3"}},[_vm._v("Urgent")]):_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"blue lighten-4"}},[_vm._v("Aucune")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","sortable":"","label":"Date de création","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(_vm._s(scope.row.date))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"","prop":"dateLivr","label":"Date livraison souhaitée","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(_vm._s(scope.row.dateLivr))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user","label":"Emis par","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(_vm._s(scope.row.user))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","width":"100","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerCommande(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                                            Imprimer\n                                          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showCommande(scope.row,true)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("Détails\n                                          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.niveauValid === 0)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"indigo"},on:{"click":function($event){$event.stopPropagation();return _vm.showFormCommandNew(scope.row,true)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("shopping_cart")])],1):_vm._e(),_vm._v("Passer une commande fournisseur\n                                            ")],1)]}}])})],1)],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" LISTE\n                                      DES 10 DERNIERES DEMANDES EN ATTENTE DE\n                                      CONFIRMATION\n                                    ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"tables":"","mt-3":"","ml-1":"","mr-1":"","data":_vm.listBesoinAttente},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Intitulé du BCI","sortable":"","width":"350"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projet","label":"Projet","sortable":"","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chantier","label":"Chantier","sortable":"","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"travaux","label":"Travaux","sortable":"","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tache","label":"Tâche","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((scope.row.tache),function(item,index){return _c('span',{key:index},[_vm._v("\n                                           "+_vm._s(item)+"/\n                                          ")])})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tranconA","label":"PK debut","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tranconB","label":"PK fin","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"priorite","sortable":"","label":"Priorite","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.priorite === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"green accent-3"}},[_vm._v("Faible")]):(
                                              scope.row.priorite === 2
                                            )?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"orange accent-4"}},[_vm._v("Normal")]):(
                                              scope.row.priorite === 3
                                            )?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"red accent-3"}},[_vm._v("Urgent")]):_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"blue lighten-4"}},[_vm._v("Aucune")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","sortable":"","label":"Date de création","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(_vm._s(scope.row.date))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"","prop":"dateLivr","label":"Date livraison souhaitée","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(_vm._s(scope.row.dateLivr))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user","label":"Emis par","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(_vm._s(scope.row.user))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"niveau","label":"Niveau de validation","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.niveauValid === 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"green accent-3"}},[_vm._v("VALIDÉ")]):(
                                                scope.row.niveauValid === 1
                                              )?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"orange accent-4"}},[_vm._v("CHEF PROJET")]):(
                                                scope.row.niveauValid === 2
                                              )?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"orange accent-3"}},[_vm._v("DEX")]):(
                                                scope.row.niveauValid === 3
                                              )?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"blue accent-3"}},[_vm._v("DGA/DOT")]):(
                                                scope.row.niveauValid === 6
                                              )?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"yellow accent-3"}},[_vm._v("RESPONSABLE ENTREPOT")]):_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"red lighten-4"}},[_vm._v("REJETÉE")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","width":"100","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerCommande(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                                            Imprimer\n                                          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.niveauValid != '' )?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showCommande(scope.row,true)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1):_vm._e(),_vm._v("Détails\n                                          ")],1),_vm._v(" "),(scope.row.travauxId != '' && scope.row.niveauValid == 1)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editRessources(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_vm._v("\n                                            Modifier\n                                          ")],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(scope.row.niveauValid == 1)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"red","fab":"","dark":"","small":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogSupr = true;
                                                _vm.idBesoin = scope.row;}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                                            supprimer cette demande\n                                          ")],1)]}}])})],1)],1)],1)],1)])],2)],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.droitAcces.index_besoin_commande)?_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md12":""}},[_c('el-button',{staticClass:"btnV",attrs:{"type":"info","size":"medium"}},[_vm._v("LISTE DES BONS DE COMMANDES INTERNES GÉNÉRÉS (BCI)")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":""}},[_c('el-card',{staticClass:"box-card"},[_c('el-collapse',{attrs:{"accordion":""}},[_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_vm._v("\n                              VEUILLEZ CLIQUER POUR DEROULER SVP\n                                 "),_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('v-badge',{directives:[{name:"show",rawName:"v-show",value:(!_vm.activDerouler),expression:"!activDerouler"}],staticClass:"notification",attrs:{"left":""}},[_c('span',{staticStyle:{"margin-top":"-11px"},attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.notifCommande))]),_vm._v(" "),_c('v-icon',{attrs:{"large":"","color":"grey lighten-1"}},[_vm._v("notifications_active")]),_vm._v("Commande(s) interne(s) générée(s)\n                                ")],1)],1)],1),_vm._v(" "),_c('div',[_c('v-layout',{staticClass:"mb-3 mt-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner de Projet"},on:{"change":function($event){return _vm.loadChantier()}},model:{value:(_vm.projetS),callback:function ($$v) {_vm.projetS=$$v},expression:"projetS"}},_vm._l((_vm.listeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner un Chantier"},on:{"change":function($event){return _vm.loadTravaux()}},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner un Chantier les travaux"},on:{"clear":function($event){return _vm.clearSelectCommande()},"change":_vm.filtrerCommandeTravaux},model:{value:(_vm.travauxS),callback:function ($$v) {_vm.travauxS=$$v},expression:"travauxS"}},_vm._l((_vm.listeTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-3 mt-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md3":""}},[_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"Filtrer par priorité"},on:{"clear":function($event){return _vm.clearSelectCommande()},"change":_vm.filtrerEtatPrioriteCommande},model:{value:(_vm.selectEtatPrioriteCommande),callback:function ($$v) {_vm.selectEtatPrioriteCommande=$$v},expression:"selectEtatPrioriteCommande"}},_vm._l((_vm.priorites),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-date-picker',{attrs:{"clearable":"","type":"daterange","range-separator":"à","start-placeholder":"date de debut","end-placeholder":"date de fin","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy"},on:{"clear":function($event){return _vm.clearSelectCommande()},"change":_vm.filtrerEtatDateCommande},model:{value:(_vm.selectEtatDateCommande),callback:function ($$v) {_vm.selectEtatDateCommande=$$v},expression:"selectEtatDateCommande"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs12":""}},[_c('div',{staticClass:"text-xs-right"},[(_vm.droitAcces.index_besoin_commande)?_c('v-tooltip',{attrs:{"top":""}},[(                                       
                                            this.nombreBonSelection
                                              .length === 1
                                        )?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.verifPrioriteBonBesoin();
                                          _vm.showFormCommandNew();
                                          _vm.loadFourn();}},slot:"activator"},[_vm._v("\n                                        Commander\n                                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1):_vm._e(),_vm._v("Passer une commande fournisseur\n                                    ")],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.index_besoin_commande)?_c('v-tooltip',{attrs:{"top":""}},[(                                          
                                            this.nombreBonSelection.length >=
                                              2
                                        )?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.verifPrioriteBonBesoin();
                                          _vm.showForGenererCommande();
                                          _vm.loadFourn();}},slot:"activator"},[_vm._v("\n                                        Commander\n                                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1):_vm._e(),_vm._v("Passer une commande fournisseur\n                                    ")],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"#2196f3"},on:{"click":function($event){return _vm.loadCommandeRecent()}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("search")])],1),_vm._v("\n                                      Afficher la liste de tous les bons internes générés\n                                    ")],1)],1)])],1),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"tables":"","mt-3":"","ml-1":"","mr-1":"","data":_vm.listCommande}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Intitulé du BCI","width":"280"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,false,3209936872)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mode","label":"Mode","width":"280"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"blue accent-3"}},[_vm._v(_vm._s(scope.row.mode)+"\n                                    ")])]}}],null,false,4160721882)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleTrx","label":"Projet/Chantier/Travaux","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fournisseurNom","label":"Fournisseur","width":"280"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"info","label":"","color":"info"}},[_vm._v(_vm._s(scope.row.fournisseurNom))])]}}],null,false,2667407144)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"priorite","label":"Priorite","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.priorite === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"green accent-3"}},[_vm._v("\n                                      Faible\n                                    ")]):(scope.row.priorite === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"orange accent-4"}},[_vm._v("\n                                      Normal\n                                    ")]):(scope.row.priorite === 3)?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"red accent-3"}},[_vm._v("\n                                      Urgent\n                                    ")]):_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"blue lighten-4"}},[_vm._v("\n                                      Aucune\n                                    ")])]}}],null,false,2147302162)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateLivr","label":"Date livraison souhaitée","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                      "+_vm._s(scope.row.dateLivr)+"\n                                    ")])]}}],null,false,3363531623)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user","label":"Emis par","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                      "+_vm._s(scope.row.user)+"\n                                    ")])]}}],null,false,627670851)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showCommande(scope.row,false)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("Détails\n                                      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerCommande(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                                        Imprimer\n                                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(
                                            _vm.droitAcces.delete_option_commande
                                          )?_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(
                                          scope.row.valid === 3                                                                                              
                                          ),expression:"\n                                          scope.row.valid === 3                                                                                              \n                                          "}],attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogCOmmande = true;
                                            _vm.idCommande = scope.row;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("Supprimer\n                                      ")],1)],1)]}}],null,false,2767081738)})],1)],1)],2)],1)],1)],1)],1)],1)],1):_vm._e()],1)],1)],1)],1)])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogBesoin),callback:function ($$v) {_vm.dialogBesoin=$$v},expression:"dialogBesoin"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter des besoins")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification du besoin")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogBesoin = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n            DETAILS ASSOCIE AU BESOIN\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticStyle:{"margin-top":"20px"}},[_c('el-radio-group',{attrs:{"size":"mini"},model:{value:(_vm.typeDmd),callback:function ($$v) {_vm.typeDmd=$$v},expression:"typeDmd"}},[_c('el-radio-button',{attrs:{"label":"Projet"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"Carburant"}})],1)],1)])],1),_vm._v(" "),_c('v-form',{ref:"formBesoin",attrs:{"lazy-validation":"","id":"formBesoin"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeDmd == 'Projet' || _vm.typeDmd == 'Carburant'),expression:"typeDmd == 'Projet' || typeDmd == 'Carburant'"}],attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Intitulé  "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"itituleBci"},model:{value:(_vm.itituleBci),callback:function ($$v) {_vm.itituleBci=$$v},expression:"itituleBci"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Type de Projet"},on:{"change":function($event){return _vm.loadChantier()}},model:{value:(_vm.projetS),callback:function ($$v) {_vm.projetS=$$v},expression:"projetS"}},_vm._l((_vm.listeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chantier concerné "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Chantier concerné"},on:{"change":function($event){return _vm.loadTravaux()}},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Travaux"},on:{"change":function($event){return _vm.loadTacheTrx()}},model:{value:(_vm.travauxS),callback:function ($$v) {_vm.travauxS=$$v},expression:"travauxS"}},_vm._l((_vm.listeTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tâches "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","multiple":"","placeholder":"Tache"},model:{value:(_vm.tacheS),callback:function ($$v) {_vm.tacheS=$$v},expression:"tacheS"}},_vm._l((_vm.listeTacheTrx),function(item){return _c('el-option',{key:item.idOptTrx,attrs:{"label":item.libelle,"value":item.idOptTrx}})}),1)],1)])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"78%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowEditRessource),callback:function ($$v) {_vm.dialogShowEditRessource=$$v},expression:"dialogShowEditRessource"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Modifier les produits de la tâche\n                      "+_vm._s(_vm.tacheSelectioner.libelleTrx))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialogShowEditRessource = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('el-form',{ref:"formEditRessource",staticClass:"demo-form-inline",attrs:{"id":"formEditRessource","label-width":"90px","model":_vm.formEditRessource}},[_vm._l((_vm.optionBesoin),function(besoin,index){return _c('v-layout',{key:besoin.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Code analytique")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"codeAnalytique","prop":'optionBesoin.' + index+ '.codeAnalytique',"placeholder":"Code analytique"},model:{value:(besoin.codeAnalytique),callback:function ($$v) {_vm.$set(besoin, "codeAnalytique", $$v)},expression:"besoin.codeAnalytique"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Code gestion")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"codeGestion","prop":'optionBesoin.' + index+ '.codeGestion',"placeholder":"Code gestion"},model:{value:(besoin.codeGestion),callback:function ($$v) {_vm.$set(besoin, "codeGestion", $$v)},expression:"besoin.codeGestion"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":"","ml-2":"","mr-2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ressource")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"produit","disabled":"","prop":'optionBesoin.' + index+ '.produit',"placeholder":"Ressource"},model:{value:(besoin.produit),callback:function ($$v) {_vm.$set(besoin, "produit", $$v)},expression:"besoin.produit"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","value":"qte","placeholder":"Quantité","prop":'optionBesoin.' + index+ '.qte'},model:{value:(besoin.qte),callback:function ($$v) {_vm.$set(besoin, "qte", $$v)},expression:"besoin.qte"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":"","ml-2":"","mr-2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité")]),_vm._v(" "),_c('el-input',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"trigger-on-focus":true,"prop":'optionBesoin.' + index+ '.qte',"readonly":true},model:{value:(besoin.unite),callback:function ($$v) {_vm.$set(besoin, "unite", $$v)},expression:"besoin.unite"}})],1)])],1)}),_vm._v(" "),(_vm.tacheSelectioner.type == 'VEHCIULE/ENGIN' ||
                                        _vm.tacheSelectioner.type == 'Vehicule')?_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"required":"","label":"Date debut"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"date","name":"dateD"},model:{value:(_vm.formEditRessource.dateD),callback:function ($$v) {_vm.$set(_vm.formEditRessource, "dateD", $$v)},expression:"formEditRessource.dateD"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date fin","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"date","name":"dateF"},model:{value:(_vm.formEditRessource.dateF),callback:function ($$v) {_vm.$set(_vm.formEditRessource, "dateF", $$v)},expression:"formEditRessource.dateF"}})],1)],1)],1):_vm._e()],2)],1)])])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.resetFormEditRess()}},slot:"activator"},[_vm._v("\n                        Fermer\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("Fermer\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","disabled":_vm.loading,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.sumbitRessource(_vm.tacheSelectioner)}},slot:"activator"},[_vm._v("\n                        Enregistrer\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1),_vm._v("Enregistrer\n                    ")],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeDmd == 'Magasin chantier'),expression:"typeDmd == 'Magasin chantier'"}],attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Magasin chantier "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Magasin chantier concerné"},model:{value:(_vm.selectDemande),callback:function ($$v) {_vm.selectDemande=$$v},expression:"selectDemande"}},_vm._l((_vm.listDemande),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',[_c('div',{staticClass:"layout row"},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("PK début ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"tranconA"},model:{value:(_vm.tranconA),callback:function ($$v) {_vm.tranconA=$$v},expression:"tranconA"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("PK fin ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"tranconB"},model:{value:(_vm.tranconB),callback:function ($$v) {_vm.tranconB=$$v},expression:"tranconB"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Date le livraison souhaitée "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","id":"dateLivrSouh","type":"date","placeholder":"Choisissez une date de livraison"},model:{value:(_vm.dateLivrSouh),callback:function ($$v) {_vm.dateLivrSouh=$$v},expression:"dateLivrSouh"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('a',{attrs:{"href":_vm.logoDefaut,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[(_vm.imagePdf)?_c('img',{attrs:{"src":_vm.logoPdf,"alt":"avatar"}}):_vm._e(),_vm._v(" "),(!_vm.imagePdf)?_c('img',{attrs:{"src":_vm.logoDefaut,"alt":"avatar"}}):_vm._e()]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('input',{ref:"fileLogo",staticStyle:{"display":"none"},attrs:{"name":"docs","type":"file","accept":"image/*,application/pdf"},on:{"change":_vm.onFileImageLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileLogo.click()}}},[_vm._v("Ajouter un justificatiF "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1)],1)]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md11":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                      "+_vm._s(_vm.typeDmd == 'Carburant' ? 'AJOUTER DES ENGINS' : 'AJOUTER LES LIGNES DE VOTRE BESOIN')+"                    \n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md18":""}},_vm._l((_vm.optionProduit),function(optionP){return _c('v-layout',{key:optionP.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeDmd != 'Carburant'),expression:"typeDmd != 'Carburant'"}],staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de ressource "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":""},on:{"change":function($event){return _vm.loadUniteProduit(optionP.produit)}},model:{value:(optionP.produit),callback:function ($$v) {_vm.$set(optionP, "produit", $$v)},expression:"optionP.produit"}},_vm._l((_vm.listeProduitAffich),function(item){return _c('el-option',{key:item.id,attrs:{"id":item.id,"label":item.value+' / '+item.type,"value":item}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Code analytique "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"valeurCodeAnalytique"},model:{value:(_vm.valeurCodeAnalytique),callback:function ($$v) {_vm.valeurCodeAnalytique=$$v},expression:"valeurCodeAnalytique"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Code gestion "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"valeurCodeGestion"},model:{value:(_vm.valeurCodeGestion),callback:function ($$v) {_vm.valeurCodeGestion=$$v},expression:"valeurCodeGestion"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","min":"1"},model:{value:(optionP.qte),callback:function ($$v) {_vm.$set(optionP, "qte", $$v)},expression:"optionP.qte"}})],1)]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeDmd != 'Carburant'),expression:"typeDmd != 'Carburant'"}],attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"valeurSelect","readonly":true},model:{value:(_vm.valeurUniteMateriel),callback:function ($$v) {_vm.valeurUniteMateriel=$$v},expression:"valeurUniteMateriel"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Priotié "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"priorite","id":"priorite"},model:{value:(optionP.priorite),callback:function ($$v) {_vm.$set(optionP, "priorite", $$v)},expression:"optionP.priorite"}},_vm._l((_vm.priorites),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.label}})}),1)],1)]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"md1":""}},[_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addListInventaire(optionP)}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)}),1),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formInventaire}},[_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableInventaire}},[_c('el-table-column',{attrs:{"prop":"type","label":"Catégorie de ressource","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Type ressource","sortable":""}}),_vm._v(" "),(_vm.typeDmd != 'Carburant')?_c('el-table-column',{attrs:{"prop":"codeAnalytique","label":"Code analytique","sortable":""}}):_vm._e(),_vm._v(" "),(_vm.typeDmd != 'Carburant')?_c('el-table-column',{attrs:{"prop":"codeGestion","label":"Code gestion","sortable":""}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"priorite","label":"Priorité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableInventaire)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                        Supprimer\n                      ")],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogBesoin = false}}},[_vm._v("\n            Annuler\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":_vm.loading,"dark":""},on:{"click":_vm.submitBesoin}},[_vm._v("\n            Enregistrer\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"79%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogComm),callback:function ($$v) {_vm.dialogComm=$$v},expression:"dialogComm"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.hiddenButton)?_c('span',[_vm._v("Généner un nouveau bon de commande interne")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit != true && _vm.hiddenButton != true)?_c('span',[_vm._v("Ajouter une nouvelle commande")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification de la commande")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogComm = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n            DETAILS ASSOCIE A LA COMMANDE\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),(!_vm.hiddenButton)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"indigo","id":"intro","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerListe()}},slot:"activator"},[_vm._v("Info "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("\n              Imprimer la liste des fournisseurs pour ces produits\n              ")],1),_vm._v(" "),(!_vm.hiddenButton)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","id":"intro","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.showDialogComparaison(); _vm.verifPrioriteBesoin();}},slot:"activator"},[_vm._v("Comparer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("compare")])],1),_vm._v("\n              Comparer les prix fournisseurs\n              ")],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-form',{ref:"formComm",attrs:{"lazy-validation":"","id":"formComm"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":!_vm.hiddenButton,"md7":_vm.hiddenButton}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Intitulé de la commande "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Intitulé de la commande"},model:{value:(_vm.libelle),callback:function ($$v) {_vm.libelle=$$v},expression:"libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de livraison "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateLivr","id":"dateLivr","format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de livraison"},model:{value:(_vm.dateLivr),callback:function ($$v) {_vm.dateLivr=$$v},expression:"dateLivr"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Priorité commande")]),_vm._v(" "),_c('el-select',{attrs:{"required":"","placeholder":"Priorite","disabled":_vm.disabledChamp},model:{value:(_vm.priorite),callback:function ($$v) {_vm.priorite=$$v},expression:"priorite"}},_vm._l((_vm.priorites),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),(!_vm.hiddenButton)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mode de commande")]),_vm._v(" "),_c('el-select',{attrs:{"required":"","placeholder":"Mode","disabled":_vm.disabledChamp},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}},_vm._l((_vm.detail),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.label}})}),1)],1)]):_vm._e(),_vm._v(" "),(!_vm.hiddenButton)?_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Fournisseur "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Fournisseur"},on:{"change":_vm.handleChangeFour},model:{value:(_vm.selectFourn),callback:function ($$v) {_vm.selectFourn=$$v},expression:"selectFourn"}},_vm._l((_vm.listFour),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]):_vm._e(),_vm._v(" "),(!_vm.hiddenButton)?_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Numéro dévis / proforma ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"numeroDevis","placeholder":"Numéro dévis / proforma"},model:{value:(_vm.numeroDevis),callback:function ($$v) {_vm.numeroDevis=$$v},expression:"numeroDevis"}})],1)]):_vm._e()],1),_vm._v(" "),(_vm.entrepotLib =='' && _vm.idTravaux !='')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Projet","readonly":true},model:{value:(_vm.projetLib),callback:function ($$v) {_vm.projetLib=$$v},expression:"projetLib"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chantier concerné")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Chantier","readonly":true},model:{value:(_vm.chantieretLib),callback:function ($$v) {_vm.chantieretLib=$$v},expression:"chantieretLib"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Travaux","readonly":true},model:{value:(_vm.travuxLib),callback:function ($$v) {_vm.travuxLib=$$v},expression:"travuxLib"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.entrepotLib !='')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Magasin concerné")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Entrepot","readonly":true},model:{value:(_vm.entrepotLib),callback:function ($$v) {_vm.entrepotLib=$$v},expression:"entrepotLib"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.entrepotLib =='' && _vm.idTravaux =='')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Autre")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":"Autre","placeholder":"AUTRE","readonly":true}})],1)])],1):_vm._e(),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                AJOUTER LES LIGNES DE VOTRE COMMANDE\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),_vm._l((_vm.optionCommande),function(optionCom,index){return _c('v-layout',{key:optionCom.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Code analytique")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"codeAnalytique","placeholder":"Code analytique","readonly":true},model:{value:(optionCom.codeAnalytique),callback:function ($$v) {_vm.$set(optionCom, "codeAnalytique", $$v)},expression:"optionCom.codeAnalytique"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Code gestion")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"codeGestion","placeholder":"Code gestion","readonly":true},model:{value:(optionCom.codeGestion),callback:function ($$v) {_vm.$set(optionCom, "codeGestion", $$v)},expression:"optionCom.codeGestion"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":!_vm.hiddenButton,"md7":_vm.hiddenButton}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ressource")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"produit","placeholder":"Ressource","readonly":true},model:{value:(optionCom.produit),callback:function ($$v) {_vm.$set(optionCom, "produit", $$v)},expression:"optionCom.produit"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité *")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","min":1,"value":"qte","prop":'optionCommande.' + index + '.qte',"placeholder":"Quantité","readonly":!_vm.hiddenButton,"width":"100%"},on:{"change":function($event){return _vm.calculTotalComm(index)}},model:{value:(optionCom.qte),callback:function ($$v) {_vm.$set(optionCom, "qte", $$v)},expression:"optionCom.qte"}})],1)]),_vm._v(" "),(!_vm.hiddenButton)?_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix unitaire *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","value":"prix","placeholder":"Prix","prop":'optionCommande.' + index + '.prix',"readonly":_vm.hiddenButton},model:{value:(optionCom.prix),callback:function ($$v) {_vm.$set(optionCom, "prix", $$v)},expression:"optionCom.prix"}})],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité")]),_vm._v(" "),_c('el-input',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"trigger-on-focus":true,"readonly":true},model:{value:(optionCom.unite),callback:function ($$v) {_vm.$set(optionCom, "unite", $$v)},expression:"optionCom.unite"}})],1)]),_vm._v(" "),(_vm.hiddenButton)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Priorité")]),_vm._v(" "),_c('el-select',{attrs:{"prop":'optionCommande.' + index + '.priorite',"trigger-on-focus":true,"disabled":_vm.disabledChamp},model:{value:(optionCom.priorite),callback:function ($$v) {_vm.$set(optionCom, "priorite", $$v)},expression:"optionCom.priorite"}},_vm._l((_vm.priorites),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]):_vm._e()],1)}),_vm._v(" "),_c('br')],2),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogComm = false}}},[_vm._v("\n            Annuler\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.dialogEdit != true)?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":_vm.loading,"dark":""},on:{"click":_vm.submitComm}},[_vm._v("\n            Enregistrer\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-btn',{attrs:{"icons":"","color":"blue","submitBesoin":"","disabled":_vm.loading,"dark":""},on:{"click":_vm.submitComm}},[_vm._v("\n            Modifier\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('ModalCommandeDetails',{attrs:{"detailCommande":_vm.detailCommande,"hiddenButton":_vm.hiddenButton,"show":_vm.showModalDetailCom},on:{"close":function($event){_vm.showModalDetailCom = false
      _vm.loadCommandeRecent();}}}),_vm._v(" "),_c('ModalCommandeMAJ',{attrs:{"detailCommande":_vm.detailCommande,"show":_vm.showModalModifCom},on:{"close":function($event){_vm.showModalModifCom = false;
      _vm.loadCommandeRecent();
      _vm.loadCommandeRecent()}}}),_vm._v(" "),_c('ModalComparateurCmd',{attrs:{"typeCommande":2,"infOrenseigner":_vm.infOrenseigner,"commandeDeriv":_vm.commandeDeriv,"commandeDerivDeux":_vm.commandeDerivDeux,"mntTotalCmd":_vm.mntTotalCmd,"nbCommandeSug":_vm.nbCommandeSug,"nbCommandeSugDeux":_vm.nbCommandeSugDeux,"show":_vm.showModalCompCmd},on:{"close":function($event){_vm.loadCommandeRecent();
      _vm.showModalCompCmd = false;}}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cet enregistrement ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteBesoin($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogCOmmande),callback:function ($$v) {_vm.dialogCOmmande=$$v},expression:"dialogCOmmande"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cet enregistrement ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogCOmmande = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteCommande($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogImprCommande),callback:function ($$v) {_vm.dialogImprCommande=$$v},expression:"dialogImprCommande"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModeCommande(2)}}},[_vm._v("\n                  Paysage\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModeCommande(1)}}},[_vm._v("\n                  Portrait\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"blue",attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogImprCommande = false}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JtZx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationPost_vue__ = __webpack_require__("KB7Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8632a94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationPost_vue__ = __webpack_require__("vMrS");
function injectStyle (ssrContext) {
  __webpack_require__("4+bD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a8632a94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8632a94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JvN7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('v-dialog',{attrs:{"max-width":"70%","persistent":"","fullscreen":"","hide-overlay":""},model:{value:(_vm.dialogDetailCarte),callback:function ($$v) {_vm.dialogDetailCarte=$$v},expression:"dialogDetailCarte"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v(" Detail de la carte carburant "+_vm._s(_vm.carte.identifiant)+" ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs3":""}},[_c('v-card',[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"large":"","color":"indigo"}},[_vm._v("info")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"green--text"},[_vm._v(_vm._s(_vm.carte.totalCrediter)+"\n                    ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Total credité (Fcfa)")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"indigo"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"red--text"},[_vm._v(_vm._s(_vm.carte.totalDebiter))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Total debité (Fcfa)")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"indigo"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"blue--text"},[_vm._v(_vm._s(_vm.carte.montantFormat))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Solde actuel (Fcfa)")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("IDENTIFIANT")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title orange--text",attrs:{"xs6":""}},[_vm._v("\n                          "+_vm._s(_vm.carte.identifiant)+"\n                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("LIBELLE")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                          "+_vm._s(_vm.carte.libelle)+"\n                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("FOURNISSEUR")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                          "+_vm._s(_vm.carte.station)+"\n                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("ZONE CONCERNEE")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                          "+_vm._s(_vm.carte.zone)+"\n                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("RESPONSABLE")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                          "+_vm._s(_vm.carte.responsable)+"\n                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-1",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("DATE DE CREATION")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                          "+_vm._s(_vm.carte.dateCreated)+"\n                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("ENREGISTRE PAR")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                          "+_vm._s(_vm.carte.userCreated)+"\n                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("MODIFIE PAR")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                          "+_vm._s(_vm.carte.userEdited)+"\n                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Description")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.carte.description,"label":"","placeholder":"","outline":""}})],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":""}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"Approvisionnement","name":"appro"}},[_c('h6',[_vm._v("LISTE DES APPROVISIONNEMENTS")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.rechargementsValider.length))]),_vm._v("\n                        Approvisionnement(s)\n                      ")],1)],1)],1)],1),_vm._v(" "),_c('data-tables',{attrs:{"data":_vm.rechargementsValider}},[_c('el-table-column',{attrs:{"prop":"created","label":"Enregistré le "}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"carteCible","label":"Carte à crediter"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(_vm._s(scope.row.carteCible))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"carteSource","label":"Carte à debiter"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(scope.row.carteSource),expression:"scope.row.carteSource"}],attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.carteSource))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantFormat","label":"Montant (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(scope.row.montantFormat),expression:"scope.row.montantFormat"}],attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.montantFormat))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libStatut","label":"Statut","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.statut == 1)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 2)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v("\n                        "+_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 3)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 4)?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 5)?_c('el-tag',[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateValidation","label":"Date de validation"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"validateur","label":"Validé par"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userCreated","label":"Appro Effectué par"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[(scope.row.statut == 5)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.modalAppro(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("done")])],1):_vm._e(),_vm._v("\n                        Valider l'Approvisionnement\n                      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.statut == 3 && scope.row.imageRecu)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","icons":"","small":"","color":"cyan"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerRecu(scope.row.imageRecu)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("photo")])],1):_vm._e(),_vm._v("\n                        Pièce jointe\n                      ")],1)]}}])})],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Achat","name":"achat"}},[_c('h6',[_vm._v("LISTE DES ACHATS")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.achats.length))]),_vm._v("\n                        Achat(s)\n                      ")],1)],1)],1)],1),_vm._v(" "),_c('data-tables',{attrs:{"data":_vm.achats}},[_c('el-table-column',{attrs:{"prop":"dateCreated","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"station","label":"Station"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantite","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantFormat","label":"Montant (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(scope.row.montantFormat),expression:"scope.row.montantFormat"}],attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.montantFormat))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vehicule","label":"vehicule"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createdUser","label":"Enregistré par"}})],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Transfert","name":"transfert"}},[_c('el-row',{staticClass:"row-bg",attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":18}},[_c('div')]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('div',{staticStyle:{"text-align":"right"}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.modalAjoutTransfert()}},slot:"activator"},[_vm._v("\n                          Transfert\n                          "),_c('v-icon',{attrs:{"center":""}},[_vm._v("add")])],1),_vm._v("\n                        Effectuer une demande de transfert\n                      ")],1)],1)])],1),_vm._v(" "),_c('el-row',{staticClass:"row-bg",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":11}},[_c('el-card',{attrs:{"shadow":"always"}},[_c('div',[_c('h6',[_vm._v("LISTE DES TRANSFERTS EMIS")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.rechargementsEmis.length))]),_vm._v("\n                                Transfert(s)\n                              ")],1)],1)],1)],1),_vm._v(" "),_c('data-tables',{attrs:{"data":_vm.rechargementsEmis}},[_c('el-table-column',{attrs:{"prop":"created","label":"Enregistré le"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"carteCible","label":"Carte creditée","width":"170"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(scope.row.carteCible),expression:"scope.row.carteCible"}],attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.carteCible))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantFormat","label":"Montant(Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(scope.row.montantFormat),expression:"scope.row.montantFormat"}],attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.montantFormat))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libStatut","label":"Statut","width":"170"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.statut == 0)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 1)?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v("\n                                "+_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 2)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 3)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 4)?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 5)?_c('el-tag',[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"validateur","label":"Validé par","width":"170"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateValidation","label":"Date de validation","width":"170"}})],1)],1)])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-card',{attrs:{"shadow":"always"}},[_c('div',[_c('h6',[_vm._v("LISTE DES TRANSFERTS DE CARTE RECUS")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.rechargementsRecus.length))]),_vm._v("\n                                Transfert(s)\n                              ")],1)],1)],1)],1),_vm._v(" "),_c('data-tables',{attrs:{"data":_vm.rechargementsRecus}},[_c('el-table-column',{attrs:{"prop":"created","label":"Enregistré le"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"carteSource","label":"Carte debitée"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(scope.row.carteSource),expression:"scope.row.carteSource"}],attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.carteSource))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantFormat","label":"Montant(Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(scope.row.montantFormat),expression:"scope.row.montantFormat"}],attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.montantFormat))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"zone","label":"Zone de la carte"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"validateur","label":"Validé par"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateValidation","label":"Date de validation"}})],1)],1)])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-4 mt-4"}),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-card',{attrs:{"shadow":"always"}},[_c('h6',[_vm._v("LISTE DES TRANSFERTS EN ATTENTE")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.rechargementsAttente.length))]),_vm._v("\n                              Carte(s)\n                            ")],1)],1)],1)],1),_vm._v(" "),_c('data-tables',{attrs:{"data":_vm.rechargementsAttente}},[_c('el-table-column',{attrs:{"prop":"created","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"carteSource","label":"Carte concernée"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(scope.row.carteSource),expression:"scope.row.carteSource"}],attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.carteSource))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantFormat","label":"Montant(Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(scope.row.montantFormat),expression:"scope.row.montantFormat"}],attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.montantFormat))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createdUser","label":"Initiateur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.modalValideTransfert(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("done")])],1),_vm._v("\n                              Valider ou rejeter le transfert\n                            ")],1)]}}])})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogAddAppro),callback:function ($$v) {_vm.dialogAddAppro=$$v},expression:"dialogAddAppro"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Voulez-vous approvisionner la carte\n        "+_vm._s(_vm.carte.identifant)+" ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Confirmation d'un approvisionnement","description":"Après la validation, l'approvisionnement ne pourra pas etre modifié, ni supprimé .","closable":false,"show-icon":"","type":"warning"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{ref:"formFiche",staticClass:"demo-form-inline",attrs:{"id":"formFiche","model":_vm.formFiche,"rules":_vm.ruleFiche}},[_c('el-form-item',{attrs:{"label":"Montant","prop":"montant"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":true,"min":1,"name":"montant","placeholder":"saisir un montant"},model:{value:(_vm.formFiche.montant),callback:function ($$v) {_vm.$set(_vm.formFiche, "montant", $$v)},expression:"formFiche.montant"}})],1),_vm._v(" "),_c('el-form-item',[_c('v-flex',{staticClass:"mr-1",attrs:{"xs12":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.image1,"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"file1",staticStyle:{"display":"none"},attrs:{"name":"image1","type":"file","accept":"image/*"},on:{"change":_vm.onFileImage1Picked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.file1.click()}}},[_vm._v("Pièce jointe\n                      "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('div',{staticClass:"font-weight-thin"},[_vm._v("\n                      Fichier au format (JPEG,PNG,PDF) avec une taille de 1048\n                      ko maximale\n                    ")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogAddAppro = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},on:{"click":function($event){return _vm.submitAppro('formFiche')}}},[_vm._v("Confirmer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done_all")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogValideTransfert),callback:function ($$v) {_vm.dialogValideTransfert=$$v},expression:"dialogValideTransfert"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Voulez-vous valider ou rejeter le transfert de la carte\n        "+_vm._s(_vm.carte.identifant)+" ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Confirmation d'un transfert","description":'Après la validation, le transfert ne pourra pas être modifié, ni supprimé, Veuillez confirmer  le montant suivant:  ' +
                  _vm.montantTransfert +
                  ' Fcfa',"closable":false,"show-icon":"","type":"warning"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{ref:"formFiche",staticClass:"demo-form-inline"},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Motif du rejet"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Pourquoi voulez-vous rejeter le tranfert ?"},model:{value:(_vm.motifRejetTransfert),callback:function ($$v) {_vm.motifRejetTransfert=$$v},expression:"motifRejetTransfert"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogValideTransfert = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"red darken-1","disabled":_vm.motifRejetTransfert == ''},on:{"click":function($event){return _vm.submitValideTransfert('refuser')}}},[_vm._v("Rejeter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done_all")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},on:{"click":function($event){return _vm.submitValideTransfert('valider')}}},[_vm._v("Valider "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done_all")])],1)],1)],1)],1),_vm._v(" "),_c('AjoutTransfertCarte',{attrs:{"editRecharge":_vm.editTransfert,"carte":_vm.carte,"show":_vm.showModalAjoutTransfert},on:{"close":function($event){_vm.showModalAjoutTransfert = false;
      _vm.loadTransfertEmis();}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K4PS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VehiculeBesoin_vue__ = __webpack_require__("HTxj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b0b6e10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VehiculeBesoin_vue__ = __webpack_require__("u4uD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VehiculeBesoin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b0b6e10_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VehiculeBesoin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KB7Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */] },
  name: "ModalValidationPost",
  props: ["show", "detailCommande", "totalMontant"],
  data: function data() {
    var _ref;

    return _ref = {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      dialogDetail: false,
      listeTacheSupp: [],
      dialogSupr: false,
      index: '',
      indexRow: '',
      indexLigne: '',
      indexRowLigne: '',
      dialogVisible: false,
      dialogConfirmRefus: false,
      logoPdf: "/static/pdf.png",
      dialogConfirm: false,
      formRefus: {},
      items: []
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "index", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "urlImage", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "ruleFormRefus", {
      rapportRefus: [{ required: true, message: "Veuillez saisir" }]
    }), _ref;
  },


  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogDetail = newValue;
      this.urlImage = this.detailCommande.urlImage;
      console.log("detailCommande", this.detailCommande);

      if (newValue == true) {
        //this.loadDevisConstat()
      }
    }
  },

  methods: {
    successNotif: function successNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      this.$notify({
        title: "ENREGISTREMENT REUSSI",
        message: mess,
        type: "success",
        position: "top-center"
      });
    },
    showDiapo: function showDiapo(images, ind, image) {
      this.items = images;
      this.index = ind;
    },
    closeDialog: function closeDialog() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      console.log("item", item);
      if (item == "images") {
        this.index = null;
      } else {
        this.$emit("close", this.detailCommande.id, "bonCommandeInterne");
      }
    },
    deleteBesoin: function deleteBesoin() {
      this.this.listeTacheSupp = [];
      if (this.detailCommande.option[this.indexLigne].id != null) {
        this.listeTacheSupp.push(this.detailCommande.option[this.indexLigne].id);
      }
      this.indexRowLigne.splice(this.indexLigne, 1);
      this.dialogSupr = false;
    },
    deleteRow: function deleteRow(index, rows) {
      this.indexLigne = index;
      this.indexRowLigne = rows;
    },
    SubmitValideDevis: function SubmitValideDevis(item) {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "besoin/avalider/bci/nivau2";

      var data = new FormData();
      data.append("decision", item == "confirme" ? 1 : 0);
      data.append("commDec", this.formRefus.rapport);
      data.append("idUser", this.user.id);
      data.append("bci", this.detailCommande.id);
      data.append("listeSupp", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.listeTacheSupp));
      // on recupere le tableau
      for (var prop in this.detailCommande.option) {
        var ligne = this.detailCommande.option[prop];
        data.append("options[id][]", ligne.id);
        data.append("options[qte][]", ligne.qte);
      }
      this.$http.post(url, data).then(function (response) {
        _this.loading = false;
        _this.dialogConfirmRefus = false;
        _this.dialogConfirm = false;
        _this.formRefus.rapport = "";
        _this.successNotif(response.body.message);
        _this.closeDialog();
      }, function (errResp) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors de la validation de la mission");
      });
    },
    SubmitRefusDevis: function SubmitRefusDevis() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "besoin/avalider/bci/nivau2";
      var data = new FormData();
      data.append("decision", item == "confirme" ? 1 : 0);
      data.append("commDec", this.formRefus.rapport);
      data.append("bci", this.detailCommande.id);
      data.append("user", this.user.id);

      this.$http.post(url, data).then(function (response) {
        _this2.loading = false;
        _this2.successNotif(response.body.message);
        _this2.dialogConfirmRefus = false;
        _this2.closeDialog();
      }, function (errResp) {
        _this2.loading = false;
        _this2.$message.error("Une erreur est survenue lors du refus de la demande de mission");
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "KOsr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//var echarts = require('echarts/lib/echarts')
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Vb+l");
__webpack_require__("Oq2I");
__webpack_require__("miEh");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
    name: "facturePaiement",
    data: function data() {
        return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            loading: false,

            formTri: {},
            listeFournisseur: [],
            listeEtat: [{
                value: 0,
                label: "Impayé"
            }, {
                value: 1,
                label: "Payé"
            }, {
                value: 2,
                label: "En attente"
            }, {
                value: 3,
                label: "En cours"
            }],
            showFactureStat: false,
            multipleSelection: [],
            liteFacture: [],
            desactiveBout: false,
            dialogMontantFacture: false,
            disabledBtnValide: true,
            libeleRechFacture: "10 DERNIERES FACTURES",
            dialogValideFacture: false,
            listeFactureSelect: [],
            dialogShowFacture: false,
            validPaiem: false,
            idFournisseur: '',
            detailFacture: {},
            totalComHT: 0,
            totalTTC: 0,
            qteLivre: 0,
            qteRestant: 0,
            totalComTVA: 0,
            totalComRemise: 0,
            nbCommande: 0,
            montantTotal: 0,
            montantVerse: 0,
            monVerse: 0,
            nbLivraison: 0,
            dataCommande: {},
            dataFactHisto: {},
            dataNbFact: {},
            dataMntFact: []

        };
    },


    methods: {
        handleSelectionChange: function handleSelectionChange(val) {
            var _this = this;

            var factNull = false;
            //trier les factures dont le montants restant est superieurs a 0
            var dataFact = val.filter(function (elt, index) {
                if (elt.mntRestant <= 0) {
                    _this.$refs.multipleTableFact.toggleRowSelection(elt);
                    factNull = true;
                }
                return elt.mntRestant > 0;
            });

            this.multipleSelection = dataFact;
            if (this.multipleSelection.length === 0) {
                this.disabledBtnValide = true;
            } else {
                this.disabledBtnValide = false;
            }

            if (factNull == true) {
                this.$message({
                    message: "Attention, vous ne pouvez selectionner que des factures dont le montant restant est  supérieur à 0 et non-autorisé",
                    type: 'warning',
                    duration: 5000
                });
            }
        },
        headerRowStyle: function headerRowStyle(_ref) {
            var row = _ref.row,
                rowIndex = _ref.rowIndex;

            return { "color": "black" };
        },
        validFacture: function validFacture() {
            var _this2 = this;

            this.loading = true;
            this.validPaiem = false;
            var formdata = new FormData();
            var data = {
                "listeFactures": this.listeFactureSelect,
                "user": this.user.id,
                "idFournisseur": this.idFournisseur
            };
            var url = this.domaine + 'facture/validation/paiement';
            formdata.append("user", this.user.id);
            //formdata.append("listeFactures", JSON.stringify(this.listeFactureSelect));
            this.$http.get(url, { params: data }).then(function (response) {
                _this2.dialogValideFacture = false;
                _this2.loadfacture();
                _this2.loading = false;
                _this2.$notify({
                    title: "Validation facture",
                    message: "L'opération s'est déroulée avec succès",
                    type: "success",
                    position: "top-center"
                });
            }, function (error) {
                _this2.dialogValideFacture = false;
                _this2.loading = false;
                _this2.$message.error("Echec lors de la validation, verifiez votre connexion");
            });
        },
        showDetailFacture: function showDetailFacture(item) {
            var _this3 = this;

            this.idFournisseur = item.idfournisseur;
            this.loading = true;
            var url = this.domaine + 'fournisseur/' + item.idFact + '/show/facture';
            this.$http.get(url).then(function (response) {

                _this3.detailFacture = response.body.facture;

                //on recupere la liste des livraison
                var tabLivraison = _this3.detailFacture.livre;
                var qteR = 0;
                var qteL = 0;
                for (var element in tabLivraison) {
                    var _item = tabLivraison[element];
                    qteL += _item.qteL;
                    qteR += _item.qteR;
                }
                _this3.qteLivre = qteL;
                _this3.qteRestant = qteR + qteL;
                var totalHT = 0;
                var totalTTC = 0;
                var totalTVA = 0;
                var totalRemise = 0;
                var optionFactures = _this3.detailFacture.option;
                for (var option in optionFactures) {
                    var tmpTotalHTSRem = parseFloat(optionFactures[option].prix * optionFactures[option].qte);
                    var mntRemise = 0;
                    var remise = parseFloat(optionFactures[option].remise);
                    if (remise > 0) {
                        mntRemise = tmpTotalHTSRem * remise / 100;
                    }
                    var tmpTotalHT = tmpTotalHTSRem - mntRemise;
                    var tva = parseFloat(optionFactures[option].tva);
                    var tmpTotalTVA = tmpTotalHT * (tva / 100);
                    totalTVA += tmpTotalTVA;
                    totalHT += tmpTotalHT;
                    totalRemise += mntRemise;
                }
                _this3.totalComHT = new Intl.NumberFormat().format(totalHT);
                _this3.totalComTVA = new Intl.NumberFormat().format(totalTVA);
                _this3.totalComRemise = new Intl.NumberFormat('fr-Fr').format(totalRemise);
                _this3.dialogShowFacture = true;
                _this3.totalTTC = totalHT + totalTVA;
                _this3.loading = false;
            }, function (error) {
                _this3.loading = false;
                _this3.$message.error("Echec lors Chargement detail facture, verifiez votre connexion");
            });
        },
        imprimeFacturePDF: function imprimeFacturePDF() {
            //  let tab = []
            //     this.listeDoc.forEach((element) => {
            //         tab.push(element.idDoc)
            //     })
            var url = this.domaine + 'facture/imprimer_facture_pdf/liste';
            window.open(url);
        },
        loadFournisseur: function loadFournisseur() {
            var _this4 = this;

            this.loading = true;
            var url = this.domaine + 'fournisseur/index';
            this.$http.get(url).then(function (response) {

                _this4.listeFournisseur = response.body.fournisseur;
                _this4.loading = false;
            }, function (err) {
                _this4.loading = false;
                _this4.$message.error("Echec lors Chargement liste fournisseurs, verifiez votre connexion");
            });
        },
        loadfacture: function loadfacture() {
            var _this5 = this;

            this.loading = true;
            var url = this.domaine + 'facture/paiement';

            this.$http.get(url).then(function (response) {

                _this5.liteFacture = response.body.factures;
                _this5.libeleRechFacture = response.body.libRecherche;
                _this5.loading = false;
            }, function (err) {
                _this5.loading = false;
                _this5.$message.error("Echec lors Chargement des factures, verifiez votre connexion");
            });
        },
        rechercheFacture: function rechercheFacture() {
            var _this6 = this;

            this.loading = true;

            var url = this.domaine + 'facture/recherche';
            var data = {
                periode: this.formTri.periode,
                fournisseur: this.formTri.fournisseur,
                etat: this.formTri.etat,
                montant: this.formTri.montant
            };

            this.$http.get(url, { params: data }).then(function (response) {
                _this6.liteFacture = response.body.factures;
                _this6.idFournisseur = _this6.liteFacture.idfournisseur;
                _this6.libeleRechFacture = response.body.libRecherche;
                _this6.loading = false;
            }, function (err) {
                _this6.loading = false;
                _this6.$message.error("Chargement des factures, verifier votre connexion");
            });
        },
        modalConfirmeMontant: function modalConfirmeMontant(item) {
            var total = 0;
            for (var prop in item) {
                var ligne = item[prop];
                total += ligne.mntTotal;
            }

            this.montantTotal = total;
            // this.listeFactureSelect = this.multipleSelection.slice();
            this.dialogMontantFacture = true;
        },
        modalValideFacture: function modalValideFacture() {
            this.listeFactureSelect = this.multipleSelection.slice();
            this.dialogValideFacture = true;
        },
        getSommeFact: function getSommeFact(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 1) {
                    sums[index] = "Total";
                    return;
                }

                if (index === 3 || index === 4 || index === 6) {
                    sums[index] = "N/A";
                    return;
                }
                var values = data.map(function (item) {
                    return Number(item[column.property]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0));
                } else {
                    sums[index] = "N/A";
                }
            });
            return sums;
        },
        statDepenseAn: function statDepenseAn(dataFactHisto) {
            var posList = ['left', 'right', 'top', 'bottom', 'inside', 'insideTop', 'insideLeft', 'insideRight', 'insideBottom', 'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'];

            app.configParameters = {
                rotate: {
                    min: -90,
                    max: 90
                },
                align: {
                    options: {
                        left: 'left',
                        center: 'center',
                        right: 'right'
                    }
                },
                verticalAlign: {
                    options: {
                        top: 'top',
                        middle: 'middle',
                        bottom: 'bottom'
                    }
                },
                position: {
                    options: echarts.util.reduce(posList, function (map, pos) {
                        map[pos] = pos;
                        return map;
                    }, {})
                },
                distance: {
                    min: 0,
                    max: 100
                }
            };

            app.config = {
                rotate: 90,
                align: 'left',
                verticalAlign: 'middle',
                position: 'insideBottom',
                distance: 15,
                onChange: function onChange() {
                    var labelOption = {
                        normal: {
                            rotate: app.config.rotate,
                            align: app.config.align,
                            verticalAlign: app.config.verticalAlign,
                            position: app.config.position,
                            distance: app.config.distance
                        }
                    };
                    myChart.setOption({
                        series: [{
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }]
                    });
                }
            };

            var labelOption = {
                show: true,
                position: app.config.position,
                distance: app.config.distance,
                align: app.config.align,
                verticalAlign: app.config.verticalAlign,
                rotate: app.config.rotate,
                formatter: '{c}  {name|{a}}',
                fontSize: 16,
                rich: {
                    name: {
                        textBorderColor: '#fff'
                    }
                }
            };

            var option = {
                color: ['#388E3C', '#F57C00', '#455A64', '#C62828'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {},
                toolbox: {
                    show: true,
                    orient: 'vertical',
                    left: 'right',
                    top: 'center',
                    feature: {
                        mark: { show: true },
                        dataView: { show: true, readOnly: false },
                        magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
                        restore: { show: true },
                        saveAsImage: { show: true }
                    }
                },
                xAxis: [{
                    type: 'category',
                    axisTick: { show: false },
                    data: []
                }],
                yAxis: [{
                    type: 'value'
                }],
                series: [{
                    name: 'Payé',
                    type: 'bar',
                    barGap: 0,
                    label: labelOption,
                    data: []
                }, {
                    name: 'En cours',
                    type: 'bar',
                    label: labelOption,
                    data: []
                }, {
                    name: 'En attente',
                    type: 'bar',
                    label: labelOption,
                    data: []
                }, {
                    name: 'Impayé',
                    type: 'bar',
                    label: labelOption,
                    data: []
                }]
            }; //option


            for (var datahis in dataFactHisto) {
                option.xAxis[0].data.push(datahis);
                var series = dataFactHisto[datahis];

                option.series[0].data.push(series["paye"]);
                option.series[1].data.push(series["cours"]);
                option.series[2].data.push(series["attente"]);
                option.series[3].data.push(series["impaye"]);
            }

            //this.dataFactHisto.forEach(function(element) {
            //optionDepense.xAxis[0].data.push(element.date);
            //optionDepense.series[0].data.push(element.montant)
            //})

            var chartFactureAn = echarts.init(document.getElementById('chartFactureAn'));
            chartFactureAn.setOption(option);
        },
        statFacture: function statFacture(dataNbFact) {
            var posList = ['left', 'right', 'top', 'bottom', 'inside', 'insideTop', 'insideLeft', 'insideRight', 'insideBottom', 'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'];

            app.configParameters = {
                rotate: {
                    min: -90,
                    max: 90
                },
                align: {
                    options: {
                        left: 'left',
                        center: 'center',
                        right: 'right'
                    }
                },
                verticalAlign: {
                    options: {
                        top: 'top',
                        middle: 'middle',
                        bottom: 'bottom'
                    }
                },
                position: {
                    options: echarts.util.reduce(posList, function (map, pos) {
                        map[pos] = pos;
                        return map;
                    }, {})
                },
                distance: {
                    min: 0,
                    max: 100
                }
            };

            app.config = {
                rotate: 90,
                align: 'left',
                verticalAlign: 'middle',
                position: 'insideBottom',
                distance: 15,
                onChange: function onChange() {
                    var labelOption = {
                        normal: {
                            rotate: app.config.rotate,
                            align: app.config.align,
                            verticalAlign: app.config.verticalAlign,
                            position: app.config.position,
                            distance: app.config.distance
                        }
                    };
                    myChart.setOption({
                        series: [{
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }]
                    });
                }
            };

            var labelOption = {
                show: true,
                position: app.config.position,
                distance: app.config.distance,
                align: app.config.align,
                verticalAlign: app.config.verticalAlign,
                rotate: app.config.rotate,
                formatter: '{c}  {name|{a}}',
                fontSize: 16,
                rich: {
                    name: {
                        textBorderColor: '#fff'
                    }
                }
            };

            var option = {

                title: {
                    text: "Statistique Nb facture",
                    left: 'left',

                    textStyle: {
                        color: '#000,'
                    }
                },

                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: []
                },

                series: [{
                    name: 'Nb Facture(s)',
                    type: 'pie',
                    radius: '75%',
                    center: ['50%', '50%'],
                    color: ["#388E3C", "#D32F2F", "#455A64", "#F57C00", "#00BCD4"],
                    data: [
                        // {value: 335, name: '直接访问'},
                    ]
                }]
            };

            for (var dataFact in dataNbFact) {
                //let series = this.dataNbFact[dataFact]

                option.series[0].data.push({ value: dataNbFact[dataFact], name: dataFact });
            }

            var chartFacture = echarts.init(document.getElementById('chartFacture'));
            chartFacture.setOption(option);
        },
        statCommande: function statCommande(dataCommande) {
            var posList = ['left', 'right', 'top', 'bottom', 'inside', 'insideTop', 'insideLeft', 'insideRight', 'insideBottom', 'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'];

            app.configParameters = {
                rotate: {
                    min: -90,
                    max: 90
                },
                align: {
                    options: {
                        left: 'left',
                        center: 'center',
                        right: 'right'
                    }
                },
                verticalAlign: {
                    options: {
                        top: 'top',
                        middle: 'middle',
                        bottom: 'bottom'
                    }
                },
                position: {
                    options: echarts.util.reduce(posList, function (map, pos) {
                        map[pos] = pos;
                        return map;
                    }, {})
                },
                distance: {
                    min: 0,
                    max: 100
                }
            };

            app.config = {
                rotate: 90,
                align: 'left',
                verticalAlign: 'middle',
                position: 'insideBottom',
                distance: 15,
                onChange: function onChange() {
                    var labelOption = {
                        normal: {
                            rotate: app.config.rotate,
                            align: app.config.align,
                            verticalAlign: app.config.verticalAlign,
                            position: app.config.position,
                            distance: app.config.distance
                        }
                    };
                    myChart.setOption({
                        series: [{
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }, {
                            label: labelOption
                        }]
                    });
                }
            };

            var labelOption = {
                show: true,
                position: app.config.position,
                distance: app.config.distance,
                align: app.config.align,
                verticalAlign: app.config.verticalAlign,
                rotate: app.config.rotate,
                formatter: '{c}  {name|{a}}',
                fontSize: 16,
                rich: {
                    name: {
                        textBorderColor: '#fff'
                    }
                }
            };

            var optionComd = {
                title: {
                    text: 'Statistique des commandes',
                    subtext: '',
                    left: 'left'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: []
                },
                series: [{
                    name: ['Commande(s)'],
                    type: 'pie',
                    radius: '75%',
                    center: ['50%', '60%'],
                    color: ["#26A69A", "#FF7043"],
                    data: [
                        //{value: 1548, name: '搜索引擎'}
                    ],
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }]
            };

            for (var dataCom in dataCommande) {

                //let series = this.dataCommande[dataCom]

                optionComd.series[0].data.push({ value: dataCommande[dataCom], name: dataCom });
            }

            this.nbCommande = dataCommande["commande"];
            this.nbLivraison = dataCommande["livraison"];

            var chartCommande = echarts.init(document.getElementById('chartCommande'));
            chartCommande.setOption(optionComd);
        },
        loadAllDataCommandeStat: function loadAllDataCommandeStat() {
            var _this7 = this;

            this.loading = true;
            var url = this.domaine + 'facture/stat/general';

            this.$http.get(url).then(function (response) {
                _this7.dataCommande = response.body.dataCommande;
                _this7.statCommande(_this7.dataCommande);
                _this7.loading = false;
            }, function (error) {
                _this7.loading = false;
            });
        },


        //STATISTIQUE FACTURE
        loadAllDataFactAn: function loadAllDataFactAn() {
            var _this8 = this;

            this.loading = true;
            var url = this.domaine + 'facture/stathisto';

            this.$http.get(url).then(function (response) {
                _this8.dataFactHisto = response.body.dataFacture;
                _this8.dataNbFact = response.body.dataNbFact;
                _this8.dataMntFact = response.body.dataMntFacture;

                _this8.statDepenseAn(_this8.dataFactHisto);
                _this8.statFacture(_this8.dataNbFact);
                _this8.loading = false;
            }, function (error) {
                _this8.loading = false;
            });
        }
    },

    mounted: function mounted() {
        this.loadfacture();
        this.loadFournisseur();
        this.loadAllDataCommandeStat();
        this.loadAllDataFactAn();
    }
});

/***/ }),

/***/ "KUzu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      loading: false,
      domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
      user: JSON.parse(sessionStorage.getItem('userInfo')),
      headersRequestValid: [{ text: 'Numero', align: 'center', sortable: true, value: '' }, { text: 'Demandeur', align: 'center', value: '' }, { text: 'Date', align: 'center', value: '' }, { text: 'Actions', align: 'center', value: '' }],
      headersDevisValid: [{ text: 'Numero', align: 'center', sortable: true, value: '' }, { text: 'Demandeur', align: 'center', value: '' }, { text: 'Date', align: 'center', value: '' }, { text: 'Actions', align: 'center', value: '' }],
      searchRequest: '',
      searchDevis: '',
      modalValidation: false,
      idDemande: '',
      paginationRequestValid: {},
      paginationDevisValid: {},
      listRequestValid: [],
      listDevisValid: []
    };
  },

  computed: {
    pagesRequest: function pagesRequest() {
      return this.paginationRequestValid.rowsPerPage ? Math.ceil(this.listRequestValid.length / this.paginationRequestValid.rowsPerPage) : 0;
    },
    pagesDevis: function pagesDevis() {
      return this.paginationDevisValid.rowsPerPage ? Math.ceil(this.listDevisValid.length / this.paginationDevisValid.rowsPerPage) : 0;
    }
  },
  methods: {
    loadPage: function loadPage() {
      var loading = this.$loading({
        lock: true,
        text: 'Veuillez patientez ...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(function () {
        loading.close();
      }, 1000);
    },
    validRequest: function validRequest(item) {
      this.idDemande = item.id;
      this.modalValidation = true;
    },
    accepterDemande: function accepterDemande() {
      var _this = this;

      var formdata = new FormData();
      formdata.append('user', this.user.id);
      var url = this.domaine + '/action-validate/' + this.idDemande;
      var request = new XMLHttpRequest();
      request.open('post', url);
      request.send(formdata);
      request.onreadystatechange = function () {
        var verif = JSON.parse(request.responseText);
        if (request.readyState === request.DONE) {
          if (request.status === 200) {
            if (verif[0].code === 1) {
              _this.$notify({
                title: 'LA DEMANDE A BIEN ETE VALIDEE',
                message: 'VALIDATION réussie avec succès.',
                type: 'success',
                position: 'top-center'
              });
              _this.modalValidation = false;
              _this.listRequestValid = verif[1];
            } else {
              _this.modalValidation = true;
              _this.$message.error("une erreur s'est produit lors de la validation");
            }
          }
        }
      };
    },
    refuserDemande: function refuserDemande() {
      var _this2 = this;

      var formdata = new FormData();
      formdata.append('user', this.user.id);
      var url = this.domaine + '/action-refuser/' + this.idDemande;
      var request = new XMLHttpRequest();
      request.open('post', url);
      request.send(formdata);
      request.onreadystatechange = function () {
        var verif = JSON.parse(request.responseText);
        if (request.readyState === request.DONE) {
          if (request.status === 200) {
            if (verif[0].code === 1) {
              _this2.$notify({
                title: 'LA DEMANDE A BIEN ETE REFUSEE',
                message: 'ACTION réussie avec succès.',
                type: 'success',
                position: 'top-center'
              });
              _this2.modalValidation = false;
              _this2.listRequestValid = verif[1];
            } else {
              _this2.modalValidation = true;
              _this2.$message.error("une erreur s'est produit lors de la validation");
            }
          }
        }
      };
    },
    validDevis: function validDevis(item) {
      this.idDemande = item.id;
    },
    loadRequest: function loadRequest() {
      var _this3 = this;

      var url = this.domaine + '/request-to-validate/' + this.user.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this3.listRequestValid = response.body;
        }
      });
    },
    loadDevis: function loadDevis() {
      var _this4 = this;

      var url = this.domaine + '/devis-to-validate/' + this.user.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this4.listDevisValid = response.body;
        }
      });
    }
  },
  mounted: function mounted() {
    this.loadPage();
    this.loadRequest();
    this.loadDevis();
  }
});

/***/ }),

/***/ "KfOf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('h3',[_vm._v("Liste des employés")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md12":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){_vm.newUser();_vm.loadService()}},slot:"activator"},[_vm._v("\n                Employé\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v(" Ajouter un employé\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":""},on:{"click":function($event){_vm.dialogListService = true;_vm.loadListService();_vm.loadUser()}},slot:"activator"},[_vm._v("\n                Service\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("list")])],1),_vm._v(" Liste des services\n            ")],1)],1)]),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"model":_vm.formTri}},[_c('el-form-item',{attrs:{"label":"Nom"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"filtrer par nom"},model:{value:(_vm.formTri.nom),callback:function ($$v) {_vm.$set(_vm.formTri, "nom", $$v)},expression:"formTri.nom"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Service"}},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"filtrer par service"},model:{value:(_vm.formTri.service),callback:function ($$v) {_vm.$set(_vm.formTri, "service", $$v)},expression:"formTri.service"}},_vm._l((_vm.listeServices),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Poste"}},[_c('el-select',{attrs:{"clearable":"","placeholder":"filtrer par poste occupé"},model:{value:(_vm.formTri.poste),callback:function ($$v) {_vm.$set(_vm.formTri, "poste", $$v)},expression:"formTri.poste"}},_vm._l((_vm.listePostes),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Contrat"}},[_c('el-select',{attrs:{"clearable":"","placeholder":"filtrer par type contrat"},model:{value:(_vm.formTri.contrat),callback:function ($$v) {_vm.$set(_vm.formTri, "contrat", $$v)},expression:"formTri.contrat"}},_vm._l((_vm.listeTypeContrat),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","color":"blue","fab":"","small":"","disabled":_vm.desactiveBout},on:{"click":function($event){return _vm.rechercheUser()}},slot:"activator"},[_c('v-icon',[_vm._v("search")])],1),_vm._v("Effectuer une recherche\n              ")],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},_vm._l((_vm.listeEmployes),function(employSelect){return _c('v-flex',{attrs:{"xs12":"","md3":"","mb-3":"","pl-2":""}},[_c('modelCarteEmploye',{attrs:{"employe":employSelect},on:{"close":function($event){return _vm.closeListeEmp()},"detailEmpl":_vm.showDetailEmploye}})],1)}),1),_vm._v(" "),_c('modalDetailEmploye',{attrs:{"show":_vm.showDetailEmpl,"userIdContrat":_vm.employSelect},on:{"close":function($event){_vm.showDetailEmpl = false}}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjout),callback:function ($$v) {_vm.dialogAjout=$$v},expression:"dialogAjout"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter un nouvel utilisateur")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjout = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enregistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-form',{ref:"formUser",attrs:{"lazy-validation":"","id":"formUser"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('div',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm4":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoUser,"alt":"avatar"}})]),_c('br'),_vm._v(" "),_c('input',{ref:"fileLogo",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileLogo.click()}}},[_vm._v("Photo  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1)],1)])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-col',[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Matricule","name":"matricule","rules":[function (v) { return !!v || 'Le Matricule est obligatoire'; }],"required":""},model:{value:(_vm.formUser.matricule),callback:function ($$v) {_vm.$set(_vm.formUser, "matricule", $$v)},expression:"formUser.matricule"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Nom et prénoms","name":"nomUser","rules":_vm.nomUserRules,"counter":4,"required":""},model:{value:(_vm.formUser.nomUser),callback:function ($$v) {_vm.$set(_vm.formUser, "nomUser", $$v)},expression:"formUser.nomUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"E-mail","name":"emailUser","rules":_vm.loginUserRules,"counter":6,"required":""},model:{value:(_vm.formUser.emailUser),callback:function ($$v) {_vm.$set(_vm.formUser, "emailUser", $$v)},expression:"formUser.emailUser"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Fonction occupé","name":"fonctionUser","counter":6,"required":""},model:{value:(_vm.formUser.fonctionUser),callback:function ($$v) {_vm.$set(_vm.formUser, "fonctionUser", $$v)},expression:"formUser.fonctionUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"label":"Services","name":"serviceUser","items":_vm.listeServices,"rules":_vm.serviceUserRules,"item-value":"id","item-text":"libelle"},model:{value:(_vm.selectServiceUser),callback:function ($$v) {_vm.selectServiceUser=$$v},expression:"selectServiceUser"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"label":"Genre","name":"genre","items":_vm.listCivilie,"rules":_vm.serviceCiviliteRules,"item-value":"value","item-text":"text"},model:{value:(_vm.selectGenreUser),callback:function ($$v) {_vm.selectGenreUser=$$v},expression:"selectGenreUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"name":"contactUser","min":"0","label":"Contact","counter":10,"rules":_vm.contactUserRules,"hint":"Exemple: 0900000055","persistent-hint":"","required":""},model:{value:(_vm.formUser.contactUser),callback:function ($$v) {_vm.$set(_vm.formUser, "contactUser", $$v)},expression:"formUser.contactUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Adresse","name":"adresse","rules":[function (v) { return !!v || 'Adresse obligatoire'; }],"required":""},model:{value:(_vm.formUser.adresse),callback:function ($$v) {_vm.$set(_vm.formUser, "adresse", $$v)},expression:"formUser.adresse"}})],1)],1)],1)],1)])],1)],1),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md12":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"error","dark":""},on:{"click":function($event){_vm.dialogAjout = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submit}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogService),callback:function ($$v) {_vm.dialogService=$$v},expression:"dialogService"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter un nouveau service")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification du service "+_vm._s(_vm.serviceCourant.libelle)+" ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogService = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingService),expression:"loadingService"}],attrs:{"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-form',{ref:"formService",attrs:{"lazy-validation":"","id":"formService"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-text-field',{attrs:{"label":"Libellé","name":"libelle","rules":_vm.libelleRules,"required":""},model:{value:(_vm.libelle),callback:function ($$v) {_vm.libelle=$$v},expression:"libelle"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-select',{attrs:{"label":"Responsable de service","name":"chef","items":_vm.users,"rules":_vm.chefRules,"item-value":"id","item-text":"nom","chips":"","required":""},model:{value:(_vm.selectChef),callback:function ($$v) {_vm.selectChef=$$v},expression:"selectChef"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogService = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submitService}},[_vm._v("Enrregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShow),callback:function ($$v) {_vm.dialogShow=$$v},expression:"dialogShow"}},[_c('v-card',[_c('v-toolbar',{staticClass:"indigo",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du service "+_vm._s(_vm.detailService.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShow = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"Veuillez patientez ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.detailService.id)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libellé : ")]),_vm._v(" "+_vm._s(_vm.detailService.libelle)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Responsable de service : ")]),_vm._v(" "+_vm._s(_vm.detailService.chef)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Date d'enrégistrement : ")]),_vm._v(" "+_vm._s(_vm.detailService.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailService.modified)+" ")])])],1)],1)])])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"error","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShow = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n          Fermer\n        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editService(_vm.detailService);}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1),_vm._v("\n          Modifier\n        ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogListService),callback:function ($$v) {_vm.dialogListService=$$v},expression:"dialogListService"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Liste des services")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogListService = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-flex',{staticClass:"mr-1",attrs:{"md12":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){return _vm.newService()}},slot:"activator"},[_vm._v("\n                      Service\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v(" Ajouter un service\n                  ")],1)],1)]),_vm._v(" "),_c('el-row',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"gutter":20,"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listService}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chef","label":"Chef de service"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Détails du service","icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showService(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Modifier le service","icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editService(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md12":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"error","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogListService =false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KqlW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"width":"80%","persistent":true,"transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogReserve),callback:function ($$v) {_vm.dialogReserve=$$v},expression:"dialogReserve"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter une nouvelle reserve pour la tache "+_vm._s(_vm.tache ? _vm.tache.libelle:"N/A")+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formReserve",staticClass:"demo-form-inline",attrs:{"id":"formReserve","model":_vm.formReserve,"rules":_vm.rules}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.formReserve.images[0],"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"fileTache",staticStyle:{"display":"none"},attrs:{"name":"fileTache","type":"file","accept":"image/*"},on:{"change":_vm.onFileTachePicked}}),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileTache.click()}},slot:"activator"},[_vm._v("\n                        Image 1\n                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('span',[_vm._v("Taille inférieur à 1024 ko")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.formReserve.images[1],"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"fileTache2",staticStyle:{"display":"none"},attrs:{"name":"fileTache2","type":"file","accept":"image/*"},on:{"change":_vm.onFileTachePicked2}}),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileTache2.click()}},slot:"activator"},[_vm._v("\n                        Image 2\n                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('span',[_vm._v("Taille inférieur à 1024 ko")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"description","label":"Description"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Description brève "},model:{value:(_vm.formReserve.description),callback:function ($$v) {_vm.$set(_vm.formReserve, "description", $$v)},expression:"formReserve.description"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.dialogReserve = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.createReserve()}}},[_vm._v("Enregistrer")])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kt0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_boardChantier_Chantier_index__ = __webpack_require__("dZna");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_besoin_besoinResponsable__ = __webpack_require__("dZfz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_rapport_ListeRapportTrx__ = __webpack_require__("chSw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_rapport_ListeReserve__ = __webpack_require__("cz/F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_boardProjet_widgetProjet__ = __webpack_require__("DXMj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */],
    ChantierIndex: __WEBPACK_IMPORTED_MODULE_1__components_boardChantier_Chantier_index__["a" /* default */],
    besoinResponsable: __WEBPACK_IMPORTED_MODULE_2__components_besoin_besoinResponsable__["a" /* default */],
    ListeRapportTrx: __WEBPACK_IMPORTED_MODULE_3__components_rapport_ListeRapportTrx__["a" /* default */],
    ListeReserve: __WEBPACK_IMPORTED_MODULE_4__components_rapport_ListeReserve__["a" /* default */],
    WidgetProjet: __WEBPACK_IMPORTED_MODULE_5__components_boardProjet_widgetProjet__["a" /* default */]
  },
  name: "DashboardProjet",
  props: {
    show: {
      type: Boolean
    },
    detailProjet: {
      type: Object
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      dialogDashboardProjet: false,
      loading: false,
      onglet: "0",

      //ONGLET CHANTIERS
      chantiers: [],

      //ONGLET besoins
      besoins: [],

      //ONGLET RAPPORS
      listeRapports: [],

      //ONGLET RESERVE
      listeReserves: []
    };
  },

  methods: {
    //ONGLET CHANTIER
    loadChantier: function loadChantier() {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "chantier/liste/" + this.detailProjet.id + "/projet";
      this.$http.get(url).then(function (response) {
        _this.chantiers = response.body.chantier;
        _this.loading = false;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Echec lors du chargement des chantiers");
      });
    },
    loadBesoinAvalider: function loadBesoinAvalider() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "besoin/projet/" + this.detailProjet.id;
      this.$http.get(url).then(function (response) {
        _this2.besoins = response.body.besoins;
        _this2.loading = false;
      });
    },
    handleTabClick: function handleTabClick(tab) {
      switch (tab) {
        case "0":
          if (this.chantiers.length == 0) {
            this.loadChantier();
          }

          break;
        case "1":
          if (this.besoins.length == 0) {
            this.loadBesoinAvalider();
          }
          break;
        case "2":
          if (this.listeRapports.length == 0) {
            this.loadRapportProjet();
          }
          break;
        case "3":
          if (this.listeReserves.length == 0) {
            this.loadReserves();
          }
          break;

        default:
          break;
      }
    },

    //onglet rapports
    loadRapportProjet: function loadRapportProjet() {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + "journal/projet/" + this.detailProjet.id;
      this.$http.get(url).then(function (response) {
        _this3.listeRapports = response.body.journaux;
        _this3.loading = false;
      }, function (error) {
        _this3.loading = false;
        _this3.$message.error("Echec lors du chargement des Journaux");
      });
    },


    //ONGLET RESERVE
    loadReserves: function loadReserves() {
      var _this4 = this;

      this.loading = true;
      var url = this.domaine + "reserve/projet/" + this.detailProjet.id;
      this.$http.get(url).then(function (response) {
        _this4.listeReserves = response.body.reserves;
        _this4.loading = false;
      }, function (error) {
        _this4.loading = false;
        _this4.$message.error("Echec lors du chargement des reserves");
      });
    },
    closeDialog: function closeDialog() {
      this.besoins.splice(0);
      this.chantiers.splice(0);
      this.$emit("close");
    }
  },

  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogDashboardProjet = newValue;
      if (newValue == true) {
        this.onglet = "0";
        this.loadChantier();
        //this.loadBesoinAvalider()
      }
    }
  }
});

/***/ }),

/***/ "KuKS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KvxP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LBxB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
      user: JSON.parse(sessionStorage.getItem('userInfo')),
      roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
      headers: [{ text: 'Libelle', value: '', sortable: true }, { text: 'Reference', value: '', sortable: true }, { text: 'Type', value: '', sortable: true }, { text: 'Prix', value: '', sortable: true }, { text: 'Actions', align: 'center', value: '' }],
      racourcis: [{ path: '/', text: 'Accueil', disabled: false }, { path: '/produit', text: 'Liste des produits', disabled: true }],
      items: [{ value: false, libelle: '', reference: '', type: '', prix: '', action: '' }],
      recherche: '',
      libelleProduit: '',
      libelleEditProduit: '',
      referenceProduit: '',
      referenceEditProduit: '',
      typeProduit: '',
      typeEditProduit: '',
      prixProduit: '',
      prixEditProduit: '',
      descProduit: '',
      descEditProduit: '',
      pagination: {},
      valid: true,
      validEdit: true,
      dialogAjout: false,
      dialogEdit: false,
      dialogSupr: false,
      dialogShow: false,
      idProduit: '',
      listType: [{ text: 'Materiel', value: 'materiel' }, { text: 'Materiaux', value: 'materiaux' }],
      listProduct: [],
      currentProduct: {},
      libelleRules: [function (v) {
        return !!v || 'Le libelle est obligatoire';
      }]
    };
  },

  computed: {
    pages: function pages() {
      return this.pagination.rowsPerPage ? Math.ceil(this.listProduct.length / this.pagination.rowsPerPage) : 0;
    }
  },
  mounted: function mounted() {
    this.loadPage();
    this.loadProduct();
  },

  methods: {
    loadPage: function loadPage() {
      var loading = this.$loading({
        lock: true,
        text: 'Veuillez patientez ...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(function () {
        loading.close();
      }, 1000);
    },
    addProduct: function addProduct() {
      var _this = this;

      var form = document.getElementById('formProduct');
      var formdata = new FormData(form);
      var url = this.domaine + 'product/create-product';
      formdata.append('typeProduit', this.typeProduit);
      var request = new XMLHttpRequest();
      request.open('post', url);
      request.send(formdata);
      this.valid = false;
      request.onreadystatechange = function () {
        var verif = JSON.parse(request.responseText);
        if (request.readyState === request.DONE) {
          if (request.status === 200) {
            if (verif[0].code === 2) {
              _this.$notify({
                title: 'LE PRODUIT A BIEN ETE AJOUTE',
                message: 'Enrégistrement réussie avec succès.',
                type: 'success',
                position: 'top-center'
              });
              _this.valid = true;
              _this.dialogAjout = false;
              _this.listProduct = verif[1];
            } else if (verif[0].code === 1) {
              _this.valid = true;
              _this.$message.error(verif[0].message);
            }
          }
        }
      };
    },
    loadProduct: function loadProduct() {
      var _this2 = this;

      var url = this.domaine + 'product/product-list';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this2.listProduct = response.body;
        }
      });
    },
    showProduct: function showProduct(current) {
      this.dialogShow = true;
      this.currentProduct = current;
    },
    editProduct: function editProduct(current) {
      this.dialogEdit = true;
      this.currentProduct = current;
      this.libelleEditProduit = this.currentProduct.libelle;
      this.referenceEditProduit = this.currentProduct.reference;
      this.typeEditProduit = this.currentProduct.type;
      this.prixEditProduit = this.currentProduct.valeur;
      this.descEditProduit = this.currentProduct.description;
    },
    updateProduct: function updateProduct() {
      var _this3 = this;

      if (this.$refs.form.validate()) {
        var form = document.getElementById('formEditProduct');
        var formdata = new FormData(form);
        var url = this.domaine + 'product/update-product/' + this.currentProduct.id;
        formdata.append('typeEditProduit', this.typeEditProduit);
        var request = new XMLHttpRequest();
        request.open('post', url);
        request.send(formdata);
        this.validEdit = false;
        request.onreadystatechange = function () {
          var verif = JSON.parse(request.responseText);
          if (request.readyState === request.DONE) {
            if (request.status === 200) {
              if (verif[0].code === 2) {
                _this3.$notify({
                  title: 'LE PRODUIT A BIEN ETE MODIFIE',
                  message: 'Modification réussie avec succès.',
                  type: 'success',
                  position: 'top-center'
                });
                _this3.validEdit = true;
                _this3.dialogEdit = false;
                _this3.listProduct = verif[1];
              } else if (verif[0].code === 1) {
                _this3.validEdit = true;
                _this3.$message.error(verif[0].message);
              }
            }
          }
        };
      }
    },
    activeDeleteProduct: function activeDeleteProduct(current) {
      this.dialogSupr = true;
      this.idProduit = current.id;
    },
    deleteProduct: function deleteProduct() {
      var _this4 = this;

      var url = this.domaine + 'product/delete-product/' + this.idProduit;
      var request = new XMLHttpRequest();
      request.open('get', url);
      request.send();
      this.dialogSupr = false;
      request.onreadystatechange = function () {
        var verif = JSON.parse(request.responseText);
        if (request.readyState === request.DONE) {
          if (request.status === 200) {
            if (verif[0].code === 2) {
              _this4.$notify({
                title: 'LE PRODUIT A BIEN ETE SUPPRIME',
                message: 'Suppression réussie avec succès.',
                type: 'success',
                position: 'top-center'
              });
              _this4.dialogSupr = false;
              _this4.listProduct = verif[1];
            } else if (verif[0].code === 1) {
              _this4.$message.error(verif[0].message);
            }
          }
        }
      };
    },
    clear: function clear() {
      this.$refs.form.reset();
      this.dialogAjout = false;
      this.dialogEdit = false;
      this.dialogSupr = false;
    },

    beforeMount: function beforeMount() {
      if (!this.roleAcces[this.$router.history.current.name]) {
        this.$router.push({ name: 'Home' });
      }
    }
  }
});

/***/ }),

/***/ "LFg+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"tile":""}},[_c('v-card-text',[_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTE DES BESOINS VEHICULES A VALIDER")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","mt-2":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","disabled":_vm.disabledBtnAchat,"icons":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.modalShowServiceAchat()}},slot:"activator"},[_vm._v("\n            Service achat\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1),_vm._v("Envoyer les besoins selectionnés au service achat\n        ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-2":""}},[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"mt-3":"","ml-1":"","mr-1":"","data":_vm.listeBesoinsVeh},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"width":"55","type":"selection"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"ID","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              ID-"+_vm._s(scope.row.id)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"produit","label":"VEHICULE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"QUANTITE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"UNITE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"periode","label":"PERIODE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.periode)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"DUREE(Jours)","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demandeur","label":"DEMANDEUR","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"respoProjet","label":"RESPONSABLE PROJET","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"PROJET/CHANTIER/TRAVAUX","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"tooltip-btn",attrs:{"slot":"activator","title":"Attribuer un vehicule","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalAttribVehicule(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1)],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"800"},model:{value:(_vm.dialogBesoinAchat),callback:function ($$v) {_vm.dialogBesoinAchat=$$v},expression:"dialogBesoinAchat"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("VALIDATION DES BESOINS EN VEHICULE SELECTIONNES")]),_vm._v(" "),_c('v-card-text',{staticClass:"mb-5"},[_c('el-alert',{attrs:{"title":'Voulez-vous transferer les besoins selectionnés au service achat ?',"description":"Les besoins selectionnés seront transferés au service achat pour établir une commande chez un fournisseur","type":"warning","center":"","closable":false,"show-icon":""}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialogBesoinAchat = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":function($event){return _vm.validBesoinAchat(1)}}},[_vm._v("Confirmer")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"800"},model:{value:(_vm.dialogAttriVeh),callback:function ($$v) {_vm.dialogAttriVeh=$$v},expression:"dialogAttriVeh"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("ATTRIBUER UN VEHICULE A DES TRAVAUX")]),_vm._v(" "),_c('v-card-text',{staticClass:"mb-5"},[_c('el-alert',{attrs:{"title":'Affecter ' +
                _vm.besoinSelect.qte +
                ' véhicule(s) pour les travaux de ' +
                _vm.besoinSelect.libTrx +
                ' pour une durée de ' +
                _vm.besoinSelect.duree +
                ' jours',"description":"Veuillez selectionner un vehicule, ainsi que le nombre exacte pour ces travaux","type":"warning","center":"","closable":false,"show-icon":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-3":""}},[_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"model":_vm.formAttrib,"label-position":"top"}},[_c('el-form-item',{attrs:{"label":"Parc","width":"50%"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"valeurSelect","id":"valeurSelect","placeholder":"Sélectionnez un parc"},on:{"change":function($event){return _vm.loadTypeParc(_vm.selectParc)}},model:{value:(_vm.selectParc),callback:function ($$v) {_vm.selectParc=$$v},expression:"selectParc"}},_vm._l((_vm.listParc),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Véhicule","width":"50%"}},[_c('el-select',{attrs:{"width":"100%","placeholder":"Sélectionnez un véhicule"},model:{value:(_vm.formAttrib.idVeh),callback:function ($$v) {_vm.$set(_vm.formAttrib, "idVeh", $$v)},expression:"formAttrib.idVeh"}},_vm._l((_vm.comboVeh),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Quantité"}},[_c('el-input-number',{attrs:{"min":1,"max":_vm.besoinSelect.qte,"size":"large","controls-position":"right","placeholder":"Quantité"},model:{value:(_vm.formAttrib.qte),callback:function ($$v) {_vm.$set(_vm.formAttrib, "qte", $$v)},expression:"formAttrib.qte"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialogAttriVeh = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":function($event){return _vm.attribVeh()}}},[_vm._v("Confirmer")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LSVI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-card',{attrs:{"color":"grey lighten-4","flat":""}},[_c('v-toolbar',{attrs:{"color":"#909399","dark":"","extended":""},scopedSlots:_vm._u([{key:"extension",fn:function(){return _vm._l((_vm.menuShow),function(menu,index){return _c('v-menu',{key:index,attrs:{"bottom":"","origin":"center center","transition":"scale-transition","offset-y":"","nudge-width":100},scopedSlots:_vm._u([(menu.etat == true)?{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-toolbar-title',_vm._g({staticClass:"mr-auto"},on),[_c('span',{staticClass:" subheading font-weight-thin"},[_vm._v(_vm._s(menu.listeMenu)+" ")]),_vm._v(" "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("arrow_drop_down")])],1)]}}:null],null,true)},[_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},_vm._l((menu.sousMenus),function(item,ind){return (item.etat)?_c('v-list-tile',{key:ind,attrs:{"router":"","disabled":!item.etat,"to":item.path}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.libelle))])],1)],1):_vm._e()}),1)],1)})},proxy:true}])},[_c('div',{staticClass:"display-1"},[_c('v-avatar',{attrs:{"tile":false,"size":50,"color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logo,"size":50,"alt":"avatar"}})]),_vm._v(" "),_c('span',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.name))])],1),_vm._v(" "),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-avatar',{staticClass:"grey lighten-4",attrs:{"size":"40px"}},[(_vm.user.url)?_c('img',{staticClass:"lazy",attrs:{"src":_vm.user.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"src":"http://archipro-v2.prodestic.net/webservice/web/uploads/avatars/default-avarta.png","alt":""}})])],1),_vm._v(" "),_c('v-list',{staticClass:"elevation-4"},[_c('v-list-tile',{on:{"click":function($event){$event.stopPropagation();_vm.dialogProfil = true}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.user.nom))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){$event.stopPropagation();_vm.dialogMdp = true}}},[_c('v-list-tile-title',[_vm._v("Modifier votre mot de passe")])],1),_vm._v(" "),(_vm.droitAcces.index_parametre)?_c('v-list-tile',{attrs:{"router":"","to":"/parametre"}},[_c('v-list-tile-title',[_vm._v("Paramètres")])],1):_vm._e(),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){$event.stopPropagation();_vm.dialogDeconnect = true}}},[_c('v-list-tile-title',[_vm._v("Se déconnecter")])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-title',[_vm._v("\n              Notifications\n              "),_c('el-tooltip',{attrs:{"content":'Notifications : ' + _vm.notif,"placement":"top"}},[_c('el-switch',{attrs:{"active-color":"#ff4949","inactive-color":"#13ce66","active-value":"descactive","inactive-value":"active"},on:{"change":_vm.onChangeNotif},model:{value:(_vm.notif),callback:function ($$v) {_vm.notif=$$v},expression:"notif"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('main',[_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('v-slide-x-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"40%"},model:{value:(_vm.dialogDeconnect),callback:function ($$v) {_vm.dialogDeconnect=$$v},expression:"dialogDeconnect"}},[_c('v-card',[_c('br'),_vm._v(" "),_c('h5',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment vous déconnecter ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"flat":"","color":"blue darken-1","large":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogDeconnect=false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"red","large":""},on:{"click":_vm.deconnect}},[_vm._v("Confirmer")])],1),_vm._v(" "),_c('v-card-actions')],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogProfil),callback:function ($$v) {_vm.dialogProfil=$$v},expression:"dialogProfil"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("MON PROFIL "+_vm._s(_vm.user.nom)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogProfil = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('div',[_c('v-flex',{attrs:{"text-xs-center":"","layout":"","align-center":"","justify-center":""}},[_c('v-avatar',{staticClass:"grey lighten-4",attrs:{"size":"140px"}},[(_vm.user.url)?_c('img',{staticClass:"lazy",attrs:{"src":_vm.user.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"src":"http://testerp.emacipro.com/webservice/web/uploads/avatars/default-avarta.png","alt":""}})])],1)],1)])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-col',[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('v-layout',{attrs:{"row":"","justify-left":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Nom et prénoms : ")]),_vm._v(" "+_vm._s(_vm.user.nom))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Login :")]),_vm._v(" "+_vm._s(_vm.user.email)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Fonction :")]),_vm._v(" "+_vm._s(_vm.user.fonction)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Service :")]),_vm._v(" "+_vm._s(_vm.user.service)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Contact :")]),_vm._v(" "+_vm._s(_vm.user.telephone)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enrégistrement : ")]),_vm._v(" "+_vm._s(_vm.user.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v(" "+_vm._s(_vm.user.modified)+" ")])])],1)],1)],1)])],1)],1),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogMdp = true}},slot:"activator"},[_vm._v("Mot de passe "),_c('v-icon',{attrs:{"right":""}},[_vm._v("lock")])],1),_vm._v("\n          Modifier votre mot de passe\n        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editUser();}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1),_vm._v("\n          Modifier votre profil\n        ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogMdp),callback:function ($$v) {_vm.dialogMdp=$$v},expression:"dialogMdp"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Modfifier votre mot de passe ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogMdp = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-form',{ref:"formMdp",attrs:{"lazy-validation":"","id":"formMdp"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify-left":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpUser","label":"Votre ancien mot de passe","rules":_vm.mdpUserRules,"counter":4,"required":""},model:{value:(_vm.mdpUser),callback:function ($$v) {_vm.mdpUser=$$v},expression:"mdpUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpNewUser","label":"Nouveau mot de passe","rules":_vm.mdpNewUserRules,"counter":4,"required":""},model:{value:(_vm.mdpNewUser),callback:function ($$v) {_vm.mdpNewUser=$$v},expression:"mdpNewUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpNewVerUser","label":"Confirmer le nouveau mot de passe","rules":_vm.mdpNewVerUserRules,"counter":4,"required":""},model:{value:(_vm.mdpNewVerUser),callback:function ($$v) {_vm.mdpNewVerUser=$$v},expression:"mdpNewVerUser"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":_vm.clear}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submitMdp}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjout),callback:function ($$v) {_vm.dialogAjout=$$v},expression:"dialogAjout"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Modfifier votre profil "+_vm._s(_vm.user.nom)+" ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjout = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-form',{ref:"formProfilUser",attrs:{"lazy-validation":"","id":"formProfilUser"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('div',[_c('v-flex',{attrs:{"text-xs-center":"","layout":"","align-center":"","justify-center":""}},[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"list-type":"picture-card","name":"photo","action":"","auto-upload":false}},[(_vm.user.url)?_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":_vm.user.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":"http://webservice.prodestic.net/web/uploads/avatars/default-avarta.png","alt":""}})])],1)],1)])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-col',[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Nom et prénoms","name":"nomUser","rules":_vm.nomUserRules,"counter":4,"required":""},model:{value:(_vm.nomUser),callback:function ($$v) {_vm.nomUser=$$v},expression:"nomUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Login de connexion","name":"loginUser","rules":_vm.loginUserRules,"counter":6,"required":""},model:{value:(_vm.loginUser),callback:function ($$v) {_vm.loginUser=$$v},expression:"loginUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Email","name":"emailUser","rules":_vm.emailUserRules,"counter":6,"required":""},model:{value:(_vm.emailUser),callback:function ($$v) {_vm.emailUser=$$v},expression:"emailUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"name":"contactUser","label":"Contact","counter":8,"rules":_vm.contactUserRules,"hint":"Exemple: 00-00-00-00","persistent-hint":"","required":""},model:{value:(_vm.contactUser),callback:function ($$v) {_vm.contactUser=$$v},expression:"contactUser"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Fonction occupé","name":"fonctionUser","counter":6,"required":""},model:{value:(_vm.fonctionUser),callback:function ($$v) {_vm.fonctionUser=$$v},expression:"fonctionUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"label":"Services","name":"serviceUser","items":_vm.listService,"rules":_vm.serviceUserRules,"item-value":"id","item-text":"libelle"},model:{value:(_vm.selectServiceUser),callback:function ($$v) {_vm.selectServiceUser=$$v},expression:"selectServiceUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpUserConnect","label":"Votre mot de passe","rules":_vm.mdpUserConnectRules,"counter":4,"required":""},model:{value:(_vm.mdpUserConnect),callback:function ($$v) {_vm.mdpUserConnect=$$v},expression:"mdpUserConnect"}})],1)],1)],1)],1)])],1)],1),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":_vm.clear}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submit}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LUUQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"primary":""}},[_c('v-layout',{attrs:{"column":"","justify-center":"","align-center":""}},[_c('v-flex',[_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('img',{staticClass:"mb-5",attrs:{"src":"/static/ARCHIPRO7.png","alt":"Vuetify.js"}})]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"label":"E-mail","rules":_vm.emailRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-btn',{attrs:{"router":"","to":"/login"}},[_vm._v("Retour")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid,"color":"blue darken-1"},on:{"click":_vm.submit}},[_vm._v("Envoyer ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LYZi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListeTableau_vue__ = __webpack_require__("Zs8z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c47129a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListeTableau_vue__ = __webpack_require__("if1K");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListeTableau_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c47129a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListeTableau_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LeWP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Lfa6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_rapport_AjoutReserve__ = __webpack_require__("v/m6");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */], AjoutReserve: __WEBPACK_IMPORTED_MODULE_1__components_rapport_AjoutReserve__["a" /* default */] },
  name: "IndexTache",
  props: {
    show: {
      type: Boolean
    },
    detailTrx: {
      type: Object
    },
    commis: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      dialogTache: false,
      loading: false,
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      listeTache: [],
      dialogOuvrier: false,
      dialogDemarrer: false,
      dialogConfirmRefus: false,
      listePrestataires: [],
      listePrestOuvriers: [],
      listePresence: [],
      listeOuvriers: [],
      formRefus: {},
      presenceSelect: {},
      tacheSelect: {
        libelle: ""
      },
      dialogTermine: false,
      formDemarrer: {},
      prestataireSelect: {
        idContrat: null,
        datePresence: null,
        file: null
      },
      tablePrestataire: [],
      dialogSuprPresence: false,
      imageRes: "/static/avatar-conducteur.png",

      //ajout reserve
      showAddReserve: false
    };
  },

  methods: {
    //reserve
    closeAjoutReserve: function closeAjoutReserve() {
      this.showAddReserve = false;
    },
    showDialogReserve: function showDialogReserve(item) {
      this.tacheSelect = item;
      this.showAddReserve = true;
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    loadTache: function loadTache(trx) {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "tache/travaux/" + trx.idTrx;
      this.$http.get(url).then(function (response) {
        _this.listeTache = response.body.taches;
        _this.loading = false;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Echec lors du chargement des taches");
      });
    },
    loadOuvrier: function loadOuvrier(tache) {
      var _this2 = this;

      this.prestataireSelect.datePresence = null;
      prestataireSelect.idContrat = null;
      this.loading = true;
      var url = this.domaine + "ouvrier/optionTravaux/" + tache.idOptTrx;
      this.$http.get(url).then(function (response) {
        _this2.listeOuvriers = response.body.ouvriers;
        _this2.listePrestataires = response.body.prestataires;
        _this2.listePrestOuvriers = response.body.listePresOuvriers;
        _this2.listePresence = response.body.listePresence;
        _this2.dialogOuvrier = true;
        _this2.loading = false;
      }, function (error) {
        _this2.loading = false;
        _this2.$message.error("Echec lors du chargement des ouvriers");
      });
    },
    submitFormDemarrer: function submitFormDemarrer(formName) {
      var _this3 = this;

      if (this.formDemarrer.dateDbt != "undefined" && this.formDemarrer.hrDbt != null && this.formDemarrer.hrDbt != "undefined" && this.formDemarrer.hrDbt != null) {
        this.loading = true;
        var url = this.domaine + "tache/demarrer/optionTrx/" + this.tacheSelect.idOptTrx;
        var data = new FormData();

        var dateDbt = this.formDemarrer.dateDbt.getFullYear() + "-" + (this.formDemarrer.dateDbt.getMonth() + 1) + "-" + this.formDemarrer.dateDbt.getDate();

        var hrDbt = this.formDemarrer.hrDbt.getHours() + ":" + this.formDemarrer.hrDbt.getMinutes();

        data.append("dateDbt", dateDbt);
        data.append("idUser", this.user.id);
        data.append("hrDbt", hrDbt);
        this.$http.post(url, data).then(function (response) {
          _this3.loading = false;
          //reinitialiser le formulaire
          _this3.dialogDemarrer = false;

          var mess = response.body.message;
          _this3.loadTache(_this3.detailTrx);
          _this3.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: mess,
            type: "success",
            position: "top-center"
          });
        }, function (erreur) {
          //reinitialiser le formulaire
          _this3.resetForm("formDemarrer");
          _this3.loading = false;
          _this3.$message.error("L'opération a echouée");
        });
      } // verifie champs date
      else {
          this.$message.error("Veuillez remplir correctement la date et l'heure svp...");
        }
    },
    submitFormStop: function submitFormStop(formName) {
      var _this4 = this;

      if (this.formRefus.rapport != "undefined" && this.formRefus.rapport != null) {
        this.loading = true;
        var url = this.domaine + "tache/arret/stop/tachetrx/" + this.tacheSelect.idOptTrx;
        var data = new FormData();

        data.append("idUser", this.user.id);
        data.append("rapport", this.formRefus.rapport);

        this.$http.post(url, data).then(function (response) {
          //reinitialiser le formulaire
          _this4.loading = false;
          _this4.dialogConfirmRefus = false;
          _this4.formRefus.rapport = "";
          var mess = response.body.message;
          _this4.loadTache(_this4.detailTrx);

          _this4.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: mess,
            type: "success",
            position: "top-center"
          });
        }, function (erreur) {
          //reinitialiser le formulaire
          _this4.formRefus.rapport = "";
          _this4.loading = false;
          _this4.$message.error("L'opération a echouée");
        });
      } //rapport non saisie
      else {
          this.$message.error("Veuillez remplir correctement les champs svp...");
        }
    },
    submitRelanceTache: function submitRelanceTache() {
      var _this5 = this;

      this.loading = true;
      var url = this.domaine + "tache/relance/optionTrx/" + this.tacheSelect.idOptTrx;
      var data = new FormData();
      data.append("idUser", this.user.id);
      this.$http.post(url, data).then(function (response) {
        //reinitialiser le formulaire
        _this5.loading = false;

        var mess = response.body.message;
        _this5.$emit("reloadListeTravaux");
        _this5.loadTache(_this5.detailTrx);

        _this5.$notify({
          title: "ENREGISTREMENT REUSSI",
          message: mess,
          type: "success",
          position: "top-center"
        });
      }, function (erreur) {
        _this5.loading = false;
        _this5.$message.error("L'opération a echouée");
      });
    },
    submitTacheTerminer: function submitTacheTerminer() {
      var _this6 = this;

      this.loading = true;
      var url = this.domaine + "tache/termine/optionTrx/" + this.tacheSelect.idOptTrx;
      var data = new FormData();
      data.append("idUser", this.user.id);
      this.$http.post(url, data).then(function (response) {
        //reinitialiser le formulaire
        _this6.loading = false;
        _this6.dialogTermine = false;

        var mess = response.body.message;
        _this6.loadTache(_this6.detailTrx);

        _this6.$notify({
          title: "ENREGISTREMENT REUSSI",
          message: mess,
          type: "success",
          position: "top-center"
        });
      }, function (erreur) {
        _this6.loading = false;
        _this6.$message.error("L'opération a echouée");
      });
    },
    submitPresence: function submitPresence() {
      var _this7 = this;

      if (this.prestataireSelect.idContrat == null || this.prestataireSelect.idContrat == "undefined" || this.prestataireSelect.datePresence == "undefined" || this.prestataireSelect.datePresence == null) {
        this.$message.error("Veuillez renseigner correctement les champs");
        return;
      }
      ///this.loading = true;
      var url = this.domaine + "presence/new";
      var data = new FormData();
      data.append("idUser", this.user.id);
      data.append("idContrat", this.prestataireSelect.idContrat);
      data.append("datePresence", this.prestataireSelect.datePresence);
      data.append("fichierRes", this.prestataireSelect.file, this.prestataireSelect.file[name]);

      this.$http.post(url, data).then(function (response) {
        //reinitialiser le formulaire

        _this7.loading = false;
        var mess = response.body.message;
        _this7.imageRes = "/static/avatar-conducteur.png";

        _this7.$notify({
          title: "ENREGISTREMENT REUSSI",
          message: mess,
          type: "success",
          position: "top-center"
        });

        _this7.loadOuvrier(_this7.tacheSelect);
        _this7.loading = false;
      }, function (erreur) {
        _this7.loading = false;
        _this7.$message.error("L'opération a echouée");
      });
    },
    deletePresence: function deletePresence(idPresence) {
      var _this8 = this;

      this.loading = true;

      var url = this.domaine + "presence/delete/" + idPresence;
      this.$http.get(url).then(function (response) {
        _this8.loading = false;

        _this8.$notify({
          title: "SUPPRESSION REUSSIE",
          message: "Demande supprimée avec succès.",
          type: "success",
          position: "top-center"
        });
        _this8.dialogSuprPresence = false;

        _this8.loadOuvrier(_this8.tacheSelect);
      }, function (errRep) {
        _this8.loading = false;
        _this8.dialogSuprPresence = false;
        _this8.$notify.error({
          title: "SUPPRESSION ECHOUEE",
          message: "La suppression de la demande a échouée.",
          position: "top-center"
        });
      });
    },
    onFileResPicked: function onFileResPicked(event) {
      var _this9 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this9.imageRes = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.prestataireSelect.file = files[0];
      //this.file = files[0];
    }
  },

  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogTache = newValue;

      if (newValue) {
        this.loadTache(this.detailTrx);
      }
    }
  }
});

/***/ }),

/***/ "Ltin":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M0+p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardComparatif_vue__ = __webpack_require__("8P/w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34dcb2d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardComparatif_vue__ = __webpack_require__("AV5A");
function injectStyle (ssrContext) {
  __webpack_require__("ti83")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardComparatif_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34dcb2d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardComparatif_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M0d+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_validationDG_ModalValidationDmd__ = __webpack_require__("J/ex");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_validationDG_ModalValidationDmdFond__ = __webpack_require__("DUFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_validationDG_ModalValidationDga__ = __webpack_require__("NMfS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_validationDG_ModalValidationMiss__ = __webpack_require__("0ygq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_validationDG_ModalValidationFacture__ = __webpack_require__("N3SU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_validationDG_ModalValidationInterv__ = __webpack_require__("gpm2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_validationDG_ModalValidationAppro__ = __webpack_require__("iWoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__facturePaiement__ = __webpack_require__("UgjE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_resourceHumaine_liste_demande__ = __webpack_require__("YSKP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Loading__ = __webpack_require__("NxGh");




var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        facturePaiement: __WEBPACK_IMPORTED_MODULE_10__facturePaiement__["a" /* default */],
        Loading: __WEBPACK_IMPORTED_MODULE_12__components_Loading__["a" /* default */], ModalValidationDmd: __WEBPACK_IMPORTED_MODULE_3__components_validationDG_ModalValidationDmd__["a" /* default */], ModalValidationMiss: __WEBPACK_IMPORTED_MODULE_6__components_validationDG_ModalValidationMiss__["a" /* default */], ModalValidationFacture: __WEBPACK_IMPORTED_MODULE_7__components_validationDG_ModalValidationFacture__["a" /* default */], ModalValidationInterv: __WEBPACK_IMPORTED_MODULE_8__components_validationDG_ModalValidationInterv__["a" /* default */], ModalValidationDmdFond: __WEBPACK_IMPORTED_MODULE_4__components_validationDG_ModalValidationDmdFond__["a" /* default */], ModalValidationDga: __WEBPACK_IMPORTED_MODULE_5__components_validationDG_ModalValidationDga__["a" /* default */], ModalValidationAppro: __WEBPACK_IMPORTED_MODULE_9__components_validationDG_ModalValidationAppro__["a" /* default */], listeDemande: __WEBPACK_IMPORTED_MODULE_11__components_resourceHumaine_liste_demande__["a" /* default */] },
    name: "app",
    data: function data() {
        var _ref;

        return _ref = {
            //data general
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            racourcis: [{ path: '/', text: 'Accueil', disabled: false }, { path: '/validationDmd', text: 'Dashboard des validations', disabled: true }],
            dialogValideSuivant: false,
            typeDmd: null,
            itemDmd: {},
            items: [],
            index: null,

            // stretch: false,
            //VALIDATION DES sDEMANDES
            listeDemandes: [],
            selectZoneDmd: '',
            oldListDemandes: [],
            legendeDmd: "LISTE DES DEMANDES DE MAINTENANCES A VALIDER",
            comboZoneDmd: [],
            mntTTCAValide: 0,
            demandeDetail: {},
            showModalDetailDmd: false,
            nbDmdMaint: 0,

            //VALIDATION MISSIONS
            legendeMiss: "LISTE DES DEMANDES DE MISSION A VALIDER",
            listeMissions: [],
            oldListMissions: [],
            selectMissDemd: "",
            listeDemandeurs: [],
            nbMiss: 0,
            mntTotalMissTTC: 0,
            detailMission: {},
            showModalDetailMiss: false,

            //VALIDATION FACTURE FOURNISSEUR
            legendeFour: "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER",
            nbFactFour: 0,
            listeFournisseurs: [],
            listeFacturesFour: [],
            oldListFacturesFour: [],
            selectFour: '',
            mntTotalFactTTC: 0,
            factureDetail: {},
            showModalDetailFact: false,

            //VALIDATION DES DEMANDES APPROVISIONNEMENTS
            legendeAppro: "LISTE DES DEMANDES APPROVISIONNEMENTS",
            mntTotalAppro: 0,
            listeDmdNoValidAppro: [],
            showModalDetailAppro: false,
            ApproDetail: {},
            nbAppro: 0,
            listBanque: [],
            listCaisse: [],

            //VALIDATION INTERVENTION
            legendeInterv: "LISTE DES REPARATIONS A VALIDER",
            mntTotalIntervTTC: 0,
            nbInterv: 0,
            selectInterv: '',
            listeDemdInterv: [],
            listeIntervention: [],
            oldListeIntervention: [],
            intervDetail: [],
            showModalIntervFact: false,

            //VALIDATION DENANDE DE FONDS
            legendeDmdFond: "LISTE DES DEMANDES DE FONDS A VALIDER",
            mntTotalDmdFondTTC: 0,
            nbDmdFond: 0,
            selectDmdFond: '',
            listeDemandeurFond: [],
            listeDmdFond: [],
            oldListeDemandeurFond: [],
            dmdFondDetail: [],
            showModalDetailDmdFond: false,
            onglet: "0",

            //VALIDATION DEMANDE CONGE
            listeDemandeurAbs: [],
            //VALIDATION COMMANDE
            legendeDmdCom: "LISTE DES BONS DE COMMANDES A VALIDER",
            mntTotalDmdComTTC: 0,
            nbDmdCom: 0,
            selectDmdCom: '',
            listeDemandeurCom: [],
            listeDmdCom: [],
            oldListeDemandeurCom: [],
            dmdComDetail: [],
            detailCommande: [],
            totalMontant: 0,
            totalComHT: [],
            totalComTVA: [],
            totalComRemise: [],
            showModalDetailDmdCom: false,
            commCourant: []
        }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'onglet', "0"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'listeProdNull', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'mntTotalCmd', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'listeProdNull', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'commandeDeriv', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'commandeDerivDeux', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'nbCommandeSug', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'nbCommandeSugDeux', 0), _ref;
    },


    methods: (_methods = {
        SubmitValideSuivant: function SubmitValideSuivant() {
            switch (this.typeDmd) {
                case "maintenance":
                    this.dialogValideSuivant = false;
                    this.modalDetailDmd(this.itemDmd);
                    break;

                case "intervention":
                    this.dialogValideSuivant = false;
                    this.modalDetailInterv(this.itemDmd);
                    break;
                case "factureFour":
                    this.dialogValideSuivant = false;
                    this.modalDetailFour(this.itemDmd);
                    break;
                case "mission":
                    this.dialogValideSuivant = false;
                    this.modalDetailMissDemd(this.itemDmd);
                    break;
                case "bonCommandeInterne":
                    this.dialogValideSuivant = false;
                    this.modalDetailDmdCom(this.itemDmd);
                    break;

                case "demandeFond":
                    this.dialogValideSuivant = false;
                    this.modalDetailDmdFond(this.itemDmd);
                    break;
            }
        },
        CancelValideSuivant: function CancelValideSuivant() {
            switch (this.typeDmd) {
                case "maintenance":
                    this.dialogValideSuivant = false;
                    this.loadDemandeAvalider();
                    break;

                case "intervention":
                    this.dialogValideSuivant = false;
                    this.loadDmdIntervention();
                    break;
                case "factureFour":
                    this.dialogValideSuivant = false;
                    this.loadFacture();
                    break;
                case "mission":
                    this.dialogValideSuivant = false;
                    this.loadMissionsAvalider;
                    break;

                case "bonCommandeInterne":
                    this.dialogValideSuivant = false;
                    this.modalDetailDmdCom(this.itemDmd);
                    break;
                case "demandeFond":
                    this.dialogValideSuivant = false;
                    this.loadDmdFond();
                    break;
            }
        },
        showDialogDmdAfter: function showDialogDmdAfter(idDmd, type) {
            this.showModalDetailDmd = false;
            this.listeDemandes = this.listeDemandes.filter(function (elm) {
                return elm.idDemande != idDmd;
            });

            if (this.listeDemandes.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDemandes[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadDemandeAvalider();
            }
        },
        showDialogDmdFondAfter: function showDialogDmdFondAfter(idDmd, type) {
            this.showModalDetailDmdFond = false;
            this.listeDmdFond = this.listeDmdFond.filter(function (elm) {
                return elm.id != idDmd;
            });
            console.log('idDmd', idDmd, type);

            if (this.listeDmdFond.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDmdFond[0];
                    this.typeDmd = type;
                    console.log('hdhd', type);
                    this.dialogValideSuivant = true;
                } else {
                this.loadDmdFond();
            }
        },
        showDialogDmdComAfter: function showDialogDmdComAfter(idDmd, type) {
            this.showModalDetailDmdCom = false;
            this.listeDmdCom = this.listeDmdCom.filter(function (elm) {
                return elm.id != idDmd;
            });
            if (this.listeDmdCom.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDmdCom[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadDmdCom();
            }
        },
        showDialogFactAfter: function showDialogFactAfter(idDmd, type) {
            this.listCaisse = [];
            this.listBanque = [];
            this.showModalDetailFact = false;
            this.loadFacture();
            this.listeFacturesFour = this.listeFacturesFour.filter(function (elm) {
                return elm.idFact != idDmd;
            });

            if (this.listeFacturesFour.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeFacturesFour[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadFacture();
            }
        },
        showDialogMissAfter: function showDialogMissAfter(idDmd, type) {
            this.showModalDetailMiss = false;
            this.listeMissions = this.listeMissions.filter(function (elm) {
                return elm.IdUtil != idDmd;
            });

            if (this.listeMissions.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeMissions[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadMissionsAvalider();
            }
        },
        showDialogIntervAfter: function showDialogIntervAfter(idDmd, type) {
            this.showModalIntervFact = false;
            this.listeIntervention = this.listeIntervention.filter(function (elm) {
                return elm.intervId != idDmd;
            });

            if (this.listeIntervention.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeIntervention[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadDmdIntervention();
            }
        },
        showDialogComAfter: function showDialogComAfter(idDmd, type) {
            this.showModalDetailDmdCom = false;
            this.listeDmdCom;
            this.listeDmdCom = this.listeDmdCom.filter(function (elm) {
                return elm.intervId != idDmd;
            });

            if (this.listeDmdCom.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDmdCom[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadDmdCom();
            }
        },


        //DEMANDE DE MAINTENANCE
        modalDetailDmd: function modalDetailDmd(item) {
            this.demandeDetail = item;
            this.showModalDetailDmd = true;
        },
        filtrerZoneDmd: function filtrerZoneDmd(idZone) {
            this.loadDmdParZone(idZone);
        },
        loadLieu: function loadLieu() {
            var _this = this;

            var url = this.domaine + 'validationDG/lieu';
            this.$http.get(url).then(function (response) {
                _this.comboZoneDmd = response.body.lieux;
            }, function (erreurRep) {});
        },
        loadDmdParZone: function loadDmdParZone(idZone) {
            this.legendeDmd = "LISTE DES DEMANDES DE MAINTENANCES A VALIDER FILTREES PAR ZONE";
            this.listeDemandes = this.oldListDemandes;
            this.listeDemandes = this.listeDemandes.filter(function (item) {
                return item.idZone == idZone;
            });
        },
        clearSelectDmdZone: function clearSelectDmdZone() {
            this.listeDemandes = this.oldListDemandes;
            this.legendeDmd = "LISTE DES DEMANDES DE MAINTENANCES A VALIDER";
        },
        loadDemandeAvalider: function loadDemandeAvalider() {
            var _this2 = this;

            this.loading = true;
            var url = this.domaine + 'validationDG/index/demandes';
            this.$http.get(url).then(function (response) {
                _this2.oldListDemandes = response.body.listeDemandes;
                _this2.listeDemandes = response.body.listeDemandes;
                _this2.mntTTCAValide = response.body.mntTTC;
                _this2.nbDmdMaint = response.body.nbMaint;
                _this2.loadLieu();
                _this2.loading = false;
            }, function (erreur) {
                _this2.loading = false;
                _this2.$message.error("Une erreur est survenue lors du chargement des demandes de maintenances'");
            });
        },


        //DEMANDE DE MISSION
        filtrerMissDemd: function filtrerMissDemd(idDemd) {
            this.loadMissionDemd(idDemd);
        },
        clearSelectMissDemd: function clearSelectMissDemd() {
            this.listeMissions = this.oldListMissions;
            this.legendeMiss = "LISTE DES DEMANDES DE MISSION A VALIDER";
        },
        loadMissionDemd: function loadMissionDemd(idDemd) {
            this.legendeMiss = "LISTE DES DEMANDES DE MISSION A VALIDER FILTREES PAR DEMANDEUR";
            this.listeMissions = this.oldListMissions;
            this.listeMissions = this.listeMissions.filter(function (item) {
                return item.idUserDemandeur == idDemd;
            });
        },
        loadMissionsAvalider: function loadMissionsAvalider() {
            var _this3 = this;

            var url = this.domaine + "validationDG/index/missions";
            this.$http.get(url).then(function (resp) {
                _this3.oldListMissions = resp.body.missions, _this3.listeMissions = resp.body.missions, _this3.nbMiss = resp.body.nbUtil, _this3.listeDemandeurs = resp.body.listeDemandeurs;
                _this3.mntTotalMissTTC = resp.body.mntTotalTTC;
            }, function (resp) {
                _this3.$message.error("erreur lors du chargement des missions.");
            });
        },
        modalDetailMissDemd: function modalDetailMissDemd(item) {
            this.detailMission = item;
            this.showModalDetailMiss = true;
        },


        //FACTURE FOURNISSEUR
        clearSelectFour: function clearSelectFour() {
            this.listeFacturesFour = this.oldListFacturesFour;
            this.legendeFour = "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER";
        },
        modalDetailFour: function modalDetailFour(item) {
            this.listBanque = [];
            this.listCaisse = [];
            if (item.listBanque.length == 0) {
                this.loadAllBanque();
            } else {
                this.listBanque = item.listBanque;
                this.listCaisse = item.listCaisse;
            }
            this.factureDetail = item;
            this.showModalDetailFact = true;
            this.showModalDetailFact = true;
            this.commandeDerivDeux = [];
            this.commandeDeriv = [];
            this.showDialogComparaison(item);
        },
        modalDetailDmdFond: function modalDetailDmdFond(item) {
            this.demandeDetail = item;
            this.showModalDetailDmdFond = true;
        },
        modalDetailDmdCom: function modalDetailDmdCom(ligne) {
            this.demandeDetail = ligne;
            this.showModalDetailDmdCom = true;
            this.commCourant = ligne;
            this.detailCommande = ligne;
            // this.showDialogComAfter(ligne, 'bonCommandeInterne')
        }
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'clearSelectFour', function clearSelectFour() {
        this.listeFacturesFour = this.oldListFacturesFour;
        this.legendeFour = "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER";
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'showDialogComparaison', function showDialogComparaison(item) {
        var _this4 = this;

        // this.loading = true;
        var smsAficher = "Aucune tarification de ce produit est indiqué chez vous fournisseurs ";
        var mesProdPrixNulle = "Les produits de cette commande ne se trouvent chez aucun autres de vos fournisseurs ";

        var formdata = new FormData();
        var url = this.domaine + "comparateur/new/commande";
        var options = [];
        var listProdPrixNulle = [];

        for (var prop in item.option) {
            var ligne = item.option[prop];
            options.push(ligne.id);
        }
        formdata.append("options", options);
        formdata.append("facture", 1);
        formdata.append("typeOption", 2); //optionBesoin

        this.$http.post(url, formdata).then(function (response) {
            //affichage des messages
            var nbCmd = 0;
            var nbCmdDeux = 0;
            var listeFoun = [];
            var listeNull = [];
            var listeFounSecond = [];

            var respFour = response.body.fournisseurs[0];
            _this4.mntTotalCmd = response.body.mntTotauxFormat;
            _this4.listeProdNull = response.body.listeProdNull;

            _this4.loading = false;
            for (var four in respFour) {
                var listeProduit = respFour[four];
                var infoFour = {
                    fournisseur: four,
                    produits: [],
                    mntTotal: 0,
                    mntTotalHt: 0

                };
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(listeProduit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var produit = _step.value;

                        infoFour.produits.push(produit);
                        infoFour.mntTotal += parseFloat(produit.mntTotal);
                        infoFour.mntTotalHt += parseFloat(produit.mntTotalHt);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                if (infoFour.produits.length == options.length) {
                    nbCmd++;
                    listeFoun.push(infoFour);
                } else {
                    nbCmdDeux++;

                    listeFounSecond.push(infoFour);
                }
            }
            _this4.nbCommandeSug = nbCmd;
            _this4.commandeDeriv = listeFoun;
            _this4.nbCommandeSugDeux = nbCmdDeux;
            _this4.commandeDerivDeux = listeFounSecond;
            // this.dialogDetailCmd = true;
            _this4.loading = false;
            //AFFICHAGE DE PRODUITS DONT LE MONTANT EST NULL
            if (response.body.listeProdNull.length > 0) {
                // this.dialogProdNull = true;
                //this.closeProdNull();
            }

            if (listeFoun.length > 0) {
                _this4.showModalCompCmd = true;
            }
            // }
        }, function (error) {
            _this4.loading = false;
            _this4.$message.error("Erreur serveur");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'filtrerFour', function filtrerFour() {
        var _this5 = this;

        // this.loadFactParFour(this.selectFour)
        var tab = this.listeFournisseurs;
        var newTab = [];
        this.listeFournisseurs = tab.filter(function (item) {
            if (item.value == _this5.selectFour) {
                newTab.push(item);
            }
            return newTab;
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'modalDetailAppro', function modalDetailAppro(item) {
        this.ApproDetail = item;
        this.showModalDetailAppro = true;
        this.loadListBanque(item.caisseId);
        this.loadListCaisse(item.caisseId);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadListBanque', function loadListBanque(item) {
        var _this6 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/tresor/' + item + '/banque';
        this.$http.get(url).then(function (response) {
            _this6.listBanque = response.body.listBanque;
            _this6.loading = false;
        }, function (errResp) {
            _this6.loading = false;
            _this6.$message.error("Une erreur est survenue lors du chargement de la liste banque");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadListCaisse', function loadListCaisse(item) {
        var _this7 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/tresor/' + item + '/caisse';
        this.$http.get(url).then(function (response) {
            _this7.listCaisse = response.body.listCaisse;
            _this7.loading = false;
        }, function (errResp) {
            _this7.loading = false;
            _this7.$message.error("Une erreur est survenue lors du chargement de la liste caisse");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadAllBanque', function loadAllBanque() {
        var _this8 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/tresor/banque';
        this.$http.get(url).then(function (response) {
            _this8.listBanque = response.body.listBanque;
            _this8.listCaisse = response.body.listCaisse;
            _this8.loading = false;
        }, function (errResp) {
            _this8.loading = false;
            _this8.$message.error("Une erreur est survenue lors du chargement de la liste banque");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadAllCaisse', function loadAllCaisse() {
        var _this9 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/tresor/caisse';
        this.$http.get(url).then(function (response) {
            _this9.listCaisse = response.body.listCaisse;
            _this9.loading = false;
        }, function (errResp) {
            _this9.loading = false;
            _this9.$message.error("Une erreur est survenue lors du chargement de la liste caisse");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadFactParFour', function loadFactParFour(idFour) {
        this.legendeFour = "LISTE DES DEVIS / FACTURES A VALIDER FILTREES PAR FOURNISSEUR";
        this.listeFacturesFour = this.oldListFacturesFour;
        this.listeFacturesFour = this.listeFacturesFour.filter(function (item) {
            return item.idUserDemandeur == idFour;
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadFacture', function loadFacture() {
        var _this10 = this;

        this.loading = true;
        var url = this.domaine + 'validationDG/fournisseur/facture';
        this.$http.get(url).then(function (response) {
            _this10.listeFournisseurs = response.body.listeFour;
            _this10.mntTotalFactTTC = response.body.totalFacture;
            _this10.nbFactFour = response.body.nbFact;
            _this10.listeFacturesFour = response.body.facture;
            _this10.oldListFacturesFour = response.body.facture;
            _this10.loading = false;
        }, function (resp) {
            _this10.$message.error("erreur lors du chargement des devis / factures fournisseurs.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'modalDetailInterv', function modalDetailInterv(item) {
        this.intervDetail = item;
        this.showModalIntervFact = true;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'clearSelectInterv', function clearSelectInterv() {
        this.listeIntervention = this.oldListeIntervention;
        this.legendeInterv = "LISTE DES REPARATIONS A VALIDER";
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'filtrerInterv', function filtrerInterv(idDemandeur) {
        this.loadDmdParInterv(idDemandeur);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdParInterv', function loadDmdParInterv(idDemandeur) {
        this.legendeInterv = "LISTE DES REPARATIONS A VALIDER FILTREES PAR DEMANDEUR";
        this.listeIntervention = this.oldListeIntervention;
        this.listeIntervention = this.oldListeIntervention.filter(function (item) {
            return item.idDemandeur == idDemandeur;
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdIntervention', function loadDmdIntervention() {
        var _this11 = this;

        this.loading = true;
        var url = this.domaine + 'validationDG/intervention/facture';
        this.$http.get(url).then(function (response) {
            _this11.listeIntervention = response.body.listeInterv;
            _this11.oldListeIntervention = response.body.listeInterv;
            _this11.mntTotalIntervTTC = response.body.mntTotal;
            _this11.nbInterv = response.body.nbInterv;
            _this11.listeDemdInterv = response.body.listeDemdInterv;
            _this11.loading = false;
        }, function (resp) {
            _this11.$message.error("erreur lors du chargement des demandes reparations.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'filtrerDmdFond', function filtrerDmdFond(idDemd) {
        this.loadDmdFond(idDemd);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'filtrerDmdCom', function filtrerDmdCom(idDemd) {
        this.loadDmdFond(idDemd);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdCom', function loadDmdCom() {
        var _this12 = this;

        this.loading = true;
        var url = this.domaine + "besoin/index/validation/dga/recent";
        this.$http.get(url).then(function (response) {
            _this12.loading = false;
            _this12.nbDmdCom = 0;
            if (response.body) {
                var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(response.body.besoin);

                _this12.nbDmdCom = data.length;
                _this12.listeDmdCom = data;
                _this12.oldListeDmdCom = data;
            }
        }, function (resp) {
            _this12.loading = false;
            _this12.$message.error("erreur lors du chargement des demandes de fonds.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdFond', function loadDmdFond() {
        var _this13 = this;

        this.loading = true;
        var url = this.domaine + 'validationDG/dmdFond/liste';
        this.$http.get(url).then(function (response) {
            _this13.listeDmdFond = response.body.listeDmdFond;
            _this13.oldListeDmdFond = response.body.listeDmdFond;
            _this13.mntTotalDmdFondTTC = response.body.mntTotal;
            _this13.nbDmdFond = response.body.nbDmdFond;
            _this13.listeDemandeurFond = response.body.listeDemandeurFond;
            _this13.loading = false;
        }, function (resp) {
            _this13.loading = false;
            _this13.$message.error("erreur lors du chargement des demandes de fonds.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdNoValidAppro', function loadDmdNoValidAppro() {
        var _this14 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/appro/no-valide-dg/all';
        this.$http.get(url).then(function (response) {
            _this14.listeDmdNoValidAppro = response.body.appro;
            _this14.mntTotalAppro = response.body.totDmdAppro;
            _this14.nbAppro = response.body.nbAppro;
            _this14.loading = false;
        }, function (resp) {
            _this14.$message.error("erreur lors du chargement des demandes approvisionnement.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'handleTabClick', function handleTabClick(tab) {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'clearSelectDmd', function clearSelectDmd() {
        this.listeFacturesFour = this.oldListFacturesFour;
        this.legendeFour = "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER";
    }), _methods),

    mounted: function mounted() {
        // this.loadDemandeAvalider()
        // this.loadMissionsAvalider()
        this.loadFacture();
        // this.loadDmdIntervention()
        this.loadDmdFond();
        this.loadDmdCom();
        // this.loadDmdNoValidAppro()
    }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ce076d3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("LSVI");
function injectStyle (ssrContext) {
  __webpack_require__("ctYl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ce076d3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MHXB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_map_ProjetMap__ = __webpack_require__("blqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dhtmlx_gantt__ = __webpack_require__("iSmP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dhtmlx_gantt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dhtmlx_gantt__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Vb+l");
__webpack_require__("Oq2I");
__webpack_require__("miEh");





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */], ProjetMap: __WEBPACK_IMPORTED_MODULE_2__components_map_ProjetMap__["a" /* default */] },
  name: 'app',
  data: function data() {
    return {
      notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
      domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
      user: JSON.parse(sessionStorage.getItem('userInfo')),
      roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
      racourcis: [{ path: '/', text: 'Accueil', disabled: false }, { path: '/chantier', text: 'Liste des visites de chantier', disabled: true }],
      loading: false,
      valid: true,
      listVisiteChantier: [],
      visiteCourant: [],
      listProjet: [],
      listChantier: [],
      listTravaux: [],
      tachesList: [],
      selectProjet: '',
      selectChantier: '',
      selectStatut: '',
      rapportField: '',
      disabledBtnSCTach: false,
      disabledBtn: true,
      dialogValid: false,
      dialogRapportValid: false,
      dialogShowVisite: false,
      dialogEdit: false,
      disabledBtnStat: false,
      dialogSupVisite: false,
      dateVisite: '',
      nomControleur: '',
      objet: '',
      dateNow: '',
      statut: [{
        etat: '0',
        label: "En attente"
      }, {
        etat: '1',
        label: "Terminée"
      }],
      multipleSelection: [],

      invoice_products: [{
        product_no: '',
        product_name: '',
        product_price: '',
        product_qty: '',
        line_total: 0
      }]

    };
  },
  mounted: function mounted() {
    this.loadPage();
    this.loadUser();
    this.loadVisiteChantier();
    this.loadProjet();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
    loadPage: function loadPage() {
      this.loading = true;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      this.dateNow = dd + '/' + mm + '/' + yyyy;
    },
    loadUser: function loadUser() {
      var _this = this;

      this.loading = true;
      var url = this.domaine + 'userCreate/user-list';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this.users = response.body;
          _this.loading = false;
        }
      });
    },
    loadVisiteChantier: function loadVisiteChantier() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + 'visitechantier/index';
      this.loading = true;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this2.listVisiteChantier = response.body.visiteChantier;
          if (_this2.listVisiteChantier === undefined || _this2.listVisiteChantier.length == 0) {
            _this2.disabledBtnSCTach = true;
          } else {
            _this2.disabledBtnSCTach = false;
          }
          _this2.loading = false;
        }
      });
    },
    loadProjet: function loadProjet() {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + 'projet/index';
      this.loading = true;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this3.listProjet = response.body.projet;
          _this3.loading = false;
        }
      });
    },
    loadProjChantier: function loadProjChantier() {
      var _this4 = this;

      this.selectChantier = '';
      var url = this.domaine + 'chantier/liste/' + this.selectProjet + '/projet';
      this.loading = true;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this4.listChantier = response.body.chantier;
          _this4.loading = false;
        }
      });
    },
    submitVisite: function submitVisite() {
      var _this5 = this;

      this.loading = true;
      if (this.selectProjet != '' && this.selectChantier != '' && this.nomControleur != '' && this.dateVisite != '' && this.objet != '' && this.selectStatut != '' && this.dateVisite > this.dateNow) {
        var form = document.getElementById('formVisite');
        var data = new FormData(form);
        var url = '';
        data.append('idProjet', this.selectProjet);
        data.append('idChantier', this.selectChantier);
        // data.append('statut', this.selectStatut)
        data.append('nomControleur', this.nomControleur);

        if (this.visiteCourant.id != '') {
          url = this.domaine + 'visitechantier/' + this.visiteCourant.id + '/' + this.selectProjet + '/' + this.selectChantier + '/edit';
        } else {
          url = this.domaine + 'visitechantier/' + this.selectProjet + '/' + this.selectChantier + '/new';
        }

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this5.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: 'Visite de chantier enregistrée avec succès.',
                type: 'success',
                position: 'top-center'
              });
              _this5.loadVisiteChantier();
              _this5.loading = false;
              _this5.dialogValid = false;
            } else if (verif.code === 0) {
              _this5.$message.error(verif.message);
              _this5.loading = false;
              _this5.dialogValid = false;
            }
          } else {
            _this5.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
            _this5.loading = false;
            _this5.dialogValid = false;
          }
        }, function (response) {
          _this5.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
          _this5.loading = false;
        });
      } else {
        this.$message.error('Veuillez renseigner les champs obligatoires');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La visite n'a pas été enregistrée.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    newVisiteChantier: function newVisiteChantier() {
      this.dialogValid = true;
      this.dialogEdit = false;
      this.visiteCourant.id = '';
      this.dateVisite = '';
      this.selectProjet = '';
      this.selectChantier = '';
      this.selectStatut = '0';
      this.objet = '';
      this.nomControleur = '';
    },
    editVisiteChantier: function editVisiteChantier(ligne) {
      this.dialogValid = true;
      this.dialogEdit = true;
      this.visiteCourant = ligne;
      this.selectProjet = ligne.idprojet;
      this.loadProjChantier();
      this.selectChantier = ligne.idchantier;
      this.selectStatut = ligne.statut;
      if (ligne.statut === '1') {
        this.disabledBtnStat = true;
      } else {
        this.disabledBtnStat = false;
      }
      this.objet = ligne.objet;
      this.nomControleur = ligne.controleur;
      this.dateVisite = ligne.dateVisite;
    },
    rapportVisiteChantier: function rapportVisiteChantier(ligne) {
      var _this6 = this;

      this.rapportField = '';
      this.dialogRapportValid = true;
      this.visiteCourant = ligne;
      var url = this.domaine + 'visitechantier/load/' + ligne.idchantier + '/list-travaux';
      this.loading = true;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this6.listTravaux = '';
          _this6.listTravaux = response.body.listeTache;
          _this6.loading = false;
        }
      });
    },
    modalShowVisite: function modalShowVisite(item) {
      this.dialogShowVisite = true;
      this.visiteCourant = item;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitRapport: function submitRapport() {
      var _this7 = this;

      // this.loading = true
      if (this.multipleSelection != '' && this.rapportField != '') {
        var form = document.getElementById('formRapport');
        var data = new FormData(form);
        var url = this.domaine + 'visitechantier/' + this.visiteCourant.id + '/rapport/add';

        // data.append('test[]', this.multipleSelection)
        this.multipleSelection.forEach(function (item) {
          // data.append('option[id][]', item.idTache)
          data.append('arr[]', item.idTache);
        });

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this7.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: 'Rapport de visite enregistré avec succès.',
                type: 'success',
                position: 'top-center'
              });
              _this7.loadVisiteChantier();
              _this7.loading = false;
              _this7.dialogRapportValid = false;
              _this7.multipleSelection = '';
            } else if (verif.code === 0) {
              _this7.$message.error(verif.message);
              _this7.loading = false;
              _this7.dialogRapportValid = false;
            }
          } else {
            _this7.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
            _this7.loading = false;
            _this7.dialogRapportValid = false;
          }
        }, function (response) {
          _this7.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
          _this7.loading = false;
        });
      } else {
        this.$message.error('Veuillez selectionner les taches concernees / le champs description');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le rapport de visite n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    modalDeleteVisite: function modalDeleteVisite(ligne) {
      this.visiteCourant = ligne;
      this.dialogSupVisite = true;
    },
    deleteVisite: function deleteVisite(ligne) {
      var _this8 = this;

      this.loading = true;
      var url = this.domaine + 'visitechantier/delete/' + this.visiteCourant.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this8.$notify({
            title: 'SUPPRESSION',
            message: response.body.message,
            type: 'success',
            position: 'top-center'
          });
          _this8.loadVisiteChantier();
          _this8.dialogSupVisite = false;
          _this8.loading = false;
        }
      });
    },
    imprimeListeVisite: function imprimeListeVisite(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "visitechantier/imprimerPDF/liste";
      } else {
        url = this.domaine + "visitechantier/imprimerEXC/liste";
      }
      window.open(url);
    },
    imprimerVisiteChantier: function imprimerVisiteChantier(ligne) {
      var url = this.domaine + "visitechantier/imprimerPDF/" + ligne.id + "/visite";
      window.open(url);
    },
    toggleSelection: function toggleSelection(rows) {
      var _this9 = this;

      if (rows) {
        rows.forEach(function (row) {
          _this9.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    }
  }, 'handleSelectionChange', function handleSelectionChange(val) {
    this.multipleSelection = val;
  }),
  computed: {}
});

/***/ }),

/***/ "MMZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: "ModalComparateurCmd",
  props: {
    showModalCompCmd: {
      type: Boolean
    },
    show: {
      type: Boolean
    },
    infOrenseigner: {
      type: Array
    },
    commandeDeriv: {
      type: Array,
      required: false
    },
    commandeDerivDeux: {
      type: Array
    },
    mntTotalCmd: {
      type: String
    },
    nbCommandeSug: {
      type: Number
    },
    nbCommandeSugDeux: {
      type: Number
    },
    typeCommande: {
      type: Number,
      default: 1 //1=>Commande avec des options commandes//2=> commande avec des optionBesoins
    }
  },
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),

      loading: false,
      dialogDetailCmd: false,
      dialogComm: false,
      deleteValeur: 0,
      valid: true,
      dialogConfirmation: false,
      fourSelct: [],
      listproduitFournisseur: [],
      selectFourn: "",
      dateLivr: "",
      priorite: "",
      libelle: "",
      totalComHT: 0,
      totalComTVA: 0,
      totalComTTC: 0,
      indexFour: "",

      //details de commande
      projetLib: "",
      entrepotLib: "",
      chantieretLib: "",
      travauxLib: "",
      priorites: [{
        value: 1,
        label: "Faible"
      }, {
        value: 2,
        label: "Normal"
      }, {
        value: 3,
        label: "Urgent"
      }]
    };
  },


  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogDetailCmd = newValue;
      if (newValue == true) {
        //this.nbCmdDerive = this.cmdDerbivees.length
      }
    }
  },

  methods: {
    validCmdDerivees: function validCmdDerivees() {
      var _this = this;

      this.loading = true;
      this.dialogConfirmation = false;
      this.showModalCompCmd = false;
      var formdata = new FormData();
      formdata.append("commandes", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.listproduitFournisseur));
      formdata.append("idUser", this.user.id);
      formdata.append("typeCommande", this.typeCommande);
      formdata.append("prioriteCommande", this.priorite);
      formdata.append("idTravaux", this.infOrenseigner[6]);
      var url = this.domaine + "comparateur/commande/new/create";
      this.$http.post(url, formdata).then(function (response) {
        _this.loading = false;
        _this.dialogComm = false;
        if (_this.deleteValeur == 1) {
          _this.commandeDeriv.splice(_this.indexFour);
        } else {
          _this.commandeDerivDeux.splice(_this.indexFour);
        }
        _this.$notify({
          title: "VALIDATION REUSSIE",
          message: "Les commandes ont été enregitrées.",
          type: "success",
          position: "top-center"
        });
        _this.closeDialog();
      }, function (error) {
        _this.$message.error("Erreur serveur");
        _this.loading = false;
        _this.closeDialog();
      });
    },
    creeCommande: function creeCommande(item, index, type) {
      this.dialogComm = true;
      this.deleteValeur = type;
      this.libelle = this.infOrenseigner[0];
      this.dateLivr = this.infOrenseigner[1];
      var prioriteSelect = this.infOrenseigner[2];
      this.projetLib = this.infOrenseigner[3];
      this.travauxLib = this.infOrenseigner[4];
      this.chantieretLib = this.infOrenseigner[5];
      this.entrepotLib = this.infOrenseigner[7];
      this.selectFourn = item.fournisseur;

      // id du fournisseur selectionner pour la suppresion dans la liste des propositions
      this.indexFour = index;
      var fini = this.priorites.find(function (prod) {
        if (prod.value == prioriteSelect) {
          return prod.label;
        }
      });
      this.priorite = fini.label;
      this.listproduitFournisseur = item;
      var tabFounr = item.produits;
      this.totalComHT = 0;
      this.totalComTVA = 0;
      this.totalComTTC = 0;
      for (var prop in item.produits) {
        var currentC = item.produits[prop];

        this.totalComHT += currentC.prixU * currentC.qteProd;
        this.totalComTVA += Math.round(currentC.prixU * currentC.qteProd * (currentC.tva / 100));
        var tot = currentC.prixU * currentC.qteProd + Math.round(currentC.prixU * currentC.qteProd * (currentC.tva / 100));
        this.totalComTTC += tot;
      }
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    }
  }, //methods

  mounted: function mounted() {}
});

/***/ }),

/***/ "MQyO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MWL9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectionTechnicien_vue__ = __webpack_require__("ot2n");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a21db1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectionTechnicien_vue__ = __webpack_require__("gpTY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectionTechnicien_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65a21db1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectionTechnicien_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MasU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_widgetTravaux_vue__ = __webpack_require__("r8XM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f30faabe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_widgetTravaux_vue__ = __webpack_require__("o8fG");
function injectStyle (ssrContext) {
  __webpack_require__("qHJW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f30faabe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_widgetTravaux_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f30faabe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_widgetTravaux_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N2ME":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FullCalendar_vue__ = __webpack_require__("8Uc3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_75db3bf7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FullCalendar_vue__ = __webpack_require__("CCLi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_FullCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_75db3bf7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_FullCalendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N3SU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationFacture_vue__ = __webpack_require__("W5pE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15306673_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationFacture_vue__ = __webpack_require__("reW9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationFacture_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15306673_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationFacture_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N6XL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_boardProjet_liste_projet__ = __webpack_require__("toja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { listeProjet: __WEBPACK_IMPORTED_MODULE_0__components_boardProjet_liste_projet__["a" /* default */], Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: "IndexProjet",
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [{ path: "/boardProjet", text: "DashBoard Projet", disabled: false }],

      projets: []
    };
  },


  methods: {
    loadProjet: function loadProjet() {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "projet/" + this.user.id + "/chefProjet/index";
      this.$http.get(url).then(function (response) {
        _this.projets = response.body.projet;
        _this.loading = false;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Echec lors du chargement des projets");
      });
    }
  },

  mounted: function mounted() {
    this.loadProjet();
  }
});

/***/ }),

/***/ "NE5R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "DetailIntervention",
  props: ["show", "intervDetail"],
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      dialogDetail: false,
      tableProduit: [],
      totalTTC: 0,
      formRapport: {},
      dialogVisible: false,
      dialogImageUrl: "",
      imageDmd1: ""
    };
  },


  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogDetail = newValue;
      if (newValue == true) {
        //this.loadDevisConstat()
      }
    }
  },

  methods: {
    imprimerDemande: function imprimerDemande(idInterv) {
      var url = this.domaine + "intervention/" + idInterv + "/imprimer/" + this.user.id;

      window.open(url);
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    handleRemove: function handleRemove(file, fileList) {},
    handleSuccess: function handleSuccess(response, file, fileList) {
      this.fileList.push(file);
    },
    handlePictureCardPreview: function handlePictureCardPreview(file, fileList) {
      this.dialogImageUrl = file.url;

      this.dialogVisible = true;
    },
    imprimerDetail: function imprimerDetail() {
      var url = this.domaine + "demande_maintenance/imprimerPDF/demande/" + this.user.id + "/" + this.demandeDetail.idDemande;
      window.open(url);
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_design_icons_iconfont_dist_material_design_icons_css__ = __webpack_require__("gJtD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_material_design_icons_iconfont_dist_material_design_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_material_design_icons_iconfont_dist_material_design_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuesax__ = __webpack_require__("p7o8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuesax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuesax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stylus_main_styl__ = __webpack_require__("tLfa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stylus_main_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__stylus_main_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_fr__ = __webpack_require__("SjQo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_amcharts3__ = __webpack_require__("wDpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_amcharts3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_amcharts3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_amcharts3_amcharts_serial__ = __webpack_require__("9EFi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_amcharts3_amcharts_serial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_amcharts3_amcharts_serial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuesax_dist_vuesax_css__ = __webpack_require__("R5w9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuesax_dist_vuesax_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuesax_dist_vuesax_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dataTable_data_tables_min_js__ = __webpack_require__("6DNL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dataTable_data_tables_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_dataTable_data_tables_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Routes__ = __webpack_require__("qvaN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_context_menu__ = __webpack_require__("wVNm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_context_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_context_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_async_data__ = __webpack_require__("KGmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_async_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_async_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_full_calendar__ = __webpack_require__("QaH6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_filter_date_format__ = __webpack_require__("d/Bt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_echarts__ = __webpack_require__("cs+8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_echarts_lib_chart_bar__ = __webpack_require__("GbHy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_echarts_lib_chart_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_echarts_lib_chart_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_echarts_lib_component_tooltip__ = __webpack_require__("Oq2I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_cool_lightbox__ = __webpack_require__("EaaM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_cool_lightbox_dist_vue_cool_lightbox_min_css__ = __webpack_require__("/9jh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_cool_lightbox_dist_vue_cool_lightbox_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_cool_lightbox_dist_vue_cool_lightbox_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


























// import ECharts modules manually to reduce bundle size

 // register component to use

//lightbox


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_vue_cool_lightbox__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('v-chart', __WEBPACK_IMPORTED_MODULE_21_vue_echarts___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_fr___default.a });
//Vue.use(VueApexCharts)

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_amcharts3___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_amcharts3_amcharts_serial___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuesax___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_context_menu___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_dataTable_data_tables_min_js___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_full_calendar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_async_data___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_filter_date_format__["a" /* default */]);
var moment = __webpack_require__("PJh5");
__webpack_require__("tzHd");
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__webpack_require__("8AgW"), {
  moment: moment
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_15__router__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_12__App__["a" /* default */], Login: __WEBPACK_IMPORTED_MODULE_13__components_Login__["a" /* default */] },
  render: function render(createElement) {
    var session = sessionStorage.getItem('sessionUser');
    if (this.$router.history.current.name === 'routes') {
      return createElement(__WEBPACK_IMPORTED_MODULE_14__components_Routes__["a" /* default */]);
    } else {
      if (session) {
        return createElement(__WEBPACK_IMPORTED_MODULE_12__App__["a" /* default */]);
      } else {
        return createElement(__WEBPACK_IMPORTED_MODULE_13__components_Login__["a" /* default */]);
      }
    }
  },
  http: {
    root: '/root',
    headers: {
      Authorization: 'Basic YXBpOnBhc3N3b3Jk'
    }
  },
  mounted: function mounted() {},

  methods: {
    back: function back() {
      this.$router.go(-1);
    },
    redirect: function redirect() {}
  }

});

/***/ }),

/***/ "NIRu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogDetailCmd),callback:function ($$v) {_vm.dialogDetailCmd=$$v},expression:"dialogDetailCmd"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Détail de la commande analyser par le comparateur ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":""}},[(_vm.commandeDeriv.length != 0)?_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v("COMMANDE(S) SUGGEREE(S) POUR LES FOURNISSEURS AYANT TOUS\n                  LES PRODUITS DE LA COMMANDE")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-container',[_c('v-layout',{staticClass:"mb-2",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v("\n                          "+_vm._s(_vm.nbCommandeSug)+"\n                        ")]),_vm._v("\n                        Fournisseur(s) proprosant des meilleurs prix pour\n                        ce(s) produit(s)\n                      ")],1)],1)],1)],1),_vm._v(" "),_c('v-container',_vm._l((_vm.commandeDeriv),function(fourn,indF){return _c('v-layout',{key:indF},[_c('v-flex',{staticClass:"mb-4 pl-3 pt-3 mr-3 elevation-5",attrs:{"xs12":""}},[(indF == 0)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"mb-2",attrs:{"xs8":""}},[_c('v-chip',{staticClass:"elevation-4 text-xs-left",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Fournisseur :    \n                          ")]),_vm._v(" "),_c('span',{staticClass:"title text-xs-left"},[_vm._v("\n                            "+_vm._s(fourn.fournisseur))])]),_vm._v(" "),_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total HT:    \n                          ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("\n                            "+_vm._s(new Intl.NumberFormat().format(fourn.mntTotalHt))+"\n                            Fcfa\n                          ")])]),_vm._v(" "),_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total TTC:   \n                          ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("\n                            "+_vm._s(new Intl.NumberFormat().format(fourn.mntTotal))+"\n                            Fcfa\n                          ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{attrs:{"data":fourn.produits}},[_c('el-table-column',{attrs:{"prop":"codeGestion","label":"Code analytique"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleProduit","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteProd","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixUFormat","label":"Prix Unitaire (Fcfa)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"Tva"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotalHt","label":"Total HT (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("\n                                "+_vm._s(scope.row.mntTotalFormatHt))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotal","label":"Total TTC (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(" "+_vm._s(scope.row.mntTotalFormat))])]}}],null,true)})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[(indF != 0)?_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){return _vm.creeCommande(fourn, indF, 1)}},slot:"activator"},[_vm._v("\n                              Créer commande\n                              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("check")])],1):_vm._e(),_vm._v("Créer une commande chez ce fournisseur\n                          ")],1):_vm._e(),_vm._v(" "),(indF == 0)?_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"green","dark":""},on:{"click":function($event){return _vm.creeCommande(fourn, indF, 1)}},slot:"activator"},[_vm._v("\n                              Créer commande\n                              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("check")])],1):_vm._e(),_vm._v("Créer une commande chez ce fournisseur\n                          ")],1):_vm._e()],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)}),1)],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.commandeDerivDeux.length != 0)?_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"teal","dark":""}},[_c('v-toolbar-title',[_vm._v("COMMANDE(S) SUGGEREE(S) POUR LES FOURNISSEURS AYANT\n                  CERTAINS PRODUITS DE LA COMMANDE")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-container',[_c('v-layout',{staticClass:"mb-2",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v("\n                          "+_vm._s(_vm.nbCommandeSugDeux)+"\n                        ")]),_vm._v("\n                        Fournisseur(s) proprosant des meilleurs prix pour\n                        ce(s) produit(s)\n                      ")],1)],1)],1)],1),_vm._v(" "),_c('v-container',_vm._l((_vm.commandeDerivDeux),function(fourn,indF){return _c('v-layout',{key:indF},[_c('v-flex',{staticClass:"mb-4 pl-3 pt-3 mr-3 elevation-5",attrs:{"xs12":""}},[(indF == 0)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"mb-2",attrs:{"xs8":""}},[_c('v-chip',{staticClass:"elevation-4 text-xs-left",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Fournisseur :   \n                          ")]),_vm._v(" "),_c('span',{staticClass:"title text-xs-left"},[_vm._v("\n                            "+_vm._s(fourn.fournisseur))])]),_vm._v(" "),_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total HT:    \n                          ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("\n                            "+_vm._s(new Intl.NumberFormat().format(fourn.mntTotalHt))+"\n                            Fcfa\n                          ")])]),_vm._v(" "),_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total TTC:    \n                          ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("\n                            "+_vm._s(new Intl.NumberFormat().format(fourn.mntTotal))+"\n                            Fcfa\n                          ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{attrs:{"data":fourn.produits}},[_c('el-table-column',{attrs:{"prop":"codeGestion","label":"Code analytique"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleProduit","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteProd","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixUFormat","label":"Prix Unitaire (Fcfa)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"Tva"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotalHt","label":"Total HT (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("\n                                "+_vm._s(scope.row.mntTotalFormatHt))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotal","label":"Total TTC (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(" "+_vm._s(scope.row.mntTotalFormat))])]}}],null,true)})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[(indF != 0)?_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){return _vm.creeCommande(fourn, indF, 2)}},slot:"activator"},[_vm._v("\n                              Créer commande\n                              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("check")])],1):_vm._e(),_vm._v("Créer une commande chez ce fournisseur\n                          ")],1):_vm._e(),_vm._v(" "),(indF == 0)?_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"green","dark":""},on:{"click":function($event){return _vm.creeCommande(fourn, indF, 2)}},slot:"activator"},[_vm._v("\n                              Créer commande\n                              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("check")])],1):_vm._e(),_vm._v("Créer une commande chez ce fournisseur\n                          ")],1):_vm._e()],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)}),1)],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5",staticStyle:{"margin-right":"30px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":""},on:{"click":function($event){$event.stopPropagation();return _vm.closeDialog()}},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Femer")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.dialogConfirmation),callback:function ($$v) {_vm.dialogConfirmation=$$v},expression:"dialogConfirmation"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Voulez-vous valider les commandes proposées ?")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        Après la confirmation, les commandes ne pourront plus être modifiées\n        et seront soumises pour validation au DIRECTEUR GENERAL, vous serez\n        informé par des notifications sms et mail.\n      ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialogConfirmation = false}}},[_vm._v("\n          Annuler\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat","disabled":_vm.loading},on:{"click":function($event){return _vm.validCmdDerivees()}}},[_vm._v("\n          Confirmer\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogComm),callback:function ($$v) {_vm.dialogComm=$$v},expression:"dialogComm"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Creer une nouvelle commande depuis le comparateur")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogComm = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n            DETAILS ASSOCIE A LA COMMANDE\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),_c('v-form',{ref:"formComm",attrs:{"lazy-validation":"","id":"formComm"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Fournisseur *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"placeholder":"Fournisseur"},model:{value:(_vm.selectFourn),callback:function ($$v) {_vm.selectFourn=$$v},expression:"selectFourn"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Intitulé de la commande *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Intitulé de la commande"},model:{value:(_vm.libelle),callback:function ($$v) {_vm.libelle=$$v},expression:"libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de livraison *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateLivr","id":"dateLivr","value-format":"yyyy-MM-dd","value":"dd-MM-yyyy","type":"date","placeholder":"Date de livraison"},model:{value:(_vm.dateLivr),callback:function ($$v) {_vm.dateLivr=$$v},expression:"dateLivr"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Priorité commande")]),_vm._v(" "),_c('el-select',{attrs:{"required":"","placeholder":"Priorite"},model:{value:(_vm.priorite),callback:function ($$v) {_vm.priorite=$$v},expression:"priorite"}},_vm._l((_vm.priorites),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])],1),_vm._v(" "),(_vm.projetLib != '')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Projet","readonly":true},model:{value:(_vm.projetLib),callback:function ($$v) {_vm.projetLib=$$v},expression:"projetLib"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chantier concerné")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Chantier","readonly":true},model:{value:(_vm.chantieretLib),callback:function ($$v) {_vm.chantieretLib=$$v},expression:"chantieretLib"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Travaux","readonly":true},model:{value:(_vm.travauxLib),callback:function ($$v) {_vm.travauxLib=$$v},expression:"travauxLib"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.projetLib == '' && _vm.entrepotLib != '')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Magasin concerné")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Entrepot","readonly":true},model:{value:(_vm.entrepotLib),callback:function ($$v) {_vm.entrepotLib=$$v},expression:"entrepotLib"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.entrepotLib == '' && _vm.travauxLib == '')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Autre")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":"Autre","placeholder":"AUTRE","readonly":true}})],1)])],1):_vm._e(),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                DETAILS DES LIGNES DE LA COMMANDE\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"wrap":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"29px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                      MONTANT HT :\n                      "+_vm._s(new Intl.NumberFormat().format(_vm.totalComHT))+" FCFA\n                    ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"29px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                      MONTANT TVA :\n                      "+_vm._s(new Intl.NumberFormat().format(_vm.totalComTVA))+" FCFA\n                    ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"29px"},attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                      MONTANT TTC :\n                      "+_vm._s(new Intl.NumberFormat().format(_vm.totalComTTC))+" FCFA\n                    ")])],1)],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{attrs:{"data":_vm.listproduitFournisseur.produits}},[_c('el-table-column',{attrs:{"prop":"codeGestion","label":"Code analytique"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleProduit","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteProd","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixUFormat","label":"Prix Unitaire (Fcfa)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"Tva"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotal","label":"Total (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(" "+_vm._s(scope.row.mntTotalFormat))])]}}])})],1)],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogComm = false}}},[_vm._v("\n              Annuler\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){_vm.dialogConfirmation = true}}},[_vm._v("\n              Enregistrer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NLC5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NMfS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationDga_vue__ = __webpack_require__("Y62D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60507f60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationDga_vue__ = __webpack_require__("vSGz");
function injectStyle (ssrContext) {
  __webpack_require__("AA+V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60507f60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationDga_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60507f60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationDga_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NPGg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formTypeTravaux_vue__ = __webpack_require__("tlJT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afe96bc6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formTypeTravaux_vue__ = __webpack_require__("uwwA");
function injectStyle (ssrContext) {
  __webpack_require__("uxeM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-afe96bc6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formTypeTravaux_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afe96bc6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formTypeTravaux_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NR+o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NTOg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fournisseur_vue__ = __webpack_require__("8Rus");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b61652_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fournisseur_vue__ = __webpack_require__("ugns");
function injectStyle (ssrContext) {
  __webpack_require__("LeWP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Fournisseur_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48b61652_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Fournisseur_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NUJi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardRapport_vue__ = __webpack_require__("8uk5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86eb552c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardRapport_vue__ = __webpack_require__("aaRc");
function injectStyle (ssrContext) {
  __webpack_require__("aTKr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardRapport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86eb552c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardRapport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nb+n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogDetail),callback:function ($$v) {_vm.dialogDetail=$$v},expression:"dialogDetail"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Detail de la demande")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"icons":"","dark":"","color":"orange"},on:{"click":function($event){return _vm.imprimerDemande(_vm.intervDetail.id)}}},[_vm._v("imprimer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                    Informations generales sur la demande\n                  ")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Reference de l'intervention")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.intervDetail.ref)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Vehicule ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.intervDetail.vehicule)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Chauffeur du véhicule ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.intervDetail.conducteur)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Montant Total (Fcfa) ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(new Intl.NumberFormat().format(
                                        _vm.intervDetail.mntTotal
                                      ))+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date demande ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.intervDetail.dateFormat2)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Type")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.intervDetail.type)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Gravite")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.intervDetail.gravite)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),(_vm.intervDetail.etat == 2)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Motif de refus")]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('el-form',{staticClass:"demo-ruleForm"},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":""}},[_c('el-input',{attrs:{"readonly":true,"type":"textarea"},model:{value:(
                                            _vm.intervDetail.remarqueValider
                                          ),callback:function ($$v) {_vm.$set(_vm.intervDetail, "remarqueValider", $$v)},expression:"\n                                            intervDetail.remarqueValider\n                                          "}})],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs3":""}},[_c('a',{attrs:{"href":_vm.intervDetail.photoDevis,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.intervDetail.photoDevis}})])],1)])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Categorie")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.intervDetail.categorie)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Priorite")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.intervDetail.priorite)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Enregistré par ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.intervDetail.demandeur)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),(_vm.intervDetail.kilometrage)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Kilometrage ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.intervDetail.kilometrage)+"\n                                  ")])],1):_vm._e(),_vm._v(" "),(_vm.intervDetail.kilometrage)?_c('v-divider',{staticClass:"mb-3"}):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Etat")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.intervDetail.libEtat)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),(_vm.intervDetail.caisse)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Caisse ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.intervDetail.caisse)+"\n                                  ")])],1):_vm._e(),_vm._v(" "),(_vm.intervDetail.caisse)?_c('v-divider',{staticClass:"mb-3"}):_vm._e(),_vm._v(" "),(_vm.intervDetail.datePaiementFormat)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de paiement ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.intervDetail.datePaiementFormat)+"\n                                  ")])],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Description")]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('el-form',{staticClass:"demo-ruleForm"},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":""}},[_c('el-input',{attrs:{"readonly":true,"type":"textarea"},model:{value:(_vm.intervDetail.motif),callback:function ($$v) {_vm.$set(_vm.intervDetail, "motif", $$v)},expression:"intervDetail.motif"}})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.intervDetail.diagnostiqueId)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                      Diagnostique\n                    ")])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"text-xs-left mb-3",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Reference Diagnostique")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                          Ref-DIAG-"+_vm._s(_vm.intervDetail.diagnostiqueId)+"\n                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Diagnostique")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                          "+_vm._s(_vm.intervDetail.libelleDiag)+"\n                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date d'enregistrement ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                          "+_vm._s(_vm.intervDetail.dateDiagEnreg)+"\n                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs3":""}},[_c('a',{attrs:{"href":_vm.intervDetail.imageDmd,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.intervDetail.imageDmd}})])],1)])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left ml-4",attrs:{"xs6":""}},[(_vm.intervDetail.maindoeuvre)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Main d'oeuvre (Fcfa)")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                          "+_vm._s(_vm.intervDetail.maindoeuvre)+"\n                        ")])],1):_vm._e(),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Diagnostique enregistré par")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                          "+_vm._s(_vm.intervDetail.userDiag)+"\n                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Entrepot concerné")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                          "+_vm._s(_vm.intervDetail.entrepot)+"\n                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-3 pl-2"},[_c('h3',[_vm._v("LISTE DES ARTICLES EN STOCK")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (TTC):\n                              "+_vm._s(_vm.intervDetail.mntArtStock)+" fcfa")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.intervDetail.articleStock}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Designation","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cout","label":"Prix unitaire"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"Tva"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Total"}})],1)],1),_vm._v(" "),_c('br')],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.intervDetail.etat > 0)?_c('v-flex',{staticClass:"mt-4",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-3 pl-2"},[_c('h3',[_vm._v("LISTE DES ARTICLES FOURNIS PAR LE GARAGE")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (TTC):\n                              "+_vm._s(_vm.intervDetail.mntArtGarage)+" fcfa")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.intervDetail.devis}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Designation","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cout","label":"Prix unitaire"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"Tva"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Total"}})],1)],1),_vm._v(" "),_c('br')],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.intervDetail.etat >= 5)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                    Planification de l'intervention\n                  ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de debut de l'intervention")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                              "+_vm._s(_vm.intervDetail.dateDFormat2)+"\n                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de fin de l'intervention")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                              "+_vm._s(_vm.intervDetail.dateFFormat2)+"\n                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.intervDetail.etat == 5)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                    Rapport de depannage\n                  ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-layout',{attrs:{"row":""}},[(_vm.intervDetail.url)?_c('v-flex',{staticClass:"mr-3",attrs:{"xs3":""}},[_c('a',{attrs:{"href":_vm.intervDetail.url,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.intervDetail.url}})])],1)]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_vm._v("Remarque")]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('el-form',{staticClass:"demo-ruleForm"},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":""}},[_c('el-input',{attrs:{"readonly":true,"type":"textarea"},model:{value:(_vm.intervDetail.remarqueFin),callback:function ($$v) {_vm.$set(_vm.intervDetail, "remarqueFin", $$v)},expression:"intervDetail.remarqueFin"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)],1)],1)],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Nbbm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_validationDG_ModalValidationDmd__ = __webpack_require__("J/ex");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_validationDG_ModalValidationDmdFond__ = __webpack_require__("DUFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_validationDG_ModalValidationDex__ = __webpack_require__("Hogj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_validationDG_ModalValidationMiss__ = __webpack_require__("0ygq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_validationDG_ModalValidationFacture__ = __webpack_require__("N3SU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_validationDG_ModalValidationInterv__ = __webpack_require__("gpm2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_validationDG_ModalValidationAppro__ = __webpack_require__("iWoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__facturePaiement__ = __webpack_require__("UgjE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_resourceHumaine_liste_demande__ = __webpack_require__("YSKP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Loading__ = __webpack_require__("NxGh");




var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        facturePaiement: __WEBPACK_IMPORTED_MODULE_10__facturePaiement__["a" /* default */],
        Loading: __WEBPACK_IMPORTED_MODULE_12__components_Loading__["a" /* default */], ModalValidationDmd: __WEBPACK_IMPORTED_MODULE_3__components_validationDG_ModalValidationDmd__["a" /* default */], ModalValidationMiss: __WEBPACK_IMPORTED_MODULE_6__components_validationDG_ModalValidationMiss__["a" /* default */], ModalValidationFacture: __WEBPACK_IMPORTED_MODULE_7__components_validationDG_ModalValidationFacture__["a" /* default */], ModalValidationInterv: __WEBPACK_IMPORTED_MODULE_8__components_validationDG_ModalValidationInterv__["a" /* default */], ModalValidationDmdFond: __WEBPACK_IMPORTED_MODULE_4__components_validationDG_ModalValidationDmdFond__["a" /* default */], ModalValidationDex: __WEBPACK_IMPORTED_MODULE_5__components_validationDG_ModalValidationDex__["a" /* default */], ModalValidationAppro: __WEBPACK_IMPORTED_MODULE_9__components_validationDG_ModalValidationAppro__["a" /* default */], listeDemande: __WEBPACK_IMPORTED_MODULE_11__components_resourceHumaine_liste_demande__["a" /* default */] },
    name: "app",
    data: function data() {
        var _ref;

        return _ref = {
            //data general
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            racourcis: [{ path: '/', text: 'Accueil', disabled: false }, { path: '/validationDmd', text: 'Dashboard des validations', disabled: true }],
            dialogValideSuivant: false,
            typeDmd: null,
            itemDmd: {},
            items: [],
            index: null,

            // stretch: false,
            //VALIDATION DES sDEMANDES
            listeDemandes: [],
            selectZoneDmd: '',
            oldListDemandes: [],
            legendeDmd: "LISTE DES DEMANDES DE MAINTENANCES A VALIDER",
            comboZoneDmd: [],
            mntTTCAValide: 0,
            demandeDetail: {},
            showModalDetailDmd: false,
            nbDmdMaint: 0,

            //VALIDATION MISSIONS
            legendeMiss: "LISTE DES DEMANDES DE MISSION A VALIDER",
            listeMissions: [],
            oldListMissions: [],
            selectMissDemd: "",
            listeDemandeurs: [],
            nbMiss: 0,
            mntTotalMissTTC: 0,
            detailMission: {},
            showModalDetailMiss: false,

            //VALIDATION FACTURE FOURNISSEUR
            legendeFour: "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER",
            nbFactFour: 0,
            listeFournisseurs: [],
            listeFacturesFour: [],
            oldListFacturesFour: [],
            selectFour: '',
            mntTotalFactTTC: 0,
            factureDetail: {},
            showModalDetailFact: false,

            //VALIDATION DES DEMANDES APPROVISIONNEMENTS
            legendeAppro: "LISTE DES DEMANDES APPROVISIONNEMENTS",
            mntTotalAppro: 0,
            listeDmdNoValidAppro: [],
            showModalDetailAppro: false,
            ApproDetail: {},
            nbAppro: 0,
            listBanque: [],
            listCaisse: [],

            //VALIDATION INTERVENTION
            legendeInterv: "LISTE DES REPARATIONS A VALIDER",
            mntTotalIntervTTC: 0,
            nbInterv: 0,
            selectInterv: '',
            listeDemdInterv: [],
            listeIntervention: [],
            oldListeIntervention: [],
            intervDetail: [],
            showModalIntervFact: false,

            //VALIDATION DENANDE DE FONDS
            legendeDmdFond: "LISTE DES DEMANDES DE FONDS A VALIDER",
            mntTotalDmdFondTTC: 0,
            nbDmdFond: 0,
            selectDmdFond: '',
            listeDemandeurFond: [],
            listeDmdFond: [],
            oldListeDemandeurFond: [],
            dmdFondDetail: [],
            showModalDetailDmdFond: false,
            onglet: "0",

            //VALIDATION DEMANDE CONGE
            listeDemandeurAbs: [],
            //VALIDATION COMMANDE
            legendeDmdCom: "LISTE DES BONS DE COMMANDES A VALIDER",
            mntTotalDmdComTTC: 0,
            nbDmdCom: 0,
            selectDmdCom: '',
            listeDemandeurCom: [],
            listeDmdCom: [],
            oldListeDemandeurCom: [],
            dmdComDetail: [],
            detailCommande: [],
            totalMontant: 0,
            totalComHT: [],
            totalComTVA: [],
            totalComRemise: [],
            showModalDetailDmdCom: false,
            commCourant: []
        }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'onglet', "0"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'listeProdNull', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'mntTotalCmd', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'listeProdNull', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'commandeDeriv', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'commandeDerivDeux', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'nbCommandeSug', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'nbCommandeSugDeux', 0), _ref;
    },


    methods: (_methods = {
        SubmitValideSuivant: function SubmitValideSuivant() {
            switch (this.typeDmd) {
                case "maintenance":
                    this.dialogValideSuivant = false;
                    this.modalDetailDmd(this.itemDmd);
                    break;

                case "intervention":
                    this.dialogValideSuivant = false;
                    this.modalDetailInterv(this.itemDmd);
                    break;
                case "factureFour":
                    this.dialogValideSuivant = false;
                    this.modalDetailFour(this.itemDmd);
                    break;
                case "mission":
                    this.dialogValideSuivant = false;
                    this.modalDetailMissDemd(this.itemDmd);
                    break;
                case "bonCommandeInterne":
                    this.dialogValideSuivant = false;
                    this.modalDetailDmdCom(this.itemDmd);
                    break;

                case "demandeFond":
                    this.dialogValideSuivant = false;
                    this.modalDetailDmdFond(this.itemDmd);
                    break;
            }
        },
        CancelValideSuivant: function CancelValideSuivant() {
            switch (this.typeDmd) {
                case "maintenance":
                    this.dialogValideSuivant = false;
                    this.loadDemandeAvalider();
                    break;

                case "intervention":
                    this.dialogValideSuivant = false;
                    this.loadDmdIntervention();
                    break;
                case "factureFour":
                    this.dialogValideSuivant = false;
                    this.loadFacture();
                    break;
                case "mission":
                    this.dialogValideSuivant = false;
                    this.loadMissionsAvalider;
                    break;

                case "bonCommandeInterne":
                    this.dialogValideSuivant = false;
                    this.modalDetailDmdCom(this.itemDmd);
                    break;
                case "demandeFond":
                    this.dialogValideSuivant = false;
                    this.loadDmdFond();
                    break;
            }
        },
        showDialogDmdAfter: function showDialogDmdAfter(idDmd, type) {
            this.showModalDetailDmd = false;
            this.listeDemandes = this.listeDemandes.filter(function (elm) {
                return elm.idDemande != idDmd;
            });

            if (this.listeDemandes.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDemandes[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadDemandeAvalider();
            }
        },
        showDialogDmdFondAfter: function showDialogDmdFondAfter(idDmd, type) {
            this.showModalDetailDmdFond = false;
            this.listeDmdFond = this.listeDmdFond.filter(function (elm) {
                return elm.id != idDmd;
            });
            console.log('idDmd', idDmd, type);

            if (this.listeDmdFond.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDmdFond[0];
                    this.typeDmd = type;
                    console.log('hdhd', type);
                    this.dialogValideSuivant = true;
                } else {
                this.loadDmdFond();
            }
        },
        showDialogDmdComAfter: function showDialogDmdComAfter(idDmd, type) {
            this.showModalDetailDmdCom = false;
            this.listeDmdCom = this.listeDmdCom.filter(function (elm) {
                return elm.id != idDmd;
            });
            if (this.listeDmdCom.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDmdCom[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadDmdCom();
            }
        },
        showDialogFactAfter: function showDialogFactAfter(idDmd, type) {
            this.listCaisse = [];
            this.listBanque = [];
            this.showModalDetailFact = false;
            this.loadFacture();
            this.listeFacturesFour = this.listeFacturesFour.filter(function (elm) {
                return elm.idFact != idDmd;
            });

            if (this.listeFacturesFour.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeFacturesFour[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadFacture();
            }
        },
        showDialogMissAfter: function showDialogMissAfter(idDmd, type) {
            this.showModalDetailMiss = false;
            this.listeMissions = this.listeMissions.filter(function (elm) {
                return elm.IdUtil != idDmd;
            });

            if (this.listeMissions.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeMissions[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadMissionsAvalider();
            }
        },
        showDialogIntervAfter: function showDialogIntervAfter(idDmd, type) {
            this.showModalIntervFact = false;
            this.listeIntervention = this.listeIntervention.filter(function (elm) {
                return elm.intervId != idDmd;
            });

            if (this.listeIntervention.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeIntervention[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadDmdIntervention();
            }
        },
        showDialogComAfter: function showDialogComAfter(idDmd, type) {
            this.showModalDetailDmdCom = false;
            this.listeDmdCom;
            this.listeDmdCom = this.listeDmdCom.filter(function (elm) {
                return elm.intervId != idDmd;
            });

            if (this.listeDmdCom.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDmdCom[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadDmdCom();
            }
        },


        //DEMANDE DE MAINTENANCE
        modalDetailDmd: function modalDetailDmd(item) {
            this.demandeDetail = item;
            this.showModalDetailDmd = true;
        },
        filtrerZoneDmd: function filtrerZoneDmd(idZone) {
            this.loadDmdParZone(idZone);
        },
        loadLieu: function loadLieu() {
            var _this = this;

            var url = this.domaine + 'validationDG/lieu';
            this.$http.get(url).then(function (response) {
                _this.comboZoneDmd = response.body.lieux;
            }, function (erreurRep) {});
        },
        loadDmdParZone: function loadDmdParZone(idZone) {
            this.legendeDmd = "LISTE DES DEMANDES DE MAINTENANCES A VALIDER FILTREES PAR ZONE";
            this.listeDemandes = this.oldListDemandes;
            this.listeDemandes = this.listeDemandes.filter(function (item) {
                return item.idZone == idZone;
            });
        },
        clearSelectDmdZone: function clearSelectDmdZone() {
            this.listeDemandes = this.oldListDemandes;
            this.legendeDmd = "LISTE DES DEMANDES DE MAINTENANCES A VALIDER";
        },
        loadDemandeAvalider: function loadDemandeAvalider() {
            var _this2 = this;

            this.loading = true;
            var url = this.domaine + 'validationDG/index/demandes';
            this.$http.get(url).then(function (response) {
                _this2.oldListDemandes = response.body.listeDemandes;
                _this2.listeDemandes = response.body.listeDemandes;
                _this2.mntTTCAValide = response.body.mntTTC;
                _this2.nbDmdMaint = response.body.nbMaint;
                _this2.loadLieu();
                _this2.loading = false;
            }, function (erreur) {
                _this2.loading = false;
                _this2.$message.error("Une erreur est survenue lors du chargement des demandes de maintenances'");
            });
        },


        //DEMANDE DE MISSION
        filtrerMissDemd: function filtrerMissDemd(idDemd) {
            this.loadMissionDemd(idDemd);
        },
        clearSelectMissDemd: function clearSelectMissDemd() {
            this.listeMissions = this.oldListMissions;
            this.legendeMiss = "LISTE DES DEMANDES DE MISSION A VALIDER";
        },
        loadMissionDemd: function loadMissionDemd(idDemd) {
            this.legendeMiss = "LISTE DES DEMANDES DE MISSION A VALIDER FILTREES PAR DEMANDEUR";
            this.listeMissions = this.oldListMissions;
            this.listeMissions = this.listeMissions.filter(function (item) {
                return item.idUserDemandeur == idDemd;
            });
        },
        loadMissionsAvalider: function loadMissionsAvalider() {
            var _this3 = this;

            var url = this.domaine + "validationDG/index/missions";
            this.$http.get(url).then(function (resp) {
                _this3.oldListMissions = resp.body.missions, _this3.listeMissions = resp.body.missions, _this3.nbMiss = resp.body.nbUtil, _this3.listeDemandeurs = resp.body.listeDemandeurs;
                _this3.mntTotalMissTTC = resp.body.mntTotalTTC;
            }, function (resp) {
                _this3.$message.error("erreur lors du chargement des missions.");
            });
        },
        modalDetailMissDemd: function modalDetailMissDemd(item) {
            this.detailMission = item;
            this.showModalDetailMiss = true;
        },


        //FACTURE FOURNISSEUR
        clearSelectFour: function clearSelectFour() {
            this.listeFacturesFour = this.oldListFacturesFour;
            this.legendeFour = "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER";
        },
        modalDetailFour: function modalDetailFour(item) {
            this.listBanque = [];
            this.listCaisse = [];
            if (item.listBanque.length == 0) {
                this.loadAllBanque();
            } else {
                this.listBanque = item.listBanque;
                this.listCaisse = item.listCaisse;
            }
            this.factureDetail = item;
            this.showModalDetailFact = true;
            this.showModalDetailFact = true;
            this.commandeDerivDeux = [];
            this.commandeDeriv = [];
            this.showDialogComparaison(item);
        },
        modalDetailDmdFond: function modalDetailDmdFond(item) {
            this.demandeDetail = item;
            this.showModalDetailDmdFond = true;
        },
        modalDetailDmdCom: function modalDetailDmdCom(ligne) {
            this.demandeDetail = ligne;
            this.showModalDetailDmdCom = true;
            this.commCourant = ligne;
            this.detailCommande = ligne;
            // this.showDialogComAfter(ligne, 'bonCommandeInterne')
        }
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'clearSelectFour', function clearSelectFour() {
        this.listeFacturesFour = this.oldListFacturesFour;
        this.legendeFour = "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER";
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'showDialogComparaison', function showDialogComparaison(item) {
        var _this4 = this;

        // this.loading = true;
        var smsAficher = "Aucune tarification de ce produit est indiqué chez vous fournisseurs ";
        var mesProdPrixNulle = "Les produits de cette commande ne se trouvent chez aucun autres de vos fournisseurs ";

        var formdata = new FormData();
        var url = this.domaine + "comparateur/new/commande";
        var options = [];
        var listProdPrixNulle = [];

        for (var prop in item.option) {
            var ligne = item.option[prop];
            options.push(ligne.id);
        }
        formdata.append("options", options);
        formdata.append("facture", 1);
        formdata.append("typeOption", 2); //optionBesoin

        this.$http.post(url, formdata).then(function (response) {
            //affichage des messages
            var nbCmd = 0;
            var nbCmdDeux = 0;
            var listeFoun = [];
            var listeNull = [];
            var listeFounSecond = [];

            var respFour = response.body.fournisseurs[0];
            _this4.mntTotalCmd = response.body.mntTotauxFormat;
            _this4.listeProdNull = response.body.listeProdNull;

            _this4.loading = false;
            for (var four in respFour) {
                var listeProduit = respFour[four];
                var infoFour = {
                    fournisseur: four,
                    produits: [],
                    mntTotal: 0,
                    mntTotalHt: 0

                };
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(listeProduit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var produit = _step.value;

                        infoFour.produits.push(produit);
                        infoFour.mntTotal += parseFloat(produit.mntTotal);
                        infoFour.mntTotalHt += parseFloat(produit.mntTotalHt);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                if (infoFour.produits.length == options.length) {
                    nbCmd++;
                    listeFoun.push(infoFour);
                } else {
                    nbCmdDeux++;

                    listeFounSecond.push(infoFour);
                }
            }
            _this4.nbCommandeSug = nbCmd;
            _this4.commandeDeriv = listeFoun;
            _this4.nbCommandeSugDeux = nbCmdDeux;
            _this4.commandeDerivDeux = listeFounSecond;
            // this.dialogDetailCmd = true;
            _this4.loading = false;
            //AFFICHAGE DE PRODUITS DONT LE MONTANT EST NULL
            if (response.body.listeProdNull.length > 0) {
                // this.dialogProdNull = true;
                //this.closeProdNull();
            }

            if (listeFoun.length > 0) {
                _this4.showModalCompCmd = true;
            }
            // }
        }, function (error) {
            _this4.loading = false;
            _this4.$message.error("Erreur serveur");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'filtrerFour', function filtrerFour() {
        var _this5 = this;

        // this.loadFactParFour(this.selectFour)
        var tab = this.listeFournisseurs;
        var newTab = [];
        this.listeFournisseurs = tab.filter(function (item) {
            if (item.value == _this5.selectFour) {
                newTab.push(item);
            }
            return newTab;
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'modalDetailAppro', function modalDetailAppro(item) {
        this.ApproDetail = item;
        this.showModalDetailAppro = true;
        this.loadListBanque(item.caisseId);
        this.loadListCaisse(item.caisseId);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadListBanque', function loadListBanque(item) {
        var _this6 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/tresor/' + item + '/banque';
        this.$http.get(url).then(function (response) {
            _this6.listBanque = response.body.listBanque;
            _this6.loading = false;
        }, function (errResp) {
            _this6.loading = false;
            _this6.$message.error("Une erreur est survenue lors du chargement de la liste banque");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadListCaisse', function loadListCaisse(item) {
        var _this7 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/tresor/' + item + '/caisse';
        this.$http.get(url).then(function (response) {
            _this7.listCaisse = response.body.listCaisse;
            _this7.loading = false;
        }, function (errResp) {
            _this7.loading = false;
            _this7.$message.error("Une erreur est survenue lors du chargement de la liste caisse");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadAllBanque', function loadAllBanque() {
        var _this8 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/tresor/banque';
        this.$http.get(url).then(function (response) {
            _this8.listBanque = response.body.listBanque;
            _this8.listCaisse = response.body.listCaisse;
            _this8.loading = false;
        }, function (errResp) {
            _this8.loading = false;
            _this8.$message.error("Une erreur est survenue lors du chargement de la liste banque");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadAllCaisse', function loadAllCaisse() {
        var _this9 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/tresor/caisse';
        this.$http.get(url).then(function (response) {
            _this9.listCaisse = response.body.listCaisse;
            _this9.loading = false;
        }, function (errResp) {
            _this9.loading = false;
            _this9.$message.error("Une erreur est survenue lors du chargement de la liste caisse");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadFactParFour', function loadFactParFour(idFour) {
        this.legendeFour = "LISTE DES DEVIS / FACTURES A VALIDER FILTREES PAR FOURNISSEUR";
        this.listeFacturesFour = this.oldListFacturesFour;
        this.listeFacturesFour = this.listeFacturesFour.filter(function (item) {
            return item.idUserDemandeur == idFour;
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadFacture', function loadFacture() {
        var _this10 = this;

        this.loading = true;
        var url = this.domaine + 'validationDG/fournisseur/facture';
        this.$http.get(url).then(function (response) {
            _this10.listeFournisseurs = response.body.listeFour;
            _this10.mntTotalFactTTC = response.body.totalFacture;
            _this10.nbFactFour = response.body.nbFact;
            _this10.listeFacturesFour = response.body.facture;
            _this10.oldListFacturesFour = response.body.facture;
            _this10.loading = false;
        }, function (resp) {
            _this10.$message.error("erreur lors du chargement des devis / factures fournisseurs.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'modalDetailInterv', function modalDetailInterv(item) {
        this.intervDetail = item;
        this.showModalIntervFact = true;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'clearSelectInterv', function clearSelectInterv() {
        this.listeIntervention = this.oldListeIntervention;
        this.legendeInterv = "LISTE DES REPARATIONS A VALIDER";
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'filtrerInterv', function filtrerInterv(idDemandeur) {
        this.loadDmdParInterv(idDemandeur);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdParInterv', function loadDmdParInterv(idDemandeur) {
        this.legendeInterv = "LISTE DES REPARATIONS A VALIDER FILTREES PAR DEMANDEUR";
        this.listeIntervention = this.oldListeIntervention;
        this.listeIntervention = this.oldListeIntervention.filter(function (item) {
            return item.idDemandeur == idDemandeur;
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdIntervention', function loadDmdIntervention() {
        var _this11 = this;

        this.loading = true;
        var url = this.domaine + 'validationDG/intervention/facture';
        this.$http.get(url).then(function (response) {
            _this11.listeIntervention = response.body.listeInterv;
            _this11.oldListeIntervention = response.body.listeInterv;
            _this11.mntTotalIntervTTC = response.body.mntTotal;
            _this11.nbInterv = response.body.nbInterv;
            _this11.listeDemdInterv = response.body.listeDemdInterv;
            _this11.loading = false;
        }, function (resp) {
            _this11.$message.error("erreur lors du chargement des demandes reparations.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'filtrerDmdFond', function filtrerDmdFond(idDemd) {
        this.loadDmdFond(idDemd);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'filtrerDmdCom', function filtrerDmdCom(idDemd) {
        this.loadDmdFond(idDemd);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdCom', function loadDmdCom() {
        var _this12 = this;

        this.loading = true;
        var url = this.domaine + "besoin/index/validation/dex/recent";
        this.$http.get(url).then(function (response) {
            _this12.loading = false;
            _this12.nbDmdCom = 0;
            if (response.body) {
                var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(response.body.besoin);

                _this12.nbDmdCom = data.length;
                _this12.listeDmdCom = data;
                _this12.oldListeDmdCom = data;
            }
        }, function (resp) {
            _this12.loading = false;
            _this12.$message.error("erreur lors du chargement des demandes de fonds.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdFond', function loadDmdFond() {
        var _this13 = this;

        this.loading = true;
        var url = this.domaine + 'validationDG/dmdFond/liste';
        this.$http.get(url).then(function (response) {
            _this13.listeDmdFond = response.body.listeDmdFond;
            _this13.oldListeDmdFond = response.body.listeDmdFond;
            _this13.mntTotalDmdFondTTC = response.body.mntTotal;
            _this13.nbDmdFond = response.body.nbDmdFond;
            _this13.listeDemandeurFond = response.body.listeDemandeurFond;
            _this13.loading = false;
        }, function (resp) {
            _this13.loading = false;
            _this13.$message.error("erreur lors du chargement des demandes de fonds.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdNoValidAppro', function loadDmdNoValidAppro() {
        var _this14 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/appro/no-valide-dg/all';
        this.$http.get(url).then(function (response) {
            _this14.listeDmdNoValidAppro = response.body.appro;
            _this14.mntTotalAppro = response.body.totDmdAppro;
            _this14.nbAppro = response.body.nbAppro;
            _this14.loading = false;
        }, function (resp) {
            _this14.$message.error("erreur lors du chargement des demandes approvisionnement.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'handleTabClick', function handleTabClick(tab) {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'clearSelectDmd', function clearSelectDmd() {
        this.listeFacturesFour = this.oldListFacturesFour;
        this.legendeFour = "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER";
    }), _methods),

    mounted: function mounted() {
        // this.loadDemandeAvalider()
        // this.loadMissionsAvalider()
        this.loadFacture();
        // this.loadDmdIntervention()
        this.loadDmdFond();
        this.loadDmdCom();
        // this.loadDmdNoValidAppro()
    }
});

/***/ }),

/***/ "NhX3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h4',[_vm._v("LISTE DES PROJETS")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('data-tables',{attrs:{"data":_vm.listeProjets,"resizable":false}},[_c('el-table-column',{attrs:{"prop":"created","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chef","label":"Chef Projet"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateD","label":"Date Début"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Date Fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"caisse","label":"Caisse"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"estimation","label":"Coût estimé"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"info"}},[_vm._v(" "+_vm._s(scope.row.estimation))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntDepense","label":"Coût des dépenses"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"success"}},[_vm._v("\n                      "+_vm._s(scope.row.mntDepense))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"evolution","label":"Evolution","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-progress-circular',{attrs:{"size":90,"width":15,"rotate":360,"value":scope.row.evolution,"color":"primary"}},[_vm._v("\n                      "+_vm._s(scope.row.evolution)+" %\n                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetail(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                      Détails...\n                    ")],1)]}}])})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('DashboardProjet',{attrs:{"detailProjet":_vm.detailProjet,"show":_vm.showDetailProjet},on:{"close":function($event){_vm.showDetailProjet = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NxGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__("8taH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec29798_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__("Wgzm");
function injectStyle (ssrContext) {
  __webpack_require__("lA3e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ec29798_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OChs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contrat_ouvrier_vue__ = __webpack_require__("C+2b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe65392e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contrat_ouvrier_vue__ = __webpack_require__("sCrI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contrat_ouvrier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe65392e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contrat_ouvrier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OIE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Validation_dex_index_vue__ = __webpack_require__("Nbbm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a133044_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Validation_dex_index_vue__ = __webpack_require__("TFWQ");
function injectStyle (ssrContext) {
  __webpack_require__("eB9y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a133044"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Validation_dex_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a133044_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Validation_dex_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OPWJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FicheVehicule"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n            "+_vm._s(item.text))])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[(_vm.messageAlert !== '')?_c('v-alert',{staticStyle:{"width":"100%","font-size":"19px"},attrs:{"value":true,"type":"error"}},[_vm._v("\n            "+_vm._s(_vm.messageAlert)+"\n          ")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md9":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                    IMAGE DU VEHICULE\n                  ")])],1),_vm._v(" "),_c('v-avatar',{attrs:{"tile":true,"size":"180px"}},[(_vm.detailVeh.urlVeh == '')?_c('img',{attrs:{"src":"/static/car_avatar.png","alt":"avatar"}}):_c('img',{attrs:{"src":_vm.detailVeh.urlVeh,"alt":"avatar"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"md9":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                    INFORMATIONS GENERALES CONCERNANT LE VEHICULE\n                  ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("CODE PARC : ")]),_vm._v(" "+_vm._s(_vm.detailVeh.codeParc))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("PARC AUTO : ")]),_vm._v(" "+_vm._s(_vm.detailVeh.parc))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("MARQUE : ")]),_vm._v(" "+_vm._s(_vm.detailVeh.marque))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("MODELE : ")]),_vm._v(" "+_vm._s(_vm.detailVeh.modele))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("SERIE : ")]),_vm._v(" "+_vm._s(_vm.detailVeh.serie))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("CATEGORIE : ")]),_vm._v(" "+_vm._s(_vm.detailVeh.categorie))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("SOUS CATEGORIE : ")]),_vm._v(" "+_vm._s(_vm.detailVeh.sousCategorie))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("DISPONIBILITE : ")]),_vm._v(" "),(_vm.detailVeh.etat == 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                        DISPONIBLE "),_c('v-icon',[_vm._v("directions_bus")])],1):(_vm.detailVeh.etat == 2)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                        EN MISSION "),_c('v-icon',[_vm._v("directions_bus")])],1):(_vm.detailVeh.etat == 3)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                        EN PANNE "),_c('v-icon',[_vm._v("directions_bus")])],1):(_vm.detailVeh.etat == 4)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                        EN REPARATION "),_c('v-icon',[_vm._v("directions_bus")])],1):(_vm.detailVeh.etat == 5)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                        EN LOCATION "),_c('v-icon',[_vm._v("directions_bus")])],1):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("KILOMETRAGE : ")]),_vm._v(" "+_vm._s(_vm.detailVeh.kilo)+" KM")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("RATIO THEORIQUE : ")]),_vm._v(" "+_vm._s(_vm.detailVeh.ratio)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("COULEUR : ")]),_vm._v(" "+_vm._s(_vm.detailVeh.couleur))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("IMMATRICULATION : ")]),_vm._v(" "+_vm._s(_vm.detailVeh.immat))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("N° DE LA CARTE GRISE : ")]),_vm._v(" "+_vm._s(_vm.detailVeh.numCarte)+"\n                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("N° DU CHASSIS : ")]),_vm._v(" "+_vm._s(_vm.detailVeh.numChass))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("TYPE DE CARBURANT : ")]),_vm._v(" "+_vm._s(_vm.detailVeh.carburant))])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                COÛT TOTAL DES DEPENSES\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('p',[_c('b',[_vm._v("PRIX D'ACHAT DU VEHICULE : ")]),_vm._v("\n                  "+_vm._s(new Intl.NumberFormat("fr-FR").format(_vm.detailVeh.prixAchat))+"\n                  FCFA\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("COUT D'UTILISATION : ")]),_vm._v("\n                  "+_vm._s(new Intl.NumberFormat("fr-FR").format(_vm.detailVeh.coutUtil))+"\n                  FCFA\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("CARBURANT : ")]),_vm._v(" "+_vm._s(_vm.detailVeh.montantCarburant)+" FCFA")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("INTERVENTION ET REPARATION : ")]),_vm._v("\n                  "+_vm._s(new Intl.NumberFormat("fr-FR").format(
                      _vm.detailVeh.montantInterv
                    ))+"\n                  FCFA\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("ASSURANCE : ")]),_vm._v("\n                  "+_vm._s(new Intl.NumberFormat("fr-FR").format(
                      _vm.detailVeh.montantAssur
                    ))+"FCFA\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("VIDANGE : ")]),_vm._v("\n                  "+_vm._s(new Intl.NumberFormat("fr-FR").format(_vm.detailVeh.montantVid))+"FCFA\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("VISITE: ")]),_vm._v("\n                  "+_vm._s(new Intl.NumberFormat("fr-FR").format(
                      _vm.detailVeh.montantVistech
                    ))+"\n                  FCFA\n                ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"22px"}},[_c('b',[_vm._v("TOTAL : ")]),_vm._v("\n                  "+_vm._s(new Intl.NumberFormat("fr-FR").format(_vm.detailVeh.totalCout))+"\n                  FCFA\n                ")])])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){return _vm.$router.push({ name: 'Flotte', path: '/parc/auto/flotte' })}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("keyboard_arrow_left")]),_vm._v(" Retour\n            ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.editVeh(_vm.detailVeh)}}},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.newVisit(_vm.detailVeh)}}},[_vm._v("Visite "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.newAssu(_vm.detailVeh)}}},[_vm._v("Assurance "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.newVign(_vm.detailVeh)}}},[_vm._v("Vidange "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"warning","dark":""},on:{"click":_vm.imprimeInfoVeh}},[_vm._v("Imprimer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("printer")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_c('v-tabs',{staticClass:"elevation-2",attrs:{"icons-and-text":"","centered":"","dark":"","color":"primary"}},[_c('v-tabs-slider',{attrs:{"color":"yellow"}}),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-1"},on:{"click":function($event){return _vm.selectTab('tab-1')}}},[_c('v-icon',[_vm._v("airline_seat_recline_normal")]),_vm._v("\n                MISSIONS\n              ")],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-2"},on:{"click":function($event){return _vm.selectTab('tab-2')}}},[_c('v-icon',[_vm._v("description")]),_vm._v("\n                DOCUMENTS\n              ")],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-3"},on:{"click":function($event){return _vm.selectTab('tab-3')}}},[_c('v-icon',[_vm._v("description")]),_vm._v("\n                ADMINISTRATIF\n              ")],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-4"},on:{"click":function($event){return _vm.selectTab('tab-4')}}},[_c('v-icon',[_vm._v("local_gas_station")]),_vm._v("\n                CONSOMMATION\n              ")],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-5"},on:{"click":function($event){return _vm.selectTab('tab-5')}}},[_c('v-icon',[_vm._v("account_box")]),_vm._v("\n                INTERVENTIONS\n              ")],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-6"},on:{"click":function($event){return _vm.selectTab('tab-6')}}},[_c('v-icon',[_vm._v("drive_eta")]),_vm._v("\n                CONTRATS DE LOCATION\n              ")],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-7"},on:{"click":function($event){return _vm.selectTab('tab-7')}}},[_c('v-icon',[_vm._v("drive_eta")]),_vm._v("\n                TRAVAUX CHANTIER\n              ")],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-8"},on:{"click":function($event){return _vm.selectTab('tab-8')}}},[_c('v-icon',[_vm._v("account_circle")]),_vm._v("\n                CONDUCTEURS\n              ")],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-1"}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisMissionVeh('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisMissionVeh('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnMiss,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                        ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),(_vm.mission.length != 0)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md5":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%","font-size":"22px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                          MISSION EN COURS\n                        ")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md10":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%","font-size":"22px"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                          MOTIF : "+_vm._s(_vm.mission.activite)+" DATE DE DEPART :\n                          "+_vm._s(_vm.mission.dateSorti)+"\n                        ")])],1)])],1):_vm._e(),_vm._v(" "),(_vm.mission.length != 0 && _vm.mission.nomPrenom != '')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"180px","color":"grey lighten-4"}},[(!_vm.mission.urlCond)?_c('img',{attrs:{"src":"/static/avatar-conducteur.png","alt":"avatar"}}):_c('img',{attrs:{"src":_vm.mission.urlCond,"alt":"avatar"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"md9":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("MATRICULE : ")]),_vm._v(" "+_vm._s(_vm.mission.matricule))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("NOM ET PRENOMS : ")]),_vm._v(" "+_vm._s(_vm.mission.nomPrenom)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("DATE DE NAISSANCE : ")]),_vm._v(" "+_vm._s(_vm.mission.dateNais)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("DATE D'EMBAUCHE : ")]),_vm._v(" "+_vm._s(_vm.mission.dateEmbauche)+"\n                          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("TYPE DE PEMIS : ")]),_vm._v(" "+_vm._s(_vm.mission.typePermis)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("N° DE PERMIS : ")]),_vm._v(" "+_vm._s(_vm.mission.numPermis))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("DATE DE VALIDITE DU PERMIS : ")]),_vm._v("\n                            "+_vm._s(_vm.mission.dateValid)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("FONCTION : ")]),_vm._v(" "+_vm._s(_vm.mission.fonction))])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("CONTACT N°1 : ")]),_vm._v(" "+_vm._s(_vm.mission.tel1))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("CONTACT N°2 : ")]),_vm._v(" "+_vm._s(_vm.mission.tel2))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("ADRESSE : ")]),_vm._v(" "+_vm._s(_vm.mission.adresse))])])],1)],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.itemsCond.length != 0)?_c('v-layout',{attrs:{"row":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.itemsCond}},[_c('el-table-column',{attrs:{"prop":"demandeur","label":"Demandeur"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.demandeur)+" fonction :\n                            "+_vm._s(scope.row.fonctionDem)+"\n                          ")])]}}],null,false,519584606)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"activite","label":"Mission"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.activite)+"\n                          ")])]}}],null,false,697834654)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date début et fin"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                            "+_vm._s(scope.row.debut)+" - "+_vm._s(scope.row.fin)+"\n                          ")])]}}],null,false,799274829)})],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisDocVeh('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisDocVeh('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnDoc,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                        ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),(_vm.itemsDoc.length != 0)?_c('v-layout',{attrs:{"row":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.itemsDoc}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.libelle)+"\n                          ")])]}}],null,false,3898851893)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"Description"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.description)+"\n                          ")])]}}],null,false,2320487785)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fichier","label":"Documents"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"outline":"","small":"","fab":"","color":"indigo"},on:{"click":function($event){return _vm.imprimeFic(scope.row.fichier)}}},[_c('v-icon',[_vm._v("photo_album")])],1)]}}],null,false,1776626711)})],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-3"}},[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisAdminAssuranceVeh('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisAdminAssuranceVeh('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnAdminAssu,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                            ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"primary","text-color":"white"}},[_vm._v("\n                        ASSURANCE\n                      ")]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"orange","text-color":"white"}},[_vm._v("\n                        MONTANT TOTAL : "+_vm._s(_vm.mntTotAssur)+" FCFA\n                      ")]),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.itemsDocAss}},[_c('el-table-column',{attrs:{"prop":"numPolice","label":"N° Police"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.numPolice)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"numAttes","label":"N° Attestation"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.numAttes)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateDbtReel","label":"Date debut"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"indigo"}},[_vm._v("\n                              "+_vm._s(scope.row.dateDbtReel)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateFnReel","label":"Date fin"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"indigo"}},[_vm._v("\n                              "+_vm._s(scope.row.dateFnReel)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntAssurReel","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                              "+_vm._s(scope.row.mntAssur)+" FCFA\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editAssu(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                                Modifier\n                              ")],1),_vm._v(" "),(scope.row.statut == false)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprAssu = true;
                                    _vm.idAssu = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                                Supprimer\n                              ")],1):_vm._e()],1)]}}])})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisAdminVidangeVeh('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisAdminVidangeVeh('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnAdminVign,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                            ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"primary","text-color":"white"}},[_vm._v("\n                        VIDANGES\n                      ")]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"orange","text-color":"white"}},[_vm._v("\n                        MONTANT TOTAL : "+_vm._s(_vm.mntTotVid)+" FCFA\n                      ")]),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.itemsDocVig}},[_c('el-table-column',{attrs:{"prop":"numero","label":"N° Vidange"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.numero)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateDebt","label":"Date debut"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.dateDebt)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateRen","label":"Date de renouvellement "},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.dateRen)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                              "+_vm._s(scope.row.montSepar)+" FCFA\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editVign(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                                Modifier\n                              ")],1),_vm._v(" "),(scope.row.statut == false)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprVign = true;
                                    _vm.idVign = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                                Supprimer\n                              ")],1):_vm._e()],1)]}}])})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisAdminVisiteVeh('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisAdminVisiteVeh('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnAdminVisit,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                            ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"primary","text-color":"white"}},[_vm._v("\n                        VISITES TECHNIQUES\n                      ")]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"orange","text-color":"white"}},[_vm._v("\n                        MONTANT TOTAL : "+_vm._s(_vm.mntTotVistech)+" FCFA\n                      ")]),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.itemsDocVis}},[_c('el-table-column',{attrs:{"prop":"numero","label":"Référence"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.numero)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateDebut","label":"Date début"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.dateDebut)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateFin","label":"Date fin"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.dateFin)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                              "+_vm._s(scope.row.montSepar)+" FCFA\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editVisit(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                                Modifier\n                              ")],1),_vm._v(" "),(scope.row.statut == false)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprVisit = true;
                                    _vm.idVisit = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                                Supprimer\n                              ")],1):_vm._e()],1)]}}])})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-4"}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover4",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisAdminConsoVeh('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisAdminConsoVeh('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover4",arg:"popover4"}],attrs:{"type":"warning","disabled":_vm.disabledBtnAdminConso,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                        ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"primary","text-color":"white"}},[_vm._v("\n                    VISITES TECHNIQUES\n                  ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"orange","text-color":"white"}},[_vm._v("\n                    MONTANT TOTAL : "+_vm._s(_vm.mntTotCons)+" FCFA\n                  ")]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"orange","text-color":"white"}},[_vm._v("\n                    QUANTITE CONSOMME : "+_vm._s(_vm.quantTotCons)+" L\n                  ")]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"orange","text-color":"white"}},[_vm._v("\n                    DISTANCE PARCOURUE : "+_vm._s(_vm.distParcTot)+" KM\n                  ")]),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.itemsCons}},[_c('el-table-column',{attrs:{"prop":"station","label":"Station"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                          "+_vm._s(scope.row.station)+"\n                        ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"carburant","label":"Carburant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                          "+_vm._s(scope.row.carburant)+"\n                        ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantite","label":"Quantité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                          "+_vm._s(scope.row.quantite)+"\n                        ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateCons","label":"Date"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"indigo"}},[_vm._v("\n                          "+_vm._s(scope.row.dateCons)+"\n                        ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                          "+_vm._s(scope.row.montant)+" FCFA\n                        ")])]}}])})],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-5"}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisAdminInterVeh('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisAdminInterVeh('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnAdminInter,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                        ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"primary","text-color":"white"}},[_vm._v("\n                    INTERVENTION\n                  ")]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"orange","text-color":"white"}},[_vm._v("\n                    MONTANT TOTAL : "+_vm._s(_vm.mntTotInterv)+" FCFA\n                  ")]),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.itemsInterv}},[_c('el-table-column',{attrs:{"prop":"vehicule","label":"Véhicule","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                          "+_vm._s(scope.row.vehicule)+"\n                          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("directions_car")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                          "+_vm._s(scope.row.date)+"\n                        ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.type == 'Curative')?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                          CURATIVE\n                        ")]):_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                          PREVENTIVE\n                        ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demandeur","label":"Demandeur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat / Etape"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                          EN ATTENTE DE VALIDATION\n                        ")]):(scope.row.etat == 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                          EN ATTENTE DE DIAGNOSTIQUE\n                        ")]):(scope.row.etat == 2)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                          INTERVENTION REFUSE\n                        ")]):(scope.row.etat == 3)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                          DEVIS VALIDE\n                        ")]):(scope.row.etat == 4)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                          DIVIS REFUSE\n                        ")]):(scope.row.etat == 5)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                          INTERVENTION TERNIME\n                        ")]):_vm._e()]}}])})],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-6"}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover6",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisAdminLocationVeh('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisAdminLocationVeh('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover6",arg:"popover6"}],attrs:{"type":"warning","disabled":_vm.disabledBtnAdminLoc,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                        ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"primary","text-color":"white"}},[_vm._v("\n                    LISTE DES CONTRATS DE LOCATION DU VEHICULE\n                  ")]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"orange","text-color":"white"}},[_vm._v("\n                    MONTANT TOTAL DES CONTRATS TERMINES :\n                    "+_vm._s(_vm.mntTotContrat)+" FCFA\n                  ")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listContrat}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Référence","width":"100","fixed":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"client","label":"Client","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.client)+"\n                          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateD","label":"Date début et Fin","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.dateD)+" - "+_vm._s(scope.row.dateF)+"\n                          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantTotal","label":"Montant","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                            "+_vm._s(scope.row.montantTotalFormat)+" FCFA\n                          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Type","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                            RESERVE\n                          ")]):(scope.row.etat == 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                            ACTIVE\n                          ")]):(scope.row.etat == 2)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                            TERMINE\n                          ")]):(scope.row.etat == 3)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                            RESILIE\n                          ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat != 0)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){return _vm.impmerFacture(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1):_vm._e(),_vm._v("\n                              Imprimer\n                            ")],1)],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-7"}},[_c('v-card-text',[_c('VehiculeBesoin',{attrs:{"listeBesoinsVeh":_vm.listeBesoinsVehValid}})],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-8"}},[_c('v-card-text',[_c('br'),_c('br'),_vm._v(" "),_c('v-chip',{attrs:{"label":"","color":"primary","text-color":"white"}},[_vm._v("\n                    LISTE DES CONDUCTEURS\n                  ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newAttrCondu($event)}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n                        Affecter un vehicule a ce conducteur\n                      ")],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listConducteur}},[_c('el-table-column',{attrs:{"prop":"url","label":"Photo","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-avatar',[(scope.row.url)?_c('img',{staticClass:"lazy",attrs:{"src":scope.row.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"src":"/static/avatar-conducteur.png","alt":""}})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nomPren","label":"Conducteur","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.nomPren)+"\n                          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date validité du permis","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.dateValPmi)+"\n                          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Disponibilité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.disponibilite === 'Disponible')?_c('v-chip',{attrs:{"color":"green","text-color":"white"}},[_c('v-avatar',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v("\n                            "+_vm._s(scope.row.disponibilite)+"\n                          ")],1):_vm._e(),_vm._v(" "),(scope.row.disponibilite === 'En activite')?_c('v-chip',{attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v("\n                            "+_vm._s(scope.row.disponibilite)+"\n                          ")],1):_vm._e(),_vm._v(" "),(scope.row.disponibilite === 'Absent')?_c('v-chip',{attrs:{"color":"red","text-color":"white"}},[_c('v-avatar',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v("\n                            "+_vm._s(scope.row.disponibilite)+"\n                          ")],1):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.ficheConducteur(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                              Détails\n                            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprCond = true;
                                  _vm.idConducteur = scope.row.idCond;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                              Supprimer\n                            ")],1)],1)]}}])})],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprAssu),callback:function ($$v) {_vm.dialogSuprAssu=$$v},expression:"dialogSuprAssu"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n            Voulez-vous vraiment supprimer cette assurance ?\n          ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprAssu = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteAssu($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprVign),callback:function ($$v) {_vm.dialogSuprVign=$$v},expression:"dialogSuprVign"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n            Voulez-vous vraiment supprimer cette vidange ?\n          ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprVign = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteVign($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprVisit),callback:function ($$v) {_vm.dialogSuprVisit=$$v},expression:"dialogSuprVisit"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n            Voulez-vous vraiment supprimer cette visite technique ?\n          ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprVisit = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteVisit($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":true,"max-width":"80%","loading":_vm.loading},model:{value:(_vm.dialogAjoutVeh),callback:function ($$v) {_vm.dialogAjoutVeh=$$v},expression:"dialogAjoutVeh"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"flex":"0 0 auto"},attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_c('span',[_vm._v("Modfier un véhicule ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutVeh = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formVehicule",attrs:{"id":"formVehicule","lazy-validation":"","enctype":"multipart/form-data"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 1,"step":"1"}},[_vm._v("Marque")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 2,"step":"2"}},[_vm._v("Générale")]),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.imageVeh,"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"fileVeh",staticStyle:{"display":"none"},attrs:{"name":"fichVeh","type":"file","accept":"image/*"},on:{"change":_vm.onFileVehPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileVeh.click()}}},[_vm._v("\n                                Photo vehicule\n                                "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.imageCarteGris,"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"fileCarteGris",staticStyle:{"display":"none"},attrs:{"name":"fichCarteGris","type":"file","accept":"image/*"},on:{"change":_vm.onFileCartePicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileCarteGris.click()}}},[_vm._v("\n                                Carte grise\n                                "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md8":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Catégorie de véhicule *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"allow-create":"","filterable":"","clearable":"","placeholder":"Catégorie de véhicule"},on:{"change":function($event){return _vm.chargeSousCat(_vm.formVehicule.categorieId)}},model:{value:(_vm.formVehicule.categorieId),callback:function ($$v) {_vm.$set(_vm.formVehicule, "categorieId", $$v)},expression:"formVehicule.categorieId"}},_vm._l((_vm.listCategorie),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Sous catégorie *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"allow-create":"","filterable":"","clearable":"","placeholder":"Catégorie de véhicule"},on:{"change":_vm.chargeMarque},model:{value:(_vm.formVehicule.sousCategorieId),callback:function ($$v) {_vm.$set(_vm.formVehicule, "sousCategorieId", $$v)},expression:"formVehicule.sousCategorieId"}},_vm._l((_vm.listSousCategorie),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Marque concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"allow-create":"","filterable":"","clearable":"","placeholder":"Marque concerné"},on:{"change":_vm.chargeModele},model:{value:(_vm.formVehicule.marqueId),callback:function ($$v) {_vm.$set(_vm.formVehicule, "marqueId", $$v)},expression:"formVehicule.marqueId"}},_vm._l((_vm.listMarque),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Série du véhicule *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"allow-create":"","filterable":"","clearable":"","placeholder":"Série du véhicule"},on:{"change":_vm.selectSerie},model:{value:(_vm.formVehicule.serieId),callback:function ($$v) {_vm.$set(_vm.formVehicule, "serieId", $$v)},expression:"formVehicule.serieId"}},_vm._l((_vm.listSerie),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Modèle concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"allow-create":"","filterable":"","clearable":"","placeholder":"Modele concerné"},on:{"change":_vm.chargeSerie},model:{value:(_vm.formVehicule.modeleId),callback:function ($$v) {_vm.$set(_vm.formVehicule, "modeleId", $$v)},expression:"formVehicule.modeleId"}},_vm._l((_vm.listModele),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Immatriculation *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"matricule","placeholder":"Immatriculation","required":""},model:{value:(_vm.formVehicule.matricule),callback:function ($$v) {_vm.$set(_vm.formVehicule, "matricule", $$v)},expression:"formVehicule.matricule"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("N° du chassis *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"numChassis","placeholder":"N° du chassis","required":""},model:{value:(_vm.formVehicule.numChassis),callback:function ($$v) {_vm.$set(_vm.formVehicule, "numChassis", $$v)},expression:"formVehicule.numChassis"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("N° de la carte grsie *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"numCarteGris","placeholder":"N° du chassis","required":""},model:{value:(_vm.formVehicule.numCarteGris),callback:function ($$v) {_vm.$set(_vm.formVehicule, "numCarteGris", $$v)},expression:"formVehicule.numCarteGris"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Code parc ")]),_vm._v(" "),_c('el-input',{attrs:{"name":"codeParc","placeholder":"Code du parc","required":""},model:{value:(_vm.formVehicule.codeParc),callback:function ($$v) {_vm.$set(_vm.formVehicule, "codeParc", $$v)},expression:"formVehicule.codeParc"}})],1)])],1)],1)],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutVeh = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("\n                      Continuer "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("navigate_next")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date d'acquisition *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"value-format":"dd-MM-yyyy","name":"dateAqui","type":"date","placeholder":"Date d'acquisition"},model:{value:(_vm.formVehicule.dateAqui),callback:function ($$v) {_vm.$set(_vm.formVehicule, "dateAqui", $$v)},expression:"formVehicule.dateAqui"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de carburant *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Type de carburant"},model:{value:(_vm.formVehicule.typeCarbuId),callback:function ($$v) {_vm.$set(_vm.formVehicule, "typeCarbuId", $$v)},expression:"formVehicule.typeCarbuId"}},_vm._l((_vm.typeCarburant),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nombre de place *")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","name":"nbPlace","placeholder":"Nombre de place","required":""},model:{value:(_vm.formVehicule.nbPlace),callback:function ($$v) {_vm.$set(_vm.formVehicule, "nbPlace", $$v)},expression:"formVehicule.nbPlace"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Kilométrage Compteur (Km/h) *")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","name":"kilometrage","placeholder":"Kilométrage (Km/h)","required":""},model:{value:(_vm.formVehicule.kilometrage),callback:function ($$v) {_vm.$set(_vm.formVehicule, "kilometrage", $$v)},expression:"formVehicule.kilometrage"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix d'achat ")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","name":"prixAchat","placeholder":"Prix d'achat du vehicule ","required":""},model:{value:(_vm.formVehicule.prixAchat),callback:function ($$v) {_vm.$set(_vm.formVehicule, "prixAchat", $$v)},expression:"formVehicule.prixAchat"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Année du vehicule ")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"value-format":"yyyy","name":"annVeh","type":"year","placeholder":"Année du vehicule"},model:{value:(_vm.formVehicule.annVeh),callback:function ($$v) {_vm.$set(_vm.formVehicule, "annVeh", $$v)},expression:"formVehicule.annVeh"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Couleur *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"couleur","placeholder":"Couleur","required":""},model:{value:(_vm.formVehicule.couleur),callback:function ($$v) {_vm.$set(_vm.formVehicule, "couleur", $$v)},expression:"formVehicule.couleur"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Affecter un parc auto *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Affecter un parc auto"},model:{value:(_vm.formVehicule.parcId),callback:function ($$v) {_vm.$set(_vm.formVehicule, "parcId", $$v)},expression:"formVehicule.parcId"}},_vm._l((_vm.listParc),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Coût utilisation *")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","name":"coutUtil","placeholder":"Cout d'utilisation du vehicule ","required":""},model:{value:(_vm.formVehicule.coutUtil),callback:function ($$v) {_vm.$set(_vm.formVehicule, "coutUtil", $$v)},expression:"formVehicule.coutUtil"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ratio théorique ")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","min":0,"name":"ratio","placeholder":"Consommation théorique","required":""},model:{value:(_vm.formVehicule.ratio),callback:function ($$v) {_vm.$set(_vm.formVehicule, "ratio", $$v)},expression:"formVehicule.ratio"}})],1)])],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutVeh = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 1}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("navigate_before")]),_vm._v(" Précédent\n                    ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.formVehIsValid},nativeOn:{"click":function($event){return _vm.createVeh(_vm.idVehModif)}}},[_vm._v("\n                      Ajouter "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprCond),callback:function ($$v) {_vm.dialogSuprCond=$$v},expression:"dialogSuprCond"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer ce conducteur ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprCond = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteConducteur($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"scrollable":"","max-width":"70%"},model:{value:(_vm.dialogFicheCond),callback:function ($$v) {_vm.dialogFicheCond=$$v},expression:"dialogFicheCond"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Fiche conducteur ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogFicheCond = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card',[_c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"180px","color":"grey lighten-4"}},[(_vm.conducteurCourant.url == null ||_vm.conducteurCourant.url == '' )?_c('img',{attrs:{"src":"/static/avatar-conducteur.png","alt":"avatar"}}):_c('img',{attrs:{"src":_vm.conducteurCourant.url,"alt":"avatar"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[(_vm.conducteurCourant.disponibilite === 'Disponible')?_c('v-chip',{attrs:{"color":"green","text-color":"white"}},[_c('v-avatar',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v("\n                      "+_vm._s(_vm.conducteurCourant.disponibilite)+"\n                    ")],1):_vm._e(),_vm._v(" "),(_vm.conducteurCourant.disponibilite === 'En activite')?_c('v-chip',{attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v("\n                      "+_vm._s(_vm.conducteurCourant.disponibilite)+"\n                    ")],1):_vm._e(),_vm._v(" "),(_vm.conducteurCourant.disponibilite === 'Absent')?_c('v-chip',{attrs:{"color":"red","text-color":"white"}},[_c('v-avatar',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v("\n                      "+_vm._s(_vm.conducteurCourant.disponibilite)+"\n                    ")],1):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Matricule : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.matricule))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Nom et prénoms : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.nom)+"\n                  "+_vm._s(_vm.conducteurCourant.prenom)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de naissance : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.dateNs)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Lieu de naissance : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.lieuNaiss)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Contacts : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.phone1)+" /\n                  "+_vm._s(_vm.conducteurCourant.phone2)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Adresse : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.adresse))])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Fonction : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.fonction))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'embauche : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.dateEmb))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Type de permis : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.typePermis)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Numéro de permis : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.numPermis)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de validite du permis : ")]),_vm._v("\n                  "+_vm._s(_vm.conducteurCourant.dateVp)+"\n                ")])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogFicheCond = false}}},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","persistent":true,"loading":_vm.loading,"scrollable":""},model:{value:(_vm.dialogAjoutVehiConducteur),callback:function ($$v) {_vm.dialogAjoutVehiConducteur=$$v},expression:"dialogAjoutVehiConducteur"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Attribuer un conducteur au vehicule "+_vm._s(_vm.detailVeh.immat)+" - "+_vm._s(_vm.detailVeh.marque)+" :\n                  "+_vm._s(_vm.detailVeh.modele)+"\n            ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutVehiConducteur = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formAttribueCondu",attrs:{"lazy-validation":"","id":"formAttribueCondu"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Véhicule concerné")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":true,"name":"numero","placeholder":"Numero"},model:{value:(_vm.detailVeh.immat),callback:function ($$v) {_vm.$set(_vm.detailVeh, "immat", $$v)},expression:"detailVeh.immat"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Conducteur *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Conducteur"},model:{value:(_vm.formAttribueCondu.conducteur),callback:function ($$v) {_vm.$set(_vm.formAttribueCondu, "conducteur", $$v)},expression:"formAttribueCondu.conducteur"}},_vm._l((_vm.AllConducteur),function(item){return _c('el-option',{key:item.idCond,attrs:{"label":item.nomPren,"value":item.idCond}})}),1)],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogAjoutVehiConducteur = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.submitAttribution()}}},[_vm._v("Enrregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"max-width":"60%","loading":_vm.loading},model:{value:(_vm.dialogAjoutAssu),callback:function ($$v) {_vm.dialogAjoutAssu=$$v},expression:"dialogAjoutAssu"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajout d'une nouvelle assurance "+_vm._s(_vm.detailVeh.immat)+" -\n              "+_vm._s(_vm.detailVeh.marque)+" : "+_vm._s(_vm.detailVeh.modele))]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification d'une assurance "+_vm._s(_vm.detailVeh.immat)+" -\n              "+_vm._s(_vm.detailVeh.marque)+" : "+_vm._s(_vm.detailVeh.modele))]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutAssu = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formAssu",attrs:{"lazy-validation":"","id":"formAssu"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEdit != true)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  AJOUTER UNE NOUVELLE ASSURANCE DU VEHICULE\n                  "+_vm._s(_vm.detailVeh.immat)+" - "+_vm._s(_vm.detailVeh.marque)+" :\n                  "+_vm._s(_vm.detailVeh.modele)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  MODIFICATION DE L'ASSURANCE DU VEHICULE\n                  "+_vm._s(_vm.detailVeh.immat)+" - "+_vm._s(_vm.detailVeh.marque)+" :\n                  "+_vm._s(_vm.detailVeh.modele)+"\n                ")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoAssur,"alt":"avatar"}})]),_c('br'),_vm._v(" "),_c('input',{ref:"fileAssur",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageAssurLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileAssur.click()}}},[_vm._v("Photo "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1),_vm._v(" "),_c('v-flex',{attrs:{"md9":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("N° Attestation *")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.assuranceCourant.statut == true,"name":"attestation","id":"attestation","placeholder":"Attestation"},model:{value:(_vm.formAssu.attestation),callback:function ($$v) {_vm.$set(_vm.formAssu, "attestation", $$v)},expression:"formAssu.attestation"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("N° Police *")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.assuranceCourant.statut == true,"name":"police","id":"police","placeholder":"Police"},model:{value:(_vm.formAssu.police),callback:function ($$v) {_vm.$set(_vm.formAssu, "police", $$v)},expression:"formAssu.police"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant TTC de l'assurance *")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.assuranceCourant.statut == true,"type":"number","min":"0","name":"montant","id":"montant","placeholder":"Montant de l'assurance"},model:{value:(_vm.formAssu.montant),callback:function ($$v) {_vm.$set(_vm.formAssu, "montant", $$v)},expression:"formAssu.montant"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date d'achat l'assurance *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.assuranceCourant.statut == true,"name":"dateAssurance","id":"dateAssurance","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date d'achat de l'assurance"},model:{value:(_vm.formAssu.dateAssu),callback:function ($$v) {_vm.$set(_vm.formAssu, "dateAssu", $$v)},expression:"formAssu.dateAssu"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Compagnie *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.assuranceCourant.statut == true,"placeholder":"La Compagnie"},model:{value:(_vm.selectCompagnLib),callback:function ($$v) {_vm.selectCompagnLib=$$v},expression:"selectCompagnLib"}},_vm._l((_vm.listCompagn),function(item){return _c('el-option',{key:item.idPres,attrs:{"label":item.libelle,"value":item.idPres}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de debut de l'assurance *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.assuranceCourant.statut == true,"name":"dateDebutAssurance","id":"dateDebutAssurance","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de debut"},model:{value:(_vm.formAssu.dateDebutAssu),callback:function ($$v) {_vm.$set(_vm.formAssu, "dateDebutAssu", $$v)},expression:"formAssu.dateDebutAssu"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin de l'assurance *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.assuranceCourant.statut == true,"name":"dateFinAssurance","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de fin"},model:{value:(_vm.formAssu.dateFinAssu),callback:function ($$v) {_vm.$set(_vm.formAssu, "dateFinAssu", $$v)},expression:"formAssu.dateFinAssu"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Activé l'assurance *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.formAssu.statut),callback:function ($$v) {_vm.$set(_vm.formAssu, "statut", $$v)},expression:"formAssu.statut"}},_vm._l((_vm.statut),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de renouvellement")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.assuranceCourant.statut == true,"id":"dateRenAssurance","name":"dateRenAssurance","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de renouvellement"},model:{value:(_vm.formAssu.dateRenAssu),callback:function ($$v) {_vm.$set(_vm.formAssu, "dateRenAssu", $$v)},expression:"formAssu.dateRenAssu"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.assuranceCourant.statut == true,"name":"description","id":"description","type":"textarea","rows":3,"required":""},model:{value:(_vm.formAssu.description),callback:function ($$v) {_vm.$set(_vm.formAssu, "description", $$v)},expression:"formAssu.description"}})],1)])],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogAjoutAssu = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.submitAssu()}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"60%","loading":_vm.loading,"scrollable":""},model:{value:(_vm.dialogAjoutVisit),callback:function ($$v) {_vm.dialogAjoutVisit=$$v},expression:"dialogAjoutVisit"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajout d'une nouvelle visite "+_vm._s(_vm.detailVeh.immat)+" -\n              "+_vm._s(_vm.detailVeh.marque)+" : "+_vm._s(_vm.detailVeh.modele))]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification de la visite du "+_vm._s(_vm.visiteCourant.dateDebut)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutVisit = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formVisite",attrs:{"lazy-validation":"","id":"formVisite"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEdit != true)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  AJOUTER UNE NOUVELLE VISITE TECHNIQUE "+_vm._s(_vm.detailVeh.immat)+" -\n                  "+_vm._s(_vm.detailVeh.marque)+" : "+_vm._s(_vm.detailVeh.modele)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  MODIFICATION DE LA VISITE TECHNIQUE\n                  "+_vm._s(_vm.visiteCourant.dateDebut)+" POUR "+_vm._s(_vm.detailVeh.immat)+" -\n                  "+_vm._s(_vm.detailVeh.marque)+" : "+_vm._s(_vm.detailVeh.modele)+"\n                ")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoVisit,"alt":"avatar"}})]),_c('br'),_vm._v(" "),_c('input',{ref:"logoVisit",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.logoVisit.click()}}},[_vm._v("Photo "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1),_vm._v(" "),_c('v-flex',{attrs:{"md9":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Numero de la visite *")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.visiteCourant.statut == true,"name":"numero","placeholder":"Numero"},model:{value:(_vm.formVisite.numero),callback:function ($$v) {_vm.$set(_vm.formVisite, "numero", $$v)},expression:"formVisite.numero"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant TTC*")]),_vm._v(" "),_c('el-input',{attrs:{"min":0,"readonly":_vm.visiteCourant.statut == true,"type":"number","name":"montant","placeholder":"Montant"},model:{value:(_vm.formVisite.montant),callback:function ($$v) {_vm.$set(_vm.formVisite, "montant", $$v)},expression:"formVisite.montant"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de la visite *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.visiteCourant.statut == true,"name":"dateDebut","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de la visite"},model:{value:(_vm.formVisite.dateDebut),callback:function ($$v) {_vm.$set(_vm.formVisite, "dateDebut", $$v)},expression:"formVisite.dateDebut"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date fin de la visite *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.visiteCourant.statut == true,"name":"dateFin","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date fin"},model:{value:(_vm.formVisite.dateFin),callback:function ($$v) {_vm.$set(_vm.formVisite, "dateFin", $$v)},expression:"formVisite.dateFin"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de renouvellement\n                        ")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.visiteCourant.statut == true,"name":"dateRen","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de renouvellement"},model:{value:(_vm.formVisite.dateRen),callback:function ($$v) {_vm.$set(_vm.formVisite, "dateRen", $$v)},expression:"formVisite.dateRen"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Activé la visite *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Activé la visite"},model:{value:(_vm.formVisite.statut),callback:function ($$v) {_vm.$set(_vm.formVisite, "statut", $$v)},expression:"formVisite.statut"}},_vm._l((_vm.statut),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"description","type":"textarea","rows":3,"required":""},model:{value:(_vm.formVisite.description),callback:function ($$v) {_vm.$set(_vm.formVisite, "description", $$v)},expression:"formVisite.description"}})],1)])],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogAjoutVisit = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.submitVisit()}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"max-width":"60%","loading":_vm.loading},model:{value:(_vm.dialogAjoutVign),callback:function ($$v) {_vm.dialogAjoutVign=$$v},expression:"dialogAjoutVign"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajout d'une nouvelle vidange "+_vm._s(_vm.detailVeh.immat)+" -\n              "+_vm._s(_vm.detailVeh.marque)+" : "+_vm._s(_vm.detailVeh.modele))]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification de la vidange du "+_vm._s(_vm.vidangeCourant.date)+"\n              "+_vm._s(_vm.detailVeh.immat)+" - "+_vm._s(_vm.detailVeh.marque)+" :\n              "+_vm._s(_vm.detailVeh.modele))]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutVign = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formVidn",attrs:{"lazy-validation":"","id":"formVidn"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEdit != true)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  AJOUTER UNE NOUVELLE VIDANDE AU VEHICULE\n                  "+_vm._s(_vm.detailVeh.immat)+" - "+_vm._s(_vm.detailVeh.marque)+" :\n                  "+_vm._s(_vm.detailVeh.modele)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  MODIFICATION DE LA VIDANGE DU "+_vm._s(_vm.vignetteCourant.date)+"\n                  "+_vm._s(_vm.detailVeh.immat)+" - "+_vm._s(_vm.detailVeh.marque)+" :\n                  "+_vm._s(_vm.detailVeh.modele)+"\n                ")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoVignet,"alt":"avatar"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{ref:"fileVignet",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageVidangeLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileVignet.click()}}},[_vm._v("Photo "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-flex',{attrs:{"md9":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Numero de la vidange *")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.vidangeCourant.statut == true,"name":"numero","placeholder":"Numero"},model:{value:(_vm.formVidn.numero),callback:function ($$v) {_vm.$set(_vm.formVidn, "numero", $$v)},expression:"formVidn.numero"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Numero facture proforma")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.vidangeCourant.statut == true,"name":"numFacture","placeholder":"Numero"},model:{value:(_vm.formVidn.numFacture),callback:function ($$v) {_vm.$set(_vm.formVidn, "numFacture", $$v)},expression:"formVidn.numFacture"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de la vidange *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.vidangeCourant.statut == true,"id":"dateVidange","name":"dateVidange","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de la vidange"},model:{value:(_vm.formVidn.dateDebt),callback:function ($$v) {_vm.$set(_vm.formVidn, "dateDebt", $$v)},expression:"formVidn.dateDebt"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Kilométrage actuel *")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.vidangeCourant.statut == true,"type":"number","min:0":"","name":"kiloActu","placeholder":"Kilométrage actuel"},model:{value:(_vm.formVidn.kiloActu),callback:function ($$v) {_vm.$set(_vm.formVidn, "kiloActu", $$v)},expression:"formVidn.kiloActu"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Kilométrage prochain *")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.vidangeCourant.statut == true,"type":"number","min:0":"","name":"kiloProch","placeholder":"Kilométrage prochain "},model:{value:(_vm.formVidn.kiloProch),callback:function ($$v) {_vm.$set(_vm.formVidn, "kiloProch", $$v)},expression:"formVidn.kiloProch"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant *")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.vidangeCourant.statut == true,"type":"number","name":"montant","placeholder":"Montant"},model:{value:(_vm.formVidn.montant),callback:function ($$v) {_vm.$set(_vm.formVidn, "montant", $$v)},expression:"formVidn.montant"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de renouvellement\n                        ")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.vidangeCourant.statut == true,"id":"dateRen","name":"dateRen","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de renouvellement"},model:{value:(_vm.formVidn.dateRen),callback:function ($$v) {_vm.$set(_vm.formVidn, "dateRen", $$v)},expression:"formVidn.dateRen"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Activé la vidange *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.formVidn.statut),callback:function ($$v) {_vm.$set(_vm.formVidn, "statut", $$v)},expression:"formVidn.statut"}},_vm._l((_vm.statut),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"description","type":"textarea","rows":3,"required":""},model:{value:(_vm.formVidn.description),callback:function ($$v) {_vm.$set(_vm.formVidn, "description", $$v)},expression:"formVidn.description"}})],1)])],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogAjoutVign = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.submitVign()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OQoE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('span',{staticClass:"title",attrs:{"mt-2":""}},[_vm._v("Détail professionnel")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"wrap":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeAdmin == true),expression:"typeAdmin == true"}],staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.showFormDetail = true}}},[_vm._v("\n                Créer\n                "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"elevation-3",attrs:{"slot":"activator","dark":"","icon":"","flat":"","color":"primary"},on:{"click":function($event){return _vm.loadDetailProf()}},slot:"activator"},[_c('v-icon',[_vm._v("cached")])],1),_vm._v("\n              actualiser la liste\n          ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailProfession}},[_c('el-table-column',{attrs:{"prop":"etablissement","label":"ETABLISSEMENT","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"red--text body-2"},[_vm._v(_vm._s(scope.row.etablissement))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"faculte","label":"FACULTE/SERVICE","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"blue--text body-2"},[_vm._v(_vm._s(scope.row.faculte))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"periode","label":"PERIODE","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"220","prop":"diplome","label":"DIPLOME/POSTE","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"orange--text body-2"},[_vm._v(_vm._s(scope.row.diplome))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateObtention","label":"DATE DIPLOME/CONTRAT","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"typeContrat","label":"TYPE CONTRAT","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"FICHIERS","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"bottom":""}},[_vm._l((scope.row.imagesDetail),function(image,imageIndex){return _c('v-avatar',{key:imageIndex,staticClass:"mb-1 mr-1 elevation-3",style:({ backgroundImage: 'url(' + image + ')' , cursor: 'pointer'}),attrs:{"slot":"activator","tile":true,"size":50,"color":"grey lighten-4"},on:{"click":function($event){return _vm.showDiapo(scope.row.imagesDetail,imageIndex)}},slot:"activator"},[_c('img',{attrs:{"src":image,"alt":"avatar"}})])}),_vm._v("\n                            Cliquez pour agrandir\n                        ")],2)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","width":"70"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){return _vm.deleteDetail(scope.row.idDetail)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("remove")])],1),_vm._v("\n                            Supprimer\n                        ")],1)]}}])})],1)],1)],1),_vm._v(" "),_c('formDetailProf',{attrs:{"idEmploye":_vm.idUserEmploye,"show":_vm.showFormDetail},on:{"close":function($event){return _vm.closeFormProf()}}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"550"},model:{value:(_vm.dialogSuppDetail),callback:function ($$v) {_vm.dialogSuppDetail=$$v},expression:"dialogSuppDetail"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_c('el-alert',{attrs:{"title":'Voulez-vous supprimer cet enregistrement ? ',"type":"warning","closable":false,"show-icon":""}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialogSuppDetail = false}}},[_vm._v("\n                    Non\n                ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":"flat"},on:{"click":function($event){return _vm.submitDeleteDetail()}}},[_vm._v("\n                    Oui\n                ")])],1)],1)],1),_vm._v(" "),_c('CoolLightBox',{attrs:{"items":_vm.items,"index":_vm.index},on:{"close":function($event){_vm.index = null}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OT9U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formNiveauTypeTravaux_vue__ = __webpack_require__("riMH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e7f4274_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formNiveauTypeTravaux_vue__ = __webpack_require__("w4nv");
function injectStyle (ssrContext) {
  __webpack_require__("ZaXl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e7f4274"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formNiveauTypeTravaux_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e7f4274_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formNiveauTypeTravaux_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OX/Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Responsable_vue__ = __webpack_require__("Cf4U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f2c7696_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Responsable_vue__ = __webpack_require__("+/4Q");
function injectStyle (ssrContext) {
  __webpack_require__("9bKt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f2c7696"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Responsable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f2c7696_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Responsable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OXnm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalCommandeMAJ_vue__ = __webpack_require__("RPgo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c709169_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalCommandeMAJ_vue__ = __webpack_require__("EQwH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalCommandeMAJ_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c709169_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalCommandeMAJ_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OaQp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_besoinCarburantResponsable_vue__ = __webpack_require__("PFXP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfe85af0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_besoinCarburantResponsable_vue__ = __webpack_require__("502k");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_besoinCarburantResponsable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfe85af0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_besoinCarburantResponsable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OgWx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_maintenance_AjoutMaintenance__ = __webpack_require__("5N1K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_maintenance_DetailMaintenance__ = __webpack_require__("lRTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_maintenance_SelectionTechnicien__ = __webpack_require__("MWL9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_maintenance_ConstatMaintenance__ = __webpack_require__("iF6j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_maintenance_RapportDepannage__ = __webpack_require__("aeEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_maintenance_RapportSatisfaction__ = __webpack_require__("oCtX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_maintenance_AjoutZoneMaintenance__ = __webpack_require__("r2/R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//function de difference de date

function dateDiff(date1, date2) {
  var diff = {}; // Initialisation du retour
  var tmp = date2 - date1;

  tmp = Math.floor(tmp / 1000); // Nombre de secondes entre les 2 dates
  diff.sec = tmp % 60; // Extraction du nombre de secondes

  tmp = Math.floor((tmp - diff.sec) / 60); // Nombre de minutes (partie entière)
  diff.min = tmp % 60; // Extraction du nombre de minutes

  tmp = Math.floor((tmp - diff.min) / 60); // Nombre d'heures (entières)
  diff.hour = tmp % 24; // Extraction du nombre d'heures

  tmp = Math.floor((tmp - diff.hour) / 24); // Nombre de jours restants
  diff.day = tmp;

  return diff;
}

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Oq2I");
__webpack_require__("miEh");











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_9__components_Loading__["a" /* default */],
    AjoutMaintenance: __WEBPACK_IMPORTED_MODULE_2__components_maintenance_AjoutMaintenance__["a" /* default */],
    DetailMaintenance: __WEBPACK_IMPORTED_MODULE_3__components_maintenance_DetailMaintenance__["a" /* default */],
    SelectionTechnicien: __WEBPACK_IMPORTED_MODULE_4__components_maintenance_SelectionTechnicien__["a" /* default */],
    ConstatMaintenance: __WEBPACK_IMPORTED_MODULE_5__components_maintenance_ConstatMaintenance__["a" /* default */],
    RapportDepannage: __WEBPACK_IMPORTED_MODULE_6__components_maintenance_RapportDepannage__["a" /* default */],
    RapportSatisfaction: __WEBPACK_IMPORTED_MODULE_7__components_maintenance_RapportSatisfaction__["a" /* default */],
    AjoutZoneMaintenance: __WEBPACK_IMPORTED_MODULE_8__components_maintenance_AjoutZoneMaintenance__["a" /* default */]
  },
  name: "Maintenance_index",
  data: function data() {
    var _ref;

    return _ref = {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [{ path: "/maintenance", text: "Maintenance", disabled: false }],
      showModalAjoutDmd: false,
      lieuSelect: "",
      dialogSupr: false,
      legendeTab: "LISTE DES DEMANDES DE MAINTENANCES",
      //detail demande
      showModalDetailDmd: false,
      showModalConstat: false,
      listeDemandes: [],
      zoneDetail: {},
      oldListDemandes: [],
      demandeDetail: {}
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dialogSupr", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "itemDmd", {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "statDemandeG", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "statusDemande", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dataZone", {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "mntTTC", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnMiss", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectZoneDmd", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "comboZoneDmd", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "editFormDmd", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "totalDmd", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "totalDmdCour", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "totalDmdRetard", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "infoRepresentant", {
      lieux: [],
      nomRepresentant: "",
      profession: ""
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "showModalSelectTechnicien", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "listeTechniciens", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "validConstat", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "showModalRapportDepannage", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "showModalRapportSatisfaction", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "showModalAjoutZone", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dialogPlanification", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "formPlanning", {
      selectTech: ""
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "rulesformPlanning", {
      dateDbt: [{
        type: "date",
        required: true,
        message: "Choisir une date de debut",
        trigger: "change"
      }],
      hrDbt: [{
        type: "date",
        required: true,
        message: "Choisir une heure de fin ",
        trigger: "change"
      }],

      dateFin: [{
        type: "date",
        required: true,
        message: "Choisir une date de debut",
        trigger: "change"
      }],
      hrFin: [{
        type: "date",
        required: true,
        message: "Choisir une heure de fin",
        trigger: "change"
      }]
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectEtatDmd", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectStatusDmd", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectRetardDmd", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnDmd", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "comboRetardDmd", [{
      etat: 0,
      label: "demande en retard de réalisation"
    }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "comboStatusDmd", [{
      etat: 0,
      label: "demande en attente de traitement"
    }, {
      etat: 1,
      label: "demande en cours de traitement "
    }, {
      etat: 2,
      label: "demande traitee"
    }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "comboEtatDmd", [{
      etat: 1,
      label: "En attente d'un technicien"
    }, {
      etat: 2,
      label: "En attente d'un constat"
    }, {
      etat: 3,
      label: "En attente de validation"
    }, {
      etat: 5,
      label: "Demande Validée"
    }, {
      etat: 6,
      label: "Demande refusée"
    }, {
      etat: 7,
      label: "Intervention en cours"
    }, {
      etat: 8,
      label: "Intervention terminée"
    }, {
      etat: 9,
      label: "Demande cloturée"
    }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "zones", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "defaultProps", {
      children: "children",
      label: "label"
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "editFormZone", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dialogZoneEdit", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dialogSuppZone", false), _ref;
  },

  computed: {},
  methods: {
    //attribuer zone
    modalAjoutDmd: function modalAjoutDmd() {
      //this.demandeDetail = {}
      this.editFormDmd = false;
      this.showModalAjoutDmd = true;
    },
    modalEditDmd: function modalEditDmd(itemDmd) {
      this.editFormDmd = true;
      this.demandeDetail = itemDmd;
      this.showModalAjoutDmd = true;
    },
    loadDemande: function loadDemande() {
      var _this = this;

      var url = this.domaine + "demande_maintenance/liste_demande/" + this.user.id;
      this.$http.get(url).then(function (response) {
        _this.mntTTC = response.body.mntTTC;
        _this.listeDemandes = response.body.listeDemandes;
        _this.oldListDemandes = response.body.listeDemandes;
        _this.statDemandeG = response.body.pie;
        _this.statusDemande = response.body.status;
        _this.demandeAnnee = response.body.dataHist;

        //affichage nombre de demande
        _this.totalDmd = _this.listeDemandes.length;
        var totalDmdCour = _this.listeDemandes.filter(function (element) {
          return element.statut == 1;
        });

        _this.totalDmdCour = totalDmdCour.length;

        var totalDmdRetard = _this.listeDemandes.filter(function (item) {
          var date1 = new Date(item.dateFormat);
          var dateNow = new Date();
          var diff = dateDiff(date1, dateNow);
          if (diff.day >= 1 && item.statut != 2) {
            //si la difference est superieur a 1jours la demande est en retard
            return true;
          } else {
            return false;
          }

          this.totalDmdRetard = totalDmdRetard.length;
        });

        _this.statDemandeGlobal();
        _this.statStatutDemande();
      }, function (response) {});
    },
    modalDetailDmd: function modalDetailDmd(item) {
      this.demandeDetail = item;
      this.showModalDetailDmd = true;
    },
    modalTechnicien: function modalTechnicien(item) {
      //charger la liste des techniciens
      this.demandeDetail = item;
      this.loadTechnicien(item.idResponsableZone);
    },
    modalConstat: function modalConstat(item) {
      this.demandeDetail = item;
      this.validConstat = false;
      this.showModalConstat = true;
    },
    modalValidConstat: function modalValidConstat(item) {
      this.demandeDetail = item;
      this.validConstat = true;
      this.showModalConstat = true;
    },
    modalplanification: function modalplanification(item) {
      this.demandeDetail = item;
      this.dialogPlanification = true;
    },
    modalRapportDepannage: function modalRapportDepannage(item) {
      this.demandeDetail = item;
      this.showModalRapportDepannage = true;
    },
    modalRapportSatisfaction: function modalRapportSatisfaction(item) {
      this.demandeDetail = item;
      this.showModalRapportSatisfaction = true;
    },
    modalAjoutZone: function modalAjoutZone() {
      this.zoneDetail = {};
      this.editFormZone = false;
      this.showModalAjoutZone = true;
    },
    modalAjoutSousZone: function modalAjoutSousZone(itemZone) {
      this.zoneDetail = itemZone;
      this.editFormZone = false;
      this.showModalAjoutZone = true;
    },
    modalEditZone: function modalEditZone(itemZone) {
      this.editFormZone = true;
      this.zoneDetail = itemZone;
      this.showModalAjoutZone = true;
    },
    modalDeleteZone: function modalDeleteZone(itemZone) {
      this.dialogSuppZone = true;
    },
    loadInfoRepresentant: function loadInfoRepresentant() {
      var _this2 = this;

      var url = this.domaine + "demande_maintenance/infoRepresentant/" + this.user.id;
      this.$http.get(url).then(function (response) {
        _this2.infoRepresentant = response.body.info;
        _this2.zones = _this2.infoRepresentant.lieux;
      }, function (response) {
        _this2.$message.error("Une erreur lors du chargement des donnees personnelles du representant");
      });
    },
    deleteDmd: function deleteDmd() {
      var _this3 = this;

      this.loading = true;

      var url = this.domaine + "demande_maintenance/delete/" + this.itemDmd.idDemande;
      this.$http.get(url).then(function (response) {
        _this3.loading = false;

        _this3.$notify({
          title: "SUPPRESSION",
          message: "Demande supprimée avec succès.",
          type: "success",
          position: "top-center"
        });
        _this3.dialogSupr = false;

        _this3.loadDemande();
      }, function (errRep) {
        _this3.loading = false;
        _this3.dialogSupr = false;
        _this3.$notify.error({
          title: "SUPPRESSION ECHOUEE",
          message: "La suppression de la demande a échouée.",
          position: "top-center"
        });
      });
    },
    deleteZone: function deleteZone() {
      var _this4 = this;

      //this.loading = true
      var url = this.domaine + "demande_maintenance/delete/zone/maintenance";
      var data = new FormData();
      data.append("idZone", this.dataZone.id);

      this.$http.post(url, data).then(function (response) {
        _this4.loading = false;

        _this4.$notify({
          title: "SUPPRESSION",
          message: "Zone supprimée avec succès.",
          type: "success",
          position: "top-center"
        });
        _this4.dialogSuppZone = false;
        _this4.dialogZoneEdit = false;

        _this4.loadInfoRepresentant();
      }, function (errRep) {
        _this4.$notify.error({
          title: "ECHEC DE SUPPRESSION",
          message: "La suppression de la zone a échouée",
          position: "top-center"
        });
      });
    },
    loadTechnicien: function loadTechnicien() {
      var _this5 = this;

      this.loading = true;
      var url = this.domaine + "demande_maintenance/technicien";
      this.$http.get(url).then(function (response) {
        _this5.loading = false;

        var codeMessage = response.body.code;
        var message = response.body.message;
        if (codeMessage == 1) {
          _this5.warningNotif(message);
        } else if (codeMessage == 2) {
          _this5.warningNotif(message);
        } else {
          _this5.listeTechniciens = response.body.technicien;
          _this5.showModalSelectTechnicien = false;
        }
      }, function (errResp) {
        _this5.loading = false;
        _this5.$message.error("Une erreur est survenue lors du chargement de la liste des techniciens");
      });
    },
    submitFormPlanning: function submitFormPlanning(formName) {
      var _this6 = this;

      if (this.formPlanning.selectTech == "") {
        this.$message.error("Veuillez selectionner un techinicien");
        return;
      }
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this6.loading = true;
          var url = _this6.domaine + "demande_maintenance/planning/intervention";
          var data = new FormData();
          var dateDbt = _this6.formPlanning.dateDbt.getFullYear() + "-" + _this6.formPlanning.dateDbt.getMonth() + "-" + _this6.formPlanning.dateDbt.getDate();
          var hrDbt = _this6.formPlanning.hrDbt.getHours() + ":" + _this6.formPlanning.hrDbt.getMinutes();

          var dateFin = _this6.formPlanning.dateFin.getFullYear() + "-" + _this6.formPlanning.dateFin.getMonth() + "-" + _this6.formPlanning.dateFin.getDate();
          var hrFin = _this6.formPlanning.hrFin.getHours() + ":" + _this6.formPlanning.hrFin.getMinutes();

          data.append("dateDbt", dateDbt);
          data.append("hrDbt", hrDbt);
          data.append("dateFin", dateFin);
          data.append("hrFin", hrFin);
          data.append("idDemande", _this6.demandeDetail.idDemande);
          data.append("idUser", _this6.user.id);
          data.append("idTechnicien", _this6.formPlanning.selectTech);
          _this6.$http.post(url, data).then(function (response) {
            _this6.loading = false;
            //reinitialiser le formulaire
            _this6.resetForm("formPlanning");

            _this6.dialogPlanification = false;
            _this6.loadDemande();
            $messages = response.body.message;

            for (var ind in $messages) {
              _this6.successNotif($messages[ind]);
            }
          }, function (erreur) {
            //reinitialiser le formulaire
            _this6.resetForm("formPlanning");

            _this6.loading = false;
            _this6.$message.error("Une erreur est survenue lors de l'enregistrement de l'intervention'");
          });
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    successNotif: function successNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      this.$notify({
        title: "ENREGISTREMENT REUSSI",
        message: mess,
        type: "success",
        position: "top-center"
      });
    },
    warningNotif: function warningNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      this.$notify({
        title: "Avertissement",
        message: mess,
        type: "warning",
        position: "top-center"
      });
    },

    //fonction de filtre
    filtrerEtatDmd: function filtrerEtatDmd(etat) {
      this.loadDmdParEtat(etat);
    },
    filtrerStatusDmd: function filtrerStatusDmd(status) {
      this.loadDmdParStatus(status);
    },
    filtrerRetardDmd: function filtrerRetardDmd() {
      this.loadDmdParRetard();
    },
    filtrerZoneDmd: function filtrerZoneDmd(idZone) {
      this.loadDmdParZone(idZone);
    },
    loadDmdParZone: function loadDmdParZone(idZone) {
      //this.loading = true;
      this.legendeTab = "LISTE DES DEMANDES DE MAINTENANCES FILTRE PAR ZONE";
      this.listeDemandes = this.oldListDemandes;

      this.selectStatusDmd = null;
      this.selectRetardDmd = null;
      this.listeDemandes = this.listeDemandes.filter(function (item) {
        return item.idZone == idZone;
      });
    },
    loadDmdParEtat: function loadDmdParEtat(etat) {
      //this.loading = true;
      this.legendeTab = "LISTE DES DEMANDES DE MAINTENANCES FILTRE PAR ETAT ";
      this.listeDemandes = this.oldListDemandes;
      this.selectZoneDmd = null;
      this.selectStatusDmd = null;
      this.selectRetardDmd = null;
      this.listeDemandes = this.listeDemandes.filter(function (item) {
        return item.etatDmd == etat;
      });
    },
    loadDmdParStatus: function loadDmdParStatus(status) {
      this.listeDemandes = this.oldListDemandes;
      this.selectZoneDmd = null;
      this.selectEtatDmd = null;
      this.selectRetardDmd = null;
      this.legendeTab = "LISTE DES DEMANDES DE MAINTENANCES FILTRE PAR STATUS ";
      this.listeDemandes = this.listeDemandes.filter(function (item) {
        return item.statut == status;
      });
    },
    loadDmdParRetard: function loadDmdParRetard() {
      this.listeDemandes = this.oldListDemandes;
      this.selectZoneDmd = null;
      this.selectEtatDmd = null;
      this.selectStatusDmd = null;
      this.legendeTab = "LISTE DES DEMANDES DE MAINTENANCES EN RETARD DE REALISATION ";

      this.listeDemandes = this.listeDemandes.filter(function (item) {
        var date1 = new Date(item.dateFormat);
        var dateNow = new Date();
        var diff = dateDiff(date1, dateNow);
        if (diff.day >= 1 && item.statut != 2) {
          //si la difference est superieur a 1jours la demande est en retard
          return true;
        } else {
          return false;
        }
      });
    },
    clearSelect: function clearSelect() {
      this.listeDemandes = this.oldListDemandes;
      this.legendeTab = "LISTE DES DEMANDES DE MAINTENANCES ";
    },


    //statistique etat
    statDemandeGlobal: function statDemandeGlobal() {
      var optionDemandeGlobal = {
        title: {
          text: "ETATS DES DEMANDES",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },

        series: [{
          name: "",
          type: "pie",
          selectedMode: "single",
          radius: [0, "30%"],

          label: {
            normal: {
              position: "inner"
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: [
            //{value:this.statDemandeG.refuse, name:'Demandes Refusées'},
            //{value:this.statDemandeG.accepte, name:'Demandes Acceptées', selected:true},
          ]
        }, {
          name: "",
          type: "pie",
          radius: ["40%", "55%"],
          label: {
            normal: {
              formatter: "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
              backgroundColor: "#eee",
              borderColor: "#aaa",
              borderWidth: 1,
              borderRadius: 4,

              rich: {
                a: {
                  color: "#999",
                  lineHeight: 22,
                  align: "center"
                },

                hr: {
                  borderColor: "#aaa",
                  width: "100%",
                  borderWidth: 0.5,
                  height: 0
                },
                b: {
                  fontSize: 16,
                  lineHeight: 33
                },
                per: {
                  color: "#eee",
                  backgroundColor: "#334455",
                  padding: [2, 4],
                  borderRadius: 2
                }
              }
            }
          },
          data: [{
            value: this.statDemandeG.enCour,
            name: "Demandes en attente d'un technicien"
          },
          //{value:this.statDemandeG.enRetard, name:"Demandes en retard d'exécution"},
          {
            value: this.statDemandeG.enAttente,
            name: "En Attente de constat"
          }, {
            value: this.statDemandeG.attenteValid,
            name: "En attente de validation"
          }, { value: this.statDemandeG.termine, name: "Terminées" }, { value: this.statDemandeG.refuse, name: "Refusées" }, {
            value: this.statDemandeG.intervEnCours,
            name: "En cours d'intervention"
          }]
        }]
      };
      var geneChartDemandeGlobal = echarts.init(document.getElementById("demandeGblobal"));
      geneChartDemandeGlobal.setOption(optionDemandeGlobal);
    },


    //statistique etat
    statStatutDemande: function statStatutDemande() {
      var optionDemandeGlobal = {
        title: {
          text: "STATUS DES DEMANDES",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },

        series: [{
          name: "",
          type: "pie",
          selectedMode: "single",
          radius: [0, "30%"],

          label: {
            normal: {
              position: "inner"
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: [
            //{value:this.statDemandeG.refuse, name:'Demandes Refusées'},
            //{value:this.statDemandeG.accepte, name:'Demandes Acceptées', selected:true},
          ]
        }, {
          name: "",
          type: "pie",
          radius: ["40%", "55%"],
          label: {
            normal: {
              formatter: "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
              backgroundColor: "#eee",
              borderColor: "#aaa",
              borderWidth: 1,
              borderRadius: 4,

              rich: {
                a: {
                  color: "#999",
                  lineHeight: 22,
                  align: "center"
                },

                hr: {
                  borderColor: "#aaa",
                  width: "100%",
                  borderWidth: 0.5,
                  height: 0
                },
                b: {
                  fontSize: 16,
                  lineHeight: 33
                },
                per: {
                  color: "#eee",
                  backgroundColor: "#334455",
                  padding: [2, 4],
                  borderRadius: 2
                }
              }
            }
          },
          data: [{ value: this.statusDemande.attente, name: "En attente" }, {
            value: this.statusDemande.enCours,
            name: "En cours de traitement"
          }, { value: this.statusDemande.traite, name: "Traitée" }]
        }]
      };
      var geneChartDemandeGlobal = echarts.init(document.getElementById("statusGbDemande"));
      geneChartDemandeGlobal.setOption(optionDemandeGlobal);
    },


    //histogramme
    statDemandeAnnee: function statDemandeAnnee() {
      var optionDemandeAnnee = {
        title: {
          text: "DEMANDES TRAITE ET NON TRAITE DURANT LES 12 DERNIERS MOIS"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },

        xAxis: [{
          type: "category",
          data: []
        }],
        yAxis: [{
          type: "value"
        }],
        series: [{
          name: "Demandes réfusés",
          type: "bar",
          data: []
        }, {
          name: "Demandes en cours",
          type: "bar",
          data: []
        }, {
          name: "Demandes traité",
          type: "bar",
          data: []
        }]
      };

      this.demandeAnnee.forEach(function (element) {
        optionDemandeAnnee.xAxis[0].data.push(element.date);
        optionDemandeAnnee.series[0].data.push(element.refuse);
        optionDemandeAnnee.series[1].data.push(element.nonTraite);
        optionDemandeAnnee.series[2].data.push(element.traite);

        // optionDemandeAnnee.series[0].data.push(element.traite)
        // optionDemandeAnnee.series[1].data.push(element.nonTraite)
        // optionDemandeAnnee.series[2].data.push(element.refuse)
      });

      var maintChart = echarts.init(document.getElementById("demandeTraite"));
      maintChart.setOption(optionDemandeAnnee);
    },
    imprimeDemandePDF: function imprimeDemandePDF() {
      var tab = [];
      this.listeDemandes.forEach(function (demande) {
        tab.push(demande.idDemande);
      });

      var url = this.domaine + "demande_maintenance/imprimerPDF/liste/" + tab;
      window.open(url);
    },
    loadLieu: function loadLieu() {
      var _this7 = this;

      var url = this.domaine + "demande_maintenance/lieu/" + this.user.id;

      this.$http.get(url).then(function (response) {
        _this7.comboZoneDmd = response.body.lieux;
      }, function (erreurRep) {});
    },

    //method tree zone
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleNodeClick: function handleNodeClick() {
      //c'est ici qu'on attribu le proprietés concernant la zone
      this.dataZone = this.$refs.tree.getCurrentNode();
      //this.filtrerZoneDmd(this.dataZone.id )
      this.dialogZoneEdit = true;
    }
  },
  mounted: function mounted() {
    this.loadDemande();
    this.loadInfoRepresentant();
    this.loadLieu();
    this.loadTechnicien();
  }
});

/***/ }),

/***/ "OpSU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogValid),callback:function ($$v) {_vm.dialogValid=$$v},expression:"dialogValid"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter une nouvelle visite de chantier ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogValid = false;}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formVisite",attrs:{"lazy-validation":"","id":"formVisite"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                Détails de la visite de chantier  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("terrain")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Objet de la visite")]),_vm._v(" "),_c('el-input',{attrs:{"name":"objet"},model:{value:(_vm.objet),callback:function ($$v) {_vm.objet=$$v},expression:"objet"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Le projet"},on:{"change":_vm.loadProjChantier},model:{value:(_vm.selectProjet),callback:function ($$v) {_vm.selectProjet=$$v},expression:"selectProjet"}},_vm._l((_vm.listProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chantier concerné ")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Le chantier"},model:{value:(_vm.selectChantier),callback:function ($$v) {_vm.selectChantier=$$v},expression:"selectChantier"}},_vm._l((_vm.listChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de visite")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.disabledBtnStat,"name":"dateVisite","id":"dateVisite","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de le visite"},model:{value:(_vm.dateVisite),callback:function ($$v) {_vm.dateVisite=$$v},expression:"dateVisite"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nom du controleur")]),_vm._v(" "),_c('el-input',{model:{value:(_vm.nomControleur),callback:function ($$v) {_vm.nomControleur=$$v},expression:"nomControleur"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogValid = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":_vm.submitVisite}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowVisite),callback:function ($$v) {_vm.dialogShowVisite=$$v},expression:"dialogShowVisite"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue darken-2",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails de la visite ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowVisite = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"Veuillez patientez ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('p',[_c('b',[_vm._v("Objet de la visite : ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.objet)+" ")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Projet concerné : "+_vm._s(_vm.visiteCourant.projet)+" ")])]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Chantier concerné : ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.chantier)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Controleur : ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.controleur)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de la visite : ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.dateVisite)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Statut : ")]),_vm._v(" "),(_vm.visiteCourant.statut == 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                              EN ATTENTE\n                            ")]):_vm._e(),_vm._v(" "),(_vm.visiteCourant.statut == 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                              TERMINEE\n                            ")]):_vm._e()],1)])],1),_vm._v(" "),(_vm.visiteCourant.statut == 1)?_c('v-layout',{attrs:{"row":"","justify":""}},[_c('p',[_c('b',[_vm._v("Description du rapport : ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.description)+" ")])]):_vm._e(),_vm._v(" "),(_vm.visiteCourant.statut == 1)?_c('h6',[_vm._v(" Taches concernees ")]):_vm._e(),_vm._v(" "),(_vm.visiteCourant.statut == 1)?_c('v-layout',{attrs:{"row":"","justify":""}},_vm._l((_vm.visiteCourant.tache),function(item,index){return _c('p',[_vm._v("\n                            "+_vm._s(item.tacheId)+" - "+_vm._s(item.tacheLib)+"\n                        ")])}),0):_vm._e()],1)])],1)])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowVisite = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n          Fermer\n        ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogRapportValid),callback:function ($$v) {_vm.dialogRapportValid=$$v},expression:"dialogRapportValid"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter un rapport de visite de chantier ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogRapportValid = false;}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formRapport",attrs:{"lazy-validation":"","id":"formRapport"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                Rapport sur le chantier "+_vm._s(_vm.visiteCourant.chantier)+"  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("terrain")])],1)],1),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('p',[_c('b',[_vm._v("OBJET DE LA VISITE: ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.objet)+" ")])]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("PROJET CONCERNE: "+_vm._s(_vm.visiteCourant.projet)+" ")])]),_vm._v(" "),_c('p',[_c('b',[_vm._v("CHANTIER CONCERNE: ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.chantier)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("CONTROLEUR : ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.controleur)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("DATE D'ENREGISTREMENT: ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("DATE D'ENREGISTREMENT: ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.dateVisite)+" ")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('p',[_c('b',[_vm._v("LISTE DES TRAVAUX ")])])])],1)]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('el-table',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listTravaux},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"selection","width":"55"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Date de travaux","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.dateDtravo))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Travaux","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.labelTravo))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Tache","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.labelTache))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"typeTravaux","label":"Type de tache","show-overflow-tooltip":""}})],1),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description de la visite")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"rapport","placeholder":"Ecrivez votre rapport ici","required":""},model:{value:(_vm.rapportField),callback:function ($$v) {_vm.rapportField=$$v},expression:"rapportField"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogRapportValid = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":_vm.submitRapport}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupVisite),callback:function ($$v) {_vm.dialogSupVisite=$$v},expression:"dialogSupVisite"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-xs-center"},[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Supprimer la visite")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"outline":"","color":"orange darken-1","icon":"warning","value":true}},[_vm._v("\n                      La suppression d'une visite est irréversible.\n                  ")])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{on:{"click":function($event){$event.stopPropagation();_vm.dialogSupVisite = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteVisite()}}},[_vm._v("Supprimer ")])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('div',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n        LISTE DES VISITES DE CHANTIER "),_c('v-icon',{attrs:{"right":""}},[_vm._v("terrain")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeVisite('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeVisite('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n              ")])],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":_vm.newVisiteChantier},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n          Ajouter un nouvelle visite\n        ")],1)],1),_vm._v(" "),_c('v-card-text',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listVisiteChantier}},[_c('el-table-column',{attrs:{"prop":"objet","label":"OBJET","width":"370","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                "+_vm._s(scope.row.objet)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"controleur","label":"CONTROLEUR"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.controleur)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chantier","label":"CHANTIER"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.chantier)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"STATUT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.statut == 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                  EN ATTENTE\n              ")]):_vm._e(),_vm._v(" "),(scope.row.statut == 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                  TERMINEE\n              ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created","label":"DATE DE CREATION"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("\n                "+_vm._s(scope.row.created)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.modalShowVisite(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                  Détails\n                ")],1),_vm._v(" "),(scope.row.statut == 0)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){$event.stopPropagation();return _vm.editVisiteChantier(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                  Modifier\n                ")],1):_vm._e(),_vm._v(" "),(scope.row.statut == 0)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"purple"},on:{"click":function($event){$event.stopPropagation();return _vm.rapportVisiteChantier(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("chat")])],1),_vm._v("\n                  Rapport\n                ")],1):_vm._e(),_vm._v(" "),(scope.row.statut == 1)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerVisiteChantier(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                  Imprimer\n                ")],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.statut == 0)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();return _vm.modalDeleteVisite(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                  Supprimer\n                ")],1)],1)]}}])})],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Opqa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_projet_AjoutPrevisionBudget__ = __webpack_require__("5d9T");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//function de difference de date

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Oq2I");
__webpack_require__("miEh");




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */],
        AjoutPrevisionBudget: __WEBPACK_IMPORTED_MODULE_2__components_projet_AjoutPrevisionBudget__["a" /* default */]
    },
    props: {
        show: {
            type: Boolean
        },
        projet: {
            type: Object
        }
    },
    name: "CompteExploitationProjet",
    data: function data() {
        return {
            //data general
            notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
            loading: false,

            //VARIABLE
            tableListeTrxBudget: [],
            idTypeTache: null,
            totalMntPropose: 0,
            totalMntValide: 0,
            totalTravauxEnAttente: 0,

            //MODAL AJOUT PREVISION
            showModalAjoutPrevision: false,
            typeTravaux: {
                libelle: ""
            },
            dateAnMois: null,
            labelPosition: 'top'

        };
    },

    computed: {},
    watch: {
        show: function show(newValue, oldValue) {
            this.tableListeTrxBudget.splice(0);
            if (newValue == true) {
                this.idTypeTache = this.projet.idType;
                this.loadListeTravaux();
            } else {
                this.loadListeTravaux();
            }
        }
    },
    methods: {
        headerRowStyle: function headerRowStyle(_ref) {
            var row = _ref.row,
                rowIndex = _ref.rowIndex;

            return { "color": "black" };
        },
        format: function format(percentage) {
            return percentage + "%";
        },
        getSumm: function getSumm(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = "Sous total";
                    return;
                }

                if (index === 4) {
                    sums[index] = "N/A";
                    return;
                }
                var values = data.map(function (item) {
                    return Number(item[column.property]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0));
                } else {
                    sums[index] = "N/A";
                }
            });

            return sums;
        },
        modalAjoutBudget: function modalAjoutBudget(item) {
            this.typeTravaux = item;
            this.showModalAjoutPrevision = true;
            console.log('je suis ici');
        },
        loadListeTravaux: function loadListeTravaux() {
            var _this = this;

            this.loading = true;

            var url = this.domaine + "budgetProjet/typeTache/" + this.idTypeTache + "/projet/" + this.projet.id;

            this.$http.get(url).then(function (resp) {
                _this.loading = false;
                _this.tableListeTrxBudget = resp.body.listeTypeTrx;
                _this.totalMntPropose = resp.body.totalMntPropose;
                _this.totalMntValide = resp.body.totalMntValide;
                _this.totalTravauxEnAttente = resp.body.totalTravauxEnAttente;
            }, function (error) {
                _this.loading = false;
                _this.$message.error("Une erreur est survenue lors du chargement de la liste travaux du module compte exploitation");
            });
        },


        //recherche info projet ou chantier
        submitForm: function submitForm() {}
    },

    mounted: function mounted() {}
});

/***/ }),

/***/ "OwC2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "LoadTarifFournExcel",
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
    props: {
        listeTypeTravaux: {
            type: Array,
            default: null
        },
        show: {
            type: Boolean,
            default: false
        },
        idFour: {
            type: Number
        }
    },
    data: function data() {
        return {
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            dialogAjoutBudget: false,
            loading: false
        };
    },

    watch: {
        show: function show(newValue, oldValue) {
            if (newValue == true) {
                this.dialogAjoutBudget = true;
            } else {
                this.dialogAjoutBudget = false;
                // this.loadProduitFounRecent()
                this.$emit("close");
            }
        }
    },
    methods: {
        saveListe: function saveListe() {
            var _this = this;

            // this.loadPage()
            this.loading = true;
            var succesEnreg = true;
            var url = this.domaine + "fournisseur/save/tarification/excel";
            var nbData = 10;
            var nbReq = 1;
            var ligne = null;

            var nbRest = void 0;
            if (this.listeTypeTravaux.length > 10) {
                nbData = 10;
                nbReq = Math.round(this.listeTypeTravaux.length / nbData);
                nbRest = this.listeTypeTravaux.length % nbData;
                if (nbRest > 0) {
                    nbReq += 1;
                }
            }
            for (var i = 0; i < nbReq; i++) {
                var initJ = i * nbData;
                var finJ = (i + 1) * nbData;
                var dataLot = [];
                if (this.listeTypeTravaux.length > 0) {
                    for (var j = initJ; j < finJ; j++) {
                        if (this.listeTypeTravaux[j] == undefined) {
                            break;
                        }
                        dataLot.push(this.listeTypeTravaux[j]);
                    }
                }
                var data = new FormData();
                for (var prop in dataLot) {
                    ligne = dataLot[prop];
                    data.append("option[type][]", ligne.type);
                    data.append("option[libelle][]", ligne.libelle);
                    data.append("option[unite][]", ligne.unite);
                    data.append("option[montant][]", ligne.montant);
                }

                // data.append('listeTypeTravaux', JSON.stringify(dataLot))
                data.append('idUser', this.user.id);
                data.append('fournisseur', this.idFour);

                this.$http.post(url, data).then(function (resp) {
                    _this.loading = false;
                    succesEnreg = false;
                    // this.loadProduitFounRecent()

                    _this.$emit("close");
                    _this.dialogAjoutBudget = false;
                    _this.$notify({
                        title: "Enregistrement",
                        message: "La liste a ete enregistre avec succes",
                        type: "success",
                        position: "top-right",
                        duration: 7000
                    });
                }, function (error) {
                    _this.loading = false;
                    succesEnreg = false;
                    _this.dialogAjoutBudget = false;
                    _this.$message.error("Erreur lors de l'enregistrement des tarifs");
                });
            }

            //  this.loading = true
            // const loading = this.$loading({
            //     lock: true,
            //     text: 'Veuillez patientez ...',
            //     spinner: 'el-icon-loading',
            //     background: 'rgba(0, 0, 0, 0.7)'
            // })
        },
        loadProduitFounRecent: function loadProduitFounRecent() {
            var _this2 = this;

            this.loading = true;
            var url = "";
            if (this.droitAcces.index_produit_fourn) {
                url = this.domaine + 'fournisseur/' + this.idFour + '/index/produit/recent';
            } else {
                url = this.domaine + 'fournisseur/' + this.idFour + '/index/' + this.user.id + '/produit/recent';
            }

            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this2.loading = false;
                }
            });
        },
        closeDialog: function closeDialog() {
            this.$emit("close");
            // this.loadListeTravaux()
        }
    }
});

/***/ }),

/***/ "P6qC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransfertCarteIndex_vue__ = __webpack_require__("bZ3R");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cd31254_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransfertCarteIndex_vue__ = __webpack_require__("giEb");
function injectStyle (ssrContext) {
  __webpack_require__("Eh/d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1cd31254"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransfertCarteIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cd31254_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransfertCarteIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PBTy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadDepenseProduitExcel_vue__ = __webpack_require__("JikA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19897e0b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadDepenseProduitExcel_vue__ = __webpack_require__("pcwE");
function injectStyle (ssrContext) {
  __webpack_require__("UMsA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19897e0b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadDepenseProduitExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19897e0b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadDepenseProduitExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PCFD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_boardChantier_Contrat_ouvrier__ = __webpack_require__("OChs");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */], ContratOuvrier: __WEBPACK_IMPORTED_MODULE_1__components_boardChantier_Contrat_ouvrier__["a" /* default */] },
  name: "ListePrestataire",
  props: {
    show: {
      type: Boolean
    },
    type: {
      type: Number, //0=>chef travaux 1=>chantier//2=>projet
      default: 0
    },
    listePrestataires: {
      type: Array
    },
    listeOuvriers: {
      type: Array
    },
    idChantier: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,

      //ONGLET OUVRIERS/PRESTATAIRES
      typePrestataire: 0,
      showListeContrat: false,
      idPrest: null,
      nbContratOuvriers: 0,
      mntTotalVerseOuv: 0,
      mntTotalRestantOuv: 0,
      mntTotalOuv: 0,

      nbContratPrest: 0,
      mntTotalVersePrest: 0,
      mntTotalRestantPrest: 0,
      mntTotalPrest: 0
    };
  },


  watch: {
    show: function show(newValue, oldValue) {
      var _this = this;

      if (newValue == true) {
        this.nbContratPrest = 0;
        this.mntTotalVersePrest = 0;
        this.mntTotalRestantPrest = 0;
        this.mntTotalPrest = 0;

        this.nbContratOuvriers = 0;

        this.mntTotalVerseOuv = 0;
        this.mntTotalRestantOuv = 0;
        this.mntTotalOuv = 0;

        if (this.listeOuvriers.length != 0) {
          this.listeOuvriers.forEach(function (ouvrier) {
            var contrats = ouvrier.contrats;
            if (contrats != null) {
              _this.nbContratOuvriers += ouvrier.nbContrats;

              _this.mntTotalVerseOuv += ouvrier.mntTotalVerse;
              _this.mntTotalRestantOuv += ouvrier.mntTotalRestant;
              _this.mntTotalOuv += ouvrier.mntTotal;

              // contrats.forEach(cont=>{
              //     this.mntTotalVerseOuv +=  cont.mntVerserContrat
              //     this.mntTotalRestantOuv +=  cont.mntAverserContrat
              //     this.mntTotalOuv +=  cont.mntTotalContrat
              // })
            }
          });
        }

        if (this.listePrestataires.length != 0) {
          this.listePrestataires.forEach(function (prestataire) {
            var contrats = prestataire.contrats;
            if (contrats != null) {
              _this.nbContratPrest += prestataire.nbContrats;
              _this.mntTotalVersePrest += prestataire.mntTotalVerse;
              _this.mntTotalRestantPrest += prestataire.mntTotalRestant;
              _this.mntTotalPrest += prestataire.mntTotal;

              // contrats.forEach(cont=>{
              //     this.mntTotalVersePrest +=  cont.mntVerserContrat
              //     this.mntTotalRestantPrest +=  cont.mntAverserContrat
              //     this.mntTotalPrest +=  cont.mntTotalContrat
              // })
            }
          });
        }
      }
    }
  },

  methods: {
    modalListeContrat: function modalListeContrat(prestataire) {
      this.typePrestataire = prestataire.type;
      this.idPrest = prestataire.idPrest;
      this.showListeContrat = true;
    }
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ "PD6H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PFHd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        idUserContrat: {
            type: Number
        }
    },
    components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
    name: "formContrat",
    data: function data() {
        return {
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,

            formContrat: {
                idTypeCont: 1,
                renumeration: 5,
                libPoste: '',
                statut: 0,
                typePaie: 1,
                tauxPaiement: 2,
                dateFin: null
            },
            listeProjets: [],
            active: 0,
            listeStatut: [{
                libelle: "non",
                id: 0
            }, {
                libelle: "exempt",
                id: 1
            }],
            listeTauxPaiement: [{
                libelle: "Heure",
                id: 1
            }, {
                libelle: "Mois",
                id: 2
            }, {
                libelle: "Semaine",
                id: 3
            }, {
                libelle: "Annee",
                id: 4
            }],
            listeTypePaie: [{
                libelle: "Salaire",
                id: 1
            }, {
                libelle: "Heure",
                id: 2
            }, {
                libelle: "Contrat",
                id: 3
            }, {
                libelle: "Commission",
                id: 4
            }],
            listeTypeContrat: [{
                libelle: "Stagiaire formation",
                id: 1
            }, {
                libelle: "Stagiaire Professionnel",
                id: 3
            }, {
                libelle: "Temps partiel",
                id: 5
            }, {
                libelle: "Consultant",
                id: 7
            }, {
                libelle: "CDI",
                id: 9
            }, {
                libelle: "CDD",
                id: 11
            }],
            listePoste: [],
            listeUser: [],
            listePhotos: [],
            rules: {
                dateSignature: [{ type: 'date', required: true, message: 'Veuillez selectionnez une date', trigger: 'blur' }],
                libPoste: [{ required: true, message: "Veuillez saisir ou selectionnez le poste", trigger: 'blur' }],
                typeContrat: [{ required: true, message: "Veuillez  selectionnez le type de contrat", trigger: 'blur' }]

            },
            dateInvalide: true,
            nextEtatContrat: 0 //contrat en cours par defaut

        };
    },

    methods: {
        //que la date de debut est toujours superieur a la date fin
        verifDate: function verifDate() {
            var _this = this;

            if (this.formContrat.dateSignature.getTime() >= this.formContrat.dateFin.getTime()) {
                this.dateInvalide = true;
                this.formContrat.dateSignature = null;
                this.formContrat.dateFin = null;

                this.$alert('La début doit être strictement inférieur à la date de fin du contrat', 'Validation champs date', {
                    confirmButtonText: 'OK'
                });
            } else {
                //Verifier si le contrat peut etre creer
                this.loading = true;
                var url = this.domaine + 'rh/verification/contrat/employe/' + this.idUserContrat;
                var tabDbt = new Intl.DateTimeFormat('en-GB').format(this.formContrat.dateSignature).split("/");
                var tabFin = new Intl.DateTimeFormat('en-GB').format(this.formContrat.dateFin).split("/");

                var data = {
                    dateDbt: tabDbt[2] + "-" + tabDbt[1] + "-" + tabDbt[0],
                    dateFin: tabFin[2] + "-" + tabFin[1] + "-" + tabFin[0],
                    typeContrat: this.formContrat.idTypeCont
                };

                this.$http.get(url, { params: data }).then(function (resp) {
                    _this.loading = false;
                    if (resp.body.code == 0) //le contrat ne peut etre creer
                        {
                            _this.formContrat.dateFin = null;
                            _this.formContrat.dateSignature = null;
                            _this.dateInvalide = true;
                            _this.$alert(resp.body.message, 'Validation champs date', {
                                confirmButtonText: 'OK'
                            });
                            return;
                        }
                    _this.dateInvalide = false;
                    _this.nextEtatContrat = resp.body.etatContrat;
                }, function (error) {
                    _this.loading = false;
                    _this.formContrat.dateFin = null;
                    _this.dateInvalide = true;
                    _this.$message.error("Une erreur sest produite lors de la validation des champs dates");
                });
            }
        },
        verifDateContCDI: function verifDateContCDI() {
            var _this2 = this;

            if (this.formContrat.idTypeCont == 9 && this.formContrat.dateSignature != null) {
                //Verifier si le contrat peut etre creer
                this.loading = true;
                var url = this.domaine + 'rh/verification/contrat/employe/' + this.idUserContrat;
                var tabDbt = new Intl.DateTimeFormat('en-GB').format(this.formContrat.dateSignature).split("/");
                var data = {
                    dateDbt: tabDbt[2] + "-" + tabDbt[1] + "-" + tabDbt[0],
                    dateFin: null,
                    typeContrat: this.formContrat.idTypeCont
                };

                this.$http.get(url, { params: data }).then(function (resp) {
                    _this2.loading = false;
                    if (resp.body.code == 0) //le contrat ne peut etre creer
                        {
                            _this2.formContrat.dateFin = null;
                            _this2.formContrat.dateSignature = null;
                            _this2.dateInvalide = true;
                            _this2.$alert(resp.body.message, 'Validation champs date', {
                                confirmButtonText: 'OK'
                            });
                            return;
                        }
                    _this2.dateInvalide = false;
                    _this2.nextEtatContrat = resp.body.etatContrat;
                }, function (error) {
                    _this2.loading = false;
                    _this2.formContrat.dateFin = null;
                    _this2.dateInvalide = true;
                    _this2.$message.error("Une erreur sest produite lors de la validation des champs dates");
                });
            }
        },
        verifInformation: function verifInformation() {
            if (this.formContrat.idTypeCont == null || this.formContrat.dateSignature == null || this.formContrat.libPoste == "") {
                this.$message.error("Veuillez remplir correctement les champs svp");
                return false;
            } else {
                return true;
            }
        },
        changeFile: function changeFile(file, fileList) {
            this.listePhotos.splice(0);
            var fileReader = new FileReader();

            for (var ind in fileList) {
                var filename = fileList[ind].name;
                if (filename.lastIndexOf(".") <= 0) {
                    return alert("Veuillez selectionner un  format de fichier valide ");
                }
                //fileReader.readAsDataURL(fileList[ind].raw)
                this.listePhotos.push(fileList[ind].raw);
            }
        },
        next: function next() {
            if (this.active++ > 1) this.active = 1;
        },
        previous: function previous() {
            if (this.active-- < 0) this.active = 0;
        },
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        },
        submitForm: function submitForm() {
            var _this3 = this;

            if (!this.verifInformation()) {
                this.active = 0;
                return;
            }

            this.loading = true;
            var url = this.domaine + 'rh/new/contrat/user/' + this.idUserContrat;
            var data = new FormData();
            data.append("dataForm", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formContrat));

            data.append("idCreatedUser", this.user.id);
            if (this.listePhotos.length > 0) {
                this.listePhotos.forEach(function (file) {
                    data.append("fichierImage[]", file, file[name]);
                }, this);
            }

            this.$http.post(url, data).then(function (response) {
                _this3.active = 0;
                _this3.resetFormContrat();
                _this3.closeForm();
                _this3.loading = false;
                _this3.successNotif(response.body.message);
            }, function (error) {
                _this3.loading = false;
                _this3.$message.error("Echec lors de l'enregistrement du contrat");
            });
        },
        loadListeProjet: function loadListeProjet() {
            var _this4 = this;

            var url = this.domaine + 'projet/liste';
            this.$http.get(url).then(function (resData) {
                _this4.listeProjets = resData.body.listeProjets;
            }, function (error) {
                _this4.loading = false;
                _this4.$message.error("Echec lors du chargement de la liste des projets");
            });
        },
        loadTypeContrat: function loadTypeContrat() {
            var _this5 = this;

            var url = this.domaine + 'rh/listeTypeConge';
            this.$http.get(url).then(function (resData) {
                _this5.listeTypeConge = resData.body.listeAbsences;
            }, function (error) {
                _this5.loading = false;
                _this5.$message.error("Echec lors du chargement de al liste des type de conges");
            });
        },
        loadUser: function loadUser() {
            var _this6 = this;

            var url = this.domaine + 'rh/users/listeUtilitsateur';
            this.$http.get(url).then(function (resData) {
                _this6.listeUser = resData.body.listeUsers;
            }, function (error) {
                _this6.loading = false;
                _this6.$message.error("Echec lors du chargement de al liste des superviseurs");
            });
        },
        loadPoste: function loadPoste() {},
        closeForm: function closeForm() {
            this.$emit("close");
        },

        //reinitialise le formulaire de creation de contrat
        resetFormContrat: function resetFormContrat() {
            this.formContrat.idTypeCont = '';
            this.formContrat.dateSignature = '';
            this.formContrat.dateFin = '';
            this.formContrat.idProjet = '';
            this.formContrat.superviseur = '';
            this.formContrat.description = '';
            this.formContrat.tauxPaiement = '';
            this.formContrat.typePaie = '';
            this.formContrat.renumeration = '';
            this.formContrat.statut = '';
        }
    },
    computed: {
        isInvalide: function isInvalide() {
            if (this.dateInvalide == true && this.formContrat.idTypeCont != 9 || this.formContrat.libPoste == "" || this.formContrat.dateSignature == null) {
                return true;
            } else {
                return false;
            }
        }
    },

    mounted: function mounted() {
        this.loadListeProjet();
        this.loadTypeContrat();
        this.loadPoste();
        this.loadUser();
    }
});

/***/ }),

/***/ "PFXP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//liste l'ensemble  des besoins  ou les besoinsa valider par un responsable


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "BesoinCarburantResponsable",
  props: {
    show: {
      type: Boolean
    },
    typeReche: {
      type: String
    },
    idresponsable: {
      type: Number,
      default: null
    },
    listeTrx: {
      type: Array
    },
    listeBesoins: {
      type: Array
    },
    listeChantiers: {
      type: Array
    },
    idProjet: {
      type: Number
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      dialogValideBesoin: false,
      multipleSelection: [],
      //FILTRE
      listeProjet: [],
      listEntrepot: [],
      listeChantier: [],
      listeTravaux: [],
      listeTaches: [],
      travauxS: "",
      tachesS: "",
      BesoinsList: [],
      projetS: "",
      valide: false,
      chantierS: "",
      listeBesoinSelect: [],
      disabledBtnValide: true,
      commDec: null
    };
  },

  watch: {
    show: function show(newValue, oldvalue) {
      if (newValue == true) {
        //this.oldListTravaux = this.listeTrx;
      }
    },
    listeBesoins: function listeBesoins(newValue, oldvalue) {
      this.BesoinsList = this.listeBesoins;
      this.listeChantier = this.listeChantiers;
    }
  },
  methods: {
    //FILTRE
    loadProjet: function loadProjet() {
      var _this = this;

      this.chantierS = "";
      this.listeChantier.splice(0);
      this.chantierS = null;
      var url = this.domaine + "projet/index/projet/all";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this.loading = false;
        _this.listeProjet = response.body.projet;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    loadTravaux: function loadTravaux() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "projet/" + this.idProjet + "/all/travaux";
      this.$http.get(url).then(function (response) {
        _this2.loading = false;
        _this2.listeChantier = response.body.chantier;
      }, function (errRep) {
        _this2.loading = false;
        _this2.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    filtrerChantier: function filtrerChantier() {
      var idChant = this.chantierS;
      if (idChant == null || idChant == "undefined" || idChant == "") {
        this.BesoinsList = this.listeBesoins;
        // this.filtrerChantier()
        return;
      }
      this.BesoinsList = this.listeBesoins.filter(function (item) {
        return item.idChant == idChant;
      });
      var tableau = this.listeBesoins.filter(function (item) {
        return item.idChant == idChant;
      });
      for (var i = 0; i < tableau.length; ++i) {
        for (var j = i + 1; j < tableau.length; ++j) {
          if (tableau[i].idTravaux === tableau[j].idTravaux) {
            tableau.splice(j--, 1);
          }
        }
      }

      this.listeTravaux = tableau;
    },
    calculTotalComm: function calculTotalComm(item) {
      this.valide = false;
      var restant = item.qte - item.qteC;
      if (restant < item.qteR) {
        this.valide = true;
        this.$message.error("La quantité demandé ne dois pas etre supérieur a la quantité prévu ");
      }
    },
    filtrerTravaux: function filtrerTravaux() {
      var travauxS = this.travauxS;
      this.listeTaches = [];
      if (travauxS != "") {
        this.BesoinsList = this.listeBesoins;
      }
      if (travauxS == null || travauxS == "undefined" || travauxS == "") {
        this.BesoinsList = this.listeBesoins;
        // this.filtrerChantier()
        return;
      }

      var tab = this.BesoinsList;
      this.BesoinsList = tab.filter(function (item) {
        return item.idTravaux == travauxS;
      });

      var tableau = tab.filter(function (item) {
        return item.idTravaux == travauxS;
      });
      for (var i = 0; i < tableau.length; ++i) {
        for (var j = i + 1; j < tableau.length; ++j) {
          if (tableau[i].idTache === tableau[j].idTache) {
            tableau.splice(j--, 1);
          }
        }
      }
      this.listeTaches = tableau;
    },
    filtrerTaches: function filtrerTaches() {
      var idTache = this.tachesS;
      if (idTache == null || idTache == "undefined" || idTache == "") {
        //  this.BesoinsList = this.listeBesoins;
        this.filtrerTravaux();
        this.filtrerChantier();
        return;
      }
      this.filtrerChantier();
      var tab = this.BesoinsList;
      this.BesoinsList = tab.filter(function (item) {
        return item.idTache == idTache;
      });
    },
    modalValideBesoin: function modalValideBesoin() {
      this.listeBesoinSelect = this.multipleSelection.slice();
      this.dialogValideBesoin = true;
      this.loadEntrepot();
    },
    loadEntrepot: function loadEntrepot() {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + "entrepot/index/carburant";
      this.$http.get(url).then(function (response) {
        _this3.loading = false;
        if (response.body) {
          _this3.listEntrepot = response.body.entrepot;
        }
      }, function (error) {
        _this3.loading = false;
      });
    },
    imprimeAllBesoins: function imprimeAllBesoins(item) {
      var url = this.domaine + "projet/impression/all/besoins/" + this.user.id + "/" + this.idProjet;
      window.open(url);
    },
    validRejetBesoin: function validRejetBesoin(decision) {
      var _this4 = this;

      if (this.valide == true) {
        this.$notify({
          title: "ENREGISTREMENT ECHOUE",
          message: "QUANTITE RENSSEIGNEE SUPERIEUR A LA QUANTITE PREVU.",
          type: "warning",
          position: "top-center"
        });
        return;
      }
      this.loading = true;

      //decision == 1 = Valider // decision == 0 //Refuser
      var url = this.domaine + "besoin/avalider";
      var nbData = 10;
      var nbReq = 1;
      var ligne = null;
      var nbRest = void 0;
      if (this.listeBesoinSelect.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.listeBesoinSelect.length / nbData);
        nbRest = this.listeBesoinSelect.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (var i = 0; i < nbReq; i++) {
        var initJ = i * nbData;
        var finJ = (i + 1) * nbData;
        var dataLot = [];
        if (this.listeBesoinSelect.length > 0) {
          for (var j = initJ; j < finJ; j++) {
            if (this.listeBesoinSelect[j] == undefined) {
              break;
            }
            dataLot.push(this.listeBesoinSelect[j]);
          }
        }
        var data = new FormData();
        for (var prop in dataLot) {
          ligne = dataLot[prop];
          data.append("option[id][]", ligne.id);
          data.append("option[dateLivrSouh][]", ligne.dateLivrSouh);
          data.append("option[qteR][]", ligne.qteR);
          data.append("option[entrepot][]", ligne.entrepot);
        }
        data.append("decision", decision);
        data.append("commDec", this.commDec);
        data.append("type", this.typeReche);
        data.append("idUser", this.user.id);

        this.$http.post(url, data).then(function (resp) {
          _this4.dialogValideBesoin = false;
          _this4.loading = false;
          _this4.$emit("reloadBesoins");
          _this4.$notify({
            title: "Validation besoins",
            message: "L'opération s'est déroulée avec succès",
            type: "success",
            position: "top-center"
          });
        }, function (error) {
          _this4.dialogValideBesoin = false;
          _this4.loading = false;
          _this4.$message.error("Erreur lors du chargement de la validation des besoins");
        });
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.disabledBtnValide = true;
      } else {
        this.disabledBtnValide = false;
      }
    },
    headerRowStyle: function headerRowStyle(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return { color: "black" };
    }
  },
  computed: {
    verifDateSouh: function verifDateSouh() {
      var resutat = true;
      for (var prop in this.listeBesoinSelect) {
        var ligne = this.listeBesoinSelect[prop];

        if (ligne["dateLivrSouh"] == null || ligne["dateLivrSouh"] == undefined) {
          resutat = false;
          break;
        }
      }
      return resutat;
    },
    clearSelectTache: function clearSelectTache() {
      // this.tachesS = ''
      this.filtrerTravaux();
    },
    clearSelectTravaux: function clearSelectTravaux() {
      // this.travauxS = ''
      this.filtrerChantier();
    },
    clearSelectChantier: function clearSelectChantier() {
      this.chantierS = "";
      this.loadProjet();
    },

    verifBtnConfirme: function verifBtnConfirme() {
      if (this.verifDateSouh == true && this.commDec != null && this.commDec.toUpperCase() == "BON POUR ACCORD") {
        return true;
      }
      return false;
    },

    verifBtnRefus: function verifBtnRefus() {
      if (this.commDec != null) {
        return true;
      }
      return false;
    }
  },
  mounted: function mounted() {
    this.chantierS = "";
  }
});

/***/ }),

/***/ "PPX5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_rapport_ListeReserve__ = __webpack_require__("cz/F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_boardTravaux_ListeTravaux__ = __webpack_require__("s7lN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_boardTravaux_widgetTravaux__ = __webpack_require__("MasU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_3__components_Loading__["a" /* default */], ListeReserve: __WEBPACK_IMPORTED_MODULE_0__components_rapport_ListeReserve__["a" /* default */], ListeTravaux: __WEBPACK_IMPORTED_MODULE_1__components_boardTravaux_ListeTravaux__["a" /* default */], WidgetTravaux: __WEBPACK_IMPORTED_MODULE_2__components_boardTravaux_widgetTravaux__["a" /* default */] },
  name: "DashboardTravaux",
  props: {
    show: {
      type: Boolean
    },
    detailChantier: {
      type: Object
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      racourcis: [{ path: "/boardTravaux'", text: "BOARD TRAVAUX", disabled: false }],

      dialogDashboardChantier: false,
      loading: false,
      onglet: "0",
      listeTravaux: [],
      listeTravauxId: [],
      //ONGLET TRAVAUX
      detailTravaux: {},
      dialogConfirmRefus: false,
      showRapport: false,
      showListeRapport: false,
      dialogListeRapport: false,
      listeRapports: [],
      periodeFormat: "",

      //ONGLET RESERVE
      listeReserves: [],

      //DASHBOARD TRAVAUX
      formTri: {
        periode: null
      }
    };
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    loadTravaux: function loadTravaux() {
      var _this = this;

      var periode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var url = "";
      console.log('his.user.fonction == ', this.user.fonction);
      if (this.user.fonction == "Super Administrateur") {
        url = this.domaine + "travaux/user/admin?periode=" + periode;
      } else {
        url = this.domaine + "travaux/user/" + this.user.id + "/" + periode;
      }
      console.log(' == ', url);

      this.loading = true;
      this.listeTravauxId = [];
      this.$http.get(url).then(function (response) {
        _this.listeTravaux = response.body.travaux;
        _this.listeTravaux.forEach(function (element) {
          _this.listeTravauxId.push(element.idTrx);
        });
        _this.loading = false;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Echec lors du chargement des travaux");
      });
    },


    //ONGLET RESERVE
    loadReserves: function loadReserves() {
      var _this2 = this;

      var periode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.loading = true;
      var url = this.domaine + "reserve/cheftravaux/" + this.user.id + "/" + periode;
      this.$http.get(url).then(function (response) {
        _this2.listeReserves = response.body.reserves;
        _this2.loading = false;
      }, function (error) {
        _this2.loading = false;
        _this2.$message.error("Echec lors du chargement des reserves");
      });
    },
    recherche: function recherche() {
      var periode = this.formTri.periode;
      var dateDbt = new Date(periode[0]);
      var dateFin = new Date(periode[1]);

      this.periodeFormat = "DU " + dateDbt.toLocaleDateString("fr-FR") + " AU " + dateFin.toLocaleDateString("fr-FR");
      this.loadTravaux(periode);
      this.loadReserves(periode);
    },
    handleTabClick: function handleTabClick(tab) {
      switch (tab) {
        case "0":
          if (this.listeTravaux.length == 0) {
            //this.loadTravaux(this.detailChantier);
          }

          break;
        case "1":
          if (this.listeReserves.length == 0) {
            //this.loadReserves();
          }
          break;

        default:
          break;
      }
    }
  },
  computed: {
    desactiveBout: function desactiveBout() {
      return this.formTri.periode == undefined;
    }
  },
  mounted: function mounted() {
    this.periodeFormat = " DES 3 DERNIERS MOIS";
    this.loadTravaux();
    this.loadReserves();
  }
});

/***/ }),

/***/ "PYhX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"width":"80%","persistent":true,"transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogDemande),callback:function ($$v) {_vm.dialogDemande=$$v},expression:"dialogDemande"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Effectuer une demande de réparation")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formIntervention",staticClass:"demo-form-inline",attrs:{"id":"formInterv","model":_vm.intervDetail,"rules":_vm.rules}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Vehicule concerné","prop":"vehicule"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Vehicule concerné"},on:{"change":function($event){return _vm.selectChauffeur(_vm.intervDetail.idVeh)}},model:{value:(_vm.intervDetail.idVeh),callback:function ($$v) {_vm.$set(_vm.intervDetail, "idVeh", $$v)},expression:"intervDetail.idVeh"}},_vm._l((_vm.listVehicule),function(item){return _c('el-option',{key:item.idVeh,attrs:{"label":item.libelle,"value":item.idVeh}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs3":""}},[_c('el-form-item',{attrs:{"label":"Chauffeur","prop":"chauffeur"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"size":"large","disabled":"","placeholder":""},model:{value:(_vm.intervDetail.Chauffeur),callback:function ($$v) {_vm.$set(_vm.intervDetail, "Chauffeur", $$v)},expression:"intervDetail.Chauffeur"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs3":""}},[_c('el-form-item',{attrs:{"label":"Categorie","prop":"categorie"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Catégorie"},model:{value:(_vm.intervDetail.categorie),callback:function ($$v) {_vm.$set(_vm.intervDetail, "categorie", $$v)},expression:"intervDetail.categorie"}},_vm._l((_vm.categorie),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs3":""}},[_c('el-form-item',{attrs:{"label":"Type de demande","prop":"type"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Type de demande"},model:{value:(_vm.intervDetail.type),callback:function ($$v) {_vm.$set(_vm.intervDetail, "type", $$v)},expression:"intervDetail.type"}},_vm._l((_vm.typeDemande),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Gravité","prop":"gravite"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Gravité"},model:{value:(_vm.intervDetail.gravite),callback:function ($$v) {_vm.$set(_vm.intervDetail, "gravite", $$v)},expression:"intervDetail.gravite"}},_vm._l((_vm.gravite),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Priorité","prop":"priorite"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Priorité"},model:{value:(_vm.intervDetail.priorite),callback:function ($$v) {_vm.$set(_vm.intervDetail, "priorite", $$v)},expression:"intervDetail.priorite"}},_vm._l((_vm.priorite),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Date de la demande","prop":"date"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"d-MM-yyyy HH:mm","value-format":"yyyy-MM-d HH:mm","name":"date","type":"datetime","placeholder":"Date de la demande"},model:{value:(_vm.intervDetail.dateFormat),callback:function ($$v) {_vm.$set(_vm.intervDetail, "dateFormat", $$v)},expression:"intervDetail.dateFormat"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Nom du demandeur","prop":"demandeur"}},[_c('el-autocomplete',{staticStyle:{"width":"100%"},attrs:{"name":"demandeur","placeholder":"nom du demandeur","fetch-suggestions":_vm.loadDemandeur},model:{value:(_vm.intervDetail.demandeur),callback:function ($$v) {_vm.$set(_vm.intervDetail, "demandeur", $$v)},expression:"intervDetail.demandeur"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Télephone du demandeur","prop":"telephone"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"telephone","placeholder":"Téléphone du demandeur"},model:{value:(_vm.intervDetail.telephone),callback:function ($$v) {_vm.$set(_vm.intervDetail, "telephone", $$v)},expression:"intervDetail.telephone"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Projet","prop":"projet"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"projet","placeholder":"projet"},on:{"change":_vm.selectProjet},model:{value:(_vm.intervDetail.projet),callback:function ($$v) {_vm.$set(_vm.intervDetail, "projet", $$v)},expression:"intervDetail.projet"}},_vm._l((_vm.listeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-2",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Chantier","prop":"chantier"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"chantier","placeholder":"chantier"},model:{value:(_vm.intervDetail.chantier),callback:function ($$v) {_vm.$set(_vm.intervDetail, "chantier", $$v)},expression:"intervDetail.chantier"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"motif"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"motif","placeholder":"description","required":""},model:{value:(_vm.intervDetail.motif),callback:function ($$v) {_vm.$set(_vm.intervDetail, "motif", $$v)},expression:"intervDetail.motif"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-3",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"","prop":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.imageDmdInterv,"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"fileDmdInterv",staticStyle:{"display":"none"},attrs:{"name":"imageDmdInterv","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageDmdIntervPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileDmdInterv.click()}}},[_vm._v("Photo "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('div',{staticClass:"font-weight-thin"},[_vm._v("\n                    Fichier au format (JPEG,PNG,PDF) avec une taille de 2 Mo\n                    maximale\n                  ")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitIntervention('formIntervention')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PsOW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v(_vm._s(item.text)+"\n        ")])}),1)],1)],1),_vm._v(" "),(_vm.droitAcces.intervention || _vm.droitAcces.list_dmdeur_intervention)?_c('el-row',{attrs:{"gutter":20}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticStyle:{"width":"450px","height":"300px"},attrs:{"id":"chartsDisponibilite"}})]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticStyle:{"width":"900px","height":"300px"},attrs:{"id":"chartsMarqueVeh"}})])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.intervention || _vm.droitAcces.list_dmdeur_intervention)?_c('el-row',{attrs:{"gutter":20}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticStyle:{"width":"100%","height":"300px"},attrs:{"id":"chartAllBilanCarburant"}})])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.intervention || _vm.droitAcces.list_dmdeur_intervention)?_c('el-row',{attrs:{"gutter":20}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticStyle:{"width":"100%","height":"300px"},attrs:{"id":"chartAllBilanCarburantQut"}})])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":18}},[_c('div',{staticClass:"grid-content"},[_c('el-row',[_c('el-col',[_c('el-card',{staticClass:"box-card"},[_c('v-layout',{attrs:{"row":"","justify":""}},[(
                      _vm.droitAcces.webservice_consommation_index ||
                        _vm.droitAcces.intervention ||
                        _vm.droitAcces.list_dmdeur_intervention
                    )?_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md6":""}},[_c('el-button',{staticClass:"btnV",attrs:{"type":"primary","size":"medium"}},[_vm._v("VEHICULES")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":""}},[_c('el-card',{staticClass:"box-card"},[_c('el-collapse',{attrs:{"accordion":""}},[_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_vm._v("\n                                Statistique flotte vehicule\n                                "),_c('i',{staticClass:"header-icon el-icon-info"})]),_vm._v(" "),_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableStatVeh,"height":"330"}},[_c('el-table-column',{attrs:{"prop":"etatVeh","label":"Etat","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":scope.row.color,"disable-transitions":""}},[_vm._v(_vm._s(scope.row.etatVeh))])]}}],null,false,436098841)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nbVehicule","label":"Nb vehicule","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","prop":"action","label":"Action","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.$router.push({
                                            name: 'Flotte',
                                            params: {
                                              etat_veh: scope.row.idEtat, 
                                            }
                                          })}}},[_vm._v("Details")])]}}],null,false,1537070668)})],1)],1)],2)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md6":""}},[_c('el-badge',{staticClass:"item",staticStyle:{"width":"100%"},attrs:{"value":_vm.nbVeh}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium"},on:{"click":function($event){return _vm.lienFlotte('flotte')}}},[_vm._v("Flottes")])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md6":""}},[_c('el-badge',{staticClass:"item",staticStyle:{"width":"100%"},attrs:{"value":_vm.nbVehLouer}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium"},on:{"click":function($event){return _vm.lienFlotte('externe')}}},[_vm._v("Flottes externes")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md6":""}},[_c('el-badge',{staticClass:"item",staticStyle:{"width":"100%"},attrs:{"value":this.nbMarqu}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium"},on:{"click":function($event){return _vm.menuMarque()}}},[_vm._v("Marques")])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md6":""}},[_c('el-badge',{staticClass:"item",staticStyle:{"width":"100%"},attrs:{"value":this.nbBesoins}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium"},on:{"click":function($event){return _vm.modalBesoin()}}},[_vm._v("Besoins Travaux")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(
                      _vm.droitAcces.webservice_consommation_index ||
                        _vm.droitAcces.intervention ||
                        _vm.droitAcces.list_dmdeur_intervention
                    )?_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md6":""}},[_c('el-button',{staticClass:"btnV",attrs:{"type":"primary","size":"medium"}},[_vm._v("UTILISATEUR")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":""}},[_c('el-card',{staticClass:"box-card"},[_c('el-collapse',{attrs:{"accordion":""}},[_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_vm._v("\n                                Statistique des conducteurs\n                                "),_c('i',{staticClass:"header-icon el-icon-info"})]),_vm._v(" "),_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableStatCond,"height":"330"}},[_c('el-table-column',{attrs:{"prop":"etatCond","label":"Etat","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":scope.row.color,"disable-transitions":""}},[_vm._v(_vm._s(scope.row.etatCond))])]}}],null,false,4063977220)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nbCond","label":"Nb Conducteur","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","prop":"action","label":"Action","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.loadListConducteur(scope.row.idEtat)}}},[_vm._v("Details")])]}}],null,false,2445834554)})],1)],1)],2)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md6":""}},[_c('el-badge',{staticClass:"item",staticStyle:{"width":"100%"},attrs:{"value":_vm.nbCond}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium"},on:{"click":function($event){return _vm.menuConducteur()}}},[_vm._v("Conducteur")])],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[(
                      _vm.droitAcces.webservice_consommation_index ||
                        _vm.droitAcces.intervention ||
                        _vm.droitAcces.list_dmdeur_intervention
                    )?_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md6":""}},[_c('el-button',{staticClass:"btnV",attrs:{"type":"success","size":"medium"}},[_vm._v("LOCATION")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":""}},[_c('el-card',{staticClass:"box-card"},[_c('el-collapse',{attrs:{"accordion":""}},[_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_vm._v("\n                                Statistique des contrats\n                                "),_c('i',{staticClass:"header-icon el-icon-info"})]),_vm._v(" "),_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableStatContrat,"height":"330"}},[_c('el-table-column',{attrs:{"prop":"etatInterv","label":"Etat","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":scope.row.color,"disable-transitions":""}},[_vm._v(_vm._s(scope.row.etatCont))])]}}],null,false,2834022164)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nbContr","label":"Nb Contrat","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","prop":"action","label":"Action","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.loadListContrat(scope.row.idEtat)}}},[_vm._v("Details")])]}}],null,false,525799629)})],1)],1)],2)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md4":""}},[_c('el-badge',{staticClass:"item",staticStyle:{"width":"100%"},attrs:{"value":_vm.nbContrat}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium"},on:{"click":function($event){return _vm.menuContrat()}}},[_vm._v("Contrats")])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md4":""}},[_c('el-badge',{staticClass:"item",staticStyle:{"width":"100%"},attrs:{"value":this.nbClient}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium"},on:{"click":function($event){return _vm.menuClient()}}},[_vm._v("Clients")])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md4":""}},[_c('el-badge',{staticClass:"item",staticStyle:{"width":"100%"},attrs:{"value":this.nbTarif}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium"},on:{"click":function($event){return _vm.modalTarifs()}}},[_vm._v("Tarifs")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md4":""}},[_c('el-badge',{staticClass:"item",staticStyle:{"width":"100%"},attrs:{"value":0}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium"},on:{"click":function($event){return _vm.modalCalend()}}},[_vm._v("Calendrier")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md6":""}},[_c('el-button',{staticClass:"btnV",attrs:{"type":"warning","size":"medium"}},[_vm._v("CONSOMMATION")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md6":""}},[_c('el-badge',{staticClass:"item",staticStyle:{"width":"100%"},attrs:{"value":this.nbCarburan}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium"},on:{"click":function($event){return _vm.menuConsommation()}}},[_vm._v("Carburants")])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md6":""}},[_c('el-badge',{staticClass:"item",staticStyle:{"width":"100%"},attrs:{"value":this.nbCarteCar}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium"},on:{"click":function($event){return _vm.menuCarte()}}},[_vm._v("Carte Carburants")])],1)],1)],1),_vm._v(" "),(_vm.droitAcces.intervention)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md12":""}},[_c('el-badge',{staticClass:"item",staticStyle:{"width":"100%"},attrs:{"value":_vm.nbDemandCarbu}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium"},on:{"click":function($event){return _vm.modalDmdCarb()}}},[_vm._v("Demande de carburant")])],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[(
                      _vm.droitAcces.webservice_consommation_index ||
                        _vm.droitAcces.intervention ||
                        _vm.droitAcces.list_dmdeur_intervention
                    )?_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md6":""}},[_c('el-button',{staticClass:"btnV",attrs:{"type":"primary","size":"medium"}},[_vm._v("ADMINISTRATION")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md6":""}},[_c('el-badge',{staticClass:"item",staticStyle:{"width":"100%"},attrs:{"value":this.nbVisiteTech}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium"},on:{"click":function($event){return _vm.menuVisiteTechnique()}}},[_vm._v("Visites technique")])],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md6":""}},[_c('el-badge',{staticClass:"item",staticStyle:{"width":"100%"},attrs:{"value":this.nbVidang}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium"},on:{"click":function($event){return _vm.menuVidange()}}},[_vm._v("Vidanges")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md6":""}},[_c('el-badge',{staticClass:"item",staticStyle:{"width":"100%"},attrs:{"value":this.nbAssur}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium"},on:{"click":function($event){return _vm.menuAssurance()}}},[_vm._v("Assurances")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md6":""}},[_c('el-button',{staticClass:"btnV",attrs:{"type":"danger","size":"medium"}},[_vm._v("MAINTENANCE")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":""}},[_c('el-card',{staticClass:"box-card"},[_c('el-collapse',{attrs:{"accordion":""}},[_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_vm._v("\n                                Statistique des maintenances\n                                "),_c('i',{staticClass:"header-icon el-icon-info"})]),_vm._v(" "),_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableStatInterv,"height":"330"}},[_c('el-table-column',{attrs:{"prop":"etatInterv","label":"Etat","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":scope.row.color,"disable-transitions":""}},[_vm._v(_vm._s(scope.row.etatInterv))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nbInterv","label":"Nb Intervention","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","prop":"action","label":"Action","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text","size":"small"},on:{"click":function($event){return _vm.loadListIntervention(
                                            scope.row.idEtat
                                          )}}},[_vm._v("Details")])]}}])})],1)],1)],2)],1)],1)],1)],1),_vm._v(" "),(_vm.droitAcces.intervention)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"md12":""}},[_c('el-badge',{staticClass:"item",staticStyle:{"width":"100%"},attrs:{"value":_vm.nbDemand}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"medium"},on:{"click":function($event){return _vm.modalInterv()}}},[_vm._v("Demandes")])],1)],1)],1):_vm._e()],1)],1)],1)],1)],1)],1)]),_vm._v(" "),(_vm.droitAcces.intervention || _vm.droitAcces.list_dmdeur_intervention)?_c('el-col',{attrs:{"span":6}},[_c('el-card',{staticClass:"box-card"},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"md12":""}},[_c('v-chip',{staticClass:"btnV",attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n              COÛT TOTAL : "+_vm._s(_vm.detailCout.totalCout)+" FCFA"),_c('v-icon',{attrs:{"right":""}},[_vm._v("monetization_on")])],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                CHARGES FIXES : "+_vm._s(_vm.detailCout.montantChargeFixe)+" FCFA\n              ")])],1),_vm._v(" "),_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","color":"secondary"}},[_vm._v("Achat : "+_vm._s(_vm.detailCout.montantAchat)+" FCFA")]),_vm._v(" "),_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","color":"secondary"}},[_vm._v("Location : "+_vm._s(_vm.detailCout.montantLocation)+" FCFA")]),_vm._v(" "),_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","color":"secondary"}},[_vm._v("Assurances : "+_vm._s(_vm.detailCout.montantAssur)+" FCFA")]),_vm._v(" "),_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","color":"secondary"}},[_vm._v("Visites techniques :\n              "+_vm._s(_vm.detailCout.montantVistech)+" FCFA")]),_vm._v(" "),_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","color":"secondary"}},[_vm._v("Vidanges : "+_vm._s(_vm.detailCout.montantVid)+" FCFA")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                CHARGES VARIABLES :\n                "+_vm._s(_vm.detailCout.montantChargeVariable)+" FCFA\n              ")])],1),_vm._v(" "),_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","color":"secondary"}},[_vm._v("Caburant : "+_vm._s(_vm.detailCout.montantCarburant)+" FCFA")]),_vm._v(" "),_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","color":"secondary"}},[_vm._v("Interventions : "+_vm._s(_vm.detailCout.montantInterv)+" FCFA")])],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"100%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogIntervention),callback:function ($$v) {_vm.dialogIntervention=$$v},expression:"dialogIntervention"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Liste des interventions ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogIntervention = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n            INTERVENTIONS\n          ")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"green","disabled":_vm.disabledBtnDmd,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeListeDemande('PDF')}},slot:"activator"},[_vm._v("Imprimer PDF "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n            Imprimer en PDF\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"warning","disabled":_vm.disabledBtnDmd,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeListeDemande('EXC')}},slot:"activator"},[_vm._v("Imprimer EXCEL "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n            Imprimer en Excel\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newIntervention($event)}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n            Ajouter une nouvelle intervention\n          ")],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listIntervention}},[_c('el-table-column',{attrs:{"prop":"vehicule","label":"Véhicule","width":"280","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.vehicule)+"\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("directions_car")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.date)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.type == 'Curative')?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                  CURATIVE\n                ")]):_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                  PREVENTIVE\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demandeur","label":"Demandeur","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat / Etape","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  EN ATTENTE DE VALIDATION\n                ")]):(scope.row.etat == 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  EN ATTENTE DE VALIDATION DU DEVIS\n                ")]):(scope.row.etat == 2)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                  INTERVENTION REFUSE\n                ")]):(scope.row.etat == 3)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                  DEVIS VALIDE\n                ")]):(scope.row.etat == 4)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                  DIVIS REFUSE\n                ")]):(scope.row.etat == 5)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                  INTERVENTION TERNIME\n                ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etape == 6)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.showIntervention(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1):_vm._e(),_vm._v("\n                    Détails\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etape < 6)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.showIntervention(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                    Modifier\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.intervention)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSupr = true;
                        _vm.InterId = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                    Supprimer\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){return _vm.imprimerDemande(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                    Imprimer\n                  ")],1)],1)]}}])})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogIntervention = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogParaMarque),callback:function ($$v) {_vm.dialogParaMarque=$$v},expression:"dialogParaMarque"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Liste Marques, Modeles et Series ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogParaMarque = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n            LISTE DES MARQUES, MODELES ET SERIES\n          ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-chip',{attrs:{"label":"","color":"orange","text-color":"white"}},[_vm._v("LISTE DES MARQUES\n            ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeMarque('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeMarque('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnMarq,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                  ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newMarque()}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n                Ajouter une nouvelle marque\n              ")],1)],1),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listMarque}},[_c('el-table-column',{attrs:{"prop":"logo","label":"Logo"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-avatar',[(scope.row.url)?_c('img',{staticClass:"lazy",attrs:{"src":scope.row.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"src":"/static/avatar-marque.png","alt":""}})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libelle"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.libelle)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editMarque(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                      Modifier\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprMarq = true;
                          _vm.idMarque = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                      Supprimer\n                    ")],1)],1)]}}])})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-chip',{attrs:{"label":"","color":"orange","text-color":"white"}},[_vm._v("\n              LISTE DES MODELES\n            ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeModele('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeModele('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnMod,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                  ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newModele()}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n                Ajouter un nouveau modele\n              ")],1)],1),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listModele}},[_c('el-table-column',{attrs:{"prop":"marque","label":"Marque"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.marqLibelle)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"modele","label":"Modele"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"indigo"}},[_vm._v("\n                    "+_vm._s(scope.row.libelle)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editModele(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                      Modifier\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprModel = true;
                          _vm.idModele = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                      Supprimer\n                    ")],1)],1)]}}])})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-chip',{attrs:{"label":"","color":"orange","text-color":"white"}},[_vm._v("LISTE DES SERIES\n            ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeSerie('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeSerie('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnSerie,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                  ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newSerie()}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n                Ajouter une nouvelle serie\n              ")],1)],1),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listSerie}},[_c('el-table-column',{attrs:{"prop":"modele","label":"Modele"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.ModeleLibelle)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serie","label":"Serie"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.libelle)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editSerie(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                      Modifier\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprSeri = true;
                          _vm.idSerie = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                      Supprimer\n                    ")],1)],1)]}}])})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogParaMarque = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogContrat),callback:function ($$v) {_vm.dialogContrat=$$v},expression:"dialogContrat"}},[_c('v-card',[_c('v-toolbar',{staticClass:"green",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Liste des contrats de locations ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogContrat = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"loading":_vm.loading}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n            LISTE DES CONTRATS DE LOCATION DE VEHICULE\n          ")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeContrat('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeContrat('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnCont,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newContrat($event)}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n            Ajouter un nouveau contrat\n          ")],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listContrat}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Référence","width":"100","fixed":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vehicule","label":"Véhicule","width":"300","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.vehicule)+"\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("directions_car")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"client","label":"Client","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.client)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateD","label":"Date début et Fin","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.dateD)+" - "+_vm._s(scope.row.dateF)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantTotal","label":"Montant","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                  "+_vm._s(scope.row.montantTotalFormat)+" FCFA\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createdUser","label":"Enregistrer par","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.createdUser)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Type","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                  RESERVE\n                ")]):(scope.row.etat == 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                  ACTIVE\n                ")]):(scope.row.etat == 2)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                  TERMINE\n                ")]):(scope.row.etat == 3)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                  RESILIE\n                ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.showContrat(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                    Détails\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat == 0)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editContrat(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                    Modifier\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat == 1)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){return _vm.closeContrat(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("close")])],1):_vm._e(),_vm._v("\n                    Mettre fin au contrat\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat != 0)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){return _vm.impmerFacture(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1):_vm._e(),_vm._v("\n                    Imprimer\n                  ")],1)],1)]}}])})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogContrat = false}}},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowListDfon),callback:function ($$v) {_vm.dialogShowListDfon=$$v},expression:"dialogShowListDfon"}},[_c('v-card',[_c('v-toolbar',{staticClass:"green",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Liste des demandes de fonds en carburant ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowListDfon = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"loading":_vm.loading}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n            LISTE DES DEMANDES DE FONDS EN CARBURANT\n          ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant Total: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntTotal)+" Fcfa ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.totalDmd))]),_vm._v("\n                Demandes\n            ")],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('data-tables',{attrs:{"data":_vm.listeDemandes}},[_c('el-table-column',{attrs:{"prop":"dateFormat","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demandeur","label":"Nom du demandeur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantFormat","label":"Montant (Fcfa)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libStatut","label":"Statut"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.statut == 0)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v("  "+_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 1)?_c('el-tag',[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 2)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 3)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 4)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 5)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"caissePaie","label":"Caisse paiement"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.caissePaie))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"carte","label":"Carte"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.carte)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.carte))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"grey"},on:{"click":function($event){return _vm.modalImpDmd(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                            Detail\n                    ")],1)]}}])})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogShowListDfon = false}}},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogClientLocation),callback:function ($$v) {_vm.dialogClientLocation=$$v},expression:"dialogClientLocation"}},[_c('v-card',[_c('v-toolbar',{staticClass:"green",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Liste des clients ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogClientLocation = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n            LISTE DES CLIENTS\n          ")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeClient('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeClient('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnCli,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newClientLocation($event)}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n            Ajouter une nouveau client\n          ")],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listClientLocation}},[_c('el-table-column',{attrs:{"prop":"nom","label":"Nom et Prenom","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.nomPrenom)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"piece","label":"Type de personne","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.type == 'Personne physique')?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"indigo"}},[_vm._v("\n                  "+_vm._s(scope.row.type)+"\n                ")]):_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.type)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"contact","label":"Contact"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                  "+_vm._s(scope.row.contact)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.showLocationClient(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                    Détails\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editClientLocation(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                    Modifier\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprClientLocation = true;
                        _vm.idClientLoc = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                    Supprimer\n                  ")],1)],1)]}}])})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogClientLocation = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogConducteur),callback:function ($$v) {_vm.dialogConducteur=$$v},expression:"dialogConducteur"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Liste des conducteurs ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogConducteur = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n            LISTE DES CONDUCTEURS\n          ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeConducteur('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeConducteur('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnCond,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n              ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('input',{ref:"fileInputExcel",staticStyle:{"display":"none"},attrs:{"name":"fileInputExcel","type":"file","accept":"image/*"},on:{"change":_vm.onFileExcelPicked}}),_vm._v(" "),_c('el-dropdown',{on:{"command":_vm.handleFileExcel}},[_c('el-button',{attrs:{"type":"success"}},[_vm._v("\n              Fichier excel"),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"0"}},[_vm._v("Importer fichier excel")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"1"}},[_vm._v("Générer un modèle")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newConducteur($event)}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n            Ajouter une nouveau conducteur\n          ")],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listConducteur}},[_c('el-table-column',{attrs:{"prop":"url","label":"Photo","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-avatar',[(scope.row.url)?_c('img',{staticClass:"lazy",attrs:{"src":scope.row.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"src":"/static/avatar-conducteur.png","alt":""}})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nomPren","label":"Conducteur","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.nomPren)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date validité du permis","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.dateValPmi)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Disponibilité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.disponibilite === 'Disponible')?_c('v-chip',{attrs:{"color":"green","text-color":"white"}},[_c('v-avatar',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v("\n                  "+_vm._s(scope.row.disponibilite)+"\n                ")],1):_vm._e(),_vm._v(" "),(scope.row.disponibilite === 'En activite')?_c('v-chip',{attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v("\n                  "+_vm._s(scope.row.disponibilite)+"\n                ")],1):_vm._e(),_vm._v(" "),(scope.row.disponibilite === 'Absent')?_c('v-chip',{attrs:{"color":"red","text-color":"white"}},[_c('v-avatar',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v("\n                  "+_vm._s(scope.row.disponibilite)+"\n                ")],1):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.ficheConducteur(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                    Détails\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editConducteur(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                    Modifier\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.ImprimerConducteur(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                    Détails\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprCond = true;
                        _vm.idConducteur = scope.row.idCond;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                    Supprimer\n                  ")],1)],1)]}}])})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogConducteur = false}}},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogVidange),callback:function ($$v) {_vm.dialogVidange=$$v},expression:"dialogVidange"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Liste des vidanges ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogVidange = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n            LISTE DES VIDANGES\n          ")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeVign('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeVign('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnAllVidn,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newVida($event)}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n            Ajouter une nouvelle vidange\n          ")],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listVidn}},[_c('el-table-column',{attrs:{"prop":"numero","label":"Numéro vidange","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.numero)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vehicule","label":"Véhicule","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.vehicule)+"\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("directions_car")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"jourRenouvel","label":"A renouveler dans","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.jourRenouvel > 0 )?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.jourRenouvel)+" JOURS\n                ")]):_c('v-chip',{attrs:{"label":"","text-color":"white","color":"warning"}},[_vm._v("\n                    EXPIRÉ Y'A "+_vm._s(Math.abs(scope.row.jourRenouvel))+" JOURS\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant (FCFA)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                  "+_vm._s(scope.row.montSepar)+" FCFA\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.showVign(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                    Détails\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editVign(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                    Modifier\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.ImprimerVidange(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                    Imprimer\n                  ")],1),_vm._v(" "),(scope.row.statut == false)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprVign = true;
                        _vm.idVign = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                    Supprimer\n                  ")],1):_vm._e()],1)]}}])})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogVidange = false}}},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogVisite),callback:function ($$v) {_vm.dialogVisite=$$v},expression:"dialogVisite"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Liste des visites techniques ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogVisite = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n            LISTE DES VISITES TECHNIQUES\n          ")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('br'),_c('br'),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newVisit($event)}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n            Ajouter une nouvelle visite technique\n          ")],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listVisite}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Référence","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.reference)+"\n              ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vehicule","label":"Véhicule","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.VehMat)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("directions_car")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date début et fin","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.dateDebut)+" - "+_vm._s(scope.row.dateFin)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant (FCFA)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                  "+_vm._s(scope.row.montSepar)+" FCFA\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.showVisit(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                    Détails\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editVisit(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                    Modifier\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.ImprimerVisite(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                    Imprimer\n                  ")],1),_vm._v(" "),(scope.row.statut == false)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprVisit = true;
                        _vm.idVisit = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                    Supprimer\n                  ")],1):_vm._e()],1)]}}])})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogVisite = false}}},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAssurance),callback:function ($$v) {_vm.dialogAssurance=$$v},expression:"dialogAssurance"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Liste des assurances ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAssurance = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n            LISTE DES ASSURANCES\n          ")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeAssur('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeAssur('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":this.nbAssur  == 0,"icon":"el-icon-printer"},on:{"click":function($event){return _vm.imprimeListeAssur('PDF')}}},[_vm._v("Imprimer la liste\n                ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newAssu($event)}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n            Ajouter une nouvelle assurance\n          ")],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listAssu}},[_c('el-table-column',{attrs:{"prop":"Société","label":"Société","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.societe)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vehMatricule","label":"Véhicule","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.vehMatricule)+" "+_vm._s(scope.row.vehMarque)+"\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("directions_car")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateFn","label":"Date de fin","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.dateFn)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntAssur","label":"Montant (FCFA)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                  "+_vm._s(scope.row.mntAssur)+" FCFA\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.showAssu(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                    Détails\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editAssu(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                    Modifier\n                  ")],1),_vm._v(" "),(scope.row.statut == false)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprAssu = true;
                        _vm.idAssu = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                    Supprimer\n                  ")],1):_vm._e()],1)]}}])})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogAssurance = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1)],1),_vm._v(" "),(!_vm.droitAcces.liste_consomation)?_c('v-dialog',{attrs:{"persistent":"","max-width":"80%","fullscreen":"","overlay":true,"scrollable":"","loading":_vm.loading},model:{value:(_vm.dialogConsommationCarburant),callback:function ($$v) {_vm.dialogConsommationCarburant=$$v},expression:"dialogConsommationCarburant"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"orange"}},[_c('v-toolbar-title',[_vm._v("Consommation de carburant")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogConsommationCarburant = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-card-title',[_c('v-chip',{attrs:{"label":"","color":"orange","text-color":"white"}},[_vm._v("\n            LISTE DES CONSOMMATION DE CARBURANTS\n          ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5imprimeListeConsPDF",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeConsPDF()}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeCarburant('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnCarbu,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newConsom()}},slot:"activator"},[_vm._v("\n              Ajouter "),_c('v-icon',{attrs:{"center":""}},[_vm._v("add")])],1),_vm._v("\n            Ajouter une nouvelle comsommation de carburant\n          ")],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n            MONTANT TOTAL : "+_vm._s(_vm.mntTotCons)+" FCFA\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("monetization_on")])],1),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n            QUANTITE CONSOMME (L) : "+_vm._s(_vm.quantTotCons)+" L\n          ")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n            QDISTANCE PARCOURUE (KM) : "+_vm._s(_vm.distParcTot)+" Km\n          ")]),_vm._v(" "),_c('div',{staticClass:"text-xs-right "},[_c('span',{staticClass:"demonstration"},[_vm._v("Période")]),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"datetimerange","range-separator":"à","format":"d-MM-yyyy HH:mm","value-format":"yyyy-MM-d HH:mm","start-placeholder":"Date de début","end-placeholder":"Date de fin"},model:{value:(_vm.periode),callback:function ($$v) {_vm.periode=$$v},expression:"periode"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","circle":""},on:{"click":function($event){$event.stopPropagation();return _vm.filtrePeriode($event)}}})],1),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listConsommation}},[_c('el-table-column',{attrs:{"prop":"station","label":"Fournisseur"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.station)+"\n                ")])]}}],null,false,3895338888)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vehicule","label":" Vehicule"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantite","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateAchat","label":"Date d'achat"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.dateAchat)+"\n                ")])]}}],null,false,627342553)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"carteID","label":"Carte"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"typeCons","label":"Moyen de paiement"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntConsFormat","label":"Montant (FCFA)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"color":"green","text-color":"white"}},[_vm._v("\n                  "+_vm._s(scope.row.mntConsFormat)+" FCFA\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("monetization_on")])],1)]}}],null,false,40042957)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createdUser","label":"Enregistré par"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"kiloCons","label":"Kilometrage","width":"70"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"distParcourCons","label":"Distance parcourue"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(scope.row.imageRecu)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","icons":"","small":"","color":"cyan"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerRecu(scope.row.imageRecu)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("photo")])],1):_vm._e(),_vm._v("\n                    Pièce jointe (Recu de paiement)\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editCarburant(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                    Modifier\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){_vm.idConsommation = scope.row.id;
                        _vm.dialogSuppCarburant = true;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                    Supprimer\n                  ")],1)],1)]}}],null,false,1495191543)})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogConsommationCarburant = false}}},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":"","loading":_vm.loading},model:{value:(_vm.dialogAjoutIntervention),callback:function ($$v) {_vm.dialogAjoutIntervention=$$v},expression:"dialogAjoutIntervention"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter une nouvelle intervention ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutIntervention = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-stepper',{model:{value:(_vm.etape),callback:function ($$v) {_vm.etape=$$v},expression:"etape"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.etape > 1}},[_vm._v("Détail de la demande")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.etape > 2}},[_vm._v("Validation de l'intervention")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3","complete":_vm.etape > 3}},[_vm._v("Diagnostique et dévis")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"4","complete":_vm.etape > 4}},[_vm._v("Interventions")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"5","complete":_vm.etape > 5}},[_vm._v("Fin des interventions")]),_vm._v(" "),(_vm.interventionCourant.etape === 5)?_c('v-stepper-step',{attrs:{"step":"6","complete":_vm.etape > 6}},[_vm._v("Bilan")]):_vm._e()],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                    AJOUT D'UNE NOUVELLE INTERVENTION\n                  ")])],1),_vm._v(" "),_c('v-form',{ref:"formIntervention",attrs:{"lazy-validation":"","id":"formIntervention"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Véhicule concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Véhicule concerné","disabled":_vm.interventionCourant.etat != 0},model:{value:(_vm.selectVehicule),callback:function ($$v) {_vm.selectVehicule=$$v},expression:"selectVehicule"}},_vm._l((_vm.listVehicule),function(item){return _c('el-option',{key:item.idVeh,attrs:{"label":item.libelle,"value":item.idVeh}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Catégorie *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Catégorie","disabled":_vm.interventionCourant.etat != 0},model:{value:(_vm.selectCategorie),callback:function ($$v) {_vm.selectCategorie=$$v},expression:"selectCategorie"}},_vm._l((_vm.categorie),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de demande *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Type de demande","disabled":_vm.interventionCourant.etat != 0},model:{value:(_vm.selectType),callback:function ($$v) {_vm.selectType=$$v},expression:"selectType"}},_vm._l((_vm.type),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Gravité *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Gravité","disabled":_vm.interventionCourant.etat != 0},model:{value:(_vm.selectGravite),callback:function ($$v) {_vm.selectGravite=$$v},expression:"selectGravite"}},_vm._l((_vm.gravite),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Priorité *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Priorité","disabled":_vm.interventionCourant.etat != 0},model:{value:(_vm.selectPriorite),callback:function ($$v) {_vm.selectPriorite=$$v},expression:"selectPriorite"}},_vm._l((_vm.priorite),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de la demande *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateInter","type":"datetime","placeholder":"Date de la demande","disabled":_vm.interventionCourant.etat != 0},model:{value:(_vm.dateInter),callback:function ($$v) {_vm.dateInter=$$v},expression:"dateInter"}})],1)]),_vm._v(" "),(_vm.selectCategorie == 'Autre')?_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Autre catégorie *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"autre","placeholder":"Autre catégorie","disabled":_vm.interventionCourant.etat != 0,"required":""},model:{value:(_vm.autre),callback:function ($$v) {_vm.autre=$$v},expression:"autre"}})],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Motif de la demande *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"motif","placeholder":"Motif de la demande","disabled":_vm.interventionCourant.etat != 0,"required":""},model:{value:(_vm.motif),callback:function ($$v) {_vm.motif=$$v},expression:"motif"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',[_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutIntervention = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.dialogEdit == false && _vm.etape == 1)?_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.submitIntervention(2)}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e(),_vm._v(" "),(
                        _vm.dialogEdit == true && _vm.interventionCourant.etape == 2
                      )?_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.submitIntervention(2)}}},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(
                        _vm.dialogEdit == false &&
                          (_vm.etape == 1 || _vm.etape > 1) &&
                          _vm.droitAcces.intervention
                      )?_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.submitIntervention(2)}}},[_vm._v("Ajouter & Continuer\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1):_vm._e(),_vm._v(" "),(
                        _vm.dialogEdit == true &&
                          (_vm.interventionCourant.etape == 2 ||
                            _vm.interventionCourant.etape > 2) &&
                          _vm.droitAcces.intervention
                      )?_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){_vm.etape += 1}}},[_vm._v("\n                      Continuer\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[(_vm.interventionCourant.etat == 2)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                    DEMANDE REFUSER ET FERME "),_c('v-icon',{attrs:{"right":""}},[_vm._v("clear")])],1):_vm._e(),_vm._v(" "),(_vm.interventionCourant.etat == 1)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                    DEMANDE VALIDE\n                  ")]):_vm._e()],1),_vm._v(" "),_c('v-form',{ref:"formValidInter",attrs:{"lazy-validation":"","id":"formValidInter"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Véhicule concerné ")]),_vm._v(" "),_c('el-input',{attrs:{"value":_vm.interventionCourant.vehicule,"disabled":true},model:{value:(_vm.interventionCourant.vehicule),callback:function ($$v) {_vm.$set(_vm.interventionCourant, "vehicule", $$v)},expression:"interventionCourant.vehicule"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Catégorie")]),_vm._v(" "),_c('el-input',{attrs:{"value":_vm.interventionCourant.categorie,"disabled":true},model:{value:(_vm.interventionCourant.categorie),callback:function ($$v) {_vm.$set(_vm.interventionCourant, "categorie", $$v)},expression:"interventionCourant.categorie"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de demande")]),_vm._v(" "),_c('el-input',{attrs:{"value":_vm.interventionCourant.type,"disabled":true},model:{value:(_vm.interventionCourant.type),callback:function ($$v) {_vm.$set(_vm.interventionCourant, "type", $$v)},expression:"interventionCourant.type"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Gravité")]),_vm._v(" "),_c('el-input',{attrs:{"value":_vm.interventionCourant.gravite,"disabled":true},model:{value:(_vm.interventionCourant.gravite),callback:function ($$v) {_vm.$set(_vm.interventionCourant, "gravite", $$v)},expression:"interventionCourant.gravite"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Priorité")]),_vm._v(" "),_c('el-input',{attrs:{"value":_vm.interventionCourant.priorite,"disabled":true},model:{value:(_vm.interventionCourant.priorite),callback:function ($$v) {_vm.$set(_vm.interventionCourant, "priorite", $$v)},expression:"interventionCourant.priorite"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de la demande")]),_vm._v(" "),_c('el-input',{attrs:{"value":_vm.interventionCourant.date,"disabled":true},model:{value:(_vm.interventionCourant.date),callback:function ($$v) {_vm.$set(_vm.interventionCourant, "date", $$v)},expression:"interventionCourant.date"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md8":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Motif de la demande")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.interventionCourant.dateInter,"type":"textarea","name":"motif","placeholder":"Motif de la demande","disabled":true},model:{value:(_vm.interventionCourant.dateInter),callback:function ($$v) {_vm.$set(_vm.interventionCourant, "dateInter", $$v)},expression:"interventionCourant.dateInter"}})],1)])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%","margin":"10px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      VALIDATION DE LA DEMANDE D'INTERVENTION\n                    ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(_vm.interventionCourant.etat <= 1)?_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Réponse de la demande *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Réponse de la demande","disabled":_vm.interventionCourant.etat == 1},model:{value:(_vm.selectReponse),callback:function ($$v) {_vm.selectReponse=$$v},expression:"selectReponse"}},_vm._l((_vm.reponse),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]):_vm._e(),_vm._v(" "),(_vm.interventionCourant.etat > 1)?_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Réponse de la demande **")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":true,"value":"Valider"}})],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md8":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Motif de la réponse ?")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.interventionCourant.etat >= 1,"name":"remarque","type":"textarea","placeholder":"Motif de la demande"},model:{value:(_vm.remarque),callback:function ($$v) {_vm.remarque=$$v},expression:"remarque"}})],1)])],1),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('v-layout',[_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutIntervention = !_vm.dialogAjoutIntervention}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.interventionCourant.etat == 0)?_c('v-btn',{attrs:{"color":"green","dark":""},on:{"click":function($event){return _vm.submitValideIntervention(3)}}},[_vm._v("Réponse "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done_all")])],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){_vm.etape -= 1}}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_left")]),_vm._v("Précédent\n                ")],1),_vm._v(" "),(_vm.interventionCourant.etat >= 1)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){_vm.etape += 1}}},[_vm._v("\n                  Continuer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[(_vm.interventionCourant.etat == 1)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                    ENREGISTREMENT DU DIAGNOSTIQUE UN DEVIS\n                  ")]):_vm._e(),_vm._v(" "),(_vm.interventionCourant.etat == 3)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                    VOTRE DEVIS FINAL EST VALIDE\n                  ")]):_vm._e(),_vm._v(" "),(_vm.interventionCourant.etat == 4)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                    VOTRE DEVIS FINAL EST REFUSE. VEUILLEZ DONC SOUMETTRE UN\n                    AUTRE DEVIS\n                  ")]):_vm._e()],1),_vm._v(" "),_c('v-form',{ref:"formDiagnostique",attrs:{"lazy-validation":"","id":"formDiagnostique"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prestataire *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Prestataire","disabled":_vm.interventionCourant.etat >= 3},model:{value:(_vm.selectPrestataire),callback:function ($$v) {_vm.selectPrestataire=$$v},expression:"selectPrestataire"}},_vm._l((_vm.listPrestataire),function(item){return _c('el-option',{key:item.idPres,attrs:{"label":item.libelle,"value":item.idPres}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Main d'oeuvre (FCFA) *")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","min":0,"name":"maindoeuvre","disabled":_vm.interventionCourant.etat >= 3},model:{value:(_vm.maindoeuvre),callback:function ($$v) {_vm.maindoeuvre=$$v},expression:"maindoeuvre"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Caisse *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Caisse *","disabled":_vm.interventionCourant.etat >= 3},model:{value:(_vm.selectCaisse),callback:function ($$v) {_vm.selectCaisse=$$v},expression:"selectCaisse"}},_vm._l((_vm.listCaisse),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de paiement *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"datePaiement","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de fin *","disabled":_vm.interventionCourant.etat >= 3},model:{value:(_vm.datePaiement),callback:function ($$v) {_vm.datePaiement=$$v},expression:"datePaiement"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md8":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Diagnostique de l'intervention *")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","name":"diagnostique","disabled":_vm.interventionCourant.etat >= 3},model:{value:(_vm.diagnostique),callback:function ($$v) {_vm.diagnostique=$$v},expression:"diagnostique"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.imageDevis,"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"fileDevis",staticStyle:{"display":"none"},attrs:{"name":"fileDevis","type":"file","accept":"image/*"},on:{"change":_vm.onFileDevPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileDevis.click()}}},[_vm._v("\n                          Devis "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)],1)],1)],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      DEVIS LIE AU DIAGNOSTIQUE\n                    ")])],1),_vm._v(" "),_vm._l((_vm.devis),function(option,index){return _c('v-layout',{key:option.key,attrs:{"row":"","prop":'option.' + index + '.value',"indexProd":option}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Désignation *")]),_vm._v(" "),_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"required":"","fetch-suggestions":_vm.querySearch,"placeholder":"Désignation","trigger-on-focus":true,"disabled":_vm.interventionCourant.etat >= 3},on:{"select":_vm.handleChangePrix},model:{value:(option.libelle),callback:function ($$v) {_vm.$set(option, "libelle", $$v)},expression:"option.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":"1","placeholder":"Quantité","disabled":_vm.interventionCourant.etat >= 3},on:{"change":_vm.calculTotalDevis},model:{value:(option.qte),callback:function ($$v) {_vm.$set(option, "qte", $$v)},expression:"option.qte"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité")]),_vm._v(" "),_c('el-input',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":"Unité","disabled":_vm.interventionCourant.etat >= 3},model:{value:(option.unite),callback:function ($$v) {_vm.$set(option, "unite", $$v)},expression:"option.unite"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix unitaire *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":"0","placeholder":"Prix unitaire","disabled":_vm.interventionCourant.etat >= 3},on:{"change":_vm.calculTotalDevis},model:{value:(option.cout),callback:function ($$v) {_vm.$set(option, "cout", $$v)},expression:"option.cout"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("TVA")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":"0","max":"18","placeholder":"TVA","disabled":_vm.interventionCourant.etat >= 3},on:{"change":_vm.calculTotalDevis},model:{value:(option.tva),callback:function ($$v) {_vm.$set(option, "tva", $$v)},expression:"option.tva"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("TOTAL TTC")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","placeholder":"TOTAL TTC","disabled":true},model:{value:(option.total),callback:function ($$v) {_vm.$set(option, "total", $$v)},expression:"option.total"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-tooltip',{attrs:{"top":""}},[(
                            _vm.interventionCourant.etat != 3 &&
                              _vm.interventionCourant.etape <= 3
                          )?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){return _vm.suppressionDevis(index)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                        Supprimer\n                      ")],1)],1)],1)}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"25px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                        MONTANT HT : "+_vm._s(_vm.ht)+" FCFA\n                      ")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('v-tooltip',{attrs:{"top":""}},[(
                            _vm.interventionCourant.etat != 3 &&
                              _vm.interventionCourant.etape <= 3
                          )?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":_vm.devisLigne},slot:"activator"},[_c('v-icon',{attrs:{"icon":"","dark":""}},[_vm._v("add")])],1):_vm._e(),_vm._v("\n                        Ajouter\n                      ")],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"25px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                        MONTANT TVA : "+_vm._s(_vm.tva)+" FCFA\n                      ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"25px","width":"100%"},attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                        MONTANT TTC : "+_vm._s(_vm.total)+" FCFA\n                      ")])],1)],1),_vm._v(" "),_c('br')],2)],1),_vm._v(" "),_c('v-layout',[_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutIntervention = !_vm.dialogAjoutIntervention}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(
                    (_vm.interventionCourant.etat == 1 ||
                      _vm.interventionCourant.etat == 4) &&
                      _vm.interventionCourant.etape == 3
                  )?_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.submitDiagnostique(3)}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e(),_vm._v(" "),(
                    _vm.interventionCourant.etatDevis != 0 &&
                      (_vm.interventionCourant.etat == 1 ||
                        _vm.interventionCourant.etat == 4)
                  )?_c('v-btn',{attrs:{"color":"green","dark":""},on:{"click":function($event){return _vm.newValiderDevis(_vm.interventionCourant)}}},[_vm._v("Réponse "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done_all")])],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){_vm.etape -= 1}}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_left")]),_vm._v("Précédent\n                ")],1),_vm._v(" "),(
                    _vm.interventionCourant.etat != 4 &&
                      _vm.interventionCourant.etat > 2
                  )?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){_vm.etape += 1}}},[_vm._v("\n                  Continuer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                    PROGRAMMATION DE L'INTERVENTION\n                  ")])],1),_vm._v(" "),_c('v-form',{ref:"formProgrammation",attrs:{"lazy-validation":"","id":"formProgrammation"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prestataire ")]),_vm._v(" "),_c('el-input',{attrs:{"disabled":true,"value":_vm.interventionCourant.fournisseur},model:{value:(_vm.interventionCourant.fournisseur),callback:function ($$v) {_vm.$set(_vm.interventionCourant, "fournisseur", $$v)},expression:"interventionCourant.fournisseur"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Main d'oeuvre (FCFA)\n                        ")]),_vm._v(" "),_c('el-input',{attrs:{"disabled":true,"value":_vm.interventionCourant.fournisseur},model:{value:(_vm.interventionCourant.maindoeuvre),callback:function ($$v) {_vm.$set(_vm.interventionCourant, "maindoeuvre", $$v)},expression:"interventionCourant.maindoeuvre"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Diagnostique de l'intervention\n                        ")]),_vm._v(" "),_c('el-input',{attrs:{"disabled":true,"value":_vm.interventionCourant.diagnostique},model:{value:(_vm.interventionCourant.diagnostique),callback:function ($$v) {_vm.$set(_vm.interventionCourant, "diagnostique", $$v)},expression:"interventionCourant.diagnostique"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date et heure de début *")]),_vm._v(" "),(_vm.interventionCourant.etat != 5)?_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateD","type":"datetime","placeholder":"Date et heure de début","disabled":_vm.interventionCourant.etat == 5},model:{value:(_vm.dateD),callback:function ($$v) {_vm.dateD=$$v},expression:"dateD"}}):_vm._e(),_vm._v(" "),(_vm.interventionCourant.etat == 5)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.interventionCourant.dateD,"disabled":_vm.interventionCourant.etat == 5},model:{value:(_vm.interventionCourant.dateD),callback:function ($$v) {_vm.$set(_vm.interventionCourant, "dateD", $$v)},expression:"interventionCourant.dateD"}}):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date et heure de fin *")]),_vm._v(" "),(_vm.interventionCourant.etat != 5)?_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateF","type":"datetime","placeholder":"Date et heure de fin","disabled":_vm.interventionCourant.etat == 5},model:{value:(_vm.dateF),callback:function ($$v) {_vm.dateF=$$v},expression:"dateF"}}):_vm._e(),_vm._v(" "),(_vm.interventionCourant.etat == 5)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.interventionCourant.dateF,"disabled":_vm.interventionCourant.etat == 5},model:{value:(_vm.interventionCourant.dateF),callback:function ($$v) {_vm.$set(_vm.interventionCourant, "dateF", $$v)},expression:"interventionCourant.dateF"}}):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Kilométrage *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0.0,"placeholder":"Kilométrage","name":"kilometrage","disabled":_vm.interventionCourant.etat == 5},model:{value:(_vm.kilometrage),callback:function ($$v) {_vm.kilometrage=$$v},expression:"kilometrage"}})],1)])],1),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('v-layout',[_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutIntervention = !_vm.dialogAjoutIntervention}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.submitProgrammation(5)}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){_vm.etape -= 1}}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_left")]),_vm._v("Précédent\n                ")],1),_vm._v(" "),(_vm.interventionCourant.etape > 4)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){_vm.etape += 1}}},[_vm._v("\n                  Continuer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"5"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                    MARQUER LA FIN DE L'INTERVENTION\n                  ")])],1),_vm._v(" "),_c('v-form',{ref:"formFinIntervention",attrs:{"lazy-validation":"","id":"formFinIntervention"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Remarque *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.interventionCourant.etat == 5,"rows":5,"type":"textarea","name":"remarque"},model:{value:(_vm.remarqueFin),callback:function ($$v) {_vm.remarqueFin=$$v},expression:"remarqueFin"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Joindre des documents\n                        ")]),_vm._v(" "),_c('el-upload',{ref:"uploadIntervention",staticClass:"upload-demo",attrs:{"disabled":_vm.interventionCourant.etat == 5,"name":"fichier","action":_vm.fichier.url,"auto-upload":false,"file-list":_vm.fileFin,"list-type":"picture","multiple":""}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("CLIQUER ICI "),_c('i',{staticClass:"el-icon-picture"})])],1)],1)])],1),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('v-layout',[_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutIntervention = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.interventionCourant.etat == 3)?_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.submitFinIntervention(5)}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){_vm.etape -= 1}}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_left")]),_vm._v("Précédent\n                ")],1),_vm._v(" "),(_vm.interventionCourant.etat == 5)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){_vm.etape += 1}}},[_vm._v("\n                  Continuer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"6"}},[_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-row',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#FFF"}},[_c('div',{staticClass:"carte-header",attrs:{"slot":"header"},slot:"header"},[_c('v-flex',{staticStyle:{"font-size":"21px","font-weight":"bold","color":"#D53A35"},attrs:{"text-xs-center":"","layout":"","align-center":"","justify-center":""}},[_vm._v("\n                              ETAPE DE LA DEMANDE\n                            ")])],1),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Véhicule concerné : ")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.vehicule)+"\n                                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Catégorie : ")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.categorie)+"\n                                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Type de demande : ")]),_vm._v(_vm._s(_vm.interventionCourant.type)+"\n                                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Demandeur : ")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.nomDemandeur)+"\n                                ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Gravité : ")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.gravite)+"\n                                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Priorité :")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.priorite)+"\n                                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de la demande :")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.date)+"\n                                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Motif de la demande :")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.motif)+"\n                                ")])])],1)],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#FFF"}},[_c('div',{staticClass:"carte-header",attrs:{"slot":"header"},slot:"header"},[_c('v-flex',{staticStyle:{"font-size":"21px","font-weight":"bold","color":"#D53A35"},attrs:{"text-xs-center":"","layout":"","align-center":"","justify-center":""}},[_vm._v("\n                              ETAPE VALIDATION DE L'INTERVENTION\n                            ")])],1),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Réponse de la demande : ")]),_vm._v(" "),(_vm.interventionCourant.etat != 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                    VALIDE\n                                  ")]):_vm._e(),_vm._v(" "),(_vm.interventionCourant.etat == 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                    REFUSE\n                                  ")]):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Motif de la réponse :")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.remarque)+"\n                                ")])])],1)],1)])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#FFF"}},[_c('div',{staticClass:"carte-header",attrs:{"slot":"header"},slot:"header"},[_c('v-flex',{staticStyle:{"font-size":"21px","font-weight":"bold","color":"#D53A35"},attrs:{"text-xs-center":"","layout":"","align-center":"","justify-center":""}},[_vm._v("\n                              ETAPE DU DIAGNOSTIQUE ET DEVIS\n                            ")])],1),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Prestataire : ")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.fournisseur)+"\n                                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Main d'oeuvre : ")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.maindoeuvre)+" FCFA\n                                ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Diagnostique :")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.diagnostique)+"\n                                ")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.interventionCourant.devis}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Désignation","width":"230","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cout","label":"Prix Unitaire","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"TVA","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"TOTAL TTC","width":"150"}})],1)],1)],1)],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#FFF"}},[_c('div',{staticClass:"carte-header",attrs:{"slot":"header"},slot:"header"},[_c('v-flex',{staticStyle:{"font-size":"21px","font-weight":"bold","color":"#D53A35"},attrs:{"text-xs-center":"","layout":"","align-center":"","justify-center":""}},[_vm._v("\n                              ETAPE PROGRAMMATION DE L'INTERVENTION\n                            ")])],1),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Date et heure de début :")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.dateD)+"\n                                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Kilométrage :")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.kilometrage)+"\n                                ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Date et heure de fin : ")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.dateF)+"\n                                ")])])],1)],1)])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#FFF"}},[_c('div',{staticClass:"carte-header",attrs:{"slot":"header"},slot:"header"},[_c('v-flex',{staticStyle:{"font-size":"21px","font-weight":"bold","color":"#D53A35"},attrs:{"text-xs-center":"","layout":"","align-center":"","justify-center":""}},[_vm._v("\n                              ETAPE FIN DE L'INTERVENTION\n                            ")])],1),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Remarque : ")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.remarqueFin)+"\n                                ")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('el-upload',{ref:"uploadIntervention",staticClass:"upload-demo",attrs:{"action":"","auto-upload":false,"file-list":_vm.fileFin,"list-type":"picture","multiple":""}})],1)],1)],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#FFF"}},[_c('div',{staticClass:"carte-header",attrs:{"slot":"header"},slot:"header"},[_c('v-flex',{staticStyle:{"font-size":"21px","font-weight":"bold","color":"#D53A35"},attrs:{"text-xs-center":"","layout":"","align-center":"","justify-center":""}},[_vm._v("\n                              SYNTHESE DE L'INTERVENTION\n                            ")])],1),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Statut de la demande :")]),_vm._v(" "),(_vm.interventionCourant.etat == 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                    EN ATTENTE DE VALIDATION\n                                  ")]):(_vm.interventionCourant.etat == 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                    EN ATTENTE DE DIAGNOSTIQUE\n                                  ")]):(_vm.interventionCourant.etat == 2)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                                    INTERVENTION REFUSE\n                                  ")]):(_vm.interventionCourant.etat == 3)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                                    DEVIS VALIDE\n                                  ")]):(_vm.interventionCourant.etat == 4)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                                    DIVIS REFUSE\n                                  ")]):(_vm.interventionCourant.etat == 5)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                                    INTERVENTION TERNIME\n                                  ")]):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Etat de la demande :")]),_vm._v(" "),(
                                      _vm.interventionCourant.etat == 5 &&
                                        _vm.interventionCourant.etape == 5
                                    )?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                    FERMER "),_c('v-icon',{attrs:{"right":""}},[_vm._v("clear")])],1):_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                    OUVERT\n                                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("insert_emoticon")])],1)],1),_vm._v(" "),_c('p',[_c('b',[_vm._v(" COÛT TOTAL :")]),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                    "+_vm._s(_vm.interventionCourant.total)+" FCFA\n                                  ")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Date d'enrégistrement : ")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.created)+"\n                                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v("\n                                  "+_vm._s(_vm.interventionCourant.modified)+"\n                                ")])])],1)],1)])],1)],1)],1)],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-layout',[_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutIntervention = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){_vm.etape -= 1}}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_left")]),_vm._v("Précédent\n                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","color":"orange"},on:{"click":function($event){return _vm.imprimerDemande(_vm.interventionCourant)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")]),_vm._v("\n                    Imprimer\n                  ")],1),_vm._v("\n                  Imprimer\n                ")],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":"","loading":_vm.loading},model:{value:(_vm.dialogAjoutContrat),callback:function ($$v) {_vm.dialogAjoutContrat=$$v},expression:"dialogAjoutContrat"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit == false)?_c('span',[_vm._v("Ajouter un nouveau contrat ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modifier le contrat de "+_vm._s(_vm.contratCourant.client)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutContrat = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n              AJOUT D'UN NOUVEAU CONTRAT\n            ")]),_vm._v(" "),(_vm.selectVehicule != '' && _vm.listTrarification.length == 0)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n              CET VEHICULE N'A AUCUNE PLAGE TARIFAIRE ENREGISTRER A SON NOM\n            ")]):_vm._e()],1),_vm._v(" "),_c('v-form',{ref:"formContrat",attrs:{"lazy-validation":"","id":"formContrat"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Client concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Client concerné","disabled":_vm.contratCourant.etat >= 1},model:{value:(_vm.selectClient),callback:function ($$v) {_vm.selectClient=$$v},expression:"selectClient"}},_vm._l((_vm.listClient),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Véhicule concerné *")]),_vm._v(" "),(_vm.dialogEdit == false)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Véhicule concerné","disabled":_vm.contratCourant.etat >= 1},on:{"change":function($event){return _vm.loadTarification()}},model:{value:(_vm.selectVehicule),callback:function ($$v) {_vm.selectVehicule=$$v},expression:"selectVehicule"}},_vm._l((_vm.listVehiculeDispo),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.dialogEdit && _vm.contratCourant.etat == 0)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Véhicule concerné"},on:{"change":function($event){return _vm.loadTarification()}},model:{value:(_vm.selectVehicule),callback:function ($$v) {_vm.selectVehicule=$$v},expression:"selectVehicule"}},_vm._l((_vm.listVehiculeDispo),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.dialogEdit && _vm.contratCourant.etat >= 1)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":true},model:{value:(_vm.contratCourant.vehicule),callback:function ($$v) {_vm.$set(_vm.contratCourant, "vehicule", $$v)},expression:"contratCourant.vehicule"}}):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tarification *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Tarification","disabled":_vm.contratCourant.etat >= 1},on:{"change":function($event){return _vm.loadPrixLocation()}},model:{value:(_vm.selectTarification),callback:function ($$v) {_vm.selectTarification=$$v},expression:"selectTarification"}},_vm._l((_vm.listTrarification),function(group){return _c('el-option-group',{key:group.value,attrs:{"label":group.label}},_vm._l((group.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant de la location *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%","font-size":"22px"},attrs:{"disabled":true,"placeholder":"Montant de la location","value":_vm.montantLocationFormat},model:{value:(_vm.montantLocationFormat),callback:function ($$v) {_vm.montantLocationFormat=$$v},expression:"montantLocationFormat"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nombre (Jour, Mois, Année)\n                  ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":1,"placeholder":"Nombre (Jour, Mois, Année)","name":"nbr","disabled":_vm.contratCourant.etat >= 1},on:{"change":_vm.calculContrat},model:{value:(_vm.nbr),callback:function ($$v) {_vm.nbr=$$v},expression:"nbr"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Remise (%) ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"placeholder":"Remise","name":"remise","disabled":_vm.contratCourant.etat >= 1},on:{"change":_vm.calculContrat},model:{value:(_vm.remise),callback:function ($$v) {_vm.remise=$$v},expression:"remise"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tva (%) ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"placeholder":"Tva","name":"tva","disabled":_vm.contratCourant.etat >= 1},on:{"change":_vm.calculContrat},model:{value:(_vm.tvaCont),callback:function ($$v) {_vm.tvaCont=$$v},expression:"tvaCont"}})],1)])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                TERMES DU CONTRAT\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Avance à la location (%)")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"name":"avance","placeholder":"Avance à la location (%)","disabled":_vm.contratCourant.etat >= 1},model:{value:(_vm.avance),callback:function ($$v) {_vm.avance=$$v},expression:"avance"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de signature *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateS","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de fin *","disabled":_vm.contratCourant.etat >= 1},model:{value:(_vm.dateS),callback:function ($$v) {_vm.dateS=$$v},expression:"dateS"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Durée du contrat *")]),_vm._v(" "),(_vm.dialogEdit == false || _vm.contratCourant.etat == 0)?_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"duree","range-separator":"à","value-format":"dd-MM-yyyy","type":"daterange","start-placeholder":"Date de début","end-placeholder":"Date de fin"},model:{value:(_vm.dateD),callback:function ($$v) {_vm.dateD=$$v},expression:"dateD"}}):_vm._e(),_vm._v(" "),(_vm.dialogEdit && _vm.contratCourant.etat >= 1)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.contratCourant.dateIntervalFormat,"disabled":true},model:{value:(_vm.contratCourant.dateIntervalFormat),callback:function ($$v) {_vm.$set(_vm.contratCourant, "dateIntervalFormat", $$v)},expression:"contratCourant.dateIntervalFormat"}}):_vm._e()],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de contrat *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"typeContrat","placeholder":"Type de contrat","disabled":true},model:{value:(_vm.typeContrat),callback:function ($$v) {_vm.typeContrat=$$v},expression:"typeContrat"}})],1)])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                SUPLEMENT DU CONTRAT\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Activer le contrat *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Activer le contrat *","disabled":_vm.contratCourant.etat >= 1},model:{value:(_vm.selectEtat),callback:function ($$v) {_vm.selectEtat=$$v},expression:"selectEtat"}},_vm._l((_vm.etatContrat),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Penalité en cas de retard (%)")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"name":"penalite","placeholder":"Penalité en cas de retard","disabled":_vm.contratCourant.etat >= 1},model:{value:(_vm.penalite),callback:function ($$v) {_vm.penalite=$$v},expression:"penalite"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Kilométrage à la sortie ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"name":"kilometrage","placeholder":"Kilométrage à la sortie","disabled":_vm.contratCourant.etat >= 1},model:{value:(_vm.kilometrage),callback:function ($$v) {_vm.kilometrage=$$v},expression:"kilometrage"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Attribuer un conducteur *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Attribuer un conducteur *","disabled":_vm.contratCourant.etat >= 1},model:{value:(_vm.attribuer),callback:function ($$v) {_vm.attribuer=$$v},expression:"attribuer"}},[_c('el-option',{attrs:{"label":"OUI","value":true}}),_vm._v(" "),_c('el-option',{attrs:{"label":"NON","value":false}})],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Caisse *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Caisse *","disabled":_vm.contratCourant.etat > 1},model:{value:(_vm.selectCaisse),callback:function ($$v) {_vm.selectCaisse=$$v},expression:"selectCaisse"}},_vm._l((_vm.listCaisse),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de paiement *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"datePaiement","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de fin *","disabled":_vm.interventionCourant.etat >= 3},model:{value:(_vm.datePaiement),callback:function ($$v) {_vm.datePaiement=$$v},expression:"datePaiement"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(_vm.attribuer == true)?_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Conducteur *")]),_vm._v(" "),(_vm.dialogEdit == false)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Conducteur *"},model:{value:(_vm.selectConducteur),callback:function ($$v) {_vm.selectConducteur=$$v},expression:"selectConducteur"}},_vm._l((_vm.listConducteurDispo),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nomPren,"value":item.id}})}),1):_vm._e(),_vm._v(" "),(_vm.dialogEdit == true && _vm.contratCourant.etat == 0)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Conducteur *","disabled":_vm.contratCourant.etat >= 1},model:{value:(_vm.selectConducteur),callback:function ($$v) {_vm.selectConducteur=$$v},expression:"selectConducteur"}},_vm._l((_vm.listConducteurDispo),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nomPren,"value":item.id}})}),1):_vm._e(),_vm._v(" "),(_vm.dialogEdit == true && _vm.contratCourant.etat >= 1)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.contratCourant.conducteur,"disabled":true},model:{value:(_vm.contratCourant.conducteur),callback:function ($$v) {_vm.$set(_vm.contratCourant, "conducteur", $$v)},expression:"contratCourant.conducteur"}}):_vm._e()],1)]):_vm._e()],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                AJOUTER DE PARAMETRES SUPLEMENTAIRES A LA FACTURE\n              ")])],1),_vm._v(" "),_vm._l((_vm.optionContrat),function(option,index){return _c('v-layout',{key:option.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Désignation *")]),_vm._v(" "),_c('el-input',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"placeholder":"Désignation","disabled":_vm.contratCourant.etat >= 1},model:{value:(option.libelle),callback:function ($$v) {_vm.$set(option, "libelle", $$v)},expression:"option.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix unitaire *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":"0","placeholder":"Prix unitaire","disabled":_vm.contratCourant.etat >= 1},on:{"change":_vm.calculContrat},model:{value:(option.cout),callback:function ($$v) {_vm.$set(option, "cout", $$v)},expression:"option.cout"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":"1","placeholder":"Quantité","disabled":_vm.contratCourant.etat >= 1},on:{"change":_vm.calculContrat},model:{value:(option.qte),callback:function ($$v) {_vm.$set(option, "qte", $$v)},expression:"option.qte"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité")]),_vm._v(" "),_c('el-input',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"disabled":_vm.contratCourant.etat >= 1,"prop":'optionCommande.' + index + '.unite',"required":"","placeholder":"Unité","trigger-on-focus":true},model:{value:(option.unite),callback:function ($$v) {_vm.$set(option, "unite", $$v)},expression:"option.unite"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("TVA")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":"0","max":"18","placeholder":"TVA","disabled":_vm.contratCourant.etat >= 1},on:{"change":_vm.calculContrat},model:{value:(option.tva),callback:function ($$v) {_vm.$set(option, "tva", $$v)},expression:"option.tva"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("TOTAL TTC")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","placeholder":"TOTAL TTC","disabled":true},model:{value:(option.total),callback:function ($$v) {_vm.$set(option, "total", $$v)},expression:"option.total"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red","disabled":_vm.contratCourant.etat >= 1},on:{"click":function($event){return _vm.deleteOptionContrat(index)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                  Supprimer\n                ")],1)],1)],1)}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-chip',{staticStyle:{"font-size":"25px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                  MONTANT HT : "+_vm._s(_vm.ht)+" FCFA\n                ")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue","disabled":_vm.contratCourant.etat >= 1},on:{"click":_vm.contratLigne},slot:"activator"},[_c('v-icon',{attrs:{"icon":"","dark":""}},[_vm._v("add")])],1),_vm._v("\n                  Ajouter\n                ")],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-chip',{staticStyle:{"font-size":"25px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                  MONTANT REMISE : "+_vm._s(_vm.totalRemise)+" FCFA\n                ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-chip',{staticStyle:{"font-size":"25px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                  MONTANT TVA : "+_vm._s(_vm.tva)+" FCFA\n                ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-chip',{staticStyle:{"font-size":"25px","width":"100%"},attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                  MONTANT TTC : "+_vm._s(_vm.total)+" FCFA\n                ")])],1)],1),_vm._v(" "),_c('br')],2),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutContrat = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.dialogEdit == false)?_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.submitContrat()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.submitContrat()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"max-width":"80%","scrollable":"","loading":_vm.loading},model:{value:(_vm.dialogAjoutClientLocation),callback:function ($$v) {_vm.dialogAjoutClientLocation=$$v},expression:"dialogAjoutClientLocation"}},[_c('v-card',[_c('v-toolbar',{staticClass:"green",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajout d'une nouvelle location client")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification du client "+_vm._s(_vm.clientLocationCourant.nomPrenom)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutClientLocation = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formClientLocation",attrs:{"lazy-validation":"","id":"formClientLocation"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEdit != true)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                AJOUTER UN NOUVEAU CLIENT\n              ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit == true)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                MODIFICATION DU CLIENT "+_vm._s(_vm.clientLocationCourant.nom)+"\n                "+_vm._s(_vm.clientLocationCourant.prenom)+"\n              ")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md2":""}},[(_vm.dialogEdit != true)?_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"list-type":"picture-card","limit":1,"name":"photo","action":"","auto-upload":false,"multiple":false}},[_c('i',{staticClass:"el-icon-plus"})]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"list-type":"picture-card","name":"photo","action":"","limit":1,"multiple":false,"auto-upload":false}},[(_vm.clientLocationCourant.url)?_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":_vm.clientLocationCourant.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":"/static/avatar-conducteur.png","alt":""}})]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"md10":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de personne *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.formClientLocation.type),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "type", $$v)},expression:"formClientLocation.type"}},_vm._l((_vm.listTypeClient),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nom *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"nom","placeholder":"Nom"},model:{value:(_vm.formClientLocation.nom),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "nom", $$v)},expression:"formClientLocation.nom"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prenom *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"prenom","placeholder":"Prenom"},model:{value:(_vm.formClientLocation.prenom),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "prenom", $$v)},expression:"formClientLocation.prenom"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Profession *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"profession","placeholder":"Profession"},model:{value:(_vm.formClientLocation.profession),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "profession", $$v)},expression:"formClientLocation.profession"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Contact * ")]),_vm._v(" "),_c('el-input',{attrs:{"name":"contact","placeholder":"Contact"},model:{value:(_vm.formClientLocation.contact),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "contact", $$v)},expression:"formClientLocation.contact"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Adresse")]),_vm._v(" "),_c('el-input',{attrs:{"name":"adresse","placeholder":"Adresse"},model:{value:(_vm.formClientLocation.adresse),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "adresse", $$v)},expression:"formClientLocation.adresse"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Email")]),_vm._v(" "),_c('el-input',{attrs:{"type":"email","name":"email","id":"email","placeholder":"Email"},model:{value:(_vm.formClientLocation.email),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "email", $$v)},expression:"formClientLocation.email"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Fixe ")]),_vm._v(" "),_c('el-input',{attrs:{"name":"fixe","placeholder":"Telephone fixe"},model:{value:(_vm.formClientLocation.fixe),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "fixe", $$v)},expression:"formClientLocation.fixe"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date d'expiration de la piece *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateExpirPiece","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date d'expiration de la piece"},model:{value:(_vm.formClientLocation.DateExpirPiece),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "DateExpirPiece", $$v)},expression:"formClientLocation.DateExpirPiece"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de la piece *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"typePiece","placeholder":"Type de piece"},model:{value:(_vm.formClientLocation.piece),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "piece", $$v)},expression:"formClientLocation.piece"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Numero de la piece *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"numPiece","placeholder":"Numero de piece"},model:{value:(_vm.formClientLocation.numPiece),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "numPiece", $$v)},expression:"formClientLocation.numPiece"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de delivrance de la piece *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateDelivrPiece","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de delivrance de la piece"},model:{value:(_vm.formClientLocation.DateDelivrPiece),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "DateDelivrPiece", $$v)},expression:"formClientLocation.DateDelivrPiece"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Personne signataire *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"persoSignataire","placeholder":"Personne signataire"},model:{value:(_vm.formClientLocation.persoSignataire),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "persoSignataire", $$v)},expression:"formClientLocation.persoSignataire"}})],1)])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                    INFORMATIONS SUR LA PERSONNE A CONTACTER EN CAS D'URGENCE\n                  ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nom *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"nomPers","placeholder":"Nom"},model:{value:(_vm.formClientLocation.nomPersoContact),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "nomPersoContact", $$v)},expression:"formClientLocation.nomPersoContact"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prenom *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"prenPers","placeholder":"Prenom"},model:{value:(_vm.formClientLocation.prenomPersoContact),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "prenomPersoContact", $$v)},expression:"formClientLocation.prenomPersoContact"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Affinite *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Affinite"},model:{value:(_vm.formClientLocation.affinite),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "affinite", $$v)},expression:"formClientLocation.affinite"}},_vm._l((_vm.affinite),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Contact * ")]),_vm._v(" "),_c('el-input',{attrs:{"name":"telPers","placeholder":"Contact"},model:{value:(_vm.formClientLocation.telPersoContact),callback:function ($$v) {_vm.$set(_vm.formClientLocation, "telPersoContact", $$v)},expression:"formClientLocation.telPersoContact"}})],1)])],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogAjoutClientLocation = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.submitClientLocation()}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"max-width":"50%"},model:{value:(_vm.dialogAjoutMarq),callback:function ($$v) {_vm.dialogAjoutMarq=$$v},expression:"dialogAjoutMarq"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajout d'une nouvelle marque")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification d'une nouvelle marque")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutMarq = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formMarque",attrs:{"lazy-validation":"","id":"formMarque"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEdit != true)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                Ajouter une nouvelle marque\n              ")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoMarque,"alt":"avatar"}})]),_c('br'),_vm._v(" "),_c('input',{ref:"fileLogo",staticStyle:{"display":"none"},attrs:{"name":"logo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileLogo.click()}}},[_vm._v("Photo "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Libelle")]),_vm._v(" "),_c('el-input',{attrs:{"name":"libelle","placeholder":"Nom de la marque"},model:{value:(_vm.formMarque.libelle),callback:function ($$v) {_vm.$set(_vm.formMarque, "libelle", $$v)},expression:"formMarque.libelle"}})],1)])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogAjoutMarq = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.submitMarq()}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogAjoutMod),callback:function ($$v) {_vm.dialogAjoutMod=$$v},expression:"dialogAjoutMod"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajout d'un nouveau modèle")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification du modèle ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutMod = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formModele",attrs:{"lazy-validation":"","id":"formModele"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',[(_vm.dialogEdit != true)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                Ajouter un nouveau Modèle\n              ")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Libelle*")]),_vm._v(" "),_c('el-input',{attrs:{"name":"libelle","placeholder":"Nom du modele"},model:{value:(_vm.formModele.libelle),callback:function ($$v) {_vm.$set(_vm.formModele, "libelle", $$v)},expression:"formModele.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Marque *")]),_vm._v(" "),_c('el-autocomplete',{staticStyle:{"width":"100%"},attrs:{"fetch-suggestions":_vm.loadListMarq,"placeholder":"Marque","trigger-on-focus":true},model:{value:(_vm.selectMarque),callback:function ($$v) {_vm.selectMarque=$$v},expression:"selectMarque"}})],1)])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogAjoutMod = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.submitModele()}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogAjoutSerie),callback:function ($$v) {_vm.dialogAjoutSerie=$$v},expression:"dialogAjoutSerie"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajout d'une nouvelle serie")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification de la serie ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutSerie = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formSerie",attrs:{"lazy-validation":"","id":"formSerie"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',[(_vm.dialogEdit != true)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                Ajouter une nouvelle serie\n              ")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Libelle*")]),_vm._v(" "),_c('el-input',{attrs:{"name":"libelle","placeholder":"Nom de la marque"},model:{value:(_vm.formSerie.libelle),callback:function ($$v) {_vm.$set(_vm.formSerie, "libelle", $$v)},expression:"formSerie.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Modèle*")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Le Modèle"},model:{value:(_vm.selectSerie),callback:function ($$v) {_vm.selectSerie=$$v},expression:"selectSerie"}},_vm._l((_vm.listModele),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogAjoutSerie = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.submitSerie()}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"max-width":"60%","loading":_vm.loading},model:{value:(_vm.dialogAjoutAssu),callback:function ($$v) {_vm.dialogAjoutAssu=$$v},expression:"dialogAjoutAssu"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit == false)?_c('span',[_vm._v("Ajout d'une nouvelle assurance")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit == true)?_c('span',[_vm._v("Modification d'une assurance ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutAssu = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formAssu",attrs:{"lazy-validation":"","id":"formAssu"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEdit != true)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                Ajouter une nouvelle assurance\n              ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                MODIFICATION DE L'ASSURANCE\n              ")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoAssur,"alt":"avatar"}})]),_c('br'),_vm._v(" "),_c('input',{ref:"fileAssur",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageAssurLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileAssur.click()}}},[_vm._v("Photo "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1),_vm._v(" "),_c('v-flex',{attrs:{"md9":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("N° Attestation *")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.assuranceCourant.statut == true,"name":"attestation","id":"attestation","placeholder":"Attestation"},model:{value:(_vm.formAssu.attestation),callback:function ($$v) {_vm.$set(_vm.formAssu, "attestation", $$v)},expression:"formAssu.attestation"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("N° Police *")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.assuranceCourant.statut == true,"name":"police","id":"police","placeholder":"Police"},model:{value:(_vm.formAssu.police),callback:function ($$v) {_vm.$set(_vm.formAssu, "police", $$v)},expression:"formAssu.police"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant TTC de l'assurance *")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.assuranceCourant.statut == true,"type":"number","min":"0","name":"montant","id":"montant","placeholder":"Montant de l'assurance"},model:{value:(_vm.formAssu.montant),callback:function ($$v) {_vm.$set(_vm.formAssu, "montant", $$v)},expression:"formAssu.montant"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date d'achat l'assurance *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.assuranceCourant.statut == true,"name":"dateAssurance","id":"dateAssurance","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de l'assurance"},model:{value:(_vm.formAssu.dateAssu),callback:function ($$v) {_vm.$set(_vm.formAssu, "dateAssu", $$v)},expression:"formAssu.dateAssu"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Compagnie *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.assuranceCourant.statut == true,"clearable":"","allow-create":"","filterable":"","placeholder":"La Compagnie"},model:{value:(_vm.selectCompagnLib),callback:function ($$v) {_vm.selectCompagnLib=$$v},expression:"selectCompagnLib"}},_vm._l((_vm.listCompagn),function(item){return _c('el-option',{key:item.idPres,attrs:{"label":item.libelle,"value":item.idPres}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Parc *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"valeurSelect","id":"valeurSelect","clearable":"","disabled":_vm.assuranceCourant.statut == true,"placeholder":"Parc auto"},on:{"change":function($event){return _vm.loadTypeParc(_vm.selectParc)}},model:{value:(_vm.selectParc),callback:function ($$v) {_vm.selectParc=$$v},expression:"selectParc"}},_vm._l((_vm.listParc),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Vehicule *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","disabled":_vm.assuranceCourant.statut == true,"placeholder":"Vehicule"},model:{value:(_vm.selectVehicule),callback:function ($$v) {_vm.selectVehicule=$$v},expression:"selectVehicule"}},_vm._l((_vm.listVehicule),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de debut de l'assurance *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.assuranceCourant.statut == true,"name":"dateDebutAssurance","id":"dateDebutAssurance","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de debut"},model:{value:(_vm.formAssu.dateDebutAssu),callback:function ($$v) {_vm.$set(_vm.formAssu, "dateDebutAssu", $$v)},expression:"formAssu.dateDebutAssu"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin de l'assurance *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.assuranceCourant.statut == true,"name":"dateFinAssurance","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de fin"},model:{value:(_vm.formAssu.dateFinAssu),callback:function ($$v) {_vm.$set(_vm.formAssu, "dateFinAssu", $$v)},expression:"formAssu.dateFinAssu"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Activé l'assurance *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.formAssu.statut),callback:function ($$v) {_vm.$set(_vm.formAssu, "statut", $$v)},expression:"formAssu.statut"}},_vm._l((_vm.statutAssu),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de renouvellement")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.assuranceCourant.statut == true,"id":"dateRenAssurance","name":"dateRenAssurance","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de renouvellement"},model:{value:(_vm.formAssu.dateRenAssu),callback:function ($$v) {_vm.$set(_vm.formAssu, "dateRenAssu", $$v)},expression:"formAssu.dateRenAssu"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.assuranceCourant.statut == true,"name":"description","id":"description","type":"textarea","rows":3,"required":""},model:{value:(_vm.formAssu.description),callback:function ($$v) {_vm.$set(_vm.formAssu, "description", $$v)},expression:"formAssu.description"}})],1)])],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogAjoutAssu = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.submitAssu()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"max-width":"60%","loading":_vm.loading},model:{value:(_vm.dialogAjoutVign),callback:function ($$v) {_vm.dialogAjoutVign=$$v},expression:"dialogAjoutVign"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEditVign == true)?_c('span',[_vm._v("Ajout d'une nouvelle vidange")]):_vm._e(),_vm._v(" "),(_vm.dialogEditVign ==false)?_c('span',[_vm._v("Modification de la "+_vm._s(_vm.vidangeCourant.ref)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutVign = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formVidn",attrs:{"lazy-validation":"","id":"formVidn"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEditVign == true)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                AJOUTER UNE NOUVELLE VIDANGE\n              ")]):_vm._e(),_vm._v(" "),(_vm.dialogEditVign != true)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                MODIFICATION DE LA VIDANGE DU VEHICULE  "+_vm._s(_vm.vidangeCourant.vehicule)+"\n              ")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoVidange,"alt":"avatar"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{ref:"fileVidange",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageVidangeLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileVidange.click()}}},[_vm._v("Photo "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-flex',{attrs:{"md9":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Numero de la vidange *")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.vidangeCourant.statut == true,"name":"numero","placeholder":"Numero"},model:{value:(_vm.formVidn.numero),callback:function ($$v) {_vm.$set(_vm.formVidn, "numero", $$v)},expression:"formVidn.numero"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Numero facture proforma")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.vidangeCourant.statut == true,"name":"numFacture","placeholder":"Numero"},model:{value:(_vm.formVidn.numFacture),callback:function ($$v) {_vm.$set(_vm.formVidn, "numFacture", $$v)},expression:"formVidn.numFacture"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Parc *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"valeurSelect","id":"valeurSelect","clearable":"","disabled":_vm.vidangeCourant.statut == true,"placeholder":"Parc auto"},on:{"change":function($event){return _vm.loadTypeParc(_vm.selectParc)}},model:{value:(_vm.selectParc),callback:function ($$v) {_vm.selectParc=$$v},expression:"selectParc"}},_vm._l((_vm.listParc),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Vehicule *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","disabled":_vm.vidangeCourant.statut == true,"placeholder":"Vehicule"},model:{value:(_vm.selectVehicule),callback:function ($$v) {_vm.selectVehicule=$$v},expression:"selectVehicule"}},_vm._l((_vm.listVehicule),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de la vidange * ")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.vidangeCourant.statut == true,"id":"dateVidange","name":"dateVidange","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de la vidange"},model:{value:(_vm.formVidn.dateDebt),callback:function ($$v) {_vm.$set(_vm.formVidn, "dateDebt", $$v)},expression:"formVidn.dateDebt"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Kilométrage actuel *")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.vidangeCourant.statut == true,"type":"number","min:0":"","name":"kiloActu","placeholder":"Kilométrage actuel"},model:{value:(_vm.formVidn.kiloActu),callback:function ($$v) {_vm.$set(_vm.formVidn, "kiloActu", $$v)},expression:"formVidn.kiloActu"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Kilométrage prochain *")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.vidangeCourant.statut == true,"type":"number","min:0":"","name":"kiloProch","placeholder":"Kilométrage prochain "},model:{value:(_vm.formVidn.kiloProch),callback:function ($$v) {_vm.$set(_vm.formVidn, "kiloProch", $$v)},expression:"formVidn.kiloProch"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant *")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.vidangeCourant.statut == true,"min":"0","type":"number","name":"montant","placeholder":"Montant"},model:{value:(_vm.formVidn.montant),callback:function ($$v) {_vm.$set(_vm.formVidn, "montant", $$v)},expression:"formVidn.montant"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de renouvellement\n                      ")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.vidangeCourant.statut == true,"id":"dateRen","name":"dateRen","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de renouvellement"},model:{value:(_vm.formVidn.dateRen),callback:function ($$v) {_vm.$set(_vm.formVidn, "dateRen", $$v)},expression:"formVidn.dateRen"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Activé la vidange *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.formVidn.statut),callback:function ($$v) {_vm.$set(_vm.formVidn, "statut", $$v)},expression:"formVidn.statut"}},_vm._l((_vm.statutVign),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"description","type":"textarea","rows":3,"required":""},model:{value:(_vm.formVidn.description),callback:function ($$v) {_vm.$set(_vm.formVidn, "description", $$v)},expression:"formVidn.description"}})],1)])],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogAjoutVign = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.submitVign()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","persistent":true,"loading":_vm.loading,"scrollable":""},model:{value:(_vm.dialogAjoutVisit),callback:function ($$v) {_vm.dialogAjoutVisit=$$v},expression:"dialogAjoutVisit"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajout d'une nouvelle visite")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification de la visite du "+_vm._s(_vm.visiteCourant.dateDebut)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutVisit = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formVisite",attrs:{"lazy-validation":"","id":"formVisite"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEdit != true)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                AJOUTER UNE NOUVELLE VISITE TECHNIQUE\n              ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                MODIFICATION DE LA VISITE TECHNIQUE\n                "+_vm._s(_vm.visiteCourant.dateDebut)+"\n              ")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoVisite,"alt":"avatar"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{ref:"fileVisite",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageVisiteLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileVisite.click()}}},[_vm._v("Photo "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-flex',{attrs:{"md9":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Numero de la visite *")]),_vm._v(" "),_c('el-input',{attrs:{"readonly":_vm.visiteCourant.statut == true ? true :false,"name":"numero","placeholder":"Numero"},model:{value:(_vm.formVisite.numero),callback:function ($$v) {_vm.$set(_vm.formVisite, "numero", $$v)},expression:"formVisite.numero"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Parc *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"valeurSelect","id":"valeurSelect","clearable":"","disabled":_vm.visiteCourant.statut == true ? true :false,"placeholder":"Parc auto"},on:{"change":function($event){return _vm.loadTypeParc(_vm.selectParc)}},model:{value:(_vm.selectParc),callback:function ($$v) {_vm.selectParc=$$v},expression:"selectParc"}},_vm._l((_vm.listParc),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Vehicule *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.visiteCourant.statut == true ? true :false,"clearable":"","placeholder":"Vehicule"},model:{value:(_vm.selectVehicule),callback:function ($$v) {_vm.selectVehicule=$$v},expression:"selectVehicule"}},_vm._l((_vm.listVehicule),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de la visite *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.visiteCourant.statut == true ? true :false,"name":"dateDebut","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de la visite"},model:{value:(_vm.formVisite.dateDebut),callback:function ($$v) {_vm.$set(_vm.formVisite, "dateDebut", $$v)},expression:"formVisite.dateDebut"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date fin de la visite *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.visiteCourant.statut  == true ? true :false,"name":"dateFin","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date fin"},model:{value:(_vm.formVisite.dateFin),callback:function ($$v) {_vm.$set(_vm.formVisite, "dateFin", $$v)},expression:"formVisite.dateFin"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant TTC*")]),_vm._v(" "),_c('el-input',{attrs:{"min":0,"readonly":_vm.visiteCourant.statut  == true ? true :false,"type":"number","name":"montant","placeholder":"Montant"},model:{value:(_vm.formVisite.montant),callback:function ($$v) {_vm.$set(_vm.formVisite, "montant", $$v)},expression:"formVisite.montant"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de renouvellement\n                      ")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.visiteCourant.statut  == true ? true :false,"name":"dateRen","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de renouvellement"},model:{value:(_vm.formVisite.dateRen),callback:function ($$v) {_vm.$set(_vm.formVisite, "dateRen", $$v)},expression:"formVisite.dateRen"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Activé la visite *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Activé la visite"},model:{value:(_vm.formVisite.statut),callback:function ($$v) {_vm.$set(_vm.formVisite, "statut", $$v)},expression:"formVisite.statut"}},_vm._l((_vm.statutVisit),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"description","type":"textarea","rows":3,"required":""},model:{value:(_vm.formVisite.description),callback:function ($$v) {_vm.$set(_vm.formVisite, "description", $$v)},expression:"formVisite.description"}})],1)])],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogAjoutVisit = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.submitVisit()}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","persistent":true,"loading":_vm.loading,"scrollable":""},model:{value:(_vm.dialogAjoutVehiConducteur),callback:function ($$v) {_vm.dialogAjoutVehiConducteur=$$v},expression:"dialogAjoutVehiConducteur"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Attribuer un véhicule au conducteur "+_vm._s(_vm.conducteurCourant.nom))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutVehiConducteur = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formAttribueCondu",attrs:{"lazy-validation":"","id":"formAttribueCondu"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Parc concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"valeurSelect","id":"valeurSelect","placeholder":"Sélectionnez un parc"},on:{"change":function($event){return _vm.loadTypeParc(_vm.formAttribueCondu.parc)}},model:{value:(_vm.formAttribueCondu.parc),callback:function ($$v) {_vm.$set(_vm.formAttribueCondu, "parc", $$v)},expression:"formAttribueCondu.parc"}},_vm._l((_vm.listParc),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Véhicule concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Véhicule concerné"},model:{value:(_vm.formAttribueCondu.vehicule),callback:function ($$v) {_vm.$set(_vm.formAttribueCondu, "vehicule", $$v)},expression:"formAttribueCondu.vehicule"}},_vm._l((_vm.listVehicule),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogAjoutVehiConducteur = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.submitAttribution()}}},[_vm._v("Enrregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"max-width":"80%","loading":_vm.loading,"scrollable":""},model:{value:(_vm.dialogAjoutCond),callback:function ($$v) {_vm.dialogAjoutCond=$$v},expression:"dialogAjoutCond"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajout d'un nouveau conducteur")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification du conducteur ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutCond = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formConducteur",attrs:{"lazy-validation":"","id":"formConducteur"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEdit != true)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                AJOUTER UN NOUVEAU CONDUCTEUR\n              ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit == true)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                MODIFICATION DU CONDUCTEUR "+_vm._s(_vm.conducteurCourant.nom)+" -\n                "+_vm._s(_vm.conducteurCourant.prenom)+"\n              ")]):_vm._e()],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":4}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('div',[_c('v-flex',{attrs:{"md6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.imageChauf,"alt":"avatar"}})]),_c('br'),_vm._v(" "),_c('input',{ref:"imageChauf",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageChauffPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.imageChauf.click()}}},[_vm._v("Photo\n                          "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1)],1)])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-col',[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Matricule")]),_vm._v(" "),_c('el-input',{attrs:{"name":"matricule","id":"matricule","placeholder":"Matricule"},model:{value:(_vm.formConducteur.matricule),callback:function ($$v) {_vm.$set(_vm.formConducteur, "matricule", $$v)},expression:"formConducteur.matricule"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nom *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"nom","id":"nom","placeholder":"Nom"},model:{value:(_vm.formConducteur.nom),callback:function ($$v) {_vm.$set(_vm.formConducteur, "nom", $$v)},expression:"formConducteur.nom"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prenom *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"prenom","id":"prenom","placeholder":"Prenom"},model:{value:(_vm.formConducteur.prenom),callback:function ($$v) {_vm.$set(_vm.formConducteur, "prenom", $$v)},expression:"formConducteur.prenom"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de naissance *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateNaiss","value-format":"dd-MM-yyyy","id":"dateNaiss","type":"date","placeholder":"Date de naissance"},model:{value:(_vm.formConducteur.dateNaiss),callback:function ($$v) {_vm.$set(_vm.formConducteur, "dateNaiss", $$v)},expression:"formConducteur.dateNaiss"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Lieu de naissaance *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"lieuNaiss","id":"lieuNaiss","placeholder":"Lieu de naissance"},model:{value:(_vm.formConducteur.lieuNaiss),callback:function ($$v) {_vm.$set(_vm.formConducteur, "lieuNaiss", $$v)},expression:"formConducteur.lieuNaiss"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Telephone 1 *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"tel1","id":"tel1","placeholder":"Telephone 1"},model:{value:(_vm.formConducteur.phone1),callback:function ($$v) {_vm.$set(_vm.formConducteur, "phone1", $$v)},expression:"formConducteur.phone1"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Telephone 2\n                                ")]),_vm._v(" "),_c('el-input',{attrs:{"name":"tel2","id":"tel2","placeholder":"Telephone 2"},model:{value:(_vm.formConducteur.phone2),callback:function ($$v) {_vm.$set(_vm.formConducteur, "phone2", $$v)},expression:"formConducteur.phone2"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Adresse ")]),_vm._v(" "),_c('el-input',{attrs:{"name":"adresse","id":"adresseConducteur","placeholder":"Adresse"},model:{value:(_vm.formConducteur.adresse),callback:function ($$v) {_vm.$set(_vm.formConducteur, "adresse", $$v)},expression:"formConducteur.adresse"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Email")]),_vm._v(" "),_c('el-input',{attrs:{"type":"email","name":"email","placeholder":"Email"},model:{value:(_vm.formConducteur.email),callback:function ($$v) {_vm.$set(_vm.formConducteur, "email", $$v)},expression:"formConducteur.email"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Fonction *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"fonction","id":"fonction","placeholder":"Fonction"},model:{value:(_vm.formConducteur.fonction),callback:function ($$v) {_vm.$set(_vm.formConducteur, "fonction", $$v)},expression:"formConducteur.fonction"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Numero du permis *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"numPermis","id":"numPermis","placeholder":"Numero du permis"},model:{value:(_vm.formConducteur.numPermis),callback:function ($$v) {_vm.$set(_vm.formConducteur, "numPermis", $$v)},expression:"formConducteur.numPermis"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de permis *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"multiple":"","id":"typedePermis","placeholder":this.detailsPermis !='' ? this.detailsPermis:''},model:{value:(_vm.typedePermis),callback:function ($$v) {_vm.typedePermis=$$v},expression:"typedePermis"}},_vm._l((_vm.listTypePermis),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de validite du permis")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"id":"dateValPermis","name":"dateValPermis","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de validite du permis"},model:{value:(_vm.formConducteur.dateValPermis),callback:function ($$v) {_vm.$set(_vm.formConducteur, "dateValPermis", $$v)},expression:"formConducteur.dateValPermis"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Disponibilite"},model:{value:(_vm.formConducteur.disponibilite),callback:function ($$v) {_vm.$set(_vm.formConducteur, "disponibilite", $$v)},expression:"formConducteur.disponibilite"}},_vm._l((_vm.listDisponibilite),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])],1)],1)],1)])],1)],1),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogAjoutCond = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){$event.preventDefault();return _vm.submitConducteur()}}},[_vm._v("Enrregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","loading":_vm.loading,"overlay":true,"max-width":"60%"},model:{value:(_vm.dialogAjoutCons),callback:function ($$v) {_vm.dialogAjoutCons=$$v},expression:"dialogAjoutCons"}},[_c('v-card',[_c('v-toolbar',{staticClass:"orange",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter ou modifier une consommation")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutCons = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formConsomm",attrs:{"lazy-validation":"","id":"formConsomm"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Parc concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"valeurSelect","id":"valeurSelect","placeholder":"Sélectionnez un parc"},on:{"change":function($event){return _vm.loadTypeParc(_vm.selectParc)}},model:{value:(_vm.selectParc),callback:function ($$v) {_vm.selectParc=$$v},expression:"selectParc"}},_vm._l((_vm.listParc),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Véhicule concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Véhicule concerné"},model:{value:(_vm.formAjoutCons.vehicule),callback:function ($$v) {_vm.$set(_vm.formAjoutCons, "vehicule", $$v)},expression:"formAjoutCons.vehicule"}},_vm._l((_vm.listVehicule),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type consommation *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Type consommation"},model:{value:(_vm.formAjoutCons.typeCons),callback:function ($$v) {_vm.$set(_vm.formAjoutCons, "typeCons", $$v)},expression:"formAjoutCons.typeCons"}},_vm._l((_vm.listType),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),(_vm.formAjoutCons.typeCons == 'Carte')?_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Liste des cartes")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Selectionner une carte"},model:{value:(_vm.formAjoutCons.identifiant),callback:function ($$v) {_vm.$set(_vm.formAjoutCons, "identifiant", $$v)},expression:"formAjoutCons.identifiant"}},_vm._l((_vm.cartes),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.identifiant}})}),1)],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Station *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"station","placeholder":"Station *"},model:{value:(_vm.formAjoutCons.station),callback:function ($$v) {_vm.$set(_vm.formAjoutCons, "station", $$v)},expression:"formAjoutCons.station"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité *")]),_vm._v(" "),_c('el-input',{attrs:{"min":0,"type":"number","name":"quantite","placeholder":"Quantité"},model:{value:(_vm.formAjoutCons.quantite),callback:function ($$v) {_vm.$set(_vm.formAjoutCons, "quantite", $$v)},expression:"formAjoutCons.quantite"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant *")]),_vm._v(" "),_c('el-input',{attrs:{"min":0,"type":"number","name":"mntCons","placeholder":"Montant"},model:{value:(_vm.formAjoutCons.montant),callback:function ($$v) {_vm.$set(_vm.formAjoutCons, "montant", $$v)},expression:"formAjoutCons.montant"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Kilomètrage *")]),_vm._v(" "),_c('el-input',{attrs:{"min":0,"type":"number","name":"kiloCons","placeholder":"Montant"},model:{value:(_vm.formAjoutCons.kiloCons),callback:function ($$v) {_vm.$set(_vm.formAjoutCons, "kiloCons", $$v)},expression:"formAjoutCons.kiloCons"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Distance parcourue ")]),_vm._v(" "),_c('el-input',{attrs:{"min":0,"type":"number","name":"distParcourCons","placeholder":"Distance parcourue"},model:{value:(_vm.formAjoutCons.distParcourCons),callback:function ($$v) {_vm.$set(_vm.formAjoutCons, "distParcourCons", $$v)},expression:"formAjoutCons.distParcourCons"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date d'achat *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"id":"dateAchat","name":"dateAchat","value-format":"yyyy-MM-d HH:mm","type":"datetime","format":"d-MM-yyyy HH:mm","placeholder":"Date d'achat"},model:{value:(_vm.formAjoutCons.dateAchat),callback:function ($$v) {_vm.$set(_vm.formAjoutCons, "dateAchat", $$v)},expression:"formAjoutCons.dateAchat"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.imageConsom,"alt":"avatar"}})]),_c('br'),_vm._v(" "),_c('input',{ref:"imageConsom",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileConsomPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.imageConsom.click()}}},[_vm._v("Photo "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogAjoutCons = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){$event.preventDefault();return _vm.submitCarburant()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":"","loading":_vm.loading},model:{value:(_vm.dialogValiderDevis),callback:function ($$v) {_vm.dialogValiderDevis=$$v},expression:"dialogValiderDevis"}},[_c('v-card',[_c('v-toolbar',{staticClass:"orange",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Validation du dévis ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogValiderDevis = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n              VALIDATION DU DEVIS\n            ")])],1),_vm._v(" "),_c('v-form',{ref:"formValiderDevis",attrs:{"lazy-validation":"","id":"formValiderDevis"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Réponse *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Prestataire"},model:{value:(_vm.selectReponseDevis),callback:function ($$v) {_vm.selectReponseDevis=$$v},expression:"selectReponseDevis"}},_vm._l((_vm.reponseDevis),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md8":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Remarque ")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","name":"remarque"},model:{value:(_vm.remarqueValider),callback:function ($$v) {_vm.remarqueValider=$$v},expression:"remarqueValider"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogValiderDevis = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.submitValiderDevis(4)}}},[_vm._v("Enrregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":"","loading":_vm.loading},model:{value:(_vm.dialogCloseContrat),callback:function ($$v) {_vm.dialogCloseContrat=$$v},expression:"dialogCloseContrat"}},[_c('v-card',[_c('v-toolbar',{staticClass:"red",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Marquer la fin du contrat de location de\n            "+_vm._s(_vm.contratCourant.client)+"\n          ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogCloseContrat = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n              METTRE FIN AU CONTRAT DE LOCATION\n            ")])],1),_vm._v(" "),_c('v-form',{ref:"formCloseContrat",attrs:{"lazy-validation":"","id":"formCloseContrat"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Valider la fin du contrat *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Valider la fin du contrat"},model:{value:(_vm.selectClose),callback:function ($$v) {_vm.selectClose=$$v},expression:"selectClose"}},_vm._l((_vm.close),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de retour *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateR","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de retour *"},model:{value:(_vm.dateR),callback:function ($$v) {_vm.dateR=$$v},expression:"dateR"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Kilométrage au retour ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"name":"kilometrage","placeholder":"Kilométrage au retour"},model:{value:(_vm.kilometrage),callback:function ($$v) {_vm.kilometrage=$$v},expression:"kilometrage"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Remarque ")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","name":"remarque"},model:{value:(_vm.remarque),callback:function ($$v) {_vm.remarque=$$v},expression:"remarque"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogCloseContrat = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){return _vm.submitCloseContrat()}}},[_vm._v("Enrregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"75%","scrollable":"","loading":_vm.loading},model:{value:(_vm.dialogShowContrat),callback:function ($$v) {_vm.dialogShowContrat=$$v},expression:"dialogShowContrat"}},[_c('v-card',[_c('v-toolbar',{staticClass:"green",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Details du contrat "+_vm._s(_vm.contratCourant.client)+" ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowContrat = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Réference : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.ref))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Client : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.client))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Véhicule : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.vehicule))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Montant total : ")]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                "+_vm._s(_vm.contratCourant.montantTotalFormat)+" FCFA\n              ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de début : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.dateDFormat))])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Date de fin : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.dateSFormat))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Type de contrat : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.libelle))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Nombre de (Jour, Mois, Année) : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.nbr)+"\n            ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Remise : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.remise))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Avance à la location : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.avance)+" %\n            ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Etat du contrat : ")]),_vm._v(" "),(_vm.contratCourant.etat == 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                RESERVE\n              ")]):_vm._e(),_vm._v(" "),(_vm.contratCourant.etat == 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                ACTIF\n              ")]):_vm._e(),_vm._v(" "),(_vm.contratCourant.etat == 2)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                TERMINE\n              ")]):_vm._e(),_vm._v(" "),(_vm.contratCourant.etat == 3)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                RESILIE\n              ")]):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Kilometrage à la sortie : ")]),_vm._v("\n              "+_vm._s(_vm.contratCourant.kilomSorti)+" Km\n            ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Conducteur : ")]),_vm._v(" "),(_vm.contratCourant.idCond != '')?_c('span',[_vm._v(_vm._s(_vm.contratCourant.conducteur))]):_c('span',[_vm._v("Aucun conducteur attribué")])]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enrégistrement : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.created)+"\n            ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Enregistré par: ")]),_vm._v(" "+_vm._s(_vm.contratCourant.createdUser))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.modified)+"\n            ")])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowContrat = false}}},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.editContrat(_vm.contratCourant)}}},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"65%","loading":_vm.loading},model:{value:(_vm.dialogShowClientLocation),callback:function ($$v) {_vm.dialogShowClientLocation=$$v},expression:"dialogShowClientLocation"}},[_c('v-card',[_c('v-toolbar',{staticClass:"green",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Details de la location client\n            "+_vm._s(_vm.clientLocationCourant.nomPrenom))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowClientLocation = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md2":""}},[(_vm.clientLocationCourant.url)?_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":_vm.clientLocationCourant.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":"/static/avatar-conducteur.png","alt":""}})]),_vm._v(" "),_c('v-flex',{attrs:{"md5":""}},[_c('p',[_c('b',[_vm._v("Référence : ")]),_vm._v(" "+_vm._s(_vm.clientLocationCourant.ref))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Nom et Prenom : ")]),_vm._v(" "+_vm._s(_vm.clientLocationCourant.nomPrenom)+"\n            ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Type de personne : ")]),_vm._v(" "),(_vm.clientLocationCourant.type == 'Personne physique')?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"indigo"}},[_vm._v("\n                "+_vm._s(_vm.clientLocationCourant.type)+"\n              ")]):_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                "+_vm._s(_vm.clientLocationCourant.type)+"\n              ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Type de piece : ")]),_vm._v(" "+_vm._s(_vm.clientLocationCourant.idPiece))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Numero de la piece : ")]),_vm._v("\n              "+_vm._s(_vm.clientLocationCourant.numPiece)+"\n            ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Contact : ")]),_vm._v(" "+_vm._s(_vm.clientLocationCourant.contact))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Email : ")]),_vm._v(" "+_vm._s(_vm.clientLocationCourant.email))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Adresse : ")]),_vm._v(" "+_vm._s(_vm.clientLocationCourant.adresse))])]),_vm._v(" "),_c('v-flex',{attrs:{"md5":""}},[_c('p',[_c('b',[_vm._v("Type : ")]),_vm._v(" "+_vm._s(_vm.clientLocationCourant.type))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Profession : ")]),_vm._v(" "+_vm._s(_vm.clientLocationCourant.profession))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Affinite : ")]),_vm._v(" "+_vm._s(_vm.clientLocationCourant.affinite))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Telephone fixe : ")]),_vm._v(" "+_vm._s(_vm.clientLocationCourant.fixe))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Personne signataire : ")]),_vm._v("\n              "+_vm._s(_vm.clientLocationCourant.persoSignataire)+"\n            ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Personne à contacter en cas d'urgence : ")]),_vm._v("\n              "+_vm._s(_vm.clientLocationCourant.nomPersoContact)+" -\n              "+_vm._s(_vm.clientLocationCourant.prenomPersoContact)+"\n            ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Affinité avec personne à contacter : ")]),_vm._v("\n              "+_vm._s(_vm.clientLocationCourant.nomPeraffinitesoContact)+"\n            ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Contact de la personne à contacter : ")]),_vm._v("\n              "+_vm._s(_vm.clientLocationCourant.telPersoContact)+"\n            ")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-tabs',{staticStyle:{"width":"100%"},attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"Vos contrats"}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.clientLocationCourant.contrat}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Référence","width":"100","fixed":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vehicule","label":"Véhicule","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                      "+_vm._s(scope.row.vehicule)+"\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("directions_car")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateD","label":"Date début et Fin","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                      "+_vm._s(scope.row.dateD)+" - "+_vm._s(scope.row.dateF)+"\n                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantTotal","label":"Montant","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                      "+_vm._s(scope.row.montantTotalFormat)+" FCFA\n                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Type","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                      RESERVE\n                    ")]):(scope.row.etat == 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                      ACTIVE\n                    ")]):(scope.row.etat == 2)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                      TERMINE\n                    ")]):(scope.row.etat == 3)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                      RESILIE\n                    ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.showContrat(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                        Détails\n                      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat == 0)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editContrat(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                        Modifier\n                      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat == 1)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){return _vm.closeContrat(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("close")])],1):_vm._e(),_vm._v("\n                        Mettre fin au contrat\n                      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat != 0)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){return _vm.impmerFacture(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1):_vm._e(),_vm._v("\n                        Imprimer\n                      ")],1)],1)]}}])})],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Vos factures"}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.clientLocationCourant.facture}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Référence","width":"100","fixed":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"refContrat","label":"Contrat concerné","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                      "+_vm._s(scope.row.refContrat)+"\n                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantTotal","label":"Montant","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                      "+_vm._s(scope.row.montantTotalFormat)+" FCFA\n                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etatGlobal","label":"Etat","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etatGlobal == 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                      IMPAYE\n                    ")]):(scope.row.etatGlobal == 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                      SOLDE\n                    ")]):(scope.row.etatGlobal == 2)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                      EN ATTENTE DE PAIEMENT\n                    ")]):(scope.row.etatGlobal == 3)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                      EN COURS DE PAIEMENT\n                    ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created","label":"Date de création","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                      "+_vm._s(scope.row.created)+"\n                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){return _vm.impmerFacture(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                        Imprimer\n                      ")],1)],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowClientLocation = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.editClientLocation(_vm.clientLocationCourant)}}},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"55%"},model:{value:(_vm.dialogShowVisit),callback:function ($$v) {_vm.dialogShowVisit=$$v},expression:"dialogShowVisit"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Details de la visite technique\n            "+_vm._s(_vm.visiteCourant.dateDebut))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowVisit = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md2":""}},[(_vm.visiteCourant.url)?_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":_vm.visiteCourant.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":"/static/img-doc.png","alt":""}})]),_vm._v(" "),_c('v-flex',{attrs:{"md5":""}},[_c('p',[_c('b',[_vm._v("Réference : ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.reference))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Numero : ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.numero))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Véhicule : ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.VehMat))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de début : ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.dateDebut))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de fin : ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.dateFin))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de rénouvellement : ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.dateRen)+"\n            ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md5":""}},[_c('p',[_c('b',[_vm._v("Montant : ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.montSepar)+" Fcfa")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Statut : ")]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                "+_vm._s(_vm.visiteCourant.statutLabel)+"\n              ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Numéro de la visite : ")]),_vm._v(" "+_vm._s(_vm.visiteCourant.numero))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description de la visite : ")]),_vm._v("\n              "+_vm._s(_vm.visiteCourant.description)+"\n            ")])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowVisit = false}}},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.editVisit(_vm.visiteCourant)}}},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogShowAssu),callback:function ($$v) {_vm.dialogShowAssu=$$v},expression:"dialogShowAssu"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Details de l'assurance")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowAssu = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("N° Attestation : ")]),_vm._v(" "+_vm._s(_vm.assuranceCourant.numAttes)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("N° Police : ")]),_vm._v(" "+_vm._s(_vm.assuranceCourant.numPolice))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Montant de l'assurance : ")]),_vm._v("\n                  "+_vm._s(_vm.assuranceCourant.mntAssur)+" FCFA\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de l'assurance : ")]),_vm._v("\n                  "+_vm._s(_vm.assuranceCourant.dateAssu)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Compagnie : ")]),_vm._v(" "+_vm._s(_vm.assuranceCourant.societe))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Statut : ")]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                    "+_vm._s(_vm.assuranceCourant.statutLabel)+"\n                  ")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Vehicule : ")]),_vm._v(" "+_vm._s(_vm.assuranceCourant.vehMatricule)+"\n                  "+_vm._s(_vm.assuranceCourant.vehMarque)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de debut : ")]),_vm._v(" "+_vm._s(_vm.assuranceCourant.dateDbt))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de fin : ")]),_vm._v(" "+_vm._s(_vm.assuranceCourant.dateFn))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de renouvellement : ")]),_vm._v("\n                  "+_vm._s(_vm.assuranceCourant.dateRenouv)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description : ")]),_vm._v(" "+_vm._s(_vm.assuranceCourant.descripAssur)+"\n                ")])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowAssu = false}}},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editAssu(_vm.assuranceCourant)}}},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"scrollable":"","max-width":"55%"},model:{value:(_vm.dialogShowVign),callback:function ($$v) {_vm.dialogShowVign=$$v},expression:"dialogShowVign"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Details de la vidange du "+_vm._s(_vm.vidangeCourant.date))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowVign = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md2":""}},[(_vm.vidangeCourant.url)?_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":_vm.vidangeCourant.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":"/static/img-doc.png","alt":""}})]),_vm._v(" "),_c('v-flex',{attrs:{"md5":""}},[_c('p',[_c('b',[_vm._v("Réference : ")]),_vm._v(" "+_vm._s(_vm.vidangeCourant.numVid))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Véhicule : ")]),_vm._v(" "+_vm._s(_vm.vidangeCourant.vehicule))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de la vidange : ")]),_vm._v(" "+_vm._s(_vm.vidangeCourant.dateDebt))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de rénouvellement : ")]),_vm._v(" "+_vm._s(_vm.vidangeCourant.dateRen)+"\n            ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md5":""}},[_c('p',[_c('b',[_vm._v("Montant : ")]),_vm._v(" "+_vm._s(_vm.vidangeCourant.montSepar)+" Fcfa")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Statut : ")]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                "+_vm._s(_vm.vidangeCourant.statutLabel)+"\n              ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Numéro de la vidange : ")]),_vm._v(" "+_vm._s(_vm.vidangeCourant.numero)+"\n            ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description de la vidange : ")]),_vm._v("\n              "+_vm._s(_vm.vidangeCourant.description)+"\n            ")])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowVign = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.editVign(_vm.vidangeCourant)}}},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"scrollable":"","max-width":"55%"},model:{value:(_vm.dialogShowCondMission),callback:function ($$v) {_vm.dialogShowCondMission=$$v},expression:"dialogShowCondMission"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Details de la mission")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowCondMission = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md5":""}},[_c('p',[_c('b',[_vm._v("Itineraire: ")]),_vm._v(" "+_vm._s(_vm.detailMission.itineraire))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Demandeur : ")]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                "+_vm._s(_vm.detailMission.demandeur)+"\n              ")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md5":""}},[_c('p',[_c('b',[_vm._v("Description")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","row":4,"readonly":true,"value":_vm.detailMission.description}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowCondMission = false}}},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"scrollable":"","max-width":"70%"},model:{value:(_vm.dialogFicheCond),callback:function ($$v) {_vm.dialogFicheCond=$$v},expression:"dialogFicheCond"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Fiche conducteur ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogFicheCond = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card',[_c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"180px","color":"grey lighten-4"}},[(_vm.conducteurCourant.url == null ||_vm.conducteurCourant.url == '' )?_c('img',{attrs:{"src":"/static/avatar-conducteur.png","alt":"avatar"}}):_c('img',{attrs:{"src":_vm.conducteurCourant.url,"alt":"avatar"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[(_vm.conducteurCourant.disponibilite === 'Disponible')?_c('v-chip',{attrs:{"color":"green","text-color":"white"}},[_c('v-avatar',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v("\n                    "+_vm._s(_vm.conducteurCourant.disponibilite)+"\n                  ")],1):_vm._e(),_vm._v(" "),(_vm.conducteurCourant.disponibilite === 'En activite')?_c('v-chip',{attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v("\n                    "+_vm._s(_vm.conducteurCourant.disponibilite)+"\n                  ")],1):_vm._e(),_vm._v(" "),(_vm.conducteurCourant.disponibilite === 'Absent')?_c('v-chip',{attrs:{"color":"red","text-color":"white"}},[_c('v-avatar',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v("\n                    "+_vm._s(_vm.conducteurCourant.disponibilite)+"\n                  ")],1):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Matricule : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.matricule))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Nom et prénoms : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.nom)+"\n                "+_vm._s(_vm.conducteurCourant.prenom)+"\n              ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de naissance : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.dateNs)+"\n              ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Lieu de naissance : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.lieuNaiss)+"\n              ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Contacts : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.phone1)+" /\n                "+_vm._s(_vm.conducteurCourant.phone2)+"\n              ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Adresse : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.adresse))])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Fonction : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.fonction))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'embauche : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.dateEmb))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Type de permis : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.typePermis)+"\n              ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Numéro de permis : ")]),_vm._v(" "+_vm._s(_vm.conducteurCourant.numPermis)+"\n              ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de validite du permis : ")]),_vm._v("\n                "+_vm._s(_vm.conducteurCourant.dateVp)+"\n              ")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-tabs',{staticClass:"elevation-2",attrs:{"icons-and-text":"","centered":"","dark":"","color":"primary"},on:{"input":_vm.selectTab}},[_c('v-tabs-slider',{attrs:{"color":"yellow"}}),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-1"}},[_c('v-icon',[_vm._v("airline_seat_recline_normal")]),_vm._v("\n                  Historique\n                ")],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-2"}},[_c('v-icon',[_vm._v("description")]),_vm._v("\n                  En cours\n                ")],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-5"}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("directions_car")]),_vm._v("\n                  Véhicules\n                ")],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-1"}},[_c('v-card',[_c('div',[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                          LISTE DE MISSIONS PASSEES\n                          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("terrain")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listCondMission}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Référence","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vehMat","label":"Véhicule","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                "+_vm._s(scope.row.vehMat)+"\n                                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("directions_car")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateMiss","label":"Date","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateSortie","label":"Date sortie et retour","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                "+_vm._s(scope.row.dateSortie)+" -\n                                "+_vm._s(scope.row.dateEntrePrevue)+"\n                              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"activite","label":"Activité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                                "+_vm._s(scope.row.activite)+"\n                              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.showCondMission(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                  Détails\n                                ")],1)],1)]}}])})],1)],1)],1)])],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-2"}},[_c('v-card',[_c('div',[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                          LISTE DE MISSIONS EN COURS\n                          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("terrain")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listCondMissEnCours}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Référence","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vehMat","label":"Véhicule","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                "+_vm._s(scope.row.vehMat)+"\n                                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("directions_car")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateMiss","label":"Date","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateSortie","label":"Date sortie et retour","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                "+_vm._s(scope.row.dateSortie)+" -\n                                "+_vm._s(scope.row.dateEntrePrevue)+"\n                              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"activite","label":"Activité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                                "+_vm._s(scope.row.activite)+"\n                              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.showCondMission(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                  Détails\n                                ")],1)],1)]}}])})],1)],1)],1)])],1),_vm._v(" "),_c('v-tab-item',{attrs:{"id":"tab-5"}},[_c('v-card',[_c('div',[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                          LISTE DES VEHICULES AFFECTES\n                          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("terrain")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newAttrCondu($event)}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n                            Affecter un vehicule a ce conducteur\n                          ")],1)],1),_vm._v(" "),_c('v-card-text',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listVehiculeAffecte}},[_c('el-table-column',{attrs:{"prop":"parc","label":"Parc","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"matricule","label":"Immatriculation/Marque","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                               "+_vm._s(scope.row.matricule)+" / "+_vm._s(scope.row.marque)+"\n                              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"marque","label":"Modèle / Série"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                                  "+_vm._s(scope.row.modele)+" / "+_vm._s(scope.row.serie)+"\n                                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){return _vm.deleteVehiCondu(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                                  Supprimer\n                                ")],1)],1)]}}])})],1)],1)],1)])],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogFicheCond = false}}},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cette intervention ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteIntervention($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprMarq),callback:function ($$v) {_vm.dialogSuprMarq=$$v},expression:"dialogSuprMarq"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer cette marque ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprMarq = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteMarq($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprModel),callback:function ($$v) {_vm.dialogSuprModel=$$v},expression:"dialogSuprModel"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer ce modele ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprModel = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteModel($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprSeri),callback:function ($$v) {_vm.dialogSuprSeri=$$v},expression:"dialogSuprSeri"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer cette serie ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprSeri = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteSeri($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprCond),callback:function ($$v) {_vm.dialogSuprCond=$$v},expression:"dialogSuprCond"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer ce conducteur ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprCond = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteConducteur($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprClientLocation),callback:function ($$v) {_vm.dialogSuprClientLocation=$$v},expression:"dialogSuprClientLocation"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cette location client ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprClientLocation = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteClientLocation($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprAssu),callback:function ($$v) {_vm.dialogSuprAssu=$$v},expression:"dialogSuprAssu"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cette assurance ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprAssu = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteAssu($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprVign),callback:function ($$v) {_vm.dialogSuprVign=$$v},expression:"dialogSuprVign"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cette vidange ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprVign = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteVign($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprVisit),callback:function ($$v) {_vm.dialogSuprVisit=$$v},expression:"dialogSuprVisit"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cette visite technique ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprVisit = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteVisit($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuppCarburant),callback:function ($$v) {_vm.dialogSuppCarburant=$$v},expression:"dialogSuppCarburant"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-xs-center"},[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Supprimer une consommation")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"outline":"","color":"orange darken-1","icon":"warning","value":true}},[_vm._v("\n            La suppression d'une consommation est irréversible.\n          ")])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{on:{"click":function($event){$event.stopPropagation();_vm.dialogSuppCarburant = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteCarburant()}}},[_vm._v("Supprimer\n        ")])],1)],1)],1),_vm._v(" "),_c('ModalTarifLocation',{attrs:{"show":_vm.showModalTarif},on:{"close":function($event){_vm.showModalTarif = false}}}),_vm._v(" "),_c('ModalCalendContrat',{attrs:{"show":_vm.showModalCalendContrat},on:{"close":function($event){_vm.showModalCalendContrat = false}}}),_vm._v(" "),_c('InterventionIndex',{attrs:{"show":_vm.showModalInterv},on:{"close":function($event){_vm.showModalInterv = false}}}),_vm._v(" "),_c('CarteCarburantIndex',{attrs:{"show":_vm.showDialogCarcurant},on:{"close":function($event){_vm.showDialogCarcurant = false}}}),_vm._v(" "),_c('BesoinTravaux',{attrs:{"show":_vm.showModalBesoin},on:{"close":function($event){_vm.showModalBesoin = false}}}),_vm._v(" "),_c('loadConducteurExcel',{attrs:{"show":_vm.showModalLoadConducteur,"listeConducteur":_vm.lstConducteur},on:{"close":function($event){_vm.showModalLoadConducteur = false;
      _vm.loadConducteur();}}}),_vm._v(" "),_c('ModalValidationDmdFond',{attrs:{"valider":false,"demandeDetail":_vm.demandeDetailFond,"logistique":true,"show":_vm.showModalDetailDmdFond},on:{"close":_vm.showDialogDmdFondAfter}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pt3C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_divers_loadTypeTaches_vue__ = __webpack_require__("F7Wq");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "formTypeTache",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */], LoadTypeTachesExcel: __WEBPACK_IMPORTED_MODULE_2__components_divers_loadTypeTaches_vue__["a" /* default */] },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    listeLotTache: {
      type: Array,
      default: new Array()
    },
    idTypeTravaux: {
      type: Number,
      default: null
    },
    etatTache: {
      type: String,
      default: "aucun"
    },
    typeProjetTab: {
      type: Array,
      default: new Array()
    },
    libelleTacheSelect: {
      type: String,
      default: null
    },
    libelleChantier: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      loading: false,
      dialogAjoutTache: false,
      typeProjet: "",
      typeSelectTravaux: "",
      listeTaches: [],
      listTravauxTab: [],
      formLotTache: {
        idTypeTache: null,
        ordre: "",
        libelle: "",
        unite: "",
        prix: 1,
        description: ""
      },
      rulesLotTache: {
        ordre: [{
          required: true,
          message: "Veuillez selectionnez un numéro d'ordre",
          trigger: "blur"
        }],
        libelle: [{
          required: true,
          message: "Veuillez  saisir un type de tache",
          trigger: "blur"
        }],
        unite: [{
          required: true,
          message: "Veuillez  saisir une unite",
          trigger: "blur"
        }],
        prix: [{
          required: true,
          message: "Veuillez  saisir un prix unitaire",
          trigger: "blur"
        }]
      },
      numOrdre: [],
      numOrdreCopie: [],
      listeTacheSupp: [],

      showModalLoadTypeTravaux: false,
      //Importer fichier excel
      fileExcel: [],
      lstTypeTravaux: []
    };
  },

  watch: {
    show: function show(newValue, oldValue) {
      var _this = this;

      if (newValue == true) {
        this.listeTaches.splice(0);
        this.numOrdre.splice(0);
        this.dialogAjoutTache = true;
        this.numOrdre.push({ num: 1 });
        if (this.listeLotTache.length > 0) {
          this.numOrdre.splice(0);
          //rechechons lordre le plus eleve
          var ordreSup = null;
          this.listeLotTache.forEach(function (elt, ind) {
            if (ind + 1 < _this.listeLotTache.length) {
              var prochainOrdre = _this.listeLotTache[ind + 1].ordre;
              if (prochainOrdre > elt.ordre) {
                ordreSup = prochainOrdre;
              } else {
                ordreSup = elt.ordre;
              }
            }
          });

          this.listeTaches = this.listeLotTache.slice();

          this.numOrdreCopie.splice(0);
          var nbLots = this.listeLotTache.length;
          this.numOrdre.push({ num: ordreSup + 1 });

          if (this.listeTaches.length == 1) {
            this.numOrdre.push({ num: 2 });
          }

          for (var i = 0; i <= nbLots; i++) {
            this.numOrdreCopie.push({ num: i + 1 });
          }
        }
      } else {
        this.dialogAjoutTache = false;
      }
    }
  },
  computed: {
    listeNumber: function listeNumber() {
      var _this2 = this;

      var listeNum = this.numOrdreCopie.slice();
      return listeNum.filter(function (elt) {
        if (elt.num <= _this2.listeTaches.length) {
          return elt;
        }
      });
    }
  },
  methods: {
    changeOrdre: function changeOrdre(value, ind) {},
    submitDupTache: function submitDupTache() {
      var _this3 = this;

      if (this.typeSelectTravaux == null) {
        this.$message.error("Aucun travaux selectionné");
        return;
      }
      this.loading = true;
      var url = this.domaine + "projet/new/duplicate/tache/projet";

      //recuperer les uniquement les lots de travaux
      var nbData = 1;
      if (this.listeTaches.length > 10) {
        nbData = 10;
      }

      var nbReq = Math.round(this.listeTaches.length / nbData);
      var nbRest = this.listeTaches.length % nbData;
      if (nbRest > 0) {
        nbReq += 1;
      }

      if (nbReq == 0 && this.listeTacheSupp.length > 0) {
        nbReq = 1;
      }

      bloc_1: {
        var _loop = function _loop(i) {
          var initJ = i * nbData;
          var finJ = (i + 1) * nbData;
          var dataLot = [];
          dataLot.splice(0);
          if (_this3.listeTaches.length > 0) {
            for (var j = initJ; j < finJ; j++) {
              if (_this3.listeTaches[j] == undefined) {
                break;
              }
              dataLot.push(_this3.listeTaches[j]);
            }
          }

          if (dataLot.length == 0 && _this3.listeTacheSupp.length == 0) {
            return "break|bloc_1";
          }
          var data = new FormData();

          var ligne = null;
          for (var prop in dataLot) {
            ligne = dataLot[prop];
            data.append("option[ordre][]", ligne.ordre);
            data.append("option[unite][]", ligne.unite);
            data.append("option[libelle][]", ligne.libelle);
            data.append("option[prix][]", ligne.prix);
            data.append("option[idTypeTache][]", ligne.idTypeTache);
            data.append("option[description][]", ligne.description);
          }

          data.append("type", _this3.typeSelectTravaux);
          data.append("idUser", _this3.user.id);
          // data.append("lots", JSON.stringify(dataLot));
          data.append("listeSupp", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.listeTacheSupp));
          data.append("etatTache", _this3.etatTache);

          _this3.$http.post(url, data).then(function (response) {
            if (response.body.code == 1 && i == nbReq - 1) {
              _this3.$notify({
                title: "Suppression travaux",
                duration: 10000,
                message: response.body.message + response.body.lstTacheNonSupp,
                type: "warning"
              });
            }

            _this3.$notify({
              title: "ENREGISTREMENT REUSSI",
              message: "Lot enregistré avec succès.",
              type: "success",
              position: "top-center"
            });
          }, function (response) {
            _this3.$message.error("Erreur lors de l'enregistrement des lots de travaux");
            _this3.loading = false;
          });
        };

        for (var i = 0; i < nbReq; i++) {
          var _ret = _loop(i);

          if (_ret === "break|bloc_1") break bloc_1;
        }
      }

      this.loading = false;
      this.closeForm();
    },
    closeForm: function closeForm() {
      this.$emit("close");
      this.resetForm();
      this.typeProjet = "";
      this.typeSelectTravaux = "";
    },
    deleteRow: function deleteRow(index, rows) {
      var ordreIndex = this.listeTaches[index].ordre;
      var indexpos = this.numOrdre.findIndex(function (elt) {
        return elt.num > ordreIndex;
      });
      var indexposCopie = this.numOrdreCopie.findIndex(function (elt) {
        return elt.num == ordreIndex;
      });

      this.numOrdre.splice(indexpos, 0, { num: ordreIndex });
      this.numOrdreCopie.splice(indexposCopie, 1);

      //enregistrer lid du lot de travaux supprimer dans la liste
      if (this.listeTaches[index].idTypeTache != null) {
        this.listeTacheSupp.push(this.listeTaches[index].idTypeTache);
      }

      rows.splice(index, 1);
      if (this.listeTaches.length <= 0) {
        this.numOrdre.splice(0);
        this.numOrdreCopie.splice(0);

        this.numOrdre.push({ num: 1 });
        this.numOrdreCopie.push({ num: 1 });
      }
    },
    handleFileExcel: function handleFileExcel(command //0=>Importer,1=>generer
    ) {
      switch (command) {
        case "0":
          //importer un fichier
          this.$refs.fileInputExcel.click();
          break;
        case "1":
          //generer un modele un fichier
          this.generateFileExcel();
          break;
      }
    },
    generateFileExcel: function generateFileExcel() {
      var url = this.domaine + "projet/generer/modele/travaux/taches";
      window.open(url);
    },
    onFileExcelPicked: function onFileExcelPicked(event) {
      var _this4 = this;

      this.fileExcel.splice(0, 1);
      var files = event.target.files;
      var filename = files[0].name;

      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this4.fileExcel.push(fileReader.result);
      });

      fileReader.readAsDataURL(files[0]);

      var url = this.domaine + "tache/load_Travaux_tache/excel";
      var data = new FormData();
      //emvoie du fichier

      data.append("fichierExcel", files[0], files[0][name]);
      this.closeForm();
      this.$http.post(url, data).then(function (resp) {
        _this4.loading = false;

        _this4.$notify({
          title: "Chargement liste type travaux",
          message: "Chargement effectué",
          type: "success",
          position: "top-right",
          duration: 7000
        });
        _this4.lstTypeTravaux = resp.body.listeTypeTravaux;
        _this4.showModalLoadTypeTravaux = true;
      }, function (resp) {
        _this4.loading = false;
        _this4.$message.error("Erreur lors de l'importation du fichier");
      });
    },
    addListTypeTache: function addListTypeTache() {
      var _this5 = this;

      this.$refs["formLotTache"].validate(function (valid) {
        if (valid) {
          var lenListelot = _this5.listeTaches.length;
          var indiceInsert = _this5.formLotTache.ordre - 1;
          _this5.listeTaches.splice(indiceInsert, 0, {
            idTypeTache: _this5.formLotTache.idTypeTache,
            libelle: _this5.formLotTache.libelle,
            unite: _this5.formLotTache.unite,
            prix: _this5.formLotTache.prix,
            ordre: _this5.formLotTache.ordre,
            description: _this5.formLotTache.description
          });
          var index = _this5.numOrdre.findIndex(function (elt) {
            return elt.num == _this5.formLotTache.ordre;
          });
          var dernierChif = _this5.numOrdre[_this5.numOrdre.length - 1].num;

          _this5.numOrdre.splice(index, 1);

          _this5.numOrdre.push({ num: dernierChif + 1 });
          _this5.resetForm();
        }
      });
    },
    loadTrvBytype: function loadTrvBytype(item) {
      var _this6 = this;

      this.loading = true;
      var url = this.domaine + "projet/travauxSelect/" + item;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this6.loading = false;
          _this6.listTravauxTab = response.body.detailtravaux;
        }
      }, function (response) {
        _this6.$message.error("Erreur lors de l'enregistrement des lots de travaux");
        _this6.loading = false;
      });
    },
    resetForm: function resetForm() {
      this.$refs["formLotTache"].resetFields();
      this.formLotTache.libelle = "";
      this.formLotTache.unite = "";
      this.formLotTache.prix = 1;
      this.formLotTache.description = "";
      this.listeTacheSupp.splice(0);
    }
  }
});

/***/ }),

/***/ "Px8Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogFormEditUser),callback:function ($$v) {_vm.dialogFormEditUser=$$v},expression:"dialogFormEditUser"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Modification des informations personnelles")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogFormEditUser = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enregistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-form',{ref:"formUserUp",attrs:{"lazy-validation":"","id":"formUserUp"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('div',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm4":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoUser,"alt":"avatar"}})]),_c('br'),_vm._v(" "),_c('input',{ref:"fileLogo",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileLogo.click()}}},[_vm._v("Photo  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1)],1)])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-col',[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Matricule","name":"matricule"},model:{value:(_vm.formUserUp.matricule),callback:function ($$v) {_vm.$set(_vm.formUserUp, "matricule", $$v)},expression:"formUserUp.matricule"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Nom et prénoms","name":"nom","required":""},model:{value:(_vm.formUserUp.nom),callback:function ($$v) {_vm.$set(_vm.formUserUp, "nom", $$v)},expression:"formUserUp.nom"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"label":"Genre","name":"sexe","items":_vm.listCivilie,"item-value":"value","item-text":"text"},model:{value:(_vm.formUserUp.sexe),callback:function ($$v) {_vm.$set(_vm.formUserUp, "sexe", $$v)},expression:"formUserUp.sexe"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-3",attrs:{"md4":""}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"id":"dateNaiss","name":"dateNaiss","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de naissance"},model:{value:(_vm.formUserUp.dateNaiss),callback:function ($$v) {_vm.$set(_vm.formUserUp, "dateNaiss", $$v)},expression:"formUserUp.dateNaiss"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Matricule CNPS","name":"numCnps","item-value":"id","item-text":"libelle"},model:{value:(_vm.formUserUp.numCnps),callback:function ($$v) {_vm.$set(_vm.formUserUp, "numCnps", $$v)},expression:"formUserUp.numCnps"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Fonction occupé","name":"fonction"},model:{value:(_vm.formUserUp.fonction),callback:function ($$v) {_vm.$set(_vm.formUserUp, "fonction", $$v)},expression:"formUserUp.fonction"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"name":"phone","min":"0","label":"Contact","counter":10,"hint":"Exemple: 0900000055","persistent-hint":"","required":""},model:{value:(_vm.formUserUp.phone),callback:function ($$v) {_vm.$set(_vm.formUserUp, "phone", $$v)},expression:"formUserUp.phone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Adresse","name":"adresse"},model:{value:(_vm.formUserUp.adresse),callback:function ($$v) {_vm.$set(_vm.formUserUp, "adresse", $$v)},expression:"formUserUp.adresse"}})],1)],1),_vm._v(" "),(_vm.droitAcces.new_contrat_employe)?_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"label":"Type d'utilisateur","name":"selectTypeUser","items":_vm.typeUser,"item-value":"value","item-text":"text"},model:{value:(_vm.selectTypeUser),callback:function ($$v) {_vm.selectTypeUser=$$v},expression:"selectTypeUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"label":"Services","name":"serviceUser","items":_vm.listeServices,"item-value":"id","item-text":"libelle"},model:{value:(_vm.selectServiceUser),callback:function ($$v) {_vm.selectServiceUser=$$v},expression:"selectServiceUser"}})],1)],1):_vm._e()],1)],1)])],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"grid-content bg-purple"},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_vm._v("\n                    NB: taille 95 x 300\n                      "),_c('br'),_vm._v(" "),_c('img',{staticStyle:{"height":"95px","width":"300px"},attrs:{"src":_vm.signUser,"alt":"avatar"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{ref:"fileSign",staticStyle:{"display":"none"},attrs:{"name":"signature","type":"file","accept":"image/*"},on:{"change":_vm.onFileSignLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileSign.click()}}},[_vm._v("Signature  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1)],1)])],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md12":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"error","dark":""},on:{"click":function($event){_vm.dialogFormEditUser = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submitForm}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QBHE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: "ListeWorklogPorjet",
  props: {
    show: {
      type: Boolean
    },
    idProjet: {
      type: Number
    },
    listeWorklog: {
      type: Array
    },
    listeWorktrx: {
      type: Array
    },
    listeTacheWorktrx: {
      type: Array
    },
    listeWorktrx2: {
      type: Array
    },
    totalHeuretrx: 0,
    totalmintrx: 0,
    totalactivitetrx: 0
  },

  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      formWork: {
        libelle: "",
        tempsmis: "",
        description: "",
        dateAdd: "",
        file: null
        // urlImage: "/static/doc.png"
      },
      formActivite: {},
      checked: false,
      tableTaches: [],
      tableTachesAffICh: [],
      typeLivraison: [{ text: "En attente", value: 1 }, { text: "En cours", value: 2 }, { text: "Terminée", value: 3 }],
      //FILTRE
      listeProjet: [],
      multipleSelection: [],
      listeChantier: [],
      listeWork: [],
      BesoinsList: [],
      projetS: '',
      logo: '',
      logoWorkProj: "/static/img-doc.png",
      chantierS: '',
      formTaches: {},
      selectTypeLivraison: "",
      editForm: false,
      dialogSupr: false,
      newVersion: true,
      dialogShowWorklog: false,
      dialogShowArticle: false,
      dialogSuprActivite: false,
      docSelect: {},
      ActiviteSelect: {},
      worklogCourant: {},
      Worklog: {},
      dialogWork: false,
      dialogActivite: false
    };
  },


  watch: {
    show: function show(newValue, oldvalue) {
      if (newValue == true) {
        this.loadWork(idProjet);
      }
    },
    listeWorktrx: function listeWorktrx(newValue, oldvalue) {
      this.listeWork = this.listeWorktrx;
    }
  },

  methods: {
    //FILTRE
    loadProjet: function loadProjet() {
      var _this = this;

      this.listeChantier.splice(0);
      this.chantierS = null;
      var url = this.domaine + 'projet/index/projet/all';
      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this.loading = false;
        _this.listeProjet = response.body.projet;
      }, function (errRep) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    loadChantier: function loadChantier() {
      var _this2 = this;

      if (this.projetS == null || this.projetS == "undefined" || this.projetS == "") {
        this.BesoinsList = this.listeBesoins;
        return;
      }
      this.loading = true;
      var url = this.domaine + 'projet/' + this.projetS + '/index/chantier';
      this.$http.get(url).then(function (response) {
        _this2.loading = false;
        _this2.listeChantier = response.body.chantier;
      }, function (errRep) {
        _this2.loading = false;
        _this2.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    filtrerChantier: function filtrerChantier() {
      var idChant = this.chantierS;
      this.listeWork = this.listeWorktrx.filter(function (item) {
        return item.idChant == idChant;
      });
    },
    clearSelect: function clearSelect() {
      this.projetS = '';
      this.chantierS = '';
      this.listeChantier.splice(0);
    },
    showDialogSuppActivite: function showDialogSuppActivite(item) {
      this.ActiviteSelect = item;
      this.dialogSuprActivite = true;
    },
    showDilogSupp: function showDilogSupp(item) {
      this.docSelect = item;
      this.dialogSupr = true;
    },
    deleteRow: function deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    showDialogWorklogDetail: function showDialogWorklogDetail(item) {
      this.dialogShowWorklog = true;
      this.worklogCourant = item;
    },
    showDialogActiviteEdit: function showDialogActiviteEdit(item) {
      this.dialogActivite = true;
      this.newVersion = false;
      this.formActivite = item;
      this.Worklog = item;
    },
    imprimeMatricePDF: function imprimeMatricePDF() {
      var url = this.domaine + 'worklogs/' + this.idProjet + '/imprimer_worklogProjet_pdf/' + this.user.id;
      window.open(url);
    },
    deleteActivite: function deleteActivite(formNameWork) {
      var _this3 = this;

      this.loading = true;
      var form = document.getElementById("formActivite");
      var data = new FormData(form);
      var url = this.domaine + "tacheworklog/delete/activite/" + this.ActiviteSelect.worklog;
      data.append("ActiviteSelect", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.ActiviteSelect));

      this.$http.post(url, data).then(function (response) {
        _this3.loading = false;
        _this3.loadWork();

        _this3.$notify({
          title: "SUPPRESSION",
          message: "Activitée supprimé avec succès.",
          type: "success",
          position: "top-center"
        });
        _this3.dialogSuprActivite = false;
      }, function (errRep) {
        _this3.loading = false;
        _this3.dialogSuprActivite = false;
        _this3.$notify.error({
          title: "SUPPRESSION ECHOUEE",
          message: "La suppression du worklog a échouée.",
          position: "top-center"
        });
      });
    },
    editTache: function editTache(formNameWork) {
      var _this4 = this;

      // this.editForm = false;
      this.$refs[formNameWork].validate(function (valid) {
        if (valid) {
          _this4.loading = true;
          var form = document.getElementById("formActivite");
          var data = new FormData(form);
          var url = _this4.domaine + "tacheworklog/edit/taches/" + _this4.Worklog.worklog;
          data.append("statut", _this4.formActivite.statut);
          data.append("worklog", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this4.Worklog));
          data.append("libelle", _this4.formActivite.libelle);
          data.append("commentaire", _this4.formActivite.commentaire);

          data.append("userId", _this4.user.id);
          data.append("idProjet", _this4.idProjet);
          _this4.loading = false;
          _this4.dialogActivite = false;
          _this4.$http.post(url, data).then(function (resp) {
            _this4.loading = false;
            _this4.resetForm("formWork");
            _this4.dialogActivite = false;
            _this4.loadWork();
            _this4.successNotif(resp.body.message);
          }, function (error) {
            _this4.loading = false;
            //this.resetForm('formWork');
            _this4.$message.error("Une erreur est survenue lors de l'enregistrement du document");
          });
        }
      });
    },

    //enregistrement des images
    onFileImageLogoPicked: function onFileImageLogoPicked(event) {
      var _this5 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this5.logoWorkProj = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoWorkProj = files[0];
    },
    showAddActivite: function showAddActivite(item) {
      this.newVersion = true;
      this.dialogActivite = true;
      this.Worklog = item;
      this.formActivite = {}, this.tableTaches = [], this.resetForm();
    },
    modifTacheEtat: function modifTacheEtat(item) {
      var _this6 = this;

      var form = document.getElementById("formWork");
      var data = new FormData(form);

      var url = this.domaine + "tacheworklog/edit/" + this.Worklog.id;
      data.append("userId", this.user.id);
      data.append("tachesTAB", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableTaches));
      data.append("formTaches", this.formTaches);
      data.append("idProjet", this.idProjet);
      this.loading = false;

      this.$http.post(url, data).then(function (resp) {
        _this6.loading = false;
        _this6.loadWork();
        _this6.successNotif(resp.body.message);
      }, function (error) {
        _this6.loading = false;
        //this.resetForm('formWork');
        _this6.$message.error("Une erreur est survenue lors de l'enregistrement du document");
      });
    },
    addListTaches: function addListTaches(item) {
      this.tableTaches.push({
        libelle: item.libelle,
        statut: item.statut,
        date: item.date,
        commentaire: item.commentaire

      });
      this.formActivite = {};
    },
    loadWork: function loadWork(idProjet) {
      var _this7 = this;

      this.loading = true;
      this.docSelect = null;
      var url = this.domaine + "worklogs/projet/" + this.idProjet;
      this.$http.get(url).then(function (response) {

        _this7.listeWorktrx = response.body.listeWorklog;
        _this7.listeTacheWorktrx = response.body.listTacheeWorklog;
        _this7.totalHeuretrx = response.body.totalheure;
        _this7.totalmintrx = response.body.totalMinutes;
        _this7.totalactivitetrx = response.body.totalActivite;

        _this7.loading = false;
      }, function (response) {
        _this7.loading = false;
      });
    },
    showAjoutWork: function showAjoutWork() {

      this.editForm = false;
      this.formWork = {};
      this.logo = '';
      this.logoWorkProj = "/static/img-doc.png";

      // document.imageWorklog.reset();

      // document.getElementById("upload").value = '';
      // this.$refs.upload.reset();
      this.resetForm('formWork');
      this.dialogWork = true;
      this.newVersion = true;
    },
    addWork: function addWork(formNameWork) {
      var _this8 = this;

      this.editForm = false;
      this.$refs[formNameWork].validate(function (valid) {
        if (valid) {
          _this8.loading = true;
          var form = document.getElementById("formWork");
          var data = new FormData(form);
          var url = _this8.domaine + "worklogs/create/projet";

          data.append("userId", _this8.user.id);
          data.append("tachesTAB", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this8.tableTaches));
          data.append("idProjet", _this8.idProjet);
          _this8.loading = false;

          _this8.$http.post(url, data).then(function (resp) {
            _this8.editForm = false;
            _this8.loading = false;
            _this8.resetForm("formWork");
            _this8.resetForm("formTaches");

            _this8.loadWork();
            _this8.dialogWork = false;
            _this8.successNotif(resp.body.message);
          }, function (error) {
            _this8.loading = false;
            _this8.dialogWork = false;
            //this.resetForm('formWork');
            _this8.$message.error("Une erreur est survenue lors de l'enregistrement du document");
          });
        }
      });
    },
    addActivite: function addActivite(formNameWork) {
      var _this9 = this;

      this.editForm = false;
      this.$refs[formNameWork].validate(function (valid) {
        if (valid) {
          _this9.loading = true;
          var form = document.getElementById("formWork");
          var data = new FormData(form);
          var url = _this9.domaine + "tacheworklog/create";

          data.append("userId", _this9.user.id);
          data.append("tachesTAB", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this9.tableTaches));
          data.append("idProjet", _this9.idProjet);
          data.append("idworklog", _this9.Worklog.id);

          _this9.$http.post(url, data).then(function (resp) {
            _this9.loading = false;
            _this9.resetForm("formActivite");
            _this9.resetForm("tableTaches");
            _this9.dialogActivite = false;
            _this9.loadWork();
            _this9.successNotif(resp.body.message);
          }, function (error) {
            _this9.loading = false;
            //this.resetForm('formWork');
            _this9.$message.error("Une erreur est survenue lors de l'enregistrement du document");
          });
        }
      });
    },
    showEditWork: function showEditWork(item) {
      this.docSelect = item;
      // this.editForm = true;
      this.formWork = item;
      this.tableTaches = item;
      this.newVersion = false;
      this.editForm = false;
      this.logoWorkProj = item.url;
      // this.resetForm();
      this.dialogWork = true;
    },
    editWork: function editWork(formNameWork) {
      var _this10 = this;

      // this.editForm = false;
      this.$refs[formNameWork].validate(function (valid) {
        if (valid) {
          _this10.loading = true;
          var form = document.getElementById("formWork");
          var data = new FormData(form);
          var url = _this10.domaine + "worklogs/edit/projet/" + _this10.docSelect.id;
          data.append("tachesTAB", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this10.tableTaches));
          data.append("userId", _this10.user.id);
          data.append("idProjet", _this10.idProjet);
          _this10.loading = false;
          _this10.dialogWork = false;
          _this10.$http.post(url, data).then(function (resp) {
            _this10.loading = false;
            _this10.resetForm("formWork");
            _this10.dialogWork = false;
            _this10.loadWork();
            _this10.successNotif(resp.body.message);
          }, function (error) {
            _this10.loading = false;
            _this10.dialogWork = false;
            _this10.resetForm('formWork');
            _this10.$message.error("Une erreur est survenue lors de l'enregistrement du document");
          });
        }
      });
    },
    deleteDoc: function deleteDoc() {
      var _this11 = this;

      this.loading = true;
      var url = this.domaine + "worklogs/delete/" + this.docSelect.id;
      this.$http.get(url).then(function (response) {
        _this11.loading = false;
        _this11.loadWork();

        _this11.$notify({
          title: "SUPPRESSION",
          message: "Worklog supprimé avec succès.",
          type: "success",
          position: "top-center"
        });
        _this11.dialogSupr = false;
      }, function (errRep) {
        _this11.loading = false;
        _this11.dialogSupr = false;
        _this11.$notify.error({
          title: "SUPPRESSION ECHOUEE",
          message: "La suppression du worklog a échouée.",
          position: "top-center"
        });
      });
    },
    successNotif: function successNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Worklog enregistré avec succès";
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";

      this.$notify({
        title: "ENREGISTREMENT DOCUMENT",
        message: mess,
        type: type,
        position: "top-center",
        duration: 10000
      });
    },
    resetForm: function resetForm(formNameWork) {
      this.formWork = [];
      this.tableTaches = [];
      this.logoWorkProj = "/static/img-doc.png";
      this.file = null;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.disabledBtnValide = true;
      } else {
        this.disabledBtnValide = false;
      }
    },
    onFileImagePicked: function onFileImagePicked(event) {
      var _this12 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 10485760) {
        this.$message.error("La taille du fichier est supérieur à 10M");
        return;
      }
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this12.formWork.urlImage = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.formWork.file = files[0];
    }
  },

  mounted: function mounted() {
    // this.loadProjet();
    this.loadChantier();
    this.clearSelect();
  }
});

/***/ }),

/***/ "QDYu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"divider":"/"}},_vm._l((_vm.items),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('div',[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick1(_vm.tab1)}},model:{value:(_vm.tab1),callback:function ($$v) {_vm.tab1=$$v},expression:"tab1"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" PLAN COMPTABLE\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('input',{ref:"fileInputExcel",staticStyle:{"display":"none"},attrs:{"name":"fileInputExcel","type":"file","accept":"image/*"},on:{"change":_vm.onFileExcelPicked}}),_vm._v(" "),(true)?_c('v-btn',{attrs:{"slot":"activator","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$refs.fileInputExcel.click()}},slot:"activator"},[_vm._v("\n              Importer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_download")])],1):_vm._e(),_vm._v("Importer fichier excel\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.generateFileExcel()}},slot:"activator"},[_vm._v("\n              Générer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1):_vm._e(),_vm._v("Générer un modèle\n          ")],1)],1),_vm._v(" "),_c('data-tables',{attrs:{"data":_vm.listPlanComptable}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Liste des comptes ")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2 mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"grid-content"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"row-class-name":_vm.tableRowClassName,"data":props.row.comptes,"stripe":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [(prop.row.sous_comptes.length > 0)?_c('div',[_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Liste des sous comptes")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2 mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"grid-content"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"row-class-name":_vm.tableRowClassName,"data":prop.row.sous_comptes,"stripe":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.comptes_auxiliaires.length > 0)?_c('div',[_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Liste des comptes auxiliaires")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2 mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"grid-content"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"row-class-name":_vm.tableRowClassName,"data":props.row.comptes_auxiliaires,"stripe":""}},[_c('el-table-column',{attrs:{"prop":"code","label":"Numéro de compte","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(scope.row.code)+"\n                                                                                  ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"green--text subheading"},[_vm._v(_vm._s(scope
                                                                                        .row
                                                                                        .libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.editType(
                                                                                            scope.row
                                                                                          )}},slot:"activator"},[_vm._v("\n                                                                                      Modifier\n                                                                                      ")]),_vm._v("\n                                                                                      Modifier\n                                                                                    ")],1)],1)]}}],null,true)})],1)],1)],1)],1)],1)])],1)],1)],1)],1):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"code","label":"Numéro de compte","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(scope.row.code)+"\n                                                            ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"green--text subheading"},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.newTache(
                                                                      scope.row,
                                                                      'niveau'
                                                                    )}},slot:"activator"},[_vm._v("\n                                                                  Ajouter\n                                                                ")]),_vm._v("\n                                                                Ajouter/Modifier\n                                                                un lot de tache\n                                                              ")],1)],1),_vm._v(" "),(
                                                                scope.row
                                                                  .nbSous === 0
                                                              )?_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.duplicateTaches(
                                                                      scope.row,
                                                                      props.row
                                                                    )}},slot:"activator"},[_vm._v("\n                                                                  Dupliquer\n                                                                ")]),_vm._v("\n                                                                Dupliquer les\n                                                                tâches\n                                                              ")],1)],1):_vm._e()]}}],null,true)})],1)],1)],1)],1)],1)])],1)],1)],1)],1):_c('div',[_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Liste des comptes auxilaires\n                                          ")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2 mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"grid-content"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"row-class-name":_vm.tableRowClassName,"data":props.row.listeTypeTache,"stripe":""}},[_c('el-table-column',{attrs:{"prop":"ordre","label":"Ordre","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(scope.row.ordre))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"green--text subheading"},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"unite"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(scope.row.unite))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"prix (FCFA)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(new Intl.NumberFormat(
                                                                  "fr-FR"
                                                                ).format(
                                                                  scope.row.prix
                                                                )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showTravaux(
                                                                      scope.row
                                                                    )}},slot:"activator"},[_vm._v("\n                                                                  Détails\n                                                                ")]),_vm._v("\n                                                                Détails\n                                                              ")],1)],1)]}}],null,true)})],1)],1)],1)],1)],1)])],1)],1)],1)],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"code","label":"Numéro du compte"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(scope.row.code))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"green--text subheading"},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(
                                        scope.row.comptes == 0 &&
                                          scope.row.comptes.length == 0 
                                      )?_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.newNiveau(scope.row)}},slot:"activator"},[_vm._v("\n                                          Ajouter un niveau\n                                        ")]),_vm._v("\n                                        Ajouter/Editer un niveau\n                                      ")],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.show_travaux)?_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showTravaux(scope.row)}},slot:"activator"},[_vm._v("\n                                          Détails\n                                        ")]):_vm._e(),_vm._v("\n                                        Détails\n                                      ")],1)],1),_vm._v(" "),(scope.row.nbSous > 0)?_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.newNiveau(scope.row)}},slot:"activator"},[_vm._v("\n                                          Editer\n                                        ")]),_vm._v("\n                                        Ajouter/Editer la sous section\n                                      ")],1)],1):_vm._e(),_vm._v(" "),(scope.row.nbSous == 0)?_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.newTache(scope.row)}},slot:"activator"},[_vm._v("\n                                          Ajouter\n                                        ")]),_vm._v("\n                                        Ajouter/Modifier un lot de tache\n                                      ")],1)],1):_vm._e(),_vm._v(" "),(scope.row.nbSous == 0)?_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.duplicateTaches(scope.row, props.row)}},slot:"activator"},[_vm._v("\n                                          Dupliquer\n                                        ")]),_vm._v("\n                                        Dupliquer les tâches\n                                      ")],1)],1):_vm._e()]}}],null,true)})],1)],1)],1)],1)],1)])],1)],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"code","label":"Numéro de la classe","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"orange--text title"},[_vm._v(_vm._s(scope.row.code))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{staticClass:"body-2"},[_vm._v("\n                "+_vm._s(scope.row.libelle)+"\n              ")])]}}])})],1)],1)],1)],1)]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprCategorie),callback:function ($$v) {_vm.dialogSuprCategorie=$$v},expression:"dialogSuprCategorie"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cette categorie ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprCategorie = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteCategory($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupTarif),callback:function ($$v) {_vm.dialogSupTarif=$$v},expression:"dialogSupTarif"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h1',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer \""+_vm._s(_vm.selectProduit)+"\" de la\n          tarification chez "+_vm._s(_vm.tarifCourant.fourn)+" ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupTarif = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteTarification($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutTache),callback:function ($$v) {_vm.dialogAjoutTache=$$v},expression:"dialogAjoutTache"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit !== true)?_c('span',[_vm._v("Ajouter une nouvelle tâche ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modifier la tâche "+_vm._s(_vm.tacheCourant.libelle)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutTache = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('v-form',{ref:"formTache",attrs:{"lazy-validation":"","id":"formTache"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de projet ")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Type de projet"},on:{"change":function($event){return _vm.loadTravaux()}},model:{value:(_vm.typeProjet),callback:function ($$v) {_vm.typeProjet=$$v},expression:"typeProjet"}},_vm._l((_vm.listTypeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Travaux"},model:{value:(_vm.travaux),callback:function ($$v) {_vm.travaux=$$v},expression:"travaux"}},_vm._l((_vm.listTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md11":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                    AJOUTER LES LIGNES DES TACHES\n                  ")])],1)])],1):_vm._e(),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formTache}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Libellé tâche*")]),_vm._v(" "),_c('el-input',{staticClass:"upper",staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Libellé tâche"},model:{value:(_vm.formTache.libelle),callback:function ($$v) {_vm.$set(_vm.formTache, "libelle", $$v)},expression:"formTache.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ordre d'éxécution")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","value":1,"id":"ordreTache","name":"ordre","min":1,"placeholder":"Ordre"},model:{value:(_vm.formTache.ordre),callback:function ($$v) {_vm.$set(_vm.formTache, "ordre", $$v)},expression:"formTache.ordre"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unite ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"unite","placeholder":"Unite"},model:{value:(_vm.formTache.unite),callback:function ($$v) {_vm.$set(_vm.formTache, "unite", $$v)},expression:"formTache.unite"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix unitaire HT ")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":0,"name":"prix","placeholder":"prix unitaire"},model:{value:(_vm.formTache.prix),callback:function ($$v) {_vm.$set(_vm.formTache, "prix", $$v)},expression:"formTache.prix"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"description","placeholder":"Description"},model:{value:(_vm.formTache.description),callback:function ($$v) {_vm.$set(_vm.formTache, "description", $$v)},expression:"formTache.description"}})],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}})],1),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-btn',{attrs:{"icons":"","color":"primary","id":"plus","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addListTaches(_vm.formTache)}}},[_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableTaches}},[_vm._l((_vm.taches),function(column){return _c('el-table-column',{key:column.id,attrs:{"prop":column.prop,"label":column.label,"sortable":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteTache(scope.$index, _vm.tableTaches)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                      Supprimer ce lot\n                    ")],1)]}}],null,false,4216734896)})],2)],1):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutTache = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submitTache}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutTravaux),callback:function ($$v) {_vm.dialogAjoutTravaux=$$v},expression:"dialogAjoutTravaux"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit !== true)?_c('span',[_vm._v("Ajouter des nouveaux lots ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modifier les lots "+_vm._s(_vm.travauxCourant.libelle)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutTravaux = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('v-card',[_c('v-form',{ref:"formTravaux",attrs:{"lazy-validation":"","id":"formTravaux"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de projet ")]),_vm._v(" "),(_vm.dialogEdit == false)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Type de projet"},model:{value:(_vm.typeProjet),callback:function ($$v) {_vm.typeProjet=$$v},expression:"typeProjet"}},_vm._l((_vm.listTypeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true},model:{value:(_vm.travauxCourant.type),callback:function ($$v) {_vm.$set(_vm.travauxCourant, "type", $$v)},expression:"travauxCourant.type"}}):_vm._e()],1)])],1),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md11":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                      AJOUTER LES LIGNES DE LOTS\n                    ")])],1)])],1):_vm._e(),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formTravaux}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Libelle lot *")]),_vm._v(" "),_c('el-input',{staticClass:"upper",staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Libellé lot"},model:{value:(_vm.formTravaux.libelle),callback:function ($$v) {_vm.$set(_vm.formTravaux, "libelle", $$v)},expression:"formTravaux.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ordre d'éxécution")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","value":1,"id":"ordre","name":"ordre","min":1,"placeholder":"ordre"},model:{value:(_vm.formTravaux.ordre),callback:function ($$v) {_vm.$set(_vm.formTravaux, "ordre", $$v)},expression:"formTravaux.ordre"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Code ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"code","placeholder":"code lot"},model:{value:(_vm.formTravaux.code),callback:function ($$v) {_vm.$set(_vm.formTravaux, "code", $$v)},expression:"formTravaux.code"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"description","placeholder":"Description"},model:{value:(_vm.formTravaux.description),callback:function ($$v) {_vm.$set(_vm.formTravaux, "description", $$v)},expression:"formTravaux.description"}})],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}})],1),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-btn',{attrs:{"icons":"","color":"primary","id":"plus","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addListParticipantDemande(_vm.formTravaux)}}},[_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableLots}},[_vm._l((_vm.columns),function(column){return _c('el-table-column',{key:column.id,attrs:{"prop":column.prop,"label":column.label,"sortable":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableLots)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                        Supprimer ce lot\n                      ")],1)]}}],null,false,1543049485)})],2)],1):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutTravaux = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitTravaux()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprTyp),callback:function ($$v) {_vm.dialogSuprTyp=$$v},expression:"dialogSuprTyp"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cet enregistrement ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprTyp = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteType($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprLots),callback:function ($$v) {_vm.dialogSuprLots=$$v},expression:"dialogSuprLots"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cet enregistrement ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprLots = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteLots($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprTache),callback:function ($$v) {_vm.dialogSuprTache=$$v},expression:"dialogSuprTache"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cet enregistrement ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprTache = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteTaches($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprProd),callback:function ($$v) {_vm.dialogSuprProd=$$v},expression:"dialogSuprProd"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cet enregistrement ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprProd = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteTypeProd($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowTypeRessource),callback:function ($$v) {_vm.dialogShowTypeRessource=$$v},expression:"dialogShowTypeRessource"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du type de ressource\n          "+_vm._s(_vm.typeRessourceCourant.libelle)+"\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowTypeRessource = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Code : ")]),_vm._v(" "+_vm._s(_vm.typeRessourceCourant.code))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libelle : ")]),_vm._v(" "+_vm._s(_vm.typeRessourceCourant.libelle)+"\n                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description : ")]),_vm._v("\n                      "+_vm._s(_vm.typeRessourceCourant.description)+"\n                    ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v("\n                      "+_vm._s(_vm.typeRessourceCourant.created)+"\n                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v("\n                      "+_vm._s(_vm.typeRessourceCourant.modified)+"\n                    ")])])],1)],1)]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowTypeRessource = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n              Fermer\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editTypeRessource(_vm.typeRessourceCourant)}},slot:"activator"},[_vm._v("Mofifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1),_vm._v("\n              Modifier\n            ")],1)],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogMofifTravaux),callback:function ($$v) {_vm.dialogMofifTravaux=$$v},expression:"dialogMofifTravaux"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Modifier le compte")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogMofifTravaux = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formTypeProj",staticClass:"demo-ruleForm",attrs:{"id":"formTypeProj","rules":_vm.rules,"label-position":"top"}},[_c('v-layout',{staticClass:"text-xs-center text-sm-left",attrs:{"row":"","wrap":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md2":"","mr-1":""}},[_c('div',[_c('el-form-item',{attrs:{"label":"Numéro de compte","prop":"code"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","name":"code","placeholder":"Numéro de compte"},model:{value:(_vm.typeCode),callback:function ($$v) {_vm.typeCode=$$v},expression:"typeCode"}})],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md8":""}},[_c('div',[_c('el-form-item',{attrs:{"label":"Libelle","prop":"libelle"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Libelle"},model:{value:(_vm.typeLibelle),callback:function ($$v) {_vm.typeLibelle=$$v},expression:"typeLibelle"}})],1)],1)])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){_vm.dialogMofifTravaux = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"green","dark":""},on:{"click":function($event){return _vm.submitType()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('formTypeTache',{attrs:{"etatTache":_vm.etatTache,"idTypeTravaux":_vm.idTypeTravauxSelect,"listeLotTache":_vm.listeTache,"show":_vm.showDialogTypeTache},on:{"close":function($event){return _vm.closeFormTypeTache()}}}),_vm._v(" "),_c('LoadTypeProduitExcel',{attrs:{"show":_vm.showModalLoadTypeTravaux,"listeTypeTravaux":_vm.lstPlanComptable},on:{"close":function($event){return _vm.closeFormTypeProduit()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QEk4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QqlA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","persistent":"","fullscreen":"","hide-overlay":""},model:{value:(_vm.dialogReglementCarte),callback:function ($$v) {_vm.dialogReglementCarte=$$v},expression:"dialogReglementCarte"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("\n            Liste des règlements de la carte "+_vm._s(_vm.carte.identifiant)+"\n          ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h6',[_vm._v("LISTE DES REGLEMENTS")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Solde Total: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntTotal)+" Fcfa ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbRgt))]),_vm._v("\n                      Règlement(s)\n                    ")],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right mb-3"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.modalAjoutRgt()}},slot:"activator"},[_vm._v("Ajouter un règlement\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("playlist_add")])],1),_vm._v("\n                  Ajouter un règlement\n                ")],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}}),_vm._v(" "),_c('data-tables',{attrs:{"data":_vm.reglements}},[_c('el-table-column',{attrs:{"prop":"dateRgt","label":"date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Mission/Chantier"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantFormat","label":"Solde (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(" "+_vm._s(scope.row.montantFormat))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createdUser","label":"Enregistré par"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updateUser","label":"Modifié par"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"Description"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.modalEditRgt(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                      Editer\n                    ")],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("REGLEMENTS")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("\n                    ID-"+_vm._s(_vm.idRgt)+"\n                  ")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.deleteDmd()}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('AjoutReglementCarte',{attrs:{"editRgt":_vm.editRgt,"carte":_vm.carte,"show":_vm.showModalAjoutRgt},on:{"close":function($event){_vm.showModalAjoutRgt = false;
      _vm.loadReglement();}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qu0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogDetail),callback:function ($$v) {_vm.dialogDetail=$$v},expression:"dialogDetail"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Fiche de Validation d'une demande de fonds")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Imprimer la demande","icons":"","dark":"","color":"orange"},on:{"click":function($event){return _vm.imprimerDemande()}}},[_vm._v("imprimer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Informations générales sur la demande\n                                            ")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Identifiant de la demande")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                DMD-"+_vm._s(_vm.demandeDetail.id)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Type de demande")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.typeDmd)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Demandeur")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.demandeur)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Enregistrée par: ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.userCreated)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDetail.projet),expression:"demandeDetail.projet"}],attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Projet")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                   "+_vm._s(_vm.demandeDetail.projet)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDetail.projet),expression:"demandeDetail.projet"}],staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDetail.chantier),expression:"demandeDetail.chantier"}],attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.chantier)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDetail.chantier),expression:"demandeDetail.chantier"}],staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDetail.zoneCarburant),expression:"demandeDetail.zoneCarburant"}],attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Zone")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.zoneCarburant)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDetail.zoneCarburant),expression:"demandeDetail.zoneCarburant"}],staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDetail.typeDmd == 'RENUMERATION OUVRIER' && _vm.valider),expression:"demandeDetail.typeDmd == 'RENUMERATION OUVRIER' && valider"}],attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Montant total (rénumération ouvrier chantier) ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(new Intl.NumberFormat().format(_vm.demandeDetail.renumTotal))+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDetail.typeDmd == 'RENUMERATION OUVRIER' && _vm.valider ),expression:"demandeDetail.typeDmd == 'RENUMERATION OUVRIER' && valider "}],staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDetail.typeDmd == 'RENUMERATION OUVRIER' && _vm.valider),expression:"demandeDetail.typeDmd == 'RENUMERATION OUVRIER' && valider"}],attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Montant payé")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(new Intl.NumberFormat().format(_vm.demandeDetail.renumPaye))+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDetail.typeDmd == 'RENUMERATION OUVRIER' && _vm.valider),expression:"demandeDetail.typeDmd == 'RENUMERATION OUVRIER' && valider"}],staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDetail.typeDmd == 'RENUMERATION OUVRIER' && _vm.valider),expression:"demandeDetail.typeDmd == 'RENUMERATION OUVRIER' && valider"}],attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Montant restant")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(new Intl.NumberFormat().format(_vm.demandeDetail.renumRestant))+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDetail.typeDmd == 'RENUMERATION OUVRIER' && _vm.valider),expression:"demandeDetail.typeDmd == 'RENUMERATION OUVRIER' && valider"}],staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de la demande")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.dateFormat)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Montant demandé ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.montantFormat)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-3",attrs:{"xs6":""}},[_vm._v("Statut")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[(_vm.demandeDetail.statut == 0)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v("  "+_vm._s(_vm.demandeDetail.libStatut))]):_vm._e(),_vm._v(" "),(_vm.demandeDetail.statut == 1)?_c('el-tag',[_vm._v(_vm._s(_vm.demandeDetail.libStatut))]):_vm._e(),_vm._v(" "),(_vm.demandeDetail.statut == 2)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(_vm.demandeDetail.libStatut))]):_vm._e(),_vm._v(" "),(_vm.demandeDetail.statut == 3)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(_vm.demandeDetail.libStatut))]):_vm._e(),_vm._v(" "),(_vm.demandeDetail.statut == 4)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(_vm.demandeDetail.libStatut))]):_vm._e()],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Caisse ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.caissePaie)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Motif de la demande ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('el-form',{staticClass:"demo-ruleForm"},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":""}},[_c('el-input',{attrs:{"readonly":true,"type":"textarea"},model:{value:(_vm.demandeDetail.motif),callback:function ($$v) {_vm.$set(_vm.demandeDetail, "motif", $$v)},expression:"demandeDetail.motif"}})],1)],1)],1)],1),_vm._v(" "),(_vm.demandeDetail.statut == 0)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Motif du rejet ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('el-form',{staticClass:"demo-ruleForm"},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":""}},[_c('el-input',{attrs:{"readonly":true,"type":"textarea"},model:{value:(_vm.demandeDetail.motifRefus),callback:function ($$v) {_vm.$set(_vm.demandeDetail, "motifRefus", $$v)},expression:"demandeDetail.motifRefus"}})],1)],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.demandeDetail.carteCarburant || _vm.demandeDetail.carte ),expression:"demandeDetail.carteCarburant || demandeDetail.carte "}],attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                                                        Informations Carte\n                                                                                    ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.recharge}},[_c('el-table-column',{attrs:{"prop":"identifiant","label":"identifiant","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Solde de la carte (Fcfa)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fournisseur","label":"Fournisseur"}})],1)],1),_vm._v(" "),_c('br')],1)],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.valider),expression:"valider"}]},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('v-alert',{staticClass:"mb-4",attrs:{"value":true,"outline":"","color":"primary","icon":"info"}},[_vm._v("Détail du budget mensuel et total validé (Pour ce type de demande)\n                                                                        ")]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":_vm.demandeDetail.listeDmdBudget}},[_c('el-table-column',{attrs:{"align":"center","prop":"libelle","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"periode","label":"PERIODE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"budgetTotal","label":"BUDGET VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                                                        "+_vm._s(new Intl.NumberFormat().format(scope.row.budgetTotal))+"\n                                                                                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntFactureValide","label":"FACTURE DEJA VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                                                        "+_vm._s(new Intl.NumberFormat().format(scope.row.mntFactureValide))+"\n                                                                                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecartBudget","label":"ECART BUDGET-FACTURE DEJA VALIDEE","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('v-chip',{attrs:{"label":"","outline":"","color":"primary"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(prop.row.ecartBudget)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"","label":"ETAT BUDGET (si la facture est validée)","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-tag',{attrs:{"type":(prop.row.ecartBudget >= _vm.demandeDetail.montant) ? 'success' : 'danger',"disable-transitions":""}},[((prop.row.ecartBudget >= _vm.demandeDetail.montant))?_c('span',[_vm._v("Dans le budget")]):_c('span',[_vm._v("Hors budget")])])]}}])})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.valider || _vm.logistique == true),expression:"valider || logistique == true"}],staticClass:"mb-5",staticStyle:{"margin-right":"100px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"red"},on:{"click":function($event){_vm.dialogConfirmRefus = true}},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Refuser la demande")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.valider || _vm.logistique == true),expression:"valider || logistique == true"}],staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"green"},on:{"click":function($event){_vm.dialogConfirm = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v("Valider la demande")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirmRefus),callback:function ($$v) {_vm.dialogConfirmRefus=$$v},expression:"dialogConfirmRefus"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation d'une demande de fonds")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous Refuser cette demande de fonds ?","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("DEMANDE DE FONDS")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("DMD-"+_vm._s(_vm.demandeDetail.id))]),_vm._v(" "),_c('p',{staticClass:"red--text .font-weight-regular subheading"},[_vm._v("MONTANT: "+_vm._s(_vm.demandeDetail.montantFormat)+" FCFA")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{ref:"refFormRefust",staticClass:"demo-form-inline",attrs:{"id":"formRefus","rules":_vm.ruleFormRefus,"label-position":"top","inline":true,"model":_vm.formRefus}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Commentaire","prop":"rapportRefus"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Pourquoi voulez-vous refuser ?"},model:{value:(_vm.formRefus.rapport),callback:function ($$v) {_vm.$set(_vm.formRefus, "rapport", $$v)},expression:"formRefus.rapport"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirmRefus = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitRefusDevis()}}},[_vm._v("Refuser")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation d'une demande de fonds")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous valider cette demande de fond ?","closable":false,"show-icon":"","type":"success"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("DEMANDE DE FONDS")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("DMD-"+_vm._s(_vm.demandeDetail.id))]),_vm._v(" "),_c('p',{staticClass:"red--text .font-weight-regular subheading"},[_vm._v("MONTANT: "+_vm._s(_vm.demandeDetail.montantFormat)+" FCFA")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirm = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideDevis()}}},[_vm._v("Confirmer")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qwre":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardCommis_vue__ = __webpack_require__("UF8r");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13e927f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardCommis_vue__ = __webpack_require__("Sr9B");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardCommis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13e927f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardCommis_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R5w9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R654":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"text-xs-center"},[_c('v-bottom-sheet',{model:{value:(_vm.sheet),callback:function ($$v) {_vm.sheet=$$v},expression:"sheet"}},[_c('v-list',[_c('v-subheader',[_vm._v("Menu Droit ")]),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.sheet = false}}},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("folder")])],1)],1)],1),_vm._v(" "),_c('v-list-tile-title',{on:{"click":function($event){_vm.sheet = false; _vm.dossier.etat = true; _vm.dossier.title='Créer';  _vm.dossier.libelle = ''; _vm.dossier.description = ''; _vm.dossier.id = ''}}},[_vm._v("Nouveau Dossier")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.sheet = false}}},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("backup")])],1)],1)],1),_vm._v(" "),_c('v-list-tile-title',{on:{"click":function($event){_vm.televersement = true; _vm.folder=false; _vm.lancement();}}},[_vm._v("Importer des Fichiers")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-bottom-sheet',{model:{value:(_vm.edit),callback:function ($$v) {_vm.edit=$$v},expression:"edit"}},[_c('v-list',[_c('v-subheader',[_vm._v(_vm._s(_vm.dossier.libelle))]),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.edit = false}}},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("folder_open")])],1)],1)],1),_vm._v(" "),_c('v-list-tile-title',{on:{"click":function($event){return _vm.naviguateFolder()}}},[_vm._v("Ouvrir le repertoire")])],1),_vm._v(" "),(_vm.currentFolder.admin == _vm.user.email)?_c('v-list-tile',{on:{"click":function($event){_vm.edit = false}}},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("share")])],1)],1)],1),_vm._v(" "),_c('v-list-tile-title',{on:{"click":function($event){return _vm.shareFolderInit()}}},[_vm._v("Partager le repertoire")])],1):_vm._e(),_vm._v(" "),(_vm.currentFolder.admin == _vm.user.email)?_c('v-list-tile',{on:{"click":function($event){_vm.edit = false}}},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("mode_edit")])],1)],1)],1),_vm._v(" "),_c('v-list-tile-title',{on:{"click":function($event){_vm.edit = false; _vm.dossier.etat = true; _vm.dossier.title='Modifier'}}},[_vm._v("Modifier le repertoire")])],1):_vm._e(),_vm._v(" "),(_vm.currentFolder.admin == _vm.user.email)?_c('v-list-tile',{on:{"click":function($event){_vm.edit = false}}},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("delete_forever")])],1)],1)],1),_vm._v(" "),_c('v-list-tile-title',{on:{"click":function($event){return _vm.removeF('folder');}}},[_vm._v("Supprimer le repertoire")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-bottom-sheet',{model:{value:(_vm.currentFichier.etat),callback:function ($$v) {_vm.$set(_vm.currentFichier, "etat", $$v)},expression:"currentFichier.etat"}},[_c('v-list',[_c('v-subheader',[_vm._v(_vm._s(_vm.currentFichier.libelle))]),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.lecture()}}},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("zoom_in")])],1)],1)],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Lire le fichier")])],1),_vm._v(" "),(_vm.currentFichier.admin == _vm.user.email)?_c('v-list-tile',{on:{"click":function($event){return _vm.shareFilesInit()}}},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("share")])],1)],1)],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Partager le fichier")])],1):_vm._e(),_vm._v(" "),(_vm.currentFichier.admin == _vm.user.email)?_c('v-list-tile',{on:{"click":function($event){return _vm.removeF('fichier');}}},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("delete_forever")])],1)],1)],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Supprimer le fichier")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition","overlay":false,"scrollable":""},model:{value:(_vm.televersement),callback:function ($$v) {_vm.televersement=$$v},expression:"televersement"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.televersement = !_vm.televersement; _vm.load()}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Envoyer des fichiers ")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-upload',{staticClass:"upload-demo",attrs:{"drag":"","action":_vm.upload,"multiple":""}},[_c('i',{staticClass:"el-icon-upload"})])],1),_vm._v(" "),_c('br')],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"xs12":"","sm12":"","element-loading-text":"Loading...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-card',{on:{"contextmenu":function($event){$event.preventDefault();_vm.sheet = true}}},[_c('section',[_c('v-list',{attrs:{"two-line":""}},[_c('v-subheader',{attrs:{"inset":""}},[_vm._v("Dossiers partagés")]),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.dossierPartage),function(item){return _c('v-flex',{attrs:{"xs3":""}},[_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){return _vm.editFolder(item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"grey lighten-1 white--text"},[_vm._v("folder")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.libelle)+"\n                    "),(item.admin == _vm.user.email)?_c('v-icon',{staticStyle:{"color":"#F00"}},[_vm._v("verified_user")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.date))])],1)],1)],1)}),1),_vm._v(" "),_c('v-subheader',{attrs:{"inset":""}},[_vm._v("Fichiers partagés")]),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.fichierPartage),function(item){return _c('v-flex',{attrs:{"xs3":""}},[_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){return _vm.editFile(item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"blue white--text"},[_vm._v("assignment")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.libelle)+"\n                    "),(item.admin == _vm.user.email)?_c('v-icon',{staticStyle:{"color":"#F00"}},[_vm._v("verified_user")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.date))])],1)],1)],1)}),1),_vm._v(" "),(_vm.currentFolder.parent)?_c('div',[_c('v-subheader',{attrs:{"inset":""}},[_vm._v("Dossier parent")]),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',{staticStyle:{"width":"100px","margin-left":"60px"},attrs:{"avatar":""},on:{"click":function($event){}},nativeOn:{"dblclick":function($event){return _vm.parentFolder()}}},[_c('p',[_vm._v("...")])])],1):_vm._e(),_vm._v(" "),_c('v-subheader',{attrs:{"inset":""}},[_vm._v("Dossiers")]),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.dossiers),function(item){return _c('v-flex',{attrs:{"xs3":""}},[_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){return _vm.editFolder(item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"grey lighten-1 white--text"},[_vm._v("folder")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.libelle))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.date))])],1)],1)],1)}),1),_vm._v(" "),_c('v-subheader',{attrs:{"inset":""}},[_vm._v("Fichiers")]),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.fichiersansNom),function(item){return _c('v-flex',{attrs:{"xs3":""}},[_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){return _vm.editFile(item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"blue white--text"},[_vm._v("assignment")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.libelle))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.date))])],1)],1)],1)}),1)],1)],1)])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":'Partager le dossier ' + _vm.currentFolder.libelle + ' avec:',"visible":_vm.dialogShareFolder,"width":"50%","center":""},on:{"update:visible":function($event){_vm.dialogShareFolder=$event}}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":"","id":"sendFolder"},model:{value:(_vm.sendFolder),callback:function ($$v) {_vm.sendFolder=$$v},expression:"sendFolder"}},[_c('span',[_c('el-transfer',{staticStyle:{"width":"100%"},attrs:{"titles":['Les utilisateurs', 'Selectionne'],"filterable":"","filter-placeholder":"Rechercher","data":_vm.folderGroupe.liste},model:{value:(_vm.folderGroupe.selection),callback:function ($$v) {_vm.$set(_vm.folderGroupe, "selection", $$v)},expression:"folderGroupe.selection"}}),_vm._v(" "),_c('v-btn',{staticStyle:{"float":"right","margin-top":"-25px"},attrs:{"icons":"","color":"blue","dark":""},on:{"click":_vm.submitShareFolder}},[_vm._v("Partager")])],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"})])],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":'Partager le fichier ' + _vm.currentFichier.libelle + ' avec:',"visible":_vm.dialogShareFile,"width":"50%","center":""},on:{"update:visible":function($event){_vm.dialogShareFile=$event}}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":"","id":"sendFile"},model:{value:(_vm.sendFile),callback:function ($$v) {_vm.sendFile=$$v},expression:"sendFile"}},[_c('span',[_c('el-transfer',{staticStyle:{"width":"100%"},attrs:{"titles":['Les utilisateurs', 'Selectionne'],"filterable":"","filter-placeholder":"Rechercher","data":_vm.groupe.liste},model:{value:(_vm.groupe.selection),callback:function ($$v) {_vm.$set(_vm.groupe, "selection", $$v)},expression:"groupe.selection"}}),_vm._v(" "),_c('v-btn',{staticStyle:{"float":"right","margin-top":"-25px"},attrs:{"icons":"","color":"blue","dark":""},on:{"click":_vm.submitShareFile}},[_vm._v("Partager")])],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"})])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"300px","persistent":""},model:{value:(_vm.dossier.etat),callback:function ($$v) {_vm.$set(_vm.dossier, "etat", $$v)},expression:"dossier.etat"}},[_c('v-card',[_c('v-card-title',[_vm._v("\n               Nouveau Dossier\n             ")]),_vm._v(" "),_c('v-card-text',[(_vm.erreur.type)?_c('div',[_c('el-alert',{attrs:{"title":_vm.erreur.message,"type":"error"}})],1):_vm._e(),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-text-field',{attrs:{"label":"Nouveau Dossier","rules":_vm.dossier.nameRules,"required":""},model:{value:(_vm.dossier.libelle),callback:function ($$v) {_vm.$set(_vm.dossier, "libelle", $$v)},expression:"dossier.libelle"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dossier.etat = !_vm.dossier.etat}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":_vm.valideCreate}},[_vm._v(_vm._s(_vm.dossier.title))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RE2M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ROzJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_boardEmploye_vue__ = __webpack_require__("HrBg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54fc2a30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_boardEmploye_vue__ = __webpack_require__("hWpT");
function injectStyle (ssrContext) {
  __webpack_require__("aWw2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54fc2a30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_boardEmploye_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54fc2a30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_boardEmploye_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RPgo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "ModalCommandeMAJ",
  props: ["show", "detailCommande"],
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      loading: false,
      fournisseur: null,
      priorite: 1,
      dateLivraison: null,
      valid: true,
      libelleCommande: "",
      prioriteCommande: 1,
      idCommande: 0,
      fournisseurCommande: null,
      dialogDetailCommande: false,
      listFournisseur: [],
      dialogModalCommandeMAJ: false,
      tailleOptionBesoinSupUn: false,
      optionBesoinIndexDeleted: [],
      optionCommandeIdDeleted: [],
      fournisseurCommandeId: null,
      optionCommande: [{
        key: 1,
        produit: "",
        qte: 1,
        unite: "",
        id: 0,
        priorite: 1
      }],
      priorites: [{
        value: 1,
        label: "Faible"
      }, {
        value: 2,
        label: "Normal"
      }, {
        value: 3,
        label: "Urgent"
      }],
      //Projet
      listeProjet: [],
      listeChantier: [],
      listeTravaux: [],
      projetS: "",
      chantierS: "",
      travauxS: ""
    };
  },


  computed: {},
  methods: {
    loadFournisseur: function loadFournisseur() {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "fournisseur/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this.listFournisseur = response.body.fournisseur;
          _this.loading = false;
        }
      });
    },
    updateCommande: function updateCommande() {
      var _this2 = this;

      this.loading = true;
      if (this.$refs.formComm.validate() && this.libelleCommande != "" && this.fournisseurCommande != null && this.prioriteCommande > 0) {
        var formdata = new FormData();
        var url = this.domaine + "besoin/update/commande";
        //recupération des informations des options besoins
        for (var i in this.optionBesoinIndexDeleted) {
          formdata.append("optionBesoin[]", this.optionBesoinIndexDeleted[i]);
          formdata.append("optionCommande[]", this.optionCommandeIdDeleted[i]);
        }
        formdata.append("idCommande", this.idCommande);
        formdata.append("libelle", this.libelleCommande);
        formdata.append("priorite", this.prioriteCommande);
        formdata.append("dateLivraison", this.dateLivraison);
        formdata.append("idUserModifier", this.user.id);
        formdata.append("fournisseur", this.fournisseurCommandeId);
        formdata.append("projetId", this.projetS);
        formdata.append("chantierId", this.chantierS);
        formdata.append("travauxId", this.travauxS);
        this.$http.post(url, formdata).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this2.$notify({
                title: "MISE A JOUR",
                message: "Mise à jour de la commande réussi",
                type: "success",
                position: "top-center"
              });
              _this2.closeDialog();
              _this2.loading = false;
              _this2.$refs.formComm.reset();
            } else if (verif.code === 2) {
              _this2.$message.error(verif.message);
              _this2.loading = false;
            }
          } else {
            _this2.$message.error("Erreur serveur");
            _this2.loading = false;
          }
        }, function (response) {
          _this2.$message.error("Erreur serveur");
          _this2.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La commande n'a pas été mise a jour!",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    removeOptionBesoin: function removeOptionBesoin(item) {
      var _this3 = this;

      this.$confirm("Si vous continuez, ce produit sera supprimer après avoir cliqué sur modifier?", "Attention", {
        confirmButtonText: "Continuer",
        cancelButtonText: "Annuler",
        type: "warning"
      }).then(function () {
        //sauvegarde de l'index du produit concerné et de l'option commande a supprimer
        _this3.optionBesoinIndexDeleted.push(item.besoinId);
        _this3.optionCommandeIdDeleted.push(item.id);
        var index = _this3.optionCommande.indexOf(item);
        if (index !== -1) {
          _this3.optionCommande.splice(index, 1);
        }
        _this3.tailleOptionBesoinSupUn = _this3.optionCommande.length > 1 ? true : false;
      }).catch(function () {
        _this3.$message({
          type: "info",
          message: "Action annulée"
        });
        _this3.loading = false;
      });
    },
    loadProjet: function loadProjet() {
      var _this4 = this;

      var url = this.domaine + "projet/index/projet/all";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this4.loading = false;
        _this4.listeProjet = response.body.projet;
        _this4.projetS = _this4.detailCommande.projetId;
      }, function (errRep) {
        _this4.loading = false;
        _this4.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    loadChantier: function loadChantier() {
      var _this5 = this;

      this.loading = true;
      var url = this.domaine + "projet/" + this.projetS + "/index/chantier";
      this.$http.get(url).then(function (response) {
        _this5.loading = false;
        _this5.listeChantier = response.body.chantier;
        _this5.chantierS = _this5.detailCommande.chantierId;
      }, function (errRep) {
        _this5.loading = false;
        _this5.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    loadDetailsCommande: function loadDetailsCommande() {
      //transfert des données du tableau de detail de commande
      this.optionCommande = this.detailCommande.option;
      this.idCommande = this.detailCommande.id;
      this.libelleCommande = this.detailCommande.libelle;
      this.prioriteCommande = this.detailCommande.priorite;
      this.dateLivraison = this.detailCommande.dateLivr;
      this.fournisseurCommande = this.detailCommande.fournisseurNom;
      this.fournisseurCommandeId = this.detailCommande.fournisseur;
      //projet
      this.projetS = this.detailCommande.projetId;
      this.chantierS = this.detailCommande.chantierId;
      this.travauxS = this.detailCommande.travauxId;
      //controle du nombre de produit formant la commande
      this.tailleOptionBesoinSupUn = this.optionCommande.length > 1 ? true : false;
    },
    loadTravaux: function loadTravaux() {
      var _this6 = this;

      this.loading = true;
      this.travauxS = "";
      this.listTravaux = [];
      if (this.chantierS !== "") {
        var url = this.domaine + "projet/" + this.chantierS + "/index/chantier/travaux";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            ;
            _this6.listeTravaux = response.body.travaux;
            _this6.travauxS = _this6.detailCommande.travauxId;
            _this6.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un chantier");
        this.loading = false;
      }
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    }
  },

  watch: {
    show: function show(newValue, oldvalue) {
      if (newValue == true) {
        this.loadDetailsCommande();
        this.loadFournisseur();
        if (this.detailCommande.projetId) {
          this.loadProjet();
          this.loadChantier();
          this.loadTravaux();
        }
        //suppression des elements du tableau d'indice de besoin
        this.optionBesoinIndexDeleted = [];
      }
      this.dialogModalCommandeMAJ = newValue;
    }
  }
});

/***/ }),

/***/ "RUNv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rb7m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dupformTypeTache_vue__ = __webpack_require__("Pt3C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_497733e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dupformTypeTache_vue__ = __webpack_require__("jRLL");
function injectStyle (ssrContext) {
  __webpack_require__("SyR5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-497733e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dupformTypeTache_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_497733e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dupformTypeTache_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RiaC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  props: {
    show: {
      type: Boolean
    },

    listeTableaux: {
      type: Array
    }
  },
  name: "TableauTache",
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [{ path: "/tableTache", text: "Tableaux des taches", disabled: false }]
    };
  },


  methods: {
    loadChantier: function loadChantier() {}
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ "SDwy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboardReporting_vue__ = __webpack_require__("T+dQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e9aa4bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboardReporting_vue__ = __webpack_require__("UD/J");
function injectStyle (ssrContext) {
  __webpack_require__("yuvZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e9aa4bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboardReporting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e9aa4bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboardReporting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SHB3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detail_employe_vue__ = __webpack_require__("kupt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_418a2d79_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detail_employe_vue__ = __webpack_require__("yWbU");
function injectStyle (ssrContext) {
  __webpack_require__("ZrPI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-418a2d79"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detail_employe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_418a2d79_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detail_employe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SYG7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Worklogs_vue__ = __webpack_require__("6GQa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_595da48a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Worklogs_vue__ = __webpack_require__("UW0N");
function injectStyle (ssrContext) {
  __webpack_require__("xoS/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Worklogs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_595da48a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Worklogs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SfI+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogDetailCommande),callback:function ($$v) {_vm.dialogDetailCommande=$$v},expression:"dialogDetailCommande"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("\n              "+_vm._s(_vm.hiddenButton
                  ? "Détails du bon de commande interne"
                  : "Détails de la commande Interne"))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n              "+_vm._s(_vm.hiddenButton
                  ? "DETAILS DU BON DE COMMANDE INTERNE"
                  : " DETAILS DE LA COMMANDE INTERNE")+"\n\n             \n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),_c('v-form',{attrs:{"lazy-validation":"","id":"formComm"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[(!_vm.hiddenButton)?_c('v-flex',[_c('span',{staticClass:"demonstration"},[_vm._v("Fournisseur ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Fournisseur","readonly":true},model:{value:(_vm.fournisseurCommande),callback:function ($$v) {_vm.fournisseurCommande=$$v},expression:"fournisseurCommande"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md4":!_vm.hiddenButton,"md7":_vm.hiddenButton}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Intitulé de la commande")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Intitulé de la commande","readonly":true},model:{value:(_vm.libelleCommande),callback:function ($$v) {_vm.libelleCommande=$$v},expression:"libelleCommande"}})],1)]),_vm._v(" "),(!_vm.hiddenButton)?_c('v-flex',[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mode")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"mode","placeholder":"Intitulé de la commande","readonly":true},model:{value:(_vm.modeCommande),callback:function ($$v) {_vm.modeCommande=$$v},expression:"modeCommande"}})],1)]):_vm._e(),_vm._v(" "),(!_vm.hiddenButton)?_c('v-flex',[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Numéro devis / proforma")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"mode","placeholder":"Numero devis / proforma","readonly":true},model:{value:(_vm.numeroDevis),callback:function ($$v) {_vm.numeroDevis=$$v},expression:"numeroDevis"}})],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de livraison")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"dateLivraison","placeholder":"Date de livraison","readonly":true},model:{value:(_vm.dateLivraison),callback:function ($$v) {_vm.dateLivraison=$$v},expression:"dateLivraison"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Priorité")]),_vm._v(" "),(_vm.prioriteCommande == 1)?_c('el-input',{attrs:{"value":"Faible","trigger-on-focus":true,"readonly":true}}):(_vm.prioriteCommande == 2)?_c('el-input',{attrs:{"value":"Normal","trigger-on-focus":true,"readonly":true}}):(_vm.prioriteCommande == 3)?_c('el-input',{attrs:{"value":"Urgent","trigger-on-focus":true,"readonly":true}}):_c('el-input',{attrs:{"value":"Aucune","trigger-on-focus":true,"readonly":true}})],1)])],1),_vm._v(" "),(_vm.detailCommande && _vm.detailCommande.entrepotId)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Magasin chantier","readonly":true},model:{value:(_vm.detailCommande.libEntrepot),callback:function ($$v) {_vm.$set(_vm.detailCommande, "libEntrepot", $$v)},expression:"detailCommande.libEntrepot"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.detailCommande && _vm.detailCommande.projetId)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"projetS","placeholder":"Type de projet","readonly":true},model:{value:(_vm.projetS),callback:function ($$v) {_vm.projetS=$$v},expression:"projetS"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chantier concerné ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"chantierS","placeholder":"Chantier concerné","readonly":true},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"travauxS","placeholder":"Travaux","readonly":true},model:{value:(_vm.travauxS),callback:function ($$v) {_vm.travauxS=$$v},expression:"travauxS"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.detailCommande && _vm.detailCommande.projetId)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tâche")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"tacheS","placeholder":"Tache","readonly":true},model:{value:(_vm.tacheS),callback:function ($$v) {_vm.tacheS=$$v},expression:"tacheS"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("PK début")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"tranconA","placeholder":"Du PK"},model:{value:(_vm.tranconA),callback:function ($$v) {_vm.tranconA=$$v},expression:"tranconA"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("PK fin")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"tranconB","placeholder":"PK FIN"},model:{value:(_vm.tranconB),callback:function ($$v) {_vm.tranconB=$$v},expression:"tranconB"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[(_vm.urlImage)?_c('v-avatar',{staticClass:"mb-1 mr-1 elevation-3",style:({
                          backgroundImage: 'url(' + _vm.urlImage + ')',
                          cursor: 'pointer'
                      }),attrs:{"slot":"activator","tile":true,"size":150,"color":"grey lighten-4"},on:{"click":function($event){return _vm.showDiapo([_vm.urlImage], 0, _vm.urlImage)}},slot:"activator"},[(_vm.imagePdf)?_c('img',{attrs:{"src":_vm.logoPdf,"alt":"avatar"}}):_vm._e(),_vm._v(" "),(!_vm.imagePdf)?_c('img',{attrs:{"src":_vm.logoDefaut,"alt":"avatar"}}):_vm._e()]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                  PRODUIT(S) LIE(S) A LA COMMANDE\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),_vm._l((_vm.optionBesoin),function(besoin){return _c('v-layout',{key:besoin.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Code analytique")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"produit","placeholder":"Code analytique","readonly":true},model:{value:(besoin.codeAnalytique),callback:function ($$v) {_vm.$set(besoin, "codeAnalytique", $$v)},expression:"besoin.codeAnalytique"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Code gestion")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"gestion","placeholder":"Code gestion","readonly":true},model:{value:(besoin.codeGestion),callback:function ($$v) {_vm.$set(besoin, "codeGestion", $$v)},expression:"besoin.codeGestion"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":!_vm.hiddenButton,"md7":_vm.hiddenButton}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ressource")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"produit","placeholder":"Ressource","readonly":true},model:{value:(besoin.produit),callback:function ($$v) {_vm.$set(besoin, "produit", $$v)},expression:"besoin.produit"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","value":"qte","placeholder":"Quantité","readonly":true},model:{value:(besoin.qte),callback:function ($$v) {_vm.$set(besoin, "qte", $$v)},expression:"besoin.qte"}})],1)]),_vm._v(" "),(!_vm.hiddenButton)?_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix unitaire *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","value":"prix","placeholder":"Prix","readonly":true},model:{value:(besoin.prix),callback:function ($$v) {_vm.$set(besoin, "prix", $$v)},expression:"besoin.prix"}})],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité")]),_vm._v(" "),_c('el-input',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"trigger-on-focus":true,"readonly":true},model:{value:(besoin.unite),callback:function ($$v) {_vm.$set(besoin, "unite", $$v)},expression:"besoin.unite"}})],1)])],1)}),_vm._v(" "),_c('br')],2),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue","dark":""},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Fermer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('CoolLightBox',{attrs:{"items":_vm.items,"index":_vm.index},on:{"close":function($event){_vm.index = null}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SgBp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sr9B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticStyle:{"padding":"0px"}},[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('ChantierIndex',{attrs:{"userAdmin":_vm.userAdmin,"commis":true,"listeChantiers":_vm.chantiers}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SyR5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T+dQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */]
  },
  name: "dashboardReporting",
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [{ path: "/", text: "Accueil", disabled: false }, {
        path: "/dashboardReporting",
        text: "Dashboard reporting",
        disabled: true
      }],

      listeUsers: [{
        nom: "",
        fonction: ""
      }],
      listReporting: []
    };
  },


  methods: {
    imprimeListeBilan: function imprimeListeBilan() {
      var url = this.domaine + "userCreate/imprimerBilandDG/" + this.user.id;
      window.open(url);
    },
    loadBilanDg: function loadBilanDg() {
      var _this = this;

      // this.loading = true;
      var url = this.domaine + "userCreate/index/reporting/semaine";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this.listReporting = response.body;
          _this.listeUsers = _this.listReporting.listeUserConecter;
          _this.loading = false;
        }
      });
    }
  },
  mounted: function mounted() {
    this.loadBilanDg();
  }
});

/***/ }),

/***/ "T8Ii":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      loading: false,
      domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
      roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
      userCon: JSON.parse(sessionStorage.getItem('userInfo')),
      droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
      racourcis: [{ path: '/', text: 'Accueil', disabled: false }, { path: '/maintenance', text: 'Maintenance', disabled: false }, { path: '/', text: 'Liste des demandes', disabled: true }],
      valid: true,
      dialogEdit: false,
      dialogAjoutDmd: false,
      dialogAjoutNote: false,
      id_dmd: null,
      nomPrenDmd: '',
      libzone: '',
      descDmd: '',
      totalDmd: 0,
      nbDmdCour: 0,
      nbDmdclot: 0,
      nbDmdRef: 0,
      msgInfo: 0,
      tel1Dmd: '',
      tel2Dmd: '',
      datePrevu: null,
      salleDmd: null,
      typeMes: 'success',
      msg: '',
      selectSal: null,
      itemsSal: [],
      selectTypeDemande: null,
      typeDemande: [{ text: 'Réparation', value: 1 }, { text: 'Fourniture de matériel', value: 2 }],
      tmp: '',
      search_dmd: '',
      headers_dmd: [{ text: 'Demandeur', value: 'dmdeur', align: 'center' }, { text: 'Etat', lue: 'etat_dmd', align: 'center' }, { text: 'Date', value: 'date_dmd', align: 'center' }, { text: 'Actions', align: 'center' }],
      items_dmd: [],
      demandeCourant: {},
      noteDemande: null
    };
  },
  mounted: function mounted() {
    this.loadPage();
    this.loadDemande();
  },

  methods: {
    loadPage: function loadPage() {
      var loading = this.$loading({
        lock: true,
        text: 'Veuillez patientez ...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(function () {
        loading.close();
      }, 1000);
    },
    loadDemande: function loadDemande() {
      var _this = this;

      var url = this.domaine + 'demande/' + this.userCon.id + '/liste';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this.nbDmdCour = response.body.listNbDmd.encours;
          _this.nbDmdclot = response.body.listNbDmd.cloture;
          _this.nbDmdRef = response.body.listNbDmd.refuse;
          _this.libzone = response.body.libZone;
          _this.itemsSal = response.body.salle;
          _this.items_dmd = response.body.listDmd;
          _this.totalDmd = response.body.listNbDmd.total;
        }
      });
    },
    loadDemandeur: function loadDemandeur(queryString, cb) {
      var _this2 = this;

      var url = this.domaine + 'maintenance/listes-demandeur';
      var formdata = new FormData();
      formdata.append('user', this.userCon.id);
      formdata.append('tag', queryString);
      this.$http.post(url, formdata).then(function (response) {
        if (response.body) {
          var links = response.body;
          var results = queryString ? links.filter(_this2.createFilter(queryString)) : links;
          cb(results);
        }
      }, function (response) {});
    },
    newDemande: function newDemande() {
      this.dialogAjoutDmd = true;
      this.dialogEdit = false;
      this.id_dmd = '';
      this.nomPrenDmd = '';
      this.selectTypeDemande = null;
      this.descDmd = '';
      this.tel1Dmd = '';
      this.tel2Dmd = '';
      this.datePrevu = null;
      this.selectSal = null;
    },
    newNote: function newNote(item) {
      this.demandeCourant = item;
      this.dialogAjoutNote = true;
      this.noteDemande = 0;
      this.descDmd = '';
    },
    editDemande: function editDemande(item) {
      this.demandeCourant = item;
      this.dialogAjoutDmd = true;
      this.dialogEdit = true;
      this.id_dmd = item.id_dmd;
      this.selectTypeDemande = item.typeDemande;
      this.nomPrenDmd = item.dmdeur;
      this.descDmd = item.motif;
      this.tel1Dmd = item.tel1;
      this.tel2Dmd = item.tel2;
      this.datePrevu = item.interventionDate;
      this.selectSal = item.idSalle;
    },
    submitDemande: function submitDemande() {
      var _this3 = this;

      this.loading = true;
      if (this.$refs.formDemande.validate()) {
        if (this.selectTypeDemande !== null && this.selectSal !== null && this.tel1Dmd !== '' && this.descDmd !== "" && this.datePrevu !== null && this.nomPrenDmd !== '') {
          var form = document.getElementById('formDemande');
          var data = new FormData(form);
          var url = this.domaine + 'demande/ajout';
          data.append('id', this.id_dmd);
          data.append('idUser', this.userCon.id);
          data.append('type', this.selectTypeDemande);
          data.append('zone', this.selectSal);

          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this3.$notify({
                  title: 'ENREGISTREMENT REUSSI',
                  message: 'Demande enregistré avec succès.',
                  type: 'success',
                  position: 'top-center'
                });
                _this3.loadDemande();
                _this3.dialogAjoutDmd = false;
                _this3.loading = false;
                _this3.$refs.formDemande.reset();
              } else if (verif.code === 0) {
                _this3.$message.error(verif.message);
                _this3.loading = false;
              }
            } else {
              _this3.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
              _this3.loading = false;
            }
          }, function (response) {
            _this3.loading = false;
            _this3.$message.error("Erreur lors de l'ajout de la demande");
          });
        } else {
          this.$message.error('Veuillez renseigner les champs obligatoires');
        }
      } else {
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La demande n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    submitNote: function submitNote() {
      var _this4 = this;

      this.loading = true;
      if (this.$refs.formNote.validate()) {
        if (this.noteDemande !== null) {
          var form = document.getElementById('formNote');
          var data = new FormData(form);
          var url = this.domaine + 'demande/' + this.demandeCourant.id_dmd + '/note';
          data.append('idUser', this.userCon.id);
          data.append('note', this.noteDemande);

          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this4.$notify({
                  title: 'ENREGISTREMENT REUSSI',
                  message: 'Note enregistré avec succès.',
                  type: 'success',
                  position: 'top-center'
                });
                _this4.loadDemande();
                _this4.dialogAjoutNote = false;
                _this4.loading = false;
                _this4.$refs.formNote.reset();
              } else if (verif.code === 0) {
                _this4.$message.error(verif.message);
                _this4.loading = false;
              }
            } else {
              _this4.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
              _this4.loading = false;
            }
          }, function (response) {
            _this4.loading = false;
            _this4.$message.error("Erreur lors de l'ajout de la demande");
          });
        } else {
          this.$message.error('Veuillez renseigner les champs obligatoires');
        }
      } else {
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La note n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    querySearch: function querySearch(queryString, cb) {
      var links = this.liste.devis;
      var results = queryString ? links.filter(this.createFilter(queryString)) : links;
      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (link) {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    affDetailDmd: function affDetailDmd(current) {
      this.$router.push({ name: 'DetailDemande', params: { demande_id: current.id_dmd } });
    }
  },
  beforeMount: function beforeMount() {
    if (!this.roleAcces[this.$router.history.current.name]) {
      this.$router.push({ name: 'Home' });
    }
  }
});

/***/ }),

/***/ "TFWQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item,ind){return _c('v-breadcrumbs-item',{key:ind,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v(" "+_vm._s(item.text))])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":"","ml-1":"","mr-1":"","mt-1":""}},[_c('v-card',[_c('el-tabs',{attrs:{"stretch":"true","type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick(_vm.onglet)}},model:{value:(_vm.onglet),callback:function ($$v) {_vm.onglet=$$v},expression:"onglet"}},[_c('el-tab-pane',{attrs:{"label":" Validation devis / facture"}},[_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeDmdCom))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbDmdCom))]),_vm._v("\n                                                    Commandes à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeDmdCom}},[_c('el-table-column',{attrs:{"prop":"dateLivr","label":"Date de livraison"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user","width":"200","label":"Demandeur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projet","width":"300","label":"Projet"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chantier","width":"300","label":"Chantier"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"travaux","width":"270","label":"travaux"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailDmdCom(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                                Detail\n                                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeFour))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total des factures  à valider: ")]),_vm._v("  "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(new Intl.NumberFormat().format(_vm.mntTotalFactTTC))+" Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbFactFour))]),_vm._v("\n                                                    Factures à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Facture par fournisseur"},on:{"clear":function($event){return _vm.clearSelectFour()},"change":_vm.filtrerFour},model:{value:(_vm.selectFour),callback:function ($$v) {_vm.selectFour=$$v},expression:"selectFour"}},_vm._l((_vm.listeFournisseurs),function(item,ind){return _c('el-option',{key:ind,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeFacturesFour}},[_c('el-table-column',{attrs:{"prop":"date","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref","label":"Référence"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(_vm._s(new Intl.NumberFormat('fr-Fr').format(scope.row.total)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleFour","label":"Fournisseur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailFour(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                                Detail\n                                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeDmdFond))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total  à valider: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntTotalDmdFondTTC)+" Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbDmdFond))]),_vm._v("\n                                                    Demande de fonds à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Demandeur"},on:{"clear":function($event){return _vm.clearSelectFour()},"change":_vm.filtrerDmdFond},model:{value:(_vm.selectDmdFond),callback:function ($$v) {_vm.selectDmdFond=$$v},expression:"selectDmdFond"}},_vm._l((_vm.listeDemandeurFond),function(item,ind){return _c('el-option',{key:ind,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeDmdFond}},[_c('el-table-column',{attrs:{"prop":"dateFormat","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demandeur","label":"Nom du demandeur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantFormat","label":"Montant (Fcfa)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"typeDmd","label":"Type demande"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailDmdFond(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                                Detail\n                                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.droitAcces.all_appro_no_valid_dg)?_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeAppro))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total  à valider: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntTotalAppro)+" F Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:" mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbAppro))]),_vm._v("\n                                                    Approvisionnement(s) à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Facture par fournisseur"},on:{"clear":function($event){return _vm.clearSelectFour()},"change":_vm.filtrerFour},model:{value:(_vm.selectFour),callback:function ($$v) {_vm.selectFour=$$v},expression:"selectFour"}},_vm._l((_vm.listeFournisseurs),function(item,ind){return _c('el-option',{key:ind,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeDmdNoValidAppro}},[_c('el-table-column',{attrs:{"prop":"dateDmd","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"caisseLibelle","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(_vm._s(scope.row.montant)+" FCFA")])]}}],null,false,1202447318)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailAppro(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                            Detail\n                                                        ")],1)]}}],null,false,2190206670)})],1)],1)],1)],1)],1):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450"},model:{value:(_vm.dialogValideSuivant),callback:function ($$v) {_vm.dialogValideSuivant=$$v},expression:"dialogValideSuivant"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(" Validation suivante ")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez-vous passer à la validation suivante ?","closable":false,"show-icon":"","type":"warning"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogValideSuivant = false}}},[_vm._v("Non")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideSuivant()}}},[_vm._v("Afficher le fiche suivante")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450"},model:{value:(_vm.dialogValideSuivant),callback:function ($$v) {_vm.dialogValideSuivant=$$v},expression:"dialogValideSuivant"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(" Validation suivante ")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez-vous passer à la validation suivante ?","closable":false,"show-icon":"","type":"warning"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){return _vm.CancelValideSuivant()}}},[_vm._v("Non")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideSuivant()}}},[_vm._v("Afficher le fiche suivante")])],1)],1)],1)],1),_vm._v(" "),_c('ModalValidationInterv',{attrs:{"intervDetail":_vm.intervDetail,"totalFact":_vm.mntTotalIntervTTC,"show":_vm.showModalIntervFact},on:{"close":_vm.showDialogIntervAfter}}),_vm._v(" "),_c('ModalValidationFacture',{attrs:{"factureDetail":_vm.factureDetail,"totalFact":_vm.mntTotalFactTTC,"show":_vm.showModalDetailFact,"listCaisse":_vm.listCaisse,"listBanque":_vm.listBanque,"commandeDeriv":_vm.commandeDeriv,"commandeDerivDeux":_vm.commandeDerivDeux,"mntTotalCmd":_vm.mntTotalCmd,"nbCommandeSug":_vm.nbCommandeSug,"nbCommandeSugDeux":_vm.nbCommandeSugDeux},on:{"close":_vm.showDialogFactAfter}}),_vm._v(" "),_c('ModalValidationDmd',{attrs:{"demandeDetail":_vm.demandeDetail,"show":_vm.showModalDetailDmd},on:{"close":_vm.showDialogDmdAfter}}),_vm._v(" "),_c('ModalValidationMiss',{attrs:{"detailMission":_vm.detailMission,"show":_vm.showModalDetailMiss},on:{"close":_vm.showDialogMissAfter}}),_vm._v(" "),_c('ModalValidationDmdFond',{attrs:{"valider":true,"logistique":true,"demandeDetail":_vm.demandeDetail,"show":_vm.showModalDetailDmdFond},on:{"close":_vm.showDialogDmdFondAfter}}),_vm._v(" "),_c('ModalValidationAppro',{attrs:{"approDetail":_vm.ApproDetail,"listCaisse":_vm.listCaisse,"listBanque":_vm.listBanque,"show":_vm.showModalDetailAppro},on:{"close":function($event){_vm.showModalDetailAppro = false; _vm.loadDmdNoValidAppro()}}}),_vm._v(" "),_c('ModalValidationDex',{attrs:{"detailCommande":_vm.detailCommande,"totalMontant":_vm.totalMontant,"show":_vm.showModalDetailDmdCom},on:{"close":_vm.showDialogDmdComAfter}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TKxh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListeWorklogPorjet_vue__ = __webpack_require__("QBHE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a43c3c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListeWorklogPorjet_vue__ = __webpack_require__("BrKG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListeWorklogPorjet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a43c3c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListeWorklogPorjet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TNey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_boardTravaux_ListePresence__ = __webpack_require__("HaGr");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_3__components_Loading__["a" /* default */], ListePresence: __WEBPACK_IMPORTED_MODULE_4__components_boardTravaux_ListePresence__["a" /* default */] },
    name: "RapportJournalier",
    props: {
        show: {
            type: Boolean
        },
        editRapport: {
            type: Boolean
        },
        detailTrx: {
            type: Object
        },
        dateRpt: {
            type: Date,
            default: function _default() {
                return new Date();
            }
        }
    },
    data: function data() {
        return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            loading: false,
            dialogRapport: false,
            e1: 1,
            d1: 1,
            items: [],
            index: null,
            dateRaport: '',
            dialogAccord: false,
            dialogNewRapport: false,

            formResoussourTechnik: {
                fonction: '',
                nbre: 0
            },

            //INFO
            formInfo: {
                vent: 0,
                pluie: 0,
                temp: 0,
                heurTravail: '',
                dateRapport: ''
            },
            datePickerRtp: {
                disabledDate: function disabledDate(date) {
                    return date > new Date();
                }
            },

            optionProduit: [{ type: "", code: "", produit: "", qte: 1, unite: "" }],
            //VISITEUR
            tableVisiteur: [],
            formVisiteur: {},

            // pour le ressource externe
            tableformExtern: [],
            formExternRes: {},
            //ARRET TRAVAUX
            formArret: {
                cause: ""
            },

            //INVENTAIRE
            formInventaire: {},
            tableInventaire: [],
            listeProduit: [],
            listeEtatMat: [{
                id: 1,
                label: "Bon etat"
            }, {
                id: 2,
                label: "Defectueux"
            }, {
                id: 3,
                label: "En panne"
            }],

            //vehicule affecte
            formVehicule: {},
            listeVehicule: [],
            tableVehicule: [],
            totalHeureVehicule: '',
            totalComHT: 0,
            totalQteCarb: 0,
            totalCouCarb: 0,
            totTTCFormatDepen: 0,

            //Ressource
            formRessource: {
                image: null
            },
            tableRessource: [],
            listeRessource: [],
            matriculVehicule: '',
            listePhotos: [],
            listeProduitAffich: [],
            valeurUniteMateriel: '',
            listTypeRessource: [],
            logoProjet: "/static/img-doc.png",
            fileRes: "",
            fichierRes: [],
            imageRes: "/static/avatar-conducteur.png",

            //TRAVAUX
            listeTaches: [],

            etatSoutraitance: false,
            tableTravaux: [],

            listeSouTraitant: [],
            formTravaux: {
                images: [],
                files: []
            },
            fileTache: "",
            listeEtatTrx: [{
                id: 1,
                label: "Terminé"
            }, {
                id: 2,
                label: "En exécution"
            }],
            listeActivite: [{
                id: 1,
                libelle: "OUI"
            }, {
                id: 2,
                libelle: "NON"
            }],
            imageTrx: "/static/travaux.jpg",
            imageTrx2: "/static/travaux.jpg",
            imageTrx3: "/static/travaux.jpg",
            imageTrx4: "/static/travaux.jpg",
            fichierImage: [],

            disabledEvolution: false,
            minEvolution: 1,
            totalVehicule: 0,
            maxEvolution: 1,
            listeControlleur: [],
            reponses: [{ text: "OUI", value: "OUI", id: 1 }, { text: "NON", value: "NON", id: 2 }],
            listeQualitatif: [{
                libelle: "Nbre d'accident avec arrêt de travail",
                reponse: "",
                qte: "",
                dateHarret: "",
                description: "",
                value: 1,
                type: 1

            }, {
                libelle: "Nbre d'accident sans arrêt de travail",
                reponse: "",
                qte: '',
                dateHarret: "",
                description: "",
                value: 2,
                type: 1
            }, {
                libelle: "Nbre de 1/4 d'heure Sécurité",
                reponse: "",
                qte: '',
                dateHarret: "",
                description: "",
                value: 3,
                type: 1
            }, {
                libelle: "Evacuation par ambulance",
                reponse: '',
                qte: "",
                dateHarret: "",
                description: "",
                value: 4,
                type: 2 //environnement
            }, {
                libelle: "Déversement accidentel (déchets liquide dangereux)",
                value: 5,
                type: 2, //environnement
                reponse: "",
                qte: 0,
                dateHarret: "",
                description: ""
            }, {
                libelle: "Passage de collecteur-transporteur de déchets",
                value: 6,
                reponse: "",
                qte: 0,
                dateHarret: "",
                description: "",
                type: 2 //environnement
            }, {
                libelle: "Déchets inertes produits",
                value: 7,
                reponse: "",
                qte: 0,
                dateHarret: "",
                description: "",
                type: 2 //environnement
            }, {
                libelle: "Déchets dangereux produits",
                value: 8,
                reponse: "",
                qte: 0,
                dateHarret: "",
                description: "",
                type: 2 //environnement
            }],

            tableQuestion: [],
            listePrestOuvriers: [],
            listeData: [],
            listeFonctions: [],
            tablePresence: [],
            tableRessTechnik: []

        };
    },

    computed: {},
    watch: {
        show: function show(newValue, oldvalue) {
            this.dialogRapport = newValue;

            if (newValue == true) {
                this.dropdata();
                this.d1 = 1;
                if (this.editRapport) {
                    var _tableVisiteur, _tableInventaire, _tableformExtern, _listeData, _tableVehicule, _tableTravaux;

                    console.log('detailTrx', this.detailTrx);
                    console.log('dateRpt', this.dateRpt);
                    var row = this.detailTrx;
                    this.formInfo.dateRapport = this.dateRpt;
                    this.detailTrx.libelle = row.libTrx;
                    this.resetForm();
                    console.log('detailTrx', this.detailTrx);

                    //  etape 1
                    this.formInfo.temp = row.temp;
                    this.formInfo.pluie = row.pluie;
                    this.formInfo.vent = row.vent;
                    this.formInfo.heurTravail = row.nmbreHeur;
                    this.formInfo.trancon = row.trancon;
                    this.formInfo.profil = row.profil;
                    this.formInfo.auProfil = row.auProfil;

                    //  etape 2
                    var transformedVisiteurs = row.listeVisiteurs.map(function (visiteur) {
                        var _visiteur$nomPrenom$s = visiteur.nomPrenom.split(" "),
                            _visiteur$nomPrenom$s2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_visiteur$nomPrenom$s, 2),
                            nom = _visiteur$nomPrenom$s2[0],
                            prenom = _visiteur$nomPrenom$s2[1];

                        return {
                            nom: nom,
                            prenom: prenom,
                            fonction: visiteur.fonction,
                            heure: visiteur.HeureDbut,
                            heureFin: visiteur.HeureFin
                        };
                    });
                    (_tableVisiteur = this.tableVisiteur).push.apply(_tableVisiteur, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(transformedVisiteurs));

                    (_tableInventaire = this.tableInventaire).push.apply(_tableInventaire, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(row.listeMateriels));

                    (_tableformExtern = this.tableformExtern).push.apply(_tableformExtern, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(row.listeExterneMateriels));

                    var transformedTechnik = row.listeRessourtechnik.map(function (visiteur) {
                        return {
                            nom: visiteur.nomPrenom,
                            heureDbt: visiteur.heureDbt,
                            fonction: visiteur.fonction,
                            heurePause: visiteur.heurePause,
                            heureIntem: visiteur.heureIntem,
                            heureTotal: visiteur.heureTotal,
                            heureFin: visiteur.HeureFin,
                            heureSuppl: visiteur.heureSuppl,
                            descriptionSupp: visiteur.descriptionSupp,
                            description: visiteur.description
                        };
                    });

                    (_listeData = this.listeData).push.apply(_listeData, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(transformedTechnik));

                    (_tableVehicule = this.tableVehicule).push.apply(_tableVehicule, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(row.listeVehicules));

                    var transformedTaches = row.listeTaches.map(function (tache) {
                        return {
                            libelle: tache.libTache,
                            qte: tache.qte,
                            unite: tache.unite,
                            imageTaches: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(tache.photos)),
                            description: tache.commentaire
                        };
                    });
                    (_tableTravaux = this.tableTravaux).push.apply(_tableTravaux, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(transformedTaches));
                } else {
                    this.formInfo.dateRapport = this.dateRpt;
                    var dateRpt = this.formInfo.dateRapport.getFullYear() + "-" + (this.formInfo.dateRapport.getMonth() + 1) + "-" + this.formInfo.dateRapport.getDate();
                    this.dateRaport = dateRpt;
                    this.formTravaux.unite = '';
                }
                this.loadTypeRessource();
                this.loadMateriel();
                this.loadVehicule();
                this.loadOuvrier();
                this.loadControlleur();
                this.loadProduit();
            }

            console.log('editRapport', this.editRapport);
        }
    },
    methods: {
        createNewRapport: function createNewRapport() {
            this.dialogNewRapport = false;
            this.dialogRapport = true;
            this.dropdata();
            this.d1 = 1;
            this.formInfo.dateRapport = this.dateRpt;
            this.formTravaux.unite = '';
            this.loadTypeRessource();
            this.loadMateriel();
            this.loadVehicule();
            this.loadOuvrier();
            this.loadControlleur();
            console.log('oii');

            // this.d1 = 1;
            // this.formInfo = {}
            // this.formArret = {}
            // this.formInventaire = []
            // this.tableInventaire = []     
            // this.formExternRes = []           
            // this.tableVisiteur = []                
            // this.formVisiteur = [],
            // this.tableformExtern = []
            // this.tablePresence = []
            // this.formInfo.dateRapport = this.dateRpt
        },

        //vide les tableaux et champs du formulaire
        dropdata: function dropdata() {
            this.tableVisiteur.splice(0);
            this.tableformExtern.splice(0);
            this.tableInventaire.splice(0);
            this.tablePresence.splice(0);
            this.tableTravaux.splice(0);
            this.tableQuestion.splice(0);
            this.tableRessTechnik.splice(0);
            this.formInfo = {};
            this.formArret = {};
            this.formTravaux.tache = '';
        },
        changeFile: function changeFile(file, fileList) {
            this.listePhotos.splice(0);
            var fileReader = new FileReader();

            for (var ind in fileList) {
                var filename = fileList[ind].name;
                if (filename.lastIndexOf(".") <= 0) {
                    return alert("Veuillez selectionner un  format de fichier valide ");
                }
                //fileReader.readAsDataURL(fileList[ind].raw)
                this.listePhotos.push(fileList[ind].raw);
                this.formTravaux.images.push(fileList[ind].raw);
            }
        },
        verifFormRessTechnik: function verifFormRessTechnik() {
            if (this.formResoussourTechnik.fonction != null && this.formResoussourTechnik.nbre != null) {
                return true;
            } else {
                return false;
            }
        },
        deleteRowRessTechnik: function deleteRowRessTechnik(index, rows) {
            rows.splice(index, 1);
        },
        loadTypeRessource: function loadTypeRessource() {
            var _this = this;

            var url = this.domaine + "product/typeRessource";
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    response.body.types.forEach(function (item) {
                        if (item.libelle != 'VEHICULE/ENGIN') {
                            _this.listTypeRessource.push(item);
                        }
                    });
                    _this.loading = false;
                }
            });
        },
        addRtechnik: function addRtechnik(item) {
            if (item.fonction == null || item.fonction == "undefined" || item.nbre == "undefined" || item.nbre == null) {
                this.$message.error("Veuillez renseigner correctement les champs");
                return;
            }
            this.tableRessTechnik.push({
                fonction: item.fonction,
                nbre: item.nbre
            });
            this.formResoussourTechnik = {};
        },
        handleChangeCont: function handleChangeCont(val) {
            var control = this.listeControlleur.filter(function (elt) {
                if (elt.nom == val) {
                    return true;
                }
                return false;
            });
            if (control[0] != undefined && control[0].prenom != null) {
                this.formVisiteur.prenom = control[0].prenom;
                this.formVisiteur.fonction = control[0].fonction;
            }
        },
        handleChangeResource: function handleChangeResource(res) {
            if (res != undefined) {
                this.formRessource.fonction = res.profession;
            }
        },
        resetForm: function resetForm() {
            this.tableTravaux.splice(0);
            this.tableInventaire.splice(0);
            this.tableVisiteur.splice(0);
            this.tableformExtern.splice(0);
            this.tableRessource.splice(0);
        },
        closeDialog: function closeDialog() {
            this.resetForm();
            this.$emit("close");
        },
        createRapport: function createRapport() {
            var _this2 = this;

            var url = this.domaine + "journal/new";
            var data = new FormData();
            if (this.formTravaux.activite == 'NON' && this.formTravaux.descriptionActivite == undefined || this.formTravaux.descriptionActivite == 'undefined') {
                this.$notify({
                    title: "Erreur dans l'enrregistrement",
                    message: "Veuillez saisir le motif",
                    type: "error",
                    position: "top-center"
                });
            } else {

                //enregistrement des tables
                data.append("tableVisiteur", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableVisiteur));
                data.append("tableVehicule", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableVehicule));
                data.append("tableRessource", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tablePresence));
                data.append("tableTravaux", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableTravaux));

                // LISTE DES PERSONNES RESSOURCES
                for (var prop in this.tableRessTechnik) {
                    var ligne = this.tableRessTechnik[prop];
                    data.append("persRessource[fonction][]", ligne.fonction);
                    data.append("persRessource[nbre][]", ligne.nbre);
                }

                // LISTE DES RESSOURCES EXTERNE
                for (var _prop in this.tableformExtern) {
                    var _ligne = this.tableformExtern[_prop];
                    data.append("reExterne[type][]", _ligne.type);
                    data.append("reExterne[libelle][]", _ligne.libelle);
                    data.append("reExterne[unite][]", _ligne.unite);
                    data.append("reExterne[qte][]", _ligne.qte);
                    data.append("reExterne[cout][]", _ligne.cout);
                    data.append("reExterne[heureDbt][]", _ligne.heure);
                    data.append("reExterne[heureFin][]", _ligne.heureFin);
                }

                // LISTE DES INVENTAIRES
                for (var _prop2 in this.tableInventaire) {
                    var _ligne2 = this.tableInventaire[_prop2];
                    data.append("inventaire[type][]", _ligne2.type);
                    data.append("inventaire[libelle][]", _ligne2.libelle);
                    data.append("inventaire[qte][]", _ligne2.qte);
                    data.append("inventaire[prix][]", _ligne2.prix);
                }

                // REPONSE AU QUESTION
                for (var _prop3 in this.listeQualitatif) {
                    var _ligne3 = this.listeQualitatif[_prop3];
                    data.append("options[reponse][]", _ligne3.reponse);
                    data.append("options[value][]", _ligne3.value);
                    data.append("options[qte][]", _ligne3.qte);
                    data.append("options[type][]", _ligne3.type);
                    data.append("options[dateHarret][]", _ligne3.dateHarret);
                    data.append("options[description][]", _ligne3.description);
                }

                // ENVOI TACHES
                for (var _prop4 in this.tableTravaux) {
                    var _ligne4 = this.tableTravaux[_prop4];
                    var img = this.tableTravaux[_prop4].imageTaches;
                    img.forEach(function (file) {
                        data.append("travaux[fichierImage][]", file, file[name]);
                    });
                    data.append("travaux[idOptTrx][]", _ligne4.idOptTrx);
                    data.append("travaux[libelle][]", _ligne4.libelle);
                    data.append("travaux[tache][]", _ligne4.tache);
                    data.append("travaux[soustraitant][]", _ligne4.sousTraitant);
                    data.append("travaux[qte][]", _ligne4.qte);
                    data.append("travaux[qteEffect][]", _ligne4.qteEffect);
                    data.append("travaux[imageTaches][]", _ligne4.imageTaches);
                    data.append("travaux[description][]", _ligne4.description);

                    img.forEach(function (file) {
                        data.append("fichierImage[]", file, file[name]);
                    });
                }

                //autre
                var dateRpt = this.formInfo.dateRapport.getFullYear() + "-" + (this.formInfo.dateRapport.getMonth() + 1) + "-" + this.formInfo.dateRapport.getDate();
                data.append("dateRapport", dateRpt);
                data.append('profil', this.formInfo.profil);
                data.append('auProfil', this.formInfo.auProfil);
                data.append("temp", this.formInfo.temp);
                data.append("trancon", this.formInfo.trancon);
                data.append("pluie", this.formInfo.pluie);
                data.append("vent", this.formInfo.vent);
                data.append("heurTravail", this.formInfo.heurTravail);
                data.append("activite", this.formTravaux.activite);
                data.append("descriptionActivite", this.formTravaux.descriptionActivite);

                data.append("idUser", this.user.id);
                data.append("idTravaux", this.detailTrx.idTrx);

                this.loading = true;
                this.$http.post(url, data).then(function (resp) {
                    _this2.loading = false;
                    _this2.$notify({
                        title: "Journal chantier enregistré",
                        message: resp.body.message,
                        type: "success",
                        position: "top-right",
                        duration: 7000
                    });
                    _this2.tableQuestion.splice(0);
                    _this2.tableTravaux.splice(0);
                    _this2.tableVisiteur.splice(0);
                    _this2.tableformExtern.splice(0);
                    _this2.tableInventaire.splice(0);
                    _this2.tableRessource.splice(0);
                    _this2.tableRessTechnik.splice(0);

                    _this2.$emit("reloadListeTrx");
                    _this2.closeDialog();
                    _this2.dialogAccord = false;
                    _this2.dialogNewRapport = true;
                }, function (resp) {
                    _this2.loading = false;
                    _this2.$message.error("Erreur lors de l'enregistrement du journal");
                });
            }
        },
        deleteRow: function deleteRow(index, rows) {
            rows.splice(index, 1);
        },
        deleteRowVehicule: function deleteRowVehicule(index, rows) {
            rows.splice(index, 1);
            var tab = this.tableVehicule;
            var totalH = 0;
            var totalQteCarbu = 0;
            var totalCouCarbu = 0;
            var totalMtanDepen = 0;
            for (var _index = 0; _index < tab.length; _index++) {
                var element = tab[_index];
                var hr = this.TransFomrToMinut(element['heureTotal']);
                totalH += hr;
                totalQteCarbu += element['qte'];
                totalMtanDepen += parseFloat(element['total']);
            }
            this.totalComHT = this.TransFomrToHeur(totalH);
            this.totalQteCarb = totalQteCarbu;
            this.totTTCFormatDepen = totalMtanDepen;
        },

        //INFOW
        verifFormInfo: function verifFormInfo() {
            if (this.formInfo.dateRapport != null && this.formInfo.profil != "" && this.formInfo.profil != null && this.formInfo.heurTravail != null && this.formInfo.auProfil != null && this.formInfo.trancon != null) {
                return true;
            } else {
                return false;
            }
        },

        //VISITEUR
        addListVisiteur: function addListVisiteur(item) {
            this.tableVisiteur.push({
                nom: item.nom,
                prenom: item.prenom,
                fonction: item.fonction,
                heure: item.heure,
                heureFin: item.heureFin
            });

            this.formVisiteur = {};
        },

        // RESSOURCE EXTERNE
        addListRessouE: function addListRessouE(item) {
            this.tableformExtern.push({
                type: item.type,
                libelle: item.libelle,
                unite: item.unite,
                qte: item.qte,
                cout: item.cout,
                heure: item.heure,
                heureFin: item.heureFin
            });

            this.formExternRes = {};
        },
        addListArret: function addListArret(item) {
            this.tableQuestion.push({
                libelle: item.libelle.libelle,
                qte: item.qte,
                dateH: item.dateHarret,
                description: item.description,
                type: item.libelle.type
            });

            this.formArret = {};
        },
        verifFormQuestion: function verifFormQuestion() {
            var i = void 0;
            var comp = 0;
            for (i = 0; i < this.listeQualitatif.length; i++) {

                if (this.listeQualitatif[i].reponse != '') {
                    comp = comp + 1;
                    if (comp == 8) return true;
                } else {
                    return false;
                }
            }
        },
        verifFormVisiteur: function verifFormVisiteur() {
            if (this.formVisiteur.nom != null && this.formVisiteur.prenom != null && this.formVisiteur.fonction != null && this.formVisiteur.heure != null) {
                return true;
            } else {
                return false;
            }
        },
        veriformExternRes: function veriformExternRes() {
            if (this.formExternRes.type != null && this.formExternRes.libelle != null && this.formExternRes.qte != null && this.formExternRes.heure != null && this.formExternRes.heureFin != null) {
                return true;
            } else {
                return false;
            }
        },
        verifFormArret: function verifFormArret() {
            if (this.formArret.libelle != null && this.formArret.qte != null && this.formArret.dateHarret != null && this.formArret.description != null) {
                return true;
            } else {
                return false;
            }
        },

        //RESSOURCE
        addListRessource: function addListRessource(item) {
            this.tableRessource.push({
                nom: item.nom.nom,
                fonction: item.fonction,
                image: this.imageRes,
                file: item.image
            });
            this.formRessource = {};
            this.imageRes = "";
        },
        verifFormRessource: function verifFormRessource() {
            if (this.formRessource.nom != null && this.formRessource.fonction != null) {
                return true;
            } else {
                return false;
            }
        },
        loadOuvrier: function loadOuvrier() {
            var _this3 = this;

            this.loading = true;
            var url = this.domaine + "ouvrier/index";
            var formdata = new FormData();
            formdata.append("user", this.user.id);
            this.$http.post(url, formdata).then(function (response) {

                _this3.loading = false;
                _this3.listeRessource = response.body.ouvrier;
            }, function (response) {
                _this3.loading = false;
            });
        },
        loadControlleur: function loadControlleur() {
            var _this4 = this;

            this.loading = true;
            var url = this.domaine + "controlleur/index";
            this.$http.get(url).then(function (response) {
                _this4.loading = false;
                _this4.listeControlleur = response.body.controlleurs;
            }, function (response) {
                _this4.loading = false;
            });
        },
        onFileResPicked: function onFileResPicked(event) {
            var _this5 = this;

            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }
            if (files[0].size > 10485760) {
                this.$message.error("La taille du fichier est supérieur à 10M");
                return;
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this5.imageRes = fileReader.result;
            });

            fileReader.readAsDataURL(files[0]);
            this.formRessource.image = files[0];
            //this.file = files[0];
            this.fichierRes.push(files[0]);
        },


        //INVENTAIRE
        addListInventaire: function addListInventaire(item) {
            console.log('item', item);
            this.tableInventaire.push({
                type: item.produit.type,
                code: item.codeGestion ? item.codeGestion : 'non defini',
                libelle: item.produit.value,
                idProduit: item.produit.id,
                etat: item.etat,
                unite: this.valeurUniteMateriel,
                qte: item.qte,
                prix: item.prix
            });
            this.valeurUniteMateriel = '';
            this.optionProduit = [{ type: "", code: "", produit: "", qte: 1, unite: "" }], this.formInventaire = {};
        },
        verifFormInventaire: function verifFormInventaire() {
            if (this.formInventaire.libelle != null && this.formInventaire.qte != null && this.formInventaire.unite != null) {
                return true;
            } else {
                return false;
            }
        },


        //vehicule
        addListVehicule: function addListVehicule(item) {
            //verifions ce vehicule fifure deja dans la liste
            var veh = this.tableVehicule.find(function (elt) {
                return elt.matricule == item.libelle;
            });

            var infoVeh = this.listeVehicule.find(function (elt) {
                return elt.matricule == item.libelle;
            });
            if (veh == undefined) {
                this.tableVehicule.push({
                    libelle: infoVeh.libelle,
                    heureDebut: item.heureDebut,
                    heureFin: item.heureFin,
                    matricule: infoVeh.matricule,
                    idVeh: infoVeh.idVeh,
                    heurePause: item.heurePause,
                    cptDjour: item.cptDjour,
                    cptFjour: item.cptFjour,
                    qte: item.qte,
                    cout: item.cout,
                    utilisation: item.utilisation,
                    total: item.total,
                    totalForma: item.total.replace(/\s/g, ''),
                    heureTotal: this.totalHeureVehicule,
                    description: item.description
                });
                var tab = this.tableVehicule;
                var totalH = 0;
                var totalQteCarbu = 0;
                var totalCouCarbu = 0;
                var totalMtanDepen = 0;
                for (var index = 0; index < tab.length; index++) {

                    var element = tab[index];
                    var hr = this.TransFomrToMinut(element['heureTotal']);
                    totalH += hr;
                    totalQteCarbu += element['qte'];
                    totalMtanDepen += parseFloat(element['total'].replace(/\s/g, ''));
                }
                this.totalComHT = this.TransFomrToHeur(totalH);
                this.totalQteCarb = totalQteCarbu;
                this.totTTCFormatDepen = totalMtanDepen;
            } else {
                this.$message.warning("Cet véhicule a déjà été renseignée");
            }
            this.matriculVehicule = '';
            this.formVehicule = {};
            this.totalHeureVehicule = '';
        },
        findCoutVehicule: function findCoutVehicule() {
            var _this6 = this;

            var libelle = this.formVehicule.libelle;
            var resultat = 0;
            this.listeVehicule.forEach(function (element) {
                if (element.ref == libelle) {
                    _this6.matriculVehicule = element.immatriculation;
                    resultat = element.valeur;
                }
                //   let elementFound = element.vehicule.find(prod => {
                //     this.matriculVehicule = prod.immatriculation
                //       return prod.value == libelle;
                //     });
                //     resultat = elementFound.valeur
                // return elementFound.valeur
            });
            this.formVehicule.utilisation = new Intl.NumberFormat('fr-Fr').format(resultat);
        },
        TransFomrToMinut: function TransFomrToMinut(item) {
            var tabDateDbt = item.split(":"); //[00:00"]
            var hr = tabDateDbt[0];
            var min = tabDateDbt[1];
            var minute = void 0;

            minute = parseFloat(hr * 60) + parseFloat(min);
            return minute;
        },
        TransFomrToHeur: function TransFomrToHeur(item) {
            var heure = void 0;
            var minute = void 0;
            heure = Math.floor(item / 60);
            minute = parseFloat(item - heure * 60);

            return minute != 0 ? heure + ':' + minute : heure + ':' + '00';
        },
        calculTotalHeure: function calculTotalHeure() {

            var maxDate = this.formVehicule.heureFin;
            var minDate = this.formVehicule.heureDebut;
            if (maxDate != null && minDate != null) {
                var heureDebut = this.TransFomrToMinut(this.formVehicule.heureDebut);
                var heureFin = this.TransFomrToMinut(this.formVehicule.heureFin);

                var dureeMinute = heureFin - heureDebut;
                // 480 minute equivaut a 8h de travail
                // if(dureeMinute <= 480){
                var heurePause = this.TransFomrToMinut(this.formVehicule.heurePause);
                var hr = parseFloat(heureFin) - parseFloat(heureDebut) - parseFloat(heurePause);
                this.totalHeureVehicule = this.TransFomrToHeur(hr);
                // }else{
                //   this.$notify({
                //           title: "Enregistrement",
                //           message: "l'heure total de travail ne doit dépasser 8h",
                //           type: "error",
                //           position: "top-right",
                //           duration: 4000
                //       });
                //       this.formVehicule.heureFin =''
                // }
            }
        },
        calculTotalComm: function calculTotalComm() {
            var HeurUtil = void 0;
            var totalHVehiCHn = this.totalHeureVehicule.split(":"); //[00:00"]
            if (totalHVehiCHn[1] == "00") {
                HeurUtil = totalHVehiCHn[0];
            } else {
                HeurUtil = (totalHVehiCHn[0] + totalHVehiCHn[1]) / 100;
            }

            this.totComLigneTTC = 0;
            var couTutilisation = this.formVehicule.utilisation.replace(/\s/g, '');
            var qte = this.formVehicule.qte;
            var coutCarBur = this.formVehicule.cout;

            var totalHTRS = parseInt(qte * coutCarBur);
            var totalTVA = parseInt(couTutilisation * HeurUtil);
            var totalRemise = 0;
            var depense = totalHTRS + totalTVA;

            this.formVehicule.total = new Intl.NumberFormat('fr-Fr').format(depense);
        },
        verifFormVehicule: function verifFormVehicule() {
            if (this.formVehicule.libelle != null && this.formVehicule.qte != null && this.formVehicule.heureDebut != null && this.formVehicule.heureFin != null) {
                return true;
            } else {
                return false;
            }
        },
        loadMateriel: function loadMateriel() {
            var _this7 = this;

            this.loading = true;
            var url = this.domaine + "product/product-list/materiel/type";
            var formdata = new FormData();
            formdata.append("user", this.user.id);
            this.$http.post(url, formdata).then(function (response) {
                if (response.body) {
                    _this7.loading = false;
                    _this7.listeProduit = response.body.produits;
                }
            }, function (response) {
                _this7.loading = false;
            });
        },
        loadVehicule: function loadVehicule() {
            var _this8 = this;

            this.loading = true;
            // let url = this.domaine + "product/product-list/vehicule/travaux/"+this.detailTrx.idTrx;

            var type = 'flotte';
            var url = this.domaine + 'parc/index/type' + '/' + type;
            var formdata = new FormData();
            formdata.append("user", this.user.id);
            this.$http.post(url, formdata).then(function (response) {
                if (response.body) {
                    _this8.loading = false;
                    _this8.listeVehicule = response.body.vehicule;
                }
            }, function (response) {
                _this8.loading = false;
            });
        },


        //TRAVAUX
        addListTravaux: function addListTravaux() {
            var item = this.formTravaux;

            //verifions si ces travaux n'ont pas deja ete selectionne
            var opt = this.tableTravaux.find(function (elt) {
                return elt.idTache == item.tache;
            });

            if (opt == undefined) {
                //  pour la tache
                var valeur = '';
                valeur = this.listeTaches.find(function (element) {
                    if (element.idTache == item.tache) {
                        return element;
                    }
                });

                // pour la tache soustraiter
                var fourn = '';
                if (this.listeSouTraitant.length > 0) {
                    fourn = this.listeSouTraitant.find(function (element) {
                        if (element.id == item.sousTraitant) {
                            return element;
                        }
                    });
                }

                this.tableTravaux.push({
                    libelle: valeur.libelle,
                    idOptTrx: valeur.opt.idOptTrx,
                    idTache: item.idTache,
                    qteEffect: item.qteEffect,
                    libellSousTrai: fourn ? fourn.libelle : '',
                    soustraitant: item.soustraitant,
                    qte: item.qte,
                    unite: item.unite,
                    files: item.files,
                    images: item.images,
                    evolution: item.evolution,
                    description: item.description,
                    imageTaches: this.listePhotos
                });
            } else {
                this.$message.error("Cette tâche a déjà été renseignée");
            }

            this.$refs.uploadFichContrat.clearFiles();
            this.listePhotos = [];
            this.formTravaux.libelle = null;
            this.formTravaux.libelle = null;
            this.formTravaux.qte = 0;
            this.formTravaux.qteEffect = null;
            this.formTravaux.description = '';

            //this.formTravaux.evolution = null;
        },
        showDiapo: function showDiapo(images, ind, image) {
            this.items = images;
            this.index = ind;
        },
        handleSelect: function handleSelect(id) {
            if (id == '' || id == null) {
                this.handleChangeTrx(this.formTravaux.tache);
            } else {
                this.formTravaux.qteTotal = 0;
                var valeur = '';
                console.log('listeSouTraitant', listeSouTraitant);
                valeur = this.listeSouTraitant.find(function (element) {
                    if (element.id == id) {
                        return element;
                    }
                });
                this.formTravaux.qteTotal = valeur.qte;
                this.formTravaux.qteEffect = valeur.qteRapport;
                this.maxEvolution = valeur.qteRestante;
            }

            // if(val == "Terminé")
            // {
            //     this.formTravaux.evolution = 100;
            //     this.disabledEvolution = true;
            // }else if(val == "En exécution")
            // {
            //     this.disabledEvolution = false;
            // }
        },
        handleChangeTrx: function handleChangeTrx(opt) {
            console.log('opt', opt);
            var valeur = '';
            if (opt) {
                valeur = this.listeTaches.find(function (element) {
                    if (element.idTache == opt) {
                        return element;
                    }
                });
                console.log('valeur', valeur);
                this.listeSouTraitant = valeur.listSoustraitant.info ? valeur.listSoustraitant.info : 0;
                this.minEvolution = valeur.opt.evolution;
                this.maxEvolution = valeur.opt.maxEvolution;
                this.formTravaux.qteEffect = valeur.opt.qteEffect;
                this.formTravaux.unite = valeur.opt.unite;
                this.formTravaux.qteTotal = valeur.opt.qteTotal;
            }
        },
        onFileTachePicked: function onFileTachePicked(event) {
            var _this9 = this;

            this.formTravaux.images.splice(0, 1);
            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }
            if (files[0].size > 10485760) {
                this.$message.error("La taille du fichier est supérieur à 10M");
                return;
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this9.formTravaux.images.push(fileReader.result);
            });

            fileReader.readAsDataURL(files[0]);
            this.formTravaux.files.push(files[0]);
            this.file = files[0];
            this.fichierImage.push(files[0]);
        },
        onFileTachePicked2: function onFileTachePicked2(event) {
            var _this10 = this;

            this.formTravaux.images.splice(1, 1);
            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }
            if (files[0].size > 10485760) {
                this.$message.error("La taille du fichier est supérieur à 10M");
                return;
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this10.formTravaux.images.push(fileReader.result);
            });

            fileReader.readAsDataURL(files[0]);
            this.formTravaux.files.push(files[0]);
            this.file = files[0];
            this.fichierImage.push(files[0]);
        },
        onFileTachePicked3: function onFileTachePicked3(event) {
            var _this11 = this;

            this.formTravaux.images.splice(2, 1);
            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }
            if (files[0].size > 10485760) {
                this.$message.error("La taille du fichier est supérieur à 10M");
                return;
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this11.formTravaux.images.push(fileReader.result);
            });

            fileReader.readAsDataURL(files[0]);
            this.formTravaux.files.push(files[0]);

            this.fichierImage.push(files[0]);
        },
        onFileTachePicked4: function onFileTachePicked4(event) {
            var _this12 = this;

            this.formTravaux.images.splice(3, 1);
            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }
            if (files[0].size > 10485760) {
                this.$message.error("La taille du fichier est supérieur à 10M");
                return;
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this12.formTravaux.images.push(fileReader.result);
            });

            fileReader.readAsDataURL(files[0]);
            this.formTravaux.files.push(files[0]);

            this.fichierImage.push(files[0]);
        },
        verifFormTravaux: function verifFormTravaux() {
            if (this.formTravaux.tache != null && this.formTravaux.qte >= 0) {
                return true;
            } else {
                return false;
            }
        },
        verifTableTravaux: function verifTableTravaux() {
            if (this.formInfo.dateRapport) {
                var dateRpt = this.formInfo.dateRapport.getDate() + "-" + (this.formInfo.dateRapport.getMonth() + 1) + "-" + this.formInfo.dateRapport.getFullYear();
                this.dateRaport = dateRpt;
            }
            if (this.tableTravaux.length != 0 || this.formTravaux.activite == 'NON') {
                return true;
            } else {
                return false;
            }
        },
        loadTache: function loadTache() {
            var _this13 = this;

            this.loading = true;
            var url = this.domaine + "tache/travaux/cours/" + this.detailTrx.idTrx;
            var formdata = new FormData();

            formdata.append("user", this.user.id);
            formdata.append("dateRapport", this.dateRaport);
            this.$http.post(url, formdata).then(function (response) {

                _this13.loading = false;
                _this13.listeTaches = response.body.taches;
                _this13.etatSoutraitance = response.body.etatSoustraitance;

                if (_this13.listeTaches.length == 0) {
                    _this13.$message.error("Aucune tâche en cours ou planifiées pour ces travaux");
                }
            }, function (response) {
                _this13.loading = false;
            });
        },
        loadPresenceOuvrier: function loadPresenceOuvrier() {
            var _this14 = this;

            if (this.tableRessource.length > 0) {
                this.d1 = 2;
                return;
            }
            this.loading = true;
            var url = this.domaine + 'ouvrier/present/travaux/' + this.detailTrx.idTrx;
            var data = new FormData();
            var dateRpt = this.formInfo.dateRapport.getFullYear() + "-" + this.formInfo.dateRapport.getMonth() + "-" + this.formInfo.dateRapport.getDate();
            data.append("dateRapport", dateRpt);
            this.$http.post(url, data).then(function (response) {
                _this14.tableRessource = response.body.ouvriers;
                _this14.d1 = 2;
                _this14.loading = false;
            }, function (error) {
                _this14.loading = false;
                _this14.d1 = 2;
                _this14.$message.error('Chargement de la liste des ouvriers presents en cours');
            });
        },
        addOptionP: function addOptionP() {
            this.optionProduit.push({
                key: Date.now(),
                type: "",
                code: "",
                produit: "",
                qte: 1,
                unite: ""
            });
        },
        loadUniteProduit: function loadUniteProduit(item) {
            console.log('item', item);
            // let valeur
            //   valeur = this.listeProduitAffich.find(function (element) {
            //       if (element.value == item) {
            //         return element.unite;                        
            //       }
            //     });
            this.valeurUniteMateriel = item.unite;
        },
        loadProduit: function loadProduit() {
            var _this15 = this;

            var url = "";
            this.loading = true;
            url = this.domaine + "product/product-list";
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this15.loading = false;
                    _this15.listeProduitAffich = response.body;
                }
            });
        },
        loadTypeProduit: function loadTypeProduit(item) {
            var _this16 = this;

            if (this.$refs.typeProduit == "") {
                return;
            }
            this.loading = true;
            var url = this.domaine + "product/productSelect/type/" + item;
            this.$http.get(url).then(function (response) {
                _this16.loading = false;
                _this16.listeProduitAffich = response.body.produits;
            }, function (errRep) {
                _this16.loading = false;
                _this16.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
            });
        },
        loadOuvrierTravaux: function loadOuvrierTravaux() {
            var _this17 = this;

            //this.prestataireSelect.datePresence = null;
            //prestataireSelect.idC = null;
            this.loading = true;
            var url = this.domaine + "ouvrier/travaux/" + this.detailTrx.idTrx;
            this.$http.get(url).then(function (response) {
                _this17.listePrestOuvriers = response.body.ouvriers;
                _this17.loading = false;
            }, function (error) {
                _this17.loading = false;
                _this17.$message.error("Echec lors du chargement de la liste des ouvriers");
            });
        },
        loadRessourceTechnik: function loadRessourceTechnik() {
            var _this18 = this;

            this.loading = true;
            var url = this.domaine + "journal/listFonction";
            this.$http.get(url).then(function (response) {
                _this18.listeFonctions = response.body.fonction;
                _this18.loading = false;
            }, function (error) {
                _this18.loading = false;
                _this18.$message.error("Echec lors du chargement de la liste des ouvriers");
            });
        },
        resetFormRapprot: function resetFormRapprot() {
            this.tableRessource.splice(0);
        },
        loadListePresence: function loadListePresence(liste) {
            this.tablePresence = liste;
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "TNzk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_projet_DetailBudgetProjet__ = __webpack_require__("nu3F");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "BudgetProjet.vue",
    components: {
        Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */],
        DetailBudgetProjet: __WEBPACK_IMPORTED_MODULE_1__components_projet_DetailBudgetProjet__["a" /* default */]
    },
    data: function data() {
        return {
            //data general
            notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
            loading: false,
            racourcis: [{ path: "/budgetProjet", text: "Budget projet", disabled: false }],

            listeProjet: [],
            detProj: {},
            showDetailProj: false,
            totalMntPropose: 0,
            totalMntValide: 0,
            totalMntMarche: 0

        };
    },

    methods: {
        modalDetailProj: function modalDetailProj(itemProjet) {
            this.detProj = itemProjet;
            this.showDetailProj = true;
        },
        headerRowStyle: function headerRowStyle(_ref) {
            var row = _ref.row,
                rowIndex = _ref.rowIndex;

            return { "color": "black" };
        },
        loadBudget: function loadBudget() {
            var _this = this;

            //this.loading = true;
            var url = this.domaine + "compteExploit/budget/projet";
            this.$http.get(url).then(function (resp) {
                _this.listeProjet = resp.body.budgetsProjet;
                _this.totalMntPropose = resp.body.mntTotalBugPropose;
                _this.totalMntValide = resp.body.mntTotalBugValide;
                _this.totalMntMarche = resp.body.mntTotalBugMarche;
            }, function (error) {
                _this.loading = false;
                _this.$message.error("Une erreur est survenue lors du chargement des budget");
            });
        },
        getSummExploitBudget: function getSummExploitBudget(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = "Sous total";
                    return;
                }

                if (index === 3) {
                    sums[index] = "N/A";
                    return;
                }
                var values = data.map(function (item) {
                    return Number(item[column.property]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0));
                } else {
                    sums[index] = "N/A";
                }
            });

            return sums;
        }
    },

    mounted: function mounted() {
        this.loadBudget();
    }
});

/***/ }),

/***/ "TR78":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_besoin_ModalCommandeDetails__ = __webpack_require__("Dbyj");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//liste l'ensemble  des besoins  ou les besoinsa valider par un responsable



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */], ModalCommandeDetails: __WEBPACK_IMPORTED_MODULE_2__components_besoin_ModalCommandeDetails__["a" /* default */] },
  name: "listeBciResponsable",
  props: {
    show: {
      type: Boolean
    },
    typeReche: {
      type: String
    },
    idresponsable: {
      type: Number,
      default: null
    },
    listeTrx: {
      type: Array
    },
    listeBesoins: {
      type: Array
    },
    listeChantiers: {
      type: Array
    },
    idProjet: {
      type: Number
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "loading", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dialogValideBesoin", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "multipleSelection", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "items", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "index", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "listeProjet", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "listbesoins", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "listeChantier", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "listeTravaux", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "listeTaches", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "travauxS", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "tachesS", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "BesoinsList", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "projetS", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "valide", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "showModalDetailCom", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dialogDetailCommande", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "produitStock", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "chantierS", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "listeBesoinSelect", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectBci", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnValide", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "commDec", null), _ref;
  },

  watch: {
    show: function show(newValue, oldvalue) {
      if (newValue == true) {
        //this.oldListTravaux = this.listeTrx;
      }
    },
    listeBesoins: function listeBesoins(newValue, oldvalue) {
      this.BesoinsList = this.listeBesoins;
      this.listeChantier = this.listeChantiers;
    }
  },
  methods: {
    //FILTRE
    loadProjet: function loadProjet() {
      var _this = this;

      this.chantierS = "";
      this.listeChantier.splice(0);
      this.chantierS = null;
      var url = this.domaine + "projet/index/projet/all";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this.loading = false;
        _this.listeProjet = response.body.projet;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    showDiapo: function showDiapo(images, ind, image) {
      this.items = images;
      this.index = ind;
    },
    loadTravaux: function loadTravaux() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "projet/" + this.idProjet + "/all/travaux";
      this.$http.get(url).then(function (response) {
        _this2.loading = false;
        _this2.listeChantier = response.body.chantier;
      }, function (errRep) {
        _this2.loading = false;
        _this2.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    molalDetails: function molalDetails(row) {
      this.showModalDetailCom = true;
      this.listbesoins = row;
    },
    molalValidation: function molalValidation(row) {
      this.dialogValideBesoin = true;
      this.listeBesoinSelect = row;
      console.log('row', row);
      this.selectBci = row.id;
    },
    filtrerChantier: function filtrerChantier() {
      var idChant = this.chantierS;
      if (idChant == null || idChant == "undefined" || idChant == "") {
        this.BesoinsList = this.listeBesoins;
        // this.filtrerChantier()
        return;
      }
      this.BesoinsList = this.listeBesoins.filter(function (item) {
        return item.idChant == idChant;
      });
      var tableau = this.listeBesoins.filter(function (item) {
        return item.idChant == idChant;
      });
      for (var i = 0; i < tableau.length; ++i) {
        for (var j = i + 1; j < tableau.length; ++j) {
          if (tableau[i].idTravaux === tableau[j].idTravaux) {
            tableau.splice(j--, 1);
          }
        }
      }

      this.listeTravaux = tableau;
    },
    calculTotalComm: function calculTotalComm(item) {
      this.valide = false;
      var restant = item.qte - item.qteC;
      if (restant < item.qteR) {
        this.valide = true;
        this.$message.error("La quantité demandé ne dois pas etre supérieur a la quantité prévu ");
      }
    },
    filtrerTravaux: function filtrerTravaux() {
      var travauxS = this.travauxS;
      this.listeTaches = [];
      if (travauxS != "") {
        this.BesoinsList = this.listeBesoins;
      }
      if (travauxS == null || travauxS == "undefined" || travauxS == "") {
        this.BesoinsList = this.listeBesoins;
        // this.filtrerChantier()
        return;
      }

      var tab = this.BesoinsList;
      this.BesoinsList = tab.filter(function (item) {
        return item.idTravaux == travauxS;
      });

      var tableau = tab.filter(function (item) {
        return item.idTravaux == travauxS;
      });
      for (var i = 0; i < tableau.length; ++i) {
        for (var j = i + 1; j < tableau.length; ++j) {
          if (tableau[i].idTache === tableau[j].idTache) {
            tableau.splice(j--, 1);
          }
        }
      }
      this.listeTaches = tableau;
    },
    filtrerTaches: function filtrerTaches() {
      var idTache = this.tachesS;
      if (idTache == null || idTache == "undefined" || idTache == "") {
        //  this.BesoinsList = this.listeBesoins;
        this.filtrerTravaux();
        this.filtrerChantier();
        return;
      }
      this.filtrerChantier();
      var tab = this.BesoinsList;
      this.BesoinsList = tab.filter(function (item) {
        return item.idTache == idTache;
      });
    },
    modalValideBesoin: function modalValideBesoin() {
      this.listeBesoinSelect = this.multipleSelection.slice();
      this.dialogValideBesoin = true;
    },
    imprimeAllBesoins: function imprimeAllBesoins(item) {
      var url = this.domaine + "projet/impression/all/besoins/" + this.user.id + "/" + this.idProjet;
      window.open(url);
    },
    validRejetBesoin: function validRejetBesoin(decision) {
      var _this3 = this;

      if (this.valide == true) {
        this.$notify({
          title: "ENREGISTREMENT ECHOUE",
          message: "QUANTITE RENSSEIGNEE SUPERIEUR A LA QUANTITE PREVU.",
          type: "warning",
          position: "top-center"
        });
        return;
      }
      this.loading = true;

      //decision == 1 = Valider // decision == 0 //Refuser
      var url = this.domaine + "besoin/avalider";
      var nbData = 10;
      var nbReq = 1;
      var ligne = null;
      var nbRest = void 0;
      this.listeBesoinSelect = this.listeBesoinSelect.option;
      if (this.listeBesoinSelect.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.listeBesoinSelect.length / nbData);
        nbRest = this.listeBesoinSelect.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (var i = 0; i < nbReq; i++) {
        var initJ = i * nbData;
        var finJ = (i + 1) * nbData;
        var dataLot = [];
        if (this.listeBesoinSelect.length > 0) {
          for (var j = initJ; j < finJ; j++) {
            if (this.listeBesoinSelect[j] == undefined) {
              break;
            }
            dataLot.push(this.listeBesoinSelect[j]);
          }
        }
        var data = new FormData();
        for (var prop in dataLot) {
          ligne = dataLot[prop];
          data.append("option[id][]", ligne.id);
          data.append("option[dateLivrSouh][]", ligne.dateLivrSouh);
          data.append("option[qteR][]", ligne.qte);
        }
        data.append("decision", decision);
        data.append("commDec", this.commDec);
        data.append("type", this.typeReche);
        data.append("idUser", this.user.id);
        data.append("bci", this.selectBci);

        this.$http.post(url, data).then(function (resp) {
          _this3.dialogValideBesoin = false;
          _this3.loading = false;
          _this3.$emit("reloadBesoins");
          _this3.$notify({
            title: "Validation besoins",
            message: "L'opération s'est déroulée avec succès",
            type: "success",
            position: "top-center"
          });
        }, function (error) {
          _this3.dialogValideBesoin = false;
          _this3.loading = false;
          _this3.$message.error("Erreur lors du chargement de la validation des besoins");
        });
      }
    },
    showDialogComparaison: function showDialogComparaison(data) {
      var _this4 = this;

      this.loading = true;
      var formdata = new FormData();
      var url = this.domaine + "entrepot/projet/" + data.projetId + "/produit";
      for (var prop in data.option) {
        var ligne = data.option[prop];
        formdata.append("options[id][]", ligne.idProd);
      }
      this.$http.post(url, formdata).then(function (response) {
        _this4.produitStock = response.body.stock;
        _this4.loading = false;
        _this4.dialogDetailCommande = true;
      }, function (error) {
        _this4.loading = false;
        _this4.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.disabledBtnValide = true;
      } else {
        this.disabledBtnValide = false;
      }
    },
    headerRowStyle: function headerRowStyle(_ref2) {
      var row = _ref2.row,
          rowIndex = _ref2.rowIndex;

      return { color: "black" };
    }
  },
  computed: {
    verifDateSouh: function verifDateSouh() {
      var resutat = true;
      var datas = this.listeBesoinSelect.option;
      for (var prop in datas) {
        var ligne = datas[prop];
        if (ligne["dateLivrSouh"] == null || ligne["dateLivrSouh"] == undefined) {
          resutat = false;
          break;
        }
      }

      return resutat;
    },
    clearSelectTache: function clearSelectTache() {
      // this.tachesS = ''
      this.filtrerTravaux();
    },
    clearSelectTravaux: function clearSelectTravaux() {
      // this.travauxS = ''
      this.filtrerChantier();
    },
    clearSelectChantier: function clearSelectChantier() {
      this.chantierS = "";
      this.loadProjet();
    },

    verifBtnConfirme: function verifBtnConfirme() {
      if (this.verifDateSouh == true && this.commDec != null && this.commDec.toUpperCase() == "BON POUR ACCORD") {
        return true;
      }
      return false;
    },

    verifBtnRefus: function verifBtnRefus() {
      if (this.commDec != null) {
        return true;
      }
      return false;
    }
  },
  mounted: function mounted() {
    this.chantierS = "";
    // this.loadProjet();
    // this.loadChantier();
    // this.clearSelect();
  }
});

/***/ }),

/***/ "TU/U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elevation-2 pt-3 pl-3 pr-3",staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTES DES TRAVAUX "+_vm._s(_vm.periode))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-4 mt-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner un travaux"},on:{"change":function($event){return _vm.filtrerTravaux()}},model:{value:(_vm.travauxS),callback:function ($$v) {_vm.travauxS=$$v},expression:"travauxS"}},_vm._l((_vm.litesDesTrx),function(item){return _c('el-option',{key:item.idTrx,attrs:{"label":item.libelle,"value":item.idTrx}})}),1)],1),_vm._v(" "),(_vm.travauxS != '')?_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner un chantier"},on:{"change":function($event){return _vm.filtrerChantier()}},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.idChant,attrs:{"label":item.libChantier,"value":item.idChant}})}),1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs2":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeAllTravaux()}},slot:"activator"},[_vm._v("\n              Imprimer "),_c('v-icon',[_vm._v("print")])],1),_vm._v("\n            Imprimer la liste des travaux\n          ")],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.litesDesTrx},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"TRAVAUX","align":"center","width":"230","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libProjChant","label":"PROJET/CHANTIER","align":"center","width":"230","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"DATE","align":"center"}},[_c('el-table-column',{attrs:{"prop":"dateD","label":"DEBUT"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"FIN"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"DUREE (Jours) "}})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"EVOLUTION","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-progress-circular',{attrs:{"size":80,"width":15,"rotate":360,"value":scope.row.evolution,"color":"orange"}},[_vm._v("\n              "+_vm._s(scope.row.evolutionNbr)+" %\n            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libEtat","label":"STATUS","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteTotEfect","label":"QTE( EFFECT/TOTAL)","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idRapport","label":"RAPPORT JOURNALIER","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","width":"250","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.showModalTache(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("terrain")])],1),_vm._v(" "),_c('span',[_vm._v("taches")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(scope.row.etat == 1 && !_vm.commis && scope.row.evolutionNbr != 100)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"red","fab":"","dark":"","small":""},nativeOn:{"click":function($event){_vm.detailTravaux = scope.row;
                  _vm.dialogConfirmRefus = true;}},slot:"activator"},[_c('v-icon',[_vm._v("stop")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Suspendre les travaux")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(scope.row.nbJour == true)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"purple","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.loadRapportTrx(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("assignment")])],1):_vm._e(),_vm._v("Liste des rapports\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(
                  scope.row.isRapport == false &&
                    scope.row.evolutionNbr != 100 &&
                    scope.row.etat == 1
                )?_c('v-btn',{attrs:{"slot":"activator","color":"orange","fab":"","dark":"","small":""},nativeOn:{"click":function($event){_vm.detailTravaux = scope.row;
                  _vm.showRapport = true;}},slot:"activator"},[_c('v-icon',[_vm._v("note_add")])],1):_vm._e(),_vm._v("Effectuer rapport journalier\n            ")],1)]}}])})],1)],1)],1),_vm._v(" "),_c('RapportJournalier',{attrs:{"detailTrx":_vm.detailTravaux,"show":_vm.showRapport},on:{"close":function($event){_vm.showRapport = false},"reloadListeTrx":function($event){return _vm.$emit('reloadListeTravaux')}}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.dialogConfirmRefus),callback:function ($$v) {_vm.dialogConfirmRefus=$$v},expression:"dialogConfirmRefus"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Arrêter les travaux: "+_vm._s(_vm.detailTravaux.libelle))]),_vm._v(" "),_c('v-card-text',[_c('el-alert',{attrs:{"title":"Arrêt Travaux","description":"Toutes les tâches issues des travaux seront également arretées, pour relancer les travaux vous devez demarrer au moins une tâche","type":"warning","center":"","closable":false,"show-icon":""}}),_vm._v(" "),_c('el-form',{ref:"formRefus",staticClass:"demo-form-inline",attrs:{"id":"formRefus","label-position":"top","inline":true,"model":_vm.formRefus}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Voulez vous Arreter les travaux?"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Pourquoi voulez-vous Arreter cette tâche ?"},model:{value:(_vm.formRefus.rapport),callback:function ($$v) {_vm.$set(_vm.formRefus, "rapport", $$v)},expression:"formRefus.rapport"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialogConfirmRefus = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":function($event){return _vm.submitFormStop('formRefus')}}},[_vm._v("Confirmer")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogListeRapport),callback:function ($$v) {_vm.dialogListeRapport=$$v},expression:"dialogListeRapport"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("LISTE DES RAPPORTS DES TRAVAUX :\n          "+_vm._s(_vm.detailTravaux.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogListeRapport = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('ListeRapportTrx',{attrs:{"libTrx":_vm.detailTravaux.libelle,"type":_vm.type,"commis":_vm.commis,"typeInterface":true,"IddetailTravaux":_vm.detailTravaux.idTrx,"show":_vm.dialogListeRapport,"listeRapportTrx":_vm.listeRapports},on:{"close":function($event){_vm.dialogListeRapport = false}}})],1)],1)],1),_vm._v(" "),_c('IndexTache',{attrs:{"detailTrx":_vm.detailTravaux,"show":_vm.showDetailTache,"commis":_vm.commis},on:{"close":function($event){_vm.$emit('reloadListeTravaux');
      _vm.showDetailTache = false;},"reloadTrx":function($event){return _vm.$emit('reloadListeTravaux')}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Tf2e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompteExploitationChantier_vue__ = __webpack_require__("D1h6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12edbbb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompteExploitationChantier_vue__ = __webpack_require__("lvxF");
function injectStyle (ssrContext) {
  __webpack_require__("FWb0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompteExploitationChantier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12edbbb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompteExploitationChantier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TqBL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "AjoutTransfertCarte",
  props: {
    show: {
      type: Boolean,
      required: true
    },
    editRecharge: {
      type: Object,
      default: {}
    },
    carte: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      // racourcis: [
      //     { path: '/', text: 'Accueil', disabled: false },
      //     { path: '/demandeFond', text: 'Demande de fonds', disabled: true }
      // ],

      dialogAjoutCarteTransfert: false,
      rules: {
        montant: [{ required: true, message: "Veuillez saisir un montant" }]
      },
      comboChantier: [],
      comboMission: [],
      formRecharge: {
        carteCibleId: ""
      },
      typeRecharge: "Cash",
      dataCarteSource: [],
      dataCarteCible: [],
      stations: [],
      comboCarteSource: [],
      comboCarteCible: [],
      carteSourceId: "",
      carteCibleId: "",
      dateRecharge: ""
    };
  },


  watch: {
    show: function show(newValue, oldValue) {
      this.dialogAjoutCarteTransfert = newValue;

      if (newValue == true) {
        this.resetForm("formRecharge");
        this.loadCartes();
      }

      if (this.editRecharge.id != null && newValue == true) {

        this.formRecharge.montant = this.editRecharge.montant;
        this.formRecharge.description = this.editRecharge.description;
        this.dateRecharge = this.editRecharge.dateRechargeNonFormat;

        if (this.editRecharge.type == "Transfert de carte à carte") {
          this.typeRecharge = "Carte";
        }
        if (this.editRecharge.type == "Cash") {
          this.typeRecharge = "Cash";
        }
      }
    }
  },

  methods: {
    infoCarteCible: function infoCarteCible(idCarte) {
      if (idCarte != null) {
        this.loadInfoCarte(idCarte, 1);
      }
    },
    loadInfoCarte: function loadInfoCarte(idCarte) {
      var _this = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      this.loading = true;
      //this.dataCarteSource.splice(0)
      this.dataCarteCible.splice(0);
      var url = this.domaine + "carteCarburant/carte/" + idCarte;
      this.$http.get(url).then(function (response) {
        _this.loading = false;
        var carte = response.body.carte[0];

        if (source == 0) {
          _this.dataCarteSource.push({
            responsable: carte.responsable,
            solde: carte.montantFormat
          });
        } else if (source == 1) {
          _this.dataCarteCible.push({
            responsable: carte.responsable,
            solde: carte.montantFormat
          });
        }
      }, function (error) {
        _this.loading = false;
        _this.$message("Chargement des informations de la carte en cours");
      });

      //  this.comboCarteCible = this.comboCarteSource.filter(function (item) {
      //   return (item.carteId != idCarte )
      // })
    },
    loadCarteCible: function loadCarteCible(idCarte) {
      this.loading = true;
      this.loadInfoCarte(idCarte);
      this.comboCarteCible = this.comboCarteSource.filter(function (item) {
        return item.carteId != idCarte;
      });
    },
    loadCartes: function loadCartes() {
      var _this2 = this;

      this.loading = true;
      //let url = this.domaine +  'carteCarburant/carte/station/'+carte.carteId
      var url = this.domaine + "carteCarburant/index";
      var formdata = new FormData();
      this.$http.get(url).then(function (response) {
        _this2.loading = false;
        var carte = _this2.carte;
        _this2.comboCarteCible = response.body.cartes.filter(function (item) {
          return item.carteId != carte.carteId;
        });
      }, function (error) {
        _this2.loading = false;
        _this2.$message("Chargement de la liste des cartes en cours");
      });
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },


    // loadStation()
    // {
    //     let url = this.domaine +  'carteCarburant/station/index'
    //     var formdata = new FormData();

    //     this.$http.get(url).then(response => {

    //             this.stations = response.body.stations

    //     },
    //      error=> {
    //         this.$message("Chargement de la liste des stations en cours")
    //     })
    // },

    submitForm: function submitForm(formName) {
      var _this3 = this;

      //verifions si la carte a ete selection
      if (this.formRecharge.carteCibleId == "") {
        this.$message.error("Veuillez selectionner une carte");
        return;
      }
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          //this.loading = true
          var form = document.getElementById("formRecharge");
          //recuperation des demandes
          var data = new FormData(form);
          var url = _this3.domaine + "carteCarburant/recharge/create";

          data.append("userId", _this3.user.id);
          data.append("montant", _this3.formRecharge.montant);
          data.append("carteId", _this3.carte.carteId);
          data.append("dateRecharge", _this3.dateRecharge);
          data.append("carteSourceId", _this3.carte.carteId);
          data.append("carteCibleId", _this3.formRecharge.carteCibleId);

          _this3.$http.post(url, data).then(function (response) {
            //reinitialiser le formulaire
            _this3.loading = false;
            var code = response.body.code;
            _this3.carteCibleId = "";
            _this3.carteSourceId = "";
            _this3.resetForm("formRecharge");
            _this3.formRecharge.description = "";
            if (code == 1) {
              _this3.successNotif(response.body.message, "ENREGISTREMENT RECHARGE", "error");
            } else {
              _this3.successNotif(response.body.message, "ENREGISTREMENT RECHARGE");
            }

            _this3.closeDialog();
          }, function (erreur) {
            //reinitialiser le formulaire
            _this3.loading = false;
            _this3.resetForm("formRecharge");
            _this3.formRecharge.description = "";
            _this3.closeDialog();
            _this3.$message.error("Une erreur est survenue lors de l'enregistrement du règlement");
          });
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    successNotif: function successNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ENREGISTREMENT REUSSI";
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "success";

      this.$notify({
        title: title,
        message: mess,
        type: type,
        position: "top-center",
        duration: 15000
      });
    }
  },

  mounted: function mounted() {
    //this.loadStation();
  }
});

/***/ }),

/***/ "TzRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        statutDemande: {
            type: Number,
            default: 0 //0=> En cours de traitement, //1=>En Attente de validation par DG
        }
    },
    components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
    name: "listeDemande",
    data: function data() {
        return {
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),

            loadingAbsence: false,
            listeAbsence: [],
            listeTypeConge: [],
            idAbsence: '',
            formDmdAbsence: {
                datedbtFin: '',
                idTypeConge: ''
            },
            nomDemandeur: '',
            idDemandeur: '',

            dialogRefus: false,
            dialogValide: false,
            dialogModifDemande: false,
            idAbsenceSelect: null,
            descRefus: "",
            desactiveBout: false,

            formTri: {},
            deduireVacance: false,
            typeIdAbsenceSelect: null,
            nbJoursVacance: 0,
            dureeAbs: 0,
            items: [],
            index: null,
            listeDeduction: [{
                label: "Déduire",
                value: true
            }, {
                label: "Ne pas déduire",
                value: false
            }]

        };
    },

    methods: {
        verifDate: function verifDate() {
            if (this.formTri.dateFin.getTime() <= this.formTri.dateDebut.getTime()) {
                this.formTri.dateFin = null;
                // this.formTri.dateDebut = null;

                this.$alert('La fin doit être strictement superieur à la date de debut', 'Validation champs date', {
                    confirmButtonText: 'OK'
                });
            }
        },
        loadTypeConge: function loadTypeConge() {
            var _this = this;

            var url = this.domaine + 'rh/listeTypeConge';
            this.$http.get(url).then(function (resData) {
                _this.listeTypeConge = resData.body.listeAbsences;
            }, function (error) {
                _this.loading = false;
                _this.$message.error("Echec lors du chargement de al liste des type de congé");
            });
        },
        rechercheUser: function rechercheUser() {
            var _this2 = this;

            this.loading = true;
            this.listeEmployes = [];
            var url = this.domaine + 'rh/recherche/listeTotalAbsence';
            var tabDbt = new Intl.DateTimeFormat('en-GB').format(this.formTri.dateDebut).split("/");
            var tabDFin = new Intl.DateTimeFormat('en-GB').format(this.formTri.dateFin).split("/");
            var data = {
                dateDbt: tabDbt[2] + "-" + tabDbt[1] + "-" + tabDbt[0],
                dateFin: tabDFin[2] + "-" + tabDFin[1] + "-" + tabDFin[0]
            };

            this.$http.get(url, { params: data }).then(function (response) {
                _this2.listeAbsence = response.body.listeAbsences;
                _this2.loading = false;
            }, function (err) {
                _this2.loading = false;
                _this2.$message.error("Chargement de la liste de recherche des employes, verifier votre connexion");
            });
        },
        showDiapo: function showDiapo(images, ind) {
            this.items = images;
            this.index = ind;
        },
        showValideAbs: function showValideAbs(item) {
            this.idAbsenceSelect = item.idAbsence;
            this.dialogValide = true;
            this.deduireVacance = false;
            this.typeIdAbsenceSelect = item.typeConge, this.nbJoursVacance = item.nbJoursVacance;
            this.dureeAbs = item.duree;
        },
        editDemande: function editDemande(item) {
            this.dialogModifDemande = true;
            this.nomDemandeur = item.demandeur;
            this.idAbsence = item.idAbsence;
            this.idDemandeur = item.idDemandeur;
            // this.formDmdAbsence.datedbtFin = item.
            this.formDmdAbsence.idTypeConge = item.typeConge;
        },
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        },
        loadListeAbsence: function loadListeAbsence() {
            var _this3 = this;

            this.loadingAbsence = true;
            var url = this.domaine + 'rh/listeTotalAbsence';
            this.$http.get(url).then(function (response) {
                //this.listeAbsence = response.body.listeAbsences;
                _this3.listeAbsence = response.body.listeAbsences.filter(function (abs) {
                    return abs.idStatus == _this3.statutDemande;
                });
                _this3.loadingAbsence = false;
            }, function (error) {
                _this3.loadingAbsence = false;
                _this3.$message.error("Echec lors du chargement de la liste des demandes absences");
            });
        },
        submitModDemande: function submitModDemande() {
            var _this4 = this;

            this.loadingAbsence = true;
            var url = this.domaine + 'rh/modif/absence/' + this.idAbsence;
            var data = new FormData();
            data.append("dataForm", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formDmdAbsence));
            data.append("userId", this.user.id);
            this.$http.post(url, data).then(function (response) {
                _this4.dialogModifDemande = false;
                _this4.loadingAbsence = false;
                if (response.body.code == 0) {
                    _this4.$alert(response.body.message, "Modification demande d'absence", {
                        confirmButtonText: 'OK'
                    });
                    return;
                }

                if (response.body.code == 1) {
                    _this4.$alert(response.body.message, "Modification demande d'absence", {
                        confirmButtonText: 'OK'
                    });
                }
                _this4.formDmdAbsence.datedbtFin = '';
                _this4.formDmdAbsence.idTypeConge = '';
                _this4.idAbsence = '';
                _this4.idDemandeur = '';
                _this4.loadListeAbsence();
                _this4.resetForm('formAbsence');
                _this4.closeForm();
            }, function (error) {
                _this4.loadingAbsence = false;
                _this4.$message.error("Echec lors de l'enregistrement de la demande");
            });
        },
        submitDemande: function submitDemande(decision, idDemandeAbsence) {
            var _this5 = this;

            if (this.nbJoursVacance < this.dureeAbs && this.deduireVacance == true) {
                this.$message.error("Le nombre de jour restant est inférieur a la durée d'absence demandée");
                return;
            }
            this.loadingAbsence = true;
            this.dialogRefus = false;
            var url = this.domaine + 'rh/validationDemande/' + this.user.id;
            var data = new FormData();
            data.append("decision", decision);
            if (this.statutDemande == 0) {
                data.append("etatdecision", 0);
            } else if (this.statutDemande == 1) {
                data.append("etatdecision", 1);
            }
            data.append("idAbsence", idDemandeAbsence);
            data.append("description", this.descRefus);
            data.append("deduireVacance", this.deduireVacance);

            this.$http.post(url, data).then(function (response) {
                _this5.loadingAbsence = false;
                _this5.dialogRefus = false, _this5.dialogValide = false, _this5.loadListeAbsence();
                _this5.successNotif(response.body.message);
            }, function (error) {
                _this5.loadingAbsence = false;
                _this5.$message.error("Echec lors de la validation de demande d'absences");
            });
        },
        closeForm: function closeForm() {
            this.$emit("close");
        }
    },
    mounted: function mounted() {
        this.loadListeAbsence();
        this.loadTypeConge();
    }
});

/***/ }),

/***/ "UD/J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","justify-center":""}},[_c('h1',{staticStyle:{"text-align":"center","margin-bottom":"8px"},attrs:{"id":"code_answer_title1"}},[_vm._v("INDICATEUR DE PRODUCTIVITE DU MOIS DE "+_vm._s(this.listReporting.tab_dates ? (this.listReporting.tab_dates[0]) : '')+" ")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('el-button',{staticClass:"tooltip-btn",attrs:{"title":"Imprimer l'indicateur de productivite","type":"warning","icon":"el-icon-printer"},on:{"click":function($event){return _vm.imprimeListeBilan()}}},[_vm._v("Imprimer en PDF\n          ")])],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"brown darken-1"}},[_c('h1',{staticStyle:{"text-align":"center","margin-bottom":"8px"},attrs:{"id":"code_answer_title1"}},[_vm._v("DEMANDES DE FONDS")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("\n                  "+_vm._s(this.listReporting.nbDemdFaPayerCaiss.length != 0
                      ? this.listReporting.nbDemdFaPayerCaiss[0]["somme"]
                      : 0)+"\n                ")]),_vm._v(" "),_c('div',[_vm._v("EN ATTENTE DE PAIEMENT")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("A VALIDER")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v("\n                "+_vm._s(this.listReporting.nbDemdFAvalider.length != 0
                    ? this.listReporting.nbDemdFAvalider[0]["somme"]
                    : 0)+"\n              ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"deep-orange darken-3 darken-2"}},[_c('h1',{staticStyle:{"text-align":"center","margin-bottom":"8px"},attrs:{"id":"code_answer_title1"}},[_vm._v("FOURNISSEURS")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("\n                  "+_vm._s(this.listReporting.nbnFacturePayrCaisse.length != 0
                      ? this.listReporting.nbnFacturePayrCaisse[0]["somme"]
                      : 0)+"\n                ")]),_vm._v(" "),_c('div',[_vm._v("FACTURES REGLEES")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("FACTURES A VALIDER")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v("\n                "+_vm._s(this.listReporting.nbnFactuFournAvalidr.length != 0
                    ? this.listReporting.nbnFactuFournAvalidr[0]["somme"]
                    : 0)+"\n              ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"cyan darken-2"}},[_c('h1',{staticStyle:{"text-align":"center","margin-bottom":"8px"},attrs:{"id":"code_answer_title1"}},[_vm._v("MISSIONS")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("\n                     "+_vm._s(this.listReporting.nbMissionCrer.length != 0
                          ? this.listReporting.nbMissionCrer[0]["somme"]
                          : 0)+"\n                    ")]),_vm._v(" "),_c('div',[_vm._v("CREES")])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"headline"},[_vm._v("\n                     "+_vm._s(this.listReporting.nbMissionClotur.length != 0
                          ? this.listReporting.nbMissionClotur[0]["somme"]
                          : 0)+"/"+_vm._s(this.listReporting.nbMissionEncour.length != 0
                          ? this.listReporting.nbMissionEncour[0]["somme"]
                          : 0)+"\n                    ")]),_vm._v(" "),_c('div',[_vm._v("CLOTUREES")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("\n                      "+_vm._s(this.listReporting.nbMissionFactureAValiderr.length != 0
                          ? this.listReporting.nbMissionFactureAValiderr[0]["somme"]
                          : 0)+"\n                    ")]),_vm._v(" "),_c('div',[_vm._v("FACTURES A VALIDER")])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"headline"},[_vm._v("\n                     "+_vm._s(this.listReporting.nbMissionClotur.length != 0
                          ? this.listReporting.nbMissionClotur[0]["somme"]
                          : 0)+"/"+_vm._s(this.listReporting.nbMissionAconfirmer.length != 0
                          ? this.listReporting.nbMissionAconfirmer[0]["somme"]
                          : 0)+"\n                    ")]),_vm._v(" "),_c('div',[_vm._v("A CONFIRMER")])])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"amber darken-4"}},[_c('h1',{staticStyle:{"text-align":"center","margin-bottom":"8px"},attrs:{"id":"code_answer_title1"}},[_vm._v("TRESORERIES")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("\n                  "+_vm._s(this.listReporting.nbnApproCaisseCrr.length != 0
                      ? this.listReporting.nbnApproCaisseCrr[0]["somme"]
                      : 0)+"\n                ")]),_vm._v(" "),_c('div',[_vm._v("APPROS ENREGISTRES")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("APPROS A VALIDER")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v("\n                "+_vm._s(this.listReporting.nbnApproCaisseAvalider.length != 0
                    ? this.listReporting.nbnApproCaisseAvalider[0]["somme"]
                    : 0)+"\n              ")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm9":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs4":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"indigo   darken-2"}},[_c('h1',{staticStyle:{"text-align":"center","margin-bottom":"8px"},attrs:{"id":"code_answer_title1"}},[_vm._v("VIDANGES")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("\n                      "+_vm._s(this.listReporting.nbnVidProgramr.length != 0
                          ? this.listReporting.nbnVidProgramr[0]["somme"]
                          : 0)+"\n                    ")]),_vm._v(" "),_c('div',[_vm._v("PROGRAMMEES")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("VISITES TECHNIQUES PROGRAMMEES")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v("\n                    "+_vm._s(this.listReporting.nbnVisitTechProgramr.length != 0
                        ? this.listReporting.nbnVisitTechProgramr[0]["somme"]
                        : 0)+"\n                  ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs4":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"light-green accent-4"}},[_c('h1',{staticStyle:{"text-align":"center","margin-bottom":"8px"},attrs:{"id":"code_answer_title1"}},[_vm._v("ASSURANCES")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("\n                      "+_vm._s(this.listReporting.nbnTotalAssurancCr.length != 0
                          ? this.listReporting.nbnTotalAssurancCr[0]["somme"]
                          : 0)+"\n                    ")]),_vm._v(" "),_c('div',[_vm._v("CREES")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("EXPIREES")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v("\n                    "+_vm._s(this.listReporting.nbnTotalAssurancExp.length != 0
                        ? this.listReporting.nbnTotalAssurancExp[0]["somme"]
                        : 0)+"/"+_vm._s(this.listReporting.nbnTotalAssurancValid.length != 0
                        ? this.listReporting.nbnTotalAssurancValid
                        : 0)+"\n                  ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs4":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"red darken-2"}},[_c('h1',{staticStyle:{"text-align":"center","margin-bottom":"8px"},attrs:{"id":"code_answer_title1"}},[_vm._v("BESOINS")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("\n                      "+_vm._s(this.listReporting.nbnBesoinCreer.length != 0
                          ? this.listReporting.nbnBesoinCreer[0]["somme"]
                          : 0)+"\n                    ")]),_vm._v(" "),_c('div',[_vm._v("CREES")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("COMMANDES FOURNISSEURS CREES")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v("\n                    "+_vm._s(this.listReporting.nbnComandFournCrr.length != 0
                          ? this.listReporting.nbnComandFournCrr[0]["somme"]
                          : 0)+"\n                  ")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs4":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"cyan darken-2"}},[_c('h1',{staticStyle:{"text-align":"center","margin-bottom":"8px"},attrs:{"id":"code_answer_title1"}},[_vm._v("PROJETS")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_vm._v("TACHES")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('div',{staticClass:"display-3 font-weight-thin"},[_vm._v("\n                              "+_vm._s(this.listReporting.nbTachesDemarer.length != 0
                                  ? this.listReporting.nbTachesDemarer[0][
                                      "somme"
                                    ]
                                  : 0)+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"caption font-weight-thin"},[_vm._v("EN COURS")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('div',{staticClass:"display-3 font-weight-thin"},[_vm._v("\n                              "+_vm._s(this.listReporting.nbTachesAreter.length != 0
                                  ? this.listReporting.nbTachesAreter[0][
                                      "somme"
                                    ]
                                  : 0)+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"caption font-weight-thin"},[_vm._v("ARRETEES")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('div',{staticClass:"display-3 font-weight-thin"},[_vm._v("\n                              "+_vm._s(this.listReporting.nbTachesTerminer.length != 0
                                  ? this.listReporting.nbTachesTerminer[0][
                                      "somme"
                                    ]
                                  : 0)+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"caption font-weight-thin"},[_vm._v("\n                              TERMINEES\n                            ")])])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("\n                          "+_vm._s(this.listReporting.nbRapportJOur.length != 0
                              ? this.listReporting.nbRapportJOur[0]["somme"]
                              : 0)+"\n                        ")]),_vm._v(" "),_c('div',[_vm._v("RAPPORTS CHANTIERS CREES")])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"headline"},[_vm._v("\n                        "+_vm._s(this.listReporting.nbRapportJOurValidr.length != 0
                            ? this.listReporting.nbRapportJOurValidr[0]["somme"]
                            : 0)+"\n                      ")]),_vm._v(" "),_c('div',[_vm._v("RAPPORTS CHANTIERS VALIDES")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("CHANTIERS CREES")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v("\n                      "+_vm._s(this.listReporting.nbChantierCrer.length != 0
                          ? this.listReporting.nbChantierCrer[0]["somme"]
                          : 0)+"\n                    ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center pr-2 ml-2",attrs:{"xs8":""}},[_c('v-card',{staticClass:"elevation-5 pl-2 pt-2"},[_c('h4',[_vm._v("\n              UTILISATEURS CONNECTES AUJOURD'HUI\n              "),_c('v-chip',{attrs:{"outline":"","color":"red"}},[_vm._v(" "+_vm._s(this.listeUsers ? this.listeUsers.length : 0)+"/"+_vm._s(this.listReporting.nbnTotalUsr -1))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-1"}),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeUsers,"height":"350"}},[_c('el-table-column',{attrs:{"prop":"nom","label":"Nom  Prénom(s)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{staticClass:"body-2"},[_vm._v(_vm._s(scope.row.name))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tpsMoyen","label":"Fonction"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"green--text title"},[_vm._v(_vm._s(scope.row.fonction))])]}}])})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"blue darken-2"}},[_c('h1',{staticStyle:{"text-align":"center","margin-bottom":"8px"},attrs:{"id":"code_answer_title1"}},[_vm._v("PARC AUTO")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_vm._v("VEHICULES")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('div',{staticClass:"display-3 font-weight-thin"},[_vm._v("\n                        "+_vm._s(this.listReporting.nbnTotalVehciulCrér.length != 0
                            ? this.listReporting.nbnTotalVehciulCrér[0][
                                "somme"
                              ]
                            : 0)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"caption font-weight-thin"},[_vm._v("CREES")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('div',{staticClass:"display-3 font-weight-thin"},[_vm._v("\n                        "+_vm._s(this.listReporting.nbnTotalVehciulPanne.length != 0
                            ? this.listReporting.nbnTotalVehciulPanne[0][
                                "somme"
                              ]
                            : 0)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"caption font-weight-thin"},[_vm._v("EN PANNES")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('div',{staticClass:"display-3 font-weight-thin"},[_vm._v("\n                        "+_vm._s(this.listReporting.nbnTotalVehciulReparation.length != 0
                            ? this.listReporting.nbnTotalVehciulReparation[0][
                                "somme"
                              ]
                            : 0)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"caption font-weight-thin"},[_vm._v("\n                        EN REPARATIONS\n                      ")])])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"orange  darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"display-2"},[_vm._v("\n                      "+_vm._s(this.listReporting.nbnTotalDemandeReparation.length != 0
                          ? this.listReporting.nbnTotalDemandeReparation[0]["somme"]
                          : 0)+"\n                    ")]),_vm._v(" "),_c('div',[_vm._v("DEMANDES DE REPARATIONS CREES")])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"display-2"},[_vm._v("\n                      "+_vm._s(this.listReporting.nbnApproCaisseCrr.length != 0
                          ? this.listReporting.nbnApproCaisseCrr[0]["somme"]
                          : 0)+"\n                    ")]),_vm._v(" "),_c('div',[_vm._v("APPROVISIONNEMENTS CARBURANT ENREGISTRES")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_vm._v("MONTANT CONSOMMATION CARBURANT")]),_vm._v(" "),_c('div',{staticClass:"display-2"},[_vm._v("\n                    "+_vm._s(this.listReporting.nbMontanConsomCarb.length != 0
                        ? this.listReporting.nbMontanConsomCarb[0]["total"]
                        : 0)+" XOF\n                  ")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v("\n                  "+_vm._s(this.listReporting.nbnBonSortiCrr.length != 0
                      ? this.listReporting.nbnBonSortiCrr[0]["somme"]
                      : 0)+"\n                ")]),_vm._v(" "),_c('div',[_vm._v("BONS DE SORTI CREES")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("BONS DE SORTI VALIDES")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v("\n                "+_vm._s(this.listReporting.nbnBonSortiValidr.length != 0
                    ? this.listReporting.nbnBonSortiValidr[0]["somme"]
                    : 0)+"\n              ")])])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UF8r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_boardChantier_Chantier_index__ = __webpack_require__("dZna");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ChantierIndex: __WEBPACK_IMPORTED_MODULE_0__components_boardChantier_Chantier_index__["a" /* default */], Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: "DashboardCommis",
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [{ path: "/boardChantier", text: "DashBoard Chantier", disabled: false }],
      userAdmin: false,
      chantiers: []
    };
  },


  methods: {
    loadChantier: function loadChantier() {
      var _this = this;

      this.loading = true;
      var url = "";
      if (this.user.fonction == "Super Administrateur") {
        url = this.domaine + "chantier/liste";
        this.userAdmin = true;
      } else {
        url = this.domaine + "chantier/responsable/" + this.user.id + '?commis=true';
        this.userAdmin = false;
      }

      this.$http.get(url).then(function (response) {
        _this.chantiers = response.body.chantier;
        _this.loading = false;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Echec lors du chargement des chantiers");
      });
    }
  },

  mounted: function mounted() {
    this.loadChantier();
  }
});

/***/ }),

/***/ "UH4A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Oq2I");
__webpack_require__("miEh");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
    name: "info-ouvrier",
    props: {
        show: {
            type: Boolean
        },
        infoOuvrier: {
            type: Object
        }
    },
    data: function data() {
        return {
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            loading: false,
            onglet: "0",
            dialogInfoOuvrier: false,
            listeContratsTache: [],
            listePaiements: [],
            listeFactureSelect: [],
            montantTotalVerse: 0,
            dialogValideFacture: false,
            dialogHeureValide: false,
            montantTotalRestant: 0,
            montantTotal: 0
        };
    },

    watch: {
        show: function show(newValue, oldvalue) {
            this.dialogInfoOuvrier = newValue;
            if (newValue == true) {
                this.onglet = "0";
                this.loadContratOuvrier(this.infoOuvrier.id);
            }
        }
    },
    methods: {
        handleTabClick: function handleTabClick(tab) {
            switch (tab) {
                case "0":
                    if (this.listeContratsTache.length == 0) {
                        this.loadContratOuvrier(this.infoOuvrier.id);
                    }
                    break;
                case "1":
                    if (this.listePaiements.length == 0) {
                        this.loadPaiementOuvrier(this.infoOuvrier.id);
                    }
                    break;
                case "2":
                    // if(this.listeReserves.length == 0   ){
                    //     this.loadReserves();
                    // }
                    break;

                case "3":
                    // this.loadWorklogs(this.detailProjet.id);
                    break;

                default:
                    break;
            }
        },
        showDialogPaiement: function showDialogPaiement(item) {
            this.listeFactureSelect = [item];
            this.dialogValideFacture = true;
        },
        EditoOuvrier: function EditoOuvrier(item) {
            this.listeFactureSelect = [item];
            console.log('listeFactureSelect', this.listeFactureSelect);
            this.dialogHeureValide = true;
        },
        validFacture: function validFacture() {
            var _this = this;

            this.loading = true;
            var formdata = new FormData();
            var item = this.listeFactureSelect[0];
            console.log('item', item);
            var url = this.domaine + 'ouvrier/' + item.idOuvrier + '/paiement/contrat/' + item.idContrat;
            formdata.append("idUser", this.user.id);
            formdata.append("montant", item.montantVerse);
            this.$http.post(url, formdata).then(function (response) {
                _this.dialogValideFacture = false;
                _this.loading = false;
                _this.$notify({
                    title: "Validation facture",
                    message: "L'opération s'est déroulée avec succès",
                    type: "success",
                    position: "top-center"
                });
            }, function (error) {
                _this.dialogValideFacture = false;
                _this.loading = false;
                _this.$message.error("Echec lors de la validation, verifiez votre connexion");
            });
        },
        validUpdateHeure: function validUpdateHeure() {
            var _this2 = this;

            this.loading = true;
            var formdata = new FormData();
            var item = this.listeFactureSelect[0];
            console.log('item', item);
            var url = this.domaine + 'ouvrier/' + item.idOuvrier + '/paiement/contrat/update_heure/' + item.idContrat;
            formdata.append("idUser", this.user.id);
            formdata.append("periodeSupp", item.periodeSupp);
            formdata.append("periodeHr", item.periodeHr);

            this.$http.post(url, formdata).then(function (response) {
                _this2.dialogHeureValide = false;
                _this2.loadContratOuvrier(_this2.infoOuvrier.id);
                _this2.loading = false;
                _this2.$notify({
                    title: "Modification des heures",
                    message: "L'opération s'est déroulée avec succès",
                    type: "success",
                    position: "top-center"
                });
            }, function (error) {
                _this2.dialogHeureValide = false;
                _this2.loading = false;
                _this2.$message.error("Echec lors de la validation, verifiez votre connexion");
            });
        },
        loadContratOuvrier: function loadContratOuvrier(idOuvrier) {
            var _this3 = this;

            this.loading = true;
            ///this.listeContratsTache.splice(0);
            var url = this.domaine + "contrat/prestataire/ouvrier/" + idOuvrier;
            this.$http.get(url).then(function (response) {
                _this3.libPrestataire = response.body.libPrestataire;
                _this3.listeContratsTache = response.body.contrats;
                _this3.montantTotalVerse = response.body.mntTotalVerseContrat;
                _this3.montantTotalRestant = response.body.mntTotalRestantContrat;
                _this3.montantTotal = response.body.mntTotalContrat;
                _this3.loading = false;
                _this3.statistiqueMntVerse();
            }, function (error) {
                _this3.loading = false;
                _this3.$message.error("Echec lors du chargement des contrats ouvriers");
            });
        },
        loadPaiementOuvrier: function loadPaiementOuvrier(idOuvrier) {
            var _this4 = this;

            this.loading = true;
            var url = this.domaine + "contrat/prestataire/historique_paiement_ouvrier/" + idOuvrier;
            this.$http.get(url).then(function (response) {
                _this4.listePaiements = response.body.paiements;
                _this4.loading = false;
            }, function (error) {
                _this4.loading = false;
                _this4.$message.error("Echec lors du chargement des paiements ouvriers");
            });
        },
        closeDialog: function closeDialog() {
            this.$emit('close');
        },
        closeDialogUpdateHeure: function closeDialogUpdateHeure() {
            this.dialogHeureValide = false;
        },
        headerRowStyle: function headerRowStyle(_ref) {
            var row = _ref.row,
                rowIndex = _ref.rowIndex;

            return { "color": "black" };
        },
        getSummExploitBudget: function getSummExploitBudget(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = "Sous total";
                    return;
                }

                if (index === 3) {
                    sums[index] = "N/A";
                    return;
                }
                var values = data.map(function (item) {
                    return Number(item[column.property]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0));
                } else {
                    sums[index] = "N/A";
                }
            });

            return sums;
        },

        //statistique etat
        statistiqueMntVerse: function statistiqueMntVerse() {

            var option = {
                backgroundColor: '#fafafa',
                title: {
                    text: 'STATISTIQUE MONTANT PAYE/RESTANT',
                    subtext: '',
                    x: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{b} : {c} ({d}%)"
                },

                series: [{
                    name: '',
                    type: 'pie',
                    radius: '70%',
                    center: ['50%', '50%'],

                    data: [{
                        value: this.montantTotalRestant,
                        name: 'mnt restant',
                        itemStyle: {
                            color: '#c23531'
                        }
                    }, {
                        value: this.montantTotalVerse,
                        name: 'mnt verse',
                        itemStyle: {
                            color: '#22c22a'
                        }
                    }],
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }]
            };
            var geneChartStatMontVerse = echarts.init(document.getElementById("statMontVerse"));
            geneChartStatMontVerse.setOption(option);
        }
    }
});

/***/ }),

/***/ "UMsA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "URUD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogDetail),callback:function ($$v) {_vm.dialogDetail=$$v},expression:"dialogDetail"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Detail de la demande")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"icons":"","dark":"","color":"orange"},on:{"click":function($event){return _vm.imprimerDetail()}}},[_vm._v("Imprimer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Informations generales sur la demande\n                                            ")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Identifiant de la demande")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.ref)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Zone")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.libZone)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Batiment")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.batiment)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Salle")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.salle)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Priorite")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                   "+_vm._s(_vm.demandeDetail.libPriorite)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de la demande")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.date)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date d'enregistrement")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.dateCreated)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Nom du demandeur")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                               "+_vm._s(_vm.demandeDetail.nomDemandeur)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(_vm.demandeDetail.imageDmd1)?_c('v-flex',{staticClass:"mr-3",attrs:{"xs3":""}},[_c('a',{attrs:{"href":_vm.demandeDetail.imageDmd1,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.demandeDetail.imageDmd1}})])],1)]):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Status")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.libStatut)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),(!_vm.droitAcces.new_maintenance)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Etat")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.libEtatDmd)+"\n                                                                            ")])],1):_vm._e(),_vm._v(" "),(!_vm.droitAcces.new_maintenance)?_c('v-divider',{staticClass:"mb-3"}):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Enregistré par ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                 "+_vm._s(_vm.demandeDetail.userCreate)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Domaine d'activité ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                 "+_vm._s(_vm.demandeDetail.domaine)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Note ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                 "+_vm._s(_vm.demandeDetail.note)+" / 10\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Description ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('el-form',{staticClass:"demo-ruleForm"},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":""}},[_c('el-input',{attrs:{"disabled":"","type":"textarea"},model:{value:(_vm.demandeDetail.commentaire),callback:function ($$v) {_vm.$set(_vm.demandeDetail, "commentaire", $$v)},expression:"demandeDetail.commentaire"}})],1)],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Pourquoi cette note ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('el-form',{staticClass:"demo-ruleForm"},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":""}},[_c('el-input',{attrs:{"disabled":"","rows":6,"type":"textarea"},model:{value:(_vm.demandeDetail.remarqueNote),callback:function ($$v) {_vm.$set(_vm.demandeDetail, "remarqueNote", $$v)},expression:"demandeDetail.remarqueNote"}})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),((_vm.user.type == 1 || _vm.user.type == 4 || _vm.user.type == 5)   && _vm.demandeDetail.etatDmd > 2   )?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Visites et constats\n                                            ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Constat enregistré par le responsable:")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                                            "+_vm._s(_vm.demandeDetail.superviseur)+"\n                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Date et heure du constat:")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                                            "+_vm._s(_vm.demandeDetail.dateConstat)+"\n                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('el-form',{staticStyle:{"width":"100%"},attrs:{"disabled":"","id":"formRapport","model":_vm.formRapport}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[(_vm.demandeDetail.imageConst1)?_c('v-flex',{staticClass:"mr-3",attrs:{"xs3":""}},[_c('a',{attrs:{"href":_vm.demandeDetail.imageConst1,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.demandeDetail.imageConst1}})])],1)]):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Rapport de constat"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":"","type":"textarea","rows":6,"placeholder":"Rapport sur le constat"},model:{value:(_vm.formRapport.rapport),callback:function ($$v) {_vm.$set(_vm.formRapport, "rapport", $$v)},expression:"formRapport.rapport"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableProduit}},[_c('el-table-column',{attrs:{"prop":"designation","label":"Designation","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantite","label":"Quantite"}})],1)],1),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.demandeDetail.etatDmd >= 3)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Validation du devis\n                                            ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.demandeDetail.nomValidateurs}},[_c('el-table-column',{attrs:{"prop":"nom","label":"Nom du validateur","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"valider","label":"Decision"}})],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.demandeDetail.etatDmd >= 7)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Planification de l'intervention\n                                            ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date debut planifier pour  l'intervention ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.dateDbt)+" à "+_vm._s(_vm.demandeDetail.hrDbt)+" \n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de fin de l'intervention")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.dateFin)+" à "+_vm._s(_vm.demandeDetail.hrFin)+" \n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.new_maintenance && _vm.demandeDetail.etatDmd >= 8)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Rapport de maintenance\n                                            ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Effectué par  le technicien")]),_vm._v(" "),_c('v-flex',{staticClass:"title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.demandeDetail.nomTech)+" ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date du rapport")]),_vm._v(" "),_c('v-flex',{staticClass:"title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.demandeDetail.dateDepannage)+" ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-layout',{attrs:{"row":""}},[(_vm.demandeDetail.imageDepan1)?_c('v-flex',{staticClass:"mr-3",attrs:{"xs3":""}},[_c('a',{attrs:{"href":_vm.demandeDetail.imageDepan1,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.demandeDetail.imageDepan1}})])],1)]):_vm._e()],1)],1)],1)],1)],1)],1)],1)],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UVH/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"blue","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogAjout = true;}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n      Ajouter un nouveau produit\n    ")],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"100%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjout),callback:function ($$v) {_vm.dialogAjout=$$v},expression:"dialogAjout"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter un nouveau produit")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjout = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":"","id":"formProduct"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('v-text-field',{attrs:{"label":"Libelle du produit","name":"libelleProduit","required":""},model:{value:(_vm.libelleProduit),callback:function ($$v) {_vm.libelleProduit=$$v},expression:"libelleProduit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-text-field',{attrs:{"label":"Reference du produit","name":"referenceProduit"},model:{value:(_vm.referenceProduit),callback:function ($$v) {_vm.referenceProduit=$$v},expression:"referenceProduit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-select',{attrs:{"label":"Type","name":"typeProduit","items":_vm.listType,"item-value":"value"},model:{value:(_vm.typeProduit),callback:function ($$v) {_vm.typeProduit=$$v},expression:"typeProduit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-text-field',{attrs:{"label":"Prix du produit","name":"prixProduit"},model:{value:(_vm.prixProduit),callback:function ($$v) {_vm.prixProduit=$$v},expression:"prixProduit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-text-field',{attrs:{"label":"Description du produit","name":"descProduit"},model:{value:(_vm.descProduit),callback:function ($$v) {_vm.descProduit=$$v},expression:"descProduit"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":_vm.clear}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.addProduct}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"100%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogEdit),callback:function ($$v) {_vm.dialogEdit=$$v},expression:"dialogEdit"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Modification du produit ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogEdit = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":"","id":"formEditProduct"},model:{value:(_vm.validEdit),callback:function ($$v) {_vm.validEdit=$$v},expression:"validEdit"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('v-text-field',{attrs:{"label":"Libelle du produit","name":"libelleEditProduit","rules":_vm.libelleRules,"counter":4,"required":""},model:{value:(_vm.libelleEditProduit),callback:function ($$v) {_vm.libelleEditProduit=$$v},expression:"libelleEditProduit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-text-field',{attrs:{"label":"Reference du produit","name":"referenceEditProduit"},model:{value:(_vm.referenceEditProduit),callback:function ($$v) {_vm.referenceEditProduit=$$v},expression:"referenceEditProduit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-select',{attrs:{"label":"Type","name":"typeEditProduit","items":_vm.listType,"item-value":"value"},model:{value:(_vm.typeEditProduit),callback:function ($$v) {_vm.typeEditProduit=$$v},expression:"typeEditProduit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-text-field',{attrs:{"label":"Prix du produit","name":"prixEditProduit","type":"number"},model:{value:(_vm.prixEditProduit),callback:function ($$v) {_vm.prixEditProduit=$$v},expression:"prixEditProduit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-text-field',{attrs:{"label":"Description du produit","name":"descEditProduit"},model:{value:(_vm.descEditProduit),callback:function ($$v) {_vm.descEditProduit=$$v},expression:"descEditProduit"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":_vm.clear}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.validEdit,"dark":""},on:{"click":_vm.updateProduct}},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShow),callback:function ($$v) {_vm.dialogShow=$$v},expression:"dialogShow"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du produit "+_vm._s(_vm.currentProduct.libelle)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShow = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":20}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"carte-header",attrs:{"slot":"header"},slot:"header"},[_c('v-flex',{attrs:{"text-xs-center":"","layout":"","align-center":"","justify-center":""}})],1),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('p',[_c('b',[_vm._v("Reference : ")]),_vm._v(" "+_vm._s(_vm.currentProduct.reference)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libelle : ")]),_vm._v(" "+_vm._s(_vm.currentProduct.libelle)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Type : ")]),_vm._v(" "+_vm._s(_vm.currentProduct.type)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Prix unitaire : ")]),_vm._v(" "+_vm._s(_vm.currentProduct.valeur)+" FCFA")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description :")]),_vm._v(" "+_vm._s(_vm.currentProduct.description)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enrégistrement :")]),_vm._v(" "+_vm._s(_vm.currentProduct.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v(" "+_vm._s(_vm.currentProduct.modified)+" ")])])])],1)])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer ce produit ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteProduct($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-card',[_c('div',[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n          LISTE DES PRODUITS "),_c('v-icon',{attrs:{"right":""}},[_vm._v("account_circle")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Rechercher","single-line":"","hide-details":""},model:{value:(_vm.recherche),callback:function ($$v) {_vm.recherche=$$v},expression:"recherche"}})],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"search":_vm.recherche,"pagination":_vm.pagination,"items":_vm.listProduct,"hide-actions":""},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.libelle))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.reference))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.type))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.valeur)+" FCFA")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showProduct(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                  Détails\n                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){$event.stopPropagation();return _vm.editProduct(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                  Modifier\n                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();return _vm.activeDeleteProduct(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                  Supprimer\n                ")],1)],1)])]}}])}),_vm._v(" "),_c('div',{staticClass:"text-xs-center pt-2"},[_c('v-pagination',{attrs:{"length":_vm.pages},model:{value:(_vm.pagination.page),callback:function ($$v) {_vm.$set(_vm.pagination, "page", $$v)},expression:"pagination.page"}})],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UW0N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('div',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%","font-weight":"bold","font-size":"25px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("VEUILLEZ EFFECTUER VOTRE RECHERCHE EN FONCTION DU PROJET OU DES CHANTIERS")]),_vm._v(" "),_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-form',[(_vm.droitAcces.work_All_projet)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Projet"},on:{"change":function($event){return _vm.loadTravauxSuiviProjet(_vm.selectTypeSearchProjet)}},model:{value:(_vm.selectTypeSearchProjet),callback:function ($$v) {_vm.selectTypeSearchProjet=$$v},expression:"selectTypeSearchProjet"}},_vm._l((_vm.listProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Chantier"},model:{value:(_vm.selectSearchChantierSuivi),callback:function ($$v) {_vm.selectSearchChantierSuivi=$$v},expression:"selectSearchChantierSuivi"}},_vm._l((_vm.listChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),(_vm.selectSearchChantierSuivi != '')?_c('v-flex',{attrs:{"md1":""}},[_c('v-btn',{attrs:{"icons":"","color":"blue","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.loadChantierDetails(_vm.selectSearchChantierSuivi)}}},[_c('v-icon',[_vm._v("search")])],1)],1):_vm._e()],1):_vm._e()],1)],1)],1)],1)],1)]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h4',[_vm._v("LISTE DES WORKLOGS")]),_vm._v(" "),_c('div',{staticClass:"text-xs-right"}),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.droitAcces.work_All_projet)?_c('v-layout',{staticClass:"mb-2 mt-2",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{attrs:{"color":"cyan","text-color":"white"}},[_c('v-avatar',{staticClass:"cyan darken-4"},[_vm._v(_vm._s(_vm.worklogTotal))]),_vm._v("WORKLOGS\n                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{attrs:{"color":"cyan","text-color":"white"}},[_c('v-avatar',{staticClass:"cyan darken-4"},[_vm._v(_vm._s(_vm.totalActivite))]),_vm._v(" ACTIVITE(S)\n                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{attrs:{"color":"blue","text-color":"white"}},[_c('v-avatar',{staticClass:"cyan darken-4"},[_vm._v(_vm._s(_vm.totalActiviteEncours))]),_vm._v(" ACTIVITE(S) EN COURS\n                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{attrs:{"color":"green","text-color":"white"}},[_c('v-avatar',{staticClass:"cyan darken-4"},[_vm._v(_vm._s(_vm.totalActiviteTermine))]),_vm._v(" ACTIVITE(S) TERMINEE(S)\n                ")],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":""}},[(_vm.droitAcces.work_All_projet)?_c('data-tables',{attrs:{"data":_vm.listeWorklog,"resizable":false}},[_c('el-table-column',{attrs:{"prop":"projet","label":"PROJET"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chantier","label":"CHANTIER","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chefChantier","label":"CHEF CHANTIER"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idwork","label":"WORKLOG ID","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"enregistrer","label":"ENREGISTRER PAR","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nbretaches","label":"ACTIVITES","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateAdd","label":"CREER","align":"center"}}),_vm._v("\\\n                  "),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"statutworklog","label":"STATUT WORKLOGS","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.statutworklog == 'Terminé')?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.statutworklog))]):_vm._e(),_vm._v(" "),(scope.row.statutworklog == 'En cours')?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.statutworklog))]):_vm._e(),_vm._v(" "),(scope.row.statutworklog == 'Aucune activitée')?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.statutworklog))]):_vm._e()]}}],null,false,100948466)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetail(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("Détails...\n                      ")],1)]}}],null,false,2545643025)})],1):_vm._e()],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowWorklog),callback:function ($$v) {_vm.dialogShowWorklog=$$v},expression:"dialogShowWorklog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du worklog "+_vm._s(_vm.worklogCourant.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowWorklog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Libellé :")]),_vm._v("\n                      "+_vm._s(_vm.worklogCourant.libelle)+"\n                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Identifiant :")]),_vm._v("\n                      "+_vm._s(_vm.worklogCourant.id)+"\n                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Temps mis (Heure) :")]),_vm._v("\n                      "+_vm._s(_vm.worklogCourant.tempsmis)+"\n                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description :")]),_vm._v("\n                      "+_vm._s(_vm.worklogCourant.description)+"\n                    ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Statut :")]),_vm._v("\n                      "+_vm._s(_vm.worklogCourant.statutworklog)+"\n                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Ajouter par :")]),_vm._v("\n                      "+_vm._s(_vm.worklogCourant.enregistrer)+"\n                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v("\n                      "+_vm._s(_vm.worklogCourant.date)+"\n                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v("\n                      "+_vm._s(_vm.worklogCourant.dateModification)+"\n                    ")]),_vm._v(" "),_c('p',[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.worklogCourant.urlImage,"alt":"avatar"}})])],1)])],1)],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Liste des activitées")]),_vm._v(" "),_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.worklogCourant.taches}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"utilisateur","label":"ENREGISTRER PAR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateCreation","label":"DATE DE CREATION "}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateModification","label":"MODIFIER LE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"DATE SYSTEME "}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"commentaire","label":"COMMENTAIRE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"statut","label":"STATUT"}})],1)],1)],1)]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowWorklog = false}},slot:"activator"},[_vm._v("\n                Fermer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("Fermer\n            ")],1)],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UgKa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","xs12":""}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%"},model:{value:(_vm.dialogAjoutBudget),callback:function ($$v) {_vm.dialogAjoutBudget=$$v},expression:"dialogAjoutBudget"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter des budgets ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeTypeTravaux}},[_c('el-table-column',{attrs:{"prop":"annee","label":"MOIS ANNEE (AAAA-MM)","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.annee)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.libelle)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"MONTANT (FCFA)","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.montant)+"\n                  ")])]}}])})],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"orange","dark":""},on:{"click":function($event){return _vm.closeDialog()}},slot:"activator"},[_vm._v("Anuller "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"green","dark":""},on:{"click":function($event){return _vm.saveListe()}},slot:"activator"},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UgjE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_facturePaiement_vue__ = __webpack_require__("KOsr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb57c17c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_facturePaiement_vue__ = __webpack_require__("gTnr");
function injectStyle (ssrContext) {
  __webpack_require__("j5vI")
  __webpack_require__("beTa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cb57c17c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_facturePaiement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb57c17c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_facturePaiement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Usxo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loading__ = __webpack_require__("NxGh");



var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//function de difference de date

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Oq2I");
__webpack_require__("miEh");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Loading: __WEBPACK_IMPORTED_MODULE_3__components_Loading__["a" /* default */]
    },
    props: {
        show: {
            type: Boolean
        },
        typeTrx: {
            type: Object
        },
        idProjet: {
            type: Number
        }

    },
    name: "AjoutPrevisionBudget",
    data: function data() {
        return {
            //data general
            notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
            loading: false,

            //VARIABLE
            dialogAjoutBudget: false,
            formBudget: {
                dateMoisAn: null,
                libelle: "",
                montant: 5
            },
            rulesBudget: {
                dateMoisAn: [{ required: true, message: "Veuillez selectionner" }],
                libelle: [{ required: true, message: "Veuillez selectionner" }],
                montant: [{ required: true, message: "Veuillez saisir" }]
            },
            datePickerRtp: {},
            listeProduitBudget: [],
            tableBudget: [],
            labelPosition: 'top'

        };
    },

    computed: {
        verifFormBudget: function verifFormBudget() {
            if (this.formBudget.dateMoisAn != null && this.formBudget.libelle != "" && this.formBudget.montant != "") {
                return true;
            } else {
                return false;
            }
        }
    },
    watch: {
        show: function show(newValue, oldValue) {
            if (newValue == true) {
                var _this = this;
                this.tableBudget.splice(0);
                var detailBudget = this.typeTrx.detailBudget;
                detailBudget.forEach(function (item) {
                    _this.tableBudget.push(item);
                });
                this.dialogAjoutBudget = true;

                this.loadProduitBudget();
                this.formBudget = {
                    libelle: "",
                    montant: 5
                };
            } else {
                this.dialogAjoutBudget = false;
            }
        }
    },
    methods: (_methods = {
        resetForm: function resetForm() {
            this.$refs["formBudget"].resetFields();
        },
        deleteRow: function deleteRow(index, rows) {
            rows.splice(index, 1);
        },


        //budget
        loadProduitBudget: function loadProduitBudget() {
            var _this2 = this;

            this.loading = true;
            var url = this.domaine + "budgetProjet/liste";

            this.listeProduitBudget.splice(0);
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this2.loading = false;
                    _this2.listeProduitBudget = response.body.produits;
                }
            }, function (response) {
                _this2.loading = false;
            });
        },
        addListBudget: function addListBudget(item) {
            //verifier si l'item n'et pas deja enregistrer dans le tableau
            var eltProd = this.tableBudget.find(function (elt) {
                return elt.libelle == item.libelle && elt.dateMoisAn == item.dateMoisAn;
            });
            if (eltProd != null) {
                this.$message.error("Cet element a déjà été ajouté à la liste");
                return;
            }

            this.tableBudget.push({
                libelle: item.libelle,
                montant: item.montant,
                dateMoisAn: item.dateMoisAn
            });

            this.formBudget = {
                libelle: "",
                montant: 5
            };
        }
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "resetForm", function resetForm(formName) {
        this.$refs[formName].resetFields();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "headerRowStyle", function headerRowStyle(_ref) {
        var row = _ref.row,
            rowIndex = _ref.rowIndex;

        return { "color": "black" };
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "format", function format(percentage) {
        return percentage + "%";
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getSumm", function getSumm(param) {
        var columns = param.columns,
            data = param.data;

        var sums = [];
        columns.forEach(function (column, index) {
            if (index === 0) {
                sums[index] = "Sous total";
                return;
            }

            if (index === 4) {
                sums[index] = "N/A";
                return;
            }
            var values = data.map(function (item) {
                return Number(item[column.property]);
            });
            if (!values.every(function (value) {
                return isNaN(value);
            })) {
                sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                    var value = Number(curr);
                    if (!isNaN(value)) {
                        return prev + curr;
                    } else {
                        return prev;
                    }
                }, 0));
            } else {
                sums[index] = "N/A";
            }
        });

        return sums;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "submitForm", function submitForm() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "closeDialog", function closeDialog() {
        this.$emit("close");
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "createBudget", function createBudget() {
        var _this3 = this;

        this.loading = true;
        var url = this.domaine + "budgetProjet/create";
        var data = new FormData();
        data.append("tableBudget", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.tableBudget));
        data.append("idProjet", this.idProjet);
        data.append("typeTravauxId", this.typeTrx.id);
        data.append("userId", this.user.id);
        this.$http.post(url, data).then(function (resp) {
            _this3.closeDialog();
            _this3.tableBudget.splice(0);
            _this3.loading = false;
            _this3.$notify({
                title: "Budget",
                message: "Budget enregistre avec succes",
                type: "success",
                position: "top-right",
                duration: 7000
            });
        }, function (error) {
            _this3.loading = false;
            _this3.$message.error("Erreur lors  de l'enregistrement du budget");
        });
    }), _methods),

    mounted: function mounted() {}
});

/***/ }),

/***/ "V2G1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v(" "+_vm._s(item.text))])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('v-card',[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h3',[_vm._v("LISTE DES RESSOURCES TECHNIQUES / MANOEUVRES")]),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.generateRapport()}},slot:"activator"},[_vm._v("\n                              Pointage\n                              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e(),_vm._v("Effectuer un pointage journalier\n                          ")],1)],1),_vm._v(" "),_c('data-tables',{attrs:{"data":_vm.listeOuvriers}},[_c('el-table-column',{attrs:{"prop":"nom","label":"Nom","width":"200","fixed":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nbContrats","label":"Nb CONTRAT(S)","width":"240"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotal","label":"MONTANT TOTAL","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                              "+_vm._s(new Intl.NumberFormat().format(scope.row.mntTotal))+"\n                          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotalVerse","label":"MONTANT PAYE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                              "+_vm._s(new Intl.NumberFormat().format(scope.row.mntTotalVerse))+"\n                          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotalRestant","label":"MONTANT RESTANT","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                              "+_vm._s(new Intl.NumberFormat().format(scope.row.mntTotalRestant))+"\n                          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.showInfoOuvrier(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                  Détails...\n                              ")],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"92%"},model:{value:(_vm.dialogRapport),callback:function ($$v) {_vm.dialogRapport=$$v},expression:"dialogRapport"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Pointage journalier")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialogRapport = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('el-steps',{attrs:{"active":_vm.active,"align-center":"","simple":""}},[_c('el-step',{attrs:{"title":"Taches","icon":"el-icon-edit"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"Date rapport","icon":"el-icon-edit"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"Ouvrier/Manoeuvre","icon":"el-icon-edit"}})],1),_vm._v(" "),_c('el-form',{ref:"formContrat",staticClass:"demo-ruleForm",attrs:{"id":"formContrat","label-position":"top","model":_vm.formContrat}},[(_vm.active == 0)?_c('el-card',{staticClass:"box-card"},[_c('el-row',{attrs:{"type":"flex","gutter":20}},[_c('el-col',{attrs:{"span":9}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Type de Projet"},on:{"change":function($event){return _vm.loadChantier()}},model:{value:(_vm.formContrat.projet),callback:function ($$v) {_vm.$set(_vm.formContrat, "projet", $$v)},expression:"formContrat.projet"}},_vm._l((_vm.listeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chantier concerné")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Chantier concerné"},on:{"change":function($event){return _vm.loadTravaux()}},model:{value:(_vm.formContrat.chantier),callback:function ($$v) {_vm.$set(_vm.formContrat, "chantier", $$v)},expression:"formContrat.chantier"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":9}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Travaux"},on:{"change":function($event){return _vm.loadTacheTrx()}},model:{value:(_vm.formContrat.travaux),callback:function ($$v) {_vm.$set(_vm.formContrat, "travaux", $$v)},expression:"formContrat.travaux"}},_vm._l((_vm.listeTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1)],1):_vm._e(),_vm._v(" "),(_vm.active == 1)?_c('el-card',{staticClass:"box-card"},[_c('el-row',{attrs:{"type":"flex","gutter":20}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                          Le pointage se fait uniquement sur les rapports journaliers effectués par le commis\n                          ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center"}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center pr-2",attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-5 pl-2 pt-2"},[_c('h4',[_vm._v("\n                                Rapport non effectués\n                                "),_c('v-chip',{attrs:{"outline":"","color":"red"}},[_vm._v(_vm._s(_vm.listeRptNon.length))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-1"}),_vm._v(" "),(_vm.listeRptNon.length != 0)?_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeRptNon,"height":"325"},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"prop":"dateRpt","label":"Date","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"travaux","label":"Travaux"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tache","label":"Tache"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"comis","label":"Commis"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showPointage(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("Details du pointage\n                                      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.rapportJour(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("note_add")])],1),_vm._v("Continuer\n                                      ")],1)]}}],null,false,633530629)})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center"})],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.active == 2)?_c('el-card',{staticClass:"box-card"},[_c('el-row',{attrs:{"type":"flex","gutter":20}},[_c('ListePresence',{attrs:{"idTravaux":_vm.formContrat.travaux,"type":'pointage',"listeOuvriers":_vm.listePrestOuvriers},on:{"dataChange":_vm.loadListePresence}})],1)],1):_vm._e(),_vm._v(" "),_c('el-row',{attrs:{"justify":"end"}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"text-xs-right"},[(_vm.active!=0)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.previous}},[_vm._v("\n\n                              Précédent\n                          ")]):_vm._e(),_vm._v(" "),(_vm.active!=2 && _vm.active!=1 && _vm.formContrat.travaux)?_c('v-btn',{attrs:{"color":"primary","disabled":_vm.isInvalide},on:{"click":_vm.next}},[_vm._v("\n                              Suivant\n\n                          ")]):_vm._e(),_vm._v(" "),(_vm.active==2)?_c('v-btn',{attrs:{"dark":"","color":"green"},on:{"click":function($event){return _vm.createRapport('formContrat')}}},[_vm._v("\n\n                              Enregistrer\n                              "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("save")])],1):_vm._e()],1)])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","scrollable":"","max-width":"90%","persistent":""},model:{value:(_vm.dialogListRapport),callback:function ($$v) {_vm.dialogListRapport=$$v},expression:"dialogListRapport"}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("LISTE DES RESSOURCES TECHNIQUES UTILISÉ DANS LE RAPPORT DU "+_vm._s(_vm.dateRapport))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogListRapport = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"pt-2"},[_c('h4',[_vm._v("LISTE DES RESSOURCES TECHNIQUES UTILISEES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailRapport.listeParticipants}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [( props.row.heureSuppl != '00:00')?_c('v-flex',[_c('p',[_c('b',[_vm._v("Heure supplémentaire")]),_vm._v("\n                            : "+_vm._s(props.row.heureSuppl)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description heure supplémentaire")]),_vm._v("\n                            : "+_vm._s(props.row.descriptionSupp)+"\n                          ")])]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description")]),_vm._v("\n                            : "+_vm._s(props.row.description)+"\n                          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nomPrenom","label":"Nom & Prénoms","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"travaux","label":"Travaux","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureDbt","label":"Heure début","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureFin","label":"Heure fin","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heurePause","label":"Heure pause","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureIntem","label":"Heure Intemperie","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureTotal","label":"Heure travail","sortable":""}})],1)],1),_vm._v(" "),(_vm.detailRapport.listeParticipants &&
                  _vm.detailRapport.listeParticipants.length == 0
                )?_c('v-alert',{staticClass:"elevation-1 subheading mb-1",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                Informations non renseignées lors de\n                l'enregistrement du rapport\n              ")]):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('infoOuvrier',{attrs:{"show":_vm.showInfo,"infoOuvrier":_vm.infoOuvr},on:{"close":function($event){_vm.showInfo = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V3j6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutTache),callback:function ($$v) {_vm.dialogAjoutTache=$$v},expression:"dialogAjoutTache"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter/Editer des nouveaux lots de tâche ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeForm()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('el-form',{ref:"formLotTache",staticClass:"demo-ruleForm",attrs:{"rules":_vm.rulesLotTache,"id":"formLotTache","label-position":"top","model":_vm.formLotTache}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs1":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Ordre","prop":"ordre"}},[_c('el-select',{attrs:{"placeholder":"Select"},model:{value:(_vm.formLotTache.ordre),callback:function ($$v) {_vm.$set(_vm.formLotTache, "ordre", $$v)},expression:"formLotTache.ordre"}},_vm._l((_vm.numOrdre),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.num,"value":item.num}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Libelle tâche","prop":"libelle"}},[_c('el-input',{attrs:{"placeholder":"Saisir un libelle","name":"libelle"},model:{value:(_vm.formLotTache.libelle),callback:function ($$v) {_vm.$set(_vm.formLotTache, "libelle", $$v)},expression:"formLotTache.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Unité","prop":"unite"}},[_c('el-input',{attrs:{"placeholder":"unité","name":"unite"},model:{value:(_vm.formLotTache.unite),callback:function ($$v) {_vm.$set(_vm.formLotTache, "unite", $$v)},expression:"formLotTache.unite"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Prix unitaire (FCFA)","prop":"prix"}},[_c('el-input-number',{attrs:{"min":0,"name":"prix"},model:{value:(_vm.formLotTache.prix),callback:function ($$v) {_vm.$set(_vm.formLotTache, "prix", $$v)},expression:"formLotTache.prix"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"description"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":"description","name":"description","rows":6},model:{value:(_vm.formLotTache.description),callback:function ($$v) {_vm.$set(_vm.formLotTache, "description", $$v)},expression:"formLotTache.description"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('el-form-item',{attrs:{"label":"Action"}},[_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addListTypeTache()}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),(_vm.etatTache != 'niveau')?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('input',{ref:"fileInputExcel",staticStyle:{"display":"none"},attrs:{"name":"fileInputExcel","type":"file","accept":"image/*"},on:{"change":_vm.onFileExcelPicked}}),_vm._v(" "),(true)?_c('v-btn',{attrs:{"slot":"activator","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$refs.fileInputExcel.click()}},slot:"activator"},[_vm._v("\n                Importer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_download")])],1):_vm._e(),_vm._v("Importer fichier excel\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.generateFileExcel()}},slot:"activator"},[_vm._v("\n                Générer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1):_vm._e(),_vm._v("Générer un modèle\n            ")],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeTaches,"border":""}},[_c('el-table-column',{attrs:{"prop":"ordre","label":"Ordre"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-select',{attrs:{"placeholder":"Select"},on:{"change":function($event){return _vm.changeOrdre(prop.row.ordre, prop.$index)}},model:{value:(prop.row.ordre),callback:function ($$v) {_vm.$set(prop.row, "ordre", $$v)},expression:"prop.row.ordre"}},_vm._l((_vm.listeNumber),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.num,"value":item.num}})}),1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé tâche"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input',{attrs:{"controls-position":"right","size":"small"},on:{"change":function($event){return _vm.handleChangeLibelle()}},model:{value:(prop.row.libelle),callback:function ($$v) {_vm.$set(prop.row, "libelle", $$v)},expression:"prop.row.libelle"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"unité"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input',{attrs:{"controls-position":"right","size":"small"},model:{value:(prop.row.unite),callback:function ($$v) {_vm.$set(prop.row, "unite", $$v)},expression:"prop.row.unite"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix unitaire (FCFA)"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input-number',{attrs:{"min":0,"name":"prix"},model:{value:(prop.row.prix),callback:function ($$v) {_vm.$set(prop.row, "prix", $$v)},expression:"prop.row.prix"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"description"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input',{attrs:{"type":"textarea","controls-position":"right","size":"small"},model:{value:(prop.row.description),callback:function ($$v) {_vm.$set(prop.row, "description", $$v)},expression:"prop.row.description"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Opérations","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.listeTaches)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                      Supprimer cette tâche\n                    ")],1)]}}])})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","align-self-end":"","mt-4":""}},[_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pr-1",attrs:{"xs2":"","offset-xs8":""}},[_c('v-btn',{attrs:{"block":"","color":"grey","dark":""},on:{"click":function($event){return _vm.closeForm()}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"green","dark":""},on:{"click":function($event){return _vm.submitTache()}},slot:"activator"},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('LoadTypeTachesExcel',{attrs:{"show":_vm.showModalLoadTypeTravaux,"listeTypeTravaux":_vm.lstTypeTravaux,"idTypeTravaux":this.idTypeTravaux},on:{"close":function($event){_vm.showModalLoadTypeTravaux = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VAqU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Validation_post_index_vue__ = __webpack_require__("sI9Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59127dbd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Validation_post_index_vue__ = __webpack_require__("mfyo");
function injectStyle (ssrContext) {
  __webpack_require__("6I+N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59127dbd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Validation_post_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59127dbd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Validation_post_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Vj4D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");


var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: "ListeReserve",
  props: {
    show: {
      type: Boolean
    },
    type: {
      type: Number, //0=>chef travaux // 1=> chef chantier, 2=>chef projet
      default: 0
    },
    listeReserveTrx: {
      type: Array
    }
  },
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      dialogValidReserve: false,
      dialogReserveTache: false,
      detailReserve: [],
      disabledBtnTermine: true,
      multipleSelection: [],
      idReserve: null,
      //FILTRE
      listeProjet: [],
      listeChantier: [],
      BesoinsList: [],
      projetS: '',
      chantierS: '',
      dialogValidChef: false,
      etatReserve: 0, //0=>Trx en cours//1=>EN ATTENTE DE VALIDATION CHEF CHANTIER//2=> EN ATTENTE DE VALIDATION CHEF PROJET
      dialogValidChefProjetReserve: false,
      coutReserve: 0,
      dureeReserve: 0,
      tacheSelect: {},
      formFinTrx: {
        com: ""
      },
      imageTrx: "/static/travaux.jpg",
      fileTache: [],
      etatRes: "",
      listeReserves: [],
      listeEtatReserve: [{
        value: 0,
        libelle: "TRAVAUX EN COURS"
      }, {
        value: 1,
        libelle: "EN ATTENTE DE VALIDATION CHEF CHANTIER"
      }, {
        value: 2,
        libelle: "EN ATTENTE DE VALIDATION CHEF PROJET"
      }, {
        value: 3,
        libelle: "VALIDE"
      }],
      dialogRefusReserve: false,
      reserveSelect: {
        libTache: ""
      }
    };
  },


  watch: {
    show: function show(newValue, oldvalue) {
      if (newValue == true) {
        //this.oldListTravaux = this.listeTrx;
      }
    },
    listeReserveTrx: function listeReserveTrx(newValue, oldvalue) {
      this.listeReserves = this.listeReserveTrx;
    }
  },

  methods: (_methods = {
    //FILTRE
    loadProjet: function loadProjet() {
      var _this = this;

      this.listeChantier.splice(0);
      this.chantierS = null;
      var url = this.domaine + 'projet/index-projet-all';
      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this.loading = false;
        _this.listeProjet = response.body.projet;
      }, function (errRep) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    loadChantier: function loadChantier() {
      var _this2 = this;

      if (this.projetS == null || this.projetS == "undefined" || this.projetS == "") {
        this.listeReserves = this.listeReserveTrx;
        return;
      }
      this.loading = true;
      var url = this.domaine + 'projet/' + this.projetS + '/index/chantier';
      this.$http.get(url).then(function (response) {
        _this2.loading = false;
        _this2.listeChantier = response.body.chantier;
      }, function (errRep) {
        _this2.loading = false;
        _this2.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    filtrerChantier: function filtrerChantier() {
      //this.oldListTravaux = this.listeTrx;
      var idChant = this.chantierS;
      this.listeReserves = this.listeReserveTrx.filter(function (item) {
        return item.idChant == idChant;
      });
    },
    clearSelect: function clearSelect() {
      //this.listeTrx = this.oldListTravaux;
      this.chantierS = '';
      this.projetS = '';
      this.chantierS = '';
      this.listeChantier.splice(0);
    },
    validerTacheRapport: function validerTacheRapport() {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + "reserve/tache/valide/" + this.idReserve;

      var data = new FormData();
      data.append("idUser", this.user.id);

      data.append("commentaire", this.formFinTrx.com);
      if (this.fileTache.length > 0) {
        data.append("fichierImage", this.fileTache, this.fileTache[name]);
      }

      this.$http.post(url, data).then(function (response) {
        _this3.dialogValidReserve = false;
        _this3.loading = false;
        _this3.$notify({
          title: "TACHE TERMINE",
          message: "Tache enregistrée avec succès",
          type: "success",
          position: "top-center"
        });
        _this3.$emit("reloadListeReserve");
        //this.loadDetailReserve(this.idReserve);
      }, function (error) {
        _this3.loading = false;
        _this3.$message.error("Echec lors de la confirmation de l'execution des travaux");
      });
    },
    refusTacheRapport: function refusTacheRapport() {
      var _this4 = this;

      this.loading = true;

      var url = this.domaine + "reserve/tache/refuser/" + this.idReserve;

      var data = new FormData();
      data.append("idUser", this.user.id);

      data.append("commentaire", this.formFinTrx.com);

      if (this.fileTache.length > 0) {
        data.append("fichierImage", this.fileTache, this.fileTache[name]);
      }

      this.$http.post(url, data).then(function (response) {
        _this4.dialogRefusReserve = false;
        _this4.loading = false;
        _this4.formFinTrx.com = "", _this4.imageTrx = "/static/travaux.jpg", _this4.$notify({
          title: "TACHE TERMINE",
          message: "Tache enregistrée avec succès",
          type: "success",
          position: "top-center"
        });
        _this4.$emit("reloadListeReserve");
      }, function (error) {
        _this4.loading = false;
        _this4.$message.error("Echec lors de la confirmation de l'execution des travaux");
      });
    },
    valideReserve: function valideReserve() {
      var _this5 = this;

      this.loading = true;
      var data = new FormData();
      data.append("idUser", this.user.id);
      var url = "";
      if (this.type == 2) {

        url = this.domaine + "reserve/respoprojet/valider/" + this.idReserve;
      } else if (this.type == 1) {
        url = this.domaine + "reserve/respochantier/valider/" + this.idReserve;
      } else {
        return;
      }

      data.append("cout", this.coutReserve);
      data.append("duree", this.dureeReserve);

      this.$http.post(url, data).then(function (response) {
        _this5.dialogValidChef = false;
        _this5.dialogReserveTache = false;
        _this5.loading = false;
        _this5.$notify({
          title: "VALIDATION RESERVE",
          message: "Reserve validé avec succès",
          type: "success",
          position: "top-center"
        });
        _this5.dialogValidChefProjetReserve = false;
        _this5.$emit("reloadListeReserve");
      }, function (error) {
        _this5.loading = false;
        _this5.$message.error("Echec lors de la validation de la reservation");
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.disabledBtnTermine = true;
      } else {
        this.disabledBtnTermine = false;
      }
    },
    loadDetailReserve: function loadDetailReserve(idReserve) {
      var _this6 = this;

      this.loading = true;
      this.idReserve = idReserve;
      var url = this.domaine + "reserve/" + idReserve;
      this.$http.get(url).then(function (response) {
        _this6.detailReserve = response.body.reserve;
        //this.dialogReserveTache = true
        _this6.loading = false;
      }, function (error) {
        _this6.loading = false;
        _this6.$message.error("Echec lors du chargement des taches");
      });
    },
    onFileTachePicked: function onFileTachePicked(event) {
      var _this7 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this7.imageTrx = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.fileTache = files[0];
    },
    filtrerEtat: function filtrerEtat() {
      this.listeReserves = this.listeReserveTrx.filter(function (item) {
        return item.etatReserve == this.etatRes;
      }, this);
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "clearSelect", function clearSelect() {
    this.listeReserves = this.listeReserveTrx;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "resetForm", function resetForm(formName) {
    this.formFinTrx.com = "";
    this.fileTache = [];
    this.imageTrx = "/static/travaux.jpg";
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "modalAjoutReserve", function modalAjoutReserve() {}), _methods),

  mounted: function mounted() {
    this.loadProjet();
    this.loadChantier();
    this.clearSelect();
  }
});

/***/ }),

/***/ "VvO2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogBesoinTrx),callback:function ($$v) {_vm.dialogBesoinTrx=$$v},expression:"dialogBesoinTrx"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("BESOINS VEHICULES POUR DES TRAVAUX")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":"","ml-1":"","mr-1":"","mt-1":""}},[_c('v-card',[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick(_vm.onglet)}},model:{value:(_vm.onglet),callback:function ($$v) {_vm.onglet=$$v},expression:"onglet"}},[_c('el-tab-pane',{attrs:{"label":"Besoins â valider"}},[_c('ListeBesoinTravaux',{on:{"reloadBesoinValider":function($event){return _vm.loadBesoinVehAvalider()}}}),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Vehicules affectés à des travaux"}},[_c('VehiculeBesoin',{attrs:{"listeBesoinsVeh":_vm.listeBesoinsVehValid}})],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W5pE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_rapport_ListeRapportTrx__ = __webpack_require__("chSw");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */], ListeRapportTrx: __WEBPACK_IMPORTED_MODULE_1__components_rapport_ListeRapportTrx__["a" /* default */] },
    name: "ModalValidationFacture",
    // props:["show","factureDetail","totalFact",],
    props: {
        show: {
            type: Boolean
        },
        factureDetail: {
            type: Array
        },
        totalFact: {
            type: Number
        },
        infOrenseigner: {
            type: Array
        },
        commandeDeriv: {
            type: Array,
            required: false
        },
        commandeDerivDeux: {
            type: Array
        },
        mntTotalCmd: {
            type: String
        },
        nbCommandeSug: {
            type: Number
        },
        nbCommandeSugDeux: {
            type: Number
        },
        typeCommande: {
            type: Number,
            default: 1 //1=>Commande avec des options commandes//2=> commande avec des optionBesoins

        },
        listCaisse: {
            type: Array
        },
        listBanque: {
            type: Array
        }

    },
    data: function data() {
        return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            dialogDetail: false,
            tableProduit: [],
            totalTTC: 0,
            formRapport: {},
            dialogVisible: false,
            dialogImageUrl: '',
            mntEstimeContrat: 0,
            mntFactureGenere: 0,
            mntAVerserContrat: 0,
            evolutionContrat: 0,
            listCaisse: [],
            factureDetail: [],
            listBanque: [],
            image1: "/static/img-doc.png",
            imageDmd1: "",
            imageDmd2: "",
            imageDmd3: "",
            imageConst1: "",
            imageConst2: "",
            imageConst3: "",
            imageDepan1: "",
            imageDepan2: "",
            imageDepan3: "",
            dialogConfirmRefus: false,
            dialogConfirm: false,
            dialogDetailCmd: false,
            formRefus: {},
            ruleFormRefus: {
                rapportRefus: [{ required: true, message: 'Veuillez saisir' }]
            },
            formValidate: {
                choix: '',
                banque: ''
            },
            listeRapports: [],
            dialogListeRapport: false
        };
    },


    computed: {},
    watch: {
        show: function show(newValue, oldvalue) {
            this.dialogDetail = newValue;
            if (newValue == true) {}
        }
    },

    methods: {
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        },
        closeDialog: function closeDialog() {
            this.$emit('close', this.factureDetail.idFact, "factureFour");
        },
        closeCompar: function closeCompar() {
            // this.$emit('close')
            this.dialogDetailCmd = false;
        },
        changeReglement: function changeReglement() {
            if (this.formValidate.choix == 2) {
                this.formValidate.banque = '';
            } else {
                this.formValidate.banque = '';
            }
        },
        loadDevisConstat: function loadDevisConstat() {
            var _this = this;

            this.loading = true;
            var url = this.domaine + 'demande_maintenance/devis/constat/' + this.factureDetail.idDemande;
            this.$http.get(url).then(function (response) {
                _this.tableProduit = response.body.tableProduit;
                _this.formRapport.rapport = response.body.rapport;
                _this.totalTTC = response.body.total;
                _this.loading = false;
            }, function (errResp) {
                _this.loading = false;
                _this.$message.error("Une erreur est survenue lors du chargement de la table des produits");
            });
        },
        handleRemove: function handleRemove(file, fileList) {},
        handleSuccess: function handleSuccess(response, file, fileList) {

            this.fileList.push(file);
        },
        handlePictureCardPreview: function handlePictureCardPreview(file, fileList) {

            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        imprimerDetail: function imprimerDetail() {
            var url = this.domaine + "demande_maintenance/imprimerPDF/demande/" + this.user.id + "/" + this.factureDetail.idDemande;
            window.open(url);
        },
        SubmitValideDevis: function SubmitValideDevis() {
            var _this2 = this;

            if (this.formValidate.choix == null || this.formValidate.banque == "undefined" || this.formValidate.banque == "") {
                this.$message.error("Remplissez les champs obligatoires");
                return;
            }

            this.loading = true;
            var url = this.domaine + 'fournisseur/valider/facture';

            var data = new FormData();
            data.append("id", this.factureDetail.idFact);
            data.append("banque", this.formValidate.banque);

            data.append("idUser", this.user.id);
            data.append("remarque", " ");
            data.append("decision", 1);
            this.$http.post(url, data).then(function (response) {
                _this2.loading = false;
                _this2.successNotif(response.body.message);
                _this2.dialogConfirm = false;
                _this2.closeDialog();
            }, function (errResp) {
                _this2.loading = false;
                _this2.$message.error("Une erreur est survenue lors de la facture");
            });
        },
        SubmitRefusDevis: function SubmitRefusDevis() {
            var _this3 = this;

            this.loading = true;
            var url = this.domaine + 'fournisseur/valider/facture';

            var data = new FormData();
            data.append("id", this.factureDetail.idFact);
            data.append("idUser", this.user.id);
            data.append("remarque", this.formRefus.rapport);
            data.append("decision", 2);
            this.$http.post(url, data).then(function (response) {
                _this3.loading = false;
                _this3.successNotif(response.body.message);
                _this3.dialogConfirmRefus = false;
                _this3.closeDialog();
            }, function (errResp) {
                _this3.loading = false;
                _this3.$message.error("Une erreur est survenue lors de la facture");
            });
        },
        loadRapportTrx: function loadRapportTrx() {
            var _this4 = this;

            this.loading = true;
            var url = this.domaine + 'journal/travaux/' + this.factureDetail.idTravaux;
            this.$http.get(url).then(function (response) {
                _this4.listeRapports = response.body.journaux;
                _this4.dialogListeRapport = true;
                _this4.loading = false;
            }, function (error) {
                _this4.loading = false;
                _this4.$message.error('Echec lors du chargement des Journaux');
            });
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "W8r5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_besoin_listeBesoinTravaux__ = __webpack_require__("mYh4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_besoin_VehiculeBesoin__ = __webpack_require__("K4PS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */], ListeBesoinTravaux: __WEBPACK_IMPORTED_MODULE_1__components_besoin_listeBesoinTravaux__["a" /* default */], VehiculeBesoin: __WEBPACK_IMPORTED_MODULE_2__components_besoin_VehiculeBesoin__["a" /* default */] },
  name: "BesoinTravaux",
  props: {
    show: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      dialogBesoinTrx: false,
      loading: false,
      onglet: "0",
      //ONGLET BESOINS TRAVAUX A VALIDER
      listeVehicules: [],
      //ONGLET LISTE VEHICULE AFFECTE
      listeBesoinsVehValid: []
    };
  },

  methods: {
    //ONGE=LET VEHICULE AFFECTE
    loadBesoinVehValider: function loadBesoinVehValider() {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "besoin/vehicule/valider";
      this.$http.get(url).then(function (response) {
        _this.listeBesoinsVehValid = response.body.besoins;
        _this.loading = false;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Echec lors du chargement des vehicules affectés au besoins");
      });
    },
    loadBesoinVehAvalider: function loadBesoinVehAvalider() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "besoin/vehicule";
      this.$http.get(url).then(function (response) {
        _this2.listeBesoinsVeh = response.body.besoins;
        _this2.nbBesoins = response.body.besoins.length;
        _this2.loading = false;
      });
    },
    handleTabClick: function handleTabClick(tab) {
      switch (tab) {
        case "0":
          this.loadBesoinVehValider();
          break;
        case "1":
          this.loadBesoinVehValider();
          break;

        default:
          this.loadBesoinVehAvalider();
          break;
      }
    },
    closeDialog: function closeDialog() {
      this.listeVehicules.splice(0);
      this.$emit("close");
    }
  },

  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogBesoinTrx = newValue;

      if (newValue == true) {
        this.onglet = "0";
        //this.loadListeVehicule()
      }
    }
  }
});

/***/ }),

/***/ "WLV0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadFourn_vue__ = __webpack_require__("uQqf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76b085af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadFourn_vue__ = __webpack_require__("qFyZ");
function injectStyle (ssrContext) {
  __webpack_require__("u1so")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76b085af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadFourn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76b085af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadFourn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WNAQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WQvJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Client_vue__ = __webpack_require__("i5JW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe0f2534_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Client_vue__ = __webpack_require__("XeBl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Client_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe0f2534_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Client_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WVMY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Maintenance_index_vue__ = __webpack_require__("OgWx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f248526_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Maintenance_index_vue__ = __webpack_require__("adPx");
function injectStyle (ssrContext) {
  __webpack_require__("wd6Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Maintenance_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f248526_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Maintenance_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WeAx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */] },
  name: "Mission",
  data: function data() {
    var _ref;

    return _ref = {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [{ path: "/mission/Mission", text: "Mission", disabled: false }],
      dialogDemande: false,
      tableMission: [],
      statistique: [],
      tableParticipant: [],
      tableParticipantDemande: [],
      listDescription: [],
      tableFrais: [],
      dialogSuppParticipant: false,
      dialogCloturerMission: false,
      dialogEditMiss: false,
      formDemande: {},
      active: 1,
      detailMission: {},
      isEdit: false,
      idEditMission: "",
      MissId: "",
      dialogDetailMission: false,
      idMission: null,
      dialogValidMission: false,
      dialogSupr: false,
      e1: 1,
      d1: 1,
      idPartMod: null,
      formParticipant: {},
      formDemandePart: {},
      formFrais: {
        quantite: 1,
        prixUnit: 5,
        tva: 0
      },
      formCloture: {},
      remboursable: false,
      radioVeh: "Vehicule de service",
      vehSelect: null,
      comboVeh: [],
      listeCaisse: [],
      chantierSelect: null,
      comboChantier: [],
      totalLigne: 0,
      comboCond: [],
      condSelect: "",
      comboUser: [],
      userMission: null,
      totalTTC: null,
      totalHT: null,
      totalTVA: null,
      total: null,
      dialogAccord: false,
      dialogAccord2: false
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogValidMission", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogRejeterMission", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "caisseSelect", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "motifRejet", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dateLimit", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbMissFin", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbMissRetour", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "missionUser", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "rules", {
      req: [{
        required: true,
        message: "Veuillez remplir ce champ",
        trigger: "blur"
      }],
      tel1: [{
        required: true,
        message: "Veuillez remplir ce champ",
        trigger: "blur"
      }]
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectEtatMiss", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnMiss", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "comboEtatMiss", [{
      etat: 0,
      label: "Toutes les missions"
    }, {
      etat: 1,
      label: "En cours"
    }, {
      etat: 2,
      label: "Cloture"
    }, {
      etat: 3,
      label: "En attente de la premiere validation"
    }, {
      etat: 4,
      label: "Annule"
    }, {
      etat: 5,
      label: "En attente de la deuxieme validation"
    }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "image1Rpt", "/static/img-doc.png"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "file1Rpt", "/static/img-doc.png"), _ref;
  },


  computed: {
    verifBudget: function verifBudget() {
      if (this.formFrais.libelle == undefined || this.formFrais.libelle == null || this.formFrais.libelle == "" || this.formFrais.quantite == 0 || this.formFrais.prixUnit == 0 || this.formFrais.tva == undefined) {
        return false;
      }
      return true;
    }
  },

  methods: {
    filtrerMission: function filtrerMission(etat) {
      this.loadMissParEtat(etat);
    },
    calculTotalComm: function calculTotalComm() {
      var quantite = this.formFrais.quantite;
      var prixUnit = this.formFrais.prixUnit;
      var tva = this.formFrais.tva;
      var mnt = quantite * prixUnit;
      var mntTva = mnt * tva / 100;
      this.totalLigne = mnt + mntTva;
    },
    loadMissParEtat: function loadMissParEtat(etat) {
      var _this = this;

      var url = this.domaine + "mission/etat_miss";
      var data = new FormData();
      data.append("etat", etat);
      this.loading = true;
      this.$http.post(url, data).then(function (response) {
        _this.loading = false;
        if (response.body) {
          _this.tableMission = response.body.missions;
          if (_this.tableMission === undefined || _this.tableMission.length == 0) {
            _this.disabledBtnMiss = true;
          } else {
            _this.disabledBtnMiss = false;
          }
        }
      }, function (response) {
        _this.loading = false;
        _this.$message.error("Erreur sur le  filtre des de missions");
      });
    },
    loadMissParEtatByUser: function loadMissParEtatByUser(etat) {
      var _this2 = this;

      var url = this.domaine + "mission/etat_miss/user";
      var data = new FormData();
      data.append("userid", this.user.id);
      data.append("etat", etat);
      this.loading = true;
      this.$http.post(url, data).then(function (response) {
        _this2.loading = false;
        if (response.body) {
          _this2.tableMission = response.body.missions;
          if (_this2.tableMission === undefined || _this2.tableMission.length == 0) {
            _this2.disabledBtnMiss = true;
          } else {
            _this2.disabledBtnMiss = false;
          }
        }
      }, function (response) {
        _this2.loading = false;
        _this2.$message.error("Erreur sur le  filtre des de missions");
      });
    },
    rejetMission: function rejetMission() {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + "mission/rejeter";
      var data = new FormData();
      data.append("motifRefus", this.motifRejet);
      data.append("idMission", this.detailMission.IdUtil);
      data.append("user", this.user.id);
      this.$http.post(url, data).then(function (resp) {
        _this3.loading = false;
        _this3.$notify({
          title: "REFUSER DEMANDE MISSION",
          message: resp.body.message,
          type: "success",
          position: "top-right"
        });
        _this3.dialogRejeterMission = false;
        _this3.dialogDetailMission = false;
        _this3.dialogValidMission = false;
        _this3.loadMissions();
      }, function (respError) {
        _this3.loading = false;
        _this3.$message.error("Erreur lors du rejet de l'ordre de mission");
      });
    },
    cloturerMission: function cloturerMission(item) {
      this.idMission = item.IdUtil;
      this.dialogCloturerMission = true;
    },
    selectVehicule: function selectVehicule(item) {
      this.loadConducteurDisp(item);
    },
    loadConducteurDisp: function loadConducteurDisp(item) {
      var _this4 = this;

      this.loading = true;
      var url = this.domaine + "conducteur/disponible/" + item;
      this.$http.get(url).then(function (resp) {
        _this4.loading = false;
        _this4.comboCond = resp.body.conducteur;
      }, function (respError) {
        _this4.loading = false;
        _this4.$message.error("Erreur lors du chargement des informations du conducteur");
      });
    },
    valideCloture: function valideCloture() {
      var _this5 = this;

      if (this.formCloture.DateRetour == '') {
        return this.$message.error("Veuillez renseigner les champs obligatoires");
      }
      this.loading = true;
      var url = this.domaine + "mission/cloturer";
      var form = document.getElementById("formRapport");
      var data = new FormData(form);
      data.append("idMission", this.idMission);
      data.append("user", this.user.id);
      data.append("formCloture", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formCloture));
      this.$http.post(url, data).then(function (resp) {
        _this5.loading = false;
        _this5.image1Rpt = "/static/img-doc.png";

        if (resp.body.code == 5) {
          _this5.$notify({
            title: "CLOTURER MISSION",
            message: resp.body.message,
            type: "warning",
            position: "top-right"
          });
        } else {
          _this5.$notify({
            title: "CLOTURER MISSION",
            message: resp.body.message,
            type: "success",
            position: "top-right"
          });
        }
        _this5.dialogCloturerMission = false;
        _this5.loadMissions();
      }, function (resp) {
        _this5.$message.error("Erreur lors de la cloture  de la mission");
        _this5.loading = false;
      });
    },
    deleteRow: function deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    deleteRowBudget: function deleteRowBudget(index, rows) {
      var item = rows.splice(index, 1);
      var mnt = item[0].quantite * item[0].prixUnit;
      var mntTva = mnt * item[0].tva / 100;
      var mntTx = mnt + mntTva;
      this.totalTTC -= mntTx;
      this.totalHT -= mnt;
      this.totalTVA -= mntTva;
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    confValidMission: function confValidMission() {
      this.dialogValidMission = true;
    },
    loadMissions: function loadMissions() {
      var _this6 = this;

      var url = "";
      if (this.droitAcces.list_mission) {
        url = this.domaine + "mission/index";
      } else if (this.droitAcces.list_mission_personne) {
        //pour une personne qui a fait la demande
        url = this.domaine + "mission/index/personne/" + this.user.id;
      } else if (this.droitAcces.list_mission_user) {
        //affiche les elements de celui qui est connecté
        url = this.domaine + "mission/index/" + this.user.id;
      }
      this.$http.get(url).then(function (resp) {
        _this6.tableMission = resp.body.missions;
        _this6.statistique = resp.body.stat;
        _this6.nbUtil = resp.body.nbUtil;
        _this6.nbMissFin = resp.body.nbMissFin;
        _this6.nbMissRetour = resp.body.nbMissRetour;
        _this6.missionUser = resp.body.missionUser;

        if (_this6.notif === "active" && _this6.droitAcces.valider2_mission && _this6.statistique.missAvalide2 > 0) {
          _this6.$vs.notify({
            title: "DEMANNDE DE MISSION",
            text: "Vous avez des demandes de mission à valider",
            color: "danger",
            position: "top-right",
            icon: "description",
            fixed: false,
            time: 10000
          });
        }

        if (_this6.notif === "active" && !_this6.droitAcces.valider2_mission && _this6.statistique.missAvalide1 > 0) {
          _this6.$vs.notify({
            title: "DEMANNDE DE MISSION",
            text: "Vous avez des demandes de mission à approuver",
            color: "danger",
            position: "top-right",
            icon: "description",
            fixed: false,
            time: 10000
          });
        }
      }, function (resp) {
        _this6.$message.error("erreur lors du chargement des missions.");
      });
    },
    removeParticipant: function removeParticipant(item) {
      var index = this.formDemande.participants.indexOf(item);
      if (index !== -1) {
        this.formDemande.participants.splice(index, 1);
      }
    },
    addParticipant: function addParticipant() {
      this.formDemande.participants.push({
        key: Date.now(),
        Nom: "",
        Prenom: "",
        Fonction: "",
        Contact: ""
      });
    },
    ImprimeSimpleMission: function ImprimeSimpleMission(idMiss, format) {
      var url = this.domaine + "mission/impression/" + idMiss + "/" + format + "/" + this.user.id;
      var data = {
        idUser: this.user.id
      };
      this.$http.get(url, { params: data }).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    addListParticipant: function addListParticipant(item) {
      if (item.Nom == undefined && item.Prenom == undefined && item.Fonction == undefined) {
        this.$message.error("Veuillez remplir correctement les champs");
        return;
      }
      this.tableParticipant.push({
        nom: item.Nom,
        prenom: item.Prenom,
        fonction: item.Fonction,
        contact: item.Contact
      });

      this.formParticipant = {};
    },
    addListParticipantDemande: function addListParticipantDemande(item) {
      if (item.Nom == undefined || item.Prenom == undefined || item.Fonction == undefined) {
        this.$message.error("Veuillez remplir correctement les champs");
        return;
      }
      this.tableParticipantDemande.push({
        nom: item.Nom,
        prenom: item.Prenom,
        fonction: item.Fonction
      });

      this.formDemandePart = {};
    },
    addListFrais: function addListFrais(item) {
      this.tableFrais.push({
        libelle: item.libelle,
        quantite: item.quantite,
        prixUnit: item.prixUnit,
        tva: item.tva ? item.tva : 0,
        total: item.quantite * item.prixUnit + item.quantite * item.prixUnit * item.tva / 100
      });
      this.formFrais = {
        libelle: null,
        quantite: 1,
        prixUnit: 5,
        tva: 0
      };
      var mnt = item.quantite * item.prixUnit;
      this.totalHT += mnt;
      var mntTva = mnt * item.tva / 100;
      this.totalTVA += mntTva;
      var mntTx = mnt + mntTva;
      this.totalTTC += mntTx;
      this.totalLigne = 0;
    },
    validMission: function validMission(etatValMiss) {
      var _this7 = this;

      this.loading = true;
      var url = this.domaine + "mission/valide/demande";
      var data = new FormData();
      data.append("idMission", this.idMission);
      data.append("etatValMiss", etatValMiss);
      data.append("tabParticipant", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableParticipant));
      data.append("tableFrais", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableFrais));
      data.append("rembourser", this.remboursable);
      data.append("idCond", this.condSelect);
      data.append("dateLimit", this.dateLimit);
      data.append("modeTransport", this.radioVeh);
      data.append("idVeh", this.vehSelect);
      data.append("idCaisse", this.caisseSelect);
      data.append("user", this.user.id);
      this.$http.post(url, data).then(function (resp) {
        _this7.loading = false;
        _this7.$notify({
          title: "VALIDE MISSION",
          message: resp.body.message,
          type: "success",
          position: "top-right"
        });

        _this7.dialogDetailMission = false;
        _this7.dialogAccord = false;
        _this7.loadMissions();
      }, function (resp) {
        _this7.$message.error("Erreur lors de la validation de mission");
        _this7.loading = false;
      });
    },
    verifFormDmd: function verifFormDmd() {
      if (this.formDemande.Activite != null && this.formDemande.DateEntrePrevue != null && this.formDemande.DateSorti != null && this.formDemande.Itineraire != null && this.formDemande.UserMission != null) {
        return true;
      } else {
        return false;
      }
    },
    valid2Mission: function valid2Mission() {
      var _this8 = this;

      this.loading = true;
      var url = this.domaine + "mission/valide/mission";
      var data = new FormData();
      data.append("idMission", this.idMission);
      data.append("etatValMiss", this.detailMission.etat);
      data.append("idVeh", this.detailMission.idVeh);
      data.append("user", this.user.id);
      this.$http.post(url, data).then(function (resp) {
        _this8.loading = false;
        _this8.$notify({
          title: "VALIDE MISSION",
          message: resp.body.message,
          type: "success",
          position: "top-right"
        });

        _this8.dialogAccord2 = false;
        _this8.dialogValidMission = false;
        _this8.loadMissions();
      }, function (resp) {
        _this8.$message.error("Erreur lors de la validation de mission");
        _this8.loading = false;
      });
    },
    newDemande: function newDemande(formName) {
      var tel = this.user.telephone.replace(/\s+/g, '');
      this.formDemande = {
        Activite: "",
        UserMission: this.user.username,
        Itineraire: "",
        tel1: tel.length == 14 ? tel.substr(4) : tel,
        Chantier: null,
        DateSorti: null,
        DateEntrePrevue: null,
        Description: ""
      };

      this.d1 = 1;
      this.loadChantier();
      this.loadUserAdmin();
      this.dialogDemande = true;
      this.tableParticipantDemande.splice(0);
      this.isEdit = false;
      this.idEditMission = "";
    },
    next: function next() {
      if (this.active++ > 2) this.active = 2;
    },
    prev: function prev() {
      if (this.active-- < 1) this.active = 1;
    },
    showDetailMission: function showDetailMission(item) {
      this.e1 = 1;
      this.idMission = item.IdUtil;
      this.dialogDetailMission = true;
      this.detailMission = {
        marque: item.marque,
        modele: item.modele,
        serie: item.serie,
        debut: item.debut,
        activite: item.activite,
        chantier: item.chantier,
        caisse: item.caisse,
        utilisateur: item.utilisateur,
        libEtat: item.libEtat,
        etat: item.etat,
        dateEntrePrevue: item.retour,
        dateValidation1: item.dateValidation1,
        dateValidation2: item.dateValidation2,
        distPrevue: item.distPrevue,
        itineraire: item.itineraire,
        prime: item.prime,
        fraisMission: item.fraisMission,
        fraisCarburant: item.fraisCarburant,
        kmDepart: item.kmDepart,
        niveauCarbDepart: item.niveauCarbDepart,
        fin: item.fin,
        kmRetour: item.kmRetour,
        niveauCarbRetour: item.niveauCarbRetour,
        distParcourue: item.distParcourue,
        carbConsom: item.carbConsom,
        fonction: item.fonction,
        description: item.description,
        date: item.date,
        demandeur: item.demandeur,
        IdUtil: item.IdUtil,
        idVeh: item.idVeh,
        modeTransport: item.modeTransport,
        userRapport: item.userRapport
      };
      this.tableParticipant = item.participants;
      this.tableFrais.splice(0);
      this.totalTTC = 0;
      this.totalHT = 0;
      this.totalTVA = 0;
      this.vehSelect = item.idVeh;
      this.condSelect = item.idCond;
    },
    showValidMission: function showValidMission(item) {
      var _detailMission;

      this.idMission = item.IdUtil;
      this.dialogValidMission = true;
      this.detailMission = (_detailMission = {
        marque: item.marque,
        userRapport: item.userRapport,
        modele: item.modele,
        serie: item.serie,
        debut: item.debut,
        retour: item.retour,
        activite: item.activite,
        chantier: item.chantier,
        caisse: item.caisse,
        utilisateur: item.utilisateur,
        libEtat: item.libEtat,
        etat: item.etat,
        dateEntrePrevue: item.retour,
        dateValidation1: item.dateValidation1,
        dateValidation2: item.dateValidation2,
        distPrevue: item.distPrevue,
        itineraire: item.itineraire,
        prime: item.prime,
        fraisMission: item.fraisMission,
        fraisCarburant: item.fraisCarburant,
        kmDepart: item.kmDepart,
        kmRetour: item.kmRetour,
        niveauCarbDepart: item.niveauCarbDepart,
        fin: item.fin
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "kmRetour", item.kmRetour), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "niveauCarbRetour", item.niveauCarbRetour), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "distParcourue", item.distParcourue), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "carbConsom", item.carbConsom), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "fonction", item.fonction), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "description", item.description), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "date", item.date), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "demandeur", item.demandeur), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "IdUtil", item.IdUtil), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "nomPren", item.nomPren), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "totalFrais", item.totalFrais), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "totalFraisHT", item.totalFraisHT), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "totalTva", item.totalTva), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "validateur1", item.validateur1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "validateur2", item.validateur2), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "idVeh", item.idVeh), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "modeTransport", item.modeTransport), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "carbConsom", item.carbConsom), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "mntCarburant", item.mntCarburant), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "imageRapport", item.imageRapport), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_detailMission, "rapport", item.rapport), _detailMission);

      this.tableParticipant = item.participants;
      this.tableFrais = item.frais;
    },
    loadVehiculeDisp: function loadVehiculeDisp() {
      var _this9 = this;

      var url = this.domaine + "mission/vehicule/disponible";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this9.comboVeh = response.body.vehicule;
        }
      });
    },
    loadChantier: function loadChantier() {
      var _this10 = this;

      var url = this.domaine + "chantier/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this10.comboChantier = response.body.chantier;
        }
      });
    },
    loadCaisse: function loadCaisse() {
      var _this11 = this;

      var url = this.domaine + "caisse/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this11.listeCaisse = response.body.caisse;
        }
      });
    },
    loadUserAdmin: function loadUserAdmin() {
      var _this12 = this;

      var url = this.domaine + "mission/liste/admin";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this12.comboUser = response.body.listAdmin;
        }
      });
    },
    confValMission: function confValMission() {
      this.dialogAccord2 = true;
    },
    imprimeMission: function imprimeMission() {
      var idEtat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var url = this.domaine + "mission/liste/impression/" + idEtat + "/" + this.user.id;
      window.open(url);
    },
    imprimeMissionExc: function imprimeMissionExc() {
      var idEtat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var url = this.domaine + "mission/impressionExc/liste/" + idEtat;
      window.open(url);
    },
    editMission: function editMission(item) {
      this.loadChantier();
      this.formDemande = {
        Activite: item.activite,
        UserMission: item.demandeur,
        tel1: item.telUserDemandeur,
        Itineraire: item.itineraire,
        Chantier: item.idChant,
        DateSorti: item.departFormat,
        DateEntrePrevue: item.prevueFormat,
        Description: item.description
      };
      this.tableParticipantDemande = item.participants;
      this.idEditMission = item.IdUtil;
      this.dialogDemande = true;
      this.isEdit = true;
      this.d1 = 1;
    },
    deleteMission: function deleteMission() {
      var _this13 = this;

      this.loading = true;
      var url = this.domaine + "mission/" + this.MissId + "/delete";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this13.$notify({
            title: "SUPPRESSION",
            message: "Mission supprimée avec succès.",
            type: "success",
            position: "top-center"
          });
          _this13.dialogSupr = false;
          _this13.loading = false;
          _this13.loadMissions();
          _this13.loading = false;
        }
      });
    },
    createDemande: function createDemande(formName) {
      var _this14 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this14.loading = true;
          var url = "";
          var data = new FormData();
          data.append("formDemande", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this14.formDemande));
          data.append("description", _this14.listDescription);
          data.append("participants", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this14.tableParticipantDemande));
          data.append("user", _this14.user.id);
          if (_this14.isEdit == true) {
            data.append("idMission", _this14.idEditMission);
            url = _this14.domaine + "mission/edit/demande";
          } else {
            url = _this14.domaine + "mission/create/demande";
          }
          _this14.$http.post(url, data).then(function (resp) {
            _this14.$refs["formDemande"].resetFields();
            _this14.loading = false;
            _this14.dialogDemande = false;
            _this14.$notify({
              title: "ENREGISTREMENT MISSION",
              message: resp.body.message,
              type: "success",
              position: "top-right",
              duration: 5000
            });

            _this14.loadMissions();
            _this14.isEdit = false;
            _this14.idEditMission = "";
            _this14.listDescription = [];
          }, function (resp) {
            _this14.$message.error("Erreur lors de l'enregistrement de la demande de mission");
            _this14.loading = false;
          });
        } else {
          _this14.d1 = 1;
          _this14.$message.error("Veuillez remplir correctement les champs s'il vous plait");
          return false;
        }
      });
    },
    showDialogAccord: function showDialogAccord() {
      if (this.caisseSelect == null && this.totalTTC > 0) {
        this.$message({
          showClose: true,
          message: "Veuillez selectionner une caisse pour effectuer les paiements.",
          type: "error"
        });
        return;
      }
      this.dialogAccord = true;
    },
    onFileImage1RptPicked: function onFileImage1RptPicked(event) {
      var _this15 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un format de fichier valide ");
      }
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this15.image1Rpt = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.file1Rpt = files[0];
    },
    createFilter: function createFilter(queryString) {
      return function (link) {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    loadDemandeur: function loadDemandeur(queryString, cb) {
      var _this16 = this;

      var url = this.domaine + "mission/listes-employe";
      var formdata = new FormData();
      formdata.append("user", this.user.id);
      formdata.append("tag", queryString);
      this.$http.post(url, formdata).then(function (response) {
        if (response.body) {
          var links = response.body;
          var results = queryString ? links.filter(_this16.createFilter(queryString)) : links;
          cb(results);
        }
      }, function (response) {});
    }
  },
  mounted: function mounted() {
    this.loadMissions();
    this.loadVehiculeDisp();
    this.loadCaisse();
  }
});

/***/ }),

/***/ "Wgzm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","content":"","content-class":"centered-dialog"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"column":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"width":7,"color":_vm.progressColor}}),_vm._v(" "),(_vm.message != null)?_c('h1',[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wi44":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"tile":""}},[_c('v-card-text',[_c('h4',{attrs:{"mt-2":""}},[_vm._v("\n      "+_vm._s(this.typeReche == "carburant"
          ? "LISTE DES DEMANDES DE CARBURANT A APPROUVER"
          : "LISTE DES RESSOURCES A APPROUVER")+"\n    ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","mt-2":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-4 mt-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Selectionner un Chantier"},on:{"change":function($event){return _vm.filtrerChantier()},"clear":function($event){return _vm.clearSelectChantier()}},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),(_vm.chantierS != '')?_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner un travaux"},on:{"change":function($event){return _vm.filtrerTravaux()}},model:{value:(_vm.travauxS),callback:function ($$v) {_vm.travauxS=$$v},expression:"travauxS"}},_vm._l((_vm.listeTravaux),function(item){return _c('el-option',{key:item.idTravaux,attrs:{"label":item.libTravaux,"value":item.idTravaux}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.travauxS != '')?_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Selectionner une tâche"},on:{"change":function($event){return _vm.filtrerTaches()}},model:{value:(_vm.tachesS),callback:function ($$v) {_vm.tachesS=$$v},expression:"tachesS"}},_vm._l((_vm.listeTaches),function(item){return _c('el-option',{key:item.idTache,attrs:{"label":item.libTache,"value":item.idTache}})}),1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","disabled":_vm.disabledBtnValide,"icons":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.modalValideBesoin()}},slot:"activator"},[_vm._v("\n            Approuver / Rejeter\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done")])],1),_vm._v("Valider les ressources sélectionées\n        ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-2":""}},[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"mt-3":"","ml-1":"","mr-1":"","data":_vm.BesoinsList},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('h3',[_vm._v("Libelle du PROJET/CHANTIER/TRAVAUX/TACHE:")]),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(props.row.libelle)+"\n              ")]),_vm._v(" "),_c('h3',[_vm._v("DEMANDEUR:")]),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(props.row.demandeur)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"55","type":"selection"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE DEMANDE","align":"center"}}),_vm._v(" "),_c('el-table-column',{directives:[{name:"fi",rawName:"v-fi",value:(_vm.typeReche != 'carburant'),expression:"typeReche != 'carburant'"}],attrs:{"prop":"codeGestion","label":"Code analytique","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"TYPE RESSOURCE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"produit","label":"RESSOURCE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"QTE PREVU","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":""}},[_vm._v("\n                "+_vm._s(scope.row.qte)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteC","label":"QTE COMMANDE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"green","label":""}},[_vm._v("\n                "+_vm._s(scope.row.qteC)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteR","label":"QTE RESTANTE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"red","label":""}},[_vm._v("\n                "+_vm._s(scope.row.qteR)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"UNITE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"priorite","sortable":"","label":"PRIORITE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.priorite === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"green accent-3"}},[_vm._v("Faible")]):(scope.row.priorite === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"orange accent-4"}},[_vm._v("Normal")]):(scope.row.priorite === 3)?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"red accent-3"}},[_vm._v("Urgent")]):_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"blue lighten-4"}},[_vm._v("Aucune")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"DATE SOUH / PERIODE D'UTILISATION","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"periode","label":"PERIODE TRAVAUX","align":"center"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"900"},model:{value:(_vm.dialogValideBesoin),callback:function ($$v) {_vm.dialogValideBesoin=$$v},expression:"dialogValideBesoin"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("VALIDATION DES RESSOURCES SELECTIONNEES")]),_vm._v(" "),_c('v-card-text',{staticClass:"mb-5"},[_c('el-alert',{attrs:{"title":'Voulez-vous approuver ou rejeter Les ressources selectionnées ',"description":"Les ressources validées concernant le matériel seront soumis aux services achat. Les demandes de carburant pour les véhicules seront traité par l'Entrepot Hydrolique,tandis que les ressources concernant les véhicules devront être analysé par le responsable logistique. Si vous décidez de valider les ressources ,veuillez précisez la date de livraison souhaitée s'il vous plait et la mention bon pour accord dans le champs commentaire.","type":"warning","center":"","closable":false,"show-icon":""}}),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%","margin-top":"30px"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":_vm.listeBesoinSelect}},[_c('el-table-column',{attrs:{"align":"center","prop":"produit","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"periode","label":"PERIODE TRAVAUX"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"dateLivrSouh","label":"DATE LIVRAISON SOUHAITEE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateLivrSouh","label":"CHANGER DATE LIVRAISON *"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('div',{staticClass:"block"},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","id":"dateLivrSouh","type":"date","placeholder":"Choississez une date de livraison"},model:{value:(prop.row.dateLivrSouh),callback:function ($$v) {_vm.$set(prop.row, "dateLivrSouh", $$v)},expression:"prop.row.dateLivrSouh"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteR","label":"QUANTITE A COMMANDER *"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('div',{staticClass:"block"},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","name":"qteR"},on:{"change":function($event){return _vm.calculTotalComm(prop.row)}},model:{value:(prop.row.qteR),callback:function ($$v) {_vm.$set(prop.row, "qteR", $$v)},expression:"prop.row.qteR"}})],1)]}}])})],1),_vm._v(" "),_c('el-form',{staticClass:"mt-4",attrs:{"label-position":"top","label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"Commentaire *"}},[_c('el-input',{attrs:{"rows":"6","type":"textarea","placeholder":"Veuillez saisir l'expression bon pour accord si vous souhaitez valider la demande"},model:{value:(_vm.commDec),callback:function ($$v) {_vm.commDec=$$v},expression:"commDec"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialogValideBesoin = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.verifBtnConfirme,"color":"green darken-1","flat":""},on:{"click":function($event){return _vm.validRejetBesoin(1)}}},[_vm._v("Confirmer")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.verifBtnRefus,"color":"red darken-1","flat":""},on:{"click":function($event){return _vm.validRejetBesoin(0)}}},[_vm._v("Rejeter")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WpKY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_board_resource_vue__ = __webpack_require__("rg0G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68c3fbe8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_board_resource_vue__ = __webpack_require__("boY9");
function injectStyle (ssrContext) {
  __webpack_require__("SgBp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_board_resource_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68c3fbe8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_board_resource_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WvDW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WyDN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","scrollable":"","loading":_vm.loading,"fullscreen":"","hide-overlay":""},model:{value:(_vm.dialogDetail),callback:function ($$v) {_vm.dialogDetail=$$v},expression:"dialogDetail"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Fiche de Validation de la commande "+_vm._s(_vm.detailCommande.ref)+_vm._s(_vm.detailCommande.libele))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',[_c('v-flex',[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Informations générales\n                                            ")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Projet")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailCommande.projet)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailCommande.chantier)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Travaux")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailCommande.travaux)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Tâche")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailCommande.tache)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Fournisseur")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailCommande.fournisseurNom)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date commande")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailCommande.dateC)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de la livraison")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailCommande.dateLivr)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Ressources\n                                            ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (TTC): "+_vm._s(new Intl.NumberFormat().format(_vm.detailCommande.totalN)))])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailCommande.option,"height":"250"}},[_c('el-table-column',{attrs:{"prop":"codeAnalytique","label":"Code analytique","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"produit","label":"Ressource","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix unitaire (FCFA)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Total TTC (FCFA)"}})],1)]],2),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5",staticStyle:{"margin-right":"100px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"red"},on:{"click":function($event){_vm.dialogConfirmRefus = true}},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Rejeter la commande")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"green"},on:{"click":function($event){_vm.dialogConfirm = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v("Valider la commande")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirmRefus),callback:function ($$v) {_vm.dialogConfirmRefus=$$v},expression:"dialogConfirmRefus"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation de la commande")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous Refuser ce devis ?","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("COMMANDE REFERENCE")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v(_vm._s(_vm.detailCommande.ref))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{ref:"refFormRefust",staticClass:"demo-form-inline",attrs:{"id":"formRefus","rules":_vm.ruleFormRefus,"label-position":"top","inline":true,"model":_vm.formRefus}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Commentaire","prop":"rapportRefus"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Pourquoi voulez-vous refuser ?"},model:{value:(_vm.formRefus.rapport),callback:function ($$v) {_vm.$set(_vm.formRefus, "rapport", $$v)},expression:"formRefus.rapport"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirmRefus = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideDevis('rejeter')}}},[_vm._v("Refuser")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation d'une commande")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous valider le devis ?","closable":false,"show-icon":"","type":"success"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("COMMANDE REFERENCE")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v(_vm._s(_vm.detailCommande.ref))])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirm = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideDevis('confirme')}}},[_vm._v("Confirmer")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X67K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FicheVehicule_vue__ = __webpack_require__("nxC/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35c5a55a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FicheVehicule_vue__ = __webpack_require__("OPWJ");
function injectStyle (ssrContext) {
  __webpack_require__("74Hy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35c5a55a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FicheVehicule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35c5a55a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FicheVehicule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XL6v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
    name: "ConstatMaintenance",
    props: {
        show: {
            type: Boolean
        },
        demandeDetail: {
            type: Object
        },
        validConstat: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            listeProduit: [],
            formRapport: {
                rapport: ""
            },
            formRefus: {},

            rapport: "",
            dialogConstat: false,
            dialogConfirm: false,
            dialogConfirmRefus: false,
            tableProduit: [],
            totalTTC: 0,
            fileList: [],
            dialogImageUrl: '',
            formProduit: {},
            dialogVisible: false,
            //image
            image1: "/static/img-doc.png",
            image2: "/static/img-doc.png",
            image3: "/static/img-doc.png",
            image4: "/static/img-doc.png",
            file1: "",
            file2: "",
            file3: "",
            ruleFormProduit: {
                idProd: [{ required: true, message: 'Veuillez saisir' }],
                quantite: [{ required: true, message: 'Veuillez saisir' }]
            },
            ruleFormRefus: {
                rapportRefus: [{ required: true, message: 'Veuillez saisir' }]
            }
        };
    },


    computed: {},
    watch: {
        show: function show(newValue, oldvalue) {
            this.dialogConstat = newValue;
        },
        validConstat: function validConstat(newValue, oldvalue) {
            if (newValue == true) {
                //charger les donnees 
                this.formProduit = {};
                this.loadDevisConstat();
                this.loadProduit();
            }
        }
    },

    methods: {
        onFileImage1Picked: function onFileImage1Picked(event) {
            var _this = this;

            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this.image1 = fileReader.result;
            });

            fileReader.readAsDataURL(files[0]);
            this.file1 = files[0];
        },

        //enregistrement des images
        onFileImage2Picked: function onFileImage2Picked(event) {
            var _this2 = this;

            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this2.image2 = fileReader.result;
            });

            fileReader.readAsDataURL(files[0]);
            this.file2 = files[0];
        },


        //enregistrement des images
        onFileImage3Picked: function onFileImage3Picked(event) {
            var _this3 = this;

            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this3.image3 = fileReader.result;
            });

            fileReader.readAsDataURL(files[0]);
            this.file3 = files[0];
        },
        handleRemove: function handleRemove(file, fileList) {},
        handleSuccess: function handleSuccess(response, file, fileList) {
            this.fileList.push(file);
        },
        handlePictureCardPreview: function handlePictureCardPreview(file, fileList) {
            this.dialogImageUrl = file.url;

            this.dialogVisible = true;
        },
        closeDialog: function closeDialog() {

            this.$emit('close');
        },
        addListProduit: function addListProduit(formName, item) {
            var _this4 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this4.tableProduit.push({
                        designation: item.designation,
                        quantite: item.quantite,
                        unite: item.unite,
                        prixU: item.prixUnit,
                        mntTotal: parseInt(item.quantite) * parseInt(item.prixUnit)
                    });
                    _this4.totalTTC += parseInt(item.quantite) * parseInt(item.prixUnit);
                    // reinitilisation des champs
                    _this4.formProduit.prixUnit = 5;
                    _this4.formProduit.unite = "";
                    _this4.resetForm(formName);
                }
            });
        },
        deleteRow: function deleteRow(index, rows) {
            var item = rows.splice(index, 1);

            this.totalTTC -= parseInt(item[0].mntTotal);
        },
        submitForm: function submitForm() {
            var _this5 = this;

            this.loading = true;
            var url = this.domaine + 'demande_maintenance/save/constat';
            var form = document.getElementById('formRapport1');
            var data = new FormData(form);
            data.append("tableProduit", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableProduit));
            data.append("rapport", this.formRapport.rapport);
            data.append("idUser", this.user.id);
            data.append("idDemande", this.demandeDetail.idDemande);
            //data.append("file",this.fileList,Blob)
            this.$http.post(url, data).then(function (response) {
                _this5.resetChampsConstat();
                //reinitialisation des images telecharger
                _this5.image1 = "/static/img-doc.png";
                _this5.image2 = "/static/img-doc.png";
                _this5.image3 = "/static/img-doc.png";
                _this5.image = "/static/img-doc.png";
                _this5.file1 = "";
                _this5.file2 = "";
                _this5.file3 = "";
                _this5.closeDialog();
                _this5.loading = false;
                if (response.body.code == 5) {
                    _this5.successNotif(response.body.message, "error");
                } else {
                    _this5.successNotif(response.body.message);
                }
            }, function (erreurRep) {
                _this5.$message.error("Une erreur est survenue lors de l'enregistrement du constat");
            });
        },
        loadProduit: function loadProduit() {
            var _this6 = this;

            var url = this.domaine + 'product/load-product-stock';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this6.listeProduit = response.body;
                }
            });
        },
        loadDevisConstat: function loadDevisConstat() {
            var _this7 = this;

            this.loading = true;
            var url = this.domaine + 'demande_maintenance/devis/constat/' + this.demandeDetail.idDemande;
            this.$http.get(url).then(function (response) {
                _this7.tableProduit = response.body.tableProduit;
                _this7.formRapport.rapport = response.body.rapport;
                _this7.totalTTC = response.body.total;
                _this7.loading = false;
            }, function (errResp) {
                _this7.loading = false;
                _this7.$message.error("Une erreur est survenue lors du chargement de la table des produits");
            });
        },
        handleChangePrix: function handleChangePrix() {
            var _this8 = this;

            this.loading = true;
            var url = this.domaine + 'demande_maintenance/recherche/produit/' + this.formProduit.idProd;
            this.$http.get(url).then(function (response) {
                _this8.loading = false;

                var produit = response.body.produit;

                _this8.formProduit.prixUnit = produit.valeur;
                _this8.formProduit.unite = produit.unite;
                _this8.formProduit.designation = produit.designation;

                // if(produit.valeur <= 0) {
                //     this.$message({
                //     message: 'Les prix de vente produits doivent être supérieur à zéro pour établir un devis correcte',
                //     type: 'warning',
                //     duration: 10000
                // });
                // }

                if (_this8.formProduit.unite == null) {
                    _this8.formProduit.unite = "pcs";
                }
            }, function (errReponse) {
                _this8.loading = false;
                _this8.$message.error("Une erreur est survenue lors du produit");
            });
        },
        resetForm: function resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Constat enregistrée avec succès";
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";

            this.$notify({
                title: 'ENREGISTREMENT CONSTAT',
                message: mess,
                type: type,
                position: 'top-center',
                duration: 15000
            });
        },
        resetChampsConstat: function resetChampsConstat() {
            this.tableProduit.splice(0);
            this.totalTTC = 0;
            this.formRapport.rapport = "";
        },
        SubmitValideDevis: function SubmitValideDevis() {
            var _this9 = this;

            this.loading = true;
            var url = "";
            if (this.demandeDetail.etatDmd == 4) {
                url = this.domaine + 'demande_maintenance/devis/validation2';
            } else {
                url = this.domaine + 'demande_maintenance/devis/validation1';
            }

            var data = new FormData();
            data.append("idDemande", this.demandeDetail.idDemande);
            data.append("idUser", this.user.id);
            this.$http.post(url, data).then(function (response) {
                _this9.loading = false;
                if (response.body.code == 5) {
                    _this9.successNotif(response.body.message, "error");
                } else {
                    _this9.successNotif(response.body.message);
                }
                _this9.dialogConfirm = false;
                _this9.closeDialog();
            }, function (errResp) {
                _this9.loading = false;
                _this9.$message.error("Une erreur est survenue lors de la validation du devis");
            });
        },
        SubmitRefusDevis: function SubmitRefusDevis() {
            var _this10 = this;

            //this.loading = true
            var url = this.domaine + 'demande_maintenance/devis/refuser';
            var data = new FormData();
            data.append("idDemande", this.demandeDetail.idDemande);
            data.append("idUser", this.user.id);
            data.append("rapport", this.formRefus.rapport);

            this.$http.post(url, data).then(function (response) {
                _this10.loading = false;
                if (response.body.code == 5) {
                    _this10.successNotif(response.body.message, "error");
                } else {
                    _this10.successNotif(response.body.message);
                }
                _this10.dialogConfirmRefus = false;
                _this10.closeDialog();
            }, function (errResp) {
                _this10.loading = false;
                _this10.$message.error("Une erreur est survenue lors du refus du devis");
            });
        }
    },

    mounted: function mounted() {
        this.loadProduit();
    }
});

/***/ }),

/***/ "XeBl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":">"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.droitAcces.client_index || _vm.droitAcces.client_projet_index)?_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticStyle:{"width":"450px","height":"300px"},attrs:{"id":"chartClientAll"}})]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticStyle:{"width":"450px","height":"300px"},attrs:{"id":"chartFactureAllClient"}})])],1)],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[(_vm.droitAcces.client_projet_new)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newClient()}},slot:"activator"},[_vm._v("\n        Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n      Ajouter un nouveau client\n    ")],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjout),callback:function ($$v) {_vm.dialogAjout=$$v},expression:"dialogAjout"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"flex":"0 0 auto"},attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[(_vm.dialogEdit == false)?_c('span',[_vm._v("Ajouter un nouveau client")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit != false)?_c('span',[_vm._v("Modification du client "+_vm._s(_vm.client.libelle)+" ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjout = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formClient",attrs:{"lazy-validation":"","id":"formClient"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de client *")]),_vm._v(" "),(!_vm.dialogEdit)?_c('el-select',{staticStyle:{"width":"100%"},on:{"change":function($event){return _vm.changeType()}},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}},_vm._l((_vm.typeRow),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.dialogEdit && _vm.form.type === 1)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":'PERSONNE PHYSIQUE'}}):_vm._e(),_vm._v(" "),(_vm.dialogEdit && _vm.form.type === 2)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":'PERSONNE MORALE'}}):_vm._e()],1)])],1),_vm._v(" "),(_vm.form.type === 1)?_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                PERSONNE PHYSIQUE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("user-list")])],1)],1):_vm._e(),_vm._v(" "),(_vm.form.type === 1)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Civilité *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.form.civilite),callback:function ($$v) {_vm.$set(_vm.form, "civilite", $$v)},expression:"form.civilite"}},_vm._l((_vm.civiliteRow),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nom *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Nom"},model:{value:(_vm.form.libelle),callback:function ($$v) {_vm.$set(_vm.form, "libelle", $$v)},expression:"form.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tèl *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"contact","placeholder":"Tèl"},model:{value:(_vm.form.contact),callback:function ($$v) {_vm.$set(_vm.form, "contact", $$v)},expression:"form.contact"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Fixe")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"fixe","placeholder":"Fixe"},model:{value:(_vm.form.fixe),callback:function ($$v) {_vm.$set(_vm.form, "fixe", $$v)},expression:"form.fixe"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.form.type === 1)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Adresse postale")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"adresse","placeholder":"Adresse postale"},model:{value:(_vm.form.adresse),callback:function ($$v) {_vm.$set(_vm.form, "adresse", $$v)},expression:"form.adresse"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Genre *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.form.genre),callback:function ($$v) {_vm.$set(_vm.form, "genre", $$v)},expression:"form.genre"}},_vm._l((_vm.genreRow),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])],1):_vm._e(),_vm._v(" "),(_vm.form.type === 2)?_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"info"}},[_vm._v("\n                PERSONNE MORALE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("user-list")])],1)],1):_vm._e(),_vm._v(" "),(_vm.form.type === 2)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Raison sociale *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Raison sociale"},model:{value:(_vm.form.libelle),callback:function ($$v) {_vm.$set(_vm.form, "libelle", $$v)},expression:"form.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Fixe *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"fixe","placeholder":"Fixe"},model:{value:(_vm.form.fixe),callback:function ($$v) {_vm.$set(_vm.form, "fixe", $$v)},expression:"form.fixe"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Adresse postale")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"adresse","placeholder":"Adresse postale"},model:{value:(_vm.form.adresse),callback:function ($$v) {_vm.$set(_vm.form, "adresse", $$v)},expression:"form.adresse"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Siège *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"localisation","placeholder":"Siège"},model:{value:(_vm.form.localisation),callback:function ($$v) {_vm.$set(_vm.form, "localisation", $$v)},expression:"form.localisation"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.form.type === 2)?_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"info"}},[_vm._v("\n                Détails sur le gérant "),_c('v-icon',{attrs:{"right":""}},[_vm._v("user-list")])],1)],1):_vm._e(),_vm._v(" "),(_vm.form.type === 2)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Civilité *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.form.civilite),callback:function ($$v) {_vm.$set(_vm.form, "civilite", $$v)},expression:"form.civilite"}},_vm._l((_vm.civiliteRow),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nom et prénoms *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"gerant","placeholder":"Nom et prénoms"},model:{value:(_vm.form.gerant),callback:function ($$v) {_vm.$set(_vm.form, "gerant", $$v)},expression:"form.gerant"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Genre *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.form.genre),callback:function ($$v) {_vm.$set(_vm.form, "genre", $$v)},expression:"form.genre"}},_vm._l((_vm.genreRow),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Contact *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"contact","placeholder":"Contact"},model:{value:(_vm.form.contact),callback:function ($$v) {_vm.$set(_vm.form, "contact", $$v)},expression:"form.contact"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.form.type === 2)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de naissance")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateN","id":"dateN","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de naissance"},model:{value:(_vm.form.dateN),callback:function ($$v) {_vm.$set(_vm.form, "dateN", $$v)},expression:"form.dateN"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Lieu de naissance")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"lieuN","placeholder":"Lieu de naissance"},model:{value:(_vm.form.lieuN),callback:function ($$v) {_vm.$set(_vm.form, "lieuN", $$v)},expression:"form.lieuN"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Situation matrimoniale")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.form.situation),callback:function ($$v) {_vm.$set(_vm.form, "situation", $$v)},expression:"form.situation"}},_vm._l((_vm.situationRow),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),(!_vm.dialogEdit)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.submit()}}},[_vm._v("\n                Enregistrer"),_c('v-icon',{attrs:{"left":""}},[_vm._v("save")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.submit()}}},[_vm._v("\n                Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogFactureAjout),callback:function ($$v) {_vm.dialogFactureAjout=$$v},expression:"dialogFactureAjout"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"flex":"0 0 auto"},attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[(!_vm.dialogEdit)?_c('span',[_vm._v("Ajouter une nouvelle facture")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification la facture "+_vm._s(_vm.facture.ref)+" ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogFactureAjout = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formFacture",attrs:{"lazy-validation":"","id":"formFacture"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n              INFORMATION CONCERNANT LE PROJET\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné *")]),_vm._v(" "),(!_vm.dialogEdit)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":""},on:{"change":function($event){return _vm.changeProjet()}},model:{value:(_vm.formFacture.projet),callback:function ($$v) {_vm.$set(_vm.formFacture, "projet", $$v)},expression:"formFacture.projet"}},_vm._l((_vm.listProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":_vm.projet.libelle}}):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chef de projet")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":_vm.projet.chef}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix du marché")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":_vm.projet.montantEstimatif}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de facture")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":_vm.projet.libelleEtatAvance}})],1)])],1),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n              DETAILS CONCERNANT LA FACTURE\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Facture ?")]),_vm._v(" "),(!_vm.dialogEdit)?_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.formFacture.avance),callback:function ($$v) {_vm.$set(_vm.formFacture, "avance", $$v)},expression:"formFacture.avance"}},_vm._l((_vm.avanceRow),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":_vm.projet.libelle}}):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date émission *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"date","id":"date","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date facture"},on:{"change":function($event){return _vm.valideF()}},model:{value:(_vm.formFacture.date),callback:function ($$v) {_vm.$set(_vm.formFacture, "date", $$v)},expression:"formFacture.date"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de paiment")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"datePaie","id":"datePaie","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de paiment"},on:{"change":function($event){return _vm.valideF()}},model:{value:(_vm.formFacture.datePaie),callback:function ($$v) {_vm.$set(_vm.formFacture, "datePaie", $$v)},expression:"formFacture.datePaie"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Trésorerie")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},on:{"change":function($event){return _vm.valideF()}},model:{value:(_vm.formFacture.caisse),callback:function ($$v) {_vm.$set(_vm.formFacture, "caisse", $$v)},expression:"formFacture.caisse"}},_vm._l((_vm.listCaisse),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[(_vm.projet.etatAvance && _vm.formFacture.projet)?_c('span',{staticClass:"demonstration"},[_vm._v("Montant avance *")]):_vm._e(),_vm._v(" "),(!_vm.projet.etatAvance)?_c('span',{staticClass:"demonstration"},[_vm._v("Montant *")]):_vm._e(),_vm._v(" "),(_vm.projet.etatAvance && _vm.formFacture.projet)?_c('el-input',{staticStyle:{"width":"100%","font-size":"2rem","font-weight":"bold"},attrs:{"name":"montantAvance","type":"number","min":0,"placeholder":"Montant avance"},on:{"change":function($event){return _vm.valideF()}},model:{value:(_vm.formFacture.montantAvance),callback:function ($$v) {_vm.$set(_vm.formFacture, "montantAvance", $$v)},expression:"formFacture.montantAvance"}}):_vm._e(),_vm._v(" "),(!_vm.projet.etatAvance)?_c('el-input',{staticStyle:{"width":"100%","font-size":"2rem","font-weight":"bold"},attrs:{"placeholder":"Montant","readonly":true},on:{"change":function($event){return _vm.valideF()}},model:{value:(_vm.formFacture.montantF),callback:function ($$v) {_vm.$set(_vm.formFacture, "montantF", $$v)},expression:"formFacture.montantF"}}):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tva")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":1,"value":"tva","placeholder":"Tva","readonly":false},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.formFacture.tva),callback:function ($$v) {_vm.$set(_vm.formFacture, "tva", $$v)},expression:"formFacture.tva"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Total ttc (FCFA)")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%","font-size":"2rem","font-weight":"bold"},attrs:{"type":"number","readonly":true,"min":0,"value":this.TotalTtc,"placeholder":this.TotalTtc},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.formFacture.TotalTtc),callback:function ($$v) {_vm.$set(_vm.formFacture, "TotalTtc", $$v)},expression:"formFacture.TotalTtc"}})],1)])],1),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n              TRANSMISSION\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Observation ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"description","type":"textarea","rows":3,"placeholder":"Observation"},model:{value:(_vm.formFacture.description),callback:function ($$v) {_vm.$set(_vm.formFacture, "description", $$v)},expression:"formFacture.description"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Transmettre ")]),_vm._v(" "),(!_vm.dialogEdit)?_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.formFacture.etat),callback:function ($$v) {_vm.$set(_vm.formFacture, "etat", $$v)},expression:"formFacture.etat"}},_vm._l((_vm.transRow),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.dialogEdit && _vm.facture.etat === 0)?_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.formFacture.etat),callback:function ($$v) {_vm.$set(_vm.formFacture, "etat", $$v)},expression:"formFacture.etat"}},_vm._l((_vm.transRow),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mode de transmission ")]),_vm._v(" "),(!_vm.dialogEdit)?_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.formFacture.modeTrans),callback:function ($$v) {_vm.$set(_vm.formFacture, "modeTrans", $$v)},expression:"formFacture.modeTrans"}},_vm._l((_vm.ModTransmition),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e()],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"drag":"","action":"","on-preview":_vm.handlePreview,"on-remove":_vm.handleRemove,"name":"docsFac[]","file-list":_vm.formFacture.fileList,"auto-upload":false,"multiple":""}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("\n                      Déposer les fichiers ici ou "),_c('em',[_vm._v("cliquez pour envoyer")])]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n                      Fichiers jpg/png avec une taille inférieure à 500kb\n                    ")])])],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),(!_vm.dialogEdit && _vm.valid)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.submitFacture()}}},[_vm._v("\n                Ajouter"),_c('v-icon',{attrs:{"left":""}},[_vm._v("add")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit && _vm.valid)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.submitFacture()}}},[_vm._v("\n                Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogVaildeFAjout),callback:function ($$v) {_vm.dialogVaildeFAjout=$$v},expression:"dialogVaildeFAjout"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"flex":"0 0 auto"},attrs:{"dark":"","color":"green"}},[_c('v-toolbar-title',[_c('span',[_vm._v("Valider la facture "+_vm._s(_vm.facture.ref)+" ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogVaildeFAjout = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formValideF",attrs:{"lazy-validation":"","id":"formValideF"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-stepper',{model:{value:(_vm.etape),callback:function ($$v) {_vm.etape=$$v},expression:"etape"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.etape > 1}},[_vm._v("Validation")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.etape > 2}},[_vm._v("Documents")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                    DETAILS CONCERNANT LA FACTURE\n                  ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":_vm.facture.projet}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":_vm.facture.montantF}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de facture")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":_vm.facture.type}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":_vm.facture.dateFo}})],1)])],1),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                    VALIDATION\n                  ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Bureau de contrôle *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.formValideF.controle),callback:function ($$v) {_vm.$set(_vm.formValideF, "controle", $$v)},expression:"formValideF.controle"}},_vm._l((_vm.valideRow),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Maitre d'ouvrage délegué *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.formValideF.delegue),callback:function ($$v) {_vm.$set(_vm.formValideF, "delegue", $$v)},expression:"formValideF.delegue"}},_vm._l((_vm.valideRow),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_vm._v("C\n                        "),_c('span',{staticClass:"demonstration"},[_vm._v("Maitre d'ouvrage  *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.formValideF.coordination),callback:function ($$v) {_vm.$set(_vm.formValideF, "coordination", $$v)},expression:"formValideF.coordination"}},_vm._l((_vm.valideRow),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',[_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogVaildeFAjout = false}}},[_vm._v("\n                      Annuler\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.formValideF.coordination === 0 || _vm.formValideF.delegue === 0 ||
                     _vm.formValideF.controle === 0,"icons":"","color":"primary"},on:{"click":function($event){_vm.etape = 2;}}},[_vm._v("\n                      Suivant "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"drag":"","action":"","on-preview":_vm.handlePreview,"on-remove":_vm.handleRemove,"name":"docs[]","file-list":_vm.formValideF.fileList,"auto-upload":false,"multiple":""}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("\n                            Déposer les fichiers ici ou "),_c('em',[_vm._v("cliquez pour envoyer")])]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n                            Fichiers jpg/png avec une taille inférieure à 500kb\n                          ")])])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Observation ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","placeholder":"Observation","rows":5,"name":"description"},model:{value:(_vm.formValideF.description),callback:function ($$v) {_vm.$set(_vm.formValideF, "description", $$v)},expression:"formValideF.description"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary"},on:{"click":function($event){_vm.etape = 1;}}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_left")]),_vm._v(" Précédent\n                    ")],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary"},on:{"click":function($event){return _vm.submitValideF()}}},[_vm._v("\n                      Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogValidePAjout),callback:function ($$v) {_vm.dialogValidePAjout=$$v},expression:"dialogValidePAjout"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"flex":"0 0 auto"},attrs:{"dark":"","color":"lime"}},[_c('v-toolbar-title',[_c('span',[_vm._v("Processus de validation de la facture "+_vm._s(_vm.facture.ref))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogValidePAjout = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formProcessus",attrs:{"lazy-validation":"","id":"formProcessus"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[(!_vm.facture.etatPross)?_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n              VEUILLEZ TERMINER LE PRECEDENT PROCESSUS DE ENTAMME.\n            ")]):_vm._e(),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"lime"}},[_vm._v("\n              DETAILS CONCERNANT LA FACTURE\n            ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":_vm.facture.projet}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":_vm.facture.montantF}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de facture")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":_vm.facture.type}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":_vm.facture.dateFo}})],1)])],1),_vm._v(" "),(_vm.facture.etatPross || _vm.dialogEdit)?_c('div',[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"lime"}},[_vm._v("\n                DETAILS CONCERNANT LA FACTURE\n              ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Entité concerné *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"entite"},model:{value:(_vm.formProcess.entite),callback:function ($$v) {_vm.$set(_vm.formProcess, "entite", $$v)},expression:"formProcess.entite"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mode de transmision *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.formProcess.mode),callback:function ($$v) {_vm.$set(_vm.formProcess, "mode", $$v)},expression:"formProcess.mode"}},_vm._l((_vm.modeRow),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de transmission *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"date","id":"date","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date"},model:{value:(_vm.formProcess.date),callback:function ($$v) {_vm.$set(_vm.formProcess, "date", $$v)},expression:"formProcess.date"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Etat")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.formProcess.etat),callback:function ($$v) {_vm.$set(_vm.formProcess, "etat", $$v)},expression:"formProcess.etat"}},_vm._l((_vm.etatRow),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Accusé de réception *")]),_vm._v(" "),_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"drag":"","action":"","on-preview":_vm.handlePreview,"on-remove":_vm.handleRemove,"name":"docsOptFac[]","file-list":_vm.formProcess.fileList,"auto-upload":false,"multiple":""}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("\n                        Déposer les fichiers ici ou "),_c('em',[_vm._v("cliquez pour envoyer")])]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n                        Fichiers jpg/png avec une taille inférieure à 500kb\n                      ")])])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"description"},model:{value:(_vm.formProcess.description),callback:function ($$v) {_vm.$set(_vm.formProcess, "description", $$v)},expression:"formProcess.description"}})],1)])],1),_vm._v(" "),_c('br')],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),(_vm.dialogEdit)?_c('v-btn',{attrs:{"text-color":"white","label":"","color":"orange","dark":""},nativeOn:{"click":function($event){return _vm.annulerPross()}}},[_vm._v("\n                Annuler "),_c('v-icon',{attrs:{"left":""}},[_vm._v("close")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.submitProcess()}}},[_vm._v("\n                Modifier "),_c('v-icon',{attrs:{"left":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(!_vm.dialogEdit && _vm.facture.etatPross)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.submitProcess()}}},[_vm._v("\n                Ajouter "),_c('v-icon',{attrs:{"left":""}},[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"lime"}},[_vm._v("\n              PROCESSUS\n            ")]),_vm._v(" "),_c('v-card-text',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listOptions}},[_c('el-table-column',{attrs:{"label":"","type":"expand","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_vm._v("Description : "+_vm._s(scope.row.description))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Enrégistré par : ")]),_vm._v(" "+_vm._s(scope.row.userCreate)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Modifié par : ")]),_vm._v(" "+_vm._s(scope.row.userUpdate)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enrégistrement : ")]),_vm._v(" "+_vm._s(scope.row.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(scope.row.modified)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('el-row',{attrs:{"gutter":20}},_vm._l((scope.row.files),function(fit){return _c('el-col',{key:fit.id,attrs:{"span":6}},[_c('a',{attrs:{"href":fit.url,"target":"_blank"}},[_vm._v(_vm._s(fit.img))]),_vm._v(" "),_c('img',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":fit.url}})])}),1)],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"entite","label":"Entité","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      "+_vm._s(scope.row.entite)+"\n                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Date"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      "+_vm._s(scope.row.dateF)+"\n                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mode","label":"Mode"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"teal"}},[_vm._v("\n                      "+_vm._s(scope.row.mode)+"\n                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!scope.row.etat)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"blue"}},[_vm._v("\n                      EN COURS DE TRAITEMENT\n                    ")]):_vm._e(),_vm._v(" "),(scope.row.etat)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                      TERMINE\n                    ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(!scope.row.etat)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){$event.stopPropagation();return _vm.editProcess(scope.row);}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                        Modifier\n                      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(!scope.row.etat)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogValidePSupr = true;
                         _vm.idOpFac = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                        Supprimer\n                      ")],1)],1)]}}])})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),(_vm.facture.etatPross)?_c('v-btn',{attrs:{"color":"lime","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.sumbitClose();}}},[_vm._v("\n                Terminer et clore "),_c('v-icon',{attrs:{"left":""}},[_vm._v("close")])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShow),callback:function ($$v) {_vm.dialogShow=$$v},expression:"dialogShow"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du client "+_vm._s(_vm.client.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShow = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-tabs',{attrs:{"type":"border-card"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('el-tab-pane',{attrs:{"name":"fiche"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("ic_person")]),_vm._v(" Fiche")],1),_vm._v(" "),_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Réference : ")]),_vm._v(" "+_vm._s(_vm.client.ref)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Nom et prénoms / Raison sociale : ")]),_vm._v(" "+_vm._s(_vm.client.libelle)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Type de client : ")]),_vm._v(" "),(_vm.client.type == 1)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                              PERSONNE PARTICULIER\n                            ")]):_vm._e(),_vm._v(" "),(_vm.client.type == 2)?_c('v-chip',{attrs:{"outline":"","text-color":"indigo","label":"","color":"indigo"}},[_vm._v("\n                              PERSONNE ENTREPRISE\n                            ")]):_vm._e()],1),_vm._v(" "),(_vm.client.type == 1)?_c('p',[_c('b',[_vm._v("Tèl : ")]),_vm._v(" "+_vm._s(_vm.client.contact)+" ")]):_vm._e(),_vm._v(" "),(_vm.client.type == 1)?_c('p',[_c('b',[_vm._v("Fixe : ")]),_vm._v(" "+_vm._s(_vm.client.fixe)+" ")]):_vm._e(),_vm._v(" "),(_vm.client.type == 2)?_c('p',[_c('b',[_vm._v("Fixe du gérant : ")]),_vm._v(" "+_vm._s(_vm.client.fixe)+" ")]):_vm._e(),_vm._v(" "),(_vm.client.type == 2)?_c('p',[_c('b',[_vm._v("Contact du gérant : ")]),_vm._v(" "+_vm._s(_vm.client.contact)+" ")]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[(_vm.client.type == 2)?_c('p',[_c('b',[_vm._v("Nom et prénoms du gérant : ")]),_vm._v(" "+_vm._s(_vm.client.gerant)+" ")]):_vm._e(),_vm._v(" "),(_vm.client.type == 2)?_c('p',[_c('b',[_vm._v("Siège : ")]),_vm._v(" "+_vm._s(_vm.client.localisation)+" ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Adresse postale : ")]),_vm._v(" "+_vm._s(_vm.client.adresse))]),_vm._v(" "),(_vm.client.type == 1)?_c('p',[_c('b',[_vm._v("Genre : ")]),_vm._v(" "+_vm._s(_vm.client.genre))]):_vm._e(),_vm._v(" "),(_vm.client.type == 2)?_c('p',[_c('b',[_vm._v("Genre du gérant : ")]),_vm._v(" "+_vm._s(_vm.client.genre))]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[(_vm.client.type == 2)?_c('p',[_c('b',[_vm._v("Date de naissance : ")]),_vm._v(" "+_vm._s(_vm.client.dateN)+" ")]):_vm._e(),_vm._v(" "),(_vm.client.type == 2)?_c('p',[_c('b',[_vm._v("Situation matrimoniale du gérant : ")]),_vm._v(" "+_vm._s(_vm.client.situation)+" ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enrégistrement : ")]),_vm._v(" "+_vm._s(_vm.client.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.client.modified)+" ")])])],1)],1)])]),_vm._v(" "),_c('el-tab-pane',{attrs:{"name":"facture"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("description")]),_vm._v(" Factures")],1),_vm._v(" "),_c('div',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      LISTE DES FACTURES "),_c('v-icon',{attrs:{"right":""}},[_vm._v("description")])],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticStyle:{"width":"450px","height":"300px"},attrs:{"id":"chartForOneClient"}})]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticStyle:{"width":"450px","height":"300px"},attrs:{"id":"chartFactureForOneClient"}})])],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newFacture([])}},slot:"activator"},[_vm._v("\n                          Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n                        Ajouter une nouvelle facture\n                      ")],1)],1),_vm._v(" "),_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-form',{ref:"formSearchProjet",attrs:{"lazy-validation":"","id":"formSearchProjet"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Type de recherche"},model:{value:(_vm.selectSearchProjet),callback:function ($$v) {_vm.selectSearchProjet=$$v},expression:"selectSearchProjet"}},_vm._l((_vm.listProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-btn',{attrs:{"icons":"","color":"blue","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.loadProjetFacture(_vm.selectSearchProjet)}}},[_c('v-icon',[_vm._v("search")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listProjetDetails}},[_c('el-table-column',{attrs:{"label":"","width":"40","fixed":"left","type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":scope.row.options}},[_c('el-table-column',{attrs:{"label":"","type":"expand","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_vm._v("Description : "+_vm._s(scope.row.description))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Enrégistré par : ")]),_vm._v(" "+_vm._s(scope.row.userCreate)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Modifié par : ")]),_vm._v(" "+_vm._s(scope.row.userUpdate)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enrégistrement : ")]),_vm._v(" "+_vm._s(scope.row.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(scope.row.modified)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('el-row',{attrs:{"gutter":20}},_vm._l((scope.row.files),function(fit){return _c('el-col',{key:fit.id,attrs:{"span":6}},[_c('a',{attrs:{"href":fit.url,"target":"_blank"}},[_vm._v(_vm._s(fit.img))]),_vm._v(" "),_c('img',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":fit.url}})])}),1)],1)],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"entite","label":"Entité","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                    "+_vm._s(scope.row.entite)+"\n                                  ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Date"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                    "+_vm._s(scope.row.dateF)+"\n                                  ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mode","label":"Mode"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"teal"}},[_vm._v("\n                                    "+_vm._s(scope.row.mode)+"\n                                  ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!scope.row.etat)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"blue"}},[_vm._v("\n                                    EN COURS DE TRAITEMENT\n                                  ")]):_vm._e(),_vm._v(" "),(scope.row.etat)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                    TERMINE\n                                  ")]):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(!scope.row.etat)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogValidePSupr = true;
                                      _vm.idOpFac = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                                      Supprimer\n                                    ")],1)],1)]}}],null,true)})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref","label":"Réf","width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.ref)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projet","label":"Projet concerné"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.projet)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"avance","label":"Type de facture"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.avance)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"blue"}},[_vm._v("\n                              FACTURE AVANCE\n                            ")]):_vm._e(),_vm._v(" "),(!scope.row.avance)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"indigo"}},[_vm._v("\n                              FACTURE\n                            ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantF","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                              "+_vm._s(scope.row.montantF)+" FCFA\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"Tva"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                              "+_vm._s(scope.row.tva)+" %\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalTtc","label":"Montant ttc"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                              "+_vm._s(scope.row.totalTtc)+" FCFA\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat === 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"blue"}},[_vm._v("\n                              "+_vm._s(scope.row.etatlibelle)+"\n                            ")]):_vm._e(),_vm._v(" "),(scope.row.etat === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                              "+_vm._s(scope.row.etatlibelle)+"\n                            ")]):_vm._e(),_vm._v(" "),(scope.row.etat === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"cyan"}},[_vm._v("\n                              "+_vm._s(scope.row.etatlibelle)+"\n                            ")]):_vm._e(),_vm._v(" "),(scope.row.etat === 3)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                              "+_vm._s(scope.row.etatlibelle)+"\n                            ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showFacture(scope.row);}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                Détails\n                              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat === 0)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){$event.stopPropagation();return _vm.newFacture(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                                Modifier\n                              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat === 1)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"lime"},on:{"click":function($event){$event.stopPropagation();_vm.newProcess(scope.row); _vm.loadOption(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("timeline")])],1):_vm._e(),_vm._v("\n                                Processus de validation\n                              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat === 2)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.valideFacture(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("done_all")])],1):_vm._e(),_vm._v("\n                                Valider\n                              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.delete)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogFactureSupr = true; _vm.idFacture = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                                Supprimer\n                              ")],1)],1)]}}])})],1)],1)],1)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"name":"projet"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("terrain")]),_vm._v(" Projets")],1),_vm._v(" "),_c('div',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      LISTE DES PROJETS "),_c('v-icon',{attrs:{"right":""}},[_vm._v("terrain")])],1),_vm._v(" "),_c('v-card-text',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listProjet}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","width":"370","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.adresse)+"\n                              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("location_on")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type de projet"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.type)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                              "+_vm._s(scope.row.type)+"\n                              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("business")])],1):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chef","label":"Chef de projet"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"indigo","label":"","color":"indigo"}},[_vm._v("\n                              "+_vm._s(scope.row.chef)+"\n                              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("person")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"evolution","label":"Evolution"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-progress-circular',{attrs:{"size":85,"width":15,"rotate":360,"value":scope.row.evolution,"color":"primary"}},[_vm._v(_vm._s(scope.row.evolutionNbr)+" %")])]}}])})],1)],1)],1)])],1)],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShow = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n          Fermer\n        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.edit(_vm.client);}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1),_vm._v("\n          Modifier\n        ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogFactureShow),callback:function ($$v) {_vm.dialogFactureShow=$$v},expression:"dialogFactureShow"}},[_c('v-card',[_c('v-toolbar',{staticStyle:{"flex":"0 0 auto"},attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_c('span',[_vm._v("Fiche de la facture "+_vm._s(_vm.facture.ref)+" ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogFactureShow = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-row',{staticStyle:{"padding":"3px"},attrs:{"gutter":20}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Référence : ")]),_vm._v(" "+_vm._s(_vm.facture.ref)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Projet concerné : ")]),_vm._v(" "+_vm._s(_vm.facture.projet)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de la facture : ")]),_vm._v(" "+_vm._s(_vm.facture.dateFo)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de paiement : ")]),_vm._v(" "+_vm._s(_vm.facture.datePaieF)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Caisse concerné : ")]),_vm._v(" "+_vm._s(_vm.facture.caisse)+" ")]),_vm._v(" "),(!_vm.facture.avance)?_c('p',[_c('b',[_vm._v("Date de début : ")]),_vm._v(" "+_vm._s(_vm.facture.dateDF)+" ")]):_vm._e(),_vm._v(" "),(!_vm.facture.avance)?_c('p',[_c('b',[_vm._v("Date de fin :")]),_vm._v(" "+_vm._s(_vm.facture.dateFF)+" ")]):_vm._e(),_vm._v(" "),(_vm.facture.etat === 1)?_c('p',[_c('b',[_vm._v("Transmit par : ")]),_vm._v(" "+_vm._s(_vm.facture.transmiPar)+" ")]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[(_vm.facture.etat === 2)?_c('p',[_c('b',[_vm._v("Date de cloture : ")]),_vm._v(" "+_vm._s(_vm.facture.dateCloreF)+" ")]):_vm._e(),_vm._v(" "),(_vm.facture.etat === 2)?_c('p',[_c('b',[_vm._v("Clore par : ")]),_vm._v(" "+_vm._s(_vm.facture.clorePar)+" ")]):_vm._e(),_vm._v(" "),(!_vm.facture.avance)?_c('p',[_c('b',[_vm._v("Durée :")]),_vm._v(" "+_vm._s(_vm.facture.duree)+" Jour(s) ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Type de facture : ")]),_vm._v(" "),(_vm.facture.avance === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"indigo"}},[_vm._v("\n                            FACTURE\n                          ")]):(_vm.facture.avance === true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"blue"}},[_vm._v("\n                            FACTURE AVANCE\n                          ")]):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Statut : ")]),_vm._v(" "),(_vm.facture.etat === 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                            "+_vm._s(_vm.facture.etatlibelle)+"\n                          ")]):(_vm.facture.etat === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                            "+_vm._s(_vm.facture.etatlibelle)+"\n                          ")]):(_vm.facture.etat === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"cyan"}},[_vm._v("\n                            "+_vm._s(_vm.facture.etatlibelle)+"\n                          ")]):(_vm.facture.etat === 3)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                            "+_vm._s(_vm.facture.etatlibelle)+"\n                          ")]):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),(_vm.facture.etatG === 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                            IMPAYE\n                          ")]):_vm._e(),_vm._v(" "),(_vm.facture.etatG === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                            SOLDE\n                          ")]):_vm._e(),_vm._v(" "),(_vm.facture.etatG === 3)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                            EN COURS DE PAIEMENT\n                          ")]):_vm._e(),(_vm.facture.etatG === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            EN ATTENTE DE PAIEMENT\n                          ")]):_vm._e()],1),_vm._v(" "),(_vm.facture.avance)?_c('p',[_c('b',[_vm._v("Montant avance : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                            "+_vm._s(_vm.facture.montantAvanceF)+" FCFA\n                          ")])],1):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Tva : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                            "+_vm._s(_vm.facture.tva)+" %\n                          ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Montant ttc : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                            "+_vm._s(_vm.facture.totalTtc)+" FCFA\n                          ")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[(!_vm.facture.avance)?_c('p',[_c('b',[_vm._v("Montant : ")]),_vm._v(" "),_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                            "+_vm._s(_vm.facture.montantF)+" FCFA\n                          ")])],1):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Mode de transmission : ")]),_vm._v(" "+_vm._s(_vm.facture.transmission)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Observation : ")]),_vm._v(" "+_vm._s(_vm.facture.description)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Enrégistré par : ")]),_vm._v(" "+_vm._s(_vm.facture.userCreate)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Dernière modification par : ")]),_vm._v(" "+_vm._s(_vm.facture.userUpdate)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enrégistrement : ")]),_vm._v(" "+_vm._s(_vm.facture.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Dernière modification  :")]),_vm._v(" "+_vm._s(_vm.facture.modified)+" ")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"blue"}},[_vm._v("\n                          PIECE JOINTE DE LA FACTURE ET ATTACHEMENT\n                        ")]),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},_vm._l((_vm.facture.files),function(fit){return _c('el-col',{key:fit.id,attrs:{"span":6}},[_c('a',{attrs:{"href":fit.url,"target":"_blank"}},[_vm._v(_vm._s(fit.img))]),_vm._v(" "),_c('img',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":fit.url}})])}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"blue"}},[_vm._v("\n                          PIECE JOINTE DE LA FACTURE VALIDE\n                        ")]),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},_vm._l((_vm.facture.docsFact),function(fit){return _c('el-col',{key:fit.id,attrs:{"span":6}},[_c('a',{attrs:{"href":fit.url,"target":"_blank"}},[_vm._v(_vm._s(fit.img))]),_vm._v(" "),_c('img',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":fit.url}})])}),1)],1)],1)],1)]),_vm._v(" "),(_vm.facture.totalRapport > 0)?_c('el-row',[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                    POINT DES TACHES REALISEES\n                  ")]),_vm._v(" "),_vm._l((_vm.facture.rapport),function(item,index){return _c('v-layout',{key:item.id,attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tâche")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":item.tache,"prop":'item.'+ index+'.tache'}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date R.")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":item.date,"prop":'item.'+ index+'.date'}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Qte")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":item.qte,"prop":'item.'+ index+'.qte'}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix U.")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":item.prixU,"prop":'item.'+ index+'.prixU'}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("TOTAL")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%","font-weight":"bold"},attrs:{"readonly":true,"value":item.totalF,"prop":'item.'+ index+'.total'}})],1)])],1)}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('el-input',{staticStyle:{"width":"100%","font-size":"1.5rem","font-weight":"bold"},attrs:{"readonly":true,"value":_vm.totalRapportF+' FCFA'}})],1)])],1)],2):_vm._e(),_vm._v(" "),_c('el-row',[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                    LISTE DES REGLEMENTS EFFECTUEES\n                  ")]),_vm._v(" "),_vm._l((_vm.facture.rapport),function(item,index){return _c('v-layout',{key:item.id,attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tâche")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":item.tache,"prop":'item.'+ index+'.tache'}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date R.")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":item.date,"prop":'item.'+ index+'.date'}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Qte")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":item.qte,"prop":'item.'+ index+'.qte'}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix U.")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"value":item.prixU,"prop":'item.'+ index+'.prixU'}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("TOTAL")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%","font-weight":"bold"},attrs:{"readonly":true,"value":item.totalF,"prop":'item.'+ index+'.total'}})],1)])],1)}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('el-input',{staticStyle:{"width":"100%","font-size":"1.5rem","font-weight":"bold"},attrs:{"readonly":true,"value":_vm.totalRapportF+' FCFA'}})],1)])],1)],2)],1)])],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogFactureShow = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n          Fermer\n        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.facture.etat === 0)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newFacture(_vm.facture);}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n          Modifier\n        ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h4',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer cet enrégistrement ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("\n            Annuler\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteC()}}},[_vm._v("\n            Supprimer\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogFactureSupr),callback:function ($$v) {_vm.dialogFactureSupr=$$v},expression:"dialogFactureSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h4',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer cet enrégistrement ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogFactureSupr = false}}},[_vm._v("\n            Annuler\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteF()}}},[_vm._v("\n            Supprimer\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogValidePSupr),callback:function ($$v) {_vm.dialogValidePSupr=$$v},expression:"dialogValidePSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h4',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer cet enrégistrement ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogValidePSupr = false}}},[_vm._v("\n            Annuler\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteOF()}}},[_vm._v("\n            Supprimer\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-card',[_c('div',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n        LISTE DES CLIENTS "),_c('v-icon',{attrs:{"right":""}},[_vm._v("emoji_people")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-text',[(_vm.droitAcces.client_index || _vm.droitAcces.client_projet_index)?_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listClient}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Nom et prénoms / Raison sociale","width":"370","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                "+_vm._s(scope.row.libelle)+"\n              ")])]}}],null,false,1949311733)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type de client"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.type == 1)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                PERSONNE PARTICULIER\n              ")]):_vm._e(),_vm._v(" "),(scope.row.type == 2)?_c('v-chip',{attrs:{"outline":"","text-color":"indigo","label":"","color":"indigo"}},[_vm._v("\n                PERSONNE ENTREPRISE\n              ")]):_vm._e()]}}],null,false,3972142620)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"contact","label":"Contact"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                "+_vm._s(scope.row.contact)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_phone")])],1)]}}],null,false,796352732)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();_vm.show(scope.row);_vm.loadProjet(scope.row);
                  _vm.loadFacture(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                  Détails\n                ")],1),_vm._v(" "),(_vm.droitAcces.client_projet_edit)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){$event.stopPropagation();return _vm.edit(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                  Modifier\n                ")],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.delete_client_projet)?_c('v-tooltip',{attrs:{"top":""}},[(scope.row.delete)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSupr = true; _vm.idClient = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                  Supprimer\n                ")],1):_vm._e()],1)]}}],null,false,1010260355)})],1):_vm._e()],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y+Vx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_rapport_ListeReserve__ = __webpack_require__("cz/F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_boardTravaux_ListeTravaux__ = __webpack_require__("s7lN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_boardTravaux_widgetTravaux__ = __webpack_require__("MasU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_boardChantier_widgetChantier__ = __webpack_require__("7rON");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_boardTravaux_ListePrestataire__ = __webpack_require__("9BzK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_worklogs_ListeWorklog__ = __webpack_require__("x4h3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import ContratOuvrier from '@/components/boardChantier/Contrat_ouvrier';








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_6__components_Loading__["a" /* default */],
    ListeReserve: __WEBPACK_IMPORTED_MODULE_0__components_rapport_ListeReserve__["a" /* default */],
    ListeTravaux: __WEBPACK_IMPORTED_MODULE_1__components_boardTravaux_ListeTravaux__["a" /* default */],
    ListePrestataire: __WEBPACK_IMPORTED_MODULE_4__components_boardTravaux_ListePrestataire__["a" /* default */],
    ListeWorklog: __WEBPACK_IMPORTED_MODULE_5__components_worklogs_ListeWorklog__["a" /* default */],
    WidgetTravaux: __WEBPACK_IMPORTED_MODULE_2__components_boardTravaux_widgetTravaux__["a" /* default */],
    WidgetChantier: __WEBPACK_IMPORTED_MODULE_3__components_boardChantier_widgetChantier__["a" /* default */]
  },
  name: "DashboardChantier",
  props: {
    show: {
      type: Boolean
    },
    detailChantier: {
      type: Object
    },
    commis: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      dialogDashboardChantier: false,
      loading: false,
      onglet: "0",
      listeTravaux: [],
      listeTravauxId: [],

      //ONGLET TRAVAUX
      detailTravaux: {},
      dialogConfirmRefus: false,
      showRapport: false,
      showListeRapport: false,
      dialogListeRapport: false,
      listeRapports: [],
      IddetailTravaux: '',
      loadFenetre: false,
      rapportPerso: false,

      //ONGLET OUVRIERS
      listPrestataires: [],
      listOuvriers: [],
      showListeOuvrier: false,

      //ONGLET WORKLOG
      listworklogs: [],
      listtache: [],
      totalHeuretrx: [],
      totalmintrx: [],
      totalActivite: [],

      //ONGLET RESERVE
      listeReserves: []
    };
  },

  methods: {
    closeDialog: function closeDialog() {
      this.listOuvriers.splice(0);
      this.listPrestataires.splice(0);
      this.$emit("close");
    },
    loadTravaux: function loadTravaux(chantier) {
      var _this = this;

      this.loading = true;
      this.listeTravauxId = [];
      var url = this.domaine + "travaux/chantiers/" + chantier.id;
      this.$http.get(url).then(function (response) {
        _this.listeTravaux = response.body.travaux;
        _this.listeTravaux.forEach(function (element) {
          _this.listeTravauxId.push(element.idTrx);
        });
        _this.loading = false;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Echec lors du chargement des travaux");
      });
    },


    //ONGLETS OUVRIERS/PRESTATAIRE

    loadOuvrier: function loadOuvrier(idChantier) {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "ouvrier/chantier/" + idChantier;
      this.$http.get(url).then(function (response) {
        _this2.listOuvriers = response.body.ouvriers;
        _this2.listPrestataires = response.body.prestataires;
        _this2.loading = false;
        _this2.showListeOuvrier = true;
      }, function (error) {
        _this2.loading = false;
        _this2.$message.error("Echec lors du chargement des ouvriers");
      });
    },


    //ONGLET RESERVE
    loadReserves: function loadReserves() {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + "reserve/chantier/" + this.detailChantier.idChant;
      this.$http.get(url).then(function (response) {
        _this3.listeReserves = response.body.reserves;
        _this3.loading = false;
      }, function (error) {
        _this3.loading = false;
        _this3.$message.error("Echec lors du chargement des reserves");
      });
    },


    //ONGLET WORKLOG
    loadWorklogs: function loadWorklogs(idChantier) {
      var _this4 = this;

      this.loading = true;
      var url = this.domaine + "worklogs/chantier/" + idChantier;
      this.$http.get(url).then(function (response) {
        _this4.listworklogs = response.body.listeWorklog;

        // this.totalheure = response.body.totalheure

        _this4.totalHeuretrx = response.body.totalheure;
        _this4.totalmintrx = response.body.totalMinutes;
        _this4.totalActivite = response.body.totalActivite;
        _this4.listtache = response.body.listTacheeWorklog;
        _this4.loading = false;
      }, function (error) {
        _this4.loading = false;
        _this4.$message.error("Echec lors du chargement des worklogs");
      });
    },

    //onglet rapports
    loadRapportProjet: function loadRapportProjet() {
      var _this5 = this;

      console.log('this.detailChantier', this.detailChantier);
      console.log('this.detailProjet', this.detailProjet);
      this.loading = true;
      var url = this.domaine + "journal/projet/chantier/" + this.detailChantier.idChant + '/' + this.user.id;
      this.$http.get(url).then(function (response) {
        _this5.listeRapports = response.body.journaux;
        _this5.loading = false;
        _this5.loadFenetre = true;
        _this5.rapportPerso = true;
        //on affecte lid du chantier pour pouvoir retrouver tous les travaux
        // this.IddetailTravaux = this.detailProjet.id;
      }, function (error) {
        _this5.loading = false;
        _this5.$message.error("Echec lors du chargement des Journaux");
      });
    },
    handleTabClick: function handleTabClick(tab) {
      this.showListeOuvrier = false;
      switch (tab) {
        case "0":
          if (this.listeTravaux.length == 0) {
            this.loadTravaux(this.detailChantier);
          }
          break;

        case "1":
          if (this.listOuvriers.length == 0 && this.listPrestataires.length == 0) {
            this.loadOuvrier(this.detailChantier.idChant);
          }
          break;

        case "2":
          if (this.listeReserves.length == 0) {
            this.loadReserves();
          }
          break;

        case "3":
          this.loadRapportProjet();
          break;

        case "4":
          this.loadWorklogs(this.detailChantier.idChant);
          break;

        default:
          break;
      }
    }
  },

  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogDashboardChantier = newValue;
      if (newValue == true) {
        this.onglet = "0";
        this.loadTravaux(this.detailChantier);
      }
    }
  }
});

/***/ }),

/***/ "Y3jT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalBanque_vue__ = __webpack_require__("0X2T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3555afbd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalBanque_vue__ = __webpack_require__("mPyz");
function injectStyle (ssrContext) {
  __webpack_require__("RUNv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalBanque_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3555afbd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalBanque_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Y5NI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "AjoutReglementCArte",
  props: {
    show: {
      type: Boolean
      //required: true
    },
    editRgt: {
      type: Object,
      default: {}
    },
    carte: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      // racourcis: [
      //     { path: '/', text: 'Accueil', disabled: false },
      //     { path: '/demandeFond', text: 'Demande de fonds', disabled: true }
      // ],
      dialogAjoutCarteRgt: false,
      rules: {
        dateRgt: [{ required: true, message: "Choisir une date ", trigger: "change" }],
        montant: [{ required: true, message: "Veuillez saisir un montant" }]
      },
      comboChantier: [],
      comboMission: [],
      formRgt: {
        dateRgt: ""
      },
      typeRgt: "Autre"
    };
  },


  watch: {
    show: function show(newValue, oldValue) {
      this.dialogAjoutCarteRgt = newValue;
      this.resetForm("formRgt");
      this.typeRgt = "Autre";
      if (newValue == true) {
        this.loadChantier();
        this.loadMission();
      }

      if (this.editRgt.id != null) {
        this.formRgt.dateRgt = this.editRgt.dateRgtNoFormat;
        //this.formRgt.dateRgt = "";
        this.formRgt.montant = this.editRgt.montant;
        if (this.editRgt.chantierId) {
          this.formRgt.chantierId = this.editRgt.chantierId;
          this.typeRgt = "Chantier";
        } else if (this.editRgt.missionId) {
          this.formRgt.missionId = this.editRgt.missionId;
          this.typeRgt = "Mission";
        } else {
          this.typeRgt = "Autre";
        }

        this.formRgt.description = this.editRgt.description;
      }
    }
  },

  methods: {
    loadChantier: function loadChantier() {
      var _this = this;

      var url = this.domaine + "chantier/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this.comboChantier = response.body.chantier;
        }
      });
    },
    loadMission: function loadMission() {
      var _this2 = this;

      var url = this.domaine + "mission/combo_mission";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this2.comboMission = response.body.missions;
        }
      });
    },


    // createFilter(queryString) {
    //     return (link) => {
    //         return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
    //     }
    // },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    handleMision: function handleMision(idMission) {
      this.formRgt.missionId = "";
      this.formRgt.missionId = idMission;
    },
    submitForm: function submitForm(formName) {
      var _this3 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          var form = document.getElementById("formRgt");
          //recuperation des demandes
          var data = new FormData(form);
          var url = "";
          if (_this3.editRgt.id == null) {
            //creer une nouvelle demande
            url = _this3.domaine + "carteCarburant/reglement/create";
          } //modifier une demande de maintenance
          else {
              url = _this3.domaine + "carteCarburant/reglement/edit";
              data.append("idRgt", _this3.editRgt.id);
            }
          data.append("userId", _this3.user.id);
          data.append("carteId", _this3.carte.carteId);
          data.append("dateRgt", _this3.formRgt.dateRgt);
          if (_this3.typeRgt == "Mission") {
            data.append("missionId", _this3.formRgt.missionId);
          } else if (_this3.typeRgt == "Chantier") {
            data.append("chantierId", _this3.formRgt.chantierId);
          }

          _this3.$http.post(url, data).then(function (response) {
            //reinitialiser le formulaire
            _this3.loading = false;
            _this3.resetForm("formRgt");
            _this3.formRgt.description = "";
            _this3.successNotif(response.body.message);
            _this3.closeDialog();
          }, function (erreur) {
            //reinitialiser le formulaire
            _this3.loading = false;
            _this3.resetForm("formRgt");
            _this3.formRgt.description = "";
            _this3.closeDialog();
            _this3.$message.error("Une erreur est survenue lors de l'enregistrement du règlement");
          });
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    successNotif: function successNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      this.$notify({
        title: "ENREGISTREMENT REUSSI",
        message: mess,
        type: "success",
        position: "top-center",
        duration: 10000
      });
    }
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ "Y62D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */] },
  name: "ModalValidationDga",
  props: ["show", "detailCommande", "totalMontant"],
  data: function data() {
    var _ref;

    return _ref = {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      dialogDetail: false,
      listeTacheSupp: [],
      dialogSupr: false,
      index: '',
      indexRow: '',
      indexLigne: '',
      indexRowLigne: '',
      dialogVisible: false,
      dialogConfirmRefus: false,
      logoPdf: "/static/pdf.png",
      dialogConfirm: false,
      formRefus: {},
      items: []
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "index", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "urlImage", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "ruleFormRefus", {
      rapportRefus: [{ required: true, message: "Veuillez saisir" }]
    }), _ref;
  },


  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogDetail = newValue;
      this.urlImage = this.detailCommande.urlImage;
      console.log("detailCommande", this.detailCommande);

      if (newValue == true) {
        //this.loadDevisConstat()
      }
    }
  },

  methods: {
    successNotif: function successNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      this.$notify({
        title: "ENREGISTREMENT REUSSI",
        message: mess,
        type: "success",
        position: "top-center"
      });
    },
    showDiapo: function showDiapo(images, ind, image) {
      this.items = images;
      this.index = ind;
    },
    closeDialog: function closeDialog() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      console.log("item", item);
      if (item == "images") {
        this.index = null;
      } else {
        this.$emit("close", this.detailCommande.id, "bonCommandeInterne");
      }
    },
    deleteBesoin: function deleteBesoin() {
      this.this.listeTacheSupp = [];
      if (this.detailCommande.option[this.indexLigne].id != null) {
        this.listeTacheSupp.push(this.detailCommande.option[this.indexLigne].id);
      }
      this.indexRowLigne.splice(this.indexLigne, 1);
      this.dialogSupr = false;
    },
    deleteRow: function deleteRow(index, rows) {
      this.indexLigne = index;
      this.indexRowLigne = rows;
    },
    SubmitValideDevis: function SubmitValideDevis(item) {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "besoin/avalider/bci/nivau3";

      var data = new FormData();
      data.append("decision", item == "confirme" ? 1 : 0);
      data.append("commDec", this.formRefus.rapport);
      data.append("idUser", this.user.id);
      data.append("bci", this.detailCommande.id);
      data.append("listeSupp", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.listeTacheSupp));
      // on recupere le tableau
      for (var prop in this.detailCommande.option) {
        var ligne = this.detailCommande.option[prop];
        data.append("options[id][]", ligne.id);
        data.append("options[qte][]", ligne.qte);
      }
      this.$http.post(url, data).then(function (response) {
        _this.loading = false;
        _this.dialogConfirmRefus = false;
        _this.dialogConfirm = false;
        _this.formRefus.rapport = "";
        _this.successNotif(response.body.message);
        _this.closeDialog();
      }, function (errResp) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors de la validation de la mission");
      });
    },
    SubmitRefusDevis: function SubmitRefusDevis() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "besoin/avalider/bci/nivau3";
      var data = new FormData();
      data.append("decision", item == "confirme" ? 1 : 0);
      data.append("commDec", this.formRefus.rapport);
      data.append("bci", this.detailCommande.id);
      data.append("user", this.user.id);

      this.$http.post(url, data).then(function (response) {
        _this2.loading = false;
        _this2.successNotif(response.body.message);
        _this2.dialogConfirmRefus = false;
        _this2.closeDialog();
      }, function (errResp) {
        _this2.loading = false;
        _this2.$message.error("Une erreur est survenue lors du refus de la demande de mission");
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "YFcr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dupformTypeTravaux_vue__ = __webpack_require__("aSNn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_748e34b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dupformTypeTravaux_vue__ = __webpack_require__("u/GC");
function injectStyle (ssrContext) {
  __webpack_require__("NR+o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-748e34b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dupformTypeTravaux_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_748e34b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dupformTypeTravaux_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YFyM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('table',{staticStyle:{"width":"100%"}},[_vm._m(0),_vm._v(" "),_vm._l((_vm.routes),function(r){return _c('tr',[_c('td',[_vm._v(_vm._s(r.path))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(r.name))])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Chemin")]),_vm._v(" "),_c('th',[_vm._v("Nom")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YJo1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalCalendContrat_vue__ = __webpack_require__("FJfj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10fe9eaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalCalendContrat_vue__ = __webpack_require__("cjD9");
function injectStyle (ssrContext) {
  __webpack_require__("/omi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10fe9eaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalCalendContrat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10fe9eaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalCalendContrat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YSKP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liste_demande_vue__ = __webpack_require__("TzRi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f97218_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liste_demande_vue__ = __webpack_require__("+ztJ");
function injectStyle (ssrContext) {
  __webpack_require__("6dBU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liste_demande_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f97218_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liste_demande_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YWoT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_resourceHumaine_form_contrat__ = __webpack_require__("84xr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        idUserContrat: {
            type: Number
        },
        typeAdmin: {
            type: Boolean,
            default: true
        }
    },
    components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */], FormContrat: __WEBPACK_IMPORTED_MODULE_2__components_resourceHumaine_form_contrat__["a" /* default */] },
    name: "contratEmploye",
    data: function data() {
        return {
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,

            dialogFormContrat: false,
            dialogFormAddTaux: false,
            dialogSuppTaux: false,
            formDynamiqueTaux: {
                taux: [{
                    key: 1,
                    tauxPaiement: 1,
                    typePaie: 1,
                    renumeration: 5,
                    statut: 0
                }]
            },
            listeContrats: [],
            listeStatut: [{
                libelle: "non",
                id: 0
            }, {
                libelle: "exempt",
                id: 1
            }],
            listeTauxPaiement: [{
                libelle: "Heure",
                id: 1
            }, {
                libelle: "Mois",
                id: 2
            }, {
                libelle: "Semaine",
                id: 3
            }, {
                libelle: "Annee",
                id: 4
            }],
            listeTypePaie: [{
                libelle: "Salaire",
                id: 1
            }, {
                libelle: "Heure",
                id: 2
            }, {
                libelle: "Contrat",
                id: 3
            }, {
                libelle: "Commission",
                id: 4
            }],
            contratSelect: null,
            tauxSelect: null,
            items: [],
            index: null

        };
    },

    methods: {
        showDiapo: function showDiapo(images, ind) {
            this.items = images;
            this.index = ind;
        },
        tableRowClassName: function tableRowClassName(_ref) {
            var row = _ref.row,
                rowIndex = _ref.rowIndex;

            if (rowIndex === 1) {
                return 'warning-row';
            } else if (rowIndex === 3) {
                return 'success-row';
            }
            return '';
        },
        loadContratUser: function loadContratUser() {
            var _this = this;

            this.loading = true;
            var url = this.domaine + "rh/contrat/employe/" + this.idUserContrat;

            this.$http.get(url).then(function (resp) {
                _this.loading = false;
                _this.listeContrats = resp.body.listeContrats;
            }, function (error) {
                _this.loading = false;
                _this.$message.error("Echec lors du chargement des contrats de l'employé ");
            });
        },
        showDeleteTaux: function showDeleteTaux(idTaux) {
            this.dialogSuppTaux = true;
            this.tauxSelect = idTaux;
        },
        submitDeleteTaux: function submitDeleteTaux() {
            var _this2 = this;

            this.loading = true;
            var url = this.domaine + "rh/taux/" + this.tauxSelect + "/delete";
            this.$http.get(url).then(function (resp) {
                _this2.loading = false;
                _this2.dialogSuppTaux = false;
                _this2.successNotif(resp.body.message);
                _this2.tauxSelect = null;
                _this2.loadContratUser();
            }, function (error) {
                _this2.loading = false;
                _this2.dialogSuppDetail = false;
                _this2.$message.error("Echec lors de la suppression du taux salarial");
            });
        },
        submitFormTaux: function submitFormTaux(formName) {
            var _this3 = this;

            this.$refs[formName].validate(function (valid) {
                if (!valid) {
                    alert('submit!');
                    return;
                }

                _this3.loading = true;
                var url = _this3.domaine + "rh/contrat/" + _this3.contratSelect + "/taux";
                var data = new FormData();
                data.append("listeTaux", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.formDynamiqueTaux.taux));
                data.append("userCreated", _this3.user.id);

                _this3.$http.post(url, data).then(function (resp) {
                    _this3.loading = false;
                    _this3.dialogFormAddTaux = false;
                    _this3.contratSelect = null;
                    _this3.loadContratUser();
                    _this3.successNotif(resp.body.message);
                }, function (error) {
                    _this3.loading = false;
                    _this3.contratSelect = null;
                    _this3.$message.error("Echec lors de l'enregistrement du taux");
                });
            });
        },
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        },
        showAddTaux: function showAddTaux(contratSel) {
            this.dialogFormAddTaux = true;
            this.contratSelect = contratSel;
        },
        removeTaux: function removeTaux(item) {
            var index = this.formDynamiqueTaux.taux.indexOf(item);
            if (index !== -1) {
                this.formDynamiqueTaux.taux.splice(index, 1);
            }
        },
        addTaux: function addTaux() {
            this.formDynamiqueTaux.taux.push({
                key: 44666,
                tauxPaiement: 1,
                typePaie: 1,
                renumeration: 5,
                statut: 0
            });
        },
        closeFormContrat: function closeFormContrat() {
            this.dialogFormContrat = false;
            this.loadContratUser();
        }
    },
    watch: {
        idUserContrat: function idUserContrat(newValue, oldValue) {
            if (newValue != 0) {
                this.loadContratUser();
            }
        }
    },
    mounted: function mounted() {
        //this.loadContratUser()
    }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Password__ = __webpack_require__("G+K8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_User__ = __webpack_require__("jyJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Fournisseur__ = __webpack_require__("NTOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Entrepot__ = __webpack_require__("JezI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Drive__ = __webpack_require__("ztN/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Parametre__ = __webpack_require__("yjku");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Keywords__ = __webpack_require__("9mGq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Produit__ = __webpack_require__("YiKP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Projet__ = __webpack_require__("FSjC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Caisse__ = __webpack_require__("DXBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Demande__ = __webpack_require__("7rJt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_demandeFond_Demande_fond_index__ = __webpack_require__("pryE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Validation__ = __webpack_require__("lztk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Routes__ = __webpack_require__("qvaN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_DetailDemande__ = __webpack_require__("pScu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_ParcAuto__ = __webpack_require__("prMl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Flotte__ = __webpack_require__("HVE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_calendrier_Planning__ = __webpack_require__("t7st");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_FicheVehicule__ = __webpack_require__("X67K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_ouvrier_listeOuvrier__ = __webpack_require__("wzzi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_validationDG_Validation_index__ = __webpack_require__("wx/6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_validationDG_Validation_dga_index__ = __webpack_require__("ebYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_validationDG_Validation_dex_index__ = __webpack_require__("OIE+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_validationDG_Validation_post_index__ = __webpack_require__("VAqU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_mission_Mission__ = __webpack_require__("ybQ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Chantier__ = __webpack_require__("bsLm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Besoin__ = __webpack_require__("382i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_besoin_listeDeBci__ = __webpack_require__("aFSH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_maintenance_Maintenance_index__ = __webpack_require__("WVMY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_comparateur_comparateur_index__ = __webpack_require__("7Ag2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_rapport_Comparateur_journal__ = __webpack_require__("v9GS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_boardChantier_Index_board_Chantier__ = __webpack_require__("B6fc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_boardCommis_DashboardCommis__ = __webpack_require__("Qwre");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_boardProjet_indexProjet__ = __webpack_require__("q1LB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_boardTravaux_DashboardTravaux__ = __webpack_require__("0iXz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_projet_DashboardComparatif__ = __webpack_require__("M0+p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_projet_DashboardRapport__ = __webpack_require__("NUJi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_gestionTache_ListeTableau__ = __webpack_require__("LYZi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_projet_CompteExploitation__ = __webpack_require__("+E58");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_projet_BudgetProjet__ = __webpack_require__("mEAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_projet_BudgetChantier__ = __webpack_require__("l9xG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_Client__ = __webpack_require__("WQvJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_worklogs_Worklogs__ = __webpack_require__("SYG7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_PlanComptable_PlanComptable__ = __webpack_require__("llJt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_validationDG_facturePaiement__ = __webpack_require__("UgjE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_resourceHumaine_board_resource__ = __webpack_require__("WpKY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_resourceHumaine_index_resource__ = __webpack_require__("+CPR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_resourceHumaine_detail_employe__ = __webpack_require__("SHB3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_resourceHumaine_liste_contrat__ = __webpack_require__("gMf6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_resourceHumaine_liste_demande__ = __webpack_require__("YSKP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_resourceHumaine_boardEmploye__ = __webpack_require__("ROzJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_reporting_dashboardReporting__ = __webpack_require__("SDwy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_tierce_RechercheInfo__ = __webpack_require__("IPbc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_projet_IndicateurProjet__ = __webpack_require__("l1zf");










//import Maintenance from '@/components/Maintenance'




















































//import fullCalendar from 'vue-fullcalendar'
//Vue.component('full-calendar', fullCalendar)


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [
  // { path: '/', name: 'Home', component: Home },
  { path: '/', name: 'Home', component: __WEBPACK_IMPORTED_MODULE_30__components_Besoin__["a" /* default */] }, { path: '/client', name: 'Client', component: __WEBPACK_IMPORTED_MODULE_45__components_Client__["a" /* default */] }, { path: '/login', name: 'Login', component: __WEBPACK_IMPORTED_MODULE_3__components_Login__["a" /* default */] }, { path: '/routes/expo', name: 'routes', component: __WEBPACK_IMPORTED_MODULE_17__components_Routes__["a" /* default */] }, { path: '/password', name: 'Password', component: __WEBPACK_IMPORTED_MODULE_4__components_Password__["a" /* default */] }, { path: '/user', name: 'User', component: __WEBPACK_IMPORTED_MODULE_5__components_User__["a" /* default */] }, { path: '/fournisseur', name: 'Fournisseur', component: __WEBPACK_IMPORTED_MODULE_6__components_Fournisseur__["a" /* default */] }, { path: '/drive', name: 'Drive', component: __WEBPACK_IMPORTED_MODULE_8__components_Drive__["a" /* default */] }, { path: '/maintenance', name: 'Maintenance', component: __WEBPACK_IMPORTED_MODULE_32__components_maintenance_Maintenance_index__["a" /* default */] }, { path: '/parametre', name: 'Parametre', component: __WEBPACK_IMPORTED_MODULE_9__components_Parametre__["a" /* default */] }, { path: '/keywords', name: 'Keywords', component: __WEBPACK_IMPORTED_MODULE_10__components_Keywords__["a" /* default */] }, { path: '/produit', name: 'Produit', component: __WEBPACK_IMPORTED_MODULE_11__components_Produit__["a" /* default */] }, { path: '/entrepot', name: 'Entrepot', component: __WEBPACK_IMPORTED_MODULE_7__components_Entrepot__["a" /* default */] }, { path: '/projet', name: 'Projet', component: __WEBPACK_IMPORTED_MODULE_12__components_Projet__["a" /* default */] }, { path: '/compteExpo', name: 'CompteExp', component: __WEBPACK_IMPORTED_MODULE_42__components_projet_CompteExploitation__["a" /* default */] }, { path: '/budgetProjet', name: 'BudgetProjet', component: __WEBPACK_IMPORTED_MODULE_43__components_projet_BudgetProjet__["a" /* default */] }, { path: '/budgetChantier', name: 'BudgetChantier', component: __WEBPACK_IMPORTED_MODULE_44__components_projet_BudgetChantier__["a" /* default */] }, { path: '/chantier', name: 'Chantier', component: __WEBPACK_IMPORTED_MODULE_29__components_Chantier__["a" /* default */] }, { path: '/caisse', name: 'Caisse', component: __WEBPACK_IMPORTED_MODULE_13__components_Caisse__["a" /* default */] }, { path: '/demande', name: 'Demande', component: __WEBPACK_IMPORTED_MODULE_14__components_Demande__["a" /* default */] }, { path: '/demandeFond', name: 'DemandeFond', component: __WEBPACK_IMPORTED_MODULE_15__components_demandeFond_Demande_fond_index__["a" /* default */] }, { path: '/Besoin/listeDeBci', name: 'listeDeBci', component: __WEBPACK_IMPORTED_MODULE_31__components_besoin_listeDeBci__["a" /* default */] }, { path: '/validation', name: 'Validation', component: __WEBPACK_IMPORTED_MODULE_16__components_Validation__["a" /* default */] }, { path: '/listeOuvrier', name: 'listeOuvrier', component: __WEBPACK_IMPORTED_MODULE_23__components_ouvrier_listeOuvrier__["a" /* default */] }, { path: '/validationDmd', name: 'ValidationDmd', component: __WEBPACK_IMPORTED_MODULE_24__components_validationDG_Validation_index__["a" /* default */] }, { path: '/validationDmd_dex', name: 'ValidationDmd_dex', component: __WEBPACK_IMPORTED_MODULE_26__components_validationDG_Validation_dex_index__["a" /* default */] }, { path: '/validationDmd_post', name: 'ValidationDmd_post', component: __WEBPACK_IMPORTED_MODULE_27__components_validationDG_Validation_post_index__["a" /* default */] }, { path: '/validationDmd_dga', name: 'ValidationDmd_dga', component: __WEBPACK_IMPORTED_MODULE_25__components_validationDG_Validation_dga_index__["a" /* default */] }, { path: '/detail/demande/:demande_id', name: 'DetailDemande', component: __WEBPACK_IMPORTED_MODULE_18__components_DetailDemande__["a" /* default */] }, { path: '/parc/auto', name: 'ParcAuto', component: __WEBPACK_IMPORTED_MODULE_19__components_ParcAuto__["a" /* default */] }, { path: '/parc/auto/flotte/:etat_veh', name: 'Flotte', props: true, component: __WEBPACK_IMPORTED_MODULE_20__components_Flotte__["a" /* default */] }, { path: '/parc/auto/fiche/:id', name: 'FicheVehicule', props: true, component: __WEBPACK_IMPORTED_MODULE_22__components_FicheVehicule__["a" /* default */] }, { path: '/planning/chantier/:id', name: 'Planning', props: true, component: __WEBPACK_IMPORTED_MODULE_21__components_calendrier_Planning__["a" /* default */] }, { path: '/mission', name: 'Mission', component: __WEBPACK_IMPORTED_MODULE_28__components_mission_Mission__["a" /* default */] }, { path: '/besoin', name: 'Besoin', component: __WEBPACK_IMPORTED_MODULE_30__components_Besoin__["a" /* default */] }, { path: '/comparateur', name: 'Comparateur', component: __WEBPACK_IMPORTED_MODULE_33__components_comparateur_comparateur_index__["a" /* default */] }, { path: '/comparateur_journal', name: 'Comparateur_journal', component: __WEBPACK_IMPORTED_MODULE_34__components_rapport_Comparateur_journal__["a" /* default */] }, { path: '/boardChantier', name: 'DashBoardChantier', component: __WEBPACK_IMPORTED_MODULE_35__components_boardChantier_Index_board_Chantier__["a" /* default */] }, { path: '/boardCommis', name: 'DashboardCommis', component: __WEBPACK_IMPORTED_MODULE_36__components_boardCommis_DashboardCommis__["a" /* default */] }, { path: '/boardProjet', name: 'DashBoardProjet', component: __WEBPACK_IMPORTED_MODULE_37__components_boardProjet_indexProjet__["a" /* default */] }, { path: '/boardTravaux', name: 'DashboardTravaux', component: __WEBPACK_IMPORTED_MODULE_38__components_boardTravaux_DashboardTravaux__["a" /* default */] }, { path: '/tableauxTache', name: 'ListeTableau', component: __WEBPACK_IMPORTED_MODULE_41__components_gestionTache_ListeTableau__["a" /* default */] }, { path: '/worklogs', name: 'Worklogs', component: __WEBPACK_IMPORTED_MODULE_46__components_worklogs_Worklogs__["a" /* default */] }, { path: '/boardFacture', name: 'facturePaiement', component: __WEBPACK_IMPORTED_MODULE_48__components_validationDG_facturePaiement__["a" /* default */] }, { path: '/boardResource', name: 'boardResource', component: __WEBPACK_IMPORTED_MODULE_49__components_resourceHumaine_board_resource__["a" /* default */] }, { path: '/indexResource', name: 'indexResource', component: __WEBPACK_IMPORTED_MODULE_50__components_resourceHumaine_index_resource__["a" /* default */] }, { path: '/liste', name: 'listeContrat', component: __WEBPACK_IMPORTED_MODULE_52__components_resourceHumaine_liste_contrat__["a" /* default */] }, { path: '/listeDemande', name: 'listeDemande', component: __WEBPACK_IMPORTED_MODULE_53__components_resourceHumaine_liste_demande__["a" /* default */] }, { path: '/detailEmploye', name: 'detailEmploye', component: __WEBPACK_IMPORTED_MODULE_51__components_resourceHumaine_detail_employe__["a" /* default */] }, { path: '/boardEmploye', name: 'boardEmploye', component: __WEBPACK_IMPORTED_MODULE_54__components_resourceHumaine_boardEmploye__["a" /* default */] }, { path: '/reporting', name: 'dashboardReporting', component: __WEBPACK_IMPORTED_MODULE_55__components_reporting_dashboardReporting__["a" /* default */] }, { path: '/search', name: 'RechercheInfo', component: __WEBPACK_IMPORTED_MODULE_56__components_tierce_RechercheInfo__["a" /* default */] }, { path: '/indicateur/projet', name: 'IndicateurProjet', component: __WEBPACK_IMPORTED_MODULE_57__components_projet_IndicateurProjet__["a" /* default */] }, { path: '/boardComparatif/projet', name: 'DashboardComparatif', component: __WEBPACK_IMPORTED_MODULE_39__components_projet_DashboardComparatif__["a" /* default */] }, { path: '/boardRapport/projet', name: 'DashboardRapport', component: __WEBPACK_IMPORTED_MODULE_40__components_projet_DashboardRapport__["a" /* default */] }, { path: '/maintenance', name: 'Maintenance', component: __WEBPACK_IMPORTED_MODULE_32__components_maintenance_Maintenance_index__["a" /* default */] }, { path: '/plan-comptable', name: 'PlanComptable', component: __WEBPACK_IMPORTED_MODULE_47__components_PlanComptable_PlanComptable__["a" /* default */] }]
}));

/***/ }),

/***/ "YdvK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutDiagIntervention_vue__ = __webpack_require__("uf1k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a45b6f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutDiagIntervention_vue__ = __webpack_require__("m09n");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutDiagIntervention_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a45b6f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutDiagIntervention_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YiKP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Produit_vue__ = __webpack_require__("LBxB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b911c186_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Produit_vue__ = __webpack_require__("UVH/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Produit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b911c186_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Produit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Yk/k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ytuf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z/zb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"tile":""}},[_c('v-card-text',[_c('h4',{attrs:{"mt-2":""}},[_vm._v("\n      "+_vm._s(this.typeReche == "carburant"
          ? "LISTE DES BCI DE CARBURANT A APPROUVER"
          : "LISTE DES BCI A APPROUVER")+"\n    ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","mt-2":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-4 mt-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Selectionner un Chantier"},on:{"change":function($event){return _vm.filtrerChantier()},"clear":function($event){return _vm.clearSelectChantier()}},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),(_vm.chantierS != '')?_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner un travaux"},on:{"change":function($event){return _vm.filtrerTravaux()}},model:{value:(_vm.travauxS),callback:function ($$v) {_vm.travauxS=$$v},expression:"travauxS"}},_vm._l((_vm.listeTravaux),function(item){return _c('el-option',{key:item.idTravaux,attrs:{"label":item.libTravaux,"value":item.idTravaux}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.travauxS != '')?_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Selectionner une tâche"},on:{"change":function($event){return _vm.filtrerTaches()}},model:{value:(_vm.tachesS),callback:function ($$v) {_vm.tachesS=$$v},expression:"tachesS"}},_vm._l((_vm.listeTaches),function(item){return _c('el-option',{key:item.idTache,attrs:{"label":item.libTache,"value":item.idTache}})}),1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-2":""}},[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"mt-3":"","ml-1":"","mr-1":"","data":_vm.BesoinsList}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Intitulé","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user","label":"DEMANDEUR","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chantier","label":"CHANTIER","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"travaux","label":"TRAVAUX","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tache","label":"TÂCHE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((scope.row.tache),function(item,index){return _c('span',{key:index},[_vm._v("\n                  "+_vm._s(item)+"/\n                ")])})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tranconA","label":"Du PK","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tranconB","label":"Au PK","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateLivr","label":"DATE SOUH / PERIODE D'UTILISATION","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.molalValidation(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("done_all")])],1),_vm._v("Valider...\n              ")],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"1500px"},model:{value:(_vm.dialogValideBesoin),callback:function ($$v) {_vm.dialogValideBesoin=$$v},expression:"dialogValideBesoin"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("VALIDATION DES RESSOURCES DU BON DE COMMANDE INTERNE (BCI)")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogValideBesoin = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"mb-5"},[_c('el-alert',{attrs:{"title":'Voulez-vous approuver ou rejeter Les ressources ',"description":"Les ressources validées concernant le matériel seront soumis aux services achat. Les demandes de carburant pour les véhicules seront traité par l'Entrepot Hydrolique,tandis que les ressources concernant les véhicules devront être analysé par le responsable logistique. Si vous décidez de valider les ressources ,veuillez précisez la date de livraison souhaitée s'il vous plait et la mention bon pour accord dans le champs commentaire.","type":"warning","center":"","closable":false,"show-icon":""}}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.listeBesoinSelect.urlImage)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","id":"intro","dark":""},on:{"click":function($event){return _vm.showDiapo([_vm.listeBesoinSelect.urlImage], 0, _vm.listeBesoinSelect.urlImage)}},slot:"activator"},[_vm._v("Voir la pièce justificatif "),_c('v-icon',{attrs:{"right":""}},[_vm._v("list")])],1):_vm._e(),_vm._v("\n                Voir la pièce justificatif\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"indigo","id":"intro","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.showDialogComparaison(_vm.listeBesoinSelect)}},slot:"activator"},[_vm._v("Consulter le stock "),_c('v-icon',{attrs:{"right":""}},[_vm._v("list")])],1),_vm._v("\n                Vérifier le stock\n            ")],1)],1),_vm._v(" "),_c('CoolLightBox',{attrs:{"items":_vm.items,"index":_vm.index},on:{"close":function($event){_vm.index = null}}}),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%","margin-top":"30px"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":_vm.listeBesoinSelect.option}},[_c('el-table-column',{attrs:{"align":"center","prop":"codeAnalytique","label":"CODE ANALYTIQUE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"codeGestion","label":"CODE GESTION"}}),_vm._v(" "),_c('el-table-column',{staticStyle:{"width":"100%"},attrs:{"align":"center","prop":"type","label":"CATEGORIE DE RESSOURCE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"produit","label":"TYPE DE RESSOURCE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"unite","label":"UNITE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"dateLivrSouh","label":"DATE LIVRAISON SOUHAITEE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateLivrSouh","label":"CHANGER DATE LIVRAISON *"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('div',{staticClass:"block"},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","id":"dateLivrSouh","type":"date","placeholder":"Choississez une date de livraison"},model:{value:(prop.row.dateLivrSouh),callback:function ($$v) {_vm.$set(prop.row, "dateLivrSouh", $$v)},expression:"prop.row.dateLivrSouh"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"QUANTITE A COMMANDER *"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('div',{staticClass:"block"},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","name":"qte"},on:{"change":function($event){return _vm.calculTotalComm(prop.row)}},model:{value:(prop.row.qte),callback:function ($$v) {_vm.$set(prop.row, "qte", $$v)},expression:"prop.row.qte"}})],1)]}}])})],1),_vm._v(" "),_c('el-form',{staticClass:"mt-4",attrs:{"label-position":"top","label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"Commentaire *"}},[_c('el-input',{attrs:{"rows":"6","type":"textarea","placeholder":"Veuillez saisir l'expression bon pour accord si vous souhaitez valider la demande"},model:{value:(_vm.commDec),callback:function ($$v) {_vm.commDec=$$v},expression:"commDec"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialogValideBesoin = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.verifBtnConfirme,"color":"green darken-1","flat":""},on:{"click":function($event){return _vm.validRejetBesoin(1)}}},[_vm._v("Confirmer")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.verifBtnRefus,"color":"red darken-1","flat":""},on:{"click":function($event){return _vm.validRejetBesoin(0)}}},[_vm._v("Rejeter")])],1)],1)],1)],1),_vm._v(" "),_c('ModalCommandeDetails',{attrs:{"detailCommande":_vm.listbesoins,"hiddenButton":true,"butonValide":true,"show":_vm.showModalDetailCom},on:{"close":function($event){_vm.showModalDetailCom = false}}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogDetailCommande),callback:function ($$v) {_vm.dialogDetailCommande=$$v},expression:"dialogDetailCommande"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("DETAILS DES PRODUITS PRÉSENT DANS L'ENTREPOT")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogDetailCommande = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"mt-3":"","ml-1":"","mr-1":"","data":_vm.produitStock},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"width":"55","type":"selection"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"entrepot","label":"ENTREPOT","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"codeGestion","label":"CODE DE GESTION","align":"center"}}),_vm._v(" "),_c('el-table-column',{directives:[{name:"fi",rawName:"v-fi",value:(_vm.typeReche != 'carburant'),expression:"typeReche != 'carburant'"}],attrs:{"prop":"codeGestion","label":"Code analytique","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"TYPE RESSOURCE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"produit","label":"RESSOURCE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"QTE DISPONIBLE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":""}},[_vm._v("\n                "+_vm._s(scope.row.qte)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"UNITE","align":"center"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue","dark":""},on:{"click":function($event){_vm.dialogDetailCommande = false}}},[_vm._v("Fermer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZNpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util__ = __webpack_require__("OMJi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_util__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "ListePresence",
  props: {
    listeOuvriers: {
      type: Array
    },
    idTravaux: {
      type: Number
    },
    listeData: {
      type: Array
    }
  },
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      listePrestOuvriers: [],
      prestataireSelect: {
        id: null,
        contrat: null,
        heureDbt: null,
        heureDbtNuit: null,
        heureFin: null,
        heureFinNuit: null,
        heurePause: null,
        heurePauseNuit: null,
        heureIntem: null,
        heureIntemNuit: null,
        // heureNuit: null,
        description: null,
        depense: null,
        heureTotal: null,
        heureTotalNuit: null
      },
      typeTravaiL: [{ text: "JOUR", value: "JOUR", id: "1" }, { text: "NUIT", value: "NUIT", id: "2" }],
      heurSUpp: [{ text: "OUI", value: "OUI", id: "1" }, { text: "NON", value: "NON", id: "2" }],
      totalPOuvrierHT: 0,
      totTTCOuvrireDepen: 0,
      totalHeureOuvrier: "",
      dateRaport: '',
      totalHeureOuvrierNuit: "",
      tablePresence: [],
      listeContratOuvrier: [],
      typePrestSelect: 0 //0=>ouvrier, 1=> prestataire
    };
  },


  watch: {
    show: function show(newValue, oldvalue) {
      // this.dialogRapport = newValue
      console.log('listeData', this.listeData);

      // if(newValue == true){
      //     this.dropdata()
      //     this.d1 = 1;
      //     if(this.editRapport) {
      //         console.log('detailTrx',this.detailTrx)
      //         console.log('dateRpt',this.dateRpt)
      //         let row = this.detailTrx
      //         this.formInfo.dateRapport = this.dateRpt
      //         this.detailTrx.libelle = row.libTrx
      //         this.resetForm()
      //         console.log('detailTrx',this.detailTrx)

      //         //  etape 1
      //         this.formInfo.temp = row.temp
      //         this.formInfo.pluie = row.pluie
      //         this.formInfo.vent = row.vent
      //         this.formInfo.heurTravail = row.nmbreHeur
      //         this.formInfo.trancon = row.trancon
      //         this.formInfo.profil = row.profil
      //         this.formInfo.auProfil = row.auProfil

      //           //  etape 2
      //         const transformedVisiteurs = row.listeVisiteurs.map(visiteur => {
      //             const [nom, prenom] = visiteur.nomPrenom.split(" ");
      //             return {
      //                 nom,
      //                 prenom,
      //                 fonction: visiteur.fonction,
      //                 heure: visiteur.HeureDbut,
      //                 heureFin: visiteur.HeureFin
      //             };
      //         });
      //         this.tableVisiteur.push(...transformedVisiteurs)

      //         this.tableInventaire.push(...row.listeMateriels) 

      //         this.tableformExtern.push(...row.listeExterneMateriels) 

      //         const transformedTechnik = row.listeRessourtechnik.map(visiteur => {                        
      //             return {
      //                 nom: visiteur.fonction,
      //                 prenom: visiteur.fonction,
      //                 fonction: visiteur.fonction,
      //                 heure: visiteur.HeureDbut,
      //                 heureFin: visiteur.HeureFin
      //             };
      //         });

      //         this.listeData.push(...transformedTechnik) 

      //         this.tableVehicule.push(...row.listeVehicules)

      //         const transformedTaches = row.listeTaches.map(tache => {
      //             return {
      //                 libelle: tache.libTache,
      //                 qte: tache.qte,
      //                 unite: tache.unite,
      //                 imageTaches: [...tache.photos],
      //                 description: tache.commentaire
      //             };
      //         });
      //         this.tableTravaux.push(...transformedTaches) 

      //     }else {
      //         this.formInfo.dateRapport = this.dateRpt
      //         let dateRpt = this.formInfo.dateRapport.getFullYear()+"-"+(this.formInfo.dateRapport.getMonth()+1)+"-"+this.formInfo.dateRapport.getDate()
      //         this.dateRaport = dateRpt
      //         this.formTravaux.unite = ''
      //     }
      //     this.loadTypeRessource()
      //     this.loadMateriel();
      //     this.loadVehicule();
      //     this.loadOuvrier();
      //     this.loadControlleur();
      //     this.loadProduit()
      // }
    }
  },

  methods: {
    addListPresence: function addListPresence(item) {
      if (item.type == 1) {
        if (item.id == null || item.id == "undefined" || item.id.nom == null || item.id.nom == "undefined" || item.heureDbt == "undefined" || item.heureDbt == null || item.heureFin == "undefined" || item.heureFin == null || item.heurePause == "undefined" || item.heurePause == null || item.heureIntem == "undefined" || item.heureIntem == null ||
        // item.contrat.idContrat == "undefined" ||
        // item.contrat.idContrat == null ||
        item.heurSUpp == null || item.heurSUpp == "undefined") {
          this.$message.error("Veuillez renseigner correctement les champs");
          return;
        }
      } else {
        if (item.id == null || item.id == "undefined" || item.id.nom == null || item.id.nom == "undefined" || item.heureDbtNuit == "undefined" || item.heureDbtNuit == null || item.heureFinNuit == "undefined" || item.heureFinNuit == null || item.heurePauseNuit == "undefined" || item.heurePauseNuit == null || item.heureIntemNuit == "undefined" || item.heureIntemNuit == null ||
        // item.contrat.idContrat == "undefined" ||
        // item.contrat.idContrat == null ||
        item.heurSUpp == null || item.heurSUpp == "undefined") {
          this.$message.error("Veuillez renseigner correctement les champs");
          return;
        }
      }

      //verifions que l'ouvrier na deja pas ete selectionne
      var ouvrier = this.tablePresence.find(function (elt) {
        if (elt.nom == item.id.nom && elt.libeleCont == item.contrat.libTache && elt.type == item.type) {
          return elt.nom;
        }
      });

      if (ouvrier != undefined) {
        this.$message.warning("Cet ouvrier a déjà été ajouté dans le tableau");
        return;
      }

      if (item.type == 1) {
        this.tablePresence.push({
          id: item.id.id,
          nom: item.id.nom,
          type: item.type,
          // contrat: item.contrat.idContrat,
          // libeleCont: item.contrat.libTache,
          heureDbt: item.heureDbt,
          heureFin: item.heureFin,
          heurePause: item.heurePause,
          heureIntem: item.heureIntem,
          heureSuppl: item.heurSUpp == 2 ? "00:00" : item.heureSuppl,
          heureTotal: item.heureTotal,
          description: item.description,
          descriptionSupp: item.heurSUpp == 2 ? "" : item.descriptionSupp,
          depense: item.depense,
          renumeration: item.renumeration
        });
      } else {
        this.tablePresence.push({
          id: item.id.id,
          nom: item.id.nom,
          // contrat: item.contrat.idContrat,
          // libeleCont: item.contrat.libTache,
          heureSuppl: item.heurSUpp == 2 ? "00:00" : item.heureSuppl,
          heureDbt: item.heureDbtNuit,
          heureFin: item.heureFinNuit,
          heurePause: item.heurePauseNuit,
          heureIntem: item.heureIntemNuit,
          heureTotal: item.heureTotalNuit,
          description: item.description,
          descriptionSupp: item.heurSUpp == 2 ? "" : item.descriptionSupp,
          depense: item.depense,
          renumeration: item.renumeration
        });
      }

      var tab = this.tablePresence;
      var totalH = 0;
      var totalQteCarbu = 0;
      var totalCouCarbu = 0;
      var totalMtanDepen = 0;
      for (var index = 0; index < tab.length; index++) {
        var element = tab[index];
        var hr = this.TransFomrToMinut(element["heureTotal"]);
        totalH += hr;
        totalQteCarbu += element["qte"];
        totalMtanDepen += parseFloat(element["depense"]);
      }
      this.totalPOuvrierHT = this.TransFomrToHeur(totalH);
      this.totTTCOuvrireDepen = totalMtanDepen;

      this.prestataireSelect = {};
      this.$emit("dataChange", this.tablePresence);
    },
    TransFomrToMinut: function TransFomrToMinut(item) {
      var tabDateDbt = item.split(":"); //[00:00"]
      var hr = tabDateDbt[0];
      var min = tabDateDbt[1];
      var minute = void 0;

      minute = parseFloat(hr * 60) + parseFloat(min);
      return minute;
    },
    TransFomrToHeur: function TransFomrToHeur(item) {
      var heure = void 0;
      var minute = void 0;
      heure = Math.floor(item / 60);
      minute = parseFloat(item - heure * 60);

      return minute != 0 ? heure + ":" + minute : heure + ":" + "00";
    },
    calculTotalComm: function calculTotalComm() {
      var maxDate = this.prestataireSelect.heureFin;
      var minDate = this.prestataireSelect.heureDbt;
      if (maxDate != null && minDate != null) {
        var tabheureDbt = this.TransFomrToMinut(this.prestataireSelect.heureDbt);
        var tabheureFin = this.TransFomrToMinut(this.prestataireSelect.heureFin);
        var tabheurePause = this.TransFomrToMinut(this.prestataireSelect.heurePause);
        var tabheureIntem = this.TransFomrToMinut(this.prestataireSelect.heureIntem);
        // let tabheureNuit = this.TransFomrToMinut(this.prestataireSelect.heureNuit)
        var dureeMinute = tabheureFin - tabheureDbt;

        var TotalHeureTrav = parseFloat(tabheureFin) - parseFloat(tabheureDbt) - parseFloat(tabheurePause) - parseFloat(tabheureIntem);

        //on transforme ensuite les minutes en heures pour l'affichage
        this.prestataireSelect.heureTotal = this.TransFomrToHeur(TotalHeureTrav);

        var totalHOuvri = this.prestataireSelect.heureTotal.split(":"); //[00:00"]
        var montantOuvr = this.prestataireSelect.renumeration;
        var HeurUtil = (totalHOuvri[0] + totalHOuvri[1]) / 100;

        this.prestataireSelect.depense = parseInt(montantOuvr * HeurUtil);
        this.totalHeureOuvrier = this.TransFomrToHeur(TotalHeureTrav);
      }
    },
    calculTotalComm1: function calculTotalComm1() {
      var minDate = this.prestataireSelect.heureDbtNuit.split(":");
      var maxDate = this.prestataireSelect.heureFinNuit.split(":");

      var tabheureDbt = this.TransFomrToMinut(this.prestataireSelect.heureDbtNuit);
      var tabheureFin = this.TransFomrToMinut(this.prestataireSelect.heureFinNuit);

      if (parseFloat(maxDate) > parseFloat(minDate)) {
        var _tabheureDbt = this.TransFomrToMinut(this.prestataireSelect.heureDbtNuit);
        var _tabheureFin = this.TransFomrToMinut(this.prestataireSelect.heureFinNuit);
        var tabheurePause = this.TransFomrToMinut(this.prestataireSelect.heurePauseNuit);
        var tabheureIntem = this.TransFomrToMinut(this.prestataireSelect.heureIntemNuit);
        // let tabheureNuit = this.TransFomrToMinut(this.prestataireSelect.heureNuit1)
        var dureeMinute = _tabheureFin - _tabheureDbt;

        var TotalHeureTrav = parseFloat(dureeMinute) - parseFloat(tabheurePause) - parseFloat(tabheureIntem);
        //on transforme ensuite les minutes en heures pour l'affichage
        this.prestataireSelect.heureTotalNuit = this.TransFomrToHeur(TotalHeureTrav);
      } else {
        var _tabheureDbt2 = this.TransFomrToMinut(this.prestataireSelect.heureDbtNuit);
        var _tabheureFin2 = this.TransFomrToMinut(this.prestataireSelect.heureFinNuit);
        var _tabheurePause = this.TransFomrToMinut(this.prestataireSelect.heurePauseNuit);
        var _tabheureIntem = this.TransFomrToMinut(this.prestataireSelect.heureIntemNuit);
        var _dureeMinute = _tabheureFin2 + 1440 - _tabheureDbt2;

        var _TotalHeureTrav = parseFloat(_dureeMinute) - parseFloat(_tabheurePause) - parseFloat(_tabheureIntem);

        //on transforme ensuite les minutes en heures pour l'affichage
        this.prestataireSelect.heureTotalNuit = this.TransFomrToHeur(_TotalHeureTrav);

        this.totalHeureOuvrierNuit = this.TransFomrToHeur(_TotalHeureTrav);
      }
    },
    deleteRow: function deleteRow(index, rows) {
      rows.splice(index, 1);
      this.$emit("dataChange", this.tablePresence);
      var tab = this.tablePresence;
      var totalH = 0;
      var totalQteCarbu = 0;
      var totalCouCarbu = 0;
      var totalMtanDepen = 0;
      for (var _index = 0; _index < tab.length; _index++) {
        var element = tab[_index];
        var hr = this.TransFomrToMinut(element["heureTotal"]);
        totalH += hr;
        totalQteCarbu += element["qte"];
        totalMtanDepen += parseFloat(element["depense"]);
      }
      this.totalPOuvrierHT = this.TransFomrToHeur(totalH);
      this.totTTCOuvrireDepen = totalMtanDepen;
    },
    loadTacheOuvrier: function loadTacheOuvrier() {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "ouvrier/" + this.prestataireSelect.id.id + "/idtravaux/" + this.idTravaux;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this.loading = false;
          _this.listeContratOuvrier = response.body.contrats;
        }
      }, function (response) {
        _this.loading = false;
      });
    },
    handleChangeOuvrier: function handleChangeOuvrier() {

      var libelle = this.prestataireSelect["id"]["id"];
      var resultat = 0;
      // let details = this.listeOuvriers.forEach(element => {
      var elementFound = this.listeOuvriers.find(function (prod) {

        return prod.id == libelle;
      });
      resultat = elementFound.montantNormal;
      //   return elementFound.valeur
      // });
      this.prestataireSelect.renumeration = resultat;
      this.loadTacheOuvrier();
    }
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ "ZO+E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZP2/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","persistent":"","overlay":true,"scrollable":""},model:{value:(_vm.dialogAjoutFond),callback:function ($$v) {_vm.dialogAjoutFond=$$v},expression:"dialogAjoutFond"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.editForm == false)?_c('span',[_vm._v(" Ajouter une demande de fonds ")]):_c('span',[_vm._v("Modifier une demande de fonds ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formDmd",staticClass:"demo-form-inline",attrs:{"id":"formDmd","model":_vm.formDmd,"rules":_vm.rules}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('div',{},[_c('el-radio-group',{attrs:{"size":"mini"},model:{value:(_vm.typeDmd),callback:function ($$v) {_vm.typeDmd=$$v},expression:"typeDmd"}},[_c('el-radio-button',{attrs:{"label":"Projet"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"Carburant"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"Autre"}})],1),_vm._v(" "),_c('el-popover',{attrs:{"placement":"top-start","title":"Approvisionement carte de carburant","width":"500","trigger":"hover"}},[_c('el-table',{attrs:{"data":_vm.helpDemande}},[_c('el-table-column',{attrs:{"width":"20","property":"num","label":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"600","property":"text","label":""}})],1),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeDmd == 'Carburant'),expression:"typeDmd == 'Carburant'"}],staticStyle:{"font-size":"25px"},attrs:{"slot":"reference","icon":"el-icon-question","type":"text"},slot:"reference"})],1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeDmd == 'Projet'),expression:"typeDmd == 'Projet'"}],staticClass:"mr-2",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Projet","prop":"projet"}},[_c('span',{staticClass:"asterix"},[_vm._v("*")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","name":"projet","placeholder":"projet"},on:{"change":_vm.selectProjet},model:{value:(_vm.formDmd.projet),callback:function ($$v) {_vm.$set(_vm.formDmd, "projet", $$v)},expression:"formDmd.projet"}},_vm._l((_vm.listeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeDmd != 'Projet'),expression:"typeDmd != 'Projet'"}],staticClass:"mr-2",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Projet","prop":"projet"}},[_c('span',{staticClass:"asterix"},[_vm._v("*")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","name":"projet","placeholder":"projet"},on:{"change":_vm.selectProjet},model:{value:(_vm.formDmd.projet),callback:function ($$v) {_vm.$set(_vm.formDmd, "projet", $$v)},expression:"formDmd.projet"}},_vm._l((_vm.listeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeDmd == 'Projet'),expression:"typeDmd == 'Projet'"}],staticClass:"mr-2",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Chantier","prop":"chantier"}},[_c('span',{staticClass:"asterix"},[_vm._v("*")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","name":"chantier","placeholder":"chantier"},on:{"change":function($event){return _vm.selectChantier(_vm.formDmd.chantier)}},model:{value:(_vm.formDmd.chantier),callback:function ($$v) {_vm.$set(_vm.formDmd, "chantier", $$v)},expression:"formDmd.chantier"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeDmd != 'Projet'),expression:"typeDmd != 'Projet'"}],staticClass:"mr-2",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Chantier","prop":"chantier"}},[_c('span',{staticClass:"asterix"},[_vm._v("*")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","name":"chantier","placeholder":"chantier"},model:{value:(_vm.formDmd.chantier),callback:function ($$v) {_vm.$set(_vm.formDmd, "chantier", $$v)},expression:"formDmd.chantier"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1),_vm._v(" "),(false)?_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeDmd == 'Carburant'),expression:"typeDmd == 'Carburant'"}],staticClass:"mr-2",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Zone","prop":"zone"}},[_c('el-autocomplete',{staticStyle:{"width":"100%"},attrs:{"name":"zone","placeholder":"nom de la zone","fetch-suggestions":_vm.loadZone},model:{value:(_vm.formDmd.zone),callback:function ($$v) {_vm.$set(_vm.formDmd, "zone", $$v)},expression:"formDmd.zone"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeDmd == 'Autre'),expression:"typeDmd == 'Autre'"}],staticClass:"mr-2",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Libelle","prop":"autre"}},[_c('span',{staticClass:"asterix"},[_vm._v("*")]),_vm._v(" "),_c('el-autocomplete',{staticStyle:{"width":"100%"},attrs:{"name":"autre","placeholder":"selectionner","fetch-suggestions":_vm.loadAutre},model:{value:(_vm.formDmd.autre),callback:function ($$v) {_vm.$set(_vm.formDmd, "autre", $$v)},expression:"formDmd.autre"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-2",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Travaux","prop":"travaux"}},[_c('span',{staticClass:"asterix"},[_vm._v("*")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","name":"travaux","placeholder":"Travaux"},model:{value:(_vm.formDmd.travaux),callback:function ($$v) {_vm.$set(_vm.formDmd, "travaux", $$v)},expression:"formDmd.travaux"}},_vm._l((_vm.listeTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-form-item',{attrs:{"label":"Caisse concerne","prop":"caisse"}},[_c('span',{staticClass:"asterix"},[_vm._v("*")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Selectionner une caisse"},on:{"change":_vm.handleChangeCaisse},model:{value:(_vm.formDmd.caisseSelect),callback:function ($$v) {_vm.$set(_vm.formDmd, "caisseSelect", $$v)},expression:"formDmd.caisseSelect"}},_vm._l((_vm.listeCaisse),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeDmd != 'Carburant'),expression:"typeDmd != 'Carburant'"}],staticClass:"ml-1",attrs:{"xs3":""}},[_c('el-form-item',{attrs:{"label":"Montant","prop":"montant"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":5,"name":"montant","placeholder":"saisir un montant"},model:{value:(_vm.formDmd.montant),callback:function ($$v) {_vm.$set(_vm.formDmd, "montant", $$v)},expression:"formDmd.montant"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-1",attrs:{"xs3":""}},[_c('el-form-item',{attrs:{"label":"Nom du demandeur","prop":"demandeur"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"demandeur","placeholder":"nom du demandeur"},model:{value:(_vm.formDmd.demandeur),callback:function ($$v) {_vm.$set(_vm.formDmd, "demandeur", $$v)},expression:"formDmd.demandeur"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-1",attrs:{"xs3":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"motif"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","row":17,"name":"motif","placeholder":"motif de la demande"},model:{value:(_vm.formDmd.motif),callback:function ($$v) {_vm.$set(_vm.formDmd, "motif", $$v)},expression:"formDmd.motif"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeDmd == 'Carburant'),expression:"typeDmd == 'Carburant'"}],attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"cyan","icon":"info"}},[_vm._v("\n                                        Liste des cartes\n                                    ")])],1),_vm._v(" "),_c('el-form',{ref:"formCarte",staticClass:"demo-form-inline",attrs:{"id":"formCarte","rules":_vm.rulesFormCarte,"label-position":"top","inline":true,"model":_vm.formCarte}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Carte à crediter","prop":"identifiant"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Selectionner une carte"},model:{value:(_vm.formCarte.identifiant),callback:function ($$v) {_vm.$set(_vm.formCarte, "identifiant", $$v)},expression:"formCarte.identifiant"}},_vm._l((_vm.listeCarte),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.identifiant,"value":item.identifiant}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('el-form-item',{attrs:{"label":"Quantité *","prop":"quantité"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":1,"value":"qte","placeholder":"Quantité"},on:{"change":function($event){return _vm.calculTotal()}},model:{value:(_vm.formCarte.qte),callback:function ($$v) {_vm.$set(_vm.formCarte, "qte", $$v)},expression:"formCarte.qte"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('el-form-item',{attrs:{"label":"Prix *","prop":"prix"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":1,"value":"prix HT","placeholder":"Prix"},on:{"change":function($event){return _vm.calculTotal()}},model:{value:(_vm.formCarte.prix),callback:function ($$v) {_vm.$set(_vm.formCarte, "prix", $$v)},expression:"formCarte.prix"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md3":""}},[_c('el-form-item',{attrs:{"label":"Montant à recharger","prop":"montant"}},[_c('p',[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.formCarte.montant))+"\n                                                        ")])])],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('el-form-item',{attrs:{"label":" "}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.addListCarte('formCarte', _vm.formCarte)}}},[_vm._v("Ajouter\n                                                ")])],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (TTC): "+_vm._s(new
                                        Intl.NumberFormat().format(_vm.totalCarte))+" fcfa")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableCarte}},[_c('el-table-column',{attrs:{"prop":"identifiant","label":"identifiant","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"qte","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"prix","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"'info'","disable-transitions":""}},[_vm._v(_vm._s(new
                                                        Intl.NumberFormat().format(scope.row.montant))+"\n                                                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableCarte)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                                    Supprimer la carte\n                                                ")],1)]}}])})],1)],1),_vm._v(" "),_c('br')],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){return _vm.resetForm('formDmd')}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("\n                                        remove_circle")])],1),_vm._v(" "),(_vm.editForm == false)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitForm('formDmd')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitForm('formDmd')}}},[_vm._v("Enregistrer\n                                    les modifications"),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZaFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: "MatriceContract",
  props: {
    show: {
      type: Boolean
    },
    idProjet: {
      type: Number
    }

  },
  data: function data() {
    var _ref;

    return _ref = {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
      droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),

      formDoc: {
        ordre: "",
        libelle: "",
        evolution: 0
      },
      editForm: false,
      dialogShowVersion: false,
      dialogSupr: false,
      listeDoc: [],
      dialogDoc: false,
      status: [{
        text: "EN ATTENTE",
        value: 0
      }, {
        text: "ACO",
        value: 1
      }, {
        text: "AC1",
        value: 2
      }, {
        text: "BPE",
        value: 3
      }],

      mode: [{
        text: "Courrier",
        value: 0
      }, {
        text: "Mail",
        value: 1
      }],
      rulesFormVersion: {

        identifiant: [{ required: true, message: 'Veuillez saisir' }],
        mode: [{ required: true, message: 'Veuillez selectionner', trigger: 'blur' }]
      }

    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "mode", [{
      text: "Courrier",
      value: 0
    }, {
      text: "Mail",
      value: 1
    }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "categories", [{
      text: "Autorisation",
      value: 0
    }, {
      text: "Environnement sociale",
      value: 1
    }, {
      text: "ETUDE",
      value: 2
    }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "versionCourante", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectCategorieMatrice", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectStatusMatrice", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectSaverMatrice", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "selectModeMatrice", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "logoMatrice", '/static/img-doc.png'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "docSelect", {
      numDoc: ""
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dialogVersion", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "formVersion", {
      libelle: "",
      commentaire: "",
      file: null,
      urlImage: "/static/doc.png"
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "newVersion", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "versionSelect", {
      libelle: ""
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dialogSuprVers", false), _ref;
  },


  watch: {
    show: function show(newValue, oldvalue) {
      console.log('newValue', newValue);
      if (newValue == true) {
        this.loadDoc();
        this.onglet = "0";
        // this.loadReserves();
        // this.loadBesoinAvalider()
        // this.loadRapportProjet();
      }
    }
  },

  methods: {
    showDialogVersionDetail: function showDialogVersionDetail(item) {
      this.dialogShowVersion = true;
      this.versionCourante = item;
    },
    showDialogSuppVersion: function showDialogSuppVersion(item) {
      this.versionSelect = item;
      this.dialogSuprVers = true;
    },
    showDilogSupp: function showDilogSupp(item) {
      this.docSelect = item;
      this.dialogSupr = true;
    },
    loadDoc: function loadDoc() {
      var _this = this;

      this.loading = true;
      this.docSelect = null;
      var url = this.domaine + 'projet/' + this.idProjet + '/index/tauxEvolution';
      this.$http.get(url).then(function (response) {
        _this.loading = false;
        _this.listeDoc = response.body.listTaux;
      }, function (response) {
        _this.loading = false;
      });
    },
    showAjoutDoc: function showAjoutDoc() {
      this.editForm = false;
      this.resetForm();
      this.dialogDoc = true;
      this.logoMatrice = '/static/img-doc.png';
    },
    imprimeMatricePDF: function imprimeMatricePDF() {
      var tab = [];
      var userid = this.user.id;
      this.listeDoc.forEach(function (element) {
        tab.push(element.idDoc);
      });
      var url = this.domaine + 'matrice/imprimer_matrice_pdf/' + userid + '/liste/' + tab;
      window.open(url);
    },
    showDialogVersionEdit: function showDialogVersionEdit(item) {
      this.dialogVersion = true;
      this.newVersion = false;
      this.versionSelect = item;
      this.formVersion = item;
      //  this.formVersion.libelle = item.libelle
      //  this.formVersion.mode = item.modeS
      this.formVersion.urlImage = item.urlImage;
      //  this.formVersion.description = item.commentaire
      //this.formVersion.status =  item.status
      // this.formVersion.reserve = item.reserve
    },
    showAddVersion: function showAddVersion(item) {
      this.newVersion = true;
      if (item.attente == true) {
        this.$message.error("Veuillez modifier l'etat de la derniere version du document");
        return;
      }
      this.docSelect = item;
      this.resetFormVersion();
      this.dialogVersion = true;
    },
    addVersion: function addVersion(formName) {
      var _this2 = this;

      //this.editForm =  false
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          var form = document.getElementById("formVersion");
          var data = new FormData(form);
          var url = _this2.domaine + 'projet/new/taux';
          data.append("mode", _this2.formDoc.mode);
          //data.append("status",this.formDoc.status)
          data.append("userId", _this2.user.id);
          _this2.$http.post(url, data).then(function (resp) {
            _this2.loading = false;
            _this2.resetFormVersion();
            _this2.dialogVersion = false;
            _this2.loadDoc();
            _this2.successNotif(resp.body.message);
          }, function (error) {
            _this2.loading = false;
            //this.resetForm('formDoc');
            _this2.$message.error("Une erreur est survenue lors de l'enregistrement du document");
          });
        }
      });
    },
    addDoc: function addDoc(formName) {
      var _this3 = this;

      this.editForm = false;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          var form = document.getElementById("formDoc");
          var data = new FormData(form);
          var url = _this3.domaine + 'projet/create/taux';
          data.append("evolution", _this3.formDoc.evolution);
          // data.append("dateSend",this.formDoc.dateSend)
          data.append("userId", _this3.user.id);
          data.append("projetId", _this3.idProjet);

          _this3.$http.post(url, data).then(function (resp) {
            var verif = resp.body;
            if (verif.code === 0) {
              _this3.loading = false;
              _this3.resetForm();
              _this3.dialogDoc = false;
              _this3.loadDoc();
              _this3.successNotif(verif.message);
            } else {
              _this3.loading = false;
              _this3.$message.error("Le numero d'ordre de ce documment existe deja");
            }
          }, function (error) {
            _this3.loading = false;
            //this.resetForm('formDoc');
            _this3.$message.error("Une erreur est survenue lors de l'enregistrement du document");
          });
        }
      });
    },
    showEditDoc: function showEditDoc(item) {

      //this.resetForm();

      this.formDoc = item;
      this.formDoc.dateSend = item.versions[0].dateSend;

      this.docSelect = item;
      this.editForm = true;

      this.logoMatrice = item.versions[0].urlImage;
      // this.formDoc.libelle = this.docSelect.libelle
      // this.formDoc.ordre = this.docSelect.ordre
      // //this.formDoc.categorie = this.docSelect.etatCategorie
      // this.formDoc.numDoc =  this.docSelect.numDoc
      // this.formDoc.version = this.docSelect.version
      // //this.formDoc.mode = this.docSelect.etatMode
      // //this.formDoc.status =  this.docSelect.etatStatus
      // this.formDoc.commentaire =  this.docSelect.commentaire
      // this.formDoc.file = null;


      this.dialogDoc = true;
    },
    editDoc: function editDoc(formName) {
      var _this4 = this;

      this.editForm = true;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.loading = true;
          var form = document.getElementById("formDoc");
          var data = new FormData(form);
          var url = _this4.domaine + 'matrice/edit/' + _this4.docSelect.idDoc;
          data.append("categorie", _this4.formDoc.categorie);
          data.append("mode", _this4.formDoc.mode);
          data.append("status", _this4.formDoc.status);
          //data.append("userId",this.user.id)
          //data.append("projetId",this.idProjet)

          _this4.$http.post(url, data).then(function (resp) {
            _this4.loading = false;
            _this4.resetForm();
            _this4.dialogDoc = false;
            _this4.loadDoc();
            _this4.successNotif(resp.body.message);
          }, function (error) {
            _this4.loading = false;
            //this.resetForm('formDoc');
            _this4.$message.error("Une erreur est survenue lors de la modification du document");
          });
        }
      });
    },
    editVersion: function editVersion() {
      var _this5 = this;

      this.loading = true;
      var form = document.getElementById("formVersion");
      var data = new FormData(form);
      var url = this.domaine + 'matrice/edit/version/' + this.versionSelect.id;
      data.append("status", this.formVersion.status);
      data.append("userId", this.user.id);
      data.append("dateSend", this.formVersion.dateSend);
      //data.append("projetId",this.idProjet)

      this.$http.post(url, data).then(function (resp) {
        _this5.loading = false;
        _this5.resetForm();
        _this5.dialogVersion = false;
        _this5.loadDoc();
        _this5.successNotif(resp.body.message);
      }, function (error) {
        _this5.loading = false;
        _this5.resetForm('formDoc');
        _this5.$message.error("Une erreur est survenue lors de la modification de la version");
      });
    },
    deleteDoc: function deleteDoc() {
      var _this6 = this;

      this.loading = true;
      var url = this.domaine + "matrice/delete/" + this.docSelect.idDoc;
      this.$http.get(url).then(function (response) {
        _this6.loading = false;
        _this6.loadDoc();

        _this6.$notify({
          title: "SUPPRESSION",
          message: "Document supprimé avec succès.",
          type: "success",
          position: "top-center"
        });
        _this6.dialogSupr = false;
      }, function (errRep) {
        _this6.loading = false;
        _this6.dialogSupr = false;
        _this6.$notify.error({
          title: "SUPPRESSION ECHOUEE",
          message: "La suppression du document a échouée.",
          position: "top-center"
        });
      });
    },
    deleteVersion: function deleteVersion() {
      var _this7 = this;

      this.loading = true;
      var url = this.domaine + "matrice/delete/version/" + this.versionSelect.id;
      this.$http.get(url).then(function (response) {
        _this7.loading = false;
        _this7.loadDoc();

        _this7.$notify({
          title: "SUPPRESSION",
          message: "Document supprimé avec succès.",
          type: "success",
          position: "top-center"
        });
        _this7.dialogSuprVers = false;
      }, function (errRep) {
        _this7.loading = false;
        _this7.dialogSupr = false;
        _this7.$notify.error({
          title: "SUPPRESSION ECHOUEE",
          message: "La suppression du document a échouée.",
          position: "top-center"
        });
      });
    },
    successNotif: function successNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Document enregistré avec succès";
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";

      this.$notify({
        title: 'ENREGISTREMENT DOCUMENT',
        message: mess,
        type: type,
        position: 'top-center',
        duration: 10000
      });
    },
    resetForm: function resetForm() {
      this.formDoc = [];
      this.file = null;
      //this.formDoc= {}
    },
    resetFormVersion: function resetFormVersion() {
      this.$refs['formVersion'].resetFields();
      this.formVersion.libelle = "";
      this.formVersion.commentaire = "";
      this.formVersion.urlImage = "/static/doc.png";
      this.formVersion.file = null;
    },

    //enregistrement des images
    onFileImageLogoPicked: function onFileImageLogoPicked(event) {
      var _this8 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this8.logoMatrice = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoMatrice = files[0];
    },
    onFileImageMatrice: function onFileImageMatrice(event) {
      var _this9 = this;

      var files = event.target.files;
      var filename = files[0].name;
      var extension = files[0].type;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 10485760) {
        this.$message.error("La taille du fichier est supérieur à 10M");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this9.formDoc.urlImage = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);

      this.formDoc.urlImage = files[0];
    },
    onFileImagePickedVersion: function onFileImagePickedVersion(event) {
      var _this10 = this;

      //  this.formVersion.urlImage = "";
      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 10485760) {
        this.$message.error("La taille du fichier est supérieur à 10M");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this10.formVersion.urlImage = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);

      this.formVersion.file = files[0];
    }
  },

  computed: {
    verifEditVersion: function verifEditVersion() {
      if (this.formVersion.status != null && this.formVersion.reserve != null) {
        return true;
      } else {
        return false;
      }
    }
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ "ZaXl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZrPI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zs8z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_gestionTache_TableauTache__ = __webpack_require__("+Krb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */], TableauTache: __WEBPACK_IMPORTED_MODULE_1__components_gestionTache_TableauTache__["a" /* default */] },
  name: "ListeTableau",
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [{ path: "/tableTache", text: "Tableaux des taches", disabled: false }],

      litesTab: []
    };
  },


  methods: {
    loadChantier: function loadChantier() {}
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ "a9pL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_map_GoogleMap__ = __webpack_require__("Fqjw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { GoogleMap: __WEBPACK_IMPORTED_MODULE_0__components_map_GoogleMap__["a" /* default */], Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
    name: "ProjetMap",
    props: ["show", "listMarqueur"],
    data: function data() {
        return {
            dialogMap: false,
            loading: false
        };
    },

    methods: {
        closeDialog: function closeDialog() {
            this.$emit('close');
        }
    },

    watch: {
        show: function show(newValue, oldvalue) {
            this.dialogMap = newValue;
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "aFSH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listeDeBci_vue__ = __webpack_require__("epPJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_205dbe85_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listeDeBci_vue__ = __webpack_require__("rYhZ");
function injectStyle (ssrContext) {
  __webpack_require__("69pY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listeDeBci_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_205dbe85_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listeDeBci_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aSNn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_divers_loadTypeTravaux_vue__ = __webpack_require__("iQMl");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "formTypeTravaux",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */], LoadTypeTravauxExcel: __WEBPACK_IMPORTED_MODULE_2__components_divers_loadTypeTravaux_vue__["a" /* default */] },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    listeLotTravaux: {
      type: Array,
      default: new Array()
    },
    typeProjetTab: {
      type: Array,
      default: new Array()
    },
    libelleSelect: {
      type: String,
      default: null
    },
    libelleChantier: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      loading: false,
      dialogAjoutTravaux: false,
      listeLots: [],
      typeProjet: "",
      formLotTravaux: {
        idTypeTrx: null,
        ordre: "",
        libelle: "",
        code: "",
        description: ""
      },
      rulesLotTravaux: {
        ordre: [{
          required: true,
          message: "Veuillez selectionnez un numéro d'ordre",
          trigger: "blur"
        }],
        libelle: [{
          required: true,
          message: "Veuillez  saisir un type de travaux",
          trigger: "blur"
        }],
        code: [{
          required: true,
          message: "Veuillez  saisir un code",
          trigger: "blur"
        }]
      },
      numOrdre: [],
      numOrdreCopie: [],
      listeTrxSupp: [],
      showModalLoadTypeTravaux: false,

      //Importer fichier excel
      fileExcel: [],
      lstTypeTravaux: []
    };
  },

  watch: {
    show: function show(newValue, oldValue) {
      var _this = this;

      if (newValue == true) {
        this.listeLots.splice(0);
        this.numOrdre.splice(0);
        this.typeProjet = "";
        this.dialogAjoutTravaux = true;
        this.numOrdre.push({ num: 1 });
        if (this.listeLotTravaux.length > 0) {
          this.numOrdre.splice(0);
          //rechechons lordre le plus eleve
          var ordreSup = null;
          this.listeLotTravaux.forEach(function (elt, ind) {
            if (ind + 1 < _this.listeLotTravaux.length) {
              var prochainOrdre = _this.listeLotTravaux[ind + 1].ordre;
              if (prochainOrdre > elt.ordre) {
                ordreSup = prochainOrdre;
              } else {
                ordreSup = elt.ordre;
              }
            }
          });

          this.listeLots = this.listeLotTravaux.slice();

          this.numOrdreCopie.splice(0);
          var nbLots = this.listeLotTravaux.length;
          this.numOrdre.push({ num: ordreSup + 1 });

          if (this.listeLotTravaux.length == 1) {
            this.numOrdre.push({ num: 2 });
          }

          for (var i = 0; i <= nbLots; i++) {
            this.numOrdreCopie.push({ num: i + 1 });
          }
        }
      } else {
        this.dialogAjoutTravaux = false;
      }
    }
  },
  computed: {
    listeNumber: function listeNumber() {
      var _this2 = this;

      var listeNum = this.numOrdreCopie.slice();
      return listeNum.filter(function (elt) {
        if (elt.num <= _this2.listeLots.length) {
          return elt;
        }
      });
    }
  },
  methods: {
    changeOrdre: function changeOrdre(value, ind) {},
    submitDup: function submitDup() {
      var _this3 = this;

      if (this.typeProjet == null) {
        this.$message.error("Aucun type de projet selectionne");
        return;
      }
      this.loading = true;

      var url = this.domaine + "projet/new/duplicate/travaux/projet";
      //recuperer les lots de travaux par groupe de 10
      var nbData = 1;
      if (this.listeLots.length > 10) {
        nbData = 10;
      }
      var nbReq = Math.round(this.listeLots.length / nbData);
      var nbRest = this.listeLots.length % nbData;
      if (nbRest > 0) {
        nbReq += 1;
      }
      if (nbReq == 0 && this.listeTrxSupp.length > 0) {
        nbReq = 1;
      }

      bloc_1: {
        var _loop = function _loop(i) {
          var initJ = i * nbData;
          var finJ = (i + 1) * nbData;
          var dataLot = [];
          dataLot.splice(0);
          if (_this3.listeLots.length > 0) {
            for (var j = initJ; j < finJ; j++) {
              if (_this3.listeLots[j] == undefined) {
                break;
              }
              dataLot.push(_this3.listeLots[j]);
            }
          }

          if (dataLot.length == 0 && _this3.listeTrxSupp.length == 0) {
            return "break|bloc_1";
          }

          var data = new FormData();
          //envoie des donnees
          var ligne = null;
          for (var prop in dataLot) {
            ligne = dataLot[prop];
            data.append("option[ordre][]", ligne.ordre);
            data.append("option[idTypeTrx][]", ligne.idTypeTrx);
            data.append("option[libelle][]", ligne.libelle);
            data.append("option[code][]", ligne.code);
            data.append("option[description][]", ligne.description);
          }
          data.append("type", _this3.typeProjet);
          data.append("idUser", _this3.user.id);
          data.append("id", _this3.user.id);
          // data.append("lots", JSON.stringify(dataLot));
          data.append("listeSupp", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.listeTrxSupp));
          _this3.$http.post(url, data).then(function (response) {
            if (response.body.code == 1 && i == nbReq - 1) {
              _this3.$notify({
                title: "Suppression travaux",
                message: response.body.message + response.body.lstTrxNonSupp,
                duration: 10000,
                type: "warning"
              });
            }

            _this3.$notify({
              title: "ENREGISTREMENT REUSSI",
              message: "Lot enregistré avec succès.",
              type: "success",
              position: "top-center"
            });
          }, function (response) {
            _this3.$message.error("Erreur lors de l'enregistrement des lots de travaux");
            _this3.loading = false;
          });
        };

        for (var i = 0; i < nbReq; i++) {
          var _ret = _loop(i);

          if (_ret === "break|bloc_1") break bloc_1;
        }
      }

      this.loading = false;
      this.$emit("close");
    },
    closeForm: function closeForm() {
      this.$emit("close");
      this.typeProjet = "";
      this.resetForm();
    },
    deleteRow: function deleteRow(index, rows) {
      var ordreIndex = this.listeLots[index].ordre;
      var indexpos = this.numOrdre.findIndex(function (elt) {
        return elt.num > ordreIndex;
      });
      var indexposCopie = this.numOrdreCopie.findIndex(function (elt) {
        return elt.num == ordreIndex;
      });

      this.numOrdre.splice(indexpos, 0, { num: ordreIndex });
      this.numOrdreCopie.splice(indexposCopie, 1);

      //enregistrer lid du lot de travaux supprimer dans la liste
      if (this.listeLots[index].idTypeTrx != null) {
        this.listeTrxSupp.push(this.listeLots[index].idTypeTrx);
      }

      rows.splice(index, 1);
      if (this.listeLots.length <= 0) {
        this.numOrdre.splice(0);
        this.numOrdreCopie.splice(0);

        this.numOrdre.push({ num: 1 });
        this.numOrdreCopie.push({ num: 1 });
      }
    },
    addListeTypeTravaux: function addListeTypeTravaux() {
      var _this4 = this;

      this.$refs["formLotTravaux"].validate(function (valid) {
        if (valid) {
          var lenListelot = _this4.listeLots.length;
          var indiceInsert = _this4.formLotTravaux.ordre - 1;
          _this4.listeLots.splice(indiceInsert, 0, {
            idTypeTrx: _this4.formLotTravaux.idTypeTrx,
            libelle: _this4.formLotTravaux.libelle,
            code: _this4.formLotTravaux.code,
            ordre: _this4.formLotTravaux.ordre,
            description: _this4.formLotTravaux.description
          });

          var index = _this4.numOrdre.findIndex(function (elt) {
            return elt.num == _this4.formLotTravaux.ordre;
          });
          var dernierChif = _this4.numOrdre[_this4.numOrdre.length - 1].num;

          _this4.numOrdre.splice(index, 1);

          _this4.numOrdre.push({ num: dernierChif + 1 });
          _this4.resetForm();
        }
      });
    },
    handleChangeLibelle: function handleChangeLibelle(newValue, oldValue) {
      if (newValue = "") {
        // this.$message({
        //     message: 'Ce champ ne peut etre vide',
        //     type: 'warning'
        // });
      }
    },
    handleFileExcel: function handleFileExcel(command //0=>Importer,1=>generer
    ) {
      switch (command) {
        case "0":
          //importer un fichier
          this.$refs.fileInputExcel.click();
          break;
        case "1":
          //generer un modele un fichier
          this.generateFileExcel();
          break;
      }
    },
    generateFileExcel: function generateFileExcel() {
      var url = this.domaine + "projet/generer/modele/travaux/projet";
      window.open(url);
    },
    onFileExcelPicked: function onFileExcelPicked(event) {
      var _this5 = this;

      //  this.closeForm()
      this.fileExcel.splice(0, 1);
      var files = event.target.files;
      var filename = files[0].name;

      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this5.fileExcel.push(fileReader.result);
      });

      fileReader.readAsDataURL(files[0]);

      var url = this.domaine + "travaux/load_typeTravaux/excel";
      var data = new FormData();
      //emvoie du fichier

      data.append("fichierExcel", files[0], files[0][name]);
      this.$http.post(url, data).then(function (resp) {
        _this5.loading = false;

        _this5.$notify({
          title: "Chargement liste type travaux",
          message: "Chargement effectué",
          type: "success",
          position: "top-right",
          duration: 7000
        });
        _this5.lstTypeTravaux = resp.body.listeTypeTravaux;
        _this5.showModalLoadTypeTravaux = true;
      }, function (resp) {
        _this5.loading = false;
        _this5.$message.error("Erreur lors de l'importation du fichier");
      });
    },
    resetForm: function resetForm() {
      this.$refs["formLotTravaux"].resetFields();
      this.formLotTravaux.libelle = "";
      this.formLotTravaux.code = "";
      this.formLotTravaux.description = "";
      this.listeTrxSupp.splice(0);
    }
  }
});

/***/ }),

/***/ "aTKr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aWw2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aaRc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n             ANALYSE DES COÛTS DE RENDEMENT\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{staticClass:"elevation-12 pt-1 mb-3",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('h3',[_vm._v("Critères de recherche ")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"model":_vm.formTri,"id":"formTri"}},[_c('el-form-item',{attrs:{"label":"Projet","width":"400 px"}},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"Projet"},on:{"change":function($event){return _vm.onchangeInfo(_vm.selectProjet)}},model:{value:(_vm.selectProjet),callback:function ($$v) {_vm.selectProjet=$$v},expression:"selectProjet"}},_vm._l((_vm.listeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Chantier"}},[_c('el-select',{attrs:{"clearable":"","placeholder":"Chantier"},on:{"change":function($event){_vm.loadTravaux();_vm.onchangeChantier(_vm.selectChantier)}},model:{value:(_vm.selectChantier),callback:function ($$v) {_vm.selectChantier=$$v},expression:"selectChantier"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Section"}},[_c('el-select',{attrs:{"clearable":"","placeholder":"Travaux"},on:{"change":function($event){_vm.loadTaches();_vm.onChangeTravaux(_vm.selectTravaux)}},model:{value:(_vm.selectTravaux),callback:function ($$v) {_vm.selectTravaux=$$v},expression:"selectTravaux"}},_vm._l((_vm.listeTravaux),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Tâche"}},[_c('el-select',{attrs:{"clearable":"","placeholder":"Tâche"},model:{value:(_vm.selectTaches),callback:function ($$v) {_vm.selectTaches=$$v},expression:"selectTaches"}},_vm._l((_vm.listTaches),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Période"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"datetimerange","range-separator":"à","start-placeholder":"Début date","end-placeholder":"Fin date"},model:{value:(_vm.selectAnneeMonth),callback:function ($$v) {_vm.selectAnneeMonth=$$v},expression:"selectAnneeMonth"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Année"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"year","placeholder":"Choisir une  année"},model:{value:(_vm.selectAnnee),callback:function ($$v) {_vm.selectAnnee=$$v},expression:"selectAnnee"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","color":"blue","fab":"","small":""},on:{"click":function($event){return _vm.loadChantierSearch()}},slot:"activator"},[_c('v-icon',[_vm._v("search")])],1),_vm._v("Effectuer une recherche\n                              ")],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"elevation-3 pt-2 pl-2 pr-2 pb-2 grey lighten-4",attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":""}},[(_vm.showGraph)?_c('div',[_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("VALEUR PLANIFIEE (VP)")]),_vm._v(" "),_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"#2f4554"}},[_vm._v(" VALEUR ACQUISE (VA)")]),_vm._v(" "),_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"#618fa8"}},[_vm._v(" COUT REEL (CR)")]),_vm._v(" "),(_vm.libelleTravaux !='' && _vm.selectAnneeMonth != '' && _vm.selectAnneeMonth != null)?_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(" PERIODE: "+_vm._s(_vm.selectAnneeMonth ? _vm.selectAnneeMonth[0] : '')+" AU "+_vm._s(_vm.selectAnneeMonth ? _vm.selectAnneeMonth[1] : '')+"  ")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"300px"},attrs:{"id":"main"}})])],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.libelleTravaux !='')?_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(" TABLEAU D'ANALYSE DE LA VALEUR ACQUISE (VP) ")]):_vm._e(),_vm._v(" "),(_vm.libelleTravaux !='' && _vm.selectAnneeMonth !='' && _vm.selectAnneeMonth !='null' && _vm.selectAnneeMonth != null)?_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(" PERIODE: "+_vm._s(_vm.selectAnneeMonth ? _vm.selectAnneeMonth[0] : '')+" AU "+_vm._s(_vm.selectAnneeMonth ? _vm.selectAnneeMonth[1] : '')+"  ")]):_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[(_vm.libelleTravaux !='')?_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"warning"}},[_vm._v("Coût budgété du travail prévu ")]):_vm._e(),_vm._v(" "),(_vm.listTravauxResult.length >0)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogueImprimer=true}},slot:"activator"},[_vm._v("\n                          Exporter en Pdf\n                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("Pdf\n                        ")],1),_vm._v(" "),(true)?_c('el-popover',{attrs:{"placement":"top-start","title":"DETAILS SUR LES CALCULS DU MONTANT TOTAL ENGAGÉS","width":"500","trigger":"hover"}},[_c('el-table',{attrs:{"data":_vm.helpDemandeN}},[_c('el-table-column',{attrs:{"width":"600","property":"text","label":""}})],1),_vm._v(" "),(true)?_c('el-button',{staticStyle:{"font-size":"25px"},attrs:{"slot":"reference","icon":"el-icon-question","type":"text"},slot:"reference"}):_vm._e()],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listTravauxResult}},[_c('el-table-column',{attrs:{"prop":"codeTravaux","label":"CODE TAVAUX","align":"center","width":"100","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"orange","color":"primary"}},[_vm._v(_vm._s(scope.row.codeTravaux))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"LISTE DES TACHES","align":"center","width":"350","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))]),_vm._v(" "),(scope.row.soutraite == 1)?_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("TACHE SOUS-TRAITE")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"budget","label":"BUDGET TOTAL XOF","align":"center","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v("\n                          "+_vm._s(new Intl.NumberFormat().format(scope.row.budgetV))+" \n                          ")])]}}])})],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.libelleTravaux !='')?_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"warning"}},[_vm._v(" RESULATS DE LA RECHERCHE DU RENDEMENT DES TACHES")]):_vm._e(),_vm._v(" "),(_vm.libelleTravaux !='')?_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"success"}},[_vm._v(" TRAVAUX: "+_vm._s(_vm.libelleTravaux))]):_vm._e(),_vm._v(" "),(_vm.libelleTravaux !='' && _vm.selectAnneeMonth !='' && _vm.selectAnneeMonth !=null && _vm.selectAnneeMonth !='null')?_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(" PERIODE: "+_vm._s(_vm.selectAnneeMonth ? _vm.selectAnneeMonth[0] :'')+" AU "+_vm._s(_vm.selectAnneeMonth ? _vm.selectAnneeMonth[1] :'')+"  ")]):_vm._e(),_vm._v(" "),(_vm.libelleTravaux !='' && _vm.selectAnnee !='' && _vm.selectAnnee != null)?_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(" ANNÉE: "+_vm._s(_vm.selectAnnee)+" ")]):_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[(_vm.listTravauxResult.length >0)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogueImprimer=true}},slot:"activator"},[_vm._v("\n                          Exporter en Pdf\n                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("Pdf\n                        ")],1),_vm._v(" "),(true)?_c('el-popover',{attrs:{"placement":"top-start","title":"DETAILS SUR LES CALCULS DU MONTANT TOTAL ENGAGÉS","width":"500","trigger":"hover"}},[_c('el-table',{attrs:{"data":_vm.helpDemandeN}},[_c('el-table-column',{attrs:{"width":"600","property":"text","label":""}})],1),_vm._v(" "),(true)?_c('el-button',{staticStyle:{"font-size":"25px"},attrs:{"slot":"reference","icon":"el-icon-question","type":"text"},slot:"reference"}):_vm._e()],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listTravauxResult}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LISTE DES TACHES","align":"center","width":"350","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))]),_vm._v(" "),(scope.row.soutraite == 1)?_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("TACHE SOUS-TRAITE")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"PREVISIONNEL","align":"center","fixed":"","width":"210"}},[_c('el-table-column',{attrs:{"prop":"rmtGlobal","label":"RDMT TOTAL","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixBudget","label":"PRIX BUDGET","width":"110"}})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"REEL","align":"center"}},[(_vm.selectAnneeMonth == null)?_c('el-table-column',{attrs:{"label":"Rendements Reel","align":"center"}},[_c('el-table-column',{attrs:{"prop":"rdmt[1]","label":"Jan"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rdmt[2]","label":"Fev"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rdmt[3]","label":"Mar"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rdmt[4]","label":"Avr"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rdmt[5]","label":"Mai"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rdmt[6]","label":"Juin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rdmt[7]","label":"Juil"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rdmt[8]","label":"Aou"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rdmt[9]","label":"Sept"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rdmt[10]","label":"Oct"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rdmt[11]","label":"Nov"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rdmt[12]","label":"Dec"}})],1):_vm._e(),_vm._v(" "),(_vm.selectAnneeMonth != null && _vm.selectAnneeMonth != 'null')?_c('el-table-column',{attrs:{"label":"Rendements Reel","align":"center"}},[(_vm.selectAnneeMonth != null && _vm.selectAnneeMonth != 'null')?_c('el-table-column',{attrs:{"align":"center","prop":"rdmt[0]","label":"PERIODE SÉLECTIONNÉE"}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixRevient","label":"PRIX REVIENT XOF","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"warning"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.prixRevient))+" ")])]}}])})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ECART","align":"center"}},[(_vm.selectAnneeMonth == null)?_c('el-table-column',{attrs:{"label":"RDMT","align":"center"}},[_c('el-table-column',{attrs:{"prop":"ecarRdmt[1]","label":"Jan"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecarRdmt[2]","label":"Fev"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecarRdmt[3]","label":"Mar"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecarRdmt[4]","label":"Avr"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecarRdmt[5]","label":"Mai"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecarRdmt[6]","label":"Juin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecarRdmt[7]","label":"Juil"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecarRdmt[8]","label":"Aou"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecarRdmt[9]","label":"Sept"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecarRdmt[10]","label":"Oct"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecarRdmt[11]","label":"Nov"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecarRdmt[12]","label":"Dec"}})],1):_vm._e(),_vm._v(" "),(_vm.selectAnneeMonth != null && _vm.selectAnneeMonth != 'null')?_c('el-table-column',{attrs:{"label":"RDMT","align":"center"}},[(_vm.selectAnneeMonth != null && _vm.selectAnneeMonth != 'null')?_c('el-table-column',{attrs:{"align":"center","prop":"ecarRdmt[0]","label":"PERIODE SÉLECTIONNÉE"}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixEcartRevient","label":"PRIX REVIENT XOF","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"red"}},[_vm._v("\n                          "+_vm._s(new Intl.NumberFormat().format(scope.row.prixEcartRevient))+" \n                        ")])]}}])})],1)],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogueImprimer),callback:function ($$v) {_vm.dialogueImprimer=$$v},expression:"dialogueImprimer"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModePlan(2)}}},[_vm._v("\n              Paysage\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModePlan(1)}}},[_vm._v("\n              Portrait\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"blue",attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogueImprimer = false}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ad4g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_user_ModalAttribuerZone__ = __webpack_require__("iA41");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_user_ModalAttribuerEquipe__ = __webpack_require__("7mNl");



var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */], ModalAttribuerZone: __WEBPACK_IMPORTED_MODULE_3__components_user_ModalAttribuerZone__["a" /* default */], ModalAttribuerEquipe: __WEBPACK_IMPORTED_MODULE_4__components_user_ModalAttribuerEquipe__["a" /* default */] },
    name: "Responsable",
    data: function (_data) {
        function data() {
            return _data.apply(this, arguments);
        }

        data.toString = function () {
            return _data.toString();
        };

        return data;
    }(function () {
        var _ref;

        return _ref = {
            //data general
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,

            valid: true,
            items: [{ value: false, photo: '', nom: '', login: '', fonction: '', contact: '48867578', action: '' }],
            mdpUserConnect: '',
            idUser: "",
            itemUser: null,
            listService: [],
            listeEquipe: [],
            listeTechnicien: [],
            dialogSupr: false,
            listeDomaine: [],
            listeResponsable: [],
            dialogAjoutResponsable: false,
            disabledBtnTech: false,
            dialogEdit: false,
            menuSele: [],
            menu: [],
            roles: [],
            responsable: {},
            selectTypeUser: null,
            selectServiceUser: null,
            dialogRole: false,
            role: [],
            typeUser: [{ text: 'Responsable de zone', value: 4 }],
            mdpUser: '',
            mdpVerUser: ''
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mdpUserConnect', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'serviceUserRules', [function (v) {
            return !!v || 'Veuillez sélectionner votre service.';
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'loginUserRules', [function (v) {
            return !!v || 'Le E-mail est obligatoire';
        }, function (v) {
            return (/^\w+([.-]?\w+)*@\w+([-]?\w+)*(.\w{2,3})+$/.test(v) || 'Vous devez respecter format de E-mail'
            );
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'nomUserRules', [function (v) {
            return !!v || 'Le nom est obligatoire';
        }, function (v) {
            return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mdpUserRules', [function (v) {
            return !!v || 'Le mot de passe est obligatoire';
        }, function (v) {
            return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mdpVerUserRules', [function (v) {
            return !!v || 'La verification du mot de passe est obligatoire. Il doit être identique au mot de pas entré précédenment';
        }, function (v) {
            return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mdpUserConnectRules', [function (v) {
            return !!v || 'Votre mot de passe est obligatoire pour la confirmation';
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'contactUserRules', [function (v) {
            return !!v || "Le contact de l'utilisateur est obligatoire";
        }, function (v) {
            return (/[0-9]/.test(v) || 'Vous devez respecter format du contact'
            );
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showModalZone', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showModalEquipe', false), _ref;
        var generateData2 = function generateData2(_) {
            //const data = [];
            var states = ['California', 'Illinois', 'Maryland', 'Texas', 'Florida', 'Colorado', 'Connecticut '];
            var initials = ['CA', 'IL', 'MD', 'TX', 'FL', 'CO', 'CT'];
            states.forEach(function (city, index) {
                data.push({
                    label: city,
                    key: index,
                    initial: initials[index]
                });
            });
            return data;
        };
        return {
            data2: generateData2(),
            value2: [],
            filterMethod: function filterMethod(query, item) {
                return item.initial.toLowerCase().indexOf(query.toLowerCase()) > -1;
            }
        };
    }),


    methods: (_methods = {
        //Imprimer la liste
        imprimeListeTech: function imprimeListeTech(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + "userCreate/imprimerPDF/technicien/liste";
            } else {
                url = this.domaine + "userCreate/imprimerEXC/technicien/liste";
            }
            window.open(url);
        },
        showModalNewUser: function showModalNewUser() {
            this.dialogEdit = false;
            this.dialogAjoutResponsable = true; // afficher le modal ajout utilisateur
        },
        showModalEditUser: function showModalEditUser(editResponsable) {
            this.dialogEdit = true;
            this.responsable = editResponsable;
            this.dialogAjoutResponsable = true;
        },
        clear: function clear() {
            this.$refs.formUser.reset();
            this.dialogAjout = false;
        },
        loadTechnicien: function loadTechnicien() {
            var _this = this;

            var url = this.domaine + 'userCreate/index/{id}/technicien';
            if (this.droitAcces.index_user) {
                url = this.domaine + 'userCreate/index/technicien';
            }

            this.$http.get(url).then(function (response) {

                if (response.body) {
                    _this.listeTechnicien = response.body;
                    if (_this.listeTechnicien === undefined || _this.listeTechnicien.length == 0) {
                        _this.disabledBtnZone = true;
                    } else {}
                }
            });
        },
        loadDomaine: function loadDomaine() {
            var _this2 = this;

            var url = this.domaine + 'userCreate/index/domaine';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this2.listeDomaine = response.body[0].domaine;
                    if (_this2.listeDomaine === undefined || _this2.listeDomaine.length == 0) {
                        _this2.disabledBtnZone = true;
                    } else {}
                }
            });
        },
        deleteUser: function deleteUser() {
            var _this3 = this;

            var url = this.domaine + 'userCreate/delete/' + this.itemUser.id;
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    if (response.body.code === 1) {
                        _this3.$notify({
                            title: 'SUPPRESSION',
                            message: 'Utilisateur supprimé avec succès.',
                            type: 'success',
                            position: 'top-center'
                        });
                        _this3.dialogSupr = false;

                        _this3.loadTechnicien();
                    } else {
                        _this3.$notify.error({
                            title: 'SUPPRESSION ECHOUE',
                            message: 'La suppression du fournisseur a échoue.',
                            position: 'top-center'
                        });
                    }
                }
            });
        },
        newRole: function newRole(item) {
            this.responsable = item;
            this.dialogRole = true;
            this.role = item.roles;
            this.menuSele = item.menus;
        },
        submitUser: function submitUser() {
            var _this4 = this;

            if (this.$refs.formUser.validate()) {
                if (this.responsable.password === this.responsable.confirmePassword) {
                    var form = document.getElementById('formUser');
                    var formdata = new FormData(form);
                    var url = '';
                    if (this.responsable.id) {
                        url = this.domaine + 'userCreate/' + this.responsable.id + '/user/edit/technicien';
                        formdata.append('mdpUser', this.mdpUserConnect);
                    } else {
                        url = this.domaine + 'userCreate/new';
                    }
                    formdata.append('idUser', this.user.id);
                    formdata.append('serviceUser', this.responsable.serviceId);
                    formdata.append('nomUser', this.responsable.nom);
                    formdata.append('idDomaine', this.responsable.domaineId);
                    //formdata.append('idEquipe', this.responsable.equipeId)
                    formdata.append('loginUser', this.responsable.login);
                    formdata.append('emailUser', this.responsable.email);
                    formdata.append('contactUser', this.responsable.contact);
                    formdata.append('fonctionUser', this.responsable.fonction);
                    formdata.append('type', 5);
                    formdata.append('poste', '');
                    formdata.append('roleUser', this.role);

                    this.loading = true;
                    this.$http.post(url, formdata).then(function (response) {
                        _this4.loading = false;
                        _this4.dialogAjoutResponsable = false;
                        var verif = response.body;
                        if (_this4.responsable.id) {
                            if (verif.code === 1) {
                                _this4.$notify({
                                    title: "L'UTILISATEUR A BIEN ETE MODIFIE",
                                    message: 'Modification effectué avec succès.',
                                    type: 'success',
                                    position: 'top-center'
                                });
                            } else if (verif.code === 2) {
                                _this4.$message.error(verif.message);
                            } else if (verif.code === 3) {
                                _this4.$message.error(verif.message);
                            } else if (verif.code === 4) {
                                _this4.$message.error(verif.message);
                            } else if (verif.code === 5) {
                                _this4.$message.error(verif.message);
                            } else if (verif.code === 0) {
                                _this4.$message.error(verif.message);
                            }
                        } else {
                            if (verif.code === 1) {
                                _this4.$notify({
                                    title: "L'UTILISATEUR A BIEN ETE AJOUTE",
                                    message: 'Enrégistrement réussie avec succès.',
                                    type: 'success',
                                    position: 'top-center'
                                });
                            } else if (verif.code === 2) {
                                _this4.$message.error(verif.message);
                            } else if (verif.code === 3) {
                                _this4.$message.error(verif.message);
                            } else if (verif.code === 4) {
                                _this4.$message.error(verif.message);
                            } else if (verif.code === 5) {
                                _this4.$message.error(verif.message);
                            } else if (verif.code === 0) {
                                _this4.$message.error(verif.message);
                            }
                        }
                        _this4.loadTechnicien();
                    }, function (response) {
                        _this4.$message.error('Erreur serveur');
                        _this4.loading = false;
                    });
                } else {
                    this.$message.error('Le mot de passe de vérification doit être identique au mot de passe');
                }
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "Utilisateur n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        loadService: function loadService() {
            var _this5 = this;

            var url = this.domaine + 'webService/liste-service';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this5.listService = response.body.service;
                    _this5.menu = response.body.menu;
                    _this5.roles = response.body.role;
                }
            });
        },
        loadEquipe: function loadEquipe() {
            var _this6 = this;

            var url = this.domaine + 'userCreate/index/equipe';
            this.$http.get(url).then(function (response) {

                if (response.body) {
                    _this6.listeEquipe = response.body[0].equipe;
                    if (_this6.listeEquipe === undefined || _this6.listeEquipe.length == 0) {
                        _this6.disabledBtnZone = true;
                    } else {}
                }
            });
        },


        //attribuer zone
        modalZone: function modalZone(editResponsable) {
            this.responsable = editResponsable;
            this.showModalZone = true;
        }
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_methods, 'newRole', function newRole(item) {
        this.responsable = item;
        this.dialogRole = true;
        this.role = item.roles;
        this.menuSele = item.menus;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_methods, 'submitRole', function submitRole() {
        var _this7 = this;

        this.loading = true;
        if (this.$refs.formRole.validate()) {
            var form = document.getElementById('formRole');
            var data = new FormData(form);
            var url = this.domaine + 'userCreate/' + this.responsable.id + '/role/user';
            data.append('idUser', this.user.id);
            data.append('menuUser', this.menuSele);
            data.append('roleUser', this.role);

            this.$http.post(url, data).then(function (response) {
                if (response.body) {
                    var verif = response.body;
                    if (verif.code === 1) {
                        _this7.$notify({
                            title: "ENREGISTREMENT REUSSI",
                            message: 'Droits enrégistré avec succès.',
                            type: 'success',
                            position: 'top-center'
                        });
                    }

                    _this7.loading = false;
                    _this7.dialogRole = false;

                    _this7.loadResponsable();

                    _this7.$refs.formRole.reset();
                    var menu = verif.menu;
                    var droit = verif.role;
                    sessionStorage.setItem('sessionAcces', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(menu));
                    sessionStorage.setItem('sessionDroit', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(droit));
                    _this7.roleAcces = JSON.parse(sessionStorage.getItem('sessionAcces'));
                    _this7.droitAcces = JSON.parse(sessionStorage.getItem('sessionDroit'));
                } else {
                    _this7.$message.error('Erreur serveur');
                    _this7.loading = false;
                    _this7.dialogRole = false;
                }
            }, function (response) {
                _this7.$message.error('Erreur serveur');
                _this7.loading = false;
            });
        } else {
            this.$notify.error({
                title: "ERREUR D'ENREGISTREMENT",
                message: "Utilisateur n'a pas été enregistré.",
                position: 'top-center'
            });
            this.loading = false;
        }
    }), _methods),
    beforeMount: function beforeMount() {
        if (!this.roleAcces[this.$router.history.current.name]) {
            this.$router.push({ name: 'Home' });
        }
    },
    mounted: function mounted() {
        this.loadDomaine();
        this.loadService();
        this.loadTechnicien();
        this.loadEquipe();
    }
});

/*export default {
data() {
  }
};*/

/***/ }),

/***/ "adPx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v(_vm._s(item.text))])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.user.type == 1)?_c('v-layout',{staticClass:"text-xs-center",attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticStyle:{"width":"auto","height":"400px"},attrs:{"id":"demandeGblobal"}})]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticStyle:{"width":"auto","height":"400px"},attrs:{"id":"statusGbDemande"}})])],1):_c('v-layout',{staticClass:"text-xs-center",attrs:{"row":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.user.type == 1),expression:"user.type == 1"}],attrs:{"md6":""}},[_c('div',{staticStyle:{"width":"auto","height":"400px"},attrs:{"id":"demandeGblobal"}})]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"md12":""}},[_c('div',{staticStyle:{"width":"auto","height":"400px"},attrs:{"id":"statusGbDemande"}})])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":"","mr-4":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v("Informations")])],1),_vm._v(" "),_c('v-list',{attrs:{"subheader":"","two-line":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Noms et prénom(s)")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.infoRepresentant.nomRepresentant))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Fonction ou Profession")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.infoRepresentant.profession))])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Zone(s) Concernée(s)")]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.user.type == 1 && _vm.droitAcces.zone_create)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.modalAjoutZone()}},slot:"activator"},[_vm._v("\n                  Ajouter une nouvelle zone\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("playlist_add")])],1):_vm._e(),_vm._v("Ajouter une nouvelle zone\n              ")],1)],1)],1)],1),_vm._v(" "),_c('div',[_c('el-tree',{ref:"tree",staticClass:"filter-tree",attrs:{"data":_vm.zones,"default-expand-all":"","filter-node-method":_vm.filterNode,"node-key":"id","props":_vm.defaultProps},nativeOn:{"dblclick":function($event){return _vm.handleNodeClick($event)}}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md9":""}},[_c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h6',[_vm._v(_vm._s(_vm.legendeTab))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.user.type == 1)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-1",attrs:{"xs12":"","md10":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Bilan financier des interventions effectuées:")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.mntTTC)+" Fcfa")])])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"mb-2",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{attrs:{"color":"cyan","text-color":"white"}},[_c('v-avatar',{staticClass:"cyan darken-4"},[_vm._v(_vm._s(_vm.totalDmd))]),_vm._v("Demandes\n                  ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{attrs:{"color":"cyan","text-color":"white"}},[_c('v-avatar',{staticClass:"cyan darken-4"},[_vm._v(_vm._s(_vm.totalDmdCour))]),_vm._v("Demandes en cours\n                  ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{attrs:{"color":"cyan","text-color":"white"}},[_c('v-avatar',{staticClass:"cyan darken-4"},[_vm._v(_vm._s(_vm.totalDmdRetard))]),_vm._v("Demandes en retard\n                  ")],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-3 mt-1",attrs:{"row":""}},[(_vm.user.type != 2)?_c('v-flex',{staticClass:"mr-1",attrs:{"md3":""}},[_c('el-select',{attrs:{"clearable":"","placeholder":"Filtrer par etat"},on:{"clear":function($event){return _vm.clearSelect()},"change":_vm.filtrerEtatDmd},model:{value:(_vm.selectEtatDmd),callback:function ($$v) {_vm.selectEtatDmd=$$v},expression:"selectEtatDmd"}},_vm._l((_vm.comboEtatDmd),function(item){return _c('el-option',{key:item.etat,attrs:{"label":item.label,"value":item.etat}})}),1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-select',{attrs:{"clearable":"","placeholder":"Filtrer par status"},on:{"clear":function($event){return _vm.clearSelect()},"change":_vm.filtrerStatusDmd},model:{value:(_vm.selectStatusDmd),callback:function ($$v) {_vm.selectStatusDmd=$$v},expression:"selectStatusDmd"}},_vm._l((_vm.comboStatusDmd),function(item){return _c('el-option',{key:item.etat,attrs:{"label":item.label,"value":item.etat}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-select',{attrs:{"clearable":"","placeholder":"Demande en retard"},on:{"clear":function($event){return _vm.clearSelect()},"change":_vm.filtrerRetardDmd},model:{value:(_vm.selectRetardDmd),callback:function ($$v) {_vm.selectRetardDmd=$$v},expression:"selectRetardDmd"}},_vm._l((_vm.comboRetardDmd),function(item){return _c('el-option',{key:item.etat,attrs:{"label":item.label,"value":item.etat}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"Demande par zone"},on:{"clear":function($event){return _vm.clearSelect()},"change":_vm.filtrerZoneDmd},model:{value:(_vm.selectZoneDmd),callback:function ($$v) {_vm.selectZoneDmd=$$v},expression:"selectZoneDmd"}},_vm._l((_vm.comboZoneDmd),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.new_maintenance)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.modalAjoutDmd()}},slot:"activator"},[_vm._v("\n                    Ajouter une demande\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("playlist_add")])],1):_vm._e(),_vm._v("Ajouter une nouvelle demande\n                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.imprimer_liste_demande)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","disabled":_vm.disabledBtnMiss,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeDemandePDF()}},slot:"activator"},[_vm._v("\n                    Imprimer\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1):_vm._e(),_vm._v("Imprimer la liste des demandes\n                ")],1)],1),_vm._v(" "),_c('data-tables',{attrs:{"data":_vm.listeDemandes}},[_c('el-table-column',{attrs:{"prop":"date","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nomDemandeur","label":"Nom du demandeur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libStatut","label":"Statut"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.statut == 0)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 1)?_c('el-tag',[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 2)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"batiment","label":"Batiment"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"salle","label":"Salle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libPriorite","label":"Priorite"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 3)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.libPriorite))]):_vm._e(),_vm._v(" "),(scope.row.priorite == 0)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.libPriorite))]):_vm._e(),_vm._v(" "),(scope.row.priorite == 1)?_c('el-tag',[_vm._v(_vm._s(scope.row.libPriorite))]):_vm._e(),_vm._v(" "),(scope.row.priorite == 2)?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.libPriorite))]):_vm._e(),_vm._v(" "),(scope.row.priorite == 3)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.libPriorite))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailDmd(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("Detail de la demande\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etatDmd == 1 && _vm.droitAcces.edit_maintenance)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){return _vm.modalEditDmd(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("Editer\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.save_constat && scope.row.etatDmd == 2)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"teal"},on:{"click":function($event){return _vm.modalConstat(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("build")])],1):_vm._e(),_vm._v("Effectuer le constat\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[((_vm.droitAcces.validation_devis && scope.row.etatDmd == 3)  )?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.modalValidConstat(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("done_all")])],1):_vm._e(),_vm._v("Valider le devis du constat\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.attribuer_technicien_maintenance && scope.row.etatDmd == 5)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"yellow"},on:{"click":function($event){return _vm.modalplanification(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1):_vm._e(),_vm._v("Planifier l'intervention\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.save_constat && scope.row.etatDmd == 7)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"brown"},on:{"click":function($event){return _vm.modalRapportDepannage(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1):_vm._e(),_vm._v("Rapport de depannage\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.new_maintenance && _vm.droitAcces.avis_demande_representant && scope.row.etatDmd == 8)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue-grey"},on:{"click":function($event){return _vm.modalRapportSatisfaction(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1):_vm._e(),_vm._v("Donnez votre avis\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etatDmd == 1 && _vm.droitAcces.delete_demande_maintenance)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.itemDmd = scope.row;_vm.dialogSupr = true;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("Supprimer\n                    ")],1)]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("DEMANDE")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("DMD-"+_vm._s(_vm.itemDmd.idDemande))])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("\n            Annuler\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.deleteDmd()}}},[_vm._v("\n            Supprimer\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogSuppZone),callback:function ($$v) {_vm.dialogSuppZone=$$v},expression:"dialogSuppZone"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","description":"Veuillez vous assurer qu'aucune demande n'a été effectuée dans cette zone","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("ZONE")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v(_vm._s(_vm.dataZone.label))])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSuppZone = false}}},[_vm._v("\n          Annuler\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.deleteZone()}}},[_vm._v("\n          Supprimer\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-bottom-sheet',{model:{value:(_vm.dialogZoneEdit),callback:function ($$v) {_vm.dialogZoneEdit=$$v},expression:"dialogZoneEdit"}},[_c('v-list',[_c('v-subheader',[_vm._v(_vm._s(_vm.dataZone.label)+"/ Responsable de zone "+_vm._s(_vm.dataZone.responsable)+" / Representant de zone "+_vm._s(_vm.dataZone.representant))]),_vm._v(" "),(_vm.droitAcces.zone_add)?_c('v-list-tile',{on:{"click":function($event){return _vm.modalAjoutSousZone(_vm.dataZone)}}},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("add")])],1)],1)],1),_vm._v(" "),_c('v-list-tile-title',{on:{"click":function($event){return _vm.modalAjoutSousZone(_vm.dataZone)}}},[_vm._v("Ajouter une sous zone")])],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.zone_add)?_c('v-list-tile',{on:{"click":function($event){return _vm.modalEditZone(_vm.dataZone)}}},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("mode_edit")])],1)],1)],1),_vm._v(" "),_c('v-list-tile-title',{on:{"click":function($event){return _vm.editZone(_vm.dataZone)}}},[_vm._v("Modifier")])],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.zone_file_remove)?_c('v-list-tile',{on:{"click":function($event){return _vm.modalDeleteZone(_vm.dataZone)}}},[_c('v-list-tile-avatar',[_c('v-avatar',{attrs:{"size":"32px","tile":""}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("delete_forever")])],1)],1)],1),_vm._v(" "),_c('v-list-tile-title',{on:{"click":function($event){return _vm.modalDeleteZone(_vm.dataZone);}}},[_vm._v("Supprimer")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600","persistent":true,"transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogPlanification),callback:function ($$v) {_vm.dialogPlanification=$$v},expression:"dialogPlanification"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Planifier une intervention pour la demande DMD-"+_vm._s(_vm.demandeDetail.idDemande))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogPlanification = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formPlanning",staticClass:"demo-form-inline",attrs:{"id":"formPlanning","label-width":"90px","model":_vm.formPlanning,"rules":_vm.rulesformPlanning}},[_c('el-form-item',{attrs:{"label":"Techniciens","required":""}},[_c('el-col',{attrs:{"span":22}},[_c('el-form-item',{attrs:{"prop":"technicien"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","name":"technicien","placeholder":"Selectionner un technicien"},model:{value:(_vm.formPlanning.selectTech),callback:function ($$v) {_vm.$set(_vm.formPlanning, "selectTech", $$v)},expression:"formPlanning.selectTech"}},_vm._l((_vm.listeTechniciens),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Debut","required":""}},[_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"dateDbt"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","placeholder":"Choisir une date de debut","format":"dd-MM-yyyy"},model:{value:(_vm.formPlanning.dateDbt),callback:function ($$v) {_vm.$set(_vm.formPlanning, "dateDbt", $$v)},expression:"formPlanning.dateDbt"}})],1)],1),_vm._v(" "),_c('el-col',{staticClass:"line",attrs:{"span":2}},[_vm._v("-")]),_vm._v(" "),_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"hrDbt"}},[_c('el-time-picker',{staticStyle:{"width":"100%"},attrs:{"type":"fixed-time","placeholder":"Choisir une heure de debut"},model:{value:(_vm.formPlanning.hrDbt),callback:function ($$v) {_vm.$set(_vm.formPlanning, "hrDbt", $$v)},expression:"formPlanning.hrDbt"}})],1)],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Fin","required":""}},[_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"dateFin"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","placeholder":"Choisir une date de fin","format":"dd-MM-yyyy"},model:{value:(_vm.formPlanning.dateFin),callback:function ($$v) {_vm.$set(_vm.formPlanning, "dateFin", $$v)},expression:"formPlanning.dateFin"}})],1)],1),_vm._v(" "),_c('el-col',{staticClass:"line",attrs:{"span":2}},[_vm._v("-")]),_vm._v(" "),_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"hrFin"}},[_c('el-time-picker',{staticStyle:{"width":"100%"},attrs:{"type":"fixed-time","placeholder":"Choisir une heure de fin"},model:{value:(_vm.formPlanning.hrFin),callback:function ($$v) {_vm.$set(_vm.formPlanning, "hrFin", $$v)},expression:"formPlanning.hrFin"}})],1)],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){return _vm.resetForm('formPlanning')}}},[_vm._v("\n              Annuler\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitFormPlanning('formPlanning')}}},[_vm._v("\n              Enregistrer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('AjoutMaintenance',{attrs:{"editForm":_vm.editFormDmd,"demandeDetail":_vm.demandeDetail,"show":_vm.showModalAjoutDmd},on:{"close":function($event){_vm.showModalAjoutDmd = false;_vm.loadDemande()}}}),_vm._v(" "),_c('DetailMaintenance',{attrs:{"demandeDetail":_vm.demandeDetail,"show":_vm.showModalDetailDmd},on:{"close":function($event){_vm.showModalDetailDmd = false}}}),_vm._v(" "),_c('SelectionTechnicien',{attrs:{"listeTechniciens":_vm.listeTechniciens,"demandeDetail":_vm.demandeDetail,"show":_vm.showModalSelectTechnicien},on:{"close":function($event){_vm.showModalSelectTechnicien = false;_vm.loadDemande()}}}),_vm._v(" "),_c('ConstatMaintenance',{attrs:{"validConstat":_vm.validConstat,"demandeDetail":_vm.demandeDetail,"show":_vm.showModalConstat},on:{"close":function($event){_vm.showModalConstat = false, _vm.validConstat= false;_vm.loadDemande()}}}),_vm._v(" "),_c('RapportDepannage',{attrs:{"demandeDetail":_vm.demandeDetail,"show":_vm.showModalRapportDepannage},on:{"close":function($event){_vm.showModalRapportDepannage = false;_vm.loadDemande()}}}),_vm._v(" "),_c('RapportSatisfaction',{attrs:{"demandeDetail":_vm.demandeDetail,"show":_vm.showModalRapportSatisfaction},on:{"close":function($event){_vm.showModalRapportSatisfaction = false;_vm.loadDemande()}}}),_vm._v(" "),_c('AjoutZoneMaintenance',{attrs:{"editForm":_vm.editFormZone,"zoneDetail":_vm.zoneDetail,"show":_vm.showModalAjoutZone},on:{"close":function($event){_vm.showModalAjoutZone = false;_vm.loadInfoRepresentant();_vm.dialogZoneEdit = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aeEY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RapportDepannage_vue__ = __webpack_require__("dNS9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1513dfe9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RapportDepannage_vue__ = __webpack_require__("FIRw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RapportDepannage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1513dfe9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RapportDepannage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aeSe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_divers_formTypeProjet__ = __webpack_require__("l7SS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_divers_formNiveauTypeTravaux__ = __webpack_require__("OT9U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_divers_formTypeTravaux__ = __webpack_require__("NPGg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_divers_formdupplication_dupformTypeTravaux__ = __webpack_require__("YFcr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_divers_formdupplication_dupformTypeTache__ = __webpack_require__("Rb7m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_divers_formTypeTache__ = __webpack_require__("8pPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_divers_loadTypeproduit_vue__ = __webpack_require__("wthK");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Vb+l");










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */],
    formTypeProjet: __WEBPACK_IMPORTED_MODULE_3__components_divers_formTypeProjet__["a" /* default */],
    formTypeTravaux: __WEBPACK_IMPORTED_MODULE_5__components_divers_formTypeTravaux__["a" /* default */],
    formNiveauTypeTravaux: __WEBPACK_IMPORTED_MODULE_4__components_divers_formNiveauTypeTravaux__["a" /* default */],
    dupformTypeTravaux: __WEBPACK_IMPORTED_MODULE_6__components_divers_formdupplication_dupformTypeTravaux__["a" /* default */],
    dupformTypeTache: __WEBPACK_IMPORTED_MODULE_7__components_divers_formdupplication_dupformTypeTache__["a" /* default */],
    formTypeTache: __WEBPACK_IMPORTED_MODULE_8__components_divers_formTypeTache__["a" /* default */],
    LoadTypeProduitExcel: __WEBPACK_IMPORTED_MODULE_9__components_divers_loadTypeproduit_vue__["a" /* default */]
  },
  name: "app",
  data: function data() {
    var _ref;

    return _ref = {
      loading: false,
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      items: [{ path: "/besoin", text: "Accueil", disabled: false }, { path: "/plan-comptable", text: "Gestion du plan comptable", disabled: true }],
      rules: {
        code: [{
          required: true,
          message: "Veuillez  saisir un code",
          trigger: "blur"
        }],
        libelle: [{
          required: true,
          message: "Veuillez  saisir un libelle",
          trigger: "blur"
        }],
        description: [{
          required: false,
          message: "Veuillez  saisir une description",
          trigger: "blur"
        }]
      },
      formTypeProj: {
        id: "",
        libelle: "",
        description: ""
      },
      columns: [{
        prop: "libelle",
        label: "Libellé lot"
      }, {
        prop: "ordre",
        label: "Ordre d'éxécution"
      }, {
        prop: "code",
        label: "Code"
      }, {
        prop: "description",
        label: "Description"
      }],
      listeRapportTrx: {
        type: Array
      },

      taches: [{
        prop: "libelle",
        label: "Libellé tâche"
      }, {
        prop: "ordre",
        label: "Ordre d'éxécution"
      }, {
        prop: "unite",
        label: "Unité"
      }, {
        prop: "prix",
        label: "Prix unitaire HT (FCFA)"
      }, {
        prop: "description",
        label: "Description"
      }],
      tachesTypeProduit: [{
        prop: "codeGestion",
        label: "Code article"
      }, {
        prop: "codeAnalytique",
        label: "Code analytique"
      }, {
        prop: "referenceProduit",
        label: "Référence"
      }, {
        prop: "libelleProduit",
        label: "Libellé"
      }, {
        prop: "valeurProduit",
        label: "Prix de (vente ou d'utilisation)(Fcfa)"
      }, {
        prop: "libelleUnite",
        label: "Unité"
      }, {
        prop: "descProduit",
        label: "Description"
      }],

      valid: true,

      dialogAjoutTypeRessource: false,
      dialogAjoutTache: false,
      dialogAjoutTravaux: false,
      dialogDupliquerTravaux: false,
      dialogAjoutProduit: false,
      dialogAjoutCategory: false,
      dialogSuprCategorie: false,
      dialogSuprKeyword: false,
      dialogEdit: false,
      dialogMofifTravaux: false,
      dialogEditCategorie: false,
      dialogShowTypeProjet: false,
      dialogShowCategorie: false,
      dialogShowTache: false,
      dialogEditProduit: false,
      dialogShowProduit: false,

      dialogSuprLexique: false,
      dialogShowTravaux: false,
      idProduit: "",
      idCategorie: "",
      idLexique: "",
      libelleProduit: "",
      libelleUnite: "Pcs",
      descProduit: "",
      typeProduit: "",
      codeType: "",
      valeurProduit: 0,
      ordre: 1,
      dialogTarif: false,
      dialogConfirm: false,
      referenceProduit: "",
      libelleCategorie: "",
      descCategorie: "",
      currentCategorie: {},
      currentProduit: {},
      categorie: "",
      itemsTypeProjet: [],
      itemsTravaux: [],
      itemsProduit: [],
      itemsTypeProduit: [],
      itemsTaches: [],
      categorieEdit: "",
      listCategorie: [],
      tableLots: [],
      tableTaches: [],
      tableTypeProduit: [],
      listeType: [],
      listeChantier: [],
      tableLotsNEW: [],
      tab: 0,
      tab1: 0,
      listProduit: [],
      IdProduiSelect: "",
      selectSearchTypeProjet: "",
      selectSearchTypeRessource: "",
      selectSearchTravaux: "",
      selectSearchProduit: "",
      selectSearchTypeProduit: "",
      selectSearchTache: "",
      listLexique: [],
      selectTypeEntre: "",
      dialogSupTarif: "",
      listTypeProjet: [],
      listTypeRessource: [],

      typeProjetCourant: [],
      typeRessourceCourant: [],
      dialogShowTypeRessource: false,
      detailTypeProjet: [],
      formTache: {
        id: "",
        libelle: "",
        ordre: 1,
        unite: "",
        prix: 0,
        description: ""
      },
      formTypeProduit: {
        id: "",
        referenceProduit: "",
        codeAnalytique: "",
        libelleProduit: "",
        valeurProduit: "",
        libelleUnite: 0,
        descProduit: ""
      },
      listTache: [],
      tacheCourant: [],
      detailTache: [],
      dialogSuprTyp: false,
      dialogSuprLots: false,
      dialogSuprTache: false,
      dialogSuprProd: false,
      //FILTRE
      listeProjet: []
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeChantier", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "BesoinsList", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeProduitAffich", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "projetS", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "IdTypeSelct", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "chantierS", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "produitCourant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listTravaux", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "typeProjet", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "travaux", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listAllTravaux", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formTravaux", {
      id: "",
      libelle: "",
      ordre: "",
      code: "",
      description: ""
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "travauxCourant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeProduitFourn", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeCommandeFourn", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeStatistik", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeStokProd", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeStokEnlev", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "detailProjet", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showDialogTypeProjet", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showDialogTypeTrx", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "typeProjetSelect", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showDialogTypeRessource", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showDialogTypeNiveauTrx", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showDialogDupTypeProjet", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showDialogDupTypeTrx", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "typeDupProjetSelect", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listTypProjetTab", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "libelleSelect", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selecAnne", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "totalCommande", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "totalQteCommande", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeTache", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeTacheTravaux", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listTypProjetTabAll", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listPlanComptable", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "idTypeTravauxSelect", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "etatTache", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showDialogDupTypeTache", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "libelleTacheSelect", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "libelleChantier", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "codeGestion", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listcodeGestion", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "typeDescription", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "typeLibelle", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "typeCode", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "editedTypeRessource", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeTrx", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeProjetTravaux", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "idTypeProjetSelect", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "idNivTypeProjetSelect", null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeTache", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeTacheTravaux", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showDialogTypeTache", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "prixAchat", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectProduit", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectIdProduit", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "valeurUniteMateriel", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "tarifCourant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "showModalLoadTypeTravaux", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fileExcel", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "lstPlanComptable", []), _ref;
  },

  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      if (newValue == true) {
        //this.oldListTravaux = this.listeTrx;
      }
    }
  },
  methods: {
    statPrixFourn: function statPrixFourn(dataFactHistoFour) {
      var posList = ["left", "right", "top", "bottom", "inside", "insideTop", "insideLeft", "insideRight", "insideBottom", "insideTopLeft", "insideTopRight", "insideBottomLeft", "insideBottomRight"];

      app.configParameters = {
        rotate: {
          min: -90,
          max: 90
        },
        align: {
          options: {
            left: "left",
            center: "center",
            right: "right"
          }
        },
        verticalAlign: {
          options: {
            top: "top",
            middle: "middle",
            bottom: "bottom"
          }
        },
        position: {
          options: echarts.util.reduce(posList, function (map, pos) {
            map[pos] = pos;
            return map;
          }, {})
        },
        distance: {
          min: 0,
          max: 100
        }
      };

      app.config = {
        rotate: 90,
        align: "left",
        verticalAlign: "middle",
        position: "insideBottom",
        distance: 15,
        onChange: function onChange() {
          var labelOption = {
            normal: {
              rotate: app.config.rotate,
              align: app.config.align,
              verticalAlign: app.config.verticalAlign,
              position: app.config.position,
              distance: app.config.distance
            }
          };
          myChart.setOption({
            series: [{
              label: labelOption
            }, {
              label: labelOption
            }, {
              label: labelOption
            }]
          });
        }
      };

      var labelOption = {
        show: true,
        position: app.config.position,
        distance: app.config.distance,
        align: app.config.align,
        verticalAlign: app.config.verticalAlign,
        rotate: app.config.rotate,
        formatter: "{c}  {name|{a}}",
        fontSize: 16,
        rich: {
          name: {
            textBorderColor: "#fff"
          }
        }
      };

      var option = {
        color: ["#388E3C", "#F57C00", "#455A64", "#C62828"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {},
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: [{
          type: "category",
          axisTick: { show: false },
          data: []
        }],
        yAxis: [{
          type: "value"
        }],
        series: [{
          name: "Prix actuel",
          type: "bar",
          barGap: 0,
          label: labelOption,
          data: []
        }, {
          name: "Ancien prix",
          type: "bar",
          label: labelOption,
          data: []
        }]
      }; //option

      for (var datahis in dataFactHistoFour) {
        option.xAxis[0].data.push(datahis);
        var series = dataFactHistoFour[datahis];
        option.series[0].data.push(series["prix actuel"]);
        option.series[1].data.push(series["ancien prix"]);
      }

      var chartFactureAnFour = echarts.init(document.getElementById("chartFactureAnFour"));
      chartFactureAnFour.setOption(option);
    },
    statComRessour: function statComRessour(dataFactHistoFour) {
      var posList = ["left", "right", "top", "bottom", "inside", "insideTop", "insideLeft", "insideRight", "insideBottom", "insideTopLeft", "insideTopRight", "insideBottomLeft", "insideBottomRight"];

      app.configParameters = {
        rotate: {
          min: -90,
          max: 90
        },
        align: {
          options: {
            left: "left",
            center: "center",
            right: "right"
          }
        },
        verticalAlign: {
          options: {
            top: "top",
            middle: "middle",
            bottom: "bottom"
          }
        },
        position: {
          options: echarts.util.reduce(posList, function (map, pos) {
            map[pos] = pos;
            return map;
          }, {})
        },
        distance: {
          min: 0,
          max: 100
        }
      };

      app.config = {
        rotate: 90,
        align: "left",
        verticalAlign: "middle",
        position: "insideBottom",
        distance: 15,
        onChange: function onChange() {
          var labelOption = {
            normal: {
              rotate: app.config.rotate,
              align: app.config.align,
              verticalAlign: app.config.verticalAlign,
              position: app.config.position,
              distance: app.config.distance
            }
          };
          myChart.setOption({
            series: [{
              label: labelOption
            }, {
              label: labelOption
            }, {
              label: labelOption
            }]
          });
        }
      };

      var labelOption = {
        show: true,
        position: app.config.position,
        distance: app.config.distance,
        align: app.config.align,
        verticalAlign: app.config.verticalAlign,
        rotate: app.config.rotate,
        formatter: "{c}  {name|{a}}",
        fontSize: 16,
        rich: {
          name: {
            textBorderColor: "#fff"
          }
        }
      };

      var option = {
        color: ["#388E3C", "#F57C00", "#455A64", "#C62828"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {},
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: [{
          type: "category",
          axisTick: { show: false },
          data: []
        }],
        yAxis: [{
          type: "value"
        }],
        series: [{
          name: "Qte commandée",
          type: "bar",
          barGap: 0,
          label: labelOption,
          data: []
        }, {
          name: "Prix",
          type: "bar",
          label: labelOption,
          data: []
        }, {
          name: "Total TTC",
          type: "bar",
          label: labelOption,
          data: []
        }]
      }; //option

      for (var datahis in dataFactHistoFour) {
        option.xAxis[0].data.push(datahis);
        var series = dataFactHistoFour[datahis];
        option.series[0].data.push(series["Qte commandée"]);
        option.series[1].data.push(series["Prix"]);
        option.series[2].data.push(series["Total TTC"]);
      }

      var chartCommFour = echarts.init(document.getElementById("chartCommFour"));
      chartCommFour.setOption(option);
    },
    statEntrepot: function statEntrepot(dataFactHistoFour) {
      var posList = ["left", "right", "top", "bottom", "inside", "insideTop", "insideLeft", "insideRight", "insideBottom", "insideTopLeft", "insideTopRight", "insideBottomLeft", "insideBottomRight"];

      app.configParameters = {
        rotate: {
          min: -90,
          max: 90
        },
        align: {
          options: {
            left: "left",
            center: "center",
            right: "right"
          }
        },
        verticalAlign: {
          options: {
            top: "top",
            middle: "middle",
            bottom: "bottom"
          }
        },
        position: {
          options: echarts.util.reduce(posList, function (map, pos) {
            map[pos] = pos;
            return map;
          }, {})
        },
        distance: {
          min: 0,
          max: 100
        }
      };

      app.config = {
        rotate: 90,
        align: "left",
        verticalAlign: "middle",
        position: "insideBottom",
        distance: 15,
        onChange: function onChange() {
          var labelOption = {
            normal: {
              rotate: app.config.rotate,
              align: app.config.align,
              verticalAlign: app.config.verticalAlign,
              position: app.config.position,
              distance: app.config.distance
            }
          };
          myChart.setOption({
            series: [{
              label: labelOption
            }, {
              label: labelOption
            }, {
              label: labelOption
            }, {
              label: labelOption
            }]
          });
        }
      };

      var labelOption = {
        show: true,
        position: app.config.position,
        distance: app.config.distance,
        align: app.config.align,
        verticalAlign: app.config.verticalAlign,
        rotate: app.config.rotate,
        formatter: "{c}  {name|{a}}",
        fontSize: 16,
        rich: {
          name: {
            textBorderColor: "#fff"
          }
        }
      };

      var option = {
        color: ["#388E3C", "#F57C00", "#455A64", "#C62828"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {},
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: [{
          type: "category",
          axisTick: { show: false },
          data: []
        }],
        yAxis: [{
          type: "value"
        }],
        series: [{
          name: "appro",
          type: "bar",
          barGap: 0,
          label: labelOption,
          data: []
        }, {
          name: "stock",
          type: "bar",
          label: labelOption,
          data: []
        }, {
          name: "sortie",
          type: "bar",
          label: labelOption,
          data: []
        }, {
          name: "retour",
          type: "bar",
          label: labelOption,
          data: []
        }]
      }; //option

      for (var datahis in dataFactHistoFour) {
        option.xAxis[0].data.push(datahis);
        var series = dataFactHistoFour[datahis];
        option.series[0].data.push(series["appro"]);
        option.series[1].data.push(series["stock"]);
        option.series[2].data.push(series["sortie"]);
        option.series[3].data.push(series["retour"]);
      }

      var chartStockProd = echarts.init(document.getElementById("chartStockProd"));
      chartStockProd.setOption(option);
    },
    handleTabClick1: function handleTabClick1(onglet) {
      switch (onglet) {
        case "0":
          //TYPE PROJET
          this.loadTypeProjet();
          break;
        case "1":
          //TYPE LOT DE TRAVAUX
          this.loadTravauxParType();
          break;
        case "2":
          //TYPE LOT DE TACHE
          this.loadTacheParTypeTrx();
          break;
        case "3":
          //TYPE DE RESSOURCE
          this.loadTypeRessource();
          break;
        case "4":
          //TYPE DE PORDUIT
          this.loadProduit();
          break;
      }
    },
    TabClick: function TabClick(onglet) {
      switch (onglet) {
        case "0":
          //PRIX FOURNISSEUR
          this.loadProdFourn();
          break;
        case "1":
          //LISTE COMMANDE
          this.loadCommandFourn();
          break;
        case "2":
          //LISTE STOCK et ENLEVEMENT
          this.loadStockFourn();
          break;
        case "3":
          //LISTE STATISTIQUE
          var ladate = new Date();
          this.loadStatistique(ladate);
          break;
      }
    },
    loadProdFourn: function loadProdFourn() {
      var _this = this;

      var url = "";
      this.loading = true;
      url = this.domaine + "product/fournisseur/product-list/" + this.currentProduit.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this.loading = false;
          _this.listeProduitFourn = response.body.produit;
          _this.statPrixFourn(response.body.dataStat);
        }
      }, function (error) {
        _this.loading = false;
      });
    },
    loadCommandFourn: function loadCommandFourn() {
      var _this2 = this;

      var url = "";
      this.loading = true;
      url = this.domaine + "fournisseur/" + this.currentProduit.id + "/commande/liste";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this2.loading = false;
          _this2.listeCommandeFourn = response.body.commande;
          _this2.statComRessour(response.body.dataStat);
        }
      }, function (error) {
        _this2.loading = false;
      });
    },
    closeFormTypeTache: function closeFormTypeTache() {
      this.showDialogTypeTache = false;
      this.loadTacheParTypeTrx();
    },
    loadStatistique: function loadStatistique(anne) {
      var _this3 = this;

      var url = "";
      this.loading = true;
      url = this.domaine + "product/" + this.currentProduit.id + "/statistique/produit/" + anne.getFullYear();
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this3.loading = false;
          _this3.totalCommande = response.body.totalCommande;
          _this3.totalQteCommande = response.body.totalQteCommande;
          _this3.listeStatistik = response.body.dataProduit;
          _this3.statDepenseAn(_this3.listeStatistik);
        }
      }, function (error) {
        _this3.loading = false;
      });
    },
    loadPage: function loadPage() {
      var loading = this.$loading({
        lock: true,
        text: "Veuillez patientez ...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
      }, 1000);
    },
    filtrerTypeProjet: function filtrerTypeProjet() {
      var idType = this.selectSearchTypeProjet;
      var tableau = this.listTypeProjet;

      this.listTypeProjet = tableau.filter(function (item) {
        return item.id == idType;
      });
      if (idType == null || idType == "undefined" || idType == "") {
        this.loadTypeProjet();
        var _tableau = this.listTypeProjet;
        this.listTypeProjet = _tableau;
        return;
      }
    },
    filtrerTypeRessource: function filtrerTypeRessource() {
      var idType = this.selectSearchTypeRessource;
      var tableau = this.listTypeRessource;

      this.listTypeRessource = tableau.filter(function (item) {
        return item.id == idType;
      });
      if (idType == null || idType == "undefined" || idType == "") {
        this.loadTypeRessource();
        var _tableau2 = this.listTypeRessource;
        this.listTypeRessource = _tableau2;
        return;
      }
    },
    filtrerTravaux: function filtrerTravaux() {
      var idType = this.selectSearchTravaux;
      var tableau = this.listAllTravaux;

      this.listAllTravaux = tableau.filter(function (item) {
        return item.id == idType;
      });
      if (idType == null || idType == "undefined" || idType == "") {
        this.loadAllTravaux();
        var _tableau3 = this.listAllTravaux;
        this.listAllTravaux = _tableau3;
        return;
      }
    },
    filtrerTache: function filtrerTache() {
      var idType = this.selectSearchTache;
      var tableau = this.listTache;
      this.listTache = tableau.filter(function (item) {
        return item.idType == idType;
      });
    },
    SelectionTypePrdotuit: function SelectionTypePrdotuit(item) {
      var data = this.listTypeRessource.filter(function (row) {
        if (row.libelle == item) {
          return row.code;
        }
      });
      this.codeType = data[0].code;
    },
    filtrerTacheType: function filtrerTacheType() {
      var idType = this.selectSearchTache;
      var tableau = this.listTache;

      this.listTache = tableau.filter(function (item) {
        return item.id == idType;
      });
      if (idType == null || idType == "undefined" || idType == "") {
        this.loadTache();
        var _tableau4 = this.listTache;
        this.listTache = _tableau4;
        return;
      }
    },
    filtrerTypeProduit: function filtrerTypeProduit() {
      var idType = this.selectSearchTypeProduit;
      var tableau = this.listProduit;

      this.listProduit = tableau.filter(function (item) {
        return item.type == idType;
      });
      if (idType == null || idType == "undefined" || idType == "") {
        this.loadProduit();
        var _tableau5 = this.listProduit;
        this.listProduit = _tableau5;
        return;
      }
    },
    filtrerProduit: function filtrerProduit() {
      var idType = this.selectSearchProduit;
      var tableau = this.listProduit;

      this.listProduit = tableau.filter(function (item) {
        return item.id == idType;
      });
      if (idType == null || idType == "undefined" || idType == "") {
        this.loadProduit();
        var _tableau6 = this.listProduit;
        this.listProduit = _tableau6;
        return;
      }
    },
    filtrerChantier: function filtrerChantier() {
      var idChant = this.chantierS;
      this.listTache = this.listeRapportTrx.filter(function (item) {
        return item.idType == idChant;
      });
    },
    clearSelect: function clearSelect() {
      this.selectSearchTypeProjet = "";
      this.chantierS = "";
      this.projetS = "";
    },
    loadProduit: function loadProduit() {
      var _this4 = this;

      var url = "";
      this.loading = true;
      url = this.domaine + "product/product-list";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this4.loading = false;
          _this4.listProduit = response.body;
          _this4.listeProduitAffich = response.body;
          _this4.itemsProduit = response.body;
        }
      });
    },
    loadTypeProduit: function loadTypeProduit() {
      var _this5 = this;

      this.loading = true;
      if (this.IdTypeSelct != 0) {
        var url = this.domaine + "product/productSelect/type/" + this.IdTypeSelct;
        this.$http.get(url).then(function (response) {
          _this5.loading = false;
          _this5.listeProduitAffich = response.body.produits;
        }, function (errRep) {
          _this5.loading = false;
          _this5.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
        });
      } else {
        this.loadProduit();
        this.loading = false;
      }
    },
    loadLexique: function loadLexique() {
      var _this6 = this;

      var url = this.domaine + "keyword/lexique-list/" + this.currentProduit.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this6.listLexique = response.body;
        }
      });
    },
    loadPlan: function loadPlan() {
      var _this7 = this;

      // this.getLoadSearch()
      var url = "";
      this.loading = true;
      url = this.domaine + "planComptable/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this7.loading = false;
          _this7.listPlanComptable = response.body.listPlan;
        }
      });
    },
    loadTypePrjt: function loadTypePrjt() {
      var _this8 = this;

      var url = "";
      url = this.domaine + "projet/list/type/projet/vide";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this8.listTypProjetTab = response.body.type;

          //contient tous les types travaux qui ont des lot
          _this8.listTypProjetTabAll = response.body.typeAll;
        }
      });
    },
    editTarif: function editTarif(ligne) {
      this.dialogTarif = true;
      this.tarifCourant = ligne;
      this.selectProduit = ligne.libelle;
      this.selectIdProduit = ligne.idprod;
      this.prixAchat = ligne.prixAchat;
      this.valeurUniteMateriel = ligne.unite;
    },
    loadTravaux: function loadTravaux() {
      var _this9 = this;

      this.loading = true;
      this.travaux = "";
      this.listTravaux = [];
      if (this.typeProjet !== "") {
        var url = this.domaine + "product/" + this.typeProjet + "/type/projet/index/travaux";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this9.listTravaux = response.body.travaux;
            _this9.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un projet");
        this.loading = false;
      }
    },
    loadTravauxBytype: function loadTravauxBytype() {
      var _this10 = this;

      if (this.projetS == null || this.projetS == "undefined" || this.projetS == "") {
        this.listTache = this.listeRapportTrx;
        return;
      }
      this.loading = true;
      var url = "";
      url = this.domaine + "product/projet/travaux/" + this.projetS + "/index";

      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this10.listeChantier = response.body.travaux;
          _this10.loading = false;
        }
      });
    },
    loadAllTravaux: function loadAllTravaux() {
      var _this11 = this;

      this.loading = true;
      var url = "";
      if (this.droitAcces.all_travaux_projet) {
        url = this.domaine + "product/projet/travaux/index";
      } else {
        url = this.domaine + "product/projet/" + this.user.id + "/travaux/index";
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this11.listAllTravaux = response.body.travaux;
          _this11.itemsTravaux = response.body.travaux;
          _this11.loading = false;
        }
      });
    },
    loadTravauxParType: function loadTravauxParType() {
      var _this12 = this;

      this.loading = true;
      setTimeout(function () {
        _this12.listeProjetTravaux.splice(0);
        var url = _this12.domaine + "projet/liste/typeTravaux";
        _this12.$http.get(url).then(function (response) {
          _this12.listeProjetTravaux = response.body.listeProjetTravaux;
          _this12.loading = false;
        }, function (error) {
          _this12.loading = false;
          _this12.$message.error("Erreur lors du chargement des travaux ");
        });
      }, 2000);
    },
    loadTacheParTypeTrx: function loadTacheParTypeTrx() {
      var _this13 = this;

      this.loading = true;
      setTimeout(function () {
        var url = _this13.domaine + "projet/liste/typeTache";
        _this13.$http.get(url).then(function (response) {
          _this13.listeTacheTravaux = response.body.listeProjetTravauxTache;
          _this13.loading = false;
        }, function (error) {
          _this13.loading = false;
          _this13.$message.error("Erreur lors du chargement des taches ");
        });
      }, 2000);
    },
    deleteTache: function deleteTache(position, rows) {
      var tableau = [];
      rows.splice(position, 1);
      this.tableLotsNEW = this.tableTaches;
      this.tableTaches = [];

      for (var index = 0; index < this.tableLotsNEW.length; index++) {
        var tab = [];
        this.tab = {
          id: index + 1,
          libelle: this.tableLotsNEW[index]["libelle"],
          ordre: index + 1,
          unite: this.tableLotsNEW[index]["unite"],
          prix: this.tableLotsNEW[index]["prix"],
          description: this.tableLotsNEW[index]["description"]
        };
        this.tableTaches.push(this.tab);
      }

      var input = document.getElementById("ordreTache");
      this.formTache = {
        ordre: this.tableTaches.length == 0 ? 1 : this.tableTaches.length + 1
      };
    },
    deleteTypeProduit: function deleteTypeProduit(position, rows) {
      rows.splice(position, 1);
    },
    deleteTarif: function deleteTarif(ligne) {
      this.dialogSupTarif = true;
      this.tarifCourant = ligne;
      this.selectProduit = ligne.libelle;
    },
    deleteTarification: function deleteTarification() {
      var _this14 = this;

      this.loading = true;
      var url = "";
      var idTarif = this.tarifCourant["id"];
      url = this.domaine + "fournisseur/delete/" + idTarif + "/tarif";
      this.$http.get(url).then(function (response) {
        if (response.body.code == 2) {
          _this14.dialogSupTarif = false;
          _this14.loading = false;
          _this14.$notify({
            title: "SUPPRESSION REUSSI",
            message: "Tarification supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          _this14.loadProdFourn();
        } else {
          _this14.loading = false;
          _this14.$message.error("Impossible de supprimer la tarification de ce produit car il est déja utilisé dans une commande");
        }
      }, function (error) {
        // this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
        _this14.$message.error("Impossible de supprimer la tarification de ce produit, il est lié à une commande.");
        _this14.loading = false;
      });
    },
    deleteRow: function deleteRow(position, rows) {
      var tableau = [];
      rows.splice(position, 1);
      this.tableLotsNEW = this.tableLots;
      this.tableLots = [];

      for (var index = 0; index < this.tableLotsNEW.length; index++) {
        var tab = [];
        this.tab = {
          id: index + 1,
          libelle: this.tableLotsNEW[index]["libelle"],
          code: this.tableLotsNEW[index]["code"],
          ordre: index + 1,
          description: this.tableLotsNEW[index]["description"]
        };
        this.tableLots.push(this.tab);
      }
      var input = document.getElementById("ordre");
      this.formTravaux = {
        ordre: this.tableLots.length == 0 ? 1 : this.tableLots.length + 1
      };
    },
    loadTypeRessource: function loadTypeRessource() {
      var _this15 = this;

      this.listcodeGestion = [];
      var url = this.domaine + "product/typeRessource";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this15.listTypeRessource = response.body.types;
          _this15.loading = false;
        }
      });
    },
    submitType: function submitType() {
      var _this16 = this;

      this.loading = true;
      var data = new FormData();
      data.append("libelle", this.typeLibelle);
      data.append("code", this.typeCode);
      data.append("idUser", this.user.id);
      var url = this.domaine + "planComptable/edit";
      this.$http.post(url, data).then(function (response) {
        _this16.loading = false;
        _this16.dialogMofifTravaux = false;
        if (response.body.code == 3) {
          _this16.$message.error(response.body.message);
          return;
        }
        _this16.$notify({
          title: "MODIFICATION REUSSI",
          message: "Type de travaux enregistré avec succès.",
          type: "success",
          position: "top-center"
        });
        _this16.loadTravauxParType();
      });
    },
    submitTarif: function submitTarif() {
      var _this17 = this;

      this.loading = true;
      var form = document.getElementById("formTarif");
      var data = new FormData(form);
      var url = "";
      var idTarif = this.tarifCourant["id"];
      url = this.domaine + "fournisseur/new/" + idTarif + "/tarif";
      data.append("produit", this.selectProduit);
      data.append("selectIdProduit", this.selectIdProduit);
      data.append("idUser", this.user.id);
      this.tableTarification = [];
      data.append("tarif", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableTarification));
      this.$http.post(url, data).then(function (response) {
        if (response.body) {
          var verif = response.body;
          if (verif.code === 1) {
            _this17.$notify({
              title: "ENREGISTREMENT REUSSI",
              message: "Tarification enregistré avec succès.",
              type: "success",
              position: "top-center"
            });
          }
          _this17.loadProdFourn();
          _this17.dialogTarif = false;
          _this17.dialogConfirm = false;
          _this17.loading = false;
        } else {
          _this17.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this17.loading = false;
          _this17.dialogAppro = false;
        }
      }, function (response) {
        _this17.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
        _this17.loading = false;
      });
    },
    closeType: function closeType() {
      this.dialogAjoutTypeRessource = false;
    },
    editType: function editType(item) {
      this.typeLibelle = item.libelle;
      this.typeCode = item.code;
      this.editedType = item;
      this.dialogMofifTravaux = true;
    },
    editTypeRessource: function editTypeRessource(item) {
      this.typeLibelle = item.libelle;
      this.typeCode = item.code;
      this.typeDescription = item.description;
      this.editedTypeRessource = item;
      this.dialogShowTypeRessource = false;
      this.dialogAjoutTypeRessource = true;
    },
    editTache: function editTache(item) {
      this.tacheCourant = item;
      this.dialogAjoutTache = true;
      this.dialogEdit = true;
      this.formTache.id = this.tacheCourant.id;
      this.formTache.ordre = this.tacheCourant.ordre;
      this.formTache.libelle = this.tacheCourant.libelle;
      this.formTache.unite = this.tacheCourant.unite;
      this.formTache.prix = this.tacheCourant.prix;

      this.typeProjet = this.tacheCourant.idTypeP;
      this.formTache.description = this.tacheCourant.description;
      this.loadTravaux();
      this.travaux = this.tacheCourant.idType;
    },
    editTravaux: function editTravaux(item) {
      this.dialogAjoutTravaux = true;
      this.dialogEdit = true;
      this.travauxCourant = item;
      this.typeProjet = item.idType;
      this.formTravaux.id = item.id;
      this.formTravaux.libelle = item.libelle;
      this.formTravaux.ordre = item.ordre;
      this.formTravaux.description = item.description;
      this.formTravaux.code = item.code;
    },
    editProduit: function editProduit(item) {
      this.produitCourant = item;
      this.dialogAjoutProduit = true;
      this.dialogEditProduit = true;
      this.idProduit = item.id;
      this.referenceProduit = item.reference;
      this.libelleProduit = item.value;
      this.libelleUnite = item.unite;
      this.typeProduit = item.type;
      this.valeurProduit = item.valeur;
      this.descProduit = item.description;
      this.codeGestion = item.codeGestion;

      this.formTypeProduit.valeurProduit = item.valeur;
      this.formTypeProduit.descProduit = item.description;
      this.formTypeProduit.referenceProduit = item.reference;
      this.formTypeProduit.codeAnalytique = item.codeAnalytique;
      this.formTypeProduit.libelleProduit = item.value;
      this.formTypeProduit.libelleUnite = item.unite;
    },
    editCategorie: function editCategorie(item) {
      this.dialogAjoutCategory = true;
      this.dialogEditCategorie = true;
      this.idCategorie = item.id;
      this.libelleCategorie = item.libelle;
      this.descCategorie = item.description;
    },
    showTravaux: function showTravaux(item) {
      this.dialogShowTravaux = true;
      this.travauxCourant = item;
    },
    addProduit: function addProduit() {
      var _this18 = this;

      this.loading = true;
      var form = document.getElementById("formProduit");
      var data = new FormData();

      var url = "";
      if (this.produitCourant.id) {
        url = this.domaine + "product/" + this.produitCourant.id + "/edit/product";
      } else {
        url = this.domaine + "product/create-product";
      }

      if (this.formTypeProduit.libelleProduit != "", this.typeProduit != "") {
        data.append("codeGestion", this.formTypeProduit.codeGestion);
        data.append("codeAnalytique", this.formTypeProduit.codeAnalytique);
        data.append("referenceProduit", this.formTypeProduit.referenceProduit);
        data.append("libelleProduit", this.formTypeProduit.libelleProduit);
        data.append("libelleUnite", this.formTypeProduit.libelleUnite);
        data.append("valeurProduit", this.formTypeProduit.valeurProduit);
        data.append("descProduit", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formTypeProduit.descProduit));
        data.append("type", this.typeProduit);
        data.append("id", this.produitCourant.id);
        data.append("typePorduit", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableTypeProduit));
        data.append("idUser", this.user.id);

        this.$http.post(url, data).then(function (response) {
          _this18.loading = false;
          var verif = response.body;
          _this18.dialogShowProduit = false;
          if (verif.code == 3) {
            _this18.$alert(verif.message, "Modification libelle ressource", {
              confirmButtonText: "OK"
            });
            return;
          }
          _this18.dialogAjoutProduit = false;
          if (verif[0].code === 2) {
            _this18.$notify({
              title: "ENREGISTREMENT PRODUIT",
              message: verif.message,
              type: "success",
              position: "top-center"
            });
          }
          if (verif[0].code === 1) {
            _this18.$notify({
              title: "MODIFICATION PRODUIT",
              message: verif.message,
              type: "success",
              position: "top-center"
            });
          }
          _this18.loading = false;
          _this18.$refs.formProduit.reset();
          _this18.resitFOrmProduit();
          _this18.referenceProduit = "";
          _this18.tableTypeProduit = [];
          _this18.loadProduit();
        }, function (response) {
          _this18.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this18.loading = false;
        });
      } else if (this.tableTypeProduit.length > 0) {
        data.append("type", this.typeProduit);
        data.append("id", this.produitCourant.id);
        data.append("typePorduit", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableTypeProduit));

        this.$http.post(url, data).then(function (response) {
          _this18.loading = false;
          _this18.dialogShowProduit = false;
          var verif = response.body;
          if (verif[0].code === 3) {
            _this18.dialogAjoutProduit = true;
            _this18.$message.error(verif[0].message);
            _this18.libelleProduit = "";
          }
          _this18.dialogAjoutProduit = false;
          if (verif[0].code === 2) {
            _this18.$notify({
              title: "ENREGISTREMENT PRODUIT",
              message: verif.message,
              type: "success",
              position: "top-center"
            });
            _this18.$refs.formProduit.reset();
            _this18.resitFOrmProduit();
            _this18.referenceProduit = "";
            _this18.tableTypeProduit = [];
            _this18.loadProduit();
          }
          if (verif[0].code === 1) {
            _this18.$notify({
              title: "MODIFICATION PRODUIT",
              message: verif.message,
              type: "success",
              position: "top-center"
            });

            _this18.$refs.formProduit.reset();
            _this18.resitFOrmProduit();
            _this18.referenceProduit = "";
            _this18.tableTypeProduit = [];
            _this18.loadProduit();
          }
        });
      } else {
        this.$message.error("Veuillez compléter le formulaire correctement!");
        this.loading = false;
      }
      // }
    },
    addListTaches: function addListTaches(item) {
      var input = document.getElementById("ordreTache");

      if (item.ordre == undefined || item.ordre == "") {
        this.tableTaches.push({
          libelle: item.libelle,
          ordre: input.value,
          unite: item.unite,
          prix: item.prix,
          description: item.description
        });
      } else {
        this.tableTaches.push({
          libelle: item.libelle,
          ordre: this.tableTaches.length + 1,
          unite: item.unite,
          prix: item.prix,
          description: item.description
        });
      }
      this.formTache = {
        ordre: this.tableTaches.length + 1
      };
    },
    resitFOrmProduit: function resitFOrmProduit() {
      this.formTypeProduit.referenceProduit = "";
      this.formTypeProduit.valeurProduit = "";
      this.formTypeProduit.descProduit = "";
      this.formTypeProduit.libelleUnite = "";
      this.formTypeProduit.codeAnalytique = "";
      this.formTypeProduit.libelleProduit = "";
    },
    addListProduit: function addListProduit(item) {
      this.tableTypeProduit.push({
        codeGestion: this.codeGestion,
        codeAnalytique: item.codeAnalytique,
        referenceProduit: item.referenceProduit,
        libelleProduit: item.libelleProduit,
        valeurProduit: item.valeurProduit,
        libelleUnite: item.libelleUnite,
        descProduit: item.descProduit
      });
      this.formTypeProduit.referenceProduit = "";
      this.formTypeProduit.codeAnalytique = "";
      this.codeGestion = "";
      this.formTypeProduit.valeurProduit = "";
      this.formTypeProduit.descProduit = "";
      this.formTypeProduit.libelleUnite = "";
      this.formTypeProduit.libelleProduit = "";
    },
    addListParticipantDemande: function addListParticipantDemande(item) {
      var input = document.getElementById("ordre");

      if (item.ordre == undefined || item.ordre == "") {
        this.tableLots.push({
          id: item.code++,
          libelle: item.libelle,
          code: item.code,
          ordre: input.value,
          description: item.description
        });
      } else {
        this.tableLots.push({
          id: this.tableLots.length + 1,
          libelle: item.libelle,
          code: item.code,
          ordre: this.tableLots.length + 1,
          description: item.description
        });
      }
      this.formTravaux = {
        ordre: this.tableLots.length + 1
      };
    },
    addCategorie: function addCategorie() {
      var _this19 = this;

      if (this.$refs.formCategorie.validate()) {
        var form = document.getElementById("formCategorie");
        var data = new FormData(form);
        var url = "";
        if (this.idCategorie) {
          url = this.domaine + "keyword/update-familly/" + this.idCategorie;
        } else {
          url = this.domaine + "keyword/create-familly";
        }
        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 2) {
              if (_this19.idCategorie) {
                _this19.$notify({
                  title: "MODIFICATION REUSSI",
                  message: "Catégorie enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
              } else {
                _this19.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Catégorie enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
              }
              _this19.dialogAjoutCategory = false;
            } else if (verif.code === 1) {
              _this19.dialogAjoutCategory = true;
              _this19.$message.error(verif.message);
            }
          } else {
            _this19.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this19.loading = false;
          }
        }, function (response) {
          _this19.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this19.loading = false;
        });
      }
    },
    generateFileExcel: function generateFileExcel() {
      var url = this.domaine + "projet/generer/modele/produits";
      window.open(url);
    },
    onFileExcelPicked: function onFileExcelPicked(event) {
      var _this20 = this;

      this.fileExcel.splice(0, 1);
      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this20.fileExcel.push(fileReader.result);
      });
      fileReader.readAsDataURL(files[0]);
      var url = this.domaine + "plan-comptable/load/excel";
      var data = new FormData();
      console.log('fichierSelect', files[0]);

      data.append("fichierExcel", files[0], files[0][name]);
      this.$http.post(url, data).then(function (resp) {
        _this20.loading = false;

        _this20.$notify({
          title: "Chargement liste du plan comptable",
          message: "Chargement effectué",
          type: "success",
          position: "top-right",
          duration: 7000
        });
        _this20.lstPlanComptable = resp.body.listeTypeTravaux;
        _this20.showModalLoadTypeTravaux = true;
      }, function (resp) {
        _this20.loading = false;
        _this20.$message.error("Erreur lors de l'importation du fichier");
      });
    },
    filtrerEtatPrioriteBesoin: function filtrerEtatPrioriteBesoin() {
      var _this21 = this;

      this.listeProduitAffich = this.listeProduitAffich.filter(function (element) {
        _this21.loading = false;
        return element.value == _this21.IdProduiSelect;
      });
    },
    submitTache: function submitTache() {
      var _this22 = this;

      this.loading = true;
      if (this.$refs.formTache.validate() && this.travaux != "" && this.formTache.libelle != "" && this.formTache.ordre != 0) {
        var form = document.getElementById("formTache");
        var data = new FormData(form);
        var url = "";
        if (this.tacheCourant.id) {
          url = this.domaine + "projet/" + this.tacheCourant.id + "/edit/tache/projet";
        } else {
          url = this.domaine + "projet/new/tache/projet";
        }

        data.append("id", this.formTache.id);
        data.append("travaux", this.travaux);
        data.append("idUser", this.user.id);
        data.append("tache", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableTaches));
        data.append("formTache", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formTache));

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 3) {
              // this.dialogAjoutTache = true
              _this22.$message.error(verif.message);
              // this.libelleProduit =""
            }
            if (verif.code === 1) {
              _this22.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Tâche enregistré avec succès.",
                type: "success",
                position: "top-center"
              });
              _this22.loading = false;
              _this22.dialogAjoutTache = false;
              _this22.tableTaches = [];
              _this22.formTache = {};
              _this22.loadTypeProjet();
              _this22.loadTache();
            } else {
              _this22.$message.error(verif.message);
              _this22.loading = false;
            }
          } else {
            _this22.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this22.loading = false;
          }
        }, function (response) {
          _this22.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this22.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La tâche n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    closeShowProdui: function closeShowProdui() {
      this.dialogShowProduit = false;
      this.handleTabClick1(4);
    },
    submitTravaux: function submitTravaux() {
      var _this23 = this;

      this.loading = true;
      if (this.$refs.formTravaux.validate() && this.tableLots != [] && this.typeProjet != "") {
        var form = document.getElementById("formTravaux");
        var data = new FormData(form);
        var url = "";
        if (this.travauxCourant.id) {
          url = this.domaine + "projet/" + this.travauxCourant.id + "/edit/travaux/projet";
        } else {
          url = this.domaine + "projet/new/travaux/projet";
        }
        data.append("formTravaux", this.formTravaux);
        data.append("id", this.formTravaux.id);
        data.append("type", this.typeProjet);
        data.append("idUser", this.user.id);
        data.append("lots", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableLots));
        data.append("formTravaux", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formTravaux));

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code == 3) {
              _this23.loading = false;
              _this23.$message.error(verif.message);
            }
            if (verif.code == 1) {
              _this23.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Lot enregistré avec succès.",
                type: "success",
                position: "top-center"
              });

              _this23.loading = false;
              _this23.dialogAjoutTravaux = false;
              //this.loadAllTravaux()
            } else {
              _this23.loading = false;
              _this23.$message.error(verif.message);
            }
          } else {
            _this23.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this23.loading = false;
          }
        }, function (response) {
          _this23.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this23.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le type travaux n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    removeKeyword: function removeKeyword(item) {
      this.dialogSuprKeyword = true;
      this.idProduit = item.id;
    },
    removeLexique: function removeLexique(item) {
      this.dialogSuprLexique = true;
      this.idLexique = item.id;
    },
    removeCategorie: function removeCategorie(item) {
      this.dialogSuprCategorie = true;
      this.idCategorie = item.id;
    },
    deleteType: function deleteType() {
      var _this24 = this;

      this.loading = true;
      var url = this.domaine + "projet/" + this.idAppro + "/delete/type";
      this.$http.get(url).then(function (response) {
        _this24.loading = false;
        if (response.body.code == 3) {
          _this24.$alert(response.body.message, "Suppresion type Chantier", {
            confirmButtonText: "OK"
          });
          _this24.dialogSuprTyp = false;
          return;
        }

        if (response.body) {
          var verif = response.body;
          if (verif.code === 1) {
            _this24.$notify({
              title: "SUPPRESSION",
              message: "Enregistrement supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
          } else if (verif.code === 2) {
            _this24.$notify({
              title: "SUPPRESSION",
              message: verif.message,
              type: "warning",
              position: "top-center"
            });
          }
          _this24.dialogSuprTyp = false;
          _this24.loadTypeProjet();
        }
      });
    },
    clearSelectProduit: function clearSelectProduit() {
      this.loadProduit();
    },
    deleteLots: function deleteLots() {
      var _this25 = this;

      var url = this.domaine + "projet/" + this.idAppro + "/lot/delete";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          var verif = response.body;
          if (verif.code === 1) {
            _this25.$notify({
              title: "SUPPRESSION",
              message: "e supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
          } else if (verif.code === 2) {
            _this25.$notify({
              title: "SUPPRESSION",
              message: verif.message,
              type: "warning",
              position: "top-center"
            });
          }
          _this25.dialogSuprLots = false;
          //this.loadAllTravaux()
        }
      });
    },
    deleteTaches: function deleteTaches() {
      var _this26 = this;

      var url = this.domaine + "projet/" + this.idAppro + "/delete/tache/projet";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          var verif = response.body;
          if (verif.code === 1) {
            _this26.$notify({
              title: "SUPPRESSION",
              message: "Tache supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
          } else if (verif.code === 2) {
            _this26.$notify({
              title: "SUPPRESSION",
              message: verif.message,
              type: "warning",
              position: "top-center"
            });
          }
          _this26.dialogSuprTache = false;
          _this26.loadTypeProjet();
          _this26.loadTache();
        }
      });
    },
    deleteTypeProd: function deleteTypeProd() {
      var _this27 = this;

      this.loading = true;
      var url = this.domaine + "product/delete-product/" + this.idAppro;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          var verif = response.body;
          if (verif.code === 1) {
            _this27.loading = false;
            _this27.$notify({
              title: "SUPPRESSION",
              message: "Approvisionnement supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
          } else if (verif.code === 2) {
            _this27.loading = false;
            _this27.$notify({
              title: "SUPPRESSION",
              message: verif.message,
              type: "warning",
              position: "top-center"
            });
          }
          _this27.loading = false;
          _this27.dialogSuprProd = false;
        }
        _this27.loading = false;
        _this27.dialogSuprProd = false;
        _this27.dialogSuprAppro = false;
        _this27.loadProduit();
      });
    }
  },
  mounted: function mounted() {
    this.loadPlan();
  }
});

/***/ }),

/***/ "aibs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//liste l'ensemble  des besoins  ou les besoinsa valider par un responsable

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "besoinResponsable",
  props: {
    show: {
      type: Boolean
    },
    typeReche: {
      type: String
    },
    idresponsable: {
      type: Number,
      default: null
    },
    listeTrx: {
      type: Array
    },
    listeBesoins: {
      type: Array
    },
    listeChantiers: {
      type: Array
    },
    idProjet: {
      type: Number
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      dialogValideBesoin: false,
      multipleSelection: [],
      //FILTRE
      listeProjet: [],
      listeChantier: [],
      listeTravaux: [],
      listeTaches: [],
      travauxS: "",
      tachesS: "",
      BesoinsList: [],
      projetS: "",
      valide: false,
      chantierS: "",
      listeBesoinSelect: [],
      disabledBtnValide: true,
      commDec: null
    };
  },

  watch: {
    show: function show(newValue, oldvalue) {
      if (newValue == true) {
        //this.oldListTravaux = this.listeTrx;
      }
    },
    listeBesoins: function listeBesoins(newValue, oldvalue) {
      this.BesoinsList = this.listeBesoins;
      this.listeChantier = this.listeChantiers;
    }
  },
  methods: {
    //FILTRE
    loadProjet: function loadProjet() {
      var _this = this;

      this.chantierS = "";
      this.listeChantier.splice(0);
      this.chantierS = null;
      var url = this.domaine + "projet/index/projet/all";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this.loading = false;
        _this.listeProjet = response.body.projet;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    loadTravaux: function loadTravaux() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "projet/" + this.idProjet + "/all/travaux";
      this.$http.get(url).then(function (response) {
        _this2.loading = false;
        _this2.listeChantier = response.body.chantier;
      }, function (errRep) {
        _this2.loading = false;
        _this2.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    filtrerChantier: function filtrerChantier() {
      var idChant = this.chantierS;
      if (idChant == null || idChant == "undefined" || idChant == "") {
        this.BesoinsList = this.listeBesoins;
        // this.filtrerChantier()
        return;
      }
      this.BesoinsList = this.listeBesoins.filter(function (item) {
        return item.idChant == idChant;
      });
      var tableau = this.listeBesoins.filter(function (item) {
        return item.idChant == idChant;
      });
      for (var i = 0; i < tableau.length; ++i) {
        for (var j = i + 1; j < tableau.length; ++j) {
          if (tableau[i].idTravaux === tableau[j].idTravaux) {
            tableau.splice(j--, 1);
          }
        }
      }

      this.listeTravaux = tableau;
    },
    calculTotalComm: function calculTotalComm(item) {
      this.valide = false;
      var restant = item.qte - item.qteC;
      if (restant < item.qteR) {
        this.valide = true;
        this.$message.error("La quantité demandé ne dois pas etre supérieur a la quantité prévu ");
      }
    },
    filtrerTravaux: function filtrerTravaux() {
      var travauxS = this.travauxS;
      this.listeTaches = [];
      if (travauxS != "") {
        this.BesoinsList = this.listeBesoins;
      }
      if (travauxS == null || travauxS == "undefined" || travauxS == "") {
        this.BesoinsList = this.listeBesoins;
        // this.filtrerChantier()
        return;
      }

      var tab = this.BesoinsList;
      this.BesoinsList = tab.filter(function (item) {
        return item.idTravaux == travauxS;
      });

      var tableau = tab.filter(function (item) {
        return item.idTravaux == travauxS;
      });
      for (var i = 0; i < tableau.length; ++i) {
        for (var j = i + 1; j < tableau.length; ++j) {
          if (tableau[i].idTache === tableau[j].idTache) {
            tableau.splice(j--, 1);
          }
        }
      }
      this.listeTaches = tableau;
    },
    filtrerTaches: function filtrerTaches() {
      var idTache = this.tachesS;
      if (idTache == null || idTache == "undefined" || idTache == "") {
        //  this.BesoinsList = this.listeBesoins;
        this.filtrerTravaux();
        this.filtrerChantier();
        return;
      }
      this.filtrerChantier();
      var tab = this.BesoinsList;
      this.BesoinsList = tab.filter(function (item) {
        return item.idTache == idTache;
      });
    },
    modalValideBesoin: function modalValideBesoin() {
      this.listeBesoinSelect = this.multipleSelection.slice();
      this.dialogValideBesoin = true;
    },
    imprimeAllBesoins: function imprimeAllBesoins(item) {
      var url = this.domaine + "projet/impression/all/besoins/" + this.user.id + "/" + this.idProjet;
      window.open(url);
    },
    validRejetBesoin: function validRejetBesoin(decision) {
      var _this3 = this;

      if (this.valide == true) {
        this.$notify({
          title: "ENREGISTREMENT ECHOUE",
          message: "QUANTITE RENSSEIGNEE SUPERIEUR A LA QUANTITE PREVU.",
          type: "warning",
          position: "top-center"
        });
        return;
      }
      this.loading = true;

      //decision == 1 = Valider // decision == 0 //Refuser
      var url = this.domaine + "besoin/avalider";
      var nbData = 10;
      var nbReq = 1;
      var ligne = null;
      var nbRest = void 0;
      if (this.listeBesoinSelect.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.listeBesoinSelect.length / nbData);
        nbRest = this.listeBesoinSelect.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (var i = 0; i < nbReq; i++) {
        var initJ = i * nbData;
        var finJ = (i + 1) * nbData;
        var dataLot = [];
        if (this.listeBesoinSelect.length > 0) {
          for (var j = initJ; j < finJ; j++) {
            if (this.listeBesoinSelect[j] == undefined) {
              break;
            }
            dataLot.push(this.listeBesoinSelect[j]);
          }
        }
        var data = new FormData();
        for (var prop in dataLot) {
          ligne = dataLot[prop];
          data.append("option[id][]", ligne.id);
          data.append("option[dateLivrSouh][]", ligne.dateLivrSouh);
          data.append("option[qteR][]", ligne.qteR);
        }
        data.append("decision", decision);
        data.append("commDec", this.commDec);
        data.append("type", this.typeReche);
        data.append("idUser", this.user.id);

        this.$http.post(url, data).then(function (resp) {
          _this3.dialogValideBesoin = false;
          _this3.loading = false;
          _this3.$emit("reloadBesoins");
          _this3.$notify({
            title: "Validation besoins",
            message: "L'opération s'est déroulée avec succès",
            type: "success",
            position: "top-center"
          });
        }, function (error) {
          _this3.dialogValideBesoin = false;
          _this3.loading = false;
          _this3.$message.error("Erreur lors du chargement de la validation des besoins");
        });
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.disabledBtnValide = true;
      } else {
        this.disabledBtnValide = false;
      }
    },
    headerRowStyle: function headerRowStyle(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return { color: "black" };
    }
  },
  computed: {
    verifDateSouh: function verifDateSouh() {
      var resutat = true;
      for (var prop in this.listeBesoinSelect) {
        var ligne = this.listeBesoinSelect[prop];

        if (ligne["dateLivrSouh"] == null || ligne["dateLivrSouh"] == undefined) {
          resutat = false;
          break;
        }
      }

      return resutat;
    },
    clearSelectTache: function clearSelectTache() {
      // this.tachesS = ''
      this.filtrerTravaux();
    },
    clearSelectTravaux: function clearSelectTravaux() {
      // this.travauxS = ''
      this.filtrerChantier();
    },
    clearSelectChantier: function clearSelectChantier() {
      this.chantierS = "";
      this.loadProjet();
    },

    verifBtnConfirme: function verifBtnConfirme() {
      if (this.verifDateSouh == true && this.commDec != null && this.commDec.toUpperCase() == "BON POUR ACCORD") {
        return true;
      }
      return false;
    },

    verifBtnRefus: function verifBtnRefus() {
      if (this.commDec != null) {
        return true;
      }
      return false;
    }
  },
  mounted: function mounted() {
    this.chantierS = "";
    // this.loadProjet();
    // this.loadChantier();
    // this.clearSelect();
  }
});

/***/ }),

/***/ "b0Nn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b3Hs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AjoutReglementCarte__ = __webpack_require__("cgcM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */], AjoutReglementCarte: __WEBPACK_IMPORTED_MODULE_0__AjoutReglementCarte__["a" /* default */] },
  name: "ReglementCarteIndex",
  props: {
    show: {
      type: Boolean,
      required: true
    },
    carte: {
      type: Object
      //required: true
    }
  },
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      // racourcis: [
      //     { path: '/', text: 'Accueil', disabled: false },
      //     { path: '/demandeFond', text: 'Demande de fonds', disabled: true }
      // ],

      reglements: [],
      oldReglements: [],
      dialogSupr: false,
      dialogReglementCarte: false,
      selectRgt: "",
      editRgt: {},
      idRgt: null,

      showModalAjoutRgt: false,
      nbRgt: 0,
      mntTotal: 0
    };
  },


  watch: {
    show: function show(newValue, oldValue) {
      this.dialogReglementCarte = newValue;
      if (newValue == true) {
        this.loadReglement();
      }
    }
  },

  methods: {
    deleteRgt: function deleteRgt(rgt) {
      this.idRgt = rgt.id;
      this.dialogSupr = true;
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    modalAjoutRgt: function modalAjoutRgt() {
      this.editRgt = {};
      this.showModalAjoutRgt = true;
    },
    modalEditRgt: function modalEditRgt(reglement) {
      this.editRgt = reglement;
      this.showModalAjoutRgt = true;
    },
    imprimeRgtPDF: function imprimeRgtPDF() {
      var tab = [];
      this.reglements.forEach(function (reglement) {
        tab.push(reglement.id);
      });

      var url = this.domaine + "carteCarburant/reglement/imprimerPDF/liste/" + tab;
      window.open(url);
    },


    // deleteDmd ()
    // {
    //       this.loading = true

    //         let url = this.domaine + 'demandeFond/delete/' + this.itemDmd.id
    //         this.$http.get(url).then(response => {
    //              this.loading = false

    //             this.$notify({
    //                 title: 'SUPPRESSION',
    //                 message: 'Demande supprimée avec succès.',
    //                 type: 'success',
    //                 position: 'top-center'
    //             })
    //             this.dialogSupr = false

    //             this.loadDemande ()
    //             }, errRep => {
    //                    this.loading = false
    //                    this.dialogSupr = false
    //                 this.$notify.error({
    //                 title: 'SUPPRESSION ECHOUEE',
    //                 message: 'La suppression de la demande a échouée.',
    //                 position: 'top-center'
    //             })
    //             })
    // },

    clearSelect: function clearSelect() {
      this.reglements = this.oldReglements;
    },
    filtrerRgt: function filtrerRgt(idRgt) {},
    loadReglement: function loadReglement() {
      var _this = this;

      //this.loading = true;

      //afficher que les carte que l'utilisateur a creer
      //if(this.droitAcces.liste_demande_fond)

      var url = this.domaine + "carteCarburant/reglement/carte/" + this.carte.carteId;

      this.$http.get(url).then(function (response) {
        //this.loading = false;
        // this.mntTTC =  response.body.mntTTC
        _this.reglements = response.body.reglements;
        _this.oldReglements = response.body.reglements;
        _this.nbRgt = _this.reglements.length;

        _this.mntTotal = response.body.montantTotalFormat;
        //affichage nombre de demande
        if (response.body.reglements > 0) {
          _this.nbRgt = _this.reglements.length;
        }
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors du chargement de la liste des règlements");
      });
    }
  },

  mounted: function mounted() {
    //this.loadReglement();
  }
});

/***/ }),

/***/ "b6Bl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_demandeFond_AjoutDemandeFond__ = __webpack_require__("4p9V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_validationDG_ModalValidationDmdFond__ = __webpack_require__("DUFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_3__components_Loading__["a" /* default */], AjoutDemandeFond: __WEBPACK_IMPORTED_MODULE_1__components_demandeFond_AjoutDemandeFond__["a" /* default */], ModalValidationDmdFond: __WEBPACK_IMPORTED_MODULE_2__components_validationDG_ModalValidationDmdFond__["a" /* default */] },
  name: "DemandeFondIndex",
  data: function data() {
    var _ref;

    return _ref = {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [{ path: "/", text: "Accueil", disabled: false }, { path: "/demandeFond", text: "Demande de fonds", disabled: true }],

      listeDemandes: [],
      oldListDemandes: [],
      legendeDmd: "",
      selectCaisseDmd: "",
      listeCaisse: [],
      selectEtatDmd: "",
      listeStatut: [],
      showModalDetailDmdFond: false
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "listeStatut", [{
      label: "refusé",
      value: 0
    }, {
      label: "en attente de validation par le DG",
      value: 1
    }, {
      label: "paiement en attente",
      value: 2
    }, {
      label: "paiement effectué",
      value: 3
    }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "showModalAjoutDmd", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dmdDetail", {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "editFormDmd", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "demandeDetailFond", {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "dialogSupr", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "itemDmd", {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "mntTotal", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "totalDmd", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "searchListeDmd", ""), _ref;
  },


  methods: {
    imprimeDemandePDF: function imprimeDemandePDF() {
      var tab = [];
      this.listeDemandes.forEach(function (demande) {
        tab.push(demande.id);
      });

      var url = this.domaine + "demandeFond/imprimerPDF/liste/" + tab;
      window.open(url);
    },
    loadCaisse: function loadCaisse() {
      var _this = this;

      var url = this.domaine + "caisse/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this.listeCaisse = response.body.caisse;
        }
      });
    },
    deleteDmd: function deleteDmd() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "demandeFond/delete/" + this.itemDmd.id;
      this.$http.get(url).then(function (response) {
        _this2.loading = false;

        _this2.$notify({
          title: "SUPPRESSION",
          message: "Demande supprimée avec succès.",
          type: "success",
          position: "top-center"
        });
        _this2.dialogSupr = false;

        _this2.loadDemande();
      }, function (errRep) {
        _this2.loading = false;
        _this2.dialogSupr = false;
        _this2.$notify.error({
          title: "SUPPRESSION ECHOUEE",
          message: "La suppression de la demande a échouée.",
          position: "top-center"
        });
      });
    },
    modalAjoutDmd: function modalAjoutDmd() {
      // this.loadCaisse()
      this.editFormDmd = false;
      this.showModalAjoutDmd = true;
    },
    modalEditDmd: function modalEditDmd(item) {
      this.editFormDmd = true;
      this.dmdDetail = item;
      this.showModalAjoutDmd = true;
    },
    clearSelect: function clearSelect() {
      this.listeDemandes = this.oldListDemandes;
      this.legendeDmd = "LISTE DES DEMANDES DE FONDS";
    },
    filtrerCaisseDmd: function filtrerCaisseDmd(idCaisse) {
      this.loadDmdParCaisse(idCaisse);
    },
    filtrerEtatDmd: function filtrerEtatDmd(idEtat) {
      this.loadDmdParEtat(idEtat);
    },
    loadDmdParEtat: function loadDmdParEtat(idEtat) {
      this.listeDemandes = this.oldListDemandes;
      this.selectCaisseDmd = null;
      this.listeDemandes = this.listeDemandes.filter(function (item) {
        return item.statut == idEtat;
      });
    },
    loadDmdParCaisse: function loadDmdParCaisse(idCaisse) {
      this.listeDemandes = this.oldListDemandes;
      this.selectEtatDmd = null;
      this.listeDemandes = this.listeDemandes.filter(function (item) {
        return item.idCaisse == idCaisse;
      });
    },
    loadDemande: function loadDemande() {
      var _this3 = this;

      this.loading = true;
      var url = "";
      if (this.droitAcces.liste_demande_fond) {
        url = this.domaine + "demandeFond/index";
      } else {
        url = this.domaine + "demandeFond/index/fond/" + this.user.id;
      }

      this.$http.get(url).then(function (response) {
        _this3.loading = false;
        _this3.listeDemandes = response.body.listeDemandes;
        _this3.oldListDemandes = response.body.listeDemandes;
        _this3.mntTotal = response.body.montantTotal;
        //affichage nombre de demande
        _this3.totalDmd = _this3.listeDemandes.length;
        var totalDmdCour = _this3.listeDemandes.filter(function (element) {
          return element.statut == 1;
        });
        _this3.totalDmdCour = totalDmdCour.length;
      }, function (response) {
        _this3.loading = false;
        _this3.$message.error("Une erreur est survenue lors du chargement des demandes de fonds");
      });
    },
    showDialogDmdFondAfter: function showDialogDmdFondAfter(idDmd, type) {
      this.showModalDetailDmdFond = false;
    },
    modalImpDmd: function modalImpDmd(item) {
      this.demandeDetailFond = item;
      this.showModalDetailDmdFond = true;
    }
  },

  mounted: function mounted() {
    this.loadDemande();
    this.loadCaisse();
  }
});

/***/ }),

/***/ "bAC1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',{staticClass:"pl-3 pr-3 pt-3  pb-3",attrs:{"tile":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"green darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.dataNbFactFour.paye))]),_vm._v(" "),_c('div',[_vm._v("Facture(s) soldée(s)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("Montant déjà versé")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataMntFactFour.paye)))])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"orange darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.dataNbFactFour.cours))]),_vm._v(" "),_c('div',[_vm._v("Facture(s) en cours")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataNbFactFour.aValider)))]),_vm._v(" "),_c('div',[_vm._v("Facture(s) à valider ")])])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_vm._v(" Montant déjà versé")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataMntFactFour.coursPaye)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_vm._v("Montant restant")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataMntFactFour.cours)))])])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"blue-grey darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.dataNbFactFour.attente))]),_vm._v(" "),_c('div',[_vm._v("Facture(s) en attente de paiement")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("Montant restant")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataMntFactFour.attente)))])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"red darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.dataNbFactFour.impaye))]),_vm._v(" "),_c('div',[_vm._v("Facture(s) impayée(s)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("Montant restant")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataMntFactFour.impaye)))])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-2":"","mb-3":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"sm12":""}},[_c('v-card',{staticClass:"elevation-5",staticStyle:{"height":"550px"}},[_c('h4',[_vm._v("Statistiques de l'etat des factures de l'année en cours ")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-1"}),_vm._v(" "),_c('div',{staticClass:"mb-2",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"chartFactureAnFour"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"sm6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-layout',{staticClass:"elevation-3 pt-2 pl-2 pr-2 pb-2 grey lighten-4",attrs:{"row":""}},[_c('v-flex',{attrs:{"sm8":""}},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"chartCommandeFour"}},[_vm._v("\n                                    diagramme pie de commande\n                                ")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm4":""}},[_c('v-layout',{staticClass:"pt-2 pl-2 pr-2 pb-2",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"teal lighten-1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_vm._v("Commande(s) livrée(s)")]),_vm._v(" "),_c('div',{staticClass:"display-2"},[_vm._v(_vm._s(_vm.nbLivraisonFour))])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm12":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"deep-orange lighten-1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_vm._v("Commande(s) effectuée(s)")]),_vm._v(" "),_c('div',{staticClass:"display-2"},[_vm._v(_vm._s(_vm.nbCommandeFour))])])],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-1",attrs:{"sm6":""}},[_c('div',{staticClass:"elevation-3 pt-2 pl-2 pr-2 pb-2 grey lighten-4",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"chartFactureFour"}},[_vm._v("\n                    diagramme pie defacture\n                ")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bHbr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_besoin_besoinResponsable__ = __webpack_require__("dZfz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_besoin_listeBciResponsable__ = __webpack_require__("zWQ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_besoin_besoinCarburantResponsable__ = __webpack_require__("OaQp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_rapport_ListeRapportTrx__ = __webpack_require__("chSw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_rapport_ListeReserve__ = __webpack_require__("cz/F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_worklogs_ListeWorklogPorjet__ = __webpack_require__("TKxh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_boardProjet_widgetProjet__ = __webpack_require__("DXMj");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */],
    besoinCarburantResponsable: __WEBPACK_IMPORTED_MODULE_3__components_besoin_besoinCarburantResponsable__["a" /* default */],
    listeBciResponsable: __WEBPACK_IMPORTED_MODULE_2__components_besoin_listeBciResponsable__["a" /* default */],
    besoinResponsable: __WEBPACK_IMPORTED_MODULE_1__components_besoin_besoinResponsable__["a" /* default */],
    ListeWorklogPorjet: __WEBPACK_IMPORTED_MODULE_6__components_worklogs_ListeWorklogPorjet__["a" /* default */],
    ListeRapportTrx: __WEBPACK_IMPORTED_MODULE_4__components_rapport_ListeRapportTrx__["a" /* default */],
    ListeReserve: __WEBPACK_IMPORTED_MODULE_5__components_rapport_ListeReserve__["a" /* default */],
    WidgetProjet: __WEBPACK_IMPORTED_MODULE_7__components_boardProjet_widgetProjet__["a" /* default */]
  },
  name: "DashboardOngletPrj",
  props: {
    show: {
      type: Boolean
    },
    detailProjet: {
      type: Object
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      dialogDashboardProjet: false,
      loading: false,
      onglet: "0",

      //ONGLET CHANTIERS
      chantiers: [],

      //ONGLET besoins
      besoins: [],

      // liste des carburation
      besoinsCarbur: [],

      //ONGLET RAPPORS
      listeRapports: [],
      loadFenetre: false,
      rapportPerso: false,
      IddetailTravaux: "",

      //ONGLET RESERVE
      listeReserves: [],

      //ONGLET WORKLOG
      listeWorktrx: [],
      listtache: [],
      totalHeuretrx: [],
      totalmintrx: [],
      totalActivite: []
    };
  },

  methods: {
    //ONGLET CHANTIER
    loadChantier: function loadChantier() {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "chantier/liste/" + this.detailProjet.id + "/projet";
      this.$http.get(url).then(function (response) {
        _this.chantiers = response.body.chantier;
        _this.loading = false;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Echec lors du chargement des chantiers");
      });
    },
    loadBesoinAvalider: function loadBesoinAvalider() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "besoin/projet/" + this.detailProjet.id;
      var data = {
        type: "autre"
      };
      this.$http.get(url, { params: data }).then(function (response) {
        console.log('dhdd', response.body);
        _this2.besoins = response.body.besoins;

        console.log('dhddddd', _this2.besoins);

        _this2.loading = false;
      });
    },
    loadBesoinCarburAvalider: function loadBesoinCarburAvalider() {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + "besoin/projet/" + this.detailProjet.id + "";
      var data = {
        type: "carburant"
      };
      this.$http.get(url, { params: data }).then(function (response) {
        _this3.besoinsCarbur = response.body.besoins;
        _this3.loading = false;
      });
    },
    handleTabClick: function handleTabClick(tab) {
      switch (tab) {
        case "0" || 0:
          this.loadBesoinAvalider();
          this.loadChantier();
          break;
        // case "1" || 1:
        //   this.loadBesoinAvalider();
        //   this.loadChantier();
        //   break;
        case "1" || 1:
          this.loadBesoinCarburAvalider();
          break;
        case "2" || 2:
          this.loadRapportProjet();
          break;
        case "3" || 3:
          this.loadReserves();
          break;

        case "4" || 4:
          this.loadWorklogs(this.detailProjet.id);
          break;
        default:
          break;
      }
    },

    //onglet rapports
    loadRapportProjet: function loadRapportProjet() {
      var _this4 = this;

      this.loading = true;
      var url = this.domaine + "journal/projet/" + this.detailProjet.id;
      this.$http.get(url).then(function (response) {
        _this4.listeRapports = response.body.journaux;
        _this4.loading = false;
        _this4.loadFenetre = true;
        //on affecte lid du chantier pour pouvoir retrouver tous les travaux
        // this.IddetailTravaux = this.detailProjet.id;
      }, function (error) {
        _this4.loading = false;
        _this4.$message.error("Echec lors du chargement des Journaux");
      });
    },

    //ONGLET WORKLOG
    loadWorklogs: function loadWorklogs(idProjet) {
      var _this5 = this;

      this.loading = true;
      var url = this.domaine + "worklogs/projet/" + this.detailProjet.id;
      this.$http.get(url).then(function (response) {
        _this5.listeWorktrx = response.body.listeWorklog;
        _this5.totalHeuretrx = response.body.totalheure;
        _this5.totalmintrx = response.body.totalMinutes;
        _this5.totalActivite = response.body.totalActivite;
        _this5.listtache = response.body.listTacheeWorklog;
        _this5.loading = false;
      }, function (error) {
        _this5.loading = false;
        _this5.$message.error("Echec lors du chargement des worklogs");
      });
    },


    //ONGLET RESERVE
    loadReserves: function loadReserves() {
      var _this6 = this;

      this.loading = true;
      var url = this.domaine + "reserve/projet/" + this.detailProjet.id;
      this.$http.get(url).then(function (response) {
        _this6.listeReserves = response.body.reserves;
        _this6.loading = false;
      }, function (error) {
        _this6.loading = false;
        _this6.$message.error("Echec lors du chargement des reserves");
      });
    },
    closeDialog: function closeDialog() {
      this.besoins.splice(0);
      this.chantiers.splice(0);
      this.$emit("close");
    }
  },

  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogDashboardProjet = newValue;
      if (newValue == true) {
        this.onglet = "0";
        this.loadChantier();
        this.loadReserves();
        this.loadBesoinAvalider();
        this.loadRapportProjet();
      }
    }
  }
});

/***/ }),

/***/ "bHrj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      valid: true,
      routes: []
    };
  },

  methods: {
    load: function load() {
      this.routes = this.$router.options.routes;
    }
  },
  mounted: function mounted() {
    this.load();
  }
});

/***/ }),

/***/ "bJnJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTES DES RESERVES TRAVAUX")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-4 mt-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner de Projet"},on:{"clear":function($event){return _vm.clearSelect()},"change":function($event){return _vm.loadChantier()}},model:{value:(_vm.projetS),callback:function ($$v) {_vm.projetS=$$v},expression:"projetS"}},_vm._l((_vm.listeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-4 mt-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner un etat"},on:{"clear":function($event){return _vm.clearSelect()},"change":function($event){return _vm.filtrerEtat()}},model:{value:(_vm.etatRes),callback:function ($$v) {_vm.etatRes=$$v},expression:"etatRes"}},_vm._l((_vm.listeEtatReserve),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.libelle,"value":item.value}})}),1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"offset-xs6":"","xs2":""}},[_c('v-btn',{attrs:{"outline":"","fab":"","small":"","color":"indigo"},on:{"click":function($event){return _vm.$emit('reloadListeReserve')}}},[_c('v-icon',[_vm._v("cached")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"99%"},attrs:{"data":_vm.listeReserves},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('h2',{staticClass:"mb-2"},[_vm._v("Commentaires:")]),_vm._v(" "),_vm._l((scope.row.commentaires),function(com,i){return _c('div',{key:i,staticClass:"mb-2"},[_c('h3',[_vm._v("Initiateur: "+_vm._s(com.initiateur))]),_vm._v(" "),_c('h4',[_vm._v("Date: "+_vm._s(com.dateCom))]),_vm._v(" "),_c('h4',[_vm._v("Description:")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(com.description))])])})],2)]),_vm._v(" "),_c('el-col',{attrs:{"span":14}},[_c('h2',{staticClass:"mb-2"},[_vm._v("Photos:")]),_vm._v(" "),_c('p',_vm._l((scope.row.photos),function(photo,index){return _c('span',{key:index},[_c('v-avatar',{staticClass:"mr-2",attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":photo,"alt":"avatar"}})])],1)}),0)])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idReserve","label":"RESERVE","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("R-"+_vm._s(scope.row.idReserve))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libTache","label":"TACHE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libEtatRes","label":"ETAT"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"initiateur","label":"INITIATEUR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"validateur","label":"VALIDATEUR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cout","label":"MONTANT"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dureeRetard","label":"DUREE RETARD (J)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[(_vm.type== 0 && scope.row.etatReserve == 0)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){_vm.reserveSelect = scope.row;_vm.idReserve = scope.row.idReserve; _vm.resetForm('formFinTrx') ;_vm.dialogValidReserve = true}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1):_vm._e(),_vm._v("Confirmer\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[( _vm.type != 0 &&  scope.row.etatReserve == 1)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){_vm.dialogValidChefProjetReserve = true; _vm.idReserve = scope.row.idReserve}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Valider les travaux de reserve(Chef projet)")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[( _vm.type != 0 &&  scope.row.etatReserve == 1)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){_vm.dialogRefusReserve = true;_vm.idReserve = scope.row.idReserve; _vm.reserveSelect = scope.row}},slot:"activator"},[_c('v-icon',[_vm._v("cached")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Refuser les travaux de reserves")])],1)]}}])})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogReserveTache),callback:function ($$v) {_vm.dialogReserveTache=$$v},expression:"dialogReserveTache"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("DETAIL RESERVE N "+_vm._s(_vm.idReserve))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogReserveTache = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"elevation-2 pt-2 pl-2 pr-2",attrs:{"xs12":"","mt-2":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailReserve}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('p',[_c('b',[_vm._v("Description")]),_vm._v("\n                    : "+_vm._s(scope.row.comment)+"\n                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Photos")])]),_vm._v(" "),_c('p',_vm._l((scope.row.photos),function(photo,index){return _c('span',{key:index},[_c('v-avatar',{staticClass:"mr-2",attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":photo,"alt":"avatar"}})])],1)}),0)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libTache","label":"Tache","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libEtatTache","label":"ETAT"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Date fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[(scope.row.libEtatTache != 'Terminé')?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){_vm.tacheSelect = scope.row;_vm.dialogValidReserve = true}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1):_vm._e(),_vm._v("Confirmer\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etatTacheJournal == 1)?_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","dark":"","fab":"","large":"","bottom":"","right":"","color":"green"},on:{"click":function($event){return _vm.valideReserve()}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Valider les travaux de reserve(Chef chantier)")])],1)]}}])})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[( _vm.type == 2 && _vm.etatReserve == 2)?_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"orange"},on:{"click":function($event){_vm.dialogValidChefProjetReserve = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Valider les travaux de reserve(Chef projet)")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"800","persistent":""},model:{value:(_vm.dialogValidReserve),callback:function ($$v) {_vm.dialogValidReserve=$$v},expression:"dialogValidReserve"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Travaux de "+_vm._s(_vm.reserveSelect.libTache))]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        En cliquant sur valider, en tant que responsable, vous confirmez que les travaux ont été correctement realisés.\n        "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{ref:"formFinTrx",staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Commentaire"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":4,"id":"commentaire","placeholder":"Commentaire"},model:{value:(_vm.formFinTrx.com),callback:function ($$v) {_vm.$set(_vm.formFinTrx, "com", $$v)},expression:"formFinTrx.com"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.imageTrx,"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"fileTache",staticStyle:{"display":"none"},attrs:{"name":"fileTache","type":"file","accept":"image/*"},on:{"change":_vm.onFileTachePicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileTache.click()}}},[_vm._v("\n                  Image Travaux\n                  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.dialogValidReserve = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat","disabled":!_vm.formFinTrx.com},nativeOn:{"click":function($event){return _vm.validerTacheRapport()}}},[_vm._v("Valider")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.dialogValidChefProjetReserve),callback:function ($$v) {_vm.dialogValidChefProjetReserve=$$v},expression:"dialogValidChefProjetReserve"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("VALIDATION TRAVAUX DE RESERVES")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        En cliquant sur valider, en tant que responsable, vous confirmez que les travaux ont été correctement realisés.\n        "),_c('p',[_c('b',[_vm._v("NB: Veuillez préciser le coût des travaux ainsi que la durée de retard sur le planning s'il vous plaît puis valider.")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{attrs:{"label":"Coût","prop":"cout","width":"100%"}},[_c('el-input-number',{attrs:{"width":"100%","min":0,"size":"large","controls-position":"right","placeholder":"coût"},model:{value:(_vm.coutReserve),callback:function ($$v) {_vm.coutReserve=$$v},expression:"coutReserve"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Durée de retard (Jours)","prop":"durée","width":"100%"}},[_c('el-input-number',{attrs:{"width":"100%","min":0,"size":"large","controls-position":"right","placeholder":"durée"},model:{value:(_vm.dureeReserve),callback:function ($$v) {_vm.dureeReserve=$$v},expression:"dureeReserve"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.dialogValidChefProjetReserve = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.valideReserve()}}},[_vm._v("Valider")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"380"},model:{value:(_vm.dialogValidChef),callback:function ($$v) {_vm.dialogValidChef=$$v},expression:"dialogValidChef"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Confirmation des travaux selectionnés")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        En cliquant sur valider, en tant que responsable, vous confirmez que les travaux ont été correctement realisés.\n        "),(_vm.type ==1)?_c('p',[_vm._v("La reserve sera soumise au chef projet pour la validation")]):_vm._e()]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.dialogValidChef = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.validerReserve()}}},[_vm._v("Valider")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"800","persistent":""},model:{value:(_vm.dialogRefusReserve),callback:function ($$v) {_vm.dialogRefusReserve=$$v},expression:"dialogRefusReserve"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Travaux de "+_vm._s(_vm.reserveSelect.libTache))]),_vm._v(" "),_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Commentaire"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":4,"id":"commentaire","placeholder":"Commentaire"},model:{value:(_vm.formFinTrx.com),callback:function ($$v) {_vm.$set(_vm.formFinTrx, "com", $$v)},expression:"formFinTrx.com"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.imageTrx,"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"fileTache",staticStyle:{"display":"none"},attrs:{"name":"fileTache","type":"file","accept":"image/*"},on:{"change":_vm.onFileTachePicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileTache.click()}}},[_vm._v("\n                  Image Travaux\n                  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.dialogRefusReserve = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat","disabled":!_vm.formFinTrx.com},nativeOn:{"click":function($event){return _vm.refusTacheRapport()}}},[_vm._v("Valider")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bMqG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
    name: "ModalValidationDmdFond",
    props: {
        show: Boolean,
        demandeDetail: {
            type: Object
        },
        logistique: {
            type: Boolean
        },
        valider: {
            type: Boolean,
            default: true
        }

    },

    data: function data() {
        return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            dialogDetail: false,
            tableProduit: [],
            totalTTC: 0,
            formRapport: {},
            dialogVisible: false,
            dialogImageUrl: '',
            recharge: [],

            dialogConfirmRefus: false,
            dialogConfirm: false,
            formRefus: {},
            ruleFormRefus: {
                rapportRefus: [{ required: true, message: 'Veuillez saisir' }]
            }

        };
    },


    computed: {},
    watch: {
        show: function show(newValue, oldvalue) {
            var _this = this;

            this.dialogDetail = newValue;
            if (newValue == true) {
                var url = this.domaine + "demandeFond/recharge/" + this.demandeDetail.id;
                this.$http.get(url).then(function (response) {
                    _this.recharge = response.body.recharge;
                });
            }
        }
    },

    methods: {
        headerRowStyle: function headerRowStyle(_ref) {
            var row = _ref.row,
                rowIndex = _ref.rowIndex;

            return { "color": "black" };
        },
        imprimerDemande: function imprimerDemande() {
            var url = this.domaine + "demandeFond/imprimerPDF/demande/" + this.demandeDetail.id;
            window.open(url);
        },
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        },
        closeDialog: function closeDialog() {
            this.$emit('close', this.demandeDetail.id, "demandeFond");
        },
        SubmitValideDevis: function SubmitValideDevis() {
            var _this2 = this;

            this.loading = true;
            var url = '';
            // if(this.logistique){
            //    url = this.domaine + 'demandeFond/logistique/validation'
            // }else{
            //   url = this.domaine + 'demandeFond/validation'
            // }
            url = this.domaine + 'demandeFond/validation';

            var data = new FormData();
            data.append("idDemande", this.demandeDetail.id);
            data.append("idUser", this.user.id);
            data.append("reponse", 2); //accepte
            data.append("rapport", "");
            this.$http.post(url, data).then(function (response) {
                _this2.loading = false;
                _this2.successNotif(response.body.message);
                _this2.dialogConfirm = false;
                _this2.closeDialog();
            }, function (errResp) {
                _this2.loading = false;
                _this2.$message.error("Une erreur est survenue lors de la validation de la demande");
            });
        },
        SubmitRefusDevis: function SubmitRefusDevis() {
            var _this3 = this;

            this.loading = true;
            var url = '';
            if (this.logistique) {
                url = this.domaine + 'demandeFond/logistique/validation';
            } else {
                url = this.domaine + 'demandeFond/validation';
            }
            var data = new FormData();
            data.append("idDemande", this.demandeDetail.id);
            data.append("idUser", this.user.id);
            data.append("reponse", 0); //refuser
            data.append("rapport", this.formRefus.rapport);

            this.$http.post(url, data).then(function (response) {
                _this3.loading = false;
                _this3.successNotif(response.body.message);
                _this3.dialogConfirmRefus = false;
                _this3.closeDialog();
            }, function (errResp) {
                _this3.loading = false;
                _this3.$message.error("Une erreur est survenue lors du refus de la demande");
            });
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "bRy7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"gantt",staticStyle:{"height":"400px"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bY0r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "",
  props: ["show", "cmdDerivees", "cmdInit"],
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      loading: false,
      dialogDetailCmd: false,
      nbCmdDerive: 0
    };
  },


  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogDetailCmd = newValue;
      if (newValue == true) {
        this.nbCmdDerive = this.cmdDerivees.length;
      }
    }
  },

  methods: {
    closeDialog: function closeDialog() {
      this.$emit("close");
    }
  },

  mounted: function mounted() {}
});

/***/ }),

/***/ "bYFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chantier_DetailBudgetChant__ = __webpack_require__("soc2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "BudgetChant.vue",
    components: {
        Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */],
        DetailBudgetChant: __WEBPACK_IMPORTED_MODULE_1__components_chantier_DetailBudgetChant__["a" /* default */]
    },
    data: function data() {
        return {
            //data general
            notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
            loading: false,
            racourcis: [{ path: "/budgetChantier", text: "Budget chantier", disabled: false }],

            listeChantier: [],
            listeAfficheChantier: [],
            detChant: {},
            showDetailChant: false,
            totalMntPropose: 0,
            totalMntValide: 0,
            totalMntMarche: 0,
            selectSearchChantier: ""

        };
    },

    methods: {
        modalDetailChant: function modalDetailChant(itemChant) {
            console.log('itemChant', itemChant);
            this.detChant = itemChant;
            this.showDetailChant = true;
        },
        headerRowStyle: function headerRowStyle(_ref) {
            var row = _ref.row,
                rowIndex = _ref.rowIndex;

            return { "color": "black" };
        },
        loadBudget: function loadBudget() {
            var _this = this;

            this.loading = true;
            var url = this.domaine + "compteExploit/budget/chantier";
            this.$http.get(url).then(function (resp) {
                _this.loading = false;
                _this.listeAfficheChantier = resp.body.budgetsChantier;
                // this.totalMntPropose = resp.body.mntTotalBugPropose;
                // this.totalMntValide = resp.body.mntTotalBugValide;
                // //this.totalMntMarche = resp.body.mntTotalBugMarche;
            }, function (error) {
                _this.loading = false;
                _this.$message.error("Une erreur est survenue lors du chargement des budget");
            });
        },
        loadMarqueurChantier: function loadMarqueurChantier() {
            var _this2 = this;

            this.loading = true;
            var url = this.domaine + "compteExploit/budget/chantier";
            this.$http.get(url).then(function (response) {
                _this2.loading = false;
                var items = response.body.budgetsChantier;
                for (var i = 0; i < items.length; i++) {}
            });
        },
        loadBudgetSeclect: function loadBudgetSeclect() {
            var _this3 = this;

            this.loading = true;
            var url = this.domaine + "compteExploit/budget/chantier" + '?id=' + this.selectSearchChantier;
            this.$http.get(url).then(function (resp) {
                if (resp.body) {
                    _this3.loading = false;
                    _this3.listeChantier = resp.body.budgetsChantier;
                    _this3.totalMntPropose = resp.body.mntTotalBugPropose;
                    _this3.totalMntValide = resp.body.mntTotalBugValide;
                }
            });
        },
        getSummExploitBudget: function getSummExploitBudget(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = "Sous total";
                    return;
                }

                if (index === 3) {
                    sums[index] = "N/A";
                    return;
                }
                var values = data.map(function (item) {
                    return Number(item[column.property]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0));
                } else {
                    sums[index] = "N/A";
                }
            });

            return sums;
        }
    },

    mounted: function mounted() {
        this.loadBudget();
    }
});

/***/ }),

/***/ "bZ3R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AjoutTransfertCarte__ = __webpack_require__("tTNa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */], AjoutTransfertCarte: __WEBPACK_IMPORTED_MODULE_0__AjoutTransfertCarte__["a" /* default */] },
  name: "TransfertCarteIndex",
  props: {
    show: {
      type: Boolean,
      required: true
    },
    carte: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      // racourcis: [
      //     { path: '/', text: 'Accueil', disabled: false },
      //     { path: '/demandeFond', text: 'Demande de fonds', disabled: true }
      // ],

      transferts: [],
      oldTransferts: [],
      dialogSupr: false,
      dialogTransfertCarte: false,
      selectTransfert: "",
      editTransfert: {},
      idTransfert: null,
      mntTotal: 0,

      showModalAjoutTransfert: false,
      nbTransfert: 0,
      selectType: "",
      selectTypeRecharge: "",
      mntCredit: 0,
      mntDebit: 0
    };
  },


  watch: {
    show: function show(newValue, oldValue) {
      this.dialogTransfertCarte = newValue;
      if (newValue == true) {
        this.loadTransfert();
      }
    }
  },

  methods: {
    showDialogSupp: function showDialogSupp(item) {
      this.idTransfert = item.id;
      this.dialogSupr = true;
    },
    deleteTransfert: function deleteTransfert(rgt) {
      this.idRgt = rgt.id;
      this.dialogSupr = true;
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    modalAjoutTransfert: function modalAjoutTransfert() {
      this.editTransfert = {};
      this.showModalAjoutTransfert = true;
    },
    modalEditTransfert: function modalEditTransfert(transfert) {
      this.editTransfert = transfert;
      this.showModalAjoutTransfert = true;
    },
    imprimetransfertPDF: function imprimetransfertPDF() {
      var tab = [];
      this.transferts.forEach(function (transfert) {
        tab.push(transfert.id);
      });

      var url = this.domaine + "carteCarburant/reglement/imprimerPDF/liste/" + tab;
      window.open(url);
    },
    deleteRecharge: function deleteRecharge() {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "carteCarburant/delete/recharge/" + this.idTransfert;
      this.$http.get(url).then(function (response) {
        _this.loading = false;

        _this.$notify({
          title: "SUPPRESSION",
          message: "Le rechargement a été supprimée avec succès.",
          type: "success",
          position: "top-center"
        });
        _this.dialogSupr = false;

        _this.loadTransfert();
      }, function (errRep) {
        _this.loading = false;
        _this.dialogSupr = false;
        _this.$notify.error({
          title: "SUPPRESSION ECHOUEE",
          message: "La suppression du rechargement a échouée.",
          position: "top-center"
        });
      });
    },
    clearSelect: function clearSelect() {
      this.transferts = this.oldtransferts;
    },
    filtrerTypeRecharge: function filtrerTypeRecharge(idtransfert) {},
    filtrerType: function filtrerType(idtype) {},
    loadTransfert: function loadTransfert() {
      var _this2 = this;

      //this.loading = true;

      //afficher que les carte que l'utilisateur a creer
      //if(this.droitAcces.liste_demande_fond)

      var url = this.domaine + "carteCarburant/transfert/carte/" + this.carte.carteId;

      this.$http.get(url).then(function (response) {
        //this.loading = false;
        // this.mntTTC =  response.body.mntTTC
        _this2.transferts = response.body.transferts;
        _this2.oldtransferts = response.body.transferts;
        _this2.nbTransfert = _this2.transferts.length;

        _this2.mntTotal = response.body.montantTotalFormat;
        _this2.mntCredit = response.body.montantCreditFormat;
        _this2.mntDebit = response.body.montantDebitFormat;
        //affichage nombre de demande
        if (response.body.transferts > 0) {
          _this2.nbtransfert = _this2.transferts.length;
        }
      }, function (error) {
        _this2.loading = false;
        _this2.$message.error("Une erreur est survenue lors du chargement de la liste des transferts");
      });
    }
  },

  mounted: function mounted() {
    //this.loadReglement();
  }
});

/***/ }),

/***/ "bagP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");


var _components$name$prop;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Oq2I");
__webpack_require__("miEh");




/* harmony default export */ __webpack_exports__["a"] = (_components$name$prop = {
  components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */] },
  name: "WidgetProjet",
  props: {
    show: {
      type: Boolean
    },
    type: {
      type: Number,
      default: 0
    },
    projet: {
      type: Object
    }
  },
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,

      statusRapport: [],
      coutPrevu: 0,
      coutActuel: 0,
      nbOuvrier: 0,
      nbPrestataire: 0,
      nbChantTermine: 0,
      nbChantArret: 0,
      nbChantEnCours: 0,
      nbChant: 0,
      tauxExec: 0
    };
  },


  watch: {},

  methods: {
    loadStatChant: function loadStatChant() {
      var _this = this;

      var url = this.domaine + "projet/stat/" + this.projet.id;

      this.$http.get(url).then(function (response) {
        _this.loading = false;
        _this.coutPrevu = response.body.coutPrevu;
        _this.coutActuel = response.body.coutActuel;
        _this.nbOuvrier = response.body.nbOuvrier;
        _this.nbPrestataire = response.body.nbPrestataire;
        _this.nbChantTermine = response.body.nbChantTermine;
        _this.nbChantArret = response.body.nbChantArret;
        _this.nbChantEnCours = response.body.nbChantEnCours;
        _this.nbChant = response.body.nbChant;
        _this.tauxExec = response.body.tauxExec;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Erreur lors chargement projet dashboard");
      });
    }
  }

}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$name$prop, "watch", {
  projet: function projet(newValue, oldValue) {
    this.loadStatChant();
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$name$prop, "mounted", function mounted() {}), _components$name$prop);

/***/ }),

/***/ "bcvN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CarteCarburant_index_vue__ = __webpack_require__("t3x9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87615824_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarteCarburant_index_vue__ = __webpack_require__("50Wr");
function injectStyle (ssrContext) {
  __webpack_require__("I9Qq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-87615824"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CarteCarburant_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87615824_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarteCarburant_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "beTa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bgFy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
    name: "ModalAttribuerZone",
    props: ["show", "userResponsable"],

    data: function data() {
        var _ref;

        return _ref = {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            loading: false,

            valid: true,
            dialogAjoutZoneResponsable: false
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "loading", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "listeZone", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "zoneSelect", []), _ref;
    },

    computed: {},

    methods: {
        closeDialog: function closeDialog() {
            this.$emit('close');
        },


        //charge les zones sans responsable 
        loadZone: function loadZone() {
            var _this = this;

            var url = this.domaine + 'attribution/liste/zonelibre/' + this.userResponsable.id;
            this.$http.get(url).then(function (response) {
                _this.listeZone = response.body.listeZone;
            });
        },
        submitZone: function submitZone() {
            var _this2 = this;

            this.loading = true;
            var formdata = new FormData();
            formdata.append('zoneSelect', this.zoneSelect);
            formdata.append('userRespId', this.userResponsable.id);

            var url = this.domaine + 'attribution/ajout/zone';
            this.$http.post(url, formdata).then(function (response) {
                _this2.loading = false;
                _this2.closeDialog();
                _this2.$notify({
                    title: "Ajout de zone",
                    message: 'Enregistrement effectué avec succès.',
                    type: 'success',
                    position: 'top-center'
                });
            }, function (resp) {
                _this2.closeDialog();
                _this2.loading = false;
                _this2.$message.error("erreur serveur");
            });
        },


        //charge les zones d'un responsable 
        loadZoneResponsable: function loadZoneResponsable() {
            var _this3 = this;

            var url = this.domaine + 'attribution/zone/responsable/' + this.userResponsable.id;
            this.$http.get(url).then(function (response) {
                _this3.zoneSelect = response.body.zoneSelect;
            }, function (resp) {});
        }
    },

    watch: {
        show: function show(newValue, oldvalue) {
            if (newValue == true) {
                this.loadZone();
                this.loadZoneResponsable();
            }
            this.dialogAjoutZoneResponsable = newValue;
        }
    },

    mounted: function mounted() {}
});

/***/ }),

/***/ "blqz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjetMap_vue__ = __webpack_require__("a9pL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13e891a5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjetMap_vue__ = __webpack_require__("JC3o");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjetMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13e891a5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjetMap_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bnB3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "boY9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"cyan darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"headline"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("assignment")]),_vm._v("\n                                                    "+_vm._s(_vm.nbContrats)+"\n                                                ")],1),_vm._v(" "),_c('div',[_vm._v("Total contrat(s)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("Contrat à renouveler")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v("\n\n                                                "+_vm._s(_vm.nbContratArenouv))])])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"orange darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"headline"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("people")]),_vm._v("\n                                                    "+_vm._s(_vm.nbEmploye)+"\n                                                ")],1),_vm._v(" "),_c('div',[_vm._v("Total employes(s)")])]),_vm._v(" "),_c('div',{staticClass:"mt-4"},[_c('div',{staticClass:"headline"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("view_list")]),_vm._v("\n                                                    "+_vm._s(_vm.nbDmdAbsAttente)+"\n                                                ")],1),_vm._v(" "),_c('div',[_vm._v("\n                                                    Demande(s) d'absence en attente de validation\n                                                    ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_vm._v("Nbre d'absent(s)")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.nbAbsent))])])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"red darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"headline"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("assignment")]),_vm._v("\n                                                    "+_vm._s(_vm.nbContrats)+"\n                                                ")],1),_vm._v(" "),_c('div',[_vm._v("Total contrat(s)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("Contrat à renouveler")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v("\n\n                                                "+_vm._s(_vm.nbContratArenouv))])])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-layout',{attrs:{"row":"","mb-4":"","ml-2":"","mr-2":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-4"},[_c('v-card-title',{staticClass:"blue-grey lighten-5",attrs:{"primary-title":""}},[_c('div',{staticStyle:{"width":"100%","height":"255px"},attrs:{"id":"chartTypeContrat"}})]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticClass:"grey lighten-4"},[_c('v-layout',{staticClass:"mb-2",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"orange--text text-xs-left"},[_c('div',[_vm._v("\n                                            STAGE PROFESSIONNEL\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.nbContProfession))])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"red--text text-xs-right"},[_c('div',[_vm._v("\n                                            STAGE FORMATION\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.nbContFormation))])])])],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-2",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"purple--text text-xs-left"},[_c('div',[_vm._v("\n                                            TEMPS PARTIEL\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"headline "},[_vm._v(_vm._s(_vm.nbContPartiel))])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"cyan--text text-xs-right"},[_c('div',[_vm._v("\n                                            CONSULTANT\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.nbContConsult))])])])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"primary--text text-xs-left"},[_c('div',[_vm._v("\n                                            CDD\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"headline "},[_vm._v(_vm._s(_vm.nbContCDD))])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"green--text text-xs-right"},[_c('div',[_vm._v("\n                                           CDI\n                                        ")]),_vm._v(" "),_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.nbContCDI))])])])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"ml-2":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-card',{staticClass:"elevation-4",staticStyle:{"height":"505px"}},[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"blue-grey darken-2","dark":""}},[_c('v-toolbar-title',[_c('v-chip',{attrs:{"color":"light-green accent-4","text-color":"white"}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.listeAbsence.length))])]),_vm._v("\n                                employés absents ce mois")],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeAbsence,"height":"370"}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('p',[_vm._v("Motif:")]),_vm._v(" "),_c('p',[_c('el-input',{attrs:{"type":"textarea"},model:{value:(scope.row.description),callback:function ($$v) {_vm.$set(scope.row, "description", $$v)},expression:"scope.row.description"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Avatar","prop":"avatar"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"demo-basic--circle"},[_c('div',{staticClass:"block"},[_c('v-avatar',{attrs:{"tile":false,"size":50,"color":"grey lighten-4"}},[_c('img',{attrs:{"src":scope.row.urlAvatar,"alt":"avatar"}})])],1)])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Nom & Prénom(s)","prop":"nom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Période","prop":"periode"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mb-1":""}},[_c('v-flex',{attrs:{"mr-2":"","xs6":""}},[_c('v-layout',{attrs:{"mb-2":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-card',{staticClass:"elevation-4",staticStyle:{"height":"450px"}},[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"brown darken-2","dark":""}},[_c('v-toolbar-title',[_c('v-chip',{attrs:{"color":"light-green accent-4","text-color":"white"}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.listeContratsRenouv.length))])]),_vm._v("\n                                 contrats expiré(s) à renouveler")],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeContratsRenouv}},[_c('el-table-column',{attrs:{"label":"ID Contrat","prop":"idContrat"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Type contrat","prop":"typeContrat"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Employe","prop":"employe"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Période","prop":"periode"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"mb-2":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-card',{staticClass:"elevation-4",staticStyle:{"height":"450px"}},[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"deep-orange darken-2","dark":""}},[_c('v-toolbar-title',[_c('v-chip',{attrs:{"color":"light-green accent-4","text-color":"white"}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.listeContratsRenouvMoisProch.length))])]),_vm._v("\n\n                                contrats à renouveler le mois prochain")],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeContratsRenouvMoisProch}},[_c('el-table-column',{attrs:{"label":"ID Contrat","prop":"idContrat"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Type contrat","prop":"typeContrat"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Employe","prop":"employe"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Période","prop":"periode"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mb-3":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-card',{staticClass:"elevation-4"},[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan darken-2","dark":""}},[_c('v-toolbar-title',[_vm._v("Demande d'absences")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center",staticStyle:{"height":"auto"}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeDemandeAbs,"height":"500"}},[(false)?_c('el-table-column',{attrs:{"label":"ID","width":"200","prop":"id"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{staticClass:"body-2"},[_vm._v(_vm._s(scope.row.id))])]}}],null,false,330709112)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Avatar","width":"100","align":"center","prop":"avatar"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"demo-basic--circle"},[_c('div',{staticClass:"block"},[_c('v-avatar',{attrs:{"tile":false,"size":50,"color":"grey lighten-4"}},[_c('img',{attrs:{"src":scope.row.urlAvatar,"alt":"avatar"}})])],1)])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Nom & Prénom(s)","width":"200","prop":"nom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{staticClass:"body-2"},[_vm._v(_vm._s(scope.row.nom))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"Demande(s) d'absence"}},[_c('el-table-column',{attrs:{"align":"center","prop":"vacance","label":"Congé restant/Total"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"blue--text title"},[_vm._v(_vm._s(props.row.vacance))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"mariage","label":"Mariage"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"green--text title"},[_vm._v(_vm._s(props.row.mariage))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"deuil","label":"Deuil"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"red--text title"},[_vm._v(_vm._s(props.row.deuil))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"famille","label":"familial et medical"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"purple--text title"},[_vm._v(_vm._s(props.row.famille))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"autre","label":"Autre"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"black--text title"},[_vm._v(_vm._s(props.row.autre))])]}}])})],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bsLm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chantier_vue__ = __webpack_require__("MHXB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_549a8540_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chantier_vue__ = __webpack_require__("OpSU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chantier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_549a8540_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chantier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "btWr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c57L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
    name: "modelCarteContrat",
    props: {
        contrat: {
            type: Object
        }
    },
    data: function data() {
        return {
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,

            dialogAnnuleCont: false,
            dialogRenouvCont: false,
            descAnnule: "",
            formValidite: {
                datedbtFin: ""
            }

        };
    },

    methods: {
        showDetailEmpl: function showDetailEmpl(idEmp) {
            this.$emit("detailEmpl", idEmp);
        },
        showAnnuleContrat: function showAnnuleContrat() {
            this.dialogAnnuleCont = true;
        },
        showRenouvContrat: function showRenouvContrat() {
            this.dialogRenouvCont = true;
        },
        submitRenewContrat: function submitRenewContrat() {
            var _this = this;

            this.loading = true;
            var urlVerif = this.domaine + 'rh/verification/contrat/employe/' + this.contrat.userIdContrat;
            var dataVerif = {
                dateDbt: this.formValidite.datedbtFin[0],
                dateFin: this.formValidite.datedbtFin[1],
                typeContrat: this.contrat.typeContrat
            };

            //Verifier si le contrat peut etre renouveler
            this.$http.get(urlVerif, { params: dataVerif }).then(function (resp) {
                _this.loading = false;
                if (resp.body.code == 0) //le contrat ne peut etre creer
                    {
                        _this.dialogRenouvCont = false, _this.$alert(resp.body.message, 'Validation champs date', {
                            confirmButtonText: 'OK'
                        });
                        //changer etat du contrat a expire
                        _this.submitEtatCont(3);
                        return;
                    }
                //le contrat ne peut etre creer
                _this.submitEtatCont(resp.body.etatContrat);
            }, function (error) {
                _this.loading = false;
                _this.formContrat.dateFin = null;
                _this.dateInvalide = true;
                _this.$message.error("Une erreur sest produite lors de la validation des champs dates");
            });
        },
        submitEtatCont: function submitEtatCont(etat) {
            var _this2 = this;

            this.loading = true;
            var url = this.domaine + "rh/contrat/" + this.contrat.idContrat + "/changeEtat";

            var data = new FormData();
            data.append("dateValidite", this.formValidite.datedbtFin);
            data.append("etat", etat);
            data.append("userId", this.user.id);
            data.append("motif", this.descAnnule);
            this.$http.post(url, data).then(function (resp) {
                _this2.loading = false;
                _this2.dialogAnnuleCont = false;
                _this2.dialogRenouvCont = false;
                _this2.formValidite.datedbtFin = null;
                _this2.$emit("contAnnule");
                _this2.successNotif(resp.body.message);
            }, function (error) {
                _this2.loading = false;
                _this2.dialogAnnuleCont = false;
                _this2.$message.error("Echec lors de l'annulation du  contrat");
            });
        },
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                duration: 10000,
                type: 'success',
                position: 'top-center'
            });
        }
    }
});

/***/ }),

/***/ "cNrM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "caSR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Representant_vue__ = __webpack_require__("tEEj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c1e1580_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Representant_vue__ = __webpack_require__("gPj6");
function injectStyle (ssrContext) {
  __webpack_require__("qnOB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c1e1580"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Representant_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c1e1580_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Representant_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cej4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: 'Parametre',
  data: function data() {
    var _paramGlobal, _ref;

    return _ref = {
      loading: false,
      loadingService: false,
      loadingRole: false,
      domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
      user: JSON.parse(sessionStorage.getItem('userInfo')),
      roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
      droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
      racourcis: [{ path: '/parametre', text: 'Accueil', disabled: false }, { path: '/keywords', text: 'Paramètres', disabled: false }],
      valid: true,
      etatParam: true,
      etatGlobal: false,
      etatCode: false,
      etatAlert: false,
      etatService: false,
      etatRoute: false,
      dialogAjout: false,
      dialogRole: false,
      dialogEdit: false,
      dialogShow: false,
      paramGlobal: (_paramGlobal = {
        smsProjet: '',
        smsTaches: '',
        smsTravaux: '',
        smsChantier: '',
        mailProjet: '',
        mailTaches: '',
        mailChantier: '',
        mailPlanifBesoin: '',
        smsPlanifBesoin: '',
        mailTravauxProjet: '',
        smsTravauxProjet: '',
        smsCommandeBesoin: '',
        mailCommandeBesoin: '',
        smsBesoin: '',
        mailBesoin: '',
        smsValidBesoinMateriel: '',
        mailValidBesoinMateriel: '',
        smsDemandeMission: '',
        mailDemandeMission: '',
        smsValid1mission: '',
        smsCloturmission: '',
        mailCloturmission: '',
        mailValid1mission: '',
        smsValid2mission: '',
        mailValid2mission: '',
        smsRejetMission: '',
        mailRejetMission: '',
        smsDemandeInterv: '',
        smsValidInterv: '',
        smsDiagnostiq: '',
        smsValidDiagnostiq: '',
        smsPlanningInterv: '',
        smsFinInterv: '',
        smsRejetInterv: '',
        mailDemandeInterv: '',
        mailValidInterv: '',
        mailDiagnostiq: '',
        mailValidDiagnostiq: '',
        mailPlanningInterv: '',
        mailFinInterv: '',
        mailRejetInterv: '',
        idParam: '',
        assurance: '',
        mission: '',
        visite: '',
        vignette: '',
        intervention: '',
        location: '',
        client: '',
        nom: '',
        logo: '',
        formeJuridique: '',
        contact: '',
        siege: '',
        capital: '',
        dg: '',
        user: '',
        fournisseur: '',
        entrepot: '',
        caisse: '',
        maintenance: '',
        vehicule: '',
        projet: '',
        facture: '',
        commande: '',
        livraison: '',
        appro: '',
        approCaisse: '',
        stock: '',
        sortir: '',
        entree: '',
        transfert: '',
        inventaire: '',
        produit: '',
        paiement: '',
        smsPaiement: '',
        mailPaiement: '',
        smsApproCaisse: '',
        mailApproCaisse: '',
        smsApproCaisseValid: '',
        mailApproCaisseValid: '',
        smsCaisse: '',
        mailSeuilCaisse: '',
        smsSeuilCaisse: '',
        mailCaisse: '',
        smsZone: '',
        mailZone: '',
        smsDemandeRep: '',
        mailDemandeRep: '',
        smsConstat: '',
        mailConstat: '',
        smsConstatValid: '',
        mailConstatValid: '',
        smsIntervention: '',
        mailIntervention: ''
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'smsTravaux', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'mailTravaux', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'smsPrestataire', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'mailPrestataire', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'smsCommande', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'mailCommande', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'smsFacture', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'mailFacture', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'smsLivraison', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'mailLivraison', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'smsDevis', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'mailDevis', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'smsDevisValid', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'mailDevisValid', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'smsAppro', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'mailAppro', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'smsCmdeFacture', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'mailCmdeFacture', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'smsFactureValid', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'mailFactureValid', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'idPres', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'idValidateurDemande', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'idValidateurDevis', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'idRespoTechnik', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'montantSeuil', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'mail', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_paramGlobal, 'sms', 0), _paramGlobal),
      fileLogo: [{ name: '', url: '' }],
      logoUser: "/static/avatar-conducteur.png",

      listParam: []
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'logoUser', "/static/avatar-conducteur.png"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'listService', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'users', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'libelle', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'libelleRules', [function (v) {
      return !!v || "Veuillez renseigner le libellé";
    }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'selectChef', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'chef', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'chefRules', [function (v) {
      return !!v || "Veuillez sélectionner le responsable du service";
    }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'serviceCourant', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'detailService', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'listPrestataire', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'listRoute', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'routeCourant', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'envoieAlert', 'caisse'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'disabledBtnServ', false), _ref;
  },

  computed: {},
  methods: {
    loadPage: function loadPage() {
      //this.loading = true
    },
    loadUser: function loadUser() {
      var _this = this;

      var url = this.domaine + 'userCreate/user-list';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this.users = response.body;
        }
      });
    },
    loadService: function loadService() {
      var _this2 = this;

      var url = this.domaine + 'webService/liste-service';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this2.listService = response.body.service;
          if (_this2.listService === undefined || _this2.listService.length == 0) {
            _this2.disabledBtnServ = true;
          } else {
            _this2.disabledBtnServ = false;
          }
        }
      });
    },
    loadParametre: function loadParametre() {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + 'webService/index/parametre';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this3.listParam = response.body.param;
          //this.paramGlobal.idDirecteur = response.body.param.idDirecteur
          _this3.loading = false;
        }
      });
    },
    loadPrestaire: function loadPrestaire() {
      var _this4 = this;

      var url = this.domaine + 'fournisseur/index/prestataire';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this4.listPrestataire = response.body.prestataire;
        }
      });
    },
    loadRoute: function loadRoute() {
      var _this5 = this;

      this.loading = true;
      var url = this.domaine + 'webService/index/route/all';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this5.listRoute = response.body.route;
          _this5.loading = false;
        }
      });
    },
    param: function param() {
      this.etatGlobal = true;
      this.etatCode = false;
      this.etatParam = false;
      this.etatAlert = false;
      this.etatService = false;
      this.etatRoute = false;
      this.newParametre();
    },
    paramCode: function paramCode() {
      this.etatCode = true;
      this.etatGlobal = false;
      this.etatParam = false;
      this.etatAlert = false;
      this.etatService = false;
      this.etatRoute = false;
      this.newParamCode();
    },
    paramAlert: function paramAlert() {
      this.etatAlert = true;
      this.etatCode = false;
      this.etatGlobal = false;
      this.etatParam = false;
      this.etatService = false;
      this.etatRoute = false;
      this.newParamAlert();
    },
    paramService: function paramService() {
      this.etatService = true;
      this.etatRoute = false;
      this.etatAlert = false;
      this.etatCode = false;
      this.etatGlobal = false;
      this.etatParam = false;
    },
    paramRoute: function paramRoute() {
      this.etatRoute = true;
      this.etatService = false;
      this.etatAlert = false;
      this.etatCode = false;
      this.etatGlobal = false;
      this.etatParam = false;
    },
    newParametre: function newParametre() {
      this.paramGlobal = this.listParam;
      for (var prop in this.fileLogo) {
        this.fileLogo[prop].name = this.listParam.logo;
        this.fileLogo[prop].url = this.listParam.url;
      }
    },
    newParamCode: function newParamCode() {
      this.paramGlobal = this.listParam;
    },
    newParamAlert: function newParamAlert() {
      this.paramGlobal = this.listParam;
    },
    newParamService: function newParamService() {
      this.dialogAjout = true;
      this.dialogEdit = false;
      this.libelle = '';
      this.selectChef = null;
    },
    newRole: function newRole(item) {
      this.routeCourant = item;
      this.dialogRole = true;
      this.dialogEdit = true;
      this.libelle = item.description;
    },
    editService: function editService(ligne) {
      this.serviceCourant = ligne;
      this.dialogAjout = true;
      this.dialogEdit = true;
      this.libelle = this.serviceCourant.libelle;
      this.selectChef = this.serviceCourant.idChef;
    },
    showService: function showService(ligne) {
      var _this6 = this;

      this.dialogShow = true;
      this.serviceCourant = ligne;
      var url = this.domaine + 'webService/' + this.serviceCourant.id + '/show/service';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this6.detailService = response.body.service;
        }
      });
    },
    submit: function submit() {
      var _this7 = this;

      this.loading = true;
      if (this.$refs.formGlobal.validate()) {
        var form = document.getElementById('formGlobal');
        var data = new FormData(form);
        data.append('idUser', this.user.id);
        data.append('idParam', this.listParam.idParam);
        data.append('prestataire', this.paramGlobal.idPres);
        data.append('valideDemande', this.paramGlobal.idValidateurDemande);
        data.append('directeur', this.paramGlobal.idDirecteur);
        data.append('valideDevis', this.paramGlobal.idValidateurDevis);
        data.append('respoTechnik', this.paramGlobal.idRespoTechnik);

        var url = this.domaine + 'webService/new/parametre';
        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this7.$notify({
                title: 'MODIFICATION REUSSI',
                message: 'Paramètres modifié avec succès.',
                type: 'success',
                position: 'top-center'
              });
              _this7.etatGlobal = false;
              _this7.etatParam = true;
              _this7.loadParametre();
              _this7.loadPage();
              _this7.loading = false;
            } else if (verif.code === 2) {
              _this7.$message.error(verif.message);
              _this7.loading = false;
            } else if (verif.code === 0) {
              _this7.$message.error(verif.message);
              _this7.loading = false;
            }
          } else {
            _this7.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
            _this7.loading = false;
          }
        }, function (response) {
          _this7.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
          _this7.loading = false;
        });
      } else {
        this.$message.error('Veuillez renseigner les champs obligatoires');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La configuration n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    submitCode: function submitCode() {
      var _this8 = this;

      this.loading = true;
      if (this.$refs.formCode.validate()) {
        var form = document.getElementById('formCode');
        var data = new FormData(form);
        data.append('idUser', this.user.id);
        data.append('idParam', this.listParam.idParam);
        var url = this.domaine + 'webService/new/parametre/code';
        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this8.$notify({
                title: 'MODIFICATION REUSSI',
                message: 'Paramètres modifié avec succès.',
                type: 'success',
                position: 'top-center'
              });
              _this8.etatCode = false;
              _this8.etatParam = true;
              _this8.loadParametre();
              _this8.loadPage();
              _this8.loading = false;
            } else if (verif.code === 2) {
              _this8.$message.error(verif.message);
              _this8.loading = false;
            } else if (verif.code === 0) {
              _this8.$message.error(verif.message);
              _this8.loading = false;
            }
          } else {
            _this8.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
            _this8.loading = false;
          }
        }, function (response) {
          _this8.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
          _this8.loading = false;
        });
      } else {
        this.$message.error('Veuillez renseigner les champs obligatoires');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La configuration n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    submitAlert: function submitAlert(type) {
      var _this9 = this;

      this.loading = true;
      if (this.$refs.formAlert.validate()) {
        var form = document.getElementById(type);
        var data = new FormData(form);
        data.append('idUser', this.user.id);
        data.append('idParam', this.listParam.idParam);
        data.append('type', type);
        var url = this.domaine + 'webService/new/parametre/alert'; //WebServiceBundle:DefaultWebServiceController

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this9.$notify({
                title: 'MODIFICATION REUSSI',
                message: 'Paramètres modifié avec succès.',
                type: 'success',
                position: 'top-center'
              });
              _this9.etatAlert = false;
              _this9.etatParam = true;
              _this9.loadParametre();
              _this9.loadPage();
              _this9.loading = false;
            } else if (verif.code === 2) {
              _this9.$message.error(verif.message);
              _this9.loading = false;
            } else if (verif.code === 0) {
              _this9.$message.error(verif.message);
              _this9.loading = false;
            }
          } else {
            _this9.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur1');
            _this9.loading = false;
          }
        }, function (response) {
          _this9.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
          _this9.loading = false;
        });
      } else {
        this.$message.error('Veuillez renseigner les champs obligatoires');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La configuration n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    submitService: function submitService() {
      var _this10 = this;

      if (this.$refs.formService.validate()) {
        this.loadingService = true;
        var form = document.getElementById('formService');
        var data = new FormData(form);
        data.append('idUser', this.user.id);
        data.append('chef', this.selectChef);
        var url = '';
        if (this.serviceCourant.id) {
          url = this.domaine + 'webService/' + this.serviceCourant.id + '/edit/service';
        } else {
          url = this.domaine + 'webService/new/service';
        }
        this.$http.post(url, data).then(function (response) {
          _this10.loadingService = false;
          if (response.body) {

            var verif = response.body;
            if (verif.code === 1) {
              if (_this10.serviceCourant.id) {
                _this10.$notify({
                  title: 'MODIFICATION REUSSI',
                  message: 'Service modifié avec succès.',
                  type: 'success',
                  position: 'top-center'
                });
              } else {
                _this10.$notify({
                  title: 'ENREGISTREMENT REUSSI',
                  message: 'Service enregistré avec succès.',
                  type: 'success',
                  position: 'top-center'
                });
              }
              _this10.dialogAjout = false;
              _this10.paramService();
              _this10.loadService();
              _this10.loadPage();
              _this10.loadingService = false;
            } else if (verif.code === 0) {
              _this10.$message.error(verif.message);
              _this10.loadingService = false;
            }
          } else {
            _this10.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
            _this10.loadingService = false;
          }
        }, function (response) {
          _this10.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
          _this10.loadingService = false;
        });
      } else {
        this.$message.error('Veuillez renseigner les champs obligatoires');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le service n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loadingService = false;
      }
    },
    submitRole: function submitRole() {
      var _this11 = this;

      this.loadingRole = true;
      if (this.$refs.formRole.validate()) {
        var form = document.getElementById('formRole');
        var data = new FormData(form);
        data.append('idUser', this.user.id);
        var url = this.domaine + 'webService/' + this.routeCourant.id + '/edit/role';

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this11.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: 'Rôle enregistré avec succès.',
                type: 'success',
                position: 'top-center'
              });

              _this11.dialogRole = false;
              _this11.loadRoute();
              _this11.loadPage();
              _this11.loadingRole = false;
            } else if (verif.code === 0) {
              _this11.$message.error(verif.message);
              _this11.loadingRole = false;
            }
          } else {
            _this11.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
            _this11.loadingRole = false;
          }
        }, function (response) {
          _this11.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
          _this11.loadingRole = false;
        });
      } else {
        this.$message.error('Veuillez renseigner les champs obligatoires');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le rôle n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loadingService = false;
      }
    },
    retour: function retour() {
      this.etatParam = true;
      this.etatGlobal = false;
      this.etatCode = false;
      this.etatAlert = false;
      this.etatService = false;
      this.etatRoute = false;
    },
    imprimeListeServ: function imprimeListeServ(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "webService/imprimerPDF/service/liste";
      } else {
        url = this.domaine + "webService/imprimerEXC/service/liste";
      }
      window.open(url);
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  },
  mounted: function mounted() {
    this.loadPage();
    this.loadUser();
    this.loadParametre();
    this.loadService();
    // this.loadPrestaire()
    this.loadRoute();
  }
});

/***/ }),

/***/ "cfln":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","persistent":"","overlay":true,"scrollable":""},model:{value:(_vm.dialogZone),callback:function ($$v) {_vm.dialogZone=$$v},expression:"dialogZone"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[((_vm.editForm == true && _vm.zoneDetail != null) || (_vm.editForm == false && _vm.zoneDetail == null) )?_c('span',[_vm._v("Ajouter ou modifier une zone de maintenance ")]):(_vm.zoneDetail.label != undefined)?_c('span',[_vm._v("Ajouter une  sous zone à la zone "+_vm._s(_vm.zoneDetail.label)+"  ")]):_c('span',[_vm._v("Ajouter une  nouvelle zone   ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formZone",staticClass:"demo-form-inline",attrs:{"id":"formZone","model":_vm.formZone,"rules":_vm.rules}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"label":"Libellé","prop":"libelle"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"nom de zone"},model:{value:(_vm.formZone.libelle),callback:function ($$v) {_vm.$set(_vm.formZone, "libelle", $$v)},expression:"formZone.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"label":"Entrepot","prop":"entrepot"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"entrepot","placeholder":"Entrepot"},model:{value:(_vm.formZone.entrepot),callback:function ($$v) {_vm.$set(_vm.formZone, "entrepot", $$v)},expression:"formZone.entrepot"}},_vm._l((_vm.listeEntrepot),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"description"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","row":6,"name":"motif","placeholder":"description de la zone"},model:{value:(_vm.formZone.description),callback:function ($$v) {_vm.$set(_vm.formZone, "description", $$v)},expression:"formZone.description"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){return _vm.resetForm('formZone')}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.editForm == false && _vm.zoneDetail.label == null)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitForm('formZone')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e(),_vm._v(" "),(_vm.editForm == true && _vm.zoneDetail.label != null)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitForm('formZone')}}},[_vm._v("Enregistrer les modifications"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e(),_vm._v(" "),(_vm.editForm == false && _vm.zoneDetail.label != null)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitForm('formZone')}}},[_vm._v("Enregistrer une sous zone"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e()],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cgcM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutReglementCarte_vue__ = __webpack_require__("Y5NI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_031d4234_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutReglementCarte_vue__ = __webpack_require__("+cHq");
function injectStyle (ssrContext) {
  __webpack_require__("Hx5p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-031d4234"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutReglementCarte_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_031d4234_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutReglementCarte_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "chSw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListeRapportTrx_vue__ = __webpack_require__("sYTI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62c92674_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListeRapportTrx_vue__ = __webpack_require__("Et9W");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListeRapportTrx_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62c92674_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListeRapportTrx_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cjD9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"75%","scrollable":"","loading":_vm.loading},model:{value:(_vm.dialogShowContrat),callback:function ($$v) {_vm.dialogShowContrat=$$v},expression:"dialogShowContrat"}},[_c('v-card',[_c('v-toolbar',{staticClass:"green",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Details du contrat "+_vm._s(_vm.contratCourant.client)+" ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowContrat = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Réference : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.ref))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Client : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.client))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Véhicule : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.vehicule))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Montant total : ")]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                "+_vm._s(_vm.contratCourant.montantTotalFormat)+" FCFA\n              ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de début : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.dateDFormat))])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Date de fin : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.dateSFormat))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Type de contrat : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.libelle))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Nombre de (Jour, Mois, Année) : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.nbr)+"\n            ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Remise : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.remise))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Avance à la location : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.avance)+" %\n            ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Etat du contrat : ")]),_vm._v(" "),(_vm.contratCourant.etat == 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                RESERVE\n              ")]):_vm._e(),_vm._v(" "),(_vm.contratCourant.etat == 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                ACTIF\n              ")]):_vm._e(),_vm._v(" "),(_vm.contratCourant.etat == 2)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("\n                TERMINE\n              ")]):_vm._e(),_vm._v(" "),(_vm.contratCourant.etat == 3)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                RESILIE\n              ")]):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Kilometrage à la sortie : ")]),_vm._v("\n              "+_vm._s(_vm.contratCourant.kilomSorti)+" Km\n            ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Conducteur : ")]),_vm._v(" "),(_vm.contratCourant.idCond != '')?_c('span',[_vm._v(_vm._s(_vm.contratCourant.conducteur))]):_c('span',[_vm._v("Aucun conducteur attribué")])]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enrégistrement : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.created)+"\n            ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.contratCourant.modified)+"\n            ")])])],1),_vm._v(" "),_c('br')],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogCalendContrat),callback:function ($$v) {_vm.dialogCalendContrat=$$v},expression:"dialogCalendContrat"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Calendrier des contrats de locations")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogCalendContrat = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('section',{staticClass:"calendar-page-side-section"},[_c('div',{staticClass:"row colors-guide-list",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"col-sm-3"},[_vm._v("\n                  Actif:\n                  "),_c('span',{staticStyle:{"height":"20px","width":"80px","display":"inline-block","background-color":"#27ae60"}}),_vm._v("\n                  Reservé:\n                  "),_c('span',{staticStyle:{"height":"20px","width":"80px","display":"inline-block","background-color":"#c0721d"}}),_vm._v("\n                  Terminé:\n                  "),_c('span',{staticStyle:{"height":"20px","width":"80px","display":"inline-block","background-color":"#3135c0"}}),_vm._v("\n                  Resilié:\n                  "),_c('span',{staticStyle:{"height":"20px","width":"80px","display":"inline-block","background-color":"#c0392b"}}),_vm._v("\n                  Expiré:\n                  "),_c('span',{staticStyle:{"height":"20px","width":"80px","display":"inline-block","background-color":"#bcbfc0"}})])])]),_vm._v(" "),_c('full-calendar',{attrs:{"config":_vm.config,"events":_vm.events},on:{"event-selected":_vm.eventSelected}})],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ctYl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cz/F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListeReserve_vue__ = __webpack_require__("Vj4D");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6033ab2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListeReserve_vue__ = __webpack_require__("bJnJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListeReserve_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6033ab2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListeReserve_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d5iX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","persistent":"","overlay":true,"scrollable":""},model:{value:(_vm.dialogAjoutCarteCaburant),callback:function ($$v) {_vm.dialogAjoutCarteCaburant=$$v},expression:"dialogAjoutCarteCaburant"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.editCarte.carteId == null)?_c('span',[_vm._v("\n            Ajouter une carte carburant\n          ")]):_c('span',[_vm._v("Modifier une carte carburant ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formCarte",staticClass:"demo-form-inline",attrs:{"id":"formCarte","model":_vm.formCarte,"rules":_vm.rules}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"ml-1",attrs:{"xs3":""}},[_c('el-form-item',{attrs:{"label":"Identifiant","prop":"identifiant"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.editCarte.carteId != null,"name":"identifiant","placeholder":"motif de la demande"},model:{value:(_vm.formCarte.identifiant),callback:function ($$v) {_vm.$set(_vm.formCarte, "identifiant", $$v)},expression:"formCarte.identifiant"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-1",attrs:{"xs3":""}},[_c('el-form-item',{attrs:{"label":"Libellé","prop":"libelle"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"motif de la demande"},model:{value:(_vm.formCarte.libelle),callback:function ($$v) {_vm.$set(_vm.formCarte, "libelle", $$v)},expression:"formCarte.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-1",attrs:{"xs3":""}},[_c('el-form-item',{attrs:{"label":"Montant initial","prop":"montant"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.editCarte.carteId != null,"min":0,"name":"montant","placeholder":"saisir un montant"},model:{value:(_vm.formCarte.montant),callback:function ($$v) {_vm.$set(_vm.formCarte, "montant", $$v)},expression:"formCarte.montant"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-1",attrs:{"xs3":""}},[_c('el-form-item',{attrs:{"label":"Zone","prop":"zone"}},[_c('el-autocomplete',{staticStyle:{"width":"100%"},attrs:{"name":"zone","placeholder":"nom de la zone","fetch-suggestions":_vm.loadZone},model:{value:(_vm.formCarte.zone),callback:function ($$v) {_vm.$set(_vm.formCarte, "zone", $$v)},expression:"formCarte.zone"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Responsable","prop":"responsable"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"nom du responsable"},model:{value:(_vm.formCarte.responsable),callback:function ($$v) {_vm.$set(_vm.formCarte, "responsable", $$v)},expression:"formCarte.responsable"}},_vm._l((_vm.responsables),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.text,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Fournisseur","prop":"station"}},[_c('el-autocomplete',{staticStyle:{"width":"100%"},attrs:{"name":"station","placeholder":"selectionner une station","fetch-suggestions":_vm.loadStation},model:{value:(_vm.formCarte.station),callback:function ($$v) {_vm.$set(_vm.formCarte, "station", $$v)},expression:"formCarte.station"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-1",attrs:{"xs5":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"description"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","row":25,"name":"description","placeholder":"description"},model:{value:(_vm.formCarte.description),callback:function ($$v) {_vm.$set(_vm.formCarte, "description", $$v)},expression:"formCarte.description"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){_vm.resetForm('formCarte');
                    _vm.closeDialog();}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.editCarte.carteId == null)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitForm('formCarte')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitForm('formCarte')}}},[_vm._v("Modifier"),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dNS9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
    name: "RapportDepannage",
    props: ["show", "demandeDetail"],
    data: function data() {
        return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),

            loading: false,
            dialogRapportDepannage: false,
            formRapport: {},
            dialogImageUrl: '',
            dialogVisible: false,
            fileList: [],
            //image
            image1: "/static/img-doc.png",
            image2: "/static/img-doc.png",
            image3: "/static/img-doc.png",
            image4: "/static/img-doc.png",
            file1: "",
            file2: "",
            file3: ""

        };
    },


    computed: {},
    watch: {
        show: function show(newValue, oldvalue) {
            this.dialogRapportDepannage = newValue;
        }
    },

    methods: {
        closeDialog: function closeDialog() {
            this.$emit('close');
        },
        handleRemove: function handleRemove(file, fileList) {},
        handleSuccess: function handleSuccess(response, file, fileList) {
            this.fileList.push(file);
        },
        handlePictureCardPreview: function handlePictureCardPreview(file, fileList) {
            this.dialogImageUrl = file.url;

            this.dialogVisible = true;
        },
        submitFormRapport: function submitFormRapport() {
            var _this = this;

            this.loading = true;
            var url = this.domaine + 'demande_maintenance/rapport/depannage';

            var form = document.getElementById('formRapport2');
            var data = new FormData(form);
            data.append("idDemande", this.demandeDetail.idDemande);
            data.append("rapport", this.formRapport.rapport);
            this.$http.post(url, data).then(function (response) {
                _this.closeDialog();
                _this.image1 = "/static/img-doc.png", _this.image2 = "/static/img-doc.png", _this.image3 = "/static/img-doc.png", _this.image = "/static/img-doc.png", _this.file1 = "", _this.file2 = "", _this.file3 = "", _this.loading = false;
                if (response.body.code == 5) {
                    _this.successNotif(response.body.message, "error");
                } else {
                    _this.successNotif(response.body.message);
                }
            }, function (erreurRep) {
                _this.$message.error("Une erreur est survenue lors de l'enregistrement du rapport de depannage");
            });
        },
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Rapport enregistrée avec succès";
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";

            this.$notify({
                title: 'ENREGISTREMENT RAPPORT',
                message: mess,
                type: type,
                position: 'top-center',
                duration: 5000
            });
        },

        //enregistrement des images
        onFileImage1Picked: function onFileImage1Picked(event) {
            var _this2 = this;

            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this2.image1 = fileReader.result;
            });

            fileReader.readAsDataURL(files[0]);
            this.file1 = files[0];
        },

        //enregistrement des images
        onFileImage2Picked: function onFileImage2Picked(event) {
            var _this3 = this;

            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this3.image2 = fileReader.result;
            });

            fileReader.readAsDataURL(files[0]);
            this.file2 = files[0];
        },


        //enregistrement des images
        onFileImage3Picked: function onFileImage3Picked(event) {
            var _this4 = this;

            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this4.image3 = fileReader.result;
            });

            fileReader.readAsDataURL(files[0]);
            this.file3 = files[0];
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "dPof":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutIntervention_vue__ = __webpack_require__("BKDk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc7d6916_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutIntervention_vue__ = __webpack_require__("PYhX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutIntervention_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc7d6916_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutIntervention_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dZfz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_besoinResponsable_vue__ = __webpack_require__("aibs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ee42248_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_besoinResponsable_vue__ = __webpack_require__("Wi44");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_besoinResponsable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ee42248_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_besoinResponsable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dZna":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chantier_index_vue__ = __webpack_require__("4Gjo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f8120d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chantier_index_vue__ = __webpack_require__("Ffyb");
function injectStyle (ssrContext) {
  __webpack_require__("kToK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chantier_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f8120d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chantier_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "daGC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gantt_vue__ = __webpack_require__("sUUh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f1767db_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gantt_vue__ = __webpack_require__("bRy7");
function injectStyle (ssrContext) {
  __webpack_require__("bnB3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f1767db"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gantt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f1767db_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gantt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dczU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ddrP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");


var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: "DetailBudgetChant",
  props: {
    show: {
      type: Boolean
    },
    detailChant: {
      type: Object
    }
  },
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      loading: false,
      dialogDetail: false,
      listeBudget: [],
      detailsBudget: [],
      bilanMensuel: [],
      bilanTravaux: [],
      listeDetail: [],
      compte: "0",
      listChargeResult: [],
      mntTotalChargeI: 0,
      dialogConfirm: false,
      disabledBtnPop: false,
      totalMntPropose: 0,
      totalMntValide: 0,
      totalMntantTravaux: 0
    };
  },


  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogDetail = newValue;
      if (newValue == true) {
        this.loadDetails(this.detailChant.idChant);
        this.loadBilan(this.detailChant.idChant);
      }
    }
  },

  methods: (_methods = {
    handleTabClick: function handleTabClick(tab) {
      switch (tab) {
        case "0":
          break;
        case "1":
          break;

        default:
          break;
      }
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getSumm: function getSumm(param) {
      var _this = this;

      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 5) {
          sums[index] = "N/A";
          return;
        }
        _this.totalMntantTravaux = 0;
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });
      this.totalMntantTravaux = sums;
      return sums;
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    getSummCompte: function getSummCompte(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getSummCompteFinance: function getSummCompteFinance(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 6) {
          sums[index] = "N/A";
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    },
    handleChange: function handleChange(newValue, oldValue) {},
    SubmitValideBudget: function SubmitValideBudget() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "compteExploit/valider/budget_chantier";
      var data = new FormData();
      var etat = false;

      for (var j = 0; j < this.listeBudget.length; j++) {
        this.listeBudget.forEach(function (item) {

          item["taches"].forEach(function (element) {

            var liste = element["detailBudget"];

            var nbData = 10;
            var nbReq = 1;
            var ligne = null;
            var details = null;
            var nbRest = void 0;
            if (liste.length > 10) {
              nbData = 10;
              nbReq = Math.round(liste.length / nbData);
              nbRest = liste.length % nbData;
              if (nbRest > 0) {
                nbReq += 1;
              }
            }
            for (var i = 0; i < nbReq; i++) {
              var initJ = i * nbData;
              var finJ = (i + 1) * nbData;
              var dataLot = [];

              if (liste.length > 0) {
                for (var _j = initJ; _j < finJ; _j++) {
                  if (liste[_j] == undefined) {
                    break;
                  }
                  dataLot.push(liste[_j]);

                  // if( liste[j]['etat'] === 0) {
                  //   dataLot.push(liste[j]);
                  // }
                }

                var _data = new FormData();
                for (var prop in dataLot) {
                  details = dataLot[prop];
                  _data.append("option[idBudget][]", details.idBudget);
                  // data.append("option[libelle][]", details.libelle);
                  // data.append("option[mntBudgetPropose][]",details.montantPropose);
                  _data.append("option[mntBudgetValide][]", details.montantValide);
                }

                _data.append("idUser", _this2.user.id);
                _data.append("idChantier", _this2.detailChant.idChant);
                _this2.$http.post(url, _data).then(function (resp) {
                  _this2.loading = false;
                  _this2.dialogConfirm = false;
                  // this.closeDialog();
                }, function (error) {
                  _this2.loading = false;
                  _this2.$message.error("Erreur lors de l'enregistrement des tarifs");
                });
              }
            }
          });
        });
      }
      this.closeDialog();
      this.dialogConfirm = false;
      this.loading = false;
      4591;

      this.$notify({
        title: "VALIDATION BUDGET",
        message: "l'operation c'est déroulé avec succès",
        type: "success",
        position: "top-right",
        duration: 5000
      });
      this.closeDialog();
    },
    headerRowStyle: function headerRowStyle(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return { color: "black" };
    },
    getSummDetailBudget: function getSummDetailBudget(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        // if (index === 5) {
        //   sums[index] = "N/A";
        //   return;
        // }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getSummCompte", function getSummCompte(param) {
    var columns = param.columns,
        data = param.data;

    var sums = [];
    columns.forEach(function (column, index) {
      if (index === 0) {
        sums[index] = "Sous total";
        return;
      }
      var values = data.map(function (item) {
        return Number(item[column.property]);
      });
      if (!values.every(function (value) {
        return isNaN(value);
      })) {
        sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
          var value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0));
      } else {
        sums[index] = "N/A";
      }
    });
    return sums;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "loadDetails", function loadDetails(idChant) {
    var _this3 = this;

    this.loading = true;
    var url = this.domaine + "compteExploit/budget/chantier/" + idChant;
    this.$http.get(url).then(function (resp) {
      _this3.loading = false;
      _this3.detailsBudget = resp.body.budgetsChantier;
      _this3.listeBudget = resp.body.budgetsChantier;
      _this3.totalMntPropose = 0;
      _this3.totalMntValide = 0;
      _this3.totalMntMarche = 0;
      _this3.listeBudget.forEach(function (item) {
        _this3.totalMntPropose += item.mntTotalBudgetPropose;
        _this3.totalMntValide += item.mntTotalBudgetValide;
      });

      // this.totalMntPropose = resp.body.mntTotalBugPropose;
      // this.totalMntValide = resp.body.mntTotalBugValide;
      //this.totalMntMarche = resp.body.mntTotalBugMarche;
    }, function (error) {
      _this3.loading = false;
      _this3.$message.error("Une erreur est survenue lors du chargement des budget");
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "loadBilan", function loadBilan(idChant) {
    var _this4 = this;

    this.loading = true;
    var url = this.domaine + "budgetChantier/bilan/chantier/" + idChant;
    this.$http.get(url).then(function (response) {
      _this4.loading = false;
      _this4.bilanMensuel = response.body.mensuel;
      _this4.bilanTravaux = response.body.bilanTravaux.travaux;
      _this4.listeDetail = response.body.detailCompte;
      _this4.listChargeResult = response.body.chargesIn;

      _this4.mntTotalChargeI = response.body.totalChargeI;
      // this.totalMntPropose = 0;
      // this.totalMntValide = 0;
      // this.totalMntMarche = 0;
      // this.bilanTravaux.details.forEach(item => {
      //   this.totalMntPropose += item.mntTotalBudgetPropose;
      //   this.totalMntValide += item.mntTotalBudgetValide;
      // });
    }, function (errRep) {
      _this4.loading = false;
      _this4.$message.error("Une erreur est survenue lors du chargement du bilan");
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "imprimeBudgtTravauxPDF", function imprimeBudgtTravauxPDF(type) {
    var url = "";
    if (type == "PDF") {
      url = this.domaine + "budgetChantier/budget/chantier/" + this.detailChant.idChant + "/user/" + this.user.id + "/imprimerPDF_budget_travaux";
    } else {
      url = this.domaine + "budgetChantier/budget/chantier/" + this.detailChant.idChant + "/user/" + this.user.id + "/imprimerEXC_budget_travaux";
    }
    window.open(url);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "imprimeBudgtTravauxPDFSimpl", function imprimeBudgtTravauxPDFSimpl(type) {
    var url = "";
    if (type == "PDF") {
      url = this.domaine + "budgetChantier/budget/chantier/" + this.detailChant.idChant + "/user/" + this.user.id + "/imprimerPDF_budget_travauxSimpl";
    } else {
      url = this.domaine + "budgetChantier/budget/chantier/" + this.detailChant.idChant + "/user/" + this.user.id + "/imprimerEXC_budget_travauxSimpl";
    }
    window.open(url);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "imprimeBudgtRecapitulatifAnnuel", function imprimeBudgtRecapitulatifAnnuel(type) {
    var url = "";
    if (type == "PDF") {
      url = this.domaine + "budgetChantier/budget/chantier/" + this.detailChant.idChant + "/user/" + this.user.id + "/imprimerPDF_RecapitulatifAnnuel";
    } else {
      url = this.domaine + "budgetChantier/budget/chantier/" + this.detailChant.idChant + "/user/" + this.user.id + "/imprimerEXC_RecapitulatifAnnuel";
    }
    window.open(url);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "imprimeBudgtRecapitulatifAnnuelSimpl", function imprimeBudgtRecapitulatifAnnuelSimpl(type) {
    var url = "";
    if (type == "PDF") {
      url = this.domaine + "budgetChantier/budget/chantier/" + this.detailChant.idChant + "/user/" + this.user.id + "/imprimerPDF_RecapitulatifAnnuelSimpl";
    } else {
      url = this.domaine + "budgetChantier/budget/chantier/" + this.detailChant.idChant + "/user/" + this.user.id + "/imprimerEXC_RecapitulatifAnnuelSimpl";
    }
    window.open(url);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "imprimeBudgtRecapitulatifTravaux", function imprimeBudgtRecapitulatifTravaux(type) {
    var url = "";
    if (type == "PDF") {
      url = this.domaine + "budgetChantier/budget/chantier/" + this.detailChant.idChant + "/user/" + this.user.id + "/imprimerPDF_RecapitulatifTravaux";
    } else {
      url = this.domaine + "budgetChantier/budget/chantier/" + this.detailChant.idChant + "/user/" + this.user.id + "/imprimerEXC_RecapitulatifTravaux";
    }
    window.open(url);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "imprimeBudgtRecapitulatifTravauxSimpl", function imprimeBudgtRecapitulatifTravauxSimpl(type) {
    var url = "";
    if (type == "PDF") {
      url = this.domaine + "budgetChantier/budget/chantier/" + this.detailChant.idChant + "/user/" + this.user.id + "/imprimerPDF_RecapitulatifTravauxSimpl";
    } else {
      url = this.domaine + "budgetChantier/budget/chantier/" + this.detailChant.idChant + "/user/" + this.user.id + "/imprimerEXC_RecapitulatifTravauxSimpl";
    }
    window.open(url);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "imprimeBudgtRecapitulatifFinance", function imprimeBudgtRecapitulatifFinance(type) {
    var url = "";
    if (type == "PDF") {
      url = this.domaine + "budgetChantier/budget/chantier/" + this.detailChant.idChant + "/user/" + this.user.id + "/imprimerPDF_RecapitulatifFinancier";
    } else {
      url = this.domaine + "budgetChantier/budget/chantier/" + this.detailChant.idChant + "/user/" + this.user.id + "/imprimerEXC_RecapitulatifFinancier";
    }
    window.open(url);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "imprimeBudgtRecapitulatifFinanceSimpl", function imprimeBudgtRecapitulatifFinanceSimpl(type) {
    var url = "";
    if (type == "PDF") {
      url = this.domaine + "budgetChantier/budget/chantier/" + this.detailChant.idChant + "/user/" + this.user.id + "/imprimerPDF_RecapitulatifFinancierSimpl";
    } else {
      url = this.domaine + "budgetChantier/budget/chantier/" + this.detailChant.idChant + "/user/" + this.user.id + "/imprimerEXC_RecapitulatifFinancierSimpl";
    }
    window.open(url);
  }), _methods),
  mounted: function mounted() {}
});

/***/ }),

/***/ "dzy+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drawer_vue__ = __webpack_require__("H7ti");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cd1acba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drawer_vue__ = __webpack_require__("FejV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drawer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cd1acba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drawer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eB9y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ea37":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticStyle:{"padding":"0px"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm6":""}},[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},[_c('v-breadcrumbs-item',[_vm._v("RECHERCHE GENERALE")])],1)],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-form',{ref:"formRech",attrs:{"lazy-validation":"","id":"formRech"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":""}},[_c('el-radio',{attrs:{"label":"commande"},model:{value:(_vm.typeRech),callback:function ($$v) {_vm.typeRech=$$v},expression:"typeRech"}},[_vm._v("Commande")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"facture"},model:{value:(_vm.typeRech),callback:function ($$v) {_vm.typeRech=$$v},expression:"typeRech"}},[_vm._v("Facture")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"livraison"},model:{value:(_vm.typeRech),callback:function ($$v) {_vm.typeRech=$$v},expression:"typeRech"}},[_vm._v("Livraison")])],1),_vm._v(" "),(_vm.typeRech== 'commande')?_c('v-flex',{attrs:{"md4":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"clearable":"","name":"commande","placeholder":"reference"},model:{value:(_vm.formRecherche.commande),callback:function ($$v) {_vm.$set(_vm.formRecherche, "commande", $$v)},expression:"formRecherche.commande"}})],1):_vm._e(),_vm._v(" "),(_vm.typeRech== 'facture')?_c('v-flex',{attrs:{"md4":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"clearable":"","name":"facture","placeholder":"reference"},model:{value:(_vm.formRecherche.facture),callback:function ($$v) {_vm.$set(_vm.formRecherche, "facture", $$v)},expression:"formRecherche.facture"}})],1):_vm._e(),_vm._v(" "),(_vm.typeRech== 'livraison')?_c('v-flex',{attrs:{"md4":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"clearable":"","name":"livraison","placeholder":"reference"},model:{value:(_vm.formRecherche.livraison),callback:function ($$v) {_vm.$set(_vm.formRecherche, "livraison", $$v)},expression:"formRecherche.livraison"}})],1):_vm._e(),_vm._v(" "),(_vm.typeRech== 'commande' ||_vm.typeRech== 'livraison' || _vm.typeRech== 'facture')?_c('v-flex',{attrs:{"md5":""}},[_c('el-select',{attrs:{"filterable":"","multiple":"","clearable":"","placeholder":"Fournisseur"},model:{value:(_vm.selectFourn),callback:function ($$v) {_vm.selectFourn=$$v},expression:"selectFourn"}},_vm._l((_vm.listFourn),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-btn',{attrs:{"icons":"","color":"blue","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.recherche()}}},[_c('v-icon',[_vm._v("search")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-card',{staticClass:"elevation-4"},[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan darken-2","dark":""}},[_c('v-toolbar-title',[_vm._v("Resultat de la recherche "+_vm._s(_vm.typeRech))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center",staticStyle:{"height":"auto"}},[(_vm.nomFourn)?_c('v-flex',{attrs:{"xs6":""}},[_c('v-chip',{staticClass:"elevation-4 text-xs-left",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.typeRech)+" passée chez le fournisseur :   ")]),_vm._v(" "),_c('span',{staticClass:"title text-xs-left"},[_vm._v("  "+_vm._s(_vm.nomFourn)+" ")])])],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.showButon)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.generateFile('pdf','simple')}},slot:"activator"},[_vm._v("\n                                          Exporter en Pdf\n                                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1):_vm._e(),_vm._v("Pdf\n                                        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.showButonExcel)?_c('v-btn',{attrs:{"slot":"activator","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.generateFile('excel','simple')}},slot:"activator"},[_vm._v("\n                                          Exporter en Excel\n                                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1):_vm._e(),_vm._v("Excel\n                                        ")],1)],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","header-row-style":_vm.headerRowStyle,"highlight-current-row":"","data":_vm.listResulat,"summary-method":_vm.getSumm,"show-summary":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(_vm.typeRech =='commande' && props.row.commande)?_c('div',[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(" "+_vm._s(props.row.commande.length)+" ")]),_vm._v("\n                                                Commande(s) trouvée(s)\n                                              ")],1)],1),_vm._v(" "),_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label ")]),_vm._v(" "),_c('span',[_vm._v("COMMANDE")])],1),_vm._v(" "),_c('el-table',{staticClass:"elevation-2",staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":props.row.commande,"summary-method":_vm.getSumm,"show-summary":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Liste des ressources")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1 mt-3",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('el-table',{staticClass:"elevation-2",staticStyle:{"width":"100%"},attrs:{"row-class-name":_vm.tableRowClassName,"data":props.row.option,"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"show-summary":""}},[_c('el-table-column',{staticStyle:{"width":"100%"},attrs:{"prop":"produit","label":"Ressource","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                                          "+_vm._s(scope.row
                                                                            .produit)+"\n                                                                        ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixUOld","label":"Ancien prix","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                                           "+_vm._s(new Intl.NumberFormat(
                                                                            "fr-FR"
                                                                          ).format(
                                                                            scope.row
                                                                              .prixUOld
                                                                          ))+"\n                                                                        ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix unitaire","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(new Intl.NumberFormat(
                                                                            "fr-FR"
                                                                          ).format(
                                                                            scope.row
                                                                              .prix
                                                                          )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantié"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(new Intl.NumberFormat(
                                                                            "fr-FR"
                                                                          ).format(
                                                                            scope.row
                                                                              .qte
                                                                          )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unite"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(scope.row
                                                                            .unite))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remise","label":"Remise %"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(new Intl.NumberFormat(
                                                                            "fr-FR"
                                                                          ).format(
                                                                            scope.row
                                                                              .remise
                                                                          )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"Tva %"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(new Intl.NumberFormat(
                                                                            "fr-FR"
                                                                          ).format(
                                                                            scope.row
                                                                              .tva
                                                                          )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Total TTC (FCFA)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(new Intl.NumberFormat(
                                                                            "fr-FR"
                                                                          ).format(
                                                                            scope.row
                                                                              .total
                                                                          )))])]}}],null,true)})],1)],1)],1)],1)],1)],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"ref","sortable":"","label":"Réference"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                  "+_vm._s(scope.row.ref)+"\n                                              ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"libelle","label":"projet/chantier/travaux"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                  "+_vm._s(scope.row.projet)+" / "+_vm._s(scope.row.chantier)+" /"+_vm._s(scope.row.travaux)+"\n                                              ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"libelle","label":"Description"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"userCreated","label":"Crée par"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                  "+_vm._s(scope.row.userCreated)+"\n                                              ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"created","label":"Date de création"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                    "+_vm._s(scope.row.created)+"\n                                                ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"totalCommande","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(prop3){return [_c('el-tag',{staticClass:"subheading"},[_vm._v(_vm._s(new Intl.NumberFormat().format(prop3.row.totalCommande))+" FCFA")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"etat","label":"Etat"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.factureValide === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                      FACTURE VALIDE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.factureValide === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                      FACTURE REJETE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                      NON LIVRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat == true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                      LIVRE EN TOTALITE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}],null,true)})],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.typeRech =='facture' && props.row.facture)?_c('div',[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(" "+_vm._s(props.row.facture.length)+" ")]),_vm._v("\n                                                Facture(s) trouvée(s)\n                                              ")],1)],1),_vm._v(" "),_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label ")]),_vm._v(" "),_c('span',[_vm._v("DEVIS/FACTURE")])],1),_vm._v(" "),_c('el-table',{staticClass:"elevation-2",staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":props.row.facture,"summary-method":_vm.getSumm,"show-summary":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Liste des ressources")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1 mt-3",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('el-table',{staticClass:"elevation-2",staticStyle:{"width":"100%"},attrs:{"row-class-name":_vm.tableRowClassName,"data":props.row.option,"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"show-summary":""}},[_c('el-table-column',{staticStyle:{"width":"100%"},attrs:{"prop":"produit","label":"Ressource","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                                          "+_vm._s(scope.row
                                                                            .produit)+"\n                                                                        ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix unitaire","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(new Intl.NumberFormat(
                                                                            "fr-FR"
                                                                          ).format(
                                                                            scope.row
                                                                              .prix
                                                                          )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantié"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(new Intl.NumberFormat(
                                                                            "fr-FR"
                                                                          ).format(
                                                                            scope.row
                                                                              .qte
                                                                          )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unite"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(scope.row
                                                                            .unite))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remise","label":"Remise %"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(scope.row
                                                                              .remise))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"Tva %"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(scope.row
                                                                              .tva))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Total TTC (FCFA)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(new Intl.NumberFormat(
                                                                            "fr-FR"
                                                                          ).format(
                                                                            scope.row
                                                                              .total
                                                                          )))])]}}],null,true)})],1)],1)],1)],1)],1)],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"ref","sortable":"","label":"Réference"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                  "+_vm._s(scope.row.ref)+"\n                                              ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"libelle","label":"projet/chantier/travaux"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                  "+_vm._s(scope.row.projet)+" / "+_vm._s(scope.row.chantier)+" / "+_vm._s(scope.row.travaux)+"\n                                              ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"libelle","label":"Description"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"created","label":"Date de création"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                    "+_vm._s(scope.row.created)+"\n                                                ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"total","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(prop3){return [_c('el-tag',{staticClass:"subheading"},[_vm._v(_vm._s(new Intl.NumberFormat().format(prop3.row.total))+" FCFA")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"etat","label":"Etat"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etatFact === 0)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                                      EN ATTENTE DE VALIDATION"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etatFact === 1)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                                      VALIDE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etatFact === 2)?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                                      REJETE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat === 'IMPAYE')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                      "+_vm._s(scope.row.etat)+"\n                                                  ")]):_vm._e(),_vm._v(" "),(scope.row.etat === 'PAYE')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                      "+_vm._s(scope.row.etat)+"\n                                                  ")]):_vm._e(),_vm._v(" "),(scope.row.etat === 'EN COURS DE PAIEMENT')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                      "+_vm._s(scope.row.etat)+"\n                                                  ")]):_vm._e(),_vm._v(" "),(scope.row.etat === 'EN ATTENTE DE PAIEMENT')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                      "+_vm._s(scope.row.etat)+"\n                                                  ")]):_vm._e()]}}],null,true)})],1)],1):_vm._e(),_vm._v(" "),(_vm.typeRech =='livraison' && props.row.livraison)?_c('div',[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(" "+_vm._s(props.row.livraison.length)+" ")]),_vm._v("\n                                                Livraison(s) trouvée(s)\n                                              ")],1)],1),_vm._v(" "),_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label ")]),_vm._v(" "),_c('span',[_vm._v("LIVRAISON")])],1),_vm._v(" "),_c('el-table',{staticClass:"elevation-2",staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":props.row.livraison,"summary-method":_vm.getSumm,"show-summary":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Liste des ressources livrées")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1 mt-3",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('el-table',{staticClass:"elevation-2",staticStyle:{"width":"100%"},attrs:{"row-class-name":_vm.tableRowClassName,"data":props.row.livre,"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"show-summary":""}},[_c('el-table-column',{staticStyle:{"width":"100%"},attrs:{"prop":"produit","label":"Ressource","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                                          "+_vm._s(scope.row
                                                                            .produit)+"\n                                                                        ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteL","label":"Quantité livré","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(scope.row
                                                                              .qteL))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteR","label":"Quantité restant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(scope.row
                                                                            .qteR))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixU","label":"Prix unitaire"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(new Intl.NumberFormat(
                                                                            "fr-FR"
                                                                          ).format(
                                                                          scope.row
                                                                            .prixU)))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remise","label":"Remise"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(scope.row
                                                                            .remise))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"Tva %"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(scope.row.tva))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalTtc","label":"Total TTC"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(new Intl.NumberFormat(
                                                                            "fr-FR"
                                                                          ).format(
                                                                          scope.row
                                                                            .totalTtc)))])]}}],null,true)})],1)],1)],1)],1)],1)],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"ref","sortable":"","label":"Réference"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                  "+_vm._s(scope.row.ref)+"\n                                              ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"comRef","label":"Ref commande"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                      "+_vm._s(scope.row.comRef)+" "+_vm._s(scope.row.libelle)+" "),_c('v-icon',{attrs:{"right":""}})],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"refact","label":"Ref facture"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                  "+_vm._s(scope.row.refact)+"\n                                              ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"created","label":"Date de création"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                    "+_vm._s(scope.row.created)+"\n                                                ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"etat","label":"Etat"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat === false)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                                      PARTIELLEMENT LIVRE "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat === true)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                                      TOTALEMENT LIVRE "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}],null,true)})],1)],1):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"fournisseurNom","label":"Fournisseur"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(_vm._s(prop.row.fournisseurNom))])]}}])}),_vm._v(" "),(_vm.typeRech !='livraison')?_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"totalGlobal","label":"Total commande"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v("\n                                        "+_vm._s(new Intl.NumberFormat().format(prop.row.totalGlobal))+" FCFA\n                                        ")])]}}],null,false,3006142245)}):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowCommande),callback:function ($$v) {_vm.dialogShowCommande=$$v},expression:"dialogShowCommande"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Détails de la commande "+_vm._s(_vm.detailCommande.ref)+" "+_vm._s(_vm.detailCommande.libelle)+" ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowCommande = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"Veuillez patientez ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.ref)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libellé : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.libelle)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de la commande : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.dateC)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de la livraison : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.dateLivr)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Statut : ")]),_vm._v(" "),(_vm.detailCommande.factureValide === 0)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                                          EN ATTENTE DE VALIDATION"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailCommande.factureValide === 1)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                                          VALIDE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailCommande.factureValide === 2)?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                                          REJETE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Enregistré par: ")]),_vm._v(" "+_vm._s(_vm.detailCommande.userCreated)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),(_vm.detailCommande.etat === false)?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                                          NON LIVRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailCommande.etat == true)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                                          LIVRE EN TOTALITE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.modified)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Projet : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.projet)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Modalité : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.modalite)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Avance démarage(%) : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.avance)+" ")])])],1),_vm._v(" "),(_vm.detailCommande.compare == 2)?_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_c('a',{attrs:{"href":"#","target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":"static/validComparateur.png"}})])],1)])],1):_vm._e()],1)]),_vm._v(" "),_c('el-row',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"stripe":"","data":_vm.detailCommande.user}},[_c('el-table-column',{attrs:{"prop":"nom","label":"Personnes concernées","width":"180"}})],1)],1)],1)])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"wrap":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"29px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                      MONTANT REMISE : "+_vm._s(_vm.totalComRemise)+" FCFA\n                                                  ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"29px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                      MONTANT HT : "+_vm._s(_vm.totalComHT)+" FCFA\n                                                  ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"29px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                      MONTANT TVA : "+_vm._s(_vm.totalComTVA)+" FCFA\n                                                  ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"29px"},attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                                      MONTANT TTC : "+_vm._s(_vm.detailCommande.total)+" FCFA\n                                                  ")])],1)],1)],1)])],1)])],1),_vm._v(" "),_c('el-card',[_c('v-card',[_c('img',{attrs:{"height":"100px","src":_vm.detailCommande.imgCommande,"alt":_vm.detailCommande.imgCommande}}),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"target":"_blank","href":_vm.detailCommande.imgCommande,"flat":"","color":"orange"}},[_vm._v("Voir le document")])],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":7}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailCommande.option,"height":"250"}},[_c('el-table-column',{attrs:{"prop":"produit","label":"Ressource","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"TVA (18%)","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix unitaire (FCFA)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remise","label":"Remise(%)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Total TTC (FCFA)"}})],1)]],2)],1)])],1),_vm._v(" "),(_vm.optionLivr.length > 1)?_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":7}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"25px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              TOUTES LES LIVRAISONS CONCERNANT LA COMMANDE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("redeem")])],1)],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.optionLivr,"height":"250"}},[_c('el-table-column',{attrs:{"prop":"id","label":"Référence","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat === true)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                                  TOTALEMENT LIVRE\n                                              ")]):_vm._e(),_vm._v(" "),(scope.row.etat === false)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                                  PARTIELLEMENT LIVRE\n                                              ")]):_vm._e()]}}],null,false,2961946082)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"livreur","label":"Livreur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date de livraison"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-popover',{attrs:{"trigger":"click","placement":"left"}},[_c('div',{staticClass:"name-wrapper",attrs:{"slot":"reference"},slot:"reference"},[_c('el-button',{attrs:{"size":"mini","type":"primary"}},[_vm._v("Détails")])],1),_vm._v(" "),_c('p',[_vm._v("Livreur : "+_vm._s(scope.row.livreur))]),_vm._v(" "),_c('p',[_vm._v("Date de livraison: "+_vm._s(scope.row.date))]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":scope.row.livre,"height":"250"}},[_c('el-table-column',{attrs:{"prop":"produit","label":"Ressource","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteL","label":"Quantité livré","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteR","label":"Quantité restant"}})],1)],1)]}}],null,false,2427286843)})],1)],1)],1)])],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"error","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowCommande = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n                      Fermer\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerCommande(_vm.detailCommande);}},slot:"activator"},[_vm._v("Imprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("\n                      Imprimer le bon de commande\n                  ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowFacture),callback:function ($$v) {_vm.dialogShowFacture=$$v},expression:"dialogShowFacture"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Détails de la facture "+_vm._s(_vm.detailFacture.ref)+" "+_vm._s(_vm.detailFacture.libelle)+" ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowFacture = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"Veuillez patientez ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":14}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('el-alert',{attrs:{"title":"Vous ne pouvez pas modifier une facture issue d'une commande","type":"warning","closable":false,"center":"","show-icon":""}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.ref)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libellé : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.libelle)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Référence commande : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.refCom)+" ")]),_vm._v(" "),(_vm.detailFacture.typeFact === true)?_c('p',[_c('b',[_vm._v("Commande concerné : ")]),_vm._v(" COM-"+_vm._s(_vm.detailFacture.id)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.typeFact === false)?_c('p',[_c('b',[_vm._v("Maintenance concerné : ")]),_vm._v(" MAIN-"+_vm._s(_vm.detailFacture.id)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.typeFact === true)?_c('p',[_c('b',[_vm._v("Date de la commande : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.dateC)+" ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Total ttc de la facture : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.total)+" FCFA")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Statut : ")]),_vm._v(" "),(_vm.detailFacture.etatFact === 0)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                                          EN ATTENTE DE VALIDATION"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailFacture.etatFact === 1)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                                          VALIDE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailFacture.etatFact === 2)?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                                          REJETE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Enregistré par : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.userCreated)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Caisse concerné : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.libelleCaisse)+" ")]),_vm._v(" "),(_vm.detailFacture.modalite !== null)?_c('p',[_c('b',[_vm._v("Modalité de règlement : ")]),_vm._v("\n                                                      "+_vm._s(_vm.detailFacture.modalite)+"\n                                                  ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.avance !== null)?_c('p',[_c('b',[_vm._v("Avance demarage : ")]),_vm._v("\n                                                      "+_vm._s(_vm.detailFacture.avance)+"\n                                                  ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.datePaie !== null)?_c('p',[_c('b',[_vm._v("Date de paiement : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.datePaie)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.remarqueFact !== null)?_c('p',[_c('b',[_vm._v("Remarque : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.remarqueFact)+" ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.modified)+" ")])])],1)],1)])],1)])],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"wrap":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"23px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                      MONTANT REMISE : "+_vm._s(_vm.totalComRemise)+" FCFA\n                                                  ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"23px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                      MONTANT HT : "+_vm._s(_vm.totalComHT)+" FCFA\n                                                  ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"23px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                      MONTANT TVA : "+_vm._s(_vm.totalComTVA)+" FCFA\n                                                  ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"23px"},attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                                      MONTANT TTC : "+_vm._s(_vm.detailFacture.total)+" FCFA\n                                                  ")])],1)],1)],1)]),_vm._v(" "),_c('el-row',[(_vm.detailFacture.imagefact !='' )?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"ml-3  elevation-5 ",attrs:{"xs3":""}},[_c('a',{attrs:{"href":_vm.detailFacture.imagefact,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.detailFacture.imagefact}})])],1)])],1):_vm._e()],1)],1)])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":7}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailFacture.option,"height":"250"}},[_c('el-table-column',{attrs:{"prop":"produit","label":"Ressource","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"TVA(%) ","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix unitaire (FCFA)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remise","label":"Remise(%)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Total TTC (FCFA)"}})],1)]],2)],1)])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"error","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowFacture = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n                      Fermer\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerFacture(_vm.detailFacture);}},slot:"activator"},[_vm._v("Imprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("\n                      Imprimer la facture\n                  ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowLivraison),callback:function ($$v) {_vm.dialogShowLivraison=$$v},expression:"dialogShowLivraison"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Détails de la livraison "+_vm._s(_vm.livraisonCourant.ref)+" "+_vm._s(_vm.livraisonCourant.libelle)+" ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowLivraison = false, _vm.showBoat = false, _vm.showConteneurs = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"Veuillez patientez ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-col',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.livraisonCourant.ref)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Référence facture : ")]),_vm._v(" "+_vm._s(_vm.livraisonCourant.refact))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Référence commande : ")]),_vm._v(" "+_vm._s(_vm.livraisonCourant.comRef)+" "+_vm._s(_vm.livraisonCourant.libelle))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de la livraison : ")]),_vm._v(" "+_vm._s(_vm.livraisonCourant.created)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),(_vm.livraisonCourant.etat === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                          PARTIELLEMENT LIVRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.livraisonCourant.etat === true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                          TOTALEMENT LIVRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v(" "+_vm._s(_vm.livraisonCourant.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.livraisonCourant.modified)+" ")])])],1)],1)])],1)])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":7}},[_c('el-card',{staticClass:"box-card"},[_c('v-card',[_c('img',{attrs:{"height":"100px","src":_vm.livraisonCourant.imgLivraison,"alt":_vm.livraisonCourant.imgLivraison}}),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"target":"_blank","href":_vm.livraisonCourant.imgLivraison,"flat":"","color":"orange"}},[_vm._v("Voir le document")])],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":7}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.livraisonCourant.livre,"height":"250"}},[_c('el-table-column',{attrs:{"prop":"produit","label":"Ressource","width":"280"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteL","label":"Quantité livré"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteR","label":"Quantité restant"}})],1)]],2)],1)])],1),_vm._v(" "),(_vm.showBoat)?_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-col',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Reference export : ")]),_vm._v(" "+_vm._s(_vm.detailLivraison[0].export)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Numéro de commande : ")]),_vm._v(" "+_vm._s(_vm.detailLivraison[0].numComBat)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Numéro BL : ")]),_vm._v(" "+_vm._s(_vm.detailLivraison[0].numBonLivraison)+"  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Lieu de réception : ")]),_vm._v(" "+_vm._s(_vm.detailLivraison[0].recepetionConteneur)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Numéro de chargement :  ")]),_vm._v("\n                                                      "+_vm._s(_vm.detailLivraison[0].numCpteLivraison)+"\n                                                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Numéro de voyage :  ")]),_vm._v("\n                                                      "+_vm._s(_vm.detailLivraison[0].numVoyage)+"\n                                                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v(" "+_vm._s(_vm.detailLivraison[0].created)+"  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailLivraison[0].modified)+" ")])])],1)],1)])],1)])],1)],1):_vm._e(),_vm._v(" "),(_vm.showConteneurs)?_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailLivraison[0].conteneurs}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',[_c('el-col',{attrs:{"span":5}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('b',[_vm._v("Description")]),_vm._v(" : "),_c('p',[_vm._v(_vm._s(props.row.description))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":19}},[_c('div',[_c('b',[_vm._v("Articles")]),_vm._v(" :\n                                          ")]),_vm._v(" "),_c('div',{staticClass:"elevation-3"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":props.row.articles}},[_c('el-table-column',{attrs:{"prop":"code","label":"Code"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"designation","label":"Désignation"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tourtes","label":"Tourtes"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"metrage","label":"Metrage"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"poidsBrute","label":"Poids Brut (kg)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"poidsNet","label":"Poids Net (kg)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tare","label":"Tare (kg)"}})],1)],1)])],1)]}}],null,false,3514290487)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"marque","label":"Marque","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(item){return [_vm._v("\n                                  "+_vm._s(item.row.marque)+"\n                              ")]}}],null,false,385302178)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"numeroConte","label":"Numéro Conteneur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"numCle","label":"Numéro clé"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"poidsCargot","label":"Poids cargot"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nbPacket","label":"Nombre de packet"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tare","label":"Tare"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mesure","label":"Mesure"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"error","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowLivraison = false, _vm.showBoat = false, _vm.showConteneurs = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n                      Fermer\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","dark":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerLivraison(_vm.livraisonCourant)}},slot:"activator"},[_vm._v(" Imprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("\n                      Imprimer la livraison\n                  ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ebYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Validation_dga_index_vue__ = __webpack_require__("M0d+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ffcf136_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Validation_dga_index_vue__ = __webpack_require__("jBBu");
function injectStyle (ssrContext) {
  __webpack_require__("QEk4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9ffcf136"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Validation_dga_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ffcf136_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Validation_dga_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ebtw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompteExploitationProjet_vue__ = __webpack_require__("Opqa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f41e572_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompteExploitationProjet_vue__ = __webpack_require__("EgS3");
function injectStyle (ssrContext) {
  __webpack_require__("0/Gr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompteExploitationProjet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f41e572_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompteExploitationProjet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "epPJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_besoin_ModalCommandeDetails__ = __webpack_require__("Dbyj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_besoin_ModalCommandeMAJ__ = __webpack_require__("OXnm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_comparateur_ModalComparateurCmd__ = __webpack_require__("9W7p");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3__components_Loading__["a" /* default */],
    ModalCommandeDetails: __WEBPACK_IMPORTED_MODULE_4__components_besoin_ModalCommandeDetails__["a" /* default */],
    ModalCommandeMAJ: __WEBPACK_IMPORTED_MODULE_5__components_besoin_ModalCommandeMAJ__["a" /* default */],
    ModalComparateurCmd: __WEBPACK_IMPORTED_MODULE_6__components_comparateur_ModalComparateurCmd__["a" /* default */]
  },
  name: "Besoin",
  data: function data() {
    var _ref;

    return _ref = {
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      valid: true,
      factNull: false,
      choix: true,
      racourcis: [{ path: "/", text: "Accueil", disabled: false }, { path: "/projet", text: "Liste des besoins", disabled: true }],
      priorites: [{
        value: 1,
        label: "Faible"
      }, {
        value: 2,
        label: "Normal"
      }, {
        value: 3,
        label: "Urgent"
      }],
      EtatConfirmation: [{
        value: 0,
        label: "Approuvé"
      }, {
        value: 1,
        label: "En attente"
      }],
      hiddenButton: false,
      notification: 0,
      notifCommande: 0,
      showModalDetailCom: false,
      selectEtatPrioriteBesoin: null,
      selectEtatConfirmationBesoin: null,
      oldComboUser: [],
      selectEtatService: null,
      comboService: [],
      idBesoin: "",
      idCommande: "",
      commDec: '',
      dialogSupr: false,
      dialogImprCommande: false,
      dialogImprCommande1: false,
      dialogCOmmande: false,
      disabledBtnValide: true,
      dialogBesoin: false,
      dialogComm: false,
      dialogEdit: false,
      listBesoin: [],
      dialogAccord: false,
      dialogAccord2: false,
      dialogValidMission: false,
      dialogRejeterMission: false,
      dialogShowEditRessource: false,
      tacheSelectioner: [],
      commCourant: [],
      items: [],
      index: null,
      formEditRessource: {
        id: '',
        libelle: '',
        qte: 0,
        dateF: '',
        dateD: ''
      },
      etat: 0,
      selectBci: '',
      selectValidateur: '',
      nombreSelection: 0,
      nombreBonSelection: 0,
      optionBesoin: [{ type: "", key: 1, value: "", qte: 1, unite: "", id: "", priorite: 1 }],
      optionProduit: [{ type: "", key: 1, produit: "", qte: 1, unite: "", priorite: "" }],
      listProd: [],
      libelle: "",
      dateLivr: "",
      priorite: 1,
      besoinCourant: [],
      listeProduitAffich: [],
      listeVehicule: [],
      infOrenseigner: [{
        libelle: '',
        dateLivr: '',
        priorite: ''
      }],
      optionCommande: [{
        key: 1,
        produit: "",
        codeGestion: "",
        prix: 0,
        qte: 1,
        tva: 0,
        total: 0,
        id: "",
        priorite: 1
      }],
      totalComTTC: 0,
      totComLigneTTCFormat: 0,
      totalComHT: 0,
      totalComTVA: 0,
      totComLigneTTC: 0,
      listFour: [],
      formInventaire: {},
      tableInventaire: [],
      selectFourn: "",
      listCommande: [],
      detailCommande: null,

      //filtre
      oldListBesoin: [],
      produitUnite: "",
      listBesoinAttente: [],
      tab: "",

      // POUR BON 
      listBonCommande: [],
      oldListBonCommande: [],
      notifBonCommande: []
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "oldListBonCommande", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectEtatDemandeur", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectEtatDate", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "comboUser", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dateCreated", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "typeProduit", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "oldListCommande", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectEtatPrioriteCommande", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectEtatDateCommande", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "activDerouler", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "disabledImprime", true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showModalModifCom", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listTypeRessource", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listeProjet", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listeChantier", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listeTravaux", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listeTacheTrx", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "temp", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "projetS", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "chantierS", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "travauxS", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tacheS", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "valeurUniteMateriel", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "commandeDeriv", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "commandeDerivDeux", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showModalCompCmd", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dialogDetailCmd", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "mntTotalCmd", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "nbCommandeSug", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "nbCommandeSugDeux", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "typeDmd", "Projet"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listDemande", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectDemande", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "disabledChamp", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dateLivrSouh", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "idTravaux", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "projetLib", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "chantieretLib", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "entrepotLib", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "travuxLib", ""), _ref;
  },


  methods: {
    //recherche le prix fournisseur pour les produits selection
    handleChangeFour: function handleChangeFour(idFour) {
      var _this = this;

      var url = this.domaine + "fournisseur/info/produit";
      this.loading = true;
      var data = new FormData();

      var produits = new Array();
      var i = void 0;
      for (i = 0; i < this.optionCommande.length; i++) {
        produits[i] = this.optionCommande[i].idProd;
      }

      data.append("produits", produits);
      data.append("fournisseur", idFour);

      this.$http.post(url, data).then(function (response) {
        var produits = response.body.produits;
        _this.loading = false;
        _this.optionCommande.forEach(function (item, index, array, $this) {
          var $idProd = item.idProd;
          var produitFind = produits.find(function (prod) {
            return prod.id == $idProd;
          });

          array[index].prix = produitFind.prix;
        });
      }, function (error) {
        _this.loading = false;
      });
    },
    showDiapo: function showDiapo(images, ind, image) {
      this.items = images;
      this.index = ind;
    },
    molalValidation: function molalValidation(row, etat, validateur) {
      if (etat == 'OUI') {
        this.dialogAccord2 = true;
      } else {
        this.dialogRejeterMission = true;
      }
      this.selectBci = row.id;
      this.selectValidateur = validateur;
    },

    //afficher le formulaire d'une commande
    showFormCommande: function showFormCommande() {
      //on determine le nombre de produit corespondant
      var comp = 0;
      var temp = [];
      this.factNull = false;
      this.optionCommande.splice(0);
      for (var index = 0; index < this.multipleSelection.length; index++) {
        var element1 = this.multipleSelection[0]["travauxId"];
        // let element2 = this.multipleSelection[0]["idProd"];
        var magasin1 = this.multipleSelection[0]["entrepotId"];
        var element = this.multipleSelection[index]["travauxId"];
        var element2 = this.multipleSelection[index]["entrepotId"];

        if (element1 != '') {
          if (element1 == element) {
            comp++;
          } else {
            this.factNull = true;
            // this.$refs.multipleTable.toggleRowSelection(
            //   this.multipleSelection[index]
            // );
          }
        } else {
          if (magasin1 == element2) {
            comp++;
          } else {
            this.factNull = true;
            this.$refs.multipleTable.toggleRowSelection(this.multipleSelection[index]);
          }
        }
      }
      if (this.multipleSelection.length == comp && this.factNull === false) {
        var multipleSelection1 = this.multipleSelection;

        var tableau = multipleSelection1;
        for (var i = 0; i < tableau.length; ++i) {
          for (var j = i + 1; j < tableau.length; ++j) {
            if (tableau[i].idProd === tableau[j].idProd) {
              tableau[i].qte = tableau[i].qte + tableau[j].qte;
              tableau.splice(j--, 1);
            }
          }
        }
        this.optionCommande = tableau;
        // this.dateLivr = th/
        this.idTravaux = this.multipleSelection[0]['idTravaux'];
        this.projetLib = this.multipleSelection[0]["projet"];
        this.dateLivr = this.multipleSelection[0]["dateLivr"];
        this.chantieretLib = this.multipleSelection[0]["chantier"];
        this.entrepotLib = this.multipleSelection[0]["libEntrepot"];
        this.travuxLib = this.multipleSelection[0]["travaux"];
        this.libelle = this.multipleSelection[0]["libelle"] ? this.multipleSelection[0]["libelle"] : '';
        this.hiddenButton = this.libelle != '' ? true : false;

        this.selectFourn = '';
        this.dialogComm = true;
        this.disabledChamp = false;
      } else {
        this.$notify({
          title: "Fusion",
          message: "Impossible de lier ces besoins pour la commande. Veuillez selectionner des besoins émit pour les mêmes Travaux / pour les mêmes entrepots",
          type: "error",
          position: "top-center"
        });
      }
    },
    besoinBonSelect: function besoinBonSelect(row, index) {
      var etat = null;
      if (parseFloat(row.qte) != 0) {
        etat = true;
      } else {
        etat = false;
      }
      return etat;
    },
    showForGenererCommande: function showForGenererCommande() {
      //on determine le nombre de produit corespondant
      var comp = 0;
      var temp = [];
      this.factNull = false;
      this.optionCommande.splice(0);
      for (var index = 0; index < this.multipleSelection.length; index++) {
        var element1 = this.multipleSelection[0]["travauxId"];
        // let element2 = this.multipleSelection[0]["idProd"];
        var magasin1 = this.multipleSelection[0]["entrepotId"];
        var element = this.multipleSelection[index]["travauxId"];
        var element2 = this.multipleSelection[index]["entrepotId"];

        if (element1 != '') {
          if (element1 == element) {
            comp++;
          } else {
            this.factNull = true;
            // this.$refs.multipleTable.toggleRowSelection(
            //   this.multipleSelection[index]
            // );
          }
        } else {
          if (magasin1 == element2) {
            comp++;
          } else {
            this.factNull = true;
            this.$refs.multipleTable.toggleRowSelection(this.multipleSelection[index]);
          }
        }
      }

      if (this.multipleSelection.length == comp && this.factNull === false) {
        var multipleSelection1 = this.multipleSelection;

        var tableau = multipleSelection1;
        for (var i = 0; i < tableau.length; ++i) {
          for (var j = i + 1; j < tableau.length; ++j) {
            if (tableau[i].idProd === tableau[j].idProd) {
              tableau[i].qte = tableau[i].qte + tableau[j].qte;
              tableau.splice(j--, 1);
            }
          }
        }
        this.optionCommande = tableau;
        // this.dateLivr = th/
        this.idTravaux = this.multipleSelection[0]['idTravaux'];
        this.projetLib = this.multipleSelection[0]["projet"];
        this.dateLivr = this.multipleSelection[0]["dateLivr"];
        this.chantieretLib = this.multipleSelection[0]["chantier"];
        this.entrepotLib = this.multipleSelection[0]["libEntrepot"];
        this.travuxLib = this.multipleSelection[0]["travaux"];
        this.libelle = this.multipleSelection[0]["libelle"] ? this.multipleSelection[0]["libelle"] : '';
        this.hiddenButton = this.libelle != '' ? true : false;

        this.selectFourn = '';
        this.dialogComm = true;
        this.disabledChamp = false;
      } else {
        this.$notify({
          title: "Fusion",
          message: "Impossible de lier ces besoins pour la commande. Veuillez selectionner des besoins émit pour les mêmes Travaux / pour les mêmes entrepots",
          type: "error",
          position: "top-center"
        });
      }
    },


    //afficher le formulaire de generation de commande
    showBunttonGenerer: function showBunttonGenerer() {
      var _this2 = this;

      dump('text');
      die();
      this.hiddenButton = true;
      //  recuperation des produits concerne
      this.optionCommande.splice(0);
      this.multipleSelection.forEach(function (optionbesoin) {
        _this2.optionCommande.push(optionbesoin);
      }, this);
      this.idTravaux = this.multipleSelection[0]['projet'];
      this.projetLib = this.multipleSelection[0]["projet"];
      this.chantieretLib = this.multipleSelection[0]["chantier"];
      this.travuxLib = this.multipleSelection[0]["travaux"];
      this.dateLivr = this.multipleSelection[0]["dateLivrSouh"];
      this.entrepotLib = this.multipleSelection[0]["libEntrepot"];
      this.libelle = '';
      this.selectFourn = '';
      this.dialogComm = true;
      this.disabledChamp = false;
    },


    //afficher le formulaire d'une commande
    showFormCommandNew: function showFormCommandNew() {
      var _this3 = this;

      //  recuperation des produits concerne
      this.optionCommande.splice(0);

      this.multipleSelection.forEach(function (optionbesoin) {
        _this3.optionCommande.push(optionbesoin['option'] ? optionbesoin['option'][0] : optionbesoin);
      }, this);
      this.idTravaux = this.multipleSelection[0]['idTravaux'];
      this.projetLib = this.multipleSelection[0]["projet"];
      this.chantieretLib = this.multipleSelection[0]["chantier"];
      this.travuxLib = this.multipleSelection[0]["travaux"];
      this.dateLivr = this.multipleSelection[0]["dateLivr"];
      this.entrepotLib = this.multipleSelection[0]["libEntrepot"];
      this.libelle = this.multipleSelection[0]["libelle"] ? this.multipleSelection[0]["libelle"] : '';
      this.hiddenButton = this.libelle != '' ? false : true;

      this.selectFourn = '';
      this.dialogComm = true;
      this.disabledChamp = false;
      this.hiddenButton = false;
    },


    //Action methodes
    showCommande: function showCommande(ligneCommande) {
      var etat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.hiddenButton = etat;
      this.disabledChamp = true;
      this.showModalDetailCom = true;
      this.detailCommande = ligneCommande;
    },
    editCommande: function editCommande(ligneCommande) {
      this.showModalModifCom = true;
      this.detailCommande = ligneCommande;
    },
    deleteCommande: function deleteCommande() {
      var _this4 = this;

      this.loading = true;
      var url = this.domaine + "besoin/delete/comd/" + this.idCommande.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this4.$notify({
            title: "SUPPRESSION",
            message: "Commande supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          _this4.dialogCOmmande = false;
          _this4.dialogSupr = false;
          _this4.loading = false;
          _this4.loadCommandeRecent();
        } else {
          _this4.$message.error("Impossible de supprimer");
          _this4.loading = false;
        }
      }, function (error) {
        _this4.$message.error("Impossible de supprimer");
        _this4.loading = false;
      });
    },

    //Controlle de l'activation du boutton deroulez
    activationDerouler: function activationDerouler() {
      this.activDerouler ? this.activDerouler = false : this.activDerouler = true;
      //enregistrement des besoins ayant été vue par l'utilisateur
      if (this.activDerouler && this.listBesoin.length > 0) this.enregistrementBesoinVue();
    },
    enregistrementBesoinVue: function enregistrementBesoinVue() {
      var url = this.domaine + "besoin/save/checked/" + this.user.id + "/show";
      this.$http.get(url);
    },
    validRejetBesoin: function validRejetBesoin(decision) {
      var _this5 = this;

      this.loading = true;
      //decision == 1 = Valider // decision == 0 //Refuser
      var url = '';
      if (this.selectValidateur == 'validateur1') {
        url = this.domaine + "besoin/avalider/bci/nivau1";
      } else {
        url = this.domaine + "besoin/avalider/bci/nivau2";
      }

      var data = new FormData();
      data.append("decision", decision);
      data.append("commDec", this.commDec);
      data.append("typeValidateur", this.selectValidateur);
      data.append("idUser", this.user.id);
      data.append("bci", this.selectBci);

      this.$http.post(url, data).then(function (resp) {
        _this5.dialogValideBesoin = false;
        _this5.loading = false;
        _this5.dialogAccord2 = false;
        _this5.dialogRejeterMission = false;
        _this5.$emit("reloadBesoins");
        _this5.$notify({
          title: "Validation besoins",
          message: "L'opération s'est déroulée avec succès",
          type: "success",
          position: "top-center"
        });
      }, function (error) {
        _this5.dialogValideBesoin = false;
        _this5.loading = false;
        _this5.$message.error("Erreur lors du chargement de la validation des besoins");
      });
    },

    //filtre commande
    clearSelectCommande: function clearSelectCommande() {
      this.listCommande = this.oldListCommande;
    },
    filtrerEtatDateCommande: function filtrerEtatDateCommande(date) {
      this.selectEtatPrioriteCommande = null;

      this.listCommande = this.oldListCommande;
      this.listCommande = this.listCommande.filter(function (commande) {
        if (commande.dateJour >= date[0] && commande.dateJour <= date[1]) return commande.dateJour;else if (commande.dateJour == date[0] && commande.dateJour == date[1]) return commande.dateJour;
      });
    },
    filtrerEtatPrioriteCommande: function filtrerEtatPrioriteCommande(priorite) {
      //reinitialisation de la liste commande
      this.listCommande = this.oldListCommande;
      this.selectEtatDateCommande = null;

      //filtre de la liste de commande
      this.listCommande = this.listCommande.filter(function (commande) {
        return commande.priorite == priorite;
      });
    },
    loadDemande: function loadDemande() {
      var _this6 = this;

      this.loading = true;
      this.listDemande = [];
      var url = this.domaine + "entrepot/liste";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this6.listDemande = response.body.demande;
          _this6.loading = false;
        }
      });
    },
    loadFourn: function loadFourn() {
      var _this7 = this;

      this.loading = true;
      var url = this.domaine + "fournisseur/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this7.listFour = response.body.fournisseur;
          _this7.loading = false;
        }
      });
    },
    loadTravaux: function loadTravaux() {
      var _this8 = this;

      this.loading = true;
      this.travauxS = "";
      this.listTravaux = [];
      if (this.chantierS != "" && this.chantierS != null) {
        var url = this.domaine + "projet/" + this.chantierS + "/index/chantier/travaux";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this8.listeTravaux = response.body.travaux;
            _this8.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un chantier");
        this.loading = false;
      }
    },
    loadTacheTrx: function loadTacheTrx() {
      var _this9 = this;

      this.loading = true;
      this.tacheS = "";
      this.listeTacheTrx.splice(0);
      if (this.travauxS != "" || this.travauxS !== undefined) {
        var url = this.domaine + "tache/travaux/" + this.travauxS;
        this.$http.get(url).then(function (response) {
          _this9.listeTacheTrx = response.body.taches;
          _this9.loading = false;
        });
      } else {
        this.$message.error("Veuillez sélectionner une tache");
        this.loading = false;
      }
    },


    //filtre
    loadDemandeur: function loadDemandeur(userId) {
      this.selectEtatDate = null;
      this.listBesoin = this.oldListBesoin;
      this.listBesoin = this.listBesoin.filter(function (item) {
        return item.userId == userId;
      });
    },
    loadDate: function loadDate(date) {
      this.listBesoin = this.oldListBesoin;
      this.selectEtatDemandeur = null;
      if (date) {
        this.listBesoin = this.listBesoin.filter(function (item) {
          if (item.dateJour >= date[0] && item.dateJour <= date[1]) return item.dateJour;else if (item.dateJour == date[0] || item.dateJour == date[1]) return item.dateJour;
        });
      }
    },
    loadServiceBesoin: function loadServiceBesoin(service) {
      var _this10 = this;

      this.listBesoin = this.oldListBesoin;
      this.selectEtatDate = null;
      this.listBesoin = this.listBesoin.filter(function (besoin) {
        _this10.comboUser = _this10.oldComboUser;
        _this10.comboUser = _this10.comboUser.filter(function (user) {
          return user.serviceId == service;
        });
        return besoin.serviceId == service;
      });
    },
    filtrerEtatPrioriteBesoin: function filtrerEtatPrioriteBesoin(priorite) {
      //reinitialisation de la liste commande
      this.listBesoin = this.oldListBesoin;
      this.selectEtatDate = null;
      this.selectEtatService = null;
      this.selectEtatDemandeur = null;

      //filtre de la liste de commande
      this.listBesoin = this.listBesoin.filter(function (besoin) {
        return besoin.priorite == priorite;
      });
    },
    filtrerEtatConfirmationBesoin: function filtrerEtatConfirmationBesoin(etat) {
      //reinitialisation de la liste commande
      this.listBesoin = this.oldListBesoin;
      this.selectEtatDate = null;
      this.selectEtatService = null;
      this.selectEtatDemandeur = null;

      // filtre de la liste de commande
      this.listBesoin = this.listBesoin.filter(function (besoin) {
        return besoin.etat == etat;
      });
    },
    filtrerEtatService: function filtrerEtatService(service) {
      this.loadServiceBesoin(service);
    },
    filtrerEtatDemandeur: function filtrerEtatDemandeur(userId) {
      this.loadDemandeur(userId);
    },
    filtrerEtatDate: function filtrerEtatDate(date) {
      if (this.selectEtatDate != null) this.loadDate(date);else this.listBesoin = this.oldListBesoin;
    },
    filtrerEntrepot: function filtrerEntrepot(idEnt) {
      this.loadDmdParEntrp(idEnt);
    },
    filtrerCmdEntrepot: function filtrerCmdEntrepot(idEnt) {
      this.loadCmdParEntrp(idEnt);
    },
    filtrerTravaux: function filtrerTravaux(travauxS) {
      this.loadDmdParTrx(travauxS);
    },
    filtrerCommandeTravaux: function filtrerCommandeTravaux(travauxS) {
      this.loadCmdParTrx(travauxS);
    },
    filtreByChantier: function filtreByChantier(idChantier) {
      this.listBesoin = this.oldListBesoin;
      if (idChantier == '' || idChantier == null) {
        this.listBesoin = this.oldListBesoin;
      }
      this.listBesoin = this.listBesoin.filter(function (item) {
        return item.chantierId == idChantier;
      });
    },
    filtreByProjet: function filtreByProjet(idProjet) {
      this.listBesoin = this.oldListBesoin;
      if (idProjet == '' || idProjet == null) {
        this.listBesoin = this.oldListBesoin;
      }
      this.listBesoin = this.listBesoin.filter(function (item) {
        return item.projetId == idProjet;
      });
    },
    loadCmdParTrx: function loadCmdParTrx(travauxS) {
      this.listCommande = this.oldListCommande;
      this.listCommande = this.listCommande.filter(function (item) {
        return item.travauxId == travauxS;
      });
    },
    loadDmdParTrx: function loadDmdParTrx(travauxS) {
      this.listBesoin = this.oldListBonCommande;
      //this.selectEtatDmd = null;
      this.listBonCommande = this.listBesoin.filter(function (item) {
        return item.travauxId == travauxS;
      });
    },
    loadDmdParEntrp: function loadDmdParEntrp(idEnt) {
      this.listBesoin = this.oldListBonCommande;
      //this.selectEtatDmd = null;
      this.listBesoin = this.listBesoin.filter(function (item) {
        return item.entrepotId == idEnt;
      });
    },
    loadCmdParEntrp: function loadCmdParEntrp(idEnt) {
      this.listCommande = this.oldListCommande;
      this.listCommande = this.listCommande.filter(function (item) {
        return item.entrepotId == idEnt;
      });
    },
    verifFormInfo: function verifFormInfo(optionP) {
      if (optionP.unite != null) {
        return true;
      } else {
        return false;
      }
    },
    clearSelect: function clearSelect() {
      this.listBonCommande = this.oldListBonCommande;
      this.comboUser = this.oldComboUser;
    },
    editRessources: function editRessources(ligne) {
      this.dialogShowEditRessource = true;
      this.tacheSelectioner = ligne;
      this.formEditRessource.libelle = ligne.produit;
      this.formEditRessource.qte = ligne.qte;
      this.formEditRessource.dateD = ligne.dateDUtilisation;
      this.formEditRessource.dateF = ligne.dateFUtilisation;
    },
    resetFormEditRess: function resetFormEditRess() {
      this.formEditRessource = {};
      this.dialogShowEditRessource = false;
    },

    //filtre
    loadUser: function loadUser() {
      var _this11 = this;

      this.loading = true;
      var url = this.domaine + "besoin/liste/utilisateur";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this11.comboUser = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.body.user);
          _this11.oldComboUser = _this11.comboUser;
          _this11.loading = false;
        }
      });
    },
    loadTypeRessource: function loadTypeRessource() {
      var _this12 = this;

      var url = this.domaine + "product/typeRessource";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this12.listTypeRessource = response.body.types;
          _this12.loading = false;
        }
      });
    },
    loadService: function loadService() {
      var _this13 = this;

      this.loading = true;
      var url = this.domaine + "besoin/liste/service";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this13.comboService = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.body.service);
          _this13.loading = false;
        }
      });
    },
    imprimerCommande: function imprimerCommande(ligne) {
      this.dialogImprCommande = true;
      this.commCourant = ligne;
    },
    imprimerCommande1: function imprimerCommande1() {
      this.dialogImprCommande1 = true;
    },
    imprimerModeCommande: function imprimerModeCommande(mode) {
      var url = this.domaine + 'besoin/' + this.commCourant.id + '/imprimer/commande/' + this.user.id + '/' + mode;
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      this.dialogImprCommande = false;
      window.open(url);
    },
    imprimerModeCommande1: function imprimerModeCommande1(mode) {
      var url = this.domaine + 'besoin/' + "imprimer/liste/bci/" + this.user.id + '/' + mode;
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      this.dialogImprCommande = false;
      window.open(url);
    },

    //Imprimer la liste des besoins
    imprimeListeBesoin: function imprimeListeBesoin(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "besoin/imprimerPDF/liste";
      } else {
        url = this.domaine + "besoin/imprimerEXC/liste";
      }

      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    deleteRow: function deleteRow(index, rows) {
      rows.splice(index, 1);
    },

    //Suppression
    deleteNeed: function deleteNeed() {
      var _this14 = this;

      var besoinId = this.recupIdSelection();

      this.$confirm("Voulez-vous supprimer cette selection?", "Attention", {
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
        type: "warning"
      }).then(function () {
        _this14.$message({
          type: "success",
          message: "Suppression en cours!"
        });
        _this14.loading = true;
        var besoinTabId = [];
        var i = 0;

        //envoie du tableau obtenu
        var url = _this14.domaine + "besoin/delete/selection/" + besoinId;
        _this14.$http.get(url).then(function (response) {
          if (response.ok) {
            _this14.loading = false;
            _this14.$notify({
              title: "SUPPRESSION REUSSIE",
              message: "La selection a été supprimée avec succès.",
              type: "success",
              position: "top-center"
            });
          }
        });
      }).catch(function () {
        _this14.$message({
          type: "info",
          message: "Suppression annulée"
        });
      });
    },
    recupIdSelection: function recupIdSelection() {
      var besoinTabId = [];
      this.multipleSelection.forEach(function (besoin) {
        besoinTabId.push(besoin.id);
      });
      return besoinTabId;
    },
    loadPage: function loadPage() {
      this.loading = true;
    },
    loadBonCommande: function loadBonCommande() {
      var _this15 = this;

      this.loading = true;
      var url = this.domaine + "besoin/index/boncommande/0/recent";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this15.listBonCommande = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.body.besoin);
          _this15.oldListBonCommande = _this15.listBonCommande;
          _this15.notifBonCommande = _this15.listBonCommande.length;
          _this15.loading = false;
        }
      });
    },
    submitComm: function submitComm() {
      var _this16 = this;

      var dateNow = new Date().toISOString().slice(0, 10);

      // on change le format de la date pour  la comparaison  de date
      var tabDateDbt = this.dateLivr.split("-"); //["16","08","2018 00:00:00"]
      var jr = tabDateDbt[0];
      var mois = tabDateDbt[1];
      var annee = tabDateDbt[2].split(" ")[0];
      var dateDbt = annee + "-" + mois + "-" + jr;
      this.loading = true;
      if (this.$refs.formComm.validate() && this.libelle != "" && this.dateLivr != "" &&
      // this.selectFourn != "" &&
      dateNow <= dateDbt) {
        var etat = false;
        if (this.optionCommande.length > 0) {
          this.optionCommande.forEach(function (item) {
            if (item.produit != "" && item.prix > 0 && item.qte > 0 && item.unite != "" && item.priorite > 0) {
              etat = true;
            }
          });
        }

        if (etat == true || this.hiddenButton == true) {
          var form = document.getElementById("formComm");
          var data = new FormData();
          var url = '';
          data.append("libelle", this.libelle);
          data.append("dateLivr", this.dateLivr);
          data.append("priorite", this.priorite);
          data.append("total", this.totalComTTC);
          data.append("idUser", this.user.id);
          data.append("fournisseur", this.selectFourn);
          data.append("projetId", this.projetS);
          data.append("chantierId", this.chantierS);
          data.append("bonGenerer", this.hiddenButton);
          data.append("travauxId", this.multipleSelection[0]["travauxId"]);
          data.append("entrepotId", this.multipleSelection[0]["entrepotId"]);
          //on va enregister dabor la commande
          url = this.domaine + "besoin/commande/new";

          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              url = _this16.domaine + "besoin/new/commande";
              var nbData = 10;
              var nbReq = 1;
              var ligne = null;

              var nbRest = void 0;
              if (_this16.optionCommande.length > 10) {
                nbData = 10;
                nbReq = Math.round(_this16.optionCommande.length / nbData);
                nbRest = _this16.optionCommande.length % nbData;
                if (nbRest > 0) {
                  nbReq += 1;
                }
              }

              _this16.totalComTTC = 0;
              for (var i = 0; i < nbReq; i++) {
                var initJ = i * nbData;
                var finJ = (i + 1) * nbData;
                var dataLot = [];
                if (_this16.optionCommande.length > 0) {
                  for (var j = initJ; j < finJ; j++) {
                    if (_this16.optionCommande[j] == undefined) {
                      break;
                    }
                    dataLot.push(_this16.optionCommande[j]);
                  }
                }
                var _data = new FormData();
                for (var prop in dataLot) {
                  ligne = dataLot[prop];
                  _data.append("options[id][]", ligne.id);
                  _data.append("options[produit][]", ligne.produit);
                  _data.append("options[prix][]", ligne.prix);
                  _data.append("options[qte][]", ligne.qte);
                  _data.append("options[unite][]", ligne.unite);
                  _data.append("options[tva][]", ligne.tva);
                  _data.append("options[total][]", ligne.total);
                  _this16.totalComTTC += ligne.total;
                }

                _data.append("idCommande", verif.idCommande);
                _data.append("idBonCommande", verif.idBonCommande);
                _data.append("total", _this16.totalComTTC);
                _data.append("idUser", _this16.user.id);
                _data.append("fournisseur", _this16.selectFourn);
                _data.append("projetId", _this16.projetS);
                _data.append("chantierId", _this16.chantierS);
                _data.append("travauxId", _this16.multipleSelection[0]["travauxId"]);

                _this16.$http.post(url, _data).then(function (response) {
                  if (response.body) {
                    var _verif = response.body;

                    if (_verif.code === 1) {
                      _this16.$notify({
                        title: "ENREGISTREMENT REUSSI",
                        message: "Commande enregistrée avec succès.",
                        type: "success",
                        position: "top-center"
                      });

                      _this16.dialogComm = false;
                      _this16.loadCommandeRecent();
                      _this16.loadRecentBesoin();
                      _this16.$refs.formComm.reset();
                    } else if (_verif.code === 2) {
                      _this16.$message.error(_verif.message);
                      _this16.loading = false;
                    } else if (_verif.code === 3) {
                      _this16.$notify({
                        title: "ENREGISTREMENT REUSSI",
                        message: "Bon de commande générer avec succès.",
                        type: "success",
                        position: "top-center"
                      });

                      _this16.dialogComm = false;
                      _this16.loadCommandeRecent();
                      _this16.loadRecentBesoin();
                      _this16.loading = false;
                    }
                    _this16.loadBonCommande();
                  } else {
                    _this16.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                    _this16.loading = false;
                    _this16.clear();
                  }
                }, function (error) {
                  _this16.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                  _this16.loading = false;
                });
              }
            }
          }, function (error) {
            _this16.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this16.loading = false;
          });
        } else {
          this.$notify({
            title: "ATTENTION",
            message: "Vous devez obligatoirement enregistré des lignes pour la commande et que ces lignes ont été correctements remplis , les prix des produits doivent etre obligatoirement superieur a 0.",
            position: "top-center",
            type: "warning"
          });
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires ou verifier que la date est superieur de la date d'aujourd'hui");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La commande n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    loadRecentBesoin: function loadRecentBesoin() {
      var _this17 = this;

      this.loading = true;
      var url = "";
      if (this.droitAcces.besoin) {
        url = this.domaine + "besoin/index_recent";
      } else {
        url = this.domaine + "besoin/index/" + this.user.id + "/user/recent";
      }

      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this17.listBesoin = response.body.besoin ? response.body.besoin : [];
          _this17.notification = _this17.listBesoin.length;
          _this17.listBesoinAttente = response.body.besoinAttente;
          _this17.oldListBesoin = response.body.besoin;
          if (_this17.oldListBesoin) _this17.disabledImprime = false;else _this17.disabledImprime = true;
          _this17.loading = false;
        }
      });
      this.loadUser();
      this.loadDate();
      this.loadService();
    },
    loadCommandeRecent: function loadCommandeRecent() {
      var _this18 = this;

      this.loading = true;
      var url = "";
      if (this.droitAcces.index_besoin_commande) {
        url = this.domaine + "besoin/index/commande/recent";
      } else {
        url = this.domaine + "besoin/index/commande/recent/" + this.user.id + "/user";
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this18.listCommande = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(response.body.commande);

          _this18.oldListCommande = _this18.listCommande;
          _this18.notifCommande = _this18.listCommande.length;
          _this18.loading = false;
        }
      });
    },
    handleSelect: function handleSelect(produit) {
      var index = this.optionBesoin.indexOf(produit);
      this.optionBesoin.splice(index, 3, produit);
    },
    editBesoin: function editBesoin() {
      this.dialogBesoin = true;
      this.dialogEdit = true;
      this.optionBesoin = this.multipleSelection;
    },
    besoinSelect: function besoinSelect(row, index) {
      var etat = null;
      if (parseFloat(row.qte) != 0) {
        etat = true;
      } else {
        etat = false;
      }
      return etat;
    },
    loadTypeProduit: function loadTypeProduit(item) {
      var _this19 = this;

      this.loading = true;
      var url = this.domaine + "product/productSelect/type/" + item;
      this.$http.get(url).then(function (response) {
        _this19.loading = false;
        _this19.listeProduitAffich = response.body.produits;
      }, function (errRep) {
        _this19.loading = false;
        _this19.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    loadVehicule: function loadVehicule() {
      var _this20 = this;

      this.loading = true;
      var url = this.domaine + "product/productSelect/type/" + 'VEHICULE/ENGIN';
      this.$http.get(url).then(function (response) {
        _this20.loading = false;
        _this20.listeVehicule = response.body.produits;
      }, function (errRep) {
        _this20.loading = false;
        _this20.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    calculTotalBe: function calculTotalBe() {},


    //Notifications
    showNotification: function showNotification() {
      var _this21 = this;

      var url = this.domaine + "besoin/affiche/notification/" + this.user.id;

      //recuperation des notifications
      this.$http.get(url).then(function (response) {
        if (response.body) _this21.notification = response.body.notification;
      });
    },
    verifPrioriteBonBesoin: function verifPrioriteBonBesoin() {
      var tabPrioriteProd = [];
      var prioriteFinal = 0;
      //Recuperation des priorites des besoins
      this.multipleSelection.forEach(function (produit) {
        tabPrioriteProd.push(produit.priorite);
      });

      //Verification et des niveaux de priorite
      for (var i = 0; i < tabPrioriteProd.length; i++) {
        if (tabPrioriteProd[i] === 3) {
          prioriteFinal = 3;
          break;
        } else if (tabPrioriteProd[i] === 2) {
          //Control de l'existence d'une priorité plus haute
          for (var _i = 0; _i < tabPrioriteProd.length; _i++) {
            if (tabPrioriteProd[_i] === 3) {
              prioriteFinal = 3;
              break;
            } else {
              prioriteFinal = 2;
            }
          }
          break;
        } else {
          prioriteFinal = 1;
        }
      }

      //Attributon de la valeur de la priorite
      this.priorite = prioriteFinal;
    },
    verifPrioriteBesoin: function verifPrioriteBesoin() {
      var tabPrioriteProd = [];
      var prioriteFinal = 0;

      //Recuperation des priorites des besoins
      this.multipleSelection.forEach(function (produit) {
        tabPrioriteProd.push(produit.priorite);
      });

      //Verification et des niveaux de priorite
      for (var i = 0; i < tabPrioriteProd.length; i++) {
        if (tabPrioriteProd[i] === 3) {
          prioriteFinal = 3;
          break;
        } else if (tabPrioriteProd[i] === 2) {
          //Control de l'existence d'une priorité plus haute
          for (var _i2 = 0; _i2 < tabPrioriteProd.length; _i2++) {
            if (tabPrioriteProd[_i2] === 3) {
              prioriteFinal = 3;
              break;
            } else {
              prioriteFinal = 2;
            }
          }
          break;
        } else {
          prioriteFinal = 1;
        }
      }

      //Attributon de la valeur de la priorite
      this.priorite = prioriteFinal;
    },
    createFilter: function createFilter(queryString) {
      return function (link) {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelectionBonChange: function handleSelectionBonChange(val) {
      var _this22 = this;

      var factNull = false;
      //verification de l'etat
      var dataFact = val.filter(function (elt, index) {
        if (elt.etat == 1) {
          _this22.$refs.multipleTableBon.toggleRowSelection(elt);
          factNull = true;
        }
        return elt.etat == 1;
      });

      this.nombreBonSelection = val;
      this.multipleSelection = val;
      if (this.nombreBonSelection.length === 0) {
        this.disabledBtnValide = true;
        this.choix = true;
      } else {
        this.disabledBtnValide = false;
        this.choix = false;
      }

      if (factNull == true) {
        this.$message({
          message: "Attention, vous ne pouvez selectionner que les besoins deja validé",
          type: "warning",
          duration: 1000
        });
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this23 = this;

      var factNull = false;
      //verification de l'etat
      var dataFact = val.filter(function (elt, index) {
        if (elt.etat == 1) {
          _this23.$refs.multipleTable.toggleRowSelection(elt);
          factNull = true;
        }
        return elt.etat == 1;
      });

      //  this.multipleSelection = dataFact
      this.multipleSelection = val;
      this.nombreSelection = val;
      if (this.multipleSelection.length === 0) {
        this.disabledBtnValide = true;
        this.choix = true;
      } else {
        this.disabledBtnValide = false;
        this.choix = false;
      }

      if (factNull == true) {
        this.$message({
          message: "Attention, vous ne pouvez selectionner que les besoins deja validé",
          type: "warning",
          duration: 1000
        });
      }
    },

    //Projet
    selectProjet: function selectProjet(idProjet) {
      this.loadChantier(idProjet);
    },
    loadProjet: function loadProjet() {
      var _this24 = this;

      var url = this.domaine + "projet/index/projet/all";

      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this24.loading = false;
        _this24.listeProjet = response.body.projet;
      }, function (errRep) {
        _this24.loading = false;
        _this24.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    loadChantier: function loadChantier() {
      var _this25 = this;

      if (this.projetS == "" || this.projetS == null) {
        return;
      }
      this.loading = true;
      this.listeChantier.splice(0);
      this.listeTacheTrx.splice(0);
      this.listeTravaux.splice(0);

      this.chantierS = "", this.travauxS = "";
      this.tacheS = "";

      var url = this.domaine + "projet/" + this.projetS + "/index/chantier";
      this.$http.get(url).then(function (response) {
        _this25.loading = false;
        _this25.listeChantier = response.body.chantier;
      }, function (errRep) {
        _this25.loading = false;
        _this25.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    loadProduitFoun: function loadProduitFoun(ligne) {
      var _this26 = this;

      this.loading = true;
      this.fournCourant = ligne;
      var url = "";
      // if (this.droitAcces.index_produit_fourn) {
      url = this.domaine + "fournisseur/" + this.fournCourant.id + "/index/produit";
      // } else {
      //   url =
      //     this.domaine +
      //     "fournisseur/" +
      //     this.fournCourant.id +
      //     "/index/" +
      //     this.user.id +
      //     "/produit";
      // }

      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this26.listProduit = response.body.produit;
          _this26.loading = false;
        }
      });
    },
    closeDialogComp: function closeDialogComp() {
      this.showModalDetailCmd = false;
      //this.loadCommande()
      //this.loadBesoin()
    },
    imprimerListe: function imprimerListe() {
      var _this27 = this;

      this.loading = true;
      this.optionCommande = this.multipleSelection;
      var options = [];
      var formdata = new FormData();
      for (var prop in this.optionCommande) {
        var ligne = this.optionCommande[prop];
        options.push(ligne.id);
      }

      var url = this.domaine + "comparateur/imprimerPDF/listePrixFourn";
      formdata.append("options", options);
      formdata.append("typeOption", 2); //optionBesoin

      var req = new XMLHttpRequest();
      this.$http.post(url, formdata, { responseType: "arraybuffer" }).then(function (response) {
        var blob = new Blob([response.data], {
          type: response.headers.get("content-type")
        });

        var url = URL.createObjectURL(blob);
        _this27.loading = false;
        window.open(url);
      });
    },
    showDialogComparaison: function showDialogComparaison() {
      var _this28 = this;

      this.loading = true;
      this.dialogComm = false;
      this.optionCommande = this.multipleSelection;
      var formdata = new FormData();
      var url = this.domaine + "comparateur/new/commande";
      var options = [];
      var listProdPrixNulle = [];
      var smsAficher = "Aucune tarification de ce produit est indiqué chez vous fournisseurs ";
      var mesProdPrixNulle = "Les produits de cette commande ne se trouvent chez aucun de vos fournisseurs ";

      for (var prop in this.optionCommande) {
        var ligne = this.optionCommande[prop];
        options.push(ligne.id);
      }
      formdata.append("options", options);
      formdata.append("typeOption", 2); //optionBesoin

      this.$http.post(url, formdata).then(function (response) {
        //affichage des messages
        var nbCmd = 0;
        var nbCmdDeux = 0;
        var listeFoun = [];
        var listeNull = [];
        var listeFounSecond = [];
        if (response.body.code == 1) {
          var nbProdNull = response.body.listeProdNull.length;
          var messages = response.body.messageProd;
          var mes = "";
          //recuperer les message
          for (var index in messages) {
            mes += "-- " + messages[index];
          }

          _this28.$confirm(mes, "Avertissement", {
            confirmButtonText: "Continuer",
            cancelButtonText: "Annuler",
            type: "warning"
          }).then(function () {
            var respFour = response.body.fournisseurs[0];
            _this28.mntTotalCmd = response.body.mntTotauxFormat;
            _this28.listeProdNull = response.body.listeProdNull;

            //let listeFoun = [];
            for (var four in respFour) {
              nbCmd++;
              var listeProduit = respFour[four];
              var infoFour = {
                fournisseur: four,
                produits: [],
                mntTotal: 0,
                mntTotalHt: 0
              };

              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(listeProduit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var produit = _step.value;

                  infoFour.produits.push(produit);
                  infoFour.mntTotal += parseFloat(produit.mntTotal);
                  infoFour.mntTotalHt += parseFloat(produit.mntTotalHt);
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              listeFoun.push(infoFour);
            }

            _this28.nbCommandeSug = nbCmd;
            _this28.commandeDeriv = listeFoun;

            _this28.dialogDetailCmd = true;
            _this28.loading = false;

            //AFFICHAGE DE PRODUITS DONT LE MONTANT EST NULL
            if (response.body.listeProdNull.length > 0) {
              _this28.dialogProdNull = true;
              //this.closeProdNull();
            }
            if (listeFoun.length > 0) {
              _this28.showModalCompCmd = true;
            }
          }).catch(function () {
            _this28.loading = false;
            _this28.showModalCompCmd = false;
            _this28.$alert(smsAficher, {
              confirmButtonText: "OK"
            });
          });
        } else {
          var respFour = response.body.fournisseurs[0];
          _this28.mntTotalCmd = response.body.mntTotauxFormat;
          _this28.listeProdNull = response.body.listeProdNull;
          if (respFour.length == 0) {
            _this28.loading = false;
            _this28.$alert(mesProdPrixNulle, "", {
              confirmButtonText: "OK"
            });
            return;
          }
          _this28.loading = false;
          _this28.dialogComm = false;
          _this28.showModalCompCmd = false;
          for (var four in respFour) {
            var listeProduit = respFour[four];
            var infoFour = {
              fournisseur: four,
              produits: [],
              mntTotal: 0,
              mntTotalHt: 0

            };
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(listeProduit), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var produit = _step2.value;

                infoFour.produits.push(produit);
                infoFour.mntTotal += parseFloat(produit.mntTotal);
                infoFour.mntTotalHt += parseFloat(produit.mntTotalHt);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            if (infoFour.produits.length == options.length) {
              nbCmd++;
              listeFoun.push(infoFour);
            } else {
              nbCmdDeux++;
              listeFounSecond.push(infoFour);
            }
          }

          _this28.nbCommandeSug = nbCmd;
          _this28.commandeDeriv = listeFoun;
          _this28.nbCommandeSugDeux = nbCmdDeux;
          _this28.commandeDerivDeux = listeFounSecond;
          _this28.dialogDetailCmd = true;
          _this28.loading = false;
          //AFFICHAGE DE PRODUITS DONT LE MONTANT EST NULL
          if (response.body.listeProdNull.length > 0) {
            _this28.dialogProdNull = true;
          }

          if (listeFoun.length > 0) {
            _this28.showModalCompCmd = true;
          }
        }
        _this28.infOrenseigner = [_this28.libelle, _this28.dateLivr, _this28.priorite, _this28.projetLib, _this28.travuxLib, _this28.chantieretLib, _this28.idTravaux, _this28.entrepotLib];
        _this28.dialogComm = false;
        _this28.showModalCompCmd = true;
      }, function (error) {
        _this28.loading = false;
        _this28.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
      });
    }
  },

  watch: {
    activDerouler: function activDerouler(newValue, oldValue) {
      if (newValue) {
        this.showNotification();
        this.loadProjet();
      }
    }
  },

  computed: {},
  mounted: function mounted() {
    this.loadPage();
    this.loadBonCommande();
    this.loadProjet();
    // this.loadRecentBesoin();
    this.loadDemande();
  }
});

/***/ }),

/***/ "f3XE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fb6D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "flbQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "foHv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elevation-2 pt-3 pl-3 pr-3",staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('h4',{attrs:{"mt-2":""}},[_vm._v("WORKLOG")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mt-3":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","disabled":false,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeMatricePDF()}},slot:"activator"},[_vm._v("\n           Imprimer\n           "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1):_vm._e(),_vm._v("Imprimer le worklog\n       ")],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.showAjoutWork()}}},[_vm._v("\n              Ajouter\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("TOTAL TEMPS : "+_vm._s(_vm.totalHeuretrx)+" HEURES  "+_vm._s(_vm.totalmintrx)+" MINUTES ")])]),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("TOTAL DES WORKLOGS: "+_vm._s(_vm.totalactivitetrx))])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"elevation-1",attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeWorktrx,"border":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',[_c('el-col',{attrs:{"span":5}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('b',[_vm._v("Description")]),_vm._v(" : "),_c('p',[_vm._v(_vm._s(props.row.description))])]),_vm._v(" "),(props.row.statutworklog !='Terminé')?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"blue"},on:{"click":function($event){return _vm.showAddActivite(props.row)}},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v("\n                        Ajouter Activités\n                      ")],1):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":19}},[_c('div',[_c('b',[_vm._v("Liste des Activités")]),_vm._v(" :\n                      ")]),_vm._v(" "),_c('div',{staticClass:"elevation-3"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":props.row.taches}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"utilisateur","label":"ENREGISTRE PAR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateCreation","label":"DATE DE CREATION "}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateModification","label":"MODIFIER LE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"DATE SYSTEME "}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"commentaire","label":"COMMENTAIRE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"statut","label":"STATUT","width":"260"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.statut == 'Terminée')?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.statut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 'En cours')?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v("  "+_vm._s(scope.row.statut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 'Aucune activitée')?_c('el-tag',{attrs:{"type":"info"}},[_vm._v("  "+_vm._s(scope.row.statut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 'En attente')?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v("  "+_vm._s(scope.row.statut))]):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","width":"80","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scop){return [(scop.row.statut == 'Terminée')?_c('v-icon',{attrs:{"color":"green"}},[_vm._v("done")]):_vm._e(),_vm._v(" "),(scop.row.statut !='Terminée' )?_c('v-btn',{attrs:{"slot":"activator","disabled":props.row.close,"color":"orange","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.showDialogActiviteEdit(scop.row)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(scop.row.statut !='Terminée' )?_c('v-btn',{attrs:{"slot":"activator","disabled":props.row.close,"color":"red","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.showDialogSuppActivite(scop.row)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1):_vm._e()]}}],null,true)})],1)],1)])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idwork","label":"ID","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"DESCRIPTION","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tempsmis","label":"TEMPS MIS","align":"center","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"enregistrer","label":"ENREGIRSTRE PAR","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateAdd","label":"DATE DE CREATION","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateModification","label":"DATE DE MODIFICATION","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"DATE SYSTEME","align":"center","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"statutworklog","label":"STATUT","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.statutworklog == 'Terminé')?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.statutworklog))]):_vm._e(),_vm._v(" "),(scope.row.statutworklog == 'En cours')?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v("  "+_vm._s(scope.row.statutworklog))]):_vm._e(),_vm._v(" "),(scope.row.statutworklog == 'Aucune activitée en cours')?_c('el-tag',{attrs:{"type":"info"}},[_vm._v("  "+_vm._s(scope.row.statutworklog))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","width":"250","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"purple","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.showDialogWorklogDetail(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v("Détails\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(scope.row.statutworklog != 'Terminé')?_c('v-btn',{attrs:{"slot":"activator","color":"orange","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.showEditWork(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v("Modifier\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(scope.row.statutworklog != 'Terminé')?_c('v-btn',{attrs:{"slot":"activator","color":"red","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.showDilogSupp(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1):_vm._e(),_vm._v("Supprimer\n            ")],1)]}}])})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","closable":false,"show-icon":"","type":"warning"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("LIBELLE:")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("ID-28}")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("\n          Annuler\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.deleteDoc()}}},[_vm._v("\n          Supprimer\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"80%","overlay":true,"transition":"dialog-bottom-transition","scrollable":"","persistent":""},model:{value:(_vm.dialogWork),callback:function ($$v) {_vm.dialogWork=$$v},expression:"dialogWork"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[(_vm.newVersion == true)?_c('span',[_vm._v("Ajouter un nouveau worklog")]):_vm._e(),_vm._v(" "),(_vm.newVersion == false)?_c('span',[_vm._v("Modification du worklog")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogWork = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formWork",staticClass:"demo-form-inline",attrs:{"id":"formWork","model":_vm.formWork}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Libellé","prop":"libelle"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","required":"","placeholder":"libelle"},model:{value:(_vm.formWork.libelle),callback:function ($$v) {_vm.$set(_vm.formWork, "libelle", $$v)},expression:"formWork.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Temps mis (Heure)","required":""}},[_c('el-time-picker',{staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.newVersion,"value-format":"H-m","type":"time","id":"tempsmis","name":"tempsmis","placeholder":"Temps mis"},model:{value:(_vm.formWork.tempsmis),callback:function ($$v) {_vm.$set(_vm.formWork, "tempsmis", $$v)},expression:"formWork.tempsmis"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"description"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":3,"name":"description","placeholder":"Description"},model:{value:(_vm.formWork.description),callback:function ($$v) {_vm.$set(_vm.formWork, "description", $$v)},expression:"formWork.description"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date de création","required":""}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.newVersion,"value-format":"dd-MM-yyyy","type":"date","id":"dateAdd","name":"dateAdd","placeholder":"Date"},model:{value:(_vm.formWork.dateAdd),callback:function ($$v) {_vm.$set(_vm.formWork, "dateAdd", $$v)},expression:"formWork.dateAdd"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"ml-3",attrs:{"xs4":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoWorklog,"alt":"avatar"}})]),_c('br'),_vm._v(" "),_c('input',{ref:"fileLogo",staticStyle:{"display":"none"},attrs:{"name":"docs","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileLogo.click()}}},[_vm._v("Photo  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br'),_vm._v(" "),_c('p',{staticClass:"font-weight-thin"},[_vm._v("Format (JPEG,PNG,PDF), 10 Mo maximum")])],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){_vm.resetForm('formWork'),_vm.resetForm('tableTaches'),_vm.dialogWork = false}}},[_vm._v("\n                      Annuler\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.newVersion == true)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.addWork('formWork')}}},[_vm._v("\n                      Enregistrer\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e(),_vm._v(" "),(_vm.newVersion == false)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.editWork('formWork')}}},[_vm._v("\n                      Modifier\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"80%","persistent":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogActivite),callback:function ($$v) {_vm.dialogActivite=$$v},expression:"dialogActivite"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[(_vm.newVersion == true)?_c('v-toolbar-title',[_vm._v("\n              Ajouter des activitées au worklog "+_vm._s(_vm.Worklog.libelle)+"\n              ")]):_vm._e(),_vm._v(" "),(_vm.newVersion == false)?_c('v-toolbar-title',[_vm._v("\n              Modifier l'état de l'activitée\n              ")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogActivite = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formActivite",staticClass:"demo-form-inline",attrs:{"id":"formActivite","model":_vm.formActivite}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Libellé","prop":"libelle"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.newVersion,"name":"libelle","required":"","placeholder":"libelle"},model:{value:(_vm.formActivite.libelle),callback:function ($$v) {_vm.$set(_vm.formActivite, "libelle", $$v)},expression:"formActivite.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Statut","prop":"statut"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.formActivite.statut),callback:function ($$v) {_vm.$set(_vm.formActivite, "statut", $$v)},expression:"formActivite.statut"}},_vm._l((_vm.typeLivraison),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.text}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date de création","prop":"date"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.newVersion,"value-format":"dd-MM-yyyy","type":"date","id":"date","placeholder":"Date"},model:{value:(_vm.formActivite.date),callback:function ($$v) {_vm.$set(_vm.formActivite, "date", $$v)},expression:"formActivite.date"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Commentaire","prop":"commentaire"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":3,"name":"commentaire","placeholder":"Description"},model:{value:(_vm.formActivite.commentaire),callback:function ($$v) {_vm.$set(_vm.formActivite, "commentaire", $$v)},expression:"formActivite.commentaire"}})],1)],1)],1),_vm._v(" "),(_vm.newVersion == true)?_c('v-layout',{attrs:{"row":""}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.addListTaches(_vm.formActivite)}}},[_vm._v("Ajouter")])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.newVersion == true)?_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableTaches}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"statut","label":"Statut"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date de création"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"commentaire","label":"Commentaire"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableTaches)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("Supprimer cet article\n                        ")],1)]}}],null,false,191946132)})],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},nativeOn:{"click":function($event){_vm.dialogActivite = false}}},[_vm._v("\n                        Annuler\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.newVersion == true)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.addActivite('formActivite')}}},[_vm._v("\n                        Enregistrer\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e(),_vm._v(" "),(_vm.newVersion == false)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.editTache('formActivite')}}},[_vm._v("\n                        Modifier\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogSuprActivite),callback:function ($$v) {_vm.dialogSuprActivite=$$v},expression:"dialogSuprActivite"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","closable":false,"show-icon":"","type":"warning"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("Activité")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("Activité- "+_vm._s(_vm.ActiviteSelect.libelle))])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSuprActivite = false}}},[_vm._v("\n                  Annuler\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.deleteActivite()}}},[_vm._v("\n                  Supprimer\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowWorklog),callback:function ($$v) {_vm.dialogShowWorklog=$$v},expression:"dialogShowWorklog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du worklog "+_vm._s(_vm.worklogCourant.libelle)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowWorklog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Libellé : ")]),_vm._v(" "+_vm._s(_vm.worklogCourant.libelle)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.worklogCourant.id)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Temps mis (Heure) : ")]),_vm._v(" "+_vm._s(_vm.worklogCourant.tempsmis)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description :")]),_vm._v(" "+_vm._s(_vm.worklogCourant.description)+"  ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Statut : ")]),_vm._v(" "+_vm._s(_vm.worklogCourant.statutworklog)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Ajouter par : ")]),_vm._v(" "+_vm._s(_vm.worklogCourant.enregistrer)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v(" "+_vm._s(_vm.worklogCourant.date)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v(" "+_vm._s(_vm.worklogCourant.dateModification)+" ")]),_vm._v(" "),_c('p',[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.worklogCourant.urlImage,"alt":"avatar"}})])],1)])],1)],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Liste des activitées ")]),_vm._v(" "),_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.worklogCourant.taches}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"utilisateur","label":"ENREGISTRER PAR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateCreation","label":"DATE DE CREATION "}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateModification","label":"MODIFIER LE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"DATE SYSTEME "}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"commentaire","label":"COMMENTAIRE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"statut","label":"STATUT"}})],1)],1)],1)]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowWorklog = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n                  Fermer\n                ")],1)],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gJtD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gKWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_echarts__ = __webpack_require__("cs+8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_line__ = __webpack_require__("4UDB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("7+uW");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Vb+l");
__webpack_require__("Oq2I");
__webpack_require__("miEh");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_4__components_Loading__["a" /* default */], "v-chart": __WEBPACK_IMPORTED_MODULE_2_vue_echarts___default.a },
  name: "app",
  data: function data() {
    var _ref;

    return _ref = {
      val: 35,
      loading: false,
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      racourcis: [{ path: "/", text: "Accueil", disabled: false }, { path: "/entrepot", text: "Liste des entrepots", disabled: true }],

      nbQteDisponible: 0,
      nbQteUtilise: 0,
      dialogAide: false,
      showTooltip: false,
      dataCommandeFour: {},
      dataFactHistoFour: {},
      dataNbFactFour: {},
      dataMntFactFour: [],
      dialogAjout: false,
      dialogStock: false,
      dialogCarburanSortie: false,
      dialogSortie: false,
      dialogEntree: false,
      dialogTransfert: false,
      dialogReponseTransfert: false,
      dialogInventaire: false,
      dialogValiderInventaire: false,
      dialogEdit: false,
      dialogShow: false,
      showDetailAppro: false,
      dialogShowSortie: false,
      dialogShowEntree: false,
      dialogShowInventaire: false,
      dialogShowTransfert: false,
      lstRessources: [],
      dialogSupr: false,
      dialogImport: false,
      valid: true,
      choix: true,
      formEtape: 1,
      tab: "fiche",
      listProd: [],
      listeProduitAffich: [],
      statsCarburant: [],
      infoSelect: [],
      typeEntre: [{ text: "Produit", value: 1 }, { text: "Hydrocarbure", value: 2 }],
      selectTypeEntre: "",
      libelleEntre: "",
      seletCiterne: "",
      descriEntre: "",
      hauteur: "",
      aire: "",
      espace: "",
      travauxSId: "",
      resistance: "",
      ville: "",
      commune: "",
      quartier: "",
      optionStock: [{
        key: 1,
        ref: "",
        value: "",
        type: "",
        seuil: 0,
        unite: "",
        coche: false,
        id: ""
      }],
      selectChefEntre: "",
      selectChefVali: "",
      users: [],
      listEntrepot: [],
      entrepotCourant: [],
      idEntrepot: "",
      detailEntre: [],
      showEnlevement: false,
      listStock: [],
      multipleSelection: [],
      optionSortie: [],
      selectEtatProduit: "",
      etatProduit: [{ text: "Très bon" }, { text: "Bon" }, { text: "Mauvais" }],
      selectRetourPrev: "",
      retourPrev: [{ text: "Non" }, { text: "Oui" }],
      dateRe: "",
      dateS: "",
      selectAll: false,
      remarqueSortie: "",
      destinataireSortie: "",
      projetS: "",
      chantierS: "",
      listSortie: [],
      sortieCourant: [],
      detailSortie: [],
      dateRetour: "",
      qteRetour: 0,
      verifeEtat: false,
      dialogConfir: false,
      remarqueRetour: "",
      selectEtatRetour: "",
      etatRetour: [{ text: "Très bon", value: "Très bon" }, { text: "Bon", value: "Bon" }, { text: "Mauvais", value: "Mauvais" }],
      raison: "",
      listEntree: [],
      entreeCourant: [],
      detailEntree: [],
      listAutreEntrepot: [],
      selectEntrepot: "",
      motifTransfert: "",
      selectPriorite: "",
      priorite: [{ text: "Très urgent", value: 1 }, { text: "Urgent", value: 2 }, { text: "Pas urgent", value: 3 }],
      qteD: 0,
      produitStock: [],
      selectProduitDemande: "",
      listTransfert: [],
      listTransfertEmis: [],
      listTransfertRecu: [],
      transfertCourant: [],
      detailTransfert: [],
      qteT: 0,
      remarqueReponse: "",
      selectReponseTransfert: "",
      reponseTransfert: [{ text: "Accepté", value: 1 }, { text: "Rejeté", value: 2 }],
      dateFin: "",
      dateDeb: "",
      inventaireCourant: []
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listSortie", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "optionInventaire", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "corriger", [{ text: "Oui", value: 1 }, { text: "Non", value: 2 }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "stockInventaire", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nomLivreur", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectCorriger", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "ecart", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "qteReel", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "projetS", ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "totalEcartLigne", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "detailInventaire", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "pourcentageNR", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "pourcentageRP", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "pourcentageRE", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "pourcentageRD", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "pourcentageRND", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "pourcNR", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "compt", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "pourcRP", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "pourcRE", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "pourcRD", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "pourcRND", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "statsEntreApproAll", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "statsEntreAppro", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbrAppro", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbrRetour", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbrTrans", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbrSortie", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbrCarburant", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbrApproEntre", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbrRetourEntre", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbrTransEntre", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbrSortieEntre", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbrCarburantEntre", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listProduitRestant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectProduitRestant", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "seuilStock", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listAppro", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listCarburant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listInventaire", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "approCourant", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "travauxS", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "optionBesoin", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "tacheS", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listProjet", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listChantier", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listTravaux", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "fileExcel", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "lstRessources", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtn", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnS", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnA", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnE", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnR", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnDTE", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnDTR", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnInv", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disableOption", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "typeSortie", [{ text: "Sortie pour un chantier", value: 1 }, { text: "Sortie pour une maintenance", value: 2 }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectTypeSortie", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listDemande", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "selectDemande", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formProduit", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "rulesProduit", {
      reference: [{ required: false, message: "Veuillez saisir" }],
      produit: [{ required: false, message: "Veuillez saisir" }],
      unite: [{ required: false, message: "Veuillez saisir" }],
      idDemande: ""
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogValidAppro", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogValidCarburan", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "items", [{ text: "OUI J'AI TOUT RECU", abbr: 1 }, { text: "J'EN AI RECU QUELQUES-UNS", abbr: 2 }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "itemsCarburant", [{ text: "TOUTE LA QUANITE", abbr: 1 }, { text: "UNE CERTAINE QUANTITE", abbr: 2 }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "labelPosition", "top"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "qteLivDepart", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "qteLivDepartRules", [function (v) {
      return !!v || "Champs obligatoire";
    }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "produitLiv", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "codetLiv", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "idProduitLiv", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "produitLivRules", [function (v) {
      return !!v || "Champs obligatoire";
    }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "choixValidLiv", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "choixValidLivRules", [function (v) {
      return !!v || "Champs obligatoire";
    }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbChoiceLiv", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "nbChoiceLivRules", [function (v) {
      return !!v || "Champs obligatoire";
    }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "remarqueLivr", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "remarqueLivrRules", [function (v) {
      return !!v || "Champs obligatoire";
    }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "idApproLiv", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeStockSelect", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "tabListProduit", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "tabNewstock", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "prodSelct", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listTypeRessource", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeInventaire", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "tableProduit", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "valeurUniteMateriel", ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "valeurCategorie", ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formAddStock", {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogIventair", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formBudget", {
      ressource: "",
      categorie: "",
      unite: '',
      seuilAlerte: 5
    }), _ref;
  },

  computed: {
    verifFormBudget: function verifFormBudget() {
      if (this.formBudget.ressource != "" && this.formBudget.seuilAlerte != "") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    addProduit: function addProduit(item) {
      var _this = this;

      if (this.tableProduit.length > 0) {
        var eltProd = this.tableProduit.find(function (elt) {
          return elt.idressource == _this.infoSelect.id;
        });
        if (eltProd != null) {
          this.$message.error("Cet element a déjà été ajouté à la liste");
          return;
        }
      }
      this.tableProduit.push({
        idressource: this.infoSelect.id,
        ressource: this.infoSelect.value,
        categorie: this.valeurCategorie,
        unite: this.valeurUniteMateriel,
        seuilAlerte: item.seuilAlerte
      });

      this.valeurUniteMateriel = "";
      this.valeurCategorie = '';
      this.formBudget.ressource = "";
      this.formBudget.seuilAlerte = 5;
      this.formBudget.categorie = "";
      this.formBudget.unite = "";
      this.infoSelect = [];
    },
    geneFileExcelInvent: function geneFileExcelInvent() {
      this.dialogIventair = false;
      var url = this.domaine + "entrepot/exportEXC/inventairRessources/" + this.entrepotCourant.id;
      window.open(url);
    },
    generateFileExcel: function generateFileExcel() {
      this.dialogImport = false;
      var url = this.domaine + "entrepot/exportEXC/stockListRessources/" + this.entrepotCourant.id;
      window.open(url);
    },
    onFileExcelInvent: function onFileExcelInvent(event) {
      var _this2 = this;

      this.loading = true;
      this.fileExcel.splice(0, 1);
      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 2097152) {
        this.$message.error("La taille du fichier est supérieur à 2 Mo");
        return;
      }
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this2.fileExcel.push(fileReader.result);
      });
      fileReader.readAsDataURL(files[0]);
      var url = this.domaine + "entrepot/loadStockInventaitr/excel";
      var data = new FormData();
      data.append("fichierExcel", files[0], files[0][name]);
      this.$http.post(url, data).then(function (resp) {
        _this2.loading = false;
        _this2.$notify({
          title: "Chargement des données",
          message: "Chargement effectué",
          type: "success",
          position: "top-right",
          duration: 7000
        });
        _this2.tabNewstock = resp.body.listeTypeTravaux;
      }, function (error) {
        _this2.loading = false;
        _this2.$message.error("Erreur lors de l'importation du fichier");
      });
    },
    onFileExcelPicked: function onFileExcelPicked(event) {
      var _this3 = this;

      this.loading = true;
      this.fileExcel.splice(0, 1);
      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 2097152) {
        this.$message.error("La taille du fichier est supérieur à 2 Mo");
        return;
      }
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this3.fileExcel.push(fileReader.result);
      });
      fileReader.readAsDataURL(files[0]);

      var url = this.domaine + "entrepot/loadStock/excel";
      var data = new FormData();
      data.append("fichierExcel", files[0], files[0][name]);
      this.$http.post(url, data).then(function (resp) {
        _this3.loading = false;
        _this3.$notify({
          title: "Chargement des données",
          message: "Chargement effectué",
          type: "success",
          position: "top-right",
          duration: 7000
        });
        _this3.tabListProduit = resp.body.listeTypeTravaux;
      }, function (error) {
        _this3.loading = false;
        _this3.$message.error("Erreur lors de l'importation du fichier");
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.listeStockSelect = val;
    },
    headerRowStyle: function headerRowStyle(_ref2) {
      var row = _ref2.row,
          rowIndex = _ref2.rowIndex;

      return { color: "black" };
    },
    getSummDetailBudget: function getSummDetailBudget(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 5) {
          sums[index] = "N/A";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    filtrerProduit: function filtrerProduit() {
      var idType = this.prodSelct;
      var tab = this.listProduit;
      if (idType == null || idType == "undefined" || idType == "") {
        this.listProduit = tab;
        return;
      }

      var libele = this.listTypeRessource.find(function (item) {
        return item.id == idType;
      });

      this.listProduit = tab.filter(function (item) {
        return item.type == libele.value;
      });
      this.comboProduit = this.listProduit;
    },
    loadUniteProduit: function loadUniteProduit(item) {
      console.log("loadUniteProduit", item);
      var valeur = void 0;
      valeur = this.listeProduitAffich.find(function (element) {
        if (element.id == item) {
          return element;
        }
      });
      console.log("loadUniteProduit", valeur);

      this.infoSelect = valeur;
      this.valeurUniteMateriel = valeur.unite;
      this.formBudget.unite = valeur.unite;
      this.formBudget.categorie = valeur.type;
      this.valeurCategorie = valeur.type;
    },
    loadTypeProduit: function loadTypeProduit() {
      var _this4 = this;

      this.loading = true;
      if (this.prodSelct != 0) {
        var url = this.domaine + "product/productSelect/type/" + this.prodSelct;
        this.$http.get(url).then(function (response) {
          _this4.loading = false;
          _this4.listProd = response.body.produits;
          _this4.listeProduitAffich = response.body.produits;
        }, function (errRep) {
          _this4.loading = false;
        });
      } else {
        this.loading = false;
      }
    },
    allCheck: function allCheck(value) {
      for (var optionSt in this.optionStock) {
        this.optionStock[optionSt].coche = value;
      }
    },
    querySearch: function querySearch(queryString, cb) {
      var links = this.listProd;
      var results = queryString ? links.filter(this.createFilter(queryString)) : links;
      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (link) {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    chartsSortie: function chartsSortie() {
      var optionSortieAll = {
        title: {
          text: "Etat globale des sorties",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          x: "left",
          data: ["Sortie avec non retour", "Sortie avec retour prévue", "Retour éffectué", "Retour retardé", "Retour non éffectué avec un delai encore valide"]
        },
        series: [{
          type: "pie",
          radius: ["50%", "80%"],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: "center"
            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: "12",
                fontWeight: "bold"
              }
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: [{ value: this.pourcentageNR, name: "Sortie avec non retour" }, { value: this.pourcentageRP, name: "Sortie avec retour prévue" }, { value: this.pourcentageRE, name: "Retour éffectué" }, { value: this.pourcentageRD, name: "Retour retardé" }, {
            value: this.pourcentageRND,
            name: "Retour non éffectué avec un délai valide"
          }]
        }]
      };

      var chartsSortieAll = echarts.init(document.getElementById("chartsSortieAll"));
      chartsSortieAll.setOption(optionSortieAll);
    },
    chartsAppro: function chartsAppro() {
      var dataAxis = [];
      var data = [];
      var yMax = 500;
      var dataShadow = [];

      for (var i = 0; i < data.length; i++) {
        dataShadow.push(yMax);
      }

      var optionApproAll = {
        title: {
          text: "Evolution des approvisionnements",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        xAxis: {
          data: [],
          axisLabel: {
            inside: true,
            textStyle: {
              color: "#000"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          z: 10
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#999"
            }
          }
        },
        dataZoom: [{
          type: "inside"
        }],
        series: [{
          // For shadow
          type: "bar",
          itemStyle: {
            normal: { color: "rgba(0,0,0,0.05)" }
          },
          barGap: "-100%",
          barCategoryGap: "40%",
          data: dataShadow,
          animation: false
        }, {
          type: "bar",
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: "#83bff6" }, { offset: 0.5, color: "#188df0" }, { offset: 1, color: "#188df0" }])
            },
            emphasis: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: "#2378f7" }, { offset: 0.7, color: "#2378f7" }, { offset: 1, color: "#83bff6" }])
            }
          },
          data: []
        }]
      };

      // Enable data zoom when user click bar.
      var zoomSize = 23;

      this.statsEntreApproAll.forEach(function (element) {
        optionApproAll.xAxis.data.push(element.date);
        optionApproAll.series[1].data.push(element.nbr);
      });

      var chartsApproAll = echarts.init(document.getElementById("chartsApproAll"));
      chartsApproAll.setOption(optionApproAll);
    },
    chartsApproEntre: function chartsApproEntre() {
      var dataAxis = [];
      var data = [];
      var yMax = 500;
      var dataShadow = [];

      for (var i = 0; i < data.length; i++) {
        dataShadow.push(yMax);
      }

      var optionApproEntre = {
        title: {
          text: "Evolution des approvisionnements",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        xAxis: {
          data: [],
          axisLabel: {
            inside: true,
            textStyle: {
              color: "#000"
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          z: 10
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#999"
            }
          }
        },
        dataZoom: [{
          type: "inside"
        }],
        series: [{
          // For shadow
          type: "bar",
          itemStyle: {
            normal: { color: "rgba(0,0,0,0.05)" }
          },
          barGap: "-100%",
          barCategoryGap: "40%",
          data: dataShadow,
          animation: false
        }, {
          type: "bar",
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: "#83bff6" }, { offset: 0.5, color: "#188df0" }, { offset: 1, color: "#188df0" }])
            },
            emphasis: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: "#2378f7" }, { offset: 0.7, color: "#2378f7" }, { offset: 1, color: "#83bff6" }])
            }
          },
          data: []
        }]
      };

      // Enable data zoom when user click bar.
      var zoomSize = 23;

      this.statsEntreAppro.forEach(function (element) {
        optionApproEntre.xAxis.data.push(element.date);
        optionApproEntre.series[1].data.push(element.nbr);
      });

      var chartsApproEntre = echarts.init(document.getElementById("chartsApproEntre"));
      chartsApproEntre.setOption(optionApproEntre);
    },
    chartsSortieEntre: function chartsSortieEntre() {
      var optionSortieEntre = {
        title: {
          text: "Etat globale des sorties",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          x: "left",
          data: ["Sortie avec non retour", "Sortie avec retour prévue", "Retour éffectué", "Retour retardé", "Retour non éffectué avec un delai encore valide"]
        },
        series: [{
          type: "pie",
          radius: ["50%", "80%"],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: "center"
            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: "12",
                fontWeight: "bold"
              }
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: [{ value: this.pourcNR, name: "Sortie avec non retour" }, { value: this.pourcRP, name: "Sortie avec retour prévue" }, { value: this.pourcRE, name: "Retour éffectué" }, { value: this.pourcRD, name: "Retour retardé" }, {
            value: this.pourcRND,
            name: "Retour non éffectué avec un délai valide"
          }]
        }]
      };
      var chartsSortieEntre = document.getElementById("chartsSortieEntre") ? echarts.init(document.getElementById("chartsSortieEntre")) : null;
      if (document.getElementById("chartsSortieEntre") != null) {
        chartsSortieEntre.setOption(optionSortieEntre);
      }
    },
    loadUser: function loadUser() {
      var _this5 = this;

      this.loading = true;
      var url = this.domaine + "userCreate/user-list";
      this.$http.get(url).then(function (response) {
        _this5.loading = false;
        if (response.body) {
          _this5.users = response.body;
        }
      });
    },
    addListProduit: function addListProduit() {
      var _this6 = this;

      var libelle = "";
      this.listProd.find(function (item) {
        if (item.id == _this6.selectProduitRestant) {
          libelle = item;
        }
      });
      console.log('jrjrr', libelle);
      this.tabListProduit.push({
        type: libelle.type,
        id: libelle.id,
        libelle: libelle.value,
        unite: this.valeurUniteMateriel,
        seuil: this.seuilStock
      });
      this.seuilStock = 0;
      this.selectProduitRestant = "";
      this.valeurUniteMateriel = "";
      this.valeurCategorie = '';
    },
    filterProdStock: function filterProdStock(produit) {
      var _this7 = this;

      this.formAddStock.qte = 0;
      this.optionInventaire.find(function (item) {
        if (item.id == produit) {
          _this7.valeurUniteMateriel = item.unite;
          _this7.formAddStock.qte = item.qte;
        }
      });
    },
    filterStock: function filterStock(prodSelct) {
      var _this8 = this;

      var valeur = this.optionInventaire;
      var prod = this.strNoAccent(prodSelct);
      console.log("prodSelct", prodSelct);
      console.log("optionInventaire", this.optionInventaire);
      this.listeInventaire = [];
      if (prodSelct != "") {
        this.optionInventaire.filter(function (item) {
          if (item.type != null) {
            if (_this8.strNoAccent(item.type.toUpperCase()) == prod.toUpperCase()) {
              _this8.listeInventaire.push(item);
            }
          }
        });
      } else {
        this.listeInventaire = valeur;
      }
      console.log("this.listeInventaire", this.listeInventaire);
    },
    addNewStockProduit: function addNewStockProduit(item) {
      var libelle = [];
      this.optionInventaire.find(function (elemnt) {
        if (elemnt.id == item.designation) {
          libelle = elemnt;
        }
      });
      var etat = false;
      this.tabNewstock.find(function (elt) {
        if (item.id == libelle.id) {
          etat = true;
        }
      });
      if (etat == false) {
        this.tabNewstock.push({
          id: libelle.id,
          unite: this.valeurUniteMateriel,
          designation: libelle.produit,
          qteTeori: libelle.qte,
          qteReel: item.qteReel,
          ecart: parseInt(item.qteReel) - parseInt(libelle.qte)
        });
        this.formAddStock = {};
        this.valeurUniteMateriel = "";
      } else {
        this.$notify({
          title: "Ajout",
          message: "Impossible d'ajouter cette ressource, car elle existe déja dans le tableau d'inventaire.",
          type: "error",
          position: "top-center"
        });
      }
    },
    loadProduit: function loadProduit() {
      var _this9 = this;

      this.loading = true;
      var url = this.domaine + "product/product-list";
      this.$http.get(url).then(function (response) {
        _this9.loading = false;
        if (response.body) {
          _this9.listProd = response.body;
          _this9.optionStock = _this9.listProd;
          _this9.listeProduitAffich = response.body;
        }
      });
    },
    loadProjet: function loadProjet() {
      var _this10 = this;

      var url = this.domaine + "projet/index-projet-all";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this10.loading = false;
        if (response.body) {
          _this10.listProjet = response.body.projet;
        }
      });
    },
    loadChantier: function loadChantier() {
      var _this11 = this;

      this.loading = true;
      this.chantierS = "";
      this.travauxS = "";
      this.listChantier = [];
      if (this.projetS !== "") {
        var url = this.domaine + "projet/" + this.projetS + "/index/chantier";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this11.listChantier = response.body.chantier;
            _this11.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un projet");
        this.loading = false;
      }
    },
    loadTravaux: function loadTravaux() {
      var _this12 = this;

      this.loading = true;
      this.travauxS = "";
      this.listTravaux = [];
      if (this.chantierS !== "") {
        var url = this.domaine + "projet/" + this.chantierS + "/index/chantier/travaux";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this12.listTravaux = response.body.travaux;
            _this12.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un chantier");
        this.loading = false;
      }
    },
    loadDemande: function loadDemande() {
      var _this13 = this;

      this.loading = true;
      this.listDemande = [];
      var url = this.domaine + "entrepot/index/demande/devis/valide";
      this.$http.get(url).then(function (response) {
        _this13.loading = false;
        if (response.body) {
          _this13.listDemande = response.body.demande;
          _this13.loading = false;
        }
      });
    },
    loadStock: function loadStock(ligne) {
      var _this14 = this;

      console.log("ligne", ligne);
      this.entrepotCourant = ligne;
      this.loading = true;
      var url = "";
      if (this.droitAcces.entrepot) {
        url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/stock";
      } else {
        url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/" + this.user.id + "/chefEntrepot/stock";
      }

      // if(this.droitAcces.index_stock_chefEntrepot){
      //    url = this.domaine + 'entrepot/' + this.entrepotCourant.id + '/' + this.user.id + '/chefEntrepot/stock'
      // }
      // if(this.droitAcces.index_stock_chefValidation){
      //   url = this.domaine + 'entrepot/' + this.entrepotCourant.id + '/' + this.user.id + '/stock'
      // }
      // if (this.droitAcces.index_stock) {//list de tous les stocks de lentrepot
      //   url = this.domaine + 'entrepot/' + this.entrepotCourant.id + '/stock'
      // }
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this14.listStock = response.body.stock;
          _this14.optionInventaire = response.body.stock;
          _this14.listeInventaire = response.body.stock;
          if (_this14.listStock === undefined || _this14.listStock.length == 0) {
            _this14.disabledBtnS = true;
          } else {
            _this14.disabledBtnS = false;
          }

          for (var produit in _this14.listStock) {
            for (var optionSt in _this14.optionStock) {
              if (_this14.listStock[produit].idprod == _this14.optionStock[optionSt].id) {
                _this14.selectAll = true;
                _this14.optionStock[optionSt].coche = true;
                _this14.optionStock[optionSt].unite = _this14.listStock[produit].unite;
                _this14.optionStock[optionSt].seuil = _this14.listStock[produit].seuil;
                _this14.optionStock[optionSt].type = _this14.listStock[produit].type;
              }
            }
          }
          _this14.loading = false;
        }
      });
    },
    loadProduitRestant: function loadProduitRestant(ligne) {
      var _this15 = this;

      this.entrepotCourant = ligne;
      var url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/produit/restant";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this15.listProduitRestant = response.body.produit;
        }
      });
    },
    loadAppro: function loadAppro(ligne) {
      var _this16 = this;

      this.entrepotCourant = ligne;
      this.loading = true;
      var url = "";

      if (this.droitAcces.index_approvisionnement_chefEntrepot) {
        //vérification pour le chef de projet
        url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/" + this.user.id + "/chefEntrepot/approvisionnement";
      }
      if (this.droitAcces.index_approvisionnement) {
        //pour celui qui a tout les droits
        url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/approvisionnement";
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this16.listAppro = response.body.approvisionnement;
          if (_this16.listAppro === undefined || _this16.listAppro.length == 0) {
            _this16.disabledBtnA = true;
          } else {
            _this16.disabledBtnA = false;
          }
          _this16.loading = false;
        }
      });
    },
    loadACarburant: function loadACarburant(ligne) {
      var _this17 = this;

      this.entrepotCourant = ligne;
      this.loading = true;
      var url = "";

      if (this.droitAcces.index_approvisionnement_chefEntrepot) {
        //vérification pour le chef de projet
        url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/" + this.user.id + "/chefEntrepot/demande/carburant";
      }
      if (this.droitAcces.index_approvisionnement) {
        //pour celui qui a tout les droits
        url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/demande/carburant";
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this17.listCarburant = response.body.carburant;
          if (_this17.listCarburant === undefined || _this17.listCarburant.length == 0) {
            _this17.disabledBtnA = true;
          } else {
            _this17.disabledBtnA = false;
          }
          _this17.loading = false;
        }
      });
    },
    loadSortie: function loadSortie(ligne) {
      var _this18 = this;

      this.entrepotCourant = ligne;
      this.loading = true;
      var url = "";
      // if (this.droitAcces.index_sortie) {
      url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/sortie";
      // }
      //  if(this.droitAcces.index_sortie_chefEntrepot) {//vérification pour le chef de projet
      //   url = this.domaine + 'entrepot/' + this.entrepotCourant.id + '/' + this.user.id + '/chefEntrepot/sortie'
      // }
      // if (this.droitAcces.index_sortie_chefValidation) {//affiche les elements quil a creé utilisateur
      //   url = this.domaine + 'entrepot/' + this.entrepotCourant.id + '/' + this.user.id + '/sortie'
      // }

      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this18.listSortie = response.body.sortie;
          if (_this18.listSortie === undefined || _this18.listSortie.length == 0) {
            _this18.disabledBtnE = true;
          } else {
            _this18.disabledBtnE = false;
          }
          _this18.loading = false;
        }
      });
    },
    loadEntree: function loadEntree(ligne) {
      var _this19 = this;

      this.entrepotCourant = ligne;
      this.loading = true;

      var url = "";

      if (this.droitAcces.index_entree_chefEntrepot) {
        //vérification pour le chef de projet
        url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/" + this.user.id + "/chefEntrepot/entree";
      }

      if (this.droitAcces.index_entree_chefValidation) {
        //affiche les elements pour le chef de validation
        url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/" + this.user.id + "/entree";
      }

      if (this.droitAcces.index_entree) {
        //list de tous
        url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/entree";
      }

      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this19.listEntree = response.body.entree;
          if (_this19.listEntree === undefined || _this19.listEntree.length == 0) {
            _this19.disabledBtnR = true;
          } else {
            _this19.disabledBtnR = false;
          }

          _this19.loading = false;
        }
      });
    },
    loadEntrepot: function loadEntrepot() {
      var _this20 = this;

      this.loading = true;
      var url = "";
      if (this.droitAcces.entrepot) {
        //list de tous
        url = this.domaine + "entrepot/index";
      } else {
        //vérification pour le chef de projet,chef validattion et aussi personne qui a fait lenregistrement (this.droitAcces.entrepot_unique_chefEntrepot_index)
        url = this.domaine + "entrepot/unique/" + this.user.id + "/chefEntrepot/index";
      }
      // else if(this.droitAcces.entrepot_unique_chefValidation_index){//affiche les elements pour le chef de validation
      //  url = this.domaine + 'entrepot/unique/'+ this.user.id +'/index'
      // }
      // else{
      //      url = this.domaine + 'entrepot/index'
      //  }

      this.disabledBtn = false;
      this.$http.get(url).then(function (response) {
        _this20.loading = false;
        if (response.body) {
          _this20.listEntrepot = response.body.entrepot;
          if (_this20.listEntrepot.length == 0) {
            _this20.disabledBtn = true;
          }
          _this20.statsEntreApproAll = response.body.stats;
          _this20.pourcentageNR = response.body.pourcentageNR;
          _this20.pourcentageRP = response.body.pourcentageRP;
          _this20.pourcentageRE = response.body.pourcentageRE;
          _this20.pourcentageRD = response.body.pourcentageRD;
          _this20.pourcentageRND = response.body.pourcentageRND;
          _this20.nbrAppro = response.body.nbrAppro;
          _this20.nbrRetour = response.body.nbrRetour;
          _this20.nbrTrans = response.body.nbrTrans;
          _this20.nbrSortie = response.body.nbrSortie;
          _this20.nbrCarburant = response.body.nbrCarburant;
          _this20.chartsSortie();
          _this20.chartsAppro();
        }
      }, function (error) {
        _this20.loading = false;
      });
    },
    loadAutreEntrepot: function loadAutreEntrepot(ligne) {
      var _this21 = this;

      this.loading = true;
      this.entrepotCourant = ligne;
      var url = this.domaine + "entrepot/autre/" + this.entrepotCourant.id;
      this.$http.get(url).then(function (response) {
        _this21.loading = false;
        if (response.body) {
          _this21.listAutreEntrepot = response.body.autre;
        }
      }, function (error) {
        _this21.loading = false;
      });
    },
    loadProduitStock: function loadProduitStock(ligne) {
      var _this22 = this;

      this.loading = true;
      this.entrepotCourant = ligne;
      var url = this.domaine + "entrepot/stock/dispo/" + this.entrepotCourant.id;
      this.$http.get(url).then(function (response) {
        _this22.loading = false;
        if (response.body) {
          _this22.produitStock = response.body.stock;
        }
      }, function (error) {
        _this22.loading = false;
      });
    },
    loadTransfert: function loadTransfert(ligne) {
      var _this23 = this;

      this.loading = true;
      this.entrepotCourant = ligne;
      var url = "";

      if (this.droitAcces.index_transfert_chefEntrepot) {
        //vérification pour le chef de projet
        url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/" + this.user.id + "/chefEntrepot/transfert";
      }
      if (this.droitAcces.index_transfert_chefValidation) {
        //affiche les elements quil a creé utilisateur
        url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/" + this.user.id + "/transfert";
      }
      if (this.droitAcces.index_transfert) {
        url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/transfert";
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this23.listTransfert = response.body.transfert;
          _this23.listTransfertEmis = response.body.transfert.emis;
          if (_this23.listTransfertEmis === undefined || _this23.listTransfertEmis.length == 0) {
            _this23.disabledBtnDTE = true;
          } else {
            _this23.disabledBtnDTE = false;
          }
          _this23.listTransfertRecu = response.body.transfert.recu;
          if (_this23.listTransfertRecu === undefined || _this23.listTransfertRecu.length == 0) {
            _this23.disabledBtnDTR = true;
          } else {
            _this23.disabledBtnDTR = false;
          }

          _this23.loading = false;
        }
      }, function (error) {
        _this23.loading = false;
        _this23.$message.error("Erreur lors du chargement");
      });
    },
    loadInventaire: function loadInventaire(ligne) {
      var _this24 = this;

      this.loading = true;
      this.entrepotCourant = ligne;
      var url = "";
      if (this.droitAcces.entrepot) {
        url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/inventaire";
      } else {
        url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/" + this.user.id + "/chefEntrepot/inventaire";
      }

      //  if(this.droitAcces.index_inventaire_chefEntrepot) {//vérification pour le chef de projet
      //   url = this.domaine + 'entrepot/' + this.entrepotCourant.id + '/' + this.user.id + '/chefEntrepot/inventaire'
      // }
      // if(this.droitAcces.index_inventaire_chefValidation){//affiche les elements quil a creé utilisateur
      //   url = this.domaine + 'entrepot/' + this.entrepotCourant.id + '/' + this.user.id + '/inventaire'
      // }
      // if (this.droitAcces.index_inventaire) {
      //   url = this.domaine + 'entrepot/' + this.entrepotCourant.id + '/inventaire'
      // }
      this.$http.get(url).then(function (response) {
        _this24.loading = false;
        if (response.body) {
          _this24.listInventaire = response.body.inventaire;
          if (_this24.listInventaire === undefined || _this24.listInventaire.length == 0) {
            _this24.disabledBtnInv = true;
          } else {
            _this24.disabledBtnInv = false;
          }
          _this24.loading = false;
        }
      }, function (error) {
        _this24.loading = false;
        _this24.$message.error("Erreur lors du chargement");
      });
    },
    stockMultiSortie: function stockMultiSortie(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.choix = true;
      } else {
        this.choix = false;
      }
    },
    stockSelect: function stockSelect(row, index) {
      var etat = null;
      if (parseInt(row.qte) != 0) {
        etat = true;
      } else {
        etat = false;
      }
      console.log("jre", etat);
      return etat;
    },
    stockDemande: function stockDemande(row, index) {
      var etat = null;
      if (parseInt(row.etat) != 0) {
        etat = true;
      } else {
        etat = false;
      }
      return etat;
    },
    newEntrepot: function newEntrepot() {
      this.loading = true;
      this.entrepotCourant.id = "";
      this.libelleEntre = "";
      this.seletCiterne = "";
      this.hauteur = "";
      this.aire = "";
      this.espace = "";
      this.selectChefEntre = "";
      this.selectChefVali = "";
      this.selectTypeEntre = "";
      this.resistance = "";
      this.ville = "";
      this.commune = "";
      this.quartier = "";
      this.projetS = '';
      this.loadUser(), this.loadProduit();
      this.optionStock = this.listProd;
      this.descriEntre = "";
      this.formEtape = 1;
      this.dialogEdit = false;
      this.dialogAjout = true;
    },
    newStock: function newStock(ligne) {
      this.tabListProduit = [];
      this.loading = false;
      this.dialogStock = true;
      this.dialogEdit = false;
      this.valeurUniteMateriel = "";
      this.prodSelct = "";
      this.entrepotCourant = ligne;
    },
    newSortie: function newSortie(ligne) {
      if (this.showEnlevement) {
        this.loading = false;
        this.dialogCarburanSortie = true;
        this.dialogEdit = false;
        this.entrepotCourant = ligne;
        this.dateS = "";
        this.remarqueSortie = "";
        this.selectTypeSortie = 1;
        var comp = 0;
        this.factNull = false;
        for (var index = 0; index < this.multipleSelection.length; index++) {
          this.chantierS = this.multipleSelection[0]["chantier"];
          this.projetS = this.multipleSelection[0]["projet"];
          this.travauxS = this.multipleSelection[0]["travaux"];
          this.optionBesoin = this.multipleSelection[0]["id"];
          this.tacheSId = this.multipleSelection[0]["tacheId"];
          this.travauxSId = this.multipleSelection[0]["idTravaux"];
          this.tacheS = this.multipleSelection[0]["tache"];
          this.destinataireSortie = this.multipleSelection[0]["demnandeur"];

          var element1 = this.multipleSelection[0]["idTravaux"];
          var element = this.multipleSelection[index]["idTravaux"];
          var element2 = this.multipleSelection[index]["idTravaux"];
          var magasin1 = this.multipleSelection[0]["entrepotId"];

          if (element1 != "") {
            if (element1 == element) {
              comp++;
            } else {
              this.factNull = true;
              this.$refs.multipleTable.toggleRowSelection(this.multipleSelection[index]);
            }
          }
        }

        if (this.multipleSelection.length == comp && this.factNull === false) {
          var multipleSelection1 = this.multipleSelection;
          var tableau = multipleSelection1;
          for (var i = 0; i < tableau.length; ++i) {
            for (var j = i + 1; j < tableau.length; ++j) {
              if (tableau[i].idTravaux === tableau[j].idTravaux) {
                tableau[i].qte = tableau[i].qte + tableau[j].qte;
                tableau.splice(j--, 1);
              }
            }
          }
          this.optionSortie = tableau;
          this.idTravaux = this.multipleSelection[0]["idTravaux"];
          this.projetLib = this.multipleSelection[0]["projet"];
          this.dateLivr = this.multipleSelection[0]["dateLivr"];
          this.chantieretLib = this.multipleSelection[0]["chantier"];
          this.entrepotLib = this.multipleSelection[0]["libEntrepot"];
          this.travuxLib = this.multipleSelection[0]["travaux"];
          this.libelle = this.multipleSelection[0]["libelle"] ? this.multipleSelection[0]["libelle"] : "";
        } else {
          this.$notify({
            title: "Fusion",
            message: "Impossible de lier ces demandes de carburant pour le bon de sorti",
            type: "error",
            position: "top-center"
          });
        }
      } else {
        this.loading = false;
        this.dialogCarburanSortie = false;
        this.dialogSortie = true;
        this.dialogEdit = false;
        this.entrepotCourant = ligne;
        this.chantierS = "";
        this.projetS = "";
        this.travauxS = "";
        this.travauxSId = "";
        this.destinataireSortie = "";
        this.dateS = "";
        this.remarqueSortie = "";
        this.optionSortie = this.multipleSelection;
        for (var prop in this.optionSortie) {
          ligne = this.optionSortie[prop];
          if (ligne.qte === 0) {
            this.$notify({
              title: "ATTENTION",
              message: "Le stock de " + ligne.produit + " est vide.",
              type: "warning",
              position: "top-center"
            });
          }
        }
      }
    },
    newEntree: function newEntree(ligne) {
      this.loading = false;
      this.dialogEntree = true;
      this.dialogEdit = false;
      this.sortieCourant = ligne;
      this.dateRetour = "";
      this.qteRetour = 0;
      this.selectEtatRetour = "";
    },
    newTransfert: function newTransfert(ligne) {
      this.loading = false;
      this.dialogTransfert = true;
      this.dialogEdit = false;
      this.entrepotCourant = ligne;
      this.selectEntrepot = "";
      this.motifTransfert = "";
      this.selectPriorite = "";
      this.selectProduitDemande = "";
      this.qteD = 0;
    },
    newReponseTransfert: function newReponseTransfert(ligne) {
      this.loading = false;
      this.dialogReponseTransfert = true;
      this.transfertCourant = ligne;
    },
    newInventaire: function newInventaire(ligne) {
      this.formEtape = 1;
      this.loading = false;
      this.dialogInventaire = true;
      this.entrepotCourant = ligne;
      this.tabNewstock = [];
      console.log(this.optionInventaire);
      this.listeInventaire = this.optionInventaire;
      // this.optionInventaire = this.listStock
    },
    validerInventaire: function validerInventaire(ligne) {
      this.loading = false;
      this.dialogValiderInventaire = true;
      this.inventaireCourant = ligne;
      this.optionInventaire = this.inventaireCourant.valider;
    },
    editEntrepot: function editEntrepot(ligne) {
      this.loading = false;
      this.formEtape = 1;
      this.dialogAjout = true;
      this.dialogEdit = true;
      this.entrepotCourant = ligne;
      this.libelleEntre = this.entrepotCourant.libelle;
      this.seletCiterne = this.entrepotCourant.citerne;
      this.hauteur = this.entrepotCourant.hauteur;
      this.aire = this.entrepotCourant.aire;
      this.espace = this.entrepotCourant.espace;
      this.selectChefEntre = this.entrepotCourant.chefEntreId;
      this.selectChefVali = this.entrepotCourant.chefValiId;
      this.selectTypeEntre = this.entrepotCourant.type;
      // if (this.entrepotCourant.type == '') {
      //   this.selectTypeEntre = "Produit";
      // } else if (
      //   this.entrepotCourant.type == 2 ||
      //   this.entrepotCourant.type == "Hydrocarbure"
      // ) {
      //   this.selectTypeEntre = "Hydrocarbure";
      // }
      this.resistance = this.entrepotCourant.resistance;
      this.ville = this.entrepotCourant.ville;
      this.commune = this.entrepotCourant.commune;
      this.quartier = this.entrepotCourant.quartier;
      this.descriEntre = this.entrepotCourant.descriEntre;
      this.projetS = this.entrepotCourant.projet;
      // requete pour recuperer les stock deja selectionne
      this.optionStock = this.listProd;
      this.loadStock(ligne);
    },
    editTransfert: function editTransfert(ligne) {
      this.loading = false;
      this.dialogTransfert = true;
      this.dialogEdit = true;
      this.transfertCourant = ligne;
      this.selectEntrepot = this.transfertCourant.idEntR;
      this.motifTransfert = this.transfertCourant.motif;
      this.selectPriorite = parseInt(this.transfertCourant.priorite);
      this.selectProduitDemande = this.transfertCourant.stock;
      this.qteD = this.transfertCourant.qteD;
    },
    submit: function submit() {
      var _this25 = this;

      if (this.$refs.formEntrepot.validate() && this.selectTypeEntre != "" && this.selectChefEntre != "" && this.selectChefVali != "" && this.libelleEntre != "" && this.projetS != "" && this.ville != "" && this.commune != "") {
        var url = "";
        console.log("entrepotCourant", this.entrepotCourant);
        if (this.entrepotCourant.id) {
          url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/edit";
        } else {
          url = this.domaine + "entrepot/create";
        }
        var form = document.getElementById("formEntrepot");
        var data = new FormData(form);
        data.append("idUser", this.user.id);
        data.append("id", this.entrepotCourant.id);
        var detail = "";

        if (typeof this.selectTypeEntre != "string") {
          switch (this.selectTypeEntre) {
            case 1:
              detail = "Produit";
              break;
            case 2:
              detail = "Hydrocarbure";
              break;
            default:
              detail = "Produit";
              break;
          }
        } else {
          switch (this.selectTypeEntre) {
            case "Produit":
              detail = "Produit";
              break;
            case "Hydrocarbure":
              detail = "Hydrocarbure";
              break;
            default:
              detail = "Produit";
              break;
          }
        }
        data.append("type", detail);
        data.append("chefEntre", this.selectChefEntre);
        data.append("chefVali", this.selectChefVali);
        data.append("citerne", this.seletCiterne);
        data.append("projetS", this.projetS);

        data.append("tableProduit", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableProduit));
        this.loading = true;
        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              if (_this25.entrepotCourant.id) {
                _this25.$notify({
                  title: "MODIFICATION REUSSI",
                  message: "Entrepot modifié avec succès.",
                  type: "success",
                  position: "top-center"
                });
              } else {
                _this25.createStock(response.body.entrepot);
                _this25.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Entrepot enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
              }
              _this25.loadEntrepot();
              _this25.dialogAjout = false;
              _this25.loading = false;
            } else if (verif.code === 0) {
              _this25.$message.error(verif.message);
              _this25.loading = false;
            }
          } else {
            _this25.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this25.loading = false;
          }
        }, function (response) {
          _this25.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this25.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "L'entrepot n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
        this.formEtape = 1;
      }
    },
    createStock: function createStock(entrepot) {
      var _this26 = this;

      var form = document.getElementById("formEntrepot");
      var nbData = 1;
      if (this.listeStockSelect.length > 10) {
        nbData = 10;
      }
      var nbReq = Math.round(this.listeStockSelect.length / nbData);
      var nbRest = this.listeStockSelect.length % nbData;
      if (nbRest > 0) {
        nbReq += 1;
      }
      if (nbReq == 0 && this.listeStockSelect.length > 0) {
        nbReq = 1;
      }
      var ligne = null;
      for (var i = 0; i < nbReq; i++) {
        var initJ = i * nbData;
        var finJ = (i + 1) * nbData;
        var dataLot = [];
        if (this.listeStockSelect.length > 0) {
          for (var j = initJ; j < finJ; j++) {
            if (this.listeStockSelect[j] == undefined) {
              break;
            }
            dataLot.push(this.listeStockSelect[j]);
          }
        }
        var data = new FormData();

        for (var prop in dataLot) {
          ligne = dataLot[prop];
          data.append("options[id][]", ligne.id);
          data.append("options[seuil][]", ligne.seuil);
          data.append("options[unite][]", ligne.unite);
          data.append("options[coche][]", ligne.coche);
        }
        var url = this.domaine + "entrepot/" + entrepot + "/stock/entrepot";
        this.loading = true;
        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this26.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Entrepot enregistré avec succès.",
                type: "success",
                position: "top-center"
              });
              _this26.loadEntrepot();
              _this26.dialogAjout = false;
              _this26.loading = false;
            } else if (verif.code === 0) {
              _this26.$message.error(verif.message);
              _this26.loading = false;
            }
          } else {
            _this26.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this26.loading = false;
          }
        }, function (response) {
          _this26.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this26.loading = false;
        });
      }
    },
    submitStock: function submitStock() {
      var _this27 = this;

      this.loading = true;
      if (this.tabListProduit.length != 0) {
        var form = document.getElementById("formStock");
        var ligne = null;
        var nbData = 10;
        var nbReq = 1;
        var nbRest = void 0;
        if (this.tabListProduit.length > 10) {
          nbData = 10;
          nbReq = Math.round(this.tabListProduit.length / nbData);
          nbRest = this.tabListProduit.length % nbData;
          if (nbRest > 0) {
            nbReq += 1;
          }
        }
        for (var i = 0; i < nbReq; i++) {
          var initJ = i * nbData;
          var finJ = (i + 1) * nbData;
          var dataLot = [];
          if (this.tabListProduit.length > 0) {
            for (var j = initJ; j < finJ; j++) {
              if (this.tabListProduit[j] == undefined) {
                break;
              }
              dataLot.push(this.tabListProduit[j]);
            }
          }
          var url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/new/stock/appro";
          var data = new FormData();
          data.append("idUser", this.user.id);
          for (var prop in dataLot) {
            ligne = dataLot[prop];
            data.append("options[produit][]", ligne.id);
            data.append("options[seuil][]", ligne.seuil);
          }

          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this27.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Stock enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
                _this27.loadStock(_this27.entrepotCourant);
                _this27.loadProduitRestant(_this27.entrepotCourant);
                _this27.showEntrepot(_this27.entrepotCourant);
                _this27.loadEntrepot();
                _this27.dialogStock = false;
                _this27.loading = false;
              } else {
                _this27.$notify({
                  title: "ENREGISTREMENT ECHOUE",
                  message: verif.message,
                  type: "error",
                  position: "top-center"
                });
                _this27.loading = false;
              }
            } else {
              _this27.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this27.loading = false;
            }
          }, function (response) {
            _this27.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this27.loading = false;
          });
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le stock n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
        this.formEtape = 1;
      }
    },
    deleteRow: function deleteRow(index, rows) {
      var item = rows.splice(index, 1);
    },
    deleteRowStock: function deleteRowStock(index, rows) {
      var item = rows.splice(index, 1);
    },
    submitSortie: function submitSortie() {
      var _this28 = this;

      this.loading = true;
      if (this.$refs.formSortie.validate() && this.dateS != "" && this.travauxS != "") {
        var form = document.getElementById("formSortie");
        var data = new FormData(form);
        var url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/new/sortie";
        data.append("idUser", this.user.id);
        data.append("travaux", this.travauxS);
        data.append("demande", this.selectDemande);
        data.append("optionBesoin", this.optionBesoin);

        data.append("tache", this.tacheSId);
        data.append("typeHydro", this.detailEntre.typeHydro);
        data.append("type", this.selectTypeSortie);
        data.append("destinataireSortie", this.destinataireSortie);
        var ligne = null;
        for (var prop in this.optionSortie) {
          ligne = this.optionSortie[prop];
          data.append("options[id][]", ligne.id);
          data.append("options[qte][]", ligne.qte);
          data.append("options[carburant][]", ligne.carburant);
          data.append("options[qteS][]", ligne.qteS);
          data.append("options[etat][]", ligne.selectEtatProduit);
          data.append("options[retour][]", ligne.selectRetourPrev);
          data.append("options[dateRe][]", ligne.dateRe);
        }
        this.$http.post(url, data).then(function (response) {
          _this28.loading = false;
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this28.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Sortie enregistré avec succès.",
                type: "success",
                position: "top-center"
              });
              _this28.loadStock(_this28.entrepotCourant);
              _this28.loadSortie(_this28.entrepotCourant);
              _this28.showEntrepot(_this28.entrepotCourant);
              if (_this28.detailEntre.typeHydro) {
                _this28.loadACarburant(_this28.detailEntre);
                _this28.loadStock(_this28.detailEntre);
              }

              _this28.dialogSortie = false;
              _this28.dialogCarburanSortie = false;
              _this28.loading = false;
            } else if (verif.code === 2) {
              _this28.$message.error(verif.message);
              _this28.loading = false;
            } else if (verif.code === 0) {
              _this28.$message.error(verif.message);
              _this28.loading = false;
            }
          } else {
            _this28.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this28.loading = false;
          }
        }, function (response) {
          _this28.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this28.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La sortie n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitEntree: function submitEntree() {
      var _this29 = this;

      this.loading = true;
      if (this.$refs.formEntree.validate() && this.selectEtatRetour != "" && this.dateRetour != "" && this.qteRetour != 0) {
        var form = document.getElementById("formEntree");
        var data = new FormData(form);
        var url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/new_entree";
        data.append("idUser", this.user.id);
        data.append("idSortie", this.sortieCourant.id);
        data.append("etat", this.selectEtatRetour);
        this.$http.post(url, data).then(function (response) {
          _this29.loading = false;
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this29.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Retour enregistré avec succès.",
                type: "success",
                position: "top-center"
              });
              _this29.loadSortie(_this29.entrepotCourant);
              _this29.loadEntree(_this29.entrepotCourant);
              _this29.loadStock(_this29.entrepotCourant);
              _this29.showEntrepot(_this29.entrepotCourant);
              _this29.loadEntrepot();
              _this29.dialogEntree = false;
              _this29.loading = false;
            } else if (verif.code === 0) {
              _this29.$message.error(verif.message);
              _this29.loading = false;
            } else if (verif.code === 2) {
              _this29.$message.error(verif.message);
              _this29.loading = false;
            }
          } else {
            _this29.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this29.loading = false;
          }
        }, function (response) {
          _this29.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this29.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La retour n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
        this.formEtape = 1;
      }
    },
    submitTransfert: function submitTransfert() {
      var _this30 = this;

      this.loading = true;
      if (this.$refs.formTransfert.validate() && this.selectPriorite != "" && this.selectProduitDemande != "" && this.selectEntrepot != "" && this.motifTransfert != "") {
        var form = document.getElementById("formTransfert");
        var data = new FormData(form);
        var url = "";
        if (this.transfertCourant.id) {
          url = this.domaine + "entrepot/" + this.transfertCourant.id + "/edit_transfert";
        } else {
          url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/new_transfert";
        }
        data.append("idUser", this.user.id);
        data.append("priorite", this.selectPriorite);
        data.append("produitDemande", this.selectProduitDemande);
        data.append("autre", this.selectEntrepot);
        this.$http.post(url, data).then(function (response) {
          _this30.loading = false;
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              if (_this30.transfertCourant.id) {
                _this30.$notify({
                  title: "MODIFICATION REUSSI",
                  message: response.body.message,
                  type: "success",
                  position: "top-center"
                });
              } else {
                _this30.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Transfert enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
              }
              _this30.loadTransfert(_this30.entrepotCourant);
              _this30.showEntrepot(_this30.entrepotCourant);
              _this30.loadEntrepot();
              _this30.dialogTransfert = false;
              _this30.loading = false;
            } else if (verif.code === 2) {
              _this30.$message.error(verif.message);
              _this30.loading = false;
            } else if (verif.code === 0) {
              _this30.$message.error(verif.message);
              _this30.loading = false;
            } else if (verif.code === 3) {
              _this30.$message.error(verif.message);
              _this30.loading = false;
            }
          } else {
            _this30.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this30.loading = false;
          }
        }, function (response) {
          _this30.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this30.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le transfert n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
        this.formEtape = 1;
      }
    },
    submitReponseTransfert: function submitReponseTransfert() {
      var _this31 = this;

      this.loading = true;
      if (this.$refs.formReponseTransfert.validate() && this.selectReponseTransfert != "" && this.qteT > 0) {
        var form = document.getElementById("formReponseTransfert");
        var data = new FormData(form);
        var url = this.domaine + "entrepot/" + this.transfertCourant.id + "/new/reponse/transfert";
        data.append("idUser", this.user.id);
        data.append("reponseTransfert", this.selectReponseTransfert);
        this.$http.post(url, data).then(function (response) {
          _this31.loading = false;
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this31.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "La réponse a été enregistré avec succès.",
                type: "success",
                position: "top-center"
              });
              _this31.dialogReponseTransfert = false;
              _this31.loadTransfert(_this31.entrepotCourant);
              _this31.showEntrepot(_this31.entrepotCourant);
              _this31.loadEntrepot();
              _this31.loading = false;
            } else if (verif.code === 2) {
              _this31.$message.error(verif.message);
              _this31.loading = false;
            } else if (verif.code === 0) {
              _this31.$message.error(verif.message);
              _this31.loading = false;
            }
          } else {
            _this31.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this31.loading = false;
          }
        }, function (response) {
          _this31.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this31.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La réponse n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
        this.formEtape = 1;
      }
    },
    submitInventaire: function submitInventaire() {
      var _this32 = this;

      //on verifi si la date debut est inferieur a la date de fin
      if (this.tabNewstock.length != 0 && this.dateDeb != "" && this.dateFin != "") {
        if (new Date(this.dateDeb) <= new Date(this.dateFin)) {
          this.loading = true;
          var form = document.getElementById("formInventaire");
          var data = new FormData(form);
          var url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/new_inventaire";
          data.append("idUser", this.user.id);
          this.$http.post(url, data).then(function (response) {
            _this32.createInventaire(response.body.inventaire);
          }, function (error) {
            _this32.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this32.loading = false;
          });
        } else {
          this.$notify.error({
            title: "ERREUR DE DATE",
            message: "La date de début ne doit pas être supérieur à la date de fin.",
            position: "top-center"
          });
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "L'inventaire n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
        this.formEtape = 1;
      }
    },
    createInventaire: function createInventaire(inventaire) {
      var _this33 = this;

      var ligne = null;
      var nbData = 10;
      var nbReq = 1;
      var tabfinal = [];
      var nbRest = void 0;
      if (this.tabNewstock.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.tabNewstock.length / nbData);
        nbRest = this.tabNewstock.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (var i = 0; i < nbReq; i++) {
        var initJ = i * nbData;
        var finJ = (i + 1) * nbData;
        var dataLot = [];
        if (this.tabNewstock.length > 0) {
          for (var j = initJ; j < finJ; j++) {
            if (this.tabNewstock[j] == undefined) {
              break;
            }
            dataLot.push(this.tabNewstock[j]);
          }
        }
        var data = new FormData();
        var url = this.domaine + "entrepot/" + inventaire + "/inventaire/valide";
        data.append("idUser", this.user.id);
        for (var prop in dataLot) {
          ligne = dataLot[prop];
          data.append("options[stock][]", ligne.id);
          data.append("options[qteT][]", ligne.qte);
          data.append("options[qteReel][]", ligne.qteReel);
          data.append("options[ecart][]", ligne.ecart);
        }

        this.$http.post(url, data).then(function (response) {
          _this33.loading = false;
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this33.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "L'inventaire a été enregistré avec succès.",
                type: "success",
                position: "top-center"
              });

              _this33.showEntrepot(_this33.entrepotCourant);
              _this33.loadInventaire(_this33.entrepotCourant);
              _this33.showEntrepot(_this33.entrepotCourant);
              _this33.loadEntrepot();
              _this33.dialogInventaire = false;
              _this33.loading = false;
            } else if (verif.code === 0) {
              _this33.$message.error(verif.message);
              _this33.loading = false;
            }
          } else {
            _this33.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this33.loading = false;
          }
        }, function (error) {
          _this33.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this33.loading = false;
        });
      }
    },
    submitValiderInventaire: function submitValiderInventaire() {
      var _this34 = this;

      this.loading = true;
      if (this.$refs.formValiderInventaire.validate()) {
        var nbData = 10;
        var nbReq = 1;
        var tabfinal = [];
        this.optionInventaire.forEach(function (item, index) {
          if (item.stockInventaire == true || item.selectCorriger == 1) {
            tabfinal.push(item);
          }
        });

        var nbRest = void 0;
        if (tabfinal.length > 10) {
          nbData = 10;
          nbReq = Math.round(tabfinal.length / nbData);
          nbRest = tabfinal.length % nbData;
          if (nbRest > 0) {
            nbReq += 1;
          }
        }
        for (var i = 0; i < nbReq; i++) {
          var initJ = i * nbData;
          var finJ = (i + 1) * nbData;
          var dataLot = [];
          if (tabfinal.length > 0) {
            for (var j = initJ; j < finJ; j++) {
              if (tabfinal[j] == undefined) {
                break;
              }
              dataLot.push(tabfinal[j]);
            }
          }

          var form = document.getElementById("formValiderInventaire");
          var data = new FormData(form);
          var url = this.domaine + "entrepot/" + this.inventaireCourant.id + "/new/valider/inventaire";
          data.append("idUser", this.user.id);
          var ligne = null;
          for (var prop in dataLot) {
            ligne = dataLot[prop];
            data.append("options[id][]", ligne.idOption);
            data.append("options[stock][]", ligne.stock);
            data.append("options[corriger][]", ligne.selectCorriger);
          }
          this.$http.post(url, data).then(function (response) {
            _this34.loading = false;
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this34.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "La validation de l'inventaire a été enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
                _this34.loadInventaire(_this34.entrepotCourant);
                _this34.showEntrepot(_this34.entrepotCourant);
                _this34.loadEntrepot();

                _this34.dialogValiderInventaire = false;
                _this34.dialogConfir = false;
                _this34.dialogShowInventaire = false;
                _this34.loading = false;
              } else if (verif.code === 0) {
                _this34.$message.error(verif.message);
                _this34.loading = false;
              }
            } else {
              _this34.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this34.loading = false;
            }
          }, function (response) {
            _this34.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this34.loading = false;
          });
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La validation de l'inventaire n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
        this.formEtape = 1;
      }
    },
    calculEcart: function calculEcart() {
      this.ecart = this.qteReel - this.inventaireCourant.qteT;
    },
    statCommande: function statCommande() {
      var dataCitrene = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var posList = ["left", "right", "top", "bottom", "inside", "insideTop", "insideLeft", "insideRight", "insideBottom", "insideTopLeft", "insideTopRight", "insideBottomLeft", "insideBottomRight"];
      app.configParameters = {
        rotate: {
          min: -90,
          max: 90
        },
        align: {
          options: {
            left: "left",
            center: "center",
            right: "right"
          }
        },
        verticalAlign: {
          options: {
            top: "top",
            middle: "middle",
            bottom: "bottom"
          }
        },
        position: {
          options: echarts.util.reduce(posList, function (map, pos) {
            map[pos] = pos;
            return map;
          }, {})
        },
        distance: {
          min: 0,
          max: 100
        }
      };

      app.config = {
        rotate: 90,
        align: "left",
        verticalAlign: "middle",
        position: "insideBottom",
        distance: 15,
        onChange: function onChange() {
          var labelOption = {
            normal: {
              rotate: app.config.rotate,
              align: app.config.align,
              verticalAlign: app.config.verticalAlign,
              position: app.config.position,
              distance: app.config.distance
            }
          };
          myChart.setOption({
            series: [{
              label: labelOption
            }, {
              label: labelOption
            }, {
              label: labelOption
            }, {
              label: labelOption
            }]
          });
        }
      };

      var optionComd = {
        title: {
          text: "QUANTITE DANS LA CITERNE",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["Disponible(s)", "Sortie(s)"]
        },
        series: [{
          name: "Quantité(s)",
          type: "pie",
          radius: "75%",
          center: ["50%", "60%"],
          color: ["#FF7043", "#26A69A"],
          data: [
            //{value: 1548, name: '搜索引擎'}
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      };
      for (var dataCom in dataCitrene) {
        optionComd.series[0].data.push({
          value: dataCitrene[dataCom],
          name: dataCom
        });
      }
      this.nbQteDisponible = dataCitrene.disponible;
      this.nbQteUtilise = dataCitrene.utilise;
      var chartCiterneCarburant = document.getElementById("chartCiterneCarburant") ? echarts.init(document.getElementById("chartCiterneCarburant")) : null;
      if (document.getElementById("chartCiterneCarburant") != null) {
        chartCiterneCarburant.setOption(optionComd);
      }
    },
    calculEcartLigne: function calculEcartLigne() {
      for (var pop in this.optionInventaire) {
        this.optionInventaire[pop].ecart = parseInt(this.optionInventaire[pop].qteReel) - parseInt(this.optionInventaire[pop].qte);
      }
    },
    verifeClore: function verifeClore() {
      if (this.sortieCourant.qteRestante == this.qteRetour) {
        this.verifeEtat = false;
      } else if (this.sortieCourant.qteRestante > this.qteRetour) {
        this.verifeEtat = true;
      } else {
        this.verifeEtat = true;
        this.qteRetour = 0;
      }
    },
    showClick: function showClick(tab, event) {
      this.loading = true;
      if (tab.name == "fiche") {
        this.showEntrepot(this.detailEntre);
      } else if (tab.name == "stock") {
        this.showEnlevement = false;
        this.loadStock(this.detailEntre);
      } else if (tab.name == "sortie") {
        this.loadSortie(this.detailEntre);
      } else if (tab.name == "retour") {
        this.loadEntree(this.detailEntre);
      } else if (tab.name == "carburant") {
        this.showEnlevement = true;
        this.loadACarburant(this.detailEntre);
      } else if (tab.name == "appro") {
        this.loadAppro(this.detailEntre);
      } else if (tab.name == "transfert") {
        this.loadTransfert(this.detailEntre);
      } else if (tab.name == "inventaire") {
        this.loadInventaire(this.detailEntre);
      }
    },
    showEntrepot: function showEntrepot(ligne) {
      var _this35 = this;

      this.loading = true;
      this.dialogShow = true;
      this.detailEntre = [];
      this.nbrApproEntre = 0;
      this.nbrRetourEntre = 0;
      this.nbrTransEntre = 0;
      this.nbrSortieEntre = 0;
      this.nbrCarburantEntre = 0;
      this.pourcNR = 0;
      this.pourcRP = 0;
      this.pourcRE = 0;
      this.pourcRD = 0;
      this.pourcRND = 0;
      this.entrepotCourant = ligne;
      var url = this.domaine + "entrepot/" + this.entrepotCourant.id + "/show";
      this.$http.get(url).then(function (response) {
        _this35.loading = false;
        if (response.body) {
          _this35.detailEntre = response.body.entrepot;
          _this35.statsEntreAppro = response.body.stats;
          _this35.pourcNR = response.body.pourcNR;
          _this35.pourcRP = response.body.pourcRP;
          _this35.pourcRE = response.body.pourcRE;
          _this35.pourcRD = response.body.pourcRD;
          _this35.pourcRND = response.body.pourcRND;
          _this35.nbrApproEntre = response.body.nbrAppro;
          _this35.nbrRetourEntre = response.body.nbrRetour;
          _this35.nbrTransEntre = response.body.nbrTrans;
          _this35.nbrSortieEntre = response.body.nbrSortie;
          _this35.nbrCarburantEntre = response.body.nbrCarburant;
          _this35.statsCarburant = response.body.citerne;
          if (_this35.detailEntre.typeHydro != "") {
            _this35.statCommande(response.body.citerne);
          }
          _this35.chartsSortieEntre();
          _this35.chartsApproEntre();
          _this35.loading = false;
        }
      });
    },
    showSortie: function showSortie(ligne) {
      var _this36 = this;

      this.loading = true;
      this.dialogShowSortie = true;
      this.sortieCourant = ligne;
      var url = this.domaine + "entrepot/" + this.sortieCourant.id + "/show/sortie";
      this.$http.get(url).then(function (response) {
        _this36.loading = false;
        if (response.body) {
          _this36.detailSortie = response.body.sortie;
          _this36.loading = false;
        }
      });
    },
    showEntree: function showEntree(ligne) {
      var _this37 = this;

      this.loading = true;
      this.dialogShowEntree = true;
      this.entreeCourant = ligne;
      var url = this.domaine + "entrepot/" + this.entreeCourant.id + "/show/entree/produit";
      this.$http.get(url).then(function (response) {
        _this37.loading = false;
        if (response.body) {
          _this37.detailEntree = response.body.entree;
          _this37.loading = false;
        }
      });
    },
    showTransfert: function showTransfert(ligne) {
      var _this38 = this;

      this.loading = true;
      this.dialogShowTransfert = true;
      this.transfertCourant = ligne;
      var url = this.domaine + "entrepot/" + this.transfertCourant.id + "/transfert/show";
      this.$http.get(url).then(function (response) {
        _this38.loading = false;
        if (response.body) {
          _this38.detailTransfert = response.body.transfert;
          _this38.loading = false;
        }
      });
    },
    showInventaire: function showInventaire(ligne) {
      var _this39 = this;

      this.loading = true;
      this.dialogShowInventaire = true;
      this.inventaireCourant = ligne;
      var url = this.domaine + "entrepot/show-inventaire/" + this.inventaireCourant.id;
      this.$http.get(url).then(function (response) {
        _this39.loading = false;
        if (response.body) {
          _this39.detailInventaire = response.body.inventaire;
          _this39.loading = false;
        }
      });
    },
    confirmerAll: function confirmerAll() {
      this.optionInventaire.forEach(function (item, index) {
        item.selectCorriger = 1;
      });
      this.submitValiderInventaire();
    },
    showAppro: function showAppro(ligne) {
      this.showDetailAppro = true;
      this.approCourant = ligne;
    },
    imprimerAppro: function imprimerAppro(ligne) {
      var _this40 = this;

      this.loading = true;
      this.approCourant = ligne;
      var url = this.domaine + "entrepot/" + this.approCourant.id + "/" + this.user.id + "/imprimer/approvisionnement";
      this.$http.get(url).then(function (response) {
        _this40.loading = false;
        if (response.body) {}
      });
      window.open(url);
    },
    imprimerSortie: function imprimerSortie(ligne) {
      var _this41 = this;

      this.loading = true;
      this.sortieCourant = ligne;
      var url = this.domaine + "entrepot/" + this.sortieCourant.id + "/" + this.user.id + "/imprimer/sortie/imprim";
      this.$http.get(url).then(function (response) {
        _this41.loading = false;
        if (response.body) {}
      });
      window.open(url);
      this.loading = false;
    },
    imprimerEntree: function imprimerEntree(ligne) {
      this.entreeCourant = ligne;
      var url = this.domaine + "entrepot/" + this.entreeCourant.id + "/" + this.user.id + "/imprimer/entree/produit";
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
      this.loading = false;
    },
    imprimerTransfert: function imprimerTransfert(ligne) {
      var _this42 = this;

      this.transfertCourant = ligne;
      var url = this.domaine + "entrepot/" + this.transfertCourant.id + "/" + this.user.id + "/transfert/imprimer";
      this.$http.get(url).then(function (response) {
        _this42.loading = false;

        if (response.body) {}
      });
      window.open(url);
      this.loading = false;
    },
    imprimerInventaire: function imprimerInventaire(ligne) {
      var _this43 = this;

      this.inventaireCourant = ligne;
      var url = this.domaine + "entrepot/" + this.inventaireCourant.id + "/" + this.user.id + "/imprimerInventaire";
      this.$http.get(url).then(function (response) {
        _this43.loading = false;

        if (response.body) {}
      });
      window.open(url);
      this.loading = false;
    },
    imprimerAllSortie: function imprimerAllSortie(ligne) {
      var _this44 = this;

      var url = this.domaine + "entrepot/" + ligne + "/imprimer/sortie/demande";
      this.$http.get(url).then(function (response) {
        _this44.loading = false;

        if (response.body) {}
      });
      this.loading = false;

      window.open(url);
    },
    imprimeListeHisEntrepotStock: function imprimeListeHisEntrepotStock(type) {
      var idEntr = this.entrepotCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "entrepot/imprimerPDF/historique/" + idEntr + "/stock/liste";
      } else {
        url = this.domaine + "entrepot/imprimerEXC/historique/" + idEntr + "/stock/liste";
      }
      window.open(url);
    },
    imprimeListeHisEntrepotAppro: function imprimeListeHisEntrepotAppro(type) {
      var idEntr = this.entrepotCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "entrepot/imprimerPDF/historique/" + idEntr + "/appro/liste";
      } else {
        url = this.domaine + "entrepot/imprimerEXC/historique/" + idEntr + "/appro/liste";
      }
      window.open(url);
    },
    imprimeListeHisEntrepotEnlevmt: function imprimeListeHisEntrepotEnlevmt(type) {
      var idEntr = this.entrepotCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "entrepot/imprimerPDF/historique/" + idEntr + "/Enlevmt/liste";
      } else {
        url = this.domaine + "entrepot/imprimerEXC/historique/" + idEntr + "/Enlevmt/liste";
      }
      window.open(url);
    },
    imprimeListeHisEntrepotRetour: function imprimeListeHisEntrepotRetour(type) {
      var idEntr = this.entrepotCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "entrepot/imprimerPDF/historique/" + idEntr + "/retour/liste";
      } else {
        url = this.domaine + "entrepot/imprimerEXC/historique/" + idEntr + "/retour/liste";
      }
      window.open(url);
    },
    imprimeListeHisEntrepotDmdTEmise: function imprimeListeHisEntrepotDmdTEmise(type) {
      var idEntr = this.entrepotCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "entrepot/imprimerPDF/historique/" + idEntr + "/dmdemise/liste";
      } else {
        url = this.domaine + "entrepot/imprimerEXC/historique/" + idEntr + "/dmdemise/liste";
      }
      window.open(url);
    },
    imprimeListeHisEntrepotDmdTRecu: function imprimeListeHisEntrepotDmdTRecu(type) {
      var idEntr = this.entrepotCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "entrepot/imprimerPDF/historique/" + idEntr + "/dmdrecu/liste";
      } else {
        url = this.domaine + "entrepot/imprimerEXC/historique/" + idEntr + "/dmdrecu/liste";
      }
      window.open(url);
    },
    imprimeListeHisEntrepotInventaire: function imprimeListeHisEntrepotInventaire(type) {
      var idEntr = this.entrepotCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "entrepot/imprimerPDF/historique/" + idEntr + "/inventaire/liste";
      } else {
        url = this.domaine + "entrepot/imprimerEXC/historique/" + idEntr + "/inventaire/liste";
      }
      window.open(url);
    },
    deleteEntrepot: function deleteEntrepot() {
      var _this45 = this;

      this.loading = true;
      var url = this.domaine + "entrepot/" + this.idEntrepot + "/delete";
      this.$http.get(url).then(function (response) {
        _this45.loading = false;
        if (response.body) {
          _this45.$notify({
            title: "SUPPRESSION",
            message: "Entrepot supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          _this45.dialogSupr = false;
          _this45.loading = false;
          _this45.loadEntrepot();
          _this45.loading = false;
        }
      }, function (error) {
        _this45.loading = false;
        _this45.$notify({
          title: "SUPPRESSION",
          message: "Impossible de surprimer ce entrepot,Veuillez contacter votre administrateur.",
          type: "danger",
          position: "top-center"
        });
      });
    },
    clear: function clear() {
      this.$refs.formEntrepot.reset();
      this.dialogAjout = false;
    },
    clearInventaire: function clearInventaire() {
      this.$refs.formInventaire.reset();
      this.dialogInventaire = false;
    },

    beforeMount: function beforeMount() {
      if (!this.roleAcces[this.$router.history.current.name]) {
        this.$router.push({ name: "Home" });
      }
    },
    imprimeListeHis: function imprimeListeHis(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "entrepot/imprimerPDF/liste";
      } else {
        url = this.domaine + "entrepot/imprimerEXC/liste";
      }
      window.open(url);
    },
    strNoAccent: function strNoAccent(a) {
      var b = "áàâäãåçéèêëíïîìñóòôöõúùûüýÁÀÂÄÃÅÇÉÈÊËÍÏÎÌÑÓÒÔÖÕÚÙÛÜÝ",
          c = "aaaaaaceeeeiiiinooooouuuuyAAAAAACEEEEIIIINOOOOOUUUUY",
          d = "";
      for (var i = 0, j = a.length; i < j; i++) {
        var e = a.substr(i, 1);
        d += b.indexOf(e) !== -1 ? c.substr(b.indexOf(e), 1) : e;
      }
      return d;
    },
    loadTypeRessource: function loadTypeRessource() {
      var _this46 = this;

      var url = this.domaine + "product/typeRessource";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this46.listTypeRessource = response.body.types;
          _this46.loading = false;
        }
      });
    },
    openDialogBon: function openDialogBon(item) {
      var _this47 = this;

      this.loading = true;
      var url = this.domaine + "demande_maintenance/" + item.id + "/listeProduitBon";
      var data = new FormData();
      data.append("idUser", this.user.id);

      this.$http.post(url, data).then(function (response) {
        _this47.loading = false;
        var resp = response.body;
        if (resp.code == 0) {
          _this47.$notify({
            title: "BON DE SORTI D'UNE PRODUIT",
            message: resp.message,
            type: "success",
            duration: 5000,
            position: "top-center"
          });
        } else {
          _this47.$notify({
            title: "BON DE SORTI D'UNE PRODUIT",
            message: resp.message,
            type: "error",
            duration: 5000,
            position: "top-center"
          });
        }
        _this47.loading = false;
        _this47.loadSortie(_this47.entrepotCourant);
        _this47.loadStock(_this47.entrepotCourant);
        _this47.showEntrepot(_this47.entrepotCourant);
      }, function (err) {
        _this47.loading = false;
      });
    },
    validDmCarbur: function validDmCarbur(item) {
      this.qteLivDepart = item.qte;
      this.produitLiv = item.produit;
      this.idProduitLiv = item.idProduit;
      this.codetLiv = item.refLivr;
      this.idApproLiv = item.id;
      this.dialogValidCarburan = true;
    },
    validLivrAppro: function validLivrAppro(item) {
      this.qteLivDepart = item.qte;
      this.produitLiv = item.produit;
      this.idProduitLiv = item.idProduit;
      this.codetLiv = item.refLivr;
      this.idApproLiv = item.id;
      this.dialogValidAppro = true;
    },
    acceptLivrApproValid: function acceptLivrApproValid() {
      var _this48 = this;

      if (this.$refs.formValidApproLivr.validate()) {
        var form = document.getElementById("formValidApproLivr");
        var data = new FormData(form);
        data.append("idUser", this.user.id);
        data.append("idEntrepot", this.entrepotCourant.id);
        data.append("qteDepart", this.qteLivDepart);
        data.append("idProduit", this.idProduitLiv);
        data.append("idAppro", this.idApproLiv);
        data.append("idReponse", this.choixValidLiv);
        data.append("nomLivreur", this.nomLivreur);
        // data.append('nbChoice', this.nbChoiceLiv)

        var url = this.domaine + "entrepot/valide/livraison/appro";
        this.$http.post(url, data).then(function (response) {
          if (response.body.code == 1) {
            _this48.$notify({
              title: "VALIDATION REUSSIE",
              message: "La validation a été ennregistrée.",
              type: "success",
              position: "top-center"
            });

            _this48.nomLivreur = "";
          }

          _this48.loadAppro(_this48.entrepotCourant);
        });

        this.dialogValidAppro = false;
        //this.dialogShow = false
      }
    },
    acceptCarburanApproValid: function acceptCarburanApproValid() {
      var _this49 = this;

      if (this.$refs.formValidApproLivr.validate()) {
        var form = document.getElementById("formValidApproLivr");
        var data = new FormData(form);
        data.append("idUser", this.user.id);
        data.append("idEntrepot", this.entrepotCourant.id);
        data.append("qteDepart", this.qteLivDepart);
        data.append("idProduit", this.idProduitLiv);
        data.append("idAppro", this.idApproLiv);
        data.append("idReponse", this.choixValidLiv);
        data.append("nomLivreur", this.nomLivreur);
        // data.append('nbChoice', this.nbChoiceLiv)

        var url = this.domaine + "entrepot/valide/livraison/appro";
        this.$http.post(url, data).then(function (response) {
          if (response.body.code == 1) {
            _this49.$notify({
              title: "VALIDATION REUSSIE",
              message: "La validation a été ennregistrée.",
              type: "success",
              position: "top-center"
            });

            _this49.nomLivreur = "";
          }

          _this49.loadAppro(_this49.entrepotCourant);
        });

        this.dialogValidCarburan = false;
      }
    },
    changeValidLiv: function changeValidLiv() {
      if (this.choixValidLiv == 2) {
        this.nbChoiceLiv = 0;
      }
    },
    loadChangChoix: function loadChangChoix() {
      if (this.nbChoiceLiv > this.qteLivDepart || this.nbChoiceLiv == this.qteLivDepart || this.nbChoiceLiv < 0) {
        this.nbChoiceLiv = 0;
      }
    },
    resetValideLivAppro: function resetValideLivAppro() {
      this.qteLivDepart = "";
      this.produitLiv = "";
      this.idProduitLiv = "";
      this.nbChoiceLiv = "";
      this.remarqueLivr = "";
      this.choixValidLiv = "";
      this.idApproLiv = "";
      this.dialogValidAppro = false;
      this.dialogValidCarburan = false;
    }
  },
  mounted: function mounted() {
    this.loadProduit();
    this.loadUser();
    this.loadEntrepot();
    this.chartsSortie();
    this.chartsAppro();
    this.loadProjet();
    this.loadDemande();
    this.loadTypeRessource();
  },

  beforeMount: function beforeMount() {
    if (!this.roleAcces[this.$router.history.current.name]) {
      this.$router.push({ name: "Home" });
    }
  }
});

/***/ }),

/***/ "gMf6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liste_contrat_vue__ = __webpack_require__("0+kO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3618d4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liste_contrat_vue__ = __webpack_require__("A1l2");
function injectStyle (ssrContext) {
  __webpack_require__("n84h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b3618d4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liste_contrat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3618d4c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liste_contrat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gPj6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutResponsable),callback:function ($$v) {_vm.dialogAjoutResponsable=$$v},expression:"dialogAjoutResponsable"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter un representant de zone")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modifier un representant de zone  ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutResponsable = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enregistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-form',{ref:"formUser",attrs:{"lazy-validation":"","id":"formUser"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('div',[_c('v-flex',{attrs:{"text-xs-center":"","layout":"","align-center":"","justify-center":""}},[(_vm.dialogEdit != true)?_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"list-type":"picture-card","name":"photo","action":"","auto-upload":false}},[_c('i',{staticClass:"el-icon-plus"})]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"list-type":"picture-card","name":"photo","action":"","auto-upload":false}},[(_vm.responsable.urlImg)?_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":_vm.responsable.urlImg,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":_vm.logoUser,"alt":""}})]):_vm._e()],1)],1)])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-col',[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Nom et prénoms","name":"nomUser","rules":_vm.nomUserRules,"counter":4,"required":""},model:{value:(_vm.responsable.nom),callback:function ($$v) {_vm.$set(_vm.responsable, "nom", $$v)},expression:"responsable.nom"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Login de connexion","name":"loginUser","rules":[function (v) { return !!v || 'Le login est obligatoire'; }],"required":""},model:{value:(_vm.responsable.login),callback:function ($$v) {_vm.$set(_vm.responsable, "login", $$v)},expression:"responsable.login"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"E-mail","name":"emailUser","rules":_vm.loginUserRules,"counter":6,"required":""},model:{value:(_vm.responsable.email),callback:function ($$v) {_vm.$set(_vm.responsable, "email", $$v)},expression:"responsable.email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"name":"contactUser","min":"0","label":"Contact","counter":8,"rules":_vm.contactUserRules,"hint":"Exemple: 00-00-00-00","persistent-hint":"","required":""},model:{value:(_vm.responsable.contact),callback:function ($$v) {_vm.$set(_vm.responsable, "contact", $$v)},expression:"responsable.contact"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Fonction occupée","name":"fonctionUser","counter":6,"required":""},model:{value:(_vm.responsable.fonction),callback:function ($$v) {_vm.$set(_vm.responsable, "fonction", $$v)},expression:"responsable.fonction"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"label":"Services","name":"serviceUser","items":_vm.listService,"rules":_vm.serviceUserRules,"item-value":"id","item-text":"libelle"},model:{value:(_vm.responsable.serviceId),callback:function ($$v) {_vm.$set(_vm.responsable, "serviceId", $$v)},expression:"responsable.serviceId"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"disabled":_vm.dialogEdit,"label":"Type d'utilisateur","name":"serviceUser","items":_vm.typeUser,"rules":[function (v) { return !!v || 'Veuillez sélectionner le type.'; }],"item-value":"value","item-text":"text"},model:{value:(_vm.responsable.type),callback:function ($$v) {_vm.$set(_vm.responsable, "type", $$v)},expression:"responsable.type"}})],1)],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                            PARAMETRE DE CONNEXION\n                                                        ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[(_vm.dialogEdit != true)?_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpUser","label":"Mot de passe","rules":_vm.mdpUserRules,"counter":4,"required":""},model:{value:(_vm.responsable.password),callback:function ($$v) {_vm.$set(_vm.responsable, "password", $$v)},expression:"responsable.password"}})],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit != true)?_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpVerUser","label":"Confirmer le mot de passe","rules":_vm.mdpVerUserRules,"counter":4,"required":""},model:{value:(_vm.responsable.confirmePassword),callback:function ($$v) {_vm.$set(_vm.responsable, "confirmePassword", $$v)},expression:"responsable.confirmePassword"}})],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpUserConnect","label":"Votre mot de passe","rules":_vm.mdpUserConnectRules,"counter":4,"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1):_vm._e()],1)],1)],1)])],1)],1),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":_vm.clear}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid},on:{"click":_vm.submitUser}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer cet enregistrement ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteUser($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogRole),callback:function ($$v) {_vm.dialogRole=$$v},expression:"dialogRole"}},[_c('v-card',[_c('v-toolbar',{staticClass:"orange",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter des droits d'accès")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogRole = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n            ATTRIBUER DES ROLES A L'UTILISATEUR\n          ")])],1),_vm._v(" "),_c('v-form',{ref:"formRole",attrs:{"lazy-validation":"","id":"formRole"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Accès au dasbord")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","multiple":"","placeholder":"Catégorie"},model:{value:(_vm.menuSele),callback:function ($$v) {_vm.menuSele=$$v},expression:"menuSele"}},_vm._l((_vm.menu),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Attribuer des roles")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","multiple":"","placeholder":"Catégorie"},model:{value:(_vm.role),callback:function ($$v) {_vm.role=$$v},expression:"role"}},_vm._l((_vm.roles),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.description,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogRole = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.menuSele.length !== 0)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":_vm.submitRole}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAttribuerEquipe),callback:function ($$v) {_vm.dialogAttribuerEquipe=$$v},expression:"dialogAttribuerEquipe"}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"1 1 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Attribuer une equipe")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAttribuerEquipe = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-form',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"flex":"1 1 auto"},attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Nom","placeholder":"Nom de l'équipe","solo":""}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"grid-content bg-purple-light",staticStyle:{"width":"500px"}},[_c('el-card',{staticClass:"box-card",staticStyle:{"margin":"10px"}},[_c('div',{staticClass:"clearfix",staticStyle:{"display":"table","content":"' '","clear":"both","flex":"1 1 auto"},attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Card name")])]),_vm._v(" "),_vm._l((5),function(o){return _c('div',{key:o,staticClass:"text item",staticStyle:{"margin-bottom":"18px","font-size":"14px","flex":"1 1 auto"}},[_vm._v("\n                                "+_vm._s('La liste des elements ' + o)+"\n                            ")])})],2)],1)])],1),_vm._v(" "),_c('hr',{staticStyle:{"height":"10px","color":"#c0eff8","border-radius":"50px","flex":"1 1 auto"}}),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":_vm.clear},slot:"activator"},[_vm._v("Annuler"),_c('v-icon',{attrs:{"rigth":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"blue","dark":""},on:{"click":function($event){$event.stopPropagation();}},slot:"activator"},[_vm._v("Ajouter"),_c('v-icon',{attrs:{"rigth":""}},[_vm._v("add")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1),_vm._v(" "),_c('ModalAttribuerZone',{attrs:{"userResponsable":_vm.responsable,"show":_vm.showModalZone},on:{"close":function($event){_vm.showModalZone = false}}}),_vm._v(" "),_c('ModalAttribuerEquipe',{attrs:{"userResponsable":_vm.responsable,"show":_vm.showModalEquipe},on:{"close":function($event){_vm.showModalEquipe = false}}}),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                        LISTE DES REPRESENTANTS DE ZONE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("accessibility")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeRespoZone('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeRespoZone('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnZone,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                              ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Rechercher","single-line":"","hide-details":""},model:{value:(_vm.recherche),callback:function ($$v) {_vm.recherche=$$v},expression:"recherche"}}),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"blue","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.showModalNewUser();}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n                            Ajouter un nouveau representant\n                        ")],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"search":_vm.recherche,"items":_vm.listeResponsable},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                              "+_vm._s(props.header.text)+"\n                            ")]),_vm._v(" "),_c('span',[_vm._v("\n                              "+_vm._s(props.header.text)+"\n                            ")])])]}},{key:"items",fn:function(props){return [_c('td',[_c('v-avatar',[(props.item.url)?_c('img',{staticClass:"lazy",attrs:{"src":props.item.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"src":_vm.logoUser,"alt":""}})])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(props.item.nom)+"\n                            ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(props.item.email)+"\n                            ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.contact))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"green","dark":""},nativeOn:{"click":function($event){return _vm.modalZone(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("home")])],1),_vm._v("\n                                            Attribuer une zone\n                                        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.admin_profil_update_user)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){$event.stopPropagation();return _vm.showModalEditUser(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                                Modifier\n                              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.role_user)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.newRole(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("vpn_key")])],1):_vm._e(),_vm._v("\n                                Droit d'accès\n                              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.user_delete)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSupr = true; _vm.idUser = props.item.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                                Supprimer\n                              ")],1)],1)])]}}])})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gTnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('div',{staticStyle:{"width":"100%"}},[_c('v-card',{staticClass:"pl-3 pr-3 pt-3  pb-3",attrs:{"tile":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"green darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.dataNbFact.paye))]),_vm._v(" "),_c('div',[_vm._v("Facture(s) soldée(s)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("Montant déjà versé")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataMntFact.paye)))])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"orange darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.dataNbFact.cours))]),_vm._v(" "),_c('div',[_vm._v("Facture(s) en cours")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataMntFact.coursPaye)))]),_vm._v(" "),_c('div',[_vm._v("Montant déjà versé")])])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("Montant restant")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataMntFact.cours)))])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"blue-grey darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.dataNbFact.attente))]),_vm._v(" "),_c('div',[_vm._v("Facture(s) en attente")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("Montant restant")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataMntFact.attente)))])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"red darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.dataNbFact.impaye))]),_vm._v(" "),_c('div',[_vm._v("Facture(s) impayée(s)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("Montant restant")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataMntFact.impaye)))])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-2":"","mb-3":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"sm12":""}},[_c('v-card',{staticClass:"elevation-5",staticStyle:{"height":"550px"}},[_c('h4',[_vm._v("Statistiques de l'etat des factures de l'année en cours ")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-1"}),_vm._v(" "),_c('div',{staticClass:"mb-2",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"chartFactureAn"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"sm6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-layout',{staticClass:"elevation-3 pt-2 pl-2 pr-2 pb-2 grey lighten-4",attrs:{"row":""}},[_c('v-flex',{attrs:{"sm8":""}},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"chartCommande"}})]),_vm._v(" "),_c('v-flex',{attrs:{"sm4":""}},[_c('v-layout',{staticClass:"pt-2 pl-2 pr-2 pb-2",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"teal lighten-1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_vm._v("Commande(s) livrée(s)")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.nbLivraison))])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm12":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"deep-orange lighten-1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_vm._v("Commande(s) effectuée(s)")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.nbCommande))])])],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-1",attrs:{"sm6":""}},[_c('div',{staticClass:"elevation-3 pt-2 pl-2 pr-2 pb-2 grey lighten-4",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"chartFacture"}})])],1)],1)],1)])],1),_vm._v(" "),_c('v-layout',{staticClass:"elevation-6 pt-1 mb-3",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"sm12":""}},[_c('h3',[_vm._v("Critères de recherche ")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"model":_vm.formTri}},[_c('el-form-item',{attrs:{"label":"Période"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"datetimerange","range-separator":"à","start-placeholder":"Début date","end-placeholder":"Fin date"},model:{value:(_vm.formTri.periode),callback:function ($$v) {_vm.$set(_vm.formTri, "periode", $$v)},expression:"formTri.periode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"fournisseur"},model:{value:(_vm.formTri.fournisseur),callback:function ($$v) {_vm.$set(_vm.formTri, "fournisseur", $$v)},expression:"formTri.fournisseur"}},_vm._l((_vm.listeFournisseur),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('el-select',{attrs:{"clearable":"","placeholder":"Etat facture"},model:{value:(_vm.formTri.etat),callback:function ($$v) {_vm.$set(_vm.formTri, "etat", $$v)},expression:"formTri.etat"}},_vm._l((_vm.listeEtat),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"montant (<=)"}},[_c('el-input-number',{attrs:{"min":1},model:{value:(_vm.formTri.montant),callback:function ($$v) {_vm.$set(_vm.formTri, "montant", $$v)},expression:"formTri.montant"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","color":"blue","fab":"","small":"","disabled":_vm.desactiveBout},on:{"click":function($event){return _vm.rechercheFacture()}},slot:"activator"},[_c('v-icon',[_vm._v("search")])],1),_vm._v("Effectuer une recherche\n                    ")],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"elevation-2 pt-3 pl-3 pr-3",attrs:{"xs12":""}},[_c('h4',{staticClass:"mt-2"},[_vm._v("LISTES DE(S) "+_vm._s(_vm.libeleRechFacture))]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2 mt-1"}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","disabled":false,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeFacturePDF()}},slot:"activator"},[_vm._v("\n                    Imprimer\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1):_vm._e(),_vm._v("Imprimer la liste des factures\n                ")],1)],1),_vm._v(" "),_c('el-table',{ref:"multipleTableFact",staticStyle:{"width":"100%"},attrs:{"highlight-current-row":"","show-summary":"","summary-method":_vm.getSommeFact,"header-row-style":_vm.headerRowStyle,"data":_vm.liteFacture},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"width":"55","type":"selection"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fournisseur","label":"Fournisseur","align":"left","width":"130","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libFact","label":"Libelle","align":"left","width":"150","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"blue--text body-2"},[_vm._v(_vm._s(scope.row.libFact))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"datePaiement","label":"Date de paiement","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"modalite","label":"Conditions de paiement","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 'En attente')?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.etat))]):(scope.row.etat == 'Payé')?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.etat))]):(scope.row.etat == 'Impayé')?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.etat))]):(scope.row.etat == 'En cours')?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.etat))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"isPaiement","label":"Paiement","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.isPaiement == true)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v("Autorisé")]):_c('el-tag',{attrs:{"type":"info"}},[_vm._v("Non-autorisé")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotal","label":"Montant total","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(new Intl.NumberFormat().format(scope.row.mntTotal))+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntPaye","label":"Montant paye","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(new Intl.NumberFormat().format(scope.row.mntPaye))+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntRestant","label":"Montant restant","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.mntRestant > 0)?_c('span',{staticStyle:{"color":"#E6A23C","font-size":"16px"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.mntRestant)))]):_c('span',[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.mntRestant)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.showDetailFacture(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                            Detail\n                        ")],1)]}}])})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"900"},model:{value:(_vm.dialogValideFacture),callback:function ($$v) {_vm.dialogValideFacture=$$v},expression:"dialogValideFacture"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_c('v-chip',{attrs:{"color":"primary","text-color":"white"}},[_vm._v(_vm._s(_vm.multipleSelection.length))]),_vm._v("\n\n                    facture(s) selectionnée(s)\n                ")],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticClass:"mb-5"},[_c('el-alert',{attrs:{"title":'Voulez-vous comfirmer le paiement à la caisse des  factures selectionnées ',"description":"Cette liste contient uniquement les factures dans le montant restant est supérieur à 0","type":"warning","center":"","closable":false,"show-icon":""}}),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%","margin-top":"30px"},attrs:{"border":"","highlight-current-row":"","show-summary":"","summary-method":_vm.getSommeFact,"header-row-style":_vm.headerRowStyle,"data":_vm.listeFactureSelect}},[_c('el-table-column',{attrs:{"align":"center","prop":"fournisseur","label":"Fournisseur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"libFact","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"mntRestant","label":"Montant restant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                "+_vm._s(new Intl.NumberFormat().format(scope.row.mntRestant))+"\n                            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"montantVerse","label":"Montant à regler"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":1,"max":prop.row.mntRestant,"name":"montantVerse","placeholder":"Montant à verser"},model:{value:(prop.row.montantVerse),callback:function ($$v) {_vm.$set(prop.row, "montantVerse", $$v)},expression:"prop.row.montantVerse"}})]}}])})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialogValideFacture = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":function($event){_vm.validPaiem = true}}},[_vm._v("Confirmer")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowFacture),callback:function ($$v) {_vm.dialogShowFacture=$$v},expression:"dialogShowFacture"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Détails de la facture ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowFacture = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"Veuillez patientez ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":14}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.ref)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libellé : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.libelle)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Référence commande : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.refCom)+" ")]),_vm._v(" "),(_vm.detailFacture.typeFact === true)?_c('p',[_c('b',[_vm._v("Commande concerné : ")]),_vm._v(" COM-"+_vm._s(_vm.detailFacture.id)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.typeFact === false)?_c('p',[_c('b',[_vm._v("Maintenance concerné : ")]),_vm._v(" MAIN-"+_vm._s(_vm.detailFacture.id)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.typeFact === true)?_c('p',[_c('b',[_vm._v("Date de la commande : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.dateC)+" ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Total ttc de la facture : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.total)+" FCFA")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),(_vm.detailFacture.etat == 'Impayé')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                        "+_vm._s(_vm.detailFacture.etat)+"\n                                                    ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.etat === 'Payé')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                        "+_vm._s(_vm.detailFacture.etat)+"\n                                                    ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.etat === 'En cours')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                        "+_vm._s(_vm.detailFacture.etat)+"\n                                                    ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.etat === 'En attente')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                        "+_vm._s(_vm.detailFacture.etat)+"\n                                                    ")]):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Enregistré par : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.userCreated)+" ")]),_vm._v(" "),(!_vm.detailFacture.refLivraison)?_c('p',[_c('b',[_vm._v("Etat de livraison : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                    PAS ENCORE LIVRE\n                                                  ")])],1):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Caisse concerné : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.libelleCaisse)+" ")]),_vm._v(" "),(_vm.detailFacture.modalite !== null)?_c('p',[_c('b',[_vm._v("Modalité de règlement : ")]),_vm._v("\n                                                    "+_vm._s(_vm.detailFacture.modalite)+"\n                                                ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.avance !== null)?_c('p',[_c('b',[_vm._v("Avance demarage : ")]),_vm._v("\n                                                    "+_vm._s(_vm.detailFacture.avance)+"\n                                                ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.datePaie !== null)?_c('p',[_c('b',[_vm._v("Date de paiement : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.datePaie)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.remarqueFact !== null)?_c('p',[_c('b',[_vm._v("Remarque : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.remarqueFact)+" ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.modified)+" ")])])],1)],1)])],1)]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.detailFacture.refLivraison)?_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant livraison : ")]),_vm._v("  "+_vm._s(_vm.detailFacture.refLivraison)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de la livraison : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.dateCreationLivraison)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Livreur : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.livreurLivraison)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Etat livraison: ")]),_vm._v(" "),(_vm.detailFacture.etatLivraison === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                        PARTIELLEMENT LIVRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailFacture.etatLivraison === true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                        TOTALEMENT LIVRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()],1),_vm._v(" "),(_vm.detailFacture.etatLivraison === false)?_c('p',[_c('b',[_vm._v("Quantité livré : ")]),_vm._v(" "+_vm._s(_vm.qteLivre)+" / "+_vm._s(_vm.qteRestant))]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.created))])])],1)],1)])],1)]):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"wrap":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"23px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                    MONTANT REMISE : "+_vm._s(_vm.totalComRemise)+" FCFA\n                                                ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"23px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                    MONTANT HT : "+_vm._s(_vm.totalComHT)+" FCFA\n                                                ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"23px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                    MONTANT TVA : "+_vm._s(_vm.totalComTVA)+" FCFA\n                                                ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"23px"},attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                                    MONTANT TTC : "+_vm._s(new Intl.NumberFormat().format(_vm.totalTTC))+" FCFA\n                                                ")])],1)],1)],1)]),_vm._v(" "),_c('el-row',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"ml-3  elevation-5 ",attrs:{"xs3":""}},[_c('a',{attrs:{"href":_vm.detailFacture.imagefact,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.detailFacture.imagefact}})])],1)])],1)],1)],1)])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":7}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailFacture.option,"height":"250"}},[_c('el-table-column',{attrs:{"prop":"produit","label":"Description","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix unitaire (FCFA)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remise","label":"Remise(%)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"TVA(%) ","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Total TTC (FCFA)"}})],1)]],2)],1)])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-btn',{staticStyle:{"margin-right":"10px","margin-bottom":"60px"},attrs:{"slot":"activator","absolute":"","dark":"","fixed":"","fab":"","large":"","disabled":_vm.multipleSelection.length == 0,"bottom":"","right":"","color":"green"},on:{"click":function($event){return _vm.modalValideFacture()}},slot:"activator"},[_c('v-icon',[_vm._v("done_all")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.validPaiem),callback:function ($$v) {_vm.validPaiem=$$v},expression:"validPaiem"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h1',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment effectuer ce paiement ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.validPaiem = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){return _vm.validFacture()}}},[_vm._v("Confirmer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("check")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "giEb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","persistent":"","fullscreen":"","hide-overlay":""},model:{value:(_vm.dialogTransfertCarte),callback:function ($$v) {_vm.dialogTransfertCarte=$$v},expression:"dialogTransfertCarte"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("\n            Liste des rechargements de la carte "+_vm._s(_vm.carte.identifiant)+"\n          ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h6',[_vm._v("LISTE DES RECHARGEMENTS")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v(" Total credité: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntCredit)+" Fcfa ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total debité: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntDebit)+" Fcfa ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Solde de la carte: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" 30 000 Fcfa ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbTransfert))]),_vm._v("\n                      transfert(s)\n                    ")],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right mb-3"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.modalAjoutTransfert()}},slot:"activator"},[_vm._v("Recharger"),_c('v-icon',{attrs:{"right":""}},[_vm._v("playlist_add")])],1),_vm._v("\n                  Recharger une carte\n                ")],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-left  mb-1 "},[_c('el-select',{attrs:{"clearable":"","placeholder":"Type de rechargement"},on:{"clear":function($event){return _vm.clearSelect()},"change":_vm.filtrerTypeRecharge},model:{value:(_vm.selectTypeRecharge),callback:function ($$v) {_vm.selectTypeRecharge=$$v},expression:"selectTypeRecharge"}},_vm._l((_vm.transferts),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1),_vm._v(" "),_c('el-select',{attrs:{"clearable":"","placeholder":"Type"},on:{"clear":function($event){return _vm.clearSelect()},"change":_vm.filtrerType},model:{value:(_vm.selectType),callback:function ($$v) {_vm.selectType=$$v},expression:"selectType"}},_vm._l((_vm.transferts),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('data-tables',{attrs:{"data":_vm.transferts}},[_c('el-table-column',{attrs:{"prop":"dateRechargeFormat","label":"date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"typeTransfert","label":"Type transfert"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":scope.row.typeTransfert == 'débit'
                          ? 'danger'
                          : 'success'}},[_vm._v("\n                      "+_vm._s(scope.row.typeTransfert))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"carteSource","label":"Carte de recharge"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.carteSource)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v("\n                      "+_vm._s(scope.row.carteSource))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"carteCible","label":"Carte rechargée"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"success"}},[_vm._v("\n                      "+_vm._s(scope.row.carteCible))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantFormat","label":"Montant (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(" "+_vm._s(scope.row.montantFormat))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.modalEditTransfert(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                      Editer\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();return _vm.showDialogSupp(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                      Supprimer\n                    ")],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("\n                    RECHARGEMENTS\n                  ")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("\n                    ID-"+_vm._s(_vm.idTransfert)+"\n                  ")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.deleteRecharge()}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('AjoutTransfertCarte',{attrs:{"editRecharge":_vm.editTransfert,"carte":_vm.carte,"show":_vm.showModalAjoutTransfert},on:{"close":function($event){_vm.showModalAjoutTransfert = false;
      _vm.loadTransfert();}}}),_vm._v("\n  -->\n  ")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gpTY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogSelectTechnicien),callback:function ($$v) {_vm.dialogSelectTechnicien=$$v},expression:"dialogSelectTechnicien"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Selectionner un technicien")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                    Veuillez selectionner un technicien pour une intervention de la demande DMD-"+_vm._s(_vm.demandeDetail.idDemande)+"\n                            ")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeTechniciens}},[_c('el-table-column',{attrs:{"prop":"nom","label":"Nom et prenoms","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"contact","label":"Contact"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"specialite","label":"Specialite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini","type":"primary","disabled":scope.row.status == 1},on:{"click":function($event){return _vm.submitTech(scope.row)}}},[_vm._v("Selectionner")])]}}])})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gpm2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationInterv_vue__ = __webpack_require__("n96b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_314bbe50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationInterv_vue__ = __webpack_require__("ISzt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationInterv_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_314bbe50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationInterv_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h4D2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v(_vm._s(item.text))])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogProjet),callback:function ($$v) {_vm.dialogProjet=$$v},expression:"dialogProjet"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Listes des participants")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogProjet = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},_vm._l((_vm.detailProjet.participant),function(item,index){return _c('span',{key:index},[_c('v-chip',{attrs:{"outline":"","text-color":"blue","label":""}},[_vm._v("  "+_vm._s(item)+"\n            ")]),_vm._v("\n              /\n              ")],1)}),0)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogCommis),callback:function ($$v) {_vm.dialogCommis=$$v},expression:"dialogCommis"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Listes des commis")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogCommis = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},_vm._l((_vm.detailCommis.commis),function(item,index){return _c('span',{key:index},[_c('v-chip',{attrs:{"outline":"","text-color":"blue","label":""}},[_vm._v("  "+_vm._s(item)+"\n            ")]),_vm._v("\n              /\n              ")],1)}),0)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogCondicteur),callback:function ($$v) {_vm.dialogCondicteur=$$v},expression:"dialogCondicteur"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Listes des conducteurs des Travaux")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogCondicteur = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_vm._v("\n            "+_vm._s(_vm.detailProjet.conducteurTravaux)+"\n          ")])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),(_vm.droitAcces.show_projet)?_c('v-dialog',{attrs:{"persistent":"","fullscreen":"","overlay":false,"scrollable":""},model:{value:(_vm.dialogShowProjet),callback:function ($$v) {_vm.dialogShowProjet=$$v},expression:"dialogShowProjet"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détail du projet: "+_vm._s(_vm.detailProjet.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialogProjet()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-expansion-panel',[_c('v-expansion-panel-content',{staticClass:"blue lighten-4 elevation-18"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                  Cliquez pour afficher tous les projets sur la carte\n                  "),_c('v-icon',[_vm._v("map")])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('div',{staticClass:"google-map",staticStyle:{"height":"500px","width":"100%"},attrs:{"id":_vm.mapName}}),_vm._v(" "),_c('div',{attrs:{"id":"legend2"}})])],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick(_vm.tab)}},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" Dashboard du projet\n                  ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-expansion-panel',{attrs:{"focusable":"","popout":"","value":"0"}},[_c('v-expansion-panel-content',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',[_vm._v("Informations sur le projet")])]},proxy:true}],null,false,1969263770)},[_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-5"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Référence :")]),_vm._v("\n                                    "+_vm._s(_vm.detailProjet.ref)+"\n                                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Prix du marché:")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":""}},[_vm._v(" "+_vm._s(_vm.detailProjet.mntMarche)+"\n                                      ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Budget validé:")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.detailProjet.mntBudgetValide)))])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Ecart théorique:")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"red","label":""}},[_vm._v(" "+_vm._s(new Intl.NumberFormat().format( _vm.detailProjet.EcartTheorique))+"\n                                      ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libellé :")]),_vm._v("\n                                    "+_vm._s(_vm.detailProjet.libelle)+"\n                                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de début :")]),_vm._v("\n                                    "+_vm._s(_vm.detailProjet.dateDFormat)+"\n                                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de fin :")]),_vm._v("\n                                    "+_vm._s(_vm.detailProjet.dateFFormat)+"\n                                  ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Situation géographique :")]),_vm._v("\n                                    "+_vm._s(_vm.detailProjet.adresse)+"\n                                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Chef de projet :")]),_vm._v("\n                                    "+_vm._s(_vm.detailProjet.chef)+"\n                                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Maitre d'ouvrage :")]),_vm._v("\n                                    "+_vm._s(_vm.detailProjet.maitreOuvrage)+"\n                                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Architect :")]),_vm._v("\n                                    "+_vm._s(_vm.detailProjet.architect)+"\n                                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Responsable d'étude :")]),_vm._v("\n                                    "+_vm._s(_vm.detailProjet.chefEtude)+"\n                                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Responsable du contrôle :")]),_vm._v("\n                                    "+_vm._s(_vm.detailProjet.chefControle)+"\n                                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Conducteur des travaux :")]),_vm._v("\n                                    "+_vm._s(_vm.detailProjet.conducteurTravaux)+"\n                                    ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Compte caisse affilié :")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":""}},[_vm._v("  "+_vm._s(_vm.detailProjet.caisse)+"\n                                      ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Compte banque(s) affilié(s) :")]),_vm._v(" "),_vm._l((_vm.detailProjet.banque),function(item,index){return _c('span',{key:index},[_c('v-chip',{attrs:{"outline":"","text-color":"green","label":""}},[_vm._v("  "+_vm._s(item)+"\n                                      ")]),_vm._v("\n                                        /\n                                        ")],1)})],2),_vm._v(" "),_c('p',[_c('b',[_vm._v("Nombre d'heure :")]),_vm._v("\n                                    "+_vm._s(_vm.detailProjet.nbrHeure)+" H\n                                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v("\n                                    "+_vm._s(_vm.detailProjet.created)+"\n                                  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v("\n                                    "+_vm._s(_vm.detailProjet.modified)+"\n                                  ")]),_vm._v(" "),(_vm.detailProjet.budget)?_c('p',[_c('b',[_vm._v("Budget:")]),_vm._v(" "),(_vm.detailProjet.budget.etat == true)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("Validé")]):_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("En attente")])],1):_vm._e(),_vm._v(" "),(_vm.detailProjet.participant)?_c('p',[_c('b',[_vm._v("Participants:")]),_vm._v(" "),_c('span',[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.showParticipants()}},slot:"activator"},[_vm._v("\n                                          Afficher\n                                          ")]),_vm._v("Afficher la liste des participants\n                                      ")],1)],1)]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('p')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('a',{attrs:{"href":_vm.detailProjet.urlImage ? _vm.detailProjet.urlImage :_vm.imageProjet,"target":"_blank"}},[_c('v-avatar',{staticClass:"mr-2",attrs:{"tile":true,"size":"250px","height":"250px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.detailProjet.urlImage ? _vm.detailProjet.urlImage :_vm.imageProjet,"alt":"avatar"}})])],1)])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('DashboardOngletPrj',{attrs:{"detailProjet":_vm.detailProjet,"show":_vm.showDetailProjet},on:{"close":function($event){_vm.showDetailProjet = false}}})],1)],1)],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-menu"}),_vm._v(" Préparation du chantier\n                    "),(_vm.nbChantier == 0)?_c('span',{staticStyle:{"color":"red","font-weight":"bold","font-size":"27px"}},[_vm._v("!")]):_vm._e()]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("LISTE DES CHANTIERS")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-layout',{attrs:{"row":""}},[(
                          _vm.droitAcces.imprime_pdf_histo_chantier_liste_projet ||
                            _vm.droitAcces.imprime_exc_histo_liste_chantier_projet
                        )?_c('v-flex',[_c('el-popover',{ref:"popChantier",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[(
                                _vm.droitAcces.imprime_pdf_histo_chantier_liste_projet
                              )?_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisChantierProjet('PDF')}}},[_vm._v("PDF")]):_vm._e(),_vm._v(" "),(
                                _vm.droitAcces.imprime_exc_histo_liste_chantier_projet
                              )?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisChantierProjet('EXC')}}},[_vm._v("EXCEL")]):_vm._e()],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popChantier",arg:"popChantier"}],attrs:{"type":"warning","disabled":_vm.disabledBtnPop,"icon":"el-icon-printer"}},[_vm._v("Rapport")])],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.newChantier(_vm.detailProjet);_vm.loadTypeProjet()
                              _vm.imageProjet = '/static/avatar_proj.png';}},slot:"activator"},[_vm._v("\n                            Chantier\n                            "),_c('v-icon',{attrs:{"left":""}},[_vm._v("add")])],1),_vm._v("Chantier\n                        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"warning","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.newCharge(_vm.detailProjet);_vm.loadTypeProjet();_vm.loadUser()}},slot:"activator"},[_vm._v("\n                            Charges \n                            "),_c('v-icon',{attrs:{"left":""}},[_vm._v("add")])],1),_vm._v("Chantier\n                        ")],1)],1)],1)],1),_vm._v(" "),_c('div',[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listChantier,"height":"450"},on:{"selection-change":_vm.selectionChangeDuplique}},[_c('el-table-column',{attrs:{"width":"55","type":"selection"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","width":"400","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("CHANT-"+_vm._s(scope.row.id)+" /\n                            "+_vm._s(scope.row.libelle))]),_vm._v(" "),(scope.row.soutraite == 1)?_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("CHANTIER SOUS-TRAITE")]):_vm._e()]}}],null,false,4124201571)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chef","label":"Chef chantier","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":""}},[_vm._v(_vm._s(scope.row.chefChantier))])]}}],null,false,1068468370)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"commis","label":"Commis chantier","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((scope.row.commis),function(item,index){return _c('span',{key:index},[_c('v-chip',{attrs:{"outline":"","text-color":"green","label":""}},[_vm._v(" "+_vm._s(item))]),_vm._v("/\n                            ")],1)})}}],null,false,625336480)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"Durée prévue"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v(_vm._s(scope.row.dureeJ)+" jour(s)")])]}}],null,false,1737867645)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantNbr","label":"Coût du marché","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(scope.row.montantNbr)+"\n                          ")])]}}],null,false,1181945409)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Dépenses","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v(_vm._s(scope.row.total)+"\n                          ")])]}}],null,false,352986102)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Travaux planifiés","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v(_vm._s(scope.row.nbTravauxPlanif)+" /\n                            "+_vm._s(scope.row.nbTravauxTot))])]}}],null,false,845992974)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Eta globale","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-progress-circular',{attrs:{"size":90,"width":15,"rotate":360,"value":scope.row.evolution,"color":"primary"}},[_vm._v(_vm._s(scope.row.evolutionNbr)+" %")])]}}],null,false,464770932)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","width":"350","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.evolution !== 100)?_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Modifier","icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){_vm.editChantier(scope.row);_vm.loadUser()}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(
                              scope.row.evolution !== 100 ||
                                _vm.droitAcces.new_travaux
                            )?_c('v-btn',{staticClass:"tooltip-btn",attrs:{"slot":"activator","title":"Planification des lots de travaux","icons":"","color":"deep-orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.newTravaux(scope.row)}},slot:"activator"},[_c('v-badge',{attrs:{"color":"red","right":""}},[(scope.row.nbTravaux == 0)?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v("!")]):_vm._e(),_vm._v(" "),_c('v-icon',[_vm._v("terrain")])],1)],1):_vm._e(),_vm._v(" "),(scope.row.evolution === 0)?_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Supprimer","icons":"","color":"red","fab":"","dark":"","small":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprChantier = true;
                              _vm.idChantier = scope.row.id;}}},[_c('v-icon',[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.imprime_chantier)?_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Imprimer","icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerChantier(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.new_travaux)?_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Duppliquer le chantier","icons":"","color":"purple","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.duplicateChantier(scope.row)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("content_copy")])],1):_vm._e()]}}],null,false,2170056083)})],1)],1)],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-date"}),_vm._v(" Planification des travaux\n                  ")]),_vm._v(" "),_c('div',[_c('v-chip',{staticStyle:{"width":"100%","font-weight":"bold","font-size":"25px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("VEUILLEZ EFFECTUER VOTRE RECHERCHE EN FONCTION DU\n                      CHANTIER ET DES TRAVAUX")]),_vm._v(" "),_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-form',{ref:"formSearchPlanif",attrs:{"lazy-validation":"","id":"formSearchPlanif"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Type de recherche"},model:{value:(_vm.selectTypeSearch),callback:function ($$v) {_vm.selectTypeSearch=$$v},expression:"selectTypeSearch"}},_vm._l((_vm.typeSearch),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1),_vm._v(" "),(_vm.selectTypeSearch == 1)?_c('v-flex',{attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Chantier"},model:{value:(_vm.selectSearchChantierFind),callback:function ($$v) {_vm.selectSearchChantierFind=$$v},expression:"selectSearchChantierFind"}},_vm._l((_vm.listChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.selectTypeSearch == 2)?_c('v-flex',{attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Chantier"},on:{"change":function($event){return _vm.loadTravaux()}},model:{value:(_vm.selectSearchChantier),callback:function ($$v) {_vm.selectSearchChantier=$$v},expression:"selectSearchChantier"}},_vm._l((_vm.listChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.selectTypeSearch == 2)?_c('v-flex',{attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Travaux"},model:{value:(_vm.selectSearchTravaux),callback:function ($$v) {_vm.selectSearchTravaux=$$v},expression:"selectSearchTravaux"}},_vm._l((_vm.listTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.selectTypeSearch == 1)?_c('v-flex',{attrs:{"md1":""}},[_c('v-btn',{attrs:{"icons":"","color":"blue","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.loadChantierSearch()}}},[_c('v-icon',[_vm._v("search")])],1)],1):_vm._e(),_vm._v(" "),(_vm.selectTypeSearch == 2)?_c('v-flex',{attrs:{"md1":""}},[_c('v-btn',{attrs:{"icons":"","color":"blue","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.loadTravauxSearch()}}},[_c('v-icon',[_vm._v("search")])],1)],1):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.listChantierResult.length != 0)?_c('el-tabs',_vm._l((_vm.listChantierResult),function(item){return _c('el-tab-pane',{key:item.key,attrs:{"label":item.libelle,"name":item.key}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Libellé du chantier :")]),_vm._v("\n                                  "+_vm._s(item.libelle)+"\n                                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Statut du chantier :")]),_vm._v("\n                                  "+_vm._s(_vm.detailProjet.libelle)+"\n                                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Sous-traité :")]),_vm._v("\n                                  "+_vm._s(item.soutraiteLibelle)+"\n                                ")]),_vm._v(" "),(item.fournisseur !='')?_c('p',[_c('b',[_vm._v("Sous-traitant :")]),_vm._v("\n                                  "+_vm._s(item.fournisseur)+"\n                                ")]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Date de début prévue :")]),_vm._v("\n                                  "+_vm._s(item.dateD)+"\n                                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de fin prévue :")]),_vm._v("\n                                  "+_vm._s(item.dateF)+"\n                                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Durée prévue :")]),_vm._v("\n                                  "+_vm._s(item.dureeJ)+" Jour(s)\n                                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Chef du chantier :")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"green","label":""}},[_vm._v(" "+_vm._s(item.chef))])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Commis chantier :")]),_vm._v(" "),_c('span',[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.showCommis(item)}},slot:"activator"},[_vm._v("\n                                          Afficher\n                                          ")]),_vm._v("Afficher la liste des commis\n                                      ")],1)],1)])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Coût estimatif des travaux :")]),_vm._v("\n                                  "+_vm._s(item.montantNbr)+"\n                                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Montant déjà depensé :")]),_vm._v("\n                                  "+_vm._s(item.total)+"\n                                ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("ETAT GLOBAL DU CHANTIER")])]),_vm._v(" "),_c('p',[_c('v-progress-circular',{attrs:{"size":110,"width":25,"rotate":360,"value":item.evolution,"color":"primary"}},[_vm._v(_vm._s(item.evolutionNbr)+"\n                                    %")])],1)])],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":""}},[(
                                _vm.droitAcces.imprime_pdf_histo_plan_travaux_liste_projet ||
                                  _vm.droitAcces.imprime_exc_histo_plan_travaux_liste_projet
                              )?_c('v-flex',[_c('el-popover',{attrs:{"placement":"top-start","title":"","width":"200","trigger":"hover","content":""}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[(
                                      _vm.droitAcces.imprime_pdf_histo_plan_travaux_liste_projet
                                    )?_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisPlanTravauxProjet('PDF')}}},[_vm._v("PDF")]):_vm._e(),_vm._v(" "),(
                                      _vm.droitAcces.imprime_exc_histo_plan_travaux_liste_projet
                                    )?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisPlanTravauxProjet('EXC')}}},[_vm._v("EXCEL")]):_vm._e()],1),_vm._v(" "),_c('el-button',{attrs:{"slot":"reference","type":"warning"},slot:"reference"},[_vm._v("Rapport")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-row',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":item.travaux}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"TRAVAUX A REALISER","align":"center","width":"380","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))]),_vm._v(" "),(scope.row.soutraite == 1)?_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("TACHES SOUS-TRAITE")]):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"DATE","align":"center"}},[_c('el-table-column',{attrs:{"prop":"dateD","label":"Début"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"Durée (Jours)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.duree)+" Jour(s)")])]}}],null,true)})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"QTE ESTIMATIF ","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(scope.row.qteEstim))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"MONTANT DU MARCHE ","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                      scope.row.montantEstim
                                    ))+"\n                                ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"BUDGET TRAVAUX","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                      scope.row.budgetTrx
                                    )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ECART BUDGET - MNT MARCHE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                      scope.row.budgetTrx -
                                        scope.row.montantEstim
                                    )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT GLOBAL","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-progress-circular',{attrs:{"size":80,"width":15,"rotate":360,"value":scope.row.evolution,"color":"orange"}},[_vm._v(_vm._s(scope.row.evolutionNbr)+"\n                                  %")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"ETAT D'EXECUTION","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(parseFloat(scope.row.evolution) == 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("EN ATTENTE")]):_vm._e(),_vm._v(" "),(
                                    parseFloat(scope.row.evolution) > 0 &&
                                    parseFloat(scope.row.evolution) != 100
                                  )?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("EN EXECUTION")]):_vm._e(),_vm._v(" "),(parseFloat(scope.row.evolution) == 100)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("TERMINE")]):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{staticClass:"tooltip-btn",attrs:{"icons":"","color":"green","title":"Voir la ressource technique","fab":"","dark":"","small":""},on:{"click":function($event){_vm.showTravaux(scope.row, item);
                                    _vm.loadEquipe(scope.row);}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),(scope.row.evolution === 0)?_c('v-btn',{staticClass:"tooltip-btn",attrs:{"icons":"","title":"Modifier","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editTravaux(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"tooltip-btn",attrs:{"icons":"","color":"teal","title":"Planification des travaux","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.newPlanifProduit(scope.row)}}},[_c('v-icon',[_vm._v("playlist_add")])],1),_vm._v(" "),_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Imprimer","icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerTravaux(scope.row, item)}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),(scope.row.evolution == '0.00')?_c('v-btn',{staticClass:"tooltip-btn",attrs:{"icons":"","color":"red","title":"Supprimer","fab":"","dark":"","small":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprTravaux = true;
                                    _vm.idTravaux = scope.row.id;}}},[_c('v-icon',[_vm._v("delete")])],1):_vm._e()]}}],null,true)})],1),_vm._v(" "),_c('br')],1)],1)}),1):_vm._e(),_vm._v(" "),(_vm.listTravauxResult.length != 0)?_c('el-row',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listTravauxResult}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"TRAVAUX A REALISER","align":"center","width":"430","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))]),_vm._v(" "),(scope.row.soutraite == 1)?_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("TRAVAUX SOUS-TRAITE")]):_vm._e()]}}],null,false,2423436390)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"DATE","align":"center"}},[_c('el-table-column',{attrs:{"prop":"dateD","label":"Début"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"Durée (Jours) "},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.duree)+" Jour(s)")])]}}],null,false,2608640762)})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"COÛT DES TRAVAUX","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.montant != 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(scope.row.montant)+"\n                            ")]):_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("NON DEFINIT")])]}}],null,false,890825857)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT GLOBAL","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-progress-circular',{attrs:{"size":80,"width":15,"rotate":360,"value":scope.row.evolution,"color":"orange"}},[_vm._v(_vm._s(scope.row.evolutionNbr)+"\n                              %")])]}}],null,false,3183642683)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"ETAT GLOBAL","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(parseFloat(scope.row.evolution) === 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("EN ATTENTE")]):_vm._e(),_vm._v(" "),(
                                parseFloat(scope.row.evolution) > 0 &&
                                parseFloat(scope.row.evolution) !== 100
                              )?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("EN EXECUTION")]):_vm._e(),_vm._v(" "),(parseFloat(scope.row.evolution)=== 100)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("TERMINE")]):_vm._e()]}}],null,false,564806968)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","width":"250","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Détails","icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){_vm.showTravaux(scope.row);
                                _vm.loadEquipe(scope.row);}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),(scope.row.evolution === 0)?_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Modifier","icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editTravaux(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(scope.row.evolution !== 100)?_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Bésoin","icons":"","color":"indigo","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.newCommande(scope.row)}}},[_c('v-icon',[_vm._v("shopping_cart")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Imprimer","icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerTravaux(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),(scope.row.evolution === 0
                              && _vm.droitAcces.projet_index_chefProjet && _vm.droitAcces.projet_index && _vm.droitAcces.delete_travaux)?_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Supprimer","icons":"","color":"red","fab":"","dark":"","small":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprTravaux = true;
                                _vm.idTravaux = scope.row.id;}}},[_c('v-icon',[_vm._v("delete")])],1):_vm._e()]}}],null,false,3189675472)})],1),_vm._v(" "),_c('br')],1):_vm._e()],1)]),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-d-arrow-right"}),_vm._v(" Suivi et contrôle\n                    technique\n                  ")]),_vm._v(" "),_c('div',[_c('el-card',{staticClass:"box-card"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[(
                              _vm.detailProjet.estimation <
                                _vm.detailProjet.montantTotalDepense
                            )?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("LE BUDGET ESTIMATIF INITIAL A ÉTÉ DÉPASSÉ")]):_vm._e(),_vm._v(" "),(
                              _vm.detailProjet.estimation >=
                                _vm.detailProjet.montantTotalDepense
                            )?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("LES DEPENSES ÉFFECTUÉES SONT TOUJOURS DANS LA\n                            FOURCHETTE ESTIMATIF DU BUDGET INITIAL")]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("BUDGET :")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"green","label":""}},[_vm._v(" "+_vm._s(_vm.detailProjet.estimationNbr)+"\n                              ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("MONTANT TOTAL DES COMMANDES :")]),_vm._v("\n                            "+_vm._s(_vm.detailProjet.montantTotalCommandeNbr)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("HEURES TOTAL DE TRAVAIL :")]),_vm._v("\n                            "+_vm._s(_vm.detailProjet.totalHeure)+" H\n                          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("MONTANT TOTAL COMMANDES ENGAGÉ :")]),_vm._v("\n                            "+_vm._s(_vm.detailProjet.montantTotalDepenseNbr)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("MONTANT TOTAL DEPENSE :")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"red","label":""}},[_vm._v(" "+_vm._s(new Intl.NumberFormat('fr-Fr').format(_vm.detailProjet.montantTotal))+"\n                              ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("TOTAL DEMANDE DE FOND:")]),_vm._v("\n                            "+_vm._s(new Intl.NumberFormat('fr-Fr').format(_vm.detailProjet.montantDmdFond ))+"\n                          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("TOTAL MISSION :")]),_vm._v("\n                            "+_vm._s(new Intl.NumberFormat().format(
                                _vm.detailProjet.montantMission
                              ))+"\n                          ")])])],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-chip',{staticStyle:{"width":"100%","font-weight":"bold","font-size":"25px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("VEUILLEZ EFFECTUER VOTRE RECHERCHE EN FONCTION DU\n                      CHANTIER ET DES TRAVAUX")]),_vm._v(" "),_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-form',{ref:"formSearchPlanifSuivi",attrs:{"lazy-validation":"","id":"formSearchPlanifSuivi"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Type de recherche"},model:{value:(_vm.selectTypeSearchSuivi),callback:function ($$v) {_vm.selectTypeSearchSuivi=$$v},expression:"selectTypeSearchSuivi"}},_vm._l((_vm.typeSearch),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1),_vm._v(" "),(_vm.selectTypeSearchSuivi == 1)?_c('v-flex',{attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Chantier"},model:{value:(_vm.selectSearchChantierFindSuivi),callback:function ($$v) {_vm.selectSearchChantierFindSuivi=$$v},expression:"selectSearchChantierFindSuivi"}},_vm._l((_vm.listChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.selectTypeSearchSuivi == 2)?_c('v-flex',{attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Chantier"},on:{"change":function($event){return _vm.loadTravauxSuivi()}},model:{value:(_vm.selectSearchChantierSuivi),callback:function ($$v) {_vm.selectSearchChantierSuivi=$$v},expression:"selectSearchChantierSuivi"}},_vm._l((_vm.listChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.selectTypeSearchSuivi == 2)?_c('v-flex',{attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Travaux"},model:{value:(_vm.selectSearchTravauxSuivi),callback:function ($$v) {_vm.selectSearchTravauxSuivi=$$v},expression:"selectSearchTravauxSuivi"}},_vm._l((_vm.listTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.selectTypeSearchSuivi == 1)?_c('v-flex',{attrs:{"md1":""}},[_c('v-btn',{attrs:{"icons":"","color":"blue","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.loadChantierSuivie()}}},[_c('v-icon',[_vm._v("search")])],1)],1):_vm._e(),_vm._v(" "),(_vm.selectTypeSearchSuivi == 2)?_c('v-flex',{attrs:{"md1":""}},[_c('v-btn',{attrs:{"icons":"","color":"blue","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.loadTravauxSuivie()}}},[_c('v-icon',[_vm._v("search")])],1)],1):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.listChantierSuivie.length != 0)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("DETAILS CHANTIER "+_vm._s(_vm.detailProjet.libelle))])],1)],1):_vm._e(),_vm._v(" "),(_vm.listChantierSuivie.length != 0)?_c('el-tabs',[_vm._l((_vm.listChantierSuivie),function(item){return _c('el-tab-pane',{key:item.key,attrs:{"label":item.libelle,"name":item.key}},[_c('v-card',[_c('v-layout',{staticClass:"elevation-5",attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-1",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDashboardChantier(item)}},slot:"activator"},[_vm._v("\n                                  Dashboard chantier\n                                  "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("dashboard")])],1),_vm._v("Info dashboard chantier\n                              ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Libelle")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[_vm._v(_vm._s(item.libelle))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date début et fin")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(item.dateD)+" --\n                                      "+_vm._s(item.dateF))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Créé le")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(item.created))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Chef chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(item.chef))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Durée (Jours)")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(item.dureeJ))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Retard (J)")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(item.nbrRetard))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Coût du marché")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(item.montantNbr))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Images")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},_vm._l((item.photos),function(photo,index){return _c('span',{key:index},[_c('v-avatar',{staticClass:"mr-2",attrs:{"tile":true,"size":"100px","height":"100px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":photo,"alt":"avatar"}})])],1)}),0)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Dépenses")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(item.total))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Créé par")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(item.createdUser))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Travaux planifiés")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_c('v-chip',{attrs:{"label":"","outline":"","color":"primary"}},[_vm._v(_vm._s(item.nbTrxPlan))])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Prestataire (chantier)")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(item.prestataire))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Montant prestataire (chantier)")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(item.montantSoustraitanceFormat)+"\n                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Evolution")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_c('v-progress-circular',{attrs:{"size":160,"width":25,"rotate":360,"value":item.evolution,"color":"primary"}},[_vm._v(_vm._s(item.evolutionNbr)+"\n                                        %")])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("LISTE DES TRAVAUX DU CHANTIER")])],1)],1),_vm._v(" "),_c('el-tabs',{on:{"tab-click":_vm.handleTabClickTravaux}},_vm._l((item.travaux),function(itemT){return _c('el-tab-pane',{key:itemT.key,attrs:{"label":itemT.libelle,"name":itemT.key,"idTravau":itemT.idTrx,"item":itemT}},[(_vm.listTravauxRow !='')?_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Identifiant :")]),_vm._v("\n                                            "+_vm._s(_vm.listTravauxRow.code)+"\n                                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libellé :")]),_vm._v("\n                                            "+_vm._s(_vm.listTravauxRow.libelle)+"\n                                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Sous-traité :")]),_vm._v("\n                                            "+_vm._s(_vm.listTravauxRow.soutraiteLibelle)+"\n                                          ")]),_vm._v(" "),(_vm.listTravauxRow.fournisseur !='')?_c('p',[_c('b',[_vm._v("Sous-traitant :")]),_vm._v("\n                                            "+_vm._s(_vm.listTravauxRow.fournisseur)+"\n                                          ")]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Date de début :")]),_vm._v("\n                                            "+_vm._s(_vm.listTravauxRow.dateD)+"\n                                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de fin :")]),_vm._v("\n                                            "+_vm._s(_vm.listTravauxRow.dateF)+"\n                                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Durée :")]),_vm._v("\n                                            "+_vm._s(_vm.listTravauxRow.duree)+" Jour(s)\n                                          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Statut :")]),_vm._v(" "),(_vm.listTravauxRow.evolution == 0)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"green"}},[_vm._v("\n                                              EN ATTENTE\n                                              "),_c('v-icon',{attrs:{"right":""}})],1):_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                              EN EXECUTION\n                                              "),_c('v-icon',{attrs:{"right":""}})],1)],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Montant travaux dépensé :")]),_vm._v("\n                                            "+_vm._s(_vm.listTravauxRow.montant)+"\n                                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v("\n                                            "+_vm._s(_vm.listTravauxRow.created)+"\n                                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v("\n                                            "+_vm._s(_vm.listTravauxRow.modified)+"\n                                          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("ETAT GLOBAL DES TRAVAUX")])]),_vm._v(" "),_c('p',[_c('v-progress-circular',{attrs:{"size":160,"width":25,"rotate":360,"value":_vm.listTravauxRow.evolution,"color":"orange"}},[_vm._v(_vm._s(_vm.listTravauxRow.evolutionNbr)+"\n                                              %")])],1)])],1)],1)])],1)])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.listTravauxRow !='')?_c('el-tabs',{on:{"tab-click":_vm.handleTabClickTaches},model:{value:(_vm.activeTacheChantier),callback:function ($$v) {_vm.activeTacheChantier=$$v},expression:"activeTacheChantier"}},[_c('el-tab-pane',{attrs:{"label":"TACHES","name":"tacheChantier"}},[_c('br'),_vm._v(" "),(_vm.listTachesRow !='')?_c('el-card',{staticClass:"box-card"},[_c('p',{attrs:{"align":"right"}},[(
                                        _vm.droitAcces.imprime_tache_travaaux_all
                                      )?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerTacheTravaux(_vm.listTravauxRow)}},slot:"activator"},[_vm._v("\n                                        Imprimer\n                                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("Imprimer toutes les tâches\n                                    ")],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('data-tables',{staticStyle:{"width":"100%","font-size":"15px"},attrs:{"data":_vm.listTachesRow.taches}},[_c('el-table-column',{attrs:{"prop":"tacheLibelle","label":"TÂCHES A REALISER","width":"200","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.tacheLibelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"travaux","label":"TRAVAUX","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.travaux))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"DATE ET INTERVAL DE TEMPS","align":"center"}},[_c('el-table-column',{attrs:{"prop":"dateDebut","label":"Début","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateFin","label":"Fin","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"Durée (Jours) ","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.duree)+"\n                                                Jour(s)")])]}}],null,true)})],1),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateDemar","label":"Date de démarrage","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT GLOBAL","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-progress',{attrs:{"text-inside":true,"stroke-width":30,"percentage":scope.row.evolution,"status":"success"}})]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"blue"}},[_vm._v(_vm._s(scope.row.libEtat))]),_vm._v(" "),(
                                                scope.row.nBprestataire == false
                                              )?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("Aucun ouvriers ou prestataires\n                                              !")]):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"UNITE","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"QUT ESTIMATIF","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteEffec","label":"QUT REALISEE","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteEcart","label":"ECART","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"PRIX UNITAIRE","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v(_vm._s(new Intl.NumberFormat().format(
                                              prop.row.prixUHT
                                            )))]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"TOTAL HT (ESTIMATIF)","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v(_vm._s(new Intl.NumberFormat().format(
                                              prop.row.totalHT
                                            )))]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"MONTANT REALISE","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v(_vm._s(new Intl.NumberFormat().format(
                                              prop.row.montantEffec
                                            )))]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTIONS","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(
                                                _vm.droitAcces.show_tache_travaux
                                              )?_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showTache(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(
                                                  scope.row.nBprestataire ==
                                                    true
                                                )?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"blue","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showOuvrier(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("assignment_ind")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("ouvriers")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(
                                                  (scope.row.etat == 0 ||
                                                    scope.row.etat == null) &&
                                                    scope.row.nBprestataire ==
                                                      true
                                                )?_c('v-btn',{attrs:{"slot":"activator","disabled":scope.row.disaledDemar,"icons":"","color":"purple","fab":"","dark":"","small":""},nativeOn:{"click":function($event){_vm.tacheSel = scope.row;
                                                  _vm.dialogDemarrer = true;}},slot:"activator"},[_c('v-icon',[_vm._v("play_circle_outline")])],1):_vm._e(),_vm._v("Démarrer\n                                            ")],1),_vm._v(" "),(_vm.droitAcces.imprime_tache)?_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerTache(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1):_vm._e(),_vm._v(" "),(
                                                scope.row.evolution === 0 &&
                                                  scope.row.etatContrat == 0
                                              )?_c('v-btn',{attrs:{"icons":"","color":"red","fab":"","dark":"","small":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprTache = true;
                                                _vm.idTache = scope.row.id;}}},[_c('v-icon',[_vm._v("delete")])],1):_vm._e()]}}],null,true)})],1)],1)],1)]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(!_vm.choixTravux)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newDemarerTravaux(_vm.listTravauxRow)}},slot:"activator"},[_vm._v("\n                                    Démarrer\n                                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1):_vm._e(),_vm._v("Démarrer les travaux\n                                ")],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"ETAT RESSOURCES"}},[(_vm.listRessourcesRow !='')?_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('data-tables',{staticStyle:{"width":"100%","font-size":"15px"},attrs:{"data":_vm.listRessourcesRow.planifProduits}},[_c('el-table-column',{attrs:{"prop":"produit","label":"RESSOURCES","align":"center","width":"230","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.produit))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité planifiée","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v(_vm._s(new Intl.NumberFormat('fr-Fr').format(scope.row.qte )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.unite))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteUtil","label":"Quantité utilisée","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v(_vm._s(new Intl.NumberFormat('fr-Fr').format(scope.row.qteUtil)))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecart","label":"Ecart","align":"center"}})],1)],1)],1)])],1):_vm._e()],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"COMMANDES","name":"commandeChantier"}},[_c('div',[(_vm.listCommandesRow !='')?_c('el-tabs',{model:{value:(_vm.activeComChantier),callback:function ($$v) {_vm.activeComChantier=$$v},expression:"activeComChantier"}},[_c('el-tab-pane',{attrs:{"label":"A VALIDER","name":"avalider"}},[_c('br'),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('p',{attrs:{"align":"left"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-chip',{staticStyle:{"width":"100%","font-weight":"20px"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("MONTANT :\n                                                  "+_vm._s(_vm.listCommandesRow.totalCommandeAValider)+"\n                                                ")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('data-tables',{staticStyle:{"width":"100%","font-size":"15px"},attrs:{"data":_vm.listCommandesRow.commavalider}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.ref))]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.dateC))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.valid === 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                    EN ATENTE DE VALIDATION\n                                                    "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.valid === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                    REJETE\n                                                    "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(
                                                      scope.row.etat === false
                                                    )?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                    NON LIVRE\n                                                    "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTIONS","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showCommande(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editCommande(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.newValidCommande(
                                                        scope.row
                                                      )}}},[_c('v-icon',[_vm._v("done_all")])],1),_vm._v(" "),(
                                                      _vm.droitAcces.imprime_commande
                                                    )?_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerCommande(
                                                        scope.row
                                                      )}}},[_c('v-icon',[_vm._v("print")])],1):_vm._e()]}}],null,true)})],1)],1)],1)])],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"VALIDER","name":"valider"}},[_c('br'),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('p',{attrs:{"align":"left"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-chip',{staticStyle:{"width":"100%","font-weight":"20px"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("MONTANT :\n                                                  "+_vm._s(_vm.listCommandesRow.totalCommandeValider)+"\n                                                ")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('data-tables',{staticStyle:{"width":"100%","font-size":"15px"},attrs:{"data":_vm.listCommandesRow.commvalide}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.ref))]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.dateC))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.valid === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                    VALIDER\n                                                    "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.valid === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                    REJETE\n                                                    "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(
                                                      scope.row.etat === false
                                                    )?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                    NON LIVRE\n                                                    "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(
                                                      scope.row.etat == true
                                                    )?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                    LIVRE\n                                                    "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTIONS","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showCommande(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerCommande(
                                                        scope.row
                                                      )}}},[_c('v-icon',[_vm._v("print")])],1)]}}],null,true)})],1)],1)],1)])],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"A LIVRE","name":"alivre"}},[_c('br'),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('p',{attrs:{"align":"left"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-chip',{staticStyle:{"width":"100%","font-weight":"20px"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("MONTANT :\n                                                  "+_vm._s(_vm.listCommandesRow.totalCommandeALivrer)+"\n                                                ")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('data-tables',{staticStyle:{"width":"100%","font-size":"15px"},attrs:{"data":_vm.listCommandesRow.commaLivrer}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.ref))]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.dateC))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.valid === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                    VALIDE\n                                                    "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(
                                                      scope.row.etat == false
                                                    )?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                    NON LIVRE\n                                                    "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTIONS","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showCommande(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerCommande(
                                                        scope.row
                                                      )}}},[_c('v-icon',[_vm._v("print")])],1)]}}],null,true)})],1)],1)],1)])],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"LIVRE","name":"livre"}},[_c('br'),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('p',{attrs:{"align":"left"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-chip',{staticStyle:{"width":"100%","font-weight":"20px"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("MONTANT :\n                                                  "+_vm._s(_vm.listCommandesRow.totalCommandeLivre)+"\n                                                ")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('data-tables',{staticStyle:{"width":"100%","font-size":"15px"},attrs:{"data":_vm.listCommandesRow.commLivre}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.ref))]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.dateC))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.valid === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                    VALIDE\n                                                    "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(
                                                      scope.row.etat == true
                                                    )?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                    LIVRE\n                                                    "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTIONS","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showCommande(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerCommande(
                                                        scope.row
                                                      )}}},[_c('v-icon',[_vm._v("print")])],1)]}}],null,true)})],1)],1)],1)])],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"TOUTES LES COMMANDES","name":"all"}},[_c('br'),_vm._v(" "),_c('p',{attrs:{"align":"left"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-chip',{staticStyle:{"width":"100%","font-weight":"20px"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("MONTANT :\n                                              "+_vm._s(_vm.listCommandesRow.totalCommande)+"\n                                            ")])],1)],1)],1),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%","font-size":"15px"},attrs:{"data":_vm.listCommandesRow.commAll}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.ref))]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.dateC))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.valid === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                              VALIDER\n                                              "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.valid === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                              REJETE\n                                              "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                              NON LIVRE\n                                              "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat == true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                              LIVRE\n                                              "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTIONS","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showCommande(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),(
                                                scope.row.factureValide === 0
                                              )?_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editCommande(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(scope.row.valid === 0)?_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.newValidCommande(scope.row)}}},[_c('v-icon',[_vm._v("done_all")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerCommande(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1)]}}],null,true)})],1)],1)],1):_vm._e()],1)])],1):_vm._e()],1)}),1)],1)}),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"PLANINGS","name":"planings"}},[_c('div',[_c('div',{ref:"gantt",staticStyle:{"height":"400px"}})])])],2):_vm._e(),_vm._v(" "),(_vm.listTravauxSuivie.length != 0)?_c('el-tabs',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("TRAVAUX "+_vm._s(_vm.listTravauxSuivie[0].libelle))])],1)],1),_vm._v(" "),_vm._l((_vm.listTravauxSuivie),function(itemT){return _c('el-tab-pane',{key:itemT.key,attrs:{"label":itemT.libelle,"name":itemT.key}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Identifiant :")]),_vm._v("\n                                        "+_vm._s(itemT.ref)+"\n                                      ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Chantier concerné :")]),_vm._v("\n                                        "+_vm._s(itemT.chantier)+"\n                                      ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libellé :")]),_vm._v("\n                                        "+_vm._s(itemT.libelle)+"\n                                      ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Sous-traité :")]),_vm._v("\n                                        "+_vm._s(itemT.soutraiteLibelle)+"\n                                      ")]),_vm._v(" "),(itemT.fournisseur !='')?_c('p',[_c('b',[_vm._v("Sous-traitant :")]),_vm._v("\n                                        "+_vm._s(itemT.fournisseur)+"\n                                      ")]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Date de début :")]),_vm._v("\n                                        "+_vm._s(itemT.dateD)+"\n                                      ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de fin :")]),_vm._v("\n                                        "+_vm._s(itemT.dateF)+"\n                                      ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Durée :")]),_vm._v("\n                                        "+_vm._s(itemT.duree)+" Jour(s)\n                                      ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Statut :")]),_vm._v(" "),(itemT.evolution == 0)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"green"}},[_vm._v("\n                                          EN ATTENTE\n                                          "),_c('v-icon',{attrs:{"right":""}})],1):_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                          EN EXECUTION\n                                          "),_c('v-icon',{attrs:{"right":""}})],1)],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Montant des travaux :")]),_vm._v("\n                                        "+_vm._s(new Intl.NumberFormat('fr-Fr').format(itemT.montant))+"\n                                      ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v("\n                                        "+_vm._s(itemT.created)+"\n                                      ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v("\n                                        "+_vm._s(itemT.modified)+"\n                                      ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("ETAT GLOBAL DES TRAVAUX")])]),_vm._v(" "),_c('p',[_c('v-progress-circular',{attrs:{"size":160,"width":25,"rotate":360,"value":itemT.evolution,"color":"orange"}},[_vm._v(_vm._s(itemT.evolutionNbr)+"\n                                          %")])],1)])],1)],1)])],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-tabs',{model:{value:(_vm.activeTacheChantier),callback:function ($$v) {_vm.activeTacheChantier=$$v},expression:"activeTacheChantier"}},[_c('el-tab-pane',{attrs:{"label":"TACHES","name":"tacheChantier"}},[_c('br'),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('p',{attrs:{"align":"right"}},[(_vm.droitAcces.imprime_tache_travaaux_all)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerTacheTravaux(itemT)}},slot:"activator"},[_vm._v("\n                                    Imprimer\n                                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("Imprimer toutes les tâches\n                                ")],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('data-tables',{ref:"multipleTable",refInFor:true,staticStyle:{"width":"100%","font-size":"15px"},attrs:{"data":itemT.taches},on:{"selection-change":_vm.selectionChangeTravaux}},[_c('el-table-column',{attrs:{"selectable":_vm.soustraitanceSelect,"width":"55","type":"selection"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"travaux","label":"TRAVAUX","width":"230","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.travaux))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tacheLibelle","label":"TÂCHES A REALISER"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.tacheLibelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"DATE ET INTERVAL DE TEMPS","align":"center"}},[_c('el-table-column',{attrs:{"prop":"dateDebut","label":"Début","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateFin","label":"Fin","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"Durée (Jours) ","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.duree)+"\n                                            Jour(s)")])]}}],null,true)})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT GLOBAL","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-progress',{attrs:{"text-inside":true,"stroke-width":30,"percentage":scope.row.evolution,"status":"success"}})]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.evolution === 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("EN ATTENTE")]):_vm._e(),_vm._v(" "),(
                                            scope.row.evolution > 0 &&
                                              scope.row.evolution !== 100
                                          )?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("EN EXECUTION")]):_vm._e(),_vm._v(" "),(scope.row.evolution === 100)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("TERMINE")]):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTIONS","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showTache(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),(
                                            scope.row.evolution !== 100 &&
                                              scope.row.etatContrat == 1 &&
                                              scope.row.lastRapport === true &&
                                              _vm.droitAcces.new_rapport_travaux
                                          )?_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.newRapport(scope.row)}}},[_c('v-icon',[_vm._v("description")])],1):_vm._e(),_vm._v(" "),(scope.row.evolution === 100)?_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.newValid(scope.row)}}},[_c('v-icon',[_vm._v("done_all")])],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.imprime_tache)?_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerTache(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1):_vm._e(),_vm._v(" "),(
                                            scope.row.evolution === 0 &&
                                              scope.row.etatContrat == 0
                                          )?_c('v-btn',{attrs:{"icons":"","color":"red","fab":"","dark":"","small":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprTache = true;
                                            _vm.idTache = scope.row.id;}}},[_c('v-icon',[_vm._v("delete")])],1):_vm._e()]}}],null,true)})],1)],1)],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(
                                  !_vm.choixTravux &&
                                    _vm.droitAcces.new_demarrer_travaux
                                )?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newDemarerTravaux(itemT)}},slot:"activator"},[_vm._v("\n                                Démarrer\n                                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1):_vm._e(),_vm._v("Démarrer les travaux\n                            ")],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"COMMANDES","name":"commandeChantier"}},[_c('div',[_c('el-tabs',{model:{value:(_vm.activeComChantier),callback:function ($$v) {_vm.activeComChantier=$$v},expression:"activeComChantier"}},[_c('el-tab-pane',{attrs:{"label":"A VALIDER","name":"avalider"}},[_c('br'),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('p',{attrs:{"align":"left"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-chip',{staticStyle:{"width":"100%","font-weight":"20px"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("MONTANT :\n                                              "+_vm._s(itemT.totalCommandeAValider)+"\n                                            ")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('data-tables',{staticStyle:{"width":"100%","font-size":"15px"},attrs:{"data":itemT.commavalider}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.ref))]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.dateC))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.valid === 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                EN ATENTE DE VALIDATION\n                                                "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.valid === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                REJETE\n                                                "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                NON LIVRE\n                                                "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTIONS","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showCommande(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editCommande(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.newValidCommande(scope.row)}}},[_c('v-icon',[_vm._v("done_all")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerCommande(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1)]}}],null,true)})],1)],1)],1)])],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"VALIDER","name":"valider"}},[_c('br'),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('p',{attrs:{"align":"left"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-chip',{staticStyle:{"width":"100%","font-weight":"20px"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("MONTANT :\n                                              "+_vm._s(itemT.totalCommandeValider)+"\n                                            ")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('data-tables',{staticStyle:{"width":"100%","font-size":"15px"},attrs:{"data":itemT.commvalide}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.ref))]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.dateC))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.valid === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                VALIDER\n                                                "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.valid === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                REJETE\n                                                "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                NON LIVRE\n                                                "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat == true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                LIVRE\n                                                "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTIONS","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showCommande(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerCommande(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1)]}}],null,true)})],1)],1)],1)])],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"A LIVRE","name":"alivre"}},[_c('br'),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('p',{attrs:{"align":"left"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-chip',{staticStyle:{"width":"100%","font-weight":"20px"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("MONTANT :\n                                              "+_vm._s(itemT.totalCommandeALivrer)+"\n                                            ")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('data-tables',{staticStyle:{"width":"100%","font-size":"15px"},attrs:{"data":itemT.commaLivrer}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.ref))]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.dateC))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.valid === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                VALIDE\n                                                "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat == false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                NON LIVRE\n                                                "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTIONS","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showCommande(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerCommande(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1)]}}],null,true)})],1)],1)],1)])],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"LIVRE","name":"livre"}},[_c('br'),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('p',{attrs:{"align":"left"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-chip',{staticStyle:{"width":"100%","font-weight":"20px"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("MONTANT :\n                                              "+_vm._s(itemT.totalCommandeLivre)+"\n                                            ")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('data-tables',{staticStyle:{"width":"100%","font-size":"15px"},attrs:{"data":itemT.commLivre}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.ref))]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.dateC))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.valid === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                VALIDE\n                                                "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat == true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                LIVRE\n                                                "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTIONS","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showCommande(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerCommande(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1)]}}],null,true)})],1)],1)],1)])],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"TOUTES LES COMMANDES","name":"all"}},[_c('br'),_vm._v(" "),_c('p',{attrs:{"align":"left"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-chip',{staticStyle:{"width":"100%","font-weight":"20px"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("MONTANT : "+_vm._s(itemT.totalCommande)+"\n                                        ")])],1)],1)],1),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%","font-size":"15px"},attrs:{"data":itemT.commAll}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.ref))]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.dateC))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.valid === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                          VALIDER\n                                          "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.valid === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                          REJETE\n                                          "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                          NON LIVRE\n                                          "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat == true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                          LIVRE\n                                          "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTIONS","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showCommande(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),(scope.row.factureValide === 0)?_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editCommande(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(scope.row.valid === 0)?_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.newValidCommande(scope.row)}}},[_c('v-icon',[_vm._v("done_all")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerCommande(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1)]}}],null,true)})],1)],1)],1)],1)])],1)],1)}),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"PLANINGS","name":"planings"}},[_c('div',[_c('div',{ref:"gantt",staticStyle:{"height":"400px"}})])])],2):_vm._e()],1)]),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" Matrice contractuelle\n                  ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('MatriceContract',{attrs:{"idProjet":_vm.detailProjet.id,"show":_vm.showMatrice}})],1)],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" Taux d'évolution\n                  ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('ListEvolution',{attrs:{"idProjet":_vm.detailProjet.id,"show":_vm.showListTaux}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowProjet = false}},slot:"activator"},[_vm._v("\n              Fermer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("Fermer\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.new_projet)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.ajoutProjet('edit', _vm.detailProjet)}},slot:"activator"},[_vm._v("\n              Modifer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("Modifier\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(!_vm.choixChantier)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"teal","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newDupliqueChantier(_vm.detailProjet)}},slot:"activator"},[_vm._v("\n              Dupliquer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_copy")])],1):_vm._e(),_vm._v("Dupliquer des chantiers\n          ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.show_travaux)?_c('v-dialog',{attrs:{"persistent":"","max-width":"90%","overlay":true,"scrollable":""},model:{value:(_vm.dialogShowTravaux),callback:function ($$v) {_vm.dialogShowTravaux=$$v},expression:"dialogShowTravaux"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Détails des travaux TRAV-"+_vm._s(_vm.detailTravaux.libelle)+" /\n              "+_vm._s(_vm.detailTravaux.ref))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.handleTabClick('2'); _vm.dialogShowTravaux = false;}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Identifiant :")]),_vm._v("\n                            "+_vm._s(_vm.detailTravaux.ref)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Chantier concerné :")]),_vm._v("\n                            "+_vm._s(_vm.detailTravaux.chantier)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libellé :")]),_vm._v("\n                            "+_vm._s(_vm.detailTravaux.libelle)+"\n                          ")]),_vm._v(" "),(_vm.detailTravaux.sousLibelle !='')?_c('p',[_c('b',[_vm._v("Sous travaux :")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"green"}},[_vm._v("\n                            "+_vm._s(_vm.detailTravaux.sousLibelle)+"\n                            ")])],1):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Sous-traité :")]),_vm._v("\n                            "+_vm._s(_vm.detailTravaux.soutraiteLibelle)+"\n                          ")]),_vm._v(" "),(_vm.detailTravaux.fournisseur !='')?_c('p',[_c('b',[_vm._v("Sous-traitant :")]),_vm._v("\n                            "+_vm._s(_vm.detailTravaux.fournisseur)+"\n                          ")]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Date de début :")]),_vm._v("\n                            "+_vm._s(_vm.detailTravaux.dateD)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de fin :")]),_vm._v("\n                            "+_vm._s(_vm.detailTravaux.dateF)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Durée :")]),_vm._v("\n                            "+_vm._s(_vm.detailTravaux.duree)+" Jour(s)\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Tache correspondant :")]),_vm._v("\n                            "+_vm._s(_vm.detailTravaux.tache)+"\n                          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Statut :")]),_vm._v(" "),(_vm.detailTravaux.evolution == 0)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"green"}},[_vm._v("\n                              EN ATTENTE\n                              "),_c('v-icon',{attrs:{"right":""}})],1):_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                              EN EXECUTION\n                              "),_c('v-icon',{attrs:{"right":""}})],1)],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Montant des travaux :")]),_vm._v("\n                            "+_vm._s(_vm.detailTravaux.montant)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v("\n                            "+_vm._s(_vm.detailTravaux.created)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v("\n                            "+_vm._s(_vm.detailTravaux.modified)+"\n                          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("ETAT GLOBAL DES TRAVAUX")])]),_vm._v(" "),_c('p',[_c('v-progress-circular',{attrs:{"size":160,"width":25,"rotate":360,"value":_vm.detailTravaux.evolution,"color":"orange"}},[_vm._v(_vm._s(_vm.detailTravaux.evolutionNbr)+"\n                              %")])],1)])],1)],1)])],1)])],1),_vm._v(" "),_c('div',[_c('el-tabs',{model:{value:(_vm.tabb),callback:function ($$v) {_vm.tabb=$$v},expression:"tabb"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" Liste des Taches\n                  ")]),_vm._v(" "),(_vm.detailTravaux.option !== null)?_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      TOUTES LES TÂCHES\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("subject")])],1)],1):_vm._e(),_vm._v(" "),(_vm.detailTravaux.option !== null)?_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('p',{attrs:{"align":"right"}},[(_vm.droitAcces.imprime_tache_travaaux_all)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerTacheTravaux(_vm.detailTravaux)}},slot:"activator"},[_vm._v("\n                          Imprimer\n                          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("Imprimer toutes les tâches\n                      ")],1):_vm._e()],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%","font-size":"15px"},attrs:{"data":_vm.detailTravaux.option},on:{"selection-change":_vm.selectionChangeTravaux}},[_c('el-table-column',{attrs:{"selectable":_vm.soustraitanceSelect,"width":"55","type":"selection"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tache","label":"TÂCHES A REALISER","align":"center","width":"230","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.tacheLibelle))])]}}],null,false,680322515)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"DATE ET INTERVAL DE TEMPS","align":"center"}},[_c('el-table-column',{attrs:{"prop":"dateD","label":"Début","width":"190"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Fin","width":"190"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"Durée (Jours) ","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.duree)+" Jour(s)")])]}}],null,false,2608640762)})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT GLOBAL","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-progress-circular',{attrs:{"size":80,"width":15,"rotate":360,"value":scope.row.evolution,"color":"green"}},[_vm._v(_vm._s(scope.row.evolution)+"\n                                  %")])]}}],null,false,2729182574)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("EN ATTENTE")]):_vm._e(),_vm._v(" "),(scope.row.etat == 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("EN EXECUTION")]):_vm._e(),_vm._v(" "),(scope.row.etat == 2)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("TERMINE")]):_vm._e(),_vm._v(" "),(scope.row.etat == 3)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("ARRETE")]):_vm._e()]}}],null,false,1910867871)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTIONS","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerTache(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),(
                                    scope.row.evolution === 0 &&
                                      scope.row.etatContrat == 0
                                  )?_c('v-btn',{attrs:{"icons":"","color":"red","fab":"","dark":"","small":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprTache = true;
                                    _vm.idTache = scope.row.id;}}},[_c('v-icon',[_vm._v("delete")])],1):_vm._e()]}}],null,false,1100019974)})],1)],1)],1)])],1):_vm._e()],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" Liste des planifications des\n                    ressources\n                  ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      BESOIN ESTIMATF EN RESSOURCES\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("subject")])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('data-tables',{staticStyle:{"width":"100%","font-size":"15px"},attrs:{"data":_vm.detailTravaux.prod}},[_c('el-table-column',{attrs:{"prop":"tacheLibelle","label":"TACHE CONCERNE","align":"center","width":"250","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.tacheLibelle))])]}}],null,false,680322515)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateD","label":"DEBUT DE LA TACHE","align":"center","width":"200","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.dateD))])]}}],null,false,2548326975)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"produit","label":"PRODUIT","align":"center","width":"230","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.produit))])]}}],null,false,3135016238)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.qte))])]}}],null,false,2818264962)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.unite))])]}}],null,false,4157911233)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created","label":"DATE DE CREATION","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.created))]}}],null,false,2410553629)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.typeProduit == 'VEHICULE')?_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showInfoRessources(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1):_vm._e(),_vm._v(" "),(scope.row.etatValid == 1)?_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editRessources(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(scope.row.etatValid == 1)?_c('v-btn',{attrs:{"icons":"","color":"red","fab":"","dark":"","small":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprRessource = true;
                                _vm.idRessour = scope.row.id;}}},[_c('v-icon',[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),(scope.row.etatValid == 0 ||  scope.row.etatValid == 2 ||  scope.row.etatValid == 4)?_c('v-chip',{attrs:{"text-color":"white","color":"success"}},[_vm._v("\n                              Besoin validé\n                            ")]):_vm._e(),_vm._v(" "),(scope.row.etatValid == 3)?_c('v-chip',{attrs:{"text-color":"white","color":"danger"}},[_vm._v("\n                              Besoin rejeté\n                            ")]):_vm._e()]}}],null,false,3807469580)})],1)],1)],1)])],1)],1)],1)],1),_vm._v(" "),(_vm.listEquipe.length !== 0)?_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                TOUTES LES BONS D'EXECUTIONS\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("person_add")])],1)],1):_vm._e(),_vm._v(" "),(_vm.listEquipe.length !== 0)?_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('p',{attrs:{"align":"right"}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerContratTravaux(_vm.detailTravaux)}},slot:"activator"},[_vm._v("\n                    Imprimer\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("Imprimer\n                ")],1)],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%","font-size":"15px"},attrs:{"data":_vm.listEquipe,"stripe":"","border":""},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"selectable":_vm.contratSelect,"width":"55","type":"selection"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"TÂCHES CONCERNE","align":"center","width":"220","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.tache))])]}}],null,false,4086614457)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"EXECUTANT DE LA TÂCHES","align":"center"}},[_c('el-table-column',{attrs:{"prop":"typeExec","label":"Type","width":"190"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"executant","label":"Raison Sociale / Nom et prénoms","width":"190"}})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"DATE ET INTERVAL DE TEMPS","align":"center"}},[_c('el-table-column',{attrs:{"prop":"dateD","label":"Début","width":"190"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Fin","width":"190"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"Durée (Jours)","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.duree)+" Jour(s)")])]}}],null,false,2608640762)})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"COÛT TOTAL () ","align":"center"}},[_c('el-table-column',{attrs:{"prop":"montant","label":"Montant journalier","width":"190"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.montant)+"\n                          ")]}}],null,false,1783068807)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"TOTAL","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"green"}},[_vm._v(_vm._s(scope.row.total)+"\n                            ")])]}}],null,false,1623575598)})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat === 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("EN ATTENTE")]):_vm._e(),_vm._v(" "),(scope.row.etat === 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("EN EXECUTION")]):_vm._e(),_vm._v(" "),(scope.row.etat === 2)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"orange"}},[_vm._v("SUSPENDU")]):_vm._e(),_vm._v(" "),(scope.row.etat === 3)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("TERMINE")]):_vm._e()]}}],null,false,227692830)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTIONS","width":"170","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editEquipe(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerContrat(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1)]}}],null,false,3887931844)})],1)],1)],1)])],1):_vm._e()],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowTravaux = false}},slot:"activator"},[_vm._v("\n              Fermer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("Fermer\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editTravaux(_vm.detailTravaux, _vm.travauxCourant, _vm.listChantierResult)}},slot:"activator"},[_vm._v("\n              Modifier les travaux\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1),_vm._v("Modifier\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerTravaux(_vm.detailTravaux)}},slot:"activator"},[_vm._v("\n              Imprimer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("Imprimer\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(!_vm.choix)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newDemarer(_vm.detailTravaux)}},slot:"activator"},[_vm._v("\n              Démarrer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1):_vm._e(),_vm._v("Démarrer les tâches\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(!_vm.choixTravux)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newDemarerTravaux(_vm.detailTravaux)}},slot:"activator"},[_vm._v("\n              Démarrer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1):_vm._e(),_vm._v("Démarrer les travaux\n          ")],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.show_tache_projet)?_c('v-dialog',{attrs:{"persistent":"","max-width":"90%","overlay":true,"scrollable":""},model:{value:(_vm.dialogShowTache),callback:function ($$v) {_vm.dialogShowTache=$$v},expression:"dialogShowTache"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Détails des tâches TACH-"+_vm._s(_vm.detailTache.ref)+"\n              "+_vm._s(_vm.detailTache.tacheLibelle))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowTache = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Référence :")]),_vm._v("\n                            "+_vm._s(_vm.detailTache.ref)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libellé :")]),_vm._v("\n                            "+_vm._s(_vm.detailTache.tacheLibelle)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Travaux concerné :")]),_vm._v("\n                            "+_vm._s(_vm.detailTache.travaux)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Sous-traité :")]),_vm._v("\n                            "+_vm._s(_vm.detailTache.soutraiteLibelle)+"\n                          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[(_vm.detailTache.fournisseur !='')?_c('p',[_c('b',[_vm._v("Sous-traitant :")]),_vm._v("\n                            "+_vm._s(_vm.detailTache.fournisseur)+"\n                          ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de début :")]),_vm._v("\n                            "+_vm._s(_vm.detailTache.dateD)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de fin :")]),_vm._v("\n                            "+_vm._s(_vm.detailTache.dateF)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Durée estimatif :")]),_vm._v("\n                            "+_vm._s(_vm.detailTache.duree)+" Jour(s)\n                          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Statut :")]),_vm._v(" "),(_vm.detailTache.evolution == 0)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"green"}},[_vm._v("\n                              EN ATTENTE\n                              "),_c('v-icon',{attrs:{"right":""}})],1):_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                              EN EXECUTION\n                              "),_c('v-icon',{attrs:{"right":""}})],1)],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v("\n                            "+_vm._s(_vm.detailTache.created)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v("\n                            "+_vm._s(_vm.detailTache.modified)+"\n                          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("ETAT GLOBAL DE LA TÂCHE")])]),_vm._v(" "),_c('p',[_c('v-progress-circular',{attrs:{"size":120,"width":25,"rotate":360,"value":_vm.detailTache.evolution,"color":"orange"}},[_vm._v(_vm._s(_vm.detailTache.evolutionNbr)+"\n                              %")])],1)])],1)],1)])],1)])],1),_vm._v(" "),_c('el-row',[_c('el-collapse',_vm._l((_vm.detailTache.rapport),function(item){return _c('el-collapse-item',{key:item.key,attrs:{"title":item.ref,"name":item.key}},[_c('div',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Référence :")]),_vm._v("\n                            "+_vm._s(item.ref)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Evolution :")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v(_vm._s(item.evolutionNbr)+" %")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Progrès de :")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","color":"green"}},[_vm._v(_vm._s(item.ecart)+" %")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('b',[_vm._v("Validé par :")]),_vm._v("\n                            "+_vm._s(item.validation)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description :")]),_vm._v("\n                            "+_vm._s(item.description)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Crée par :")]),_vm._v("\n                            "+_vm._s(item.userCreate)+"\n                          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-upload',{staticClass:"upload-demo",attrs:{"action":"","file-list":item.fichier,"list-type":"picture","disabled":true}})],1)],1)],1)])])}),1)],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowTache = false}},slot:"activator"},[_vm._v("\n              Fermer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("Fermer\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerTache(_vm.detailTache)}},slot:"activator"},[_vm._v("\n              Imprimer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("Imprimer\n          ")],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.commande_show)?_c('v-dialog',{attrs:{"persistent":"","max-width":"60%","overlay":true,"scrollable":""},model:{value:(_vm.dialogShowCommande),callback:function ($$v) {_vm.dialogShowCommande=$$v},expression:"dialogShowCommande"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Détails de la commande "+_vm._s(_vm.detailCommande.libelle)+" /\n              "+_vm._s(_vm.detailCommande.ref))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowCommande = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant :")]),_vm._v("\n                            "+_vm._s(_vm.detailCommande.ref)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libellé :")]),_vm._v("\n                            "+_vm._s(_vm.detailCommande.libelle)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de la commande :")]),_vm._v("\n                            "+_vm._s(_vm.detailCommande.dateC)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de la livraison :")]),_vm._v("\n                            "+_vm._s(_vm.detailCommande.dateLivr)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Statut :")]),_vm._v(" "),(_vm.detailCommande.valid === 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                              EN ATENTE DE VALIDATION\n                              "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailCommande.valid === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                              VALIDE\n                              "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailCommande.valid === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                              REJETE\n                              "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Etat de la livraison :")]),_vm._v(" "),(_vm.detailCommande.etat === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                              NON LIVRE\n                              "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailCommande.etat == true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                              LIVRE EN TOTALITE\n                              "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Etat de la facture :")]),_vm._v(" "),(_vm.detailCommande.factureValide === 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                              EN ATENTE DE VALIDATION\n                              "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailCommande.factureValide === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                              FACTURE VALIDE\n                              "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailCommande.factureValide === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                              FACTURE REJETE\n                              "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Fournisseur :")]),_vm._v("\n                            "+_vm._s(_vm.detailCommande.fournisseurNom)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v("\n                            "+_vm._s(_vm.detailCommande.created)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v("\n                            "+_vm._s(_vm.detailCommande.modified)+"\n                          ")])])],1)],1)])],1)])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                TOUTS LES PRODUITS DEMANDE\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailCommande.option,"height":"250"}},[_c('el-table-column',{attrs:{"prop":"produit","label":"Désignation"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}})],1)],1)],1)])],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowCommande = false}},slot:"activator"},[_vm._v("\n              Fermer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("Fermer\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editCommande(_vm.detailCommande)}},slot:"activator"},[_vm._v("\n              Modifer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1),_vm._v("Modifer\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerCommande(_vm.detailCommande)}},slot:"activator"},[_vm._v("\n              Imprimer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("Imprimer\n          ")],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"80%","overlay":true,"scrollable":""},model:{value:(_vm.form.etat),callback:function ($$v) {_vm.$set(_vm.form, "etat", $$v)},expression:"form.etat"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v(_vm._s(_vm.texteP))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.form.etat = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formProjet",attrs:{"lazy-validation":"","id":"formProjet"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("Détails concernant le projet")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nom du projet "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input',{attrs:{"name":"libelle","placeholder":"Nom du projet"},model:{value:(_vm.form.libelle),callback:function ($$v) {_vm.$set(_vm.form, "libelle", $$v)},expression:"form.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Situation géographique "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input',{attrs:{"name":"adresse","placeholder":"Situation géographique"},model:{value:(_vm.form.adresse),callback:function ($$v) {_vm.$set(_vm.form, "adresse", $$v)},expression:"form.adresse"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","name":"dateD","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de début"},model:{value:(_vm.dateD),callback:function ($$v) {_vm.dateD=$$v},expression:"dateD"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateF","format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de fin"},model:{value:(_vm.dateF),callback:function ($$v) {_vm.dateF=$$v},expression:"dateF"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix du marché "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":1,"placeholder":"Prix du marché","readonly":false},model:{value:(_vm.form.prix),callback:function ($$v) {_vm.$set(_vm.form, "prix", $$v)},expression:"form.prix"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant du budget "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":1,"placeholder":"Montant du budget","readonly":false},model:{value:(_vm.form.prixBudget),callback:function ($$v) {_vm.$set(_vm.form, "prixBudget", $$v)},expression:"form.prixBudget"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description du projet")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"description","placeholder":"Description du projet"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1)])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("Poste de responsabilité")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Responsable du projet "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Responsable du projet"},model:{value:(_vm.form.chef),callback:function ($$v) {_vm.$set(_vm.form, "chef", $$v)},expression:"form.chef"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Architect ")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Architect"},model:{value:(_vm.form.architect),callback:function ($$v) {_vm.$set(_vm.form, "architect", $$v)},expression:"form.architect"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Responsable étude "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Responsable étude"},model:{value:(_vm.form.chefEtude),callback:function ($$v) {_vm.$set(_vm.form, "chefEtude", $$v)},expression:"form.chefEtude"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Responsable contrôle "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Responsable contrôle"},model:{value:(_vm.form.chefControle),callback:function ($$v) {_vm.$set(_vm.form, "chefControle", $$v)},expression:"form.chefControle"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Maître d'ouvrage "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Maître d'ouvrage"},model:{value:(_vm.form.maitre_ouvrage),callback:function ($$v) {_vm.$set(_vm.form, "maitre_ouvrage", $$v)},expression:"form.maitre_ouvrage"}},_vm._l((_vm.listClient),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Conducteur des travaux "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Conducteur des travaux"},model:{value:(_vm.form.controleur_travaux),callback:function ($$v) {_vm.$set(_vm.form, "controleur_travaux", $$v)},expression:"form.controleur_travaux"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Participants")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","multiple":"","placeholder":"Participants"},model:{value:(_vm.selectUsers),callback:function ($$v) {_vm.selectUsers=$$v},expression:"selectUsers"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("Localisation du projet")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Latitude "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","value":"latitude","name":"latitude","placeholder":"Latitude"},model:{value:(_vm.latitude),callback:function ($$v) {_vm.latitude=$$v},expression:"latitude"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Longitude "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","value":"Longitude","name":"longitude","placeholder":"Longitude"},model:{value:(_vm.longitude),callback:function ($$v) {_vm.longitude=$$v},expression:"longitude"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"}),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","color":"info"},on:{"click":function($event){return _vm.mapGoogle()}},slot:"activator"},[_vm._v("Google Map")]),_vm._v(" "),_c('span',[_vm._v("Cliquez pour rechercher les coordonnees d'un lieu")])],1)],1)])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("Autre détails concernant le projet")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Banque affiliée "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","multiple":"","placeholder":"Banque affiliée"},model:{value:(_vm.selectBanques),callback:function ($$v) {_vm.selectBanques=$$v},expression:"selectBanques"}},_vm._l((_vm.listBanque),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Caisse affiliée "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Caisse affiliée"},model:{value:(_vm.form.caisse),callback:function ($$v) {_vm.$set(_vm.form, "caisse", $$v)},expression:"form.caisse"}},_vm._l((_vm.listCaisse),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nombre d'heure de travail")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","min":1,"max":24,"name":"nbrHeure","placeholder":"Nombre d'heure de travail"},model:{value:(_vm.form.nbrHeure),callback:function ($$v) {_vm.$set(_vm.form, "nbrHeure", $$v)},expression:"form.nbrHeure"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('a',{attrs:{"href":_vm.logoProjet,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoProjet,"alt":"avatar"}})]),_c('br')],1),_vm._v(" "),_c('input',{ref:"fileLogo",staticStyle:{"display":"none"},attrs:{"name":"fileProj","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileLogo.click()}}},[_vm._v("Photo "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.form.etat = false}}},[_vm._v("\n                Annuler\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.submit()}}},[_vm._v("\n                Enregistrer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogPlan),callback:function ($$v) {_vm.dialogPlan=$$v},expression:"dialogPlan"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter de nouveau chantier pour le projet\n              "+_vm._s(_vm.detailProjet.ref)+" / "+_vm._s(_vm.detailProjet.libelle))]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modifier le chantier "+_vm._s(_vm.chantierCourant.libelle))]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogPlan = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formPlan",attrs:{"lazy-validation":"","id":"formPlan"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  Détails le projet "+_vm._s(_vm.detailProjet.ref)+" /\n                  "+_vm._s(_vm.projetCourant.libelle)+"\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("terrain")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.projetCourant.libelle,"disabled":""},model:{value:(_vm.projetCourant.libelle),callback:function ($$v) {_vm.$set(_vm.projetCourant, "libelle", $$v)},expression:"projetCourant.libelle"}})],1)]),_vm._v(" "),(_vm.projetCourant.type != '')?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de projet")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.projetCourant.type,"disabled":""},model:{value:(_vm.projetCourant.type),callback:function ($$v) {_vm.$set(_vm.projetCourant, "type", $$v)},expression:"projetCourant.type"}})],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début *")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.projetCourant.dateD,"disabled":""},model:{value:(_vm.projetCourant.dateD),callback:function ($$v) {_vm.$set(_vm.projetCourant, "dateD", $$v)},expression:"projetCourant.dateD"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin *")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.projetCourant.dateF,"disabled":""},model:{value:(_vm.projetCourant.dateF),callback:function ($$v) {_vm.$set(_vm.projetCourant, "dateF", $$v)},expression:"projetCourant.dateF"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"}),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","color":"info"},on:{"click":function($event){return _vm.mapGoogle()}},slot:"activator"},[_vm._v("Google Map")]),_vm._v(" "),_c('span',[_vm._v("Cliquez pour rechercher les coordonnees d'un lieu")])],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('a',{attrs:{"href":_vm.logoChantier,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoChantier,"alt":"avatar"}})]),_c('br')],1),_vm._v(" "),_c('input',{ref:"fileChantier",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageChantPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileChantier.click()}}},[_vm._v("Photo "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Latitude *")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","value":"latitude","name":"latitude","placeholder":"Latitude"},model:{value:(_vm.chantier.latitude),callback:function ($$v) {_vm.$set(_vm.chantier, "latitude", $$v)},expression:"chantier.latitude"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Longitude *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","value":"Longitude","name":"longitude","placeholder":"Longitude"},model:{value:(_vm.chantier.longitude),callback:function ($$v) {_vm.$set(_vm.chantier, "longitude", $$v)},expression:"chantier.longitude"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Libellé *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":"libelle","name":"libelle","placeholder":"Libellé"},model:{value:(_vm.chantier.libelle),callback:function ($$v) {_vm.$set(_vm.chantier, "libelle", $$v)},expression:"chantier.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de Chantier *")]),_vm._v(" "),(_vm.dialogEdit)?_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.chantier.typeLibelle,"disabled":""}}):_vm._e(),_vm._v(" "),(!_vm.dialogEdit)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.projetCourant.type != '' ||
                          (_vm.dialogEdit == true && _vm.chantier.type != null),"filterable":"","placeholder":"Type de Projet"},on:{"change":function($event){return _vm.loadProduitBudget()}},model:{value:(_vm.chantier.type),callback:function ($$v) {_vm.$set(_vm.chantier, "type", $$v)},expression:"chantier.type"}},_vm._l((_vm.listTypeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant du marché *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"value":"montant","name":"montant","placeholder":"Montant estimatif"},model:{value:(_vm.chantier.montant),callback:function ($$v) {_vm.$set(_vm.chantier, "montant", $$v)},expression:"chantier.montant"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateD","id":"date3","format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de début"},model:{value:(_vm.chantier.dateD),callback:function ($$v) {_vm.$set(_vm.chantier, "dateD", $$v)},expression:"chantier.dateD"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateF","id":"date4","format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de fin"},model:{value:(_vm.chantier.dateF),callback:function ($$v) {_vm.$set(_vm.chantier, "dateF", $$v)},expression:"chantier.dateF"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chef de chantier *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Chef de chantier"},model:{value:(_vm.chantier.idChef),callback:function ($$v) {_vm.$set(_vm.chantier, "idChef", $$v)},expression:"chantier.idChef"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Commis *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","multiple":"","placeholder":"Commis"},model:{value:(_vm.chantier.idCommis),callback:function ($$v) {_vm.$set(_vm.chantier, "idCommis", $$v)},expression:"chantier.idCommis"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Sous-traiter ?")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Soutraitance"},on:{"change":_vm.handleChangeSoustraitant},model:{value:(_vm.chantier.soutraite),callback:function ($$v) {_vm.$set(_vm.chantier, "soutraite", $$v)},expression:"chantier.soutraite"}},_vm._l((_vm.etatSoutraitance),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(_vm.chantier.soutraite == 1)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Sous-traitant")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Prestataire"},model:{value:(_vm.chantier.prestataire),callback:function ($$v) {_vm.$set(_vm.chantier, "prestataire", $$v)},expression:"chantier.prestataire"}},_vm._l((_vm.listPrestataire),function(item){return _c('el-option',{key:item.idPres,attrs:{"label":item.libelle,"value":item.idPres}})}),1)],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.chantier.soutraite == 1),expression:"chantier.soutraite == 1"}],attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant sous traitance *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","name":"montantSoustraitance","placeholder":"Montant sous traitance"},model:{value:(_vm.chantier.montantSoustraitance),callback:function ($$v) {_vm.$set(_vm.chantier, "montantSoustraitance", $$v)},expression:"chantier.montantSoustraitance"}})],1)]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.idChantMod),expression:"idChantMod"}],attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Etat du chantier")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Etat du chantier "},model:{value:(_vm.chantier.etat),callback:function ($$v) {_vm.$set(_vm.chantier, "etat", $$v)},expression:"chantier.etat"}},_vm._l((_vm.listEtat),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.dialogEdit)?_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("LISTE DES TRAVAUX CONCERNANT CE CHANTIER")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.travauxCourant,"default-sort":{ prop: 'id', order: 'descending' },"stripe":"","border":"","height":"350"}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Taches","width":"280","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,false,1558031285)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Date de debut","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v(_vm._s(scope.row.dateDebut))])]}}],null,false,3393872923)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Date de fin","width":"240"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v(_vm._s(scope.row.dateFin))])]}}],null,false,2966813137)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Durée","width":"240"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v(_vm._s(scope.row.duree)+" Jours")])]}}],null,false,3166100029)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editTache(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1)]}}],null,false,2379653291)})],1)],1)])],1)],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogPlan = false}}},[_vm._v("\n                Annuler\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","disabled":_vm.loading},on:{"click":function($event){return _vm.submitPlan()}}},[_vm._v("\n                Enregistrer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogCharge),callback:function ($$v) {_vm.dialogCharge=$$v},expression:"dialogCharge"}},[_c('v-card',[_c('v-toolbar',{staticClass:"green",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Liste des charges indirects liées au projet ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogCharge = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"loading":_vm.loading}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n              LISTE DES CHARGES INDIRECTS\n            ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-chip',{staticStyle:{"font-size":"19px","width":"90%"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(" "+_vm._s(_vm.listeCharges.length)+" ")]),_vm._v("\n                  Charges Indirects\n                ")],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant Total: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(new Intl.NumberFormat().format(_vm.mntTotal ))+" XOF ")])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"warning","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newRessource(_vm.detailProjet)}},slot:"activator"},[_vm._v("\n                            Ajouter \n                            "),_c('v-icon',{attrs:{"left":""}},[_vm._v("add")])],1),_vm._v("Ajouter des charges indirects\n                        ")],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('data-tables',{attrs:{"data":_vm.listeCharges}},[_c('el-table-column',{attrs:{"prop":"type","label":"Type"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"produit","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"periode","label":"Période","width":"190px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.periode == 'tous')?_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("APPLIQUER A TOUT LE PROJET")]):_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("SUR UNE PERIODE")]),_vm._v(" "),(scope.row.periode != 'tous')?_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.dateD)+" AU "+_vm._s(scope.row.dateF)+" ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mode","label":"Type de rémunération"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.mode))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(_vm._s(scope.row.qte))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cout","label":"Cout"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Total"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(scope.row.total)+" XOF")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"red","fab":"","dark":"","small":""},on:{"click":function($event){_vm.dialogSuprCharge = true;
                            _vm.idCharge = scope.row.id;}}},[_c('v-icon',[_vm._v("delete")])],1)]}}])})],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogCharge = false}}},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogFormCharge),callback:function ($$v) {_vm.dialogFormCharge=$$v},expression:"dialogFormCharge"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter des charges indirects")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modifier le chantier "+_vm._s(_vm.chantierCourant.libelle))]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogFormCharge = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formPlanCharge",attrs:{"lazy-validation":"","id":"formPlanCharge"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n              Détails le projet "+_vm._s(_vm.detailProjet.ref)+" /\n              "+_vm._s(_vm.projetCourant.libelle)+"\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("terrain")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md5":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.projetCourant.libelle,"disabled":""},model:{value:(_vm.projetCourant.libelle),callback:function ($$v) {_vm.$set(_vm.projetCourant, "libelle", $$v)},expression:"projetCourant.libelle"}})],1)]),_vm._v(" "),(_vm.projetCourant.type != '')?_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de projet")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.projetCourant.type,"disabled":""},model:{value:(_vm.projetCourant.type),callback:function ($$v) {_vm.$set(_vm.projetCourant, "type", $$v)},expression:"projetCourant.type"}})],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début *")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.projetCourant.dateD,"disabled":""},model:{value:(_vm.projetCourant.dateD),callback:function ($$v) {_vm.$set(_vm.projetCourant, "dateD", $$v)},expression:"projetCourant.dateD"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin *")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.projetCourant.dateF,"disabled":""},model:{value:(_vm.projetCourant.dateF),callback:function ($$v) {_vm.$set(_vm.projetCourant, "dateF", $$v)},expression:"projetCourant.dateF"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nombre de jour")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.projetCourant.dureeJ,"disabled":""},model:{value:(_vm.projetCourant.dureeJ),callback:function ($$v) {_vm.$set(_vm.projetCourant, "dureeJ", $$v)},expression:"projetCourant.dureeJ"}})],1)])],1),_vm._v(" "),_vm._l((_vm.optionProduit),function(optionP){return _c('v-layout',{key:optionP.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Type ressource "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"valeurSelect","id":"valeurSelect","filterable":"","placeholder":"Type ressource"},on:{"change":function($event){return _vm.loadTypeProduit(optionP.type)}},model:{value:(optionP.type),callback:function ($$v) {_vm.$set(optionP, "type", $$v)},expression:"optionP.type"}},_vm._l((_vm.listTypeRessource),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ressource "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":""},on:{"change":function($event){return _vm.loadUniteProduit(optionP.produit)}},model:{value:(optionP.produit),callback:function ($$v) {_vm.$set(optionP, "produit", $$v)},expression:"optionP.produit"}},_vm._l((_vm.listProd),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.value,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","min":"1"},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(optionP.qte),callback:function ($$v) {_vm.$set(optionP, "qte", $$v)},expression:"optionP.qte"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"valeurSelect","readonly":true},model:{value:(_vm.valeurUniteMateriel),callback:function ($$v) {_vm.valeurUniteMateriel=$$v},expression:"valeurUniteMateriel"}})],1)])],1)}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("A appliquer sur  *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Réponse"},on:{"change":function($event){return _vm.changePeriode()}},model:{value:(_vm.selectReponse),callback:function ($$v) {_vm.selectReponse=$$v},expression:"selectReponse"}},_vm._l((_vm.appiSearch),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type rémunération *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Réponse"},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.selectRemuneration),callback:function ($$v) {_vm.selectRemuneration=$$v},expression:"selectRemuneration"}},_vm._l((_vm.modeRemuneration),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),(_vm.selectReponse == 'periode')?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateD","id":"date3","format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de début"},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.chargeDateD),callback:function ($$v) {_vm.chargeDateD=$$v},expression:"chargeDateD"}})],1)]):_vm._e(),_vm._v(" "),(_vm.selectReponse == 'periode')?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateF","id":"date4","format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de fin"},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.chargeDateF),callback:function ($$v) {_vm.chargeDateF=$$v},expression:"chargeDateF"}})],1)]):_vm._e(),_vm._v(" "),(_vm.selectReponse == 'periode')?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nbre de jour")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.jourDifference,"disabled":""},model:{value:(_vm.jourDifference),callback:function ($$v) {_vm.jourDifference=$$v},expression:"jourDifference"}})],1)]):_vm._e(),_vm._v(" "),(_vm.selectRemuneration != '' && _vm.selectReponse != 'periode')?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[(_vm.selectRemuneration == 'journalier')?_c('span',{staticClass:"demonstration"},[_vm._v("Coût unitaire journalier *")]):_vm._e(),_vm._v(" "),(_vm.selectRemuneration != 'journalier')?_c('span',{staticClass:"demonstration"},[_vm._v("Coût unitaire mensuel *")]):_vm._e(),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"name":"montantChargeJournalier","placeholder":"Cout unitaire"},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.montantChargeJournalier),callback:function ($$v) {_vm.montantChargeJournalier=$$v},expression:"montantChargeJournalier"}})],1)]):_vm._e(),_vm._v(" "),(_vm.selectRemuneration != '' &&  _vm.selectReponse != 'periode')?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant Total ht *")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.totalMontantHT,"disabled":""},model:{value:(_vm.totalMontantHT),callback:function ($$v) {_vm.totalMontantHT=$$v},expression:"totalMontantHT"}})],1)]):_vm._e()],1),_vm._v(" "),(_vm.selectReponse == 'periode')?_c('v-layout',{attrs:{"row":""}},[(_vm.selectRemuneration != '')?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Coût unitaire *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"name":"montantChargeJournalier","placeholder":"Cout unitaire"},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.montantChargeJournalier),callback:function ($$v) {_vm.montantChargeJournalier=$$v},expression:"montantChargeJournalier"}})],1)]):_vm._e(),_vm._v(" "),(_vm.selectRemuneration != '')?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant Total ht *")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.totalMontantHT,"disabled":""},model:{value:(_vm.totalMontantHT),callback:function ($$v) {_vm.totalMontantHT=$$v},expression:"totalMontantHT"}})],1)]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogFormCharge = false}}},[_vm._v("\n              Annuler\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","disabled":_vm.loading},on:{"click":function($event){return _vm.submitCharge()}}},[_vm._v("\n              Enregistrer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],2)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","scrollable":"","loading":_vm.loading,"fullscreen":"","hide-overlay":"","persistent":""},model:{value:(_vm.dialogTravaux),callback:function ($$v) {_vm.dialogTravaux=$$v},expression:"dialogTravaux"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter de nouveaux travaux sur le chantier\n              "+_vm._s(_vm.detailPlanifCourant.libelle)+" pour le projet\n              "+_vm._s(_vm.detailPlanifCourant.projet))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogTravaux = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formTravaux",attrs:{"lazy-validation":"","id":"formTravaux"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  Détails du chantier "+_vm._s(_vm.detailPlanifCourant.libelle)+"\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("terrain")])],1),_vm._v(" "),(_vm.chantierCourant.soutraite == true)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("Le projet est sous-traiter par le\n                  "+_vm._s(_vm.chantierCourant.fournisseur)+" ce qui signifie que tous les\n                  travaux qui en découllent seront également soutraité")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.detailPlanifCourant.projet,"disabled":""},model:{value:(_vm.detailPlanifCourant.projet),callback:function ($$v) {_vm.$set(_vm.detailPlanifCourant, "projet", $$v)},expression:"detailPlanifCourant.projet"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chef de projet")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.detailPlanifCourant.chefPrj,"disabled":""},model:{value:(_vm.detailPlanifCourant.chefPrj),callback:function ($$v) {_vm.$set(_vm.detailPlanifCourant, "chefPrj", $$v)},expression:"detailPlanifCourant.chefPrj"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.detailPlanifCourant.dateDbtProj,"disabled":""},model:{value:(_vm.detailPlanifCourant.dateDbtProj),callback:function ($$v) {_vm.$set(_vm.detailPlanifCourant, "dateDbtProj", $$v)},expression:"detailPlanifCourant.dateDbtProj"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.detailPlanifCourant.dateFinProj,"disabled":""},model:{value:(_vm.detailPlanifCourant.dateFinProj),callback:function ($$v) {_vm.$set(_vm.detailPlanifCourant, "dateFinProj", $$v)},expression:"detailPlanifCourant.dateFinProj"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chantier concerné")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.detailPlanifCourant.libelle,"disabled":""},model:{value:(_vm.detailPlanifCourant.libelle),callback:function ($$v) {_vm.$set(_vm.detailPlanifCourant, "libelle", $$v)},expression:"detailPlanifCourant.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chef de chantier")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.detailPlanifCourant.chefChantier,"disabled":""},model:{value:(_vm.detailPlanifCourant.chefChantier),callback:function ($$v) {_vm.$set(_vm.detailPlanifCourant, "chefChantier", $$v)},expression:"detailPlanifCourant.chefChantier"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Commis chantier")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.detailPlanifCourant.commis,"disabled":""},model:{value:(_vm.detailPlanifCourant.commis),callback:function ($$v) {_vm.$set(_vm.detailPlanifCourant, "commis", $$v)},expression:"detailPlanifCourant.commis"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.detailPlanifCourant.dateD,"disabled":""},model:{value:(_vm.detailPlanifCourant.dateD),callback:function ($$v) {_vm.$set(_vm.detailPlanifCourant, "dateD", $$v)},expression:"detailPlanifCourant.dateD"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.detailPlanifCourant.dateF,"disabled":""},model:{value:(_vm.detailPlanifCourant.dateF),callback:function ($$v) {_vm.$set(_vm.detailPlanifCourant, "dateF", $$v)},expression:"detailPlanifCourant.dateF"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Soustraitance")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.detailPlanifCourant.soutraiteLibelle,"disabled":""},model:{value:(_vm.detailPlanifCourant.soutraiteLibelle),callback:function ($$v) {_vm.$set(_vm.detailPlanifCourant, "soutraiteLibelle", $$v)},expression:"detailPlanifCourant.soutraiteLibelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Sous-traitant")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.detailPlanifCourant.fournisseur,"disabled":""},model:{value:(_vm.detailPlanifCourant.fournisseur),callback:function ($$v) {_vm.$set(_vm.detailPlanifCourant, "fournisseur", $$v)},expression:"detailPlanifCourant.fournisseur"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Durée prévue (Jours)")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.detailPlanifCourant.dureeJ,"disabled":""},model:{value:(_vm.detailPlanifCourant.dureeJ),callback:function ($$v) {_vm.$set(_vm.detailPlanifCourant, "dureeJ", $$v)},expression:"detailPlanifCourant.dureeJ"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant du marché ()")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.detailPlanifCourant.montantNbr,"disabled":""},model:{value:(_vm.detailPlanifCourant.montantNbr),callback:function ($$v) {_vm.$set(_vm.detailPlanifCourant, "montantNbr", $$v)},expression:"detailPlanifCourant.montantNbr"}})],1)])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  Détails concernant les travaux\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("filter_2")])],1)],1),_vm._v(" "),_c('v-stepper',{model:{value:(_vm.etape),callback:function ($$v) {_vm.etape=$$v},expression:"etape"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.etape > 1}},[_vm._v("Détail des travaux à effectuer")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.etape > 2}},[_vm._v("Tâches à éffectuer")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux concerné par le projet "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{directives:[{name:"show",rawName:"v-show",value:(!_vm.readBtnModTrx),expression:"!readBtnModTrx"}],staticStyle:{"width":"100%"},attrs:{"clearable":"","disabled":_vm.readBtnModTrx,"filterable":"","placeholder":"Travaux concerné par le projet"},on:{"change":function($event){return _vm.loadTache()}},model:{value:(_vm.selectTravaux),callback:function ($$v) {_vm.selectTravaux=$$v},expression:"selectTravaux"}},_vm._l((_vm.listTravauxProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1),_vm._v(" "),_c('el-input',{directives:[{name:"show",rawName:"v-show",value:(_vm.readBtnModTrx),expression:"readBtnModTrx"}],staticStyle:{"width":"100%"},attrs:{"type":"text","name":"typeTravaux","disabled":_vm.readBtnModTrx,"placeholder":"Travaux concerné par le projet"},model:{value:( this.travauxCourant.libelle),callback:function ($$v) {_vm.$set(this.travauxCourant, "libelle", $$v)},expression:" this.travauxCourant.libelle"}})],1)]),_vm._v(" "),(_vm.readBtdTrx)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Sous Section  "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{directives:[{name:"show",rawName:"v-show",value:(!_vm.readBtnModTrx),expression:"!readBtnModTrx"}],staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Sous section"},on:{"change":function($event){return _vm.loadSousTache(_vm.selectSousTravaux)}},model:{value:(_vm.selectSousTravaux),callback:function ($$v) {_vm.selectSousTravaux=$$v},expression:"selectSousTravaux"}},_vm._l((_vm.listeSousTache),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1),_vm._v(" "),(_vm.travauxCourant.sousLibelle != '' && _vm.readBtnModTrx ==true)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"typeTravaux","disabled":_vm.readBtnModTrx,"placeholder":"Sous section"},model:{value:( this.travauxCourant.sousLibelle),callback:function ($$v) {_vm.$set(this.travauxCourant, "sousLibelle", $$v)},expression:" this.travauxCourant.sousLibelle"}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début  "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateD","format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de fin"},model:{value:(_vm.travauxCourant.dateDebut),callback:function ($$v) {_vm.$set(_vm.travauxCourant, "dateDebut", $$v)},expression:"travauxCourant.dateDebut"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin  "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateF","id":"dateFTrx","format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","placeholder":"Date de fin","type":"date","required":""},model:{value:(_vm.travauxCourant.dateFin),callback:function ($$v) {_vm.$set(_vm.travauxCourant, "dateFin", $$v)},expression:"travauxCourant.dateFin"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chef des travaux  "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Chef des travaux"},model:{value:(_vm.selectChefTravaux),callback:function ($$v) {_vm.selectChefTravaux=$$v},expression:"selectChefTravaux"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)])],1),_vm._v(" "),(
                        _vm.chantierCourant.soutraite == 0 || _vm.dialogEdit == true
                      )?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Sous-traiter ?")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Sous-traiter"},model:{value:(_vm.selectSoustraite),callback:function ($$v) {_vm.selectSoustraite=$$v},expression:"selectSoustraite"}},_vm._l((_vm.etatSoutraitance),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)])],1):_vm._e(),_vm._v(" "),(_vm.chantierCourant.soutraite == 1)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Soutraitance")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.chantierCourant.soutraiteLibelle,"disabled":""},model:{value:(_vm.chantierCourant.soutraiteLibelle),callback:function ($$v) {_vm.$set(_vm.chantierCourant, "soutraiteLibelle", $$v)},expression:"chantierCourant.soutraiteLibelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Sous-traitant")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.chantierCourant.fournisseur,"disabled":""},model:{value:(_vm.chantierCourant.fournisseur),callback:function ($$v) {_vm.$set(_vm.chantierCourant, "fournisseur", $$v)},expression:"chantierCourant.fournisseur"}})],1)])],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"description","type":"textarea","rows":5},model:{value:(_vm.descriptionTravaux),callback:function ($$v) {_vm.descriptionTravaux=$$v},expression:"descriptionTravaux"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogTravaux = false}}},[_vm._v("\n                        Annuler\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.disabledBtnContTrx)?_c('v-btn',{attrs:{"icons":"","disabled":!_vm.disabledBtnContTrx,"color":"primary"},on:{"click":function($event){_vm.calculMntTache();
                          _vm.etape += 1;}}},[_vm._v("\n                        Continuer\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Début des travaux  "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%","font-size":"22px"},attrs:{"value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","placeholder":"Date de début","readonly":true},model:{value:(_vm.travauxCourant.dateDebut),callback:function ($$v) {_vm.$set(_vm.travauxCourant, "dateDebut", $$v)},expression:"travauxCourant.dateDebut"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Fin des travaux  "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%","font-size":"22px"},attrs:{"value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","placeholder":"Date de fin","readonly":true},model:{value:(_vm.travauxCourant.dateFin),callback:function ($$v) {_vm.$set(_vm.travauxCourant, "dateFin", $$v)},expression:"travauxCourant.dateFin"}})],1)])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                        Ajouter des tâches\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("filter_2")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (HT):\n                            "+_vm._s(new Intl.NumberFormat().format(_vm.totalHT)))])])],1)],1),_vm._v(" "),_vm._l((_vm.optionTache),function(optionT,index){return _c('v-layout',{key:optionT.key,attrs:{"row":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.readBtnModTrx),expression:"readBtnModTrx"}],attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ordre")]),_vm._v(" "),_c('el-input',{attrs:{"prop":'optionTache.' + index + '.ordre',"readonly":!_vm.readBtnModTrx},model:{value:(optionT.ordre),callback:function ($$v) {_vm.$set(optionT, "ordre", $$v)},expression:"optionT.ordre"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tâche")]),_vm._v(" "),_c('el-input',{attrs:{"prop":'optionTache.' + index + '.tache',"readonly":!_vm.readBtnModTrx},model:{value:(optionT.libelle),callback:function ($$v) {_vm.$set(optionT, "libelle", $$v)},expression:"optionT.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"min":0,"value":"unite","prop":'optionTache.' + index + '.unite',"placeholder":"Unité","readonly":!_vm.readBtnModTrx},model:{value:(optionT.unite),callback:function ($$v) {_vm.$set(optionT, "unite", $$v)},expression:"optionT.unite"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début   "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"id":"dateD","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","prop":'optionTache.' + index + '.dateDebut',"placeholder":"Date de début","type":"date","required":""},model:{value:(optionT.dateDebut),callback:function ($$v) {_vm.$set(optionT, "dateDebut", $$v)},expression:"optionT.dateDebut"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"id":"dateF","value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","prop":'optionTache.' + index + '.dateFin',"placeholder":"Date de fin","type":"date","required":""},model:{value:(optionT.dateFin),callback:function ($$v) {_vm.$set(optionT, "dateFin", $$v)},expression:"optionT.dateFin"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":0,"value":"prix HT","prop":'optionTache.' + index + '.prix',"placeholder":"Prix","readonly":!_vm.readBtnModTrx},model:{value:(optionT.prix),callback:function ($$v) {_vm.$set(optionT, "prix", $$v)},expression:"optionT.prix"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":1,"value":"qte","prop":'optionTache.' + index + '.qte',"placeholder":"Quantité","readonly":!_vm.readBtnModTrx},on:{"change":function($event){return _vm.calculTotalTache(index)}},model:{value:(optionT.qte),callback:function ($$v) {_vm.$set(optionT, "qte", $$v)},expression:"optionT.qte"}})],1)]),_vm._v(" "),_c('v-flex',{staticClass:"mr-4",attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Total (HT)")]),_vm._v(" "),_c('p',[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"prop":'optionTache.' + index + '.total',"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v(_vm._s(new Intl.NumberFormat().format(optionT.total)))])])],1)])]),_vm._v(" "),_c('v-flex',{staticClass:"ml-4",attrs:{"md1":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.preventDefault();return _vm.removeTache(optionT)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("Supprime\n                        ")],1)],1)],1)}),_vm._v(" "),(_vm.readBtnModTrx)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addTacheComm()}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',[_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogTravaux = false}}},[_vm._v("\n                        Annuler\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){_vm.etape -= 1}}},[_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_left")]),_vm._v("Précédent\n                      ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-btn',{attrs:{"color":"primary","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.submitTravaux()}}},[_vm._v("\n                        Enregistrer\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-btn',{attrs:{"color":"primary","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.submitEditTravaux(_vm.travauxCourant.id)}}},[_vm._v("\n                        Enregistrer\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e()],1)],2)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogComm),callback:function ($$v) {_vm.dialogComm=$$v},expression:"dialogComm"}},[_c('v-card',[_c('v-toolbar',{staticClass:"indigo",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit !== true)?_c('span',[_vm._v("Recueille de besoin pour les travaux du chantier\n              "+_vm._s(_vm.travauxCourant.chantier))]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modifier le recueille de besoin\n              "+_vm._s(_vm.commandeCourant.libelle))]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogComm = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEdit !== true)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"indigo"}},[_vm._v("\n                Recueillir les besoins pour la travaux\n                "+_vm._s(_vm.travauxCourant.libelle)+"\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"indigo"}},[_vm._v("\n                Modification du recueille de besoin\n                "+_vm._s(_vm.commandeCourant.libelle)+"\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1):_vm._e()],1),_vm._v(" "),_c('el-form',{ref:"formComm",staticClass:"demo-ruleForm",attrs:{"model":_vm.FormComm,"rules":_vm.rulesComm,"id":"formComm"}},[_c('v-layout',{attrs:{"row":""}},[(_vm.dialogEdit !== true)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chantier concerné")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.travauxCourant.chantier,"disabled":""},model:{value:(_vm.travauxCourant.chantier),callback:function ($$v) {_vm.$set(_vm.travauxCourant, "chantier", $$v)},expression:"travauxCourant.chantier"}})],1)]):_vm._e(),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.travauxCourant.libelle,"disabled":""},model:{value:(_vm.travauxCourant.libelle),callback:function ($$v) {_vm.$set(_vm.travauxCourant, "libelle", $$v)},expression:"travauxCourant.libelle"}})],1)]):_vm._e(),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Durée (Jours)")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.travauxCourant.duree,"disabled":""},model:{value:(_vm.travauxCourant.duree),callback:function ($$v) {_vm.$set(_vm.travauxCourant, "duree", $$v)},expression:"travauxCourant.duree"}})],1)]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Libellé")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.commandeCourant.libelle,"disabled":""},model:{value:(_vm.commandeCourant.libelle),callback:function ($$v) {_vm.$set(_vm.commandeCourant, "libelle", $$v)},expression:"commandeCourant.libelle"}})],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Fournisseur")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Prestataire"},model:{value:(_vm.FormComm.fournisseur),callback:function ($$v) {_vm.$set(_vm.FormComm, "fournisseur", $$v)},expression:"FormComm.fournisseur"}},_vm._l((_vm.listPrestataire),function(item){return _c('el-option',{key:item.idPres,attrs:{"label":item.libelle,"value":item.idPres}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md11":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"indigo"}},[_vm._v("\n                      Ajouter des lignes des besoins\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","small":"","dark":""},on:{"click":_vm.addOptionComm}},[_c('v-icon',[_vm._v("add")])],1)],1)],1),_vm._v(" "),_vm._l((_vm.FormComm.optionCommande),function(optionC){return _c('v-layout',{key:optionC.key,attrs:{"row":"","prop":"optionCommande"}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Produit")]),_vm._v(" "),_c('el-form-item',[_c('el-autocomplete',{staticStyle:{"width":"100%"},attrs:{"fetch-suggestions":_vm.loadProduit,"name":"produit","placeholder":"Produit","required":""},model:{value:(optionC.produit),callback:function ($$v) {_vm.$set(optionC, "produit", $$v)},expression:"optionC.produit"}})],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md5":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité")]),_vm._v(" "),_c('el-form-item',[_c('el-input',{attrs:{"type":"number","min":"1"},model:{value:(optionC.qte),callback:function ($$v) {_vm.$set(optionC, "qte", $$v)},expression:"optionC.qte"}})],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.preventDefault();return _vm.removeOptionComm(optionC)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("Supprimer\n                  ")],1)],1)],1)}),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogComm = false}}},[_vm._v("\n                Annuler\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.submitComm('formComm')}}},[_vm._v("\n                Enregistrer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],2)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogPlanifProduit),callback:function ($$v) {_vm.dialogPlanifProduit=$$v},expression:"dialogPlanifProduit"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Planification des Besoins Matériels / Matériaux pour la tâche\n              "+_vm._s(_vm.tacheCourante.libelle))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogPlanifProduit = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début de la tâche")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.tacheCourante.dateD,"disabled":""},model:{value:(_vm.tacheCourante.dateD),callback:function ($$v) {_vm.$set(_vm.tacheCourante, "dateD", $$v)},expression:"tacheCourante.dateD"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin de la tâche")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.tacheCourante.dateF,"disabled":""},model:{value:(_vm.tacheCourante.dateF),callback:function ($$v) {_vm.$set(_vm.tacheCourante, "dateF", $$v)},expression:"tacheCourante.dateF"}})],1)])],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-form',{ref:"formPlanifProduit",attrs:{"lazy-validation":"","id":"formPlanifProduit"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('el-alert',{attrs:{"title":'Veuillez Sélectionner la tâche',"type":"warning","center":"","closable":false,"show-icon":""}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md18":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tâches*")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Tache"},model:{value:(_vm.tacheS),callback:function ($$v) {_vm.tacheS=$$v},expression:"tacheS"}},_vm._l((_vm.listeTacheTrx),function(item){return _c('el-option',{key:item.idTache,attrs:{"label":item.libelle,"value":item.idTache}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-3":"","mb-1":""}},[_c('el-alert',{attrs:{"title":'Veuillez Sélectionner les Engins',"type":"warning","center":"","closable":false,"show-icon":""}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Vehicule/Engin *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"prodSelctEngin","id":"prodSelctEngin","clearable":"","filterable":"","placeholder":"Immatriculation du véhicule"},on:{"change":function($event){return _vm.loadProdVehicule(_vm.prodSelctEngin)}},model:{value:(_vm.prodSelctEngin),callback:function ($$v) {_vm.prodSelctEngin=$$v},expression:"prodSelctEngin"}},_vm._l((_vm.loptionVehicule),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"name":"selectEnginQte","placeholder":"Quantité"},model:{value:(_vm.selectEnginQte),callback:function ($$v) {_vm.selectEnginQte=$$v},expression:"selectEnginQte"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Période*")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"datetimerange","range-separator":"au","start-placeholder":"Début date","end-placeholder":"Fin date"},model:{value:(_vm.periodeEngin),callback:function ($$v) {_vm.periodeEngin=$$v},expression:"periodeEngin"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Priorité *")]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Priorité"},model:{value:(_vm.selectEnginPriorite),callback:function ($$v) {_vm.selectEnginPriorite=$$v},expression:"selectEnginPriorite"}},_vm._l((_vm.priorites),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.label}})}),1)],1)])],1),_vm._v(" "),(_vm.prodSelctEngin != '' && this.selectEnginQte != 0)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"icons":"","color":"primary","id":"plus","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addOptionV()}}},[_c('v-icon',[_vm._v("add")])],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tabListEngin}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Vehicule/engin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantite","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"periode","label":"Période"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"priorite","label":"Priorité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteEnginRow(scope.$index, _vm.tabListEngin)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                        Supprimer cette ligne\n                                    ")],1)]}}])})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-3":"","mb-1":""}},[_c('el-alert',{attrs:{"title":'Veuillez Sélectionner les besoins en Matériels pour la tâche',"type":"warning","center":"","closable":false,"show-icon":""}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md2":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Type ressource *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"typeProduit","id":"typeProduit","clearable":"","filterable":"","placeholder":"Type ressource"},on:{"change":function($event){return _vm.loadTypeProduit(_vm.prodSelct)}},model:{value:(_vm.prodSelct),callback:function ($$v) {_vm.prodSelct=$$v},expression:"prodSelct"}},_vm._l((_vm.listTypeRessource),function(item){return _c('el-option',{key:item.libelle,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Produit *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Produit"},on:{"change":function($event){return _vm.loadUniteProduit(_vm.selectProduit)}},model:{value:(_vm.selectProduit),callback:function ($$v) {_vm.selectProduit=$$v},expression:"selectProduit"}},_vm._l((_vm.listProd),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.value,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"valeurUniteMateriel","readonly":true},model:{value:(_vm.valeurUniteMateriel),callback:function ($$v) {_vm.valeurUniteMateriel=$$v},expression:"valeurUniteMateriel"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"name":"selectQte","placeholder":"Quantité"},model:{value:(_vm.selectQte),callback:function ($$v) {_vm.selectQte=$$v},expression:"selectQte"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Priorité *")]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Priorité"},model:{value:(_vm.selectPriorite),callback:function ($$v) {_vm.selectPriorite=$$v},expression:"selectPriorite"}},_vm._l((_vm.priorites),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.label}})}),1)],1)])],1),_vm._v(" "),(_vm.selectProduit != '' && this.selectQte != 0)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"md12":""}},[_c('v-btn',{attrs:{"icons":"","color":"primary","id":"plus","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addListProduit()}}},[_c('v-icon',[_vm._v("add")])],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tabListProduit}},[_c('el-table-column',{attrs:{"prop":"type","label":"Type"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Produit"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantite","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"priorite","label":"Priorité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tabListProduit)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                        Supprimer cette ligne\n                                    ")],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":"","mt-3":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogPlanifProduit = false}}},[_vm._v("\n                    Annuler\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.tabListProduit.length !=0  || _vm.tabListEngin.length!= 0)?_c('v-btn',{attrs:{"icons":"","color":"primary","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.saveListe()}}},[_vm._v("\n                    Enregistrer\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"overlay":true,"scrollable":"","persistent":"","max-width":"92%"},model:{value:(_vm.showModalLoadPreparation),callback:function ($$v) {_vm.showModalLoadPreparation=$$v},expression:"showModalLoadPreparation"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Importation des ressources pour la planification de la tâche "+_vm._s(_vm.tacheCourante.libelle)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.showModalLoadPreparation =false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('data-tables',{attrs:{"data":_vm.lstPreparation,"width":"100%"}},[_c('el-table-column',{attrs:{"prop":"tache","label":"TACHES","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                          "+_vm._s(scope.row.tache)+"\n                                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ressource","label":"RESSOURCES","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                          "+_vm._s(scope.row.ressource)+"\n                                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantite","label":"QUANTITE","width":"500px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                                          "+_vm._s(scope.row.quantite)+"\n                                      ")])]}}])})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.showModalLoadPreparation = false}}},[_vm._v("\n                      Annuler\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.saveListe()}}},[_vm._v("\n                      Enregistrer\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogImport),callback:function ($$v) {_vm.dialogImport=$$v},expression:"dialogImport"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h4',{attrs:{"align":"center"}},[_vm._v("Nb: Le fichier contient uniquement les ressources qui figurent dans votre base de ressources.")]),_vm._v(" "),_c('h4',{attrs:{"align":"center"}},[_vm._v("Indiquer uniquement la 'QUANTITE' et la 'PRIORITE' de chaque ligne de produit que vous souhaitez.")]),_vm._v(" "),_c('h3',{attrs:{"align":"center"}},[_vm._v("Supprimer ensuite les lignes restantes dans votre fichier avant importation.")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogImport = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.generateFileExcel()}}},[_vm._v("Généner "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogEquipe),callback:function ($$v) {_vm.dialogEquipe=$$v},expression:"dialogEquipe"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit !== true)?_c('span',[_vm._v("Définir les équipes en fonction des tâches\n              "+_vm._s(_vm.tacheCourant.libelle))]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modifier le contrat de "+_vm._s(_vm.equipeCourant.executant))]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogEquipe = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEdit !== true)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                Attribuer des personnes à la tâche "+_vm._s(_vm.tacheCourant.tache)+"\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("person_add")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                Modification du contrat de\n                "+_vm._s(_vm.equipeCourant.executant)+" concernant la tâche\n                "+_vm._s(_vm.equipeCourant.tache)+"\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("person_add")])],1):_vm._e()],1),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tâche concerné")]),_vm._v(" "),_c('el-input',{attrs:{"value":_vm.tacheCourant.tacheLibelle,"disabled":""},model:{value:(_vm.tacheCourant.tacheLibelle),callback:function ($$v) {_vm.$set(_vm.tacheCourant, "tacheLibelle", $$v)},expression:"tacheCourant.tacheLibelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux concerné")]),_vm._v(" "),_c('el-input',{attrs:{"value":_vm.tacheCourant.travaux,"disabled":""},model:{value:(_vm.tacheCourant.travaux),callback:function ($$v) {_vm.$set(_vm.tacheCourant, "travaux", $$v)},expression:"tacheCourant.travaux"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.tacheCourant.dateDebut,"disabled":""},model:{value:(_vm.tacheCourant.dateDebut),callback:function ($$v) {_vm.$set(_vm.tacheCourant, "dateDebut", $$v)},expression:"tacheCourant.dateDebut"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.tacheCourant.dateFin,"disabled":""},model:{value:(_vm.tacheCourant.dateFin),callback:function ($$v) {_vm.$set(_vm.tacheCourant, "dateFin", $$v)},expression:"tacheCourant.dateFin"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Durée prévue (Jours)")]),_vm._v(" "),_c('el-input',{attrs:{"value":_vm.tacheCourant.duree,"disabled":""},model:{value:(_vm.tacheCourant.duree),callback:function ($$v) {_vm.$set(_vm.tacheCourant, "duree", $$v)},expression:"tacheCourant.duree"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Soustraitance")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.tacheCourant.soutraiteLibelle,"disabled":""},model:{value:(_vm.tacheCourant.soutraiteLibelle),callback:function ($$v) {_vm.$set(_vm.tacheCourant, "soutraiteLibelle", $$v)},expression:"tacheCourant.soutraiteLibelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Sous-traitant")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.tacheCourant.fournisseur,"disabled":""},model:{value:(_vm.tacheCourant.fournisseur),callback:function ($$v) {_vm.$set(_vm.tacheCourant, "fournisseur", $$v)},expression:"tacheCourant.fournisseur"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md11":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                    Ajouter des lignes\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("person_add")])],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","small":"","dark":""},on:{"click":_vm.addOptionEquipe}},[_c('v-icon',[_vm._v("add")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-form',{ref:"formEquipe",attrs:{"lazy-validation":"","id":"formEquipe"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary"},on:{"click":function($event){return _vm.showDialogAjoutOuvrier()}}},[_vm._v("\n                    Ressources techniques\n                    "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("add")])],1)],1),_vm._v(" "),_vm._l((_vm.optionEquipe),function(optionE){return (_vm.dialogEdit != true)?_c('v-layout',{key:optionE.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type d'éxecutant")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Type d'éxecutant"},model:{value:(optionE.selectType),callback:function ($$v) {_vm.$set(optionE, "selectType", $$v)},expression:"optionE.selectType"}},_vm._l((optionE.type),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),(optionE.selectType === 1)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Fournisseur")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Prestataire"},model:{value:(optionE.fournisseur),callback:function ($$v) {_vm.$set(optionE, "fournisseur", $$v)},expression:"optionE.fournisseur"}},_vm._l((_vm.listPrestataire),function(item){return _c('el-option',{key:item.idPres,attrs:{"label":item.libelle,"value":item.idPres}})}),1)],1)]):_vm._e(),_vm._v(" "),(optionE.selectType === 2)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ouvrier/Manoeuvre")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Ouvrier/Manoeuvre"},model:{value:(optionE.ouvrier),callback:function ($$v) {_vm.$set(optionE, "ouvrier", $$v)},expression:"optionE.ouvrier"}},_vm._l((_vm.listOuvrier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Durée")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"duree","range-separator":"à","format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","type":"daterange","start-placeholder":"Date de début","end-placeholder":"Date de fin","required":""},model:{value:(optionE.duree),callback:function ($$v) {_vm.$set(optionE, "duree", $$v)},expression:"optionE.duree"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant journalier(Ouvrier) /\n                        Forfait(Prestataire)")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","required":"","min":0},model:{value:(optionE.montant),callback:function ($$v) {_vm.$set(optionE, "montant", $$v)},expression:"optionE.montant"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant heures supplémentaires\n                        (Ouvrier/Prestataire)")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","min":0},model:{value:(optionE.montantSupp),callback:function ($$v) {_vm.$set(optionE, "montantSupp", $$v)},expression:"optionE.montantSupp"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.preventDefault();return _vm.removeOptionEquipe(optionE)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("Supprimer\n                    ")],1)],1)],1):_vm._e()}),_vm._v(" "),(_vm.dialogEdit)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type d'exécutant")]),_vm._v(" "),_c('el-input',{attrs:{"value":_vm.equipeCourant.typeExec,"disabled":""},model:{value:(_vm.equipeCourant.typeExec),callback:function ($$v) {_vm.$set(_vm.equipeCourant, "typeExec", $$v)},expression:"equipeCourant.typeExec"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Exécutant")]),_vm._v(" "),_c('el-input',{attrs:{"value":_vm.equipeCourant.executant,"disabled":""},model:{value:(_vm.equipeCourant.executant),callback:function ($$v) {_vm.$set(_vm.equipeCourant, "executant", $$v)},expression:"equipeCourant.executant"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateD","value-format":"dd-MM-yyyy","type":"date","required":""},model:{value:(_vm.dateDContrat),callback:function ($$v) {_vm.dateDContrat=$$v},expression:"dateDContrat"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateF","format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","type":"date","required":""},model:{value:(_vm.dateFContrat),callback:function ($$v) {_vm.dateFContrat=$$v},expression:"dateFContrat"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant / Jour")]),_vm._v(" "),_c('el-input',{attrs:{"name":"montant","type":"number","min":0},model:{value:(_vm.montantContrat),callback:function ($$v) {_vm.montantContrat=$$v},expression:"montantContrat"}})],1)])],1):_vm._e()],2)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogEquipe = false}}},[_vm._v("\n              Annuler\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-btn',{attrs:{"icons":"","color":"primary","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.submitEquipe()}}},[_vm._v("\n              Enregistrer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e(),_vm._v(" "),(
                _vm.dialogEdit &&
                  _vm.dateDContrat !== null &&
                  _vm.dateFContrat !== null &&
                  _vm.montantContrat !== 0
              )?_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.submitEquipe()}}},[_vm._v("\n              Modifier\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogDupliqueChantier),callback:function ($$v) {_vm.dialogDupliqueChantier=$$v},expression:"dialogDupliqueChantier"}},[_c('v-card',[_c('v-toolbar',{staticClass:"teal",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Dupliquer les chantier du projet suivant\n              "+_vm._s(_vm.projetCourant.libelle))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogDupliqueChantier = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"teal"}},[_vm._v("\n                Dupliquer les chantiers sélectionnés\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_copy")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.projetCourant.libelle,"disabled":""},model:{value:(_vm.projetCourant.libelle),callback:function ($$v) {_vm.$set(_vm.projetCourant, "libelle", $$v)},expression:"projetCourant.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de projet")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.projetCourant.type,"disabled":""},model:{value:(_vm.projetCourant.type),callback:function ($$v) {_vm.$set(_vm.projetCourant, "type", $$v)},expression:"projetCourant.type"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début *")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.projetCourant.dateD,"disabled":""},model:{value:(_vm.projetCourant.dateD),callback:function ($$v) {_vm.$set(_vm.projetCourant, "dateD", $$v)},expression:"projetCourant.dateD"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin *")]),_vm._v(" "),_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.projetCourant.dateF,"disabled":""},model:{value:(_vm.projetCourant.dateF),callback:function ($$v) {_vm.$set(_vm.projetCourant, "dateF", $$v)},expression:"projetCourant.dateF"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                    ATTENTION ! Cette action ne fait l'objet d'aucune remise a\n                    niveau\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_copy")])],1)],1)])],1),_vm._v(" "),_c('v-form',{ref:"formDupliqueChantier",attrs:{"lazy-validation":"","id":"formDupliqueChantier"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},_vm._l((_vm.optionDuplique),function(optionE){return _c('v-layout',{key:optionE.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Référence")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","value":optionE.ref,"disabled":""},model:{value:(optionE.ref),callback:function ($$v) {_vm.$set(optionE, "ref", $$v)},expression:"optionE.ref"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chantier")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","value":optionE.libelle,"disabled":""},model:{value:(optionE.libelle),callback:function ($$v) {_vm.$set(optionE, "libelle", $$v)},expression:"optionE.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date début")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","value":optionE.dateD,"disabled":""},model:{value:(optionE.dateD),callback:function ($$v) {_vm.$set(optionE, "dateD", $$v)},expression:"optionE.dateD"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date fin")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","value":optionE.dateF,"disabled":""},model:{value:(optionE.dateF),callback:function ($$v) {_vm.$set(optionE, "dateF", $$v)},expression:"optionE.dateF"}})],1)])],1)}),1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogDupliqueChantier = false}}},[_vm._v("\n              Annuler\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.submitDupliqueChantier()}}},[_vm._v("\n              Enregistrer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogDemarer),callback:function ($$v) {_vm.dialogDemarer=$$v},expression:"dialogDemarer"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Démarrer de nouvelles tâches")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogDemarer = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formDemarer",attrs:{"lazy-validation":"","id":"formDemarer"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      Marquer le démarrage des tâches des travaux\n                      "+_vm._s(_vm.travauxCourant.libelle)+"\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("touch_app")])],1)],1)])],1),_vm._v(" "),_vm._l((_vm.optionDemarer),function(optionD){return _c('v-layout',{key:optionD.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tâche")]),_vm._v(" "),_c('el-input',{attrs:{"value":optionD.tache,"placeholder":"Tâche","disabled":""},model:{value:(optionD.tache),callback:function ($$v) {_vm.$set(optionD, "tache", $$v)},expression:"optionD.tache"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type d'exécutant")]),_vm._v(" "),_c('el-input',{attrs:{"value":optionD.typeExec,"placeholder":"Tâche","disabled":""},model:{value:(optionD.typeExec),callback:function ($$v) {_vm.$set(optionD, "typeExec", $$v)},expression:"optionD.typeExec"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Exécutant")]),_vm._v(" "),_c('el-input',{attrs:{"value":optionD.executant,"placeholder":"Exécutant","disabled":""},model:{value:(optionD.executant),callback:function ($$v) {_vm.$set(optionD, "executant", $$v)},expression:"optionD.executant"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Durée (Jours)")]),_vm._v(" "),_c('el-input',{attrs:{"value":optionD.duree,"placeholder":"Durée (Jours)","disabled":""},model:{value:(optionD.duree),callback:function ($$v) {_vm.$set(optionD, "duree", $$v)},expression:"optionD.duree"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début")]),_vm._v(" "),_c('el-date-picker',{attrs:{"format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","type":"date","required":""},model:{value:(optionD.date),callback:function ($$v) {_vm.$set(optionD, "date", $$v)},expression:"optionD.date"}})],1)])],1)}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogDemarer = false}}},[_vm._v("\n                Annuler\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.submitDemarrer()}}},[_vm._v("\n                Enregistrer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],2)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogDemarerTravaux),callback:function ($$v) {_vm.dialogDemarerTravaux=$$v},expression:"dialogDemarerTravaux"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Démarrer les travaux "+_vm._s(_vm.travauxCourant.libelle))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogDemarerTravaux = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formDemarerTravaux",attrs:{"lazy-validation":"","id":"formDemarerTravaux"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      Marquer le démarrage des travaux\n                      "+_vm._s(_vm.travauxCourant.libelle)+"\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("touch_app")])],1)],1)])],1),_vm._v(" "),_vm._l((_vm.optionDemarer),function(optionD){return _c('v-layout',{key:optionD.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tâche")]),_vm._v(" "),_c('el-input',{attrs:{"value":optionD.tacheLibelle,"placeholder":"Tâche","disabled":""},model:{value:(optionD.tacheLibelle),callback:function ($$v) {_vm.$set(optionD, "tacheLibelle", $$v)},expression:"optionD.tacheLibelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Exécutant")]),_vm._v(" "),_c('el-input',{attrs:{"value":_vm.travauxCourant.fournisseur,"placeholder":"Exécutant","disabled":""},model:{value:(_vm.travauxCourant.fournisseur),callback:function ($$v) {_vm.$set(_vm.travauxCourant, "fournisseur", $$v)},expression:"travauxCourant.fournisseur"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Durée (Jours)")]),_vm._v(" "),_c('el-input',{attrs:{"value":optionD.duree,"placeholder":"Durée (Jours)","disabled":""},model:{value:(optionD.duree),callback:function ($$v) {_vm.$set(optionD, "duree", $$v)},expression:"optionD.duree"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début")]),_vm._v(" "),_c('el-date-picker',{attrs:{"format":"dd-MM-yyyy","value-format":"dd-MM-yyyy","type":"date","required":""},model:{value:(optionD.date),callback:function ($$v) {_vm.$set(optionD, "date", $$v)},expression:"optionD.date"}})],1)])],1)}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogDemarerTravaux = false}}},[_vm._v("\n                Annuler\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.submitDemarrerTravaux()}}},[_vm._v("\n                Enregistrer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],2)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogRapport),callback:function ($$v) {_vm.dialogRapport=$$v},expression:"dialogRapport"}},[_c('v-card',[_c('v-toolbar',{staticClass:"orange",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Rapport de la journée de travail")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogRapport = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formRapport",attrs:{"lazy-validation":"","id":"formRapport"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                  Ajouter le rapport de cette journée de travail\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("description")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"}),_vm._v(" "),_c('el-slider',{staticStyle:{"width":"100%"},attrs:{"name":"evolution","show-input":""},model:{value:(_vm.evolution),callback:function ($$v) {_vm.evolution=$$v},expression:"evolution"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{attrs:{"name":"description","rows":10,"type":"textarea"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ajouter des fichiers")]),_vm._v(" "),_c('el-upload',{ref:"uploadRapport",staticClass:"upload-demo",attrs:{"name":"fichier[]","action":"","auto-upload":false,"file-list":_vm.fichier,"list-type":"picture","multiple":""}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("\n                        CLIQUER ICI\n                        "),_c('i',{staticClass:"el-icon-picture"})])],1)],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogRapport = false}}},[_vm._v("\n                Annuler\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.description !== '')?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.submitRapport()}}},[_vm._v("\n                Enregistrer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogMultipleRapport),callback:function ($$v) {_vm.dialogMultipleRapport=$$v},expression:"dialogMultipleRapport"}},[_c('v-card',[_c('v-toolbar',{staticClass:"orange",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Rapport multiple des travaux")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogMultipleRapport = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                Sélectionner les travaux concernés\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("description")])],1)],1),_vm._v(" "),_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-form',{ref:"formSearchPlanifSuivi",attrs:{"lazy-validation":"","id":"formSearchPlanifSuivi"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Chantier"},on:{"change":function($event){return _vm.loadTravauxSuivi()}},model:{value:(_vm.selectChantierRapport),callback:function ($$v) {_vm.selectChantierRapport=$$v},expression:"selectChantierRapport"}},_vm._l((_vm.listChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Travaux"},model:{value:(_vm.selectTravauxRapport),callback:function ($$v) {_vm.selectTravauxRapport=$$v},expression:"selectTravauxRapport"}},_vm._l((_vm.listTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-btn',{attrs:{"icons":"","color":"blue","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.loadTravauxSuivie()}}},[_c('v-icon',[_vm._v("search")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-form',{ref:"formRapportMultiple",attrs:{"lazy-validation":"","id":"formRapportMultiple"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},_vm._l((_vm.optionRapport),function(optionR){return _c('v-layout',{key:optionR.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ordre")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":optionR.ordre,"disabled":""},model:{value:(optionR.ordre),callback:function ($$v) {_vm.$set(optionR, "ordre", $$v)},expression:"optionR.ordre"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tâche")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","value":optionR.tache,"disabled":""},model:{value:(optionR.tache),callback:function ($$v) {_vm.$set(optionR, "tache", $$v)},expression:"optionR.tache"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Evolution")]),_vm._v(" "),_c('el-slider',{staticStyle:{"width":"100%"},attrs:{"name":"evolution","show-input":""},model:{value:(optionR.evolution),callback:function ($$v) {_vm.$set(optionR, "evolution", $$v)},expression:"optionR.evolution"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{attrs:{"name":"description","type":"textarea"},model:{value:(optionR.description),callback:function ($$v) {_vm.$set(optionR, "description", $$v)},expression:"optionR.description"}})],1)])],1)}),1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogMultipleRapport = false}}},[_vm._v("\n              Annuler\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.optionRapport.length != 0)?_c('v-btn',{attrs:{"icons":"","color":"primary","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.submitRapportMultiple()}}},[_vm._v("\n              Enregistrer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogValid),callback:function ($$v) {_vm.dialogValid=$$v},expression:"dialogValid"}},[_c('v-card',[_c('v-toolbar',{staticClass:"green",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Valider les travaux éffectués")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogValid = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formValid",attrs:{"lazy-validation":"","id":"formValid"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                  Validation des travaux éffectués\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done_all")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Réponse")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Type d'éxecutant"},model:{value:(_vm.selectReponse),callback:function ($$v) {_vm.selectReponse=$$v},expression:"selectReponse"}},_vm._l((_vm.reponseValid),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{attrs:{"name":"description","rows":10,"type":"textarea"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogValid = false}}},[_vm._v("\n                Annuler\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.selectReponse !== null)?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":_vm.loading,"dark":""},on:{"click":_vm.submitValid}},[_vm._v("\n                Enregistrer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogValidCommande),callback:function ($$v) {_vm.dialogValidCommande=$$v},expression:"dialogValidCommande"}},[_c('v-card',[_c('v-toolbar',{staticClass:"green",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Valider le recueil de besoins "+_vm._s(_vm.commandeCourant.libelle))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogValidCommande = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formValidCommande",attrs:{"lazy-validation":"","id":"formValidCommande"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                  Validation du recueil de besoin\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done_all")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Réponse")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Réponse"},model:{value:(_vm.selectReponse),callback:function ($$v) {_vm.selectReponse=$$v},expression:"selectReponse"}},_vm._l((_vm.reponseValid),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{attrs:{"name":"description","rows":5,"type":"textarea"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogValidCommande = false}}},[_vm._v("\n                Annuler\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.selectReponse !== null)?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":_vm.loading,"dark":""},on:{"click":_vm.submitValidCommande}},[_vm._v("\n                Enregistrer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("\n            Voulez-vous vraiment supprimer cet enrégistrement ?\n          ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("\n              Annuler\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteProjet()}}},[_vm._v("\n              Supprimer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprCharge),callback:function ($$v) {_vm.dialogSuprCharge=$$v},expression:"dialogSuprCharge"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("\n            Voulez-vous vraiment supprimer cet enrégistrement ?\n          ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprCharge = false}}},[_vm._v("\n              Annuler\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteCharge()}}},[_vm._v("\n              Supprimer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprRessource),callback:function ($$v) {_vm.dialogSuprRessource=$$v},expression:"dialogSuprRessource"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("\n            Voulez-vous vraiment supprimer cet enrégistrement ?\n          ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprRessource = false}}},[_vm._v("\n              Annuler\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteRessources()}}},[_vm._v("\n              Supprimer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowEditRessource),callback:function ($$v) {_vm.dialogShowEditRessource=$$v},expression:"dialogShowEditRessource"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Modifier la quantité du produit de la tâche\n            "+_vm._s(_vm.tacheSelectioner.tacheLibelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialogShowEditRessource = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('el-form',{ref:"formEditRessource",staticClass:"demo-form-inline",attrs:{"id":"formEditRessource","label-width":"90px","model":_vm.formEditRessource}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Produit"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"libelle","disabled":""},model:{value:(_vm.formEditRessource.libelle),callback:function ($$v) {_vm.$set(_vm.formEditRessource, "libelle", $$v)},expression:"formEditRessource.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Quantité","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","name":"qte","min":0},model:{value:(_vm.newQteRessource),callback:function ($$v) {_vm.newQteRessource=$$v},expression:"newQteRessource"}})],1)],1)],1),_vm._v(" "),(_vm.tacheSelectioner.typeProduit == 'VEHICULE')?_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"required":"","label":"Date debut"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"date","name":"dateD"},model:{value:(_vm.formEditRessource.dateD),callback:function ($$v) {_vm.$set(_vm.formEditRessource, "dateD", $$v)},expression:"formEditRessource.dateD"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date fin","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"date","name":"dateF"},model:{value:(_vm.formEditRessource.dateF),callback:function ($$v) {_vm.$set(_vm.formEditRessource, "dateF", $$v)},expression:"formEditRessource.dateF"}})],1)],1)],1):_vm._e()],1)],1)])])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{staticClass:"text-xs-right",attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.resetFormEditRess()}},slot:"activator"},[_vm._v("\n              Fermer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("Fermer\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","disabled":_vm.loading,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.sumbitRessource(_vm.tacheSelectioner)}},slot:"activator"},[_vm._v("\n              Enregistrer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1),_vm._v("Enregistrer\n          ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowInfoRessource),callback:function ($$v) {_vm.dialogShowInfoRessource=$$v},expression:"dialogShowInfoRessource"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du produit de la tâche\n            "+_vm._s(_vm.tacheSelectioner.tacheLibelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialogShowInfoRessource = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('el-form',{ref:"formInfoRessource",staticClass:"demo-form-inline",attrs:{"id":"formInfoRessource","label-width":"90px","model":_vm.formInfoRessource}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Produit"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"libelle","disabled":""},model:{value:(_vm.formInfoRessource.libelle),callback:function ($$v) {_vm.$set(_vm.formInfoRessource, "libelle", $$v)},expression:"formInfoRessource.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Quantité"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","name":"qte","min":0,"disabled":""},model:{value:(_vm.formInfoRessource.qte),callback:function ($$v) {_vm.$set(_vm.formInfoRessource, "qte", $$v)},expression:"formInfoRessource.qte"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date debut"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"dateD","disabled":""},model:{value:(_vm.formInfoRessource.dateD),callback:function ($$v) {_vm.$set(_vm.formInfoRessource, "dateD", $$v)},expression:"formInfoRessource.dateD"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date fin"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"dateF","disabled":""},model:{value:(_vm.formInfoRessource.dateF),callback:function ($$v) {_vm.$set(_vm.formInfoRessource, "dateF", $$v)},expression:"formInfoRessource.dateF"}})],1)],1)],1)],1)],1)])])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{staticClass:"text-xs-right",attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.resetFormInfoRess()}},slot:"activator"},[_vm._v("\n              Fermer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("Fermer\n          ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprChantier),callback:function ($$v) {_vm.dialogSuprChantier=$$v},expression:"dialogSuprChantier"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("\n            Voulez-vous vraiment supprimer cet enrégistrement ?\n          ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprChantier = false}}},[_vm._v("\n              Annuler\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteChantier()}}},[_vm._v("\n              Supprimer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),(_vm.droitAcces.delete_travaux)?_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprTravaux),callback:function ($$v) {_vm.dialogSuprTravaux=$$v},expression:"dialogSuprTravaux"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("\n            Voulez-vous vraiment supprimer cet enrégistrement ?\n          ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprTravaux = false}}},[_vm._v("\n              Annuler\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteTravaux()}}},[_vm._v("\n              Supprimer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.delete_tache)?_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprTache),callback:function ($$v) {_vm.dialogSuprTache=$$v},expression:"dialogSuprTache"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("\n            Voulez-vous vraiment supprimer cet enrégistrement ?\n          ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprTache = false}}},[_vm._v("\n              Annuler\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteTache()}}},[_vm._v("\n              Supprimer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"70%"},model:{value:(_vm.dialogAjoutOuvrier),callback:function ($$v) {_vm.dialogAjoutOuvrier=$$v},expression:"dialogAjoutOuvrier"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter une ressources personnelles")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutOuvrier = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-container',[_c('el-form',{ref:"formManoeuvre",attrs:{"label-position":"right","model":_vm.formManoeuvre,"rules":_vm.rulesformManoeuvre,"id":"formManoeuvre","label-width":"120px"}},[_c('el-row',[_c('el-col',{attrs:{"span":4}},[_c('a',{attrs:{"href":_vm.logoOuvrier,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoOuvrier,"alt":"avatar"}})]),_c('br')],1),_vm._v(" "),_c('input',{ref:"fileOuvrier",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageOuvrierPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileOuvrier.click()}}},[_vm._v("Photo "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-form-item',{attrs:{"label":"Domicile","prop":"domicile"}},[_c('el-input',{model:{value:(_vm.formManoeuvre.domicile),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "domicile", $$v)},expression:"formManoeuvre.domicile"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-form-item',{attrs:{"label":"Nom","prop":"nom"}},[_c('el-input',{model:{value:(_vm.formManoeuvre.nom),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "nom", $$v)},expression:"formManoeuvre.nom"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-form-item',{attrs:{"label":"Profession","prop":"profession"}},[_c('el-input',{model:{value:(_vm.formManoeuvre.profession),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "profession", $$v)},expression:"formManoeuvre.profession"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-form-item',{attrs:{"label":"Type de piece","prop":"piece"}},[_c('el-input',{model:{value:(_vm.formManoeuvre.piece),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "piece", $$v)},expression:"formManoeuvre.piece"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"NumPiece","prop":"numPiece"}},[_c('el-input',{model:{value:(_vm.formManoeuvre.numPiece),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "numPiece", $$v)},expression:"formManoeuvre.numPiece"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Contact","prop":"contact"}},[_c('el-input',{model:{value:(_vm.formManoeuvre.contact),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "contact", $$v)},expression:"formManoeuvre.contact"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Date de naissance","prop":"dateNaiss"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"date","placeholder":"Date de naissance"},model:{value:(_vm.formManoeuvre.dateNaiss),callback:function ($$v) {_vm.$set(_vm.formManoeuvre, "dateNaiss", $$v)},expression:"formManoeuvre.dateNaiss"}})],1)],1),_vm._v(" "),_c('small',{staticClass:"red--text"},[_vm._v("*Champs obligatoire")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialogAjoutOuvrier = false}}},[_vm._v("Fermer")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.submitformManoeuvre('formManoeuvre')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-content',{staticClass:"blue lighten-4 elevation-18"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n          Cliquez pour afficher les chantiers la carte\n          "),_c('v-icon',[_vm._v("map")])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('ProjetMap',{attrs:{"show":_vm.showModalMap,"listMarqueur":_vm.dataMarqueurProj},on:{"close":function($event){_vm.showModalMap = false}}})],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-card',[_c('div',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n          LISTE DES PROJETS\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("terrain")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-layout',{attrs:{"row":""}},[(
                _vm.droitAcces.imprime_pdf_histo_liste_projet ||
                  _vm.droitAcces.imprime_exc_histo_liste_projet
              )?_c('v-flex',[_c('el-popover',{ref:"popProjet",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[(_vm.droitAcces.imprime_pdf_histo_liste_projet)?_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisProjets('PDF')}}},[_vm._v("PDF\n                  ")]):_vm._e(),_vm._v(" "),(_vm.droitAcces.imprime_exc_histo_liste_projet)?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisProjets('EXC')}}},[_vm._v("EXCEL\n                    ")]):_vm._e()],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popProjet",arg:"popProjet"}],attrs:{"type":"warning","disabled":_vm.disabledBtnPop,"icon":"el-icon-printer"}},[_vm._v("Rapport")])],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.new_projet)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.ajoutProjet('new');_vm.loadCaisse()
                  _vm.logoProjet = '/static/img-doc.png';}},slot:"activator"},[_vm._v("\n                  Ajouter\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e(),_vm._v("Ajouter un nouveau projet\n              ")],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","color":"primary","small":"","dark":""},on:{"click":function($event){_vm.dialogAide = _vm.listTravauxProjet;
                  _vm.fichierProj.splice(0);}}},[_c('v-icon',[_vm._v("help_outline")])],1),_vm._v(" "),_c('v-bottom-sheet',{model:{value:(_vm.dialogAide),callback:function ($$v) {_vm.dialogAide=$$v},expression:"dialogAide"}},[_c('v-list',[_c('v-subheader',[_vm._v("Creer un projet")]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-title',[_vm._v("1-Creer un projet")])],1)],1),_vm._v(" "),_c('v-list',[_c('v-subheader',[_vm._v("Menu preparation Chantier")]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-title',[_vm._v("2-Creer les chantiers")])],1)],1)],1)],1)],1)],1),_vm._v(" "),(
            _vm.droitAcces.projet_index ||
              _vm.droitAcces.projet_index_chefProjet ||
              _vm.droitAcces.projet_index_chefEtude ||
              _vm.droitAcces.projet_index_chefControle ||
              _vm.droitAcces.projet_index_user
          )?_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-form',{ref:"formSearchProjet",attrs:{"lazy-validation":"","id":"formSearchProjet"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Projet"},model:{value:(_vm.selectSearchProjet),callback:function ($$v) {_vm.selectSearchProjet=$$v},expression:"selectSearchProjet"}},_vm._l((_vm.items),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.libelle.toUpperCase()))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.type.toUpperCase())+" - ("+_vm._s(item.nbChantier)+") chantier(s)")])])}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-btn',{attrs:{"icons":"","disabled":_vm.selectSearchProjet == undefined ||
                            _vm.selectSearchProjet == '',"color":"primary","small":""},on:{"click":function($event){return _vm.loadProjet()}}},[_vm._v("\n                        VALIDER\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("search")])],1)],1)],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(
            (_vm.listProjetResult.length !== 0 && _vm.droitAcces.projet_index) ||
              _vm.droitAcces.projet_index_chefProjet ||
              _vm.droitAcces.projet_index_chefEtude ||
              _vm.droitAcces.projet_index_chefControle ||
              _vm.droitAcces.projet_index_user ||
              _vm.droitAcces.projet_all_index
          )?_c('v-card-text',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listProjetResult}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","width":"370","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle))]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                  "+_vm._s(scope.row.adresse)+"\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("location_on")])],1)]}}],null,false,4242506860)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chef","label":"Chef de projet"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"indigo","label":"","color":"indigo"}},[_vm._v("\n                  "+_vm._s(scope.row.chef)+"\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("person")])],1)]}}],null,false,2080111840)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"evolution","label":"Evolution"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-progress-circular',{attrs:{"size":85,"width":15,"rotate":360,"value":scope.row.evolution,"color":"primary"}},[_vm._v(_vm._s(scope.row.evolutionNbr)+" %")])]}}],null,false,483112400)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created","label":"Date de création"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v(_vm._s(scope.row.created))])]}}],null,false,1731568830)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.show_projet)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();_vm.tab = '0';
                        _vm.showProjet(scope.row);
                        _vm.loadChantier(scope.row);
                        _vm.loadProjetTache(scope.row);
                        _vm.loadProjetContrat(scope.row);
                        _vm.loadProduitTravaux(scope.row);
                        _vm.loadPlanningProjet(scope.row);
                        _vm.modalDashboardProjet(scope.row);
                        _vm.loadClient();
                        _vm.loadUser();
                        _vm.loadPrestaire();}},slot:"activator"},[_c('v-badge',{attrs:{"color":"red"}},[(_vm.nbChantier == 0)?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v("!")]):_vm._e(),_vm._v(" "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1)],1):_vm._e(),_vm._v("Détails\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.new_projet)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.ajoutProjet('edit', scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("Modifier\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.delete_projets)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){_vm.dialogSupr = true;
                        _vm.idProjet = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("Supprimer\n                  ")],1)],1)]}}],null,false,1647714970)})],1)],1):_vm._e(),_vm._v(" "),(
            !_vm.droitAcces.projet_index ||
              !_vm.droitAcces.projet_index_chefProjet ||
              !_vm.droitAcces.projet_index_chefEtude ||
              !_vm.droitAcces.projet_index_chefControle ||
              _vm.droitAcces.projet_all_index
          )?_c('p',{attrs:{"align":"center"}}):_vm._e()],1)]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.dialogInfoPlan),callback:function ($$v) {_vm.dialogInfoPlan=$$v},expression:"dialogInfoPlan"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation des besoins Matériels")]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("\n              La liste besoins énumerés sera soumise pour validation au chef de\n              projet, vous serez informez par notification\n            ")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialogInfoPlan = false}}},[_vm._v("Ok")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600","persistent":true},model:{value:(_vm.dialogDemarrer),callback:function ($$v) {_vm.dialogDemarrer=$$v},expression:"dialogDemarrer"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Démarrer une tâche: "+_vm._s(_vm.tacheSel.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogDemarrer = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formDemarrer",staticClass:"demo-form-inline",attrs:{"id":"formDemarrer","label-width":"90px","model":_vm.formDemarrer}},[_c('el-form-item',{attrs:{"label":"Debut","required":""}},[_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"dateDbt"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","placeholder":"Choisir une date de debut","format":"dd-MM-yyyy"},model:{value:(_vm.formDemarrer.dateDbt),callback:function ($$v) {_vm.$set(_vm.formDemarrer, "dateDbt", $$v)},expression:"formDemarrer.dateDbt"}})],1)],1),_vm._v(" "),_c('el-col',{staticClass:"line",attrs:{"span":2}},[_vm._v("-")]),_vm._v(" "),_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"hrDbt"}},[_c('el-time-picker',{staticStyle:{"width":"100%"},attrs:{"type":"fixed-time","placeholder":"Choisir une heure de debut"},model:{value:(_vm.formDemarrer.hrDbt),callback:function ($$v) {_vm.$set(_vm.formDemarrer, "hrDbt", $$v)},expression:"formDemarrer.hrDbt"}})],1)],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){return _vm.resetForm('formDemarrer')}}},[_vm._v("\n                Annuler\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","dark":"","color":"green","disabled":_vm.loading},on:{"click":function($event){return _vm.submitFormDemarrer('formDemarrer')}}},[_vm._v("\n                Enregistrer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowReglement),callback:function ($$v) {_vm.dialogShowReglement=$$v},expression:"dialogShowReglement"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Modifier les dates de la tache\n            "+_vm._s(_vm.travauxCourant.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.resetFormVersion()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('el-form',{ref:"formTacheDemarrer",staticClass:"demo-form-inline",attrs:{"id":"formTacheDemarrer","label-width":"90px","model":_vm.formTacheDemarrer}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Debut","required":""}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"value-format":"dd-MM-yyyy","type":"date","id":"dateDbtache","name":"dateDbtache","placeholder":"Date"},model:{value:(_vm.formTacheDemarrer.dateDbtache),callback:function ($$v) {_vm.$set(_vm.formTacheDemarrer, "dateDbtache", $$v)},expression:"formTacheDemarrer.dateDbtache"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Fin","required":""}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"value-format":"dd-MM-yyyy","type":"date","id":"dateFintache","name":"dateFintache","placeholder":"Date"},model:{value:(_vm.formTacheDemarrer.dateFintache),callback:function ($$v) {_vm.$set(_vm.formTacheDemarrer, "dateFintache", $$v)},expression:"formTacheDemarrer.dateFintache"}})],1)],1)],1)],1)],1)])])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.resetFormVersion()}},slot:"activator"},[_vm._v("\n              Fermer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("Fermer\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","disabled":_vm.loading,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editDateTache('formTacheDemarrer')}},slot:"activator"},[_vm._v("\n              Enregistrer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1),_vm._v("Enregistrer\n          ")],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('DashboardChantierProjet',{attrs:{"detailChantier":_vm.detailChantier,"show":_vm.showDetailChantier},on:{"close":function($event){_vm.showDetailChantier = false}}}),_vm._v(" "),_c('IndexTache',{attrs:{"detailTrx":_vm.detailTravaux,"show":_vm.showDetailTache,"commis":false},on:{"close":function($event){_vm.showDetailTache = false},"reloadTrx":function($event){return _vm.$emit('reloadListeTravaux')}}}),_vm._v(" "),_c('IndexOuvrierTrx',{attrs:{"tacheSelect":_vm.tacheSel,"show":_vm.showSelTache},on:{"close":function($event){_vm.showSelTache = false}}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"900"},model:{value:(_vm.showDialogDupTrx),callback:function ($$v) {_vm.showDialogDupTrx=$$v},expression:"showDialogDupTrx"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Duplication du chantier : "+_vm._s(_vm.libelleSelect.libelle))]),_vm._v(" "),_c('v-card-text',{staticClass:"mb-5"},[_c('el-alert',{attrs:{"title":'Voulez-vous duppliquer tous les travaux, les planifications des tâches et la budgétisation de ce chantier?',"type":"warning","center":"","closable":false,"show-icon":""}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.showDialogDupTrx = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":function($event){return _vm.validDuplique(_vm.libelleSelect)}}},[_vm._v("Confirmer")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hJS6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hVEt":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "bP1G",
	"./af.js": "bP1G",
	"./ar": "v5eC",
	"./ar-dz": "is3S",
	"./ar-dz.js": "is3S",
	"./ar-kw": "Z229",
	"./ar-kw.js": "Z229",
	"./ar-ly": "cmXK",
	"./ar-ly.js": "cmXK",
	"./ar-ma": "NmGt",
	"./ar-ma.js": "NmGt",
	"./ar-sa": "fldL",
	"./ar-sa.js": "fldL",
	"./ar-tn": "nqBs",
	"./ar-tn.js": "nqBs",
	"./ar.js": "v5eC",
	"./az": "6x3T",
	"./az.js": "6x3T",
	"./be": "x7Yo",
	"./be.js": "x7Yo",
	"./bg": "uzcH",
	"./bg.js": "uzcH",
	"./bm": "wYEo",
	"./bm.js": "wYEo",
	"./bn": "xmGM",
	"./bn.js": "xmGM",
	"./bo": "YABq",
	"./bo.js": "YABq",
	"./br": "VRg1",
	"./br.js": "VRg1",
	"./bs": "JT3D",
	"./bs.js": "JT3D",
	"./ca": "++BX",
	"./ca.js": "++BX",
	"./cs": "/wBA",
	"./cs.js": "/wBA",
	"./cv": "w3+f",
	"./cv.js": "w3+f",
	"./cy": "A1/H",
	"./cy.js": "A1/H",
	"./da": "i31j",
	"./da.js": "i31j",
	"./de": "X6aO",
	"./de-at": "rQ/n",
	"./de-at.js": "rQ/n",
	"./de-ch": "4prY",
	"./de-ch.js": "4prY",
	"./de.js": "X6aO",
	"./dv": "tJdF",
	"./dv.js": "tJdF",
	"./el": "mInQ",
	"./el.js": "mInQ",
	"./en-au": "ClxJ",
	"./en-au.js": "ClxJ",
	"./en-ca": "lN/b",
	"./en-ca.js": "lN/b",
	"./en-gb": "pwFG",
	"./en-gb.js": "pwFG",
	"./en-ie": "8xWM",
	"./en-ie.js": "8xWM",
	"./en-il": "jjw6",
	"./en-il.js": "jjw6",
	"./en-nz": "AG2A",
	"./en-nz.js": "AG2A",
	"./eo": "zfKD",
	"./eo.js": "zfKD",
	"./es": "z+VS",
	"./es-do": "XG7U",
	"./es-do.js": "XG7U",
	"./es-us": "bMls",
	"./es-us.js": "bMls",
	"./es.js": "z+VS",
	"./et": "F94x",
	"./et.js": "F94x",
	"./eu": "nA+h",
	"./eu.js": "nA+h",
	"./fa": "e5Tc",
	"./fa.js": "e5Tc",
	"./fi": "c2tk",
	"./fi.js": "c2tk",
	"./fo": "PtEz",
	"./fo.js": "PtEz",
	"./fr": "SUuq",
	"./fr-ca": "79RE",
	"./fr-ca.js": "79RE",
	"./fr-ch": "rmG0",
	"./fr-ch.js": "rmG0",
	"./fr.js": "SUuq",
	"./fy": "q0y2",
	"./fy.js": "q0y2",
	"./gd": "wubG",
	"./gd.js": "wubG",
	"./gl": "0eVu",
	"./gl.js": "0eVu",
	"./gom-latn": "zxGv",
	"./gom-latn.js": "zxGv",
	"./gu": "+Adg",
	"./gu.js": "+Adg",
	"./he": "rCOL",
	"./he.js": "rCOL",
	"./hi": "dErd",
	"./hi.js": "dErd",
	"./hr": "clRe",
	"./hr.js": "clRe",
	"./hu": "wLm5",
	"./hu.js": "wLm5",
	"./hy-am": "nqUh",
	"./hy-am.js": "nqUh",
	"./id": "/iTI",
	"./id.js": "/iTI",
	"./is": "gwdK",
	"./is.js": "gwdK",
	"./it": "D039",
	"./it.js": "D039",
	"./ja": "FCY1",
	"./ja.js": "FCY1",
	"./jv": "6n7N",
	"./jv.js": "6n7N",
	"./ka": "Atyt",
	"./ka.js": "Atyt",
	"./kk": "101U",
	"./kk.js": "101U",
	"./km": "FPNq",
	"./km.js": "FPNq",
	"./kn": "cMtA",
	"./kn.js": "cMtA",
	"./ko": "WGhh",
	"./ko.js": "WGhh",
	"./ky": "Pdp3",
	"./ky.js": "Pdp3",
	"./lb": "DiuR",
	"./lb.js": "DiuR",
	"./lo": "ZdrS",
	"./lo.js": "ZdrS",
	"./lt": "aabL",
	"./lt.js": "aabL",
	"./lv": "sz/X",
	"./lv.js": "sz/X",
	"./me": "GLJl",
	"./me.js": "GLJl",
	"./mi": "uOzy",
	"./mi.js": "uOzy",
	"./mk": "uVIa",
	"./mk.js": "uVIa",
	"./ml": "nnnZ",
	"./ml.js": "nnnZ",
	"./mn": "oTjq",
	"./mn.js": "oTjq",
	"./mr": "kGGT",
	"./mr.js": "kGGT",
	"./ms": "YBZt",
	"./ms-my": "F+i6",
	"./ms-my.js": "F+i6",
	"./ms.js": "YBZt",
	"./mt": "1azn",
	"./mt.js": "1azn",
	"./my": "tOK0",
	"./my.js": "tOK0",
	"./nb": "MoD7",
	"./nb.js": "MoD7",
	"./ne": "23X9",
	"./ne.js": "23X9",
	"./nl": "hji7",
	"./nl-be": "/GMh",
	"./nl-be.js": "/GMh",
	"./nl.js": "hji7",
	"./nn": "fcLP",
	"./nn.js": "fcLP",
	"./pa-in": "8EZy",
	"./pa-in.js": "8EZy",
	"./pl": "F3dV",
	"./pl.js": "F3dV",
	"./pt": "AceZ",
	"./pt-br": "HjC+",
	"./pt-br.js": "HjC+",
	"./pt.js": "AceZ",
	"./ro": "LqIn",
	"./ro.js": "LqIn",
	"./ru": "f7Gc",
	"./ru.js": "f7Gc",
	"./sd": "81is",
	"./sd.js": "81is",
	"./se": "zZe+",
	"./se.js": "zZe+",
	"./si": "yVA8",
	"./si.js": "yVA8",
	"./sk": "QdFH",
	"./sk.js": "QdFH",
	"./sl": "gzuR",
	"./sl.js": "gzuR",
	"./sq": "e+TO",
	"./sq.js": "e+TO",
	"./sr": "tmOy",
	"./sr-cyrl": "wQJG",
	"./sr-cyrl.js": "wQJG",
	"./sr.js": "tmOy",
	"./ss": "Iu1k",
	"./ss.js": "Iu1k",
	"./sv": "+yes",
	"./sv.js": "+yes",
	"./sw": "MTYc",
	"./sw.js": "MTYc",
	"./ta": "/ej7",
	"./ta.js": "/ej7",
	"./te": "4rxu",
	"./te.js": "4rxu",
	"./tet": "GM1B",
	"./tet.js": "GM1B",
	"./tg": "V1DD",
	"./tg.js": "V1DD",
	"./th": "OtaC",
	"./th.js": "OtaC",
	"./tl-ph": "ecbb",
	"./tl-ph.js": "ecbb",
	"./tlh": "BOT3",
	"./tlh.js": "BOT3",
	"./tr": "gGKr",
	"./tr.js": "gGKr",
	"./tzl": "PT7i",
	"./tzl.js": "PT7i",
	"./tzm": "VDSP",
	"./tzm-latn": "mobR",
	"./tzm-latn.js": "mobR",
	"./tzm.js": "VDSP",
	"./ug-cn": "3sGX",
	"./ug-cn.js": "3sGX",
	"./uk": "905m",
	"./uk.js": "905m",
	"./ur": "oDKn",
	"./ur.js": "oDKn",
	"./uz": "5dk3",
	"./uz-latn": "Tbj8",
	"./uz-latn.js": "Tbj8",
	"./uz.js": "5dk3",
	"./vi": "kYlc",
	"./vi.js": "kYlc",
	"./x-pseudo": "RSdQ",
	"./x-pseudo.js": "RSdQ",
	"./yo": "UAnA",
	"./yo.js": "UAnA",
	"./zh-cn": "uN28",
	"./zh-cn.js": "uN28",
	"./zh-hk": "jcyg",
	"./zh-hk.js": "jcyg",
	"./zh-tw": "3x6E",
	"./zh-tw.js": "3x6E"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hVEt";

/***/ }),

/***/ "hWpT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('detailEmploye',{attrs:{"admin":false,"showEmpl":_vm.showEmp,"idUserCont":_vm.idUser}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hZT5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":true,"fullscreen":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogInfoOuvrier),callback:function ($$v) {_vm.dialogInfoOuvrier=$$v},expression:"dialogInfoOuvrier"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("FICHE OUVRIER "+_vm._s(_vm.infoOuvrier.nom))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{staticClass:"mb-5 mt-2 elevation-3 pt-4 pl-2 pr-2 pb-5",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-left mr-5 ",attrs:{"xs1":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"140px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.infoOuvrier.url,"alt":"avatar"}})])],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-2 ml-2",attrs:{"xs7":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{attrs:{"mt-2":""}},[_vm._v("INFORMATION PERSONNELLE")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_vm._v("Matricule")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs8":""}},[_vm._v("\n                                                        "+_vm._s(_vm.infoOuvrier.matricule)+"\n                                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Nom")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                        "+_vm._s(_vm.infoOuvrier.nom)+"\n                                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Domicile/Siege")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                        "+_vm._s(_vm.infoOuvrier.domicile)+"\n                                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Contact")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                        "+_vm._s(_vm.infoOuvrier.contact)+"\n                                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Profession")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                        "+_vm._s(_vm.infoOuvrier.profession)+"\n                                                    ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Type pièce")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                "+_vm._s(_vm.infoOuvrier.piece)+"\n                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Numéro ID")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                "+_vm._s(_vm.infoOuvrier.numPiece)+"\n                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de naissance")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                "+_vm._s(_vm.infoOuvrier.dateNaiss)+"\n                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_vm._v("Enregistré le")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs8":""}},[_vm._v("\n                                                "+_vm._s(_vm.infoOuvrier.created)+"\n                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticStyle:{"width":"400px","height":"300px"},attrs:{"id":"statMontVerse"}})])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick(_vm.onglet)}},model:{value:(_vm.onglet),callback:function ($$v) {_vm.onglet=$$v},expression:"onglet"}},[_c('el-tab-pane',{attrs:{"label":"Contrats"}},[_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{staticStyle:{"width":"100%"},attrs:{"xs12":""}},[_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTE DES CONTRATS")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-1",attrs:{"xs12":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"primary darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total : ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("   "+_vm._s(new Intl.NumberFormat().format(_vm.montantTotal))+" ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1",attrs:{"xs12":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total payé: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("   "+_vm._s(new Intl.NumberFormat().format(_vm.montantTotalVerse))+" ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1",attrs:{"xs12":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total restant: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("   "+_vm._s(new Intl.NumberFormat().format(_vm.montantTotalRestant))+" ")])])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"elevation-3 pt-3 pl-3 pr-3 pb-3",attrs:{"xs12":""}},[_c('h4',[_vm._v("PRESTATION TACHES ")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"data":_vm.listeContratsTache}},[_c('el-table-column',{attrs:{"prop":"idContrat","label":"ID-CONTRAT","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etatContrat","label":"ETAT CONTRAT","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 0)?_c('el-tag',{staticClass:"subheading",attrs:{"type":"info"}},[_vm._v("\n                                                                "+_vm._s(scope.row.etatContrat)+"\n                                                            ")]):_vm._e(),_vm._v(" "),(scope.row.etat == 1)?_c('el-tag',{staticClass:"subheading"},[_vm._v("\n                                                                "+_vm._s(scope.row.etatContrat)+"\n                                                            ")]):_vm._e(),_vm._v(" "),(scope.row.etat == 2)?_c('el-tag',{staticClass:"subheading",attrs:{"type":"blue"}},[_vm._v("\n                                                                "+_vm._s(scope.row.etatContrat)+"\n                                                            ")]):_vm._e(),_vm._v(" "),(scope.row.etat == 3)?_c('el-tag',{staticClass:"subheading",attrs:{"type":"success"}},[_vm._v("\n                                                                "+_vm._s(scope.row.etatContrat)+"\n                                                            ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chantier","label":"PROJET/CHANTIER","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateDbtFin","label":"PERIODE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dureePresence","label":"PRESENCE(hr)","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dureePresenceHeureSupp","label":"PRESENCE HEURE SUPP(hr)","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantContrat","label":"MONTANT/(hr)","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"info"}},[_vm._v("\n                                                                "+_vm._s(scope.row.montantContrat)+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantContratHeuSupp","label":"MONTANT HEURE SUPP/(hr)","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"info"}},[_vm._v("\n                                                                "+_vm._s(scope.row.montantContratHeuSupp)+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantTotal","label":"MONTANT TOTAL","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("\n                                                                "+_vm._s(new Intl.NumberFormat().format(scope.row.montantTotal))+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntVerse","label":"MONTANT PAYE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"success"}},[_vm._v("\n                                                                "+_vm._s(new Intl.NumberFormat().format(scope.row.mntVerse))+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntRestant","label":"MONTANT RESTANT","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"warning"}},[_vm._v("\n                                                                "+_vm._s(new Intl.NumberFormat().format(scope.row.mntRestant))+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","disabled":scope.row.montantTotalFormat == 0,"fab":"","small":"","color":"primary","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.showDialogPaiement(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("attach_money")])],1),_vm._v("\n                                                                Notifier un paiement\n                                                            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){return _vm.EditoOuvrier(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                                                                Edit pointage...\n                                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Paiements"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"elevation-3  pt-3 pl-3 pr-3 pb-3",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{attrs:{"mt-2":""}},[_vm._v("HISTORIQUE DES PAIEMENTS")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"data":_vm.listePaiements}},[_c('el-table-column',{attrs:{"prop":"idContrat","label":"ID-CONTRAT","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleFact","label":"FACTURE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"refFact","label":"REFERENCE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleTrx","label":"TRAVAUX","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mnt","label":"MONTANT","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"info"}},[_vm._v("\n                                                                "+_vm._s(scope.row.mnt)+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"auteur","label":"AUTEUR","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"datePaiement","label":"DATE DE PAIEMENT","align":"center"}})],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('br')],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"98%"},model:{value:(_vm.dialogValideFacture),callback:function ($$v) {_vm.dialogValideFacture=$$v},expression:"dialogValideFacture"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("\n            Confirmation de paiement\n            ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticClass:"mb-5"},[_c('el-alert',{attrs:{"title":'Voulez-vous effectuer un paiement ',"type":"warning","center":"","closable":false,"show-icon":""}}),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%","margin-top":"30px"},attrs:{"border":"","highlight-current-row":"","show-summary":"","header-row-style":_vm.headerRowStyle,"data":_vm.listeFactureSelect}},[_c('el-table-column',{attrs:{"align":"center","prop":"ouvrier","label":"Ouvrier"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"projet","label":"Projet"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"chantier","label":"Chantier"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"mntRestant","label":"Montant restant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                            "+_vm._s(new Intl.NumberFormat().format(scope.row.mntRestant))+"\n                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"montantVerse","label":"Montant à regler"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":1,"max":prop.row.mntRestant,"name":"montantVerse","placeholder":"Montant à verser"},model:{value:(prop.row.montantVerse),callback:function ($$v) {_vm.$set(prop.row, "montantVerse", $$v)},expression:"prop.row.montantVerse"}})]}}])})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialogValideFacture = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":function($event){return _vm.validFacture()}}},[_vm._v("Confirmer")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"98%"},model:{value:(_vm.dialogHeureValide),callback:function ($$v) {_vm.dialogHeureValide=$$v},expression:"dialogHeureValide"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("\n            Modifier les heures de pointage\n            ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticClass:"mb-5"},[_c('el-table',{staticStyle:{"width":"100%","margin-top":"30px"},attrs:{"border":"","highlight-current-row":"","show-summary":"","header-row-style":_vm.headerRowStyle,"data":_vm.listeFactureSelect}},[_c('el-table-column',{attrs:{"align":"center","prop":"ouvrier","label":"Ouvrier"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"projet","label":"Projet"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"chantier","label":"Chantier"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"periodeHr","label":"Précence"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":1,"max":prop.row.periodeHr,"name":"periodeHr","placeholder":"Nombre de minute"},model:{value:(prop.row.periodeHr),callback:function ($$v) {_vm.$set(prop.row, "periodeHr", $$v)},expression:"prop.row.periodeHr"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"periodeSupp","label":"Présence heure supp"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":1,"max":prop.row.periodeSupp,"name":"periodeSupp","placeholder":"Nombre de minuter"},model:{value:(prop.row.periodeSupp),callback:function ($$v) {_vm.$set(prop.row, "periodeSupp", $$v)},expression:"prop.row.periodeSupp"}})]}}])})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.closeDialogUpdateHeure()}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":function($event){return _vm.validUpdateHeure()}}},[_vm._v("Confirmer")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hq/E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "htyB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"width":"80%","persistent":true,"transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogDemande),callback:function ($$v) {_vm.dialogDemande=$$v},expression:"dialogDemande"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter ou modifier une demande de maintenance")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formDemande",staticClass:"demo-form-inline",attrs:{"id":"formDemande","model":_vm.formDemande,"rules":_vm.rules}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Lieu","prop":"lieu"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"lieu","placeholder":"lieu"},model:{value:(_vm.formDemande.lieu),callback:function ($$v) {_vm.$set(_vm.formDemande, "lieu", $$v)},expression:"formDemande.lieu"}},_vm._l((_vm.listeLieux),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Type de la demande","prop":"typeDemande"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"typeDemande","placeholder":"Type de la demande"},model:{value:(_vm.formDemande.typeDemande),callback:function ($$v) {_vm.$set(_vm.formDemande, "typeDemande", $$v)},expression:"formDemande.typeDemande"}},_vm._l((_vm.typeDemande),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Nom du demandeur","prop":"demandeur"}},[_c('el-autocomplete',{staticStyle:{"width":"100%"},attrs:{"name":"demandeur","placeholder":"nom du demandeur","fetch-suggestions":_vm.loadDemandeur},model:{value:(_vm.formDemande.demandeur),callback:function ($$v) {_vm.$set(_vm.formDemande, "demandeur", $$v)},expression:"formDemande.demandeur"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Contact 1 du demandeur","prop":"tel1"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"tel1","placeholder":"Contact 1 du demandeur"},model:{value:(_vm.formDemande.tel1),callback:function ($$v) {_vm.$set(_vm.formDemande, "tel1", $$v)},expression:"formDemande.tel1"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Contact 2 du demandeur","prop":"tel2"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"tel2","placeholder":"Contact 2 du demandeur"},model:{value:(_vm.formDemande.tel2),callback:function ($$v) {_vm.$set(_vm.formDemande, "tel2", $$v)},expression:"formDemande.tel2"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Bâtiment","prop":"batiment"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"bâtiment"},model:{value:(_vm.formDemande.batiment),callback:function ($$v) {_vm.$set(_vm.formDemande, "batiment", $$v)},expression:"formDemande.batiment"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Salle","prop":"salle"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"salle","placeholder":"salle"},model:{value:(_vm.formDemande.salle),callback:function ($$v) {_vm.$set(_vm.formDemande, "salle", $$v)},expression:"formDemande.salle"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Priorité","prop":"priorite"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"priorite","placeholder":"Type de la priorité"},model:{value:(_vm.formDemande.priorite),callback:function ($$v) {_vm.$set(_vm.formDemande, "priorite", $$v)},expression:"formDemande.priorite"}},_vm._l((_vm.priorite),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"description"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"motif","placeholder":"motif"},model:{value:(_vm.formDemande.detail),callback:function ($$v) {_vm.$set(_vm.formDemande, "detail", $$v)},expression:"formDemande.detail"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Corps de metier","prop":"domaine"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"domaine","placeholder":"Corps de metier"},model:{value:(_vm.formDemande.domaine),callback:function ($$v) {_vm.$set(_vm.formDemande, "domaine", $$v)},expression:"formDemande.domaine"}},_vm._l((_vm.listeDomaine),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date de la maintenance"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy HH:mm","type":"datetime","value-format":"yyyy-MM-dd HH:mm ","id":"DateMaint","placeholder":"Date de maintenance"},model:{value:(_vm.formDemande.dateDemande),callback:function ($$v) {_vm.$set(_vm.formDemande, "dateDemande", $$v)},expression:"formDemande.dateDemande"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs2":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.image1,"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"file1",staticStyle:{"display":"none"},attrs:{"name":"image1","type":"file","accept":"image/*"},on:{"change":_vm.onFileImage1Picked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.file1.click()}}},[_vm._v("Photo  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('div',{staticClass:"font-weight-thin"},[_vm._v("Fichier au format (JPEG,PNG,PDF) avec une taille de 1048 ko maximale")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){return _vm.resetForm('formDemande')}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.editForm == false)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitForm('formDemande')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitForm('formDemande')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hxV6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":true,"width":"90%","scrollable":""},model:{value:(_vm.dialogOuvrier),callback:function ($$v) {_vm.dialogOuvrier=$$v},expression:"dialogOuvrier"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("LISTE DES OUVRIERS ET PRESTATAIRE AFFECTES A LA TACHE:\n        "+_vm._s(_vm.tacheSelect.tacheLibelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTE DES OUVRIERS")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","elevation-2":""}},[_c('v-flex',{attrs:{"sm12":"","mt-2":""}},[_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"mt-3":"","ml-1":"","mr-1":"","data":_vm.listeOuvriers}},[_c('el-table-column',{attrs:{"prop":"idContrat","label":"Contrat","align":"center","width":"100","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("CONT-"+_vm._s(scope.row.idContrat))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nom","label":"NOM","align":"center","width":"230","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateD","label":"Début"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"MONTANT/Heure","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantSupp","label":"MONTANT HEURE SUPP","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etatContrat","label":"Etat contrat","align":"center"}})],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTE DES PRESTATAIRES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","elevation-2":""}},[_c('v-flex',{attrs:{"sm12":"","mt-2":""}},[_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"mt-3":"","ml-1":"","mr-1":"","data":_vm.listePrestataires}},[_c('el-table-column',{attrs:{"prop":"idContrat","label":"Contrat","align":"center","width":"100","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("CONT-"+_vm._s(scope.row.idContrat))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nom","label":"NOM","align":"center","width":"230","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateD","label":"Début"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"MONTANT/JOUR","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantHeur","label":"MONTANT/H","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantSupp","label":"MONTANT HEURE SUPP","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etatContrat","label":"Etat contrat","align":"center"}})],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}})],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i+cl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"70%"},model:{value:(_vm.dialogFormContrat),callback:function ($$v) {_vm.dialogFormContrat=$$v},expression:"dialogFormContrat"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Créer un contrat")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialogFormContrat = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('formContrat',{attrs:{"idUserContrat":_vm.idUserContrat},on:{"close":function($event){return _vm.closeFormContrat()}}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{staticClass:"headline",attrs:{"mt-2":""}},[_vm._v("Liste des contrats")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[(_vm.typeAdmin == true)?_c('v-btn',{attrs:{"slot":"activator","color":"primary"},on:{"click":function($event){_vm.dialogFormContrat = true}},slot:"activator"},[_vm._v("\n                                Créer\n                                "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("add")])],1):_vm._e(),_vm._v("\n\n                            Créer un contrat\n                        ")],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"elevation-3",attrs:{"slot":"activator","dark":"","icon":"","flat":"","color":"primary"},on:{"click":function($event){return _vm.loadContratUser()}},slot:"activator"},[_c('v-icon',[_vm._v("cached")])],1),_vm._v("\n                            actualiser la liste\n                        ")],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pt-2 pb-2 pl-2 pr-2 mt-1",attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeContrats}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":"","mr-3":"","mt-2":""}},[_c('span',{staticClass:"title"},[_vm._v("Validité contrat")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":props.row.validites,"stripe":"","row-class-name":_vm.tableRowClassName}},[_c('el-table-column',{attrs:{"prop":"dateDbt","label":"Début","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateFin","label":"Fin","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"infoStatut","label":"info"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.idStatut == 1)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.infoStatut))]):(scope.row.idStatut == 0)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.infoStatut))]):_vm._e()]}}],null,true)})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"mr-3":"","xs5":"","mt-2":""}},[_c('div',{staticClass:"grid-content"},[_c('p',{staticClass:"title"},[_vm._v("Contrat créer par: "+_vm._s(props.row.createdUser)+" le "+_vm._s(props.row.created))]),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v("Contrat modifié par: "+_vm._s(props.row.updateUser)+" le "+_vm._s(props.row.created))])]),_vm._v(" "),_c('div',{staticClass:"grid-content"},[_c('el-input',{attrs:{"type":"textarea","rows":7,"readonly":true,"disabled":true,"placeholder":"Description du contrat"},model:{value:(props.row.description),callback:function ($$v) {_vm.$set(props.row, "description", $$v)},expression:"props.row.description"}})],1)])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2 mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"grid-content"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[(_vm.typeAdmin)?_c('v-btn',{attrs:{"slot":"activator","small":"","dark":"","color":"primary"},on:{"click":function($event){return _vm.showAddTaux(props.row.idContrat)}},slot:"activator"},[_vm._v("\n                                                                            Ajouter un taux\n                                                                        ")]):_vm._e(),_vm._v("\n                                                                        Ajouter un taux\n                                                                    ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Taux de paiement")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"row-class-name":_vm.tableRowClassName,"data":props.row.taux,"stripe":""}},[_c('el-table-column',{attrs:{"prop":"libTauxPaiement","label":"Taux paiement","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libTypePaie","label":"Type paiement","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libStatutTemp","label":"Temps supplémentaire"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"renumeration","label":"Salaire nette"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                                                "+_vm._s(new Intl.NumberFormat().format(scope.row.renumeration))+"\n                                                                            ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createdUser","label":"Ajouté par","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created","label":"Créée le","width":"180"}}),_vm._v(" "),(_vm.typeAdmin)?_c('el-table-column',{attrs:{"prop":"Action","label":"Action","align":"center","width":"100","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"bottom":""}},[(scope.row.isDelete == true)?_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"red"},on:{"click":function($event){return _vm.showDeleteTaux(scope.row.idTaux)}},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1):_vm._e(),_vm._v("\n                                                                                    Supprimer le taux salariale\n                                                                                ")],1)]}}],null,true)}):_vm._e()],1)],1)],1)],1)],1)])],1)],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idContrat","label":"ID-CONTRAT","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                    CONTRAT-"+_vm._s(scope.row.idContrat)+"\n                                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateSign","label":"DATE ECHEANCE","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libTypeContrat","label":"TYPE CONTRAT","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libEtat","label":"STATUT","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 4)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.libEtat))]):(scope.row.etat == 0)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.libEtat))]):(scope.row.etat == 3)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.libEtat))]):(scope.row.etat == 2 )?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.libEtat))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projet","label":"PROJET","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"blue--text body-2"},[_vm._v(_vm._s(scope.row.projet))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"poste","label":"POSTE","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"superviseur","label":"SUPERVISEUR","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libTypeContrat","label":"TYPE CONTRAT","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"orange--text body-2"},[_vm._v(_vm._s(scope.row.libTypeContrat))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"FICHIER","align":"center","width":"250","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"bottom":""}},[_vm._l((scope.row.imagesCont),function(image,imageIndex){return _c('v-avatar',{key:imageIndex,staticClass:"mb-1 mr-1 elevation-3",style:({ backgroundImage: 'url(' + image + ')' , cursor: 'pointer'}),attrs:{"slot":"activator","tile":true,"size":50,"color":"grey lighten-4"},on:{"click":function($event){return _vm.showDiapo(scope.row.imagesCont,imageIndex)}},slot:"activator"},[_c('img',{attrs:{"src":image,"alt":"avatar"}})])}),_vm._v("\n                                        Cliquez pour agrandir\n                                    ")],2)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"50%"},model:{value:(_vm.dialogFormAddTaux),callback:function ($$v) {_vm.dialogFormAddTaux=$$v},expression:"dialogFormAddTaux"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter un taux")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialogFormAddTaux = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formDynamiqueTaux",attrs:{"label-position":"top","model":_vm.formDynamiqueTaux}},[_c('el-card',{staticClass:"box-card",attrs:{"justify":"center"}},_vm._l((_vm.formDynamiqueTaux.taux),function(taux,ind){return _c('el-row',{key:(taux.ind),attrs:{"justify":"center","type":"flex","gutter":20}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label":"Paiement","prop":'taux.' + ind + '.tauxPaiement'}},[_c('el-select',{attrs:{"placeholder":"Taux de paiement"},model:{value:(taux.tauxPaiement),callback:function ($$v) {_vm.$set(taux, "tauxPaiement", $$v)},expression:"taux.tauxPaiement"}},_vm._l((_vm.listeTauxPaiement),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label":"Type de paie","prop":'taux.' + ind + '.typePaie'}},[_c('el-select',{attrs:{"placeholder":"Type de paie"},model:{value:(taux.typePaie),callback:function ($$v) {_vm.$set(taux, "typePaie", $$v)},expression:"taux.typePaie"}},_vm._l((_vm.listeTypePaie),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":7}},[_c('el-form-item',{attrs:{"label":"Rénumération","prop":'taux.' + ind + '.renumeration'}},[_c('el-input-number',{attrs:{"min":1},model:{value:(taux.renumeration),callback:function ($$v) {_vm.$set(taux, "renumeration", $$v)},expression:"taux.renumeration"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('div',[_c('el-form-item',{attrs:{"label":"Temps supplémentaire","prop":'taux.' + ind + '.statut'}},[_c('el-select',{attrs:{"placeholder":"Statut de temps"},model:{value:(taux.statut),callback:function ($$v) {_vm.$set(taux, "statut", $$v)},expression:"taux.statut"}},_vm._l((_vm.listeStatut),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('div',[_c('el-form-item',{attrs:{"label":"."}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":"","color":"red"},on:{"click":function($event){return _vm.removeTaux(taux)}},slot:"activator"},[_c('v-icon',[_vm._v("clear")])],1),_vm._v("\n                                                        Supprimer\n                                                    ")],1)],1)],1)])],1)}),1),_vm._v(" "),_c('el-row',{attrs:{"justify":"end"}},[_c('el-col',{attrs:{"span":3,"offset":21}},[_c('div',[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","absolute":"","right":"","top":"","dark":"","fab":"","color":"orange"},on:{"click":_vm.addTaux},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v("\n                                                Ajouter une ligne\n                                            ")],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"text-xs-right mt-4"},[_c('div',{staticClass:"mt-4",staticStyle:{"width":"100%"}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","dark":"","color":"green"},on:{"click":function($event){return _vm.submitFormTaux('formDynamiqueTaux')}},slot:"activator"},[_vm._v("\n\n                                    Enregistrer\n                                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1),_vm._v("\n                                    enregistrer les taux\n                                ")],1)],1)])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"350"},model:{value:(_vm.dialogSuppTaux),callback:function ($$v) {_vm.dialogSuppTaux=$$v},expression:"dialogSuppTaux"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_c('el-alert',{attrs:{"title":'Voulez-vous supprimer cet enregistrement ?',"type":"warning","closable":false,"show-icon":""}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialogSuppTaux = false}}},[_vm._v("\n                        Non\n                    ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":"flat"},on:{"click":function($event){return _vm.submitDeleteTaux()}}},[_vm._v("\n                        Oui\n                    ")])],1)],1)],1),_vm._v(" "),_c('CoolLightBox',{attrs:{"items":_vm.items,"index":_vm.index},on:{"close":function($event){_vm.index = null}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i/7P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");


var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
    name: "AjoutMaintenance",
    props: ["show", "demandeDetail", "editForm"],
    data: function data() {
        return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),

            loading: false,
            labelPosition: 'left',
            dialogDemande: false,
            formDemande: {},
            listeLieux: [],
            listeDomaine: [],
            today: new Date(),
            image1: "/static/img-doc.png",
            image2: "/static/img-doc.png",
            image3: "/static/img-doc.png",
            image4: "/static/img-doc.png",
            file1: "",
            file2: "",
            file3: "",
            priorite: [{ text: 'Faible', value: 0 }, { text: 'Moyen', value: 1 }, { text: 'Haute', value: 2 }, { text: 'Urgent', value: 3 }],
            typeDemande: [{ text: 'Réparation', value: 1 }, { text: 'Fourniture de matériel', value: 2 }, { text: 'Entretien', value: 3 }],
            rules: {

                typeDemande: [{ required: true, message: 'Veuillez saisir' }],
                lieu: [{ required: true, message: 'Veuillez saisir' }],
                priorite: [{ required: true, message: 'Veuillez saisir' }],
                demandeur: [{ required: true, message: 'Veuillez saisir', trigger: 'change' }],
                batiment: [{ required: true, message: 'Veuillez saisir', trigger: 'blur' }],
                salle: [{ required: true, message: 'Veuillez saisir', trigger: 'blur' }],
                tel1: [{ required: true, message: 'Veuillez saisir' }],
                domaine: [{ required: true, message: 'Veuillez saisir' }]
            }
        };
    },


    computed: {},
    watch: {
        show: function show(newValue, oldvalue) {
            this.dialogDemande = newValue;
            if (newValue == true) {
                if (this.editForm == true) {

                    this.formDemande.lieu = this.demandeDetail.idZone;
                    this.formDemande.typeDemande = this.demandeDetail.typeDemande;
                    this.formDemande.demandeur = this.demandeDetail.nomDemandeur;
                    this.formDemande.tel1 = this.demandeDetail.persTel1;
                    this.formDemande.tel2 = this.demandeDetail.persTel2;
                    this.formDemande.batiment = this.demandeDetail.batiment;
                    this.formDemande.salle = this.demandeDetail.salle;
                    this.formDemande.priorite = this.demandeDetail.priorite;
                    this.formDemande.detail = this.demandeDetail.commentaire;
                    this.formDemande.domaine = this.demandeDetail.domaine;
                }
            } else {
                this.formDemande = {};
            }
        }
    },

    methods: (_methods = {
        createFilter: function createFilter(queryString) {
            return function (link) {
                return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
        closeDialog: function closeDialog() {
            this.$emit('close');
        },
        submitForm: function submitForm(formName) {
            var _this = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this.loading = true;
                    var form = document.getElementById("formDemande");
                    //recuperation des demandes
                    var data = new FormData(form);
                    var url = "";
                    if (_this.editForm == false) {
                        url = _this.domaine + 'demande_maintenance/new';
                    } else {
                        url = _this.domaine + 'demande_maintenance/edit';
                        data.append("idDemande", _this.demandeDetail.idDemande);
                    }

                    data.append("priorite", _this.formDemande.priorite);
                    data.append("typeDemande", _this.formDemande.typeDemande);
                    data.append("lieu", _this.formDemande.lieu);
                    data.append("batiment", _this.formDemande.batiment);
                    data.append("domaine", _this.formDemande.domaine);

                    if (_this.formDemande.dateDemande != "undefined") {
                        data.append("dateMaint", _this.formDemande.dateDemande);
                    }
                    data.append("userId", _this.user.id);
                    _this.$http.post(url, data).then(function (response) {
                        //reinitialiser le formulaire
                        _this.resetForm('formDemande');
                        _this.formDemande.detail = '';
                        //reinitialisation des images telecharger
                        _this.image1 = "/static/img-doc.png";
                        _this.image2 = "/static/img-doc.png";
                        _this.image3 = "/static/img-doc.png";
                        _this.image = "/static/img-doc.png";
                        _this.file1 = "";
                        _this.file2 = "";
                        _this.file3 = "";
                        _this.loading = false;
                        if (response.body.code == 5) {
                            _this.successNotif(response.body.message, "error");
                        } else {
                            _this.successNotif(response.body.message);
                        }

                        _this.closeDialog();
                    }, function (erreur) {
                        //reinitialiser le formulaire
                        _this.resetForm('formDemande');
                        _this.formDemande.detail = '';
                        //reinitialisation des images telecharger
                        _this.image1 = "/static/img-doc.png";
                        _this.image2 = "/static/img-doc.png";
                        _this.image3 = "/static/img-doc.png";
                        _this.image = "/static/img-doc.png";
                        _this.file1 = "";
                        _this.file2 = "";
                        _this.file3 = "";
                        _this.closeDialog();
                        _this.loading = false;
                        _this.$message.error("Une erreur est survenue lors de l'enregistrement de la demande");
                    });
                }
            });
        }
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "createFilter", function createFilter(queryString) {
        return function (link) {
            return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
        };
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "resetForm", function resetForm(formName) {
        this.$refs[formName].resetFields();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "loadDemandeur", function loadDemandeur(queryString, cb) {
        var _this2 = this;

        var url = this.domaine + 'maintenance/listes-demandeur';
        var formdata = new FormData();
        formdata.append('user', this.user.id);
        formdata.append('tag', queryString);
        this.$http.post(url, formdata).then(function (response) {
            if (response.body) {
                var links = response.body;
                var results = queryString ? links.filter(_this2.createFilter(queryString)) : links;
                cb(results);
            }
        }, function (response) {});
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "loadLieu", function loadLieu() {
        var _this3 = this;

        var url = this.domaine + 'demande_maintenance/lieu/' + this.user.id;

        this.$http.get(url).then(function (response) {
            _this3.listeLieux = response.body.lieux;
        }, function (erreurRep) {});
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "loadDomaine", function loadDomaine() {
        var _this4 = this;

        var url = this.domaine + 'demande_maintenance/liste/domaine';

        this.$http.get(url).then(function (response) {
            _this4.listeDomaine = response.body.domaine;
        }, function (erreurRep) {});
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "successNotif", function successNotif() {
        var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Demande enregistrée avec succès";
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "success";

        this.$notify({
            title: 'ENREGISTREMENT DEMANDE',
            message: mess,
            type: type,
            position: 'top-center',
            duration: 10000
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "onFileImage1Picked", function onFileImage1Picked(event) {
        var _this5 = this;

        var files = event.target.files;
        var filename = files[0].name;
        if (filename.lastIndexOf(".") <= 0) {
            return alert("Veuillez selectionner un  format de fichier valide ");
        }

        var fileReader = new FileReader();
        fileReader.addEventListener("load", function () {
            _this5.image1 = fileReader.result;
        });

        fileReader.readAsDataURL(files[0]);
        this.file1 = files[0];
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "onFileImage2Picked", function onFileImage2Picked(event) {
        var _this6 = this;

        var files = event.target.files;
        var filename = files[0].name;
        if (filename.lastIndexOf(".") <= 0) {
            return alert("Veuillez selectionner un  format de fichier valide ");
        }

        var fileReader = new FileReader();
        fileReader.addEventListener("load", function () {
            _this6.image2 = fileReader.result;
        });

        fileReader.readAsDataURL(files[0]);
        this.file2 = files[0];
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "onFileImage3Picked", function onFileImage3Picked(event) {
        var _this7 = this;

        var files = event.target.files;
        var filename = files[0].name;
        if (filename.lastIndexOf(".") <= 0) {
            return alert("Veuillez selectionner un  format de fichier valide ");
        }

        var fileReader = new FileReader();
        fileReader.addEventListener("load", function () {
            _this7.image3 = fileReader.result;
        });

        fileReader.readAsDataURL(files[0]);
        this.file3 = files[0];
    }), _methods),

    mounted: function mounted() {
        this.loadLieu();
        this.loadDomaine();
    }
});

/***/ }),

/***/ "i4xy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i5JW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Vb+l");
__webpack_require__("Oq2I");
__webpack_require__("miEh");

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: 'app',
  data: function data() {
    return {
      loading: false,
      domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
      user: JSON.parse(sessionStorage.getItem('userInfo')),
      roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
      droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
      racourcis: [{ path: '/', text: 'Accueil', disabled: false }, { path: '/client', text: 'Liste des clients', disabled: true }],
      dialogAjout: false,
      dialogFactureAjout: false,
      dialogVaildeFAjout: false,
      dialogValidePAjout: false,
      dialogEdit: false,
      dialogShow: false,
      dialogFactureShow: false,
      dialogSupr: false,
      dialogFactureSupr: false,
      dialogValidePSupr: false,
      statAllFactureClient: [],
      statDetailClientForOne: [],
      valid: false,
      listClient: [],
      idClient: '',
      client: [],
      form: {
        type: 1,
        libelle: '',
        genre: '',
        situation: '',
        contact: '',
        fixe: '',
        localisation: '',
        adresse: '',
        dateN: '',
        lieuN: '',
        gerant: ''
      },
      typeRow: [{ label: 'PERSONNE PHYSIQUE', value: 1 }, { label: 'PERSONNE MORALE', value: 2 }],
      civiliteRow: [{ label: 'MONSIEUR', value: 'Mr' }, { label: 'MADAME', value: 'Mme' }, { label: 'MADEMOISELLE', value: 'Mlle' }],
      genreRow: [{ label: 'MASCULIN', value: 'M' }, { label: 'FEMININ', value: 'F' }],
      situationRow: [{ label: 'CELIBATAIRE', value: 'Célibataire' }, { label: 'MARIE', value: 'Marié' }],
      tab: 'facture',
      listFacture: [],
      formFacture: {
        id: '',
        date: '',
        avance: 1,
        datePaie: '',
        montant: 0,
        montantF: '0',
        montantAvance: 0,
        etat: 0,
        caisse: '',
        description: '',
        statsPieFacture: '',
        statsPieFactureForOne: '',
        projet: '',
        dateD: '',
        dateF: '',
        search: [],
        fileList: [{
          name: '',
          url: ''
        }]
      },
      listProjet: [],
      userDetails: "",
      listProjetDetails: [],
      allProjet: [],
      projet: [],
      listCaisse: [],
      selectSearchProjet: "",
      transRow: [{ label: 'NE PAS TRANSMETRE', value: 0 }, { label: 'TRANSMETRE', value: 1 }],
      ModTransmition: [{ label: 'MAIL', value: 0 }, { label: 'COURRIER', value: 1 }],
      facture: [],
      etape: 0,
      TotalTtc: 0,
      valideRow: [{ label: 'NON VALIDER', value: 0 }, { label: 'VALIDER', value: 1 }],
      formValideF: {
        id: '',
        delegue: 0,
        coordination: 0,
        controle: 0,
        description: '',
        fileList: [{
          name: '',
          url: ''
        }]
      },
      message: {
        code: 0,
        message: ''
      },
      idFacture: '',
      totalRapportF: '0',
      avanceRow: [{ label: "FACTURE", value: false }, { label: "FACTURE D'AVANCE", value: true }],
      formProcess: {
        id: '',
        idFac: '',
        entite: '',
        mode: '',
        date: '',
        etat: false,
        description: '',
        fileList: [{
          name: '',
          url: ''
        }]
      },
      modeRow: [{ label: "MAIL", value: "MAIL" }, { label: "COURRIER", value: "COURRIER" }],
      etatRow: [{ label: "EN COURS DE TRAITEMENT", value: false }, { label: "TERMINE", value: true }],
      listOptions: [],
      option: [],
      idOpFac: ''
    };
  },

  computed: {},
  methods: {
    loadClient: function loadClient() {
      var _this = this;

      this.loading = true;
      var url = this.domaine + 'client/projet/index';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this.listClient = response.body.client;
          _this.statAllFactureClient = response.body.statsFact;
          _this.statsPieFacture = response.body.pie;
          _this.loading = false;
          _this.statAllFacture();
          _this.statAllDiagramCirc();
        }
      }, function (error) {
        _this.loading = false;
      });
    },
    loadTravauxSuiviProjet: function loadTravauxSuiviProjet(ligne) {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "projet/" + ligne + "/index/chantier";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this2.listChantier = response.body.chantier;
          _this2.loading = false;
        }
      });
    },
    loadProjet: function loadProjet(item) {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + 'client/projet/' + item.id + '/index';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this3.listProjet = response.body.projet;
          _this3.userDetails = item.id;
          _this3.statDetailClientForOne = response.body.stats;
          _this3.statsPieFactureForOne = response.body.pieClient;
          _this3.statForOneClient();
          _this3.statCircForOneclient();
          _this3.loading = false;
        }
      }, function (error) {
        _this3.loading = false;
      });
    },
    loadProjetFacture: function loadProjetFacture(ligne) {
      var _this4 = this;

      this.loading = true;
      var url = this.domaine + "facture/client/" + this.userDetails + "/projet/" + ligne + "/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this4.listProjetDetails = response.body;
          _this4.loading = false;
        }
      }, function (error) {
        _this4.loading = false;
      });
    },
    loadCaisse: function loadCaisse() {
      var _this5 = this;

      var url = this.domaine + "caisse/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this5.listCaisse = response.body.caisse;
        }
      });
    },
    loadFacture: function loadFacture(item) {
      var _this6 = this;

      this.loading = true;
      var url = this.domaine + "facture/client/" + item.id + "/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this6.listFacture = response.body;
          _this6.loading = false;
        }
      });
    },
    loadOption: function loadOption(item) {
      var _this7 = this;

      this.loading = true;
      var url = this.domaine + "facture/client/" + item.id + "/index/process";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this7.listOptions = response.body;
          _this7.loading = false;
        }
      });
    },
    findProjet: function findProjet(item) {
      var _this8 = this;

      this.loading = true;
      var url = this.domaine + "projet/" + item + "/show";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this8.projet = response.body.projet;
          _this8.loading = false;
          _this8.valideF();
        }
      });
    },
    newClient: function newClient() {
      this.dialogAjout = true;
      this.dialogEdit = false;
      this.client = [];
      this.form = {
        type: 1,
        libelle: '',
        genre: '',
        situation: '',
        contact: '',
        fixe: '',
        localisation: '',
        adresse: '',
        dateN: '',
        lieuN: '',
        gerant: ''
      };
    },
    newFacture: function newFacture(item) {
      this.dialogFactureAjout = true;
      this.message = {};
      this.TotalTtc = 0;
      if (item.length !== 0) {
        this.dialogEdit = true;
        this.facture = item;
        this.formFacture = {
          id: item.id,
          avance: item.avance,
          date: item.date,
          datePaie: item.datePaie,
          dateD: item.dateD,
          dateF: item.dateF,
          montant: item.montant,
          montantAvance: item.montantAvance,
          etat: item.etat,
          caisse: item.idCa,
          description: item.description,
          projet: item.idP
        };
        this.findProjet(item.idP);
        if (!item.avance) {
          this.search();
        }
      } else {
        this.dialogEdit = false;
        this.projet = [];
        this.formFacture.projet = {};
        this.formFacture = {
          id: '',
          avance: 1,
          date: '',
          datePaie: '',
          montant: 0,
          montantF: '0',
          montantAvance: 0,
          etat: 0,
          caisse: '',
          description: '',
          projet: '',
          dateD: '',
          dateF: '',
          search: []
        };
      }
    },
    newProcess: function newProcess(item) {
      this.dialogValidePAjout = true;
      this.dialogEdit = false;
      this.facture = item;
      this.formProcess = {
        id: '',
        idFac: item.id,
        entite: '',
        mode: '',
        date: '',
        etat: false,
        description: ''
      };
    },
    valideFacture: function valideFacture(item) {
      this.dialogVaildeFAjout = true;
      this.facture = item;
      this.etape = 1;
      this.formValideF = {
        id: item.id,
        delegue: 0,
        coordination: 0,
        controle: 0,
        description: ''
      };
    },
    edit: function edit(item) {
      this.dialogAjout = true;
      this.dialogEdit = true;
      this.client = item;
      this.form = item;
      this.form.type = parseInt(item.type);
    },
    show: function show(item) {
      this.dialogShow = true;
      this.client = item;
    },
    editProcess: function editProcess(item) {
      this.dialogEdit = true;
      this.option = item;
      this.formProcess = {
        id: item.id,
        idFac: item.idFac,
        entite: item.entite,
        mode: item.mode,
        date: item.date,
        etat: item.etat,
        description: item.description
      };
    },
    showFacture: function showFacture(item) {
      this.dialogFactureShow = true;
      this.facture = item;
      this.totalRapportF = new Intl.NumberFormat('fr-Fr').format(item.totalRapport);
    },
    formValide: function formValide() {
      if (this.form.type === 1) {
        if (this.form.civilite !== '' && this.form.libelle !== '' && this.form.contact !== '' && this.form.genre !== '') {
          return this.valid = true;
        } else {
          return this.valid = false;
        }
      } else {
        if (this.form.civilite !== '' && this.form.libelle !== '' && this.form.contact !== '' && this.form.genre !== '' && this.form.gerant !== '') {
          return this.valid = true;
        } else {
          return this.valid = false;
        }
      }
    },
    valideF: function valideF() {
      var form = this.formFacture;
      //avance
      if (this.projet.etatAvance) {
        if (form.date !== '' && form.datePaie !== '' && form.caisse !== '' && form.montantAvance !== 0) {
          return this.valid = true;
        } else {
          return this.valid = false;
        }
      } else {
        if (form.date !== '' && form.datePaie !== '' && form.caisse !== '' && form.montant !== 0 && form.dateD !== '' && form.dateF !== '' && form.search.length > 0) {
          return this.valid = true;
        } else {
          return this.valid = false;
        }
      }
    },
    changeType: function changeType() {
      var type = this.form.type;
      this.form = {
        type: type,
        libelle: '',
        genre: '',
        situation: '',
        contact: '',
        fixe: '',
        localisation: '',
        adresse: '',
        dateN: '',
        lieuN: '',
        gerant: ''
      };
    },
    changeProjet: function changeProjet() {
      var idProjet = this.formFacture.projet;
      this.formFacture = {
        id: '',
        date: '',
        datePaie: '',
        montant: 0,
        montantF: '0',
        montantAvance: 0,
        etat: 0,
        caisse: '',
        description: '',
        projet: idProjet,
        dateD: '',
        dateF: '',
        search: []
      };
      if (this.formFacture.projet !== '' && this.formFacture.projet !== null) {
        this.findProjet(this.formFacture.projet);
      } else {
        this.projet = [];
      }
    },
    search: function search() {
      var _this9 = this;

      var url = this.domaine + 'facture/client/search';
      var form = document.getElementById('formFacture');
      var data = new FormData(form);
      data.append('projet', this.formFacture.projet);
      data.append('dateD', this.formFacture.dateD);
      data.append('dateF', this.formFacture.dateF);
      this.$http.post(url, data).then(function (response) {
        if (response.body) {
          _this9.formFacture.search = response.body.data;
          _this9.formFacture.montant = response.body.total;
          _this9.formFacture.montantF = new Intl.NumberFormat('fr-Fr').format(response.body.total);
          _this9.message = response.body;
          _this9.$notify.warning({
            title: "RESULTATS",
            message: _this9.message.message,
            position: 'top-center',
            timeout: 300000
          });
          _this9.valideF();
        }
      }, function (response) {});
    },
    submit: function submit() {
      var _this10 = this;

      this.formValide();
      if (this.valid) {
        this.loading = true;
        var form = document.getElementById('formClient');
        var data = new FormData(form);
        var url = '';
        data.append('idUser', this.user.id);
        data.append('type', this.form.type);
        data.append('civilite', this.form.civilite);
        data.append('genre', this.form.genre);
        data.append('situation', this.form.situation);
        if (this.client.id) {
          url = this.domaine + 'client/projet/' + this.client.id + '/edit';
        } else {
          url = this.domaine + 'client/projet/new';
        }
        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              if (_this10.client.id) {
                _this10.$notify({
                  title: 'MODIFICATION REUSSI',
                  message: 'Client modifié avec succès.',
                  type: 'success',
                  position: 'top-center'
                });
              } else {
                _this10.$notify({
                  title: 'ENREGISTREMENT REUSSI',
                  message: 'Client enregistré avec succès.',
                  type: 'success',
                  position: 'top-center'
                });
              }

              _this10.loadClient();
              _this10.dialogAjout = false;
              _this10.loading = false;
            } else if (verif.code === 0) {
              _this10.$message.error(verif.message);
              _this10.loading = false;
            }
          } else {
            _this10.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
            _this10.loading = false;
          }
        }, function (response) {
          _this10.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
          _this10.loading = false;
        });
      } else {
        this.$message.error('Veuillez renseigner les champs obligatoires');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le client n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    submitFacture: function submitFacture() {
      var _this11 = this;

      this.loading = true;
      var formF = this.formFacture;
      if (formF.projet !== '' && formF.date !== '' && formF.caisse !== '' && (formF.montantAvance !== 0 || formF.montant !== 0)) {
        var form = document.getElementById('formFacture');
        var data = new FormData(form);
        var url = '';
        data.append('idUser', this.user.id);
        data.append('id', this.formFacture.id);
        data.append('client', this.client.id);
        data.append('projet', this.formFacture.projet);
        data.append('caisse', this.formFacture.caisse);
        data.append('etat', this.formFacture.etat);
        data.append('avance', this.formFacture.avance);
        data.append('montant', this.formFacture.montant);
        data.append('tva', this.formFacture.tva);
        data.append('totalTtc', this.TotalTtc);
        data.append('transmission', this.formFacture.modeTrans);
        url = this.domaine + 'facture/client/new';

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              if (_this11.formFacture.id) {
                _this11.$notify({
                  title: 'MODIFICATION REUSSI',
                  message: 'Facture modifié avec succès.',
                  type: 'success',
                  position: 'top-center'
                });
              } else {
                _this11.$notify({
                  title: 'ENREGISTREMENT REUSSI',
                  message: 'Facture enregistré avec succès.',
                  type: 'success',
                  position: 'top-center'
                });
              }

              _this11.loadFacture(_this11.client);
              _this11.dialogFactureAjout = false;
              _this11.loading = false;
            } else if (verif.code === 0) {
              _this11.$message.error(verif.message);
              _this11.loading = false;
            }
          } else {
            _this11.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
            _this11.loading = false;
          }
        }, function (response) {
          _this11.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
          _this11.loading = false;
        });
      } else {
        this.$message.error('Veuillez renseigner les champs obligatoires');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La facture n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    submitValideF: function submitValideF() {
      var _this12 = this;

      this.loading = true;
      var formF = this.formValideF;
      if (formF.delegue !== 0 && formF.coordination !== 0 && formF.controle !== 0) {
        var form = document.getElementById('formValideF');
        var data = new FormData(form);
        data.append('idUser', this.user.id);
        data.append('id', formF.id);
        data.append('delegue', formF.delegue);
        data.append('coordination', formF.coordination);
        data.append('controle', formF.controle);
        var url = this.domaine + 'facture/client/valider';

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this12.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: 'Validation éffectuée avec succès.',
                type: 'success',
                position: 'top-center'
              });

              _this12.loadFacture(_this12.client);
              _this12.dialogVaildeFAjout = false;
              _this12.loading = false;
            } else if (verif.code === 0) {
              _this12.$message.error(verif.message);
              _this12.loading = false;
            }
          } else {
            _this12.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
            _this12.loading = false;
          }
        }, function (response) {
          _this12.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
          _this12.loading = false;
        });
      } else {
        this.$message.error('Veuillez renseigner les champs obligatoires');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La validation n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    submitProcess: function submitProcess() {
      var _this13 = this;

      this.loading = true;
      var formF = this.formProcess;
      if (formF.idFac !== '' && formF.date !== '' && formF.entite !== '' && formF.mode !== '') {
        var form = document.getElementById('formProcessus');
        var data = new FormData(form);
        var url = '';
        data.append('idUser', this.user.id);
        data.append('id', this.formProcess.id);
        data.append('facture', this.formProcess.idFac);
        data.append('mode', this.formProcess.mode);
        data.append('etat', this.formProcess.etat);
        url = this.domaine + 'facture/client/new/processus';

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this13.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: 'Facture enregistré avec succès.',
                type: 'success',
                position: 'top-center'
              });

              _this13.loadOption(_this13.facture);
              _this13.loadFacture(_this13.client);
              _this13.dialogValidePAjout = false;
              _this13.dialogEdit = false;
              _this13.loading = false;
            } else if (verif.code === 0) {
              _this13.$message.error(verif.message);
              _this13.loading = false;
            }
          } else {
            _this13.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
            _this13.loading = false;
          }
        }, function (response) {
          _this13.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
          _this13.loading = false;
        });
      } else {
        this.$message.error('Veuillez renseigner les champs obligatoires');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La facture n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    sumbitClose: function sumbitClose() {
      var _this14 = this;

      if (this.facture.etatPross) {
        this.loading = true;
        var form = document.getElementById('formProcessus');
        var data = new FormData(form);
        data.append('idUser', this.user.id);
        var url = this.domaine + 'facture/client/clore/' + this.facture.id + '/processus';
        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this14.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: 'Facture enregistré avec succès.',
                type: 'success',
                position: 'top-center'
              });

              _this14.loadFacture(_this14.client);
              _this14.dialogValidePAjout = false;
              _this14.loading = false;
            } else if (verif.code === 0) {
              _this14.$message.error(verif.message);
              _this14.loading = false;
            }
          } else {
            _this14.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
            _this14.loading = false;
          }
        }, function (response) {
          _this14.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
          _this14.loading = false;
        });
      } else {
        this.$message.error('VEUILLEZ TERMINER LE PRECEDENT PROCESSUS DE ENTAMME.');
      }
    },
    calculTotalComm: function calculTotalComm() {

      var montant = void 0;
      var tva = parseInt(this.formFacture.tva, 10);
      var mtnTVA = 0;
      var mtnTotal = 0;
      if (this.projet.etatAvance && this.formFacture.projet) {
        montant = this.formFacture.montantAvance;
      } else {
        montant = this.formFacture.montantF;
      }
      mtnTotal = parseInt(montant, 10) + parseInt(Math.round(montant * (tva / 100)), 10);
      // this.TotalTtc = new Intl.NumberFormat("fr-FR").format(mtnTotal);
      this.TotalTtc = mtnTotal;
    },
    annulerPross: function annulerPross() {
      this.dialogEdit = false;
      this.option = [];
      this.formProcess = {
        id: '',
        idFac: this.facture.id,
        entite: '',
        mode: '',
        date: '',
        etat: false,
        description: ''
      };
    },
    deleteC: function deleteC(item) {
      var _this15 = this;

      var url = this.domaine + "client/projet/delete/" + this.idClient;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this15.$notify({
            title: "SUPPRESSION",
            message: "Client supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          _this15.dialogSupr = false;
          _this15.loadClient();
        }
      });
    },
    deleteF: function deleteF(item) {
      var _this16 = this;

      var url = this.domaine + "facture/client/delete/" + this.idFacture;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this16.$notify({
            title: "SUPPRESSION",
            message: "Facture supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          _this16.dialogFactureSupr = false;
          _this16.loadFacture(_this16.client);
        }
      });
    },
    deleteOF: function deleteOF() {
      var _this17 = this;

      var url = this.domaine + "facture/client/process/delete/" + this.idOpFac;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this17.$notify({
            title: "SUPPRESSION",
            message: "Supression éffectuée avec succès.",
            type: "success",
            position: "top-center"
          });
          _this17.dialogValidePSupr = false;
          _this17.loadOption(_this17.facture);
          _this17.loadFacture(_this17.client);
          _this17.dialogValidePAjout = false;
        }
      });
    },
    handleRemove: function handleRemove(file, fileList) {},
    handlePreview: function handlePreview(file) {
      this.formValideF.fileList = file;
    },
    statAllDiagramCirc: function statAllDiagramCirc() {
      //commande livre et commande effectue
      var optionComm = {
        title: {
          text: 'Facture(Payée, Impayée,En cours,En attente)',
          subtext: '',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          bottom: 10,
          left: 'left',
          data: ['Facture payée', 'Facture impayée', 'Facture en cours', 'Facture en attente']
        },
        series: [{
          type: 'pie',
          radius: '65%',
          center: ['50%', '50%'],
          selectedMode: 'single',
          data: [{ value: this.statsPieFacture.paye, name: 'facture payée' }, { value: this.statsPieFacture.impaye, name: 'facture impayée' }, { value: this.statsPieFacture.enCours, name: 'facture en cours' }, { value: this.statsPieFacture.attente, name: 'facture en attente' }],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
      var chartClientAll = echarts.init(document.getElementById('chartClientAll'));
      chartClientAll.setOption(optionComm);
    },
    statAllFacture: function statAllFacture() {
      //facture paye et impaye
      var optionFactAll = {
        title: {
          text: 'Facture payée et impayée',
          subtext: '',
          left: 'center'
        },
        color: ['#e5323e', '#67C23A'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: []
        }],
        yAxis: [{ type: 'value' }],
        series: [{
          name: 'Impayé',
          type: 'bar',
          barWidth: 5,
          data: []
        }, {
          name: 'Payé',
          type: 'bar',
          barWidth: 5,
          data: []
        }]
      };

      this.statAllFactureClient.forEach(function (element) {
        optionFactAll.xAxis[0].data.push(element.date);
        optionFactAll.series[0].data.push(element.impaye);
        optionFactAll.series[1].data.push(element.paye);
      });

      var chartFactureAllClient = echarts.init(document.getElementById('chartFactureAllClient'));
      chartFactureAllClient.setOption(optionFactAll);
    },
    statCircForOneclient: function statCircForOneclient() {
      //commande livre et commande effectue
      var optionComm = {
        title: {
          text: 'Facture(Payée, Impayée,En cours,En attente)',
          subtext: '',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          bottom: 10,
          left: 'left',
          data: ['Facture payée', 'Facture impayée', 'Facture en cours', 'Facture en attente']
        },
        series: [{
          type: 'pie',
          radius: '65%',
          center: ['50%', '50%'],
          selectedMode: 'single',
          data: [{ value: this.statsPieFactureForOne.paye, name: 'facture payée' }, { value: this.statsPieFactureForOne.impaye, name: 'facture impayée' }, { value: this.statsPieFactureForOne.enCours, name: 'facture en cours' }, { value: this.statsPieFactureForOne.attente, name: 'facture en attente' }],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      };
      var chartForOneClient = echarts.init(document.getElementById('chartForOneClient'));
      chartForOneClient.setOption(optionComm);
    },
    statForOneClient: function statForOneClient() {
      //facture paye et impaye
      var optionFactAll = {
        title: {
          text: 'Facture payée et impayée',
          subtext: '',
          left: 'center'
        },
        color: ['#e5323e', '#67C23A'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: []
        }],
        yAxis: [{ type: 'value' }],
        series: [{
          name: 'Impayé',
          type: 'bar',
          barWidth: 5,
          data: []
        }, {
          name: 'Payé',
          type: 'bar',
          barWidth: 5,
          data: []
        }]
      };

      this.statDetailClientForOne.forEach(function (element) {
        optionFactAll.xAxis[0].data.push(element.date);
        optionFactAll.series[0].data.push(element.impaye);
        optionFactAll.series[1].data.push(element.paye);
      });

      var chartFactureForOneClient = echarts.init(document.getElementById('chartFactureForOneClient'));
      chartFactureForOneClient.setOption(optionFactAll);
    }
  },
  mounted: function mounted() {
    this.loadClient();
    this.loadCaisse();
  },

  beforeMount: function beforeMount() {
    // if(!this.roleAcces[this.$router.history.current.name]){
    //   this.$router.push({ name: 'Home'  })
    // }
  }
});

/***/ }),

/***/ "iA41":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalAttribuerZone_vue__ = __webpack_require__("bgFy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b12f3fd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalAttribuerZone_vue__ = __webpack_require__("k5w0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalAttribuerZone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b12f3fd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalAttribuerZone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iF6j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConstatMaintenance_vue__ = __webpack_require__("XL6v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57dd13d3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConstatMaintenance_vue__ = __webpack_require__("tUpR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConstatMaintenance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57dd13d3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConstatMaintenance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iHuT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");


var _components$name$prop;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Oq2I");
__webpack_require__("miEh");




/* harmony default export */ __webpack_exports__["a"] = (_components$name$prop = {
  components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */] },
  name: "WidgetChantier",
  props: {
    show: {
      type: Boolean
    },
    type: {
      type: Number,
      default: 0
    },
    chantier: {
      type: Object
    }
  },
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,

      statusRapport: [],
      coutPrevu: 0,
      coutActuel: 0,
      nbOuvrier: 0,
      nbPrestataire: 0,
      nbTrxTermine: 0,
      nbTrxArret: 0,
      nbTrxEnCours: 0,
      nbTrx: 0,
      tauxExec: 0
    };
  },


  watch: {},

  methods: {
    loadStatChantTrx: function loadStatChantTrx() {
      var _this = this;

      var url = this.domaine + "chantier/stat/" + this.chantier.idChant;

      this.$http.get(url).then(function (response) {
        _this.loading = false;
        _this.coutPrevu = response.body.coutPrevu;
        _this.coutActuel = response.body.coutActuel;
        _this.nbOuvrier = response.body.nbOuvrier;
        _this.nbPrestataire = response.body.nbPrestataire;
        _this.nbTrxTermine = response.body.nbTrxTermine;
        _this.nbTrxArret = response.body.nbTrxArret;
        _this.nbTrxEnCours = response.body.nbTrxEnCours;
        _this.nbTrx = response.body.nbTrx;
        _this.tauxExec = response.body.tauxExec;
      }, function (error) {
        _this.loading = false;
      });
    }
  }

}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$name$prop, "watch", {
  chantier: function chantier(newValue, oldValue) {
    if (this.chantier.idChant != null) {
      this.loadStatChantTrx();
    } else {}
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$name$prop, "mounted", function mounted() {}), _components$name$prop);

/***/ }),

/***/ "iQMl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadTypeTravaux_vue__ = __webpack_require__("vbkS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67b8ed28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadTypeTravaux_vue__ = __webpack_require__("Adal");
function injectStyle (ssrContext) {
  __webpack_require__("NLC5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67b8ed28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadTypeTravaux_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67b8ed28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadTypeTravaux_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iWoE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationAppro_vue__ = __webpack_require__("xEp4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fcfadc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationAppro_vue__ = __webpack_require__("GUsS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalValidationAppro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fcfadc8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalValidationAppro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "if1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"align-center":"","xs12":""}},[_c('TableauTache',{attrs:{"listeTableaux":_vm.litesTab}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-btn',{staticClass:"mb-4",attrs:{"dark":"","color":"green","large":"","fab":"","fixed":"","bottom":"","right":""}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j5vI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jBBu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item,ind){return _c('v-breadcrumbs-item',{key:ind,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v(" "+_vm._s(item.text))])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":"","ml-1":"","mr-1":"","mt-1":""}},[_c('v-card',[_c('el-tabs',{attrs:{"stretch":"true","type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick(_vm.onglet)}},model:{value:(_vm.onglet),callback:function ($$v) {_vm.onglet=$$v},expression:"onglet"}},[_c('el-tab-pane',{attrs:{"label":" Validation devis / facture"}},[_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeDmdCom))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbDmdCom))]),_vm._v("\n                                                    Commandes à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeDmdCom}},[_c('el-table-column',{attrs:{"prop":"dateLivr","label":"Date de livraison"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user","width":"200","label":"Demandeur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projet","width":"300","label":"Projet"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chantier","width":"300","label":"Chantier"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"travaux","width":"270","label":"travaux"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailDmdCom(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                                Detail\n                                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeFour))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total des factures  à valider: ")]),_vm._v("  "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(new Intl.NumberFormat().format(_vm.mntTotalFactTTC))+" Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbFactFour))]),_vm._v("\n                                                    Factures à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Facture par fournisseur"},on:{"clear":function($event){return _vm.clearSelectFour()},"change":_vm.filtrerFour},model:{value:(_vm.selectFour),callback:function ($$v) {_vm.selectFour=$$v},expression:"selectFour"}},_vm._l((_vm.listeFournisseurs),function(item,ind){return _c('el-option',{key:ind,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeFacturesFour}},[_c('el-table-column',{attrs:{"prop":"date","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref","label":"Référence"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(_vm._s(new Intl.NumberFormat('fr-Fr').format(scope.row.total)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleFour","label":"Fournisseur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailFour(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                                Detail\n                                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeDmdFond))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total  à valider: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntTotalDmdFondTTC)+" Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbDmdFond))]),_vm._v("\n                                                    Demande de fonds à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Demandeur"},on:{"clear":function($event){return _vm.clearSelectFour()},"change":_vm.filtrerDmdFond},model:{value:(_vm.selectDmdFond),callback:function ($$v) {_vm.selectDmdFond=$$v},expression:"selectDmdFond"}},_vm._l((_vm.listeDemandeurFond),function(item,ind){return _c('el-option',{key:ind,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeDmdFond}},[_c('el-table-column',{attrs:{"prop":"dateFormat","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demandeur","label":"Nom du demandeur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantFormat","label":"Montant (Fcfa)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"typeDmd","label":"Type demande"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailDmdFond(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                                Detail\n                                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.droitAcces.all_appro_no_valid_dg)?_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeAppro))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total  à valider: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntTotalAppro)+" F Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:" mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbAppro))]),_vm._v("\n                                                    Approvisionnement(s) à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Facture par fournisseur"},on:{"clear":function($event){return _vm.clearSelectFour()},"change":_vm.filtrerFour},model:{value:(_vm.selectFour),callback:function ($$v) {_vm.selectFour=$$v},expression:"selectFour"}},_vm._l((_vm.listeFournisseurs),function(item,ind){return _c('el-option',{key:ind,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeDmdNoValidAppro}},[_c('el-table-column',{attrs:{"prop":"dateDmd","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"caisseLibelle","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(_vm._s(scope.row.montant)+" FCFA")])]}}],null,false,1202447318)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailAppro(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                            Detail\n                                                        ")],1)]}}],null,false,2190206670)})],1)],1)],1)],1)],1):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450"},model:{value:(_vm.dialogValideSuivant),callback:function ($$v) {_vm.dialogValideSuivant=$$v},expression:"dialogValideSuivant"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(" Validation suivante ")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez-vous passer à la validation suivante ?","closable":false,"show-icon":"","type":"warning"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogValideSuivant = false}}},[_vm._v("Non")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideSuivant()}}},[_vm._v("Afficher le fiche suivante")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450"},model:{value:(_vm.dialogValideSuivant),callback:function ($$v) {_vm.dialogValideSuivant=$$v},expression:"dialogValideSuivant"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(" Validation suivante ")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez-vous passer à la validation suivante ?","closable":false,"show-icon":"","type":"warning"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){return _vm.CancelValideSuivant()}}},[_vm._v("Non")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideSuivant()}}},[_vm._v("Afficher le fiche suivante")])],1)],1)],1)],1),_vm._v(" "),_c('ModalValidationInterv',{attrs:{"intervDetail":_vm.intervDetail,"totalFact":_vm.mntTotalIntervTTC,"show":_vm.showModalIntervFact},on:{"close":_vm.showDialogIntervAfter}}),_vm._v(" "),_c('ModalValidationFacture',{attrs:{"factureDetail":_vm.factureDetail,"totalFact":_vm.mntTotalFactTTC,"show":_vm.showModalDetailFact,"listCaisse":_vm.listCaisse,"listBanque":_vm.listBanque,"commandeDeriv":_vm.commandeDeriv,"commandeDerivDeux":_vm.commandeDerivDeux,"mntTotalCmd":_vm.mntTotalCmd,"nbCommandeSug":_vm.nbCommandeSug,"nbCommandeSugDeux":_vm.nbCommandeSugDeux},on:{"close":_vm.showDialogFactAfter}}),_vm._v(" "),_c('ModalValidationDmd',{attrs:{"demandeDetail":_vm.demandeDetail,"show":_vm.showModalDetailDmd},on:{"close":_vm.showDialogDmdAfter}}),_vm._v(" "),_c('ModalValidationMiss',{attrs:{"detailMission":_vm.detailMission,"show":_vm.showModalDetailMiss},on:{"close":_vm.showDialogMissAfter}}),_vm._v(" "),_c('ModalValidationDmdFond',{attrs:{"valider":true,"logistique":true,"demandeDetail":_vm.demandeDetail,"show":_vm.showModalDetailDmdFond},on:{"close":_vm.showDialogDmdFondAfter}}),_vm._v(" "),_c('ModalValidationAppro',{attrs:{"approDetail":_vm.ApproDetail,"listCaisse":_vm.listCaisse,"listBanque":_vm.listBanque,"show":_vm.showModalDetailAppro},on:{"close":function($event){_vm.showModalDetailAppro = false; _vm.loadDmdNoValidAppro()}}}),_vm._v(" "),_c('ModalValidationDga',{attrs:{"detailCommande":_vm.detailCommande,"totalMontant":_vm.totalMontant,"show":_vm.showModalDetailDmdCom},on:{"close":_vm.showDialogDmdComAfter}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jRLL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutTache),callback:function ($$v) {_vm.dialogAjoutTache=$$v},expression:"dialogAjoutTache"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Dupliquer les tâches de "+_vm._s(this.libelleChantier)+"/"+_vm._s(_vm.libelleTacheSelect))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeForm()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md5":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type chantier *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Selectionné un type projet"},on:{"change":function($event){return _vm.loadTrvBytype(_vm.typeProjet)}},model:{value:(_vm.typeProjet),callback:function ($$v) {_vm.typeProjet=$$v},expression:"typeProjet"}},_vm._l((_vm.typeProjetTab),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"md5":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type Travaux *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Selectionné un type travaux"},model:{value:(_vm.typeSelectTravaux),callback:function ($$v) {_vm.typeSelectTravaux=$$v},expression:"typeSelectTravaux"}},_vm._l((_vm.listTravauxTab),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-form',{ref:"formLotTache",staticClass:"demo-ruleForm",attrs:{"rules":_vm.rulesLotTache,"id":"formLotTache","label-position":"top","model":_vm.formLotTache}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs1":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Ordre","prop":"ordre"}},[_c('el-select',{attrs:{"placeholder":"Select"},model:{value:(_vm.formLotTache.ordre),callback:function ($$v) {_vm.$set(_vm.formLotTache, "ordre", $$v)},expression:"formLotTache.ordre"}},_vm._l((_vm.numOrdre),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.num,"value":item.num}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Libelle tâche","prop":"libelle"}},[_c('el-input',{attrs:{"placeholder":"Saisir un libelle","name":"libelle"},model:{value:(_vm.formLotTache.libelle),callback:function ($$v) {_vm.$set(_vm.formLotTache, "libelle", $$v)},expression:"formLotTache.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Unité","prop":"unite"}},[_c('el-input',{attrs:{"placeholder":"unité","name":"unite"},model:{value:(_vm.formLotTache.unite),callback:function ($$v) {_vm.$set(_vm.formLotTache, "unite", $$v)},expression:"formLotTache.unite"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Prix unitaire (FCFA)","prop":"prix"}},[_c('el-input-number',{attrs:{"min":0,"name":"prix"},model:{value:(_vm.formLotTache.prix),callback:function ($$v) {_vm.$set(_vm.formLotTache, "prix", $$v)},expression:"formLotTache.prix"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"description"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":"description","name":"description","rows":6},model:{value:(_vm.formLotTache.description),callback:function ($$v) {_vm.$set(_vm.formLotTache, "description", $$v)},expression:"formLotTache.description"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('el-form-item',{attrs:{"label":"Action"}},[_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addListTypeTache()}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),(_vm.typeSelectTravaux != '')?_c('div',{staticClass:"text-xs-right"},[_c('input',{ref:"fileInputExcel",staticStyle:{"display":"none"},attrs:{"name":"fileInputExcel","type":"file","accept":"image/*"},on:{"change":_vm.onFileExcelPicked}}),_vm._v(" "),_c('el-dropdown',{on:{"command":_vm.handleFileExcel}},[_c('el-button',{attrs:{"type":"success"}},[_vm._v("\n                Fichier excel"),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"0"}},[_vm._v("Importer fichier excel")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"1"}},[_vm._v("Générer un modèle")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeTaches,"border":""}},[_c('el-table-column',{attrs:{"prop":"ordre","label":"Ordre"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-select',{attrs:{"placeholder":"Select"},on:{"change":function($event){return _vm.changeOrdre(prop.row.ordre, prop.$index)}},model:{value:(prop.row.ordre),callback:function ($$v) {_vm.$set(prop.row, "ordre", $$v)},expression:"prop.row.ordre"}},_vm._l((_vm.listeNumber),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.num,"value":item.num}})}),1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé tâche"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input',{attrs:{"controls-position":"right","size":"small"},model:{value:(prop.row.libelle),callback:function ($$v) {_vm.$set(prop.row, "libelle", $$v)},expression:"prop.row.libelle"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"unité"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input',{attrs:{"controls-position":"right","size":"small"},model:{value:(prop.row.unite),callback:function ($$v) {_vm.$set(prop.row, "unite", $$v)},expression:"prop.row.unite"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix unitaire (FCFA)"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input-number',{attrs:{"min":0,"name":"prix"},model:{value:(prop.row.prix),callback:function ($$v) {_vm.$set(prop.row, "prix", $$v)},expression:"prop.row.prix"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"description"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input',{attrs:{"type":"textarea","controls-position":"right","size":"small"},model:{value:(prop.row.description),callback:function ($$v) {_vm.$set(prop.row, "description", $$v)},expression:"prop.row.description"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Opérations","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.listeTaches)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                      Modifier cette tâche\n                    ")],1)]}}])})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","align-self-end":"","mt-4":""}},[_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pr-1",attrs:{"xs2":"","offset-xs8":""}},[_c('v-btn',{attrs:{"block":"","color":"grey","dark":""},on:{"click":function($event){return _vm.closeForm()}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.typeSelectTravaux != '')?_c('v-btn',{attrs:{"slot":"activator","disable":"","icons":"","block":"","color":"green","dark":""},on:{"click":function($event){return _vm.submitDupTache()}},slot:"activator"},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e()],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('LoadTypeTachesExcel',{attrs:{"show":_vm.showModalLoadTypeTravaux,"listeTypeTravaux":_vm.lstTypeTravaux,"idTypeTravaux":this.typeSelectTravaux},on:{"close":function($event){_vm.showModalLoadTypeTravaux = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jRpV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */] },
    name: "AjoutDemandeFond",
    props: ["show", "dmdDetail", "editForm"],
    data: function data() {
        var _ref;

        return _ref = {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            typeDmd: 'Projet'
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "loading", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "labelPosition", 'left'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "dialogAjoutFond", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "disabledSelectCaisse", false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formDmd", {
            chantier: '',
            autre: '',
            montant: 5,
            demandeur: '',
            motif: '',
            projet: '',
            caisseSelect: ''
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "rules", {
            montant: [{ required: true, message: 'Veuillez saisir' }],

            motif: [{ required: true, message: 'Veuillez saisir' }],
            // demandeur: [
            //     { required: true, message: 'Veuillez saisir', trigger: 'change' },

            // ],
            caisseSelect: [{ message: 'Veuillez selectionner une caisse', trigger: 'change' }]
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeProjet", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeChantier", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeTravaux", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeCaisse", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "caisseSelect", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "formCarte", {
            identifiant: '',
            montant: 1,
            qte: 1,
            prix: 1
        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "rulesFormCarte", {
            identifiant: [{ message: 'Veuillez selectionner une carte', trigger: 'blur', required: true }]

            // montant: [
            //     { message: 'Veuillez saisir',trigger: 'blur' },

            // ],

        }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "listeCarte", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "totalCarte", 0), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "tableCarte", []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "helpDemande", [{
            num: "1",
            text: "Selectionner les cartes ainsi que le montant"
        }, {
            num: "2",
            text: "Après validation par le DG, Veuillez retirer le montant indiqué dans la caisse concernée puis effectuer l'approvisionnement de la carte dans le menu Logistique"
        }]), _ref;
    },


    computed: {},
    watch: {
        show: function show(newValue, oldvalue) {
            this.dialogAjoutFond = newValue;
            if (newValue == true) {
                this.formDmd.demandeur = this.user.username ? this.user.username : '';
                if (this.editForm == true) {
                    this.loadProjet();
                    this.loadCaisse();
                    this.formDmd.projet = this.dmdDetail.idProjet;
                    this.formDmd.autre = this.dmdDetail.autreDmd;
                    if (this.dmdDetail.autreDmd) {
                        this.typeDmd = "Autre";
                    }
                    this.formDmd.chantier = this.dmdDetail.chantier;
                    this.formDmd.motif = this.dmdDetail.motif;
                    this.formDmd.montant = this.dmdDetail.montant;
                    this.formDmd.caisseSelect = this.dmdDetail.idCaisse;
                }
            } else {
                //cahrgement de la liste des demandeur

                this.formDmd = {};
            }
        }

    },

    methods: {
        calculTotal: function calculTotal() {
            var total = this.formCarte.qte * this.formCarte.prix;
            this.formCarte.montant = total;
        },
        addListCarte: function addListCarte(formName, item) {
            var _this = this;

            if (this.formCarte.montant < 5) {
                this.$message.error("Veuillez selectionner un montant supérieur ou égale à 5 fcfa");
                return;
            }
            this.$refs[formName].validate(function (valid) {
                if (valid) {

                    _this.tableCarte.push({
                        identifiant: item.identifiant,
                        montant: parseFloat(item.montant),
                        qte: item.qte,
                        prix: item.prix
                    });
                    _this.totalCarte += parseFloat(item.montant);
                    // reinitilisation des champs
                    //this.formCarte.identifiant = ""
                    //this.formCarte.montant = 5
                    _this.resetForm(formName);
                }
            });
        },
        deleteRow: function deleteRow(index, rows) {
            var item = rows.splice(index, 1);
            this.totalCarte -= parseInt(item[0].montant);
        },
        closeDialog: function closeDialog() {
            this.$emit('close');
            // if(this.editForm){
            //   window.location.reload();
            // }
        },
        submitForm: function submitForm(formName) {
            var _this2 = this;

            if (this.typeDmd == "Autre" && this.formDmd.autre == undefined) {
                this.$message.error("Veuillez saisir ou selectionner le libelle");
                return;
            }
            // if(this.formDmd.demandeur == undefined){
            //     this.$message.error("Veuillez saisir ou selectionner le demandeur");
            //     return
            // }
            else if (this.formDmd.caisseSelect == undefined) {
                    this.$message.error("Veuillez selectionner une caisse");
                    return;
                } else if (this.typeDmd == "Projet" && (this.formDmd.projet == undefined || this.formDmd.chantier == undefined || this.formDmd.chantier == '' || this.formDmd.travaux == undefined || this.formDmd.travaux == '')) {
                    // else if(this.typeDmd == "Projet" && (this.formDmd.projet == undefined)){
                    this.$message.error("Veuillez saisir ou selectionner le projet et le chantier");
                    return;
                }
            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this2.loading = true;
                    var form = document.getElementById("formDmd");
                    //recuperation des demandes
                    var data = new FormData(form);
                    var url = "";
                    if (_this2.editForm == false) //creer une nouvelle demande
                        {
                            url = _this2.domaine + 'demandeFond/create';
                        } else //modifier une demande de maintenance
                        {
                            url = _this2.domaine + 'demandeFond/edit';
                            data.append("idDmd", _this2.dmdDetail.id);
                        }

                    if (_this2.typeDmd == "Carburant") {
                        data.append("montant", _this2.totalCarte);
                    } else if (_this2.typeDmd == "Projet") {
                        data.append("montant", _this2.formDmd.montant);
                    } else if (_this2.typeDmd == "Mission") {
                        data.append("montant", _this2.formDmd.montant);
                    }

                    data.append("idProjet", _this2.formDmd.projet);
                    data.append("idChantier", _this2.formDmd.chantier);
                    data.append("idTravaux", _this2.formDmd.travaux);
                    data.append("motif", _this2.formDmd.motif);
                    data.append("typeDmd", _this2.typeDmd);
                    data.append("idCaisse", _this2.formDmd.caisseSelect);
                    data.append("userId", _this2.user.id);
                    data.append("tableCarte", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this2.tableCarte));
                    _this2.$http.post(url, data).then(function (response) {
                        //reinitialiser le formulaire
                        _this2.loading = false;
                        _this2.tableCarte.splice(0);
                        _this2.resetForm('formDmd');
                        _this2.formDmd.motif = '';
                        _this2.successNotif(response.body.message);
                        _this2.closeDialog();
                        if (_this2.editForm) {
                            // window.location.reload();
                        }
                    }, function (erreur) {
                        //reinitialiser le formulaire
                        _this2.loading = false;
                        _this2.resetForm('formDmd');
                        _this2.formDmd.motif = '';
                        _this2.closeDialog();
                        _this2.$message.error("Une erreur est survenue lors de l'enregistrement de la demande de fond");
                    });
                }
            });
        },
        loadDemandeur: function loadDemandeur(queryString, cb) {
            var _this3 = this;

            var url = this.domaine + "mission/listes-employe";
            var formdata = new FormData();
            formdata.append("user", this.user.id);
            formdata.append("tag", queryString);
            this.$http.post(url, formdata).then(function (response) {
                if (response.body) {
                    var links = response.body;
                    var results = queryString ? links.filter(_this3.createFilter(queryString)) : links;
                    cb(results);
                }
            }, function (response) {});
        },
        loadCaisse: function loadCaisse() {
            var _this4 = this;

            var url = this.domaine + "caisse/index";
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this4.listeCaisse = response.body.caisse;
                }
            });
        },
        loadZone: function loadZone(queryString, cb) {
            var _this5 = this;

            var url = this.domaine + 'demandeFond/listes-zone';
            var formdata = new FormData();
            formdata.append('user', this.user.id);
            formdata.append('tag', queryString);
            this.$http.post(url, formdata).then(function (response) {
                if (response.body) {
                    var links = response.body;
                    var results = queryString ? links.filter(_this5.createFilter(queryString)) : links;
                    cb(results);
                }
            }, function (response) {});
        },
        loadAutre: function loadAutre(queryString, cb) {
            var _this6 = this;

            var url = this.domaine + 'demandeFond/listes-autre';
            var formdata = new FormData();
            formdata.append('user', this.user.id);
            formdata.append('tag', queryString);
            this.$http.post(url, formdata).then(function (response) {
                if (response.body) {
                    var links = response.body;
                    var results = queryString ? links.filter(_this6.createFilter(queryString)) : links;
                    cb(results);
                }
            }, function (response) {});
        },
        createFilter: function createFilter(queryString) {
            return function (link) {
                return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
        resetForm: function resetForm(formName) {
            this.formCarte.qte = 1;
            this.formCarte.prix = 1;
            this.formCarte.montant = 1;
            this.$refs[formName].resetFields();
            this.formDmd.montant = 5;
        },
        handleChangeCaisse: function handleChangeCaisse(idCaisse) {
            //this.caisseSelect = idCaisse
            this.formDmd.caisseSelect = idCaisse;
        },
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        },
        selectProjet: function selectProjet(idProjet) {
            this.listeChantier.splice(0);
            //this.formDmd.chantier = '';
            this.loadChantier(idProjet);
        },
        selectChantier: function selectChantier(idChantier) {
            this.loadTravaux(idChantier);
        },
        loadProjet: function loadProjet() {
            var _this7 = this;

            var url = this.domaine + 'projet/index-projet-all';
            this.loading = true;
            this.$http.get(url).then(function (response) {
                _this7.loading = false;
                _this7.listeProjet = response.body.projet;
            }, function (errRep) {
                _this7.loading = false;
                _this7.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
            });
        },
        loadChantier: function loadChantier(item) {
            var _this8 = this;

            this.loading = true;
            //this.formDmd.chantier = '';
            var url = this.domaine + 'projet/' + item + '/index/chantier';
            this.$http.get(url).then(function (response) {
                _this8.loading = false;
                _this8.listeChantier = response.body.chantier;
                _this8.listeChantier.length > 0 ? _this8.formDmd.chantier == _this8.listeChantier[0].id : null;
                _this8.loadTravaux(item);
                _this8.loadCaisseProjet(item);
            }, function (errRep) {
                _this8.loading = false;
                _this8.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
            });
        },
        loadTravaux: function loadTravaux(item) {
            var _this9 = this;

            this.loading = true;
            //this.formDmd.chantier = '';
            var url = this.domaine + 'projet/' + item + '/index/chantier/search';
            this.$http.get(url).then(function (response) {
                _this9.loading = false;
                _this9.listeTravaux = response.body.chantier[0].travaux;
            }, function (errRep) {
                _this9.loading = false;
                _this9.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
            });
        },
        loadCaisseProjet: function loadCaisseProjet(item) {
            var _this10 = this;

            if (item !== '') {
                this.loading = true;
                var url = this.domaine + 'caisse/project/' + item;
                this.$http.get(url).then(function (response) {
                    if (response.body) {
                        _this10.loading = false;
                        _this10.formDmd.caisseSelect = response.body.caisse.id;
                        _this10.disabledSelectCaisse = true;
                    }
                }, function (error) {
                    _this10.loading = false;
                });
            } else {
                this.disabledSelectCaisse = false;
                this.loading = false;
            }
        },
        loadCarte: function loadCarte() {
            var _this11 = this;

            var url = this.domaine + 'carteCarburant/index';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this11.listeCarte = response.body.cartes;
                }
            });
        }
    },

    mounted: function mounted() {
        this.loadProjet();
        this.loadCaisse();
        this.loadCarte();
    }
});

/***/ }),

/***/ "jg7/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboardProjet_vue__ = __webpack_require__("Kt0c");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_761197f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboardProjet_vue__ = __webpack_require__("7kbu");
function injectStyle (ssrContext) {
  __webpack_require__("4q6j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboardProjet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_761197f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboardProjet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jyJz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__ = __webpack_require__("qgpy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55fe8983_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__ = __webpack_require__("mnDS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55fe8983_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k5w0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutZoneResponsable),callback:function ($$v) {_vm.dialogAjoutZoneResponsable=$$v},expression:"dialogAjoutZoneResponsable"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Attribuer une zone a un responsable "+_vm._s(_vm.userResponsable.nom))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enregistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-alert',{attrs:{"value":true,"type":"warning"}},[_vm._v("\n                                NB: La responsabilite d'une zone comporte egalement tous les sous zones qui la composent\n                            ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"text-md-center",attrs:{"md12":""}},[_c('div',[_c('el-transfer',{staticStyle:{"text-align":"left","display":"inline-block"},attrs:{"filterable":"","filter-placeholder":"Recherche","titles":['Zone libre', 'Zone selectionnee'],"left-default-checked":[2, 3],"data":_vm.listeZone},model:{value:(_vm.zoneSelect),callback:function ($$v) {_vm.zoneSelect=$$v},expression:"zoneSelect"}})],1)]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"md12":""}},[_c('v-btn',{attrs:{"dark":"","color":"grey"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","dark":"","color":"green","disabled":!_vm.valid},on:{"click":function($event){return _vm.submitZone()}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kBig":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"divider":"/"}},_vm._l((_vm.items),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n           "+_vm._s(item.text)+"\n         ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('div',[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick1(_vm.tab1)}},model:{value:(_vm.tab1),callback:function ($$v) {_vm.tab1=$$v},expression:"tab1"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" LISTE DES TYPES CHANTIERS\n           ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-4 mt-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Selectionner un Type de chantier"},on:{"change":function($event){return _vm.filtrerTypeProjet()}},model:{value:(_vm.selectSearchTypeProjet),callback:function ($$v) {_vm.selectSearchTypeProjet=$$v},expression:"selectSearchTypeProjet"}},_vm._l((_vm.itemsTypeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.libelle.toUpperCase()))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v("( "+_vm._s(item.ref)+")")])])}),1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.new_type_projet)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newTypeProjet()}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e(),_vm._v("\n                   Ajouter un nouveau type de chantier\n                 ")],1)],1)],1)],1),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listTypeProjet}},[_c('el-table-column',{attrs:{"prop":"code","label":"Code de type chantier","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"orange--text title"},[_vm._v(_vm._s(scope.row.code))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{staticClass:"body-2"},[_vm._v(_vm._s(scope.row.libelle))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.show_type_projet)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showTypeProjet(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1):_vm._e(),_vm._v("\n                     Détails\n                   ")],1),_vm._v(" "),(_vm.droitAcces.edit_type_projet)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editTypeProjet(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                     Modifier\n                   ")],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprTyp = true;
                         _vm.idAppro = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                     Supprimer\n                   ")],1)],1)]}}])})],1)],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" LISTE DES LOTS\n           ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('data-tables',{attrs:{"data":_vm.listeProjetTravaux}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Liste des travaux")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2 mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"grid-content"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"row-class-name":_vm.tableRowClassName,"data":props.row.listeTypeTravaux,"stripe":""}},[_c('el-table-column',{attrs:{"prop":"ordre","label":"Ordre","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(scope.row.ordre))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"code","label":"Code","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(scope.row.code))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"green--text subheading"},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.show_travaux)?_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showTravaux(scope.row)}},slot:"activator"},[_vm._v("\n                                                 Détails\n                                             ")]):_vm._e(),_vm._v("\n                                             Détails\n                                         ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.show_travaux)?_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.editType(scope.row,'travaux')}},slot:"activator"},[_vm._v("\n                                                 Modifier\n                                             ")]):_vm._e(),_vm._v("\n                                             Modifier\n                                         ")],1)],1)]}}],null,true)})],1)],1)],1)],1)],1)])],1)],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"reference","label":"Référence","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"orange--text title"},[_vm._v(_vm._s(scope.row.reference))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type chantier","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{staticClass:"body-2"},[_vm._v("\n                   "+_vm._s(scope.row.libelle)+"\n                 ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.newTravaux(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1),_vm._v("\n                    Ajouter/Modifier un lot de travaux\n                   ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.duplicateTravaux(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("content_copy")])],1),_vm._v("\n                      Dupliquer les travaux\n                   ")],1)],1)]}}])})],1)],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" LISTE DES TÂCHES\n           ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('data-tables',{attrs:{"data":_vm.listeTacheTravaux}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Liste des travaux ")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2 mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"grid-content"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"row-class-name":_vm.tableRowClassName,"data":props.row.listeTypeTravaux,"stripe":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.nbSous > 0)?_c('div',[_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Liste des sous sections")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2 mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"grid-content"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"row-class-name":_vm.tableRowClassName,"data":props.row.sous,"stripe":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Liste des tâches")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2 mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"grid-content"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"row-class-name":_vm.tableRowClassName,"data":props.row
                                                                                                 .listeTypeTache,"stripe":""}},[_c('el-table-column',{attrs:{"prop":"ordre","label":"Ordre","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(scope.row
                                                                                                       .ordre))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"green--text subheading"},[_vm._v(_vm._s(scope.row
                                                                                                       .libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"unite"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(scope.row
                                                                                                       .unite))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"prix (FCFA)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(new Intl.NumberFormat(
                                                                                                       "fr-FR"
                                                                                                     ).format(
                                                                                                       scope.row
                                                                                                         .prix
                                                                                                     )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showTravaux(scope.row)}},slot:"activator"},[_vm._v("\n                                                                                                           Détails\n                                                                                                       ")]),_vm._v("\n                                                                                                       Détails\n                                                                                                   ")],1)],1)]}}],null,true)})],1)],1)],1)],1)],1)])],1)],1)],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ordre","label":"Ordre"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(scope.row.ordre))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"code","label":"Code","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(scope.row.code)+" ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"green--text subheading"},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.show_travaux)?_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showTravaux(scope.row)}},slot:"activator"},[_vm._v("\n                                                                                               Détails\n                                                                                           ")]):_vm._e(),_vm._v("\n                                                                                           Détails\n                                                                                       ")],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.newTache(scope.row,'niveau')}},slot:"activator"},[_vm._v("\n                                                                                                 Ajouter\n                                                                                             ")]),_vm._v("\n                                                                                             Ajouter/Modifier un lot de tache\n                                                                                         ")],1)],1),_vm._v(" "),(scope.row.nbSous === 0)?_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.duplicateTaches(scope.row,props.row)}},slot:"activator"},[_vm._v("\n                                                                                                 Dupliquer\n                                                                                             ")]),_vm._v("\n                                                                                             Dupliquer les tâches\n                                                                                         ")],1)],1):_vm._e()]}}],null,true)})],1)],1)],1)],1)],1)])],1)],1)],1)],1):_c('div',[_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Liste des tâches ")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2 mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"grid-content"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"row-class-name":_vm.tableRowClassName,"data":props.row.listeTypeTache,"stripe":""}},[_c('el-table-column',{attrs:{"prop":"ordre","label":"Ordre","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(scope.row
                                                                                 .ordre))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"green--text subheading"},[_vm._v(_vm._s(scope.row
                                                                                 .libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"unite"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(scope.row
                                                                                 .unite))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"prix (FCFA)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(new Intl.NumberFormat(
                                                                                 "fr-FR"
                                                                               ).format(
                                                                                 scope.row
                                                                                   .prix
                                                                               )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showTravaux(scope.row)}},slot:"activator"},[_vm._v("\n                                                                                     Détails\n                                                                                 ")]),_vm._v("\n                                                                                 Détails\n                                                                             ")],1)],1)]}}],null,true)})],1)],1)],1)],1)],1)])],1)],1)],1)],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ordre","label":"Ordre"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(scope.row.ordre))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"code","label":"Code","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"grey--text title"},[_vm._v(_vm._s(scope.row.code))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"green--text subheading"},[_vm._v(_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.nbSous == 0 && scope.row.sous.length == 0 && scope.row.listeTypeTache.length == 0)?_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.newNiveau(scope.row)}},slot:"activator"},[_vm._v("\n                                                             Ajouter un niveau\n                                                         ")]),_vm._v("\n                                                         Ajouter/Editer un niveau\n                                                     ")],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.show_travaux)?_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showTravaux(scope.row)}},slot:"activator"},[_vm._v("\n                                                      Détails\n                                                       ")]):_vm._e(),_vm._v("\n                                                       Détails\n                                                   ")],1)],1),_vm._v(" "),(scope.row.nbSous > 0)?_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.newNiveau(scope.row)}},slot:"activator"},[_vm._v("\n                                                             Editer\n                                                         ")]),_vm._v("\n                                                         Ajouter/Editer la sous section\n                                                     ")],1)],1):_vm._e(),_vm._v(" "),(scope.row.nbSous == 0 )?_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.newTache(scope.row)}},slot:"activator"},[_vm._v("\n                                                             Ajouter\n                                                         ")]),_vm._v("\n                                                         Ajouter/Modifier un lot de tache\n                                                     ")],1)],1):_vm._e(),_vm._v(" "),(scope.row.nbSous == 0)?_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.duplicateTaches(scope.row,props.row)}},slot:"activator"},[_vm._v("\n                                                             Dupliquer\n                                                         ")]),_vm._v("\n                                                         Dupliquer les tâches\n                                                     ")],1)],1):_vm._e()]}}],null,true)})],1)],1)],1)],1)],1)])],1)],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"reference","label":"Référence","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"orange--text title"},[_vm._v(_vm._s(scope.row.reference))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type chantier","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{staticClass:"body-2"},[_vm._v("\n                   "+_vm._s(scope.row.libelle)+"\n                 ")])]}}])})],1)],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" LISTE DES CATEGORIES DE RESSOURCES\n           ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newTypeRessource()}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n                   Ajouter/Editer un nouveau type de ressource\n                 ")],1)],1)],1)],1),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listTypeRessource}},[_c('el-table-column',{attrs:{"prop":"code","label":"Code"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{staticClass:"body-2"},[_vm._v(_vm._s(scope.row.code))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{staticClass:"body-2"},[_vm._v(_vm._s(scope.row.libelle))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showTypeRessource(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                     Détails\n                   ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editTypeRessource(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                     Modifier\n                   ")],1)],1)]}}])})],1)],1),_vm._v(" "),(_vm.droitAcces.product_list)?_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" LISTE DES RESSOURCES\n           ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-4 mt-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"valeurSelect","clearable":"","id":"valeurSelect","filterable":"","placeholder":"Sélectionner un type ressource"},on:{"change":function($event){return _vm.loadTypeProduit()}},model:{value:(_vm.IdTypeSelct),callback:function ($$v) {_vm.IdTypeSelct=$$v},expression:"IdTypeSelct"}},_vm._l((_vm.listTypeRessource),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Sélectionner une ressource"},on:{"clear":function($event){return _vm.clearSelectProduit()},"change":_vm.filtrerEtatPrioriteBesoin},model:{value:(_vm.IdProduiSelect),callback:function ($$v) {_vm.IdProduiSelect=$$v},expression:"IdProduiSelect"}},_vm._l((_vm.listeProduitAffich),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.index_type_tache && _vm.droitAcces.create_new_product)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newProduit()}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e(),_vm._v("\n                   Ajouter une nouvelle ressource\n                 ")],1)],1)],1)],1),_vm._v(" "),(_vm.droitAcces.index_type_tache && _vm.droitAcces.create_new_product)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('input',{ref:"fileInputExcel",staticStyle:{"display":"none"},attrs:{"name":"fileInputExcel","type":"file","accept":"image/*"},on:{"change":_vm.onFileExcelPicked}}),_vm._v(" "),(true)?_c('v-btn',{attrs:{"slot":"activator","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$refs.fileInputExcel.click()}},slot:"activator"},[_vm._v("\n                           Importer\n                           "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_download")])],1):_vm._e(),_vm._v("Importer fichier excel\n                 ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.generateFileExcel()}},slot:"activator"},[_vm._v("\n                     Générer\n                     "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1):_vm._e(),_vm._v("Générer un modèle\n                 ")],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeProduitAffich}},[_c('el-table-column',{attrs:{"prop":"value","label":"Code gestion","fixed":"left","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"indigo"}},[_vm._v("\n                   "+_vm._s(scope.row.codeGestion)+"\n                 ")])]}}],null,false,3659348860)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"codeAnalytique","label":"Code Analytique","fixed":"left","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                   "+_vm._s(scope.row.codeAnalytique)+"\n                 ")])]}}],null,false,1506241999)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"Référence/Libellé","fixed":"left","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                   "+_vm._s(scope.row.reference)+"\n                 ")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                   "+_vm._s(scope.row.value)+"\n                 ")])]}}],null,false,1411318637)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                   "+_vm._s(scope.row.type)+"\n                 ")])]}}],null,false,2907065559)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"valeur","label":"Prix de (vente ou d'utilisation) (FCFA)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"indigo","label":"","color":"indigo"}},[_vm._v("\n                   "+_vm._s(new Intl.NumberFormat("fr-FR").format(scope.row.valeur))+"\n                   "),_c('v-icon',{attrs:{"right":""}},[_vm._v("money")])],1)]}}],null,false,3039762649)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unite","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                   "+_vm._s(scope.row.unite)+"\n                 ")])]}}],null,false,192966540)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();_vm.tab = '0';
                       _vm.showProduit(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                     Détails\n                   ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editProduit(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                     Modifier\n                   ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprProd = true;
                         _vm.idAppro = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                     Supprimer\n                   ")],1)],1)]}}],null,false,698030675)})],1)],1):_vm._e()],1)],1)]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprCategorie),callback:function ($$v) {_vm.dialogSuprCategorie=$$v},expression:"dialogSuprCategorie"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n           Voulez-vous vraiment supprimer cette categorie ?\n         ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprCategorie = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteCategory($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprKeyword),callback:function ($$v) {_vm.dialogSuprKeyword=$$v},expression:"dialogSuprKeyword"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer ce mot cle ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprKeyword = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteKeyword($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprLexique),callback:function ($$v) {_vm.dialogSuprLexique=$$v},expression:"dialogSuprLexique"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer ce champ ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprLexique = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteLexique($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupTarif),callback:function ($$v) {_vm.dialogSupTarif=$$v},expression:"dialogSupTarif"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h1',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer \""+_vm._s(_vm.selectProduit)+"\" de la tarification chez "+_vm._s(_vm.tarifCourant.fourn)+" ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupTarif = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteTarification($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutCategory),callback:function ($$v) {_vm.dialogAjoutCategory=$$v},expression:"dialogAjoutCategory"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter une nouvelle categorie")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutCategory = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formCategorie",attrs:{"lazy-validation":"","id":"formCategorie"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-text-field',{attrs:{"label":"Libelle","name":"libelleCategorie","required":""},model:{value:(_vm.libelleCategorie),callback:function ($$v) {_vm.libelleCategorie=$$v},expression:"libelleCategorie"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-textarea',{attrs:{"label":"Description","name":"descCategorie","multi-line":"","required":""},model:{value:(_vm.descCategorie),callback:function ($$v) {_vm.descCategorie=$$v},expression:"descCategorie"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutCategory = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.addCategorie}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"85%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutProduit),callback:function ($$v) {_vm.dialogAjoutProduit=$$v},expression:"dialogAjoutProduit"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEditProduit !== true)?_c('span',[_vm._v("Ajouter une nouvelle ressource")]):_vm._e(),_vm._v(" "),(_vm.dialogEditProduit)?_c('span',[_vm._v("Modifier la ressource")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutProduit = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('v-form',{ref:"formProduit",attrs:{"lazy-validation":"","id":"formProduit"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Catégorie de ressource *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Catégorie ressource"},on:{"change":function($event){return _vm.SelectionTypePrdotuit(_vm.typeProduit)}},model:{value:(_vm.typeProduit),callback:function ($$v) {_vm.typeProduit=$$v},expression:"typeProduit"}},_vm._l((_vm.listTypeRessource),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Code catégorie *")]),_vm._v(" "),_c('el-input',{attrs:{"name":"codeType","disabled":""},model:{value:(_vm.codeType),callback:function ($$v) {_vm.codeType=$$v},expression:"codeType"}})],1)])],1),_vm._v(" "),(_vm.dialogEditProduit != true)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md11":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                     AJOUTER LES LIGNES DE PRODUITS\n                   ")])],1)])],1):_vm._e(),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formTypeProduit}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Code article")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","allow-create":"","filterable":"","placeholder":"Code article"},model:{value:(_vm.codeGestion),callback:function ($$v) {_vm.codeGestion=$$v},expression:"codeGestion"}},_vm._l((_vm.listcodeGestion),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Code analytique")]),_vm._v(" "),_c('el-input',{attrs:{"name":"codeAnalytique","placeholder":"Code anlytique"},model:{value:(_vm.formTypeProduit.codeAnalytique),callback:function ($$v) {_vm.$set(_vm.formTypeProduit, "codeAnalytique", $$v)},expression:"formTypeProduit.codeAnalytique"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Référence")]),_vm._v(" "),_c('el-input',{attrs:{"name":"referenceProduit","placeholder":"Reference"},model:{value:(_vm.formTypeProduit.referenceProduit),callback:function ($$v) {_vm.$set(_vm.formTypeProduit, "referenceProduit", $$v)},expression:"formTypeProduit.referenceProduit"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Libellé *")]),_vm._v(" "),_c('el-input',{staticClass:"upper",attrs:{"name":"libelleProduit","placeholder":"Libelle"},model:{value:(_vm.formTypeProduit.libelleProduit),callback:function ($$v) {_vm.$set(_vm.formTypeProduit, "libelleProduit", $$v)},expression:"formTypeProduit.libelleProduit"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix de (vente ou d'utilisation)(FCFA) *")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","name":"valeurProduit","placeholder":"Prix de vente ou d'utilisation"},model:{value:(_vm.formTypeProduit.valeurProduit),callback:function ($$v) {_vm.$set(_vm.formTypeProduit, "valeurProduit", $$v)},expression:"formTypeProduit.valeurProduit"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité * ")]),_vm._v(" "),_c('el-input',{staticClass:"upper",attrs:{"name":"libelleUnite","placeholder":"Unité"},model:{value:(_vm.formTypeProduit.libelleUnite),callback:function ($$v) {_vm.$set(_vm.formTypeProduit, "libelleUnite", $$v)},expression:"formTypeProduit.libelleUnite"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"descProduit","type":"textarea","rows":3},model:{value:(_vm.formTypeProduit.descProduit),callback:function ($$v) {_vm.$set(_vm.formTypeProduit, "descProduit", $$v)},expression:"formTypeProduit.descProduit"}})],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[(_vm.dialogEditProduit != true && this.tableTypeProduit.length != 5)?_c('v-btn',{attrs:{"icons":"","color":"primary","id":"plus","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addListProduit(_vm.formTypeProduit)}}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),(_vm.dialogEditProduit !== true)?_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableTypeProduit}},[_vm._l((_vm.tachesTypeProduit),function(column){return _c('el-table-column',{key:column.id,attrs:{"prop":column.prop,"label":column.label,"sortable":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteTypeProduit(scope.$index, _vm.tableTypeProduit)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                       Supprimer cette ressource\n                     ")],1)]}}],null,false,1708886536)})],2)],1):_vm._e()],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutProduit = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.addProduit}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutTache),callback:function ($$v) {_vm.dialogAjoutTache=$$v},expression:"dialogAjoutTache"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit !== true)?_c('span',[_vm._v("Ajouter une nouvelle tâche ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modifier la tâche "+_vm._s(_vm.tacheCourant.libelle)+"\n           ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutTache = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('v-form',{ref:"formTache",attrs:{"lazy-validation":"","id":"formTache"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de projet ")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Type de projet"},on:{"change":function($event){return _vm.loadTravaux()}},model:{value:(_vm.typeProjet),callback:function ($$v) {_vm.typeProjet=$$v},expression:"typeProjet"}},_vm._l((_vm.listTypeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Travaux"},model:{value:(_vm.travaux),callback:function ($$v) {_vm.travaux=$$v},expression:"travaux"}},_vm._l((_vm.listTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md11":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                     AJOUTER LES LIGNES DES TACHES\n                   ")])],1)])],1):_vm._e(),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formTache}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Libellé tâche*")]),_vm._v(" "),_c('el-input',{staticClass:"upper",staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Libellé tâche"},model:{value:(_vm.formTache.libelle),callback:function ($$v) {_vm.$set(_vm.formTache, "libelle", $$v)},expression:"formTache.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ordre d'éxécution")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","value":1,"id":"ordreTache","name":"ordre","min":1,"placeholder":"Ordre"},model:{value:(_vm.formTache.ordre),callback:function ($$v) {_vm.$set(_vm.formTache, "ordre", $$v)},expression:"formTache.ordre"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unite ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"unite","placeholder":"Unite"},model:{value:(_vm.formTache.unite),callback:function ($$v) {_vm.$set(_vm.formTache, "unite", $$v)},expression:"formTache.unite"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix unitaire HT ")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":0,"name":"prix","placeholder":"prix unitaire"},model:{value:(_vm.formTache.prix),callback:function ($$v) {_vm.$set(_vm.formTache, "prix", $$v)},expression:"formTache.prix"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"description","placeholder":"Description"},model:{value:(_vm.formTache.description),callback:function ($$v) {_vm.$set(_vm.formTache, "description", $$v)},expression:"formTache.description"}})],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}})],1),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-btn',{attrs:{"icons":"","color":"primary","id":"plus","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addListTaches(_vm.formTache)}}},[_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableTaches}},[_vm._l((_vm.taches),function(column){return _c('el-table-column',{key:column.id,attrs:{"prop":column.prop,"label":column.label,"sortable":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteTache(scope.$index, _vm.tableTaches)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                       Supprimer ce lot\n                     ")],1)]}}],null,false,2528725424)})],2)],1):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutTache = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submitTache}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutTravaux),callback:function ($$v) {_vm.dialogAjoutTravaux=$$v},expression:"dialogAjoutTravaux"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit !== true)?_c('span',[_vm._v("Ajouter des nouveaux lots ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modifier les lots "+_vm._s(_vm.travauxCourant.libelle)+"\n           ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutTravaux = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('v-card',[_c('v-form',{ref:"formTravaux",attrs:{"lazy-validation":"","id":"formTravaux"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de projet ")]),_vm._v(" "),(_vm.dialogEdit == false)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Type de projet"},model:{value:(_vm.typeProjet),callback:function ($$v) {_vm.typeProjet=$$v},expression:"typeProjet"}},_vm._l((_vm.listTypeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true},model:{value:(_vm.travauxCourant.type),callback:function ($$v) {_vm.$set(_vm.travauxCourant, "type", $$v)},expression:"travauxCourant.type"}}):_vm._e()],1)])],1),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md11":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                       AJOUTER LES LIGNES DE LOTS\n                     ")])],1)])],1):_vm._e(),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formTravaux}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Libelle lot *")]),_vm._v(" "),_c('el-input',{staticClass:"upper",staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Libellé lot"},model:{value:(_vm.formTravaux.libelle),callback:function ($$v) {_vm.$set(_vm.formTravaux, "libelle", $$v)},expression:"formTravaux.libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ordre d'éxécution")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","value":1,"id":"ordre","name":"ordre","min":1,"placeholder":"ordre"},model:{value:(_vm.formTravaux.ordre),callback:function ($$v) {_vm.$set(_vm.formTravaux, "ordre", $$v)},expression:"formTravaux.ordre"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Code ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"code","placeholder":"code lot"},model:{value:(_vm.formTravaux.code),callback:function ($$v) {_vm.$set(_vm.formTravaux, "code", $$v)},expression:"formTravaux.code"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"description","placeholder":"Description"},model:{value:(_vm.formTravaux.description),callback:function ($$v) {_vm.$set(_vm.formTravaux, "description", $$v)},expression:"formTravaux.description"}})],1)])],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}})],1),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-btn',{attrs:{"icons":"","color":"primary","id":"plus","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addListParticipantDemande(_vm.formTravaux)}}},[_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableLots}},[_vm._l((_vm.columns),function(column){return _c('el-table-column',{key:column.id,attrs:{"prop":column.prop,"label":column.label,"sortable":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableLots)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                         Supprimer ce lot\n                       ")],1)]}}],null,false,2509338125)})],2)],1):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutTravaux = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitTravaux()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowCategorie),callback:function ($$v) {_vm.dialogShowCategorie=$$v},expression:"dialogShowCategorie"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails de la catégorie ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowCategorie = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":20}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"carte-header",attrs:{"slot":"header"},slot:"header"},[_c('v-flex',{attrs:{"text-xs-center":"","layout":"","align-center":"","justify-center":""}})],1),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('p',[_c('b',[_vm._v("Libellé : ")]),_vm._v(" "+_vm._s(_vm.currentCategorie.libelle))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description : ")]),_vm._v(" "+_vm._s(_vm.currentCategorie.description)+"\n                   ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v("\n                     "+_vm._s(_vm.currentCategorie.created)+"\n                   ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v("\n                     "+_vm._s(_vm.currentCategorie.modified)+"\n                   ")])])])],1)])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"90%","overlay":false,"scrollable":""},model:{value:(_vm.dialogShowProduit),callback:function ($$v) {_vm.dialogShowProduit=$$v},expression:"dialogShowProduit"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails de la ressource "+_vm._s(_vm.currentProduit.value))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeShowProdui()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-expansion-panel',[_c('v-expansion-panel-content',{staticClass:"blue lighten-4 elevation-18"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                 CLIQUEZ POUR AFFICHER LES DETAILS DE LA RESSOURCE\n                 "),_c('i',{staticClass:"el-icon-tickets"})]),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Type : ")]),_vm._v(" "+_vm._s(_vm.currentProduit.type))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Code article : ")]),_vm._v(" "+_vm._s(_vm.currentProduit.codeGestion))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Réference : ")]),_vm._v(" "+_vm._s(_vm.currentProduit.ref))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Prix de (vente ou d'utilisation) (FCFA) : ")]),_vm._v("\n                       "+_vm._s(new Intl.NumberFormat("fr-FR").format(
                           _vm.currentProduit.valeur
                         ))+"\n                     ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Unité : ")]),_vm._v(" "+_vm._s(_vm.currentProduit.unite))])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Description : ")]),_vm._v(" "+_vm._s(_vm.currentProduit.description)+"\n                     ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v("\n                       "+_vm._s(_vm.currentProduit.created)+"\n                     ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v("\n                       "+_vm._s(_vm.currentProduit.modified)+"\n                     ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Modifié par :")]),_vm._v("\n                       "+_vm._s(_vm.currentProduit.userModified)+"\n                     ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Taux d'utilisation")])]),_vm._v(" "),_c('v-progress-circular',{attrs:{"size":100,"width":30,"rotate":360,"value":_vm.currentProduit.evolution,"color":"red"}},[_vm._v(_vm._s(_vm.currentProduit.evolutionNbr)+" %")])],1)],1)],1)])],1)])],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":function($event){return _vm.TabClick(_vm.tab)}},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-list"}),_vm._v(" PRIX FOURNISSEURS\n                 ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify":""}},[_c('v-layout',{attrs:{"mb-2":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-flex',{staticClass:"text-xs-center"},[_c('v-card',{staticClass:"elevation-5",staticStyle:{"height":"350px"}},[_c('h4',[_vm._v("Statistiques fournisseurs")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-1"}),_vm._v(" "),_c('div',{staticClass:"mb-2",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"chartFactureAnFour"}})],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-expansion-panel',{attrs:{"focusable":"","popout":"","value":"0"}},[_c('v-expansion-panel-content',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(" "+_vm._s(_vm.listeProduitFourn.length)+" ")]),_vm._v("\n                                   Fournisseur(s) trouvé(s)\n                                 ")],1)],1)]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-5"},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeProduitFourn}},[_c('el-table-column',{attrs:{"prop":"value","label":"REF FOURNISSEUR\t","fixed":"left","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"indigo"}},[_vm._v("\n                                         "+_vm._s(scope.row.ref)+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"FOURNISSEUR","fixed":"left","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                         "+_vm._s(scope.row.fourn)+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"valeur","label":"PRIX UNITAIRE HT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"indigo","label":"","color":"indigo"}},[_vm._v("\n                                         "+_vm._s(new Intl.NumberFormat("fr-FR").format(scope.row.prix))+"\n                                         "),_c('v-icon',{attrs:{"right":""}},[_vm._v("money")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixOld","label":"Ancien prix","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                         "+_vm._s(scope.row.prixOld)+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unite","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                         "+_vm._s(scope.row.unite)+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userCreated","label":"Crée par","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                         "+_vm._s(scope.row.userCreated)+"\n                                       ")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"indigo"}},[_vm._v("\n                                        "+_vm._s(scope.row.created ?  scope.row.created : '')+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userCreated","label":"Modifier par","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                         "+_vm._s(scope.row.userUpdate)+"\n                                       ")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                         "+_vm._s(scope.row.modified)+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editTarif(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                                           Modifier\n                                         ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();return _vm.deleteTarif(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                                           Supprimer\n                                         ")],1)],1)]}}])})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-menu"}),_vm._v(" COMMANDES LIEES A LA RESSOURCE\n                 ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify":""}},[_c('v-layout',{attrs:{"mb-2":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-flex',{staticClass:"text-xs-center"},[_c('v-card',{staticClass:"elevation-5",staticStyle:{"height":"350px"}},[_c('h4',[_vm._v("Statistiques commandes")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-1"}),_vm._v(" "),_c('div',{staticClass:"mb-2",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"chartCommFour"}})],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-expansion-panel',{attrs:{"focusable":"","popout":"","value":"1"}},[_c('v-expansion-panel-content',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(" "+_vm._s(_vm.listeCommandeFourn.length)+" ")]),_vm._v("\n                                   Commande(s) trouvée(s)\n                                 ")],1)],1)]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-5"},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeCommandeFourn}},[_c('el-table-column',{attrs:{"prop":"idProj","label":"ID PROJ","fixed":"left","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"indigo"}},[_vm._v("\n                                         "+_vm._s(scope.row.idProj)+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref","label":"REF COMMANDE","fixed":"left","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"indigo"}},[_vm._v("\n                                         "+_vm._s(scope.row.ref)+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projet","label":"PROJET","fixed":"left","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                         "+_vm._s(scope.row.projet)+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":"FOURNISSEUR","fixed":"left","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                         "+_vm._s(scope.row.fournisseurNom)+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"QUANTITE COMMANDEE","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                         "+_vm._s(scope.row.qte)+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"valeur","label":"PRIX UNITAIRE HT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"indigo","label":"","color":"indigo"}},[_vm._v("\n                                         "+_vm._s(new Intl.NumberFormat("fr-FR").format(scope.row.prix))+"\n                                         "),_c('v-icon',{attrs:{"right":""}},[_vm._v("money")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"UNITE","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                         "+_vm._s(scope.row.unite)+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"TOTAL TTC","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                         "+_vm._s(scope.row.total)+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userCreated","label":"ENREGISTRER PAR","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                         "+_vm._s(scope.row.userCreated)+"\n                                       ")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"indigo"}},[_vm._v("\n                                        "+_vm._s(scope.row.created ?  scope.row.created : '')+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"compare","label":"COMPARATEUR"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.compare == 2)?[_c('a',{attrs:{"href":"#"}},[_c('v-avatar',{attrs:{"tile":true,"size":"50px","height":"50px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":"static/validComparateur.png"}})])],1)]:undefined}}],null,true)})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")]),_vm._v(" STOCKS ENTREPOT\n                 ")],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","justify":""}},[_c('v-layout',{attrs:{"mb-2":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-flex',{staticClass:"text-xs-center"},[_c('v-card',{staticClass:"elevation-5",staticStyle:{"height":"350px"}},[_c('h4',[_vm._v("Statistiques stocks")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-1"}),_vm._v(" "),_c('div',{staticClass:"mb-2",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"chartStockProd"}})],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-expansion-panel',{attrs:{"focusable":"","popout":"","value":"2"}},[_c('v-expansion-panel-content',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(" "+_vm._s(_vm.listeStokProd.length)+" ")]),_vm._v("\n                                   Entrepot(s) trouvé(s)\n                                 ")],1)],1)]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-5"},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeStokProd}},[_c('el-table-column',{attrs:{"prop":"value","label":"ENTREPOT","fixed":"left","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                         "+_vm._s(scope.row.entrepot)+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ville","label":"Localisation"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                         "+_vm._s(scope.row.ville)+" - "+_vm._s(scope.row.commune)+" - "+_vm._s(scope.row.quartier)),_c('v-icon',{attrs:{"right":""}},[_vm._v("location_on")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"QUANTITE DISPONIBLE","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                         "+_vm._s(scope.row.qte)+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"UNITE","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                         "+_vm._s(scope.row.unite)+"\n                                       ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userCreated","label":"DATE AJOUT","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"indigo"}},[_vm._v("\n                                        "+_vm._s(scope.row.created ?  scope.row.created : '')+"\n                                       ")])]}}])})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowProduit = false}},slot:"activator"},[_vm._v("\n               Fermer\n               "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("Fermer\n           ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.new_projet)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editProduit(_vm.currentProduit)}},slot:"activator"},[_vm._v("\n               Modifer\n               "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("Modifier\n           ")],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogTarif),callback:function ($$v) {_vm.dialogTarif=$$v},expression:"dialogTarif"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Modifier la tarification chez le fournisseur "+_vm._s(_vm.tarifCourant.fourn))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogTarif = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formTarif",attrs:{"lazy-validation":"","id":"formTarif"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"valeurSelect","readonly":true},model:{value:(_vm.valeurUniteMateriel),callback:function ($$v) {_vm.valeurUniteMateriel=$$v},expression:"valeurUniteMateriel"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix d'achat *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","name":"prixAchat","min":0,"placeholder":"Prix d'achat"},model:{value:(_vm.prixAchat),callback:function ($$v) {_vm.prixAchat=$$v},expression:"prixAchat"}})],1)])],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogTarif = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){_vm.dialogConfirm = true}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h2',{attrs:{"align":"center"}},[_vm._v("La modification sera prise en compte pour les nouvelles commandes")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogTarif = false;_vm.dialogConfirm = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.submitTarif($event)}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowTypeProjet),callback:function ($$v) {_vm.dialogShowTypeProjet=$$v},expression:"dialogShowTypeProjet"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du type de projet "+_vm._s(_vm.typeProjetCourant.ref)+" /\n           "+_vm._s(_vm.typeProjetCourant.libelle)+"\n         ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowTypeProjet = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Référence : ")]),_vm._v(" "+_vm._s(_vm.detailTypeProjet.ref))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Code : ")]),_vm._v(" "+_vm._s(_vm.detailTypeProjet.code))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libelle : ")]),_vm._v(" "+_vm._s(_vm.detailTypeProjet.libelle))])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Description : ")]),_vm._v(" "+_vm._s(_vm.detailTypeProjet.description)+"\n                     ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v("\n                       "+_vm._s(_vm.detailTypeProjet.created)+"\n                     ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v("\n                       "+_vm._s(_vm.detailTypeProjet.modified)+"\n                     ")])])],1)],1)]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowTypeProjet = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n               Fermer\n             ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editTypeProjet(_vm.detailTypeProjet)}},slot:"activator"},[_vm._v("Mofifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1),_vm._v("\n               Modifier\n             ")],1)],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowTache),callback:function ($$v) {_vm.dialogShowTache=$$v},expression:"dialogShowTache"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails de la tâche "+_vm._s(_vm.tacheCourant.ref)+" /\n           "+_vm._s(_vm.tacheCourant.libelle)+"\n         ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowTache = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Référence : ")]),_vm._v(" "+_vm._s(_vm.detailTache.ref))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libelle : ")]),_vm._v(" "+_vm._s(_vm.detailTache.libelle))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Type de travaux : ")]),_vm._v(" "+_vm._s(_vm.detailTache.type))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Ordre : ")]),_vm._v(" "+_vm._s(_vm.detailTache.ordre))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Prix unitaire HT : ")]),_vm._v("\n                       "+_vm._s(new Intl.NumberFormat().format(_vm.detailTache.prix))+"\n                     ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Description : ")]),_vm._v(" "+_vm._s(_vm.detailTache.description))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v(" "+_vm._s(_vm.detailTache.created)+"\n                     ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Crée par :")]),_vm._v(" "+_vm._s(_vm.detailTache.createdUser))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v(" "+_vm._s(_vm.detailTache.modified)+"\n                     ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Modifié par :")]),_vm._v(" "+_vm._s(_vm.detailTache.updateUser))])])],1)],1)]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowTache = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n               Fermer\n             ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editTache(_vm.detailTache)}},slot:"activator"},[_vm._v("Mofifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1),_vm._v("\n               Modifier\n             ")],1)],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowTravaux),callback:function ($$v) {_vm.dialogShowTravaux=$$v},expression:"dialogShowTravaux"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails des travaux "+_vm._s(_vm.travauxCourant.ref)+" /\n           "+_vm._s(_vm.travauxCourant.libelle)+"\n         ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowTravaux = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Code : ")]),_vm._v(" "+_vm._s(_vm.travauxCourant.code))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libelle : ")]),_vm._v(" "+_vm._s(_vm.travauxCourant.libelle))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Type de projet : ")]),_vm._v(" "+_vm._s(_vm.travauxCourant.type))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Ordre : ")]),_vm._v(" "+_vm._s(_vm.travauxCourant.ordre))])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Description : ")]),_vm._v(" "+_vm._s(_vm.travauxCourant.description)+"\n                     ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v("\n                       "+_vm._s(_vm.travauxCourant.created)+"\n                     ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v("\n                       "+_vm._s(_vm.travauxCourant.modified)+"\n                     ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Modifié par :")]),_vm._v(" "+_vm._s(_vm.travauxCourant.updateUser)+"\n                     ")])])],1)],1)]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowTravaux = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n               Fermer\n             ")],1)],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprTyp),callback:function ($$v) {_vm.dialogSuprTyp=$$v},expression:"dialogSuprTyp"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n           Voulez-vous vraiment supprimer cet enregistrement ?\n         ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprTyp = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteType($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutTypeRessource),callback:function ($$v) {_vm.dialogAjoutTypeRessource=$$v},expression:"dialogAjoutTypeRessource"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter/Editer un type de ressource")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeType()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formTypeProj",staticClass:"demo-ruleForm",attrs:{"id":"formTypeProj","rules":_vm.rules,"label-position":"top"}},[_c('v-layout',{staticClass:"text-xs-center text-sm-left",attrs:{"row":"","wrap":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":"","mr-1":""}},[_c('div',[_c('el-form-item',{attrs:{"label":"Code","prop":"code"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"code","placeholder":"Code"},model:{value:(_vm.typeCode),callback:function ($$v) {_vm.typeCode=$$v},expression:"typeCode"}})],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',[_c('el-form-item',{attrs:{"label":"Libelle","prop":"libelle"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Libelle"},model:{value:(_vm.typeLibelle),callback:function ($$v) {_vm.typeLibelle=$$v},expression:"typeLibelle"}})],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',[_c('el-form-item',{attrs:{"label":"Description","prop":"description"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"description","placeholder":"Description"},model:{value:(_vm.typeDescription),callback:function ($$v) {_vm.typeDescription=$$v},expression:"typeDescription"}})],1)],1)])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){return _vm.closeType()}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"green","dark":""},on:{"click":function($event){return _vm.submitTypeRessource()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprLots),callback:function ($$v) {_vm.dialogSuprLots=$$v},expression:"dialogSuprLots"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n           Voulez-vous vraiment supprimer cet enregistrement ?\n         ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprLots = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteLots($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprTache),callback:function ($$v) {_vm.dialogSuprTache=$$v},expression:"dialogSuprTache"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n           Voulez-vous vraiment supprimer cet enregistrement ?\n         ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprTache = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteTaches($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprProd),callback:function ($$v) {_vm.dialogSuprProd=$$v},expression:"dialogSuprProd"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n           Voulez-vous vraiment supprimer cet enregistrement ?\n         ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprProd = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteTypeProd($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowTypeRessource),callback:function ($$v) {_vm.dialogShowTypeRessource=$$v},expression:"dialogShowTypeRessource"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du type de ressource\n           "+_vm._s(_vm.typeRessourceCourant.libelle)+"\n         ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowTypeRessource = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Code : ")]),_vm._v(" "+_vm._s(_vm.typeRessourceCourant.code))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libelle : ")]),_vm._v(" "+_vm._s(_vm.typeRessourceCourant.libelle))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description : ")]),_vm._v(" "+_vm._s(_vm.typeRessourceCourant.description)+"\n                     ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v("\n                       "+_vm._s(_vm.typeRessourceCourant.created)+"\n                     ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v("\n                       "+_vm._s(_vm.typeRessourceCourant.modified)+"\n                     ")])])],1)],1)]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowTypeRessource = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n               Fermer\n             ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editTypeRessource(_vm.typeRessourceCourant)}},slot:"activator"},[_vm._v("Mofifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1),_vm._v("\n               Modifier\n             ")],1)],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogMofifTravaux),callback:function ($$v) {_vm.dialogMofifTravaux=$$v},expression:"dialogMofifTravaux"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Modifier le libellé")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){(_vm.dialogMofifTravaux =false)}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formTypeProj",staticClass:"demo-ruleForm",attrs:{"id":"formTypeProj","rules":_vm.rules,"label-position":"top"}},[_c('v-layout',{staticClass:"text-xs-center text-sm-left",attrs:{"row":"","wrap":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md2":"","mr-1":""}},[_c('div',[_c('el-form-item',{attrs:{"label":"Ordre","prop":"code"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","name":"ordre","placeholder":"Ordre"},model:{value:(_vm.typeCode),callback:function ($$v) {_vm.typeCode=$$v},expression:"typeCode"}})],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md8":""}},[_c('div',[_c('el-form-item',{attrs:{"label":"Libelle","prop":"libelle"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Libelle"},model:{value:(_vm.typeLibelle),callback:function ($$v) {_vm.typeLibelle=$$v},expression:"typeLibelle"}})],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',[_c('el-form-item',{attrs:{"label":"Code","prop":"code"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"code","placeholder":"Code"},model:{value:(_vm.typeDescription),callback:function ($$v) {_vm.typeDescription=$$v},expression:"typeDescription"}})],1)],1)])],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){_vm.dialogMofifTravaux=false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"green","dark":""},on:{"click":function($event){return _vm.submitType()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('formTypeProjet',{attrs:{"editedTypeProjet":_vm.typeProjetSelect,"show":_vm.showDialogTypeProjet},on:{"close":function($event){return _vm.closeFormTypeProjet()}}}),_vm._v(" "),_c('formNiveauTypeTravaux',{attrs:{"idTypeNivProjet":_vm.idNivTypeProjetSelect,"listeLotTravaux":_vm.listeTrx,"show":_vm.showDialogTypeNiveauTrx},on:{"close":function($event){return _vm.closeNiveauFormTypeTrx()}}}),_vm._v(" "),_c('formTypeTravaux',{attrs:{"idTypeProjet":_vm.idTypeProjetSelect,"etatTache":_vm.etatTache,"listeLotTravaux":_vm.listeTrx,"show":_vm.showDialogTypeTrx},on:{"close":function($event){return _vm.closeFormTypeTrx()}}}),_vm._v(" "),_c('formTypeTache',{attrs:{"etatTache":_vm.etatTache,"idTypeTravaux":_vm.idTypeTravauxSelect,"listeLotTache":_vm.listeTache,"show":_vm.showDialogTypeTache},on:{"close":function($event){return _vm.closeFormTypeTache()}}}),_vm._v(" "),_c('dupformTypeTravaux',{attrs:{"listeLotTravaux":_vm.listeTrx,"typeProjetTab":_vm.listTypProjetTab,"libelleSelect":_vm.libelleSelect,"libelleChantier":_vm.libelleChantier,"show":_vm.showDialogDupTypeTrx},on:{"close":function($event){return _vm.closeDupFormTypeTrx()}}}),_vm._v(" "),_c('dupformTypeTache',{attrs:{"idTypeTravaux":_vm.idTypeTravauxSelect,"typeProjetTab":_vm.listTypProjetTabAll,"listeLotTache":_vm.listeTache,"libelleTacheSelect":_vm.libelleTacheSelect,"libelleChantier":_vm.libelleChantier,"etatTache":_vm.etatTache,"show":_vm.showDialogDupTypeTache},on:{"close":function($event){return _vm.closeDupFormTypeTache()}}}),_vm._v(" "),_c('LoadTypeProduitExcel',{attrs:{"show":_vm.showModalLoadTypeTravaux,"listeTypeTravaux":_vm.lstTypeTravaux},on:{"close":function($event){return _vm.closeFormTypeProduit()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kSEu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',{staticClass:"pl-3 pr-3 pt-3  pb-3",attrs:{"tile":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"green darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.dataNbFact.paye))]),_vm._v(" "),_c('div',[_vm._v("Facture(s) soldée(s)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("Montant déjà versé")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataMntFact.paye)))])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"orange darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.dataNbFact.cours))]),_vm._v(" "),_c('div',[_vm._v("Devis/Facture(s) en cours")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataNbFact.aValider)))]),_vm._v(" "),_c('div',[_vm._v("Devis/Facture(s) à valider ")])])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_vm._v(" Montant déjà versé")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataMntFact.coursPaye)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("Montant restant")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataMntFact.cours)))])])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"blue-grey darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.dataNbFact.attente))]),_vm._v(" "),_c('div',[_vm._v("Devis/Facture(s) en attente")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("Montant restant")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataMntFact.attente)))])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"red darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.dataNbFact.impaye))]),_vm._v(" "),_c('div',[_vm._v("Devis/Facture(s) impayée(s)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("Montant restant")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.dataMntFact.impaye)))])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-2":"","mb-3":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"sm12":""}},[_c('v-card',{staticClass:"elevation-5",staticStyle:{"height":"550px"}},[_c('h4',[_vm._v("Statistiques de l'etat des devis / factures de l'année en cours ")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-1"}),_vm._v(" "),_c('div',{staticClass:"mb-2",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"chartFactureAn"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"sm6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-layout',{staticClass:"elevation-3 pt-2 pl-2 pr-2 pb-2 grey lighten-4",attrs:{"row":""}},[_c('v-flex',{attrs:{"sm8":""}},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"chartCommande"}},[_vm._v("\n                                    diagramme pie de commande\n                                ")])]),_vm._v(" "),_c('v-flex',{attrs:{"sm4":""}},[_c('v-layout',{staticClass:"pt-2 pl-2 pr-2 pb-2",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"teal lighten-1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_vm._v("Commande(s) livrée(s)")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.nbCommande))])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm12":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"deep-orange lighten-1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_vm._v("Commande(s) effectuée(s)")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.nbLivraison))])])],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-1",attrs:{"sm6":""}},[_c('div',{staticClass:"elevation-3 pt-2 pl-2 pr-2 pb-2 grey lighten-4",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"chartFacture"}},[_vm._v("\n                    diagramme pie defacture\n                ")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kSaB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kToK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kt8t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"divider":"/"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title')],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('div',{staticClass:"text item"},[(_vm.droitAcces.index_parametre)?_c('el-button',{staticStyle:{"margin":"5px","width":"100%"},attrs:{"icons":""},on:{"click":function($event){return _vm.param()}}},[_vm._v("Vue d'ensemble "),_c('v-icon',{attrs:{"right":""}},[_vm._v("aspect_ratio")])],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.admin_new_param_code)?_c('el-button',{staticStyle:{"margin":"5px","width":"100%"},attrs:{"icons":""},on:{"click":function($event){return _vm.paramCode()}}},[_vm._v("Code et identifiant "),_c('v-icon',{attrs:{"right":""}},[_vm._v("code")])],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.admin_new_param_alert)?_c('el-button',{staticStyle:{"margin":"5px","width":"100%"},attrs:{"icons":""},on:{"click":function($event){return _vm.paramAlert()}}},[_vm._v("Alert et notification "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add_alert")])],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.index_service)?_c('el-button',{staticStyle:{"margin":"5px","width":"100%"},attrs:{"icons":""},on:{"click":function($event){return _vm.paramService()}}},[_vm._v("Service "),_c('v-icon',{attrs:{"right":""}},[_vm._v("pie_chart_outlined")])],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.route_all_application)?_c('el-button',{staticStyle:{"margin":"5px","width":"100%"},attrs:{"icons":""},on:{"click":function($event){return _vm.paramRoute()}}},[_vm._v("Routes "),_c('v-icon',{attrs:{"right":""}},[_vm._v("rounded_corner")])],1):_vm._e()],1)])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[(_vm.droitAcces.index_parametre && _vm.etatParam)?_c('el-tabs',[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v(" Ma configuration "),_c('v-icon',{attrs:{"right":""}},[_vm._v("dashboard")])],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-avatar',{staticClass:"grey lighten-4",attrs:{"size":"140px"}},[(_vm.listParam.url)?_c('img',{staticClass:"lazy",attrs:{"src":_vm.listParam.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"src":_vm.logoUser,"alt":""}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Raison sociale : ")]),_vm._v(" "+_vm._s(_vm.listParam.nom)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Forme juridique : ")]),_vm._v(" "+_vm._s(_vm.listParam.formeJuridique)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Siège : ")]),_vm._v(" "+_vm._s(_vm.listParam.siege))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Directeur général : ")]),_vm._v(" "+_vm._s(_vm.listParam.dg)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Contact : ")]),_vm._v(" "+_vm._s(_vm.listParam.contact))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Capital : ")]),_vm._v(" "+_vm._s(_vm.listParam.capital)+" FCFA")])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Prestataire : ")]),_vm._v(" "+_vm._s(_vm.listParam.nomPrestataire))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Validateur des demandes : ")]),_vm._v(" "+_vm._s(_vm.listParam.validateurDemande))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Validateur des dévis : ")]),_vm._v(" "+_vm._s(_vm.listParam.validateurDevis))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Responsable technique : ")]),_vm._v(" "+_vm._s(_vm.listParam.responsableTechnik))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("SMS SENDER : ")]),_vm._v(" "+_vm._s(_vm.listParam.sms))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("MAIL SENDER : ")]),_vm._v(" "+_vm._s(_vm.listParam.mail))])])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                            CONFIGURATION DES PREFIXES DES CODES\n                          ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Utilisateur : ")]),_vm._v(" "+_vm._s(_vm.listParam.user)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Fournisseur : ")]),_vm._v(" "+_vm._s(_vm.listParam.fournisseur)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Entrepot : ")]),_vm._v(" "+_vm._s(_vm.listParam.entrepot))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Caisse : ")]),_vm._v(" "+_vm._s(_vm.listParam.caisse)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Stock : ")]),_vm._v(" "+_vm._s(_vm.listParam.stock)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Sortie d'entrepot : ")]),_vm._v(" "+_vm._s(_vm.listParam.sortir)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Retour d'entrepot : ")]),_vm._v(" "+_vm._s(_vm.listParam.entree))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Transfert : ")]),_vm._v(" "+_vm._s(_vm.listParam.transfert)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Maintenance : ")]),_vm._v(" "+_vm._s(_vm.listParam.maintenance)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Véhicule : ")]),_vm._v(" "+_vm._s(_vm.listParam.vehicule)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Projet : ")]),_vm._v(" "+_vm._s(_vm.listParam.projet))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Commande : ")]),_vm._v(" "+_vm._s(_vm.listParam.commande))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Facture : ")]),_vm._v(" "+_vm._s(_vm.listParam.facture)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Inventaire : ")]),_vm._v(" "+_vm._s(_vm.listParam.inventaire)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Produit : ")]),_vm._v(" "+_vm._s(_vm.listParam.produit)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Paiement caisse : ")]),_vm._v(" "+_vm._s(_vm.listParam.paiement))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Livraison : ")]),_vm._v(" "+_vm._s(_vm.listParam.livraison))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Approvisionnment : ")]),_vm._v(" "+_vm._s(_vm.listParam.appro))])]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Créditer la caisse : ")]),_vm._v(" "+_vm._s(_vm.listParam.approCaisse))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Demande d'intervention : ")]),_vm._v(" "+_vm._s(_vm.listParam.intervention))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Client : ")]),_vm._v(" "+_vm._s(_vm.listParam.client))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Contrat de location : ")]),_vm._v(" "+_vm._s(_vm.listParam.location))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Vignette : ")]),_vm._v(" "+_vm._s(_vm.listParam.vignette))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Visite technique : ")]),_vm._v(" "+_vm._s(_vm.listParam.visite))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Assurance : ")]),_vm._v(" "+_vm._s(_vm.listParam.assurance))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Mission : ")]),_vm._v(" "+_vm._s(_vm.listParam.mission))])])],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.admin_new_param && _vm.etatGlobal)?_c('el-tabs',[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v(" Vue d'ensemble "),_c('v-icon',{attrs:{"right":""}},[_vm._v("aspect_ratio")])],1),_vm._v(" "),_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-form',{ref:"formGlobal",attrs:{"lazy-validation":"","id":"formGlobal"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Raison sociale")]),_vm._v(" "),_c('el-input',{attrs:{"name":"nom","placeholder":"Raison sociale"},model:{value:(_vm.paramGlobal.nom),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "nom", $$v)},expression:"paramGlobal.nom"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Forme jurique")]),_vm._v(" "),_c('el-input',{attrs:{"name":"formeJuridique","placeholder":"Forme jurique"},model:{value:(_vm.paramGlobal.formeJuridique),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "formeJuridique", $$v)},expression:"paramGlobal.formeJuridique"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Siège social")]),_vm._v(" "),_c('el-input',{attrs:{"name":"siege","placeholder":"Siège social"},model:{value:(_vm.paramGlobal.siege),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "siege", $$v)},expression:"paramGlobal.siege"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Contact")]),_vm._v(" "),_c('el-input',{attrs:{"name":"contact","placeholder":"Contact"},model:{value:(_vm.paramGlobal.contact),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "contact", $$v)},expression:"paramGlobal.contact"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Capital")]),_vm._v(" "),_c('el-input',{attrs:{"name":"capital","placeholder":"Capital"},model:{value:(_vm.paramGlobal.capital),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "capital", $$v)},expression:"paramGlobal.capital"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Directeur Général")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Directeur Général"},model:{value:(_vm.paramGlobal.idDirecteur),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "idDirecteur", $$v)},expression:"paramGlobal.idDirecteur"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nom et prénoms du DG")]),_vm._v(" "),_c('el-input',{attrs:{"name":"dg","placeholder":"Nom et prénoms du DG"},model:{value:(_vm.paramGlobal.dg),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "dg", $$v)},expression:"paramGlobal.dg"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prestataire")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Prestataire"},model:{value:(_vm.paramGlobal.idPres),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "idPres", $$v)},expression:"paramGlobal.idPres"}},_vm._l((_vm.listPrestataire),function(item){return _c('el-option',{key:item.idPres,attrs:{"label":item.libelle,"value":item.idPres}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Validateur des demandes")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Validateur des demandes"},model:{value:(_vm.paramGlobal.idValidateurDemande),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "idValidateurDemande", $$v)},expression:"paramGlobal.idValidateurDemande"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Validateur des dévis")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Validateur des dévis"},model:{value:(_vm.paramGlobal.idValidateurDevis),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "idValidateurDevis", $$v)},expression:"paramGlobal.idValidateurDevis"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant alert seuil validation")]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","min":"0","name":"montantSeuil","placeholder":"Montant alert seuil validation"},model:{value:(_vm.paramGlobal.montantSeuil),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "montantSeuil", $$v)},expression:"paramGlobal.montantSeuil"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS")]),_vm._v(" "),_c('el-input',{attrs:{"min":"0","name":"sms","placeholder":"SMS SENDER"},model:{value:(_vm.paramGlobal.sms),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "sms", $$v)},expression:"paramGlobal.sms"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail")]),_vm._v(" "),_c('el-input',{attrs:{"min":"0","name":"mail","placeholder":"MAIL SENDER"},model:{value:(_vm.paramGlobal.mail),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mail", $$v)},expression:"paramGlobal.mail"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Titre entete principal")]),_vm._v(" "),_c('el-input',{attrs:{"name":"entete1","type":"textarea","autosize":"","placeholder":"titre entete principal"},model:{value:(_vm.paramGlobal.entete1),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "entete1", $$v)},expression:"paramGlobal.entete1"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Titre entete secondaire")]),_vm._v(" "),_c('el-input',{attrs:{"name":"entete2","type":"textarea","autosize":"","placeholder":"titre entete secondaire"},model:{value:(_vm.paramGlobal.entete2),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "entete2", $$v)},expression:"paramGlobal.entete2"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Pied de page")]),_vm._v(" "),_c('el-input',{attrs:{"name":"piedPage","type":"textarea","autosize":"","placeholder":"pied de page"},model:{value:(_vm.paramGlobal.piedPage),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "piedPage", $$v)},expression:"paramGlobal.piedPage"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Responsable technique")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Responsable technique"},model:{value:(_vm.paramGlobal.idRespoTechnik),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "idRespoTechnik", $$v)},expression:"paramGlobal.idRespoTechnik"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"name":"logo","action":"","auto-upload":false,"file-list":_vm.fileLogo,"list-type":"picture"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("CLIQUER ICI "),_c('i',{staticClass:"el-icon-picture"})])],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.retour()}}},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Retour ")],1),_vm._v(" "),(_vm.droitAcces.admin_new_param)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){return _vm.submit()}}},[_vm._v(" Enregistrer "),_c('v-icon',[_vm._v("save")])],1):_vm._e()],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.admin_new_param_code && _vm.etatCode)?_c('el-tabs',[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v(" Configuration de vos code et identifiant "),_c('v-icon',{attrs:{"right":""}},[_vm._v("code")])],1),_vm._v(" "),_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-form',{ref:"formCode",attrs:{"lazy-validation":"","id":"formCode"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Utilisateur")]),_vm._v(" "),_c('el-input',{attrs:{"name":"user","placeholder":"Utilisateur"},model:{value:(_vm.paramGlobal.user),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "user", $$v)},expression:"paramGlobal.user"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Fournisseur")]),_vm._v(" "),_c('el-input',{attrs:{"name":"fournisseur","placeholder":"Fournisseur"},model:{value:(_vm.paramGlobal.fournisseur),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "fournisseur", $$v)},expression:"paramGlobal.fournisseur"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Entrepot")]),_vm._v(" "),_c('el-input',{attrs:{"name":"entrepot","placeholder":"Entrepot"},model:{value:(_vm.paramGlobal.entrepot),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "entrepot", $$v)},expression:"paramGlobal.entrepot"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Caisse")]),_vm._v(" "),_c('el-input',{attrs:{"name":"caisse","placeholder":"Caisse"},model:{value:(_vm.paramGlobal.caisse),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "caisse", $$v)},expression:"paramGlobal.caisse"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Maintenance")]),_vm._v(" "),_c('el-input',{attrs:{"name":"maintenance","placeholder":"Maintenance"},model:{value:(_vm.paramGlobal.maintenance),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "maintenance", $$v)},expression:"paramGlobal.maintenance"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Véhicule")]),_vm._v(" "),_c('el-input',{attrs:{"name":"vehicule","placeholder":"Véhicule"},model:{value:(_vm.paramGlobal.vehicule),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "vehicule", $$v)},expression:"paramGlobal.vehicule"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet")]),_vm._v(" "),_c('el-input',{attrs:{"name":"projet","placeholder":"Projet"},model:{value:(_vm.paramGlobal.projet),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "projet", $$v)},expression:"paramGlobal.projet"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Facture")]),_vm._v(" "),_c('el-input',{attrs:{"name":"facture","placeholder":"Facture"},model:{value:(_vm.paramGlobal.facture),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "facture", $$v)},expression:"paramGlobal.facture"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Commande")]),_vm._v(" "),_c('el-input',{attrs:{"name":"commande","placeholder":"Commande"},model:{value:(_vm.paramGlobal.commande),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "commande", $$v)},expression:"paramGlobal.commande"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Livraison")]),_vm._v(" "),_c('el-input',{attrs:{"name":"livraison","placeholder":"Livraison"},model:{value:(_vm.paramGlobal.livraison),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "livraison", $$v)},expression:"paramGlobal.livraison"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Approvisionnement")]),_vm._v(" "),_c('el-input',{attrs:{"name":"appro","placeholder":"Approvisionnement"},model:{value:(_vm.paramGlobal.appro),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "appro", $$v)},expression:"paramGlobal.appro"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Créditer la caisse")]),_vm._v(" "),_c('el-input',{attrs:{"name":"approCaisse","placeholder":"Créditer la caisse"},model:{value:(_vm.paramGlobal.approCaisse),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "approCaisse", $$v)},expression:"paramGlobal.approCaisse"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Stock")]),_vm._v(" "),_c('el-input',{attrs:{"name":"stock","placeholder":"Stock"},model:{value:(_vm.paramGlobal.stock),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "stock", $$v)},expression:"paramGlobal.stock"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Sortir d'entrepot")]),_vm._v(" "),_c('el-input',{attrs:{"name":"sortir","placeholder":"Sortir d'entrepot"},model:{value:(_vm.paramGlobal.sortir),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "sortir", $$v)},expression:"paramGlobal.sortir"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Retour d'entrepot")]),_vm._v(" "),_c('el-input',{attrs:{"name":"entree","placeholder":"Retour d'entrepot"},model:{value:(_vm.paramGlobal.entree),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "entree", $$v)},expression:"paramGlobal.entree"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Transfert")]),_vm._v(" "),_c('el-input',{attrs:{"name":"transfert","placeholder":"Transfert"},model:{value:(_vm.paramGlobal.transfert),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "transfert", $$v)},expression:"paramGlobal.transfert"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Inventaire")]),_vm._v(" "),_c('el-input',{attrs:{"name":"inventaire","placeholder":"Inventaire"},model:{value:(_vm.paramGlobal.inventaire),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "inventaire", $$v)},expression:"paramGlobal.inventaire"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Produit")]),_vm._v(" "),_c('el-input',{attrs:{"name":"produit","placeholder":"Produit"},model:{value:(_vm.paramGlobal.produit),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "produit", $$v)},expression:"paramGlobal.produit"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Paiement")]),_vm._v(" "),_c('el-input',{attrs:{"name":"paiement","placeholder":"Paiement"},model:{value:(_vm.paramGlobal.paiement),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "paiement", $$v)},expression:"paramGlobal.paiement"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Client")]),_vm._v(" "),_c('el-input',{attrs:{"name":"client","placeholder":"Client"},model:{value:(_vm.paramGlobal.client),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "client", $$v)},expression:"paramGlobal.client"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Contrat de location")]),_vm._v(" "),_c('el-input',{attrs:{"name":"location","placeholder":"Contrat de location"},model:{value:(_vm.paramGlobal.location),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "location", $$v)},expression:"paramGlobal.location"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Demande d'intervention")]),_vm._v(" "),_c('el-input',{attrs:{"name":"intervention","placeholder":"Demande d'intervention"},model:{value:(_vm.paramGlobal.intervention),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "intervention", $$v)},expression:"paramGlobal.intervention"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Viste technique")]),_vm._v(" "),_c('el-input',{attrs:{"name":"visite","placeholder":"Viste technique"},model:{value:(_vm.paramGlobal.visite),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "visite", $$v)},expression:"paramGlobal.visite"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Vignette")]),_vm._v(" "),_c('el-input',{attrs:{"name":"vignette","placeholder":"Vignette"},model:{value:(_vm.paramGlobal.vignette),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "vignette", $$v)},expression:"paramGlobal.vignette"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Assurance")]),_vm._v(" "),_c('el-input',{attrs:{"name":"assurance","placeholder":"Assurance"},model:{value:(_vm.paramGlobal.assurance),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "assurance", $$v)},expression:"paramGlobal.assurance"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mission")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mission","placeholder":"Mission"},model:{value:(_vm.paramGlobal.mission),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mission", $$v)},expression:"paramGlobal.mission"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.retour()}}},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Retour ")],1),_vm._v(" "),(_vm.droitAcces.admin_new_param_code)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){return _vm.submitCode()}}},[_vm._v(" Ajouter "),_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.admin_new_param_alert && _vm.etatAlert)?_c('el-tabs',[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v(" Alert et notification (Mail / SMS) "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add_alert")])],1),_vm._v(" "),_c('el-alert',{attrs:{"title":"ATTENTION","type":"warning","description":"VEUILLEZ EVITER LES CARACTERES SPECIAUX SUIVANT <<()>>  ","show-icon":""}}),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-form',{ref:"formAlert",attrs:{"id":"formAlert"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('el-card',{staticClass:"box-card"},[_c('el-tabs',{model:{value:(_vm.envoieAlert),callback:function ($$v) {_vm.envoieAlert=$$v},expression:"envoieAlert"}},[_c('el-tab-pane',{attrs:{"label":"CAISSE","name":"caisse"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  CAISSE\n                                ")])],1),_vm._v(" "),_c('v-form',{ref:"caisseParam",attrs:{"id":"caisseParam","lazy-validation":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS seuil minimun atteint caisse")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsSeuilCaisse","type":"textarea","autosize":"","placeholder":"SMS seuil minimum atteint caisse"},model:{value:(_vm.paramGlobal.smsSeuilCaisse),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsSeuilCaisse", $$v)},expression:"paramGlobal.smsSeuilCaisse"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail minimun atteint caisse")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailSeuilCaisse","type":"textarea","autosize":"","placeholder":"Mail minimum atteint caisse"},model:{value:(_vm.paramGlobal.mailSeuilCaisse),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailSeuilCaisse", $$v)},expression:"paramGlobal.mailSeuilCaisse"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS nouvelle caisse")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsCaisse","type":"textarea","autosize":"","placeholder":"SMS nouvelle caisse"},model:{value:(_vm.paramGlobal.smsCaisse),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsCaisse", $$v)},expression:"paramGlobal.smsCaisse"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail nouvelle caisse")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailCaisse","type":"textarea","autosize":"","placeholder":"Mail nouvelle caisse"},model:{value:(_vm.paramGlobal.mailCaisse),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailCaisse", $$v)},expression:"paramGlobal.mailCaisse"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS nouveau approvisionnement de la caisse")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsApproCaisse","type":"textarea","autosize":"","placeholder":"SMS nouveau approvisionnement de la caisse"},model:{value:(_vm.paramGlobal.smsApproCaisse),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsApproCaisse", $$v)},expression:"paramGlobal.smsApproCaisse"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail nouveau approvisionnement de la caisse")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailApproCaisse","type":"textarea","autosize":"","placeholder":"Mail nouveau approvisionnement de la caisse"},model:{value:(_vm.paramGlobal.mailApproCaisse),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailApproCaisse", $$v)},expression:"paramGlobal.mailApproCaisse"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS validation approvisionnement caisse")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsApproCaisseValid","type":"textarea","autosize":"","placeholder":"SMS validation approvisionnement caisse"},model:{value:(_vm.paramGlobal.smsApproCaisseValid),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsApproCaisseValid", $$v)},expression:"paramGlobal.smsApproCaisseValid"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail validation approvisionnement caisse")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailApproCaisseValid","type":"textarea","autosize":"","placeholder":"Mail validation approvisionnement caisse"},model:{value:(_vm.paramGlobal.mailApproCaisseValid),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailApproCaisseValid", $$v)},expression:"paramGlobal.mailApproCaisseValid"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS nouveau paiement")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsPaiement","type":"textarea","autosize":"","placeholder":"SMS nouveau paiement"},model:{value:(_vm.paramGlobal.smsPaiement),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsPaiement", $$v)},expression:"paramGlobal.smsPaiement"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail nouveau paiement")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailPaiement","type":"textarea","autosize":"","placeholder":"Mail nouveau paiement"},model:{value:(_vm.paramGlobal.mailPaiement),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailPaiement", $$v)},expression:"paramGlobal.mailPaiement"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.retour()}}},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Retour ")],1),_vm._v(" "),(_vm.droitAcces.admin_new_param_alert)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){return _vm.submitAlert('caisseParam')}}},[_vm._v(" Ajouter "),_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"MAINTENANCE","name":"maintenance"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  MAINTENANCE\n                                ")])],1),_vm._v(" "),_c('v-form',{ref:"maintenanceParam",attrs:{"id":"maintenanceParam","lazy-validation":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Ajout de zone")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsZone","type":"textarea","autosize":"","placeholder":"SMS Ajout de zone"},model:{value:(_vm.paramGlobal.smsZone),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsZone", $$v)},expression:"paramGlobal.smsZone"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Ajout de zone")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailZone","type":"textarea","autosize":"","placeholder":"Mail Ajout de zone"},model:{value:(_vm.paramGlobal.mailZone),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailZone", $$v)},expression:"paramGlobal.mailZone"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Ajout de constat")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsConstat","type":"textarea","autosize":"","placeholder":"SMS Ajout de constat"},model:{value:(_vm.paramGlobal.smsConstat),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsConstat", $$v)},expression:"paramGlobal.smsConstat"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Ajout de constat")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailConstat","type":"textarea","autosize":"","placeholder":"Mail Ajout de constat"},model:{value:(_vm.paramGlobal.mailConstat),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailConstat", $$v)},expression:"paramGlobal.mailConstat"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Ajout de validation de constat")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsConstatValid","type":"textarea","autosize":"","placeholder":"SMS Ajout de validation de constat"},model:{value:(_vm.paramGlobal.smsConstatValid),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsConstatValid", $$v)},expression:"paramGlobal.smsConstatValid"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail de validation Ajout de constat")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailConstatValid","type":"textarea","autosize":"","placeholder":"Mail de validation Ajout de constat"},model:{value:(_vm.paramGlobal.mailConstatValid),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailConstatValid", $$v)},expression:"paramGlobal.mailConstatValid"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS ajout d'une intervention")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsIntervention","type":"textarea","autosize":"","placeholder":"SMS Ajout d'une intervention"},model:{value:(_vm.paramGlobal.smsIntervention),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsIntervention", $$v)},expression:"paramGlobal.smsIntervention"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail ajout d'une intervention")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailIntervention","type":"textarea","autosize":"","placeholder":"Mail Ajout d'une intervention"},model:{value:(_vm.paramGlobal.mailIntervention),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailIntervention", $$v)},expression:"paramGlobal.mailIntervention"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS ajout de fin de travaux")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsTravaux","type":"textarea","autosize":"","placeholder":"SMS ajout de fin de travaux"},model:{value:(_vm.paramGlobal.smsTravaux),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsTravaux", $$v)},expression:"paramGlobal.smsTravaux"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail ajout de fin de travaux")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailTravaux","type":"textarea","autosize":"","placeholder":"Mail ajout de fin de travaux"},model:{value:(_vm.paramGlobal.mailTravaux),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailTravaux", $$v)},expression:"paramGlobal.mailTravaux"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.retour()}}},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Retour ")],1),_vm._v(" "),(_vm.droitAcces.admin_new_param_alert)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){return _vm.submitAlert('maintenanceParam')}}},[_vm._v(" Ajouter "),_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"PRESTATAIRE","name":"prestataire"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  PRESTATAIRE\n                                ")])],1),_vm._v(" "),_c('v-form',{ref:"prestataireParam",attrs:{"id":"prestataireParam","lazy-validation":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Ajout de prestataire")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsPrestataire","type":"textarea","autosize":"","placeholder":"SMS Ajout de prestataire"},model:{value:(_vm.paramGlobal.smsPrestataire),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsPrestataire", $$v)},expression:"paramGlobal.smsPrestataire"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Ajout de prestataire")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailPrestataire","type":"textarea","autosize":"","placeholder":"Mail Ajout de prestataire"},model:{value:(_vm.paramGlobal.mailPrestataire),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailPrestataire", $$v)},expression:"paramGlobal.mailPrestataire"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Ajout de devis")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsDevis","type":"textarea","autosize":"","placeholder":"SMS Ajout de devis"},model:{value:(_vm.paramGlobal.smsDevis),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsDevis", $$v)},expression:"paramGlobal.smsDevis"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Ajout de devis")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailDevis","type":"textarea","autosize":"","placeholder":"Mail Ajout de devis"},model:{value:(_vm.paramGlobal.mailDevis),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailDevis", $$v)},expression:"paramGlobal.mailDevis"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Ajout de validation de devis")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsDevisValid","type":"textarea","autosize":"","placeholder":"SMS Ajout de validation de devis"},model:{value:(_vm.paramGlobal.smsDevisValid),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsDevisValid", $$v)},expression:"paramGlobal.smsDevisValid"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Ajout de validation de devis")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailDevisValid","type":"textarea","autosize":"","placeholder":"Mail Ajout de validation de devis"},model:{value:(_vm.paramGlobal.mailDevisValid),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailDevisValid", $$v)},expression:"paramGlobal.mailDevisValid"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Ajout d'approvisionnement")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsAppro","type":"textarea","autosize":"","placeholder":"SMS Ajout d'approvisionnement"},model:{value:(_vm.paramGlobal.smsAppro),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsAppro", $$v)},expression:"paramGlobal.smsAppro"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Ajout d'approvisionnement")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailAppro","type":"textarea","autosize":"","placeholder":"Mail Ajout d'approvisionnement"},model:{value:(_vm.paramGlobal.mailAppro),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailAppro", $$v)},expression:"paramGlobal.mailAppro"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.retour()}}},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Retour ")],1),_vm._v(" "),(_vm.droitAcces.admin_new_param_alert)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){return _vm.submitAlert('prestataireParam')}}},[_vm._v(" Ajouter "),_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"MISSION","name":"mission"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  MISSION\n                                ")])],1),_vm._v(" "),_c('v-form',{ref:"parcParam",attrs:{"id":"parcParam","lazy-validation":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS demande de mission")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsDemandeMission","type":"textarea","autosize":"","placeholder":"SMS demande de mission"},model:{value:(_vm.paramGlobal.smsDemandeMission),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsDemandeMission", $$v)},expression:"paramGlobal.smsDemandeMission"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail demande de mission")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailDemandeMission","type":"textarea","autosize":"","placeholder":"Mail demande de mission"},model:{value:(_vm.paramGlobal.mailDemandeMission),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailDemandeMission", $$v)},expression:"paramGlobal.mailDemandeMission"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS première étape de validation d'une mission ")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsValid1mission","type":"textarea","autosize":"","placeholder":"SMS première étape de validation d'une mission"},model:{value:(_vm.paramGlobal.smsValid1mission),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsValid1mission", $$v)},expression:"paramGlobal.smsValid1mission"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail première étape de validation d'une mission")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailValid1mission","type":"textarea","autosize":"","placeholder":"Mail première étape de validation d'une mission"},model:{value:(_vm.paramGlobal.mailValid1mission),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailValid1mission", $$v)},expression:"paramGlobal.mailValid1mission"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS cloturer une mission ")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsCloturmission","type":"textarea","autosize":"","placeholder":"SMS cloturer une mission"},model:{value:(_vm.paramGlobal.smsCloturmission),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsCloturmission", $$v)},expression:"paramGlobal.smsCloturmission"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail cloturer une mission")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailCloturmission","type":"textarea","autosize":"","placeholder":"Mail cloturer une mission"},model:{value:(_vm.paramGlobal.mailCloturmission),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailCloturmission", $$v)},expression:"paramGlobal.mailCloturmission"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS seconde étape de validation d'une mission")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsValid2mission","type":"textarea","autosize":"","placeholder":"SMS seconde étape de validation d'une mission"},model:{value:(_vm.paramGlobal.smsValid2mission),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsValid2mission", $$v)},expression:"paramGlobal.smsValid2mission"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail seconde étape de validation d'une mission")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailValid2mission","type":"textarea","autosize":"","placeholder":"Mail seconde étape de validation d'une mission"},model:{value:(_vm.paramGlobal.mailValid2mission),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailValid2mission", $$v)},expression:"paramGlobal.mailValid2mission"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS rejet d'une mission")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsRejetMission","type":"textarea","autosize":"","placeholder":"SMS rejet d'une mission"},model:{value:(_vm.paramGlobal.smsRejetMission),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsRejetMission", $$v)},expression:"paramGlobal.smsRejetMission"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail rejet d'une mission")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailRejetMission","type":"textarea","autosize":"","placeholder":"Mail rejet d'une mission"},model:{value:(_vm.paramGlobal.mailRejetMission),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailRejetMission", $$v)},expression:"paramGlobal.mailRejetMission"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.retour()}}},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Retour ")],1),_vm._v(" "),(_vm.droitAcces.admin_new_param_alert)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){return _vm.submitAlert('parcParam')}}},[_vm._v(" Ajouter "),_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"INTERVENTION","name":"intervention"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  INTERVENTION\n                                ")])],1),_vm._v(" "),_c('v-form',{ref:"parcInterv",attrs:{"id":"parcInterv","lazy-validation":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS demande d'intervention")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsDemandeInterv","type":"textarea","autosize":"","placeholder":"SMS demande d'intervention"},model:{value:(_vm.paramGlobal.smsDemandeInterv),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsDemandeInterv", $$v)},expression:"paramGlobal.smsDemandeInterv"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail demande d'intervention")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailDemandeInterv","type":"textarea","autosize":"","placeholder":"Mail demande d'intervention"},model:{value:(_vm.paramGlobal.mailDemandeInterv),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailDemandeInterv", $$v)},expression:"paramGlobal.mailDemandeInterv"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS validation d'intervention")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsValidInterv","type":"textarea","autosize":"","placeholder":"SMS validation d'intervention"},model:{value:(_vm.paramGlobal.smsValidInterv),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsValidInterv", $$v)},expression:"paramGlobal.smsValidInterv"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail validation d'intervention")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailValidInterv","type":"textarea","autosize":"","placeholder":"Mail validation d'intervention"},model:{value:(_vm.paramGlobal.mailValidInterv),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailValidInterv", $$v)},expression:"paramGlobal.mailValidInterv"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS planning d'intervention")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsPlanningInterv","type":"textarea","autosize":"","placeholder":"SMS planning d'intervention"},model:{value:(_vm.paramGlobal.smsPlanningInterv),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsPlanningInterv", $$v)},expression:"paramGlobal.smsPlanningInterv"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail planning d'intervention")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailPlanningInterv","type":"textarea","autosize":"","placeholder":"Mail planning d'intervention"},model:{value:(_vm.paramGlobal.mailPlanningInterv),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailPlanningInterv", $$v)},expression:"paramGlobal.mailPlanningInterv"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS fin d'intervention")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsFinInterv","type":"textarea","autosize":"","placeholder":"SMS fin d'intervention"},model:{value:(_vm.paramGlobal.smsFinInterv),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsFinInterv", $$v)},expression:"paramGlobal.smsFinInterv"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail fin d'intervention")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailFinInterv","type":"textarea","autosize":"","placeholder":"Mail fin d'intervention"},model:{value:(_vm.paramGlobal.mailFinInterv),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailFinInterv", $$v)},expression:"paramGlobal.mailFinInterv"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS rejet d'intervention")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsRejetInterv","type":"textarea","autosize":"","placeholder":"SMS rejet d'intervention"},model:{value:(_vm.paramGlobal.smsRejetInterv),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsRejetInterv", $$v)},expression:"paramGlobal.smsRejetInterv"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail rejet d'intervention")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailRejetInterv","type":"textarea","autosize":"","placeholder":"Mail rejet d'intervention"},model:{value:(_vm.paramGlobal.mailRejetInterv),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailRejetInterv", $$v)},expression:"paramGlobal.mailRejetInterv"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.retour()}}},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Retour ")],1),_vm._v(" "),(_vm.droitAcces.admin_new_param_alert)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){return _vm.submitAlert('parcInterv')}}},[_vm._v(" Ajouter "),_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"DIAGNOSTIQUE","name":"diagnostique"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  DIAGNOSTIQUE\n                                ")])],1),_vm._v(" "),_c('v-form',{ref:"parcDiag",attrs:{"id":"parcDiag","lazy-validation":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS diagnostic d'intervention")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsDiagnostiq","type":"textarea","autosize":"","placeholder":"SMS diagnostic d'intervention"},model:{value:(_vm.paramGlobal.smsDiagnostiq),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsDiagnostiq", $$v)},expression:"paramGlobal.smsDiagnostiq"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail diagnostic d'intervention")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailDiagnostiq","type":"textarea","autosize":"","placeholder":"Mail diagnostic d'intervention"},model:{value:(_vm.paramGlobal.mailDiagnostiq),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailDiagnostiq", $$v)},expression:"paramGlobal.mailDiagnostiq"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS validation de diagnostic")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsValidDiagnostiq","type":"textarea","autosize":"","placeholder":"SMS validation de diagnostic"},model:{value:(_vm.paramGlobal.smsValidDiagnostiq),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsValidDiagnostiq", $$v)},expression:"paramGlobal.smsValidDiagnostiq"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail validation de diagnostic")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailValidDiagnostiq","type":"textarea","autosize":"","placeholder":"Mail validation de diagnostic"},model:{value:(_vm.paramGlobal.mailValidDiagnostiq),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailValidDiagnostiq", $$v)},expression:"paramGlobal.mailValidDiagnostiq"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.retour()}}},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Retour ")],1),_vm._v(" "),(_vm.droitAcces.admin_new_param_alert)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){return _vm.submitAlert('parcDiag')}}},[_vm._v(" Ajouter "),_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"DIVERS","name":"divers"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  DIVERS\n                                ")])],1),_vm._v(" "),_c('v-form',{ref:"diversParam",attrs:{"id":"diversParam","lazy-validation":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Ajout de travaux")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsTravaux","type":"textarea","autosize":"","placeholder":"SMS Ajout de travaux"},model:{value:(_vm.paramGlobal.smsTravaux),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsTravaux", $$v)},expression:"paramGlobal.smsTravaux"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Ajout de travaux")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailTravaux","type":"textarea","autosize":"","placeholder":"Mail Ajout de travaux"},model:{value:(_vm.paramGlobal.mailTravaux),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailTravaux", $$v)},expression:"paramGlobal.mailTravaux"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Création de la facture d'une commande")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsFactureCommande","type":"textarea","autosize":"","placeholder":"SMS Création de la facture d'une commande"},model:{value:(_vm.paramGlobal.smsFactureCommande),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsFactureCommande", $$v)},expression:"paramGlobal.smsFactureCommande"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Création de la facture d'une commande")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailFactureCommande","type":"textarea","autosize":"","placeholder":"Mail Création de la facture d'une commande"},model:{value:(_vm.paramGlobal.mailFactureCommande),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailFactureCommande", $$v)},expression:"paramGlobal.mailFactureCommande"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Sorti de l'entrepot")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsSortiEntrepot","type":"textarea","autosize":"","placeholder":"SMS Sorti de l'entrepot"},model:{value:(_vm.paramGlobal.smsSortiEntrepot),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsSortiEntrepot", $$v)},expression:"paramGlobal.smsSortiEntrepot"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Sorti de l'entrepot")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailSortiEntrepot","type":"textarea","autosize":"","placeholder":"Mail Sorti de l'entrepot"},model:{value:(_vm.paramGlobal.mailSortiEntrepot),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailSortiEntrepot", $$v)},expression:"paramGlobal.mailSortiEntrepot"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS retour de l'entrepot")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsRetourEntrepot","type":"textarea","autosize":"","placeholder":"SMS retour de l'entrepot"},model:{value:(_vm.paramGlobal.smsRetourEntrepot),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsRetourEntrepot", $$v)},expression:"paramGlobal.smsRetourEntrepot"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail retour de l'entrepot")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailRetourEntrepot","type":"textarea","autosize":"","placeholder":"Mail retour de l'entrepot"},model:{value:(_vm.paramGlobal.mailRetourEntrepot),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailRetourEntrepot", $$v)},expression:"paramGlobal.mailRetourEntrepot"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS reglement caisse")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsReglementCaisse","type":"textarea","autosize":"","placeholder":"SMS reglement caisse"},model:{value:(_vm.paramGlobal.smsReglementCaisse),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsReglementCaisse", $$v)},expression:"paramGlobal.smsReglementCaisse"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail reglement caisse")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailReglementCaisse","type":"textarea","autosize":"","placeholder":"Mail reglement caisse"},model:{value:(_vm.paramGlobal.mailReglementCaisse),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailReglementCaisse", $$v)},expression:"paramGlobal.mailReglementCaisse"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS création d'un utilisateur")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsCreateUser","type":"textarea","autosize":"","placeholder":"SMS création d'un utilisateur"},model:{value:(_vm.paramGlobal.smsCreateUser),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsCreateUser", $$v)},expression:"paramGlobal.smsCreateUser"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail création d'un utilisateur")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailCreateUser","type":"textarea","autosize":"","placeholder":"Mail création d'un utilisateur"},model:{value:(_vm.paramGlobal.mailCreateUser),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailCreateUser", $$v)},expression:"paramGlobal.mailCreateUser"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS changement d'un mot de passe")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsChangePassword","type":"textarea","autosize":"","placeholder":"SMS changement d'un mot de passe"},model:{value:(_vm.paramGlobal.smsChangePassword),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsChangePassword", $$v)},expression:"paramGlobal.smsChangePassword"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail changement d'un mot de passe")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailChangePassword","type":"textarea","autosize":"","placeholder":"Mail changement d'un mot de passe"},model:{value:(_vm.paramGlobal.mailChangePassword),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailChangePassword", $$v)},expression:"paramGlobal.mailChangePassword"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS validation demande maintenance")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsValideDmdMaint","type":"textarea","autosize":"","placeholder":"SMS validation demande maintenance"},model:{value:(_vm.paramGlobal.smsValideDmdMaint),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsValideDmdMaint", $$v)},expression:"paramGlobal.smsValideDmdMaint"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail validation demande maintenance")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailValideDmdMaint","type":"textarea","autosize":"","placeholder":"Mail validation demande maintenance"},model:{value:(_vm.paramGlobal.mailValideDmdMaint),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailValideDmdMaint", $$v)},expression:"paramGlobal.mailValideDmdMaint"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS validation demande de fond")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsValideDmdFond","type":"textarea","autosize":"","placeholder":"SMS validation demande de fond"},model:{value:(_vm.paramGlobal.smsValideDmdFond),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsValideDmdFond", $$v)},expression:"paramGlobal.smsValideDmdFond"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail validation demande de fond")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailValideDmdFond","type":"textarea","autosize":"","placeholder":"Mail validation demande de fond"},model:{value:(_vm.paramGlobal.mailValideDmdFond),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailValideDmdFond", $$v)},expression:"paramGlobal.mailValideDmdFond"}})],1)])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail facture commande")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailFactureCommande","type":"textarea","autosize":"","placeholder":"Mail validation demande de fond"},model:{value:(_vm.paramGlobal.mailFactureCommande),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailFactureCommande", $$v)},expression:"paramGlobal.mailFactureCommande"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Livraison d'une commande")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailLivraisonCommande","type":"textarea","autosize":"","placeholder":"Mail Livraison d'une commande"},model:{value:(_vm.paramGlobal.mailLivraisonCommande),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailLivraisonCommande", $$v)},expression:"paramGlobal.mailLivraisonCommande"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.retour()}}},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Retour ")],1),_vm._v(" "),(_vm.droitAcces.admin_new_param_alert)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){return _vm.submitAlert('diversParam')}}},[_vm._v(" Ajouter "),_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"PROJET","name":"projet"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  PROJET\n                                ")])],1),_vm._v(" "),_c('v-form',{ref:"projetParam",attrs:{"id":"projetParam","lazy-validation":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Ajout d'un nouveau projet")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsProjet","type":"textarea","autosize":"","placeholder":"SMS Ajout d'un nouveau projet"},model:{value:(_vm.paramGlobal.smsProjet),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsProjet", $$v)},expression:"paramGlobal.smsProjet"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Ajout d'un nouveau projet")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailProjet","type":"textarea","autosize":"","placeholder":"Mail Ajout d'un nouveau projet"},model:{value:(_vm.paramGlobal.mailProjet),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailProjet", $$v)},expression:"paramGlobal.mailProjet"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Ajout d'un nouveau chantier")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsChantier","type":"textarea","autosize":"","placeholder":"SMS Ajout d'un nouveau chantier"},model:{value:(_vm.paramGlobal.smsChantier),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsChantier", $$v)},expression:"paramGlobal.smsChantier"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Ajout d'un nouveau chantier")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailChantier","type":"textarea","autosize":"","placeholder":"MAil Ajout d'un nouveau chantier"},model:{value:(_vm.paramGlobal.mailChantier),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailChantier", $$v)},expression:"paramGlobal.mailChantier"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Ajout de nouveau travaux")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsTravauxProjet","type":"textarea","autosize":"","placeholder":"SMS Ajout de nouveau travaux"},model:{value:(_vm.paramGlobal.smsTravauxProjet),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsTravauxProjet", $$v)},expression:"paramGlobal.smsTravauxProjet"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Ajout de nouveau travaux")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailTravauxProjet","type":"textarea","autosize":"","placeholder":"Mail Ajout de nouveau travaux"},model:{value:(_vm.paramGlobal.mailTravauxProjet),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailTravauxProjet", $$v)},expression:"paramGlobal.mailTravauxProjet"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Planification de besoins matériels")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsPlanifBesoin","type":"textarea","autosize":"","placeholder":"SMS Ajout Planification de besoins matériels"},model:{value:(_vm.paramGlobal.smsPlanifBesoin),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsPlanifBesoin", $$v)},expression:"paramGlobal.smsPlanifBesoin"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Planification de besoins matériels")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailPlanifBesoin","type":"textarea","autosize":"","placeholder":"Mail Planification de besoins matériels"},model:{value:(_vm.paramGlobal.mailPlanifBesoin),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailPlanifBesoin", $$v)},expression:"paramGlobal.mailPlanifBesoin"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Planification des tâches")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsTaches","type":"textarea","autosize":"","placeholder":"SMS Planification des tâches"},model:{value:(_vm.paramGlobal.smsTaches),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsTaches", $$v)},expression:"paramGlobal.smsTaches"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Planification des tâches")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailTaches","type":"textarea","autosize":"","placeholder":"Mail Planification des tâches"},model:{value:(_vm.paramGlobal.mailTaches),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailTaches", $$v)},expression:"paramGlobal.mailTaches"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Validation de besoins matériels")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsValidBesoinMateriel","type":"textarea","autosize":"","placeholder":"SMS Ajout Validation de besoins matériels"},model:{value:(_vm.paramGlobal.smsValidBesoinMateriel),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsValidBesoinMateriel", $$v)},expression:"paramGlobal.smsValidBesoinMateriel"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Validation de besoins matériels")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailValidBesoinMateriel","type":"textarea","autosize":"","placeholder":"Mail Validation de besoins matériels"},model:{value:(_vm.paramGlobal.mailValidBesoinMateriel),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailValidBesoinMateriel", $$v)},expression:"paramGlobal.mailValidBesoinMateriel"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.retour()}}},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Retour ")],1),_vm._v(" "),(_vm.droitAcces.admin_new_param_alert)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){return _vm.submitAlert('projetParam')}}},[_vm._v(" Ajouter "),_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"BESOINS","name":"besoins"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  BESOINS\n                                ")])],1),_vm._v(" "),_c('v-form',{ref:"besoinParam",attrs:{"id":"besoinParam","lazy-validation":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Ajout de besoin")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsBesoin","type":"textarea","autosize":"","placeholder":"SMS Ajout de besoin"},model:{value:(_vm.paramGlobal.smsBesoin),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsBesoin", $$v)},expression:"paramGlobal.smsBesoin"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Ajout de besoin")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailBesoin","type":"textarea","autosize":"","placeholder":"Mail Ajout de Besoin"},model:{value:(_vm.paramGlobal.mailBesoin),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailBesoin", $$v)},expression:"paramGlobal.mailBesoin"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Validation du besoin")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsValidBesoin","type":"textarea","autosize":"","placeholder":"SMS validation du besoin"},model:{value:(_vm.paramGlobal.smsValidBesoin),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsValidBesoin", $$v)},expression:"paramGlobal.smsValidBesoin"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Validation du besoin")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailValidBesoin","type":"textarea","autosize":"","placeholder":"Mail validation du besoin"},model:{value:(_vm.paramGlobal.mailValidBesoin),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailValidBesoin", $$v)},expression:"paramGlobal.mailValidBesoin"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Comparateur de commande du besoin")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsCmdComparateur","type":"textarea","autosize":"","placeholder":"SMS Comparateur de commande du besoin"},model:{value:(_vm.paramGlobal.smsCmdComparateur),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsCmdComparateur", $$v)},expression:"paramGlobal.smsCmdComparateur"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Comparateur de commande du besoin")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailCmdComparateur","type":"textarea","autosize":"","placeholder":"Mail Comparateur de commande du besoin"},model:{value:(_vm.paramGlobal.mailCmdComparateur),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailCmdComparateur", $$v)},expression:"paramGlobal.mailCmdComparateur"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.retour()}}},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Retour ")],1),_vm._v(" "),(_vm.droitAcces.admin_new_param_alert)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){return _vm.submitAlert('besoinParam')}}},[_vm._v(" Ajouter "),_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"FOURNISSEUR","name":"fournisseur"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  FOURNISSEUR\n                                ")])],1),_vm._v(" "),_c('v-form',{ref:"fournisseurParam",attrs:{"id":"fournisseurParam","lazy-validation":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Ajout de commande")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsCommande","type":"textarea","autosize":"","placeholder":"SMS Ajout de commande"},model:{value:(_vm.paramGlobal.smsCommande),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsCommande", $$v)},expression:"paramGlobal.smsCommande"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Ajout de commande")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailCommande","type":"textarea","autosize":"","placeholder":"Mail Ajout de commande"},model:{value:(_vm.paramGlobal.mailCommande),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailCommande", $$v)},expression:"paramGlobal.mailCommande"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Ajout de facture")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsFacture","type":"textarea","autosize":"","placeholder":"SMS Ajout de facture"},model:{value:(_vm.paramGlobal.smsFacture),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsFacture", $$v)},expression:"paramGlobal.smsFacture"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Ajout de facture")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailFacture","type":"textarea","autosize":"","placeholder":"Mail Ajout de facture"},model:{value:(_vm.paramGlobal.mailFacture),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailFacture", $$v)},expression:"paramGlobal.mailFacture"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Ajout de livraison")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsLivraison","type":"textarea","autosize":"","placeholder":"SMS Ajout de livraison"},model:{value:(_vm.paramGlobal.smsLivraison),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsLivraison", $$v)},expression:"paramGlobal.smsLivraison"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Ajout de livraison")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailLivraison","type":"textarea","autosize":"","placeholder":"Mail Ajout de livraison"},model:{value:(_vm.paramGlobal.mailLivraison),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailLivraison", $$v)},expression:"paramGlobal.mailLivraison"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS transformation commande en facture")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsCmdeFacture","type":"textarea","autosize":"","placeholder":"SMS transformation commande en produit"},model:{value:(_vm.paramGlobal.smsCmdeFacture),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsCmdeFacture", $$v)},expression:"paramGlobal.smsCmdeFacture"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail transformation commande en facture")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailCmdeFacture","type":"textarea","autosize":"","placeholder":"Mail transformation commande en produit"},model:{value:(_vm.paramGlobal.mailCmdeFacture),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailCmdeFacture", $$v)},expression:"paramGlobal.mailCmdeFacture"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS validation de facture")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsFactureValid","type":"textarea","autosize":"","placeholder":"SMS validation de facture"},model:{value:(_vm.paramGlobal.smsFactureValid),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsFactureValid", $$v)},expression:"paramGlobal.smsFactureValid"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail validation de facture")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailFactureValid","type":"textarea","autosize":"","placeholder":"Mail validation de facture"},model:{value:(_vm.paramGlobal.mailFactureValid),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailFactureValid", $$v)},expression:"paramGlobal.mailFactureValid"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.retour()}}},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Retour ")],1),_vm._v(" "),(_vm.droitAcces.admin_new_param_alert)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){return _vm.submitAlert('fournisseurParam')}}},[_vm._v(" Ajouter "),_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"LOGISTIQUE","name":"parcAuto"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  LOGISTIQUE\n                                ")])],1),_vm._v(" "),_c('v-form',{ref:"ParcAutoParam",attrs:{"id":"ParcAutoParam","lazy-validation":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("SMS Ajout d'une demande")]),_vm._v(" "),_c('el-input',{attrs:{"name":"smsDemandeRep","type":"textarea","autosize":"","placeholder":"SMS Ajout de Demande"},model:{value:(_vm.paramGlobal.smsDemandeRep),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "smsDemandeRep", $$v)},expression:"paramGlobal.smsDemandeRep"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mail Ajout d'une demande")]),_vm._v(" "),_c('el-input',{attrs:{"name":"mailDemandeRep","type":"textarea","autosize":"","placeholder":"Mail Ajout de Demande"},model:{value:(_vm.paramGlobal.mailDemandeRep),callback:function ($$v) {_vm.$set(_vm.paramGlobal, "mailDemandeRep", $$v)},expression:"paramGlobal.mailDemandeRep"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.retour()}}},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Retour ")],1),_vm._v(" "),(_vm.droitAcces.admin_new_param_alert)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){return _vm.submitAlert('ParcAutoParam')}}},[_vm._v(" Ajouter "),_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.index_service && _vm.etatService)?_c('el-tabs',[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v(" Services "),_c('v-icon',{attrs:{"right":""}},[_vm._v("pie_chart_outlined")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.droitAcces.new_service)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){_vm.dialogAjout = true}}},[_vm._v(" Ajouter "),_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeServ('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeServ('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnServ,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                          ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('el-row',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"gutter":20,"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listService}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chef","label":"Chef de service"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.droitAcces.show_service)?_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showService(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.edit_service)?_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editService(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e()]}}],null,false,3759366534)})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.retour()}}},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Retour ")],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('el-tabs',[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v(" Routes "),_c('v-icon',{attrs:{"right":""}},[_vm._v("rounded_corner")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('el-row',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"gutter":20,"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listRoute}},[_c('el-table-column',{attrs:{"prop":"route","label":"Route"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"Libellé"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Modifier","icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.newRole(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1)]}}])})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){return _vm.retour()}}},[_c('v-icon',[_vm._v("keyboard_backspace")]),_vm._v(" Retour ")],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('br')])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjout),callback:function ($$v) {_vm.dialogAjout=$$v},expression:"dialogAjout"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter un nouveau service")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification du service "+_vm._s(_vm.serviceCourant.libelle)+" ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjout = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingService),expression:"loadingService"}],attrs:{"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-form',{ref:"formService",attrs:{"lazy-validation":"","id":"formService"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-text-field',{attrs:{"label":"Libellé","name":"libelle","rules":_vm.libelleRules,"required":""},model:{value:(_vm.libelle),callback:function ($$v) {_vm.libelle=$$v},expression:"libelle"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-select',{attrs:{"label":"Responsable de service","name":"chef","items":_vm.users,"rules":_vm.chefRules,"item-value":"id","item-text":"nom","chips":"","required":""},model:{value:(_vm.selectChef),callback:function ($$v) {_vm.selectChef=$$v},expression:"selectChef"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjout = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.droitAcces.edit_service && _vm.dialogEdit != true)?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submitService}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.edit_service && _vm.dialogEdit)?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submitService}},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogRole),callback:function ($$v) {_vm.dialogRole=$$v},expression:"dialogRole"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit)?_c('span',[_vm._v("Modification du rôle "+_vm._s(_vm.routeCourant.description)+" ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogRole = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingRole),expression:"loadingRole"}],attrs:{"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-form',{ref:"formRole",attrs:{"lazy-validation":"","id":"formRole"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-text-field',{attrs:{"label":"Route","value":_vm.routeCourant.route,"disabled":""},model:{value:(_vm.routeCourant.route),callback:function ($$v) {_vm.$set(_vm.routeCourant, "route", $$v)},expression:"routeCourant.route"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-text-field',{attrs:{"label":"Libellé","value":_vm.routeCourant.libelle,"disabled":""},model:{value:(_vm.routeCourant.libelle),callback:function ($$v) {_vm.$set(_vm.routeCourant, "libelle", $$v)},expression:"routeCourant.libelle"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-text-field',{attrs:{"label":"Description","name":"libelle","rules":_vm.libelleRules,"required":""},model:{value:(_vm.libelle),callback:function ($$v) {_vm.libelle=$$v},expression:"libelle"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogRole = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.droitAcces.edit_role_all && _vm.dialogEdit)?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submitRole}},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShow),callback:function ($$v) {_vm.dialogShow=$$v},expression:"dialogShow"}},[_c('v-card',[_c('v-toolbar',{staticClass:"indigo",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du service "+_vm._s(_vm.detailService.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShow = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"Veuillez patientez ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.detailService.id)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libellé : ")]),_vm._v(" "+_vm._s(_vm.detailService.libelle)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Responsable de service : ")]),_vm._v(" "+_vm._s(_vm.detailService.chef)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Date d'enrégistrement : ")]),_vm._v(" "+_vm._s(_vm.detailService.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailService.modified)+" ")])])],1)],1)])])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShow = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n          Fermer\n        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.edit_service)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editService(_vm.detailService);}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n          Modifier\n        ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kuBM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('el-steps',{attrs:{"active":_vm.active,"align-center":"","simple":""}},[_c('el-step',{attrs:{"title":"Informations","icon":"el-icon-edit"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"Salaire","icon":"el-icon-edit"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"Fichier","icon":"el-icon-edit"}})],1),_vm._v(" "),_c('el-form',{ref:"formContrat",staticClass:"demo-ruleForm",attrs:{"id":"formContrat","rules":_vm.rules,"label-position":"top","model":_vm.formContrat}},[(_vm.active == 0)?_c('el-card',{staticClass:"box-card"},[_c('el-row',{attrs:{"type":"flex","gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Type de contrat","prop":"typeContrat"}},[_c('el-select',{attrs:{"placeholder":"Type de contrat"},model:{value:(_vm.formContrat.idTypeCont),callback:function ($$v) {_vm.$set(_vm.formContrat, "idTypeCont", $$v)},expression:"formContrat.idTypeCont"}},_vm._l((_vm.listeTypeContrat),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Date début","prop":"dateSignature"}},[_c('el-date-picker',{attrs:{"format":"d-MM-yyyy","placeholder":"Date de signature","type":"date"},on:{"change":_vm.verifDateContCDI},model:{value:(_vm.formContrat.dateSignature),callback:function ($$v) {_vm.$set(_vm.formContrat, "dateSignature", $$v)},expression:"formContrat.dateSignature"}})],1)],1),_vm._v(" "),(_vm.formContrat.idTypeCont != 9)?_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Date de fin"}},[_c('el-date-picker',{attrs:{"format":"d-MM-yyyy","placeholder":"Date de fin","type":"date"},on:{"change":_vm.verifDate},model:{value:(_vm.formContrat.dateFin),callback:function ($$v) {_vm.$set(_vm.formContrat, "dateFin", $$v)},expression:"formContrat.dateFin"}})],1)],1):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Poste","prop":"libPoste"}},[_c('el-select',{attrs:{"clearable":"","allow-create":"","filterable":"","placeholder":"Type de poste"},model:{value:(_vm.formContrat.libPoste),callback:function ($$v) {_vm.$set(_vm.formContrat, "libPoste", $$v)},expression:"formContrat.libPoste"}},_vm._l((_vm.listePoste),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Projet concerné"}},[_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"Projet concerné"},model:{value:(_vm.formContrat.idProjet),callback:function ($$v) {_vm.$set(_vm.formContrat, "idProjet", $$v)},expression:"formContrat.idProjet"}},_vm._l((_vm.listeProjets),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Superviseur"}},[_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"Projet concerné"},model:{value:(_vm.formContrat.superviseur),callback:function ($$v) {_vm.$set(_vm.formContrat, "superviseur", $$v)},expression:"formContrat.superviseur"}},_vm._l((_vm.listeUser),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description","rows":6,"type":"textarea"},model:{value:(_vm.formContrat.description),callback:function ($$v) {_vm.$set(_vm.formContrat, "description", $$v)},expression:"formContrat.description"}})],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.active == 1)?_c('el-card',{staticClass:"box-card"},[_c('el-row',{attrs:{"type":"flex","gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Paiement"}},[_c('el-select',{attrs:{"placeholder":"Taux de paiement"},model:{value:(_vm.formContrat.tauxPaiement),callback:function ($$v) {_vm.$set(_vm.formContrat, "tauxPaiement", $$v)},expression:"formContrat.tauxPaiement"}},_vm._l((_vm.listeTauxPaiement),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Type de paie"}},[_c('el-select',{attrs:{"placeholder":"Type de paie"},model:{value:(_vm.formContrat.typePaie),callback:function ($$v) {_vm.$set(_vm.formContrat, "typePaie", $$v)},expression:"formContrat.typePaie"}},_vm._l((_vm.listeTypePaie),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Rénumération"}},[_c('el-input-number',{attrs:{"min":1},model:{value:(_vm.formContrat.renumeration),callback:function ($$v) {_vm.$set(_vm.formContrat, "renumeration", $$v)},expression:"formContrat.renumeration"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('div',[_c('el-form-item',{attrs:{"label":"Statut de temps supplémentaire"}},[_c('el-select',{attrs:{"placeholder":"Statut de temps"},model:{value:(_vm.formContrat.statut),callback:function ($$v) {_vm.$set(_vm.formContrat, "statut", $$v)},expression:"formContrat.statut"}},_vm._l((_vm.listeStatut),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1)])],1)],1):_vm._e(),_vm._v(" "),(_vm.active == 2)?_c('el-card',{staticClass:"box-card"},[_c('el-row',{attrs:{"type":"flex","gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('el-upload',{ref:"uploadFichContrat",staticClass:"upload-demo",attrs:{"list-type":"picture-card","name":"photo","action":"","auto-upload":false,"on-change":_vm.changeFile,"multiple":true}},[_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":"","alt":""}})])],1)],1)],1):_vm._e(),_vm._v(" "),_c('el-row',{attrs:{"justify":"end"}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"text-xs-right"},[(_vm.active!=0)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.previous}},[_vm._v("\n\n                        Précédent\n                    ")]):_vm._e(),_vm._v(" "),(_vm.active!=2)?_c('v-btn',{attrs:{"color":"primary","disabled":_vm.isInvalide},on:{"click":_vm.next}},[_vm._v("\n                        Suivant\n\n                    ")]):_vm._e(),_vm._v(" "),(_vm.active==2)?_c('v-btn',{attrs:{"dark":"","color":"green"},on:{"click":function($event){return _vm.submitForm('formContrat')}}},[_vm._v("\n\n                        Enregistrer\n                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("save")])],1):_vm._e()],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kupt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_resourceHumaine_form_absence__ = __webpack_require__("ArOJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_resourceHumaine_contrat_employe__ = __webpack_require__("uYtD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_resourceHumaine_detail_professionnel__ = __webpack_require__("m9s8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_resourceHumaine_form_edit_user__ = __webpack_require__("2h4C");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        idUserCont: {
            type: Number
            //default: 8
        },
        showEmpl: {
            type: Boolean,
            default: false
        },
        admin: {
            type: Boolean,
            default: true
        }
    },
    components: { formAbsence: __WEBPACK_IMPORTED_MODULE_1__components_resourceHumaine_form_absence__["a" /* default */], formEditUser: __WEBPACK_IMPORTED_MODULE_5__components_resourceHumaine_form_edit_user__["a" /* default */], Loading: __WEBPACK_IMPORTED_MODULE_4__components_Loading__["a" /* default */], contratEmploye: __WEBPACK_IMPORTED_MODULE_2__components_resourceHumaine_contrat_employe__["a" /* default */], detailProfessionnel: __WEBPACK_IMPORTED_MODULE_3__components_resourceHumaine_detail_professionnel__["a" /* default */] },
    name: "detailEmploye",
    data: function data() {
        return {
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            loading: false,
            loadingAbsence: false,

            //data
            onglet: "0",
            infoEmploye: {},
            detailProfession: [],
            listeContrats: [],
            listeAbsence: [],
            dialogFormDmdAbsence: false,
            showDialogPerso: false,
            idAbsenceSelect: null,
            dialogSuppAbs: false,
            demandeEnAttente: false,
            items: [],
            index: null,

            //DIALOG RETOUR
            dialogRetourAbs: false,
            formRetourAbs: {},
            dateNow: new Date()

        };
    },


    watch: {
        showEmpl: function showEmpl(newValue, oldValue) {
            if (newValue == true) {
                this.onglet = "0";
                this.detailProfession.splice(0);
                this.listeContrats.splice(0);
                this.listeAbsence.splice(0);
                this.loadInfo();
            }
        }
    },

    computed: {
        formRetourIsValid: function formRetourIsValid() {

            if (this.formRetourAbs.dateRetour == null || this.formRetourAbs.desc == "" || this.formRetourAbs.desc == undefined) {
                return false;
            } else {
                return true;
            }
        }
    },

    methods: {
        submitFormRetour: function submitFormRetour() {
            var _this = this;

            this.loading = true;
            var url = this.domaine + 'rh/absence/' + this.idAbsenceSelect + "/retour";
            var data = new FormData();
            data.append("dataForm", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.formRetourAbs));
            data.append("userCreated", this.user.id);

            this.$http.post(url, data).then(function (response) {
                _this.loading = false;
                _this.resetForm('formRetourAbs');
                _this.dialogRetourAbs = false;
                _this.listeAbsence.splice(0);
                _this.loadListeAbsence();
                _this.successNotif(response.body.message);
            }, function (error) {
                _this.loading = false;
                _this.$message.error("Echec lors de l'enregistrement");
            });
        },
        resetForm: function resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        },
        showDialogRetour: function showDialogRetour(idAbs) {
            this.dialogRetourAbs = true;
            this.idAbsenceSelect = idAbs;
        },
        showDiapo: function showDiapo(images, ind) {
            this.items = images;
            this.index = ind;
        },
        showSuppAbs: function showSuppAbs(idAbsence) {
            this.idAbsenceSelect = idAbsence;
            this.dialogSuppAbs = true;
        },
        loadInfo: function loadInfo() {
            var _this2 = this;

            this.loading = true;
            var url = this.domaine + "userCreate/infoUser/" + this.idUserCont;
            this.$http.get(url).then(function (resp) {
                _this2.infoEmploye = resp.body.employe;
            }, function (error) {
                _this2.loading = false;
                _this2.$message.error("Echec lors du chargement des informations utilisateurs");
            });
        },
        closeFormUser: function closeFormUser() {
            this.showDialogPerso = false;
            this.loadInfo();
        },
        showDetailPerso: function showDetailPerso() {
            this.showDialogPerso = true;
        },
        handleTabClick: function handleTabClick(onglet) {
            switch (onglet) {
                case "1":
                    //Detail professionnel
                    //this.loadListeAbsence()
                    break;
                case "2":
                    //liste demande
                    this.loadListeAbsence();
                    break;
            }
        },
        imprimerDemande: function imprimerDemande(item) {
            var url = this.domaine + 'impr/impression/user/' + this.idUserCont + '/demande/' + item.idAbsence + '/conge';
            window.open(url);
        },
        showFormDmd: function showFormDmd() {
            this.dialogFormDmdAbsence = true;
        },
        closeFormAbs: function closeFormAbs() {
            this.dialogFormDmdAbsence = false;
            this.listeAbsence.splice(0);
            this.loadListeAbsence();
        },
        loadListeAbsence: function loadListeAbsence() {
            var _this3 = this;

            this.loading = true;
            this.loadingAbsence = true;
            if (this.listeAbsence.length > 0) {
                return;
            }
            this.loadingAbsence = true;
            var url = this.domaine + 'rh/listeAbsence/' + this.idUserCont;
            this.$http.get(url).then(function (response) {
                _this3.loading = false;
                _this3.loadingAbsence = false;
                _this3.listeAbsence = response.body.listeAbsences;
                _this3.demandeEnAttente = response.body.dmdEnAttente;
                _this3.loadingAbsence = false;
            }, function (error) {
                _this3.loadingAbsence = false;
                _this3.$message.error("Echec lors du chargement de la liste des demandes absences");
            });
        },
        submitSuppAbs: function submitSuppAbs() {
            var _this4 = this;

            this.loading = true;
            var url = this.domaine + "rh/absence/" + this.idAbsenceSelect + "/delete";
            this.$http.get(url).then(function (resp) {
                _this4.loading = false;
                _this4.dialogSuppAbs = false;
                _this4.listeAbsence.splice(0);
                _this4.loadListeAbsence();
                _this4.successNotif(response.body.message);
            }, function (error) {
                _this4.loading = false;
                _this4.dialogSuppAbs = false;
                _this4.$message.error("Echec lors de la suppression de la demande");
            });
        }
    }
});

/***/ }),

/***/ "l+OV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l1zf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndicateurProjet_vue__ = __webpack_require__("8p1G");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f46c48b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndicateurProjet_vue__ = __webpack_require__("3lq4");
function injectStyle (ssrContext) {
  __webpack_require__("tbFU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndicateurProjet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f46c48b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndicateurProjet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l7SS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formTypeProjet_vue__ = __webpack_require__("qGI2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcf159c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formTypeProjet_vue__ = __webpack_require__("Cv1M");
function injectStyle (ssrContext) {
  __webpack_require__("flbQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fcf159c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formTypeProjet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fcf159c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formTypeProjet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l9xG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetChantier_vue__ = __webpack_require__("bYFS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4873b8b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetChantier_vue__ = __webpack_require__("pxXP");
function injectStyle (ssrContext) {
  __webpack_require__("AnuP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4873b8b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetChantier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4873b8b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetChantier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lA3e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10fb35aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("vRkt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10fb35aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "lQEb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elevation-2 pt-3 pl-3 pr-3",staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTE DES TAUX D'EXÉCUTION DU PROJET")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mt-3":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.showAjoutDoc()}}},[_vm._v("\n              Ajouter\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"elevation-1",attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeDoc,"border":""}},[_c('el-table-column',{attrs:{"prop":"dateD","label":"Date","align":"center","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"green"}},[_vm._v(_vm._s(scope.row.dateD))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"evolution","label":"TAUX","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                    scope.row.evolution
                ))+"\n            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.showEditDoc(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_vm._v("Modifier\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"red","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.showDilogSupp(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v("Supprimer\n            ")],1)]}}])})],1)],1)],1),_vm._v(" "),(!_vm.droitAcces.delete_matrice)?_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","closable":false,"show-icon":"","type":"warning"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("DOCUMENT")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("NUMERO-12345")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("\n          Annuler\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.deleteDoc()}}},[_vm._v("\n          Supprimer\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogSuprVers),callback:function ($$v) {_vm.dialogSuprVers=$$v},expression:"dialogSuprVers"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","closable":false,"show-icon":"","type":"warning"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("DOCUMENT")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("version-"+_vm._s(_vm.versionSelect.libelle))])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSuprVers = false}}},[_vm._v("\n          Annuler\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.deleteVersion()}}},[_vm._v("\n          Supprimer\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"40%","persistent":true,"transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogDoc),callback:function ($$v) {_vm.dialogDoc=$$v},expression:"dialogDoc"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter ou modifier un taux d'évolution physique")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogDoc = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formDoc",staticClass:"demo-form-inline",attrs:{"id":"formDoc","model":_vm.formDoc}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date","required":""}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"value-format":"dd-MM-yyyy","type":"date","id":"dateSend","name":"dateSend","placeholder":"Date"},model:{value:(_vm.formDoc.dateSend),callback:function ($$v) {_vm.$set(_vm.formDoc, "dateSend", $$v)},expression:"formDoc.dateSend"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"label":"Pourcentage","prop":"evolution"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":1,"placeholder":"Pourcentage","readonly":false},model:{value:(_vm.formDoc.evolution),callback:function ($$v) {_vm.$set(_vm.formDoc, "evolution", $$v)},expression:"formDoc.evolution"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){_vm.dialogDoc = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.editForm == false)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.addDoc('formDoc')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.editDoc('formDoc')}}},[_vm._v("Modifier"),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"70%","persistent":true,"transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogVersion),callback:function ($$v) {_vm.dialogVersion=$$v},expression:"dialogVersion"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter une version au document ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogVersion = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formVersion",staticClass:"demo-form-inline",attrs:{"id":"formVersion","model":_vm.formVersion,"rules":_vm.rulesFormVersion}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Identifiant(version)","prop":"ordre"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.newVersion,"name":"identifiant","placeholder":"Identifiant de la version"},model:{value:(_vm.formVersion.libelle),callback:function ($$v) {_vm.$set(_vm.formVersion, "libelle", $$v)},expression:"formVersion.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Mode de transmission","prop":"mode"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.newVersion,"name":"mode","placeholder":"Mode de transmission"},model:{value:(_vm.formVersion.mode),callback:function ($$v) {_vm.$set(_vm.formVersion, "mode", $$v)},expression:"formVersion.mode"}},_vm._l((_vm.mode),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.newVersion == false),expression:"newVersion == false"}],staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date de transmission"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","type":"date","id":"dateSend","name":"dateSend","placeholder":"Date"},model:{value:(_vm.formVersion.dateSend),callback:function ($$v) {_vm.$set(_vm.formVersion, "dateSend", $$v)},expression:"formVersion.dateSend"}})],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.newVersion == false),expression:"newVersion == false"}],staticClass:"mr-1",attrs:{"xs2":""}},[_c('el-form-item',{attrs:{"label":"Status","prop":"statut"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"status","placeholder":"Status"},model:{value:(_vm.formVersion.status),callback:function ($$v) {_vm.$set(_vm.formVersion, "status", $$v)},expression:"formVersion.status"}},_vm._l((_vm.status),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-3",attrs:{"xs2":""}},[_c('p',{staticClass:"font-weight-thin"},[_vm._v("Format (JPEG,PNG,PDF), 10 Mo maximum")]),_vm._v(" "),(_vm.versionCourante.extention=='gif' || _vm.versionCourante.extention=='PNG' ||_vm.versionCourante.extention=='JPEG' || _vm.versionCourante.extention=='jpg'|| _vm.versionCourante.extention=='JPG')?_c('p',[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.formVersion.urlImage,"alt":"avatar"}})])],1):_vm._e(),_vm._v(" "),(_vm.versionCourante.extention=='pdf' || _vm.versionCourante.extention=='PDF')?_c('p',[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('a',{attrs:{"href":_vm.formVersion.urlImage,"target":"_blank"}},[_c('iframe',{attrs:{"src":_vm.formVersion.urlImage}}),_vm._v("\n                                  Cliquer içi pour afficher le pdf")])])],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"file1",staticStyle:{"display":"none"},attrs:{"name":"docs","type":"file","accept":"image/*|pdf"},on:{"change":_vm.onFileImagePickedVersion}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.file1.click()}}},[_vm._v("Document  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"commentaire"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","disabled":!_vm.newVersion,"rows":10,"name":"commentaire","placeholder":"commentaire"},model:{value:(_vm.formVersion.commentaire),callback:function ($$v) {_vm.$set(_vm.formVersion, "commentaire", $$v)},expression:"formVersion.commentaire"}})],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.newVersion == false),expression:"newVersion == false"}],staticClass:"mr-1",attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"label":"Reserve","prop":"reserve"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":10,"name":"reserve","placeholder":"reserve"},model:{value:(_vm.formVersion.reserve),callback:function ($$v) {_vm.$set(_vm.formVersion, "reserve", $$v)},expression:"formVersion.reserve"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.newVersion == true),expression:"newVersion == true"}],attrs:{"color":"grey","dark":""},on:{"click":function($event){return _vm.resetFormVersion()}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.newVersion == true)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.addVersion('formVersion')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_c('v-btn',{attrs:{"disbaled":!_vm.verifEditVersion,"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.editVersion('formVersion')}}},[_vm._v("Modifier"),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowVersion),callback:function ($$v) {_vm.dialogShowVersion=$$v},expression:"dialogShowVersion"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails de la version "+_vm._s(_vm.versionCourante.libelle)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowVersion = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md6":""}},[(_vm.versionCourante.extention=='gif' || _vm.versionCourante.extention=='PNG' ||_vm.versionCourante.extention=='JPEG' || _vm.versionCourante.extention=='jpg'|| _vm.versionCourante.extention=='JPG')?_c('p',[_c('a',{attrs:{"href":_vm.versionCourante.urlImage,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.versionCourante.urlImage,"alt":"avatar"}}),_vm._v("\n                                       Cliquer içi pour afficher l'image\n                                ")])],1)]):_vm._e(),_vm._v(" "),(_vm.versionCourante.extention=='pdf' || _vm.versionCourante.extention=='PDF')?_c('p',[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('a',{attrs:{"href":_vm.versionCourante.urlImage,"target":"_blank"}},[_c('iframe',{attrs:{"src":_vm.versionCourante.urlImage}}),_vm._v("\n                        Cliquer içi pour afficher le pdf")])])],1):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.versionCourante.libelle)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Mode de transmission : ")]),_vm._v(" "+_vm._s(_vm.versionCourante.mode)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Statut : ")]),_vm._v(" "+_vm._s(_vm.versionCourante.libStatus)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Ajouter par : ")]),_vm._v(" "+_vm._s(_vm.versionCourante.userCreated)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Commentaire :")]),_vm._v(" "+_vm._s(_vm.versionCourante.commentaire)+"  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Réserve :")]),_vm._v(" "+_vm._s(_vm.versionCourante.reserve)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v(" "+_vm._s(_vm.versionCourante.dateCreated)+" ")])])],1)],1)]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowVersion = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n              Fermer\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.showDialogVersionEdit(_vm.versionCourante)}},slot:"activator"},[_vm._v("Mofifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1),_vm._v("\n            Modifier\n          ")],1)],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lRTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailMaintenance_vue__ = __webpack_require__("1wCn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bdc1edb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailMaintenance_vue__ = __webpack_require__("URUD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailMaintenance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bdc1edb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailMaintenance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lYAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"flex":"1 1 auto"}},[_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAttribuerEquipe),callback:function ($$v) {_vm.dialogAttribuerEquipe=$$v},expression:"dialogAttribuerEquipe"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Attribuer une équipe a "+_vm._s(_vm.userResponsable.nom))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('div',{staticClass:"grid-content bg-purple-light"},[_c('v-form',[_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"nom","placeholder":"Nom de l'equipe"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"grid-content bg-purple",staticStyle:{"margin":"10px"}},[_c('el-transfer',{attrs:{"data":_vm.data},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}})],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticStyle:{"margin":"10px"}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Information du technicien")])]),_vm._v(" "),_vm._l((4),function(o){return _c('div',{key:o,staticClass:"text item"},[_vm._v("\n                                "+_vm._s('technicien ' + o)+"\n                            ")])})],2)],1)])],1),_vm._v(" "),_c('hr',{staticStyle:{"height":"20px","color":"#afeeee","border-radius":"20px"}}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"md12":""}},[_c('v-btn',{attrs:{"dark":"","color":"orange"},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "llJt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanComptable_vue__ = __webpack_require__("aeSe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a02728f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlanComptable_vue__ = __webpack_require__("QDYu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanComptable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a02728f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlanComptable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ltEs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogDetail),callback:function ($$v) {_vm.dialogDetail=$$v},expression:"dialogDetail"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Fiche de Validation d'une demande de maintenance")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Informations generales sur la demande\n                                            ")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Identifiant de la demande")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                DMD-"+_vm._s(_vm.demandeDetail.idDemande)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Batiment")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.batiment)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Salle")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.salle)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Priorite")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                   "+_vm._s(_vm.demandeDetail.libPriorite)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de la demande")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.date)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Nom du demandeur")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                               "+_vm._s(_vm.demandeDetail.nomDemandeur)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(_vm.demandeDetail.imageDmd1)?_c('v-flex',{staticClass:"mr-3",attrs:{"xs3":""}},[_c('a',{attrs:{"href":_vm.demandeDetail.imageDmd1,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.demandeDetail.imageDmd1}})])],1)]):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Status")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.libStatut)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Etat")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.demandeDetail.libEtatDmd)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Enregistré par ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                 "+_vm._s(_vm.demandeDetail.userRepresentant)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Domaine d'activité ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                 "+_vm._s(_vm.demandeDetail.domaine)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Description ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('el-form',{staticClass:"demo-ruleForm"},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":""}},[_c('el-input',{attrs:{"disabled":"","type":"textarea"},model:{value:(_vm.demandeDetail.commentaire),callback:function ($$v) {_vm.$set(_vm.demandeDetail, "commentaire", $$v)},expression:"demandeDetail.commentaire"}})],1)],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Visites et constats\n                                            ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Constat effectué par :")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                                            "+_vm._s(_vm.demandeDetail.nomTech)+"\n                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('el-form',{staticStyle:{"width":"100%"},attrs:{"disabled":"","id":"formRapport","model":_vm.formRapport}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[(_vm.demandeDetail.imageConst1)?_c('v-flex',{staticClass:"mr-3",attrs:{"xs3":""}},[_c('a',{attrs:{"href":_vm.demandeDetail.imageConst1,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.demandeDetail.imageConst1}})])],1)]):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Rapport de constat"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":"","type":"textarea","rows":6,"placeholder":"Rapport sur le constat"},model:{value:(_vm.formRapport.rapport),callback:function ($$v) {_vm.$set(_vm.formRapport, "rapport", $$v)},expression:"formRapport.rapport"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableProduit}},[_c('el-table-column',{attrs:{"prop":"designation","label":"Designation","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantite","label":"Quantite"}})],1)],1),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Première Validation\n                                            ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.demandeDetail.nomValidateurs}},[_c('el-table-column',{attrs:{"prop":"nom","label":"Nom du validateur","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"valider","label":"Decision"}})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5",staticStyle:{"margin-right":"100px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"red"},on:{"click":function($event){_vm.dialogConfirmRefus = true}},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Refuser la demande")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"green"},on:{"click":function($event){_vm.dialogConfirm = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v("Valider la demande")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirmRefus),callback:function ($$v) {_vm.dialogConfirmRefus=$$v},expression:"dialogConfirmRefus"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation du devis pour une demande de maintenance")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous Refuser ce devis ?","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("DEMANDE")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("DMD-"+_vm._s(_vm.demandeDetail.idDemande))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{ref:"refFormRefust",staticClass:"demo-form-inline",attrs:{"id":"formRefus","rules":_vm.ruleFormRefus,"label-position":"top","inline":true,"model":_vm.formRefus}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Commentaire","prop":"rapportRefus"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Pourquoi voulez-vous refuser ?"},model:{value:(_vm.formRefus.rapport),callback:function ($$v) {_vm.$set(_vm.formRefus, "rapport", $$v)},expression:"formRefus.rapport"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirmRefus = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitRefusDevis()}}},[_vm._v("Refuser")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation du devis pour une demande de maintenance")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous valider le devis ?","closable":false,"show-icon":"","type":"success"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("DEMANDE")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("DMD-"+_vm._s(_vm.demandeDetail.idDemande))])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirm = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideDevis()}}},[_vm._v("Confirmer")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lvxF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h3',[_vm._v("Prévision du budget")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-2"},[_c('el-select',{attrs:{"placeholder":"Filtrer la liste"},on:{"change":_vm.filtrerMission},model:{value:(_vm.selectEtatMiss),callback:function ($$v) {_vm.selectEtatMiss=$$v},expression:"selectEtatMiss"}},_vm._l((_vm.comboEtatMiss),function(item){return _c('el-option',{key:item.etat,attrs:{"label":item.label,"value":item.etat}})}),1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL TRAVAUX EN ATTENTE DE VALIDATION :\n                    "+_vm._s(new Intl.NumberFormat().format(_vm.totalTravauxEnAttente))+"\n                  ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL MONTANT PROPOSE :\n                    "+_vm._s(new Intl.NumberFormat().format(_vm.totalMntPropose))+"\n                  ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL MONTANT VALIDE :\n                    "+_vm._s(new Intl.NumberFormat().format(_vm.totalMntValide))+"\n                  ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","disabled":false,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeComptePDF()}},slot:"activator"},[_vm._v("\n                    Imprimer\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1):_vm._e(),_vm._v("Imprimer le compte d'exploitation\n                ")],1)],1)],1),_vm._v(" "),_c('el-tab-pane'),_vm._v(" "),_c('v-layout',{staticClass:"mb-4 mt-2",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.tableListeTrxBudget}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Liste des Tâches ")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2 mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"grid-content"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":props.row.taches,"stripe":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"title"},[_vm._v("Détails budget")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2 mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"grid-content"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":props.row
                                                                  .detailBudget,"stripe":""}},[_c('el-table-column',{attrs:{"align":"center","prop":"libelle","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"montantPropose","label":"MONTANT PROPOSE"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                                  "+_vm._s(new Intl.NumberFormat().format(
                                                                      scope
                                                                        .row
                                                                        .montantPropose
                                                                    ))+"\n                                                                ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"montantValide","label":"MONTANT VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                                  "+_vm._s(new Intl.NumberFormat().format(
                                                                      scope
                                                                        .row
                                                                        .montantValide
                                                                    ))+"\n                                                                ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"periode","label":"PERIODE"}})],1)],1)],1)],1)],1)])],1)],1)],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"blue","label":""}},[_vm._v(" "+_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntBudgetPropose","label":"MONTANT PROPOSE","align":"center","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":'warning'}},[_vm._v("\n                                              "+_vm._s(new Intl.NumberFormat().format(
                                                  scope.row.mntBudgetPropose
                                                ))+"\n                                            ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntBudgetValide","label":"MONTANT VALIDE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":'success'}},[_vm._v("\n                                              "+_vm._s(new Intl.NumberFormat().format(
                                                  scope.row.mntBudgetValide
                                                ))+"\n                                            ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","prop":"action","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[(scope.row.mntBudgetValide == 0)?_c('v-btn',{attrs:{"slot":"activator","flat":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.modalAjoutBudget(scope.row,true)}},slot:"activator"},[_vm._v("\n                                                    Modifier\n                                                ")]):_vm._e(),_vm._v("\n                                                Modifier le budget\n                                            ")],1)]}}],null,true)})],1)],1)],1)],1)],1)])],1)],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"TRAVAUX","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"orange--text"},[_vm._v(_vm._s(scope.row.libelle))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"MONTANT PROPOSE","align":"center","prop":"mntBudgetPropose"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":'warning'}},[_vm._v("\n                        "+_vm._s(new Intl.NumberFormat().format(
                            scope.row.mntBudgetPropose
                          ))+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"MONTANT VALIDE","align":"center","prop":"mntBudgetValide"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":'success'}},[_vm._v("\n                        "+_vm._s(new Intl.NumberFormat().format(
                            scope.row.mntBudgetValide
                          ))+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"ETAT","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":scope.row.etat == 1 ? 'success' : 'warning',"disable-transitions":""}},[_vm._v(_vm._s(scope.row.libEtat))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","prop":"action","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etat == 3)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalAjoutBudget(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1):_vm._e(),_vm._v("Etablir le budget\n                      ")],1)]}}])})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('AjoutPrevisionBudgetChantier',{attrs:{"show":_vm.showModalAjoutPrevision,"typeTrx":_vm.typeTravaux,"typeEtat":_vm.typeEtat,"idChant":this.chantier.id},on:{"close":function($event){_vm.showModalAjoutPrevision = false;
      _vm.loadListeTravaux();}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lzUs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lztk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Validation_vue__ = __webpack_require__("KUzu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fb9583b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Validation_vue__ = __webpack_require__("EBtP");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Validation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fb9583b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Validation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m+tu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('el-form',{ref:_vm.prestataireSelect,staticClass:"el-form el-form--label-top el-form--inline",attrs:{"id":"prestataireSelect","label-position":"top","inline":true,"model":_vm.prestataireSelect}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{attrs:{"label":"Nom","prop":"nom"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Select"},on:{"change":function($event){return _vm.handleChangeOuvrier()}},model:{value:(_vm.prestataireSelect.id),callback:function ($$v) {_vm.$set(_vm.prestataireSelect, "id", $$v)},expression:"prestataireSelect.id"}},_vm._l((_vm.listeOuvriers),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.nom,"value":item}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.nom))]),_vm._v("/\n                "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.profession))])])}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{attrs:{"label":"Type de travailleur","required":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"valeurSelect","id":"valeurSelect","placeholder":"Type de travailleur"},model:{value:(_vm.prestataireSelect.type),callback:function ($$v) {_vm.$set(_vm.prestataireSelect, "type", $$v)},expression:"prestataireSelect.type"}},_vm._l((_vm.typeTravaiL),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{attrs:{"label":"Heure supplémentaire","required":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"valeurheureSupp","id":"valeurheureSupp","placeholder":"Heure supplémentaire"},model:{value:(_vm.prestataireSelect.heurSUpp),callback:function ($$v) {_vm.$set(_vm.prestataireSelect, "heurSUpp", $$v)},expression:"prestataireSelect.heurSUpp"}},_vm._l((_vm.heurSUpp),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.id}})}),1)],1)],1)],1),_vm._v(" "),(this.prestataireSelect.type == 1)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"50%"},attrs:{"label":"Heure Début","required":""}},[_c('el-time-select',{attrs:{"picker-options":{
                start: '06:00',
                step: '00:15',
                end: '18:00'
              },"placeholder":"Heure debut "},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.prestataireSelect.heureDbt),callback:function ($$v) {_vm.$set(_vm.prestataireSelect, "heureDbt", $$v)},expression:"prestataireSelect.heureDbt"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"50%"},attrs:{"label":"Heure Fin","required":""}},[_c('el-time-select',{attrs:{"picker-options":{
                start: '06:00',
                step: '00:15',
                end: '18:00'
              },"placeholder":"Heure fin "},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.prestataireSelect.heureFin),callback:function ($$v) {_vm.$set(_vm.prestataireSelect, "heureFin", $$v)},expression:"prestataireSelect.heureFin"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"50%"},attrs:{"label":"Heure Pause","required":""}},[_c('el-time-select',{attrs:{"picker-options":{
                start: '00:00',
                step: '00:15',
                end: '10:00'
              },"placeholder":"Heure de pause "},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.prestataireSelect.heurePause),callback:function ($$v) {_vm.$set(_vm.prestataireSelect, "heurePause", $$v)},expression:"prestataireSelect.heurePause"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"50%"},attrs:{"label":"Heure Intenperie","required":""}},[_c('el-time-select',{attrs:{"picker-options":{
                start: '00:00',
                step: '00:15',
                end: '10:00'
              },"placeholder":"Heure Intempéries "},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.prestataireSelect.heureIntem),callback:function ($$v) {_vm.$set(_vm.prestataireSelect, "heureIntem", $$v)},expression:"prestataireSelect.heureIntem"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Total travail","required":""}},[_c('el-input',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":this.totalHeureOuvrier,"readonly":true},model:{value:(_vm.prestataireSelect.heureTotal),callback:function ($$v) {_vm.$set(_vm.prestataireSelect, "heureTotal", $$v)},expression:"prestataireSelect.heureTotal"}})],1)],1)],1):_vm._e(),_vm._v(" "),(this.prestataireSelect.type == 2)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"50%"},attrs:{"label":"Heure Début","required":""}},[_c('el-time-select',{attrs:{"picker-options":{
                start: '00:00',
                step: '00:15',
                end: '23:00'
              },"placeholder":"Heure debut "},on:{"change":function($event){return _vm.calculTotalComm1()}},model:{value:(_vm.prestataireSelect.heureDbtNuit),callback:function ($$v) {_vm.$set(_vm.prestataireSelect, "heureDbtNuit", $$v)},expression:"prestataireSelect.heureDbtNuit"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"50%"},attrs:{"label":"Heure Fin","required":""}},[_c('el-time-select',{attrs:{"picker-options":{
                start: '00:00',
                step: '00:15',
                end: '05:00'
              },"placeholder":"Heure fin "},on:{"change":function($event){return _vm.calculTotalComm1()}},model:{value:(_vm.prestataireSelect.heureFinNuit),callback:function ($$v) {_vm.$set(_vm.prestataireSelect, "heureFinNuit", $$v)},expression:"prestataireSelect.heureFinNuit"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"50%"},attrs:{"label":"Heure Pause","required":""}},[_c('el-time-select',{attrs:{"picker-options":{
                start: '00:00',
                step: '00:15',
                end: '10:00'
              },"placeholder":"Heure de pause "},on:{"change":function($event){return _vm.calculTotalComm1()}},model:{value:(_vm.prestataireSelect.heurePauseNuit),callback:function ($$v) {_vm.$set(_vm.prestataireSelect, "heurePauseNuit", $$v)},expression:"prestataireSelect.heurePauseNuit"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"50%"},attrs:{"label":"Heure Intenperie","required":""}},[_c('el-time-select',{attrs:{"picker-options":{
                start: '00:00',
                step: '00:15',
                end: '10:00'
              },"placeholder":"Heure Intempéries "},on:{"change":function($event){return _vm.calculTotalComm1()}},model:{value:(_vm.prestataireSelect.heureIntemNuit),callback:function ($$v) {_vm.$set(_vm.prestataireSelect, "heureIntemNuit", $$v)},expression:"prestataireSelect.heureIntemNuit"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Total travail","required":""}},[_c('el-input',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"required":"","placeholder":this.totalHeureOuvrierNuit,"readonly":true},model:{value:(_vm.prestataireSelect.heureTotalNuit),callback:function ($$v) {_vm.$set(_vm.prestataireSelect, "heureTotalNuit", $$v)},expression:"prestataireSelect.heureTotalNuit"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(this.prestataireSelect.heurSUpp == 1)?_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"50%"},attrs:{"label":"Heure supplémentaire","required":""}},[_c('el-time-select',{attrs:{"picker-options":{
                start: '00:00',
                step: '00:15',
                end: '08:00'
              },"placeholder":"Heure supplémentaire "},on:{"change":function($event){return _vm.calculTotalComm()}},model:{value:(_vm.prestataireSelect.heureSuppl),callback:function ($$v) {_vm.$set(_vm.prestataireSelect, "heureSuppl", $$v)},expression:"prestataireSelect.heureSuppl"}})],1)],1):_vm._e(),_vm._v(" "),(this.prestataireSelect.heurSUpp == 1)?_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Description heure supplémentaire"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Description  "},model:{value:(_vm.prestataireSelect.descriptionSupp),callback:function ($$v) {_vm.$set(_vm.prestataireSelect, "descriptionSupp", $$v)},expression:"prestataireSelect.descriptionSupp"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Observation"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Description  "},model:{value:(_vm.prestataireSelect.description),callback:function ($$v) {_vm.$set(_vm.prestataireSelect, "description", $$v)},expression:"prestataireSelect.description"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('el-form-item',{attrs:{"label":"Action"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.addListPresence(_vm.prestataireSelect)}}},[_vm._v("Ajouter")])],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{staticClass:"ml-2 mr-2",attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tablePresence}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.heureSuppl != '00:00')?_c('v-flex',[_c('p',[_c('b',[_vm._v("Heure supplémentaire")]),_vm._v("\n                : "+_vm._s(props.row.heureSuppl)+"\n              ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description heure supplémentaire")]),_vm._v("\n                : "+_vm._s(props.row.descriptionSupp)+"\n              ")])]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description")]),_vm._v("\n              : "+_vm._s(props.row.description)+"\n            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nom","label":"Nom","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureDbt","label":"Heure de debut"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureFin","label":"Heure de fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heurePause","label":"Heure Pause"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureIntem","label":"Heure Intemperie"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"heureTotal","label":"Total travail"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tablePresence)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("Supprimer\n            ")],1)]}}])})],1)],1),_vm._v(" "),_c('br')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m09n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","scrollable":"","loading":_vm.loading,"max-width":"100%","persistent":""},model:{value:(_vm.dialogConstat),callback:function ($$v) {_vm.dialogConstat=$$v},expression:"dialogConstat"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Effectuer le diagnostique pour la demande d'intervention\n          "+_vm._s(_vm.demandeDetail.ref))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 1,"step":"1"}},[_vm._v("Description Diagnostique")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 2,"step":"2"}},[_vm._v("Besoin materiel en stock")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 3,"step":"3"}},[_vm._v("Besoins materiels fourni par le garage")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","height":"auto","flat":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{ref:"formRapport",staticClass:"demo-form-inline",staticStyle:{"width":"100%"},attrs:{"id":"formRapportDiag","rules":_vm.ruleEtape1,"model":_vm.formRapport}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"150px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.image1,"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"file1",staticStyle:{"display":"none"},attrs:{"name":"fileDevis","type":"file","accept":"image/*"},on:{"change":_vm.onFileImage1Picked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.file1.click()}}},[_vm._v("Photo\n                                      "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('div',{staticClass:"font-weight-thin"},[_vm._v("\n                                      Fichier au format (JPEG,PNG,PDF) avec\n                                      une taille de 2 Mo maximale\n                                    ")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1 mt-1",attrs:{"xs4":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Garage *")]),_vm._v(" "),_c('el-select',{staticClass:"mt-3",staticStyle:{"width":"100%"},attrs:{"clearable":"","allow-create":"","filterable":"","name":"garage","placeholder":"nom du garage"},model:{value:(_vm.selectGarage),callback:function ($$v) {_vm.selectGarage=$$v},expression:"selectGarage"}},_vm._l((_vm.listGarage),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Main d'oeuvre (FCFA) *"}},[_c('el-input',{attrs:{"type":"number","min":0},model:{value:(_vm.formRapport.mainDoeuvre),callback:function ($$v) {_vm.$set(_vm.formRapport, "mainDoeuvre", $$v)},expression:"formRapport.mainDoeuvre"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Caisse *"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Caisse *"},model:{value:(_vm.formRapport.selectCaisse),callback:function ($$v) {_vm.$set(_vm.formRapport, "selectCaisse", $$v)},expression:"formRapport.selectCaisse"}},_vm._l((_vm.listCaisse),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Date du diagnostique *"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"d-MM-yyyy","value-format":"yyyy-MM-d","type":"date","placeholder":"Date de fin *"},model:{value:(_vm.formRapport.dateDiag),callback:function ($$v) {_vm.$set(_vm.formRapport, "dateDiag", $$v)},expression:"formRapport.dateDiag"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"label":"rapport du diagnostique *"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.tabDiagnostique),callback:function ($$v) {_vm.tabDiagnostique=$$v},expression:"tabDiagnostique"}})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.etape2('formRapport')}}},[_vm._v("Suivant")])],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","height":"400px","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs6":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Selectionner un Entrepot *"},on:{"change":function($event){return _vm.handleChangeEntrepot()}},model:{value:(_vm.formRapport.entrepot),callback:function ($$v) {_vm.$set(_vm.formRapport, "entrepot", $$v)},expression:"formRapport.entrepot"}},_vm._l((_vm.listEntrepot),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{attrs:{"flat":""}},[_c('el-form',{ref:"refFormProduit",staticClass:"demo-form-inline",attrs:{"id":"formProduit","rules":_vm.ruleFormProduit,"label-position":"top","inline":true,"model":_vm.formProduit}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md5":""}},[_c('el-form',{attrs:{"label":"Désignation","prop":"designation"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Select"},on:{"change":function($event){return _vm.handleChangePrix()}},model:{value:(_vm.formProduit.idProd),callback:function ($$v) {_vm.$set(_vm.formProduit, "idProd", $$v)},expression:"formProduit.idProd"}},_vm._l((_vm.listStock),function(item){return _c('el-option',{key:item.idProduit,attrs:{"label":item.produit,"value":item.idProduit}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form',{attrs:{"label":"Quantite","prop":"quantite"}},[_c('el-input-number',{attrs:{"disabled":_vm.validConstat,"min":1,"size":"large","controls-position":"right","placeholder":"quantite"},model:{value:(_vm.formProduit.quantite),callback:function ($$v) {_vm.$set(_vm.formProduit, "quantite", $$v)},expression:"formProduit.quantite"}})],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.validConstat),expression:"validConstat"}],attrs:{"md3":""}},[_c('el-form',{attrs:{"label":"Prix Unitaire(FCFA)","prop":"prixU"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":5,"disabled":"","size":"large","controls-position":"right","placeholder":"prix unitaire(HT)"},model:{value:(_vm.formProduit.prixUnit),callback:function ($$v) {_vm.$set(_vm.formProduit, "prixUnit", $$v)},expression:"formProduit.prixUnit"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form',{attrs:{"label":"Unite","prop":"unite"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"size":"large","disabled":"","placeholder":""},model:{value:(_vm.formProduit.unite),callback:function ($$v) {_vm.$set(_vm.formProduit, "unite", $$v)},expression:"formProduit.unite"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form',{attrs:{"label":"-"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.addListProduit(
                                      'refFormProduit',
                                      _vm.formProduit
                                    )}}},[_vm._v("Ajouter")])],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableProduit}},[_c('el-table-column',{attrs:{"prop":"designation","label":"Designation","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantite","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixU","label":"Prix Unitaire(FCFA)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"unite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotal","label":"Total(Fcfa)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableProduit)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                  Supprimer ce produit\n                                ")],1)]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.e1 = 1}}},[_vm._v("\n                    Précédent\n                  ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green","dark":""},on:{"click":function($event){return _vm.etape3()}}},[_vm._v("\n                    Suivant\n                  ")])],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","height":"400px","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{attrs:{"flat":""}},[_c('el-form',{ref:"refFormProduitFour",staticClass:"demo-form-inline",attrs:{"id":"formProduitFour","rules":_vm.ruleFormProduitFour,"label-position":"top","inline":true,"model":_vm.formProduitFour}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Type ressource"},on:{"change":function($event){return _vm.loadTypeProduit(_vm.typeProduit)}},model:{value:(_vm.typeProduit),callback:function ($$v) {_vm.typeProduit=$$v},expression:"typeProduit"}},_vm._l((_vm.listTypeRessource),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.li}})}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-form',{attrs:{"label":"Désignation","prop":"designation"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","allow-create":"","filterable":"","placeholder":"Désignation"},model:{value:(_vm.formProduitFour.designation),callback:function ($$v) {_vm.$set(_vm.formProduitFour, "designation", $$v)},expression:"formProduitFour.designation"}},_vm._l((_vm.listProd),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.value,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form',{attrs:{"label":"Quantite","prop":"quantite"}},[_c('el-input-number',{attrs:{"min":1,"size":"large","controls-position":"right","placeholder":"quantite"},model:{value:(_vm.formProduitFour.quantite),callback:function ($$v) {_vm.$set(_vm.formProduitFour, "quantite", $$v)},expression:"formProduitFour.quantite"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form',{attrs:{"label":"Prix Unitaire(FCFA)","prop":"prixU"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":5,"size":"large","controls-position":"right","placeholder":"prix unitaire(HT)"},model:{value:(_vm.formProduitFour.prixUnit),callback:function ($$v) {_vm.$set(_vm.formProduitFour, "prixUnit", $$v)},expression:"formProduitFour.prixUnit"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form',{attrs:{"label":"Unite","prop":"unite"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"size":"large","placeholder":"Unité"},model:{value:(_vm.formProduitFour.unite),callback:function ($$v) {_vm.$set(_vm.formProduitFour, "unite", $$v)},expression:"formProduitFour.unite"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form',{attrs:{"label":"''"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.addListProduitFour(
                                      'refFormProduitFour',
                                      _vm.formProduitFour
                                    )}}},[_vm._v("Ajouter")])],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableProduitFour}},[_c('el-table-column',{attrs:{"prop":"designation","label":"Designation","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantite","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixU","label":"Prix Unitaire(FCFA)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"unite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotal","label":"Total(Fcfa)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(
                                        scope.$index,
                                        _vm.tableProduitFour
                                      )}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                  Supprimer ce produit\n                                ")],1)]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.e1 = 2}}},[_vm._v("\n                    Précédent\n                  ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green","dark":""},on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("\n                    Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation du devis pour une demande de maintenance")]),_vm._v(" "),_c('v-card-text',[_vm._v("Voulez vous valider le devis ?")]),_vm._v(" "),_c('v-flex',{staticClass:"mb-2 ml-1 mr-1",attrs:{"xs12":""}},[(_vm.demandeDetail.entrepot != null)?_c('el-alert',{attrs:{"title":"Aucun entrepot défini dans la zone ","description":'Pour générer un bon de sortie vous devez définir un entrepot pour la zone ' +
                _vm.demandeDetail.libZone,"closable":false,"show-icon":"","type":"warning"}}):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialogConfirm = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){return _vm.SubmitValideDevis()}}},[_vm._v("Confirmer")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.dialogConfirmRefus),callback:function ($$v) {_vm.dialogConfirmRefus=$$v},expression:"dialogConfirmRefus"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation du devis pour une demande de maintenance")]),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"refFormRefust",staticClass:"demo-form-inline",attrs:{"disabled":_vm.validConstat,"id":"formRefus","rules":_vm.ruleFormRefus,"label-position":"top","inline":true,"model":_vm.formRefus}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Voulez vous Refuser ce devis ?","prop":"rapportRefus"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Pourquoi voulez-vous refuser ?"},model:{value:(_vm.formRefus.rapport),callback:function ($$v) {_vm.$set(_vm.formRefus, "rapport", $$v)},expression:"formRefus.rapport"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialogConfirmRefus = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){return _vm.SubmitRefusDevis()}}},[_vm._v("Confirmer")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m7tA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"100%"},model:{value:(_vm.dialogAjoutConducteur),callback:function ($$v) {_vm.dialogAjoutConducteur=$$v},expression:"dialogAjoutConducteur"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.libelleType))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(_vm.typeGraph === 'stat_projet')?_c('v-layout',{staticClass:"mb-2",attrs:{"row":""}},[_c('div',{staticClass:"chart",attrs:{"id":"bar-chart"}})]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.typeGraph === 'courbe_marge')?_c('v-layout',{staticClass:"mb-2",attrs:{"row":""}},[_c('div',{ref:"chart",staticStyle:{"width":"100%","height":"400px"}})]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.typeGraph === 'transactions')?_c('v-layout',{staticClass:"mb-2",attrs:{"row":""}},[_c('div',{ref:"trans",staticStyle:{"width":"100%","height":"400px","position":"relative"}})]):_vm._e(),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeData.projets}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',{staticClass:"elevation-3 pl-4 pr-4 pt-2"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple mb-2"},[_c('div',[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("LISTE PAR NUMERO DE COMPTE ")])],1),_vm._v(" "),_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":props.row.marche,"align":"center","summary-method":_vm.getSummCompteFinance,"show-summary":"","height":"550"}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',{staticClass:"elevation-3 pl-4 pr-4 pt-2"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple mb-2"},[_c('div',[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("LISTE DES TRANSACTIONS")])],1),_vm._v(" "),_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":props.row.depenses,"align":"center","summary-method":_vm.getSummCompteFinance,"show-summary":"","height":"550"}},[_c('el-table-column',{attrs:{"prop":"date","label":"Date","align":"center","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"green"}},[_vm._v(_vm._s(scope.row.date))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleDepense","label":"Libellé de l'opération","align":"center","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.libelleDepense))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"MOUVEMENTS","align":"center"}},[_c('el-table-column',{attrs:{"prop":"montantD","label":"DÉBITS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.montantD))+" ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantC","label":"CRÉDITS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.montantC))+" ")])]}}],null,true)})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"SOLDES","align":"center"}},[_c('el-table-column',{attrs:{"prop":"soldeD","label":"DÉBITEURS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.soldeD))+" ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"soldeC","label":"CRÉDITEURS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.soldeC))+" ")])]}}],null,true)})],1)],1)],1)])])],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleCompte","label":"NUMÉRO DE COMPTE","align":"center","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.code)+" "+_vm._s(scope.row.libelleCompte))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"MOUVEMENTS","align":"center"}},[_c('el-table-column',{attrs:{"prop":"totalMontantD","label":"DÉBIT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                                        scope.row.totalMontantD
                                                        ))+" XOF\n                                                    ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalMontantC","label":"CRÉDIT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                                        scope.row.totalMontantC
                                                        ))+" XOF\n                                                    ")])]}}],null,true)})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"SOLDES","align":"center"}},[_c('el-table-column',{attrs:{"prop":"totalSoldeD","label":"TOTAL DÉBITEURS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.totalSoldeD))+"  XOF")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalSoldeC","label":"TOTAL CRÉDITEURS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.totalSoldeC))+"  XOF")])]}}],null,true)})],1)],1)],1)])])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleProjet","label":"LIBELLÉ PROJET","align":"center","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.libelleProjet))])]}}])}),_vm._v(" "),(!_vm.hideInterface)?_c('el-table-column',{attrs:{"label":"EVOLUTION PHYSIQUE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-progress-circular',{attrs:{"size":80,"width":15,"rotate":360,"value":scope.row.evolution,"color":"orange"}},[_vm._v(_vm._s(scope.row.evolution)+"\n                                    %")])]}}],null,false,1915397925)}):_vm._e(),_vm._v(" "),(!_vm.hideInterface)?_c('el-table-column',{attrs:{"label":"MONTANT DU MARCHE ","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"blue"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                        scope.row.montantMarche
                                        ))+"\n                                    ")])]}}],null,false,2576262346)}):_vm._e(),_vm._v(" "),(!_vm.hideInterface)?_c('el-table-column',{attrs:{"label":"BUDGET ESTIMATIF ","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                        scope.row.budget
                                        )))])]}}],null,false,1444013856)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"label":"MOUVEMENTS","align":"center"}},[_c('el-table-column',{attrs:{"prop":"chargeDirect","label":"DÉBIT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                        scope.row.montantD
                                        ))+" XOF\n                                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chargeIndirect","label":"CRÉDIT"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                        scope.row.montantC
                                        ))+" XOF\n                                    ")])]}}])})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"SOLDES","align":"center"}},[_c('el-table-column',{attrs:{"prop":"soldeDebit","label":"DÉBITEURS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.soldeDebit))+" XOF")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"soldeCredit","label":"CRÉDITEURS"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.soldeCredit))+" XOF ")])]}}])})],1),_vm._v(" "),(!_vm.hideInterface)?_c('el-table-column',{attrs:{"label":"MARGE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.marge))+" XOF")])]}}],null,false,2938116776)}):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("\n                    Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m9s8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detail_professionnel_vue__ = __webpack_require__("pQDW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31661323_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detail_professionnel_vue__ = __webpack_require__("OQoE");
function injectStyle (ssrContext) {
  __webpack_require__("fb6D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31661323"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detail_professionnel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31661323_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detail_professionnel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mEAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetProjet_vue__ = __webpack_require__("TNzk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_deaac50c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetProjet_vue__ = __webpack_require__("2gK+");
function injectStyle (ssrContext) {
  __webpack_require__("KvxP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-deaac50c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BudgetProjet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_deaac50c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BudgetProjet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mPyz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('p',[_c('b',[_vm._v("Désignation : ")]),_vm._v(" "+_vm._s(_vm.detailBanque.libelle)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Gérant : ")]),_vm._v(" "+_vm._s(_vm.detailBanque.gerant)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Type de trésorerie : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                              BANQUE\n                            ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),(_vm.detailBanque.etat === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                              FERME\n                            ")]):_vm._e(),_vm._v(" "),(_vm.detailBanque.etat === true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                              OUVERT\n                            ")]):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Solde Initial : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(_vm.detailBanque.soldeInitial)+" FCFA\n                            ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Solde : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(_vm.detailBanque.solde)+" FCFA\n                            ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enrégistrement : ")]),_vm._v(" "+_vm._s(_vm.detailBanque.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailBanque.modified))])])],1)],1)])])],1)],1),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('v-flex',{attrs:{"md9":""}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticStyle:{"width":"950px","height":"300px"},attrs:{"id":"chartAllBilanBanque"}})])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                          SOLDE\n                        ")]),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                          "+_vm._s(_vm.detailBanque.solde)+" FCFA\n                        ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                          CREDIT\n                        ")]),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                          "+_vm._s(_vm.montantEntree)+" FCFA\n                        ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                          DEBIT\n                        ")]),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                          "+_vm._s(_vm.montantSortie)+" FCFA\n                        ")])],1)],1)],1)],1)],1)],1)]),_vm._v(" "),(_vm.droitAcces.caisse_facture)?_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-form',{ref:"formFacture",attrs:{"lazy-validation":"","id":"formFacture"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-radio',{attrs:{"label":"fournisseur"},model:{value:(_vm.typeRech),callback:function ($$v) {_vm.typeRech=$$v},expression:"typeRech"}},[_vm._v("Paiement fournisseur/prestataire")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"client"},model:{value:(_vm.typeRech),callback:function ($$v) {_vm.typeRech=$$v},expression:"typeRech"}},[_vm._v("Client")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"fond"},model:{value:(_vm.typeRech),callback:function ($$v) {_vm.typeRech=$$v},expression:"typeRech"}},[_vm._v("Décaissement")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"mission"},model:{value:(_vm.typeRech),callback:function ($$v) {_vm.typeRech=$$v},expression:"typeRech"}},[_vm._v("Paiement mission")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(_vm.typeRech !='location')?_c('v-flex',{attrs:{"md2":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Type"},model:{value:(_vm.selectTypeFacture),callback:function ($$v) {_vm.selectTypeFacture=$$v},expression:"selectTypeFacture"}},_vm._l((_vm.typeFacture),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(this.selectTypeFacture === 1 || this.selectTypeFacture === 2)?_c('v-flex',{attrs:{"md3":""}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateFacture","rules":_vm.dateFactureRules,"type":"daterange","range-separator":"à","start-placeholder":"Date de début","end-placeholder":"Date de fin","required":""},model:{value:(_vm.dateFacture),callback:function ($$v) {_vm.dateFacture=$$v},expression:"dateFacture"}})],1):_vm._e(),_vm._v(" "),(_vm.typeRech !='location')?_c('v-flex',{attrs:{"md2":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Etat"},model:{value:(_vm.selectEtatFacture),callback:function ($$v) {_vm.selectEtatFacture=$$v},expression:"selectEtatFacture"}},_vm._l((_vm.etatFacture),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.typeRech== 'fournisseur')?_c('v-flex',{attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Fournisseur"},model:{value:(_vm.selectFournisseur),callback:function ($$v) {_vm.selectFournisseur=$$v},expression:"selectFournisseur"}},_vm._l((_vm.listFournisseur),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeRech== 'fond'),expression:"typeRech== 'fond'"}],attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Demandeur"},model:{value:(_vm.selectDemandeur),callback:function ($$v) {_vm.selectDemandeur=$$v},expression:"selectDemandeur"}},_vm._l((_vm.listeDemandeur),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.value,"value":item.id}})}),1)],1),_vm._v(" "),(_vm.typeRech== 'client')?_c('v-flex',{attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Client"},model:{value:(_vm.selectClient),callback:function ($$v) {_vm.selectClient=$$v},expression:"selectClient"}},_vm._l((_vm.listClient),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-btn',{attrs:{"icons":"","color":"blue","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.loadFacture(_vm.detailBanque)}}},[_c('v-icon',[_vm._v("search")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.listFacture.length !== 0)?_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listFacture,"default-sort":{prop: 'id', order: 'descending'},"stripe":"","border":"","height":"350"}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","width":"280","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.libelle)+"\n                          ")])]}}],null,false,3619004149)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"typeFact","label":"Concerne","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.typeFact)+"\n                          ")])]}}],null,false,599287431)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"concerne","label":"Fournisseur / Demandeur","width":"220"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat === 'IMPAYE')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                            "+_vm._s(scope.row.etat)+"\n                          ")]):_vm._e(),_vm._v(" "),(scope.row.etat === 'SOLDE')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                            "+_vm._s(scope.row.etat)+"\n                          ")]):_vm._e(),_vm._v(" "),(scope.row.etat === 'EN COURS DE PAIEMENT')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                            "+_vm._s(scope.row.etat)+"\n                          ")]):_vm._e(),(scope.row.etat === 'EN ATTENTE DE PAIEMENT')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.etat)+"\n                          ")]):_vm._e()]}}],null,false,929985627)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Montant","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                            "+_vm._s(scope.row.total)+" FCFA\n                          ")])]}}],null,false,2379220420)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","width":"140","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.droitAcces.caisse_reglement)?_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.loadRegement(scope.row, scope.row.type)}}},[_c('v-icon',[_vm._v("local_atm")])],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.imprime_facture && scope.row.type != 3)?_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerFacture(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1):_vm._e()]}}],null,false,1280049557)})],1)],1)],1)],1)],1),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogLoadReglement),callback:function ($$v) {_vm.dialogLoadReglement=$$v},expression:"dialogLoadReglement"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Liste des reglements de la facture "+_vm._s(_vm.factureCourant.ref)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeLoadReglement()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"18px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                          TOTAL A REGLER: "+_vm._s(_vm.totalFacture)+" FCFA\n                        ")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"18px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                           PAYE : "+_vm._s(_vm.payeFacture)+" FCFA\n                        ")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"18px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                           RESTANT : "+_vm._s(_vm.impayeFacture)+" FCFA\n                        ")])],1)])],1)],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[(_vm.factureCourant.etatReglFact === true)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                    FACTURE SOLDE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("check")])],1):_vm._e()],1),_vm._v(" "),(_vm.factureCourant.etatPaiement == false)?_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                    LE DERNIER PAIMENT EFFECTUER N'A PAS ENCORE ETE ENCAISSE PAR LE FOURNISSEUR "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add_alert")])],1)],1):_vm._e(),_vm._v(" "),(_vm.listReglement.length === 0)?_c('div',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("AUCUN PAIEMENT N'A ENCORE ETE EFFECTUE SUR CETTE FACTURE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add_alert")])],1)],1)]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(this.soldeCaisse !== 0 && (_vm.factureCourant.etatPaiement === null || _vm.factureCourant.etatPaiement === true) && _vm.factureCourant.etatReglFact === false && this.soldeCaisse &&  _vm.factureCourant.type != 3 && _vm.totalFacture !=0)?_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.edit_reglement)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newReglement(_vm.factureCourant, _vm.typeF)}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e(),_vm._v("\n                    Ajouter un nouveau paiement\n                  ")],1)],1):_vm._e(),_vm._v(" "),(this.soldeCaisse != 0 && _vm.factureCourant.etatPaiement == null || _vm.factureCourant.etatPaiement == true && _vm.dialogAjoutReglement == true  && _vm.dialogEdit == false && _vm.factureCourant.etatReglFact == false && this.soldeCaisse != 0)?_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEdit != true)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("AJOUT D'UN NOUVEAU PAIEMENT "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_atm")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("MODIFIER LE PAIEMENT PAIE-"+_vm._s(_vm.reglementCourant.id)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_atm")])],1):_vm._e()],1),_vm._v(" "),_c('v-form',{ref:"formReglement",attrs:{"lazy-validation":"","id":"formReglement"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant à verser *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","readonly":_vm.readInput,"min":0,"max":_vm.totalFacture,"name":"montantVerse","placeholder":"Montant à verser"},model:{value:(_vm.montantVerse),callback:function ($$v) {_vm.montantVerse=$$v},expression:"montantVerse"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Effectué par ? *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.readInput,"filterable":"","placeholder":"Effectué par"},model:{value:(_vm.selectEffectue),callback:function ($$v) {_vm.selectEffectue=$$v},expression:"selectEffectue"}},_vm._l((_vm.effectue),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mode de paiement *")]),_vm._v(" "),(_vm.caisseCourant.type == 'Caisse')?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.readInput,"filterable":"","placeholder":"Mode de paiement"},model:{value:(_vm.selectMode),callback:function ($$v) {_vm.selectMode=$$v},expression:"selectMode"}},_vm._l((_vm.mode),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.caisseCourant.type == 'Banque')?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Mode de paiement"},model:{value:(_vm.selectMode),callback:function ($$v) {_vm.selectMode=$$v},expression:"selectMode"}},_vm._l((_vm.modeBanque),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1):_vm._e()],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(_vm.selectEffectue == 2)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nom du remettant *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"remettant","placeholder":"Nom du remettant"},model:{value:(_vm.remettant),callback:function ($$v) {_vm.remettant=$$v},expression:"remettant"}})],1)]):_vm._e(),_vm._v(" "),(_vm.selectMode == 2 || _vm.selectMode == 3)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Référence chèque *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"reference","placeholder":"Référence"},model:{value:(_vm.reference),callback:function ($$v) {_vm.reference=$$v},expression:"reference"}})],1)]):_vm._e(),_vm._v(" "),(_vm.selectMode == 2)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Encaissé ? *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Encaissé"},model:{value:(_vm.selectEncaisse),callback:function ($$v) {_vm.selectEncaisse=$$v},expression:"selectEncaisse"}},_vm._l((_vm.encaisse),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.selectMode == 2)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"ml-3",attrs:{"xs4":""}},[_c('p',{staticClass:"font-weight-thin"},[_vm._v("Format (JPEG,PNG,PDF), 10 Mo maximum")]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.urlImage,"alt":"avatar"}})]),_c('br'),_vm._v(" "),_c('input',{ref:"docs",staticStyle:{"display":"none"},attrs:{"name":"docs","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.docs.click()}}},[_vm._v("Photo  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.closeLoadReglement()}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){_vm.validBanquPaiem = true}}},[_vm._v("Enregistré "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)])],1)],1),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.dialogEdit === true && _vm.dialogEditReglement === true)?_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEdit)?_c('v-chip',{staticStyle:{"font-size":"22px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("MODIFIER LE PAIEMENT PAIE-"+_vm._s(_vm.reglementCourant.id)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_atm")])],1):_vm._e()],1),_vm._v(" "),_c('v-form',{ref:"formReglement",attrs:{"lazy-validation":"","id":"formReglement"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant à verser *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"max":_vm.impayeFacture1,"name":"montantVerse","placeholder":"Montant à verser"},model:{value:(_vm.montantVerse),callback:function ($$v) {_vm.montantVerse=$$v},expression:"montantVerse"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Effectué par ? *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Effectué par"},model:{value:(_vm.selectEffectue),callback:function ($$v) {_vm.selectEffectue=$$v},expression:"selectEffectue"}},_vm._l((_vm.effectue),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mode de paiement *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Mode de paiement"},model:{value:(_vm.selectMode),callback:function ($$v) {_vm.selectMode=$$v},expression:"selectMode"}},_vm._l((_vm.mode),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(_vm.selectEffectue == 2)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nom du remettant *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"remettant","placeholder":"Nom du remettant"},model:{value:(_vm.remettant),callback:function ($$v) {_vm.remettant=$$v},expression:"remettant"}})],1)]):_vm._e(),_vm._v(" "),(_vm.selectMode == 2 || _vm.selectMode == 3)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Banque / Réseau mobile *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"banque","placeholder":"Banque / Réseau mobile"},model:{value:(_vm.banque),callback:function ($$v) {_vm.banque=$$v},expression:"banque"}})],1)]):_vm._e(),_vm._v(" "),(_vm.selectMode == 2 || _vm.selectMode == 3)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Référence *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"reference","placeholder":"Référence"},model:{value:(_vm.reference),callback:function ($$v) {_vm.reference=$$v},expression:"reference"}})],1)]):_vm._e(),_vm._v(" "),(_vm.selectMode == 2)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Encaissé ? *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Encaissé"},model:{value:(_vm.selectEncaisse),callback:function ($$v) {_vm.selectEncaisse=$$v},expression:"selectEncaisse"}},_vm._l((_vm.encaisse),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.selectMode == 2)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"ml-3",attrs:{"xs4":""}},[_c('p',{staticClass:"font-weight-thin"},[_vm._v("Format (JPEG,PNG,PDF), 10 Mo maximum")]),_vm._v(" "),_c('v-avatar',{attrs:{"tile":true,"required":"","size":"120px","height":"100px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.urlImage,"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"name":"docs","type":"file","accept":"image/*|pdf"},on:{"change":_vm.onFileImagePicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.file.click()}}},[_vm._v("\n                                            Document\n                                            "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogEditReglement = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitReglement()}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)])],1)],1),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.listReglement.length !== 0)?_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listReglement,"default-sort":{prop: 'id', order: 'descending'},"stripe":"","border":"","height":"350"}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Référence","width":"280","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(scope.row.ref)+"\n                                ")])]}}],null,false,1406602243)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                  IMPAYE\n                                ")]):_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                  PAYE\n                                ")])]}}],null,false,852661332)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant","width":"240"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                                  "+_vm._s(scope.row.montant)+" FCFA\n                                ")])]}}],null,false,3187444133)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date de paiement","width":"240"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                                  "+_vm._s(scope.row.date)+"\n                                ")])]}}],null,false,2107138256)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","width":"240"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.droitAcces.show_reglement)?_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showReglement(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.edit_reglement && scope.row.etat === false)?_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editRegement(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"indigo","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showPieceJustifi(scope.row)}}},[_c('v-icon',[_vm._v("photo_camera")])],1),_vm._v(" "),(_vm.droitAcces.imprime_reglement)?_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerReglement(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1):_vm._e()]}}],null,false,3562591791)})],1)],1)])],1)],1),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.closeLoadReglement()}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n                  Fermer\n                ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":"","xs12":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"icons":"","text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  APPROVISIONNEMENTS VALIDE PAR LE DG "),_c('v-icon',{attrs:{"right":""}},[_vm._v("get_app")])],1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":"","xs12":""}},[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listApproDgCheq,"default-sort":{prop: 'id', order: 'descending'},"stripe":"","border":"","height":"350"}},[_c('el-table-column',{attrs:{"prop":"dateDmd","label":"Date demande","width":"280","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      "+_vm._s(scope.row.dateDmd)+"\n                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateValid","label":"Date validation","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                      "+_vm._s(scope.row.dateValid)+"\n                    ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant (CFA)","width":"220"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"caisseLibelle","label":"Tresorerie","width":"220"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","width":"140","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.loadDialogConfirm(scope.row)}}},[_c('v-icon',[_vm._v("local_atm")])],1)]}}])})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"icons":"","text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  HISTORIQUE DES APPROVISIONNMENTS "),_c('v-icon',{attrs:{"right":""}},[_vm._v("get_app")])],1)],1),_vm._v(" "),_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticStyle:{"font-size":"12px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                            MONTANT TOTAL DES APPROVISIONNEMENTS: "+_vm._s(_vm.montantEntree)+" FCFA\n                          ")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs2":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeHistoBanque(_vm.detailBanque.id)}},slot:"activator"},[_vm._v("\n                                    Imprimer "),_c('v-icon',[_vm._v("print")])],1),_vm._v("\n                                Imprimer l'historique des approvisionnements\n                            ")],1)],1)],1),_vm._v(" "),_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listApproBanque,"default-sort":{prop: 'id', order: 'descending'},"stripe":"","border":"","height":"350"}},[_c('el-table-column',{attrs:{"prop":"motif","label":"Libellé","width":"280","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.motif)+"\n                          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.valide === 0)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                            EN ATTENTE DE VALIDATION\n                          ")]):(scope.row.valide === 1)?_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                            VALIDER PAR LE DG\n                          ")]):(scope.row.valide === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                            REFUSER PAR LE DG\n                          ")]):_vm._e(),_vm._v(" "),(scope.row.status === 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            EN COURS DE TRAITEMENT\n                          ")]):(scope.row.status === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                            TRAITEMENT TERMINE\n                          ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"validateur","label":"En charge de valider","width":"220"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                            "+_vm._s(scope.row.montant)+" FCFA\n                          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","width":"140","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Détails","icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showAppro(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),(scope.row.valide === 0 && scope.row.etat === false)?_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Modifier","icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editAppro(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Imprimer","icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerAppro(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.valide === 0)?_c('v-btn',{staticClass:"tooltip-btn",attrs:{"slot":"activator","title":"Supprimer","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprAppro = true; _vm.idAppro = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                            Supprimer\n                          ")],1)]}}])})],1)],1)],1)],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"icons":"","text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  HISTORIQUE DES 30 DERNIERES OPERATIONS "),_c('v-icon',{attrs:{"right":""}},[_vm._v("get_app")])],1)],1),_vm._v(" "),_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-form',{ref:"formOperation",attrs:{"lazy-validation":"","id":"formOperation"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateOperation","rules":_vm.dateOperationRules,"type":"daterange","range-separator":"-","start-placeholder":"Date de début","end-placeholder":"Date de fin","required":""},model:{value:(_vm.dateOperation),callback:function ($$v) {_vm.dateOperation=$$v},expression:"dateOperation"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-dropdown',{attrs:{"size":"small","split-button":"","type":"primary"},on:{"command":_vm.handleCommand,"click":_vm.handleClick}},[_vm._v("\n                                recherche\n                                "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"all"}},[_vm._v("Afficher toutes les transactions")])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHis('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHis('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtn,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                        ")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-chip',{staticStyle:{"font-size":"12px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                    TOTAL ENTREE: "+_vm._s(_vm.totalEntree)+" FCFA\n                  ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-chip',{staticStyle:{"font-size":"12px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                    TOTAL SORTIE: "+_vm._s(_vm.totalSortie)+" FCFA\n                  ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-chip',{staticStyle:{"font-size":"13px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                    SOLDE: "+_vm._s(_vm.detailBanque.solde)+" FCFA\n                  ")])],1)],1),_vm._v(" "),_c('data-tables',{ref:"multipleTable1",staticStyle:{"width":"100%"},attrs:{"data":_vm.listOperation,"default-sort":{prop: 'id', order: 'descending'},"stripe":"","border":"","height":"350"}},[_c('el-table-column',{attrs:{"prop":"ref","label":"ID","width":"150","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date","width":"150","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","width":"280","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"initiateur","label":"Initiateur","width":"220"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"validateur","label":"Validateur","width":"220"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"OPERATION"}},[_c('el-table-column',{attrs:{"prop":"entree","label":"ENTREE","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sortie","label":"SORTIE","width":"120"}})],1),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"solde","label":"Solde","width":"220"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowReglement),callback:function ($$v) {_vm.dialogShowReglement=$$v},expression:"dialogShowReglement"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du reglement "+_vm._s(_vm.detailReglement.ref)+" de la facture "+_vm._s(_vm.detailReglement.refFact)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowReglement = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.ref)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Facture : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.refFact)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Banque : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.caisse)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Montant : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                        "+_vm._s(_vm.detailReglement.montant)+" FCFA\n                                      ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),(_vm.detailReglement.etat)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                        PAYE\n                                      ")]):_vm._e(),_vm._v(" "),(!_vm.detailReglement.etat)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                        IMPAYE\n                                      ")]):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Mode de paiement : ")]),_vm._v(" "),(_vm.detailReglement.mode === 1)?_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        Espèce\n                                      ")]):(_vm.detailReglement.mode === 2)?_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        Chèque\n                                      ")]):(_vm.detailReglement.mode === 3)?_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        Mobile money\n                                      ")]):_vm._e()],1),_vm._v(" "),(_vm.detailReglement.banque !== null)?_c('p',[_c('b',[_vm._v("Banque / Réseau mobile : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.banque))]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[(_vm.detailReglement.reference !== null)?_c('p',[_c('b',[_vm._v("Référence : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.reference))]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Paiement : ")]),_vm._v(" "),(_vm.detailReglement.partiel === true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                        PARTIEL\n                                      ")]):(_vm.detailReglement.partiel === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                        TOTAL\n                                      ")]):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date du paiement : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Récuperé par : ")]),_vm._v(" "),(_vm.detailReglement.effectue === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                                        "+_vm._s(_vm.detailReglement.concerne)+"\n                                      ")]):(_vm.detailReglement.effectue === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                                        "+_vm._s(_vm.detailReglement.remettant)+"\n                                      ")]):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Enregistré par : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.userCreated)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.modified)+" ")]),_vm._v(" "),_c('p',[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.detailReglement.urlImage,"alt":"avatar"}})])],1)])],1)],1)])])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowReglement = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n                      Fermer\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.detailReglement.etat === false)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editRegement(_vm.detailReglement);}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                      Modifier\n                    ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.validBanquPaiem),callback:function ($$v) {_vm.validBanquPaiem=$$v},expression:"validBanquPaiem"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h1',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment effectuer un paiement d'un montant de  "+_vm._s(new Intl.NumberFormat().format(this.montantVerse))+" FCFA")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.validBanquPaiem = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){return _vm.submitReglement()}}},[_vm._v("Confirmer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("check")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","persistent":"","overlay":true,"scrollable":"","loading":_vm.loading},model:{value:(_vm.dialogConfirmCheq),callback:function ($$v) {_vm.dialogConfirmCheq=$$v},expression:"dialogConfirmCheq"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Confirmation de l'approvisionnement")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirmCheq = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-form',{ref:"formValidCheq",staticClass:"demo-ruleForm",attrs:{"label-position":"top","rules":_vm.rules,"model":_vm.formValidCheq,"id":"formValidCheq"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Numéro de chèque")]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"numCheq"}},[_c('el-input',{attrs:{"name":"numCheq","placeholder":"Numéro de chèque"},model:{value:(_vm.formValidCheq.numCheq),callback:function ($$v) {_vm.$set(_vm.formValidCheq, "numCheq", $$v)},expression:"formValidCheq.numCheq"}})],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de signature")]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"dateSign"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateSign","value-format":"dd-MM-yyyy","type":"datetime","placeholder":"Date de signature"},model:{value:(_vm.formValidCheq.dateSign),callback:function ($$v) {_vm.$set(_vm.formValidCheq, "dateSign", $$v)},expression:"formValidCheq.dateSign"}})],1)],1)])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                    JOINDRE DES FICHIERS\n                                  ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs2":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.image1,"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"file1",staticStyle:{"display":"none"},attrs:{"name":"image1","type":"file","accept":"image/*"},on:{"change":_vm.onFileImage1Picked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.file1.click()}}},[_vm._v("Docs "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('div',{staticClass:"font-weight-thin"},[_vm._v("Joindre le chèque au format (JPEG,PNG,PDF) avec une taille de 1048 ko maximale")])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){_vm.dialogConfirmCheq = false; _vm.idBanqueCourant = ''; _vm.resetForm('formValidCheq')}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.submitValidForm('formValidCheq')}}},[_vm._v("Confirmer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowPiece),callback:function ($$v) {_vm.dialogShowPiece=$$v},expression:"dialogShowPiece"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Ajouter une piece justificative")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowPiece = false;_vm.showButtonPiece=false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('v-form',{ref:"formPieceJointe",attrs:{"lazy-validation":"","id":"formPieceJointe"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('p',{staticClass:"font-weight-thin"},[_vm._v("Format (JPEG,PNG,PDF), 10 Mo maximum")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.pieceJusti,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.pieceJusti,"alt":"avatar"}})]),_c('br')],1),_vm._v(" "),_c('input',{ref:"fileLogo",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFilepiceJutiPicked}}),_vm._v(" "),(_vm.showButtonPiece==true)?_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileLogo.click()}}},[_vm._v("Document  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1):_vm._e(),_c('br')],1)],1)],1)],1)])])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowPiece = false;_vm.showButtonPiece=false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n        Fermer\n      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.showButtonPiece === false)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.showButtonPiece=true}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n        Modifier\n      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.showButtonPiece === true)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.savePieceJointe();}},slot:"activator"},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e(),_vm._v("\n        Enregistrer\n      ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"45%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutTrans),callback:function ($$v) {_vm.dialogAjoutTrans=$$v},expression:"dialogAjoutTrans"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Transferer des fonds dans une autre trésorerie")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutTrans = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"transFertForm",staticClass:"demo-ruleForm",attrs:{"model":_vm.transFertForm,"rules":_vm.rulesTransfer,"id":"transFertForm","label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"Le montant","prop":"montantTransf"}},[_c('el-input',{attrs:{"type":"number","name":"montantTransf"},model:{value:(_vm.transFertForm.montantTransf),callback:function ($$v) {_vm.$set(_vm.transFertForm, "montantTransf", $$v)},expression:"transFertForm.montantTransf"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Caisse concerne","prop":"caisse"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Selectionner une caisse"},model:{value:(_vm.transFertForm.caisseSelect),callback:function ($$v) {_vm.$set(_vm.transFertForm, "caisseSelect", $$v)},expression:"transFertForm.caisseSelect"}},_vm._l((_vm.listCaisse),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Le motif","prop":"motif"}},[_c('el-input',{attrs:{"type":"textarea","name":"libelleTransfert","rows":5,"placeholder":"Presenter le motif"},model:{value:(_vm.transFertForm.libelleTransfert),callback:function ($$v) {_vm.$set(_vm.transFertForm, "libelleTransfert", $$v)},expression:"transFertForm.libelleTransfert"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":_vm.ClearTransfertForm}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitTransferCaisse('transFertForm')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n      Fermer\n    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"indigo","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newAppro(_vm.detailBanque);}},slot:"activator"},[_vm._v("Appro banque "),_c('v-icon',{attrs:{"right":""}},[_vm._v("get_app")])],1),_vm._v("\n      Approvisionner la banque\n    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"grey","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newTransfert(_vm.detailBanque);}},slot:"activator"},[_vm._v("Transfert "),_c('v-icon',{attrs:{"right":""}},[_vm._v("transfer_within_a_station")])],1),_vm._v("\n        Tranfert de fond dans une autre trésorerie\n      ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mQ16":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");


var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
    name: "AjoutZoneMaintenance",
    props: ["show", "zoneDetail", "editForm"],
    data: function data() {
        return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),

            loading: false,
            labelPosition: 'left',
            dialogZone: false,
            formZone: {},
            listeEntrepot: [],

            rules: {
                libelle: [{ required: true, message: 'Veuillez saisir' }],
                entrepot: [{ required: true, message: 'Veuillez selectionner' }]

            }
        };
    },


    computed: {},
    watch: {
        show: function show(newValue, oldvalue) {
            this.dialogZone = newValue;

            if (newValue == true) {
                if (this.editForm == true) {

                    this.formZone.libelle = this.zoneDetail.label;
                    this.formZone.entrepot = this.zoneDetail.idEntr;
                    this.formZone.description = this.zoneDetail.description;
                }
            } else {
                this.formZone = {};
            }
        }
    },

    methods: (_methods = {
        loadEntrepot: function loadEntrepot() {
            var _this = this;

            var url = this.domaine + 'entrepot/index';
            this.$http.get(url).then(function (response) {

                if (response.body) {
                    _this.listeEntrepot = response.body.entrepot;
                }
            });
        },
        createFilter: function createFilter(queryString) {
            return function (link) {
                return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
        closeDialog: function closeDialog() {
            this.$emit('close');
        },
        submitForm: function submitForm(formName) {
            var _this2 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this2.loading = true;
                    var form = document.getElementById("formZone");
                    //recuperation des demandes
                    var data = new FormData(form);
                    var url = "";
                    if (_this2.editForm == false && _this2.zoneDetail.label == null) //creer une nouvelle zone
                        {
                            url = _this2.domaine + 'demande_maintenance/create/zone';
                        } else if (_this2.editForm == false && _this2.zoneDetail.label != null) //ajouter une zone
                        {
                            url = _this2.domaine + 'demande_maintenance/create/souszone';
                            data.append("idZone", _this2.zoneDetail.id);
                        } else //modifier une sous une zone
                        {
                            url = _this2.domaine + 'demande_maintenance/edit/zone';
                            data.append("idZone", _this2.zoneDetail.id);
                        }

                    data.append("libelle", _this2.formZone.libelle);
                    data.append("idEntrepot", _this2.formZone.entrepot);
                    data.append("description", _this2.formZone.description);
                    data.append("userId", _this2.user.id);
                    _this2.$http.post(url, data).then(function (response) {
                        //reinitialiser le formulaire
                        _this2.resetForm('formZone');
                        _this2.formZone.description = '';
                        _this2.loading = false;
                        _this2.successNotif("Zone enregistrée avec succès");
                        _this2.closeDialog();
                    }, function (erreur) {
                        //reinitialiser le formulaire
                        _this2.resetForm('formZone');
                        _this2.formZone.description = '';
                        _this2.closeDialog();
                        _this2.loading = false;
                        _this2.$message.error("Une erreur est survenue lors de l'enregistrement de la zone");
                    });
                }
            });
        }
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "createFilter", function createFilter(queryString) {
        return function (link) {
            return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
        };
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "resetForm", function resetForm(formName) {
        this.$refs[formName].resetFields();
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "successNotif", function successNotif() {
        var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

        this.$notify({
            title: 'ENREGISTREMENT REUSSI',
            message: mess,
            type: 'success',
            position: 'top-center'
        });
    }), _methods),

    mounted: function mounted() {
        this.loadEntrepot();
    }
});

/***/ }),

/***/ "mYh4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listeBesoinTravaux_vue__ = __webpack_require__("v6OC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e33ff30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listeBesoinTravaux_vue__ = __webpack_require__("LFg+");
function injectStyle (ssrContext) {
  __webpack_require__("CZee")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listeBesoinTravaux_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e33ff30_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listeBesoinTravaux_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mZ7f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_boardChantier_Chantier_index__ = __webpack_require__("dZna");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { ChantierIndex: __WEBPACK_IMPORTED_MODULE_0__components_boardChantier_Chantier_index__["a" /* default */], Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: "Index_board_Chantier",
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [{ path: "/boardChantier", text: "DashBoard Chantier", disabled: false }],
      userAdmin: false,
      chantiers: []
    };
  },


  methods: {
    loadChantier: function loadChantier() {
      var _this = this;

      this.loading = true;
      var url = "";
      if (this.user.fonction == "Super Administrateur") {
        url = this.domaine + "chantier/liste";
        this.userAdmin = true;
      } else {
        url = this.domaine + "chantier/responsable/" + this.user.id;
        this.userAdmin = false;
      }

      this.$http.get(url).then(function (response) {
        _this.chantiers = response.body.chantier;
        _this.loading = false;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Echec lors du chargement des chantiers");
      });
    }
  },

  mounted: function mounted() {
    this.loadChantier();
  }
});

/***/ }),

/***/ "masD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mfyo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item,ind){return _c('v-breadcrumbs-item',{key:ind,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v(" "+_vm._s(item.text))])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":"","ml-1":"","mr-1":"","mt-1":""}},[_c('v-card',[_c('el-tabs',{attrs:{"stretch":"true","type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick(_vm.onglet)}},model:{value:(_vm.onglet),callback:function ($$v) {_vm.onglet=$$v},expression:"onglet"}},[_c('el-tab-pane',{attrs:{"label":" Validation devis / facture"}},[_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeDmdCom))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbDmdCom))]),_vm._v("\n                                                    Commandes à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeDmdCom}},[_c('el-table-column',{attrs:{"prop":"dateLivr","label":"Date de livraison"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user","width":"200","label":"Demandeur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projet","width":"300","label":"Projet"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chantier","width":"300","label":"Chantier"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"travaux","width":"270","label":"travaux"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailDmdCom(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                                Detail\n                                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeFour))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total des factures  à valider: ")]),_vm._v("  "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(new Intl.NumberFormat().format(_vm.mntTotalFactTTC))+" Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbFactFour))]),_vm._v("\n                                                    Factures à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Facture par fournisseur"},on:{"clear":function($event){return _vm.clearSelectFour()},"change":_vm.filtrerFour},model:{value:(_vm.selectFour),callback:function ($$v) {_vm.selectFour=$$v},expression:"selectFour"}},_vm._l((_vm.listeFournisseurs),function(item,ind){return _c('el-option',{key:ind,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeFacturesFour}},[_c('el-table-column',{attrs:{"prop":"date","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref","label":"Référence"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(_vm._s(new Intl.NumberFormat('fr-Fr').format(scope.row.total)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleFour","label":"Fournisseur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailFour(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                                Detail\n                                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeDmdFond))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total  à valider: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntTotalDmdFondTTC)+" Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbDmdFond))]),_vm._v("\n                                                    Demande de fonds à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Demandeur"},on:{"clear":function($event){return _vm.clearSelectFour()},"change":_vm.filtrerDmdFond},model:{value:(_vm.selectDmdFond),callback:function ($$v) {_vm.selectDmdFond=$$v},expression:"selectDmdFond"}},_vm._l((_vm.listeDemandeurFond),function(item,ind){return _c('el-option',{key:ind,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeDmdFond}},[_c('el-table-column',{attrs:{"prop":"dateFormat","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demandeur","label":"Nom du demandeur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantFormat","label":"Montant (Fcfa)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"typeDmd","label":"Type demande"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailDmdFond(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                                Detail\n                                                            ")],1)]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.droitAcces.all_appro_no_valid_dg)?_c('v-flex',{staticClass:"mr-3",attrs:{"xs6":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.legendeAppro))])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total  à valider: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntTotalAppro)+" F Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:" mb-3",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.nbAppro))]),_vm._v("\n                                                    Approvisionnement(s) à valider\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Facture par fournisseur"},on:{"clear":function($event){return _vm.clearSelectFour()},"change":_vm.filtrerFour},model:{value:(_vm.selectFour),callback:function ($$v) {_vm.selectFour=$$v},expression:"selectFour"}},_vm._l((_vm.listeFournisseurs),function(item,ind){return _c('el-option',{key:ind,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.listeDmdNoValidAppro}},[_c('el-table-column',{attrs:{"prop":"dateDmd","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"caisseLibelle","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(_vm._s(scope.row.montant)+" FCFA")])]}}],null,false,1202447318)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailAppro(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                                                            Detail\n                                                        ")],1)]}}],null,false,2190206670)})],1)],1)],1)],1)],1):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450"},model:{value:(_vm.dialogValideSuivant),callback:function ($$v) {_vm.dialogValideSuivant=$$v},expression:"dialogValideSuivant"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(" Validation suivante ")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez-vous passer à la validation suivante ?","closable":false,"show-icon":"","type":"warning"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogValideSuivant = false}}},[_vm._v("Non")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideSuivant()}}},[_vm._v("Afficher le fiche suivante")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"450"},model:{value:(_vm.dialogValideSuivant),callback:function ($$v) {_vm.dialogValideSuivant=$$v},expression:"dialogValideSuivant"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(" Validation suivante ")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez-vous passer à la validation suivante ?","closable":false,"show-icon":"","type":"warning"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){return _vm.CancelValideSuivant()}}},[_vm._v("Non")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideSuivant()}}},[_vm._v("Afficher le fiche suivante")])],1)],1)],1)],1),_vm._v(" "),_c('ModalValidationInterv',{attrs:{"intervDetail":_vm.intervDetail,"totalFact":_vm.mntTotalIntervTTC,"show":_vm.showModalIntervFact},on:{"close":_vm.showDialogIntervAfter}}),_vm._v(" "),_c('ModalValidationFacture',{attrs:{"factureDetail":_vm.factureDetail,"totalFact":_vm.mntTotalFactTTC,"show":_vm.showModalDetailFact,"listCaisse":_vm.listCaisse,"listBanque":_vm.listBanque,"commandeDeriv":_vm.commandeDeriv,"commandeDerivDeux":_vm.commandeDerivDeux,"mntTotalCmd":_vm.mntTotalCmd,"nbCommandeSug":_vm.nbCommandeSug,"nbCommandeSugDeux":_vm.nbCommandeSugDeux},on:{"close":_vm.showDialogFactAfter}}),_vm._v(" "),_c('ModalValidationDmd',{attrs:{"demandeDetail":_vm.demandeDetail,"show":_vm.showModalDetailDmd},on:{"close":_vm.showDialogDmdAfter}}),_vm._v(" "),_c('ModalValidationMiss',{attrs:{"detailMission":_vm.detailMission,"show":_vm.showModalDetailMiss},on:{"close":_vm.showDialogMissAfter}}),_vm._v(" "),_c('ModalValidationDmdFond',{attrs:{"valider":true,"logistique":true,"demandeDetail":_vm.demandeDetail,"show":_vm.showModalDetailDmdFond},on:{"close":_vm.showDialogDmdFondAfter}}),_vm._v(" "),_c('ModalValidationAppro',{attrs:{"approDetail":_vm.ApproDetail,"listCaisse":_vm.listCaisse,"listBanque":_vm.listBanque,"show":_vm.showModalDetailAppro},on:{"close":function($event){_vm.showModalDetailAppro = false; _vm.loadDmdNoValidAppro()}}}),_vm._v(" "),_c('ModalValidationPost',{attrs:{"detailCommande":_vm.detailCommande,"totalMontant":_vm.totalMontant,"show":_vm.showModalDetailDmdCom},on:{"close":_vm.showDialogDmdComAfter}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mlun":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadBudget_vue__ = __webpack_require__("CMsF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac359bea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadBudget_vue__ = __webpack_require__("UgKa");
function injectStyle (ssrContext) {
  __webpack_require__("ZO+E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ac359bea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadBudget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac359bea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadBudget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mnDS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n            "+_vm._s(item.text)+"\n          ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjout),callback:function ($$v) {_vm.dialogAjout=$$v},expression:"dialogAjout"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter un nouvel utilisateur")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification de l'utilisateur "+_vm._s(_vm.userCourant.nom)+" ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjout = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enregistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-form',{ref:"formUser",attrs:{"lazy-validation":"","id":"formUser"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('div',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":"","sm4":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoUser,"alt":"avatar"}})]),_c('br'),_vm._v(" "),_c('input',{ref:"fileLogo",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileLogo.click()}}},[_vm._v("Photo  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1)],1)])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-col',[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Nom et prénoms","name":"nomUser","rules":_vm.nomUserRules,"counter":4,"required":""},model:{value:(_vm.nomUser),callback:function ($$v) {_vm.nomUser=$$v},expression:"nomUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Login de connexion","name":"loginUser","rules":[function (v) { return !!v || 'Le login est obligatoire'; }],"required":""},model:{value:(_vm.loginUser),callback:function ($$v) {_vm.loginUser=$$v},expression:"loginUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"E-mail","name":"emailUser","rules":_vm.loginUserRules,"counter":6,"required":""},model:{value:(_vm.emailUser),callback:function ($$v) {_vm.emailUser=$$v},expression:"emailUser"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"name":"contactUser","min":"0","label":"Contact","counter":8,"rules":_vm.contactUserRules,"hint":"Exemple: 00-00-00-00","persistent-hint":"","required":""},model:{value:(_vm.contactUser),callback:function ($$v) {_vm.contactUser=$$v},expression:"contactUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"label":"Fonction occupé","name":"fonctionUser","counter":6,"required":""},model:{value:(_vm.fonctionUser),callback:function ($$v) {_vm.fonctionUser=$$v},expression:"fonctionUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"label":"Services","name":"serviceUser","items":_vm.listService,"rules":_vm.serviceUserRules,"item-value":"id","item-text":"libelle"},model:{value:(_vm.selectServiceUser),callback:function ($$v) {_vm.selectServiceUser=$$v},expression:"selectServiceUser"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[(_vm.selectTypeUser === 2)?_c('v-flex',{attrs:{"md4":""}},[_c('v-select',{attrs:{"label":"Poste occupé","name":"serviceUser","items":_vm.posteUser,"rules":[function (v) { return !!v || 'Veuillez sélectionner le poste.'; }],"item-value":"value","item-text":"text"},model:{value:(_vm.selectPosteUser),callback:function ($$v) {_vm.selectPosteUser=$$v},expression:"selectPosteUser"}})],1):_vm._e()],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                PARAMETRE DE CONNEXION\n                              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[(_vm.dialogEdit != true)?_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpUser","label":"Mot de passe","rules":_vm.mdpUserRules,"counter":4,"required":""},model:{value:(_vm.mdpUser),callback:function ($$v) {_vm.mdpUser=$$v},expression:"mdpUser"}})],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpUserConnect","label":"Votre mot de passe","rules":_vm.mdpUserConnectRules,"counter":4,"required":""},model:{value:(_vm.mdpUserConnect),callback:function ($$v) {_vm.mdpUserConnect=$$v},expression:"mdpUserConnect"}})],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit != true)?_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpVerUser","label":"Confirmer le mot de passe","rules":_vm.mdpVerUserRules,"counter":4,"required":""},model:{value:(_vm.mdpVerUser),callback:function ($$v) {_vm.mdpVerUser=$$v},expression:"mdpVerUser"}})],1):_vm._e()],1)],1)],1)])],1)],1),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":_vm.clear}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submit}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutGroupe),callback:function ($$v) {_vm.dialogAjoutGroupe=$$v},expression:"dialogAjoutGroupe"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.editGroup != true)?_c('span',[_vm._v("Ajouter un groupe")]):_vm._e(),_vm._v(" "),(_vm.editGroup)?_c('span',[_vm._v("Modification le groupe ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutGroupe = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enregistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-form',{ref:"formGroup",attrs:{"id":"formGroup","lazy-validation":""}},[_c('v-text-field',{attrs:{"name":"libelle","rules":_vm.GroupLIbRules,"label":"Libelle","required":""},model:{value:(_vm.formGroupe.libelle),callback:function ($$v) {_vm.$set(_vm.formGroupe, "libelle", $$v)},expression:"formGroupe.libelle"}}),_vm._v(" "),_c('v-textarea',{attrs:{"name":"description","textarea":"","label":"Description"},model:{value:(_vm.formGroupe.description),callback:function ($$v) {_vm.$set(_vm.formGroupe, "description", $$v)},expression:"formGroupe.description"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.SaveGroupe()}}},[_vm._v("\n                Enregistrer\n              ")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAttRole),callback:function ($$v) {_vm.dialogAttRole=$$v},expression:"dialogAttRole"}},[_c('v-card',[_c('v-toolbar',{staticClass:"orange",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter des permissions d'accès")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAttRole = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                ATTRIBUER DES ACCES MENUS AU GROUPE\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('el-transfer',{attrs:{"filterable":"","titles":['Liste des menus', 'Menu(s) du groupe'],"button-texts":['Retirer', 'Ajouter'],"data":_vm.allRoleMenus},model:{value:(_vm.menusGrpActu),callback:function ($$v) {_vm.menusGrpActu=$$v},expression:"menusGrpActu"}})],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  ATTRIBUER DES ACCES ROUTES AU GROUPE\n                ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":"","row":""}},[_c('el-transfer',{attrs:{"filterable":"","titles":['Liste des routes', 'Route(s) du groupe'],"button-texts":['Retirer', 'Ajouter'],"data":_vm.allRoleRoutes},model:{value:(_vm.routesGrpActu),callback:function ($$v) {_vm.routesGrpActu=$$v},expression:"routesGrpActu"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogAttRole = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":_vm.submitAttRoles}},[_vm._v("Valider la modification "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogRole),callback:function ($$v) {_vm.dialogRole=$$v},expression:"dialogRole"}},[_c('v-card',[_c('v-toolbar',{staticClass:"orange",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter des droits d'accès")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogRole = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                ATTRIBUER DES ROLES A L'UTILISATEUR\n              ")])],1),_vm._v(" "),_c('v-form',{ref:"formRole",attrs:{"lazy-validation":"","id":"formRole"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Attribuer des groupes")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","multiple":"","placeholder":"Selectionner les groupes"},model:{value:(_vm.selectedGroup),callback:function ($$v) {_vm.selectedGroup=$$v},expression:"selectedGroup"}},_vm._l((_vm.listeGroupes),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogRole = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.selectedGroup.length !== 0)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":_vm.submitRole}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShow),callback:function ($$v) {_vm.dialogShow=$$v},expression:"dialogShow"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails de l'utilisateur "+_vm._s(_vm.userCourant.nom)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShow = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"carte-header",attrs:{"slot":"header"},slot:"header"},[_c('v-flex',{attrs:{"text-xs-center":"","layout":"","align-center":"","justify-center":""}},[_c('v-avatar',{staticClass:"grey lighten-4",attrs:{"size":"140px"}},[(_vm.detailUser.url)?_c('img',{staticClass:"lazy",attrs:{"src":_vm.detailUser.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"src":_vm.logoUser,"alt":""}})])],1)],1),_vm._v(" "),_c('div',{staticClass:"text item"},[_c('p',[_c('b',[_vm._v("Nom et prénoms : ")]),_vm._v(" "+_vm._s(_vm.detailUser.nom)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Login :")]),_vm._v(" "+_vm._s(_vm.detailUser.username)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Email :")]),_vm._v(" "+_vm._s(_vm.detailUser.email)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Fonction :")]),_vm._v(" "+_vm._s(_vm.detailUser.fonction)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Service :")]),_vm._v(" "+_vm._s(_vm.detailUser.service)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Contact :")]),_vm._v(" "+_vm._s(_vm.detailUser.telephone)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enrégistrement :")]),_vm._v(" "+_vm._s(_vm.detailUser.created))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v(" "+_vm._s(_vm.detailUser.modified))])])])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.admin_profil_update_user && _vm.userCourant.type === 1 || _vm.userCourant.type === 2)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editUser(_vm.userCourant);}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                  Modifier\n                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newRole(_vm.detailUser);}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("vpn_key")])],1),_vm._v("\n                  Droit d'accès\n                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.submitResetPassword();}},slot:"activator"},[_vm._v("Reinitialiser le mot de passe "),_c('v-icon',{attrs:{"right":""}},[_vm._v("lock")])],1),_vm._v("\n                  Reinitialiser le mot de passe de l'utilisateur\n                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogMdp = true;}},slot:"activator"},[_vm._v(" Attribuer un nouveau  mot de passe  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("lock")])],1),_vm._v("\n                  Attribuer un nouveau  mot de passe \n                ")],1)],1),_vm._v(" "),_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-star-off"}),_vm._v(" Menus autorisés")]),_vm._v(" "),_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailUser.menu,"height":"400"}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Description"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(scope.row.libelle)+"\n                                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"Route"}})],1)],1)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Config"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-document"}),_vm._v(" Rôles")]),_vm._v(" "),_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailUser.role,"height":"400"}},[_c('el-table-column',{attrs:{"prop":"description","label":"Description","width":"350"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(scope.row.description)+"\n                                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"route","label":"Route"}})],1)],1)])],1)],1)],1)],1),_vm._v(" "),_c('br')])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogMdp),callback:function ($$v) {_vm.dialogMdp=$$v},expression:"dialogMdp"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Attribuer un mot de passe à l'utilisateur "+_vm._s(_vm.detailUser.nom))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogMdp = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{attrs:{"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-form',{ref:"formMdp",attrs:{"lazy-validation":"","id":"formMdp"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify-left":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpNewUser","label":"Nouveau mot de passe","rules":_vm.mdpNewUserRules,"counter":4,"required":""},model:{value:(_vm.mdpNewUser),callback:function ($$v) {_vm.mdpNewUser=$$v},expression:"mdpNewUser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-text-field',{attrs:{"type":"password","name":"mdpNewVerUser","label":"Confirmer le nouveau mot de passe","rules":_vm.mdpNewVerUserRules,"counter":4,"required":""},model:{value:(_vm.mdpNewVerUser),callback:function ($$v) {_vm.mdpNewVerUser=$$v},expression:"mdpNewVerUser"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":_vm.clear}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submitMdp}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowGroup),callback:function ($$v) {_vm.dialogShowGroup=$$v},expression:"dialogShowGroup"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du groupe "+_vm._s(_vm.groupCourant.libelle)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowGroup = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"text item"},[_c('h5',[_vm._v("Libelle :"),_c('b',[_vm._v(" "+_vm._s(_vm.groupCourant.libelle)+" ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Créé le :"),_c('b',[_vm._v(" "+_vm._s(_vm.groupCourant.created)+" ")])]),_vm._v(" "),_c('p',[_vm._v("Créé par :"),_c('b',[_vm._v(" "+_vm._s(_vm.groupCourant.createur)+" ")])])])])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":16}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-star-off"}),_vm._v(" Menus autorisés")]),_vm._v(" "),_c('div',[_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Rechercher","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headersGroupMenus,"search":_vm.search,"items":_vm.groupeRoles.menus},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                                  "+_vm._s(props.header.text)+"\n                                ")]),_vm._v(" "),_c('span',[_vm._v("\n                                  "+_vm._s(props.header.text)+"\n                                ")])])]}},{key:"items",fn:function(props){return [_c('td',[_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(props.item.nom)+"\n                                ")])],1),_vm._v(" "),_c('td',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(props.item.libelle)+"\n                                ")])],1)]}}])})],1)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Config"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-document"}),_vm._v(" Rôles")]),_vm._v(" "),_c('div',[_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Rechercher","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headersGroupMenus,"search":_vm.search,"items":_vm.groupeRoles.routes},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                                  "+_vm._s(props.header.text)+"\n                                ")]),_vm._v(" "),_c('span',[_vm._v("\n                                  "+_vm._s(props.header.text)+"\n                                ")])])]}},{key:"items",fn:function(props){return [_c('td',[_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(props.item.description)+"\n                                ")])],1),_vm._v(" "),_c('td',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(props.item.route)+"\n                                ")])],1)]}}])})],1)])],1)],1)],1)],1),_vm._v(" "),_c('br')])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer cet enregistrement ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteUser($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)])],1)],1),_vm._v(" "),(_vm.droitAcces.index_user)?_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('div',{staticClass:"text item"},[_c('el-button',{staticStyle:{"margin":"5px","width":"100%"},attrs:{"icons":""},on:{"click":function($event){return _vm.voirUser()}}},[_vm._v("Utilisateur"),_c('v-icon',{attrs:{"right":""}},[_vm._v("account_circle")])],1),_vm._v(" "),(_vm.user.fonction == 'Super Administrateur')?_c('div',[_c('el-button',{staticStyle:{"margin":"5px","width":"100%"},attrs:{"icons":""},on:{"click":function($event){return _vm.voirResponsable()}}},[_vm._v("Responsable"),_c('v-icon',{attrs:{"right":""}},[_vm._v("accessibility")])],1),_vm._v(" "),_c('el-button',{staticStyle:{"margin":"5px","width":"100%"},attrs:{"icons":""},on:{"click":function($event){return _vm.voirRepresentant()}}},[_vm._v("Représentant de  zone"),_c('v-icon',{attrs:{"right":""}},[_vm._v("accessibility")])],1),_vm._v(" "),_c('el-button',{staticStyle:{"margin":"5px","width":"100%"},attrs:{"icons":""},on:{"click":function($event){return _vm.voirFourn()}}},[_vm._v("Prestataire"),_c('v-icon',{attrs:{"right":""}},[_vm._v("assignment")])],1),_vm._v(" "),_c('el-button',{staticStyle:{"margin":"5px","width":"100%"},attrs:{"icons":""},on:{"click":function($event){return _vm.voirGroup()}}},[_vm._v("Groupes"),_c('v-icon',{attrs:{"right":""}},[_vm._v("call_split")])],1)],1):_vm._e()],1)])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[(_vm.sessionUser)?_c('el-tabs',[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v(" UTILISATEUR "),_c('v-icon',{attrs:{"right":""}},[_vm._v("account_circle")])],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[(_vm.droitAcces.create_user)?_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"blue","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newUser();}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n                          Ajouter un nouvel utilisateur\n                        ")],1)],1):_vm._e(),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            LISTE DES UTILISATEURS "),_c('v-icon',{attrs:{"right":""}},[_vm._v("account_circle")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeUser('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeUser('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnUs,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                                  ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"Rechercher un utilisateur"},on:{"clear":function($event){return _vm.clearSelect()},"change":_vm.filtrerEtatPrioriteBesoin},model:{value:(_vm.rechercheUser),callback:function ($$v) {_vm.rechercheUser=$$v},expression:"rechercheUser"}},_vm._l((_vm.listUser),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.listUser},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                                  "+_vm._s(props.header.text)+"\n                                ")]),_vm._v(" "),_c('span',[_vm._v("\n                                  "+_vm._s(props.header.text)+"\n                                ")])])]}},{key:"items",fn:function(props){return [_c('td',[_c('v-avatar',[(props.item.url)?_c('img',{staticClass:"lazy",attrs:{"src":props.item.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"src":_vm.logoUser,"alt":""}})])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(props.item.nom)+"\n                                ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(props.item.email)+"\n                                ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.contact))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.user_show)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showUser(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1):_vm._e(),_vm._v("\n                                    Détails\n                                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.admin_profil_update_user)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){$event.stopPropagation();return _vm.editUser(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                                    Modifier\n                                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.role_user)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.newRole(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("vpn_key")])],1):_vm._e(),_vm._v("\n                                    Droit d'accès\n                                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.user_delete)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSupr = true; _vm.idUser = props.item.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                                    Supprimer\n                                  ")],1)],1)])]}}],null,false,4268761431)})],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.index_responsable_zone )?_c('el-tabs',[(_vm.sessionResponsable)?_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v(" REPRESENTANT DE ZONE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("accessibility")])],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('Representant')],1)],1):_vm._e(),_vm._v(" "),(_vm.sessionResponsableZone)?_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v(" RESPONSABLE DE ZONE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("accessibility")])],1),_vm._v(" "),_c('Responsable')],1):_vm._e(),_vm._v(" "),(_vm.sessionResponsableZone)?_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v(" TECHNICIEN "),_c('v-icon',{attrs:{"right":""}},[_vm._v("accessibility")])],1),_vm._v(" "),_c('Technicien')],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.sessionFourn)?_c('el-tabs',[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v(" PRESTATAIRE DESIGNE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("assignment")])],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            LISTE DES PRESTATAIRES DESIGNES "),_c('v-icon',{attrs:{"right":""}},[_vm._v("assignment")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListePrest('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListePrest('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnPrest,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                                  ")])],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Rechercher","single-line":"","hide-details":""},model:{value:(_vm.recherche),callback:function ($$v) {_vm.recherche=$$v},expression:"recherche"}})],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"search":_vm.recherche,"items":_vm.listFournisseur},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                                  "+_vm._s(props.header.text)+"\n                                ")]),_vm._v(" "),_c('span',[_vm._v("\n                                  "+_vm._s(props.header.text)+"\n                                ")])])]}},{key:"items",fn:function(props){return [_c('td',[_c('v-avatar',[(props.item.url)?_c('img',{staticClass:"lazy",attrs:{"src":props.item.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"src":_vm.logoUser,"alt":""}})])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(props.item.nom)+"\n                                ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(props.item.email)+"\n                                ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.contact))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.user_show)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showUser(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1):_vm._e(),_vm._v("\n                                    Détails\n                                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.role_user)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.newRole(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("vpn_key")])],1):_vm._e(),_vm._v("\n                                    Droit d'accès\n                                  ")],1)],1)])]}}],null,false,1389859109)})],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.sessionGroup)?_c('el-tabs',[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v(" LISTE DES GROUPES "),_c('v-icon',{attrs:{"right":""}},[_vm._v("assignment")])],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"blue","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newGroupe();}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n                            Ajouter un groupe\n                        ")],1)],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            LISTE DES GROUPES "),_c('v-icon',{attrs:{"right":""}},[_vm._v("assignment")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Rechercher","single-line":"","hide-details":""},model:{value:(_vm.recherche),callback:function ($$v) {_vm.recherche=$$v},expression:"recherche"}})],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headersGroup,"search":_vm.recherche,"items":_vm.listGroupe},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                                  "+_vm._s(props.header.text)+"\n                                ")]),_vm._v(" "),_c('span',[_vm._v("\n                                  "+_vm._s(props.header.text)+"\n                                ")])])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-right"},[_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(props.item.created)+"\n                                ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(props.item.libelle)+"\n                                ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(props.item.description)+"\n                                ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.user_show)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showGroupe(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1):_vm._e(),_vm._v("\n                                    Détails du groupe\n                                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.user_show)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.modalEditGroup(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                                    Modifier\n                                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.role_user)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.attribuerRoleGroup(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("vpn_key")])],1):_vm._e(),_vm._v("\n                                    Droit d'accès\n                                  ")],1)],1)])]}}],null,false,675608911)})],1)],1)],1)],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('br')])],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mnuV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LoadConducteurExcel",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  props: {
    listeTypeTravaux: {
      type: Array,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      dialogAjoutConducteur: false,
      loading: false
    };
  },

  watch: {
    show: function show(newValue, oldValue) {
      if (newValue == true) {
        this.dialogAjoutConducteur = true;
      } else {
        this.dialogAjoutConducteur = false;
        window.location.reload();
      }
    }
  },
  methods: {
    saveListe: function saveListe() {
      var _this = this;

      // this.loadPage()

      var succesEnreg = true;
      var url = this.domaine + "product/save/liste_Produit/excel";
      var nbData = 10;
      var nbReq = 1;
      var ligne = null;

      var nbRest = void 0;
      if (this.listeTypeTravaux.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.listeTypeTravaux.length / nbData);
        nbRest = this.listeTypeTravaux.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (var i = 0; i < nbReq; i++) {
        var initJ = i * nbData;
        var finJ = (i + 1) * nbData;
        var dataLot = [];
        if (this.listeTypeTravaux.length > 0) {
          for (var j = initJ; j < finJ; j++) {
            if (this.listeTypeTravaux[j] == undefined) {
              break;
            }
            dataLot.push(this.listeTypeTravaux[j]);
          }
        }
        var data = new FormData();
        for (var prop in dataLot) {
          ligne = dataLot[prop];
          data.append("option[codeGestion][]", ligne.codeGestion);
          data.append("option[codeAnalytique][]", ligne.codeAnalytique);
          data.append("option[reference][]", ligne.reference);
          data.append("option[libelle][]", ligne.libelle);
          data.append("option[type][]", ligne.type);
          data.append("option[unite][]", ligne.unite);
          data.append("option[valeur][]", ligne.valeur);
          data.append("option[description][]", ligne.description);
        }

        // data.append('listeTypeTravaux', JSON.stringify(dataLot))
        data.append("idUser", this.user.id);

        this.$http.post(url, data).then(function (resp) {
          succesEnreg = true;
          _this.$notify({
            title: "Enregistrement",
            message: "La liste a ete enregistre avec succes",
            type: "success",
            position: "top-right",
            duration: 2000
          });
        }, function (error) {
          _this.loading = false;
          _this.$message.error("Erreur lors de l'enregistrement des types travaux");
          succesEnreg = false;
        });
      }

      //  this.loading = true
      var loading = this.$loading({
        lock: true,
        text: "Veuillez patientez ...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
        // this.loading = false
        if (succesEnreg == true) {
          _this.$notify({
            title: "Enregistrement",
            message: "La liste a ete enregistre avec succes",
            type: "success",
            position: "top-right",
            duration: 7000
          });
          _this.$emit("close");
        }
      }, 30000);
    },
    loadProduit: function loadProduit() {
      var _this2 = this;

      this.loading = true;

      var url = "";
      if (this.droitAcces.product_list) {
        url = this.domaine + "product/product-list";
      } else {
        url = this.domaine + "product/" + this.user.id + "/product-list";
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this2.listProduit = response.body;
          _this2.itemsProduit = response.body;
        }
        _this2.loading = false;
      });
    },
    closeDialog: function closeDialog() {
      var _this3 = this;

      var loading = this.$loading({
        lock: true,
        text: "Veuillez patientez ...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
        _this3.$emit("close");
      }, 1000);

      this.loadProduit();
    }
  }
});

/***/ }),

/***/ "n84h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n96b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
    name: "ModalValidationFacture",
    props: ["show", "intervDetail", "totalFact"],
    data: function data() {
        return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            dialogDetail: false,
            tableProduit: [],
            totalTTC: 0,
            formRapport: {},
            dialogVisible: false,
            dialogImageUrl: '',
            imageDmd1: "",
            imageDmd2: "",
            imageDmd3: "",
            imageConst1: "",
            imageConst2: "",
            imageConst3: "",
            imageDepan1: "",
            imageDepan2: "",
            imageDepan3: "",
            dialogConfirmRefus: false,
            commandeDeriv: [],
            dialogConfirm: false,
            formRefus: {},
            ruleFormRefus: {
                rapportRefus: [{ required: true, message: 'Veuillez saisir' }]
            }
        };
    },


    computed: {},
    watch: {
        show: function show(newValue, oldvalue) {
            this.dialogDetail = newValue;
            if (newValue == true) {
                this.analyseCommande(this.intervDetail.commandes[0].idCommande);
            }
        }
    },

    methods: {
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        },
        closeDialog: function closeDialog() {
            this.$emit('close', this.intervDetail.intervId, "intervention");
        },
        loadDevisConstat: function loadDevisConstat() {
            var _this = this;

            this.loading = true;
            var url = this.domaine + 'demande_maintenance/devis/constat/' + this.intervDetail.idDemande;
            this.$http.get(url).then(function (response) {

                _this.tableProduit = response.body.tableProduit;
                _this.formRapport.rapport = response.body.rapport;
                _this.totalTTC = response.body.total;
                _this.loading = false;
            }, function (errResp) {
                _this.loading = false;
                _this.$message.error("Une erreur est survenue lors du chargement de la table des produits");
            });
        },
        handleSuccess: function handleSuccess(response, file, fileList) {
            this.fileList.push(file);
        },
        handlePictureCardPreview: function handlePictureCardPreview(file, fileList) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        imprimerDetail: function imprimerDetail() {

            var url = this.domaine + "demande_maintenance/imprimerPDF/demande/" + this.user.id + "/" + this.intervDetail.idDemande;
            window.open(url);
        },
        SubmitValideDevis: function SubmitValideDevis() {
            var _this2 = this;

            this.loading = true;
            var data = new FormData();
            data.append('idUser', this.user.id);
            data.append('etape', 3);
            data.append('reponse', 3);
            data.append('remarque', "");
            data.append('intervId', this.intervDetail.intervId);
            data.append('entrepotId', this.intervDetail.entrepotId);
            var url = this.domaine + 'intervention/new/valider/intervention';
            this.$http.post(url, data).then(function (response) {
                _this2.loading = false;
                _this2.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: "Validation de l'intervention enregistré avec succès.",
                    type: 'success',
                    position: 'top-center'
                });
                _this2.dialogConfirm = false;
                _this2.closeDialog();
                return response.body.message;
            }).then(function (message) {
                for (mes in message) {
                    _this2.$notify({
                        title: 'COMMANDE GENEREE ',
                        message: mes,
                        type: 'success',
                        position: 'top-center'
                    });
                }
            }, function (response) {
                _this2.loading = false;
                _this2.dialogConfirm = false;
                _this2.closeDialog();
            });
        },
        SubmitRefusDevis: function SubmitRefusDevis() {
            var _this3 = this;

            this.loading = true;
            var url = this.domaine + 'intervention/new/' + this.intervDetail.intervId + '/valider/intervention';

            var data = new FormData();
            data.append("id", this.intervDetail.idFact);
            data.append("idUser", this.user.id);
            data.append('etape', 2);
            data.append("remarque", this.formRefus.rapport);
            data.append("reponse", 2);
            this.$http.post(url, data).then(function (response) {
                _this3.loading = false;
                _this3.successNotif(response.body.message);
                _this3.dialogConfirmRefus = false;
                _this3.closeDialog();
            }, function (errResp) {
                _this3.loading = false;
                _this3.$message.error("Une erreur est survenue lors de la facture");
            });
        },
        analyseCommande: function analyseCommande(idCommande) {
            var _this4 = this;

            //analyse des produit des la commande
            var url = this.domaine + 'comparateur/commande/' + idCommande;
            this.$http.get(url).then(function (response) {
                var respFour = response.body.fournisseurs[0];
                var listeFoun = [];
                for (var four in respFour) {
                    //nbCmd++;
                    var listeProduit = respFour[four];
                    var infoFour = {
                        "fournisseur": four,
                        "produits": [],
                        "mntTotal": 0
                    };
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(listeProduit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var produit = _step.value;

                            infoFour.produits.push(produit);
                            infoFour.mntTotal += parseFloat(produit.mntTotal);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    listeFoun.push(infoFour);
                }
                _this4.commandeDeriv = listeFoun;
            }, function (errorResp) {});
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var domaine = "https://erp-gestion.bemitian.com/webservice/web/privated/";
/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  data: function data() {
    return {
      valid: true,
      password: '',
      dialogPassword: false,
      login: '',
      loading: false,
      loginRules: [function (v) {
        return !!v || 'Le login est obligatoire';
      }, function (v) {
        return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
      }],
      passwordRules: [function (v) {
        return !!v || 'Le mot de passe est obligatoire';
      }, function (v) {
        return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
      }],
      logo: "/static/bemitian-sa.jpeg"
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      var loading = this.$loading({
        lock: true,
        text: 'En cours de traitement',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.9)'
      });
      setTimeout(function () {
        loading.close();
      }, 3000);
      if (this.$refs.form.validate()) {
        var url = domaine + 'userCreate/login-user-connexion/' + this.login + '/' + this.password;
        this.$http.get(url).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 5) {
              _this.$notify({
                title: 'BIENVENUE DANS VOTRE SESSION',
                message: 'Connexion réussie avec succès.',
                type: 'success',
                position: 'top-center'
              });
              sessionStorage.setItem('sessionUser', true);
              var notif = response.body.data.notif;
              var menu = response.body.data.menus;
              var droit = response.body.data.roles;
              var group = response.body.data.group;
              sessionStorage.setItem('sessionNotif', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(notif));
              if (group.length > 0) {
                sessionStorage.setItem('userGroup', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(group));
              }
              sessionStorage.setItem('sessionDomaine', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(domaine));
              sessionStorage.setItem('sessionAcces', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(menu)); //role pour acceder au menu
              sessionStorage.setItem('sessionDroit', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(droit)); //role pour acceder a certaines fonction
              sessionStorage.setItem('userInfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.body.data));
              _this.$router.go({ name: 'Home' });
            } else if (verif.code === 4) {
              _this.$notify.error({
                title: 'ERREUR',
                message: "Erreur d'indentification de l'utilisateur.",
                position: 'top-center'
              });
            } else if (verif.code === 3) {
              _this.$notify.error({
                title: 'ERREUR',
                message: "Erreur l'utilisateur inexistante pas.",
                position: 'top-center'
              });
            } else if (verif.code === 2) {
              _this.$notify.error({
                title: 'ERREUR',
                message: 'Le format de votre e-mail est invalide',
                position: 'top-center'
              });
            }
          } else {}
        }, function (response) {});
      }
    },
    submitResetPassword: function submitResetPassword() {
      var _this2 = this;

      this.loading = true;
      this.dialogPassword = false;

      var url = domaine + 'userCreate/reset/password';
      var data = new FormData();
      data.append("username", this.login);
      this.$http.post(url, data).then(function (response) {
        _this2.loading = false;

        if (response.body.code == 0) {
          _this2.$notify.error({
            title: 'Reinitialisation du mot de passe',
            message: "L'utilisateur n'exite pas"
          });
          return;
        } else {
          _this2.$notify({
            type: 'success',
            title: 'Reinitialisation du mot de passe',
            message: "Le mot de passe a ete enregistre vous recevrez les identifiants par sms et mail"
          });
        }
      }, function (response) {
        _this2.loading = false;
        _this2.$notify.error({
          title: 'Reinitialisation du mot de passe',
          message: "Une erreur est survenu lors de la reinitialisation de votre mot de passe"
        });
      });
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  },
  computed: {
    isValidLogin: function isValidLogin() {
      if (this.login == undefined || this.login == "") {
        return false;
      } else {
        return true;
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ "nbCe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","scrollable":"","loading":_vm.loading,"fullscreen":"","hide-overlay":""},model:{value:(_vm.dialogDetail),callback:function ($$v) {_vm.dialogDetail=$$v},expression:"dialogDetail"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Fiche de Validation du bon de commande interne\n          "+_vm._s(_vm.detailCommande.ref))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',[_c('v-flex',[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                    Informations générales\n                  ")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Projet")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.projet)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.chantier)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Travaux")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.travaux)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Tâches")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},_vm._l((_vm.detailCommande.tache),function(item,index){return _c('span',{key:index},[_c('v-chip',{attrs:{"outline":"","label":""}},[_vm._v("\n                                        "+_vm._s(item)+"\n                                      ")]),_vm._v("\n                                      /\n                                    ")],1)}),0)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("PK début")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.tranconA)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("PK fin")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.tranconB)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de la livraison")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.dateLivr)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Demandeur")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.user)+"\n                                  ")])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.urlImage)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","id":"intro","dark":""},on:{"click":function($event){return _vm.showDiapo([_vm.urlImage], 0, _vm.urlImage)}},slot:"activator"},[_vm._v("Voir la pièce justificatif\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("list")])],1):_vm._e(),_vm._v("\n                    Voir la pièce justificatif\n                  ")],1)],1),_vm._v(" "),_c('CoolLightBox',{attrs:{"items":_vm.items,"index":_vm.index},on:{"close":function($event){_vm.index = null}}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                    liste des ressources\n                  ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('el-table',{staticClass:"text-center",attrs:{"data":_vm.detailCommande.option,"border":""}},[_c('el-table-column',{staticClass:"text-center",attrs:{"prop":"codeAnalytique","label":"Code analytique"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.codeAnalytique))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"codeGestion","label":"Code de gestion"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.codeGestion))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"400","prop":"produit","label":"Ressource"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"orange accent-3"}},[_vm._v(_vm._s(scope.row.produit))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"80","prop":"unite","label":"unité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.unite))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"250","prop":"qte","label":"Quantité commandé"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input-number',{attrs:{"min":0,"name":"qte"},model:{value:(prop.row.qte),callback:function ($$v) {_vm.$set(prop.row, "qte", $$v)},expression:"prop.row.qte"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteStock","label":"Quantité en stock"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(new Intl.NumberFormat("fr-Fr").format(scope.row.qteStock)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"budgetPre","label":"Budget Prévu"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(new Intl.NumberFormat("fr-Fr").format(scope.row.budgetPre)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalDepn","label":"Budget Engagé"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(new Intl.NumberFormat("fr-Fr").format(scope.row.totalDepn)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"budgetR","label":"Budget Restant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(new Intl.NumberFormat("fr-Fr").format(scope.row.budgetR)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Opérations","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();_vm.dialogSupr = true;
                                _vm.deleteRow(scope.$index, _vm.detailCommande.option)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                            Supprimer cette tâche\n                          ")],1)]}}])})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5",staticStyle:{"margin-right":"100px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"red"},on:{"click":function($event){_vm.dialogConfirmRefus = true}},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Rejeter la commande")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"green"},on:{"click":function($event){_vm.dialogConfirm = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v("Valider la commande")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirmRefus),callback:function ($$v) {_vm.dialogConfirmRefus=$$v},expression:"dialogConfirmRefus"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation du bon de commande interne")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous Refuser ce bon de commnde ?","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("\n                COMMANDE REFERENCE\n              ")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("\n                "+_vm._s(_vm.detailCommande.ref)+"\n              ")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirmRefus = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideDevis('rejeter')}}},[_vm._v("Refuser")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation d'un bon de commande interne (bci)")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous valider ce bon de commande interne ?","closable":false,"show-icon":"","type":"success"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("\n                BON DE COMMANDE REFERENCE\n              ")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("\n                "+_vm._s(_vm.detailCommande.ref)+"\n              ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{ref:"refFormRefust",staticClass:"demo-form-inline",attrs:{"id":"formRefus","label-position":"top","inline":true,"model":_vm.formRefus}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Commentaire","prop":"rapportRefus"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Commentaire"},model:{value:(_vm.formRefus.rapport),callback:function ($$v) {_vm.$set(_vm.formRefus, "rapport", $$v)},expression:"formRefus.rapport"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirm = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideDevis('confirme')}}},[_vm._v("Confirmer")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cette ligne ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteBesoin()}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nenw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","xs12":""}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"100%"},model:{value:(_vm.dialogAjoutConducteur),callback:function ($$v) {_vm.dialogAjoutConducteur=$$v},expression:"dialogAjoutConducteur"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter des lots de taches ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeTypeTravaux}},[_c('el-table-column',{attrs:{"prop":"ordre","label":"Ordre","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.ordre)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé tâche","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.libelle)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.unite)+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix unitaire (FCFA)","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(new Intl.NumberFormat("fr-FR").format(scope.row.prix))+"\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"Description","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                    "+_vm._s(scope.row.description)+"\n                  ")])]}}])})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"orange","dark":""},on:{"click":function($event){return _vm.closeDialog()}},slot:"activator"},[_vm._v("Anuller "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('span',[_vm._v("Annuler")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"green","dark":""},on:{"click":function($event){return _vm.saveListe()}},slot:"activator"},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1),_vm._v(" "),_c('span',[_vm._v("Enregistrer les lots de taches")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nu3F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailBudgetProjet_vue__ = __webpack_require__("xsRH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44397927_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailBudgetProjet_vue__ = __webpack_require__("4pxx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailBudgetProjet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44397927_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailBudgetProjet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nxC/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_besoin_VehiculeBesoin__ = __webpack_require__("K4PS");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */], VehiculeBesoin: __WEBPACK_IMPORTED_MODULE_2__components_besoin_VehiculeBesoin__["a" /* default */] },
  name: "FicheVehicule",
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      loading: false,
      valid: true,
      detailVeh: {},
      mission: {},
      docAttach: {},
      racourcis: [{ path: "/parc/auto", text: "Parc auto", disabled: false }, { path: "/parc/auto/flotte", text: "Flotte", disabled: false }, { path: "/", text: "Fiche vehicule", disabled: false }],
      idVeh: this.$route.params.id,
      dialogAjoutVeh: false,
      dialogSuprVign: false,
      idAssu: "",
      idVign: "",
      idVisit: "",
      dialogSuprVisit: false,
      dialogSuprAssu: false,
      dialogAjoutAssu: false,
      dialogAjoutVisit: false,
      dialogAjoutVign: false,
      dialogEdit: false,
      dialogSuprCond: false,
      active: null,
      logoAssur: "/static/img-doc.png",
      logoVisit: "/static/img-doc.png",
      formCond: {},
      itemsCond: [],
      itemsDoc: [],
      itemsDocAss: [],
      listConducteur: [],
      mntTotAssur: 0,
      mntTotVig: 0,
      mntTotVid: 0,
      mntTotVistech: 0,
      itemsDocVig: [],
      itemsDocVis: [],
      itemsCons: [],
      listSousCategorie: [],
      mntTotCons: 0,
      quantTotCons: 0,
      distParcTot: 0,
      itemsInterv: [],
      listContrat: [],
      logoVignet: "",
      nbrContratExpireDay: 0,
      mntTotInterv: 0,
      messageAlert: "",
      formAssu: {
        attestation: "",
        police: "",
        montant: "",
        description: "",
        dateAssu: null,
        dateDebutAssu: null,
        dateFinAssu: null,
        dateRenAssu: null
      },
      formVisite: {
        libelle: "",
        numero: "",
        dateDebut: null,
        dateFin: null,
        dateRen: null,
        montant: "",
        description: "",
        vehMat: ""
      },
      formVidn: {
        numero: "",
        date: null,
        dateDebt: null,
        dateRen: null,
        montant: "",
        document: "",
        vehMat: "",
        statut: ""
      },
      selectCompagnLib: "",
      assuranceCourant: [],
      statut: [{ value: 1, label: "Activé" }, { value: 0, label: "Desactivé" }],
      statutVign: [{
        value: 1,
        label: "Activé"
      }, {
        value: 0,
        label: "Desactivé"
      }],
      listCompagn: [],
      visiteCourant: [],
      vignetteCourant: [],
      listMarque: [],
      listCategorie: [],
      typeCarburant: [],
      vidangeCourant: [],

      idConducteur: "",
      listModele: [],
      listSerie: [],
      e1: 0,
      imageCarteGris: "/static/img-doc.png",
      imageVeh: "/static/car_avatar.png",
      formVehicule: {},
      listParc: [],
      mntTotContrat: 0,
      nbAssurAbs: 0,
      nbAssurAexp: 0,
      nbVisiteTechAbs: 0,
      nbVisiteTechExp: 0,
      nbVignetteAbs: 0,
      nbVignetteExp: 0,
      disabledBtnDoc: false,
      disabledBtnMiss: false,
      disabledBtnAdminAssu: false,
      disabledBtnAdminVign: false,
      disabledBtnAdminVisit: false,
      disabledBtnAdminConso: false,
      disabledBtnAdminInter: false,
      disabledBtnAdminLoc: false,
      dialogAjoutVehiConducteur: false,
      dialogFicheCond: false,
      AllConducteur: [],
      conducteurCourant: [],
      formAttribueCondu: {
        conducteur: '',
        vehicule: ''
      },
      //ONGLET TRAVAUX
      listeBesoinsVehValid: []
    };
  },

  computed: {
    formVehIsValid: function formVehIsValid() {
      return this.formVehicule.marqueId != "" && this.formVehicule.modeleId != "" && this.formVehicule.serieId != "" && this.formVehicule.matricule != null && this.formVehicule.numChassis != null && this.formVehicule.numCarteGris != null && this.formVehicule.typeCarbuId != null && this.formVehicule.kilometrage != null && this.formVehicule.parcId != null;
    }
  },
  methods: {
    loadBesoinVehValider: function loadBesoinVehValider() {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "besoin/valider/vehicule/" + this.idVeh;
      this.$http.get(url).then(function (response) {
        _this.listeBesoinsVehValid = response.body.besoins;
        _this.loading = false;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Echec lors du chargement des vehicules affectés au besoins");
      });
    },
    newAttrCondu: function newAttrCondu() {
      this.loadListConducteur();
      this.dialogAjoutVehiConducteur = true;
      this.formAttribueCondu.conducteur = '';
    },
    imprimeInfoVeh: function imprimeInfoVeh() {

      var url = this.domaine + "tabParcauto/impression/vehicule/" + this.idVeh;
      window.open(url);
    },
    imprimeListeHisDocVeh: function imprimeListeHisDocVeh(type) {
      var idVeh = this.idVeh;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "tabParcauto/imprimerPDF/historique/" + idVeh + "/document/vehicule";
      } else {
        url = this.domaine + "tabParcauto/imprimerEXC/historique/" + idVeh + "/document/vehicule";
      }
      window.open(url);
    },
    imprimeListeHisMissionVeh: function imprimeListeHisMissionVeh(type) {
      var idVeh = this.idVeh;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "tabParcauto/imprimerPDF/historique/" + idVeh + "/mission/vehicule";
      } else {
        url = this.domaine + "tabParcauto/imprimerEXC/historique/" + idVeh + "/mission/vehicule";
      }
      window.open(url);
    },
    imprimeListeHisAdminAssuranceVeh: function imprimeListeHisAdminAssuranceVeh(type) {
      var idVeh = this.idVeh;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "tabParcauto/imprimerPDF/historique/" + idVeh + "/admin-assurance/vehicule";
      } else {
        url = this.domaine + "tabParcauto/imprimerEXC/historique/" + idVeh + "/admin-assurance/vehicule";
      }
      window.open(url);
    },
    imprimeListeHisAdminVidangeVeh: function imprimeListeHisAdminVidangeVeh(type) {
      var idVeh = this.idVeh;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "tabParcauto/imprimerPDF/historique/" + idVeh + "/admin-vidange/vehicule";
      } else {
        url = this.domaine + "tabParcauto/imprimerEXC/historique/" + idVeh + "/admin-vidange/vehicule";
      }
      window.open(url);
    },
    imprimeListeHisAdminVisiteVeh: function imprimeListeHisAdminVisiteVeh(type) {
      var idVeh = this.idVeh;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "tabParcauto/imprimerPDF/historique/" + idVeh + "/admin-visite/vehicule";
      } else {
        url = this.domaine + "tabParcauto/imprimerEXC/historique/" + idVeh + "/admin-visite/vehicule";
      }
      window.open(url);
    },
    imprimeListeHisAdminConsoVeh: function imprimeListeHisAdminConsoVeh(type) {
      var idVeh = this.idVeh;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "tabParcauto/imprimerPDF/historique/" + idVeh + "/admin-conso/vehicule";
      } else {
        url = this.domaine + "tabParcauto/imprimerEXC/historique/" + idVeh + "/admin-conso/vehicule";
      }
      window.open(url);
    },
    imprimeListeHisAdminInterVeh: function imprimeListeHisAdminInterVeh(type) {
      var idVeh = this.idVeh;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "tabParcauto/imprimerPDF/historique/" + idVeh + "/admin-interv/vehicule";
      } else {
        url = this.domaine + "tabParcauto/imprimerEXC/historique/" + idVeh + "/admin-interv/vehicule";
      }
      window.open(url);
    },
    imprimeListeHisAdminLocationVeh: function imprimeListeHisAdminLocationVeh(type) {
      var idVeh = this.idVeh;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "contrat/imprimerPDF/historique/" + idVeh + "/admin-location/vehicule";
      } else {
        url = this.domaine + "contrat/imprimerEXC/historique/" + idVeh + "/admin-location/vehicule";
      }
      window.open(url);
    },
    ficheConducteur: function ficheConducteur(ligne) {
      this.dialogFicheCond = true;
      this.conducteurCourant = ligne;
    },
    loadPage: function loadPage() {
      this.loading = true;
    },
    chargeSousCat: function chargeSousCat(idCat) {
      if (idCat != "" && !isNaN(idCat)) {
        //chargement des modele lie a la categorie
        this.loadSousCat(idCat);
      } else {
        this.formVehicule.marqueId = '';
        this.listSerie = [];
        this.formVehicule.serieId = '';
        this.formVehicule.modeleId = '';
      }
    },
    loadSousCat: function loadSousCat(idCat) {
      var _this2 = this;

      var url = this.domaine + 'parc/index/sous_categorie/' + idCat;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this2.listSousCategorie = response.body.sous;
        }
      });
    },
    chargeMarque: function chargeMarque(idCat) {
      if (idCat != "" && !isNaN(idCat)) {
        //chargement des modele lie a la categorie
        this.loadMarque(idCat);
      } else {
        this.formVehicule.marqueId = "";
        this.listSerie = [];
        this.formVehicule.serieId = "";
        this.formVehicule.modeleId = "";
      }
    },
    chargeModele: function chargeModele(idMarq) {
      if (idMarq != "" && !isNaN(idMarq)) {
        //chargement des modele lie a la categorie
        this.loadModele(idMarq);
      } else {
        this.listMarque.push({ id: idMarq, libelle: idMarq, text: idMarq });
      }
    },
    chargeSerie: function chargeSerie(idMod) {
      if (idMod != "" && !isNaN(idMod)) {
        //chargement des modele lie a la categorie
        this.loadSerie(idMod);
      } else {
        this.listModele.push({ id: idMod, libelle: idMod, text: idMod });
      }
    },
    selectSerie: function selectSerie(idSerie) {
      if (idSerie != "" && !isNaN(idSerie)) {} else {
        this.listSerie.push({ id: idSerie, libelle: idSerie, text: idSerie });
      }
    },
    selectTab: function selectTab(idtab) {
      var _this3 = this;

      this.loading = true;
      switch (idtab) {
        case "tab-1":
          {
            var url = this.domaine + "tabParcauto/utilisation/" + this.idVeh;
            this.$http.get(url).then(function (resp) {
              _this3.mission = resp.body.mission;
              _this3.itemsCond = resp.body.utilisations;
              if (_this3.itemsCond === undefined || _this3.itemsCond.length == 0) {
                _this3.disabledBtnMiss = true;
              } else {
                _this3.disabledBtnMiss = false;
              }
              _this3.loading = false;
            }, function (resp) {
              _this3.$message.error("erreur lors du chargement des donnees d'utilisations");
              _this3.loading = false;
            });
          }
          break;
        case "tab-2":
          {
            var _url = this.domaine + "tabParcauto/docattach/" + this.idVeh;
            this.$http.get(_url).then(function (resp) {
              _this3.itemsDoc = resp.body;
              if (_this3.itemsDoc === undefined || _this3.itemsDoc.length == 0) {
                _this3.disabledBtnDoc = true;
              } else {
                _this3.disabledBtnDoc = false;
              }
              _this3.loading = false;
            }, function (resp) {
              _this3.$message.error("erreur lors du chargement des documents attaches au vehicule");
              _this3.loading = false;
            });
          }
          break;
        case "tab-3":
          {
            var _url2 = this.domaine + "tabParcauto/docadmin/" + this.idVeh;
            this.$http.get(_url2).then(function (resp) {
              _this3.itemsDocAss = resp.body.docsassur;
              if (_this3.itemsDocAss === undefined || _this3.itemsDocAss.length == 0) {
                _this3.disabledBtnAdminAssu = true;
              } else {
                _this3.disabledBtnAdminAssu = false;
              }
              _this3.itemsDocVig = resp.body.docsvig;
              if (_this3.itemsDocVig === undefined || _this3.itemsDocVig.length == 0) {
                _this3.disabledBtnAdminVign = true;
              } else {
                _this3.disabledBtnAdminVign = false;
              }
              _this3.itemsDocVis = resp.body.docsvistech;
              if (_this3.itemsDocVis === undefined || _this3.itemsDocVis.length == 0) {
                _this3.disabledBtnAdminVisit = true;
              } else {
                _this3.disabledBtnAdminVisit = false;
              }
              _this3.mntTotAssur = resp.body.total.mntTotAssur;
              _this3.mntTotVig = resp.body.total.mntTotVig;
              _this3.mntTotVid = resp.body.total.mntTotVid;
              _this3.mntTotVistech = resp.body.total.mntTotVistech;
              _this3.loading = false;
            }, function (resp) {
              _this3.$message.error("erreur lors du chargement des documents administratifs");
              _this3.loading = false;
            });
          }
          break;
        case "tab-4":
          {
            var _url3 = this.domaine + "tabParcauto/consommation/" + this.idVeh;
            this.$http.get(_url3).then(function (resp) {
              _this3.itemsCons = resp.body.consommation;
              if (_this3.itemsCons === undefined || _this3.itemsCons.length == 0) {
                _this3.disabledBtnAdminConso = true;
              } else {
                _this3.disabledBtnAdminConso = false;
              }
              _this3.mntTotCons = resp.body.total.mntTotCons;
              _this3.quantTotCons = resp.body.total.quantTotCons;
              _this3.distParcTot = resp.body.total.distParcTot;
              _this3.loading = false;
            }, function (resp) {
              _this3.$message.error("erreur lors du chargement des consommations");
              _this3.loading = false;
            });
          }
          break;
        case "tab-5":
          {
            var _url4 = this.domaine + "tabParcauto/intervention/" + this.idVeh;
            this.$http.get(_url4).then(function (resp) {
              _this3.itemsInterv = resp.body.interventions;

              if (_this3.itemsInterv === undefined || _this3.itemsInterv.length == 0) {
                _this3.disabledBtnAdminInter = true;
              } else {
                _this3.disabledBtnAdminInter = false;
              }
              _this3.mntTotInterv = resp.body.mntInterv;
              _this3.loading = false;
            }, function (resp) {
              _this3.$message.error("Erreur lors du chargement des interventions");
              _this3.loading = false;
            });
          }
          break;
        case "tab-6":
          {
            var _url5 = this.domaine + "contrat/vehicule/" + this.idVeh;
            this.$http.get(_url5).then(function (response) {
              if (response.body) {
                _this3.mntTotContrat = response.body.mntTotContrat;
                _this3.listContrat = response.body.contrat;
                _this3.nbrContratExpireDay = response.body.nbrContratExpireDay;
                _this3.loading = false;
                var notif = _this3.$vs;
                var thise = _this3;
                _this3.listContrat.forEach(function (item) {
                  //on verifi si la date de fin du contrat est passé
                  if (thise.notif === "active" && item.expire == true) {
                    notif.notify({
                      title: "CONTRAT EXPIRE",
                      text: "Le contrat " + item.ref + " du client " + item.client + " a expiré depuis la date du " + item.dateFFormat,
                      color: "danger",
                      position: "top-right",
                      icon: "description",
                      time: 10000,
                      click: function click() {
                        thise.contratCourant = item;
                        thise.dialogShowContrat = true;
                      }
                    });
                  }
                });

                //contrat expirant aujourd'hui
                if (_this3.notif === "active" && _this3.nbrContratExpireDay != 0) {
                  _this3.$vs.notify({
                    title: "CONTRAT EXPIRANT AUJOURD'HUI",
                    text: _this3.nbrContratExpireDay + " Contrat (s) expire(ent) aujourd'hui.",
                    color: "rgb(58, 154, 201)",
                    position: "top-right",
                    icon: "check_box",
                    time: 10000
                  });
                }
              }
            });
          }
          break;
        case "tab-7":
          {
            this.loadBesoinVehValider();
          }
          break;
        case "tab-8":
          {
            this.loadVConducteur();
          }
          break;
        default:
          {}
      }
    },

    //enregistrement des images
    onFileImageLogoPicked: function onFileImageLogoPicked(event) {
      var _this4 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this4.logoVisit = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoVisit = files[0];
    },
    onFileImageVidangeLogoPicked: function onFileImageVidangeLogoPicked(event) {
      var _this5 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this5.logoVignet = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoVignet = files[0];
    },

    //enregistrement des images
    onFileImageAssurLogoPicked: function onFileImageAssurLogoPicked(event) {
      var _this6 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this6.logoAssur = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoAssur = files[0];
    },
    loadParc: function loadParc() {
      var _this7 = this;

      var url = this.domaine + "parc/index/parc";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this7.listParc = response.body.parc;
        }
      });
    },
    loadMarque: function loadMarque(idCat) {
      var _this8 = this;

      var url = this.domaine + "parc/index/marque/cat";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this8.listMarque = response.body.marque;
        }
      });
    },
    loadCategorie: function loadCategorie() {
      var _this9 = this;

      var url = this.domaine + "parc/index/categorie";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this9.listCategorie = response.body.categorie;
        }
      });
    },
    loadCarburant: function loadCarburant() {
      var _this10 = this;

      var url = this.domaine + "parc/index/carburant";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this10.typeCarburant = response.body.carburant;
        }
      });
    },
    loadModele: function loadModele(idMarq) {
      var _this11 = this;

      var url = this.domaine + "parc/index/modele/marque/" + idMarq;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this11.listModele = response.body.modele;
        }
      });
    },
    loadSerie: function loadSerie(idMod) {
      var _this12 = this;

      var url = this.domaine + "parc/index/serie/modele/" + idMod;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this12.listSerie = response.body.serie;
        }
      });
    },
    loadCompagnie: function loadCompagnie() {
      var _this13 = this;

      var url = this.domaine + "fournisseur/indexFournisseur";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this13.listCompagn = response.body.prestataire;
        }
      });
    },
    loadInfoVeh: function loadInfoVeh(idVeh) {
      var _this14 = this;

      this.loading = true;
      var url = this.domaine + "parc/vehicule/" + this.idVeh;
      this.$http.get(url).then(function (resp) {
        _this14.detailVeh = resp.body.vehicule;
        _this14.messageAlert = resp.body.alertMess;
        _this14.loading = false;
      }, function (resp) {
        _this14.$message.error("erreur lors du chargement des infos sur le vehicule.");
        _this14.loading = false;
      });
    },
    newAssu: function newAssu(ligne) {
      this.dialogAjoutAssu = true;
      this.dialogEdit = false;
      this.logoAssur = "/static/img-doc.png";
      this.formAssu = {};
      this.visiteCourant = [];
    },
    newVisit: function newVisit(ligne) {
      this.dialogAjoutVisit = true;
      this.dialogEdit = false;
      this.logoVisit = "/static/img-doc.png";
      this.formVisite = {};
      this.visiteCourant = [];
    },
    newVign: function newVign() {
      this.dialogAjoutVign = true;
      this.dialogEdit = false;
      this.formVidn = {};
      this.vidangeCourant = [];
      // this.vidangeCourant.id = ""
      this.logoVignet = "/static/img-doc.png";
    },
    editVeh: function editVeh(ligne) {
      this.loadSousCat(ligne.categorieId);
      this.loadModele(ligne.marqueId);
      this.loadSerie(ligne.modeleId);
      this.formVehicule = ligne;
      this.formVehicule.parcId = ligne.parcId;
      this.formVehicule.kilometrage = ligne.kilo;
      this.formVehicule.matricule = ligne.immat;
      this.formVehicule.numCarteGris = ligne.numCarte;
      this.formVehicule.numChassis = ligne.numChass;
      this.idVehModif = this.idVeh;
      this.imageCarteGris = ligne.urlCart;
      this.imageVeh = ligne.urlVeh;
      this.dialogAjoutVeh = true;
    },
    editAssu: function editAssu(ligne) {
      this.dialogAjoutAssu = true;
      this.dialogEdit = true;
      this.logoAssur = ligne.url;
      this.assuranceCourant = ligne;
      this.formAssu.attestation = this.assuranceCourant.numAttes;
      this.formAssu.coutUtil = this.assuranceCourant.coutUtil;
      this.formAssu.police = this.assuranceCourant.numPolice;
      this.formAssu.montant = this.assuranceCourant.mntAssurReel;
      this.formAssu.description = this.assuranceCourant.descripAssur;
      this.formAssu.dateAssu = this.assuranceCourant.dateAssur;
      this.formAssu.dateDebutAssu = this.assuranceCourant.dateDbtReel;
      this.formAssu.dateFinAssu = this.assuranceCourant.dateFnReel;
      this.formAssu.dateRenAssu = this.assuranceCourant.dateRenouvReel;
      this.formAssu.statut = this.assuranceCourant.statut;
      this.selectCompagnLib = this.assuranceCourant.societeId;
      this.imageCarteGris = ligne.urlCarteGrise;
      this.imageVeh = ligne.photoVeh;
    },
    editVign: function editVign(ligne) {
      this.dialogAjoutVign = true;
      this.dialogEdit = true;
      this.logoVignet = ligne.url;
      this.vidangeCourant = ligne;
      this.formVidn = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, ligne);
      this.formVidn.montant = this.vidangeCourant.montant;
      this.formVidn.statut = this.vidangeCourant.statut;
    },
    editVisit: function editVisit(ligne) {
      this.dialogAjoutVisit = true;
      this.dialogEdit = true;
      this.logoVisit = ligne.url;
      this.visiteCourant = ligne;
      this.formVisite = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, ligne);
      this.formVisite.montant = this.visiteCourant.montant;
      this.formVisite.statut = this.visiteCourant.statut;
    },
    deleteAssu: function deleteAssu() {
      var _this15 = this;

      var url = this.domaine + "parc/delete/assurance/" + this.idAssu;
      this.$http.get(url).then(function (response) {
        if (response.body.rep == 1) {
          _this15.$notify({
            title: "SUPPRESSION",
            message: "Assurance supprimée avec succès.",
            type: "success",
            position: "top-center",
            duration: 5000

          });
          _this15.dialogSuprAssu = false;
          _this15.selectTab('tab-3');
        } else if (response.body.rep == 0) {
          _this15.$notify({
            title: "SUPPRESSION",
            message: "Suppression impossible.",
            type: "error",
            position: "top-center",
            duration: 5000
          });
          _this15.dialogSuprAssu = false;
        }
      });
    },
    deleteVisit: function deleteVisit() {
      var _this16 = this;

      var url = this.domaine + "visite/delete/" + this.idVisit;
      this.$http.get(url).then(function (response) {
        if (response.body.rep == 1) {
          _this16.$notify({
            title: "SUPPRESSION",
            message: "Visite technique supprimé avec succès.",
            type: "success",
            position: "top-center",
            duration: 5000
          });
          _this16.dialogSuprVisit = false;
          _this16.selectTab('tab-3');
        } else if (response.body.rep == 0) {
          _this16.$notify({
            title: "SUPPRESSION",
            message: "Suppression impossible.",
            type: "error",
            position: "top-center",
            duration: 5000
          });
          _this16.dialogSuprVisit = false;
        }
      });
    },
    deleteVign: function deleteVign() {
      var _this17 = this;

      var url = this.domaine + "vidange/delete/" + this.idVign;
      this.$http.get(url).then(function (response) {
        if (response.body.rep == 1) {
          _this17.$notify({
            title: "SUPPRESSION",
            message: "Vidange supprimée avec succès.",
            type: "success",
            position: "top-center",
            duration: 5000
          });
          _this17.dialogSuprVign = false;
          _this17.selectTab('tab-3');
        } else if (response.body.rep == 0) {
          _this17.$notify({
            title: "SUPPRESSION",
            message: "Suppression impossible.",
            type: "error",
            position: "top-center",
            duration: 5000
          });
          _this17.dialogSuprVign = false;
        }
      });
    },
    deleteConducteur: function deleteConducteur() {
      var _this18 = this;

      this.loading = true;
      var url = this.domaine + "conducteur/delete/vehicule/" + this.idConducteur + '/' + this.idVeh;
      this.$http.get(url).then(function (response) {
        if (response.body.code === 1) {
          _this18.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: "Véhicule retiré avec succès.",
            type: "success",
            position: "top-center",
            duration: 5000
          });
          _this18.loadVConducteur();
          _this18.dialogSuprCond = false;
          _this18.loading = false;
        }
      }, function (error) {
        _this18.$message.error("Impossible de retirer ce vehicule à ce conducteur.");
        _this18.loading = false;
      });
    },
    submitAssu: function submitAssu() {
      var _this19 = this;

      if (this.$refs.formAssu.validate()) {
        if (this.formAssu.attestation != "" && this.formAssu.police != "" && this.formAssu.montant > 0 && this.formAssu.dateAssu != "" && this.selectCompagnLib != "" && this.formAssu.dateDebutAssu && this.formAssu.dateFinAssu && (this.formAssu.statut == 1 || this.formAssu.statut == 0)) {
          var form = document.getElementById("formAssu");
          var data = new FormData(form);
          data.append("idVeh", this.idVeh);
          data.append("idCompagn", this.selectCompagnLib);
          data.append("statut", this.formAssu.statut);
          if (this.assuranceCourant.id) {
            data.append("id", this.assuranceCourant.id);
          } else {
            data.append("id", "");
          }
          this.loading = true;
          var url = this.domaine + "parc/new/assurance";
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1 || verif.code === 4) {
                _this19.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Asssurance enregistrée avec succès.",
                  type: "success",
                  position: "top-center",
                  duration: 5000
                });

                _this19.selectTab('tab-3');
                _this19.loadInfoVeh(_this19.idVeh);
                _this19.dialogAjoutAssu = false;
                _this19.loading = false;
                _this19.$refs.formAssu.reset();
              } else if (verif.code === 0) {
                _this19.$message.error(verif.message);
                _this19.loading = false;
              } else if (verif.code === 2) {
                _this19.$message.error(verif.message);
                _this19.loading = false;
              } else if (verif.code === 3) {
                _this19.$message.error(verif.message);
                _this19.loading = false;
              }
            } else {
              _this19.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur 1");
              _this19.loading = false;
            }
          }, function (response) {
            _this19.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur 2");
            _this19.loading = false;
          });
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Assurance n'a pas été enregistré.",
          position: "top-center",
          duration: 5000
        });
        this.loading = false;
      }
    },
    submitVisit: function submitVisit() {
      var _this20 = this;

      if (this.$refs.formVisite.validate()) {
        if (this.formVisite.numero != "" && this.formVisite.dateDebut != "" && this.formVisite.dateFin != "" && this.formVisite.montant > 0 && (this.formVisite.statut == 0 || this.formVisite.statut == 1)) {
          var form = document.getElementById("formVisite");
          var data = new FormData(form);
          data.append("idVeh", this.idVeh);
          data.append("statut", this.formVisite.statut);
          var url = this.domaine + "visite/new";
          if (this.visiteCourant.id) {
            data.append("id", this.visiteCourant.id);
          } else {
            data.append("id", "");
          }
          this.loading = true;
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this20.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Visite technique enregistrée avec succès.",
                  type: "success",
                  position: "top-center",
                  duration: 5000
                });

                _this20.selectTab('tab-3');
                _this20.loadInfoVeh(_this20.idVeh);
                _this20.dialogAjoutVisit = false;
                _this20.loading = false;
                _this20.$refs.formVisite.reset();
              } else if (verif.code === 0) {
                _this20.$message.error(verif.message);
                _this20.loading = false;
              } else if (verif.code === 4) {
                _this20.$message.error(verif.message);
                _this20.loading = false;
              } else if (verif.code === 2) {
                _this20.$message.error(verif.message);
                _this20.loading = false;
              } else if (verif.code === 3) {
                _this20.$message.error(verif.message);
                _this20.loading = false;
              }
            } else {
              _this20.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this20.loading = false;
            }
          }, function (response) {
            _this20.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this20.loading = false;
          });
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Vignette n'a pas été enregistrée.",
          position: "top-center",
          duration: 5000
        });
        this.loading = false;
      }
    },
    submitAttribution: function submitAttribution() {
      var _this21 = this;

      this.loading = true;
      var form = document.getElementById("formAttribueCondu");
      var data = new FormData(form);
      var url = this.domaine + "parc/attrib/vehicule/new";
      data.append("conducteur", this.formAttribueCondu.conducteur);
      data.append("vehicule", this.idVeh);
      this.$http.post(url, data).then(function (response) {
        _this21.loading = false;
        var verif = response.body;
        if (verif.code === 1) {
          _this21.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: "Conducteur affécté à ce vehicule.",
            type: "success",
            position: "top-center",
            duration: 5000
          });
          _this21.loadVConducteur();
          _this21.dialogAjoutVehiConducteur = false;
          _this21.loading = false;
        }
      }, function (error) {
        _this21.$message.error("Ce véhicule déja été affecter à ce conducteur");
        _this21.loading = false;
      });
    },
    loadVConducteur: function loadVConducteur() {
      var _this22 = this;

      this.loading = true;
      var url = this.domaine + "parc/conducteur-affecter/" + this.idVeh;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this22.listConducteur = response.body.listConducteur;
          _this22.loading = false;
        }
      }, function (error) {
        _this22.$message.error("Impossible d'avoir la liste des conducteurs");
        _this22.loading = false;
      });
    },
    deleteVehiCondu: function deleteVehiCondu(row) {
      var _this23 = this;

      this.loading = true;
      var url = this.domaine + "conducteur/delete/vehicule/" + this.conducteurCourant.idCond + '/' + row.idVeh;
      this.$http.get(url).then(function (response) {
        if (response.body.code === 1) {
          _this23.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: "Véhicule retiré avec succès.",
            type: "success",
            position: "top-center"
          });
          _this23.loadVConducteur();
          _this23.loading = false;
        }
      }, function (error) {
        _this23.$message.error("Impossible de retirer ce vehicule à ce conducteur.");
        _this23.loading = false;
      });
    },
    submitVign: function submitVign() {
      var _this24 = this;

      this.loading = true;
      // if (this.$refs.formVidn.validate()) {
      if (this.formVidn.numero != "" && this.selectVehicule != "" && this.formVidn.kiloActu != "" && this.formVidn.kiloProch != "" && this.formVidn.dateDebt != "" && this.formVidn.montant > 0 && this.formVidn.statut == 0 || this.formVidn.statut == 1) {
        var form = document.getElementById("formVidn");
        var data = new FormData(form);

        data.append("idVeh", this.idVeh);
        data.append("statut", this.formVidn.statut);
        var url = this.domaine + "vidange/new";
        if (this.vidangeCourant.id) {
          data.append("id", this.vidangeCourant.id);
        } else {
          data.append("id", "");
        }

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this24.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "vidange enregistrée avec succès.",
                type: "success",
                position: "top-center"
              });

              _this24.loadInfoVeh(_this24.idVeh);
              _this24.selectTab('tab-3');
              _this24.dialogAjoutVign = false;
              _this24.loading = false;
              _this24.$refs.formVidn.reset();
              _this24.selectVehicule = "";
            } else if (verif.code === 0) {
              _this24.$message.error(verif.message);
              _this24.loading = false;
            } else if (verif.code === 3) {
              _this24.$message.error(verif.message);
              _this24.loading = false;
            }
          } else {
            _this24.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this24.loading = false;
          }
        }, function (response) {
          _this24.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this24.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "vidange n'a pas été enregistrée.",
          position: "top-center",
          duration: 5000
        });
        this.loading = false;
      }
      // } else {
      //   this.$message.error('Veuillez renseigner les champs obligatoires')
      //   this.$notify.error({
      //     title: "ERREUR D'ENREGISTREMENT",
      //     message: "vidange n'a pas été enregistrée.",
      //     position: 'top-center'
      //   })
      //   this.loading = false
      // }
    },
    createVeh: function createVeh() {
      var _this25 = this;

      var idVehModif = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      this.loading = true;
      if (this.formVehicule.marqueId == null || this.formVehicule.modeleId == null || this.formVehicule.serieId == null || this.formVehicule.categorieId == null) {
        this.loading = false;
        this.$message.error("Veuillez renseigner correctement les champs categorie, marque, modele et serie");
        return;
      }

      if (this.$refs.formVehicule.validate()) {
        var form = document.getElementById("formVehicule");
        var data = new FormData(form);
        var url = "";

        if (idVehModif !== "" && idVehModif !== undefined) {
          url = this.domaine + "parc/edit/vehicule/" + idVehModif;
        } else {
          url = this.domaine + "parc/new/vehicule"; //WebServiceBundle:ParcAutoController:newVehicule
        }

        data.append("idUser", this.user.id);
        data.append("type", this.formVehicule.categorieId);
        data.append("typeCarbu", this.formVehicule.typeCarbuId);
        data.append("marque", this.formVehicule.marqueId);
        data.append("modele", this.formVehicule.modeleId);
        data.append("serie", this.formVehicule.serieId);
        data.append("parc", this.formVehicule.parcId);
        data.append("dateAqui", this.formVehicule.dateAqui);
        data.append("annVeh", this.formVehicule.annVeh);
        data.append("sousCategorie", this.formVehicule.sousCategorieId);
        data.append('codeParc', this.formVehicule.codeParc);
        data.append('ratio', this.formVehicule.ratio);

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            _this25.loading = false;
            _this25.e1 = 1;
            var verif = response.body;
            if (verif.code === 1) {
              _this25.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Véhicule enregistré avec succès.",
                type: "success",
                position: "top-right",
                duration: 5000
              });
              _this25.dialogAjoutVeh = false;
              _this25.$refs.formVehicule.reset();
              _this25.loadInfoVeh(_this25.idVeh);
            } else if (verif.code === 0) {
              _this25.$message.error(verif.message);
              _this25.loading = false;
            } else if (verif.code === 5) {
              _this25.loading = false;
              _this25.$message.error(verif.message);
            }
          } else {
            _this25.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this25.loading = false;
          }
        }, function (response) {
          _this25.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this25.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le véhicule n'a pas été enregistré.",
          position: "top-right"
        });
        this.loading = false;
        this.e1 = 1;
      }
    },
    imprimeFic: function imprimeFic(urlFic) {
      window.open(urlFic);
    },
    impmerFacture: function impmerFacture(ligne) {
      this.contratCourant = ligne;
      var url = this.domaine + "contrat/" + this.contratCourant.id + "/imprimer/facture";
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    onFileCartePicked: function onFileCartePicked(event) {
      var _this26 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this26.imageCarteGris = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.fileCarteGris = files[0];
    },
    onFileVehPicked: function onFileVehPicked(event) {
      var _this27 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this27.imageVeh = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.fileVeh = files[0];
    },
    loadListConducteur: function loadListConducteur() {
      var _this28 = this;

      this.loading = true;
      var url = this.domaine + "conducteur/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this28.AllConducteur = response.body.conducteur;
        }
      });
    },
    loadNotif: function loadNotif(idVeh) {
      var _this29 = this;

      var url = this.domaine + "tabParcauto/notif/" + idVeh;
      this.$http.get(url).then(function (response) {
        _this29.loading = false;
        if (response.body) {
          _this29.nbAssurAbs = response.body.nbAssurAbs;
          _this29.nbAssurAexp = response.body.nbAssurAexp;

          _this29.nbVisiteTechAbs = response.body.nbVisiteTechAbs;
          _this29.nbVisiteTechExp = response.body.nbVisiteTechExp;

          _this29.nbVignetteAbs = response.body.nbVignetteAbs;
          _this29.nbVignetteExp = response.body.nbVignetteExp;

          if (_this29.notif === "active" && _this29.nbAssurAbs != 0) {
            _this29.$vs.notify({
              title: "ASSURANCE NON-VALIDE",
              text: "Ce vehicule ne possede ou n'a pas une assurance valide",
              color: "warning",
              position: "top-right",
              icon: "description",
              time: 10000
            });
          }

          if (_this29.notif === "active" && _this29.nbAssurAexp != 0) {
            _this29.$vs.notify({
              title: "EXPIRATION ASSURANCE",
              text: " l'assurance(s) va expirer dans moins de 3 mois",
              color: "warning",
              position: "top-right",
              icon: "description",
              time: 10000
            });
          }

          if (_this29.notif === "active" && _this29.nbVisiteTechAbs != 0) {
            _this29.$vs.notify({
              title: "VISITE TECHNIQUE NON-VALIDE",
              text: " Ce vehicule ne possede  ou n'a pas une visite technique valide",
              color: "warning",
              position: "top-right",
              icon: "description",
              time: 25000
            });
          }

          if (_this29.notif === "active" && _this29.nbVisiteTechExp != 0) {
            _this29.$vs.notify({
              title: "EXPIRATION VISITE TECHNIQUE",
              text: "La visite(s) technique va expirer dans moins de  3 mois",
              color: "warning",
              position: "top-right",
              icon: "description",
              time: 35000
            });
          }

          if (_this29.notif === "active" && _this29.nbVignetteAbs != 0) {
            _this29.$vs.notify({
              title: "VIGNETTE NON-VALIDE",
              text: "Ce vehicule ne possede ou n'a pas une vignette valide",
              color: "warning",
              position: "top-right",
              icon: "description",
              time: 45000
            });
          }

          if (_this29.notif === "active" && _this29.nbVignetteExp != 0) {
            _this29.$vs.notify({
              title: " EXPIRATION VIGNETTE",
              text: "La vignettes va expirer dans moins de 3 mois",
              color: "warning",
              position: "top-right",
              icon: "description",
              time: 60000
            });
          }
        }
      }, function (response) {
        _this29.loading = false;
        _this29.$message.error("Erreur lors du chargement des notifications");
      });
    }
  },
  mounted: function mounted() {
    this.loadPage();
    this.loadListConducteur();
    this.loadInfoVeh(this.idVeh);
    this.loadCompagnie();
    this.loadCategorie();
    this.loadCarburant();
    this.loadParc();
    this.loadNotif(this.idVeh);
    this.loadBesoinVehValider();
  }
});

/***/ }),

/***/ "o8fG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs4":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"cyan darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.totalReserve))]),_vm._v(" "),_c('div',[_vm._v("Total réserve(s)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("Taux reprise (%)")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.tauxReprise))])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-2 mr-1",attrs:{"xs4":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"orange darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.reserveValid))]),_vm._v(" "),_c('div',[_vm._v("Réserve(s) validée(s)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_vm._v("Réserves (en cours)")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.reserveEnCours))])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-2",attrs:{"xs4":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"red darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.tacheTermine))]),_vm._v(" "),_c('div',[_vm._v("Travaux réserve terminés")])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.nbTrx))]),_vm._v(" "),_c('div',[_vm._v("Total travaux")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_vm._v("Travaux à refaire")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.tacheRefaire))])])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"height":"100%"},attrs:{"xs12":""}},[_c('v-layout',{staticStyle:{"height":"100%"},attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center pr-2 ml-2",staticStyle:{"height":"100%"},attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-5 pl-2 pt-2",staticStyle:{"height":"100%"}},[_c('h4',[_vm._v("\n              Rapport non effectués\n              "),_c('v-chip',{attrs:{"outline":"","color":"red"}},[_vm._v(_vm._s(_vm.listeRptNon.length))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-1"}),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeRptNon}},[_c('el-table-column',{attrs:{"prop":"value","label":"Date","fixed":"left","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"indigo"}},[_vm._v("\n                  "+_vm._s(scope.row.dateRpt)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"travaux","label":"Section","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                  "+_vm._s(scope.row.travaux)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"tooltip-btn",attrs:{"slot":"activator","title":"Ajouter un rapport journalier ","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.rapportJour(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("note_add")])],1),_vm._v("Effectuer rapport journalier\n                  ")],1)],1)]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('RapportJournalier',{attrs:{"dateRpt":_vm.dateRapport,"detailTrx":_vm.detailTravaux,"show":_vm.showRapport},on:{"close":function($event){_vm.showRapport = false},"reloadListeTrx":function($event){_vm.loadStatRapport();
      _vm.$emit('reloadListeTravaux');}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oCtX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RapportSatisfaction_vue__ = __webpack_require__("6y32");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12f5d2b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RapportSatisfaction_vue__ = __webpack_require__("/XTI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RapportSatisfaction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12f5d2b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RapportSatisfaction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "opP9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticStyle:{"width":"450px","height":"300px"},attrs:{"id":"chartsSortieAll"}})]),_vm._v(" "),_c('v-flex',{attrs:{"md8":""}},[_c('div',{staticStyle:{"width":"900px","height":"300px"},attrs:{"id":"chartsApproAll"}})])],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n          Approvisionnement : "+_vm._s(_vm.nbrAppro)+"\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add_shopping_cart")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n          Demande de carburant : "+_vm._s(_vm.nbrCarburant)+"\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("list")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n          Sortie : "+_vm._s(_vm.nbrSortie)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n          Retour : "+_vm._s(_vm.nbrRetour)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("replay")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"blue lighten-2"}},[_vm._v("\n          Transfert : "+_vm._s(_vm.nbrTrans)+"\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("transfer_within_a_station")])],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newEntrepot()}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n      Ajouter un nouvel entrepot\n    ")],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","color":"primary","small":"","dark":""},on:{"click":function($event){_vm.dialogAide = true}}},[_c('v-icon',[_vm._v("help_outline")])],1),_vm._v(" "),_c('v-bottom-sheet',{model:{value:(_vm.dialogAide),callback:function ($$v) {_vm.dialogAide=$$v},expression:"dialogAide"}},[_c('v-list',[_c('v-subheader',[_vm._v("CLASSE A")]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-title',[_vm._v("Un entrepôt de classe A correspond à un entrepôt de haute\n            fonctionnalité.")])],1)],1),_vm._v(" "),_c('v-list',[_c('v-subheader',[_vm._v("CLASSE B")]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-title',[_vm._v("Un entrepôt de classe B, est un entrepôt qui répond juste aux\n            normes standard.")])],1)],1),_vm._v(" "),_c('v-list',[_c('v-subheader',[_vm._v("CLASSE C")]),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-title',[_vm._v("Les entrepôts de classe C : ne répondant à aucun des critères des\n            classes A et B.")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShow),callback:function ($$v) {_vm.dialogShow=$$v},expression:"dialogShow"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails sur l'entrepot "+_vm._s(_vm.entrepotCourant.ref)+" /\n          "+_vm._s(_vm.entrepotCourant.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShow = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[(_vm.detailEntre.typeHydro)?_c('v-flex',{staticClass:"mr-1",attrs:{"sm6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-layout',{staticClass:"elevation-3 pt-2 pl-2 pr-2 pb-2 grey lighten-4",attrs:{"row":""}},[_c('v-flex',{attrs:{"sm8":""}},[_c('div',{staticStyle:{"width":"90%","height":"90%"},attrs:{"id":"chartCiterneCarburant"}})]),_vm._v(" "),_c('v-flex',{attrs:{"sm4":""}},[_c('v-layout',{staticClass:"pt-2 pl-2 pr-2 pb-2",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"teal lighten-1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_vm._v("Quantités sorties")]),_vm._v(" "),_c('div',{staticClass:"display-2"},[_vm._v("\n                                    "+_vm._s(new Intl.NumberFormat().format(
                                        _vm.nbQteUtilise
                                      ))+"\n                                    L\n                                  ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"sm12":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"deep-orange lighten-1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_vm._v("Quantités Disponibles")]),_vm._v(" "),_c('div',{staticClass:"display-2"},[_vm._v("\n                                    "+_vm._s(new Intl.NumberFormat().format(
                                        _vm.nbQteDisponible
                                      ))+"\n                                    L\n                                  ")])])],1)],1)],1)],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.detailEntre.typeHydro == false)?_c('v-flex',{attrs:{"sm6":""}},[_c('div',{staticStyle:{"width":"450px","height":"300px"},attrs:{"id":"chartsSortieEntre"}})]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"sm6":""}},[_c('div',{staticStyle:{"width":"900px","height":"300px"},attrs:{"id":"chartsApproEntre"}})])],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  Approvisionnement : "+_vm._s(_vm.nbrApproEntre)+"\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add_shopping_cart")])],1)],1),_vm._v(" "),(_vm.detailEntre.typeHydro)?_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                  Demande de carburant : "+_vm._s(_vm.nbrCarburantEntre)+"\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("list")])],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                  Sortie : "+_vm._s(_vm.nbrSortieEntre)+"\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                  Retour : "+_vm._s(_vm.nbrRetourEntre)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("replay")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"text-color":"white","label":"","color":"blue lighten-2"}},[_vm._v("\n                  Transfert : "+_vm._s(_vm.nbrTransEntre)+"\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("transfer_within_a_station")])],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":_vm.showClick}},[_c('el-tab-pane',{attrs:{"name":"fiche"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("ic_person")]),_vm._v(" Fiche")],1),_vm._v(" "),_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Réference : ")]),_vm._v(" "+_vm._s(_vm.detailEntre.ref))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Désignation : ")]),_vm._v(" "+_vm._s(_vm.detailEntre.libelle)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Ville : ")]),_vm._v(" "+_vm._s(_vm.detailEntre.ville))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Projet : ")]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                              "+_vm._s(_vm.entrepotCourant.projet)+" \n                            ")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Commune : ")]),_vm._v(" "+_vm._s(_vm.detailEntre.commune))]),_vm._v(" "),(_vm.detailEntre.typeHydro)?_c('p',[_c('b',[_vm._v("Capacité : ")]),_vm._v(" "),_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("\n                              "+_vm._s(_vm.entrepotCourant.citerne)+" L\n                            ")])],1):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Type d'entrepot : ")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                              "+_vm._s(_vm.detailEntre.typeLibelle)+"\n                            ")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Chef de l'entrepot : ")]),_vm._v("\n                            "+_vm._s(_vm.detailEntre.chefEntre)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Chef de validation : ")]),_vm._v("\n                            "+_vm._s(_vm.detailEntre.chefVali)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v("\n                            "+_vm._s(_vm.detailEntre.created)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v("\n                            "+_vm._s(_vm.detailEntre.modified)+"\n                          ")])])],1)],1)])]),_vm._v(" "),_c('el-tab-pane',{attrs:{"name":"stock"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")]),_vm._v(" Stock")],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"text-xs-right"},[_c('v-layout',{attrs:{"row":""}},[(
                            _vm.droitAcces.imprime_pdf_histo_stock_liste_entrepot ||
                              _vm.droitAcces.imprime_exc_histo_stock_liste_entrepot
                          )?_c('v-flex',[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisEntrepotStock('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisEntrepotStock('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnS,"icon":"el-icon-printer"}},[_vm._v("Rapport\n                            ")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listStock,"default-sort":{ prop: 'produit', order: 'descending' },"stripe":"","border":"","height":"350"},on:{"selection-change":_vm.stockMultiSortie}},[_c('el-table-column',{attrs:{"selectable":_vm.stockSelect,"width":"55","type":"selection"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref","label":"id","width":"110","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                          "+_vm._s(scope.row.ref)+"\n                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"produit","label":"Produit (Code article/catégorie)","width":"280","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                            "+_vm._s(scope.row.codeGestion)+"\n                          ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.produit)+"\n                          ")]),_vm._v(" "),(scope.row.type != '')?_c('v-chip',{attrs:{"text-color":"black","label":"","color":"succes"}},[_vm._v("\n                            ("+_vm._s(scope.row.type)+" - "+_vm._s(scope.row.reference)+")\n                          ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref","label":"Dernière opération","width":"220","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.operationStock === 'ENLEVEMENT')?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                            "+_vm._s(scope.row.operationStock)+" LE\n                            "+_vm._s(scope.row.dateStock)+"\n                          ")]):_vm._e(),_vm._v(" "),(
                              scope.row.operationStock === 'APPROVISIONNEMENT'
                            )?_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.operationStock)+" LE\n                            "+_vm._s(scope.row.dateStock)+"\n                          ")]):_vm._e(),_vm._v(" "),(scope.row.operationStock === 'RETOUR')?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                            "+_vm._s(scope.row.operationStock)+" LE\n                            "+_vm._s(scope.row.dateStock)+"\n                          ")]):_vm._e(),_vm._v(" "),(
                              scope.row.operationStock ===
                                'NOUVEAU PRODUIT AJOUTER'
                            )?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.operationStock)+"\n                          ")]):_vm._e(),_vm._v(" "),(
                              scope.row.operationStock === 'AUCUNE OPERATION'
                            )?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.operationStock)+"\n                          ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"address","label":"Mouvement","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.typeStock === 'SORTIE')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                            "+_vm._s(scope.row.typeStock)+"\n                          ")]):_vm._e(),_vm._v(" "),(scope.row.typeStock === 'ENTREE')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                            "+_vm._s(scope.row.typeStock)+"\n                          ")]):_vm._e(),_vm._v(" "),(scope.row.typeStock === 'AUCUN')?_c('v-chip',{attrs:{"outline":"","text-color":"secondary","label":"","color":"secondary"}},[_vm._v("\n                            "+_vm._s(scope.row.typeStock)+"\n                          ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité actuelle","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.qte != 0)?_c('v-chip',{attrs:{"text-color":"white","color":"secondary"}},[_vm._v("\n                            "+_vm._s(scope.row.qte)+"\n                          ")]):_vm._e(),_vm._v(" "),(scope.row.qte == 0)?_c('v-chip',{attrs:{"text-color":"white","color":"red"}},[_vm._v("\n                            VIDE\n                          ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité","width":"280"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.unite)+"\n                          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix unitaire","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                            "+_vm._s(scope.row.prix)+" FCFA\n                          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"valeur","label":"Valeur du stock","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                            "+_vm._s(scope.row.valeur)+" FCFA\n                          ")])]}}])})],1)],1)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"name":"appro"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("add_shopping_cart")]),_vm._v("\n                    Approvsionnement")],1),_vm._v(" "),_c('div',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      LISTE DES APPROVISIONNEMENT\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add_shopping_cart")])],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":""}},[(
                            _vm.droitAcces.imprime_pdf_histo_stock_liste_approvi ||
                              _vm.droitAcces.imprime_exc_histo_stock_liste_approv
                          )?_c('v-flex',[_c('el-popover',{ref:"popProjet",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[(
                                  _vm.droitAcces.imprime_pdf_histo_stock_liste_approvi
                                )?_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisEntrepotAppro('PDF')}}},[_vm._v("PDF")]):_vm._e(),_vm._v(" "),(
                                  _vm.droitAcces.imprime_exc_histo_stock_liste_approv
                                )?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisEntrepotAppro('EXC')}}},[_vm._v("EXCEL")]):_vm._e()],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popProjet",arg:"popProjet"}],attrs:{"type":"warning","disabled":_vm.disabledBtnA,"icon":"el-icon-printer"}},[_vm._v("Rapport\n                            ")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card-text',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listAppro}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Réference","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.ref)+"\n                            ")])]}}])}),_vm._v(" "),(_vm.detailEntre.libelle != 'HYDORLIQUE')?_c('el-table-column',{attrs:{"prop":"codeGestion","label":"Code analytique","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"indigo"}},[_vm._v("\n                              "+_vm._s(scope.row.codeGestion)+"\n                            ")])]}}],null,false,2062005340)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"produit","label":"Produit","width":"370"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.produit)+" ("+_vm._s(scope.row.type)+" -\n                              "+_vm._s(scope.row.refProd)+")\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"color":"green","text-color":"white"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.qte)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"color":"orange","text-color":"white"}},[_vm._v(_vm._s(scope.row.unite))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date appro"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("\n                              "+_vm._s(scope.row.date)+"\n                              "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("date_range")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"valide","label":"Validation appro"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.valide == false)?_c('v-chip',{attrs:{"text-color":"white","color":"green"}},[_vm._v("\n                              Valide\n                            ")]):_vm._e(),_vm._v(" "),(scope.row.valide == true)?_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("\n                              Validation en attente\n                            ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showAppro(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                Détails\n                              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(
                                    scope.row.valide == true &&
                                      _vm.droitAcces.valid_liv_appro
                                  )?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.validLivrAppro(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("done_all")])],1):_vm._e(),_vm._v("\n                                Valider definitivement l'approvisionnement\n                              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerAppro(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                                Imprimer\n                              ")],1)],1)]}}])})],1)],1)],1)]),_vm._v(" "),(_vm.detailEntre.typeHydro)?_c('el-tab-pane',{attrs:{"name":"carburant"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("list")]),_vm._v(" Demande de carburant")],1),_vm._v(" "),_c('div',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      LISTE DES DEMANDES DE CARBURANT\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("list")])],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('el-popover',{ref:"popProjet",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[(
                                  _vm.droitAcces.imprime_pdf_histo_stock_liste_approvi
                                )?_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisEntrepotAppro('PDF')}}},[_vm._v("PDF")]):_vm._e(),_vm._v(" "),(
                                  _vm.droitAcces.imprime_exc_histo_stock_liste_approv
                                )?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisEntrepotAppro('EXC')}}},[_vm._v("EXCEL")]):_vm._e()],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popProjet",arg:"popProjet"}],attrs:{"type":"warning","disabled":_vm.disabledBtnA,"icon":"el-icon-printer"}},[_vm._v("Rapport\n                            ")])],1)],1)],1)],1),_vm._v(" "),_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listCarburant,"default-sort":{ prop: 'produit', order: 'descending' },"stripe":"","border":"","height":"350"},on:{"selection-change":_vm.stockMultiSortie}},[_c('el-table-column',{attrs:{"selectable":_vm.stockDemande,"width":"50","type":"selection"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projet","label":"Projet / Tache","width":"400"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                          "+_vm._s(scope.row.libelleTrx)+"\n                        ")]}}],null,false,2234242404)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demnandeur","label":"Demandeur","width":"170"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.demnandeur)+"\n                          ")])]}}],null,false,2622231652)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"produit","label":"Produit","width":"380","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.produit)+"- "+_vm._s(scope.row.refProd)+")\n                          ")])]}}],null,false,3250614911)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"color":"green","text-color":"white"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.qte)))])]}}],null,false,48327925)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unitée","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"color":"primary","text-color":"white"}},[_vm._v("LITRE")])]}}],null,false,862785737)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date de livraison","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("\n                            "+_vm._s(scope.row.date)+"\n                            "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("date_range")])],1)]}}],null,false,666421680)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Etat","fixed":"right","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 0)?_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("\n                            "+_vm._s(scope.row.etatLibelle)+"\n                          ")]):_vm._e(),_vm._v(" "),(scope.row.etat != 0)?_c('v-chip',{attrs:{"text-color":"white","color":"green"}},[_vm._v("\n                            "+_vm._s(scope.row.etatLibelle)+"\n                          ")]):_vm._e()]}}],null,false,2039077831)})],1)],1)]):_vm._e(),_vm._v(" "),_c('el-tab-pane',{attrs:{"name":"sortie"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")]),_vm._v(" Enlèvement")],1),_vm._v(" "),_c('div',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      LISTE DES ENLEVEMENTS "),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('el-popover',{ref:"popProjet",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[(
                                  _vm.droitAcces.imprime_pdf_histo_enlevmt_liste_entrpot
                                )?_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisEntrepotEnlevmt('PDF')}}},[_vm._v("PDF")]):_vm._e(),_vm._v(" "),(
                                  _vm.droitAcces.imprime_exc_histo_enlvmt_liste_entrept
                                )?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisEntrepotEnlevmt('EXC')}}},[_vm._v("EXCEL")]):_vm._e()],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popProjet",arg:"popProjet"}],attrs:{"type":"warning","disabled":_vm.disabledBtnE,"icon":"el-icon-printer"}},[_vm._v("Rapport\n                            ")])],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listSortie}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Réference","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.ref)+"\n                            ")]),_vm._v(" "),(scope.row.refDmd != '')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                              "+_vm._s(scope.row.refDmd)+"\n                            ")]):_vm._e(),_vm._v(" "),(scope.row.refTravaux != '')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                              "+_vm._s(scope.row.refTravaux)+"\n                            ")]):_vm._e(),_vm._v(" "),(scope.row.refInterv != '')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                              "+_vm._s(scope.row.refInterv)+"\n                            ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"produit","label":"Produit","width":"270"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.produit)+" ("+_vm._s(scope.row.type)+" -\n                              "+_vm._s(scope.row.refProd)+")\n                              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("location_on")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"color":"green","text-color":"white"}},[_vm._v(_vm._s(scope.row.qte))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"color":"orange","text-color":"white"}},[_vm._v(_vm._s(scope.row.unite))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateS","label":"Date de sortie"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("\n                              "+_vm._s(scope.row.dateS)+"\n                            ")])]}}])}),_vm._v(" "),(_vm.detailEntre.libelle != 'HYDORLIQUE')?_c('el-table-column',{attrs:{"prop":"lastRetour","label":"Date de retour"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.lastRetour !== null && scope.row.lastRetour !== '' )?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.lastRetour)+"\n                              "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("date_range")])],1):_vm._e(),_vm._v(" "),(scope.row.lastRetour === null || scope.row.lastRetour === '')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                              Aucun retour n'est prévu\n                            ")]):_vm._e()]}}],null,false,2276514525)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showSortie(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                Détails\n                              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(
                                    scope.row.etatValide == false &&
                                      _vm.droitAcces.show_sortie &&
                                      _vm.droitAcces.index_sortie_chefEntrepot &&
                                      _vm.droitAcces.index_stock_chefValidation
                                  )?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.openDialogBon(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("done_all")])],1):_vm._e(),_vm._v("\n                                Valider la sortie du produit\n                              ")],1),_vm._v(" "),(_vm.detailEntre.libelle != 'HYDORLIQUE')?_c('v-tooltip',{attrs:{"top":""}},[(scope.row.retour)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.newEntree(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("replay")])],1):_vm._e(),_vm._v("\n                                Faire un retour\n                              ")],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(
                                    _vm.droitAcces.imprime_sortie &&
                                      scope.row.idDmd == ''
                                  )?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerSortie(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1):_vm._e(),_vm._v("\n                                Imprimer\n                              ")],1)],1)]}}])})],1)],1)],1)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"name":"retour"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("replay")]),_vm._v(" Retour")],1),_vm._v(" "),_c('div',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      LISTE DES RETOURS "),_c('v-icon',{attrs:{"right":""}},[_vm._v("replay")])],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":""}},[(
                            _vm.droitAcces.imprime_pdf_histo_retour_liste_entrepot ||
                              _vm.droitAcces.imprime_exc_histo_retour_liste_entrept
                          )?_c('v-flex',[_c('el-popover',{ref:"popProjet",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[(
                                  _vm.droitAcces.imprime_pdf_histo_retour_liste_entrepot
                                )?_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisEntrepotRetour('PDF')}}},[_vm._v("PDF")]):_vm._e(),_vm._v(" "),(
                                  _vm.droitAcces.imprime_exc_histo_retour_liste_entrept
                                )?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisEntrepotRetour('EXC')}}},[_vm._v("EXCEL")]):_vm._e()],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popProjet",arg:"popProjet"}],attrs:{"type":"warning","disabled":_vm.disabledBtnR,"icon":"el-icon-printer"}},[_vm._v("Rapport\n                            ")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card-text',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listEntree}},[_c('el-table-column',{attrs:{"prop":"sortie","label":"Sortie concerné","fixed":"left","width":"370"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                            "+_vm._s(scope.row.sortie)+"\n                            "),(scope.row.clore === true)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                              RETOUR CLORE\n                            ")]):_vm._e(),_vm._v(" "),(scope.row.clore === false)?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                              RETOUR NON TERMINE\n                            ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"produit","label":"Produit","width":"370"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.produit)+" ("+_vm._s(scope.row.type)+" -\n                              "+_vm._s(scope.row.refProd)+")\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.unite)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteR","label":"Quantité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"color":"green","text-color":"white"}},[_vm._v("\n                              "+_vm._s(scope.row.qteR)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateS","label":"Date de sortie"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("\n                              "+_vm._s(scope.row.sortie)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateR","label":"Date de retour"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.dateR)+"\n                              "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("date_range")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showEntree(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                Détails\n                              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerEntree(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                                Imprimer\n                              ")],1)],1)]}}])})],1)],1)],1)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"name":"transfert"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("transfer_within_a_station")]),_vm._v("\n                    Transfert")],1),_vm._v(" "),_c('div',[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                          TOUTES VOS DEMANDES DE TRANSFERT ÉMISES\n                          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("transfer_within_a_station")])],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('el-popover',{ref:"popover4",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("\n                                    Veuillez choisir le format d'impression ?\n                                  ")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisEntrepotDmdTEmise(
                                          'PDF'
                                        )}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisEntrepotDmdTEmise(
                                          'EXC'
                                        )}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover4",arg:"popover4"}],attrs:{"type":"warning","disabled":_vm.disabledBtnDTE,"icon":"el-icon-printer"}},[_vm._v("\n                                    Rapport\n                                  ")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[[(
                                    _vm.droitAcces.index_transfert ||
                                      _vm.droitAcces.index_transfert_chefValidation ||
                                      _vm.droitAcces.index_transfert_chefEntrepot
                                  )?_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listTransfertEmis,"height":"200"}},[_c('el-table-column',{attrs:{"prop":"produit","label":"Produit"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                      "+_vm._s(scope.row.produit)+"\n                                      "),(scope.row.reponse == 'En cours')?_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        En cours\n                                      ")]):_vm._e(),_vm._v(" "),(scope.row.reponse == 'Rejeté')?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                        Rejeté\n                                      ")]):_vm._e(),_vm._v(" "),(scope.row.reponse == 'Validé')?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                        Validé\n                                      ")]):_vm._e()]}}],null,false,1351193381)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"indigo"}},[_vm._v("\n                                        "+_vm._s(scope.row.unite)+"\n                                      ")])]}}],null,false,3570393135)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"entrepotR","label":"Entrepot"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.entrepotR)+"\n                                      ")])]}}],null,false,494891699)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteD","label":"Quantité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.qteD)+"\n                                      ")])]}}],null,false,3878057798)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showTransfert(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                        Détails\n                                      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(
                                            scope.row.demande === false &&
                                              scope.row.etat === false &&
                                              _vm.droitAcces.edit_transfert
                                          )?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.editTransfert(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                                        Modifier\n                                      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerTransfert(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                                        Imprimer\n                                      ")],1)]}}],null,false,4162931345)})],1):_vm._e()]],2)],1)])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                          TOUTES VOS DEMANDES DE TRANSFERT REÇU\n                          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("transfer_within_a_station")])],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listTransfertRecu,"height":"200"}},[_c('el-table-column',{attrs:{"prop":"produit","label":"Produit"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                      "+_vm._s(scope.row.produit)+"\n                                      "),(scope.row.reponse == 'En cours')?_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        En cours\n                                      ")]):_vm._e(),_vm._v(" "),(scope.row.reponse == 'Rejeté')?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                        Rejeté\n                                      ")]):_vm._e(),_vm._v(" "),(scope.row.reponse == 'Validé')?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                        Validé\n                                      ")]):_vm._e(),_vm._v(" "),(
                                          scope.row.demande === false &&
                                            scope.row.etat === false &&
                                            scope.row.priorite == 1
                                        )?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                        Très urgent\n                                      ")]):_vm._e(),_vm._v(" "),(
                                          scope.row.demande === false &&
                                            scope.row.etat === false &&
                                            scope.row.priorite == 2
                                        )?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                        Urgent\n                                      ")]):_vm._e(),_vm._v(" "),(
                                          scope.row.demande === false &&
                                            scope.row.etat === false &&
                                            scope.row.priorite == 3
                                        )?_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        Pas urgent\n                                      ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"indigo"}},[_vm._v("\n                                        "+_vm._s(scope.row.unite)+"\n                                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"entrepotD","label":"Entrepot"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.entrepotD)+"\n                                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteD","label":"Quantité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v("\n                                        "+_vm._s(scope.row.qteD)+"\n                                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"mouseenter":function($event){_vm.showTooltip = true},"mouseleave":function($event){_vm.showTooltip = false},"click":function($event){$event.stopPropagation();return _vm.showTransfert(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                        Détails\n                                      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(
                                            scope.row.demande === false &&
                                              scope.row.etat === false
                                          )?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"indigo"},on:{"click":function($event){$event.stopPropagation();return _vm.newReponseTransfert(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("report")])],1):_vm._e(),_vm._v("\n                                        Répondre à la demande\n                                      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerTransfert(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                                        Imprimer\n                                      ")],1)]}}])})],1)]],2)],1)])],1),_vm._v(" "),_c('br')],1)],1)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"name":"inventaire"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("timeline")]),_vm._v(" Inventaire")],1),_vm._v(" "),_c('div',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      LISTE DES INVENTAIRES "),_c('v-icon',{attrs:{"right":""}},[_vm._v("timeline")])],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":""}},[(
                            _vm.droitAcces.imprime_pdf_histo_inventaire_liste_entrepo ||
                              _vm.droitAcces.imprime_exc_histo_inventaire_entrept
                          )?_c('v-flex',[_c('el-popover',{ref:"popProjet",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[(
                                  _vm.droitAcces.imprime_pdf_histo_inventaire_liste_entrepo
                                )?_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisEntrepotInventaire('PDF')}}},[_vm._v("PDF")]):_vm._e(),_vm._v(" "),(
                                  _vm.droitAcces.imprime_exc_histo_inventaire_entrept
                                )?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisEntrepotInventaire('EXC')}}},[_vm._v("EXCEL")]):_vm._e()],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popProjet",arg:"popProjet"}],attrs:{"type":"warning","disabled":_vm.disabledBtnInv,"icon":"el-icon-printer"}},[_vm._v("Rapport\n                            ")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card-text',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listInventaire}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Réference","fixed":"left","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.ref)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"entrepot","label":"Entrepot","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"indigo"}},[_vm._v("\n                              Entrepot : "+_vm._s(scope.row.entrepot)+"\n                            ")]),_vm._v(" "),(scope.row.etat === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                              INVALIDE\n                            ")]):_vm._e(),_vm._v(" "),(scope.row.etat === true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                              VALIDE\n                            ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateD","label":"Date de début"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.dateD)+"\n                              "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("date_range")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Date de fin"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.dateF)+"\n                              "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("date_range")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showInventaire(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                Détails\n                              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(
                                    scope.row.etat === false
                                  )?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green lighten-2"},on:{"click":function($event){$event.stopPropagation();return _vm.validerInventaire(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("done_all")])],1):_vm._e(),_vm._v("\n                                Valider l'inventaire\n                              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerInventaire(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                                Imprimer\n                              ")],1)],1)]}}])})],1)],1)],1)])],1)],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShow = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n          Fermer\n        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editEntrepot(_vm.entrepotCourant)}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1),_vm._v("\n          Modifier\n        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"indigo darken-4","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newStock(_vm.entrepotCourant)}},slot:"activator"},[_vm._v("Stock "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1),_vm._v("\n          Ajouter un nouveau stock\n        ")],1),_vm._v(" "),(this.multipleSelection.length == 1)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newSortie(_vm.entrepotCourant)}},slot:"activator"},[_vm._v("Sortir "),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1),_vm._v("\n          Effectuer un enlevement\n        ")],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.detailEntre.etatInventaire === false)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"blue lighten-2","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.newTransfert(_vm.entrepotCourant);
              _vm.loadProduitStock(_vm.entrepotCourant);}},slot:"activator"},[_vm._v("Transfert "),_c('v-icon',{attrs:{"right":""}},[_vm._v("transfer_within_a_station")])],1):_vm._e(),_vm._v("\n          Effectuer un transfert\n        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.detailEntre.etatInventaire === false)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"blue darken-2","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.newInventaire(_vm.entrepotCourant);
              _vm.loadStock(_vm.entrepotCourant);
              _vm.loadProduitStock(_vm.entrepotCourant);}},slot:"activator"},[_vm._v("Inventaire "),_c('v-icon',{attrs:{"right":""}},[_vm._v("timeline")])],1):_vm._e(),_vm._v("\n          Effectuer un inventaire\n        ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.dialogValidAppro),callback:function ($$v) {_vm.dialogValidAppro=$$v},expression:"dialogValidAppro"}},[_c('v-card',[_c('v-form',{ref:"formValidApproLivr",attrs:{"id":"formValidApproLivr","lazy-validation":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('div',{staticClass:"title mb-3"},[_vm._v("\n                  Approvisionnement en attente de votre confirmation\n                ")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("Details de votre approvisionnement en attente.")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"name":"codetLiv","disabled":true,"label":"Code livraison"},model:{value:(_vm.codetLiv),callback:function ($$v) {_vm.codetLiv=$$v},expression:"codetLiv"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"name":"qteLivDepart","rules":_vm.qteLivDepartRules,"disabled":true,"required":"","label":"La quantité"},model:{value:(_vm.qteLivDepart),callback:function ($$v) {_vm.qteLivDepart=$$v},expression:"qteLivDepart"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md6":""}},[_c('v-text-field',{attrs:{"name":"produitLiv","disabled":true,"label":"Le produit"},model:{value:(_vm.produitLiv),callback:function ($$v) {_vm.produitLiv=$$v},expression:"produitLiv"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-alert',{attrs:{"value":true,"type":"warning"}},[_vm._v("\n              Confirmation de l'approvisionnement.\n            ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"items":_vm.items,"name":"choixValidLiv","rules":_vm.choixValidLivRules,"item-text":"text","item-value":"abbr","label":"Faite une action"},on:{"change":function($event){return _vm.changeValidLiv()}},model:{value:(_vm.choixValidLiv),callback:function ($$v) {_vm.choixValidLiv=$$v},expression:"choixValidLiv"}})],1),_vm._v(" "),(_vm.choixValidLiv == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"type":"number","name":"nbChoiceLiv","rules":_vm.nbChoiceLivRules,"label":"Quel nombre avez vous réçu?","placeholder":"Saisissez le nombre"},on:{"change":function($event){return _vm.loadChangChoix()}},model:{value:(_vm.nbChoiceLiv),callback:function ($$v) {_vm.nbChoiceLiv=$$v},expression:"nbChoiceLiv"}})],1):_vm._e(),_vm._v(" "),(_vm.choixValidLiv == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"name":"Commentaire","rules":_vm.remarqueLivrRules,"label":"Qu\\'est il arrivé au reste du produit manquant ?","multi-line":""},model:{value:(_vm.remarqueLivr),callback:function ($$v) {_vm.remarqueLivr=$$v},expression:"remarqueLivr"}})],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('span',{staticClass:"subheading"},[_vm._v("NOM DU LIVREUR *")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('el-input',{attrs:{"name":"libelle","placeholder":"Nom du livreur"},model:{value:(_vm.nomLivreur),callback:function ($$v) {_vm.nomLivreur=$$v},expression:"nomLivreur"}})],1)])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.resetValideLivAppro()}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.acceptLivrApproValid()}}},[_vm._v("Confirmer")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},model:{value:(_vm.dialogValidCarburan),callback:function ($$v) {_vm.dialogValidCarburan=$$v},expression:"dialogValidCarburan"}},[_c('v-card',[_c('v-form',{ref:"formValidApproLivr",attrs:{"id":"formValidApproLivr","lazy-validation":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('div',{staticClass:"title mb-3"},[_vm._v("\n                  Demande de carburant en attente de confirmation\n                ")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("Details de votre demande.")])])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs3":"","sm3":"","md9":""}},[_c('v-text-field',{attrs:{"name":"produitLiv","disabled":true,"label":"Véhicule"},model:{value:(_vm.produitLiv),callback:function ($$v) {_vm.produitLiv=$$v},expression:"produitLiv"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"name":"qteLivDepart","rules":_vm.qteLivDepartRules,"disabled":true,"required":"","label":"La quantité"},model:{value:(_vm.qteLivDepart),callback:function ($$v) {_vm.qteLivDepart=$$v},expression:"qteLivDepart"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-alert',{attrs:{"value":true,"type":"warning"}},[_vm._v("\n              Confirmation de l'approvisionnement.\n            ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"items":_vm.itemsCarburant,"name":"choixValidLiv","rules":_vm.choixValidLivRules,"item-text":"text","item-value":"abbr","label":"Faite une action"},on:{"change":function($event){return _vm.changeValidLiv()}},model:{value:(_vm.choixValidLiv),callback:function ($$v) {_vm.choixValidLiv=$$v},expression:"choixValidLiv"}})],1),_vm._v(" "),(_vm.choixValidLiv == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"type":"number","min":"0","name":"nbChoiceLiv","rules":_vm.nbChoiceLivRules,"label":"Combien voulez vous affecter?","placeholder":"Saisissez le nombre"},on:{"change":function($event){return _vm.loadChangChoix()}},model:{value:(_vm.nbChoiceLiv),callback:function ($$v) {_vm.nbChoiceLiv=$$v},expression:"nbChoiceLiv"}})],1):_vm._e(),_vm._v(" "),(_vm.choixValidLiv == 2)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"name":"Commentaire","rules":_vm.remarqueLivrRules,"label":"Motif?","multi-line":""},model:{value:(_vm.remarqueLivr),callback:function ($$v) {_vm.remarqueLivr=$$v},expression:"remarqueLivr"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.resetValideLivAppro()}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.acceptCarburanApproValid()}}},[_vm._v("Confirmer")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowSortie),callback:function ($$v) {_vm.dialogShowSortie=$$v},expression:"dialogShowSortie"}},[_c('v-card',[_c('v-toolbar',{staticClass:"red",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails de l'enlèvement "+_vm._s(_vm.sortieCourant.ref))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowSortie = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"Veuillez patientez ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.detailSortie.ref))]),_vm._v(" "),(_vm.detailSortie.infoTravaux != '')?_c('p',[_c('b',[_vm._v("Projet concerné : ")]),_vm._v("\n                            "+_vm._s(_vm.detailSortie.infoTravaux)+"\n                          ")]):_vm._e(),_vm._v(" "),(_vm.detailSortie.infoDemande != '')?_c('p',[_c('b',[_vm._v("Maintenance concerné : ")]),_vm._v("\n                            "+_vm._s(_vm.detailSortie.infoDemande)+"\n                          ")]):_vm._e(),_vm._v(" "),(_vm.detailSortie.refInterv != '')?_c('p',[_c('b',[_vm._v("Intervention concerné : ")]),_vm._v("\n                            "+_vm._s(_vm.detailSortie.infoInterv)+"\n                          ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Produit : ")]),_vm._v(" "+_vm._s(_vm.detailSortie.produit)+" ("+_vm._s(_vm.sortieCourant.type)+"\n                            - "+_vm._s(_vm.detailSortie.refProd)+")\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Quantité sortie : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                              "+_vm._s(_vm.detailSortie.qte)+"\n                            ")])],1),_vm._v(" "),(_vm.detailSortie.retour === true)?_c('p',[_c('b',[_vm._v("Date de retour prévue : ")]),_vm._v("\n                            "+_vm._s(_vm.detailSortie.dateR)+"\n                          ")]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[((_vm.detailSortie.demandeur = ''))?_c('p',[_c('b',[_vm._v("Demande effectué par: ")]),_vm._v("\n                            "+_vm._s(_vm.detailSortie.demandeur
                                ? _vm.detailSortie.demandeur
                                : "")+"\n                          ")]):_vm._e(),_vm._v(" "),(_vm.detailSortie.refInterv != '')?_c('p',[_c('b',[_vm._v("Demande effectué par: ")]),_vm._v("\n                            "+_vm._s(_vm.detailSortie.demandeurInterv
                                ? _vm.detailSortie.demandeurInterv
                                : "")+"\n                          ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de sortie : ")]),_vm._v(" "+_vm._s(_vm.detailSortie.dateS)+"\n                          ")]),_vm._v(" "),(_vm.detailSortie.retour === true)?_c('p',[_c('b',[_vm._v("Dernier retour éffectué : ")]),_vm._v("\n                            "+_vm._s(_vm.detailSortie.lastRetour)+"\n                          ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Retour : ")]),_vm._v(" "),(_vm.detailSortie.retour === true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                              Retour prévu\n                            ")]):_vm._e(),_vm._v(" "),(_vm.detailSortie.retour === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                              Aucun retour prévu\n                            ")]):_vm._e()],1),_vm._v(" "),(_vm.detailSortie.etat === false)?_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),(
                                _vm.detailSortie.clore === false &&
                                  _vm.detailSortie.qte !==
                                    _vm.detailSortie.qteRestante
                              )?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"warning"}},[_vm._v("\n                              Retour partiel "),_c('v-icon',{attrs:{"right":""}},[_vm._v("thumb_down")])],1):_vm._e(),_vm._v(" "),(
                                _vm.detailSortie.clore === false &&
                                  _vm.detailSortie.qte ===
                                    _vm.detailSortie.qteRestante
                              )?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              Aucun retour éffectué\n                              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("thumb_down")])],1):_vm._e(),_vm._v(" "),(_vm.detailSortie.clore === true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                              Retour éffectué en totalité\n                              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("thumb_up")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.detailSortie.etat === true)?_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                              Clôt "),_c('v-icon',{attrs:{"right":""}},[_vm._v("thumb_up")])],1)],1):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',[_c('b',[_vm._v("Entrepot : ")]),_vm._v(" "+_vm._s(_vm.detailSortie.entrepot)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Etat du produit : ")]),_vm._v(" "),(_vm.detailSortie.etatSortie === 'Bon')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(_vm.detailSortie.etatSortie)+"\n                              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("thumb_up")])],1):_vm._e(),_vm._v(" "),(_vm.detailSortie.etatSortie === 'Très bon')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(_vm.detailSortie.etatSortie)+"\n                              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("thumb_up")])],1):_vm._e(),_vm._v(" "),(_vm.detailSortie.etatSortie === 'Mauvais')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(_vm.detailSortie.etatSortie)+"\n                              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("thumb_down")])],1):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Remarque : ")]),_vm._v(" "+_vm._s(_vm.detailSortie.remarque)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v("\n                            "+_vm._s(_vm.detailSortie.created)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v("\n                            "+_vm._s(_vm.detailSortie.modified)+"\n                          ")])])],1)],1)])],1)])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[(_vm.detailSortie.entree !== null)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n            TOUS LES RETOURS CONCERNANTS LA SORTIE SORT-"+_vm._s(_vm.detailSortie.id)+"\n          ")]):_vm._e()],1),_vm._v(" "),(_vm.detailSortie.entree !== null)?_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailSortie.entree,"height":"200"}},[_c('el-table-column',{attrs:{"prop":"sortie","label":"Sortie concerné","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"produit","label":"Produit","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteR","label":"Quantité retourné"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateR","label":"Date"}})],1)]],2)],1)])],1)],1),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowSortie = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n          Fermer\n        ")],1),_vm._v(" "),(_vm.detailEntre.libelle != 'Hydrocarbure')?_c('v-tooltip',{attrs:{"top":""}},[(
              _vm.detailSortie.dateR !== null &&
                _vm.detailSortie.etatInventaire === true &&
                _vm.detailSortie.clore == false
            )?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newEntree(_vm.sortieCourant)}},slot:"activator"},[_vm._v("Retour "),_c('v-icon',{attrs:{"right":""}},[_vm._v("replay")])],1):_vm._e(),_vm._v("\n          Faire un retour\n        ")],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerSortie(_vm.sortieCourant)}},slot:"activator"},[_vm._v("Imprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("\n          Imprimer le bon de sorti\n        ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowEntree),callback:function ($$v) {_vm.dialogShowEntree=$$v},expression:"dialogShowEntree"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du retour "+_vm._s(_vm.entreeCourant.ref))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowEntree = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"Veuillez patientez ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.detailEntree.ref))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Sortie concerné : ")]),_vm._v("\n                            "+_vm._s(_vm.detailEntree.sortie)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Produit : ")]),_vm._v(" "+_vm._s(_vm.detailEntree.produit)+" ("+_vm._s(_vm.detailEntree.type)+"\n                            - "+_vm._s(_vm.detailEntree.ref)+")\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Quantité retour : ")]),_vm._v(" "),_c('v-chip',{attrs:{"color":"green","text-color":"white"}},[_vm._v("\n                              "+_vm._s(_vm.detailEntree.qteR)+"\n                            ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de retour : ")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(_vm.detailEntree.dateR)+"\n                              "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("date_range")])],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),(_vm.detailEntree.clore === true)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                              RETOUR CLORE\n                            ")]):_vm._e(),_vm._v(" "),(_vm.detailEntree.clore === false)?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                              RETOUR NON TERMINE\n                            ")]):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Remarque : ")]),_vm._v(" "+_vm._s(_vm.detailEntree.commentaire)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v("\n                            "+_vm._s(_vm.detailEntree.created)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v("\n                            "+_vm._s(_vm.detailEntree.modified)+"\n                          ")])])],1)],1)])],1)])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowEntree = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n          Fermer\n        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerEntree(_vm.entreeCourant)}},slot:"activator"},[_vm._v("Imprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("\n          Imprimer le retour\n        ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowTransfert),callback:function ($$v) {_vm.dialogShowTransfert=$$v},expression:"dialogShowTransfert"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue lighten-2",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du transfert "+_vm._s(_vm.transfertCourant.ref))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowTransfert = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"Veuillez patientez ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.detailTransfert.ref)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Entrepot émettant : ")]),_vm._v("\n                            "+_vm._s(_vm.detailTransfert.entrepotD)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Entrepot transférant : ")]),_vm._v("\n                            "+_vm._s(_vm.detailTransfert.entrepotF)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Produit : ")]),_vm._v(" "+_vm._s(_vm.detailTransfert.produit)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Quantité transferé : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v("\n                              "+_vm._s(_vm.detailTransfert.qteD)+"\n                            ")])],1),_vm._v(" "),(
                              _vm.detailTransfert.demande === true &&
                                _vm.detailTransfert.etat === true
                            )?_c('p',[_c('b',[_vm._v("Quantité transferé : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v("\n                              "+_vm._s(_vm.detailTransfert.qteT)+"\n                            ")])],1):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Etat da la demande : ")]),_vm._v(" "),(_vm.detailTransfert.reponse === 'En cours')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              En cours de traitement\n                            ")]):_vm._e(),_vm._v(" "),(_vm.detailTransfert.reponse === 'Rejeté')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                              DEMANDE REJETE\n                            ")]):_vm._e(),_vm._v(" "),(_vm.detailTransfert.reponse === 'Validé')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                              VALIDE\n                            ")]):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Prorité : ")]),_vm._v(" "),(_vm.detailTransfert.priorite === '1')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                              TRES URGENT\n                            ")]):_vm._e(),_vm._v(" "),(_vm.detailTransfert.priorite === '2')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                              URGENT\n                            ")]):_vm._e(),_vm._v(" "),(_vm.detailTransfert.priorite === '3')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                              PAS D'URGENCE\n                            ")]):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de demande : ")]),_vm._v("\n                            "+_vm._s(_vm.detailTransfert.created)+"\n                          ")]),_vm._v(" "),(
                              _vm.detailTransfert.demande === true &&
                                _vm.detailTransfert.etat === true
                            )?_c('p',[_c('b',[_vm._v("Date de transfert : ")]),_vm._v("\n                            "+_vm._s(_vm.detailTransfert.date)+"\n                          ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Motif de la demande : ")]),_vm._v("\n                            "+_vm._s(_vm.detailTransfert.motif)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Remarque : ")]),_vm._v("\n                            "+_vm._s(_vm.detailTransfert.commentaire)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v("\n                            "+_vm._s(_vm.detailTransfert.created)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v("\n                            "+_vm._s(_vm.detailTransfert.modified)+"\n                          ")])])],1)],1)])],1)])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowTransfert = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n          Fermer\n        ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowInventaire),callback:function ($$v) {_vm.dialogShowInventaire=$$v},expression:"dialogShowInventaire"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue darken-2",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails de l'inventaire\n          "+_vm._s(_vm.inventaireCourant.ref))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowInventaire = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"Veuillez patientez ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.detailInventaire.ref)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Inventaire concernant l'entrepot : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"indigo"}},[_vm._v("\n                              Entrepot : "+_vm._s(_vm.detailInventaire.entrepot)+"\n                            ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Etat de l'inventaire : ")]),_vm._v(" "),(_vm.detailInventaire.etat === true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                              VALIDE\n                            ")]):_vm._e(),_vm._v(" "),(_vm.detailInventaire.etat === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                              INVALIDE\n                            ")]):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Date de début : ")]),_vm._v("\n                            "+_vm._s(_vm.detailInventaire.dateD)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de fin : ")]),_vm._v(" "+_vm._s(_vm.detailInventaire.dateF)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v("\n                            "+_vm._s(_vm.detailInventaire.created)+"\n                          ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v("\n                            "+_vm._s(_vm.detailInventaire.modified)+"\n                          ")])])],1)],1)])],1)])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailInventaire.option,"height":"200"}},[_c('el-table-column',{attrs:{"prop":"produit","label":"Produit","width":"280"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.produit)+" ("+_vm._s(scope.row.type)+" -\n                              "+_vm._s(scope.row.ref)+")\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité","width":"280"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.unite)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteT","label":"Quantité théorique"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.qteT)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteReel","label":"Quantité réele"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.qteReel)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecart","label":"Ecart"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v("\n                              "+_vm._s(scope.row.ecart)+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"corriger","label":"Corriger ?"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.corriger === null)?_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v("\n                             NON\n                            ")]):_vm._e(),_vm._v(" "),(scope.row.corriger === 'OUI')?_c('v-chip',{attrs:{"text-color":"white","color":"green"}},[_vm._v("\n                              "+_vm._s(scope.row.corriger)+"\n                            ")]):_vm._e(),_vm._v(" "),(scope.row.corriger === 'NON')?_c('v-chip',{attrs:{"text-color":"white","color":"red"}},[_vm._v("\n                              "+_vm._s(scope.row.corriger)+"\n                            ")]):_vm._e()]}}])})],1)]],2)],1)])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowInventaire = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n          Fermer\n        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(
              _vm.detailInventaire.etat === false && _vm.droitAcces.valider_inventaire
            )?_c('v-btn',{attrs:{"slot":"activator","dark":"","color":"green lighten-2"},on:{"click":function($event){$event.stopPropagation();return _vm.validerInventaire(_vm.inventaireCourant)}},slot:"activator"},[_vm._v("\n            Valider\n            "),_c('v-icon',{attrs:{"dark":""}},[_vm._v("done_all")])],1):_vm._e(),_vm._v("\n          Valider l'inventaire\n        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerInventaire(_vm.inventaireCourant)}},slot:"activator"},[_vm._v("Imprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("\n          Imprimer l'inventaire\n        ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjout),callback:function ($$v) {_vm.dialogAjout=$$v},expression:"dialogAjout"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter un nouvel entrepot")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification de l'entrepot "+_vm._s(_vm.entrepotCourant.libelle)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjout = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formEntrepot",attrs:{"lazy-validation":"","id":"formEntrepot"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-stepper',{model:{value:(_vm.formEtape),callback:function ($$v) {_vm.formEtape=$$v},expression:"formEtape"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.formEtape > 1}},[_vm._v("\n                  ENTREPOT\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_convenience_store")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.formEtape > 2}},[_vm._v("\n                  STOCK "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1):_vm._e()],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      Description technique de votre entrepot\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_convenience_store")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Chantier concerné"},model:{value:(_vm.projetS),callback:function ($$v) {_vm.projetS=$$v},expression:"projetS"}},_vm._l((_vm.listProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Désignation *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelleEntre","placeholder":"Désignation"},model:{value:(_vm.libelleEntre),callback:function ($$v) {_vm.libelleEntre=$$v},expression:"libelleEntre"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type d'entrepot *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Type d'entrepot "},model:{value:(_vm.selectTypeEntre),callback:function ($$v) {_vm.selectTypeEntre=$$v},expression:"selectTypeEntre"}},_vm._l((_vm.typeEntre),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),(_vm.selectTypeEntre == '2')?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Capacité de la citerne *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"name":"seletCiterne","placeholder":"Capacité de la citerne"},model:{value:(_vm.seletCiterne),callback:function ($$v) {_vm.seletCiterne=$$v},expression:"seletCiterne"}})],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ville *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"ville","placeholder":"Ville"},model:{value:(_vm.ville),callback:function ($$v) {_vm.ville=$$v},expression:"ville"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quartier")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"quartier","placeholder":"Quartier"},model:{value:(_vm.quartier),callback:function ($$v) {_vm.quartier=$$v},expression:"quartier"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chef d'entrepot *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Chef d'entrepot"},model:{value:(_vm.selectChefEntre),callback:function ($$v) {_vm.selectChefEntre=$$v},expression:"selectChefEntre"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chef de validation *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Chef de validation"},model:{value:(_vm.selectChefVali),callback:function ($$v) {_vm.selectChefVali=$$v},expression:"selectChefVali"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Commune *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"commune","placeholder":"Commune"},model:{value:(_vm.commune),callback:function ($$v) {_vm.commune=$$v},expression:"commune"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"descriEntre","placeholder":"Description"},model:{value:(_vm.descriEntre),callback:function ($$v) {_vm.descriEntre=$$v},expression:"descriEntre"}})],1)])],1),_vm._v(" "),_c('br')],1),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-stepper-content',{attrs:{"step":"2"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                      Identification du stock actuel\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),_c('div',[_c('el-form',{ref:"formBudget",staticClass:"demo-form-inline",attrs:{"id":"formBudget","model":_vm.formBudget,"label-position":_vm.labelPosition}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"ressource","label":"Type de ressource ","required":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","default-first-option":"","placeholder":"Selectionnez un type de ressource"},on:{"change":function($event){return _vm.loadUniteProduit(_vm.formBudget.ressource)}},model:{value:(_vm.formBudget.ressource),callback:function ($$v) {_vm.$set(_vm.formBudget, "ressource", $$v)},expression:"formBudget.ressource"}},_vm._l((_vm.listProd),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.value,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"categorie","label":"Catégorie de ressource","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","readonly":true,"value":_vm.valeurCategorie,"placeholder":"Catégorie"},model:{value:(_vm.formBudget.categorie),callback:function ($$v) {_vm.$set(_vm.formBudget, "categorie", $$v)},expression:"formBudget.categorie"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md2":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"unite","label":"Unité","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","readonly":true,"value":_vm.valeurUniteMateriel,"placeholder":"Unité"},model:{value:(_vm.formBudget.unite),callback:function ($$v) {_vm.$set(_vm.formBudget, "unite", $$v)},expression:"formBudget.unite"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md2":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"seuilAlerte","label":"Seuil d'alerte ","required":""}},[_c('el-input-number',{attrs:{"controls-position":"right","min":5},model:{value:(_vm.formBudget.seuilAlerte),callback:function ($$v) {_vm.$set(_vm.formBudget, "seuilAlerte", $$v)},expression:"formBudget.seuilAlerte"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-2",attrs:{"md2":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"action"}},[_c('el-button',{attrs:{"type":"primary","disabled":!_vm.verifFormBudget},on:{"click":function($event){return _vm.addProduit(_vm.formBudget)}}},[_vm._v("Ajouter")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableProduit}},[_c('el-table-column',{attrs:{"prop":"ressource","label":"Type de ressource","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"categorie","label":"Catégorie de ressource","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"seuilAlerte","label":"Seuil d'alerte"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                              "+_vm._s(new Intl.NumberFormat().format(
                                  scope.row.seuilAlerte
                                ))+"\n                            ")]}}],null,false,1655112016)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableProduit)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                Supprimer\n                              ")],1)]}}],null,false,4039431545)})],1)],1)],1)],1),_vm._v(" "),_c('br')]):_vm._e()],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),(_vm.dialogEdit !== true && _vm.formEtape == 2)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.formEtape = 1}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("chevron_left")]),_vm._v(" Précedent")],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit !== true && _vm.formEtape == 1)?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.formEtape = 2}}},[_vm._v("Suivant"),_c('v-icon',{attrs:{"right":""}},[_vm._v("chevron_right")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit !== true && _vm.formEtape == 2)?_c('v-btn',{attrs:{"icons":"","color":"green","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submit()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-btn',{attrs:{"icons":"","color":"orange","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submit()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogStock),callback:function ($$v) {_vm.dialogStock=$$v},expression:"dialogStock"}},[_c('v-card',[_c('v-toolbar',{staticClass:"indigo darken-4",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter un nouveau stock ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogStock = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formStock",attrs:{"lazy-validation":"","id":"formStock"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"indigo darken-4"}},[_vm._v("\n                Ajout d'un nouveau stock de produit dans l'entrepot ENTR-"+_vm._s(_vm.entrepotCourant.id)+"\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('input',{ref:"fileInputExcel",staticStyle:{"display":"none"},attrs:{"name":"fileInputExcel","type":"file","accept":"image/*"},on:{"change":_vm.onFileExcelPicked}}),_vm._v(" "),(true)?_c('v-btn',{attrs:{"slot":"activator","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$refs.fileInputExcel.click()}},slot:"activator"},[_vm._v("\n                  Importer\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_download")])],1):_vm._e(),_vm._v("Importer fichier excel\n              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogImport = true}},slot:"activator"},[_vm._v("\n                  Générer\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1):_vm._e(),_vm._v("Générer un modèle\n              ")],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de ressource *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Type de ressource"},on:{"change":function($event){return _vm.loadUniteProduit(_vm.selectProduitRestant)}},model:{value:(_vm.selectProduitRestant),callback:function ($$v) {_vm.selectProduitRestant=$$v},expression:"selectProduitRestant"}},_vm._l((_vm.listProd),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.value,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Catégorie de ressource ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","readonly":true,"value":_vm.valeurCategorie,"placeholder":"Catégorie"},model:{value:(_vm.valeurCategorie),callback:function ($$v) {_vm.valeurCategorie=$$v},expression:"valeurCategorie"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"valeurSelect","readonly":true},model:{value:(_vm.valeurUniteMateriel),callback:function ($$v) {_vm.valeurUniteMateriel=$$v},expression:"valeurUniteMateriel"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Seuil du stock *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"name":"seuilStock","placeholder":"Seuil du stock"},model:{value:(_vm.seuilStock),callback:function ($$v) {_vm.seuilStock=$$v},expression:"seuilStock"}})],1)])],1),_vm._v(" "),(_vm.selectProduitRestant != '' && this.seuilStock != 0)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"icons":"","color":"primary","id":"plus","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addListProduit()}}},[_c('v-icon',[_vm._v("add")])],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tabListProduit}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Type de ressource"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Catégorie de ressource"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"seuil","label":"Seuil"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tabListProduit)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                      Supprimer cette ligne\n                    ")],1)]}}])})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogStock = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(this.tabListProduit.length != 0)?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitStock()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSortie),callback:function ($$v) {_vm.dialogSortie=$$v},expression:"dialogSortie"}},[_c('v-card',[_c('v-toolbar',{staticClass:"red",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter un nouvel enlèvement ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification de l'enlèvement "+_vm._s(_vm.entrepotCourant.libelle)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogSortie = false;
            _vm.disableOption = false;}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formSortie",attrs:{"lazy-validation":"","id":"formSortie"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                SORTI D'UN PRODUIT DE L'ENTREPOT\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de sortie *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.disableOption,"name":"dateS","id":"dateS","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de sortie"},model:{value:(_vm.dateS),callback:function ($$v) {_vm.dateS=$$v},expression:"dateS"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Demandeur *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"destinataireSortie","placeholder":"Demandeur"},model:{value:(_vm.destinataireSortie),callback:function ($$v) {_vm.destinataireSortie=$$v},expression:"destinataireSortie"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Remarque")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"remarqueSortie","placeholder":"Remarque"},model:{value:(_vm.remarqueSortie),callback:function ($$v) {_vm.remarqueSortie=$$v},expression:"remarqueSortie"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de sortie *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.disableOption,"placeholder":"Type de sortie"},model:{value:(_vm.selectTypeSortie),callback:function ($$v) {_vm.selectTypeSortie=$$v},expression:"selectTypeSortie"}},_vm._l((_vm.typeSortie),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[(_vm.selectTypeSortie == 1)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                SORTIR CONCERNANT UN CHANTIER "),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1):_vm._e()],1),_vm._v(" "),(_vm.selectTypeSortie == 1)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Chantier concerné"},on:{"change":function($event){return _vm.loadChantier()}},model:{value:(_vm.projetS),callback:function ($$v) {_vm.projetS=$$v},expression:"projetS"}},_vm._l((_vm.listProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chantier concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Chantier concerné"},on:{"change":function($event){return _vm.loadTravaux()}},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}},_vm._l((_vm.listChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Travaux"},model:{value:(_vm.travauxS),callback:function ($$v) {_vm.travauxS=$$v},expression:"travauxS"}},_vm._l((_vm.listTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1):_vm._e(),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[(_vm.selectTypeSortie == 2)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                SORTIR CONCERNANT UNE DEMANDE DE MAINTENANCE\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1):_vm._e()],1),_vm._v(" "),(_vm.selectTypeSortie == 2)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Demande de maintenance concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.disableOption,"placeholder":"Demande de maintenance concerné"},model:{value:(_vm.selectDemande),callback:function ($$v) {_vm.selectDemande=$$v},expression:"selectDemande"}},_vm._l((_vm.listDemande),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1):_vm._e(),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                PRODUIT A SORTIR "),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1)],1),_vm._v(" "),_vm._l((_vm.optionSortie),function(optionS,index){return _c('v-layout',{key:optionS.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Désignation *")]),_vm._v(" "),(optionS.qte !== 0)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"prop":'optionSortie.' + index + '.produit',"value":"produit","placeholder":"Demandeur"},model:{value:(optionS.produit),callback:function ($$v) {_vm.$set(optionS, "produit", $$v)},expression:"optionS.produit"}}):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité sortie *")]),_vm._v(" "),(optionS.qte !== 0)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.disableOption,"type":"number","min":0,"max":optionS.qte,"prop":'optionSortie.' + index + '.qteS',"value":"qteS","placeholder":"Quantité sortie"},model:{value:(optionS.qteS),callback:function ($$v) {_vm.$set(optionS, "qteS", $$v)},expression:"optionS.qteS"}}):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Etat du produit *")]),_vm._v(" "),(optionS.qte !== 0)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","prop":'optionSortie.' + index + '.etat',"name":"etat","placeholder":"Etat du produit"},model:{value:(optionS.selectEtatProduit),callback:function ($$v) {_vm.$set(optionS, "selectEtatProduit", $$v)},expression:"optionS.selectEtatProduit"}},_vm._l((_vm.etatProduit),function(item){return _c('el-option',{key:item.text,attrs:{"label":item.text,"value":item.text}})}),1):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Un retour est-il prévue ? *")]),_vm._v(" "),(optionS.qte !== 0)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","prop":'optionSortie.' + index + '.retour',"name":"retour","placeholder":"Un retour est-il prévue ?"},model:{value:(optionS.selectRetourPrev),callback:function ($$v) {_vm.$set(optionS, "selectRetourPrev", $$v)},expression:"optionS.selectRetourPrev"}},_vm._l((_vm.retourPrev),function(item){return _c('el-option',{key:item.text,attrs:{"label":item.text,"value":item.text}})}),1):_vm._e()],1)]),_vm._v(" "),(optionS.selectRetourPrev === 'Oui')?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date du retour ? *")]),_vm._v(" "),(optionS.qte !== 0)?_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"prop":'optionSortie.' + index + '.dateRe',"name":"dateRe","id":"dateRe","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date du retour ?"},model:{value:(optionS.dateRe),callback:function ($$v) {_vm.$set(optionS, "dateRe", $$v)},expression:"optionS.dateRe"}}):_vm._e()],1)]):_vm._e()],1)}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogSortie = false;
                _vm.disableOption = false;}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitSortie()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],2)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogCarburanSortie),callback:function ($$v) {_vm.dialogCarburanSortie=$$v},expression:"dialogCarburanSortie"}},[_c('v-card',[_c('v-toolbar',{staticClass:"red",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter un nouvel enlèvement ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification de l'enlèvement "+_vm._s(_vm.entrepotCourant.libelle)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogCarburanSortie = false;
            _vm.disableOption = false;}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formSortie",attrs:{"lazy-validation":"","id":"formSortie"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                SORTI DE CARBURANT CONCERNANT UNE TACHE\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.detailEntre.typeHydro,"filterable":"","placeholder":"Chantier concerné"},on:{"change":function($event){return _vm.loadChantier()}},model:{value:(_vm.projetS),callback:function ($$v) {_vm.projetS=$$v},expression:"projetS"}},_vm._l((_vm.listProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chantier concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.detailEntre.typeHydro,"filterable":"","placeholder":"Chantier concerné"},on:{"change":function($event){return _vm.loadTravaux()}},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}},_vm._l((_vm.listChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.detailEntre.typeHydro,"filterable":"","placeholder":"Travaux"},model:{value:(_vm.travauxS),callback:function ($$v) {_vm.travauxS=$$v},expression:"travauxS"}},_vm._l((_vm.listTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tache *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.detailEntre.typeHydro,"filterable":"","placeholder":"Tâche"},model:{value:(_vm.tacheS),callback:function ($$v) {_vm.tacheS=$$v},expression:"tacheS"}},_vm._l((_vm.listTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                SORTI D'UNE QUANTITE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Demandeur *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.detailEntre.typeHydro,"name":"destinataireSortie","placeholder":"Demandeur"},model:{value:(_vm.destinataireSortie),callback:function ($$v) {_vm.destinataireSortie=$$v},expression:"destinataireSortie"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de sortie *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.disableOption,"name":"dateS","id":"dateS","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de sortie"},model:{value:(_vm.dateS),callback:function ($$v) {_vm.dateS=$$v},expression:"dateS"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Remarque")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"remarqueSortie","placeholder":"Remarque"},model:{value:(_vm.remarqueSortie),callback:function ($$v) {_vm.remarqueSortie=$$v},expression:"remarqueSortie"}})],1)])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                VEHICULE/ENGIN"),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1)],1),_vm._v(" "),_vm._l((_vm.optionSortie),function(optionS,index){return _c('v-layout',{key:optionS.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Engin *")]),_vm._v(" "),(optionS.qte !== 0)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"prop":'optionSortie.' + index + '.produit',"value":"produit","placeholder":"Demandeur"},model:{value:(optionS.produit),callback:function ($$v) {_vm.$set(optionS, "produit", $$v)},expression:"optionS.produit"}}):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité demandé *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true,"prop":'optionSortie.' + index + '.qte',"value":"qte","placeholder":"qte"},model:{value:(optionS.qte),callback:function ($$v) {_vm.$set(optionS, "qte", $$v)},expression:"optionS.qte"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité sortie *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.disableOption,"type":"number","min":0,"max":'optionSortie.' + index + '.qte',"prop":'optionSortie.' + index + '.qteS',"value":"qteS","placeholder":"Quantité sortie"},model:{value:(optionS.qteS),callback:function ($$v) {_vm.$set(optionS, "qteS", $$v)},expression:"optionS.qteS"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Carburant *")]),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"Selectionner le carburant"},model:{value:(optionS.carburant),callback:function ($$v) {_vm.$set(optionS, "carburant", $$v)},expression:"optionS.carburant"}},_vm._l((_vm.listStock),function(item){return _c('el-option',{key:item.value,staticStyle:{"width":"100%"},attrs:{"label":item.produit,"value":item.id}})}),1)],1)])],1)}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogCarburanSortie = false;
                _vm.disableOption = false;}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitSortie()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],2)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogEntree),callback:function ($$v) {_vm.dialogEntree=$$v},expression:"dialogEntree"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter un nouveau retour pour la sortie SORT-"+_vm._s(_vm.sortieCourant.id)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification le retour ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogEntree = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formEntree",attrs:{"lazy-validation":"","id":"formEntree"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                Retour dans l'entrepot "),_c('v-icon',{attrs:{"right":""}},[_vm._v("replay")])],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"font-size":"15px","font-weight":"bold"},attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Réference du produit *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.sortieCourant.refProd,"placeholder":"Réference du produit","disabled":true},model:{value:(_vm.sortieCourant.refProd),callback:function ($$v) {_vm.$set(_vm.sortieCourant, "refProd", $$v)},expression:"sortieCourant.refProd"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Produit sorti")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.sortieCourant.produit,"placeholder":"Produit sorti","disabled":true},model:{value:(_vm.sortieCourant.produit),callback:function ($$v) {_vm.$set(_vm.sortieCourant, "produit", $$v)},expression:"sortieCourant.produit"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité sortie")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.sortieCourant.qte,"placeholder":"Quantité sortie","disabled":true},model:{value:(_vm.sortieCourant.qte),callback:function ($$v) {_vm.$set(_vm.sortieCourant, "qte", $$v)},expression:"sortieCourant.qte"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de sortie")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.sortieCourant.dateS,"placeholder":"Date de sortie","disabled":true},model:{value:(_vm.sortieCourant.dateS),callback:function ($$v) {_vm.$set(_vm.sortieCourant, "dateS", $$v)},expression:"sortieCourant.dateS"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de retour *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateRetour","id":"dateRetour","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de retour"},model:{value:(_vm.dateRetour),callback:function ($$v) {_vm.dateRetour=$$v},expression:"dateRetour"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité restante")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.sortieCourant.qteRestante,"placeholder":"Quantité restante","disabled":true},model:{value:(_vm.sortieCourant.qteRestante),callback:function ($$v) {_vm.$set(_vm.sortieCourant, "qteRestante", $$v)},expression:"sortieCourant.qteRestante"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité restante")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"qteRetour","type":"number","min":0,"max":_vm.sortieCourant.qteRestante,"placeholder":"Quantité restante"},on:{"change":function($event){return _vm.verifeClore()}},model:{value:(_vm.qteRetour),callback:function ($$v) {_vm.qteRetour=$$v},expression:"qteRetour"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Etat du produit *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Etat du produit"},model:{value:(_vm.selectEtatRetour),callback:function ($$v) {_vm.selectEtatRetour=$$v},expression:"selectEtatRetour"}},_vm._l((_vm.etatRetour),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),(_vm.verifeEtat == true)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Qu'est-il arrivé aux autres produit ? *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"raison","placeholder":"Qu'est-il arrivé aux autres produit ?"},model:{value:(_vm.raison),callback:function ($$v) {_vm.raison=$$v},expression:"raison"}})],1)]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Remarque")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"remarqueRetour","placeholder":"Remarque"},model:{value:(_vm.remarqueRetour),callback:function ($$v) {_vm.remarqueRetour=$$v},expression:"remarqueRetour"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogEntree = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitEntree()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogTransfert),callback:function ($$v) {_vm.dialogTransfert=$$v},expression:"dialogTransfert"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue lighten-2",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter une nouvelle demande de transfert\n          ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification de la demande transfert TRANS-"+_vm._s(_vm.transfertCourant.id)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogTransfert = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formTransfert",attrs:{"lazy-validation":"","id":"formTransfert"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"blue lighten-2"}},[_vm._v("\n                TRANSFERT DE PRODUIT\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("transfer_within_a_station")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Motif du transfert *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"motifTransfert","placeholder":"Motif du transfert"},model:{value:(_vm.motifTransfert),callback:function ($$v) {_vm.motifTransfert=$$v},expression:"motifTransfert"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Priorité *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Priorité"},model:{value:(_vm.selectPriorite),callback:function ($$v) {_vm.selectPriorite=$$v},expression:"selectPriorite"}},_vm._l((_vm.priorite),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Désignation *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Désignation"},model:{value:(_vm.selectProduitDemande),callback:function ($$v) {_vm.selectProduitDemande=$$v},expression:"selectProduitDemande"}},_vm._l((_vm.produitStock),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.produit,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité demandé *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"name":"qteD","placeholder":"Quantité demandé"},model:{value:(_vm.qteD),callback:function ($$v) {_vm.qteD=$$v},expression:"qteD"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Entrepot concerné par la demande *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Entrepot concerné par la demande"},model:{value:(_vm.selectEntrepot),callback:function ($$v) {_vm.selectEntrepot=$$v},expression:"selectEntrepot"}},_vm._l((_vm.listAutreEntrepot),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogTransfert = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitTransfert()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogReponseTransfert),callback:function ($$v) {_vm.dialogReponseTransfert=$$v},expression:"dialogReponseTransfert"}},[_c('v-card',[_c('v-toolbar',{staticClass:"indigo",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Répondre à la demande de transfert TRANS-"+_vm._s(_vm.transfertCourant.id)+"\n          ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogReponseTransfert = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formReponseTransfert",attrs:{"lazy-validation":"","id":"formReponseTransfert"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"indigo"}},[_vm._v("\n                REPONSE AU TRANSFERT TRANS-"+_vm._s(_vm.transfertCourant.id)+"\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("report")])],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"font-size":"15px"},attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Produit concerné")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.transfertCourant.produit,"placeholder":"Produit concerné","disabled":true},model:{value:(_vm.transfertCourant.produit),callback:function ($$v) {_vm.$set(_vm.transfertCourant, "produit", $$v)},expression:"transfertCourant.produit"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité demande")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.transfertCourant.qteD,"placeholder":"Quantité demande","disabled":true},model:{value:(_vm.transfertCourant.qteD),callback:function ($$v) {_vm.$set(_vm.transfertCourant, "qteD", $$v)},expression:"transfertCourant.qteD"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Motif de la demande")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.transfertCourant.motif,"placeholder":"Motif de la demande","disabled":true},model:{value:(_vm.transfertCourant.motif),callback:function ($$v) {_vm.$set(_vm.transfertCourant, "motif", $$v)},expression:"transfertCourant.motif"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de la demande")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.transfertCourant.date,"placeholder":"Date de la demande","disabled":true},model:{value:(_vm.transfertCourant.date),callback:function ($$v) {_vm.$set(_vm.transfertCourant, "date", $$v)},expression:"transfertCourant.date"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Réponse à la demande éffectué *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Réponse à la demande éffectué"},model:{value:(_vm.selectReponseTransfert),callback:function ($$v) {_vm.selectReponseTransfert=$$v},expression:"selectReponseTransfert"}},_vm._l((_vm.reponseTransfert),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Remarque")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"remarqueReponse","placeholder":"Remarque"},model:{value:(_vm.remarqueReponse),callback:function ($$v) {_vm.remarqueReponse=$$v},expression:"remarqueReponse"}})],1)]),_vm._v(" "),(_vm.selectReponseTransfert === 1)?_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité transferé")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"name":"qteT","placeholder":"Quantité transferé"},model:{value:(_vm.qteT),callback:function ($$v) {_vm.qteT=$$v},expression:"qteT"}})],1)]):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogReponseTransfert = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitReponseTransfert()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogInventaire),callback:function ($$v) {_vm.dialogInventaire=$$v},expression:"dialogInventaire"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue darken-2",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter un nouveau inventaire ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogInventaire = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formInventaire",attrs:{"lazy-validation":"","id":"formInventaire"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-stepper',{model:{value:(_vm.formEtape),callback:function ($$v) {_vm.formEtape=$$v},expression:"formEtape"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.formEtape > 1}},[_vm._v("\n                  PERIODE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("event")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.dialogEdit !== true)?_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.formEtape > 2}},[_vm._v("\n                  STOCK "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1):_vm._e()],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"blue darken-2"}},[_vm._v("\n                      INVENTAIRE DE L'ENTREPOT ENTR-"+_vm._s(_vm.entrepotCourant.id)+"\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("timeline")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de début *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","name":"dateDeb","id":"dateDeb","value-format":"yyyy-MM-dd","type":"date","placeholder":"Date de début"},model:{value:(_vm.dateDeb),callback:function ($$v) {_vm.dateDeb=$$v},expression:"dateDeb"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de fin *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","name":"dateFin","id":"dateFin","value-format":"yyyy-MM-dd","type":"date","placeholder":"Date de fin"},model:{value:(_vm.dateFin),callback:function ($$v) {_vm.dateFin=$$v},expression:"dateFin"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":_vm.clearInventaire}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.dateDeb != '' && _vm.dateFin != '')?_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.formEtape = 2}}},[_vm._v("Suivant"),_c('v-icon',{attrs:{"left":""}},[_vm._v("chevron_right")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"blue darken-2"}},[_vm._v("\n                      Identification du stock concerné\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('input',{ref:"fileInputExcelInvent",staticStyle:{"display":"none"},attrs:{"name":"fileInputExcelInvent","type":"file","accept":"image/*"},on:{"change":_vm.onFileExcelInvent}}),_vm._v(" "),(true)?_c('v-btn',{attrs:{"slot":"activator","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$refs.fileInputExcelInvent.click()}},slot:"activator"},[_vm._v("\n                        Importer\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_download")])],1):_vm._e(),_vm._v("Importer fichier excel\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogIventair = true}},slot:"activator"},[_vm._v("\n                        Générer\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1):_vm._e(),_vm._v("Générer un modèle\n                    ")],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}}),_vm._v(" "),_c('el-form',{ref:"formAddStock",staticClass:"demo-form-inline",attrs:{"id":"formAddStock","label-position":"top","inline":true,"model":_vm.formAddStock}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Désignation *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Produit"},on:{"change":function($event){return _vm.filterProdStock(_vm.formAddStock.designation)}},model:{value:(_vm.formAddStock.designation),callback:function ($$v) {_vm.$set(_vm.formAddStock, "designation", $$v)},expression:"formAddStock.designation"}},_vm._l((_vm.listeInventaire),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.produit,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité*")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"valeurSelect","readonly":true},model:{value:(_vm.valeurUniteMateriel),callback:function ($$v) {_vm.valeurUniteMateriel=$$v},expression:"valeurUniteMateriel"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité théorique\n                          ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":"qte","placeholder":"Quantité théorique","readonly":true},model:{value:(_vm.formAddStock.qte),callback:function ($$v) {_vm.$set(_vm.formAddStock, "qte", $$v)},expression:"formAddStock.qte"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité réele *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"value":"qteReel","placeholder":"Quantité réele"},model:{value:(_vm.formAddStock.qteReel),callback:function ($$v) {_vm.$set(_vm.formAddStock, "qteReel", $$v)},expression:"formAddStock.qteReel"}})],1)]),_vm._v(" "),(_vm.formAddStock.designation != '')?_c('v-btn',{attrs:{"icons":"","color":"primary","id":"plus","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addNewStockProduit(_vm.formAddStock)}}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tabNewstock}},[_c('el-table-column',{attrs:{"prop":"designation","label":"Désignation"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteTeori","label":"Quantité théorique"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteReel","label":"Quantité réele"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRowStock(scope.$index, _vm.tabNewstock)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                            Supprimer cette ligne\n                          ")],1)]}}])})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":_vm.clearInventaire}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.formEtape = 1}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("chevron_left")]),_vm._v(" Précedent")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"green","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitInventaire()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogConfir),callback:function ($$v) {_vm.dialogConfir=$$v},expression:"dialogConfir"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous corriger le stock pour toutes les lignes?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogConfir = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.confirmerAll($event)}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogValiderInventaire),callback:function ($$v) {_vm.dialogValiderInventaire=$$v},expression:"dialogValiderInventaire"}},[_c('v-card',[_c('v-toolbar',{staticClass:"green lighten-2",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Validation de l'inventaire INVE-"+_vm._s(_vm.inventaireCourant.id)+"\n          ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogValiderInventaire = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formValiderInventaire",attrs:{"lazy-validation":"","id":"formValiderInventaire"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green lighten-2"}},[_vm._v("\n                VALIDATION DE L'INVENTAIRE DU STOCK DE L'ENTREPOT ENTR-"+_vm._s(_vm.entrepotCourant.id)+"\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("timeline")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogConfir = true}},slot:"activator"},[_vm._v("\n                  Corriger (OUI)\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done_all")])],1):_vm._e(),_vm._v("Confirmer pour tous\n              ")],1)],1),_vm._v(" "),_vm._l((_vm.optionInventaire),function(optionV,index){return _c('v-layout',{key:optionV.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Désignation")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":"produit","prop":'optionInventaire.' + index + '.produit',"placeholder":"Désignation","readonly":true},model:{value:(optionV.produit),callback:function ($$v) {_vm.$set(optionV, "produit", $$v)},expression:"optionV.produit"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":"unite","prop":'optionInventaire.' + index + '.unite',"placeholder":"Unité","readonly":true},model:{value:(optionV.unite),callback:function ($$v) {_vm.$set(optionV, "unite", $$v)},expression:"optionV.unite"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité théorique")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":"qteT","prop":'optionInventaire.' + index + '.qteT',"placeholder":"Quantité théorique","readonly":true},model:{value:(optionV.qteT),callback:function ($$v) {_vm.$set(optionV, "qteT", $$v)},expression:"optionV.qteT"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité réele")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":"qteReel","prop":'optionInventaire.' + index + '.qteReel',"placeholder":"Quantité réele","readonly":true},model:{value:(optionV.qteReel),callback:function ($$v) {_vm.$set(optionV, "qteReel", $$v)},expression:"optionV.qteReel"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ecart type")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":"ecart","prop":'optionInventaire.' + index + '.ecart',"placeholder":"Ecart type","readonly":true},model:{value:(optionV.ecart),callback:function ($$v) {_vm.$set(optionV, "ecart", $$v)},expression:"optionV.ecart"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Corriger le stock ? *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","prop":'optionInventaire.' + index + '.corriger',"placeholder":"Corriger le stock ?"},model:{value:(optionV.selectCorriger),callback:function ($$v) {_vm.$set(optionV, "selectCorriger", $$v)},expression:"optionV.selectCorriger"}},_vm._l((_vm.corriger),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)])],1)}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogValiderInventaire = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.droitAcces.valider_inventaire)?_c('v-btn',{attrs:{"icons":"","color":"green","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitValiderInventaire()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e()],1)],2)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cet enrégistrement ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteEntrepot($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-card',[_c('div',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n        LISTE DES ENTREPOTS "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_convenience_store")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":""}},[(
              _vm.droitAcces.imprime_pdf_histo_stock_liste_entrepot ||
                _vm.droitAcces.imprime_exc_histo_stock_liste_entrepot
            )?_c('v-flex',[_c('el-popover',{ref:"popProjetStock",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[(_vm.droitAcces.imprime_pdf_histo_stock_liste_entrepot)?_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHis('PDF')}}},[_vm._v("PDF")]):_vm._e(),_vm._v(" "),(_vm.droitAcces.imprime_exc_histo_stock_liste_entrepot)?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHis('EXC')}}},[_vm._v("EXCEL")]):_vm._e()],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popProjetStock",arg:"popProjetStock"}],attrs:{"type":"warning","icon":"el-icon-printer"}},[_vm._v("Rapport\n              ")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card-text',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listEntrepot}},[_c('el-table-column',{attrs:{"prop":"projet","label":"Projet","width":"370","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"warning"}},[_vm._v("\n                "+_vm._s(scope.row.projet)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","width":"370","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                "+_vm._s(scope.row.libelle)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ville","label":"Localisation"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                "+_vm._s(scope.row.ville)+" - "+_vm._s(scope.row.commune)+" -\n                "+_vm._s(scope.row.quartier)),_c('v-icon',{attrs:{"right":""}},[_vm._v("location_on")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type d'entrepot"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.type == '1' || scope.row.type == 'Produit')?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                PRODUIT\n              ")]):_vm._e(),_vm._v(" "),(
                  scope.row.type == '2' || scope.row.type == 'Hydrocarbure'
                )?_c('v-chip',{attrs:{"outline":"","text-color":"warning","label":"","color":"warning"}},[_vm._v("\n                HYDROCARBURE\n              ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();_vm.showEntrepot(scope.row);
                      _vm.loadAutreEntrepot(scope.row);
                      _vm.loadProduitStock(scope.row);
                      _vm.loadProduitRestant(scope.row);}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                  Détails\n                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){$event.stopPropagation();return _vm.editEntrepot(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                  Modifier\n                ")],1),_vm._v(" "),(
                    scope.row.idCreated == _vm.user.id ||
                      _vm.droitAcces.entrepot_delete
                  )?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSupr = true;
                      _vm.idEntrepot = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                  Supprimer\n                ")],1):_vm._e()],1)]}}])})],1)],1)],1)]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.showDetailAppro),callback:function ($$v) {_vm.showDetailAppro=$$v},expression:"showDetailAppro"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Détails de l'approvisionnement "+_vm._s(_vm.approCourant.ref))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.showDetailAppro = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"Veuillez patientez ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("N° Commande : ")]),_vm._v(" "+_vm._s(_vm.approCourant.refCom))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("N° Livraison : ")]),_vm._v(" "+_vm._s(_vm.approCourant.refLivr))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Dispatching éffectué par : ")]),_vm._v("\n                        "+_vm._s(_vm.approCourant.dispatching)+"\n                      ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Livreur: ")]),_vm._v(" "+_vm._s(_vm.approCourant.userCreated))])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Validé par : ")]),_vm._v(" "+_vm._s(_vm.approCourant.created))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de validation : ")]),_vm._v("\n                        "+_vm._s(_vm.approCourant.created)+"\n                      ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Service achat: ")]),_vm._v(" "+_vm._s(_vm.approCourant.achat))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Receptioniste: ")]),_vm._v("\n                        "+_vm._s(_vm.approCourant.receptioniste)+"\n                      ")])])],1)],1)])],1)])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.showDetailAppro = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n            Fermer\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerAppro(_vm.approCourant)}},slot:"activator"},[_vm._v("Imprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("\n            Imprimer la fiche\n          ")],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogImport),callback:function ($$v) {_vm.dialogImport=$$v},expression:"dialogImport"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h4',{attrs:{"align":"center"}},[_vm._v("\n          Nb: Le fichier contient uniquement les ressources qui ne figurent\n          pas dans votre stock.\n        ")]),_vm._v(" "),_c('h4',{attrs:{"align":"center"}},[_vm._v("\n          Indiquer uniquement le seuil de chaque ligne de produit que vous\n          souhaitez ajouter à votre stock.\n        ")]),_vm._v(" "),_c('h3',{attrs:{"align":"center"}},[_vm._v("\n          Supprimer ensuite les lignes restantes dans votre fichier avant\n          importation.\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogImport = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.generateFileExcel()}}},[_vm._v("Généner "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogIventair),callback:function ($$v) {_vm.dialogIventair=$$v},expression:"dialogIventair"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h4',{attrs:{"align":"center"}},[_vm._v("\n          Nb: Le fichier contient uniquement les ressources qui ne figurent\n          dans votre stock.\n        ")]),_vm._v(" "),_c('h4',{attrs:{"align":"center"}},[_vm._v("\n          Indiquer uniquement la quantité réele de chaque ligne de produit que\n          vous souhaitez corriger.\n        ")]),_vm._v(" "),_c('h3',{attrs:{"align":"center"}},[_vm._v("\n          Supprimer ensuite les lignes restantes dans votre fichier avant\n          importation.\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogIventair = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.geneFileExcelInvent()}}},[_vm._v("Généner "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ot2n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
    name: "SelectionTechnicien",
    props: ["show", "listeTechniciens", "demandeDetail"],
    data: function data() {
        return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            loading: false,
            dialogSelectTechnicien: false
        };
    },


    computed: {},
    watch: {
        show: function show(newValue, oldvalue) {
            this.dialogSelectTechnicien = newValue;
        }
    },

    methods: {
        closeDialog: function closeDialog() {
            this.$emit('close');
        },
        submitTech: function submitTech(item) {
            var _this = this;

            this.loading = true;

            var url = this.domaine + 'demande_maintenance/select/technicien';
            item.idTechnicien;
            //recuperation des demandes
            var data = new FormData();
            data.append("idDemande", this.demandeDetail.idDemande);
            data.append("idUser", this.user.id);
            data.append("idTechnicien", item.idTechnicien);

            this.$http.post(url, data).then(function (response) {
                _this.closeDialog();
                _this.loading = false;
                _this.successNotif("Une notification sms et mail a ete envoye au technicien " + item.nom);
            }, function (erreur) {
                _this.closeDialog();
                _this.loading = false;
                _this.$message.error("Une erreur est survenue lors de l'enregistrement du choix du technicien");
            });
        },
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "p9u+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexOuvrierTrx_vue__ = __webpack_require__("rzYm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5546650_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexOuvrierTrx_vue__ = __webpack_require__("hxV6");
function injectStyle (ssrContext) {
  __webpack_require__("cNrM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexOuvrierTrx_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5546650_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexOuvrierTrx_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pQDW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_resourceHumaine_form_detail_prof__ = __webpack_require__("E/of");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { formDetailProf: __WEBPACK_IMPORTED_MODULE_0__components_resourceHumaine_form_detail_prof__["a" /* default */], Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
    props: {
        idUserEmploye: {
            type: Number,
            default: null
        },
        show: {
            type: Boolean,
            default: false
        },
        typeAdmin: {
            type: Boolean,
            default: true
        }
    },
    name: "detailProfessionnel",
    data: function data() {
        return {
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            loading: false,

            detailProfession: [],
            dialogSuppDetail: false,
            idDetail: null,
            showFormDetail: false,
            items: [],
            index: null
        };
    },

    watch: {
        show: function show(newValue, oldValue) {
            if (newValue != null) {
                // if(this.detailProfession.length > 0){
                //     return;
                // }
                this.loadDetailProf();
            }
        }
    },
    methods: {
        loadDetailProf: function loadDetailProf() {
            var _this = this;

            this.loading = true;
            var data = {
                idUserCreated: this.user.id
            };
            var url = this.domaine + "rh/detailProfessionnel/" + this.idUserEmploye;
            this.$http.get(url, { params: data }).then(function (resp) {
                _this.loading = false;
                _this.detailProfession = resp.body.detailProfs;
            }, function (error) {
                _this.loading = false;
                _this.$message.error("Echec lors du chargement des détails professionnels de l'employé");
            });
        },
        deleteDetail: function deleteDetail(idDetail) {
            this.idDetail = idDetail;
            this.dialogSuppDetail = true;
        },
        submitDeleteDetail: function submitDeleteDetail() {
            var _this2 = this;

            this.loading = true;
            var url = this.domaine + "rh/detailProf/" + this.idDetail + "/deleteDetail";

            this.$http.get(url).then(function (resp) {
                _this2.loading = false;
                _this2.dialogSuppDetail = false;
                _this2.successNotif(resp.body.message);
                _this2.loadDetailProf();
            }, function (error) {
                _this2.loading = false;
                _this2.dialogSuppDetail = false;
                _this2.$message.error("Echec lors de la suppression des détails professionnels de l'employé");
            });
        },
        closeFormProf: function closeFormProf() {
            this.showFormDetail = false;
            this.loadDetailProf();
        },
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        },
        showDiapo: function showDiapo(images, ind) {
            this.items = images;
            this.index = ind;
        }
    }
});

/***/ }),

/***/ "pScu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailDemande_vue__ = __webpack_require__("38y9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9be6c7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailDemande_vue__ = __webpack_require__("ttRm");
function injectStyle (ssrContext) {
  __webpack_require__("9DBo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailDemande_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a9be6c7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailDemande_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pZwn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","scrollable":"","loading":_vm.loading,"fullscreen":"","hide-overlay":""},model:{value:(_vm.dialogDetail),callback:function ($$v) {_vm.dialogDetail=$$v},expression:"dialogDetail"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Fiche de Validation d'une mission "+_vm._s(_vm.detailMission.IdUtil))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',[_c('v-flex',[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Informations générales\n                                            ")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date Depart")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailMission.debut)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Activite")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailMission.activite)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de la demande")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailMission.date)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Retour prevue")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailMission.dateEntrePrevue)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Itineraire")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailMission.itineraire)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Marque")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailMission.marque)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Modele")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailMission.modele)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Serie")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailMission.serie)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Moyen de transport")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailMission.modeTransport)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de paiement de la facture")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailMission.datePaiement)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right blue--text title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailMission.chantier)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Budget  validé  pour ce chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right blue--text title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(new Intl.NumberFormat().format(_vm.detailMission.budgetMoisMission))+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Montant total déjà decaissé")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right blue--text title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(new Intl.NumberFormat().format(_vm.detailMission.mntMissionDecaisse))+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Montant restant à depenser")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right blue--text title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(new Intl.NumberFormat().format(_vm.detailMission.ecart))+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Etat budget mission (si la facture est validée)")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_c('el-tag',{attrs:{"type":(_vm.detailMission.ecart >= _vm.detailMission.totalFrais) ? 'success' : 'danger',"disable-transitions":""}},[(_vm.detailMission.ecart >= _vm.detailMission.totalFrais)?_c('span',[_vm._v("Dans le budget")]):_c('span',[_vm._v("Hors budget")])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Demandeur ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailMission.demandeur)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Conducteur ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailMission.nomPren)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Validateur 1 ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailMission.validateur1)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Validateur 2 ")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailMission.validateur2)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Etat")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right blue--text  title",attrs:{"xs10":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.detailMission.libEtat)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Description")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs12":""}},[_c('el-form',{staticClass:"demo-ruleForm"},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":""}},[_c('el-input',{attrs:{"readonly":true,"type":"textarea"},model:{value:(_vm.detailMission.description),callback:function ($$v) {_vm.$set(_vm.detailMission, "description", $$v)},expression:"detailMission.description"}})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Informations participants\n                                            ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailMission.participants}},[_c('el-table-column',{attrs:{"prop":"nom","label":"Nom","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prenom","label":"Prenom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fonction","label":"Fonction"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Informations frais de mission\n                                            ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (HT): "+_vm._s(new Intl.NumberFormat().format(_vm.detailMission.totalFraisHT))+"  fcfa")])]),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (TVA): "+_vm._s(new Intl.NumberFormat().format(_vm.detailMission.totalTva))+" fcfa")])]),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (TTC):"+_vm._s(new Intl.NumberFormat().format(_vm.detailMission.totalFrais))+" fcfa")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailMission.frais}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Libelle","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantite","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixUnit","label":"Prix unitaire"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                                        "+_vm._s(new Intl.NumberFormat().format(scope.row.prixUnit))+"\n                                                                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"TVA"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                                        "+_vm._s(new Intl.NumberFormat().format(scope.row.tva))+"\n                                                                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Total"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                                        "+_vm._s(new Intl.NumberFormat().format(scope.row.total))+"\n                                                                    ")]}}])})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.detailMission.etat == 5)?_c('v-btn',{staticClass:"mb-5",staticStyle:{"margin-right":"100px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"red"},on:{"click":function($event){_vm.dialogConfirmRefus = true}},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Refuser la mission")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.detailMission.etat == 5)?_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"green"},on:{"click":function($event){_vm.dialogConfirm = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Valider la mission")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirmRefus),callback:function ($$v) {_vm.dialogConfirmRefus=$$v},expression:"dialogConfirmRefus"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation d'une demande de mission")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous Refuser ce devis ?","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("DEMANDE DE MISSION")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("DMD-"+_vm._s(_vm.detailMission.IdUtil))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{ref:"refFormRefust",staticClass:"demo-form-inline",attrs:{"id":"formRefus","rules":_vm.ruleFormRefus,"label-position":"top","inline":true,"model":_vm.formRefus}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Commentaire","prop":"rapportRefus"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Pourquoi voulez-vous refuser ?"},model:{value:(_vm.formRefus.rapport),callback:function ($$v) {_vm.$set(_vm.formRefus, "rapport", $$v)},expression:"formRefus.rapport"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirmRefus = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitRefusDevis()}}},[_vm._v("Refuser")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation d'une demande de mission")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous valider le devis ?","closable":false,"show-icon":"","type":"success"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("DEMANDE DE MISSION")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("MISS-"+_vm._s(_vm.detailMission.IdUtil))])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirm = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideDevis()}}},[_vm._v("Confirmer")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pbl8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
      user: JSON.parse(sessionStorage.getItem('userInfo')),
      roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
      items: [],
      valid: true,
      password: '',
      email: '',
      emailRules: [function (v) {
        return !!v || 'Veuillez entrer obligatoirement votre e-mail';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([-]?\w+)*(.\w{2,3})+$/.test(v) || 'Vous devez respecter format de E-mail'
        );
      }],
      beforeMount: function beforeMount() {
        if (!this.roleAcces[this.$router.history.current.name]) {
          this.$router.push({ name: 'Home' });
        }
      }
    };
  },

  methods: {
    submit: function submit() {},
    clear: function clear() {
      this.$refs.form.reset();
    }
  }
});

/***/ }),

/***/ "pc6w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_map_ProjetMap__ = __webpack_require__("blqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dhtmlx_gantt__ = __webpack_require__("iSmP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dhtmlx_gantt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dhtmlx_gantt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_boardProjet_dashboardOngletPrj__ = __webpack_require__("5VJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_boardChantier_DashboardChantierProjet__ = __webpack_require__("6G+4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_boardChantier_index_tache_chantier__ = __webpack_require__("q0O9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_boardTravaux_IndexOuvrierTrx__ = __webpack_require__("p9u+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_projet_MatriceContract__ = __webpack_require__("zc6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_projet_ListEvolution__ = __webpack_require__("y7U+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_projet_CompteExploitationProjet__ = __webpack_require__("ebtw");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Vb+l");
__webpack_require__("Oq2I");
__webpack_require__("miEh");












/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_3__components_Loading__["a" /* default */],
    ProjetMap: __WEBPACK_IMPORTED_MODULE_4__components_map_ProjetMap__["a" /* default */],
    DashboardOngletPrj: __WEBPACK_IMPORTED_MODULE_6__components_boardProjet_dashboardOngletPrj__["a" /* default */],
    DashboardChantierProjet: __WEBPACK_IMPORTED_MODULE_7__components_boardChantier_DashboardChantierProjet__["a" /* default */],
    IndexTache: __WEBPACK_IMPORTED_MODULE_8__components_boardChantier_index_tache_chantier__["a" /* default */],
    IndexOuvrierTrx: __WEBPACK_IMPORTED_MODULE_9__components_boardTravaux_IndexOuvrierTrx__["a" /* default */],
    MatriceContract: __WEBPACK_IMPORTED_MODULE_10__components_projet_MatriceContract__["a" /* default */],
    ListEvolution: __WEBPACK_IMPORTED_MODULE_11__components_projet_ListEvolution__["a" /* default */],
    CompteExploitationProjet: __WEBPACK_IMPORTED_MODULE_12__components_projet_CompteExploitationProjet__["a" /* default */]
  },
  name: "projet",
  data: function data() {
    var _ref;

    return _ref = {
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      valid: true,
      choix: true,
      etat: false,
      disabledBtnContTrx: false,
      choixTravux: true,
      choixChantier: true,
      dialogImport: false,
      racourcis: [{ path: "/", text: "Accueil", disabled: false }, { path: "/projet", text: "Liste des projets", disabled: true }],
      tabb: "0",
      tab: "0",
      logoProjet: "/static/img-doc.png",
      logoChantier: "/static/img-doc.png",
      fileLogo: "",
      logoOuvrier: "/static/img-doc.png",

      activeSuivie: "taches",
      activeCom: "avalider",
      activeEngin: "engin",
      activeTacheChantier: "tacheChantier",
      activeComChantier: "avalider",
      dialogPlan: false,
      dialogCharge: false,
      dialogFormCharge: false,
      dialogTravaux: false,
      dialogComm: false,
      dialogPlanifProduit: false,
      dialogEquipe: false,
      showDialogDupTrx: false,
      dialogProjet: false,
      detailCommis: [],
      dialogCondicteur: false,
      dialogCommis: false,
      libelleSelect: [],
      formTacheDemarrer: {
        dateDbtache: '',
        dateFintache: ''
      },
      dialogShowReglement: false,
      dialogShowEditRessource: false,
      dialogShowInfoRessource: false,
      dialogDemarer: false,
      dialogDemarerTravaux: false,
      dialogRapport: false,
      dialogValid: false,
      dialogValidCommande: false,
      dialogShowProjet: false,
      dialogShowTravaux: false,
      dialogShowTache: false,
      dialogShowCommande: false,
      dialogEdit: false,
      dialogSupr: false,
      dialogSuprChantier: false,
      dialogSuprTravaux: false,
      dialogSuprTache: false,
      dialogSuprRessource: false,
      dialogDupliqueChantier: false,
      dialogMultipleRapport: false,
      activDerouler: false,
      idProjet: "",
      idChantier: "",
      idTravaux: "",
      idTache: "",
      idRessour: "",
      UniteVehicule: "",
      projetCourant: [],
      detailProjet: [],
      selectBanques: [],
      selectUsers: [],
      optionE: [],
      texteP: "",
      priorites: [{
        value: 1,
        label: "Faible"
      }, {
        value: 2,
        label: "Normal"
      }, {
        value: 3,
        label: "Urgent"
      }],
      prodSelct: '',
      formEditRessource: {
        id: '',
        libelle: '',
        qte: 0,
        dateF: '',
        dateD: ''
      },
      newQteRessource: 0,
      formManoeuvre: {
        nom: "",
        domicile: "",
        profession: "",
        piece: "",
        numPiece: "",
        contact: "",
        dateNaiss: ""
      },
      formInfoRessource: {
        id: '',
        libelle: '',
        qte: 0,
        dateD: '',
        dateF: ''
      },
      form: {
        id: "",
        etat: false,
        type: "",
        description: "",
        libelle: "",
        adresse: "",
        chef: "",
        chefEtude: "",
        chefControle: "",
        architect: "",
        caisse: "",
        banque: "",
        nbrHeure: 1,
        maitre_ouvrage: "",
        prixBudget: "",
        prix: "",
        controleur_travaux: ''
      },
      liste: [],
      type: { etat: false },
      selected: [],
      items: [],
      loptionVehicule: [],
      optionChantier: [{
        key: 1,
        libelle: "",
        dateD: "",
        dateF: "",
        montant: 0,
        idChef: "",
        id: ""
      }],
      libelleRules: [function (v) {
        return !!v || "Veuillez renseigner le libellé obligatoirement";
      }],
      listChantier: [],
      chantierCourant: [],
      travauxCourant: [],
      optionTache: [{
        key: 1,
        unite: "",
        dateDebut: "",
        dateFin: "",
        tache: "",
        qte: 1,
        prix: 0,
        total: 0,
        id: ""
      }],
      users: [],
      usersRules: [function (v) {
        return !!v || "Veuillez renseigner le libellé obligatoirement";
      }],
      listPrestataire: [],
      listOuvrier: [],
      listTravaux: [],
      listTypeProjet: [],
      listTravauxProjet: [],
      rulesZone: {
        ville: [{
          required: true,
          message: "Veuillez renseigner la ville",
          trigger: "blur"
        }],
        commune: [{
          required: true,
          message: "Veuillez renseigner la commune",
          trigger: "change"
        }],
        quartier: [{
          required: true,
          message: "Veuillez renseigner le quartier",
          trigger: "change"
        }]
      },
      listEtat: [{ id: 1, libelle: "En cours" }, { id: 2, libelle: "Arret du chantier" }, { id: 3, libelle: "Termine" }],
      selectZone: "",
      selectEtat: ""
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "travauxCourant", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "FormComm", {
      fournisseur: "",
      optionCommande: [{ key: 1, produit: "", qte: 1, id: "" }]
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "rulesComm", {
      optionCommande: [{
        produit: [{
          required: true,
          message: "Veuillez renseigner la ville",
          trigger: "blur"
        }],
        prix: [{
          required: true,
          message: "Veuillez renseigner la commune",
          trigger: "change"
        }],
        qte: [{
          required: true,
          message: "Veuillez renseigner le quartier",
          trigger: "change"
        }],
        tva: [{
          required: true,
          message: "Veuillez renseigner le quartier",
          trigger: "change"
        }]
      }]
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listProd", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "detailTravaux", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "detailPlanifProduit", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "etape", 1), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "descriptionTravaux", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectChefTravaux", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "optionEquipe", [{
      key: 1,
      type: [{ text: "Prestataire", value: 1 }, { text: "Ouvrier/Manoeuvre", value: 2 }],
      selectType: "",
      fournisseur: "",
      ouvrier: "",
      duree: "",
      montant: 0,
      montantSupp: 0,
      id: ""
    }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tacheCourant", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "equipeCourant", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tacheSelectioner", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listEquipe", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "multipleSelection", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "optionDemarer", [{ key: 1, date: "", id: "" }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dateDContrat", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dateFContrat", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "montantContrat", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "nbSection", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "evolution", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "description", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dateD", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dateDbtache", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dateFintache", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dateF", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listProjetTache", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listProjetContrat", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "fichier", [{ name: "", url: "" }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "reponseValid", [{ text: "VALIDER", value: 1 }, { text: "REFUSE", value: 2 }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectReponse", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listProjetAValid", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listProjetAll", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listProjetValid", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "commandeCourant", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "detailCommande", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listProjetAlivre", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listProjetlivre", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listCaisse", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listBanque", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listEngin", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listeProduitAffich", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listProduiTravaux", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectTravaux", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listeSousTache", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectSousTravaux", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "readBtdTrx", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tasks", {
      data: [],
      links: []
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "libProjet", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "chefProjet", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "libChantier", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "chefChantier", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showModalMap", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "longitude", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "latitude", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "montant", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "libelle", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "mapName", "chantier-map"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "markers", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listeTacheSupp", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "chantier", {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "idChantMod", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "disabledBtnPop", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dialogAjoutOuvrier", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "fileExcel", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "rulesformManoeuvre", {
      nom: [{ required: true, message: "Saisir un nom", trigger: "blur" }],

      piece: [{
        required: true,
        message: "Saisir le type de piece",
        trigger: "blur"
      }],
      numPiece: [{
        required: true,
        message: "Saisir le numero de la piece",
        trigger: "blur"
      }],
      contact: [{
        required: true,
        message: "Saisir un numéro de téléphone",
        trigger: "blur"
      }]
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectPrestataire", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "lstPreparation", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showModalLoadPreparation", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectSoustraite", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "etatSoutraitance", [{ text: "NON", value: 0 }, { text: "OUI", value: 1 }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "montantSoustraitance", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "montantEstime", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listChantierSuivie", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listTravauxSuivie", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tacheCourant", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "detailTache", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "projetSelect", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectSearchChantier", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectSearchEtat", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectSearchProjet", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dateSearch", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "etatSearch", [{ text: "En attente", value: 0 }, { text: "En cours", value: 1 }, { text: "Terminé", value: 2 }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "typeSearch", [{ text: "Par chantier", value: 1 }, { text: "Par travaux", value: 2 }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectTypeSearch", 1), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectSearchTravaux", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listProjetResult", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listChantierResult", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listTravauxResult", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectSearchChantierFind", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectTypeSearchSuivi", 1), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectSearchTravauxSuivi", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectSearchChantierSuivi", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectSearchChantierFindSuivi", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "typeRapport", [{ text: "Etat général", value: 1 }, { text: "Valeur financiere", value: 2 }, { text: "Commande", value: 3 },
    //{ text: 'Ressource humaine', value: 4 },
    { text: "Mission", value: 4 }, { text: "Produit", value: 5 }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectTypeRapport", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "colorx", "#8B0000"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "searchResultEtat", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "searchResultEtatMontant", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "searchResultList", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "searchResultTravauxList", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "searchProduitChantierList", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "searchResultEtatCommande", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "libelleEtatResult", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "totalCommande", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "totalDepense", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "optionDuplique", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectChantierRapport", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectTravauxRapport", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "optionRapport", [{ evolution: 0, description: "", fichier: [] }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "statsGeneralAll", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "statsMontantAll", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "statsCommandeAll", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tabListProduit", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectProduit", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectQte", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "optionProduit", [{ type: "", produit: "", qte: 1, priorite: "" }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "optionVehicule", [{ vehicule: "", qte: 1, priorite: "", periode: "" }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dataMarqueurProj", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dialogAide", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "nbChantier", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "uniteAffic", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listProdPlan", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "typeProduit", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listTypeRessource", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listVehPlan", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dialogInfoPlan", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showMatrice", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showListTaux", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "detailProjet", {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showDetailProjet", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "detailChantier", {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showDetailChantier", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "detailTravaux", {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showDetailTache", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "imageProjet", "/static/routeDefaut.jpeg"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "fileProj", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "fichierProj", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tacheSel", {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showSelTache", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dialogDemarrer", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "formDemarrer", {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "readBtnModTrx", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "totalHT", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tacheCourante", {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "valeurUniteMateriel", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectPriorite", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectEnginQte", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "prodSelctEngin", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "periodeEngin", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectEnginPriorite", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tabListEngin", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listeTacheTrx", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tacheS", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listClient", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "detailPlanifCourant", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listTravauxRow", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listCommandesRow", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listTachesRow", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listRessourcesRow", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listeCharges", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "mntTotal", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "appiSearch", [{ text: "Toute la durée du projet", value: 'tous' }, { text: "Période", value: 'periode' }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "modeRemuneration", [{ text: "Journalier", value: 'journalier' }, { text: "Mensuel", value: 'mensuel' }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectRemuneration", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "chargeDateD", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "chargeDateF", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "montantChargeJournalier", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "totalMontantHT", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "jourDifference", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "totalMontantSan", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "idCharge", ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "dialogSuprCharge", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "listeProduitBudget", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "tableBudget", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showCompteExploit", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "showListingTaux", false), _ref;
  },
  created: function created() {
    this.loadMarqueurProjet();
  },
  mounted: function mounted() {
    this.loadProjetAll();
    this.statsAllProjet();
    this.loadTypeRessource();
    this.loadTypeEngin();
  },

  methods: {
    handleChangeSoustraitant: function handleChangeSoustraitant(soustraite) {
      if (soustraite == 0) {
        this.chantier.prestataire = null;
        this.chantier.montantSoustraitance = 0;
      }
    },
    calculTotalComm: function calculTotalComm() {
      this.totalMontantHT = 0;
      var totalHT = 0;
      var qte = this.optionProduit[0]['qte'];

      if (this.selectReponse == 'tous') {
        if (this.selectRemuneration == 'journalier') {
          totalHT = this.montantChargeJournalier * qte * this.projetCourant.dureeJ;
        } else {
          totalHT = this.montantChargeJournalier * qte * this.projetCourant.dureeM;
        }
      } else {
        var Dcharge = this.functionTime(this.chargeDateD);
        var Fcharge = this.functionTime(this.chargeDateF);
        var Diff_temps = Fcharge.getTime() - Dcharge.getTime();
        var Diff_jours = Diff_temps / (1000 * 3600 * 24);
        var jour = Math.round(Diff_jours);

        this.jourDifference = jour;
        if (this.selectRemuneration == 'journalier') {
          totalHT = this.montantChargeJournalier * qte * jour;
        } else {
          totalHT = this.montantChargeJournalier * qte * (jour / 30);
        }
      }
      this.totalMontantHT = new Intl.NumberFormat("fr-Fr").format(totalHT);
      this.totalMontantSan = totalHT;
    },


    //budget
    loadProduitBudget: function loadProduitBudget() {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "product/product-travaux-list/all/type";
      var formdata = new FormData();
      formdata.append("user", this.user.id);
      formdata.append("typeTacheProjet", this.form.type);
      this.listeProduitBudget.splice(0);
      this.$http.post(url, formdata).then(function (response) {
        if (response.body) {
          _this.loading = false;
          _this.listeProduitBudget = response.body.produits;
        }
      }, function (response) {
        _this.loading = false;
      });
    },
    deleteRow: function deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    loadTypeRessource: function loadTypeRessource() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "product/typeRessource";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this2.listTypeRessource = response.body.types;
          _this2.loading = false;
        }
      });
    },
    loadTypeEngin: function loadTypeEngin() {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + "product/productVehicule-list";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this3.loptionVehicule = response.body.vehicule;
          _this3.loading = false;
        }
      });
    },
    deleteEnginRow: function deleteEnginRow(index, rows) {
      rows.splice(index, 1);
    },
    addListBudget: function addListBudget(item) {
      //verifier si l'item n'et pas deja enregistrer dans le tableau
      var eltProd = this.tableBudget.find(function (elt) {
        return elt == item.libelle.libelle;
      });
      if (eltProd != null) {
        this.$message.error("Cet element a déjà été ajouté à la liste");
        return;
      }

      this.tableBudget.push({
        libelle: item.libelle.libelle,
        montantAdecaisse: item.montantAdecaisse,
        type: item.libelle.typeBudget,
        id: item.libelle.id
      });
    },
    showParticipants: function showParticipants() {
      this.dialogProjet = true;
    },
    showCondicteur: function showCondicteur() {
      this.dialogCondicteur = true;
    },
    showCommis: function showCommis(item) {
      this.dialogCommis = true;
      this.detailCommis = item;
    },
    loadTacheTrx: function loadTacheTrx() {
      var _this4 = this;

      this.loading = true;
      this.tacheS = "";
      this.listeTacheTrx.splice(0);
      if (this.travauxS != "" || this.travauxS !== undefined) {
        var url = this.domaine + "tache/travaux/" + this.tacheCourante.id;
        this.$http.get(url).then(function (response) {
          _this4.listeTacheTrx = response.body.taches;
          _this4.loading = false;
          if (_this4.listeTacheTrx.length <= 0) {
            _this4.dialogPlanifProduit = false;
            _this4.$message.error("Veuillez definir des taches pour se travaux");
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner une tache");
        this.loading = false;
      }
    },
    closeDialogProjet: function closeDialogProjet() {
      this.showMatrice = false;
      this.dialogShowProjet = false;
      this.showCompteExploit = false;
      this.showListingTaux = false;
    },
    calculTotalTache: function calculTotalTache(index) {
      var item = this.optionTache[index];
      var oldTotal = this.optionTache[index].total;
      if (oldTotal != undefined) {
        this.totalHT -= oldTotal;
      }

      var total = item.qte * item.prix;
      if (total != undefined) {
        this.optionTache[index].total = total;
        this.totalHT += total;
      }
    },
    calculMntTache: function calculMntTache() {
      this.totalHT = 0;
      for (var index in this.optionTache) {
        var item = this.optionTache[index];
        var total = item.qte * item.prix;
        if (total != undefined) {
          this.totalHT += total;
          this.optionTache[index].total = total;
        }
      }
    },
    handleTabClick: function handleTabClick(tab) {
      this.showMatrice = false;
      this.showListTaux = false;
      console.log('tab', tab);
      switch (tab) {
        case "1":
          this.showCompteExploit = true;
          this.showMatrice = false;
          break;
        case "2":
          this.showMatrice = true;
          this.showCompteExploit = false;
          break;

        case "5":
        case 5:
          this.showListTaux = true;
          this.showListingTaux = false;
          break;

        default:
          this.showMatrice = false;
          this.showCompteExploit = false;
          break;
      }
    },
    handleTabClickTravaux: function handleTabClickTravaux(obj, e) {
      var item = obj.$attrs.idTravau;
      this.listTravauxRow = [];
      this.listTachesRow = [];
      this.listCommandesRow = [];
      this.listRessourcesRow = [];
      this.loadTravauxRow(item);
    },
    handleTabClickTaches: function handleTabClickTaches(tab) {
      var item = this.listTravauxRow.idTrx;
      switch (tab.index) {
        case "0":
          this.loadTachesTravaux(item);
          break;
        case "1":
          this.loadRessourcesTravaux(item);
          break;
        case "2":
          this.loadCommandesTravaux(item);
          break;
      }
    },
    loadTravauxRow: function loadTravauxRow(idTravaux) {
      var _this5 = this;

      this.loading = true;
      // this.listTravauxRow = []
      var url = this.domaine + "projet/chantier/" + this.selectSearchChantierFindSuivi + "/travaux/" + idTravaux;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this5.loading = false;
          _this5.listTravauxRow = response.body.travaux;
        }
      }, function (error) {
        _this5.loading = false;
        _this5.$message.error("L'opération a echouée");
      });
    },
    loadTachesTravaux: function loadTachesTravaux(idTravaux) {
      var _this6 = this;

      this.loading = true;
      // this.listTravauxRow = []
      var url = this.domaine + "projet/chantier/" + this.selectSearchChantierFindSuivi + "/travaux/" + idTravaux + "/taches";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this6.loading = false;
          _this6.listTachesRow = response.body.taches;
        }
      }, function (error) {
        _this6.loading = false;
        _this6.$message.error("L'opération a echouée");
      });
    },
    loadRessourcesTravaux: function loadRessourcesTravaux(idTravaux) {
      var _this7 = this;

      this.loading = true;
      // this.listTravauxRow = []
      var url = this.domaine + "projet/chantier/" + this.selectSearchChantierFindSuivi + "/travaux/" + idTravaux + "/ressources";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this7.loading = false;
          _this7.listRessourcesRow = response.body.ressources;
        }
      }, function (error) {
        _this7.loading = false;
        _this7.$message.error("L'opération a echouée");
      });
    },
    loadCommandesTravaux: function loadCommandesTravaux(idTravaux) {
      var _this8 = this;

      this.loading = true;
      // this.listTravauxRow = []
      var url = this.domaine + "projet/chantier/" + this.selectSearchChantierFindSuivi + "/travaux/" + idTravaux + "/commandes";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this8.loading = false;
          _this8.listCommandesRow = response.body.commandes;
        }
      });
    },

    //demarrer une tache
    submitFormDemarrer: function submitFormDemarrer(formName) {
      var _this9 = this;

      if (this.formDemarrer.dateDbt != "undefined" && this.formDemarrer.hrDbt != null && this.formDemarrer.hrDbt != "undefined" && this.formDemarrer.hrDbt != null) {
        this.loading = true;
        var url = this.domaine + "tache/demarrer/optionTrx/" + this.tacheSel.idOpt;
        var data = new FormData();

        var dateDbt = this.formDemarrer.dateDbt.getFullYear() + "-" + this.formDemarrer.dateDbt.getMonth() + "-" + this.formDemarrer.dateDbt.getDate();
        var hrDbt = this.formDemarrer.hrDbt.getHours() + ":" + this.formDemarrer.hrDbt.getMinutes();

        data.append("dateDbt", dateDbt);
        data.append("hrDbt", hrDbt);
        data.append("idUser", this.user.id);
        this.$http.post(url, data).then(function (response) {
          _this9.loading = false;
          //reinitialiser le formulaire
          _this9.dialogDemarrer = false;
          var mess = response.body.message;
          _this9.loadChantierSuivie();
          _this9.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: mess,
            type: "success",
            position: "top-center"
          });
        }, function (erreur) {
          //reinitialiser le formulaire
          _this9.resetForm("formDemarrer");
          _this9.loading = false;
          _this9.$message.error("L'opération a echouée");
        });
      } // verifie champs date
      else {
          this.$message.error("Veuillez remplir correctement la date et l'heure svp...");
        }
    },


    //Liste ouvrier
    showOuvrier: function showOuvrier(tache) {
      this.showSelTache = false;
      this.tacheSel = tache;
      this.showSelTache = true;
    },


    //image projet
    onFileProjPicked: function onFileProjPicked(event) {
      var _this10 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this10.imageProjet = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.fichierProj.push(files[0]);
    },


    //TACHES TRAVAUX
    showModalTache: function showModalTache(trx) {
      this.detailTravaux = trx;
      this.showDetailTache = true;
    },

    //DASHBOARD PROJET
    modalDashboardProjet: function modalDashboardProjet(item) {
      this.detailProjet = item;
      this.showDetailProjet = true;
    },

    //DASHBOARD CHANTIER
    modalDashboardChantier: function modalDashboardChantier(item) {
      this.detailChantier = item;
      this.showDetailChantier = true;
    },


    //CHARGEMENT DES MARQUEURS DE LA CARTE
    loadMarqueurProjet: function loadMarqueurProjet() {
      var _this11 = this;

      this.loading = true;
      var url = this.domaine + "projet/index";
      this.$http.get(url).then(function (response) {
        _this11.loading = false;
        var items = response.body.projet;
        for (var i = 0; i < items.length; i++) {
          _this11.dataMarqueurProj.push({
            lat: items[i].lat,
            lng: items[i].lng,
            evolutionNbr: items[i].evolutionNbr,
            dateD: items[i].dateD,
            dateF: items[i].dateF,
            adresse: items[i].adresse,
            couleurMarker: items[i].couleurMarker,
            libelle: items[i].libelle,
            urlImage: items[i].urlImage,
            mntMarche: items[i].mntMarche,
            montantTotalDepenseNbr: items[i].montantTotalDepenseNbr,
            marge: items[i].marge
          });
        }
      }, function (response) {
        _this11.loading = false;
        _this11.$message.error("erreur lors du chargement des coordonnees des projets");
      });
    },

    //Controlle de l'activation du boutton deroulez
    activationDerouler: function activationDerouler() {
      this.activDerouler ? this.activDerouler = false : this.activDerouler = true;
    },
    statsAllProjet: function statsAllProjet() {
      var _this12 = this;

      this.loading = true;
      var url = this.domaine + "projet/stats/all/projet";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this12.statsGeneralAll = response.body.pie;
          _this12.statsMontantAll = response.body.piemontant;
          _this12.statsCommandeAll = response.body.piecom;
          _this12.statEtatGeneralAll();
          _this12.statEtatMontantAll();
          _this12.statEtatCommandeAll();
          _this12.loading = false;
        }
      });
    },
    statEtatGeneralAll: function statEtatGeneralAll() {
      var option = {
        title: {
          text: this.statsGeneralAll.libelle,
          subtext: this.statsGeneralAll.libelleSub,
          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["EN ATTENTE", "EN COURS", "TERMINE"]
        },
        series: [{
          name: this.statsGeneralAll.libelleSub,
          type: "pie",
          radius: "55%",
          center: ["50%", "60%"],
          data: [{ value: this.statsGeneralAll.enAttente, name: "EN ATTENTE" }, { value: this.statsGeneralAll.enCours, name: "EN COURS" }, { value: this.statsGeneralAll.termine, name: "TERMINE" }],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      };

      var chartEtatGeneralAll = echarts.init(document.getElementById("chartEtatGeneralAll"));
      chartEtatGeneralAll.setOption(option);
    },
    statEtatMontantAll: function statEtatMontantAll() {
      var option = {
        title: {
          text: this.statsMontantAll.libelle,
          subtext: this.statsMontantAll.libelleSub,
          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["MAIN D'OEUVRE", "COMMANDE", "MISSION"]
        },
        series: [{
          name: this.statsMontantAll.libelleSub,
          type: "pie",
          radius: "55%",
          center: ["50%", "60%"],
          data: [{ value: this.statsMontantAll.mainOuvre, name: "MAIN D'OEUVRE" }, { value: this.statsMontantAll.commande, name: "COMMANDE" }, { value: this.statsMontantAll.mission, name: "MISSION" }],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      };

      var chartEtatMontantAll = echarts.init(document.getElementById("chartEtatMontantAll"));
      chartEtatMontantAll.setOption(option);
    },
    statEtatCommandeAll: function statEtatCommandeAll() {
      var optionCom = {
        title: {
          text: this.statsCommandeAll.libelle,
          subtext: this.statsCommandeAll.libelleSub,
          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["NON LIVRE", "LIVRE"]
        },
        series: [{
          name: this.statsCommandeAll.libelleSub,
          type: "pie",
          radius: "55%",
          center: ["50%", "60%"],
          data: [{ value: this.statsCommandeAll.nonLivre, name: "NON LIVRE" }, { value: this.statsCommandeAll.livre, name: "LIVRE" }],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      };

      var chartEtatCommandeAll = echarts.init(document.getElementById("chartEtatCommandeAll"));
      chartEtatCommandeAll.setOption(optionCom);
    },
    statEtatGeneral: function statEtatGeneral() {
      var option = {
        title: {
          text: this.searchResultEtat.libelle,
          subtext: this.searchResultEtat.libelleSub,
          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["EN ATTENTE", "EN COURS", "TERMINE"]
        },
        series: [{
          name: this.searchResultEtat.libelleSub,
          type: "pie",
          radius: "55%",
          center: ["50%", "60%"],
          data: [{ value: this.searchResultEtat.enAttente, name: "EN ATTENTE" }, { value: this.searchResultEtat.enCours, name: "EN COURS" }, { value: this.searchResultEtat.termine, name: "TERMINE" }],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      };

      var chartEtatGeneral = echarts.init(document.getElementById("chartEtatGeneral"));
      chartEtatGeneral.setOption(option);
    },
    statEtatMontant: function statEtatMontant() {
      var option = {
        title: {
          text: this.searchResultEtatMontant.libelle,
          subtext: this.searchResultEtatMontant.libelleSub,
          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["MAIN D'OEUVRE", "COMMANDE", "MISSION"]
        },
        series: [{
          name: this.searchResultEtatMontant.libelleSub,
          type: "pie",
          radius: "55%",
          center: ["50%", "60%"],
          data: [{
            value: this.searchResultEtatMontant.mainOuvre,
            name: "MAIN D'OEUVRE"
          }, {
            value: this.searchResultEtatMontant.commande,
            name: "COMMANDE"
          }, { value: this.searchResultEtatMontant.mission, name: "MISSION" }],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      };

      var chartEtatMontant = echarts.init(document.getElementById("chartEtatMontant"));
      chartEtatMontant.setOption(option);
    },
    statEtatCommande: function statEtatCommande() {
      var optionCom = {
        title: {
          text: this.searchResultEtatCommande.libelle,
          subtext: this.searchResultEtatCommande.libelleSub,
          x: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["NON LIVRE", "LIVRE"]
        },
        series: [{
          name: this.searchResultEtatCommande.libelleSub,
          type: "pie",
          radius: "55%",
          center: ["50%", "60%"],
          data: [{
            value: this.searchResultEtatCommande.nonLivre,
            name: "NON LIVRE"
          }, { value: this.searchResultEtatCommande.livre, name: "LIVRE" }],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)"
            }
          }
        }]
      };

      var chartEtatCommande = echarts.init(document.getElementById("chartEtatCommande"));
      chartEtatCommande.setOption(optionCom);
    },
    submitformManoeuvre: function submitformManoeuvre(formName) {
      var _this13 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this13.loading = true;
          // enregistrement des ouvriers
          var url = _this13.domaine + "ouvrier/new";
          var form = document.getElementById("formManoeuvre");
          var data = new FormData(form);
          data.append("nom", _this13.formManoeuvre.nom);
          data.append("domicile", _this13.formManoeuvre.domicile);
          data.append("profession", _this13.formManoeuvre.profession);
          data.append("piece", _this13.formManoeuvre.piece);
          data.append("contact", _this13.formManoeuvre.contact);
          data.append("numPiece", _this13.formManoeuvre.numPiece);
          data.append("dateNaiss", _this13.formManoeuvre.dateNaiss);
          _this13.$http.post(url, data).then(function (response) {
            _this13.loadOuvrier();
            _this13.loading = false;
            _this13.dialogAjoutOuvrier = false;

            _this13.$message({
              message: "L'enregistrement sest deroule avec succes ",
              type: "success"
            });
          }, function (response) {
            _this13.loading = false;
            _this13.$message.error("Erreur lors de l'enregistrement d'un manoeuvre ");
          });
        }
      });
    },
    showDialogAjoutOuvrier: function showDialogAjoutOuvrier() {
      this.dialogAjoutOuvrier = true;
      this.formManoeuvre.nom = "";
      this.formManoeuvre.domicile = "";
      this.formManoeuvre.profession = "";
      this.formManoeuvre.contact = "";
      this.formManoeuvre.piece = "";
      this.formManoeuvre.numPiece = "";
      this.formManoeuvre.dateNaiss = "";
      this.logoOuvrier = "/static/img-doc.png";
      this.optionE.selectType = "";
      this.optionE.fournisseur = "";
      this.optionE.ouvrier = "";
      this.optionE.duree = "";
      this.optionE.montant = "";
      this.optionE.montantSupp = "";
    },
    querySearchOuvrier: function querySearchOuvrier(queryString, cb) {
      var links = this.listOuvrier;
      var results = queryString ? links.filter(this.createFilterOuvrier(queryString)) : links;
      // call callback function to return suggestions
      cb(results);
    },
    isValidDateTrx: function isValidDateTrx() {
      if (this.idChantMod != null) {
        return false;
      }

      if (this.chantierCourant.dateD != null && this.chantierCourant.dateF != null) {
        var tabDateDbt = this.chantierCourant.dateD.split("-"); //["16","08","2018 00:00:00"]
        var jr = tabDateDbt[0];
        var mois = tabDateDbt[1];
        var annee = tabDateDbt[2].split(" ")[0];
        var hr = tabDateDbt[2].split(" ")[1];
        var dateDbt = annee + "-" + mois + "-" + jr + "T" + hr;
        var dateChtDbt = new Date(dateDbt);
        var tabDateFin = this.chantierCourant.dateF.split("-");
        var jrF = tabDateFin[0];
        var moisF = tabDateFin[1];
        var anneeF = tabDateFin[2].split(" ")[0];
        var hrF = tabDateFin[2].split(" ")[1];
        var dateFin = anneeF + "-" + moisF + "-" + jrF + "T" + hrF;
        var dateChtFin = new Date(dateFin);

        if (this.selectTravaux != "" && this.selectChefTravaux != "" && this.dateD != null && this.dateF != null && this.dateF <= dateChtFin && this.dateF >= dateChtDbt && this.dateD <= dateChtFin && this.dateD >= dateChtDbt && this.dateF >= this.dateD) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    loadGanttParam: function loadGanttParam() {
      var _this14 = this;

      //planning de gantt
      gantt.config.fit_tasks = true;
      gantt.config.readonly = true;
      gantt.attachEvent("onTaskSelected", function (id) {
        var task = gantt.getTask(id);
        _this14.$emit("task-selected", task);
      });

      gantt.config.scale_unit = "month";
      gantt.config.date_scale = "%F, %Y";

      //default columns definition
      gantt.config.columns = [{ name: "text", label: "Projet", width: "*", tree: true }, { name: "start_date", label: "Date initiale", align: "center" }, { name: "duration", label: "Durée", align: "center" }];

      //langue
      gantt.locale = {
        date: {
          month_full: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
          month_short: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aôu", "Sep", "Oct", "Nov", "Déc"],
          day_full: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
          day_short: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"]
        },
        labels: {
          new_task: "Tâche neuve",
          icon_save: "Enregistrer",
          icon_cancel: "Annuler",
          icon_details: "Détails",
          icon_edit: "Modifier",
          icon_delete: "Effacer",
          confirm_closing: "", //Vos modifications seront perdus, êtes-vous sûr ?
          confirm_deleting: "L'événement sera effacé sans appel, êtes-vous sûr ?",

          section_description: "Description",
          section_time: "Période",
          section_type: "Type",

          /* grid columns */
          column_text: "Tâche neuve",
          column_start_date: "Date initiale",
          column_duration: "Durée",
          column_add: "",

          /* link confirmation */
          confirm_link_deleting: "seront supprimées",
          link_start: "(début)",
          link_end: "(fin)",

          type_task: "Task",
          type_project: "Project",
          type_milestone: "Milestone",

          minutes: "Minutes",
          hours: "Heures",
          days: "Jours",
          weeks: "Semaine",
          months: "Mois",
          years: "Années"
        }
      };
      gantt.init(this.$refs.gantt);
      gantt.clearAll();
      gantt.parse(this.tasks);
    },
    loadPage: function loadPage() {
      this.loading = true;
    },
    showPlanning: function showPlanning(idChantier) {
      this.loadPlanning(idChantier);
    },
    loadPlanning: function loadPlanning(idChantier) {
      var _this15 = this;

      this.loading = true;
      var url = this.domaine + "chantier/planning/" + idChantier;
      this.$http.get(url).then(function (response) {
        _this15.libProjet = response.body.libProjet;
        _this15.chefProjet = response.body.chefProjet;
        _this15.libChantier = response.body.libChantier;
        _this15.chefChantier = response.body.chefChantier;
        _this15.tasks.data.splice(0);

        if (response.body.data != undefined && response.body.data.length > 0) {
          var _tasks$data, _tasks$links;

          var data = response.body.data;
          (_tasks$data = _this15.tasks.data).push.apply(_tasks$data, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data));
          var tabTrx = [];
          var link = response.body.data.map(function (elt) {
            if (elt.start_date == undefined) {
              tabTrx.push(elt.id);
              if (tabTrx[tabTrx.length - 2] != undefined) {
                var idPrec = tabTrx[tabTrx.length - 2];
                var idlast = tabTrx[tabTrx.length - 1];
                return {
                  id: elt.id,
                  source: idPrec,
                  target: idlast,
                  type: "1"
                };
              }
              return {};
            } else {
              return {
                id: elt.id,
                source: elt.id,
                target: elt.id + 1,
                type: "1"
              };
            }
          });

          (_tasks$links = _this15.tasks.links).push.apply(_tasks$links, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(link));
          _this15.loading = false;
        } else {
          _this15.tasks.data.splice(0);
          _this15.loading = false;
        }

        _this15.$router.push({
          name: "Planning",
          params: {
            id: idChantier,
            libProjet: _this15.libProjet,
            chefProjet: _this15.chefProjet,
            libChantier: _this15.libChantier,
            chefChantier: _this15.chefChantier,
            tasks: _this15.tasks
          }
        });
      }, function (response) {
        _this15.loading = false;
        _this15.$message.error("erreur lors du chargement des travaux");
      });
    },
    loadPlanningProjet: function loadPlanningProjet(ligne) {
      var _this16 = this;

      this.loading = true;
      var url = this.domaine + "projet/planning/" + ligne.id;
      this.$http.get(url).then(function (response) {
        _this16.tasks.data.splice(0);
        _this16.tasks.links.splice(0);
        if (response.body.data !== undefined && response.body.data.length > 0) {
          var _tasks$data2, _tasks$links2;

          var data = response.body.data;
          (_tasks$data2 = _this16.tasks.data).push.apply(_tasks$data2, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data));
          var tabTrx = [];
          var link = response.body.data.map(function (elt) {
            if (elt.start_date === undefined) {
              tabTrx.push(elt.id);
              if (tabTrx[tabTrx.length - 2] !== undefined) {
                var idPrec = tabTrx[tabTrx.length - 2];
                var idlast = tabTrx[tabTrx.length - 1];
                return {
                  id: elt.id,
                  source: idPrec,
                  target: idlast,
                  type: "1"
                };
              }
              return {};
            } else {
              return {
                id: elt.id,
                source: elt.id,
                target: elt.id + 1,
                type: "1"
              };
            }
          });

          (_tasks$links2 = _this16.tasks.links).push.apply(_tasks$links2, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(link));
          //this.loadGanttParam()
          _this16.loading = false;
        } else {
          _this16.tasks.data.splice(0);
          _this16.tasks.links.splice(0);
          _this16.loading = false;
        }
      }, function (response) {
        _this16.loading = false;
        _this16.$message.error("erreur lors du chargement des chantiers");
      });
    },
    loadUser: function loadUser() {
      var _this17 = this;

      this.loading = true;
      var url = this.domaine + "userCreate/user-list";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this17.users = response.body;
          _this17.loading = false;
        }
      });
    },
    loadUniteProduit: function loadUniteProduit(item) {
      var valeur = void 0;
      this.valeurUniteMateriel = '';
      valeur = this.listProd.find(function (element) {
        if (element.id == item) {
          return element.unite;
        }
      });
      this.valeurUniteMateriel = valeur.unite;
    },
    loadTypeProduit: function loadTypeProduit(item) {
      var _this18 = this;

      if (this.prodSelct == "" && item == '') {
        return;
      }
      this.loading = true;
      var url = this.domaine + "product/productSelect/type/" + item;
      this.$http.get(url).then(function (response) {
        _this18.loading = false;
        _this18.listProd = response.body.produits;
      }, function (errRep) {
        _this18.loading = false;
        _this18.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    loadPrestaire: function loadPrestaire() {
      var _this19 = this;

      this.loading = true;
      var url = this.domaine + "fournisseur/listePrestataire/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this19.listPrestataire = response.body.prestataire;
          _this19.loading = false;
        }
      });
    },
    loadClient: function loadClient() {
      var _this20 = this;

      this.loading = true;
      var url = this.domaine + "client/projet/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this20.listClient = response.body.client;
          _this20.loading = false;
        }
      });
    },
    onFileImageChantPicked: function onFileImageChantPicked(event) {
      var _this21 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this21.logoChantier = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoChantier = files[0];
    },
    onFileImageLogoPicked: function onFileImageLogoPicked(event) {
      var _this22 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this22.logoProjet = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoProjet = files[0];
    },
    onFileImageOuvrierPicked: function onFileImageOuvrierPicked(event) {
      var _this23 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this23.logoOuvrier = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoOuvrier = files[0];
    },
    loadProduit: function loadProduit(queryString, cb) {
      var _this24 = this;

      var url = this.domaine + "product/product-list";
      var formdata = new FormData();
      formdata.append("user", this.user.id);
      formdata.append("tag", queryString);
      this.$http.post(url, formdata).then(function (response) {
        if (response.body) {
          _this24.listProd = response.body;
          var links = response.body;
          var results = queryString ? links.filter(_this24.createFilter(queryString)) : links;
          cb(results);
        }
      }, function (response) {});
    },
    loadProduitPlan: function loadProduitPlan() {
      var _this25 = this;

      this.loading = true;
      var url = this.domaine + "product/product-list/type";
      var formdata = new FormData();
      formdata.append("user", this.user.id);
      this.$http.post(url, formdata).then(function (response) {
        if (response.body) {
          _this25.loading = false;
          _this25.listProdPlan = response.body.produits;
          _this25.listVehPlan = response.body.vehicules;
        }
      }, function (response) {
        _this25.loading = false;
      });
    },
    loadProdVehicule: function loadProdVehicule(queryString, cb) {
      var _this26 = this;

      var url = this.domaine + "product/productVehicule-list";
      var formdata = new FormData();
      formdata.append("user", this.user.id);
      formdata.append("tag", queryString);
      this.$http.post(url, formdata).then(function (response) {
        if (response.body) {
          _this26.listProd = response.body;
          var links = response.body;
          var results = queryString ? links.filter(_this26.createFilter(queryString)) : links;
          cb(results);
        }
      }, function (response) {});
    },
    loadCaisse: function loadCaisse() {
      var _this27 = this;

      var url = this.domaine + "caisse/caisse_banque_projet";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this27.listCaisse = response.body.listeCaisse;
          _this27.listBanque = response.body.listeBanque;
        }
      });
    },
    loadOuvrier: function loadOuvrier() {
      var _this28 = this;

      var url = this.domaine + "ouvrier/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this28.listOuvrier = response.body.ouvrier;
        }
      });
    },
    loadOuvrierSelect: function loadOuvrierSelect(queryString, cb) {
      var _this29 = this;

      var url = this.domaine + "ouvrier/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this29.listOuvrier = response.body.ouvrier;

          var links = response.body.ouvrier;
          var results = queryString ? links.filter(_this29.createFilter(queryString)) : links;
          cb(results);
        }
      });
    },
    loadTypeProjet: function loadTypeProjet() {
      var _this30 = this;

      var url = this.domaine + "projet/index/type/projet";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this30.listTypeProjet = response.body.type;
        }
      });
    },
    generateFileExcel: function generateFileExcel() {
      this.dialogImport = false;
      var url = this.domaine + "projet/generer/planification/modele";
      window.open(url);
    },
    onFileExcelPicked: function onFileExcelPicked(event) {
      var _this31 = this;

      this.fileExcel.splice(0, 1);
      // this.dialogAjoutBudget = false
      this.loading = true;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this31.fileExcel.push(fileReader.result);
      });
      fileReader.readAsDataURL(files[0]);

      var url = this.domaine + "projet/loadPreparation/excel";
      var data = new FormData();
      data.append("fichierExcel", files[0], files[0][name]);
      this.$http.post(url, data).then(function (resp) {
        _this31.loading = false;
        _this31.$notify({
          title: "Chargement liste des ressources à importer",
          message: "Chargement effectué",
          type: "success",
          position: "top-right",
          duration: 7000
        });
        // this.showModalLoadPreparation = true;
        _this31.loading = false;
        _this31.tabListProduit = resp.body.listePreration;
      }, function (error) {
        _this31.loading = false;
        _this31.$message.error("Erreur lors de l'importation du fichier");
      });
    },
    saveListe: function saveListe() {
      var _this32 = this;

      // this.loadPage()
      var etatVeh = false;
      this.loading = true;
      var succesEnreg = true;
      var url = this.domaine + "projet/save/preparation/excel/" + this.tacheCourante.id;
      var nbData = 10;
      var nbReq = 1;
      var ligne = null;

      var nbRest = void 0;
      if (this.tabListProduit.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.tabListProduit.length / nbData);
        nbRest = this.tabListProduit.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (var i = 0; i < nbReq; i++) {
        var initJ = i * nbData;
        var finJ = (i + 1) * nbData;
        var dataLot = [];
        if (this.tabListProduit.length > 0) {
          for (var j = initJ; j < finJ; j++) {
            if (this.tabListProduit[j] == undefined) {
              break;
            }
            dataLot.push(this.tabListProduit[j]);
          }
        }
        var data = new FormData();
        for (var prop in dataLot) {
          ligne = dataLot[prop];
          data.append("option[id][]", ligne.id);
          data.append("option[produit][]", ligne.libelle);
          data.append("option[quantite][]", ligne.quantite);
          data.append("option[priorite][]", ligne.priorite);
        }

        for (var _prop in this.tabListEngin) {
          var _ligne = this.tabListEngin[_prop];
          if (_ligne.value != "" && _ligne.qte != 0 && _ligne.periode != "") {
            //etatVeh = true;
            data.append("optionVeh[vehicule][]", _ligne.id);
            data.append("optionVeh[qte][]", _ligne.quantite);
            data.append("optionVeh[priotite][]", _ligne.priorite);
            data.append("optionVeh[date][]", _ligne.periode);
          } else {
            etatVeh = false;
          }
        }

        data.append('idUser', this.user.id);
        data.append('idTypeTravaux', this.tacheCourante.idTypeTravaux);
        data.append('travaux', this.tacheCourante.idTrx);
        data.append('tache', this.tacheS);

        this.$http.post(url, data).then(function (resp) {
          _this32.showModalLoadPreparation = false;
          _this32.dialogPlanifProduit = false;
          _this32.loading = false;
          succesEnreg = false;
          _this32.$notify({
            title: "Enregistrement",
            message: "La liste a ete enregistre avec succes",
            type: "success",
            position: "top-right",
            duration: 7000 });

          // if(resp.code === 0 || resp.code === 2) {
          //     succesEnreg = false                          
          //     this.$notify({
          //     title: "Enregistrement",
          //     message: "La liste a ete enregistre avec succes",
          //     type: "success",
          //     position: "top-right",
          //     duration: 7000
          // });
          // }else {
          //     succesEnreg = false                          
          //     this.$notify({
          //     title: "Erreur",
          //     message: resp.message,
          //     type: "info",
          //     position: "top-right",
          //     duration: 7000
          // });
          // }                      
        }, function (error) {
          _this32.loading = false;
          succesEnreg = false;
          _this32.$message.error("Erreur lors de l'enregistrement des types travaux");
        });
      }
    },
    loadTache: function loadTache() {
      var _this33 = this;

      this.loading = true;
      this.optionTache = [];
      this.listeSousTache = [];
      this.readBtdTrx = false;
      if (this.selectTravaux != "") {
        var item = this.listTravauxProjet.find(function (elt) {
          return elt.id == _this33.selectTravaux;
        });
        if (item.nbSection != 0) {
          var url = this.domaine + "projet/typeSousTravaux/" + this.selectTravaux + '/' + this.chantierCourant.id;
          this.$http.get(url).then(function (response) {
            if (response.body) {
              _this33.readBtdTrx = true;
              _this33.disabledBtnContTrx = true;
              _this33.listeSousTache = response.body.sousTravaux;
              if (_this33.listeSousTache.length == 0) {
                _this33.disabledBtnContTrx = false;
                _this33.$notify({
                  title: "ATTENTION",
                  message: "Veuillez renseigner les taches de cet lot avant de continué.",
                  type: "warning"
                });
                _this33.loading = false;
              }
              // this.calculMntTache();
              _this33.loading = false;
            }
          });
        } else {

          this.selectSousTravaux = '';
          this.disabledBtnContTrx = true;
          var _url = this.domaine + "projet/" + this.selectTravaux + "/index/tache";
          this.$http.get(_url).then(function (response) {
            if (response.body) {
              _this33.optionTache = response.body.tache;
              if (_this33.optionTache.length == 0) {
                _this33.disabledBtnContTrx = false;
                _this33.$notify({
                  title: "ATTENTION",
                  message: "Veuillez renseigner les taches de cet lot avant de continué.",
                  type: "warning"
                });
                _this33.loading = false;
              }
              _this33.calculMntTache();
              _this33.loading = false;
            }
          });
        }
      } else {
        this.$notify({
          title: "ATTENTION",
          message: "Veuillez sélectionner des travaux.",
          type: "warning"
        });
        this.loading = false;
      }
    },
    loadSousTache: function loadSousTache(item) {
      var _this34 = this;

      this.loading = true;
      this.optionTache = [];
      if (this.selectTravaux != "") {
        var trav = this.travauxCourant.id ? this.travauxCourant.id : null;
        var url = this.domaine + "projet/sousTache/" + item + '/' + trav + '/' + 0 + "/index/tache";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this34.optionTache = response.body.tache;
            _this34.calculMntTache();
            _this34.loading = false;
          }
        });
      } else {
        this.$notify({
          title: "ATTENTION",
          message: "Veuillez sélectionner des travaux.",
          type: "warning"
        });
        this.loading = false;
      }
    },
    loadTacheParTravaux: function loadTacheParTravaux() {
      var _this35 = this;

      this.loading = true;
      this.optionTache = [];
      if (this.selectTravaux != "") {
        var url = '';
        if (this.travauxCourant.sousLibelle != '') {
          url = this.domaine + "projet/sousTache/" + this.selectTravaux + '/' + this.travauxCourant.id + '/' + 1 + "/index/tache";
        } else {
          url = this.domaine + "projet/travaux_tache/" + this.travauxCourant.id + "/index/tache";
        }

        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this35.optionTache = response.body.tache;
            _this35.calculMntTache();
            _this35.loading = false;
          }
        });
      } else {
        this.$notify({
          title: "ATTENTION",
          message: "Veuillez sélectionner des travaux.",
          type: "warning"
        });
        this.loading = false;
      }
    },
    loadTravaux: function loadTravaux() {
      var _this36 = this;

      this.loading = true;
      this.selectSearchTravaux = "";
      this.listTravaux = [];

      if (this.selectSearchChantier !== "") {
        var url = this.domaine + "projet/" + this.selectSearchChantier + "/index/chantier/travaux";
        this.$http.get(url).then(function (response) {
          _this36.listTravaux = response.body.travaux;
          _this36.loading = false;
        });
      } else {
        this.$message.error("Veuillez sélectionner un chantier");
        this.loading = false;
      }
    },
    loadTravauxSuivi: function loadTravauxSuivi() {
      var _this37 = this;

      if (this.selectSearchChantierSuivi !== "" || this.selectSearchChantier !== "" || this.selectChantierRapport !== "") {
        this.loading = true;
        this.selectSearchTravauxSuivi = "";
        this.selectTravauxRapport = "";
        this.listTravaux = [];
        this.listTacheRapport = [];
        var idChantierSearch = "";
        if (this.selectSearchChantierSuivi !== "") {
          this.selectSearchChantier = "";
          this.selectChantierRapport;
          idChantierSearch = this.selectSearchChantierSuivi;
        } else if (this.selectSearchChantier !== "") {
          this.selectSearchChantierSuivi = "";
          this.selectChantierRapport;
          idChantierSearch = this.selectSearchChantier;
        } else if (this.selectChantierRapport !== "") {
          this.selectSearchChantierSuivi = "";
          this.selectSearchChantier = "";
          idChantierSearch = this.selectChantierRapport;
        }

        if (this.idChantierSearch !== "") {
          var url = this.domaine + "projet/" + idChantierSearch + "/index/chantier/travaux";
          this.$http.get(url).then(function (response) {
            _this37.listTravaux = response.body.travaux;
            _this37.loading = false;
          });
        } else {
          this.$message.error("Veuillez sélectionner un chantier");
          this.loading = false;
        }
      }
    },
    loadTravauxSearch: function loadTravauxSearch() {
      var _this38 = this;

      this.loading = true;
      this.selectSearchChantierFind = "";
      this.listChantierResult = [];
      this.listTravauxResult = [];
      if (this.$refs.formSearchPlanif.validate() && this.selectSearchTravaux != "") {
        var url = this.domaine + "projet/index/travaux/result";
        var form = document.getElementById("formSearchPlanif");
        var data = new FormData(form);
        data.append("id", this.selectSearchTravaux);
        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            _this38.listTravauxResult = response.body.travaux;
            _this38.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner les travaux");
        this.loading = false;
      }
    },
    loadTravauxSuivie: function loadTravauxSuivie() {
      var _this39 = this;

      this.loading = true;
      this.selectSearchChantierFindSuivi = "";
      this.listChantierSuivie = [];
      this.listTravauxSuivie = [];
      this.listTravauxRow = [];
      this.listTachesRow = [];
      this.listCommandesRow = [];
      this.listRessourcesRow = [];
      this.optionRapport = [];
      var idTravauxResult = "";
      if (this.selectSearchTravauxSuivi !== "") {
        this.selectTravauxRapport = "";
        idTravauxResult = this.selectSearchTravauxSuivi;
      } else if (this.selectTravauxRapport !== "") {
        this.selectSearchTravauxSuivi = "";
        idTravauxResult = this.selectTravauxRapport;
      }
      if (this.$refs.formSearchPlanifSuivi.validate() && idTravauxResult != "") {
        var url = this.domaine + "projet/" + idTravauxResult + "/index/travaux/suivi";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            var msg = "";
            var typeN = "";
            _this39.listTravauxSuivie = response.body.travaux;
            _this39.optionRapport = response.body.tache;
            if (_this39.listTravauxSuivie === undefined || _this39.listTravauxSuivie.length == 0) {
              _this39.disabledBtnCP = true;
            } else {
              _this39.disabledBtnCP = false;
            }

            if (_this39.optionRapport.length == 0) {
              _this39.$notify({
                title: "RESULTATS",
                message: "Aucune tâche en cours d'execution ou démarré n'a été retrouvé pour ces travaux.",
                type: "warning",
                position: "top-center"
              });
            } else if (_this39.optionRapport.length > 0) {
              _this39.$notify({
                title: "RESULTATS",
                message: _this39.optionRapport.length + " tâche(s) trouvée(s).",
                type: "success",
                position: "top-center"
              });
            }

            _this39.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner les travaux.");
        this.loading = false;
      }
    },
    loadTravauxProjet: function loadTravauxProjet(item //charge le types de travaux lie au chantier ou au projet
    ) {
      var _this40 = this;

      this.loading = true;
      this.projetCourant = item;
      var url = this.domaine + "projet/" + this.projetCourant.id + "/index/travaux/projet";

      if (this.projetCourant.type != null) {
        url = this.domaine + "projet/" + this.projetCourant.id + "/index/travaux/projet";
      } else {
        url = this.domaine + "chantier/" + this.chantierCourant.id + "/typeTravaux";
      }

      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this40.listTravauxProjet = response.body.travaux;
          _this40.loading = false;
        }
      }, function (response) {});
    },
    loadTravauxChantier: function loadTravauxChantier(item) {
      var _this41 = this;

      this.loading = true;
      this.chantierCourant = item;
      var url = "";
      if (this.chantierCourant.typeChantier != null) {
        url = this.domaine + "chantier/" + this.chantierCourant.idChantier + "/typeTravaux";
      } else {
        url = this.domaine + "projet/typetrx/chantier/" + this.chantierCourant.idChantier;
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this41.listTravauxProjet = response.body.travaux;
          _this41.loading = false;
        }
      }, function (response) {});
    },
    loadEditTravaux: function loadEditTravaux(idChantier) {
      var _this42 = this;

      this.loading = true;
      var url = this.domaine + "projet/typetrx/all/chantier/" + idChantier;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this42.listTravauxProjet = response.body.travaux;
          _this42.loading = false;
        }
      }, function (response) {});
    },
    loadProjetAll: function loadProjetAll() {
      var _this43 = this;

      this.loading = true;
      var url = "";
      if (this.droitAcces.projet_all_index) {
        //vérification pour un user
        url = this.domaine + "projet/index-projet-all";
      } else if (this.droitAcces.projet_index) {
        url = this.domaine + "projet/index";
      } else if (this.droitAcces.projet_index_chefProjet) {
        //vérification pour le chef de projet
        url = this.domaine + "projet/" + this.user.id + "/chefProjet/index";
      } else if (this.droitAcces.projet_index_chefEtude) {
        //vérification pour le chef d'Etude
        url = this.domaine + "projet/" + this.user.id + "/chefEtude/index";
      } else if (this.droitAcces.projet_index_chefControle) {
        //vérification pour le chef d'Etude
        url = this.domaine + "projet/" + this.user.id + "/chefControle/index";
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this43.items = response.body.projet;
          _this43.loading = false;
        }
      });
    },
    loadProjet: function loadProjet() {
      var _this44 = this;

      this.loading = true;
      this.listProjetResult = [];
      if (this.$refs.formSearchProjet.validate()) {
        var url = "";
        if (this.droitAcces.projet_index) {
          url = this.domaine + "projet/index";
        } else if (this.droitAcces.projet_index_chefProjet) {
          //vérification pour le chef de projet
          url = this.domaine + "projet/" + this.user.id + "/chefProjet/index";
        } else if (this.droitAcces.projet_index_chefEtude) {
          //vérification pour le chef d'Etude
          url = this.domaine + "projet/" + this.user.id + "/chefEtude/index";
        } else if (this.droitAcces.projet_index_chefControle) {
          //vérification pour le chef d'Etude
          url = this.domaine + "projet/" + this.user.id + "/chefControle/index";
        }

        var form = document.getElementById("formSearchProjet");
        var data = new FormData(form);
        data.append("id", this.selectSearchProjet);
        this.$http.post(url, data).then(function (response) {
          _this44.loading = false;
          if (response.body.projet.length > 0) {
            _this44.listProjetResult = response.body.projet;
            _this44.nbChantier = response.body.projet[0].nbChantier;

            if (_this44.notif === "active" && response.body.progression === false) {
              _this44.$vs.notify({
                title: "PROGRESSION",
                text: "Les progressions journalières des différentes tâches attendent",
                type: "warning",
                position: "top-right",
                icon: "timeline",
                duration: 5000
              });
            }

            if (_this44.notif === "active" && response.body.rapport === true) {
              _this44.$vs.notify({
                title: "RAPPORT",
                text: "Les rapports journaliers des différentes tâches attendent",
                color: "danger",
                position: "top-right",
                icon: "description",
                duration: 5000
              });
            }

            _this44.loading = false;
          }
        });
      }
    },
    loadListeProjet: function loadListeProjet() {
      var _this45 = this;

      this.loading = true;
      this.listProjetResult = [];
      if (this.$refs.formSearchProjet.validate()) {
        var url = "";
        if (this.droitAcces.projet_all_index) {
          //vérification pour un user
          url = this.domaine + "projet/index-projet-all";
        } else if (this.droitAcces.projet_index_chefProjet) {
          //vérification pour le chef de projet
          url = this.domaine + "projet/" + this.user.id + "/chefProjet/index";
        } else if (this.droitAcces.projet_index_user) {
          //vérification pour un user
          url = this.domaine + "projet/" + this.user.id + "/index";
        } else if (this.droitAcces.projet_index) {
          url = this.domaine + "projet/index";
        } else if (this.droitAcces.projet_index_chefEtude) {
          //vérification pour le chef d'Etude
          url = this.domaine + "projet/" + this.user.id + "/chefEtude/index";
        } else if (this.droitAcces.projet_index_chefControle) {
          //vérification pour le chef d'Etude
          url = this.domaine + "projet/" + this.user.id + "/chefControle/index";
        }

        var form = document.getElementById("formSearchProjet");
        var data = new FormData(form);
        data.append("id", this.selectSearchProjet);
        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            _this45.loading = false;
            _this45.items = response.body.projet;
            if (_this45.notif === "active" && response.body.progression === false) {
              _this45.$vs.notify({
                title: "PROGRESSION",
                text: "Les progressions journalières des différentes tâches attendent",
                type: "warning",
                position: "top-right",
                icon: "timeline",
                duration: 5000
              });
            }
            if (_this45.notif = "active" && response.body.rapport === true) {
              _this45.$vs.notify({
                title: "RAPPORT",
                text: "Les rapports journalières des différentes tâches attendent",
                color: "danger",
                position: "top-right",
                icon: "description",
                duration: 5000
              });
            }
          }
        });
      }
    },
    loadChantier: function loadChantier(item) {
      var _this46 = this;

      this.loading = true;
      this.projetCourant = item;
      var url = this.domaine + "projet/" + this.projetCourant.id + "/index/chantier";
      var element = document.getElementById(this.mapName);
      var options = {
        zoom: 7.0,
        gestureHandling: "greedy",
        center: new google.maps.LatLng(this.projetCourant.latitude, this.projetCourant.longitude)
      };
      var map = new google.maps.Map(element, options);

      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this46.listChantier = response.body.chantier;
          if (_this46.listChantier === undefined || _this46.listChantier.length == 0) {
            _this46.disabledBtnCP = true;
          } else {
            _this46.disabledBtnCP = false;
          }

          for (var i = 0; i < _this46.listChantier.length; i++) {
            var marker = {
              lat: _this46.listChantier[i].latitude,
              lng: _this46.listChantier[i].longitude,
              lib: " <b style='font-weight: bold'>Adresse: </b>" + _this46.listChantier[i].adresse + " <br/>   <b style='font-weight: bold'>Projet: </b>" + _this46.listChantier[i].projet + "<br/> <b style='font-weight: bold'>Chantier: </b>" + _this46.listChantier[i].libelle + " <br/> <b style='font-weight: bold'>Date début: </b>" + _this46.listChantier[i].dateD + " <br/><b style='font-weight: bold'> Date de fin: </b>" + _this46.listChantier[i].dateF + " <br/><b style='font-weight: bold'> Etat d'avancement : </b> <b style='font-weight: bold; color:blue'>" + _this46.listChantier[i].evolutionNbr + " %</b> <br/> <b style='font-weight: bold'>Lat/Lng: </b>" + _this46.listChantier[i].latitude + "/" + _this46.listChantier[i].longitude,
              couleurMk: _this46.listChantier[i].couleurMarker
            };
            _this46.markers.push(marker);
          }

          //Ajout des markers
          _this46.markers.forEach(function (coord) {
            var position = new google.maps.LatLng(coord.lat, coord.lng);
            var libelle = coord.lib;
            var marker = new google.maps.Marker({
              position: position,
              map: map,
              icon: {
                path: "M256,0C153.755,0,70.573,83.182,70.573,185.426c0,126.888,165.939,313.167,173.004,321.035    c6.636,7.391,18.222,7.378,24.846,0c7.065-7.868,173.004-194.147,173.004-321.035C441.425,83.182,358.244,0,256,0z M256,278.719    c-51.442,0-93.292-41.851-93.292-93.293S204.559,92.134,256,92.134s93.291,41.851,93.291,93.293S307.441,278.719,256,278.719z",
                fillColor: coord.couleurMk,
                fillOpacity: 0.8,
                scale: 0.05,
                strokeColor: coord.couleurMk,
                strokeWeight: 1
              }
            });
            _this46.attachSecretMessage(marker, libelle);
          });
          _this46.loading = false;
        }
      });
    },
    loadChantierSearch: function loadChantierSearch() {
      var _this47 = this;

      this.loading = true;
      this.selectSearchChantier = "";
      this.listTravauxResult = [];
      this.listChantierResult = [];
      if (this.$refs.formSearchPlanif.validate() && this.selectSearchChantierFind != "") {
        var url = this.domaine + "projet/" + this.selectSearchChantierFind + "/index/chantier/search";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this47.listChantierResult = response.body.chantier;
            _this47.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner le chantier");
        this.loading = false;
      }
    },
    loadAffSupTravaux: function loadAffSupTravaux(item) {
      var _this48 = this;

      this.loading = true;
      this.selectSearchChantier = "";
      this.listTravauxResult = [];
      this.listChantierResult = [];
      var url = this.domaine + "projet/" + item + "/index/chantier/search";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this48.listChantierResult = response.body.chantier;
          _this48.loading = false;
        }
      });
    },
    loadChantierSuivie: function loadChantierSuivie() {
      var _this49 = this;

      this.loading = true;
      this.selectSearchChantierSuivi = "";
      this.listChantierSuivie = [];
      this.listTravauxSuivie = [];
      this.listTravauxRow = [];
      this.listTachesRow = [];
      this.listCommandesRow = [];
      this.listRessourcesRow = [];
      if (this.$refs.formSearchPlanifSuivi.validate() && this.selectSearchChantierFindSuivi != "") {
        var url = this.domaine + "projet/" + this.selectSearchChantierFindSuivi + "/index/chantier/suivi";
        this.$http.get(url).then(function (response) {
          _this49.loading = false;
          if (response.body) {
            _this49.loading = false;
            _this49.listChantierSuivie = response.body.chantier;
            if (_this49.listChantierSuivie === undefined || _this49.listChantierSuivie.length == 0) {
              _this49.disabledBtnCP = true;
            } else {
              _this49.disabledBtnCP = false;
            }
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner le chantier.");
        this.loading = false;
      }
    },
    loadEquipe: function loadEquipe(item) {
      var _this50 = this;

      this.loading = true;
      this.travauxCourant = item;
      var url = this.domaine + "projet/" + this.travauxCourant.id + "/index/equipe";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this50.listEquipe = response.body.equipe;
          _this50.loading = false;
        }
      });
    },
    loadProjetTache: function loadProjetTache(item) {
      var _this51 = this;

      this.loading = true;
      this.projetCourant = item;
      var url = this.domaine + "projet/" + this.projetCourant.id + "/index/projet/tache";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this51.listProjetTache = response.body.tache;
          if (_this51.listProjetTache === undefined || _this51.listProjetTache.length == 0) {
            _this51.disabledBtnSCTach = true;
          } else {
            _this51.disabledBtnSCTach = false;
          }
          _this51.loading = false;
        }
      });
    },
    loadProjetContrat: function loadProjetContrat(item) {
      var _this52 = this;

      this.projetCourant = item;
      var url = this.domaine + "projet/" + this.projetCourant.id + "/index/projet/contrat";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this52.listProjetContrat = response.body.contrat;
          if (_this52.listProjetContrat === undefined || _this52.listProjetContrat.length == 0) {
            _this52.disabledBtnSCont = true;
          } else {
            _this52.disabledBtnSCont = false;
          }
          _this52.loading = false;
        }
      });
    },
    loadCommandeAValid: function loadCommandeAValid(item) {
      var _this53 = this;

      this.loading = true;
      this.projetCourant = item;
      var url = this.domaine + "projet/" + this.projetCourant.id + "/index/projet/commande/avalid";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this53.listProjetAValid = response.body.commande;
          if (_this53.listProjetAValid === undefined || _this53.listProjetAValid.length == 0) {
            _this53.disabledBtnSCmdeAvalid = true;
          } else {
            _this53.disabledBtnSCmdeAvalid = false;
          }
          _this53.loading = false;
        }
      });
    },
    loadChargeIndirect: function loadChargeIndirect() {
      var _this54 = this;

      var url = this.domaine + "projet/" + this.projetCourant.id + "index/projet/charge";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this54.loading = false;
          _this54.listeCharges = response.body.charges;
          _this54.mntTotal = response.body.totalCharge;
        }
      });
    },
    loadCommandeAll: function loadCommandeAll(item) {
      var _this55 = this;

      this.loading = true;
      this.projetCourant = item;
      var url = this.domaine + "projet/" + this.projetCourant.id + "/index/projet/commande/all";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this55.listProjetAll = response.body.commande;
          if (_this55.listProjetAll === undefined || _this55.listProjetAll.length == 0) {
            _this55.disabledBtnSCmdeAll = true;
          } else {
            _this55.disabledBtnSCmdeAll = false;
          }
          _this55.loading = false;
        }
      });
    },
    loadCommandeValid: function loadCommandeValid(item) {
      var _this56 = this;

      this.loading = true;
      this.projetCourant = item;
      var url = this.domaine + "projet/" + this.projetCourant.id + "/index/projet/commande/valid";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this56.listProjetValid = response.body.commande;
          if (_this56.listProjetValid === undefined || _this56.listProjetValid.length == 0) {
            _this56.disabledBtnSCmdeValid = true;
          } else {
            _this56.disabledBtnSCmdeValid = false;
          }
          _this56.loading = false;
        }
      });
    },
    loadCommandeALivre: function loadCommandeALivre(item) {
      var _this57 = this;

      this.projetCourant = item;
      var url = this.domaine + "projet/" + this.projetCourant.id + "/index/projet/commande/alivre";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this57.listProjetAlivre = response.body.commande;
          if (_this57.listProjetAlivre === undefined || _this57.listProjetAlivre.length == 0) {
            _this57.disabledBtnSCmdeAliv = true;
          } else {
            _this57.disabledBtnSCmdeAliv = false;
          }
          _this57.loading = false;
        }
      });
    },
    loadCommandeLivre: function loadCommandeLivre(item) {
      var _this58 = this;

      this.projetCourant = item;
      var url = this.domaine + "projet/" + this.projetCourant.id + "/index/projet/commande/livre";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this58.listProjetlivre = response.body.commande;
          if (_this58.listProjetlivre === undefined || _this58.listProjetlivre.length == 0) {
            _this58.disabledBtnSCmdLiv = true;
          } else {
            _this58.disabledBtnSCmdLiv = false;
          }
          _this58.loading = false;
        }
      });
    },
    loadEngin: function loadEngin(item) {
      var _this59 = this;

      this.projetCourant = item;
      var url = this.domaine + "projet/" + this.projetCourant.id + "/index/projet/engin";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this59.listEngin = response.body.mission;
          if (_this59.listEngin === undefined || _this59.listEngin.length == 0) {
            _this59.disabledBtnSVeh = true;
          } else {
            _this59.disabledBtnSVeh = false;
          }
          _this59.loading = false;
        }
      });
    },
    loadProduitTravaux: function loadProduitTravaux(item) {
      var _this60 = this;

      this.projetCourant = item;
      var url = this.domaine + "projet/" + this.projetCourant.id + "/index/projet/materiel";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this60.listProduiTravaux = response.body.produit;
          if (_this60.listProduiTravaux === undefined || _this60.listProduiTravaux.length == 0) {
            _this60.disabledBtnSMat = true;
          } else {
            _this60.disabledBtnSMat = false;
          }
          _this60.loading = false;
        }
      });
    },
    showProjet: function showProjet(idProjet) {
      var _this61 = this;

      this.loading = true;
      this.dialogShowProjet = true;
      var url = this.domaine + "projet/" + idProjet.id + "/show";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this61.detailProjet = response.body.projet;
          if (_this61.notif === "active" && response.body.progression === false) {
            _this61.$vs.notify({
              title: "PROGRESSION " + _this61.detailProjet.libelle,
              text: "Les progressions journalières des différentes tâches attendent",
              type: "warning",
              position: "top-right",
              icon: "timeline",
              duration: 5000,
              click: function click() {
                _this61.tabb = "suivie", _this61.activeSuivie = "taches", _this61.$vs.notify({
                  title: "TÂCHES",
                  text: "Veuillez marquer la progression",
                  color: "success",
                  icon: "timeline"
                });
              }
            });
          }
          if (_this61.notif === "active" && response.body.rapport === true) {
            _this61.$vs.notify({
              title: "RAPPORT",
              text: "Les rapports journalières des différentes tâches attendent",
              color: "danger",
              position: "top-right",
              icon: "description",
              duration: 5000,
              click: function click() {
                _this61.tabb = "suivie", _this61.activeSuivie = "taches", _this61.$vs.notify({
                  title: "RAPPORT",
                  text: "Veuillez faire les rapports",
                  color: "success",
                  icon: "description"
                });
              }
            });
          }

          _this61.loading = false;
        }
      });
    },
    showTravaux: function showTravaux(item) {
      var _this62 = this;

      this.loading = true;
      this.dialogShowTravaux = true;
      this.disabledBtnContTrx = true;
      this.travauxCourant = item;
      var url = this.domaine + "projet/" + this.travauxCourant.id + "/travaux/show";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this62.loading = false;
          _this62.detailTravaux = response.body.travaux;
        }
      });
    },
    showTravauxRessource: function showTravauxRessource(item) {
      var _this63 = this;

      this.loading = true;
      this.dialogShowTravaux = true;
      this.travauxCourant = item;
      var url = this.domaine + "projet/" + this.travauxCourant.idTravaux + "/travaux/show";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this63.loading = false;
          _this63.detailTravaux = response.body.travaux;
        }
      });
    },
    showTache: function showTache(item) {
      var _this64 = this;

      this.loading = true;
      this.tacheCourant = item;
      this.dialogShowTache = true;
      var url = this.domaine + "projet/" + this.tacheCourant.id + "/tache/show";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this64.detailTache = response.body.tache;
          _this64.loading = false;
        }
      });
    },
    showCommande: function showCommande(item) {
      var _this65 = this;

      this.commandeCourant = item;
      this.dialogShowCommande = true;
      var url = this.domaine + "fournisseur/" + this.commandeCourant.id + "/show/commande";
      this.loading = true;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this65.detailCommande = response.body.commande;
          _this65.loading = false;
        }
      });
    },
    deleteRessources: function deleteRessources() {
      var _this66 = this;

      this.loading = true;
      var url = this.domaine + "projet/delete/ressources/" + this.idRessour + "/travaux/" + this.detailTravaux.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this66.$notify({
            title: "SUPPRESSION",
            message: "Ressource supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          _this66.loading = false;
          _this66.dialogSuprRessource = false;
          _this66.dialogShowTravaux = false;
        }
      }, function (error) {
        _this66.loading = false;
        _this66.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
        // this.loading = false;
      });
    },
    showInfoRessources: function showInfoRessources(ligne) {
      this.dialogShowInfoRessource = true;
      this.tacheSelectioner = ligne;
      this.formInfoRessource.libelle = ligne.produit;
      this.formInfoRessource.qte = ligne.qte;
      this.formInfoRessource.dateD = ligne.dateDUtilisation;
      this.formInfoRessource.dateF = ligne.dateFUtilisation;
    },
    editRessources: function editRessources(ligne) {
      this.dialogShowEditRessource = true;
      this.tacheSelectioner = ligne;
      this.formEditRessource.libelle = ligne.produit;
      // this.formEditRessource.qte = ligne.qte
      this.newQteRessource = ligne.qte;
      this.formEditRessource.dateD = ligne.dateDUtilisation;
      this.formEditRessource.dateF = ligne.dateFUtilisation;
    },
    sumbitRessource: function sumbitRessource(ligne) {
      var _this67 = this;

      this.loading = true;
      var form = document.getElementById("formEditRessource");
      var data = new FormData(form);
      var url = "";
      // data.append("dataForm", JSON.stringify(this.formEditRessource))
      data.append("idOptBesoin", ligne.idOptBesoin);
      data.append("idOptTravaux", ligne.id);
      data.append("newQteRessource", this.newQteRessource);

      url = this.domaine + "projet/travaux/" + this.detailTravaux.id + "/ressources/edit";
      this.$http.post(url, data).then(function (response) {
        _this67.loading = false;
        if (response.body) {
          var verif = response.body;
          _this67.loading = false;
          if (verif.code === 1) {
            _this67.$notify({
              title: "MODIFICATION REUSSI",
              message: response.body.message,
              type: "success",
              position: "top-center"
            });
            _this67.loading = false;
            _this67.dialogSuprRessource = false;
            _this67.dialogShowEditRessource = false;
            _this67.dialogShowTravaux = false;
            _this67.formEditRessource.dateD = '';
            _this67.formEditRessource.dateD = '';
            _this67.newQteRessource = 0;
            _this67.handleTabClick('2');
            //  this.showTravaux(ligne)
            _this67.showTravauxRessource(ligne);
          }
        }
      }, function (error) {
        _this67.loading = false;
        _this67.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
        // this.loading = false;
      });
    },
    submitCharge: function submitCharge() {
      var _this68 = this;

      if (this.selectReponse == 'periode') {
        var Dcharge = this.functionTime(this.chargeDateD);
        var Fcharge = this.functionTime(this.chargeDateF);
        var Dprojet = this.functionTime(this.projetCourant.dateD);
        var Fprojet = this.functionTime(this.projetCourant.dateF);

        if (Dprojet.getTime() >= Dcharge.getTime() && Fprojet.getTime() <= Fcharge.getTime()) {
          this.$message.error("Veuillez renseigner les champs obligatoires");
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "La besoin n'a pas été enregistré."

          });
        } else {
          var produit = this.optionProduit[0]['produit'];
          if (this.listeCharges.length > 0) {
            var etat = false;
            this.listeCharges.forEach(function (item) {
              if (item.idProduit == produit) {
                etat = true;
              }
            });
            if (etat) {
              this.$message.error("Cette ressource existe deja dans les charges indirects de ce projet");
            }
          } else {
            this.loading = true;
            var formdata = new FormData();
            var url = this.domaine + "projet/new/charge";
            formdata.append("idUser", this.user.id);
            formdata.append("projet", this.projetCourant.id);
            formdata.append("produit", this.optionProduit[0]['produit']);
            formdata.append("qte", this.optionProduit[0]['qte']);
            formdata.append("cout", this.montantChargeJournalier);
            formdata.append("remuneration", this.selectRemuneration);
            formdata.append("chargeDateD", this.chargeDateD);
            formdata.append("modeAappliquer", this.selectReponse);
            formdata.append("chargeDateF", this.chargeDateF);
            formdata.append("total", this.totalMontantSan);

            this.$http.post(url, formdata).then(function (response) {
              if (response.body) {
                var verif = response.body;
                if (verif.code === 1) {
                  _this68.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Besoin enregistré avec succès.",
                    type: "success",
                    position: "top-center"
                  });

                  _this68.dialogFormCharge = false;
                  _this68.loadChargeIndirect();
                  _this68.selectDemande = '';
                  _this68.loading = false;
                  _this68.$refs.formBesoin.reset();
                }
              } else {
                _this68.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                _this68.loading = false;
                _this68.clear();
              }
            }, function (response) {
              _this68.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this68.loading = false;
            });
          }
        }
      } else {
        var _produit = this.optionProduit[0]['produit'];
        if (this.listeCharges.length > 0) {
          var _etat = false;
          this.listeCharges.forEach(function (item) {
            if (item.idProduit == _produit) {
              _etat = true;
            }
          });
          if (_etat) {
            this.$message.error("Cette ressource existe deja dans les charges indirects de ce projet");
          }
        } else {
          this.loading = true;
          var formdata = new FormData();
          var _url2 = this.domaine + "projet/new/charge";
          formdata.append("idUser", this.user.id);
          formdata.append("projet", this.projetCourant.id);
          formdata.append("produit", this.optionProduit[0]['produit']);
          formdata.append("qte", this.optionProduit[0]['qte']);
          formdata.append("cout", this.montantChargeJournalier);
          formdata.append("remuneration", this.selectRemuneration);
          formdata.append("chargeDateD", this.chargeDateD);
          formdata.append("modeAappliquer", this.selectReponse);
          formdata.append("chargeDateF", this.chargeDateF);
          formdata.append("total", this.totalMontantSan);

          this.$http.post(_url2, formdata).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this68.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Besoin enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });

                _this68.dialogFormCharge = false;
                _this68.loadChargeIndirect();
                _this68.selectDemande = '';
                _this68.loading = false;
                _this68.$refs.formBesoin.reset();
              }
            } else {
              _this68.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this68.loading = false;
              _this68.clear();
            }
          }, function (response) {
            _this68.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this68.loading = false;
          });
        }
      }
    },
    resetFormInfoRess: function resetFormInfoRess() {
      this.formInfoRessource = {};
      this.dialogShowInfoRessource = false;
    },
    resetFormEditRess: function resetFormEditRess() {
      this.formEditRessource = {};
      this.newQteRessource = 0;
      this.dialogShowEditRessource = false;
    },
    editTache: function editTache(ligne) {

      this.dialogShowReglement = true;
      this.formTacheDemarrer.dateDbtache = ligne.dateDFormat;
      this.formTacheDemarrer.dateFintache = ligne.dateFFormat;
      this.tacheSelectioner = ligne.idTrx;
      this.travauxCourant = ligne;
      // this.projetCourant = ligne;
    },
    editDateTache: function editDateTache() {
      var _this69 = this;

      this.loading = true;
      var form = document.getElementById("formTacheDemarrer");
      var data = new FormData(form);
      var url = "";
      data.append("idUser", this.user.id);
      data.append("idtache", this.tacheSelectioner);
      data.append("dateDbtache", this.formTacheDemarrer.dateDbtache);
      data.append("dateFintache", this.formTacheDemarrer.dateFintache);

      url = this.domaine + "projet/" + this.chantierCourant.id + "/edit/tache";
      this.$http.post(url, data).then(function (response) {
        _this69.loading = false;
        if (response.body) {
          var verif = response.body;
          _this69.loading = false;
          if (verif.code === 1) {
            _this69.$notify({
              title: "MODIFICATION REUSSI",
              message: response.body.message,
              type: "success",
              position: "top-center"
            });

            _this69.loadChantier(_this69.projetCourant);

            _this69.loadProjetTache(_this69.projetCourant);
            _this69.loadProjet();
            _this69.dialogShowReglement = false;
            _this69.dialogPlan = false;

            _this69.formTacheDemarrer.dateDbtache = "";
            _this69.formTacheDemarrer.dateFintache = "";
          } else {
            _this69.loading = false;
            _this69.$notify.error({
              title: "ERREUR D'ENREGISTREMENT",
              message: verif.message,
              position: "top-center"
            });
            // this.loading = false;
          }
        } else {
          _this69.loading = false;
          _this69.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          // this.loading = false;
        }
      }, function (response) {
        _this69.loading = false;
        _this69.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
        // this.loading = false;
      });
    },
    resetFormVersion: function resetFormVersion() {
      this.dialogShowReglement = false;
      //  this.$refs['formTacheDemarrer'].resetFields();

      this.formTacheDemarrer.dateDbtache = "";
      this.formTacheDemarrer.dateFintache = "";
    },
    ajoutProjet: function ajoutProjet(type, item) {
      if (type === "edit") {
        this.projetSelect = item;
        this.form.id = item.id;
        this.form.type = item.idType;
        this.form.etatBudget = item.budget.etat;
        this.tableBudget = item.budget.budgets;
        this.form.libelle = item.libelle;
        this.form.chef = item.idChef;
        this.form.maitre_ouvrage = item.idMaitreO;
        this.form.controleur_travaux = item.idConducTravaux;
        this.form.chefEtude = item.idChefEtud;
        this.form.chefControle = item.idChefCon;
        this.form.architect = item.idArcht;
        this.form.description = item.description;
        this.form.adresse = item.adresse;
        this.form.nbrHeure = item.nbrHeure;
        this.form.prix = item.mntMarcheNormal;
        this.form.prixBudget = item.prixBudget;
        this.form.caisse = item.idCaisse;
        this.selectBanques = item.idBanque;
        this.selectUsers = item.IdParticipant;
        this.loadCaisse();
        // this.form.banque = item.idBanque;
        this.logoProjet = item.urlImage;
        //this.form.caisse = item.idCaisse;
        this.dateD = item.dateD;
        this.dateF = item.dateF;
        this.latitude = item.latitude;
        this.longitude = item.longitude;
        this.texteP = "Modifier le projet " + item.libelle;
      } else {
        //this.tableBudget.splice(0);
        this.form.etatBudget = false;
        this.logoProjet = "/static/img-doc.png";
        this.form.id = "";
        this.form.type = "";
        this.form.libelle = "";
        this.form.chef = "";
        this.form.maitre_ouvrage = "";
        this.form.controleur_travaux = "";
        this.form.chefEtude = "";
        this.form.chefControle = "";
        this.form.architect = "";
        this.form.description = "";
        this.form.adresse = "";
        this.form.nbrHeure = 1;
        this.form.caisse = "";
        // this.form.banque = "";
        this.selectBanques = [];
        this.selectUsers = [];
        this.form.prix = "";
        this.dateD = "";
        this.dateF = "";
        this.latitude = 0;
        this.longitude = 0;
        this.texteP = "Ajouter un nouveau projet";
      }
      this.loadClient();
      this.loadUser();
      this.loadPrestaire();
      this.form.etat = true;
    },
    newCharge: function newCharge(item) {
      this.chantierCourant.id = "";
      this.chantier = {};
      this.projetCourant = item;
      this.dialogCharge = true;
      this.dialogEdit = false;
      this.loadChargeIndirect();
      // this.optionTChantier = [
      //   {
      //     key: 1,
      //     libelle: "",
      //     dateD: "",
      //     dateF: "",
      //     montant: 0,
      //     idChef: "",
      //     id: ""
      //   }
      // ];
    },
    changePeriode: function changePeriode() {
      this.chargeDateD = '';
      this.chargeDateF = '';
    },
    newRessource: function newRessource(item) {
      this.dialogFormCharge = true;
      this.optionProduit = [{ type: "", produit: "", qte: 0 }], this.valeurUniteMateriel = '';
      this.selectReponse = '';
      this.selectRemuneration = '';
      this.chargeDateD = '';
      this.chargeDateF = '';
      this.montantChargeJournalier = '';
      this.totalMontantHT = 0;
      this.loadTypeRessource();
    },
    newChantier: function newChantier(item) {
      this.chantierCourant.id = "";
      this.chantier = {};
      this.projetCourant = item;
      this.dialogPlan = true;
      this.dialogEdit = false;
      this.logoChantier = "/static/img-doc.png";
      this.selectZone = "";
      this.latitude = 0;
      this.longitude = 0;
      this.optionChantier = [{
        key: 1,
        libelle: "",
        dateD: "",
        dateF: "",
        montant: 0,
        idChef: "",
        id: ""
      }];
    },
    newTravaux: function newTravaux(item) {
      this.readBtnModTrx = false;
      this.chantierCourant = item;
      this.travauxCourant.sousLibelle = '';
      this.travauxCourant.id = "";
      this.detailPlanifCourant = item;
      this.loadTravauxChantier(item);
      this.dialogTravaux = true;
      this.readBtdTrx = false;
      this.dialogEdit = false;
      this.optionTache = [];
      this.selectTravaux = "";
      this.dateD = "";
      this.dateF = "";
      this.selectSoustraite = "";
      this.selectPrestataire = "";
      this.montantSoustraitance = 0;
      this.selectSousTravaux = '';
      this.etape = 1;
      this.descriptionTravaux = "";
    },
    newCommande: function newCommande(item, ligne) {
      this.travauxCourant = item;
      this.dialogComm = true;
      this.dialogEdit = false;
      this.FormComm.optionCommande = [{
        key: 1,
        produit: "",
        qte: 1,
        id: ""
      }];
      this.FormComm.fournisseur = "";
    },
    newEquipe: function newEquipe(item) {
      this.tacheCourant = item;
      this.equipeCourant.id = "";

      if (this.tacheCourant.soutraite == 1) {
        //tache deja soutraite par un prestataire
        this.$alert("Cette tache est déjà soustraitée par le prestataire " + this.tacheCourant.fournisseur, "Tache soustraitée ", {
          confirmButtonText: "OK",
          callback: function callback(action) {
            return;
          }
        });
        return;
      } else {
        this.dialogEquipe = true;
        this.dialogEdit = false;
        this.optionEquipe = [{
          key: 1,
          type: [{ text: "Prestataire", value: 1 }, { text: "Ouvrier/Manoeuvre", value: 2 }],
          selectType: "",
          fournisseur: "",
          ouvrier: "",
          duree: "",
          montant: 0,
          montantSupp: 0,
          id: ""
        }];
      }
    },
    newDemarer: function newDemarer(item) {
      this.travauxCourant = item;
      this.dialogDemarer = true;
      this.optionDemarer = this.multipleSelection;
    },
    newDemarerTravaux: function newDemarerTravaux(item) {
      this.travauxCourant = item;
      this.dialogDemarerTravaux = true;
      this.optionDemarer = this.multipleSelection;
    },
    newRapport: function newRapport(item) {
      this.tacheCourant = item;
      this.evolution = this.tacheCourant.evolution;
      this.dialogRapport = true;
      this.description = "";
      this.fichier = [];
    },
    newValid: function newValid(item) {
      this.tacheCourant = item;
      this.dialogValid = true;
      this.description = this.tacheCourant.descriptionValid;
      this.selectReponse = null;
    },
    newValidCommande: function newValidCommande(item) {
      this.commandeCourant = item;
      this.dialogValidCommande = true;
      this.description = this.commandeCourant.description;
      this.selectReponse = null;
    },
    newDupliqueChantier: function newDupliqueChantier(item) {
      this.projetCourant = item;
      this.dialogDupliqueChantier = true;
      this.optionDuplique = this.multipleSelection;
    },
    newRapportTravaux: function newRapportTravaux() {
      this.dialogMultipleRapport = true;
      this.optionRapport = [];
      this.selectChantierRapport = "";
      this.selectTravauxRapport = "";
    },
    newPlanifProduit: function newPlanifProduit(item) {
      this.dialogPlanifProduit = true;
      this.tabListProduit = [];
      this.tabListEngin = [];
      this.prodSelctEngin = '';
      this.tacheCourante = item;
      this.optionProduit = [{ type: "", produit: "", qte: 1, priorite: "" }];
      this.optionVehicule = [{ vehicule: "", qte: 1, priorite: "", periode: "" }];
      this.valeurUniteMateriel = "";
      this.loadTacheTrx();
      this.loadTypeRessource();
      this.loadTypeEngin();
      this.loadProduitPlan();
    },
    editChantier: function editChantier(item) {
      console.log('item', item);
      this.chantier = item;
      this.chantier.dateD = item.dateD2;
      this.chantier.type = item.typeChantier;
      this.chantier.dateF = item.dateF2;
      this.chantierCourant = item;
      this.travauxCourant = item.travaux;
      this.dialogPlan = true;
      this.dialogEdit = true;
      this.selectZone = this.chantierCourant.idZone;
      this.libelle = this.chantierCourant.libelle;
      this.dateD = this.chantierCourant.dateD;
      this.dateF = this.chantierCourant.dateF;
      this.montant = this.chantierCourant.montant;
      this.latitude = this.chantierCourant.latitude;
      this.longitude = this.chantierCourant.longitude;
      this.selectUsers = this.chantierCourant.idParticipant;
      this.logoChantier = item.urlImage;
      this.handleChangeSoustraitant(item.soutraite);
    },
    editTravaux: function editTravaux(item, item2, listChantierResult) {
      this.listeTacheSupp = [];
      this.detailPlanifCourant = item;
      this.readBtnModTrx = true;
      this.travauxCourant = item;
      this.dialogTravaux = true;
      this.readBtdTrx = false;
      this.dialogEdit = true;
      if (item.sousLibelle) {
        this.readBtdTrx = true;
      }
      this.selectTravaux = item.idTypeTravaux;
      this.loadTacheParTravaux();
      this.descriptionTravaux = this.travauxCourant.description;
      this.selectChefTravaux = this.travauxCourant.idChef;
      this.dateD = this.travauxCourant.dateDebutF;
      this.dateF = this.travauxCourant.dateFinF;
      this.etape = 1;
      this.selectSoustraite = this.travauxCourant.soutraite;
      this.selectPrestataire = this.travauxCourant.idFour;
      this.optionTache = item2.option;
      this.montantSoustraitance = this.travauxCourant.montantSoustraitance;
    },
    editEquipe: function editEquipe(item) {
      this.equipeCourant = item;
      this.dialogEquipe = true;
      this.dialogEdit = true;
      this.montantContrat = this.equipeCourant.montantNbr;
      this.dateDContrat = this.equipeCourant.dateD;
      this.dateFContrat = this.equipeCourant.dateF;
    },
    editCommande: function editCommande(ligne) {
      this.loading = false;
      this.commandeCourant = ligne;
      this.travauxCourant.id = ligne.idTrav;
      this.dialogComm = true;
      this.dialogEdit = true;
      this.FormComm.optionCommande = this.commandeCourant.option;
      this.FormComm.fournisseur = this.commandeCourant.fournisseur;
    },
    submit: function submit() {
      var _this70 = this;

      var dbt = this.dateD.split("-");
      var fin = this.dateF.split("-");
      var dateDFormat = new Date(dbt[2] + "-" + dbt[1] + "-" + dbt[0]);

      var dateFFormat = new Date(fin[2] + "-" + fin[1] + "-" + fin[0]);
      if (this.$refs.formProjet.validate() && this.form.nbrHeure > 0 && this.form.nbrHeure <= 24 && this.form.chef !== "" && this.form.maitre_ouvrage !== "" && this.form.controleur_travaux !== "" && this.form.adresse !== "" && this.form.libelle !== "" && this.longitude !== 0 && this.latitude !== 0 && this.form.caisse !== "" && this.selectBanques.length != 0
      // this.selectUsers.length != 0
      ) {
          if (dateDFormat <= dateFFormat) {
            var form = document.getElementById("formProjet");
            var data = new FormData(form);
            data.append("id", this.form.id);
            data.append("type", "N/A"); //ne pas supprimer pour eviter des erreurs
            data.append("chef", this.form.chef);
            data.append("chefEtude", this.form.chefEtude);
            data.append("maitre_ouvrage", this.form.maitre_ouvrage);
            data.append("controleur_travaux", this.form.controleur_travaux);
            data.append("chefControle", this.form.chefControle);
            data.append("architect", this.form.architect);
            data.append("caisse", this.form.caisse);
            data.append("prix", this.form.prix);
            data.append("prixBudget", this.form.prixBudget);
            data.append("idUser", this.user.id);
            data.append("banque", this.selectBanques);
            data.append("Users", this.selectUsers);

            var url = this.domaine + "projet/new";
            // this.loading = true;
            this.$http.post(url, data).then(function (response) {
              if (response.body) {
                if (response.body.code == 1) {
                  _this70.$notify({
                    title: "NOTIFICATION PROJET",
                    message: response.body.message,
                    type: "success",
                    duration: 3000,
                    position: "top-center"
                  });
                  _this70.form.etat = false;;
                  // this.loadListeProjet()
                  _this70.loadProjetAll();
                  _this70.form.etat = false;

                  _this70.loading = false;
                }
                if (response.body.code == 2) {
                  _this70.$notify({
                    title: "ENREGISTREMENT PROJET",
                    message: "le nom du projet existe déjà.",
                    type: "Warning",
                    position: "top-center",
                    duration: 5000
                  });
                  _this70.loading = false;
                }
              }
            }, function (response) {
              _this70.loading = false;
            });
          } else {
            this.$notify({
              title: "ERREUR CONCERNANT LES DATES",
              message: "La de fin ne doit pas être supérieur à la date de début.",
              type: "warning",
              position: "top-center"
            });
            this.loading = false;
          }
        } else {
        this.$message.error("veuillez compléter le formulaire  correctement!");
        this.loading = false;
      }
    },
    isValidDateChantier: function isValidDateChantier() {
      if (this.projetCourant.dateD != null && this.projetCourant.dateD != null) {
        var tabDateDbt = this.projetCourant.dateD.split("-");
        var dateDbt = tabDateDbt.reverse();
        var datePrjDbt = new Date(dateDbt);
        var tabDateFin = this.projetCourant.dateF.split("-");
        var dateFin = tabDateFin.reverse();
        var datePrjFin = new Date(dateFin);

        if (this.chantier.latitude == null || this.chantier.longitude == null || this.chantier.libelle == null || this.chantier.montant == null || this.chantier.dateD < datePrjDbt || this.chantier.dateD > datePrjFin || this.chantier.dateD > this.chantier.dateF || this.chantier.dateF < datePrjDbt || this.chantier.dateF > datePrjFin || this.chantier.dateF == null || this.chantier.dateD == null || this.chantier.idChef == null) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    functionTime: function functionTime(dateR) {
      if (dateR != '') {
        var date = "";
        var splittedDate = dateR.split("-");

        //on verifie si la date est au format Y-m-d
        if (splittedDate[2].length == 4) {
          date = [splittedDate[2], splittedDate[1], splittedDate[0]].join("-");
          var dateObject = new Date(date);
        } else {
          var dateObject = new Date(dateR);
        }
        return dateObject;
      }
    },
    submitPlan: function submitPlan() {
      var _this71 = this;

      this.loading = true;
      // this.chantierCourant = null;
      var Dchantier = this.functionTime(this.chantier.dateD);
      var Fchantier = this.functionTime(this.chantier.dateF);
      var Dprojet = this.functionTime(this.projetCourant.dateD);
      var Fprojet = this.functionTime(this.projetCourant.dateF);

      if (Dprojet.getTime() <= Dchantier.getTime() && Fprojet.getTime() >= Fchantier.getTime()) {
        if (
        // this.$refs.formProjet.validate() &&
        this.chantier.longitude != 0 && this.chantier.latitude != 0 && this.chantier.libelle != "" && this.chantier.idCommis != "" && this.chantier.dateD != "" && this.chantier.dateF != "" && this.chantier.idChef != "" && this.chantier.type !== "" && this.chantier.type != null) {
          var form = document.getElementById("formPlan");
          var data = new FormData(form);
          var url = "";
          if (this.chantierCourant.id != "") {
            url = this.domaine + "projet/" + this.chantierCourant.id + "/edit/plan";
            data.append("etat", this.chantier.etat);
          } else {
            url = this.domaine + "projet/" + this.projetCourant.id + "/new/plan";
          }

          data.append("idUser", this.user.id);
          data.append("idChef", this.chantier.idChef);
          data.append("commis", this.chantier.idCommis);
          data.append("type", this.chantier.type);
          data.append("soutraite", this.chantier.soutraite);
          data.append("prestataire", this.chantier.prestataire);
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                if (_this71.chantierCourant.id) {
                  _this71.$notify({
                    title: "MODIFICATION REUSSI",
                    message: response.body.message,
                    type: "success",
                    position: "top-center"
                  });
                } else {
                  _this71.chantierCourant = response.body.chantier;
                  _this71.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: response.body.message,
                    type: "success",
                    position: "top-center"
                  });
                }

                _this71.showProjet(_this71.projetCourant);
                _this71.loadChantier(_this71.projetCourant);
                _this71.loadProjet();
                _this71.dialogPlan = false;
                _this71.loading = false;
              } else if (verif.code === 0) {
                _this71.$message.error(verif.message);
                _this71.loading = false;
              }
            } else {
              _this71.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this71.loading = false;
            }
          }, function (response) {
            _this71.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this71.loading = false;
          });
        } else {
          this.$message.error("veuillez compléter le formulaire  correctement!");
          this.loading = false;
        }
      } else {
        this.$message.error("Les dates pour la réalisation du chantier doivent être  comprise  entre les dates du projet");
        this.loading = false;
      }
    },
    validDuplique: function validDuplique(chantier) {
      var _this72 = this;

      var url = "";
      url = this.domaine + "projet/new_duplicate/chantier/" + chantier.idChantier;
      var data = new FormData();
      data.append("idUser", this.user.id);
      this.$http.post(url, data).then(function (response) {
        _this72.$notify({
          title: "Duplication Chantier",
          message: "Le  chantier , les travaux et tâches ont été dupliqués",
          type: "success",
          position: "top-center"
        });
        _this72.loading = false;
        _this72.loadChantier(_this72.projetCourant);
        _this72.showDialogDupTrx = false;
        //this.$refs.formEquipe.reset();
      }, function (response) {
        _this72.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
        _this72.loading = false;
      });
    },
    duplicateTravauxChantier: function duplicateTravauxChantier(oldChantier, newChantier) {
      var _this73 = this;

      this.chantier = oldChantier;
      var data = new FormData();
      data.append("oldChantier", oldChantier.idChantier);
      data.append("newChantierId", newChantier.idChantier);

      var url = "";
      url = this.domaine + "projet/duplicate/chantier/new_travaux_chantier";
      this.$http.post(url, data).then(function (response) {
        _this73.$notify({
          title: "OPERATION REUSSI",
          message: "Duplication avec succès.",
          type: "success",
          position: "top-center"
        });
        _this73.loading = false;
      }, function (response) {
        _this73.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
        _this73.loading = false;
      });
    },
    isValidDateOptionTache: function isValidDateOptionTache() {
      this.dateD.setSeconds(0);
      this.dateF.setSeconds(0);

      for (var indexOption in this.optionTache) {
        var option = this.optionTache[indexOption];

        if (option.dateDebut != null && option.dateFin != null) {
          option.dateDebut.setSeconds(0);
          option.dateFin.setSeconds(0);
          //verification des dates
          if (option.dateDebut > option.dateFin || option.dateDebut > this.dateF || option.dateDebut < this.dateD || option.dateFin < this.dateD || option.dateFin > this.dateF) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      }
    },
    isValidDateOptionEquipe: function isValidDateOptionEquipe() {
      var result = false;
      if (this.tacheCourant.dateDebut != null && this.tacheCourant.dateFin != null) {
        var tabDateDbt = this.tacheCourant.dateDebut.split("-"); //["16","08","2018 00:00:00"]
        var jr = tabDateDbt[0];
        var mois = tabDateDbt[1];
        var annee = tabDateDbt[2].split(" ")[0];
        var hr = tabDateDbt[2].split(" ")[1];
        var dateDbt = annee + "-" + mois + "-" + jr + "T" + hr;
        var dateChtDbt = new Date(dateDbt);

        var tabDateFin = this.tacheCourant.dateFin.split("-");
        var jrF = tabDateFin[0];
        var moisF = tabDateFin[1];
        var anneeF = tabDateFin[2].split(" ")[0];
        var hrF = tabDateFin[2].split(" ")[1];
        var dateFin = anneeF + "-" + moisF + "-" + jrF + "T" + hrF;
        var dateChtFin = new Date(dateFin);

        //this.tacheCourant.setSeconds(0)
        //this.dateF.setSeconds(0)
        if (this.optionEquipe.length == 0) {
          this.$message.error("Veuillez Ajouter un manoeuvre pour la tache");
          result = false;
        } else {
          for (var indexOption in this.optionEquipe) {
            var option = this.optionEquipe[indexOption];

            if (option.duree[0] != null && option.duree[1] != null) {
              if (option.duree[0] > option.duree[1] || option.duree[0] > dateChtFin || option.duree[0] < dateChtDbt || option.duree[1] < dateChtDbt || option.duree[1] > dateChtFin || option.montant <= 0) {
                this.$message.error("Veuillez verifier les dates et le montant saisi a la ligne " + (parseInt(indexOption, 10) + 1));

                result = false;
                break;
              } else {
                result = true;
              }
            } else {
              this.$message.error("Veuillez verifier les dates et le montant saisi a la ligne " + (indexOption + 1));

              result = false;
              break;
            }
          }
        }
      }

      return result;
    },
    submitSearch: function submitSearch() {
      var _this74 = this;

      this.loading = true;
      this.searchResultList = [];
      this.searchResultTravauxList = [];
      this.searchResultEtat = [];
      this.searchResultEtatCommande = [];
      this.searchResultEtatMontant = [];
      if (this.$refs.formSearchTypeRapport.validate() && this.selectTypeRapport != "") {
        var form = document.getElementById("formSearchTypeRapport");
        var data = new FormData(form);
        var url = this.domaine + "projet/rapport/search";
        data.append("idUser", this.user.id);
        data.append("type", this.selectTypeRapport);
        data.append("chantier", this.selectSearchChantier);
        data.append("travaux", this.selectSearchTravauxSuivi);
        data.append("etat", this.selectSearchEtat);

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            _this74.searchResultList = verif.table;
            _this74.searchResultTravauxList = verif.table2;
            _this74.searchResultEtatMontant = verif.piemontant;
            _this74.searchResultEtatCommande = verif.piecom;
            _this74.searchResultEtat = verif.pie;
            _this74.totalCommande = verif.totalCommande;
            _this74.totalDepense = verif.totalDepense;
            if (verif.code === 1) {
              _this74.$notify({
                title: "RESULTATS DES RECHERCHES",
                message: "Nous avons trouvé.",
                type: "success",
                position: "top-center"
              });

              if (_this74.selectTypeRapport == 1) {
                _this74.statEtatGeneral();
              } else if (_this74.selectTypeRapport == 2) {
                _this74.statEtatMontant();
              } else if (_this74.selectTypeRapport == 3) {
                _this74.statEtatCommande();
              }

              _this74.loading = false;
            } else if (verif.code === 0) {
              _this74.$message.error(verif.message);
              _this74.loading = false;
            }
          } else {
            _this74.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this74.loading = false;
          }
        }, function (response) {
          _this74.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this74.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Les travaux n'ont pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitTravaux: function submitTravaux() {
      var _this75 = this;

      // this.loading = true;
      var statut = false;
      for (var prop in this.optionTache) {
        var ligne = this.optionTache[prop];
        if (ligne.dateDebut == null && ligne.dateFin == null) {
          this.loading = false;
          this.$message.error("Veuillez renseigner les champs obligatoires");
          return;
        }
      }
      if (this.$refs.formTravaux.validate()) {
        var form = document.getElementById("formTravaux");
        var data = new FormData(form);
        var etat = false;
        var url = "";
        if (this.chantierCourant.id != '') {
          url = this.domaine + "projet/" + this.chantierCourant.id + "/new/travaux";
        } else {
          url = this.domaine + "projet/" + this.chantierCourant.idChant + "/new/travaux";
        }

        var _ligne2 = null;

        var nbData = 10;
        var nbReq = 1;
        var nbRest = void 0;
        if (this.optionTache.length > 10) {
          nbData = 10;
          nbReq = Math.round(this.optionTache.length / nbData);
          nbRest = this.optionTache.length % nbData;
          if (nbRest > 0) {
            nbReq += 1;
          }
        }
        for (var i = 0; i < nbReq; i++) {
          var initJ = i * nbData;
          var finJ = (i + 1) * nbData;
          var dataLot = [];
          if (this.optionTache.length > 0) {
            for (var j = initJ; j < finJ; j++) {
              if (this.optionTache[j] == undefined) {
                break;
              }
              dataLot.push(this.optionTache[j]);
            }
          }
          var data = new FormData(form);

          for (var _prop2 in dataLot) {
            _ligne2 = dataLot[_prop2];
            data.append("option[id][]", _ligne2.id);
            data.append("option[dateD][]", _ligne2.dateDebut);
            data.append("option[dateF][]", _ligne2.dateFin);
            data.append("option[ordre][]", _ligne2.ordre);
            data.append("option[prix][]", _ligne2.prix);
            data.append("option[qte][]", _ligne2.qte);
            data.append("option[total][]", _ligne2.total);
            etat = true;
          }

          data.append("listeSupp", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.listeTacheSupp));

          data.append("idUser", this.user.id);
          data.append("chef", this.selectChefTravaux);
          data.append("montantEstime", this.montantEstime);
          data.append("montantSoustraitance", this.montantSoustraitance);
          data.append("travaux", this.selectTravaux);
          if (this.chantierCourant.soutraite == 1) {
            data.append("idFour", this.chantierCourant.idFour);
            data.append("soutraite", this.chantierCourant.soutraite);
          } else {
            data.append("idFour", this.selectPrestataire);
            data.append("soutraite", this.selectSoustraite);
          }

          data.append("selectSous", this.selectSousTravaux ? this.selectSousTravaux : 0);
          data.append("totalHT", this.totalHT);

          this.$http.post(url, data).then(function (response) {
            _this75.loading = false;
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {

                _this75.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Travaux enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });

                _this75.showProjet(_this75.projetCourant);
                _this75.loadChantier(_this75.projetCourant);
                _this75.dialogTravaux = false;
                _this75.loading = false;
                _this75.$refs.formTravaux.reset();
              } else {
                _this75.loading = false;
                _this75.$notify.error({
                  title: "ERREUR D'ENREGISTREMENT",
                  message: verif.message,
                  position: "top-center"
                });
              }
            }
            // else {
            //   this.loading = false;
            //   this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");

            // }
          }, function (response) {
            _this75.loading = false;
            _this75.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          });
        }
      } else {
        this.loading = false;
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Les travaux n'ont pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitEditTravaux: function submitEditTravaux(idTrx) {
      var _this76 = this;

      this.loading = true;
      var statut = false;
      for (var prop in this.optionTache) {
        var ligne = this.optionTache[prop];
        if (ligne.dateDebut == null && ligne.dateFin == null) {
          this.loading = false;
          this.$message.error("Veuillez renseigner les champs obligatoires");
          return;
        }
      }

      if (this.$refs.formTravaux.validate()) {
        var form;
        var data;
        var data;

        (function () {
          form = document.getElementById("formTravaux");
          data = new FormData(form);

          var url = _this76.domaine + "projet/" + idTrx + "/edit/travaux";
          var ligne = null;
          var nbData = 10;
          var nbReq = 1;
          var nbRest = void 0;
          if (_this76.optionTache.length > 10) {
            nbData = 10;
            nbReq = Math.round(_this76.optionTache.length / nbData);
            nbRest = _this76.optionTache.length % nbData;
            if (nbRest > 0) {
              nbReq += 1;
            }
          }

          var _loop = function _loop(i) {
            var initJ = i * nbData;
            var finJ = (i + 1) * nbData;
            var dataLot = [];
            if (_this76.optionTache.length > 0) {
              for (var j = initJ; j < finJ; j++) {
                if (_this76.optionTache[j] == undefined) {
                  break;
                }
                dataLot.push(_this76.optionTache[j]);
              }
            }
            data = new FormData(form);

            for (var _prop3 in dataLot) {
              ligne = dataLot[_prop3];

              console.log('ligne.tache ', ligne.tache);
              console.log('ligne.libelle ', ligne.libelle);

              if (ligne.tache === ligne.tache2) {
                data.append("option[tache][]", ligne.tache != '' ? ligne.tache : ligne.libelle);
              } else {
                data.append("option[tache][]", ligne.libelle != '' ? ligne.libelle : ligne.tache);
              }
              data.append("option[id][]", ligne.id);
              data.append("option[dateD][]", ligne.dateDebut);
              data.append("option[dateF][]", ligne.dateFin);
              data.append("option[ordre][]", ligne.ordre);
              data.append("option[prix][]", ligne.prix);
              data.append("option[unite][]", ligne.unite);
              data.append("option[qte][]", ligne.qte);
              data.append("option[total][]", ligne.total);
            }

            data.append("listeSupp", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this76.listeTacheSupp));
            data.append("totalHT", _this76.totalHT);
            data.append("chef", _this76.selectChefTravaux);
            data.append("montantEstime", _this76.montantEstime);
            data.append("soustraite", _this76.selectSoustraite);
            data.append("mntSoutraite", _this76.montantSoustraitance);
            data.append("description", _this76.descriptionTravaux);
            data.append("dateDebut", _this76.travauxCourant.dateDebut);
            data.append("dateFin", _this76.travauxCourant.dateFin);
            data.append("idFour", _this76.selectPrestataire);
            data.append("soutraite", _this76.selectSoustraite);
            data.append("travaux", _this76.selectTravaux);
            data.append("idUser", _this76.user.id);
            data.append("selectSous", _this76.selectSousTravaux ? _this76.selectSousTravaux : 0);

            _this76.$http.post(url, data).then(function (resp) {
              _this76.handleTabClick('2');
              _this76.dialogShowTravaux = false;
              _this76.loading = false;
              if (resp.body.code == 2 && i == nbReq - 1) {
                _this76.$notify({
                  title: 'Suppression Taches',
                  duration: 5000,
                  message: resp.body.message,
                  type: 'warning'
                });
              } else {
                _this76.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Les travaux ont ete enregistre",
                  type: "success",
                  position: "top-center"
                });
              }
            }, function (error) {
              _this76.loading = false;
              _this76.$message.error("Echec de l'operation veuillez verifier la connexion");
            });
          };

          for (var i = 0; i < nbReq; i++) {
            _loop(i);
          }

          _this76.showProjet(_this76.projetCourant);
          _this76.loadChantier(_this76.projetCourant);
          _this76.dialogTravaux = false;
          _this76.loading = false;
          var loading = _this76.$loading({
            lock: true,
            text: 'Veuillez patientez ...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          setTimeout(function () {
            loading.close();
            // this.loading = false
            if (succesEnreg == true) {
              _this76.$notify({
                title: "Enregistrement",
                message: "La liste a ete enregistre avec succes",
                type: "success",
                position: "top-right",
                duration: 5000
              });
              _this76.$emit("close");
            }
          }, 7000);
        })();
      } //data formulaire inexacte
      else {
          this.loading = false;
          this.$message.error("Veuillez renseigner les champs obligatoires");
        }
    },
    submitComm: function submitComm(formComm) {
      var _this77 = this;

      this.loading = true;
      this.$refs[formComm].validate(function (valid) {
        var etat = false;
        if (_this77.FormComm.optionCommande.length > 0) {
          for (var prop in _this77.FormComm.optionCommande) {
            var item = _this77.FormComm.optionCommande[prop];
            if (item.produit != "" && item.qte > 0) {
              etat = true;
            }
          }
        }

        if (etat == true) {
          var form = document.getElementById("formComm");
          var data = new FormData(form);
          var url = _this77.domaine + "projet/" + _this77.travauxCourant.id + "/new/commande";
          data.append("idUser", _this77.user.id);
          data.append("idPres", _this77.FormComm.fournisseur);
          var ligne = null;
          for (var _prop4 in _this77.FormComm.optionCommande) {
            ligne = _this77.FormComm.optionCommande[_prop4];
            data.append("options[id][]", ligne.id);
            data.append("options[produit][]", ligne.produit);
            data.append("options[qte][]", ligne.qte);
          }

          if (_this77.commandeCourant.id) {
            data.append("id", _this77.commandeCourant.id);
          } else {
            data.append("id", "");
          }

          _this77.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this77.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Commande enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });
                _this77.showProjet(_this77.projetCourant);
                _this77.loadChantier(_this77.projetCourant);
                _this77.loadCommandeAValid(_this77.projetCourant);
                _this77.dialogComm = false;
                _this77.loading = false;
              } else if (verif.code === 0) {
                _this77.$message.error(verif.message);
                _this77.loading = false;
              }
            } else {
              _this77.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this77.loading = false;
            }
          }, function (response) {
            _this77.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this77.loading = false;
          });
        } else {
          _this77.$notify({
            title: "ATTENTION",
            message: "Veuillez renseigner les lignes de la commande.",
            type: "warning",
            position: "top-center"
          });
          _this77.loading = false;
        }
      });
    },
    submitEquipe: function submitEquipe() {
      var _this78 = this;

      this.loading = true;
      if (this.$refs.formEquipe.validate()) {
        var etat = false;
        var form = document.getElementById("formEquipe");
        var data = new FormData(form);
        var url = "";
        if (this.equipeCourant.id != "") {
          url = this.domaine + "projet/" + this.equipeCourant.id + "/edit/contrat";
          etat = true;
        } else {
          url = this.domaine + "projet/" + this.tacheCourant.id + "/new/equipe";
          var ligne = null;
          for (var prop in this.optionEquipe) {
            ligne = this.optionEquipe[prop];
            if (ligne.selectType !== null && ligne.duree !== null && ligne.ouvrier !== null || ligne.fournisseur !== "") {
              etat = true;
              data.append("option[id][]", ligne.id);
              data.append("option[type][]", ligne.selectType);
              data.append("option[ouvrier][]", ligne.ouvrier);
              data.append("option[fournisseur][]", ligne.fournisseur);
              data.append("option[duree][]", ligne.duree);
              data.append("option[montant][]", ligne.montant);
              data.append("option[montantSupp][]", ligne.montantSupp);
            } else {
              etat = false;
            }
          }
        }
        data.append("idUser", this.user.id);
        if (etat) {
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                if (_this78.equipeCourant.id) {
                  _this78.$notify({
                    title: "MODIFICATION REUSSI",
                    message: "Contrat modifié avec succès.",
                    type: "success",
                    position: "top-center"
                  });
                } else {
                  _this78.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Equipe enregistré avec succès.",
                    type: "success",
                    position: "top-center"
                  });
                }

                _this78.loadChantier(_this78.projetCourant);
                _this78.loadEquipe(_this78.travauxCourant);
                _this78.dialogEquipe = false;
                _this78.loading = false;
                _this78.$refs.formEquipe.reset();
              } else if (verif.code === 0) {
                _this78.$message.error(verif.message);
                _this78.loading = false;
              }
            } else {
              _this78.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this78.loading = false;
            }
          }, function (response) {
            _this78.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this78.loading = false;
          });
        } else {
          this.$notify({
            title: "ATTENTION",
            message: "Veuillez renseigner correctement tout les champs.",
            type: "warning",
            position: "top-center"
          });

          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Equipe n'ont pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitDupliqueChantier: function submitDupliqueChantier() {
      var _this79 = this;

      this.loading = true;
      if (this.$refs.formDupliqueChantier.validate()) {
        var etat = false;
        var form = document.getElementById("formDupliqueChantier");
        var data = new FormData(form);
        var url = this.domaine + "projet/" + this.projetCourant.id + "/new/dupliquer/chantier";
        var ligne = null;
        for (var prop in this.optionDuplique) {
          ligne = this.optionDuplique[prop];
          if (ligne.id !== null && ligne.id !== "") {
            etat = true;
            data.append("option[id][]", ligne.id);
          } else {
            etat = false;
          }
        }

        data.append("idUser", this.user.id);
        if (etat) {
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this79.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Copie réussi avec succès.",
                  type: "success",
                  position: "top-center"
                });

                _this79.loadChantier(_this79.projetCourant);
                _this79.dialogDupliqueChantier = false;
                _this79.loading = false;
                _this79.$refs.formDupliqueChantier.reset();
              } else if (verif.code === 0) {
                _this79.$message.error(verif.message);
                _this79.loading = false;
              }
            } else {
              _this79.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this79.loading = false;
            }
          }, function (response) {
            _this79.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this79.loading = false;
          });
        } else {
          this.$notify({
            title: "ATTENTION",
            message: "Veuillez renseigner correctement tout les champs.",
            type: "warning",
            position: "top-center"
          });

          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Equipe n'ont pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitDemarrer: function submitDemarrer() {
      var _this80 = this;

      this.loading = true;
      if (this.$refs.formDemarer.validate()) {
        var etat = false;
        var form = document.getElementById("formDemarer");
        var data = new FormData(form);
        var url = this.domaine + "projet/" + this.travauxCourant.id + "/new/contrat";
        data.append("idUser", this.user.id);
        var ligne = null;
        for (var prop in this.optionDemarer) {
          ligne = this.optionDemarer[prop];
          if (ligne.date !== null) {
            etat = true;
            data.append("option[id][]", ligne.id);
            data.append("option[date][]", ligne.date);
          } else {
            etat = false;
          }
        }
        if (etat) {
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this80.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Contrat démarrer avec succès.",
                  type: "success",
                  position: "top-center"
                });
                _this80.showTravaux(_this80.travauxCourant, _this80.chantierCourant);
                _this80.loadEquipe(_this80.travauxCourant);
                _this80.dialogDemarer = false;
                _this80.loading = false;
                _this80.$refs.formDemarer.reset();
              } else {
                _this80.$message.error(verif.message);
                _this80.loading = false;
              }
            } else {
              _this80.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this80.loading = false;
            }
          }, function (response) {
            _this80.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this80.loading = false;
          });
        } else {
          this.$notify({
            title: "ATTENTION",
            message: "Veuillez renseigner correctement tout les champs.",
            type: "warning",
            position: "top-center"
          });

          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "L'action n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    imprimeAllTresorerie: function imprimeAllTresorerie(item) {
      var url = this.domaine + "caisse/impression/liste/tresor";
      window.open(url);
    },
    addTacheComm: function addTacheComm() {
      this.optionTache.push({
        ordre: this.optionTache.length + 1,
        tache: '',
        libelle: '',
        unite: '',
        dateDebut: '',
        dateFin: '',
        qte: 1,
        prix: 0,
        total: 0
      });
      // this.totComLigneTTC += 5
    },
    submitDemarrerTravaux: function submitDemarrerTravaux() {
      var _this81 = this;

      this.loading = true;
      if (this.$refs.formDemarerTravaux.validate()) {
        var etat = false;
        var form = document.getElementById("formDemarerTravaux");
        var data = new FormData(form);
        var url = this.domaine + "projet/" + this.travauxCourant.id + "/demarrer/travaux";
        data.append("idUser", this.user.id);
        var ligne = null;
        for (var prop in this.optionDemarer) {
          ligne = this.optionDemarer[prop];
          if (ligne.date !== "") {
            etat = true;
            data.append("option[id][]", ligne.id);
            data.append("option[date][]", ligne.date);
          } else {
            etat = false;
          }
        }
        if (etat) {
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this81.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Travaux démarrer avec succès.",
                  type: "success",
                  position: "top-center"
                });
                _this81.showTravaux(_this81.travauxCourant, _this81.chantierCourant);
                _this81.loadEquipe(_this81.travauxCourant);
                _this81.dialogDemarerTravaux = false;
                _this81.loading = false;
                _this81.$refs.formDemarerTravaux.reset();
              } else {
                _this81.$message.error(verif.message);
                _this81.loading = false;
              }
            } else {
              _this81.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this81.loading = false;
            }
          }, function (response) {
            _this81.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this81.loading = false;
          });
        } else {
          this.$notify({
            title: "ATTENTION",
            message: "Veuillez renseigner correctement tout les champs.",
            type: "warning",
            position: "top-center"
          });

          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "L'action n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    addListProduit: function addListProduit() {
      var _this82 = this;

      var libelle = '';
      this.listProd.find(function (item) {
        if (item.id == _this82.selectProduit) {
          libelle = item;
        }
      });
      this.tabListProduit.push({
        type: libelle.type,
        id: libelle.id,
        libelle: libelle.value,
        unite: this.valeurUniteMateriel,
        priorite: this.selectPriorite,
        quantite: this.selectQte
      });
      this.selectQte = 0;
      this.priorite = '';
      this.selectProduit = '';
      this.valeurUniteMateriel = '';
    },
    submitRapport: function submitRapport() {
      var _this83 = this;

      this.loading = true;
      if (this.$refs.formRapport.validate()) {
        var etat = false;
        var form = document.getElementById("formRapport");
        var data = new FormData(form);
        var url = this.domaine + "projet/" + this.tacheCourant.id + "/new/rapport";
        data.append("idUser", this.user.id);
        data.append("evolution", this.evolution);

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this83.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Rapport enregistré avec succès.",
                type: "success",
                position: "top-center"
              });
              _this83.showProjet(_this83.projetCourant);
              _this83.loadChantier(_this83.projetCourant);
              _this83.loadProjetTache(_this83.projetCourant);
              _this83.loadProjet();
              _this83.dialogShowTravaux = false;
              _this83.handleTabClick('2');

              _this83.dialogRapport = false;
              _this83.loading = false;
              _this83.$refs.formRapport.reset();
            } else {
              _this83.$message.error(verif.message);
              _this83.loading = false;
            }
          } else {
            _this83.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this83.loading = false;
          }
        }, function (response) {
          _this83.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this83.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le rapport n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitRapportMultiple: function submitRapportMultiple() {
      var _this84 = this;

      this.loading = true;
      if (this.$refs.formRapportMultiple.validate()) {
        var etat = false;
        var form = document.getElementById("formRapportMultiple");
        var data = new FormData(form);
        var url = this.domaine + "projet/new/rapport/multiple";
        data.append("idUser", this.user.id);
        var ligne = null;
        for (var prop in this.optionRapport) {
          ligne = this.optionRapport[prop];
          if (ligne.id != "") {
            etat = true;
            data.append("option[id][]", ligne.id);
            data.append("option[evolution][]", ligne.evolution);
            data.append("option[description][]", ligne.description);
            data.append("option[fichier][]", ligne.fichier);
          } else {
            etat = false;
          }
        }

        if (etat) {
          this.$http.post(url, data).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this84.$notify({
                  title: "ENREGISTREMENT REUSSI",
                  message: "Rapport enregistré avec succès.",
                  type: "success",
                  position: "top-center"
                });

                _this84.showProjet(_this84.projetCourant);
                _this84.loadChantier(_this84.projetCourant);
                _this84.loadProjetTache(_this84.projetCourant);
                _this84.loadProjet();
                _this84.dialogMultipleRapport = false;
                _this84.loading = false;
                _this84.$refs.formRapportMultiple.reset();
              } else {
                _this84.$message.error(verif.message);
                _this84.loading = false;
              }
            } else {
              _this84.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              _this84.loading = false;
            }
          }, function (response) {
            _this84.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this84.loading = false;
          });
        } else {
          this.$notify({
            title: "ATTENTION",
            message: "Veuillez renseigner correctement tout les champs.",
            type: "warning",
            position: "top-center"
          });

          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Le rapport n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    handleSelect: function handleSelect(produit) {
      var index = this.optionVehicule.indexOf(produit);
      this.optionVehicule.splice(index, 3, produit);
    },
    submitValid: function submitValid() {
      var _this85 = this;

      this.loading = true;
      if (this.$refs.formValid.validate()) {
        var form = document.getElementById("formValid");
        var data = new FormData(form);
        var url = this.domaine + "projet/" + this.tacheCourant.id + "/new/valid";
        data.append("idUser", this.user.id);
        data.append("reponse", this.selectReponse);

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this85.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Validation enregistré avec succès.",
                type: "success",
                position: "top-center"
              });
              _this85.showProjet(_this85.projetCourant);
              _this85.loadChantier(_this85.projetCourant);
              _this85.loadProjetTache(_this85.projetCourant);
              _this85.loadCommandeAValid(_this85.projetCourant);
              _this85.loadCommandeValid(_this85.projetCourant);
              _this85.loadCommandeALivre(_this85.projetCourant);
              _this85.loadCommandeLivre(_this85.projetCourant);
              _this85.loadProjet();
              _this85.dialogValid = false;
              _this85.loading = false;
              _this85.$refs.formValid.reset();
            } else if (verif.code === 0) {
              _this85.$message.error(verif.message);
              _this85.loading = false;
            }
          } else {
            _this85.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this85.loading = false;
          }
        }, function (response) {
          _this85.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this85.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La validation n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitValidCommande: function submitValidCommande() {
      var _this86 = this;

      this.loading = true;
      if (this.$refs.formValidCommande.validate()) {
        var form = document.getElementById("formValidCommande");
        var data = new FormData(form);
        var url = this.domaine + "projet/" + this.commandeCourant.id + "/new/valid/commande";
        data.append("idUser", this.user.id);
        data.append("reponse", this.selectReponse);

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this86.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Validation enregistré avec succès.",
                type: "success",
                position: "top-center"
              });
              _this86.showProjet(_this86.projetCourant);
              _this86.loadChantier(_this86.projetCourant);
              _this86.loadProjetTache(_this86.projetCourant);
              _this86.loadCommandeValid(_this86.projetCourant);
              _this86.loadProjet();
              _this86.dialogValidCommande = false;
              _this86.loading = false;
              _this86.$refs.formValidCommande.reset();
            } else if (verif.code === 0) {
              _this86.$message.error(verif.message);
              _this86.loading = false;
            }
          } else {
            _this86.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this86.loading = false;
          }
        }, function (response) {
          _this86.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this86.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La validation n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    submitPlanifProduit: function submitPlanifProduit() {
      var _this87 = this;

      this.loading = true;

      var etat = true;
      var etatVeh = true;
      var form = document.getElementById("formPlanifProduit");
      var data = new FormData(form);
      var url = this.domaine + "projet/" + this.travauxCourant.id + "/new/planification/produit/travaux";
      data.append("idUser", this.user.id);
      var ligne = null;
      for (var prop in this.optionProduit) {
        var _ligne3 = this.optionProduit[prop];
        if (_ligne3.produit != "" && _ligne3.qte != 0) {
          //etat = true;
          data.append("option[produit][]", _ligne3.produit);
          data.append("option[qte][]", _ligne3.qte);
          data.append("option[priorite][]", _ligne3.priorite);
        } else {
          etat = false;
        }
      }

      for (var _prop5 in this.optionVehicule) {
        var _ligne4 = this.optionVehicule[_prop5];
        if (_ligne4.vehicule != "" && _ligne4.qte != 0 && _ligne4.duree != 0) {
          //etatVeh = true;
          data.append("optionVeh[vehicule][]", _ligne4.vehicule);
          data.append("optionVeh[qte][]", _ligne4.qte);
          data.append("optionVeh[priorite][]", _ligne4.priorite);
          data.append("optionVeh[periode][]", _ligne4.periode);
        } else {
          etatVeh = false;
        }
      }

      if (etat == true && etatVeh == true) {
        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this87.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: response.body.message,
                type: "success",
                position: "top-center"
              });
              //affichage message info
              _this87.dialogInfoPlan = true;

              _this87.showProjet(_this87.projetCourant);
              _this87.loadChantier(_this87.projetCourant);
              _this87.loadProjetTache(_this87.projetCourant);
              _this87.dialogPlanifProduit = false;
              _this87.loading = false;
              _this87.$refs.formPlanifProduit.reset();
            } else if (verif.code === 0) {
              _this87.$message.error(verif.message);
              _this87.loading = false;
            }
          } else {
            _this87.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this87.loading = false;
          }
        }, function (response) {
          _this87.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this87.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner correctement les champs.");
        this.loading = false;
      }
      // } else {
      //   this.$message.error("Veuillez renseigner les champs obligatoires");
      //   this.$notify.error({
      //     title: "ERREUR D'ENREGISTREMENT",
      //     message: "La validation n'a pas été enregistré.",
      //     position: "top-center"
      //   });
      //   this.loading = false;
      // }
    },
    submitPlanifTacheProduit: function submitPlanifTacheProduit() {
      var _this88 = this;

      this.loading = true;
      var etat = true;
      var etatVeh = true;
      var form = document.getElementById("formPlanifProduit");
      var data = new FormData(form);
      var url = this.domaine + "tache/planification/" + this.tacheS;
      data.append("idUser", this.user.id);
      // let ligne = null;
      for (var prop in this.optionProduit) {
        var ligne = this.optionProduit[prop];
        if (ligne.produit != "" && ligne.qte != 0) {
          //etat = true;
          data.append("option[produit][]", ligne.produit);
          data.append("option[qte][]", ligne.qte);
          data.append("option[priorite][]", ligne.priorite);
        } else {
          etat = false;
        }
      }

      for (var _prop6 in this.optionVehicule) {
        var _ligne5 = this.optionVehicule[_prop6];
        if (_ligne5.value != "" && _ligne5.qte != 0 && _ligne5.periode != "") {
          //etatVeh = true;
          data.append("optionVeh[vehicule][]", _ligne5.value);
          data.append("optionVeh[qte][]", _ligne5.qte);
          data.append("optionVeh[unite][]", _ligne5.unite);
          data.append("optionVeh[periode][]", _ligne5.periode);
        } else {
          etatVeh = false;
        }
      }

      if (etat == true && etatVeh == true) {
        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this88.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: "Planification de produit enregistré avec succès.",
                type: "success",
                position: "top-center"
              });
              //affichage message info
              _this88.dialogInfoPlan = true;

              //this.showProjet(this.projetCourant);
              //this.loadChantier(this.projetCourant);
              //this.loadProjetTache(this.projetCourant);
              _this88.dialogPlanifProduit = false;
              _this88.loading = false;
              _this88.$refs.formPlanifProduit.reset();
            } else if (verif.code === 0) {
              _this88.$message.error(verif.message);
              _this88.loading = false;
            }
          } else {
            _this88.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
            _this88.loading = false;
          }
        }, function (response) {
          _this88.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          _this88.loading = false;
        });
      } else {
        this.$message.error("Veuillez renseigner correctement les champs.");
        this.loading = false;
      }
    },
    imprimerRapportGeneral: function imprimerRapportGeneral(item, type, chantier, travaux, date, etat) {
      if (type == "") {
        type = null;
      }
      if (chantier == "") {
        chantier = null;
      }
      if (travaux == "") {
        travaux = null;
      }
      if (date == "") {
        date = null;
      }
      if (etat == "") {
        etat = null;
      }
      var url = "";
      if (item == "PDF") {
        url = this.domaine + "projet/" + type + "/" + chantier + "/" + travaux + "/" + date + "/" + etat + "/imprimer/rapport";
      } else {
        url = this.domaine + "projet/" + type + "/" + chantier + "/" + travaux + "/" + date + "/" + etat + "/excel/rapport";
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    imprimerContrat: function imprimerContrat(ligne) {
      this.equipeCourant = ligne;
      var url = this.domaine + "projet/" + this.equipeCourant.id + "/imprimer/contrat";
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    imprimerTravaux: function imprimerTravaux(ligne) {
      this.travauxCourant = ligne;
      var url = this.domaine + "projet/" + this.travauxCourant.id + "/imprimer/travaux";
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    imprimerTache: function imprimerTache(ligne) {
      this.tacheCourant = ligne;
      var url = this.domaine + "projet/" + this.tacheCourant.id + "/imprimer/tache/travaux";
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    imprimerTacheTravaux: function imprimerTacheTravaux(ligne) {
      this.travauxCourant = ligne;
      var url = this.domaine + "projet/" + this.travauxCourant.id + "/imprimer/tache/travaux/all";
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    imprimerContratTravaux: function imprimerContratTravaux(ligne) {
      this.travauxCourant = ligne;
      var url = this.domaine + "projet/" + this.travauxCourant.id + "/imprimer/contrat/travaux/all";
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    mapGoogle: function mapGoogle() {
      window.open("https://www.google.com/maps/@?api=1&map_action=map");
    },
    imprimerCommande: function imprimerCommande(ligne) {
      this.commandeCourant = ligne;
      var url = this.domaine + "fournisseur/" + this.commandeCourant.id + "/imprimer/commande/user/" + this.user.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    duplicateChantier: function duplicateChantier(item) {
      this.libelleSelect = item;
      this.showDialogDupTrx = true;
    },
    imprimerChantier: function imprimerChantier(ligne) {
      this.chantierCourant = ligne;
      var url = this.domaine + "projet/" + ligne.id + "/imprimer/chantier";
      this.$http.get(url).then(function (response) {
        if (response.body) {}
      });
      window.open(url);
    },
    imprimeListeHisProjets: function imprimeListeHisProjets(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "projet/imprimerPDF/historique/projet/liste";
      } else {
        url = this.domaine + "projet/imprimerEXC/historique/projet/liste";
      }
      window.open(url);
    },
    imprimeListeHisChantierProjet: function imprimeListeHisChantierProjet(type) {
      var idProj = this.projetCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "projet/imprimerPDF/historique/" + idProj + "/chantier/liste";
      } else {
        url = this.domaine + "projet/imprimerEXC/historique/" + idProj + "/chantier/liste";
      }
      window.open(url);
    },
    imprimeListeHisPlanTravauxProjet: function imprimeListeHisPlanTravauxProjet(type) {
      var idProj = this.projetCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "projet/imprimerPDF/historique/" + idProj + "/plan-travaux/liste";
      } else {
        url = this.domaine + "projet/imprimerEXC/historique/" + idProj + "/plan-travaux/liste";
      }
      window.open(url);
    },
    imprimeListeHisSuivieTacheProjet: function imprimeListeHisSuivieTacheProjet(type) {
      var idProj = this.projetCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "projet/imprimerPDF/historique/" + idProj + "/suivie-tache/liste";
      } else {
        url = this.domaine + "projet/imprimerEXC/historique/" + idProj + "/suivie-tache/liste";
      }
      window.open(url);
    },
    imprimeListeHisSuivieContratProjet: function imprimeListeHisSuivieContratProjet(type) {
      var idProj = this.projetCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "projet/imprimerPDF/historique/" + idProj + "/suivie-contrat/liste";
      } else {
        url = this.domaine + "projet/imprimerEXC/historique/" + idProj + "/suivie-contrat/liste";
      }
      window.open(url);
    },
    imprimeListeHisSuivieCmdeAvaliderProjet: function imprimeListeHisSuivieCmdeAvaliderProjet(type) {
      var idProj = this.projetCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "projet/imprimerPDF/historique/" + idProj + "/suivie-cmde-a-valider/liste";
      } else {
        url = this.domaine + "projet/imprimerEXC/historique/" + idProj + "/suivie-cmde-a-valider/liste";
      }
      window.open(url);
    },
    imprimeListeHisSuivieCmdeValiderProjet: function imprimeListeHisSuivieCmdeValiderProjet(type) {
      var idProj = this.projetCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "projet/imprimerPDF/historique/" + idProj + "/suivie-cmde-valider/liste";
      } else {
        url = this.domaine + "projet/imprimerEXC/historique/" + idProj + "/suivie-cmde-valider/liste";
      }
      window.open(url);
    },
    imprimeListeHisSuivieCmdeAlivrerProjet: function imprimeListeHisSuivieCmdeAlivrerProjet(type) {
      var idProj = this.projetCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "projet/imprimerPDF/historique/" + idProj + "/suivie-cmde-a-livrer/liste";
      } else {
        url = this.domaine + "projet/imprimerEXC/historique/" + idProj + "/suivie-cmde-a-livrer/liste";
      }
      window.open(url);
    },
    imprimeListeHisSuivieCmdLivrerProjet: function imprimeListeHisSuivieCmdLivrerProjet(type) {
      var idProj = this.projetCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "projet/imprimerPDF/historique/" + idProj + "/suivie-cmde-livrer/liste";
      } else {
        url = this.domaine + "projet/imprimerEXC/historique/" + idProj + "/suivie-cmde-livrer/liste";
      }
      window.open(url);
    },
    imprimeListeHisSuivieAllCmdesProjet: function imprimeListeHisSuivieAllCmdesProjet(type) {
      var idProj = this.projetCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "projet/imprimerPDF/historique/" + idProj + "/suivie-all-cmdes/liste";
      } else {
        url = this.domaine + "projet/imprimerEXC/historique/" + idProj + "/suivie-all-cmdes/liste";
      }
      window.open(url);
    },
    imprimeListeHisSuivieEngEtVehiculeProjet: function imprimeListeHisSuivieEngEtVehiculeProjet(type) {
      var idProj = this.projetCourant.id;
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "projet/imprimerPDF/historique/" + idProj + "/suivie-engins-vehicule/liste";
      } else {
        url = this.domaine + "projet/imprimerEXC/historique/" + idProj + "/suivie-engins-vehicule/liste";
      }
      window.open(url);
    },
    attachSecretMessage: function attachSecretMessage(marker, secretMessage) {
      var infowindow = new google.maps.InfoWindow({
        content: secretMessage
      });

      marker.addListener("click", function () {
        infowindow.open(marker.get("map"), marker);
      });
    },
    modalMap: function modalMap() {
      this.showModalMap = true;
    },
    addOptionChantier: function addOptionChantier() {
      this.optionChantier.push({
        key: Date.now(),
        libelle: "",
        duree: null,
        montant: 0,
        idChef: null,
        id: ""
      });
    },
    addOptionComm: function addOptionComm() {
      this.FormComm.optionCommande.push({
        key: Date.now(),
        produit: "",
        qte: 1,
        unite: "",
        id: ""
      });
      this.totComLigneTTC += 5;
    },
    addOptionP: function addOptionP() {
      this.optionProduit.push({
        key: Date.now(),
        type: "",
        produit: "",
        qte: 1,
        priorite: ""
      });
      this.valeurUniteMateriel = '';
    },
    addOptionV: function addOptionV() {
      var _this89 = this;

      var libelle = '';
      this.loptionVehicule.find(function (item) {
        if (item.id == _this89.prodSelctEngin) {
          libelle = item;
        }
      });
      var date = this.periodeEngin[0] + ' au ' + this.periodeEngin[1];
      this.tabListEngin.push({
        id: libelle.id,
        libelle: libelle.value,
        quantite: this.selectEnginQte,
        periode: date,
        priorite: this.selectEnginPriorite
      });
      this.selectEnginQte = 0;
      this.prodSelctEngin = '';
      this.valeurUniteMateriel = '';

      // this.optionVehicule.push({
      //   key: Date.now(),
      //   vehicule: "",
      //   qte: 1,
      //   unite: "",
      //   periode: ""
      // });
    },
    addOptionEquipe: function addOptionEquipe() {
      if (this.tacheCourant.soutraite == 1) {
        this.optionEquipe.push({
          key: Date.now(),
          type: [{ text: "Prestataire", value: 1 }],
          selectType: 1,
          fournisseur: this.tacheCourant.idFour,
          ouvrier: "",
          duree: "",
          montant: 0,
          montantSupp: 0,
          id: ""
        });
      } else {
        this.optionEquipe.push({
          key: Date.now(),
          type: [{ text: "Prestataire", value: 1 }, { text: "Manoeuvre", value: 2 }],
          selectType: "",
          fournisseur: "",
          ouvrier: "",
          duree: "",
          montant: 0,
          montantSupp: 0,
          id: ""
        });
      }

      this.totComLigneTTC += 5;
    },
    removePlan: function removePlan(item) {
      var index = this.optionChantier.indexOf(item);
      if (index !== -1) {
        this.optionChantier.splice(index, 1);
      }
    },
    removeTache: function removeTache(item) {
      var index = this.optionTache.indexOf(item);
      if (index !== -1) {
        if (this.optionTache[index].total != undefined) {
          this.totalHT -= this.optionTache[index].total;
        }
        // enregistrer lid du lot de travaux supprimer dans la liste
        if (this.optionTache[index].id != null) {
          this.listeTacheSupp.push(this.optionTache[index].idOptionTrx);
        }
        this.optionTache.splice(index, 1);
      }
    },
    removeOptionComm: function removeOptionComm(item) {
      var index = this.FormComm.optionCommande.indexOf(item);
      if (index !== -1) {
        this.FormComm.optionCommande.splice(index, 1);
      }
    },
    findUnite: function findUnite(index) {
      //  this.uniteAffic =index['unite']
    },
    removeOptionP: function removeOptionP(item) {
      var index = this.optionProduit.indexOf(item);
      if (index !== -1) {
        this.optionProduit.splice(index, 1);
      }
    },
    removeOptionBesoin: function removeOptionBesoin(item) {
      var index = this.optionVehicule.indexOf(item);
      if (index !== -1) {
        this.optionVehicule.splice(index, 1);
      }
    },
    removeOptionV: function removeOptionV(item) {
      var index = this.optionVehicule.indexOf(item);
      if (index !== -1) {
        this.optionVehicule.splice(index, 1);
      }
    },
    removeOptionEquipe: function removeOptionEquipe(item) {
      var index = this.optionEquipe.indexOf(item);
      if (index !== -1) {
        this.optionEquipe.splice(index, 1);
      }
    },
    deleteCharge: function deleteCharge(item) {
      var _this90 = this;

      var url = this.domaine + "projet/delete/charge/" + this.idCharge;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this90.$notify({
            title: "SUPPRESSION",
            message: "Charge supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          _this90.dialogSuprCharge = false;
          _this90.loadChargeIndirect();
        }
      });
    },
    deleteProjet: function deleteProjet(item) {
      var _this91 = this;

      var url = this.domaine + "projet/delete/" + this.idProjet;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this91.$notify({
            title: "SUPPRESSION",
            message: "Projet supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          _this91.dialogSupr = false;
          _this91.loadListeProjet();
          _this91.loadProjet();
          _this91.loadPage();
        }
      });
    },
    deleteChantier: function deleteChantier(item) {
      var _this92 = this;

      this.loading = true;
      var url = this.domaine + "projet/delete/chantier/" + this.idChantier;
      this.$http.get(url).then(function (response) {
        _this92.loading = false;
        _this92.dialogSuprChantier = false;
        if (response.body.code == 3) {
          _this92.$notify({
            title: "SUPPRESSION",
            message: response.body.message,
            type: "warning",
            duration: 5000,
            position: "top-center"
          });
          return;
        }

        if (response.body) {
          _this92.$notify({
            title: "SUPPRESSION",
            message: "Chantier supprimé avec succès.",
            type: "success",
            position: "top-center",
            duration: 5000
          });
          _this92.dialogSuprChantier = false;
          _this92.showProjet(_this92.projetCourant);
          _this92.loadChantier(_this92.projetCourant);
          _this92.loadPage();
        }
      }, function (error) {
        _this92.loading = false;
        _this92.$message.error("Vous ne pouvez pas supprimer un chantier,car il est lié à un autre traitement.'");
      });
    },
    deleteTravaux: function deleteTravaux() {
      var _this93 = this;

      var url = this.domaine + "projet/delete/travaux/" + this.idTravaux;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          if (response.body.code == 2) {
            _this93.$notify(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({
              title: 'SUPPRESSION',
              duration: 5000,
              message: resp.body.message,
              type: 'warning'
            }, "duration", 5000));
          } else {
            _this93.$notify({
              title: "SUPPRESSION REUSSI",
              message: "Travaux supprimé avec succès",
              type: "success",
              position: "top-center",
              duration: 5000
            });
          }
          _this93.dialogSuprTravaux = false;
          _this93.showProjet(_this93.projetCourant);
          _this93.loadChantier(_this93.projetCourant);
          if (_this93.selectSearchChantierFind != null) _this93.loadAffSupTravaux(_this93.selectSearchChantierFind);
          _this93.loadPage();
        }
      }, function (response) {
        _this93.$message.error("Une erreur est survenue lors de la supression,Veuillez contacter votre administrateur");
      });
    },
    deleteTache: function deleteTache(item) {
      var _this94 = this;

      var url = this.domaine + "projet/delete/tache/" + this.idTache;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this94.$notify({
            title: "SUPPRESSION",
            message: "Tâche supprimé avec succès.",
            type: "success",
            position: "top-center",
            duration: 5000
          });
          _this94.dialogSuprTache = false;
          _this94.showProjet(_this94.projetCourant);
          _this94.loadChantier(_this94.projetCourant);
          _this94.loadTravauxProjet(_this94.projetCourant);
          _this94.loadPage();
        }
      });
    },
    handleRemove: function handleRemove(file, fileList) {},
    handlePreview: function handlePreview(file) {},
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning("La limite est 3, vous avez choisi " + files.length + " fichiers, soit " + (files.length + fileList.length) + " au total.");
    },
    beforeRemove: function beforeRemove(file, fileList) {
      return this.$confirm("Supprimer le fichier de " + file.name + " ?");
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.choix = true;
      } else {
        this.choix = false;
      }
    },
    selectionChangeDuplique: function selectionChangeDuplique(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.choixChantier = true;
      } else {
        this.choixChantier = false;
      }
    },
    selectionChangeTravaux: function selectionChangeTravaux(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.choixTravux = true;
      } else {
        this.choixTravux = false;
      }
    },
    contratSelect: function contratSelect(row, index) {
      var etat = null;
      if (parseInt(row.etat) === 0) {
        etat = true;
      } else {
        etat = false;
      }
      return etat;
    },
    soustraitanceSelect: function soustraitanceSelect(row, index) {
      var etat = null;
      if (parseInt(row.soutraite) === 1 && row.etatContrat == 0) {
        etat = true;
      } else {
        etat = false;
      }
      return etat;
    },
    querySearch: function querySearch(queryString, cb) {
      var links = this.listKeyword;
      var results = queryString ? links.filter(this.createFilter(queryString)) : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter: function createFilter(queryString) {
      return function (link) {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    projet: function projet(item) {
      this.$router.push({
        name: "Projets",
        params: { projet_id: item.id, projets_id: "0" }
      });
    },

    beforeMount: function beforeMount() {
      if (!this.roleAcces[this.$router.history.current.name]) {
        this.$router.push({ name: "Home" });
      }
    }
  },
  computed: {
    disabledBtnContTrx: function disabledBtnContTrx() {
      return true;
    },

    verifFormBudget: function verifFormBudget() {
      if (this.formBudget.libelle.libelle != null && this.formBudget.montantAdecaisse != null) {
        return true;
      } else {
        return true;
      }
    }
  }
});

/***/ }),

/***/ "pcwE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","xs12":""}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"100%"},model:{value:(_vm.dialogAjoutConducteur),callback:function ($$v) {_vm.dialogAjoutConducteur=$$v},expression:"dialogAjoutConducteur"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter des dépenses au projet "+_vm._s(_vm.projet.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{staticClass:"mb-2",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"red lighten-1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xs12":""}},[_c('div',[_vm._v("MONTANT DÉBIT")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v("\n                            "+_vm._s(new Intl.NumberFormat().format(
                                _vm.listTotals.montantD
                              ))+"\n                            XOF\n                          ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"green lighten-1"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xs12":""}},[_c('div',[_vm._v("MONTANT CRÉDIT")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v("\n                            "+_vm._s(new Intl.NumberFormat().format(
                                _vm.listTotals.montantC
                              ))+"\n                            XOF\n                          ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"red darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xs12":""}},[_c('div',[_vm._v("SOLDE DÉBITEURS")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v("\n                            "+_vm._s(new Intl.NumberFormat().format(
                                _vm.listTotals.soldeD
                              ))+"\n                            XOF\n                          ")])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"sm3":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"green darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xs12":""}},[_c('div',[_vm._v("SOLDE CRÉDITEURS")]),_vm._v(" "),_c('div',{staticClass:"display-1"},[_vm._v("\n                            "+_vm._s(new Intl.NumberFormat().format(
                                _vm.listTotals.soldeC
                              ))+"\n                            XOF\n                          ")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeTypeTravaux}},[_c('el-table-column',{staticStyle:{"width":"100%"},attrs:{"prop":"date","label":"Date"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                        "+_vm._s(scope.row.date)+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{staticStyle:{"width":"100%"},attrs:{"prop":"code","label":"Numéro de compte"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                        "+_vm._s(scope.row.code)+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{staticStyle:{"width":"100%"},attrs:{"prop":"banque","label":"Trésorerie"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                        "+_vm._s(scope.row.banque)+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{staticStyle:{"width":"100%"},attrs:{"prop":"libelle","label":"Libellé écriture"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                        "+_vm._s(scope.row.libelle)+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{staticStyle:{"width":"100%"},attrs:{"prop":"montantD","label":"Montant débit"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                        "+_vm._s(scope.row.montantD)+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{staticStyle:{"width":"100%"},attrs:{"prop":"montantC","label":"Montant crédit"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                        "+_vm._s(scope.row.montantC)+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{staticStyle:{"width":"100%"},attrs:{"prop":"soldeD","label":"Solde débiteur"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                        "+_vm._s(scope.row.soldeD)+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{staticStyle:{"width":"100%"},attrs:{"prop":"soldeC","label":"Solde créditeur"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("\n                        "+_vm._s(scope.row.soldeC)+"\n                      ")])]}}])})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){return _vm.saveListe()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer cette ligne ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteRow()}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pnvJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LoadConducteurExcel",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  props: {
    listeTypeTravaux: {
      type: Array,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    idTypeTravaux: {
      type: Number
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      dialogAjoutConducteur: false,
      loading: false
    };
  },

  watch: {
    show: function show(newValue, oldValue) {
      if (newValue == true) {
        this.dialogAjoutConducteur = true;
      } else {
        this.dialogAjoutConducteur = false;
      }
    }
  },
  methods: {
    saveListe: function saveListe() {
      var _this = this;

      var succesEnreg = true;
      var url = this.domaine + "projet/save/liste_Taches/excel";
      var nbData = 10;
      var nbReq = 1;
      var ligne = null;

      var nbRest = void 0;

      if (this.listeTypeTravaux.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.listeTypeTravaux.length / nbData);
        nbRest = this.listeTypeTravaux.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (var i = 0; i < nbReq; i++) {
        var initJ = i * nbData;
        var finJ = (i + 1) * nbData;
        var dataLot = [];
        if (this.listeTypeTravaux.length > 0) {
          for (var j = initJ; j < finJ; j++) {
            if (this.listeTypeTravaux[j] == undefined) {
              break;
            }
            dataLot.push(this.listeTypeTravaux[j]);
          }
        }
        var data = new FormData();
        // data.append('listeTypeTravaux', JSON.stringify(dataLot))
        for (var prop in dataLot) {
          ligne = dataLot[prop];
          data.append("option[ordre][]", ligne.ordre);
          data.append("option[libelle][]", ligne.libelle);
          data.append("option[unite][]", ligne.unite);
          data.append("option[valeur][]", ligne.prix);
          data.append("option[description][]", ligne.description);
        }

        data.append("idTypeTache", this.idTypeTravaux);
        data.append("idUser", this.user.id);

        this.$http.post(url, data).then(function (resp) {}, function (error) {
          _this.loading = false;
          _this.$message.error("Erreur lors de l'enregistrement des types travaux");
          succesEnreg = false;
          window.location.reload();
        });
      }
      var loading = this.$loading({
        lock: true,
        text: "Veuillez patientez ...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
        // this.loading = false
        _this.dialogAjoutConducteur = false;
        if (succesEnreg == true) {
          _this.$notify({
            title: "Enregistrement",
            message: "La liste a ete enregistre avec succes",
            type: "success",
            position: "top-right",
            duration: 7000
          });
          _this.$emit("close");
        }
      }, 30000);
    },
    loadTache: function loadTache() {
      var _this2 = this;

      var url = "";
      if (this.droitAcces.index_tache_type) {
        url = this.domaine + "projet/index/tache/type";
      } else {
        url = this.domaine + "projet/index/" + this.user.id + "/tache/type";
      }
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this2.listTache = response.body.tache;
          _this2.listeRapportTrx = response.body.tache;
          _this2.itemsTaches = response.body.tache;
        }
      });
    },
    closeDialog: function closeDialog() {
      var _this3 = this;

      var loading = this.$loading({
        lock: true,
        text: "Veuillez patientez ...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
        _this3.$emit("close");
      }, 1000);
    }
  }
});

/***/ }),

/***/ "prMl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParcAuto_vue__ = __webpack_require__("+3Xw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ce8c75c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParcAuto_vue__ = __webpack_require__("PsOW");
function injectStyle (ssrContext) {
  __webpack_require__("Ebd3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ParcAuto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ce8c75c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ParcAuto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pryE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demande_fond_index_vue__ = __webpack_require__("b6Bl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6c1bc0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Demande_fond_index_vue__ = __webpack_require__("vA4v");
function injectStyle (ssrContext) {
  __webpack_require__("dczU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d6c1bc0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Demande_fond_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6c1bc0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Demande_fond_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pxXP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v(_vm._s(item.text)+"\n                ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-3",staticStyle:{"width":"100%"}},[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h3',[_vm._v("Liste des budgets chantiers")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-form',{ref:"",attrs:{"lazy-validation":"","id":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","clearable":"","placeholder":"Chantier"},model:{value:(_vm.selectSearchChantier),callback:function ($$v) {_vm.selectSearchChantier=$$v},expression:"selectSearchChantier"}},_vm._l((_vm.listeAfficheChantier),function(item){return _c('el-option',{key:item.idChant,attrs:{"label":item.libelle,"value":item.idChant}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.libelle.toUpperCase()))])])}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-btn',{attrs:{"icons":"","color":"primary","small":""},on:{"click":function($event){return _vm.loadBudgetSeclect()}}},[_vm._v("\n                                    VALIDER\n                                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("search")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL MONTANT PROPOSE\n                                : "+_vm._s(new
                                Intl.NumberFormat().format(_vm.totalMntPropose))+" ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL MONTANT VALIDE\n                                : "+_vm._s(new
                                Intl.NumberFormat().format(_vm.totalMntValide))+" ")])])],1)],1),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"border":"","header-row-style":_vm.headerRowStyle,"highlight-current-row":"","data":_vm.listeChantier,"summary-method":_vm.getSummExploitBudget,"show-summary":""}},[_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"libelle","label":"CHANTIER"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(" "+_vm._s(prop.row.libelle)+"  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"mntTotalProjetPropose","label":"MONTANT TOTAL PROPOSE"},scopedSlots:_vm._u([{key:"default",fn:function(prop4){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"blue"}},[_vm._v("\n                                "+_vm._s(new Intl.NumberFormat().format(prop4.row.mntTotalProjetPropose))+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"mntTotalProjetValide","label":"MONTANT TOTAL VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(prop5){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"success"}},[_vm._v("\n                                "+_vm._s(new Intl.NumberFormat().format(prop5.row.mntTotalProjetValide))+"\n                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT","prop":"etat"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":scope.row.etat == 0 ? 'warning' : 'success',"disable-transitions":""}},[_vm._v(_vm._s(scope.row.libEtatBudget))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etatBudget != 3)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){return _vm.modalDetailChant(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1):_vm._e(),_vm._v("Detail du chantier\n                            ")],1)]}}])})],1)],1)],1)],1)],1),_vm._v(" "),_c('DetailBudgetChant',{attrs:{"show":_vm.showDetailChant,"detailChant":_vm.detChant},on:{"close":function($event){_vm.showDetailChant = false; _vm.loadBudget()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q0O9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_tache_chantier_vue__ = __webpack_require__("Lfa6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fae0945_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_tache_chantier_vue__ = __webpack_require__("xhyT");
function injectStyle (ssrContext) {
  __webpack_require__("i4xy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_tache_chantier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fae0945_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_tache_chantier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q0WE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q1LB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_indexProjet_vue__ = __webpack_require__("N6XL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98992b2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_indexProjet_vue__ = __webpack_require__("sd6U");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_indexProjet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98992b2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_indexProjet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q590":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"elevation-2 pt-3 pl-3 pr-3",staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('h4',{attrs:{"mt-2":""}},[_vm._v("MATRICE PROJET")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","mt-3":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","disabled":false,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeMatricePDF()}},slot:"activator"},[_vm._v("\n           Imprimer\n           "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1):_vm._e(),_vm._v("Imprimer la matrice\n       ")],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","dark":""},on:{"click":function($event){return _vm.showAjoutDoc()}}},[_vm._v("\n              Ajouter\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"elevation-1",attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeDoc,"border":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',{staticClass:"ml-3"},[_c('el-col',{attrs:{"span":5}},[_c('div',{staticClass:"ml-2"},[_c('b',[_vm._v("Description")]),_vm._v(" : "),_c('p',[_vm._v(_vm._s(props.row.commentaire))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":19}},[_c('div',[_c('b',[_vm._v("Versions du document")]),_vm._v(" :\n                      ")]),_vm._v(" "),_c('div',{staticClass:"elevation-1"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":props.row.versions}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"IDENTIFIANT"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateCreated","label":"DATE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userCreated","label":"ENREGISTRER PAR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libStatus","label":"Status"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mode","label":"MODE DE TRANSMISSION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateSend","label":" DATE DE TRANSMISSION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","width":"100","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scop){return [_c('v-btn',{attrs:{"slot":"activator","disabled":props.row.close,"color":"orange","fab":"","dark":"","flat":"","small":""},nativeOn:{"click":function($event){return _vm.showDialogVersionEdit(scop.row)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"slot":"activator","color":"primary","fab":"","dark":"","flat":"","small":""},nativeOn:{"click":function($event){return _vm.showDialogVersionDetail(scop.row)}},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-btn',{attrs:{"slot":"activator","disabled":props.row.close,"color":"red","fab":"","dark":"","flat":"","small":""},nativeOn:{"click":function($event){return _vm.showDialogSuppVersion(scop.row)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1)]}}],null,true)})],1)],1)])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ordre","label":"N ORDRE","align":"center","width":"230"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE","align":"center","width":"230"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"categorie","label":"CATEGORIE","align":"center","width":"230"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"numDoc","label":"NUMERO DOCUMENT","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"STATUS","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userCreated","label":"ENREGISTRE PAR","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","width":"200","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"bottom":""}},[(scope.row.close == false)?_c('v-btn',{attrs:{"slot":"activator","color":"purple","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.showAddVersion(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("description")])],1):_vm._e(),_vm._v("Version\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.showEditDoc(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_vm._v("Modifier\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"red","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.showDilogSupp(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v("Supprimer\n            ")],1)]}}])})],1)],1)],1),_vm._v(" "),(!_vm.droitAcces.delete_matrice)?_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","closable":false,"show-icon":"","type":"warning"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("DOCUMENT")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("NUMERO-12345")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("\n          Annuler\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.deleteDoc()}}},[_vm._v("\n          Supprimer\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogSuprVers),callback:function ($$v) {_vm.dialogSuprVers=$$v},expression:"dialogSuprVers"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","closable":false,"show-icon":"","type":"warning"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("DOCUMENT")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("version-"+_vm._s(_vm.versionSelect.libelle))])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSuprVers = false}}},[_vm._v("\n          Annuler\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.deleteVersion()}}},[_vm._v("\n          Supprimer\n          "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"80%","persistent":true,"transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogDoc),callback:function ($$v) {_vm.dialogDoc=$$v},expression:"dialogDoc"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter ou modifier un document")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogDoc = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formDoc",staticClass:"demo-form-inline",attrs:{"id":"formDoc","model":_vm.formDoc,"rules":_vm.rulesFormDoc}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Numéro d'ordre","prop":"ordre"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"ordre","placeholder":"N ordre"},model:{value:(_vm.formDoc.ordre),callback:function ($$v) {_vm.$set(_vm.formDoc, "ordre", $$v)},expression:"formDoc.ordre"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Libellé","prop":"libelle"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"libelle"},model:{value:(_vm.formDoc.libelle),callback:function ($$v) {_vm.$set(_vm.formDoc, "libelle", $$v)},expression:"formDoc.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Catégorie","prop":"categorie"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"categorie","placeholder":"Catégorie"},model:{value:(_vm.formDoc.categorie),callback:function ($$v) {_vm.$set(_vm.formDoc, "categorie", $$v)},expression:"formDoc.categorie"}},_vm._l((_vm.categories),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Numéro du document","prop":"numDoc"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"numDoc","placeholder":"Numéro document"},model:{value:(_vm.formDoc.numDoc),callback:function ($$v) {_vm.$set(_vm.formDoc, "numDoc", $$v)},expression:"formDoc.numDoc"}})],1)],1),_vm._v(" "),(_vm.editForm == false)?_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Version","prop":"version"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"version","placeholder":"Version"},model:{value:(_vm.formDoc.version),callback:function ($$v) {_vm.$set(_vm.formDoc, "version", $$v)},expression:"formDoc.version"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.editForm == false)?_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Mode de transmission","prop":"mode"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"mode","placeholder":"Mode de transmission"},model:{value:(_vm.formDoc.mode),callback:function ($$v) {_vm.$set(_vm.formDoc, "mode", $$v)},expression:"formDoc.mode"}},_vm._l((_vm.mode),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date de transmission","required":""}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"value-format":"dd-MM-yyyy","type":"date","id":"dateSend","name":"dateSend","placeholder":"Date"},model:{value:(_vm.formDoc.dateSend),callback:function ($$v) {_vm.$set(_vm.formDoc, "dateSend", $$v)},expression:"formDoc.dateSend"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"commentaire"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":10,"name":"commentaire","placeholder":"commentaire"},model:{value:(_vm.formDoc.commentaire),callback:function ($$v) {_vm.$set(_vm.formDoc, "commentaire", $$v)},expression:"formDoc.commentaire"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-3",attrs:{"xs4":""}},[_c('p',{staticClass:"font-weight-thin"},[_vm._v("Format (JPEG,PNG,PDF), 10 Mo maximum")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.logoMatrice,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoMatrice,"alt":"avatar"}})]),_c('br')],1),_vm._v(" "),_c('input',{ref:"fileLogo",staticStyle:{"display":"none"},attrs:{"name":"docs","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageLogoPicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileLogo.click()}}},[_vm._v("Document  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){_vm.dialogDoc = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.editForm == false)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.addDoc('formDoc')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.editDoc('formDoc')}}},[_vm._v("Modifier"),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"70%","persistent":true,"transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogVersion),callback:function ($$v) {_vm.dialogVersion=$$v},expression:"dialogVersion"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter une version au document ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogVersion = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formVersion",staticClass:"demo-form-inline",attrs:{"id":"formVersion","model":_vm.formVersion,"rules":_vm.rulesFormVersion}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Identifiant(version)","prop":"ordre"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.newVersion,"name":"identifiant","placeholder":"Identifiant de la version"},model:{value:(_vm.formVersion.libelle),callback:function ($$v) {_vm.$set(_vm.formVersion, "libelle", $$v)},expression:"formVersion.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{attrs:{"label":"Mode de transmission","prop":"mode"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.newVersion,"name":"mode","placeholder":"Mode de transmission"},model:{value:(_vm.formVersion.mode),callback:function ($$v) {_vm.$set(_vm.formVersion, "mode", $$v)},expression:"formVersion.mode"}},_vm._l((_vm.mode),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.newVersion == false),expression:"newVersion == false"}],staticClass:"mr-1",attrs:{"xs4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Date de transmission"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"value-format":"dd-MM-yyyy","format":"dd-MM-yyyy","type":"date","id":"dateSend","name":"dateSend","placeholder":"Date"},model:{value:(_vm.formVersion.dateSend),callback:function ($$v) {_vm.$set(_vm.formVersion, "dateSend", $$v)},expression:"formVersion.dateSend"}})],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.newVersion == false),expression:"newVersion == false"}],staticClass:"mr-1",attrs:{"xs2":""}},[_c('el-form-item',{attrs:{"label":"Status","prop":"statut"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"status","placeholder":"Status"},model:{value:(_vm.formVersion.status),callback:function ($$v) {_vm.$set(_vm.formVersion, "status", $$v)},expression:"formVersion.status"}},_vm._l((_vm.status),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-3",attrs:{"xs2":""}},[_c('p',{staticClass:"font-weight-thin"},[_vm._v("Format (JPEG,PNG,PDF), 10 Mo maximum")]),_vm._v(" "),(_vm.versionCourante.extention=='gif' || _vm.versionCourante.extention=='PNG' ||_vm.versionCourante.extention=='JPEG' || _vm.versionCourante.extention=='jpg'|| _vm.versionCourante.extention=='JPG')?_c('p',[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.formVersion.urlImage,"alt":"avatar"}})])],1):_vm._e(),_vm._v(" "),(_vm.versionCourante.extention=='pdf' || _vm.versionCourante.extention=='PDF')?_c('p',[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('a',{attrs:{"href":_vm.formVersion.urlImage,"target":"_blank"}},[_c('iframe',{attrs:{"src":_vm.formVersion.urlImage}}),_vm._v("\n                                  Cliquer içi pour afficher le pdf")])])],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"file1",staticStyle:{"display":"none"},attrs:{"name":"docs","type":"file","accept":"image/*|pdf"},on:{"change":_vm.onFileImagePickedVersion}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.file1.click()}}},[_vm._v("Document  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"commentaire"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","disabled":!_vm.newVersion,"rows":10,"name":"commentaire","placeholder":"commentaire"},model:{value:(_vm.formVersion.commentaire),callback:function ($$v) {_vm.$set(_vm.formVersion, "commentaire", $$v)},expression:"formVersion.commentaire"}})],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.newVersion == false),expression:"newVersion == false"}],staticClass:"mr-1",attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"label":"Reserve","prop":"reserve"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":10,"name":"reserve","placeholder":"reserve"},model:{value:(_vm.formVersion.reserve),callback:function ($$v) {_vm.$set(_vm.formVersion, "reserve", $$v)},expression:"formVersion.reserve"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.newVersion == true),expression:"newVersion == true"}],attrs:{"color":"grey","dark":""},on:{"click":function($event){return _vm.resetFormVersion()}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.newVersion == true)?_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.addVersion('formVersion')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_c('v-btn',{attrs:{"disbaled":!_vm.verifEditVersion,"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.editVersion('formVersion')}}},[_vm._v("Modifier"),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowVersion),callback:function ($$v) {_vm.dialogShowVersion=$$v},expression:"dialogShowVersion"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails de la version "+_vm._s(_vm.versionCourante.libelle)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowVersion = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md6":""}},[(_vm.versionCourante.extention=='gif' || _vm.versionCourante.extention=='PNG' ||_vm.versionCourante.extention=='JPEG' || _vm.versionCourante.extention=='jpg'|| _vm.versionCourante.extention=='JPG')?_c('p',[_c('a',{attrs:{"href":_vm.versionCourante.urlImage,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.versionCourante.urlImage,"alt":"avatar"}}),_vm._v("\n                                       Cliquer içi pour afficher l'image\n                                ")])],1)]):_vm._e(),_vm._v(" "),(_vm.versionCourante.extention=='pdf' || _vm.versionCourante.extention=='PDF')?_c('p',[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('a',{attrs:{"href":_vm.versionCourante.urlImage,"target":"_blank"}},[_c('iframe',{attrs:{"src":_vm.versionCourante.urlImage}}),_vm._v("\n                        Cliquer içi pour afficher le pdf")])])],1):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.versionCourante.libelle)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Mode de transmission : ")]),_vm._v(" "+_vm._s(_vm.versionCourante.mode)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Statut : ")]),_vm._v(" "+_vm._s(_vm.versionCourante.libStatus)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Ajouter par : ")]),_vm._v(" "+_vm._s(_vm.versionCourante.userCreated)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Commentaire :")]),_vm._v(" "+_vm._s(_vm.versionCourante.commentaire)+"  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Réserve :")]),_vm._v(" "+_vm._s(_vm.versionCourante.reserve)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v(" "+_vm._s(_vm.versionCourante.dateCreated)+" ")])])],1)],1)]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowVersion = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n              Fermer\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.showDialogVersionEdit(_vm.versionCourante)}},slot:"activator"},[_vm._v("Mofifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1),_vm._v("\n            Modifier\n          ")],1)],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qFyZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","xs12":""}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%"},model:{value:(_vm.dialogAjoutBudget),callback:function ($$v) {_vm.dialogAjoutBudget=$$v},expression:"dialogAjoutBudget"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter des fournisseurs ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeTypeTravaux}},[_c('el-table-column',{attrs:{"prop":"raison","label":"RAISON","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"codePartenaire","label":"CODE PARTENAIRE","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"formJuridique","label":"FORME JURIDIQUE","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"registre","label":"REGISTE","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"civilite","label":"CIVILITE","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"service","label":"SERVICE","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"profession","label":"PROFESSION","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"siege","label":"SIEGE","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nom","label":"NOM","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prenom","label":"PRENOM","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateNais","label":"DATE DE NAISSANCE ","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"contact","label":"CONTACT","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"numPiece","label":"NUMERO DE PIECE","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"naturePiece","label":"NATURE DE PIECE","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"typeFour","label":"TYPE DE FOURNISSEUR","width":"300"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"orange","dark":""},on:{"click":function($event){return _vm.closeDialog()}},slot:"activator"},[_vm._v("Anuller "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"green","dark":""},on:{"click":function($event){return _vm.saveListe()}},slot:"activator"},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qGI2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "formTypeProjet",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    editedTypeProjet: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      dialogAjoutTypeProjet: false,
      formTypeProj: {
        id: "",
        libelle: "",
        description: ""
      },
      rules: {
        libelle: [{
          required: true,
          message: "Veuillez  saisir un libelle",
          trigger: "blur"
        }],
        description: [{
          required: true,
          message: "Veuillez  saisir une description",
          trigger: "blur"
        }],
        code: [{
          required: true,
          message: "Veuillez  saisir le code",
          trigger: "blur"
        }]
      }
    };
  },

  watch: {
    show: function show(newValue, oldValue) {
      if (newValue == true) {
        this.dialogAjoutTypeProjet = true;
        if (this.editedTypeProjet != null) {
          this.formTypeProj = this.editedTypeProjet;
          //this.loadTypeProjet();
        }
      } else {
        this.dialogAjoutTypeProjet = false;
      }
    }
  },
  methods: {
    closeForm: function closeForm() {
      this.resetForm();
      this.$emit("close");
    },
    submitTypeProjet: function submitTypeProjet() {
      var _this = this;

      this.$refs["formTypeProj"].validate(function (valid) {
        if (valid) {
          _this.loading = true;
          var form = document.getElementById("formTypeProj");
          var data = new FormData(form);
          var url = "";
          if (_this.editedTypeProjet != null) {
            url = _this.domaine + "projet/" + _this.editedTypeProjet.id + "/edit/type/projet";
          } else {
            url = _this.domaine + "projet/new/type/projet";
          }
          data.append("idUser", _this.user.id);
          _this.$http.post(url, data).then(function (response) {
            _this.loading = false;
            if (response.body.code == 3) {
              _this.$message.error(response.body.message);
              return;
            }
            _this.$notify({
              title: "ENREGISTREMENT REUSSI",
              message: "Type de chantier enregistré avec succès.",
              type: "success",
              position: "top-center"
            });
            _this.closeForm();
          }, function (error) {
            _this.loading = false;
            _this.$message.error("Erreur lors de l'enregistrement du type projet ");
          });
        }
      });
    },
    //submit
    resetForm: function resetForm() {
      this.formTypeProj.libelle = "";
      this.formTypeProj.description = "";
      this.formTypeProj.code = "";
    }
  } // methods
});

/***/ }),

/***/ "qHJW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qgpy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_user_Responsable__ = __webpack_require__("OX/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_user_Technicien__ = __webpack_require__("/UO0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_user_Representant__ = __webpack_require__("caSR");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */], Responsable: __WEBPACK_IMPORTED_MODULE_3__components_user_Responsable__["a" /* default */], Technicien: __WEBPACK_IMPORTED_MODULE_4__components_user_Technicien__["a" /* default */], Representant: __WEBPACK_IMPORTED_MODULE_5__components_user_Representant__["a" /* default */] },
  name: 'User',
  data: function data() {
    return {
      loading: false,
      domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
      user: JSON.parse(sessionStorage.getItem('userInfo')),
      roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
      droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
      menu: [],
      menuSele: [],
      roles: [],
      role: [],
      logoUser: "/static/avatar-conducteur.png",
      fileLogo: "",

      headers: [{ text: 'Avatar', align: 'left', sortable: true, value: '' }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({ text: 'Nom et prénoms', value: 'a', sortable: true }, "value", 'Nom et prénoms'), { text: 'Login', value: '', sortable: true }, { text: 'Contact', value: 'Contact', sortable: true }, { text: 'Actions', align: 'center', value: 'Action', sortable: true }],
      headersGroup: [{ text: 'Date', value: 'created', sortable: true }, { text: 'Nom', value: 'libelle', sortable: true }, { text: 'Description', value: 'description', sortable: true }, { text: 'Actions', align: 'center' }],
      items: [{ value: false, photo: '', nom: '', login: '', fonction: '', contact: '48867578', action: '' }],
      racourcis: [{ path: '/', text: 'Accueil', disabled: false }, { path: '/user', text: 'Liste des utilisateurs', disabled: true }],
      recherche: '',
      rechercheUser: '',
      sessionUser: true,
      sessionResponsable: false,
      sessionResponsableZone: false,
      sessionFourn: false,
      sessionGroup: false,
      dialogAjout: false,
      dialogRole: false,
      dialogAttRole: false,
      dialogEdit: false,
      dialogSupr: false,
      dialogShow: false,
      dialogShowGroup: false,
      dialogMdp: false,
      dialogImageUrl: '',
      dialogImageVisible: false,
      dialogAjoutGroupe: false,
      editGroup: false,
      valid: true,
      idUser: '',
      nomUser: '',
      photo: '',
      loginUser: '',
      emailUser: '',
      contactUser: '',
      fonctionUser: '',
      mdpNewVerUser: '',
      mdpNewUser: '',
      selectServiceUser: null,
      selectTypeUser: null,
      typeUser: [{ text: "Membre de l'entreprise", value: 1 }],
      selectPosteUser: null,
      posteUser: [{ text: "Directeur du service technique", value: 1 }, { text: 'Responsable délégué', value: 2 }],
      listService: [],
      serviceUserRules: [function (v) {
        return !!v || 'Veuillez sélectionner votre service.';
      }],
      mdpUser: '',
      mdpVerUser: '',
      mdpUserConnect: '',
      loginUserRules: [function (v) {
        return !!v || 'Le E-mail est obligatoire';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([-]?\w+)*(.\w{2,3})+$/.test(v) || 'Vous devez respecter format de E-mail'
        );
      }],
      nomUserRules: [function (v) {
        return !!v || 'Le nom est obligatoire';
      }, function (v) {
        return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
      }],
      mdpUserRules: [function (v) {
        return !!v || 'Le mot de passe est obligatoire';
      }, function (v) {
        return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
      }],
      mdpVerUserRules: [function (v) {
        return !!v || 'La vérifiaction du mot de passe est obligatoire. Il doit être identique au mot de pas entré précédenment';
      }, function (v) {
        return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
      }],
      mdpUserConnectRules: [function (v) {
        return !!v || 'Votre mot de passe est obligatoire pour la confirmation';
      }],
      contactUserRules: [function (v) {
        return !!v || "Le contact de l'utilisateur est obligatoire";
      }, function (v) {
        return (/[0-9]/.test(v) || 'Vous devez respecter format du contact'
        );
      }],
      listUser: [],
      userCourant: [],
      detailUser: [],
      listResponsable: [],
      listFournisseur: [],
      listGroupe: [],
      groupCourant: [],
      disabledBtnUs: false,
      disabledBtnZone: false,
      disabledBtnPrest: false,
      formGroupe: {
        libelle: '',
        description: ''
      },
      GroupLIbRules: [function (v) {
        return !!v || 'Le libelle est obligatoire';
      }],
      listeGroupes: [],
      selectedGroup: [],
      UserGroupListe: [],
      allRoleMenus: [],
      allRoleRoutes: [],
      menusGrpActu: [],
      routesGrpActu: [],
      groupeRoles: {
        menus: [],
        routes: []
      },
      search: '',
      headersGroupMenus: [{ text: 'Nom', align: 'left', sortable: true, value: 'nom' }, { text: 'Libelle', align: 'left', value: 'libelle' }],
      mdpNewVerUserRules: [function (v) {
        return !!v || 'Veuillez confirmer le nouveau mot de passe.';
      }, function (v) {
        return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
      }],
      mdpNewUserRules: [function (v) {
        return !!v || 'Le nouveau mot de passe est obligatoire.';
      }, function (v) {
        return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
      }]
    };
  },

  computed: {},
  mounted: function mounted() {
    this.loadService();
    this.loadUser();
    this.loadResponsable();
    this.loadFournisseur();
    this.loadPage();
  },

  methods: {
    loadPage: function loadPage() {
      var loading = this.$loading({
        lock: true,
        text: 'Veuillez patientez ...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(function () {
        loading.close();
      }, 1000);
    },
    submitResetPassword: function submitResetPassword() {
      var _this = this;

      this.loading = true;
      this.dialogPassword = false;

      var url = this.domaine + 'userCreate/reset/password';
      var data = new FormData();
      data.append("username", this.detailUser.username);
      this.$http.post(url, data).then(function (response) {
        _this.loading = false;
        _this.dialogShow = false;
        if (response.body.code == 0) {
          _this.$notify.error({
            title: 'Reinitialisation du mot de passe',
            message: "L'utilisateur n'exite pas"
          });
          return;
        } else {
          _this.$notify({
            type: 'success',
            title: 'Reinitialisation du mot de passe',
            message: "Le mot de passe a ete enregistre l'utilisateur recevra les identifiants par sms et mail"
          });
        }
      }, function (response) {
        _this.dialogShow = false;
        _this.loading = false;
        _this.$notify.error({
          title: 'Reinitialisation du mot de passe',
          message: "Une erreur est survenue lors de la reinitialisation du mot de passe"
        });
      });
    },
    loadService: function loadService() {
      var _this2 = this;

      var url = this.domaine + 'webService/liste-service';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this2.listService = response.body.service;
          _this2.menu = response.body.menu;
          _this2.roles = response.body.role;
        }
      });
    },
    loadUser: function loadUser() {
      var _this3 = this;

      var url = this.domaine + 'userCreate/user/' + this.user.id + '/unique';
      if (this.droitAcces.index_user) {
        url = this.domaine + 'userCreate/user-list';
      }

      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this3.listUser = response.body;
          if (_this3.listUser === undefined || _this3.listUser.length == 0) {
            _this3.disabledBtnUs = true;
          } else {
            _this3.disabledBtnUs = false;
          }
        }
      });
    },
    loadResponsable: function loadResponsable() {
      var _this4 = this;

      var url = this.domaine + 'userCreate/index/responsable/zone';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this4.listResponsable = response.body;
          if (_this4.listResponsable === undefined || _this4.listResponsable.length == 0) {
            _this4.disabledBtnZone = true;
          } else {
            _this4.disabledBtnZone = false;
          }
        }
      });
    },
    loadFournisseur: function loadFournisseur() {
      var _this5 = this;

      var url = this.domaine + 'userCreate/index/fournisseur/designe';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this5.listFournisseur = response.body;
          if (_this5.listFournisseur === undefined || _this5.listFournisseur.length == 0) {
            _this5.disabledBtnPrest = true;
          } else {
            _this5.disabledBtnPrest = false;
          }
        }
      });
    },
    loadGroupe: function loadGroupe() {
      var _this6 = this;

      var url = this.domaine + 'userGroupe/index';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this6.listGroupe = response.body;
          if (_this6.listGroupe === undefined || _this6.listGroupe.length == 0) {
            _this6.disabledBtnPrest = true;
          } else {
            _this6.disabledBtnPrest = false;
          }
        }
      });
    },
    newUser: function newUser() {
      this.dialogAjout = true;
      this.userCourant.id = '';
      this.userCourant = {};
      this.nomUser = '';
      this.loginUser = '';
      this.emailUser = '';
      this.fonctionUser = '';
      this.selectServiceUser = null;
      this.selectTypeUser = null;
      this.selectPosteUser = null;
      this.contactUser = '';
      this.mdpUser = '';
      this.mdpVerUser = '';
      // this.$refs["formFour"].resetFields();
    },
    newGroupe: function newGroupe() {
      this.dialogAjoutGroupe = true;
      this.editGroup = false;
      this.formGroupe.libelle = '';
      this.formGroupe.description = '';
      this.groupCourant = [];
    },
    SaveGroupe: function SaveGroupe() {
      var _this7 = this;

      if (this.$refs.formGroup.validate()) {

        this.loading = true;
        var form = document.getElementById('formGroup');
        var data = new FormData(form);
        data.append("idUSer", this.user.id);

        var url = '';
        if (this.groupCourant.id) {
          url = this.domaine + 'userGroupe/' + this.groupCourant.id + '/edit';
        } else {
          url = this.domaine + 'userGroupe/new';
        }

        this.$http.post(url, data).then(function (response) {
          if (response.body.code == 1 || response.body.code == 2) {

            _this7.loading = false;
            _this7.dialogAjoutGroupe = false;
            _this7.loadGroupe();
            _this7.$notify({
              title: "LE GROUPE A BIEN ETE ENREGISTRE",
              message: 'Groupe enregistré avec succès.',
              type: 'success',
              position: 'top-center'
            });
          } else {

            _this7.loading = false;
            _this7.$notify({
              title: "DESOLE CE NOM DE GROUPE EXISTE DEJA",
              message: 'Ce nom de groupe existe déja.',
              type: 'error',
              position: 'top-center'
            });
          }
        }, function (response) {
          _this7.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
          _this7.loading = false;
        });
      }
    },
    newRole: function newRole(item) {
      // this.UserGroupListe = []

      this.loadAllGroupes();
      this.loadGroupeUser(item.id);
      //this.selectedGroup=[15,17]

      this.userCourant = item;
      this.dialogRole = true;
    },
    attribuerRoleGroup: function attribuerRoleGroup(item) {
      var _this8 = this;

      this.menusGrpActu = [];
      this.routesGrpActu = [];
      this.groupCourant = item;
      this.dialogAttRole = true;
      var url = this.domaine + 'userGroupe/load/' + this.groupCourant.id + '/all';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this8.allRoleMenus = response.body.roleMenus;
          _this8.menusGrpActu = response.body.menuGroup;
          _this8.allRoleRoutes = response.body.roleRoutes;
          _this8.routesGrpActu = response.body.routeGroup;
        }
      });
    },
    loadAllGroupes: function loadAllGroupes() {
      var _this9 = this;

      // RECUP DE TS LES GROUP
      var url = this.domaine + 'userGroupe/index';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this9.listeGroupes.splice(0);
          _this9.listeGroupes = response.body;
        }
      });
    },
    loadGroupeUser: function loadGroupeUser(id) {
      var _this10 = this;

      // RECUP DES GROUP DU USER
      var lien = this.domaine + 'userGroupe/load/user/' + id + '/groupe';
      this.$http.get(lien).then(function (response) {
        if (response.body) {
          _this10.selectedGroup.splice(0);
          response.body.forEach(function (element) {
            _this10.UserGroupListe.push(element);
            _this10.selectedGroup.push(element.id);
          });
        }
      });
    },
    voirUser: function voirUser() {
      this.sessionUser = true;
      this.sessionResponsableZone = false;
      this.sessionFourn = false;
      this.sessionResponsable = false;
      this.sessionGroup = false;
    },
    voirResponsable: function voirResponsable() {
      this.sessionResponsableZone = true;
      this.sessionResponsable = false;
      this.sessionFourn = false;
      this.sessionUser = false;
      this.sessionGroup = false;
    },
    voirRepresentant: function voirRepresentant() {
      this.sessionResponsableZone = false;
      this.sessionResponsable = true;
      this.sessionFourn = false;
      this.sessionUser = false;
      this.sessionGroup = false;
    },
    voirFourn: function voirFourn() {
      this.sessionFourn = true;
      this.sessionResponsableZone = false;
      this.sessionResponsable = false;
      this.sessionUser = false;
      this.sessionGroup = false;
    },
    voirGroup: function voirGroup() {
      this.sessionFourn = false;
      this.sessionResponsableZone = false;
      this.sessionResponsable = false;
      this.sessionUser = false;
      this.sessionGroup = true;
      this.loadGroupe();
    },
    editUser: function editUser(ligne) {
      this.dialogEdit = true;
      this.dialogAjout = true;

      this.userCourant = ligne;
      this.nomUser = this.userCourant.nom;
      this.loginUser = this.userCourant.username;
      this.emailUser = this.userCourant.email;
      this.fonctionUser = this.userCourant.fonction;
      this.selectServiceUser = this.userCourant.serviceId;
      this.contactUser = this.userCourant.contact;
      this.selectTypeUser = this.userCourant.type;
      this.selectPosteUser = this.userCourant.poste;
      this.mdpUserConnect = '';
      this.logoUser = ligne.url;
    },
    modalEditGroup: function modalEditGroup(ligne) {
      this.dialogAjoutGroupe = true;
      this.editGroup = true;
      this.groupCourant = ligne;
      this.formGroupe = this.groupCourant;
    },
    showUser: function showUser(ligne) {
      var _this11 = this;

      this.dialogShow = true;
      this.userCourant = ligne;
      var url = this.domaine + 'userCreate/show/' + this.userCourant.id;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this11.detailUser = response.body;
        }
      });
    },
    showGroupe: function showGroupe(ligne) {
      var _this12 = this;

      this.dialogShowGroup = true;
      this.groupCourant = ligne;
      var url = this.domaine + 'userGroupe/load/' + ligne.id + '/groupe/unique/roles';
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this12.groupeRoles.menus = response.body.Rmenus;
          _this12.groupeRoles.routes = response.body.Rroutes;
        }
      });
    },
    submitMdp: function submitMdp() {
      var _this13 = this;

      this.loading = true;
      if (this.$refs.formMdp.validate()) {
        if (this.mdpNewUser === this.mdpNewVerUser) {
          var form = document.getElementById('formMdp');
          var formdata = new FormData(form);
          var url = this.domaine + 'userCreate/' + this.detailUser.id + '/edit/admin/password';
          formdata.append('idUser', this.user.id);
          this.$http.post(url, formdata).then(function (response) {
            if (response.body) {
              var verif = response.body;
              if (verif.code === 1) {
                _this13.$notify({
                  title: "Mot de passe à bien été modifié",
                  message: 'Modification éffectué avec succès.',
                  type: 'success',
                  position: 'top-center'
                });
              } else if (verif.code === 2) {
                _this13.$message.error(verif.message);
              } else if (verif.code === 3) {
                _this13.$message.error(verif.message);
              } else if (verif.code === 0) {
                _this13.$message.error(verif.message);
              }
              _this13.loading = false;
              _this13.dialogMdp = false;
              _this13.loadPage();
            } else {
              _this13.$message.error('Erreur serveur');
              _this13.loading = false;
            }
          }, function (response) {
            _this13.$message.error('Erreur serveur');
            _this13.loading = false;
          });
        } else {
          this.$message.error('Le mot de passe de vérification doit être identique au nouveau mot de passe');
          this.loading = false;
        }
      } else {
        this.$message.error('Veuillez renseigner les champs obligatoires');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Utilisateur n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    submit: function submit() {
      var _this14 = this;

      this.loading = true;
      if (this.$refs.formUser.validate()) {
        var form = document.getElementById('formUser');
        var formdata = new FormData(form);
        var url = '';
        if (this.userCourant.id) {
          url = this.domaine + 'userCreate/' + this.userCourant.id + '/user/edit';
          formdata.append('mdpUser', this.mdpUserConnect);
        } else {
          url = this.domaine + 'userCreate/new';
        }
        formdata.append('idUser', this.user.id);
        formdata.append('serviceUser', this.selectServiceUser);
        formdata.append('nomUser', this.nomUser);
        formdata.append('loginUser', this.loginUser);
        formdata.append('contactUser', this.contactUser);
        formdata.append('fonctionUser', this.fonctionUser);
        // formdata.append('type', this.selectTypeUser)
        formdata.append('poste', this.selectPosteUser);
        formdata.append('roleUser', this.role);

        this.$http.post(url, formdata).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (_this14.userCourant.id) {
              if (verif.code === 1) {
                _this14.$notify({
                  title: "L'UTILISATEUR A BIEN ETE MOFIFIE",
                  message: 'Modification effectué avec succès.',
                  type: 'success',
                  position: 'top-center'
                });
                _this14.loading = false;
                _this14.dialogAjout = false;
              } else if (verif.code === 2) {
                _this14.loading = false;
                _this14.$message.error(verif.message);
              } else if (verif.code === 3) {
                _this14.loading = false;
                _this14.$message.error(verif.message);
              } else if (verif.code === 4) {
                _this14.loading = false;
                _this14.$message.error(verif.message);
              } else if (verif.code === 5) {
                _this14.loading = false;
                _this14.$message.error(verif.message);
              } else if (verif.code === 0) {
                _this14.loading = false;
                _this14.$message.error(verif.message);
              }
              _this14.loadUser();
            } else {
              if (verif.code === 1) {
                _this14.$notify({
                  title: "L'UTILISATEUR A BIEN ETE AJOUTE",
                  message: 'Enrégistrement réussie avec succès.',
                  type: 'success',
                  position: 'top-center'
                });

                _this14.loading = false;
                _this14.dialogAjout = false;
                _this14.loadUser();
                _this14.loadResponsable();
                _this14.loadFournisseur();
                _this14.loadPage();
              } else if (verif.code === 2) {
                _this14.loading = false;
                _this14.$message.error(verif.message);
              } else if (verif.code === 3) {
                _this14.loading = false;
                _this14.$message.error(verif.message);
              } else if (verif.code === 4) {
                _this14.loading = false;
                _this14.$message.error(verif.message);
              } else if (verif.code === 5) {
                _this14.loading = false;
                _this14.$message.error(verif.message);
              } else if (verif.code === 0) {
                _this14.$message.error(verif.message);
                _this14.loading = false;
                _this14.dialogAjout = false;
                _this14.loadUser();
                _this14.loadResponsable();
                _this14.loadFournisseur();
                _this14.loadPage();
              }
            }
          } else {
            _this14.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
            _this14.loading = false;
            _this14.dialogAjout = false;
          }
        }, function (response) {
          _this14.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
          _this14.loading = false;
        });
        //} else {
        //this.$message.error('Le mot de passe de vérification doit être identique au mot de passe')
        //}
      } else {
        this.$message.error('Veuillez renseigner les champs obligatoires');
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Utilisateur n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    imprimeListeUser: function imprimeListeUser(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "userCreate/imprimerPDF/liste";
      } else {
        url = this.domaine + "userCreate/imprimerEXC/liste";
      }
      window.open(url);
    },
    filtrerEtatPrioriteBesoin: function filtrerEtatPrioriteBesoin() {
      var _this15 = this;

      //filtre de la liste de commande
      this.listUser = this.listUser.filter(function (element) {
        return element.id == _this15.rechercheUser;
      });
    },
    clearSelect: function clearSelect() {
      this.loadUser();
    },
    imprimeListeRespoZone: function imprimeListeRespoZone(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "userCreate/imprimerPDF/responsable/liste";
      } else {
        url = this.domaine + "userCreate/imprimerEXC/responsable/liste";
      }
      window.open(url);
    },
    imprimeListePrest: function imprimeListePrest(type) {
      var url = "";
      if (type == "PDF") {
        url = this.domaine + "userCreate/imprimerPDF/prestataire/liste";
      } else {
        url = this.domaine + "userCreate/imprimerEXC/prestataire/liste";
      }
      window.open(url);
    },
    submitRole: function submitRole() {
      var _this16 = this;

      this.loading = true;
      if (this.$refs.formRole.validate()) {
        var form = document.getElementById('formRole');
        var data = new FormData(form);
        var url = this.domaine + 'userCreate/' + this.userCourant.id + '/role/user';
        data.append('idUser', this.user.id);
        data.append('selectGroups', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedGroup));

        this.$http.post(url, data).then(function (response) {
          if (response.body) {
            var verif = response.body;
            if (verif.code === 1) {
              _this16.$notify({
                title: "ENREGISTREMENT REUSSI",
                message: 'Droits enregistré avec succès,veuillez vous reconnecter pour appliquer les changements',
                type: 'success',
                DURATION: 10000,
                position: 'top-center'
              });
            }

            _this16.loading = false;
            _this16.dialogRole = false;
            _this16.loadUser();
            _this16.loadResponsable();
            _this16.loadFournisseur();
            _this16.loadPage();
            _this16.$refs.formRole.reset();
            var menu = verif.menu;
            var droit = verif.role;
            //sessionStorage.setItem('sessionAcces', JSON.stringify(menu))
            //sessionStorage.setItem('sessionDroit', JSON.stringify(droit))
            //this.roleAcces = JSON.parse(sessionStorage.getItem('sessionAcces'))
            //this.droitAcces = JSON.parse(sessionStorage.getItem('sessionDroit'))
          } else {
            _this16.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
            _this16.loading = false;
            _this16.dialogRole = false;
          }
        }, function (response) {
          _this16.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
          _this16.loading = false;
        });
      } else {
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "Utilisateur n'a pas été enregistré.",
          position: 'top-center'
        });
        this.loading = false;
      }
    },
    deleteUser: function deleteUser() {
      var _this17 = this;

      var url = this.domaine + 'userCreate/delete/' + this.idUser;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          if (response.body.code === 1) {
            _this17.$notify({
              title: 'SUPPRESSION',
              message: "L'utilisateur à supprimé avec succès.",
              type: 'success',
              position: 'top-center'
            });
            _this17.dialogSupr = false;
            _this17.loadUser();
            _this17.loadPage();
          } else if (response.body.code === -2) {
            _this17.$notify.error({
              title: 'SUPPRESSION IMPOSSIBLE',
              message: 'Impossible de supprimer cet utilisateur car il présent dans un projet.',
              position: 'top-center'
            });
          } else {
            _this17.$notify.error({
              title: 'SUPPRESSION ECHOUE',
              message: 'La suppression de l\'utilisateur à échoue.',
              position: 'top-center'
            });
          }
        }
      });
    },

    //enregistrement des images
    onFileImageLogoPicked: function onFileImageLogoPicked(event) {
      var _this18 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this18.logoUser = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.logoUser = files[0];
    },
    submitAttRoles: function submitAttRoles() {
      var _this19 = this;

      // this.loading = true
      var data = new FormData();
      data.append('idGroup', this.groupCourant.id);
      data.append('RoleMenus', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.menusGrpActu));
      data.append('RoleRoutes', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.routesGrpActu));

      var url = this.domaine + 'userGroupe/roles/attribution/groupe';

      this.$http.post(url, data).then(function (response) {
        if (response.body.code == 1) {

          _this19.$notify({
            type: 'success',
            title: 'Roles attribues avec succes',
            message: "Role attribue avec succes"
          });
          _this19.dialogAttRole = false;
          _this19.loadGroupe();
          _this19.loading = false;
        }
      }, function (response) {
        _this19.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
        _this19.loading = false;
      });
    },
    clear: function clear() {
      this.$refs.formUser.reset();
      this.dialogAjout = false;
    }
  }
  // beforeMount: function () {
  //   if(!this.roleAcces[this.$router.history.current.name]){
  //     this.$router.push({ name: 'Home'  })
  //   }
  // }
});

/***/ }),

/***/ "qnOB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qojX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qvaN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Routes_vue__ = __webpack_require__("bHrj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bf5e0ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Routes_vue__ = __webpack_require__("YFyM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Routes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bf5e0ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Routes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r0nc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "ModalCommandeDetails",
  props: ["show", "detailCommande", "hiddenButton"],

  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      loading: false,

      fournisseur: null,
      priorite: 1,
      dateLivraison: null,
      libelleCommande: "",
      prioriteCommande: 1,
      idCommande: 0,
      modeCommande: null,
      numeroDevis: null,
      imagePdf: false,
      fournisseurCommande: null,

      dialogDetailCommande: false,
      optionBesoin: [{
        key: 1,
        produit: "",
        qte: 1,
        unite: "",
        id: 0,
        priorite: 1
      }],

      items: [],
      index: null,
      //Projet
      listeProjet: [],
      listeChantier: [],
      listeTravaux: [],
      listeTacheTrx: [],
      projetS: "",
      chantierS: "",
      travauxS: "",
      tacheS: '',
      tranconA: '',
      urlImage: '',
      logoDefaut: '/static/img-doc.png',
      logoPdf: '/static/pdf.png',
      tranconB: '',

      priorites: [{
        value: 1,
        label: "Faible"
      }, {
        value: 2,
        label: "Normal"
      }, {
        value: 3,
        label: "Urgent"
      }]
    };
  },


  computed: {},

  methods: {
    loadProjet: function loadProjet() {
      var _this = this;

      var url = this.domaine + "projet/index/projet/all";

      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this.loading = false;
        _this.listeProjet = response.body.projet;
        _this.projetS = _this.detailCommande.projet;
      }, function (errRep) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    showDiapo: function showDiapo(images, ind, image) {
      this.items = images;
      this.index = ind;
    },
    loadChantier: function loadChantier() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "projet/" + this.projetS + "/index/chantier";
      this.$http.get(url).then(function (response) {
        _this2.loading = false;
        _this2.listeChantier = response.body.chantier;
        _this2.chantierS = _this2.detailCommande.chantier;
      }, function (errRep) {
        _this2.loading = false;
        _this2.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    loadTravaux: function loadTravaux() {
      var _this3 = this;

      this.loading = true;
      this.travauxS = "";
      this.listTravaux = [];
      if (this.chantierS !== "") {
        var url = this.domaine + "projet/" + this.chantierS + "/index/chantier/travaux";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this3.listeTravaux = response.body.travaux;
            _this3.travauxS = _this3.detailCommande.travaux;
            console.log('this.travauxS', _this3.travauxS);
            _this3.loading = false;
          }
        });
      } else {
        this.loading = false;
      }
    },
    loadTacheTrx: function loadTacheTrx() {
      var _this4 = this;

      this.loading = true;
      this.tacheS = "";
      this.listeTacheTrx.splice(0);
      console.log("this.travauxS", this.travauxS);
      if (this.travauxS !== "" || this.travauxS !== undefined) {
        var url = this.domaine + "tache/travaux/" + this.travauxS;
        this.$http.get(url).then(function (response) {
          _this4.listeTacheTrx = response.body.taches;
          _this4.tacheS = _this4.detailCommande.tache;
          _this4.loading = false;
          console.log('jaffiche', _this4.tache);
        });
      } else {
        this.$message.error("Veuillez sélectionner une tache");
        this.loading = false;
      }
    },
    loadDetailsCommande: function loadDetailsCommande() {
      this.optionBesoin = this.detailCommande.option;
      this.idCommande = this.detailCommande.id;
      this.libelleCommande = this.detailCommande.libelle;
      this.prioriteCommande = this.detailCommande.priorite;
      this.dateLivraison = this.detailCommande.dateLivr;
      this.fournisseurCommande = this.detailCommande.fournisseurNom;
      this.modeCommande = this.detailCommande.mode;
      this.numeroDevis = this.detailCommande.numeroDevis;
      //projet
      console.log('this.detailCommande', this.detailCommande);
      this.projetS = this.detailCommande.projetId;
      this.chantierS = this.detailCommande.chantierId;
      this.travauxS = this.detailCommande.travauxId;
      this.tacheS = this.detailCommande.tache;
      this.tranconA = this.detailCommande.tranconA;
      this.tranconB = this.detailCommande.tranconB;
      this.urlImage = this.detailCommande.urlImage;
      var valeur = this.urlImage.substring(this.urlImage.lastIndexOf(".") + 1);
      console.log('valeur', valeur);
      this.imagePdf = false;
      if (valeur == 'pdf') {
        this.imagePdf = true;
      }

      console.log('this.tacheS', this.tacheS);
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    }
  },

  watch: {
    show: function show(newValue, oldvalue) {
      if (newValue == true) {
        this.loadDetailsCommande();
        if (this.detailCommande.projetId) {
          this.loadProjet();
          this.loadChantier();
          this.loadTravaux();
          // this.loadTacheTrx();
        }
      }
      this.dialogDetailCommande = newValue;
    }
  }
});

/***/ }),

/***/ "r2/R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutZoneMaintenance_vue__ = __webpack_require__("mQ16");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_597b8b68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutZoneMaintenance_vue__ = __webpack_require__("cfln");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutZoneMaintenance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_597b8b68_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutZoneMaintenance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r8Q+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_echarts__ = __webpack_require__("cs+8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_chart_line__ = __webpack_require__("4UDB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_rapport_ListeRapportTrx__ = __webpack_require__("chSw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Vb+l");
__webpack_require__("Oq2I");
__webpack_require__("miEh");



// import * as echarts from 'echarts';



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_3__components_Loading__["a" /* default */],
    'v-chart': __WEBPACK_IMPORTED_MODULE_0_vue_echarts___default.a, ListeRapportTrx: __WEBPACK_IMPORTED_MODULE_2__components_rapport_ListeRapportTrx__["a" /* default */]
  },
  name: "DashboardRapport",
  props: {
    show: {
      type: Boolean
    },
    detailProjet: {
      type: Object
    }
  },
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      loading: false,
      dialogDetail: false,
      showButonExcel: false,
      dialogueImprimer: false,
      listeProjet: [],
      listeRecherche: [],
      listeRapport: [],
      listeChantier: [],
      listeTravaux: [],
      selectTaches: '',
      listTaches: [],
      typeRech: '',
      listTravauxResult: [],
      listChargeResult: [],
      mntTotalChargeI: 0,
      showGraph: false,
      mntTotalChargeD: 0,
      mntTotalChargeDE: 0,
      mntTotalChargeMA: 0,
      mntTotalDepense: 0,
      listeBudget: [],
      bilanMensuel: [],
      bilanTravaux: [],
      listeDetail: [],
      helpDemande: [{
        num: "1",
        text: "Somme de toutes les commandes éffectuées"
      }, {
        num: "2",
        text: "Somme de toutes les demandes de fond éffectuées"
      }, {
        num: "3",
        text: "Somme de toutes les dépenses indiqué dans le rapport journalier"
      }],
      helpDemandeN: [{
        num: "1",
        text: "REDEMENT GLOBAL: Qte tâche / Total durée prévu."
      }, {
        num: "1",
        text: "REDEMENT REEL: Le rendement réel d'une tâche d'un projet par jour: Calculé en divisant le nombre de tâches effectuées par le nombre de jours consacrés à la tâche."
      }, {
        num: "2",
        text: "Prix BUDGET: Somme de toutes les commandes effectués pour la tâche."
      }, {
        num: "3",
        text: "ECART PRIX DE REVIENT: L'écart du prix de revient d'une tâche peut être calculé en soustrayant le coût réel de la tâche à son coût prévu. Par exemple, si le coût prévu pour une tâche était de 100 et que le coût réel était de 120, l'écart du prix de revient serait de 2"
      }, {
        num: "4",
        text: "ECART REDEMENT: L'écart de rendement d'une tâche d'un projet peut être calculé en soustrayant le rendement réel de la tâche à son rendement attendu. Par exemple, si la tâche a été estimée à prendre 100 heures pour être terminée, mais qu'elle a pris 120 heures, alors l'écart de rendement sera de -20 heures."
      }, {
        num: "5",
        text: "COUT RELL:Le coût réel d'une tâche d'un projet est le coût final de la réalisation de cette tâche, c'est-à-dire le coût réellement dépensé pour la réaliser."
      }, {
        num: "6",
        text: "VALEUR PLANIFIEE: La valeur planifiée d'une tâche d'un projet est le coût estimé de la réalisation de cette tâche."
      }],
      listeTypeRech: [{ libelle: "RÉCAPITULATIF", id: "recap" }, { libelle: "DÉTAILLÉS", id: "details" }],
      //  new data
      selectProjet: [],
      selectChantier: [],
      selectTravaux: [],
      selectAnnee: '',
      libelleTravaux: '',
      selectAnneeFormat: '',
      //critere de recherche
      formTri: { periode: '' },

      compte: "0",
      dialogConfirm: false,
      disabledBtnPop: false,
      totalMntPropose: 0,
      totalMntValide: 0
    };
  },


  computed: {},
  watch: {
    show: function show(newValue, oldvalue) {
      var _this2 = this;

      this.dialogDetail = newValue;
      if (newValue == true) {
        this.listeBudget = this.detailProjet.budgets;
        var _this = this;
        this.totalMntPropose = 0;
        this.totalMntValide = 0;
        this.totalMntMarche = 0;
        this.listeBudget.forEach(function (item) {
          _this2.totalMntPropose += item.mntTotalBudgetPropose;
          _this2.totalMntValide += item.mntTotalBudgetValide;
        });
        this.loadBilan(this.detailProjet.idProj);
      }
    }
  },

  methods: {
    handleTabClick: function handleTabClick(tab) {
      switch (tab) {
        case "0":
          break;
        case "1":
          break;

        default:
          break;
      }
    },
    headerRowStyle: function headerRowStyle(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      return { color: "black" };
    },
    statistique: function statistique(dataStat) {
      var chartDom = document.getElementById('main');
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        title: {
          text: 'Rapport d\'analyse de la valeur acquise'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['VALEUR PLANIFIEE (VP)', 'VALEUR ACQUISE (VA)', 'COUT REEL (CR),']
        },
        grid: {
          left: '10%',
          right: '10%',
          bottom: '10%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: 'VALEUR PLANIFIEE',
          type: 'line',
          stack: 'Total',
          data: []
        }, {
          name: 'VALEUR ACQUISE',
          type: 'line',
          stack: 'Total',
          data: []
        }, {
          name: 'COUT REEL',
          type: 'line',
          stack: 'Total',
          data: []
        }]
      };

      var tabNb = option.xAxis.data.length;
      for (var i = 0; i < tabNb; i++) {
        for (var dataCBud in dataStat) {
          var mois = option.xAxis.data;

          if (mois[i] === dataStat[dataCBud]['mois']) {
            option.series[0].data.push({ value: dataStat[dataCBud]['vp'], name: "VALEUR PLANIFIEE (VP)" });
            option.series[1].data.push({ value: dataStat[dataCBud]['va'], name: "VALEUR ACQUISE (VA)" });
            option.series[2].data.push({ value: dataStat[dataCBud]['cr'], name: "COUT REEL (CR)" });
          }
        }
      }
      option && myChart.setOption(option);
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getSumm: function getSumm(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 4) {
          sums[index] = "N/A";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    getSummCompte: function getSummCompte(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });
      return sums;
    },
    getSummCompteFinance: function getSummCompteFinance(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 6) {
          sums[index] = "N/A";
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getSummDetailBudget: function getSummDetailBudget(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "Sous total";
          return;
        }

        if (index === 5) {
          sums[index] = "N/A";
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });

        if (!values.every(function (value) {
          return isNaN(value);
        })) {

          sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0));
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    loadBilan: function loadBilan(idProjet) {
      var _this3 = this;

      this.loading = true;
      var url = this.domaine + "budgetProjet/bilan/projet/" + idProjet;
      this.$http.get(url).then(function (response) {
        _this3.loading = false;
        _this3.bilanMensuel = response.body.mensuel;
        _this3.bilanTravaux = response.body.bilanTravaux.travaux;
        _this3.listeDetail = response.body.detailCompte;
      }, function (errRep) {
        _this3.loading = false;
        _this3.$message.error("Une erreur est survenue lors du chargement du bilan");
      });
    },
    loadProjet: function loadProjet() {
      var _this4 = this;

      var url = this.domaine + "projet/indicateur/projet";

      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this4.loading = false;
        _this4.listeProjet = response.body.projet;
        // this.listeRapport = response.body.rapport;
      }, function (errRep) {
        _this4.loading = false;
        _this4.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    loadChantierSearch: function loadChantierSearch() {
      var _this5 = this;

      this.loading = true;
      this.listTravauxResult = [];
      this.listChantierResult = [];
      if (this.selectChantier != "" && this.typeRech != "") {

        this.listeTravaux.find(function (item) {
          if (item.id == _this5.selectTravaux) {
            _this5.libelleTravaux = item.libelle;
          }
        });
        var dateSelect = null;
        this.selectAnneeFormat = '';
        var url = this.domaine + "journal/chantier/" + this.selectChantier + "/travaux/" + (this.selectTravaux ? this.selectTravaux : null) + "/annee/" + (this.selectAnnee ? this.selectAnnee : null) + '/' + this.typeRech + "/taches/" + (this.selectTaches ? this.selectTaches : null) + "/rendement";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this5.loading = false;
            _this5.listTravauxResult = response.body;
            _this5.$notify({
              title: 'RESULTATS DE VOTRE RECHERCHE',
              type: 'success',
              position: 'top-center'
            });
          }
        });
      } else {
        this.$message.error("Assurez-vous d'avoir sélectionner un chantier et un type de recherche");
        this.loading = false;
      }
    },
    loadTravaux: function loadTravaux() {
      var _this6 = this;

      this.loading = true;
      this.listTravaux = [];
      if (this.selectChantier != "" && this.selectChantier != null) {
        var url = this.domaine + "projet/" + this.selectChantier + "/index/chantier/travaux";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this6.listeTravaux = response.body.travaux;
            _this6.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un chantier");
        this.loading = false;
      }
    },
    loadTaches: function loadTaches() {
      var _this7 = this;

      this.loading = true;
      this.listTravaux = [];
      if (this.selectTravaux != "" && this.selectTravaux != null) {
        var url = this.domaine + "projet/travaux_tache/" + this.selectTravaux + "/index/tache";
        this.$http.get(url).then(function (response) {
          if (response.body) {
            _this7.listTaches = response.body.tache;
            _this7.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un travaux");
        this.loading = false;
      }
    },
    onchangeInfo: function onchangeInfo(projetS) {
      var _this8 = this;

      this.listeProjet.find(function (item) {
        if (item.id == projetS) {
          _this8.listeChantier = item.chantier;
        }
      });
    },
    onchangeChantier: function onchangeChantier(chantierS) {
      var _this9 = this;

      this.listeChantier.find(function (item) {
        if (item.id == chantierS) {
          _this9.listeTravaux = item.travauxId;
        }
      });
    },
    onChangeTravaux: function onChangeTravaux(travaux) {
      var _this10 = this;

      this.listeTravaux.find(function (item) {
        if (item.idChantier == travaux) {
          _this10.listTaches = item.travauxId;
        }
      });
    },
    imprimerModePlan: function imprimerModePlan(mode) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      console.log('mode', this.type);

      this.type = type ? type : this.type;
      console.log('mode', this.type);
      console.log('mode', mode);
      var url = '';
      if (mode == 'exel') {
        url = this.domaine + "journal/chantier/" + this.selectChantier + "/travaux/" + (this.selectTravaux ? this.selectTravaux : null) + "/annee/" + (this.selectAnnee ? this.selectAnnee : null) + '/' + this.typeRech + "/taches/" + (this.selectTaches ? this.selectTaches : null) + "/rendement" + '/' + this.user.id + '/' + mode + '/' + this.type;
      } else {
        url = this.domaine + "journal/chantier/" + this.selectChantier + "/travaux/" + (this.selectTravaux ? this.selectTravaux : null) + "/annee/" + (this.selectAnnee ? this.selectAnnee : null) + '/' + this.typeRech + "/taches/" + (this.selectTaches ? this.selectTaches : null) + "/rendement" + '/' + this.user.id + '/' + mode + '/' + this.type;
        this.$http.get(url).then(function (response) {
          if (response.body) {}
        });
        this.dialogueImprimer = false;
        this.type = '';
      }

      window.open(url);
    }
  },
  mounted: function mounted() {
    this.loadProjet();
  }
});

/***/ }),

/***/ "r8XM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas__ = __webpack_require__("eMjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_boardChantier_RapportJournalier__ = __webpack_require__("uij/");



var _components$name$prop;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Oq2I");
__webpack_require__("miEh");





/* harmony default export */ __webpack_exports__["a"] = (_components$name$prop = {
  components: { Loading: __WEBPACK_IMPORTED_MODULE_3__components_Loading__["a" /* default */], RapportJournalier: __WEBPACK_IMPORTED_MODULE_4__components_boardChantier_RapportJournalier__["a" /* default */] },
  name: "WidgetTravaux",
  props: {
    show: {
      type: Boolean
    },
    type: {
      type: Number,
      default: 0
    },
    listeTrx: {
      type: Array
    },
    listeTrxId: {
      type: Array
    }
  },
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      IdProduiSelect: "",
      statusRapport: [],
      listeRptNon: [],
      listeRptNon_: [],
      totalReserve: 0,
      reserveEnCours: 0,
      reserveValid: 0,
      tacheRefaire: 0,
      tacheTermine: 0,
      tauxReprise: 0,
      nbTrx: 0,
      showRapport: false,
      detailTravaux: {},
      dateRapport: null
    };
  },


  watch: {},

  methods: {
    //statistique rapport
    statStatutRapport: function statStatutRapport() {
      var optionRapport = {
        title: {
          text: "ETAT DES RAPPORTS JOURNALIERS",
          subtext: "",
          left: "center"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },

        series: [{
          name: "",
          type: "pie",
          selectedMode: "single",
          radius: [0, "30%"],

          label: {
            normal: {
              position: "inner"
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: [
            //{value:this.statDemandeG.refuse, name:'Demandes Refusées'},
            //{value:this.statDemandeG.accepte, name:'Demandes Acceptées', selected:true},
          ]
        }, {
          name: "",
          type: "pie",
          radius: ["40%", "55%"],
          label: {
            normal: {
              formatter: "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
              backgroundColor: "#eee",
              borderColor: "#aaa",
              borderWidth: 1,
              borderRadius: 4,

              rich: {
                a: {
                  color: "#999",
                  lineHeight: 16,
                  align: "center"
                },

                hr: {
                  borderColor: "#aaa",
                  width: "100%",
                  borderWidth: 0.5,
                  height: 0
                },
                b: {
                  fontSize: 12,
                  lineHeight: 20
                },
                per: {
                  color: "#eee",
                  backgroundColor: "#334455",
                  padding: [2, 2],
                  borderRadius: 2
                }
              }
            }
          },
          data: [{
            value: this.statusRapport.nbRptNonEffec,
            name: "Non effectués"
          }, {
            value: this.statusRapport.nbRptEffec,
            name: "Effectués"
          }]
        }]
      };
      var geneChartRapport = echarts.init(document.getElementById("statusRapportID"));
      geneChartRapport.setOption(optionRapport);
    },
    loadStatRapport: function loadStatRapport() {
      var _this = this;

      this.loading = true;
      var url = this.domaine + "journal/stat/travaux";
      var data = new FormData();
      data.append("listeTrxId", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.listeTrxId));
      data.append("iduser", this.user.id);
      this.$http.post(url, data).then(function (response) {
        _this.loading = false;
        _this.statusRapport.nbRptEffec = response.body.nbRptEffec;
        _this.statusRapport.nbRptNonEffec = response.body.nbRptNonEffec;
        //this.statusRapport.push(response.body.statRapport);
        _this.listeRptNon = response.body.listeTrxNonEffec;
        console.log('dd', _this.listeRptNon);
        // this.statStatutRapport();
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Erreur lors de dashboard travaux");
      });
    },
    filtrerEtatPrioriteBesoin: function filtrerEtatPrioriteBesoin() {
      var _this2 = this;

      this.listeRptNon = this.listeRptNon.filter(function (element) {
        console.log('element', element);
        console.log('element', _this2.IdProduiSelect);
        return element.dateRpt == _this2.IdProduiSelect;
      });
    },
    clearSelectProduit: function clearSelectProduit() {
      this.listeRptNon = this.listeRptNon_;
      // this.loadProduit();
    },
    loadStatReserve: function loadStatReserve() {
      var _this3 = this;

      var url = this.domaine + "reserve/stat/travaux";
      var data = new FormData();
      data.append("listeTrx", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.listeTrxId));
      this.$http.post(url, data).then(function (response) {
        _this3.loading = false;
        _this3.totalReserve = response.body.totalReserve;
        _this3.reserveEnCours = response.body.reserveEnCours;
        _this3.reserveValid = response.body.reserveValid;
        _this3.tacheRefaire = response.body.tacheRefaire;
        _this3.tacheTermine = response.body.tacheTermine;
        _this3.tauxReprise = response.body.tauxReprise;
        _this3.nbTrx = response.body.nbTrx;
      }, function (error) {
        _this3.loading = false;
        _this3.$message.error("Erreur lors chargement reserves dashboard");
      });
    },
    rapportJour: function rapportJour(item) {
      var _this4 = this;

      var url = this.domaine + "travaux/" + item.idTrx;
      this.$http.get(url).then(function (response) {
        _this4.detailTravaux = response.body.travaux;
        _this4.dateRapport = new Date(item.dateRptFormat);
        _this4.showRapport = true;
        _this4.loading = false;
      }, function (error) {
        _this4.loading = false;
        _this4.$message.error("Echec lors du chargement formulaire en cours");
      });
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$name$prop, "watch", {
  listeTrx: function listeTrx(newValue, oldValue) {
    console.log('jesusisi');
    // this.statStatutRapport();
    this.loadStatRapport();
    this.loadStatReserve();
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$name$prop, "mounted", function mounted() {}), _components$name$prop);

/***/ }),

/***/ "rYhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text))])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h2',[_vm._v("LISTE DES BONS DE COMMANDE INTERNES (BCI)")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-layout',{staticClass:"mb-3 mt-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner de Projet"},on:{"change":function($event){_vm.loadChantier();_vm.filtreByProjet(_vm.projetS)}},model:{value:(_vm.projetS),callback:function ($$v) {_vm.projetS=$$v},expression:"projetS"}},_vm._l((_vm.listeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner un Chantier"},on:{"change":function($event){return _vm.loadTravaux()}},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner un travaux"},on:{"clear":function($event){return _vm.clearSelect()},"change":function($event){return _vm.filtrerTravaux(_vm.travauxS)}},model:{value:(_vm.travauxS),callback:function ($$v) {_vm.travauxS=$$v},expression:"travauxS"}},_vm._l((_vm.listeTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right mb-3"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"elevation-3",attrs:{"slot":"activator","dark":"","icon":"","flat":"","color":"primary"},on:{"click":function($event){return _vm.loadBonCommande()}},slot:"activator"},[_c('v-icon',[_vm._v("cached")])],1),_vm._v("\n              actualiser la liste\n          ")],1),_vm._v(" "),_c('v-tooltip',[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerCommande1()}},slot:"activator"},[_vm._v("\n              Imprimer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("\n            Imprimer la liste des bons de commandes internes\n          ")],1)],1),_vm._v(" "),_c('data-tables',{ref:"multipleTableBon",staticStyle:{"width":"100%"},attrs:{"tables":"","mt-3":"","ml-1":"","mr-1":"","data":_vm.listBonCommande,"default-sort":{
            prop: 'libelle',
            order: 'descending'
          }},on:{"selection-change":_vm.handleSelectionBonChange}},[_c('el-table-column',{attrs:{"selectable":_vm.besoinBonSelect,"width":"55","type":"selection"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","width":"280"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v(_vm._s(scope.row.libelle)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projet","label":"Projet","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"chantier","label":"Chantier","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"travaux","label":"Travaux","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tache","label":"Tâche","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((scope.row.tache),function(item,index){return _c('span',{key:index},[_vm._v("\n                "+_vm._s(item)+"/\n              ")])})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tranconA","label":"PK debut","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tranconB","label":"PK fin","width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateLivr","label":"Date livraison souhaitée","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                "+_vm._s(scope.row.dateLivr)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user","label":"Emis par","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                "+_vm._s(scope.row.user)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"niveau","label":"Niveau de validation","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.niveauValid === 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"green accent-3"}},[_vm._v("VALIDÉ")]):(
                    scope.row.niveauValid === 1
                  )?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"orange accent-4"}},[_vm._v("CHEF PROJET")]):(
                    scope.row.niveauValid === 2
                  )?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"orange accent-3"}},[_vm._v("DEX")]):(
                    scope.row.niveauValid === 3
                  )?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"blue accent-3"}},[_vm._v("DGA/DOT")]):(
                    scope.row.niveauValid === 6
                  )?_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"yellow accent-3"}},[_vm._v("RESPONSABLE ENTREPOT")]):_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"red lighten-4"}},[_vm._v("REJETÉE")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showCommande(scope.row, true)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("Détails\n                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerCommande(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                  Imprimer\n                ")],1)],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogImprCommande),callback:function ($$v) {_vm.dialogImprCommande=$$v},expression:"dialogImprCommande"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModeCommande(2)}}},[_vm._v("\n                  Paysage\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModeCommande(1)}}},[_vm._v("\n                  Portrait\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"blue",attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogImprCommande = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogImprCommande1),callback:function ($$v) {_vm.dialogImprCommande1=$$v},expression:"dialogImprCommande1"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModeCommande1(2)}}},[_vm._v("\n                  Paysage\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModeCommande1(1)}}},[_vm._v("\n                  Portrait\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"blue",attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogImprCommande1 = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"40%"},model:{value:(_vm.dialogAccord2),callback:function ($$v) {_vm.dialogAccord2=$$v},expression:"dialogAccord2"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Voulez-vous valider ce bon de commande ?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.dialogAccord2 = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.validRejetBesoin(1)}}},[_vm._v("Valider")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"40%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogRejeterMission),callback:function ($$v) {_vm.dialogRejeterMission=$$v},expression:"dialogRejeterMission"}},[_c('v-card',[_c('v-card-title',{staticClass:"text-xs-center"},[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Rejeter le bon de commande")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"outline":"","color":"orange darken-1","icon":"warning","value":true}},[_vm._v("\n                          Etes-vous sur de vouloir rejeter le bon de commande ?\n                      ")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{staticClass:"demo-form-inline"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-form-item',{attrs:{"label":"Motif du refus"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":"Motif du refus"},model:{value:(_vm.commDec),callback:function ($$v) {_vm.commDec=$$v},expression:"commDec"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{on:{"click":function($event){$event.stopPropagation();_vm.dialogRejeterMission = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.validRejetBesoin(0)}}},[_vm._v("Confirmer\n                  ")])],1)],1)],1),_vm._v(" "),_c('ModalCommandeDetails',{attrs:{"detailCommande":_vm.detailCommande,"hiddenButton":_vm.hiddenButton,"show":_vm.showModalDetailCom},on:{"close":function($event){_vm.showModalDetailCom = false}}}),_vm._v(" "),_c('CoolLightBox',{attrs:{"items":_vm.items,"index":_vm.index},on:{"close":function($event){_vm.index = null}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "racX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "reW9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogDetail),callback:function ($$v) {_vm.dialogDetail=$$v},expression:"dialogDetail"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Fiche de Validation devis / facture fournisseur")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Informations générales sur devis / facture\n                                            ")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Réference de la facture")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.factureDetail.ref)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Libelle")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.factureDetail.libelle)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Date de création de la facture")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.factureDetail.date)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.factureDetail.chantier !=''),expression:"factureDetail.chantier !=''"}],attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Projet / Chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[_vm._v("\n                                                                               "+_vm._s(_vm.factureDetail.projet)+" / "+_vm._s(_vm.factureDetail.chantier)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.factureDetail.libEntrepot),expression:"factureDetail.libEntrepot"}],attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Entrepot")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs12":""}},[_vm._v("\n                                                                               "+_vm._s(_vm.factureDetail.libEntrepot)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Emetteur de la facture")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.factureDetail.emetteurFacture)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de paiement")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.factureDetail.datePaiement)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),(_vm.factureDetail.modifiedCommande != null)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de modification de la commande")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.factureDetail.modifiedCommande)+"\n                                                                            ")])],1):_vm._e(),_vm._v(" "),(_vm.factureDetail.usermodified != null)?_c('v-divider',{staticClass:"mb-3"}):_vm._e(),_vm._v(" "),(_vm.factureDetail.usermodified != null)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Modifié par")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.factureDetail.usermodified)+"\n                                                                            ")])],1):_vm._e(),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),(_vm.factureDetail.idContrat)?_c('v-layout',{staticClass:"mb-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Contrat prestataire")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                contrat-"+_vm._s(_vm.factureDetail.idContrat)+"\n                                                                            ")])],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(!_vm.factureDetail.imgCommande)?_c('v-flex',{staticClass:"mr-2",attrs:{"xs2":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.image1,"alt":"avatar"}})])],1):_c('v-flex',{staticClass:"mr-3  elevation-23 ",attrs:{"xs3":""}},[_c('a',{attrs:{"href":_vm.factureDetail.imgCommande,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.factureDetail.imgCommande}})])],1)])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Fournisseur")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.factureDetail.libelleFour)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Conditions de paiement")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.factureDetail.modalite)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Avance démarage %")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.factureDetail.avance)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Travaux")]),_vm._v(" "),(_vm.factureDetail.travaux != null)?_c('v-layout',[_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.factureDetail.travaux)+"\n                                                                            ")])],1):_vm._e(),_vm._v(" "),(_vm.factureDetail.idContrat != null)?_c('v-layout',[_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                            "+_vm._s(_vm.factureDetail.libelleTravaux)+"\n                                                                            ")])],1):_vm._e()],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Initiateur de la commande")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(_vm.factureDetail.demandeurCommande)+"\n                                                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),(_vm.factureDetail.idContrat == null)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Budget Travaux")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(new Intl.NumberFormat().format(_vm.factureDetail.budgetTravaux))+"\n\n                                                                            ")])],1):_vm._e(),_vm._v(" "),(_vm.factureDetail.idContrat == null)?_c('v-divider',{staticClass:"mb-3"}):_vm._e(),_vm._v(" "),(_vm.factureDetail.idContrat == null)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Montant decaisse Travaux")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(new Intl.NumberFormat().format(_vm.factureDetail.mntTotalDecaisseTrx))+"\n\n                                                                            ")])],1):_vm._e(),_vm._v(" "),(_vm.factureDetail.idContrat == null)?_c('v-divider',{staticClass:"mb-3"}):_vm._e(),_vm._v(" "),(_vm.factureDetail.idContrat == null)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Ecart montant")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                "+_vm._s(new Intl.NumberFormat().format(_vm.factureDetail.ecartBudgetTrx))+"\n\n                                                                            ")])],1):_vm._e(),_vm._v(" "),(_vm.factureDetail.idContrat == null)?_c('v-divider',{staticClass:"mb-3"}):_vm._e(),_vm._v(" "),(_vm.factureDetail.idContrat == null)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Etat budget travaux (si la facture est validée)")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_c('el-tag',{attrs:{"type":(_vm.factureDetail.ecartBudgetTrx >= _vm.factureDetail.total) ? 'success' : 'danger',"disable-transitions":""}},[(_vm.factureDetail.ecartBudgetTrx >= _vm.factureDetail.total)?_c('span',[_vm._v("Dans le budget")]):_c('span',[_vm._v("Hors budget")])])],1)],1):_vm._e(),_vm._v(" "),(_vm.factureDetail.idContrat == null)?_c('v-divider',{staticClass:"mb-3"}):_vm._e(),_vm._v(" "),(_vm.listeRapports.length > 0 )?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.loadRapportTrx()}},slot:"activator"},[_vm._v("\n                                                                                        Liste des rapports\n                                                                                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("assignment")])],1),_vm._v("Liste des rapports\n                                                                                ")],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.factureDetail.compare == 2)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Validé par le comparateur de prix")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_c('a',{attrs:{"href":"#","target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":"static/validComparateur.png"}})])],1)])],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"green","dark":""},on:{"click":function($event){_vm.dialogDetailCmd = true}},slot:"activator"},[_vm._v(" Consulter\n                                                                                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("compare")])],1):_vm._e(),_vm._v("Voir la proprosition du comparateur de prix\n                                                                              ")],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                                Produits / Travaux\n                                            ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (TTC): "+_vm._s(new Intl.NumberFormat().format(_vm.factureDetail.total)))])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.factureDetail.idContrat)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"primary darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Mnt Contrat : ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("   "+_vm._s(new Intl.NumberFormat().format(_vm.factureDetail.mntEstime))+" ")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"blue-grey darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Devis / facture(s) déjà generée(s) : ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("   "+_vm._s(new Intl.NumberFormat().format(_vm.factureDetail.mntFacture))+" ")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Mnt à verser / évolution: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("   "+_vm._s(new Intl.NumberFormat().format(_vm.factureDetail.mntAVerse))+" / "+_vm._s(_vm.factureDetail.evolution)+"% ")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"red darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Mnt restant: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("   "+_vm._s(new Intl.NumberFormat().format(_vm.factureDetail.mntRestant))+" ")])])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.factureDetail.option}},[_c('el-table-column',{attrs:{"prop":"produit","label":"Designation","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixUOld","label":"Ancien prix unitaire"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                                                                                       "+_vm._s(new Intl.NumberFormat().format(scope.row.prixUOld))+"\n                                                                                      ")])]}}])}),_vm._v(" "),(_vm.factureDetail.idContrat == null)?_c('el-table-column',{attrs:{"prop":"prix","label":"Prix unitaire"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v("\n                                                                               "+_vm._s(new Intl.NumberFormat().format(prop.row.prix))+"\n                                                                            ")]}}],null,false,3663219406)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),(_vm.factureDetail.idContrat == null)?_c('el-table-column',{attrs:{"prop":"qte","label":"Quantite"}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remise","label":"Remise(%)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"Tva(%)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Total commande / Montant prestataire"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v("\n                                                                              "+_vm._s(new Intl.NumberFormat().format(prop.row.total))+"\n                                                                            ")]}}])})],1)],1),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5",staticStyle:{"margin-right":"100px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"red"},on:{"click":function($event){_vm.dialogConfirmRefus = true}},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Refuser la demande")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"green"},on:{"click":function($event){_vm.dialogConfirm = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v("Valider la demande")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirmRefus),callback:function ($$v) {_vm.dialogConfirmRefus=$$v},expression:"dialogConfirmRefus"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation de devis / facture")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous Refuser cette facture ?","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("FACTURE")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("FACT-"+_vm._s(_vm.factureDetail.idFact))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{ref:"refFormRefust",staticClass:"demo-form-inline",attrs:{"id":"formRefus","rules":_vm.ruleFormRefus,"label-position":"top","inline":true,"model":_vm.formRefus}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Commentaire","prop":"rapportRefus"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Pourquoi voulez-vous refuser ?"},model:{value:(_vm.formRefus.rapport),callback:function ($$v) {_vm.$set(_vm.formRefus, "rapport", $$v)},expression:"formRefus.rapport"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirmRefus = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitRefusDevis()}}},[_vm._v("Refuser")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation de devis / facture")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous valider le facture ?","closable":false,"show-icon":"","type":"success"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("FACTURE")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("FACT-"+_vm._s(_vm.factureDetail.idFact))])]),_vm._v(" "),_c('el-form',{ref:"formValidate",staticClass:"demo-ruleForm demo-form-inline",attrs:{"model":_vm.formValidate,"inline":true,"label-width":"150px"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"prop":"choix","label":"Type de règlement","rules":[
                                          { required: true, message: 'Le champs est obligatoire'} ]}},[_c('el-select',{attrs:{"placeholder":"Votre choix"},on:{"change":function($event){return _vm.changeReglement()}},model:{value:(_vm.formValidate.choix),callback:function ($$v) {_vm.$set(_vm.formValidate, "choix", $$v)},expression:"formValidate.choix"}},[_c('el-option',{attrs:{"label":"En Espèce","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Par Chèque","value":"2"}})],1)],1)],1),_vm._v(" "),(_vm.formValidate.choix == 2)?_c('v-flex',{staticClass:"mr-1",attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"prop":"banque","label":"La banque","rules":[
                                          { required: true, message: 'Le champs est obligatoire'} ]}},[_c('el-select',{attrs:{"placeholder":"La banque"},model:{value:(_vm.formValidate.banque),callback:function ($$v) {_vm.$set(_vm.formValidate, "banque", $$v)},expression:"formValidate.banque"}},_vm._l((_vm.listBanque),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1):_vm._e(),_vm._v(" "),(_vm.formValidate.choix == 1)?_c('v-flex',{staticClass:"mr-1",attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"prop":"banque","label":"La Caisse","rules":[
                                          { required: true, message: 'Le champs est obligatoire'} ]}},[_c('el-select',{attrs:{"placeholder":"La caisse"},model:{value:(_vm.formValidate.banque),callback:function ($$v) {_vm.$set(_vm.formValidate, "banque", $$v)},expression:"formValidate.banque"}},_vm._l((_vm.listCaisse),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirm = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideDevis()}}},[_vm._v("Confirmer")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogListeRapport),callback:function ($$v) {_vm.dialogListeRapport=$$v},expression:"dialogListeRapport"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("LISTE DES RAPPORTS DES TRAVAUX : "+_vm._s(_vm.factureDetail.travaux))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogListeRapport = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('ListeRapportTrx',{attrs:{"libTrx":_vm.factureDetail.travaux,"IddetailTravaux":_vm.factureDetail.idTravaux,"listeRapportTrx":_vm.listeRapports}})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogDetailCmd),callback:function ($$v) {_vm.dialogDetailCmd=$$v},expression:"dialogDetailCmd"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Détail de la commande analyser par le comparateur ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeCompar()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(_vm.commandeDeriv.length == 0 && _vm.commandeDerivDeux.length == 0)?_c('v-alert',{staticClass:"elevation-1 subheading mb-1 mt-5",attrs:{"color":"warning","value":true,"icon":"priority_high","outline":""}},[_vm._v("\n                    Les produits de cette commande ne se trouvent chez aucun de vos fournisseurs,\n                      Pour une meilleur performance du comparateur, veuillez constitué une base importante de fournisseurs.\n                    ")]):_vm._e(),_vm._v(" "),_c('v-card-text',[_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":""}},[(_vm.commandeDeriv.length != 0)?_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v("COMMANDE(S) SUGGEREE(S) POUR LES FOURNISSEURS AYANT TOUS LES PRODUITS DE LA COMMANDE")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-container',[_c('v-layout',{staticClass:"mb-2",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(" "+_vm._s(_vm.nbCommandeSug)+" ")]),_vm._v("\n                                          Fournisseur(s) proprosant des meilleurs prix pour ce(s) produit(s)\n                                        ")],1)],1)],1)],1),_vm._v(" "),_c('v-container',_vm._l((_vm.commandeDeriv),function(fourn,indF){return _c('v-layout',{key:indF},[_c('v-flex',{staticClass:"mb-4 pl-3 pt-3 mr-3 elevation-5",attrs:{"xs12":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs8":""}},[_c('v-chip',{staticClass:"elevation-4 text-xs-left",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Fournisseur :      ")]),_vm._v(" "),_c('span',{staticClass:"title text-xs-left"},[_vm._v("   "+_vm._s(fourn.fournisseur))])]),_vm._v(" "),_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total HT:     ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("    "+_vm._s(new Intl.NumberFormat().format(fourn.mntTotalHt))+"  Fcfa ")])]),_vm._v(" "),_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total TTC:     ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("    "+_vm._s(new Intl.NumberFormat().format(fourn.mntTotal))+"  Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{attrs:{"data":fourn.produits}},[_c('el-table-column',{attrs:{"prop":"libelleProduit","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteProd","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixUFormat","label":"Prix Unitaire (Fcfa)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"Tva"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotalHt","label":"Total HT (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("  "+_vm._s(scope.row.mntTotalFormatHt))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotal","label":"Total TTC (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("  "+_vm._s(scope.row.mntTotalFormat))])]}}],null,true)})],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)}),1)],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.commandeDerivDeux.length != 0)?_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"teal","dark":""}},[_c('v-toolbar-title',[_vm._v("COMMANDE(S) SUGGEREE(S) POUR LES FOURNISSEURS AYANT CERTAINS PRODUITS DE LA COMMANDE")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-container',[_c('v-layout',{staticClass:"mb-2",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(" "+_vm._s(_vm.nbCommandeSugDeux)+" ")]),_vm._v("\n                                          Fournisseur(s) proprosant des meilleurs prix pour ce(s) produit(s)\n                                        ")],1)],1)],1)],1),_vm._v(" "),_c('v-container',_vm._l((_vm.commandeDerivDeux),function(fourn,indF){return _c('v-layout',{key:indF},[_c('v-flex',{staticClass:"mb-4 pl-3 pt-3 mr-3 elevation-5",attrs:{"xs12":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs8":""}},[_c('v-chip',{staticClass:"elevation-4 text-xs-left",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Fournisseur :     ")]),_vm._v(" "),_c('span',{staticClass:"title text-xs-left"},[_vm._v("   "+_vm._s(fourn.fournisseur))])]),_vm._v(" "),_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total HT:     ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("    "+_vm._s(new Intl.NumberFormat().format(fourn.mntTotalHt))+"  Fcfa ")])]),_vm._v(" "),_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total TTC:     ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("    "+_vm._s(new Intl.NumberFormat().format(fourn.mntTotal))+"  Fcfa ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{attrs:{"data":fourn.produits}},[_c('el-table-column',{attrs:{"prop":"libelleProduit","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteProd","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixUFormat","label":"Prix Unitaire (Fcfa)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"Tva"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotalHt","label":"Total HT (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("  "+_vm._s(scope.row.mntTotalFormatHt))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotal","label":"Total TTC (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("   "+_vm._s(scope.row.mntTotalFormat))])]}}],null,true)})],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)}),1)],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5",staticStyle:{"margin-right":"30px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":""},on:{"click":function($event){$event.stopPropagation();return _vm.closeCompar()}},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Femer")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rg0G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
    name: "boardResource",
    data: function data() {
        return {
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            loading: false,

            listeAbsence: [],
            listeDemandeAbs: [],
            listeContratsRenouv: [],
            listeContratsRenouvMoisProch: [],

            nbContrats: 0,
            nbContratArenouv: 0,
            nbContFormation: 0,
            nbContProfession: 0,
            nbContPartiel: 0,
            nbContConsult: 0,
            nbContCDD: 0,
            nbContCDI: 0,

            nbEmploye: 0,
            nbAbsent: 0,
            nbDmdAbsAttente: 0

        };
    },

    methods: {
        loadStatistiqueRh: function loadStatistiqueRh() {
            var _this = this;

            //this.loading = true;
            var url = this.domaine + "rh/statistique";
            this.$http.get(url).then(function (resp) {
                var dataStat = resp.body.dataStat;
                //chargement des donnees de stst
                _this.nbContrats = dataStat.nbContrats;
                _this.nbContratArenouv = dataStat.nbContratsArenouveler;
                _this.nbContFormation = dataStat.nbContratsFormation;
                _this.nbContProfession = dataStat.nbContratsProf;
                _this.nbContPartiel = dataStat.nbContratsTempsPart;
                _this.nbContConsult = dataStat.nbContratsConsultant;
                _this.nbContCDD = dataStat.nbContratsCDD;
                _this.nbContCDI = dataStat.nbContratsCDI;
                _this.nbEmploye = dataStat.nbEmployes;
                _this.nbAbsent = dataStat.nbAbsents;
                _this.nbDmdAbsAttente = dataStat.nbAbsencesAttente;

                _this.listeContratsRenouv = dataStat.listeContArenouveler;
                _this.listeContratsRenouvMoisProch = dataStat.listeContratArenouvMoisProch;
                _this.listeAbsence = dataStat.listeEmployeAbsent;
                _this.listeDemandeAbs = dataStat.listeDemandeEmpl;

                _this.statTypeContrat(dataStat.dataPie);
                _this.loading = false;
            }, function (error) {
                _this.loading = false;
                _this.$message.error("Echec lors du chargement des informations de statistique");
            });
        },
        statTypeContrat: function statTypeContrat(dataTypeContrat) {
            var option = {
                title: {
                    text: "",
                    left: 'top',
                    textStyle: {
                        color: '#000',
                        fontWeight: 'normal',
                        position: 'top'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: 10,
                    data: []
                },
                series: [{
                    name: 'Nb Contrat(s)',
                    type: 'pie',
                    width: 'auto',
                    color: ["#F44336", "#FF9800", "#9C27B0", "#00BCD4", "#4CAF50", "#03A9F4"],
                    radius: ['60%', '90%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: true,
                        position: 'right'
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: '10',
                            fontWeight: 'normal'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: []
                }]
            };

            for (var datapie in dataTypeContrat) {
                option.series[0].data.push({ value: dataTypeContrat[datapie], name: "" });
            }

            var chartContrat = echarts.init(document.getElementById('chartTypeContrat'));
            chartContrat.setOption(option);
        }
    },
    mounted: function mounted() {
        this.loadStatistiqueRh();
    }
});

/***/ }),

/***/ "riMH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_divers_loadTypeTravaux_vue__ = __webpack_require__("iQMl");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "formNiveauTypeTravaux",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */], LoadTypeTravauxExcel: __WEBPACK_IMPORTED_MODULE_2__components_divers_loadTypeTravaux_vue__["a" /* default */] },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    listeLotTravaux: {
      type: Array,
      default: new Array()
    },
    idTypeNivProjet: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      loading: false,
      dialogAjoutTravaux: false,
      listeLots: [],
      formLotTravaux: {
        idTypeTrx: null,
        ordre: "",
        libelle: "",
        code: "",
        description: ""
      },
      rulesLotTravaux: {
        ordre: [{
          required: true,
          message: "Veuillez selectionnez un numéro d'ordre",
          trigger: "blur"
        }],
        libelle: [{
          required: true,
          message: "Veuillez  saisir un type de travaux",
          trigger: "blur"
        }],
        code: [{
          required: true,
          message: "Veuillez  saisir un code",
          trigger: "blur"
        }]
      },
      numOrdre: [],
      numOrdreCopie: [],
      listeTrxSupp: [],
      showModalLoadTypeTravaux: false,

      //Importer fichier excel
      fileExcel: [],
      lstTypeTravaux: []
    };
  },

  watch: {
    show: function show(newValue, oldValue) {
      var _this = this;

      if (newValue == true) {
        this.listeLots.splice(0);
        this.numOrdre.splice(0);
        this.dialogAjoutTravaux = true;
        this.listeTrxSupp = [];
        this.numOrdre.push({ num: 1 });
        if (this.listeLotTravaux.length > 0) {
          this.numOrdre.splice(0);
          //rechechons lordre le plus eleve
          var ordreSup = null;
          this.listeLotTravaux.forEach(function (elt, ind) {
            if (ind + 1 < _this.listeLotTravaux.length) {
              var prochainOrdre = _this.listeLotTravaux[ind + 1].ordre;
              if (prochainOrdre > elt.ordre) {
                ordreSup = prochainOrdre;
              } else {
                ordreSup = elt.ordre;
              }
            }
          });

          this.listeLots = this.listeLotTravaux.slice();
          this.numOrdreCopie.splice(0);
          var nbLots = this.listeLotTravaux.length;
          this.numOrdre.push({ num: ordreSup + 1 });

          if (this.listeLotTravaux.length == 1) {
            this.numOrdre.push({ num: 2 });
          }

          for (var i = 0; i <= nbLots; i++) {
            this.numOrdreCopie.push({ num: i + 1 });
          }
        }
      } else {
        this.dialogAjoutTravaux = false;
        this.listeTrxSupp = [];
      }
    }
  },
  computed: {
    listeNumber: function listeNumber() {
      var _this2 = this;

      var listeNum = this.numOrdreCopie.slice();
      return listeNum.filter(function (elt) {
        if (elt.num <= _this2.listeLots.length) {
          return elt;
        }
      });
    }
  },
  methods: {
    changeOrdre: function changeOrdre(value, ind) {},
    submitTravaux: function submitTravaux() {
      var _this3 = this;

      if (this.idTypeNivProjet == null) {
        this.$message.error("Aucun type de projet selectionné");
        return;
      }
      this.loading = true;
      var url = this.domaine + "projet/new/travaux/projet/niveau";
      //recuperer les lots de travaux par groupe de 10
      var nbData = 10;
      var nbReq = 1;
      var ligne = null;

      var nbRest = void 0;
      if (this.listeLots.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.listeLots.length / nbData);
        nbRest = this.listeLots.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (var i = 0; i < nbReq; i++) {
        var initJ = i * nbData;
        var finJ = (i + 1) * nbData;
        var dataLot = [];
        if (this.listeLots.length > 0) {
          for (var j = initJ; j < finJ; j++) {
            if (this.listeLots[j] == undefined) {
              break;
            }
            dataLot.push(this.listeLots[j]);
          }
        }
        var data = new FormData();

        for (var prop in dataLot) {
          ligne = dataLot[prop];
          data.append("option[ordre][]", ligne.ordre);
          data.append("option[libelle][]", ligne.libelle);
          data.append("option[code][]", ligne.code);
          data.append("option[description][]", ligne.description);
        }

        // data.append('listeTypeTravaux', JSON.stringify(dataLot))
        data.append("type", this.idTypeNivProjet);
        data.append("idUser", this.user.id);
        data.append("listeSupp", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.listeTrxSupp));

        this.$http.post(url, data).then(function (resp) {
          _this3.loading = false;
          // succesEnreg = true;
          if (resp.body.code == 1) {
            _this3.$notify({
              title: "Enregistrement",
              message: resp.body.message,
              duration: 7000,
              type: "success"
            });
          }

          if (resp.body.code == 2) {
            _this3.$notify({
              title: "Suppression",
              message: resp.body.message,
              duration: 7000,
              type: "warning"
            });
          }
        }, function (error) {
          _this3.loading = false;
          _this3.$message.error("Erreur lors de l'enregistrement des lots");
        });
      }
      this.$emit("close");
    },
    closeForm: function closeForm() {
      this.$emit("close");
      this.resetForm();
    },
    deleteRow: function deleteRow(index, rows) {
      var ordreIndex = this.listeLots[index].ordre;
      var indexpos = this.numOrdre.findIndex(function (elt) {
        return elt.num > ordreIndex;
      });
      var indexposCopie = this.numOrdreCopie.findIndex(function (elt) {
        return elt.num == ordreIndex;
      });

      this.numOrdre.splice(indexpos, 0, { num: ordreIndex });
      this.numOrdreCopie.splice(indexposCopie, 1);

      //enregistrer lid du lot de travaux supprimer dans la liste
      if (this.listeLots[index].idTypeTrx != null) {
        this.listeTrxSupp.push(this.listeLots[index].idTypeTrx);
      }

      rows.splice(index, 1);
      if (this.listeLots.length <= 0) {
        this.numOrdre.splice(0);
        this.numOrdreCopie.splice(0);

        this.numOrdre.push({ num: 1 });
        this.numOrdreCopie.push({ num: 1 });
      }
    },
    addListeTypeTravaux: function addListeTypeTravaux() {
      var _this4 = this;

      this.$refs["formLotTravaux"].validate(function (valid) {
        if (valid) {
          var lenListelot = _this4.listeLots.length;
          var indiceInsert = _this4.formLotTravaux.ordre - 1;
          _this4.listeLots.splice(indiceInsert, 0, {
            idTypeTrx: _this4.formLotTravaux.idTypeTrx,
            libelle: _this4.formLotTravaux.libelle,
            code: _this4.formLotTravaux.code,
            ordre: _this4.formLotTravaux.ordre,
            description: _this4.formLotTravaux.description
          });

          var index = _this4.numOrdre.findIndex(function (elt) {
            return elt.num == _this4.formLotTravaux.ordre;
          });

          var dernierChif = _this4.numOrdre[_this4.numOrdre.length - 1].num;

          _this4.numOrdre.splice(index, 1);

          _this4.numOrdre.push({ num: dernierChif + 1 });
          _this4.resetForm();
        }
      });
    },
    handleChangeLibelle: function handleChangeLibelle(newValue, oldValue) {
      if (newValue = "") {
        // this.$message({
        //     message: 'Ce champ ne peut etre vide',
        //     type: 'warning'
        // });
      }
    },
    handleFileExcel: function handleFileExcel(command //0=>Importer,1=>generer
    ) {
      switch (command) {
        case "0":
          //importer un fichier
          this.$refs.fileInputExcel.click();
          break;
        case "1":
          //generer un modele un fichier
          this.generateFileExcel();
          break;
      }
    },
    generateFileExcel: function generateFileExcel() {
      var url = this.domaine + "projet/generer/modele/travaux/projet";
      window.open(url);
    },
    onFileExcelPicked: function onFileExcelPicked(event) {
      var _this5 = this;

      //  this.closeForm()
      this.fileExcel.splice(0, 1);
      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this5.fileExcel.push(fileReader.result);
      });

      fileReader.readAsDataURL(files[0]);

      var url = this.domaine + "travaux/load_typeTravaux/excel";
      var data = new FormData();
      //emvoie du fichier

      data.append("fichierExcel", files[0], files[0][name]);
      this.$http.post(url, data).then(function (resp) {
        _this5.loading = false;

        _this5.$notify({
          title: "Chargement liste type travaux",
          message: "Chargement effectué",
          type: "success",
          position: "top-right",
          duration: 7000
        });
        _this5.lstTypeTravaux = resp.body.listeTypeTravaux;
        _this5.showModalLoadTypeTravaux = true;
      }, function (resp) {
        _this5.loading = false;
        _this5.$message.error("Erreur lors de l'importation du fichier");
      });
    },
    resetForm: function resetForm() {
      this.$refs["formLotTravaux"].resetFields();
      this.formLotTravaux.libelle = "";
      this.formLotTravaux.code = "";
      this.formLotTravaux.description = "";
      this.listeTrxSupp.splice(0);
    }
  }
});

/***/ }),

/***/ "rzYm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "IndexOuvrierTrx",
  props: {
    show: {
      type: Boolean
    },
    detailTrx: {
      type: Object
    },
    tacheSelect: {
      type: Object
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      dialogTache: false,
      loading: false,
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      listeTache: [],
      dialogOuvrier: false,
      dialogDemarrer: false,
      dialogConfirmRefus: false,
      listePrestataires: [],
      listePrestOuvriers: [],
      listePresence: [],
      listeOuvriers: [],
      formRefus: {},
      presenceSelect: {},
      //   tacheSelect: {
      //     libelle: ""
      //   },
      dialogTermine: false,
      formDemarrer: {},
      prestataireSelect: {
        idContrat: null,
        datePresence: null,
        file: null
      },
      tablePrestataire: [],
      dialogSuprPresence: false,
      imageRes: "/static/avatar-conducteur.png"
    };
  },

  methods: {
    closeDialog: function closeDialog() {
      this.dialogOuvrier = false;
      this.$emit("close");
    },
    loadOuvrier: function loadOuvrier(tache) {
      var _this = this;

      this.prestataireSelect.datePresence = null;
      this.prestataireSelect.idContrat = null;
      this.loading = true;
      var url = "";
      if (tache.idOpt) {
        url = this.domaine + "ouvrier/optionTravaux/" + tache.idOpt;
      } else {
        url = this.domaine + "ouvrier/optionTravaux/" + tache.id;
      }

      this.$http.get(url).then(function (response) {
        _this.listeOuvriers = response.body.ouvriers;
        _this.listePrestataires = response.body.prestataires;
        _this.listePrestOuvriers = response.body.listePresOuvriers;
        _this.listePresence = response.body.listePresence;
        _this.dialogOuvrier = true;
        _this.loading = false;
      }, function (error) {
        _this.loading = false;
        _this.$message.error("Echec lors du chargement des ouvriers");
      });
    },
    submitFormDemarrer: function submitFormDemarrer(formName) {
      var _this2 = this;

      if (this.formDemarrer.dateDbt != "undefined" && this.formDemarrer.hrDbt != null && this.formDemarrer.hrDbt != "undefined" && this.formDemarrer.hrDbt != null) {
        this.loading = true;
        var url = this.domaine + "tache/demarrer/optionTrx/" + this.tacheSelect.idOpt;
        var data = new FormData();

        var dateDbt = this.formDemarrer.dateDbt.getFullYear() + "-" + this.formDemarrer.dateDbt.getMonth() + "-" + this.formDemarrer.dateDbt.getDate();
        var hrDbt = this.formDemarrer.hrDbt.getHours() + ":" + this.formDemarrer.hrDbt.getMinutes();

        data.append("dateDbt", dateDbt);
        data.append("hrDbt", hrDbt);
        this.$http.post(url, data).then(function (response) {
          _this2.loading = false;
          //reinitialiser le formulaire
          _this2.dialogDemarrer = false;

          var mess = response.body.message;
          _this2.loadTache(_this2.detailTrx);
          _this2.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: mess,
            type: "success",
            position: "top-center"
          });
        }, function (erreur) {
          //reinitialiser le formulaire
          _this2.resetForm("formDemarrer");
          _this2.loading = false;
          _this2.$message.error("L'opération a echouée");
        });
      } // verifie champs date
      else {
          this.$message.error("Veuillez remplir correctement la date et l'heure svp...");
        }
    },
    submitFormStop: function submitFormStop(formName) {
      var _this3 = this;

      if (this.formRefus.rapport != "undefined" && this.formRefus.rapport != null) {
        this.loading = true;
        var url = this.domaine + "tache/arret/stop/tachetrx/" + this.tacheSelect.idOpt;
        var data = new FormData();

        data.append("idUser", this.user.id);
        data.append("rapport", this.formRefus.rapport);

        this.$http.post(url, data).then(function (response) {
          //reinitialiser le formulaire
          _this3.loading = false;
          _this3.dialogConfirmRefus = false;
          _this3.formRefus.rapport = "";
          var mess = response.body.message;
          _this3.loadTache(_this3.detailTrx);

          _this3.$notify({
            title: "ENREGISTREMENT REUSSI",
            message: mess,
            type: "success",
            position: "top-center"
          });
        }, function (erreur) {
          //reinitialiser le formulaire
          _this3.formRefus.rapport = "";
          _this3.loading = false;
          _this3.$message.error("L'opération a echouée");
        });
      } //rapport non saisie
      else {
          this.$message.error("Veuillez remplir correctement les champs svp...");
        }
    },
    submitRelanceTache: function submitRelanceTache() {
      var _this4 = this;

      this.loading = true;
      var url = this.domaine + "tache/relance/optionTrx/" + this.tacheSelect.idOpt;
      var data = new FormData();
      data.append("idUser", this.user.id);
      this.$http.post(url, data).then(function (response) {
        //reinitialiser le formulaire
        _this4.loading = false;

        var mess = response.body.message;
        _this4.$emit("reloadListeTravaux");
        _this4.loadTache(_this4.detailTrx);

        _this4.$notify({
          title: "ENREGISTREMENT REUSSI",
          message: mess,
          type: "success",
          position: "top-center"
        });
      }, function (erreur) {
        _this4.loading = false;
        _this4.$message.error("L'opération a echouée");
      });
    },
    submitTacheTerminer: function submitTacheTerminer() {
      var _this5 = this;

      this.loading = true;
      var url = this.domaine + "tache/termine/optionTrx/" + this.tacheSelect.idOpt;
      var data = new FormData();
      data.append("idUser", this.user.id);
      this.$http.post(url, data).then(function (response) {
        //reinitialiser le formulaire
        _this5.loading = false;
        _this5.dialogTermine = false;

        var mess = response.body.message;
        _this5.loadTache(_this5.detailTrx);

        _this5.$notify({
          title: "ENREGISTREMENT REUSSI",
          message: mess,
          type: "success",
          position: "top-center"
        });
      }, function (erreur) {
        _this5.loading = false;
        _this5.$message.error("L'opération a echouée");
      });
    },
    submitPresence: function submitPresence() {
      var _this6 = this;

      if (this.prestataireSelect.idContrat == null || this.prestataireSelect.idContrat == "undefined" || this.prestataireSelect.datePresence == "undefined" || this.prestataireSelect.datePresence == null) {
        this.$message.error("Veuillez renseigner correctement les champs");
        return;
      }
      ///this.loading = true;
      var url = this.domaine + "presence/new";
      var data = new FormData();
      data.append("idUser", this.user.id);
      data.append("idContrat", this.prestataireSelect.idContrat);
      data.append("datePresence", this.prestataireSelect.datePresence);
      data.append("fichierRes", this.prestataireSelect.file, this.prestataireSelect.file[name]);

      this.$http.post(url, data).then(function (response) {
        //reinitialiser le formulaire

        _this6.loading = false;
        var mess = response.body.message;
        _this6.imageRes = "/static/avatar-conducteur.png";

        _this6.$notify({
          title: "ENREGISTREMENT REUSSI",
          message: mess,
          type: "success",
          position: "top-center"
        });

        _this6.loadOuvrier(_this6.tacheSelect);
        _this6.loading = false;
      }, function (erreur) {
        _this6.loading = false;
        _this6.$message.error("L'opération a echouée");
      });
    },
    deletePresence: function deletePresence(idPresence) {
      var _this7 = this;

      this.loading = true;

      var url = this.domaine + "presence/delete/" + idPresence;
      this.$http.get(url).then(function (response) {
        _this7.loading = false;

        _this7.$notify({
          title: "SUPPRESSION REUSSIE",
          message: "Demande supprimée avec succès.",
          type: "success",
          position: "top-center"
        });
        _this7.dialogSuprPresence = false;

        _this7.loadOuvrier(_this7.tacheSelect);
      }, function (errRep) {
        _this7.loading = false;
        _this7.dialogSuprPresence = false;
        _this7.$notify.error({
          title: "SUPPRESSION ECHOUEE",
          message: "La suppression de la demande a échouée.",
          position: "top-center"
        });
      });
    },
    onFileResPicked: function onFileResPicked(event) {
      var _this8 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this8.imageRes = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.prestataireSelect.file = files[0];
      //this.file = files[0];
    }
  },

  watch: {
    show: function show(newValue, oldvalue) {
      this.dialogOuvrier = newValue;
      if (newValue) {
        this.loadOuvrier(this.tacheSelect);
      }
    }
  }
});

/***/ }),

/***/ "s/BL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReglementCarteIndex_vue__ = __webpack_require__("b3Hs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_900de6ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReglementCarteIndex_vue__ = __webpack_require__("QqlA");
function injectStyle (ssrContext) {
  __webpack_require__("KuKS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-900de6ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReglementCarteIndex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_900de6ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReglementCarteIndex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s2TK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"60%","persistent":"","overlay":true,"scrollable":""},model:{value:(_vm.dialogAjoutCarteTransfert),callback:function ($$v) {_vm.dialogAjoutCarteTransfert=$$v},expression:"dialogAjoutCarteTransfert"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v(" Effectuer un transfert ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formRecharge",attrs:{"id":"formRecharge","model":_vm.formRecharge,"rules":_vm.rules,"label-width":"120px"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Carte à crediter","prop":"carte"}},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"Selectionner une carte"},on:{"change":_vm.infoCarteCible},model:{value:(_vm.formRecharge.carteCibleId),callback:function ($$v) {_vm.$set(_vm.formRecharge, "carteCibleId", $$v)},expression:"formRecharge.carteCibleId"}},_vm._l((_vm.comboCarteCible),function(item){return _c('el-option',{key:item.carteId,attrs:{"label":item.identifiant,"value":item.carteId}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-1",attrs:{"xs1":""}},[_c('el-popover',{attrs:{"placement":"top-end","width":"350","trigger":"hover","title":"Info carte"}},[_c('el-table',{attrs:{"data":_vm.dataCarteCible}},[_c('el-table-column',{attrs:{"width":"200","property":"responsable","label":"Responsable"}}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"150","property":"solde","label":"solde(Fcfa)"}})],1),_vm._v(" "),_c('el-button',{attrs:{"slot":"reference","type":"text","icon":"el-icon-info"},slot:"reference"})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"ml-1",attrs:{"xs6":""}},[_c('el-form-item',{attrs:{"label":"Montant","prop":"montant"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":0,"name":"montant","placeholder":"saisir un montant"},model:{value:(_vm.formRecharge.montant),callback:function ($$v) {_vm.$set(_vm.formRecharge, "montant", $$v)},expression:"formRecharge.montant"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"ml-1",attrs:{"xs12":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"description"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","row":25,"name":"description","placeholder":"description"},model:{value:(_vm.formRecharge.description),callback:function ($$v) {_vm.$set(_vm.formRecharge, "description", $$v)},expression:"formRecharge.description"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){return _vm.resetForm('formRecharge')}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitForm('formRecharge')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s7lN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListeTravaux_vue__ = __webpack_require__("tJl8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06c2a5c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListeTravaux_vue__ = __webpack_require__("TU/U");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListeTravaux_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06c2a5c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListeTravaux_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sAkm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sCrI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":true,"fullscreen":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogContrat),callback:function ($$v) {_vm.dialogContrat=$$v},expression:"dialogContrat"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("FICHE DU PRESTATAIRE/OUVRIER "+_vm._s(_vm.libPrestataire)+"\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{staticClass:"mb-5 mt-2 elevation-3 pt-4 pl-2 pr-2 pb-4",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-left mr-3 ",attrs:{"xs1":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"140px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.infoPrestataire.url,"alt":"avatar"}})])],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-2 ml-2",attrs:{"xs7":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{attrs:{"mt-2":""}},[_vm._v("INFORMATION PERSONNELLE")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Nom")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                            "+_vm._s(_vm.infoPrestataire.nom)+"\n                          ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Domicile/Siege")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                            "+_vm._s(_vm.infoPrestataire.domicile)+"\n                          ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Contact")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                            "+_vm._s(_vm.infoPrestataire.contact)+"\n                          ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Profession")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                            "+_vm._s(_vm.infoPrestataire.profession)+"\n                          ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Type pièce")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                        "+_vm._s(_vm.infoPrestataire.piece)+"\n                      ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Numéro ID")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                        "+_vm._s(_vm.infoPrestataire.numPiece)+"\n                      ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de naissance")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                        "+_vm._s(_vm.infoPrestataire.dateNaiss)+"\n                      ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_vm._v("Enregistré le")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs8":""}},[_vm._v("\n                        "+_vm._s(_vm.infoPrestataire.created)+"\n                      ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center ml-3 ",attrs:{"xs5":""}},[_c('div',{staticClass:"elevation-3",staticStyle:{"width":"100%","height":"300px"},attrs:{"id":"statMontVerse"}})])],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{staticStyle:{"width":"100%"},attrs:{"xs12":""}},[_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTE DES CONTRATS")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-1",attrs:{"xs12":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"primary darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total : ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" \n                      "+_vm._s(new Intl.NumberFormat().format(_vm.montantTotal))+"\n                    ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1",attrs:{"xs12":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total payé: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" \n                      "+_vm._s(new Intl.NumberFormat().format(_vm.montantTotalVerse))+"\n                    ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1",attrs:{"xs12":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total restant: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" \n                      "+_vm._s(new Intl.NumberFormat().format(_vm.montantTotalRestant))+"\n                    ")])])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"elevation-3 pt-3 pl-3 pr-3 pb-3",attrs:{"xs12":""}},[_c('h4',[_vm._v("PRESTATION TACHES")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"data":_vm.listeContratsTache}},[_c('el-table-column',{attrs:{"prop":"idContrat","label":"ID-CONTRAT","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etatContrat","label":"ETAT CONTRAT","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 0)?_c('el-tag',{staticClass:"subheading",attrs:{"type":"info"}},[_vm._v("\n                        "+_vm._s(scope.row.etatContrat)+"\n                      ")]):_vm._e(),_vm._v(" "),(scope.row.etat == 1)?_c('el-tag',{staticClass:"subheading"},[_vm._v("\n                        "+_vm._s(scope.row.etatContrat)+"\n                      ")]):_vm._e(),_vm._v(" "),(scope.row.etat == 2)?_c('el-tag',{staticClass:"subheading",attrs:{"type":"blue"}},[_vm._v("\n                        "+_vm._s(scope.row.etatContrat)+"\n                      ")]):_vm._e(),_vm._v(" "),(scope.row.etat == 3)?_c('el-tag',{staticClass:"subheading",attrs:{"type":"success"}},[_vm._v("\n                        "+_vm._s(scope.row.etatContrat)+"\n                      ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tache","label":"TACHE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateDbtFin","label":"PERIODE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dureePresence","label":"PRESENCE(H)/EVOLUTION(%)","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantContrat","label":"MONTANT/OUVRIER(HRE)","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"info"}},[_vm._v("\n                        "+_vm._s(scope.row.montantContrat)+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantTotalFormat","label":"MONTANT TOTAL","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("\n                        "+_vm._s(scope.row.montantTotalFormat)+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntAverserContrat","label":"MONTANT A PAYER","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"success"}},[_vm._v("\n                        "+_vm._s(new Intl.NumberFormat().format(
                            scope.row.mntAverserContrat
                          ))+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntVerseFormat","label":"MONTANT PAYE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"success"}},[_vm._v("\n                        "+_vm._s(scope.row.mntVerseFormat)+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntRestantFormat","label":"MONTANT RESTANT","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"warning"}},[_vm._v("\n                        "+_vm._s(scope.row.mntRestantFormat)+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","disabled":scope.row.montantTotalFormat == 0 ||
                              scope.row.mntRestantFormat == 0,"fab":"","small":"","color":"green","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.showDialogPaiement(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("local_atm")])],1),_vm._v("\n                        Notifier un paiement\n                      ")],1)]}}])})],1)],1),_vm._v(" "),(_vm.type == 1)?_c('v-flex',{staticClass:"elevation-3 mt-4 pt-3 pl-3 pr-3 pb-3",attrs:{"xs12":""}},[_c('h4',[_vm._v("PRESTATION TRAVAUX/CHANTIERS")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"data":_vm.listeContratsTravaux}},[_c('el-table-column',{attrs:{"prop":"idContrat","label":"ID-CONTRAT","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etatContrat","label":"ETAT CONTRAT","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 0)?_c('el-tag',{staticClass:"subheading",attrs:{"type":"info"}},[_vm._v("\n                        "+_vm._s(scope.row.etatContrat)+"\n                      ")]):_vm._e(),_vm._v(" "),(scope.row.etat == 1)?_c('el-tag',{staticClass:"subheading"},[_vm._v("\n                        "+_vm._s(scope.row.etatContrat)+"\n                      ")]):_vm._e(),_vm._v(" "),(scope.row.etat == 2)?_c('el-tag',{staticClass:"subheading",attrs:{"type":"blue"}},[_vm._v("\n                        "+_vm._s(scope.row.etatContrat)+"\n                      ")]):_vm._e(),_vm._v(" "),(scope.row.etat == 3)?_c('el-tag',{staticClass:"subheading",attrs:{"type":"success"}},[_vm._v("\n                        "+_vm._s(scope.row.etatContrat)+"\n                      ")]):_vm._e()]}}],null,false,716052849)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"TYPE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tache","label":"TRAVAUX/CHANTIER","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"EVOLUTION","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-progress-circular',{attrs:{"size":80,"width":15,"rotate":360,"value":scope.row.evolution,"color":"orange"}},[_vm._v("\n                        "+_vm._s(scope.row.evolutionNbr)+" %\n                      ")])]}}],null,false,232624802)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantContrat","label":"MONTANT CONTRAT","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("\n                        "+_vm._s(new Intl.NumberFormat().format(
                            scope.row.montantContrat
                          ))+"\n                      ")])]}}],null,false,2096053806)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntVerserContrat","label":"MONTANT PAYE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"success"}},[_vm._v("\n                        "+_vm._s(new Intl.NumberFormat().format(
                            scope.row.mntVerserContrat
                          ))+"\n                      ")])]}}],null,false,2141783912)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntAverserContrat","label":"MONTANT A PAYE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"warning"}},[_vm._v("\n                        "+_vm._s(new Intl.NumberFormat().format(
                            scope.row.mntAverserContrat
                          ))+"\n                      ")])]}}],null,false,1570628160)})],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"elevation-3  pt-3 pl-3 pr-3 pb-3",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{attrs:{"mt-2":""}},[_vm._v("HISTORIQUE DES PAIEMENTS")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","disabled":false,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimePaiementPDF()}},slot:"activator"},[_vm._v("\n                    Imprimer\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1):_vm._e(),_vm._v("Imprimer les paiements\n                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"data":_vm.listePaiements}},[_c('el-table-column',{attrs:{"prop":"idContrat","label":"ID-CONTRAT","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleFact","label":"FACTURE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleTrx","label":"TRAVAUX","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mnt","label":"MONTANT","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"info"}},[_vm._v("\n                        "+_vm._s(scope.row.mnt)+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"auteur","label":"AUTEUR","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"datePaiement","label":"DATE DE PAIEMENT","align":"center"}}),_vm._v(" "),(this.type == 0)?_c('el-table-column',{attrs:{"label":"Actions","width":"140","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerFacture(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1)]}}],null,false,13696410)}):_vm._e()],1)],1)],1)],1),_vm._v(" "),(_vm.type == 0)?_c('v-flex',{staticClass:"ml-4 elevation-3  pt-3 pl-3 pr-3 pb-3",attrs:{"xs6":""}},[_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTE DE PRESENCE")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tablePresence,"header-row-style":_vm.headerRowStyle,"highlight-current-row":"","summary-method":_vm.getSummExploitBudget,"show-summary":""}},[_c('el-table-column',{attrs:{"prop":"tache","label":"TRAVAUX/TACHE","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(scope.row.tache))]}}],null,false,1654169254)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"datePresence","label":"Date PRESENCE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"DUREE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntHeur","label":"MONTANT/HRE","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"info"}},[_vm._v("\n                        "+_vm._s(scope.row.mntHeur)+"\n                      ")])]}}],null,false,1339383483)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntJour","label":"TOTAL"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("\n                        "+_vm._s(scope.row.mntJour)+"\n                      ")])]}}],null,false,2147632393)})],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('br')],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"700","persistent":true},model:{value:(_vm.dialogPaiement),callback:function ($$v) {_vm.dialogPaiement=$$v},expression:"dialogPaiement"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Enregistrer un paiement. contrat-"+_vm._s(_vm.idContrat))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogPaiement = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formPaiement",staticClass:"demo-form-inline",attrs:{"label-position":"top","id":"formPaiement","model":_vm.formPaiement,"inline":true}},[_c('el-form-item',{staticStyle:{"width":"50%"},attrs:{"label":"Montant"}},[_c('el-input-number',{staticStyle:{"width":"80%"},attrs:{"min":5,"max":_vm.mntMaxRestant},model:{value:(_vm.formPaiement.montant),callback:function ($$v) {_vm.$set(_vm.formPaiement, "montant", $$v)},expression:"formPaiement.montant"}})],1),_vm._v(" "),_c('el-form-item',{staticStyle:{"width":"40%"},attrs:{"label":"Date de paiement","required":""}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","placeholder":"Choisir une date de paiement","format":"dd-MM-yyyy","value-format":"yyyy-MM-dd"},model:{value:(_vm.formPaiement.datePaiement),callback:function ($$v) {_vm.$set(_vm.formPaiement, "datePaiement", $$v)},expression:"formPaiement.datePaiement"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){return _vm.resetForm('formPaiement')}}},[_vm._v("\n            Annuler\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitFormPaiement('formPaiement')}}},[_vm._v("\n            Enregistrer\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sI9Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_validationDG_ModalValidationDmd__ = __webpack_require__("J/ex");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_validationDG_ModalValidationDmdFond__ = __webpack_require__("DUFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_validationDG_ModalValidationPost__ = __webpack_require__("JtZx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_validationDG_ModalValidationMiss__ = __webpack_require__("0ygq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_validationDG_ModalValidationFacture__ = __webpack_require__("N3SU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_validationDG_ModalValidationInterv__ = __webpack_require__("gpm2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_validationDG_ModalValidationAppro__ = __webpack_require__("iWoE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__facturePaiement__ = __webpack_require__("UgjE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_resourceHumaine_liste_demande__ = __webpack_require__("YSKP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Loading__ = __webpack_require__("NxGh");




var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        facturePaiement: __WEBPACK_IMPORTED_MODULE_10__facturePaiement__["a" /* default */],
        Loading: __WEBPACK_IMPORTED_MODULE_12__components_Loading__["a" /* default */], ModalValidationDmd: __WEBPACK_IMPORTED_MODULE_3__components_validationDG_ModalValidationDmd__["a" /* default */], ModalValidationMiss: __WEBPACK_IMPORTED_MODULE_6__components_validationDG_ModalValidationMiss__["a" /* default */], ModalValidationFacture: __WEBPACK_IMPORTED_MODULE_7__components_validationDG_ModalValidationFacture__["a" /* default */], ModalValidationInterv: __WEBPACK_IMPORTED_MODULE_8__components_validationDG_ModalValidationInterv__["a" /* default */], ModalValidationDmdFond: __WEBPACK_IMPORTED_MODULE_4__components_validationDG_ModalValidationDmdFond__["a" /* default */], ModalValidationPost: __WEBPACK_IMPORTED_MODULE_5__components_validationDG_ModalValidationPost__["a" /* default */], ModalValidationAppro: __WEBPACK_IMPORTED_MODULE_9__components_validationDG_ModalValidationAppro__["a" /* default */], listeDemande: __WEBPACK_IMPORTED_MODULE_11__components_resourceHumaine_liste_demande__["a" /* default */] },
    name: "app",
    data: function data() {
        var _ref;

        return _ref = {
            //data general
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            racourcis: [{ path: '/', text: 'Accueil', disabled: false }, { path: '/validationDmd', text: 'Dashboard des validations', disabled: true }],
            dialogValideSuivant: false,
            typeDmd: null,
            itemDmd: {},
            items: [],
            index: null,

            // stretch: false,
            //VALIDATION DES sDEMANDES
            listeDemandes: [],
            selectZoneDmd: '',
            oldListDemandes: [],
            legendeDmd: "LISTE DES DEMANDES DE MAINTENANCES A VALIDER",
            comboZoneDmd: [],
            mntTTCAValide: 0,
            demandeDetail: {},
            showModalDetailDmd: false,
            nbDmdMaint: 0,

            //VALIDATION MISSIONS
            legendeMiss: "LISTE DES DEMANDES DE MISSION A VALIDER",
            listeMissions: [],
            oldListMissions: [],
            selectMissDemd: "",
            listeDemandeurs: [],
            nbMiss: 0,
            mntTotalMissTTC: 0,
            detailMission: {},
            showModalDetailMiss: false,

            //VALIDATION FACTURE FOURNISSEUR
            legendeFour: "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER",
            nbFactFour: 0,
            listeFournisseurs: [],
            listeFacturesFour: [],
            oldListFacturesFour: [],
            selectFour: '',
            mntTotalFactTTC: 0,
            factureDetail: {},
            showModalDetailFact: false,

            //VALIDATION DES DEMANDES APPROVISIONNEMENTS
            legendeAppro: "LISTE DES DEMANDES APPROVISIONNEMENTS",
            mntTotalAppro: 0,
            listeDmdNoValidAppro: [],
            showModalDetailAppro: false,
            ApproDetail: {},
            nbAppro: 0,
            listBanque: [],
            listCaisse: [],

            //VALIDATION INTERVENTION
            legendeInterv: "LISTE DES REPARATIONS A VALIDER",
            mntTotalIntervTTC: 0,
            nbInterv: 0,
            selectInterv: '',
            listeDemdInterv: [],
            listeIntervention: [],
            oldListeIntervention: [],
            intervDetail: [],
            showModalIntervFact: false,

            //VALIDATION DENANDE DE FONDS
            legendeDmdFond: "LISTE DES DEMANDES DE FONDS A VALIDER",
            mntTotalDmdFondTTC: 0,
            nbDmdFond: 0,
            selectDmdFond: '',
            listeDemandeurFond: [],
            listeDmdFond: [],
            oldListeDemandeurFond: [],
            dmdFondDetail: [],
            showModalDetailDmdFond: false,
            onglet: "0",

            //VALIDATION DEMANDE CONGE
            listeDemandeurAbs: [],
            //VALIDATION COMMANDE
            legendeDmdCom: "LISTE DES BONS DE COMMANDES A VALIDER",
            mntTotalDmdComTTC: 0,
            nbDmdCom: 0,
            selectDmdCom: '',
            listeDemandeurCom: [],
            listeDmdCom: [],
            oldListeDemandeurCom: [],
            dmdComDetail: [],
            detailCommande: [],
            totalMontant: 0,
            totalComHT: [],
            totalComTVA: [],
            totalComRemise: [],
            showModalDetailDmdCom: false,
            commCourant: []
        }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'onglet', "0"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'listeProdNull', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'mntTotalCmd', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'listeProdNull', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'commandeDeriv', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'commandeDerivDeux', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'nbCommandeSug', 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'nbCommandeSugDeux', 0), _ref;
    },


    methods: (_methods = {
        SubmitValideSuivant: function SubmitValideSuivant() {
            switch (this.typeDmd) {
                case "maintenance":
                    this.dialogValideSuivant = false;
                    this.modalDetailDmd(this.itemDmd);
                    break;

                case "intervention":
                    this.dialogValideSuivant = false;
                    this.modalDetailInterv(this.itemDmd);
                    break;
                case "factureFour":
                    this.dialogValideSuivant = false;
                    this.modalDetailFour(this.itemDmd);
                    break;
                case "mission":
                    this.dialogValideSuivant = false;
                    this.modalDetailMissDemd(this.itemDmd);
                    break;
                case "bonCommandeInterne":
                    this.dialogValideSuivant = false;
                    this.modalDetailDmdCom(this.itemDmd);
                    break;

                case "demandeFond":
                    this.dialogValideSuivant = false;
                    this.modalDetailDmdFond(this.itemDmd);
                    break;
            }
        },
        CancelValideSuivant: function CancelValideSuivant() {
            switch (this.typeDmd) {
                case "maintenance":
                    this.dialogValideSuivant = false;
                    this.loadDemandeAvalider();
                    break;

                case "intervention":
                    this.dialogValideSuivant = false;
                    this.loadDmdIntervention();
                    break;
                case "factureFour":
                    this.dialogValideSuivant = false;
                    this.loadFacture();
                    break;
                case "mission":
                    this.dialogValideSuivant = false;
                    this.loadMissionsAvalider;
                    break;

                case "bonCommandeInterne":
                    this.dialogValideSuivant = false;
                    this.modalDetailDmdCom(this.itemDmd);
                    break;
                case "demandeFond":
                    this.dialogValideSuivant = false;
                    this.loadDmdFond();
                    break;
            }
        },
        showDialogDmdAfter: function showDialogDmdAfter(idDmd, type) {
            this.showModalDetailDmd = false;
            this.listeDemandes = this.listeDemandes.filter(function (elm) {
                return elm.idDemande != idDmd;
            });

            if (this.listeDemandes.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDemandes[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadDemandeAvalider();
            }
        },
        showDialogDmdFondAfter: function showDialogDmdFondAfter(idDmd, type) {
            this.showModalDetailDmdFond = false;
            this.listeDmdFond = this.listeDmdFond.filter(function (elm) {
                return elm.id != idDmd;
            });
            console.log('idDmd', idDmd, type);

            if (this.listeDmdFond.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDmdFond[0];
                    this.typeDmd = type;
                    console.log('hdhd', type);
                    this.dialogValideSuivant = true;
                } else {
                this.loadDmdFond();
            }
        },
        showDialogDmdComAfter: function showDialogDmdComAfter(idDmd, type) {
            this.showModalDetailDmdCom = false;
            this.listeDmdCom = this.listeDmdCom.filter(function (elm) {
                return elm.id != idDmd;
            });
            if (this.listeDmdCom.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDmdCom[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadDmdCom();
            }
        },
        showDialogFactAfter: function showDialogFactAfter(idDmd, type) {
            this.listCaisse = [];
            this.listBanque = [];
            this.showModalDetailFact = false;
            this.loadFacture();
            this.listeFacturesFour = this.listeFacturesFour.filter(function (elm) {
                return elm.idFact != idDmd;
            });

            if (this.listeFacturesFour.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeFacturesFour[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadFacture();
            }
        },
        showDialogMissAfter: function showDialogMissAfter(idDmd, type) {
            this.showModalDetailMiss = false;
            this.listeMissions = this.listeMissions.filter(function (elm) {
                return elm.IdUtil != idDmd;
            });

            if (this.listeMissions.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeMissions[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadMissionsAvalider();
            }
        },
        showDialogIntervAfter: function showDialogIntervAfter(idDmd, type) {
            this.showModalIntervFact = false;
            this.listeIntervention = this.listeIntervention.filter(function (elm) {
                return elm.intervId != idDmd;
            });

            if (this.listeIntervention.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeIntervention[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadDmdIntervention();
            }
        },
        showDialogComAfter: function showDialogComAfter(idDmd, type) {
            this.showModalDetailDmdCom = false;
            this.listeDmdCom;
            this.listeDmdCom = this.listeDmdCom.filter(function (elm) {
                return elm.intervId != idDmd;
            });

            if (this.listeDmdCom.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDmdCom[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                } else {
                this.loadDmdCom();
            }
        },


        //DEMANDE DE MAINTENANCE
        modalDetailDmd: function modalDetailDmd(item) {
            this.demandeDetail = item;
            this.showModalDetailDmd = true;
        },
        filtrerZoneDmd: function filtrerZoneDmd(idZone) {
            this.loadDmdParZone(idZone);
        },
        loadLieu: function loadLieu() {
            var _this = this;

            var url = this.domaine + 'validationDG/lieu';
            this.$http.get(url).then(function (response) {
                _this.comboZoneDmd = response.body.lieux;
            }, function (erreurRep) {});
        },
        loadDmdParZone: function loadDmdParZone(idZone) {
            this.legendeDmd = "LISTE DES DEMANDES DE MAINTENANCES A VALIDER FILTREES PAR ZONE";
            this.listeDemandes = this.oldListDemandes;
            this.listeDemandes = this.listeDemandes.filter(function (item) {
                return item.idZone == idZone;
            });
        },
        clearSelectDmdZone: function clearSelectDmdZone() {
            this.listeDemandes = this.oldListDemandes;
            this.legendeDmd = "LISTE DES DEMANDES DE MAINTENANCES A VALIDER";
        },
        loadDemandeAvalider: function loadDemandeAvalider() {
            var _this2 = this;

            this.loading = true;
            var url = this.domaine + 'validationDG/index/demandes';
            this.$http.get(url).then(function (response) {
                _this2.oldListDemandes = response.body.listeDemandes;
                _this2.listeDemandes = response.body.listeDemandes;
                _this2.mntTTCAValide = response.body.mntTTC;
                _this2.nbDmdMaint = response.body.nbMaint;
                _this2.loadLieu();
                _this2.loading = false;
            }, function (erreur) {
                _this2.loading = false;
                _this2.$message.error("Une erreur est survenue lors du chargement des demandes de maintenances'");
            });
        },


        //DEMANDE DE MISSION
        filtrerMissDemd: function filtrerMissDemd(idDemd) {
            this.loadMissionDemd(idDemd);
        },
        clearSelectMissDemd: function clearSelectMissDemd() {
            this.listeMissions = this.oldListMissions;
            this.legendeMiss = "LISTE DES DEMANDES DE MISSION A VALIDER";
        },
        loadMissionDemd: function loadMissionDemd(idDemd) {
            this.legendeMiss = "LISTE DES DEMANDES DE MISSION A VALIDER FILTREES PAR DEMANDEUR";
            this.listeMissions = this.oldListMissions;
            this.listeMissions = this.listeMissions.filter(function (item) {
                return item.idUserDemandeur == idDemd;
            });
        },
        loadMissionsAvalider: function loadMissionsAvalider() {
            var _this3 = this;

            var url = this.domaine + "validationDG/index/missions";
            this.$http.get(url).then(function (resp) {
                _this3.oldListMissions = resp.body.missions, _this3.listeMissions = resp.body.missions, _this3.nbMiss = resp.body.nbUtil, _this3.listeDemandeurs = resp.body.listeDemandeurs;
                _this3.mntTotalMissTTC = resp.body.mntTotalTTC;
            }, function (resp) {
                _this3.$message.error("erreur lors du chargement des missions.");
            });
        },
        modalDetailMissDemd: function modalDetailMissDemd(item) {
            this.detailMission = item;
            this.showModalDetailMiss = true;
        },


        //FACTURE FOURNISSEUR
        clearSelectFour: function clearSelectFour() {
            this.listeFacturesFour = this.oldListFacturesFour;
            this.legendeFour = "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER";
        },
        modalDetailFour: function modalDetailFour(item) {
            this.listBanque = [];
            this.listCaisse = [];
            if (item.listBanque.length == 0) {
                this.loadAllBanque();
            } else {
                this.listBanque = item.listBanque;
                this.listCaisse = item.listCaisse;
            }
            this.factureDetail = item;
            this.showModalDetailFact = true;
            this.showModalDetailFact = true;
            this.commandeDerivDeux = [];
            this.commandeDeriv = [];
            this.showDialogComparaison(item);
        },
        modalDetailDmdFond: function modalDetailDmdFond(item) {
            this.demandeDetail = item;
            this.showModalDetailDmdFond = true;
        },
        modalDetailDmdCom: function modalDetailDmdCom(ligne) {
            this.demandeDetail = ligne;
            this.showModalDetailDmdCom = true;
            this.commCourant = ligne;
            this.detailCommande = ligne;
            // this.showDialogComAfter(ligne, 'bonCommandeInterne')
        }
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'clearSelectFour', function clearSelectFour() {
        this.listeFacturesFour = this.oldListFacturesFour;
        this.legendeFour = "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER";
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'showDialogComparaison', function showDialogComparaison(item) {
        var _this4 = this;

        // this.loading = true;
        var smsAficher = "Aucune tarification de ce produit est indiqué chez vous fournisseurs ";
        var mesProdPrixNulle = "Les produits de cette commande ne se trouvent chez aucun autres de vos fournisseurs ";

        var formdata = new FormData();
        var url = this.domaine + "comparateur/new/commande";
        var options = [];
        var listProdPrixNulle = [];

        for (var prop in item.option) {
            var ligne = item.option[prop];
            options.push(ligne.id);
        }
        formdata.append("options", options);
        formdata.append("facture", 1);
        formdata.append("typeOption", 2); //optionBesoin

        this.$http.post(url, formdata).then(function (response) {
            //affichage des messages
            var nbCmd = 0;
            var nbCmdDeux = 0;
            var listeFoun = [];
            var listeNull = [];
            var listeFounSecond = [];

            var respFour = response.body.fournisseurs[0];
            _this4.mntTotalCmd = response.body.mntTotauxFormat;
            _this4.listeProdNull = response.body.listeProdNull;

            _this4.loading = false;
            for (var four in respFour) {
                var listeProduit = respFour[four];
                var infoFour = {
                    fournisseur: four,
                    produits: [],
                    mntTotal: 0,
                    mntTotalHt: 0

                };
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(listeProduit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var produit = _step.value;

                        infoFour.produits.push(produit);
                        infoFour.mntTotal += parseFloat(produit.mntTotal);
                        infoFour.mntTotalHt += parseFloat(produit.mntTotalHt);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                if (infoFour.produits.length == options.length) {
                    nbCmd++;
                    listeFoun.push(infoFour);
                } else {
                    nbCmdDeux++;

                    listeFounSecond.push(infoFour);
                }
            }
            _this4.nbCommandeSug = nbCmd;
            _this4.commandeDeriv = listeFoun;
            _this4.nbCommandeSugDeux = nbCmdDeux;
            _this4.commandeDerivDeux = listeFounSecond;
            // this.dialogDetailCmd = true;
            _this4.loading = false;
            //AFFICHAGE DE PRODUITS DONT LE MONTANT EST NULL
            if (response.body.listeProdNull.length > 0) {
                // this.dialogProdNull = true;
                //this.closeProdNull();
            }

            if (listeFoun.length > 0) {
                _this4.showModalCompCmd = true;
            }
            // }
        }, function (error) {
            _this4.loading = false;
            _this4.$message.error("Erreur serveur");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'filtrerFour', function filtrerFour() {
        var _this5 = this;

        // this.loadFactParFour(this.selectFour)
        var tab = this.listeFournisseurs;
        var newTab = [];
        this.listeFournisseurs = tab.filter(function (item) {
            if (item.value == _this5.selectFour) {
                newTab.push(item);
            }
            return newTab;
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'modalDetailAppro', function modalDetailAppro(item) {
        this.ApproDetail = item;
        this.showModalDetailAppro = true;
        this.loadListBanque(item.caisseId);
        this.loadListCaisse(item.caisseId);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadListBanque', function loadListBanque(item) {
        var _this6 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/tresor/' + item + '/banque';
        this.$http.get(url).then(function (response) {
            _this6.listBanque = response.body.listBanque;
            _this6.loading = false;
        }, function (errResp) {
            _this6.loading = false;
            _this6.$message.error("Une erreur est survenue lors du chargement de la liste banque");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadListCaisse', function loadListCaisse(item) {
        var _this7 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/tresor/' + item + '/caisse';
        this.$http.get(url).then(function (response) {
            _this7.listCaisse = response.body.listCaisse;
            _this7.loading = false;
        }, function (errResp) {
            _this7.loading = false;
            _this7.$message.error("Une erreur est survenue lors du chargement de la liste caisse");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadAllBanque', function loadAllBanque() {
        var _this8 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/tresor/banque';
        this.$http.get(url).then(function (response) {
            _this8.listBanque = response.body.listBanque;
            _this8.listCaisse = response.body.listCaisse;
            _this8.loading = false;
        }, function (errResp) {
            _this8.loading = false;
            _this8.$message.error("Une erreur est survenue lors du chargement de la liste banque");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadAllCaisse', function loadAllCaisse() {
        var _this9 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/tresor/caisse';
        this.$http.get(url).then(function (response) {
            _this9.listCaisse = response.body.listCaisse;
            _this9.loading = false;
        }, function (errResp) {
            _this9.loading = false;
            _this9.$message.error("Une erreur est survenue lors du chargement de la liste caisse");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadFactParFour', function loadFactParFour(idFour) {
        this.legendeFour = "LISTE DES DEVIS / FACTURES A VALIDER FILTREES PAR FOURNISSEUR";
        this.listeFacturesFour = this.oldListFacturesFour;
        this.listeFacturesFour = this.listeFacturesFour.filter(function (item) {
            return item.idUserDemandeur == idFour;
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadFacture', function loadFacture() {
        var _this10 = this;

        this.loading = true;
        var url = this.domaine + 'validationDG/fournisseur/facture';
        this.$http.get(url).then(function (response) {
            _this10.listeFournisseurs = response.body.listeFour;
            _this10.mntTotalFactTTC = response.body.totalFacture;
            _this10.nbFactFour = response.body.nbFact;
            _this10.listeFacturesFour = response.body.facture;
            _this10.oldListFacturesFour = response.body.facture;
            _this10.loading = false;
        }, function (resp) {
            _this10.$message.error("erreur lors du chargement des devis / factures fournisseurs.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'modalDetailInterv', function modalDetailInterv(item) {
        this.intervDetail = item;
        this.showModalIntervFact = true;
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'clearSelectInterv', function clearSelectInterv() {
        this.listeIntervention = this.oldListeIntervention;
        this.legendeInterv = "LISTE DES REPARATIONS A VALIDER";
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'filtrerInterv', function filtrerInterv(idDemandeur) {
        this.loadDmdParInterv(idDemandeur);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdParInterv', function loadDmdParInterv(idDemandeur) {
        this.legendeInterv = "LISTE DES REPARATIONS A VALIDER FILTREES PAR DEMANDEUR";
        this.listeIntervention = this.oldListeIntervention;
        this.listeIntervention = this.oldListeIntervention.filter(function (item) {
            return item.idDemandeur == idDemandeur;
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdIntervention', function loadDmdIntervention() {
        var _this11 = this;

        this.loading = true;
        var url = this.domaine + 'validationDG/intervention/facture';
        this.$http.get(url).then(function (response) {
            _this11.listeIntervention = response.body.listeInterv;
            _this11.oldListeIntervention = response.body.listeInterv;
            _this11.mntTotalIntervTTC = response.body.mntTotal;
            _this11.nbInterv = response.body.nbInterv;
            _this11.listeDemdInterv = response.body.listeDemdInterv;
            _this11.loading = false;
        }, function (resp) {
            _this11.$message.error("erreur lors du chargement des demandes reparations.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'filtrerDmdFond', function filtrerDmdFond(idDemd) {
        this.loadDmdFond(idDemd);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'filtrerDmdCom', function filtrerDmdCom(idDemd) {
        this.loadDmdFond(idDemd);
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdCom', function loadDmdCom() {
        var _this12 = this;

        this.loading = true;
        var url = this.domaine + "besoin/index/validation/post/recent";
        this.$http.get(url).then(function (response) {
            _this12.loading = false;
            _this12.nbDmdCom = 0;
            if (response.body) {
                var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(response.body.besoin);

                _this12.nbDmdCom = data.length;
                _this12.listeDmdCom = data;
                _this12.oldListeDmdCom = data;
            }
        }, function (resp) {
            _this12.loading = false;
            _this12.$message.error("erreur lors du chargement des demandes de fonds.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdFond', function loadDmdFond() {
        var _this13 = this;

        this.loading = true;
        var url = this.domaine + 'validationDG/dmdFond/liste';
        this.$http.get(url).then(function (response) {
            _this13.listeDmdFond = response.body.listeDmdFond;
            _this13.oldListeDmdFond = response.body.listeDmdFond;
            _this13.mntTotalDmdFondTTC = response.body.mntTotal;
            _this13.nbDmdFond = response.body.nbDmdFond;
            _this13.listeDemandeurFond = response.body.listeDemandeurFond;
            _this13.loading = false;
        }, function (resp) {
            _this13.loading = false;
            _this13.$message.error("erreur lors du chargement des demandes de fonds.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'loadDmdNoValidAppro', function loadDmdNoValidAppro() {
        var _this14 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/appro/no-valide-dg/all';
        this.$http.get(url).then(function (response) {
            _this14.listeDmdNoValidAppro = response.body.appro;
            _this14.mntTotalAppro = response.body.totDmdAppro;
            _this14.nbAppro = response.body.nbAppro;
            _this14.loading = false;
        }, function (resp) {
            _this14.$message.error("erreur lors du chargement des demandes approvisionnement.");
        });
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'handleTabClick', function handleTabClick(tab) {}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_methods, 'clearSelectDmd', function clearSelectDmd() {
        this.listeFacturesFour = this.oldListFacturesFour;
        this.legendeFour = "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER";
    }), _methods),

    mounted: function mounted() {
        // this.loadDemandeAvalider()
        // this.loadMissionsAvalider()
        this.loadFacture();
        // this.loadDmdIntervention()
        this.loadDmdFond();
        this.loadDmdCom();
        // this.loadDmdNoValidAppro()
    }
});

/***/ }),

/***/ "sUUh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__ = __webpack_require__("iSmP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dhtmlx_gantt__);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "gantt",
  props: {
    tasks: {
      type: Object,
      default: function _default() {
        return { data: [], links: [] };
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    gantt.config.fit_tasks = true;
    gantt.config.readonly = true;

    gantt.attachEvent("onTaskSelected", function (id) {
      var task = gantt.getTask(id);
      _this.$emit("task-selected", task);
    });

    gantt.config.scale_unit = "month";
    gantt.config.date_scale = "%F, %Y";

    //default columns definition
    gantt.config.columns = [{ name: "text", label: "Travaux", width: "*", tree: true }, { name: "start_date", label: "Date initiale", align: "center" }, { name: "duration", label: "Durée", align: "center" }];

    //langue
    gantt.locale = {
      date: {
        month_full: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
        month_short: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aôu", "Sep", "Oct", "Nov", "Déc"],
        day_full: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
        day_short: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"]
      },
      labels: {
        new_task: "Tâche neuve",
        icon_save: "Enregistrer",
        icon_cancel: "Annuler",
        icon_details: "Détails",
        icon_edit: "Modifier",
        icon_delete: "Effacer",
        confirm_closing: "", //Vos modifications seront perdus, êtes-vous sûr ?
        confirm_deleting: "L'événement sera effacé sans appel, êtes-vous sûr ?",

        section_description: "Description",
        section_time: "Période",
        section_type: "Type",

        /* grid columns */

        column_text: "Tâche neuve",
        column_start_date: "Date initiale",
        column_duration: "Durée",
        column_add: "",

        /* link confirmation */

        confirm_link_deleting: "seront supprimées",
        link_start: "(début)",
        link_end: "(fin)",

        type_task: "Task",
        type_project: "Project",
        type_milestone: "Milestone",

        minutes: "Minutes",
        hours: "Heures",
        days: "Jours",
        weeks: "Semaine",
        months: "Mois",
        years: "Années"
      }
    };

    gantt.init(this.$refs.gantt);
    gantt.clearAll();
    gantt.parse(this.$props.tasks);
  }
});

/***/ }),

/***/ "sVGo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_divers_loadTypeTaches_vue__ = __webpack_require__("F7Wq");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "formTypeTache",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */], LoadTypeTachesExcel: __WEBPACK_IMPORTED_MODULE_2__components_divers_loadTypeTaches_vue__["a" /* default */] },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    listeLotTache: {
      type: Array,
      default: new Array()
    },
    idTypeTravaux: {
      type: Number,
      default: null
    },
    etatTache: {
      type: String,
      default: "aucun"
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      loading: false,
      dialogAjoutTache: false,
      listeTaches: [],
      formLotTache: {
        idTypeTache: null,
        ordre: "",
        libelle: "",
        unite: "",
        prix: 1,
        description: ""
      },
      rulesLotTache: {
        ordre: [{
          required: true,
          message: "Veuillez selectionnez un numéro d'ordre",
          trigger: "blur"
        }],
        libelle: [{
          required: true,
          message: "Veuillez  saisir un type de tache",
          trigger: "blur"
        }],
        unite: [{
          required: true,
          message: "Veuillez  saisir une unite",
          trigger: "blur"
        }],
        prix: [{
          required: true,
          message: "Veuillez  saisir un prix unitaire",
          trigger: "blur"
        }]
      },
      numOrdre: [],
      numOrdreCopie: [],
      listeTacheSupp: [],

      showModalLoadTypeTravaux: false,
      //Importer fichier excel
      fileExcel: [],
      lstTypeTravaux: []
    };
  },

  watch: {
    show: function show(newValue, oldValue) {
      var _this = this;

      if (newValue == true) {
        this.listeTaches.splice(0);
        this.numOrdre.splice(0);
        this.dialogAjoutTache = true;
        this.listeTacheSupp = [];
        this.numOrdre.push({ num: 1 });
        if (this.listeLotTache.length > 0) {
          this.numOrdre.splice(0);
          //rechechons lordre le plus eleve
          var ordreSup = null;
          this.listeLotTache.forEach(function (elt, ind) {
            if (ind + 1 < _this.listeLotTache.length) {
              var prochainOrdre = _this.listeLotTache[ind + 1].ordre;
              if (prochainOrdre > elt.ordre) {
                ordreSup = prochainOrdre;
              } else {
                ordreSup = elt.ordre;
              }
            }
          });
          this.listeTaches = this.listeLotTache.slice();

          this.numOrdreCopie.splice(0);
          var nbLots = this.listeLotTache.length;
          this.numOrdre.push({ num: ordreSup + 1 });

          if (this.listeTaches.length == 1) {
            this.numOrdre.push({ num: 2 });
          }

          for (var i = 0; i <= nbLots; i++) {
            this.numOrdreCopie.push({ num: i + 1 });
          }
        }
      } else {
        this.dialogAjoutTache = false;
        this.listeTacheSupp = [];
      }
    }
  },
  computed: {
    listeNumber: function listeNumber() {
      var _this2 = this;

      var listeNum = this.numOrdreCopie.slice();
      return listeNum.filter(function (elt) {
        if (elt.num <= _this2.listeTaches.length) {
          return elt;
        }
      });
    }
  },
  methods: {
    changeOrdre: function changeOrdre(value, ind) {},
    submitTache: function submitTache() {
      var _this3 = this;

      if (this.idTypeTravaux == null) {
        this.$message.error("Aucun type de projet selectionne");
        return;
      }
      this.loading = true;
      var url = this.domaine + "projet/new/tache/projet";
      //recuperer les uniquement les lots de travaux
      var nbData = 10;
      var nbReq = 1;
      var ligne = null;

      var nbRest = void 0;

      if (this.listeTaches.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.listeTaches.length / nbData);
        nbRest = this.listeTaches.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (var i = 0; i < nbReq; i++) {
        var initJ = i * nbData;
        var finJ = (i + 1) * nbData;
        var dataLot = [];
        if (this.listeTaches.length > 0) {
          for (var j = initJ; j < finJ; j++) {
            if (this.listeTaches[j] == undefined) {
              break;
            }
            dataLot.push(this.listeTaches[j]);
          }
        }
        var data = new FormData();
        // data.append('listeTypeTravaux', JSON.stringify(dataLot))
        for (var prop in dataLot) {
          ligne = dataLot[prop];
          data.append("option[ordre][]", ligne.ordre);
          data.append("option[libelle][]", ligne.libelle);
          data.append("option[unite][]", ligne.unite);
          data.append("option[valeur][]", ligne.prix);
          data.append("option[description][]", ligne.description);
        }

        data.append("idTypeTravaux", this.idTypeTravaux);
        data.append("listeSupp", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.listeTacheSupp));
        data.append("idUser", this.user.id);
        data.append("etatTache", this.etatTache);

        this.$http.post(url, data).then(function (response) {
          if (response.body.code == 2) {
            _this3.$notify({
              title: "Suppression travaux",
              duration: 5000,
              message: response.body.message,
              type: "warning"
            });
          } else {
            _this3.$notify({
              title: "ENREGISTREMENT REUSSI",
              message: "Tâches enregistrés avec succès.",
              type: "success",
              position: "top-center"
            });
          }
        }, function (error) {
          _this3.loading = false;
          _this3.$message.error("Erreur lors de l'enregistrement des tâches");
          succesEnreg = false;
          window.location.reload();
        });
      }
      this.loading = false;
      this.closeForm();
    },
    closeForm: function closeForm() {
      this.$emit("close");
      this.resetForm();
    },
    deleteRow: function deleteRow(index, rows) {
      var ordreIndex = this.listeTaches[index].ordre;
      var indexpos = this.numOrdre.findIndex(function (elt) {
        return elt.num > ordreIndex;
      });
      var indexposCopie = this.numOrdreCopie.findIndex(function (elt) {
        return elt.num == ordreIndex;
      });

      this.numOrdre.splice(indexpos, 0, { num: ordreIndex });
      this.numOrdreCopie.splice(indexposCopie, 1);

      //enregistrer lid du lot de travaux supprimer dans la liste
      if (this.listeTaches[index].idTypeTache != null) {
        this.listeTacheSupp.push(this.listeTaches[index].idTypeTache);
      }

      rows.splice(index, 1);
      if (this.listeTaches.length <= 0) {
        this.numOrdre.splice(0);
        this.numOrdreCopie.splice(0);

        this.numOrdre.push({ num: 1 });
        this.numOrdreCopie.push({ num: 1 });
      }
    },
    handleFileExcel: function handleFileExcel(command //0=>Importer,1=>generer
    ) {
      switch (command) {
        case "0":
          //importer un fichier
          this.$refs.fileInputExcel.click();
          break;
        case "1":
          //generer un modele un fichier
          this.generateFileExcel();
          break;
      }
    },
    generateFileExcel: function generateFileExcel() {
      var url = this.domaine + "projet/generer/modele/travaux/taches";
      window.open(url);
    },
    onFileExcelPicked: function onFileExcelPicked(event) {
      var _this4 = this;

      this.fileExcel.splice(0, 1);
      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this4.fileExcel.push(fileReader.result);
      });

      fileReader.readAsDataURL(files[0]);
      this.loading = true;

      var url = this.domaine + "tache/load_Travaux_tache/excel";
      var data = new FormData();
      //emvoie du fichier

      data.append("fichierExcel", files[0], files[0][name]);
      // this.closeForm();

      this.$http.post(url, data).then(function (resp) {
        _this4.loading = false;

        _this4.$notify({
          title: "Chargement liste type travaux",
          message: "Chargement effectué",
          type: "success",
          position: "top-right",
          duration: 7000
        });
        // this.lstTypeTravaux = resp.body.listeTypeTravaux;
        _this4.listeTaches = resp.body.listeTypeTravaux;
        // this.showModalLoadTypeTravaux = true;
      }, function (resp) {
        _this4.loading = false;
        _this4.$message.error("Erreur lors de l'importation du fichier");
      });
    },
    addListTypeTache: function addListTypeTache() {
      var _this5 = this;

      this.$refs["formLotTache"].validate(function (valid) {
        if (valid) {
          var lenListelot = _this5.listeTaches.length;
          var indiceInsert = _this5.formLotTache.ordre - 1;
          _this5.listeTaches.splice(indiceInsert, 0, {
            idTypeTache: _this5.formLotTache.idTypeTache,
            libelle: _this5.formLotTache.libelle,
            unite: _this5.formLotTache.unite,
            prix: _this5.formLotTache.prix,
            ordre: _this5.formLotTache.ordre,
            description: _this5.formLotTache.description
          });
          var index = _this5.numOrdre.findIndex(function (elt) {
            return elt.num == _this5.formLotTache.ordre;
          });
          var dernierChif = _this5.numOrdre[_this5.numOrdre.length - 1].num;

          _this5.numOrdre.splice(index, 1);

          _this5.numOrdre.push({ num: dernierChif + 1 });
          _this5.resetForm();
        }
      });
    },
    handleChangeLibelle: function handleChangeLibelle(newValue, oldValue) {
      if (newValue = "") {
        // this.$message({
        //     message: 'Ce champ ne peut etre vide',
        //     type: 'warning'
        // });
      }
    },
    resetForm: function resetForm() {
      this.$refs["formLotTache"].resetFields();
      this.formLotTache.libelle = "";
      this.formLotTache.unite = "";
      this.formLotTache.prix = 1;
      this.formLotTache.description = "";
      this.listeTacheSupp.splice(0);
    }
  }
});

/***/ }),

/***/ "sYTI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_rapport_AjoutReserve__ = __webpack_require__("v/m6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_boardChantier_RapportJournalier__ = __webpack_require__("uij/");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */], AjoutReserve: __WEBPACK_IMPORTED_MODULE_3__components_rapport_AjoutReserve__["a" /* default */], RapportJournalier: __WEBPACK_IMPORTED_MODULE_4__components_boardChantier_RapportJournalier__["a" /* default */] },
  name: "ListeRapportTrx",
  props: {
    show: {
      type: Boolean
    },
    typeInterface: {
      type: Boolean,
      default: true
    },
    rapportPerso: {
      type: Boolean,
      default: true
    },
    IddetailTravaux: {
      type: Number
    },
    type: {
      type: Number, //0=>chef travaux, 1=> chef chantier, 2=>chef projet
      default: 0
    },
    listeRapportTrx: {
      type: Array
    },
    libTrx: {
      type: String,
      default: null
    },
    commis: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      dialogSupr: false,
      inter: 'RAPPORT',
      IdRapport: "",
      dialogListeRapport: false,
      motifRejet: "",
      listeContraTravaux: [],
      dialogDetailRapport: false,
      dialogDetailGblobalRapport: false,
      detailRapport: {
        listeReserves: [],
        listeVisiteurs: [],
        incidents: [],
        listeMateriels: [],
        listeVehicules: [],
        listeExterneMateriels: [],
        listeRessourtechnik: []
      },
      disabledBtnReserve: true,
      multipleSelection: [],
      RapportTrx: [],
      items: [],
      index: null,
      dialogAccord: false,
      descriptionReserve: "",
      showRapport: false,
      editRapport: false,

      dialogValidNewRapport: false,
      listDatat: [],

      // VEHICULE
      totalQteCarb: 0,
      totTTCFormatDepen: 0,
      totalVehiHT: "",
      totalVehiHMinite: 0,

      // MATERIEL EXRTERNE
      MntToDepenExterne: 0,
      totalExterniHT: "",
      soustraitant: "",

      //OUVRIER
      totalOuvrHT: "",
      totTTCMtOuvreDepen: 0,
      totalOuvrHTMinute: 0,
      totalOuvrHTMinuteSup: 0,
      totalOuvrHTHrSup: 0,

      typeValidation: '',
      //FILTRE
      listeProjet: [],
      listeChantier: [],
      BesoinsList: [],
      projetS: "",
      chantierS: "",
      travauxS: "",
      dialogValidation: false,
      dialogRejeterMission: false,
      dialogValidRapport: false,
      dialogValidRapportGbloabl: false,

      //LISTE RAPPORTS
      dialogDetailListeRapport: false,
      listeTravaux: [],

      listeRapports: {
        listeTaches: [],
        listeReserves: [],
        listeVisiteurs: [],
        listeParticipants: [],
        listeMateriels: [],
        listeVehicules: [],
        incidents: [],
        listeExterneMateriels: [],
        listeRessourtechnik: []
      },
      formReserve: {
        images: []
      },
      fichierImage: [],
      idTacheSelect: null,
      tacheSelect: null,
      //RESERVE
      showAddReserve: false
    };
  },

  watch: {
    show: function show(newValue, oldvalue) {
      if (newValue == true) {
        this.typeInterface = false;
      }
      this.loadChantier();
      this.dialogListeRapport = newValue;
    },
    listeRapportTrx: function listeRapportTrx(newValue, oldvalue) {
      this.RapportTrx = this.listeRapportTrx;
      this.typeInterface = true;
    }
  },

  methods: {
    //FILTRE
    loadProjet: function loadProjet() {
      var _this = this;

      this.listeChantier.splice(0);
      this.chantierS = null;
      var url = this.domaine + "projet/index-projet-all";

      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this.loading = false;
        _this.listeProjet = response.body.projet;
      }, function (errRep) {
        _this.loading = false;
        _this.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    deleteJournal: function deleteJournal() {
      var _this2 = this;

      var url = this.domaine + "journal/delete/" + this.IdRapport.idRapport + '?inter=' + this.inter;
      this.$http.get(url).then(function (response) {
        if (response.body) {
          if (response.body.code === 1) {
            _this2.$notify({
              title: "SUPPRESSION",
              message: "Le rapport à été supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
            // this.emit('dialogListeRapport')
            _this2.dialogSupr = false;
            _this2.$emit("close");
          } else if (response.body.code === -2) {
            _this2.$notify.error({
              title: "SUPPRESSION IMPOSSIBLE",
              message: "Impossible de supprimer ce rapport.",
              position: "top-center"
            });
          } else {
            _this2.$notify.error({
              title: "SUPPRESSION ECHOUE",
              message: "La suppression de rapport à échoué.",
              position: "top-center"
            });
          }
        }
      });
    },
    showDiapo: function showDiapo(images, ind, image) {
      this.items = images;
      this.index = ind;
    },
    loadChantier: function loadChantier() {
      var _this3 = this;

      console.log("jrjr");
      if (this.projetS == null || this.projetS == "undefined" || this.projetS == "") {
        this.RapportTrx = this.listeRapportTrx;
        return;
      }
      this.loading = true;
      var url = this.domaine + "projet/" + this.projetS + "/index/chantier";
      this.$http.get(url).then(function (response) {
        _this3.loading = false;
        _this3.listeChantier = response.body.chantier;
      }, function (errRep) {
        _this3.loading = false;
        _this3.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    onTouch: function onTouch() {
      console.log('aldo');
      if (this.listeChantier.length > 0) {
        this.loadChantier();
      }
    },
    filtrerChantier: function filtrerChantier() {
      //this.oldListTravaux = this.listeTrx;
      var idChant = this.chantierS;
      this.RapportTrx = this.listeRapportTrx.filter(function (item) {
        return item.idChant == idChant;
      });
    },
    clearSelect: function clearSelect() {
      //this.listeTrx = this.oldListTravaux;
      this.projetS = "";
      this.chantierS = "";
      this.listeChantier.splice(0);
    },


    //RESERVE
    //reserve
    closeAjoutReserve: function closeAjoutReserve() {
      this.showAddReserve = false;
      this.loadDetailRapport(this.detailRapport);
    },
    closeListeRapport: function closeListeRapport() {
      this.dialogDetailListeRapport = false;
      this.totTTCFormatDepen = 0;
      this.totalQteCarb = 0;
      this.totalVehiHT = "";
      this.totalOuvrHT = "";
      this.totalOuvrHTHrSup = "";
      this.MntToDepenExterne = 0;
      this.totalExterniHT = 0;
    },
    showDialogReserve: function showDialogReserve(itemTache) {
      this.tacheSelect = itemTache;
      this.showAddReserve = true;
    },
    verifValideChefChant: function verifValideChefChant() {
      if (this.detailRapport.etatRapport == 0 && this.commis == false) {
        return true;
      } else {
        return false;
      }
    },
    verifValideChefProjet: function verifValideChefProjet() {
      if (this.type == 2 && (this.detailRapport.etatRapport == 1 || this.detailRapport.etatRapport == 0 && this.commis == false)) {
        return true;
      } else {
        return false;
      }
    },
    verifValideChefProjetGlobal: function verifValideChefProjetGlobal() {
      if (this.type == 2 && this.detailRapport.etatRapport == 0 && !this.commis) {
        return true;
      } else {
        return false;
      }
    },
    verifBoutReserve: function verifBoutReserve() {
      if (this.type == 1 && this.detailRapport.listeReserves.length == 0) {
        //chef chantier
        return this.verifValideChefChant();
      } else if (this.type == 2 && this.detailRapport.listeReserves.length == 0) {
        //chef projet
        return this.verifValideChefProjet();
      }
    },
    validerRapport: function validerRapport(etat) {
      var _this4 = this;

      this.loading = true;
      var url = "";
      if (this.type == 2) {
        url = this.domaine + "journal/respoprojet/valider/" + this.detailRapport.idRapport;
      } else if (this.type == 1) {
        url = this.domaine + "journal/respochantier/valider/" + this.detailRapport.idRapport;
      } else {
        return;
      }

      var data = new FormData();
      data.append("idUser", this.user.id);
      data.append("etat", etat);
      data.append("motif", this.motifRejet);
      data.append("typeValidation", this.typeValidation);

      this.$http.post(url, data).then(function (response) {
        _this4.dialogValidRapport = false;
        _this4.dialogDetailRapport = false;
        _this4.dialogDetailGblobalRapport = false;
        _this4.loading = false;
        if (etat == "REJETER") {
          _this4.$notify({
            title: "RAPPORT REJETE",
            message: "Rapport rejeter",
            type: "danger",
            position: "top-center",
            duration: 7000
          });
        } else {
          _this4.$notify({
            title: "VALIDATION RAPPORT",
            message: "Rapport validé",
            type: "success",
            position: "top-center",
            duration: 7000
          });
        }
        _this4.dialogValidation = false;
        _this4.dialogRejeterMission = false;
        _this4.motifRejet = '';
        _this4.$emit("reloadListeRapport");
      }, function (error) {
        _this4.loading = false;
        _this4.$message.error("Echec lors de la validation rapport");
      });
    },
    validerRapportGlobal: function validerRapportGlobal() {
      var _this5 = this;

      this.loading = true;
      var url = "";
      if (this.type == 2) {
        url = this.domaine + "journal/global/respoprojet/valider/" + this.detailRapport.idRapport;
      } else if (this.type == 1) {
        url = this.domaine + "journal/global/respochantier/valider/" + this.detailRapport.idRapport;
      } else {
        return;
      }

      var data = new FormData();
      data.append("idUser", this.user.id);
      data.append("typeValidation", this.typeValidation);

      this.$http.post(url, data).then(function (response) {
        _this5.dialogValidRapportGbloabl = false;
        _this5.dialogDetailRapport = false;
        _this5.dialogDetailGblobalRapport = false;
        _this5.loading = false;
        _this5.$notify({
          title: "VALIDATION DU RAPPORT GLOBAL",
          message: "Rapport validé",
          type: "success",
          position: "top-center",
          duration: 7000
        });
        _this5.$emit("reloadListeRapport");
      }, function (error) {
        _this5.loading = false;
        _this5.$message.error("Echec lors de la validation rapport");
      });
    },
    createReserve: function createReserve() {
      var _this6 = this;

      this.loading = true;
      var url = this.domaine + "reserve/new";
      var data = new FormData();
      //enregistrement des taches
      //data.append("tableTacheRapport", JSON.stringify(this.detailRapport.listeTaches) );

      data.append("idTache", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.idTacheSelect));

      data.append("description", this.descriptionReserve);
      data.append("idUser", this.user.id);
      data.append("idRapport", this.detailRapport.idRapport);
      if (this.fichierImage.length > 0) {
        this.fichierImage.forEach(function (file) {
          data.append("fichierImage[]", file, file[name]);
        }, this);
      }

      this.$http.post(url, data).then(function (resp) {
        _this6.loading = false;
        _this6.dialogAccord = false;
        _this6.$notify({
          title: "Reserve",
          message: "Reserve chantier enregistré",
          type: "success",
          position: "top-right",
          duration: 7000
        });

        _this6.loadDetailRapport(_this6.detailRapport);
        _this6.formReserve.images.splice(0);

        $this.$emit("reloadListeTrx");
        //this.dialogAccord = false
        //this.dialogRapport = false
      }, function (resp) {
        _this6.loading = false;
        _this6.$message.error("Erreur lors de l'enregistrement d'une reserve");
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.disabledBtnReserve = true;
      } else {
        this.disabledBtnReserve = false;
      }
    },
    loadDetailGlobalRapport: function loadDetailGlobalRapport(item) {
      var _this7 = this;

      this.loading = true;
      var url = this.domaine + "journal/global/" + item.idRapport;

      this.$http.get(url).then(function (response) {
        _this7.detailRapport = response.body.journal;
        _this7.soustraitant = response.body.journal.soustraiter;
        //information pour les vehicules
        _this7.totalQteCarb = response.body.journal.QteToCarbur;
        _this7.totTTCFormatDepen = response.body.journal.MntToDepen;
        _this7.totalVehiHT = response.body.journal.ToTalHeur;

        // information pour materiel externe
        _this7.MntToDepenExterne = response.body.journal.MntToDepenExterne;
        _this7.totalExterniHT = response.body.journal.ToTalHeurExterne;

        //information pour les ouvriers
        _this7.totalOuvrHT = response.body.journal.HeuOuvreToTl;
        _this7.totalOuvrHTHrSup = response.body.journal.HeuOuvreToTlHrSup;

        _this7.totTTCMtOuvreDepen = response.body.journal.MntOuvreToTl;

        _this7.typeValidation = 'global';
        _this7.dialogDetailGblobalRapport = true;
        _this7.loading = false;
      }, function (error) {
        _this7.loading = false;
        _this7.$message.error("Echec lors du chargement detail du Journal");
      });
    },
    loadDetailRapport: function loadDetailRapport(item) {
      var _this8 = this;

      this.loading = true;
      var url = this.domaine + "journal/" + item.idRapport;
      this.$http.get(url).then(function (response) {
        _this8.detailRapport = response.body.journal;

        _this8.soustraitant = response.body.journal.soustraiter;
        //information pour les vehicules
        _this8.totalQteCarb = response.body.journal.QteToCarbur;
        _this8.totTTCFormatDepen = response.body.journal.MntToDepen;
        _this8.totalVehiHT = response.body.journal.ToTalHeur;

        // information pour materiel externe
        _this8.MntToDepenExterne = response.body.journal.MntToDepenExterne;
        _this8.totalExterniHT = response.body.journal.ToTalHeurExterne;

        //information pour les ouvriers
        _this8.totalOuvrHT = response.body.journal.HeuOuvreToTl;
        _this8.totalOuvrHTHrSup = response.body.journal.HeuOuvreToTlHrSup;

        _this8.totTTCMtOuvreDepen = response.body.journal.MntOuvreToTl;
        _this8.typeValidation = 'seul';

        _this8.dialogDetailRapport = true;
        _this8.loading = false;
      }, function (error) {
        _this8.loading = false;
        _this8.$message.error("Echec lors du chargement detail du Journal");
      });
    },
    editRapportJour: function editRapportJour(item) {
      var _this9 = this;

      console.log('response', item);
      // this.loading = true;
      var url = this.domaine + 'journal/' + item.idRapport;
      this.$http.get(url).then(function (response) {
        _this9.showRapport = true;
        _this9.editRapport = true;
        _this9.loading = false;
        _this9.detailTravaux = response.body.journal;
        console.log('response ici', item);
        _this9.dateRapport = new Date(item.dateRprtN);
      }, function (error) {
        _this9.loading = false;
        _this9.$message.error("Echec lors du chargement formulaire en cours");
      });
    },
    rapportJour: function rapportJour(item) {
      var _this10 = this;

      this.dialogValidNewRapport = false;
      console.log('item', item);
      var url = this.domaine + "travaux/" + item.idTrx;
      this.$http.get(url).then(function (response) {
        _this10.detailTravaux = response.body.travaux;
        _this10.dateRapport = new Date(item.dateRprtN);
        _this10.showRapport = true;
        _this10.loading = false;
      }, function (error) {
        _this10.loading = false;
        _this10.$message.error("Echec lors du chargement formulaire en cours");
      });
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    loadListerapports: function loadListerapports() {
      var _this11 = this;

      //this.loading = true;
      this.listeRapports.listeTaches.splice(0);
      this.listeRapports.listeReserves.splice(0);
      this.listeRapports.listeVisiteurs.splice(0);
      this.listeRapports.listeParticipants.splice(0);
      this.listeRapports.listeMateriels.splice(0);
      this.listeRapports.listeVehicules.splice(0);
      this.listeRapports.listeRessourtechnik.splice(0);
      this.listeRapports.listeExterneMateriels.splice(0);
      this.listeRapports.incidents.splice(0);

      // this.totalVehiHT = ''
      // this.totalOuvrHT = ''
      this.totalOuvrHTMinute = 0, this.totalOuvrHTMinuteSup = 0, this.totalVehiHMinite = 0,
      // this.IddetailTravaux = this.projetS

      this.listeRapportTrx.forEach(function (item) {
        var url = _this11.domaine + "journal/" + item.idRapport;
        _this11.$http.get(url).then(function (response) {
          var _listeRapports$listeT, _listeRapports$listeR, _listeRapports$listeV, _listeRapports$listeP, _listeRapports$listeV2, _listeRapports$incide, _listeRapports$listeR2, _listeRapports$listeE;

          (_listeRapports$listeT = _this11.listeRapports.listeTaches).push.apply(_listeRapports$listeT, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.body.journal.listeTaches));
          (_listeRapports$listeR = _this11.listeRapports.listeReserves).push.apply(_listeRapports$listeR, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.body.journal.listeReserves));
          (_listeRapports$listeV = _this11.listeRapports.listeVisiteurs).push.apply(_listeRapports$listeV, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.body.journal.listeVisiteurs));
          (_listeRapports$listeP = _this11.listeRapports.listeParticipants).push.apply(_listeRapports$listeP, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.body.journal.listeParticipants));
          if (response.body.journal.listeMateriels) {
            var _listeRapports$listeM;

            (_listeRapports$listeM = _this11.listeRapports.listeMateriels).push.apply(_listeRapports$listeM, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.body.journal.listeMateriels));
          }
          (_listeRapports$listeV2 = _this11.listeRapports.listeVehicules).push.apply(_listeRapports$listeV2, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.body.journal.listeVehicules));
          (_listeRapports$incide = _this11.listeRapports.incidents).push.apply(_listeRapports$incide, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.body.journal.incidents));

          (_listeRapports$listeR2 = _this11.listeRapports.listeRessourtechnik).push.apply(_listeRapports$listeR2, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.body.journal.listeRessourtechnik));
          (_listeRapports$listeE = _this11.listeRapports.listeExterneMateriels).push.apply(_listeRapports$listeE, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(response.body.journal.listeMaterielsExtern));

          //information pour les vehicules
          _this11.totalQteCarb += response.body.journal.QteToCarbur, _this11.totTTCFormatDepen += response.body.journal.MntToDepen, _this11.totalVehiHMinite += response.body.journal.ToTalHeurMinute;

          _this11.typeInterface = true;
          //information pour les ouvriers
          _this11.totalOuvrHTMinute += response.body.journal.HeuOuvreToTlMinute, _this11.totalOuvrHTMinuteSup += response.body.journal.HeuOuvreToTlMinuteSup, _this11.totTTCMtOuvreDepen += response.body.journal.MntOuvreToTl;
        }, function (error) {
          _this11.loading = false;
          _this11.$message.error("Echec lors du chargement detail du Journal");
        });
      }, this);

      this.loading = false;
      this.dialogDetailListeRapport = true;
    },
    secondsToHms: function secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 60);
      var m = Math.floor(d % 60);
      var hDisplay = h > 0 ? h : "00";
      var mDisplay = m > 0 ? m : "00";
      return hDisplay + ":" + mDisplay;
    },
    onFileTachePicked: function onFileTachePicked(event) {
      var _this12 = this;

      this.formReserve.images.splice(0, 1);
      this.fichierImage.splice(0, 1);
      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this12.formReserve.images.push(fileReader.result);
      });

      fileReader.readAsDataURL(files[0]);

      this.fichierImage.push(files[0]);
    },
    onFileTachePicked2: function onFileTachePicked2(event) {
      var _this13 = this;

      this.formReserve.images.splice(1, 1);
      this.fichierImage.splice(1, 1);
      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this13.formReserve.images.push(fileReader.result);
      });

      fileReader.readAsDataURL(files[0]);
      this.fichierImage.push(files[0]);
    },
    loadRapportTrx: function loadRapportTrx() {
      var _this14 = this;

      console.log('this.detailTravaux ', this.detailTravaux);
      this.loading = true;
      var url = void 0;
      if (this.commis) {
        url = this.domaine + "journal/travaux/" + this.detailTravaux.idTrx + "?idUser=" + this.user.id;
      } else {
        url = this.domaine + "journal/travaux/" + this.detailTravaux.idTrx;
      }
      this.$http.get(url).then(function (response) {
        _this14.listeRapports = response.body.journaux;
        _this14.dialogListeRapport = true;
        _this14.type = 1;
        _this14.loading = false;
      }, function (error) {
        _this14.loading = false;
        _this14.$message.error("Echec lors du chargement des Journaux");
      });
    },

    //impression rapports
    imprimeJournalPDF: function imprimeJournalPDF(item) {
      var url = "";
      url = this.domaine + "journal/imprimerPDF/" + this.detailRapport.idRapport + "/" + this.user.id + "/" + item;
      window.open(url);
    },


    //impression de tous les rapports
    imprimeALLJournalPDF: function imprimeALLJournalPDF(format) {
      var url = this.domaine + "journal/imprimer_AllPDF/" + this.IddetailTravaux + "/" + format + "/" + this.user.id;
      window.open(url);
    }
  },

  mounted: function mounted() {
    // this.loadProjet();
    this.loadChantier();
    this.clearSelect();
  }
});

/***/ }),

/***/ "sd6U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticStyle:{"padding":"0px"}},[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('listeProjet',{attrs:{"listeProjets":_vm.projets}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sig4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"width":"90%","persistent":true,"transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogAjoutBudget),callback:function ($$v) {_vm.dialogAjoutBudget=$$v},expression:"dialogAjoutBudget"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v(" "+_vm._s(_vm.typeEtat ? 'Modifier le budget pour la tâche ': 'Planifier budget pour les travaux')+" "+_vm._s(_vm.typeTrx.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formBudget",staticClass:"demo-form-inline",attrs:{"id":"formBudget","model":_vm.formBudget,"rules":_vm.rulesBudget,"label-position":_vm.labelPosition}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[(!_vm.typeEtat)?_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"tache","label":"Tache","fil":"","required":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"valeurSelect","clearable":"","id":"valeurSelect","placeholder":"Sélectionner une tache"},on:{"change":function($event){return _vm.loadTypeBudeget()}},model:{value:(_vm.formBudget.tache),callback:function ($$v) {_vm.$set(_vm.formBudget, "tache", $$v)},expression:"formBudget.tache"}},_vm._l((_vm.listaches),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.typeEtat)?_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"tache","label":"Tache","required":"","filterable":""}},[_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.typeTrx.libelle,"disabled":""},model:{value:( _vm.typeTrx.libelle),callback:function ($$v) {_vm.$set(_vm.typeTrx, "libelle", $$v)},expression:" typeTrx.libelle"}})],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"tache","label":"Date de debut","required":""}},[(_vm.typeEtat)?_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.typeTrx.dateD,"disabled":""},model:{value:(_vm.typeTrx.dateD),callback:function ($$v) {_vm.$set(_vm.typeTrx, "dateD", $$v)},expression:"typeTrx.dateD"}}):_vm._e(),_vm._v(" "),(!_vm.typeEtat)?_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.tableDate.dateD,"disabled":""},model:{value:(_vm.tableDate.dateD),callback:function ($$v) {_vm.$set(_vm.tableDate, "dateD", $$v)},expression:"tableDate.dateD"}}):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"tache","label":"Date de fin","required":""}},[(_vm.typeEtat)?_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.typeTrx.dateF,"disabled":""},model:{value:(_vm.typeTrx.dateF),callback:function ($$v) {_vm.$set(_vm.typeTrx, "dateF", $$v)},expression:"typeTrx.dateF"}}):_vm._e(),_vm._v(" "),(!_vm.typeEtat)?_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"value":_vm.tableDate.dateF,"disabled":""},model:{value:(_vm.tableDate.dateF),callback:function ($$v) {_vm.$set(_vm.tableDate, "dateF", $$v)},expression:"tableDate.dateF"}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"ressource","label":"Type de ressource","required":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":""},on:{"change":function($event){return _vm.loadUniteProduit(_vm.formBudget.ressource)}},model:{value:(_vm.formBudget.ressource),callback:function ($$v) {_vm.$set(_vm.formBudget, "ressource", $$v)},expression:"formBudget.ressource"}},_vm._l((_vm.listeProduitAffich),function(item){return _c('el-option',{key:item.id,attrs:{"id":item.id,"label":item.value+' / '+item.type,"value":item}})}),1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"elevation-3",attrs:{"slot":"activator","dark":"","icon":"","flat":"","color":"primary"},on:{"click":function($event){return _vm.loadProduit()}},slot:"activator"},[_c('v-icon',[_vm._v("cached")])],1),_vm._v("\n                      actualiser la liste\n                  ")],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"valeurCodeAnalytique","label":"Code analytique","filterable":""}},[_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"type":"text","name":"valeurCodeAnalytique"},model:{value:(_vm.valeurCodeAnalytique),callback:function ($$v) {_vm.valeurCodeAnalytique=$$v},expression:"valeurCodeAnalytique"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"valeurCodeGestion","label":"Code gestion","filterable":""}},[_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"type":"text","name":"valeurCodeGestion"},model:{value:(_vm.valeurCodeGestion),callback:function ($$v) {_vm.valeurCodeGestion=$$v},expression:"valeurCodeGestion"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"unite","label":"Unité"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"valeurSelect","readonly":true},model:{value:(_vm.valeurUniteMateriel),callback:function ($$v) {_vm.valeurUniteMateriel=$$v},expression:"valeurUniteMateriel"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"qte","label":"Quantité ","required":""}},[_c('el-input-number',{staticStyle:{"font-size":"22px"},attrs:{"controls-position":"right","min":0},on:{"change":function($event){return _vm.calculMontant(_vm.formBudget)}},model:{value:(_vm.formBudget.qte),callback:function ($$v) {_vm.$set(_vm.formBudget, "qte", $$v)},expression:"formBudget.qte"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"prix","label":"Prix unitaire ","required":""}},[_c('el-input-number',{staticStyle:{"font-size":"22px"},attrs:{"controls-position":"right","min":0},on:{"change":function($event){return _vm.calculMontant(_vm.formBudget)}},model:{value:(_vm.formBudget.prix),callback:function ($$v) {_vm.$set(_vm.formBudget, "prix", $$v)},expression:"formBudget.prix"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"prop":"total","label":"Montant total"}},[_c('el-input',{staticStyle:{"font-size":"22px"},attrs:{"type":"text","name":"montantTotal","readonly":true},model:{value:(_vm.montantTotal),callback:function ($$v) {_vm.montantTotal=$$v},expression:"montantTotal"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"action"}},[_c('el-button',{attrs:{"type":"primary","disabled":!_vm.verifFormBudget},on:{"click":function($event){return _vm.addListBudget(_vm.formBudget)}}},[_vm._v("Ajouter")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('input',{ref:"fileInputExcel",staticStyle:{"display":"none"},attrs:{"name":"fileInputExcel","type":"file","accept":"image/*"},on:{"change":_vm.onFileExcelPicked}}),_vm._v(" "),(true)?_c('v-btn',{attrs:{"slot":"activator","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$refs.fileInputExcel.click()}},slot:"activator"},[_vm._v("\n                    Importer\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_download")])],1):_vm._e(),_vm._v("Importer fichier excel\n                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogImport = true}},slot:"activator"},[_vm._v("\n                    Générer\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1):_vm._e(),_vm._v("Générer un modèle\n                ")],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.typeEtat)?_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableBudget}},[_c('el-table-column',{attrs:{"prop":"ressource","label":"Type de ressource","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"codeAnalytique","label":"Code analytique","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"codeGestion","label":"Code de gestion","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix Unitaire","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Montant total"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(new Intl.NumberFormat().format(
                            scope.row.montant
                          ))+"\n                      ")]}}],null,false,3786492830)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableBudget)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                          Supprimer\n                        ")],1)]}}],null,false,376747069)})],1):_vm._e(),_vm._v(" "),(!_vm.typeEtat)?_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableBudget}},[_c('el-table-column',{attrs:{"prop":"ressource","label":"Type de ressource","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"codeAnalytique","label":"Code analytique","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"codeGestion","label":"Code de gestion","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix Unitaire","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Montant total"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(new Intl.NumberFormat().format(
                            scope.row.montant
                          ))+"\n                      ")]}}],null,false,3786492830)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableBudget)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                          Supprimer\n                        ")],1)]}}],null,false,376747069)})],1):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("Annuler")]),_vm._v(" "),(_vm.formBudget.tache != '')?_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.createBudget()}}},[_vm._v("Enregistrer")]):_vm._e(),_vm._v(" "),(_vm.typeEtat)?_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){return _vm.createBudget()}}},[_vm._v("Enregistrer")]):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('LoadTypeBudgetExcel',{attrs:{"show":_vm.showModalLoadBudget,"idChantier":_vm.idChant,"typeTrx":this.typeTrx.id,"listeTypeTravaux":_vm.lstBudget},on:{"close":function($event){_vm.showModalLoadBudget = false;
      _vm.loadListeTravaux();
      _vm.closeDialog();}}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogImport),callback:function ($$v) {_vm.dialogImport=$$v},expression:"dialogImport"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h4',{attrs:{"align":"center"}},[_vm._v("Nb: Le fichier contient uniquement les ressources qui figurent dans votre base de produit.")]),_vm._v(" "),_c('h4',{attrs:{"align":"center"}},[_vm._v("Indiquer uniquement la QUANTITE et le PRIX UNITAIRE de chaque ligne de produit que vous souhaitez ajouter pour élaborer votre budget.")]),_vm._v(" "),_c('h3',{attrs:{"align":"center"}},[_vm._v("Supprimer ensuite les lignes restantes dans votre fichier avant importation.")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogImport = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.generateFileExcel()}}},[_vm._v("Généner "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "skxa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tresorerie_ModalBanque__ = __webpack_require__("Y3jT");


var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var echarts = __webpack_require__("Icdr");
__webpack_require__("GbHy");
__webpack_require__("N1UU");
__webpack_require__("5/bM");
__webpack_require__("cWq4");
__webpack_require__("u9yV");
__webpack_require__("Vb+l");
__webpack_require__("Oq2I");
__webpack_require__("miEh");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */], ModalBanque: __WEBPACK_IMPORTED_MODULE_2__components_Tresorerie_ModalBanque__["a" /* default */] },
    name: 'app',
    data: function data() {
        var _ref;

        return _ref = {
            loading: false,
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            headers: [{ text: 'Désignation', align: 'center', sortable: true, value: '' }, { text: 'Gérant', align: 'center', sortable: true, value: '' }, { text: "Etat", align: 'center', sortable: true, value: '' }, { text: "Solde", align: 'center', sortable: true, value: '' }, { text: 'Actions', align: 'center', value: '' }],
            items: [{ value: false, designation: '', gerant: '', etat: '', solde: '', action: '' }],
            racourcis: [{ path: '/', text: 'Accueil', disabled: false }, { path: '/entepot', text: 'Liste des caisses', disabled: true }],
            search: '',
            formRech: {
                recherche: ''
            },
            approForm: {
                motif: '',
                montant: ''
            },
            transFertForm: {
                montantTransf: '',
                libelleTransfert: '',
                caisseSelect: ''
            },
            retourForm: {
                motif: '',
                montant: ''
            },
            rulesRetour: {
                commentaire: [{ required: true, message: 'Veuillez saisir le commentaire', trigger: 'blur' }],
                montant: [{ required: true, message: 'Veuillez saisir le montant', trigger: 'blur' }]
            },
            rulesAppro: {
                motif: [{ required: true, message: 'Veuillez saisir le motif', trigger: 'blur' }],
                montant: [{ required: true, message: 'Veuillez saisir le montant', trigger: 'blur' }]
            },
            rulesTransfer: {
                caisse: [{ required: true, message: 'Veuillez selectionner une caisse', trigger: 'blur' }],
                motif: [{ required: true, message: 'Veuillez saisir le motif', trigger: 'blur' }],
                montant: [{ required: true, message: 'Veuillez saisir le montant', trigger: 'blur' }]
            },
            pieceJusti: '',
            dialogAjout: false,
            dialogAjoutReglement: false,
            dialogAjoutAppro: false,
            dialogAjoutTrans: false,
            dialogAjoutValideAppro: false,
            dialogEditReglement: false,
            dialogEdit: false,
            showButtonPiece: false,
            dialogShow: false,
            totalretour: 0,

            dialogAjoutDepense: false,
            nature: '',

            dialogShowReglement: false,
            dialogShowPiece: false,
            optionPaiement: '',
            dialogShowAppro: false,
            dialogRetour: false,
            dialogLoadReglement: false,
            dialogSupr: false,
            validPaiem: false,
            validTransfert: false,
            validRetour: false,
            dialogSuprAppro: false,
            dialogModalBanque: false,
            valid: true,
            users: [],
            selectAdmin: "",
            seuilMax: 5,
            fileLogo: '',
            seuilMin: 5,
            categorie: "",
            soldeInitial: 0,
            numCompte: 'O',
            libelle: '',
            activer: false,
            idCaisse: '',
            listCaisse: [],
            listCaisseTransfert: [],
            oldListCaisses: [],
            selectCaisseDmd: '',
            tableOpera: [],
            statBanque: [],
            caisseCourant: [],
            detailCaisse: [],
            detailCaisseS: [],
            libelleCaisse: '',
            dateFacture: "",
            dateOperation: "",
            montant: '',
            demandeur: '',
            selectEtatDepense: '',
            etatDepense: '',
            listDepense: [],
            selectTresor: [],
            selectTypes: [],
            listAllDepense: [],
            dialogDepense: false,
            motif: '',

            //critere de recherche
            formTri: {
                periode: ''
            },
            dateFactureRules: [function (v) {
                return !!v || "Veuillez renseigner les intervalles de date";
            }],
            dateOperationRules: [function (v) {
                return !!v || "Veuillez renseigner les intervalles de date";
            }],
            selectTypeFacture: "",
            typeFacture: [{ text: 'Par date de création', value: 1 }, { text: 'Par période', value: 2 }],
            selectEtatFacture: "",
            etatFacture: [{ text: 'Impayé', value: 0 }, { text: 'Soldé', value: 1 }, { text: 'En attente de paiement', value: 2 }, { text: 'En cours de paiement', value: 3 }],
            listFournisseur: [],
            listProjet: [],
            listClient: [],
            selectFournisseur: "",
            selectProjet: "",
            selectClient: "",
            listFacture: [],
            totalFacture: 0,
            totalFacture1: 0,
            payeFacture: 0,
            payeFacture1: 0,
            impayeFacture: 0,
            impayeFacture1: 0,
            factureCourant: [],
            listReglement: [],
            montantVerse: 5,
            remettant: '',
            banque: '',
            reference: '',
            selectEncaisse: '',
            encaisse: [{ text: 'OUI', value: 1 }, { text: 'NON', value: 2 }],
            selectEffectue: "",
            effectue: [{ text: 'Lui même', value: 1 }, { text: 'Autre', value: 2 }],
            selectMode: '',
            mode: [{ text: 'Espèce', value: 1 }],
            modeBanque: [
            //{ text: 'Espèce', value: 1 },
            { text: 'Chèque', value: 2 }],
            reglementCourant: [],
            detailReglement: [],
            montantSortie: 0,
            montantEntree: 0,
            totalEntree: 0,
            totalSortie: 0,
            montantTvaEntree: 0,
            montantTvaSortie: 0,
            montantAppro: 5,
            libelleAppro: '',
            libelleTransfert: '',
            remarqueAppro: '',
            selectValidateurAppro: '',
            approCourant: [],
            listApproCaisse: []
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'pieceJusti', "/static/img-doc.png"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'listApproDgCheq', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'selectReponseAppro', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'reponseAppro', [{ text: 'Autorisé', value: 1 }, { text: 'Réfusé', value: 2 }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'detailAppro', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'detailRetour', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'soldeCaisse', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'statAllCaisse', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'statCaisse', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'statCaisse1', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'statCaisse2', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'listResulat', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'showRecherche', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'typeF', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'idAppro', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'selectTresorerie', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'listeTypeF', [{ label: 'FOURNISSEUR/PRESTATAIRE', value: 1 }, { label: 'MISSION', value: 2 }, { label: 'INTERVENTION', value: 3 }, { label: 'DECAISSEMENT', value: 4 }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'typeTresorerie', [{ text: 'CAISSE', value: 'Caisse' }, { text: 'BANQUE', value: 'Banque' }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'categorieCaisse', [{ text: 'Projet', value: "Projet" }, { text: 'Bureau', value: 'Bureau' }, { text: 'Maintenance', value: 'Maintenance' }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'listOperation', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'dateDbt', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'dateFin', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'disabledBtn', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'typeRech', "fournisseur"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'selectDemandeur', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'listeDemandeur', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'readInput', false), _ref;
    },

    computed: {},
    methods: (_methods = {
        getSumm: function getSumm(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = "Total";
                    return;
                }

                if (index === 4) {
                    sums[index] = "N/A";
                    return;
                }
                var values = data.map(function (item) {
                    return Number(item[column.property]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0));
                } else {
                    sums[index] = "N/A";
                }
            });

            return sums;
        },
        handleCommand: function handleCommand(command) {
            this.loadOperation(this.caisseCourant);
        },
        headerRowStyle: function headerRowStyle(_ref2) {
            var row = _ref2.row,
                rowIndex = _ref2.rowIndex;

            return { "color": "black" };
        },
        handleClick: function handleClick() {
            this.loadSearchOperation(this.caisseCourant);
        },
        loadPage: function loadPage() {
            this.loading = true;
        },
        loadUser: function loadUser() {
            var _this = this;

            this.loading = true;
            var url = this.domaine + 'userCreate/user-list';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this.users = response.body;
                    _this.loading = false;
                }
            });
        },
        rechercheFacture: function rechercheFacture() {
            var _this2 = this;

            if (this.formTri.caisse == '' && this.formTri.type == '') {
                this.$notify({
                    title: 'Erreur...',
                    message: "Veuillez renseigner les champs obligatoires.",
                    type: 'warning',
                    position: 'top-center'
                });
                return;
            }
            this.loading = true;
            var form = document.getElementById("formTri");
            var data = new FormData(form);
            data.append('idUser', this.user.id);
            data.append('periode', this.formTri.periode);
            data.append('tresorerie', this.selectTresor);
            data.append('type', this.selectTypes);

            // this.loading = true
            this.listResulat = [];
            var url = this.domaine + 'caisse/recherche/information';
            this.$http.post(url, data).then(function (response) {
                if (response.body) {
                    var tab = response.body.recherch;
                    _this2.listResulat = tab;
                    _this2.showRecherche = true;
                    _this2.$notify({
                        title: 'RESULTAT RECHERCHE',
                        message: 'Factures trouvéesavec succès.',
                        type: 'success',
                        position: 'top-center'
                    });
                    _this2.loading = false;
                }
            }, function (error) {
                _this2.$message.error('Sélectionnez au moins une trésorerie');
                _this2.loading = false;
                _this2.validPaiem = false;
            });
        },
        loadFournisseur: function loadFournisseur() {
            var _this3 = this;

            this.loading = true;
            var url = this.domaine + 'fournisseur/index';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this3.listFournisseur = response.body.fournisseur;
                    _this3.loading = false;
                }
            });
        },
        loadProjet: function loadProjet(ligne) {
            var _this4 = this;

            this.loading = true;
            var url = this.domaine + 'caisse/' + ligne.id + '/caisse/projet';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this4.listProjet = response.body.projet;
                    _this4.loading = false;
                }
            });
        },
        savePieceJointe: function savePieceJointe() {
            var _this5 = this;

            var url = this.domaine + 'caisse/' + this.typeF + '/' + this.optionPaiement.id + '/new/optionPaiement';
            var form = document.getElementById("formPieceJointe");
            var data = new FormData(form);
            data.append('idUser', this.user.id);
            data.append('idPiece', this.optionPaiement.idPiece);

            this.loading = true;

            this.$http.post(url, data).then(function (response) {
                if (response.body) {
                    _this5.$notify({
                        title: 'ENREGISTREMENT REUSSI',
                        message: 'Piece jointe enregistré avec succès.',
                        type: 'success',
                        position: 'top-center'
                    });

                    _this5.dialogShowPiece = false;
                    _this5.showButtonPiece = false;
                    _this5.showCaisse(_this5.caisseCourant);
                    _this5.loadRegement(_this5.factureCourant, _this5.typeF);

                    _this5.loading = false;
                }
            }, function (error) {
                _this5.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                _this5.loading = false;
                _this5.validPaiem = false;
            });
        },
        clearSelect: function clearSelect() {
            this.listCaisse = this.oldListCaisses;
        },
        loadClient: function loadClient() {
            var _this6 = this;

            this.loading = true;
            var url = this.domaine + 'client/projet/index';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this6.listClient = response.body.client;
                    _this6.loading = false;
                }
            }, function (error) {
                _this6.loading = false;
            });
        },
        loadFactureClient: function loadFactureClient(item) {
            var _this7 = this;

            var url = this.domaine + "facture/client/" + item.id + "/index";
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this7.listFacture = response.body;
                }
            });
        },
        searchOpera: function searchOpera() {
            var _this8 = this;

            if (formRech.recherche != '') {
                var form = document.getElementById('formRech');
                var data = new FormData(form);
                var url = this.domaine + 'caisse/' + this.caisseCourant.id + '/search/show';
                this.$http.post(url, data).then(function (response) {
                    if (response.body) {
                        _this8.loading = true;
                        _this8.tableOpera = response.body.operation;
                        _this8.loading = false;
                    }
                });
            }
        },
        loadCaisse: function loadCaisse() {
            var _this9 = this;

            this.loading = true;
            var url = "";
            if (this.droitAcces.caisse) {
                //pour l'admin
                url = this.domaine + 'caisse/index';
            } else if (this.droitAcces.caisse_unique_user) {
                //pour celui qui a crée la caisee
                url = this.domaine + 'caisse/unique/' + this.user.id + '/user/index';
            } else {
                url = this.domaine + 'caisse/unique/' + this.user.id + '/index';
            }
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this9.detailCaisseS = response.body.caisse;
                    _this9.listCaisse = response.body.caisse;
                    _this9.listCaisseTransfert = response.body.caisse;
                    _this9.oldListCaisses = response.body.caisse, _this9.soldeCaisse = response.body.soldeCaisse;
                    _this9.statAllCaisse = response.body.stats;
                    _this9.statAllbilan();
                    _this9.loading = false;
                }
            });
        },
        loadOperationsCaisse: function loadOperationsCaisse(item) {
            var _this10 = this;

            this.loading = true;
            var url = this.domaine + 'caisse/load/operations/' + item + '/today';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this10.tableOpera = response.body.operations;
                    _this10.loading = false;
                }
            });
        },
        loadFacture: function loadFacture(ligne) {
            var _this11 = this;

            this.loading = true;
            this.caisseCourant = ligne;
            this.listFacture = [];
            if (this.$refs.formFacture.validate()) {

                var form = document.getElementById('formFacture');
                var data = new FormData(form);
                var url = this.domaine + 'caisse/' + this.caisseCourant.id + '/facture';
                data.append('idUser', this.user.id);
                data.append('fournisseur', this.selectFournisseur);
                data.append('projet', this.selectProjet);
                data.append("dateFacture", this.dateFacture);
                data.append('type', this.selectTypeFacture);
                data.append('typeRech', this.typeRech);
                data.append('client', this.selectClient);
                data.append('categorie', this.caisseCourant.categorie);

                data.append('idDemandeur', this.selectDemandeur);
                data.append('etat', this.selectEtatFacture);
                this.$http.post(url, data).then(function (response) {
                    if (response.body) {
                        var verif = response.body;
                        if (verif.code === 1) {
                            _this11.listFacture = verif.facture;
                            if (_this11.listFacture.length === 0) {
                                _this11.$notify({
                                    title: 'RESULTATS DE VOTRE RECHERCHE',
                                    message: "Aucune facture n'a été trouvée.",
                                    type: 'warning',
                                    position: 'top-center'
                                });
                            } else {
                                _this11.$notify({
                                    title: 'RESULTATS DE VOTRE RECHERCHE',
                                    message: _this11.listFacture.length + " facture(s) ont été trouvée(s).",
                                    type: 'success',
                                    position: 'top-center'
                                });
                            }
                        } else if (verif.code === 2) {
                            _this11.$message({
                                message: verif.message,
                                type: 'warning'
                            });
                            _this11.loading = false;
                        } else if (verif.code === 3) {
                            _this11.$message({
                                message: verif.message,
                                type: 'warning'
                            });
                            _this11.loading = false;
                        } else if (verif.code === 0) {
                            _this11.$message.error(verif.message);
                            _this11.loading = false;
                        }

                        _this11.loading = false;
                    } else {
                        _this11.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this11.loading = false;
                    }
                }, function (response) {
                    _this11.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                    _this11.loading = false;
                });
            }
        },
        loadSearchOperation: function loadSearchOperation(ligne) {
            var _this12 = this;

            this.loading = true;
            this.disabledBtn = false;
            this.caisseCourant = ligne;
            if (this.$refs.formOperation.validate()) {
                var form = document.getElementById('formOperation');
                var data = new FormData(form);
                var url = this.domaine + 'caisse/search/' + this.caisseCourant.id + '/caisse/operation';
                this.$http.post(url, data).then(function (response) {
                    _this12.dateDbt = response.body.dateD;
                    _this12.dateFin = response.body.dateF;
                    if (response.body) {
                        var verif = response.body;
                        if (verif.operation) {
                            _this12.listOperation = verif.operation;
                        } else {
                            _this12.loading = false;
                            _this12.listOperation = [];
                            _this12.dateDbt = 0;
                            _this12.dateFin = 0;
                            _this12.disabledBtn = true;
                            _this12.$message.error('Resultat de recherche vide');
                        }
                        _this12.loading = false;
                    } else {
                        _this12.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this12.dateDbt = 0;
                        _this12.dateFin = 0;
                        _this12.disabledBtn = true;
                        _this12.loading = false;
                    }
                }, function (response) {
                    _this12.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                    _this12.loading = false;
                });
            } else {
                this.loading = false;
                this.$message.error('Veuillez selectionner les dates');
            }
        },
        retourCaisse: function retourCaisse(ligne, type) {
            var _this13 = this;

            this.dialogRetour = true, this.typeF = type;
            this.reglementCourant = ligne;
            this.montantVerse = 5;
            // this.dialogLoadReglement = true
            var url = this.domaine + 'caisse/' + this.reglementCourant.id + '/' + this.user.id + '/index/retour';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this13.detailRetour = response.body.retour;
                }
            });
        },
        loadRegement: function loadRegement(ligne, type) {
            var _this14 = this;

            this.typeF = type;
            this.factureCourant = ligne;

            this.montantVerse = 5;
            this.dialogLoadReglement = true;
            var url = this.domaine + 'caisse/' + this.typeF + '/' + this.factureCourant.idFact + '/index/reglement';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this14.listReglement = response.body.paiement;
                    _this14.typeF = response.body.typeF;
                    if (response.body.type != 3) // si ce na'est pas un facture de demande de fonds
                        {
                            _this14.readInput = false;
                        } else {
                        _this14.montantVerse = response.body.total1;
                        _this14.totalretour = response.body.totalretour;
                        _this14.selectEffectue = 1; //"Lui meme"
                        _this14.selectMode = 1; //"espece"
                        _this14.readInput = true;
                    }
                    _this14.totalFacture = response.body.total;
                    _this14.totalFacture1 = response.body.total1;
                    _this14.payeFacture = response.body.total;
                    _this14.payeFacture1 = response.body.paye1;
                    _this14.totalretour = response.body.totalretour;
                    _this14.impayeFacture = response.body.impaye;
                    _this14.impayeFacture1 = response.body.impaye1;
                    _this14.soldeCaisse = response.body.soldeCaisse;
                    _this14.dialogAjoutReglement = false;
                    _this14.dialogEditReglement = false;
                    _this14.dialogEdit = false;
                }
            });
        },
        loadAppro: function loadAppro(ligne) {
            var _this15 = this;

            this.caisseCourant = ligne;
            var url = this.domaine + 'caisse/' + this.caisseCourant.id + '/index/appro/caisse';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this15.listApproCaisse = response.body.appro;
                }
            });
        },
        loadOperation: function loadOperation(ligne) {
            var _this16 = this;

            this.loading = true;
            this.disabledBtn = false;
            this.dateDbt = 0;
            this.dateFin = 0;
            this.caisseCourant = ligne;
            var url = this.domaine + 'caisse/' + this.caisseCourant.id + '/' + this.user.id + '/operation';
            this.$http.get(url).then(function (response) {
                _this16.loading = false;
                if (response.body.operation.length > 0) {
                    _this16.listOperation = response.body.operation;
                } else {
                    _this16.dateDbt = 0;
                    _this16.dateFin = 0;
                    _this16.disabledBtn = true;
                }
            }, function (response) {
                _this16.loading = false;
                _this16.$message.error('Erreur lors du chargement des transactions');
                _this16.dateDbt = 0;
                _this16.dateFin = 0;
                _this16.disabledBtn = true;
            });
        },
        showCaisse: function showCaisse(ligne) {
            var _this17 = this;

            this.loading = true;

            this.dialogShow = true;
            this.caisseCourant = ligne;
            this.listFacture = [];
            var url = this.domaine + 'caisse/' + this.caisseCourant.id + '/show';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this17.loading = false;

                    _this17.detailCaisse = response.body.caisse;
                    _this17.detailCaisseS = response.body.details;
                    _this17.montantSortie = response.body.montantSortie;
                    _this17.montantEntree = response.body.montantEntree;
                    _this17.montantTvaEntree = response.body.montantTvaEntree;
                    _this17.soldeCaisse = _this17.detailCaisseS.solde1;

                    _this17.totalEntree = response.body.totalEntree;
                    _this17.totalSortie = response.body.totalSortie;

                    _this17.montantTvaSortie = response.body.montantTvaSortie;
                    _this17.statCaisse1 = response.body.stats1;
                    _this17.statAllbilanCaisse();
                }
            });
        },
        showReglement: function showReglement(ligne) {
            var _this18 = this;

            this.dialogShowReglement = true;
            this.reglementCourant = ligne;
            var url = this.domaine + 'caisse/' + this.reglementCourant.id + '/show/reglement';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this18.detailReglement = response.body.paiement;
                }
            });
        },
        showAppro: function showAppro(ligne) {
            var _this19 = this;

            this.dialogShowAppro = true;
            this.approCourant = ligne;

            var url = this.domaine + 'caisse/' + this.approCourant.id + '/show/appro';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this19.detailAppro = response.body.appro;
                }
            });
        },
        newCaisse: function newCaisse() {
            this.loading = false;
            this.dialogAjout = true;
            this.dialogEdit = false;
            this.selectAdmin = '';
            this.seuilMax = 5;
            this.seuilMin = 5;
            this.libelle = '';
            this.activer = false;
            this.selectTresorerie = '';
            this.caisseCourant = '';
            this.soldeInitial = '';
            this.categorie = '';
        },
        newReglement: function newReglement(ligne) {

            this.dialogAjoutReglement = true;
            this.dialogEditReglement = false;
            this.dialogEdit = false;
            this.montantVerse = 5;
            this.remettant = '';
            this.banque = '';
            this.reference = '';
            this.selectEncaisse = null;
            this.selectEffectue = null;
            this.selectMode = null;
            this.readInput = false;
        },
        newTransfert: function newTransfert(ligne) {
            this.loading = false;
            this.dialogAjoutTrans = true;
            this.transFertForm = {};
        },
        newAppro: function newAppro(ligne) {
            this.loading = false;

            this.dialogAjoutAppro = true;

            this.dialogEdit = false;
            this.approCourant = [];
            this.approCourant.id = '';
            this.approForm.montant = '';
            this.approForm.motif = '';
            this.selectValidateurAppro = null;
        },
        newValideAppro: function newValideAppro(ligne) {
            this.loading = false;
            this.approCourant = ligne;
            this.dialogAjoutValideAppro = true;
            this.dialogEdit = false;
        },
        editCaisse: function editCaisse(ligne) {
            this.loading = false;
            this.dialogAjout = true;
            this.dialogEdit = true;
            this.caisseCourant = ligne;
            this.selectAdmin = this.caisseCourant.idGerant;
            this.seuilMax = this.caisseCourant.seuilMax;
            this.seuilMin = this.caisseCourant.seuilMin;
            // if (this.numCompte == null) { this.numCompte = 'O'}
            this.libelle = this.caisseCourant.libelle;
            this.activer = this.caisseCourant.etat;
            this.numCompte = this.caisseCourant.numCompte;
            this.soldeInitial = this.caisseCourant.soldeInitial;
            this.selectTresorerie = this.caisseCourant.type;
            this.categorie = this.caisseCourant.categorie;
        },
        editRegement: function editRegement(ligne) {
            this.loading = false;
            this.dialogShowReglement = false;
            this.dialogAjoutReglement = false;
            this.dialogEditReglement = true;
            this.dialogEdit = true;
            this.reglementCourant = ligne;
            this.montantVerse = this.reglementCourant.montant1;
            this.remettant = this.reglementCourant.remettant;
            this.banque = this.reglementCourant.banque;
            this.reference = this.reglementCourant.reference;
            this.selectEncaisse = this.reglementCourant.encaisse;
            this.selectEffectue = this.reglementCourant.effectue;
            this.selectMode = this.reglementCourant.mode;
        },
        editAppro: function editAppro(ligne) {
            this.loading = false;
            this.approCourant = ligne;
            this.dialogAjoutAppro = true;
            this.dialogEdit = true;
            this.approForm.montant = this.approCourant.montant1;
            this.approForm.motif = this.approCourant.motif;
            this.selectValidateurAppro = this.approCourant.idValid;
        },
        ajouterRetour: function ajouterRetour(ligne, detailRetour) {
            var _this20 = this;

            this.loading = true;
            this.validRetour = false;
            if (this.retourForm.montant != "" && this.retourForm.commentaire != "") {
                var form = document.getElementById('retourForm');
                var data = new FormData(form);
                var url = '';
                data.append('idUser', this.user.id);
                data.append('idpaiement', this.detailRetour.idPaionly);
                data.append('concerne', this.detailRetour.concerne);
                data.append('idCaisse', this.caisseCourant.id);
                data.append('idFacture', this.factureCourant.idFact);
                data.append('admin', this.selectAdmin);
                data.append('activer', this.activer);
                data.append('categorie', this.categorie);
                data.append('type', this.selectTresorerie);

                url = this.domaine + 'caisse/' + this.factureCourant.idFact + '/ajout/retour';
                this.$http.post(url, data).then(function (response) {
                    if (response.body) {
                        var verif = response.body;
                        if (verif.code === 1) {
                            _this20.$notify({
                                title: 'ENREGISTREMENT REUSSI',
                                message: response.body.message,
                                type: 'success',
                                position: 'top-center'
                            });
                        }
                        // this.loadCaisse()
                        _this20.dialogRetour = false;
                        _this20.retourForm.motif = '';
                        _this20.retourForm.montant = '';
                        _this20.loadOperation(_this20.caisseCourant);
                        _this20.loadRegement(_this20.factureCourant, _this20.typeF);
                        _this20.loadCaisse();
                        _this20.showCaisse(_this20.caisseCourant);
                        // this.loadRegement (this.factureCourant, this.typeF)
                        // this.showCaisse(this.caisseCourant)

                        _this20.loading = false;
                        _this20.validRetour = false;
                    } else {
                        _this20.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this20.loading = false;
                    }
                }, function (response) {
                    _this20.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                    _this20.loading = false;
                });
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "le retour caisse n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        changeTresor: function changeTresor() {

            if (this.selectTresorerie === 'Banque') {
                this.numCompte = '';
            } else {
                this.numCompte = 'O';
            }
        },
        submitCaisse: function submitCaisse() {
            var _this21 = this;

            this.loading = true;

            if (this.selectTresorerie == "Caisse") {
                if (this.$refs.formCaisse.validate() && this.libelle != "" && this.selectAdmin != "" && this.seuilMin != "" && this.seuilMax != "" && this.categorie != "" && this.numCompte != "" && this.soldeInitial > -1 && this.soldeInitial != "") {} else {
                    this.$message.error('Veuillez renseigner les champs obligatoires');
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "La caisse n'a pas été enregistré.",
                        position: 'top-center'
                    });

                    this.loading = false;
                }
            } else if (this.selectTresorerie == "Banque") {
                if (this.$refs.formCaisse.validate() && this.libelle != "" && this.selectAdmin != "" && this.seuilMin != "" && this.seuilMax != "" && this.numCompte != "" && this.soldeInitial > -1 && this.soldeInitial != "") {} else {
                    this.$message.error('Veuillez renseigner les champs obligatoires');
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "La caisse n'a pas été enregistré.",
                        position: 'top-center'
                    });
                    this.loading = false;
                }
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "La caisse n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }

            var form = document.getElementById('formCaisse');
            var data = new FormData(form);
            var url = '';
            data.append('idUser', this.user.id);
            data.append('admin', this.selectAdmin);
            data.append('activer', this.activer);
            data.append('type', this.selectTresorerie);
            data.append('categorie', this.categorie);
            if (this.caisseCourant.id) {
                url = this.domaine + 'caisse/' + this.caisseCourant.id + '/edit';
            } else {
                url = this.domaine + 'caisse/create';
            }
            this.$http.post(url, data).then(function (response) {
                if (response.body) {
                    var verif = response.body;
                    if (verif.code === 1) {
                        if (_this21.caisseCourant.id) {
                            _this21.$notify({
                                title: 'MODIFICATION REUSSI',
                                message: 'Caisse modifié avec succès.',
                                type: 'success',
                                position: 'top-center'
                            });
                            _this21.showCaisse(_this21.caisseCourant);
                        } else {
                            _this21.$notify({
                                title: 'ENREGISTREMENT REUSSI',
                                message: 'Caisse enregistré avec succès.',
                                type: 'success',
                                position: 'top-center'
                            });
                        }
                        _this21.loadPage();
                        _this21.loadCaisse();
                        _this21.dialogAjout = false;
                        _this21.dialogShow = false;
                        _this21.loading = false;
                    } else if (verif.code === 0) {
                        _this21.$message.error(verif.message);
                        _this21.loading = false;
                    }
                } else {
                    _this21.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                    _this21.loading = false;
                }
            }, function (response) {
                _this21.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                _this21.loading = false;
            });
        },
        submitReglement: function submitReglement() {
            var _this22 = this;

            if (this.selectMode == "" || this.selectMode == null) {
                this.$notify.error({
                    title: "MODE DE PAIEMENT",
                    message: "Veuillez selectionner le mode de paiement",
                    position: 'top-center'
                });
                this.validPaiem = false;
                return;
            }
            this.validPaiem = false;
            this.loading = true;

            if (this.soldeCaisse >= this.montantVerse) {

                if (this.montantVerse > 0 && this.montantVerse <= this.impayeFacture1) {

                    var etat = false;
                    if (this.selectEffectue != "" && this.selectMode != "") {
                        if (this.selectEffectue == 2 && this.remettant == '' || this.selectMode != 1 && this.selectMode == 2 && (this.banque == '' || this.reference == '' || this.selectEncaisse == '')) {
                            etat = false;
                        } else if (this.selectEffectue == 2 && this.remettant == '' || this.selectMode != 1 && this.selectMode == 3 && (this.banque == '' || this.reference == '')) {
                            etat = false;
                        } else {
                            etat = true;
                        }
                    } else {
                        etat = false;
                    }

                    if (etat == true) {
                        if (this.$refs.formReglement.validate()) {
                            var form = document.getElementById('formReglement');
                            var data = new FormData(form);
                            var url = '';
                            data.append('idUser', this.user.id);
                            data.append('effectue', this.selectEffectue);
                            data.append('mode', this.selectMode);
                            data.append('encaisse', this.selectEncaisse);

                            url = this.domaine + 'caisse/' + this.typeF + '/' + this.factureCourant.idFact + '/new/reglement';
                            this.$http.post(url, data).then(function (response) {

                                if (response.body) {
                                    _this22.dialogEditReglement = false;
                                    _this22.dialogAjoutReglement = false;
                                    var verif = response.body;
                                    if (verif.code === 1) {
                                        if (_this22.reglementCourant.id) {
                                            _this22.$notify({
                                                title: 'MODIFICATION REUSSI',
                                                message: response.body.message,
                                                type: 'success',
                                                position: 'top-center'
                                            });
                                        } else {
                                            _this22.$notify({
                                                title: 'ENREGISTREMENT REUSSI',
                                                message: 'Paiement enregistré avec succès.',
                                                type: 'success',
                                                position: 'top-center'
                                            });
                                        }

                                        _this22.$refs.formReglement.reset();
                                        _this22.loadRegement(_this22.factureCourant, _this22.typeF);
                                        _this22.loadCaisse();
                                        _this22.showCaisse(_this22.caisseCourant);
                                        _this22.loadOperation(_this22.caisseCourant);

                                        _this22.listFacture = [];
                                        _this22.loading = false;
                                        _this22.dialogEdit = false;
                                        // this.dialogLoadReglement = false
                                    } else if (verif.code === 0) {
                                        _this22.$message.error(verif.message);
                                        _this22.loading = false;
                                    }
                                } else {
                                    _this22.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                                    _this22.loading = false;
                                    _this22.validPaiem = false;
                                }
                            }, function (response) {
                                _this22.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                                _this22.loading = false;
                                _this22.validPaiem = false;
                            });
                        } else {
                            this.$message.error('Veuillez renseigner les champs obligatoires');
                            this.$notify.error({
                                title: "ERREUR D'ENREGISTREMENT",
                                message: "Le paiement n'a pas été enregistré.",
                                position: 'top-center'
                            });
                            this.loading = false;
                            this.validPaiem = false;
                        }
                    } else {
                        this.$message.error('Veuillez renseigner les champs obligatoires');
                        this.loading = false;
                        this.validPaiem = false;
                    }
                } else {
                    this.$notify.error({
                        title: "ERREUR DU MONTANT",
                        message: "Le montant versé ne doit pas etre supérieur au montant restant.",
                        position: 'top-center'
                    });
                    this.loading = false;
                    this.validPaiem = false;
                }
            } else {
                this.$notify.error({
                    title: "ERREUR DU MONTANT",
                    message: "Impossible d'effectuer un paiement, fond insuffisant dans la caisse.",
                    position: 'top-center'
                });
                this.loading = false;
                this.validPaiem = false;
            }
        },
        filtrerCaisseDmd: function filtrerCaisseDmd(idCaisse) {
            this.loadDmdParCaisse(idCaisse);
        },
        loadDmdParCaisse: function loadDmdParCaisse(idCaisse) {
            this.listCaisse = this.oldListCaisses.filter(function (item) {
                return item.id == idCaisse;
            });
        },
        loadBilanFacture: function loadBilanFacture() {
            var url = this.domaine + 'caisse/' + this.caisseCourant.id + '/imprimer/bilan/' + this.user.id;
            this.$http.get(url).then(function (response) {
                if (response.body) {}
            });
            window.open(url);
        },
        showBanque: function showBanque(ligne) {
            var _this23 = this;

            this.dialogModalBanque = true;
            // this.dialogShow = true
            this.caisseCourant = ligne;

            this.listFacture = [];
            var url = this.domaine + 'caisse/' + this.caisseCourant.id + '/show';
            this.$http.get(url).then(function (response) {
                if (response.body) {

                    _this23.detailCaisse = response.body.caisse;
                    _this23.detailCaisseS = response.body.details;
                    _this23.montantSortie = response.body.montantSortie;
                    _this23.montantEntree = response.body.montantEntree;
                    _this23.montantTvaEntree = response.body.montantTvaEntree;
                    _this23.montantTvaSortie = response.body.montantTvaSortie;
                    _this23.totalEntree = response.body.totalEntree;
                    _this23.totalSortie = response.body.totalSortie;
                    _this23.statCaisse2 = response.body.stats1;
                    _this23.statAllbilanCaisse();
                }
            });
        },

        //enregistrement des images
        onFileImageLogoPicked: function onFileImageLogoPicked(event) {
            var _this24 = this;

            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }

            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this24.pieceJusti = fileReader.result;
            });

            fileReader.readAsDataURL(files[0]);
            this.pieceJusti = files[0];
        },
        showPieceJustifi: function showPieceJustifi(item) {
            this.optionPaiement = item;
            this.dialogShowPiece = true;
            this.showButtonPiece = false;
            this.pieceJusti = item.urlPiece;
        },
        submitApproCaisse: function submitApproCaisse(formName) {
            var _this25 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {
                    _this25.loading = true;
                    var form = document.getElementById('approForm');
                    var data = new FormData(form);
                    data.append('idUser', _this25.user.id);

                    var url = '';
                    if (_this25.approCourant.id) {
                        url = _this25.domaine + 'caisse/' + _this25.approCourant.id + '/edit/appro/caisse';
                    } else {
                        url = _this25.domaine + 'caisse/' + _this25.caisseCourant.id + '/new/appro/caisse';
                    }

                    _this25.$http.post(url, data).then(function (response) {
                        if (response.body) {
                            var verif = response.body;
                            if (verif.code === 1) {
                                if (_this25.approCourant.id) {
                                    _this25.$notify({
                                        title: 'MODIFICATION REUSSI',
                                        message: 'Approvisionnement de la caisse modifié avec succès.',
                                        type: 'success',
                                        position: 'top-center'
                                    });
                                } else {
                                    _this25.$notify({
                                        title: 'ENREGISTREMENT REUSSI',
                                        message: 'Approvisionnement de la caisse enregistré avec succès.',
                                        type: 'success',
                                        position: 'top-center'
                                    });
                                }
                                _this25.dialogAjoutAppro = false;
                                _this25.loadAppro(_this25.caisseCourant);

                                //AFFICHER LE MODAL DE CAISSE OU BANQUE
                                if (_this25.caisseCourant.type === "Caisse") {
                                    _this25.showCaisse(_this25.caisseCourant);
                                } else {
                                    _this25.showBanque(_this25.caisseCourant);
                                }

                                _this25.loading = false;
                            } else if (verif.code === 0) {
                                _this25.$message.error(verif.message);
                                _this25.loading = false;
                            }
                        } else {
                            _this25.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                            _this25.loading = false;
                        }
                    }, function (response) {
                        _this25.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this25.loading = false;
                    });
                }
            });
        },
        submitTransferCaisse: function submitTransferCaisse() {
            var _this26 = this;

            if (this.soldeCaisse >= this.transFertForm.montantTransf) {
                this.loading = true;
                var form = document.getElementById('transFertForm');
                var data = new FormData(form);
                data.append('montantTransf', this.transFertForm.montantTransf);
                data.append('libelleTransfert', this.transFertForm.libelleTransfert);
                data.append('idUser', this.user.id);
                data.append('caisseCrediter', this.transFertForm.caisseSelect);
                var url = this.domaine + 'caisse/' + this.caisseCourant.id + '/new/transfert/caisse';

                this.$http.post(url, data).then(function (response) {
                    if (response.body) {
                        var verif = response.body;
                        _this26.dialogAjoutTrans = false;
                        if (verif.code === 1) {
                            _this26.$notify({
                                title: 'ENREGISTREMENT REUSSI',
                                message: 'Transfert dans une autre caisse enregistré avec succès.',
                                type: 'success',
                                position: 'top-center'
                            });
                            _this26.validTransfert = false;
                            _this26.dialogAjoutAppro = false;
                            _this26.loadAppro(_this26.caisseCourant);
                            //AFFICHER LE MODAL DE CAISSE OU BANQUE
                            if (_this26.caisseCourant.type === "Caisse") {
                                _this26.showCaisse(_this26.caisseCourant);
                            } else {
                                _this26.showBanque(_this26.caisseCourant);
                            }

                            _this26.loading = false;
                        } else if (verif.code === 0) {
                            _this26.$message.error(verif.message);
                            _this26.loading = false;
                        }
                    } else {
                        _this26.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this26.loading = false;
                    }
                }, function (response) {
                    _this26.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                    _this26.loading = false;
                });
            } else {
                this.$message.error("Montant à transférer est supérieur au solde de la caisse.");
            }
        },
        ClearApproForm: function ClearApproForm() {
            this.dialogAjoutAppro = false;
            this.$refs['approForm'].resetFields();
        },
        ClearTransfertForm: function ClearTransfertForm() {
            this.dialogAjoutTrans = false;
            this.$refs['transFertForm'].resetFields();
        },
        submitValideAppro: function submitValideAppro() {
            var _this27 = this;

            this.loading = true;
            if (this.$refs.formValideAppro.validate() && this.selectReponseAppro != "") {
                var form = document.getElementById('formValideAppro');
                var data = new FormData(form);
                data.append('idUser', this.user.id);
                data.append('reponse', this.selectReponseAppro);
                var url = this.domaine + 'caisse/' + this.approCourant.id + '/valide/appro';
                this.$http.post(url, data).then(function (response) {
                    if (response.body) {
                        var verif = response.body;
                        if (verif.code === 1) {
                            _this27.$notify({
                                title: 'ENREGISTREMENT REUSSI',
                                message: 'Validation enregistré avec succès.',
                                type: 'success',
                                position: 'top-center'
                            });
                            _this27.dialogAjoutValideAppro = false;
                            _this27.loadAppro(_this27.caisseCourant);
                            _this27.showCaisse(_this27.caisseCourant);
                            _this27.loading = false;
                        } else if (verif.code === 0) {
                            _this27.$message.error(verif.message);
                            _this27.loading = false;
                        }
                    } else {
                        _this27.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                        _this27.loading = false;
                    }
                }, function (response) {
                    _this27.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur');
                    _this27.loading = false;
                });
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "La validation n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        imprimerFacture: function imprimerFacture(ligne) {
            var url = "";
            var mode = 2;
            if (ligne.type == 1) {
                url = this.domaine + 'fournisseur/' + ligne.idFact + '/' + this.user.id + '/imprimer/facture/' + mode;
            } else {
                url = this.domaine + 'fournisseur/' + ligne.idFact + '/' + this.user.id + '/imprimer/factureParc';
            }

            this.$http.get(url).then(function (response) {
                if (response.body) {}
            });
            window.open(url);
        },
        imprimeListeHis: function imprimeListeHis(type) {
            var idCaisse = this.caisseCourant.id;
            var url = "";
            if (type == "PDF") {
                url = this.domaine + "caisse/imprimerPDF/historique/" + idCaisse + "/" + this.dateDbt + "/" + this.dateFin;
            } else {
                url = this.domaine + "caisse/imprimerEXC/historique/" + idCaisse + "/" + this.dateDbt + "/" + this.dateFin;
            }
            window.open(url);
        },
        imprimerReglement: function imprimerReglement(ligne) {
            this.reglementCourant = ligne;
            var url = this.domaine + 'caisse/' + this.reglementCourant.id + '/imprimer/reglement/' + this.user.id;
            this.$http.get(url).then(function (response) {
                if (response.body) {}
            });
            window.open(url);
        },
        imprimerAppro: function imprimerAppro(ligne) {
            this.approCourant = ligne;
            var url = this.domaine + 'caisse/' + this.approCourant.id + '/imprimer/appro/' + this.user.id + '/caisse';
            this.$http.get(url).then(function (response) {
                if (response.body) {}
            });
            window.open(url);
        },
        imprimeSearchFacture: function imprimeSearchFacture(item) {

            this.selectFournisseur = this.selectFournisseur != '' ? this.selectFournisseur : "null";
            this.selectTypeFacture = this.selectTypeFacture != '' ? this.selectTypeFacture : "null";
            this.selectEtatFacture = this.selectEtatFacture != '' ? this.selectEtatFacture : "null";
            this.dateFacture = this.dateFacture != '' ? this.dateFacture : "null";

            var url = this.domaine + 'caisse/impression/facture/search/' + item + '/' + this.user.id + '/' + this.selectFournisseur + '/' + this.selectTypeFacture + '/' + this.selectEtatFacture + '/' + this.dateFacture;
            window.open(url);

            this.selectFournisseur = '';
            this.selectTypeFacture = '';
            this.selectEtatFacture = '';
            this.dateFacture = '';
        },
        imprimeHistoCaisse: function imprimeHistoCaisse(item) {
            var url = this.domaine + 'caisse/impression/historique/appro/' + item;
            window.open(url);
        },
        imprimeAllTresorerie: function imprimeAllTresorerie(item) {
            var url = this.domaine + 'caisse/impression/liste/tresor';
            window.open(url);
        },
        imprimeRech: function imprimeRech() {
            var _this28 = this;

            var formdata = new FormData();

            var url = this.domaine + "caisse/imprimerPDF/listeRecherche";
            formdata.append('idUser', this.user.id);
            formdata.append('periode', this.formTri.periode);
            formdata.append('tresorerie', this.selectTresor);
            formdata.append('type', this.selectTypes);

            var req = new XMLHttpRequest();
            this.$http.post(url, formdata, { responseType: "arraybuffer" }).then(function (response) {
                var blob = new Blob([response.data], {
                    type: response.headers.get("content-type")
                });

                var url = URL.createObjectURL(blob);
                _this28.loading = false;
                window.open(url);
            });
        },
        statAllbilan: function statAllbilan() {
            //somme des entrée et des sorties
            var optionAllBilan = {
                title: {
                    text: 'TOTAL DES MONTANTS CREDIT ET DEBIT DES TRESORERIES',
                    subtext: '',
                    left: 'center'
                },
                color: ['#67C23A', '#e5323e'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: []
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    data: []
                }],
                yAxis: [{ type: 'value' }],
                series: [{
                    name: 'Montant entrée ',
                    type: 'bar',
                    barWidth: 30,
                    data: []
                }, {
                    name: 'Montant sortie ',
                    type: 'bar',
                    barWidth: 30,
                    data: []
                }]
            };

            this.statAllCaisse.forEach(function (element) {
                optionAllBilan.xAxis[0].data.push(element.date);
                optionAllBilan.series[0].data.push(element.entree);
                optionAllBilan.series[1].data.push(element.sortie);
            });

            var chartAllBilan = echarts.init(document.getElementById('chartAllBilan'));
            chartAllBilan.setOption(optionAllBilan);
        },
        statAllbilanCaisse: function statAllbilanCaisse() {
            //somme des entrée et des sorties
            var optionAllBilanCaisse = {
                title: {
                    text: 'TOTAL DES MONTANTS CREDIT ET DEBIT DE LA CAISSE',
                    subtext: '',
                    left: 'center'
                },
                color: ['#67C23A', '#e5323e'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: []
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    data: []
                }],
                yAxis: [{ type: 'value' }],
                series: [{
                    name: 'Montant entrée ',
                    type: 'bar',
                    barWidth: 30,
                    data: []
                }, {
                    name: 'Montant sortie ',
                    type: 'bar',
                    barWidth: 30,
                    data: []
                }]
            };

            this.statCaisse1.forEach(function (element) {
                optionAllBilanCaisse.xAxis[0].data.push(element.date);
                optionAllBilanCaisse.series[0].data.push(element.entree);
                optionAllBilanCaisse.series[1].data.push(element.sortie);
            });

            var chartAllBilanCaisseOnly = echarts.init(document.getElementById('chartAllBilanCaisseOnly'));
            chartAllBilanCaisseOnly.setOption(optionAllBilanCaisse);
        },
        deleteCaisse: function deleteCaisse() {
            var _this29 = this;

            var url = this.domaine + 'caisse/' + this.idCaisse + '/delete';
            this.$http.get(url).then(function (response) {
                if (response.body.code == 1) {
                    _this29.$notify({
                        title: 'SUPPRESSION',
                        message: 'Caisse supprimé avec succès.',
                        type: 'success',
                        position: 'top-center'
                    });
                    _this29.dialogSupr = false;
                    _this29.loadCaisse();
                    _this29.loadPage();
                } else if (response.body.code == 0) {

                    _this29.$notify({
                        title: 'SUPPRESSION',
                        message: 'Impossible de supprimer la caisse.',
                        type: 'error',
                        position: 'top-center'
                    });
                    _this29.dialogSupr = false;
                }
            });
        },
        deleteAppro: function deleteAppro() {
            var _this30 = this;

            var url = this.domaine + 'caisse/' + this.idAppro + '/delete/approvisionnement';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    var verif = response.body;
                    if (verif.code === 1) {
                        _this30.$notify({
                            title: 'SUPPRESSION',
                            message: 'Approvisionnement supprimé avec succès.',
                            type: 'success',
                            position: 'top-center'
                        });
                    } else if (verif.code === 2) {
                        _this30.$notify({
                            title: 'SUPPRESSION',
                            message: verif.message,
                            type: 'warning',
                            position: 'top-center'
                        });
                    }
                    _this30.dialogSuprAppro = false;
                    _this30.loadCaisse();
                    _this30.showCaisse(_this30.caisseCourant);
                    _this30.loadAppro(_this30.caisseCourant);
                    _this30.loadPage();
                }
            });
        },
        closeLoadReglement: function closeLoadReglement() {
            this.dialogLoadReglement = false;
            this.dialogAjoutReglement = false;
            this.dialogEditReglement = false;
            this.dialogEdit = false;
        },
        clear: function clear() {
            this.$refs.form.reset();
            this.dialogAjout = false;
        },

        // DEMANDEUR
        loadDemandeur: function loadDemandeur() {
            var _this31 = this;

            var url = this.domaine + 'maintenance/listes-demandeur';
            var formdata = new FormData();
            formdata.append('user', this.user.id);

            this.$http.get(url, formdata).then(function (response) {
                _this31.listeDemandeur = response.body;
            }, function (response) {
                _this31.$message.error("Une erreur est survenue lors du chargement de la liste des demandeurs'");
            });
        }
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'showBanque', function showBanque(ligne) {
        var _this32 = this;

        this.dialogModalBanque = true;
        // this.dialogShow = true
        this.caisseCourant = ligne;

        this.listFacture = [];
        var url = this.domaine + 'caisse/' + this.caisseCourant.id + '/show';
        this.$http.get(url).then(function (response) {
            if (response.body) {
                _this32.detailCaisse = response.body.caisse;
                _this32.detailCaisseS = response.body.details;
                _this32.montantSortie = response.body.montantSortie;
                _this32.montantEntree = response.body.montantEntree;
                _this32.montantTvaEntree = response.body.montantTvaEntree;
                _this32.montantTvaSortie = response.body.montantTvaSortie;
                _this32.totalEntree = response.body.totalEntree;
                _this32.totalSortie = response.body.totalSortie;
                _this32.statCaisse2 = response.body.stats1;
                _this32.statAllbilanBanque();
            }
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'statAllbilanBanque', function statAllbilanBanque() {
        //somme des entrée et des sorties
        var optionAllBilanBanque = {
            title: {
                text: 'TOTAL DES MONTANTS CREDIT ET DEBIT DE LA BANQUE',
                subtext: '',
                left: 'center'
            },
            color: ['#67C23A', '#e5323e'],
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                data: []
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [{
                type: 'category',
                data: []
            }],
            yAxis: [{ type: 'value' }],
            series: [{
                name: 'Montant entrée ',
                type: 'bar',
                barWidth: 30,
                data: []
            }, {
                name: 'Montant sortie ',
                type: 'bar',
                barWidth: 30,
                data: []
            }]
        };
        this.statCaisse2.forEach(function (element) {
            optionAllBilanBanque.xAxis[0].data.push(element.date);
            optionAllBilanBanque.series[0].data.push(element.entree);
            optionAllBilanBanque.series[1].data.push(element.sortie);
        });

        var chartAllBilanBanque = echarts.init(document.getElementById('chartAllBilanBanque'));
        chartAllBilanBanque.setOption(optionAllBilanBanque);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'loadListApproDgCheqBanque', function loadListApproDgCheqBanque(item) {
        var _this33 = this;

        this.loading = true;
        var url = this.domaine + 'caisse/appro/' + item + '/valide-dg-cheque/a-confirmer';
        this.$http.get(url).then(function (response) {
            if (response.body) {
                _this33.listApproDgCheq = response.body.listApproCheq;
                _this33.loading = false;
            }
        });
    }), _methods),
    mounted: function mounted() {
        this.loadPage();
        this.loadUser();
        this.loadClient();
        this.loadFournisseur();
        this.loadCaisse();
        // this.showBanque()
        this.statAllbilan();
        this.loadDemandeur();
    },

    beforeMount: function beforeMount() {
        if (!this.roleAcces[this.$router.history.current.name]) {
            this.$router.push({ name: 'Home' });
        }
    }
});

/***/ }),

/***/ "soc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailBudgetChant_vue__ = __webpack_require__("ddrP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d94d8f08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailBudgetChant_vue__ = __webpack_require__("z4rP");
function injectStyle (ssrContext) {
  __webpack_require__("HIBi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailBudgetChant_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d94d8f08_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailBudgetChant_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ssBb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDetailCommande_vue__ = __webpack_require__("bY0r");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d850d222_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDetailCommande_vue__ = __webpack_require__("tGuE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDetailCommande_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d850d222_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDetailCommande_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "svFH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"google-map",staticStyle:{"height":"600px","width":"100%"},attrs:{"id":_vm.mapName}}),_vm._v(" "),_c('div',{attrs:{"id":"legend"}}),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pac-card",attrs:{"id":"pac-card"}},[_c('div',[_c('div',{attrs:{"id":"title"}},[_vm._v("\n                Rechercher un lieu\n            ")]),_vm._v(" "),_c('div',{staticClass:"pac-controls",attrs:{"id":"type-selector"}},[_c('input',{attrs:{"type":"radio","name":"type","id":"changetype-all","checked":"checked"}}),_vm._v(" "),_c('label',{attrs:{"for":"changetype-all"}},[_vm._v("All")]),_vm._v(" "),_c('input',{attrs:{"type":"radio","name":"type","id":"changetype-establishment"}}),_vm._v(" "),_c('label',{attrs:{"for":"changetype-establishment"}},[_vm._v("\n                    Établissements")]),_vm._v(" "),_c('input',{attrs:{"type":"radio","name":"type","id":"changetype-address"}}),_vm._v(" "),_c('label',{attrs:{"for":"changetype-address"}},[_vm._v("Adresses")]),_vm._v(" "),_c('input',{attrs:{"type":"radio","name":"type","id":"changetype-geocode"}}),_vm._v(" "),_c('label',{attrs:{"for":"changetype-geocode"}},[_vm._v("Geocodes")])]),_vm._v(" "),_c('div',{staticClass:"pac-controls",attrs:{"id":"strict-bounds-selector"}},[_c('input',{attrs:{"type":"checkbox","id":"use-strict-bounds","value":""}}),_vm._v(" "),_c('label',{attrs:{"for":"use-strict-bounds"}},[_vm._v("Cite, Region")])])]),_vm._v(" "),_c('div',{attrs:{"id":"pac-container"}},[_c('input',{attrs:{"id":"pac-input","type":"text","placeholder":"Enter a location"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"infowindow-content"}},[_c('img',{attrs:{"src":"","width":"16","height":"16","id":"place-icon"}}),_vm._v(" "),_c('span',{staticClass:"title",attrs:{"id":"place-name"}}),_c('br'),_vm._v(" "),_c('span',{attrs:{"id":"place-address"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t0yD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modelCarteEmploye_vue__ = __webpack_require__("I1Kh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb2f6df2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modelCarteEmploye_vue__ = __webpack_require__("++Cn");
function injectStyle (ssrContext) {
  __webpack_require__("/lFb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bb2f6df2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modelCarteEmploye_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb2f6df2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modelCarteEmploye_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t3x9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReglementCarteIndex__ = __webpack_require__("s/BL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransfertCarteIndex__ = __webpack_require__("P6qC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AjoutCarteCarburant__ = __webpack_require__("xDZZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FicheDetailCarte__ = __webpack_require__("FmqX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_4__components_Loading__["a" /* default */],
    AjoutCarteCarburant: __WEBPACK_IMPORTED_MODULE_2__AjoutCarteCarburant__["a" /* default */],
    ReglementCarteIndex: __WEBPACK_IMPORTED_MODULE_0__ReglementCarteIndex__["a" /* default */],
    TransfertCarteIndex: __WEBPACK_IMPORTED_MODULE_1__TransfertCarteIndex__["a" /* default */],
    FicheDetailCarte: __WEBPACK_IMPORTED_MODULE_3__FicheDetailCarte__["a" /* default */]
  },
  name: "CarteCarburantIndex",
  props: ["show"],
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      // racourcis: [
      //     { path: '/', text: 'Accueil', disabled: false },
      //     { path: '/demandeFond', text: 'Demande de fonds', disabled: true }
      // ],
      cartes: [],
      disabledBtnCarte: false,
      oldCartes: [],
      dialogSupr: false,
      dialogCarteCaburant: false,
      selectSoc: "",
      listeSociete: [],
      showModalAjoutCarte: false,
      showModalRgt: false,
      nbCarte: 0,
      mntTotal: 0,
      carteRgt: {},
      carteId: null,
      carteSelect: {},

      //Rechargement
      carteTransfert: {},
      showModalTransfert: false,
      showModalTransfertCarte: false,

      //Detail
      showModalDetail: false
    };
  },


  watch: {
    show: function show(newValue, oldValue) {
      this.dialogCarteCaburant = newValue;
      this.loadStation();
    }
  },

  methods: {
    showDialogSupp: function showDialogSupp(item) {
      this.carteId = item.carteId;
      this.dialogSupr = true;
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    modalAjoutCarte: function modalAjoutCarte() {
      this.carteTransfert = {};
      this.showModalAjoutCarte = true;
    },
    modalRgt: function modalRgt(carte) {
      this.carteRgt = carte;
      this.showModalRgt = true;
    },
    modalDetailCarte: function modalDetailCarte(carte) {
      this.carteSelect = carte;
      this.showModalDetail = true;
    },
    modalTransfert: function modalTransfert(carte) {
      this.carteTransfert = carte;
      this.showModalTransfert = true;
    },
    loadStation: function loadStation() {
      var _this = this;

      var url = this.domaine + "carteCarburant/station/index";
      this.$http.get(url).then(function (response) {
        _this.listeSociete = response.body.stations;
        //    this.cartes = response.body.stations
        _this.nbCarteCar = response.body.nbCarteCar;
      }, function (error) {
        //this.$message("Chargement de la liste des stations en cours")
      });
    },
    imprimeDemandePDF: function imprimeDemandePDF() {
      var tab = [];
      this.cartes.forEach(function (carte) {
        tab.push(carte.carteId);
      });

      var url = this.domaine + "carteCarburant/imprimerPDF/liste/" + tab;
      window.open(url);
    },
    modalEditCarte: function modalEditCarte(carte) {
      this.carteTransfert = carte;
      this.showModalAjoutCarte = true;
    },
    deleteCarte: function deleteCarte() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "carteCarburant/delete/carte/" + this.carteId;
      this.$http.get(url).then(function (response) {
        _this2.loading = false;

        _this2.$notify({
          title: "SUPPRESSION",
          message: response.body.message,
          type: "success",
          position: "top-center",
          duration: 10000
        });
        _this2.dialogSupr = false;

        _this2.loadCarte();
      }, function (errRep) {
        _this2.loading = false;
        _this2.dialogSupr = false;
        _this2.$notify.error({
          title: "SUPPRESSION ECHOUEE",
          message: "La suppression de la carte a échouée.",
          position: "top-center"
        });
      });
    },
    clearSelect: function clearSelect() {
      this.cartes = this.oldCartes;
    },
    filtrerSociete: function filtrerSociete(idSoc) {
      this.loadCarteParStation(idSoc);
    },
    loadCarteParStation: function loadCarteParStation(idStation) {
      this.cartes = this.oldCartes;

      //this.selectSoc = null;
      this.cartes = this.cartes.filter(function (item) {
        return item.idStation == idStation;
      });
    },
    loadCarte: function loadCarte() {
      var _this3 = this;

      this.loading = true;

      //afficher que les carte que l'utilisateur a creer
      //if(this.droitAcces.liste_demande_fond)

      var url = this.domaine + "carteCarburant/index";

      this.$http.get(url).then(function (response) {
        _this3.loading = false;

        // this.mntTTC =  response.body.mntTTC
        _this3.cartes = response.body.cartes;
        _this3.oldCartes = response.body.cartes;

        _this3.mntTotal = response.body.montantTotalFormat;
        //affichage nombre de demande
        _this3.nbCarte = _this3.cartes.length;
      }, function (response) {
        _this3.loading = false;
        _this3.$message.error("Une erreur est survenue lors du chargement des cartes");
      });
    }
  },

  mounted: function mounted() {
    this.loadCarte();
  }
});

/***/ }),

/***/ "t7st":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Planning_vue__ = __webpack_require__("Agyo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0e0a0f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Planning_vue__ = __webpack_require__("F3kx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Planning_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0e0a0f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Planning_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t9n0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        idEmploye: {
            type: Number
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
    name: "formEditUser",
    data: function data() {
        return {
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            fileLogo: "",
            fileSign: '',
            fileUser: '',
            photo: '',
            listeServices: [],
            items: [{ value: false, photo: '', nom: '', login: '', fonction: '', contact: '48867578', action: '' }],
            menu: false,
            modal: false,
            menu2: false,
            date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
            valid: true,
            selectServiceUser: '',
            logoUser: "/static/avatar-conducteur.png",
            signUser: "/static/signature.jpg",
            listCivilie: [{ text: "Masculin", value: 1 }, { text: 'Feminin', value: 2 }],
            typeUser: [{ text: "Membre de l'entreprise", value: 1 }],
            selectTypeUser: '',
            dialogFormEditUser: false,
            formUserUp: {
                nom: "",
                sexe: "Masculin",
                phone: "",
                genre: '',
                dateNaiss: null,
                civilite: "",
                matricule: "",
                numCnps: "",
                fonction: "",
                adresse: ""
            },
            listeCivilite: [{
                libelle: "Celibataire",
                id: 1
            }, {
                libelle: "Marié",
                id: 2
            }, {
                libelle: "Conjoint de fait",
                id: 3
            }, {
                libelle: "Partenariat domestique",
                id: 4
            }]
        };
    },

    watch: {
        show: function show(newValue, oldValue) {
            if (newValue == true) {
                this.dialogFormEditUser = true;
                this.loadService();
                this.loadInfoEmploye();
            } else {
                this.dialogFormEditUser = false;
            }
        }
    },
    methods: {
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        },

        //enregistrement des images
        onFileImageLogoPicked: function onFileImageLogoPicked(event) {
            var _this = this;

            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }
            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this.logoUser = fileReader.result;
            });
            fileReader.readAsDataURL(files[0]);
            this.logoUser = files[0];
        },
        onFileSignLogoPicked: function onFileSignLogoPicked(event) {
            var _this2 = this;

            var files = event.target.files;
            var filename = files[0].name;
            if (filename.lastIndexOf(".") <= 0) {
                return alert("Veuillez selectionner un  format de fichier valide ");
            }
            var fileReader = new FileReader();
            fileReader.addEventListener("load", function () {
                _this2.signUser = fileReader.result;
            });
            fileReader.readAsDataURL(files[0]);
            this.signUser = files[0];
        },
        loadService: function loadService() {
            var _this3 = this;

            var url = this.domaine + "userCreate/liste/service";
            this.loading = true;
            this.$http.get(url).then(function (resp) {
                _this3.loading = false;
                _this3.listeServices = resp.body.listeServices;
            }, function (error) {
                _this3.loading = false;
                _this3.$message.error("Echec lors du chargement de la liste des services");
            });
        },
        submitForm: function submitForm() {
            var _this4 = this;

            this.loading = true;
            var url = this.domaine + "userCreate/users/" + this.idEmploye + "/update";
            var form = document.getElementById('formUserUp');
            var formdata = new FormData(form);
            formdata.append('type', this.selectTypeUser);
            formdata.append('service', this.selectServiceUser);
            this.$http.post(url, formdata).then(function (resp) {
                _this4.loading = false;
                _this4.successNotif(resp.body.message);
                _this4.closeForm();
            }, function (error) {
                _this4.loading = false;
                _this4.$message.error("Echec lors de l'enregistrement des informations utilisateurs");
            });
        },
        loadInfoEmploye: function loadInfoEmploye() {
            var _this5 = this;

            this.loading = true;
            var url = this.domaine + "userCreate/infoUser/" + this.idEmploye;
            this.$http.get(url).then(function (resp) {
                var infoEmploye = resp.body.employe;
                _this5.formUserUp = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
                    nom: infoEmploye.nom,
                    sexe: infoEmploye.sexe,
                    dateNaiss: infoEmploye.dateNaissanceFormat,
                    phone: infoEmploye.contact,
                    civilite: infoEmploye.idCivilite,
                    matricule: infoEmploye.matricule,
                    numCnps: infoEmploye.matriculeCnps,
                    fonction: infoEmploye.fonction,
                    adresse: infoEmploye.adresse,
                    service: infoEmploye.service
                }, 'numCnps', infoEmploye.matriculeCnps);
                console.log('formUserUp', _this5.formUserUp);
                _this5.selectTypeUser = infoEmploye.service;
                _this5.selectServiceUser = infoEmploye.service;
                _this5.logoUser = infoEmploye.urlAvatar;
                _this5.signUser = infoEmploye.urlSign;
                _this5.loading = false;
            }, function (error) {
                _this5.loading = false;
                _this5.$message.error("Echec lors du chargement des informations utilisateurs");
            });
        },
        closeForm: function closeForm() {
            this.$emit("close");
        }
    }

});

/***/ }),

/***/ "tE4K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");


var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: "AjoutCarteCarburant",
  props: {
    show: {
      type: Boolean,
      required: true
    },
    editCarte: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      // racourcis: [
      //     { path: '/', text: 'Accueil', disabled: false },
      //     { path: '/demandeFond', text: 'Demande de fonds', disabled: true }
      // ],
      dialogAjoutCarteCaburant: false,
      rules: {
        identifiant: [{ required: true, message: "Veuillez saisir" }],
        libelle: [{ required: true, message: "Veuillez saisir" }],
        station: [{ required: true, message: "Veuillez saisir" }],
        zone: [{ required: true, message: "Veuillez saisir" }],
        responsable: [{ required: true, message: "Veuillez saisir" }]
      },
      formCarte: {
        identifiant: "",
        libelle: "",
        montant: "",
        zone: "",
        responsable: "",
        station: "",
        description: ""
      },
      responsables: []
    };
  },


  watch: {
    show: function show(newValue, oldValue) {
      this.dialogAjoutCarteCaburant = newValue;
      if (newValue == true) {
        this.loadResponsable();
      }

      if (this.editCarte.carteId != null) {
        this.formCarte.identifiant = this.editCarte.identifiant;
        this.formCarte.montant = this.editCarte.montant;
        this.formCarte.description = this.editCarte.description;
        this.formCarte.libelle = this.editCarte.libelle;
        this.formCarte.zone = this.editCarte.zone;
        this.formCarte.station = this.editCarte.station;
        this.formCarte.responsable = this.editCarte.responsable;
      } else {
        this.formCarte.identifiant = "";
        this.formCarte.montant = "";
        this.formCarte.description = "";
        this.formCarte.libelle = "";
        this.formCarte.zone = "";
        this.formCarte.station = "";
        this.formCarte.responsable = "";
      }
    }
  },

  methods: (_methods = {
    loadResponsable: function loadResponsable() {
      var _this = this;

      var url = this.domaine + "carteCarburant/user/responsable";
      this.$http.get(url).then(function (response) {
        _this.responsables = response.body;
      }, function (response) {
        _this.$message("Chargement des responsables en cours");
      });
    },
    loadZone: function loadZone(queryString, cb) {
      var _this2 = this;

      var url = this.domaine + "demandeFond/listes-zone";
      var formdata = new FormData();
      formdata.append("user", this.user.id);
      formdata.append("tag", queryString);
      this.$http.post(url, formdata).then(function (response) {
        if (response.body) {
          var links = response.body;
          var results = queryString ? links.filter(_this2.createFilter(queryString)) : links;
          cb(results);
        }
      }, function (response) {});
    },
    createFilter: function createFilter(queryString) {
      return function (link) {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    loadStation: function loadStation(queryString, cb) {
      var _this3 = this;

      var url = this.domaine + "carteCarburant/station/index";
      this.$http.get(url).then(function (response) {
        var links = response.body.stations;
        var results = queryString ? links.filter(_this3.createFilter(queryString)) : links;
        cb(results);
      }, function (error) {
        _this3.$message("Chargement de la liste des stations en cours");
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "createFilter", function createFilter(queryString) {
    return function (link) {
      return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
    };
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "closeDialog", function closeDialog() {
    this.$emit("close");
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "submitForm", function submitForm(formName) {
    var _this4 = this;

    this.$refs[formName].validate(function (valid) {
      if (valid) {
        _this4.loading = true;
        var form = document.getElementById("formCarte");
        //recuperation des demandes
        var data = new FormData(form);
        var url = "";
        if (_this4.editCarte.carteId == null) {
          //creer une nouvelle demande
          url = _this4.domaine + "carteCarburant/new/carte";
        } //modifier une demande de maintenance
        else {
            url = _this4.domaine + "carteCarburant/carte/edit/info";
            data.append("idCarte", _this4.editCarte.carteId);
          }

        data.append("station", _this4.formCarte.station);
        data.append("identifiant", _this4.formCarte.identifiant);
        data.append("libelle", _this4.formCarte.libelle);
        data.append("montant", _this4.formCarte.montant);
        data.append("description", _this4.formCarte.description);
        data.append("zone", _this4.formCarte.zone);
        data.append("responsableId", _this4.formCarte.responsable);
        data.append("userId", _this4.user.id);
        _this4.$http.post(url, data).then(function (response) {
          //reinitialiser le formulaire
          _this4.loading = false;
          _this4.resetForm("formCarte");
          _this4.formCarte.description = "";
          _this4.successNotif(response.body.message);
          _this4.closeDialog();
        }, function (erreur) {
          //reinitialiser le formulaire
          _this4.loading = false;
          _this4.resetForm("formCarte");
          _this4.formDmd.motif = "";
          _this4.closeDialog();
          _this4.$message.error("Une erreur est survenue lors de l'enregistrement de la carte");
        });
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "resetForm", function resetForm(formName) {
    this.$refs[formName].resetFields();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "successNotif", function successNotif() {
    var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

    this.$notify({
      title: "ENREGISTREMENT REUSSI",
      message: mess,
      type: "success",
      position: "top-center",
      duration: 10000
    });
  }), _methods),

  mounted: function mounted() {}
});

/***/ }),

/***/ "tEEj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_user_ModalAttribuerZone__ = __webpack_require__("iA41");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_user_ModalAttribuerEquipe__ = __webpack_require__("7mNl");



var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */], ModalAttribuerZone: __WEBPACK_IMPORTED_MODULE_3__components_user_ModalAttribuerZone__["a" /* default */], ModalAttribuerEquipe: __WEBPACK_IMPORTED_MODULE_4__components_user_ModalAttribuerEquipe__["a" /* default */] },
    name: "Responsable",
    data: function (_data) {
        function data() {
            return _data.apply(this, arguments);
        }

        data.toString = function () {
            return _data.toString();
        };

        return data;
    }(function () {
        var _ref;

        return _ref = {
            //data general
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,

            valid: true,
            items: [{ value: false, photo: '', nom: '', login: '', fonction: '', contact: '48867578', action: '' }],
            headers: [{ text: 'Avarta', align: 'left', sortable: false, value: '' }, { text: 'Nom et prénoms', value: 'a', sortable: true }, { text: 'Login', value: '' }, { text: 'Contact', value: '' }, { text: 'Actions', align: 'center', value: '' }],
            mdpUserConnect: '',
            listService: [],
            dialogSupr: false,
            listeResponsable: [],
            dialogAjoutResponsable: false,
            dialogEdit: false,
            recherche: "",
            itemUser: null,
            disabledBtnZone: false,
            dialogAttribuerEquipe: false,
            menuSele: []
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'listeResponsable', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'menu', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'roles', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'responsable', {}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectTypeUser', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectServiceUser', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'dialogRole', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'role', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'typeUser', [{ text: 'Representant de zone', value: 2 }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mdpUser', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mdpVerUser', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mdpUserConnect', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'serviceUserRules', [function (v) {
            return !!v || 'Veuillez sélectionner votre service.';
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'loginUserRules', [function (v) {
            return !!v || 'Le E-mail est obligatoire';
        }, function (v) {
            return (/^\w+([.-]?\w+)*@\w+([-]?\w+)*(.\w{2,3})+$/.test(v) || 'Vous devez respecter format de E-mail'
            );
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'nomUserRules', [function (v) {
            return !!v || 'Le nom est obligatoire';
        }, function (v) {
            return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mdpUserRules', [function (v) {
            return !!v || 'Le mot de passe est obligatoire';
        }, function (v) {
            return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mdpVerUserRules', [function (v) {
            return !!v || 'La verification du mot de passe est obligatoire. Il doit être identique au mot de pas entré précédenment';
        }, function (v) {
            return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'mdpUserConnectRules', [function (v) {
            return !!v || 'Votre mot de passe est obligatoire pour la confirmation';
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'contactUserRules', [function (v) {
            return !!v || "Le contact de l'utilisateur est obligatoire";
        }, function (v) {
            return (/[0-9]/.test(v) || 'Vous devez respecter format du contact'
            );
        }]), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showModalZone', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'showModalEquipe', false), _ref;
        var generateData2 = function generateData2(_) {
            //const data = [];
            var states = ['California', 'Illinois', 'Maryland', 'Texas', 'Florida', 'Colorado', 'Connecticut '];
            var initials = ['CA', 'IL', 'MD', 'TX', 'FL', 'CO', 'CT'];
            states.forEach(function (city, index) {
                data.push({
                    label: city,
                    key: index,
                    initial: initials[index]
                });
            });
            return data;
        };
        return {
            data2: generateData2(),
            value2: [],
            filterMethod: function filterMethod(query, item) {
                return item.initial.toLowerCase().indexOf(query.toLowerCase()) > -1;
            }
        };
    }),

    methods: (_methods = {
        attribuerEquipe: function attribuerEquipe() {
            this.dialogAttribuerEquipe = true;
        },
        deleteUser: function deleteUser() {
            var _this = this;

            var url = this.domaine + 'userCreate/delete/' + this.idUser;
            this.loading = true;
            this.$http.get(url).then(function (response) {
                _this.loading = false;
                if (response.body) {
                    if (response.body.code === 1) {
                        _this.$notify({
                            title: 'SUPPRESSION',
                            message: 'Utilisateur supprimé avec succès.',
                            type: 'success',
                            position: 'top-center'
                        });
                        _this.dialogSupr = false;

                        _this.loadResponsable();
                    } else {
                        _this.$notify.error({
                            title: 'SUPPRESSION ECHOUE',
                            message: 'La suppression du fournisseur a échoué.',
                            position: 'top-center'
                        });
                    }
                }
            });
        },
        showModalNewUser: function showModalNewUser() {
            this.dialogEdit = false;
            this.dialogAjoutResponsable = true; // afficher le modal ajout utilisateur
        },
        showModalEditUser: function showModalEditUser(editResponsable) {
            this.dialogEdit = true;
            this.responsable = editResponsable;
            this.dialogAjoutResponsable = true;
        },
        editUser: function editUser(ligne) {
            this.dialogEdit = true;
            this.dialogAjout = true;
            this.userCourant = ligne;
            this.nomUser = this.userCourant.nom;
            this.loginUser = this.userCourant.username;
            this.emailUser = this.userCourant.email;
            this.fonctionUser = this.userCourant.fonction;
            this.selectServiceUser = this.userCourant.serviceId;
            this.contactUser = this.userCourant.contact;
            this.selectTypeUser = this.userCourant.type;
            this.selectPosteUser = this.userCourant.poste;
            this.role = ligne.roles;
            this.mdpUserConnect = '';
        },
        clear: function clear() {
            this.$refs.formUser.reset();
            this.dialogAjout = false;
        },
        loadResponsable: function loadResponsable() {
            var _this2 = this;

            var url = this.domaine + 'userCreate/index/representant';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this2.listeResponsable = response.body;
                    if (_this2.listeResponsable === undefined || _this2.listeResponsable.length == 0) {
                        _this2.disabledBtnZone = true;
                    } else {}
                }
            });
        },
        submitUser: function submitUser() {
            var _this3 = this;

            if (this.$refs.formUser.validate()) {
                if (this.responsable.password === this.responsable.confirmePassword) {
                    var form = document.getElementById('formUser');
                    var formdata = new FormData(form);
                    var url = '';
                    if (this.responsable.id) {
                        url = this.domaine + 'userCreate/' + this.responsable.id + '/user/edit';
                        formdata.append('mdpUser', this.mdpUserConnect);
                    } else {
                        url = this.domaine + 'userCreate/new';
                        formdata.append('mdpUser', this.responsable.password);
                        formdata.append('mdpVerUser', this.responsable.confirmePassword);
                    }
                    formdata.append('idUser', this.user.id);
                    formdata.append('serviceUser', this.responsable.serviceId);
                    formdata.append('nomUser', this.responsable.nom);
                    formdata.append('nomEquipe', null);
                    formdata.append('loginUser', this.responsable.login);
                    formdata.append('emailUser', this.responsable.email);
                    formdata.append('contactUser', this.responsable.contact);
                    formdata.append('fonctionUser', this.responsable.fonction);
                    formdata.append('type', this.responsable.type);
                    formdata.append('poste', '');
                    formdata.append('roleUser', this.role);

                    this.loading = true;
                    this.$http.post(url, formdata).then(function (response) {
                        _this3.loading = false;
                        _this3.dialogAjoutResponsable = false;
                        var verif = response.body;
                        if (_this3.responsable.id) {
                            if (verif.code === 1) {
                                _this3.$notify({
                                    title: "L'UTILISATEUR A BIEN ETE MODIFIE",
                                    message: 'Modification effectué avec succès.',
                                    type: 'success',
                                    position: 'top-center'
                                });
                            } else if (verif.code === 2) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 3) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 4) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 5) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 0) {
                                _this3.$message.error(verif.message);
                            }
                        } else {
                            if (verif.code === 1) {
                                _this3.$notify({
                                    title: "L'UTILISATEUR A BIEN ETE AJOUTE",
                                    message: 'Enrégistrement réussie avec succès.',
                                    type: 'success',
                                    position: 'top-center'
                                });
                            } else if (verif.code === 2) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 3) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 4) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 5) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 0) {
                                _this3.$message.error(verif.message);
                            }
                        }
                        _this3.loadResponsable();
                    }, function (response) {
                        _this3.$message.error('Erreur serveur');
                        _this3.loading = false;
                    });
                } else {
                    this.$message.error('Le mot de passe de vérification doit être identique au mot de passe');
                }
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "Utilisateur n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        newRole: function newRole(item) {
            this.responsable = item;
            this.dialogRole = true;
            this.role = item.roles;
            this.menuSele = item.menus;
        },
        loadService: function loadService() {
            var _this4 = this;

            var url = this.domaine + 'webService/liste-service';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this4.listService = response.body.service;
                    _this4.menu = response.body.menu;
                    _this4.roles = response.body.role;
                }
            });
        },


        //attribuer zone
        modalZone: function modalZone(editResponsable) {
            this.responsable = editResponsable;
            this.showModalZone = true;
        }
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_methods, 'newRole', function newRole(item) {
        this.responsable = item;
        this.dialogRole = true;
        this.role = item.roles;
        this.menuSele = item.menus;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_methods, 'submitRole', function submitRole() {
        var _this5 = this;

        this.loading = true;
        if (this.$refs.formRole.validate()) {
            var form = document.getElementById('formRole');
            var data = new FormData(form);
            var url = this.domaine + 'userCreate/' + this.responsable.id + '/role/user';
            data.append('idUser', this.user.id);
            data.append('menuUser', this.menuSele);
            data.append('roleUser', this.role);

            this.$http.post(url, data).then(function (response) {
                if (response.body) {
                    var verif = response.body;
                    if (verif.code === 1) {
                        _this5.$notify({
                            title: "ENREGISTREMENT REUSSI",
                            message: 'Droits enrégistré avec succès.',
                            type: 'success',
                            position: 'top-center'
                        });
                    }

                    _this5.loading = false;
                    _this5.dialogRole = false;

                    _this5.loadResponsable();

                    _this5.$refs.formRole.reset();
                    var menu = verif.menu;
                    var droit = verif.role;
                    sessionStorage.setItem('sessionAcces', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(menu));
                    sessionStorage.setItem('sessionDroit', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(droit));
                    _this5.roleAcces = JSON.parse(sessionStorage.getItem('sessionAcces'));
                    _this5.droitAcces = JSON.parse(sessionStorage.getItem('sessionDroit'));
                } else {
                    _this5.$message.error('Erreur serveur');
                    _this5.loading = false;
                    _this5.dialogRole = false;
                }
            }, function (response) {
                _this5.$message.error('Erreur serveur');
                _this5.loading = false;
            });
        } else {
            this.$notify.error({
                title: "ERREUR D'ENREGISTREMENT",
                message: "Utilisateur n'a pas été enregistré.",
                position: 'top-center'
            });
            this.loading = false;
        }
    }), _methods),
    beforeMount: function beforeMount() {
        if (!this.roleAcces[this.$router.history.current.name]) {
            this.$router.push({ name: 'Home' });
        }
    },
    mounted: function mounted() {
        this.loadService();
        this.loadResponsable();
    }
});

/*export default {
data() {
  }
};*/

/***/ }),

/***/ "tGuE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogDetailCmd),callback:function ($$v) {_vm.dialogDetailCmd=$$v},expression:"dialogDetailCmd"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Detail de la commande analyser par le comparateur ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-3",attrs:{"xs12":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"grey","dark":""}},[_c('v-toolbar-title',[_vm._v("Commande initiale ")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{staticClass:"mb-4"},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total de la commande:\n                      ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("\n                        "+_vm._s(_vm.cmdInit.mntTotalFormat)+" Fcfa\n                      ")])]),_vm._v(" "),_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Référence de la commande:\n                      ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.cmdInit.refCmd))])]),_vm._v(" "),_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Initiateur de la commande:\n                      ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.cmdInit.userCreate))])]),_vm._v(" "),_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Date: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.cmdInit.dateCom))])])],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":_vm.cmdInit.optionCmd}},[_c('el-table-column',{attrs:{"prop":"libelleProd","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteProd","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixU","label":"Prix Unitaire(Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("\n                            "+_vm._s(new Intl.NumberFormat().format(scope.row.prixU)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"Tva %"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotal","label":"Total (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(" "+_vm._s(scope.row.mntTotalFormat))])]}}])})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-4",attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v("Commande(s) suggérée(s) par le comparateur\n                ")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center"},[_c('v-layout',{staticClass:"mb-3",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total economisé:\n                      ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("\n                        "+_vm._s(_vm.cmdInit.beneficeTotalFormat)+" Fcfa\n                      ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v("\n                        "+_vm._s(_vm.nbCmdDerive)+"\n                      ")]),_vm._v("\n                      Commande(s)\n                    ")],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.cmdDerivees),function(cmd){return _c('v-flex',{key:cmd.idCmd,staticClass:"mb-4 pl-3 pt-3 mr-3 elevation-5",attrs:{"xs12":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs6":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Reference de la commande:\n                        ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(cmd.refCmd))])]),_vm._v(" "),_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total de la commande:\n                        ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("\n                          "+_vm._s(cmd.mntTotalFormat)+" Fcfa\n                        ")])]),_vm._v(" "),_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Date: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(cmd.dateCom)+" ")])]),_vm._v(" "),_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Initiateur de la commande:\n                        ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(cmd.userCreate))])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{attrs:{"data":cmd.optionCmd}},[_c('el-table-column',{attrs:{"prop":"libelleProd","label":"Libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteProd","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixU","label":"Prix Unitaire"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("\n                              "+_vm._s(new Intl.NumberFormat().format(
                                  scope.row.prixU
                                )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"Tva"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotal","label":"Total (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(" "+_vm._s(scope.row.mntTotalFormat))])]}}],null,true)})],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)}),1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tJl8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_boardChantier_index_tache_chantier__ = __webpack_require__("q0O9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_boardChantier_RapportJournalier__ = __webpack_require__("uij/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_rapport_ListeRapportTrx__ = __webpack_require__("chSw");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */], IndexTache: __WEBPACK_IMPORTED_MODULE_1__components_boardChantier_index_tache_chantier__["a" /* default */], RapportJournalier: __WEBPACK_IMPORTED_MODULE_2__components_boardChantier_RapportJournalier__["a" /* default */], ListeRapportTrx: __WEBPACK_IMPORTED_MODULE_3__components_rapport_ListeRapportTrx__["a" /* default */] },
  name: "ListeTravaux",
  props: {
    show: {
      type: Boolean
    },
    commis: {
      type: Boolean
    },
    type: {
      type: Number, //0=>chef travaux 1=>chantier//2=>projet
      default: 0
    },
    listeTrx: {
      type: Array
    },
    listeTrxId: {
      type: Array
    },
    periode: {
      type: String,
      default: null
    },
    idChantier: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,

      detailTravaux: {},
      dialogConfirmRefus: false,
      showRapport: false,
      showListeRapport: false,
      dialogListeRapport: false,
      listeRapports: [],
      showDetailTache: false,
      formRefus: {},
      travauxS: "",
      multipleSelection: [],

      //FILTRE
      listeProjet: [],
      projetS: "",
      chantierS: "",
      oldListTravaux: [],
      litesDesTrx: [],
      listeTravaux: [],
      listeChantier: [],
      rptAValid: 0,
      etatRpt: [{
        libelle: "Tous les travaux",
        value: "0"
      }, {
        libelle: "Trx avec rapport à valider",
        value: "1"
      }]
    };
  },

  watch: {
    show: function show(newValue, oldvalue) {
      if (newValue == true) {
        //this.oldListTravaux = this.listeTrx;
      }
    },
    listeTrx: function listeTrx(newValue, oldvalue) {
      this.litesDesTrx = this.listeTrx;
      this.idChant = this.idchantier;
    }
  },

  methods: {
    filtrerTravaux: function filtrerTravaux() {
      var TravauxValeur = this.travauxS;
      if (TravauxValeur == null || TravauxValeur == "undefined" || TravauxValeur == "") {
        var valeur = this.litesDesTrx;
        this.litesDesTrx = valeur;
        return;
      }

      var tab = this.litesDesTrx;
      this.litesDesTrx = this.litesDesTrx.filter(function (item) {
        return item.idTrx == TravauxValeur;
      });

      var tableau = tab.filter(function (item) {
        return item.idTrx == TravauxValeur;
      });
      for (var i = 0; i < tableau.length; ++i) {
        for (var j = i + 1; j < tableau.length; ++j) {
          if (tableau[i].idTache === tableau[j].idTache) {
            tableau.splice(j--, 1);
          }
        }
      }
      this.listeChantier = tableau;
    },
    filtrerChantier: function filtrerChantier() {
      var idChantier = this.chantierS;
      if (idChantier == null || idChantier == "undefined" || idChantier == "") {
        this.filtrerTravaux();
        return;
      }
      var tab = this.litesDesTrx;
      this.idChantier = tab.filter(function (item) {
        return item.idChant == idChantier;
      });
    },
    submitFormStop: function submitFormStop(formName) {
      var _this = this;

      if (this.formRefus.rapport != "undefined" && this.formRefus.rapport != null) {
        this.loading = true;
        var url = this.domaine + "travaux/stop/" + this.detailTravaux.idTrx;
        var data = new FormData();

        data.append("idUser", this.user.id);
        data.append("rapport", this.formRefus.rapport);

        this.$http.post(url, data).then(function (response) {
          //reinitialiser le formulaire
          _this.loading = false;
          _this.dialogConfirmRefus = false;
          _this.formRefus.rapport = "";
          var mess = response.body.message;
          //this.loadTravaux(this.detailChantier);
          _this.$emit("reloadListeTravaux");

          _this.$notify({
            title: "LES TRAVAUX ONT ETE ARRETE",
            message: mess,
            type: "success",
            position: "top-center"
          });
        }, function (erreur) {
          //reinitialiser le formulaire
          _this.formRefus.rapport = "";
          _this.loading = false;
          _this.$message.error("L'opération a echouée");
        });
      } //rapport non saisie
      else {
          this.$message.error("Veuillez remplir correctement les champs svp...");
        }
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    showModalTache: function showModalTache(trx) {
      this.detailTravaux = trx;
      this.showDetailTache = true;
    },
    loadRapportTrx: function loadRapportTrx(trx) {
      var _this2 = this;

      this.detailTravaux = trx;
      this.loading = true;
      var url = void 0;
      if (this.commis) {
        url = this.domaine + "journal/travaux/" + this.detailTravaux.idTrx + "?idUser=" + this.user.id;
      } else {
        url = this.domaine + "journal/travaux/" + this.detailTravaux.idTrx;
      }
      this.$http.get(url).then(function (response) {
        _this2.listeRapports = response.body.journaux;
        _this2.dialogListeRapport = true;
        _this2.type = 1;
        _this2.loading = false;
      }, function (error) {
        _this2.loading = false;
        _this2.$message.error("Echec lors du chargement des Journaux");
      });
    },

    //FILTRE
    loadProjet: function loadProjet() {
      var _this3 = this;

      this.listeChantier.splice(0);
      this.chantierS = null;
      var url = this.domaine + "projet/index/projet/all";

      this.loading = true;
      this.$http.get(url).then(function (response) {
        _this3.loading = false;
        _this3.listeProjet = response.body.projet;
      }, function (errRep) {
        _this3.loading = false;
        _this3.$message.error("Une erreur est survenue lors du chargement de la liste des projets");
      });
    },
    loadChantier: function loadChantier() {
      var _this4 = this;

      if (this.projetS == null || this.projetS == "undefined" || this.projetS == "") {
        this.litesDesTrx = this.listeTrx;
        return;
      }
      this.loading = true;
      var url = this.domaine + "projet/" + this.projetS + "/index/chantier";
      this.$http.get(url).then(function (response) {
        _this4.loading = false;
        _this4.listeChantier = response.body.chantier;
      }, function (errRep) {
        _this4.loading = false;
        _this4.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.disabledBtnValide = true;
      } else {
        this.disabledBtnValide = false;
      }
    },
    clearSelect: function clearSelect() {
      //this.listeTrx = this.oldListTravaux;
      this.projetS = "";
      this.chantierS = "";
      this.listeChantier.splice(0);
    },
    imprimeAllTravaux: function imprimeAllTravaux() {
      var url = this.domaine + "travaux/impression/listeTravaux/chantier/" + this.idChantier + "/" + this.user.id;
      window.open(url);
    }
  },
  mounted: function mounted() {
    this.loadChantier();
    this.clearSelect();
  }
});

/***/ }),

/***/ "tLfa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tMzy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tTNa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutTransfertCarte_vue__ = __webpack_require__("TqBL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66f087ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutTransfertCarte_vue__ = __webpack_require__("s2TK");
function injectStyle (ssrContext) {
  __webpack_require__("JEO5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66f087ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutTransfertCarte_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66f087ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutTransfertCarte_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tUpR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":true,"width":"80%","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogConstat),callback:function ($$v) {_vm.dialogConstat=$$v},expression:"dialogConstat"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[(!_vm.validConstat)?_c('v-toolbar-title',[_vm._v("Effectuer le constat pour la demande de maintenance DMD-"+_vm._s(_vm.demandeDetail.ref))]):_c('v-toolbar-title',[_vm._v("Valider le constat pour la demande de maintenance DMD-"+_vm._s(_vm.demandeDetail.ref))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[(!_vm.validConstat)?_c('v-alert',{staticClass:"mb-4",attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                Telecharger des images pour le constat\n                            ")]):_c('v-alert',{staticClass:"mb-4",attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                Rapport effectue\n                            ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{ref:"formRapport1",staticStyle:{"width":"100%"},attrs:{"disabled":_vm.validConstat,"id":"formRapport1","model":_vm.formRapport}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(!_vm.validConstat),expression:"!validConstat"}],staticClass:"mr-2",attrs:{"xs2":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.image1,"alt":"avatar"}})]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('input',{ref:"file1",staticStyle:{"display":"none"},attrs:{"name":"image1","type":"file","accept":"image/*"},on:{"change":_vm.onFileImage1Picked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.file1.click()}}},[_vm._v("Photo  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('div',{staticClass:"font-weight-thin"},[_vm._v("Fichier au format (JPEG,PNG,PDF) avec une taille de 1048 ko maximale")])],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.validConstat),expression:"validConstat"}],staticClass:"mr-3",attrs:{"xs3":""}},[_c('a',{attrs:{"href":_vm.demandeDetail.imageConst1,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.demandeDetail.imageConst1}})])],1)])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Rapport de constat"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.validConstat,"type":"textarea","rows":6,"placeholder":"Rapport sur le constat"},model:{value:(_vm.formRapport.rapport),callback:function ($$v) {_vm.$set(_vm.formRapport, "rapport", $$v)},expression:"formRapport.rapport"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                                        Besoins materiels\n                                    ")])],1),_vm._v(" "),_c('el-form',{ref:"refFormProduit",staticClass:"demo-form-inline",attrs:{"disabled":_vm.validConstat,"id":"formProduit","rules":_vm.ruleFormProduit,"label-position":"top","inline":true,"model":_vm.formProduit}},[_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(!_vm.validConstat),expression:"!validConstat"}],attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{attrs:{"label":"Designation","prop":"designation"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.validConstat,"filterable":"","placeholder":"Select"},on:{"change":function($event){return _vm.handleChangePrix()}},model:{value:(_vm.formProduit.idProd),callback:function ($$v) {_vm.$set(_vm.formProduit, "idProd", $$v)},expression:"formProduit.idProd"}},_vm._l((_vm.listeProduit),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{attrs:{"label":"Quantite","prop":"quantite"}},[_c('el-input-number',{attrs:{"disabled":_vm.validConstat,"min":1,"size":"large","controls-position":"right","placeholder":"quantite"},model:{value:(_vm.formProduit.quantite),callback:function ($$v) {_vm.$set(_vm.formProduit, "quantite", $$v)},expression:"formProduit.quantite"}})],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"md3":""}},[_c('el-form-item',{attrs:{"label":"Prix Unitaire(FCFA)","prop":"prixU"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":0,"disabled":"","size":"large","controls-position":"right","placeholder":"prix unitaire(HT)"},model:{value:(_vm.formProduit.prixUnit),callback:function ($$v) {_vm.$set(_vm.formProduit, "prixUnit", $$v)},expression:"formProduit.prixUnit"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{attrs:{"label":"Unite","prop":"unite"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"size":"large","disabled":"","value":"pcs","placeholder":""},model:{value:(_vm.formProduit.unite),callback:function ($$v) {_vm.$set(_vm.formProduit, "unite", $$v)},expression:"formProduit.unite"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{attrs:{"label":"    "}},[_c('el-button',{attrs:{"disabled":_vm.validConstat,"type":"primary"},on:{"click":function($event){return _vm.addListProduit('refFormProduit',_vm.formProduit)}}},[_vm._v("Ajouter")])],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-chip',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (TTC): "+_vm._s(_vm.totalTTC)+" fcfa")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableProduit,"disabled":_vm.validConstat}},[_c('el-table-column',{attrs:{"prop":"designation","label":"Designation","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantite","label":"Quantite"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"unite"}}),_vm._v(" "),(!_vm.validConstat)?_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","disabled":_vm.validConstat,"fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableProduit)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                                                Supprimer ce produit\n                                                            ")],1)]}}],null,false,2072540926)}):_vm._e()],1)],1),_vm._v(" "),_c('br')],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}},[(!_vm.validConstat)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitForm()}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1):_vm._e(),_vm._v(" "),(this.demandeDetail.etatDmd == 4)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){_vm.dialogConfirm = true}}},[_vm._v("Confirmer de la Validation"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1):_vm._e()],1),_vm._v(" "),(this.demandeDetail.etatDmd == 3)?_c('v-layout',{staticClass:"text-xs-right"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"icons":"","dark":"","color":"red"},on:{"click":function($event){_vm.dialogConfirmRefus = true}}},[_vm._v("Refuser"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){_vm.dialogConfirm = true}}},[_vm._v("Valider"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation du devis pour une demande de maintenance")]),_vm._v(" "),_c('v-card-text',[_vm._v("Voulez vous valider le devis ?")]),_vm._v(" "),_c('v-flex',{staticClass:"mb-2 ml-1 mr-1",attrs:{"xs12":""}},[(_vm.demandeDetail.entrepot == null)?_c('el-alert',{attrs:{"title":"Aucun entrepot défini dans la zone ","description":'Pour générer un bon de sortie vous devez définir un entrepot pour la zone '+_vm.demandeDetail.libZone,"closable":false,"show-icon":"","type":"warning"}}):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialogConfirm = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){return _vm.SubmitValideDevis()}}},[_vm._v("Confirmer")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.dialogConfirmRefus),callback:function ($$v) {_vm.dialogConfirmRefus=$$v},expression:"dialogConfirmRefus"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation du devis pour une demande de maintenance")]),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"refFormRefust",staticClass:"demo-form-inline",attrs:{"disabled":_vm.validConstat,"id":"formRefus","rules":_vm.ruleFormRefus,"label-position":"top","inline":true,"model":_vm.formRefus}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Voulez vous Refuser ce devis ?","prop":"rapportRefus"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Pourquoi voulez-vous refuser ?"},model:{value:(_vm.formRefus.rapport),callback:function ($$v) {_vm.$set(_vm.formRefus, "rapport", $$v)},expression:"formRefus.rapport"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialogConfirmRefus = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){return _vm.SubmitRefusDevis()}}},[_vm._v("Confirmer")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tbFU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ti83":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tlJT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_divers_loadTypeTravaux_vue__ = __webpack_require__("iQMl");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "formTypeTravaux",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */], LoadTypeTravauxExcel: __WEBPACK_IMPORTED_MODULE_2__components_divers_loadTypeTravaux_vue__["a" /* default */] },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    listeLotTravaux: {
      type: Array,
      default: new Array()
    },
    idTypeProjet: {
      type: Number,
      default: null
    },
    etatTache: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      loading: false,
      dialogAjoutTravaux: false,
      listeLots: [],
      formLotTravaux: {
        idTypeTrx: null,
        ordre: "",
        libelle: "",
        code: "",
        description: ""
      },
      rulesLotTravaux: {
        ordre: [{
          required: true,
          message: "Veuillez selectionnez un numéro d'ordre",
          trigger: "blur"
        }],
        libelle: [{
          required: true,
          message: "Veuillez  saisir un type de travaux",
          trigger: "blur"
        }],
        code: [{
          required: true,
          message: "Veuillez  saisir un code",
          trigger: "blur"
        }]
      },
      numOrdre: [],
      numOrdreCopie: [],
      listeTrxSupp: [],
      showModalLoadTypeTravaux: false,

      //Importer fichier excel
      fileExcel: [],
      lstTypeTravaux: []
    };
  },

  watch: {
    show: function show(newValue, oldValue) {
      var _this = this;

      if (newValue == true) {
        this.listeLots.splice(0);
        this.numOrdre.splice(0);
        this.dialogAjoutTravaux = true;
        this.listeTrxSupp = [];
        this.numOrdre.push({ num: 1 });
        if (this.listeLotTravaux.length > 0) {
          this.numOrdre.splice(0);
          //rechechons lordre le plus eleve
          var ordreSup = null;
          this.listeLotTravaux.forEach(function (elt, ind) {
            if (ind + 1 < _this.listeLotTravaux.length) {
              var prochainOrdre = _this.listeLotTravaux[ind + 1].ordre;
              if (prochainOrdre > elt.ordre) {
                ordreSup = prochainOrdre;
              } else {
                ordreSup = elt.ordre;
              }
            }
          });

          this.listeLots = this.listeLotTravaux.slice();

          this.numOrdreCopie.splice(0);
          var nbLots = this.listeLotTravaux.length;
          this.numOrdre.push({ num: ordreSup + 1 });

          if (this.listeLotTravaux.length == 1) {
            this.numOrdre.push({ num: 2 });
          }

          for (var i = 0; i <= nbLots; i++) {
            this.numOrdreCopie.push({ num: i + 1 });
          }
        }
      } else {
        this.dialogAjoutTravaux = false;
        this.listeTrxSupp = [];
      }
    }
  },
  computed: {
    listeNumber: function listeNumber() {
      var _this2 = this;

      var listeNum = this.numOrdreCopie.slice();
      return listeNum.filter(function (elt) {
        if (elt.num <= _this2.listeLots.length) {
          return elt;
        }
      });
    }
  },
  methods: {
    changeOrdre: function changeOrdre(value, ind) {},
    submitTravaux: function submitTravaux() {
      var _this3 = this;

      if (this.idTypeProjet == null) {
        this.$message.error("Aucun type de projet selectionné");
        return;
      }
      this.loading = true;
      var url = this.domaine + "projet/new/travaux/projet";
      //recuperer les lots de travaux par groupe de 10
      var nbData = 10;
      var nbReq = 1;
      var ligne = null;

      var nbRest = void 0;
      if (this.listeLots.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.listeLots.length / nbData);
        nbRest = this.listeLots.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (var i = 0; i < nbReq; i++) {
        var initJ = i * nbData;
        var finJ = (i + 1) * nbData;
        var dataLot = [];
        if (this.listeLots.length > 0) {
          for (var j = initJ; j < finJ; j++) {
            if (this.listeLots[j] == undefined) {
              break;
            }
            dataLot.push(this.listeLots[j]);
          }
        }
        var data = new FormData();

        for (var prop in dataLot) {
          ligne = dataLot[prop];
          data.append("option[ordre][]", ligne.ordre);
          data.append("option[libelle][]", ligne.libelle);
          data.append("option[code][]", ligne.code);
          data.append("option[description][]", ligne.description);
        }

        // data.append('listeTypeTravaux', JSON.stringify(dataLot))
        data.append("type", this.idTypeProjet);
        data.append("idUser", this.user.id);
        data.append("listeSupp", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.listeTrxSupp));

        this.$http.post(url, data).then(function (resp) {
          _this3.loading = false;
          // succesEnreg = true;
          if (resp.body.code == 1) {
            _this3.$notify({
              title: "Enregistrement",
              message: resp.body.message,
              duration: 7000,
              type: "success"
            });
          }

          if (resp.body.code == 2) {
            _this3.$notify({
              title: "Suppression",
              message: resp.body.message,
              duration: 7000,
              type: "warning"
            });
          }
        }, function (error) {
          _this3.loading = false;
          _this3.$message.error("Erreur lors de l'enregistrement des lots");
        });
      }
      this.$emit("close");
    },
    closeForm: function closeForm() {
      this.$emit("close");
      this.resetForm();
    },
    deleteRow: function deleteRow(index, rows) {
      var ordreIndex = this.listeLots[index].ordre;
      var indexpos = this.numOrdre.findIndex(function (elt) {
        return elt.num > ordreIndex;
      });
      var indexposCopie = this.numOrdreCopie.findIndex(function (elt) {
        return elt.num == ordreIndex;
      });

      this.numOrdre.splice(indexpos, 0, { num: ordreIndex });
      this.numOrdreCopie.splice(indexposCopie, 1);

      //enregistrer lid du lot de travaux supprimer dans la liste
      if (this.listeLots[index].idTypeTrx != null) {
        this.listeTrxSupp.push(this.listeLots[index].idTypeTrx);
      }

      rows.splice(index, 1);
      if (this.listeLots.length <= 0) {
        this.numOrdre.splice(0);
        this.numOrdreCopie.splice(0);

        this.numOrdre.push({ num: 1 });
        this.numOrdreCopie.push({ num: 1 });
      }
    },
    addListeTypeTravaux: function addListeTypeTravaux() {
      var _this4 = this;

      this.$refs["formLotTravaux"].validate(function (valid) {
        if (valid) {
          var lenListelot = _this4.listeLots.length;
          var indiceInsert = _this4.formLotTravaux.ordre - 1;
          _this4.listeLots.splice(indiceInsert, 0, {
            idTypeTrx: _this4.formLotTravaux.idTypeTrx,
            libelle: _this4.formLotTravaux.libelle,
            code: _this4.formLotTravaux.code,
            ordre: _this4.formLotTravaux.ordre,
            description: _this4.formLotTravaux.description
          });

          var index = _this4.numOrdre.findIndex(function (elt) {
            return elt.num == _this4.formLotTravaux.ordre;
          });

          var dernierChif = _this4.numOrdre[_this4.numOrdre.length - 1].num;

          _this4.numOrdre.splice(index, 1);

          _this4.numOrdre.push({ num: dernierChif + 1 });
          _this4.resetForm();
        }
      });
    },
    handleChangeLibelle: function handleChangeLibelle(newValue, oldValue) {
      if (newValue = "") {
        // this.$message({
        //     message: 'Ce champ ne peut etre vide',
        //     type: 'warning'
        // });
      }
    },
    handleFileExcel: function handleFileExcel(command //0=>Importer,1=>generer
    ) {
      switch (command) {
        case "0":
          //importer un fichier
          this.$refs.fileInputExcel.click();
          break;
        case "1":
          //generer un modele un fichier
          this.generateFileExcel();
          break;
      }
    },
    generateFileExcel: function generateFileExcel() {
      var url = this.domaine + "projet/generer/modele/travaux/projet";
      window.open(url);
    },
    onFileExcelPicked: function onFileExcelPicked(event) {
      var _this5 = this;

      this.loading = true;
      this.fileExcel.splice(0, 1);
      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".xls") <= 0) {
        return alert("Veuillez selectionner un fichier excel valide ");
      }
      if (files[0].size > 1048576) {
        this.$message.error("La taille du fichier est supérieur à 1024 ko");
        return;
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this5.fileExcel.push(fileReader.result);
      });

      fileReader.readAsDataURL(files[0]);

      var url = this.domaine + "travaux/load_typeTravaux/excel";
      var data = new FormData();
      //emvoie du fichier

      data.append("fichierExcel", files[0], files[0][name]);
      this.$http.post(url, data).then(function (resp) {
        _this5.loading = false;

        _this5.$notify({
          title: "Chargement liste type travaux",
          message: "Chargement effectué",
          type: "success",
          position: "top-right",
          duration: 7000
        });
        _this5.listeLots = resp.body.listeTypeTravaux;
        // this.showModalLoadTypeTravaux = true;
      }, function (resp) {
        _this5.loading = false;
        _this5.$message.error("Erreur lors de l'importation du fichier");
      });
    },
    resetForm: function resetForm() {
      this.$refs["formLotTravaux"].resetFields();
      this.formLotTravaux.libelle = "";
      this.formLotTravaux.code = "";
      this.formLotTravaux.description = "";
      this.listeTrxSupp.splice(0);
    }
  }
});

/***/ }),

/***/ "toja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liste_projet_vue__ = __webpack_require__("9zqR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76016d9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liste_projet_vue__ = __webpack_require__("NhX3");
function injectStyle (ssrContext) {
  __webpack_require__("9Voz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liste_projet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76016d9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liste_projet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ttRm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff","margin":"10px"}},[_c('v-card-title',[_c('v-flex',{staticClass:"sousTraitInfo mb-2 pb-2",attrs:{"md12":""}},[_vm._v("\n            INFORMATION DE LA DEMANDE\n          ")]),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_vm._v("\n            Référence : "),_c('v-chip',{attrs:{"color":"primary","label":"","text-color":"white"}},[_vm._v(" DEMD-"+_vm._s(_vm.id_dmd))])],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_vm._v("\n            Motif : "+_vm._s(_vm.detailDemande.motif)+"\n          ")]),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_vm._v("\n            Demandeur : "),_c('v-chip',{attrs:{"outline":"","color":"primary","label":"","text-color":"primary"}},[_vm._v(_vm._s(_vm.detailDemande.dmdeur))])],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_vm._v("\n            Etat de la demande : "),_c('v-chip',{attrs:{"color":_vm.detailDemande.type,"label":"","text-color":"white"}},[_vm._v(" "+_vm._s(_vm.detailDemande.etat_dmd))])],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_vm._v("\n            Date de la demande : "+_vm._s(_vm.detailDemande.date_dmd)+"\n          ")]),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_vm._v("\n            Lieu concerné par la demande : \n            "),_c('p',[_vm._v(_vm._s(_vm.detailDemande.zone))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.detailDemande.zone1))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.detailDemande.zone2))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.detailDemande.zone3))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.detailDemande.zone4))]),_vm._v(" "),_c('v-chip',{attrs:{"color":"orange","icon":"","label":"","text-color":"white"}},[_vm._v(" \n              "+_vm._s(_vm.detailDemande.lieu)),_c('v-icon',[_vm._v("location_on")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_vm._v("\n            Date d'enrégistrement : "+_vm._s(_vm.detailDemande.created)+"\n          ")]),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_vm._v("\n            Date de modification : "+_vm._s(_vm.detailDemande.modified)+"\n          ")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md9":""}},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff","margin":"10px"}},[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n          LISTE DES CONSTATS EFFECTUES\n        ")]),_vm._v(" "),(_vm.listConstat.length === 0)?_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newConstat($event)}},slot:"activator"},[_vm._v("Ajouter\n              "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v("Ajouter un nouveau constat")])],1)],1):_vm._e(),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers_constat,"items":_vm.listConstat,"search":_vm.search_constat,"no-data-text":"Aucune données","rows-per-page-text":"Ligne(s) par page"},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v(" "+_vm._s(props.header.text)+" ")]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(props.header.text)+" ")])])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                "+_vm._s(props.item.ref)+" \n              ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                "+_vm._s(props.item.superviseur)+" \n              ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[(props.item.etat === 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                EN ATTENTE DE TRAITEMENT\n              ")]):_vm._e(),_vm._v(" "),(props.item.etat === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                VALIDER\n              ")]):_vm._e(),_vm._v(" "),(props.item.etat === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                REFUSE\n              ")]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                "+_vm._s(props.item.categorie)+" \n              ")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showConstat(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                Détails\n              ")],1),_vm._v(" "),(props.item.etat === 0)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.editConstat(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                Modifier\n              ")],1):_vm._e(),_vm._v(" "),(props.item.etat === 0)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.newValidation(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("done_all")])],1),_vm._v("\n                Valider\n              ")],1):_vm._e(),_vm._v(" "),(props.item.etat === 0)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSupr = true; _vm.idConst = props.item.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                Supprimer\n              ")],1):_vm._e()],1)]}},{key:"pageText",fn:function(ref){
var pageStart = ref.pageStart;
var pageStop = ref.pageStop;
return [_vm._v("\n            Ligne "+_vm._s(pageStart)+" à "+_vm._s(pageStop)+"\n          ")]}}])})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShow),callback:function ($$v) {_vm.dialogShow=$$v},expression:"dialogShow"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du constat "+_vm._s(_vm.detailConstat.ref))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShow = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.detailConstat.ref)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Superviseur : ")]),_vm._v(" "+_vm._s(_vm.detailConstat.superviseur)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Prestataire : ")]),_vm._v(" "+_vm._s(_vm.detailConstat.prestataire)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Catégorie : ")]),_vm._v(" "+_vm._s(_vm.detailConstat.categorie)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),(_vm.detailConstat.etat === 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            EN ATTENTE DE TRAITEMENT\n                          ")]):_vm._e(),_vm._v(" "),(_vm.detailConstat.etat === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                            VALIDER\n                          ")]):_vm._e(),_vm._v(" "),(_vm.detailConstat.etat === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                            REFUSE\n                          ")]):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[(_vm.detailConstat.etat === 1)?_c('p',[_c('b',[_vm._v("Motif de validation : ")]),_vm._v(" "+_vm._s(_vm.detailConstat.descriptionValide)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailConstat.etat === 2)?_c('p',[_c('b',[_vm._v("Motif de réfus : ")]),_vm._v(" "+_vm._s(_vm.detailConstat.descriptionValide)+" ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Description: ")]),_vm._v(" "+_vm._s(_vm.detailConstat.description)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enrégistrement : ")]),_vm._v(" "+_vm._s(_vm.detailConstat.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailConstat.modified)+" ")])])],1)],1)])])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShow = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n          Fermer\n        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.detailConstat.etat === 0)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editConstat(_vm.detailConstat)}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n          Modifier\n        ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","persistent":""},model:{value:(_vm.dialogAjoutCst),callback:function ($$v) {_vm.dialogAjoutCst=$$v},expression:"dialogAjoutCst"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v(" Ajouter un nouveau constat\n          "),_c('h6',{staticClass:"caption"},[_vm._v("Yamoussoukro / zone ouest")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutCst = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-form',{ref:"formConstat",attrs:{"lazy-validation":"","id":"formConstat"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                Ajout d'un nouveau constat\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-text-field',{attrs:{"label":"Prestataire","name":"prestataire","disabled":""},model:{value:(_vm.listParam.nomPrestataire),callback:function ($$v) {_vm.$set(_vm.listParam, "nomPrestataire", $$v)},expression:"listParam.nomPrestataire"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-select',{attrs:{"label":"Superviseur","name":"superviseur","items":_vm.users,"item-value":"id","item-text":"nom","rules":[function (v) { return !!v || 'Veuillez sélectionner le superviseur'; }],"required":"","autocomplete":""},model:{value:(_vm.constat.nomPrenSuperv),callback:function ($$v) {_vm.$set(_vm.constat, "nomPrenSuperv", $$v)},expression:"constat.nomPrenSuperv"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-select',{attrs:{"label":"Catégorie","items":_vm.listCategorie,"item-value":"idCat","item-text":"libelCat","rules":[function (v) { return !!v || 'Veuillez selectionner une categorie'; }],"required":"","autocomplete":""},model:{value:(_vm.constat.selectCat),callback:function ($$v) {_vm.$set(_vm.constat, "selectCat", $$v)},expression:"constat.selectCat"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-text-field',{attrs:{"label":"Remarque","name":"descRmq","multi-line":"","rows":"3"},model:{value:(_vm.constat.descRmq),callback:function ($$v) {_vm.$set(_vm.constat, "descRmq", $$v)},expression:"constat.descRmq"}})],1)],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                JOINDRE DES FICHIERS\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticStyle:{"margin-bottom":"5px"}},[_vm._v("Documents joints (images)")]),_vm._v(" "),_c('el-upload',{attrs:{"action":_vm.constat.fichier.url,"list-type":"picture-card","on-preview":_vm.handlePictureCardPreview,"auto-upload":false,"multiple":"","name":"photo[]","on-remove":_vm.handleRemove}},[_c('i',{staticClass:"el-icon-plus"})]),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"size":"tiny"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('img',{attrs:{"width":"100%","src":_vm.dialogImageUrl,"alt":""}})])],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutCst = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submit}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","persistent":""},model:{value:(_vm.dialogAjoutValid),callback:function ($$v) {_vm.dialogAjoutValid=$$v},expression:"dialogAjoutValid"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"green"}},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v(" Valider le constat de la demande DEMD-"+_vm._s(_vm.id_dmd)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutValid = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enrégistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('v-form',{ref:"formValidation",attrs:{"lazy-validation":"","id":"formValidation"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                Validation du constat DEMD-"+_vm._s(_vm.id_dmd)+" - "+_vm._s(_vm.detailDemande.motif)+"\n              ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-select',{attrs:{"label":"Catégorie","items":_vm.validation,"item-value":"value","rules":[function (v) { return !!v || 'Veuillez sélectionner votre réponse'; }],"required":""},model:{value:(_vm.slectValidation),callback:function ($$v) {_vm.slectValidation=$$v},expression:"slectValidation"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-text-field',{attrs:{"label":"Remarque","name":"description","multi-line":"","rows":"3"},model:{value:(_vm.descriptionValid),callback:function ($$v) {_vm.descriptionValid=$$v},expression:"descriptionValid"}})],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutValid = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submitValider}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer cet enrégistrement ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteConst($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tvP0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvuD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intervention_index_vue__ = __webpack_require__("G9KA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56581ea6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intervention_index_vue__ = __webpack_require__("GBiN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intervention_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56581ea6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intervention_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tyEA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v(_vm._s(item.text)+"\n                ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-center",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h3',[_vm._v("Champs de recherche")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('v-layout',{staticClass:"mb-4 mt-2",attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('el-form',{ref:"formSearch",staticClass:"demo-form-inline",attrs:{"id":"formSearch","model":_vm.formSearch,"rules":_vm.rulesForm,"inline":true}},[_c('el-form-item',{attrs:{"label":"Projet","prop":"projet"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"projet","placeholder":"projet"},on:{"change":_vm.selectProjet},model:{value:(_vm.formSearch.projet),callback:function ($$v) {_vm.$set(_vm.formSearch, "projet", $$v)},expression:"formSearch.projet"}},_vm._l((_vm.listeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Chantier","prop":"chantier"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","name":"chantier","placeholder":"chantier"},model:{value:(_vm.formSearch.chantier),callback:function ($$v) {_vm.$set(_vm.formSearch, "chantier", $$v)},expression:"formSearch.chantier"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":" "}},[_c('el-button',{attrs:{"type":"primary","disabled":_vm.disableBtnRecherche},on:{"click":function($event){$event.stopPropagation();return _vm.loadBilan()}}},[_vm._v("Rechercher\n                                        ")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"elevation-3 pt-2 pl-2 pr-2",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h3',[_vm._v("Informations générales")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-4"}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs4":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Projet")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right  title",attrs:{"xs9":""}},[_vm._v(_vm._s(_vm.info.libelleProjet))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Type de projet")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[_vm._v(_vm._s(_vm.info.typeProjet))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[_vm._v(_vm._s(_vm.info.libelleChant))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Responsable")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[_vm._v(_vm._s(_vm.info.libelleResponsable)+"\n                                            ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Date début")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[_vm._v(_vm._s(_vm.info.dateDbt))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Date fin")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[_vm._v(_vm._s(_vm.info.dateFin))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_vm._v("Situation géographique")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs8":""}},[_vm._v(_vm._s(_vm.info.situation))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Date enregistrement")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[_vm._v(_vm._s(_vm.info.enregistre))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs3":""}},[_c('v-progress-circular',{attrs:{"size":150,"width":15,"rotate":360,"value":_vm.info.evolution,"color":"orange"}},[_vm._v(_vm._s(parseFloat(_vm.info.evolution).toFixed(2))+" %\n                                        ")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mt-4",attrs:{"xs12":""}},[_c('h3',[_vm._v("Résultat compte d'exploitation")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('el-tabs',{attrs:{"stretch":true,"type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick(_vm.compte)}},model:{value:(_vm.compte),callback:function ($$v) {_vm.compte=$$v},expression:"compte"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',[_vm._v("account_balance")]),_vm._v(" Recapitulatif annuel")],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-flex',[_c('el-popover',{ref:"popChantier",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin":"0"},attrs:{"align":"center"}},[_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifAnnuelSimpl('PDF')}}},[_vm._v("PDF SIMPLE")])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifAnnuel('PDF')}}},[_vm._v("PDF DETAILLE")])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifAnnuelSimpl('EXC')}}},[_vm._v("EXC ")])],1)])]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popChantier",arg:"popChantier"}],attrs:{"type":"warning","disabled":_vm.disabledBtnPop,"icon":"el-icon-printer"}},[_vm._v("Rapport")])],1)],1)],1),_vm._v(" "),_c('el-collapse',{attrs:{"accordion":""}},_vm._l((_vm.bilanMensuel),function(groupeMois,index){return _c('v-layout',{key:index,staticClass:"text-xs-center",attrs:{"wrap":""}},[_c('div',{staticStyle:{"width":"100%"}},[_c('el-collapse-item',{staticClass:" mb-1 pl-3 pr-3",staticStyle:{"width":"100%"},attrs:{"name":index}},[_c('template',{slot:"title"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-sm-left",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"dark":"","label":"","text-color":"white","color":"purple"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v("\n                                                                        "+_vm._s(index)+"\n                                                                    ")],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-sm-left",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL MONTANT\n                                                                        MARCHE: "+_vm._s(new
                                                                        Intl.NumberFormat().format(groupeMois.totalMntPrevu))+" ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-sm-left",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("TOTAL MONTANT\n                                                                        ENGAGÉ: "+_vm._s(new
                                                                        Intl.NumberFormat().format(groupeMois.totalMntDecaisse))+" ")])])],1)],1)],1),_vm._v(" "),_vm._l((groupeMois.mois),function(travaux,mois){return _c('v-flex',{key:mois,staticClass:"mt-3",attrs:{"xs12":""}},[_c('span',{staticClass:"blue--text",staticStyle:{"font-size":"20px"}},[_vm._v(" "+_vm._s(mois)+"-"+_vm._s(index))]),_vm._v(" "),_c('el-table',{staticClass:"elevation-1",staticStyle:{"width":"100%"},attrs:{"data":travaux,"highlight-current-row":"","header-row-style":_vm.headerRowStyle,"border":"","summary-method":_vm.getSummaries,"show-summary":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',{staticClass:"elevation-3 pl-4 pr-4 pt-2"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple mb-2"},[_c('v-alert',{staticClass:"mb-4",attrs:{"value":true,"outline":"","color":"primary","icon":"info"}},[_vm._v("Liste des tâches\n                                                                                    ")]),_vm._v(" "),_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":props.row.taches,"summary-method":_vm.getSummaries,"show-summary":""}},[_c('el-table-column',{attrs:{"align":"center","prop":"libelle","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"unite","label":"UNITE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"prixU","label":"PRIX UNITAIRE"},scopedSlots:_vm._u([{key:"default",fn:function(prop1){return [_vm._v(_vm._s(new
                                                                                                    Intl.NumberFormat().format(prop1.row.prixU))+"\n                                                                                                ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"qtePrevu","label":"QUANTITE PREVUE"},scopedSlots:_vm._u([{key:"default",fn:function(prop2){return [_vm._v(_vm._s(new
                                                                                                    Intl.NumberFormat().format(prop2.row.qtePrevu))+"\n                                                                                                ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"qteRealise","label":"QUANTITE REALISEE"},scopedSlots:_vm._u([{key:"default",fn:function(prop3){return [_vm._v(_vm._s(new
                                                                                                    Intl.NumberFormat().format(prop3.row.qteRealise))+"\n                                                                                                ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"mntPrevu","label":"MONTANT MARCHE"},scopedSlots:_vm._u([{key:"default",fn:function(prop4){return [_vm._v(_vm._s(new
                                                                                                    Intl.NumberFormat().format(prop4.row.mntPrevu))+"\n                                                                                                ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"mntRealise","label":"VALEUR REALISE"},scopedSlots:_vm._u([{key:"default",fn:function(prop5){return [_vm._v(_vm._s(new
                                                                                                    Intl.NumberFormat().format(prop5.row.mntRealise))+"\n                                                                                                ")]}}],null,true)})],1)],1)],1)])],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","align":"center","label":"Travaux"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantPrevu","align":"center","label":"Montant prévu"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v(_vm._s(new
                                                                        Intl.NumberFormat().format(prop.row.montantPrevu))+"\n                                                                    ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantRealise","align":"center","label":"Valeur réalisé"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v(_vm._s(new
                                                                        Intl.NumberFormat().format(prop.row.montantRealise))+"\n                                                                    ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"montantDecaisse","label":"Montant decaissé"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v(_vm._s(new
                                                                        Intl.NumberFormat().format(prop.row.montantDecaisse))+"\n                                                                    ")]}}],null,true)})],1)],1)})],2),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"})],1)])}),1)],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',[_vm._v("library_books")]),_vm._v(" Recapitulatif travaux DQE")],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("Liste des travaux")])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","disabled":false,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeProjetPDF()}},slot:"activator"},[_vm._v("\n                                                        Imprimer\n                                                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1):_vm._e(),_vm._v("Imprimer la matrice\n                                                    ")],1)],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","header-row-style":_vm.headerRowStyle,"highlight-current-row":"","data":_vm.bilanTravaux,"summary-method":_vm.getSumm,"show-summary":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("Liste des tâches planifiées")])],1),_vm._v(" "),_c('el-table',{staticClass:"elevation-2",staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":props.row.taches,"summary-method":_vm.getSummariesTache,"show-summary":""}},[_c('el-table-column',{attrs:{"align":"center","prop":"libelle","sortable":"","label":"DESIGNATION"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(" "+_vm._s(prop.row.libelle)+"  ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"mntPrevu","label":"MONTANT MARCHE"},scopedSlots:_vm._u([{key:"default",fn:function(prop4){return [_c('el-tag',{staticClass:"subheading"},[_vm._v("\n                                                                            "+_vm._s(new Intl.NumberFormat().format(prop4.row.mntPrevu))+"\n                                                                        ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"mntRealise","label":"MONTANT REALISE"},scopedSlots:_vm._u([{key:"default",fn:function(prop5){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v("\n                                                                            "+_vm._s(new Intl.NumberFormat().format(prop5.row.mntRealise))+"\n                                                                        ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"ecart","label":"ECART"},scopedSlots:_vm._u([{key:"default",fn:function(prop3){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":prop3.row.ecart < 0 ? 'danger' : 'success'}},[_vm._v("\n                                                                                "+_vm._s(new Intl.NumberFormat().format(prop3.row.ecart))+"\n                                                                            ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"evolution","label":"EVOLUTION(%)"},scopedSlots:_vm._u([{key:"default",fn:function(prop2){return [_c('el-progress',{attrs:{"percentage":Number.parseFloat(prop2.row.evolution).toFixed(2),"color":Number.parseFloat(prop2.row.evolution).toFixed(2) >= 50 ? '#76FF03': 'blue',"format":_vm.format}})]}}],null,true)})],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"libelle","label":"DESIGNATION"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(" "+_vm._s(prop.row.libelle)+"  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"montantPrevu","label":"MONTANT MARCHE"},scopedSlots:_vm._u([{key:"default",fn:function(prop4){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"blue"}},[_vm._v("\n                                                                "+_vm._s(new Intl.NumberFormat().format(prop4.row.montantPrevu))+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"montantEffectif","label":"MONTANT REALISE"},scopedSlots:_vm._u([{key:"default",fn:function(prop5){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v("\n                                                            "+_vm._s(new Intl.NumberFormat().format(prop5.row.montantEffectif))+"\n                                                        ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"ecart","label":"ECART"},scopedSlots:_vm._u([{key:"default",fn:function(prop3){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":prop3.row.ecart < 0 ? 'danger' : 'success'}},[_vm._v("\n                                                                "+_vm._s(new Intl.NumberFormat().format(prop3.row.ecart))+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"evolution","label":"EVOLUTION(%)"},scopedSlots:_vm._u([{key:"default",fn:function(prop2){return [_c('el-progress',{attrs:{"percentage":Number.parseFloat(prop2.row.evolution).toFixed(2),"color":Number.parseFloat(prop2.row.evolution).toFixed(2) >= 50 ? '#76FF03': 'blue',"format":_vm.format}})]}}])})],1)],1)],1)],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',[_vm._v("account_balance_wallet")]),_vm._v(" Etat financier")],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","disabled":false,"dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerEtatProjetPDF()}},slot:"activator"},[_vm._v("\n                                                        Imprimer\n                                                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1):_vm._e(),_vm._v("Imprimer état projet ou chantier\n                                                    ")],1)],1),_vm._v(" "),_vm._l((_vm.listeDetail),function(compte,index){return _c('v-layout',{key:index,staticClass:"mt-3 mb-4",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(index))])],1),_vm._v(" "),_c('el-table',{staticClass:"mb-4",staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":compte,"summary-method":_vm.getSummCompte,"show-summary":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(propsArticle){return [_c('el-row',{staticClass:"elevation-3 pl-4 pr-4 pt-2"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("Détails facture")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":propsArticle.row.produits,"summary-method":_vm.getSummaries,"show-summary":""}},[_c('el-table-column',{attrs:{"prop":"ref","align":"center","label":"REFERENCE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"designation","align":"center","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","align":"center","label":"QUANTITE"},scopedSlots:_vm._u([{key:"default",fn:function(propA1){return [_vm._v(_vm._s(new
                                                                                    Intl.NumberFormat().format(propA1.row.qte))+"\n                                                                                ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","align":"center","label":"UNITE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixU","align":"center","label":"PRIX UNITAIRE"},scopedSlots:_vm._u([{key:"default",fn:function(propA2){return [_vm._v(_vm._s(new
                                                                                    Intl.NumberFormat().format(propA2.row.prixU))+"\n                                                                                ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","align":"center","label":"TVA"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remise","label":"REMISE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","align":"center","label":"TOTAL"},scopedSlots:_vm._u([{key:"default",fn:function(propA3){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v("\n                                                                                    "+_vm._s(new
                                                                                    Intl.NumberFormat().format(propA3.row.total))+"\n                                                                                ")])]}}],null,true)})],1)],1)])],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"","align":"center","prop":"ref","label":"REFERENCE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(" "+_vm._s(prop.row.ref)+"  ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"designation","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"qte","label":"QUANTITE"},scopedSlots:_vm._u([{key:"default",fn:function(propq){return [_vm._v(_vm._s(new Intl.NumberFormat().format(propq.row.qte))+"\n                                                        ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"unite","label":"UNITE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"prixU","label":"PRIX UNITAIRE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v(_vm._s(new Intl.NumberFormat().format(prop.row.prixU))+"\n                                                        ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"total","label":"TOTAL FACTURE"},scopedSlots:_vm._u([{key:"default",fn:function(prop2){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v("\n                                                                "+_vm._s(new Intl.NumberFormat().format(prop2.row.total))+"\n                                                            ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"total","label":"TOTAL FACTURE PAYEE"},scopedSlots:_vm._u([{key:"default",fn:function(prop2){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"success"}},[_vm._v("\n                                                                "+_vm._s(new Intl.NumberFormat().format(prop2.row.totalPaye))+"\n                                                            ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"total","label":"TOTAL FACTURE IMPAYEE"},scopedSlots:_vm._u([{key:"default",fn:function(prop2){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"danger"}},[_vm._v("\n                                                                "+_vm._s(new Intl.NumberFormat().format(prop2.row.totalImpaye))+"\n                                                            ")])]}}],null,true)})],1)],1)],1)})],2),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Matériaux/Matériel utilisés"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',[_vm._v("storage")]),_vm._v(" Matériaux/Matériels utilisés")],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-3",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("Matériaux/Matériels")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":_vm.listeMateriaux,"summary-method":_vm.getSummCompte,"show-summary":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(propsArticle){return [_c('el-row',{staticClass:"elevation-3 pl-4 pr-4 pt-2"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('h4',[_vm._v("Détails articles")]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":propsArticle.row.materiels,"summary-method":_vm.getSummaries,"show-summary":""}},[_c('el-table-column',{attrs:{"prop":"refProd","label":"REFERENCE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(_vm._s(prop.row.refProd))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"designation","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"QTE UTILISEE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v(_vm._s(new Intl.NumberFormat().format(prop.row.qte)))]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteSortie","label":"QTE SORTIE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v(_vm._s(new Intl.NumberFormat().format(prop.row.qteSortie)))]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"UNITE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixU","label":"PRIX UNITAIRE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v(_vm._s(new Intl.NumberFormat().format(prop.row.prixU)))]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"TVA"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remise","label":"REMISE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"TOTAL"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v(_vm._s(new Intl.NumberFormat().format(prop.row.total)))]}}],null,true)})],1)],1)])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"libelle","label":"LIBELLE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(" "+_vm._s(prop.row.libelle)+"  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"dateD","label":"DATE DEBUT"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v(_vm._s(prop.row.dateD)+"\n                                                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"dateF","label":"DATE FIN"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v(_vm._s(prop.row.dateF)+"\n                                                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"chefTravaux","label":"CHEF TRAVAUX"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v(_vm._s(prop.row.chefTravaux)+"\n                                                        ")]}}])})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u/GC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutTravaux),callback:function ($$v) {_vm.dialogAjoutTravaux=$$v},expression:"dialogAjoutTravaux"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Dupliquer les lots du type de chantier:\n            "+_vm._s(this.libelleSelect))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeForm()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type chantier *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Selectionné un type projet"},model:{value:(_vm.typeProjet),callback:function ($$v) {_vm.typeProjet=$$v},expression:"typeProjet"}},_vm._l((_vm.typeProjetTab),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-form',{ref:"formLotTravaux",staticClass:"demo-ruleForm",attrs:{"id":"formLotTravaux","rules":_vm.rulesLotTravaux,"label-position":"top","model":_vm.formLotTravaux}},[(_vm.typeProjet !== '')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs1":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Ordre","prop":"ordre"}},[_c('el-select',{attrs:{"placeholder":"Select"},model:{value:(_vm.formLotTravaux.ordre),callback:function ($$v) {_vm.$set(_vm.formLotTravaux, "ordre", $$v)},expression:"formLotTravaux.ordre"}},_vm._l((_vm.numOrdre),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.num,"value":item.num}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Libellé travaux","prop":"libelle"}},[_c('el-input',{attrs:{"placeholder":"Saisir le libellé","name":"libelle"},model:{value:(_vm.formLotTravaux.libelle),callback:function ($$v) {_vm.$set(_vm.formLotTravaux, "libelle", $$v)},expression:"formLotTravaux.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Code","prop":"code"}},[_c('el-input',{attrs:{"placeholder":"Code","name":"code"},model:{value:(_vm.formLotTravaux.code),callback:function ($$v) {_vm.$set(_vm.formLotTravaux, "code", $$v)},expression:"formLotTravaux.code"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"description"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":"description","name":"description","rows":6},model:{value:(_vm.formLotTravaux.description),callback:function ($$v) {_vm.$set(_vm.formLotTravaux, "description", $$v)},expression:"formLotTravaux.description"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('el-form-item',{attrs:{"label":"Action"}},[_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addListeTypeTravaux()}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.typeProjet !== '')?_c('div',{staticClass:"text-xs-right"},[_c('input',{ref:"fileInputExcel",staticStyle:{"display":"none"},attrs:{"name":"fileInputExcel","type":"file","accept":"image/*"},on:{"change":_vm.onFileExcelPicked}}),_vm._v(" "),_c('el-dropdown',{on:{"command":_vm.handleFileExcel}},[_c('el-button',{attrs:{"type":"success"}},[_vm._v("\n                Fichier excel"),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"0"}},[_vm._v("Importer fichier excel")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"1"}},[_vm._v("Générer un modèle")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeLots,"border":""}},[_c('el-table-column',{attrs:{"prop":"ordre","label":"Ordre"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-select',{attrs:{"placeholder":"Select"},on:{"change":function($event){return _vm.changeOrdre(prop.row.ordre, prop.$index)}},model:{value:(prop.row.ordre),callback:function ($$v) {_vm.$set(prop.row, "ordre", $$v)},expression:"prop.row.ordre"}},_vm._l((_vm.listeNumber),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.num,"value":item.num}})}),1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé travaux"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input',{attrs:{"controls-position":"right","size":"small"},on:{"change":function($event){return _vm.handleChangeLibelle()}},model:{value:(prop.row.libelle),callback:function ($$v) {_vm.$set(prop.row, "libelle", $$v)},expression:"prop.row.libelle"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"code","label":"Code"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input',{attrs:{"controls-position":"right","size":"small"},model:{value:(prop.row.code),callback:function ($$v) {_vm.$set(prop.row, "code", $$v)},expression:"prop.row.code"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"description"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input',{attrs:{"type":"textarea","controls-position":"right","size":"small"},model:{value:(prop.row.description),callback:function ($$v) {_vm.$set(prop.row, "description", $$v)},expression:"prop.row.description"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Opérations","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.listeLots)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                      Modifier ce lot\n                    ")],1)]}}])})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","align-self-end":"","mt-4":""}},[_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pr-1",attrs:{"xs2":"","offset-xs8":""}},[_c('v-btn',{attrs:{"block":"","color":"grey","dark":""},on:{"click":function($event){return _vm.closeForm()}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1)],1),_vm._v(" "),(_vm.typeProjet != '')?_c('v-flex',{attrs:{"xs2":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"green","dark":""},on:{"click":function($event){return _vm.submitDup()}},slot:"activator"},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('LoadTypeTravauxExcel',{attrs:{"show":_vm.showModalLoadTypeTravaux,"listeTypeTravaux":_vm.lstTypeTravaux,"idTypeProjet":this.typeProjet},on:{"close":function($event){_vm.showModalLoadTypeTravaux = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u1so":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u4uD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"tile":""}},[_c('v-card-text',[_c('h4',{attrs:{"mt-2":""}},[_vm._v("Vehicules affectés à des travaux")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","mt-2":""}},[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"mt-3":"","ml-1":"","mr-1":"","data":_vm.listeBesoinsVeh}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              ID-"+_vm._s(scope.row.id)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"vehicule","label":"VEHICULE ATTRIBUE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"periode","label":"PERIODE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.periode)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"produit","label":"VEHICULE DEMANDE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"QUANTITE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"DUREE(Jours)","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"MONTANT/(J)","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"COUT TOTAL","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.total)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demandeur","label":"DEMANDEUR","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"responsables","label":"VALIDE PAR PROJET/LOGISTIQUE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"PROJET/CHANTIER/TRAVAUX","align":"center"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uPRn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        idEmploye: {
            type: Number
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
    name: "formDetailProf",
    data: function data() {
        return {
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,

            dialogFormDetailProf: false,
            formDynamiqueProf: {
                formDetailProfs: [{
                    key: 1,
                    etablissement: null,
                    faculte: null,
                    periode: null,
                    dateDiplome: null,
                    diplome: null,
                    typeCont: null,
                    listePhotos: []
                }]
            },
            etablissement: '',
            faculte: '',
            diplome: '',
            dateDiplome: '',
            periode: '',

            listeTypeContrat: [{
                libelle: "Stagiaire formation"

            }, {
                libelle: "Stagiaire Professionnel"

            }, {
                libelle: "Temps partiel"

            }, {
                libelle: "Consultant"

            }, {
                libelle: "CDI"

            }, {
                libelle: "CDD"

            }],
            indiceForm: null

        };
    },

    watch: {
        show: function show(newValue, oldValue) {
            if (newValue == true) {
                this.loadTypeContrat();
                this.dialogFormDetailProf = true;
            } else {
                this.dialogFormDetailProf = false;
            }
        }
    },
    methods: {
        changeFile: function changeFile(file, fileList) {
            var formDyn = this.formDynamiqueProf.formDetailProfs[this.indiceForm];

            var fileReader = new FileReader();
            formDyn.listePhotos.splice(0);

            for (var ind in fileList) {
                var filename = fileList[ind].name;
                if (filename.lastIndexOf(".") <= 0) {
                    return alert("Veuillez selectionner un  format de fichier valide ");
                }
                formDyn.listePhotos.push(fileList[ind].raw);
            }
        },
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        },
        addDetailProf: function addDetailProf() {
            this.formDynamiqueProf.formDetailProfs.push({
                key: 44666,
                etablissement: null,
                faculte: null,
                periode: null,
                dateDiplome: null,
                diplome: null,
                typeCont: null,
                listePhotos: []
            });
        },
        removeProf: function removeProf(item) {
            var index = this.formDynamiqueProf.formDetailProfs.indexOf(item);
            if (index !== -1) {
                this.formDynamiqueProf.formDetailProfs.splice(index, 1);
            }
        },

        //reinitialise le formulaire de creation de contrat
        resetFormDetails: function resetFormDetails() {
            // this.formDynamiqueProf = {}
            this.formDynamiqueProf = {
                formDetailProfs: [{
                    etablissement: null,
                    faculte: null,
                    periode: null,
                    dateDiplome: null,
                    diplome: null,
                    typeCont: null,
                    listePhotos: []
                }]
            };
        },
        submitFormProf: function submitFormProf(formName) {
            var _this = this;

            this.formDynamiqueProf.formDetailProfs.forEach(function (formDet, indx) {
                _this.etablissement = formDet.etablissement;
                _this.periode = formDet.periode;
                _this.faculte = formDet.faculte;
                _this.dateDiplome = formDet.dateDiplome;
                _this.diplome = formDet.diplome;
            });

            if (this.etablissement != null && this.periode != null) {

                this.$refs[formName].validate(function (valid) {

                    if (!valid) {
                        return;
                    }
                    _this.loading = true;
                    var url = _this.domaine + "rh/detailProfessionnel/" + _this.idEmploye;
                    var data = new FormData();
                    data.append("listeDetailProf", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.formDynamiqueProf.formDetailProfs));
                    data.append("userCreated", _this.user.id);

                    _this.formDynamiqueProf.formDetailProfs.forEach(function (formDet, indx) {
                        var listesPhotos = formDet.listePhotos;
                        listesPhotos.forEach(function (file) {
                            data.append("fichier" + indx + "[]", file, file[name]);
                        }, _this);
                    });

                    _this.$http.post(url, data).then(function (resp) {
                        _this.loading = false;
                        _this.closeForm();
                        _this.successNotif(resp.body.message);
                        _this.resetFormDetails();
                    }, function (error) {
                        _this.loading = false;
                        _this.$message.error("Echec lors de l'enregistrement des renseignements, Veuillez verifier votre connexion internet");
                    });
                });
            } else {
                this.$message.error("veuillez renseigner tous les champs");
            }
        },
        loadTypeContrat: function loadTypeContrat() {
            var _this2 = this;

            var url = this.domaine + 'rh/listeTypeConge';
            this.$http.get(url).then(function (resData) {
                _this2.listeTypeConge = resData.body.listeAbsences;
            }, function (error) {
                _this2.loading = false;
                _this2.$message.error("Echec lors du chargement de al liste des type de conges, Veuillez verifier votre connexion internet");
            });
        },
        resetForm: function resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        closeForm: function closeForm() {
            this.$emit("close");
        }
    }

});

/***/ }),

/***/ "uQqf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "LoadTarifFournExcel",
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
    props: {
        listeTypeTravaux: {
            type: Array,
            default: null
        },
        show: {
            type: Boolean,
            default: false
        },
        idFour: {
            type: Number
        }
    },
    data: function data() {
        return {
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            dialogAjoutBudget: false,
            loading: false
        };
    },

    watch: {
        show: function show(newValue, oldValue) {
            if (newValue == true) {
                this.dialogAjoutBudget = true;
            } else {
                this.dialogAjoutBudget = false;
                // this.loadProduitFounRecent()
                this.$emit("close");
            }
        }
    },
    methods: {
        saveListe: function saveListe() {
            var _this = this;

            // this.loadPage()
            this.loading = true;
            var succesEnreg = true;
            var url = this.domaine + "fournisseur/save/fournisseur/liste_Produit/excel";
            var nbData = 10;
            var nbReq = 1;
            var ligne = null;

            var nbRest = void 0;
            if (this.listeTypeTravaux.length > 10) {
                nbData = 10;
                nbReq = Math.round(this.listeTypeTravaux.length / nbData);
                nbRest = this.listeTypeTravaux.length % nbData;
                if (nbRest > 0) {
                    nbReq += 1;
                }
            }
            for (var i = 0; i < nbReq; i++) {
                var initJ = i * nbData;
                var finJ = (i + 1) * nbData;
                var dataLot = [];
                if (this.listeTypeTravaux.length > 0) {
                    for (var j = initJ; j < finJ; j++) {
                        if (this.listeTypeTravaux[j] == undefined) {
                            break;
                        }
                        dataLot.push(this.listeTypeTravaux[j]);
                    }
                }
                var data = new FormData();
                for (var prop in dataLot) {
                    ligne = dataLot[prop];
                    data.append("option[raison][]", ligne.raison);
                    data.append("option[codePartenaire][]", ligne.codePartenaire);
                    data.append("option[formJuridique][]", ligne.formJuridique);
                    data.append("option[registre][]", ligne.registre);
                    data.append("option[typeFour][]", ligne.typeFour);
                    data.append("option[corpsMetier][]", ligne.corpsMetier);
                    data.append("option[civilite][]", ligne.civilite);
                    data.append("option[nom][]", ligne.nom);
                    data.append("option[prenom][]", ligne.prenom);
                    data.append("option[contact][]", ligne.contact);
                    data.append("option[dateNais][]", ligne.dateNais);
                    data.append("option[naturePiece][]", ligne.naturePiece);
                    data.append("option[numPiece][]", ligne.numPiece);
                    data.append("option[siege][]", ligne.siege);
                    data.append("option[profession][]", ligne.profession);
                    data.append("option[contact][]", ligne.contact);
                    data.append("option[service][]", ligne.service);
                }

                // data.append('listeTypeTravaux', JSON.stringify(dataLot))
                data.append('idUser', this.user.id);
                data.append('fournisseur', this.idFour);

                this.$http.post(url, data).then(function (resp) {
                    _this.loading = false;
                    succesEnreg = false;
                    // this.loadProduitFounRecent()

                    _this.$emit("close");
                    _this.dialogAjoutBudget = false;
                    _this.$notify({
                        title: "Enregistrement",
                        message: "La liste a ete enregistre avec succes",
                        type: "success",
                        position: "top-right",
                        duration: 7000
                    });
                }, function (error) {
                    _this.loading = false;
                    succesEnreg = false;
                    _this.dialogAjoutBudget = false;
                    _this.$message.error("Erreur lors de l'enregistrement des tarifs");
                });
            }

            //  this.loading = true
            // const loading = this.$loading({
            //     lock: true,
            //     text: 'Veuillez patientez ...',
            //     spinner: 'el-icon-loading',
            //     background: 'rgba(0, 0, 0, 0.7)'
            // })
        },
        loadProduitFounRecent: function loadProduitFounRecent() {
            var _this2 = this;

            this.loading = true;
            var url = "";
            if (this.droitAcces.index_produit_fourn) {
                url = this.domaine + 'fournisseur/' + this.idFour + '/index/produit/recent';
            } else {
                url = this.domaine + 'fournisseur/' + this.idFour + '/index/' + this.user.id + '/produit/recent';
            }

            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this2.loading = false;
                }
            });
        },
        closeDialog: function closeDialog() {
            this.$emit("close");
            // this.loadListeTravaux()
        }
    }
});

/***/ }),

/***/ "uYtD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contrat_employe_vue__ = __webpack_require__("YWoT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57852e7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contrat_employe_vue__ = __webpack_require__("i+cl");
function injectStyle (ssrContext) {
  __webpack_require__("3mFV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contrat_employe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57852e7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contrat_employe_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uf1k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Loading__ = __webpack_require__("NxGh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_1__components_Loading__["a" /* default */] },
  name: "AjoutDiagIntervention",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    demandeDetail: {
      type: Object
    },
    validConstat: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      listeProduit: [],
      listStock: [],
      formRapport: {},
      formRefus: {},

      rapport: "",
      dialogConstat: false,
      dialogConfirm: false,
      dialogConfirmRefus: false,
      tableProduit: [],
      tableProduitFour: [],
      totalTTC: 0,
      fileList: [],
      dialogImageUrl: "",
      formProduit: {},
      dialogVisible: false,
      //image
      image1: "/static/img-doc.png",
      image2: "/static/img-doc.png",
      image3: "/static/img-doc.png",
      image4: "/static/img-doc.png",
      file1: "",
      file2: "",
      file3: "",
      listProd: [],
      typeProduit: "",
      listTypeRessource: [],

      ruleFormProduit: {
        idProd: [{ required: true, message: "Veuillez saisir" }],
        quantite: [{ required: true, message: "Veuillez saisir" }]
      },
      formProduitFour: {},
      ruleFormProduitFour: {
        designation: [{ required: true, message: "Veuillez saisir" }],
        quantite: [{ required: true, message: "Veuillez saisir" }]
      },
      ruleFormRefus: {
        rapportRefus: [{ required: true, message: "Veuillez saisir" }]
      },
      //info intervention
      listPrestataire: [],
      listCaisse: [],
      tabDiagnostique: [],
      selectGarage: "",
      e1: 0,
      ruleEtape1: {
        tel1: [{
          required: true,
          message: "Veuillez remplir ce champ",
          trigger: "blur"
        }]
      },
      commandeDeriv: [],
      listEntrepot: [],
      listGarage: []
    }; //return
  },
  //data

  computed: {},
  watch: {
    show: function show(newValue, oldValue) {
      if (newValue == true) {
        this.dialogConstat = true;
        this.loadCaisse();
        this.resetForm();
      } else {
        this.dialogConstat = false;
      }
    }
  },

  methods: {
    loadEntrepot: function loadEntrepot() {
      var _this = this;

      var url = this.domaine + "entrepot/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this.listEntrepot = response.body.entrepot;
        }
      });
    },
    onFileImage1Picked: function onFileImage1Picked(event) {
      var _this2 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this2.image1 = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.file1 = files[0];
    },

    //enregistrement des images
    onFileImage2Picked: function onFileImage2Picked(event) {
      var _this3 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this3.image2 = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.file2 = files[0];
    },


    //enregistrement des images
    onFileImage3Picked: function onFileImage3Picked(event) {
      var _this4 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this4.image3 = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.file3 = files[0];
    },
    handleSuccess: function handleSuccess(response, file, fileList) {
      this.fileList.push(file);
    },
    handlePictureCardPreview: function handlePictureCardPreview(file, fileList) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    addListProduit: function addListProduit(formName, item) {
      var _this5 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var libelle = "";
          var unite = "";
          _this5.listStock.find(function (produit) {
            if (produit.idProduit === item.idProd) {
              libelle = produit.produit;
              unite = produit.unite;
            }
          });
          _this5.tableProduit.push({
            designation: libelle,
            quantite: item.quantite,
            unite: unite ? unite : "pcs",
            prixU: item.prixUnit,
            mntTotal: parseInt(item.quantite) * parseInt(item.prixUnit)
          });
          _this5.totalTTC += parseInt(item.quantite) * parseInt(item.prixUnit);
          // reinitilisation des champs
          _this5.formProduit.prixUnit = 0;
          _this5.formProduit.unite = "";
          _this5.formProduit.idProd = "";
          _this5.formProduit.quantite = "";
          // this.resetForm()
        }
      });
    },
    addListProduitFour: function addListProduitFour(formName, item) {
      var _this6 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this6.tableProduitFour.push({
            designation: item.designation,
            quantite: item.quantite,
            unite: item.unite ? item.unite : "pcs",
            prixU: item.prixUnit,
            mntTotal: parseInt(item.quantite) * parseInt(item.prixUnit)
          });
          _this6.totalTTC += parseInt(item.quantite) * parseInt(item.prixUnit);
          // reinitilisation des champs
          _this6.formProduitFour.prixUnit = 5;
          _this6.formProduitFour.quantite = 5;
          _this6.formProduitFour.unite = "";
          _this6.formProduitFour.designation = "";
          // this.resetForm()
        }
      });
    },
    deleteRow: function deleteRow(index, rows) {
      var item = rows.splice(index, 1);
      this.totalTTC -= parseInt(item[0].mntTotal);
    },
    submitForm: function submitForm() {
      var _this7 = this;

      //analyse des prix des produits
      this.loading = true;
      var url = this.domaine + "intervention/new/" + this.demandeDetail.id + "/diagnostique";
      var form = document.getElementById("formRapportDiag");
      var data = new FormData(form);
      data.append("tableProduit", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableProduit));
      data.append("tableProduitFour", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.tableProduitFour));
      data.append("idUser", this.user.id);
      data.append("garage", this.selectGarage);
      data.append("caisse", this.formRapport.selectCaisse);
      data.append("dateDiag", this.formRapport.dateDiag);
      data.append("entrepot", this.formRapport.entrepot);
      data.append("diagnostique", this.tabDiagnostique);
      data.append("maindoeuvre", this.formRapport.mainDoeuvre);
      this.$http.post(url, data).then(function (response) {
        // this.resetChampsConstat()
        _this7.dialogConstat = false;
        _this7.closeDialog();
        _this7.loading = false;
        _this7.successNotif("L'enregistrement du diagnostique s'est bien deroule' ");
      }, function (erreurRep) {
        _this7.loading = false;
        _this7.$message.error("Une erreur est survenue,Vérifier le contenu des différents champs de chaques étapes");
      });
    },
    loadProduit: function loadProduit() {
      var _this8 = this;

      var url = this.domaine + "product/load-product-stock";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this8.listeProduit = response.body;
        }
      });
    },
    loadTypeRessource: function loadTypeRessource() {
      var _this9 = this;

      var url = this.domaine + "product/typeRessource";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this9.listTypeRessource = response.body.types;
          _this9.loading = false;
        }
      });
    },
    loadProduitGarage: function loadProduitGarage(queryString, cb) {
      var _this10 = this;

      var url = this.domaine + "product/load-product-stock";
      this.$http.get(url).then(function (response) {
        var links = response.body;
        var results = queryString ? links.filter(_this10.createFilter(queryString)) : links;
        cb(results);
      }, function (response) {});
    },
    loadDevisConstat: function loadDevisConstat() {
      var _this11 = this;

      this.loading = true;
      var url = this.domaine + "demande_maintenance/devis/constat/" + this.demandeDetail.idDemande;
      this.$http.get(url).then(function (response) {
        _this11.tableProduit = response.body.tableProduit;
        _this11.formRapport.rapport = response.body.rapport;
        _this11.totalTTC = response.body.total;
        _this11.loading = false;
      }, function (errResp) {
        _this11.loading = false;
        _this11.$message.error("Une erreur est survenue lors du chargement de la table des produits");
      });
    },
    handleChangeEntrepot: function handleChangeEntrepot() {
      var _this12 = this;

      this.loading = true;
      var url = this.domaine + "entrepot/stock/dispo/" + this.formRapport.entrepot;
      this.$http.get(url).then(function (response) {
        _this12.loading = false;
        _this12.listStock = response.body.stock;
      }, function (error) {
        _this12.loading = false;
        _this12.$message.error("Une erreur est survenue lors du produit");
      });
    },
    handleChangePrix: function handleChangePrix() {
      var _this13 = this;

      this.loading = true;
      var url = this.domaine + "maintenance/recherche/produit/" + this.formProduit.idProd;
      this.$http.get(url).then(function (response) {
        _this13.loading = false;
        var produit = response.body.produit;
        _this13.formProduit.prixUnit = produit.valeur;
        _this13.formProduit.unite = produit.unite;
      }, function (errReponse) {
        _this13.loading = false;
        _this13.formProduit.prixUnit = "";
        _this13.formProduit.unite = "";
        //  this.$message.error("Une erreur est survenue lors du produit")
      });
    },
    resetForm: function resetForm() {
      //reinitialisation des images telecharger
      this.image1 = "/static/img-doc.png";
      this.image2 = "/static/img-doc.png";
      this.image3 = "/static/img-doc.png";
      this.image = "/static/img-doc.png";
      this.file1 = "";
      this.file2 = "";
      this.file3 = "";
      this.selectGarage = "";
      this.typeProduit = "";
      this.tabDiagnostique = [];
      this.e1 = 1;
      this.formRapport = {};
      this.tableProduitFour = [];
      this.tableProduit = [];
    },
    loadTypeProduit: function loadTypeProduit(item) {
      var _this14 = this;

      if (this.$refs.typeProduit == "") {
        return;
      }
      this.loading = true;
      var url = this.domaine + "product/productSelect/type/" + item;
      this.$http.get(url).then(function (response) {
        _this14.loading = false;
        _this14.listProd = response.body.produits;
      }, function (errRep) {
        _this14.loading = false;
        _this14.$message.error("Une erreur est survenue lors du chargement de la liste du chntier");
      });
    },
    successNotif: function successNotif() {
      var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      this.$notify({
        title: "ENREGISTREMENT REUSSI",
        message: mess,
        type: "success",
        position: "top-center"
      });
    },
    resetChampsConstat: function resetChampsConstat() {
      this.tableProduit.splice(0);
      this.totalTTC = 0;
      this.formRapport.rapport = "";
    },
    SubmitValideDevis: function SubmitValideDevis() {
      var _this15 = this;

      this.loading = true;
      var url = "";
      if (this.demandeDetail.etatDmd == 4) {
        url = this.domaine + "demande_maintenance/devis/validation2";
      } else {
        url = this.domaine + "demande_maintenance/devis/validation1";
      }

      var data = new FormData();
      data.append("idDemande", this.demandeDetail.idDemande);
      data.append("idUser", this.user.id);
      this.$http.post(url, data).then(function (response) {
        _this15.loading = false;
        _this15.successNotif(response.body.message);
        _this15.dialogConfirm = false;
        _this15.closeDialog();
      }, function (errResp) {
        _this15.loading = false;
        _this15.$message.error("Une erreur est survenue lors de la validation du devis");
      });
    },
    SubmitRefusDevis: function SubmitRefusDevis() {
      var _this16 = this;

      //this.loading = true
      var url = this.domaine + "demande_maintenance/devis/refuser";
      var data = new FormData();
      data.append("idDemande", this.demandeDetail.idDemande);
      data.append("idUser", this.user.id);
      data.append("rapport", this.formRefus.rapport);

      this.$http.post(url, data).then(function (response) {
        _this16.loading = false;
        _this16.successNotif(response.body.message);
        _this16.dialogConfirmRefus = false;
        _this16.closeDialog();
      }, function (errResp) {
        _this16.loading = false;
        _this16.$message.error("Une erreur est survenue lors du refus du devis");
      });
    },
    loadCaisse: function loadCaisse() {
      var _this17 = this;

      var url = this.domaine + "caisse/index";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this17.listCaisse = response.body.caisse;
        }
      });
    },
    loadGarage: function loadGarage() {
      var _this18 = this;

      var url = this.domaine + "intervention/index/garage";
      this.$http.get(url).then(function (response) {
        if (response.body) {
          _this18.listGarage = response.body.garage;
        }
      }, function (response) {});
    },
    createFilter: function createFilter(queryString) {
      return function (link) {
        return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    etape2: function etape2() {
      if (this.selectGarage == undefined || this.selectGarage == "") {
        this.$message.error("Selectionner un garage");
        return;
      }
      if (this.formRapport.mainDoeuvre == undefined) {
        this.$message.error("Saisir la main d'oeuvre");
        return;
      }
      if (this.formRapport.selectCaisse == undefined) {
        this.$message.error("Selectionner une caisse");
        return;
      }
      if (this.formRapport.dateDiag == undefined) {
        this.$message.error("Selectionner la date du diagnostique");
        return;
      }
      if (this.tabDiagnostique == undefined || this.tabDiagnostique.length == 0) {
        this.$message.error("Veuillez saisir ue description dans le champs rapport");
        return;
      }

      this.e1 = 2;
    },
    etape3: function etape3() {
      if (this.tableProduit.length > 0 && this.formRapport.entrepot == undefined) {
        this.$message.error("Veuillez selectionner un entrepot pour la sortie du matériel");
        return;
      }
      this.e1 = 3;
    }
  }, //mthods
  mounted: function mounted() {
    this.loadProduit();
    this.loadEntrepot();
    this.loadTypeRessource();
    this.loadGarage();
    this.loadTypeRessource();
  }
});

/***/ }),

/***/ "ugns":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"four"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n                        "+_vm._s(item.text)+"\n                    ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('boardFacture',{attrs:{"show":_vm.showFactureStat}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogComm),callback:function ($$v) {_vm.dialogComm=$$v},expression:"dialogComm"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true )?_c('span',[_vm._v("Ajouter une nouvelle commande")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification de la commande "+_vm._s(_vm.commCourant.ref)+" "+_vm._s(_vm.commCourant.libelle)+" ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialogComm = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            DETAILS ASSOCIE A LA COMMANDE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),_c('v-form',{ref:"formComm",attrs:{"lazy-validation":"","id":"formComm"},model:{value:(_vm.formComm),callback:function ($$v) {_vm.formComm=$$v},expression:"formComm"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Intitulé de la commande *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Intitulé de la commande"},model:{value:(_vm.libelle),callback:function ($$v) {_vm.libelle=$$v},expression:"libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de livraison *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateLivr","id":"dateLivr","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de livraison"},model:{value:(_vm.dateLivr),callback:function ($$v) {_vm.dateLivr=$$v},expression:"dateLivr"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Associer des utilisateurs ")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","multiple":"","placeholder":"Associer des utilisateurs"},model:{value:(_vm.selectUsers),callback:function ($$v) {_vm.selectUsers=$$v},expression:"selectUsers"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de commande *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Type de commande"},model:{value:(_vm.selectTypeCom),callback:function ($$v) {_vm.selectTypeCom=$$v},expression:"selectTypeCom"}},_vm._l((_vm.typeComm),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Avance démarrage(%)")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"max":100,"min":0,"size":"small","controls-position":"right"},model:{value:(_vm.avance),callback:function ($$v) {_vm.avance=$$v},expression:"avance"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Conditions de paiement")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"paiement"},model:{value:(_vm.modePaie),callback:function ($$v) {_vm.modePaie=$$v},expression:"modePaie"}},_vm._l((_vm.modalitePaie),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[(_vm.selectTypeCom == 1)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                    COMMANDE CONCERNANT UN CHANTIER "),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1):_vm._e()],1),_vm._v(" "),(_vm.selectTypeCom == 1)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Type de Projet","disabled":_vm.dialogEdit},on:{"change":function($event){return _vm.loadChantier()}},model:{value:(_vm.projetS),callback:function ($$v) {_vm.projetS=$$v},expression:"projetS"}},_vm._l((_vm.listProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chantier concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Chantier concerné","disabled":_vm.dialogEdit},on:{"change":function($event){return _vm.loadTravaux()}},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}},_vm._l((_vm.listChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Travaux","disabled":_vm.dialogEdit},model:{value:(_vm.travauxS),callback:function ($$v) {_vm.travauxS=$$v},expression:"travauxS"}},_vm._l((_vm.listTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1):_vm._e(),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[(_vm.selectTypeCom == 2)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                    COMMANDE CONCERNANT UNE DEMANDE DE MAINTENANCE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("last_page")])],1):_vm._e()],1),_vm._v(" "),(_vm.selectTypeCom == 2)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Demande de maintenance concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Demande de maintenance concerné"},model:{value:(_vm.selectDemande),callback:function ($$v) {_vm.selectDemande=$$v},expression:"selectDemande"}},_vm._l((_vm.listDemande),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1):_vm._e(),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                    AJOUTER LES LIGNES DE VOTRE COMMANDE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"md3":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Type ressource *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"typeProduit","id":"typeProduit","filterable":"","placeholder":"Type ressource"},on:{"change":function($event){return _vm.loadTypeProduit(_vm.prodSelct)}},model:{value:(_vm.prodSelct),callback:function ($$v) {_vm.prodSelct=$$v},expression:"prodSelct"}},_vm._l((_vm.listTypeRessource),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1)],1),_vm._v(" "),_vm._l((_vm.optionCommande),function(optionComd,index){return _c('v-layout',{key:optionComd.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ressource *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","prop":'optionCommande.'+ index+'.produit',"placeholder":"Produit"},on:{"change":function($event){return _vm.totauxCommande(index)}},model:{value:(optionComd.produit),callback:function ($$v) {_vm.$set(optionComd, "produit", $$v)},expression:"optionComd.produit"}},_vm._l((_vm.listProd),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.value,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix unitaire *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":5,"value":"prix","prop":'optionCommande.' + index+ '.prix',"placeholder":"Prix unitaire"},on:{"change":function($event){return _vm.totauxCommande(index)}},model:{value:(optionComd.prix),callback:function ($$v) {_vm.$set(optionComd, "prix", $$v)},expression:"optionComd.prix"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":1,"value":"qte","prop":'optionCommande.' + index+ '.qte',"placeholder":"Quantité"},on:{"change":function($event){return _vm.totauxCommande(index)}},model:{value:(optionComd.qte),callback:function ($$v) {_vm.$set(optionComd, "qte", $$v)},expression:"optionComd.qte"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité")]),_vm._v(" "),_c('el-input',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"prop":'optionCommande.' + index+ '.unite',"required":"","placeholder":"Unité","trigger-on-focus":true},model:{value:(optionComd.unite),callback:function ($$v) {_vm.$set(optionComd, "unite", $$v)},expression:"optionComd.unite"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("TOTAL ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"value":"total","prop":'optionCommande.' + index+ '.total',"placeholder":"TOTAL","readonly":true},model:{value:(optionComd.total),callback:function ($$v) {_vm.$set(optionComd, "total", $$v)},expression:"optionComd.total"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.preventDefault();return _vm.removeOptionComm(optionComd)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                                        Supprimer\n                                    ")],1)],1)],1)}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md2":""}},[_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addOptionComm()}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)],2),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogComm = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.dialogEdit != true)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){return _vm.displayMontant()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit == true)?_c('v-btn',{attrs:{"color":"blue","dark":""},on:{"click":function($event){return _vm.displayMontant()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogFacture),callback:function ($$v) {_vm.dialogFacture=$$v},expression:"dialogFacture"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true )?_c('span',[_vm._v("Créer la facture d'une commande")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification de la facture "+_vm._s(_vm.factureCourant.ref)+" "+_vm._s(_vm.factureCourant.libelle)+" ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogFacture = false; _vm.dialogShowFacture = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            DETAILS ASSOCIE A LA NOUVELLE FACTURE  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("note_add")])],1)],1),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":"","id":"formFacture"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Référence commande")]),_vm._v(" "),(_vm.dialogEdit)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Référence commande","disabled":true},model:{value:(_vm.factureCourant.refCom),callback:function ($$v) {_vm.$set(_vm.factureCourant, "refCom", $$v)},expression:"factureCourant.refCom"}}):_vm._e(),_vm._v(" "),(_vm.dialogEdit != true)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Référence commande","disabled":true},model:{value:(_vm.commCourant.ref),callback:function ($$v) {_vm.$set(_vm.commCourant, "ref", $$v)},expression:"commCourant.ref"}}):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Libellé de commande")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Libellé de commande","disabled":true},model:{value:(_vm.libelle),callback:function ($$v) {_vm.libelle=$$v},expression:"libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de la commande")]),_vm._v(" "),(_vm.dialogEdit)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Date de la commande","disabled":true},model:{value:(_vm.factureCourant.dateC),callback:function ($$v) {_vm.$set(_vm.factureCourant, "dateC", $$v)},expression:"factureCourant.dateC"}}):_vm._e(),_vm._v(" "),(_vm.dialogEdit != true)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Date de la commande","disabled":true},model:{value:(_vm.commCourant.dateC),callback:function ($$v) {_vm.$set(_vm.commCourant, "dateC", $$v)},expression:"commCourant.dateC"}}):_vm._e()],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Conditions de paiement *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Conditions de paiement"},model:{value:(_vm.selectModalite),callback:function ($$v) {_vm.selectModalite=$$v},expression:"selectModalite"}},_vm._l((_vm.modalitePaie),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Avance démarrage(%)")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"max":100,"min":0,"size":"small","controls-position":"right"},model:{value:(_vm.avance),callback:function ($$v) {_vm.avance=$$v},expression:"avance"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de paiement *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"datePaie","id":"datePaie","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de paiement"},model:{value:(_vm.datePaie),callback:function ($$v) {_vm.datePaie=$$v},expression:"datePaie"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.image1,"alt":"avatar"}})]),_vm._v(" "),_c('input',{ref:"file1",staticStyle:{"display":"none"},attrs:{"name":"image1","type":"file","accept":"image/*|pdf"},on:{"change":_vm.onFileImage1Picked}}),_vm._v(" "),_c('span',{staticClass:"font-weight-thin"},[_vm._v("Joindre le devis validé au format (JPEG,PNG,PDF) avec une taille de 10 Mo maximale")]),_vm._v(" "),_c('div',{staticClass:"font-weight-thin red--text"},[_vm._v(_vm._s(_vm.nameFile))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.file1.click()}}},[_vm._v("Docs "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout'),_vm._v(" "),_vm._l((_vm.optionCommande),function(optionCom,index){return _c('v-layout',{key:optionCom.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ressource *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","diseable":"","prop":'optionCommande.'+ index+'.produit',"placeholder":"Produit"},on:{"change":function($event){return _vm.calculTotalComm(index)}},model:{value:(optionCom.produit),callback:function ($$v) {_vm.$set(optionCom, "produit", $$v)},expression:"optionCom.produit"}},_vm._l((_vm.listProd),function(item){return _c('el-option',{key:item.id,attrs:{"readonly":true,"label":item.value,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix unitaire *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","readonly":true,"min":5,"value":"prix","prop":'optionCommande.' + index+ '.prix',"placeholder":"Prix unitaire"},on:{"blur":function($event){return _vm.calculTotalComm(index)}},model:{value:(optionCom.prix),callback:function ($$v) {_vm.$set(optionCom, "prix", $$v)},expression:"optionCom.prix"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","readonly":true,"min":1,"value":"qte","prop":'optionCommande.' + index+ '.qte',"placeholder":"Quantité"},on:{"change":function($event){return _vm.calculTotalComm(index)}},model:{value:(optionCom.qte),callback:function ($$v) {_vm.$set(optionCom, "qte", $$v)},expression:"optionCom.qte"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité")]),_vm._v(" "),_c('el-input',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"prop":'optionCommande.' + index+ '.unite',"required":"","placeholder":"Unité","trigger-on-focus":true},model:{value:(optionCom.unite),callback:function ($$v) {_vm.$set(optionCom, "unite", $$v)},expression:"optionCom.unite"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Remise %")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"value":"remise","prop":'optionCommande.' + index+ '.remise',"placeholder":"REMISE"},on:{"change":function($event){return _vm.calculTotalComm(index)}},model:{value:(optionCom.remise),callback:function ($$v) {_vm.$set(optionCom, "remise", $$v)},expression:"optionCom.remise"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("TVA %")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"value":"tva","prop":'optionCommande.' + index+ '.tva',"placeholder":"TVA"},on:{"change":function($event){return _vm.calculTotalComm(index)}},model:{value:(optionCom.tva),callback:function ($$v) {_vm.$set(optionCom, "tva", $$v)},expression:"optionCom.tva"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("TOTAL")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"value":"total","prop":'optionCommande.' + index+ '.total',"placeholder":"TOTAL","readonly":true},on:{"change":function($event){return _vm.calculTotalComm(index)}},model:{value:(optionCom.total),callback:function ($$v) {_vm.$set(optionCom, "total", $$v)},expression:"optionCom.total"}})],1)])],1)}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        TOTAL HT : "+_vm._s(_vm.totalComHT)+" FCFA\n                                    ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        TOTAL REMISE : "+_vm._s(_vm.totalComRemise)+" FCFA\n                                    ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        TOTAL TVA : "+_vm._s(_vm.totalComTVA)+" FCFA\n                                    ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        TOTAL TTC : "+_vm._s(_vm.totComLigneTTCFormat)+" FCFA\n                                    ")])],1)],1),_vm._v(" "),_c('br')],2),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogFacture = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.dialogEdit != true)?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.submitFacture()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":_vm.loading,"dark":""},on:{"click":function($event){return _vm.submitEditFacture()}}},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"95%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogFactureFact),callback:function ($$v) {_vm.dialogFactureFact=$$v},expression:"dialogFactureFact"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true )?_c('span',[_vm._v("Ajouter dévis / facture")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification dévis / facture")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogFactureFact = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            DETAILS ASSOCIE AU DEVIS / FACTURE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("note_add")])],1)],1),_vm._v(" "),(_vm.selectContrat != null)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"primary darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Mnt Contrat : ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("   "+_vm._s(new Intl.NumberFormat().format(_vm.mntEstimeContrat))+" ")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"blue-grey darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("facture(s) déjà generée(s) : ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("   "+_vm._s(new Intl.NumberFormat().format(_vm.mntFactureGenere))+" ")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Mnt à verser / évolution: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("   "+_vm._s(new Intl.NumberFormat().format(_vm.mntAVerserContrat))+" / "+_vm._s(_vm.evolutionContrat)+"% ")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"red darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Mnt restant: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("   "+_vm._s(new Intl.NumberFormat().format(_vm.mntRestantContrat))+" ")])])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-form',{ref:"formFactureFact",attrs:{"lazy-validation":"","id":"formFactureFact"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Libellé de la facture")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Libellé de la facture","name":"libelle"},model:{value:(_vm.libelle),callback:function ($$v) {_vm.libelle=$$v},expression:"libelle"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Conditions de paiement *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Conditions de paiement"},model:{value:(_vm.selectModalite),callback:function ($$v) {_vm.selectModalite=$$v},expression:"selectModalite"}},_vm._l((_vm.modalitePaie),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:((_vm.selectContrat != null)  && (_vm.avanceContSelect  == false)),expression:"(selectContrat != null)  && (avanceContSelect  == false)"}],attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Avance démarrage(%)")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"max":100,"min":0,"size":"small","controls-position":"right"},model:{value:(_vm.avance),callback:function ($$v) {_vm.avance=$$v},expression:"avance"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de paiement *")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"datePaie","id":"datePaie","value-format":"dd-MM-yyyy","type":"date","placeholder":"Date de paiement"},model:{value:(_vm.datePaie),callback:function ($$v) {_vm.datePaie=$$v},expression:"datePaie"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Contrat prestataire(Projet/Chantier/travaux/tache) ")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Contrat prestataire"},on:{"clear":function($event){_vm.loadCaisse();_vm.libTachePrest = null;_vm.clearAll()},"change":function($event){return _vm.changeContrat(_vm.selectContrat)}},model:{value:(_vm.selectContrat),callback:function ($$v) {_vm.selectContrat=$$v},expression:"selectContrat"}},_vm._l((_vm.listContrat),function(item){return _c('el-option',{key:item.idContrat,attrs:{"label":item.projet,"value":item.idContrat,"value-key":item.idContrat}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v("CONTRAT-"+_vm._s(item.idContrat))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v("Projet: "+_vm._s(item.projet))])])}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Compte *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.disabledSelectCaisse,"filterable":"","placeholder":"Caisse"},model:{value:(_vm.selectCaisse),callback:function ($$v) {_vm.selectCaisse=$$v},expression:"selectCaisse"}},_vm._l((_vm.listCaisse),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',[_c('v-layout',[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","disabled":_vm.selectContrat != null,"filterable":"","placeholder":"Type de Projet"},on:{"change":function($event){return _vm.loadChantier()}},model:{value:(_vm.projetS),callback:function ($$v) {_vm.projetS=$$v},expression:"projetS"}},_vm._l((_vm.listProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chantier concerné *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","disabled":_vm.selectContrat != null,"filterable":"","placeholder":"Chantier concerné"},on:{"change":function($event){return _vm.loadTravaux()}},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}},_vm._l((_vm.listChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux ")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","disabled":_vm.selectContrat != null,"filterable":"","placeholder":"Selectionner travaux"},model:{value:(_vm.travauxS),callback:function ($$v) {_vm.travauxS=$$v},expression:"travauxS"}},_vm._l((_vm.listTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectContrat != null &&  _vm.libTachePrest != null),expression:"selectContrat != null &&  libTachePrest != null"}],attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Tache ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"clearable":"","disabled":true,"placeholder":"Libellé de la tache","name":"tache"},model:{value:(_vm.libTachePrest),callback:function ($$v) {_vm.libTachePrest=$$v},expression:"libTachePrest"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.logoFacture,"alt":"avatar"}})]),_c('br'),_vm._v(" "),_c('input',{ref:"logoFacture",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageFacturePicked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.logoFacture.click()}}},[_vm._v("Photo  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_c('br')],1)],1)],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                    AJOUTER LES LIGNES DE VOTRE FACTURE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("note_add")])],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectContrat == null),expression:"selectContrat == null"}],attrs:{"md3":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Type ressource *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"typeProduit","id":"typeProduit","filterable":"","placeholder":"Type ressource"},on:{"change":function($event){return _vm.loadTypeProduit(_vm.prodSelct)}},model:{value:(_vm.prodSelct),callback:function ($$v) {_vm.prodSelct=$$v},expression:"prodSelct"}},_vm._l((_vm.listTypeRessource),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1)],1),_vm._v(" "),_vm._l((_vm.optionCommande),function(optionCom,index){return _c('v-layout',{key:optionCom.key,attrs:{"row":""}},[_c('v-flex',{class:{'md3': _vm.selectContrat == null,  'md7': _vm.selectContrat !=null}},[(_vm.selectContrat == null)?_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ressource *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","prop":'optionCommande.'+ index+'.produit',"placeholder":"Ressource"},on:{"change":function($event){return _vm.calculTotalComm(index)}},model:{value:(optionCom.produit),callback:function ($$v) {_vm.$set(optionCom, "produit", $$v)},expression:"optionCom.produit"}},_vm._l((_vm.listProd),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.value,"value":item.id}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.selectContrat != null)?_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"prop":'optionCommande.'+ index+'.produit',"placeholder":"Service"},model:{value:(optionCom.produit),callback:function ($$v) {_vm.$set(optionCom, "produit", $$v)},expression:"optionCom.produit"}})],1):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[(_vm.selectContrat == null)?_c('span',{staticClass:"demonstration"},[_vm._v("Prix unitaire *")]):_c('span',{staticClass:"demonstration"},[_vm._v("Montant *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.selectContrat != null && _vm.avance != 0,"type":"number","value":"prix","prop":'optionCommande.' + index+ '.prix',"placeholder":"Prix unitaire"},on:{"blur":function($event){return _vm.calculTotalComm(index)}},model:{value:(optionCom.prix),callback:function ($$v) {_vm.$set(optionCom, "prix", $$v)},expression:"optionCom.prix"}})],1)]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectContrat == null),expression:"selectContrat == null"}],attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":1,"value":"qte","prop":'optionCommande.' + index+ '.qte',"placeholder":"Quantité","readonly":false},on:{"change":function($event){return _vm.calculTotalComm(index)}},model:{value:(optionCom.qte),callback:function ($$v) {_vm.$set(optionCom, "qte", $$v)},expression:"optionCom.qte"}})],1)]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectContrat == null),expression:"selectContrat == null"}],attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité")]),_vm._v(" "),_c('el-input',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"prop":'optionCommande.' + index+ '.unite',"required":"","placeholder":"Unité","trigger-on-focus":true},model:{value:(optionCom.unite),callback:function ($$v) {_vm.$set(optionCom, "unite", $$v)},expression:"optionCom.unite"}})],1)]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectContrat == null),expression:"selectContrat == null"}],attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Remise")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"value":"remise","prop":'optionCommande.' + index+ '.remise',"placeholder":"REMISE"},on:{"change":function($event){return _vm.calculTotalComm(index)}},model:{value:(optionCom.remise),callback:function ($$v) {_vm.$set(optionCom, "remise", $$v)},expression:"optionCom.remise"}})],1)]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectContrat == null),expression:"selectContrat == null"}],attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("TVA ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"value":"tva","prop":'optionCommande.' + index+ '.tva',"placeholder":"TVA"},on:{"change":function($event){return _vm.calculTotalComm(index)}},model:{value:(optionCom.tva),callback:function ($$v) {_vm.$set(optionCom, "tva", $$v)},expression:"optionCom.tva"}})],1)]),_vm._v(" "),_c('v-flex',{class:{'md1': _vm.selectContrat == null,  'md3': _vm.selectContrat !=null}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("TOTAL ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"value":"total","prop":'optionCommande.' + index+ '.total',"placeholder":"TOTAL","readonly":true},on:{"change":function($event){return _vm.calculTotalComm(index)}},model:{value:(optionCom.total),callback:function ($$v) {_vm.$set(optionCom, "total", $$v)},expression:"optionCom.total"}})],1)]),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectContrat == null),expression:"selectContrat == null"}],attrs:{"md1":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.preventDefault();return _vm.removeOptionComm(optionCom)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                                        Supprimer\n                                    ")],1)],1)],1)}),_vm._v(" "),_c('v-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectContrat == null),expression:"selectContrat == null"}]},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                            TOTAL HT : "+_vm._s(_vm.totalComHT)+" FCFA\n                                        ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                            TOTAL REMISE : "+_vm._s(_vm.totalComRemise)+" FCFA\n                                        ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","small":"","dark":""},on:{"click":_vm.addOptionComm}},[_c('v-icon',[_vm._v("add")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                            TOTAL TVA : "+_vm._s(_vm.totalComTVA)+" FCFA\n                                        ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"33px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                            TOTAL TTC : "+_vm._s(_vm.totComLigneTTCFormat)+" FCFA\n                                        ")])],1)],1)],1),_vm._v(" "),_c('br')],2),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogFactureFact = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.dialogEdit != true)?_c('v-btn',{attrs:{"icons":"","color":"blue","dark":""},on:{"click":function($event){return _vm.submitFactureFact()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitFactureFact()}}},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogValiFacture),callback:function ($$v) {_vm.dialogValiFacture=$$v},expression:"dialogValiFacture"}},[_c('v-card',[_c('v-toolbar',{staticClass:"green",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Validation de la facture "+_vm._s(_vm.factureCourant.ref)+" "+_vm._s(_vm.factureCourant.libelle))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogValiFacture = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enregistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                            VALIDATION DE LA FACTURE "+_vm._s(_vm.factureCourant.ref)+" "+_vm._s(_vm.factureCourant.libelle)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done_all")])],1)],1),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":"","id":"formValidFacture"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-select',{attrs:{"label":"Décision concernant la facture","name":"decisionFact","items":_vm.decisionFact,"item-value":"value","required":""},model:{value:(_vm.selectDecisionFact),callback:function ($$v) {_vm.selectDecisionFact=$$v},expression:"selectDecisionFact"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('v-textarea',{attrs:{"name":"remarque","label":"Remarque","multi-line":""}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogValiFacture = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":_vm.submitValidFacture}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogLivraison),callback:function ($$v) {_vm.dialogLivraison=$$v},expression:"dialogLivraison"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Nouvelle livraison devis / facture "+_vm._s(_vm.factureCourant.ref)+" "+_vm._s(_vm.factureCourant.libelle))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogLivraison = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            NOUVELLE LIVRAISON DEVIS / FACTURE "+_vm._s(_vm.factureCourant.ref)+" "+_vm._s(_vm.factureCourant.libelle)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done_all")])],1)],1),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":"","id":"formLivraison"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de la livraison ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.factureCourant.dateLivr,"placeholder":"Date de la livraison","disabled":true},model:{value:(_vm.factureCourant.dateLivr),callback:function ($$v) {_vm.$set(_vm.factureCourant, "dateLivr", $$v)},expression:"factureCourant.dateLivr"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de livraison *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Type de livraison"},model:{value:(_vm.selectTypeLivraison),callback:function ($$v) {_vm.selectTypeLivraison=$$v},expression:"selectTypeLivraison"}},_vm._l((_vm.typeLivraison),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Etat de la livraison *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Etat de la livraison"},on:{"change":_vm.handleTypeLivr},model:{value:(_vm.selectLivraison),callback:function ($$v) {_vm.selectLivraison=$$v},expression:"selectLivraison"}},_vm._l((_vm.etatLivraison),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.optionLivraison),function(optionLivr,index){return _c('v-flex',{key:index,attrs:{"md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ressource")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Ressource","disabled":true},model:{value:(optionLivr.produit),callback:function ($$v) {_vm.$set(optionLivr, "produit", $$v)},expression:"optionLivr.produit"}},_vm._l((_vm.listProd),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.produit,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité commandée / à livrer")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","value":"qte","prop":'optionLivraison.' + index+ '.qte',"placeholder":"Quantité commandée","readonly":true},model:{value:(optionLivr.qte),callback:function ($$v) {_vm.$set(optionLivr, "qte", $$v)},expression:"optionLivr.qte"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité livrée")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.selectLivraison == 1,"min":0,"max":optionLivr.qte,"value":"qteL","prop":'optionLivraison.' + index+ '.qteL',"placeholder":"Quantité livrée"},model:{value:(optionLivr.qteL),callback:function ($$v) {_vm.$set(optionLivr, "qteL", $$v)},expression:"optionLivr.qteL"}})],1)])],1)],1)}),1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.image2,"alt":"avatar"}})]),_vm._v(" "),_c('input',{ref:"file2",staticStyle:{"display":"none"},attrs:{"name":"image2","type":"file","accept":"image/*"},on:{"change":_vm.onFileImage2Picked}}),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.file2.click()}}},[_vm._v("Docs "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('div',{staticClass:"font-weight-thin"},[_vm._v("Joindre une image au format (JPEG,PNG,PDF) avec une taille de 10 Mo maximale")])],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[(_vm.selectTypeLivraison == 2)?_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                    INFORMATIONS GENERALES SUR LE BATEAU "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done_all")])],1):_vm._e()],1),_vm._v(" "),(_vm.selectTypeLivraison == 2)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Reference export")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"export","placeholder":"Reference export"},model:{value:(_vm.formBateau.export),callback:function ($$v) {_vm.$set(_vm.formBateau, "export", $$v)},expression:"formBateau.export"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Numéro de commande")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"numCom","placeholder":"Numéro de commande"},model:{value:(_vm.formBateau.numCom),callback:function ($$v) {_vm.$set(_vm.formBateau, "numCom", $$v)},expression:"formBateau.numCom"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Numéro BL")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"bon","placeholder":"Numéro BL"},model:{value:(_vm.formBateau.bl),callback:function ($$v) {_vm.$set(_vm.formBateau, "bl", $$v)},expression:"formBateau.bl"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Lieu de réception")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"reception","placeholder":"Lieu de réception"},model:{value:(_vm.formBateau.reception),callback:function ($$v) {_vm.$set(_vm.formBateau, "reception", $$v)},expression:"formBateau.reception"}})],1)])],1):_vm._e(),_vm._v(" "),(_vm.selectTypeLivraison == 2)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Numéro de chargement ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"numCharge","placeholder":"numéro de compte livraison"},model:{value:(_vm.formBateau.numChargement),callback:function ($$v) {_vm.$set(_vm.formBateau, "numChargement", $$v)},expression:"formBateau.numChargement"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Numéro de voyage ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"numVoyage","placeholder":"Numéro de voyage"},model:{value:(_vm.formBateau.numVoyage),callback:function ($$v) {_vm.$set(_vm.formBateau, "numVoyage", $$v)},expression:"formBateau.numVoyage"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Lieu de provénance")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"provenance","placeholder":"Lieu de provénance"},model:{value:(_vm.formBateau.provenance),callback:function ($$v) {_vm.$set(_vm.formBateau, "provenance", $$v)},expression:"formBateau.provenance"}})],1)])],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.selectTypeLivraison == 2)?_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"color":"blue","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newConteneur('formConteneur')}}},[_vm._v("Ajouter un conteneur "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1):_vm._e(),_vm._v(" "),(_vm.selectTypeLivraison == 2)?_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTE DES CONTENEURS")]):_vm._e(),_vm._v(" "),(_vm.selectTypeLivraison == 2)?_c('v-divider'):_vm._e(),_vm._v(" "),(_vm.selectTypeLivraison == 2)?_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableConteneur}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',[_c('el-col',{attrs:{"span":5}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('b',[_vm._v("Description")]),_vm._v(" : "),_c('p',[_vm._v(_vm._s(props.row.conteneur.description))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":19}},[_c('div',[_c('b',[_vm._v("Articles")]),_vm._v(" :\n                                                    ")]),_vm._v(" "),_c('div',[_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":4}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('v-chip',{staticStyle:{"font-size":"16px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("Tourtes: "+_vm._s(new Intl.NumberFormat().format(props.row.conteneur.tourtesTotal))+" ")])])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('v-chip',{staticStyle:{"font-size":"16px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("Metrages: "+_vm._s(new Intl.NumberFormat().format(props.row.conteneur.metrageTotal))+" ")])])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('v-chip',{staticStyle:{"font-size":"16px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("Tare (Kg): "+_vm._s(new Intl.NumberFormat().format(props.row.conteneur.tareTotal))+" ")])])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('v-chip',{staticStyle:{"font-size":"16px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("Poids brutes (Kg): "+_vm._s(new Intl.NumberFormat().format(props.row.conteneur.poidsBruteTotal))+" ")])])],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('v-chip',{staticStyle:{"font-size":"16px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("Poids net (Kg): "+_vm._s(new Intl.NumberFormat().format(props.row.conteneur.poidsNetTotal))+" ")])])],1)])],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"elevation-3"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":props.row.articles}},[_c('el-table-column',{attrs:{"prop":"code","label":"Code"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"designation","label":"Désignation"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tourtes","label":"Tourtes"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"metrage","label":"Metrage"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tourtes","label":"Tourtes"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"poidsBrute","label":"Poids Brut (kg)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"poidsNet","label":"Poids Net (kg)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tare","label":"Tare (kg)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","width":"100","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scop){return [_c('v-btn',{attrs:{"slot":"activator","color":"red","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.supprimerArticle(scop.$index, props.row.articles)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1)]}}],null,true)})],1)],1)])],1)]}}],null,false,1596141188)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"marque","label":"Marque","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(item){return [_vm._v("\n                                            "+_vm._s(item.row.conteneur.marque)+"\n                                        ")]}}],null,false,2816519251)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"numConteneur","label":"Numéro compte"},scopedSlots:_vm._u([{key:"default",fn:function(item){return [_vm._v("\n                                            "+_vm._s(item.row.conteneur.numConteneur)+"\n                                        ")]}}],null,false,2318302597)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"numCle","label":"numéro clé"},scopedSlots:_vm._u([{key:"default",fn:function(item){return [_vm._v("\n                                            "+_vm._s(item.row.conteneur.numCle)+"\n                                        ")]}}],null,false,1596053968)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type"},scopedSlots:_vm._u([{key:"default",fn:function(item){return [_vm._v("\n                                            "+_vm._s(item.row.conteneur.type)+"\n                                        ")]}}],null,false,1670754964)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"poids","label":"Poids cargot"},scopedSlots:_vm._u([{key:"default",fn:function(item){return [_vm._v("\n                                            "+_vm._s(item.row.conteneur.poids)+"\n                                        ")]}}],null,false,3430681165)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nbPacket","label":"Nombre de packet"},scopedSlots:_vm._u([{key:"default",fn:function(item){return [_vm._v("\n                                            "+_vm._s(item.row.conteneur.nbPacket)+"\n                                        ")]}}],null,false,937482856)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tare","label":"Tare"},scopedSlots:_vm._u([{key:"default",fn:function(item){return [_vm._v("\n                                            "+_vm._s(item.row.conteneur.tare)+"\n                                        ")]}}],null,false,2907132366)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mesure","label":"Mesure"},scopedSlots:_vm._u([{key:"default",fn:function(item){return [_vm._v("\n                                            "+_vm._s(item.row.conteneur.mesure)+"\n                                        ")]}}],null,false,3795277269)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){return _vm.editConteneur(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                                Détails\n                                            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableConteneur)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                                Supprimer ce conteneur\n                                            ")],1)]}}],null,false,1383163691)})],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogLivraison = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.selectTypeLivraison === 1 || _vm.selectTypeLivraison === 2)?_c('v-btn',{attrs:{"icons":"","color":"green","disabled":_vm.loading,"dark":""},on:{"click":_vm.submitLivraison}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.deleteConteneur),callback:function ($$v) {_vm.deleteConteneur=$$v},expression:"deleteConteneur"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","closable":false,"show-icon":"","type":"warning"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("\n                        Annuler\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.ConteneurDelete()}}},[_vm._v("\n                        Supprimer\n                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","scrollable":"","loading":_vm.loading,"max-width":"80%","persistent":""},model:{value:(_vm.dialogConteneur),callback:function ($$v) {_vm.dialogConteneur=$$v},expression:"dialogConteneur"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Ajouter un conteneur")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogConteneur = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-stepper',{model:{value:(_vm.d1),callback:function ($$v) {_vm.d1=$$v},expression:"d1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"complete":_vm.d1 > 1,"step":"1"}},[_vm._v("Informations sur le conteneur")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.d1 > 2,"step":"2"}},[_vm._v("Articles")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',[_c('el-form',{ref:"formConteneur",staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formConteneur}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Marque","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"marque","placeholder":"Marque"},model:{value:(_vm.formConteneur.marque),callback:function ($$v) {_vm.$set(_vm.formConteneur, "marque", $$v)},expression:"formConteneur.marque"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs3":""}},[_c('el-form-item',{attrs:{"label":"Numéro conteneur"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"numConteneur","placeholder":"Numéro conteneur"},model:{value:(_vm.formConteneur.numConteneur),callback:function ($$v) {_vm.$set(_vm.formConteneur, "numConteneur", $$v)},expression:"formConteneur.numConteneur"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"xs3":""}},[_c('el-form-item',{attrs:{"label":"Numéro de la clé"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"numCle","placeholder":"Numéro de la clé"},model:{value:(_vm.formConteneur.numCle),callback:function ($$v) {_vm.$set(_vm.formConteneur, "numCle", $$v)},expression:"formConteneur.numCle"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Type de container"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Type de conteneur"},model:{value:(_vm.formConteneur.type),callback:function ($$v) {_vm.$set(_vm.formConteneur, "type", $$v)},expression:"formConteneur.type"}},_vm._l((_vm.typeConteneur),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Poids cargot"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"name":"poids","placeholder":"Poids cargot"},model:{value:(_vm.formConteneur.poids),callback:function ($$v) {_vm.$set(_vm.formConteneur, "poids", $$v)},expression:"formConteneur.poids"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Le tare (kg)","prop":"tare"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"name":"tare","placeholder":"Tare"},model:{value:(_vm.formConteneur.tare),callback:function ($$v) {_vm.$set(_vm.formConteneur, "tare", $$v)},expression:"formConteneur.tare"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Mesure"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Mesure"},model:{value:(_vm.formConteneur.mesure),callback:function ($$v) {_vm.$set(_vm.formConteneur, "mesure", $$v)},expression:"formConteneur.mesure"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Nombre de packet"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Nombre de packet"},model:{value:(_vm.formConteneur.nbPacket),callback:function ($$v) {_vm.$set(_vm.formConteneur, "nbPacket", $$v)},expression:"formConteneur.nbPacket"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Description des packets"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":4,"id":"description","placeholder":"Description des packets"},model:{value:(_vm.formConteneur.description),callback:function ($$v) {_vm.$set(_vm.formConteneur, "description", $$v)},expression:"formConteneur.description"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"error"},on:{"click":function($event){_vm.dialogConteneur = false}}},[_vm._v("Fermer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.verifFormConteneur()},nativeOn:{"click":function($event){_vm.d1 = 2}}},[_vm._v("Continuer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("keyboard_arrow_right")])],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"primary","icon":"info"}},[_vm._v("\n                                                Ajouter des articles au conteneur\n                                            ")])],1),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formArticle}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Code","required":""}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Code"},model:{value:(_vm.formArticle.code),callback:function ($$v) {_vm.$set(_vm.formArticle, "code", $$v)},expression:"formArticle.code"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Désignation"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Désignation"},model:{value:(_vm.formArticle.designation),callback:function ($$v) {_vm.$set(_vm.formArticle, "designation", $$v)},expression:"formArticle.designation"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Quantité"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Quantité"},model:{value:(_vm.formArticle.qte),callback:function ($$v) {_vm.$set(_vm.formArticle, "qte", $$v)},expression:"formArticle.qte"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Tourtes"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Tourtes"},model:{value:(_vm.formArticle.tourtes),callback:function ($$v) {_vm.$set(_vm.formArticle, "tourtes", $$v)},expression:"formArticle.tourtes"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Métrage"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Métrage"},model:{value:(_vm.formArticle.metrage),callback:function ($$v) {_vm.$set(_vm.formArticle, "metrage", $$v)},expression:"formArticle.metrage"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Poids Brut (kg)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"name":"poidsBrute","placeholder":"Poids Brut"},model:{value:(_vm.formArticle.poidsBrute),callback:function ($$v) {_vm.$set(_vm.formArticle, "poidsBrute", $$v)},expression:"formArticle.poidsBrute"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Tare (kg)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"name":"tare","placeholder":"tare"},model:{value:(_vm.formArticle.tare),callback:function ($$v) {_vm.$set(_vm.formArticle, "tare", $$v)},expression:"formArticle.tare"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Poids net (kg)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"name":"poidsNet","placeholder":"Poids net"},model:{value:(_vm.formArticle.poidsNet),callback:function ($$v) {_vm.$set(_vm.formArticle, "poidsNet", $$v)},expression:"formArticle.poidsNet"}})],1)],1)],1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.addListArticleConteneur(_vm.formArticle)}}},[_vm._v("Ajouter")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableArticleConteneur}},[_c('el-table-column',{attrs:{"prop":"code","label":"Code","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"designation","label":"Désignation"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tourtes","label":"Tourtes"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"metrage","label":"Metrage"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"poidsBrute","label":"Poids Brut (kg)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tare","label":"Tare (kg)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"poidsNet","label":"Poids net (kg)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableArticleConteneur)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                                            Supprimer cet article\n                                                        ")],1)]}}])})],1)],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","flat":"","color":"error"},on:{"click":function($event){_vm.dialogConteneur = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.d1 = 1}}},[_c('v-icon',[_vm._v("keyboard_arrow_left")]),_vm._v("Précédent")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.addListConteneur();_vm.dialogConteneur = false}}},[_vm._v("Ajouter"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"90%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAppro),callback:function ($$v) {_vm.dialogAppro=$$v},expression:"dialogAppro"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Nouvel approvisionnement pour la livraison "+_vm._s(_vm.livraisonCourant.ref))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAppro = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enregistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            NOUVEL APPROVISIONNEMENT POUR LA LIVRAISON "+_vm._s(_vm.livraisonCourant.ref)),_c('v-icon',{attrs:{"right":""}},[_vm._v("add_shopping_cart")])],1)],1),_vm._v(" "),_c('v-form',{ref:"formAppro",attrs:{"lazy-validation":"","id":"formAppro"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_vm._l((_vm.optionEntrepot),function(optionEntre,index){return _c('v-container',{key:optionEntre.key,attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md2":""}},[_c('v-textarea',{staticClass:"subheading black--text",attrs:{"value":"ref","prop":'optionEntrepot.' + index+ '.ref',"label":"Référence","disabled":""},model:{value:(optionEntre.ref),callback:function ($$v) {_vm.$set(optionEntre, "ref", $$v)},expression:"optionEntre.ref"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('v-textarea',{staticClass:"subheading black--text",attrs:{"value":"libelle","prop":'optionEntrepot.' + index+ '.libelle',"label":"Désignation","disabled":""},model:{value:(optionEntre.libelle),callback:function ($$v) {_vm.$set(optionEntre, "libelle", $$v)},expression:"optionEntre.libelle"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md5":""}},[_c('v-textarea',{staticClass:"subheading black--text",attrs:{"value":"lieu","prop":'optionEntrepot.' + index+ '.lieu',"label":"Localisation","disabled":""},model:{value:(optionEntre.lieu),callback:function ($$v) {_vm.$set(optionEntre, "lieu", $$v)},expression:"optionEntre.lieu"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-checkbox',{attrs:{"prop":'optionEntrepot.' + index+ '.valide',"color":"green"},on:{"change":function($event){return _vm.calculTotalAppro(optionEntre,_vm.optionAppro,index)}},model:{value:(optionEntre.valide),callback:function ($$v) {_vm.$set(optionEntre, "valide", $$v)},expression:"optionEntre.valide"}})],1)],1),_vm._v(" "),(optionEntre.valide === true)?_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.optionAppro),function(optionItem,index){return _c('v-flex',{key:optionItem.key,attrs:{"xs10":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('v-textarea',{attrs:{"value":"produit","prop":'optionAppro.' + index+ '.produit',"label":"Produit","disabled":""},model:{value:(optionItem.produit),callback:function ($$v) {_vm.$set(optionItem, "produit", $$v)},expression:"optionItem.produit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('v-textarea',{attrs:{"value":"qteC","prop":'optionAppro.' + index+ '.qteC',"label":"Quantité commandée","disabled":""},model:{value:(optionItem.qteC),callback:function ($$v) {_vm.$set(optionItem, "qteC", $$v)},expression:"optionItem.qteC"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('v-textarea',{attrs:{"value":"qteL","prop":'optionAppro.' + index+ '.qteL',"label":"Quantité livrée","disabled":""},model:{value:(optionItem.qteL),callback:function ($$v) {_vm.$set(optionItem, "qteL", $$v)},expression:"optionItem.qteL"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('v-textarea',{attrs:{"value":"qteR","prop":'optionAppro.' + index+ '.qteR',"label":"Quantité restante","disabled":""},model:{value:(optionItem.qteR),callback:function ($$v) {_vm.$set(optionItem, "qteR", $$v)},expression:"optionItem.qteR"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('el-input',{attrs:{"value":"qteRecu","prop":'optionAppro.' + index+ '.qteRecu',"label":"Quantité reçue","type":"number","min":1,"max":optionItem.qteL,"required":""},on:{"change":function($event){return _vm.calculTotalAppro(optionEntre,optionItem,index)}},model:{value:(_vm.optionQteRecu['p'+optionEntre.id+optionItem.id].qte),callback:function ($$v) {_vm.$set(_vm.optionQteRecu['p'+optionEntre.id+optionItem.id], "qte", $$v)},expression:"optionQteRecu['p'+optionEntre.id+optionItem.id].qte"}})],1)],1)],1)}),1):_vm._e()],1)}),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogAppro = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitAppro()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],2)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogTarif),callback:function ($$v) {_vm.dialogTarif=$$v},expression:"dialogTarif"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit == false)?_c('span',[_vm._v("Ajouter nouvelle tarification ressource")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit == true)?_c('span',[_vm._v("Modifier la tarification")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogTarif = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formTarif",attrs:{"lazy-validation":"","id":"formTarif"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[(_vm.dialogEdit == false)?_c('v-flex',{attrs:{"md3":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Type ressource *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"typeProduit","id":"typeProduit","filterable":"","placeholder":"Type ressource"},on:{"change":function($event){return _vm.loadTypeProduit(_vm.prodSelct)}},model:{value:(_vm.prodSelct),callback:function ($$v) {_vm.prodSelct=$$v},expression:"prodSelct"}},_vm._l((_vm.listTypeRessource),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ressource concerné *")]),_vm._v(" "),(_vm.dialogEdit == false)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Ressource concerné"},on:{"change":function($event){return _vm.loadUniteProduit(_vm.selectProduit)}},model:{value:(_vm.selectProduit),callback:function ($$v) {_vm.selectProduit=$$v},expression:"selectProduit"}},_vm._l((_vm.listProd),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.value,"value":item.id}})}),1):_vm._e(),_vm._v(" "),(_vm.dialogEdit == true)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"readonly":true},model:{value:(_vm.selectProduit),callback:function ($$v) {_vm.selectProduit=$$v},expression:"selectProduit"}}):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"valeurSelect","readonly":true},model:{value:(_vm.valeurUniteMateriel),callback:function ($$v) {_vm.valeurUniteMateriel=$$v},expression:"valeurUniteMateriel"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix d'achat *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","name":"prixAchat","min":0,"placeholder":"Prix d'achat"},model:{value:(_vm.prixAchat),callback:function ($$v) {_vm.prixAchat=$$v},expression:"prixAchat"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[(_vm.dialogEdit == false && this.tableTarification.length != 5 )?_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addListTaches(_vm.selectProduit,_vm.prixAchat)}}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(_vm.dialogEdit == false)?_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableTarification}},[_vm._l((_vm.taches),function(column){return _c('el-table-column',{key:column.id,attrs:{"prop":column.prop,"label":column.label,"sortable":""}})}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteTache(scope.$index, _vm.tableTarification)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                                Supprimer ce tarif\n                                            ")],1)]}}],null,false,2159344184)})],2):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogTarif = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(_vm.dialogEdit == false)?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":_vm.loading,"dark":""},on:{"click":_vm.submitTarif}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit == true)?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":_vm.loading,"dark":""},on:{"click":function($event){_vm.dialogConfirm = true}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e()],1)],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h2',{attrs:{"align":"center"}},[_vm._v("La modification sera prise en compte pour les nouvelles commandes")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogTarif = false;_vm.dialogConfirm = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.submitTarif($event)}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogDevis),callback:function ($$v) {_vm.dialogDevis=$$v},expression:"dialogDevis"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter un nouveau devis")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogDevis = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"En cours d'enregistrement ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            DEVIS DE LA DEMANDE "+_vm._s(_vm.maintenanceCourant.ref)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("note_add")])],1)],1),_vm._v(" "),_c('v-form',{ref:"formDevis",attrs:{"lazy-validation":"","id":"formDevis"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                    AJOUTER LES LIGNES DE VOTRE FACTURE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("note_add")])],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"md3":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Type ressource *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"typeProduit","id":"typeProduit","filterable":"","placeholder":"Type ressource"},on:{"change":function($event){return _vm.loadTypeProduit(_vm.prodSelct)}},model:{value:(_vm.prodSelct),callback:function ($$v) {_vm.prodSelct=$$v},expression:"prodSelct"}},_vm._l((_vm.listTypeRessource),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1)],1),_vm._v(" "),_vm._l((_vm.optionDevis),function(option,index){return _c('v-layout',{key:option.key,attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Ressource *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Ressource","disabled":_vm.maintenanceCourant.etatFact === 1},on:{"change":function($event){return _vm.calculTotalDevis()}},model:{value:(option.libelle),callback:function ($$v) {_vm.$set(option, "libelle", $$v)},expression:"option.libelle"}},_vm._l((_vm.listProd),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.value,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Quantité")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.maintenanceCourant.etatFact === 1,"type":"number","min":"1","placeholder":"Quantité"},on:{"change":_vm.calculTotalDevis},model:{value:(option.qte),callback:function ($$v) {_vm.$set(option, "qte", $$v)},expression:"option.qte"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix unitaire")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.maintenanceCourant.etatFact === 1,"type":"number","min":"0","placeholder":"Prix unitaire","readonly":true},on:{"change":_vm.calculTotalDevis},model:{value:(option.cout),callback:function ($$v) {_vm.$set(option, "cout", $$v)},expression:"option.cout"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("TVA")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.maintenanceCourant.etatFact === 1,"type":"number","min":"0","max":"18","placeholder":"TVA"},on:{"change":_vm.calculTotalDevis},model:{value:(option.tva),callback:function ($$v) {_vm.$set(option, "tva", $$v)},expression:"option.tva"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("TOTAL TTC")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","placeholder":"TOTAL TTC","disabled":""},model:{value:(option.total),callback:function ($$v) {_vm.$set(option, "total", $$v)},expression:"option.total"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[(_vm.maintenanceCourant.etatFact !== 1)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){return _vm.suppressionDevis(index)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                                        Supprimer\n                                    ")],1):_vm._e()],1)],1)}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"29px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        MONTANT HT : "+_vm._s(_vm.devisHt)+" FCFA\n                                    ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.maintenanceCourant.etatFact !== 1)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":_vm.demandeDevisPlus},slot:"activator"},[_c('v-icon',{attrs:{"icon":"","dark":""}},[_vm._v("add")])],1):_vm._e(),_vm._v("\n                                        Ajouter\n                                    ")],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"29px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                        MONTANT TVA : "+_vm._s(_vm.devisTva)+" FCFA\n                                    ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md10":""}},[_c('v-chip',{staticStyle:{"font-size":"29px","width":"100%"},attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                        MONTANT TTC : "+_vm._s(_vm.devisTotal)+" FCFA\n                                    ")])],1)],1)],2),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogDevis = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.dialogEdit != true && _vm.optionDevis.length !== 0)?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitDevis()}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit && _vm.optionDevis.length !== 0)?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitDevis()}}},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowArticle),callback:function ($$v) {_vm.dialogShowArticle=$$v},expression:"dialogShowArticle"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Détails de articles du conteneur ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowArticle = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableEnsemble.infoArticle}},[_c('el-table-column',{attrs:{"prop":"code","label":"Code","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"designation","label":"Désignation"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tourtes","label":"Tourtes"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"metrage","label":"Metrage"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"poidsBrute","label":"Poids Brut (kg)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tare","label":"Tare (kg)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"poidsNet","label":"Poids net (kg)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableArticleConteneur)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                                    Supprimer cet article\n                                ")],1)]}}])})],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowCommande),callback:function ($$v) {_vm.dialogShowCommande=$$v},expression:"dialogShowCommande"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Détails de la commande "+_vm._s(_vm.commCourant.ref)+" "+_vm._s(_vm.commCourant.libelle)+" ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowCommande = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"Veuillez patientez ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.ref)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libellé : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.libelle)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de la commande : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.dateC)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de la livraison : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.dateLivr)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Statut : ")]),_vm._v(" "),(_vm.detailCommande.factureValide === 0)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                                            EN ATTENTE DE VALIDATION"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailCommande.factureValide === 1)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                                            VALIDE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailCommande.factureValide === 2)?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                                            REJETE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),(_vm.detailCommande.etat === false)?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                                            NON LIVRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailCommande.etat == true)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                                            LIVRE EN TOTALITE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Conditions de paiement : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.modalite)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Enregistré par: ")]),_vm._v(" "+_vm._s(_vm.detailCommande.userCreated)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.created)+" ")]),_vm._v(" "),(_vm.detailCommande.usermodified)?_c('div',[_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.modified)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Modifier par : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.usermodified)+" ")])]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Projet : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.projet))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Avance démarage(%) : ")]),_vm._v(" "+_vm._s(_vm.detailCommande.avance)+" ")])])],1),_vm._v(" "),(_vm.detailCommande.compare == 2)?_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_c('a',{attrs:{"href":"#","target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":"static/validComparateur.png"}})])],1)])],1):_vm._e()],1)]),_vm._v(" "),_c('el-row',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"stripe":"","data":_vm.detailCommande.user}},[_c('el-table-column',{attrs:{"prop":"nom","label":"Personnes concernées","width":"180"}})],1)],1)],1)])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"wrap":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"29px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                        MONTANT REMISE : "+_vm._s(_vm.totalComRemise)+" FCFA\n                                                    ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"29px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                        MONTANT HT : "+_vm._s(_vm.totalComHT)+" FCFA\n                                                    ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"29px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                        MONTANT TVA : "+_vm._s(_vm.totalComTVA)+" FCFA\n                                                    ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"29px"},attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                                        MONTANT TTC : "+_vm._s(_vm.commCourant.total)+" FCFA\n                                                    ")])],1)],1)],1)])],1)])],1),_vm._v(" "),_c('el-card',[_c('v-card',[_c('img',{attrs:{"height":"100px","src":_vm.commCourant.imgCommande,"alt":_vm.commCourant.imgCommande}}),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"target":"_blank","href":_vm.commCourant.imgCommande,"flat":"","color":"orange"}},[_vm._v("Voir le document")])],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":7}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailCommande.option,"height":"250"}},[_c('el-table-column',{attrs:{"prop":"produit","label":"Ressource","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixUOld","label":"Ancien Prix unitaire (FCFA)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("\n                                                      "+_vm._s(scope.row.prixUOld)+"\n                                                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix unitaire (FCFA)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remise","label":"Remise(%)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"TVA (18%)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Total TTC (FCFA)"}})],1)]],2)],1)])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowCommande = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n                        Fermer\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.commCourant.compare != 2 && _vm.commCourant.factureValide === 0)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editCommande(_vm.commCourant);}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                        Modifier\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.commCourant.factureExiste !== true)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"grey","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newFacture(_vm.commCourant);}},slot:"activator"},[_vm._v(" Transformer la commande en facture "),_c('v-icon',{attrs:{"right":""}},[_vm._v("note_add")])],1):_vm._e(),_vm._v("\n                        Transformer en facture\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerCommande(_vm.commCourant);}},slot:"activator"},[_vm._v("Imprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("\n                        Imprimer le bon de commande\n                    ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"80%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowFacture),callback:function ($$v) {_vm.dialogShowFacture=$$v},expression:"dialogShowFacture"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Détails de la facture "+_vm._s(_vm.factureCourant.ref)+" "+_vm._s(_vm.factureCourant.libelle)+" ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowFacture = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"Veuillez patientez ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":14}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('el-alert',{attrs:{"title":"Vous ne pouvez pas modifier une facture issue d'une commande","type":"warning","closable":false,"center":"","show-icon":""}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.ref)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Libellé : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.libelle)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Référence commande : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.refCom)+" ")]),_vm._v(" "),(_vm.detailFacture.typeFact === true)?_c('p',[_c('b',[_vm._v("Commande concerné : ")]),_vm._v(" COM-"+_vm._s(_vm.detailFacture.id)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.typeFact === false)?_c('p',[_c('b',[_vm._v("Maintenance concerné : ")]),_vm._v(" MAIN-"+_vm._s(_vm.detailFacture.id)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.typeFact === true)?_c('p',[_c('b',[_vm._v("Date de la commande : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.dateC)+" ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Total ttc de la facture : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.total)+" FCFA")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Statut : ")]),_vm._v(" "),(_vm.detailFacture.etatFact === 0)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                                            EN ATTENTE DE VALIDATION"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailFacture.etatFact === 1)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                                            VALIDE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailFacture.etatFact === 2)?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                                            REJETE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()],1),_vm._v(" "),(_vm.detailFacture.remarqueFact !== null)?_c('p',[_c('b',[_vm._v("Remarque : ")]),_vm._v(" "),(_vm.detailFacture.etatFact === 2)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","color":"red","name":"description"},model:{value:(_vm.detailFacture.remarqueFact),callback:function ($$v) {_vm.$set(_vm.detailFacture, "remarqueFact", $$v)},expression:"detailFacture.remarqueFact"}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Enregistré par : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.userCreated)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Caisse concerné : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.libelleCaisse)+" ")]),_vm._v(" "),(_vm.detailFacture.modalite !== null)?_c('p',[_c('b',[_vm._v("Conditions de paiement: ")]),_vm._v("\n                                                        "+_vm._s(_vm.detailFacture.modalite)+"\n                                                    ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.avance !== null)?_c('p',[_c('b',[_vm._v("Avance demarage : ")]),_vm._v("\n                                                        "+_vm._s(_vm.detailFacture.avance)+"\n                                                    ")]):_vm._e(),_vm._v(" "),(_vm.detailFacture.datePaie !== null)?_c('p',[_c('b',[_vm._v("Date de paiement : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.datePaie)+" ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailFacture.modified)+" ")])])],1)],1)])],1)])],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"wrap":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"23px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                        MONTANT REMISE : "+_vm._s(_vm.totalComRemise)+" FCFA\n                                                    ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"23px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                        MONTANT HT : "+_vm._s(_vm.totalComHT)+" FCFA\n                                                    ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"23px"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                        MONTANT TVA : "+_vm._s(_vm.totalComTVA)+" FCFA\n                                                    ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-chip',{staticStyle:{"font-size":"23px"},attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                                        MONTANT TTC : "+_vm._s(_vm.detailFacture.total)+" FCFA\n                                                    ")])],1)],1)],1)]),_vm._v(" "),_c('el-row',[(_vm.detailFacture.imagefact !='' )?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"ml-3  elevation-5 ",attrs:{"xs3":""}},[_c('a',{attrs:{"href":_vm.detailFacture.imagefact,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.detailFacture.imagefact}})])],1)])],1):_vm._e()],1)],1)])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":7}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailFacture.option,"height":"250"}},[_c('el-table-column',{attrs:{"prop":"produit","label":"Ressource","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix unitaire (FCFA)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remise","label":"Remise(%)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"TVA(%) ","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Total TTC (FCFA)"}})],1)]],2)],1)])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowFacture = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n                        Fermer\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.detailFacture.etatFact === 0 && _vm.detailFacture.typeFact === true || _vm.detailFacture.typeFact === null && _vm.detailFacture.etatReglFact === false && _vm.detailFacture.etatFact === 0)?_c('v-btn',{attrs:{"slot":"activator","disabled":_vm.detailFacture.refCom != 'N/A',"icons":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.editerFacture();}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                        Modifier\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerFacture(_vm.detailFacture);}},slot:"activator"},[_vm._v("Imprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("\n                        Imprimer la facture\n                    ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowLivraison),callback:function ($$v) {_vm.dialogShowLivraison=$$v},expression:"dialogShowLivraison"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Détails de la livraison "+_vm._s(_vm.livraisonCourant.ref)+" "+_vm._s(_vm.livraisonCourant.libelle)+" ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowLivraison = false, _vm.showBoat = false, _vm.showConteneurs = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"Veuillez patientez ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-col',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.livraisonCourant.ref)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Référence facture : ")]),_vm._v(" "+_vm._s(_vm.livraisonCourant.refact))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Référence commande : ")]),_vm._v(" "+_vm._s(_vm.livraisonCourant.comRef)+" "+_vm._s(_vm.livraisonCourant.libelle))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de la livraison : ")]),_vm._v(" "+_vm._s(_vm.livraisonCourant.created)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),(_vm.livraisonCourant.etat === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                            PARTIELLEMENT LIVRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.livraisonCourant.etat === true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                            TOTALEMENT LIVRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v(" "+_vm._s(_vm.livraisonCourant.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.livraisonCourant.modified)+" ")])])],1)],1)])],1)])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":7}},[_c('el-card',{staticClass:"box-card"},[_c('v-card',[_c('img',{attrs:{"height":"100px","src":_vm.livraisonCourant.imgLivraison,"alt":_vm.livraisonCourant.imgLivraison}}),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"target":"_blank","href":_vm.livraisonCourant.imgLivraison,"flat":"","color":"orange"}},[_vm._v("Voir le document")])],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":7}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.livraisonCourant.livre,"height":"250"}},[_c('el-table-column',{attrs:{"prop":"produit","label":"Ressource","width":"280"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteL","label":"Quantité livré"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteR","label":"Quantité restant"}})],1)]],2)],1)])],1),_vm._v(" "),(_vm.showBoat)?_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-col',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Reference export : ")]),_vm._v(" "+_vm._s(_vm.detailLivraison[0].export)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Numéro de commande : ")]),_vm._v(" "+_vm._s(_vm.detailLivraison[0].numComBat)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Numéro BL : ")]),_vm._v(" "+_vm._s(_vm.detailLivraison[0].numBonLivraison)+"  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Lieu de réception : ")]),_vm._v(" "+_vm._s(_vm.detailLivraison[0].recepetionConteneur)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Numéro de chargement :  ")]),_vm._v("\n                                                        "+_vm._s(_vm.detailLivraison[0].numCpteLivraison)+"\n                                                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Numéro de voyage :  ")]),_vm._v("\n                                                        "+_vm._s(_vm.detailLivraison[0].numVoyage)+"\n                                                    ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v(" "+_vm._s(_vm.detailLivraison[0].created)+"  ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailLivraison[0].modified)+" ")])])],1)],1)])],1)])],1)],1):_vm._e(),_vm._v(" "),(_vm.showConteneurs)?_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailLivraison[0].conteneurs}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',[_c('el-col',{attrs:{"span":5}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('b',[_vm._v("Description")]),_vm._v(" : "),_c('p',[_vm._v(_vm._s(props.row.description))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":19}},[_c('div',[_c('b',[_vm._v("Articles")]),_vm._v(" :\n                                            ")]),_vm._v(" "),_c('div',{staticClass:"elevation-3"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":props.row.articles}},[_c('el-table-column',{attrs:{"prop":"code","label":"Code"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"designation","label":"Désignation"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tourtes","label":"Tourtes"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"metrage","label":"Metrage"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"poidsBrute","label":"Poids Brut (kg)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"poidsNet","label":"Poids Net (kg)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tare","label":"Tare (kg)"}})],1)],1)])],1)]}}],null,false,2855251511)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"marque","label":"Marque","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(item){return [_vm._v("\n                                    "+_vm._s(item.row.marque)+"\n                                ")]}}],null,false,1908458146)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"numeroConte","label":"Numéro Conteneur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"numCle","label":"Numéro clé"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"poidsCargot","label":"Poids cargot"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nbPacket","label":"Nombre de packet"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tare","label":"Tare"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mesure","label":"Mesure"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowLivraison = false, _vm.showBoat = false, _vm.showConteneurs = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n                        Fermer\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","dark":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerLivraison(_vm.livraisonCourant)}},slot:"activator"},[_vm._v(" Imprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("\n                        Imprimer la livraison\n                    ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowMaintenance),callback:function ($$v) {_vm.dialogShowMaintenance=$$v},expression:"dialogShowMaintenance"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Détails de la maintenance "+_vm._s(_vm.maintenanceCourant.ref))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowMaintenance = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"element-loading-text":"Veuillez patientez ...","element-loading-spinner":"el-icon-loading","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":16}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Demandeur : ")]),_vm._v(" "+_vm._s(_vm.detailMaintenance.nomDemandeur))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de l'intervention : ")]),_vm._v(" "+_vm._s(_vm.detailMaintenance.date)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Début de l'intervention : ")]),_vm._v(" "+_vm._s(_vm.detailMaintenance.interventionDate)+" à "+_vm._s(_vm.detailMaintenance.heureDebut))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Fin de l'intervention : ")]),_vm._v(" "+_vm._s(_vm.detailMaintenance.interventionDateFin)+" à "+_vm._s(_vm.detailMaintenance.interventionHeureFin)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Contacts : ")]),_vm._v(" "+_vm._s(_vm.detailMaintenance.tel1)+" / "+_vm._s(_vm.detailMaintenance.tel2))])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Statut : ")]),_vm._v(" "),(_vm.detailMaintenance.processus == true)?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                                            FERMER "),_c('v-icon',{attrs:{"right":""}},[_vm._v("clear")])],1):_vm._e(),_vm._v(" "),(_vm.detailMaintenance.processus == false)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                                            OUVERT "),_c('v-icon',{attrs:{"right":""}},[_vm._v("insert_emoticon")])],1):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":_vm.detailMaintenance.color}},[_vm._v("\n                                                            "+_vm._s(_vm.detailMaintenance.etatDmd)+"\n                                                        ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v(" "+_vm._s(_vm.detailMaintenance.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailMaintenance.modified)+" ")])])],1)],1)])],1)])],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('div',{staticClass:"text item"},_vm._l((_vm.detailMaintenance.files),function(item){return _c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('a',{attrs:{"icons":"","click":item.url,"target":"_blank"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("photo")]),_vm._v(" "+_vm._s(item.name))],1)])],1)}),1)])],1)])],1)],1),_vm._v(" "),(_vm.longDevis !== 0)?_c('el-row',{staticStyle:{"padding":"10px"},attrs:{"gutter":7}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.detailMaintenance.devis,"height":"250"}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Désignation","width":"280"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cout","label":"Prix unitaire (FCFA)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"TVA (18%)"}})],1)]],2)],1)])],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowMaintenance = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n                        Fermer\n                    ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShow),callback:function ($$v) {_vm.dialogShow=$$v},expression:"dialogShow"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du fournisseur "+_vm._s(_vm.fournCourant.nom)+" "+_vm._s(_vm.fournCourant.pren)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShow = false; _vm.showFactureStatFour = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('boardFactureFournisseur',{attrs:{"idFour":_vm.fournCourant.id,"show":_vm.showFactureStatFour}})],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("ic_person")]),_vm._v(" Fiche")],1),_vm._v(" "),_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('p',[_c('v-flex',{attrs:{"text-xs-center":"","layout":"","align-center":"","justify-center":""}},[_c('v-avatar',{staticClass:"grey lighten-4",attrs:{"size":"140px"}},[(_vm.detailFour.url)?_c('img',{staticClass:"lazy",attrs:{"src":_vm.detailFour.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"src":"http://archipro-v2.prodestic.net/webservice/web/uploads/avatars/default-avarta.png","alt":""}})])],1)],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.detailFour.ref)+" ")]),_vm._v(" "),_c('p',[(_vm.detailFour.type == 0)?_c('b',[_vm._v("Raison sociale : ")]):_vm._e(),(_vm.detailFour.type == 1)?_c('b',[_vm._v("Nom et prénoms : ")]):_vm._e(),_vm._v(" "),(_vm.detailFour.type == 1)?_c('span',[_vm._v(_vm._s(_vm.detailFour.civilite))]):_vm._e(),_vm._v(" "+_vm._s(_vm.detailFour.nom)+" "+_vm._s(_vm.detailFour.pren)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[(_vm.detailFour.formJuridique != null)?_c('p',[_c('b',[_vm._v("Forme juridique : ")]),_vm._v(" "+_vm._s(_vm.detailFour.formJuridique)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFour.dateNais != null)?_c('p',[_c('b',[_vm._v("Date de naissance : ")]),_vm._v(" "+_vm._s(_vm.detailFour.dateNais)+" ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Type de fournisseur : ")]),_vm._v(" "),(_vm.detailFour.type == 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                                PARTICULIER"),_c('v-icon',{attrs:{"right":""}},[_vm._v("account_circle")])],1):_vm._e(),_vm._v(" "),(_vm.detailFour.type == 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"indigo darken-4"}},[_vm._v("\n                                                                ENTREPRISE"),_c('v-icon',{attrs:{"right":""}},[_vm._v("business")])],1):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Rôle du fournisseur : ")]),_vm._v(" "),(_vm.detailFour.typeFour == 1)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                                                FOURNISSEUR"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailFour.typeFour == 2)?_c('v-chip',{attrs:{"outline":"","text-color":"indigo","label":"","color":"indigo darken-4"}},[_vm._v("\n                                                                PRESTATAIRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(_vm.detailFour.typeFour == 3)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                                                FOURNISSEUR ET PRESTATAIRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Login de connexion :")]),_vm._v(" "+_vm._s(_vm.detailFour.email))]),_vm._v(" "),(_vm.detailFour.formJuridique != null)?_c('p',[_c('b',[_vm._v("Forme juridique : ")]),_vm._v(" "+_vm._s(_vm.detailFour.formJuridique)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFour.dateNais != null)?_c('p',[_c('b',[_vm._v("Date de naissance : ")]),_vm._v(" "+_vm._s(_vm.detailFour.dateNais)+" ")]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[(_vm.detailFour.registreComm != null)?_c('p',[_c('b',[_vm._v("Régistre de commerce : ")]),_vm._v(" "+_vm._s(_vm.detailFour.registreComm)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFour.lieuNais != null)?_c('p',[_c('b',[_vm._v("Lieu de naissance : ")]),_vm._v(" "+_vm._s(_vm.detailFour.lieuNais)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFour.contact != null)?_c('p',[(_vm.detailFour.type == 0)?_c('b',[_vm._v("tél bureau : ")]):_vm._e(),(_vm.detailFour.type == 1)?_c('b',[_vm._v("Contact : ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.detailFour.contact)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFour.siege != null)?_c('p',[_c('b',[_vm._v("Siège : ")]),_vm._v(" "+_vm._s(_vm.detailFour.siege)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFour.nationalite != null)?_c('p',[_c('b',[_vm._v("Nationalité : ")]),_vm._v(" "+_vm._s(_vm.detailFour.nationalite)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFour.domicile != null)?_c('p',[_c('b',[_vm._v("Domicile : ")]),_vm._v(" "+_vm._s(_vm.detailFour.domicile)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFour.naturePiece != null)?_c('p',[_c('b',[_vm._v("Nature de la pièce : ")]),_vm._v(" "+_vm._s(_vm.detailFour.naturePiece)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFour.representant != null)?_c('p',[_c('b',[_vm._v("Représentant légal : ")]),_vm._v(" "+_vm._s(_vm.detailFour.representant)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFour.contactGerant != null)?_c('p',[_c('b',[_vm._v("Contact : ")]),_vm._v(" "+_vm._s(_vm.detailFour.contactGerant)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFour.numPiece != null)?_c('p',[_c('b',[_vm._v("Numéro de la pièce : ")]),_vm._v(" "+_vm._s(_vm.detailFour.numPiece)+" ")]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[(_vm.detailFour.dateDeliv != null)?_c('p',[_c('b',[_vm._v("Date de délivrance : ")]),_vm._v(" "+_vm._s(_vm.detailFour.dateDeliv)+" ")]):_vm._e(),_vm._v(" "),(_vm.detailFour.dateExpi != null)?_c('p',[_c('b',[_vm._v("Date d'expiration : ")]),_vm._v(" "+_vm._s(_vm.detailFour.dateExpi)+" ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Activité : ")]),_vm._v(" "+_vm._s(_vm.detailFour.service)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Profession : ")]),_vm._v(" "+_vm._s(_vm.detailFour.profession)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Métier : ")]),_vm._v(" "+_vm._s(_vm.detailFour.metier)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de création : ")]),_vm._v(" "+_vm._s(_vm.detailFour.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Enregistré par: ")]),_vm._v(" "+_vm._s(_vm.detailFour.userCreated)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailFour.modified)+" ")])])],1)],1)])]),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")]),_vm._v(" Commande")],1),_vm._v(" "),_c('div',[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                    LISTE DES 10 DERNIERES COMMANDES ENGAGÉES AJOUTEES "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                    TOTAL DES COMMANDES ENGAGÉES : "+_vm._s(_vm.totalCommande)+" FCFA "),_c('v-icon',{attrs:{"right":""}},[_vm._v("monetization_on")])],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[(this.nombreSelection.length >=2)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){return _vm.imprimerFuCom()}},slot:"activator"},[_vm._v("\n                                                                    Imprimer en un\n                                                                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1):_vm._e(),_vm._v(" Imprimer en un seul bon de commande\n                                                                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.loadCommande(_vm.detailFour)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("search")])],1),_vm._v("\n                                                                    Afficher la liste de toutes les commandes\n                                                                ")],1)],1)])],1)],1),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"highlight-current-rowref":"multipleTable","data":_vm.listCommande},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"selectable":_vm.besoinSelect,"width":"55","type":"selection"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref","label":"Référence"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                            "+_vm._s(scope.row.ref)+"\n                                                        ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projet","label":"Projet / Entrepot"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                            "+_vm._s(scope.row.projet ? scope.row.projet : scope.row.libEntrepot)+"\n                                                        ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Description"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"Date commande"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                                "+_vm._s(scope.row.dateC)+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                                "+_vm._s(scope.row.total)+" FCFA"),_c('v-icon',{attrs:{"right":""}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.factureValide === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                                FACTURE VALIDE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.factureValide === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                                FACTURE REJETE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                                NON LIVRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat == true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                                LIVRE EN TOTALITE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"compare","label":"Comparateur"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.compare == 2)?[_c('a',{attrs:{"href":"#"}},[_c('v-avatar',{attrs:{"tile":true,"size":"50px","height":"50px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":"static/validComparateur.png"}})])],1)]:undefined}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[(scope.row.factureValide === 2)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogReactiv = true; _vm.commReactiv = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("cached")])],1),_vm._v("\n                                                                    Reprendre\n                                                                ")],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showCommande(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                                                    Détails\n                                                                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.factureValide === 0 && scope.row.compare != 2 && scope.row.factureExiste !== true)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){$event.stopPropagation();return _vm.editCommande(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n                                                                    Modifier\n                                                                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.compare == 0  &&  scope.row.factureExiste !== true)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"grey"},on:{"click":function($event){$event.stopPropagation();_vm.disableCaisse  = false;_vm.newFacture(scope.row);}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("note_add")])],1):_vm._e(),_vm._v("\n                                                                    Faire la facture\n                                                                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerCommande(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                                                                    Imprimer\n                                                                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.etatRefaire == false && scope.row.factureValide != 2 && scope.row.factureExiste == false)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprComm = true; _vm.idComm = scope.row.id; _vm.fournCourant}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                                                                    Supprimer\n                                                                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.compare != 2  && scope.row.etatRefaire == false  && scope.row.factureValide != 1 && scope.row.factureValide != 2 && scope.row.factureExiste !== true)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"cyan"},on:{"click":function($event){return _vm.showDialogComparaison(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("compare_arrows")])],1):_vm._e(),_vm._v("\n                                                                  Effectuer une comparaison\n                                                                ")],1)],1)]}}])})],1)],1)],1)]),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("note_add")]),_vm._v(" Devis / Facture")],1),_vm._v(" "),_c('div',[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                    LISTE DES 10 DERNIERES FACTURES AJOUTEES "),_c('v-icon',{attrs:{"right":""}},[_vm._v("note_add")])],1),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                    TOTAL DES FACTURES : "+_vm._s(_vm.totalFacture)+" FCFA "),_c('v-icon',{attrs:{"right":""}},[_vm._v("monetization_on")])],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"#455a64"},on:{"click":function($event){return _vm.loadFacture(_vm.detailFour)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("search")])],1),_vm._v("\n                                                                    Afficher la liste de toutes les factures\n                                                                ")],1)],1)])],1)],1),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listFacture}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Référence"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                                "+_vm._s(scope.row.ref)+"\n                                                            ")]),_vm._v(" "),(scope.row.ref2 !='')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                                "+_vm._s(scope.row.ref2)+"\n                                                            ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Description"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                                "+_vm._s(scope.row.total)+" FCFA"),_c('v-icon',{attrs:{"right":""}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat","width":"400"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etatFact === 0)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                                                EN ATTENTE DE VALIDATION"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etatFact === 1)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                                                VALIDE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etatFact === 2)?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                                                REJETE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat === 'IMPAYE')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                                                "+_vm._s(scope.row.etat)+"\n                                                            ")]):_vm._e(),_vm._v(" "),(scope.row.etat === 'PAYE')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                                "+_vm._s(scope.row.etat)+"\n                                                            ")]):_vm._e(),_vm._v(" "),(scope.row.etat === 'EN COURS DE PAIEMENT')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                                "+_vm._s(scope.row.etat)+"\n                                                            ")]):_vm._e(),_vm._v(" "),(scope.row.etat === 'EN ATTENTE DE PAIEMENT')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                                "+_vm._s(scope.row.etat)+"\n                                                            ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right","width":"340"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.preventDefault();return _vm.showFacture(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                                                    Détails\n                                                                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[( scope.row.etatFact !== 0 && scope.row.etatFact !== 2 && scope.row.typeFact === true && scope.row.etat === false)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.newLivraison(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("card_giftcard")])],1):_vm._e(),_vm._v("\n                                                                    Livraison\n                                                                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerFacture(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                                                                    Imprimer\n                                                                ")],1)],1)]}}])})],1)],1)],1)]),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("redeem")]),_vm._v(" Livraison")],1),_vm._v(" "),_c('div',[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                    LISTE DES 10 DERNIERES LIVRAISONS AJOUTEES "),_c('v-icon',{attrs:{"right":""}},[_vm._v("redeem")])],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"#455a64"},on:{"click":function($event){return _vm.loadLivraison(_vm.detailFour)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("search")])],1),_vm._v("\n                                                                    Afficher la liste de toutes les livraisons\n                                                                ")],1)],1)])],1)],1),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listLivraison}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Référence"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                                                "+_vm._s(scope.row.ref)+"\n                                                            ")]),_vm._v(" "),(scope.row.refact !='')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                                  "+_vm._s(scope.row.refact)+"\n                                                              ")]):_vm._e(),_vm._v(" "),(scope.row.comRef !='')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                                "+_vm._s(scope.row.comRef)+"\n                                                            ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date livraison"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                                "+_vm._s(scope.row.date)+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat","width":"400"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                                "+_vm._s(scope.row.comRef)+" "+_vm._s(scope.row.libelle)+" "),_c('v-icon',{attrs:{"right":""}})],1),_vm._v(" "),(scope.row.etat === false)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                                                PARTIELLEMENT LIVRE "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat === true)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                                                TOTALEMENT LIVRE "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right","width":"340"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showLivraison(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                                                    Détails\n                                                                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.nbrAppro === 0)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.newAppro(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add_shopping_cart")])],1):_vm._e(),_vm._v("\n                                                                    Approvisionner\n                                                                ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerLivraison(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("print")])],1),_vm._v("\n                                                                    Imprimer\n                                                                ")],1)],1)]}}])})],1)],1)],1)]),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-news"}),_vm._v(" Tarifications")]),_vm._v(" "),_c('div',[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                    LISTE DES 10 DERNIERES TARIFICATIONS AJOUTEES\n                                                ")]),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"#455a64"},on:{"click":function($event){return _vm.loadProduitFoun(_vm.detailFour)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("search")])],1),_vm._v("\n                                                            Afficher la liste de toutes les tarifications\n                                                        ")],1)],1)]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newTarif()}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n                                                    Ajouter\n                                                ")],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-3 mt-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"name":"typeProduit","id":"typeProduit","clearable":"","filterable":"","placeholder":"Type ressource"},on:{"change":function($event){return _vm.filtrerTypeTarification()},"clear":function($event){return _vm.clearSelect4()}},model:{value:(_vm.prodSelct),callback:function ($$v) {_vm.prodSelct=$$v},expression:"prodSelct"}},_vm._l((_vm.listTypeRessource),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1),_vm._v(" "),(_vm.prodSelct != '')?_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Rechercher une produit"},on:{"change":function($event){return _vm.filtrerTarification()}},model:{value:(_vm.produiS),callback:function ($$v) {_vm.produiS=$$v},expression:"produiS"}},_vm._l((_vm.comboProduit),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md8":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('input',{ref:"fileInputExcel",staticStyle:{"display":"none"},attrs:{"name":"fileInputExcel","type":"file","accept":"image/*"},on:{"change":_vm.onFileExcelPicked}}),_vm._v(" "),(true)?_c('v-btn',{attrs:{"slot":"activator","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$refs.fileInputExcel.click()}},slot:"activator"},[_vm._v("\n                                                    Importer\n                                                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_download")])],1):_vm._e(),_vm._v("Importer fichier excel\n                                          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogImport = true}},slot:"activator"},[_vm._v("\n                                              Générer\n                                              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1):_vm._e(),_vm._v("Générer un modèle\n                                          ")],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listProduit,"stripe":"","border":"","height":"350"}},[_c('el-table-column',{attrs:{"prop":"codeGestion","label":"Code analytique"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"indigo"}},[_vm._v("\n                                                                 "+_vm._s(scope.row.codeGestion)+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type de ressources"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                                 "+_vm._s(scope.row.type)+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","width":"480"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                                "+_vm._s(scope.row.libelle)+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixAchat","label":"Prix d'achat"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                                "+_vm._s(Intl.NumberFormat().format(scope.row.prixAchat))+" FCFA\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                                "+_vm._s(scope.row.unite)+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showTarif(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                                                    Détails\n                                                            ")],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editTarif(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.deleteTarif(scope.row)}}},[_c('v-icon',[_vm._v("delete")])],1)]}}])})],1)],1)],1)]),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")]),_vm._v(" Contrat de sous-traitance")],1),_vm._v(" "),_c('div',[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                    LISTE DES TRAVAUX ET TACHE SOUS TRAITES "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                    TOTAL CONTRAT  : "+_vm._s(_vm.totalContrat)+" FCFA "),_c('v-icon',{attrs:{"right":""}},[_vm._v("monetization_on")])],1),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                    TOTAL VERSE  : "+_vm._s(_vm.totalVerse)+" FCFA "),_c('v-icon',{attrs:{"right":""}},[_vm._v("monetization_on")])],1),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                                    TOTAL RESTANT  : "+_vm._s(_vm.totalRestant)+" FCFA "),_c('v-icon',{attrs:{"right":""}},[_vm._v("monetization_on")])],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"text-xs-center"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('el-popover',{ref:"popOver",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisContra('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisContra('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popOver",arg:"popOver"}],attrs:{"type":"warning","icon":"el-icon-printer"}},[_vm._v("Rapport\n                                                                ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{staticClass:"text-xs-right",attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newContrat()}},slot:"activator"},[_vm._v("\n                                                            Contrat\n                                                            "),_c('v-icon',{attrs:{"left":""}},[_vm._v("add")])],1),_vm._v("Contrat de soutraitance\n                                                        ")],1)],1)],1)],1),_vm._v(" "),_c('data-tables',{attrs:{"data":_vm.listContrat}},[_c('el-table-column',{attrs:{"prop":"idContrat","label":"Contrat"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                                ID-"+_vm._s(scope.row.idContrat)+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projet","label":"Projet/Chantier/travaux/tache"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                                "+_vm._s(scope.row.projet)+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntEstime","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                                "+_vm._s(new Intl.NumberFormat('fr-Fr').format(scope.row.mntEstime))+" FCFA"),_c('v-icon',{attrs:{"right":""}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntVerse","label":"Montant versé"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                                "+_vm._s(new Intl.NumberFormat('fr-Fr').format(scope.row.mntVerse))+" FCFA"),_c('v-icon',{attrs:{"right":""}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntReelAVerse","label":"Montant restant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                                                "+_vm._s(new Intl.NumberFormat('fr-Fr').format(scope.row.mntReelAVerse))+" FCFA"),_c('v-icon',{attrs:{"right":""}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateD","label":"Date Début - fin"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                                                "+_vm._s(scope.row.dateD)+" - "+_vm._s(scope.row.dateF)+"\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"EVOLUTION","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-progress-circular',{attrs:{"size":80,"width":15,"rotate":360,"value":scope.row.evolution,"color":"orange"}},[_vm._v("\n                                                                "+_vm._s(scope.row.evolution)+" %\n                                                            ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right","width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();return _vm.showDetailContrat(scope.row.idContrat)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                                                    Détails\n                                                                ")],1)],1)]}}])})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":true,"fullscreen":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogInfoContrat),callback:function ($$v) {_vm.dialogInfoContrat=$$v},expression:"dialogInfoContrat"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("FICHE CONTRAT")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogInfoContrat = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{staticClass:"mb-5 mt-2 elevation-3 pt-4 pl-2 pr-2 pb-4",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2 ml-2",attrs:{"xs7":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{attrs:{"mt-2":""}},[_vm._v("INFORMATION GENERALE")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Identifiant")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title red--text ",attrs:{"xs6":""}},[_vm._v("\n                                                                                            Contrat-"+_vm._s(_vm.detailContrat.idContrat)+"\n                                                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Projet")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v("\n                                                                                            "+_vm._s(_vm.detailContrat.libProjet)+"\n                                                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                            "+_vm._s(_vm.detailContrat.chantier)+"\n                                                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Travaux")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                            "+_vm._s(_vm.detailContrat.libTravaux)+"\n                                                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Prestataire")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title red--text",attrs:{"xs6":""}},[_vm._v("\n                                                                                            "+_vm._s(_vm.detailContrat.prestataire)+"\n                                                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[(_vm.detailContrat.libTache !='')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Tache")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                            "+_vm._s(_vm.detailContrat.libTache)+"\n                                                                                        ")])],1):_vm._e(),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Caisse concernée")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                            "+_vm._s(_vm.detailContrat.caisse)+"\n                                                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Banque concernée")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},_vm._l((_vm.detailContrat.banque),function(item,index){return _c('span',{key:index},[_vm._v("\n                                                                                                  "+_vm._s(item)+" /\n                                                                                            ")])}),0)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Date Dbt et fin")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[_vm._v("\n                                                                                            "+_vm._s(_vm.detailContrat.dateDbt)+" / "+_vm._s(_vm.detailContrat.dateFin)+"\n                                                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Créé le")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                                            "+_vm._s(_vm.detailContrat.dateCreated)+"\n                                                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs5":""}},[_c('v-layout',{staticClass:"text-xs-center",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"sm6":""}},[_c('v-progress-circular',{attrs:{"size":200,"width":20,"rotate":360,"value":_vm.detailContrat.evolution,"color":"teal"}},[_vm._v("\n                                                                        "+_vm._s(_vm.detailContrat.evolution)+" %\n                                                                    ")]),_vm._v(" "),_c('div',{staticClass:"subheading teal--text"},[_vm._v("Evolution physique")])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center",attrs:{"sm6":""}},[_c('v-progress-circular',{attrs:{"size":180,"width":30,"rotate":360,"value":_vm.detailContrat.evolution,"color":"primary"}},[_vm._v("\n                                                                        "+_vm._s(_vm.detailContrat.evolutionFinance)+" %\n                                                                    ")]),_vm._v(" "),_c('div',{staticClass:"subheading primary--text"},[_vm._v("Evolution financière")])],1)],1)],1)],1),_vm._v(" "),(_vm.detailContrat.taches !='')?_c('v-flex',{staticClass:"elevation-3  pt-3 pl-3 pr-3 pb-3",attrs:{"sm12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTES DES TACHES")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":_vm.detailContrat.taches}},[_c('el-table-column',{attrs:{"prop":"refFact","label":"TACHE A REALISER","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.tacheLibelle))])]}}],null,false,680322515)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"DATE ET INTERVAL DE TEMPS","align":"center"}},[_c('el-table-column',{attrs:{"prop":"dateD","label":"Début","width":"190"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Fin","width":"190"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"Durée (Jours) ","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.duree)+" Jour(s)")])]}}],null,false,2608640762)})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT GLOBAL","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-progress-circular',{attrs:{"size":80,"width":15,"rotate":360,"value":scope.row.evolution,"color":"green"}},[_vm._v(_vm._s(scope.row.evolution)+"\n                                                                                  %")])]}}],null,false,797520238)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat == 0)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"red"}},[_vm._v("EN ATTENTE")]):_vm._e(),_vm._v(" "),(scope.row.etat == 1)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"primary"}},[_vm._v("EN EXECUTION")]):_vm._e(),_vm._v(" "),(scope.row.etat == 2)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("TERMINE")]):_vm._e(),_vm._v(" "),(scope.row.etat == 3)?_c('v-chip',{attrs:{"label":"","text-color":"white","color":"green"}},[_vm._v("ARRETE")]):_vm._e()]}}],null,false,1910867871)})],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-1",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"primary darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Total contrat : ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("    "+_vm._s(new Intl.NumberFormat().format(_vm.detailContrat.mntTotal))+" ")]),_vm._v(" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("monetization_on")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Verse: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("    "+_vm._s(new Intl.NumberFormat().format(_vm.detailContrat.mntVerse))+" ")]),_vm._v(" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("monetization_on")])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Restant : ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("   "+_vm._s(new Intl.NumberFormat().format(_vm.detailContrat.mntRestant))+" ")]),_vm._v(" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("monetization_on")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"elevation-3  pt-3 pl-3 pr-3 pb-3",attrs:{"sm12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{attrs:{"mt-2":""}},[_vm._v("HISTORIQUE DES FACTURES DU CONTRAT")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"99%"},attrs:{"highlight-current-row":"","show-summary":"","summary-method":_vm.getSommeFact,"header-row-style":_vm.headerRowStyle,"data":_vm.detailContrat.factures}},[_c('el-table-column',{attrs:{"prop":"refFact","label":"REFERENCE","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelleFact","label":"LIBELLE","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"blue--text body-2"},[_vm._v(_vm._s(scope.row.libelleFact))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"datePaiement","label":"DATE DE PAIEMENT","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etatLibFacture","label":"ETAT","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etatLibFacture == 'En attente')?_c('el-tag',[_vm._v(_vm._s(scope.row.etatLibFacture))]):(scope.row.etatLibFacture == 'Payé')?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.etatLibFacture))]):(scope.row.etatLibFacture == 'Impayé')?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.etatLibFacture))]):(scope.row.etatLibFacture == 'En cours')?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.etatLibFacture))]):(scope.row.etatLibFacture == 'Validation en attente')?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.etatLibFacture))]):(scope.row.etatLibFacture == 'Réfusé')?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.etatLibFacture))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntFacture","label":"TOTAL","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v("\n                                                                                     "+_vm._s(new Intl.NumberFormat().format(scope.row.mntFacture ))+"\n                                                                                 ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntFatureVerse","label":"VERSE","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v("\n                                                                                     "+_vm._s(new Intl.NumberFormat().format(scope.row.mntFatureVerse))+"\n                                                                                 ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntFatureRestant","label":"RESTANT","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.mntFatureRestant > 0)?_c('span',{staticStyle:{"color":"#E6A23C","font-size":"16px"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.mntFatureRestant)))]):_c('span',[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.mntFatureRestant)))])]}}])})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShow = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n                        Fermer\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editFourn(_vm.fournCourant);}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1),_vm._v("\n                        Modifier\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"indigo darken-4","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newCommande(_vm.fournCourant);}},slot:"activator"},[_vm._v("Commande "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1),_vm._v("\n                        Créer une commande\n                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newFactureFact(_vm.fournCourant);}},slot:"activator"},[_vm._v("Devis / Facture "),_c('v-icon',{attrs:{"right":""}},[_vm._v("note_add")])],1),_vm._v("\n                        Créer devis / facture\n                    ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowTarif),callback:function ($$v) {_vm.dialogShowTarif=$$v},expression:"dialogShowTarif"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails de la tarification de la ressource "+_vm._s(_vm.tarifCourant.libelle)+"\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowTarif = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#F9FAFC"}},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Ressource concerné : ")]),_vm._v(" "+_vm._s(_vm.tarifCourant.libelle))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Prix d'achat : ")]),_vm._v("\n                       "+_vm._s(Intl.NumberFormat().format(_vm.tarifCourant.prixAchat))+" FCFA")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Code analytique:")]),_vm._v("\n                        "+_vm._s(_vm.tarifCourant.codeGestion)+"\n                      ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Unité :")]),_vm._v("\n                        "+_vm._s(_vm.tarifCourant.unite)+"\n                      ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Date de modification :")]),_vm._v("\n                        "+_vm._s(_vm.tarifCourant.modified)+"\n                      ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Dernier prix renseigné :")]),_vm._v("\n                         "+_vm._s(Intl.NumberFormat().format(_vm.tarifCourant.prixOld))+" FCFA\n                      ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Modifier par :")]),_vm._v("\n                        "+_vm._s(_vm.tarifCourant.userUpdate)+"\n                      ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement :")]),_vm._v("\n                        "+_vm._s(_vm.tarifCourant.created)+"\n                      ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Enrregistrer par :")]),_vm._v("\n                        "+_vm._s(_vm.tarifCourant.userCreated)+"\n                      ")])])],1)],1)])],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogReactiv),callback:function ($$v) {_vm.dialogReactiv=$$v},expression:"dialogReactiv"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("Voulez-vous réactiver cette commande ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogReactiv = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.refaireCommande()}}},[_vm._v("Confirmer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("check")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer cet enregistrement ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteFourn($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprComm),callback:function ($$v) {_vm.dialogSuprComm=$$v},expression:"dialogSuprComm"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer cet enregistrement ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprComm = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteCommande($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupTarif),callback:function ($$v) {_vm.dialogSupTarif=$$v},expression:"dialogSupTarif"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h1',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer \""+_vm._s(this.selectProduit)+"\" de la Tarification ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupTarif = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteTarification($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),(_vm.user.type === 1 || _vm.user.type === 0)?_c('v-card',[_c('div',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                    LISTE DES 10 DERNIERS FOURNISSEURS AJOUTES "),_c('v-icon',{attrs:{"right":""}},[_vm._v("assignment")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('el-popover',{ref:"popProjet",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisContra('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHisContra('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popProjet",arg:"popProjet"}],attrs:{"type":"warning","disabled":_vm.disabledBtnPop,"icon":"el-icon-printer"}},[_vm._v("Rapport")])],1)],1),_vm._v(" "),(_vm.user.type === 1 || _vm.user.type === 0)?_c('v-flex',[_c('div',{staticClass:"text-xs-right"},[_c('el-dropdown',{on:{"command":_vm.handleCommandFour}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("\n                                        Ajouter fournisseur"),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"1"}},[_vm._v("Personne physique")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"0"}},[_vm._v("Personne morale")])],1)],1)],1)]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.generateFileFour()}},slot:"activator"},[_vm._v("\n                                        Exporter\n                                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1):_vm._e(),_vm._v("Exporter la liste des fournisseurs en  fichier excel\n                            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('input',{ref:"fileInputExcel",staticStyle:{"display":"none"},attrs:{"name":"fileInputExcel","type":"file","accept":"image/*"},on:{"change":_vm.onFileExcelPickedFourn}}),_vm._v(" "),(true)?_c('v-btn',{attrs:{"slot":"activator","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$refs.fileInputExcel.click()}},slot:"activator"},[_vm._v("\n                                        Importer\n                                        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_download")])],1):_vm._e(),_vm._v("Importer fichier excel\n                            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.generateFileExcelFour()}},slot:"activator"},[_vm._v("\n                                    Générer\n                                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1):_vm._e(),_vm._v("Générer un modèle\n                            ")],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{staticClass:"mb-4 mt-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[(_vm.etatAffichage == 1)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner un Metier"},on:{"clear":function($event){return _vm.clearSelect1()},"change":function($event){return _vm.filtrerMetier()}},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}},_vm._l((_vm.comboMetier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[(_vm.etatAffichage == 1)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Selectionner une Profession"},on:{"clear":function($event){return _vm.clearSelect2()},"change":function($event){return _vm.filtrerProfession()}},model:{value:(_vm.projetS),callback:function ($$v) {_vm.projetS=$$v},expression:"projetS"}},_vm._l((_vm.comboProfession),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.profession,"value":item.id}})}),1):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"#455a64"},on:{"click":function($event){return _vm.loadFourn()}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("search")])],1),_vm._v("\n                                        Afficher la liste de tous les fournisseurs\n                                    ")],1)],1)])],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-4 mt-1",attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-1",attrs:{"md4":""}},[(_vm.etatAffichage == 1)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Rechercher un Fournisseur"},on:{"clear":function($event){return _vm.clearSelect3()},"change":function($event){return _vm.filtrerFournisseur()}},model:{value:(_vm.fourniS),callback:function ($$v) {_vm.fourniS=$$v},expression:"fourniS"}},_vm._l((_vm.comboFournisseur),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1):_vm._e()],1)],1)],1),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listFour}},[(false)?_c('el-table-column',{attrs:{"prop":"ref","label":"Réference"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                "+_vm._s(scope.row.ref)+"\n                            ")]}}],null,false,746817260)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"photo","label":"Photo","width":"100","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-avatar',[(scope.row.url)?_c('img',{staticClass:"lazy",attrs:{"src":scope.row.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"src":"http://elbtp.archipro.ci/webservice/web/uploads/avatars/default-avarta.png","alt":""}})])]}}],null,false,4119506554)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nom","label":"Raison sociale / Nom et prénoms"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                    "+_vm._s(scope.row.nom)+" "+_vm._s(scope.row.pren)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("business")])],1)]}}],null,false,215142401)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"type","label":"Type"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.type == 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                    PARTICULIER"),_c('v-icon',{attrs:{"right":""}},[_vm._v("account_circle")])],1):_vm._e(),_vm._v(" "),(scope.row.type == 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"indigo darken-4"}},[_vm._v("\n                                    ENTREPRISE"),_c('v-icon',{attrs:{"right":""}},[_vm._v("business")])],1):_vm._e(),_vm._v(" "),(scope.row.typeFour == 1)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                    FOURNISSEUR"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.typeFour == 2)?_c('v-chip',{attrs:{"outline":"","text-color":"indigo","label":"","color":"indigo darken-4"}},[_vm._v("\n                                    PRESTATAIRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.typeFour == 3)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                    FOURNISSEUR ET PRESTATAIRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}],null,false,655013058)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"contact","label":"Contact"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("\n                                    "+_vm._s(scope.row.contact)+"\n                                ")])]}}],null,false,3413101918)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();_vm.showFourn(scope.row); _vm.loadCommandeRecent(scope.row.id); _vm.loadFactureRecent(scope.row.id); _vm.loadLivraisonRecent(scope.row.id); _vm.loadMaintenanceRecent(scope.row); _vm.loadProduitFounRecent(scope.row); _vm.loadContrat(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                        Détails\n                                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editFourn(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                                        Modifier\n                                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){_vm.dialogSupr = true; _vm.idFourn = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                                        Supprimer\n                                    ")],1)],1)]}}],null,false,1389705817)})],1)],1)],1)]):(_vm.user.type === 3)?_c('v-card',[_c('div',[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                        PRESTATAIRE : "+_vm._s(_vm.user.nom)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("assignment")])],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"search":_vm.search,"items":_vm.listFournConnect},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                  "+_vm._s(props.header.text)+"\n                ")]),_vm._v(" "),_c('span',[_vm._v("\n                  "+_vm._s(props.header.text)+"\n                ")])])]}},{key:"items",fn:function(props){return [_c('td',[_c('v-avatar',[(props.item.url)?_c('img',{staticClass:"lazy",attrs:{"src":props.item.url,"alt":""}}):_c('img',{staticClass:"lazy",attrs:{"src":"http://archipro-v2.prodestic.net/webservice/web/uploads/avatars/default-avarta.png","alt":""}})])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.nom)+" "+_vm._s(props.item.pren))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[(props.item.type == 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                    PARTICULIER"),_c('v-icon',{attrs:{"right":""}},[_vm._v("account_circle")])],1):_vm._e(),_vm._v(" "),(props.item.type == 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"indigo darken-4"}},[_vm._v("\n                                    ENTREPRISE"),_c('v-icon',{attrs:{"right":""}},[_vm._v("business")])],1):_vm._e(),_vm._v(" "),(props.item.typeFour == 1)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                    FOURNISSEUR"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(props.item.typeFour == 2)?_c('v-chip',{attrs:{"outline":"","text-color":"indigo","label":"","color":"indigo darken-4"}},[_vm._v("\n                                    PRESTATAIRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(props.item.typeFour == 3)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                    FOURNISSEUR ET PRESTATAIRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.contact))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();_vm.showFourn(props.item); _vm.loadCommandeRecent(props.item.id); _vm.loadFactureRecent(props.item.id); _vm.loadLivraisonRecent(props.item.id); _vm.loadStatsPieCommandeFourn(props.item); _vm.loadMaintenanceRecent(props.item); _vm.loadProduitFounRecent(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1),_vm._v("\n                                        Détails\n                                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){$event.stopPropagation();return _vm.editFourn(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                                        Modifier\n                                    ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSupr = true; _vm.idFourn = props.item.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                                        Supprimer\n                                    ")],1)],1)])]}}])})],1)],1)]):_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"width":"100%","font-size":"23px"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                VOUS N'AVEZ PAS LES AUTORISATIONS REQUISES POUR VOIR LA LISTE DES FOURNISSEURS.\n                CONTACTER L'ADMINISTRATEUR\n                "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("stop_screen_share")])],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"width":"50%"},model:{value:(_vm.dialogMontantCommande),callback:function ($$v) {_vm.dialogMontantCommande=$$v},expression:"dialogMontantCommande"}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',{staticClass:"headline primary lighten-2 white--text",attrs:{"primary-title":""}},[_vm._v("\n                            Calcul des montants de la commande\n                        ")]),_vm._v(" "),_c('v-card-text',[_c('v-list',{staticClass:"pa-0",attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"indigo"}},[_vm._v("attach_money")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Montant total Hors Taxe sans remise (fcfa)")]),_vm._v(" "),_c('v-list-tile-sub-title')],1),_vm._v(" "),_c('v-list-tile-action',[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.totalComHTSR))])])],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"indigo"}},[_vm._v("attach_money")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Montant total net (fcfa)")]),_vm._v(" "),_c('v-list-tile-sub-title')],1),_vm._v(" "),_c('v-list-tile-action',[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.totalComHT))])])],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"indigo"}},[_vm._v("attach_money")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Montant total REMISE(fcfa)")]),_vm._v(" "),_c('v-list-tile-sub-title')],1),_vm._v(" "),_c('v-list-tile-action',[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.totalComRemise))])])],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"indigo"}},[_vm._v("attach_money")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Montant total TVA (fcfa)")]),_vm._v(" "),_c('v-list-tile-sub-title')],1),_vm._v(" "),_c('v-list-tile-action',[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.totalComTVA))])])],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"indigo"}},[_vm._v("attach_money")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Montant total TTC (fcfa)")]),_vm._v(" "),_c('v-list-tile-sub-title')],1),_vm._v(" "),_c('v-list-tile-action',[_c('span',{staticClass:"title red--text"},[_vm._v(_vm._s(_vm.totComLigneTTCFormat))])])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","dark":""},on:{"click":function($event){_vm.dialogMontantCommande = false}}},[_vm._v("\n                                Annuler\n                            ")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.loading,"color":"green","dark":""},on:{"click":function($event){return _vm.submitComm()}}},[_vm._v("\n                                Valider\n                            ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","scrollable":"","loading":_vm.loading,"fullscreen":"","hide-overlay":""},model:{value:(_vm.dialogComparaison),callback:function ($$v) {_vm.dialogComparaison=$$v},expression:"dialogComparaison"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Fiche de proposition de commande ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogComparaison = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',[_c('v-flex',[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"color":"grey","outline":"","icon":"info"}},[_vm._v("\n                                            DETAILS DE LA COMMANDE INITIALE\n                                        ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (TTC): "+_vm._s(new Intl.NumberFormat().format(_vm.totCommandeInit))+" fcfa")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.commandeInit.option}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"LIBELLE","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"UNITE","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"QUANTITE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"PRIX UNITAIRE"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("  "+_vm._s(new Intl.NumberFormat().format(scope.row.prix)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"TVA"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"TOTAL"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("  "+_vm._s(new Intl.NumberFormat().format(scope.row.total)))])]}}])})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"color":"purple","outlin":"","icon":"warning"}},[_vm._v("\n                                            LISTE DES COMMANDES SUGGEREES\n                                        ")]),_vm._v(" "),_c('v-layout',{staticClass:"mb-3",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"90%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant total economisé:    ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.totalBenefice)+" Fcfa ")])])],1)],1),_vm._v(" "),_vm._l((_vm.commandeDeriv),function(cmdDeri,index){return _c('p',{key:index},_vm._l((cmdDeri),function(CmdD,index){return _c('v-card',{key:index,staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticClass:"elevation-4 text-xs-left",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"green darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Commande à passer chez le fournisseur :   ")]),_vm._v(" "),_c('span',{staticClass:"title text-xs-left"},[_vm._v("  "+_vm._s(index)+" ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":CmdD}},[_c('el-table-column',{attrs:{"prop":"libelleProduit","label":"LIBELLE","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"UNITE","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteProd","label":"QUANTITE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixU","label":"PRIX UNITAIRE"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("  "+_vm._s(new Intl.NumberFormat().format(scope.row.prixU)))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","label":"TVA"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotal","label":"TOTAL"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("  "+_vm._s(new Intl.NumberFormat().format(scope.row.mntTotal)))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"beneficeFormat","label":"GAIN (Fcfa)"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v("  "+_vm._s(scope.row.beneficeFormat))])]}}],null,true)})],1)],1)],1)],1)],1)}),1)})],2)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),(_vm.totalBenefice != 0)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5",staticStyle:{"margin-right":"30px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"green"},on:{"click":function($event){_vm.validCommd = true}},slot:"activator"},[_c('v-icon',[_vm._v("check")])],1),_vm._v(" "),_c('span',[_vm._v("Valider toutes les propositions")])],1):_vm._e()],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"Liste des Ressources","visible":_vm.dialogProdNull,"width":"70%"},on:{"update:visible":function($event){_vm.dialogProdNull=$event}}},[_c('div',[_c('el-alert',{attrs:{"title":"Fournisseur ou Prix d'achat non renseigné","type":"warning","closable":false,"description":"Le(s) ressource(s) suivant ne possède(nt) ancun fournisseur ou un prix d'achat, aucune commande n'a été générée pour ces ressources, Veuillez renseigner ces informations","show-icon":""}})],1),_vm._v(" "),_c('div',[_c('el-table',{attrs:{"data":_vm.listeProdNull}},[_c('el-table-column',{attrs:{"property":"libelleProduit","label":"Ressource"}}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"prixU","label":"Montant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input-number',{attrs:{"min":0,"size":"small","controls-position":"right"},model:{value:(scope.row.prixU),callback:function ($$v) {_vm.$set(scope.row, "prixU", $$v)},expression:"scope.row.prixU"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"fournisseur","label":"Fournisseur"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Associer un fournisseur"},model:{value:(scope.row.fournisseur),callback:function ($$v) {_vm.$set(scope.row, "fournisseur", $$v)},expression:"scope.row.fournisseur"}},_vm._l((_vm.listFour),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)]}}])})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.attribuerFour()}}},[_vm._v("Confirmer")])],1)]),_vm._v(" "),_c('formAjoutFour',{attrs:{"idFour":_vm.fournCourant.id,"show":_vm.showFour,"typeFour":parseInt(_vm.typeF)},on:{"close":function($event){return _vm.closeFormFour()}}}),_vm._v(" "),_c('LoadTarificationFourn',{attrs:{"show":_vm.showModalLoadTarification,"idFour":_vm.fournCourant.id,"listeTypeTravaux":_vm.lstRessources},on:{"close":function($event){_vm.showModalLoadTarification =false;_vm.closeFormFourTarif(_vm.fournCourant.id);}}}),_vm._v(" "),_c('LoadFourn',{attrs:{"show":_vm.showModalLoadTarificationFour,"idFour":_vm.fournCourant.id,"listeTypeTravaux":_vm.lstRessources},on:{"close":function($event){_vm.showModalLoadTarificationFour =false;_vm.closeFormFourTarif(_vm.fournCourant.id);}}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.validCommd),callback:function ($$v) {_vm.validCommd=$$v},expression:"validCommd"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h1',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment annuler la commande passée chez ce fournisseur ? ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.validCommd = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){_vm.validCmdDerivees(_vm.commandeDeriv)()}}},[_vm._v("Confirmer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("check")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogImprCommande),callback:function ($$v) {_vm.dialogImprCommande=$$v},expression:"dialogImprCommande"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModeCommande(2)}}},[_vm._v("\n                    Paysage\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModeCommande(1)}}},[_vm._v("\n                    Portrait\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"blue",attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogImprCommande = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogImprFacture),callback:function ($$v) {_vm.dialogImprFacture=$$v},expression:"dialogImprFacture"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModeFacture(2)}}},[_vm._v("\n                    Paysage\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModeFacture(1)}}},[_vm._v("\n                    Portrait\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"blue",attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogImprFacture = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogImprFusionCom),callback:function ($$v) {_vm.dialogImprFusionCom=$$v},expression:"dialogImprFusionCom"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerListe(2)}}},[_vm._v("\n                    Paysage\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerListe(1)}}},[_vm._v("\n                    Portrait\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"blue",attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogImprFacture = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogImprLivraison),callback:function ($$v) {_vm.dialogImprLivraison=$$v},expression:"dialogImprLivraison"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModeLivraison(2)}}},[_vm._v("\n                    Paysage\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModeLivraison(1)}}},[_vm._v("\n                    Portrait\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"blue",attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogImprLivraison = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"100%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowModalSous),callback:function ($$v) {_vm.dialogShowModalSous=$$v},expression:"dialogShowModalSous"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter un contrat de soutraitance ")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification du besoin")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowModalSous= false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"text-center":"","text-color":"white","label":"","color":"primary"}},[_vm._v("\n             INFORMATION SUR LE PROJET\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("shopping_cart")])],1),_vm._v(" "),_c('v-form',{ref:"formBesoin",attrs:{"lazy-validation":"","id":"formBesoin"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Projet concerné "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Type de Projet"},on:{"change":function($event){_vm.loadChantier();_vm.onchangeInfo(_vm.projetS)}},model:{value:(_vm.projetS),callback:function ($$v) {_vm.projetS=$$v},expression:"projetS"}},_vm._l((_vm.listProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chantier concerné "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Chantier concerné"},on:{"change":function($event){return _vm.loadTravaux()}},model:{value:(_vm.chantierS),callback:function ($$v) {_vm.chantierS=$$v},expression:"chantierS"}},_vm._l((_vm.listChantier),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Travaux "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Travaux"},on:{"change":function($event){return _vm.loadTacheTrx(_vm.travauxS)}},model:{value:(_vm.travauxS),callback:function ($$v) {_vm.travauxS=$$v},expression:"travauxS"}},_vm._l((_vm.listTravaux),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Chef projet")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Chef projet","readonly":true},model:{value:(_vm.chefProjet),callback:function ($$v) {_vm.chefProjet=$$v},expression:"chefProjet"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Date de debut")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Date debut","readonly":true},model:{value:(_vm.dateDebut),callback:function ($$v) {_vm.dateDebut=$$v},expression:"dateDebut"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date fin")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Date de fin","readonly":true},model:{value:(_vm.dateFin),callback:function ($$v) {_vm.dateFin=$$v},expression:"dateFin"}})],1)])],1),_vm._v(" "),(_vm.listTaches.length === 0 && _vm.showValeur == true)?_c('el-alert',{attrs:{"title":'TOUTES LES TACHES DE SES TRAVAUX ONT ÉTÉ SOUS-TRAITÉES',"type":"warning","center":"","closable":false,"show-icon":""}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.listTaches.length > 0)?_c('div',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md11":""}},[_c('v-chip',{staticStyle:{"width":"100%"},attrs:{"outline":"","text-center":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                      AJOUTER LES QUANTITES DES TACHES A SOUTRAITER\n                    ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md18":""}},_vm._l((_vm.optinListTaches),function(optionP,index){return _c('v-layout',{key:optionP.key,attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('span',{staticClass:"demonstration"},[_vm._v("Libelle "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","name":"valeurSelect","id":"valeurSelect","filterable":"","placeholder":"Taches"},on:{"change":function($event){return _vm.loadInfoTaches(optionP.libelle)}},model:{value:(optionP.libelle),callback:function ($$v) {_vm.$set(optionP, "libelle", $$v)},expression:"optionP.libelle"}},_vm._l((_vm.listTaches),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.libelle}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Unité")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"valeurUnite","readonly":true},model:{value:(_vm.valeurUnite),callback:function ($$v) {_vm.valeurUnite=$$v},expression:"valeurUnite"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date debut")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"valeurDateD","readonly":true},model:{value:(_vm.valeurDateD),callback:function ($$v) {_vm.valeurDateD=$$v},expression:"valeurDateD"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Date fin")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"valeurDateF","readonly":true},model:{value:(_vm.valeurDateF),callback:function ($$v) {_vm.valeurDateF=$$v},expression:"valeurDateF"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Prix unitaire "),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","name":"valeurPrix"},model:{value:(_vm.valeurPrix),callback:function ($$v) {_vm.valeurPrix=$$v},expression:"valeurPrix"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Qte à soutraiter  /  "+_vm._s(_vm.qteAsous)),_c('span',{staticClass:"asterix"},[_vm._v("*")])]),_vm._v(" "),_c('el-input',{attrs:{"type":"number","min":"0","max":_vm.qteAsous},on:{"change":function($event){return _vm.calculTotalLign(optionP.qte)}},model:{value:(optionP.qte),callback:function ($$v) {_vm.$set(optionP, "qte", $$v)},expression:"optionP.qte"}})],1)]),_vm._v(" "),_c('v-flex',{staticClass:"mr-4",attrs:{"md1":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Total (HT)")]),_vm._v(" "),_c('p',[_c('v-chip',{attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v(_vm._s(new Intl.NumberFormat().format(_vm.valeurTtLigne)))])])],1)])]),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addListInventaire(optionP)}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)}),1),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"label-position":"top","inline":true,"model":_vm.formInventaire}},[_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableInventaire}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateD","label":"Date de debut"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Date Fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Prix"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteAsou","label":"Quantité à soutraiter"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalHt","label":"Total HT"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.tableInventaire)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                          Supprimer\n                        ")],1)]}}],null,false,2832546761)})],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"label":"","outline":"","color":"green"}},[_c('b',[_vm._v("Total (HT):\n                            "+_vm._s(new Intl.NumberFormat().format(_vm.totalHT)))])])],1)],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogShowModalSous = false}}},[_vm._v("\n              Annuler\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.tableInventaire.length > 0)?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":_vm.loading,"dark":""},on:{"click":_vm.submitContrat}},[_vm._v("\n              Enregistrer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogImport),callback:function ($$v) {_vm.dialogImport=$$v},expression:"dialogImport"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h4',{attrs:{"align":"center"}},[_vm._v("Nb: Le fichier contient uniquement les ressources qui figurent dans votre base de produit.")]),_vm._v(" "),_c('h4',{attrs:{"align":"center"}},[_vm._v("Indiquer uniquement le PRIX D'ACHAT de chaque ligne de produit que vous souhaitez ajouter à la tarification chez ce fournisseur.")]),_vm._v(" "),_c('h3',{attrs:{"align":"center"}},[_vm._v("Supprimer ensuite les lignes restantes dans votre fichier avant importation.")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogImport = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.generateFileExcel()}}},[_vm._v("Généner "),_c('v-icon',{attrs:{"right":""}},[_vm._v("done")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uij/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RapportJournalier_vue__ = __webpack_require__("TNey");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c25468_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RapportJournalier_vue__ = __webpack_require__("IOgm");
function injectStyle (ssrContext) {
  __webpack_require__("9Hs7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15c25468"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RapportJournalier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c25468_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RapportJournalier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uwwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutTravaux),callback:function ($$v) {_vm.dialogAjoutTravaux=$$v},expression:"dialogAjoutTravaux"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter/Editer des nouveaux lots de travaux ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeForm()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formLotTravaux",staticClass:"demo-ruleForm",attrs:{"id":"formLotTravaux","rules":_vm.rulesLotTravaux,"label-position":"top","model":_vm.formLotTravaux}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs1":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Ordre","prop":"ordre"}},[_c('el-select',{attrs:{"placeholder":"Select"},model:{value:(_vm.formLotTravaux.ordre),callback:function ($$v) {_vm.$set(_vm.formLotTravaux, "ordre", $$v)},expression:"formLotTravaux.ordre"}},_vm._l((_vm.numOrdre),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.num,"value":item.num}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Code","prop":"code"}},[_c('el-input',{attrs:{"placeholder":"Code","name":"code"},model:{value:(_vm.formLotTravaux.code),callback:function ($$v) {_vm.$set(_vm.formLotTravaux, "code", $$v)},expression:"formLotTravaux.code"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Libellé travaux","prop":"libelle"}},[_c('el-input',{attrs:{"placeholder":"Saisir le libellé","name":"libelle"},model:{value:(_vm.formLotTravaux.libelle),callback:function ($$v) {_vm.$set(_vm.formLotTravaux, "libelle", $$v)},expression:"formLotTravaux.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"description"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":"description","name":"description","rows":6},model:{value:(_vm.formLotTravaux.description),callback:function ($$v) {_vm.$set(_vm.formLotTravaux, "description", $$v)},expression:"formLotTravaux.description"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('el-form-item',{attrs:{"label":"Action"}},[_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addListeTypeTravaux()}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('input',{ref:"fileInputExcel",staticStyle:{"display":"none"},attrs:{"name":"fileInputExcel","type":"file","accept":"image/*"},on:{"change":_vm.onFileExcelPicked}}),_vm._v(" "),(true)?_c('v-btn',{attrs:{"slot":"activator","color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.$refs.fileInputExcel.click()}},slot:"activator"},[_vm._v("\n                Importer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_download")])],1):_vm._e(),_vm._v("Importer fichier excel\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(true)?_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.generateFileExcel()}},slot:"activator"},[_vm._v("\n                Générer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1):_vm._e(),_vm._v("Générer un modèle\n            ")],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeLots,"border":""}},[_c('el-table-column',{attrs:{"prop":"ordre","label":"Ordre"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-select',{attrs:{"placeholder":"Select"},on:{"change":function($event){return _vm.changeOrdre(prop.row.ordre, prop.$index)}},model:{value:(prop.row.ordre),callback:function ($$v) {_vm.$set(prop.row, "ordre", $$v)},expression:"prop.row.ordre"}},_vm._l((_vm.listeNumber),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.num,"value":item.num}})}),1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"code","label":"Code"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input',{attrs:{"controls-position":"right","size":"small"},model:{value:(prop.row.code),callback:function ($$v) {_vm.$set(prop.row, "code", $$v)},expression:"prop.row.code"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé travaux"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input',{attrs:{"controls-position":"right","size":"small"},on:{"change":function($event){return _vm.handleChangeLibelle()}},model:{value:(prop.row.libelle),callback:function ($$v) {_vm.$set(prop.row, "libelle", $$v)},expression:"prop.row.libelle"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"description"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input',{attrs:{"type":"textarea","controls-position":"right","size":"small"},model:{value:(prop.row.description),callback:function ($$v) {_vm.$set(prop.row, "description", $$v)},expression:"prop.row.description"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Opérations","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.listeLots)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                      Supprimer ce lot\n                    ")],1)]}}])})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","align-self-end":"","mt-4":""}},[_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pr-1",attrs:{"xs2":"","offset-xs8":""}},[_c('v-btn',{attrs:{"block":"","color":"grey","dark":""},on:{"click":function($event){return _vm.closeForm()}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"green","dark":""},on:{"click":function($event){return _vm.submitTravaux()}},slot:"activator"},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('LoadTypeTravauxExcel',{attrs:{"show":_vm.showModalLoadTypeTravaux,"listeTypeTravaux":_vm.lstTypeTravaux,"idTypeProjet":this.idTypeProjet},on:{"close":function($event){_vm.showModalLoadTypeTravaux = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uxb+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uxeM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v/m6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutReserve_vue__ = __webpack_require__("Ixl6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c13a6e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutReserve_vue__ = __webpack_require__("KqlW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutReserve_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c13a6e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutReserve_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v6OC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//liste l'ensemble  des besoins  ou les besoinsa valider par un responsable

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  name: "ListeBesoinTravaux",
  props: {
    show: {
      type: Boolean
    },
    idresponsable: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      dialogBesoinAchat: false,
      dialogAttriVeh: false,
      multipleSelection: [],
      disabledBtnAchat: true,
      disabledAttriVeh: false,
      formAttrib: {},
      besoinSelect: {},
      listeBesoinsVeh: [],
      comboVeh: [],
      listParc: '',
      selectParc: ''
    };
  },

  methods: {
    loadVehicule: function loadVehicule() {
      var _this = this;

      var url = this.domaine + "vehicule/liste_vehicule";
      this.$http.get(url).then(function (response) {
        _this.comboVeh = response.body.vehicule;
      });
    },
    modalAttribVehicule: function modalAttribVehicule(item) {
      this.besoinSelect = item;
      this.dialogAttriVeh = true;
    },
    modalShowServiceAchat: function modalShowServiceAchat() {
      this.dialogBesoinAchat = true;
    },
    attribVeh: function attribVeh() {
      var _this2 = this;

      this.loading = true;
      var url = this.domaine + "besoin/attribuer/vehicule";
      var formdata = new FormData();
      formdata.append("idVeh", this.formAttrib.idVeh);
      formdata.append("qte", this.formAttrib.qte);
      formdata.append("idBesoin", this.besoinSelect.id);
      formdata.append("idUser", this.user.id);
      this.$http.post(url, formdata).then(function (response) {
        _this2.loading = false;
        _this2.dialogAttriVeh = false;
        _this2.selectParc = '';
        _this2.formAttrib.idVeh = '';
        _this2.formAttrib.qte = '';
        _this2.loadBesoinVehAvalider();
        _this2.$emit("reloadBesoinValider");
        _this2.$notify({
          title: "Validation besoins",
          message: "L'opération s'est déroulée avec succès",
          type: "success",
          position: "top-center"
        });
      }, function (error) {
        _this2.loading = false;
        _this2.dialogAttriVeh = false;
        _this2.$message.error("Erreur lors de l'attribution du véhicule aux travaux");
      });
    },
    validBesoinAchat: function validBesoinAchat(decision) {
      var _this3 = this;

      this.loading = true;

      //decision == 1 = Valider // decision == 0 //Refuser
      var formdata = new FormData();
      var url = this.domaine + "besoin/transfert";
      var optBesoins = [];
      for (var prop in this.multipleSelection) {
        var ligne = this.multipleSelection[prop];
        optBesoins.push(ligne.id);
      }
      formdata.append("optBesoins", optBesoins);
      formdata.append("decision", decision);
      this.$http.post(url, formdata).then(function (response) {
        _this3.loadBesoinVehAvalider();
        _this3.dialogBesoinAchat = false;
        _this3.loading = false;
        _this3.$emit("reloadBesoinValider");
        _this3.$notify({
          title: "Validation besoins",
          message: "L'opération s'est déroulée avec succès",
          type: "success",
          position: "top-center"
        });
      }, function (error) {
        _this3.dialogBesoinAchat = false;
        _this3.loading = false;
        _this3.$message.error("Erreur lors du chargement de la validation des besoins");
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.disabledBtnAchat = true;
      } else {
        this.disabledBtnAchat = false;
      }
    },
    loadBesoinVehAvalider: function loadBesoinVehAvalider() {
      var _this4 = this;

      this.loading = true;
      var url = this.domaine + "besoin/vehicule";
      this.$http.get(url).then(function (response) {
        _this4.listeBesoinsVeh = response.body.besoins;
        _this4.nbBesoins = response.body.besoins.length;
        _this4.loading = false;
      });
    },
    loadTypeParc: function loadTypeParc(item) {
      var _this5 = this;

      this.loading = true;
      var url = this.domaine + "parc/parcSelect/" + item;
      this.$http.get(url).then(function (response) {
        _this5.loading = false;
        _this5.comboVeh = response.body.detailVehi;
      }, function (errRep) {
        _this5.loading = false;
        _this5.$message.error("Une erreur est survenue lors du chargement de la liste des vehicules");
      });
    },
    loadParc: function loadParc() {
      var _this6 = this;

      var url = this.domaine + "parc/index/parc";
      this.$http.get(url).then(function (response) {
        if (response.body.parc) {
          var tableau = response.body.parc;
          for (var i = 0; i < tableau.length; ++i) {
            for (var j = i + 1; j < tableau.length; ++j) {
              if (tableau[i].libelle === tableau[j].libelle) {
                tableau.splice(j--, 1);
              }
            }
          }
          _this6.listParc = tableau;
        }
      });
    }
  },
  mounted: function mounted() {
    this.loadVehicule();
    this.loadParc();
    this.loadBesoinVehAvalider();
  }
});

/***/ }),

/***/ "v9GS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comparateur_journal_vue__ = __webpack_require__("r8Q+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c9b7dd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comparateur_journal_vue__ = __webpack_require__("y5D2");
function injectStyle (ssrContext) {
  __webpack_require__("b0Nn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comparateur_journal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c9b7dd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comparateur_journal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vA4v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text))])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-text',{attrs:{"fluid":"","grid-list-md":""}},[_c('h2',[_vm._v("LISTE DES DEMANDES DE FONDS")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"elevation-4",staticStyle:{"width":"100%"},attrs:{"label":"","outline":"","color":"orange darken-1"}},[_c('span',{staticClass:"subheading"},[_vm._v("Montant Total: ")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.mntTotal)+" Fcfa ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1 ",attrs:{"xs4":"","md4":""}},[_c('v-card-text',{},[_c('v-chip',{staticStyle:{"font-size":"18px"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v(_vm._s(_vm.totalDmd))]),_vm._v("\n                Demandes\n              ")],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right mb-3"},[(_vm.droitAcces.create_demande_fond)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.modalAjoutDmd()}},slot:"activator"},[_vm._v("Ajouter une demande "),_c('v-icon',{attrs:{"right":""}},[_vm._v("playlist_add")])],1),_vm._v("\n            Effectuer une demande de fonds\n          ")],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.imprimer_liste_demandeFond)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeDemandePDF()}},slot:"activator"},[_vm._v("\n              Imprimer\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v(" print")])],1),_vm._v("\n            Imprimer la liste des demandes\n          ")],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}}),_vm._v(" "),_c('div',{staticClass:"text-xs-right "},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"Selectionner une caisse"},on:{"clear":function($event){return _vm.clearSelect()},"change":_vm.filtrerCaisseDmd},model:{value:(_vm.selectCaisseDmd),callback:function ($$v) {_vm.selectCaisseDmd=$$v},expression:"selectCaisseDmd"}},_vm._l((_vm.listeCaisse),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1),_vm._v(" "),_c('el-select',{attrs:{"clearable":"","placeholder":"Selectionner le statut"},on:{"clear":function($event){return _vm.clearSelect()},"change":_vm.filtrerEtatDmd},model:{value:(_vm.selectEtatDmd),callback:function ($$v) {_vm.selectEtatDmd=$$v},expression:"selectEtatDmd"}},_vm._l((_vm.listeStatut),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('data-tables',{attrs:{"data":_vm.listeDemandes}},[_c('el-table-column',{attrs:{"prop":"dateFormat","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"demandeur","label":"Nom du demandeur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montantFormat","label":"Montant (Fcfa)"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libStatut","label":"Statut"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.statut == 0)?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v("\n                "+_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 1)?_c('el-tag',[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 2)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 3)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 4)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e(),_vm._v(" "),(scope.row.statut == 5)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.libStatut))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"caissePaie","label":"Caisse paiement"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.caissePaie))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"carte","label":"Carte"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.carte)?_c('el-tag',{attrs:{"type":"info"}},[_vm._v(_vm._s(scope.row.carte))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Action","align":"center","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"grey"},on:{"click":function($event){return _vm.modalImpDmd(scope.row)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("list")])],1),_vm._v("\n                Detail\n              ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(scope.row.statut == 1 || scope.row.statut == 5),expression:"scope.row.statut == 1 || scope.row.statut == 5"}],attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.itemDmd = scope.row;
                    _vm.dialogSupr = true;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1),_vm._v("\n                Supprimer\n              ")],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("DEMANDE")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("\n              DMD-"+_vm._s(_vm.itemDmd.id)+"\n            ")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.deleteDmd()}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)],1)],1),_vm._v(" "),_c('AjoutDemandeFond',{attrs:{"editForm":_vm.editFormDmd,"dmdDetail":_vm.dmdDetail,"show":_vm.showModalAjoutDmd},on:{"close":function($event){_vm.showModalAjoutDmd = false;
      _vm.loadDemande();}}}),_vm._v(" "),_c('ModalValidationDmdFond',{attrs:{"valider":false,"logistique":false,"demandeDetail":_vm.demandeDetailFond,"show":_vm.showModalDetailDmdFond},on:{"close":_vm.showDialogDmdFondAfter}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vMrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","scrollable":"","loading":_vm.loading,"fullscreen":"","hide-overlay":""},model:{value:(_vm.dialogDetail),callback:function ($$v) {_vm.dialogDetail=$$v},expression:"dialogDetail"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Fiche de Validation du bon de commande interne\n          "+_vm._s(_vm.detailCommande.ref))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',[_c('v-flex',[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                    Informations générales\n                  ")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Projet")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.projet)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.chantier)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Travaux")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.travaux)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Tâches")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},_vm._l((_vm.detailCommande.tache),function(item,index){return _c('span',{key:index},[_c('v-chip',{attrs:{"outline":"","label":""}},[_vm._v("\n                                        "+_vm._s(item)+"\n                                      ")]),_vm._v("\n                                      /\n                                    ")],1)}),0)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("PK début")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.tranconA)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("PK fin")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.tranconB)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de la livraison")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.dateLivr)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Demandeur")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.user)+"\n                                  ")])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.urlImage)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","id":"intro","dark":""},on:{"click":function($event){return _vm.showDiapo([_vm.urlImage], 0, _vm.urlImage)}},slot:"activator"},[_vm._v("Voir la pièce justificatif\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("list")])],1):_vm._e(),_vm._v("\n                    Voir la pièce justificatif\n                  ")],1)],1),_vm._v(" "),_c('CoolLightBox',{attrs:{"items":_vm.items,"index":_vm.index},on:{"close":function($event){_vm.index = null}}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                    liste des ressources\n                  ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('el-table',{staticClass:"text-center",attrs:{"data":_vm.detailCommande.option,"border":""}},[_c('el-table-column',{staticClass:"text-center",attrs:{"prop":"codeAnalytique","label":"Code analytique"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.codeAnalytique))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"codeGestion","label":"Code de gestion"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.codeGestion))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"400","prop":"produit","label":"Ressource"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"orange accent-3"}},[_vm._v(_vm._s(scope.row.produit))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"80","prop":"unite","label":"unité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.unite))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"250","prop":"qte","label":"Quantité commandé"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input-number',{attrs:{"min":0,"name":"qte"},model:{value:(prop.row.qte),callback:function ($$v) {_vm.$set(prop.row, "qte", $$v)},expression:"prop.row.qte"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteStock","label":"Quantité en stock"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(new Intl.NumberFormat("fr-Fr").format(scope.row.qteStock)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"budgetPre","label":"Budget Prévu"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(new Intl.NumberFormat("fr-Fr").format(scope.row.budgetPre)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalDepn","label":"Budget Engagé"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(new Intl.NumberFormat("fr-Fr").format(scope.row.totalDepn)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"budgetR","label":"Budget Restant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(new Intl.NumberFormat("fr-Fr").format(scope.row.budgetR)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Opérations","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();_vm.dialogSupr = true;
                                _vm.deleteRow(scope.$index, _vm.detailCommande.option)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                            Supprimer cette tâche\n                          ")],1)]}}])})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5",staticStyle:{"margin-right":"100px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"red"},on:{"click":function($event){_vm.dialogConfirmRefus = true}},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Rejeter la commande")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"green"},on:{"click":function($event){_vm.dialogConfirm = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v("Valider la commande")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirmRefus),callback:function ($$v) {_vm.dialogConfirmRefus=$$v},expression:"dialogConfirmRefus"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation du bon de commande interne")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous Refuser ce bon de commnde ?","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("\n                COMMANDE REFERENCE\n              ")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("\n                "+_vm._s(_vm.detailCommande.ref)+"\n              ")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirmRefus = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideDevis('rejeter')}}},[_vm._v("Refuser")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation d'un bon de commande interne (bci)")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous valider ce bon de commande interne ?","closable":false,"show-icon":"","type":"success"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("\n                BON DE COMMANDE REFERENCE\n              ")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("\n                "+_vm._s(_vm.detailCommande.ref)+"\n              ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{ref:"refFormRefust",staticClass:"demo-form-inline",attrs:{"id":"formRefus","label-position":"top","inline":true,"model":_vm.formRefus}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Commentaire","prop":"rapportRefus"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Commentaire"},model:{value:(_vm.formRefus.rapport),callback:function ($$v) {_vm.$set(_vm.formRefus, "rapport", $$v)},expression:"formRefus.rapport"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirm = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideDevis('confirme')}}},[_vm._v("Confirmer")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cette ligne ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteBesoin()}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vRkt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":"chevron_right"}},_vm._l((_vm.items),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n          "+_vm._s(item.text)+"\n        ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[(_vm.nbrSms === 0)?_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n        VOUS N'AVEZ PLUS D'SMS. VOUS NE POUVEZ DONC PAS RECEVOIR D'SMS DE NOTIFICATION. VEUILLEZ RECHARGER VOTRE COMPTE \n      ")]):_vm._e()],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('div',{staticStyle:{"width":"1400px","height":"400px"},attrs:{"id":"userChart"}})])],1),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[(_vm.droitAcces.last_commande)?_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('div',{staticClass:"text item"},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeCmde('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeCmde('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnCmd,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                          ")])],1)],1)],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                        LISTE DES 10 DERNIÈRES COMMANDES\n                      ")])],1),_vm._v(" "),_c('el-table',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listLastCommande,"default-sort":{prop: 'id', order: 'descending'},"stripe":"","border":"","height":"350"}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Référence","width":"100","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.ref)+"\n                          ")])]}}],null,false,9181187)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Montant","width":"230"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(scope.row.total)+" FCFA"),_c('v-icon',{attrs:{"right":""}})],1)]}}],null,false,3941333389)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Etat","width":"280"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.factureValide === 0)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                  EN ATTENTE DE VALIDATION"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.factureValide === 1)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                  VALIDE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.factureValide === 2)?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                  REJETE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat === false)?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                  NON LIVRE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat == true)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                  LIVRE EN TOTALITE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}],null,false,3809083512)})],1)],1)])],1)]):_vm._e(),_vm._v(" "),(_vm.droitAcces.last_facture)?_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('div',{staticClass:"text item"},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeFact('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeFact('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnFact,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                          ")])],1)],1)],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                        LISTE DES 10 DERNIÈRES FACTURES\n                      ")])],1),_vm._v(" "),_c('el-table',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listLastFacture,"default-sort":{prop: 'id', order: 'descending'},"stripe":"","border":"","height":"350"}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Référence","width":"100","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.ref)+"\n                          ")])]}}],null,false,9181187)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Montant","width":"230"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(scope.row.total)+" FCFA"),_c('v-icon',{attrs:{"right":""}})],1)]}}],null,false,3941333389)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etatFact","label":"Etat","width":"280"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etatFact === 0)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                  EN ATENTE DE VALIDATION"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etatFact === 1)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                  VALIDE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etatFact === 2)?_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                                  REJETE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etatReglFact === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                  IMPAYE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etatReglFact === true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                  PAYE"),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}],null,false,3414825462)})],1)],1)])],1)]):_vm._e(),_vm._v(" "),(_vm.droitAcces.last_livraison)?_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeLiv('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeLiv('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnLiv,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                          ")])],1)],1)],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                        LISTE DES 10 DERNIÈRES LIVRAISONS\n                      ")])],1),_vm._v(" "),_c('el-table',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listLastLivraison,"default-sort":{prop: 'id', order: 'descending'},"stripe":"","border":"","height":"350"}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Référence","width":"100","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.ref)+"\n                          ")])]}}],null,false,9181187)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"commande","label":"Commande","width":"230"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(scope.row.commande)+" "+_vm._s(scope.row.libelle)+" "),_c('v-icon',{attrs:{"right":""}})],1),_vm._v(" "),(scope.row.etat === false)?_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n                                  PARTIELLEMENT LIVRE "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e(),_vm._v(" "),(scope.row.etat === true)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                  TOTALEMENT LIVRE "),_c('v-icon',{attrs:{"right":""}})],1):_vm._e()]}}],null,false,523314167)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date","width":"280"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(scope.row.date)+"\n                              ")])]}}],null,false,809252507)})],1)],1)],1),_vm._v(" "),_c('br')]):_vm._e()],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[(_vm.droitAcces.last_paiement)?_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('div',{staticClass:"text item"},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListePaie('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListePaie('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnPaie,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                              ")])],1)],1)],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                            LISTE DES 10 DERNIERS PAIEMENTS\n                          ")])],1),_vm._v(" "),_c('el-table',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listLastPaiemnet,"default-sort":{prop: 'id', order: 'descending'},"stripe":"","border":"","height":"350"}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Référence","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                "+_vm._s(scope.row.ref)+"\n                              ")])]}}],null,false,1321340931)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                      IMPAYE\n                                  ")]):_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                      PAYE\n                                  ")])]}}],null,false,1340547924)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                                      "+_vm._s(scope.row.montant)+" FCFA\n                                  ")])]}}],null,false,1249382309)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date","width":"240"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                                      "+_vm._s(scope.row.date)+"\n                                  ")])]}}],null,false,506251472)})],1)],1)])],1)]):_vm._e(),_vm._v(" "),(_vm.droitAcces.retard_paiement)?_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-card',{staticClass:"box-card",staticStyle:{"background":"#fff"}},[_c('div',{staticClass:"text item"},[_c('v-flex',{attrs:{"xs3":""}},[_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeRetard('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeRetard('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtnReta,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                              ")])],1)],1)],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"20px","width":"100%"},attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                            LISTE DES PAIEMENTS EN RETARD\n                          ")])],1),_vm._v(" "),_c('el-table',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listRetardPaiemnet,"default-sort":{prop: 'id', order: 'descending'},"stripe":"","border":"","height":"350"}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Référence","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                "+_vm._s(scope.row.ref)+"\n                              ")])]}}],null,false,1321340931)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"concerne","label":"Concerne"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                      "+_vm._s(scope.row.concerne)+"\n                                  ")])]}}],null,false,2550870418)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                      "+_vm._s(scope.row.etat)+"\n                                  ")])]}}],null,false,3306228041)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fournisseur","label":"Fournisseur"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Montant","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                                      "+_vm._s(scope.row.total)+" FCFA\n                                  ")])]}}],null,false,1555144644)})],1)],1)])],1),_vm._v(" "),_c('br')]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vSGz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","scrollable":"","loading":_vm.loading,"fullscreen":"","hide-overlay":""},model:{value:(_vm.dialogDetail),callback:function ($$v) {_vm.dialogDetail=$$v},expression:"dialogDetail"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Fiche de Validation du bon de commande interne\n          "+_vm._s(_vm.detailCommande.ref))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',[_c('v-flex',[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                    Informations générales\n                  ")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Projet")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.projet)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.chantier)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Travaux")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.travaux)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Tâches")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},_vm._l((_vm.detailCommande.tache),function(item,index){return _c('span',{key:index},[_c('v-chip',{attrs:{"outline":"","label":""}},[_vm._v("\n                                        "+_vm._s(item)+"\n                                      ")]),_vm._v("\n                                      /\n                                    ")],1)}),0)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("PK début")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.tranconA)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("PK fin")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.tranconB)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de la livraison")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.dateLivr)+"\n                                  ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Demandeur")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left title",attrs:{"xs6":""}},[_vm._v("\n                                    "+_vm._s(_vm.detailCommande.user)+"\n                                  ")])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.urlImage)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","id":"intro","dark":""},on:{"click":function($event){return _vm.showDiapo([_vm.urlImage], 0, _vm.urlImage)}},slot:"activator"},[_vm._v("Voir la pièce justificatif\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("list")])],1):_vm._e(),_vm._v("\n                    Voir la pièce justificatif\n                  ")],1)],1),_vm._v(" "),_c('CoolLightBox',{attrs:{"items":_vm.items,"index":_vm.index},on:{"close":function($event){_vm.index = null}}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                    liste des ressources\n                  ")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('el-table',{staticClass:"text-center",attrs:{"data":_vm.detailCommande.option,"border":""}},[_c('el-table-column',{staticClass:"text-center",attrs:{"prop":"codeAnalytique","label":"Code analytique"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.codeAnalytique))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"codeGestion","label":"Code de gestion"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.codeGestion))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"400","prop":"produit","label":"Ressource"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","fab":"","color":"orange accent-3"}},[_vm._v(_vm._s(scope.row.produit))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"80","prop":"unite","label":"unité"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(scope.row.unite))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"250","prop":"qte","label":"Quantité commandé"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input-number',{attrs:{"min":0,"name":"qte"},model:{value:(prop.row.qte),callback:function ($$v) {_vm.$set(prop.row, "qte", $$v)},expression:"prop.row.qte"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteStock","label":"Quantité en stock"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(new Intl.NumberFormat("fr-Fr").format(scope.row.qteStock)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"budgetPre","label":"Budget Prévu"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(new Intl.NumberFormat("fr-Fr").format(scope.row.budgetPre)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalDepn","label":"Budget Engagé"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(new Intl.NumberFormat("fr-Fr").format(scope.row.totalDepn)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"budgetR","label":"Budget Restant"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('b',[_vm._v(_vm._s(new Intl.NumberFormat("fr-Fr").format(scope.row.budgetR)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Opérations","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();_vm.dialogSupr = true;
                                _vm.deleteRow(scope.$index, _vm.detailCommande.option)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                            Supprimer cette tâche\n                          ")],1)]}}])})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5",staticStyle:{"margin-right":"100px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"red"},on:{"click":function($event){_vm.dialogConfirmRefus = true}},slot:"activator"},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('span',[_vm._v("Rejeter la commande")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"mb-5 ml-5",attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"green"},on:{"click":function($event){_vm.dialogConfirm = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v("Valider la commande")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirmRefus),callback:function ($$v) {_vm.dialogConfirmRefus=$$v},expression:"dialogConfirmRefus"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation du bon de commande interne")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous Refuser ce bon de commnde ?","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("\n                COMMANDE REFERENCE\n              ")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("\n                "+_vm._s(_vm.detailCommande.ref)+"\n              ")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirmRefus = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideDevis('rejeter')}}},[_vm._v("Refuser")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation d'un bon de commande interne (bci)")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous valider ce bon de commande interne ?","closable":false,"show-icon":"","type":"success"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("\n                BON DE COMMANDE REFERENCE\n              ")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("\n                "+_vm._s(_vm.detailCommande.ref)+"\n              ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{ref:"refFormRefust",staticClass:"demo-form-inline",attrs:{"id":"formRefus","label-position":"top","inline":true,"model":_vm.formRefus}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Commentaire","prop":"rapportRefus"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Commentaire"},model:{value:(_vm.formRefus.rapport),callback:function ($$v) {_vm.$set(_vm.formRefus, "rapport", $$v)},expression:"formRefus.rapport"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirm = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideDevis('confirme')}}},[_vm._v("Confirmer")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("\n          Voulez-vous vraiment supprimer cette ligne ?\n        ")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteBesoin()}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vbkS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LoadConducteurExcel",
  components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
  props: {
    listeTypeTravaux: {
      type: Array,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    idTypeProjet: {
      type: Number
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      dialogAjoutConducteur: false,
      loading: false
    };
  },

  watch: {
    show: function show(newValue, oldValue) {
      if (newValue == true) {
        this.dialogAjoutConducteur = true;
      } else {
        this.dialogAjoutConducteur = false;
      }
    }
  },
  methods: {
    saveListe: function saveListe() {
      var _this = this;

      var succesEnreg = true;
      var url = this.domaine + "projet/save/liste_TypeTravaux/excel";
      var nbData = 10;
      var nbReq = 1;
      var ligne = null;

      var nbRest = void 0;
      if (this.listeTypeTravaux.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.listeTypeTravaux.length / nbData);
        nbRest = this.listeTypeTravaux.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }

      for (var i = 0; i < nbReq; i++) {
        var initJ = i * nbData;
        var finJ = (i + 1) * nbData;
        var dataLot = [];
        if (this.listeTypeTravaux.length > 0) {
          for (var j = initJ; j < finJ; j++) {
            if (this.listeTypeTravaux[j] == undefined) {
              break;
            }
            dataLot.push(this.listeTypeTravaux[j]);
          }
        }
        var data = new FormData();

        for (var prop in dataLot) {
          ligne = dataLot[prop];
          data.append("option[ordre][]", ligne.ordre);
          data.append("option[libelle][]", ligne.libelle);
          data.append("option[code][]", ligne.code);
          data.append("option[description][]", ligne.description);
        }

        // data.append('listeTypeTravaux', JSON.stringify(dataLot))
        data.append("type", this.idTypeProjet);
        data.append("idUser", this.user.id);

        this.$http.post(url, data).then(function (resp) {}, function (error) {
          _this.loading = false;
          _this.$message.error("Erreur lors de l'enregistrement des types travaux");
          succesEnreg = false;
          window.location.reload();
        });
      }
      var loading = this.$loading({
        lock: true,
        text: "Veuillez patientez ...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
        // this.loading = false
        if (succesEnreg == true) {
          _this.dialogAjoutConducteur = false;
          _this.$emit("close");
          _this.$emit("showModalLoadTypeTravaux");

          _this.$notify({
            title: "Enregistrement",
            message: "La liste a ete enregistre avec succes",
            type: "success",
            position: "top-right",
            duration: 7000
          });
        }
      }, 30000);
    },
    loadTravauxParType: function loadTravauxParType() {
      var _this2 = this;

      this.loading = true;
      setTimeout(function () {
        _this2.listeProjetTravaux.splice(0);
        var url = _this2.domaine + "projet/liste/typeTravaux";
        _this2.$http.get(url).then(function (response) {
          _this2.listeProjetTravaux = response.body.listeProjetTravaux;
          _this2.loading = false;
        }, function (error) {
          _this2.loading = false;
          _this2.$message.error("Erreur lors du chargement des travaux ");
        });
      }, 2000);
    },
    closeDialog: function closeDialog() {
      var _this3 = this;

      var loading = this.$loading({
        lock: true,
        text: "Veuillez patientez ...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(function () {
        loading.close();
        _this3.$emit("close");
      }, 1000);
    }
  }
});

/***/ }),

/***/ "vnsy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('el-form',{ref:"formAbsence",staticClass:"demo-form-inline",attrs:{"model":_vm.formDmdAbsence}},[_c('el-row',{attrs:{"type":"flex","gutter":20,"justify":"center"}},[_c('el-col',{attrs:{"span":14}},[_c('div',{staticClass:"block"},[_c('el-form-item',{attrs:{"label":"Période de congé"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy HH:mm","value-format":"yyyy-MM-dd HH:mm","type":"datetimerange","range-separator":"au","start-placeholder":"Début date","end-placeholder":"Fin date"},model:{value:(_vm.formDmdAbsence.datedbtFin),callback:function ($$v) {_vm.$set(_vm.formDmdAbsence, "datedbtFin", $$v)},expression:"formDmdAbsence.datedbtFin"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('div',[_c('el-form-item',{attrs:{"label":"Type de congé"}},[_c('el-select',{attrs:{"placeholder":"Type de congé"},model:{value:(_vm.formDmdAbsence.idTypeConge),callback:function ($$v) {_vm.$set(_vm.formDmdAbsence, "idTypeConge", $$v)},expression:"formDmdAbsence.idTypeConge"}},_vm._l((_vm.listeTypeConge),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1)])],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{staticStyle:{"width":"97%"},attrs:{"label":"Description"}},[_c('el-input',{attrs:{"type":"textarea","rows":6},model:{value:(_vm.formDmdAbsence.desc),callback:function ($$v) {_vm.$set(_vm.formDmdAbsence, "desc", $$v)},expression:"formDmdAbsence.desc"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","gutter":20}},[_c('el-col',{attrs:{"span":24}},[_c('el-upload',{ref:"uploadFichAbsence",staticClass:"upload-demo",attrs:{"list-type":"picture-card","name":"photo","action":"","auto-upload":false,"on-change":_vm.changeFile,"multiple":true}},[_c('img',{staticClass:"lazy",attrs:{"height":"142","width":"142","src":"","alt":""}})])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","gutter":20,"justify":"end"}},[_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"mt-4",staticStyle:{"width":"100%"}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","disabled":!_vm.formIsValid,"color":"green"},on:{"click":function($event){return _vm.submitForm()}},slot:"activator"},[_vm._v("\n\n                            Enregistrer\n                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1),_vm._v("\n                        enregistrer une demande\n                    ")],1)],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "voI1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('v-breadcrumbs',{attrs:{"icons":"","divider":">"}},_vm._l((_vm.racourcis),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"icons":"","router":"","to":item.path,"disabled":item.disabled}},[_vm._v("\n            "+_vm._s(item.text)+"\n          ")])}),1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.droitAcces.caisse)?_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticStyle:{"width":"1300px","height":"300px"},attrs:{"id":"chartAllBilan"}})])],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"elevation-6 pt-1 mb-3",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"sm12":""}},[_c('h3',[_vm._v("Critères de recherche pour les factures en attente de paiement ")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"model":_vm.formTri,"id":"formTri"}},[_c('el-form-item',{attrs:{"label":"Période"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"datetimerange","range-separator":"à","start-placeholder":"Début date","end-placeholder":"Fin date"},model:{value:(_vm.formTri.periode),callback:function ($$v) {_vm.$set(_vm.formTri, "periode", $$v)},expression:"formTri.periode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Trésorerie"}},[_c('el-select',{attrs:{"filterable":"","multiple":"","clearable":"","placeholder":"Trésorerie"},model:{value:(_vm.selectTresor),callback:function ($$v) {_vm.selectTresor=$$v},expression:"selectTresor"}},_vm._l((_vm.listCaisse),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Type de facture"}},[_c('el-select',{attrs:{"clearable":"","multiple":"","placeholder":"Type de facture"},model:{value:(_vm.selectTypes),callback:function ($$v) {_vm.selectTypes=$$v},expression:"selectTypes"}},_vm._l((_vm.listeTypeF),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","color":"blue","fab":"","small":""},on:{"click":function($event){return _vm.rechercheFacture()}},slot:"activator"},[_c('v-icon',[_vm._v("search")])],1),_vm._v("Effectuer une recherche\n                        ")],1)],1)],1)],1)],1),_vm._v(" "),(_vm.showRecherche)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-card',{staticClass:"elevation-4"},[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"cyan darken-2","dark":""}},[_c('v-toolbar-title',[_vm._v("LISTE DES FACTURES IMPAYEES ")])],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeRech()}},slot:"activator"},[_vm._v("\n                              Imprimer "),_c('v-icon',[_vm._v("print")])],1),_vm._v("\n                            Imprimer la liste des factures de la recherche\n                          ")],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"text-xs-center",staticStyle:{"height":"auto"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","header-row-style":_vm.headerRowStyle,"highlight-current-row":"","data":_vm.listResulat,"summary-method":_vm.getSumm,"show-summary":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.fourn)?_c('div',[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label ")]),_vm._v(" "),_c('span',[_vm._v("FOUNISSEUR/PRESTATAIRE")])],1),_vm._v(" "),_c('el-table',{staticClass:"elevation-2",staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":props.row.fourn,"summary-method":_vm.getSumm,"show-summary":""}},[_c('el-table-column',{attrs:{"align":"center","prop":"ref","sortable":"","label":"REFERENCE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(_vm._s(prop.row.ref))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"projet","label":"PROJET"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"concerne","label":"FOURNISSEUR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"impaye","label":"MONTANT IMPAYE"},scopedSlots:_vm._u([{key:"default",fn:function(prop3){return [_c('el-tag',{staticClass:"subheading"},[_vm._v(_vm._s(new Intl.NumberFormat().format(prop3.row.impaye))+" FCFA")])]}}],null,true)})],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(props.row.mission)?_c('div',[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("MISSION")])],1),_vm._v(" "),_c('el-table',{staticClass:"elevation-2",staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":props.row.mission,"summary-method":_vm.getSumm,"show-summary":""}},[_c('el-table-column',{attrs:{"align":"center","prop":"ref","sortable":"","label":"REFERENCE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(_vm._s(prop.row.ref))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"projet","label":"PROJET"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"concerne","label":"FOURNISSEUR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"impaye","label":"MONTANT IMPAYE"},scopedSlots:_vm._u([{key:"default",fn:function(prop3){return [_c('el-tag',{staticClass:"subheading"},[_vm._v(_vm._s(new Intl.NumberFormat().format(prop3.row.impaye))+" FCFA")])]}}],null,true)})],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(props.row.interv)?_c('div',[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("INTERVENTION")])],1),_vm._v(" "),_c('el-table',{staticClass:"elevation-2",staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":props.row.interv,"summary-method":_vm.getSumm,"show-summary":""}},[_c('el-table-column',{attrs:{"align":"center","prop":"ref","sortable":"","label":"REFERENCE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(_vm._s(prop.row.ref))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"projet","label":"PROJET"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"concerne","label":"FOURNISSEUR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"impaye","label":"MONTANT IMPAYE"},scopedSlots:_vm._u([{key:"default",fn:function(prop3){return [_c('el-tag',{staticClass:"subheading"},[_vm._v(_vm._s(new Intl.NumberFormat().format(prop3.row.impaye))+" FCFA")])]}}],null,true)})],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(props.row.dmdfond)?_c('div',[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("DEMANDE DE FOND")])],1),_vm._v(" "),_c('el-table',{staticClass:"elevation-2",staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":props.row.dmdfond,"summary-method":_vm.getSumm,"show-summary":""}},[_c('el-table-column',{attrs:{"align":"center","prop":"ref","sortable":"","label":"REFERENCE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(_vm._s(prop.row.ref))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"projet","label":"PROJET"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"concerne","label":"FOURNISSEUR"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"impaye","label":"MONTANT IMPAYE"},scopedSlots:_vm._u([{key:"default",fn:function(prop3){return [_c('el-tag',{staticClass:"subheading"},[_vm._v(_vm._s(new Intl.NumberFormat().format(prop3.row.impaye))+" FCFA")])]}}],null,true)})],1)],1):_vm._e()]}}],null,false,32111044)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"libelle","label":"TRESORERIE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(_vm._s(prop.row.libelle))])]}}],null,false,3802561489)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"totalFacture","label":"MONTANT TOTAL"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v("\n                                          "+_vm._s(new Intl.NumberFormat().format(prop.row.totalFacture))+" FCFA\n                                          ")])]}}],null,false,2617850556)})],1)],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"text-xs-right mt-4"},[(_vm.droitAcces.caisse)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeAllTresorerie()}},slot:"activator"},[_vm._v("\n          Imprimer "),_c('v-icon',[_vm._v("print")])],1),_vm._v("\n        Imprimer la liste de la tresorerie\n      ")],1):_vm._e(),_vm._v(" "),(_vm.droitAcces.create_caisse)?_c('v-tooltip',{staticClass:"ml-3",attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newCaisse()}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1),_vm._v("\n        Ajouter une nouvelle caisse\n      ")],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjout),callback:function ($$v) {_vm.dialogAjout=$$v},expression:"dialogAjout"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter une nouvelle trésorerie")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification de la trésorerie "+_vm._s(_vm.caisseCourant.ref)+" ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjout = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formCaisse",attrs:{"lazy-validation":"","id":"formCaisse"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEdit != true)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  Ajout d'une nouvelle trésorerie "),_c('v-icon',{attrs:{"right":""}},[_vm._v("account_balance")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  Modifier la trésorerie "+_vm._s(_vm.caisseCourant.ref)+" / "+_vm._s(_vm.caisseCourant.libelle)),_c('v-icon',{attrs:{"right":""}},[_vm._v("account_balance")])],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Type de trésorerie *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.dialogEdit,"placeholder":"Type de trésorerie"},on:{"change":_vm.changeTresor},model:{value:(_vm.selectTresorerie),callback:function ($$v) {_vm.selectTresorerie=$$v},expression:"selectTresorerie"}},_vm._l((_vm.typeTresorerie),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Libellé de la trésorerie *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"libelle","placeholder":"Libellé de la trésorerie"},model:{value:(_vm.libelle),callback:function ($$v) {_vm.libelle=$$v},expression:"libelle"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Gérant *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Gérant"},model:{value:(_vm.selectAdmin),callback:function ($$v) {_vm.selectAdmin=$$v},expression:"selectAdmin"}},_vm._l((_vm.users),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.nom,"value":item.id}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectTresorerie == 'Caisse'),expression:"selectTresorerie == 'Caisse'"}],staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Categorie de la caisse")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.dialogEdit,"placeholder":"Categorie de la caisse"},model:{value:(_vm.categorie),callback:function ($$v) {_vm.categorie=$$v},expression:"categorie"}},_vm._l((_vm.categorieCaisse),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectTresorerie == 'Caisse'),expression:"selectTresorerie == 'Caisse'"}],staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Seuil minimum")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":5,"name":"seuilMin","placeholder":"Seuil minimum"},model:{value:(_vm.seuilMin),callback:function ($$v) {_vm.seuilMin=$$v},expression:"seuilMin"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectTresorerie == 'Caisse'),expression:"selectTresorerie == 'Caisse'"}],staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Seuil maximum")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":5,"name":"seuilMax","placeholder":"Seuil maximum"},model:{value:(_vm.seuilMax),callback:function ($$v) {_vm.seuilMax=$$v},expression:"seuilMax"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectTresorerie == 'Banque'),expression:"selectTresorerie == 'Banque'"}],staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Numero du compte")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"text","name":"numCompte","placeholder":"Numero du compte"},model:{value:(_vm.numCompte),callback:function ($$v) {_vm.numCompte=$$v},expression:"numCompte"}})],1)])],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.dialogEdit == false),expression:"dialogEdit == false"}],attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Solde initial")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"name":"soldeInitial","placeholder":"Solde initial"},model:{value:(_vm.soldeInitial),callback:function ($$v) {_vm.soldeInitial=$$v},expression:"soldeInitial"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-checkbox',{attrs:{"label":"Rendre la trésorerie disponible","name":"activer","value":"","color":"green","hide-details":""},model:{value:(_vm.activer),callback:function ($$v) {_vm.activer=$$v},expression:"activer"}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjout = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitCaisse()}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"45%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutTrans),callback:function ($$v) {_vm.dialogAjoutTrans=$$v},expression:"dialogAjoutTrans"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Transferer des fonds dans une autre trésorerie")]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification du transfert de fond "+_vm._s(_vm.approCourant.ref)+" de la caisse "+_vm._s(_vm.detailCaisse.ref)+" ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutTrans = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"transFertForm",staticClass:"demo-ruleForm",attrs:{"model":_vm.transFertForm,"rules":_vm.rulesTransfer,"id":"transFertForm","label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"Le montant","prop":"montantTransf"}},[_c('el-input',{attrs:{"type":"number","name":"montantTransf"},model:{value:(_vm.transFertForm.montantTransf),callback:function ($$v) {_vm.$set(_vm.transFertForm, "montantTransf", $$v)},expression:"transFertForm.montantTransf"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"rules":_vm.rulesAppro,"label":"Caisse concerne","prop":"caisse"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Selectionner une caisse"},model:{value:(_vm.transFertForm.caisseSelect),callback:function ($$v) {_vm.$set(_vm.transFertForm, "caisseSelect", $$v)},expression:"transFertForm.caisseSelect"}},_vm._l((_vm.listCaisseTransfert),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Le motif","prop":"libelleTransfert"}},[_c('el-input',{attrs:{"type":"textarea","name":"libelleTransfert","rows":5,"placeholder":"Presenter le motif"},model:{value:(_vm.transFertForm.libelleTransfert),callback:function ($$v) {_vm.$set(_vm.transFertForm, "libelleTransfert", $$v)},expression:"transFertForm.libelleTransfert"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":_vm.ClearTransfertForm}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){_vm.validTransfert = true}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"55%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutAppro),callback:function ($$v) {_vm.dialogAjoutAppro=$$v},expression:"dialogAjoutAppro"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Ajouter un nouvel approvisionnement à "+_vm._s(_vm.detailCaisse.ref))]):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('span',[_vm._v("Modification l'approvisionnement "+_vm._s(_vm.approCourant.ref)+" de la caisse "+_vm._s(_vm.detailCaisse.ref)+" ")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutAppro = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"approForm",staticClass:"demo-ruleForm",attrs:{"model":_vm.approForm,"rules":_vm.rulesAppro,"id":"approForm","label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"Le montant","prop":"montant"}},[_c('el-input',{attrs:{"type":"number","name":"montantAppro"},model:{value:(_vm.approForm.montant),callback:function ($$v) {_vm.$set(_vm.approForm, "montant", $$v)},expression:"approForm.montant"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Le motif","prop":"motif"}},[_c('el-input',{attrs:{"type":"textarea","name":"libelleAppro","rows":5,"placeholder":"Presenter le motif"},model:{value:(_vm.approForm.motif),callback:function ($$v) {_vm.$set(_vm.approForm, "motif", $$v)},expression:"approForm.motif"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":_vm.ClearApproForm}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitApproCaisse('approForm')}}},[_vm._v("Enregistrer"),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutValideAppro),callback:function ($$v) {_vm.dialogAjoutValideAppro=$$v},expression:"dialogAjoutValideAppro"}},[_c('v-card',[_c('v-toolbar',{staticClass:"green",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[(_vm.dialogEdit != true)?_c('span',[_vm._v("Valider l'approvisionnement "+_vm._s(_vm.approCourant.ref))]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogAjoutValideAppro = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formValideAppro",attrs:{"lazy-validation":"","id":"formValideAppro"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                  Validation approvisionnement "),_c('v-icon',{attrs:{"right":""}},[_vm._v("get_app")])],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"font-size":"15px","font-weight":"bold"},attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Motif de la demande")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.approCourant.motif,"placeholder":"Motif de la demande","disabled":true},model:{value:(_vm.approCourant.motif),callback:function ($$v) {_vm.$set(_vm.approCourant, "motif", $$v)},expression:"approCourant.motif"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Initiateur de la demande")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.approCourant.initiateur,"placeholder":"Initiateur de la demande","disabled":true},model:{value:(_vm.approCourant.initiateur),callback:function ($$v) {_vm.$set(_vm.approCourant, "initiateur", $$v)},expression:"approCourant.initiateur"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Chargé de validation")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.approCourant.validateur,"placeholder":"Chargé de validation","disabled":true},model:{value:(_vm.approCourant.validateur),callback:function ($$v) {_vm.$set(_vm.approCourant, "validateur", $$v)},expression:"approCourant.validateur"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant demandé (FCFA)")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"value":_vm.approCourant.montant,"placeholder":"Montant demandé (FCFA)","disabled":true},model:{value:(_vm.approCourant.montant),callback:function ($$v) {_vm.$set(_vm.approCourant, "montant", $$v)},expression:"approCourant.montant"}})],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Réponse *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Réponse"},model:{value:(_vm.selectReponseAppro),callback:function ($$v) {_vm.selectReponseAppro=$$v},expression:"selectReponseAppro"}},_vm._l((_vm.reponseAppro),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Remarque")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","name":"remarqueAppro","placeholder":"Remarque"},model:{value:(_vm.remarqueAppro),callback:function ($$v) {_vm.remarqueAppro=$$v},expression:"remarqueAppro"}})],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){_vm.dialogAjoutValideAppro = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.droitAcces.new_valider_appro)?_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitValideAppro()}}},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShow),callback:function ($$v) {_vm.dialogShow=$$v},expression:"dialogShow"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails de la trésorerie "+_vm._s(_vm.caisseCourant.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShow = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md3":""}},[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('p',[_c('b',[_vm._v("Désignation : ")]),_vm._v(" "+_vm._s(_vm.detailCaisse.libelle)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Gérant : ")]),_vm._v(" "+_vm._s(_vm.detailCaisseS.gerant)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Catégorie : ")]),_vm._v(" "+_vm._s(_vm.detailCaisseS.categorie)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Type de trésorerie : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                    "+_vm._s(_vm.detailCaisseS.type)+"\n                                  ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),(_vm.detailCaisseS.etat != true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                    FERME\n                                  ")]):_vm._e(),_vm._v(" "),(_vm.detailCaisseS.etat == true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                    OUVERT\n                                  ")]):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Solde initial : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                    "+_vm._s(_vm.detailCaisseS.soldeInitial)+" FCFA\n                                  ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Solde : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                    "+_vm._s(_vm.detailCaisseS.solde)+" FCFA\n                                  ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Seuil maximum : ")]),_vm._v(" "+_vm._s(_vm.detailCaisseS.seuilMax)+" FCFA")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Seuil minimum : ")]),_vm._v(" "+_vm._s(_vm.detailCaisseS.seuilMin1)+" FCFA")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enrégistrement : ")]),_vm._v(" "+_vm._s(_vm.detailCaisseS.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailCaisseS.modified)+" ")])])],1)],1)])])],1)],1),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('v-flex',{attrs:{"md9":""}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticStyle:{"width":"950px","height":"300px"},attrs:{"id":"chartAllBilanCaisseOnly"}})])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                SOLDE\n                              ")]),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                "+_vm._s(_vm.detailCaisseS.solde)+" FCFA\n                              ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                CREDIT\n                              ")]),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                "+_vm._s(_vm.montantEntree)+" FCFA\n                              ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                DEBIT\n                              ")]),_vm._v(" "),_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                "+_vm._s(_vm.montantSortie)+" FCFA\n                              ")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md12":""}},[(_vm.detailCaisse.solde1 <= _vm.detailCaisse.seuilMin)?_c('v-chip',{staticStyle:{"font-size":"15px","width":"100%"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                              ATTENTION VOTRE SEUIL MINIMUM EST ATTEINT, VEUILLEZ DONC FAIRE UN DEMANDE D'APPROVISIONNEMENT DE VOTRE CAISSE.\n                            ")]):_vm._e()],1)],1)],1)],1)],1)]),_vm._v(" "),(_vm.droitAcces.caisse_facture)?_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-form',{ref:"formFacture",attrs:{"lazy-validation":"","id":"formFacture"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-radio',{attrs:{"label":"fournisseur"},model:{value:(_vm.typeRech),callback:function ($$v) {_vm.typeRech=$$v},expression:"typeRech"}},[_vm._v("fournisseur/prestataire")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"mission"},model:{value:(_vm.typeRech),callback:function ($$v) {_vm.typeRech=$$v},expression:"typeRech"}},[_vm._v("Mission")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"fond"},model:{value:(_vm.typeRech),callback:function ($$v) {_vm.typeRech=$$v},expression:"typeRech"}},[_vm._v("Décaissement")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('el-radio',{attrs:{"label":"intervention"},model:{value:(_vm.typeRech),callback:function ($$v) {_vm.typeRech=$$v},expression:"typeRech"}},[_vm._v("Intervention")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"location"},model:{value:(_vm.typeRech),callback:function ($$v) {_vm.typeRech=$$v},expression:"typeRech"}},[_vm._v("Location")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"client"},model:{value:(_vm.typeRech),callback:function ($$v) {_vm.typeRech=$$v},expression:"typeRech"}},[_vm._v("Client")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(_vm.typeRech !='location')?_c('v-flex',{attrs:{"md2":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Type"},model:{value:(_vm.selectTypeFacture),callback:function ($$v) {_vm.selectTypeFacture=$$v},expression:"selectTypeFacture"}},_vm._l((_vm.typeFacture),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(this.selectTypeFacture === 1 || this.selectTypeFacture === 2)?_c('v-flex',{attrs:{"md3":""}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"value-format":"yyyy-MM-dd","id":"dateFact","name":"dateFact","rules":_vm.dateFactureRules,"type":"daterange","range-separator":"à","start-placeholder":"Date de début","end-placeholder":"Date de fin","required":""},model:{value:(_vm.dateFacture),callback:function ($$v) {_vm.dateFacture=$$v},expression:"dateFacture"}})],1):_vm._e(),_vm._v(" "),(_vm.typeRech !='location')?_c('v-flex',{attrs:{"md2":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","placeholder":"Etat"},model:{value:(_vm.selectEtatFacture),callback:function ($$v) {_vm.selectEtatFacture=$$v},expression:"selectEtatFacture"}},_vm._l((_vm.etatFacture),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.typeRech== 'fournisseur')?_c('v-flex',{attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Fournisseur"},model:{value:(_vm.selectFournisseur),callback:function ($$v) {_vm.selectFournisseur=$$v},expression:"selectFournisseur"}},_vm._l((_vm.listFournisseur),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.typeRech== 'projet')?_c('v-flex',{attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Projet"},model:{value:(_vm.selectProjet),callback:function ($$v) {_vm.selectProjet=$$v},expression:"selectProjet"}},_vm._l((_vm.listProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.typeRech== 'client')?_c('v-flex',{attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Client"},model:{value:(_vm.selectClient),callback:function ($$v) {_vm.selectClient=$$v},expression:"selectClient"}},_vm._l((_vm.listClient),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.typeRech== 'fond'),expression:"typeRech== 'fond'"}],attrs:{"md4":""}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","filterable":"","placeholder":"Demandeur"},model:{value:(_vm.selectDemandeur),callback:function ($$v) {_vm.selectDemandeur=$$v},expression:"selectDemandeur"}},_vm._l((_vm.listeDemandeur),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.value,"value":item.id}})}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md1":""}},[_c('v-btn',{attrs:{"icons":"","color":"blue","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.loadFacture(_vm.caisseCourant)}}},[_c('v-icon',[_vm._v("search")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.listFacture.length !== 0)?_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs2":""}},[(_vm.droitAcces.impression_search_facture)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeSearchFacture(_vm.caisseCourant.id)}},slot:"activator"},[_vm._v("\n                                  Imprimer "),_c('v-icon',[_vm._v("print")])],1),_vm._v("\n                                Imprimer la liste de recherche\n                              ")],1):_vm._e()],1)],1),_vm._v(" "),(_vm.droitAcces.caisse_facture)?_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listFacture,"default-sort":{prop: 'id', order: 'descending'},"stripe":"","border":"","height":"350"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"icons":"","text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                LISTE DES FACTURES "),_c('v-icon',{attrs:{"right":""}},[_vm._v("get_app")])],1)],1),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","width":"280","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(scope.row.libelle)+"\n                                ")])]}}],null,false,3094453493)}),_vm._v(" "),(_vm.listFacture.concerne != 'Aucun')?_c('el-table-column',{attrs:{"prop":"concerne","label":"Concerné","width":"220"}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [( isNaN(scope.row.etat) && scope.row.etat === 'IMPAYE'  )?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                  "+_vm._s(scope.row.etat)+"\n                                ")]):_vm._e(),_vm._v(" "),( isNaN(scope.row.etat) &&  scope.row.etat === 'SOLDE' )?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                  "+_vm._s(scope.row.etat)+"\n                                ")]):_vm._e(),_vm._v(" "),( isNaN(scope.row.etat) &&  scope.row.etat === 'EN COURS DE PAIEMENT')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                  "+_vm._s(scope.row.etat)+"\n                                ")]):_vm._e(),( isNaN(scope.row.etat) &&  scope.row.etat === 'EN ATTENTE DE PAIEMENT')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                "+_vm._s(scope.row.etat)+"\n                              ")]):_vm._e(),_vm._v(" "),(  scope.row.etatLibelle === 'IMPAYE' )?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                  "+_vm._s(scope.row.etatLibelle)+"\n                                ")]):_vm._e(),_vm._v(" "),(scope.row.etatLibelle === 'SOLDE' || scope.row.etatLibelle === 'PAYE' )?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                  "+_vm._s(scope.row.etatLibelle)+"\n                                ")]):_vm._e(),_vm._v(" "),(  scope.row.etatLibelle === 'EN COURS DE PAIEMENT')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                                  "+_vm._s(scope.row.etatLibelle)+"\n                                ")]):_vm._e(),(  scope.row.etatLibelle === 'EN ATTENTE DE PAIEMENT')?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                "+_vm._s(scope.row.etatLibelle)+"\n                              ")]):_vm._e()]}}],null,false,3902425187)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Montant","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                                  "+_vm._s(scope.row.total)+" FCFA\n                                ")])]}}],null,false,1669763524)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"impaye","label":"Reste à payer","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"warning"}},[_vm._v("\n                                  "+_vm._s(scope.row.impaye)+" FCFA\n                                ")])]}}],null,false,2536411999)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","width":"140","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.loadRegement(scope.row, scope.row.type)}}},[_c('v-icon',[_vm._v("local_atm")])],1),_vm._v(" "),(scope.row.type != 3 && scope.row.type != 5)?_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerFacture(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1):_vm._e()]}}],null,false,4126314923)})],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.listApproCaisse.length !=0 && _vm.droitAcces.caisse_appro)?_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"icons":"","text-color":"white","label":"","color":"primary"}},[_vm._v("\n                        HISTORIQUE DES APPROVISIONNEMENTS "),_c('v-icon',{attrs:{"right":""}},[_vm._v("get_app")])],1)],1),_vm._v(" "),_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{staticStyle:{"font-size":"12px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                MONTANT TOTAL DES APPROVISIONNEMENTS: "+_vm._s(_vm.montantEntree)+" FCFA\n                              ")])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs2":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimeHistoCaisse(_vm.caisseCourant.id)}},slot:"activator"},[_vm._v("\n                                  Imprimer "),_c('v-icon',[_vm._v("print")])],1),_vm._v("\n                                Imprimer l'historique des approvisionnements\n                              ")],1)],1)],1),_vm._v(" "),_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listApproCaisse,"default-sort":{prop: 'id', order: 'descending'},"stripe":"","border":"","height":"350"}},[_c('el-table-column',{attrs:{"prop":"motif","label":"Libellé","width":"280","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  "+_vm._s(scope.row.motif)+"\n                                ")])]}}],null,false,4080693419)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.valide === 0)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                                  EN ATTENTE DE VALIDATION\n                                ")]):(scope.row.valide === 1 && scope.row.modeAppro != 4)?_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                                  VALIDER PAR LE DG\n                                ")]):(scope.row.modeAppro == 4)?_c('v-chip',{attrs:{"outline":"","text-color":"grey","label":"","color":"grey"}},[_vm._v("\n                                  TRANSFERT DE FOND\n                                ")]):(scope.row.valide === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                  REFUSER PAR LE DG\n                                ")]):_vm._e(),_vm._v(" "),(scope.row.status === 0)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                  EN COURS DE TRAITEMENT\n                                ")]):(scope.row.status === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                  TRAITEMENT TERMINE\n                                ")]):_vm._e()]}}],null,false,3698812309)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"validateur","label":"En charge de valider","width":"220"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                                  "+_vm._s(scope.row.montant)+" FCFA\n                                ")])]}}],null,false,3187444133)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","width":"140","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Détails","icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showAppro(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),(scope.row.valide === 0 && scope.row.etat === false && _vm.droitAcces.edit_appro_caisse)?_c('v-btn',{staticClass:"tooltip-btn",attrs:{"title":"Modifier","icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editAppro(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"tooltip-btn",attrs:{"icons":"","title":"Imprimer","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerAppro(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(scope.row.valide === 0)?_c('v-btn',{staticClass:"tooltip-btn",attrs:{"slot":"activator","title":"Supprimer","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSuprAppro = true; _vm.idAppro = scope.row.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                                  Supprimer\n                                ")],1)]}}],null,false,325659812)})],1)],1)],1)],1)],1),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"19px","width":"100%"},attrs:{"icons":"","text-color":"white","label":"","color":"primary"}},[_vm._v("\n                        HISTORIQUE DES 30 DERNIERES OPERATIONS "),_c('v-icon',{attrs:{"right":""}},[_vm._v("get_app")])],1)],1),_vm._v(" "),_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px","margin":"5px"}},[_c('el-row',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('el-card',{staticClass:"box-card"},[_c('v-form',{ref:"formOperation",attrs:{"lazy-validation":"","id":"formOperation"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"name":"dateOperation","rules":_vm.dateOperationRules,"type":"daterange","range-separator":"-","start-placeholder":"Date de début","end-placeholder":"Date de fin","required":""},model:{value:(_vm.dateOperation),callback:function ($$v) {_vm.dateOperation=$$v},expression:"dateOperation"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('el-dropdown',{attrs:{"size":"small","split-button":"","type":"primary"},on:{"command":_vm.handleCommand,"click":_vm.handleClick}},[_vm._v("\n                                            recherche\n                                            "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"all"}},[_vm._v("Afficher toutes les transactions")])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[(_vm.droitAcces.imprime_pdf_historique_caisse)?_c('el-col',{attrs:{"span":2}},[_c('el-popover',{ref:"popover5",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","margin":"0"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHis('PDF')}}},[_vm._v("PDF")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeListeHis('EXC')}}},[_vm._v("EXCEL")])],1)]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popover5",arg:"popover5"}],attrs:{"type":"warning","disabled":_vm.disabledBtn,"icon":"el-icon-printer"}},[_vm._v("Imprimer la liste\n                                  ")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-chip',{staticStyle:{"font-size":"12px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                                TOTAL ENTREE: "+_vm._s(_vm.totalEntree)+" FCFA\n                              ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-chip',{staticStyle:{"font-size":"12px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                                TOTAL SORTIE: "+_vm._s(_vm.totalSortie)+" FCFA\n                              ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-chip',{staticStyle:{"font-size":"13px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                                SOLDE: "+_vm._s(_vm.detailCaisseS.solde)+" FCFA\n                              ")])],1)],1),_vm._v(" "),_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listOperation,"default-sort":{prop: 'id', order: 'descending'},"stripe":"","border":"","height":"350"}},[_c('el-table-column',{attrs:{"prop":"ref","label":"ID","width":"100","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date","width":"100","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé","width":"280","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"initiateur","label":"Initiateur","width":"220"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"validateur","label":"Validateur","width":"220"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"OPERATION"}},[_c('el-table-column',{attrs:{"prop":"entree","label":"ENTREE","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sortie","label":"SORTIE","width":"120"}})],1),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"solde","label":"Solde","width":"150"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('br')])],1)],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShow = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n            Fermer\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.edit_caisse)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editCaisse(_vm.detailCaisse);}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n            Modifier\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.new_appro_caisse)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"indigo","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newAppro(_vm.detailCaisse);}},slot:"activator"},[_vm._v("Appro caisse "),_c('v-icon',{attrs:{"right":""}},[_vm._v("get_app")])],1):_vm._e(),_vm._v("\n            Approvisionner la caisse\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.new_appro_caisse)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"grey","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newTransfert(_vm.detailCaisse);}},slot:"activator"},[_vm._v("Transfert "),_c('v-icon',{attrs:{"right":""}},[_vm._v("transfer_within_a_station")])],1):_vm._e(),_vm._v("\n            Tranfert de fond dans une autre trésorerie\n          ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowReglement),callback:function ($$v) {_vm.dialogShowReglement=$$v},expression:"dialogShowReglement"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails du reglement "+_vm._s(_vm.detailReglement.ref)+" de la facture "+_vm._s(_vm.detailReglement.refFact)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowReglement = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.ref)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Facture : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.refFact)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Caisse : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.caisse)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Montant : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(_vm.detailReglement.montant)+" FCFA\n                            ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),(!_vm.detailReglement.etat)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                              IMPAYE\n                            ")]):_vm._e(),_vm._v(" "),(_vm.detailReglement.etat)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                              PAYE\n                            ")]):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Mode de paiement : ")]),_vm._v(" "),(_vm.detailReglement.mode === 1)?_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                              Espèce\n                            ")]):(_vm.detailReglement.mode === 2)?_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                              Chèque\n                            ")]):(_vm.detailReglement.mode === 3)?_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                              Mobile money\n                            ")]):_vm._e()],1),_vm._v(" "),(_vm.detailReglement.banque !== null)?_c('p',[_c('b',[_vm._v("Banque / Réseau mobile : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.banque))]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[(_vm.detailReglement.reference !== null)?_c('p',[_c('b',[_vm._v("Référence : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.reference))]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Paiement : ")]),_vm._v(" "),(_vm.detailReglement.partiel === true)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                              PARTIEL\n                            ")]):(_vm.detailReglement.partiel === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                              TOTAL\n                            ")]):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date du paiement : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Récuperé par : ")]),_vm._v(" "),(_vm.detailReglement.effectue === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                              "+_vm._s(_vm.detailReglement.concerne)+"\n                            ")]):(_vm.detailReglement.effectue === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                              "+_vm._s(_vm.detailReglement.remettant)+"\n                            ")]):_vm._e()],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Enregistré par : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.userCreated)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enregistrement : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailReglement.modified)+" ")])])],1)],1)])])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowReglement = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n            Fermer\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.detailReglement.etat === false)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editRegement(_vm.detailReglement);}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n            Modifier\n          ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowAppro),callback:function ($$v) {_vm.dialogShowAppro=$$v},expression:"dialogShowAppro"}},[_c('v-card',[_c('v-toolbar',{staticClass:"indigo",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Détails de l'approvisionnement "+_vm._s(_vm.detailAppro.ref))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowAppro = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant : ")]),_vm._v(" "+_vm._s(_vm.detailAppro.ref)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Caisse débité: ")]),_vm._v(" "+_vm._s(_vm.detailAppro.caisseDebiter)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Caisse crédité : ")]),_vm._v(" "+_vm._s(_vm.detailAppro.caisse)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Motif : ")]),_vm._v(" "+_vm._s(_vm.detailAppro.motif)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Montant : ")]),_vm._v(" "),_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                              "+_vm._s(_vm.detailAppro.montant)+" FCFA\n                            ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),(_vm.detailAppro.etat === true)?_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                              TRAITE\n                            ")]):(_vm.detailAppro.etat === false)?_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                              EN ATTENTE DE VALIDATION\n                            ")]):_vm._e(),_vm._v(" "),(_vm.detailAppro.valide === 1)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                              DEMANDE AUTORISE\n                            ")]):(_vm.detailAppro.valide === 2)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                              DEMANDE REFUSE\n                            ")]):_vm._e()],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Initiateur : ")]),_vm._v(" "+_vm._s(_vm.detailAppro.initiateur))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Validateur : ")]),_vm._v(" "+_vm._s(_vm.detailAppro.validateur))]),_vm._v(" "),(_vm.detailAppro.remarque != '')?_c('p',[_c('b',[_vm._v("Commentaire : ")]),_vm._v(" "+_vm._s(_vm.detailAppro.remarque)+" ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enrégistrement : ")]),_vm._v(" "+_vm._s(_vm.detailAppro.created)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date de modification : ")]),_vm._v(" "+_vm._s(_vm.detailAppro.modified)+" ")])])],1)],1)])])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowAppro = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n            Fermer\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.detailAppro.valide === 0 && _vm.detailAppro.etat === false)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.editAppro(_vm.detailAppro);}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n            Modifier\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerAppro(_vm.detailAppro);}},slot:"activator"},[_vm._v("Imprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("\n            Imprimer l'approvisionnement\n          ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"70%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogRetour),callback:function ($$v) {_vm.dialogRetour=$$v},expression:"dialogRetour"}},[_c('v-card',[_c('v-toolbar',{staticClass:"indigo",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[(_vm.detailRetour.etatretour != 1)?_c('v-toolbar-title',[_vm._v("Effectuer un retour de caisse suite au "+_vm._s(_vm.detailRetour.idPai))]):_vm._e(),_vm._v(" "),(_vm.detailRetour.etatretour == 1)?_c('v-toolbar-title',[_vm._v("Détails sur le retour de caisse suite au  "+_vm._s(_vm.detailRetour.idPai))]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogRetour = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                Informations générales sur la demande\n              ")]),_vm._v(" "),_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Identifiant facture : ")]),_vm._v(" "+_vm._s(_vm.detailRetour.idFact)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Concerné : ")]),_vm._v(" "+_vm._s(_vm.detailRetour.concerne)+" FCFA")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Montant Payé : ")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"red"}},[_vm._v("\n                              "+_vm._s(_vm.detailRetour.montant)+" FCFA\n                            ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Etat : ")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"red","label":"","color":"red"}},[_vm._v("\n                              "+_vm._s(_vm.detailRetour.etat)+"\n                            ")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Date de paiement ")]),_vm._v(" "+_vm._s(_vm.detailRetour.date))]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Enregistrer par : ")]),_vm._v(" "+_vm._s(_vm.detailRetour.userCreated))])])],1)],1)])])],1),_vm._v(" "),_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n                Détails sur le retour dans la caisse\n              ")]),_vm._v(" "),_c('el-row',[_c('el-card',{staticClass:"box-card"},[(_vm.detailRetour.etatretour == 1)?_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md6":""}},[(_vm.detailRetour.etatretour == 1)?_c('p',[_c('b',[_vm._v("Montant retourné : ")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n                          "+_vm._s(_vm.detailRetour.motantretour)+"  FCFA\n                        ")])],1):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v("Date d'enrregistrement : ")]),_vm._v(" "+_vm._s(_vm.detailRetour.dateretour)+" ")])]),_vm._v(" "),_c('v-flex',{attrs:{"md6":""}},[_c('p',[_c('b',[_vm._v("Motif du retour : ")]),_vm._v(" "),_c('v-chip',{attrs:{"outline":"","text-color":"orange","label":"","color":"green"}},[_vm._v("\n                          "+_vm._s(_vm.detailRetour.commentaire)+"\n                        ")])],1),_vm._v(" "),_c('p',[_c('b',[_vm._v("Effectué par : ")]),_vm._v(" "+_vm._s(_vm.detailRetour.userRetour)+" ")])])],1):_vm._e(),_vm._v(" "),_c('v-card-text',[(_vm.detailRetour.etatretour != 1)?_c('el-form',{ref:"retourForm",staticClass:"demo-ruleForm",attrs:{"model":_vm.retourForm,"rules":_vm.rulesRetour,"id":"retourForm","label-width":"100px"}},[_c('el-form-item',{attrs:{"label":"Montant","prop":"montant"}},[_c('el-input',{attrs:{"type":"number","name":"montanRetour","width":"80px"},model:{value:(_vm.retourForm.montant),callback:function ($$v) {_vm.$set(_vm.retourForm, "montant", $$v)},expression:"retourForm.montant"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Motif","prop":"commentaire"}},[_c('el-input',{attrs:{"type":"textarea","name":"commentaire","rows":5,"placeholder":"Motif"},model:{value:(_vm.retourForm.commentaire),callback:function ($$v) {_vm.$set(_vm.retourForm, "commentaire", $$v)},expression:"retourForm.commentaire"}})],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogRetour = false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n                Fermer\n              ")],1),_vm._v(" "),(_vm.detailRetour.etatretour != 1)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){_vm.validRetour = true}},slot:"activator"},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1),_vm._v("\n                Ajouter\n              ")],1):_vm._e()],1),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"95%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogLoadReglement),callback:function ($$v) {_vm.dialogLoadReglement=$$v},expression:"dialogLoadReglement"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Liste des reglements de la facture "+_vm._s(_vm.factureCourant.ref)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeLoadReglement()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[(_vm.totalretour == 0)?_c('v-layout',{attrs:{"row":""}},[(_vm.payeFacture != 0)?_c('v-flex',{attrs:{"md4":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"18px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                    TOTAL A REGLER : "+_vm._s(_vm.totalFacture)+" FCFA\n                  ")])],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"18px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                   PAYE : "+_vm._s(_vm.payeFacture)+" FCFA\n                  ")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"18px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                    RESTANT : "+_vm._s(_vm.impayeFacture)+" FCFA\n                  ")])],1)])],1):_vm._e(),_vm._v(" "),(this.totalretour != 0 )?_c('v-layout',{attrs:{"row":""}},[(_vm.payeFacture != 0)?_c('v-flex',{attrs:{"md3":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"18px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                    TOTAL A REGLER : "+_vm._s(_vm.totalFacture)+" FCFA\n                  ")])],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"18px","width":"100%"},attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                   PAYE : "+_vm._s(_vm.payeFacture)+" FCFA\n                  ")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"18px","width":"100%"},attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                    RESTANT : "+_vm._s(_vm.impayeFacture)+" FCFA\n                  ")])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md3":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"18px","width":"100%"},attrs:{"text-color":"white","label":"","color":"orange"}},[_vm._v("\n                    RETOURNE : "+_vm._s(_vm.totalretour)+" FCFA\n                  ")])],1)])],1):_vm._e()],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[(_vm.factureCourant.etatReglFact === true)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"outline":"","text-color":"green","label":"","color":"green"}},[_vm._v("\n              FACTURE SOLDE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("check")])],1):_vm._e()],1),_vm._v(" "),(_vm.factureCourant.etatPaiement == false)?_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("\n              LE DERNIER PAIMENT EFFECTUER N'A PAS ENCORE ETE ENCAISSE PAR LE FOURNISSEUR "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add_alert")])],1)],1):_vm._e(),_vm._v(" "),(_vm.listReglement.length === 0)?_c('div',[_c('p',{attrs:{"align":"center"}},[_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"outline":"","text-color":"orange","label":"","color":"orange"}},[_vm._v("AUCUN PAIEMENT N'A ENCORE ETE EFFECTUE SUR CETTE FACTURE "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add_alert")])],1)],1)]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(this.totalFacture != 0 && this.soldeCaisse != 0 && (_vm.factureCourant.etatPaiement == null || _vm.factureCourant.etatPaiement == true) && _vm.factureCourant.etatReglFact == false && this.soldeCaisse )?_c('div',{staticClass:"text-xs-right"},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.edit_reglement)?_c('v-btn',{attrs:{"slot":"activator","disabled":_vm.impayeFacture == 0,"icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.newReglement(_vm.factureCourant, _vm.typeF)}},slot:"activator"},[_vm._v("Ajouter "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1):_vm._e(),_vm._v("\n              Ajouter un nouveau paiement\n            ")],1)],1):_vm._e(),_vm._v(" "),(this.soldeCaisse != 0 && _vm.factureCourant.etatPaiement == null || _vm.factureCourant.etatPaiement == true && _vm.dialogAjoutReglement == true  && _vm.dialogEdit == false && _vm.factureCourant.etatReglFact == false && this.soldeCaisse != 0)?_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEdit != true)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("AJOUT D'UN NOUVEAU PAIEMENT "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_atm")])],1):_vm._e(),_vm._v(" "),(_vm.dialogEdit)?_c('v-chip',{staticStyle:{"font-size":"22px","width":"100%"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("MODIFIER LE PAIEMENT PAIE-"+_vm._s(_vm.reglementCourant.id)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_atm")])],1):_vm._e()],1),_vm._v(" "),_c('v-form',{ref:"formReglement",attrs:{"lazy-validation":"","id":"formReglement"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant à verser *")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.readInput,"min":0,"max":_vm.totalFacture1,"name":"montantVerse","placeholder":"Montant à verser"},model:{value:(_vm.montantVerse),callback:function ($$v) {_vm.montantVerse=$$v},expression:"montantVerse"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Remis à ? *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.readInput,"filterable":"","placeholder":"Effectué par"},model:{value:(_vm.selectEffectue),callback:function ($$v) {_vm.selectEffectue=$$v},expression:"selectEffectue"}},_vm._l((_vm.effectue),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mode de paiement *")]),_vm._v(" "),(_vm.caisseCourant.type == 'Caisse')?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.readInput,"filterable":"","placeholder":"Mode de paiement"},model:{value:(_vm.selectMode),callback:function ($$v) {_vm.selectMode=$$v},expression:"selectMode"}},_vm._l((_vm.mode),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.caisseCourant.type == 'Banque')?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Mode de paiement"},model:{value:(_vm.selectMode),callback:function ($$v) {_vm.selectMode=$$v},expression:"selectMode"}},_vm._l((_vm.modeBanque),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1):_vm._e()],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(_vm.selectEffectue == 2)?_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nom du remettant *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"remettant","placeholder":"Nom du remettant"},model:{value:(_vm.remettant),callback:function ($$v) {_vm.remettant=$$v},expression:"remettant"}})],1)]):_vm._e(),_vm._v(" "),(_vm.selectMode == 2 || _vm.selectMode == 3)?_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Banque / Réseau mobile *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"banque","placeholder":"Banque / Réseau mobile"},model:{value:(_vm.banque),callback:function ($$v) {_vm.banque=$$v},expression:"banque"}})],1)]):_vm._e(),_vm._v(" "),(_vm.selectMode == 2 || _vm.selectMode == 3)?_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Référence *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"reference","placeholder":"Référence"},model:{value:(_vm.reference),callback:function ($$v) {_vm.reference=$$v},expression:"reference"}})],1)]):_vm._e(),_vm._v(" "),(_vm.selectMode == 2)?_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Encaissé ? *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Encaissé"},model:{value:(_vm.selectEncaisse),callback:function ($$v) {_vm.selectEncaisse=$$v},expression:"selectEncaisse"}},_vm._l((_vm.encaisse),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogAjoutReglement = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){_vm.validPaiem = true}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)])],1)],1),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.dialogEdit === true && _vm.dialogEditReglement === true)?_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',[_c('p',{attrs:{"align":"center"}},[(_vm.dialogEdit)?_c('v-chip',{staticStyle:{"font-size":"22px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("MODIFIER LE PAIEMENT PAIE-"+_vm._s(_vm.reglementCourant.id)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_atm")])],1):_vm._e()],1),_vm._v(" "),_c('v-form',{ref:"formReglement",attrs:{"lazy-validation":"","id":"formReglement"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Montant à verser *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"number","min":0,"max":_vm.impayeFacture1,"name":"montantVerse","placeholder":"Montant à verser"},model:{value:(_vm.montantVerse),callback:function ($$v) {_vm.montantVerse=$$v},expression:"montantVerse"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Effectué par ? *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Effectué par"},model:{value:(_vm.selectEffectue),callback:function ($$v) {_vm.selectEffectue=$$v},expression:"selectEffectue"}},_vm._l((_vm.effectue),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"md4":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Mode de paiement *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Mode de paiement"},model:{value:(_vm.selectMode),callback:function ($$v) {_vm.selectMode=$$v},expression:"selectMode"}},_vm._l((_vm.mode),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(_vm.selectEffectue == 2)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Nom du remettant *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"remettant","placeholder":"Nom du remettant"},model:{value:(_vm.remettant),callback:function ($$v) {_vm.remettant=$$v},expression:"remettant"}})],1)]):_vm._e(),_vm._v(" "),(_vm.selectMode == 2 || _vm.selectMode == 3)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Banque / Réseau mobile *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"banque","placeholder":"Banque / Réseau mobile"},model:{value:(_vm.banque),callback:function ($$v) {_vm.banque=$$v},expression:"banque"}})],1)]):_vm._e(),_vm._v(" "),(_vm.selectMode == 2 || _vm.selectMode == 3)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Référence *")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"name":"reference","placeholder":"Référence"},model:{value:(_vm.reference),callback:function ($$v) {_vm.reference=$$v},expression:"reference"}})],1)]):_vm._e(),_vm._v(" "),(_vm.selectMode == 2)?_c('v-flex',{attrs:{"md3":""}},[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("Encaissé ? *")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Encaissé"},model:{value:(_vm.selectEncaisse),callback:function ($$v) {_vm.selectEncaisse=$$v},expression:"selectEncaisse"}},_vm._l((_vm.encaisse),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)]):_vm._e()],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogEditReglement = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"blue","disabled":!_vm.valid,"dark":""},on:{"click":function($event){return _vm.submitReglement()}}},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)])],1)],1),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.listReglement.length !== 0)?_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',[_c('data-tables',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.listReglement,"default-sort":{prop: 'id', order: 'descending'},"stripe":"","border":"","height":"350"}},[_c('el-table-column',{attrs:{"prop":"ref","label":"Référence","width":"280","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                            "+_vm._s(scope.row.ref)+"\n                          ")])]}}],null,false,9181187)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etat","label":"Etat","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.etat === false)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                            IMPAYE\n                          ")]):_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                            PAYE\n                          ")])]}}],null,false,2852499668)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"montant","label":"Montant","width":"240"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                            "+_vm._s(scope.row.montant)+" FCFA\n                          ")])]}}],null,false,1569982885)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date de paiement","width":"240"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"text-color":"white","label":"","color":"secondary"}},[_vm._v("\n                            "+_vm._s(scope.row.date)+"\n                          ")])]}}],null,false,543649232)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Actions","width":"240"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-btn',{attrs:{"icons":"","color":"green","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showReglement(scope.row)}}},[_c('v-icon',[_vm._v("folder_open")])],1),_vm._v(" "),(scope.row.etat === false)?_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.editRegement(scope.row)}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"indigo","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showPieceJustifi(scope.row)}}},[_c('v-icon',[_vm._v("photo_camera")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.imprimerReglement(scope.row)}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),(scope.row.typeFacture == 3)?_c('v-btn',{attrs:{"icons":"","color":"blue","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.retourCaisse(scope.row, scope.row.typeFacture)}}},[_c('v-icon',[_vm._v("arrow_back")])],1):_vm._e()]}}],null,false,3592594468)})],1)],1)])],1)],1),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.closeLoadReglement()}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n            Fermer\n          ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSupr),callback:function ($$v) {_vm.dialogSupr=$$v},expression:"dialogSupr"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h3',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer cette trésorerie ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSupr = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteCaisse($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogShowPiece),callback:function ($$v) {_vm.dialogShowPiece=$$v},expression:"dialogShowPiece"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Ajouter une piece justificative")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogShowPiece = false;_vm.showButtonPiece=false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-row',{attrs:{"gutter":20}},[_c('div',{staticClass:"grid-content",staticStyle:{"padding":"3px"}},[_c('el-row',[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"grid-content bg-purple"},[_c('div',{staticClass:"text item"},[_c('v-form',{ref:"formPieceJointe",attrs:{"lazy-validation":"","id":"formPieceJointe"},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":"","justify":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('p',{staticClass:"font-weight-thin"},[_vm._v("Format (JPEG,PNG,PDF), 10 Mo maximum")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.pieceJusti,"target":"_blank"}},[_c('v-avatar',{attrs:{"tile":true,"size":"140px","height":"120px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.pieceJusti,"alt":"avatar"}})]),_c('br')],1),_vm._v(" "),_c('input',{ref:"fileLogo",staticStyle:{"display":"none"},attrs:{"name":"photo","type":"file","accept":"image/*"},on:{"change":_vm.onFileImageLogoPicked}}),_vm._v(" "),(_vm.showButtonPiece==true)?_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","required":""},nativeOn:{"click":function($event){return _vm.$refs.fileLogo.click()}}},[_vm._v("Document  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1):_vm._e(),_c('br')],1)],1)],1)],1)])])],1)],1),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogShowPiece = false;_vm.showButtonPiece=false}},slot:"activator"},[_vm._v("Fermer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("close")])],1),_vm._v("\n            Fermer\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.showButtonPiece === false)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.showButtonPiece=true}},slot:"activator"},[_vm._v("Modifier "),_c('v-icon',{attrs:{"right":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v("\n            Modifier\n          ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.showButtonPiece === true)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.savePieceJointe();}},slot:"activator"},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1):_vm._e(),_vm._v("\n            Enregistrer\n          ")],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.validTransfert),callback:function ($$v) {_vm.validTransfert=$$v},expression:"validTransfert"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h1',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment effectuer un transfert d'un montant de  "+_vm._s(new Intl.NumberFormat().format(this.transFertForm.montantTransf))+" FCFA")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.validTransfert = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){return _vm.submitTransferCaisse()}}},[_vm._v("Confirmer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("check")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.validPaiem),callback:function ($$v) {_vm.validPaiem=$$v},expression:"validPaiem"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h1',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment effectuer un paiement d'un montant de  "+_vm._s(new Intl.NumberFormat().format(this.montantVerse))+" FCFA")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.validPaiem = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){return _vm.submitReglement()}}},[_vm._v("Confirmer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("check")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.validRetour),callback:function ($$v) {_vm.validRetour=$$v},expression:"validRetour"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h1',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment effectuer un retour caisse d'un montant de  "+_vm._s(new Intl.NumberFormat().format(this.retourForm.montant))+" FCFA")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.validRetour = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){return _vm.ajouterRetour(_vm.retourForm,_vm.detailRetour)}}},[_vm._v("Confirmer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("check")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogSuprAppro),callback:function ($$v) {_vm.dialogSuprAppro=$$v},expression:"dialogSuprAppro"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('h6',{attrs:{"align":"center"}},[_vm._v("Voulez-vous vraiment supprimer cet enrégistrement ?")]),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"orange","dark":""},nativeOn:{"click":function($event){_vm.dialogSuprAppro = false}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"red","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.deleteAppro($event)}}},[_vm._v("Supprimer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","overlay":true,"transition":"dialog-bottom-transition"},model:{value:(_vm.dialogModalBanque),callback:function ($$v) {_vm.dialogModalBanque=$$v},expression:"dialogModalBanque"}},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialogModalBanque = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Détails de la trésorerie")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){_vm.dialogModalBanque = false}}},[_vm._v("Fermer")])],1)],1),_vm._v(" "),_c('ModalBanque',{attrs:{"statCaisse2":_vm.statCaisse2,"dialogModalBanque":_vm.dialogModalBanque,"listApproDgCheq":_vm.listApproDgCheq,"detailBanque":_vm.detailCaisseS,"montantEntree":_vm.montantEntree,"montantSortie":_vm.montantSortie,"tableOpera":_vm.tableOpera,"formRech":_vm.formRech,"searchOpera":_vm.searchOpera,"approCourant":_vm.approCourant,"newAppro":_vm.newAppro,"newTransfert":_vm.newTransfert,"dialogAjoutAppro":_vm.dialogAjoutAppro,"listApproBanque":_vm.listApproCaisse,"showAppro":_vm.showAppro,"imprimeHistoBanque":_vm.imprimeHistoCaisse,"editAppro":_vm.editAppro,"imprimerAppro":_vm.imprimerAppro,"handleCommand":_vm.handleCommand,"handleClick":_vm.handleClick,"disabledBtn":_vm.disabledBtn,"listOperation":_vm.listOperation,"dateOperation":_vm.dateOperation,"totalEntree":_vm.totalEntree,"totalSortie":_vm.totalSortie,"imprimeListeHis":_vm.imprimeListeHis},on:{"close":function($event){_vm.dialogModalBanque = false}}})],1),_vm._v(" "),_c('v-card',[_c('div',[_c('v-card-title',[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n            LISTE DES TRESORERIES "),_c('v-icon',{attrs:{"right":""}},[_vm._v("account_balance")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"Selectionner une caisse"},on:{"clear":function($event){return _vm.clearSelect()},"change":_vm.filtrerCaisseDmd},model:{value:(_vm.selectCaisseDmd),callback:function ($$v) {_vm.selectCaisseDmd=$$v},expression:"selectCaisseDmd"}},_vm._l((_vm.listCaisse),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"search":_vm.search,"items":_vm.listCaisse},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('v-tooltip',{attrs:{"top":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                  "+_vm._s(props.header.text)+"\n                ")]),_vm._v(" "),_c('span',[_vm._v("\n                  "+_vm._s(props.header.text)+"\n                ")])])]}},{key:"items",fn:function(props){return [(!props.item.libelleFull)?_c('td',{staticClass:"text-xs-center"},[_vm._v(" "+_vm._s(props.item.libelle)+" ")]):_vm._e(),_vm._v(" "),(props.item.libelleFull)?_c('td',{staticClass:"text-xs-center"},[_vm._v(" "+_vm._s(props.item.libelleFull)+" ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-chip',{attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v("\n                  "+_vm._s(props.item.gerant)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v("perm_identity")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[(!props.item.etat)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"red"}},[_vm._v("\n                  FERME\n                ")]):_vm._e(),_vm._v(" "),(props.item.etat)?_c('v-chip',{attrs:{"text-color":"white","label":"","color":"green"}},[_vm._v("\n                  OUVERT\n                ")]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-chip',{attrs:{"outline":"","text-color":"primary","label":"","color":"primary"}},[_vm._v("\n                  "+_vm._s(props.item.solde)+" FCFA "),_c('v-icon',{attrs:{"right":""}},[_vm._v("local_atm")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('div',{staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"top":""}},[(props.item.etat === true && props.item.type === 'Caisse')?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){$event.stopPropagation();_vm.showCaisse(props.item); _vm.loadAppro(props.item); _vm.loadOperation(props.item); _vm.loadOperationsCaisse(props.item.id); _vm.loadProjet(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1):_vm._e(),_vm._v("\n                    Détails\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(props.item.type === 'Banque')?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"orange"},on:{"click":function($event){$event.stopPropagation();_vm.showBanque(props.item); _vm.loadListApproDgCheqBanque(props.item.id); _vm.loadAppro(props.item); _vm.loadOperation(props.item); _vm.loadOperationsCaisse(props.item.id); _vm.loadProjet(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("folder_open")])],1):_vm._e(),_vm._v("\n                    Details Banque\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"blue"},on:{"click":function($event){$event.stopPropagation();return _vm.editCaisse(props.item)}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("edit")])],1),_vm._v("\n                    Modifier\n                  ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.droitAcces.caisse_delete)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},on:{"click":function($event){$event.stopPropagation();_vm.dialogSupr = true; _vm.idCaisse = props.item.id;}},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                    Supprimer\n                  ")],1)],1)])]}}])})],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vswG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w4nv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogAjoutTravaux),callback:function ($$v) {_vm.dialogAjoutTravaux=$$v},expression:"dialogAjoutTravaux"}},[_c('v-card',[_c('v-toolbar',{staticClass:"blue",staticStyle:{"flex":"0 0 auto"},attrs:{"dark":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Ajouter/Editer une sous section")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeForm()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formLotTravaux",staticClass:"demo-ruleForm",attrs:{"id":"formLotTravaux","rules":_vm.rulesLotTravaux,"label-position":"top","model":_vm.formLotTravaux}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs1":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Ordre","prop":"ordre"}},[_c('el-select',{attrs:{"placeholder":"Select"},model:{value:(_vm.formLotTravaux.ordre),callback:function ($$v) {_vm.$set(_vm.formLotTravaux, "ordre", $$v)},expression:"formLotTravaux.ordre"}},_vm._l((_vm.numOrdre),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.num,"value":item.num}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Code","prop":"code"}},[_c('el-input',{attrs:{"placeholder":"Code","name":"code"},model:{value:(_vm.formLotTravaux.code),callback:function ($$v) {_vm.$set(_vm.formLotTravaux, "code", $$v)},expression:"formLotTravaux.code"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Libellé travaux","prop":"libelle"}},[_c('el-input',{attrs:{"placeholder":"Saisir le libellé","name":"libelle"},model:{value:(_vm.formLotTravaux.libelle),callback:function ($$v) {_vm.$set(_vm.formLotTravaux, "libelle", $$v)},expression:"formLotTravaux.libelle"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","mr-1":""}},[_c('el-form-item',{attrs:{"label":"Description","prop":"description"}},[_c('el-input',{attrs:{"type":"textarea","placeholder":"description","name":"description","rows":6},model:{value:(_vm.formLotTravaux.description),callback:function ($$v) {_vm.$set(_vm.formLotTravaux, "description", $$v)},expression:"formLotTravaux.description"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('el-form-item',{attrs:{"label":"Action"}},[_c('v-btn',{attrs:{"icons":"","color":"primary","fab":"","small":"","dark":""},on:{"click":function($event){return _vm.addListeTypeTravaux()}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeLots,"border":""}},[_c('el-table-column',{attrs:{"prop":"ordre","label":"Ordre"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-select',{attrs:{"placeholder":"Select"},on:{"change":function($event){return _vm.changeOrdre(prop.row.ordre, prop.$index)}},model:{value:(prop.row.ordre),callback:function ($$v) {_vm.$set(prop.row, "ordre", $$v)},expression:"prop.row.ordre"}},_vm._l((_vm.listeNumber),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.num,"value":item.num}})}),1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"code","label":"Code"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input',{attrs:{"controls-position":"right","size":"small"},model:{value:(prop.row.code),callback:function ($$v) {_vm.$set(prop.row, "code", $$v)},expression:"prop.row.code"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé travaux"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input',{attrs:{"controls-position":"right","size":"small"},on:{"change":function($event){return _vm.handleChangeLibelle()}},model:{value:(prop.row.libelle),callback:function ($$v) {_vm.$set(prop.row, "libelle", $$v)},expression:"prop.row.libelle"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"description"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-input',{attrs:{"type":"textarea","controls-position":"right","size":"small"},model:{value:(prop.row.description),callback:function ($$v) {_vm.$set(prop.row, "description", $$v)},expression:"prop.row.description"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Opérations","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","small":"","icons":"","color":"red","dark":""},nativeOn:{"click":function($event){$event.preventDefault();return _vm.deleteRow(scope.$index, _vm.listeLots)}},slot:"activator"},[_c('v-icon',{attrs:{"center":""}},[_vm._v("delete")])],1),_vm._v("\n                      Supprimer ce lot\n                    ")],1)]}}])})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","align-self-end":"","mt-4":""}},[_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pr-1",attrs:{"xs2":"","offset-xs8":""}},[_c('v-btn',{attrs:{"block":"","color":"grey","dark":""},on:{"click":function($event){return _vm.closeForm()}}},[_vm._v("Annuler "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","block":"","color":"green","dark":""},on:{"click":function($event){return _vm.submitTravaux()}},slot:"activator"},[_vm._v("Enregistrer "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wS7l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogDashboardChantier),callback:function ($$v) {_vm.dialogDashboardChantier=$$v},expression:"dialogDashboardChantier"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("TABLEAU DE BORD CHANTIER")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","mt-2":"","ml-1":"","mb-3":""}},[_c('v-flex',{staticClass:"elevation-3",attrs:{"sm2":"","mr-2":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"cyan","dark":""}},[_c('v-toolbar-title',[_vm._v("Informations Chantier")])],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailChantier.libelle))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Libelle")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailChantier.chefProjet))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Responsable projet")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailChantier.chefChantier))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Chef chantier")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailChantier.dateD)+" --"+_vm._s(_vm.detailChantier.dateF)+"\n                  ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Période d'exécution")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailChantier.libEtat))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Etat")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.detailChantier.jourRestant))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Jour(s) restant(s)")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"background-color":"#FAFAFA"},attrs:{"sm10":""}},[_c('v-carousel',{staticClass:"pt-3 pr-3 pl-3 pb-3",attrs:{"cycle":false,"light":"","hide-delimiters":true}},[_c('v-carousel-item',[_c('WidgetTravaux',{attrs:{"commis":_vm.commis,"listeTrx":_vm.listeTravaux,"listeTrxId":_vm.listeTravauxId}})],1),_vm._v(" "),_c('v-carousel-item',[_c('WidgetChantier',{attrs:{"chantier":_vm.detailChantier}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":"","ml-1":"","mr-1":"","mt-1":""}},[_c('v-card',[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick(_vm.onglet)}},model:{value:(_vm.onglet),callback:function ($$v) {_vm.onglet=$$v},expression:"onglet"}},[_c('el-tab-pane',{attrs:{"label":"travaux"}},[_c('ListeTravaux',{attrs:{"type":2,"commis":_vm.commis,"idchantier":_vm.detailChantier.id,"listeTrx":_vm.listeTravaux},on:{"reloadListeTravaux":function($event){return _vm.loadTravaux(_vm.detailChantier)}}})],1),_vm._v(" "),(!this.commis)?_c('el-tab-pane',{attrs:{"label":"Ouvriers/Prestataires"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-card-text',[_c('ListePrestataire',{attrs:{"idChantier":_vm.detailChantier.idChant,"type":1,"listeOuvriers":_vm.listOuvriers,"listePrestataires":_vm.listPrestataires,"show":_vm.showListeOuvrier}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Reserve Travaux"}},[_c('ListeReserve',{attrs:{"type":1,"listeReserveTrx":_vm.listeReserves},on:{"reloadListeReserve":function($event){return _vm.loadReserves()}}}),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Compte d'exploitation"}},[_c('CompteExploitationChantier',{attrs:{"chantier":_vm.detailChantier,"show":_vm.showCompteExploit}}),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wd6Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wthK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadTypeproduit_vue__ = __webpack_require__("mnuV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c62310_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadTypeproduit_vue__ = __webpack_require__("1V8V");
function injectStyle (ssrContext) {
  __webpack_require__("l+OV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01c62310"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loadTypeproduit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c62310_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loadTypeproduit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wx/6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Validation_index_vue__ = __webpack_require__("2lgG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a470e20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Validation_index_vue__ = __webpack_require__("DtXX");
function injectStyle (ssrContext) {
  __webpack_require__("f3XE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a470e20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Validation_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a470e20_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Validation_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wzJ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_bar__ = __webpack_require__("GbHy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_echarts_lib_chart_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_chart_pie__ = __webpack_require__("Vb+l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_lib_chart_pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_echarts_lib_chart_pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_tooltip__ = __webpack_require__("Oq2I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_title__ = __webpack_require__("miEh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts__ = __webpack_require__("XLwt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_echarts__ = __webpack_require__("cs+8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_chart_line__ = __webpack_require__("4UDB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_echarts_lib_chart_line__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LoadShowGraph",
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2__components_Loading__["a" /* default */],
    'v-chart': __WEBPACK_IMPORTED_MODULE_8_vue_echarts___default.a
  },
  props: {
    listeData: {
      type: Array,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    typeGraph: {
      type: String
    }
  },
  data: function data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      dialogAjoutConducteur: false,
      loading: false,
      libelleType: '',
      chart: null,
      hideInterface: true
    };
  },

  watch: {
    show: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(newValue, oldValue) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(newValue === true)) {
                  _context.next = 9;
                  break;
                }

                this.dialogAjoutConducteur = true;

                // Attendre que le dialogue soit monté
                _context.next = 4;
                return this.$nextTick();

              case 4:

                if (this.typeGraph === 'transactions') {
                  this.libelleType = "Détails des informations sur le graphique des états des transactions";
                  if (this.listeData && this.listeData.stackedLinData) {
                    this.hideInterface = false;
                    this.initLineChart(this.listeData.stackedLinData);
                  }
                }
                if (this.typeGraph === 'courbe_marge') {
                  this.libelleType = "Détails des informations sur le graphique des courbes d'évolution des marges";
                  if (this.listeData && this.listeData.barChartData) {
                    this.initChart(this.listeData.barChartData);
                  }
                }
                if (this.typeGraph === 'stat_projet') {
                  this.libelleType = "Détails des informations sur le graphique des statistiques du projet";
                  if (this.listeData && this.listeData.barChartData) {
                    this.initBarChart(this.listeData.barChartData);
                  }
                }
                _context.next = 11;
                break;

              case 9:
                this.dialogAjoutConducteur = false;
                window.location.reload();

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function show(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return show;
    }()
  },
  methods: {
    initLineChart: function initLineChart(row) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formatNumber, options;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.$nextTick();

              case 2:
                if (_this.$refs.trans) {
                  _context2.next = 5;
                  break;
                }

                console.error("L'élément de référence 'trans' n'existe pas");
                return _context2.abrupt('return');

              case 5:

                try {
                  _this.chart = __WEBPACK_IMPORTED_MODULE_7_echarts__["init"](_this.$refs.trans);
                  // Formatage des données pour une meilleure lisibilité

                  formatNumber = function formatNumber(value) {
                    return value.toString();
                  };

                  options = {
                    title: {
                      text: "Etat des transactions des projets (Débit / Crédit)",
                      left: "left",
                      subtextStyle: {
                        color: "#007BFF",
                        fontSize: 14,
                        cursor: "pointer",
                        fontWeight: "bold",
                        width: 200,
                        overflow: 'break'
                      },
                      triggerEvent: true
                    },
                    tooltip: {
                      trigger: "axis",
                      axisPointer: {
                        type: 'cross'
                      },
                      formatter: function formatter(params) {
                        var result = params[0].axisValue + '<br/>';
                        params.forEach(function (param) {
                          result += param.marker + param.seriesName + ': ' + new Intl.NumberFormat().format(formatNumber(param.value)) + ' XOF<br/>';
                        });
                        return result;
                      }
                    },
                    legend: {
                      data: ["Débit", "Crédit"],
                      top: '50px'
                    },
                    grid: {
                      left: '3%',
                      right: '4%',
                      bottom: '3%',
                      containLabel: true
                    },
                    dataZoom: [{
                      type: 'inside',
                      start: 0,
                      end: 100
                    }, {
                      start: 0,
                      end: 100
                    }],
                    xAxis: {
                      type: "category",
                      boundaryGap: false,
                      data: row.mois,
                      axisLabel: {
                        rotate: 45
                      }
                    },
                    yAxis: [{
                      type: "value",
                      name: "Débit",
                      position: 'left',
                      axisLabel: {
                        formatter: function formatter(value) {
                          return new Intl.NumberFormat().format(formatNumber(value)) + ' XOF';
                        }
                      },
                      axisLine: {
                        show: true,
                        lineStyle: {
                          color: '#ff4d4f'
                        }
                      }
                    }, {
                      type: "value",
                      name: "Crédit",
                      position: 'right',
                      axisLabel: {
                        formatter: function formatter(value) {
                          return new Intl.NumberFormat().format(formatNumber(value)) + ' XOF';
                        }
                      },
                      axisLine: {
                        show: true,
                        lineStyle: {
                          color: '#52c41a'
                        }
                      }
                    }],
                    series: [{
                      name: "Débit",
                      type: "line",
                      data: row.debit, // Prend la première valeur de chaque tableau
                      yAxisIndex: 0,
                      symbol: 'circle',
                      symbolSize: 8,
                      lineStyle: {
                        color: '#ff4d4f',
                        width: 3
                      },
                      itemStyle: {
                        color: '#ff4d4f'
                      },
                      areaStyle: {
                        color: new __WEBPACK_IMPORTED_MODULE_7_echarts__["graphic"].LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(255,77,79,0.3)' }, { offset: 1, color: 'rgba(255,77,79,0.1)' }])
                      }
                    }, {
                      name: "Crédit",
                      type: "line",
                      data: row.credit,
                      yAxisIndex: 1,
                      symbol: 'circle',
                      symbolSize: 8,
                      lineStyle: {
                        color: '#52c41a',
                        width: 3
                      },
                      itemStyle: {
                        color: '#52c41a'
                      },
                      areaStyle: {
                        color: new __WEBPACK_IMPORTED_MODULE_7_echarts__["graphic"].LinearGradient(0, 0, 0, 1, [{ offset: 0, color: 'rgba(82,196,26,0.3)' }, { offset: 1, color: 'rgba(82,196,26,0.1)' }])
                      }
                    }]
                  };

                  _this.chart.setOption(options);

                  // Gérer le redimensionnement
                  window.addEventListener('resize', _this.handleResize);
                } catch (error) {
                  console.error('Erreur lors de l\'initialisation du graphique:', error);
                }

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    initBarChart: function initBarChart(row) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var element, options;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this2.$nextTick();

              case 2:
                element = document.getElementById('bar-chart');

                if (element) {
                  _context3.next = 6;
                  break;
                }

                console.error("L'élément 'bar-chart' n'existe pas");
                return _context3.abrupt('return');

              case 6:

                try {
                  _this2.chart = __WEBPACK_IMPORTED_MODULE_7_echarts__["init"](element);
                  options = {
                    title: {
                      text: "Statistiques des indicateurs clés des projets",
                      left: "left",
                      subtextStyle: {
                        color: "#007BFF",
                        fontSize: 14,
                        cursor: "pointer",
                        fontWeight: "bold"
                      },
                      // Activer les événements sur le sous-titre
                      triggerEvent: true
                    },
                    tooltip: {
                      trigger: "axis",
                      axisPointer: { type: "shadow" }
                    },
                    legend: {
                      data: ["Montant du marché", "Budget total", "Montant encaissé", "Montant décaissé"],
                      bottom: 0
                    },
                    xAxis: {
                      type: "category",
                      data: row.projects.map(function (project) {
                        return project.substring(0, 5);
                      })
                    },
                    yAxis: {
                      type: "value"
                    },
                    color: ["#5470C6", "#8e6e63", "#d3302f", "#378f3c"], // Palette de couleurs
                    series: [{
                      name: "Montant du marché",
                      type: "bar",
                      data: row.montantMarche,
                      itemStyle: { color: "#5470C6" // Couleur spécifique
                      } }, {
                      name: "Budget total",
                      type: "bar",
                      data: row.budgetTotal,
                      itemStyle: { color: "#8e6e63" // Couleur spécifique
                      } }, {
                      name: "Montant décaissé",
                      type: "bar",
                      data: row.montantDecaisse,
                      itemStyle: { color: "#d3302f" // Couleur spécifique
                      } }, {
                      name: "Montant encaissé",
                      type: "bar",
                      data: row.montantEncaisse,
                      itemStyle: { color: "#378f3c" // Couleur spécifique
                      } }]
                  };


                  _this2.chart.setOption(options);
                  window.addEventListener('resize', _this2.handleResize);
                } catch (error) {
                  console.error('Erreur lors de l\'initialisation du graphique:', error);
                }

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    initChart: function initChart(row) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var options;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this3.$nextTick();

              case 2:
                if (_this3.$refs.chart) {
                  _context4.next = 5;
                  break;
                }

                console.error("L'élément de référence 'chart' n'existe pas");
                return _context4.abrupt('return');

              case 5:

                try {
                  _this3.chart = __WEBPACK_IMPORTED_MODULE_7_echarts__["init"](_this3.$refs.chart);
                  options = {
                    title: {
                      text: "Courbe d'évolution des marges et du taux d'évolution physique",
                      left: "left",
                      subtextStyle: {
                        color: "#007BFF",
                        fontSize: 14,
                        cursor: "pointer",
                        fontWeight: "bold"
                      },
                      triggerEvent: true
                    },

                    tooltip: {
                      trigger: "axis",
                      axisPointer: {
                        type: "cross"
                      },
                      formatter: function formatter(params) {
                        var result = params[0].axisValueLabel + "<br/>";
                        params.forEach(function (param) {
                          // Formater selon le type de donnée
                          var value = param.seriesName === "Taux physique" ? param.value + "%" : param.value.toLocaleString() + " XOF";
                          result += param.marker + param.seriesName + ": " + value + "<br/>";
                        });
                        return result;
                      }
                    },
                    legend: {
                      data: ["Marge", "Taux physique"]
                    },
                    grid: {
                      left: "3%",
                      right: "4%",
                      bottom: "3%",
                      containLabel: true
                    },
                    toolbox: {
                      feature: {
                        saveAsImage: {}
                      }
                    },
                    xAxis: {
                      type: "category",
                      boundaryGap: false,
                      data: row.projects.map(function (project) {
                        return project.substring(0, 5);
                      })
                    },
                    yAxis: [{
                      type: "value",
                      name: "Marge (XOF)",
                      position: "left",
                      axisLine: {
                        show: true,
                        lineStyle: {
                          color: "#4CAF50"
                        }
                      },
                      axisLabel: {
                        formatter: "{value} XOF"
                      }
                    }, {
                      type: "value",
                      name: "Taux physique (%)",
                      position: "right",
                      axisLine: {
                        show: true,
                        lineStyle: {
                          color: "#1976D2"
                        }
                      },
                      axisLabel: {
                        formatter: "{value} %"
                      },
                      splitLine: {
                        show: false
                      }
                    }],
                    series: [{
                      name: "Marge",
                      type: "line",
                      smooth: true,
                      yAxisIndex: 0, // Utilise le premier axe Y
                      data: row.marges,
                      lineStyle: {
                        color: "#4CAF50",
                        width: 3
                      },
                      itemStyle: {
                        color: "#4CAF50"
                      },
                      symbol: "circle",
                      symbolSize: 8
                    }, {
                      name: "Taux physique",
                      type: "line",
                      yAxisIndex: 1, // Utilise le second axe Y
                      smooth: true,
                      data: row.taux,
                      lineStyle: {
                        color: "#1976D2",
                        width: 3
                      },
                      itemStyle: {
                        color: "#1976D2"
                      },
                      symbol: "circle",
                      symbolSize: 8
                    }]
                  };


                  _this3.chart.setOption(options);
                  window.addEventListener('resize', _this3.handleResize);
                } catch (error) {
                  console.error('Erreur lors de l\'initialisation du graphique:', error);
                }

              case 6:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3);
      }))();
    },
    handleResize: function handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    },
    closeDialog: function closeDialog() {
      if (this.chart) {
        this.chart.dispose();
      }
      this.$emit("close");
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
      window.removeEventListener('resize', this.handleResize);
    }
  }
});

/***/ }),

/***/ "wzzi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listeOuvrier_vue__ = __webpack_require__("/w6/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ef0d625_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listeOuvrier_vue__ = __webpack_require__("V2G1");
function injectStyle (ssrContext) {
  __webpack_require__("CLLl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ef0d625"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listeOuvrier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ef0d625_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listeOuvrier_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x4h3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListeWorklog_vue__ = __webpack_require__("696s");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bbfa1cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListeWorklog_vue__ = __webpack_require__("foHv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListeWorklog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bbfa1cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListeWorklog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xDZZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutCarteCarburant_vue__ = __webpack_require__("tE4K");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77de19d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutCarteCarburant_vue__ = __webpack_require__("d5iX");
function injectStyle (ssrContext) {
  __webpack_require__("Yk/k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77de19d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AjoutCarteCarburant_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77de19d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AjoutCarteCarburant_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xEp4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
    name: "ModalValidationAppro",
    props: ["show", "approDetail", "totalFact", "listBanque", "listCaisse"],
    data: function data() {
        return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            dialogDetail: false,
            tableProduit: [],
            // listBanque:[],
            totalTTC: 0,
            formRapport: {},
            dialogVisible: false,
            dialogImageUrl: '',
            imageDmd1: "",
            imageDmd2: "",
            imageDmd3: "",
            imageConst1: "",
            imageConst2: "",
            imageConst3: "",
            imageDepan1: "",
            imageDepan2: "",
            imageDepan3: "",
            dialogConfirmRefus: false,
            dialogConfirm: false,
            formRefus: {
                rapport: ''
            },
            rulesRefus: {
                rapport: [{ required: true, message: 'Svp preciser la raison', trigger: 'blur' }]
            },
            formValidate: {
                choix: '',
                banque: '',
                commantaire: ''
            }

        };
    },


    computed: {},
    watch: {
        show: function show(newValue, oldvalue) {
            this.dialogDetail = newValue;
            if (newValue == true) {}
        }
    },

    methods: {
        successNotif: function successNotif() {
            var mess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.$notify({
                title: 'ENREGISTREMENT REUSSI',
                message: mess,
                type: 'success',
                position: 'top-center'
            });
        },
        closeDialog: function closeDialog() {
            this.$emit('close');
            this.dialogDetail = false;
        },
        loadDevisConstat: function loadDevisConstat() {
            var _this = this;

            this.loading = true;
            var url = this.domaine + 'demande_maintenance/devis/constat/' + this.factureDetail.idDemande;
            this.$http.get(url).then(function (response) {
                _this.tableProduit = response.body.tableProduit;
                _this.formRapport.rapport = response.body.rapport;
                _this.totalTTC = response.body.total;
                _this.loading = false;
            }, function (errResp) {
                _this.loading = false;
                _this.$message.error("Une erreur est survenue lors du chargement de la table des produits");
            });
        },


        // loadListBanque (){
        //     this.loading = true
        //     let url = this.domaine + 'caisse/tresor/'+ this.approDetail.caisseId +'/banque'
        //     this.$http.get(url).then(response => {
        //         this.listBanque = response.body.listBanque
        //         this.loading = false
        //     },errResp=>{
        //          this.loading = false
        //           this.$message.error("Une erreur est survenue lors du chargement de la liste banque")
        //     })
        // },

        handleSuccess: function handleSuccess(response, file, fileList) {
            this.fileList.push(file);
        },
        handlePictureCardPreview: function handlePictureCardPreview(file, fileList) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        imprimerDetail: function imprimerDetail() {
            var url = this.domaine + "demande_maintenance/imprimerPDF/demande/" + this.user.id + "/" + this.factureDetail.idDemande;
            window.open(url);
        },
        SubmitValideDevis: function SubmitValideDevis() {
            var _this2 = this;

            this.loading = true;
            var url = this.domaine + 'fournisseur/valider/facture';

            var data = new FormData();
            data.append("id", this.factureDetail.idFact);
            data.append("idUser", this.user.id);
            data.append("remarque", " ");
            data.append("decision", 1);
            this.$http.post(url, data).then(function (response) {
                _this2.loading = false;
                _this2.successNotif(response.body.message);
                _this2.dialogConfirm = false;
                _this2.closeDialog();
            }, function (errResp) {
                _this2.loading = false;
                _this2.$message.error("Une erreur est survenue lors de la facture");
            });
        },
        submitRefusAppro: function submitRefusAppro(formName) {
            var _this3 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {

                    _this3.loading = true;
                    var url = _this3.domaine + 'caisse/' + _this3.approDetail.id + '/refus';
                    var form = document.getElementById('formRefus');
                    var data = new FormData(form);
                    // data.append("id", this.approDetail.caisseId)
                    data.append("commentaire", _this3.formRefus.rapport);
                    _this3.$http.post(url, data).then(function (response) {
                        _this3.loading = false;
                        _this3.successNotif(response.body.message);
                        _this3.dialogConfirmRefus = false;
                        _this3.closeDialog();
                    }, function (errResp) {
                        _this3.loading = false;
                        _this3.$message.error("Une erreur est survenue lors de la facture");
                    });
                } else {
                    return false;
                }
            });
        },
        resetFormRefusAppro: function resetFormRefusAppro(formName) {
            this.$refs[formName].resetFields();
            this.dialogConfirmRefus = false;
        },
        submitValidate: function submitValidate(formName) {
            var _this4 = this;

            this.$refs[formName].validate(function (valid) {
                if (valid) {

                    _this4.loading = true;
                    var url = _this4.domaine + 'caisse/' + _this4.approDetail.id + '/accept';
                    var data = new FormData();
                    data.append("mode", _this4.formValidate.choix);
                    data.append("banque", _this4.formValidate.banque);
                    data.append("commantaire", _this4.formValidate.commantaire);
                    data.append("idUser", _this4.user.id);
                    _this4.$http.post(url, data).then(function (response) {
                        _this4.loading = false;
                        _this4.successNotif(response.body.message);
                        _this4.dialogConfirm = false;
                        _this4.formValidate.choix = "";
                        _this4.formValidate.banque = "";
                        _this4.formValidate.commantaire = "";
                        _this4.closeDialog();
                    }, function (errResp) {
                        _this4.loading = false;
                        _this4.$message.error("Une erreur est survenue lors de la facture");
                    });
                } else {
                    return false;
                }
            });
        },
        changeReglement: function changeReglement() {
            if (this.formValidate.choix == 2) {
                this.formValidate.banque = '';
            } else {
                this.formValidate.banque = '';
            }
        },
        resetFormValidate: function resetFormValidate(formName) {
            this.$refs[formName].resetFields();
            this.dialogConfirm = false;
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_menu_Drawer__ = __webpack_require__("dzy+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "app",
    components: { menuDrawer: __WEBPACK_IMPORTED_MODULE_1__components_menu_Drawer__["a" /* default */] },
    data: function data() {
        return {
            notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
            menus: [{ listeMenu: "Demande", etat: false,
                sousMenus: [{ libelle: 'Recueil de besoin', icon: 'payment', route: 'Besoin', path: '/besoin', etat: true }, { libelle: 'Demande de fonds', icon: 'account_balance_wallet', route: 'DemandeFond', path: '/demandeFond', etat: false },
                // {libelle:'Approbation des demandes de fonds' , icon:'account_balance_wallet' , route:'DemandeFondControle' , path:'/demandeFondControle', etat:true },
                { libelle: 'Liste des BCI', icon: 'account_balance_wallet', route: 'Besoin', path: '/besoin/listeDeBci', etat: false }]
            }, { listeMenu: "Admin", etat: false,
                sousMenus: [{ libelle: "Devis/factures & demandes d'absence", icon: 'list', route: 'ValidationDmd', path: '/validationDmd', etat: false }, { libelle: "Validation DEX", icon: 'list', route: 'ValidationDmd_dex', path: '/validationDmd_dex', etat: false }, { libelle: "Validation COST CONTROL", icon: 'list', route: 'ValidationDmd_post', path: '/validationDmd_post', etat: false }, { libelle: "Validation DGA/DOT", icon: 'list', route: 'ValidationDmd_dga', path: '/validationDmd_dga', etat: false }, { libelle: 'Compte d\'exploitataion', icon: 'account_balance', route: 'BudgetChantier', path: '/budgetChantier', etat: false }, { libelle: 'Indicateur de productivité', icon: 'schedule', route: 'dashboardReporting', path: '/reporting', etat: false }, { libelle: 'Performance achat', icon: 'compare', route: 'comparateur', path: '/comparateur', etat: false }, { libelle: 'Indicateur projet', icon: 'home', route: 'indicateurProjet', path: '/indicateur/projet', etat: false }]
            }, { listeMenu: "Projet", etat: false,
                sousMenus: [{ libelle: 'Projet', icon: 'home', route: 'Projet', path: '/projet', etat: false }, { libelle: 'Worklogs', icon: 'work', route: 'Worklogs', path: '/worklogs', etat: false }, { libelle: 'Board chantier', icon: 'business', route: 'DashBoardChantier', path: '/boardChantier', etat: false }, { libelle: 'Board travaux', icon: 'business', route: 'DashboardTravaux', path: '/boardTravaux', etat: false }, { libelle: 'Board Commis', icon: 'business', route: 'DashboardCommis', path: '/boardCommis', etat: false }, { libelle: 'Performance rapport', icon: 'compare', route: 'comparateur_journal', path: '/comparateur_journal', etat: false }, { libelle: 'Tableau comparatif de projet', icon: 'home', route: 'DashboardComparatif', path: '/boardComparatif/projet', etat: false }, { libelle: 'Tableau Analyse de rendement', icon: 'list', route: 'DashboardRapport', path: '/boardRapport/projet', etat: false }]
            }, { listeMenu: "RH", etat: false,
                sousMenus: [{ libelle: 'Board RH', icon: 'groups', route: 'indexResource', path: '/indexResource', etat: false }, { libelle: 'Demande de conge', icon: 'check_box', route: 'boardEmploye', path: '/boardEmploye', etat: true }, { libelle: 'Ressource technique', icon: 'group', route: 'listeOuvrier', path: '/listeOuvrier', etat: false }, { libelle: 'Mission', icon: 'drive_eta', route: 'Mission', path: '/mission', etat: false }]
            }, { listeMenu: "Tiers", etat: false,
                sousMenus: [{ libelle: 'Fournisseur et prestataire', icon: 'shopping_cart', route: 'Fournisseur', path: '/fournisseur', etat: false }, { libelle: 'Magasin chantier', icon: 'store', route: 'Entrepot', path: '/entrepot', etat: false }, { libelle: 'Client', icon: 'people', route: 'Client', path: '/Client', etat: false }, { libelle: "Recherche d'information", icon: 'search', route: 'search', path: '/search', etat: true }]
            }, { listeMenu: "Logistique", etat: false,
                sousMenus: [{ libelle: 'Tableau de bord', icon: 'ev_station', route: 'Parc', path: '/parc/auto', etat: false }]
            }, { listeMenu: "Comptabilité", etat: false,
                sousMenus: [{ libelle: 'Trésorerie', icon: 'account_balance_wallet', route: 'Caisse', path: '/caisse', etat: false }, { libelle: 'Plan comptable', icon: 'list', route: 'PlanComptable', path: '/plan-comptable', etat: true }]
            }, { listeMenu: "Paramètres", etat: false,
                sousMenus: [{ libelle: 'Configuration', icon: 'settings', route: 'Parametre', path: '/parametre', etat: false }, { libelle: 'Utilisateurs', icon: 'groups', route: 'User', path: '/user', etat: false }, { libelle: 'Ressources & Type chantier', icon: 'store', route: 'Keywords', path: '/keywords', etat: false }]
            }],
            tabs: null,
            loading: false,
            domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
            user: JSON.parse(sessionStorage.getItem('userInfo')),
            roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            clipped: false,
            drawer: true,
            fixed: false,
            dialogDeconnect: false,
            dialogProfil: false,
            dialogMdp: false,
            dialogAjout: false,
            dialogImageUrl: '',
            dialogImageVisible: false,
            items: [{ icon: 'home', path: '/', title: 'Accueil' }, { icon: 'account_circle', path: '/user', title: 'Utilisateurs' }, { icon: 'assignment', path: '/fournisseur', title: 'Fournisseurs' }],
            miniVariant: false,
            right: true,
            rightDrawer: false,
            title: 'ACHIPRO',
            valid: true,
            nomUser: '',
            loginUser: '',
            contactUser: '',
            fonctionUser: '',
            emailUser: "",
            listeMenus: [],
            listFinal: [],
            selectServiceUser: null,
            listService: [],
            serviceUserRules: [function (v) {
                return !!v || 'Veuillez sélectionner votre service.';
            }],
            mdpUserConnect: '',
            mdpUser: '',
            mdpNewUser: '',
            mdpNewVerUser: '',
            mdpUserRules: [function (v) {
                return !!v || 'Votre mot de passe est obligatoire';
            }, function (v) {
                return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
            }],
            mdpNewUserRules: [function (v) {
                return !!v || 'Le nouveau mot de passe est obligatoire.';
            }, function (v) {
                return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
            }],
            mdpNewVerUserRules: [function (v) {
                return !!v || 'Veuillez confirmer le nouveau mot de passe.';
            }, function (v) {
                return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
            }],
            mdpUserConnectRules: [function (v) {
                return !!v || 'Votre mot de passe est obligatoire pour la confirmation';
            }],
            nomUserRules: [function (v) {
                return !!v || 'Le nom est obligatoire';
            }, function (v) {
                return v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
            }],
            loginUserRules: [function (v) {
                return !!v || 'Le login est obligatoire';
            }, function (v) {
                return v.length >= 4 || 'Vous devez renter pas moins de 4 caractères';
            }],
            emailUserRules: [function (v) {
                return !!v || 'E-mail est obligatoire';
            }, function (v) {
                return (/.+@.+/.test(v) || 'Vous devez respecter format de E-mail'
                );
            }],
            contactUserRules: [function (v) {
                return !!v || "Le contact de l'utilisateur est obligatoire";
            }, function (v) {
                return (/[0-9]/.test(v) || 'Vous devez respecter format du contact'
                );
            }],
            showdrawer: null,
            name: "BEMITIAN-SA",
            logo: "/static/bemitian-sa.jpeg"

        };
    },
    mounted: function mounted() {
        this.loadService();
        this.loadPage();
        this.menusVerif();
    },

    computed: {
        // un accesseur (getter) calculé
        menuShow: function menuShow() {

            var menusC = this.menus.slice();
            var listeMenus = menusC.filter(function (menu) {
                return menu.sousMenus.filter(function (sousM) {
                    return sousM.etat == true;
                });
            });

            var final = [];
            for (var i = 0; i < listeMenus.length; i++) {
                var comp = 0;
                for (var j = 0; j < listeMenus[i]['sousMenus'].length; j++) {
                    if (listeMenus[i]['sousMenus'][j].etat == true) {
                        comp++;
                    }
                }
                if (comp != 0) {
                    listeMenus[i].etat = true;
                    final.push(listeMenus[i]);
                }
            }
            return final;
        }
    },
    methods: {
        onChangeNotif: function onChangeNotif() {
            var _this = this;

            this.notifs = this.notif;
            var url = this.domaine + "userCreate/users/" + this.user.id;
            this.$http.get(url).then(function (resp) {
                sessionStorage.setItem("sessionNotif", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.notifs));
                _this.loading = false;
                window.location.reload();
            }, function (error) {
                _this.loading = false;
                _this.$message.error("");
            });
        },
        menu: function menu(url) {
            this.$router.go({ name: url });
        },
        loadPage: function loadPage() {
            this.loading = true;
        },
        loadService: function loadService() {
            var _this2 = this;

            var url = this.domaine + 'webService/liste-service';
            this.$http.get(url).then(function (response) {
                if (response.body) {
                    _this2.listService = response.body.service;
                }
            });
        },
        editUser: function editUser() {
            this.dialogAjout = true;
            this.nomUser = this.user.nom;
            this.loginUser = this.user.username;
            this.emailUser = this.user.email;
            this.fonctionUser = this.user.fonction;
            this.selectServiceUser = this.user.serviceId;
            this.contactUser = this.user.telephone;
            this.mdpUserConnect = '';
            this.loading = false;
        },
        submit: function submit() {
            var _this3 = this;

            this.loading = true;
            if (this.$refs.formProfilUser.validate()) {
                if (this.mdpNewUser === this.mdpNewVerUser) {
                    var form = document.getElementById('formProfilUser');
                    var formdata = new FormData(form);
                    var url = this.domaine + 'userCreate/' + this.user.id + '/user/edit';
                    formdata.append('idUser', this.user.id);
                    formdata.append('nomUser', this.nomUser);
                    formdata.append('loginUser', this.loginUser);
                    formdata.append('fonctionUser', this.fonctionUser);
                    formdata.append('emailUser', this.emailUser);
                    formdata.append('contactUser', this.contactUser);
                    formdata.append('serviceUser', this.selectServiceUser);
                    formdata.append('mdpUser', this.mdpUserConnect);

                    this.$http.post(url, formdata).then(function (response) {
                        if (response.body) {
                            var verif = response.body;
                            if (verif.code === 1) {
                                _this3.$notify({
                                    title: "L'UTILISATEUR A BIEN ETE MOFIFIE",
                                    message: 'Modification éffectué avec succès.',
                                    type: 'success',
                                    position: 'top-center'
                                });
                            } else if (verif.code === 2) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 3) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 4) {
                                _this3.$message.error(verif.message);
                            } else if (verif.code === 5) {
                                _this3.$message.error(verif.message);
                            }
                            _this3.loading = false;
                            _this3.dialogAjout = false;
                            _this3.loadPage();
                        } else {
                            _this3.$message.error('Erreur serveur');
                            _this3.loading = false;
                            _this3.dialogAjout = false;
                        }
                    }, function (response) {
                        _this3.$message.error('Erreur serveur');
                        _this3.loading = false;
                    });
                } else {
                    this.$message.error('Le mot de passe de vérification doit être identique a votre mot de passe');
                }
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "Utilisateur n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        submitMdp: function submitMdp() {
            var _this4 = this;

            this.loading = true;
            if (this.$refs.formMdp.validate()) {
                if (this.mdpNewUser === this.mdpNewVerUser) {
                    var form = document.getElementById('formMdp');
                    var formdata = new FormData(form);
                    var url = this.domaine + 'userCreate/' + this.user.id + '/edit/admin/password';
                    formdata.append('idUser', this.user.id);
                    this.$http.post(url, formdata).then(function (response) {
                        if (response.body) {
                            var verif = response.body;
                            if (verif.code === 1) {
                                _this4.$notify({
                                    title: "L'UTILISATEUR A BIEN ETE MOFIFIE",
                                    message: 'Modification éffectué avec succès.',
                                    type: 'success',
                                    position: 'top-center'
                                });
                            } else if (verif.code === 2) {
                                _this4.$message.error(verif.message);
                            } else if (verif.code === 3) {
                                _this4.$message.error(verif.message);
                            } else if (verif.code === 0) {
                                _this4.$message.error(verif.message);
                            }
                            _this4.loading = false;
                            _this4.dialogMdp = false;
                            _this4.loadPage();
                        } else {
                            _this4.$message.error('Erreur serveur');
                            _this4.loading = false;
                        }
                    }, function (response) {
                        _this4.$message.error('Erreur serveur');
                        _this4.loading = false;
                    });
                } else {
                    this.$message.error('Le mot de passe de vérification doit être identique au nouveau mot de passe');
                    this.loading = false;
                }
            } else {
                this.$message.error('Veuillez renseigner les champs obligatoires');
                this.$notify.error({
                    title: "ERREUR D'ENREGISTREMENT",
                    message: "Utilisateur n'a pas été enregistré.",
                    position: 'top-center'
                });
                this.loading = false;
            }
        },
        submitNotif: function submitNotif() {
            var _this5 = this;

            this.loading = true;
            var url = this.domaine + 'userCreate/' + this.user.id + '/notification/user';
            var data = new FormData();
            data.append('idUser', this.user.id);
            data.append('notif', this.notif);

            this.$http.post(url, data).then(function (response) {
                if (response.body) {
                    var verif = response.body;
                    var notification = response.body.data.notif;
                    sessionStorage.setItem('sessionNotif', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(notification));

                    _this5.$notify({
                        title: "NOTIFICATION " + _this5.notif,
                        message: 'Modification éffectué avec succès.',
                        type: 'success',
                        position: 'top-center'
                    });

                    _this5.loading = false;
                    _this5.loadPage();
                } else {
                    _this5.$message.error('Erreur serveur');
                    _this5.loading = false;
                }
            }, function (response) {
                _this5.$message.error('Erreur serveur');
                _this5.loading = false;
            });
        },
        clear: function clear() {
            this.$refs.formProfilUser.reset();
            this.dialogAjout = false;
            this.dialogMdp = false;
        },
        deconnect: function deconnect() {
            sessionStorage.clear();
            this.$router.go({ name: 'Login' });
        },
        menusVerif: function menusVerif() {
            self = this;
            this.menus.forEach(function (menu) {
                menu.sousMenus.forEach(function (sousM) {
                    if (self.roleAcces[sousM.route]) {
                        sousM.etat = true;
                    }
                });
            });
        }
    }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bbb7160_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("09Nl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bbb7160_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xQNe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formAjoutFour_vue__ = __webpack_require__("0dNY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b09ed3d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formAjoutFour_vue__ = __webpack_require__("GjUy");
function injectStyle (ssrContext) {
  __webpack_require__("CjW+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b09ed3d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formAjoutFour_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b09ed3d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formAjoutFour_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xhyT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogTache),callback:function ($$v) {_vm.dialogTache=$$v},expression:"dialogTache"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("LISTE DES TACHES POUR LES TRAVAUX :\n          "+_vm._s(_vm.detailTrx.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":"","ml-2":"","mr-2":"","mt-5":""}},[_c('v-card',[_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"mt-3":"","ml-1":"","mr-1":"","data":_vm.listeTache}},[_c('el-table-column',{attrs:{"prop":"libelle","label":"TACHES","align":"center","width":"230","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"DATE","align":"center"}},[_c('el-table-column',{attrs:{"prop":"dateD","label":"Début"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"Durée (Jours) "}})],1),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateDemarage","label":"Demarré le"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libEtat","label":"STATUS","align":"center"}}),_vm._v(" "),(!_vm.commis)?_c('el-table-column',{attrs:{"label":"ACTION","align":"center","width":"250","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"blue","fab":"","dark":"","small":""},on:{"click":function($event){_vm.tacheSelect = scope.row;
                              _vm.loadOuvrier(scope.row);}},slot:"activator"},[_c('v-icon',[_vm._v("assignment_ind")])],1),_vm._v(" "),_c('span',[_vm._v("ouvriers")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(
                              scope.row.prestataire == true &&
                                scope.row.etat != 0
                            )?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","fab":"","dark":"","small":""},on:{"click":function($event){return _vm.showDialogReserve(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("announcement")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("reserve")])],1),_vm._v(" "),(scope.row.etat == 0)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"green","fab":"","dark":"","small":""},nativeOn:{"click":function($event){_vm.tacheSelect = scope.row;
                            _vm.dialogDemarrer = true;}},slot:"activator"},[_c('v-icon',[_vm._v("play_circle_outline")])],1):_vm._e(),_vm._v("Démarrer\n                      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(scope.row.etat == 3 )?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"orange","fab":"","dark":"","small":""},nativeOn:{"click":function($event){_vm.tacheSelect = scope.row;
                            _vm.submitRelanceTache();}},slot:"activator"},[_c('v-icon',[_vm._v("play_circle_outline")])],1):_vm._e(),_vm._v("Relancer\n                      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(scope.row.etat == 1)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"red","fab":"","dark":"","small":""},nativeOn:{"click":function($event){_vm.tacheSelect = scope.row;
                            _vm.dialogConfirmRefus = true;}},slot:"activator"},[_c('v-icon',[_vm._v("stop")])],1):_vm._e(),_vm._v("Suspendre\n                      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(!scope.row.etat == 2)?_c('v-btn',{attrs:{"slot":"activator","icons":"","color":"green","fab":"","dark":"","small":""},nativeOn:{"click":function($event){_vm.tacheSelect = scope.row;
                            _vm.dialogTermine = true;}},slot:"activator"},[_c('v-icon',[_vm._v("done_all")])],1):_vm._e(),_vm._v("Terminer\n                      ")],1)]}}],null,false,3877203186)}):_vm._e()],1),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":true,"width":"90%","scrollable":""},model:{value:(_vm.dialogOuvrier),callback:function ($$v) {_vm.dialogOuvrier=$$v},expression:"dialogOuvrier"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("LISTE DES OUVRIERS ET PRESTATAIRE AFFECTES A LA TACHE:\n            "+_vm._s(_vm.tacheSelect.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogOuvrier = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTE DES OUVRIERS")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","elevation-2":""}},[_c('v-flex',{attrs:{"sm12":"","mt-2":""}},[_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"mt-3":"","ml-1":"","mr-1":"","data":_vm.listeOuvriers}},[_c('el-table-column',{attrs:{"prop":"idContrat","label":"Contrat","align":"center","width":"100","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("CONT-"+_vm._s(scope.row.idContrat))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nom","label":"NOM","align":"center","width":"230","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateD","label":"Début"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"Durée (Jours) "}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etatContrat","label":"Etat contrat","align":"center"}})],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{attrs:{"mt-2":""}},[_vm._v("LISTE DES PRESTATAIRES")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","elevation-2":""}},[_c('v-flex',{attrs:{"sm12":"","mt-2":""}},[_c('data-tables',{staticStyle:{"width":"99%"},attrs:{"mt-3":"","ml-1":"","mr-1":"","data":_vm.listePrestataires}},[_c('el-table-column',{attrs:{"prop":"idContrat","label":"Contrat","align":"center","width":"100","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("CONT-"+_vm._s(scope.row.idContrat))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nom","label":"NOM","align":"center","width":"230","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateC","label":"DATE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateD","label":"Début"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateF","label":"Fin"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"duree","label":"Durée (Jours) "}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"etatContrat","label":"Etat contrat","align":"center"}})],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-right",attrs:{"row":""}})],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"50%"},model:{value:(_vm.dialogSuprPresence),callback:function ($$v) {_vm.dialogSuprPresence=$$v},expression:"dialogSuprPresence"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Supprimer cet enregistrement ?")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"La suppression est définitive","closable":false,"show-icon":"","type":"error"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('p',{staticClass:"grey--text font-weight-thin body-1"},[_vm._v("\n                OUVRIER/PRESTATAIRE\n              ")]),_vm._v(" "),_c('p',{staticClass:"black--text .font-weight-regular subheading"},[_vm._v("\n                "+_vm._s(_vm.presenceSelect.libelle)+"\n              ")])])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},on:{"click":function($event){_vm.dialogSuprPresence = false}}},[_vm._v("\n            Annuler\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),(this.tacheSelect.etat != 2)?_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.deletePresence(_vm.presenceSelect.idPresence)}}},[_vm._v("\n            Supprimer\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("delete")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600","persistent":true},model:{value:(_vm.dialogDemarrer),callback:function ($$v) {_vm.dialogDemarrer=$$v},expression:"dialogDemarrer"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Démarrer une tâche: "+_vm._s(_vm.tacheSelect.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogDemarrer = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formDemarrer",staticClass:"demo-form-inline",attrs:{"id":"formDemarrer","label-width":"90px","model":_vm.formDemarrer}},[_c('el-form-item',{attrs:{"label":"Debut","required":""}},[_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"dateDbt"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","placeholder":"Choisir une date de debut","format":"dd-MM-yyyy"},model:{value:(_vm.formDemarrer.dateDbt),callback:function ($$v) {_vm.$set(_vm.formDemarrer, "dateDbt", $$v)},expression:"formDemarrer.dateDbt"}})],1)],1),_vm._v(" "),_c('el-col',{staticClass:"line",attrs:{"span":2}},[_vm._v("-")]),_vm._v(" "),_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"prop":"hrDbt"}},[_c('el-time-picker',{staticStyle:{"width":"100%"},attrs:{"type":"fixed-time","placeholder":"Choisir une heure de debut"},model:{value:(_vm.formDemarrer.hrDbt),callback:function ($$v) {_vm.$set(_vm.formDemarrer, "hrDbt", $$v)},expression:"formDemarrer.hrDbt"}})],1)],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"grey","dark":""},on:{"click":function($event){return _vm.resetForm('formDemarrer')}}},[_vm._v("\n                Annuler\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("remove_circle")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","dark":"","color":"green"},on:{"click":function($event){return _vm.submitFormDemarrer('formDemarrer')}}},[_vm._v("\n                Enregistrer\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.dialogConfirmRefus),callback:function ($$v) {_vm.dialogConfirmRefus=$$v},expression:"dialogConfirmRefus"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Arreter la tâche: "+_vm._s(_vm.tacheSelect.libelle))]),_vm._v(" "),_c('v-card-text',[_c('el-form',{ref:"formRefus",staticClass:"demo-form-inline",attrs:{"id":"formRefus","label-position":"top","inline":true,"model":_vm.formRefus}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form-item',{staticStyle:{"width":"100%"},attrs:{"label":"Voulez vous Arreter la tâche ?"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":6,"placeholder":"Pourquoi voulez-vous Arreter cette tâche ?"},model:{value:(_vm.formRefus.rapport),callback:function ($$v) {_vm.$set(_vm.formRefus, "rapport", $$v)},expression:"formRefus.rapport"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialogConfirmRefus = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":function($event){return _vm.submitFormStop('formRefus')}}},[_vm._v("Confirmer")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.dialogTermine),callback:function ($$v) {_vm.dialogTermine=$$v},expression:"dialogTermine"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Tâche terminée: "+_vm._s(_vm.tacheSelect.libelle))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.dialogTermine = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},on:{"click":function($event){return _vm.submitTacheTerminer()}}},[_vm._v("Confirmer")])],1)],1)],1)],1)],1),_vm._v(" "),_c('AjoutReserve',{attrs:{"tache":_vm.tacheSelect,"show":_vm.showAddReserve},on:{"close":function($event){return _vm.closeAjoutReserve()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xoS/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xsRH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loading__ = __webpack_require__("NxGh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Loading: __WEBPACK_IMPORTED_MODULE_0__components_Loading__["a" /* default */] },
    name: "DetailBudgetProjet",
    props: {
        show: {
            type: Boolean
        },
        detailProjet: {
            type: Object
        }
    },
    data: function data() {
        return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),

            loading: false,
            dialogDetail: false,
            listeBudget: [],
            bilanMensuel: [],
            bilanTravaux: [],
            listeDetail: [],
            compte: "0",
            dialogConfirm: false,
            disabledBtnPop: false,
            totalMntPropose: 0,
            totalMntValide: 0

        };
    },


    computed: {},
    watch: {
        show: function show(newValue, oldvalue) {
            var _this2 = this;

            this.dialogDetail = newValue;
            if (newValue == true) {
                this.listeBudget = this.detailProjet.budgets;
                var _this = this;
                this.totalMntPropose = 0;
                this.totalMntValide = 0;
                this.totalMntMarche = 0;
                this.listeBudget.forEach(function (item) {
                    _this2.totalMntPropose += item.mntTotalBudgetPropose;
                    _this2.totalMntValide += item.mntTotalBudgetValide;
                });
                this.loadBilan(this.detailProjet.idProj);
            }
        }
    },

    methods: {
        handleTabClick: function handleTabClick(tab) {
            switch (tab) {
                case "0":
                    break;
                case "1":
                    break;

                default:
                    break;
            }
        },
        getSummaries: function getSummaries(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = "Sous total";
                    return;
                }
                var values = data.map(function (item) {
                    return Number(item[column.property]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0));
                } else {
                    sums[index] = "N/A";
                }
            });

            return sums;
        },
        getSumm: function getSumm(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = "Sous total";
                    return;
                }

                if (index === 4) {
                    sums[index] = "N/A";
                    return;
                }
                var values = data.map(function (item) {
                    return Number(item[column.property]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0));
                } else {
                    sums[index] = "N/A";
                }
            });

            return sums;
        },
        closeDialog: function closeDialog() {
            this.$emit('close');
        },
        getSummCompte: function getSummCompte(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = "Sous total";
                    return;
                }

                var values = data.map(function (item) {
                    return Number(item[column.property]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0));
                } else {
                    sums[index] = "N/A";
                }
            });

            return sums;
        },
        getSummCompteFinance: function getSummCompteFinance(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = "Sous total";
                    return;
                }

                if (index === 6) {
                    sums[index] = "N/A";
                    return;
                }

                var values = data.map(function (item) {
                    return Number(item[column.property]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0));
                } else {
                    sums[index] = "N/A";
                }
            });

            return sums;
        },
        handleChange: function handleChange(newValue, oldValue) {},
        SubmitValideBudget: function SubmitValideBudget() {
            var _this3 = this;

            this.loading = true;
            var url = this.domaine + "compteExploit/valider/budget_projet";

            var nbData = 10;
            var nbReq = 1;
            var ligne = null;

            var nbRest = void 0;
            if (this.listeBudget.length > 10) {
                nbData = 10;
                nbReq = Math.round(this.listeBudget.length / nbData);
                nbRest = this.listeBudget.length % nbData;
                if (nbRest > 0) {
                    nbReq += 1;
                }
            }
            for (var i = 0; i < nbReq; i++) {
                var initJ = i * nbData;
                var finJ = (i + 1) * nbData;
                var dataLot = [];
                if (this.listeBudget.length > 0) {
                    for (var j = initJ; j < finJ; j++) {
                        if (this.listeBudget[j] == undefined) {
                            break;
                        }
                        dataLot.push(this.listeBudget[j]);
                    }
                }
                var data = new FormData();
                for (var prop in dataLot) {
                    console.lpg('ddjd', dataLot[prop]);
                    ligne = dataLot[prop];
                    data.append("option[id][]", ligne.id);
                    data.append("option[libelle][]", ligne.libelle);
                    data.append("option[mntTotalBudgetPropose][]", ligne.mntTotalBudgetPropose);
                    data.append("option[mntTotalBudgetValide][]", ligne.mntTotalBudgetValide);
                    data.append("option[ecartMntTotal][]", ligne.ecartMntTotal);
                    data.append("option[idBudget][]", ligne.idBudget);
                    data.append("option[libelle][]", ligne.libelle);
                    data.append("option[mntBudgetPropose][]", ligne.mntBudgetPropose);
                    data.append("option[mntBudgetValide][]", ligne.mntBudgetValide);
                    data.append("option[ecartBudget][]", ligne.ecartBudget);
                    data.append("option[mois][]", ligne.mois);
                }

                // data.append('listeTypeTravaux', JSON.stringify(dataLot))
                data.append("idUser", this.user.id);
                data.append("idProjet", this.detailProjet.id);

                this.$http.post(url, data).then(function (resp) {
                    _this3.loading = false;
                    succesEnreg = false;
                    _this3.$emit("close");
                    _this3.dialogAjoutBudget = false;
                    _this3.showFourn();
                    _this3.$notify({
                        title: "Enregistrement",
                        message: "La liste a ete enregistre avec succes",
                        type: "success",
                        position: "top-right",
                        duration: 5000
                    });
                }, function (error) {
                    _this3.loading = false;
                    succesEnreg = false;
                    _this3.dialogAjoutBudget = false;
                    _this3.$message.error("Erreur lors de l'enregistrement des tarifs");
                });
            }
        },
        headerRowStyle: function headerRowStyle(_ref) {
            var row = _ref.row,
                rowIndex = _ref.rowIndex;

            return { "color": "black" };
        },
        getSummDetailBudget: function getSummDetailBudget(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = "Sous total";
                    return;
                }

                if (index === 5) {
                    sums[index] = "N/A";
                    return;
                }
                var values = data.map(function (item) {
                    return Number(item[column.property]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = new Intl.NumberFormat().format(values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0));
                } else {
                    sums[index] = "N/A";
                }
            });

            return sums;
        },
        loadBilan: function loadBilan(idProjet) {
            var _this4 = this;

            this.loading = true;
            var url = this.domaine + "budgetProjet/bilan/projet/" + idProjet;
            this.$http.get(url).then(function (response) {
                _this4.loading = false;
                _this4.bilanMensuel = response.body.mensuel;
                _this4.bilanTravaux = response.body.bilanTravaux.travaux;
                _this4.listeDetail = response.body.detailCompte;
            }, function (errRep) {
                _this4.loading = false;
                _this4.$message.error("Une erreur est survenue lors du chargement du bilan");
            });
        },
        imprimeBudgtTravauxPDF: function imprimeBudgtTravauxPDF(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerPDF_budget_travaux';
            } else {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerEXC_budget_travaux';
            }
            window.open(url);
        },
        imprimeBudgtTravauxPDFSimpl: function imprimeBudgtTravauxPDFSimpl(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerPDF_budget_travauxSimpl';
            } else {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerEXC_budget_travauxSimpl';
            }
            window.open(url);
        },
        imprimeBudgtRecapitulatifAnnuel: function imprimeBudgtRecapitulatifAnnuel(type) {

            var url = "";
            if (type == "PDF") {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerPDF_RecapitulatifAnnuel';
            } else {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerEXC_RecapitulatifAnnuel';
            }
            window.open(url);
        },
        imprimeBudgtRecapitulatifAnnuelSimpl: function imprimeBudgtRecapitulatifAnnuelSimpl(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerPDF_RecapitulatifAnnuelSimpl';
            } else {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerEXC_RecapitulatifAnnuelSimpl';
            }
            window.open(url);
        },
        imprimeBudgtRecapitulatifTravaux: function imprimeBudgtRecapitulatifTravaux(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerPDF_RecapitulatifTravaux';
            } else {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerEXC_RecapitulatifTravaux';
            }
            window.open(url);
        },
        imprimeBudgtRecapitulatifTravauxSimpl: function imprimeBudgtRecapitulatifTravauxSimpl(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerPDF_RecapitulatifTravauxSimpl';
            } else {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerEXC_RecapitulatifTravauxSimpl';
            }
            window.open(url);
        },
        imprimeBudgtRecapitulatifFinance: function imprimeBudgtRecapitulatifFinance(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerPDF_RecapitulatifFinancier';
            } else {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerEXC_RecapitulatifFinancier';
            }
            window.open(url);
        },
        imprimeBudgtRecapitulatifFinanceSimpl: function imprimeBudgtRecapitulatifFinanceSimpl(type) {
            var url = "";
            if (type == "PDF") {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerPDF_RecapitulatifFinancierSimpl';
            } else {
                url = this.domaine + 'budgetProjet/budget/projet/' + this.detailProjet.idProj + '/user/' + this.user.id + '/imprimerEXC_RecapitulatifFinancierSimpl';
            }
            window.open(url);
        }
    },
    mounted: function mounted() {}
});

/***/ }),

/***/ "y5D2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("\n             ANALYSE DU JOURNAL DES DONNEES\n            ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{staticClass:"elevation-12 pt-1 mb-3",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('h3',[_vm._v("Critères de recherche ")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"}),_vm._v(" "),_c('el-form',{staticClass:"demo-form-inline",attrs:{"inline":true,"model":_vm.formTri,"id":"formTri"}},[_c('el-form-item',{attrs:{"label":"Projet"}},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"Projet"},on:{"change":function($event){return _vm.onchangeInfo(_vm.selectProjet)}},model:{value:(_vm.selectProjet),callback:function ($$v) {_vm.selectProjet=$$v},expression:"selectProjet"}},_vm._l((_vm.listeProjet),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Chantier"}},[_c('el-select',{attrs:{"clearable":"","placeholder":"Chantier"},on:{"change":function($event){_vm.loadTravaux();_vm.onchangeChantier(_vm.selectChantier)}},model:{value:(_vm.selectChantier),callback:function ($$v) {_vm.selectChantier=$$v},expression:"selectChantier"}},_vm._l((_vm.listeChantier),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Section"}},[_c('el-select',{attrs:{"clearable":"","placeholder":"Travaux"},on:{"change":function($event){_vm.loadTaches();_vm.onChangeTravaux(_vm.selectTravaux)}},model:{value:(_vm.selectTravaux),callback:function ($$v) {_vm.selectTravaux=$$v},expression:"selectTravaux"}},_vm._l((_vm.listeTravaux),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Tâche"}},[_c('el-select',{attrs:{"clearable":"","placeholder":"Tâche"},model:{value:(_vm.selectTaches),callback:function ($$v) {_vm.selectTaches=$$v},expression:"selectTaches"}},_vm._l((_vm.listTaches),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Période"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":"dd-MM-yyyy","value-format":"yyyy-MM-dd","type":"datetimerange","range-separator":"à","start-placeholder":"Début date","end-placeholder":"Fin date"},model:{value:(_vm.selectAnnee),callback:function ($$v) {_vm.selectAnnee=$$v},expression:"selectAnnee"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Type de recherche"}},[_c('el-select',{attrs:{"clearable":"","placeholder":"Type de recherche"},model:{value:(_vm.typeRech),callback:function ($$v) {_vm.typeRech=$$v},expression:"typeRech"}},_vm._l((_vm.listeTypeRech),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.libelle,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","color":"blue","fab":"","small":""},on:{"click":function($event){return _vm.loadChantierSearch()}},slot:"activator"},[_c('v-icon',[_vm._v("search")])],1),_vm._v("Effectuer une recherche\n                              ")],1)],1)],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-chip',{staticClass:"text-align:center",staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"primary"}},[_vm._v(" TABLEAU RECAPITULATIF DES MAINS D'ŒUVRES ")]),_vm._v(" "),(_vm.listTravauxResult.listeParticipants && _vm.listTravauxResult.listeParticipants.length >0)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogueImprimer=true;_vm.type='ALL'}},slot:"activator"},[_vm._v("\n                    Exporter en Pdf tous les tableaux\n                      "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("Pdf\n                ")],1)],1):_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[(_vm.listTravauxResult.listeParticipants && _vm.listTravauxResult.listeParticipants.length >0)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogueImprimer=true;_vm.type='JOURNAL_PARTICIPANT'}},slot:"activator"},[_vm._v("\n                          Exporter en Pdf\n                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("Pdf\n                      ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModePlan('exel','JOURNAL_PARTICIPANT_EXCEL')}},slot:"activator"},[_vm._v("\n                          Exporter en Excel\n                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1),_vm._v("Excel\n                      ")],1)],1):_vm._e(),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listTravauxResult.listeParticipants}},[(_vm.typeRech != 'recap')?_c('el-table-column',{attrs:{"prop":"createdAt","label":"Date de saisie","align":"center","width":"150","fixed":""}}):_vm._e(),_vm._v(" "),(_vm.typeRech != 'recap')?_c('el-table-column',{attrs:{"prop":"dateRapport","label":"Date du rapport","align":"center","width":"150","fixed":""}}):_vm._e(),_vm._v(" "),(_vm.typeRech != 'recap')?_c('el-table-column',{attrs:{"prop":"libTrx","label":"Libellé travaux","align":"center","width":"250"}}):_vm._e(),_vm._v(" "),(_vm.typeRech != 'recap')?_c('el-table-column',{attrs:{"prop":"tache","label":"Libellé de la tâche","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"warning"}},[_vm._v(_vm._s(scope.row.tache))])]}}],null,false,1895330418)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"matricule","label":"Matricule","align":"center","width":"150","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nomPrenom","label":"Nom & Prénom","align":"center","width":"250","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.nomPrenom))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"fonction","label":"Fonction","align":"center","width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"entierHeureT","label":"Temps de travail (H)","align":"center","width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"coutN","label":"Taux horaire (XOF / heure)","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"warning","color":"warning"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.coutN)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"coutT","label":"Cout total XOF","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.coutT))])]}}])})],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"warning"}},[_vm._v("MATÉRIELS ET CARBURANTS")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[(_vm.listTravauxResult.listeVehicules && _vm.listTravauxResult.listeVehicules.length >0)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogueImprimer=true;_vm.type='JOURNAL_VEHICULE'}},slot:"activator"},[_vm._v("\n                          Exporter en Pdf\n                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("Pdf\n                        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModePlan('exel','JOURNAL_VEHICULE_EXCEL')}},slot:"activator"},[_vm._v("\n                          Exporter en Excel\n                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1),_vm._v("Excel\n                      ")],1)],1):_vm._e(),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listTravauxResult.listeVehicules}},[(_vm.typeRech != 'recap')?_c('el-table-column',{attrs:{"prop":"createdAt","label":"Date de saisie","align":"center","width":"150","fixed":""}}):_vm._e(),_vm._v(" "),(_vm.typeRech != 'recap')?_c('el-table-column',{attrs:{"prop":"dateRapport","label":"Date du rapport","align":"center","width":"150","fixed":""}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libTrx","label":"Libellé travaux","align":"center","width":"250"}}),_vm._v(" "),(_vm.typeRech != 'recap')?_c('el-table-column',{attrs:{"prop":"tache","label":"Libellé de la tâche","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"warning"}},[_vm._v(_vm._s(scope.row.tache))])]}}],null,false,1895330418)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Immatriculation / Marque","align":"center","width":"250","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cptDjour","label":"Compteur début","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"warning"}},[_vm._v(_vm._s(scope.row.cptDjour))])]}}])},[_vm._v("\n                      ffff\n                    ")]),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cptFjour","label":"Compteur fin","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"warning","color":"warning"}},[_vm._v(_vm._s(scope.row.cptFjour))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"coutUnitaire","label":"Coût unitaire (Jour)","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"warning"}},[_vm._v(_vm._s(scope.row.coutUnitaire))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nmbreHeur","label":"Temps de travail (H)","align":"center","width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Qté GO","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.qte))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cout","label":"Coût GO  XOF","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"warning"}},[_vm._v(_vm._s(scope.row.cout))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalN","label":"Montant d'utilisation en carburant (XOF)","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"warning"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.totalN)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"coutT_utilisation","label":"Montant d'utilisation de l'engin (XOF)","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"warning"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(scope.row.coutT_utilisation)))])]}}])})],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"warning"}},[_vm._v("JOURNAL DES MATÉRIAUX")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[( _vm.listTravauxResult.listeMateriels && _vm.listTravauxResult.listeMateriels.length >0)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){_vm.type='JOURNAL_MATERIAUX';_vm.dialogueImprimer=true}},slot:"activator"},[_vm._v("\n                          Exporter en Pdf\n                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("Pdf\n                        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":""},on:{"click":function($event){return _vm.imprimerModePlan('exel','JOURNAL_MATERIAUX_EXCEL')}},slot:"activator"},[_vm._v("\n                          Exporter en Excel\n                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1),_vm._v("Excel\n                      ")],1)],1):_vm._e(),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listTravauxResult.listeMateriels}},[(_vm.typeRech != 'recap')?_c('el-table-column',{attrs:{"prop":"createdAt","label":"Date de saisie","align":"center","width":"150","fixed":""}}):_vm._e(),_vm._v(" "),(_vm.typeRech != 'recap')?_c('el-table-column',{attrs:{"prop":"dateRapport","label":"Date du rapport","align":"center","width":"150","fixed":""}}):_vm._e(),_vm._v(" "),(_vm.typeRech != 'recap')?_c('el-table-column',{attrs:{"prop":"libTrx","label":"Libellé travaux","align":"center","width":"500"}}):_vm._e(),_vm._v(" "),(_vm.typeRech != 'recap')?_c('el-table-column',{attrs:{"prop":"tache","label":"Libellé de la tâche","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"warning"}},[_vm._v(_vm._s(scope.row.tache))])]}}],null,false,1895330418)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libMat","label":"Désignation","align":"center","width":"250","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.libMat))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","label":"Unité","align":"center","width":"150","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qteMat","label":"Quantité","align":"center","width":"250","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.qteMat))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prix","label":"Cout unitaire XOF","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"warning"}},[_vm._v(_vm._s(scope.row.prix))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":"Coût total XOF","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.total))])]}}])})],1),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.typeRech != 'recap')?_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"warning"}},[_vm._v("JOURNAL DES TRAVAUX")]):_vm._e(),_vm._v(" "),(_vm.typeRech != 'recap')?_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[(_vm.listTravauxResult.listeTaches && _vm.listTravauxResult.listeTaches.length >0)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogueImprimer=true;_vm.type='JOURNAL_TACHES'}},slot:"activator"},[_vm._v("\n                          Exporter en Pdf\n                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("Pdf\n                        ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":""},on:{"click":function($event){return _vm.imprimerModePlan('exel','JOURNAL_TACHES_EXCEL')}},slot:"activator"},[_vm._v("\n                          Exporter en Excel\n                            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1),_vm._v("Excel\n                      ")],1)],1):_vm._e(),_vm._v(" "),(_vm.typeRech != 'recap')?_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listTravauxResult.listeTaches}},[(_vm.typeRech != 'recap')?_c('el-table-column',{attrs:{"prop":"createdAt","label":"Date de saisie","align":"center","width":"150","fixed":""}}):_vm._e(),_vm._v(" "),(_vm.typeRech != 'recap')?_c('el-table-column',{attrs:{"prop":"dateRapport","label":"Date du rapport","align":"center","width":"150","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"orange","color":"primary"}},[_vm._v(_vm._s(scope.row.dateRapport))])]}}],null,false,1776866461)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libTrx","label":"Libellé travaux","align":"center","width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tache","label":"Libellé de la tâche","align":"center","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"warning"}},[_vm._v(_vm._s(scope.row.tache))])]}}],null,false,1895330418)}),_vm._v(" "),(_vm.typeRech != 'recap')?_c('el-table-column',{attrs:{"prop":"profil","label":"Section","align":"center","width":"250","fixed":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","label":"","text-color":"primary","color":"primary"}},[_vm._v(_vm._s(scope.row.profil)+" - "+_vm._s(scope.row.auProfil))])]}}],null,false,3146554587)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","label":"Quantité réalisée","align":"center","width":"250","fixed":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixHt","label":"Prix de revient XOF","align":"center","width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"totalMo","label":"Dépenses travaux","align":"center","width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"commentaire","label":"Observation","align":"center","width":"350"}})],1):_vm._e(),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('br')],1)],1):_vm._e()],1),_vm._v(" "),_c('v-chip',{staticStyle:{"border-radius":"16px"},attrs:{"text-color":"white","label":"","color":"warning"}},[_vm._v("LISTE DES RAPPORTS JOURNALIERS")]),_vm._v(" "),(_vm.listTravauxResult.rapports && _vm.listTravauxResult.rapports.length >0)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogueImprimer=true;_vm.type='JOURNAL_RAPPORT'}},slot:"activator"},[_vm._v(" Exporter en Pdf\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v("Pdf\n            ")],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":""},on:{"click":function($event){return _vm.imprimerModePlan('exel', 'JOURNAL_RAPPORT_EXCEL')}},slot:"activator"},[_vm._v("\n                  Exporter en Excel\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("file_upload")])],1),_vm._v("Excel\n              ")],1)],1):_vm._e(),_vm._v(" "),_c('ListeRapportTrx',{attrs:{"type":2,"commis":false,"typeInterface":true,"rapportPerso":false,"show":true,"listeRapportTrx":_vm.listTravauxResult.rapports},on:{"reloadListeRapport":function($event){return _vm.loadChantierSearch()}}})],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"50%","overlay":true,"scrollable":"","persistent":""},model:{value:(_vm.dialogueImprimer),callback:function ($$v) {_vm.dialogueImprimer=$$v},expression:"dialogueImprimer"}},[_c('v-card',[_c('v-card-text',{attrs:{"text-xs-center":""}},[_c('p',{attrs:{"align":"center"}},[_c('v-btn',{attrs:{"color":"green","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModePlan(2)}}},[_vm._v("\n              Paysage\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icons":"","color":"orange","dark":""},on:{"click":function($event){$event.stopPropagation();return _vm.imprimerModePlan(1)}}},[_vm._v("\n              Portrait\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("print")])],1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"blue",attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogueImprimer = false}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y7Bl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y7U+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListEvolution_vue__ = __webpack_require__("ZaFh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09ddcabc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListEvolution_vue__ = __webpack_require__("lQEb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListEvolution_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09ddcabc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListEvolution_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yNzM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yWbU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":"","mr-1":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"mb-3":"","xs12":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"cyan darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"display-1"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("assignment")]),_vm._v("\n                                                    "+_vm._s(_vm.infoEmploye.congeVacance)+"\n                                                ")],1),_vm._v(" "),_c('div',[_vm._v("Congé vacances(Jrs)")])])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"mb-3":"","xs12":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"orange darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"headline"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("assignment")]),_vm._v("\n                                                    "+_vm._s(_vm.infoEmploye.congeFam))],1),_vm._v(" "),_c('div',[_vm._v("Congé familiaux et medicaux(Jrs)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("Deuil(Jrs)")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.infoEmploye.congeDeuil))])])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"mb-3":"","xs12":""}},[_c('v-card',{staticClass:"white--text elevation-5",attrs:{"color":"red darken-2"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('div',[_c('div',{staticClass:"headline"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("assignment")]),_vm._v("\n                                                    "+_vm._s(_vm.infoEmploye.congeMariage)+"\n                                                ")],1),_vm._v(" "),_c('div',[_vm._v("Mariage(Jrs)")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_vm._v("Autre(Jrs)")]),_vm._v(" "),_c('div',{staticClass:"display-3"},[_vm._v(_vm._s(_vm.infoEmploye.congeAutre))])])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","ml-3":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"blue-grey darken-2","dark":""}},[_c('v-toolbar-title',[_vm._v("Informations personnelles ")])],1),_vm._v(" "),_c('v-card-title',[_c('v-layout',{staticClass:"mb-2 mt-2  pt-2 pb-2 pl-2 pr-2",attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs2":""}},[_c('v-avatar',{staticClass:"elevation-4",attrs:{"tile":true,"size":"140px","height":"140px","color":"grey lighten-4"}},[_c('img',{attrs:{"src":_vm.infoEmploye.urlAvatar,"alt":"avatar"}})]),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"small":"","color":"primary"},on:{"click":function($event){return _vm.showDetailPerso()}}},[_vm._v("\n                                        Modifier\n                                        "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Nom")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                    "+_vm._s(_vm.infoEmploye.nom)+"\n                                                                ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date naissance")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                    "+_vm._s(_vm.infoEmploye.dateNaissance)+"\n                                                                ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Sexe")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                    "+_vm._s(_vm.infoEmploye.sexe)+"\n                                                                ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Contact")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                    "+_vm._s(_vm.infoEmploye.contact)+"\n                                                                ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Rénumération")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                                    "+_vm._s(new Intl.NumberFormat().format(_vm.infoEmploye.renumeration))+"\n                                                                ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Etat du contrat")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[(_vm.infoEmploye.etatContrat == 0)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(_vm.infoEmploye.libEtatContrat))]):_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(_vm.infoEmploye.libEtatContrat))])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Signature")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_c('img',{staticStyle:{"height":"95px","width":"300px"},attrs:{"src":_vm.infoEmploye.urlSign,"alt":"avatar"}})])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Nb contrat(s)")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                            "+_vm._s(_vm.infoEmploye.nbCont)+"\n                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Type contrat")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                            "+_vm._s(_vm.infoEmploye.typeContrat)+"\n                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Civilté")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                            "+_vm._s(_vm.infoEmploye.civilite)+"\n                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Matricule")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                            "+_vm._s(_vm.infoEmploye.matricule)+"\n                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Numéro CNPS")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                            "+_vm._s(_vm.infoEmploye.matriculeCnps)+"\n                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Fonction")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("\n                                                            "+_vm._s(_vm.infoEmploye.fonction)+"\n                                                        ")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("Adresse")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs10":""}},[_c('el-input',{attrs:{"type":"textarea","rows":4,"readonly":true,"placeholder":"Adresse"},model:{value:(_vm.infoEmploye.adresse),callback:function ($$v) {_vm.$set(_vm.infoEmploye, "adresse", $$v)},expression:"infoEmploye.adresse"}})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","ml-1":"","mr-1":"","mt-1":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"text-xs-center",attrs:{"color":"blue-grey darken-2","dark":""}},[_c('v-toolbar-title',[_vm._v("Informations professionnelles")])],1),_vm._v(" "),_c('v-card-title',[_c('el-tabs',{staticStyle:{"width":"100%"},attrs:{"type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick(_vm.onglet)}},model:{value:(_vm.onglet),callback:function ($$v) {_vm.onglet=$$v},expression:"onglet"}},[_c('el-tab-pane',{attrs:{"label":"Mes Contrats"}},[_c('contratEmploye',{attrs:{"typeAdmin":_vm.admin,"idUserContrat":_vm.idUserCont}})],1),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"width":"100%"},attrs:{"label":"Detail professionnel"}},[_c('detailProfessionnel',{attrs:{"typeAdmin":_vm.admin,"show":_vm.onglet == '1',"idUserEmploye":_vm.idUserCont}})],1),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"width":"100%"},attrs:{"label":"les demandes d'absences"}},[_c('div',{staticStyle:{"width":"100%"}},[_c('span',{staticClass:"title"},[_vm._v("Liste des demandes de congés de l'année en cours")]),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.admin == false),expression:"admin == false"}],staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","disabled":_vm.demandeEnAttente,"color":"primary"},on:{"click":function($event){return _vm.showFormDmd()}},slot:"activator"},[_vm._v("\n                                                            Créer\n                                                            "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("add")])],1),_vm._v("\n                                                        Créer un demande d'absence\n                                                    ")],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"elevation-3",attrs:{"slot":"activator","dark":"","icon":"","flat":"","color":"primary"},on:{"click":function($event){return _vm.loadListeAbsence()}},slot:"activator"},[_c('v-icon',[_vm._v("cached")])],1),_vm._v("\n                                                    actualiser la liste\n                                                ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.demandeEnAttente)?_c('v-alert',{staticClass:"elevation-4 subheading mb-3",attrs:{"value":true,"color":"warning","icon":"priority_high","outline":""}},[_vm._v("\n                                                        Vous avez une demande d'absence en attente de validation, vous devez patientez jusqu'a la validation de celle-ci avant de faire une autre demande\n                                                    ")]):_vm._e(),_vm._v(" "),_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeAbsence}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('span',{staticClass:"title"},[_vm._v("Validateur demande d'absence")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":props.row.validationDmd,"stripe":""}},[_c('el-table-column',{attrs:{"prop":"responsable","label":"Responsable","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"statut","label":"Statut","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"cyan--text body-2"},[_vm._v(_vm._s(scope.row.statut))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateValidation","label":"date de validation"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","ml-2":""}},[_c('div',{staticClass:"grid-content"},[_c('p',{staticClass:"title"},[_vm._v("Description")]),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('div',{staticClass:"grid-content"},[_c('el-input',{attrs:{"type":"textarea","rows":5,"disabled":false,"readonly":"true","placeholder":"Description"},model:{value:(props.row.description),callback:function ($$v) {_vm.$set(props.row, "description", $$v)},expression:"props.row.description"}})],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","ml-2":""}},[_c('div',{staticClass:"grid-content"},[_c('p',{staticClass:"title"},[_vm._v("Motif de refus")]),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('div',{staticClass:"grid-content"},[_c('el-input',{attrs:{"type":"textarea","rows":5,"disabled":false,"readonly":"true","placeholder":"Motif de refus"},model:{value:(props.row.descRefus),callback:function ($$v) {_vm.$set(props.row, "descRefus", $$v)},expression:"props.row.descRefus"}})],1)])],1)],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateDbt","label":"DATE DEBUT","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateFin","label":"DATE FIN","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"dateRetour","label":"DATE RETOUR","align":"left"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"typeConge","label":"TYPE CONGE","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',[_vm._v(_vm._s(scope.row.typeConge))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"width":"180","prop":"status","label":"STATUT","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status == 'En cours de traitement')?_c('el-tag',[_vm._v(_vm._s(scope.row.status))]):(scope.row.status == 'En Attente de validation par DG')?_c('el-tag',{attrs:{"type":"warning"}},[_vm._v(_vm._s(scope.row.status))]):(scope.row.status == 'Refusé par la DRH')?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.status))]):(scope.row.status == 'Validée par DG')?_c('el-tag',{attrs:{"type":"success"}},[_vm._v(_vm._s(scope.row.status))]):(scope.row.status == 'Refusé le DG')?_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.status))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"FICHIER","align":"center","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-tooltip',{attrs:{"bottom":""}},[_vm._l((scope.row.imagesAbs),function(image,imageIndex){return _c('v-avatar',{key:imageIndex,staticClass:"mb-1 mr-1 elevation-3",style:({ backgroundImage: 'url(' + image + ')' , cursor: 'pointer'}),attrs:{"slot":"activator","tile":true,"size":50,"color":"grey lighten-4"},on:{"click":function($event){return _vm.showDiapo(scope.row.imagesAbs,imageIndex)}},slot:"activator"},[_c('img',{attrs:{"src":image,"alt":"avatar"}})])}),_vm._v("\n                                                                    Cliquez pour agrandir\n                                                                ")],2)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ACTION","align":"center","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status =='Validée par DG')?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"orange","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.imprimerDemande(scope.row)}},slot:"activator"},[_c('v-icon',[_vm._v("print")])],1),_vm._v("\n                                                                    Imprimer votre autorisation\n                                                                ")],1):_vm._e(),_vm._v(" "),(_vm.admin == true && !scope.row.retourIsPossible)?_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","color":"purple","fab":"","small":""},nativeOn:{"click":function($event){return _vm.showDialogRetour(scope.row.idAbsence)}},slot:"activator"},[_c('v-icon',[_vm._v("swap_vert")])],1),_vm._v("\n                                                                    Retour de congé\n                                                                ")],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(scope.row.idStatus == 0)?_c('v-btn',{attrs:{"slot":"activator","color":"red","icon":"","fab":"","dark":"","small":""},nativeOn:{"click":function($event){return _vm.showSuppAbs(scope.row.idAbsence)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1):_vm._e(),_vm._v("\n                                                                    Supprimer\n                                                                ")],1)]}}])})],1)],1)],1)],1)])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"60%","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogFormDmdAbsence),callback:function ($$v) {_vm.dialogFormDmdAbsence=$$v},expression:"dialogFormDmdAbsence"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Effectuer une demande d'absence")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialogFormDmdAbsence = false}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"text-xs-center",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('formAbsence',{on:{"close":function($event){return _vm.closeFormAbs()}}})],1)],1)],1)],1),_vm._v(" "),_c('formEditUser',{attrs:{"show":_vm.showDialogPerso,"idEmploye":_vm.idUserCont},on:{"close":function($event){return _vm.closeFormUser()}}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"550"},model:{value:(_vm.dialogSuppAbs),callback:function ($$v) {_vm.dialogSuppAbs=$$v},expression:"dialogSuppAbs"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_c('el-alert',{attrs:{"title":"Voulez-vous supprimer cette demande ?","type":"warning","closable":false,"show-icon":""}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","flat":"flat"},on:{"click":function($event){_vm.dialogSuppAbs = false}}},[_vm._v("\n                    Annuler\n                ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","dark":""},on:{"click":function($event){return _vm.submitSuppAbs()}}},[_vm._v("\n                    Supprimer\n                ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"40%","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogRetourAbs),callback:function ($$v) {_vm.dialogRetourAbs=$$v},expression:"dialogRetourAbs"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Confirmer la présence de l'employé")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialogRetourAbs = false}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-form',{ref:"formRetourAbs",staticClass:"demo-form-inline",attrs:{"model":_vm.formRetourAbs}},[_c('el-row',{attrs:{"type":"flex","gutter":20}},[_c('el-col',{attrs:{"span":14}},[_c('div',{staticClass:"block"},[_c('el-form-item',{attrs:{"label":"Date retour"}},[_c('el-date-picker',{attrs:{"type":"datetime","format":"dd-MM-yyyy HH:mm:ss","placeholder":"Selectionnez date et horaire"},model:{value:(_vm.formRetourAbs.dateRetour),callback:function ($$v) {_vm.$set(_vm.formRetourAbs, "dateRetour", $$v)},expression:"formRetourAbs.dateRetour"}},[_vm._v("\n                                                >\n                                            ")])],1)],1)])],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{staticStyle:{"width":"97%"},attrs:{"label":"Description"}},[_c('el-input',{attrs:{"type":"textarea","rows":6},model:{value:(_vm.formRetourAbs.desc),callback:function ($$v) {_vm.$set(_vm.formRetourAbs, "desc", $$v)},expression:"formRetourAbs.desc"}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"type":"flex","gutter":20,"justify":"end"}},[_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"mt-4",staticStyle:{"width":"100%"}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","disabled":!_vm.formRetourIsValid,"color":"green"},on:{"click":function($event){return _vm.submitFormRetour()}},slot:"activator"},[_vm._v("\n\n                                                Enregistrer\n                                                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("save")])],1),_vm._v("\n                                            enregistrer\n                                        ")],1)],1)])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('CoolLightBox',{attrs:{"items":_vm.items,"index":_vm.index},on:{"close":function($event){_vm.index = null}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ybQ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mission_vue__ = __webpack_require__("WeAx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00c21359_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mission_vue__ = __webpack_require__("AW6Z");
function injectStyle (ssrContext) {
  __webpack_require__("z9Rq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00c21359"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Mission_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00c21359_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Mission_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yjku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Parametre_vue__ = __webpack_require__("cej4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47d0f1a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Parametre_vue__ = __webpack_require__("kt8t");
function injectStyle (ssrContext) {
  __webpack_require__("4XjW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Parametre_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47d0f1a3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Parametre_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yuvZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z4rP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialogDetail),callback:function ($$v) {_vm.dialogDetail=$$v},expression:"dialogDetail"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Details du budget pour le projet\n          "+_vm._s(_vm.detailChant.libelle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.closeDialog()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"mb-5",attrs:{"color":"","flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("Informations generales sur le projet")]),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-4",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Référence")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v("Projet "+_vm._s(_vm.detailChant.idChant))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Libellé")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailChant.libelle))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Type de chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailChant.typeChantier))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date début")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailChant.dateDbt))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date de fin")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailChant.dateFin))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Situation géographique")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailChant.adresse))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_vm._v("Chef de chantier")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs9":""}},[_vm._v(_vm._s(_vm.detailChant.responsable))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Budget établi par")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailChant.userCreatedBudget))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Budget validé par")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailChant.userModifiedBudget))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Etat du budget")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailChant.libEtatBudget))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_vm._v("Date d'enregistrement budget")]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right title",attrs:{"xs6":""}},[_vm._v(_vm._s(_vm.detailChant.dateEnregBudget))])],1),_vm._v(" "),_c('v-divider',{staticClass:"mb-3"})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("Liste du budget travaux à valider")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"card l-bg-orange-dark"},[_c('div',{staticClass:"card-statistic-3 p-4"},[_c('div',{staticClass:"card-icon card-icon-large"}),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("\n                                TOTAL BUDGET PROPOSE\n                              ")])]),_vm._v(" "),_c('div',{staticClass:"row  align-items-center mb-2 d-flex"},[_c('div',{staticClass:"col-8"},[_c('h1',{attrs:{"id":"price"}},[_vm._v("\n                                  "+_vm._s(new Intl.NumberFormat().format(
                                      _vm.totalMntPropose
                                    ))+"\n                                  FCFA\n                                ")])])])])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('div',{staticClass:"col-xl-3 ml-2"},[_c('div',{staticClass:"card l-bg-green-dark"},[_c('div',{staticClass:"card-statistic-3 p-4"},[_c('div',{staticClass:"card-icon card-icon-large"}),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("\n                                TOTAL BUDGET VALIDE\n                              ")])]),_vm._v(" "),_c('div',{staticClass:"row  align-items-center mb-2 d-flex"},[_c('div',{staticClass:"col-8"},[_c('h1',{attrs:{"id":"price"}},[_vm._v("\n                                  "+_vm._s(new Intl.NumberFormat().format(
                                      _vm.totalMntValide
                                    ))+"\n                                  FCFA\n                                ")])])])])])])]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs4":""}},[_c('v-flex',[_c('el-popover',{ref:"popChantier0",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("Veuillez choisir le format d'impression ?")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin":"0"},attrs:{"align":"center"}},[_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtTravauxPDF('PDF')}}},[_vm._v("PDF SIMPLE")])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtTravauxPDF('PDF')}}},[_vm._v("PDF DETAILLE")])],1)])]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popChantier0",arg:"popChantier0"}],attrs:{"type":"warning","disabled":_vm.disabledBtnPop,"icon":"el-icon-printer"}},[_vm._v("Rapport")])],1)],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-5",attrs:{"color":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs12":""}},[_c('data-tables',{staticStyle:{"width":"100%"},attrs:{"data":_vm.listeBudget}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('v-layout',{staticClass:"elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-alert',{staticClass:"mb-4",attrs:{"value":true,"outline":"","color":"primary","icon":"info"}},[_vm._v("Liste des Tâches")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2 mt-3",attrs:{"xs12":""}},[_c('div',{staticClass:"grid-content"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":props.row.taches,"stripe":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',{staticClass:"elevation-3 pl-4 pr-4 pt-2"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple mb-2"},[_c('v-alert',{staticClass:"mb-4",attrs:{"value":true,"outline":"","color":"primary","icon":"info"}},[_vm._v("Détail du\n                                                              budget\n                                                              travaux")]),_vm._v(" "),_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":props.row
                                                                    .detailBudget,"summary-method":_vm.getSummDetailBudget,"show-summary":""}},[_c('el-table-column',{attrs:{"align":"center","prop":"libelle","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"mntBudgetPropose","label":"BUDGET PROPOSE"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(new Intl.NumberFormat().format(
                                                                        scope
                                                                          .row
                                                                          .montantPropose
                                                                      ))+"                                                                     \n                                                                ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntBudgetValide","label":"BUDGET VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [(
                                                                        prop
                                                                          .row
                                                                          .etatBudgetTrx ==
                                                                          0
                                                                      )?_c('el-input-number',{attrs:{"controls-position":"right","min":0,"size":"small"},on:{"change":_vm.handleChange},model:{value:(
                                                                        prop
                                                                          .row
                                                                          .montantValide
                                                                      ),callback:function ($$v) {_vm.$set(prop
                                                                          .row
                                                                          , "montantValide", $$v)},expression:"\n                                                                        prop\n                                                                          .row\n                                                                          .montantValide\n                                                                      "}}):_c('el-tag',{staticClass:"subheading",attrs:{"type":"success"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                                                          prop
                                                                            .row
                                                                            .montantValide
                                                                        )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ecartBudget","label":"ECART MNT BUDGET-PROPOSE","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('v-chip',{attrs:{"label":"","outline":"","color":"primary"}},[_vm._v(_vm._s(prop
                                                                          .row
                                                                          .montantValide -
                                                                          prop
                                                                            .row
                                                                            .montantPropose))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"periode","label":"PERIODE"}})],1)],1)],1)])],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","label":"Libellé"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('v-chip',{attrs:{"outline":"","text-color":"blue","label":""}},[_vm._v(" "+_vm._s(scope.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntBudgetPropose","label":"MONTANT PROPOSE","sortable":"","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":'warning'}},[_vm._v("\n                                                        "+_vm._s(new Intl.NumberFormat().format(
                                                            scope.row
                                                              .mntBudgetPropose
                                                          ))+"\n                                                      ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntBudgetValide","label":"MONTANT VALIDE","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":scope.row.mntBudgetValide > 0 ? 'success' : 'danger'}},[_vm._v("\n                                                        "+_vm._s(new Intl.NumberFormat().format(
                                                            scope.row
                                                              .mntBudgetValide
                                                          ))+"\n                                                      ")])]}}],null,true)})],1)],1)],1)],1)],1)])],1)],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Travaux","prop":"libelle"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"BUDGET PROPOSE","prop":"mntTotalBudgetPropose"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(new Intl.NumberFormat().format(
                                  scope.row.mntTotalBudgetPropose
                                )))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"BUDGET VALIDE","prop":"mntTotalBudgetValide"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(new Intl.NumberFormat().format(
                                  scope.row.mntTotalBudgetValide
                                )))]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ETAT","prop":"libEtatBudgetTrx"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":scope.row.etatBudgetTrx == 1
                                      ? 'success'
                                      : 'danger'}},[_vm._v(_vm._s(scope.row.libEtatBudgetTrx))])]}}])})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mt-4",attrs:{"xs12":""}},[_c('v-alert',{attrs:{"value":true,"outline":"","color":"purple","icon":"info"}},[_vm._v("Résultat compte d'exploitation(Affiche uniquement\n                            les travaux planifiés par le chef de\n                            projet)")]),_vm._v(" "),_c('el-tabs',{attrs:{"stretch":true,"type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick(_vm.compte)}},model:{value:(_vm.compte),callback:function ($$v) {_vm.compte=$$v},expression:"compte"}},[_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',[_vm._v("account_balance")]),_vm._v("Recapitulatif\n                                annuel\n                              ")],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-flex',[_c('el-popover',{ref:"popChantier",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("\n                                      Veuillez choisir le format d'impression\n                                      ?\n                                    ")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin":"0"},attrs:{"align":"center"}},[_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifAnnuelSimpl(
                                              'PDF'
                                            )}}},[_vm._v("PDF SIMPLE")])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifAnnuel(
                                              'PDF'
                                            )}}},[_vm._v("PDF DETAILLE")])],1)])]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popChantier",arg:"popChantier"}],attrs:{"type":"warning","disabled":_vm.disabledBtnPop,"icon":"el-icon-printer"}},[_vm._v("Rapport")])],1)],1)],1),_vm._v(" "),_c('el-collapse',{attrs:{"accordion":""}},_vm._l((_vm.bilanMensuel),function(groupeMois,index){return _c('v-layout',{key:index,staticClass:"text-xs-center",attrs:{"wrap":""}},[_c('div',{staticStyle:{"width":"100%"}},[_c('el-collapse-item',{staticClass:"mb-1 pl-3 pr-3",staticStyle:{"width":"100%"},attrs:{"name":index}},[_c('template',{slot:"title"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-sm-left",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"20px"},attrs:{"dark":"","label":"","text-color":"white","color":"purple"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v("\n                                              "+_vm._s(index)+"\n                                            ")],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-sm-left",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("\n                                                TOTAL MONTANT PREVU:\n                                                "+_vm._s(new Intl.NumberFormat().format(
                                                    groupeMois.totalMntPrevu
                                                  ))+"\n                                              ")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-sm-left",attrs:{"xs4":""}},[_c('v-chip',{staticStyle:{"font-size":"15px"},attrs:{"label":"","outline":"","color":"primary"}},[_c('b',[_vm._v("\n                                                TOTAL MONTANT ENGAGÉ:\n                                                "+_vm._s(new Intl.NumberFormat().format(
                                                    groupeMois.totalMntDecaisse
                                                  ))+"\n                                              ")])])],1)],1)],1),_vm._v(" "),_vm._l((groupeMois.mois),function(travaux,mois){return _c('v-flex',{key:mois,staticClass:"mt-3",attrs:{"xs12":""}},[_c('span',{staticClass:"blue--text",staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(mois)+"-"+_vm._s(index))]),_vm._v(" "),_c('el-table',{staticClass:"elevation-1",staticStyle:{"width":"100%"},attrs:{"data":travaux,"highlight-current-row":"","header-row-style":_vm.headerRowStyle,"border":"","summary-method":_vm.getSummaries,"show-summary":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-row',{staticClass:"elevation-3 pl-4 pr-4 pt-2"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple mb-2"},[_c('v-alert',{staticClass:"mb-4",attrs:{"value":true,"outline":"","color":"primary","icon":"info"}},[_vm._v("Liste du budget\n                                                      établi")]),_vm._v(" "),_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":props.row
                                                            .detailBudget,"summary-method":_vm.getSummaries,"show-summary":""}},[_c('el-table-column',{attrs:{"align":"center","prop":"libelle","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"mntBudgetValide","label":"BUDGET VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(_vm._s(new Intl.NumberFormat().format(
                                                                scope.row
                                                                  .mntBudgetValide
                                                              )))]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"mntProdDecaiss","label":"MONTANT ENGAGÉ"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                            "+_vm._s(new Intl.NumberFormat().format(
                                                                scope.row
                                                                  .mntProdDecaiss
                                                              ))+"\n                                                          ")]}}],null,true)})],1)],1)],1)])],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"libelle","align":"center","label":"Travaux"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntTotalBudgetValide","align":"center","label":"Budget validé"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v("\n                                              "+_vm._s(new Intl.NumberFormat().format(
                                                  prop.row
                                                    .mntTotalBudgetValide
                                                ))+"\n                                            ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"montantDecaisse","label":"Montant decaissé"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_vm._v("\n                                              "+_vm._s(new Intl.NumberFormat().format(
                                                  prop.row.montantDecaisse
                                                ))+"\n                                            ")]}}],null,true)})],1)],1)})],2),_vm._v(" "),_c('v-divider',{staticClass:"mb-2"})],1)])}),1)],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',[_vm._v("library_books")]),_vm._v("Recapitulatif\n                                travaux\n                              ")],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-flex',[_c('el-popover',{ref:"popChantier2",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("\n                                      Veuillez choisir le format d'impression\n                                      ?\n                                    ")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin":"0"},attrs:{"align":"center"}},[_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifTravauxSimpl(
                                              'PDF'
                                            )}}},[_vm._v("PDF SIMPLE")])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifTravaux(
                                              'PDF'
                                            )}}},[_vm._v("PDF DETAILLE")])],1)])]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popChantier2",arg:"popChantier2"}],attrs:{"type":"warning","disabled":_vm.disabledBtnPop,"icon":"el-icon-printer"}},[_vm._v("Rapport")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-3"},[_c('v-flex',{attrs:{"xs3":""}},[_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"card l-bg-orange-dark"},[_c('div',{staticClass:"card-statistic-3 p-4"},[_c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("\n                                            BUDGET TOTAL VALIDE\n                                          ")]),_vm._v(" "),_c('h5',{attrs:{"id":"price"}},[_vm._v("\n                                            (Somme des budgets validés)\n                                          ")])]),_vm._v(" "),_c('div',{staticClass:"row  align-items-center mb-2 d-flex"},[_c('div',{staticClass:"col-8"},[_c('h1',{attrs:{"id":"price"}},[_vm._v("\n                                              "+_vm._s(new Intl.NumberFormat().format(
                                                  _vm.bilanTravaux.totalValide
                                                ))+"\n                                              FCFA\n                                            ")])])])])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('div',{staticClass:"col-xl-3 ml-2"},[_c('div',{staticClass:"card l-bg-red-dark"},[_c('div',{staticClass:"card-statistic-3 p-4"},[_c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("\n                                            MONTANT TOTAL ENGAGÉ\n                                          ")]),_vm._v(" "),_c('h5',{attrs:{"id":"price"}},[_vm._v("\n                                            (Somme des montants décaissés)\n                                          ")])]),_vm._v(" "),_c('div',{staticClass:"row  align-items-center mb-2 d-flex"},[_c('div',{staticClass:"col-8"},[_c('h1',{attrs:{"id":"price"}},[_vm._v("\n                                              "+_vm._s(new Intl.NumberFormat().format(
                                                  _vm.bilanTravaux.totalDecaisse
                                                ))+"\n                                              FCFA\n                                            ")])])])])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('div',{staticClass:"col-xl-3 ml-2"},[_c('div',{staticClass:"card l-bg-green-dark"},[_c('div',{staticClass:"card-statistic-3 p-4"},[_c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("\n                                            ECART BUDGET\n                                          ")]),_vm._v(" "),_c('h5',{attrs:{"id":"price"}},[_vm._v("\n                                            (Budget validé - Montant\n                                            décaissés)\n                                          ")])]),_vm._v(" "),_c('div',{staticClass:"row  align-items-center mb-2 d-flex"},[_c('div',{staticClass:"col-8"},[_c('h1',{attrs:{"id":"price"}},[_vm._v("\n                                              "+_vm._s(new Intl.NumberFormat().format(
                                                  _vm.bilanTravaux.TotalEcart
                                                ))+"\n                                              FCFA\n                                            ")])])])])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-chip',{staticStyle:{"font-size":"19px","width":"90%"},attrs:{"color":"orange","text-color":"white"}},[_c('v-avatar',{staticClass:"orange darken-4"},[_vm._v("\n                                      "+_vm._s(_vm.bilanTravaux.totalTravaux)+"\n                                    ")]),_vm._v("\n                                    Lots de travaux\n                                  ")],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("Liste des travaux")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","header-row-style":_vm.headerRowStyle,"highlight-current-row":"","data":_vm.bilanTravaux.details,"summary-method":_vm.getSumm,"show-summary":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("Budget travaux")])],1),_vm._v(" "),_c('el-table',{staticClass:"elevation-2",staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":props.row.detailBudget,"summary-method":_vm.getSumm,"show-summary":""}},[_c('el-table-column',{attrs:{"align":"center","prop":"libelle","sortable":"","label":"DESIGNATION"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(_vm._s(prop.row.libelle))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"mntRealise","label":"BUDGET VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(prop5){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                                      prop5.row
                                                        .mntBudgetValide
                                                    )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","prop":"mntProdDecaiss","label":"MONTANT ENGAGÉ"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                                "+_vm._s(new Intl.NumberFormat().format(
                                                    scope.row.mntProdDecaiss
                                                  ))+"\n                                              ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"ecart","label":"ECART"},scopedSlots:_vm._u([{key:"default",fn:function(prop3){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":prop3.row.ecart < 0
                                                      ? 'danger'
                                                      : 'success'}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                                      prop3.row.ecart
                                                    )))])]}}],null,true)})],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"libelle","label":"DESIGNATION"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(_vm._s(prop.row.libelle))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"mntTotalBudgetValide","label":"BUDGET VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(prop5){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                              prop5.row.mntTotalBudgetValide
                                            )))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"mntTotalTypeTrxDecaisse","label":"MONTANT ENGAGÉ"},scopedSlots:_vm._u([{key:"default",fn:function(prop5){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                              prop5.row
                                                .mntTotalTypeTrxDecaisse
                                            )))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"ecart","label":"ECART"},scopedSlots:_vm._u([{key:"default",fn:function(prop3){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":prop3.row.ecart < 0
                                              ? 'danger'
                                              : 'success'}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                              prop3.row.ecart
                                            )))])]}}])})],1)],1)],1)],1),_vm._v(" "),_c('el-tab-pane',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('v-icon',[_vm._v("account_balance_wallet")]),_vm._v("Etat\n                                financier\n                              ")],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":""}},[_c('v-flex',[_c('el-popover',{ref:"popChantier3",attrs:{"placement":"top","width":"180","trigger":"hover"}},[_c('p',[_vm._v("\n                                      Veuillez choisir le format d'impression\n                                      ?\n                                    ")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin":"0"},attrs:{"align":"center"}},[_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifFinanceSimpl(
                                              'PDF'
                                            )}}},[_vm._v("PDF SIMPLE")])],1),_vm._v(" "),_c('p',{attrs:{"align":"center"}},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.imprimeBudgtRecapitulatifFinance(
                                              'PDF'
                                            )}}},[_vm._v("PDF DETAILLE")])],1)])]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:popChantier3",arg:"popChantier3"}],attrs:{"type":"warning","disabled":_vm.disabledBtnPop,"icon":"el-icon-printer"}},[_vm._v("Rapport")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mb-3"},[_c('v-flex',{attrs:{"xs3":""}},[_c('div',{staticClass:"col-xl-3"},[_c('div',{staticClass:"card l-bg-orange-dark"},[_c('div',{staticClass:"card-statistic-3 p-4"},[_c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("\n                                            TOTAL DES FACTURES\n                                          ")]),_vm._v(" "),_c('h5',{attrs:{"id":"price"}},[_vm._v("\n                                            (Somme de toutttes les factures)\n                                          ")])]),_vm._v(" "),_c('div',{staticClass:"row  align-items-center mb-2 d-flex"},[_c('div',{staticClass:"col-8"},[_c('h1',{attrs:{"id":"price"}},[_vm._v("\n                                              "+_vm._s(new Intl.NumberFormat().format(
                                                  _vm.listeDetail.total
                                                ))+"\n                                              FCFA\n                                            ")])])])])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('div',{staticClass:"col-xl-3 ml-2"},[_c('div',{staticClass:"card l-bg-green-dark"},[_c('div',{staticClass:"card-statistic-3 p-4"},[_c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("\n                                            TOTAL DES FACTURES PAYEES\n                                          ")]),_vm._v(" "),_c('h5',{attrs:{"id":"price"}},[_vm._v("\n                                            (Somme de toutes les factures\n                                            payées)\n                                          ")])]),_vm._v(" "),_c('div',{staticClass:"row  align-items-center mb-2 d-flex"},[_c('div',{staticClass:"col-8"},[_c('h1',{attrs:{"id":"price"}},[_vm._v("\n                                              "+_vm._s(new Intl.NumberFormat().format(
                                                  _vm.listeDetail.totalPaye
                                                ))+"\n                                              FCFA\n                                            ")])])])])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('div',{staticClass:"col-xl-3 ml-2"},[_c('div',{staticClass:"card l-bg-red-dark"},[_c('div',{staticClass:"card-statistic-3 p-4"},[_c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("\n                                            TOTAL DES FACTURES IMPAYEES\n                                          ")]),_vm._v(" "),_c('h5',{attrs:{"id":"price"}},[_vm._v("\n                                            (Sommes de toutes les factures\n                                            impayées)\n                                          ")])]),_vm._v(" "),_c('div',{staticClass:"row  align-items-center mb-2 d-flex"},[_c('div',{staticClass:"col-8"},[_c('h1',{attrs:{"id":"price"}},[_vm._v("\n                                              "+_vm._s(new Intl.NumberFormat().format(
                                                  _vm.listeDetail.totalImpaye
                                                ))+"\n                                              FCFA\n                                            ")])])])])])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[(_vm.listeDetail.ecart <= 0)?_c('div',{staticClass:"col-xl-3 ml-2"},[_c('div',{staticClass:"card l-bg-red-dark"},[_c('div',{staticClass:"card-statistic-3 p-4"},[_c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("\n                                            TOTAL ECART BUDGET\n                                          ")]),_vm._v(" "),_c('h5',{attrs:{"id":"price"}},[_vm._v("\n                                            (Budget validé - Total des\n                                            factures)\n                                          ")])]),_vm._v(" "),_c('div',{staticClass:"row  align-items-center mb-2 d-flex"},[_c('div',{staticClass:"col-8"},[_c('h1',{attrs:{"id":"price"}},[_vm._v("\n                                              "+_vm._s(new Intl.NumberFormat().format(
                                                  _vm.totalMntValide -
                                                    _vm.listeDetail.totalPaye
                                                ))+"\n                                              FCFA\n                                            ")])])])])])]):_vm._e(),_vm._v(" "),(_vm.listeDetail.ecart > 0)?_c('div',{staticClass:"col-xl-3 ml-2"},[_c('div',{staticClass:"card l-bg-green-dark"},[_c('div',{staticClass:"card-statistic-3 p-4"},[_c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("\n                                            TOTAL ECART BUDGET\n                                          ")])]),_vm._v(" "),_c('div',{staticClass:"row align-items-center mb-2 d-flex"},[_c('div',{staticClass:"card col-8"},[_c('h1',{attrs:{"id":"price"}},[_vm._v("\n                                              "+_vm._s(new Intl.NumberFormat().format(
                                                  _vm.listeDetail.ecart
                                                ))+"\n                                              FCFA\n                                            ")])])])])])]):_vm._e()])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('div',{staticClass:"col-xl-3 ml-2"},[(
                                        _vm.totalMntValide - _vm.listeDetail.total > 0
                                      )?_c('div',{staticClass:"card l-bg-green-dark"},[_c('div',{staticClass:"card-statistic-3 p-4"},[_c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("\n                                            MARGE REELLE\n                                          ")]),_vm._v(" "),_c('h5',{attrs:{"id":"price"}},[_vm._v("\n                                            (Montant marché - Total des\n                                            factures payées)\n                                          ")])]),_vm._v(" "),_c('div',{staticClass:"row  align-items-center mb-2 d-flex"},[_c('div',{staticClass:"col-8"},[_c('h1',{attrs:{"id":"price"}},[_vm._v("\n                                              "+_vm._s(new Intl.NumberFormat().format(
                                                  _vm.totalMntValide -
                                                    _vm.listeDetail.total
                                                ))+"\n                                              FCFA\n                                            ")])])])])]):_vm._e(),_vm._v(" "),(
                                        _vm.totalMntValide - _vm.listeDetail.total < 0
                                      )?_c('div',{staticClass:"card l-bg-red-dark"},[_c('div',{staticClass:"card-statistic-3 p-4"},[_c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("\n                                            MARGE REELLE\n                                          ")])]),_vm._v(" "),_c('div',{staticClass:"row  align-items-center mb-2 d-flex"},[_c('div',{staticClass:"col-8"},[_c('h1',{attrs:{"id":"price"}},[_vm._v("\n                                              "+_vm._s(new Intl.NumberFormat().format(
                                                  _vm.totalMntValide -
                                                    _vm.listeDetail.total
                                                ))+"\n                                              FCFA\n                                            ")])])])])]):_vm._e()])]),_vm._v(" "),(_vm.mntTotalChargeI > 0)?_c('v-flex',{attrs:{"xs3":""}},[_c('div',{staticClass:"col-xl-3 ml-2"},[_c('div',{staticClass:"card l-bg-red-dark"},[_c('div',{staticClass:"card-statistic-3 p-4"},[_c('div',{staticClass:"mb-4"},[_c('h4',{staticClass:"card-title mb-0"},[_vm._v("\n                                            MONTANT TOTAL CHARGE INDIRECT\n                                          ")])]),_vm._v(" "),_c('div',{staticClass:"row  align-items-center mb-2 d-flex"},[_c('div',{staticClass:"col-8"},[_c('h1',{attrs:{"id":"price"}},[_vm._v("\n                                              "+_vm._s(new Intl.NumberFormat().format(
                                                  _vm.mntTotalChargeI
                                                ))+"\n                                              FCFA\n                                            ")])])])])])])]):_vm._e()],1),_vm._v(" "),(_vm.listChargeResult.length != 0)?_c('v-card-text',[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("DETAILS DES CHARGES INDIRECT")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","header-row-style":_vm.headerRowStyle,"highlight-current-row":"","data":_vm.listChargeResult,"summary-method":_vm.getSummCompte,"show-summary":""}},[_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"type","label":"TYPE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(_vm._s(prop.row.type))])]}}],null,false,2527360430)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"produit","label":"DESIGNATION"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(_vm._s(prop.row.produit))])]}}],null,false,851994871)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"unite","label":"UNITE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(_vm._s(prop.row.unite))])]}}],null,false,2744664341)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"periode","label":"Période","align":"center","width":"190px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.periode == 'tous')?_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("APPLIQUER A TOUT LE PROJET")]):_c('v-chip',{attrs:{"text-color":"white","color":"orange"}},[_vm._v("SUR UNE PERIODE")]),_vm._v(" "),(scope.row.periode != 'tous')?_c('v-chip',{attrs:{"text-color":"white","color":"primary"}},[_vm._v(_vm._s(scope.row.dateD)+" AU\n                                        "+_vm._s(scope.row.dateF)+"\n                                      ")]):_vm._e()]}}],null,false,3970140164)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"qte","label":"QUANTITE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                            prop.row.qte
                                          )))])]}}],null,false,4165632846)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"cout","label":"PRIX UNITAIRE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                            prop.row.cout
                                          )))])]}}],null,false,1223605699)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"total","label":"TOTAL"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                            prop.row.total
                                          )))])]}}],null,false,2312482636)})],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.listeDetail.details),function(compte,index){return _c('v-layout',{key:index,staticClass:"mt-3 mb-4",attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(index))])],1),_vm._v(" "),_c('el-table',{staticClass:"mb-4",staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":compte,"summary-method":_vm.getSummCompteFinance,"show-summary":""}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(propsArticle){return [_c('el-row',{staticClass:"elevation-3 pl-4 pr-4 pt-2"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"grid-content bg-purple"},[_c('v-chip',{attrs:{"dark":"","label":"","color":"purple","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(" "),_c('span',[_vm._v("Détails facture")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","highlight-current-row":"","header-row-style":_vm.headerRowStyle,"data":propsArticle.row.produits,"summary-method":_vm.getSummaries,"show-summary":""}},[_c('el-table-column',{attrs:{"prop":"ref","align":"center","label":"REFERENCE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"designation","align":"center","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qte","align":"center","label":"QUANTITE"},scopedSlots:_vm._u([{key:"default",fn:function(propA1){return [_vm._v("\n                                                    "+_vm._s(new Intl.NumberFormat().format(
                                                        propA1.row.qte
                                                      ))+"\n                                                  ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"unite","align":"center","label":"UNITE"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"prixU","align":"center","label":"PRIX UNITAIRE"},scopedSlots:_vm._u([{key:"default",fn:function(propA2){return [_vm._v("\n                                                    "+_vm._s(new Intl.NumberFormat().format(
                                                        propA2.row.prixU
                                                      ))+"\n                                                  ")]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tva","align":"center","label":"TVA"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remise","label":"REMISE","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","align":"center","label":"TOTAL"},scopedSlots:_vm._u([{key:"default",fn:function(propA3){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v("\n                                                      "+_vm._s(new Intl.NumberFormat().format(
                                                          propA3.row.total
                                                        ))+"\n                                                    ")])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"mntBudgetValide","align":"center","label":"Budget matériel validé"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v("\n                                                      "+_vm._s(new Intl.NumberFormat().format(
                                                          prop.row
                                                            .mntBudgetValide
                                                        ))+"\n                                                    ")])]}}],null,true)})],1)],1)])],1)]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"","align":"center","prop":"ref","label":"REFERENCE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('span',{staticClass:"subheading black--text"},[_vm._v(_vm._s(prop.row.ref))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"designation","label":"DESIGNATION"}}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"total","label":"TOTAL FACTURE"},scopedSlots:_vm._u([{key:"default",fn:function(prop2){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"warning"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                              prop2.row.total
                                            )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"totalPaye","label":"TOTAL FACTURE PAYEE"},scopedSlots:_vm._u([{key:"default",fn:function(prop2){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"success"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                              prop2.row.totalPaye
                                            )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"totalImpaye","label":"TOTAL FACTURE IMPAYEE"},scopedSlots:_vm._u([{key:"default",fn:function(prop2){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"danger"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                              prop2.row.totalImpaye
                                            )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"mntTotalBudgetValide","label":"BUDGET PRODUIT VALIDE"},scopedSlots:_vm._u([{key:"default",fn:function(prop){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":"info"}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                              prop.row.mntTotalBudgetValide
                                            )))])]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","sortable":"","prop":"ecart","label":"ECART BUDGET-TOTAL FACTURE"},scopedSlots:_vm._u([{key:"default",fn:function(prop3){return [_c('el-tag',{staticClass:"subheading",attrs:{"type":prop3.row.ecart < 0
                                              ? 'danger'
                                              : 'success'}},[_vm._v(_vm._s(new Intl.NumberFormat().format(
                                              prop3.row.ecart
                                            )))])]}}],null,true)})],1)],1)],1)})],2)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.detailChant.etat == false && _vm.listeBudget.length > 0)?_c('v-btn',{staticClass:"mb-5",staticStyle:{"margin-right":"100px"},attrs:{"slot":"activator","absolute":"","dark":"","fab":"","large":"","bottom":"","right":"","color":"success"},on:{"click":function($event){_vm.dialogConfirm = true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Valider le budget")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"650"},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Validation du budget du projet\n          "+_vm._s(_vm.detailChant.libelle))]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"mb-2",attrs:{"xs12":""}},[_c('el-alert',{attrs:{"title":"Voulez vous valider le budget  ?","closable":false,"show-icon":"","type":"success"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","dark":""},nativeOn:{"click":function($event){_vm.dialogConfirm = false}}},[_vm._v("Annuler")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","dark":""},nativeOn:{"click":function($event){return _vm.SubmitValideBudget()}}},[_vm._v("Confirmer")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z9Rq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zWQ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listeBciResponsable_vue__ = __webpack_require__("TR78");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1173d614_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listeBciResponsable_vue__ = __webpack_require__("Z/zb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_listeBciResponsable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1173d614_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_listeBciResponsable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zc6M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatriceContract_vue__ = __webpack_require__("HZcb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_639fdef2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MatriceContract_vue__ = __webpack_require__("q590");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MatriceContract_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_639fdef2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MatriceContract_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zfpq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('Loading',{attrs:{"value":_vm.loading}}),_vm._v(" "),_c('v-card',{attrs:{"tile":""}},[_c('v-layout',{attrs:{"row":"","mt-2":"","ml-1":"","mb-3":""}},[_c('v-flex',{attrs:{"sm12":""}},[_c('WidgetProjet',{attrs:{"projet":_vm.detailProjet}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"sm12":"","ml-1":"","mr-1":"","mt-1":""}},[_c('v-card',[_c('el-tabs',{attrs:{"type":"border-card"},on:{"tab-click":function($event){return _vm.handleTabClick(_vm.onglet)}},model:{value:(_vm.onglet),callback:function ($$v) {_vm.onglet=$$v},expression:"onglet"}},[_c('el-tab-pane',{attrs:{"label":"Bon de commande interne à valider"}},[_c('listeBciResponsable',{attrs:{"typeReche":'ressource',"listeBesoins":_vm.besoins,"listeChantiers":_vm.chantiers,"idProjet":this.detailProjet.id,"idresponsable":_vm.detailProjet.idChef},on:{"reloadBesoins":function($event){_vm.loadBesoinAvalider(), _vm.loadChantier()}}})],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Demandes de carburants à valider"}},[_c('besoinCarburantResponsable',{attrs:{"typeReche":'carburant',"listeBesoins":_vm.besoinsCarbur,"listeChantiers":_vm.chantiers,"idProjet":this.detailProjet.id,"idresponsable":_vm.detailProjet.idChef},on:{"reloadBesoins":function($event){_vm.loadBesoinCarburAvalider(), _vm.loadChantier()}}})],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Rapport Journaliers"}},[_c('ListeRapportTrx',{attrs:{"type":2,"commis":false,"typeInterface":true,"rapportPerso":_vm.rapportPerso,"show":_vm.loadFenetre,"listeRapportTrx":_vm.listeRapports},on:{"reloadListeRapport":function($event){return _vm.loadRapportProjet()}}})],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Reserve Travaux"}},[_c('ListeReserve',{attrs:{"type":2,"listeReserveTrx":_vm.listeReserves},on:{"reloadListeReserve":function($event){return _vm.loadReserves()}}}),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Worklog"}},[_c('ListeWorklogPorjet',{attrs:{"type":2,"listeWorktrx":_vm.listeWorktrx,"listeTacheWorktrx":_vm.listtache,"idProjet":_vm.detailProjet.id,"totalHeuretrx":_vm.totalHeuretrx,"totalmintrx":_vm.totalmintrx,"totalactivitetrx":_vm.totalActivite},on:{"reloadWorklogs":function($event){return _vm.loadWorklogs(_vm.detailProjet.id)}}}),_vm._v(" "),_c('br')],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ztN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drive_vue__ = __webpack_require__("/p7q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a07523bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drive_vue__ = __webpack_require__("R654");
function injectStyle (ssrContext) {
  __webpack_require__("Ytuf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Drive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a07523bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Drive_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f475c1fe5f03de26c286.js